webpackJsonp([274064371769067],{

/***/ "./node_modules/camel-case/camel-case.js":
/***/ (function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__("./node_modules/upper-case/upper-case.js")
	var noCase = __webpack_require__("./node_modules/no-case/no-case.js")
	
	/**
	 * Camel case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale, mergeNumbers) {
	  var result = noCase(value, locale)
	
	  // Replace periods between numeric entities with an underscore.
	  if (!mergeNumbers) {
	    result = result.replace(/ (?=\d)/g, '_')
	  }
	
	  // Replace spaces between words with an upper cased character.
	  return result.replace(/ (.)/g, function (m, $1) {
	    return upperCase($1, locale)
	  })
	}


/***/ }),

/***/ "./node_modules/chain-function/index.js":
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),

/***/ "./node_modules/classnames/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ "./node_modules/copy-to-clipboard/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deselectCurrent = __webpack_require__("./node_modules/toggle-selection/index.js");
	
	var defaultMessage = 'Copy to clipboard: #{key}, Enter';
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug, message, reselectPrevious, range, selection, mark, success = false;
	  if (!options) { options = {}; }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement('span');
	    mark.textContent = text;
	    // reset user styles for span element
	    mark.style.all = 'unset';
	    // prevents scrolling to the end of the page
	    mark.style.position = 'fixed';
	    mark.style.top = 0;
	    mark.style.clip = 'rect(0, 0, 0, 0)';
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = 'pre';
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = 'text';
	    mark.style.MozUserSelect = 'text';
	    mark.style.msUserSelect = 'text';
	    mark.style.userSelect = 'text';
	
	    document.body.appendChild(mark);
	
	    range.selectNode(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand('copy');
	    if (!successful) {
	      throw new Error('copy command was unsuccessful');
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error('unable to copy using execCommand: ', err);
	    debug && console.warn('trying IE specific stuff');
	    try {
	      window.clipboardData.setData('text', text);
	      success = true;
	    } catch (err) {
	      debug && console.error('unable to copy using clipboardData: ', err);
	      debug && console.error('falling back to prompt');
	      message = format('message' in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == 'function') {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ }),

/***/ "./node_modules/deep-equal/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__("./node_modules/deep-equal/lib/keys.js");
	var isArguments = __webpack_require__("./node_modules/deep-equal/lib/is_arguments.js");
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ "./node_modules/deep-equal/lib/is_arguments.js":
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ "./node_modules/deep-equal/lib/keys.js":
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ "./node_modules/exenv/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ "./node_modules/grommet/components/Animate.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactTransitionGroup = __webpack_require__("./node_modules/react-transition-group/index.js");
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSClassnames = __webpack_require__("./node_modules/grommet/utils/CSSClassnames.js");
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _DOM = __webpack_require__("./node_modules/grommet/utils/DOM.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.ANIMATE;
	
	var AnimateChild = function (_Component) {
	  _inherits(AnimateChild, _Component);
	
	  function AnimateChild(props, context) {
	    _classCallCheck(this, AnimateChild);
	
	    var _this = _possibleConstructorReturn(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).call(this, props, context));
	
	    var enter = props.enter,
	        leave = props.leave;
	    // leave will reuse enter if leave is not defined
	
	    _this.state = {
	      enter: enter,
	      leave: leave || enter,
	      state: 'inactive'
	    };
	    return _this;
	  }
	
	  _createClass(AnimateChild, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var enter = nextProps.enter,
	          leave = nextProps.leave;
	
	      this.setState({ enter: enter, leave: leave || enter });
	      if (nextProps.visible !== this.props.visible) {
	        var _ref = nextProps.visible ? ['enter', 'active'] : ['leave', 'inactive'],
	            _ref2 = _slicedToArray(_ref, 2),
	            nextState = _ref2[0],
	            lastState = _ref2[1];
	
	        this._delay(nextState, this._done.bind(this, lastState));
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timer) {
	        clearTimeout(this._timer);
	        this._timer = undefined;
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      if (true === this.props.visible) {
	        this._delay('enter', callback);
	      }
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      if (true === this.props.visible) {
	        this._delay('enter', callback);
	      }
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this._done('active');
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this._done('active');
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this._delay('leave', callback);
	    }
	  }, {
	    key: 'componentDidLeave',
	    value: function componentDidLeave(callback) {
	      this._done('inactive');
	    }
	  }, {
	    key: '_delay',
	    value: function _delay(state, callback) {
	      var delay = this.state[state].delay;
	      // ensure we start out inactive in case we aren't being kept in the DOM
	
	      if ('enter' === state) {
	        this.setState({ state: 'inactive ' });
	      }
	      clearTimeout(this._timer);
	      this._timer = setTimeout(this._start.bind(this, state, callback), delay || 1);
	    }
	  }, {
	    key: '_start',
	    value: function _start(state, callback) {
	      var duration = this.state[state].duration;
	
	      this.setState({ state: state });
	      this._timer = setTimeout(callback, duration);
	    }
	  }, {
	    key: '_done',
	    value: function _done(state) {
	      this.setState({ state: state });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state = this.state,
	          enter = _state.enter,
	          leave = _state.leave,
	          state = _state.state;
	
	      var animation = (this.state[state] || this.state.enter).animation;
	      var className = (0, _classnames2.default)(CLASS_ROOT + '__child', CLASS_ROOT + '__child--' + animation, CLASS_ROOT + '__child--' + state);
	      var duration = 'enter' === state || 'inactive' === state ? enter.duration : leave.duration;
	      var style = { transitionDuration: (duration || 0) + 'ms' };
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: style },
	        children
	      );
	    }
	  }]);
	
	  return AnimateChild;
	}(_react.Component);
	
	AnimateChild.displayName = 'AnimateChild';
	
	
	AnimateChild.propTypes = {
	  enter: _propTypes2.default.shape({
	    animation: _propTypes2.default.string,
	    duration: _propTypes2.default.number,
	    delay: _propTypes2.default.number
	  }).isRequired,
	  leave: _propTypes2.default.shape({
	    animation: _propTypes2.default.string,
	    duration: _propTypes2.default.number,
	    delay: _propTypes2.default.number
	  }),
	  visible: _propTypes2.default.bool
	};
	
	AnimateChild.defaultProps = {
	  visible: false
	};
	
	var Animate = function (_Component2) {
	  _inherits(Animate, _Component2);
	
	  function Animate(props, context) {
	    _classCallCheck(this, Animate);
	
	    var _this2 = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props, context));
	
	    _this2._checkScroll = _this2._checkScroll.bind(_this2);
	    _this2.state = { visible: true === props.visible };
	    return _this2;
	  }
	
	  _createClass(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if ('scroll' === this.props.visible) {
	        this._listenForScroll();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var visible = this.props.visible;
	
	      if (visible !== nextProps.visible) {
	        if ('scroll' === visible) {
	          this._unlistenForScroll();
	        } else if ('scroll' === nextProps.visible) {
	          this._listenForScroll();
	        }
	        this.setState({ visible: true === nextProps.visible });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if ('scroll' === this.props.visible) {
	        this._unlistenForScroll();
	      }
	    }
	  }, {
	    key: '_listenForScroll',
	    value: function _listenForScroll() {
	      var _this3 = this;
	
	      // add a time so that the finScrollParents function
	      // get the right container sizes
	      setTimeout(function () {
	        var scrollParents = (0, _DOM.findScrollParents)((0, _reactDom.findDOMNode)(_this3.animateRef));
	        scrollParents.forEach(function (scrollParent) {
	          scrollParent.addEventListener('scroll', _this3._checkScroll);
	        }, _this3);
	      }, 0);
	    }
	  }, {
	    key: '_unlistenForScroll',
	    value: function _unlistenForScroll() {
	      var _this4 = this;
	
	      var scrollParents = (0, _DOM.findScrollParents)((0, _reactDom.findDOMNode)(this.animateRef));
	      scrollParents.forEach(function (scrollParent) {
	        scrollParent.removeEventListener('scroll', _this4._checkScroll);
	      }, this);
	    }
	  }, {
	    key: '_checkScroll',
	    value: function _checkScroll() {
	      var _props = this.props,
	          onAppear = _props.onAppear,
	          onLeave = _props.onLeave;
	
	      var group = (0, _reactDom.findDOMNode)(this);
	      var rect = group.getBoundingClientRect();
	
	      if (rect.top < window.innerHeight) {
	        this.setState({ visible: true }, function () {
	          if (onAppear) {
	            onAppear();
	          }
	        });
	      } else {
	        this.setState({ visible: false }, function () {
	          if (onLeave) {
	            onLeave();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props2 = this.props,
	          enter = _props2.enter,
	          leave = _props2.leave,
	          className = _props2.className,
	          children = _props2.children,
	          component = _props2.component,
	          keep = _props2.keep,
	          props = _objectWithoutProperties(_props2, ['enter', 'leave', 'className', 'children', 'component', 'keep']);
	
	      delete props.onAppear;
	      delete props.onLeave;
	      delete props.visible;
	      var visible = this.state.visible;
	
	
	      var classes = (0, _classnames2.default)(CLASS_ROOT, className);
	
	      var animateChildren = void 0;
	      if (keep || visible) {
	        animateChildren = _react2.default.Children.map(children, function (child, index) {
	          return _react2.default.createElement(
	            AnimateChild,
	            { key: index, enter: enter, leave: leave,
	              visible: visible },
	            child
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        _reactTransitionGroup.TransitionGroup,
	        _extends({}, props, {
	          className: classes,
	          component: component,
	          ref: function ref(_ref3) {
	            return _this5.animateRef = _ref3;
	          }
	        }),
	        animateChildren
	      );
	    }
	  }]);
	
	  return Animate;
	}(_react.Component);
	
	Animate.displayName = 'Animate';
	exports.default = Animate;
	
	
	var ANIMATIONS = ['fade', 'slide-up', 'slide-down', 'slide-left', 'slide-right', 'jiggle'];
	
	Animate.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  enter: _propTypes2.default.shape({
	    animation: _propTypes2.default.oneOf(ANIMATIONS).isRequired,
	    duration: _propTypes2.default.number,
	    delay: _propTypes2.default.number
	  }).isRequired,
	  keep: _propTypes2.default.bool,
	  leave: _propTypes2.default.shape({
	    animation: _propTypes2.default.oneOf(ANIMATIONS).isRequired,
	    duration: _propTypes2.default.number,
	    delay: _propTypes2.default.number
	  }),
	  onAppear: _propTypes2.default.func,
	  onLeave: _propTypes2.default.func,
	  visible: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['scroll']), _propTypes2.default.bool])
	};
	
	Animate.defaultProps = {
	  component: 'div',
	  enter: { animation: 'fade', duration: 300 },
	  visible: true
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/grommet/components/Box.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _KeyboardAccelerators = __webpack_require__("./node_modules/grommet/utils/KeyboardAccelerators.js");
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _Intl = __webpack_require__("./node_modules/grommet/utils/Intl.js");
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__("./node_modules/grommet/utils/Props.js");
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _DOM = __webpack_require__("./node_modules/grommet/utils/DOM.js");
	
	var _SkipLinkAnchor = __webpack_require__("./node_modules/grommet/components/SkipLinkAnchor.js");
	
	var _SkipLinkAnchor2 = _interopRequireDefault(_SkipLinkAnchor);
	
	var _CSSClassnames = __webpack_require__("./node_modules/grommet/utils/CSSClassnames.js");
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Announcer = __webpack_require__("./node_modules/grommet/utils/Announcer.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.BOX;
	var BACKGROUND_COLOR_INDEX = _CSSClassnames2.default.BACKGROUND_COLOR_INDEX;
	
	var Box = function (_Component) {
	  _inherits(Box, _Component);
	
	  function Box(props) {
	    _classCallCheck(this, Box);
	
	    var _this = _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).call(this, props));
	
	    _this.state = { mouseActive: false };
	    return _this;
	  }
	
	  _createClass(Box, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var onClick = this.props.onClick;
	
	      if (onClick) {
	        var clickCallback = function clickCallback() {
	          if (_this2.boxContainerRef === document.activeElement) {
	            onClick();
	          }
	        };
	
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, {
	          enter: clickCallback,
	          space: clickCallback
	        });
	      }
	
	      this._setDarkBackground();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.colorIndex !== this.props.colorIndex) {
	        if (nextProps.colorIndex) {
	          this.setState({ updateDarkBackground: true });
	        } else {
	          this.setState({ darkBackground: undefined });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.announce) {
	        (0, _Announcer.announce)(this.boxContainerRef.textContent);
	      }
	      if (this.state.updateDarkBackground) {
	        this.setState({ updateDarkBackground: false });
	        this._setDarkBackground();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onClick) {
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this);
	      }
	      if (this._checkBackground) {
	        this._checkBackground.stop();
	      }
	    }
	  }, {
	    key: '_setDarkBackground',
	    value: function _setDarkBackground() {
	      var _this3 = this;
	
	      var colorIndex = this.props.colorIndex;
	
	      var box = (0, _reactDom.findDOMNode)(this.boxContainerRef);
	      if (this._checkBackground) {
	        this._checkBackground.stop();
	      }
	      this._checkBackground = (0, _DOM.checkDarkBackground)(colorIndex, box, function (darkBackground) {
	        return _this3.setState({ darkBackground: darkBackground });
	      });
	    }
	  }, {
	    key: '_normalize',
	    value: function _normalize(string) {
	      return string.replace('/', '-');
	    }
	  }, {
	    key: '_addPropertyClass',
	    value: function _addPropertyClass(classes, property) {
	      var _this4 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var value = (options.object || this.props)[property];
	      var elementName = options.elementName || CLASS_ROOT;
	      var prefix = options.prefix || property;
	      if (value) {
	        if (typeof value === 'string') {
	          classes.push(elementName + '--' + prefix + '-' + this._normalize(value));
	        } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	          Object.keys(value).forEach(function (key) {
	            _this4._addPropertyClass(classes, key, {
	              object: value, prefix: prefix + '-' + key });
	          });
	        } else {
	          classes.push(elementName + '--' + this._normalize(prefix));
	        }
	      }
	    }
	  }, {
	    key: '_backgroundContextClass',
	    value: function _backgroundContextClass(darkBackground) {
	      var result = void 0;
	      if (undefined === darkBackground) {
	        result = BACKGROUND_COLOR_INDEX + '--pending';
	      } else if (darkBackground) {
	        result = BACKGROUND_COLOR_INDEX + '--dark';
	      } else {
	        result = BACKGROUND_COLOR_INDEX + '--light';
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          appCentered = _props.appCentered,
	          backgroundImage = _props.backgroundImage,
	          children = _props.children,
	          className = _props.className,
	          colorIndex = _props.colorIndex,
	          containerClassName = _props.containerClassName,
	          focusable = _props.focusable,
	          full = _props.full,
	          id = _props.id,
	          onClick = _props.onClick,
	          _onBlur = _props.onBlur,
	          _onFocus = _props.onFocus,
	          _onMouseDown = _props.onMouseDown,
	          _onMouseUp = _props.onMouseUp,
	          pad = _props.pad,
	          primary = _props.primary,
	          role = _props.role,
	          size = _props.size,
	          tabIndex = _props.tabIndex,
	          tag = _props.tag,
	          texture = _props.texture;
	      var _state = this.state,
	          darkBackground = _state.darkBackground,
	          mouseActive = _state.mouseActive;
	
	      var classes = [CLASS_ROOT];
	      var containerClasses = [CLASS_ROOT + '__container'];
	      var restProps = _Props2.default.omit(this.props, Object.keys(Box.propTypes));
	      this._addPropertyClass(classes, 'full');
	      if (full && full.responsive === undefined) {
	        // default is true for backwards compatibility sake
	        classes.push(CLASS_ROOT + '--full-responsive');
	      }
	      this._addPropertyClass(classes, 'direction');
	      this._addPropertyClass(classes, 'justify');
	      this._addPropertyClass(classes, 'align');
	      this._addPropertyClass(classes, 'alignContent', { prefix: 'align-content' });
	      this._addPropertyClass(classes, 'alignSelf', { prefix: 'align-self' });
	      this._addPropertyClass(classes, 'reverse');
	      this._addPropertyClass(classes, 'responsive');
	      this._addPropertyClass(classes, 'basis');
	      this._addPropertyClass(classes, 'flex');
	      this._addPropertyClass(classes, 'pad');
	      this._addPropertyClass(classes, 'margin');
	      this._addPropertyClass(classes, 'separator');
	      this._addPropertyClass(classes, 'textAlign', { prefix: 'text-align' });
	      this._addPropertyClass(classes, 'wrap');
	
	      if (this.props.hasOwnProperty('flex')) {
	        if (!this.props.flex) {
	          classes.push(CLASS_ROOT + '--flex-off');
	        }
	      }
	      if (size) {
	        if ((typeof size === 'undefined' ? 'undefined' : _typeof(size)) === 'object') {
	          Object.keys(size).forEach(function (key) {
	            _this5._addPropertyClass(classes, key, { object: size });
	          });
	        } else {
	          this._addPropertyClass(classes, 'size');
	        }
	        if (size) {
	          if (!(size.width && size.width.max)) {
	            // don't apply 100% max-width when size using size.width.max option
	            classes.push(CLASS_ROOT + '--size');
	          }
	          if (size.width && size.width.max) {
	            // allow widths to shrink, apply 100% width
	            classes.push(CLASS_ROOT + '--width-max');
	          }
	        }
	      }
	
	      // needed to properly set flex-basis for 1/3 & 2/3 basis boxes
	      if (pad && pad.between && children) {
	        if (_react2.default.Children.count(children) % 3 === 0) {
	          classes.push(CLASS_ROOT + '--pad-between-thirds');
	        }
	      }
	
	      if (appCentered) {
	        this._addPropertyClass(containerClasses, 'full', { elementName: CLASS_ROOT + '__container' });
	        if (colorIndex) {
	          containerClasses.push(BACKGROUND_COLOR_INDEX + '-' + colorIndex);
	          containerClasses.push(this._backgroundContextClass(darkBackground));
	        }
	        if (containerClassName) {
	          containerClasses.push(containerClassName);
	        }
	      } else if (colorIndex) {
	        classes.push(BACKGROUND_COLOR_INDEX + '-' + colorIndex);
	        classes.push(this._backgroundContextClass(darkBackground));
	      }
	
	      var a11yProps = {};
	      var clickableProps = {};
	      if (onClick) {
	        classes.push(CLASS_ROOT + "--clickable");
	        clickableProps = {
	          onMouseDown: function onMouseDown(event) {
	            _this5.setState({ mouseActive: true });
	            if (_onMouseDown) {
	              _onMouseDown(event);
	            }
	          },
	          onMouseUp: function onMouseUp(event) {
	            _this5.setState({ mouseActive: false });
	            if (_onMouseUp) {
	              _onMouseUp(event);
	            }
	          },
	          onFocus: function onFocus(event) {
	            if (mouseActive === false) {
	              _this5.setState({ focus: true });
	            }
	            if (_onFocus) {
	              _onFocus(event);
	            }
	          },
	          onBlur: function onBlur(event) {
	            _this5.setState({ focus: false });
	            if (_onBlur) {
	              _onBlur(event);
	            }
	          }
	        };
	        if (focusable) {
	          if (this.state.focus) {
	            classes.push(CLASS_ROOT + '--focus');
	          }
	          var boxLabel = typeof a11yTitle !== 'undefined' ? a11yTitle : _Intl2.default.getMessage(this.context.intl, 'Box');
	          a11yProps.tabIndex = tabIndex || 0;
	          a11yProps["aria-label"] = this.props['aria-label'] || boxLabel;
	          a11yProps.role = role || 'group';
	        }
	      }
	
	      var skipLinkAnchor = void 0;
	      if (primary) {
	        var mainContentLabel = _Intl2.default.getMessage(this.context.intl, 'Main Content');
	        skipLinkAnchor = _react2.default.createElement(_SkipLinkAnchor2.default, { label: mainContentLabel });
	      }
	
	      if (className) {
	        classes.push(className);
	      }
	
	      var style = {};
	      if (texture && 'string' === typeof texture) {
	        if (texture.indexOf('url(') !== -1) {
	          style.backgroundImage = texture;
	        } else {
	          style.backgroundImage = 'url(' + texture + ')';
	        }
	      } else if (backgroundImage) {
	        style.background = backgroundImage + " no-repeat center center";
	        style.backgroundSize = "cover";
	      }
	      style = _extends({}, style, restProps.style);
	      var textureMarkup = void 0;
	      if ('object' === (typeof texture === 'undefined' ? 'undefined' : _typeof(texture))) {
	        textureMarkup = _react2.default.createElement(
	          'div',
	          { className: CLASS_ROOT + "__texture" },
	          texture
	        );
	      }
	
	      var Component = tag;
	      if (appCentered) {
	        return _react2.default.createElement(
	          'div',
	          _extends({}, restProps, { ref: function ref(_ref) {
	              return _this5.boxContainerRef = _ref;
	            },
	            className: containerClasses.join(' '),
	            style: style, role: role }, a11yProps, clickableProps),
	          skipLinkAnchor,
	          _react2.default.createElement(
	            Component,
	            { id: id, className: classes.join(' ') },
	            textureMarkup,
	            children
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          Component,
	          _extends({}, restProps, { ref: function ref(_ref2) {
	              return _this5.boxContainerRef = _ref2;
	            },
	            id: id, className: classes.join(' '), style: style,
	            role: role, tabIndex: tabIndex,
	            onClick: onClick }, a11yProps, clickableProps),
	          skipLinkAnchor,
	          textureMarkup,
	          children
	        );
	      }
	    }
	  }]);
	
	  return Box;
	}(_react.Component);
	
	Box.displayName = 'Box';
	exports.default = Box;
	
	
	var FIXED_SIZES = ['xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge'];
	var RELATIVE_SIZES = ['full', '1/2', '1/3', '2/3', '1/4', '3/4'];
	var SIZES = FIXED_SIZES.concat(RELATIVE_SIZES);
	var MARGIN_SIZES = ['small', 'medium', 'large', 'none'];
	var PAD_SIZES = ['small', 'medium', 'large', 'xlarge', 'none'];
	
	Box.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  announce: _propTypes2.default.bool,
	  align: _propTypes2.default.oneOf(['start', 'center', 'end', 'baseline', 'stretch']),
	  alignContent: _propTypes2.default.oneOf(['start', 'center', 'end', 'between', 'around', 'stretch']),
	  alignSelf: _propTypes2.default.oneOf(['start', 'center', 'end', 'stretch']),
	  appCentered: _propTypes2.default.bool,
	  backgroundImage: _propTypes2.default.string,
	  basis: _propTypes2.default.oneOf(SIZES),
	  colorIndex: _propTypes2.default.string,
	  containerClassName: _propTypes2.default.string,
	  direction: _propTypes2.default.oneOf(['row', 'column']),
	  focusable: _propTypes2.default.bool,
	  flex: _propTypes2.default.oneOf(['grow', 'shrink', true, false]),
	  full: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.shape({
	    vertical: _propTypes2.default.bool,
	    horizontal: _propTypes2.default.bool,
	    responsive: _propTypes2.default.bool
	  })]),
	  // remove in 1.0?
	  onClick: _propTypes2.default.func,
	  justify: _propTypes2.default.oneOf(['start', 'center', 'between', 'end', 'around']),
	  margin: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(MARGIN_SIZES), _propTypes2.default.shape({
	    bottom: _propTypes2.default.oneOf(MARGIN_SIZES),
	    horizontal: _propTypes2.default.oneOf(MARGIN_SIZES),
	    left: _propTypes2.default.oneOf(MARGIN_SIZES),
	    right: _propTypes2.default.oneOf(MARGIN_SIZES),
	    top: _propTypes2.default.oneOf(MARGIN_SIZES),
	    vertical: _propTypes2.default.oneOf(MARGIN_SIZES)
	  })]),
	  pad: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(PAD_SIZES), _propTypes2.default.shape({
	    between: _propTypes2.default.oneOf(PAD_SIZES),
	    horizontal: _propTypes2.default.oneOf(PAD_SIZES),
	    vertical: _propTypes2.default.oneOf(PAD_SIZES)
	  })]),
	  primary: _propTypes2.default.bool,
	  reverse: _propTypes2.default.bool,
	  responsive: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  separator: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right', 'horizontal', 'vertical', 'all', 'none']),
	  size: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'full']), // remove in 1.0?, use basis
	  _propTypes2.default.shape({
	    height: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.shape({
	      max: _propTypes2.default.oneOf(FIXED_SIZES),
	      min: _propTypes2.default.oneOf(FIXED_SIZES)
	    })]),
	    width: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.shape({
	      max: _propTypes2.default.oneOf(FIXED_SIZES),
	      min: _propTypes2.default.oneOf(FIXED_SIZES)
	    })])
	  })]),
	  tag: _propTypes2.default.string,
	  textAlign: _propTypes2.default.oneOf(['left', 'center', 'right']),
	  texture: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
	  wrap: _propTypes2.default.bool
	};
	
	Box.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Box.defaultProps = {
	  announce: false,
	  direction: 'column',
	  pad: 'none',
	  tag: 'div',
	  responsive: true,
	  focusable: true
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/grommet/components/Heading.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__("./node_modules/grommet/utils/CSSClassnames.js");
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.HEADING;
	
	var Heading = function (_Component) {
	  _inherits(Heading, _Component);
	
	  function Heading() {
	    _classCallCheck(this, Heading);
	
	    return _possibleConstructorReturn(this, (Heading.__proto__ || Object.getPrototypeOf(Heading)).apply(this, arguments));
	  }
	
	  _createClass(Heading, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          align = _props.align,
	          children = _props.children,
	          className = _props.className,
	          margin = _props.margin,
	          size = _props.size,
	          strong = _props.strong,
	          Tag = _props.tag,
	          truncate = _props.truncate,
	          uppercase = _props.uppercase,
	          props = _objectWithoutProperties(_props, ['align', 'children', 'className', 'margin', 'size', 'strong', 'tag', 'truncate', 'uppercase']);
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--strong', strong), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, CLASS_ROOT + '--margin-' + margin, margin), _defineProperty(_classnames, CLASS_ROOT + '--truncate', truncate), _defineProperty(_classnames, CLASS_ROOT + '--uppercase', uppercase), _classnames), className);
	
	      return _react2.default.createElement(
	        Tag,
	        _extends({}, props, { className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return Heading;
	}(_react.Component);
	
	Heading.displayName = 'Heading';
	exports.default = Heading;
	
	
	Heading.propTypes = {
	  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
	  margin: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  strong: _propTypes2.default.bool,
	  tag: _propTypes2.default.string,
	  truncate: _propTypes2.default.bool,
	  uppercase: _propTypes2.default.bool
	};
	
	Heading.defaultProps = {
	  tag: 'h1'
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/grommet/components/List.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Spinning = __webpack_require__("./node_modules/grommet/components/icons/Spinning.js");
	
	var _Spinning2 = _interopRequireDefault(_Spinning);
	
	var _InfiniteScroll = __webpack_require__("./node_modules/grommet/utils/InfiniteScroll.js");
	
	var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);
	
	var _Selection = __webpack_require__("./node_modules/grommet/utils/Selection.js");
	
	var _Selection2 = _interopRequireDefault(_Selection);
	
	var _CSSClassnames = __webpack_require__("./node_modules/grommet/utils/CSSClassnames.js");
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _KeyboardAccelerators = __webpack_require__("./node_modules/grommet/utils/KeyboardAccelerators.js");
	
	var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);
	
	var _Intl = __webpack_require__("./node_modules/grommet/utils/Intl.js");
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Announcer = __webpack_require__("./node_modules/grommet/utils/Announcer.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.LIST;
	var LIST_ITEM = _CSSClassnames2.default.LIST_ITEM;
	var SELECTED_CLASS = CLASS_ROOT + '-item--selected';
	var ACTIVE_CLASS = CLASS_ROOT + '-item--active';
	
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List(props, context) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props, context));
	
	    _this._onClick = _this._onClick.bind(_this);
	    _this._fireClick = _this._fireClick.bind(_this);
	    _this._announceItem = _this._announceItem.bind(_this);
	    _this._onPreviousItem = _this._onPreviousItem.bind(_this);
	    _this._onNextItem = _this._onNextItem.bind(_this);
	    _this._onEnter = _this._onEnter.bind(_this);
	
	    _this.state = {
	      activeItem: undefined,
	      mouseActive: false,
	      selected: _Selection2.default.normalizeIndexes(props.selected)
	    };
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          onMore = _props.onMore,
	          selectable = _props.selectable;
	
	      this._setSelection();
	      if (onMore) {
	        this._scroll = _InfiniteScroll2.default.startListeningForScroll(this.moreRef, onMore);
	      }
	      if (selectable) {
	        // only listen for navigation keys if the list row can be selected
	        this._keyboardHandlers = {
	          left: this._onPreviousItem,
	          up: this._onPreviousItem,
	          right: this._onNextItem,
	          down: this._onNextItem,
	          enter: this._onEnter,
	          space: this._onEnter
	        };
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this._scroll) {
	        _InfiniteScroll2.default.stopListeningForScroll(this._scroll);
	        this._scroll = undefined;
	      }
	      if (nextProps.hasOwnProperty('selected')) {
	        this.setState({
	          selected: _Selection2.default.normalizeIndexes(nextProps.selected)
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props2 = this.props,
	          onMore = _props2.onMore,
	          selectable = _props2.selectable;
	      var selected = this.state.selected;
	
	      if (JSON.stringify(selected) !== JSON.stringify(prevState.selected)) {
	        this._setSelection();
	      }
	      if (onMore && !this._scroll) {
	        this._scroll = _InfiniteScroll2.default.startListeningForScroll(this.moreRef, onMore);
	      }
	      if (selectable) {
	        // only listen for navigation keys if the list row can be selected
	        this._keyboardHandlers = {
	          left: this._onPreviousItem,
	          up: this._onPreviousItem,
	          right: this._onNextItem,
	          down: this._onNextItem,
	          enter: this._onEnter,
	          space: this._onEnter
	        };
	        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var selectable = this.props.selectable;
	
	      if (this._scroll) {
	        _InfiniteScroll2.default.stopListeningForScroll(this._scroll);
	      }
	      if (selectable) {
	        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
	      }
	    }
	  }, {
	    key: '_announceItem',
	    value: function _announceItem(label) {
	      var intl = this.context.intl;
	
	      var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
	      (0, _Announcer.announce)(label + ' ' + enterSelectMessage);
	    }
	  }, {
	    key: '_setSelection',
	    value: function _setSelection() {
	      if (this.listRef) {
	        _Selection2.default.setClassFromIndexes({
	          containerElement: this.listRef,
	          childSelector: '.' + LIST_ITEM,
	          selectedClass: SELECTED_CLASS,
	          selectedIndexes: this.state.selected
	        });
	      };
	    }
	  }, {
	    key: '_onPreviousItem',
	    value: function _onPreviousItem(event) {
	      var _this2 = this;
	
	      if (this.listRef.contains(document.activeElement)) {
	        event.preventDefault();
	        var activeItem = this.state.activeItem;
	
	        var rows = this.listRef.querySelectorAll('ul li');
	        if (rows && rows.length > 0) {
	          if (activeItem === undefined) {
	            rows[0].classList.add(ACTIVE_CLASS);
	            this.setState({ activeItem: 0 }, function () {
	              _this2._announceItem(rows[_this2.state.activeItem].innerText);
	            });
	          } else if (activeItem - 1 >= 0) {
	            rows[activeItem].classList.remove(ACTIVE_CLASS);
	            rows[activeItem - 1].classList.add(ACTIVE_CLASS);
	            this.setState({ activeItem: activeItem - 1 }, function () {
	              _this2._announceItem(rows[_this2.state.activeItem].innerText);
	            });
	          }
	        }
	
	        //stop event propagation
	        return true;
	      }
	    }
	  }, {
	    key: '_onNextItem',
	    value: function _onNextItem(event) {
	      var _this3 = this;
	
	      if (this.listRef.contains(document.activeElement)) {
	        event.preventDefault();
	        var activeItem = this.state.activeItem;
	
	        var rows = this.listRef.querySelectorAll('ul li');
	        if (rows && rows.length > 0) {
	          if (activeItem === undefined) {
	            rows[0].classList.add(ACTIVE_CLASS);
	            this.setState({ activeItem: 0 }, function () {
	              _this3._announceItem(rows[_this3.state.activeItem].innerText);
	            });
	          } else if (activeItem + 1 <= rows.length - 1) {
	            rows[activeItem].classList.remove(ACTIVE_CLASS);
	            rows[activeItem + 1].classList.add(ACTIVE_CLASS);
	            this.setState({ activeItem: activeItem + 1 }, function () {
	              _this3._announceItem(rows[_this3.state.activeItem].innerText);
	            });
	          }
	        }
	
	        //stop event propagation
	        return true;
	      }
	    }
	  }, {
	    key: '_fireClick',
	    value: function _fireClick(element, shiftKey) {
	      var event = void 0;
	      try {
	        event = new MouseEvent('click', {
	          'bubbles': true,
	          'cancelable': true,
	          'shiftKey': shiftKey
	        });
	      } catch (e) {
	        // IE11 workaround.
	        event = document.createEvent('Event');
	        event.initEvent('click', true, true);
	      }
	      // We use dispatchEvent to have the browser fill out the event fully.
	      element.dispatchEvent(event);
	    }
	  }, {
	    key: '_onEnter',
	    value: function _onEnter(event) {
	      var activeItem = this.state.activeItem;
	      var intl = this.context.intl;
	
	      if (this.listRef.contains(document.activeElement) && activeItem !== undefined) {
	        var rows = this.listRef.querySelectorAll('ul li');
	        this._fireClick(rows[activeItem], event.shiftKey);
	        rows[activeItem].classList.remove(ACTIVE_CLASS);
	        var label = rows[activeItem].innerText;
	        var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
	        (0, _Announcer.announce)(label + ' ' + selectedMessage);
	      }
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick(event) {
	      var _props3 = this.props,
	          onSelect = _props3.onSelect,
	          selectable = _props3.selectable,
	          selected = _props3.selected;
	
	      if (!this.props.selectable) {
	        return;
	      }
	
	      var selection = _Selection2.default.onClick(event, {
	        containerElement: this.listRef,
	        childSelector: '.' + LIST_ITEM,
	        selectedClass: SELECTED_CLASS,
	        multiSelect: 'multiple' === selectable,
	        priorSelectedIndexes: this.state.selected
	      });
	
	      // only set the selected state and classes if the caller isn't managing it.
	      if (selected === undefined) {
	        this.setState({ selected: selection }, this._setSelection);
	      }
	
	      if (onSelect) {
	        onSelect(selection.length === 1 ? selection[0] : selection);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames,
	          _this4 = this;
	
	      var _props4 = this.props,
	          a11yTitle = _props4.a11yTitle,
	          children = _props4.children,
	          className = _props4.className,
	          emptyIndicator = _props4.emptyIndicator,
	          _onBlur = _props4.onBlur,
	          _onFocus = _props4.onFocus,
	          onMore = _props4.onMore,
	          _onMouseDown = _props4.onMouseDown,
	          _onMouseUp = _props4.onMouseUp,
	          selectable = _props4.selectable,
	          props = _objectWithoutProperties(_props4, ['a11yTitle', 'children', 'className', 'emptyIndicator', 'onBlur', 'onFocus', 'onMore', 'onMouseDown', 'onMouseUp', 'selectable']);
	
	      var _state = this.state,
	          activeItem = _state.activeItem,
	          focus = _state.focus,
	          mouseActive = _state.mouseActive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--focus', focus), _defineProperty(_classnames, CLASS_ROOT + '--selectable', selectable), _defineProperty(_classnames, CLASS_ROOT + '--moreable', onMore), _classnames), className);
	
	      var empty = void 0;
	      if (emptyIndicator) {
	        empty = _react2.default.createElement(
	          'li',
	          { className: CLASS_ROOT + '__empty' },
	          emptyIndicator
	        );
	      }
	
	      var more = void 0;
	      if (onMore) {
	        more = _react2.default.createElement(
	          'li',
	          { ref: function ref(_ref) {
	              return _this4.moreRef = _ref;
	            }, className: CLASS_ROOT + '__more' },
	          _react2.default.createElement(_Spinning2.default, null)
	        );
	      }
	
	      var selectableProps = void 0;
	      if (selectable) {
	        var multiSelectMessage = selectable === 'multiple' ? '(' + _Intl2.default.getMessage(intl, 'Multi Select') + ')' : '';
	        var listMessage = a11yTitle || _Intl2.default.getMessage(intl, 'List');
	        var navigationHelpMessage = _Intl2.default.getMessage(intl, 'Navigation Help');
	        selectableProps = {
	          'aria-label': listMessage + ' ' + multiSelectMessage + ' ' + navigationHelpMessage,
	          tabIndex: '0',
	          onClick: this._onClick,
	          onMouseDown: function onMouseDown(event) {
	            _this4.setState({ mouseActive: true });
	            if (_onMouseDown) {
	              _onMouseDown(event);
	            }
	          },
	          onMouseUp: function onMouseUp(event) {
	            _this4.setState({ mouseActive: false });
	            if (_onMouseUp) {
	              _onMouseUp(event);
	            }
	          },
	          onFocus: function onFocus(event) {
	            if (mouseActive === false) {
	              _this4.setState({ focus: true });
	            }
	            if (_onFocus) {
	              _onFocus(event);
	            }
	          },
	          onBlur: function onBlur(event) {
	            if (activeItem) {
	              var rows = _this4.listRef.querySelectorAll('ul li');
	              rows[activeItem].classList.remove(ACTIVE_CLASS);
	            }
	            _this4.setState({ focus: false, activeItem: undefined });
	            if (_onBlur) {
	              _onBlur(event);
	            }
	          }
	        };
	      }
	
	      return _react2.default.createElement(
	        'ul',
	        _extends({}, props, { ref: function ref(_ref2) {
	            return _this4.listRef = _ref2;
	          }, className: classes
	        }, selectableProps),
	        empty,
	        children,
	        more
	      );
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	List.displayName = 'List';
	exports.default = List;
	
	
	List.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	List.propTypes = {
	  emptyIndicator: _propTypes2.default.node,
	  onMore: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  selectable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['multiple'])]),
	  selected: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)])
	};
	
	List.defaultProps = {
	  role: 'list'
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/grommet/components/ListItem.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Box = __webpack_require__("./node_modules/grommet/components/Box.js");
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Props = __webpack_require__("./node_modules/grommet/utils/Props.js");
	
	var _Props2 = _interopRequireDefault(_Props);
	
	var _CSSClassnames = __webpack_require__("./node_modules/grommet/utils/CSSClassnames.js");
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.LIST_ITEM;
	
	var ListItem = function (_Component) {
	  _inherits(ListItem, _Component);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  _createClass(ListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onClick = _props.onClick;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, className, _defineProperty({}, CLASS_ROOT + '--selectable', onClick));
	
	      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
	      var restProps = _Props2.default.omit(this.props, Object.keys(ListItem.propTypes));
	
	      return _react2.default.createElement(
	        _Box2.default,
	        _extends({}, boxProps, restProps, { tag: 'li', className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return ListItem;
	}(_react.Component);
	
	ListItem.displayName = 'ListItem';
	exports.default = ListItem;
	;
	
	ListItem.propTypes = _extends({}, _Box2.default.propTypes);
	
	ListItem.defaultProps = {
	  align: 'center',
	  direction: 'row',
	  pad: { horizontal: 'medium', vertical: 'small' },
	  separator: 'bottom',
	  role: 'listitem'
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/grommet/components/SkipLinkAnchor.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSClassnames = __webpack_require__("./node_modules/grommet/utils/CSSClassnames.js");
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.SKIP_LINK_ANCHOR;
	
	var SkipLinkAnchor = function (_Component) {
	  _inherits(SkipLinkAnchor, _Component);
	
	  function SkipLinkAnchor() {
	    _classCallCheck(this, SkipLinkAnchor);
	
	    return _possibleConstructorReturn(this, (SkipLinkAnchor.__proto__ || Object.getPrototypeOf(SkipLinkAnchor)).apply(this, arguments));
	  }
	
	  _createClass(SkipLinkAnchor, [{
	    key: 'render',
	    value: function render() {
	      var id = 'skip-link-' + this.props.label.toLowerCase().replace(/ /g, '_');
	
	      return _react2.default.createElement(
	        'a',
	        { tabIndex: '-1', 'aria-hidden': 'true', id: id, className: CLASS_ROOT },
	        this.props.label
	      );
	    }
	  }]);
	
	  return SkipLinkAnchor;
	}(_react.Component);
	
	SkipLinkAnchor.displayName = 'SkipLinkAnchor';
	exports.default = SkipLinkAnchor;
	
	
	SkipLinkAnchor.propTypes = {
	  label: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/grommet/components/icons/Pulse.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Add = __webpack_require__("./node_modules/grommet/components/icons/base/Add.js");
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _CSSClassnames = __webpack_require__("./node_modules/grommet/utils/CSSClassnames.js");
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.PULSE;
	
	var Pulse = function (_Component) {
	  _inherits(Pulse, _Component);
	
	  function Pulse() {
	    _classCallCheck(this, Pulse);
	
	    return _possibleConstructorReturn(this, (Pulse.__proto__ || Object.getPrototypeOf(Pulse)).apply(this, arguments));
	  }
	
	  _createClass(Pulse, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          icon = _props.icon,
	          props = _objectWithoutProperties(_props, ['className', 'icon']);
	
	      var classes = (0, _classnames2.default)(CLASS_ROOT, className);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, { className: classes }),
	        _react2.default.createElement(
	          'div',
	          { className: CLASS_ROOT + '__icon' },
	          icon
	        ),
	        _react2.default.createElement('div', { className: CLASS_ROOT + '__icon-anim' })
	      );
	    }
	  }]);
	
	  return Pulse;
	}(_react.Component);
	
	Pulse.displayName = 'Pulse';
	exports.default = Pulse;
	
	
	Pulse.propTypes = {
	  className: _propTypes2.default.string,
	  icon: _propTypes2.default.node
	};
	
	Pulse.defaultProps = {
	  icon: _react2.default.createElement(_Add2.default, null)
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/grommet/components/icons/Spinning.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__("./node_modules/grommet/utils/CSSClassnames.js");
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__("./node_modules/grommet/utils/Intl.js");
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.SPINNING;
	
	var Spinning = function (_Component) {
	  _inherits(Spinning, _Component);
	
	  function Spinning() {
	    _classCallCheck(this, Spinning);
	
	    return _possibleConstructorReturn(this, (Spinning.__proto__ || Object.getPrototypeOf(Spinning)).apply(this, arguments));
	  }
	
	  _createClass(Spinning, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          a11yTitle = _props.a11yTitle,
	          className = _props.className,
	          small = _props.small,
	          size = _props.size,
	          responsive = _props.responsive,
	          props = _objectWithoutProperties(_props, ['a11yTitle', 'className', 'small', 'size', 'responsive']);
	
	      var intl = this.context.intl;
	
	
	      var sizeOverride = small ? 'small' : size;
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + sizeOverride, sizeOverride), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _classnames), className);
	
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, { className: classes, viewBox: '0 0 48 48', version: '1.1',
	          role: 'img', 'aria-label': a11yTitle || _Intl2.default.getMessage(intl, 'Spinning') }),
	        _react2.default.createElement('circle', { cx: '24', cy: '24', r: '21',
	          stroke: '#979797', strokeWidth: '6', fill: 'none' })
	      );
	    }
	  }]);
	
	  return Spinning;
	}(_react.Component);
	
	Spinning.displayName = 'Spinning';
	exports.default = Spinning;
	
	
	Spinning.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Spinning.defaultProps = {
	  responsive: true
	};
	
	Spinning.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  small: _propTypes2.default.bool,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/grommet/components/icons/base/Add.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__("./node_modules/grommet/utils/CSSClassnames.js");
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__("./node_modules/grommet/utils/Intl.js");
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__("./node_modules/grommet/utils/Props.js");
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-add', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'add');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 L12,2 M2,12 L22,12' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Add';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/grommet/components/icons/base/Copy.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CSSClassnames = __webpack_require__("./node_modules/grommet/utils/CSSClassnames.js");
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	var _Intl = __webpack_require__("./node_modules/grommet/utils/Intl.js");
	
	var _Intl2 = _interopRequireDefault(_Intl);
	
	var _Props = __webpack_require__("./node_modules/grommet/utils/Props.js");
	
	var _Props2 = _interopRequireDefault(_Props);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
	
	var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
	var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          colorIndex = _props.colorIndex;
	      var _props2 = this.props,
	          a11yTitle = _props2.a11yTitle,
	          size = _props2.size,
	          responsive = _props2.responsive;
	      var intl = this.context.intl;
	
	
	      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-copy', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));
	
	      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'copy');
	
	      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
	        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M9,15 L17,15 L9,15 Z M9,11 L19,11 L9,11 Z M9,7 L13,7 L9,7 Z M16,1 L16,7 L22,7 M6,5 L2,5 L2,23 L18,23 L18,19 M22,19 L6,19 L6,1 L17,1 L22,6 L22,19 L22,19 Z' })
	      );
	    }
	  }]);
	
	  return Icon;
	}(_react.Component);
	
	Icon.displayName = 'Icon';
	exports.default = Icon;
	;
	
	Icon.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	Icon.defaultProps = {
	  responsive: true
	};
	
	Icon.displayName = 'Copy';
	
	Icon.icon = true;
	
	Icon.propTypes = {
	  a11yTitle: _propTypes2.default.string,
	  colorIndex: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
	  responsive: _propTypes2.default.bool
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/grommet/utils/Announcer.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.announcePageLoaded = announcePageLoaded;
	exports.announce = announce;
	
	var _CSSClassnames = __webpack_require__("./node_modules/grommet/utils/CSSClassnames.js");
	
	var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLASS_ROOT = _CSSClassnames2.default.APP; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	function clearAnnouncer() {
	  var announcer = document.querySelector('.' + CLASS_ROOT + '__announcer');
	  if (announcer) {
	    announcer.innerHTML = '';
	  }
	};
	
	function announcePageLoaded(title) {
	  announce(title + ' page was loaded');
	}
	
	function announce(message) {
	  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'assertive';
	
	  var announcer = document.querySelector('.' + CLASS_ROOT + '__announcer');
	  if (announcer) {
	    announcer.setAttribute('aria-live', 'off');
	    announcer.innerHTML = message;
	    setTimeout(clearAnnouncer, 500);
	    announcer.setAttribute('aria-live', mode);
	  }
	}
	
	exports.default = { announce: announce, announcePageLoaded: announcePageLoaded };

/***/ }),

/***/ "./node_modules/grommet/utils/CSSClassnames.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2016 Hewlett Packard Enterprise Development LP
	
	var namespace = exports.namespace = 'grommetux-';
	
	exports.default = {
	  ACCORDION: namespace + 'accordion',
	  ACCORDION_PANEL: namespace + 'accordion-panel',
	  ANCHOR: namespace + 'anchor',
	  ANIMATE: namespace + 'animate',
	  APP: namespace + 'app',
	  ARTICLE: namespace + 'article',
	  ATTRIBUTE: namespace + 'attribute',
	  BACKGROUND_COLOR_INDEX: namespace + 'background-color-index',
	  BOX: namespace + 'box',
	  BORDER_COLOR_INDEX: namespace + 'border-color-index',
	  BRICK: namespace + 'brick',
	  BUTTON: namespace + 'button',
	  CALENDAR: namespace + 'calendar',
	  CARD: namespace + 'card',
	  CAROUSEL: namespace + 'carousel',
	  CAROUSEL_CONTROLS: namespace + 'carousel-controls',
	  CHART: namespace + 'chart',
	  CHART_AXIS: namespace + 'chart-axis',
	  CHART_BASE: namespace + 'chart-base',
	  CHART_GRAPH: namespace + 'chart-graph',
	  CHART_GRID: namespace + 'chart-grid',
	  CHART_HOT_SPOTS: namespace + 'chart-hot-spots',
	  CHART_LAYERS: namespace + 'chart-layers',
	  CHART_MARKER: namespace + 'chart-marker',
	  CHART_MARKER_LABEL: namespace + 'chart-marker-label',
	  CHART_RANGE: namespace + 'chart-range',
	  CHECK_BOX: namespace + 'check-box',
	  COLLAPSIBLE: namespace + 'collapsible',
	  COLOR_INDEX: namespace + 'color-index',
	  COLUMNS: namespace + 'columns',
	  CONTROL_ICON: namespace + 'control-icon',
	  DATE_TIME: namespace + 'date-time',
	  DATE_TIME_DROP: namespace + 'date-time-drop',
	  DISTRIBUTION: namespace + 'distribution',
	  DROP: namespace + 'drop',
	  FOOTER: namespace + 'footer',
	  FORM: namespace + 'form',
	  FORM_FIELD: namespace + 'form-field',
	  FORM_FIELDS: namespace + 'form-fields',
	  HEADER: namespace + 'header',
	  HEADING: namespace + 'heading',
	  HEADLINE: namespace + 'headline',
	  HERO: namespace + 'hero',
	  IMAGE: namespace + 'image',
	  IMAGE_FIELD: namespace + 'image-field',
	  INPUT: namespace + 'input',
	  LABEL: namespace + 'label',
	  LAYER: namespace + 'layer',
	  LEGEND: namespace + 'legend',
	  LIST: namespace + 'list',
	  LIST_ITEM: namespace + 'list-item',
	  LOGIN: namespace + 'login',
	  LOGIN_FORM: namespace + 'login-form',
	  LOGO_ICON: namespace + 'logo-icon',
	  MAP: namespace + 'map',
	  MENU: namespace + 'menu',
	  METER: namespace + 'meter',
	  NAMESPACE: '' + namespace,
	  NOTIFICATION: namespace + 'notification',
	  NUMBER_INPUT: namespace + 'number-input',
	  OBJECT: namespace + 'object',
	  PARAGRAPH: namespace + 'paragraph',
	  PASSWORD_INPUT: namespace + 'password-input',
	  PULSE: namespace + 'pulse',
	  QUOTE: namespace + 'quote',
	  RADIO_BUTTON: namespace + 'radio-button',
	  SEARCH: namespace + 'search',
	  SEARCH_INPUT: namespace + 'search-input',
	  SECTION: namespace + 'section',
	  SELECT: namespace + 'select',
	  SIDEBAR: namespace + 'sidebar',
	  SKIP_LINK_ANCHOR: namespace + 'skip-link-anchor',
	  SKIP_LINKS: namespace + 'skip-links',
	  SPLIT: namespace + 'split',
	  SPINNING: namespace + 'icon-spinning',
	  STATUS_ICON: namespace + 'status-icon',
	  SUN_BURST: namespace + 'sun-burst',
	  TAB: namespace + 'tab',
	  TABLE: namespace + 'table',
	  TABLE_ROW: namespace + 'table-row',
	  TABS: namespace + 'tabs',
	  TAG: namespace + 'tag',
	  TAGS: namespace + 'tags',
	  TBD: namespace + 'tbd',
	  TEXT_INPUT: namespace + 'text-input',
	  TILE: namespace + 'tile',
	  TILES: namespace + 'tiles',
	  TIMESTAMP: namespace + 'timestamp',
	  TIP: namespace + 'tip',
	  TITLE: namespace + 'title',
	  TOAST: namespace + 'toast',
	  TOPOLOGY: namespace + 'topology',
	  VALUE: namespace + 'value',
	  VIDEO: namespace + 'video',
	  WORLD_MAP: namespace + 'world-map'
	};

/***/ }),

/***/ "./node_modules/grommet/utils/DOM.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.findScrollParents = findScrollParents;
	exports.isDescendant = isDescendant;
	exports.findAncestor = findAncestor;
	exports.filterByFocusable = filterByFocusable;
	exports.getBestFirstFocusable = getBestFirstFocusable;
	exports.isFormElement = isFormElement;
	exports.generateId = generateId;
	exports.generateUUID = generateUUID;
	exports.checkDarkBackground = checkDarkBackground;
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var COLOR_RGB_REGEXP = /rgb\((\d+), (\d+), (\d+)\)/;
	var COLOR_RGBA_REGEXP = /rgba\((\d+), (\d+), (\d+), ([\d\.]+)\)/;
	var LIGHT_HINT_REGEXP = /^light/;
	
	function hash(input) {
	  var hash = 0,
	      i,
	      chr,
	      len;
	  if (input.length === 0) return hash;
	  for (i = 0, len = input.length; i < len; i++) {
	    chr = input.charCodeAt(i);
	    hash = (hash << 5) - hash + chr;
	    hash = hash & hash; // Convert to 32bit integer
	  }
	  return hash;
	};
	
	function findScrollParents(element, horizontal) {
	  var result = [];
	  var parent = element.parentNode;
	  while (parent && parent.getBoundingClientRect) {
	    var rect = parent.getBoundingClientRect();
	    // 10px is to account for borders and scrollbars in a lazy way
	    if (horizontal) {
	      if (rect.width && parent.scrollWidth > rect.width + 10) {
	        result.push(parent);
	      }
	    } else {
	      if (rect.height && parent.scrollHeight > rect.height + 10) {
	        result.push(parent);
	      }
	    }
	    parent = parent.parentNode;
	  }
	  // last scrollable element will be the document 
	  // if nothing else is scrollable in the page
	  if (result.length === 0) {
	    result.push(document);
	  }
	  return result;
	}
	
	function isDescendant(parent, child) {
	  var node = child.parentNode;
	  while (node != null) {
	    if (node == parent) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	  return false;
	}
	
	function findAncestor(element, className) {
	  var node = element.parentNode;
	  while (node != null) {
	    if (node.classList && node.classList.contains(className)) {
	      break;
	    }
	    node = node.parentNode;
	  }
	  return node;
	}
	
	function filterByFocusable(elements) {
	  return Array.prototype.filter.call(elements || [], function (element) {
	    var currentTag = element.tagName.toLowerCase();
	    var validTags = /(svg|a|area|input|select|textarea|button|iframe|div)$/;
	    var isValidTag = currentTag.match(validTags) && element.focus;
	
	    if (currentTag === 'a') {
	      return isValidTag && element.childNodes.length > 0 && element.getAttribute('href');
	    } else if (currentTag === 'svg' || currentTag === 'div') {
	      return isValidTag && element.hasAttribute('tabindex');
	    }
	
	    return isValidTag;
	  });
	}
	
	function getBestFirstFocusable(elements) {
	  var bestFirstFocusable;
	
	  Array.prototype.some.call(elements || [], function (element) {
	    var currentTag = element.tagName.toLowerCase();
	    var isValidTag = currentTag.match(/(input|select|textarea)$/);
	    return isValidTag ? (bestFirstFocusable = element, true) : false;
	  });
	
	  if (!bestFirstFocusable) {
	    bestFirstFocusable = this.filterByFocusable(elements)[0];
	  }
	
	  return bestFirstFocusable;
	}
	
	function isFormElement(element) {
	  var elementType = element ? element.tagName.toLowerCase() : undefined;
	  return elementType && (elementType === 'input' || elementType === 'textarea');
	}
	
	function generateId(element) {
	  if (element) {
	    var id = void 0;
	    var elementId = element.getAttribute('id');
	    if (!elementId) {
	      // IE11 fix: check for parentNode instead of parentElement
	      var parentElement = element.parentElement || element.parentNode;
	      if (parentElement) {
	        id = hash(parentElement.innerHTML);
	        element.setAttribute('id', id);
	      }
	    } else {
	      id = elementId;
	    }
	    return id;
	  }
	}
	
	function generateUUID() {
	  function S4() {
	    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
	  }
	  var uuid = '' + S4() + S4() + ('-' + S4() + '-4' + S4().substr(0, 3)) + ('-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
	  return uuid;
	}
	
	var CHECK_DARK_BACKGROUND_BACKOFFS = [0, 20, 80, 200];
	
	function hasDarkBackground(element) {
	  var result = false;
	  var color = window.getComputedStyle(element).backgroundColor;
	  var match = color.match(COLOR_RGB_REGEXP) || color.match(COLOR_RGBA_REGEXP);
	  if (match) {
	    var _match$slice$map = match.slice(1).map(function (n) {
	      return parseInt(n, 10);
	    }),
	        _match$slice$map2 = _slicedToArray(_match$slice$map, 3),
	        red = _match$slice$map2[0],
	        green = _match$slice$map2[1],
	        blue = _match$slice$map2[2];
	    // http://www.had2know.com/technology/
	    //  color-contrast-calculator-web-design.html
	
	
	    var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
	    if (0 === brightness) {
	      // Browsers return 0,0,0 when they don't know yet.
	      result = undefined;
	      // changed threshold below to accomodate the Aruba theme for now
	    } else if (brightness < 137) {
	      ///125) {
	      result = true;
	    }
	  }
	  return result;
	}
	
	function checkDarkBackgroundBackoff(element, handler, backoffDurations) {
	  return setTimeout(function () {
	    var dark = hasDarkBackground(element);
	    if (undefined === dark && backoffDurations.length > 0) {
	      checkDarkBackgroundBackoff(element, handler, backoffDurations);
	    } else {
	      handler(dark);
	    }
	  }, backoffDurations.shift());
	}
	
	function checkDarkBackground(colorIndex, element, handler) {
	  var timer = void 0;
	  if (colorIndex) {
	    if ('dark' === colorIndex) {
	      // caller knows
	      handler(true);
	    } else if (LIGHT_HINT_REGEXP.test(colorIndex)) {
	      // skip if this is a 'light-*' color index
	      handler(false);
	    } else {
	      // Measure the actual background color brightness to determine whether
	      // to set a dark or light context.
	      if (element && window.getComputedStyle) {
	        timer = checkDarkBackgroundBackoff(element, handler, CHECK_DARK_BACKGROUND_BACKOFFS);
	      }
	    }
	  }
	  return { stop: function stop() {
	      return clearTimeout(timer);
	    } };
	}

/***/ }),

/***/ "./node_modules/grommet/utils/InfiniteScroll.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DOM = __webpack_require__("./node_modules/grommet/utils/DOM.js");
	
	var SCROLL_MORE_DELAY = 500; // when the user scrolls
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var SCROLL_MORE_INITIAL_DELAY = 50; // when we start out at the bottom already
	
	function _evaluate(scrollState) {
	  (scrollState.scrollParents || []).forEach(function (scrollParent) {
	    // are we at the bottom?
	    var bottom;
	    if (scrollParent === document) {
	      bottom = window.innerHeight;
	    } else {
	      bottom = scrollParent.getBoundingClientRect().bottom;
	    }
	    var indicatorRect = scrollState.indicatorElement.getBoundingClientRect();
	    // Only if bottom isn't zero. This can happen when content hasn't
	    // arrived yet.
	    // 10px offset is to ensure onEnd() gets called
	    if (bottom && indicatorRect.bottom <= bottom + 10) {
	      scrollState.onEnd();
	    }
	  });
	}
	
	function _onScroll(scrollState) {
	  // delay a bit to ride out quick users
	  clearTimeout(scrollState.scrollTimer);
	  scrollState.scrollTimer = setTimeout(function () {
	    return _evaluate(scrollState);
	  }, SCROLL_MORE_DELAY);
	}
	
	function _onResize(scrollState) {
	  clearTimeout(scrollState.scrollTimer);
	  scrollState.scrollTimer = setTimeout(function () {
	    return _evaluate(scrollState);
	  }, SCROLL_MORE_DELAY);
	}
	
	exports.default = {
	  startListeningForScroll: function startListeningForScroll(indicatorElement, onEnd) {
	    var scrollState = {
	      onEnd: onEnd,
	      indicatorElement: indicatorElement,
	      scrollParents: (0, _DOM.findScrollParents)(indicatorElement)
	    };
	
	    scrollState._onResize = _onResize.bind(this, scrollState);
	    scrollState._onScroll = _onScroll.bind(this, scrollState);
	
	    window.addEventListener("resize", scrollState._onResize);
	    // check in case we're already at the bottom and the indicator is visible
	    (scrollState.scrollParents || []).forEach(function (scrollParent) {
	      scrollParent.addEventListener("scroll", scrollState._onScroll);
	      if (scrollParent === document || scrollParent === document.body) {
	        var rect = indicatorElement.getBoundingClientRect();
	        if (rect.top < window.innerHeight) {
	          scrollState.scrollTimer = setTimeout(onEnd, SCROLL_MORE_INITIAL_DELAY);
	        }
	      }
	    });
	    return scrollState;
	  },
	  stopListeningForScroll: function stopListeningForScroll(scrollState) {
	    (scrollState.scrollParents || []).forEach(function (scrollParent) {
	      clearTimeout(scrollState.scrollTimer);
	      scrollParent.removeEventListener("scroll", scrollState._onScroll);
	      window.removeEventListener("resize", scrollState._onResize);
	    });
	    scrollState.scrollParents = undefined;
	  }
	};
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/grommet/utils/Intl.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2014 Hewlett Packard Enterprise Development LP
	exports.default = {
	  getMessage: function getMessage(intl, key, values) {
	    if (intl) {
	      return intl.formatMessage({
	        id: key,
	        defaultMessage: key
	      }, values);
	    } else {
	      return key;
	    }
	  }
	};
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/grommet/utils/KeyboardAccelerators.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _DOM = __webpack_require__("./node_modules/grommet/utils/DOM.js");
	
	// Allow callers to use key labels instead of key code numbers.
	// This makes their code easier to read.
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	var KEYS = {
	  backspace: 8,
	  tab: 9,
	  enter: 13,
	  esc: 27,
	  escape: 27,
	  space: 32,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  comma: 188,
	  shift: 16
	};
	
	var _keyboardAccelerators = {};
	var _listeners = [];
	var _isKeyboardAcceleratorListening = false;
	
	var _onKeyboardAcceleratorKeyPress = function _onKeyboardAcceleratorKeyPress(e) {
	  var key = e.keyCode ? e.keyCode : e.which;
	  _listeners.slice().reverse().some(function (listener) {
	    if (_keyboardAccelerators[listener]) {
	      var handlers = _keyboardAccelerators[listener].handlers;
	      if (handlers.hasOwnProperty(key)) {
	        if (handlers[key] && handlers[key](e)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  });
	};
	
	// KeyboardAccelerators is a utility for handling keyboard events.
	// Add listeners using startListeningToKeyboard().
	// Remove listeners using stopListeningToKeyboard().
	exports.default = {
	  _initKeyboardAccelerators: function _initKeyboardAccelerators(element) {
	    var id = (0, _DOM.generateId)(element);
	    _keyboardAccelerators[id] = {
	      handlers: {}
	    };
	  },
	  _getKeyboardAcceleratorHandlers: function _getKeyboardAcceleratorHandlers(element) {
	    var id = (0, _DOM.generateId)(element);
	    return _keyboardAccelerators[id].handlers;
	  },
	  _getDowns: function _getDowns(element) {
	    var id = (0, _DOM.generateId)(element);
	    return _keyboardAccelerators[id].downs;
	  },
	  _isComponentListening: function _isComponentListening(element) {
	    var id = (0, _DOM.generateId)(element);
	
	    return _listeners.some(function (listener) {
	      return listener === id;
	    });
	  },
	  _subscribeComponent: function _subscribeComponent(element) {
	    var id = (0, _DOM.generateId)(element);
	    _listeners.push(id);
	  },
	  _unsubscribeComponent: function _unsubscribeComponent(element) {
	    var id = (0, _DOM.generateId)(element);
	
	    var removeListenerIndex = _listeners.indexOf(id);
	    _listeners.splice(removeListenerIndex, 1);
	
	    delete _keyboardAccelerators[id];
	  },
	
	
	  // Add handlers for specific keys.
	  // This function can be called multiple times, existing handlers will
	  // be replaced, new handlers will be added.
	  startListeningToKeyboard: function startListeningToKeyboard(component, handlers) {
	    var element = (0, _reactDom.findDOMNode)(component);
	    if (element) {
	      this._initKeyboardAccelerators(element);
	      var keys = 0;
	      for (var key in handlers) {
	        if (handlers.hasOwnProperty(key)) {
	          var keyCode = key;
	          if (KEYS.hasOwnProperty(key)) {
	            keyCode = KEYS[key];
	          }
	          keys += 1;
	          this._getKeyboardAcceleratorHandlers(element)[keyCode] = handlers[key];
	        }
	      }
	
	      if (keys > 0) {
	        if (!_isKeyboardAcceleratorListening) {
	          window.addEventListener("keydown", _onKeyboardAcceleratorKeyPress);
	          _isKeyboardAcceleratorListening = true;
	        }
	        if (!this._isComponentListening(element)) {
	          this._subscribeComponent(element);
	        }
	      }
	    }
	  },
	
	
	  // Remove handlers for all keys or specific keys.
	  // If no argument is passed in, all handlers are removed.
	  // This function can be called multiple times, only the handlers
	  // specified will be removed.
	  stopListeningToKeyboard: function stopListeningToKeyboard(component, handlers) {
	    var element = (0, _reactDom.findDOMNode)(component);
	    if (!this._isComponentListening(element)) {
	      return;
	    }
	    if (handlers) {
	      for (var key in handlers) {
	        if (handlers.hasOwnProperty(key)) {
	          var keyCode = key;
	          if (KEYS.hasOwnProperty(key)) {
	            keyCode = KEYS[key];
	          }
	          delete this._getKeyboardAcceleratorHandlers(element)[keyCode];
	        }
	      }
	    }
	
	    var keyCount = 0;
	    for (var keyHandler in this._getKeyboardAcceleratorHandlers(element)) {
	      if (this._getKeyboardAcceleratorHandlers(element).hasOwnProperty(keyHandler)) {
	        keyCount += 1;
	      }
	    }
	
	    if (!handlers || 0 === keyCount) {
	      this._initKeyboardAccelerators(element);
	      this._unsubscribeComponent(element);
	    }
	
	    if (_listeners.length === 0) {
	      window.removeEventListener("keydown", _onKeyboardAcceleratorKeyPress);
	      _isKeyboardAcceleratorListening = false;
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/grommet/utils/Props.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
	
	exports.default = {
	  pick: function pick(props, fields) {
	    var has = function has(p) {
	      return props.hasOwnProperty(p);
	    };
	    var obj = {};
	    (fields || []).forEach(function (field) {
	      if (has(field)) obj[field] = props[field];
	    });
	    return obj;
	  },
	  omit: function omit(props, fields) {
	    var obj = {};
	    Object.keys(props).forEach(function (p) {
	      if ((fields || []).indexOf(p) === -1) {
	        obj[p] = props[p];
	      }
	    });
	    return obj;
	  }
	};
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/grommet/utils/Selection.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// (C) Copyright 2015 Hewlett Packard Enterprise Development LP
	
	// Functions to manage selection via both child index and a specific class name.
	
	// Ensures it is an array.
	function normalizeIndexes(selectedIndexes) {
	  var result = void 0;
	  if (undefined === selectedIndexes || null === selectedIndexes) {
	    result = [];
	  } else if (typeof selectedIndexes === 'number') {
	    result = [selectedIndexes];
	  } else {
	    result = selectedIndexes;
	  }
	  return result;
	}
	
	// Clears any selected items
	// options: {containerElement: , selectedClass: }
	function clearClass(options) {
	  if (options && options.containerElement) {
	    var items = options.containerElement.querySelectorAll("." + options.selectedClass);
	    for (var i = 0; i < items.length; i++) {
	      items[i].classList.remove(options.selectedClass);
	    }
	  }
	}
	
	// Sets the selectedClass on all children whose index is in selectedIndexes.
	// options: {containerElement: , childSelector: , selectedClass: ,
	//    selectedIndexes: []}
	function setClassFromIndexes(options) {
	  clearClass(options);
	  if (options && options.containerElement && options.selectedIndexes) {
	    var items = options.containerElement.querySelectorAll(options.childSelector);
	    options.selectedIndexes.forEach(function (index) {
	      if (items[index]) {
	        items[index].classList.add(options.selectedClass);
	      }
	    });
	  }
	}
	
	// Gets the selected selectedClass on all children whose index is in
	// selectedIndexes.
	// options: {containerElement: , childSelector: , selectedClass: }
	function getIndexesFromClass(options) {
	  var items = options.containerElement.querySelectorAll(options.childSelector);
	  var selectedIndexes = [];
	  for (var i = 0; i < items.length; i++) {
	    if (items[i].classList.contains(options.selectedClass)) {
	      selectedIndexes.push(i);
	    }
	  }
	  return selectedIndexes;
	}
	
	// Returns a new selectedIndexes array with the latest selected indexes
	// options: {containerElement: , childSelector: , //selectedClass: ,
	//   multiSelect: true|false, priorSelectedIndexes: []}
	function onClick(event, options) {
	
	  // Go up the DOM tree until we match the childSelector
	  var item = event.target;
	  var matchFunction = item.matches || item.matchesElement || item.msMatchesSelector;
	  while (matchFunction && item && !matchFunction.bind(item, options.childSelector)()) {
	    item = item.parentNode;
	    matchFunction = item.matches || item.matchesElement || item.msMatchesSelector;
	  }
	
	  // determine the index of the clicked element
	  var indexInContainer = 0;
	  var previousItem = item.previousSibling;
	  while (previousItem != null) {
	    previousItem = previousItem.previousSibling;
	    indexInContainer += 1;
	  }
	
	  var selectedIndexes = void 0; // what will be returned
	
	  if (!event.ctrlKey && !event.metaKey && !event.shiftKey) {
	
	    selectedIndexes = [indexInContainer];
	  } else {
	    // was it selected?
	    var indexInPrior = options.priorSelectedIndexes.indexOf(indexInContainer);
	
	    if (!options.multiSelect) {
	
	      if (-1 !== indexInPrior && (event.ctrlKey || event.metaKey)) {
	        selectedIndexes = [];
	      } else {
	        selectedIndexes = options.priorSelectedIndexes;
	      }
	    } else {
	      // multi-select
	
	      // make a copy of the prior list so we can modify it
	      selectedIndexes = options.priorSelectedIndexes.slice(0);
	
	      if (event.shiftKey) {
	
	        // select from nearest selected item to the currently selected item
	        var closestIndex = -1;
	        selectedIndexes.forEach(function (selectIndex, arrayIndex) {
	          if (-1 === closestIndex) {
	            closestIndex = selectIndex;
	          } else if (Math.abs(indexInContainer - selectIndex) < Math.abs(indexInContainer - closestIndex)) {
	            closestIndex = selectIndex;
	          }
	        });
	
	        for (var i = indexInContainer; i !== closestIndex;) {
	          selectedIndexes.push(i);
	          if (closestIndex < indexInContainer) {
	            i -= 1;
	          } else {
	            i += 1;
	          }
	        }
	
	        if (indexInPrior > -1) {
	          selectedIndexes.splice(indexInPrior, 1);
	        }
	
	        // Remove text selection. This often happens when shift multi-selecting
	        window.getSelection().removeAllRanges();
	      } else {
	        // toggle
	        if (-1 === indexInPrior) {
	          selectedIndexes.push(indexInContainer);
	        } else {
	          selectedIndexes.splice(indexInPrior, 1);
	        }
	      }
	    }
	  }
	
	  return selectedIndexes;
	}
	
	exports.default = {
	  normalizeIndexes: normalizeIndexes,
	  clearClass: clearClass,
	  getIndexesFromClass: getIndexesFromClass,
	  setClassFromIndexes: setClassFromIndexes,
	  onClick: onClick
	};
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/highlight.js/lib/highlight.js":
/***/ (function(module, exports, __webpack_require__) {

	/*
	Syntax highlighting with language autodetection.
	https://highlightjs.org/
	*/
	
	(function(factory) {
	
	  // Find the global object for export to both the browser and web workers.
	  var globalObject = typeof window === 'object' && window ||
	                     typeof self === 'object' && self;
	
	  // Setup highlight.js for different environments. First is Node.js or
	  // CommonJS.
	  if(true) {
	    factory(exports);
	  } else if(globalObject) {
	    // Export hljs globally even when using AMD for cases when this script
	    // is loaded with others that may still expect a global hljs.
	    globalObject.hljs = factory({});
	
	    // Finally register the global hljs with AMD.
	    if(typeof define === 'function' && define.amd) {
	      define([], function() {
	        return globalObject.hljs;
	      });
	    }
	  }
	
	}(function(hljs) {
	  // Convenience variables for build-in objects
	  var ArrayProto = [],
	      objectKeys = Object.keys;
	
	  // Global internal variables used within the highlight.js library.
	  var languages = {},
	      aliases   = {};
	
	  // Regular expressions used throughout the highlight.js library.
	  var noHighlightRe    = /^(no-?highlight|plain|text)$/i,
	      languagePrefixRe = /\blang(?:uage)?-([\w-]+)\b/i,
	      fixMarkupRe      = /((^(<[^>]+>|\t|)+|(?:\n)))/gm;
	
	  var spanEndTag = '</span>';
	
	  // Global options used when within external APIs. This is modified when
	  // calling the `hljs.configure` function.
	  var options = {
	    classPrefix: 'hljs-',
	    tabReplace: null,
	    useBR: false,
	    languages: undefined
	  };
	
	
	  /* Utility functions */
	
	  function escape(value) {
	    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	  }
	
	  function tag(node) {
	    return node.nodeName.toLowerCase();
	  }
	
	  function testRe(re, lexeme) {
	    var match = re && re.exec(lexeme);
	    return match && match.index === 0;
	  }
	
	  function isNotHighlighted(language) {
	    return noHighlightRe.test(language);
	  }
	
	  function blockLanguage(block) {
	    var i, match, length, _class;
	    var classes = block.className + ' ';
	
	    classes += block.parentNode ? block.parentNode.className : '';
	
	    // language-* takes precedence over non-prefixed class names.
	    match = languagePrefixRe.exec(classes);
	    if (match) {
	      return getLanguage(match[1]) ? match[1] : 'no-highlight';
	    }
	
	    classes = classes.split(/\s+/);
	
	    for (i = 0, length = classes.length; i < length; i++) {
	      _class = classes[i]
	
	      if (isNotHighlighted(_class) || getLanguage(_class)) {
	        return _class;
	      }
	    }
	  }
	
	  function inherit(parent) {  // inherit(parent, override_obj, override_obj, ...)
	    var key;
	    var result = {};
	    var objects = Array.prototype.slice.call(arguments, 1);
	
	    for (key in parent)
	      result[key] = parent[key];
	    objects.forEach(function(obj) {
	      for (key in obj)
	        result[key] = obj[key];
	    });
	    return result;
	  }
	
	  /* Stream merging */
	
	  function nodeStream(node) {
	    var result = [];
	    (function _nodeStream(node, offset) {
	      for (var child = node.firstChild; child; child = child.nextSibling) {
	        if (child.nodeType === 3)
	          offset += child.nodeValue.length;
	        else if (child.nodeType === 1) {
	          result.push({
	            event: 'start',
	            offset: offset,
	            node: child
	          });
	          offset = _nodeStream(child, offset);
	          // Prevent void elements from having an end tag that would actually
	          // double them in the output. There are more void elements in HTML
	          // but we list only those realistically expected in code display.
	          if (!tag(child).match(/br|hr|img|input/)) {
	            result.push({
	              event: 'stop',
	              offset: offset,
	              node: child
	            });
	          }
	        }
	      }
	      return offset;
	    })(node, 0);
	    return result;
	  }
	
	  function mergeStreams(original, highlighted, value) {
	    var processed = 0;
	    var result = '';
	    var nodeStack = [];
	
	    function selectStream() {
	      if (!original.length || !highlighted.length) {
	        return original.length ? original : highlighted;
	      }
	      if (original[0].offset !== highlighted[0].offset) {
	        return (original[0].offset < highlighted[0].offset) ? original : highlighted;
	      }
	
	      /*
	      To avoid starting the stream just before it should stop the order is
	      ensured that original always starts first and closes last:
	
	      if (event1 == 'start' && event2 == 'start')
	        return original;
	      if (event1 == 'start' && event2 == 'stop')
	        return highlighted;
	      if (event1 == 'stop' && event2 == 'start')
	        return original;
	      if (event1 == 'stop' && event2 == 'stop')
	        return highlighted;
	
	      ... which is collapsed to:
	      */
	      return highlighted[0].event === 'start' ? original : highlighted;
	    }
	
	    function open(node) {
	      function attr_str(a) {return ' ' + a.nodeName + '="' + escape(a.value).replace('"', '&quot;') + '"';}
	      result += '<' + tag(node) + ArrayProto.map.call(node.attributes, attr_str).join('') + '>';
	    }
	
	    function close(node) {
	      result += '</' + tag(node) + '>';
	    }
	
	    function render(event) {
	      (event.event === 'start' ? open : close)(event.node);
	    }
	
	    while (original.length || highlighted.length) {
	      var stream = selectStream();
	      result += escape(value.substring(processed, stream[0].offset));
	      processed = stream[0].offset;
	      if (stream === original) {
	        /*
	        On any opening or closing tag of the original markup we first close
	        the entire highlighted node stack, then render the original tag along
	        with all the following original tags at the same offset and then
	        reopen all the tags on the highlighted stack.
	        */
	        nodeStack.reverse().forEach(close);
	        do {
	          render(stream.splice(0, 1)[0]);
	          stream = selectStream();
	        } while (stream === original && stream.length && stream[0].offset === processed);
	        nodeStack.reverse().forEach(open);
	      } else {
	        if (stream[0].event === 'start') {
	          nodeStack.push(stream[0].node);
	        } else {
	          nodeStack.pop();
	        }
	        render(stream.splice(0, 1)[0]);
	      }
	    }
	    return result + escape(value.substr(processed));
	  }
	
	  /* Initialization */
	
	  function expand_mode(mode) {
	    if (mode.variants && !mode.cached_variants) {
	      mode.cached_variants = mode.variants.map(function(variant) {
	        return inherit(mode, {variants: null}, variant);
	      });
	    }
	    return mode.cached_variants || (mode.endsWithParent && [inherit(mode)]) || [mode];
	  }
	
	  function compileLanguage(language) {
	
	    function reStr(re) {
	        return (re && re.source) || re;
	    }
	
	    function langRe(value, global) {
	      return new RegExp(
	        reStr(value),
	        'm' + (language.case_insensitive ? 'i' : '') + (global ? 'g' : '')
	      );
	    }
	
	    function compileMode(mode, parent) {
	      if (mode.compiled)
	        return;
	      mode.compiled = true;
	
	      mode.keywords = mode.keywords || mode.beginKeywords;
	      if (mode.keywords) {
	        var compiled_keywords = {};
	
	        var flatten = function(className, str) {
	          if (language.case_insensitive) {
	            str = str.toLowerCase();
	          }
	          str.split(' ').forEach(function(kw) {
	            var pair = kw.split('|');
	            compiled_keywords[pair[0]] = [className, pair[1] ? Number(pair[1]) : 1];
	          });
	        };
	
	        if (typeof mode.keywords === 'string') { // string
	          flatten('keyword', mode.keywords);
	        } else {
	          objectKeys(mode.keywords).forEach(function (className) {
	            flatten(className, mode.keywords[className]);
	          });
	        }
	        mode.keywords = compiled_keywords;
	      }
	      mode.lexemesRe = langRe(mode.lexemes || /\w+/, true);
	
	      if (parent) {
	        if (mode.beginKeywords) {
	          mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')\\b';
	        }
	        if (!mode.begin)
	          mode.begin = /\B|\b/;
	        mode.beginRe = langRe(mode.begin);
	        if (!mode.end && !mode.endsWithParent)
	          mode.end = /\B|\b/;
	        if (mode.end)
	          mode.endRe = langRe(mode.end);
	        mode.terminator_end = reStr(mode.end) || '';
	        if (mode.endsWithParent && parent.terminator_end)
	          mode.terminator_end += (mode.end ? '|' : '') + parent.terminator_end;
	      }
	      if (mode.illegal)
	        mode.illegalRe = langRe(mode.illegal);
	      if (mode.relevance == null)
	        mode.relevance = 1;
	      if (!mode.contains) {
	        mode.contains = [];
	      }
	      mode.contains = Array.prototype.concat.apply([], mode.contains.map(function(c) {
	        return expand_mode(c === 'self' ? mode : c)
	      }));
	      mode.contains.forEach(function(c) {compileMode(c, mode);});
	
	      if (mode.starts) {
	        compileMode(mode.starts, parent);
	      }
	
	      var terminators =
	        mode.contains.map(function(c) {
	          return c.beginKeywords ? '\\.?(' + c.begin + ')\\.?' : c.begin;
	        })
	        .concat([mode.terminator_end, mode.illegal])
	        .map(reStr)
	        .filter(Boolean);
	      mode.terminators = terminators.length ? langRe(terminators.join('|'), true) : {exec: function(/*s*/) {return null;}};
	    }
	
	    compileMode(language);
	  }
	
	  /*
	  Core highlighting function. Accepts a language name, or an alias, and a
	  string with the code to highlight. Returns an object with the following
	  properties:
	
	  - relevance (int)
	  - value (an HTML string with highlighting markup)
	
	  */
	  function highlight(name, value, ignore_illegals, continuation) {
	
	    function subMode(lexeme, mode) {
	      var i, length;
	
	      for (i = 0, length = mode.contains.length; i < length; i++) {
	        if (testRe(mode.contains[i].beginRe, lexeme)) {
	          return mode.contains[i];
	        }
	      }
	    }
	
	    function endOfMode(mode, lexeme) {
	      if (testRe(mode.endRe, lexeme)) {
	        while (mode.endsParent && mode.parent) {
	          mode = mode.parent;
	        }
	        return mode;
	      }
	      if (mode.endsWithParent) {
	        return endOfMode(mode.parent, lexeme);
	      }
	    }
	
	    function isIllegal(lexeme, mode) {
	      return !ignore_illegals && testRe(mode.illegalRe, lexeme);
	    }
	
	    function keywordMatch(mode, match) {
	      var match_str = language.case_insensitive ? match[0].toLowerCase() : match[0];
	      return mode.keywords.hasOwnProperty(match_str) && mode.keywords[match_str];
	    }
	
	    function buildSpan(classname, insideSpan, leaveOpen, noPrefix) {
	      var classPrefix = noPrefix ? '' : options.classPrefix,
	          openSpan    = '<span class="' + classPrefix,
	          closeSpan   = leaveOpen ? '' : spanEndTag
	
	      openSpan += classname + '">';
	
	      return openSpan + insideSpan + closeSpan;
	    }
	
	    function processKeywords() {
	      var keyword_match, last_index, match, result;
	
	      if (!top.keywords)
	        return escape(mode_buffer);
	
	      result = '';
	      last_index = 0;
	      top.lexemesRe.lastIndex = 0;
	      match = top.lexemesRe.exec(mode_buffer);
	
	      while (match) {
	        result += escape(mode_buffer.substring(last_index, match.index));
	        keyword_match = keywordMatch(top, match);
	        if (keyword_match) {
	          relevance += keyword_match[1];
	          result += buildSpan(keyword_match[0], escape(match[0]));
	        } else {
	          result += escape(match[0]);
	        }
	        last_index = top.lexemesRe.lastIndex;
	        match = top.lexemesRe.exec(mode_buffer);
	      }
	      return result + escape(mode_buffer.substr(last_index));
	    }
	
	    function processSubLanguage() {
	      var explicit = typeof top.subLanguage === 'string';
	      if (explicit && !languages[top.subLanguage]) {
	        return escape(mode_buffer);
	      }
	
	      var result = explicit ?
	                   highlight(top.subLanguage, mode_buffer, true, continuations[top.subLanguage]) :
	                   highlightAuto(mode_buffer, top.subLanguage.length ? top.subLanguage : undefined);
	
	      // Counting embedded language score towards the host language may be disabled
	      // with zeroing the containing mode relevance. Usecase in point is Markdown that
	      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
	      // score.
	      if (top.relevance > 0) {
	        relevance += result.relevance;
	      }
	      if (explicit) {
	        continuations[top.subLanguage] = result.top;
	      }
	      return buildSpan(result.language, result.value, false, true);
	    }
	
	    function processBuffer() {
	      result += (top.subLanguage != null ? processSubLanguage() : processKeywords());
	      mode_buffer = '';
	    }
	
	    function startNewMode(mode) {
	      result += mode.className? buildSpan(mode.className, '', true): '';
	      top = Object.create(mode, {parent: {value: top}});
	    }
	
	    function processLexeme(buffer, lexeme) {
	
	      mode_buffer += buffer;
	
	      if (lexeme == null) {
	        processBuffer();
	        return 0;
	      }
	
	      var new_mode = subMode(lexeme, top);
	      if (new_mode) {
	        if (new_mode.skip) {
	          mode_buffer += lexeme;
	        } else {
	          if (new_mode.excludeBegin) {
	            mode_buffer += lexeme;
	          }
	          processBuffer();
	          if (!new_mode.returnBegin && !new_mode.excludeBegin) {
	            mode_buffer = lexeme;
	          }
	        }
	        startNewMode(new_mode, lexeme);
	        return new_mode.returnBegin ? 0 : lexeme.length;
	      }
	
	      var end_mode = endOfMode(top, lexeme);
	      if (end_mode) {
	        var origin = top;
	        if (origin.skip) {
	          mode_buffer += lexeme;
	        } else {
	          if (!(origin.returnEnd || origin.excludeEnd)) {
	            mode_buffer += lexeme;
	          }
	          processBuffer();
	          if (origin.excludeEnd) {
	            mode_buffer = lexeme;
	          }
	        }
	        do {
	          if (top.className) {
	            result += spanEndTag;
	          }
	          if (!top.skip) {
	            relevance += top.relevance;
	          }
	          top = top.parent;
	        } while (top !== end_mode.parent);
	        if (end_mode.starts) {
	          startNewMode(end_mode.starts, '');
	        }
	        return origin.returnEnd ? 0 : lexeme.length;
	      }
	
	      if (isIllegal(lexeme, top))
	        throw new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || '<unnamed>') + '"');
	
	      /*
	      Parser should not reach this point as all types of lexemes should be caught
	      earlier, but if it does due to some bug make sure it advances at least one
	      character forward to prevent infinite looping.
	      */
	      mode_buffer += lexeme;
	      return lexeme.length || 1;
	    }
	
	    var language = getLanguage(name);
	    if (!language) {
	      throw new Error('Unknown language: "' + name + '"');
	    }
	
	    compileLanguage(language);
	    var top = continuation || language;
	    var continuations = {}; // keep continuations for sub-languages
	    var result = '', current;
	    for(current = top; current !== language; current = current.parent) {
	      if (current.className) {
	        result = buildSpan(current.className, '', true) + result;
	      }
	    }
	    var mode_buffer = '';
	    var relevance = 0;
	    try {
	      var match, count, index = 0;
	      while (true) {
	        top.terminators.lastIndex = index;
	        match = top.terminators.exec(value);
	        if (!match)
	          break;
	        count = processLexeme(value.substring(index, match.index), match[0]);
	        index = match.index + count;
	      }
	      processLexeme(value.substr(index));
	      for(current = top; current.parent; current = current.parent) { // close dangling modes
	        if (current.className) {
	          result += spanEndTag;
	        }
	      }
	      return {
	        relevance: relevance,
	        value: result,
	        language: name,
	        top: top
	      };
	    } catch (e) {
	      if (e.message && e.message.indexOf('Illegal') !== -1) {
	        return {
	          relevance: 0,
	          value: escape(value)
	        };
	      } else {
	        throw e;
	      }
	    }
	  }
	
	  /*
	  Highlighting with language detection. Accepts a string with the code to
	  highlight. Returns an object with the following properties:
	
	  - language (detected language)
	  - relevance (int)
	  - value (an HTML string with highlighting markup)
	  - second_best (object with the same structure for second-best heuristically
	    detected language, may be absent)
	
	  */
	  function highlightAuto(text, languageSubset) {
	    languageSubset = languageSubset || options.languages || objectKeys(languages);
	    var result = {
	      relevance: 0,
	      value: escape(text)
	    };
	    var second_best = result;
	    languageSubset.filter(getLanguage).forEach(function(name) {
	      var current = highlight(name, text, false);
	      current.language = name;
	      if (current.relevance > second_best.relevance) {
	        second_best = current;
	      }
	      if (current.relevance > result.relevance) {
	        second_best = result;
	        result = current;
	      }
	    });
	    if (second_best.language) {
	      result.second_best = second_best;
	    }
	    return result;
	  }
	
	  /*
	  Post-processing of the highlighted markup:
	
	  - replace TABs with something more useful
	  - replace real line-breaks with '<br>' for non-pre containers
	
	  */
	  function fixMarkup(value) {
	    return !(options.tabReplace || options.useBR)
	      ? value
	      : value.replace(fixMarkupRe, function(match, p1) {
	          if (options.useBR && match === '\n') {
	            return '<br>';
	          } else if (options.tabReplace) {
	            return p1.replace(/\t/g, options.tabReplace);
	          }
	          return '';
	      });
	  }
	
	  function buildClassName(prevClassName, currentLang, resultLang) {
	    var language = currentLang ? aliases[currentLang] : resultLang,
	        result   = [prevClassName.trim()];
	
	    if (!prevClassName.match(/\bhljs\b/)) {
	      result.push('hljs');
	    }
	
	    if (prevClassName.indexOf(language) === -1) {
	      result.push(language);
	    }
	
	    return result.join(' ').trim();
	  }
	
	  /*
	  Applies highlighting to a DOM node containing code. Accepts a DOM node and
	  two optional parameters for fixMarkup.
	  */
	  function highlightBlock(block) {
	    var node, originalStream, result, resultNode, text;
	    var language = blockLanguage(block);
	
	    if (isNotHighlighted(language))
	        return;
	
	    if (options.useBR) {
	      node = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
	      node.innerHTML = block.innerHTML.replace(/\n/g, '').replace(/<br[ \/]*>/g, '\n');
	    } else {
	      node = block;
	    }
	    text = node.textContent;
	    result = language ? highlight(language, text, true) : highlightAuto(text);
	
	    originalStream = nodeStream(node);
	    if (originalStream.length) {
	      resultNode = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
	      resultNode.innerHTML = result.value;
	      result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
	    }
	    result.value = fixMarkup(result.value);
	
	    block.innerHTML = result.value;
	    block.className = buildClassName(block.className, language, result.language);
	    block.result = {
	      language: result.language,
	      re: result.relevance
	    };
	    if (result.second_best) {
	      block.second_best = {
	        language: result.second_best.language,
	        re: result.second_best.relevance
	      };
	    }
	  }
	
	  /*
	  Updates highlight.js global options with values passed in the form of an object.
	  */
	  function configure(user_options) {
	    options = inherit(options, user_options);
	  }
	
	  /*
	  Applies highlighting to all <pre><code>..</code></pre> blocks on a page.
	  */
	  function initHighlighting() {
	    if (initHighlighting.called)
	      return;
	    initHighlighting.called = true;
	
	    var blocks = document.querySelectorAll('pre code');
	    ArrayProto.forEach.call(blocks, highlightBlock);
	  }
	
	  /*
	  Attaches highlighting to the page load event.
	  */
	  function initHighlightingOnLoad() {
	    addEventListener('DOMContentLoaded', initHighlighting, false);
	    addEventListener('load', initHighlighting, false);
	  }
	
	  function registerLanguage(name, language) {
	    var lang = languages[name] = language(hljs);
	    if (lang.aliases) {
	      lang.aliases.forEach(function(alias) {aliases[alias] = name;});
	    }
	  }
	
	  function listLanguages() {
	    return objectKeys(languages);
	  }
	
	  function getLanguage(name) {
	    name = (name || '').toLowerCase();
	    return languages[name] || languages[aliases[name]];
	  }
	
	  /* Interface definition */
	
	  hljs.highlight = highlight;
	  hljs.highlightAuto = highlightAuto;
	  hljs.fixMarkup = fixMarkup;
	  hljs.highlightBlock = highlightBlock;
	  hljs.configure = configure;
	  hljs.initHighlighting = initHighlighting;
	  hljs.initHighlightingOnLoad = initHighlightingOnLoad;
	  hljs.registerLanguage = registerLanguage;
	  hljs.listLanguages = listLanguages;
	  hljs.getLanguage = getLanguage;
	  hljs.inherit = inherit;
	
	  // Common regexps
	  hljs.IDENT_RE = '[a-zA-Z]\\w*';
	  hljs.UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
	  hljs.NUMBER_RE = '\\b\\d+(\\.\\d+)?';
	  hljs.C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
	  hljs.BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
	  hljs.RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';
	
	  // Common modes
	  hljs.BACKSLASH_ESCAPE = {
	    begin: '\\\\[\\s\\S]', relevance: 0
	  };
	  hljs.APOS_STRING_MODE = {
	    className: 'string',
	    begin: '\'', end: '\'',
	    illegal: '\\n',
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	  hljs.QUOTE_STRING_MODE = {
	    className: 'string',
	    begin: '"', end: '"',
	    illegal: '\\n',
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	  hljs.PHRASAL_WORDS_MODE = {
	    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
	  };
	  hljs.COMMENT = function (begin, end, inherits) {
	    var mode = hljs.inherit(
	      {
	        className: 'comment',
	        begin: begin, end: end,
	        contains: []
	      },
	      inherits || {}
	    );
	    mode.contains.push(hljs.PHRASAL_WORDS_MODE);
	    mode.contains.push({
	      className: 'doctag',
	      begin: '(?:TODO|FIXME|NOTE|BUG|XXX):',
	      relevance: 0
	    });
	    return mode;
	  };
	  hljs.C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$');
	  hljs.C_BLOCK_COMMENT_MODE = hljs.COMMENT('/\\*', '\\*/');
	  hljs.HASH_COMMENT_MODE = hljs.COMMENT('#', '$');
	  hljs.NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.NUMBER_RE,
	    relevance: 0
	  };
	  hljs.C_NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.C_NUMBER_RE,
	    relevance: 0
	  };
	  hljs.BINARY_NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.BINARY_NUMBER_RE,
	    relevance: 0
	  };
	  hljs.CSS_NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.NUMBER_RE + '(' +
	      '%|em|ex|ch|rem'  +
	      '|vw|vh|vmin|vmax' +
	      '|cm|mm|in|pt|pc|px' +
	      '|deg|grad|rad|turn' +
	      '|s|ms' +
	      '|Hz|kHz' +
	      '|dpi|dpcm|dppx' +
	      ')?',
	    relevance: 0
	  };
	  hljs.REGEXP_MODE = {
	    className: 'regexp',
	    begin: /\//, end: /\/[gimuy]*/,
	    illegal: /\n/,
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      {
	        begin: /\[/, end: /\]/,
	        relevance: 0,
	        contains: [hljs.BACKSLASH_ESCAPE]
	      }
	    ]
	  };
	  hljs.TITLE_MODE = {
	    className: 'title',
	    begin: hljs.IDENT_RE,
	    relevance: 0
	  };
	  hljs.UNDERSCORE_TITLE_MODE = {
	    className: 'title',
	    begin: hljs.UNDERSCORE_IDENT_RE,
	    relevance: 0
	  };
	  hljs.METHOD_GUARD = {
	    // excludes method names from keyword processing
	    begin: '\\.\\s*' + hljs.UNDERSCORE_IDENT_RE,
	    relevance: 0
	  };
	
	  return hljs;
	}));


/***/ }),

/***/ "./node_modules/highlight.js/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var hljs = __webpack_require__("./node_modules/highlight.js/lib/highlight.js");
	
	hljs.registerLanguage('1c', __webpack_require__("./node_modules/highlight.js/lib/languages/1c.js"));
	hljs.registerLanguage('abnf', __webpack_require__("./node_modules/highlight.js/lib/languages/abnf.js"));
	hljs.registerLanguage('accesslog', __webpack_require__("./node_modules/highlight.js/lib/languages/accesslog.js"));
	hljs.registerLanguage('actionscript', __webpack_require__("./node_modules/highlight.js/lib/languages/actionscript.js"));
	hljs.registerLanguage('ada', __webpack_require__("./node_modules/highlight.js/lib/languages/ada.js"));
	hljs.registerLanguage('apache', __webpack_require__("./node_modules/highlight.js/lib/languages/apache.js"));
	hljs.registerLanguage('applescript', __webpack_require__("./node_modules/highlight.js/lib/languages/applescript.js"));
	hljs.registerLanguage('cpp', __webpack_require__("./node_modules/highlight.js/lib/languages/cpp.js"));
	hljs.registerLanguage('arduino', __webpack_require__("./node_modules/highlight.js/lib/languages/arduino.js"));
	hljs.registerLanguage('armasm', __webpack_require__("./node_modules/highlight.js/lib/languages/armasm.js"));
	hljs.registerLanguage('xml', __webpack_require__("./node_modules/highlight.js/lib/languages/xml.js"));
	hljs.registerLanguage('asciidoc', __webpack_require__("./node_modules/highlight.js/lib/languages/asciidoc.js"));
	hljs.registerLanguage('aspectj', __webpack_require__("./node_modules/highlight.js/lib/languages/aspectj.js"));
	hljs.registerLanguage('autohotkey', __webpack_require__("./node_modules/highlight.js/lib/languages/autohotkey.js"));
	hljs.registerLanguage('autoit', __webpack_require__("./node_modules/highlight.js/lib/languages/autoit.js"));
	hljs.registerLanguage('avrasm', __webpack_require__("./node_modules/highlight.js/lib/languages/avrasm.js"));
	hljs.registerLanguage('awk', __webpack_require__("./node_modules/highlight.js/lib/languages/awk.js"));
	hljs.registerLanguage('axapta', __webpack_require__("./node_modules/highlight.js/lib/languages/axapta.js"));
	hljs.registerLanguage('bash', __webpack_require__("./node_modules/highlight.js/lib/languages/bash.js"));
	hljs.registerLanguage('basic', __webpack_require__("./node_modules/highlight.js/lib/languages/basic.js"));
	hljs.registerLanguage('bnf', __webpack_require__("./node_modules/highlight.js/lib/languages/bnf.js"));
	hljs.registerLanguage('brainfuck', __webpack_require__("./node_modules/highlight.js/lib/languages/brainfuck.js"));
	hljs.registerLanguage('cal', __webpack_require__("./node_modules/highlight.js/lib/languages/cal.js"));
	hljs.registerLanguage('capnproto', __webpack_require__("./node_modules/highlight.js/lib/languages/capnproto.js"));
	hljs.registerLanguage('ceylon', __webpack_require__("./node_modules/highlight.js/lib/languages/ceylon.js"));
	hljs.registerLanguage('clean', __webpack_require__("./node_modules/highlight.js/lib/languages/clean.js"));
	hljs.registerLanguage('clojure', __webpack_require__("./node_modules/highlight.js/lib/languages/clojure.js"));
	hljs.registerLanguage('clojure-repl', __webpack_require__("./node_modules/highlight.js/lib/languages/clojure-repl.js"));
	hljs.registerLanguage('cmake', __webpack_require__("./node_modules/highlight.js/lib/languages/cmake.js"));
	hljs.registerLanguage('coffeescript', __webpack_require__("./node_modules/highlight.js/lib/languages/coffeescript.js"));
	hljs.registerLanguage('coq', __webpack_require__("./node_modules/highlight.js/lib/languages/coq.js"));
	hljs.registerLanguage('cos', __webpack_require__("./node_modules/highlight.js/lib/languages/cos.js"));
	hljs.registerLanguage('crmsh', __webpack_require__("./node_modules/highlight.js/lib/languages/crmsh.js"));
	hljs.registerLanguage('crystal', __webpack_require__("./node_modules/highlight.js/lib/languages/crystal.js"));
	hljs.registerLanguage('cs', __webpack_require__("./node_modules/highlight.js/lib/languages/cs.js"));
	hljs.registerLanguage('csp', __webpack_require__("./node_modules/highlight.js/lib/languages/csp.js"));
	hljs.registerLanguage('css', __webpack_require__("./node_modules/highlight.js/lib/languages/css.js"));
	hljs.registerLanguage('d', __webpack_require__("./node_modules/highlight.js/lib/languages/d.js"));
	hljs.registerLanguage('markdown', __webpack_require__("./node_modules/highlight.js/lib/languages/markdown.js"));
	hljs.registerLanguage('dart', __webpack_require__("./node_modules/highlight.js/lib/languages/dart.js"));
	hljs.registerLanguage('delphi', __webpack_require__("./node_modules/highlight.js/lib/languages/delphi.js"));
	hljs.registerLanguage('diff', __webpack_require__("./node_modules/highlight.js/lib/languages/diff.js"));
	hljs.registerLanguage('django', __webpack_require__("./node_modules/highlight.js/lib/languages/django.js"));
	hljs.registerLanguage('dns', __webpack_require__("./node_modules/highlight.js/lib/languages/dns.js"));
	hljs.registerLanguage('dockerfile', __webpack_require__("./node_modules/highlight.js/lib/languages/dockerfile.js"));
	hljs.registerLanguage('dos', __webpack_require__("./node_modules/highlight.js/lib/languages/dos.js"));
	hljs.registerLanguage('dsconfig', __webpack_require__("./node_modules/highlight.js/lib/languages/dsconfig.js"));
	hljs.registerLanguage('dts', __webpack_require__("./node_modules/highlight.js/lib/languages/dts.js"));
	hljs.registerLanguage('dust', __webpack_require__("./node_modules/highlight.js/lib/languages/dust.js"));
	hljs.registerLanguage('ebnf', __webpack_require__("./node_modules/highlight.js/lib/languages/ebnf.js"));
	hljs.registerLanguage('elixir', __webpack_require__("./node_modules/highlight.js/lib/languages/elixir.js"));
	hljs.registerLanguage('elm', __webpack_require__("./node_modules/highlight.js/lib/languages/elm.js"));
	hljs.registerLanguage('ruby', __webpack_require__("./node_modules/highlight.js/lib/languages/ruby.js"));
	hljs.registerLanguage('erb', __webpack_require__("./node_modules/highlight.js/lib/languages/erb.js"));
	hljs.registerLanguage('erlang-repl', __webpack_require__("./node_modules/highlight.js/lib/languages/erlang-repl.js"));
	hljs.registerLanguage('erlang', __webpack_require__("./node_modules/highlight.js/lib/languages/erlang.js"));
	hljs.registerLanguage('excel', __webpack_require__("./node_modules/highlight.js/lib/languages/excel.js"));
	hljs.registerLanguage('fix', __webpack_require__("./node_modules/highlight.js/lib/languages/fix.js"));
	hljs.registerLanguage('flix', __webpack_require__("./node_modules/highlight.js/lib/languages/flix.js"));
	hljs.registerLanguage('fortran', __webpack_require__("./node_modules/highlight.js/lib/languages/fortran.js"));
	hljs.registerLanguage('fsharp', __webpack_require__("./node_modules/highlight.js/lib/languages/fsharp.js"));
	hljs.registerLanguage('gams', __webpack_require__("./node_modules/highlight.js/lib/languages/gams.js"));
	hljs.registerLanguage('gauss', __webpack_require__("./node_modules/highlight.js/lib/languages/gauss.js"));
	hljs.registerLanguage('gcode', __webpack_require__("./node_modules/highlight.js/lib/languages/gcode.js"));
	hljs.registerLanguage('gherkin', __webpack_require__("./node_modules/highlight.js/lib/languages/gherkin.js"));
	hljs.registerLanguage('glsl', __webpack_require__("./node_modules/highlight.js/lib/languages/glsl.js"));
	hljs.registerLanguage('go', __webpack_require__("./node_modules/highlight.js/lib/languages/go.js"));
	hljs.registerLanguage('golo', __webpack_require__("./node_modules/highlight.js/lib/languages/golo.js"));
	hljs.registerLanguage('gradle', __webpack_require__("./node_modules/highlight.js/lib/languages/gradle.js"));
	hljs.registerLanguage('groovy', __webpack_require__("./node_modules/highlight.js/lib/languages/groovy.js"));
	hljs.registerLanguage('haml', __webpack_require__("./node_modules/highlight.js/lib/languages/haml.js"));
	hljs.registerLanguage('handlebars', __webpack_require__("./node_modules/highlight.js/lib/languages/handlebars.js"));
	hljs.registerLanguage('haskell', __webpack_require__("./node_modules/highlight.js/lib/languages/haskell.js"));
	hljs.registerLanguage('haxe', __webpack_require__("./node_modules/highlight.js/lib/languages/haxe.js"));
	hljs.registerLanguage('hsp', __webpack_require__("./node_modules/highlight.js/lib/languages/hsp.js"));
	hljs.registerLanguage('htmlbars', __webpack_require__("./node_modules/highlight.js/lib/languages/htmlbars.js"));
	hljs.registerLanguage('http', __webpack_require__("./node_modules/highlight.js/lib/languages/http.js"));
	hljs.registerLanguage('hy', __webpack_require__("./node_modules/highlight.js/lib/languages/hy.js"));
	hljs.registerLanguage('inform7', __webpack_require__("./node_modules/highlight.js/lib/languages/inform7.js"));
	hljs.registerLanguage('ini', __webpack_require__("./node_modules/highlight.js/lib/languages/ini.js"));
	hljs.registerLanguage('irpf90', __webpack_require__("./node_modules/highlight.js/lib/languages/irpf90.js"));
	hljs.registerLanguage('java', __webpack_require__("./node_modules/highlight.js/lib/languages/java.js"));
	hljs.registerLanguage('javascript', __webpack_require__("./node_modules/highlight.js/lib/languages/javascript.js"));
	hljs.registerLanguage('jboss-cli', __webpack_require__("./node_modules/highlight.js/lib/languages/jboss-cli.js"));
	hljs.registerLanguage('json', __webpack_require__("./node_modules/highlight.js/lib/languages/json.js"));
	hljs.registerLanguage('julia', __webpack_require__("./node_modules/highlight.js/lib/languages/julia.js"));
	hljs.registerLanguage('julia-repl', __webpack_require__("./node_modules/highlight.js/lib/languages/julia-repl.js"));
	hljs.registerLanguage('kotlin', __webpack_require__("./node_modules/highlight.js/lib/languages/kotlin.js"));
	hljs.registerLanguage('lasso', __webpack_require__("./node_modules/highlight.js/lib/languages/lasso.js"));
	hljs.registerLanguage('ldif', __webpack_require__("./node_modules/highlight.js/lib/languages/ldif.js"));
	hljs.registerLanguage('leaf', __webpack_require__("./node_modules/highlight.js/lib/languages/leaf.js"));
	hljs.registerLanguage('less', __webpack_require__("./node_modules/highlight.js/lib/languages/less.js"));
	hljs.registerLanguage('lisp', __webpack_require__("./node_modules/highlight.js/lib/languages/lisp.js"));
	hljs.registerLanguage('livecodeserver', __webpack_require__("./node_modules/highlight.js/lib/languages/livecodeserver.js"));
	hljs.registerLanguage('livescript', __webpack_require__("./node_modules/highlight.js/lib/languages/livescript.js"));
	hljs.registerLanguage('llvm', __webpack_require__("./node_modules/highlight.js/lib/languages/llvm.js"));
	hljs.registerLanguage('lsl', __webpack_require__("./node_modules/highlight.js/lib/languages/lsl.js"));
	hljs.registerLanguage('lua', __webpack_require__("./node_modules/highlight.js/lib/languages/lua.js"));
	hljs.registerLanguage('makefile', __webpack_require__("./node_modules/highlight.js/lib/languages/makefile.js"));
	hljs.registerLanguage('mathematica', __webpack_require__("./node_modules/highlight.js/lib/languages/mathematica.js"));
	hljs.registerLanguage('matlab', __webpack_require__("./node_modules/highlight.js/lib/languages/matlab.js"));
	hljs.registerLanguage('maxima', __webpack_require__("./node_modules/highlight.js/lib/languages/maxima.js"));
	hljs.registerLanguage('mel', __webpack_require__("./node_modules/highlight.js/lib/languages/mel.js"));
	hljs.registerLanguage('mercury', __webpack_require__("./node_modules/highlight.js/lib/languages/mercury.js"));
	hljs.registerLanguage('mipsasm', __webpack_require__("./node_modules/highlight.js/lib/languages/mipsasm.js"));
	hljs.registerLanguage('mizar', __webpack_require__("./node_modules/highlight.js/lib/languages/mizar.js"));
	hljs.registerLanguage('perl', __webpack_require__("./node_modules/highlight.js/lib/languages/perl.js"));
	hljs.registerLanguage('mojolicious', __webpack_require__("./node_modules/highlight.js/lib/languages/mojolicious.js"));
	hljs.registerLanguage('monkey', __webpack_require__("./node_modules/highlight.js/lib/languages/monkey.js"));
	hljs.registerLanguage('moonscript', __webpack_require__("./node_modules/highlight.js/lib/languages/moonscript.js"));
	hljs.registerLanguage('n1ql', __webpack_require__("./node_modules/highlight.js/lib/languages/n1ql.js"));
	hljs.registerLanguage('nginx', __webpack_require__("./node_modules/highlight.js/lib/languages/nginx.js"));
	hljs.registerLanguage('nimrod', __webpack_require__("./node_modules/highlight.js/lib/languages/nimrod.js"));
	hljs.registerLanguage('nix', __webpack_require__("./node_modules/highlight.js/lib/languages/nix.js"));
	hljs.registerLanguage('nsis', __webpack_require__("./node_modules/highlight.js/lib/languages/nsis.js"));
	hljs.registerLanguage('objectivec', __webpack_require__("./node_modules/highlight.js/lib/languages/objectivec.js"));
	hljs.registerLanguage('ocaml', __webpack_require__("./node_modules/highlight.js/lib/languages/ocaml.js"));
	hljs.registerLanguage('openscad', __webpack_require__("./node_modules/highlight.js/lib/languages/openscad.js"));
	hljs.registerLanguage('oxygene', __webpack_require__("./node_modules/highlight.js/lib/languages/oxygene.js"));
	hljs.registerLanguage('parser3', __webpack_require__("./node_modules/highlight.js/lib/languages/parser3.js"));
	hljs.registerLanguage('pf', __webpack_require__("./node_modules/highlight.js/lib/languages/pf.js"));
	hljs.registerLanguage('php', __webpack_require__("./node_modules/highlight.js/lib/languages/php.js"));
	hljs.registerLanguage('pony', __webpack_require__("./node_modules/highlight.js/lib/languages/pony.js"));
	hljs.registerLanguage('powershell', __webpack_require__("./node_modules/highlight.js/lib/languages/powershell.js"));
	hljs.registerLanguage('processing', __webpack_require__("./node_modules/highlight.js/lib/languages/processing.js"));
	hljs.registerLanguage('profile', __webpack_require__("./node_modules/highlight.js/lib/languages/profile.js"));
	hljs.registerLanguage('prolog', __webpack_require__("./node_modules/highlight.js/lib/languages/prolog.js"));
	hljs.registerLanguage('protobuf', __webpack_require__("./node_modules/highlight.js/lib/languages/protobuf.js"));
	hljs.registerLanguage('puppet', __webpack_require__("./node_modules/highlight.js/lib/languages/puppet.js"));
	hljs.registerLanguage('purebasic', __webpack_require__("./node_modules/highlight.js/lib/languages/purebasic.js"));
	hljs.registerLanguage('python', __webpack_require__("./node_modules/highlight.js/lib/languages/python.js"));
	hljs.registerLanguage('q', __webpack_require__("./node_modules/highlight.js/lib/languages/q.js"));
	hljs.registerLanguage('qml', __webpack_require__("./node_modules/highlight.js/lib/languages/qml.js"));
	hljs.registerLanguage('r', __webpack_require__("./node_modules/highlight.js/lib/languages/r.js"));
	hljs.registerLanguage('rib', __webpack_require__("./node_modules/highlight.js/lib/languages/rib.js"));
	hljs.registerLanguage('roboconf', __webpack_require__("./node_modules/highlight.js/lib/languages/roboconf.js"));
	hljs.registerLanguage('routeros', __webpack_require__("./node_modules/highlight.js/lib/languages/routeros.js"));
	hljs.registerLanguage('rsl', __webpack_require__("./node_modules/highlight.js/lib/languages/rsl.js"));
	hljs.registerLanguage('ruleslanguage', __webpack_require__("./node_modules/highlight.js/lib/languages/ruleslanguage.js"));
	hljs.registerLanguage('rust', __webpack_require__("./node_modules/highlight.js/lib/languages/rust.js"));
	hljs.registerLanguage('scala', __webpack_require__("./node_modules/highlight.js/lib/languages/scala.js"));
	hljs.registerLanguage('scheme', __webpack_require__("./node_modules/highlight.js/lib/languages/scheme.js"));
	hljs.registerLanguage('scilab', __webpack_require__("./node_modules/highlight.js/lib/languages/scilab.js"));
	hljs.registerLanguage('scss', __webpack_require__("./node_modules/highlight.js/lib/languages/scss.js"));
	hljs.registerLanguage('shell', __webpack_require__("./node_modules/highlight.js/lib/languages/shell.js"));
	hljs.registerLanguage('smali', __webpack_require__("./node_modules/highlight.js/lib/languages/smali.js"));
	hljs.registerLanguage('smalltalk', __webpack_require__("./node_modules/highlight.js/lib/languages/smalltalk.js"));
	hljs.registerLanguage('sml', __webpack_require__("./node_modules/highlight.js/lib/languages/sml.js"));
	hljs.registerLanguage('sqf', __webpack_require__("./node_modules/highlight.js/lib/languages/sqf.js"));
	hljs.registerLanguage('sql', __webpack_require__("./node_modules/highlight.js/lib/languages/sql.js"));
	hljs.registerLanguage('stan', __webpack_require__("./node_modules/highlight.js/lib/languages/stan.js"));
	hljs.registerLanguage('stata', __webpack_require__("./node_modules/highlight.js/lib/languages/stata.js"));
	hljs.registerLanguage('step21', __webpack_require__("./node_modules/highlight.js/lib/languages/step21.js"));
	hljs.registerLanguage('stylus', __webpack_require__("./node_modules/highlight.js/lib/languages/stylus.js"));
	hljs.registerLanguage('subunit', __webpack_require__("./node_modules/highlight.js/lib/languages/subunit.js"));
	hljs.registerLanguage('swift', __webpack_require__("./node_modules/highlight.js/lib/languages/swift.js"));
	hljs.registerLanguage('taggerscript', __webpack_require__("./node_modules/highlight.js/lib/languages/taggerscript.js"));
	hljs.registerLanguage('yaml', __webpack_require__("./node_modules/highlight.js/lib/languages/yaml.js"));
	hljs.registerLanguage('tap', __webpack_require__("./node_modules/highlight.js/lib/languages/tap.js"));
	hljs.registerLanguage('tcl', __webpack_require__("./node_modules/highlight.js/lib/languages/tcl.js"));
	hljs.registerLanguage('tex', __webpack_require__("./node_modules/highlight.js/lib/languages/tex.js"));
	hljs.registerLanguage('thrift', __webpack_require__("./node_modules/highlight.js/lib/languages/thrift.js"));
	hljs.registerLanguage('tp', __webpack_require__("./node_modules/highlight.js/lib/languages/tp.js"));
	hljs.registerLanguage('twig', __webpack_require__("./node_modules/highlight.js/lib/languages/twig.js"));
	hljs.registerLanguage('typescript', __webpack_require__("./node_modules/highlight.js/lib/languages/typescript.js"));
	hljs.registerLanguage('vala', __webpack_require__("./node_modules/highlight.js/lib/languages/vala.js"));
	hljs.registerLanguage('vbnet', __webpack_require__("./node_modules/highlight.js/lib/languages/vbnet.js"));
	hljs.registerLanguage('vbscript', __webpack_require__("./node_modules/highlight.js/lib/languages/vbscript.js"));
	hljs.registerLanguage('vbscript-html', __webpack_require__("./node_modules/highlight.js/lib/languages/vbscript-html.js"));
	hljs.registerLanguage('verilog', __webpack_require__("./node_modules/highlight.js/lib/languages/verilog.js"));
	hljs.registerLanguage('vhdl', __webpack_require__("./node_modules/highlight.js/lib/languages/vhdl.js"));
	hljs.registerLanguage('vim', __webpack_require__("./node_modules/highlight.js/lib/languages/vim.js"));
	hljs.registerLanguage('x86asm', __webpack_require__("./node_modules/highlight.js/lib/languages/x86asm.js"));
	hljs.registerLanguage('xl', __webpack_require__("./node_modules/highlight.js/lib/languages/xl.js"));
	hljs.registerLanguage('xquery', __webpack_require__("./node_modules/highlight.js/lib/languages/xquery.js"));
	hljs.registerLanguage('zephir', __webpack_require__("./node_modules/highlight.js/lib/languages/zephir.js"));
	
	module.exports = hljs;

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/1c.js":
/***/ (function(module, exports) {

	module.exports = function(hljs){
	
	  // общий паттерн для определения идентификаторов
	  var UNDERSCORE_IDENT_RE = '[A-Za-zА-Яа-яёЁ_][A-Za-zА-Яа-яёЁ_0-9]+';
	  
	  // v7 уникальные ключевые слова, отсутствующие в v8 ==> keyword
	  var v7_keywords =
	  'далее ';
	
	  // v8 ключевые слова ==> keyword
	  var v8_keywords =
	  'возврат вызватьисключение выполнить для если и из или иначе иначеесли исключение каждого конецесли ' +
	  'конецпопытки конеццикла не новый перейти перем по пока попытка прервать продолжить тогда цикл экспорт ';
	
	  // keyword : ключевые слова
	  var KEYWORD = v7_keywords + v8_keywords;
	  
	  // v7 уникальные директивы, отсутствующие в v8 ==> meta-keyword
	  var v7_meta_keywords =
	  'загрузитьизфайла ';
	
	  // v8 ключевые слова в инструкциях препроцессора, директивах компиляции, аннотациях ==> meta-keyword
	  var v8_meta_keywords =
	  'вебклиент вместо внешнеесоединение клиент конецобласти мобильноеприложениеклиент мобильноеприложениесервер ' +
	  'наклиенте наклиентенасервере наклиентенасерверебезконтекста насервере насерверебезконтекста область перед ' +
	  'после сервер толстыйклиентобычноеприложение толстыйклиентуправляемоеприложение тонкийклиент ';
	
	  // meta-keyword : ключевые слова в инструкциях препроцессора, директивах компиляции, аннотациях
	  var METAKEYWORD = v7_meta_keywords + v8_meta_keywords;
	
	  // v7 системные константы ==> built_in
	  var v7_system_constants =
	  'разделительстраниц разделительстрок символтабуляции ';
	  
	  // v7 уникальные методы глобального контекста, отсутствующие в v8 ==> built_in
	  var v7_global_context_methods =
	  'ansitooem oemtoansi ввестивидсубконто ввестиперечисление ввестипериод ввестиплансчетов выбранныйплансчетов ' +
	  'датагод датамесяц датачисло заголовоксистемы значениевстроку значениеизстроки каталогиб каталогпользователя ' +
	  'кодсимв конгода конецпериодаби конецрассчитанногопериодаби конецстандартногоинтервала конквартала конмесяца ' +
	  'коннедели лог лог10 максимальноеколичествосубконто названиеинтерфейса названиенабораправ назначитьвид ' +
	  'назначитьсчет найтиссылки началопериодаби началостандартногоинтервала начгода начквартала начмесяца ' +
	  'начнедели номерднягода номерднянедели номернеделигода обработкаожидания основнойжурналрасчетов ' +
	  'основнойплансчетов основнойязык очиститьокносообщений периодстр получитьвремята получитьдатута ' +
	  'получитьдокументта получитьзначенияотбора получитьпозициюта получитьпустоезначение получитьта ' +
	  'префиксавтонумерации пропись пустоезначение разм разобратьпозициюдокумента рассчитатьрегистрына ' +
	  'рассчитатьрегистрыпо симв создатьобъект статусвозврата стрколичествострок сформироватьпозициюдокумента ' +
	  'счетпокоду текущеевремя типзначения типзначениястр установитьтана установитьтапо фиксшаблон шаблон ';
	  
	  // v8 методы глобального контекста ==> built_in
	  var v8_global_context_methods =
	  'acos asin atan base64значение base64строка cos exp log log10 pow sin sqrt tan xmlзначение xmlстрока ' +
	  'xmlтип xmlтипзнч активноеокно безопасныйрежим безопасныйрежимразделенияданных булево ввестидату ввестизначение ' +
	  'ввестистроку ввестичисло возможностьчтенияxml вопрос восстановитьзначение врег выгрузитьжурналрегистрации ' +
	  'выполнитьобработкуоповещения выполнитьпроверкуправдоступа вычислить год данныеформывзначение дата день деньгода ' +
	  'деньнедели добавитьмесяц заблокироватьданныедляредактирования заблокироватьработупользователя завершитьработусистемы ' +
	  'загрузитьвнешнююкомпоненту закрытьсправку записатьjson записатьxml записатьдатуjson записьжурналарегистрации ' +
	  'заполнитьзначениясвойств запроситьразрешениепользователя запуститьприложение запуститьсистему зафиксироватьтранзакцию ' +
	  'значениевданныеформы значениевстрокувнутр значениевфайл значениезаполнено значениеизстрокивнутр значениеизфайла ' +
	  'изxmlтипа импортмоделиxdto имякомпьютера имяпользователя инициализироватьпредопределенныеданные информацияобошибке ' +
	  'каталогбиблиотекимобильногоустройства каталогвременныхфайлов каталогдокументов каталогпрограммы кодироватьстроку ' +
	  'кодлокализацииинформационнойбазы кодсимвола командасистемы конецгода конецдня конецквартала конецмесяца конецминуты ' +
	  'конецнедели конецчаса конфигурациябазыданныхизмененадинамически конфигурацияизменена копироватьданныеформы ' +
	  'копироватьфайл краткоепредставлениеошибки лев макс местноевремя месяц мин минута монопольныйрежим найти ' +
	  'найтинедопустимыесимволыxml найтиокнопонавигационнойссылке найтипомеченныенаудаление найтипоссылкам найтифайлы ' +
	  'началогода началодня началоквартала началомесяца началоминуты началонедели началочаса начатьзапросразрешенияпользователя ' +
	  'начатьзапускприложения начатькопированиефайла начатьперемещениефайла начатьподключениевнешнейкомпоненты ' +
	  'начатьподключениерасширенияработыскриптографией начатьподключениерасширенияработысфайлами начатьпоискфайлов ' +
	  'начатьполучениекаталогавременныхфайлов начатьполучениекаталогадокументов начатьполучениерабочегокаталогаданныхпользователя ' +
	  'начатьполучениефайлов начатьпомещениефайла начатьпомещениефайлов начатьсозданиедвоичныхданныхизфайла начатьсозданиекаталога ' +
	  'начатьтранзакцию начатьудалениефайлов начатьустановкувнешнейкомпоненты начатьустановкурасширенияработыскриптографией ' +
	  'начатьустановкурасширенияработысфайлами неделягода необходимостьзавершениясоединения номерсеансаинформационнойбазы ' +
	  'номерсоединенияинформационнойбазы нрег нстр обновитьинтерфейс обновитьнумерациюобъектов обновитьповторноиспользуемыезначения ' +
	  'обработкапрерыванияпользователя объединитьфайлы окр описаниеошибки оповестить оповеститьобизменении ' +
	  'отключитьобработчикзапросанастроекклиенталицензирования отключитьобработчикожидания отключитьобработчикоповещения ' +
	  'открытьзначение открытьиндекссправки открытьсодержаниесправки открытьсправку открытьформу открытьформумодально ' +
	  'отменитьтранзакцию очиститьжурналрегистрации очиститьнастройкипользователя очиститьсообщения параметрыдоступа ' +
	  'перейтипонавигационнойссылке переместитьфайл подключитьвнешнююкомпоненту ' +
	  'подключитьобработчикзапросанастроекклиенталицензирования подключитьобработчикожидания подключитьобработчикоповещения ' +
	  'подключитьрасширениеработыскриптографией подключитьрасширениеработысфайлами подробноепредставлениеошибки ' +
	  'показатьвводдаты показатьвводзначения показатьвводстроки показатьвводчисла показатьвопрос показатьзначение ' +
	  'показатьинформациюобошибке показатьнакарте показатьоповещениепользователя показатьпредупреждение полноеимяпользователя ' +
	  'получитьcomобъект получитьxmlтип получитьадреспоместоположению получитьблокировкусеансов получитьвремязавершенияспящегосеанса ' +
	  'получитьвремязасыпанияпассивногосеанса получитьвремяожиданияблокировкиданных получитьданныевыбора ' +
	  'получитьдополнительныйпараметрклиенталицензирования получитьдопустимыекодылокализации получитьдопустимыечасовыепояса ' +
	  'получитьзаголовокклиентскогоприложения получитьзаголовоксистемы получитьзначенияотборажурналарегистрации ' +
	  'получитьидентификаторконфигурации получитьизвременногохранилища получитьимявременногофайла ' +
	  'получитьимяклиенталицензирования получитьинформациюэкрановклиента получитьиспользованиежурналарегистрации ' +
	  'получитьиспользованиесобытияжурналарегистрации получитькраткийзаголовокприложения получитьмакетоформления ' +
	  'получитьмаскувсефайлы получитьмаскувсефайлыклиента получитьмаскувсефайлысервера получитьместоположениепоадресу ' +
	  'получитьминимальнуюдлинупаролейпользователей получитьнавигационнуюссылку получитьнавигационнуюссылкуинформационнойбазы ' +
	  'получитьобновлениеконфигурациибазыданных получитьобновлениепредопределенныхданныхинформационнойбазы получитьобщиймакет ' +
	  'получитьобщуюформу получитьокна получитьоперативнуюотметкувремени получитьотключениебезопасногорежима ' +
	  'получитьпараметрыфункциональныхопцийинтерфейса получитьполноеимяпредопределенногозначения ' +
	  'получитьпредставлениянавигационныхссылок получитьпроверкусложностипаролейпользователей получитьразделительпути ' +
	  'получитьразделительпутиклиента получитьразделительпутисервера получитьсеансыинформационнойбазы ' +
	  'получитьскоростьклиентскогосоединения получитьсоединенияинформационнойбазы получитьсообщенияпользователю ' +
	  'получитьсоответствиеобъектаиформы получитьсоставстандартногоинтерфейсаodata получитьструктурухранениябазыданных ' +
	  'получитьтекущийсеансинформационнойбазы получитьфайл получитьфайлы получитьформу получитьфункциональнуюопцию ' +
	  'получитьфункциональнуюопциюинтерфейса получитьчасовойпоясинформационнойбазы пользователиос поместитьвовременноехранилище ' +
	  'поместитьфайл поместитьфайлы прав праводоступа предопределенноезначение представлениекодалокализации представлениепериода ' +
	  'представлениеправа представлениеприложения представлениесобытияжурналарегистрации представлениечасовогопояса предупреждение ' +
	  'прекратитьработусистемы привилегированныйрежим продолжитьвызов прочитатьjson прочитатьxml прочитатьдатуjson пустаястрока ' +
	  'рабочийкаталогданныхпользователя разблокироватьданныедляредактирования разделитьфайл разорватьсоединениесвнешнимисточникомданных ' +
	  'раскодироватьстроку рольдоступна секунда сигнал символ скопироватьжурналрегистрации смещениелетнеговремени ' +
	  'смещениестандартноговремени соединитьбуферыдвоичныхданных создатькаталог создатьфабрикуxdto сокрл сокрлп сокрп сообщить ' +
	  'состояние сохранитьзначение сохранитьнастройкипользователя сред стрдлина стрзаканчиваетсяна стрзаменить стрнайти стрначинаетсяс ' +
	  'строка строкасоединенияинформационнойбазы стрполучитьстроку стрразделить стрсоединить стрсравнить стрчисловхождений '+
	  'стрчислострок стршаблон текущаядата текущаядатасеанса текущаяуниверсальнаядата текущаяуниверсальнаядатавмиллисекундах ' +
	  'текущийвариантинтерфейсаклиентскогоприложения текущийвариантосновногошрифтаклиентскогоприложения текущийкодлокализации ' +
	  'текущийрежимзапуска текущийязык текущийязыксистемы тип типзнч транзакцияактивна трег удалитьданныеинформационнойбазы ' +
	  'удалитьизвременногохранилища удалитьобъекты удалитьфайлы универсальноевремя установитьбезопасныйрежим ' +
	  'установитьбезопасныйрежимразделенияданных установитьблокировкусеансов установитьвнешнююкомпоненту ' +
	  'установитьвремязавершенияспящегосеанса установитьвремязасыпанияпассивногосеанса установитьвремяожиданияблокировкиданных ' +
	  'установитьзаголовокклиентскогоприложения установитьзаголовоксистемы установитьиспользованиежурналарегистрации ' +
	  'установитьиспользованиесобытияжурналарегистрации установитькраткийзаголовокприложения ' +
	  'установитьминимальнуюдлинупаролейпользователей установитьмонопольныйрежим установитьнастройкиклиенталицензирования ' +
	  'установитьобновлениепредопределенныхданныхинформационнойбазы установитьотключениебезопасногорежима ' +
	  'установитьпараметрыфункциональныхопцийинтерфейса установитьпривилегированныйрежим ' +
	  'установитьпроверкусложностипаролейпользователей установитьрасширениеработыскриптографией ' +
	  'установитьрасширениеработысфайлами установитьсоединениесвнешнимисточникомданных установитьсоответствиеобъектаиформы ' +
	  'установитьсоставстандартногоинтерфейсаodata установитьчасовойпоясинформационнойбазы установитьчасовойпояссеанса ' +
	  'формат цел час часовойпояс часовойпояссеанса число числопрописью этоадресвременногохранилища ';
	
	  // v8 свойства глобального контекста ==> built_in
	  var v8_global_context_property =
	  'wsссылки библиотекакартинок библиотекамакетовоформлениякомпоновкиданных библиотекастилей бизнеспроцессы ' +
	  'внешниеисточникиданных внешниеобработки внешниеотчеты встроенныепокупки главныйинтерфейс главныйстиль ' +
	  'документы доставляемыеуведомления журналыдокументов задачи информацияобинтернетсоединении использованиерабочейдаты ' +
	  'историяработыпользователя константы критерииотбора метаданные обработки отображениерекламы отправкадоставляемыхуведомлений ' +
	  'отчеты панельзадачос параметрзапуска параметрысеанса перечисления планывидоврасчета планывидовхарактеристик ' +
	  'планыобмена планысчетов полнотекстовыйпоиск пользователиинформационнойбазы последовательности проверкавстроенныхпокупок ' +
	  'рабочаядата расширенияконфигурации регистрыбухгалтерии регистрынакопления регистрырасчета регистрысведений ' +
	  'регламентныезадания сериализаторxdto справочники средствагеопозиционирования средствакриптографии средствамультимедиа ' +
	  'средстваотображениярекламы средствапочты средствателефонии фабрикаxdto файловыепотоки фоновыезадания хранилищанастроек ' +
	  'хранилищевариантовотчетов хранилищенастроекданныхформ хранилищеобщихнастроек хранилищепользовательскихнастроекдинамическихсписков ' +
	  'хранилищепользовательскихнастроекотчетов хранилищесистемныхнастроек ';
	
	  // built_in : встроенные или библиотечные объекты (константы, классы, функции)
	  var BUILTIN =
	  v7_system_constants +
	  v7_global_context_methods + v8_global_context_methods +
	  v8_global_context_property;
	  
	  // v8 системные наборы значений ==> class
	  var v8_system_sets_of_values =
	  'webцвета windowsцвета windowsшрифты библиотекакартинок рамкистиля символы цветастиля шрифтыстиля ';
	
	  // v8 системные перечисления - интерфейсные ==> class
	  var v8_system_enums_interface =
	  'автоматическоесохранениеданныхформывнастройках автонумерациявформе автораздвижениесерий ' +
	  'анимациядиаграммы вариантвыравниванияэлементовизаголовков вариантуправлениявысотойтаблицы ' +
	  'вертикальнаяпрокруткаформы вертикальноеположение вертикальноеположениеэлемента видгруппыформы ' +
	  'виддекорацииформы виддополненияэлементаформы видизмененияданных видкнопкиформы видпереключателя ' +
	  'видподписейкдиаграмме видполяформы видфлажка влияниеразмеранапузырекдиаграммы горизонтальноеположение ' +
	  'горизонтальноеположениеэлемента группировкаколонок группировкаподчиненныхэлементовформы ' +
	  'группыиэлементы действиеперетаскивания дополнительныйрежимотображения допустимыедействияперетаскивания ' +
	  'интервалмеждуэлементамиформы использованиевывода использованиеполосыпрокрутки ' +
	  'используемоезначениеточкибиржевойдиаграммы историявыборапривводе источникзначенийоситочекдиаграммы ' +
	  'источникзначенияразмерапузырькадиаграммы категориягруппыкоманд максимумсерий начальноеотображениедерева ' +
	  'начальноеотображениесписка обновлениетекстаредактирования ориентациядендрограммы ориентациядиаграммы ' +
	  'ориентацияметокдиаграммы ориентацияметоксводнойдиаграммы ориентацияэлементаформы отображениевдиаграмме ' +
	  'отображениевлегендедиаграммы отображениегруппыкнопок отображениезаголовкашкалыдиаграммы ' +
	  'отображениезначенийсводнойдиаграммы отображениезначенияизмерительнойдиаграммы ' +
	  'отображениеинтерваладиаграммыганта отображениекнопки отображениекнопкивыбора отображениеобсужденийформы ' +
	  'отображениеобычнойгруппы отображениеотрицательныхзначенийпузырьковойдиаграммы отображениепанелипоиска ' +
	  'отображениеподсказки отображениепредупрежденияприредактировании отображениеразметкиполосырегулирования ' +
	  'отображениестраницформы отображениетаблицы отображениетекстазначениядиаграммыганта ' +
	  'отображениеуправленияобычнойгруппы отображениефигурыкнопки палитрацветовдиаграммы поведениеобычнойгруппы ' +
	  'поддержкамасштабадендрограммы поддержкамасштабадиаграммыганта поддержкамасштабасводнойдиаграммы ' +
	  'поисквтаблицепривводе положениезаголовкаэлементаформы положениекартинкикнопкиформы ' +
	  'положениекартинкиэлементаграфическойсхемы положениекоманднойпанелиформы положениекоманднойпанелиэлементаформы ' +
	  'положениеопорнойточкиотрисовки положениеподписейкдиаграмме положениеподписейшкалызначенийизмерительнойдиаграммы ' +
	  'положениесостоянияпросмотра положениестрокипоиска положениетекстасоединительнойлинии положениеуправленияпоиском ' +
	  'положениешкалывремени порядокотображенияточекгоризонтальнойгистограммы порядоксерийвлегендедиаграммы ' +
	  'размеркартинки расположениезаголовкашкалыдиаграммы растягиваниеповертикалидиаграммыганта ' +
	  'режимавтоотображениясостояния режимвводастроктаблицы режимвыборанезаполненного режимвыделениядаты ' +
	  'режимвыделениястрокитаблицы режимвыделениятаблицы режимизмененияразмера режимизменениясвязанногозначения ' +
	  'режимиспользованиядиалогапечати режимиспользованияпараметракоманды режиммасштабированияпросмотра ' +
	  'режимосновногоокнаклиентскогоприложения режимоткрытияокнаформы режимотображениявыделения ' +
	  'режимотображениягеографическойсхемы режимотображениязначенийсерии режимотрисовкисеткиграфическойсхемы ' +
	  'режимполупрозрачностидиаграммы режимпробеловдиаграммы режимразмещениянастранице режимредактированияколонки ' +
	  'режимсглаживаниядиаграммы режимсглаживанияиндикатора режимсписказадач сквозноевыравнивание ' +
	  'сохранениеданныхформывнастройках способзаполнениятекстазаголовкашкалыдиаграммы ' +
	  'способопределенияограничивающегозначениядиаграммы стандартнаягруппакоманд стандартноеоформление ' +
	  'статусоповещенияпользователя стильстрелки типаппроксимациилиниитрендадиаграммы типдиаграммы ' +
	  'типединицышкалывремени типимпортасерийслоягеографическойсхемы типлиниигеографическойсхемы типлиниидиаграммы ' +
	  'типмаркерагеографическойсхемы типмаркерадиаграммы типобластиоформления ' +
	  'типорганизацииисточникаданныхгеографическойсхемы типотображениясериислоягеографическойсхемы ' +
	  'типотображенияточечногообъектагеографическойсхемы типотображенияшкалыэлементалегендыгеографическойсхемы ' +
	  'типпоискаобъектовгеографическойсхемы типпроекциигеографическойсхемы типразмещенияизмерений ' +
	  'типразмещенияреквизитовизмерений типрамкиэлементауправления типсводнойдиаграммы ' +
	  'типсвязидиаграммыганта типсоединениязначенийпосериямдиаграммы типсоединенияточекдиаграммы ' +
	  'типсоединительнойлинии типстороныэлементаграфическойсхемы типформыотчета типшкалырадарнойдиаграммы ' +
	  'факторлиниитрендадиаграммы фигуракнопки фигурыграфическойсхемы фиксациявтаблице форматдняшкалывремени ' +
	  'форматкартинки ширинаподчиненныхэлементовформы ';
	
	  // v8 системные перечисления - свойства прикладных объектов ==> class
	  var v8_system_enums_objects_properties =
	  'виддвижениябухгалтерии виддвижениянакопления видпериодарегистрарасчета видсчета видточкимаршрутабизнеспроцесса ' +
	  'использованиеагрегатарегистранакопления использованиегруппиэлементов использованиережимапроведения ' +
	  'использованиесреза периодичностьагрегатарегистранакопления режимавтовремя режимзаписидокумента режимпроведениядокумента ';
	
	  // v8 системные перечисления - планы обмена ==> class
	  var v8_system_enums_exchange_plans =
	  'авторегистрацияизменений допустимыйномерсообщения отправкаэлементаданных получениеэлементаданных ';
	
	  // v8 системные перечисления - табличный документ ==> class
	  var v8_system_enums_tabular_document =
	  'использованиерасшифровкитабличногодокумента ориентациястраницы положениеитоговколоноксводнойтаблицы ' +
	  'положениеитоговстроксводнойтаблицы положениетекстаотносительнокартинки расположениезаголовкагруппировкитабличногодокумента ' +
	  'способчтениязначенийтабличногодокумента типдвустороннейпечати типзаполненияобластитабличногодокумента ' +
	  'типкурсоровтабличногодокумента типлиниирисункатабличногодокумента типлинииячейкитабличногодокумента ' +
	  'типнаправленияпереходатабличногодокумента типотображениявыделениятабличногодокумента типотображениялинийсводнойтаблицы ' +
	  'типразмещениятекстатабличногодокумента типрисункатабличногодокумента типсмещениятабличногодокумента ' +
	  'типузоратабличногодокумента типфайлатабличногодокумента точностьпечати чередованиерасположениястраниц ';
	
	  // v8 системные перечисления - планировщик ==> class
	  var v8_system_enums_sheduler =
	  'отображениевремениэлементовпланировщика ';
	
	  // v8 системные перечисления - форматированный документ ==> class
	  var v8_system_enums_formatted_document =
	  'типфайлаформатированногодокумента ';
	
	  // v8 системные перечисления - запрос ==> class
	  var v8_system_enums_query =
	  'обходрезультатазапроса типзаписизапроса ';
	
	  // v8 системные перечисления - построитель отчета ==> class
	  var v8_system_enums_report_builder =
	  'видзаполнениярасшифровкипостроителяотчета типдобавленияпредставлений типизмеренияпостроителяотчета типразмещенияитогов ';
	
	  // v8 системные перечисления - работа с файлами ==> class
	  var v8_system_enums_files =
	  'доступкфайлу режимдиалогавыборафайла режимоткрытияфайла ';
	
	  // v8 системные перечисления - построитель запроса ==> class
	  var v8_system_enums_query_builder =
	  'типизмеренияпостроителязапроса ';
	
	  // v8 системные перечисления - анализ данных ==> class
	  var v8_system_enums_data_analysis =
	  'видданныханализа методкластеризации типединицыинтервалавременианализаданных типзаполнениятаблицырезультатаанализаданных ' +
	  'типиспользованиячисловыхзначенийанализаданных типисточникаданныхпоискаассоциаций типколонкианализаданныхдереворешений ' +
	  'типколонкианализаданныхкластеризация типколонкианализаданныхобщаястатистика типколонкианализаданныхпоискассоциаций ' +
	  'типколонкианализаданныхпоискпоследовательностей типколонкимоделипрогноза типмерырасстоянияанализаданных ' +
	  'типотсеченияправилассоциации типполяанализаданных типстандартизациианализаданных типупорядочиванияправилассоциациианализаданных ' +
	  'типупорядочиванияшаблоновпоследовательностейанализаданных типупрощениядереварешений ';
	
	  // v8 системные перечисления - xml, json, xs, dom, xdto, web-сервисы ==> class
	  var v8_system_enums_xml_json_xs_dom_xdto_ws =
	  'wsнаправлениепараметра вариантxpathxs вариантзаписидатыjson вариантпростоготипаxs видгруппымоделиxs видфасетаxdto ' +
	  'действиепостроителяdom завершенностьпростоготипаxs завершенностьсоставноготипаxs завершенностьсхемыxs запрещенныеподстановкиxs ' +
	  'исключениягруппподстановкиxs категорияиспользованияатрибутаxs категорияограниченияидентичностиxs категорияограниченияпространствименxs ' +
	  'методнаследованияxs модельсодержимогоxs назначениетипаxml недопустимыеподстановкиxs обработкапробельныхсимволовxs обработкасодержимогоxs ' +
	  'ограничениезначенияxs параметрыотбораузловdom переносстрокjson позициявдокументеdom пробельныесимволыxml типатрибутаxml типзначенияjson ' +
	  'типканоническогоxml типкомпонентыxs типпроверкиxml типрезультатаdomxpath типузлаdom типузлаxml формаxml формапредставленияxs ' +
	  'форматдатыjson экранированиесимволовjson ';
	
	  // v8 системные перечисления - система компоновки данных ==> class
	  var v8_system_enums_data_composition_system =
	  'видсравнениякомпоновкиданных действиеобработкирасшифровкикомпоновкиданных направлениесортировкикомпоновкиданных ' +
	  'расположениевложенныхэлементоврезультатакомпоновкиданных расположениеитоговкомпоновкиданных расположениегруппировкикомпоновкиданных ' +
	  'расположениеполейгруппировкикомпоновкиданных расположениеполякомпоновкиданных расположениереквизитовкомпоновкиданных ' +
	  'расположениересурсовкомпоновкиданных типбухгалтерскогоостаткакомпоновкиданных типвыводатекстакомпоновкиданных ' +
	  'типгруппировкикомпоновкиданных типгруппыэлементовотборакомпоновкиданных типдополненияпериодакомпоновкиданных ' +
	  'типзаголовкаполейкомпоновкиданных типмакетагруппировкикомпоновкиданных типмакетаобластикомпоновкиданных типостаткакомпоновкиданных ' +
	  'типпериодакомпоновкиданных типразмещениятекстакомпоновкиданных типсвязинаборовданныхкомпоновкиданных типэлементарезультатакомпоновкиданных ' +
	  'расположениелегендыдиаграммыкомпоновкиданных типпримененияотборакомпоновкиданных режимотображенияэлементанастройкикомпоновкиданных ' +
	  'режимотображениянастроеккомпоновкиданных состояниеэлементанастройкикомпоновкиданных способвосстановлениянастроеккомпоновкиданных ' +
	  'режимкомпоновкирезультата использованиепараметракомпоновкиданных автопозицияресурсовкомпоновкиданных '+
	  'вариантиспользованиягруппировкикомпоновкиданных расположениересурсоввдиаграммекомпоновкиданных фиксациякомпоновкиданных ' +
	  'использованиеусловногооформлениякомпоновкиданных ';
	
	  // v8 системные перечисления - почта ==> class
	  var v8_system_enums_email =
	  'важностьинтернетпочтовогосообщения обработкатекстаинтернетпочтовогосообщения способкодированияинтернетпочтовоговложения ' +
	  'способкодированиянеasciiсимволовинтернетпочтовогосообщения типтекстапочтовогосообщения протоколинтернетпочты ' +
	  'статусразборапочтовогосообщения ';
	
	  // v8 системные перечисления - журнал регистрации ==> class
	  var v8_system_enums_logbook =
	  'режимтранзакциизаписижурналарегистрации статустранзакциизаписижурналарегистрации уровеньжурналарегистрации ';
	
	  // v8 системные перечисления - криптография ==> class
	  var v8_system_enums_cryptography =
	  'расположениехранилищасертификатовкриптографии режимвключениясертификатовкриптографии режимпроверкисертификатакриптографии ' +
	  'типхранилищасертификатовкриптографии ';
	
	  // v8 системные перечисления - ZIP ==> class
	  var v8_system_enums_zip =
	  'кодировкаименфайловвzipфайле методсжатияzip методшифрованияzip режимвосстановленияпутейфайловzip режимобработкиподкаталоговzip ' +
	  'режимсохраненияпутейzip уровеньсжатияzip ';
	
	  // v8 системные перечисления - 
	  // Блокировка данных, Фоновые задания, Автоматизированное тестирование,
	  // Доставляемые уведомления, Встроенные покупки, Интернет, Работа с двоичными данными ==> class
	  var v8_system_enums_other =
	  'звуковоеоповещение направлениепереходакстроке позициявпотоке порядокбайтов режимблокировкиданных режимуправленияблокировкойданных ' +
	  'сервисвстроенныхпокупок состояниефоновогозадания типподписчикадоставляемыхуведомлений уровеньиспользованиязащищенногосоединенияftp ';
	
	  // v8 системные перечисления - схема запроса ==> class
	  var v8_system_enums_request_schema =
	  'направлениепорядкасхемызапроса типдополненияпериодамисхемызапроса типконтрольнойточкисхемызапроса типобъединениясхемызапроса ' +
	  'типпараметрадоступнойтаблицысхемызапроса типсоединениясхемызапроса ';
	
	  // v8 системные перечисления - свойства объектов метаданных ==> class
	  var v8_system_enums_properties_of_metadata_objects =
	  'httpметод автоиспользованиеобщегореквизита автопрефиксномеразадачи вариантвстроенногоязыка видиерархии видрегистранакопления ' +
	  'видтаблицывнешнегоисточникаданных записьдвиженийприпроведении заполнениепоследовательностей индексирование ' +
	  'использованиебазыпланавидоврасчета использованиебыстроговыбора использованиеобщегореквизита использованиеподчинения ' +
	  'использованиеполнотекстовогопоиска использованиеразделяемыхданныхобщегореквизита использованиереквизита ' +
	  'назначениеиспользованияприложения назначениерасширенияконфигурации направлениепередачи обновлениепредопределенныхданных ' +
	  'оперативноепроведение основноепредставлениевидарасчета основноепредставлениевидахарактеристики основноепредставлениезадачи ' +
	  'основноепредставлениепланаобмена основноепредставлениесправочника основноепредставлениесчета перемещениеграницыприпроведении ' +
	  'периодичностьномерабизнеспроцесса периодичностьномерадокумента периодичностьрегистрарасчета периодичностьрегистрасведений ' +
	  'повторноеиспользованиевозвращаемыхзначений полнотекстовыйпоискпривводепостроке принадлежностьобъекта проведение ' +
	  'разделениеаутентификацииобщегореквизита разделениеданныхобщегореквизита разделениерасширенийконфигурацииобщегореквизита '+
	  'режимавтонумерацииобъектов режимзаписирегистра режимиспользованиямодальности ' +
	  'режимиспользованиясинхронныхвызововрасширенийплатформыивнешнихкомпонент режимповторногоиспользованиясеансов ' +
	  'режимполученияданныхвыборапривводепостроке режимсовместимости режимсовместимостиинтерфейса ' +
	  'режимуправленияблокировкойданныхпоумолчанию сериикодовпланавидовхарактеристик сериикодовпланасчетов ' +
	  'сериикодовсправочника созданиепривводе способвыбора способпоискастрокипривводепостроке способредактирования ' +
	  'типданныхтаблицывнешнегоисточникаданных типкодапланавидоврасчета типкодасправочника типмакета типномерабизнеспроцесса ' +
	  'типномерадокумента типномеразадачи типформы удалениедвижений ';
	
	  // v8 системные перечисления - разные ==> class
	  var v8_system_enums_differents =
	  'важностьпроблемыприменениярасширенияконфигурации вариантинтерфейсаклиентскогоприложения вариантмасштабаформклиентскогоприложения ' +
	  'вариантосновногошрифтаклиентскогоприложения вариантстандартногопериода вариантстандартнойдатыначала видграницы видкартинки ' +
	  'видотображенияполнотекстовогопоиска видрамки видсравнения видцвета видчисловогозначения видшрифта допустимаядлина допустимыйзнак ' +
	  'использованиеbyteordermark использованиеметаданныхполнотекстовогопоиска источникрасширенийконфигурации клавиша кодвозвратадиалога ' +
	  'кодировкаxbase кодировкатекста направлениепоиска направлениесортировки обновлениепредопределенныхданных обновлениеприизмененииданных ' +
	  'отображениепанелиразделов проверказаполнения режимдиалогавопрос режимзапускаклиентскогоприложения режимокругления режимоткрытияформприложения ' +
	  'режимполнотекстовогопоиска скоростьклиентскогосоединения состояниевнешнегоисточникаданных состояниеобновленияконфигурациибазыданных ' +
	  'способвыборасертификатаwindows способкодированиястроки статуссообщения типвнешнейкомпоненты типплатформы типповеденияклавишиenter ' +
	  'типэлементаинформацииовыполненииобновленияконфигурациибазыданных уровеньизоляциитранзакций хешфункция частидаты';
	
	  // class: встроенные наборы значений, системные перечисления (содержат дочерние значения, обращения к которым через разыменование)
	  var CLASS =
	  v8_system_sets_of_values +
	  v8_system_enums_interface +
	  v8_system_enums_objects_properties +
	  v8_system_enums_exchange_plans +
	  v8_system_enums_tabular_document +
	  v8_system_enums_sheduler +
	  v8_system_enums_formatted_document +
	  v8_system_enums_query +
	  v8_system_enums_report_builder +
	  v8_system_enums_files +
	  v8_system_enums_query_builder +
	  v8_system_enums_data_analysis +
	  v8_system_enums_xml_json_xs_dom_xdto_ws +
	  v8_system_enums_data_composition_system +
	  v8_system_enums_email +
	  v8_system_enums_logbook +
	  v8_system_enums_cryptography +
	  v8_system_enums_zip +
	  v8_system_enums_other +
	  v8_system_enums_request_schema +
	  v8_system_enums_properties_of_metadata_objects +
	  v8_system_enums_differents;
	
	  // v8 общие объекты (у объектов есть конструктор, экземпляры создаются методом НОВЫЙ) ==> type
	  var v8_shared_object =
	  'comобъект ftpсоединение httpзапрос httpсервисответ httpсоединение wsопределения wsпрокси xbase анализданных аннотацияxs ' +
	  'блокировкаданных буфердвоичныхданных включениеxs выражениекомпоновкиданных генераторслучайныхчисел географическаясхема ' +
	  'географическиекоординаты графическаясхема группамоделиxs данныерасшифровкикомпоновкиданных двоичныеданные дендрограмма ' +
	  'диаграмма диаграммаганта диалогвыборафайла диалогвыборацвета диалогвыборашрифта диалограсписаниярегламентногозадания ' +
	  'диалогредактированиястандартногопериода диапазон документdom документhtml документацияxs доставляемоеуведомление ' +
	  'записьdom записьfastinfoset записьhtml записьjson записьxml записьzipфайла записьданных записьтекста записьузловdom ' +
	  'запрос защищенноесоединениеopenssl значенияполейрасшифровкикомпоновкиданных извлечениетекста импортxs интернетпочта ' +
	  'интернетпочтовоесообщение интернетпочтовыйпрофиль интернетпрокси интернетсоединение информациядляприложенияxs ' +
	  'использованиеатрибутаxs использованиесобытияжурналарегистрации источникдоступныхнастроеккомпоновкиданных ' +
	  'итераторузловdom картинка квалификаторыдаты квалификаторыдвоичныхданных квалификаторыстроки квалификаторычисла ' +
	  'компоновщикмакетакомпоновкиданных компоновщикнастроеккомпоновкиданных конструктормакетаоформлениякомпоновкиданных ' +
	  'конструкторнастроеккомпоновкиданных конструкторформатнойстроки линия макеткомпоновкиданных макетобластикомпоновкиданных ' +
	  'макетоформлениякомпоновкиданных маскаxs менеджеркриптографии наборсхемxml настройкикомпоновкиданных настройкисериализацииjson ' +
	  'обработкакартинок обработкарасшифровкикомпоновкиданных обходдереваdom объявлениеатрибутаxs объявлениенотацииxs ' +
	  'объявлениеэлементаxs описаниеиспользованиясобытиядоступжурналарегистрации ' +
	  'описаниеиспользованиясобытияотказвдоступежурналарегистрации описаниеобработкирасшифровкикомпоновкиданных ' +
	  'описаниепередаваемогофайла описаниетипов определениегруппыатрибутовxs определениегруппымоделиxs ' +
	  'определениеограниченияидентичностиxs определениепростоготипаxs определениесоставноготипаxs определениетипадокументаdom ' +
	  'определенияxpathxs отборкомпоновкиданных пакетотображаемыхдокументов параметрвыбора параметркомпоновкиданных ' +
	  'параметрызаписиjson параметрызаписиxml параметрычтенияxml переопределениеxs планировщик полеанализаданных ' +
	  'полекомпоновкиданных построительdom построительзапроса построительотчета построительотчетаанализаданных ' +
	  'построительсхемxml поток потоквпамяти почта почтовоесообщение преобразованиеxsl преобразованиекканоническомуxml ' +
	  'процессорвыводарезультатакомпоновкиданныхвколлекциюзначений процессорвыводарезультатакомпоновкиданныхвтабличныйдокумент ' +
	  'процессоркомпоновкиданных разыменовательпространствименdom рамка расписаниерегламентногозадания расширенноеимяxml ' +
	  'результатчтенияданных своднаядиаграмма связьпараметравыбора связьпотипу связьпотипукомпоновкиданных сериализаторxdto ' +
	  'сертификатклиентаwindows сертификатклиентафайл сертификаткриптографии сертификатыудостоверяющихцентровwindows ' +
	  'сертификатыудостоверяющихцентровфайл сжатиеданных системнаяинформация сообщениепользователю сочетаниеклавиш ' +
	  'сравнениезначений стандартнаядатаначала стандартныйпериод схемаxml схемакомпоновкиданных табличныйдокумент ' +
	  'текстовыйдокумент тестируемоеприложение типданныхxml уникальныйидентификатор фабрикаxdto файл файловыйпоток ' +
	  'фасетдлиныxs фасетколичестваразрядовдробнойчастиxs фасетмаксимальноговключающегозначенияxs ' +
	  'фасетмаксимальногоисключающегозначенияxs фасетмаксимальнойдлиныxs фасетминимальноговключающегозначенияxs ' +
	  'фасетминимальногоисключающегозначенияxs фасетминимальнойдлиныxs фасетобразцаxs фасетобщегоколичестваразрядовxs ' +
	  'фасетперечисленияxs фасетпробельныхсимволовxs фильтрузловdom форматированнаястрока форматированныйдокумент ' +
	  'фрагментxs хешированиеданных хранилищезначения цвет чтениеfastinfoset чтениеhtml чтениеjson чтениеxml чтениеzipфайла ' +
	  'чтениеданных чтениетекста чтениеузловdom шрифт элементрезультатакомпоновкиданных ';
	
	  // v8 универсальные коллекции значений ==> type
	  var v8_universal_collection =
	  'comsafearray деревозначений массив соответствие списокзначений структура таблицазначений фиксированнаяструктура ' +
	  'фиксированноесоответствие фиксированныймассив ';
	
	  // type : встроенные типы
	  var TYPE =
	  v8_shared_object +
	  v8_universal_collection;
	
	  // literal : примитивные типы
	  var LITERAL = 'null истина ложь неопределено';
	  
	  // number : числа
	  var NUMBERS = hljs.inherit(hljs.NUMBER_MODE);
	
	  // string : строки
	  var STRINGS = {
	    className: 'string',
	    begin: '"|\\|', end: '"|$',
	    contains: [{begin: '""'}]
	  };
	
	  // number : даты
	  var DATE = {
	    begin: "'", end: "'", excludeBegin: true, excludeEnd: true,
	    contains: [
	      {
	        className: 'number',
	        begin: '\\d{4}([\\.\\\\/:-]?\\d{2}){0,5}'
	      }
	    ]
	  };
	  
	  // comment : комментарии
	  var COMMENTS = hljs.inherit(hljs.C_LINE_COMMENT_MODE);
	  
	  // meta : инструкции препроцессора, директивы компиляции
	  var META = {
	    className: 'meta',
	    lexemes: UNDERSCORE_IDENT_RE,
	    begin: '#|&', end: '$',
	    keywords: {'meta-keyword': KEYWORD + METAKEYWORD},
	    contains: [
	      COMMENTS
	    ]
	  };
	  
	  // symbol : метка goto
	  var SYMBOL = {
	    className: 'symbol',
	    begin: '~', end: ';|:', excludeEnd: true
	  };  
	  
	  // function : объявление процедур и функций
	  var FUNCTION = {
	    className: 'function',
	    lexemes: UNDERSCORE_IDENT_RE,
	    variants: [
	      {begin: 'процедура|функция', end: '\\)', keywords: 'процедура функция'},
	      {begin: 'конецпроцедуры|конецфункции', keywords: 'конецпроцедуры конецфункции'}
	    ],
	    contains: [
	      {
	        begin: '\\(', end: '\\)', endsParent : true,
	        contains: [
	          {
	            className: 'params',
	            lexemes: UNDERSCORE_IDENT_RE,
	            begin: UNDERSCORE_IDENT_RE, end: ',', excludeEnd: true, endsWithParent: true,
	            keywords: {
	              keyword: 'знач',
	              literal: LITERAL
	            },
	            contains: [
	              NUMBERS,
	              STRINGS,
	              DATE
	            ]
	          },
	          COMMENTS
	        ]
	      },
	      hljs.inherit(hljs.TITLE_MODE, {begin: UNDERSCORE_IDENT_RE})
	    ]
	  };
	
	  return {
	    case_insensitive: true,
	    lexemes: UNDERSCORE_IDENT_RE,
	    keywords: {
	      keyword: KEYWORD,
	      built_in: BUILTIN,
	      class: CLASS,
	      type: TYPE,
	      literal: LITERAL
	    },
	    contains: [
	      META,
	      FUNCTION,
	      COMMENTS,
	      SYMBOL,
	      NUMBERS,
	      STRINGS,
	      DATE
	    ]  
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/abnf.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    var regexes = {
	        ruleDeclaration: "^[a-zA-Z][a-zA-Z0-9-]*",
	        unexpectedChars: "[!@#$^&',?+~`|:]"
	    };
	
	    var keywords = [
	        "ALPHA",
	        "BIT",
	        "CHAR",
	        "CR",
	        "CRLF",
	        "CTL",
	        "DIGIT",
	        "DQUOTE",
	        "HEXDIG",
	        "HTAB",
	        "LF",
	        "LWSP",
	        "OCTET",
	        "SP",
	        "VCHAR",
	        "WSP"
	    ];
	
	    var commentMode = hljs.COMMENT(";", "$");
	
	    var terminalBinaryMode = {
	        className: "symbol",
	        begin: /%b[0-1]+(-[0-1]+|(\.[0-1]+)+){0,1}/
	    };
	
	    var terminalDecimalMode = {
	        className: "symbol",
	        begin: /%d[0-9]+(-[0-9]+|(\.[0-9]+)+){0,1}/
	    };
	
	    var terminalHexadecimalMode = {
	        className: "symbol",
	        begin: /%x[0-9A-F]+(-[0-9A-F]+|(\.[0-9A-F]+)+){0,1}/,
	    };
	
	    var caseSensitivityIndicatorMode = {
	        className: "symbol",
	        begin: /%[si]/
	    };
	
	    var ruleDeclarationMode = {
	        begin: regexes.ruleDeclaration + '\\s*=',
	        returnBegin: true,
	        end: /=/,
	        relevance: 0,
	        contains: [{className: "attribute", begin: regexes.ruleDeclaration}]
	    };
	
	    return {
	      illegal: regexes.unexpectedChars,
	      keywords: keywords.join(" "),
	      contains: [
	          ruleDeclarationMode,
	          commentMode,
	          terminalBinaryMode,
	          terminalDecimalMode,
	          terminalHexadecimalMode,
	          caseSensitivityIndicatorMode,
	          hljs.QUOTE_STRING_MODE,
	          hljs.NUMBER_MODE
	      ]
	    };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/accesslog.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    contains: [
	      // IP
	      {
	        className: 'number',
	        begin: '\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b'
	      },
	      // Other numbers
	      {
	        className: 'number',
	        begin: '\\b\\d+\\b',
	        relevance: 0
	      },
	      // Requests
	      {
	        className: 'string',
	        begin: '"(GET|POST|HEAD|PUT|DELETE|CONNECT|OPTIONS|PATCH|TRACE)', end: '"',
	        keywords: 'GET POST HEAD PUT DELETE CONNECT OPTIONS PATCH TRACE',
	        illegal: '\\n',
	        relevance: 10
	      },
	      // Dates
	      {
	        className: 'string',
	        begin: /\[/, end: /\]/,
	        illegal: '\\n'
	      },
	      // Strings
	      {
	        className: 'string',
	        begin: '"', end: '"',
	        illegal: '\\n'
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/actionscript.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE = '[a-zA-Z_$][a-zA-Z0-9_$]*';
	  var IDENT_FUNC_RETURN_TYPE_RE = '([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)';
	
	  var AS3_REST_ARG_MODE = {
	    className: 'rest_arg',
	    begin: '[.]{3}', end: IDENT_RE,
	    relevance: 10
	  };
	
	  return {
	    aliases: ['as'],
	    keywords: {
	      keyword: 'as break case catch class const continue default delete do dynamic each ' +
	        'else extends final finally for function get if implements import in include ' +
	        'instanceof interface internal is namespace native new override package private ' +
	        'protected public return set static super switch this throw try typeof use var void ' +
	        'while with',
	      literal: 'true false null undefined'
	    },
	    contains: [
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'package', end: '{',
	        contains: [hljs.TITLE_MODE]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        contains: [
	          {
	            beginKeywords: 'extends implements'
	          },
	          hljs.TITLE_MODE
	        ]
	      },
	      {
	        className: 'meta',
	        beginKeywords: 'import include', end: ';',
	        keywords: {'meta-keyword': 'import include'}
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '[{;]', excludeEnd: true,
	        illegal: '\\S',
	        contains: [
	          hljs.TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)',
	            contains: [
	              hljs.APOS_STRING_MODE,
	              hljs.QUOTE_STRING_MODE,
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              AS3_REST_ARG_MODE
	            ]
	          },
	          {
	            begin: ':\\s*' + IDENT_FUNC_RETURN_TYPE_RE
	          }
	        ]
	      },
	      hljs.METHOD_GUARD
	    ],
	    illegal: /#/
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/ada.js":
/***/ (function(module, exports) {

	module.exports = // We try to support full Ada2012
	//
	// We highlight all appearances of types, keywords, literals (string, char, number, bool)
	// and titles (user defined function/procedure/package)
	// CSS classes are set accordingly
	//
	// Languages causing problems for language detection:
	// xml (broken by Foo : Bar type), elm (broken by Foo : Bar type), vbscript-html (broken by body keyword)
	// sql (ada default.txt has a lot of sql keywords)
	
	function(hljs) {
	    // Regular expression for Ada numeric literals.
	    // stolen form the VHDL highlighter
	
	    // Decimal literal:
	    var INTEGER_RE = '\\d(_|\\d)*';
	    var EXPONENT_RE = '[eE][-+]?' + INTEGER_RE;
	    var DECIMAL_LITERAL_RE = INTEGER_RE + '(\\.' + INTEGER_RE + ')?' + '(' + EXPONENT_RE + ')?';
	
	    // Based literal:
	    var BASED_INTEGER_RE = '\\w+';
	    var BASED_LITERAL_RE = INTEGER_RE + '#' + BASED_INTEGER_RE + '(\\.' + BASED_INTEGER_RE + ')?' + '#' + '(' + EXPONENT_RE + ')?';
	
	    var NUMBER_RE = '\\b(' + BASED_LITERAL_RE + '|' + DECIMAL_LITERAL_RE + ')';
	
	    // Identifier regex
	    var ID_REGEX = '[A-Za-z](_?[A-Za-z0-9.])*';
	
	    // bad chars, only allowed in literals
	    var BAD_CHARS = '[]{}%#\'\"'
	
	    // Ada doesn't have block comments, only line comments
	    var COMMENTS = hljs.COMMENT('--', '$');
	
	    // variable declarations of the form
	    // Foo : Bar := Baz;
	    // where only Bar will be highlighted
	    var VAR_DECLS = {
	        // TODO: These spaces are not required by the Ada syntax
	        // however, I have yet to see handwritten Ada code where
	        // someone does not put spaces around :
	        begin: '\\s+:\\s+', end: '\\s*(:=|;|\\)|=>|$)',
	        // endsWithParent: true,
	        // returnBegin: true,
	        illegal: BAD_CHARS,
	        contains: [
	            {
	                // workaround to avoid highlighting
	                // named loops and declare blocks
	                beginKeywords: 'loop for declare others',
	                endsParent: true,
	            },
	            {
	                // properly highlight all modifiers
	                className: 'keyword',
	                beginKeywords: 'not null constant access function procedure in out aliased exception'
	            },
	            {
	                className: 'type',
	                begin: ID_REGEX,
	                endsParent: true,
	                relevance: 0,
	            }
	        ]
	    };
	
	    return {
	        case_insensitive: true,
	        keywords: {
	            keyword:
	                'abort else new return abs elsif not reverse abstract end ' +
	                'accept entry select access exception of separate aliased exit or some ' +
	                'all others subtype and for out synchronized array function overriding ' +
	                'at tagged generic package task begin goto pragma terminate ' +
	                'body private then if procedure type case in protected constant interface ' +
	                'is raise use declare range delay limited record when delta loop rem while ' +
	                'digits renames with do mod requeue xor',
	            literal:
	                'True False',
	        },
	        contains: [
	            COMMENTS,
	            // strings "foobar"
	            {
	                className: 'string',
	                begin: /"/, end: /"/,
	                contains: [{begin: /""/, relevance: 0}]
	            },
	            // characters ''
	            {
	                // character literals always contain one char
	                className: 'string',
	                begin: /'.'/
	            },
	            {
	                // number literals
	                className: 'number',
	                begin: NUMBER_RE,
	                relevance: 0
	            },
	            {
	                // Attributes
	                className: 'symbol',
	                begin: "'" + ID_REGEX,
	            },
	            {
	                // package definition, maybe inside generic
	                className: 'title',
	                begin: '(\\bwith\\s+)?(\\bprivate\\s+)?\\bpackage\\s+(\\bbody\\s+)?', end: '(is|$)',
	                keywords: 'package body',
	                excludeBegin: true,
	                excludeEnd: true,
	                illegal: BAD_CHARS
	            },
	            {
	                // function/procedure declaration/definition
	                // maybe inside generic
	                begin: '(\\b(with|overriding)\\s+)?\\b(function|procedure)\\s+', end: '(\\bis|\\bwith|\\brenames|\\)\\s*;)',
	                keywords: 'overriding function procedure with is renames return',
	                // we need to re-match the 'function' keyword, so that
	                // the title mode below matches only exactly once
	                returnBegin: true,
	                contains:
	                [
	                    COMMENTS,
	                    {
	                        // name of the function/procedure
	                        className: 'title',
	                        begin: '(\\bwith\\s+)?\\b(function|procedure)\\s+',
	                        end: '(\\(|\\s+|$)',
	                        excludeBegin: true,
	                        excludeEnd: true,
	                        illegal: BAD_CHARS
	                    },
	                    // 'self'
	                    // // parameter types
	                    VAR_DECLS,
	                    {
	                        // return type
	                        className: 'type',
	                        begin: '\\breturn\\s+', end: '(\\s+|;|$)',
	                        keywords: 'return',
	                        excludeBegin: true,
	                        excludeEnd: true,
	                        // we are done with functions
	                        endsParent: true,
	                        illegal: BAD_CHARS
	
	                    },
	                ]
	            },
	            {
	                // new type declarations
	                // maybe inside generic
	                className: 'type',
	                begin: '\\b(sub)?type\\s+', end: '\\s+',
	                keywords: 'type',
	                excludeBegin: true,
	                illegal: BAD_CHARS
	            },
	
	            // see comment above the definition
	            VAR_DECLS,
	
	            // no markup
	            // relevance boosters for small snippets
	            // {begin: '\\s*=>\\s*'},
	            // {begin: '\\s*:=\\s*'},
	            // {begin: '\\s+:=\\s+'},
	        ]
	    };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/apache.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var NUMBER = {className: 'number', begin: '[\\$%]\\d+'};
	  return {
	    aliases: ['apacheconf'],
	    case_insensitive: true,
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {className: 'section', begin: '</?', end: '>'},
	      {
	        className: 'attribute',
	        begin: /\w+/,
	        relevance: 0,
	        // keywords aren’t needed for highlighting per se, they only boost relevance
	        // for a very generally defined mode (starts with a word, ends with line-end
	        keywords: {
	          nomarkup:
	            'order deny allow setenv rewriterule rewriteengine rewritecond documentroot ' +
	            'sethandler errordocument loadmodule options header listen serverroot ' +
	            'servername'
	        },
	        starts: {
	          end: /$/,
	          relevance: 0,
	          keywords: {
	            literal: 'on off all'
	          },
	          contains: [
	            {
	              className: 'meta',
	              begin: '\\s\\[', end: '\\]$'
	            },
	            {
	              className: 'variable',
	              begin: '[\\$%]\\{', end: '\\}',
	              contains: ['self', NUMBER]
	            },
	            NUMBER,
	            hljs.QUOTE_STRING_MODE
	          ]
	        }
	      }
	    ],
	    illegal: /\S/
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/applescript.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: ''});
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)',
	    contains: ['self', hljs.C_NUMBER_MODE, STRING]
	  };
	  var COMMENT_MODE_1 = hljs.COMMENT('--', '$');
	  var COMMENT_MODE_2 = hljs.COMMENT(
	    '\\(\\*',
	    '\\*\\)',
	    {
	      contains: ['self', COMMENT_MODE_1] //allow nesting
	    }
	  );
	  var COMMENTS = [
	    COMMENT_MODE_1,
	    COMMENT_MODE_2,
	    hljs.HASH_COMMENT_MODE
	  ];
	
	  return {
	    aliases: ['osascript'],
	    keywords: {
	      keyword:
	        'about above after against and around as at back before beginning ' +
	        'behind below beneath beside between but by considering ' +
	        'contain contains continue copy div does eighth else end equal ' +
	        'equals error every exit fifth first for fourth from front ' +
	        'get given global if ignoring in into is it its last local me ' +
	        'middle mod my ninth not of on onto or over prop property put ref ' +
	        'reference repeat returning script second set seventh since ' +
	        'sixth some tell tenth that the|0 then third through thru ' +
	        'timeout times to transaction try until where while whose with ' +
	        'without',
	      literal:
	        'AppleScript false linefeed return pi quote result space tab true',
	      built_in:
	        'alias application boolean class constant date file integer list ' +
	        'number real record string text ' +
	        'activate beep count delay launch log offset read round ' +
	        'run say summarize write ' +
	        'character characters contents day frontmost id item length ' +
	        'month name paragraph paragraphs rest reverse running time version ' +
	        'weekday word words year'
	    },
	    contains: [
	      STRING,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'built_in',
	        begin:
	          '\\b(clipboard info|the clipboard|info for|list (disks|folder)|' +
	          'mount volume|path to|(close|open for) access|(get|set) eof|' +
	          'current date|do shell script|get volume settings|random number|' +
	          'set volume|system attribute|system info|time to GMT|' +
	          '(load|run|store) script|scripting components|' +
	          'ASCII (character|number)|localized string|' +
	          'choose (application|color|file|file name|' +
	          'folder|from list|remote application|URL)|' +
	          'display (alert|dialog))\\b|^\\s*return\\b'
	      },
	      {
	        className: 'literal',
	        begin:
	          '\\b(text item delimiters|current application|missing value)\\b'
	      },
	      {
	        className: 'keyword',
	        begin:
	          '\\b(apart from|aside from|instead of|out of|greater than|' +
	          "isn't|(doesn't|does not) (equal|come before|come after|contain)|" +
	          '(greater|less) than( or equal)?|(starts?|ends|begins?) with|' +
	          'contained by|comes (before|after)|a (ref|reference)|POSIX file|' +
	          'POSIX path|(date|time) string|quoted form)\\b'
	      },
	      {
	        beginKeywords: 'on',
	        illegal: '[${=;\\n]',
	        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
	      }
	    ].concat(COMMENTS),
	    illegal: '//|->|=>|\\[\\['
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/arduino.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var CPP = hljs.getLanguage('cpp').exports;
		return {
	    keywords: {
	      keyword:
	        'boolean byte word string String array ' + CPP.keywords.keyword,
	      built_in:
	        'setup loop while catch for if do goto try switch case else ' +
	        'default break continue return ' +
	        'KeyboardController MouseController SoftwareSerial ' +
	        'EthernetServer EthernetClient LiquidCrystal ' +
	        'RobotControl GSMVoiceCall EthernetUDP EsploraTFT ' +
	        'HttpClient RobotMotor WiFiClient GSMScanner ' +
	        'FileSystem Scheduler GSMServer YunClient YunServer ' +
	        'IPAddress GSMClient GSMModem Keyboard Ethernet ' +
	        'Console GSMBand Esplora Stepper Process ' +
	        'WiFiUDP GSM_SMS Mailbox USBHost Firmata PImage ' +
	        'Client Server GSMPIN FileIO Bridge Serial ' +
	        'EEPROM Stream Mouse Audio Servo File Task ' +
	        'GPRS WiFi Wire TFT GSM SPI SD ' +
	        'runShellCommandAsynchronously analogWriteResolution ' +
	        'retrieveCallingNumber printFirmwareVersion ' +
	        'analogReadResolution sendDigitalPortPair ' +
	        'noListenOnLocalhost readJoystickButton setFirmwareVersion ' +
	        'readJoystickSwitch scrollDisplayRight getVoiceCallStatus ' +
	        'scrollDisplayLeft writeMicroseconds delayMicroseconds ' +
	        'beginTransmission getSignalStrength runAsynchronously ' +
	        'getAsynchronously listenOnLocalhost getCurrentCarrier ' +
	        'readAccelerometer messageAvailable sendDigitalPorts ' +
	        'lineFollowConfig countryNameWrite runShellCommand ' +
	        'readStringUntil rewindDirectory readTemperature ' +
	        'setClockDivider readLightSensor endTransmission ' +
	        'analogReference detachInterrupt countryNameRead ' +
	        'attachInterrupt encryptionType readBytesUntil ' +
	        'robotNameWrite readMicrophone robotNameRead cityNameWrite ' +
	        'userNameWrite readJoystickY readJoystickX mouseReleased ' +
	        'openNextFile scanNetworks noInterrupts digitalWrite ' +
	        'beginSpeaker mousePressed isActionDone mouseDragged ' +
	        'displayLogos noAutoscroll addParameter remoteNumber ' +
	        'getModifiers keyboardRead userNameRead waitContinue ' +
	        'processInput parseCommand printVersion readNetworks ' +
	        'writeMessage blinkVersion cityNameRead readMessage ' +
	        'setDataMode parsePacket isListening setBitOrder ' +
	        'beginPacket isDirectory motorsWrite drawCompass ' +
	        'digitalRead clearScreen serialEvent rightToLeft ' +
	        'setTextSize leftToRight requestFrom keyReleased ' +
	        'compassRead analogWrite interrupts WiFiServer ' +
	        'disconnect playMelody parseFloat autoscroll ' +
	        'getPINUsed setPINUsed setTimeout sendAnalog ' +
	        'readSlider analogRead beginWrite createChar ' +
	        'motorsStop keyPressed tempoWrite readButton ' +
	        'subnetMask debugPrint macAddress writeGreen ' +
	        'randomSeed attachGPRS readString sendString ' +
	        'remotePort releaseAll mouseMoved background ' +
	        'getXChange getYChange answerCall getResult ' +
	        'voiceCall endPacket constrain getSocket writeJSON ' +
	        'getButton available connected findUntil readBytes ' +
	        'exitValue readGreen writeBlue startLoop IPAddress ' +
	        'isPressed sendSysex pauseMode gatewayIP setCursor ' +
	        'getOemKey tuneWrite noDisplay loadImage switchPIN ' +
	        'onRequest onReceive changePIN playFile noBuffer ' +
	        'parseInt overflow checkPIN knobRead beginTFT ' +
	        'bitClear updateIR bitWrite position writeRGB ' +
	        'highByte writeRed setSpeed readBlue noStroke ' +
	        'remoteIP transfer shutdown hangCall beginSMS ' +
	        'endWrite attached maintain noCursor checkReg ' +
	        'checkPUK shiftOut isValid shiftIn pulseIn ' +
	        'connect println localIP pinMode getIMEI ' +
	        'display noBlink process getBand running beginSD ' +
	        'drawBMP lowByte setBand release bitRead prepare ' +
	        'pointTo readRed setMode noFill remove listen ' +
	        'stroke detach attach noTone exists buffer ' +
	        'height bitSet circle config cursor random ' +
	        'IRread setDNS endSMS getKey micros ' +
	        'millis begin print write ready flush width ' +
	        'isPIN blink clear press mkdir rmdir close ' +
	        'point yield image BSSID click delay ' +
	        'read text move peek beep rect line open ' +
	        'seek fill size turn stop home find ' +
	        'step tone sqrt RSSI SSID ' +
	        'end bit tan cos sin pow map abs max ' +
	        'min get run put',
	      literal:
	        'DIGITAL_MESSAGE FIRMATA_STRING ANALOG_MESSAGE ' +
	        'REPORT_DIGITAL REPORT_ANALOG INPUT_PULLUP ' +
	        'SET_PIN_MODE INTERNAL2V56 SYSTEM_RESET LED_BUILTIN ' +
	        'INTERNAL1V1 SYSEX_START INTERNAL EXTERNAL ' +
	        'DEFAULT OUTPUT INPUT HIGH LOW'
	    },
	    contains: [
	      CPP.preprocessor,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/armasm.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    //local labels: %?[FB]?[AT]?\d{1,2}\w+
	  return {
	    case_insensitive: true,
	    aliases: ['arm'],
	    lexemes: '\\.?' + hljs.IDENT_RE,
	    keywords: {
	      meta:
	        //GNU preprocs
	        '.2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .arm .thumb .code16 .code32 .force_thumb .thumb_func .ltorg '+
	        //ARM directives
	        'ALIAS ALIGN ARM AREA ASSERT ATTR CN CODE CODE16 CODE32 COMMON CP DATA DCB DCD DCDU DCDO DCFD DCFDU DCI DCQ DCQU DCW DCWU DN ELIF ELSE END ENDFUNC ENDIF ENDP ENTRY EQU EXPORT EXPORTAS EXTERN FIELD FILL FUNCTION GBLA GBLL GBLS GET GLOBAL IF IMPORT INCBIN INCLUDE INFO KEEP LCLA LCLL LCLS LTORG MACRO MAP MEND MEXIT NOFP OPT PRESERVE8 PROC QN READONLY RELOC REQUIRE REQUIRE8 RLIST FN ROUT SETA SETL SETS SN SPACE SUBT THUMB THUMBX TTL WHILE WEND ',
	      built_in:
	        'r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 '+ //standard registers
	        'pc lr sp ip sl sb fp '+ //typical regs plus backward compatibility
	        'a1 a2 a3 a4 v1 v2 v3 v4 v5 v6 v7 v8 f0 f1 f2 f3 f4 f5 f6 f7 '+ //more regs and fp
	        'p0 p1 p2 p3 p4 p5 p6 p7 p8 p9 p10 p11 p12 p13 p14 p15 '+ //coprocessor regs
	        'c0 c1 c2 c3 c4 c5 c6 c7 c8 c9 c10 c11 c12 c13 c14 c15 '+ //more coproc
	        'q0 q1 q2 q3 q4 q5 q6 q7 q8 q9 q10 q11 q12 q13 q14 q15 '+ //advanced SIMD NEON regs
	
	        //program status registers
	        'cpsr_c cpsr_x cpsr_s cpsr_f cpsr_cx cpsr_cxs cpsr_xs cpsr_xsf cpsr_sf cpsr_cxsf '+
	        'spsr_c spsr_x spsr_s spsr_f spsr_cx spsr_cxs spsr_xs spsr_xsf spsr_sf spsr_cxsf '+
	
	        //NEON and VFP registers
	        's0 s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 '+
	        's16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 '+
	        'd0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11 d12 d13 d14 d15 '+
	        'd16 d17 d18 d19 d20 d21 d22 d23 d24 d25 d26 d27 d28 d29 d30 d31 ' +
	
	        '{PC} {VAR} {TRUE} {FALSE} {OPT} {CONFIG} {ENDIAN} {CODESIZE} {CPU} {FPU} {ARCHITECTURE} {PCSTOREOFFSET} {ARMASM_VERSION} {INTER} {ROPI} {RWPI} {SWST} {NOSWST} . @'
	    },
	    contains: [
	      {
	        className: 'keyword',
	        begin: '\\b('+     //mnemonics
	            'adc|'+
	            '(qd?|sh?|u[qh]?)?add(8|16)?|usada?8|(q|sh?|u[qh]?)?(as|sa)x|'+
	            'and|adrl?|sbc|rs[bc]|asr|b[lx]?|blx|bxj|cbn?z|tb[bh]|bic|'+
	            'bfc|bfi|[su]bfx|bkpt|cdp2?|clz|clrex|cmp|cmn|cpsi[ed]|cps|'+
	            'setend|dbg|dmb|dsb|eor|isb|it[te]{0,3}|lsl|lsr|ror|rrx|'+
	            'ldm(([id][ab])|f[ds])?|ldr((s|ex)?[bhd])?|movt?|mvn|mra|mar|'+
	            'mul|[us]mull|smul[bwt][bt]|smu[as]d|smmul|smmla|'+
	            'mla|umlaal|smlal?([wbt][bt]|d)|mls|smlsl?[ds]|smc|svc|sev|'+
	            'mia([bt]{2}|ph)?|mrr?c2?|mcrr2?|mrs|msr|orr|orn|pkh(tb|bt)|rbit|'+
	            'rev(16|sh)?|sel|[su]sat(16)?|nop|pop|push|rfe([id][ab])?|'+
	            'stm([id][ab])?|str(ex)?[bhd]?|(qd?)?sub|(sh?|q|u[qh]?)?sub(8|16)|'+
	            '[su]xt(a?h|a?b(16)?)|srs([id][ab])?|swpb?|swi|smi|tst|teq|'+
	            'wfe|wfi|yield'+
	        ')'+
	        '(eq|ne|cs|cc|mi|pl|vs|vc|hi|ls|ge|lt|gt|le|al|hs|lo)?'+ //condition codes
	        '[sptrx]?' ,                                             //legal postfixes
	        end: '\\s'
	      },
	      hljs.COMMENT('[;@]', '$', {relevance: 0}),
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: '\'',
	        end: '[^\\\\]\'',
	        relevance: 0
	      },
	      {
	        className: 'title',
	        begin: '\\|', end: '\\|',
	        illegal: '\\n',
	        relevance: 0
	      },
	      {
	        className: 'number',
	        variants: [
	            {begin: '[#$=]?0x[0-9a-f]+'}, //hex
	            {begin: '[#$=]?0b[01]+'},     //bin
	            {begin: '[#$=]\\d+'},        //literal
	            {begin: '\\b\\d+'}           //bare number
	        ],
	        relevance: 0
	      },
	      {
	        className: 'symbol',
	        variants: [
	            {begin: '^[a-z_\\.\\$][a-z0-9_\\.\\$]+'}, //ARM syntax
	            {begin: '^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:'}, //GNU ARM syntax
	            {begin: '[=#]\\w+' }  //label reference
	        ],
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/asciidoc.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['adoc'],
	    contains: [
	      // block comment
	      hljs.COMMENT(
	        '^/{4,}\\n',
	        '\\n/{4,}$',
	        // can also be done as...
	        //'^/{4,}$',
	        //'^/{4,}$',
	        {
	          relevance: 10
	        }
	      ),
	      // line comment
	      hljs.COMMENT(
	        '^//',
	        '$',
	        {
	          relevance: 0
	        }
	      ),
	      // title
	      {
	        className: 'title',
	        begin: '^\\.\\w.*$'
	      },
	      // example, admonition & sidebar blocks
	      {
	        begin: '^[=\\*]{4,}\\n',
	        end: '\\n^[=\\*]{4,}$',
	        relevance: 10
	      },
	      // headings
	      {
	        className: 'section',
	        relevance: 10,
	        variants: [
	          {begin: '^(={1,5}) .+?( \\1)?$'},
	          {begin: '^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$'},
	        ]
	      },
	      // document attributes
	      {
	        className: 'meta',
	        begin: '^:.+?:',
	        end: '\\s',
	        excludeEnd: true,
	        relevance: 10
	      },
	      // block attributes
	      {
	        className: 'meta',
	        begin: '^\\[.+?\\]$',
	        relevance: 0
	      },
	      // quoteblocks
	      {
	        className: 'quote',
	        begin: '^_{4,}\\n',
	        end: '\\n_{4,}$',
	        relevance: 10
	      },
	      // listing and literal blocks
	      {
	        className: 'code',
	        begin: '^[\\-\\.]{4,}\\n',
	        end: '\\n[\\-\\.]{4,}$',
	        relevance: 10
	      },
	      // passthrough blocks
	      {
	        begin: '^\\+{4,}\\n',
	        end: '\\n\\+{4,}$',
	        contains: [
	          {
	            begin: '<', end: '>',
	            subLanguage: 'xml',
	            relevance: 0
	          }
	        ],
	        relevance: 10
	      },
	      // lists (can only capture indicators)
	      {
	        className: 'bullet',
	        begin: '^(\\*+|\\-+|\\.+|[^\\n]+?::)\\s+'
	      },
	      // admonition
	      {
	        className: 'symbol',
	        begin: '^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+',
	        relevance: 10
	      },
	      // inline strong
	      {
	        className: 'strong',
	        // must not follow a word character or be followed by an asterisk or space
	        begin: '\\B\\*(?![\\*\\s])',
	        end: '(\\n{2}|\\*)',
	        // allow escaped asterisk followed by word char
	        contains: [
	          {
	            begin: '\\\\*\\w',
	            relevance: 0
	          }
	        ]
	      },
	      // inline emphasis
	      {
	        className: 'emphasis',
	        // must not follow a word character or be followed by a single quote or space
	        begin: '\\B\'(?![\'\\s])',
	        end: '(\\n{2}|\')',
	        // allow escaped single quote followed by word char
	        contains: [
	          {
	            begin: '\\\\\'\\w',
	            relevance: 0
	          }
	        ],
	        relevance: 0
	      },
	      // inline emphasis (alt)
	      {
	        className: 'emphasis',
	        // must not follow a word character or be followed by an underline or space
	        begin: '_(?![_\\s])',
	        end: '(\\n{2}|_)',
	        relevance: 0
	      },
	      // inline smart quotes
	      {
	        className: 'string',
	        variants: [
	          {begin: "``.+?''"},
	          {begin: "`.+?'"}
	        ]
	      },
	      // inline code snippets (TODO should get same treatment as strong and emphasis)
	      {
	        className: 'code',
	        begin: '(`.+?`|\\+.+?\\+)',
	        relevance: 0
	      },
	      // indented literal block
	      {
	        className: 'code',
	        begin: '^[ \\t]',
	        end: '$',
	        relevance: 0
	      },
	      // horizontal rules
	      {
	        begin: '^\'{3,}[ \\t]*$',
	        relevance: 10
	      },
	      // images and links
	      {
	        begin: '(link:)?(http|https|ftp|file|irc|image:?):\\S+\\[.*?\\]',
	        returnBegin: true,
	        contains: [
	          {
	            begin: '(link|image:?):',
	            relevance: 0
	          },
	          {
	            className: 'link',
	            begin: '\\w',
	            end: '[^\\[]+',
	            relevance: 0
	          },
	          {
	            className: 'string',
	            begin: '\\[',
	            end: '\\]',
	            excludeBegin: true,
	            excludeEnd: true,
	            relevance: 0
	          }
	        ],
	        relevance: 10
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/aspectj.js":
/***/ (function(module, exports) {

	module.exports = function (hljs) {
	  var KEYWORDS =
	    'false synchronized int abstract float private char boolean static null if const ' +
	    'for true while long throw strictfp finally protected import native final return void ' +
	    'enum else extends implements break transient new catch instanceof byte super volatile case ' +
	    'assert short package default double public try this switch continue throws privileged ' +
	    'aspectOf adviceexecution proceed cflowbelow cflow initialization preinitialization ' +
	    'staticinitialization withincode target within execution getWithinTypeName handler ' +
	    'thisJoinPoint thisJoinPointStaticPart thisEnclosingJoinPointStaticPart declare parents '+
	    'warning error soft precedence thisAspectInstance';
	  var SHORTKEYS = 'get set args call';
	  return {
	    keywords : KEYWORDS,
	    illegal : /<\/|#/,
	    contains : [
	      hljs.COMMENT(
	        '/\\*\\*',
	        '\\*/',
	        {
	          relevance : 0,
	          contains : [
	            {
	              // eat up @'s in emails to prevent them to be recognized as doctags
	              begin: /\w+@/, relevance: 0
	            },
	            {
	              className : 'doctag',
	              begin : '@[A-Za-z]+'
	            }
	          ]
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className : 'class',
	        beginKeywords : 'aspect',
	        end : /[{;=]/,
	        excludeEnd : true,
	        illegal : /[:;"\[\]]/,
	        contains : [
	          {
	            beginKeywords : 'extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton'
	          },
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            begin : /\([^\)]*/,
	            end : /[)]+/,
	            keywords : KEYWORDS + ' ' + SHORTKEYS,
	            excludeEnd : false
	          }
	        ]
	      },
	      {
	        className : 'class',
	        beginKeywords : 'class interface',
	        end : /[{;=]/,
	        excludeEnd : true,
	        relevance: 0,
	        keywords : 'class interface',
	        illegal : /[:"\[\]]/,
	        contains : [
	          {beginKeywords : 'extends implements'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        // AspectJ Constructs
	        beginKeywords : 'pointcut after before around throwing returning',
	        end : /[)]/,
	        excludeEnd : false,
	        illegal : /["\[\]]/,
	        contains : [
	          {
	            begin : hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
	            returnBegin : true,
	            contains : [hljs.UNDERSCORE_TITLE_MODE]
	          }
	        ]
	      },
	      {
	        begin : /[:]/,
	        returnBegin : true,
	        end : /[{;]/,
	        relevance: 0,
	        excludeEnd : false,
	        keywords : KEYWORDS,
	        illegal : /["\[\]]/,
	        contains : [
	          {
	            begin : hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
	            keywords : KEYWORDS + ' ' + SHORTKEYS,
	            relevance: 0
	          },
	          hljs.QUOTE_STRING_MODE
	        ]
	      },
	      {
	        // this prevents 'new Name(...), or throw ...' from being recognized as a function definition
	        beginKeywords : 'new throw',
	        relevance : 0
	      },
	      {
	        // the function class is a bit different for AspectJ compared to the Java language
	        className : 'function',
	        begin : /\w+ +\w+(\.)?\w+\s*\([^\)]*\)\s*((throws)[\w\s,]+)?[\{;]/,
	        returnBegin : true,
	        end : /[{;=]/,
	        keywords : KEYWORDS,
	        excludeEnd : true,
	        contains : [
	          {
	            begin : hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
	            returnBegin : true,
	            relevance: 0,
	            contains : [hljs.UNDERSCORE_TITLE_MODE]
	          },
	          {
	            className : 'params',
	            begin : /\(/, end : /\)/,
	            relevance: 0,
	            keywords : KEYWORDS,
	            contains : [
	              hljs.APOS_STRING_MODE,
	              hljs.QUOTE_STRING_MODE,
	              hljs.C_NUMBER_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      hljs.C_NUMBER_MODE,
	      {
	        // annotation is also used in this language
	        className : 'meta',
	        begin : '@[A-Za-z]+'
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/autohotkey.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var BACKTICK_ESCAPE = {
	    begin: '`[\\s\\S]'
	  };
	
	  return {
	    case_insensitive: true,
	    aliases: [ 'ahk' ],
	    keywords: {
	      keyword: 'Break Continue Critical Exit ExitApp Gosub Goto New OnExit Pause return SetBatchLines SetTimer Suspend Thread Throw Until ahk_id ahk_class ahk_pid ahk_exe ahk_group',
	      literal: 'A|0 true false NOT AND OR',
	      built_in: 'ComSpec Clipboard ClipboardAll ErrorLevel',
	    },
	    contains: [
	      {
	        className: 'built_in',
	        begin: 'A_[a-zA-Z0-9]+'
	      },
	      BACKTICK_ESCAPE,
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [BACKTICK_ESCAPE]}),
	      hljs.COMMENT(';', '$', {relevance: 0}),
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'number',
	        begin: hljs.NUMBER_RE,
	        relevance: 0
	      },
	      {
	        className: 'subst', // FIXED
	        begin: '%(?=[a-zA-Z0-9#_$@])', end: '%',
	        illegal: '[^a-zA-Z0-9#_$@]'
	      },
	      {
	        className: 'built_in',
	        begin: '^\\s*\\w+\\s*,'
	        //I don't really know if this is totally relevant
	      },
	      {
	        className: 'meta', 
	        begin: '^\\s*#\w+', end:'$',
	        relevance: 0
	      },
	      {
	        className: 'symbol',
	        contains: [BACKTICK_ESCAPE],
	        variants: [
	          {begin: '^[^\\n";]+::(?!=)'},
	          {begin: '^[^\\n";]+:(?!=)', relevance: 0} // zero relevance as it catches a lot of things
	                                                    // followed by a single ':' in many languages
	        ]
	      },
	      {
	        // consecutive commas, not for highlighting but just for relevance
	        begin: ',\\s*,'
	      }
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/autoit.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    var KEYWORDS = 'ByRef Case Const ContinueCase ContinueLoop ' +
	        'Default Dim Do Else ElseIf EndFunc EndIf EndSelect ' +
	        'EndSwitch EndWith Enum Exit ExitLoop For Func ' +
	        'Global If In Local Next ReDim Return Select Static ' +
	        'Step Switch Then To Until Volatile WEnd While With',
	
	        LITERAL = 'True False And Null Not Or',
	
	        BUILT_IN =
	          'Abs ACos AdlibRegister AdlibUnRegister Asc AscW ASin Assign ATan AutoItSetOption AutoItWinGetTitle AutoItWinSetTitle Beep Binary BinaryLen BinaryMid BinaryToString BitAND BitNOT BitOR BitRotate BitShift BitXOR BlockInput Break Call CDTray Ceiling Chr ChrW ClipGet ClipPut ConsoleRead ConsoleWrite ConsoleWriteError ControlClick ControlCommand ControlDisable ControlEnable ControlFocus ControlGetFocus ControlGetHandle ControlGetPos ControlGetText ControlHide ControlListView ControlMove ControlSend ControlSetText ControlShow ControlTreeView Cos Dec DirCopy DirCreate DirGetSize DirMove DirRemove DllCall DllCallAddress DllCallbackFree DllCallbackGetPtr DllCallbackRegister DllClose DllOpen DllStructCreate DllStructGetData DllStructGetPtr DllStructGetSize DllStructSetData DriveGetDrive DriveGetFileSystem DriveGetLabel DriveGetSerial DriveGetType DriveMapAdd DriveMapDel DriveMapGet DriveSetLabel DriveSpaceFree DriveSpaceTotal DriveStatus EnvGet EnvSet EnvUpdate Eval Execute Exp FileChangeDir FileClose FileCopy FileCreateNTFSLink FileCreateShortcut FileDelete FileExists FileFindFirstFile FileFindNextFile FileFlush FileGetAttrib FileGetEncoding FileGetLongName FileGetPos FileGetShortcut FileGetShortName FileGetSize FileGetTime FileGetVersion FileInstall FileMove FileOpen FileOpenDialog FileRead FileReadLine FileReadToArray FileRecycle FileRecycleEmpty FileSaveDialog FileSelectFolder FileSetAttrib FileSetEnd FileSetPos FileSetTime FileWrite FileWriteLine Floor FtpSetProxy FuncName GUICreate GUICtrlCreateAvi GUICtrlCreateButton GUICtrlCreateCheckbox GUICtrlCreateCombo GUICtrlCreateContextMenu GUICtrlCreateDate GUICtrlCreateDummy GUICtrlCreateEdit GUICtrlCreateGraphic GUICtrlCreateGroup GUICtrlCreateIcon GUICtrlCreateInput GUICtrlCreateLabel GUICtrlCreateList GUICtrlCreateListView GUICtrlCreateListViewItem GUICtrlCreateMenu GUICtrlCreateMenuItem GUICtrlCreateMonthCal GUICtrlCreateObj GUICtrlCreatePic GUICtrlCreateProgress GUICtrlCreateRadio GUICtrlCreateSlider GUICtrlCreateTab GUICtrlCreateTabItem GUICtrlCreateTreeView GUICtrlCreateTreeViewItem GUICtrlCreateUpdown GUICtrlDelete GUICtrlGetHandle GUICtrlGetState GUICtrlRead GUICtrlRecvMsg GUICtrlRegisterListViewSort GUICtrlSendMsg GUICtrlSendToDummy GUICtrlSetBkColor GUICtrlSetColor GUICtrlSetCursor GUICtrlSetData GUICtrlSetDefBkColor GUICtrlSetDefColor GUICtrlSetFont GUICtrlSetGraphic GUICtrlSetImage GUICtrlSetLimit GUICtrlSetOnEvent GUICtrlSetPos GUICtrlSetResizing GUICtrlSetState GUICtrlSetStyle GUICtrlSetTip GUIDelete GUIGetCursorInfo GUIGetMsg GUIGetStyle GUIRegisterMsg GUISetAccelerators GUISetBkColor GUISetCoord GUISetCursor GUISetFont GUISetHelp GUISetIcon GUISetOnEvent GUISetState GUISetStyle GUIStartGroup GUISwitch Hex HotKeySet HttpSetProxy HttpSetUserAgent HWnd InetClose InetGet InetGetInfo InetGetSize InetRead IniDelete IniRead IniReadSection IniReadSectionNames IniRenameSection IniWrite IniWriteSection InputBox Int IsAdmin IsArray IsBinary IsBool IsDeclared IsDllStruct IsFloat IsFunc IsHWnd IsInt IsKeyword IsNumber IsObj IsPtr IsString Log MemGetStats Mod MouseClick MouseClickDrag MouseDown MouseGetCursor MouseGetPos MouseMove MouseUp MouseWheel MsgBox Number ObjCreate ObjCreateInterface ObjEvent ObjGet ObjName OnAutoItExitRegister OnAutoItExitUnRegister Ping PixelChecksum PixelGetColor PixelSearch ProcessClose ProcessExists ProcessGetStats ProcessList ProcessSetPriority ProcessWait ProcessWaitClose ProgressOff ProgressOn ProgressSet Ptr Random RegDelete RegEnumKey RegEnumVal RegRead RegWrite Round Run RunAs RunAsWait RunWait Send SendKeepActive SetError SetExtended ShellExecute ShellExecuteWait Shutdown Sin Sleep SoundPlay SoundSetWaveVolume SplashImageOn SplashOff SplashTextOn Sqrt SRandom StatusbarGetText StderrRead StdinWrite StdioClose StdoutRead String StringAddCR StringCompare StringFormat StringFromASCIIArray StringInStr StringIsAlNum StringIsAlpha StringIsASCII StringIsDigit StringIsFloat StringIsInt StringIsLower StringIsSpace StringIsUpper StringIsXDigit StringLeft StringLen StringLower StringMid StringRegExp StringRegExpReplace StringReplace StringReverse StringRight StringSplit StringStripCR StringStripWS StringToASCIIArray StringToBinary StringTrimLeft StringTrimRight StringUpper Tan TCPAccept TCPCloseSocket TCPConnect TCPListen TCPNameToIP TCPRecv TCPSend TCPShutdown, UDPShutdown TCPStartup, UDPStartup TimerDiff TimerInit ToolTip TrayCreateItem TrayCreateMenu TrayGetMsg TrayItemDelete TrayItemGetHandle TrayItemGetState TrayItemGetText TrayItemSetOnEvent TrayItemSetState TrayItemSetText TraySetClick TraySetIcon TraySetOnEvent TraySetPauseIcon TraySetState TraySetToolTip TrayTip UBound UDPBind UDPCloseSocket UDPOpen UDPRecv UDPSend VarGetType WinActivate WinActive WinClose WinExists WinFlash WinGetCaretPos WinGetClassList WinGetClientSize WinGetHandle WinGetPos WinGetProcess WinGetState WinGetText WinGetTitle WinKill WinList WinMenuSelectItem WinMinimizeAll WinMinimizeAllUndo WinMove WinSetOnTop WinSetState WinSetTitle WinSetTrans WinWait',
	
	        COMMENT = {
	            variants: [
	              hljs.COMMENT(';', '$', {relevance: 0}),
	              hljs.COMMENT('#cs', '#ce'),
	              hljs.COMMENT('#comments-start', '#comments-end')
	            ]
	        },
	
	        VARIABLE = {
	            begin: '\\$[A-z0-9_]+'
	        },
	
	        STRING = {
	            className: 'string',
	            variants: [{
	                begin: /"/,
	                end: /"/,
	                contains: [{
	                    begin: /""/,
	                    relevance: 0
	                }]
	            }, {
	                begin: /'/,
	                end: /'/,
	                contains: [{
	                    begin: /''/,
	                    relevance: 0
	                }]
	            }]
	        },
	
	        NUMBER = {
	            variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]
	        },
	
	        PREPROCESSOR = {
	            className: 'meta',
	            begin: '#',
	            end: '$',
	            keywords: {'meta-keyword': 'comments include include-once NoTrayIcon OnAutoItStartRegister pragma compile RequireAdmin'},
	            contains: [{
	                    begin: /\\\n/,
	                    relevance: 0
	                }, {
	                    beginKeywords: 'include',
	                    keywords: {'meta-keyword': 'include'},
	                    end: '$',
	                    contains: [
	                        STRING, {
	                            className: 'meta-string',
	                            variants: [{
	                                begin: '<',
	                                end: '>'
	                            }, {
	                                begin: /"/,
	                                end: /"/,
	                                contains: [{
	                                    begin: /""/,
	                                    relevance: 0
	                                }]
	                            }, {
	                                begin: /'/,
	                                end: /'/,
	                                contains: [{
	                                    begin: /''/,
	                                    relevance: 0
	                                }]
	                            }]
	                        }
	                    ]
	                },
	                STRING,
	                COMMENT
	            ]
	        },
	
	        CONSTANT = {
	            className: 'symbol',
	            // begin: '@',
	            // end: '$',
	            // keywords: 'AppDataCommonDir AppDataDir AutoItExe AutoItPID AutoItVersion AutoItX64 COM_EventObj CommonFilesDir Compiled ComputerName ComSpec CPUArch CR CRLF DesktopCommonDir DesktopDepth DesktopDir DesktopHeight DesktopRefresh DesktopWidth DocumentsCommonDir error exitCode exitMethod extended FavoritesCommonDir FavoritesDir GUI_CtrlHandle GUI_CtrlId GUI_DragFile GUI_DragId GUI_DropId GUI_WinHandle HomeDrive HomePath HomeShare HotKeyPressed HOUR IPAddress1 IPAddress2 IPAddress3 IPAddress4 KBLayout LF LocalAppDataDir LogonDNSDomain LogonDomain LogonServer MDAY MIN MON MSEC MUILang MyDocumentsDir NumParams OSArch OSBuild OSLang OSServicePack OSType OSVersion ProgramFilesDir ProgramsCommonDir ProgramsDir ScriptDir ScriptFullPath ScriptLineNumber ScriptName SEC StartMenuCommonDir StartMenuDir StartupCommonDir StartupDir SW_DISABLE SW_ENABLE SW_HIDE SW_LOCK SW_MAXIMIZE SW_MINIMIZE SW_RESTORE SW_SHOW SW_SHOWDEFAULT SW_SHOWMAXIMIZED SW_SHOWMINIMIZED SW_SHOWMINNOACTIVE SW_SHOWNA SW_SHOWNOACTIVATE SW_SHOWNORMAL SW_UNLOCK SystemDir TAB TempDir TRAY_ID TrayIconFlashing TrayIconVisible UserName UserProfileDir WDAY WindowsDir WorkingDir YDAY YEAR',
	            // relevance: 5
	            begin: '@[A-z0-9_]+'
	        },
	
	        FUNCTION = {
	            className: 'function',
	            beginKeywords: 'Func',
	            end: '$',
	            illegal: '\\$|\\[|%',
	            contains: [
	                hljs.UNDERSCORE_TITLE_MODE, {
	                    className: 'params',
	                    begin: '\\(',
	                    end: '\\)',
	                    contains: [
	                        VARIABLE,
	                        STRING,
	                        NUMBER
	                    ]
	                }
	            ]
	        };
	
	    return {
	        case_insensitive: true,
	        illegal: /\/\*/,
	        keywords: {
	            keyword: KEYWORDS,
	            built_in: BUILT_IN,
	            literal: LITERAL
	        },
	        contains: [
	            COMMENT,
	            VARIABLE,
	            STRING,
	            NUMBER,
	            PREPROCESSOR,
	            CONSTANT,
	            FUNCTION
	        ]
	    }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/avrasm.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    case_insensitive: true,
	    lexemes: '\\.?' + hljs.IDENT_RE,
	    keywords: {
	      keyword:
	        /* mnemonic */
	        'adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs ' +
	        'brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr ' +
	        'clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor ' +
	        'fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul ' +
	        'muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs ' +
	        'sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub ' +
	        'subi swap tst wdr',
	      built_in:
	        /* general purpose registers */
	        'r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 ' +
	        'r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ' +
	        /* IO Registers (ATMega128) */
	        'ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h ' +
	        'tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ' +
	        'ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ' +
	        'ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk ' +
	        'tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ' +
	        'ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr ' +
	        'porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ' +
	        'ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf',
	      meta:
	        '.byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list ' +
	        '.listmac .macro .nolist .org .set'
	    },
	    contains: [
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.COMMENT(
	        ';',
	        '$',
	        {
	          relevance: 0
	        }
	      ),
	      hljs.C_NUMBER_MODE, // 0x..., decimal, float
	      hljs.BINARY_NUMBER_MODE, // 0b...
	      {
	        className: 'number',
	        begin: '\\b(\\$[a-zA-Z0-9]+|0o[0-7]+)' // $..., 0o...
	      },
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: '\'', end: '[^\\\\]\'',
	        illegal: '[^\\\\][^\']'
	      },
	      {className: 'symbol',  begin: '^[A-Za-z0-9_.$]+:'},
	      {className: 'meta', begin: '#', end: '$'},
	      {  // подстановка в «.macro»
	        className: 'subst',
	        begin: '@[0-9]+'
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/awk.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VARIABLE = {
	    className: 'variable',
	    variants: [
	      {begin: /\$[\w\d#@][\w\d_]*/},
	      {begin: /\$\{(.*?)}/}
	    ]
	  };
	  var KEYWORDS = 'BEGIN END if else while do for in break continue delete next nextfile function func exit|10';
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE],
	    variants: [
	      {
	        begin: /(u|b)?r?'''/, end: /'''/,
	        relevance: 10
	      },
	      {
	        begin: /(u|b)?r?"""/, end: /"""/,
	        relevance: 10
	      },
	      {
	        begin: /(u|r|ur)'/, end: /'/,
	        relevance: 10
	      },
	      {
	        begin: /(u|r|ur)"/, end: /"/,
	        relevance: 10
	      },
	      {
	        begin: /(b|br)'/, end: /'/
	      },
	      {
	        begin: /(b|br)"/, end: /"/
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE
	    ]
	  };
	  return {
		 keywords: {
		   keyword: KEYWORDS
	    },
	    contains: [
	      VARIABLE,
	      STRING,
	      hljs.REGEXP_MODE,
	      hljs.HASH_COMMENT_MODE,
	      hljs.NUMBER_MODE
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/axapta.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: 'false int abstract private char boolean static null if for true ' +
	      'while long throw finally protected final return void enum else ' +
	      'break new catch byte super case short default double public try this switch ' +
	      'continue reverse firstfast firstonly forupdate nofetch sum avg minof maxof count ' +
	      'order group by asc desc index hint like dispaly edit client server ttsbegin ' +
	      'ttscommit str real date container anytype common div mod',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'meta',
	        begin: '#', end: '$'
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        illegal: ':',
	        contains: [
	          {beginKeywords: 'extends implements'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/bash.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VAR = {
	    className: 'variable',
	    variants: [
	      {begin: /\$[\w\d#@][\w\d_]*/},
	      {begin: /\$\{(.*?)}/}
	    ]
	  };
	  var QUOTE_STRING = {
	    className: 'string',
	    begin: /"/, end: /"/,
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      VAR,
	      {
	        className: 'variable',
	        begin: /\$\(/, end: /\)/,
	        contains: [hljs.BACKSLASH_ESCAPE]
	      }
	    ]
	  };
	  var APOS_STRING = {
	    className: 'string',
	    begin: /'/, end: /'/
	  };
	
	  return {
	    aliases: ['sh', 'zsh'],
	    lexemes: /\b-?[a-z\._]+\b/,
	    keywords: {
	      keyword:
	        'if then else elif fi for while in do done case esac function',
	      literal:
	        'true false',
	      built_in:
	        // Shell built-ins
	        // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
	        'break cd continue eval exec exit export getopts hash pwd readonly return shift test times ' +
	        'trap umask unset ' +
	        // Bash built-ins
	        'alias bind builtin caller command declare echo enable help let local logout mapfile printf ' +
	        'read readarray source type typeset ulimit unalias ' +
	        // Shell modifiers
	        'set shopt ' +
	        // Zsh built-ins
	        'autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles ' +
	        'compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate ' +
	        'fc fg float functions getcap getln history integer jobs kill limit log noglob popd print ' +
	        'pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit ' +
	        'unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof ' +
	        'zpty zregexparse zsocket zstyle ztcp',
	      _:
	        '-ne -eq -lt -gt -f -d -e -s -l -a' // relevance booster
	    },
	    contains: [
	      {
	        className: 'meta',
	        begin: /^#![^\n]+sh\s*$/,
	        relevance: 10
	      },
	      {
	        className: 'function',
	        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
	        returnBegin: true,
	        contains: [hljs.inherit(hljs.TITLE_MODE, {begin: /\w[\w\d_]*/})],
	        relevance: 0
	      },
	      hljs.HASH_COMMENT_MODE,
	      QUOTE_STRING,
	      APOS_STRING,
	      VAR
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/basic.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    case_insensitive: true,
	    illegal: '^\.',
	    // Support explicitely typed variables that end with $%! or #.
	    lexemes: '[a-zA-Z][a-zA-Z0-9_\$\%\!\#]*',
	    keywords: {
	        keyword:
	          'ABS ASC AND ATN AUTO|0 BEEP BLOAD|10 BSAVE|10 CALL CALLS CDBL CHAIN CHDIR CHR$|10 CINT CIRCLE ' +
	          'CLEAR CLOSE CLS COLOR COM COMMON CONT COS CSNG CSRLIN CVD CVI CVS DATA DATE$ ' +
	          'DEFDBL DEFINT DEFSNG DEFSTR DEF|0 SEG USR DELETE DIM DRAW EDIT END ENVIRON ENVIRON$ ' +
	          'EOF EQV ERASE ERDEV ERDEV$ ERL ERR ERROR EXP FIELD FILES FIX FOR|0 FRE GET GOSUB|10 GOTO ' +
	          'HEX$ IF|0 THEN ELSE|0 INKEY$ INP INPUT INPUT# INPUT$ INSTR IMP INT IOCTL IOCTL$ KEY ON ' +
	          'OFF LIST KILL LEFT$ LEN LET LINE LLIST LOAD LOC LOCATE LOF LOG LPRINT USING LSET ' +
	          'MERGE MID$ MKDIR MKD$ MKI$ MKS$ MOD NAME NEW NEXT NOISE NOT OCT$ ON OR PEN PLAY STRIG OPEN OPTION ' +
	          'BASE OUT PAINT PALETTE PCOPY PEEK PMAP POINT POKE POS PRINT PRINT] PSET PRESET ' +
	          'PUT RANDOMIZE READ REM RENUM RESET|0 RESTORE RESUME RETURN|0 RIGHT$ RMDIR RND RSET ' +
	          'RUN SAVE SCREEN SGN SHELL SIN SOUND SPACE$ SPC SQR STEP STICK STOP STR$ STRING$ SWAP ' +
	          'SYSTEM TAB TAN TIME$ TIMER TROFF TRON TO USR VAL VARPTR VARPTR$ VIEW WAIT WHILE ' +
	          'WEND WIDTH WINDOW WRITE XOR'
	    },
	    contains: [
	      hljs.QUOTE_STRING_MODE,
	      hljs.COMMENT('REM', '$', {relevance: 10}),
	      hljs.COMMENT('\'', '$', {relevance: 0}),
	      {
	        // Match line numbers
	        className: 'symbol',
	        begin: '^[0-9]+\ ',
	        relevance: 10
	      },
	      {
	        // Match typed numeric constants (1000, 12.34!, 1.2e5, 1.5#, 1.2D2)
	        className: 'number',
	        begin: '\\b([0-9]+[0-9edED\.]*[#\!]?)',
	        relevance: 0
	      },
	      {
	        // Match hexadecimal numbers (&Hxxxx)
	        className: 'number',
	        begin: '(\&[hH][0-9a-fA-F]{1,4})'
	      },
	      {
	        // Match octal numbers (&Oxxxxxx)
	        className: 'number',
	        begin: '(\&[oO][0-7]{1,6})'
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/bnf.js":
/***/ (function(module, exports) {

	module.exports = function(hljs){
	  return {
	    contains: [
	      // Attribute
	      {
	        className: 'attribute',
	        begin: /</, end: />/
	      },
	      // Specific
	      {
	        begin: /::=/,
	        starts: {
	          end: /$/,
	          contains: [
	            {
	              begin: /</, end: />/
	            },
	            // Common
	            hljs.C_LINE_COMMENT_MODE,
	            hljs.C_BLOCK_COMMENT_MODE,
	            hljs.APOS_STRING_MODE,
	            hljs.QUOTE_STRING_MODE
	          ]
	        }
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/brainfuck.js":
/***/ (function(module, exports) {

	module.exports = function(hljs){
	  var LITERAL = {
	    className: 'literal',
	    begin: '[\\+\\-]',
	    relevance: 0
	  };
	  return {
	    aliases: ['bf'],
	    contains: [
	      hljs.COMMENT(
	        '[^\\[\\]\\.,\\+\\-<> \r\n]',
	        '[\\[\\]\\.,\\+\\-<> \r\n]',
	        {
	          returnEnd: true,
	          relevance: 0
	        }
	      ),
	      {
	        className: 'title',
	        begin: '[\\[\\]]',
	        relevance: 0
	      },
	      {
	        className: 'string',
	        begin: '[\\.,]',
	        relevance: 0
	      },
	      {
	        // this mode works as the only relevance counter
	        begin: /\+\+|\-\-/, returnBegin: true,
	        contains: [LITERAL]
	      },
	      LITERAL
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/cal.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS =
	    'div mod in and or not xor asserterror begin case do downto else end exit for if of repeat then to ' +
	    'until while with var';
	  var LITERALS = 'false true';
	  var COMMENT_MODES = [
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.COMMENT(
	      /\{/,
	      /\}/,
	      {
	        relevance: 0
	      }
	    ),
	    hljs.COMMENT(
	      /\(\*/,
	      /\*\)/,
	      {
	        relevance: 10
	      }
	    )
	  ];
	  var STRING = {
	    className: 'string',
	    begin: /'/, end: /'/,
	    contains: [{begin: /''/}]
	  };
	  var CHAR_STRING = {
	    className: 'string', begin: /(#\d+)+/
	  };
	  var DATE = {
	      className: 'number',
	      begin: '\\b\\d+(\\.\\d+)?(DT|D|T)',
	      relevance: 0
	  };
	  var DBL_QUOTED_VARIABLE = {
	      className: 'string', // not a string technically but makes sense to be highlighted in the same style
	      begin: '"',
	      end: '"'
	  };
	
	  var PROCEDURE = {
	    className: 'function',
	    beginKeywords: 'procedure', end: /[:;]/,
	    keywords: 'procedure|10',
	    contains: [
	      hljs.TITLE_MODE,
	      {
	        className: 'params',
	        begin: /\(/, end: /\)/,
	        keywords: KEYWORDS,
	        contains: [STRING, CHAR_STRING]
	      }
	    ].concat(COMMENT_MODES)
	  };
	
	  var OBJECT = {
	    className: 'class',
	    begin: 'OBJECT (Table|Form|Report|Dataport|Codeunit|XMLport|MenuSuite|Page|Query) (\\d+) ([^\\r\\n]+)',
	    returnBegin: true,
	    contains: [
	      hljs.TITLE_MODE,
	        PROCEDURE
	    ]
	  };
	
	  return {
	    case_insensitive: true,
	    keywords: { keyword: KEYWORDS, literal: LITERALS },
	    illegal: /\/\*/,
	    contains: [
	      STRING, CHAR_STRING,
	      DATE, DBL_QUOTED_VARIABLE,
	      hljs.NUMBER_MODE,
	      OBJECT,
	      PROCEDURE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/capnproto.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['capnp'],
	    keywords: {
	      keyword:
	        'struct enum interface union group import using const annotation extends in of on as with from fixed',
	      built_in:
	        'Void Bool Int8 Int16 Int32 Int64 UInt8 UInt16 UInt32 UInt64 Float32 Float64 ' +
	        'Text Data AnyPointer AnyStruct Capability List',
	      literal:
	        'true false'
	    },
	    contains: [
	      hljs.QUOTE_STRING_MODE,
	      hljs.NUMBER_MODE,
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'meta',
	        begin: /@0x[\w\d]{16};/,
	        illegal: /\n/
	      },
	      {
	        className: 'symbol',
	        begin: /@\d+\b/
	      },
	      {
	        className: 'class',
	        beginKeywords: 'struct enum', end: /\{/,
	        illegal: /\n/,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {
	            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
	          })
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'interface', end: /\{/,
	        illegal: /\n/,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {
	            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
	          })
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/ceylon.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  // 2.3. Identifiers and keywords
	  var KEYWORDS =
	    'assembly module package import alias class interface object given value ' +
	    'assign void function new of extends satisfies abstracts in out return ' +
	    'break continue throw assert dynamic if else switch case for while try ' +
	    'catch finally then let this outer super is exists nonempty';
	  // 7.4.1 Declaration Modifiers
	  var DECLARATION_MODIFIERS =
	    'shared abstract formal default actual variable late native deprecated' +
	    'final sealed annotation suppressWarnings small';
	  // 7.4.2 Documentation
	  var DOCUMENTATION =
	    'doc by license see throws tagged';
	  var SUBST = {
	    className: 'subst', excludeBegin: true, excludeEnd: true,
	    begin: /``/, end: /``/,
	    keywords: KEYWORDS,
	    relevance: 10
	  };
	  var EXPRESSIONS = [
	    {
	      // verbatim string
	      className: 'string',
	      begin: '"""',
	      end: '"""',
	      relevance: 10
	    },
	    {
	      // string literal or template
	      className: 'string',
	      begin: '"', end: '"',
	      contains: [SUBST]
	    },
	    {
	      // character literal
	      className: 'string',
	      begin: "'",
	      end: "'"
	    },
	    {
	      // numeric literal
	      className: 'number',
	      begin: '#[0-9a-fA-F_]+|\\$[01_]+|[0-9_]+(?:\\.[0-9_](?:[eE][+-]?\\d+)?)?[kMGTPmunpf]?',
	      relevance: 0
	    }
	  ];
	  SUBST.contains = EXPRESSIONS;
	
	  return {
	    keywords: {
	      keyword: KEYWORDS + ' ' + DECLARATION_MODIFIERS,
	      meta: DOCUMENTATION
	    },
	    illegal: '\\$[^01]|#[^0-9a-fA-F]',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.COMMENT('/\\*', '\\*/', {contains: ['self']}),
	      {
	        // compiler annotation
	        className: 'meta',
	        begin: '@[a-z]\\w*(?:\\:\"[^\"]*\")?'
	      }
	    ].concat(EXPRESSIONS)
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/clean.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['clean','icl','dcl'],
	    keywords: {
	      keyword:
	        'if let in with where case of class instance otherwise ' +
	        'implementation definition system module from import qualified as ' +
	        'special code inline foreign export ccall stdcall generic derive ' +
	        'infix infixl infixr',
	      literal:
	        'True False'
	    },
	    contains: [
	
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	
	      {begin: '->|<-[|:]?|::|#!?|>>=|\\{\\||\\|\\}|:==|=:|\\.\\.|<>|`'} // relevance booster
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/clojure-repl.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    contains: [
	      {
	        className: 'meta',
	        begin: /^([\w.-]+|\s*#_)=>/,
	        starts: {
	          end: /$/,
	          subLanguage: 'clojure'
	        }
	      }
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/clojure.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var keywords = {
	    'builtin-name':
	      // Clojure keywords
	      'def defonce cond apply if-not if-let if not not= = < > <= >= == + / * - rem '+
	      'quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? '+
	      'set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? '+
	      'class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? '+
	      'string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . '+
	      'inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last '+
	      'drop-while while intern condp case reduced cycle split-at split-with repeat replicate '+
	      'iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext '+
	      'nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends '+
	      'add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler '+
	      'set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter '+
	      'monitor-exit defmacro defn defn- macroexpand macroexpand-1 for dosync and or '+
	      'when when-not when-let comp juxt partial sequence memoize constantly complement identity assert '+
	      'peek pop doto proxy defstruct first rest cons defprotocol cast coll deftype defrecord last butlast '+
	      'sigs reify second ffirst fnext nfirst nnext defmulti defmethod meta with-meta ns in-ns create-ns import '+
	      'refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! '+
	      'assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger '+
	      'bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline '+
	      'flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking '+
	      'assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! '+
	      'reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! '+
	      'new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty '+
	      'hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list '+
	      'disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer '+
	      'chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate '+
	      'unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta '+
	      'lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize'
	   };
	
	  var SYMBOLSTART = 'a-zA-Z_\\-!.?+*=<>&#\'';
	  var SYMBOL_RE = '[' + SYMBOLSTART + '][' + SYMBOLSTART + '0-9/;:]*';
	  var SIMPLE_NUMBER_RE = '[-+]?\\d+(\\.\\d+)?';
	
	  var SYMBOL = {
	    begin: SYMBOL_RE,
	    relevance: 0
	  };
	  var NUMBER = {
	    className: 'number', begin: SIMPLE_NUMBER_RE,
	    relevance: 0
	  };
	  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
	  var COMMENT = hljs.COMMENT(
	    ';',
	    '$',
	    {
	      relevance: 0
	    }
	  );
	  var LITERAL = {
	    className: 'literal',
	    begin: /\b(true|false|nil)\b/
	  };
	  var COLLECTION = {
	    begin: '[\\[\\{]', end: '[\\]\\}]'
	  };
	  var HINT = {
	    className: 'comment',
	    begin: '\\^' + SYMBOL_RE
	  };
	  var HINT_COL = hljs.COMMENT('\\^\\{', '\\}');
	  var KEY = {
	    className: 'symbol',
	    begin: '[:]{1,2}' + SYMBOL_RE
	  };
	  var LIST = {
	    begin: '\\(', end: '\\)'
	  };
	  var BODY = {
	    endsWithParent: true,
	    relevance: 0
	  };
	  var NAME = {
	    keywords: keywords,
	    lexemes: SYMBOL_RE,
	    className: 'name', begin: SYMBOL_RE,
	    starts: BODY
	  };
	  var DEFAULT_CONTAINS = [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL, SYMBOL];
	
	  LIST.contains = [hljs.COMMENT('comment', ''), NAME, BODY];
	  BODY.contains = DEFAULT_CONTAINS;
	  COLLECTION.contains = DEFAULT_CONTAINS;
	  HINT_COL.contains = [COLLECTION];
	
	  return {
	    aliases: ['clj'],
	    illegal: /\S/,
	    contains: [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/cmake.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['cmake.in'],
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'add_custom_command add_custom_target add_definitions add_dependencies ' +
	        'add_executable add_library add_subdirectory add_test aux_source_directory ' +
	        'break build_command cmake_minimum_required cmake_policy configure_file ' +
	        'create_test_sourcelist define_property else elseif enable_language enable_testing ' +
	        'endforeach endfunction endif endmacro endwhile execute_process export find_file ' +
	        'find_library find_package find_path find_program fltk_wrap_ui foreach function ' +
	        'get_cmake_property get_directory_property get_filename_component get_property ' +
	        'get_source_file_property get_target_property get_test_property if include ' +
	        'include_directories include_external_msproject include_regular_expression install ' +
	        'link_directories load_cache load_command macro mark_as_advanced message option ' +
	        'output_required_files project qt_wrap_cpp qt_wrap_ui remove_definitions return ' +
	        'separate_arguments set set_directory_properties set_property ' +
	        'set_source_files_properties set_target_properties set_tests_properties site_name ' +
	        'source_group string target_link_libraries try_compile try_run unset variable_watch ' +
	        'while build_name exec_program export_library_dependencies install_files ' +
	        'install_programs install_targets link_libraries make_directory remove subdir_depends ' +
	        'subdirs use_mangled_mesa utility_source variable_requires write_file ' +
	        'qt5_use_modules qt5_use_package qt5_wrap_cpp on off true false and or ' +
	        'equal less greater strless strgreater strequal matches'
	    },
	    contains: [
	      {
	        className: 'variable',
	        begin: '\\${', end: '}'
	      },
	      hljs.HASH_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.NUMBER_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/coffeescript.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      // JS keywords
	      'in if for while finally new do return else break catch instanceof throw try this ' +
	      'switch continue typeof delete debugger super yield import export from as default await ' +
	      // Coffee keywords
	      'then unless until loop of by when and or is isnt not',
	    literal:
	      // JS literals
	      'true false null undefined ' +
	      // Coffee literals
	      'yes no on off',
	    built_in:
	      'npm require console print module global window document'
	  };
	  var JS_IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
	  var SUBST = {
	    className: 'subst',
	    begin: /#\{/, end: /}/,
	    keywords: KEYWORDS
	  };
	  var EXPRESSIONS = [
	    hljs.BINARY_NUMBER_MODE,
	    hljs.inherit(hljs.C_NUMBER_MODE, {starts: {end: '(\\s*/)?', relevance: 0}}), // a number tries to eat the following slash to prevent treating it as a regexp
	    {
	      className: 'string',
	      variants: [
	        {
	          begin: /'''/, end: /'''/,
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: /'/, end: /'/,
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: /"""/, end: /"""/,
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	        },
	        {
	          begin: /"/, end: /"/,
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	        }
	      ]
	    },
	    {
	      className: 'regexp',
	      variants: [
	        {
	          begin: '///', end: '///',
	          contains: [SUBST, hljs.HASH_COMMENT_MODE]
	        },
	        {
	          begin: '//[gim]*',
	          relevance: 0
	        },
	        {
	          // regex can't start with space to parse x / 2 / 3 as two divisions
	          // regex can't start with *, and it supports an "illegal" in the main mode
	          begin: /\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/
	        }
	      ]
	    },
	    {
	      begin: '@' + JS_IDENT_RE // relevance booster
	    },
	    {
	      subLanguage: 'javascript',
	      excludeBegin: true, excludeEnd: true,
	      variants: [
	        {
	          begin: '```', end: '```',
	        },
	        {
	          begin: '`', end: '`',
	        }
	      ]
	    }
	  ];
	  SUBST.contains = EXPRESSIONS;
	
	  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
	  var PARAMS_RE = '(\\(.*\\))?\\s*\\B[-=]>';
	  var PARAMS = {
	    className: 'params',
	    begin: '\\([^\\(]', returnBegin: true,
	    /* We need another contained nameless mode to not have every nested
	    pair of parens to be called "params" */
	    contains: [{
	      begin: /\(/, end: /\)/,
	      keywords: KEYWORDS,
	      contains: ['self'].concat(EXPRESSIONS)
	    }]
	  };
	
	  return {
	    aliases: ['coffee', 'cson', 'iced'],
	    keywords: KEYWORDS,
	    illegal: /\/\*/,
	    contains: EXPRESSIONS.concat([
	      hljs.COMMENT('###', '###'),
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'function',
	        begin: '^\\s*' + JS_IDENT_RE + '\\s*=\\s*' + PARAMS_RE, end: '[-=]>',
	        returnBegin: true,
	        contains: [TITLE, PARAMS]
	      },
	      {
	        // anonymous function start
	        begin: /[:\(,=]\s*/,
	        relevance: 0,
	        contains: [
	          {
	            className: 'function',
	            begin: PARAMS_RE, end: '[-=]>',
	            returnBegin: true,
	            contains: [PARAMS]
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class',
	        end: '$',
	        illegal: /[:="\[\]]/,
	        contains: [
	          {
	            beginKeywords: 'extends',
	            endsWithParent: true,
	            illegal: /[:="\[\]]/,
	            contains: [TITLE]
	          },
	          TITLE
	        ]
	      },
	      {
	        begin: JS_IDENT_RE + ':', end: ':',
	        returnBegin: true, returnEnd: true,
	        relevance: 0
	      }
	    ])
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/coq.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      keyword:
	        '_ as at cofix else end exists exists2 fix for forall fun if IF in let ' +
	        'match mod Prop return Set then Type using where with ' +
	        'Abort About Add Admit Admitted All Arguments Assumptions Axiom Back BackTo ' +
	        'Backtrack Bind Blacklist Canonical Cd Check Class Classes Close Coercion ' +
	        'Coercions CoFixpoint CoInductive Collection Combined Compute Conjecture ' +
	        'Conjectures Constant constr Constraint Constructors Context Corollary ' +
	        'CreateHintDb Cut Declare Defined Definition Delimit Dependencies Dependent' +
	        'Derive Drop eauto End Equality Eval Example Existential Existentials ' +
	        'Existing Export exporting Extern Extract Extraction Fact Field Fields File ' +
	        'Fixpoint Focus for From Function Functional Generalizable Global Goal Grab ' +
	        'Grammar Graph Guarded Heap Hint HintDb Hints Hypotheses Hypothesis ident ' +
	        'Identity If Immediate Implicit Import Include Inductive Infix Info Initial ' +
	        'Inline Inspect Instance Instances Intro Intros Inversion Inversion_clear ' +
	        'Language Left Lemma Let Libraries Library Load LoadPath Local Locate Ltac ML ' +
	        'Mode Module Modules Monomorphic Morphism Next NoInline Notation Obligation ' +
	        'Obligations Opaque Open Optimize Options Parameter Parameters Parametric ' +
	        'Path Paths pattern Polymorphic Preterm Print Printing Program Projections ' +
	        'Proof Proposition Pwd Qed Quit Rec Record Recursive Redirect Relation Remark ' +
	        'Remove Require Reserved Reset Resolve Restart Rewrite Right Ring Rings Save ' +
	        'Scheme Scope Scopes Script Search SearchAbout SearchHead SearchPattern ' +
	        'SearchRewrite Section Separate Set Setoid Show Solve Sorted Step Strategies ' +
	        'Strategy Structure SubClass Table Tables Tactic Term Test Theorem Time ' +
	        'Timeout Transparent Type Typeclasses Types Undelimit Undo Unfocus Unfocused ' +
	        'Unfold Universe Universes Unset Unshelve using Variable Variables Variant ' +
	        'Verbose Visibility where with',
	      built_in:
	        'abstract absurd admit after apply as assert assumption at auto autorewrite ' +
	        'autounfold before bottom btauto by case case_eq cbn cbv change ' +
	        'classical_left classical_right clear clearbody cofix compare compute ' +
	        'congruence constr_eq constructor contradict contradiction cut cutrewrite ' +
	        'cycle decide decompose dependent destruct destruction dintuition ' +
	        'discriminate discrR do double dtauto eapply eassumption eauto ecase ' +
	        'econstructor edestruct ediscriminate eelim eexact eexists einduction ' +
	        'einjection eleft elim elimtype enough equality erewrite eright ' +
	        'esimplify_eq esplit evar exact exactly_once exfalso exists f_equal fail ' +
	        'field field_simplify field_simplify_eq first firstorder fix fold fourier ' +
	        'functional generalize generalizing gfail give_up has_evar hnf idtac in ' +
	        'induction injection instantiate intro intro_pattern intros intuition ' +
	        'inversion inversion_clear is_evar is_var lapply lazy left lia lra move ' +
	        'native_compute nia nsatz omega once pattern pose progress proof psatz quote ' +
	        'record red refine reflexivity remember rename repeat replace revert ' +
	        'revgoals rewrite rewrite_strat right ring ring_simplify rtauto set ' +
	        'setoid_reflexivity setoid_replace setoid_rewrite setoid_symmetry ' +
	        'setoid_transitivity shelve shelve_unifiable simpl simple simplify_eq solve ' +
	        'specialize split split_Rabs split_Rmult stepl stepr subst sum swap ' +
	        'symmetry tactic tauto time timeout top transitivity trivial try tryif ' +
	        'unfold unify until using vm_compute with'
	    },
	    contains: [
	      hljs.QUOTE_STRING_MODE,
	      hljs.COMMENT('\\(\\*', '\\*\\)'),
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'type',
	        excludeBegin: true,
	        begin: '\\|\\s*',
	        end: '\\w+'
	      },
	      {begin: /[-=]>/} // relevance booster
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/cos.js":
/***/ (function(module, exports) {

	module.exports = function cos (hljs) {
	
	  var STRINGS = {
	    className: 'string',
	    variants: [
	      {
	        begin: '"',
	        end: '"',
	        contains: [{ // escaped
	          begin: "\"\"",
	          relevance: 0
	        }]
	      }
	    ]
	  };
	
	  var NUMBERS = {
	    className: "number",
	    begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)",
	    relevance: 0
	  };
	
	  var COS_KEYWORDS =
	    'property parameter class classmethod clientmethod extends as break ' +
	    'catch close continue do d|0 else elseif for goto halt hang h|0 if job ' +
	    'j|0 kill k|0 lock l|0 merge new open quit q|0 read r|0 return set s|0 ' +
	    'tcommit throw trollback try tstart use view while write w|0 xecute x|0 ' +
	    'zkill znspace zn ztrap zwrite zw zzdump zzwrite print zbreak zinsert ' +
	    'zload zprint zremove zsave zzprint mv mvcall mvcrt mvdim mvprint zquit ' +
	    'zsync ascii';
	
	    // registered function - no need in them due to all functions are highlighted,
	    // but I'll just leave this here.
	
	    //"$bit", "$bitcount",
	    //"$bitfind", "$bitlogic", "$case", "$char", "$classmethod", "$classname",
	    //"$compile", "$data", "$decimal", "$double", "$extract", "$factor",
	    //"$find", "$fnumber", "$get", "$increment", "$inumber", "$isobject",
	    //"$isvaliddouble", "$isvalidnum", "$justify", "$length", "$list",
	    //"$listbuild", "$listdata", "$listfind", "$listfromstring", "$listget",
	    //"$listlength", "$listnext", "$listsame", "$listtostring", "$listvalid",
	    //"$locate", "$match", "$method", "$name", "$nconvert", "$next",
	    //"$normalize", "$now", "$number", "$order", "$parameter", "$piece",
	    //"$prefetchoff", "$prefetchon", "$property", "$qlength", "$qsubscript",
	    //"$query", "$random", "$replace", "$reverse", "$sconvert", "$select",
	    //"$sortbegin", "$sortend", "$stack", "$text", "$translate", "$view",
	    //"$wascii", "$wchar", "$wextract", "$wfind", "$wiswide", "$wlength",
	    //"$wreverse", "$xecute", "$zabs", "$zarccos", "$zarcsin", "$zarctan",
	    //"$zcos", "$zcot", "$zcsc", "$zdate", "$zdateh", "$zdatetime",
	    //"$zdatetimeh", "$zexp", "$zhex", "$zln", "$zlog", "$zpower", "$zsec",
	    //"$zsin", "$zsqr", "$ztan", "$ztime", "$ztimeh", "$zboolean",
	    //"$zconvert", "$zcrc", "$zcyc", "$zdascii", "$zdchar", "$zf",
	    //"$ziswide", "$zlascii", "$zlchar", "$zname", "$zposition", "$zqascii",
	    //"$zqchar", "$zsearch", "$zseek", "$zstrip", "$zwascii", "$zwchar",
	    //"$zwidth", "$zwpack", "$zwbpack", "$zwunpack", "$zwbunpack", "$zzenkaku",
	    //"$change", "$mv", "$mvat", "$mvfmt", "$mvfmts", "$mviconv",
	    //"$mviconvs", "$mvinmat", "$mvlover", "$mvoconv", "$mvoconvs", "$mvraise",
	    //"$mvtrans", "$mvv", "$mvname", "$zbitand", "$zbitcount", "$zbitfind",
	    //"$zbitget", "$zbitlen", "$zbitnot", "$zbitor", "$zbitset", "$zbitstr",
	    //"$zbitxor", "$zincrement", "$znext", "$zorder", "$zprevious", "$zsort",
	    //"device", "$ecode", "$estack", "$etrap", "$halt", "$horolog",
	    //"$io", "$job", "$key", "$namespace", "$principal", "$quit", "$roles",
	    //"$storage", "$system", "$test", "$this", "$tlevel", "$username",
	    //"$x", "$y", "$za", "$zb", "$zchild", "$zeof", "$zeos", "$zerror",
	    //"$zhorolog", "$zio", "$zjob", "$zmode", "$znspace", "$zparent", "$zpi",
	    //"$zpos", "$zreference", "$zstorage", "$ztimestamp", "$ztimezone",
	    //"$ztrap", "$zversion"
	
	  return {
	    case_insensitive: true,
	    aliases: ["cos", "cls"],
	    keywords: COS_KEYWORDS,
	    contains: [
	      NUMBERS,
	      STRINGS,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: "comment",
	        begin: /;/, end: "$",
	        relevance: 0
	      },
	      { // Functions and user-defined functions: write $ztime(60*60*3), $$myFunc(10), $$^Val(1)
	        className: "built_in",
	        begin: /(?:\$\$?|\.\.)\^?[a-zA-Z]+/
	      },
	      { // Macro command: quit $$$OK
	        className: "built_in",
	        begin: /\$\$\$[a-zA-Z]+/
	      },
	      { // Special (global) variables: write %request.Content; Built-in classes: %Library.Integer
	        className: "built_in",
	        begin: /%[a-z]+(?:\.[a-z]+)*/
	      },
	      { // Global variable: set ^globalName = 12 write ^globalName
	        className: "symbol",
	        begin: /\^%?[a-zA-Z][\w]*/
	      },
	      { // Some control constructions: do ##class(Package.ClassName).Method(), ##super()
	        className: "keyword",
	        begin: /##class|##super|#define|#dim/
	      },
	
	      // sub-languages: are not fully supported by hljs by 11/15/2015
	      // left for the future implementation.
	      {
	        begin: /&sql\(/,    end: /\)/,
	        excludeBegin: true, excludeEnd: true,
	        subLanguage: "sql"
	      },
	      {
	        begin: /&(js|jscript|javascript)</, end: />/,
	        excludeBegin: true, excludeEnd: true,
	        subLanguage: "javascript"
	      },
	      {
	        // this brakes first and last tag, but this is the only way to embed a valid html
	        begin: /&html<\s*</, end: />\s*>/,
	        subLanguage: "xml"
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/cpp.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var CPP_PRIMITIVE_TYPES = {
	    className: 'keyword',
	    begin: '\\b[a-z\\d_]*_t\\b'
	  };
	
	  var STRINGS = {
	    className: 'string',
	    variants: [
	      {
	        begin: '(u8?|U)?L?"', end: '"',
	        illegal: '\\n',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        begin: '(u8?|U)?R"', end: '"',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        begin: '\'\\\\?.', end: '\'',
	        illegal: '.'
	      }
	    ]
	  };
	
	  var NUMBERS = {
	    className: 'number',
	    variants: [
	      { begin: '\\b(0b[01\']+)' },
	      { begin: '(-?)\\b([\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)(u|U|l|L|ul|UL|f|F|b|B)' },
	      { begin: '(-?)(\\b0[xX][a-fA-F0-9\']+|(\\b[\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)([eE][-+]?[\\d\']+)?)' }
	    ],
	    relevance: 0
	  };
	
	  var PREPROCESSOR =       {
	    className: 'meta',
	    begin: /#\s*[a-z]+\b/, end: /$/,
	    keywords: {
	      'meta-keyword':
	        'if else elif endif define undef warning error line ' +
	        'pragma ifdef ifndef include'
	    },
	    contains: [
	      {
	        begin: /\\\n/, relevance: 0
	      },
	      hljs.inherit(STRINGS, {className: 'meta-string'}),
	      {
	        className: 'meta-string',
	        begin: /<[^\n>]*>/, end: /$/,
	        illegal: '\\n',
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE
	    ]
	  };
	
	  var FUNCTION_TITLE = hljs.IDENT_RE + '\\s*\\(';
	
	  var CPP_KEYWORDS = {
	    keyword: 'int float while private char catch import module export virtual operator sizeof ' +
	      'dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace ' +
	      'unsigned long volatile static protected bool template mutable if public friend ' +
	      'do goto auto void enum else break extern using asm case typeid ' +
	      'short reinterpret_cast|10 default double register explicit signed typename try this ' +
	      'switch continue inline delete alignof constexpr decltype ' +
	      'noexcept static_assert thread_local restrict _Bool complex _Complex _Imaginary ' +
	      'atomic_bool atomic_char atomic_schar ' +
	      'atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong ' +
	      'atomic_ullong new throw return ' +
	      'and or not',
	    built_in: 'std string cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream ' +
	      'auto_ptr deque list queue stack vector map set bitset multiset multimap unordered_set ' +
	      'unordered_map unordered_multiset unordered_multimap array shared_ptr abort abs acos ' +
	      'asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp ' +
	      'fscanf isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper ' +
	      'isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow ' +
	      'printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp ' +
	      'strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan ' +
	      'vfprintf vprintf vsprintf endl initializer_list unique_ptr',
	    literal: 'true false nullptr NULL'
	  };
	
	  var EXPRESSION_CONTAINS = [
	    CPP_PRIMITIVE_TYPES,
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    NUMBERS,
	    STRINGS
	  ];
	
	  return {
	    aliases: ['c', 'cc', 'h', 'c++', 'h++', 'hpp'],
	    keywords: CPP_KEYWORDS,
	    illegal: '</',
	    contains: EXPRESSION_CONTAINS.concat([
	      PREPROCESSOR,
	      {
	        begin: '\\b(deque|list|queue|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<', end: '>',
	        keywords: CPP_KEYWORDS,
	        contains: ['self', CPP_PRIMITIVE_TYPES]
	      },
	      {
	        begin: hljs.IDENT_RE + '::',
	        keywords: CPP_KEYWORDS
	      },
	      {
	        // This mode covers expression context where we can't expect a function
	        // definition and shouldn't highlight anything that looks like one:
	        // `return some()`, `else if()`, `(x*sum(1, 2))`
	        variants: [
	          {begin: /=/, end: /;/},
	          {begin: /\(/, end: /\)/},
	          {beginKeywords: 'new throw return else', end: /;/}
	        ],
	        keywords: CPP_KEYWORDS,
	        contains: EXPRESSION_CONTAINS.concat([
	          {
	            begin: /\(/, end: /\)/,
	            keywords: CPP_KEYWORDS,
	            contains: EXPRESSION_CONTAINS.concat(['self']),
	            relevance: 0
	          }
	        ]),
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: '(' + hljs.IDENT_RE + '[\\*&\\s]+)+' + FUNCTION_TITLE,
	        returnBegin: true, end: /[{;=]/,
	        excludeEnd: true,
	        keywords: CPP_KEYWORDS,
	        illegal: /[^\w\s\*&]/,
	        contains: [
	          {
	            begin: FUNCTION_TITLE, returnBegin: true,
	            contains: [hljs.TITLE_MODE],
	            relevance: 0
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            keywords: CPP_KEYWORDS,
	            relevance: 0,
	            contains: [
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              STRINGS,
	              NUMBERS,
	              CPP_PRIMITIVE_TYPES
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          PREPROCESSOR
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class struct', end: /[{;:]/,
	        contains: [
	          {begin: /</, end: />/, contains: ['self']}, // skip generic stuff
	          hljs.TITLE_MODE
	        ]
	      }
	    ]),
	    exports: {
	      preprocessor: PREPROCESSOR,
	      strings: STRINGS,
	      keywords: CPP_KEYWORDS
	    }
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/crmsh.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var RESOURCES = 'primitive rsc_template';
	
	  var COMMANDS = 'group clone ms master location colocation order fencing_topology ' +
	      'rsc_ticket acl_target acl_group user role ' +
	      'tag xml';
	
	  var PROPERTY_SETS = 'property rsc_defaults op_defaults';
	
	  var KEYWORDS = 'params meta operations op rule attributes utilization';
	
	  var OPERATORS = 'read write deny defined not_defined in_range date spec in ' +
	      'ref reference attribute type xpath version and or lt gt tag ' +
	      'lte gte eq ne \\';
	
	  var TYPES = 'number string';
	
	  var LITERALS = 'Master Started Slave Stopped start promote demote stop monitor true false';
	
	  return {
	    aliases: ['crm', 'pcmk'],
	    case_insensitive: true,
	    keywords: {
	      keyword: KEYWORDS + ' ' + OPERATORS + ' ' + TYPES,
	      literal: LITERALS
	    },
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        beginKeywords: 'node',
	        starts: {
	          end: '\\s*([\\w_-]+:)?',
	          starts: {
	            className: 'title',
	            end: '\\s*[\\$\\w_][\\w_-]*'
	          }
	        }
	      },
	      {
	        beginKeywords: RESOURCES,
	        starts: {
	          className: 'title',
	          end: '\\s*[\\$\\w_][\\w_-]*',
	          starts: {
	            end: '\\s*@?[\\w_][\\w_\\.:-]*'
	          }
	        }
	      },
	      {
	        begin: '\\b(' + COMMANDS.split(' ').join('|') + ')\\s+',
	        keywords: COMMANDS,
	        starts: {
	          className: 'title',
	          end: '[\\$\\w_][\\w_-]*'
	        }
	      },
	      {
	        beginKeywords: PROPERTY_SETS,
	        starts: {
	          className: 'title',
	          end: '\\s*([\\w_-]+:)?'
	        }
	      },
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'meta',
	        begin: '(ocf|systemd|service|lsb):[\\w_:-]+',
	        relevance: 0
	      },
	      {
	        className: 'number',
	        begin: '\\b\\d+(\\.\\d+)?(ms|s|h|m)?',
	        relevance: 0
	      },
	      {
	        className: 'literal',
	        begin: '[-]?(infinity|inf)',
	        relevance: 0
	      },
	      {
	        className: 'attr',
	        begin: /([A-Za-z\$_\#][\w_-]+)=/,
	        relevance: 0
	      },
	      {
	        className: 'tag',
	        begin: '</?',
	        end: '/?>',
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/crystal.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var NUM_SUFFIX = '(_[uif](8|16|32|64))?';
	  var CRYSTAL_IDENT_RE = '[a-zA-Z_]\\w*[!?=]?';
	  var RE_STARTER = '!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|' +
	    '>>|>|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';
	  var CRYSTAL_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\][=?]?';
	  var CRYSTAL_KEYWORDS = {
	    keyword:
	      'abstract alias as as? asm begin break case class def do else elsif end ensure enum extend for fun if ' +
	      'include instance_sizeof is_a? lib macro module next nil? of out pointerof private protected rescue responds_to? ' +
	      'return require select self sizeof struct super then type typeof union uninitialized unless until when while with yield ' +
	      '__DIR__ __END_LINE__ __FILE__ __LINE__',
	    literal: 'false nil true'
	  };
	  var SUBST = {
	    className: 'subst',
	    begin: '#{', end: '}',
	    keywords: CRYSTAL_KEYWORDS
	  };
	  var EXPANSION = {
	    className: 'template-variable',
	    variants: [
	      {begin: '\\{\\{', end: '\\}\\}'},
	      {begin: '\\{%', end: '%\\}'}
	    ],
	    keywords: CRYSTAL_KEYWORDS
	  };
	
	  function recursiveParen(begin, end) {
	    var
	    contains = [{begin: begin, end: end}];
	    contains[0].contains = contains;
	    return contains;
	  }
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	    variants: [
	      {begin: /'/, end: /'/},
	      {begin: /"/, end: /"/},
	      {begin: /`/, end: /`/},
	      {begin: '%w?\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
	      {begin: '%w?\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
	      {begin: '%w?{', end: '}', contains: recursiveParen('{', '}')},
	      {begin: '%w?<', end: '>', contains: recursiveParen('<', '>')},
	      {begin: '%w?/', end: '/'},
	      {begin: '%w?%', end: '%'},
	      {begin: '%w?-', end: '-'},
	      {begin: '%w?\\|', end: '\\|'},
	      {begin: /<<-\w+$/, end: /^\s*\w+$/},
	    ],
	    relevance: 0,
	  };
	  var Q_STRING = {
	    className: 'string',
	    variants: [
	      {begin: '%q\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
	      {begin: '%q\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
	      {begin: '%q{', end: '}', contains: recursiveParen('{', '}')},
	      {begin: '%q<', end: '>', contains: recursiveParen('<', '>')},
	      {begin: '%q/', end: '/'},
	      {begin: '%q%', end: '%'},
	      {begin: '%q-', end: '-'},
	      {begin: '%q\\|', end: '\\|'},
	      {begin: /<<-'\w+'$/, end: /^\s*\w+$/},
	    ],
	    relevance: 0,
	  };
	  var REGEXP = {
	    begin: '(' + RE_STARTER + ')\\s*',
	    contains: [
	      {
	        className: 'regexp',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	        variants: [
	          {begin: '//[a-z]*', relevance: 0},
	          {begin: '/', end: '/[a-z]*'},
	          {begin: '%r\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
	          {begin: '%r\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
	          {begin: '%r{', end: '}', contains: recursiveParen('{', '}')},
	          {begin: '%r<', end: '>', contains: recursiveParen('<', '>')},
	          {begin: '%r/', end: '/'},
	          {begin: '%r%', end: '%'},
	          {begin: '%r-', end: '-'},
	          {begin: '%r\\|', end: '\\|'},
	        ]
	      }
	    ],
	    relevance: 0
	  };
	  var REGEXP2 = {
	    className: 'regexp',
	    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	    variants: [
	      {begin: '%r\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
	      {begin: '%r\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
	      {begin: '%r{', end: '}', contains: recursiveParen('{', '}')},
	      {begin: '%r<', end: '>', contains: recursiveParen('<', '>')},
	      {begin: '%r/', end: '/'},
	      {begin: '%r%', end: '%'},
	      {begin: '%r-', end: '-'},
	      {begin: '%r\\|', end: '\\|'},
	    ],
	    relevance: 0
	  };
	  var ATTRIBUTE = {
	    className: 'meta',
	    begin: '@\\[', end: '\\]',
	    contains: [
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'meta-string'})
	    ]
	  };
	  var CRYSTAL_DEFAULT_CONTAINS = [
	    EXPANSION,
	    STRING,
	    Q_STRING,
	    REGEXP,
	    REGEXP2,
	    ATTRIBUTE,
	    hljs.HASH_COMMENT_MODE,
	    {
	      className: 'class',
	      beginKeywords: 'class module struct', end: '$|;',
	      illegal: /=/,
	      contains: [
	        hljs.HASH_COMMENT_MODE,
	        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
	        {begin: '<'} // relevance booster for inheritance
	      ]
	    },
	    {
	      className: 'class',
	      beginKeywords: 'lib enum union', end: '$|;',
	      illegal: /=/,
	      contains: [
	        hljs.HASH_COMMENT_MODE,
	        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
	      ],
	      relevance: 10
	    },
	    {
	      className: 'function',
	      beginKeywords: 'def', end: /\B\b/,
	      contains: [
	        hljs.inherit(hljs.TITLE_MODE, {
	          begin: CRYSTAL_METHOD_RE,
	          endsParent: true
	        })
	      ]
	    },
	    {
	      className: 'function',
	      beginKeywords: 'fun macro', end: /\B\b/,
	      contains: [
	        hljs.inherit(hljs.TITLE_MODE, {
	          begin: CRYSTAL_METHOD_RE,
	          endsParent: true
	        })
	      ],
	      relevance: 5
	    },
	    {
	      className: 'symbol',
	      begin: hljs.UNDERSCORE_IDENT_RE + '(\\!|\\?)?:',
	      relevance: 0
	    },
	    {
	      className: 'symbol',
	      begin: ':',
	      contains: [STRING, {begin: CRYSTAL_METHOD_RE}],
	      relevance: 0
	    },
	    {
	      className: 'number',
	      variants: [
	        { begin: '\\b0b([01_]*[01])' + NUM_SUFFIX },
	        { begin: '\\b0o([0-7_]*[0-7])' + NUM_SUFFIX },
	        { begin: '\\b0x([A-Fa-f0-9_]*[A-Fa-f0-9])' + NUM_SUFFIX },
	        { begin: '\\b(([0-9][0-9_]*[0-9]|[0-9])(\\.[0-9_]*[0-9])?([eE][+-]?[0-9_]*[0-9])?)' + NUM_SUFFIX}
	      ],
	      relevance: 0
	    }
	  ];
	  SUBST.contains = CRYSTAL_DEFAULT_CONTAINS;
	  EXPANSION.contains = CRYSTAL_DEFAULT_CONTAINS.slice(1); // without EXPANSION
	
	  return {
	    aliases: ['cr'],
	    lexemes: CRYSTAL_IDENT_RE,
	    keywords: CRYSTAL_KEYWORDS,
	    contains: CRYSTAL_DEFAULT_CONTAINS
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/cs.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      // Normal keywords.
	      'abstract as base bool break byte case catch char checked const continue decimal ' +
	      'default delegate do double enum event explicit extern finally fixed float ' +
	      'for foreach goto if implicit in int interface internal is lock long nameof ' +
	      'object operator out override params private protected public readonly ref sbyte ' +
	      'sealed short sizeof stackalloc static string struct switch this try typeof ' +
	      'uint ulong unchecked unsafe ushort using virtual void volatile while ' +
	      // Contextual keywords.
	      'add alias ascending async await by descending dynamic equals from get global group into join ' +
	      'let on orderby partial remove select set value var where yield',
	    literal:
	      'null false true'
	  };
	
	  var VERBATIM_STRING = {
	    className: 'string',
	    begin: '@"', end: '"',
	    contains: [{begin: '""'}]
	  };
	  var VERBATIM_STRING_NO_LF = hljs.inherit(VERBATIM_STRING, {illegal: /\n/});
	  var SUBST = {
	    className: 'subst',
	    begin: '{', end: '}',
	    keywords: KEYWORDS
	  };
	  var SUBST_NO_LF = hljs.inherit(SUBST, {illegal: /\n/});
	  var INTERPOLATED_STRING = {
	    className: 'string',
	    begin: /\$"/, end: '"',
	    illegal: /\n/,
	    contains: [{begin: '{{'}, {begin: '}}'}, hljs.BACKSLASH_ESCAPE, SUBST_NO_LF]
	  };
	  var INTERPOLATED_VERBATIM_STRING = {
	    className: 'string',
	    begin: /\$@"/, end: '"',
	    contains: [{begin: '{{'}, {begin: '}}'}, {begin: '""'}, SUBST]
	  };
	  var INTERPOLATED_VERBATIM_STRING_NO_LF = hljs.inherit(INTERPOLATED_VERBATIM_STRING, {
	    illegal: /\n/,
	    contains: [{begin: '{{'}, {begin: '}}'}, {begin: '""'}, SUBST_NO_LF]
	  });
	  SUBST.contains = [
	    INTERPOLATED_VERBATIM_STRING,
	    INTERPOLATED_STRING,
	    VERBATIM_STRING,
	    hljs.APOS_STRING_MODE,
	    hljs.QUOTE_STRING_MODE,
	    hljs.C_NUMBER_MODE,
	    hljs.C_BLOCK_COMMENT_MODE
	  ];
	  SUBST_NO_LF.contains = [
	    INTERPOLATED_VERBATIM_STRING_NO_LF,
	    INTERPOLATED_STRING,
	    VERBATIM_STRING_NO_LF,
	    hljs.APOS_STRING_MODE,
	    hljs.QUOTE_STRING_MODE,
	    hljs.C_NUMBER_MODE,
	    hljs.inherit(hljs.C_BLOCK_COMMENT_MODE, {illegal: /\n/})
	  ];
	  var STRING = {
	    variants: [
	      INTERPOLATED_VERBATIM_STRING,
	      INTERPOLATED_STRING,
	      VERBATIM_STRING,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE
	    ]
	  };
	
	  var TYPE_IDENT_RE = hljs.IDENT_RE + '(<' + hljs.IDENT_RE + '(\\s*,\\s*' + hljs.IDENT_RE + ')*>)?(\\[\\])?';
	
	  return {
	    aliases: ['csharp'],
	    keywords: KEYWORDS,
	    illegal: /::/,
	    contains: [
	      hljs.COMMENT(
	        '///',
	        '$',
	        {
	          returnBegin: true,
	          contains: [
	            {
	              className: 'doctag',
	              variants: [
	                {
	                  begin: '///', relevance: 0
	                },
	                {
	                  begin: '<!--|-->'
	                },
	                {
	                  begin: '</?', end: '>'
	                }
	              ]
	            }
	          ]
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'meta',
	        begin: '#', end: '$',
	        keywords: {
	          'meta-keyword': 'if else elif endif define undef warning error line region endregion pragma checksum'
	        }
	      },
	      STRING,
	      hljs.C_NUMBER_MODE,
	      {
	        beginKeywords: 'class interface', end: /[{;=]/,
	        illegal: /[^\s:]/,
	        contains: [
	          hljs.TITLE_MODE,
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      {
	        beginKeywords: 'namespace', end: /[{;=]/,
	        illegal: /[^\s:]/,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: '[a-zA-Z](\\.?\\w)*'}),
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      {
	        // [Attributes("")]
	        className: 'meta',
	        begin: '^\\s*\\[', excludeBegin: true, end: '\\]', excludeEnd: true,
	        contains: [
	          {className: 'meta-string', begin: /"/, end: /"/}
	        ]
	      },
	      {
	        // Expression keywords prevent 'keyword Name(...)' from being
	        // recognized as a function definition
	        beginKeywords: 'new return throw await else',
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: '(' + TYPE_IDENT_RE + '\\s+)+' + hljs.IDENT_RE + '\\s*\\(', returnBegin: true,
	        end: /[{;=]/, excludeEnd: true,
	        keywords: KEYWORDS,
	        contains: [
	          {
	            begin: hljs.IDENT_RE + '\\s*\\(', returnBegin: true,
	            contains: [hljs.TITLE_MODE],
	            relevance: 0
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            excludeBegin: true,
	            excludeEnd: true,
	            keywords: KEYWORDS,
	            relevance: 0,
	            contains: [
	              STRING,
	              hljs.C_NUMBER_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/csp.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    case_insensitive: false,
	    lexemes: '[a-zA-Z][a-zA-Z0-9_-]*',
	    keywords: {
	      keyword: 'base-uri child-src connect-src default-src font-src form-action' +
	        ' frame-ancestors frame-src img-src media-src object-src plugin-types' +
	        ' report-uri sandbox script-src style-src', 
	    },
	    contains: [
	    {
	      className: 'string',
	      begin: "'", end: "'"
	    },
	    {
	      className: 'attribute',
	      begin: '^Content', end: ':', excludeEnd: true,
	    },
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/css.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
	  var RULE = {
	    begin: /[A-Z\_\.\-]+\s*:/, returnBegin: true, end: ';', endsWithParent: true,
	    contains: [
	      {
	        className: 'attribute',
	        begin: /\S/, end: ':', excludeEnd: true,
	        starts: {
	          endsWithParent: true, excludeEnd: true,
	          contains: [
	            {
	              begin: /[\w-]+\(/, returnBegin: true,
	              contains: [
	                {
	                  className: 'built_in',
	                  begin: /[\w-]+/
	                },
	                {
	                  begin: /\(/, end: /\)/,
	                  contains: [
	                    hljs.APOS_STRING_MODE,
	                    hljs.QUOTE_STRING_MODE
	                  ]
	                }
	              ]
	            },
	            hljs.CSS_NUMBER_MODE,
	            hljs.QUOTE_STRING_MODE,
	            hljs.APOS_STRING_MODE,
	            hljs.C_BLOCK_COMMENT_MODE,
	            {
	              className: 'number', begin: '#[0-9A-Fa-f]+'
	            },
	            {
	              className: 'meta', begin: '!important'
	            }
	          ]
	        }
	      }
	    ]
	  };
	
	  return {
	    case_insensitive: true,
	    illegal: /[=\/|'\$]/,
	    contains: [
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'selector-id', begin: /#[A-Za-z0-9_-]+/
	      },
	      {
	        className: 'selector-class', begin: /\.[A-Za-z0-9_-]+/
	      },
	      {
	        className: 'selector-attr',
	        begin: /\[/, end: /\]/,
	        illegal: '$'
	      },
	      {
	        className: 'selector-pseudo',
	        begin: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/
	      },
	      {
	        begin: '@(font-face|page)',
	        lexemes: '[a-z-]+',
	        keywords: 'font-face page'
	      },
	      {
	        begin: '@', end: '[{;]', // at_rule eating first "{" is a good thing
	                                 // because it doesn’t let it to be parsed as
	                                 // a rule set but instead drops parser into
	                                 // the default mode which is how it should be.
	        illegal: /:/, // break on Less variables @var: ...
	        contains: [
	          {
	            className: 'keyword',
	            begin: /\w+/
	          },
	          {
	            begin: /\s/, endsWithParent: true, excludeEnd: true,
	            relevance: 0,
	            contains: [
	              hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE,
	              hljs.CSS_NUMBER_MODE
	            ]
	          }
	        ]
	      },
	      {
	        className: 'selector-tag', begin: IDENT_RE,
	        relevance: 0
	      },
	      {
	        begin: '{', end: '}',
	        illegal: /\S/,
	        contains: [
	          hljs.C_BLOCK_COMMENT_MODE,
	          RULE,
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/d.js":
/***/ (function(module, exports) {

	module.exports = /**
	 * Known issues:
	 *
	 * - invalid hex string literals will be recognized as a double quoted strings
	 *   but 'x' at the beginning of string will not be matched
	 *
	 * - delimited string literals are not checked for matching end delimiter
	 *   (not possible to do with js regexp)
	 *
	 * - content of token string is colored as a string (i.e. no keyword coloring inside a token string)
	 *   also, content of token string is not validated to contain only valid D tokens
	 *
	 * - special token sequence rule is not strictly following D grammar (anything following #line
	 *   up to the end of line is matched as special token sequence)
	 */
	
	function(hljs) {
	  /**
	   * Language keywords
	   *
	   * @type {Object}
	   */
	  var D_KEYWORDS = {
	    keyword:
	      'abstract alias align asm assert auto body break byte case cast catch class ' +
	      'const continue debug default delete deprecated do else enum export extern final ' +
	      'finally for foreach foreach_reverse|10 goto if immutable import in inout int ' +
	      'interface invariant is lazy macro mixin module new nothrow out override package ' +
	      'pragma private protected public pure ref return scope shared static struct ' +
	      'super switch synchronized template this throw try typedef typeid typeof union ' +
	      'unittest version void volatile while with __FILE__ __LINE__ __gshared|10 ' +
	      '__thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__',
	    built_in:
	      'bool cdouble cent cfloat char creal dchar delegate double dstring float function ' +
	      'idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar ' +
	      'wstring',
	    literal:
	      'false null true'
	  };
	
	  /**
	   * Number literal regexps
	   *
	   * @type {String}
	   */
	  var decimal_integer_re = '(0|[1-9][\\d_]*)',
	    decimal_integer_nosus_re = '(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)',
	    binary_integer_re = '0[bB][01_]+',
	    hexadecimal_digits_re = '([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)',
	    hexadecimal_integer_re = '0[xX]' + hexadecimal_digits_re,
	
	    decimal_exponent_re = '([eE][+-]?' + decimal_integer_nosus_re + ')',
	    decimal_float_re = '(' + decimal_integer_nosus_re + '(\\.\\d*|' + decimal_exponent_re + ')|' +
	                '\\d+\\.' + decimal_integer_nosus_re + decimal_integer_nosus_re + '|' +
	                '\\.' + decimal_integer_re + decimal_exponent_re + '?' +
	              ')',
	    hexadecimal_float_re = '(0[xX](' +
	                  hexadecimal_digits_re + '\\.' + hexadecimal_digits_re + '|'+
	                  '\\.?' + hexadecimal_digits_re +
	                 ')[pP][+-]?' + decimal_integer_nosus_re + ')',
	
	    integer_re = '(' +
	      decimal_integer_re + '|' +
	      binary_integer_re  + '|' +
	       hexadecimal_integer_re   +
	    ')',
	
	    float_re = '(' +
	      hexadecimal_float_re + '|' +
	      decimal_float_re  +
	    ')';
	
	  /**
	   * Escape sequence supported in D string and character literals
	   *
	   * @type {String}
	   */
	  var escape_sequence_re = '\\\\(' +
	              '[\'"\\?\\\\abfnrtv]|' +  // common escapes
	              'u[\\dA-Fa-f]{4}|' +     // four hex digit unicode codepoint
	              '[0-7]{1,3}|' +       // one to three octal digit ascii char code
	              'x[\\dA-Fa-f]{2}|' +    // two hex digit ascii char code
	              'U[\\dA-Fa-f]{8}' +      // eight hex digit unicode codepoint
	              ')|' +
	              '&[a-zA-Z\\d]{2,};';      // named character entity
	
	  /**
	   * D integer number literals
	   *
	   * @type {Object}
	   */
	  var D_INTEGER_MODE = {
	    className: 'number',
	      begin: '\\b' + integer_re + '(L|u|U|Lu|LU|uL|UL)?',
	      relevance: 0
	  };
	
	  /**
	   * [D_FLOAT_MODE description]
	   * @type {Object}
	   */
	  var D_FLOAT_MODE = {
	    className: 'number',
	    begin: '\\b(' +
	        float_re + '([fF]|L|i|[fF]i|Li)?|' +
	        integer_re + '(i|[fF]i|Li)' +
	      ')',
	    relevance: 0
	  };
	
	  /**
	   * D character literal
	   *
	   * @type {Object}
	   */
	  var D_CHARACTER_MODE = {
	    className: 'string',
	    begin: '\'(' + escape_sequence_re + '|.)', end: '\'',
	    illegal: '.'
	  };
	
	  /**
	   * D string escape sequence
	   *
	   * @type {Object}
	   */
	  var D_ESCAPE_SEQUENCE = {
	    begin: escape_sequence_re,
	    relevance: 0
	  };
	
	  /**
	   * D double quoted string literal
	   *
	   * @type {Object}
	   */
	  var D_STRING_MODE = {
	    className: 'string',
	    begin: '"',
	    contains: [D_ESCAPE_SEQUENCE],
	    end: '"[cwd]?'
	  };
	
	  /**
	   * D wysiwyg and delimited string literals
	   *
	   * @type {Object}
	   */
	  var D_WYSIWYG_DELIMITED_STRING_MODE = {
	    className: 'string',
	    begin: '[rq]"',
	    end: '"[cwd]?',
	    relevance: 5
	  };
	
	  /**
	   * D alternate wysiwyg string literal
	   *
	   * @type {Object}
	   */
	  var D_ALTERNATE_WYSIWYG_STRING_MODE = {
	    className: 'string',
	    begin: '`',
	    end: '`[cwd]?'
	  };
	
	  /**
	   * D hexadecimal string literal
	   *
	   * @type {Object}
	   */
	  var D_HEX_STRING_MODE = {
	    className: 'string',
	    begin: 'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',
	    relevance: 10
	  };
	
	  /**
	   * D delimited string literal
	   *
	   * @type {Object}
	   */
	  var D_TOKEN_STRING_MODE = {
	    className: 'string',
	    begin: 'q"\\{',
	    end: '\\}"'
	  };
	
	  /**
	   * Hashbang support
	   *
	   * @type {Object}
	   */
	  var D_HASHBANG_MODE = {
	    className: 'meta',
	    begin: '^#!',
	    end: '$',
	    relevance: 5
	  };
	
	  /**
	   * D special token sequence
	   *
	   * @type {Object}
	   */
	  var D_SPECIAL_TOKEN_SEQUENCE_MODE = {
	    className: 'meta',
	    begin: '#(line)',
	    end: '$',
	    relevance: 5
	  };
	
	  /**
	   * D attributes
	   *
	   * @type {Object}
	   */
	  var D_ATTRIBUTE_MODE = {
	    className: 'keyword',
	    begin: '@[a-zA-Z_][a-zA-Z_\\d]*'
	  };
	
	  /**
	   * D nesting comment
	   *
	   * @type {Object}
	   */
	  var D_NESTING_COMMENT_MODE = hljs.COMMENT(
	    '\\/\\+',
	    '\\+\\/',
	    {
	      contains: ['self'],
	      relevance: 10
	    }
	  );
	
	  return {
	    lexemes: hljs.UNDERSCORE_IDENT_RE,
	    keywords: D_KEYWORDS,
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	        hljs.C_BLOCK_COMMENT_MODE,
	        D_NESTING_COMMENT_MODE,
	        D_HEX_STRING_MODE,
	        D_STRING_MODE,
	        D_WYSIWYG_DELIMITED_STRING_MODE,
	        D_ALTERNATE_WYSIWYG_STRING_MODE,
	        D_TOKEN_STRING_MODE,
	        D_FLOAT_MODE,
	        D_INTEGER_MODE,
	        D_CHARACTER_MODE,
	        D_HASHBANG_MODE,
	        D_SPECIAL_TOKEN_SEQUENCE_MODE,
	        D_ATTRIBUTE_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/dart.js":
/***/ (function(module, exports) {

	module.exports = function (hljs) {
	  var SUBST = {
	    className: 'subst',
	    begin: '\\$\\{', end: '}',
	    keywords: 'true false null this is new super'
	  };
	
	  var STRING = {
	    className: 'string',
	    variants: [
	      {
	        begin: 'r\'\'\'', end: '\'\'\''
	      },
	      {
	        begin: 'r"""', end: '"""'
	      },
	      {
	        begin: 'r\'', end: '\'',
	        illegal: '\\n'
	      },
	      {
	        begin: 'r"', end: '"',
	        illegal: '\\n'
	      },
	      {
	        begin: '\'\'\'', end: '\'\'\'',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      },
	      {
	        begin: '"""', end: '"""',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      },
	      {
	        begin: '\'', end: '\'',
	        illegal: '\\n',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      },
	      {
	        begin: '"', end: '"',
	        illegal: '\\n',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      }
	    ]
	  };
	  SUBST.contains = [
	    hljs.C_NUMBER_MODE, STRING
	  ];
	
	  var KEYWORDS = {
	    keyword: 'assert async await break case catch class const continue default do else enum extends false final ' +
	      'finally for if in is new null rethrow return super switch sync this throw true try var void while with yield ' +
	      'abstract as dynamic export external factory get implements import library operator part set static typedef',
	    built_in:
	      // dart:core
	      'print Comparable DateTime Duration Function Iterable Iterator List Map Match Null Object Pattern RegExp Set ' +
	      'Stopwatch String StringBuffer StringSink Symbol Type Uri bool double int num ' +
	      // dart:html
	      'document window querySelector querySelectorAll Element ElementList'
	  };
	
	  return {
	    keywords: KEYWORDS,
	    contains: [
	      STRING,
	      hljs.COMMENT(
	        '/\\*\\*',
	        '\\*/',
	        {
	          subLanguage: 'markdown'
	        }
	      ),
	      hljs.COMMENT(
	        '///',
	        '$',
	        {
	          subLanguage: 'markdown'
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        contains: [
	          {
	            beginKeywords: 'extends implements'
	          },
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'meta', begin: '@[A-Za-z]+'
	      },
	      {
	        begin: '=>' // No markup, just a relevance booster
	      }
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/delphi.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS =
	    'exports register file shl array record property for mod while set ally label uses raise not ' +
	    'stored class safecall var interface or private static exit index inherited to else stdcall ' +
	    'override shr asm far resourcestring finalization packed virtual out and protected library do ' +
	    'xorwrite goto near function end div overload object unit begin string on inline repeat until ' +
	    'destructor write message program with read initialization except default nil if case cdecl in ' +
	    'downto threadvar of try pascal const external constructor type public then implementation ' +
	    'finally published procedure absolute reintroduce operator as is abstract alias assembler ' +
	    'bitpacked break continue cppdecl cvar enumerator experimental platform deprecated ' +
	    'unimplemented dynamic export far16 forward generic helper implements interrupt iochecks ' +
	    'local name nodefault noreturn nostackframe oldfpccall otherwise saveregisters softfloat ' +
	    'specialize strict unaligned varargs ';
	  var COMMENT_MODES = [
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.COMMENT(/\{/, /\}/, {relevance: 0}),
	    hljs.COMMENT(/\(\*/, /\*\)/, {relevance: 10})
	  ];
	  var DIRECTIVE = {
	    className: 'meta',
	    variants: [
	      {begin: /\{\$/, end: /\}/},
	      {begin: /\(\*\$/, end: /\*\)/}
	    ]
	  };
	  var STRING = {
	    className: 'string',
	    begin: /'/, end: /'/,
	    contains: [{begin: /''/}]
	  };
	  var CHAR_STRING = {
	    className: 'string', begin: /(#\d+)+/
	  };
	  var CLASS = {
	    begin: hljs.IDENT_RE + '\\s*=\\s*class\\s*\\(', returnBegin: true,
	    contains: [
	      hljs.TITLE_MODE
	    ]
	  };
	  var FUNCTION = {
	    className: 'function',
	    beginKeywords: 'function constructor destructor procedure', end: /[:;]/,
	    keywords: 'function constructor|10 destructor|10 procedure|10',
	    contains: [
	      hljs.TITLE_MODE,
	      {
	        className: 'params',
	        begin: /\(/, end: /\)/,
	        keywords: KEYWORDS,
	        contains: [STRING, CHAR_STRING, DIRECTIVE].concat(COMMENT_MODES)
	      },
	      DIRECTIVE
	    ].concat(COMMENT_MODES)
	  };
	  return {
	    aliases: ['dpr', 'dfm', 'pas', 'pascal', 'freepascal', 'lazarus', 'lpr', 'lfm'],
	    case_insensitive: true,
	    keywords: KEYWORDS,
	    illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
	    contains: [
	      STRING, CHAR_STRING,
	      hljs.NUMBER_MODE,
	      CLASS,
	      FUNCTION,
	      DIRECTIVE
	    ].concat(COMMENT_MODES)
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/diff.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['patch'],
	    contains: [
	      {
	        className: 'meta',
	        relevance: 10,
	        variants: [
	          {begin: /^@@ +\-\d+,\d+ +\+\d+,\d+ +@@$/},
	          {begin: /^\*\*\* +\d+,\d+ +\*\*\*\*$/},
	          {begin: /^\-\-\- +\d+,\d+ +\-\-\-\-$/}
	        ]
	      },
	      {
	        className: 'comment',
	        variants: [
	          {begin: /Index: /, end: /$/},
	          {begin: /={3,}/, end: /$/},
	          {begin: /^\-{3}/, end: /$/},
	          {begin: /^\*{3} /, end: /$/},
	          {begin: /^\+{3}/, end: /$/},
	          {begin: /\*{5}/, end: /\*{5}$/}
	        ]
	      },
	      {
	        className: 'addition',
	        begin: '^\\+', end: '$'
	      },
	      {
	        className: 'deletion',
	        begin: '^\\-', end: '$'
	      },
	      {
	        className: 'addition',
	        begin: '^\\!', end: '$'
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/django.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var FILTER = {
	    begin: /\|[A-Za-z]+:?/,
	    keywords: {
	      name:
	        'truncatewords removetags linebreaksbr yesno get_digit timesince random striptags ' +
	        'filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands ' +
	        'title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode ' +
	        'timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort ' +
	        'dictsortreversed default_if_none pluralize lower join center default ' +
	        'truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first ' +
	        'escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize ' +
	        'localtime utc timezone'
	    },
	    contains: [
	      hljs.QUOTE_STRING_MODE,
	      hljs.APOS_STRING_MODE
	    ]
	  };
	
	  return {
	    aliases: ['jinja'],
	    case_insensitive: true,
	    subLanguage: 'xml',
	    contains: [
	      hljs.COMMENT(/\{%\s*comment\s*%}/, /\{%\s*endcomment\s*%}/),
	      hljs.COMMENT(/\{#/, /#}/),
	      {
	        className: 'template-tag',
	        begin: /\{%/, end: /%}/,
	        contains: [
	          {
	            className: 'name',
	            begin: /\w+/,
	            keywords: {
	              name:
	                'comment endcomment load templatetag ifchanged endifchanged if endif firstof for ' +
	                'endfor ifnotequal endifnotequal widthratio extends include spaceless ' +
	                'endspaceless regroup ifequal endifequal ssi now with cycle url filter ' +
	                'endfilter debug block endblock else autoescape endautoescape csrf_token empty elif ' +
	                'endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix ' +
	                'plural get_current_language language get_available_languages ' +
	                'get_current_language_bidi get_language_info get_language_info_list localize ' +
	                'endlocalize localtime endlocaltime timezone endtimezone get_current_timezone ' +
	                'verbatim'
	            },
	            starts: {
	              endsWithParent: true,
	              keywords: 'in by as',
	              contains: [FILTER],
	              relevance: 0
	            }
	          }
	        ]
	      },
	      {
	        className: 'template-variable',
	        begin: /\{\{/, end: /}}/,
	        contains: [FILTER]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/dns.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['bind', 'zone'],
	    keywords: {
	      keyword:
	        'IN A AAAA AFSDB APL CAA CDNSKEY CDS CERT CNAME DHCID DLV DNAME DNSKEY DS HIP IPSECKEY KEY KX ' +
	        'LOC MX NAPTR NS NSEC NSEC3 NSEC3PARAM PTR RRSIG RP SIG SOA SRV SSHFP TA TKEY TLSA TSIG TXT'
	    },
	    contains: [
	      hljs.COMMENT(';', '$', {relevance: 0}),
	      {
	        className: 'meta',
	        begin: /^\$(TTL|GENERATE|INCLUDE|ORIGIN)\b/
	      },
	      // IPv6
	      {
	        className: 'number',
	        begin: '((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))\\b'
	      },
	      // IPv4
	      {
	        className: 'number',
	        begin: '((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b'
	      },
	      hljs.inherit(hljs.NUMBER_MODE, {begin: /\b\d+[dhwm]?/})
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/dockerfile.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['docker'],
	    case_insensitive: true,
	    keywords: 'from maintainer expose env arg user onbuild stopsignal',
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.NUMBER_MODE,
	      {
	        beginKeywords: 'run cmd entrypoint volume add copy workdir label healthcheck shell',
	        starts: {
	          end: /[^\\]\n/,
	          subLanguage: 'bash'
	        }
	      }
	    ],
	    illegal: '</'
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/dos.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var COMMENT = hljs.COMMENT(
	    /^\s*@?rem\b/, /$/,
	    {
	      relevance: 10
	    }
	  );
	  var LABEL = {
	    className: 'symbol',
	    begin: '^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)',
	    relevance: 0
	  };
	  return {
	    aliases: ['bat', 'cmd'],
	    case_insensitive: true,
	    illegal: /\/\*/,
	    keywords: {
	      keyword:
	        'if else goto for in do call exit not exist errorlevel defined ' +
	        'equ neq lss leq gtr geq',
	      built_in:
	        'prn nul lpt3 lpt2 lpt1 con com4 com3 com2 com1 aux ' +
	        'shift cd dir echo setlocal endlocal set pause copy ' +
	        'append assoc at attrib break cacls cd chcp chdir chkdsk chkntfs cls cmd color ' +
	        'comp compact convert date dir diskcomp diskcopy doskey erase fs ' +
	        'find findstr format ftype graftabl help keyb label md mkdir mode more move path ' +
	        'pause print popd pushd promt rd recover rem rename replace restore rmdir shift' +
	        'sort start subst time title tree type ver verify vol ' +
	        // winutils
	        'ping net ipconfig taskkill xcopy ren del'
	    },
	    contains: [
	      {
	        className: 'variable', begin: /%%[^ ]|%[^ ]+?%|![^ ]+?!/
	      },
	      {
	        className: 'function',
	        begin: LABEL.begin, end: 'goto:eof',
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'}),
	          COMMENT
	        ]
	      },
	      {
	        className: 'number', begin: '\\b\\d+',
	        relevance: 0
	      },
	      COMMENT
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/dsconfig.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var QUOTED_PROPERTY = {
	    className: 'string',
	    begin: /"/, end: /"/
	  };
	  var APOS_PROPERTY = {
	    className: 'string',
	    begin: /'/, end: /'/
	  };
	  var UNQUOTED_PROPERTY = {
	    className: 'string',
	    begin: '[\\w-?]+:\\w+', end: '\\W',
	    relevance: 0
	  };
	  var VALUELESS_PROPERTY = {
	    className: 'string',
	    begin: '\\w+-?\\w+', end: '\\W',
	    relevance: 0
	  };
	
	  return {
	    keywords: 'dsconfig',
	    contains: [
	      {
	        className: 'keyword',
	        begin: '^dsconfig', end: '\\s', excludeEnd: true,
	        relevance: 10
	      },
	      {
	        className: 'built_in',
	        begin: '(list|create|get|set|delete)-(\\w+)', end: '\\s', excludeEnd: true,
	        illegal: '!@#$%^&*()',
	        relevance: 10
	      },
	      {
	        className: 'built_in',
	        begin: '--(\\w+)', end: '\\s', excludeEnd: true
	      },
	      QUOTED_PROPERTY,
	      APOS_PROPERTY,
	      UNQUOTED_PROPERTY,
	      VALUELESS_PROPERTY,
	      hljs.HASH_COMMENT_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/dts.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var STRINGS = {
	    className: 'string',
	    variants: [
	      hljs.inherit(hljs.QUOTE_STRING_MODE, { begin: '((u8?|U)|L)?"' }),
	      {
	        begin: '(u8?|U)?R"', end: '"',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        begin: '\'\\\\?.', end: '\'',
	        illegal: '.'
	      }
	    ]
	  };
	
	  var NUMBERS = {
	    className: 'number',
	    variants: [
	      { begin: '\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)' },
	      { begin: hljs.C_NUMBER_RE }
	    ],
	    relevance: 0
	  };
	
	  var PREPROCESSOR = {
	    className: 'meta',
	    begin: '#', end: '$',
	    keywords: {'meta-keyword': 'if else elif endif define undef ifdef ifndef'},
	    contains: [
	      {
	        begin: /\\\n/, relevance: 0
	      },
	      {
	        beginKeywords: 'include', end: '$',
	        keywords: {'meta-keyword': 'include'},
	        contains: [
	          hljs.inherit(STRINGS, {className: 'meta-string'}),
	          {
	            className: 'meta-string',
	            begin: '<', end: '>',
	            illegal: '\\n'
	          }
	        ]
	      },
	      STRINGS,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE
	    ]
	  };
	
	  var DTS_REFERENCE = {
	    className: 'variable',
	    begin: '\\&[a-z\\d_]*\\b'
	  };
	
	  var DTS_KEYWORD = {
	    className: 'meta-keyword',
	    begin: '/[a-z][a-z\\d-]*/'
	  };
	
	  var DTS_LABEL = {
	    className: 'symbol',
	    begin: '^\\s*[a-zA-Z_][a-zA-Z\\d_]*:'
	  };
	
	  var DTS_CELL_PROPERTY = {
	    className: 'params',
	    begin: '<',
	    end: '>',
	    contains: [
	      NUMBERS,
	      DTS_REFERENCE
	    ]
	  };
	
	  var DTS_NODE = {
	    className: 'class',
	    begin: /[a-zA-Z_][a-zA-Z\d_@]*\s{/,
	    end: /[{;=]/,
	    returnBegin: true,
	    excludeEnd: true
	  };
	
	  var DTS_ROOT_NODE = {
	    className: 'class',
	    begin: '/\\s*{',
	    end: '};',
	    relevance: 10,
	    contains: [
	      DTS_REFERENCE,
	      DTS_KEYWORD,
	      DTS_LABEL,
	      DTS_NODE,
	      DTS_CELL_PROPERTY,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      NUMBERS,
	      STRINGS
	    ]
	  };
	
	  return {
	    keywords: "",
	    contains: [
	      DTS_ROOT_NODE,
	      DTS_REFERENCE,
	      DTS_KEYWORD,
	      DTS_LABEL,
	      DTS_NODE,
	      DTS_CELL_PROPERTY,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      NUMBERS,
	      STRINGS,
	      PREPROCESSOR,
	      {
	        begin: hljs.IDENT_RE + '::',
	        keywords: ""
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/dust.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var EXPRESSION_KEYWORDS = 'if eq ne lt lte gt gte select default math sep';
	  return {
	    aliases: ['dst'],
	    case_insensitive: true,
	    subLanguage: 'xml',
	    contains: [
	      {
	        className: 'template-tag',
	        begin: /\{[#\/]/, end: /\}/, illegal: /;/,
	        contains: [
	          {
	            className: 'name',
	            begin: /[a-zA-Z\.-]+/,
	            starts: {
	              endsWithParent: true, relevance: 0,
	              contains: [
	                hljs.QUOTE_STRING_MODE
	              ]
	            }
	          }
	        ]
	      },
	      {
	        className: 'template-variable',
	        begin: /\{/, end: /\}/, illegal: /;/,
	        keywords: EXPRESSION_KEYWORDS
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/ebnf.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    var commentMode = hljs.COMMENT(/\(\*/, /\*\)/);
	
	    var nonTerminalMode = {
	        className: "attribute",
	        begin: /^[ ]*[a-zA-Z][a-zA-Z-]*([\s-]+[a-zA-Z][a-zA-Z]*)*/
	    };
	
	    var specialSequenceMode = {
	        className: "meta",
	        begin: /\?.*\?/
	    };
	
	    var ruleBodyMode = {
	        begin: /=/, end: /;/,
	        contains: [
	            commentMode,
	            specialSequenceMode,
	            // terminals
	            hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE
	        ]
	    };
	
	    return {
	        illegal: /\S/,
	        contains: [
	            commentMode,
	            nonTerminalMode,
	            ruleBodyMode
	        ]
	    };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/elixir.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var ELIXIR_IDENT_RE = '[a-zA-Z_][a-zA-Z0-9_]*(\\!|\\?)?';
	  var ELIXIR_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?';
	  var ELIXIR_KEYWORDS =
	    'and false then defined module in return redo retry end for true self when ' +
	    'next until do begin unless nil break not case cond alias while ensure or ' +
	    'include use alias fn quote';
	  var SUBST = {
	    className: 'subst',
	    begin: '#\\{', end: '}',
	    lexemes: ELIXIR_IDENT_RE,
	    keywords: ELIXIR_KEYWORDS
	  };
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	    variants: [
	      {
	        begin: /'/, end: /'/
	      },
	      {
	        begin: /"/, end: /"/
	      }
	    ]
	  };
	  var FUNCTION = {
	    className: 'function',
	    beginKeywords: 'def defp defmacro', end: /\B\b/, // the mode is ended by the title
	    contains: [
	      hljs.inherit(hljs.TITLE_MODE, {
	        begin: ELIXIR_IDENT_RE,
	        endsParent: true
	      })
	    ]
	  };
	  var CLASS = hljs.inherit(FUNCTION, {
	    className: 'class',
	    beginKeywords: 'defimpl defmodule defprotocol defrecord', end: /\bdo\b|$|;/
	  });
	  var ELIXIR_DEFAULT_CONTAINS = [
	    STRING,
	    hljs.HASH_COMMENT_MODE,
	    CLASS,
	    FUNCTION,
	    {
	      className: 'symbol',
	      begin: ':(?!\\s)',
	      contains: [STRING, {begin: ELIXIR_METHOD_RE}],
	      relevance: 0
	    },
	    {
	      className: 'symbol',
	      begin: ELIXIR_IDENT_RE + ':',
	      relevance: 0
	    },
	    {
	      className: 'number',
	      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	      relevance: 0
	    },
	    {
	      className: 'variable',
	      begin: '(\\$\\W)|((\\$|\\@\\@?)(\\w+))'
	    },
	    {
	      begin: '->'
	    },
	    { // regexp container
	      begin: '(' + hljs.RE_STARTERS_RE + ')\\s*',
	      contains: [
	        hljs.HASH_COMMENT_MODE,
	        {
	          className: 'regexp',
	          illegal: '\\n',
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	          variants: [
	            {
	              begin: '/', end: '/[a-z]*'
	            },
	            {
	              begin: '%r\\[', end: '\\][a-z]*'
	            }
	          ]
	        }
	      ],
	      relevance: 0
	    }
	  ];
	  SUBST.contains = ELIXIR_DEFAULT_CONTAINS;
	
	  return {
	    lexemes: ELIXIR_IDENT_RE,
	    keywords: ELIXIR_KEYWORDS,
	    contains: ELIXIR_DEFAULT_CONTAINS
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/elm.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var COMMENT = {
	    variants: [
	      hljs.COMMENT('--', '$'),
	      hljs.COMMENT(
	        '{-',
	        '-}',
	        {
	          contains: ['self']
	        }
	      )
	    ]
	  };
	
	  var CONSTRUCTOR = {
	    className: 'type',
	    begin: '\\b[A-Z][\\w\']*', // TODO: other constructors (built-in, infix).
	    relevance: 0
	  };
	
	  var LIST = {
	    begin: '\\(', end: '\\)',
	    illegal: '"',
	    contains: [
	      {className: 'type', begin: '\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?'},
	      COMMENT
	    ]
	  };
	
	  var RECORD = {
	    begin: '{', end: '}',
	    contains: LIST.contains
	  };
	
	  return {
	    keywords:
	      'let in if then else case of where module import exposing ' +
	      'type alias as infix infixl infixr port effect command subscription',
	    contains: [
	
	      // Top-level constructions.
	
	      {
	        beginKeywords: 'port effect module', end: 'exposing',
	        keywords: 'port effect module where command subscription exposing',
	        contains: [LIST, COMMENT],
	        illegal: '\\W\\.|;'
	      },
	      {
	        begin: 'import', end: '$',
	        keywords: 'import as exposing',
	        contains: [LIST, COMMENT],
	        illegal: '\\W\\.|;'
	      },
	      {
	        begin: 'type', end: '$',
	        keywords: 'type alias',
	        contains: [CONSTRUCTOR, LIST, RECORD, COMMENT]
	      },
	      {
	        beginKeywords: 'infix infixl infixr', end: '$',
	        contains: [hljs.C_NUMBER_MODE, COMMENT]
	      },
	      {
	        begin: 'port', end: '$',
	        keywords: 'port',
	        contains: [COMMENT]
	      },
	
	      // Literals and names.
	
	      // TODO: characters.
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      CONSTRUCTOR,
	      hljs.inherit(hljs.TITLE_MODE, {begin: '^[_a-z][\\w\']*'}),
	      COMMENT,
	
	      {begin: '->|<-'} // No markup, relevance booster
	    ],
	    illegal: /;/
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/erb.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    subLanguage: 'xml',
	    contains: [
	      hljs.COMMENT('<%#', '%>'),
	      {
	        begin: '<%[%=-]?', end: '[%-]?%>',
	        subLanguage: 'ruby',
	        excludeBegin: true,
	        excludeEnd: true
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/erlang-repl.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      built_in:
	        'spawn spawn_link self',
	      keyword:
	        'after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if ' +
	        'let not of or orelse|10 query receive rem try when xor'
	    },
	    contains: [
	      {
	        className: 'meta', begin: '^[0-9]+> ',
	        relevance: 10
	      },
	      hljs.COMMENT('%', '$'),
	      {
	        className: 'number',
	        begin: '\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)',
	        relevance: 0
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        begin: '\\?(::)?([A-Z]\\w*(::)?)+'
	      },
	      {
	        begin: '->'
	      },
	      {
	        begin: 'ok'
	      },
	      {
	        begin: '!'
	      },
	      {
	        begin: '(\\b[a-z\'][a-zA-Z0-9_\']*:[a-z\'][a-zA-Z0-9_\']*)|(\\b[a-z\'][a-zA-Z0-9_\']*)',
	        relevance: 0
	      },
	      {
	        begin: '[A-Z][a-zA-Z0-9_\']*',
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/erlang.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var BASIC_ATOM_RE = '[a-z\'][a-zA-Z0-9_\']*';
	  var FUNCTION_NAME_RE = '(' + BASIC_ATOM_RE + ':' + BASIC_ATOM_RE + '|' + BASIC_ATOM_RE + ')';
	  var ERLANG_RESERVED = {
	    keyword:
	      'after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if ' +
	      'let not of orelse|10 query receive rem try when xor',
	    literal:
	      'false true'
	  };
	
	  var COMMENT = hljs.COMMENT('%', '$');
	  var NUMBER = {
	    className: 'number',
	    begin: '\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)',
	    relevance: 0
	  };
	  var NAMED_FUN = {
	    begin: 'fun\\s+' + BASIC_ATOM_RE + '/\\d+'
	  };
	  var FUNCTION_CALL = {
	    begin: FUNCTION_NAME_RE + '\\(', end: '\\)',
	    returnBegin: true,
	    relevance: 0,
	    contains: [
	      {
	        begin: FUNCTION_NAME_RE, relevance: 0
	      },
	      {
	        begin: '\\(', end: '\\)', endsWithParent: true,
	        returnEnd: true,
	        relevance: 0
	        // "contains" defined later
	      }
	    ]
	  };
	  var TUPLE = {
	    begin: '{', end: '}',
	    relevance: 0
	    // "contains" defined later
	  };
	  var VAR1 = {
	    begin: '\\b_([A-Z][A-Za-z0-9_]*)?',
	    relevance: 0
	  };
	  var VAR2 = {
	    begin: '[A-Z][a-zA-Z0-9_]*',
	    relevance: 0
	  };
	  var RECORD_ACCESS = {
	    begin: '#' + hljs.UNDERSCORE_IDENT_RE,
	    relevance: 0,
	    returnBegin: true,
	    contains: [
	      {
	        begin: '#' + hljs.UNDERSCORE_IDENT_RE,
	        relevance: 0
	      },
	      {
	        begin: '{', end: '}',
	        relevance: 0
	        // "contains" defined later
	      }
	    ]
	  };
	
	  var BLOCK_STATEMENTS = {
	    beginKeywords: 'fun receive if try case', end: 'end',
	    keywords: ERLANG_RESERVED
	  };
	  BLOCK_STATEMENTS.contains = [
	    COMMENT,
	    NAMED_FUN,
	    hljs.inherit(hljs.APOS_STRING_MODE, {className: ''}),
	    BLOCK_STATEMENTS,
	    FUNCTION_CALL,
	    hljs.QUOTE_STRING_MODE,
	    NUMBER,
	    TUPLE,
	    VAR1, VAR2,
	    RECORD_ACCESS
	  ];
	
	  var BASIC_MODES = [
	    COMMENT,
	    NAMED_FUN,
	    BLOCK_STATEMENTS,
	    FUNCTION_CALL,
	    hljs.QUOTE_STRING_MODE,
	    NUMBER,
	    TUPLE,
	    VAR1, VAR2,
	    RECORD_ACCESS
	  ];
	  FUNCTION_CALL.contains[1].contains = BASIC_MODES;
	  TUPLE.contains = BASIC_MODES;
	  RECORD_ACCESS.contains[1].contains = BASIC_MODES;
	
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)',
	    contains: BASIC_MODES
	  };
	  return {
	    aliases: ['erl'],
	    keywords: ERLANG_RESERVED,
	    illegal: '(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))',
	    contains: [
	      {
	        className: 'function',
	        begin: '^' + BASIC_ATOM_RE + '\\s*\\(', end: '->',
	        returnBegin: true,
	        illegal: '\\(|#|//|/\\*|\\\\|:|;',
	        contains: [
	          PARAMS,
	          hljs.inherit(hljs.TITLE_MODE, {begin: BASIC_ATOM_RE})
	        ],
	        starts: {
	          end: ';|\\.',
	          keywords: ERLANG_RESERVED,
	          contains: BASIC_MODES
	        }
	      },
	      COMMENT,
	      {
	        begin: '^-', end: '\\.',
	        relevance: 0,
	        excludeEnd: true,
	        returnBegin: true,
	        lexemes: '-' + hljs.IDENT_RE,
	        keywords:
	          '-module -record -undef -export -ifdef -ifndef -author -copyright -doc -vsn ' +
	          '-import -include -include_lib -compile -define -else -endif -file -behaviour ' +
	          '-behavior -spec',
	        contains: [PARAMS]
	      },
	      NUMBER,
	      hljs.QUOTE_STRING_MODE,
	      RECORD_ACCESS,
	      VAR1, VAR2,
	      TUPLE,
	      {begin: /\.$/} // relevance booster
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/excel.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['xlsx', 'xls'],
	    case_insensitive: true,
	    lexemes: /[a-zA-Z][\w\.]*/,
	    // built-in functions imported from https://web.archive.org/web/20160513042710/https://support.office.com/en-us/article/Excel-functions-alphabetical-b3944572-255d-4efb-bb96-c6d90033e188
	    keywords: {
	        built_in: 'ABS ACCRINT ACCRINTM ACOS ACOSH ACOT ACOTH AGGREGATE ADDRESS AMORDEGRC AMORLINC AND ARABIC AREAS ASC ASIN ASINH ATAN ATAN2 ATANH AVEDEV AVERAGE AVERAGEA AVERAGEIF AVERAGEIFS BAHTTEXT BASE BESSELI BESSELJ BESSELK BESSELY BETADIST BETA.DIST BETAINV BETA.INV BIN2DEC BIN2HEX BIN2OCT BINOMDIST BINOM.DIST BINOM.DIST.RANGE BINOM.INV BITAND BITLSHIFT BITOR BITRSHIFT BITXOR CALL CEILING CEILING.MATH CEILING.PRECISE CELL CHAR CHIDIST CHIINV CHITEST CHISQ.DIST CHISQ.DIST.RT CHISQ.INV CHISQ.INV.RT CHISQ.TEST CHOOSE CLEAN CODE COLUMN COLUMNS COMBIN COMBINA COMPLEX CONCAT CONCATENATE CONFIDENCE CONFIDENCE.NORM CONFIDENCE.T CONVERT CORREL COS COSH COT COTH COUNT COUNTA COUNTBLANK COUNTIF COUNTIFS COUPDAYBS COUPDAYS COUPDAYSNC COUPNCD COUPNUM COUPPCD COVAR COVARIANCE.P COVARIANCE.S CRITBINOM CSC CSCH CUBEKPIMEMBER CUBEMEMBER CUBEMEMBERPROPERTY CUBERANKEDMEMBER CUBESET CUBESETCOUNT CUBEVALUE CUMIPMT CUMPRINC DATE DATEDIF DATEVALUE DAVERAGE DAY DAYS DAYS360 DB DBCS DCOUNT DCOUNTA DDB DEC2BIN DEC2HEX DEC2OCT DECIMAL DEGREES DELTA DEVSQ DGET DISC DMAX DMIN DOLLAR DOLLARDE DOLLARFR DPRODUCT DSTDEV DSTDEVP DSUM DURATION DVAR DVARP EDATE EFFECT ENCODEURL EOMONTH ERF ERF.PRECISE ERFC ERFC.PRECISE ERROR.TYPE EUROCONVERT EVEN EXACT EXP EXPON.DIST EXPONDIST FACT FACTDOUBLE FALSE|0 F.DIST FDIST F.DIST.RT FILTERXML FIND FINDB F.INV F.INV.RT FINV FISHER FISHERINV FIXED FLOOR FLOOR.MATH FLOOR.PRECISE FORECAST FORECAST.ETS FORECAST.ETS.CONFINT FORECAST.ETS.SEASONALITY FORECAST.ETS.STAT FORECAST.LINEAR FORMULATEXT FREQUENCY F.TEST FTEST FV FVSCHEDULE GAMMA GAMMA.DIST GAMMADIST GAMMA.INV GAMMAINV GAMMALN GAMMALN.PRECISE GAUSS GCD GEOMEAN GESTEP GETPIVOTDATA GROWTH HARMEAN HEX2BIN HEX2DEC HEX2OCT HLOOKUP HOUR HYPERLINK HYPGEOM.DIST HYPGEOMDIST IF|0 IFERROR IFNA IFS IMABS IMAGINARY IMARGUMENT IMCONJUGATE IMCOS IMCOSH IMCOT IMCSC IMCSCH IMDIV IMEXP IMLN IMLOG10 IMLOG2 IMPOWER IMPRODUCT IMREAL IMSEC IMSECH IMSIN IMSINH IMSQRT IMSUB IMSUM IMTAN INDEX INDIRECT INFO INT INTERCEPT INTRATE IPMT IRR ISBLANK ISERR ISERROR ISEVEN ISFORMULA ISLOGICAL ISNA ISNONTEXT ISNUMBER ISODD ISREF ISTEXT ISO.CEILING ISOWEEKNUM ISPMT JIS KURT LARGE LCM LEFT LEFTB LEN LENB LINEST LN LOG LOG10 LOGEST LOGINV LOGNORM.DIST LOGNORMDIST LOGNORM.INV LOOKUP LOWER MATCH MAX MAXA MAXIFS MDETERM MDURATION MEDIAN MID MIDBs MIN MINIFS MINA MINUTE MINVERSE MIRR MMULT MOD MODE MODE.MULT MODE.SNGL MONTH MROUND MULTINOMIAL MUNIT N NA NEGBINOM.DIST NEGBINOMDIST NETWORKDAYS NETWORKDAYS.INTL NOMINAL NORM.DIST NORMDIST NORMINV NORM.INV NORM.S.DIST NORMSDIST NORM.S.INV NORMSINV NOT NOW NPER NPV NUMBERVALUE OCT2BIN OCT2DEC OCT2HEX ODD ODDFPRICE ODDFYIELD ODDLPRICE ODDLYIELD OFFSET OR PDURATION PEARSON PERCENTILE.EXC PERCENTILE.INC PERCENTILE PERCENTRANK.EXC PERCENTRANK.INC PERCENTRANK PERMUT PERMUTATIONA PHI PHONETIC PI PMT POISSON.DIST POISSON POWER PPMT PRICE PRICEDISC PRICEMAT PROB PRODUCT PROPER PV QUARTILE QUARTILE.EXC QUARTILE.INC QUOTIENT RADIANS RAND RANDBETWEEN RANK.AVG RANK.EQ RANK RATE RECEIVED REGISTER.ID REPLACE REPLACEB REPT RIGHT RIGHTB ROMAN ROUND ROUNDDOWN ROUNDUP ROW ROWS RRI RSQ RTD SEARCH SEARCHB SEC SECH SECOND SERIESSUM SHEET SHEETS SIGN SIN SINH SKEW SKEW.P SLN SLOPE SMALL SQL.REQUEST SQRT SQRTPI STANDARDIZE STDEV STDEV.P STDEV.S STDEVA STDEVP STDEVPA STEYX SUBSTITUTE SUBTOTAL SUM SUMIF SUMIFS SUMPRODUCT SUMSQ SUMX2MY2 SUMX2PY2 SUMXMY2 SWITCH SYD T TAN TANH TBILLEQ TBILLPRICE TBILLYIELD T.DIST T.DIST.2T T.DIST.RT TDIST TEXT TEXTJOIN TIME TIMEVALUE T.INV T.INV.2T TINV TODAY TRANSPOSE TREND TRIM TRIMMEAN TRUE|0 TRUNC T.TEST TTEST TYPE UNICHAR UNICODE UPPER VALUE VAR VAR.P VAR.S VARA VARP VARPA VDB VLOOKUP WEBSERVICE WEEKDAY WEEKNUM WEIBULL WEIBULL.DIST WORKDAY WORKDAY.INTL XIRR XNPV XOR YEAR YEARFRAC YIELD YIELDDISC YIELDMAT Z.TEST ZTEST'
	    },
	    contains: [
	      {
	        /* matches a beginning equal sign found in Excel formula examples */ 
	        begin: /^=/,
	        end: /[^=]/, returnEnd: true, illegal: /=/, /* only allow single equal sign at front of line */
	        relevance: 10
	      },
	      /* technically, there can be more than 2 letters in column names, but this prevents conflict with some keywords */
	      {
	        /* matches a reference to a single cell */
	        className: 'symbol',
	        begin: /\b[A-Z]{1,2}\d+\b/,
	        end: /[^\d]/, excludeEnd: true,
	        relevance: 0
	      },
	      {
	        /* matches a reference to a range of cells */
	        className: 'symbol',
	        begin: /[A-Z]{0,2}\d*:[A-Z]{0,2}\d*/,
	        relevance: 0
	      },
	      hljs.BACKSLASH_ESCAPE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'number',
	        begin: hljs.NUMBER_RE + '(%)?',
	        relevance: 0
	      },
	      /* Excel formula comments are done by putting the comment in a function call to N() */
	      hljs.COMMENT(/\bN\(/,/\)/,
	      {
	        excludeBegin: true,
	        excludeEnd: true,
	        illegal: /\n/
	      })
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/fix.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    contains: [
	    {
	      begin: /[^\u2401\u0001]+/,
	      end: /[\u2401\u0001]/,
	      excludeEnd: true,
	      returnBegin: true,
	      returnEnd: false,
	      contains: [
	      {
	        begin: /([^\u2401\u0001=]+)/,
	        end: /=([^\u2401\u0001=]+)/,
	        returnEnd: true,
	        returnBegin: false,
	        className: 'attr'
	      },
	      {
	        begin: /=/,
	        end: /([\u2401\u0001])/,
	        excludeEnd: true,
	        excludeBegin: true,
	        className: 'string'
	      }]
	    }],
	    case_insensitive: true
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/flix.js":
/***/ (function(module, exports) {

	module.exports = function (hljs) {
	
	    var CHAR = {
	        className: 'string',
	        begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
	    };
	
	    var STRING = {
	        className: 'string',
	        variants: [
	            {
	                begin: '"', end: '"'
	            }
	        ]
	    };
	
	    var NAME = {
	        className: 'title',
	        begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/
	    };
	
	    var METHOD = {
	        className: 'function',
	        beginKeywords: 'def',
	        end: /[:={\[(\n;]/,
	        excludeEnd: true,
	        contains: [NAME]
	    };
	
	    return {
	        keywords: {
	            literal: 'true false',
	            keyword: 'case class def else enum if impl import in lat rel index let match namespace switch type yield with'
	        },
	        contains: [
	            hljs.C_LINE_COMMENT_MODE,
	            hljs.C_BLOCK_COMMENT_MODE,
	            CHAR,
	            STRING,
	            METHOD,
	            hljs.C_NUMBER_MODE
	        ]
	    };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/fortran.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)'
	  };
	
	  var F_KEYWORDS = {
	    literal: '.False. .True.',
	    keyword: 'kind do while private call intrinsic where elsewhere ' +
	      'type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then ' +
	      'public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. ' +
	      'goto save else use module select case ' +
	      'access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit ' +
	      'continue format pause cycle exit ' +
	      'c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg ' +
	      'synchronous nopass non_overridable pass protected volatile abstract extends import ' +
	      'non_intrinsic value deferred generic final enumerator class associate bind enum ' +
	      'c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t ' +
	      'c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double ' +
	      'c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr ' +
	      'c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer ' +
	      'c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor ' +
	      'numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ' +
	      'ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive ' +
	      'pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure ' +
	      'integer real character complex logical dimension allocatable|10 parameter ' +
	      'external implicit|10 none double precision assign intent optional pointer ' +
	      'target in out common equivalence data',
	    built_in: 'alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint ' +
	      'dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl ' +
	      'algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama ' +
	      'iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod ' +
	      'qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log ' +
	      'log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate ' +
	      'adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product ' +
	      'eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul ' +
	      'maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product ' +
	      'radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind ' +
	      'set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer ' +
	      'dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ' +
	      'ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode ' +
	      'is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of'  +
	      'acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 ' +
	      'atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits ' +
	      'bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr ' +
	      'num_images parity popcnt poppar shifta shiftl shiftr this_image'
	  };
	  return {
	    case_insensitive: true,
	    aliases: ['f90', 'f95'],
	    keywords: F_KEYWORDS,
	    illegal: /\/\*/,
	    contains: [
	      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'string', relevance: 0}),
	      {
	        className: 'function',
	        beginKeywords: 'subroutine function program',
	        illegal: '[${=\\n]',
	        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
	      },
	      hljs.COMMENT('!', '$', {relevance: 0}),
	      {
	        className: 'number',
	        begin: '(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?',
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/fsharp.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var TYPEPARAM = {
	    begin: '<', end: '>',
	    contains: [
	      hljs.inherit(hljs.TITLE_MODE, {begin: /'[a-zA-Z0-9_]+/})
	    ]
	  };
	
	  return {
	    aliases: ['fs'],
	    keywords:
	      'abstract and as assert base begin class default delegate do done ' +
	      'downcast downto elif else end exception extern false finally for ' +
	      'fun function global if in inherit inline interface internal lazy let ' +
	      'match member module mutable namespace new null of open or ' +
	      'override private public rec return sig static struct then to ' +
	      'true try type upcast use val void when while with yield',
	    illegal: /\/\*/,
	    contains: [
	      {
	        // monad builder keywords (matches before non-bang kws)
	        className: 'keyword',
	        begin: /\b(yield|return|let|do)!/
	      },
	      {
	        className: 'string',
	        begin: '@"', end: '"',
	        contains: [{begin: '""'}]
	      },
	      {
	        className: 'string',
	        begin: '"""', end: '"""'
	      },
	      hljs.COMMENT('\\(\\*', '\\*\\)'),
	      {
	        className: 'class',
	        beginKeywords: 'type', end: '\\(|=|$', excludeEnd: true,
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          TYPEPARAM
	        ]
	      },
	      {
	        className: 'meta',
	        begin: '\\[<', end: '>\\]',
	        relevance: 10
	      },
	      {
	        className: 'symbol',
	        begin: '\\B(\'[A-Za-z])\\b',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/gams.js":
/***/ (function(module, exports) {

	module.exports = function (hljs) {
	  var KEYWORDS = {
	    'keyword':
	      'abort acronym acronyms alias all and assign binary card diag display ' +
	      'else eq file files for free ge gt if integer le loop lt maximizing ' +
	      'minimizing model models ne negative no not option options or ord ' +
	      'positive prod put putpage puttl repeat sameas semicont semiint smax ' +
	      'smin solve sos1 sos2 sum system table then until using while xor yes',
	    'literal': 'eps inf na',
	    'built-in':
	      'abs arccos arcsin arctan arctan2 Beta betaReg binomial ceil centropy ' +
	      'cos cosh cvPower div div0 eDist entropy errorf execSeed exp fact ' +
	      'floor frac gamma gammaReg log logBeta logGamma log10 log2 mapVal max ' +
	      'min mod ncpCM ncpF ncpVUpow ncpVUsin normal pi poly power ' +
	      'randBinomial randLinear randTriangle round rPower sigmoid sign ' +
	      'signPower sin sinh slexp sllog10 slrec sqexp sqlog10 sqr sqrec sqrt ' +
	      'tan tanh trunc uniform uniformInt vcPower bool_and bool_eqv bool_imp ' +
	      'bool_not bool_or bool_xor ifThen rel_eq rel_ge rel_gt rel_le rel_lt ' +
	      'rel_ne gday gdow ghour gleap gmillisec gminute gmonth gsecond gyear ' +
	      'jdate jnow jstart jtime errorLevel execError gamsRelease gamsVersion ' +
	      'handleCollect handleDelete handleStatus handleSubmit heapFree ' +
	      'heapLimit heapSize jobHandle jobKill jobStatus jobTerminate ' +
	      'licenseLevel licenseStatus maxExecError sleep timeClose timeComp ' +
	      'timeElapsed timeExec timeStart'
	  };
	  var PARAMS = {
	    className: 'params',
	    begin: /\(/, end: /\)/,
	    excludeBegin: true,
	    excludeEnd: true,
	  };
	  var SYMBOLS = {
	    className: 'symbol',
	    variants: [
	      {begin: /\=[lgenxc]=/},
	      {begin: /\$/},
	    ]
	  };
	  var QSTR = { // One-line quoted comment string
	    className: 'comment',
	    variants: [
	      {begin: '\'', end: '\''},
	      {begin: '"', end: '"'},
	    ],
	    illegal: '\\n',
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	  var ASSIGNMENT = {
	    begin: '/',
	    end: '/',
	    keywords: KEYWORDS,
	    contains: [
	      QSTR,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	    ],
	  };
	  var DESCTEXT = { // Parameter/set/variable description text
	    begin: /[a-z][a-z0-9_]*(\([a-z0-9_, ]*\))?[ \t]+/,
	    excludeBegin: true,
	    end: '$',
	    endsWithParent: true,
	    contains: [
	      QSTR,
	      ASSIGNMENT,
	      {
	        className: 'comment',
	        begin: /([ ]*[a-z0-9&#*=?@>\\<:\-,()$\[\]_.{}!+%^]+)+/,
	        relevance: 0
	      },
	    ],
	  };
	
	  return {
	    aliases: ['gms'],
	    case_insensitive: true,
	    keywords: KEYWORDS,
	    contains: [
	      hljs.COMMENT(/^\$ontext/, /^\$offtext/),
	      {
	        className: 'meta',
	        begin: '^\\$[a-z0-9]+',
	        end: '$',
	        returnBegin: true,
	        contains: [
	          {
	            className: 'meta-keyword',
	            begin: '^\\$[a-z0-9]+',
	          }
	        ]
	      },
	      hljs.COMMENT('^\\*', '$'),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.APOS_STRING_MODE,
	      // Declarations
	      {
	        beginKeywords:
	          'set sets parameter parameters variable variables ' +
	          'scalar scalars equation equations',
	        end: ';',
	        contains: [
	          hljs.COMMENT('^\\*', '$'),
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.APOS_STRING_MODE,
	          ASSIGNMENT,
	          DESCTEXT,
	        ]
	      },
	      { // table environment
	        beginKeywords: 'table',
	        end: ';',
	        returnBegin: true,
	        contains: [
	          { // table header row
	            beginKeywords: 'table',
	            end: '$',
	            contains: [DESCTEXT],
	          },
	          hljs.COMMENT('^\\*', '$'),
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.APOS_STRING_MODE,
	          hljs.C_NUMBER_MODE,
	          // Table does not contain DESCTEXT or ASSIGNMENT
	        ]
	      },
	      // Function definitions
	      {
	        className: 'function',
	        begin: /^[a-z][a-z0-9_,\-+' ()$]+\.{2}/,
	        returnBegin: true,
	        contains: [
	              { // Function title
	                className: 'title',
	                begin: /^[a-z0-9_]+/,
	              },
	              PARAMS,
	              SYMBOLS,
	            ],
	      },
	      hljs.C_NUMBER_MODE,
	      SYMBOLS,
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/gauss.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword: 'and bool break call callexe checkinterrupt clear clearg closeall cls comlog compile ' +
	              'continue create debug declare delete disable dlibrary dllcall do dos ed edit else ' +
	              'elseif enable end endfor endif endp endo errorlog errorlogat expr external fn ' +
	              'for format goto gosub graph if keyword let lib library line load loadarray loadexe ' +
	              'loadf loadk loadm loadp loads loadx local locate loopnextindex lprint lpwidth lshow ' +
	              'matrix msym ndpclex new not open or output outwidth plot plotsym pop prcsn print ' +
	              'printdos proc push retp return rndcon rndmod rndmult rndseed run save saveall screen ' +
	              'scroll setarray show sparse stop string struct system trace trap threadfor ' +
	              'threadendfor threadbegin threadjoin threadstat threadend until use while winprint',
	    built_in: 'abs acf aconcat aeye amax amean AmericanBinomCall AmericanBinomCall_Greeks AmericanBinomCall_ImpVol ' +
	              'AmericanBinomPut AmericanBinomPut_Greeks AmericanBinomPut_ImpVol AmericanBSCall AmericanBSCall_Greeks ' +
	              'AmericanBSCall_ImpVol AmericanBSPut AmericanBSPut_Greeks AmericanBSPut_ImpVol amin amult annotationGetDefaults ' +
	              'annotationSetBkd annotationSetFont annotationSetLineColor annotationSetLineStyle annotationSetLineThickness ' +
	              'annualTradingDays arccos arcsin areshape arrayalloc arrayindex arrayinit arraytomat asciiload asclabel astd ' +
	              'astds asum atan atan2 atranspose axmargin balance band bandchol bandcholsol bandltsol bandrv bandsolpd bar ' +
	              'base10 begwind besselj bessely beta box boxcox cdfBeta cdfBetaInv cdfBinomial cdfBinomialInv cdfBvn cdfBvn2 ' +
	              'cdfBvn2e cdfCauchy cdfCauchyInv cdfChic cdfChii cdfChinc cdfChincInv cdfExp cdfExpInv cdfFc cdfFnc cdfFncInv ' +
	              'cdfGam cdfGenPareto cdfHyperGeo cdfLaplace cdfLaplaceInv cdfLogistic cdfLogisticInv cdfmControlCreate cdfMvn ' +
	              'cdfMvn2e cdfMvnce cdfMvne cdfMvt2e cdfMvtce cdfMvte cdfN cdfN2 cdfNc cdfNegBinomial cdfNegBinomialInv cdfNi ' +
	              'cdfPoisson cdfPoissonInv cdfRayleigh cdfRayleighInv cdfTc cdfTci cdfTnc cdfTvn cdfWeibull cdfWeibullInv cdir ' +
	              'ceil ChangeDir chdir chiBarSquare chol choldn cholsol cholup chrs close code cols colsf combinate combinated ' +
	              'complex con cond conj cons ConScore contour conv convertsatostr convertstrtosa corrm corrms corrvc corrx corrxs ' +
	              'cos cosh counts countwts crossprd crout croutp csrcol csrlin csvReadM csvReadSA cumprodc cumsumc curve cvtos ' +
	              'datacreate datacreatecomplex datalist dataload dataloop dataopen datasave date datestr datestring datestrymd ' +
	              'dayinyr dayofweek dbAddDatabase dbClose dbCommit dbCreateQuery dbExecQuery dbGetConnectOptions dbGetDatabaseName ' +
	              'dbGetDriverName dbGetDrivers dbGetHostName dbGetLastErrorNum dbGetLastErrorText dbGetNumericalPrecPolicy ' +
	              'dbGetPassword dbGetPort dbGetTableHeaders dbGetTables dbGetUserName dbHasFeature dbIsDriverAvailable dbIsOpen ' +
	              'dbIsOpenError dbOpen dbQueryBindValue dbQueryClear dbQueryCols dbQueryExecPrepared dbQueryFetchAllM dbQueryFetchAllSA ' +
	              'dbQueryFetchOneM dbQueryFetchOneSA dbQueryFinish dbQueryGetBoundValue dbQueryGetBoundValues dbQueryGetField ' +
	              'dbQueryGetLastErrorNum dbQueryGetLastErrorText dbQueryGetLastInsertID dbQueryGetLastQuery dbQueryGetPosition ' +
	              'dbQueryIsActive dbQueryIsForwardOnly dbQueryIsNull dbQueryIsSelect dbQueryIsValid dbQueryPrepare dbQueryRows ' +
	              'dbQuerySeek dbQuerySeekFirst dbQuerySeekLast dbQuerySeekNext dbQuerySeekPrevious dbQuerySetForwardOnly ' +
	              'dbRemoveDatabase dbRollback dbSetConnectOptions dbSetDatabaseName dbSetHostName dbSetNumericalPrecPolicy ' +
	              'dbSetPort dbSetUserName dbTransaction DeleteFile delif delrows denseToSp denseToSpRE denToZero design det detl ' +
	              'dfft dffti diag diagrv digamma doswin DOSWinCloseall DOSWinOpen dotfeq dotfeqmt dotfge dotfgemt dotfgt dotfgtmt ' +
	              'dotfle dotflemt dotflt dotfltmt dotfne dotfnemt draw drop dsCreate dstat dstatmt dstatmtControlCreate dtdate dtday ' +
	              'dttime dttodtv dttostr dttoutc dtvnormal dtvtodt dtvtoutc dummy dummybr dummydn eig eigh eighv eigv elapsedTradingDays ' +
	              'endwind envget eof eqSolve eqSolvemt eqSolvemtControlCreate eqSolvemtOutCreate eqSolveset erf erfc erfccplx erfcplx error ' +
	              'etdays ethsec etstr EuropeanBinomCall EuropeanBinomCall_Greeks EuropeanBinomCall_ImpVol EuropeanBinomPut ' +
	              'EuropeanBinomPut_Greeks EuropeanBinomPut_ImpVol EuropeanBSCall EuropeanBSCall_Greeks EuropeanBSCall_ImpVol ' +
	              'EuropeanBSPut EuropeanBSPut_Greeks EuropeanBSPut_ImpVol exctsmpl exec execbg exp extern eye fcheckerr fclearerr feq ' +
	              'feqmt fflush fft ffti fftm fftmi fftn fge fgemt fgets fgetsa fgetsat fgetst fgt fgtmt fileinfo filesa fle flemt ' +
	              'floor flt fltmt fmod fne fnemt fonts fopen formatcv formatnv fputs fputst fseek fstrerror ftell ftocv ftos ftostrC ' +
	              'gamma gammacplx gammaii gausset gdaAppend gdaCreate gdaDStat gdaDStatMat gdaGetIndex gdaGetName gdaGetNames gdaGetOrders ' +
	              'gdaGetType gdaGetTypes gdaGetVarInfo gdaIsCplx gdaLoad gdaPack gdaRead gdaReadByIndex gdaReadSome gdaReadSparse ' +
	              'gdaReadStruct gdaReportVarInfo gdaSave gdaUpdate gdaUpdateAndPack gdaVars gdaWrite gdaWrite32 gdaWriteSome getarray ' +
	              'getdims getf getGAUSShome getmatrix getmatrix4D getname getnamef getNextTradingDay getNextWeekDay getnr getorders ' +
	              'getpath getPreviousTradingDay getPreviousWeekDay getRow getscalar3D getscalar4D getTrRow getwind glm gradcplx gradMT ' +
	              'gradMTm gradMTT gradMTTm gradp graphprt graphset hasimag header headermt hess hessMT hessMTg hessMTgw hessMTm ' +
	              'hessMTmw hessMTT hessMTTg hessMTTgw hessMTTm hessMTw hessp hist histf histp hsec imag indcv indexcat indices indices2 ' +
	              'indicesf indicesfn indnv indsav integrate1d integrateControlCreate intgrat2 intgrat3 inthp1 inthp2 inthp3 inthp4 ' +
	              'inthpControlCreate intquad1 intquad2 intquad3 intrleav intrleavsa intrsect intsimp inv invpd invswp iscplx iscplxf ' +
	              'isden isinfnanmiss ismiss key keyav keyw lag lag1 lagn lapEighb lapEighi lapEighvb lapEighvi lapgEig lapgEigh lapgEighv ' +
	              'lapgEigv lapgSchur lapgSvdcst lapgSvds lapgSvdst lapSvdcusv lapSvds lapSvdusv ldlp ldlsol linSolve listwise ln lncdfbvn ' +
	              'lncdfbvn2 lncdfmvn lncdfn lncdfn2 lncdfnc lnfact lngammacplx lnpdfmvn lnpdfmvt lnpdfn lnpdft loadd loadstruct loadwind ' +
	              'loess loessmt loessmtControlCreate log loglog logx logy lower lowmat lowmat1 ltrisol lu lusol machEpsilon make makevars ' +
	              'makewind margin matalloc matinit mattoarray maxbytes maxc maxindc maxv maxvec mbesselei mbesselei0 mbesselei1 mbesseli ' +
	              'mbesseli0 mbesseli1 meanc median mergeby mergevar minc minindc minv miss missex missrv moment momentd movingave ' +
	              'movingaveExpwgt movingaveWgt nextindex nextn nextnevn nextwind ntos null null1 numCombinations ols olsmt olsmtControlCreate ' +
	              'olsqr olsqr2 olsqrmt ones optn optnevn orth outtyp pacf packedToSp packr parse pause pdfCauchy pdfChi pdfExp pdfGenPareto ' +
	              'pdfHyperGeo pdfLaplace pdfLogistic pdfn pdfPoisson pdfRayleigh pdfWeibull pi pinv pinvmt plotAddArrow plotAddBar plotAddBox ' +
	              'plotAddHist plotAddHistF plotAddHistP plotAddPolar plotAddScatter plotAddShape plotAddTextbox plotAddTS plotAddXY plotArea ' +
	              'plotBar plotBox plotClearLayout plotContour plotCustomLayout plotGetDefaults plotHist plotHistF plotHistP plotLayout ' +
	              'plotLogLog plotLogX plotLogY plotOpenWindow plotPolar plotSave plotScatter plotSetAxesPen plotSetBar plotSetBarFill ' +
	              'plotSetBarStacked plotSetBkdColor plotSetFill plotSetGrid plotSetLegend plotSetLineColor plotSetLineStyle plotSetLineSymbol ' +
	              'plotSetLineThickness plotSetNewWindow plotSetTitle plotSetWhichYAxis plotSetXAxisShow plotSetXLabel plotSetXRange ' +
	              'plotSetXTicInterval plotSetXTicLabel plotSetYAxisShow plotSetYLabel plotSetYRange plotSetZAxisShow plotSetZLabel ' +
	              'plotSurface plotTS plotXY polar polychar polyeval polygamma polyint polymake polymat polymroot polymult polyroot ' +
	              'pqgwin previousindex princomp printfm printfmt prodc psi putarray putf putvals pvCreate pvGetIndex pvGetParNames ' +
	              'pvGetParVector pvLength pvList pvPack pvPacki pvPackm pvPackmi pvPacks pvPacksi pvPacksm pvPacksmi pvPutParVector ' +
	              'pvTest pvUnpack QNewton QNewtonmt QNewtonmtControlCreate QNewtonmtOutCreate QNewtonSet QProg QProgmt QProgmtInCreate ' +
	              'qqr qqre qqrep qr qre qrep qrsol qrtsol qtyr qtyre qtyrep quantile quantiled qyr qyre qyrep qz rank rankindx readr ' +
	              'real reclassify reclassifyCuts recode recserar recsercp recserrc rerun rescale reshape rets rev rfft rffti rfftip rfftn ' +
	              'rfftnp rfftp rndBernoulli rndBeta rndBinomial rndCauchy rndChiSquare rndCon rndCreateState rndExp rndGamma rndGeo rndGumbel ' +
	              'rndHyperGeo rndi rndKMbeta rndKMgam rndKMi rndKMn rndKMnb rndKMp rndKMu rndKMvm rndLaplace rndLCbeta rndLCgam rndLCi rndLCn ' +
	              'rndLCnb rndLCp rndLCu rndLCvm rndLogNorm rndMTu rndMVn rndMVt rndn rndnb rndNegBinomial rndp rndPoisson rndRayleigh ' +
	              'rndStateSkip rndu rndvm rndWeibull rndWishart rotater round rows rowsf rref sampleData satostrC saved saveStruct savewind ' +
	              'scale scale3d scalerr scalinfnanmiss scalmiss schtoc schur searchsourcepath seekr select selif seqa seqm setdif setdifsa ' +
	              'setvars setvwrmode setwind shell shiftr sin singleindex sinh sleep solpd sortc sortcc sortd sorthc sorthcc sortind ' +
	              'sortindc sortmc sortr sortrc spBiconjGradSol spChol spConjGradSol spCreate spDenseSubmat spDiagRvMat spEigv spEye spLDL ' +
	              'spline spLU spNumNZE spOnes spreadSheetReadM spreadSheetReadSA spreadSheetWrite spScale spSubmat spToDense spTrTDense ' +
	              'spTScalar spZeros sqpSolve sqpSolveMT sqpSolveMTControlCreate sqpSolveMTlagrangeCreate sqpSolveMToutCreate sqpSolveSet ' +
	              'sqrt statements stdc stdsc stocv stof strcombine strindx strlen strput strrindx strsect strsplit strsplitPad strtodt ' +
	              'strtof strtofcplx strtriml strtrimr strtrunc strtruncl strtruncpad strtruncr submat subscat substute subvec sumc sumr ' +
	              'surface svd svd1 svd2 svdcusv svds svdusv sysstate tab tan tanh tempname threadBegin threadEnd threadEndFor threadFor ' +
	              'threadJoin threadStat time timedt timestr timeutc title tkf2eps tkf2ps tocart todaydt toeplitz token topolar trapchk ' +
	              'trigamma trimr trunc type typecv typef union unionsa uniqindx uniqindxsa unique uniquesa upmat upmat1 upper utctodt ' +
	              'utctodtv utrisol vals varCovMS varCovXS varget vargetl varmall varmares varput varputl vartypef vcm vcms vcx vcxs ' +
	              'vec vech vecr vector vget view viewxyz vlist vnamecv volume vput vread vtypecv wait waitc walkindex where window ' +
	              'writer xlabel xlsGetSheetCount xlsGetSheetSize xlsGetSheetTypes xlsMakeRange xlsReadM xlsReadSA xlsWrite xlsWriteM ' +
	              'xlsWriteSA xpnd xtics xy xyz ylabel ytics zeros zeta zlabel ztics cdfEmpirical dot h5create h5open h5read h5readAttribute ' +
	              'h5write h5writeAttribute ldl plotAddErrorBar plotAddSurface plotCDFEmpirical plotSetColormap plotSetContourLabels ' +
	              'plotSetLegendFont plotSetTextInterpreter plotSetXTicCount plotSetYTicCount plotSetZLevels powerm strjoin strtrim sylvester',
	    literal: 'DB_AFTER_LAST_ROW DB_ALL_TABLES DB_BATCH_OPERATIONS DB_BEFORE_FIRST_ROW DB_BLOB DB_EVENT_NOTIFICATIONS ' +
	             'DB_FINISH_QUERY DB_HIGH_PRECISION DB_LAST_INSERT_ID DB_LOW_PRECISION_DOUBLE DB_LOW_PRECISION_INT32 ' +
	             'DB_LOW_PRECISION_INT64 DB_LOW_PRECISION_NUMBERS DB_MULTIPLE_RESULT_SETS DB_NAMED_PLACEHOLDERS ' +
	             'DB_POSITIONAL_PLACEHOLDERS DB_PREPARED_QUERIES DB_QUERY_SIZE DB_SIMPLE_LOCKING DB_SYSTEM_TABLES DB_TABLES ' +
	             'DB_TRANSACTIONS DB_UNICODE DB_VIEWS'
	  };
	
	  var PREPROCESSOR =
	  {
	    className: 'meta',
	    begin: '#', end: '$',
	    keywords: {'meta-keyword': 'define definecs|10 undef ifdef ifndef iflight ifdllcall ifmac ifos2win ifunix else endif lineson linesoff srcfile srcline'},
	    contains: [
	      {
	        begin: /\\\n/, relevance: 0
	      },
	      {
	        beginKeywords: 'include', end: '$',
	        keywords: {'meta-keyword': 'include'},
	        contains: [
	          {
	            className: 'meta-string',
	            begin: '"', end: '"',
	            illegal: '\\n'
	          }
	        ]
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE
	    ]
	  };
	
	  var FUNCTION_TITLE = hljs.UNDERSCORE_IDENT_RE + '\\s*\\(?';
	  var PARSE_PARAMS = [
	    {
	      className: 'params',
	      begin: /\(/, end: /\)/,
	      keywords: KEYWORDS,
	      relevance: 0,
	      contains: [
	        hljs.C_NUMBER_MODE,
	        hljs.C_LINE_COMMENT_MODE,
	        hljs.C_BLOCK_COMMENT_MODE
	      ]
	    }
	  ];
	
	  return {
	    aliases: ['gss'],
	    case_insensitive: true, // language is case-insensitive
	    keywords: KEYWORDS,
	    illegal: '(\\{[%#]|[%#]\\})',
	    contains: [
	      hljs.C_NUMBER_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.COMMENT('@', '@'),
	      PREPROCESSOR,
	      {
	        className: 'string',
	        begin: '"', end: '"',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        className: 'function',
	        beginKeywords: 'proc keyword',
	        end: ';',
	        excludeEnd: true,
	        keywords: KEYWORDS,
	        contains: [
	          {
	            begin: FUNCTION_TITLE, returnBegin: true,
	            contains: [hljs.UNDERSCORE_TITLE_MODE],
	            relevance: 0
	          },
	          hljs.C_NUMBER_MODE,
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          PREPROCESSOR
	        ].concat(PARSE_PARAMS)
	      },
	      {
	        className: 'function',
	        beginKeywords: 'fn',
	        end: ';',
	        excludeEnd: true,
	        keywords: KEYWORDS,
	        contains: [
	          {
	            begin: FUNCTION_TITLE + hljs.IDENT_RE + '\\)?\\s*\\=\\s*', returnBegin: true,
	            contains: [hljs.UNDERSCORE_TITLE_MODE],
	            relevance: 0
	          },
	          hljs.C_NUMBER_MODE,
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ].concat(PARSE_PARAMS)
	      },
	      {
	        className: 'function',
	        begin: '\\bexternal (proc|keyword|fn)\\s+',
	        end: ';',
	        excludeEnd: true,
	        keywords: KEYWORDS,
	        contains: [
	          {
	            begin: FUNCTION_TITLE, returnBegin: true,
	            contains: [hljs.UNDERSCORE_TITLE_MODE],
	            relevance: 0
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      {
	        className: 'function',
	        begin: '\\bexternal (matrix|string|array|sparse matrix|struct ' + hljs.IDENT_RE + ')\\s+',
	        end: ';',
	        excludeEnd: true,
	        keywords: KEYWORDS,
	        contains: [
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/gcode.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    var GCODE_IDENT_RE = '[A-Z_][A-Z0-9_.]*';
	    var GCODE_CLOSE_RE = '\\%';
	    var GCODE_KEYWORDS =
	      'IF DO WHILE ENDWHILE CALL ENDIF SUB ENDSUB GOTO REPEAT ENDREPEAT ' +
	      'EQ LT GT NE GE LE OR XOR';
	    var GCODE_START = {
	        className: 'meta',
	        begin: '([O])([0-9]+)'
	    };
	    var GCODE_CODE = [
	        hljs.C_LINE_COMMENT_MODE,
	        hljs.C_BLOCK_COMMENT_MODE,
	        hljs.COMMENT(/\(/, /\)/),
	        hljs.inherit(hljs.C_NUMBER_MODE, {begin: '([-+]?([0-9]*\\.?[0-9]+\\.?))|' + hljs.C_NUMBER_RE}),
	        hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	        hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	        {
	            className: 'name',
	            begin: '([G])([0-9]+\\.?[0-9]?)'
	        },
	        {
	            className: 'name',
	            begin: '([M])([0-9]+\\.?[0-9]?)'
	        },
	        {
	            className: 'attr',
	            begin: '(VC|VS|#)',
	            end: '(\\d+)'
	        },
	        {
	            className: 'attr',
	            begin: '(VZOFX|VZOFY|VZOFZ)'
	        },
	        {
	            className: 'built_in',
	            begin: '(ATAN|ABS|ACOS|ASIN|SIN|COS|EXP|FIX|FUP|ROUND|LN|TAN)(\\[)',
	            end: '([-+]?([0-9]*\\.?[0-9]+\\.?))(\\])'
	        },
	        {
	            className: 'symbol',
	            variants: [
	                {
	                    begin: 'N', end: '\\d+',
	                    illegal: '\\W'
	                }
	            ]
	        }
	    ];
	
	    return {
	        aliases: ['nc'],
	        // Some implementations (CNC controls) of G-code are interoperable with uppercase and lowercase letters seamlessly.
	        // However, most prefer all uppercase and uppercase is customary.
	        case_insensitive: true,
	        lexemes: GCODE_IDENT_RE,
	        keywords: GCODE_KEYWORDS,
	        contains: [
	            {
	                className: 'meta',
	                begin: GCODE_CLOSE_RE
	            },
	            GCODE_START
	        ].concat(GCODE_CODE)
	    };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/gherkin.js":
/***/ (function(module, exports) {

	module.exports = function (hljs) {
	  return {
	    aliases: ['feature'],
	    keywords: 'Feature Background Ability Business\ Need Scenario Scenarios Scenario\ Outline Scenario\ Template Examples Given And Then But When',
	    contains: [
	      {
	        className: 'symbol',
	        begin: '\\*',
	        relevance: 0
	      },
	      {
	        className: 'meta',
	        begin: '@[^@\\s]+'
	      },
	      {
	        begin: '\\|', end: '\\|\\w*$',
	        contains: [
	          {
	            className: 'string',
	            begin: '[^|]+'
	          }
	        ]
	      },
	      {
	        className: 'variable',
	        begin: '<', end: '>'
	      },
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'string',
	        begin: '"""', end: '"""'
	      },
	      hljs.QUOTE_STRING_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/glsl.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      keyword:
	        // Statements
	        'break continue discard do else for if return while switch case default ' +
	        // Qualifiers
	        'attribute binding buffer ccw centroid centroid varying coherent column_major const cw ' +
	        'depth_any depth_greater depth_less depth_unchanged early_fragment_tests equal_spacing ' +
	        'flat fractional_even_spacing fractional_odd_spacing highp in index inout invariant ' +
	        'invocations isolines layout line_strip lines lines_adjacency local_size_x local_size_y ' +
	        'local_size_z location lowp max_vertices mediump noperspective offset origin_upper_left ' +
	        'out packed patch pixel_center_integer point_mode points precise precision quads r11f_g11f_b10f '+
	        'r16 r16_snorm r16f r16i r16ui r32f r32i r32ui r8 r8_snorm r8i r8ui readonly restrict ' +
	        'rg16 rg16_snorm rg16f rg16i rg16ui rg32f rg32i rg32ui rg8 rg8_snorm rg8i rg8ui rgb10_a2 ' +
	        'rgb10_a2ui rgba16 rgba16_snorm rgba16f rgba16i rgba16ui rgba32f rgba32i rgba32ui rgba8 ' +
	        'rgba8_snorm rgba8i rgba8ui row_major sample shared smooth std140 std430 stream triangle_strip ' +
	        'triangles triangles_adjacency uniform varying vertices volatile writeonly',
	      type:
	        'atomic_uint bool bvec2 bvec3 bvec4 dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 ' +
	        'dmat3x4 dmat4 dmat4x2 dmat4x3 dmat4x4 double dvec2 dvec3 dvec4 float iimage1D iimage1DArray ' +
	        'iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBuffer' +
	        'iimageCube iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray ' +
	        'image2DRect image3D imageBuffer imageCube imageCubeArray int isampler1D isampler1DArray ' +
	        'isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D ' +
	        'isamplerBuffer isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 mat2 mat2x2 mat2x3 ' +
	        'mat2x4 mat3 mat3x2 mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 sampler1D sampler1DArray ' +
	        'sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray sampler2DArrayShadow ' +
	        'sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow sampler3D ' +
	        'samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow ' +
	        'image1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray uimage2DRect ' +
	        'uimage3D uimageBuffer uimageCube uimageCubeArray uint usampler1D usampler1DArray ' +
	        'usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D ' +
	        'samplerBuffer usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 vec2 vec3 vec4 void',
	      built_in:
	        // Constants
	        'gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize gl_MaxClipDistances gl_MaxClipPlanes ' +
	        'gl_MaxCombinedAtomicCounterBuffers gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms ' +
	        'gl_MaxCombinedImageUnitsAndFragmentOutputs gl_MaxCombinedTextureImageUnits gl_MaxComputeAtomicCounterBuffers ' +
	        'gl_MaxComputeAtomicCounters gl_MaxComputeImageUniforms gl_MaxComputeTextureImageUnits ' +
	        'gl_MaxComputeUniformComponents gl_MaxComputeWorkGroupCount gl_MaxComputeWorkGroupSize ' +
	        'gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers gl_MaxFragmentAtomicCounters ' +
	        'gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents gl_MaxFragmentInputVectors ' +
	        'gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers ' +
	        'gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents ' +
	        'gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits ' +
	        'gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents ' +
	        'gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset ' +
	        'gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms ' +
	        'gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits ' +
	        'gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents ' +
	        'gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters ' +
	        'gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents ' +
	        'gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents ' +
	        'gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits ' +
	        'gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors ' +
	        'gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs gl_MaxVertexImageUniforms ' +
	        'gl_MaxVertexOutputComponents gl_MaxVertexOutputVectors gl_MaxVertexTextureImageUnits ' +
	        'gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffset ' +
	        // Variables
	        'gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial ' +
	        'gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color ' +
	        'gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord ' +
	        'gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor ' +
	        'gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial ' +
	        'gl_FrontSecondaryColor gl_GlobalInvocationID gl_InstanceID gl_InvocationID gl_Layer gl_LightModel ' +
	        'gl_LightSource gl_LocalInvocationID gl_LocalInvocationIndex gl_ModelViewMatrix ' +
	        'gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose gl_ModelViewMatrixTranspose ' +
	        'gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse gl_ModelViewProjectionMatrixInverseTranspose ' +
	        'gl_ModelViewProjectionMatrixTranspose gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 ' +
	        'gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 ' +
	        'gl_Normal gl_NormalMatrix gl_NormalScale gl_NumSamples gl_NumWorkGroups gl_ObjectPlaneQ ' +
	        'gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn gl_Point gl_PointCoord ' +
	        'gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn gl_ProjectionMatrix gl_ProjectionMatrixInverse ' +
	        'gl_ProjectionMatrixInverseTranspose gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask ' +
	        'gl_SampleMaskIn gl_SamplePosition gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter ' +
	        'gl_TexCoord gl_TextureEnvColor gl_TextureMatrix gl_TextureMatrixInverse gl_TextureMatrixInverseTranspose ' +
	        'gl_TextureMatrixTranspose gl_Vertex gl_VertexID gl_ViewportIndex gl_WorkGroupID gl_WorkGroupSize gl_in gl_out ' +
	        // Functions
	        'EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive abs acos acosh all any asin ' +
	        'asinh atan atanh atomicAdd atomicAnd atomicCompSwap atomicCounter atomicCounterDecrement ' +
	        'atomicCounterIncrement atomicExchange atomicMax atomicMin atomicOr atomicXor barrier ' +
	        'bitCount bitfieldExtract bitfieldInsert bitfieldReverse ceil clamp cos cosh cross ' +
	        'dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward findLSB findMSB ' +
	        'floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan ' +
	        'greaterThanEqual groupMemoryBarrier imageAtomicAdd imageAtomicAnd imageAtomicCompSwap ' +
	        'imageAtomicExchange imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad ' +
	        'imageSize imageStore imulExtended intBitsToFloat interpolateAtCentroid interpolateAtOffset ' +
	        'interpolateAtSample inverse inversesqrt isinf isnan ldexp length lessThan lessThanEqual log ' +
	        'log2 matrixCompMult max memoryBarrier memoryBarrierAtomicCounter memoryBarrierBuffer ' +
	        'memoryBarrierImage memoryBarrierShared min mix mod modf noise1 noise2 noise3 noise4 ' +
	        'normalize not notEqual outerProduct packDouble2x32 packHalf2x16 packSnorm2x16 packSnorm4x8 ' +
	        'packUnorm2x16 packUnorm4x8 pow radians reflect refract round roundEven shadow1D shadow1DLod ' +
	        'shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj shadow2DProjLod sign sin sinh ' +
	        'smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture texture1D texture1DLod ' +
	        'texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj texture2DProjLod ' +
	        'texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod ' +
	        'textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset ' +
	        'textureLod textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset ' +
	        'textureProjLod textureProjLodOffset textureProjOffset textureQueryLevels textureQueryLod ' +
	        'textureSize transpose trunc uaddCarry uintBitsToFloat umulExtended unpackDouble2x32 ' +
	        'unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 unpackUnorm2x16 unpackUnorm4x8 usubBorrow',
	      literal: 'true false'
	    },
	    illegal: '"',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'meta',
	        begin: '#', end: '$'
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/go.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var GO_KEYWORDS = {
	    keyword:
	      'break default func interface select case map struct chan else goto package switch ' +
	      'const fallthrough if range type continue for import return var go defer ' +
	      'bool byte complex64 complex128 float32 float64 int8 int16 int32 int64 string uint8 ' +
	      'uint16 uint32 uint64 int uint uintptr rune',
	    literal:
	       'true false iota nil',
	    built_in:
	      'append cap close complex copy imag len make new panic print println real recover delete'
	  };
	  return {
	    aliases: ['golang'],
	    keywords: GO_KEYWORDS,
	    illegal: '</',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'string',
	        variants: [
	          hljs.QUOTE_STRING_MODE,
	          {begin: '\'', end: '[^\\\\]\''},
	          {begin: '`', end: '`'},
	        ]
	      },
	      {
	        className: 'number',
	        variants: [
	          {begin: hljs.C_NUMBER_RE + '[dflsi]', relevance: 1},
	          hljs.C_NUMBER_MODE
	        ]
	      },
	      {
	        begin: /:=/ // relevance booster
	      },
	      {
	        className: 'function',
	        beginKeywords: 'func', end: /\s*\{/, excludeEnd: true,
	        contains: [
	          hljs.TITLE_MODE,
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            keywords: GO_KEYWORDS,
	            illegal: /["']/
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/golo.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    return {
	      keywords: {
	        keyword:
	          'println readln print import module function local return let var ' +
	          'while for foreach times in case when match with break continue ' +
	          'augment augmentation each find filter reduce ' +
	          'if then else otherwise try catch finally raise throw orIfNull ' +
	          'DynamicObject|10 DynamicVariable struct Observable map set vector list array',
	        literal:
	          'true false null'
	      },
	      contains: [
	        hljs.HASH_COMMENT_MODE,
	        hljs.QUOTE_STRING_MODE,
	        hljs.C_NUMBER_MODE,
	        {
	          className: 'meta', begin: '@[A-Za-z]+'
	        }
	      ]
	    }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/gradle.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'task project allprojects subprojects artifacts buildscript configurations ' +
	        'dependencies repositories sourceSets description delete from into include ' +
	        'exclude source classpath destinationDir includes options sourceCompatibility ' +
	        'targetCompatibility group flatDir doLast doFirst flatten todir fromdir ant ' +
	        'def abstract break case catch continue default do else extends final finally ' +
	        'for if implements instanceof native new private protected public return static ' +
	        'switch synchronized throw throws transient try volatile while strictfp package ' +
	        'import false null super this true antlrtask checkstyle codenarc copy boolean ' +
	        'byte char class double float int interface long short void compile runTime ' +
	        'file fileTree abs any append asList asWritable call collect compareTo count ' +
	        'div dump each eachByte eachFile eachLine every find findAll flatten getAt ' +
	        'getErr getIn getOut getText grep immutable inject inspect intersect invokeMethods ' +
	        'isCase join leftShift minus multiply newInputStream newOutputStream newPrintWriter ' +
	        'newReader newWriter next plus pop power previous print println push putAt read ' +
	        'readBytes readLines reverse reverseEach round size sort splitEachLine step subMap ' +
	        'times toInteger toList tokenize upto waitForOrKill withPrintWriter withReader ' +
	        'withStream withWriter withWriterAppend write writeLine'
	    },
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.NUMBER_MODE,
	      hljs.REGEXP_MODE
	
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/groovy.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    return {
	        keywords: {
	            literal : 'true false null',
	            keyword:
	            'byte short char int long boolean float double void ' +
	            // groovy specific keywords
	            'def as in assert trait ' +
	            // common keywords with Java
	            'super this abstract static volatile transient public private protected synchronized final ' +
	            'class interface enum if else for while switch case break default continue ' +
	            'throw throws try catch finally implements extends new import package return instanceof'
	        },
	
	        contains: [
	            hljs.COMMENT(
	                '/\\*\\*',
	                '\\*/',
	                {
	                    relevance : 0,
	                    contains : [
	                      {
	                          // eat up @'s in emails to prevent them to be recognized as doctags
	                          begin: /\w+@/, relevance: 0
	                      },
	                      {
	                          className : 'doctag',
	                          begin : '@[A-Za-z]+'
	                      }
	                    ]
	                }
	            ),
	            hljs.C_LINE_COMMENT_MODE,
	            hljs.C_BLOCK_COMMENT_MODE,
	            {
	                className: 'string',
	                begin: '"""', end: '"""'
	            },
	            {
	                className: 'string',
	                begin: "'''", end: "'''"
	            },
	            {
	                className: 'string',
	                begin: "\\$/", end: "/\\$",
	                relevance: 10
	            },
	            hljs.APOS_STRING_MODE,
	            {
	                className: 'regexp',
	                begin: /~?\/[^\/\n]+\//,
	                contains: [
	                    hljs.BACKSLASH_ESCAPE
	                ]
	            },
	            hljs.QUOTE_STRING_MODE,
	            {
	                className: 'meta',
	                begin: "^#!/usr/bin/env", end: '$',
	                illegal: '\n'
	            },
	            hljs.BINARY_NUMBER_MODE,
	            {
	                className: 'class',
	                beginKeywords: 'class interface trait enum', end: '{',
	                illegal: ':',
	                contains: [
	                    {beginKeywords: 'extends implements'},
	                    hljs.UNDERSCORE_TITLE_MODE
	                ]
	            },
	            hljs.C_NUMBER_MODE,
	            {
	                className: 'meta', begin: '@[A-Za-z]+'
	            },
	            {
	                // highlight map keys and named parameters as strings
	                className: 'string', begin: /[^\?]{0}[A-Za-z0-9_$]+ *:/
	            },
	            {
	                // catch middle element of the ternary operator
	                // to avoid highlight it as a label, named parameter, or map key
	                begin: /\?/, end: /\:/
	            },
	            {
	                // highlight labeled statements
	                className: 'symbol', begin: '^\\s*[A-Za-z0-9_$]+:',
	                relevance: 0
	            }
	        ],
	        illegal: /#|<\//
	    }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/haml.js":
/***/ (function(module, exports) {

	module.exports = // TODO support filter tags like :javascript, support inline HTML
	function(hljs) {
	  return {
	    case_insensitive: true,
	    contains: [
	      {
	        className: 'meta',
	        begin: '^!!!( (5|1\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\b.*))?$',
	        relevance: 10
	      },
	      // FIXME these comments should be allowed to span indented lines
	      hljs.COMMENT(
	        '^\\s*(!=#|=#|-#|/).*$',
	        false,
	        {
	          relevance: 0
	        }
	      ),
	      {
	        begin: '^\\s*(-|=|!=)(?!#)',
	        starts: {
	          end: '\\n',
	          subLanguage: 'ruby'
	        }
	      },
	      {
	        className: 'tag',
	        begin: '^\\s*%',
	        contains: [
	          {
	            className: 'selector-tag',
	            begin: '\\w+'
	          },
	          {
	            className: 'selector-id',
	            begin: '#[\\w-]+'
	          },
	          {
	            className: 'selector-class',
	            begin: '\\.[\\w-]+'
	          },
	          {
	            begin: '{\\s*',
	            end: '\\s*}',
	            contains: [
	              {
	                begin: ':\\w+\\s*=>',
	                end: ',\\s+',
	                returnBegin: true,
	                endsWithParent: true,
	                contains: [
	                  {
	                    className: 'attr',
	                    begin: ':\\w+'
	                  },
	                  hljs.APOS_STRING_MODE,
	                  hljs.QUOTE_STRING_MODE,
	                  {
	                    begin: '\\w+',
	                    relevance: 0
	                  }
	                ]
	              }
	            ]
	          },
	          {
	            begin: '\\(\\s*',
	            end: '\\s*\\)',
	            excludeEnd: true,
	            contains: [
	              {
	                begin: '\\w+\\s*=',
	                end: '\\s+',
	                returnBegin: true,
	                endsWithParent: true,
	                contains: [
	                  {
	                    className: 'attr',
	                    begin: '\\w+',
	                    relevance: 0
	                  },
	                  hljs.APOS_STRING_MODE,
	                  hljs.QUOTE_STRING_MODE,
	                  {
	                    begin: '\\w+',
	                    relevance: 0
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      },
	      {
	        begin: '^\\s*[=~]\\s*'
	      },
	      {
	        begin: '#{',
	        starts: {
	          end: '}',
	          subLanguage: 'ruby'
	        }
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/handlebars.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var BUILT_INS = {'builtin-name': 'each in with if else unless bindattr action collection debugger log outlet template unbound view yield'};
	  return {
	    aliases: ['hbs', 'html.hbs', 'html.handlebars'],
	    case_insensitive: true,
	    subLanguage: 'xml',
	    contains: [
	    hljs.COMMENT('{{!(--)?', '(--)?}}'),
	      {
	        className: 'template-tag',
	        begin: /\{\{[#\/]/, end: /\}\}/,
	        contains: [
	          {
	            className: 'name',
	            begin: /[a-zA-Z\.-]+/,
	            keywords: BUILT_INS,
	            starts: {
	              endsWithParent: true, relevance: 0,
	              contains: [
	                hljs.QUOTE_STRING_MODE
	              ]
	            }
	          }
	        ]
	      },
	      {
	        className: 'template-variable',
	        begin: /\{\{/, end: /\}\}/,
	        keywords: BUILT_INS
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/haskell.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var COMMENT = {
	    variants: [
	      hljs.COMMENT('--', '$'),
	      hljs.COMMENT(
	        '{-',
	        '-}',
	        {
	          contains: ['self']
	        }
	      )
	    ]
	  };
	
	  var PRAGMA = {
	    className: 'meta',
	    begin: '{-#', end: '#-}'
	  };
	
	  var PREPROCESSOR = {
	    className: 'meta',
	    begin: '^#', end: '$'
	  };
	
	  var CONSTRUCTOR = {
	    className: 'type',
	    begin: '\\b[A-Z][\\w\']*', // TODO: other constructors (build-in, infix).
	    relevance: 0
	  };
	
	  var LIST = {
	    begin: '\\(', end: '\\)',
	    illegal: '"',
	    contains: [
	      PRAGMA,
	      PREPROCESSOR,
	      {className: 'type', begin: '\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?'},
	      hljs.inherit(hljs.TITLE_MODE, {begin: '[_a-z][\\w\']*'}),
	      COMMENT
	    ]
	  };
	
	  var RECORD = {
	    begin: '{', end: '}',
	    contains: LIST.contains
	  };
	
	  return {
	    aliases: ['hs'],
	    keywords:
	      'let in if then else case of where do module import hiding ' +
	      'qualified type data newtype deriving class instance as default ' +
	      'infix infixl infixr foreign export ccall stdcall cplusplus ' +
	      'jvm dotnet safe unsafe family forall mdo proc rec',
	    contains: [
	
	      // Top-level constructions.
	
	      {
	        beginKeywords: 'module', end: 'where',
	        keywords: 'module where',
	        contains: [LIST, COMMENT],
	        illegal: '\\W\\.|;'
	      },
	      {
	        begin: '\\bimport\\b', end: '$',
	        keywords: 'import qualified as hiding',
	        contains: [LIST, COMMENT],
	        illegal: '\\W\\.|;'
	      },
	
	      {
	        className: 'class',
	        begin: '^(\\s*)?(class|instance)\\b', end: 'where',
	        keywords: 'class family instance where',
	        contains: [CONSTRUCTOR, LIST, COMMENT]
	      },
	      {
	        className: 'class',
	        begin: '\\b(data|(new)?type)\\b', end: '$',
	        keywords: 'data family type newtype deriving',
	        contains: [PRAGMA, CONSTRUCTOR, LIST, RECORD, COMMENT]
	      },
	      {
	        beginKeywords: 'default', end: '$',
	        contains: [CONSTRUCTOR, LIST, COMMENT]
	      },
	      {
	        beginKeywords: 'infix infixl infixr', end: '$',
	        contains: [hljs.C_NUMBER_MODE, COMMENT]
	      },
	      {
	        begin: '\\bforeign\\b', end: '$',
	        keywords: 'foreign import export ccall stdcall cplusplus jvm ' +
	                  'dotnet safe unsafe',
	        contains: [CONSTRUCTOR, hljs.QUOTE_STRING_MODE, COMMENT]
	      },
	      {
	        className: 'meta',
	        begin: '#!\\/usr\\/bin\\/env\ runhaskell', end: '$'
	      },
	
	      // "Whitespaces".
	
	      PRAGMA,
	      PREPROCESSOR,
	
	      // Literals and names.
	
	      // TODO: characters.
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      CONSTRUCTOR,
	      hljs.inherit(hljs.TITLE_MODE, {begin: '^[_a-z][\\w\']*'}),
	
	      COMMENT,
	
	      {begin: '->|<-'} // No markup, relevance booster
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/haxe.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE = '[a-zA-Z_$][a-zA-Z0-9_$]*';
	  var IDENT_FUNC_RETURN_TYPE_RE = '([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)';
	
	  var HAXE_BASIC_TYPES = 'Int Float String Bool Dynamic Void Array ';
	
	  return {
	    aliases: ['hx'],
	    keywords: {
	      keyword: 'break case cast catch continue default do dynamic else enum extern ' +
	               'for function here if import in inline never new override package private get set ' +
	               'public return static super switch this throw trace try typedef untyped using var while ' +
	               HAXE_BASIC_TYPES,
	      built_in:
	        'trace this',
	      literal:
	        'true false null _'
	    },
	    contains: [
	      { className: 'string', // interpolate-able strings
	        begin: '\'', end: '\'',
	        contains: [
	          hljs.BACKSLASH_ESCAPE,
	          { className: 'subst', // interpolation
	            begin: '\\$\\{', end: '\\}'
	          },
	          { className: 'subst', // interpolation
	            begin: '\\$', end: '\\W}'
	          }
	        ]
	      },
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      { className: 'meta', // compiler meta
	        begin: '@:', end: '$'
	      },
	      { className: 'meta', // compiler conditionals
	        begin: '#', end: '$',
	        keywords: {'meta-keyword': 'if else elseif end error'}
	      },
	      { className: 'type', // function types
	        begin: ':[ \t]*', end: '[^A-Za-z0-9_ \t\\->]',
	        excludeBegin: true, excludeEnd: true,
	        relevance: 0
	      },
	      { className: 'type', // types
	        begin: ':[ \t]*', end: '\\W',
	        excludeBegin: true, excludeEnd: true
	      },
	      { className: 'type', // instantiation
	        begin: 'new *', end: '\\W',
	        excludeBegin: true, excludeEnd: true
	      },
	      { className: 'class', // enums
	        beginKeywords: 'enum', end: '\\{',
	        contains: [
	          hljs.TITLE_MODE
	        ]
	      },
	      { className: 'class', // abstracts
	        beginKeywords: 'abstract', end: '[\\{$]',
	        contains: [
	          { className: 'type',
	            begin: '\\(', end: '\\)',
	            excludeBegin: true, excludeEnd: true
	          },
	          { className: 'type',
	            begin: 'from +', end: '\\W',
	            excludeBegin: true, excludeEnd: true
	          },
	          { className: 'type',
	            begin: 'to +', end: '\\W',
	            excludeBegin: true, excludeEnd: true
	          },
	          hljs.TITLE_MODE
	        ],
	        keywords: {
	          keyword: 'abstract from to'
	        }
	      },
	      { className: 'class', // classes
	        begin: '\\b(class|interface) +', end: '[\\{$]',  excludeEnd: true,
	        keywords: 'class interface',
	        contains: [
	          { className: 'keyword',
	            begin: '\\b(extends|implements) +',
	            keywords: 'extends implements',
	            contains: [
	              {
	                className: 'type',
	                begin: hljs.IDENT_RE,
	                relevance: 0
	              }
	            ]
	          },
	          hljs.TITLE_MODE
	        ]
	      },
	      { className: 'function',
	        beginKeywords: 'function', end: '\\(', excludeEnd: true,
	        illegal: '\\S',
	        contains: [
	          hljs.TITLE_MODE
	        ]
	      }
	    ],
	    illegal: /<\//
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/hsp.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    case_insensitive: true,
	    lexemes: /[\w\._]+/,
	    keywords: 'goto gosub return break repeat loop continue wait await dim sdim foreach dimtype dup dupptr end stop newmod delmod mref run exgoto on mcall assert logmes newlab resume yield onexit onerror onkey onclick oncmd exist delete mkdir chdir dirlist bload bsave bcopy memfile if else poke wpoke lpoke getstr chdpm memexpand memcpy memset notesel noteadd notedel noteload notesave randomize noteunsel noteget split strrep setease button chgdisp exec dialog mmload mmplay mmstop mci pset pget syscolor mes print title pos circle cls font sysfont objsize picload color palcolor palette redraw width gsel gcopy gzoom gmode bmpsave hsvcolor getkey listbox chkbox combox input mesbox buffer screen bgscr mouse objsel groll line clrobj boxf objprm objmode stick grect grotate gsquare gradf objimage objskip objenable celload celdiv celput newcom querycom delcom cnvstow comres axobj winobj sendmsg comevent comevarg sarrayconv callfunc cnvwtos comevdisp libptr system hspstat hspver stat cnt err strsize looplev sublev iparam wparam lparam refstr refdval int rnd strlen length length2 length3 length4 vartype gettime peek wpeek lpeek varptr varuse noteinfo instr abs limit getease str strmid strf getpath strtrim sin cos tan atan sqrt double absf expf logf limitf powf geteasef mousex mousey mousew hwnd hinstance hdc ginfo objinfo dirinfo sysinfo thismod __hspver__ __hsp30__ __date__ __time__ __line__ __file__ _debug __hspdef__ and or xor not screen_normal screen_palette screen_hide screen_fixedsize screen_tool screen_frame gmode_gdi gmode_mem gmode_rgb0 gmode_alpha gmode_rgb0alpha gmode_add gmode_sub gmode_pixela ginfo_mx ginfo_my ginfo_act ginfo_sel ginfo_wx1 ginfo_wy1 ginfo_wx2 ginfo_wy2 ginfo_vx ginfo_vy ginfo_sizex ginfo_sizey ginfo_winx ginfo_winy ginfo_mesx ginfo_mesy ginfo_r ginfo_g ginfo_b ginfo_paluse ginfo_dispx ginfo_dispy ginfo_cx ginfo_cy ginfo_intid ginfo_newid ginfo_sx ginfo_sy objinfo_mode objinfo_bmscr objinfo_hwnd notemax notesize dir_cur dir_exe dir_win dir_sys dir_cmdline dir_desktop dir_mydoc dir_tv font_normal font_bold font_italic font_underline font_strikeout font_antialias objmode_normal objmode_guifont objmode_usefont gsquare_grad msgothic msmincho do until while wend for next _break _continue switch case default swbreak swend ddim ldim alloc m_pi rad2deg deg2rad ease_linear ease_quad_in ease_quad_out ease_quad_inout ease_cubic_in ease_cubic_out ease_cubic_inout ease_quartic_in ease_quartic_out ease_quartic_inout ease_bounce_in ease_bounce_out ease_bounce_inout ease_shake_in ease_shake_out ease_shake_inout ease_loop',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.APOS_STRING_MODE,
	
	      {
	        // multi-line string
	        className: 'string',
	        begin: '{"', end: '"}',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	
	      hljs.COMMENT(';', '$', {relevance: 0}),
	
	      {
	        // pre-processor
	        className: 'meta',
	        begin: '#', end: '$',
	        keywords: {'meta-keyword': 'addion cfunc cmd cmpopt comfunc const defcfunc deffunc define else endif enum epack func global if ifdef ifndef include modcfunc modfunc modinit modterm module pack packopt regcmd runtime undef usecom uselib'},
	        contains: [
	          hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'meta-string'}),
	          hljs.NUMBER_MODE,
	          hljs.C_NUMBER_MODE,
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	
	      {
	        // label
	        className: 'symbol',
	        begin: '^\\*(\\w+|@)'
	      },
	
	      hljs.NUMBER_MODE,
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/htmlbars.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var BUILT_INS = 'action collection component concat debugger each each-in else get hash if input link-to loc log mut outlet partial query-params render textarea unbound unless with yield view';
	
	  var ATTR_ASSIGNMENT = {
	    illegal: /\}\}/,
	    begin: /[a-zA-Z0-9_]+=/,
	    returnBegin: true,
	    relevance: 0,
	    contains: [
	      {
	        className: 'attr', begin: /[a-zA-Z0-9_]+/
	      }
	    ]
	  };
	
	  var SUB_EXPR = {
	    illegal: /\}\}/,
	    begin: /\)/, end: /\)/,
	    contains: [
	      {
	        begin: /[a-zA-Z\.\-]+/,
	        keywords: {built_in: BUILT_INS},
	        starts: {
	          endsWithParent: true, relevance: 0,
	          contains: [
	            hljs.QUOTE_STRING_MODE,
	          ]
	        }
	      }
	    ]
	  };
	
	  var TAG_INNARDS = {
	    endsWithParent: true, relevance: 0,
	    keywords: {keyword: 'as', built_in: BUILT_INS},
	    contains: [
	      hljs.QUOTE_STRING_MODE,
	      ATTR_ASSIGNMENT,
	      hljs.NUMBER_MODE
	    ]
	  };
	
	  return {
	    case_insensitive: true,
	    subLanguage: 'xml',
	    contains: [
	      hljs.COMMENT('{{!(--)?', '(--)?}}'),
	      {
	        className: 'template-tag',
	        begin: /\{\{[#\/]/, end: /\}\}/,
	        contains: [
	          {
	            className: 'name',
	            begin: /[a-zA-Z\.\-]+/,
	            keywords: {'builtin-name': BUILT_INS},
	            starts: TAG_INNARDS
	          }
	        ]
	      },
	      {
	        className: 'template-variable',
	        begin: /\{\{[a-zA-Z][a-zA-Z\-]+/, end: /\}\}/,
	        keywords: {keyword: 'as', built_in: BUILT_INS},
	        contains: [
	          hljs.QUOTE_STRING_MODE
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/http.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VERSION = 'HTTP/[0-9\\.]+';
	  return {
	    aliases: ['https'],
	    illegal: '\\S',
	    contains: [
	      {
	        begin: '^' + VERSION, end: '$',
	        contains: [{className: 'number', begin: '\\b\\d{3}\\b'}]
	      },
	      {
	        begin: '^[A-Z]+ (.*?) ' + VERSION + '$', returnBegin: true, end: '$',
	        contains: [
	          {
	            className: 'string',
	            begin: ' ', end: ' ',
	            excludeBegin: true, excludeEnd: true
	          },
	          {
	            begin: VERSION
	          },
	          {
	            className: 'keyword',
	            begin: '[A-Z]+'
	          }
	        ]
	      },
	      {
	        className: 'attribute',
	        begin: '^\\w', end: ': ', excludeEnd: true,
	        illegal: '\\n|\\s|=',
	        starts: {end: '$', relevance: 0}
	      },
	      {
	        begin: '\\n\\n',
	        starts: {subLanguage: [], endsWithParent: true}
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/hy.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var keywords = {
	    'builtin-name':
	      // keywords
	      '!= % %= & &= * ** **= *= *map ' +
	      '+ += , --build-class-- --import-- -= . / // //= ' +
	      '/= < << <<= <= = > >= >> >>= ' +
	      '@ @= ^ ^= abs accumulate all and any ap-compose ' +
	      'ap-dotimes ap-each ap-each-while ap-filter ap-first ap-if ap-last ap-map ap-map-when ap-pipe ' +
	      'ap-reduce ap-reject apply as-> ascii assert assoc bin break butlast ' +
	      'callable calling-module-name car case cdr chain chr coll? combinations compile ' +
	      'compress cond cons cons? continue count curry cut cycle dec ' +
	      'def default-method defclass defmacro defmacro-alias defmacro/g! defmain defmethod defmulti defn ' +
	      'defn-alias defnc defnr defreader defseq del delattr delete-route dict-comp dir ' +
	      'disassemble dispatch-reader-macro distinct divmod do doto drop drop-last drop-while empty? ' +
	      'end-sequence eval eval-and-compile eval-when-compile even? every? except exec filter first ' +
	      'flatten float? fn fnc fnr for for* format fraction genexpr ' +
	      'gensym get getattr global globals group-by hasattr hash hex id ' +
	      'identity if if* if-not if-python2 import in inc input instance? ' +
	      'integer integer-char? integer? interleave interpose is is-coll is-cons is-empty is-even ' +
	      'is-every is-float is-instance is-integer is-integer-char is-iterable is-iterator is-keyword is-neg is-none ' +
	      'is-not is-numeric is-odd is-pos is-string is-symbol is-zero isinstance islice issubclass ' +
	      'iter iterable? iterate iterator? keyword keyword? lambda last len let ' +
	      'lif lif-not list* list-comp locals loop macro-error macroexpand macroexpand-1 macroexpand-all ' +
	      'map max merge-with method-decorator min multi-decorator multicombinations name neg? next ' +
	      'none? nonlocal not not-in not? nth numeric? oct odd? open ' +
	      'or ord partition permutations pos? post-route postwalk pow prewalk print ' +
	      'product profile/calls profile/cpu put-route quasiquote quote raise range read read-str ' +
	      'recursive-replace reduce remove repeat repeatedly repr require rest round route ' +
	      'route-with-methods rwm second seq set-comp setattr setv some sorted string ' +
	      'string? sum switch symbol? take take-nth take-while tee try unless ' +
	      'unquote unquote-splicing vars walk when while with with* with-decorator with-gensyms ' +
	      'xi xor yield yield-from zero? zip zip-longest | |= ~'
	   };
	
	  var SYMBOLSTART = 'a-zA-Z_\\-!.?+*=<>&#\'';
	  var SYMBOL_RE = '[' + SYMBOLSTART + '][' + SYMBOLSTART + '0-9/;:]*';
	  var SIMPLE_NUMBER_RE = '[-+]?\\d+(\\.\\d+)?';
	
	  var SHEBANG = {
	    className: 'meta',
	    begin: '^#!', end: '$'
	  };
	
	  var SYMBOL = {
	    begin: SYMBOL_RE,
	    relevance: 0
	  };
	  var NUMBER = {
	    className: 'number', begin: SIMPLE_NUMBER_RE,
	    relevance: 0
	  };
	  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
	  var COMMENT = hljs.COMMENT(
	    ';',
	    '$',
	    {
	      relevance: 0
	    }
	  );
	  var LITERAL = {
	    className: 'literal',
	    begin: /\b([Tt]rue|[Ff]alse|nil|None)\b/
	  };
	  var COLLECTION = {
	    begin: '[\\[\\{]', end: '[\\]\\}]'
	  };
	  var HINT = {
	    className: 'comment',
	    begin: '\\^' + SYMBOL_RE
	  };
	  var HINT_COL = hljs.COMMENT('\\^\\{', '\\}');
	  var KEY = {
	    className: 'symbol',
	    begin: '[:]{1,2}' + SYMBOL_RE
	  };
	  var LIST = {
	    begin: '\\(', end: '\\)'
	  };
	  var BODY = {
	    endsWithParent: true,
	    relevance: 0
	  };
	  var NAME = {
	    keywords: keywords,
	    lexemes: SYMBOL_RE,
	    className: 'name', begin: SYMBOL_RE,
	    starts: BODY
	  };
	  var DEFAULT_CONTAINS = [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL, SYMBOL];
	
	  LIST.contains = [hljs.COMMENT('comment', ''), NAME, BODY];
	  BODY.contains = DEFAULT_CONTAINS;
	  COLLECTION.contains = DEFAULT_CONTAINS;
	
	  return {
	    aliases: ['hylang'],
	    illegal: /\S/,
	    contains: [SHEBANG, LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/inform7.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var START_BRACKET = '\\[';
	  var END_BRACKET = '\\]';
	  return {
	    aliases: ['i7'],
	    case_insensitive: true,
	    keywords: {
	      // Some keywords more or less unique to I7, for relevance.
	      keyword:
	        // kind:
	        'thing room person man woman animal container ' +
	        'supporter backdrop door ' +
	        // characteristic:
	        'scenery open closed locked inside gender ' +
	        // verb:
	        'is are say understand ' +
	        // misc keyword:
	        'kind of rule'
	    },
	    contains: [
	      {
	        className: 'string',
	        begin: '"', end: '"',
	        relevance: 0,
	        contains: [
	          {
	            className: 'subst',
	            begin: START_BRACKET, end: END_BRACKET
	          }
	        ]
	      },
	      {
	        className: 'section',
	        begin: /^(Volume|Book|Part|Chapter|Section|Table)\b/,
	        end: '$'
	      },
	      {
	        // Rule definition
	        // This is here for relevance.
	        begin: /^(Check|Carry out|Report|Instead of|To|Rule|When|Before|After)\b/,
	        end: ':',
	        contains: [
	          {
	            //Rule name
	            begin: '\\(This', end: '\\)'
	          }
	        ]
	      },
	      {
	        className: 'comment',
	        begin: START_BRACKET, end: END_BRACKET,
	        contains: ['self']
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/ini.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var STRING = {
	    className: "string",
	    contains: [hljs.BACKSLASH_ESCAPE],
	    variants: [
	      {
	        begin: "'''", end: "'''",
	        relevance: 10
	      }, {
	        begin: '"""', end: '"""',
	        relevance: 10
	      }, {
	        begin: '"', end: '"'
	      }, {
	        begin: "'", end: "'"
	      }
	    ]
	  };
	  return {
	    aliases: ['toml'],
	    case_insensitive: true,
	    illegal: /\S/,
	    contains: [
	      hljs.COMMENT(';', '$'),
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'section',
	        begin: /^\s*\[+/, end: /\]+/
	      },
	      {
	        begin: /^[a-z0-9\[\]_-]+\s*=\s*/, end: '$',
	        returnBegin: true,
	        contains: [
	          {
	            className: 'attr',
	            begin: /[a-z0-9\[\]_-]+/
	          },
	          {
	            begin: /=/, endsWithParent: true,
	            relevance: 0,
	            contains: [
	              {
	                className: 'literal',
	                begin: /\bon|off|true|false|yes|no\b/
	              },
	              {
	                className: 'variable',
	                variants: [
	                  {begin: /\$[\w\d"][\w\d_]*/},
	                  {begin: /\$\{(.*?)}/}
	                ]
	              },
	              STRING,
	              {
	                className: 'number',
	                begin: /([\+\-]+)?[\d]+_[\d_]+/
	              },
	              hljs.NUMBER_MODE
	            ]
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/irpf90.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)'
	  };
	
	  var F_KEYWORDS = {
	    literal: '.False. .True.',
	    keyword: 'kind do while private call intrinsic where elsewhere ' +
	      'type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then ' +
	      'public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. ' +
	      'goto save else use module select case ' +
	      'access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit ' +
	      'continue format pause cycle exit ' +
	      'c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg ' +
	      'synchronous nopass non_overridable pass protected volatile abstract extends import ' +
	      'non_intrinsic value deferred generic final enumerator class associate bind enum ' +
	      'c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t ' +
	      'c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double ' +
	      'c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr ' +
	      'c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer ' +
	      'c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor ' +
	      'numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ' +
	      'ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive ' +
	      'pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure ' +
	      'integer real character complex logical dimension allocatable|10 parameter ' +
	      'external implicit|10 none double precision assign intent optional pointer ' +
	      'target in out common equivalence data ' +
	      // IRPF90 special keywords
	      'begin_provider &begin_provider end_provider begin_shell end_shell begin_template end_template subst assert touch ' +
	      'soft_touch provide no_dep free irp_if irp_else irp_endif irp_write irp_read',
	    built_in: 'alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint ' +
	      'dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl ' +
	      'algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama ' +
	      'iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod ' +
	      'qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log ' +
	      'log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate ' +
	      'adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product ' +
	      'eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul ' +
	      'maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product ' +
	      'radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind ' +
	      'set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer ' +
	      'dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ' +
	      'ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode ' +
	      'is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of'  +
	      'acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 ' +
	      'atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits ' +
	      'bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr ' +
	      'num_images parity popcnt poppar shifta shiftl shiftr this_image ' +
	      // IRPF90 special built_ins
	      'IRP_ALIGN irp_here'
	  };
	  return {
	    case_insensitive: true,
	    keywords: F_KEYWORDS,
	    illegal: /\/\*/,
	    contains: [
	      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'string', relevance: 0}),
	      {
	        className: 'function',
	        beginKeywords: 'subroutine function program',
	        illegal: '[${=\\n]',
	        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
	      },
	      hljs.COMMENT('!', '$', {relevance: 0}),
	      hljs.COMMENT('begin_doc', 'end_doc', {relevance: 10}),
	      {
	        className: 'number',
	        begin: '(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?',
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/java.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var JAVA_IDENT_RE = '[\u00C0-\u02B8a-zA-Z_$][\u00C0-\u02B8a-zA-Z_$0-9]*';
	  var GENERIC_IDENT_RE = JAVA_IDENT_RE + '(<' + JAVA_IDENT_RE + '(\\s*,\\s*' + JAVA_IDENT_RE + ')*>)?';
	  var KEYWORDS =
	    'false synchronized int abstract float private char boolean static null if const ' +
	    'for true while long strictfp finally protected import native final void ' +
	    'enum else break transient catch instanceof byte super volatile case assert short ' +
	    'package default double public try this switch continue throws protected public private ' +
	    'module requires exports do';
	
	  // https://docs.oracle.com/javase/7/docs/technotes/guides/language/underscores-literals.html
	  var JAVA_NUMBER_RE = '\\b' +
	    '(' +
	      '0[bB]([01]+[01_]+[01]+|[01]+)' + // 0b...
	      '|' +
	      '0[xX]([a-fA-F0-9]+[a-fA-F0-9_]+[a-fA-F0-9]+|[a-fA-F0-9]+)' + // 0x...
	      '|' +
	      '(' +
	        '([\\d]+[\\d_]+[\\d]+|[\\d]+)(\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))?' +
	        '|' +
	        '\\.([\\d]+[\\d_]+[\\d]+|[\\d]+)' +
	      ')' +
	      '([eE][-+]?\\d+)?' + // octal, decimal, float
	    ')' +
	    '[lLfF]?';
	  var JAVA_NUMBER_MODE = {
	    className: 'number',
	    begin: JAVA_NUMBER_RE,
	    relevance: 0
	  };
	
	  return {
	    aliases: ['jsp'],
	    keywords: KEYWORDS,
	    illegal: /<\/|#/,
	    contains: [
	      hljs.COMMENT(
	        '/\\*\\*',
	        '\\*/',
	        {
	          relevance : 0,
	          contains : [
	            {
	              // eat up @'s in emails to prevent them to be recognized as doctags
	              begin: /\w+@/, relevance: 0
	            },
	            {
	              className : 'doctag',
	              begin : '@[A-Za-z]+'
	            }
	          ]
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: /[{;=]/, excludeEnd: true,
	        keywords: 'class interface',
	        illegal: /[:"\[\]]/,
	        contains: [
	          {beginKeywords: 'extends implements'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        // Expression keywords prevent 'keyword Name(...)' from being
	        // recognized as a function definition
	        beginKeywords: 'new throw return else',
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: '(' + GENERIC_IDENT_RE + '\\s+)+' + hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true, end: /[{;=]/,
	        excludeEnd: true,
	        keywords: KEYWORDS,
	        contains: [
	          {
	            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
	            relevance: 0,
	            contains: [hljs.UNDERSCORE_TITLE_MODE]
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            keywords: KEYWORDS,
	            relevance: 0,
	            contains: [
	              hljs.APOS_STRING_MODE,
	              hljs.QUOTE_STRING_MODE,
	              hljs.C_NUMBER_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      JAVA_NUMBER_MODE,
	      {
	        className: 'meta', begin: '@[A-Za-z]+'
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/javascript.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
	  var KEYWORDS = {
	    keyword:
	      'in of if for while finally var new function do return void else break catch ' +
	      'instanceof with throw case default try this switch continue typeof delete ' +
	      'let yield const export super debugger as async await static ' +
	      // ECMAScript 6 modules import
	      'import from as'
	    ,
	    literal:
	      'true false null undefined NaN Infinity',
	    built_in:
	      'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
	      'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
	      'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
	      'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
	      'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
	      'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
	      'module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect ' +
	      'Promise'
	  };
	  var EXPRESSIONS;
	  var NUMBER = {
	    className: 'number',
	    variants: [
	      { begin: '\\b(0[bB][01]+)' },
	      { begin: '\\b(0[oO][0-7]+)' },
	      { begin: hljs.C_NUMBER_RE }
	    ],
	    relevance: 0
	  };
	  var SUBST = {
	    className: 'subst',
	    begin: '\\$\\{', end: '\\}',
	    keywords: KEYWORDS,
	    contains: []  // defined later
	  };
	  var TEMPLATE_STRING = {
	    className: 'string',
	    begin: '`', end: '`',
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      SUBST
	    ]
	  };
	  SUBST.contains = [
	    hljs.APOS_STRING_MODE,
	    hljs.QUOTE_STRING_MODE,
	    TEMPLATE_STRING,
	    NUMBER,
	    hljs.REGEXP_MODE
	  ]
	  var PARAMS_CONTAINS = SUBST.contains.concat([
	    hljs.C_BLOCK_COMMENT_MODE,
	    hljs.C_LINE_COMMENT_MODE
	  ]);
	
	  return {
	    aliases: ['js', 'jsx'],
	    keywords: KEYWORDS,
	    contains: [
	      {
	        className: 'meta',
	        relevance: 10,
	        begin: /^\s*['"]use (strict|asm)['"]/
	      },
	      {
	        className: 'meta',
	        begin: /^#!/, end: /$/
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      TEMPLATE_STRING,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      NUMBER,
	      { // object attr container
	        begin: /[{,]\s*/, relevance: 0,
	        contains: [
	          {
	            begin: IDENT_RE + '\\s*:', returnBegin: true,
	            relevance: 0,
	            contains: [{className: 'attr', begin: IDENT_RE, relevance: 0}]
	          }
	        ]
	      },
	      { // "value" container
	        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
	        keywords: 'return throw case',
	        contains: [
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          hljs.REGEXP_MODE,
	          {
	            className: 'function',
	            begin: '(\\(.*?\\)|' + IDENT_RE + ')\\s*=>', returnBegin: true,
	            end: '\\s*=>',
	            contains: [
	              {
	                className: 'params',
	                variants: [
	                  {
	                    begin: IDENT_RE
	                  },
	                  {
	                    begin: /\(\s*\)/,
	                  },
	                  {
	                    begin: /\(/, end: /\)/,
	                    excludeBegin: true, excludeEnd: true,
	                    keywords: KEYWORDS,
	                    contains: PARAMS_CONTAINS
	                  }
	                ]
	              }
	            ]
	          },
	          { // E4X / JSX
	            begin: /</, end: /(\/\w+|\w+\/)>/,
	            subLanguage: 'xml',
	            contains: [
	              {begin: /<\w+\s*\/>/, skip: true},
	              {
	                begin: /<\w+/, end: /(\/\w+|\w+\/)>/, skip: true,
	                contains: [
	                  {begin: /<\w+\s*\/>/, skip: true},
	                  'self'
	                ]
	              }
	            ]
	          }
	        ],
	        relevance: 0
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: /\{/, excludeEnd: true,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE}),
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            excludeBegin: true,
	            excludeEnd: true,
	            contains: PARAMS_CONTAINS
	          }
	        ],
	        illegal: /\[|%/
	      },
	      {
	        begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
	      },
	      hljs.METHOD_GUARD,
	      { // ES6 class
	        className: 'class',
	        beginKeywords: 'class', end: /[{;=]/, excludeEnd: true,
	        illegal: /[:"\[\]]/,
	        contains: [
	          {beginKeywords: 'extends'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        beginKeywords: 'constructor', end: /\{/, excludeEnd: true
	      }
	    ],
	    illegal: /#(?!!)/
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/jboss-cli.js":
/***/ (function(module, exports) {

	module.exports = function (hljs) {
	  var PARAM = {
	    begin: /[\w-]+ *=/, returnBegin: true,
	    relevance: 0,
	    contains: [{className: 'attr', begin: /[\w-]+/}]
	  };
	  var PARAMSBLOCK = {
	    className: 'params',
	    begin: /\(/,
	    end: /\)/,
	    contains: [PARAM],
	    relevance : 0
	  };
	  var OPERATION = {
	    className: 'function',
	    begin: /:[\w\-.]+/,
	    relevance: 0
	  };
	  var PATH = {
	    className: 'string',
	    begin: /\B(([\/.])[\w\-.\/=]+)+/,
	  };
	  var COMMAND_PARAMS = {
	    className: 'params',
	    begin: /--[\w\-=\/]+/,
	  };
	  return {
	    aliases: ['wildfly-cli'],
	    lexemes: '[a-z\-]+',
	    keywords: {
	      keyword: 'alias batch cd clear command connect connection-factory connection-info data-source deploy ' +
	      'deployment-info deployment-overlay echo echo-dmr help history if jdbc-driver-info jms-queue|20 jms-topic|20 ls ' +
	      'patch pwd quit read-attribute read-operation reload rollout-plan run-batch set shutdown try unalias ' +
	      'undeploy unset version xa-data-source', // module
	      literal: 'true false'
	    },
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      COMMAND_PARAMS,
	      OPERATION,
	      PATH,
	      PARAMSBLOCK
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/json.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var LITERALS = {literal: 'true false null'};
	  var TYPES = [
	    hljs.QUOTE_STRING_MODE,
	    hljs.C_NUMBER_MODE
	  ];
	  var VALUE_CONTAINER = {
	    end: ',', endsWithParent: true, excludeEnd: true,
	    contains: TYPES,
	    keywords: LITERALS
	  };
	  var OBJECT = {
	    begin: '{', end: '}',
	    contains: [
	      {
	        className: 'attr',
	        begin: /"/, end: /"/,
	        contains: [hljs.BACKSLASH_ESCAPE],
	        illegal: '\\n',
	      },
	      hljs.inherit(VALUE_CONTAINER, {begin: /:/})
	    ],
	    illegal: '\\S'
	  };
	  var ARRAY = {
	    begin: '\\[', end: '\\]',
	    contains: [hljs.inherit(VALUE_CONTAINER)], // inherit is a workaround for a bug that makes shared modes with endsWithParent compile only the ending of one of the parents
	    illegal: '\\S'
	  };
	  TYPES.splice(TYPES.length, 0, OBJECT, ARRAY);
	  return {
	    contains: TYPES,
	    keywords: LITERALS,
	    illegal: '\\S'
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/julia-repl.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    contains: [
	      {
	        className: 'meta',
	        begin: /^julia>/,
	        relevance: 10,
	        starts: {
	          // end the highlighting if we are on a new line and the line does not have at
	          // least six spaces in the beginning
	          end: /^(?![ ]{6})/,
	          subLanguage: 'julia'
	      },
	      // jldoctest Markdown blocks are used in the Julia manual and package docs indicate
	      // code snippets that should be verified when the documentation is built. They can be
	      // either REPL-like or script-like, but are usually REPL-like and therefore we apply
	      // julia-repl highlighting to them. More information can be found in Documenter's
	      // manual: https://juliadocs.github.io/Documenter.jl/latest/man/doctests.html
	      aliases: ['jldoctest']
	      }
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/julia.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  // Since there are numerous special names in Julia, it is too much trouble
	  // to maintain them by hand. Hence these names (i.e. keywords, literals and
	  // built-ins) are automatically generated from Julia v0.6 itself through
	  // the following scripts for each.
	
	  var KEYWORDS = {
	    // # keyword generator, multi-word keywords handled manually below
	    // foreach(println, ["in", "isa", "where"])
	    // for kw in Base.REPLCompletions.complete_keyword("")
	    //     if !(contains(kw, " ") || kw == "struct")
	    //         println(kw)
	    //     end
	    // end
	    keyword:
	      'in isa where ' +
	      'baremodule begin break catch ccall const continue do else elseif end export false finally for function ' +
	      'global if import importall let local macro module quote return true try using while ' +
	      // legacy, to be deprecated in the next release
	      'type immutable abstract bitstype typealias ',
	
	    // # literal generator
	    // println("true")
	    // println("false")
	    // for name in Base.REPLCompletions.completions("", 0)[1]
	    //     try
	    //         v = eval(Symbol(name))
	    //         if !(v isa Function || v isa Type || v isa TypeVar || v isa Module || v isa Colon)
	    //             println(name)
	    //         end
	    //     end
	    // end
	    literal:
	      'true false ' +
	      'ARGS C_NULL DevNull ENDIAN_BOM ENV I Inf Inf16 Inf32 Inf64 InsertionSort JULIA_HOME LOAD_PATH MergeSort ' +
	      'NaN NaN16 NaN32 NaN64 PROGRAM_FILE QuickSort RoundDown RoundFromZero RoundNearest RoundNearestTiesAway ' +
	      'RoundNearestTiesUp RoundToZero RoundUp STDERR STDIN STDOUT VERSION catalan e|0 eu|0 eulergamma golden im ' +
	      'nothing pi γ π φ ',
	
	    // # built_in generator:
	    // for name in Base.REPLCompletions.completions("", 0)[1]
	    //     try
	    //         v = eval(Symbol(name))
	    //         if v isa Type || v isa TypeVar
	    //             println(name)
	    //         end
	    //     end
	    // end
	    built_in:
	      'ANY AbstractArray AbstractChannel AbstractFloat AbstractMatrix AbstractRNG AbstractSerializer AbstractSet ' +
	      'AbstractSparseArray AbstractSparseMatrix AbstractSparseVector AbstractString AbstractUnitRange AbstractVecOrMat ' +
	      'AbstractVector Any ArgumentError Array AssertionError Associative Base64DecodePipe Base64EncodePipe Bidiagonal '+
	      'BigFloat BigInt BitArray BitMatrix BitVector Bool BoundsError BufferStream CachingPool CapturedException ' +
	      'CartesianIndex CartesianRange Cchar Cdouble Cfloat Channel Char Cint Cintmax_t Clong Clonglong ClusterManager ' +
	      'Cmd CodeInfo Colon Complex Complex128 Complex32 Complex64 CompositeException Condition ConjArray ConjMatrix ' +
	      'ConjVector Cptrdiff_t Cshort Csize_t Cssize_t Cstring Cuchar Cuint Cuintmax_t Culong Culonglong Cushort Cwchar_t ' +
	      'Cwstring DataType Date DateFormat DateTime DenseArray DenseMatrix DenseVecOrMat DenseVector Diagonal Dict ' +
	      'DimensionMismatch Dims DirectIndexString Display DivideError DomainError EOFError EachLine Enum Enumerate ' +
	      'ErrorException Exception ExponentialBackOff Expr Factorization FileMonitor Float16 Float32 Float64 Function ' +
	      'Future GlobalRef GotoNode HTML Hermitian IO IOBuffer IOContext IOStream IPAddr IPv4 IPv6 IndexCartesian IndexLinear ' +
	      'IndexStyle InexactError InitError Int Int128 Int16 Int32 Int64 Int8 IntSet Integer InterruptException ' +
	      'InvalidStateException Irrational KeyError LabelNode LinSpace LineNumberNode LoadError LowerTriangular MIME Matrix ' +
	      'MersenneTwister Method MethodError MethodTable Module NTuple NewvarNode NullException Nullable Number ObjectIdDict ' +
	      'OrdinalRange OutOfMemoryError OverflowError Pair ParseError PartialQuickSort PermutedDimsArray Pipe ' +
	      'PollingFileWatcher ProcessExitedException Ptr QuoteNode RandomDevice Range RangeIndex Rational RawFD ' +
	      'ReadOnlyMemoryError Real ReentrantLock Ref Regex RegexMatch RemoteChannel RemoteException RevString RoundingMode ' +
	      'RowVector SSAValue SegmentationFault SerializationState Set SharedArray SharedMatrix SharedVector Signed ' +
	      'SimpleVector Slot SlotNumber SparseMatrixCSC SparseVector StackFrame StackOverflowError StackTrace StepRange ' +
	      'StepRangeLen StridedArray StridedMatrix StridedVecOrMat StridedVector String SubArray SubString SymTridiagonal ' +
	      'Symbol Symmetric SystemError TCPSocket Task Text TextDisplay Timer Tridiagonal Tuple Type TypeError TypeMapEntry ' +
	      'TypeMapLevel TypeName TypeVar TypedSlot UDPSocket UInt UInt128 UInt16 UInt32 UInt64 UInt8 UndefRefError UndefVarError ' +
	      'UnicodeError UniformScaling Union UnionAll UnitRange Unsigned UpperTriangular Val Vararg VecElement VecOrMat Vector ' +
	      'VersionNumber Void WeakKeyDict WeakRef WorkerConfig WorkerPool '
	  };
	
	  // ref: http://julia.readthedocs.org/en/latest/manual/variables/#allowed-variable-names
	  var VARIABLE_NAME_RE = '[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*';
	
	  // placeholder for recursive self-reference
	  var DEFAULT = {
	    lexemes: VARIABLE_NAME_RE, keywords: KEYWORDS, illegal: /<\//
	  };
	
	  // ref: http://julia.readthedocs.org/en/latest/manual/integers-and-floating-point-numbers/
	  var NUMBER = {
	    className: 'number',
	    // supported numeric literals:
	    //  * binary literal (e.g. 0x10)
	    //  * octal literal (e.g. 0o76543210)
	    //  * hexadecimal literal (e.g. 0xfedcba876543210)
	    //  * hexadecimal floating point literal (e.g. 0x1p0, 0x1.2p2)
	    //  * decimal literal (e.g. 9876543210, 100_000_000)
	    //  * floating pointe literal (e.g. 1.2, 1.2f, .2, 1., 1.2e10, 1.2e-10)
	    begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
	    relevance: 0
	  };
	
	  var CHAR = {
	    className: 'string',
	    begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
	  };
	
	  var INTERPOLATION = {
	    className: 'subst',
	    begin: /\$\(/, end: /\)/,
	    keywords: KEYWORDS
	  };
	
	  var INTERPOLATED_VARIABLE = {
	    className: 'variable',
	    begin: '\\$' + VARIABLE_NAME_RE
	  };
	
	  // TODO: neatly escape normal code in string literal
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
	    variants: [
	      { begin: /\w*"""/, end: /"""\w*/, relevance: 10 },
	      { begin: /\w*"/, end: /"\w*/ }
	    ]
	  };
	
	  var COMMAND = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
	    begin: '`', end: '`'
	  };
	
	  var MACROCALL = {
	    className: 'meta',
	    begin: '@' + VARIABLE_NAME_RE
	  };
	
	  var COMMENT = {
	    className: 'comment',
	    variants: [
	      { begin: '#=', end: '=#', relevance: 10 },
	      { begin: '#', end: '$' }
	    ]
	  };
	
	  DEFAULT.contains = [
	    NUMBER,
	    CHAR,
	    STRING,
	    COMMAND,
	    MACROCALL,
	    COMMENT,
	    hljs.HASH_COMMENT_MODE,
	    {
	      className: 'keyword',
	      begin:
	        '\\b(((abstract|primitive)\\s+)type|(mutable\\s+)?struct)\\b'
	    },
	    {begin: /<:/}  // relevance booster
	  ];
	  INTERPOLATION.contains = DEFAULT.contains;
	
	  return DEFAULT;
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/kotlin.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      'abstract as val var vararg get set class object open private protected public noinline ' +
	      'crossinline dynamic final enum if else do while for when throw try catch finally ' +
	      'import package is in fun override companion reified inline lateinit init' +
	      'interface annotation data sealed internal infix operator out by constructor super ' +
	      // to be deleted soon
	      'trait volatile transient native default',
	    built_in:
	      'Byte Short Char Int Long Boolean Float Double Void Unit Nothing',
	    literal:
	      'true false null'
	  };
	  var KEYWORDS_WITH_LABEL = {
	    className: 'keyword',
	    begin: /\b(break|continue|return|this)\b/,
	    starts: {
	      contains: [
	        {
	          className: 'symbol',
	          begin: /@\w+/
	        }
	      ]
	    }
	  };
	  var LABEL = {
	    className: 'symbol', begin: hljs.UNDERSCORE_IDENT_RE + '@'
	  };
	
	  // for string templates
	  var SUBST = {
	    className: 'subst',
	    begin: '\\${', end: '}', contains: [hljs.APOS_STRING_MODE, hljs.C_NUMBER_MODE]
	  };
	  var VARIABLE = {
	    className: 'variable', begin: '\\$' + hljs.UNDERSCORE_IDENT_RE
	  };
	  var STRING = {
	    className: 'string',
	    variants: [
	      {
	        begin: '"""', end: '"""',
	        contains: [VARIABLE, SUBST]
	      },
	      // Can't use built-in modes easily, as we want to use STRING in the meta
	      // context as 'meta-string' and there's no syntax to remove explicitly set
	      // classNames in built-in modes.
	      {
	        begin: '\'', end: '\'',
	        illegal: /\n/,
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        begin: '"', end: '"',
	        illegal: /\n/,
	        contains: [hljs.BACKSLASH_ESCAPE, VARIABLE, SUBST]
	      }
	    ]
	  };
	
	  var ANNOTATION_USE_SITE = {
	    className: 'meta', begin: '@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*' + hljs.UNDERSCORE_IDENT_RE + ')?'
	  };
	  var ANNOTATION = {
	    className: 'meta', begin: '@' + hljs.UNDERSCORE_IDENT_RE,
	    contains: [
	      {
	        begin: /\(/, end: /\)/,
	        contains: [
	          hljs.inherit(STRING, {className: 'meta-string'})
	        ]
	      }
	    ]
	  };
	
	  return {
	    keywords: KEYWORDS,
	    contains : [
	      hljs.COMMENT(
	        '/\\*\\*',
	        '\\*/',
	        {
	          relevance : 0,
	          contains : [{
	            className : 'doctag',
	            begin : '@[A-Za-z]+'
	          }]
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      KEYWORDS_WITH_LABEL,
	      LABEL,
	      ANNOTATION_USE_SITE,
	      ANNOTATION,
	      {
	        className: 'function',
	        beginKeywords: 'fun', end: '[(]|$',
	        returnBegin: true,
	        excludeEnd: true,
	        keywords: KEYWORDS,
	        illegal: /fun\s+(<.*>)?[^\s\(]+(\s+[^\s\(]+)\s*=/,
	        relevance: 5,
	        contains: [
	          {
	            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
	            relevance: 0,
	            contains: [hljs.UNDERSCORE_TITLE_MODE]
	          },
	          {
	            className: 'type',
	            begin: /</, end: />/, keywords: 'reified',
	            relevance: 0
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            endsParent: true,
	            keywords: KEYWORDS,
	            relevance: 0,
	            contains: [
	              {
	                begin: /:/, end: /[=,\/]/, endsWithParent: true,
	                contains: [
	                  {className: 'type', begin: hljs.UNDERSCORE_IDENT_RE},
	                  hljs.C_LINE_COMMENT_MODE,
	                  hljs.C_BLOCK_COMMENT_MODE
	                ],
	                relevance: 0
	              },
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              ANNOTATION_USE_SITE,
	              ANNOTATION,
	              STRING,
	              hljs.C_NUMBER_MODE
	            ]
	          },
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface trait', end: /[:\{(]|$/, // remove 'trait' when removed from KEYWORDS
	        excludeEnd: true,
	        illegal: 'extends implements',
	        contains: [
	          {beginKeywords: 'public protected internal private constructor'},
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            className: 'type',
	            begin: /</, end: />/, excludeBegin: true, excludeEnd: true,
	            relevance: 0
	          },
	          {
	            className: 'type',
	            begin: /[,:]\s*/, end: /[<\(,]|$/, excludeBegin: true, returnEnd: true
	          },
	          ANNOTATION_USE_SITE,
	          ANNOTATION
	        ]
	      },
	      STRING,
	      {
	        className: 'meta',
	        begin: "^#!/usr/bin/env", end: '$',
	        illegal: '\n'
	      },
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/lasso.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var LASSO_IDENT_RE = '[a-zA-Z_][\\w.]*';
	  var LASSO_ANGLE_RE = '<\\?(lasso(script)?|=)';
	  var LASSO_CLOSE_RE = '\\]|\\?>';
	  var LASSO_KEYWORDS = {
	    literal:
	      'true false none minimal full all void and or not ' +
	      'bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft',
	    built_in:
	      'array date decimal duration integer map pair string tag xml null ' +
	      'boolean bytes keyword list locale queue set stack staticarray ' +
	      'local var variable global data self inherited currentcapture givenblock',
	    keyword:
	      'cache database_names database_schemanames database_tablenames ' +
	      'define_tag define_type email_batch encode_set html_comment handle ' +
	      'handle_error header if inline iterate ljax_target link ' +
	      'link_currentaction link_currentgroup link_currentrecord link_detail ' +
	      'link_firstgroup link_firstrecord link_lastgroup link_lastrecord ' +
	      'link_nextgroup link_nextrecord link_prevgroup link_prevrecord log ' +
	      'loop namespace_using output_none portal private protect records ' +
	      'referer referrer repeating resultset rows search_args ' +
	      'search_arguments select sort_args sort_arguments thread_atomic ' +
	      'value_list while abort case else fail_if fail_ifnot fail if_empty ' +
	      'if_false if_null if_true loop_abort loop_continue loop_count params ' +
	      'params_up return return_value run_children soap_definetag ' +
	      'soap_lastrequest soap_lastresponse tag_name ascending average by ' +
	      'define descending do equals frozen group handle_failure import in ' +
	      'into join let match max min on order parent protected provide public ' +
	      'require returnhome skip split_thread sum take thread to trait type ' +
	      'where with yield yieldhome'
	  };
	  var HTML_COMMENT = hljs.COMMENT(
	    '<!--',
	    '-->',
	    {
	      relevance: 0
	    }
	  );
	  var LASSO_NOPROCESS = {
	    className: 'meta',
	    begin: '\\[noprocess\\]',
	    starts: {
	      end: '\\[/noprocess\\]',
	      returnEnd: true,
	      contains: [HTML_COMMENT]
	    }
	  };
	  var LASSO_START = {
	    className: 'meta',
	    begin: '\\[/noprocess|' + LASSO_ANGLE_RE
	  };
	  var LASSO_DATAMEMBER = {
	    className: 'symbol',
	    begin: '\'' + LASSO_IDENT_RE + '\''
	  };
	  var LASSO_CODE = [
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    hljs.inherit(hljs.C_NUMBER_MODE, {begin: hljs.C_NUMBER_RE + '|(-?infinity|NaN)\\b'}),
	    hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	    hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	    {
	      className: 'string',
	      begin: '`', end: '`'
	    },
	    { // variables
	      variants: [
	        {
	          begin: '[#$]' + LASSO_IDENT_RE
	        },
	        {
	          begin: '#', end: '\\d+',
	          illegal: '\\W'
	        }
	      ]
	    },
	    {
	      className: 'type',
	      begin: '::\\s*', end: LASSO_IDENT_RE,
	      illegal: '\\W'
	    },
	    {
	      className: 'params',
	      variants: [
	        {
	          begin: '-(?!infinity)' + LASSO_IDENT_RE,
	          relevance: 0
	        },
	        {
	          begin: '(\\.\\.\\.)'
	        }
	      ]
	    },
	    {
	      begin: /(->|\.)\s*/,
	      relevance: 0,
	      contains: [LASSO_DATAMEMBER]
	    },
	    {
	      className: 'class',
	      beginKeywords: 'define',
	      returnEnd: true, end: '\\(|=>',
	      contains: [
	        hljs.inherit(hljs.TITLE_MODE, {begin: LASSO_IDENT_RE + '(=(?!>))?|[-+*/%](?!>)'})
	      ]
	    }
	  ];
	  return {
	    aliases: ['ls', 'lassoscript'],
	    case_insensitive: true,
	    lexemes: LASSO_IDENT_RE + '|&[lg]t;',
	    keywords: LASSO_KEYWORDS,
	    contains: [
	      {
	        className: 'meta',
	        begin: LASSO_CLOSE_RE,
	        relevance: 0,
	        starts: { // markup
	          end: '\\[|' + LASSO_ANGLE_RE,
	          returnEnd: true,
	          relevance: 0,
	          contains: [HTML_COMMENT]
	        }
	      },
	      LASSO_NOPROCESS,
	      LASSO_START,
	      {
	        className: 'meta',
	        begin: '\\[no_square_brackets',
	        starts: {
	          end: '\\[/no_square_brackets\\]', // not implemented in the language
	          lexemes: LASSO_IDENT_RE + '|&[lg]t;',
	          keywords: LASSO_KEYWORDS,
	          contains: [
	            {
	              className: 'meta',
	              begin: LASSO_CLOSE_RE,
	              relevance: 0,
	              starts: {
	                end: '\\[noprocess\\]|' + LASSO_ANGLE_RE,
	                returnEnd: true,
	                contains: [HTML_COMMENT]
	              }
	            },
	            LASSO_NOPROCESS,
	            LASSO_START
	          ].concat(LASSO_CODE)
	        }
	      },
	      {
	        className: 'meta',
	        begin: '\\[',
	        relevance: 0
	      },
	      {
	        className: 'meta',
	        begin: '^#!', end:'lasso9$',
	        relevance: 10
	      }
	    ].concat(LASSO_CODE)
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/ldif.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    contains: [
	      {
	        className: 'attribute',
	        begin: '^dn', end: ': ', excludeEnd: true,
	        starts: {end: '$', relevance: 0},
	        relevance: 10
	      },
	      {
	        className: 'attribute',
	        begin: '^\\w', end: ': ', excludeEnd: true,
	        starts: {end: '$', relevance: 0}
	      },
	      {
	        className: 'literal',
	        begin: '^-', end: '$'
	      },
	      hljs.HASH_COMMENT_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/leaf.js":
/***/ (function(module, exports) {

	module.exports = function (hljs) {
	  return {
	    contains: [
	      {
	        className: 'function',
	        begin: '#+' + '[A-Za-z_0-9]*' + '\\(',
	        end:' {',
	        returnBegin: true,
	        excludeEnd: true,
	        contains : [
	          {
	            className: 'keyword',
	            begin: '#+'
	          },
	          {
	            className: 'title',
	            begin: '[A-Za-z_][A-Za-z_0-9]*'
	          },
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)',
	            endsParent: true,
	            contains: [
	              {
	                className: 'string',
	                begin: '"',
	                end: '"'
	              },
	              {
	                className: 'variable',
	                begin: '[A-Za-z_][A-Za-z_0-9]*'
	              }
	            ]
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/less.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE        = '[\\w-]+'; // yes, Less identifiers may begin with a digit
	  var INTERP_IDENT_RE = '(' + IDENT_RE + '|@{' + IDENT_RE + '})';
	
	  /* Generic Modes */
	
	  var RULES = [], VALUE = []; // forward def. for recursive modes
	
	  var STRING_MODE = function(c) { return {
	    // Less strings are not multiline (also include '~' for more consistent coloring of "escaped" strings)
	    className: 'string', begin: '~?' + c + '.*?' + c
	  };};
	
	  var IDENT_MODE = function(name, begin, relevance) { return {
	    className: name, begin: begin, relevance: relevance
	  };};
	
	  var PARENS_MODE = {
	    // used only to properly balance nested parens inside mixin call, def. arg list
	    begin: '\\(', end: '\\)', contains: VALUE, relevance: 0
	  };
	
	  // generic Less highlighter (used almost everywhere except selectors):
	  VALUE.push(
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    STRING_MODE("'"),
	    STRING_MODE('"'),
	    hljs.CSS_NUMBER_MODE, // fixme: it does not include dot for numbers like .5em :(
	    {
	      begin: '(url|data-uri)\\(',
	      starts: {className: 'string', end: '[\\)\\n]', excludeEnd: true}
	    },
	    IDENT_MODE('number', '#[0-9A-Fa-f]+\\b'),
	    PARENS_MODE,
	    IDENT_MODE('variable', '@@?' + IDENT_RE, 10),
	    IDENT_MODE('variable', '@{'  + IDENT_RE + '}'),
	    IDENT_MODE('built_in', '~?`[^`]*?`'), // inline javascript (or whatever host language) *multiline* string
	    { // @media features (it’s here to not duplicate things in AT_RULE_MODE with extra PARENS_MODE overriding):
	      className: 'attribute', begin: IDENT_RE + '\\s*:', end: ':', returnBegin: true, excludeEnd: true
	    },
	    {
	      className: 'meta',
	      begin: '!important'
	    }
	  );
	
	  var VALUE_WITH_RULESETS = VALUE.concat({
	    begin: '{', end: '}', contains: RULES
	  });
	
	  var MIXIN_GUARD_MODE = {
	    beginKeywords: 'when', endsWithParent: true,
	    contains: [{beginKeywords: 'and not'}].concat(VALUE) // using this form to override VALUE’s 'function' match
	  };
	
	  /* Rule-Level Modes */
	
	  var RULE_MODE = {
	    begin: INTERP_IDENT_RE + '\\s*:', returnBegin: true, end: '[;}]',
	    relevance: 0,
	    contains: [
	      {
	        className: 'attribute',
	        begin: INTERP_IDENT_RE, end: ':', excludeEnd: true,
	        starts: {
	          endsWithParent: true, illegal: '[<=$]',
	          relevance: 0,
	          contains: VALUE
	        }
	      }
	    ]
	  };
	
	  var AT_RULE_MODE = {
	    className: 'keyword',
	    begin: '@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b',
	    starts: {end: '[;{}]', returnEnd: true, contains: VALUE, relevance: 0}
	  };
	
	  // variable definitions and calls
	  var VAR_RULE_MODE = {
	    className: 'variable',
	    variants: [
	      // using more strict pattern for higher relevance to increase chances of Less detection.
	      // this is *the only* Less specific statement used in most of the sources, so...
	      // (we’ll still often loose to the css-parser unless there's '//' comment,
	      // simply because 1 variable just can't beat 99 properties :)
	      {begin: '@' + IDENT_RE + '\\s*:', relevance: 15},
	      {begin: '@' + IDENT_RE}
	    ],
	    starts: {end: '[;}]', returnEnd: true, contains: VALUE_WITH_RULESETS}
	  };
	
	  var SELECTOR_MODE = {
	    // first parse unambiguous selectors (i.e. those not starting with tag)
	    // then fall into the scary lookahead-discriminator variant.
	    // this mode also handles mixin definitions and calls
	    variants: [{
	      begin: '[\\.#:&\\[>]', end: '[;{}]'  // mixin calls end with ';'
	      }, {
	      begin: INTERP_IDENT_RE, end: '{'
	    }],
	    returnBegin: true,
	    returnEnd:   true,
	    illegal: '[<=\'$"]',
	    relevance: 0,
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      MIXIN_GUARD_MODE,
	      IDENT_MODE('keyword',  'all\\b'),
	      IDENT_MODE('variable', '@{'  + IDENT_RE + '}'),     // otherwise it’s identified as tag
	      IDENT_MODE('selector-tag',  INTERP_IDENT_RE + '%?', 0), // '%' for more consistent coloring of @keyframes "tags"
	      IDENT_MODE('selector-id', '#' + INTERP_IDENT_RE),
	      IDENT_MODE('selector-class', '\\.' + INTERP_IDENT_RE, 0),
	      IDENT_MODE('selector-tag',  '&', 0),
	      {className: 'selector-attr', begin: '\\[', end: '\\]'},
	      {className: 'selector-pseudo', begin: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/},
	      {begin: '\\(', end: '\\)', contains: VALUE_WITH_RULESETS}, // argument list of parametric mixins
	      {begin: '!important'} // eat !important after mixin call or it will be colored as tag
	    ]
	  };
	
	  RULES.push(
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    AT_RULE_MODE,
	    VAR_RULE_MODE,
	    RULE_MODE,
	    SELECTOR_MODE
	  );
	
	  return {
	    case_insensitive: true,
	    illegal: '[=>\'/<($"]',
	    contains: RULES
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/lisp.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var LISP_IDENT_RE = '[a-zA-Z_\\-\\+\\*\\/\\<\\=\\>\\&\\#][a-zA-Z0-9_\\-\\+\\*\\/\\<\\=\\>\\&\\#!]*';
	  var MEC_RE = '\\|[^]*?\\|';
	  var LISP_SIMPLE_NUMBER_RE = '(\\-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|\\-)?\\d+)?';
	  var SHEBANG = {
	    className: 'meta',
	    begin: '^#!', end: '$'
	  };
	  var LITERAL = {
	    className: 'literal',
	    begin: '\\b(t{1}|nil)\\b'
	  };
	  var NUMBER = {
	    className: 'number',
	    variants: [
	      {begin: LISP_SIMPLE_NUMBER_RE, relevance: 0},
	      {begin: '#(b|B)[0-1]+(/[0-1]+)?'},
	      {begin: '#(o|O)[0-7]+(/[0-7]+)?'},
	      {begin: '#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?'},
	      {begin: '#(c|C)\\(' + LISP_SIMPLE_NUMBER_RE + ' +' + LISP_SIMPLE_NUMBER_RE, end: '\\)'}
	    ]
	  };
	  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
	  var COMMENT = hljs.COMMENT(
	    ';', '$',
	    {
	      relevance: 0
	    }
	  );
	  var VARIABLE = {
	    begin: '\\*', end: '\\*'
	  };
	  var KEYWORD = {
	    className: 'symbol',
	    begin: '[:&]' + LISP_IDENT_RE
	  };
	  var IDENT = {
	    begin: LISP_IDENT_RE,
	    relevance: 0
	  };
	  var MEC = {
	    begin: MEC_RE
	  };
	  var QUOTED_LIST = {
	    begin: '\\(', end: '\\)',
	    contains: ['self', LITERAL, STRING, NUMBER, IDENT]
	  };
	  var QUOTED = {
	    contains: [NUMBER, STRING, VARIABLE, KEYWORD, QUOTED_LIST, IDENT],
	    variants: [
	      {
	        begin: '[\'`]\\(', end: '\\)'
	      },
	      {
	        begin: '\\(quote ', end: '\\)',
	        keywords: {name: 'quote'}
	      },
	      {
	        begin: '\'' + MEC_RE
	      }
	    ]
	  };
	  var QUOTED_ATOM = {
	    variants: [
	      {begin: '\'' + LISP_IDENT_RE},
	      {begin: '#\'' + LISP_IDENT_RE + '(::' + LISP_IDENT_RE + ')*'}
	    ]
	  };
	  var LIST = {
	    begin: '\\(\\s*', end: '\\)'
	  };
	  var BODY = {
	    endsWithParent: true,
	    relevance: 0
	  };
	  LIST.contains = [
	    {
	      className: 'name',
	      variants: [
	        {begin: LISP_IDENT_RE},
	        {begin: MEC_RE}
	      ]
	    },
	    BODY
	  ];
	  BODY.contains = [QUOTED, QUOTED_ATOM, LIST, LITERAL, NUMBER, STRING, COMMENT, VARIABLE, KEYWORD, MEC, IDENT];
	
	  return {
	    illegal: /\S/,
	    contains: [
	      NUMBER,
	      SHEBANG,
	      LITERAL,
	      STRING,
	      COMMENT,
	      QUOTED,
	      QUOTED_ATOM,
	      LIST,
	      IDENT
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/livecodeserver.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VARIABLE = {
	    begin: '\\b[gtps][A-Z]+[A-Za-z0-9_\\-]*\\b|\\$_[A-Z]+',
	    relevance: 0
	  };
	  var COMMENT_MODES = [
	    hljs.C_BLOCK_COMMENT_MODE,
	    hljs.HASH_COMMENT_MODE,
	    hljs.COMMENT('--', '$'),
	    hljs.COMMENT('[^:]//', '$')
	  ];
	  var TITLE1 = hljs.inherit(hljs.TITLE_MODE, {
	    variants: [
	      {begin: '\\b_*rig[A-Z]+[A-Za-z0-9_\\-]*'},
	      {begin: '\\b_[a-z0-9\\-]+'}
	    ]
	  });
	  var TITLE2 = hljs.inherit(hljs.TITLE_MODE, {begin: '\\b([A-Za-z0-9_\\-]+)\\b'});
	  return {
	    case_insensitive: false,
	    keywords: {
	      keyword:
	        '$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER ' +
	        'codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph ' +
	        'after byte bytes english the until http forever descending using line real8 with seventh ' +
	        'for stdout finally element word words fourth before black ninth sixth characters chars stderr ' +
	        'uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid ' +
	        'at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 ' +
	        'int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat ' +
	        'end repeat URL in try into switch to words https token binfile each tenth as ticks tick ' +
	        'system real4 by dateItems without char character ascending eighth whole dateTime numeric short ' +
	        'first ftp integer abbreviated abbr abbrev private case while if ' +
	        'div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within ' +
	        'contains ends with begins the keys of keys',
	      literal:
	        'SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE ' +
	        'QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO ' +
	        'six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five ' +
	        'quote empty one true return cr linefeed right backslash null seven tab three two ' +
	        'RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK ' +
	        'FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK',
	      built_in:
	        'put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode ' +
	        'base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum ' +
	        'cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress ' +
	        'constantNames cos date dateFormat decompress directories ' +
	        'diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global ' +
	        'globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset ' +
	        'keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders ' +
	        'libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 ' +
	        'longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge millisec ' +
	        'millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar ' +
	        'numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets ' +
	        'paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation ' +
	        'populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile ' +
	        'revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull ' +
	        'revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered ' +
	        'revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames ' +
	        'revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull ' +
	        'revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections ' +
	        'revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype ' +
	        'revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext ' +
	        'revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames ' +
	        'revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase ' +
	        'revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute ' +
	        'revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces ' +
	        'revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode ' +
	        'revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling ' +
	        'revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error ' +
	        'revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute ' +
	        'revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort ' +
	        'revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree ' +
	        'revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance ' +
	        'sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound ' +
	        'stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper ' +
	        'transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames ' +
	        'variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet ' +
	        'xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process ' +
	        'combine constant convert create new alias folder directory decrypt delete variable word line folder ' +
	        'directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile ' +
	        'libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback ' +
	        'libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime ' +
	        'libURLSetStatusCallback load multiply socket prepare process post seek rel relative read from process rename ' +
	        'replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase ' +
	        'revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees ' +
	        'revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord ' +
	        'revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase ' +
	        'revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD ' +
	        'revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost ' +
	        'revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData ' +
	        'revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel ' +
	        'revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback ' +
	        'revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop ' +
	        'subtract union unload wait write'
	    },
	    contains: [
	      VARIABLE,
	      {
	        className: 'keyword',
	        begin: '\\bend\\sif\\b'
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '$',
	        contains: [
	          VARIABLE,
	          TITLE2,
	          hljs.APOS_STRING_MODE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.BINARY_NUMBER_MODE,
	          hljs.C_NUMBER_MODE,
	          TITLE1
	        ]
	      },
	      {
	        className: 'function',
	        begin: '\\bend\\s+', end: '$',
	        keywords: 'end',
	        contains: [
	          TITLE2,
	          TITLE1
	        ],
	        relevance: 0
	      },
	      {
	        beginKeywords: 'command on', end: '$',
	        contains: [
	          VARIABLE,
	          TITLE2,
	          hljs.APOS_STRING_MODE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.BINARY_NUMBER_MODE,
	          hljs.C_NUMBER_MODE,
	          TITLE1
	        ]
	      },
	      {
	        className: 'meta',
	        variants: [
	          {
	            begin: '<\\?(rev|lc|livecode)',
	            relevance: 10
	          },
	          { begin: '<\\?' },
	          { begin: '\\?>' }
	        ]
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.BINARY_NUMBER_MODE,
	      hljs.C_NUMBER_MODE,
	      TITLE1
	    ].concat(COMMENT_MODES),
	    illegal: ';$|^\\[|^=|&|{'
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/livescript.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      // JS keywords
	      'in if for while finally new do return else break catch instanceof throw try this ' +
	      'switch continue typeof delete debugger case default function var with ' +
	      // LiveScript keywords
	      'then unless until loop of by when and or is isnt not it that otherwise from to til fallthrough super ' +
	      'case default function var void const let enum export import native ' +
	      '__hasProp __extends __slice __bind __indexOf',
	    literal:
	      // JS literals
	      'true false null undefined ' +
	      // LiveScript literals
	      'yes no on off it that void',
	    built_in:
	      'npm require console print module global window document'
	  };
	  var JS_IDENT_RE = '[A-Za-z$_](?:\-[0-9A-Za-z$_]|[0-9A-Za-z$_])*';
	  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
	  var SUBST = {
	    className: 'subst',
	    begin: /#\{/, end: /}/,
	    keywords: KEYWORDS
	  };
	  var SUBST_SIMPLE = {
	    className: 'subst',
	    begin: /#[A-Za-z$_]/, end: /(?:\-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,
	    keywords: KEYWORDS
	  };
	  var EXPRESSIONS = [
	    hljs.BINARY_NUMBER_MODE,
	    {
	      className: 'number',
	      begin: '(\\b0[xX][a-fA-F0-9_]+)|(\\b\\d(\\d|_\\d)*(\\.(\\d(\\d|_\\d)*)?)?(_*[eE]([-+]\\d(_\\d|\\d)*)?)?[_a-z]*)',
	      relevance: 0,
	      starts: {end: '(\\s*/)?', relevance: 0} // a number tries to eat the following slash to prevent treating it as a regexp
	    },
	    {
	      className: 'string',
	      variants: [
	        {
	          begin: /'''/, end: /'''/,
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: /'/, end: /'/,
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: /"""/, end: /"""/,
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST, SUBST_SIMPLE]
	        },
	        {
	          begin: /"/, end: /"/,
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST, SUBST_SIMPLE]
	        },
	        {
	          begin: /\\/, end: /(\s|$)/,
	          excludeEnd: true
	        }
	      ]
	    },
	    {
	      className: 'regexp',
	      variants: [
	        {
	          begin: '//', end: '//[gim]*',
	          contains: [SUBST, hljs.HASH_COMMENT_MODE]
	        },
	        {
	          // regex can't start with space to parse x / 2 / 3 as two divisions
	          // regex can't start with *, and it supports an "illegal" in the main mode
	          begin: /\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/
	        }
	      ]
	    },
	    {
	      begin: '@' + JS_IDENT_RE
	    },
	    {
	      begin: '``', end: '``',
	      excludeBegin: true, excludeEnd: true,
	      subLanguage: 'javascript'
	    }
	  ];
	  SUBST.contains = EXPRESSIONS;
	
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', returnBegin: true,
	    /* We need another contained nameless mode to not have every nested
	    pair of parens to be called "params" */
	    contains: [
	      {
	        begin: /\(/, end: /\)/,
	        keywords: KEYWORDS,
	        contains: ['self'].concat(EXPRESSIONS)
	      }
	    ]
	  };
	
	  return {
	    aliases: ['ls'],
	    keywords: KEYWORDS,
	    illegal: /\/\*/,
	    contains: EXPRESSIONS.concat([
	      hljs.COMMENT('\\/\\*', '\\*\\/'),
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'function',
	        contains: [TITLE, PARAMS],
	        returnBegin: true,
	        variants: [
	          {
	            begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?(\\(.*\\))?\\s*\\B\\->\\*?', end: '\\->\\*?'
	          },
	          {
	            begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?!?(\\(.*\\))?\\s*\\B[-~]{1,2}>\\*?', end: '[-~]{1,2}>\\*?'
	          },
	          {
	            begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?(\\(.*\\))?\\s*\\B!?[-~]{1,2}>\\*?', end: '!?[-~]{1,2}>\\*?'
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class',
	        end: '$',
	        illegal: /[:="\[\]]/,
	        contains: [
	          {
	            beginKeywords: 'extends',
	            endsWithParent: true,
	            illegal: /[:="\[\]]/,
	            contains: [TITLE]
	          },
	          TITLE
	        ]
	      },
	      {
	        begin: JS_IDENT_RE + ':', end: ':',
	        returnBegin: true, returnEnd: true,
	        relevance: 0
	      }
	    ])
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/llvm.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var identifier = '([-a-zA-Z$._][\\w\\-$.]*)';
	  return {
	    //lexemes: '[.%]?' + hljs.IDENT_RE,
	    keywords:
	      'begin end true false declare define global ' +
	      'constant private linker_private internal ' +
	      'available_externally linkonce linkonce_odr weak ' +
	      'weak_odr appending dllimport dllexport common ' +
	      'default hidden protected extern_weak external ' +
	      'thread_local zeroinitializer undef null to tail ' +
	      'target triple datalayout volatile nuw nsw nnan ' +
	      'ninf nsz arcp fast exact inbounds align ' +
	      'addrspace section alias module asm sideeffect ' +
	      'gc dbg linker_private_weak attributes blockaddress ' +
	      'initialexec localdynamic localexec prefix unnamed_addr ' +
	      'ccc fastcc coldcc x86_stdcallcc x86_fastcallcc ' +
	      'arm_apcscc arm_aapcscc arm_aapcs_vfpcc ptx_device ' +
	      'ptx_kernel intel_ocl_bicc msp430_intrcc spir_func ' +
	      'spir_kernel x86_64_sysvcc x86_64_win64cc x86_thiscallcc ' +
	      'cc c signext zeroext inreg sret nounwind ' +
	      'noreturn noalias nocapture byval nest readnone ' +
	      'readonly inlinehint noinline alwaysinline optsize ssp ' +
	      'sspreq noredzone noimplicitfloat naked builtin cold ' +
	      'nobuiltin noduplicate nonlazybind optnone returns_twice ' +
	      'sanitize_address sanitize_memory sanitize_thread sspstrong ' +
	      'uwtable returned type opaque eq ne slt sgt ' +
	      'sle sge ult ugt ule uge oeq one olt ogt ' +
	      'ole oge ord uno ueq une x acq_rel acquire ' +
	      'alignstack atomic catch cleanup filter inteldialect ' +
	      'max min monotonic nand personality release seq_cst ' +
	      'singlethread umax umin unordered xchg add fadd ' +
	      'sub fsub mul fmul udiv sdiv fdiv urem srem ' +
	      'frem shl lshr ashr and or xor icmp fcmp ' +
	      'phi call trunc zext sext fptrunc fpext uitofp ' +
	      'sitofp fptoui fptosi inttoptr ptrtoint bitcast ' +
	      'addrspacecast select va_arg ret br switch invoke ' +
	      'unwind unreachable indirectbr landingpad resume ' +
	      'malloc alloca free load store getelementptr ' +
	      'extractelement insertelement shufflevector getresult ' +
	      'extractvalue insertvalue atomicrmw cmpxchg fence ' +
	      'argmemonly double',
	    contains: [
	      {
	        className: 'keyword',
	        begin: 'i\\d+'
	      },
	      hljs.COMMENT(
	        ';', '\\n', {relevance: 0}
	      ),
	      // Double quote string
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        variants: [
	          // Double-quoted string
	          { begin: '"', end: '[^\\\\]"' },
	        ],
	        relevance: 0
	      },
	      {
	        className: 'title',
	        variants: [
	          { begin: '@' + identifier },
	          { begin: '@\\d+' },
	          { begin: '!' + identifier },
	          { begin: '!\\d+' + identifier }
	        ]
	      },
	      {
	        className: 'symbol',
	        variants: [
	          { begin: '%' + identifier },
	          { begin: '%\\d+' },
	          { begin: '#\\d+' },
	        ]
	      },
	      {
	        className: 'number',
	        variants: [
	            { begin: '0[xX][a-fA-F0-9]+' },
	            { begin: '-?\\d+(?:[.]\\d+)?(?:[eE][-+]?\\d+(?:[.]\\d+)?)?' }
	        ],
	        relevance: 0
	      },
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/lsl.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	
	    var LSL_STRING_ESCAPE_CHARS = {
	        className: 'subst',
	        begin: /\\[tn"\\]/
	    };
	
	    var LSL_STRINGS = {
	        className: 'string',
	        begin: '"',
	        end: '"',
	        contains: [
	            LSL_STRING_ESCAPE_CHARS
	        ]
	    };
	
	    var LSL_NUMBERS = {
	        className: 'number',
	        begin: hljs.C_NUMBER_RE
	    };
	
	    var LSL_CONSTANTS = {
	        className: 'literal',
	        variants: [
	            {
	                begin: '\\b(?:PI|TWO_PI|PI_BY_TWO|DEG_TO_RAD|RAD_TO_DEG|SQRT2)\\b'
	            },
	            {
	                begin: '\\b(?:XP_ERROR_(?:EXPERIENCES_DISABLED|EXPERIENCE_(?:DISABLED|SUSPENDED)|INVALID_(?:EXPERIENCE|PARAMETERS)|KEY_NOT_FOUND|MATURITY_EXCEEDED|NONE|NOT_(?:FOUND|PERMITTED(?:_LAND)?)|NO_EXPERIENCE|QUOTA_EXCEEDED|RETRY_UPDATE|STORAGE_EXCEPTION|STORE_DISABLED|THROTTLED|UNKNOWN_ERROR)|JSON_APPEND|STATUS_(?:PHYSICS|ROTATE_[XYZ]|PHANTOM|SANDBOX|BLOCK_GRAB(?:_OBJECT)?|(?:DIE|RETURN)_AT_EDGE|CAST_SHADOWS|OK|MALFORMED_PARAMS|TYPE_MISMATCH|BOUNDS_ERROR|NOT_(?:FOUND|SUPPORTED)|INTERNAL_ERROR|WHITELIST_FAILED)|AGENT(?:_(?:BY_(?:LEGACY_|USER)NAME|FLYING|ATTACHMENTS|SCRIPTED|MOUSELOOK|SITTING|ON_OBJECT|AWAY|WALKING|IN_AIR|TYPING|CROUCHING|BUSY|ALWAYS_RUN|AUTOPILOT|LIST_(?:PARCEL(?:_OWNER)?|REGION)))?|CAMERA_(?:PITCH|DISTANCE|BEHINDNESS_(?:ANGLE|LAG)|(?:FOCUS|POSITION)(?:_(?:THRESHOLD|LOCKED|LAG))?|FOCUS_OFFSET|ACTIVE)|ANIM_ON|LOOP|REVERSE|PING_PONG|SMOOTH|ROTATE|SCALE|ALL_SIDES|LINK_(?:ROOT|SET|ALL_(?:OTHERS|CHILDREN)|THIS)|ACTIVE|PASS(?:IVE|_(?:ALWAYS|IF_NOT_HANDLED|NEVER))|SCRIPTED|CONTROL_(?:FWD|BACK|(?:ROT_)?(?:LEFT|RIGHT)|UP|DOWN|(?:ML_)?LBUTTON)|PERMISSION_(?:RETURN_OBJECTS|DEBIT|OVERRIDE_ANIMATIONS|SILENT_ESTATE_MANAGEMENT|TAKE_CONTROLS|TRIGGER_ANIMATION|ATTACH|CHANGE_LINKS|(?:CONTROL|TRACK)_CAMERA|TELEPORT)|INVENTORY_(?:TEXTURE|SOUND|OBJECT|SCRIPT|LANDMARK|CLOTHING|NOTECARD|BODYPART|ANIMATION|GESTURE|ALL|NONE)|CHANGED_(?:INVENTORY|COLOR|SHAPE|SCALE|TEXTURE|LINK|ALLOWED_DROP|OWNER|REGION(?:_START)?|TELEPORT|MEDIA)|OBJECT_(?:CLICK_ACTION|HOVER_HEIGHT|LAST_OWNER_ID|(?:PHYSICS|SERVER|STREAMING)_COST|UNKNOWN_DETAIL|CHARACTER_TIME|PHANTOM|PHYSICS|TEMP_ON_REZ|NAME|DESC|POS|PRIM_(?:COUNT|EQUIVALENCE)|RETURN_(?:PARCEL(?:_OWNER)?|REGION)|REZZER_KEY|ROO?T|VELOCITY|OMEGA|OWNER|GROUP|CREATOR|ATTACHED_POINT|RENDER_WEIGHT|(?:BODY_SHAPE|PATHFINDING)_TYPE|(?:RUNNING|TOTAL)_SCRIPT_COUNT|TOTAL_INVENTORY_COUNT|SCRIPT_(?:MEMORY|TIME))|TYPE_(?:INTEGER|FLOAT|STRING|KEY|VECTOR|ROTATION|INVALID)|(?:DEBUG|PUBLIC)_CHANNEL|ATTACH_(?:AVATAR_CENTER|CHEST|HEAD|BACK|PELVIS|MOUTH|CHIN|NECK|NOSE|BELLY|[LR](?:SHOULDER|HAND|FOOT|EAR|EYE|[UL](?:ARM|LEG)|HIP)|(?:LEFT|RIGHT)_PEC|HUD_(?:CENTER_[12]|TOP_(?:RIGHT|CENTER|LEFT)|BOTTOM(?:_(?:RIGHT|LEFT))?)|[LR]HAND_RING1|TAIL_(?:BASE|TIP)|[LR]WING|FACE_(?:JAW|[LR]EAR|[LR]EYE|TOUNGE)|GROIN|HIND_[LR]FOOT)|LAND_(?:LEVEL|RAISE|LOWER|SMOOTH|NOISE|REVERT)|DATA_(?:ONLINE|NAME|BORN|SIM_(?:POS|STATUS|RATING)|PAYINFO)|PAYMENT_INFO_(?:ON_FILE|USED)|REMOTE_DATA_(?:CHANNEL|REQUEST|REPLY)|PSYS_(?:PART_(?:BF_(?:ZERO|ONE(?:_MINUS_(?:DEST_COLOR|SOURCE_(ALPHA|COLOR)))?|DEST_COLOR|SOURCE_(ALPHA|COLOR))|BLEND_FUNC_(DEST|SOURCE)|FLAGS|(?:START|END)_(?:COLOR|ALPHA|SCALE|GLOW)|MAX_AGE|(?:RIBBON|WIND|INTERP_(?:COLOR|SCALE)|BOUNCE|FOLLOW_(?:SRC|VELOCITY)|TARGET_(?:POS|LINEAR)|EMISSIVE)_MASK)|SRC_(?:MAX_AGE|PATTERN|ANGLE_(?:BEGIN|END)|BURST_(?:RATE|PART_COUNT|RADIUS|SPEED_(?:MIN|MAX))|ACCEL|TEXTURE|TARGET_KEY|OMEGA|PATTERN_(?:DROP|EXPLODE|ANGLE(?:_CONE(?:_EMPTY)?)?)))|VEHICLE_(?:REFERENCE_FRAME|TYPE_(?:NONE|SLED|CAR|BOAT|AIRPLANE|BALLOON)|(?:LINEAR|ANGULAR)_(?:FRICTION_TIMESCALE|MOTOR_DIRECTION)|LINEAR_MOTOR_OFFSET|HOVER_(?:HEIGHT|EFFICIENCY|TIMESCALE)|BUOYANCY|(?:LINEAR|ANGULAR)_(?:DEFLECTION_(?:EFFICIENCY|TIMESCALE)|MOTOR_(?:DECAY_)?TIMESCALE)|VERTICAL_ATTRACTION_(?:EFFICIENCY|TIMESCALE)|BANKING_(?:EFFICIENCY|MIX|TIMESCALE)|FLAG_(?:NO_DEFLECTION_UP|LIMIT_(?:ROLL_ONLY|MOTOR_UP)|HOVER_(?:(?:WATER|TERRAIN|UP)_ONLY|GLOBAL_HEIGHT)|MOUSELOOK_(?:STEER|BANK)|CAMERA_DECOUPLED))|PRIM_(?:ALPHA_MODE(?:_(?:BLEND|EMISSIVE|MASK|NONE))?|NORMAL|SPECULAR|TYPE(?:_(?:BOX|CYLINDER|PRISM|SPHERE|TORUS|TUBE|RING|SCULPT))?|HOLE_(?:DEFAULT|CIRCLE|SQUARE|TRIANGLE)|MATERIAL(?:_(?:STONE|METAL|GLASS|WOOD|FLESH|PLASTIC|RUBBER))?|SHINY_(?:NONE|LOW|MEDIUM|HIGH)|BUMP_(?:NONE|BRIGHT|DARK|WOOD|BARK|BRICKS|CHECKER|CONCRETE|TILE|STONE|DISKS|GRAVEL|BLOBS|SIDING|LARGETILE|STUCCO|SUCTION|WEAVE)|TEXGEN_(?:DEFAULT|PLANAR)|SCULPT_(?:TYPE_(?:SPHERE|TORUS|PLANE|CYLINDER|MASK)|FLAG_(?:MIRROR|INVERT))|PHYSICS(?:_(?:SHAPE_(?:CONVEX|NONE|PRIM|TYPE)))?|(?:POS|ROT)_LOCAL|SLICE|TEXT|FLEXIBLE|POINT_LIGHT|TEMP_ON_REZ|PHANTOM|POSITION|SIZE|ROTATION|TEXTURE|NAME|OMEGA|DESC|LINK_TARGET|COLOR|BUMP_SHINY|FULLBRIGHT|TEXGEN|GLOW|MEDIA_(?:ALT_IMAGE_ENABLE|CONTROLS|(?:CURRENT|HOME)_URL|AUTO_(?:LOOP|PLAY|SCALE|ZOOM)|FIRST_CLICK_INTERACT|(?:WIDTH|HEIGHT)_PIXELS|WHITELIST(?:_ENABLE)?|PERMS_(?:INTERACT|CONTROL)|PARAM_MAX|CONTROLS_(?:STANDARD|MINI)|PERM_(?:NONE|OWNER|GROUP|ANYONE)|MAX_(?:URL_LENGTH|WHITELIST_(?:SIZE|COUNT)|(?:WIDTH|HEIGHT)_PIXELS)))|MASK_(?:BASE|OWNER|GROUP|EVERYONE|NEXT)|PERM_(?:TRANSFER|MODIFY|COPY|MOVE|ALL)|PARCEL_(?:MEDIA_COMMAND_(?:STOP|PAUSE|PLAY|LOOP|TEXTURE|URL|TIME|AGENT|UNLOAD|AUTO_ALIGN|TYPE|SIZE|DESC|LOOP_SET)|FLAG_(?:ALLOW_(?:FLY|(?:GROUP_)?SCRIPTS|LANDMARK|TERRAFORM|DAMAGE|CREATE_(?:GROUP_)?OBJECTS)|USE_(?:ACCESS_(?:GROUP|LIST)|BAN_LIST|LAND_PASS_LIST)|LOCAL_SOUND_ONLY|RESTRICT_PUSHOBJECT|ALLOW_(?:GROUP|ALL)_OBJECT_ENTRY)|COUNT_(?:TOTAL|OWNER|GROUP|OTHER|SELECTED|TEMP)|DETAILS_(?:NAME|DESC|OWNER|GROUP|AREA|ID|SEE_AVATARS))|LIST_STAT_(?:MAX|MIN|MEAN|MEDIAN|STD_DEV|SUM(?:_SQUARES)?|NUM_COUNT|GEOMETRIC_MEAN|RANGE)|PAY_(?:HIDE|DEFAULT)|REGION_FLAG_(?:ALLOW_DAMAGE|FIXED_SUN|BLOCK_TERRAFORM|SANDBOX|DISABLE_(?:COLLISIONS|PHYSICS)|BLOCK_FLY|ALLOW_DIRECT_TELEPORT|RESTRICT_PUSHOBJECT)|HTTP_(?:METHOD|MIMETYPE|BODY_(?:MAXLENGTH|TRUNCATED)|CUSTOM_HEADER|PRAGMA_NO_CACHE|VERBOSE_THROTTLE|VERIFY_CERT)|STRING_(?:TRIM(?:_(?:HEAD|TAIL))?)|CLICK_ACTION_(?:NONE|TOUCH|SIT|BUY|PAY|OPEN(?:_MEDIA)?|PLAY|ZOOM)|TOUCH_INVALID_FACE|PROFILE_(?:NONE|SCRIPT_MEMORY)|RC_(?:DATA_FLAGS|DETECT_PHANTOM|GET_(?:LINK_NUM|NORMAL|ROOT_KEY)|MAX_HITS|REJECT_(?:TYPES|AGENTS|(?:NON)?PHYSICAL|LAND))|RCERR_(?:CAST_TIME_EXCEEDED|SIM_PERF_LOW|UNKNOWN)|ESTATE_ACCESS_(?:ALLOWED_(?:AGENT|GROUP)_(?:ADD|REMOVE)|BANNED_AGENT_(?:ADD|REMOVE))|DENSITY|FRICTION|RESTITUTION|GRAVITY_MULTIPLIER|KFM_(?:COMMAND|CMD_(?:PLAY|STOP|PAUSE)|MODE|FORWARD|LOOP|PING_PONG|REVERSE|DATA|ROTATION|TRANSLATION)|ERR_(?:GENERIC|PARCEL_PERMISSIONS|MALFORMED_PARAMS|RUNTIME_PERMISSIONS|THROTTLED)|CHARACTER_(?:CMD_(?:(?:SMOOTH_)?STOP|JUMP)|DESIRED_(?:TURN_)?SPEED|RADIUS|STAY_WITHIN_PARCEL|LENGTH|ORIENTATION|ACCOUNT_FOR_SKIPPED_FRAMES|AVOIDANCE_MODE|TYPE(?:_(?:[ABCD]|NONE))?|MAX_(?:DECEL|TURN_RADIUS|(?:ACCEL|SPEED)))|PURSUIT_(?:OFFSET|FUZZ_FACTOR|GOAL_TOLERANCE|INTERCEPT)|REQUIRE_LINE_OF_SIGHT|FORCE_DIRECT_PATH|VERTICAL|HORIZONTAL|AVOID_(?:CHARACTERS|DYNAMIC_OBSTACLES|NONE)|PU_(?:EVADE_(?:HIDDEN|SPOTTED)|FAILURE_(?:DYNAMIC_PATHFINDING_DISABLED|INVALID_(?:GOAL|START)|NO_(?:NAVMESH|VALID_DESTINATION)|OTHER|TARGET_GONE|(?:PARCEL_)?UNREACHABLE)|(?:GOAL|SLOWDOWN_DISTANCE)_REACHED)|TRAVERSAL_TYPE(?:_(?:FAST|NONE|SLOW))?|CONTENT_TYPE_(?:ATOM|FORM|HTML|JSON|LLSD|RSS|TEXT|XHTML|XML)|GCNP_(?:RADIUS|STATIC)|(?:PATROL|WANDER)_PAUSE_AT_WAYPOINTS|OPT_(?:AVATAR|CHARACTER|EXCLUSION_VOLUME|LEGACY_LINKSET|MATERIAL_VOLUME|OTHER|STATIC_OBSTACLE|WALKABLE)|SIM_STAT_PCT_CHARS_STEPPED)\\b'
	            },
	            {
	                begin: '\\b(?:FALSE|TRUE)\\b'
	            },
	            {
	                begin: '\\b(?:ZERO_ROTATION)\\b'
	            },
	            {
	                begin: '\\b(?:EOF|JSON_(?:ARRAY|DELETE|FALSE|INVALID|NULL|NUMBER|OBJECT|STRING|TRUE)|NULL_KEY|TEXTURE_(?:BLANK|DEFAULT|MEDIA|PLYWOOD|TRANSPARENT)|URL_REQUEST_(?:GRANTED|DENIED))\\b'
	            },
	            {
	                begin: '\\b(?:ZERO_VECTOR|TOUCH_INVALID_(?:TEXCOORD|VECTOR))\\b'
	            }
	        ]
	    };
	
	    var LSL_FUNCTIONS = {
	        className: 'built_in',
	        begin: '\\b(?:ll(?:AgentInExperience|(?:Create|DataSize|Delete|KeyCount|Keys|Read|Update)KeyValue|GetExperience(?:Details|ErrorMessage)|ReturnObjectsBy(?:ID|Owner)|Json(?:2List|[GS]etValue|ValueType)|Sin|Cos|Tan|Atan2|Sqrt|Pow|Abs|Fabs|Frand|Floor|Ceil|Round|Vec(?:Mag|Norm|Dist)|Rot(?:Between|2(?:Euler|Fwd|Left|Up))|(?:Euler|Axes)2Rot|Whisper|(?:Region|Owner)?Say|Shout|Listen(?:Control|Remove)?|Sensor(?:Repeat|Remove)?|Detected(?:Name|Key|Owner|Type|Pos|Vel|Grab|Rot|Group|LinkNumber)|Die|Ground|Wind|(?:[GS]et)(?:AnimationOverride|MemoryLimit|PrimMediaParams|ParcelMusicURL|Object(?:Desc|Name)|PhysicsMaterial|Status|Scale|Color|Alpha|Texture|Pos|Rot|Force|Torque)|ResetAnimationOverride|(?:Scale|Offset|Rotate)Texture|(?:Rot)?Target(?:Remove)?|(?:Stop)?MoveToTarget|Apply(?:Rotational)?Impulse|Set(?:KeyframedMotion|ContentType|RegionPos|(?:Angular)?Velocity|Buoyancy|HoverHeight|ForceAndTorque|TimerEvent|ScriptState|Damage|TextureAnim|Sound(?:Queueing|Radius)|Vehicle(?:Type|(?:Float|Vector|Rotation)Param)|(?:Touch|Sit)?Text|Camera(?:Eye|At)Offset|PrimitiveParams|ClickAction|Link(?:Alpha|Color|PrimitiveParams(?:Fast)?|Texture(?:Anim)?|Camera|Media)|RemoteScriptAccessPin|PayPrice|LocalRot)|ScaleByFactor|Get(?:(?:Max|Min)ScaleFactor|ClosestNavPoint|StaticPath|SimStats|Env|PrimitiveParams|Link(?:PrimitiveParams|Number(?:OfSides)?|Key|Name|Media)|HTTPHeader|FreeURLs|Object(?:Details|PermMask|PrimCount)|Parcel(?:MaxPrims|Details|Prim(?:Count|Owners))|Attached(?:List)?|(?:SPMax|Free|Used)Memory|Region(?:Name|TimeDilation|FPS|Corner|AgentCount)|Root(?:Position|Rotation)|UnixTime|(?:Parcel|Region)Flags|(?:Wall|GMT)clock|SimulatorHostname|BoundingBox|GeometricCenter|Creator|NumberOf(?:Prims|NotecardLines|Sides)|Animation(?:List)?|(?:Camera|Local)(?:Pos|Rot)|Vel|Accel|Omega|Time(?:stamp|OfDay)|(?:Object|CenterOf)?Mass|MassMKS|Energy|Owner|(?:Owner)?Key|SunDirection|Texture(?:Offset|Scale|Rot)|Inventory(?:Number|Name|Key|Type|Creator|PermMask)|Permissions(?:Key)?|StartParameter|List(?:Length|EntryType)|Date|Agent(?:Size|Info|Language|List)|LandOwnerAt|NotecardLine|Script(?:Name|State))|(?:Get|Reset|GetAndReset)Time|PlaySound(?:Slave)?|LoopSound(?:Master|Slave)?|(?:Trigger|Stop|Preload)Sound|(?:(?:Get|Delete)Sub|Insert)String|To(?:Upper|Lower)|Give(?:InventoryList|Money)|RezObject|(?:Stop)?LookAt|Sleep|CollisionFilter|(?:Take|Release)Controls|DetachFromAvatar|AttachToAvatar(?:Temp)?|InstantMessage|(?:GetNext)?Email|StopHover|MinEventDelay|RotLookAt|String(?:Length|Trim)|(?:Start|Stop)Animation|TargetOmega|Request(?:Experience)?Permissions|(?:Create|Break)Link|BreakAllLinks|(?:Give|Remove)Inventory|Water|PassTouches|Request(?:Agent|Inventory)Data|TeleportAgent(?:Home|GlobalCoords)?|ModifyLand|CollisionSound|ResetScript|MessageLinked|PushObject|PassCollisions|AxisAngle2Rot|Rot2(?:Axis|Angle)|A(?:cos|sin)|AngleBetween|AllowInventoryDrop|SubStringIndex|List2(?:CSV|Integer|Json|Float|String|Key|Vector|Rot|List(?:Strided)?)|DeleteSubList|List(?:Statistics|Sort|Randomize|(?:Insert|Find|Replace)List)|EdgeOfWorld|AdjustSoundVolume|Key2Name|TriggerSoundLimited|EjectFromLand|(?:CSV|ParseString)2List|OverMyLand|SameGroup|UnSit|Ground(?:Slope|Normal|Contour)|GroundRepel|(?:Set|Remove)VehicleFlags|(?:AvatarOn)?(?:Link)?SitTarget|Script(?:Danger|Profiler)|Dialog|VolumeDetect|ResetOtherScript|RemoteLoadScriptPin|(?:Open|Close)RemoteDataChannel|SendRemoteData|RemoteDataReply|(?:Integer|String)ToBase64|XorBase64|Log(?:10)?|Base64To(?:String|Integer)|ParseStringKeepNulls|RezAtRoot|RequestSimulatorData|ForceMouselook|(?:Load|Release|(?:E|Une)scape)URL|ParcelMedia(?:CommandList|Query)|ModPow|MapDestination|(?:RemoveFrom|AddTo|Reset)Land(?:Pass|Ban)List|(?:Set|Clear)CameraParams|HTTP(?:Request|Response)|TextBox|DetectedTouch(?:UV|Face|Pos|(?:N|Bin)ormal|ST)|(?:MD5|SHA1|DumpList2)String|Request(?:Secure)?URL|Clear(?:Prim|Link)Media|(?:Link)?ParticleSystem|(?:Get|Request)(?:Username|DisplayName)|RegionSayTo|CastRay|GenerateKey|TransferLindenDollars|ManageEstateAccess|(?:Create|Delete)Character|ExecCharacterCmd|Evade|FleeFrom|NavigateTo|PatrolPoints|Pursue|UpdateCharacter|WanderWithin))\\b'
	    };
	
	    return {
	        illegal: ':',
	        contains: [
	            LSL_STRINGS,
	            {
	                className: 'comment',
	                variants: [
	                    hljs.COMMENT('//', '$'),
	                    hljs.COMMENT('/\\*', '\\*/')
	                ]
	            },
	            LSL_NUMBERS,
	            {
	                className: 'section',
	                variants: [
	                    {
	                        begin: '\\b(?:state|default)\\b'
	                    },
	                    {
	                        begin: '\\b(?:state_(?:entry|exit)|touch(?:_(?:start|end))?|(?:land_)?collision(?:_(?:start|end))?|timer|listen|(?:no_)?sensor|control|(?:not_)?at_(?:rot_)?target|money|email|experience_permissions(?:_denied)?|run_time_permissions|changed|attach|dataserver|moving_(?:start|end)|link_message|(?:on|object)_rez|remote_data|http_re(?:sponse|quest)|path_update|transaction_result)\\b'
	                    }
	                ]
	            },
	            LSL_FUNCTIONS,
	            LSL_CONSTANTS,
	            {
	                className: 'type',
	                begin: '\\b(?:integer|float|string|key|vector|quaternion|rotation|list)\\b'
	            }
	        ]
	    };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/lua.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var OPENING_LONG_BRACKET = '\\[=*\\[';
	  var CLOSING_LONG_BRACKET = '\\]=*\\]';
	  var LONG_BRACKETS = {
	    begin: OPENING_LONG_BRACKET, end: CLOSING_LONG_BRACKET,
	    contains: ['self']
	  };
	  var COMMENTS = [
	    hljs.COMMENT('--(?!' + OPENING_LONG_BRACKET + ')', '$'),
	    hljs.COMMENT(
	      '--' + OPENING_LONG_BRACKET,
	      CLOSING_LONG_BRACKET,
	      {
	        contains: [LONG_BRACKETS],
	        relevance: 10
	      }
	    )
	  ];
	  return {
	    lexemes: hljs.UNDERSCORE_IDENT_RE,
	    keywords: {
	      literal: "true false nil",
	      keyword: "and break do else elseif end for goto if in local not or repeat return then until while",
	      built_in:
	        //Metatags and globals:
	        '_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len ' +
	        '__gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert ' +
	        //Standard methods and properties:
	        'collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring' +
	        'module next pairs pcall print rawequal rawget rawset require select setfenv' +
	        'setmetatable tonumber tostring type unpack xpcall arg self' +
	        //Library methods and properties (one line per library):
	        'coroutine resume yield status wrap create running debug getupvalue ' +
	        'debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv ' +
	        'io lines write close flush open output type read stderr stdin input stdout popen tmpfile ' +
	        'math log max acos huge ldexp pi cos tanh pow deg tan cosh sinh random randomseed frexp ceil floor rad abs sqrt modf asin min mod fmod log10 atan2 exp sin atan ' +
	        'os exit setlocale date getenv difftime remove time clock tmpname rename execute package preload loadlib loaded loaders cpath config path seeall ' +
	        'string sub upper len gfind rep find match char dump gmatch reverse byte format gsub lower ' +
	        'table setn insert getn foreachi maxn foreach concat sort remove'
	    },
	    contains: COMMENTS.concat([
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '\\)',
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'}),
	          {
	            className: 'params',
	            begin: '\\(', endsWithParent: true,
	            contains: COMMENTS
	          }
	        ].concat(COMMENTS)
	      },
	      hljs.C_NUMBER_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: OPENING_LONG_BRACKET, end: CLOSING_LONG_BRACKET,
	        contains: [LONG_BRACKETS],
	        relevance: 5
	      }
	    ])
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/makefile.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  /* Variables: simple (eg $(var)) and special (eg $@) */
	  var VARIABLE = {
	    className: 'variable',
	    variants: [
	      {
	        begin: '\\$\\(' + hljs.UNDERSCORE_IDENT_RE + '\\)',
	        contains: [hljs.BACKSLASH_ESCAPE],
	      },
	      {
	        begin: /\$[@%<?\^\+\*]/
	      },
	    ]
	  };
	  /* Quoted string with variables inside */
	  var QUOTE_STRING = {
	    className: 'string',
	    begin: /"/, end: /"/,
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      VARIABLE,
	    ]
	  };
	  /* Function: $(func arg,...) */
	  var FUNC = {
	    className: 'variable',
	    begin: /\$\([\w-]+\s/, end: /\)/,
	    keywords: {
	      built_in:
	        'subst patsubst strip findstring filter filter-out sort ' +
	        'word wordlist firstword lastword dir notdir suffix basename ' +
	        'addsuffix addprefix join wildcard realpath abspath error warning ' +
	        'shell origin flavor foreach if or and call eval file value',
	    },
	    contains: [
	      VARIABLE,
	    ]
	  };
	  /* Variable assignment */
	  var VAR_ASSIG = {
	    begin: '^' + hljs.UNDERSCORE_IDENT_RE + '\\s*[:+?]?=',
	    illegal: '\\n',
	    returnBegin: true,
	    contains: [
	      {
	        begin: '^' + hljs.UNDERSCORE_IDENT_RE, end: '[:+?]?=',
	        excludeEnd: true,
	      }
	    ]
	  };
	  /* Meta targets (.PHONY) */
	  var META = {
	    className: 'meta',
	    begin: /^\.PHONY:/, end: /$/,
	    keywords: {'meta-keyword': '.PHONY'},
	    lexemes: /[\.\w]+/
	  };
	  /* Targets */
	  var TARGET = {
	    className: 'section',
	    begin: /^[^\s]+:/, end: /$/,
	    contains: [VARIABLE,]
	  };
	  return {
	    aliases: ['mk', 'mak'],
	    keywords:
	      'define endef undefine ifdef ifndef ifeq ifneq else endif ' +
	      'include -include sinclude override export unexport private vpath',
	    lexemes: /[\w-]+/,
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      VARIABLE,
	      QUOTE_STRING,
	      FUNC,
	      VAR_ASSIG,
	      META,
	      TARGET,
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/markdown.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['md', 'mkdown', 'mkd'],
	    contains: [
	      // highlight headers
	      {
	        className: 'section',
	        variants: [
	          { begin: '^#{1,6}', end: '$' },
	          { begin: '^.+?\\n[=-]{2,}$' }
	        ]
	      },
	      // inline html
	      {
	        begin: '<', end: '>',
	        subLanguage: 'xml',
	        relevance: 0
	      },
	      // lists (indicators only)
	      {
	        className: 'bullet',
	        begin: '^([*+-]|(\\d+\\.))\\s+'
	      },
	      // strong segments
	      {
	        className: 'strong',
	        begin: '[*_]{2}.+?[*_]{2}'
	      },
	      // emphasis segments
	      {
	        className: 'emphasis',
	        variants: [
	          { begin: '\\*.+?\\*' },
	          { begin: '_.+?_'
	          , relevance: 0
	          }
	        ]
	      },
	      // blockquotes
	      {
	        className: 'quote',
	        begin: '^>\\s+', end: '$'
	      },
	      // code snippets
	      {
	        className: 'code',
	        variants: [
	          {
	            begin: '^```\w*\s*$', end: '^```\s*$'
	          },
	          {
	            begin: '`.+?`'
	          },
	          {
	            begin: '^( {4}|\t)', end: '$',
	            relevance: 0
	          }
	        ]
	      },
	      // horizontal rules
	      {
	        begin: '^[-\\*]{3,}', end: '$'
	      },
	      // using links - title and link
	      {
	        begin: '\\[.+?\\][\\(\\[].*?[\\)\\]]',
	        returnBegin: true,
	        contains: [
	          {
	            className: 'string',
	            begin: '\\[', end: '\\]',
	            excludeBegin: true,
	            returnEnd: true,
	            relevance: 0
	          },
	          {
	            className: 'link',
	            begin: '\\]\\(', end: '\\)',
	            excludeBegin: true, excludeEnd: true
	          },
	          {
	            className: 'symbol',
	            begin: '\\]\\[', end: '\\]',
	            excludeBegin: true, excludeEnd: true
	          }
	        ],
	        relevance: 10
	      },
	      {
	        begin: /^\[[^\n]+\]:/,
	        returnBegin: true,
	        contains: [
	          {
	            className: 'symbol',
	            begin: /\[/, end: /\]/,
	            excludeBegin: true, excludeEnd: true
	          },
	          {
	            className: 'link',
	            begin: /:\s*/, end: /$/,
	            excludeBegin: true
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/mathematica.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['mma'],
	    lexemes: '(\\$|\\b)' + hljs.IDENT_RE + '\\b',
	    keywords: 'AbelianGroup Abort AbortKernels AbortProtect Above Abs Absolute AbsoluteCorrelation AbsoluteCorrelationFunction AbsoluteCurrentValue AbsoluteDashing AbsoluteFileName AbsoluteOptions AbsolutePointSize AbsoluteThickness AbsoluteTime AbsoluteTiming AccountingForm Accumulate Accuracy AccuracyGoal ActionDelay ActionMenu ActionMenuBox ActionMenuBoxOptions Active ActiveItem ActiveStyle AcyclicGraphQ AddOnHelpPath AddTo AdjacencyGraph AdjacencyList AdjacencyMatrix AdjustmentBox AdjustmentBoxOptions AdjustTimeSeriesForecast AffineTransform After AiryAi AiryAiPrime AiryAiZero AiryBi AiryBiPrime AiryBiZero AlgebraicIntegerQ AlgebraicNumber AlgebraicNumberDenominator AlgebraicNumberNorm AlgebraicNumberPolynomial AlgebraicNumberTrace AlgebraicRules AlgebraicRulesData Algebraics AlgebraicUnitQ Alignment AlignmentMarker AlignmentPoint All AllowedDimensions AllowGroupClose AllowInlineCells AllowKernelInitialization AllowReverseGroupClose AllowScriptLevelChange AlphaChannel AlternatingGroup AlternativeHypothesis Alternatives AmbientLight Analytic AnchoredSearch And AndersonDarlingTest AngerJ AngleBracket AngularGauge Animate AnimationCycleOffset AnimationCycleRepetitions AnimationDirection AnimationDisplayTime AnimationRate AnimationRepetitions AnimationRunning Animator AnimatorBox AnimatorBoxOptions AnimatorElements Annotation Annuity AnnuityDue Antialiasing Antisymmetric Apart ApartSquareFree Appearance AppearanceElements AppellF1 Append AppendTo Apply ArcCos ArcCosh ArcCot ArcCoth ArcCsc ArcCsch ArcSec ArcSech ArcSin ArcSinDistribution ArcSinh ArcTan ArcTanh Arg ArgMax ArgMin ArgumentCountQ ARIMAProcess ArithmeticGeometricMean ARMAProcess ARProcess Array ArrayComponents ArrayDepth ArrayFlatten ArrayPad ArrayPlot ArrayQ ArrayReshape ArrayRules Arrays Arrow Arrow3DBox ArrowBox Arrowheads AspectRatio AspectRatioFixed Assert Assuming Assumptions AstronomicalData Asynchronous AsynchronousTaskObject AsynchronousTasks AtomQ Attributes AugmentedSymmetricPolynomial AutoAction AutoDelete AutoEvaluateEvents AutoGeneratedPackage AutoIndent AutoIndentSpacings AutoItalicWords AutoloadPath AutoMatch Automatic AutomaticImageSize AutoMultiplicationSymbol AutoNumberFormatting AutoOpenNotebooks AutoOpenPalettes AutorunSequencing AutoScaling AutoScroll AutoSpacing AutoStyleOptions AutoStyleWords Axes AxesEdge AxesLabel AxesOrigin AxesStyle Axis ' +
	      'BabyMonsterGroupB Back Background BackgroundTasksSettings Backslash Backsubstitution Backward Band BandpassFilter BandstopFilter BarabasiAlbertGraphDistribution BarChart BarChart3D BarLegend BarlowProschanImportance BarnesG BarOrigin BarSpacing BartlettHannWindow BartlettWindow BaseForm Baseline BaselinePosition BaseStyle BatesDistribution BattleLemarieWavelet Because BeckmannDistribution Beep Before Begin BeginDialogPacket BeginFrontEndInteractionPacket BeginPackage BellB BellY Below BenfordDistribution BeniniDistribution BenktanderGibratDistribution BenktanderWeibullDistribution BernoulliB BernoulliDistribution BernoulliGraphDistribution BernoulliProcess BernsteinBasis BesselFilterModel BesselI BesselJ BesselJZero BesselK BesselY BesselYZero Beta BetaBinomialDistribution BetaDistribution BetaNegativeBinomialDistribution BetaPrimeDistribution BetaRegularized BetweennessCentrality BezierCurve BezierCurve3DBox BezierCurve3DBoxOptions BezierCurveBox BezierCurveBoxOptions BezierFunction BilateralFilter Binarize BinaryFormat BinaryImageQ BinaryRead BinaryReadList BinaryWrite BinCounts BinLists Binomial BinomialDistribution BinomialProcess BinormalDistribution BiorthogonalSplineWavelet BipartiteGraphQ BirnbaumImportance BirnbaumSaundersDistribution BitAnd BitClear BitGet BitLength BitNot BitOr BitSet BitShiftLeft BitShiftRight BitXor Black BlackmanHarrisWindow BlackmanNuttallWindow BlackmanWindow Blank BlankForm BlankNullSequence BlankSequence Blend Block BlockRandom BlomqvistBeta BlomqvistBetaTest Blue Blur BodePlot BohmanWindow Bold Bookmarks Boole BooleanConsecutiveFunction BooleanConvert BooleanCountingFunction BooleanFunction BooleanGraph BooleanMaxterms BooleanMinimize BooleanMinterms Booleans BooleanTable BooleanVariables BorderDimensions BorelTannerDistribution Bottom BottomHatTransform BoundaryStyle Bounds Box BoxBaselineShift BoxData BoxDimensions Boxed Boxes BoxForm BoxFormFormatTypes BoxFrame BoxID BoxMargins BoxMatrix BoxRatios BoxRotation BoxRotationPoint BoxStyle BoxWhiskerChart Bra BracketingBar BraKet BrayCurtisDistance BreadthFirstScan Break Brown BrownForsytheTest BrownianBridgeProcess BrowserCategory BSplineBasis BSplineCurve BSplineCurve3DBox BSplineCurveBox BSplineCurveBoxOptions BSplineFunction BSplineSurface BSplineSurface3DBox BubbleChart BubbleChart3D BubbleScale BubbleSizes BulletGauge BusinessDayQ ButterflyGraph ButterworthFilterModel Button ButtonBar ButtonBox ButtonBoxOptions ButtonCell ButtonContents ButtonData ButtonEvaluator ButtonExpandable ButtonFrame ButtonFunction ButtonMargins ButtonMinHeight ButtonNote ButtonNotebook ButtonSource ButtonStyle ButtonStyleMenuListing Byte ByteCount ByteOrdering ' +
	      'C CachedValue CacheGraphics CalendarData CalendarType CallPacket CanberraDistance Cancel CancelButton CandlestickChart Cap CapForm CapitalDifferentialD CardinalBSplineBasis CarmichaelLambda Cases Cashflow Casoratian Catalan CatalanNumber Catch CauchyDistribution CauchyWindow CayleyGraph CDF CDFDeploy CDFInformation CDFWavelet Ceiling Cell CellAutoOverwrite CellBaseline CellBoundingBox CellBracketOptions CellChangeTimes CellContents CellContext CellDingbat CellDynamicExpression CellEditDuplicate CellElementsBoundingBox CellElementSpacings CellEpilog CellEvaluationDuplicate CellEvaluationFunction CellEventActions CellFrame CellFrameColor CellFrameLabelMargins CellFrameLabels CellFrameMargins CellGroup CellGroupData CellGrouping CellGroupingRules CellHorizontalScrolling CellID CellLabel CellLabelAutoDelete CellLabelMargins CellLabelPositioning CellMargins CellObject CellOpen CellPrint CellProlog Cells CellSize CellStyle CellTags CellularAutomaton CensoredDistribution Censoring Center CenterDot CentralMoment CentralMomentGeneratingFunction CForm ChampernowneNumber ChanVeseBinarize Character CharacterEncoding CharacterEncodingsPath CharacteristicFunction CharacteristicPolynomial CharacterRange Characters ChartBaseStyle ChartElementData ChartElementDataFunction ChartElementFunction ChartElements ChartLabels ChartLayout ChartLegends ChartStyle Chebyshev1FilterModel Chebyshev2FilterModel ChebyshevDistance ChebyshevT ChebyshevU Check CheckAbort CheckAll Checkbox CheckboxBar CheckboxBox CheckboxBoxOptions ChemicalData ChessboardDistance ChiDistribution ChineseRemainder ChiSquareDistribution ChoiceButtons ChoiceDialog CholeskyDecomposition Chop Circle CircleBox CircleDot CircleMinus CirclePlus CircleTimes CirculantGraph CityData Clear ClearAll ClearAttributes ClearSystemCache ClebschGordan ClickPane Clip ClipboardNotebook ClipFill ClippingStyle ClipPlanes ClipRange Clock ClockGauge ClockwiseContourIntegral Close Closed CloseKernels ClosenessCentrality Closing ClosingAutoSave ClosingEvent ClusteringComponents CMYKColor Coarse Coefficient CoefficientArrays CoefficientDomain CoefficientList CoefficientRules CoifletWavelet Collect Colon ColonForm ColorCombine ColorConvert ColorData ColorDataFunction ColorFunction ColorFunctionScaling Colorize ColorNegate ColorOutput ColorProfileData ColorQuantize ColorReplace ColorRules ColorSelectorSettings ColorSeparate ColorSetter ColorSetterBox ColorSetterBoxOptions ColorSlider ColorSpace Column ColumnAlignments ColumnBackgrounds ColumnForm ColumnLines ColumnsEqual ColumnSpacings ColumnWidths CommonDefaultFormatTypes Commonest CommonestFilter CommonUnits CommunityBoundaryStyle CommunityGraphPlot CommunityLabels CommunityRegionStyle CompatibleUnitQ CompilationOptions CompilationTarget Compile Compiled CompiledFunction Complement CompleteGraph CompleteGraphQ CompleteKaryTree CompletionsListPacket Complex Complexes ComplexExpand ComplexInfinity ComplexityFunction ComponentMeasurements ' +
	      'ComponentwiseContextMenu Compose ComposeList ComposeSeries Composition CompoundExpression CompoundPoissonDistribution CompoundPoissonProcess CompoundRenewalProcess Compress CompressedData Condition ConditionalExpression Conditioned Cone ConeBox ConfidenceLevel ConfidenceRange ConfidenceTransform ConfigurationPath Congruent Conjugate ConjugateTranspose Conjunction Connect ConnectedComponents ConnectedGraphQ ConnesWindow ConoverTest ConsoleMessage ConsoleMessagePacket ConsolePrint Constant ConstantArray Constants ConstrainedMax ConstrainedMin ContentPadding ContentsBoundingBox ContentSelectable ContentSize Context ContextMenu Contexts ContextToFilename ContextToFileName Continuation Continue ContinuedFraction ContinuedFractionK ContinuousAction ContinuousMarkovProcess ContinuousTimeModelQ ContinuousWaveletData ContinuousWaveletTransform ContourDetect ContourGraphics ContourIntegral ContourLabels ContourLines ContourPlot ContourPlot3D Contours ContourShading ContourSmoothing ContourStyle ContraharmonicMean Control ControlActive ControlAlignment ControllabilityGramian ControllabilityMatrix ControllableDecomposition ControllableModelQ ControllerDuration ControllerInformation ControllerInformationData ControllerLinking ControllerManipulate ControllerMethod ControllerPath ControllerState ControlPlacement ControlsRendering ControlType Convergents ConversionOptions ConversionRules ConvertToBitmapPacket ConvertToPostScript ConvertToPostScriptPacket Convolve ConwayGroupCo1 ConwayGroupCo2 ConwayGroupCo3 CoordinateChartData CoordinatesToolOptions CoordinateTransform CoordinateTransformData CoprimeQ Coproduct CopulaDistribution Copyable CopyDirectory CopyFile CopyTag CopyToClipboard CornerFilter CornerNeighbors Correlation CorrelationDistance CorrelationFunction CorrelationTest Cos Cosh CoshIntegral CosineDistance CosineWindow CosIntegral Cot Coth Count CounterAssignments CounterBox CounterBoxOptions CounterClockwiseContourIntegral CounterEvaluator CounterFunction CounterIncrements CounterStyle CounterStyleMenuListing CountRoots CountryData Covariance CovarianceEstimatorFunction CovarianceFunction CoxianDistribution CoxIngersollRossProcess CoxModel CoxModelFit CramerVonMisesTest CreateArchive CreateDialog CreateDirectory CreateDocument CreateIntermediateDirectories CreatePalette CreatePalettePacket CreateScheduledTask CreateTemporary CreateWindow CriticalityFailureImportance CriticalitySuccessImportance CriticalSection Cross CrossingDetect CrossMatrix Csc Csch CubeRoot Cubics Cuboid CuboidBox Cumulant CumulantGeneratingFunction Cup CupCap Curl CurlyDoubleQuote CurlyQuote CurrentImage CurrentlySpeakingPacket CurrentValue CurvatureFlowFilter CurveClosed Cyan CycleGraph CycleIndexPolynomial Cycles CyclicGroup Cyclotomic Cylinder CylinderBox CylindricalDecomposition ' +
	      'D DagumDistribution DamerauLevenshteinDistance DampingFactor Darker Dashed Dashing DataCompression DataDistribution DataRange DataReversed Date DateDelimiters DateDifference DateFunction DateList DateListLogPlot DateListPlot DatePattern DatePlus DateRange DateString DateTicksFormat DaubechiesWavelet DavisDistribution DawsonF DayCount DayCountConvention DayMatchQ DayName DayPlus DayRange DayRound DeBruijnGraph Debug DebugTag Decimal DeclareKnownSymbols DeclarePackage Decompose Decrement DedekindEta Default DefaultAxesStyle DefaultBaseStyle DefaultBoxStyle DefaultButton DefaultColor DefaultControlPlacement DefaultDuplicateCellStyle DefaultDuration DefaultElement DefaultFaceGridsStyle DefaultFieldHintStyle DefaultFont DefaultFontProperties DefaultFormatType DefaultFormatTypeForStyle DefaultFrameStyle DefaultFrameTicksStyle DefaultGridLinesStyle DefaultInlineFormatType DefaultInputFormatType DefaultLabelStyle DefaultMenuStyle DefaultNaturalLanguage DefaultNewCellStyle DefaultNewInlineCellStyle DefaultNotebook DefaultOptions DefaultOutputFormatType DefaultStyle DefaultStyleDefinitions DefaultTextFormatType DefaultTextInlineFormatType DefaultTicksStyle DefaultTooltipStyle DefaultValues Defer DefineExternal DefineInputStreamMethod DefineOutputStreamMethod Definition Degree DegreeCentrality DegreeGraphDistribution DegreeLexicographic DegreeReverseLexicographic Deinitialization Del Deletable Delete DeleteBorderComponents DeleteCases DeleteContents DeleteDirectory DeleteDuplicates DeleteFile DeleteSmallComponents DeleteWithContents DeletionWarning Delimiter DelimiterFlashTime DelimiterMatching Delimiters Denominator DensityGraphics DensityHistogram DensityPlot DependentVariables Deploy Deployed Depth DepthFirstScan Derivative DerivativeFilter DescriptorStateSpace DesignMatrix Det DGaussianWavelet DiacriticalPositioning Diagonal DiagonalMatrix Dialog DialogIndent DialogInput DialogLevel DialogNotebook DialogProlog DialogReturn DialogSymbols Diamond DiamondMatrix DiceDissimilarity DictionaryLookup DifferenceDelta DifferenceOrder DifferenceRoot DifferenceRootReduce Differences DifferentialD DifferentialRoot DifferentialRootReduce DifferentiatorFilter DigitBlock DigitBlockMinimum DigitCharacter DigitCount DigitQ DihedralGroup Dilation Dimensions DiracComb DiracDelta DirectedEdge DirectedEdges DirectedGraph DirectedGraphQ DirectedInfinity Direction Directive Directory DirectoryName DirectoryQ DirectoryStack DirichletCharacter DirichletConvolve DirichletDistribution DirichletL DirichletTransform DirichletWindow DisableConsolePrintPacket DiscreteChirpZTransform DiscreteConvolve DiscreteDelta DiscreteHadamardTransform DiscreteIndicator DiscreteLQEstimatorGains DiscreteLQRegulatorGains DiscreteLyapunovSolve DiscreteMarkovProcess DiscretePlot DiscretePlot3D DiscreteRatio DiscreteRiccatiSolve DiscreteShift DiscreteTimeModelQ DiscreteUniformDistribution DiscreteVariables DiscreteWaveletData DiscreteWaveletPacketTransform ' +
	      'DiscreteWaveletTransform Discriminant Disjunction Disk DiskBox DiskMatrix Dispatch DispersionEstimatorFunction Display DisplayAllSteps DisplayEndPacket DisplayFlushImagePacket DisplayForm DisplayFunction DisplayPacket DisplayRules DisplaySetSizePacket DisplayString DisplayTemporary DisplayWith DisplayWithRef DisplayWithVariable DistanceFunction DistanceTransform Distribute Distributed DistributedContexts DistributeDefinitions DistributionChart DistributionDomain DistributionFitTest DistributionParameterAssumptions DistributionParameterQ Dithering Div Divergence Divide DivideBy Dividers Divisible Divisors DivisorSigma DivisorSum DMSList DMSString Do DockedCells DocumentNotebook DominantColors DOSTextFormat Dot DotDashed DotEqual Dotted DoubleBracketingBar DoubleContourIntegral DoubleDownArrow DoubleLeftArrow DoubleLeftRightArrow DoubleLeftTee DoubleLongLeftArrow DoubleLongLeftRightArrow DoubleLongRightArrow DoubleRightArrow DoubleRightTee DoubleUpArrow DoubleUpDownArrow DoubleVerticalBar DoublyInfinite Down DownArrow DownArrowBar DownArrowUpArrow DownLeftRightVector DownLeftTeeVector DownLeftVector DownLeftVectorBar DownRightTeeVector DownRightVector DownRightVectorBar Downsample DownTee DownTeeArrow DownValues DragAndDrop DrawEdges DrawFrontFaces DrawHighlighted Drop DSolve Dt DualLinearProgramming DualSystemsModel DumpGet DumpSave DuplicateFreeQ Dynamic DynamicBox DynamicBoxOptions DynamicEvaluationTimeout DynamicLocation DynamicModule DynamicModuleBox DynamicModuleBoxOptions DynamicModuleParent DynamicModuleValues DynamicName DynamicNamespace DynamicReference DynamicSetting DynamicUpdating DynamicWrapper DynamicWrapperBox DynamicWrapperBoxOptions ' +
	      'E EccentricityCentrality EdgeAdd EdgeBetweennessCentrality EdgeCapacity EdgeCapForm EdgeColor EdgeConnectivity EdgeCost EdgeCount EdgeCoverQ EdgeDashing EdgeDelete EdgeDetect EdgeForm EdgeIndex EdgeJoinForm EdgeLabeling EdgeLabels EdgeLabelStyle EdgeList EdgeOpacity EdgeQ EdgeRenderingFunction EdgeRules EdgeShapeFunction EdgeStyle EdgeThickness EdgeWeight Editable EditButtonSettings EditCellTagsSettings EditDistance EffectiveInterest Eigensystem Eigenvalues EigenvectorCentrality Eigenvectors Element ElementData Eliminate EliminationOrder EllipticE EllipticExp EllipticExpPrime EllipticF EllipticFilterModel EllipticK EllipticLog EllipticNomeQ EllipticPi EllipticReducedHalfPeriods EllipticTheta EllipticThetaPrime EmitSound EmphasizeSyntaxErrors EmpiricalDistribution Empty EmptyGraphQ EnableConsolePrintPacket Enabled Encode End EndAdd EndDialogPacket EndFrontEndInteractionPacket EndOfFile EndOfLine EndOfString EndPackage EngineeringForm Enter EnterExpressionPacket EnterTextPacket Entropy EntropyFilter Environment Epilog Equal EqualColumns EqualRows EqualTilde EquatedTo Equilibrium EquirippleFilterKernel Equivalent Erf Erfc Erfi ErlangB ErlangC ErlangDistribution Erosion ErrorBox ErrorBoxOptions ErrorNorm ErrorPacket ErrorsDialogSettings EstimatedDistribution EstimatedProcess EstimatorGains EstimatorRegulator EuclideanDistance EulerE EulerGamma EulerianGraphQ EulerPhi Evaluatable Evaluate Evaluated EvaluatePacket EvaluationCell EvaluationCompletionAction EvaluationElements EvaluationMode EvaluationMonitor EvaluationNotebook EvaluationObject EvaluationOrder Evaluator EvaluatorNames EvenQ EventData EventEvaluator EventHandler EventHandlerTag EventLabels ExactBlackmanWindow ExactNumberQ ExactRootIsolation ExampleData Except ExcludedForms ExcludePods Exclusions ExclusionsStyle Exists Exit ExitDialog Exp Expand ExpandAll ExpandDenominator ExpandFileName ExpandNumerator Expectation ExpectationE ExpectedValue ExpGammaDistribution ExpIntegralE ExpIntegralEi Exponent ExponentFunction ExponentialDistribution ExponentialFamily ExponentialGeneratingFunction ExponentialMovingAverage ExponentialPowerDistribution ExponentPosition ExponentStep Export ExportAutoReplacements ExportPacket ExportString Expression ExpressionCell ExpressionPacket ExpToTrig ExtendedGCD Extension ExtentElementFunction ExtentMarkers ExtentSize ExternalCall ExternalDataCharacterEncoding Extract ExtractArchive ExtremeValueDistribution ' +
	      'FaceForm FaceGrids FaceGridsStyle Factor FactorComplete Factorial Factorial2 FactorialMoment FactorialMomentGeneratingFunction FactorialPower FactorInteger FactorList FactorSquareFree FactorSquareFreeList FactorTerms FactorTermsList Fail FailureDistribution False FARIMAProcess FEDisableConsolePrintPacket FeedbackSector FeedbackSectorStyle FeedbackType FEEnableConsolePrintPacket Fibonacci FieldHint FieldHintStyle FieldMasked FieldSize File FileBaseName FileByteCount FileDate FileExistsQ FileExtension FileFormat FileHash FileInformation FileName FileNameDepth FileNameDialogSettings FileNameDrop FileNameJoin FileNames FileNameSetter FileNameSplit FileNameTake FilePrint FileType FilledCurve FilledCurveBox Filling FillingStyle FillingTransform FilterRules FinancialBond FinancialData FinancialDerivative FinancialIndicator Find FindArgMax FindArgMin FindClique FindClusters FindCurvePath FindDistributionParameters FindDivisions FindEdgeCover FindEdgeCut FindEulerianCycle FindFaces FindFile FindFit FindGeneratingFunction FindGeoLocation FindGeometricTransform FindGraphCommunities FindGraphIsomorphism FindGraphPartition FindHamiltonianCycle FindIndependentEdgeSet FindIndependentVertexSet FindInstance FindIntegerNullVector FindKClan FindKClique FindKClub FindKPlex FindLibrary FindLinearRecurrence FindList FindMaximum FindMaximumFlow FindMaxValue FindMinimum FindMinimumCostFlow FindMinimumCut FindMinValue FindPermutation FindPostmanTour FindProcessParameters FindRoot FindSequenceFunction FindSettings FindShortestPath FindShortestTour FindThreshold FindVertexCover FindVertexCut Fine FinishDynamic FiniteAbelianGroupCount FiniteGroupCount FiniteGroupData First FirstPassageTimeDistribution FischerGroupFi22 FischerGroupFi23 FischerGroupFi24Prime FisherHypergeometricDistribution FisherRatioTest FisherZDistribution Fit FitAll FittedModel FixedPoint FixedPointList FlashSelection Flat Flatten FlattenAt FlatTopWindow FlipView Floor FlushPrintOutputPacket Fold FoldList Font FontColor FontFamily FontForm FontName FontOpacity FontPostScriptName FontProperties FontReencoding FontSize FontSlant FontSubstitutions FontTracking FontVariations FontWeight For ForAll Format FormatRules FormatType FormatTypeAutoConvert FormatValues FormBox FormBoxOptions FortranForm Forward ForwardBackward Fourier FourierCoefficient FourierCosCoefficient FourierCosSeries FourierCosTransform FourierDCT FourierDCTFilter FourierDCTMatrix FourierDST FourierDSTMatrix FourierMatrix FourierParameters FourierSequenceTransform FourierSeries FourierSinCoefficient FourierSinSeries FourierSinTransform FourierTransform FourierTrigSeries FractionalBrownianMotionProcess FractionalPart FractionBox FractionBoxOptions FractionLine Frame FrameBox FrameBoxOptions Framed FrameInset FrameLabel Frameless FrameMargins FrameStyle FrameTicks FrameTicksStyle FRatioDistribution FrechetDistribution FreeQ FrequencySamplingFilterKernel FresnelC FresnelS Friday FrobeniusNumber FrobeniusSolve ' +
	      'FromCharacterCode FromCoefficientRules FromContinuedFraction FromDate FromDigits FromDMS Front FrontEndDynamicExpression FrontEndEventActions FrontEndExecute FrontEndObject FrontEndResource FrontEndResourceString FrontEndStackSize FrontEndToken FrontEndTokenExecute FrontEndValueCache FrontEndVersion FrontFaceColor FrontFaceOpacity Full FullAxes FullDefinition FullForm FullGraphics FullOptions FullSimplify Function FunctionExpand FunctionInterpolation FunctionSpace FussellVeselyImportance ' +
	      'GaborFilter GaborMatrix GaborWavelet GainMargins GainPhaseMargins Gamma GammaDistribution GammaRegularized GapPenalty Gather GatherBy GaugeFaceElementFunction GaugeFaceStyle GaugeFrameElementFunction GaugeFrameSize GaugeFrameStyle GaugeLabels GaugeMarkers GaugeStyle GaussianFilter GaussianIntegers GaussianMatrix GaussianWindow GCD GegenbauerC General GeneralizedLinearModelFit GenerateConditions GeneratedCell GeneratedParameters GeneratingFunction Generic GenericCylindricalDecomposition GenomeData GenomeLookup GeodesicClosing GeodesicDilation GeodesicErosion GeodesicOpening GeoDestination GeodesyData GeoDirection GeoDistance GeoGridPosition GeometricBrownianMotionProcess GeometricDistribution GeometricMean GeometricMeanFilter GeometricTransformation GeometricTransformation3DBox GeometricTransformation3DBoxOptions GeometricTransformationBox GeometricTransformationBoxOptions GeoPosition GeoPositionENU GeoPositionXYZ GeoProjectionData GestureHandler GestureHandlerTag Get GetBoundingBoxSizePacket GetContext GetEnvironment GetFileName GetFrontEndOptionsDataPacket GetLinebreakInformationPacket GetMenusPacket GetPageBreakInformationPacket Glaisher GlobalClusteringCoefficient GlobalPreferences GlobalSession Glow GoldenRatio GompertzMakehamDistribution GoodmanKruskalGamma GoodmanKruskalGammaTest Goto Grad Gradient GradientFilter GradientOrientationFilter Graph GraphAssortativity GraphCenter GraphComplement GraphData GraphDensity GraphDiameter GraphDifference GraphDisjointUnion ' +
	      'GraphDistance GraphDistanceMatrix GraphElementData GraphEmbedding GraphHighlight GraphHighlightStyle GraphHub Graphics Graphics3D Graphics3DBox Graphics3DBoxOptions GraphicsArray GraphicsBaseline GraphicsBox GraphicsBoxOptions GraphicsColor GraphicsColumn GraphicsComplex GraphicsComplex3DBox GraphicsComplex3DBoxOptions GraphicsComplexBox GraphicsComplexBoxOptions GraphicsContents GraphicsData GraphicsGrid GraphicsGridBox GraphicsGroup GraphicsGroup3DBox GraphicsGroup3DBoxOptions GraphicsGroupBox GraphicsGroupBoxOptions GraphicsGrouping GraphicsHighlightColor GraphicsRow GraphicsSpacing GraphicsStyle GraphIntersection GraphLayout GraphLinkEfficiency GraphPeriphery GraphPlot GraphPlot3D GraphPower GraphPropertyDistribution GraphQ GraphRadius GraphReciprocity GraphRoot GraphStyle GraphUnion Gray GrayLevel GreatCircleDistance Greater GreaterEqual GreaterEqualLess GreaterFullEqual GreaterGreater GreaterLess GreaterSlantEqual GreaterTilde Green Grid GridBaseline GridBox GridBoxAlignment GridBoxBackground GridBoxDividers GridBoxFrame GridBoxItemSize GridBoxItemStyle GridBoxOptions GridBoxSpacings GridCreationSettings GridDefaultElement GridElementStyleOptions GridFrame GridFrameMargins GridGraph GridLines GridLinesStyle GroebnerBasis GroupActionBase GroupCentralizer GroupElementFromWord GroupElementPosition GroupElementQ GroupElements GroupElementToWord GroupGenerators GroupMultiplicationTable GroupOrbits GroupOrder GroupPageBreakWithin GroupSetwiseStabilizer GroupStabilizer GroupStabilizerChain Gudermannian GumbelDistribution ' +
	      'HaarWavelet HadamardMatrix HalfNormalDistribution HamiltonianGraphQ HammingDistance HammingWindow HankelH1 HankelH2 HankelMatrix HannPoissonWindow HannWindow HaradaNortonGroupHN HararyGraph HarmonicMean HarmonicMeanFilter HarmonicNumber Hash HashTable Haversine HazardFunction Head HeadCompose Heads HeavisideLambda HeavisidePi HeavisideTheta HeldGroupHe HeldPart HelpBrowserLookup HelpBrowserNotebook HelpBrowserSettings HermiteDecomposition HermiteH HermitianMatrixQ HessenbergDecomposition Hessian HexadecimalCharacter Hexahedron HexahedronBox HexahedronBoxOptions HiddenSurface HighlightGraph HighlightImage HighpassFilter HigmanSimsGroupHS HilbertFilter HilbertMatrix Histogram Histogram3D HistogramDistribution HistogramList HistogramTransform HistogramTransformInterpolation HitMissTransform HITSCentrality HodgeDual HoeffdingD HoeffdingDTest Hold HoldAll HoldAllComplete HoldComplete HoldFirst HoldForm HoldPattern HoldRest HolidayCalendar HomeDirectory HomePage Horizontal HorizontalForm HorizontalGauge HorizontalScrollPosition HornerForm HotellingTSquareDistribution HoytDistribution HTMLSave Hue HumpDownHump HumpEqual HurwitzLerchPhi HurwitzZeta HyperbolicDistribution HypercubeGraph HyperexponentialDistribution Hyperfactorial Hypergeometric0F1 Hypergeometric0F1Regularized Hypergeometric1F1 Hypergeometric1F1Regularized Hypergeometric2F1 Hypergeometric2F1Regularized HypergeometricDistribution HypergeometricPFQ HypergeometricPFQRegularized HypergeometricU Hyperlink HyperlinkCreationSettings Hyphenation HyphenationOptions HypoexponentialDistribution HypothesisTestData ' +
	      'I Identity IdentityMatrix If IgnoreCase Im Image Image3D Image3DSlices ImageAccumulate ImageAdd ImageAdjust ImageAlign ImageApply ImageAspectRatio ImageAssemble ImageCache ImageCacheValid ImageCapture ImageChannels ImageClip ImageColorSpace ImageCompose ImageConvolve ImageCooccurrence ImageCorners ImageCorrelate ImageCorrespondingPoints ImageCrop ImageData ImageDataPacket ImageDeconvolve ImageDemosaic ImageDifference ImageDimensions ImageDistance ImageEffect ImageFeatureTrack ImageFileApply ImageFileFilter ImageFileScan ImageFilter ImageForestingComponents ImageForwardTransformation ImageHistogram ImageKeypoints ImageLevels ImageLines ImageMargins ImageMarkers ImageMeasurements ImageMultiply ImageOffset ImagePad ImagePadding ImagePartition ImagePeriodogram ImagePerspectiveTransformation ImageQ ImageRangeCache ImageReflect ImageRegion ImageResize ImageResolution ImageRotate ImageRotated ImageScaled ImageScan ImageSize ImageSizeAction ImageSizeCache ImageSizeMultipliers ImageSizeRaw ImageSubtract ImageTake ImageTransformation ImageTrim ImageType ImageValue ImageValuePositions Implies Import ImportAutoReplacements ImportString ImprovementImportance In IncidenceGraph IncidenceList IncidenceMatrix IncludeConstantBasis IncludeFileExtension IncludePods IncludeSingularTerm Increment Indent IndentingNewlineSpacings IndentMaxFraction IndependenceTest IndependentEdgeSetQ IndependentUnit IndependentVertexSetQ Indeterminate IndexCreationOptions Indexed IndexGraph IndexTag Inequality InexactNumberQ InexactNumbers Infinity Infix Information Inherited InheritScope Initialization InitializationCell InitializationCellEvaluation InitializationCellWarning InlineCounterAssignments InlineCounterIncrements InlineRules Inner Inpaint Input InputAliases InputAssumptions InputAutoReplacements InputField InputFieldBox InputFieldBoxOptions InputForm InputGrouping InputNamePacket InputNotebook InputPacket InputSettings InputStream InputString InputStringPacket InputToBoxFormPacket Insert InsertionPointObject InsertResults Inset Inset3DBox Inset3DBoxOptions InsetBox InsetBoxOptions Install InstallService InString Integer IntegerDigits IntegerExponent IntegerLength IntegerPart IntegerPartitions IntegerQ Integers IntegerString Integral Integrate Interactive InteractiveTradingChart Interlaced Interleaving InternallyBalancedDecomposition InterpolatingFunction InterpolatingPolynomial Interpolation InterpolationOrder InterpolationPoints InterpolationPrecision Interpretation InterpretationBox InterpretationBoxOptions InterpretationFunction ' +
	      'InterpretTemplate InterquartileRange Interrupt InterruptSettings Intersection Interval IntervalIntersection IntervalMemberQ IntervalUnion Inverse InverseBetaRegularized InverseCDF InverseChiSquareDistribution InverseContinuousWaveletTransform InverseDistanceTransform InverseEllipticNomeQ InverseErf InverseErfc InverseFourier InverseFourierCosTransform InverseFourierSequenceTransform InverseFourierSinTransform InverseFourierTransform InverseFunction InverseFunctions InverseGammaDistribution InverseGammaRegularized InverseGaussianDistribution InverseGudermannian InverseHaversine InverseJacobiCD InverseJacobiCN InverseJacobiCS InverseJacobiDC InverseJacobiDN InverseJacobiDS InverseJacobiNC InverseJacobiND InverseJacobiNS InverseJacobiSC InverseJacobiSD InverseJacobiSN InverseLaplaceTransform InversePermutation InverseRadon InverseSeries InverseSurvivalFunction InverseWaveletTransform InverseWeierstrassP InverseZTransform Invisible InvisibleApplication InvisibleTimes IrreduciblePolynomialQ IsolatingInterval IsomorphicGraphQ IsotopeData Italic Item ItemBox ItemBoxOptions ItemSize ItemStyle ItoProcess ' +
	      'JaccardDissimilarity JacobiAmplitude Jacobian JacobiCD JacobiCN JacobiCS JacobiDC JacobiDN JacobiDS JacobiNC JacobiND JacobiNS JacobiP JacobiSC JacobiSD JacobiSN JacobiSymbol JacobiZeta JankoGroupJ1 JankoGroupJ2 JankoGroupJ3 JankoGroupJ4 JarqueBeraALMTest JohnsonDistribution Join Joined JoinedCurve JoinedCurveBox JoinForm JordanDecomposition JordanModelDecomposition ' +
	      'K KagiChart KaiserBesselWindow KaiserWindow KalmanEstimator KalmanFilter KarhunenLoeveDecomposition KaryTree KatzCentrality KCoreComponents KDistribution KelvinBei KelvinBer KelvinKei KelvinKer KendallTau KendallTauTest KernelExecute KernelMixtureDistribution KernelObject Kernels Ket Khinchin KirchhoffGraph KirchhoffMatrix KleinInvariantJ KnightTourGraph KnotData KnownUnitQ KolmogorovSmirnovTest KroneckerDelta KroneckerModelDecomposition KroneckerProduct KroneckerSymbol KuiperTest KumaraswamyDistribution Kurtosis KuwaharaFilter ' +
	      'Label Labeled LabeledSlider LabelingFunction LabelStyle LaguerreL LambdaComponents LambertW LanczosWindow LandauDistribution Language LanguageCategory LaplaceDistribution LaplaceTransform Laplacian LaplacianFilter LaplacianGaussianFilter Large Larger Last Latitude LatitudeLongitude LatticeData LatticeReduce Launch LaunchKernels LayeredGraphPlot LayerSizeFunction LayoutInformation LCM LeafCount LeapYearQ LeastSquares LeastSquaresFilterKernel Left LeftArrow LeftArrowBar LeftArrowRightArrow LeftDownTeeVector LeftDownVector LeftDownVectorBar LeftRightArrow LeftRightVector LeftTee LeftTeeArrow LeftTeeVector LeftTriangle LeftTriangleBar LeftTriangleEqual LeftUpDownVector LeftUpTeeVector LeftUpVector LeftUpVectorBar LeftVector LeftVectorBar LegendAppearance Legended LegendFunction LegendLabel LegendLayout LegendMargins LegendMarkers LegendMarkerSize LegendreP LegendreQ LegendreType Length LengthWhile LerchPhi Less LessEqual LessEqualGreater LessFullEqual LessGreater LessLess LessSlantEqual LessTilde LetterCharacter LetterQ Level LeveneTest LeviCivitaTensor LevyDistribution Lexicographic LibraryFunction LibraryFunctionError LibraryFunctionInformation LibraryFunctionLoad LibraryFunctionUnload LibraryLoad LibraryUnload LicenseID LiftingFilterData LiftingWaveletTransform LightBlue LightBrown LightCyan Lighter LightGray LightGreen Lighting LightingAngle LightMagenta LightOrange LightPink LightPurple LightRed LightSources LightYellow Likelihood Limit LimitsPositioning LimitsPositioningTokens LindleyDistribution Line Line3DBox LinearFilter LinearFractionalTransform LinearModelFit LinearOffsetFunction LinearProgramming LinearRecurrence LinearSolve LinearSolveFunction LineBox LineBreak LinebreakAdjustments LineBreakChart LineBreakWithin LineColor LineForm LineGraph LineIndent LineIndentMaxFraction LineIntegralConvolutionPlot LineIntegralConvolutionScale LineLegend LineOpacity LineSpacing LineWrapParts LinkActivate LinkClose LinkConnect LinkConnectedQ LinkCreate LinkError LinkFlush LinkFunction LinkHost LinkInterrupt LinkLaunch LinkMode LinkObject LinkOpen LinkOptions LinkPatterns LinkProtocol LinkRead LinkReadHeld LinkReadyQ Links LinkWrite LinkWriteHeld LiouvilleLambda List Listable ListAnimate ListContourPlot ListContourPlot3D ListConvolve ListCorrelate ListCurvePathPlot ListDeconvolve ListDensityPlot Listen ListFourierSequenceTransform ListInterpolation ListLineIntegralConvolutionPlot ListLinePlot ListLogLinearPlot ListLogLogPlot ListLogPlot ListPicker ListPickerBox ListPickerBoxBackground ListPickerBoxOptions ListPlay ListPlot ListPlot3D ListPointPlot3D ListPolarPlot ListQ ListStreamDensityPlot ListStreamPlot ListSurfacePlot3D ListVectorDensityPlot ListVectorPlot ListVectorPlot3D ListZTransform Literal LiteralSearch LocalClusteringCoefficient LocalizeVariables LocationEquivalenceTest LocationTest Locator LocatorAutoCreate LocatorBox LocatorBoxOptions LocatorCentering LocatorPane LocatorPaneBox LocatorPaneBoxOptions ' +
	      'LocatorRegion Locked Log Log10 Log2 LogBarnesG LogGamma LogGammaDistribution LogicalExpand LogIntegral LogisticDistribution LogitModelFit LogLikelihood LogLinearPlot LogLogisticDistribution LogLogPlot LogMultinormalDistribution LogNormalDistribution LogPlot LogRankTest LogSeriesDistribution LongEqual Longest LongestAscendingSequence LongestCommonSequence LongestCommonSequencePositions LongestCommonSubsequence LongestCommonSubsequencePositions LongestMatch LongForm Longitude LongLeftArrow LongLeftRightArrow LongRightArrow Loopback LoopFreeGraphQ LowerCaseQ LowerLeftArrow LowerRightArrow LowerTriangularize LowpassFilter LQEstimatorGains LQGRegulator LQOutputRegulatorGains LQRegulatorGains LUBackSubstitution LucasL LuccioSamiComponents LUDecomposition LyapunovSolve LyonsGroupLy ' +
	      'MachineID MachineName MachineNumberQ MachinePrecision MacintoshSystemPageSetup Magenta Magnification Magnify MainSolve MaintainDynamicCaches Majority MakeBoxes MakeExpression MakeRules MangoldtLambda ManhattanDistance Manipulate Manipulator MannWhitneyTest MantissaExponent Manual Map MapAll MapAt MapIndexed MAProcess MapThread MarcumQ MardiaCombinedTest MardiaKurtosisTest MardiaSkewnessTest MarginalDistribution MarkovProcessProperties Masking MatchingDissimilarity MatchLocalNameQ MatchLocalNames MatchQ Material MathematicaNotation MathieuC MathieuCharacteristicA MathieuCharacteristicB MathieuCharacteristicExponent MathieuCPrime MathieuGroupM11 MathieuGroupM12 MathieuGroupM22 MathieuGroupM23 MathieuGroupM24 MathieuS MathieuSPrime MathMLForm MathMLText Matrices MatrixExp MatrixForm MatrixFunction MatrixLog MatrixPlot MatrixPower MatrixQ MatrixRank Max MaxBend MaxDetect MaxExtraBandwidths MaxExtraConditions MaxFeatures MaxFilter Maximize MaxIterations MaxMemoryUsed MaxMixtureKernels MaxPlotPoints MaxPoints MaxRecursion MaxStableDistribution MaxStepFraction MaxSteps MaxStepSize MaxValue MaxwellDistribution McLaughlinGroupMcL Mean MeanClusteringCoefficient MeanDegreeConnectivity MeanDeviation MeanFilter MeanGraphDistance MeanNeighborDegree MeanShift MeanShiftFilter Median MedianDeviation MedianFilter Medium MeijerG MeixnerDistribution MemberQ MemoryConstrained MemoryInUse Menu MenuAppearance MenuCommandKey MenuEvaluator MenuItem MenuPacket MenuSortingValue MenuStyle MenuView MergeDifferences Mesh MeshFunctions MeshRange MeshShading MeshStyle Message MessageDialog MessageList MessageName MessageOptions MessagePacket Messages MessagesNotebook MetaCharacters MetaInformation Method MethodOptions MexicanHatWavelet MeyerWavelet Min MinDetect MinFilter MinimalPolynomial MinimalStateSpaceModel Minimize Minors MinRecursion MinSize MinStableDistribution Minus MinusPlus MinValue Missing MissingDataMethod MittagLefflerE MixedRadix MixedRadixQuantity MixtureDistribution Mod Modal Mode Modular ModularLambda Module Modulus MoebiusMu Moment Momentary MomentConvert MomentEvaluate MomentGeneratingFunction Monday Monitor MonomialList MonomialOrder MonsterGroupM MorletWavelet MorphologicalBinarize MorphologicalBranchPoints MorphologicalComponents MorphologicalEulerNumber MorphologicalGraph MorphologicalPerimeter MorphologicalTransform Most MouseAnnotation MouseAppearance MouseAppearanceTag MouseButtons Mouseover MousePointerNote MousePosition MovingAverage MovingMedian MoyalDistribution MultiedgeStyle MultilaunchWarning MultiLetterItalics MultiLetterStyle MultilineFunction Multinomial MultinomialDistribution MultinormalDistribution MultiplicativeOrder Multiplicity Multiselection MultivariateHypergeometricDistribution MultivariatePoissonDistribution MultivariateTDistribution ' +
	      'N NakagamiDistribution NameQ Names NamespaceBox Nand NArgMax NArgMin NBernoulliB NCache NDSolve NDSolveValue Nearest NearestFunction NeedCurrentFrontEndPackagePacket NeedCurrentFrontEndSymbolsPacket NeedlemanWunschSimilarity Needs Negative NegativeBinomialDistribution NegativeMultinomialDistribution NeighborhoodGraph Nest NestedGreaterGreater NestedLessLess NestedScriptRules NestList NestWhile NestWhileList NevilleThetaC NevilleThetaD NevilleThetaN NevilleThetaS NewPrimitiveStyle NExpectation Next NextPrime NHoldAll NHoldFirst NHoldRest NicholsGridLines NicholsPlot NIntegrate NMaximize NMaxValue NMinimize NMinValue NominalVariables NonAssociative NoncentralBetaDistribution NoncentralChiSquareDistribution NoncentralFRatioDistribution NoncentralStudentTDistribution NonCommutativeMultiply NonConstants None NonlinearModelFit NonlocalMeansFilter NonNegative NonPositive Nor NorlundB Norm Normal NormalDistribution NormalGrouping Normalize NormalizedSquaredEuclideanDistance NormalsFunction NormFunction Not NotCongruent NotCupCap NotDoubleVerticalBar Notebook NotebookApply NotebookAutoSave NotebookClose NotebookConvertSettings NotebookCreate NotebookCreateReturnObject NotebookDefault NotebookDelete NotebookDirectory NotebookDynamicExpression NotebookEvaluate NotebookEventActions NotebookFileName NotebookFind NotebookFindReturnObject NotebookGet NotebookGetLayoutInformationPacket NotebookGetMisspellingsPacket NotebookInformation NotebookInterfaceObject NotebookLocate NotebookObject NotebookOpen NotebookOpenReturnObject NotebookPath NotebookPrint NotebookPut NotebookPutReturnObject NotebookRead NotebookResetGeneratedCells Notebooks NotebookSave NotebookSaveAs NotebookSelection NotebookSetupLayoutInformationPacket NotebooksMenu NotebookWrite NotElement NotEqualTilde NotExists NotGreater NotGreaterEqual NotGreaterFullEqual NotGreaterGreater NotGreaterLess NotGreaterSlantEqual NotGreaterTilde NotHumpDownHump NotHumpEqual NotLeftTriangle NotLeftTriangleBar NotLeftTriangleEqual NotLess NotLessEqual NotLessFullEqual NotLessGreater NotLessLess NotLessSlantEqual NotLessTilde NotNestedGreaterGreater NotNestedLessLess NotPrecedes NotPrecedesEqual NotPrecedesSlantEqual NotPrecedesTilde NotReverseElement NotRightTriangle NotRightTriangleBar NotRightTriangleEqual NotSquareSubset NotSquareSubsetEqual NotSquareSuperset NotSquareSupersetEqual NotSubset NotSubsetEqual NotSucceeds NotSucceedsEqual NotSucceedsSlantEqual NotSucceedsTilde NotSuperset NotSupersetEqual NotTilde NotTildeEqual NotTildeFullEqual NotTildeTilde NotVerticalBar NProbability NProduct NProductFactors NRoots NSolve NSum NSumTerms Null NullRecords NullSpace NullWords Number NumberFieldClassNumber NumberFieldDiscriminant NumberFieldFundamentalUnits NumberFieldIntegralBasis NumberFieldNormRepresentatives NumberFieldRegulator NumberFieldRootsOfUnity NumberFieldSignature NumberForm NumberFormat NumberMarks NumberMultiplier NumberPadding NumberPoint NumberQ NumberSeparator ' +
	      'NumberSigns NumberString Numerator NumericFunction NumericQ NuttallWindow NValues NyquistGridLines NyquistPlot ' +
	      'O ObservabilityGramian ObservabilityMatrix ObservableDecomposition ObservableModelQ OddQ Off Offset OLEData On ONanGroupON OneIdentity Opacity Open OpenAppend Opener OpenerBox OpenerBoxOptions OpenerView OpenFunctionInspectorPacket Opening OpenRead OpenSpecialOptions OpenTemporary OpenWrite Operate OperatingSystem OptimumFlowData Optional OptionInspectorSettings OptionQ Options OptionsPacket OptionsPattern OptionValue OptionValueBox OptionValueBoxOptions Or Orange Order OrderDistribution OrderedQ Ordering Orderless OrnsteinUhlenbeckProcess Orthogonalize Out Outer OutputAutoOverwrite OutputControllabilityMatrix OutputControllableModelQ OutputForm OutputFormData OutputGrouping OutputMathEditExpression OutputNamePacket OutputResponse OutputSizeLimit OutputStream Over OverBar OverDot Overflow OverHat Overlaps Overlay OverlayBox OverlayBoxOptions Overscript OverscriptBox OverscriptBoxOptions OverTilde OverVector OwenT OwnValues ' +
	      'PackingMethod PaddedForm Padding PadeApproximant PadLeft PadRight PageBreakAbove PageBreakBelow PageBreakWithin PageFooterLines PageFooters PageHeaderLines PageHeaders PageHeight PageRankCentrality PageWidth PairedBarChart PairedHistogram PairedSmoothHistogram PairedTTest PairedZTest PaletteNotebook PalettePath Pane PaneBox PaneBoxOptions Panel PanelBox PanelBoxOptions Paneled PaneSelector PaneSelectorBox PaneSelectorBoxOptions PaperWidth ParabolicCylinderD ParagraphIndent ParagraphSpacing ParallelArray ParallelCombine ParallelDo ParallelEvaluate Parallelization Parallelize ParallelMap ParallelNeeds ParallelProduct ParallelSubmit ParallelSum ParallelTable ParallelTry Parameter ParameterEstimator ParameterMixtureDistribution ParameterVariables ParametricFunction ParametricNDSolve ParametricNDSolveValue ParametricPlot ParametricPlot3D ParentConnect ParentDirectory ParentForm Parenthesize ParentList ParetoDistribution Part PartialCorrelationFunction PartialD ParticleData Partition PartitionsP PartitionsQ ParzenWindow PascalDistribution PassEventsDown PassEventsUp Paste PasteBoxFormInlineCells PasteButton Path PathGraph PathGraphQ Pattern PatternSequence PatternTest PauliMatrix PaulWavelet Pause PausedTime PDF PearsonChiSquareTest PearsonCorrelationTest PearsonDistribution PerformanceGoal PeriodicInterpolation Periodogram PeriodogramArray PermutationCycles PermutationCyclesQ PermutationGroup PermutationLength PermutationList PermutationListQ PermutationMax PermutationMin PermutationOrder PermutationPower PermutationProduct PermutationReplace Permutations PermutationSupport Permute PeronaMalikFilter Perpendicular PERTDistribution PetersenGraph PhaseMargins Pi Pick PIDData PIDDerivativeFilter PIDFeedforward PIDTune Piecewise PiecewiseExpand PieChart PieChart3D PillaiTrace PillaiTraceTest Pink Pivoting PixelConstrained PixelValue PixelValuePositions Placed Placeholder PlaceholderReplace Plain PlanarGraphQ Play PlayRange Plot Plot3D Plot3Matrix PlotDivision PlotJoined PlotLabel PlotLayout PlotLegends PlotMarkers PlotPoints PlotRange PlotRangeClipping PlotRangePadding PlotRegion PlotStyle Plus PlusMinus Pochhammer PodStates PodWidth Point Point3DBox PointBox PointFigureChart PointForm PointLegend PointSize PoissonConsulDistribution PoissonDistribution PoissonProcess PoissonWindow PolarAxes PolarAxesOrigin PolarGridLines PolarPlot PolarTicks PoleZeroMarkers PolyaAeppliDistribution PolyGamma Polygon Polygon3DBox Polygon3DBoxOptions PolygonBox PolygonBoxOptions PolygonHoleScale PolygonIntersections PolygonScale PolyhedronData PolyLog PolynomialExtendedGCD PolynomialForm PolynomialGCD PolynomialLCM PolynomialMod PolynomialQ PolynomialQuotient PolynomialQuotientRemainder PolynomialReduce PolynomialRemainder Polynomials PopupMenu PopupMenuBox PopupMenuBoxOptions PopupView PopupWindow Position Positive PositiveDefiniteMatrixQ PossibleZeroQ Postfix PostScript Power PowerDistribution PowerExpand PowerMod PowerModList ' +
	      'PowerSpectralDensity PowersRepresentations PowerSymmetricPolynomial Precedence PrecedenceForm Precedes PrecedesEqual PrecedesSlantEqual PrecedesTilde Precision PrecisionGoal PreDecrement PredictionRoot PreemptProtect PreferencesPath Prefix PreIncrement Prepend PrependTo PreserveImageOptions Previous PriceGraphDistribution PrimaryPlaceholder Prime PrimeNu PrimeOmega PrimePi PrimePowerQ PrimeQ Primes PrimeZetaP PrimitiveRoot PrincipalComponents PrincipalValue Print PrintAction PrintForm PrintingCopies PrintingOptions PrintingPageRange PrintingStartingPageNumber PrintingStyleEnvironment PrintPrecision PrintTemporary Prism PrismBox PrismBoxOptions PrivateCellOptions PrivateEvaluationOptions PrivateFontOptions PrivateFrontEndOptions PrivateNotebookOptions PrivatePaths Probability ProbabilityDistribution ProbabilityPlot ProbabilityPr ProbabilityScalePlot ProbitModelFit ProcessEstimator ProcessParameterAssumptions ProcessParameterQ ProcessStateDomain ProcessTimeDomain Product ProductDistribution ProductLog ProgressIndicator ProgressIndicatorBox ProgressIndicatorBoxOptions Projection Prolog PromptForm Properties Property PropertyList PropertyValue Proportion Proportional Protect Protected ProteinData Pruning PseudoInverse Purple Put PutAppend Pyramid PyramidBox PyramidBoxOptions ' +
	      'QBinomial QFactorial QGamma QHypergeometricPFQ QPochhammer QPolyGamma QRDecomposition QuadraticIrrationalQ Quantile QuantilePlot Quantity QuantityForm QuantityMagnitude QuantityQ QuantityUnit Quartics QuartileDeviation Quartiles QuartileSkewness QueueingNetworkProcess QueueingProcess QueueProperties Quiet Quit Quotient QuotientRemainder ' +
	      'RadialityCentrality RadicalBox RadicalBoxOptions RadioButton RadioButtonBar RadioButtonBox RadioButtonBoxOptions Radon RamanujanTau RamanujanTauL RamanujanTauTheta RamanujanTauZ Random RandomChoice RandomComplex RandomFunction RandomGraph RandomImage RandomInteger RandomPermutation RandomPrime RandomReal RandomSample RandomSeed RandomVariate RandomWalkProcess Range RangeFilter RangeSpecification RankedMax RankedMin Raster Raster3D Raster3DBox Raster3DBoxOptions RasterArray RasterBox RasterBoxOptions Rasterize RasterSize Rational RationalFunctions Rationalize Rationals Ratios Raw RawArray RawBoxes RawData RawMedium RayleighDistribution Re Read ReadList ReadProtected Real RealBlockDiagonalForm RealDigits RealExponent Reals Reap Record RecordLists RecordSeparators Rectangle RectangleBox RectangleBoxOptions RectangleChart RectangleChart3D RecurrenceFilter RecurrenceTable RecurringDigitsForm Red Reduce RefBox ReferenceLineStyle ReferenceMarkers ReferenceMarkerStyle Refine ReflectionMatrix ReflectionTransform Refresh RefreshRate RegionBinarize RegionFunction RegionPlot RegionPlot3D RegularExpression Regularization Reinstall Release ReleaseHold ReliabilityDistribution ReliefImage ReliefPlot Remove RemoveAlphaChannel RemoveAsynchronousTask Removed RemoveInputStreamMethod RemoveOutputStreamMethod RemoveProperty RemoveScheduledTask RenameDirectory RenameFile RenderAll RenderingOptions RenewalProcess RenkoChart Repeated RepeatedNull RepeatedString Replace ReplaceAll ReplaceHeldPart ReplaceImageValue ReplaceList ReplacePart ReplacePixelValue ReplaceRepeated Resampling Rescale RescalingTransform ResetDirectory ResetMenusPacket ResetScheduledTask Residue Resolve Rest Resultant ResumePacket Return ReturnExpressionPacket ReturnInputFormPacket ReturnPacket ReturnTextPacket Reverse ReverseBiorthogonalSplineWavelet ReverseElement ReverseEquilibrium ReverseGraph ReverseUpEquilibrium RevolutionAxis RevolutionPlot3D RGBColor RiccatiSolve RiceDistribution RidgeFilter RiemannR RiemannSiegelTheta RiemannSiegelZ Riffle Right RightArrow RightArrowBar RightArrowLeftArrow RightCosetRepresentative RightDownTeeVector RightDownVector RightDownVectorBar RightTee RightTeeArrow RightTeeVector RightTriangle RightTriangleBar RightTriangleEqual RightUpDownVector RightUpTeeVector RightUpVector RightUpVectorBar RightVector RightVectorBar RiskAchievementImportance RiskReductionImportance RogersTanimotoDissimilarity Root RootApproximant RootIntervals RootLocusPlot RootMeanSquare RootOfUnityQ RootReduce Roots RootSum Rotate RotateLabel RotateLeft RotateRight RotationAction RotationBox RotationBoxOptions RotationMatrix RotationTransform Round RoundImplies RoundingRadius Row RowAlignments RowBackgrounds RowBox RowHeights RowLines RowMinHeight RowReduce RowsEqual RowSpacings RSolve RudvalisGroupRu Rule RuleCondition RuleDelayed RuleForm RulerUnits Run RunScheduledTask RunThrough RuntimeAttributes RuntimeOptions RussellRaoDissimilarity ' +
	      'SameQ SameTest SampleDepth SampledSoundFunction SampledSoundList SampleRate SamplingPeriod SARIMAProcess SARMAProcess SatisfiabilityCount SatisfiabilityInstances SatisfiableQ Saturday Save Saveable SaveAutoDelete SaveDefinitions SawtoothWave Scale Scaled ScaleDivisions ScaledMousePosition ScaleOrigin ScalePadding ScaleRanges ScaleRangeStyle ScalingFunctions ScalingMatrix ScalingTransform Scan ScheduledTaskActiveQ ScheduledTaskData ScheduledTaskObject ScheduledTasks SchurDecomposition ScientificForm ScreenRectangle ScreenStyleEnvironment ScriptBaselineShifts ScriptLevel ScriptMinSize ScriptRules ScriptSizeMultipliers Scrollbars ScrollingOptions ScrollPosition Sec Sech SechDistribution SectionGrouping SectorChart SectorChart3D SectorOrigin SectorSpacing SeedRandom Select Selectable SelectComponents SelectedCells SelectedNotebook Selection SelectionAnimate SelectionCell SelectionCellCreateCell SelectionCellDefaultStyle SelectionCellParentStyle SelectionCreateCell SelectionDebuggerTag SelectionDuplicateCell SelectionEvaluate SelectionEvaluateCreateCell SelectionMove SelectionPlaceholder SelectionSetStyle SelectWithContents SelfLoops SelfLoopStyle SemialgebraicComponentInstances SendMail Sequence SequenceAlignment SequenceForm SequenceHold SequenceLimit Series SeriesCoefficient SeriesData SessionTime Set SetAccuracy SetAlphaChannel SetAttributes Setbacks SetBoxFormNamesPacket SetDelayed SetDirectory SetEnvironment SetEvaluationNotebook SetFileDate SetFileLoadingContext SetNotebookStatusLine SetOptions SetOptionsPacket SetPrecision SetProperty SetSelectedNotebook SetSharedFunction SetSharedVariable SetSpeechParametersPacket SetStreamPosition SetSystemOptions Setter SetterBar SetterBox SetterBoxOptions Setting SetValue Shading Shallow ShannonWavelet ShapiroWilkTest Share Sharpen ShearingMatrix ShearingTransform ShenCastanMatrix Short ShortDownArrow Shortest ShortestMatch ShortestPathFunction ShortLeftArrow ShortRightArrow ShortUpArrow Show ShowAutoStyles ShowCellBracket ShowCellLabel ShowCellTags ShowClosedCellArea ShowContents ShowControls ShowCursorTracker ShowGroupOpenCloseIcon ShowGroupOpener ShowInvisibleCharacters ShowPageBreaks ShowPredictiveInterface ShowSelection ShowShortBoxForm ShowSpecialCharacters ShowStringCharacters ShowSyntaxStyles ShrinkingDelay ShrinkWrapBoundingBox SiegelTheta SiegelTukeyTest Sign Signature SignedRankTest SignificanceLevel SignPadding SignTest SimilarityRules SimpleGraph SimpleGraphQ Simplify Sin Sinc SinghMaddalaDistribution SingleEvaluation SingleLetterItalics SingleLetterStyle SingularValueDecomposition SingularValueList SingularValuePlot SingularValues Sinh SinhIntegral SinIntegral SixJSymbol Skeleton SkeletonTransform SkellamDistribution Skewness SkewNormalDistribution Skip SliceDistribution Slider Slider2D Slider2DBox Slider2DBoxOptions SliderBox SliderBoxOptions SlideView Slot SlotSequence Small SmallCircle Smaller SmithDelayCompensator SmithWatermanSimilarity ' +
	      'SmoothDensityHistogram SmoothHistogram SmoothHistogram3D SmoothKernelDistribution SocialMediaData Socket SokalSneathDissimilarity Solve SolveAlways SolveDelayed Sort SortBy Sound SoundAndGraphics SoundNote SoundVolume Sow Space SpaceForm Spacer Spacings Span SpanAdjustments SpanCharacterRounding SpanFromAbove SpanFromBoth SpanFromLeft SpanLineThickness SpanMaxSize SpanMinSize SpanningCharacters SpanSymmetric SparseArray SpatialGraphDistribution Speak SpeakTextPacket SpearmanRankTest SpearmanRho Spectrogram SpectrogramArray Specularity SpellingCorrection SpellingDictionaries SpellingDictionariesPath SpellingOptions SpellingSuggestionsPacket Sphere SphereBox SphericalBesselJ SphericalBesselY SphericalHankelH1 SphericalHankelH2 SphericalHarmonicY SphericalPlot3D SphericalRegion SpheroidalEigenvalue SpheroidalJoiningFactor SpheroidalPS SpheroidalPSPrime SpheroidalQS SpheroidalQSPrime SpheroidalRadialFactor SpheroidalS1 SpheroidalS1Prime SpheroidalS2 SpheroidalS2Prime Splice SplicedDistribution SplineClosed SplineDegree SplineKnots SplineWeights Split SplitBy SpokenString Sqrt SqrtBox SqrtBoxOptions Square SquaredEuclideanDistance SquareFreeQ SquareIntersection SquaresR SquareSubset SquareSubsetEqual SquareSuperset SquareSupersetEqual SquareUnion SquareWave StabilityMargins StabilityMarginsStyle StableDistribution Stack StackBegin StackComplete StackInhibit StandardDeviation StandardDeviationFilter StandardForm Standardize StandbyDistribution Star StarGraph StartAsynchronousTask StartingStepSize StartOfLine StartOfString StartScheduledTask StartupSound StateDimensions StateFeedbackGains StateOutputEstimator StateResponse StateSpaceModel StateSpaceRealization StateSpaceTransform StationaryDistribution StationaryWaveletPacketTransform StationaryWaveletTransform StatusArea StatusCentrality StepMonitor StieltjesGamma StirlingS1 StirlingS2 StopAsynchronousTask StopScheduledTask StrataVariables StratonovichProcess StreamColorFunction StreamColorFunctionScaling StreamDensityPlot StreamPlot StreamPoints StreamPosition Streams StreamScale StreamStyle String StringBreak StringByteCount StringCases StringCount StringDrop StringExpression StringForm StringFormat StringFreeQ StringInsert StringJoin StringLength StringMatchQ StringPosition StringQ StringReplace StringReplaceList StringReplacePart StringReverse StringRotateLeft StringRotateRight StringSkeleton StringSplit StringTake StringToStream StringTrim StripBoxes StripOnInput StripWrapperBoxes StrokeForm StructuralImportance StructuredArray StructuredSelection StruveH StruveL Stub StudentTDistribution Style StyleBox StyleBoxAutoDelete StyleBoxOptions StyleData StyleDefinitions StyleForm StyleKeyMapping StyleMenuListing StyleNameDialogSettings StyleNames StylePrint StyleSheetPath Subfactorial Subgraph SubMinus SubPlus SubresultantPolynomialRemainders ' +
	      'SubresultantPolynomials Subresultants Subscript SubscriptBox SubscriptBoxOptions Subscripted Subset SubsetEqual Subsets SubStar Subsuperscript SubsuperscriptBox SubsuperscriptBoxOptions Subtract SubtractFrom SubValues Succeeds SucceedsEqual SucceedsSlantEqual SucceedsTilde SuchThat Sum SumConvergence Sunday SuperDagger SuperMinus SuperPlus Superscript SuperscriptBox SuperscriptBoxOptions Superset SupersetEqual SuperStar Surd SurdForm SurfaceColor SurfaceGraphics SurvivalDistribution SurvivalFunction SurvivalModel SurvivalModelFit SuspendPacket SuzukiDistribution SuzukiGroupSuz SwatchLegend Switch Symbol SymbolName SymletWavelet Symmetric SymmetricGroup SymmetricMatrixQ SymmetricPolynomial SymmetricReduction Symmetrize SymmetrizedArray SymmetrizedArrayRules SymmetrizedDependentComponents SymmetrizedIndependentComponents SymmetrizedReplacePart SynchronousInitialization SynchronousUpdating Syntax SyntaxForm SyntaxInformation SyntaxLength SyntaxPacket SyntaxQ SystemDialogInput SystemException SystemHelpPath SystemInformation SystemInformationData SystemOpen SystemOptions SystemsModelDelay SystemsModelDelayApproximate SystemsModelDelete SystemsModelDimensions SystemsModelExtract SystemsModelFeedbackConnect SystemsModelLabels SystemsModelOrder SystemsModelParallelConnect SystemsModelSeriesConnect SystemsModelStateFeedbackConnect SystemStub ' +
	      'Tab TabFilling Table TableAlignments TableDepth TableDirections TableForm TableHeadings TableSpacing TableView TableViewBox TabSpacings TabView TabViewBox TabViewBoxOptions TagBox TagBoxNote TagBoxOptions TaggingRules TagSet TagSetDelayed TagStyle TagUnset Take TakeWhile Tally Tan Tanh TargetFunctions TargetUnits TautologyQ TelegraphProcess TemplateBox TemplateBoxOptions TemplateSlotSequence TemporalData Temporary TemporaryVariable TensorContract TensorDimensions TensorExpand TensorProduct TensorQ TensorRank TensorReduce TensorSymmetry TensorTranspose TensorWedge Tetrahedron TetrahedronBox TetrahedronBoxOptions TeXForm TeXSave Text Text3DBox Text3DBoxOptions TextAlignment TextBand TextBoundingBox TextBox TextCell TextClipboardType TextData TextForm TextJustification TextLine TextPacket TextParagraph TextRecognize TextRendering TextStyle Texture TextureCoordinateFunction TextureCoordinateScaling Therefore ThermometerGauge Thick Thickness Thin Thinning ThisLink ThompsonGroupTh Thread ThreeJSymbol Threshold Through Throw Thumbnail Thursday Ticks TicksStyle Tilde TildeEqual TildeFullEqual TildeTilde TimeConstrained TimeConstraint Times TimesBy TimeSeriesForecast TimeSeriesInvertibility TimeUsed TimeValue TimeZone Timing Tiny TitleGrouping TitsGroupT ToBoxes ToCharacterCode ToColor ToContinuousTimeModel ToDate ToDiscreteTimeModel ToeplitzMatrix ToExpression ToFileName Together Toggle ToggleFalse Toggler TogglerBar TogglerBox TogglerBoxOptions ToHeldExpression ToInvertibleTimeSeries TokenWords Tolerance ToLowerCase ToNumberField TooBig Tooltip TooltipBox TooltipBoxOptions TooltipDelay TooltipStyle Top TopHatTransform TopologicalSort ToRadicals ToRules ToString Total TotalHeight TotalVariationFilter TotalWidth TouchscreenAutoZoom TouchscreenControlPlacement ToUpperCase Tr Trace TraceAbove TraceAction TraceBackward TraceDepth TraceDialog TraceForward TraceInternal TraceLevel TraceOff TraceOn TraceOriginal TracePrint TraceScan TrackedSymbols TradingChart TraditionalForm TraditionalFunctionNotation TraditionalNotation TraditionalOrder TransferFunctionCancel TransferFunctionExpand TransferFunctionFactor TransferFunctionModel TransferFunctionPoles TransferFunctionTransform TransferFunctionZeros TransformationFunction TransformationFunctions TransformationMatrix TransformedDistribution TransformedField Translate TranslationTransform TransparentColor Transpose TreeForm TreeGraph TreeGraphQ TreePlot TrendStyle TriangleWave TriangularDistribution Trig TrigExpand TrigFactor TrigFactorList Trigger TrigReduce TrigToExp TrimmedMean True TrueQ TruncatedDistribution TsallisQExponentialDistribution TsallisQGaussianDistribution TTest Tube TubeBezierCurveBox TubeBezierCurveBoxOptions TubeBox TubeBSplineCurveBox TubeBSplineCurveBoxOptions Tuesday TukeyLambdaDistribution TukeyWindow Tuples TuranGraph TuringMachine ' +
	      'Transparent ' +
	      'UnateQ Uncompress Undefined UnderBar Underflow Underlined Underoverscript UnderoverscriptBox UnderoverscriptBoxOptions Underscript UnderscriptBox UnderscriptBoxOptions UndirectedEdge UndirectedGraph UndirectedGraphQ UndocumentedTestFEParserPacket UndocumentedTestGetSelectionPacket Unequal Unevaluated UniformDistribution UniformGraphDistribution UniformSumDistribution Uninstall Union UnionPlus Unique UnitBox UnitConvert UnitDimensions Unitize UnitRootTest UnitSimplify UnitStep UnitTriangle UnitVector Unprotect UnsameQ UnsavedVariables Unset UnsetShared UntrackedVariables Up UpArrow UpArrowBar UpArrowDownArrow Update UpdateDynamicObjects UpdateDynamicObjectsSynchronous UpdateInterval UpDownArrow UpEquilibrium UpperCaseQ UpperLeftArrow UpperRightArrow UpperTriangularize Upsample UpSet UpSetDelayed UpTee UpTeeArrow UpValues URL URLFetch URLFetchAsynchronous URLSave URLSaveAsynchronous UseGraphicsRange Using UsingFrontEnd ' +
	      'V2Get ValidationLength Value ValueBox ValueBoxOptions ValueForm ValueQ ValuesData Variables Variance VarianceEquivalenceTest VarianceEstimatorFunction VarianceGammaDistribution VarianceTest VectorAngle VectorColorFunction VectorColorFunctionScaling VectorDensityPlot VectorGlyphData VectorPlot VectorPlot3D VectorPoints VectorQ Vectors VectorScale VectorStyle Vee Verbatim Verbose VerboseConvertToPostScriptPacket VerifyConvergence VerifySolutions VerifyTestAssumptions Version VersionNumber VertexAdd VertexCapacity VertexColors VertexComponent VertexConnectivity VertexCoordinateRules VertexCoordinates VertexCorrelationSimilarity VertexCosineSimilarity VertexCount VertexCoverQ VertexDataCoordinates VertexDegree VertexDelete VertexDiceSimilarity VertexEccentricity VertexInComponent VertexInDegree VertexIndex VertexJaccardSimilarity VertexLabeling VertexLabels VertexLabelStyle VertexList VertexNormals VertexOutComponent VertexOutDegree VertexQ VertexRenderingFunction VertexReplace VertexShape VertexShapeFunction VertexSize VertexStyle VertexTextureCoordinates VertexWeight Vertical VerticalBar VerticalForm VerticalGauge VerticalSeparator VerticalSlider VerticalTilde ViewAngle ViewCenter ViewMatrix ViewPoint ViewPointSelectorSettings ViewPort ViewRange ViewVector ViewVertical VirtualGroupData Visible VisibleCell VoigtDistribution VonMisesDistribution ' +
	      'WaitAll WaitAsynchronousTask WaitNext WaitUntil WakebyDistribution WalleniusHypergeometricDistribution WaringYuleDistribution WatershedComponents WatsonUSquareTest WattsStrogatzGraphDistribution WaveletBestBasis WaveletFilterCoefficients WaveletImagePlot WaveletListPlot WaveletMapIndexed WaveletMatrixPlot WaveletPhi WaveletPsi WaveletScale WaveletScalogram WaveletThreshold WeaklyConnectedComponents WeaklyConnectedGraphQ WeakStationarity WeatherData WeberE Wedge Wednesday WeibullDistribution WeierstrassHalfPeriods WeierstrassInvariants WeierstrassP WeierstrassPPrime WeierstrassSigma WeierstrassZeta WeightedAdjacencyGraph WeightedAdjacencyMatrix WeightedData WeightedGraphQ Weights WelchWindow WheelGraph WhenEvent Which While White Whitespace WhitespaceCharacter WhittakerM WhittakerW WienerFilter WienerProcess WignerD WignerSemicircleDistribution WilksW WilksWTest WindowClickSelect WindowElements WindowFloating WindowFrame WindowFrameElements WindowMargins WindowMovable WindowOpacity WindowSelected WindowSize WindowStatusArea WindowTitle WindowToolbars WindowWidth With WolframAlpha WolframAlphaDate WolframAlphaQuantity WolframAlphaResult Word WordBoundary WordCharacter WordData WordSearch WordSeparators WorkingPrecision Write WriteString Wronskian ' +
	      'XMLElement XMLObject Xnor Xor ' +
	      'Yellow YuleDissimilarity ' +
	      'ZernikeR ZeroSymmetric ZeroTest ZeroWidthTimes Zeta ZetaZero ZipfDistribution ZTest ZTransform ' +
	      '$Aborted $ActivationGroupID $ActivationKey $ActivationUserRegistered $AddOnsDirectory $AssertFunction $Assumptions $AsynchronousTask $BaseDirectory $BatchInput $BatchOutput $BoxForms $ByteOrdering $Canceled $CharacterEncoding $CharacterEncodings $CommandLine $CompilationTarget $ConditionHold $ConfiguredKernels $Context $ContextPath $ControlActiveSetting $CreationDate $CurrentLink $DateStringFormat $DefaultFont $DefaultFrontEnd $DefaultImagingDevice $DefaultPath $Display $DisplayFunction $DistributedContexts $DynamicEvaluation $Echo $Epilog $ExportFormats $Failed $FinancialDataSource $FormatType $FrontEnd $FrontEndSession $GeoLocation $HistoryLength $HomeDirectory $HTTPCookies $IgnoreEOF $ImagingDevices $ImportFormats $InitialDirectory $Input $InputFileName $InputStreamMethods $Inspector $InstallationDate $InstallationDirectory $InterfaceEnvironment $IterationLimit $KernelCount $KernelID $Language $LaunchDirectory $LibraryPath $LicenseExpirationDate $LicenseID $LicenseProcesses $LicenseServer $LicenseSubprocesses $LicenseType $Line $Linked $LinkSupported $LoadedFiles $MachineAddresses $MachineDomain $MachineDomains $MachineEpsilon $MachineID $MachineName $MachinePrecision $MachineType $MaxExtraPrecision $MaxLicenseProcesses $MaxLicenseSubprocesses $MaxMachineNumber $MaxNumber $MaxPiecewiseCases $MaxPrecision $MaxRootDegree $MessageGroups $MessageList $MessagePrePrint $Messages $MinMachineNumber $MinNumber $MinorReleaseNumber $MinPrecision $ModuleNumber $NetworkLicense $NewMessage $NewSymbol $Notebooks $NumberMarks $Off $OperatingSystem $Output $OutputForms $OutputSizeLimit $OutputStreamMethods $Packages $ParentLink $ParentProcessID $PasswordFile $PatchLevelID $Path $PathnameSeparator $PerformanceGoal $PipeSupported $Post $Pre $PreferencesDirectory $PrePrint $PreRead $PrintForms $PrintLiteral $ProcessID $ProcessorCount $ProcessorType $ProductInformation $ProgramName $RandomState $RecursionLimit $ReleaseNumber $RootDirectory $ScheduledTask $ScriptCommandLine $SessionID $SetParentLink $SharedFunctions $SharedVariables $SoundDisplay $SoundDisplayFunction $SuppressInputFormHeads $SynchronousEvaluation $SyntaxHandler $System $SystemCharacterEncoding $SystemID $SystemWordLength $TemporaryDirectory $TemporaryPrefix $TextStyle $TimedOut $TimeUnit $TimeZone $TopDirectory $TraceOff $TraceOn $TracePattern $TracePostAction $TracePreAction $Urgent $UserAddOnsDirectory $UserBaseDirectory $UserDocumentsDirectory $UserName $Version $VersionNumber',
	    contains: [
	      {
	        className: 'comment',
	        begin: /\(\*/, end: /\*\)/
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        begin: /\{/, end: /\}/,
	        illegal: /:/
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/matlab.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var COMMON_CONTAINS = [
	    hljs.C_NUMBER_MODE,
	    {
	      className: 'string',
	      begin: '\'', end: '\'',
	      contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
	    }
	  ];
	  var TRANSPOSE = {
	    relevance: 0,
	    contains: [
	      {
	        begin: /'['\.]*/
	      }
	    ]
	  };
	
	  return {
	    keywords: {
	      keyword:
	        'break case catch classdef continue else elseif end enumerated events for function ' +
	        'global if methods otherwise parfor persistent properties return spmd switch try while',
	      built_in:
	        'sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan ' +
	        'atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot ' +
	        'cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog ' +
	        'realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal ' +
	        'cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli ' +
	        'besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma ' +
	        'gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms ' +
	        'nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones ' +
	        'eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ' +
	        'ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril ' +
	        'triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute ' +
	        'shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i inf nan ' +
	        'isnan isinf isfinite j why compan gallery hadamard hankel hilb invhilb magic pascal ' +
	        'rosser toeplitz vander wilkinson'
	    },
	    illegal: '(//|"|#|/\\*|\\s+/\\w+)',
	    contains: [
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '$',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            className: 'params',
	            variants: [
	              {begin: '\\(', end: '\\)'},
	              {begin: '\\[', end: '\\]'}
	            ]
	          }
	        ]
	      },
	      {
	        begin: /[a-zA-Z_][a-zA-Z_0-9]*'['\.]*/,
	        returnBegin: true,
	        relevance: 0,
	        contains: [
	          {begin: /[a-zA-Z_][a-zA-Z_0-9]*/, relevance: 0},
	          TRANSPOSE.contains[0]
	        ]
	      },
	      {
	        begin: '\\[', end: '\\]',
	        contains: COMMON_CONTAINS,
	        relevance: 0,
	        starts: TRANSPOSE
	      },
	      {
	        begin: '\\{', end: /}/,
	        contains: COMMON_CONTAINS,
	        relevance: 0,
	        starts: TRANSPOSE
	      },
	      {
	        // transpose operators at the end of a function call
	        begin: /\)/,
	        relevance: 0,
	        starts: TRANSPOSE
	      },
	      hljs.COMMENT('^\\s*\\%\\{\\s*$', '^\\s*\\%\\}\\s*$'),
	      hljs.COMMENT('\\%', '$')
	    ].concat(COMMON_CONTAINS)
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/maxima.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = 'if then else elseif for thru do while unless step in and or not';
	  var LITERALS = 'true false unknown inf minf ind und %e %i %pi %phi %gamma';
	  var BUILTIN_FUNCTIONS =
	        ' abasep abs absint absolute_real_time acos acosh acot acoth acsc acsch activate'
	      + ' addcol add_edge add_edges addmatrices addrow add_vertex add_vertices adjacency_matrix'
	      + ' adjoin adjoint af agd airy airy_ai airy_bi airy_dai airy_dbi algsys alg_type'
	      + ' alias allroots alphacharp alphanumericp amortization %and annuity_fv'
	      + ' annuity_pv antid antidiff AntiDifference append appendfile apply apply1 apply2'
	      + ' applyb1 apropos args arit_amortization arithmetic arithsum array arrayapply'
	      + ' arrayinfo arraymake arraysetapply ascii asec asech asin asinh askinteger'
	      + ' asksign assoc assoc_legendre_p assoc_legendre_q assume assume_external_byte_order'
	      + ' asympa at atan atan2 atanh atensimp atom atvalue augcoefmatrix augmented_lagrangian_method'
	      + ' av average_degree backtrace bars barsplot barsplot_description base64 base64_decode'
	      + ' bashindices batch batchload bc2 bdvac belln benefit_cost bern bernpoly bernstein_approx'
	      + ' bernstein_expand bernstein_poly bessel bessel_i bessel_j bessel_k bessel_simplify'
	      + ' bessel_y beta beta_incomplete beta_incomplete_generalized beta_incomplete_regularized'
	      + ' bezout bfallroots bffac bf_find_root bf_fmin_cobyla bfhzeta bfloat bfloatp'
	      + ' bfpsi bfpsi0 bfzeta biconnected_components bimetric binomial bipartition'
	      + ' block blockmatrixp bode_gain bode_phase bothcoef box boxplot boxplot_description'
	      + ' break bug_report build_info|10 buildq build_sample burn cabs canform canten'
	      + ' cardinality carg cartan cartesian_product catch cauchy_matrix cbffac cdf_bernoulli'
	      + ' cdf_beta cdf_binomial cdf_cauchy cdf_chi2 cdf_continuous_uniform cdf_discrete_uniform'
	      + ' cdf_exp cdf_f cdf_gamma cdf_general_finite_discrete cdf_geometric cdf_gumbel'
	      + ' cdf_hypergeometric cdf_laplace cdf_logistic cdf_lognormal cdf_negative_binomial'
	      + ' cdf_noncentral_chi2 cdf_noncentral_student_t cdf_normal cdf_pareto cdf_poisson'
	      + ' cdf_rank_sum cdf_rayleigh cdf_signed_rank cdf_student_t cdf_weibull cdisplay'
	      + ' ceiling central_moment cequal cequalignore cf cfdisrep cfexpand cgeodesic'
	      + ' cgreaterp cgreaterpignore changename changevar chaosgame charat charfun charfun2'
	      + ' charlist charp charpoly chdir chebyshev_t chebyshev_u checkdiv check_overlaps'
	      + ' chinese cholesky christof chromatic_index chromatic_number cint circulant_graph'
	      + ' clear_edge_weight clear_rules clear_vertex_label clebsch_gordan clebsch_graph'
	      + ' clessp clesspignore close closefile cmetric coeff coefmatrix cograd col collapse'
	      + ' collectterms columnop columnspace columnswap columnvector combination combine'
	      + ' comp2pui compare compfile compile compile_file complement_graph complete_bipartite_graph'
	      + ' complete_graph complex_number_p components compose_functions concan concat'
	      + ' conjugate conmetderiv connected_components connect_vertices cons constant'
	      + ' constantp constituent constvalue cont2part content continuous_freq contortion'
	      + ' contour_plot contract contract_edge contragrad contrib_ode convert coord'
	      + ' copy copy_file copy_graph copylist copymatrix cor cos cosh cot coth cov cov1'
	      + ' covdiff covect covers crc24sum create_graph create_list csc csch csetup cspline'
	      + ' ctaylor ct_coordsys ctransform ctranspose cube_graph cuboctahedron_graph'
	      + ' cunlisp cv cycle_digraph cycle_graph cylindrical days360 dblint deactivate'
	      + ' declare declare_constvalue declare_dimensions declare_fundamental_dimensions'
	      + ' declare_fundamental_units declare_qty declare_translated declare_unit_conversion'
	      + ' declare_units declare_weights decsym defcon define define_alt_display define_variable'
	      + ' defint defmatch defrule defstruct deftaylor degree_sequence del delete deleten'
	      + ' delta demo demoivre denom depends derivdegree derivlist describe desolve'
	      + ' determinant dfloat dgauss_a dgauss_b dgeev dgemm dgeqrf dgesv dgesvd diag'
	      + ' diagmatrix diag_matrix diagmatrixp diameter diff digitcharp dimacs_export'
	      + ' dimacs_import dimension dimensionless dimensions dimensions_as_list direct'
	      + ' directory discrete_freq disjoin disjointp disolate disp dispcon dispform'
	      + ' dispfun dispJordan display disprule dispterms distrib divide divisors divsum'
	      + ' dkummer_m dkummer_u dlange dodecahedron_graph dotproduct dotsimp dpart'
	      + ' draw draw2d draw3d drawdf draw_file draw_graph dscalar echelon edge_coloring'
	      + ' edge_connectivity edges eigens_by_jacobi eigenvalues eigenvectors eighth'
	      + ' einstein eivals eivects elapsed_real_time elapsed_run_time ele2comp ele2polynome'
	      + ' ele2pui elem elementp elevation_grid elim elim_allbut eliminate eliminate_using'
	      + ' ellipse elliptic_e elliptic_ec elliptic_eu elliptic_f elliptic_kc elliptic_pi'
	      + ' ematrix empty_graph emptyp endcons entermatrix entertensor entier equal equalp'
	      + ' equiv_classes erf erfc erf_generalized erfi errcatch error errormsg errors'
	      + ' euler ev eval_string evenp every evolution evolution2d evundiff example exp'
	      + ' expand expandwrt expandwrt_factored expint expintegral_chi expintegral_ci'
	      + ' expintegral_e expintegral_e1 expintegral_ei expintegral_e_simplify expintegral_li'
	      + ' expintegral_shi expintegral_si explicit explose exponentialize express expt'
	      + ' exsec extdiff extract_linear_equations extremal_subset ezgcd %f f90 facsum'
	      + ' factcomb factor factorfacsum factorial factorout factorsum facts fast_central_elements'
	      + ' fast_linsolve fasttimes featurep fernfale fft fib fibtophi fifth filename_merge'
	      + ' file_search file_type fillarray findde find_root find_root_abs find_root_error'
	      + ' find_root_rel first fix flatten flength float floatnump floor flower_snark'
	      + ' flush flush1deriv flushd flushnd flush_output fmin_cobyla forget fortran'
	      + ' fourcos fourexpand fourier fourier_elim fourint fourintcos fourintsin foursimp'
	      + ' foursin fourth fposition frame_bracket freeof freshline fresnel_c fresnel_s'
	      + ' from_adjacency_matrix frucht_graph full_listify fullmap fullmapl fullratsimp'
	      + ' fullratsubst fullsetify funcsolve fundamental_dimensions fundamental_units'
	      + ' fundef funmake funp fv g0 g1 gamma gamma_greek gamma_incomplete gamma_incomplete_generalized'
	      + ' gamma_incomplete_regularized gauss gauss_a gauss_b gaussprob gcd gcdex gcdivide'
	      + ' gcfac gcfactor gd generalized_lambert_w genfact gen_laguerre genmatrix gensym'
	      + ' geo_amortization geo_annuity_fv geo_annuity_pv geomap geometric geometric_mean'
	      + ' geosum get getcurrentdirectory get_edge_weight getenv get_lu_factors get_output_stream_string'
	      + ' get_pixel get_plot_option get_tex_environment get_tex_environment_default'
	      + ' get_vertex_label gfactor gfactorsum ggf girth global_variances gn gnuplot_close'
	      + ' gnuplot_replot gnuplot_reset gnuplot_restart gnuplot_start go Gosper GosperSum'
	      + ' gr2d gr3d gradef gramschmidt graph6_decode graph6_encode graph6_export graph6_import'
	      + ' graph_center graph_charpoly graph_eigenvalues graph_flow graph_order graph_periphery'
	      + ' graph_product graph_size graph_union great_rhombicosidodecahedron_graph great_rhombicuboctahedron_graph'
	      + ' grid_graph grind grobner_basis grotzch_graph hamilton_cycle hamilton_path'
	      + ' hankel hankel_1 hankel_2 harmonic harmonic_mean hav heawood_graph hermite'
	      + ' hessian hgfred hilbertmap hilbert_matrix hipow histogram histogram_description'
	      + ' hodge horner hypergeometric i0 i1 %ibes ic1 ic2 ic_convert ichr1 ichr2 icosahedron_graph'
	      + ' icosidodecahedron_graph icurvature ident identfor identity idiff idim idummy'
	      + ' ieqn %if ifactors iframes ifs igcdex igeodesic_coords ilt image imagpart'
	      + ' imetric implicit implicit_derivative implicit_plot indexed_tensor indices'
	      + ' induced_subgraph inferencep inference_result infix info_display init_atensor'
	      + ' init_ctensor in_neighbors innerproduct inpart inprod inrt integerp integer_partitions'
	      + ' integrate intersect intersection intervalp intopois intosum invariant1 invariant2'
	      + ' inverse_fft inverse_jacobi_cd inverse_jacobi_cn inverse_jacobi_cs inverse_jacobi_dc'
	      + ' inverse_jacobi_dn inverse_jacobi_ds inverse_jacobi_nc inverse_jacobi_nd inverse_jacobi_ns'
	      + ' inverse_jacobi_sc inverse_jacobi_sd inverse_jacobi_sn invert invert_by_adjoint'
	      + ' invert_by_lu inv_mod irr is is_biconnected is_bipartite is_connected is_digraph'
	      + ' is_edge_in_graph is_graph is_graph_or_digraph ishow is_isomorphic isolate'
	      + ' isomorphism is_planar isqrt isreal_p is_sconnected is_tree is_vertex_in_graph'
	      + ' items_inference %j j0 j1 jacobi jacobian jacobi_cd jacobi_cn jacobi_cs jacobi_dc'
	      + ' jacobi_dn jacobi_ds jacobi_nc jacobi_nd jacobi_ns jacobi_p jacobi_sc jacobi_sd'
	      + ' jacobi_sn JF jn join jordan julia julia_set julia_sin %k kdels kdelta kill'
	      + ' killcontext kostka kron_delta kronecker_product kummer_m kummer_u kurtosis'
	      + ' kurtosis_bernoulli kurtosis_beta kurtosis_binomial kurtosis_chi2 kurtosis_continuous_uniform'
	      + ' kurtosis_discrete_uniform kurtosis_exp kurtosis_f kurtosis_gamma kurtosis_general_finite_discrete'
	      + ' kurtosis_geometric kurtosis_gumbel kurtosis_hypergeometric kurtosis_laplace'
	      + ' kurtosis_logistic kurtosis_lognormal kurtosis_negative_binomial kurtosis_noncentral_chi2'
	      + ' kurtosis_noncentral_student_t kurtosis_normal kurtosis_pareto kurtosis_poisson'
	      + ' kurtosis_rayleigh kurtosis_student_t kurtosis_weibull label labels lagrange'
	      + ' laguerre lambda lambert_w laplace laplacian_matrix last lbfgs lc2kdt lcharp'
	      + ' lc_l lcm lc_u ldefint ldisp ldisplay legendre_p legendre_q leinstein length'
	      + ' let letrules letsimp levi_civita lfreeof lgtreillis lhs li liediff limit'
	      + ' Lindstedt linear linearinterpol linear_program linear_regression line_graph'
	      + ' linsolve listarray list_correlations listify list_matrix_entries list_nc_monomials'
	      + ' listoftens listofvars listp lmax lmin load loadfile local locate_matrix_entry'
	      + ' log logcontract log_gamma lopow lorentz_gauge lowercasep lpart lratsubst'
	      + ' lreduce lriemann lsquares_estimates lsquares_estimates_approximate lsquares_estimates_exact'
	      + ' lsquares_mse lsquares_residual_mse lsquares_residuals lsum ltreillis lu_backsub'
	      + ' lucas lu_factor %m macroexpand macroexpand1 make_array makebox makefact makegamma'
	      + ' make_graph make_level_picture makelist makeOrders make_poly_continent make_poly_country'
	      + ' make_polygon make_random_state make_rgb_picture makeset make_string_input_stream'
	      + ' make_string_output_stream make_transform mandelbrot mandelbrot_set map mapatom'
	      + ' maplist matchdeclare matchfix mat_cond mat_fullunblocker mat_function mathml_display'
	      + ' mat_norm matrix matrixmap matrixp matrix_size mattrace mat_trace mat_unblocker'
	      + ' max max_clique max_degree max_flow maximize_lp max_independent_set max_matching'
	      + ' maybe md5sum mean mean_bernoulli mean_beta mean_binomial mean_chi2 mean_continuous_uniform'
	      + ' mean_deviation mean_discrete_uniform mean_exp mean_f mean_gamma mean_general_finite_discrete'
	      + ' mean_geometric mean_gumbel mean_hypergeometric mean_laplace mean_logistic'
	      + ' mean_lognormal mean_negative_binomial mean_noncentral_chi2 mean_noncentral_student_t'
	      + ' mean_normal mean_pareto mean_poisson mean_rayleigh mean_student_t mean_weibull'
	      + ' median median_deviation member mesh metricexpandall mgf1_sha1 min min_degree'
	      + ' min_edge_cut minfactorial minimalPoly minimize_lp minimum_spanning_tree minor'
	      + ' minpack_lsquares minpack_solve min_vertex_cover min_vertex_cut mkdir mnewton'
	      + ' mod mode_declare mode_identity ModeMatrix moebius mon2schur mono monomial_dimensions'
	      + ' multibernstein_poly multi_display_for_texinfo multi_elem multinomial multinomial_coeff'
	      + ' multi_orbit multiplot_mode multi_pui multsym multthru mycielski_graph nary'
	      + ' natural_unit nc_degree ncexpt ncharpoly negative_picture neighbors new newcontext'
	      + ' newdet new_graph newline newton new_variable next_prime nicedummies niceindices'
	      + ' ninth nofix nonarray noncentral_moment nonmetricity nonnegintegerp nonscalarp'
	      + ' nonzeroandfreeof notequal nounify nptetrad npv nroots nterms ntermst'
	      + ' nthroot nullity nullspace num numbered_boundaries numberp number_to_octets'
	      + ' num_distinct_partitions numerval numfactor num_partitions nusum nzeta nzetai'
	      + ' nzetar octets_to_number octets_to_oid odd_girth oddp ode2 ode_check odelin'
	      + ' oid_to_octets op opena opena_binary openr openr_binary openw openw_binary'
	      + ' operatorp opsubst optimize %or orbit orbits ordergreat ordergreatp orderless'
	      + ' orderlessp orthogonal_complement orthopoly_recur orthopoly_weight outermap'
	      + ' out_neighbors outofpois pade parabolic_cylinder_d parametric parametric_surface'
	      + ' parg parGosper parse_string parse_timedate part part2cont partfrac partition'
	      + ' partition_set partpol path_digraph path_graph pathname_directory pathname_name'
	      + ' pathname_type pdf_bernoulli pdf_beta pdf_binomial pdf_cauchy pdf_chi2 pdf_continuous_uniform'
	      + ' pdf_discrete_uniform pdf_exp pdf_f pdf_gamma pdf_general_finite_discrete'
	      + ' pdf_geometric pdf_gumbel pdf_hypergeometric pdf_laplace pdf_logistic pdf_lognormal'
	      + ' pdf_negative_binomial pdf_noncentral_chi2 pdf_noncentral_student_t pdf_normal'
	      + ' pdf_pareto pdf_poisson pdf_rank_sum pdf_rayleigh pdf_signed_rank pdf_student_t'
	      + ' pdf_weibull pearson_skewness permanent permut permutation permutations petersen_graph'
	      + ' petrov pickapart picture_equalp picturep piechart piechart_description planar_embedding'
	      + ' playback plog plot2d plot3d plotdf ploteq plsquares pochhammer points poisdiff'
	      + ' poisexpt poisint poismap poisplus poissimp poissubst poistimes poistrim polar'
	      + ' polarform polartorect polar_to_xy poly_add poly_buchberger poly_buchberger_criterion'
	      + ' poly_colon_ideal poly_content polydecomp poly_depends_p poly_elimination_ideal'
	      + ' poly_exact_divide poly_expand poly_expt poly_gcd polygon poly_grobner poly_grobner_equal'
	      + ' poly_grobner_member poly_grobner_subsetp poly_ideal_intersection poly_ideal_polysaturation'
	      + ' poly_ideal_polysaturation1 poly_ideal_saturation poly_ideal_saturation1 poly_lcm'
	      + ' poly_minimization polymod poly_multiply polynome2ele polynomialp poly_normal_form'
	      + ' poly_normalize poly_normalize_list poly_polysaturation_extension poly_primitive_part'
	      + ' poly_pseudo_divide poly_reduced_grobner poly_reduction poly_saturation_extension'
	      + ' poly_s_polynomial poly_subtract polytocompanion pop postfix potential power_mod'
	      + ' powerseries powerset prefix prev_prime primep primes principal_components'
	      + ' print printf printfile print_graph printpois printprops prodrac product properties'
	      + ' propvars psi psubst ptriangularize pui pui2comp pui2ele pui2polynome pui_direct'
	      + ' puireduc push put pv qput qrange qty quad_control quad_qag quad_qagi quad_qagp'
	      + ' quad_qags quad_qawc quad_qawf quad_qawo quad_qaws quadrilateral quantile'
	      + ' quantile_bernoulli quantile_beta quantile_binomial quantile_cauchy quantile_chi2'
	      + ' quantile_continuous_uniform quantile_discrete_uniform quantile_exp quantile_f'
	      + ' quantile_gamma quantile_general_finite_discrete quantile_geometric quantile_gumbel'
	      + ' quantile_hypergeometric quantile_laplace quantile_logistic quantile_lognormal'
	      + ' quantile_negative_binomial quantile_noncentral_chi2 quantile_noncentral_student_t'
	      + ' quantile_normal quantile_pareto quantile_poisson quantile_rayleigh quantile_student_t'
	      + ' quantile_weibull quartile_skewness quit qunit quotient racah_v racah_w radcan'
	      + ' radius random random_bernoulli random_beta random_binomial random_bipartite_graph'
	      + ' random_cauchy random_chi2 random_continuous_uniform random_digraph random_discrete_uniform'
	      + ' random_exp random_f random_gamma random_general_finite_discrete random_geometric'
	      + ' random_graph random_graph1 random_gumbel random_hypergeometric random_laplace'
	      + ' random_logistic random_lognormal random_negative_binomial random_network'
	      + ' random_noncentral_chi2 random_noncentral_student_t random_normal random_pareto'
	      + ' random_permutation random_poisson random_rayleigh random_regular_graph random_student_t'
	      + ' random_tournament random_tree random_weibull range rank rat ratcoef ratdenom'
	      + ' ratdiff ratdisrep ratexpand ratinterpol rational rationalize ratnumer ratnump'
	      + ' ratp ratsimp ratsubst ratvars ratweight read read_array read_binary_array'
	      + ' read_binary_list read_binary_matrix readbyte readchar read_hashed_array readline'
	      + ' read_list read_matrix read_nested_list readonly read_xpm real_imagpart_to_conjugate'
	      + ' realpart realroots rearray rectangle rectform rectform_log_if_constant recttopolar'
	      + ' rediff reduce_consts reduce_order region region_boundaries region_boundaries_plus'
	      + ' rem remainder remarray rembox remcomps remcon remcoord remfun remfunction'
	      + ' remlet remove remove_constvalue remove_dimensions remove_edge remove_fundamental_dimensions'
	      + ' remove_fundamental_units remove_plot_option remove_vertex rempart remrule'
	      + ' remsym remvalue rename rename_file reset reset_displays residue resolvante'
	      + ' resolvante_alternee1 resolvante_bipartite resolvante_diedrale resolvante_klein'
	      + ' resolvante_klein3 resolvante_produit_sym resolvante_unitaire resolvante_vierer'
	      + ' rest resultant return reveal reverse revert revert2 rgb2level rhs ricci riemann'
	      + ' rinvariant risch rk rmdir rncombine romberg room rootscontract round row'
	      + ' rowop rowswap rreduce run_testsuite %s save saving scalarp scaled_bessel_i'
	      + ' scaled_bessel_i0 scaled_bessel_i1 scalefactors scanmap scatterplot scatterplot_description'
	      + ' scene schur2comp sconcat scopy scsimp scurvature sdowncase sec sech second'
	      + ' sequal sequalignore set_alt_display setdifference set_draw_defaults set_edge_weight'
	      + ' setelmx setequalp setify setp set_partitions set_plot_option set_prompt set_random_state'
	      + ' set_tex_environment set_tex_environment_default setunits setup_autoload set_up_dot_simplifications'
	      + ' set_vertex_label seventh sexplode sf sha1sum sha256sum shortest_path shortest_weighted_path'
	      + ' show showcomps showratvars sierpinskiale sierpinskimap sign signum similaritytransform'
	      + ' simp_inequality simplify_sum simplode simpmetderiv simtran sin sinh sinsert'
	      + ' sinvertcase sixth skewness skewness_bernoulli skewness_beta skewness_binomial'
	      + ' skewness_chi2 skewness_continuous_uniform skewness_discrete_uniform skewness_exp'
	      + ' skewness_f skewness_gamma skewness_general_finite_discrete skewness_geometric'
	      + ' skewness_gumbel skewness_hypergeometric skewness_laplace skewness_logistic'
	      + ' skewness_lognormal skewness_negative_binomial skewness_noncentral_chi2 skewness_noncentral_student_t'
	      + ' skewness_normal skewness_pareto skewness_poisson skewness_rayleigh skewness_student_t'
	      + ' skewness_weibull slength smake small_rhombicosidodecahedron_graph small_rhombicuboctahedron_graph'
	      + ' smax smin smismatch snowmap snub_cube_graph snub_dodecahedron_graph solve'
	      + ' solve_rec solve_rec_rat some somrac sort sparse6_decode sparse6_encode sparse6_export'
	      + ' sparse6_import specint spherical spherical_bessel_j spherical_bessel_y spherical_hankel1'
	      + ' spherical_hankel2 spherical_harmonic spherical_to_xyz splice split sposition'
	      + ' sprint sqfr sqrt sqrtdenest sremove sremovefirst sreverse ssearch ssort sstatus'
	      + ' ssubst ssubstfirst staircase standardize standardize_inverse_trig starplot'
	      + ' starplot_description status std std1 std_bernoulli std_beta std_binomial'
	      + ' std_chi2 std_continuous_uniform std_discrete_uniform std_exp std_f std_gamma'
	      + ' std_general_finite_discrete std_geometric std_gumbel std_hypergeometric std_laplace'
	      + ' std_logistic std_lognormal std_negative_binomial std_noncentral_chi2 std_noncentral_student_t'
	      + ' std_normal std_pareto std_poisson std_rayleigh std_student_t std_weibull'
	      + ' stemplot stirling stirling1 stirling2 strim striml strimr string stringout'
	      + ' stringp strong_components struve_h struve_l sublis sublist sublist_indices'
	      + ' submatrix subsample subset subsetp subst substinpart subst_parallel substpart'
	      + ' substring subvar subvarp sum sumcontract summand_to_rec supcase supcontext'
	      + ' symbolp symmdifference symmetricp system take_channel take_inference tan'
	      + ' tanh taylor taylorinfo taylorp taylor_simplifier taytorat tcl_output tcontract'
	      + ' tellrat tellsimp tellsimpafter tentex tenth test_mean test_means_difference'
	      + ' test_normality test_proportion test_proportions_difference test_rank_sum'
	      + ' test_sign test_signed_rank test_variance test_variance_ratio tex tex1 tex_display'
	      + ' texput %th third throw time timedate timer timer_info tldefint tlimit todd_coxeter'
	      + ' toeplitz tokens to_lisp topological_sort to_poly to_poly_solve totaldisrep'
	      + ' totalfourier totient tpartpol trace tracematrix trace_options transform_sample'
	      + ' translate translate_file transpose treefale tree_reduce treillis treinat'
	      + ' triangle triangularize trigexpand trigrat trigreduce trigsimp trunc truncate'
	      + ' truncated_cube_graph truncated_dodecahedron_graph truncated_icosahedron_graph'
	      + ' truncated_tetrahedron_graph tr_warnings_get tube tutte_graph ueivects uforget'
	      + ' ultraspherical underlying_graph undiff union unique uniteigenvectors unitp'
	      + ' units unit_step unitvector unorder unsum untellrat untimer'
	      + ' untrace uppercasep uricci uriemann uvect vandermonde_matrix var var1 var_bernoulli'
	      + ' var_beta var_binomial var_chi2 var_continuous_uniform var_discrete_uniform'
	      + ' var_exp var_f var_gamma var_general_finite_discrete var_geometric var_gumbel'
	      + ' var_hypergeometric var_laplace var_logistic var_lognormal var_negative_binomial'
	      + ' var_noncentral_chi2 var_noncentral_student_t var_normal var_pareto var_poisson'
	      + ' var_rayleigh var_student_t var_weibull vector vectorpotential vectorsimp'
	      + ' verbify vers vertex_coloring vertex_connectivity vertex_degree vertex_distance'
	      + ' vertex_eccentricity vertex_in_degree vertex_out_degree vertices vertices_to_cycle'
	      + ' vertices_to_path %w weyl wheel_graph wiener_index wigner_3j wigner_6j'
	      + ' wigner_9j with_stdout write_binary_data writebyte write_data writefile wronskian'
	      + ' xreduce xthru %y Zeilberger zeroequiv zerofor zeromatrix zeromatrixp zeta'
	      + ' zgeev zheev zlange zn_add_table zn_carmichael_lambda zn_characteristic_factors'
	      + ' zn_determinant zn_factor_generators zn_invert_by_lu zn_log zn_mult_table'
	      + ' absboxchar activecontexts adapt_depth additive adim aform algebraic'
	      + ' algepsilon algexact aliases allbut all_dotsimp_denoms allocation allsym alphabetic'
	      + ' animation antisymmetric arrays askexp assume_pos assume_pos_pred assumescalar'
	      + ' asymbol atomgrad atrig1 axes axis_3d axis_bottom axis_left axis_right axis_top'
	      + ' azimuth background background_color backsubst berlefact bernstein_explicit'
	      + ' besselexpand beta_args_sum_to_integer beta_expand bftorat bftrunc bindtest'
	      + ' border boundaries_array box boxchar breakup %c capping cauchysum cbrange'
	      + ' cbtics center cflength cframe_flag cnonmet_flag color color_bar color_bar_tics'
	      + ' colorbox columns commutative complex cone context contexts contour contour_levels'
	      + ' cosnpiflag ctaypov ctaypt ctayswitch ctayvar ct_coords ctorsion_flag ctrgsimp'
	      + ' cube current_let_rule_package cylinder data_file_name debugmode decreasing'
	      + ' default_let_rule_package delay dependencies derivabbrev derivsubst detout'
	      + ' diagmetric diff dim dimensions dispflag display2d|10 display_format_internal'
	      + ' distribute_over doallmxops domain domxexpt domxmxops domxnctimes dontfactor'
	      + ' doscmxops doscmxplus dot0nscsimp dot0simp dot1simp dotassoc dotconstrules'
	      + ' dotdistrib dotexptsimp dotident dotscrules draw_graph_program draw_realpart'
	      + ' edge_color edge_coloring edge_partition edge_type edge_width %edispflag'
	      + ' elevation %emode endphi endtheta engineering_format_floats enhanced3d %enumer'
	      + ' epsilon_lp erfflag erf_representation errormsg error_size error_syms error_type'
	      + ' %e_to_numlog eval even evenfun evflag evfun ev_point expandwrt_denom expintexpand'
	      + ' expintrep expon expop exptdispflag exptisolate exptsubst facexpand facsum_combine'
	      + ' factlim factorflag factorial_expand factors_only fb feature features'
	      + ' file_name file_output_append file_search_demo file_search_lisp file_search_maxima|10'
	      + ' file_search_tests file_search_usage file_type_lisp file_type_maxima|10 fill_color'
	      + ' fill_density filled_func fixed_vertices flipflag float2bf font font_size'
	      + ' fortindent fortspaces fpprec fpprintprec functions gamma_expand gammalim'
	      + ' gdet genindex gensumnum GGFCFMAX GGFINFINITY globalsolve gnuplot_command'
	      + ' gnuplot_curve_styles gnuplot_curve_titles gnuplot_default_term_command gnuplot_dumb_term_command'
	      + ' gnuplot_file_args gnuplot_file_name gnuplot_out_file gnuplot_pdf_term_command'
	      + ' gnuplot_pm3d gnuplot_png_term_command gnuplot_postamble gnuplot_preamble'
	      + ' gnuplot_ps_term_command gnuplot_svg_term_command gnuplot_term gnuplot_view_args'
	      + ' Gosper_in_Zeilberger gradefs grid grid2d grind halfangles head_angle head_both'
	      + ' head_length head_type height hypergeometric_representation %iargs ibase'
	      + ' icc1 icc2 icounter idummyx ieqnprint ifb ifc1 ifc2 ifg ifgi ifr iframe_bracket_form'
	      + ' ifri igeowedge_flag ikt1 ikt2 imaginary inchar increasing infeval'
	      + ' infinity inflag infolists inm inmc1 inmc2 intanalysis integer integervalued'
	      + ' integrate_use_rootsof integration_constant integration_constant_counter interpolate_color'
	      + ' intfaclim ip_grid ip_grid_in irrational isolate_wrt_times iterations itr'
	      + ' julia_parameter %k1 %k2 keepfloat key key_pos kinvariant kt label label_alignment'
	      + ' label_orientation labels lassociative lbfgs_ncorrections lbfgs_nfeval_max'
	      + ' leftjust legend letrat let_rule_packages lfg lg lhospitallim limsubst linear'
	      + ' linear_solver linechar linel|10 linenum line_type linewidth line_width linsolve_params'
	      + ' linsolvewarn lispdisp listarith listconstvars listdummyvars lmxchar load_pathname'
	      + ' loadprint logabs logarc logcb logconcoeffp logexpand lognegint logsimp logx'
	      + ' logx_secondary logy logy_secondary logz lriem m1pbranch macroexpansion macros'
	      + ' mainvar manual_demo maperror mapprint matrix_element_add matrix_element_mult'
	      + ' matrix_element_transpose maxapplydepth maxapplyheight maxima_tempdir|10 maxima_userdir|10'
	      + ' maxnegex MAX_ORD maxposex maxpsifracdenom maxpsifracnum maxpsinegint maxpsiposint'
	      + ' maxtayorder mesh_lines_color method mod_big_prime mode_check_errorp'
	      + ' mode_checkp mode_check_warnp mod_test mod_threshold modular_linear_solver'
	      + ' modulus multiplicative multiplicities myoptions nary negdistrib negsumdispflag'
	      + ' newline newtonepsilon newtonmaxiter nextlayerfactor niceindicespref nm nmc'
	      + ' noeval nolabels nonegative_lp noninteger nonscalar noun noundisp nouns np'
	      + ' npi nticks ntrig numer numer_pbranch obase odd oddfun opacity opproperties'
	      + ' opsubst optimprefix optionset orientation origin orthopoly_returns_intervals'
	      + ' outative outchar packagefile palette partswitch pdf_file pfeformat phiresolution'
	      + ' %piargs piece pivot_count_sx pivot_max_sx plot_format plot_options plot_realpart'
	      + ' png_file pochhammer_max_index points pointsize point_size points_joined point_type'
	      + ' poislim poisson poly_coefficient_ring poly_elimination_order polyfactor poly_grobner_algorithm'
	      + ' poly_grobner_debug poly_monomial_order poly_primary_elimination_order poly_return_term_list'
	      + ' poly_secondary_elimination_order poly_top_reduction_only posfun position'
	      + ' powerdisp pred prederror primep_number_of_tests product_use_gamma program'
	      + ' programmode promote_float_to_bigfloat prompt proportional_axes props psexpand'
	      + ' ps_file radexpand radius radsubstflag rassociative ratalgdenom ratchristof'
	      + ' ratdenomdivide rateinstein ratepsilon ratfac rational ratmx ratprint ratriemann'
	      + ' ratsimpexpons ratvarswitch ratweights ratweyl ratwtlvl real realonly redraw'
	      + ' refcheck resolution restart resultant ric riem rmxchar %rnum_list rombergabs'
	      + ' rombergit rombergmin rombergtol rootsconmode rootsepsilon run_viewer same_xy'
	      + ' same_xyz savedef savefactors scalar scalarmatrixp scale scale_lp setcheck'
	      + ' setcheckbreak setval show_edge_color show_edges show_edge_type show_edge_width'
	      + ' show_id show_label showtime show_vertex_color show_vertex_size show_vertex_type'
	      + ' show_vertices show_weight simp simplified_output simplify_products simpproduct'
	      + ' simpsum sinnpiflag solvedecomposes solveexplicit solvefactors solvenullwarn'
	      + ' solveradcan solvetrigwarn space sparse sphere spring_embedding_depth sqrtdispflag'
	      + ' stardisp startphi starttheta stats_numer stringdisp structures style sublis_apply_lambda'
	      + ' subnumsimp sumexpand sumsplitfact surface surface_hide svg_file symmetric'
	      + ' tab taylordepth taylor_logexpand taylor_order_coefficients taylor_truncate_polynomials'
	      + ' tensorkill terminal testsuite_files thetaresolution timer_devalue title tlimswitch'
	      + ' tr track transcompile transform transform_xy translate_fast_arrays transparent'
	      + ' transrun tr_array_as_ref tr_bound_function_applyp tr_file_tty_messagesp tr_float_can_branch_complex'
	      + ' tr_function_call_default trigexpandplus trigexpandtimes triginverses trigsign'
	      + ' trivial_solutions tr_numer tr_optimize_max_loop tr_semicompile tr_state_vars'
	      + ' tr_warn_bad_function_calls tr_warn_fexpr tr_warn_meval tr_warn_mode'
	      + ' tr_warn_undeclared tr_warn_undefined_variable tstep ttyoff tube_extremes'
	      + ' ufg ug %unitexpand unit_vectors uric uriem use_fast_arrays user_preamble'
	      + ' usersetunits values vect_cross verbose vertex_color vertex_coloring vertex_partition'
	      + ' vertex_size vertex_type view warnings weyl width windowname windowtitle wired_surface'
	      + ' wireframe xaxis xaxis_color xaxis_secondary xaxis_type xaxis_width xlabel'
	      + ' xlabel_secondary xlength xrange xrange_secondary xtics xtics_axis xtics_rotate'
	      + ' xtics_rotate_secondary xtics_secondary xtics_secondary_axis xu_grid x_voxel'
	      + ' xy_file xyplane xy_scale yaxis yaxis_color yaxis_secondary yaxis_type yaxis_width'
	      + ' ylabel ylabel_secondary ylength yrange yrange_secondary ytics ytics_axis'
	      + ' ytics_rotate ytics_rotate_secondary ytics_secondary ytics_secondary_axis'
	      + ' yv_grid y_voxel yx_ratio zaxis zaxis_color zaxis_type zaxis_width zeroa zerob'
	      + ' zerobern zeta%pi zlabel zlabel_rotate zlength zmin zn_primroot_limit zn_primroot_pretest';
	  var SYMBOLS = '_ __ %|0 %%|0';
	
	  return {
	    lexemes: '[A-Za-z_%][0-9A-Za-z_%]*',
	    keywords: {
	      keyword: KEYWORDS,
	      literal: LITERALS,
	      built_in: BUILTIN_FUNCTIONS,
	      symbol: SYMBOLS,
	    },
	    contains: [
	      {
	        className: 'comment',
	        begin: '/\\*',
	        end: '\\*/',
	        contains: ['self']
	      },
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'number',
	        relevance: 0,
	        variants: [
	          {
	            // float number w/ exponent
	            // hmm, I wonder if we ought to include other exponent markers?
	            begin: '\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Ee][-+]?\\d+\\b',
	          },
	          {
	            // bigfloat number
	            begin: '\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Bb][-+]?\\d+\\b',
	            relevance: 10
	          },
	          {
	            // float number w/out exponent
	            // Doesn't seem to recognize floats which start with '.'
	            begin: '\\b(\\.\\d+|\\d+\\.\\d+)\\b',
	          },
	          {
	            // integer in base up to 36
	            // Doesn't seem to recognize integers which end with '.'
	            begin: '\\b(\\d+|0[0-9A-Za-z]+)\\.?\\b',
	          }
	        ]
	      }
	    ],
	    illegal: /@/
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/mel.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords:
	      'int float string vector matrix if else switch case default while do for in break ' +
	      'continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic ' +
	      'addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey ' +
	      'affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve ' +
	      'alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor ' +
	      'animDisplay animView annotate appendStringArray applicationName applyAttrPreset ' +
	      'applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx ' +
	      'artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu ' +
	      'artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand ' +
	      'assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface ' +
	      'attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu ' +
	      'attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp ' +
	      'attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery ' +
	      'autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults ' +
	      'bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership ' +
	      'bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType ' +
	      'boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu ' +
	      'buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge ' +
	      'cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch ' +
	      'catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox ' +
	      'character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp ' +
	      'checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip ' +
	      'clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore ' +
	      'closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter ' +
	      'cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color ' +
	      'colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp ' +
	      'colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem ' +
	      'componentEditor compositingInterop computePolysetVolume condition cone confirmDialog ' +
	      'connectAttr connectControl connectDynamic connectJoint connectionInfo constrain ' +
	      'constrainValue constructionHistory container containsMultibyte contextInfo control ' +
	      'convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation ' +
	      'convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache ' +
	      'cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel ' +
	      'cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver ' +
	      'cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor ' +
	      'createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer ' +
	      'createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse ' +
	      'currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx ' +
	      'curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface ' +
	      'curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox ' +
	      'defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete ' +
	      'deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes ' +
	      'delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo ' +
	      'dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable ' +
	      'disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected ' +
	      'displayColor displayCull displayLevelOfDetail displayPref displayRGBColor ' +
	      'displaySmoothness displayStats displayString displaySurface distanceDimContext ' +
	      'distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct ' +
	      'doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator ' +
	      'duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression ' +
	      'dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor ' +
	      'dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers ' +
	      'editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor ' +
	      'editorTemplate effector emit emitter enableDevice encodeString endString endsWith env ' +
	      'equivalent equivalentTol erf error eval evalDeferred evalEcho event ' +
	      'exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp ' +
	      'expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof ' +
	      'fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo ' +
	      'filetest filletCurve filter filterCurve filterExpand filterStudioImport ' +
	      'findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster ' +
	      'finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar ' +
	      'floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo ' +
	      'fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint ' +
	      'frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss ' +
	      'geometryConstraint getApplicationVersionAsFloat getAttr getClassification ' +
	      'getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes ' +
	      'getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender ' +
	      'glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl ' +
	      'gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid ' +
	      'gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap ' +
	      'HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor ' +
	      'HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached ' +
	      'HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel ' +
	      'headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey ' +
	      'hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender ' +
	      'hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox ' +
	      'iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ' +
	      'ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ' +
	      'ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform ' +
	      'insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance ' +
	      'instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp ' +
	      'interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf ' +
	      'isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect ' +
	      'itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx ' +
	      'jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner ' +
	      'keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx ' +
	      'keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx ' +
	      'keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx ' +
	      'keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor ' +
	      'layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList ' +
	      'lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep ' +
	      'listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory ' +
	      'listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation ' +
	      'listNodeTypes listPanelCategories listRelatives listSets listTransforms ' +
	      'listUnselected listerEditor loadFluid loadNewShelf loadPlugin ' +
	      'loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log ' +
	      'longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive ' +
	      'makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext ' +
	      'manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx ' +
	      'manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout ' +
	      'menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp ' +
	      'mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move ' +
	      'moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute ' +
	      'nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast ' +
	      'nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint ' +
	      'normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect ' +
	      'nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref ' +
	      'nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType ' +
	      'objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface ' +
	      'offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit ' +
	      'orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier ' +
	      'paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration ' +
	      'panelHistory paramDimContext paramDimension paramLocator parent parentConstraint ' +
	      'particle particleExists particleInstancer particleRenderInfo partition pasteKey ' +
	      'pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture ' +
	      'pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo ' +
	      'pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult ' +
	      'pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend ' +
	      'polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal ' +
	      'polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge ' +
	      'polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge ' +
	      'polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet ' +
	      'polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet ' +
	      'polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection ' +
	      'polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge ' +
	      'polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet ' +
	      'polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix ' +
	      'polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut ' +
	      'polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet ' +
	      'polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge ' +
	      'polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex ' +
	      'polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection ' +
	      'polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection ' +
	      'polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint ' +
	      'polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate ' +
	      'polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge ' +
	      'polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing ' +
	      'polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet ' +
	      'polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace ' +
	      'popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer ' +
	      'projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx ' +
	      'propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd ' +
	      'python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection ' +
	      'radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl ' +
	      'readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference ' +
	      'referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE ' +
	      'registerPluginResource rehash reloadImage removeJoint removeMultiInstance ' +
	      'removePanelCategory rename renameAttr renameSelectionList renameUI render ' +
	      'renderGlobalsNode renderInfo renderLayerButton renderLayerParent ' +
	      'renderLayerPostProcess renderLayerUnparent renderManip renderPartition ' +
	      'renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor ' +
	      'renderWindowSelectContext renderer reorder reorderDeformers requires reroot ' +
	      'resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget ' +
	      'reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx ' +
	      'rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout ' +
	      'runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage ' +
	      'saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale ' +
	      'scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor ' +
	      'sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable ' +
	      'scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt ' +
	      'searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey ' +
	      'selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType ' +
	      'selectedNodes selectionConnection separator setAttr setAttrEnumResource ' +
	      'setAttrMapping setAttrNiceNameResource setConstraintRestPosition ' +
	      'setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr ' +
	      'setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe ' +
	      'setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag ' +
	      'setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject ' +
	      'setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets ' +
	      'shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare ' +
	      'shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField ' +
	      'shortNameOf showHelp showHidden showManipCtx showSelectionInTitle ' +
	      'showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface ' +
	      'size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep ' +
	      'snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound ' +
	      'soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort ' +
	      'spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString ' +
	      'startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp ' +
	      'stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex ' +
	      'stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex ' +
	      'stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString ' +
	      'stringToStringArray strip stripPrefixFromName stroke subdAutoProjection ' +
	      'subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV ' +
	      'subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror ' +
	      'subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease ' +
	      'subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring ' +
	      'surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton ' +
	      'symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext ' +
	      'texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext ' +
	      'texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text ' +
	      'textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList ' +
	      'textToShelf textureDisplacePlane textureHairColor texturePlacementContext ' +
	      'textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath ' +
	      'toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower ' +
	      'toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper ' +
	      'trace track trackCtx transferAttributes transformCompare transformLimits translator ' +
	      'trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence ' +
	      'twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit ' +
	      'unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink ' +
	      'uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane ' +
	      'viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex ' +
	      'waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire ' +
	      'wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform',
	    illegal: '</',
	    contains: [
	      hljs.C_NUMBER_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: '`', end: '`',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      { // eats variables
	        begin: '[\\$\\%\\@](\\^\\w\\b|#\\w+|[^\\s\\w{]|{\\w+}|\\w+)'
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/mercury.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      'module use_module import_module include_module end_module initialise ' +
	      'mutable initialize finalize finalise interface implementation pred ' +
	      'mode func type inst solver any_pred any_func is semidet det nondet ' +
	      'multi erroneous failure cc_nondet cc_multi typeclass instance where ' +
	      'pragma promise external trace atomic or_else require_complete_switch ' +
	      'require_det require_semidet require_multi require_nondet ' +
	      'require_cc_multi require_cc_nondet require_erroneous require_failure',
	    meta:
	      // pragma
	      'inline no_inline type_spec source_file fact_table obsolete memo ' +
	      'loop_check minimal_model terminates does_not_terminate ' +
	      'check_termination promise_equivalent_clauses ' +
	      // preprocessor
	      'foreign_proc foreign_decl foreign_code foreign_type ' +
	      'foreign_import_module foreign_export_enum foreign_export ' +
	      'foreign_enum may_call_mercury will_not_call_mercury thread_safe ' +
	      'not_thread_safe maybe_thread_safe promise_pure promise_semipure ' +
	      'tabled_for_io local untrailed trailed attach_to_io_state ' +
	      'can_pass_as_mercury_type stable will_not_throw_exception ' +
	      'may_modify_trail will_not_modify_trail may_duplicate ' +
	      'may_not_duplicate affects_liveness does_not_affect_liveness ' +
	      'doesnt_affect_liveness no_sharing unknown_sharing sharing',
	    built_in:
	      'some all not if then else true fail false try catch catch_any ' +
	      'semidet_true semidet_false semidet_fail impure_true impure semipure'
	  };
	
	  var COMMENT = hljs.COMMENT('%', '$');
	
	  var NUMCODE = {
	    className: 'number',
	    begin: "0'.\\|0[box][0-9a-fA-F]*"
	  };
	
	  var ATOM = hljs.inherit(hljs.APOS_STRING_MODE, {relevance: 0});
	  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {relevance: 0});
	  var STRING_FMT = {
	    className: 'subst',
	    begin: '\\\\[abfnrtv]\\|\\\\x[0-9a-fA-F]*\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]',
	    relevance: 0
	  };
	  STRING.contains.push(STRING_FMT);
	
	  var IMPLICATION = {
	    className: 'built_in',
	    variants: [
	      {begin: '<=>'},
	      {begin: '<=', relevance: 0},
	      {begin: '=>', relevance: 0},
	      {begin: '/\\\\'},
	      {begin: '\\\\/'}
	    ]
	  };
	
	  var HEAD_BODY_CONJUNCTION = {
	    className: 'built_in',
	    variants: [
	      {begin: ':-\\|-->'},
	      {begin: '=', relevance: 0}
	    ]
	  };
	
	  return {
	    aliases: ['m', 'moo'],
	    keywords: KEYWORDS,
	    contains: [
	      IMPLICATION,
	      HEAD_BODY_CONJUNCTION,
	      COMMENT,
	      hljs.C_BLOCK_COMMENT_MODE,
	      NUMCODE,
	      hljs.NUMBER_MODE,
	      ATOM,
	      STRING,
	      {begin: /:-/} // relevance booster
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/mipsasm.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	    //local labels: %?[FB]?[AT]?\d{1,2}\w+
	  return {
	    case_insensitive: true,
	    aliases: ['mips'],
	    lexemes: '\\.?' + hljs.IDENT_RE,
	    keywords: {
	      meta:
	        //GNU preprocs
	        '.2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .ltorg ',
	      built_in:
	        '$0 $1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11 $12 $13 $14 $15 ' + // integer registers
	        '$16 $17 $18 $19 $20 $21 $22 $23 $24 $25 $26 $27 $28 $29 $30 $31 ' + // integer registers
	        'zero at v0 v1 a0 a1 a2 a3 a4 a5 a6 a7 ' + // integer register aliases
	        't0 t1 t2 t3 t4 t5 t6 t7 t8 t9 s0 s1 s2 s3 s4 s5 s6 s7 s8 ' + // integer register aliases
	        'k0 k1 gp sp fp ra ' + // integer register aliases
	        '$f0 $f1 $f2 $f2 $f4 $f5 $f6 $f7 $f8 $f9 $f10 $f11 $f12 $f13 $f14 $f15 ' + // floating-point registers
	        '$f16 $f17 $f18 $f19 $f20 $f21 $f22 $f23 $f24 $f25 $f26 $f27 $f28 $f29 $f30 $f31 ' + // floating-point registers
	        'Context Random EntryLo0 EntryLo1 Context PageMask Wired EntryHi ' + // Coprocessor 0 registers
	        'HWREna BadVAddr Count Compare SR IntCtl SRSCtl SRSMap Cause EPC PRId ' + // Coprocessor 0 registers
	        'EBase Config Config1 Config2 Config3 LLAddr Debug DEPC DESAVE CacheErr ' + // Coprocessor 0 registers
	        'ECC ErrorEPC TagLo DataLo TagHi DataHi WatchLo WatchHi PerfCtl PerfCnt ' // Coprocessor 0 registers
	    },
	    contains: [
	      {
	        className: 'keyword',
	        begin: '\\b('+     //mnemonics
	            // 32-bit integer instructions
	            'addi?u?|andi?|b(al)?|beql?|bgez(al)?l?|bgtzl?|blezl?|bltz(al)?l?|' +
	            'bnel?|cl[oz]|divu?|ext|ins|j(al)?|jalr(\.hb)?|jr(\.hb)?|lbu?|lhu?|' +
	            'll|lui|lw[lr]?|maddu?|mfhi|mflo|movn|movz|move|msubu?|mthi|mtlo|mul|' +
	            'multu?|nop|nor|ori?|rotrv?|sb|sc|se[bh]|sh|sllv?|slti?u?|srav?|' +
	            'srlv?|subu?|sw[lr]?|xori?|wsbh|' +
	            // floating-point instructions
	            'abs\.[sd]|add\.[sd]|alnv.ps|bc1[ft]l?|' +
	            'c\.(s?f|un|u?eq|[ou]lt|[ou]le|ngle?|seq|l[et]|ng[et])\.[sd]|' +
	            '(ceil|floor|round|trunc)\.[lw]\.[sd]|cfc1|cvt\.d\.[lsw]|' +
	            'cvt\.l\.[dsw]|cvt\.ps\.s|cvt\.s\.[dlw]|cvt\.s\.p[lu]|cvt\.w\.[dls]|' +
	            'div\.[ds]|ldx?c1|luxc1|lwx?c1|madd\.[sd]|mfc1|mov[fntz]?\.[ds]|' +
	            'msub\.[sd]|mth?c1|mul\.[ds]|neg\.[ds]|nmadd\.[ds]|nmsub\.[ds]|' +
	            'p[lu][lu]\.ps|recip\.fmt|r?sqrt\.[ds]|sdx?c1|sub\.[ds]|suxc1|' +
	            'swx?c1|' +
	            // system control instructions
	            'break|cache|d?eret|[de]i|ehb|mfc0|mtc0|pause|prefx?|rdhwr|' +
	            'rdpgpr|sdbbp|ssnop|synci?|syscall|teqi?|tgei?u?|tlb(p|r|w[ir])|' +
	            'tlti?u?|tnei?|wait|wrpgpr'+
	        ')',
	        end: '\\s'
	      },
	      hljs.COMMENT('[;#]', '$'),
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: '\'',
	        end: '[^\\\\]\'',
	        relevance: 0
	      },
	      {
	        className: 'title',
	        begin: '\\|', end: '\\|',
	        illegal: '\\n',
	        relevance: 0
	      },
	      {
	        className: 'number',
	        variants: [
	            {begin: '0x[0-9a-f]+'}, //hex
	            {begin: '\\b-?\\d+'}           //bare number
	        ],
	        relevance: 0
	      },
	      {
	        className: 'symbol',
	        variants: [
	            {begin: '^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:'}, //GNU MIPS syntax
	            {begin: '^\\s*[0-9]+:'}, // numbered local labels
	            {begin: '[0-9]+[bf]' }  // number local label reference (backwards, forwards)
	        ],
	        relevance: 0
	      }
	    ],
	    illegal: '\/'
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/mizar.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords:
	      'environ vocabularies notations constructors definitions ' +
	      'registrations theorems schemes requirements begin end definition ' +
	      'registration cluster existence pred func defpred deffunc theorem ' +
	      'proof let take assume then thus hence ex for st holds consider ' +
	      'reconsider such that and in provided of as from be being by means ' +
	      'equals implies iff redefine define now not or attr is mode ' +
	      'suppose per cases set thesis contradiction scheme reserve struct ' +
	      'correctness compatibility coherence symmetry assymetry ' +
	      'reflexivity irreflexivity connectedness uniqueness commutativity ' +
	      'idempotence involutiveness projectivity',
	    contains: [
	      hljs.COMMENT('::', '$')
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/mojolicious.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    subLanguage: 'xml',
	    contains: [
	      {
	        className: 'meta',
	        begin: '^__(END|DATA)__$'
	      },
	    // mojolicious line
	      {
	        begin: "^\\s*%{1,2}={0,2}", end: '$',
	        subLanguage: 'perl'
	      },
	    // mojolicious block
	      {
	        begin: "<%{1,2}={0,2}",
	        end: "={0,1}%>",
	        subLanguage: 'perl',
	        excludeBegin: true,
	        excludeEnd: true
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/monkey.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var NUMBER = {
	    className: 'number', relevance: 0,
	    variants: [
	      {
	        begin: '[$][a-fA-F0-9]+'
	      },
	      hljs.NUMBER_MODE
	    ]
	  };
	
	  return {
	    case_insensitive: true,
	    keywords: {
	      keyword: 'public private property continue exit extern new try catch ' +
	        'eachin not abstract final select case default const local global field ' +
	        'end if then else elseif endif while wend repeat until forever for ' +
	        'to step next return module inline throw import',
	
	      built_in: 'DebugLog DebugStop Error Print ACos ACosr ASin ASinr ATan ATan2 ATan2r ATanr Abs Abs Ceil ' +
	        'Clamp Clamp Cos Cosr Exp Floor Log Max Max Min Min Pow Sgn Sgn Sin Sinr Sqrt Tan Tanr Seed PI HALFPI TWOPI',
	
	      literal: 'true false null and or shl shr mod'
	    },
	    illegal: /\/\*/,
	    contains: [
	      hljs.COMMENT('#rem', '#end'),
	      hljs.COMMENT(
	        "'",
	        '$',
	        {
	          relevance: 0
	        }
	      ),
	      {
	        className: 'function',
	        beginKeywords: 'function method', end: '[(=:]|$',
	        illegal: /\n/,
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '$',
	        contains: [
	          {
	            beginKeywords: 'extends implements'
	          },
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        className: 'built_in',
	        begin: '\\b(self|super)\\b'
	      },
	      {
	        className: 'meta',
	        begin: '\\s*#', end: '$',
	        keywords: {'meta-keyword': 'if else elseif endif end then'}
	      },
	      {
	        className: 'meta',
	        begin: '^\\s*strict\\b'
	      },
	      {
	        beginKeywords: 'alias', end: '=',
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      hljs.QUOTE_STRING_MODE,
	      NUMBER
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/moonscript.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      // Moonscript keywords
	      'if then not for in while do return else elseif break continue switch and or ' +
	      'unless when class extends super local import export from using',
	    literal:
	      'true false nil',
	    built_in:
	      '_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load ' +
	      'loadfile loadstring module next pairs pcall print rawequal rawget rawset require ' +
	      'select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug ' +
	      'io math os package string table'
	  };
	  var JS_IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
	  var SUBST = {
	    className: 'subst',
	    begin: /#\{/, end: /}/,
	    keywords: KEYWORDS
	  };
	  var EXPRESSIONS = [
	    hljs.inherit(hljs.C_NUMBER_MODE,
	      {starts: {end: '(\\s*/)?', relevance: 0}}), // a number tries to eat the following slash to prevent treating it as a regexp
	    {
	      className: 'string',
	      variants: [
	        {
	          begin: /'/, end: /'/,
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: /"/, end: /"/,
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	        }
	      ]
	    },
	    {
	      className: 'built_in',
	      begin: '@__' + hljs.IDENT_RE
	    },
	    {
	      begin: '@' + hljs.IDENT_RE // relevance booster on par with CoffeeScript
	    },
	    {
	      begin: hljs.IDENT_RE + '\\\\' + hljs.IDENT_RE // inst\method
	    }
	  ];
	  SUBST.contains = EXPRESSIONS;
	
	  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
	  var PARAMS_RE = '(\\(.*\\))?\\s*\\B[-=]>';
	  var PARAMS = {
	    className: 'params',
	    begin: '\\([^\\(]', returnBegin: true,
	    /* We need another contained nameless mode to not have every nested
	    pair of parens to be called "params" */
	    contains: [{
	      begin: /\(/, end: /\)/,
	      keywords: KEYWORDS,
	      contains: ['self'].concat(EXPRESSIONS)
	    }]
	  };
	
	  return {
	    aliases: ['moon'],
	    keywords: KEYWORDS,
	    illegal: /\/\*/,
	    contains: EXPRESSIONS.concat([
	      hljs.COMMENT('--', '$'),
	      {
	        className: 'function',  // function: -> =>
	        begin: '^\\s*' + JS_IDENT_RE + '\\s*=\\s*' + PARAMS_RE, end: '[-=]>',
	        returnBegin: true,
	        contains: [TITLE, PARAMS]
	      },
	      {
	        begin: /[\(,:=]\s*/, // anonymous function start
	        relevance: 0,
	        contains: [
	          {
	            className: 'function',
	            begin: PARAMS_RE, end: '[-=]>',
	            returnBegin: true,
	            contains: [PARAMS]
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class',
	        end: '$',
	        illegal: /[:="\[\]]/,
	        contains: [
	          {
	            beginKeywords: 'extends',
	            endsWithParent: true,
	            illegal: /[:="\[\]]/,
	            contains: [TITLE]
	          },
	          TITLE
	        ]
	      },
	      {
	        className: 'name',    // table
	        begin: JS_IDENT_RE + ':', end: ':',
	        returnBegin: true, returnEnd: true,
	        relevance: 0
	      }
	    ])
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/n1ql.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    case_insensitive: true,
	    contains: [
	      {
	        beginKeywords:
	          'build create index delete drop explain infer|10 insert merge prepare select update upsert|10',
	        end: /;/, endsWithParent: true,
	        keywords: {
	          // Taken from http://developer.couchbase.com/documentation/server/current/n1ql/n1ql-language-reference/reservedwords.html
	          keyword:
	            'all alter analyze and any array as asc begin between binary boolean break bucket build by call ' +
	            'case cast cluster collate collection commit connect continue correlate cover create database ' +
	            'dataset datastore declare decrement delete derived desc describe distinct do drop each element ' +
	            'else end every except exclude execute exists explain fetch first flatten for force from ' +
	            'function grant group gsi having if ignore ilike in include increment index infer inline inner ' +
	            'insert intersect into is join key keys keyspace known last left let letting like limit lsm map ' +
	            'mapping matched materialized merge minus namespace nest not number object offset on ' +
	            'option or order outer over parse partition password path pool prepare primary private privilege ' +
	            'procedure public raw realm reduce rename return returning revoke right role rollback satisfies ' +
	            'schema select self semi set show some start statistics string system then to transaction trigger ' +
	            'truncate under union unique unknown unnest unset update upsert use user using validate value ' +
	            'valued values via view when where while with within work xor',
	          // Taken from http://developer.couchbase.com/documentation/server/4.5/n1ql/n1ql-language-reference/literals.html
	          literal:
	            'true false null missing|5',
	          // Taken from http://developer.couchbase.com/documentation/server/4.5/n1ql/n1ql-language-reference/functions.html
	          built_in:
	            'array_agg array_append array_concat array_contains array_count array_distinct array_ifnull array_length ' +
	            'array_max array_min array_position array_prepend array_put array_range array_remove array_repeat array_replace ' +
	            'array_reverse array_sort array_sum avg count max min sum greatest least ifmissing ifmissingornull ifnull ' +
	            'missingif nullif ifinf ifnan ifnanorinf naninf neginfif posinfif clock_millis clock_str date_add_millis ' +
	            'date_add_str date_diff_millis date_diff_str date_part_millis date_part_str date_trunc_millis date_trunc_str ' +
	            'duration_to_str millis str_to_millis millis_to_str millis_to_utc millis_to_zone_name now_millis now_str ' +
	            'str_to_duration str_to_utc str_to_zone_name decode_json encode_json encoded_size poly_length base64 base64_encode ' +
	            'base64_decode meta uuid abs acos asin atan atan2 ceil cos degrees e exp ln log floor pi power radians random ' +
	            'round sign sin sqrt tan trunc object_length object_names object_pairs object_inner_pairs object_values ' +
	            'object_inner_values object_add object_put object_remove object_unwrap regexp_contains regexp_like regexp_position ' +
	            'regexp_replace contains initcap length lower ltrim position repeat replace rtrim split substr title trim upper ' +
	            'isarray isatom isboolean isnumber isobject isstring type toarray toatom toboolean tonumber toobject tostring'
	        },
	        contains: [
	          {
	            className: 'string',
	            begin: '\'', end: '\'',
	            contains: [hljs.BACKSLASH_ESCAPE],
	            relevance: 0
	          },
	          {
	            className: 'string',
	            begin: '"', end: '"',
	            contains: [hljs.BACKSLASH_ESCAPE],
	            relevance: 0
	          },
	          {
	            className: 'symbol',
	            begin: '`', end: '`',
	            contains: [hljs.BACKSLASH_ESCAPE],
	            relevance: 2
	          },
	          hljs.C_NUMBER_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      hljs.C_BLOCK_COMMENT_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/nginx.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VAR = {
	    className: 'variable',
	    variants: [
	      {begin: /\$\d+/},
	      {begin: /\$\{/, end: /}/},
	      {begin: '[\\$\\@]' + hljs.UNDERSCORE_IDENT_RE}
	    ]
	  };
	  var DEFAULT = {
	    endsWithParent: true,
	    lexemes: '[a-z/_]+',
	    keywords: {
	      literal:
	        'on off yes no true false none blocked debug info notice warn error crit ' +
	        'select break last permanent redirect kqueue rtsig epoll poll /dev/poll'
	    },
	    relevance: 0,
	    illegal: '=>',
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'string',
	        contains: [hljs.BACKSLASH_ESCAPE, VAR],
	        variants: [
	          {begin: /"/, end: /"/},
	          {begin: /'/, end: /'/}
	        ]
	      },
	      // this swallows entire URLs to avoid detecting numbers within
	      {
	        begin: '([a-z]+):/', end: '\\s', endsWithParent: true, excludeEnd: true,
	        contains: [VAR]
	      },
	      {
	        className: 'regexp',
	        contains: [hljs.BACKSLASH_ESCAPE, VAR],
	        variants: [
	          {begin: "\\s\\^", end: "\\s|{|;", returnEnd: true},
	          // regexp locations (~, ~*)
	          {begin: "~\\*?\\s+", end: "\\s|{|;", returnEnd: true},
	          // *.example.com
	          {begin: "\\*(\\.[a-z\\-]+)+"},
	          // sub.example.*
	          {begin: "([a-z\\-]+\\.)+\\*"}
	        ]
	      },
	      // IP
	      {
	        className: 'number',
	        begin: '\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b'
	      },
	      // units
	      {
	        className: 'number',
	        begin: '\\b\\d+[kKmMgGdshdwy]*\\b',
	        relevance: 0
	      },
	      VAR
	    ]
	  };
	
	  return {
	    aliases: ['nginxconf'],
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        begin: hljs.UNDERSCORE_IDENT_RE + '\\s+{', returnBegin: true,
	        end: '{',
	        contains: [
	          {
	            className: 'section',
	            begin: hljs.UNDERSCORE_IDENT_RE
	          }
	        ],
	        relevance: 0
	      },
	      {
	        begin: hljs.UNDERSCORE_IDENT_RE + '\\s', end: ';|{', returnBegin: true,
	        contains: [
	          {
	            className: 'attribute',
	            begin: hljs.UNDERSCORE_IDENT_RE,
	            starts: DEFAULT
	          }
	        ],
	        relevance: 0
	      }
	    ],
	    illegal: '[^\\s\\}]'
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/nimrod.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['nim'],
	    keywords: {
	      keyword:
	        'addr and as asm bind block break case cast const continue converter ' +
	        'discard distinct div do elif else end enum except export finally ' +
	        'for from generic if import in include interface is isnot iterator ' +
	        'let macro method mixin mod nil not notin object of or out proc ptr ' +
	        'raise ref return shl shr static template try tuple type using var ' +
	        'when while with without xor yield',
	      literal:
	        'shared guarded stdin stdout stderr result true false',
	      built_in:
	        'int int8 int16 int32 int64 uint uint8 uint16 uint32 uint64 float ' +
	        'float32 float64 bool char string cstring pointer expr stmt void ' +
	        'auto any range array openarray varargs seq set clong culong cchar ' +
	        'cschar cshort cint csize clonglong cfloat cdouble clongdouble ' +
	        'cuchar cushort cuint culonglong cstringarray semistatic'
	    },
	    contains: [ {
	        className: 'meta', // Actually pragma
	        begin: /{\./,
	        end: /\.}/,
	        relevance: 10
	      }, {
	        className: 'string',
	        begin: /[a-zA-Z]\w*"/,
	        end: /"/,
	        contains: [{begin: /""/}]
	      }, {
	        className: 'string',
	        begin: /([a-zA-Z]\w*)?"""/,
	        end: /"""/
	      },
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'type',
	        begin: /\b[A-Z]\w+\b/,
	        relevance: 0
	      }, {
	        className: 'number',
	        relevance: 0,
	        variants: [
	          {begin: /\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/},
	          {begin: /\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/},
	          {begin: /\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/},
	          {begin: /\b(\d[_\d]*)('?[iIuUfF](8|16|32|64))?/}
	        ]
	      },
	      hljs.HASH_COMMENT_MODE
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/nix.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var NIX_KEYWORDS = {
	    keyword:
	      'rec with let in inherit assert if else then',
	    literal:
	      'true false or and null',
	    built_in:
	      'import abort baseNameOf dirOf isNull builtins map removeAttrs throw ' +
	      'toString derivation'
	  };
	  var ANTIQUOTE = {
	    className: 'subst',
	    begin: /\$\{/,
	    end: /}/,
	    keywords: NIX_KEYWORDS
	  };
	  var ATTRS = {
	    begin: /[a-zA-Z0-9-_]+(\s*=)/, returnBegin: true,
	    relevance: 0,
	    contains: [
	      {
	        className: 'attr',
	        begin: /\S+/
	      }
	    ]
	  };
	  var STRING = {
	    className: 'string',
	    contains: [ANTIQUOTE],
	    variants: [
	      {begin: "''", end: "''"},
	      {begin: '"', end: '"'}
	    ]
	  };
	  var EXPRESSIONS = [
	    hljs.NUMBER_MODE,
	    hljs.HASH_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    STRING,
	    ATTRS
	  ];
	  ANTIQUOTE.contains = EXPRESSIONS;
	  return {
	    aliases: ["nixos"],
	    keywords: NIX_KEYWORDS,
	    contains: EXPRESSIONS
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/nsis.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var CONSTANTS = {
	    className: 'variable',
	    begin: /\$(ADMINTOOLS|APPDATA|CDBURN_AREA|CMDLINE|COMMONFILES32|COMMONFILES64|COMMONFILES|COOKIES|DESKTOP|DOCUMENTS|EXEDIR|EXEFILE|EXEPATH|FAVORITES|FONTS|HISTORY|HWNDPARENT|INSTDIR|INTERNET_CACHE|LANGUAGE|LOCALAPPDATA|MUSIC|NETHOOD|OUTDIR|PICTURES|PLUGINSDIR|PRINTHOOD|PROFILE|PROGRAMFILES32|PROGRAMFILES64|PROGRAMFILES|QUICKLAUNCH|RECENT|RESOURCES_LOCALIZED|RESOURCES|SENDTO|SMPROGRAMS|SMSTARTUP|STARTMENU|SYSDIR|TEMP|TEMPLATES|VIDEOS|WINDIR)/
	  };
	
	  var DEFINES = {
	    // ${defines}
	    className: 'variable',
	    begin: /\$+{[\w\.:-]+}/
	  };
	
	  var VARIABLES = {
	    // $variables
	    className: 'variable',
	    begin: /\$+\w+/,
	    illegal: /\(\){}/
	  };
	
	  var LANGUAGES = {
	    // $(language_strings)
	    className: 'variable',
	    begin: /\$+\([\w\^\.:-]+\)/
	  };
	
	  var PARAMETERS = {
	    // command parameters
	    className: 'params',
	    begin: '(ARCHIVE|FILE_ATTRIBUTE_ARCHIVE|FILE_ATTRIBUTE_NORMAL|FILE_ATTRIBUTE_OFFLINE|FILE_ATTRIBUTE_READONLY|FILE_ATTRIBUTE_SYSTEM|FILE_ATTRIBUTE_TEMPORARY|HKCR|HKCU|HKDD|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_DYN_DATA|HKEY_LOCAL_MACHINE|HKEY_PERFORMANCE_DATA|HKEY_USERS|HKLM|HKPD|HKU|IDABORT|IDCANCEL|IDIGNORE|IDNO|IDOK|IDRETRY|IDYES|MB_ABORTRETRYIGNORE|MB_DEFBUTTON1|MB_DEFBUTTON2|MB_DEFBUTTON3|MB_DEFBUTTON4|MB_ICONEXCLAMATION|MB_ICONINFORMATION|MB_ICONQUESTION|MB_ICONSTOP|MB_OK|MB_OKCANCEL|MB_RETRYCANCEL|MB_RIGHT|MB_RTLREADING|MB_SETFOREGROUND|MB_TOPMOST|MB_USERICON|MB_YESNO|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY)'
	  };
	
	  var COMPILER = {
	    // !compiler_flags
	    className: 'keyword',
	    begin: /\!(addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversionsystem|ifdef|ifmacrodef|ifmacrondef|ifndef|if|include|insertmacro|macroend|macro|makensis|packhdr|searchparse|searchreplace|tempfile|undef|verbose|warning)/
	  };
	
	  var METACHARS = {
	    // $\n, $\r, $\t, $$
	    className: 'subst',
	    begin: /\$(\\[nrt]|\$)/
	  };
	
	  var PLUGINS = {
	    // plug::ins
	    className: 'class',
	    begin: /\w+\:\:\w+/
	  };
	
	    var STRING = {
	      className: 'string',
	      variants: [
	        {
	          begin: '"', end: '"'
	        },
	        {
	          begin: '\'', end: '\''
	        },
	        {
	          begin: '`', end: '`'
	        }
	      ],
	      illegal: /\n/,
	      contains: [
	        METACHARS,
	        CONSTANTS,
	        DEFINES,
	        VARIABLES,
	        LANGUAGES
	      ]
	  };
	
	  return {
	    case_insensitive: false,
	    keywords: {
	      keyword:
	      'Abort AddBrandingImage AddSize AllowRootDirInstall AllowSkipFiles AutoCloseWindow BGFont BGGradient BrandingText BringToFront Call CallInstDLL Caption ChangeUI CheckBitmap ClearErrors CompletedText ComponentText CopyFiles CRCCheck CreateDirectory CreateFont CreateShortCut Delete DeleteINISec DeleteINIStr DeleteRegKey DeleteRegValue DetailPrint DetailsButtonText DirText DirVar DirVerify EnableWindow EnumRegKey EnumRegValue Exch Exec ExecShell ExecWait ExpandEnvStrings File FileBufSize FileClose FileErrorText FileOpen FileRead FileReadByte FileReadUTF16LE FileReadWord FileSeek FileWrite FileWriteByte FileWriteUTF16LE FileWriteWord FindClose FindFirst FindNext FindWindow FlushINI FunctionEnd GetCurInstType GetCurrentAddress GetDlgItem GetDLLVersion GetDLLVersionLocal GetErrorLevel GetFileTime GetFileTimeLocal GetFullPathName GetFunctionAddress GetInstDirError GetLabelAddress GetTempFileName Goto HideWindow Icon IfAbort IfErrors IfFileExists IfRebootFlag IfSilent InitPluginsDir InstallButtonText InstallColors InstallDir InstallDirRegKey InstProgressFlags InstType InstTypeGetText InstTypeSetText IntCmp IntCmpU IntFmt IntOp IsWindow LangString LicenseBkColor LicenseData LicenseForceSelection LicenseLangString LicenseText LoadLanguageFile LockWindow LogSet LogText ManifestDPIAware ManifestSupportedOS MessageBox MiscButtonText Name Nop OutFile Page PageCallbacks PageExEnd Pop Push Quit ReadEnvStr ReadINIStr ReadRegDWORD ReadRegStr Reboot RegDLL Rename RequestExecutionLevel ReserveFile Return RMDir SearchPath SectionEnd SectionGetFlags SectionGetInstTypes SectionGetSize SectionGetText SectionGroupEnd SectionIn SectionSetFlags SectionSetInstTypes SectionSetSize SectionSetText SendMessage SetAutoClose SetBrandingImage SetCompress SetCompressor SetCompressorDictSize SetCtlColors SetCurInstType SetDatablockOptimize SetDateSave SetDetailsPrint SetDetailsView SetErrorLevel SetErrors SetFileAttributes SetFont SetOutPath SetOverwrite SetRebootFlag SetRegView SetShellVarContext SetSilent ShowInstDetails ShowUninstDetails ShowWindow SilentInstall SilentUnInstall Sleep SpaceTexts StrCmp StrCmpS StrCpy StrLen SubCaption Unicode UninstallButtonText UninstallCaption UninstallIcon UninstallSubCaption UninstallText UninstPage UnRegDLL Var VIAddVersionKey VIFileVersion VIProductVersion WindowIcon WriteINIStr WriteRegBin WriteRegDWORD WriteRegExpandStr WriteRegStr WriteUninstaller XPStyle',
	      literal:
	      'admin all auto both bottom bzip2 colored components current custom directory false force hide highest ifdiff ifnewer instfiles lastused leave left license listonly lzma nevershow none normal notset off on open print right show silent silentlog smooth textonly top true try un.components un.custom un.directory un.instfiles un.license uninstConfirm user Win10 Win7 Win8 WinVista zlib'
	    },
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.COMMENT(
	        ';',
	        '$',
	        {
	          relevance: 0
	        }
	      ),
	      {
	        className: 'function',
	        beginKeywords: 'Function PageEx Section SectionGroup', end: '$'
	      },
	      STRING,
	      COMPILER,
	      DEFINES,
	      VARIABLES,
	      LANGUAGES,
	      PARAMETERS,
	      PLUGINS,
	      hljs.NUMBER_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/objectivec.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var API_CLASS = {
	    className: 'built_in',
	    begin: '\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+',
	  };
	  var OBJC_KEYWORDS = {
	    keyword:
	      'int float while char export sizeof typedef const struct for union ' +
	      'unsigned long volatile static bool mutable if do return goto void ' +
	      'enum else break extern asm case short default double register explicit ' +
	      'signed typename this switch continue wchar_t inline readonly assign ' +
	      'readwrite self @synchronized id typeof ' +
	      'nonatomic super unichar IBOutlet IBAction strong weak copy ' +
	      'in out inout bycopy byref oneway __strong __weak __block __autoreleasing ' +
	      '@private @protected @public @try @property @end @throw @catch @finally ' +
	      '@autoreleasepool @synthesize @dynamic @selector @optional @required ' +
	      '@encode @package @import @defs @compatibility_alias ' +
	      '__bridge __bridge_transfer __bridge_retained __bridge_retain ' +
	      '__covariant __contravariant __kindof ' +
	      '_Nonnull _Nullable _Null_unspecified ' +
	      '__FUNCTION__ __PRETTY_FUNCTION__ __attribute__ ' +
	      'getter setter retain unsafe_unretained ' +
	      'nonnull nullable null_unspecified null_resettable class instancetype ' +
	      'NS_DESIGNATED_INITIALIZER NS_UNAVAILABLE NS_REQUIRES_SUPER ' +
	      'NS_RETURNS_INNER_POINTER NS_INLINE NS_AVAILABLE NS_DEPRECATED ' +
	      'NS_ENUM NS_OPTIONS NS_SWIFT_UNAVAILABLE ' +
	      'NS_ASSUME_NONNULL_BEGIN NS_ASSUME_NONNULL_END ' +
	      'NS_REFINED_FOR_SWIFT NS_SWIFT_NAME NS_SWIFT_NOTHROW ' +
	      'NS_DURING NS_HANDLER NS_ENDHANDLER NS_VALUERETURN NS_VOIDRETURN',
	    literal:
	      'false true FALSE TRUE nil YES NO NULL',
	    built_in:
	      'BOOL dispatch_once_t dispatch_queue_t dispatch_sync dispatch_async dispatch_once'
	  };
	  var LEXEMES = /[a-zA-Z@][a-zA-Z0-9_]*/;
	  var CLASS_KEYWORDS = '@interface @class @protocol @implementation';
	  return {
	    aliases: ['mm', 'objc', 'obj-c'],
	    keywords: OBJC_KEYWORDS,
	    lexemes: LEXEMES,
	    illegal: '</',
	    contains: [
	      API_CLASS,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        variants: [
	          {
	            begin: '@"', end: '"',
	            illegal: '\\n',
	            contains: [hljs.BACKSLASH_ESCAPE]
	          },
	          {
	            begin: '\'', end: '[^\\\\]\'',
	            illegal: '[^\\\\][^\']'
	          }
	        ]
	      },
	      {
	        className: 'meta',
	        begin: '#',
	        end: '$',
	        contains: [
	          {
	            className: 'meta-string',
	            variants: [
	              { begin: '\"', end: '\"' },
	              { begin: '<', end: '>' }
	            ]
	          }
	        ]
	      },
	      {
	        className: 'class',
	        begin: '(' + CLASS_KEYWORDS.split(' ').join('|') + ')\\b', end: '({|$)', excludeEnd: true,
	        keywords: CLASS_KEYWORDS, lexemes: LEXEMES,
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        begin: '\\.'+hljs.UNDERSCORE_IDENT_RE,
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/ocaml.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  /* missing support for heredoc-like string (OCaml 4.0.2+) */
	  return {
	    aliases: ['ml'],
	    keywords: {
	      keyword:
	        'and as assert asr begin class constraint do done downto else end ' +
	        'exception external for fun function functor if in include ' +
	        'inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method ' +
	        'mod module mutable new object of open! open or private rec sig struct ' +
	        'then to try type val! val virtual when while with ' +
	        /* camlp4 */
	        'parser value',
	      built_in:
	        /* built-in types */
	        'array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit ' +
	        /* (some) types in Pervasives */
	        'in_channel out_channel ref',
	      literal:
	        'true false'
	    },
	    illegal: /\/\/|>>/,
	    lexemes: '[a-z_]\\w*!?',
	    contains: [
	      {
	        className: 'literal',
	        begin: '\\[(\\|\\|)?\\]|\\(\\)',
	        relevance: 0
	      },
	      hljs.COMMENT(
	        '\\(\\*',
	        '\\*\\)',
	        {
	          contains: ['self']
	        }
	      ),
	      { /* type variable */
	        className: 'symbol',
	        begin: '\'[A-Za-z_](?!\')[\\w\']*'
	        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
	      },
	      { /* polymorphic variant */
	        className: 'type',
	        begin: '`[A-Z][\\w\']*'
	      },
	      { /* module or constructor */
	        className: 'type',
	        begin: '\\b[A-Z][\\w\']*',
	        relevance: 0
	      },
	      { /* don't color identifiers, but safely catch all identifiers with '*/
	        begin: '[a-z_]\\w*\'[\\w\']*', relevance: 0
	      },
	      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	      {
	        className: 'number',
	        begin:
	          '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' +
	          '0[oO][0-7_]+[Lln]?|' +
	          '0[bB][01_]+[Lln]?|' +
	          '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)',
	        relevance: 0
	      },
	      {
	        begin: /[-=]>/ // relevance booster
	      }
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/openscad.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
		var SPECIAL_VARS = {
			className: 'keyword',
			begin: '\\$(f[asn]|t|vp[rtd]|children)'
		},
		LITERALS = {
			className: 'literal',
			begin: 'false|true|PI|undef'
		},
		NUMBERS = {
			className: 'number',
			begin: '\\b\\d+(\\.\\d+)?(e-?\\d+)?', //adds 1e5, 1e-10
			relevance: 0
		},
		STRING = hljs.inherit(hljs.QUOTE_STRING_MODE,{illegal: null}),
		PREPRO = {
			className: 'meta',
			keywords: {'meta-keyword': 'include use'},
			begin: 'include|use <',
			end: '>'
		},
		PARAMS = {
			className: 'params',
			begin: '\\(', end: '\\)',
			contains: ['self', NUMBERS, STRING, SPECIAL_VARS, LITERALS]
		},
		MODIFIERS = {
			begin: '[*!#%]',
			relevance: 0
		},
		FUNCTIONS = {
			className: 'function',
			beginKeywords: 'module function',
			end: '\\=|\\{',
			contains: [PARAMS, hljs.UNDERSCORE_TITLE_MODE]
		};
	
		return {
			aliases: ['scad'],
			keywords: {
				keyword: 'function module include use for intersection_for if else \\%',
				literal: 'false true PI undef',
				built_in: 'circle square polygon text sphere cube cylinder polyhedron translate rotate scale resize mirror multmatrix color offset hull minkowski union difference intersection abs sign sin cos tan acos asin atan atan2 floor round ceil ln log pow sqrt exp rands min max concat lookup str chr search version version_num norm cross parent_module echo import import_dxf dxf_linear_extrude linear_extrude rotate_extrude surface projection render children dxf_cross dxf_dim let assign'
			},
			contains: [
				hljs.C_LINE_COMMENT_MODE,
				hljs.C_BLOCK_COMMENT_MODE,
				NUMBERS,
				PREPRO,
				STRING,
				SPECIAL_VARS,
				MODIFIERS,
				FUNCTIONS
			]
		}
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/oxygene.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var OXYGENE_KEYWORDS = 'abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue '+
	    'create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false '+
	    'final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited '+
	    'inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of '+
	    'old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly '+
	    'record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple '+
	    'type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal '+
	    'register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained';
	  var CURLY_COMMENT =  hljs.COMMENT(
	    '{',
	    '}',
	    {
	      relevance: 0
	    }
	  );
	  var PAREN_COMMENT = hljs.COMMENT(
	    '\\(\\*',
	    '\\*\\)',
	    {
	      relevance: 10
	    }
	  );
	  var STRING = {
	    className: 'string',
	    begin: '\'', end: '\'',
	    contains: [{begin: '\'\''}]
	  };
	  var CHAR_STRING = {
	    className: 'string', begin: '(#\\d+)+'
	  };
	  var FUNCTION = {
	    className: 'function',
	    beginKeywords: 'function constructor destructor procedure method', end: '[:;]',
	    keywords: 'function constructor|10 destructor|10 procedure|10 method|10',
	    contains: [
	      hljs.TITLE_MODE,
	      {
	        className: 'params',
	        begin: '\\(', end: '\\)',
	        keywords: OXYGENE_KEYWORDS,
	        contains: [STRING, CHAR_STRING]
	      },
	      CURLY_COMMENT, PAREN_COMMENT
	    ]
	  };
	  return {
	    case_insensitive: true,
	    lexemes: /\.?\w+/,
	    keywords: OXYGENE_KEYWORDS,
	    illegal: '("|\\$[G-Zg-z]|\\/\\*|</|=>|->)',
	    contains: [
	      CURLY_COMMENT, PAREN_COMMENT, hljs.C_LINE_COMMENT_MODE,
	      STRING, CHAR_STRING,
	      hljs.NUMBER_MODE,
	      FUNCTION,
	      {
	        className: 'class',
	        begin: '=\\bclass\\b', end: 'end;',
	        keywords: OXYGENE_KEYWORDS,
	        contains: [
	          STRING, CHAR_STRING,
	          CURLY_COMMENT, PAREN_COMMENT, hljs.C_LINE_COMMENT_MODE,
	          FUNCTION
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/parser3.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var CURLY_SUBCOMMENT = hljs.COMMENT(
	    '{',
	    '}',
	    {
	      contains: ['self']
	    }
	  );
	  return {
	    subLanguage: 'xml', relevance: 0,
	    contains: [
	      hljs.COMMENT('^#', '$'),
	      hljs.COMMENT(
	        '\\^rem{',
	        '}',
	        {
	          relevance: 10,
	          contains: [
	            CURLY_SUBCOMMENT
	          ]
	        }
	      ),
	      {
	        className: 'meta',
	        begin: '^@(?:BASE|USE|CLASS|OPTIONS)$',
	        relevance: 10
	      },
	      {
	        className: 'title',
	        begin: '@[\\w\\-]+\\[[\\w^;\\-]*\\](?:\\[[\\w^;\\-]*\\])?(?:.*)$'
	      },
	      {
	        className: 'variable',
	        begin: '\\$\\{?[\\w\\-\\.\\:]+\\}?'
	      },
	      {
	        className: 'keyword',
	        begin: '\\^[\\w\\-\\.\\:]+'
	      },
	      {
	        className: 'number',
	        begin: '\\^#[0-9a-fA-F]+'
	      },
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/perl.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var PERL_KEYWORDS = 'getpwent getservent quotemeta msgrcv scalar kill dbmclose undef lc ' +
	    'ma syswrite tr send umask sysopen shmwrite vec qx utime local oct semctl localtime ' +
	    'readpipe do return format read sprintf dbmopen pop getpgrp not getpwnam rewinddir qq' +
	    'fileno qw endprotoent wait sethostent bless s|0 opendir continue each sleep endgrent ' +
	    'shutdown dump chomp connect getsockname die socketpair close flock exists index shmget' +
	    'sub for endpwent redo lstat msgctl setpgrp abs exit select print ref gethostbyaddr ' +
	    'unshift fcntl syscall goto getnetbyaddr join gmtime symlink semget splice x|0 ' +
	    'getpeername recv log setsockopt cos last reverse gethostbyname getgrnam study formline ' +
	    'endhostent times chop length gethostent getnetent pack getprotoent getservbyname rand ' +
	    'mkdir pos chmod y|0 substr endnetent printf next open msgsnd readdir use unlink ' +
	    'getsockopt getpriority rindex wantarray hex system getservbyport endservent int chr ' +
	    'untie rmdir prototype tell listen fork shmread ucfirst setprotoent else sysseek link ' +
	    'getgrgid shmctl waitpid unpack getnetbyname reset chdir grep split require caller ' +
	    'lcfirst until warn while values shift telldir getpwuid my getprotobynumber delete and ' +
	    'sort uc defined srand accept package seekdir getprotobyname semop our rename seek if q|0 ' +
	    'chroot sysread setpwent no crypt getc chown sqrt write setnetent setpriority foreach ' +
	    'tie sin msgget map stat getlogin unless elsif truncate exec keys glob tied closedir' +
	    'ioctl socket readlink eval xor readline binmode setservent eof ord bind alarm pipe ' +
	    'atan2 getgrent exp time push setgrent gt lt or ne m|0 break given say state when';
	  var SUBST = {
	    className: 'subst',
	    begin: '[$@]\\{', end: '\\}',
	    keywords: PERL_KEYWORDS
	  };
	  var METHOD = {
	    begin: '->{', end: '}'
	    // contains defined later
	  };
	  var VAR = {
	    variants: [
	      {begin: /\$\d/},
	      {begin: /[\$%@](\^\w\b|#\w+(::\w+)*|{\w+}|\w+(::\w*)*)/},
	      {begin: /[\$%@][^\s\w{]/, relevance: 0}
	    ]
	  };
	  var STRING_CONTAINS = [hljs.BACKSLASH_ESCAPE, SUBST, VAR];
	  var PERL_DEFAULT_CONTAINS = [
	    VAR,
	    hljs.HASH_COMMENT_MODE,
	    hljs.COMMENT(
	      '^\\=\\w',
	      '\\=cut',
	      {
	        endsWithParent: true
	      }
	    ),
	    METHOD,
	    {
	      className: 'string',
	      contains: STRING_CONTAINS,
	      variants: [
	        {
	          begin: 'q[qwxr]?\\s*\\(', end: '\\)',
	          relevance: 5
	        },
	        {
	          begin: 'q[qwxr]?\\s*\\[', end: '\\]',
	          relevance: 5
	        },
	        {
	          begin: 'q[qwxr]?\\s*\\{', end: '\\}',
	          relevance: 5
	        },
	        {
	          begin: 'q[qwxr]?\\s*\\|', end: '\\|',
	          relevance: 5
	        },
	        {
	          begin: 'q[qwxr]?\\s*\\<', end: '\\>',
	          relevance: 5
	        },
	        {
	          begin: 'qw\\s+q', end: 'q',
	          relevance: 5
	        },
	        {
	          begin: '\'', end: '\'',
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: '"', end: '"'
	        },
	        {
	          begin: '`', end: '`',
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: '{\\w+}',
	          contains: [],
	          relevance: 0
	        },
	        {
	          begin: '\-?\\w+\\s*\\=\\>',
	          contains: [],
	          relevance: 0
	        }
	      ]
	    },
	    {
	      className: 'number',
	      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	      relevance: 0
	    },
	    { // regexp container
	      begin: '(\\/\\/|' + hljs.RE_STARTERS_RE + '|\\b(split|return|print|reverse|grep)\\b)\\s*',
	      keywords: 'split return print reverse grep',
	      relevance: 0,
	      contains: [
	        hljs.HASH_COMMENT_MODE,
	        {
	          className: 'regexp',
	          begin: '(s|tr|y)/(\\\\.|[^/])*/(\\\\.|[^/])*/[a-z]*',
	          relevance: 10
	        },
	        {
	          className: 'regexp',
	          begin: '(m|qr)?/', end: '/[a-z]*',
	          contains: [hljs.BACKSLASH_ESCAPE],
	          relevance: 0 // allows empty "//" which is a common comment delimiter in other languages
	        }
	      ]
	    },
	    {
	      className: 'function',
	      beginKeywords: 'sub', end: '(\\s*\\(.*?\\))?[;{]', excludeEnd: true,
	      relevance: 5,
	      contains: [hljs.TITLE_MODE]
	    },
	    {
	      begin: '-\\w\\b',
	      relevance: 0
	    },
	    {
	      begin: "^__DATA__$",
	      end: "^__END__$",
	      subLanguage: 'mojolicious',
	      contains: [
	        {
	            begin: "^@@.*",
	            end: "$",
	            className: "comment"
	        }
	      ]
	    }
	  ];
	  SUBST.contains = PERL_DEFAULT_CONTAINS;
	  METHOD.contains = PERL_DEFAULT_CONTAINS;
	
	  return {
	    aliases: ['pl', 'pm'],
	    lexemes: /[\w\.]+/,
	    keywords: PERL_KEYWORDS,
	    contains: PERL_DEFAULT_CONTAINS
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/pf.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var MACRO = {
	    className: 'variable',
	    begin: /\$[\w\d#@][\w\d_]*/
	  };
	  var TABLE = {
	    className: 'variable',
	    begin: /<(?!\/)/, end: />/
	  };
	  var QUOTE_STRING = {
	    className: 'string',
	    begin: /"/, end: /"/
	  };
	
	  return {
	    aliases: ['pf.conf'],
	    lexemes: /[a-z0-9_<>-]+/,
	    keywords: {
	      built_in: /* block match pass are "actions" in pf.conf(5), the rest are
	                 * lexically similar top-level commands.
	                 */
	        'block match pass load anchor|5 antispoof|10 set table',
	      keyword:
	        'in out log quick on rdomain inet inet6 proto from port os to route' +
	        'allow-opts divert-packet divert-reply divert-to flags group icmp-type' +
	        'icmp6-type label once probability recieved-on rtable prio queue' +
	        'tos tag tagged user keep fragment for os drop' +
	        'af-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robin' +
	        'source-hash static-port' +
	        'dup-to reply-to route-to' +
	        'parent bandwidth default min max qlimit' +
	        'block-policy debug fingerprints hostid limit loginterface optimization' +
	        'reassemble ruleset-optimization basic none profile skip state-defaults' +
	        'state-policy timeout' +
	        'const counters persist' +
	        'no modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppy' +
	        'source-track global rule max-src-nodes max-src-states max-src-conn' +
	        'max-src-conn-rate overload flush' +
	        'scrub|5 max-mss min-ttl no-df|10 random-id',
	      literal:
	        'all any no-route self urpf-failed egress|5 unknown'
	    },
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.NUMBER_MODE,
	      hljs.QUOTE_STRING_MODE,
	      MACRO,
	      TABLE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/php.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VARIABLE = {
	    begin: '\\$+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*'
	  };
	  var PREPROCESSOR = {
	    className: 'meta', begin: /<\?(php)?|\?>/
	  };
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, PREPROCESSOR],
	    variants: [
	      {
	        begin: 'b"', end: '"'
	      },
	      {
	        begin: 'b\'', end: '\''
	      },
	      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
	    ]
	  };
	  var NUMBER = {variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]};
	  return {
	    aliases: ['php3', 'php4', 'php5', 'php6'],
	    case_insensitive: true,
	    keywords:
	      'and include_once list abstract global private echo interface as static endswitch ' +
	      'array null if endwhile or const for endforeach self var while isset public ' +
	      'protected exit foreach throw elseif include __FILE__ empty require_once do xor ' +
	      'return parent clone use __CLASS__ __LINE__ else break print eval new ' +
	      'catch __METHOD__ case exception default die require __FUNCTION__ ' +
	      'enddeclare final try switch continue endfor endif declare unset true false ' +
	      'trait goto instanceof insteadof __DIR__ __NAMESPACE__ ' +
	      'yield finally',
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.COMMENT('//', '$', {contains: [PREPROCESSOR]}),
	      hljs.COMMENT(
	        '/\\*',
	        '\\*/',
	        {
	          contains: [
	            {
	              className: 'doctag',
	              begin: '@[A-Za-z]+'
	            }
	          ]
	        }
	      ),
	      hljs.COMMENT(
	        '__halt_compiler.+?;',
	        false,
	        {
	          endsWithParent: true,
	          keywords: '__halt_compiler',
	          lexemes: hljs.UNDERSCORE_IDENT_RE
	        }
	      ),
	      {
	        className: 'string',
	        begin: /<<<['"]?\w+['"]?$/, end: /^\w+;?$/,
	        contains: [
	          hljs.BACKSLASH_ESCAPE,
	          {
	            className: 'subst',
	            variants: [
	              {begin: /\$\w+/},
	              {begin: /\{\$/, end: /\}/}
	            ]
	          }
	        ]
	      },
	      PREPROCESSOR,
	      {
	        className: 'keyword', begin: /\$this\b/
	      },
	      VARIABLE,
	      {
	        // swallow composed identifiers to avoid parsing them as keywords
	        begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: /[;{]/, excludeEnd: true,
	        illegal: '\\$|\\[|%',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)',
	            contains: [
	              'self',
	              VARIABLE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              STRING,
	              NUMBER
	            ]
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        illegal: /[:\(\$"]/,
	        contains: [
	          {beginKeywords: 'extends implements'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        beginKeywords: 'namespace', end: ';',
	        illegal: /[\.']/,
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        beginKeywords: 'use', end: ';',
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        begin: '=>' // No markup, just a relevance booster
	      },
	      STRING,
	      NUMBER
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/pony.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      'actor addressof and as be break class compile_error compile_intrinsic' +
	      'consume continue delegate digestof do else elseif embed end error' +
	      'for fun if ifdef in interface is isnt lambda let match new not object' +
	      'or primitive recover repeat return struct then trait try type until ' +
	      'use var where while with xor',
	    meta:
	      'iso val tag trn box ref',
	    literal:
	      'this false true'
	  };
	
	  var TRIPLE_QUOTE_STRING_MODE = {
	    className: 'string',
	    begin: '"""', end: '"""',
	    relevance: 10
	  };
	
	  var QUOTE_STRING_MODE = {
	    className: 'string',
	    begin: '"', end: '"',
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	
	  var SINGLE_QUOTE_CHAR_MODE = {
	    className: 'string',
	    begin: '\'', end: '\'',
	    contains: [hljs.BACKSLASH_ESCAPE],
	    relevance: 0
	  };
	
	  var TYPE_NAME = {
	    className: 'type',
	    begin: '\\b_?[A-Z][\\w]*',
	    relevance: 0
	  };
	
	  var PRIMED_NAME = {
	    begin: hljs.IDENT_RE + '\'', relevance: 0
	  };
	
	  var CLASS = {
	    className: 'class',
	    beginKeywords: 'class actor', end: '$',
	    contains: [
	      hljs.TITLE_MODE,
	      hljs.C_LINE_COMMENT_MODE
	    ]
	  }
	
	  var FUNCTION = {
	    className: 'function',
	    beginKeywords: 'new fun', end: '=>',
	    contains: [
	      hljs.TITLE_MODE,
	      {
	        begin: /\(/, end: /\)/,
	        contains: [
	          TYPE_NAME,
	          PRIMED_NAME,
	          hljs.C_NUMBER_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      {
	        begin: /:/, endsWithParent: true,
	        contains: [TYPE_NAME]
	      },
	      hljs.C_LINE_COMMENT_MODE
	    ]
	  }
	
	  return {
	    keywords: KEYWORDS,
	    contains: [
	      CLASS,
	      FUNCTION,
	      TYPE_NAME,
	      TRIPLE_QUOTE_STRING_MODE,
	      QUOTE_STRING_MODE,
	      SINGLE_QUOTE_CHAR_MODE,
	      PRIMED_NAME,
	      hljs.C_NUMBER_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/powershell.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var BACKTICK_ESCAPE = {
	    begin: '`[\\s\\S]',
	    relevance: 0
	  };
	  var VAR = {
	    className: 'variable',
	    variants: [
	      {begin: /\$[\w\d][\w\d_:]*/}
	    ]
	  };
	  var LITERAL = {
	    className: 'literal',
	    begin: /\$(null|true|false)\b/
	  };
	  var QUOTE_STRING = {
	    className: 'string',
	    variants: [
	      { begin: /"/, end: /"/ },
	      { begin: /@"/, end: /^"@/ }
	    ],
	    contains: [
	      BACKTICK_ESCAPE,
	      VAR,
	      {
	        className: 'variable',
	        begin: /\$[A-z]/, end: /[^A-z]/
	      }
	    ]
	  };
	  var APOS_STRING = {
	    className: 'string',
	    variants: [
	      { begin: /'/, end: /'/ },
	      { begin: /@'/, end: /^'@/ }
	    ]
	  };
	
	  var PS_HELPTAGS = {
	    className: 'doctag',
	    variants: [
	      /* no paramater help tags */ 
	      { begin: /\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/ },
	      /* one parameter help tags */
	      { begin: /\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/ }
	    ]
	  };
	  var PS_COMMENT = hljs.inherit(
	    hljs.COMMENT(null, null),
	    {
	      variants: [
	        /* single-line comment */
	        { begin: /#/, end: /$/ },
	        /* multi-line comment */
	        { begin: /<#/, end: /#>/ }
	      ],
	      contains: [PS_HELPTAGS]
	    }
	  );
	
	  return {
	    aliases: ['ps'],
	    lexemes: /-?[A-z\.\-]+/,
	    case_insensitive: true,
	    keywords: {
	      keyword: 'if else foreach return function do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch',
	      built_in: 'Add-Computer Add-Content Add-History Add-JobTrigger Add-Member Add-PSSnapin Add-Type Checkpoint-Computer Clear-Content Clear-EventLog Clear-History Clear-Host Clear-Item Clear-ItemProperty Clear-Variable Compare-Object Complete-Transaction Connect-PSSession Connect-WSMan Convert-Path ConvertFrom-Csv ConvertFrom-Json ConvertFrom-SecureString ConvertFrom-StringData ConvertTo-Csv ConvertTo-Html ConvertTo-Json ConvertTo-SecureString ConvertTo-Xml Copy-Item Copy-ItemProperty Debug-Process Disable-ComputerRestore Disable-JobTrigger Disable-PSBreakpoint Disable-PSRemoting Disable-PSSessionConfiguration Disable-WSManCredSSP Disconnect-PSSession Disconnect-WSMan Disable-ScheduledJob Enable-ComputerRestore Enable-JobTrigger Enable-PSBreakpoint Enable-PSRemoting Enable-PSSessionConfiguration Enable-ScheduledJob Enable-WSManCredSSP Enter-PSSession Exit-PSSession Export-Alias Export-Clixml Export-Console Export-Counter Export-Csv Export-FormatData Export-ModuleMember Export-PSSession ForEach-Object Format-Custom Format-List Format-Table Format-Wide Get-Acl Get-Alias Get-AuthenticodeSignature Get-ChildItem Get-Command Get-ComputerRestorePoint Get-Content Get-ControlPanelItem Get-Counter Get-Credential Get-Culture Get-Date Get-Event Get-EventLog Get-EventSubscriber Get-ExecutionPolicy Get-FormatData Get-Host Get-HotFix Get-Help Get-History Get-IseSnippet Get-Item Get-ItemProperty Get-Job Get-JobTrigger Get-Location Get-Member Get-Module Get-PfxCertificate Get-Process Get-PSBreakpoint Get-PSCallStack Get-PSDrive Get-PSProvider Get-PSSession Get-PSSessionConfiguration Get-PSSnapin Get-Random Get-ScheduledJob Get-ScheduledJobOption Get-Service Get-TraceSource Get-Transaction Get-TypeData Get-UICulture Get-Unique Get-Variable Get-Verb Get-WinEvent Get-WmiObject Get-WSManCredSSP Get-WSManInstance Group-Object Import-Alias Import-Clixml Import-Counter Import-Csv Import-IseSnippet Import-LocalizedData Import-PSSession Import-Module Invoke-AsWorkflow Invoke-Command Invoke-Expression Invoke-History Invoke-Item Invoke-RestMethod Invoke-WebRequest Invoke-WmiMethod Invoke-WSManAction Join-Path Limit-EventLog Measure-Command Measure-Object Move-Item Move-ItemProperty New-Alias New-Event New-EventLog New-IseSnippet New-Item New-ItemProperty New-JobTrigger New-Object New-Module New-ModuleManifest New-PSDrive New-PSSession New-PSSessionConfigurationFile New-PSSessionOption New-PSTransportOption New-PSWorkflowExecutionOption New-PSWorkflowSession New-ScheduledJobOption New-Service New-TimeSpan New-Variable New-WebServiceProxy New-WinEvent New-WSManInstance New-WSManSessionOption Out-Default Out-File Out-GridView Out-Host Out-Null Out-Printer Out-String Pop-Location Push-Location Read-Host Receive-Job Register-EngineEvent Register-ObjectEvent Register-PSSessionConfiguration Register-ScheduledJob Register-WmiEvent Remove-Computer Remove-Event Remove-EventLog Remove-Item Remove-ItemProperty Remove-Job Remove-JobTrigger Remove-Module Remove-PSBreakpoint Remove-PSDrive Remove-PSSession Remove-PSSnapin Remove-TypeData Remove-Variable Remove-WmiObject Remove-WSManInstance Rename-Computer Rename-Item Rename-ItemProperty Reset-ComputerMachinePassword Resolve-Path Restart-Computer Restart-Service Restore-Computer Resume-Job Resume-Service Save-Help Select-Object Select-String Select-Xml Send-MailMessage Set-Acl Set-Alias Set-AuthenticodeSignature Set-Content Set-Date Set-ExecutionPolicy Set-Item Set-ItemProperty Set-JobTrigger Set-Location Set-PSBreakpoint Set-PSDebug Set-PSSessionConfiguration Set-ScheduledJob Set-ScheduledJobOption Set-Service Set-StrictMode Set-TraceSource Set-Variable Set-WmiInstance Set-WSManInstance Set-WSManQuickConfig Show-Command Show-ControlPanelItem Show-EventLog Sort-Object Split-Path Start-Job Start-Process Start-Service Start-Sleep Start-Transaction Start-Transcript Stop-Computer Stop-Job Stop-Process Stop-Service Stop-Transcript Suspend-Job Suspend-Service Tee-Object Test-ComputerSecureChannel Test-Connection Test-ModuleManifest Test-Path Test-PSSessionConfigurationFile Trace-Command Unblock-File Undo-Transaction Unregister-Event Unregister-PSSessionConfiguration Unregister-ScheduledJob Update-FormatData Update-Help Update-List Update-TypeData Use-Transaction Wait-Event Wait-Job Wait-Process Where-Object Write-Debug Write-Error Write-EventLog Write-Host Write-Output Write-Progress Write-Verbose Write-Warning Add-MDTPersistentDrive Disable-MDTMonitorService Enable-MDTMonitorService Get-MDTDeploymentShareStatistics Get-MDTMonitorData Get-MDTOperatingSystemCatalog Get-MDTPersistentDrive Import-MDTApplication Import-MDTDriver Import-MDTOperatingSystem Import-MDTPackage Import-MDTTaskSequence New-MDTDatabase Remove-MDTMonitorData Remove-MDTPersistentDrive Restore-MDTPersistentDrive Set-MDTMonitorData Test-MDTDeploymentShare Test-MDTMonitorData Update-MDTDatabaseSchema Update-MDTDeploymentShare Update-MDTLinkedDS Update-MDTMedia Update-MDTMedia Add-VamtProductKey Export-VamtData Find-VamtManagedMachine Get-VamtConfirmationId Get-VamtProduct Get-VamtProductKey Import-VamtData Initialize-VamtData Install-VamtConfirmationId Install-VamtProductActivation Install-VamtProductKey Update-VamtProduct',
	      nomarkup: '-ne -eq -lt -gt -ge -le -not -like -notlike -match -notmatch -contains -notcontains -in -notin -replace'
	    },
	    contains: [
	      BACKTICK_ESCAPE,
	      hljs.NUMBER_MODE,
	      QUOTE_STRING,
	      APOS_STRING,
	      LITERAL,
	      VAR,
	      PS_COMMENT
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/processing.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      keyword: 'BufferedReader PVector PFont PImage PGraphics HashMap boolean byte char color ' +
	        'double float int long String Array FloatDict FloatList IntDict IntList JSONArray JSONObject ' +
	        'Object StringDict StringList Table TableRow XML ' +
	        // Java keywords
	        'false synchronized int abstract float private char boolean static null if const ' +
	        'for true while long throw strictfp finally protected import native final return void ' +
	        'enum else break transient new catch instanceof byte super volatile case assert short ' +
	        'package default double public try this switch continue throws protected public private',
	      literal: 'P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI',
	      title: 'setup draw',
	      built_in: 'displayHeight displayWidth mouseY mouseX mousePressed pmouseX pmouseY key ' +
	        'keyCode pixels focused frameCount frameRate height width ' +
	        'size createGraphics beginDraw createShape loadShape PShape arc ellipse line point ' +
	        'quad rect triangle bezier bezierDetail bezierPoint bezierTangent curve curveDetail curvePoint ' +
	        'curveTangent curveTightness shape shapeMode beginContour beginShape bezierVertex curveVertex ' +
	        'endContour endShape quadraticVertex vertex ellipseMode noSmooth rectMode smooth strokeCap ' +
	        'strokeJoin strokeWeight mouseClicked mouseDragged mouseMoved mousePressed mouseReleased ' +
	        'mouseWheel keyPressed keyPressedkeyReleased keyTyped print println save saveFrame day hour ' +
	        'millis minute month second year background clear colorMode fill noFill noStroke stroke alpha ' +
	        'blue brightness color green hue lerpColor red saturation modelX modelY modelZ screenX screenY ' +
	        'screenZ ambient emissive shininess specular add createImage beginCamera camera endCamera frustum ' +
	        'ortho perspective printCamera printProjection cursor frameRate noCursor exit loop noLoop popStyle ' +
	        'pushStyle redraw binary boolean byte char float hex int str unbinary unhex join match matchAll nf ' +
	        'nfc nfp nfs split splitTokens trim append arrayCopy concat expand reverse shorten sort splice subset ' +
	        'box sphere sphereDetail createInput createReader loadBytes loadJSONArray loadJSONObject loadStrings ' +
	        'loadTable loadXML open parseXML saveTable selectFolder selectInput beginRaw beginRecord createOutput ' +
	        'createWriter endRaw endRecord PrintWritersaveBytes saveJSONArray saveJSONObject saveStream saveStrings ' +
	        'saveXML selectOutput popMatrix printMatrix pushMatrix resetMatrix rotate rotateX rotateY rotateZ scale ' +
	        'shearX shearY translate ambientLight directionalLight lightFalloff lights lightSpecular noLights normal ' +
	        'pointLight spotLight image imageMode loadImage noTint requestImage tint texture textureMode textureWrap ' +
	        'blend copy filter get loadPixels set updatePixels blendMode loadShader PShaderresetShader shader createFont ' +
	        'loadFont text textFont textAlign textLeading textMode textSize textWidth textAscent textDescent abs ceil ' +
	        'constrain dist exp floor lerp log mag map max min norm pow round sq sqrt acos asin atan atan2 cos degrees ' +
	        'radians sin tan noise noiseDetail noiseSeed random randomGaussian randomSeed'
	    },
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/profile.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    contains: [
	      hljs.C_NUMBER_MODE,
	      {
	        begin: '[a-zA-Z_][\\da-zA-Z_]+\\.[\\da-zA-Z_]{1,3}', end: ':',
	        excludeEnd: true
	      },
	      {
	        begin: '(ncalls|tottime|cumtime)', end: '$',
	        keywords: 'ncalls tottime|10 cumtime|10 filename',
	        relevance: 10
	      },
	      {
	        begin: 'function calls', end: '$',
	        contains: [hljs.C_NUMBER_MODE],
	        relevance: 10
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: '\\(', end: '\\)$',
	        excludeBegin: true, excludeEnd: true,
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/prolog.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	
	  var ATOM = {
	
	    begin: /[a-z][A-Za-z0-9_]*/,
	    relevance: 0
	  };
	
	  var VAR = {
	
	    className: 'symbol',
	    variants: [
	      {begin: /[A-Z][a-zA-Z0-9_]*/},
	      {begin: /_[A-Za-z0-9_]*/},
	    ],
	    relevance: 0
	  };
	
	  var PARENTED = {
	
	    begin: /\(/,
	    end: /\)/,
	    relevance: 0
	  };
	
	  var LIST = {
	
	    begin: /\[/,
	    end: /\]/
	  };
	
	  var LINE_COMMENT = {
	
	    className: 'comment',
	    begin: /%/, end: /$/,
	    contains: [hljs.PHRASAL_WORDS_MODE]
	  };
	
	  var BACKTICK_STRING = {
	
	    className: 'string',
	    begin: /`/, end: /`/,
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	
	  var CHAR_CODE = {
	
	    className: 'string', // 0'a etc.
	    begin: /0\'(\\\'|.)/
	  };
	
	  var SPACE_CODE = {
	
	    className: 'string',
	    begin: /0\'\\s/ // 0'\s
	  };
	
	  var PRED_OP = { // relevance booster
	    begin: /:-/
	  };
	
	  var inner = [
	
	    ATOM,
	    VAR,
	    PARENTED,
	    PRED_OP,
	    LIST,
	    LINE_COMMENT,
	    hljs.C_BLOCK_COMMENT_MODE,
	    hljs.QUOTE_STRING_MODE,
	    hljs.APOS_STRING_MODE,
	    BACKTICK_STRING,
	    CHAR_CODE,
	    SPACE_CODE,
	    hljs.C_NUMBER_MODE
	  ];
	
	  PARENTED.contains = inner;
	  LIST.contains = inner;
	
	  return {
	    contains: inner.concat([
	      {begin: /\.$/} // relevance booster
	    ])
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/protobuf.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      keyword: 'package import option optional required repeated group',
	      built_in: 'double float int32 int64 uint32 uint64 sint32 sint64 ' +
	        'fixed32 fixed64 sfixed32 sfixed64 bool string bytes',
	      literal: 'true false'
	    },
	    contains: [
	      hljs.QUOTE_STRING_MODE,
	      hljs.NUMBER_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'message enum service', end: /\{/,
	        illegal: /\n/,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {
	            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
	          })
	        ]
	      },
	      {
	        className: 'function',
	        beginKeywords: 'rpc',
	        end: /;/, excludeEnd: true,
	        keywords: 'rpc returns'
	      },
	      {
	        begin: /^\s*[A-Z_]+/,
	        end: /\s*=/, excludeEnd: true
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/puppet.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	
	  var PUPPET_KEYWORDS = {
	    keyword:
	    /* language keywords */
	      'and case default else elsif false if in import enherits node or true undef unless main settings $string ',
	    literal:
	    /* metaparameters */
	      'alias audit before loglevel noop require subscribe tag ' +
	    /* normal attributes */
	      'owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check ' +
	      'en_address ip_address realname command environment hour monute month monthday special target weekday '+
	      'creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore ' +
	      'links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source ' +
	      'souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid '+
	      'ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel ' +
	      'native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options ' +
	      'device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use ' +
	      'message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform ' +
	      'responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running ' +
	      'start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age ' +
	      'password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled ' +
	      'enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist ' +
	      'priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey ' +
	      'sslverify mounted',
	    built_in:
	    /* core facts */
	      'architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers ' +
	      'domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces '+
	      'ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion ' +
	      'kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease ' +
	      'lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major ' +
	      'macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease '+
	      'operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion '+
	      'rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced '+
	      'selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime '+
	      'uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version'
	  };
	
	  var COMMENT = hljs.COMMENT('#', '$');
	
	  var IDENT_RE = '([A-Za-z_]|::)(\\w|::)*';
	
	  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE});
	
	  var VARIABLE = {className: 'variable', begin: '\\$' + IDENT_RE};
	
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, VARIABLE],
	    variants: [
	      {begin: /'/, end: /'/},
	      {begin: /"/, end: /"/}
	    ]
	  };
	
	  return {
	    aliases: ['pp'],
	    contains: [
	      COMMENT,
	      VARIABLE,
	      STRING,
	      {
	        beginKeywords: 'class', end: '\\{|;',
	        illegal: /=/,
	        contains: [TITLE, COMMENT]
	      },
	      {
	        beginKeywords: 'define', end: /\{/,
	        contains: [
	          {
	            className: 'section', begin: hljs.IDENT_RE, endsParent: true
	          }
	        ]
	      },
	      {
	        begin: hljs.IDENT_RE + '\\s+\\{', returnBegin: true,
	        end: /\S/,
	        contains: [
	          {
	            className: 'keyword',
	            begin: hljs.IDENT_RE
	          },
	          {
	            begin: /\{/, end: /\}/,
	            keywords: PUPPET_KEYWORDS,
	            relevance: 0,
	            contains: [
	              STRING,
	              COMMENT,
	              {
	                begin:'[a-zA-Z_]+\\s*=>',
	                returnBegin: true, end: '=>',
	                contains: [
	                  {
	                    className: 'attr',
	                    begin: hljs.IDENT_RE,
	                  }
	                ]
	              },
	              {
	                className: 'number',
	                begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	                relevance: 0
	              },
	              VARIABLE
	            ]
	          }
	        ],
	        relevance: 0
	      }
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/purebasic.js":
/***/ (function(module, exports) {

	module.exports = // Base deafult colors in PB IDE: background: #FFFFDF; foreground: #000000;
	
	function(hljs) {
	  var STRINGS = { // PB IDE color: #0080FF (Azure Radiance)
	    className: 'string',
	    begin: '(~)?"', end: '"',
	    illegal: '\\n'
	  };
	  var CONSTANTS = { // PB IDE color: #924B72 (Cannon Pink)
	    //  "#" + a letter or underscore + letters, digits or underscores + (optional) "$"
	    className: 'symbol',
	    begin: '#[a-zA-Z_]\\w*\\$?'
	  };
	
	  return {
	    aliases: ['pb', 'pbi'],
	    keywords: // PB IDE color: #006666 (Blue Stone) + Bold
	      // The following keywords list was taken and adapted from GuShH's PureBasic language file for GeSHi...
	      'And As Break CallDebugger Case CompilerCase CompilerDefault CompilerElse CompilerEndIf CompilerEndSelect ' +
	      'CompilerError CompilerIf CompilerSelect Continue Data DataSection EndDataSection Debug DebugLevel ' +
	      'Default Define Dim DisableASM DisableDebugger DisableExplicit Else ElseIf EnableASM ' +
	      'EnableDebugger EnableExplicit End EndEnumeration EndIf EndImport EndInterface EndMacro EndProcedure ' +
	      'EndSelect EndStructure EndStructureUnion EndWith Enumeration Extends FakeReturn For Next ForEach ' +
	      'ForEver Global Gosub Goto If Import ImportC IncludeBinary IncludeFile IncludePath Interface Macro ' +
	      'NewList Not Or ProcedureReturn Protected Prototype ' +
	      'PrototypeC Read ReDim Repeat Until Restore Return Select Shared Static Step Structure StructureUnion ' +
	      'Swap To Wend While With XIncludeFile XOr ' +
	      'Procedure ProcedureC ProcedureCDLL ProcedureDLL Declare DeclareC DeclareCDLL DeclareDLL',
	    contains: [
	      // COMMENTS | PB IDE color: #00AAAA (Persian Green)
	      hljs.COMMENT(';', '$', {relevance: 0}),
	
	      { // PROCEDURES DEFINITIONS
	        className: 'function',
	        begin: '\\b(Procedure|Declare)(C|CDLL|DLL)?\\b',
	        end: '\\(',
	        excludeEnd: true,
	        returnBegin: true,
	        contains: [
	          { // PROCEDURE KEYWORDS | PB IDE color: #006666 (Blue Stone) + Bold
	            className: 'keyword',
	            begin: '(Procedure|Declare)(C|CDLL|DLL)?',
	            excludeEnd: true
	          },
	          { // PROCEDURE RETURN TYPE SETTING | PB IDE color: #000000 (Black)
	            className: 'type',
	            begin: '\\.\\w*'
	            // end: ' ',
	          },
	          hljs.UNDERSCORE_TITLE_MODE // PROCEDURE NAME | PB IDE color: #006666 (Blue Stone)
	        ]
	      },
	      STRINGS,
	      CONSTANTS
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/python.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      'and elif is global as in if from raise for except finally print import pass return ' +
	      'exec else break not with class assert yield try while continue del or def lambda ' +
	      'async await nonlocal|10 None True False',
	    built_in:
	      'Ellipsis NotImplemented'
	  };
	  var PROMPT = {
	    className: 'meta',  begin: /^(>>>|\.\.\.) /
	  };
	  var SUBST = {
	    className: 'subst',
	    begin: /\{/, end: /\}/,
	    keywords: KEYWORDS,
	    illegal: /#/
	  };
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE],
	    variants: [
	      {
	        begin: /(u|b)?r?'''/, end: /'''/,
	        contains: [PROMPT],
	        relevance: 10
	      },
	      {
	        begin: /(u|b)?r?"""/, end: /"""/,
	        contains: [PROMPT],
	        relevance: 10
	      },
	      {
	        begin: /(fr|rf|f)'''/, end: /'''/,
	        contains: [PROMPT, SUBST]
	      },
	      {
	        begin: /(fr|rf|f)"""/, end: /"""/,
	        contains: [PROMPT, SUBST]
	      },
	      {
	        begin: /(u|r|ur)'/, end: /'/,
	        relevance: 10
	      },
	      {
	        begin: /(u|r|ur)"/, end: /"/,
	        relevance: 10
	      },
	      {
	        begin: /(b|br)'/, end: /'/
	      },
	      {
	        begin: /(b|br)"/, end: /"/
	      },
	      {
	        begin: /(fr|rf|f)'/, end: /'/,
	        contains: [SUBST]
	      },
	      {
	        begin: /(fr|rf|f)"/, end: /"/,
	        contains: [SUBST]
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE
	    ]
	  };
	  var NUMBER = {
	    className: 'number', relevance: 0,
	    variants: [
	      {begin: hljs.BINARY_NUMBER_RE + '[lLjJ]?'},
	      {begin: '\\b(0o[0-7]+)[lLjJ]?'},
	      {begin: hljs.C_NUMBER_RE + '[lLjJ]?'}
	    ]
	  };
	  var PARAMS = {
	    className: 'params',
	    begin: /\(/, end: /\)/,
	    contains: ['self', PROMPT, NUMBER, STRING]
	  };
	  SUBST.contains = [STRING, NUMBER, PROMPT];
	  return {
	    aliases: ['py', 'gyp'],
	    keywords: KEYWORDS,
	    illegal: /(<\/|->|\?)|=>/,
	    contains: [
	      PROMPT,
	      NUMBER,
	      STRING,
	      hljs.HASH_COMMENT_MODE,
	      {
	        variants: [
	          {className: 'function', beginKeywords: 'def'},
	          {className: 'class', beginKeywords: 'class'}
	        ],
	        end: /:/,
	        illegal: /[${=;\n,]/,
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          PARAMS,
	          {
	            begin: /->/, endsWithParent: true,
	            keywords: 'None'
	          }
	        ]
	      },
	      {
	        className: 'meta',
	        begin: /^[\t ]*@/, end: /$/
	      },
	      {
	        begin: /\b(print|exec)\(/ // don’t highlight keywords-turned-functions in Python 3
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/q.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var Q_KEYWORDS = {
	  keyword:
	    'do while select delete by update from',
	  literal:
	    '0b 1b',
	  built_in:
	    'neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum',
	  type:
	    '`float `double int `timestamp `timespan `datetime `time `boolean `symbol `char `byte `short `long `real `month `date `minute `second `guid'
	  };
	  return {
	  aliases:['k', 'kdb'],
	  keywords: Q_KEYWORDS,
	  lexemes: /(`?)[A-Za-z0-9_]+\b/,
	  contains: [
	  hljs.C_LINE_COMMENT_MODE,
	    hljs.QUOTE_STRING_MODE,
	    hljs.C_NUMBER_MODE
	     ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/qml.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	      keyword:
	        'in of on if for while finally var new function do return void else break catch ' +
	        'instanceof with throw case default try this switch continue typeof delete ' +
	        'let yield const export super debugger as async await import',
	      literal:
	        'true false null undefined NaN Infinity',
	      built_in:
	        'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
	        'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
	        'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
	        'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
	        'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
	        'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
	        'module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect ' +
	        'Behavior bool color coordinate date double enumeration font geocircle georectangle ' +
	        'geoshape int list matrix4x4 parent point quaternion real rect ' +
	        'size string url variant vector2d vector3d vector4d' +
	        'Promise'
	    };
	
	  var QML_IDENT_RE = '[a-zA-Z_][a-zA-Z0-9\\._]*';
	
	  // Isolate property statements. Ends at a :, =, ;, ,, a comment or end of line.
	  // Use property class.
	  var PROPERTY = {
	      className: 'keyword',
	      begin: '\\bproperty\\b',
	      starts: {
	        className: 'string',
	        end: '(:|=|;|,|//|/\\*|$)',
	        returnEnd: true
	      }
	  };
	
	  // Isolate signal statements. Ends at a ) a comment or end of line.
	  // Use property class.
	  var SIGNAL = {
	      className: 'keyword',
	      begin: '\\bsignal\\b',
	      starts: {
	        className: 'string',
	        end: '(\\(|:|=|;|,|//|/\\*|$)',
	        returnEnd: true
	      }
	  };
	
	  // id: is special in QML. When we see id: we want to mark the id: as attribute and
	  // emphasize the token following.
	  var ID_ID = {
	      className: 'attribute',
	      begin: '\\bid\\s*:',
	      starts: {
	        className: 'string',
	        end: QML_IDENT_RE,
	        returnEnd: false
	      }
	  };
	
	  // Find QML object attribute. An attribute is a QML identifier followed by :.
	  // Unfortunately it's hard to know where it ends, as it may contain scalars,
	  // objects, object definitions, or javascript. The true end is either when the parent
	  // ends or the next attribute is detected.
	  var QML_ATTRIBUTE = {
	    begin: QML_IDENT_RE + '\\s*:',
	    returnBegin: true,
	    contains: [
	      {
	        className: 'attribute',
	        begin: QML_IDENT_RE,
	        end: '\\s*:',
	        excludeEnd: true,
	        relevance: 0
	      }
	    ],
	    relevance: 0
	  };
	
	  // Find QML object. A QML object is a QML identifier followed by { and ends at the matching }.
	  // All we really care about is finding IDENT followed by { and just mark up the IDENT and ignore the {.
	  var QML_OBJECT = {
	    begin: QML_IDENT_RE + '\\s*{', end: '{',
	    returnBegin: true,
	    relevance: 0,
	    contains: [
	      hljs.inherit(hljs.TITLE_MODE, {begin: QML_IDENT_RE})
	    ]
	  };
	
	  return {
	    aliases: ['qt'],
	    case_insensitive: false,
	    keywords: KEYWORDS,
	    contains: [
	      {
	        className: 'meta',
	        begin: /^\s*['"]use (strict|asm)['"]/
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      { // template string
	        className: 'string',
	        begin: '`', end: '`',
	        contains: [
	          hljs.BACKSLASH_ESCAPE,
	          {
	            className: 'subst',
	            begin: '\\$\\{', end: '\\}'
	          }
	        ]
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'number',
	        variants: [
	          { begin: '\\b(0[bB][01]+)' },
	          { begin: '\\b(0[oO][0-7]+)' },
	          { begin: hljs.C_NUMBER_RE }
	        ],
	        relevance: 0
	      },
	      { // "value" container
	        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
	        keywords: 'return throw case',
	        contains: [
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          hljs.REGEXP_MODE,
	          { // E4X / JSX
	            begin: /</, end: />\s*[);\]]/,
	            relevance: 0,
	            subLanguage: 'xml'
	          }
	        ],
	        relevance: 0
	      },
	      SIGNAL,
	      PROPERTY,
	      {
	        className: 'function',
	        beginKeywords: 'function', end: /\{/, excludeEnd: true,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][0-9A-Za-z$_]*/}),
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            excludeBegin: true,
	            excludeEnd: true,
	            contains: [
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          }
	        ],
	        illegal: /\[|%/
	      },
	      {
	        begin: '\\.' + hljs.IDENT_RE, relevance: 0 // hack: prevents detection of keywords after dots
	      },
	      ID_ID,
	      QML_ATTRIBUTE,
	      QML_OBJECT
	    ],
	    illegal: /#/
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/r.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE = '([a-zA-Z]|\\.[a-zA-Z.])[a-zA-Z0-9._]*';
	
	  return {
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        begin: IDENT_RE,
	        lexemes: IDENT_RE,
	        keywords: {
	          keyword:
	            'function if in break next repeat else for return switch while try tryCatch ' +
	            'stop warning require library attach detach source setMethod setGeneric ' +
	            'setGroupGeneric setClass ...',
	          literal:
	            'NULL NA TRUE FALSE T F Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 ' +
	            'NA_complex_|10'
	        },
	        relevance: 0
	      },
	      {
	        // hex value
	        className: 'number',
	        begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
	        relevance: 0
	      },
	      {
	        // explicit integer
	        className: 'number',
	        begin: "\\d+(?:[eE][+\\-]?\\d*)?L\\b",
	        relevance: 0
	      },
	      {
	        // number with trailing decimal
	        className: 'number',
	        begin: "\\d+\\.(?!\\d)(?:i\\b)?",
	        relevance: 0
	      },
	      {
	        // number
	        className: 'number',
	        begin: "\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d*)?i?\\b",
	        relevance: 0
	      },
	      {
	        // number with leading decimal
	        className: 'number',
	        begin: "\\.\\d+(?:[eE][+\\-]?\\d*)?i?\\b",
	        relevance: 0
	      },
	
	      {
	        // escaped identifier
	        begin: '`',
	        end: '`',
	        relevance: 0
	      },
	
	      {
	        className: 'string',
	        contains: [hljs.BACKSLASH_ESCAPE],
	        variants: [
	          {begin: '"', end: '"'},
	          {begin: "'", end: "'"}
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/rib.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords:
	      'ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis ' +
	      'Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone ' +
	      'CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail ' +
	      'DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format ' +
	      'FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry ' +
	      'Hider Hyperboloid Identity Illuminate Imager Interior LightSource ' +
	      'MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte ' +
	      'MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option ' +
	      'Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples ' +
	      'PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection ' +
	      'Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ' +
	      'ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere ' +
	      'SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd ' +
	      'TransformPoints Translate TrimCurve WorldBegin WorldEnd',
	    illegal: '</',
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/roboconf.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENTIFIER = '[a-zA-Z-_][^\\n{]+\\{';
	
	  var PROPERTY = {
	    className: 'attribute',
	    begin: /[a-zA-Z-_]+/, end: /\s*:/, excludeEnd: true,
	    starts: {
	      end: ';',
	      relevance: 0,
	      contains: [
	        {
	          className: 'variable',
	          begin: /\.[a-zA-Z-_]+/
	        },
	        {
	          className: 'keyword',
	          begin: /\(optional\)/
	        }
	      ]
	    }
	  };
	
	  return {
	    aliases: ['graph', 'instances'],
	    case_insensitive: true,
	    keywords: 'import',
	    contains: [
	      // Facet sections
	      {
	        begin: '^facet ' + IDENTIFIER,
	        end: '}',
	        keywords: 'facet',
	        contains: [
	          PROPERTY,
	          hljs.HASH_COMMENT_MODE
	        ]
	      },
	
	      // Instance sections
	      {
	        begin: '^\\s*instance of ' + IDENTIFIER,
	        end: '}',
	        keywords: 'name count channels instance-data instance-state instance of',
	        illegal: /\S/,
	        contains: [
	          'self',
	          PROPERTY,
	          hljs.HASH_COMMENT_MODE
	        ]
	      },
	
	      // Component sections
	      {
	        begin: '^' + IDENTIFIER,
	        end: '}',
	        contains: [
	          PROPERTY,
	          hljs.HASH_COMMENT_MODE
	        ]
	      },
	
	      // Comments
	      hljs.HASH_COMMENT_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/routeros.js":
/***/ (function(module, exports) {

	module.exports = // Colors from RouterOS terminal:
	//   green        - #0E9A00
	//   teal         - #0C9A9A
	//   purple       - #99069A
	//   light-brown  - #9A9900
	
	function(hljs) {
	
	  var STATEMENTS = 'foreach do while for if from to step else on-error and or not in';
	
	  // Global commands: Every global command should start with ":" token, otherwise it will be treated as variable.
	  var GLOBAL_COMMANDS = 'global local beep delay put len typeof pick log time set find environment terminal error execute parse resolve toarray tobool toid toip toip6 tonum tostr totime';
	
	  // Common commands: Following commands available from most sub-menus:
	  var COMMON_COMMANDS = 'add remove enable disable set get print export edit find run debug error info warning';
	
	  var LITERALS = 'true false yes no nothing nil null';
	
	  var OBJECTS = 'traffic-flow traffic-generator firewall scheduler aaa accounting address-list address align area bandwidth-server bfd bgp bridge client clock community config connection console customer default dhcp-client dhcp-server discovery dns e-mail ethernet filter firewall firmware gps graphing group hardware health hotspot identity igmp-proxy incoming instance interface ip ipsec ipv6 irq l2tp-server lcd ldp logging mac-server mac-winbox mangle manual mirror mme mpls nat nd neighbor network note ntp ospf ospf-v3 ovpn-server page peer pim ping policy pool port ppp pppoe-client pptp-server prefix profile proposal proxy queue radius resource rip ripng route routing screen script security-profiles server service service-port settings shares smb sms sniffer snmp snooper socks sstp-server system tool tracking type upgrade upnp user-manager users user vlan secret vrrp watchdog web-access wireless pptp pppoe lan wan layer7-protocol lease simple raw';
	
	  // print parameters
	  // Several parameters are available for print command:
	  // ToDo: var PARAMETERS_PRINT = 'append as-value brief detail count-only file follow follow-only from interval terse value-list without-paging where info';
	  // ToDo: var OPERATORS = '&& and ! not || or in ~ ^ & << >> + - * /';
	  // ToDo: var TYPES = 'num number bool boolean str string ip ip6-prefix id time array';
	  // ToDo: The following tokens serve as delimiters in the grammar: ()  []  {}  :   ;   $   / 
	
	  var VAR_PREFIX = 'global local set for foreach';
	
	  var VAR = {
	    className: 'variable',
	    variants: [
	      {begin: /\$[\w\d#@][\w\d_]*/},
	      {begin: /\$\{(.*?)}/}
	    ]
	  };
	  
	  var QUOTE_STRING = {
	    className: 'string',
	    begin: /"/, end: /"/,
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      VAR,
	      {
	        className: 'variable',
	        begin: /\$\(/, end: /\)/,
	        contains: [hljs.BACKSLASH_ESCAPE]
	      }
	    ]
	  };
	  
	  var APOS_STRING = {
	    className: 'string',
	    begin: /'/, end: /'/
	  };
	  
	  var IPADDR = '((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b';
	  var IPADDR_wBITMASK =  IPADDR+'/(3[0-2]|[1-2][0-9]|\\d)';
	  //////////////////////////////////////////////////////////////////////
	  return {
	    aliases: ['routeros', 'mikrotik'],
	    case_insensitive: true,
	    lexemes: /:?[\w-]+/,
	    keywords: {
	      literal: LITERALS,
	      keyword: STATEMENTS + ' :' + STATEMENTS.split(' ').join(' :') + ' :' + GLOBAL_COMMANDS.split(' ').join(' :'),
	    },
	    contains: [
	      { // недопустимые конструкции
	        variants: [
	          { begin: /^@/, end: /$/, },               // dns
	          { begin: /\/\*/, end: /\*\//, },          // -- comment
	          { begin: /%%/, end: /$/, },               // -- comment
	          { begin: /^'/, end: /$/, },               // Monkey one line comment
	          { begin: /^\s*\/[\w-]+=/, end: /$/, },    // jboss-cli
	          { begin: /\/\//, end: /$/, },             // Stan comment
	          { begin: /^\[\</, end: /\>\]$/, },        // F# class declaration?
	          { begin: /<\//, end: />/, },              // HTML tags
	          { begin: /^facet /, end: /\}/, },         // roboconf - лютый костыль )))
	          { begin: '^1\\.\\.(\\d+)$', end: /$/, },  // tap  
	        ],
	        illegal: /./,
	      },
	      hljs.COMMENT('^#', '$'),
	      QUOTE_STRING,
	      APOS_STRING,
	      VAR,
	      { // attribute=value
	        begin: /[\w-]+\=([^\s\{\}\[\]\(\)]+)/, 
	        relevance: 0,
	        returnBegin: true,
	        contains: [
	          {
	            className: 'attribute',
	            begin: /[^=]+/
	          },
	          {
	            begin: /=/, 
	            endsWithParent:  true,
	            relevance: 0,
	            contains: [
	              QUOTE_STRING,
	              APOS_STRING,
	              VAR,
	              {
	                className: 'literal',
	                begin: '\\b(' + LITERALS.split(' ').join('|') + ')\\b',
	              },
	              /*{
	                // IPv4 addresses and subnets
	                className: 'number',
	                variants: [
	                  {begin: IPADDR_wBITMASK+'(,'+IPADDR_wBITMASK+')*'}, //192.168.0.0/24,1.2.3.0/24
	                  {begin: IPADDR+'-'+IPADDR},       // 192.168.0.1-192.168.0.3
	                  {begin: IPADDR+'(,'+IPADDR+')*'}, // 192.168.0.1,192.168.0.34,192.168.24.1,192.168.0.1
	                ]
	              }, // */
	              /*{
	                // MAC addresses and DHCP Client IDs
	                className: 'number',
	                begin: /\b(1:)?([0-9A-Fa-f]{1,2}[:-]){5}([0-9A-Fa-f]){1,2}\b/,
	              }, //*/
	              {
	                // Не форматировать не классифицированные значения. Необходимо для исключения подсветки значений как built_in.
	                // className: 'number',  
	                begin: /("[^"]*"|[^\s\{\}\[\]]+)/,
	              }, //*/
	            ]
	          } //*/
	        ]
	      },//*/
	      {
	        // HEX values
	        className: 'number',
	        begin: /\*[0-9a-fA-F]+/,
	      }, //*/
	
	      { 
	        begin: '\\b(' + COMMON_COMMANDS.split(' ').join('|') + ')([\\s\[\(]|\])',
	        returnBegin: true,
	        contains: [
	          {
	            className: 'builtin-name', //'function',
	            begin: /\w+/,
	          },
	        ],  
	      },
	      
	      { 
	        className: 'built_in',
	        variants: [
	          {begin: '(\\.\\./|/|\\s)((' + OBJECTS.split(' ').join('|') + ');?\\s)+',relevance: 10,},
	          {begin: /\.\./,},
	        ],
	      },//*/
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/rsl.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      keyword:
	        'float color point normal vector matrix while for if do return else break extern continue',
	      built_in:
	        'abs acos ambient area asin atan atmosphere attribute calculatenormal ceil cellnoise ' +
	        'clamp comp concat cos degrees depth Deriv diffuse distance Du Dv environment exp ' +
	        'faceforward filterstep floor format fresnel incident length lightsource log match ' +
	        'max min mod noise normalize ntransform opposite option phong pnoise pow printf ' +
	        'ptlined radians random reflect refract renderinfo round setcomp setxcomp setycomp ' +
	        'setzcomp shadow sign sin smoothstep specular specularbrdf spline sqrt step tan ' +
	        'texture textureinfo trace transform vtransform xcomp ycomp zcomp'
	    },
	    illegal: '</',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'meta',
	        begin: '#', end: '$'
	      },
	      {
	        className: 'class',
	        beginKeywords: 'surface displacement light volume imager', end: '\\('
	      },
	      {
	        beginKeywords: 'illuminate illuminance gather', end: '\\('
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/ruby.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var RUBY_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?';
	  var RUBY_KEYWORDS = {
	    keyword:
	      'and then defined module in return redo if BEGIN retry end for self when ' +
	      'next until do begin unless END rescue else break undef not super class case ' +
	      'require yield alias while ensure elsif or include attr_reader attr_writer attr_accessor',
	    literal:
	      'true false nil'
	  };
	  var YARDOCTAG = {
	    className: 'doctag',
	    begin: '@[A-Za-z]+'
	  };
	  var IRB_OBJECT = {
	    begin: '#<', end: '>'
	  };
	  var COMMENT_MODES = [
	    hljs.COMMENT(
	      '#',
	      '$',
	      {
	        contains: [YARDOCTAG]
	      }
	    ),
	    hljs.COMMENT(
	      '^\\=begin',
	      '^\\=end',
	      {
	        contains: [YARDOCTAG],
	        relevance: 10
	      }
	    ),
	    hljs.COMMENT('^__END__', '\\n$')
	  ];
	  var SUBST = {
	    className: 'subst',
	    begin: '#\\{', end: '}',
	    keywords: RUBY_KEYWORDS
	  };
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	    variants: [
	      {begin: /'/, end: /'/},
	      {begin: /"/, end: /"/},
	      {begin: /`/, end: /`/},
	      {begin: '%[qQwWx]?\\(', end: '\\)'},
	      {begin: '%[qQwWx]?\\[', end: '\\]'},
	      {begin: '%[qQwWx]?{', end: '}'},
	      {begin: '%[qQwWx]?<', end: '>'},
	      {begin: '%[qQwWx]?/', end: '/'},
	      {begin: '%[qQwWx]?%', end: '%'},
	      {begin: '%[qQwWx]?-', end: '-'},
	      {begin: '%[qQwWx]?\\|', end: '\\|'},
	      {
	        // \B in the beginning suppresses recognition of ?-sequences where ?
	        // is the last character of a preceding identifier, as in: `func?4`
	        begin: /\B\?(\\\d{1,3}|\\x[A-Fa-f0-9]{1,2}|\\u[A-Fa-f0-9]{4}|\\?\S)\b/
	      },
	      {
	        begin: /<<(-?)\w+$/, end: /^\s*\w+$/,
	      }
	    ]
	  };
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)', endsParent: true,
	    keywords: RUBY_KEYWORDS
	  };
	
	  var RUBY_DEFAULT_CONTAINS = [
	    STRING,
	    IRB_OBJECT,
	    {
	      className: 'class',
	      beginKeywords: 'class module', end: '$|;',
	      illegal: /=/,
	      contains: [
	        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
	        {
	          begin: '<\\s*',
	          contains: [{
	            begin: '(' + hljs.IDENT_RE + '::)?' + hljs.IDENT_RE
	          }]
	        }
	      ].concat(COMMENT_MODES)
	    },
	    {
	      className: 'function',
	      beginKeywords: 'def', end: '$|;',
	      contains: [
	        hljs.inherit(hljs.TITLE_MODE, {begin: RUBY_METHOD_RE}),
	        PARAMS
	      ].concat(COMMENT_MODES)
	    },
	    {
	      // swallow namespace qualifiers before symbols
	      begin: hljs.IDENT_RE + '::'
	    },
	    {
	      className: 'symbol',
	      begin: hljs.UNDERSCORE_IDENT_RE + '(\\!|\\?)?:',
	      relevance: 0
	    },
	    {
	      className: 'symbol',
	      begin: ':(?!\\s)',
	      contains: [STRING, {begin: RUBY_METHOD_RE}],
	      relevance: 0
	    },
	    {
	      className: 'number',
	      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	      relevance: 0
	    },
	    {
	      begin: '(\\$\\W)|((\\$|\\@\\@?)(\\w+))' // variables
	    },
	    {
	      className: 'params',
	      begin: /\|/, end: /\|/,
	      keywords: RUBY_KEYWORDS
	    },
	    { // regexp container
	      begin: '(' + hljs.RE_STARTERS_RE + '|unless)\\s*',
	      keywords: 'unless',
	      contains: [
	        IRB_OBJECT,
	        {
	          className: 'regexp',
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	          illegal: /\n/,
	          variants: [
	            {begin: '/', end: '/[a-z]*'},
	            {begin: '%r{', end: '}[a-z]*'},
	            {begin: '%r\\(', end: '\\)[a-z]*'},
	            {begin: '%r!', end: '![a-z]*'},
	            {begin: '%r\\[', end: '\\][a-z]*'}
	          ]
	        }
	      ].concat(COMMENT_MODES),
	      relevance: 0
	    }
	  ].concat(COMMENT_MODES);
	
	  SUBST.contains = RUBY_DEFAULT_CONTAINS;
	  PARAMS.contains = RUBY_DEFAULT_CONTAINS;
	
	  var SIMPLE_PROMPT = "[>?]>";
	  var DEFAULT_PROMPT = "[\\w#]+\\(\\w+\\):\\d+:\\d+>";
	  var RVM_PROMPT = "(\\w+-)?\\d+\\.\\d+\\.\\d(p\\d+)?[^>]+>";
	
	  var IRB_DEFAULT = [
	    {
	      begin: /^\s*=>/,
	      starts: {
	        end: '$', contains: RUBY_DEFAULT_CONTAINS
	      }
	    },
	    {
	      className: 'meta',
	      begin: '^('+SIMPLE_PROMPT+"|"+DEFAULT_PROMPT+'|'+RVM_PROMPT+')',
	      starts: {
	        end: '$', contains: RUBY_DEFAULT_CONTAINS
	      }
	    }
	  ];
	
	  return {
	    aliases: ['rb', 'gemspec', 'podspec', 'thor', 'irb'],
	    keywords: RUBY_KEYWORDS,
	    illegal: /\/\*/,
	    contains: COMMENT_MODES.concat(IRB_DEFAULT).concat(RUBY_DEFAULT_CONTAINS)
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/ruleslanguage.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	       keyword: 'BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE ' +
	         'INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 ' +
	         'INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 ' +
	         'INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 ' +
	         'INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 ' +
	         'INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 ' +
	         'INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 ' +
	         'INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 ' +
	         'INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 ' +
	         'INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 ' +
	         'INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 ' +
	         'INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 ' +
	         'INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 ' +
	         'INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 ' +
	         'INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 ' +
	         'MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER ' +
	         'OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE ' +
	         'NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH ' +
	         'IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND ' +
	         'UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ' +
	         'ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE ' +
	         'GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE ' +
	         'SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING ' +
	         'DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF ' +
	         'MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY ' +
	         'YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE ' +
	         'COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR ' +
	         'READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ' +
	         'ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE ' +
	         'EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE ' +
	         'SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL ' +
	         'COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN ' +
	         'MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING ' +
	         'FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM ' +
	         'NUMDAYS READ_DATE STAGING',
	       built_in: 'IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML ' +
	         'DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT ' +
	         'DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE ' +
	         'DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT ' +
	         'DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME'
	    },
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'literal',
	        variants: [
	          {begin: '#\\s+[a-zA-Z\\ \\.]*', relevance: 0}, // looks like #-comment
	          {begin: '#[a-zA-Z\\ \\.]+'}
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/rust.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var NUM_SUFFIX = '([ui](8|16|32|64|128|size)|f(32|64))\?';
	  var KEYWORDS =
	    'alignof as be box break const continue crate do else enum extern ' +
	    'false fn for if impl in let loop match mod mut offsetof once priv ' +
	    'proc pub pure ref return self Self sizeof static struct super trait true ' +
	    'type typeof unsafe unsized use virtual while where yield move default';
	  var BUILTINS =
	    // functions
	    'drop ' +
	    // types
	    'i8 i16 i32 i64 i128 isize ' +
	    'u8 u16 u32 u64 u128 usize ' +
	    'f32 f64 ' +
	    'str char bool ' +
	    'Box Option Result String Vec ' +
	    // traits
	    'Copy Send Sized Sync Drop Fn FnMut FnOnce ToOwned Clone Debug ' +
	    'PartialEq PartialOrd Eq Ord AsRef AsMut Into From Default Iterator ' +
	    'Extend IntoIterator DoubleEndedIterator ExactSizeIterator ' +
	    'SliceConcatExt ToString ' +
	    // macros
	    'assert! assert_eq! bitflags! bytes! cfg! col! concat! concat_idents! ' +
	    'debug_assert! debug_assert_eq! env! panic! file! format! format_args! ' +
	    'include_bin! include_str! line! local_data_key! module_path! ' +
	    'option_env! print! println! select! stringify! try! unimplemented! ' +
	    'unreachable! vec! write! writeln! macro_rules! assert_ne! debug_assert_ne!';
	  return {
	    aliases: ['rs'],
	    keywords: {
	      keyword:
	        KEYWORDS,
	      literal:
	        'true false Some None Ok Err',
	      built_in:
	        BUILTINS
	    },
	    lexemes: hljs.IDENT_RE + '!?',
	    illegal: '</',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.COMMENT('/\\*', '\\*/', {contains: ['self']}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {begin: /b?"/, illegal: null}),
	      {
	        className: 'string',
	        variants: [
	           { begin: /r(#*)"(.|\n)*?"\1(?!#)/ },
	           { begin: /b?'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/ }
	        ]
	      },
	      {
	        className: 'symbol',
	        begin: /'[a-zA-Z_][a-zA-Z0-9_]*/
	      },
	      {
	        className: 'number',
	        variants: [
	          { begin: '\\b0b([01_]+)' + NUM_SUFFIX },
	          { begin: '\\b0o([0-7_]+)' + NUM_SUFFIX },
	          { begin: '\\b0x([A-Fa-f0-9_]+)' + NUM_SUFFIX },
	          { begin: '\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)' +
	                   NUM_SUFFIX
	          }
	        ],
	        relevance: 0
	      },
	      {
	        className: 'function',
	        beginKeywords: 'fn', end: '(\\(|<)', excludeEnd: true,
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        className: 'meta',
	        begin: '#\\!?\\[', end: '\\]',
	        contains: [
	          {
	            className: 'meta-string',
	            begin: /"/, end: /"/
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'type', end: ';',
	        contains: [
	          hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {endsParent: true})
	        ],
	        illegal: '\\S'
	      },
	      {
	        className: 'class',
	        beginKeywords: 'trait enum struct union', end: '{',
	        contains: [
	          hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {endsParent: true})
	        ],
	        illegal: '[\\w\\d]'
	      },
	      {
	        begin: hljs.IDENT_RE + '::',
	        keywords: {built_in: BUILTINS}
	      },
	      {
	        begin: '->'
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/scala.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	
	  var ANNOTATION = { className: 'meta', begin: '@[A-Za-z]+' };
	
	  // used in strings for escaping/interpolation/substitution
	  var SUBST = {
	    className: 'subst',
	    variants: [
	      {begin: '\\$[A-Za-z0-9_]+'},
	      {begin: '\\${', end: '}'}
	    ]
	  };
	
	  var STRING = {
	    className: 'string',
	    variants: [
	      {
	        begin: '"', end: '"',
	        illegal: '\\n',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        begin: '"""', end: '"""',
	        relevance: 10
	      },
	      {
	        begin: '[a-z]+"', end: '"',
	        illegal: '\\n',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      },
	      {
	        className: 'string',
	        begin: '[a-z]+"""', end: '"""',
	        contains: [SUBST],
	        relevance: 10
	      }
	    ]
	
	  };
	
	  var SYMBOL = {
	    className: 'symbol',
	    begin: '\'\\w[\\w\\d_]*(?!\')'
	  };
	
	  var TYPE = {
	    className: 'type',
	    begin: '\\b[A-Z][A-Za-z0-9_]*',
	    relevance: 0
	  };
	
	  var NAME = {
	    className: 'title',
	    begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
	    relevance: 0
	  };
	
	  var CLASS = {
	    className: 'class',
	    beginKeywords: 'class object trait type',
	    end: /[:={\[\n;]/,
	    excludeEnd: true,
	    contains: [
	      {
	        beginKeywords: 'extends with',
	        relevance: 10
	      },
	      {
	        begin: /\[/,
	        end: /\]/,
	        excludeBegin: true,
	        excludeEnd: true,
	        relevance: 0,
	        contains: [TYPE]
	      },
	      {
	        className: 'params',
	        begin: /\(/,
	        end: /\)/,
	        excludeBegin: true,
	        excludeEnd: true,
	        relevance: 0,
	        contains: [TYPE]
	      },
	      NAME
	    ]
	  };
	
	  var METHOD = {
	    className: 'function',
	    beginKeywords: 'def',
	    end: /[:={\[(\n;]/,
	    excludeEnd: true,
	    contains: [NAME]
	  };
	
	  return {
	    keywords: {
	      literal: 'true false null',
	      keyword: 'type yield lazy override def with val var sealed abstract private trait object if forSome for while throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit'
	    },
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      STRING,
	      SYMBOL,
	      TYPE,
	      METHOD,
	      CLASS,
	      hljs.C_NUMBER_MODE,
	      ANNOTATION
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/scheme.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var SCHEME_IDENT_RE = '[^\\(\\)\\[\\]\\{\\}",\'`;#|\\\\\\s]+';
	  var SCHEME_SIMPLE_NUMBER_RE = '(\\-|\\+)?\\d+([./]\\d+)?';
	  var SCHEME_COMPLEX_NUMBER_RE = SCHEME_SIMPLE_NUMBER_RE + '[+\\-]' + SCHEME_SIMPLE_NUMBER_RE + 'i';
	  var BUILTINS = {
	    'builtin-name':
	      'case-lambda call/cc class define-class exit-handler field import ' +
	      'inherit init-field interface let*-values let-values let/ec mixin ' +
	      'opt-lambda override protect provide public rename require ' +
	      'require-for-syntax syntax syntax-case syntax-error unit/sig unless ' +
	      'when with-syntax and begin call-with-current-continuation ' +
	      'call-with-input-file call-with-output-file case cond define ' +
	      'define-syntax delay do dynamic-wind else for-each if lambda let let* ' +
	      'let-syntax letrec letrec-syntax map or syntax-rules \' * + , ,@ - ... / ' +
	      '; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan ' +
	      'boolean? caar cadr call-with-input-file call-with-output-file ' +
	      'call-with-values car cdddar cddddr cdr ceiling char->integer ' +
	      'char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? ' +
	      'char-downcase char-lower-case? char-numeric? char-ready? char-upcase ' +
	      'char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? ' +
	      'char? close-input-port close-output-port complex? cons cos ' +
	      'current-input-port current-output-port denominator display eof-object? ' +
	      'eq? equal? eqv? eval even? exact->inexact exact? exp expt floor ' +
	      'force gcd imag-part inexact->exact inexact? input-port? integer->char ' +
	      'integer? interaction-environment lcm length list list->string ' +
	      'list->vector list-ref list-tail list? load log magnitude make-polar ' +
	      'make-rectangular make-string make-vector max member memq memv min ' +
	      'modulo negative? newline not null-environment null? number->string ' +
	      'number? numerator odd? open-input-file open-output-file output-port? ' +
	      'pair? peek-char port? positive? procedure? quasiquote quote quotient ' +
	      'rational? rationalize read read-char real-part real? remainder reverse ' +
	      'round scheme-report-environment set! set-car! set-cdr! sin sqrt string ' +
	      'string->list string->number string->symbol string-append string-ci<=? ' +
	      'string-ci<? string-ci=? string-ci>=? string-ci>? string-copy ' +
	      'string-fill! string-length string-ref string-set! string<=? string<? ' +
	      'string=? string>=? string>? string? substring symbol->string symbol? ' +
	      'tan transcript-off transcript-on truncate values vector ' +
	      'vector->list vector-fill! vector-length vector-ref vector-set! ' +
	      'with-input-from-file with-output-to-file write write-char zero?'
	  };
	
	  var SHEBANG = {
	    className: 'meta',
	    begin: '^#!',
	    end: '$'
	  };
	
	  var LITERAL = {
	    className: 'literal',
	    begin: '(#t|#f|#\\\\' + SCHEME_IDENT_RE + '|#\\\\.)'
	  };
	
	  var NUMBER = {
	    className: 'number',
	    variants: [
	      { begin: SCHEME_SIMPLE_NUMBER_RE, relevance: 0 },
	      { begin: SCHEME_COMPLEX_NUMBER_RE, relevance: 0 },
	      { begin: '#b[0-1]+(/[0-1]+)?' },
	      { begin: '#o[0-7]+(/[0-7]+)?' },
	      { begin: '#x[0-9a-f]+(/[0-9a-f]+)?' }
	    ]
	  };
	
	  var STRING = hljs.QUOTE_STRING_MODE;
	
	  var REGULAR_EXPRESSION = {
	    className: 'regexp',
	    begin: '#[pr]x"',
	    end: '[^\\\\]"'
	  };
	
	  var COMMENT_MODES = [
	    hljs.COMMENT(
	      ';',
	      '$',
	      {
	        relevance: 0
	      }
	    ),
	    hljs.COMMENT('#\\|', '\\|#')
	  ];
	
	  var IDENT = {
	    begin: SCHEME_IDENT_RE,
	    relevance: 0
	  };
	
	  var QUOTED_IDENT = {
	    className: 'symbol',
	    begin: '\'' + SCHEME_IDENT_RE
	  };
	
	  var BODY = {
	    endsWithParent: true,
	    relevance: 0
	  };
	
	  var QUOTED_LIST = {
	    variants: [
	      { begin: /'/ },
	      { begin: '`' }
	    ],
	    contains: [
	      {
	        begin: '\\(', end: '\\)',
	        contains: ['self', LITERAL, STRING, NUMBER, IDENT, QUOTED_IDENT]
	      }
	    ]
	  };
	
	  var NAME = {
	    className: 'name',
	    begin: SCHEME_IDENT_RE,
	    lexemes: SCHEME_IDENT_RE,
	    keywords: BUILTINS
	  };
	
	  var LAMBDA = {
	    begin: /lambda/, endsWithParent: true, returnBegin: true,
	    contains: [
	      NAME,
	      {
	        begin: /\(/, end: /\)/, endsParent: true,
	        contains: [IDENT],
	      }
	    ]
	  };
	
	  var LIST = {
	    variants: [
	      { begin: '\\(', end: '\\)' },
	      { begin: '\\[', end: '\\]' }
	    ],
	    contains: [LAMBDA, NAME, BODY]
	  };
	
	  BODY.contains = [LITERAL, NUMBER, STRING, IDENT, QUOTED_IDENT, QUOTED_LIST, LIST].concat(COMMENT_MODES);
	
	  return {
	    illegal: /\S/,
	    contains: [SHEBANG, NUMBER, STRING, QUOTED_IDENT, QUOTED_LIST, LIST].concat(COMMENT_MODES)
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/scilab.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	
	  var COMMON_CONTAINS = [
	    hljs.C_NUMBER_MODE,
	    {
	      className: 'string',
	      begin: '\'|\"', end: '\'|\"',
	      contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
	    }
	  ];
	
	  return {
	    aliases: ['sci'],
	    lexemes: /%?\w+/,
	    keywords: {
	      keyword: 'abort break case clear catch continue do elseif else endfunction end for function '+
	        'global if pause return resume select try then while',
	      literal:
	        '%f %F %t %T %pi %eps %inf %nan %e %i %z %s',
	      built_in: // Scilab has more than 2000 functions. Just list the most commons
	       'abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp error '+
	       'exec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isempty '+
	       'isinfisnan isvector lasterror length load linspace list listfiles log10 log2 log '+
	       'max min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand real '+
	       'round sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tan '+
	       'type typename warning zeros matrix'
	    },
	    illegal: '("|#|/\\*|\\s+/\\w+)',
	    contains: [
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '$',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)'
	          }
	        ]
	      },
	      {
	        begin: '[a-zA-Z_][a-zA-Z_0-9]*(\'+[\\.\']*|[\\.\']+)', end: '',
	        relevance: 0
	      },
	      {
	        begin: '\\[', end: '\\]\'*[\\.\']*',
	        relevance: 0,
	        contains: COMMON_CONTAINS
	      },
	      hljs.COMMENT('//', '$')
	    ].concat(COMMON_CONTAINS)
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/scss.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
	  var VARIABLE = {
	    className: 'variable',
	    begin: '(\\$' + IDENT_RE + ')\\b'
	  };
	  var HEXCOLOR = {
	    className: 'number', begin: '#[0-9A-Fa-f]+'
	  };
	  var DEF_INTERNALS = {
	    className: 'attribute',
	    begin: '[A-Z\\_\\.\\-]+', end: ':',
	    excludeEnd: true,
	    illegal: '[^\\s]',
	    starts: {
	      endsWithParent: true, excludeEnd: true,
	      contains: [
	        HEXCOLOR,
	        hljs.CSS_NUMBER_MODE,
	        hljs.QUOTE_STRING_MODE,
	        hljs.APOS_STRING_MODE,
	        hljs.C_BLOCK_COMMENT_MODE,
	        {
	          className: 'meta', begin: '!important'
	        }
	      ]
	    }
	  };
	  return {
	    case_insensitive: true,
	    illegal: '[=/|\']',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'selector-id', begin: '\\#[A-Za-z0-9_-]+',
	        relevance: 0
	      },
	      {
	        className: 'selector-class', begin: '\\.[A-Za-z0-9_-]+',
	        relevance: 0
	      },
	      {
	        className: 'selector-attr', begin: '\\[', end: '\\]',
	        illegal: '$'
	      },
	      {
	        className: 'selector-tag', // begin: IDENT_RE, end: '[,|\\s]'
	        begin: '\\b(a|abbr|acronym|address|area|article|aside|audio|b|base|big|blockquote|body|br|button|canvas|caption|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|div|dl|dt|em|embed|fieldset|figcaption|figure|footer|form|frame|frameset|(h[1-6])|head|header|hgroup|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|map|mark|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|samp|script|section|select|small|span|strike|strong|style|sub|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|ul|var|video)\\b',
	        relevance: 0
	      },
	      {
	        begin: ':(visited|valid|root|right|required|read-write|read-only|out-range|optional|only-of-type|only-child|nth-of-type|nth-last-of-type|nth-last-child|nth-child|not|link|left|last-of-type|last-child|lang|invalid|indeterminate|in-range|hover|focus|first-of-type|first-line|first-letter|first-child|first|enabled|empty|disabled|default|checked|before|after|active)'
	      },
	      {
	        begin: '::(after|before|choices|first-letter|first-line|repeat-index|repeat-item|selection|value)'
	      },
	      VARIABLE,
	      {
	        className: 'attribute',
	        begin: '\\b(z-index|word-wrap|word-spacing|word-break|width|widows|white-space|visibility|vertical-align|unicode-bidi|transition-timing-function|transition-property|transition-duration|transition-delay|transition|transform-style|transform-origin|transform|top|text-underline-position|text-transform|text-shadow|text-rendering|text-overflow|text-indent|text-decoration-style|text-decoration-line|text-decoration-color|text-decoration|text-align-last|text-align|tab-size|table-layout|right|resize|quotes|position|pointer-events|perspective-origin|perspective|page-break-inside|page-break-before|page-break-after|padding-top|padding-right|padding-left|padding-bottom|padding|overflow-y|overflow-x|overflow-wrap|overflow|outline-width|outline-style|outline-offset|outline-color|outline|orphans|order|opacity|object-position|object-fit|normal|none|nav-up|nav-right|nav-left|nav-index|nav-down|min-width|min-height|max-width|max-height|mask|marks|margin-top|margin-right|margin-left|margin-bottom|margin|list-style-type|list-style-position|list-style-image|list-style|line-height|letter-spacing|left|justify-content|initial|inherit|ime-mode|image-orientation|image-resolution|image-rendering|icon|hyphens|height|font-weight|font-variant-ligatures|font-variant|font-style|font-stretch|font-size-adjust|font-size|font-language-override|font-kerning|font-feature-settings|font-family|font|float|flex-wrap|flex-shrink|flex-grow|flex-flow|flex-direction|flex-basis|flex|filter|empty-cells|display|direction|cursor|counter-reset|counter-increment|content|column-width|column-span|column-rule-width|column-rule-style|column-rule-color|column-rule|column-gap|column-fill|column-count|columns|color|clip-path|clip|clear|caption-side|break-inside|break-before|break-after|box-sizing|box-shadow|box-decoration-break|bottom|border-width|border-top-width|border-top-style|border-top-right-radius|border-top-left-radius|border-top-color|border-top|border-style|border-spacing|border-right-width|border-right-style|border-right-color|border-right|border-radius|border-left-width|border-left-style|border-left-color|border-left|border-image-width|border-image-source|border-image-slice|border-image-repeat|border-image-outset|border-image|border-color|border-collapse|border-bottom-width|border-bottom-style|border-bottom-right-radius|border-bottom-left-radius|border-bottom-color|border-bottom|border|background-size|background-repeat|background-position|background-origin|background-image|background-color|background-clip|background-attachment|background-blend-mode|background|backface-visibility|auto|animation-timing-function|animation-play-state|animation-name|animation-iteration-count|animation-fill-mode|animation-duration|animation-direction|animation-delay|animation|align-self|align-items|align-content)\\b',
	        illegal: '[^\\s]'
	      },
	      {
	        begin: '\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b'
	      },
	      {
	        begin: ':', end: ';',
	        contains: [
	          VARIABLE,
	          HEXCOLOR,
	          hljs.CSS_NUMBER_MODE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.APOS_STRING_MODE,
	          {
	            className: 'meta', begin: '!important'
	          }
	        ]
	      },
	      {
	        begin: '@', end: '[{;]',
	        keywords: 'mixin include extend for if else each while charset import debug media page content font-face namespace warn',
	        contains: [
	          VARIABLE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.APOS_STRING_MODE,
	          HEXCOLOR,
	          hljs.CSS_NUMBER_MODE,
	          {
	            begin: '\\s[A-Za-z0-9_.-]+',
	            relevance: 0
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/shell.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['console'],
	    contains: [
	      {
	        className: 'meta',
	        begin: '^\\s{0,3}[\\w\\d\\[\\]()@-]*[>%$#]',
	        starts: {
	          end: '$', subLanguage: 'bash'
	        }
	      },
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/smali.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var smali_instr_low_prio = ['add', 'and', 'cmp', 'cmpg', 'cmpl', 'const', 'div', 'double', 'float', 'goto', 'if', 'int', 'long', 'move', 'mul', 'neg', 'new', 'nop', 'not', 'or', 'rem', 'return', 'shl', 'shr', 'sput', 'sub', 'throw', 'ushr', 'xor'];
	  var smali_instr_high_prio = ['aget', 'aput', 'array', 'check', 'execute', 'fill', 'filled', 'goto/16', 'goto/32', 'iget', 'instance', 'invoke', 'iput', 'monitor', 'packed', 'sget', 'sparse'];
	  var smali_keywords = ['transient', 'constructor', 'abstract', 'final', 'synthetic', 'public', 'private', 'protected', 'static', 'bridge', 'system'];
	  return {
	    aliases: ['smali'],
	    contains: [
	      {
	        className: 'string',
	        begin: '"', end: '"',
	        relevance: 0
	      },
	      hljs.COMMENT(
	        '#',
	        '$',
	        {
	          relevance: 0
	        }
	      ),
	      {
	        className: 'keyword',
	        variants: [
	          {begin: '\\s*\\.end\\s[a-zA-Z0-9]*'},
	          {begin: '^[ ]*\\.[a-zA-Z]*', relevance: 0},
	          {begin: '\\s:[a-zA-Z_0-9]*', relevance: 0},
	          {begin: '\\s(' + smali_keywords.join('|') + ')'}
	        ]
	      },
	      {
	        className: 'built_in',
	        variants : [
	          {
	            begin: '\\s('+smali_instr_low_prio.join('|')+')\\s'
	          },
	          {
	            begin: '\\s('+smali_instr_low_prio.join('|')+')((\\-|/)[a-zA-Z0-9]+)+\\s',
	            relevance: 10
	          },
	          {
	            begin: '\\s('+smali_instr_high_prio.join('|')+')((\\-|/)[a-zA-Z0-9]+)*\\s',
	            relevance: 10
	          },
	        ]
	      },
	      {
	        className: 'class',
	        begin: 'L[^\(;:\n]*;',
	        relevance: 0
	      },
	      {
	        begin: '[vp][0-9]+',
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/smalltalk.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var VAR_IDENT_RE = '[a-z][a-zA-Z0-9_]*';
	  var CHAR = {
	    className: 'string',
	    begin: '\\$.{1}'
	  };
	  var SYMBOL = {
	    className: 'symbol',
	    begin: '#' + hljs.UNDERSCORE_IDENT_RE
	  };
	  return {
	    aliases: ['st'],
	    keywords: 'self super nil true false thisContext', // only 6
	    contains: [
	      hljs.COMMENT('"', '"'),
	      hljs.APOS_STRING_MODE,
	      {
	        className: 'type',
	        begin: '\\b[A-Z][A-Za-z0-9_]*',
	        relevance: 0
	      },
	      {
	        begin: VAR_IDENT_RE + ':',
	        relevance: 0
	      },
	      hljs.C_NUMBER_MODE,
	      SYMBOL,
	      CHAR,
	      {
	        // This looks more complicated than needed to avoid combinatorial
	        // explosion under V8. It effectively means `| var1 var2 ... |` with
	        // whitespace adjacent to `|` being optional.
	        begin: '\\|[ ]*' + VAR_IDENT_RE + '([ ]+' + VAR_IDENT_RE + ')*[ ]*\\|',
	        returnBegin: true, end: /\|/,
	        illegal: /\S/,
	        contains: [{begin: '(\\|[ ]*)?' + VAR_IDENT_RE}]
	      },
	      {
	        begin: '\\#\\(', end: '\\)',
	        contains: [
	          hljs.APOS_STRING_MODE,
	          CHAR,
	          hljs.C_NUMBER_MODE,
	          SYMBOL
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/sml.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['ml'],
	    keywords: {
	      keyword:
	        /* according to Definition of Standard ML 97  */
	        'abstype and andalso as case datatype do else end eqtype ' +
	        'exception fn fun functor handle if in include infix infixr ' +
	        'let local nonfix of op open orelse raise rec sharing sig ' +
	        'signature struct structure then type val with withtype where while',
	      built_in:
	        /* built-in types according to basis library */
	        'array bool char exn int list option order real ref string substring vector unit word',
	      literal:
	        'true false NONE SOME LESS EQUAL GREATER nil'
	    },
	    illegal: /\/\/|>>/,
	    lexemes: '[a-z_]\\w*!?',
	    contains: [
	      {
	        className: 'literal',
	        begin: /\[(\|\|)?\]|\(\)/,
	        relevance: 0
	      },
	      hljs.COMMENT(
	        '\\(\\*',
	        '\\*\\)',
	        {
	          contains: ['self']
	        }
	      ),
	      { /* type variable */
	        className: 'symbol',
	        begin: '\'[A-Za-z_](?!\')[\\w\']*'
	        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
	      },
	      { /* polymorphic variant */
	        className: 'type',
	        begin: '`[A-Z][\\w\']*'
	      },
	      { /* module or constructor */
	        className: 'type',
	        begin: '\\b[A-Z][\\w\']*',
	        relevance: 0
	      },
	      { /* don't color identifiers, but safely catch all identifiers with '*/
	        begin: '[a-z_]\\w*\'[\\w\']*'
	      },
	      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	      {
	        className: 'number',
	        begin:
	          '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' +
	          '0[oO][0-7_]+[Lln]?|' +
	          '0[bB][01_]+[Lln]?|' +
	          '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)',
	        relevance: 0
	      },
	      {
	        begin: /[-=]>/ // relevance booster
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/sqf.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var CPP = hljs.getLanguage('cpp').exports;
	
	  // In SQF, a variable start with _
	  var VARIABLE = {
	    className: 'variable',
	    begin: /\b_+[a-zA-Z_]\w*/
	  };
	
	  // In SQF, a function should fit myTag_fnc_myFunction pattern
	  // https://community.bistudio.com/wiki/Functions_Library_(Arma_3)#Adding_a_Function
	  var FUNCTION = {
	    className: 'title',
	    begin: /[a-zA-Z][a-zA-Z0-9]+_fnc_\w*/
	  };
	
	  // In SQF strings, quotes matching the start are escaped by adding a consecutive.
	  // Example of single escaped quotes: " "" " and  ' '' '.
	  var STRINGS = {
	    className: 'string',
	    variants: [
	      {
	        begin: '"',
	        end: '"',
	        contains: [{begin: '""', relevance: 0}]
	      },
	      {
	        begin: '\'',
	        end: '\'',
	        contains: [{begin: '\'\'', relevance: 0}]
	      }
	    ]
	  };
	
	  return {
	    aliases: ['sqf'],
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'case catch default do else exit exitWith for forEach from if ' +
	        'switch then throw to try waitUntil while with',
	      built_in:
	        'abs accTime acos action actionIDs actionKeys actionKeysImages actionKeysNames ' +
	        'actionKeysNamesArray actionName actionParams activateAddons activatedAddons activateKey ' +
	        'add3DENConnection add3DENEventHandler add3DENLayer addAction addBackpack addBackpackCargo ' +
	        'addBackpackCargoGlobal addBackpackGlobal addCamShake addCuratorAddons addCuratorCameraArea ' +
	        'addCuratorEditableObjects addCuratorEditingArea addCuratorPoints addEditorObject addEventHandler ' +
	        'addGoggles addGroupIcon addHandgunItem addHeadgear addItem addItemCargo addItemCargoGlobal ' +
	        'addItemPool addItemToBackpack addItemToUniform addItemToVest addLiveStats addMagazine ' +
	        'addMagazineAmmoCargo addMagazineCargo addMagazineCargoGlobal addMagazineGlobal addMagazinePool ' +
	        'addMagazines addMagazineTurret addMenu addMenuItem addMissionEventHandler addMPEventHandler ' +
	        'addMusicEventHandler addOwnedMine addPlayerScores addPrimaryWeaponItem ' +
	        'addPublicVariableEventHandler addRating addResources addScore addScoreSide addSecondaryWeaponItem ' +
	        'addSwitchableUnit addTeamMember addToRemainsCollector addUniform addVehicle addVest addWaypoint ' +
	        'addWeapon addWeaponCargo addWeaponCargoGlobal addWeaponGlobal addWeaponItem addWeaponPool ' +
	        'addWeaponTurret agent agents AGLToASL aimedAtTarget aimPos airDensityRTD airportSide ' +
	        'AISFinishHeal alive all3DENEntities allControls allCurators allCutLayers allDead allDeadMen ' +
	        'allDisplays allGroups allMapMarkers allMines allMissionObjects allow3DMode allowCrewInImmobile ' +
	        'allowCuratorLogicIgnoreAreas allowDamage allowDammage allowFileOperations allowFleeing allowGetIn ' +
	        'allowSprint allPlayers allSites allTurrets allUnits allUnitsUAV allVariables ammo and animate ' +
	        'animateDoor animateSource animationNames animationPhase animationSourcePhase animationState ' +
	        'append apply armoryPoints arrayIntersect asin ASLToAGL ASLToATL assert assignAsCargo ' +
	        'assignAsCargoIndex assignAsCommander assignAsDriver assignAsGunner assignAsTurret assignCurator ' +
	        'assignedCargo assignedCommander assignedDriver assignedGunner assignedItems assignedTarget ' +
	        'assignedTeam assignedVehicle assignedVehicleRole assignItem assignTeam assignToAirport atan atan2 ' +
	        'atg ATLToASL attachedObject attachedObjects attachedTo attachObject attachTo attackEnabled ' +
	        'backpack backpackCargo backpackContainer backpackItems backpackMagazines backpackSpaceFor ' +
	        'behaviour benchmark binocular blufor boundingBox boundingBoxReal boundingCenter breakOut breakTo ' +
	        'briefingName buildingExit buildingPos buttonAction buttonSetAction cadetMode call callExtension ' +
	        'camCommand camCommit camCommitPrepared camCommitted camConstuctionSetParams camCreate camDestroy ' +
	        'cameraEffect cameraEffectEnableHUD cameraInterest cameraOn cameraView campaignConfigFile ' +
	        'camPreload camPreloaded camPrepareBank camPrepareDir camPrepareDive camPrepareFocus camPrepareFov ' +
	        'camPrepareFovRange camPreparePos camPrepareRelPos camPrepareTarget camSetBank camSetDir ' +
	        'camSetDive camSetFocus camSetFov camSetFovRange camSetPos camSetRelPos camSetTarget camTarget ' +
	        'camUseNVG canAdd canAddItemToBackpack canAddItemToUniform canAddItemToVest ' +
	        'cancelSimpleTaskDestination canFire canMove canSlingLoad canStand canSuspend canUnloadInCombat ' +
	        'canVehicleCargo captive captiveNum cbChecked cbSetChecked ceil channelEnabled cheatsEnabled ' +
	        'checkAIFeature checkVisibility civilian className clearAllItemsFromBackpack clearBackpackCargo ' +
	        'clearBackpackCargoGlobal clearGroupIcons clearItemCargo clearItemCargoGlobal clearItemPool ' +
	        'clearMagazineCargo clearMagazineCargoGlobal clearMagazinePool clearOverlay clearRadio ' +
	        'clearWeaponCargo clearWeaponCargoGlobal clearWeaponPool clientOwner closeDialog closeDisplay ' +
	        'closeOverlay collapseObjectTree collect3DENHistory combatMode commandArtilleryFire commandChat ' +
	        'commander commandFire commandFollow commandFSM commandGetOut commandingMenu commandMove ' +
	        'commandRadio commandStop commandSuppressiveFire commandTarget commandWatch comment commitOverlay ' +
	        'compile compileFinal completedFSM composeText configClasses configFile configHierarchy configName ' +
	        'configNull configProperties configSourceAddonList configSourceMod configSourceModList ' +
	        'connectTerminalToUAV controlNull controlsGroupCtrl copyFromClipboard copyToClipboard ' +
	        'copyWaypoints cos count countEnemy countFriendly countSide countType countUnknown ' +
	        'create3DENComposition create3DENEntity createAgent createCenter createDialog createDiaryLink ' +
	        'createDiaryRecord createDiarySubject createDisplay createGearDialog createGroup ' +
	        'createGuardedPoint createLocation createMarker createMarkerLocal createMenu createMine ' +
	        'createMissionDisplay createMPCampaignDisplay createSimpleObject createSimpleTask createSite ' +
	        'createSoundSource createTask createTeam createTrigger createUnit createVehicle createVehicleCrew ' +
	        'createVehicleLocal crew ctrlActivate ctrlAddEventHandler ctrlAngle ctrlAutoScrollDelay ' +
	        'ctrlAutoScrollRewind ctrlAutoScrollSpeed ctrlChecked ctrlClassName ctrlCommit ctrlCommitted ' +
	        'ctrlCreate ctrlDelete ctrlEnable ctrlEnabled ctrlFade ctrlHTMLLoaded ctrlIDC ctrlIDD ' +
	        'ctrlMapAnimAdd ctrlMapAnimClear ctrlMapAnimCommit ctrlMapAnimDone ctrlMapCursor ctrlMapMouseOver ' +
	        'ctrlMapScale ctrlMapScreenToWorld ctrlMapWorldToScreen ctrlModel ctrlModelDirAndUp ctrlModelScale ' +
	        'ctrlParent ctrlParentControlsGroup ctrlPosition ctrlRemoveAllEventHandlers ctrlRemoveEventHandler ' +
	        'ctrlScale ctrlSetActiveColor ctrlSetAngle ctrlSetAutoScrollDelay ctrlSetAutoScrollRewind ' +
	        'ctrlSetAutoScrollSpeed ctrlSetBackgroundColor ctrlSetChecked ctrlSetEventHandler ctrlSetFade ' +
	        'ctrlSetFocus ctrlSetFont ctrlSetFontH1 ctrlSetFontH1B ctrlSetFontH2 ctrlSetFontH2B ctrlSetFontH3 ' +
	        'ctrlSetFontH3B ctrlSetFontH4 ctrlSetFontH4B ctrlSetFontH5 ctrlSetFontH5B ctrlSetFontH6 ' +
	        'ctrlSetFontH6B ctrlSetFontHeight ctrlSetFontHeightH1 ctrlSetFontHeightH2 ctrlSetFontHeightH3 ' +
	        'ctrlSetFontHeightH4 ctrlSetFontHeightH5 ctrlSetFontHeightH6 ctrlSetFontHeightSecondary ' +
	        'ctrlSetFontP ctrlSetFontPB ctrlSetFontSecondary ctrlSetForegroundColor ctrlSetModel ' +
	        'ctrlSetModelDirAndUp ctrlSetModelScale ctrlSetPosition ctrlSetScale ctrlSetStructuredText ' +
	        'ctrlSetText ctrlSetTextColor ctrlSetTooltip ctrlSetTooltipColorBox ctrlSetTooltipColorShade ' +
	        'ctrlSetTooltipColorText ctrlShow ctrlShown ctrlText ctrlTextHeight ctrlType ctrlVisible ' +
	        'curatorAddons curatorCamera curatorCameraArea curatorCameraAreaCeiling curatorCoef ' +
	        'curatorEditableObjects curatorEditingArea curatorEditingAreaType curatorMouseOver curatorPoints ' +
	        'curatorRegisteredObjects curatorSelected curatorWaypointCost current3DENOperation currentChannel ' +
	        'currentCommand currentMagazine currentMagazineDetail currentMagazineDetailTurret ' +
	        'currentMagazineTurret currentMuzzle currentNamespace currentTask currentTasks currentThrowable ' +
	        'currentVisionMode currentWaypoint currentWeapon currentWeaponMode currentWeaponTurret ' +
	        'currentZeroing cursorObject cursorTarget customChat customRadio cutFadeOut cutObj cutRsc cutText ' +
	        'damage date dateToNumber daytime deActivateKey debriefingText debugFSM debugLog deg ' +
	        'delete3DENEntities deleteAt deleteCenter deleteCollection deleteEditorObject deleteGroup ' +
	        'deleteIdentity deleteLocation deleteMarker deleteMarkerLocal deleteRange deleteResources ' +
	        'deleteSite deleteStatus deleteTeam deleteVehicle deleteVehicleCrew deleteWaypoint detach ' +
	        'detectedMines diag_activeMissionFSMs diag_activeScripts diag_activeSQFScripts ' +
	        'diag_activeSQSScripts diag_captureFrame diag_captureSlowFrame diag_codePerformance diag_drawMode ' +
	        'diag_enable diag_enabled diag_fps diag_fpsMin diag_frameNo diag_list diag_log diag_logSlowFrame ' +
	        'diag_mergeConfigFile diag_recordTurretLimits diag_tickTime diag_toggle dialog diarySubjectExists ' +
	        'didJIP didJIPOwner difficulty difficultyEnabled difficultyEnabledRTD difficultyOption direction ' +
	        'directSay disableAI disableCollisionWith disableConversation disableDebriefingStats ' +
	        'disableNVGEquipment disableRemoteSensors disableSerialization disableTIEquipment ' +
	        'disableUAVConnectability disableUserInput displayAddEventHandler displayCtrl displayNull ' +
	        'displayParent displayRemoveAllEventHandlers displayRemoveEventHandler displaySetEventHandler ' +
	        'dissolveTeam distance distance2D distanceSqr distributionRegion do3DENAction doArtilleryFire ' +
	        'doFire doFollow doFSM doGetOut doMove doorPhase doStop doSuppressiveFire doTarget doWatch ' +
	        'drawArrow drawEllipse drawIcon drawIcon3D drawLine drawLine3D drawLink drawLocation drawPolygon ' +
	        'drawRectangle driver drop east echo edit3DENMissionAttributes editObject editorSetEventHandler ' +
	        'effectiveCommander emptyPositions enableAI enableAIFeature enableAimPrecision enableAttack ' +
	        'enableAudioFeature enableCamShake enableCaustics enableChannel enableCollisionWith enableCopilot ' +
	        'enableDebriefingStats enableDiagLegend enableEndDialog enableEngineArtillery enableEnvironment ' +
	        'enableFatigue enableGunLights enableIRLasers enableMimics enablePersonTurret enableRadio ' +
	        'enableReload enableRopeAttach enableSatNormalOnDetail enableSaving enableSentences ' +
	        'enableSimulation enableSimulationGlobal enableStamina enableTeamSwitch enableUAVConnectability ' +
	        'enableUAVWaypoints enableVehicleCargo endLoadingScreen endMission engineOn enginesIsOnRTD ' +
	        'enginesRpmRTD enginesTorqueRTD entities estimatedEndServerTime estimatedTimeLeft ' +
	        'evalObjectArgument everyBackpack everyContainer exec execEditorScript execFSM execVM exp ' +
	        'expectedDestination exportJIPMessages eyeDirection eyePos face faction fadeMusic fadeRadio ' +
	        'fadeSound fadeSpeech failMission fillWeaponsFromPool find findCover findDisplay findEditorObject ' +
	        'findEmptyPosition findEmptyPositionReady findNearestEnemy finishMissionInit finite fire ' +
	        'fireAtTarget firstBackpack flag flagOwner flagSide flagTexture fleeing floor flyInHeight ' +
	        'flyInHeightASL fog fogForecast fogParams forceAddUniform forcedMap forceEnd forceMap forceRespawn ' +
	        'forceSpeed forceWalk forceWeaponFire forceWeatherChange forEachMember forEachMemberAgent ' +
	        'forEachMemberTeam format formation formationDirection formationLeader formationMembers ' +
	        'formationPosition formationTask formatText formLeader freeLook fromEditor fuel fullCrew ' +
	        'gearIDCAmmoCount gearSlotAmmoCount gearSlotData get3DENActionState get3DENAttribute get3DENCamera ' +
	        'get3DENConnections get3DENEntity get3DENEntityID get3DENGrid get3DENIconsVisible ' +
	        'get3DENLayerEntities get3DENLinesVisible get3DENMissionAttribute get3DENMouseOver get3DENSelected ' +
	        'getAimingCoef getAllHitPointsDamage getAllOwnedMines getAmmoCargo getAnimAimPrecision ' +
	        'getAnimSpeedCoef getArray getArtilleryAmmo getArtilleryComputerSettings getArtilleryETA ' +
	        'getAssignedCuratorLogic getAssignedCuratorUnit getBackpackCargo getBleedingRemaining ' +
	        'getBurningValue getCameraViewDirection getCargoIndex getCenterOfMass getClientState ' +
	        'getClientStateNumber getConnectedUAV getCustomAimingCoef getDammage getDescription getDir ' +
	        'getDirVisual getDLCs getEditorCamera getEditorMode getEditorObjectScope getElevationOffset ' +
	        'getFatigue getFriend getFSMVariable getFuelCargo getGroupIcon getGroupIconParams getGroupIcons ' +
	        'getHideFrom getHit getHitIndex getHitPointDamage getItemCargo getMagazineCargo getMarkerColor ' +
	        'getMarkerPos getMarkerSize getMarkerType getMass getMissionConfig getMissionConfigValue ' +
	        'getMissionDLCs getMissionLayerEntities getModelInfo getMousePosition getNumber getObjectArgument ' +
	        'getObjectChildren getObjectDLC getObjectMaterials getObjectProxy getObjectTextures getObjectType ' +
	        'getObjectViewDistance getOxygenRemaining getPersonUsedDLCs getPilotCameraDirection ' +
	        'getPilotCameraPosition getPilotCameraRotation getPilotCameraTarget getPlayerChannel ' +
	        'getPlayerScores getPlayerUID getPos getPosASL getPosASLVisual getPosASLW getPosATL ' +
	        'getPosATLVisual getPosVisual getPosWorld getRelDir getRelPos getRemoteSensorsDisabled ' +
	        'getRepairCargo getResolution getShadowDistance getShotParents getSlingLoad getSpeed getStamina ' +
	        'getStatValue getSuppression getTerrainHeightASL getText getUnitLoadout getUnitTrait getVariable ' +
	        'getVehicleCargo getWeaponCargo getWeaponSway getWPPos glanceAt globalChat globalRadio goggles ' +
	        'goto group groupChat groupFromNetId groupIconSelectable groupIconsVisible groupId groupOwner ' +
	        'groupRadio groupSelectedUnits groupSelectUnit grpNull gunner gusts halt handgunItems ' +
	        'handgunMagazine handgunWeapon handsHit hasInterface hasPilotCamera hasWeapon hcAllGroups ' +
	        'hcGroupParams hcLeader hcRemoveAllGroups hcRemoveGroup hcSelected hcSelectGroup hcSetGroup ' +
	        'hcShowBar hcShownBar headgear hideBody hideObject hideObjectGlobal hideSelection hint hintC ' +
	        'hintCadet hintSilent hmd hostMission htmlLoad HUDMovementLevels humidity image importAllGroups ' +
	        'importance in inArea inAreaArray incapacitatedState independent inflame inflamed ' +
	        'inGameUISetEventHandler inheritsFrom initAmbientLife inPolygon inputAction inRangeOfArtillery ' +
	        'insertEditorObject intersect is3DEN is3DENMultiplayer isAbleToBreathe isAgent isArray ' +
	        'isAutoHoverOn isAutonomous isAutotest isBleeding isBurning isClass isCollisionLightOn ' +
	        'isCopilotEnabled isDedicated isDLCAvailable isEngineOn isEqualTo isEqualType isEqualTypeAll ' +
	        'isEqualTypeAny isEqualTypeArray isEqualTypeParams isFilePatchingEnabled isFlashlightOn ' +
	        'isFlatEmpty isForcedWalk isFormationLeader isHidden isInRemainsCollector ' +
	        'isInstructorFigureEnabled isIRLaserOn isKeyActive isKindOf isLightOn isLocalized isManualFire ' +
	        'isMarkedForCollection isMultiplayer isMultiplayerSolo isNil isNull isNumber isObjectHidden ' +
	        'isObjectRTD isOnRoad isPipEnabled isPlayer isRealTime isRemoteExecuted isRemoteExecutedJIP ' +
	        'isServer isShowing3DIcons isSprintAllowed isStaminaEnabled isSteamMission ' +
	        'isStreamFriendlyUIEnabled isText isTouchingGround isTurnedOut isTutHintsEnabled isUAVConnectable ' +
	        'isUAVConnected isUniformAllowed isVehicleCargo isWalking isWeaponDeployed isWeaponRested ' +
	        'itemCargo items itemsWithMagazines join joinAs joinAsSilent joinSilent joinString kbAddDatabase ' +
	        'kbAddDatabaseTargets kbAddTopic kbHasTopic kbReact kbRemoveTopic kbTell kbWasSaid keyImage ' +
	        'keyName knowsAbout land landAt landResult language laserTarget lbAdd lbClear lbColor lbCurSel ' +
	        'lbData lbDelete lbIsSelected lbPicture lbSelection lbSetColor lbSetCurSel lbSetData lbSetPicture ' +
	        'lbSetPictureColor lbSetPictureColorDisabled lbSetPictureColorSelected lbSetSelectColor ' +
	        'lbSetSelectColorRight lbSetSelected lbSetTooltip lbSetValue lbSize lbSort lbSortByValue lbText ' +
	        'lbValue leader leaderboardDeInit leaderboardGetRows leaderboardInit leaveVehicle libraryCredits ' +
	        'libraryDisclaimers lifeState lightAttachObject lightDetachObject lightIsOn lightnings limitSpeed ' +
	        'linearConversion lineBreak lineIntersects lineIntersectsObjs lineIntersectsSurfaces ' +
	        'lineIntersectsWith linkItem list listObjects ln lnbAddArray lnbAddColumn lnbAddRow lnbClear ' +
	        'lnbColor lnbCurSelRow lnbData lnbDeleteColumn lnbDeleteRow lnbGetColumnsPosition lnbPicture ' +
	        'lnbSetColor lnbSetColumnsPos lnbSetCurSelRow lnbSetData lnbSetPicture lnbSetText lnbSetValue ' +
	        'lnbSize lnbText lnbValue load loadAbs loadBackpack loadFile loadGame loadIdentity loadMagazine ' +
	        'loadOverlay loadStatus loadUniform loadVest local localize locationNull locationPosition lock ' +
	        'lockCameraTo lockCargo lockDriver locked lockedCargo lockedDriver lockedTurret lockIdentity ' +
	        'lockTurret lockWP log logEntities logNetwork logNetworkTerminate lookAt lookAtPos magazineCargo ' +
	        'magazines magazinesAllTurrets magazinesAmmo magazinesAmmoCargo magazinesAmmoFull magazinesDetail ' +
	        'magazinesDetailBackpack magazinesDetailUniform magazinesDetailVest magazinesTurret ' +
	        'magazineTurretAmmo mapAnimAdd mapAnimClear mapAnimCommit mapAnimDone mapCenterOnCamera ' +
	        'mapGridPosition markAsFinishedOnSteam markerAlpha markerBrush markerColor markerDir markerPos ' +
	        'markerShape markerSize markerText markerType max members menuAction menuAdd menuChecked menuClear ' +
	        'menuCollapse menuData menuDelete menuEnable menuEnabled menuExpand menuHover menuPicture ' +
	        'menuSetAction menuSetCheck menuSetData menuSetPicture menuSetValue menuShortcut menuShortcutText ' +
	        'menuSize menuSort menuText menuURL menuValue min mineActive mineDetectedBy missionConfigFile ' +
	        'missionDifficulty missionName missionNamespace missionStart missionVersion mod modelToWorld ' +
	        'modelToWorldVisual modParams moonIntensity moonPhase morale move move3DENCamera moveInAny ' +
	        'moveInCargo moveInCommander moveInDriver moveInGunner moveInTurret moveObjectToEnd moveOut ' +
	        'moveTime moveTo moveToCompleted moveToFailed musicVolume name nameSound nearEntities ' +
	        'nearestBuilding nearestLocation nearestLocations nearestLocationWithDubbing nearestObject ' +
	        'nearestObjects nearestTerrainObjects nearObjects nearObjectsReady nearRoads nearSupplies ' +
	        'nearTargets needReload netId netObjNull newOverlay nextMenuItemIndex nextWeatherChange nMenuItems ' +
	        'not numberToDate objectCurators objectFromNetId objectParent objNull objStatus onBriefingGroup ' +
	        'onBriefingNotes onBriefingPlan onBriefingTeamSwitch onCommandModeChanged onDoubleClick ' +
	        'onEachFrame onGroupIconClick onGroupIconOverEnter onGroupIconOverLeave onHCGroupSelectionChanged ' +
	        'onMapSingleClick onPlayerConnected onPlayerDisconnected onPreloadFinished onPreloadStarted ' +
	        'onShowNewObject onTeamSwitch openCuratorInterface openDLCPage openMap openYoutubeVideo opfor or ' +
	        'orderGetIn overcast overcastForecast owner param params parseNumber parseText parsingNamespace ' +
	        'particlesQuality pi pickWeaponPool pitch pixelGrid pixelGridBase pixelGridNoUIScale pixelH pixelW ' +
	        'playableSlotsNumber playableUnits playAction playActionNow player playerRespawnTime playerSide ' +
	        'playersNumber playGesture playMission playMove playMoveNow playMusic playScriptedMission ' +
	        'playSound playSound3D position positionCameraToWorld posScreenToWorld posWorldToScreen ' +
	        'ppEffectAdjust ppEffectCommit ppEffectCommitted ppEffectCreate ppEffectDestroy ppEffectEnable ' +
	        'ppEffectEnabled ppEffectForceInNVG precision preloadCamera preloadObject preloadSound ' +
	        'preloadTitleObj preloadTitleRsc preprocessFile preprocessFileLineNumbers primaryWeapon ' +
	        'primaryWeaponItems primaryWeaponMagazine priority private processDiaryLink productVersion ' +
	        'profileName profileNamespace profileNameSteam progressLoadingScreen progressPosition ' +
	        'progressSetPosition publicVariable publicVariableClient publicVariableServer pushBack ' +
	        'pushBackUnique putWeaponPool queryItemsPool queryMagazinePool queryWeaponPool rad radioChannelAdd ' +
	        'radioChannelCreate radioChannelRemove radioChannelSetCallSign radioChannelSetLabel radioVolume ' +
	        'rain rainbow random rank rankId rating rectangular registeredTasks registerTask reload ' +
	        'reloadEnabled remoteControl remoteExec remoteExecCall remove3DENConnection remove3DENEventHandler ' +
	        'remove3DENLayer removeAction removeAll3DENEventHandlers removeAllActions removeAllAssignedItems ' +
	        'removeAllContainers removeAllCuratorAddons removeAllCuratorCameraAreas ' +
	        'removeAllCuratorEditingAreas removeAllEventHandlers removeAllHandgunItems removeAllItems ' +
	        'removeAllItemsWithMagazines removeAllMissionEventHandlers removeAllMPEventHandlers ' +
	        'removeAllMusicEventHandlers removeAllOwnedMines removeAllPrimaryWeaponItems removeAllWeapons ' +
	        'removeBackpack removeBackpackGlobal removeCuratorAddons removeCuratorCameraArea ' +
	        'removeCuratorEditableObjects removeCuratorEditingArea removeDrawIcon removeDrawLinks ' +
	        'removeEventHandler removeFromRemainsCollector removeGoggles removeGroupIcon removeHandgunItem ' +
	        'removeHeadgear removeItem removeItemFromBackpack removeItemFromUniform removeItemFromVest ' +
	        'removeItems removeMagazine removeMagazineGlobal removeMagazines removeMagazinesTurret ' +
	        'removeMagazineTurret removeMenuItem removeMissionEventHandler removeMPEventHandler ' +
	        'removeMusicEventHandler removeOwnedMine removePrimaryWeaponItem removeSecondaryWeaponItem ' +
	        'removeSimpleTask removeSwitchableUnit removeTeamMember removeUniform removeVest removeWeapon ' +
	        'removeWeaponGlobal removeWeaponTurret requiredVersion resetCamShake resetSubgroupDirection ' +
	        'resistance resize resources respawnVehicle restartEditorCamera reveal revealMine reverse ' +
	        'reversedMouseY roadAt roadsConnectedTo roleDescription ropeAttachedObjects ropeAttachedTo ' +
	        'ropeAttachEnabled ropeAttachTo ropeCreate ropeCut ropeDestroy ropeDetach ropeEndPosition ' +
	        'ropeLength ropes ropeUnwind ropeUnwound rotorsForcesRTD rotorsRpmRTD round runInitScript ' +
	        'safeZoneH safeZoneW safeZoneWAbs safeZoneX safeZoneXAbs safeZoneY save3DENInventory saveGame ' +
	        'saveIdentity saveJoysticks saveOverlay saveProfileNamespace saveStatus saveVar savingEnabled say ' +
	        'say2D say3D scopeName score scoreSide screenshot screenToWorld scriptDone scriptName scriptNull ' +
	        'scudState secondaryWeapon secondaryWeaponItems secondaryWeaponMagazine select selectBestPlaces ' +
	        'selectDiarySubject selectedEditorObjects selectEditorObject selectionNames selectionPosition ' +
	        'selectLeader selectMax selectMin selectNoPlayer selectPlayer selectRandom selectWeapon ' +
	        'selectWeaponTurret sendAUMessage sendSimpleCommand sendTask sendTaskResult sendUDPMessage ' +
	        'serverCommand serverCommandAvailable serverCommandExecutable serverName serverTime set ' +
	        'set3DENAttribute set3DENAttributes set3DENGrid set3DENIconsVisible set3DENLayer ' +
	        'set3DENLinesVisible set3DENMissionAttributes set3DENModelsVisible set3DENObjectType ' +
	        'set3DENSelected setAccTime setAirportSide setAmmo setAmmoCargo setAnimSpeedCoef setAperture ' +
	        'setApertureNew setArmoryPoints setAttributes setAutonomous setBehaviour setBleedingRemaining ' +
	        'setCameraInterest setCamShakeDefParams setCamShakeParams setCamUseTi setCaptive setCenterOfMass ' +
	        'setCollisionLight setCombatMode setCompassOscillation setCuratorCameraAreaCeiling setCuratorCoef ' +
	        'setCuratorEditingAreaType setCuratorWaypointCost setCurrentChannel setCurrentTask ' +
	        'setCurrentWaypoint setCustomAimCoef setDamage setDammage setDate setDebriefingText ' +
	        'setDefaultCamera setDestination setDetailMapBlendPars setDir setDirection setDrawIcon ' +
	        'setDropInterval setEditorMode setEditorObjectScope setEffectCondition setFace setFaceAnimation ' +
	        'setFatigue setFlagOwner setFlagSide setFlagTexture setFog setFormation setFormationTask ' +
	        'setFormDir setFriend setFromEditor setFSMVariable setFuel setFuelCargo setGroupIcon ' +
	        'setGroupIconParams setGroupIconsSelectable setGroupIconsVisible setGroupId setGroupIdGlobal ' +
	        'setGroupOwner setGusts setHideBehind setHit setHitIndex setHitPointDamage setHorizonParallaxCoef ' +
	        'setHUDMovementLevels setIdentity setImportance setLeader setLightAmbient setLightAttenuation ' +
	        'setLightBrightness setLightColor setLightDayLight setLightFlareMaxDistance setLightFlareSize ' +
	        'setLightIntensity setLightnings setLightUseFlare setLocalWindParams setMagazineTurretAmmo ' +
	        'setMarkerAlpha setMarkerAlphaLocal setMarkerBrush setMarkerBrushLocal setMarkerColor ' +
	        'setMarkerColorLocal setMarkerDir setMarkerDirLocal setMarkerPos setMarkerPosLocal setMarkerShape ' +
	        'setMarkerShapeLocal setMarkerSize setMarkerSizeLocal setMarkerText setMarkerTextLocal ' +
	        'setMarkerType setMarkerTypeLocal setMass setMimic setMousePosition setMusicEffect ' +
	        'setMusicEventHandler setName setNameSound setObjectArguments setObjectMaterial ' +
	        'setObjectMaterialGlobal setObjectProxy setObjectTexture setObjectTextureGlobal ' +
	        'setObjectViewDistance setOvercast setOwner setOxygenRemaining setParticleCircle setParticleClass ' +
	        'setParticleFire setParticleParams setParticleRandom setPilotCameraDirection ' +
	        'setPilotCameraRotation setPilotCameraTarget setPilotLight setPiPEffect setPitch setPlayable ' +
	        'setPlayerRespawnTime setPos setPosASL setPosASL2 setPosASLW setPosATL setPosition setPosWorld ' +
	        'setRadioMsg setRain setRainbow setRandomLip setRank setRectangular setRepairCargo ' +
	        'setShadowDistance setShotParents setSide setSimpleTaskAlwaysVisible setSimpleTaskCustomData ' +
	        'setSimpleTaskDescription setSimpleTaskDestination setSimpleTaskTarget setSimpleTaskType ' +
	        'setSimulWeatherLayers setSize setSkill setSlingLoad setSoundEffect setSpeaker setSpeech ' +
	        'setSpeedMode setStamina setStaminaScheme setStatValue setSuppression setSystemOfUnits ' +
	        'setTargetAge setTaskResult setTaskState setTerrainGrid setText setTimeMultiplier setTitleEffect ' +
	        'setTriggerActivation setTriggerArea setTriggerStatements setTriggerText setTriggerTimeout ' +
	        'setTriggerType setType setUnconscious setUnitAbility setUnitLoadout setUnitPos setUnitPosWeak ' +
	        'setUnitRank setUnitRecoilCoefficient setUnitTrait setUnloadInCombat setUserActionText setVariable ' +
	        'setVectorDir setVectorDirAndUp setVectorUp setVehicleAmmo setVehicleAmmoDef setVehicleArmor ' +
	        'setVehicleCargo setVehicleId setVehicleLock setVehiclePosition setVehicleTiPars setVehicleVarName ' +
	        'setVelocity setVelocityTransformation setViewDistance setVisibleIfTreeCollapsed setWaves ' +
	        'setWaypointBehaviour setWaypointCombatMode setWaypointCompletionRadius setWaypointDescription ' +
	        'setWaypointForceBehaviour setWaypointFormation setWaypointHousePosition setWaypointLoiterRadius ' +
	        'setWaypointLoiterType setWaypointName setWaypointPosition setWaypointScript setWaypointSpeed ' +
	        'setWaypointStatements setWaypointTimeout setWaypointType setWaypointVisible ' +
	        'setWeaponReloadingTime setWind setWindDir setWindForce setWindStr setWPPos show3DIcons showChat ' +
	        'showCinemaBorder showCommandingMenu showCompass showCuratorCompass showGPS showHUD showLegend ' +
	        'showMap shownArtilleryComputer shownChat shownCompass shownCuratorCompass showNewEditorObject ' +
	        'shownGPS shownHUD shownMap shownPad shownRadio shownScoretable shownUAVFeed shownWarrant ' +
	        'shownWatch showPad showRadio showScoretable showSubtitles showUAVFeed showWarrant showWatch ' +
	        'showWaypoint showWaypoints side sideAmbientLife sideChat sideEmpty sideEnemy sideFriendly ' +
	        'sideLogic sideRadio sideUnknown simpleTasks simulationEnabled simulCloudDensity ' +
	        'simulCloudOcclusion simulInClouds simulWeatherSync sin size sizeOf skill skillFinal skipTime ' +
	        'sleep sliderPosition sliderRange sliderSetPosition sliderSetRange sliderSetSpeed sliderSpeed ' +
	        'slingLoadAssistantShown soldierMagazines someAmmo sort soundVolume spawn speaker speed speedMode ' +
	        'splitString sqrt squadParams stance startLoadingScreen step stop stopEngineRTD stopped str ' +
	        'sunOrMoon supportInfo suppressFor surfaceIsWater surfaceNormal surfaceType swimInDepth ' +
	        'switchableUnits switchAction switchCamera switchGesture switchLight switchMove ' +
	        'synchronizedObjects synchronizedTriggers synchronizedWaypoints synchronizeObjectsAdd ' +
	        'synchronizeObjectsRemove synchronizeTrigger synchronizeWaypoint systemChat systemOfUnits tan ' +
	        'targetKnowledge targetsAggregate targetsQuery taskAlwaysVisible taskChildren taskCompleted ' +
	        'taskCustomData taskDescription taskDestination taskHint taskMarkerOffset taskNull taskParent ' +
	        'taskResult taskState taskType teamMember teamMemberNull teamName teams teamSwitch ' +
	        'teamSwitchEnabled teamType terminate terrainIntersect terrainIntersectASL text textLog ' +
	        'textLogFormat tg time timeMultiplier titleCut titleFadeOut titleObj titleRsc titleText toArray ' +
	        'toFixed toLower toString toUpper triggerActivated triggerActivation triggerArea ' +
	        'triggerAttachedVehicle triggerAttachObject triggerAttachVehicle triggerStatements triggerText ' +
	        'triggerTimeout triggerTimeoutCurrent triggerType turretLocal turretOwner turretUnit tvAdd tvClear ' +
	        'tvCollapse tvCount tvCurSel tvData tvDelete tvExpand tvPicture tvSetCurSel tvSetData tvSetPicture ' +
	        'tvSetPictureColor tvSetPictureColorDisabled tvSetPictureColorSelected tvSetPictureRight ' +
	        'tvSetPictureRightColor tvSetPictureRightColorDisabled tvSetPictureRightColorSelected tvSetText ' +
	        'tvSetTooltip tvSetValue tvSort tvSortByValue tvText tvTooltip tvValue type typeName typeOf ' +
	        'UAVControl uiNamespace uiSleep unassignCurator unassignItem unassignTeam unassignVehicle ' +
	        'underwater uniform uniformContainer uniformItems uniformMagazines unitAddons unitAimPosition ' +
	        'unitAimPositionVisual unitBackpack unitIsUAV unitPos unitReady unitRecoilCoefficient units ' +
	        'unitsBelowHeight unlinkItem unlockAchievement unregisterTask updateDrawIcon updateMenuItem ' +
	        'updateObjectTree useAISteeringComponent useAudioTimeForMoves vectorAdd vectorCos ' +
	        'vectorCrossProduct vectorDiff vectorDir vectorDirVisual vectorDistance vectorDistanceSqr ' +
	        'vectorDotProduct vectorFromTo vectorMagnitude vectorMagnitudeSqr vectorMultiply vectorNormalized ' +
	        'vectorUp vectorUpVisual vehicle vehicleCargoEnabled vehicleChat vehicleRadio vehicles ' +
	        'vehicleVarName velocity velocityModelSpace verifySignature vest vestContainer vestItems ' +
	        'vestMagazines viewDistance visibleCompass visibleGPS visibleMap visiblePosition ' +
	        'visiblePositionASL visibleScoretable visibleWatch waves waypointAttachedObject ' +
	        'waypointAttachedVehicle waypointAttachObject waypointAttachVehicle waypointBehaviour ' +
	        'waypointCombatMode waypointCompletionRadius waypointDescription waypointForceBehaviour ' +
	        'waypointFormation waypointHousePosition waypointLoiterRadius waypointLoiterType waypointName ' +
	        'waypointPosition waypoints waypointScript waypointsEnabledUAV waypointShow waypointSpeed ' +
	        'waypointStatements waypointTimeout waypointTimeoutCurrent waypointType waypointVisible ' +
	        'weaponAccessories weaponAccessoriesCargo weaponCargo weaponDirection weaponInertia weaponLowered ' +
	        'weapons weaponsItems weaponsItemsCargo weaponState weaponsTurret weightRTD west WFSideText wind',
	      literal:
	        'true false nil'
	    },
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.NUMBER_MODE,
	      VARIABLE,
	      FUNCTION,
	      STRINGS,
	      CPP.preprocessor
	    ],
	    illegal: /#/
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/sql.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var COMMENT_MODE = hljs.COMMENT('--', '$');
	  return {
	    case_insensitive: true,
	    illegal: /[<>{}*#]/,
	    contains: [
	      {
	        beginKeywords:
	          'begin end start commit rollback savepoint lock alter create drop rename call ' +
	          'delete do handler insert load replace select truncate update set show pragma grant ' +
	          'merge describe use explain help declare prepare execute deallocate release ' +
	          'unlock purge reset change stop analyze cache flush optimize repair kill ' +
	          'install uninstall checksum restore check backup revoke comment',
	        end: /;/, endsWithParent: true,
	        lexemes: /[\w\.]+/,
	        keywords: {
	          keyword:
	            'abort abs absolute acc acce accep accept access accessed accessible account acos action activate add ' +
	            'addtime admin administer advanced advise aes_decrypt aes_encrypt after agent aggregate ali alia alias ' +
	            'allocate allow alter always analyze ancillary and any anydata anydataset anyschema anytype apply ' +
	            'archive archived archivelog are as asc ascii asin assembly assertion associate asynchronous at atan ' +
	            'atn2 attr attri attrib attribu attribut attribute attributes audit authenticated authentication authid ' +
	            'authors auto autoallocate autodblink autoextend automatic availability avg backup badfile basicfile ' +
	            'before begin beginning benchmark between bfile bfile_base big bigfile bin binary_double binary_float ' +
	            'binlog bit_and bit_count bit_length bit_or bit_xor bitmap blob_base block blocksize body both bound ' +
	            'buffer_cache buffer_pool build bulk by byte byteordermark bytes cache caching call calling cancel ' +
	            'capacity cascade cascaded case cast catalog category ceil ceiling chain change changed char_base ' +
	            'char_length character_length characters characterset charindex charset charsetform charsetid check ' +
	            'checksum checksum_agg child choose chr chunk class cleanup clear client clob clob_base clone close ' +
	            'cluster_id cluster_probability cluster_set clustering coalesce coercibility col collate collation ' +
	            'collect colu colum column column_value columns columns_updated comment commit compact compatibility ' +
	            'compiled complete composite_limit compound compress compute concat concat_ws concurrent confirm conn ' +
	            'connec connect connect_by_iscycle connect_by_isleaf connect_by_root connect_time connection ' +
	            'consider consistent constant constraint constraints constructor container content contents context ' +
	            'contributors controlfile conv convert convert_tz corr corr_k corr_s corresponding corruption cos cost ' +
	            'count count_big counted covar_pop covar_samp cpu_per_call cpu_per_session crc32 create creation ' +
	            'critical cross cube cume_dist curdate current current_date current_time current_timestamp current_user ' +
	            'cursor curtime customdatum cycle data database databases datafile datafiles datalength date_add ' +
	            'date_cache date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts ' +
	            'day day_to_second dayname dayofmonth dayofweek dayofyear days db_role_change dbtimezone ddl deallocate ' +
	            'declare decode decompose decrement decrypt deduplicate def defa defau defaul default defaults ' +
	            'deferred defi defin define degrees delayed delegate delete delete_all delimited demand dense_rank ' +
	            'depth dequeue des_decrypt des_encrypt des_key_file desc descr descri describ describe descriptor ' +
	            'deterministic diagnostics difference dimension direct_load directory disable disable_all ' +
	            'disallow disassociate discardfile disconnect diskgroup distinct distinctrow distribute distributed div ' +
	            'do document domain dotnet double downgrade drop dumpfile duplicate duration each edition editionable ' +
	            'editions element ellipsis else elsif elt empty enable enable_all enclosed encode encoding encrypt ' +
	            'end end-exec endian enforced engine engines enqueue enterprise entityescaping eomonth error errors ' +
	            'escaped evalname evaluate event eventdata events except exception exceptions exchange exclude excluding ' +
	            'execu execut execute exempt exists exit exp expire explain export export_set extended extent external ' +
	            'external_1 external_2 externally extract failed failed_login_attempts failover failure far fast ' +
	            'feature_set feature_value fetch field fields file file_name_convert filesystem_like_logging final ' +
	            'finish first first_value fixed flash_cache flashback floor flush following follows for forall force ' +
	            'form forma format found found_rows freelist freelists freepools fresh from from_base64 from_days ' +
	            'ftp full function general generated get get_format get_lock getdate getutcdate global global_name ' +
	            'globally go goto grant grants greatest group group_concat group_id grouping grouping_id groups ' +
	            'gtid_subtract guarantee guard handler hash hashkeys having hea head headi headin heading heap help hex ' +
	            'hierarchy high high_priority hosts hour http id ident_current ident_incr ident_seed identified ' +
	            'identity idle_time if ifnull ignore iif ilike ilm immediate import in include including increment ' +
	            'index indexes indexing indextype indicator indices inet6_aton inet6_ntoa inet_aton inet_ntoa infile ' +
	            'initial initialized initially initrans inmemory inner innodb input insert install instance instantiable ' +
	            'instr interface interleaved intersect into invalidate invisible is is_free_lock is_ipv4 is_ipv4_compat ' +
	            'is_not is_not_null is_used_lock isdate isnull isolation iterate java join json json_exists ' +
	            'keep keep_duplicates key keys kill language large last last_day last_insert_id last_value lax lcase ' +
	            'lead leading least leaves left len lenght length less level levels library like like2 like4 likec limit ' +
	            'lines link list listagg little ln load load_file lob lobs local localtime localtimestamp locate ' +
	            'locator lock locked log log10 log2 logfile logfiles logging logical logical_reads_per_call ' +
	            'logoff logon logs long loop low low_priority lower lpad lrtrim ltrim main make_set makedate maketime ' +
	            'managed management manual map mapping mask master master_pos_wait match matched materialized max ' +
	            'maxextents maximize maxinstances maxlen maxlogfiles maxloghistory maxlogmembers maxsize maxtrans ' +
	            'md5 measures median medium member memcompress memory merge microsecond mid migration min minextents ' +
	            'minimum mining minus minute minvalue missing mod mode model modification modify module monitoring month ' +
	            'months mount move movement multiset mutex name name_const names nan national native natural nav nchar ' +
	            'nclob nested never new newline next nextval no no_write_to_binlog noarchivelog noaudit nobadfile ' +
	            'nocheck nocompress nocopy nocycle nodelay nodiscardfile noentityescaping noguarantee nokeep nologfile ' +
	            'nomapping nomaxvalue nominimize nominvalue nomonitoring none noneditionable nonschema noorder ' +
	            'nopr nopro noprom nopromp noprompt norely noresetlogs noreverse normal norowdependencies noschemacheck ' +
	            'noswitch not nothing notice notrim novalidate now nowait nth_value nullif nulls num numb numbe ' +
	            'nvarchar nvarchar2 object ocicoll ocidate ocidatetime ociduration ociinterval ociloblocator ocinumber ' +
	            'ociref ocirefcursor ocirowid ocistring ocitype oct octet_length of off offline offset oid oidindex old ' +
	            'on online only opaque open operations operator optimal optimize option optionally or oracle oracle_date ' +
	            'oradata ord ordaudio orddicom orddoc order ordimage ordinality ordvideo organization orlany orlvary ' +
	            'out outer outfile outline output over overflow overriding package pad parallel parallel_enable ' +
	            'parameters parent parse partial partition partitions pascal passing password password_grace_time ' +
	            'password_lock_time password_reuse_max password_reuse_time password_verify_function patch path patindex ' +
	            'pctincrease pctthreshold pctused pctversion percent percent_rank percentile_cont percentile_disc ' +
	            'performance period period_add period_diff permanent physical pi pipe pipelined pivot pluggable plugin ' +
	            'policy position post_transaction pow power pragma prebuilt precedes preceding precision prediction ' +
	            'prediction_cost prediction_details prediction_probability prediction_set prepare present preserve ' +
	            'prior priority private private_sga privileges procedural procedure procedure_analyze processlist ' +
	            'profiles project prompt protection public publishingservername purge quarter query quick quiesce quota ' +
	            'quotename radians raise rand range rank raw read reads readsize rebuild record records ' +
	            'recover recovery recursive recycle redo reduced ref reference referenced references referencing refresh ' +
	            'regexp_like register regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy ' +
	            'reject rekey relational relative relaylog release release_lock relies_on relocate rely rem remainder rename ' +
	            'repair repeat replace replicate replication required reset resetlogs resize resource respect restore ' +
	            'restricted result result_cache resumable resume retention return returning returns reuse reverse revoke ' +
	            'right rlike role roles rollback rolling rollup round row row_count rowdependencies rowid rownum rows ' +
	            'rtrim rules safe salt sample save savepoint sb1 sb2 sb4 scan schema schemacheck scn scope scroll ' +
	            'sdo_georaster sdo_topo_geometry search sec_to_time second section securefile security seed segment select ' +
	            'self sequence sequential serializable server servererror session session_user sessions_per_user set ' +
	            'sets settings sha sha1 sha2 share shared shared_pool short show shrink shutdown si_averagecolor ' +
	            'si_colorhistogram si_featurelist si_positionalcolor si_stillimage si_texture siblings sid sign sin ' +
	            'size size_t sizes skip slave sleep smalldatetimefromparts smallfile snapshot some soname sort soundex ' +
	            'source space sparse spfile split sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows ' +
	            'sql_small_result sql_variant_property sqlcode sqldata sqlerror sqlname sqlstate sqrt square standalone ' +
	            'standby start starting startup statement static statistics stats_binomial_test stats_crosstab ' +
	            'stats_ks_test stats_mode stats_mw_test stats_one_way_anova stats_t_test_ stats_t_test_indep ' +
	            'stats_t_test_one stats_t_test_paired stats_wsr_test status std stddev stddev_pop stddev_samp stdev ' +
	            'stop storage store stored str str_to_date straight_join strcmp strict string struct stuff style subdate ' +
	            'subpartition subpartitions substitutable substr substring subtime subtring_index subtype success sum ' +
	            'suspend switch switchoffset switchover sync synchronous synonym sys sys_xmlagg sysasm sysaux sysdate ' +
	            'sysdatetimeoffset sysdba sysoper system system_user sysutcdatetime table tables tablespace tan tdo ' +
	            'template temporary terminated tertiary_weights test than then thread through tier ties time time_format ' +
	            'time_zone timediff timefromparts timeout timestamp timestampadd timestampdiff timezone_abbr ' +
	            'timezone_minute timezone_region to to_base64 to_date to_days to_seconds todatetimeoffset trace tracking ' +
	            'transaction transactional translate translation treat trigger trigger_nestlevel triggers trim truncate ' +
	            'try_cast try_convert try_parse type ub1 ub2 ub4 ucase unarchived unbounded uncompress ' +
	            'under undo unhex unicode uniform uninstall union unique unix_timestamp unknown unlimited unlock unpivot ' +
	            'unrecoverable unsafe unsigned until untrusted unusable unused update updated upgrade upped upper upsert ' +
	            'url urowid usable usage use use_stored_outlines user user_data user_resources users using utc_date ' +
	            'utc_timestamp uuid uuid_short validate validate_password_strength validation valist value values var ' +
	            'var_samp varcharc vari varia variab variabl variable variables variance varp varraw varrawc varray ' +
	            'verify version versions view virtual visible void wait wallet warning warnings week weekday weekofyear ' +
	            'wellformed when whene whenev wheneve whenever where while whitespace with within without work wrapped ' +
	            'xdb xml xmlagg xmlattributes xmlcast xmlcolattval xmlelement xmlexists xmlforest xmlindex xmlnamespaces ' +
	            'xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltype xor year year_to_month years yearweek',
	          literal:
	            'true false null',
	          built_in:
	            'array bigint binary bit blob boolean char character date dec decimal float int int8 integer interval number ' +
	            'numeric real record serial serial8 smallint text varchar varying void'
	        },
	        contains: [
	          {
	            className: 'string',
	            begin: '\'', end: '\'',
	            contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
	          },
	          {
	            className: 'string',
	            begin: '"', end: '"',
	            contains: [hljs.BACKSLASH_ESCAPE, {begin: '""'}]
	          },
	          {
	            className: 'string',
	            begin: '`', end: '`',
	            contains: [hljs.BACKSLASH_ESCAPE]
	          },
	          hljs.C_NUMBER_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          COMMENT_MODE
	        ]
	      },
	      hljs.C_BLOCK_COMMENT_MODE,
	      COMMENT_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/stan.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        begin: hljs.UNDERSCORE_IDENT_RE,
	        lexemes: hljs.UNDERSCORE_IDENT_RE,
	        keywords: {
	          // Stan's keywords
	          name:
	            'for in while repeat until if then else',
	          // Stan's probablity distributions (less beta and gamma, as commonly
	          // used for parameter names). So far, _log and _rng variants are not
	          // included
	          symbol:
	            'bernoulli bernoulli_logit binomial binomial_logit '               +
	            'beta_binomial hypergeometric categorical categorical_logit '      +
	            'ordered_logistic neg_binomial neg_binomial_2 '                    +
	            'neg_binomial_2_log poisson poisson_log multinomial normal '       +
	            'exp_mod_normal skew_normal student_t cauchy double_exponential '  +
	            'logistic gumbel lognormal chi_square inv_chi_square '             +
	            'scaled_inv_chi_square exponential inv_gamma weibull frechet '     +
	            'rayleigh wiener pareto pareto_type_2 von_mises uniform '          +
	            'multi_normal multi_normal_prec multi_normal_cholesky multi_gp '   +
	            'multi_gp_cholesky multi_student_t gaussian_dlm_obs dirichlet '    +
	            'lkj_corr lkj_corr_cholesky wishart inv_wishart',
	          // Stan's data types
	          'selector-tag':
	            'int real vector simplex unit_vector ordered positive_ordered '    +
	            'row_vector matrix cholesky_factor_corr cholesky_factor_cov '      +
	            'corr_matrix cov_matrix',
	          // Stan's model blocks
	          title:
	            'functions model data parameters quantities transformed '          +
	            'generated',
	          literal:
	            'true false'
	        },
	        relevance: 0
	      },
	      // The below is all taken from the R language definition
	      {
	        // hex value
	        className: 'number',
	        begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
	        relevance: 0
	      },
	      {
	        // hex value
	        className: 'number',
	        begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
	        relevance: 0
	      },
	      {
	        // explicit integer
	        className: 'number',
	        begin: "\\d+(?:[eE][+\\-]?\\d*)?L\\b",
	        relevance: 0
	      },
	      {
	        // number with trailing decimal
	        className: 'number',
	        begin: "\\d+\\.(?!\\d)(?:i\\b)?",
	        relevance: 0
	      },
	      {
	        // number
	        className: 'number',
	        begin: "\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d*)?i?\\b",
	        relevance: 0
	      },
	      {
	        // number with leading decimal
	        className: 'number',
	        begin: "\\.\\d+(?:[eE][+\\-]?\\d*)?i?\\b",
	        relevance: 0
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/stata.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['do', 'ado'],
	    case_insensitive: true,
	    keywords: 'if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d|0 datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e|0 ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate g|0 gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h|0 hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l|0 la lab labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m|0 ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize meqparse mer merg merge mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n|0 nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u|0 unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5',
	        contains: [
	      {
	        className: 'symbol',
	        begin: /`[a-zA-Z0-9_]+'/
	      },
	      {
	        className: 'variable',
	        begin: /\$\{?[a-zA-Z0-9_]+\}?/
	      },
	      {
	        className: 'string',
	        variants: [
	          {begin: '`"[^\r\n]*?"\''},
	          {begin: '"[^\r\n"]*"'}
	        ]
	      },
	
	      {
	        className: 'built_in',
	        variants: [
	          {
	            begin: '\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\(|$)'
	          }
	        ]
	      },
	
	      hljs.COMMENT('^[ \t]*\\*.*$', false),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/step21.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var STEP21_IDENT_RE = '[A-Z_][A-Z0-9_.]*';
	  var STEP21_KEYWORDS = {
	    keyword: 'HEADER ENDSEC DATA'
	  };
	  var STEP21_START = {
	    className: 'meta',
	    begin: 'ISO-10303-21;',
	    relevance: 10
	  };
	  var STEP21_CLOSE = {
	    className: 'meta',
	    begin: 'END-ISO-10303-21;',
	    relevance: 10
	  };
	
	  return {
	    aliases: ['p21', 'step', 'stp'],
	    case_insensitive: true, // STEP 21 is case insensitive in theory, in practice all non-comments are capitalized.
	    lexemes: STEP21_IDENT_RE,
	    keywords: STEP21_KEYWORDS,
	    contains: [
	      STEP21_START,
	      STEP21_CLOSE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.COMMENT('/\\*\\*!', '\\*/'),
	      hljs.C_NUMBER_MODE,
	      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	      {
	        className: 'string',
	        begin: "'", end: "'"
	      },
	      {
	        className: 'symbol',
	        variants: [
	          {
	            begin: '#', end: '\\d+',
	            illegal: '\\W'
	          }
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/stylus.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	
	  var VARIABLE = {
	    className: 'variable',
	    begin: '\\$' + hljs.IDENT_RE
	  };
	
	  var HEX_COLOR = {
	    className: 'number',
	    begin: '#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})'
	  };
	
	  var AT_KEYWORDS = [
	    'charset',
	    'css',
	    'debug',
	    'extend',
	    'font-face',
	    'for',
	    'import',
	    'include',
	    'media',
	    'mixin',
	    'page',
	    'warn',
	    'while'
	  ];
	
	  var PSEUDO_SELECTORS = [
	    'after',
	    'before',
	    'first-letter',
	    'first-line',
	    'active',
	    'first-child',
	    'focus',
	    'hover',
	    'lang',
	    'link',
	    'visited'
	  ];
	
	  var TAGS = [
	    'a',
	    'abbr',
	    'address',
	    'article',
	    'aside',
	    'audio',
	    'b',
	    'blockquote',
	    'body',
	    'button',
	    'canvas',
	    'caption',
	    'cite',
	    'code',
	    'dd',
	    'del',
	    'details',
	    'dfn',
	    'div',
	    'dl',
	    'dt',
	    'em',
	    'fieldset',
	    'figcaption',
	    'figure',
	    'footer',
	    'form',
	    'h1',
	    'h2',
	    'h3',
	    'h4',
	    'h5',
	    'h6',
	    'header',
	    'hgroup',
	    'html',
	    'i',
	    'iframe',
	    'img',
	    'input',
	    'ins',
	    'kbd',
	    'label',
	    'legend',
	    'li',
	    'mark',
	    'menu',
	    'nav',
	    'object',
	    'ol',
	    'p',
	    'q',
	    'quote',
	    'samp',
	    'section',
	    'span',
	    'strong',
	    'summary',
	    'sup',
	    'table',
	    'tbody',
	    'td',
	    'textarea',
	    'tfoot',
	    'th',
	    'thead',
	    'time',
	    'tr',
	    'ul',
	    'var',
	    'video'
	  ];
	
	  var TAG_END = '[\\.\\s\\n\\[\\:,]';
	
	  var ATTRIBUTES = [
	    'align-content',
	    'align-items',
	    'align-self',
	    'animation',
	    'animation-delay',
	    'animation-direction',
	    'animation-duration',
	    'animation-fill-mode',
	    'animation-iteration-count',
	    'animation-name',
	    'animation-play-state',
	    'animation-timing-function',
	    'auto',
	    'backface-visibility',
	    'background',
	    'background-attachment',
	    'background-clip',
	    'background-color',
	    'background-image',
	    'background-origin',
	    'background-position',
	    'background-repeat',
	    'background-size',
	    'border',
	    'border-bottom',
	    'border-bottom-color',
	    'border-bottom-left-radius',
	    'border-bottom-right-radius',
	    'border-bottom-style',
	    'border-bottom-width',
	    'border-collapse',
	    'border-color',
	    'border-image',
	    'border-image-outset',
	    'border-image-repeat',
	    'border-image-slice',
	    'border-image-source',
	    'border-image-width',
	    'border-left',
	    'border-left-color',
	    'border-left-style',
	    'border-left-width',
	    'border-radius',
	    'border-right',
	    'border-right-color',
	    'border-right-style',
	    'border-right-width',
	    'border-spacing',
	    'border-style',
	    'border-top',
	    'border-top-color',
	    'border-top-left-radius',
	    'border-top-right-radius',
	    'border-top-style',
	    'border-top-width',
	    'border-width',
	    'bottom',
	    'box-decoration-break',
	    'box-shadow',
	    'box-sizing',
	    'break-after',
	    'break-before',
	    'break-inside',
	    'caption-side',
	    'clear',
	    'clip',
	    'clip-path',
	    'color',
	    'column-count',
	    'column-fill',
	    'column-gap',
	    'column-rule',
	    'column-rule-color',
	    'column-rule-style',
	    'column-rule-width',
	    'column-span',
	    'column-width',
	    'columns',
	    'content',
	    'counter-increment',
	    'counter-reset',
	    'cursor',
	    'direction',
	    'display',
	    'empty-cells',
	    'filter',
	    'flex',
	    'flex-basis',
	    'flex-direction',
	    'flex-flow',
	    'flex-grow',
	    'flex-shrink',
	    'flex-wrap',
	    'float',
	    'font',
	    'font-family',
	    'font-feature-settings',
	    'font-kerning',
	    'font-language-override',
	    'font-size',
	    'font-size-adjust',
	    'font-stretch',
	    'font-style',
	    'font-variant',
	    'font-variant-ligatures',
	    'font-weight',
	    'height',
	    'hyphens',
	    'icon',
	    'image-orientation',
	    'image-rendering',
	    'image-resolution',
	    'ime-mode',
	    'inherit',
	    'initial',
	    'justify-content',
	    'left',
	    'letter-spacing',
	    'line-height',
	    'list-style',
	    'list-style-image',
	    'list-style-position',
	    'list-style-type',
	    'margin',
	    'margin-bottom',
	    'margin-left',
	    'margin-right',
	    'margin-top',
	    'marks',
	    'mask',
	    'max-height',
	    'max-width',
	    'min-height',
	    'min-width',
	    'nav-down',
	    'nav-index',
	    'nav-left',
	    'nav-right',
	    'nav-up',
	    'none',
	    'normal',
	    'object-fit',
	    'object-position',
	    'opacity',
	    'order',
	    'orphans',
	    'outline',
	    'outline-color',
	    'outline-offset',
	    'outline-style',
	    'outline-width',
	    'overflow',
	    'overflow-wrap',
	    'overflow-x',
	    'overflow-y',
	    'padding',
	    'padding-bottom',
	    'padding-left',
	    'padding-right',
	    'padding-top',
	    'page-break-after',
	    'page-break-before',
	    'page-break-inside',
	    'perspective',
	    'perspective-origin',
	    'pointer-events',
	    'position',
	    'quotes',
	    'resize',
	    'right',
	    'tab-size',
	    'table-layout',
	    'text-align',
	    'text-align-last',
	    'text-decoration',
	    'text-decoration-color',
	    'text-decoration-line',
	    'text-decoration-style',
	    'text-indent',
	    'text-overflow',
	    'text-rendering',
	    'text-shadow',
	    'text-transform',
	    'text-underline-position',
	    'top',
	    'transform',
	    'transform-origin',
	    'transform-style',
	    'transition',
	    'transition-delay',
	    'transition-duration',
	    'transition-property',
	    'transition-timing-function',
	    'unicode-bidi',
	    'vertical-align',
	    'visibility',
	    'white-space',
	    'widows',
	    'width',
	    'word-break',
	    'word-spacing',
	    'word-wrap',
	    'z-index'
	  ];
	
	  // illegals
	  var ILLEGAL = [
	    '\\?',
	    '(\\bReturn\\b)', // monkey
	    '(\\bEnd\\b)', // monkey
	    '(\\bend\\b)', // vbscript
	    '(\\bdef\\b)', // gradle
	    ';', // a whole lot of languages
	    '#\\s', // markdown
	    '\\*\\s', // markdown
	    '===\\s', // markdown
	    '\\|',
	    '%', // prolog
	  ];
	
	  return {
	    aliases: ['styl'],
	    case_insensitive: false,
	    keywords: 'if else for in',
	    illegal: '(' + ILLEGAL.join('|') + ')',
	    contains: [
	
	      // strings
	      hljs.QUOTE_STRING_MODE,
	      hljs.APOS_STRING_MODE,
	
	      // comments
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	
	      // hex colors
	      HEX_COLOR,
	
	      // class tag
	      {
	        begin: '\\.[a-zA-Z][a-zA-Z0-9_-]*' + TAG_END,
	        returnBegin: true,
	        contains: [
	          {className: 'selector-class', begin: '\\.[a-zA-Z][a-zA-Z0-9_-]*'}
	        ]
	      },
	
	      // id tag
	      {
	        begin: '\\#[a-zA-Z][a-zA-Z0-9_-]*' + TAG_END,
	        returnBegin: true,
	        contains: [
	          {className: 'selector-id', begin: '\\#[a-zA-Z][a-zA-Z0-9_-]*'}
	        ]
	      },
	
	      // tags
	      {
	        begin: '\\b(' + TAGS.join('|') + ')' + TAG_END,
	        returnBegin: true,
	        contains: [
	          {className: 'selector-tag', begin: '\\b[a-zA-Z][a-zA-Z0-9_-]*'}
	        ]
	      },
	
	      // psuedo selectors
	      {
	        begin: '&?:?:\\b(' + PSEUDO_SELECTORS.join('|') + ')' + TAG_END
	      },
	
	      // @ keywords
	      {
	        begin: '\@(' + AT_KEYWORDS.join('|') + ')\\b'
	      },
	
	      // variables
	      VARIABLE,
	
	      // dimension
	      hljs.CSS_NUMBER_MODE,
	
	      // number
	      hljs.NUMBER_MODE,
	
	      // functions
	      //  - only from beginning of line + whitespace
	      {
	        className: 'function',
	        begin: '^[a-zA-Z][a-zA-Z0-9_\-]*\\(.*\\)',
	        illegal: '[\\n]',
	        returnBegin: true,
	        contains: [
	          {className: 'title', begin: '\\b[a-zA-Z][a-zA-Z0-9_\-]*'},
	          {
	            className: 'params',
	            begin: /\(/,
	            end: /\)/,
	            contains: [
	              HEX_COLOR,
	              VARIABLE,
	              hljs.APOS_STRING_MODE,
	              hljs.CSS_NUMBER_MODE,
	              hljs.NUMBER_MODE,
	              hljs.QUOTE_STRING_MODE
	            ]
	          }
	        ]
	      },
	
	      // attributes
	      //  - only from beginning of line + whitespace
	      //  - must have whitespace after it
	      {
	        className: 'attribute',
	        begin: '\\b(' + ATTRIBUTES.reverse().join('|') + ')\\b',
	        starts: {
	          // value container
	          end: /;|$/,
	          contains: [
	            HEX_COLOR,
	            VARIABLE,
	            hljs.APOS_STRING_MODE,
	            hljs.QUOTE_STRING_MODE,
	            hljs.CSS_NUMBER_MODE,
	            hljs.NUMBER_MODE,
	            hljs.C_BLOCK_COMMENT_MODE
	          ],
	          illegal: /\./,
	          relevance: 0
	        }
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/subunit.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var DETAILS = {
	    className: 'string',
	    begin: '\\[\n(multipart)?', end: '\\]\n'
	  };
	  var TIME = {
	    className: 'string',
	    begin: '\\d{4}-\\d{2}-\\d{2}(\\s+)\\d{2}:\\d{2}:\\d{2}\.\\d+Z'
	  };
	  var PROGRESSVALUE = {
	    className: 'string',
	    begin: '(\\+|-)\\d+'
	  };
	  var KEYWORDS = {
	    className: 'keyword',
	    relevance: 10,
	    variants: [
	      { begin: '^(test|testing|success|successful|failure|error|skip|xfail|uxsuccess)(:?)\\s+(test)?' },
	      { begin: '^progress(:?)(\\s+)?(pop|push)?' },
	      { begin: '^tags:' },
	      { begin: '^time:' }
	    ],
	  };
	  return {
	    case_insensitive: true,
	    contains: [
	      DETAILS,
	      TIME,
	      PROGRESSVALUE,
	      KEYWORDS
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/swift.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var SWIFT_KEYWORDS = {
	      keyword: '__COLUMN__ __FILE__ __FUNCTION__ __LINE__ as as! as? associativity ' +
	        'break case catch class continue convenience default defer deinit didSet do ' +
	        'dynamic dynamicType else enum extension fallthrough false fileprivate final for func ' +
	        'get guard if import in indirect infix init inout internal is lazy left let ' +
	        'mutating nil none nonmutating open operator optional override postfix precedence ' +
	        'prefix private protocol Protocol public repeat required rethrows return ' +
	        'right self Self set static struct subscript super switch throw throws true ' +
	        'try try! try? Type typealias unowned var weak where while willSet',
	      literal: 'true false nil',
	      built_in: 'abs advance alignof alignofValue anyGenerator assert assertionFailure ' +
	        'bridgeFromObjectiveC bridgeFromObjectiveCUnconditional bridgeToObjectiveC ' +
	        'bridgeToObjectiveCUnconditional c contains count countElements countLeadingZeros ' +
	        'debugPrint debugPrintln distance dropFirst dropLast dump encodeBitsAsWords ' +
	        'enumerate equal fatalError filter find getBridgedObjectiveCType getVaList ' +
	        'indices insertionSort isBridgedToObjectiveC isBridgedVerbatimToObjectiveC ' +
	        'isUniquelyReferenced isUniquelyReferencedNonObjC join lazy lexicographicalCompare ' +
	        'map max maxElement min minElement numericCast overlaps partition posix ' +
	        'precondition preconditionFailure print println quickSort readLine reduce reflect ' +
	        'reinterpretCast reverse roundUpToAlignment sizeof sizeofValue sort split ' +
	        'startsWith stride strideof strideofValue swap toString transcode ' +
	        'underestimateCount unsafeAddressOf unsafeBitCast unsafeDowncast unsafeUnwrap ' +
	        'unsafeReflect withExtendedLifetime withObjectAtPlusZero withUnsafePointer ' +
	        'withUnsafePointerToObject withUnsafeMutablePointer withUnsafeMutablePointers ' +
	        'withUnsafePointer withUnsafePointers withVaList zip'
	    };
	
	  var TYPE = {
	    className: 'type',
	    begin: '\\b[A-Z][\\w\u00C0-\u02B8\']*',
	    relevance: 0
	  };
	  var BLOCK_COMMENT = hljs.COMMENT(
	    '/\\*',
	    '\\*/',
	    {
	      contains: ['self']
	    }
	  );
	  var SUBST = {
	    className: 'subst',
	    begin: /\\\(/, end: '\\)',
	    keywords: SWIFT_KEYWORDS,
	    contains: [] // assigned later
	  };
	  var NUMBERS = {
	      className: 'number',
	      begin: '\\b([\\d_]+(\\.[\\deE_]+)?|0x[a-fA-F0-9_]+(\\.[a-fA-F0-9p_]+)?|0b[01_]+|0o[0-7_]+)\\b',
	      relevance: 0
	  };
	  var QUOTE_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
	    contains: [SUBST, hljs.BACKSLASH_ESCAPE]
	  });
	  SUBST.contains = [NUMBERS];
	
	  return {
	    keywords: SWIFT_KEYWORDS,
	    contains: [
	      QUOTE_STRING_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      BLOCK_COMMENT,
	      TYPE,
	      NUMBERS,
	      {
	        className: 'function',
	        beginKeywords: 'func', end: '{', excludeEnd: true,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {
	            begin: /[A-Za-z$_][0-9A-Za-z$_]*/
	          }),
	          {
	            begin: /</, end: />/
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/, endsParent: true,
	            keywords: SWIFT_KEYWORDS,
	            contains: [
	              'self',
	              NUMBERS,
	              QUOTE_STRING_MODE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              {begin: ':'} // relevance booster
	            ],
	            illegal: /["']/
	          }
	        ],
	        illegal: /\[|%/
	      },
	      {
	        className: 'class',
	        beginKeywords: 'struct protocol class extension enum',
	        keywords: SWIFT_KEYWORDS,
	        end: '\\{',
	        excludeEnd: true,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][\u00C0-\u02B80-9A-Za-z$_]*/})
	        ]
	      },
	      {
	        className: 'meta', // @attributes
	        begin: '(@warn_unused_result|@exported|@lazy|@noescape|' +
	                  '@NSCopying|@NSManaged|@objc|@convention|@required|' +
	                  '@noreturn|@IBAction|@IBDesignable|@IBInspectable|@IBOutlet|' +
	                  '@infix|@prefix|@postfix|@autoclosure|@testable|@available|' +
	                  '@nonobjc|@NSApplicationMain|@UIApplicationMain)'
	
	      },
	      {
	        beginKeywords: 'import', end: /$/,
	        contains: [hljs.C_LINE_COMMENT_MODE, BLOCK_COMMENT]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/taggerscript.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	
	  var COMMENT = {
	    className: 'comment',
	    begin: /\$noop\(/,
	    end: /\)/,
	    contains: [{
	      begin: /\(/,
	      end: /\)/,
	      contains: ['self', {
	        begin: /\\./
	      }]
	    }],
	    relevance: 10
	  };
	
	  var FUNCTION = {
	    className: 'keyword',
	    begin: /\$(?!noop)[a-zA-Z][_a-zA-Z0-9]*/,
	    end: /\(/,
	    excludeEnd: true
	  };
	
	  var VARIABLE = {
	    className: 'variable',
	    begin: /%[_a-zA-Z0-9:]*/,
	    end: '%'
	  };
	
	  var ESCAPE_SEQUENCE = {
	    className: 'symbol',
	    begin: /\\./
	  };
	
	  return {
	    contains: [
	      COMMENT,
	      FUNCTION,
	      VARIABLE,
	      ESCAPE_SEQUENCE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/tap.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    case_insensitive: true,
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      // version of format and total amount of testcases
	      {
	        className: 'meta',
	        variants: [
	          { begin: '^TAP version (\\d+)$' },
	          { begin: '^1\\.\\.(\\d+)$' }
	        ],
	      },
	      // YAML block
	      {
	        begin: '(\s+)?---$', end: '\\.\\.\\.$',
	        subLanguage: 'yaml',
	        relevance: 0
	      },
		  // testcase number
	      {
	        className: 'number',
	        begin: ' (\\d+) '
	      },
		  // testcase status and description
	      {
	        className: 'symbol',
	        variants: [
	          { begin: '^ok' },
	          { begin: '^not ok' }
	        ],
	      },
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/tcl.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['tk'],
	    keywords: 'after append apply array auto_execok auto_import auto_load auto_mkindex ' +
	      'auto_mkindex_old auto_qualify auto_reset bgerror binary break catch cd chan clock ' +
	      'close concat continue dde dict encoding eof error eval exec exit expr fblocked ' +
	      'fconfigure fcopy file fileevent filename flush for foreach format gets glob global ' +
	      'history http if incr info interp join lappend|10 lassign|10 lindex|10 linsert|10 list ' +
	      'llength|10 load lrange|10 lrepeat|10 lreplace|10 lreverse|10 lsearch|10 lset|10 lsort|10 '+
	      'mathfunc mathop memory msgcat namespace open package parray pid pkg::create pkg_mkIndex '+
	      'platform platform::shell proc puts pwd read refchan regexp registry regsub|10 rename '+
	      'return safe scan seek set socket source split string subst switch tcl_endOfWord '+
	      'tcl_findLibrary tcl_startOfNextWord tcl_startOfPreviousWord tcl_wordBreakAfter '+
	      'tcl_wordBreakBefore tcltest tclvars tell time tm trace unknown unload unset update '+
	      'uplevel upvar variable vwait while',
	    contains: [
	      hljs.COMMENT(';[ \\t]*#', '$'),
	      hljs.COMMENT('^[ \\t]*#', '$'),
	      {
	        beginKeywords: 'proc',
	        end: '[\\{]',
	        excludeEnd: true,
	        contains: [
	          {
	            className: 'title',
	            begin: '[ \\t\\n\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*',
	            end: '[ \\t\\n\\r]',
	            endsWithParent: true,
	            excludeEnd: true
	          }
	        ]
	      },
	      {
	        excludeEnd: true,
	        variants: [
	          {
	            begin: '\\$(\\{)?(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*\\(([a-zA-Z0-9_])*\\)',
	            end: '[^a-zA-Z0-9_\\}\\$]'
	          },
	          {
	            begin: '\\$(\\{)?(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*',
	            end: '(\\))?[^a-zA-Z0-9_\\}\\$]'
	          }
	        ]
	      },
	      {
	        className: 'string',
	        contains: [hljs.BACKSLASH_ESCAPE],
	        variants: [
	          hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	          hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
	        ]
	      },
	      {
	        className: 'number',
	        variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]
	      }
	    ]
	  }
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/tex.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var COMMAND = {
	    className: 'tag',
	    begin: /\\/,
	    relevance: 0,
	    contains: [
	      {
	        className: 'name',
	        variants: [
	          {begin: /[a-zA-Zа-яА-я]+[*]?/},
	          {begin: /[^a-zA-Zа-яА-я0-9]/}
	        ],
	        starts: {
	          endsWithParent: true,
	          relevance: 0,
	          contains: [
	            {
	              className: 'string', // because it looks like attributes in HTML tags
	              variants: [
	                {begin: /\[/, end: /\]/},
	                {begin: /\{/, end: /\}/}
	              ]
	            },
	            {
	              begin: /\s*=\s*/, endsWithParent: true,
	              relevance: 0,
	              contains: [
	                {
	                  className: 'number',
	                  begin: /-?\d*\.?\d+(pt|pc|mm|cm|in|dd|cc|ex|em)?/
	                }
	              ]
	            }
	          ]
	        }
	      }
	    ]
	  };
	
	  return {
	    contains: [
	      COMMAND,
	      {
	        className: 'formula',
	        contains: [COMMAND],
	        relevance: 0,
	        variants: [
	          {begin: /\$\$/, end: /\$\$/},
	          {begin: /\$/, end: /\$/}
	        ]
	      },
	      hljs.COMMENT(
	        '%',
	        '$',
	        {
	          relevance: 0
	        }
	      )
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/thrift.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var BUILT_IN_TYPES = 'bool byte i16 i32 i64 double string binary';
	  return {
	    keywords: {
	      keyword:
	        'namespace const typedef struct enum service exception void oneway set list map required optional',
	      built_in:
	        BUILT_IN_TYPES,
	      literal:
	        'true false'
	    },
	    contains: [
	      hljs.QUOTE_STRING_MODE,
	      hljs.NUMBER_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'struct enum service exception', end: /\{/,
	        illegal: /\n/,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {
	            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
	          })
	        ]
	      },
	      {
	        begin: '\\b(set|list|map)\\s*<', end: '>',
	        keywords: BUILT_IN_TYPES,
	        contains: ['self']
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/tp.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var TPID = {
	    className: 'number',
	    begin: '[1-9][0-9]*', /* no leading zeros */
	    relevance: 0
	  };
	  var TPLABEL = {
	    className: 'symbol',
	    begin: ':[^\\]]+'
	  };
	  var TPDATA = {
	    className: 'built_in',
	    begin: '(AR|P|PAYLOAD|PR|R|SR|RSR|LBL|VR|UALM|MESSAGE|UTOOL|UFRAME|TIMER|\
	    TIMER_OVERFLOW|JOINT_MAX_SPEED|RESUME_PROG|DIAG_REC)\\[', end: '\\]',
	    contains: [
	      'self',
	      TPID,
	      TPLABEL
	    ]
	  };
	  var TPIO = {
	    className: 'built_in',
	    begin: '(AI|AO|DI|DO|F|RI|RO|UI|UO|GI|GO|SI|SO)\\[', end: '\\]',
	    contains: [
	      'self',
	      TPID,
	      hljs.QUOTE_STRING_MODE, /* for pos section at bottom */
	      TPLABEL
	    ]
	  };
	
	  return {
	    keywords: {
	      keyword:
	        'ABORT ACC ADJUST AND AP_LD BREAK CALL CNT COL CONDITION CONFIG DA DB ' +
	        'DIV DETECT ELSE END ENDFOR ERR_NUM ERROR_PROG FINE FOR GP GUARD INC ' +
	        'IF JMP LINEAR_MAX_SPEED LOCK MOD MONITOR OFFSET Offset OR OVERRIDE ' +
	        'PAUSE PREG PTH RT_LD RUN SELECT SKIP Skip TA TB TO TOOL_OFFSET ' +
	        'Tool_Offset UF UT UFRAME_NUM UTOOL_NUM UNLOCK WAIT X Y Z W P R STRLEN ' +
	        'SUBSTR FINDSTR VOFFSET PROG ATTR MN POS',
	      literal:
	        'ON OFF max_speed LPOS JPOS ENABLE DISABLE START STOP RESET'
	    },
	    contains: [
	      TPDATA,
	      TPIO,
	      {
	        className: 'keyword',
	        begin: '/(PROG|ATTR|MN|POS|END)\\b'
	      },
	      {
	        /* this is for cases like ,CALL */
	        className: 'keyword',
	        begin: '(CALL|RUN|POINT_LOGIC|LBL)\\b'
	      },
	      {
	        /* this is for cases like CNT100 where the default lexemes do not
	         * separate the keyword and the number */
	        className: 'keyword',
	        begin: '\\b(ACC|CNT|Skip|Offset|PSPD|RT_LD|AP_LD|Tool_Offset)'
	      },
	      {
	        /* to catch numbers that do not have a word boundary on the left */
	        className: 'number',
	        begin: '\\d+(sec|msec|mm/sec|cm/min|inch/min|deg/sec|mm|in|cm)?\\b',
	        relevance: 0
	      },
	      hljs.COMMENT('//', '[;$]'),
	      hljs.COMMENT('!', '[;$]'),
	      hljs.COMMENT('--eg:', '$'),
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: '\'', end: '\''
	      },
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'variable',
	        begin: '\\$[A-Za-z0-9_]+'
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/twig.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)'
	  };
	
	  var FUNCTION_NAMES = 'attribute block constant cycle date dump include ' +
	                  'max min parent random range source template_from_string';
	
	  var FUNCTIONS = {
	    beginKeywords: FUNCTION_NAMES,
	    keywords: {name: FUNCTION_NAMES},
	    relevance: 0,
	    contains: [
	      PARAMS
	    ]
	  };
	
	  var FILTER = {
	    begin: /\|[A-Za-z_]+:?/,
	    keywords:
	      'abs batch capitalize convert_encoding date date_modify default ' +
	      'escape first format join json_encode keys last length lower ' +
	      'merge nl2br number_format raw replace reverse round slice sort split ' +
	      'striptags title trim upper url_encode',
	    contains: [
	      FUNCTIONS
	    ]
	  };
	
	  var TAGS = 'autoescape block do embed extends filter flush for ' +
	    'if import include macro sandbox set spaceless use verbatim';
	
	  TAGS = TAGS + ' ' + TAGS.split(' ').map(function(t){return 'end' + t}).join(' ');
	
	  return {
	    aliases: ['craftcms'],
	    case_insensitive: true,
	    subLanguage: 'xml',
	    contains: [
	      hljs.COMMENT(/\{#/, /#}/),
	      {
	        className: 'template-tag',
	        begin: /\{%/, end: /%}/,
	        contains: [
	          {
	            className: 'name',
	            begin: /\w+/,
	            keywords: TAGS,
	            starts: {
	              endsWithParent: true,
	              contains: [FILTER, FUNCTIONS],
	              relevance: 0
	            }
	          }
	        ]
	      },
	      {
	        className: 'template-variable',
	        begin: /\{\{/, end: /}}/,
	        contains: ['self', FILTER, FUNCTIONS]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/typescript.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      'in if for while finally var new function do return void else break catch ' +
	      'instanceof with throw case default try this switch continue typeof delete ' +
	      'let yield const class public private protected get set super ' +
	      'static implements enum export import declare type namespace abstract ' +
	      'as from extends async await',
	    literal:
	      'true false null undefined NaN Infinity',
	    built_in:
	      'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
	      'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
	      'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
	      'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
	      'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
	      'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
	      'module console window document any number boolean string void Promise'
	  };
	
	  return {
	    aliases: ['ts'],
	    keywords: KEYWORDS,
	    contains: [
	      {
	        className: 'meta',
	        begin: /^\s*['"]use strict['"]/
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      { // template string
	        className: 'string',
	        begin: '`', end: '`',
	        contains: [
	          hljs.BACKSLASH_ESCAPE,
	          {
	            className: 'subst',
	            begin: '\\$\\{', end: '\\}'
	          }
	        ]
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'number',
	        variants: [
	          { begin: '\\b(0[bB][01]+)' },
	          { begin: '\\b(0[oO][0-7]+)' },
	          { begin: hljs.C_NUMBER_RE }
	        ],
	        relevance: 0
	      },
	      { // "value" container
	        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
	        keywords: 'return throw case',
	        contains: [
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          hljs.REGEXP_MODE,
	          {
	            className: 'function',
	            begin: '(\\(.*?\\)|' + hljs.IDENT_RE + ')\\s*=>', returnBegin: true,
	            end: '\\s*=>',
	            contains: [
	              {
	                className: 'params',
	                variants: [
	                  {
	                    begin: hljs.IDENT_RE
	                  },
	                  {
	                    begin: /\(\s*\)/,
	                  },
	                  {
	                    begin: /\(/, end: /\)/,
	                    excludeBegin: true, excludeEnd: true,
	                    keywords: KEYWORDS,
	                    contains: [
	                      'self',
	                      hljs.C_LINE_COMMENT_MODE,
	                      hljs.C_BLOCK_COMMENT_MODE
	                    ]
	                  }
	                ]
	              }
	            ]
	          }
	        ],
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: 'function', end: /[\{;]/, excludeEnd: true,
	        keywords: KEYWORDS,
	        contains: [
	          'self',
	          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][0-9A-Za-z$_]*/}),
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            excludeBegin: true,
	            excludeEnd: true,
	            keywords: KEYWORDS,
	            contains: [
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ],
	            illegal: /["'\(]/
	          }
	        ],
	        illegal: /%/,
	        relevance: 0 // () => {} is more typical in TypeScript
	      },
	      {
	        beginKeywords: 'constructor', end: /\{/, excludeEnd: true,
	        contains: [
	          'self',
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            excludeBegin: true,
	            excludeEnd: true,
	            keywords: KEYWORDS,
	            contains: [
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ],
	            illegal: /["'\(]/
	          }
	        ]
	      },
	      { // prevent references like module.id from being higlighted as module definitions
	        begin: /module\./,
	        keywords: {built_in: 'module'},
	        relevance: 0
	      },
	      {
	        beginKeywords: 'module', end: /\{/, excludeEnd: true
	      },
	      {
	        beginKeywords: 'interface', end: /\{/, excludeEnd: true,
	        keywords: 'interface extends'
	      },
	      {
	        begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
	      },
	      {
	        begin: '\\.' + hljs.IDENT_RE, relevance: 0 // hack: prevents detection of keywords after dots
	      },
	      {
	        className: 'meta', begin: '@[A-Za-z]+'
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/vala.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    keywords: {
	      keyword:
	        // Value types
	        'char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 ' +
	        'uint16 uint32 uint64 float double bool struct enum string void ' +
	        // Reference types
	        'weak unowned owned ' +
	        // Modifiers
	        'async signal static abstract interface override virtual delegate ' +
	        // Control Structures
	        'if while do for foreach else switch case break default return try catch ' +
	        // Visibility
	        'public private protected internal ' +
	        // Other
	        'using new this get set const stdout stdin stderr var',
	      built_in:
	        'DBus GLib CCode Gee Object Gtk Posix',
	      literal:
	        'false true null'
	    },
	    contains: [
	      {
	        className: 'class',
	        beginKeywords: 'class interface namespace', end: '{', excludeEnd: true,
	        illegal: '[^,:\\n\\s\\.]',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'string',
	        begin: '"""', end: '"""',
	        relevance: 5
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'meta',
	        begin: '^#', end: '$',
	        relevance: 2
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/vbnet.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['vb'],
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'addhandler addressof alias and andalso aggregate ansi as assembly auto binary by byref byval ' + /* a-b */
	        'call case catch class compare const continue custom declare default delegate dim distinct do ' + /* c-d */
	        'each equals else elseif end enum erase error event exit explicit finally for friend from function ' + /* e-f */
	        'get global goto group handles if implements imports in inherits interface into is isfalse isnot istrue ' + /* g-i */
	        'join key let lib like loop me mid mod module mustinherit mustoverride mybase myclass ' + /* j-m */
	        'namespace narrowing new next not notinheritable notoverridable ' + /* n */
	        'of off on operator option optional or order orelse overloads overridable overrides ' + /* o */
	        'paramarray partial preserve private property protected public ' + /* p */
	        'raiseevent readonly redim rem removehandler resume return ' + /* r */
	        'select set shadows shared skip static step stop structure strict sub synclock ' + /* s */
	        'take text then throw to try unicode until using when where while widening with withevents writeonly xor', /* t-x */
	      built_in:
	        'boolean byte cbool cbyte cchar cdate cdec cdbl char cint clng cobj csbyte cshort csng cstr ctype ' +  /* b-c */
	        'date decimal directcast double gettype getxmlnamespace iif integer long object ' + /* d-o */
	        'sbyte short single string trycast typeof uinteger ulong ushort', /* s-u */
	      literal:
	        'true false nothing'
	    },
	    illegal: '//|{|}|endif|gosub|variant|wend', /* reserved deprecated keywords */
	    contains: [
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [{begin: '""'}]}),
	      hljs.COMMENT(
	        '\'',
	        '$',
	        {
	          returnBegin: true,
	          contains: [
	            {
	              className: 'doctag',
	              begin: '\'\'\'|<!--|-->',
	              contains: [hljs.PHRASAL_WORDS_MODE]
	            },
	            {
	              className: 'doctag',
	              begin: '</?', end: '>',
	              contains: [hljs.PHRASAL_WORDS_MODE]
	            }
	          ]
	        }
	      ),
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'meta',
	        begin: '#', end: '$',
	        keywords: {'meta-keyword': 'if else elseif end region externalsource'}
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/vbscript-html.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    subLanguage: 'xml',
	    contains: [
	      {
	        begin: '<%', end: '%>',
	        subLanguage: 'vbscript'
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/vbscript.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    aliases: ['vbs'],
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'call class const dim do loop erase execute executeglobal exit for each next function ' +
	        'if then else on error option explicit new private property let get public randomize ' +
	        'redim rem select case set stop sub while wend with end to elseif is or xor and not ' +
	        'class_initialize class_terminate default preserve in me byval byref step resume goto',
	      built_in:
	        'lcase month vartype instrrev ubound setlocale getobject rgb getref string ' +
	        'weekdayname rnd dateadd monthname now day minute isarray cbool round formatcurrency ' +
	        'conversions csng timevalue second year space abs clng timeserial fixs len asc ' +
	        'isempty maths dateserial atn timer isobject filter weekday datevalue ccur isdate ' +
	        'instr datediff formatdatetime replace isnull right sgn array snumeric log cdbl hex ' +
	        'chr lbound msgbox ucase getlocale cos cdate cbyte rtrim join hour oct typename trim ' +
	        'strcomp int createobject loadpicture tan formatnumber mid scriptenginebuildversion ' +
	        'scriptengine split scriptengineminorversion cint sin datepart ltrim sqr ' +
	        'scriptenginemajorversion time derived eval date formatpercent exp inputbox left ascw ' +
	        'chrw regexp server response request cstr err',
	      literal:
	        'true false null nothing empty'
	    },
	    illegal: '//',
	    contains: [
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [{begin: '""'}]}),
	      hljs.COMMENT(
	        /'/,
	        /$/,
	        {
	          relevance: 0
	        }
	      ),
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/verilog.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var SV_KEYWORDS = {
	    keyword:
	      'accept_on alias always always_comb always_ff always_latch and assert assign ' +
	      'assume automatic before begin bind bins binsof bit break buf|0 bufif0 bufif1 ' +
	      'byte case casex casez cell chandle checker class clocking cmos config const ' +
	      'constraint context continue cover covergroup coverpoint cross deassign default ' +
	      'defparam design disable dist do edge else end endcase endchecker endclass ' +
	      'endclocking endconfig endfunction endgenerate endgroup endinterface endmodule ' +
	      'endpackage endprimitive endprogram endproperty endspecify endsequence endtable ' +
	      'endtask enum event eventually expect export extends extern final first_match for ' +
	      'force foreach forever fork forkjoin function generate|5 genvar global highz0 highz1 ' +
	      'if iff ifnone ignore_bins illegal_bins implements implies import incdir include ' +
	      'initial inout input inside instance int integer interconnect interface intersect ' +
	      'join join_any join_none large let liblist library local localparam logic longint ' +
	      'macromodule matches medium modport module nand negedge nettype new nexttime nmos ' +
	      'nor noshowcancelled not notif0 notif1 or output package packed parameter pmos ' +
	      'posedge primitive priority program property protected pull0 pull1 pulldown pullup ' +
	      'pulsestyle_ondetect pulsestyle_onevent pure rand randc randcase randsequence rcmos ' +
	      'real realtime ref reg reject_on release repeat restrict return rnmos rpmos rtran ' +
	      'rtranif0 rtranif1 s_always s_eventually s_nexttime s_until s_until_with scalared ' +
	      'sequence shortint shortreal showcancelled signed small soft solve specify specparam ' +
	      'static string strong strong0 strong1 struct super supply0 supply1 sync_accept_on ' +
	      'sync_reject_on table tagged task this throughout time timeprecision timeunit tran ' +
	      'tranif0 tranif1 tri tri0 tri1 triand trior trireg type typedef union unique unique0 ' +
	      'unsigned until until_with untyped use uwire var vectored virtual void wait wait_order ' +
	      'wand weak weak0 weak1 while wildcard wire with within wor xnor xor',
	    literal:
	      'null',
	    built_in:
	      '$finish $stop $exit $fatal $error $warning $info $realtime $time $printtimescale ' +
	      '$bitstoreal $bitstoshortreal $itor $signed $cast $bits $stime $timeformat ' +
	      '$realtobits $shortrealtobits $rtoi $unsigned $asserton $assertkill $assertpasson ' +
	      '$assertfailon $assertnonvacuouson $assertoff $assertcontrol $assertpassoff ' +
	      '$assertfailoff $assertvacuousoff $isunbounded $sampled $fell $changed $past_gclk ' +
	      '$fell_gclk $changed_gclk $rising_gclk $steady_gclk $coverage_control ' +
	      '$coverage_get $coverage_save $set_coverage_db_name $rose $stable $past ' +
	      '$rose_gclk $stable_gclk $future_gclk $falling_gclk $changing_gclk $display ' +
	      '$coverage_get_max $coverage_merge $get_coverage $load_coverage_db $typename ' +
	      '$unpacked_dimensions $left $low $increment $clog2 $ln $log10 $exp $sqrt $pow ' +
	      '$floor $ceil $sin $cos $tan $countbits $onehot $isunknown $fatal $warning ' +
	      '$dimensions $right $high $size $asin $acos $atan $atan2 $hypot $sinh $cosh ' +
	      '$tanh $asinh $acosh $atanh $countones $onehot0 $error $info $random ' +
	      '$dist_chi_square $dist_erlang $dist_exponential $dist_normal $dist_poisson ' +
	      '$dist_t $dist_uniform $q_initialize $q_remove $q_exam $async$and$array ' +
	      '$async$nand$array $async$or$array $async$nor$array $sync$and$array ' +
	      '$sync$nand$array $sync$or$array $sync$nor$array $q_add $q_full $psprintf ' +
	      '$async$and$plane $async$nand$plane $async$or$plane $async$nor$plane ' +
	      '$sync$and$plane $sync$nand$plane $sync$or$plane $sync$nor$plane $system ' +
	      '$display $displayb $displayh $displayo $strobe $strobeb $strobeh $strobeo ' +
	      '$write $readmemb $readmemh $writememh $value$plusargs ' +
	      '$dumpvars $dumpon $dumplimit $dumpports $dumpportson $dumpportslimit ' +
	      '$writeb $writeh $writeo $monitor $monitorb $monitorh $monitoro $writememb ' +
	      '$dumpfile $dumpoff $dumpall $dumpflush $dumpportsoff $dumpportsall ' +
	      '$dumpportsflush $fclose $fdisplay $fdisplayb $fdisplayh $fdisplayo ' +
	      '$fstrobe $fstrobeb $fstrobeh $fstrobeo $swrite $swriteb $swriteh ' +
	      '$swriteo $fscanf $fread $fseek $fflush $feof $fopen $fwrite $fwriteb ' +
	      '$fwriteh $fwriteo $fmonitor $fmonitorb $fmonitorh $fmonitoro $sformat ' +
	      '$sformatf $fgetc $ungetc $fgets $sscanf $rewind $ftell $ferror'
	    };
	  return {
	    aliases: ['v', 'sv', 'svh'],
	    case_insensitive: false,
	    keywords: SV_KEYWORDS, lexemes: /[\w\$]+/,
	    contains: [
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'number',
	        contains: [hljs.BACKSLASH_ESCAPE],
	        variants: [
	          {begin: '\\b((\\d+\'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)'},
	          {begin: '\\B((\'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)'},
	          {begin: '\\b([0-9_])+', relevance: 0}
	        ]
	      },
	      /* parameters to instances */
	      {
	        className: 'variable',
	        variants: [
	          {begin: '#\\((?!parameter).+\\)'},
	          {begin: '\\.\\w+', relevance: 0},
	        ]
	      },
	      {
	        className: 'meta',
	        begin: '`', end: '$',
	        keywords: {'meta-keyword': 'define __FILE__ ' +
	          '__LINE__ begin_keywords celldefine default_nettype define ' +
	          'else elsif end_keywords endcelldefine endif ifdef ifndef ' +
	          'include line nounconnected_drive pragma resetall timescale ' +
	          'unconnected_drive undef undefineall'},
	        relevance: 0
	      }
	    ]
	  }; // return
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/vhdl.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  // Regular expression for VHDL numeric literals.
	
	  // Decimal literal:
	  var INTEGER_RE = '\\d(_|\\d)*';
	  var EXPONENT_RE = '[eE][-+]?' + INTEGER_RE;
	  var DECIMAL_LITERAL_RE = INTEGER_RE + '(\\.' + INTEGER_RE + ')?' + '(' + EXPONENT_RE + ')?';
	  // Based literal:
	  var BASED_INTEGER_RE = '\\w+';
	  var BASED_LITERAL_RE = INTEGER_RE + '#' + BASED_INTEGER_RE + '(\\.' + BASED_INTEGER_RE + ')?' + '#' + '(' + EXPONENT_RE + ')?';
	
	  var NUMBER_RE = '\\b(' + BASED_LITERAL_RE + '|' + DECIMAL_LITERAL_RE + ')';
	
	  return {
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'abs access after alias all and architecture array assert assume assume_guarantee attribute ' +
	        'begin block body buffer bus case component configuration constant context cover disconnect ' +
	        'downto default else elsif end entity exit fairness file for force function generate ' +
	        'generic group guarded if impure in inertial inout is label library linkage literal ' +
	        'loop map mod nand new next nor not null of on open or others out package port ' +
	        'postponed procedure process property protected pure range record register reject ' +
	        'release rem report restrict restrict_guarantee return rol ror select sequence ' +
	        'severity shared signal sla sll sra srl strong subtype then to transport type ' +
	        'unaffected units until use variable vmode vprop vunit wait when while with xnor xor',
	      built_in:
	        'boolean bit character ' +
	        'integer time delay_length natural positive ' +
	        'string bit_vector file_open_kind file_open_status ' +
	        'std_logic std_logic_vector unsigned signed boolean_vector integer_vector ' +
	        'std_ulogic std_ulogic_vector unresolved_unsigned u_unsigned unresolved_signed u_signed' +
	        'real_vector time_vector',
	      literal:
	        'false true note warning error failure ' +  // severity_level
	        'line text side width'                      // textio
	    },
	    illegal: '{',
	    contains: [
	      hljs.C_BLOCK_COMMENT_MODE,      // VHDL-2008 block commenting.
	      hljs.COMMENT('--', '$'),
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'number',
	        begin: NUMBER_RE,
	        relevance: 0
	      },
	      {
	        className: 'string',
	        begin: '\'(U|X|0|1|Z|W|L|H|-)\'',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        className: 'symbol',
	        begin: '\'[A-Za-z](_?[A-Za-z0-9])*',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/vim.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    lexemes: /[!#@\w]+/,
	    keywords: {
	      keyword:
	        // express version except: ! & * < = > !! # @ @@
	        'N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope '+
	        'cp cpf cq cr cs cst cu cuna cunme cw delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu go gr grepa gu gv ha helpf helpg helpt hi hid his ia iabc if ij il im imapc '+
	        'ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 '+
	        'profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf quita qa rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor '+
	        'so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew '+
	        'tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ '+
	        // full version
	        'Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload '+
	        'bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap '+
	        'cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor '+
	        'endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap '+
	        'imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview '+
	        'lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap '+
	        'nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext '+
	        'ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding '+
	        'scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace '+
	        'startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious '+'trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew '+
	        'vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank',
	      built_in: //built in func
	        'synIDtrans atan2 range matcharg did_filetype asin feedkeys xor argv ' +
	        'complete_check add getwinposx getqflist getwinposy screencol ' +
	        'clearmatches empty extend getcmdpos mzeval garbagecollect setreg ' +
	        'ceil sqrt diff_hlID inputsecret get getfperm getpid filewritable ' +
	        'shiftwidth max sinh isdirectory synID system inputrestore winline ' +
	        'atan visualmode inputlist tabpagewinnr round getregtype mapcheck ' +
	        'hasmapto histdel argidx findfile sha256 exists toupper getcmdline ' +
	        'taglist string getmatches bufnr strftime winwidth bufexists ' +
	        'strtrans tabpagebuflist setcmdpos remote_read printf setloclist ' +
	        'getpos getline bufwinnr float2nr len getcmdtype diff_filler luaeval ' +
	        'resolve libcallnr foldclosedend reverse filter has_key bufname ' +
	        'str2float strlen setline getcharmod setbufvar index searchpos ' +
	        'shellescape undofile foldclosed setqflist buflisted strchars str2nr ' +
	        'virtcol floor remove undotree remote_expr winheight gettabwinvar ' +
	        'reltime cursor tabpagenr finddir localtime acos getloclist search ' +
	        'tanh matchend rename gettabvar strdisplaywidth type abs py3eval ' +
	        'setwinvar tolower wildmenumode log10 spellsuggest bufloaded ' +
	        'synconcealed nextnonblank server2client complete settabwinvar ' +
	        'executable input wincol setmatches getftype hlID inputsave ' +
	        'searchpair or screenrow line settabvar histadd deepcopy strpart ' +
	        'remote_peek and eval getftime submatch screenchar winsaveview ' +
	        'matchadd mkdir screenattr getfontname libcall reltimestr getfsize ' +
	        'winnr invert pow getbufline byte2line soundfold repeat fnameescape ' +
	        'tagfiles sin strwidth spellbadword trunc maparg log lispindent ' +
	        'hostname setpos globpath remote_foreground getchar synIDattr ' +
	        'fnamemodify cscope_connection stridx winbufnr indent min ' +
	        'complete_add nr2char searchpairpos inputdialog values matchlist ' +
	        'items hlexists strridx browsedir expand fmod pathshorten line2byte ' +
	        'argc count getwinvar glob foldtextresult getreg foreground cosh ' +
	        'matchdelete has char2nr simplify histget searchdecl iconv ' +
	        'winrestcmd pumvisible writefile foldlevel haslocaldir keys cos ' +
	        'matchstr foldtext histnr tan tempname getcwd byteidx getbufvar ' +
	        'islocked escape eventhandler remote_send serverlist winrestview ' +
	        'synstack pyeval prevnonblank readfile cindent filereadable changenr ' +
	        'exp'
	    },
	    illegal: /;/,
	    contains: [
	      hljs.NUMBER_MODE,
	      hljs.APOS_STRING_MODE,
	
	      /*
	      A double quote can start either a string or a line comment. Strings are
	      ended before the end of a line by another double quote and can contain
	      escaped double-quotes and post-escaped line breaks.
	
	      Also, any double quote at the beginning of a line is a comment but we
	      don't handle that properly at the moment: any double quote inside will
	      turn them into a string. Handling it properly will require a smarter
	      parser.
	      */
	      {
	        className: 'string',
	        begin: /"(\\"|\n\\|[^"\n])*"/
	      },
	      hljs.COMMENT('"', '$'),
	
	      {
	        className: 'variable',
	        begin: /[bwtglsav]:[\w\d_]*/
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function function!', end: '$',
	        relevance: 0,
	        contains: [
	          hljs.TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)'
	          }
	        ]
	      },
	      {
	        className: 'symbol',
	        begin: /<[\w-]+>/
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/x86asm.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  return {
	    case_insensitive: true,
	    lexemes: '[.%]?' + hljs.IDENT_RE,
	    keywords: {
	      keyword:
	        'lock rep repe repz repne repnz xaquire xrelease bnd nobnd ' +
	        'aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63',
	      built_in:
	        // Instruction pointer
	        'ip eip rip ' +
	        // 8-bit registers
	        'al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ' +
	        // 16-bit registers
	        'ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w ' +
	        // 32-bit registers
	        'eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d ' +
	        // 64-bit registers
	        'rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 ' +
	        // Segment registers
	        'cs ds es fs gs ss ' +
	        // Floating point stack registers
	        'st st0 st1 st2 st3 st4 st5 st6 st7 ' +
	        // MMX Registers
	        'mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 ' +
	        // SSE registers
	        'xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 ' +
	        'xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ' +
	        // AVX registers
	        'ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ' +
	        'ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 ' +
	        // AVX-512F registers
	        'zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 ' +
	        'zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 ' +
	        // AVX-512F mask registers
	        'k0 k1 k2 k3 k4 k5 k6 k7 ' +
	        // Bound (MPX) register
	        'bnd0 bnd1 bnd2 bnd3 ' +
	        // Special register
	        'cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 ' +
	        // NASM altreg package
	        'r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b ' +
	        'r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d ' +
	        'r0h r1h r2h r3h ' +
	        'r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l ' +
	
	        'db dw dd dq dt ddq do dy dz ' +
	        'resb resw resd resq rest resdq reso resy resz ' +
	        'incbin equ times ' +
	        'byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr',
	
	      meta:
	        '%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif ' +
	        '%if %ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep ' +
	        '%endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment ' +
	        '.nolist ' +
	        '__FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ ' +
	        '__UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend ' +
	        'align alignb sectalign daz nodaz up down zero default option assume public ' +
	
	        'bits use16 use32 use64 default section segment absolute extern global common cpu float ' +
	        '__utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ ' +
	        '__float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ ' +
	        '__Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e ' +
	        'float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__'
	    },
	    contains: [
	      hljs.COMMENT(
	        ';',
	        '$',
	        {
	          relevance: 0
	        }
	      ),
	      {
	        className: 'number',
	        variants: [
	          // Float number and x87 BCD
	          {
	            begin: '\\b(?:([0-9][0-9_]*)?\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|' +
	                   '(0[Xx])?[0-9][0-9_]*\\.?[0-9_]*(?:[pP](?:[+-]?[0-9_]+)?)?)\\b',
	            relevance: 0
	          },
	
	          // Hex number in $
	          { begin: '\\$[0-9][0-9A-Fa-f]*', relevance: 0 },
	
	          // Number in H,D,T,Q,O,B,Y suffix
	          { begin: '\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[Hh]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\b' },
	
	          // Number in X,D,T,Q,O,B,Y prefix
	          { begin: '\\b(?:0[Xx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\b'}
	        ]
	      },
	      // Double quote string
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        variants: [
	          // Single-quoted string
	          { begin: '\'', end: '[^\\\\]\'' },
	          // Backquoted string
	          { begin: '`', end: '[^\\\\]`' }
	        ],
	        relevance: 0
	      },
	      {
	        className: 'symbol',
	        variants: [
	          // Global label and local label
	          { begin: '^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)' },
	          // Macro-local label
	          { begin: '^\\s*%%[A-Za-z0-9_$#@~.?]*:' }
	        ],
	        relevance: 0
	      },
	      // Macro parameter
	      {
	        className: 'subst',
	        begin: '%[0-9]+',
	        relevance: 0
	      },
	      // Macro parameter
	      {
	        className: 'subst',
	        begin: '%!\S+',
	        relevance: 0
	      },
	      {
	        className: 'meta',
	        begin: /^\s*\.[\w_-]+/
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/xl.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var BUILTIN_MODULES =
	    'ObjectLoader Animate MovieCredits Slides Filters Shading Materials LensFlare Mapping VLCAudioVideo ' +
	    'StereoDecoder PointCloud NetworkAccess RemoteControl RegExp ChromaKey Snowfall NodeJS Speech Charts';
	
	  var XL_KEYWORDS = {
	    keyword:
	      'if then else do while until for loop import with is as where when by data constant ' +
	      'integer real text name boolean symbol infix prefix postfix block tree',
	    literal:
	      'true false nil',
	    built_in:
	      'in mod rem and or xor not abs sign floor ceil sqrt sin cos tan asin ' +
	      'acos atan exp expm1 log log2 log10 log1p pi at text_length text_range ' +
	      'text_find text_replace contains page slide basic_slide title_slide ' +
	      'title subtitle fade_in fade_out fade_at clear_color color line_color ' +
	      'line_width texture_wrap texture_transform texture scale_?x scale_?y ' +
	      'scale_?z? translate_?x translate_?y translate_?z? rotate_?x rotate_?y ' +
	      'rotate_?z? rectangle circle ellipse sphere path line_to move_to ' +
	      'quad_to curve_to theme background contents locally time mouse_?x ' +
	      'mouse_?y mouse_buttons ' +
	      BUILTIN_MODULES
	  };
	
	  var DOUBLE_QUOTE_TEXT = {
	    className: 'string',
	    begin: '"', end: '"', illegal: '\\n'
	  };
	  var SINGLE_QUOTE_TEXT = {
	    className: 'string',
	    begin: '\'', end: '\'', illegal: '\\n'
	  };
	  var LONG_TEXT = {
	    className: 'string',
	    begin: '<<', end: '>>'
	  };
	  var BASED_NUMBER = {
	    className: 'number',
	    begin: '[0-9]+#[0-9A-Z_]+(\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?'
	  };
	  var IMPORT = {
	    beginKeywords: 'import', end: '$',
	    keywords: XL_KEYWORDS,
	    contains: [DOUBLE_QUOTE_TEXT]
	  };
	  var FUNCTION_DEFINITION = {
	    className: 'function',
	    begin: /[a-z][^\n]*->/, returnBegin: true, end: /->/,
	    contains: [
	      hljs.inherit(hljs.TITLE_MODE, {starts: {
	        endsWithParent: true,
	        keywords: XL_KEYWORDS
	      }})
	    ]
	  };
	  return {
	    aliases: ['tao'],
	    lexemes: /[a-zA-Z][a-zA-Z0-9_?]*/,
	    keywords: XL_KEYWORDS,
	    contains: [
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    DOUBLE_QUOTE_TEXT,
	    SINGLE_QUOTE_TEXT,
	    LONG_TEXT,
	    FUNCTION_DEFINITION,
	    IMPORT,
	    BASED_NUMBER,
	    hljs.NUMBER_MODE
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/xml.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var XML_IDENT_RE = '[A-Za-z0-9\\._:-]+';
	  var TAG_INTERNALS = {
	    endsWithParent: true,
	    illegal: /</,
	    relevance: 0,
	    contains: [
	      {
	        className: 'attr',
	        begin: XML_IDENT_RE,
	        relevance: 0
	      },
	      {
	        begin: /=\s*/,
	        relevance: 0,
	        contains: [
	          {
	            className: 'string',
	            endsParent: true,
	            variants: [
	              {begin: /"/, end: /"/},
	              {begin: /'/, end: /'/},
	              {begin: /[^\s"'=<>`]+/}
	            ]
	          }
	        ]
	      }
	    ]
	  };
	  return {
	    aliases: ['html', 'xhtml', 'rss', 'atom', 'xjb', 'xsd', 'xsl', 'plist'],
	    case_insensitive: true,
	    contains: [
	      {
	        className: 'meta',
	        begin: '<!DOCTYPE', end: '>',
	        relevance: 10,
	        contains: [{begin: '\\[', end: '\\]'}]
	      },
	      hljs.COMMENT(
	        '<!--',
	        '-->',
	        {
	          relevance: 10
	        }
	      ),
	      {
	        begin: '<\\!\\[CDATA\\[', end: '\\]\\]>',
	        relevance: 10
	      },
	      {
	        begin: /<\?(php)?/, end: /\?>/,
	        subLanguage: 'php',
	        contains: [{begin: '/\\*', end: '\\*/', skip: true}]
	      },
	      {
	        className: 'tag',
	        /*
	        The lookahead pattern (?=...) ensures that 'begin' only matches
	        '<style' as a single word, followed by a whitespace or an
	        ending braket. The '$' is needed for the lexeme to be recognized
	        by hljs.subMode() that tests lexemes outside the stream.
	        */
	        begin: '<style(?=\\s|>|$)', end: '>',
	        keywords: {name: 'style'},
	        contains: [TAG_INTERNALS],
	        starts: {
	          end: '</style>', returnEnd: true,
	          subLanguage: ['css', 'xml']
	        }
	      },
	      {
	        className: 'tag',
	        // See the comment in the <style tag about the lookahead pattern
	        begin: '<script(?=\\s|>|$)', end: '>',
	        keywords: {name: 'script'},
	        contains: [TAG_INTERNALS],
	        starts: {
	          end: '\<\/script\>', returnEnd: true,
	          subLanguage: ['actionscript', 'javascript', 'handlebars', 'xml']
	        }
	      },
	      {
	        className: 'meta',
	        variants: [
	          {begin: /<\?xml/, end: /\?>/, relevance: 10},
	          {begin: /<\?\w+/, end: /\?>/}
	        ]
	      },
	      {
	        className: 'tag',
	        begin: '</?', end: '/?>',
	        contains: [
	          {
	            className: 'name', begin: /[^\/><\s]+/, relevance: 0
	          },
	          TAG_INTERNALS
	        ]
	      }
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/xquery.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var KEYWORDS = 'for let if while then else return where group by xquery encoding version' +
	    'module namespace boundary-space preserve strip default collation base-uri ordering' +
	    'copy-namespaces order declare import schema namespace function option in allowing empty' +
	    'at tumbling window sliding window start when only end when previous next stable ascending' +
	    'descending empty greatest least some every satisfies switch case typeswitch try catch and' +
	    'or to union intersect instance of treat as castable cast map array delete insert into' +
	    'replace value rename copy modify update';
	  var LITERAL = 'false true xs:string xs:integer element item xs:date xs:datetime xs:float xs:double xs:decimal QName xs:anyURI xs:long xs:int xs:short xs:byte attribute';
	  var VAR = {
	    begin: /\$[a-zA-Z0-9\-]+/
	  };
	
	  var NUMBER = {
	    className: 'number',
	    begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	    relevance: 0
	  };
	
	  var STRING = {
	    className: 'string',
	    variants: [
	      {begin: /"/, end: /"/, contains: [{begin: /""/, relevance: 0}]},
	      {begin: /'/, end: /'/, contains: [{begin: /''/, relevance: 0}]}
	    ]
	  };
	
	  var ANNOTATION = {
	    className: 'meta',
	    begin: '%\\w+'
	  };
	
	  var COMMENT = {
	    className: 'comment',
	    begin: '\\(:', end: ':\\)',
	    relevance: 10,
	    contains: [
	      {
	        className: 'doctag', begin: '@\\w+'
	      }
	    ]
	  };
	
	  var METHOD = {
	    begin: '{', end: '}'
	  };
	
	  var CONTAINS = [
	    VAR,
	    STRING,
	    NUMBER,
	    COMMENT,
	    ANNOTATION,
	    METHOD
	  ];
	  METHOD.contains = CONTAINS;
	
	
	  return {
	    aliases: ['xpath', 'xq'],
	    case_insensitive: false,
	    lexemes: /[a-zA-Z\$][a-zA-Z0-9_:\-]*/,
	    illegal: /(proc)|(abstract)|(extends)|(until)|(#)/,
	    keywords: {
	      keyword: KEYWORDS,
	      literal: LITERAL
	    },
	    contains: CONTAINS
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/yaml.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var LITERALS = 'true false yes no null';
	
	  var keyPrefix = '^[ \\-]*';
	  var keyName =  '[a-zA-Z_][\\w\\-]*';
	  var KEY = {
	    className: 'attr',
	    variants: [
	      { begin: keyPrefix + keyName + ":"},
	      { begin: keyPrefix + '"' + keyName + '"' + ":"},
	      { begin: keyPrefix + "'" + keyName + "'" + ":"}
	    ]
	  };
	
	  var TEMPLATE_VARIABLES = {
	    className: 'template-variable',
	    variants: [
	      { begin: '\{\{', end: '\}\}' }, // jinja templates Ansible
	      { begin: '%\{', end: '\}' } // Ruby i18n
	    ]
	  };
	  var STRING = {
	    className: 'string',
	    relevance: 0,
	    variants: [
	      {begin: /'/, end: /'/},
	      {begin: /"/, end: /"/},
	      {begin: /\S+/}
	    ],
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      TEMPLATE_VARIABLES
	    ]
	  };
	
	  return {
	    case_insensitive: true,
	    aliases: ['yml', 'YAML', 'yaml'],
	    contains: [
	      KEY,
	      {
	        className: 'meta',
	        begin: '^---\s*$',
	        relevance: 10
	      },
	      { // multi line string
	        className: 'string',
	        begin: '[\\|>] *$',
	        returnEnd: true,
	        contains: STRING.contains,
	        // very simple termination: next hash key
	        end: KEY.variants[0].begin
	      },
	      { // Ruby/Rails erb
	        begin: '<%[%=-]?', end: '[%-]?%>',
	        subLanguage: 'ruby',
	        excludeBegin: true,
	        excludeEnd: true,
	        relevance: 0
	      },
	      { // data type
	        className: 'type',
	        begin: '!!' + hljs.UNDERSCORE_IDENT_RE,
	      },
	      { // fragment id &ref
	        className: 'meta',
	        begin: '&' + hljs.UNDERSCORE_IDENT_RE + '$',
	      },
	      { // fragment reference *ref
	        className: 'meta',
	        begin: '\\*' + hljs.UNDERSCORE_IDENT_RE + '$'
	      },
	      { // array listing
	        className: 'bullet',
	        begin: '^ *-',
	        relevance: 0
	      },
	      hljs.HASH_COMMENT_MODE,
	      {
	        beginKeywords: LITERALS,
	        keywords: {literal: LITERALS}
	      },
	      hljs.C_NUMBER_MODE,
	      STRING
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/lib/languages/zephir.js":
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE],
	    variants: [
	      {
	        begin: 'b"', end: '"'
	      },
	      {
	        begin: 'b\'', end: '\''
	      },
	      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
	    ]
	  };
	  var NUMBER = {variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]};
	  return {
	    aliases: ['zep'],
	    case_insensitive: true,
	    keywords:
	      'and include_once list abstract global private echo interface as static endswitch ' +
	      'array null if endwhile or const for endforeach self var let while isset public ' +
	      'protected exit foreach throw elseif include __FILE__ empty require_once do xor ' +
	      'return parent clone use __CLASS__ __LINE__ else break print eval new ' +
	      'catch __METHOD__ case exception default die require __FUNCTION__ ' +
	      'enddeclare final try switch continue endfor endif declare unset true false ' +
	      'trait goto instanceof insteadof __DIR__ __NAMESPACE__ ' +
	      'yield finally int uint long ulong char uchar double float bool boolean string' +
	      'likely unlikely',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.HASH_COMMENT_MODE,
	      hljs.COMMENT(
	        '/\\*',
	        '\\*/',
	        {
	          contains: [
	            {
	              className: 'doctag',
	              begin: '@[A-Za-z]+'
	            }
	          ]
	        }
	      ),
	      hljs.COMMENT(
	        '__halt_compiler.+?;',
	        false,
	        {
	          endsWithParent: true,
	          keywords: '__halt_compiler',
	          lexemes: hljs.UNDERSCORE_IDENT_RE
	        }
	      ),
	      {
	        className: 'string',
	        begin: '<<<[\'"]?\\w+[\'"]?$', end: '^\\w+;',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        // swallow composed identifiers to avoid parsing them as keywords
	        begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: /[;{]/, excludeEnd: true,
	        illegal: '\\$|\\[|%',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)',
	            contains: [
	              'self',
	              hljs.C_BLOCK_COMMENT_MODE,
	              STRING,
	              NUMBER
	            ]
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        illegal: /[:\(\$"]/,
	        contains: [
	          {beginKeywords: 'extends implements'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        beginKeywords: 'namespace', end: ';',
	        illegal: /[\.']/,
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        beginKeywords: 'use', end: ';',
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        begin: '=>' // No markup, just a relevance booster
	      },
	      STRING,
	      NUMBER
	    ]
	  };
	};

/***/ }),

/***/ "./node_modules/highlight.js/styles/dracula.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/lower-case/lower-case.js":
/***/ (function(module, exports) {

	/**
	 * Special language-specific overrides.
	 *
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 *
	 * @type {Object}
	 */
	var LANGUAGES = {
	  tr: {
	    regexp: /\u0130|\u0049|\u0049\u0307/g,
	    map: {
	      '\u0130': '\u0069',
	      '\u0049': '\u0131',
	      '\u0049\u0307': '\u0069'
	    }
	  },
	  az: {
	    regexp: /[\u0130]/g,
	    map: {
	      '\u0130': '\u0069',
	      '\u0049': '\u0131',
	      '\u0049\u0307': '\u0069'
	    }
	  },
	  lt: {
	    regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
	    map: {
	      '\u0049': '\u0069\u0307',
	      '\u004A': '\u006A\u0307',
	      '\u012E': '\u012F\u0307',
	      '\u00CC': '\u0069\u0307\u0300',
	      '\u00CD': '\u0069\u0307\u0301',
	      '\u0128': '\u0069\u0307\u0303'
	    }
	  }
	}
	
	/**
	 * Lowercase a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  var lang = LANGUAGES[locale]
	
	  str = str == null ? '' : String(str)
	
	  if (lang) {
	    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
	  }
	
	  return str.toLowerCase()
	}


/***/ }),

/***/ "./node_modules/no-case/no-case.js":
/***/ (function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__("./node_modules/lower-case/lower-case.js")
	
	var NON_WORD_REGEXP = __webpack_require__("./node_modules/no-case/vendor/non-word-regexp.js")
	var CAMEL_CASE_REGEXP = __webpack_require__("./node_modules/no-case/vendor/camel-case-regexp.js")
	var CAMEL_CASE_UPPER_REGEXP = __webpack_require__("./node_modules/no-case/vendor/camel-case-upper-regexp.js")
	
	/**
	 * Sentence case a string.
	 *
	 * @param  {string} str
	 * @param  {string} locale
	 * @param  {string} replacement
	 * @return {string}
	 */
	module.exports = function (str, locale, replacement) {
	  if (str == null) {
	    return ''
	  }
	
	  replacement = typeof replacement !== 'string' ? ' ' : replacement
	
	  function replace (match, index, value) {
	    if (index === 0 || index === (value.length - match.length)) {
	      return ''
	    }
	
	    return replacement
	  }
	
	  str = String(str)
	    // Support camel case ("camelCase" -> "camel Case").
	    .replace(CAMEL_CASE_REGEXP, '$1 $2')
	    // Support odd camel case ("CAMELCase" -> "CAMEL Case").
	    .replace(CAMEL_CASE_UPPER_REGEXP, '$1 $2')
	    // Remove all non-word characters and replace with a single space.
	    .replace(NON_WORD_REGEXP, replace)
	
	  // Lower case the entire string.
	  return lowerCase(str, locale)
	}


/***/ }),

/***/ "./node_modules/no-case/vendor/camel-case-regexp.js":
/***/ (function(module, exports) {

	module.exports = /([a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])/g


/***/ }),

/***/ "./node_modules/no-case/vendor/camel-case-upper-regexp.js":
/***/ (function(module, exports) {

	module.exports = /([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A][a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])/g


/***/ }),

/***/ "./node_modules/no-case/vendor/non-word-regexp.js":
/***/ (function(module, exports) {

	module.exports = /[^A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g


/***/ }),

/***/ "./node_modules/pascal-case/pascal-case.js":
/***/ (function(module, exports, __webpack_require__) {

	var camelCase = __webpack_require__("./node_modules/camel-case/camel-case.js")
	var upperCaseFirst = __webpack_require__("./node_modules/upper-case-first/upper-case-first.js")
	
	/**
	 * Pascal case a string.
	 *
	 * @param  {string}  value
	 * @param  {string}  [locale]
	 * @param  {boolean} [mergeNumbers]
	 * @return {string}
	 */
	module.exports = function (value, locale, mergeNumbers) {
	  return upperCaseFirst(camelCase(value, locale, mergeNumbers), locale)
	}


/***/ }),

/***/ "./node_modules/process/browser.js":
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/react-helmet/lib/Helmet.js":
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__("./node_modules/react-side-effect/lib/index.js");
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__("./node_modules/deep-equal/index.js");
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__("./node_modules/react-helmet/lib/HelmetUtils.js");
	
	var _HelmetConstants = __webpack_require__("./node_modules/react-helmet/lib/HelmetConstants.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ "./node_modules/react-helmet/lib/HelmetConstants.js":
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ "./node_modules/react-helmet/lib/HelmetUtils.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__("./node_modules/object-assign/index.js");
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__("./node_modules/react-helmet/lib/HelmetConstants.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ "./node_modules/react-highlight/index.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("./node_modules/react-highlight/lib/index.js");

/***/ }),

/***/ "./node_modules/react-highlight/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _highlightJs = __webpack_require__("./node_modules/highlight.js/lib/index.js");
	
	var _highlightJs2 = _interopRequireDefault(_highlightJs);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var Highlight = (function (_React$Component) {
	    _inherits(Highlight, _React$Component);
	
	    function Highlight() {
	        _classCallCheck(this, Highlight);
	
	        _get(Object.getPrototypeOf(Highlight.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Highlight, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.highlightCode();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.highlightCode();
	        }
	    }, {
	        key: 'highlightCode',
	        value: function highlightCode() {
	            var domNode = _reactDom2['default'].findDOMNode(this);
	            var nodes = domNode.querySelectorAll('pre code');
	
	            var i = undefined;
	            for (i = 0; i < nodes.length; i++) {
	                _highlightJs2['default'].highlightBlock(nodes[i]);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var children = _props.children;
	            var className = _props.className;
	            var element = _props.element;
	            var innerHTML = _props.innerHTML;
	
	            var Element = element ? _react2['default'].DOM[element] : null;
	
	            if (innerHTML) {
	                if (!Element) {
	                    Element = _react2['default'].DOM.div;
	                }
	
	                return Element({ dangerouslySetInnerHTML: { __html: children }, className: className || null }, null);
	            } else {
	                if (Element) {
	                    return Element({ className: className }, children);
	                } else {
	                    return _react2['default'].createElement(
	                        'pre',
	                        null,
	                        _react2['default'].createElement(
	                            'code',
	                            { className: className },
	                            children
	                        )
	                    );
	                }
	            }
	        }
	    }]);
	
	    return Highlight;
	})(_react2['default'].Component);
	
	Highlight.defaultProps = {
	    innerHTML: false,
	    className: null,
	    element: null
	};
	
	exports['default'] = Highlight;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-side-effect/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__("./node_modules/exenv/index.js");
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__("./node_modules/shallowequal/index.js");
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ "./node_modules/react-tooltip/dist/constant.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  GLOBAL: {
	    HIDE: '__react_tooltip_hide_event',
	    REBUILD: '__react_tooltip_rebuild_event',
	    SHOW: '__react_tooltip_show_event'
	  }
	};

/***/ }),

/***/ "./node_modules/react-tooltip/dist/decorators/customEvent.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	
	    return event || !!ele.getAttribute('data-event');
	  };
	
	  /* Bind listener for custom event */
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _state = this.state,
	        event = _state.event,
	        eventOff = _state.eventOff;
	
	    var dataEvent = ele.getAttribute('data-event') || event;
	    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
	
	    dataEvent.split(' ').forEach(function (event) {
	      ele.removeEventListener(event, customListener);
	      customListener = checkStatus.bind(_this, dataEventOff);
	      ele.addEventListener(event, customListener, false);
	    });
	    if (dataEventOff) {
	      dataEventOff.split(' ').forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	
	  /* Unbind listener for custom event */
	  target.prototype.customUnbindListener = function (ele) {
	    var _state2 = this.state,
	        event = _state2.event,
	        eventOff = _state2.eventOff;
	
	    var dataEvent = event || ele.getAttribute('data-event');
	    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
	
	    ele.removeEventListener(dataEvent, customListener);
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	};
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	
	  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
	  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
	  var currentItem = e.currentTarget.getAttribute('currentItem');
	
	  if (!isCapture) e.stopPropagation();
	  if (show && currentItem === 'true') {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute('currentItem', 'true');
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute('currentItem', 'false');
	    } else {
	      targetArray[i].setAttribute('currentItem', 'true');
	    }
	  }
	};
	
	var customListener = void 0;

/***/ }),

/***/ "./node_modules/react-tooltip/dist/decorators/getEffect.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute('data-effect');
	    return dataEffect || this.props.effect || 'float';
	  };
	};

/***/ }),

/***/ "./node_modules/react-tooltip/dist/decorators/isCapture.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    var dataIsCapture = currentTarget.getAttribute('data-iscapture');
	    return dataIsCapture && dataIsCapture === 'true' || this.props.isCapture || false;
	  };
	};

/***/ }),

/***/ "./node_modules/react-tooltip/dist/decorators/staticMethods.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
	  };
	
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	  target.rebuild = function () {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
	  };
	
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	  target.show = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = { currentTarget: event.detail.target };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
	    }
	  };
	};
	
	var _constant = __webpack_require__("./node_modules/react-tooltip/dist/constant.js");
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatibale with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event = void 0;
	
	  if (typeof window.CustomEvent === 'function') {
	    event = new window.CustomEvent(eventName, { detail: opts });
	  } else {
	    event = document.createEvent('Event');
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	}; /**
	    * Static methods for react-tooltip
	    */

/***/ }),

/***/ "./node_modules/react-tooltip/dist/decorators/trackRemoval.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	
	    var observer = new MutationObserver(function (mutations) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var mutation = _step.value;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = mutation.removedNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var element = _step2.value;
	
	              if (element === _this.state.currentTarget) {
	                _this.hideTooltip();
	                return;
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    });
	
	    observer.observe(window.document, { childList: true, subtree: true });
	
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	};
	
	/**
	 * Tracking target removing from DOM.
	 * It's nessesary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};

/***/ }),

/***/ "./node_modules/react-tooltip/dist/decorators/windowListener.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);
	
	    // ReactTooltip.rebuild
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);
	
	    // ReactTooltip.show
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);
	
	    // Resize
	    if (resizeHide) {
	      window.removeEventListener('resize', this.onWindowResize);
	      window.addEventListener('resize', this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener('resize', this.onWindowResize);
	  };
	
	  /**
	   * invoked by resize event of window
	   */
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	};
	
	var _constant = __webpack_require__("./node_modules/react-tooltip/dist/constant.js");
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/react-tooltip/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	/* Decoraters */
	
	
	/* Utils */
	
	
	/* CSS */
	
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _staticMethods = __webpack_require__("./node_modules/react-tooltip/dist/decorators/staticMethods.js");
	
	var _staticMethods2 = _interopRequireDefault(_staticMethods);
	
	var _windowListener = __webpack_require__("./node_modules/react-tooltip/dist/decorators/windowListener.js");
	
	var _windowListener2 = _interopRequireDefault(_windowListener);
	
	var _customEvent = __webpack_require__("./node_modules/react-tooltip/dist/decorators/customEvent.js");
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	var _isCapture = __webpack_require__("./node_modules/react-tooltip/dist/decorators/isCapture.js");
	
	var _isCapture2 = _interopRequireDefault(_isCapture);
	
	var _getEffect = __webpack_require__("./node_modules/react-tooltip/dist/decorators/getEffect.js");
	
	var _getEffect2 = _interopRequireDefault(_getEffect);
	
	var _trackRemoval = __webpack_require__("./node_modules/react-tooltip/dist/decorators/trackRemoval.js");
	
	var _trackRemoval2 = _interopRequireDefault(_trackRemoval);
	
	var _getPosition = __webpack_require__("./node_modules/react-tooltip/dist/utils/getPosition.js");
	
	var _getPosition2 = _interopRequireDefault(_getPosition);
	
	var _getTipContent = __webpack_require__("./node_modules/react-tooltip/dist/utils/getTipContent.js");
	
	var _getTipContent2 = _interopRequireDefault(_getTipContent);
	
	var _aria = __webpack_require__("./node_modules/react-tooltip/dist/utils/aria.js");
	
	var _nodeListToArray = __webpack_require__("./node_modules/react-tooltip/dist/utils/nodeListToArray.js");
	
	var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);
	
	var _style = __webpack_require__("./node_modules/react-tooltip/dist/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReactTooltip, _Component);
	
	  function ReactTooltip(props) {
	    _classCallCheck(this, ReactTooltip);
	
	    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));
	
	    _this.state = {
	      place: 'top', // Direction of tooltip
	      type: 'dark', // Color theme of tooltip
	      effect: 'float', // float or fixed
	      show: false,
	      border: false,
	      placeholder: '',
	      offset: {},
	      extraClass: '',
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null, // Current mouse event
	      currentTarget: null, // Current target of mouse event
	      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
	      isEmptyTip: false,
	      disable: false
	    };
	
	    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize']);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: 'bind',
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          insecure = _props.insecure,
	          resizeHide = _props.resizeHide;
	
	      if (insecure) {
	        this.setStyleHeader(); // Set the style to the <link>
	      }
	      this.bindListener(); // Bind listener for tooltip
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var ariaProps = this.state.ariaProps;
	
	      var newAriaProps = (0, _aria.parseAria)(props);
	
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	      if (isChanged) {
	        this.setState({ ariaProps: newAriaProps });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mount = false;
	
	      this.clearTimer();
	
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: 'getTargetArray',
	    value: function getTargetArray(id) {
	      var targetArray = void 0;
	      if (!id) {
	        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
	      } else {
	        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
	      }
	      // targetArray is a NodeList, convert it to a real array
	      return (0, _nodeListToArray2.default)(targetArray);
	    }
	
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: 'bindListener',
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          globalEventOff = _props2.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	
	      targetArray.forEach(function (target) {
	        var isCaptureMode = _this3.isCapture(target);
	        var effect = _this3.getEffect(target);
	        if (target.getAttribute('currentItem') === null) {
	          target.setAttribute('currentItem', 'false');
	        }
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customBindListener(target);
	          return;
	        }
	
	        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
	        if (effect === 'float') {
	          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
	        }
	        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
	      });
	
	      // Global event to hide tooltip
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, false);
	      }
	
	      // Track removal of targetArray elements from DOM
	      this.bindRemovalTracker();
	    }
	
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: 'unbindListener',
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          globalEventOff = _props3.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        _this4.unbindBasicListener(target);
	        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	      });
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	
	    /**
	     * Invoke this before bind listener and ummount the compont
	     * it is necessary to invloke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: 'unbindBasicListener',
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
	      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
	      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
	    }
	
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip(e, isGlobalCall) {
	      var _this5 = this;
	
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || this.state.show) return;
	      }
	      // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	      var _props4 = this.props,
	          children = _props4.children,
	          multiline = _props4.multiline,
	          getContent = _props4.getContent;
	
	      var originTooltip = e.currentTarget.getAttribute('data-tip');
	      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
	
	      // Generate tootlip content
	      var content = void 0;
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0]();
	        } else {
	          content = getContent();
	        }
	      }
	      var placeholder = (0, _getTipContent2.default)(originTooltip, children, content, isMultiline);
	      var isEmptyTip = typeof placeholder === 'string' && placeholder === '' || placeholder === null;
	
	      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
	
	      // if it need to skip adding hide listener to scroll
	      var scrollHide = true;
	      if (e.currentTarget.getAttribute('data-scroll-hide')) {
	        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      }
	
	      // To prevent previously created timers from triggering
	      this.clearTimer();
	
	      this.setState({
	        placeholder: placeholder,
	        isEmptyTip: isEmptyTip,
	        place: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
	        type: e.currentTarget.getAttribute('data-type') || this.props.type || 'dark',
	        effect: switchToSolid && 'solid' || this.getEffect(e.currentTarget),
	        offset: e.currentTarget.getAttribute('data-offset') || this.props.offset || {},
	        html: e.currentTarget.getAttribute('data-html') ? e.currentTarget.getAttribute('data-html') === 'true' : this.props.html || false,
	        delayShow: e.currentTarget.getAttribute('data-delay-show') || this.props.delayShow || 0,
	        delayHide: e.currentTarget.getAttribute('data-delay-hide') || this.props.delayHide || 0,
	        border: e.currentTarget.getAttribute('data-border') ? e.currentTarget.getAttribute('data-border') === 'true' : this.props.border || false,
	        extraClass: e.currentTarget.getAttribute('data-class') || this.props.class || this.props.className || '',
	        disable: e.currentTarget.getAttribute('data-tip-disable') ? e.currentTarget.getAttribute('data-tip-disable') === 'true' : this.props.disable || false
	      }, function () {
	        if (scrollHide) _this5.addScrollListener(e);
	        _this5.updateTooltip(e);
	
	        if (getContent && Array.isArray(getContent)) {
	          _this5.intervalUpdateContent = setInterval(function () {
	            if (_this5.mount) {
	              var _getContent = _this5.props.getContent;
	
	              var _placeholder = (0, _getTipContent2.default)(originTooltip, _getContent[0](), isMultiline);
	              var _isEmptyTip = typeof _placeholder === 'string' && _placeholder === '';
	              _this5.setState({
	                placeholder: _placeholder,
	                isEmptyTip: _isEmptyTip
	              });
	            }
	          }, getContent[1]);
	        }
	      });
	    }
	
	    /**
	     * When mouse hover, updatetooltip
	     */
	
	  }, {
	    key: 'updateTooltip',
	    value: function updateTooltip(e) {
	      var _this6 = this;
	
	      var _state = this.state,
	          delayShow = _state.delayShow,
	          show = _state.show,
	          isEmptyTip = _state.isEmptyTip,
	          disable = _state.disable;
	      var afterShow = this.props.afterShow;
	      var placeholder = this.state.placeholder;
	
	      var delayTime = show ? 0 : parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget;
	
	      if (isEmptyTip || disable) return; // if the tooltip is empty, disable the tooltip
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          (function () {
	            var isInvisible = !_this6.state.show;
	            _this6.setState({
	              currentEvent: e,
	              currentTarget: eventTarget,
	              show: true
	            }, function () {
	              _this6.updatePosition();
	              if (isInvisible && afterShow) afterShow();
	            });
	          })();
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip(e, hasTarget) {
	      var _this7 = this;
	
	      var _state2 = this.state,
	          delayHide = _state2.delayHide,
	          isEmptyTip = _state2.isEmptyTip,
	          disable = _state2.disable;
	      var afterHide = this.props.afterHide;
	
	      if (!this.mount) return;
	      if (isEmptyTip || disable) return; // if the tooltip is empty, disable the tooltip
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	      var resetState = function resetState() {
	        var isVisible = _this7.state.show;
	        _this7.setState({
	          show: false
	        }, function () {
	          _this7.removeScrollListener();
	          if (isVisible && afterHide) afterHide();
	        });
	      };
	
	      this.clearTimer();
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	
	    /**
	     * Add scroll eventlistener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: 'addScrollListener',
	    value: function addScrollListener(e) {
	      var isCaptureMode = this.isCapture(e.currentTarget);
	      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'removeScrollListener',
	    value: function removeScrollListener() {
	      window.removeEventListener('scroll', this.hideTooltip);
	    }
	
	    // Calculation the position
	
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var _this8 = this;
	
	      var _state3 = this.state,
	          currentEvent = _state3.currentEvent,
	          currentTarget = _state3.currentTarget,
	          place = _state3.place,
	          effect = _state3.effect,
	          offset = _state3.offset;
	
	      var node = _reactDom2.default.findDOMNode(this);
	      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, effect, offset);
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this8.updatePosition();
	        });
	      }
	      // Set tooltip position
	      node.style.left = result.position.left + 'px';
	      node.style.top = result.position.top + 'px';
	    }
	
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	  }, {
	    key: 'setStyleHeader',
	    value: function setStyleHeader() {
	      if (!document.getElementsByTagName('head')[0].querySelector('style[id="react-tooltip"]')) {
	        var tag = document.createElement('style');
	        tag.id = 'react-tooltip';
	        tag.innerHTML = _style2.default;
	        document.getElementsByTagName('head')[0].appendChild(tag);
	      }
	    }
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: 'clearTimer',
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state4 = this.state,
	          placeholder = _state4.placeholder,
	          extraClass = _state4.extraClass,
	          html = _state4.html,
	          ariaProps = _state4.ariaProps,
	          disable = _state4.disable,
	          isEmptyTip = _state4.isEmptyTip;
	
	      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' });
	
	      var Wrapper = this.props.wrapper;
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      if (html) {
	        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass
	        }, ariaProps, {
	          'data-id': 'tooltip',
	          dangerouslySetInnerHTML: { __html: placeholder } }));
	      } else {
	        return _react2.default.createElement(
	          Wrapper,
	          _extends({ className: tooltipClass + ' ' + extraClass
	          }, ariaProps, {
	            'data-id': 'tooltip' }),
	          placeholder
	        );
	      }
	    }
	  }]);
	
	  return ReactTooltip;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.any,
	  place: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  effect: _propTypes2.default.string,
	  offset: _propTypes2.default.object,
	  multiline: _propTypes2.default.bool,
	  border: _propTypes2.default.bool,
	  insecure: _propTypes2.default.bool,
	  class: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  html: _propTypes2.default.bool,
	  delayHide: _propTypes2.default.number,
	  delayShow: _propTypes2.default.number,
	  event: _propTypes2.default.string,
	  eventOff: _propTypes2.default.string,
	  watchWindow: _propTypes2.default.bool,
	  isCapture: _propTypes2.default.bool,
	  globalEventOff: _propTypes2.default.string,
	  getContent: _propTypes2.default.any,
	  afterShow: _propTypes2.default.func,
	  afterHide: _propTypes2.default.func,
	  disable: _propTypes2.default.bool,
	  scrollHide: _propTypes2.default.bool,
	  resizeHide: _propTypes2.default.bool,
	  wrapper: _propTypes2.default.string
	}, _class2.defaultProps = {
	  insecure: true,
	  resizeHide: true,
	  wrapper: 'div'
	}, _class2.supportedWrappers = ['div', 'span'], _temp)) || _class) || _class) || _class) || _class) || _class) || _class;
	
	/* export default not fit for standalone, it will exports {default:...} */
	
	
	module.exports = ReactTooltip;

/***/ }),

/***/ "./node_modules/react-tooltip/dist/style.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ }),

/***/ "./node_modules/react-tooltip/dist/utils/aria.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseAria = parseAria;
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return (/(^aria-\w+$|^role$)/.test(prop)
	    );
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	
	  return ariaObj;
	}

/***/ }),

/***/ "./node_modules/react-tooltip/dist/utils/getPosition.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (e, target, node, place, effect, offset) {
	  var tipWidth = node.clientWidth;
	  var tipHeight = node.clientHeight;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, target.clientWidth, target.clientHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft;
	
	  // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  // Judge if the tooltip has over the window(screen)
	  var outsideVertical = function outsideVertical() {
	    var result = false;
	    var newPlace = void 0;
	    if (getTipOffsetTop('left') < 0 && getTipOffsetBottom('left') <= windowHeight && getTipOffsetBottom('bottom') <= windowHeight) {
	      result = true;
	      newPlace = 'bottom';
	    } else if (getTipOffsetBottom('left') > windowHeight && getTipOffsetTop('left') >= 0 && getTipOffsetTop('top') >= 0) {
	      result = true;
	      newPlace = 'top';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideLeft = function outsideLeft() {
	    var _outsideVertical = outsideVertical(),
	        result = _outsideVertical.result,
	        newPlace = _outsideVertical.newPlace; // Deal with vertical as first priority
	
	
	    if (result && outsideHorizontal().result) {
	      return { result: false }; // No need to change, if change to vertical will out of space
	    }
	    if (!result && getTipOffsetLeft('left') < 0 && getTipOffsetRight('right') <= windowWidth) {
	      result = true; // If vertical ok, but let out of side and right won't out of side
	      newPlace = 'right';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideRight = function outsideRight() {
	    var _outsideVertical2 = outsideVertical(),
	        result = _outsideVertical2.result,
	        newPlace = _outsideVertical2.newPlace;
	
	    if (result && outsideHorizontal().result) {
	      return { result: false }; // No need to change, if change to vertical will out of space
	    }
	    if (!result && getTipOffsetRight('right') > windowWidth && getTipOffsetLeft('left') >= 0) {
	      result = true;
	      newPlace = 'left';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	
	  var outsideHorizontal = function outsideHorizontal() {
	    var result = false;
	    var newPlace = void 0;
	    if (getTipOffsetLeft('top') < 0 && getTipOffsetRight('top') <= windowWidth && getTipOffsetRight('right') <= windowWidth) {
	      result = true;
	      newPlace = 'right';
	    } else if (getTipOffsetRight('top') > windowWidth && getTipOffsetLeft('top') >= 0 && getTipOffsetLeft('left') >= 0) {
	      result = true;
	      newPlace = 'left';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideTop = function outsideTop() {
	    var _outsideHorizontal = outsideHorizontal(),
	        result = _outsideHorizontal.result,
	        newPlace = _outsideHorizontal.newPlace;
	
	    if (result && outsideVertical().result) {
	      return { result: false };
	    }
	    if (!result && getTipOffsetTop('top') < 0 && getTipOffsetBottom('bottom') <= windowHeight) {
	      result = true;
	      newPlace = 'bottom';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideBottom = function outsideBottom() {
	    var _outsideHorizontal2 = outsideHorizontal(),
	        result = _outsideHorizontal2.result,
	        newPlace = _outsideHorizontal2.newPlace;
	
	    if (result && outsideVertical().result) {
	      return { result: false };
	    }
	    if (!result && getTipOffsetBottom('bottom') > windowHeight && getTipOffsetTop('top') >= 0) {
	      result = true;
	      newPlace = 'top';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	
	  // Return new state to change the placement to the reverse if possible
	  var outsideLeftResult = outsideLeft();
	  var outsideRightResult = outsideRight();
	  var outsideTopResult = outsideTop();
	  var outsideBottomResult = outsideBottom();
	
	  if (place === 'left' && outsideLeftResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideLeftResult.newPlace }
	    };
	  } else if (place === 'right' && outsideRightResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideRightResult.newPlace }
	    };
	  } else if (place === 'top' && outsideTopResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideTopResult.newPlace }
	    };
	  } else if (place === 'bottom' && outsideBottomResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideBottomResult.newPlace }
	    };
	  }
	
	  // Return tooltip offset position
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	};
	
	// Get current mouse offset
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	  var targetWidth = currentTarget.clientWidth;
	  var targetHeight = currentTarget.clientHeight;
	
	  if (effect === 'float') {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	};
	
	// List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {OBject} {left: {Number}, top: {Number}}
	 */
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top = void 0;
	  var right = void 0;
	  var bottom = void 0;
	  var left = void 0;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === 'float') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === 'solid') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return { top: top, bottom: bottom, left: left, right: right };
	};
	
	// Consider additional offset into position calculation
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === '[object String]') {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
	  }
	  for (var key in offset) {
	    if (key === 'top') {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === 'bottom') {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === 'left') {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === 'right') {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
	};
	
	// Get the offset of the parent elements
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	
	  return { parentTop: parentTop, parentLeft: parentLeft };
	};

/***/ }),

/***/ "./node_modules/react-tooltip/dist/utils/getTipContent.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	  if (getContent === null) return null; // Tip not exist and childern is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  }
	
	  // Multiline tooltip content
	  return tip.split(regexp).map(function (d, i) {
	    return _react2.default.createElement(
	      'span',
	      { key: i, className: 'multi-line' },
	      d
	    );
	  });
	};
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/react-tooltip/dist/utils/nodeListToArray.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nodeList) {
	  var length = nodeList.length;
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	};

/***/ }),

/***/ "./node_modules/react-transition-group/CSSTransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__("./node_modules/react-transition-group/TransitionGroup.js");
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__("./node_modules/react-transition-group/CSSTransitionGroupChild.js");
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/CSSTransitionGroupChild.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__("./node_modules/dom-helpers/class/addClass.js");
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__("./node_modules/dom-helpers/class/removeClass.js");
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__("./node_modules/dom-helpers/util/requestAnimationFrame.js");
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__("./node_modules/dom-helpers/transition/properties.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/TransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__("./node_modules/chain-function/index.js");
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__("./node_modules/react-transition-group/utils/ChildMapping.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransitionGroup = __webpack_require__("./node_modules/react-transition-group/CSSTransitionGroup.js");
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _TransitionGroup = __webpack_require__("./node_modules/react-transition-group/TransitionGroup.js");
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransitionGroup: _CSSTransitionGroup2.default
	};

/***/ }),

/***/ "./node_modules/react-transition-group/utils/ChildMapping.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ "./node_modules/react-transition-group/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ "./node_modules/shallowequal/index.js":
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ "./node_modules/toggle-selection/index.js":
/***/ (function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ }),

/***/ "./node_modules/upper-case-first/upper-case-first.js":
/***/ (function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__("./node_modules/upper-case/upper-case.js")
	
	/**
	 * Upper case the first character of a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  str = String(str)
	
	  return upperCase(str.charAt(0), locale) + str.substr(1)
	}


/***/ }),

/***/ "./node_modules/upper-case/upper-case.js":
/***/ (function(module, exports) {

	/**
	 * Special language-specific overrides.
	 *
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 *
	 * @type {Object}
	 */
	var LANGUAGES = {
	  tr: {
	    regexp: /[\u0069]/g,
	    map: {
	      '\u0069': '\u0130'
	    }
	  },
	  az: {
	    regexp: /[\u0069]/g,
	    map: {
	      '\u0069': '\u0130'
	    }
	  },
	  lt: {
	    regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
	    map: {
	      '\u0069\u0307': '\u0049',
	      '\u006A\u0307': '\u004A',
	      '\u012F\u0307': '\u012E',
	      '\u0069\u0307\u0300': '\u00CC',
	      '\u0069\u0307\u0301': '\u00CD',
	      '\u0069\u0307\u0303': '\u0128'
	    }
	  }
	}
	
	/**
	 * Upper case a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  var lang = LANGUAGES[locale]
	
	  str = str == null ? '' : String(str)
	
	  if (lang) {
	    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
	  }
	
	  return str.toUpperCase()
	}


/***/ }),

/***/ "./src/components/CodeSnippet/CodeSnippet.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHighlight = __webpack_require__("./node_modules/react-highlight/index.js");
	
	var _reactHighlight2 = _interopRequireDefault(_reactHighlight);
	
	__webpack_require__("./node_modules/highlight.js/styles/dracula.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CodeSnippet = function CodeSnippet(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    _reactHighlight2.default,
	    { className: className },
	    ' ',
	    children,
	    ' '
	  );
	};
	
	CodeSnippet.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string
	};
	
	exports.default = CodeSnippet;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/CopyButton/CopyButton.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Pulse = __webpack_require__("./node_modules/grommet/components/icons/Pulse.js");
	
	var _Pulse2 = _interopRequireDefault(_Pulse);
	
	var _Copy = __webpack_require__("./node_modules/grommet/components/icons/base/Copy.js");
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _reactTooltip = __webpack_require__("./node_modules/react-tooltip/dist/index.js");
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _Animate = __webpack_require__("./node_modules/grommet/components/Animate.js");
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CopyButton = function CopyButton(_ref) {
	  var copiedLabelVisible = _ref.copiedLabelVisible,
	      dataTip = _ref.dataTip,
	      onCopyBtnClick = _ref.onCopyBtnClick;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { cursor: 'pointer' } },
	    _react2.default.createElement(_Pulse2.default, { icon: _react2.default.createElement(_Copy2.default, null), 'data-tip': dataTip, onClick: onCopyBtnClick }),
	    _react2.default.createElement(_reactTooltip2.default, null),
	    _react2.default.createElement(
	      _Animate2.default,
	      {
	        visible: copiedLabelVisible,
	        enter: { animation: 'slide-right', duration: 300, delay: 0 },
	        leave: { animation: 'slide-right', duration: 900, delay: 0 }
	      },
	      _react2.default.createElement(
	        'span',
	        { style: { position: 'absolute' } },
	        'Copied!'
	      )
	    )
	  );
	};
	
	CopyButton.propTypes = {
	  copiedLabelVisible: _propTypes2.default.bool,
	  dataTip: _propTypes2.default.string,
	  onCopyBtnClick: _propTypes2.default.func
	};
	
	exports.default = CopyButton;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/Devicon/Devicon.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Box = __webpack_require__("./node_modules/grommet/components/Box.js");
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _IconImportCode = __webpack_require__("./src/components/IconImportCode/IconImportCode.js");
	
	var _IconImportCode2 = _interopRequireDefault(_IconImportCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Devicon = function Devicon(_ref) {
	  var IconComponent = _ref.IconComponent,
	      componentName = _ref.componentName,
	      iconName = _ref.iconName,
	      iconVersion = _ref.iconVersion;
	
	  return _react2.default.createElement(
	    _Box2.default,
	    { align: 'center' },
	    _react2.default.createElement(
	      _Box2.default,
	      {
	        margin: {
	          vertical: 'medium'
	        }
	      },
	      _react2.default.createElement(IconComponent, { key: componentName, width: 200, height: 200 })
	    ),
	    _react2.default.createElement(
	      _Box2.default,
	      null,
	      _react2.default.createElement(_IconImportCode2.default, { iconName: iconName, iconVersion: iconVersion })
	    )
	  );
	};
	
	Devicon.propTypes = {
	  iconComponent: _propTypes2.default.element,
	  componentName: _propTypes2.default.string,
	  iconName: _propTypes2.default.string,
	  iconVersion: _propTypes2.default.string
	};
	
	exports.default = Devicon;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/IconImportCode/IconImportCode.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pascalCase = __webpack_require__("./node_modules/pascal-case/pascal-case.js");
	
	var _pascalCase2 = _interopRequireDefault(_pascalCase);
	
	var _Box = __webpack_require__("./node_modules/grommet/components/Box.js");
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _CodeSnippet = __webpack_require__("./src/components/CodeSnippet/CodeSnippet.js");
	
	var _CodeSnippet2 = _interopRequireDefault(_CodeSnippet);
	
	var _CopyButtonContainer = __webpack_require__("./src/containers/CopyButtonContainer/CopyButtonContainer.js");
	
	var _CopyButtonContainer2 = _interopRequireDefault(_CopyButtonContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconImportCode = function IconImportCode(_ref) {
	  var iconName = _ref.iconName,
	      iconVersion = _ref.iconVersion;
	
	  var code = 'import Icon' + (0, _pascalCase2.default)(iconName) + ' from \'react-devicon/' + iconName + '/' + iconVersion + '\'';
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _CodeSnippet2.default,
	      { className: 'javascript' },
	      code
	    ),
	    _react2.default.createElement(
	      _Box2.default,
	      { justify: 'center', direction: 'center' },
	      _react2.default.createElement(_CopyButtonContainer2.default, { toCopy: code })
	    )
	  );
	};
	
	IconImportCode.propTypes = {
	  iconName: _propTypes2.default.string,
	  iconVersion: _propTypes2.default.string
	};
	
	exports.default = IconImportCode;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/containers/CopyButtonContainer/CopyButtonContainer.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CopyButton = __webpack_require__("./src/components/CopyButton/CopyButton.js");
	
	var _CopyButton2 = _interopRequireDefault(_CopyButton);
	
	var _copyToClipboard = __webpack_require__("./node_modules/copy-to-clipboard/index.js");
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CopyButtonContainer = function (_Component) {
	  _inherits(CopyButtonContainer, _Component);
	
	  function CopyButtonContainer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CopyButtonContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      copedLabelVisible: false
	    }, _this.handleCopyButtonClick = function () {
	      (0, _copyToClipboard2.default)(_this.props.toCopy);
	      _this.setState({
	        copedLabelVisible: true
	      }, function () {
	        return setTimeout(function () {
	          return _this.setState({
	            copedLabelVisible: false
	          }, 1000);
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CopyButtonContainer.prototype.render = function render() {
	    return _react2.default.createElement(_CopyButton2.default, {
	      copiedLabelVisible: this.state.copedLabelVisible,
	      dataTip: 'Copy to Clipboard',
	      onCopyBtnClick: this.handleCopyButtonClick
	    });
	  };
	
	  return CopyButtonContainer;
	}(_react.Component);
	
	CopyButtonContainer.propTypes = {
	  toCopy: _propTypes2.default.string
	};
	
	exports.default = CopyButtonContainer;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/media/fpoumian/seagate_dev/code/javascript/WebStormProjects/react-devicon/docs/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/media/fpoumian/seagate_dev/code/javascript/WebStormProjects/react-devicon/docs/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/media/fpoumian/seagate_dev/code/javascript/WebStormProjects/react-devicon/docs/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/media/fpoumian/seagate_dev/code/javascript/WebStormProjects/react-devicon/docs/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/media/fpoumian/seagate_dev/code/javascript/WebStormProjects/react-devicon/docs/node_modules/babel-preset-stage-0/lib/index.js\",\"/media/fpoumian/seagate_dev/code/javascript/WebStormProjects/react-devicon/docs/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/IconPage.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__("../src/components/index.js");
	
	var iconComponents = _interopRequireWildcard(_index);
	
	var _pascalCase = __webpack_require__("./node_modules/pascal-case/pascal-case.js");
	
	var _pascalCase2 = _interopRequireDefault(_pascalCase);
	
	var _Devicon = __webpack_require__("./src/components/Devicon/Devicon.js");
	
	var _Devicon2 = _interopRequireDefault(_Devicon);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _List = __webpack_require__("./node_modules/grommet/components/List.js");
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__("./node_modules/grommet/components/ListItem.js");
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Heading = __webpack_require__("./node_modules/grommet/components/Heading.js");
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconPage = function (_React$Component) {
	  _inherits(IconPage, _React$Component);
	
	  function IconPage() {
	    _classCallCheck(this, IconPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IconPage.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return false;
	  };
	
	  IconPage.prototype.render = function render() {
	    var _props$pathContext = this.props.pathContext,
	        name = _props$pathContext.name,
	        versions = _props$pathContext.versions;
	
	
	    var devicons = versions.map(function (version) {
	      return {
	        componentName: '' + (0, _pascalCase2.default)(name) + (0, _pascalCase2.default)(version),
	        name: name,
	        version: version
	      };
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'React Devicon | ' + name
	        )
	      ),
	      _react2.default.createElement(
	        _Heading2.default,
	        { align: 'center' },
	        this.props.pathContext.name
	      ),
	      _react2.default.createElement(
	        _List2.default,
	        null,
	        devicons.map(function (devicon) {
	          var IconComponent = iconComponents[devicon.componentName] || null;
	          return IconComponent ? _react2.default.createElement(
	            _ListItem2.default,
	            {
	              justify: 'center',
	              pad: {
	                vertical: 'medium'
	              },
	              key: devicon.componentName
	            },
	            _react2.default.createElement(_Devicon2.default, {
	              componentName: devicon.componentName,
	              iconName: devicon.name,
	              iconVersion: devicon.version,
	              IconComponent: IconComponent
	            })
	          ) : '';
	        })
	      )
	    );
	  };
	
	  return IconPage;
	}(_react2.default.Component);
	
	IconPage.propTypes = {
	  pathContext: _propTypes2.default.object
	};
	
	exports.default = IconPage;
	module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/lodash.isnumber/index.js":
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	 * as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && objectToString.call(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),

/***/ "../node_modules/react-svg-inline/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles from "./styles"
	
	var cleanups = {
	  // some useless stuff for us
	  // that svgo doesn't remove
	  title: /<title>.*<\/title>/gi,
	  desc: /<desc>.*<\/desc>/gi,
	  comment: /<!--.*-->/gi,
	  defs: /<defs>.*<\/defs>/gi,
	
	  // remove hardcoded dimensions
	  width: / +width="\d+(\.\d+)?(px)?"/gi,
	  height: / +height="\d+(\.\d+)?(px)?"/gi,
	
	  // remove fill
	  fill: / +fill=\"(none|#[0-9a-f]+)\"/gi,
	
	  // Sketch.app shit
	  sketchMSShapeGroup: / +sketch:type=\"MSShapeGroup\"/gi,
	  sketchMSPage: / +sketch:type=\"MSPage\"/gi,
	  sketchMSLayerGroup: / +sketch:type=\"MSLayerGroup\"/gi
	};
	
	// @styled(styles)
	
	var SVGInline = function (_Component) {
	  _inherits(SVGInline, _Component);
	
	  function SVGInline() {
	    _classCallCheck(this, SVGInline);
	
	    return _possibleConstructorReturn(this, (SVGInline.__proto__ || Object.getPrototypeOf(SVGInline)).apply(this, arguments));
	  }
	
	  _createClass(SVGInline, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          component = _props.component,
	          svg = _props.svg,
	          fill = _props.fill,
	          width = _props.width,
	          classSuffix = _props.classSuffix,
	          cleanupExceptions = _props.cleanupExceptions,
	          componentProps = _objectWithoutProperties(_props, ["className", "component", "svg", "fill", "width", "classSuffix", "cleanupExceptions"]);
	
	      var _props2 = this.props,
	          cleanup = _props2.cleanup,
	          height = _props2.height;
	
	
	      if (
	      // simple way to enable entire cleanup
	      cleanup === true ||
	      // passing cleanupExceptions enable cleanup as well
	      cleanup.length === 0 && cleanupExceptions.length > 0) {
	        cleanup = Object.keys(cleanups);
	      }
	      cleanup = cleanup.filter(function (key) {
	        return !(cleanupExceptions.indexOf(key) > -1);
	      });
	
	      if (width && height === undefined) {
	        height = width;
	      }
	
	      // remove useless props for wrapper
	      delete componentProps.cleanup;
	      delete componentProps.height;
	
	      var classes = (0, _classnames2.default)(_defineProperty({
	        "SVGInline": true,
	        "SVGInline--cleaned": cleanup.length
	      }, className, className));
	      var svgClasses = classes.split(" ").join(classSuffix + " ") + classSuffix;
	
	      return _react2.default.createElement(component, _extends({}, componentProps, { // take most props
	        className: classes,
	        dangerouslySetInnerHTML: {
	          __html: SVGInline.cleanupSvg(svg, cleanup).replace(/<svg/, "<svg class=\"" + svgClasses + "\"" + (fill ? " fill=\"" + fill + "\"" : "") + (width || height ? " style=\"" + (width ? "width: " + width + ";" : "") + (height ? "height: " + height + ";" : "") + "\"" : ""))
	        }
	      }));
	    }
	  }]);
	
	  return SVGInline;
	}(_react.Component);
	
	SVGInline.propTypes = {
	  className: _propTypes2.default.string,
	  classSuffix: _propTypes2.default.string,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  svg: _propTypes2.default.string.isRequired,
	  fill: _propTypes2.default.string,
	  cleanup: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
	  cleanupExceptions: _propTypes2.default.array,
	  width: _propTypes2.default.string,
	  height: _propTypes2.default.string
	};
	
	SVGInline.defaultProps = {
	  component: "span",
	  classSuffix: "-svg",
	  cleanup: [],
	  cleanupExceptions: []
	};
	
	SVGInline.cleanupSvg = function (svg) {
	  var cleanup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  return Object.keys(cleanups).filter(function (key) {
	    return cleanup.indexOf(key) > -1;
	  }).reduce(function (acc, key) {
	    return acc.replace(cleanups[key], "");
	  }, svg).trim();
	};
	
	exports.default = SVGInline;

/***/ }),

/***/ "../src/components/amazonwebservices/original-wordmark/AmazonwebservicesOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AmazonwebservicesOriginalWordmark = __webpack_require__("../src/components/amazonwebservices/original-wordmark/AmazonwebservicesOriginalWordmark.svg");
	
	var _AmazonwebservicesOriginalWordmark2 = _interopRequireDefault(_AmazonwebservicesOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AmazonwebservicesOriginalWordmark */
	function AmazonwebservicesOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AmazonwebservicesOriginalWordmark',
	    svg: _AmazonwebservicesOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AmazonwebservicesOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AmazonwebservicesOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/amazonwebservices/original-wordmark/AmazonwebservicesOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#201C1D\" d=\"M44.634 57.361c-2.599 0-5.499 1.001-6.107 4.296-.064.351.167.517.391.567l2.663.32c.246-.014.414-.28.461-.533.228-1.134 1.16-1.669 2.201-1.669.563 0 1.193.193 1.527.71.381.576.354 1.359.354 2.024v.391c-1.582.182-3.666.292-5.147.958-1.709.76-2.912 2.307-2.912 4.58 0 2.913 1.785 4.366 4.083 4.366 1.94 0 3.013-.456 4.509-2.022.497.738.656 1.073 1.562 1.846a.55.55 0 0 0 .64-.071v.035c.545-.497 1.535-1.401 2.094-1.881.222-.187.174-.493 0-.746-.5-.707-1.029-1.276-1.029-2.592v-4.366c0-1.85.156-3.556-1.172-4.828-1.046-1.031-2.791-1.385-4.118-1.385zm35.786 0c-2.6 0-5.498 1.001-6.106 4.296-.064.351.166.517.39.567l2.664.32c.246-.014.415-.28.461-.533.229-1.134 1.161-1.669 2.201-1.669.564 0 1.193.193 1.526.71.381.576.319 1.359.319 2.024v.391c-1.582.182-3.63.292-5.112.958-1.711.76-2.91 2.307-2.91 4.58 0 2.913 1.785 4.366 4.082 4.366 1.938 0 3.011-.456 4.509-2.022.495.738.656 1.073 1.563 1.846a.548.548 0 0 0 .639-.071v.035c.546-.497 1.537-1.401 2.095-1.881.222-.187.171-.493 0-.746-.5-.707-1.03-1.276-1.03-2.592v-4.366c0-1.85.12-3.556-1.206-4.828-1.05-1.031-2.759-1.385-4.085-1.385zm-20.13.142c-1.68 0-2.924.848-3.585 2.663h-.036v-1.882a.534.534 0 0 0-.496-.497h-2.557a.54.54 0 0 0-.533.533v14.378a.554.554 0 0 0 .498.497h2.733a.537.537 0 0 0 .532-.533v-7.633c0-1.664-.08-3.94 1.882-3.94 1.937 0 1.668 2.339 1.668 3.94v7.633c0 .271.222.515.498.533h2.733c.29 0 .532-.243.532-.533v-7.633c0-.816-.033-2.006.248-2.733s.971-1.207 1.634-1.207c.789 0 1.394.275 1.598 1.242.126.575.071 2.094.071 2.698v7.633c0 .271.222.515.496.533h2.734c.29 0 .532-.243.532-.533v-9.088c0-1.545.154-3.298-.71-4.509-.765-1.088-2.015-1.563-3.16-1.563-1.605 0-3.101.848-3.763 2.663-.764-1.814-1.842-2.662-3.549-2.662zm46.472 0c-3.949 0-6.142 3.473-6.142 7.953 0 4.448 2.167 8.022 6.142 8.022 3.823 0 6.249-3.492 6.249-7.881 0-4.537-2.198-8.094-6.249-8.094zm15.585 0c-1.887 0-2.966.943-3.728 2.911h-.035v-2.201c-.049-.222-.258-.377-.497-.39h-2.521a.525.525 0 0 0-.533.461v14.378c0 .271.225.515.497.533h2.699a.54.54 0 0 0 .531-.533v-7.739c0-.97.083-1.855.463-2.733.306-.697.899-1.137 1.562-1.137 1.883 0 1.703 2.295 1.703 3.87v7.811a.545.545 0 0 0 .498.462h2.733a.537.537 0 0 0 .532-.462v-9.053c0-1.392.003-3.324-.71-4.474-.764-1.241-1.975-1.704-3.194-1.704zm-32.803.249c-.278 0-.497.22-.498.532v2.059c.001.31.213.531.498.533h4.686l-5.361 7.916c-.326.511-.354 1.089-.354 1.421v2.095c0 .302.328.63.639.461 3.056-1.668 6.717-1.52 9.479-.035.336.183.675-.16.675-.462V70.07a.934.934 0 0 0-.497-.781c-1.568-.901-3.388-1.178-5.111-1.136l4.65-6.815c.43-.613.67-.981.674-1.279v-1.774c0-.306-.209-.532-.496-.532h-8.984zm17.218 2.698c.865 0 1.504.386 1.811 1.384.354 1.152.391 2.588.391 3.799 0 1.846-.086 4.899-2.201 4.899-2.139 0-2.13-3.78-2.13-5.538-.001-1.753.117-4.544 2.129-4.544zm-60.673 5.254v.604c0 1.092.04 2.01-.497 2.981-.434.79-1.116 1.279-1.881 1.279-1.045 0-1.668-.849-1.668-2.06-.001-2.387 2.074-2.804 4.046-2.804zm35.786 0v.604c0 1.092.04 2.01-.496 2.981-.435.79-1.112 1.279-1.882 1.279-1.047 0-1.669-.849-1.669-2.06 0-2.387 2.073-2.804 4.047-2.804z\"/><path d=\"M99.59 73.656v2.06h1.386v-2.06H99.59zm-40.152.356v14.662h1.278V87.36c.272.521.582.91.958 1.171.376.262.806.391 1.277.391.939 0 1.75-.479 2.45-1.455.701-.977 1.065-2.392 1.065-4.189 0-1.178-.151-2.154-.462-2.981-.311-.826-.725-1.441-1.242-1.847-.519-.406-1.107-.639-1.739-.639-.452 0-.874.118-1.244.354-.368.236-.666.622-.958 1.101v-5.254h-1.383zm13.135 3.443c-.962 0-1.728.285-2.271.852s-.815 1.296-.815 2.202c0 .525.115.972.318 1.384.202.413.49.748.852.994.364.246 1.09.57 2.166.923.745.24 1.19.444 1.385.604.281.233.427.538.427.959 0 .486-.17.892-.498 1.207-.328.317-.786.461-1.385.461-.6 0-1.094-.168-1.455-.532-.362-.364-.557-.918-.64-1.668l-1.384.283c.313 2.278 1.449 3.41 3.408 3.408 1.045 0 1.844-.295 2.449-.923.604-.628.924-1.471.924-2.485 0-.548-.098-1.022-.284-1.419a2.251 2.251 0 0 0-.782-.924c-.336-.229-1.089-.536-2.236-.923-.834-.292-1.321-.506-1.49-.64-.284-.224-.427-.53-.427-.922 0-.4.133-.739.427-.995.294-.255.747-.39 1.349-.39 1.058 0 1.65.581 1.774 1.739l1.35-.213c-.094-.732-.253-1.312-.496-1.705a2.665 2.665 0 0 0-1.065-.958c-.465-.232-.992-.319-1.601-.319zm8.486 0c-1.109 0-2.046.457-2.77 1.42-.723.963-1.063 2.358-1.063 4.189 0 1.764.348 3.146 1.063 4.083.718.934 1.646 1.384 2.806 1.384.921 0 1.685-.276 2.307-.852.624-.575 1.077-1.423 1.313-2.557l-1.42-.248c-.407 1.451-1.16 2.163-2.2 2.165-.664 0-1.206-.281-1.669-.887-.464-.607-.726-1.507-.78-2.698h6.105v-.497c0-1.792-.357-3.137-1.065-4.083-.709-.945-1.569-1.419-2.627-1.419zm8.414 0c-.331 0-.621.112-.888.355-.267.242-.567.744-.888 1.49v-1.633h-1.243v10.615h1.385v-5.538c0-.772.074-1.516.249-2.201.1-.394.289-.703.532-.923.244-.221.523-.32.816-.32.326 0 .65.131.994.391l.462-1.668c-.482-.386-.955-.568-1.419-.568zm16.969 0c-1.096 0-1.999.462-2.699 1.385-.696.923-1.063 2.309-1.063 4.153 0 1.831.372 3.218 1.063 4.154.693.934 1.559 1.384 2.628 1.384.884 0 1.642-.328 2.272-.994.63-.665 1.014-1.646 1.172-2.911l-1.35-.213c-.101.905-.336 1.557-.71 1.988-.373.43-.823.639-1.349.639-.67 0-1.241-.313-1.67-.958-.427-.646-.638-1.68-.638-3.124 0-1.4.227-2.41.674-3.053.448-.644 1.021-.994 1.704-.994.457 0 .847.177 1.172.531.327.356.543.918.674 1.634l1.351-.283c-.162-1.119-.521-1.962-1.102-2.521-.58-.56-1.284-.817-2.129-.817zm7.917 0c-1.11 0-2.046.457-2.77 1.42-.723.963-1.065 2.358-1.065 4.189 0 1.764.349 3.146 1.065 4.083.719.934 1.646 1.384 2.805 1.384.918 0 1.685-.276 2.308-.852.622-.575 1.075-1.423 1.314-2.557l-1.42-.248c-.41 1.451-1.128 2.163-2.166 2.165-.664 0-1.241-.281-1.704-.887-.463-.607-.725-1.507-.781-2.698h6.106v-.497c0-1.792-.357-3.137-1.065-4.083-.706-.945-1.568-1.419-2.627-1.419zm8.202 0c-.966 0-1.729.285-2.272.852-.545.566-.817 1.296-.817 2.202 0 .525.082.972.284 1.384.2.413.489.748.853.994.361.246 1.09.57 2.166.923.743.24 1.226.444 1.42.604.281.233.426.538.426.959 0 .486-.168.892-.497 1.207-.326.317-.785.461-1.384.461-.602 0-1.094-.168-1.456-.532-.361-.364-.595-.918-.675-1.668l-1.384.283c.313 2.278 1.446 3.41 3.407 3.408 1.047 0 1.881-.295 2.485-.923s.922-1.471.922-2.485c0-.548-.096-1.022-.282-1.419a2.322 2.322 0 0 0-.817-.924c-.336-.229-1.054-.536-2.2-.923-.835-.292-1.357-.506-1.527-.64-.283-.224-.426-.53-.426-.922 0-.4.167-.739.462-.995.294-.255.75-.39 1.35-.39 1.058 0 1.649.581 1.774 1.739l1.349-.213c-.094-.732-.252-1.312-.497-1.705a2.662 2.662 0 0 0-1.064-.958c-.463-.232-.994-.319-1.6-.319zm-31.668.213l3.09 10.615h1.313l3.089-10.615h-1.42l-1.811 6.497c-.219.785-.413 1.464-.533 2.023-.15-.705-.296-1.446-.496-2.166l-1.775-6.354h-1.457zm8.697 0v10.615h1.386V77.668H99.59zm-45.513.143c-1.098 0-1.981.492-2.697 1.455-.717.963-1.102 2.358-1.102 4.189 0 1.765.355 3.113 1.065 4.047.709.935 1.657 1.42 2.806 1.42.911 0 1.655-.312 2.271-.888.616-.575 1.042-1.423 1.279-2.556l-1.385-.213c-.404 1.451-1.136 2.163-2.165 2.165-.659 0-1.21-.281-1.669-.888-.46-.606-.727-1.506-.781-2.697h6.035l.036-.497c0-1.792-.364-3.172-1.065-4.119-.701-.945-1.581-1.418-2.628-1.418zm-15.584.248l2.485 10.615h1.455l1.634-8.165.284 1.81 1.313 6.355h1.42l2.521-10.615h-1.313L46.906 84.2l-.462 2.06-.426-2.06-1.207-6.142h-1.42l-1.278 6.213-.426 2.201-.496-2.272-1.279-6.142h-1.419zm42.53.852c.69 0 1.258.333 1.704.994.306.452.506 1.14.567 2.059h-4.58c.044-.932.307-1.65.747-2.201.44-.55.943-.852 1.562-.852zm33.3 0c.688 0 1.258.333 1.704.994.308.452.506 1.14.569 2.059h-4.581c.044-.932.308-1.65.746-2.201.437-.55.943-.852 1.562-.852zm-60.246.39c.682 0 1.23.334 1.67.995.304.452.505 1.14.567 2.059h-4.51c.043-.932.275-1.687.711-2.236.434-.552.948-.818 1.562-.818zm8.805 0c.615 0 1.14.342 1.563.995.423.652.604 1.659.604 3.053 0 1.357-.2 2.37-.64 3.053-.439.684-.96 1.029-1.526 1.029-.416 0-.794-.14-1.136-.426-.344-.286-.595-.696-.782-1.242-.186-.546-.283-1.387-.283-2.485 0-1.294.231-2.263.674-2.947.443-.684.96-1.03 1.526-1.03z\"/><path fill=\"#F7A80D\" d=\"M18.594 68.048l-5.29 2.271 4.899 2.095 5.681-2.095-5.29-2.271zm-7.952 2.839l-.178 10.226 7.74 3.408V73.905l-7.562-3.018zm15.904 0l-6.994 2.663v10.012l6.994-2.84v-9.835zm8.343-31.809l-5.326 2.271 4.935 2.095 5.681-2.095-5.29-2.271zm-7.385 3.018V52.32l6.604 1.917.213-9.302-6.817-2.839zm14.769.567l-6.249 2.663v10.047l6.249-2.84v-9.87zM9.877 53.468l-5.29 2.272 4.899 2.095 5.68-2.095-5.289-2.272zm-7.951 2.841l-.178 10.224 7.739 3.408V59.326l-7.561-3.017zm15.904 0l-6.994 2.662v10.012l6.994-2.84v-9.834zm9.088-3.218l-5.29 2.271 4.899 2.094 5.68-2.094-5.289-2.271zm-7.952 2.839l-.177 10.225 7.739 3.408V58.948l-7.562-3.018zm15.905 0l-6.994 2.663v10.012l6.994-2.841V55.93zm16.662-16.852l-5.289 2.271 4.899 2.095 5.681-2.095-5.291-2.271zm-7.952 2.84l-.178 10.225 7.74 3.407V44.936l-7.562-3.018zm15.904 0l-6.994 2.663v10.011l6.994-2.84v-9.834z\"/></svg>"

/***/ }),

/***/ "../src/components/amazonwebservices/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AmazonwebservicesOriginalWordmark = __webpack_require__("../src/components/amazonwebservices/original-wordmark/AmazonwebservicesOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AmazonwebservicesOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/amazonwebservices/original/AmazonwebservicesOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AmazonwebservicesOriginal = __webpack_require__("../src/components/amazonwebservices/original/AmazonwebservicesOriginal.svg");
	
	var _AmazonwebservicesOriginal2 = _interopRequireDefault(_AmazonwebservicesOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AmazonwebservicesOriginal */
	function AmazonwebservicesOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AmazonwebservicesOriginal',
	    svg: _AmazonwebservicesOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AmazonwebservicesOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AmazonwebservicesOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/amazonwebservices/original/AmazonwebservicesOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#F7A80D\" d=\"M38.089 77.466l-11.4 4.896 10.559 4.514 12.241-4.514-11.4-4.896zm-17.138 6.12l-.382 22.034 16.679 7.345V90.089l-16.297-6.503zm34.276 0l-15.073 5.739V110.9l15.073-6.121V83.586zm17.979-68.551L61.73 19.931l10.635 4.515 12.241-4.515-11.4-4.896zm-15.914 6.503v22.034l14.231 4.132.459-20.046-14.69-6.12zm31.828 1.224L75.654 28.5v21.652l13.466-6.121V22.762zM19.306 46.047L7.907 50.944l10.558 4.514 12.241-4.514-11.4-4.897zM2.168 52.168l-.382 22.034 16.679 7.345V58.671L2.168 52.168zm34.275 0l-15.071 5.738V79.48l15.071-6.12V52.168zm19.587-6.937l-11.4 4.897 10.558 4.514 12.241-4.514-11.399-4.897zm-17.137 6.121l-.383 22.035 16.679 7.345V57.855l-16.296-6.503zm34.275 0L58.096 57.09v21.576l15.072-6.121V51.352zm35.908-36.317l-11.399 4.896 10.559 4.515 12.241-4.515-11.401-4.896zm-17.137 6.121l-.382 22.034 16.679 7.344V27.658l-16.297-6.502zm34.275 0l-15.071 5.738v21.575l15.071-6.12V21.156z\"/></svg>"

/***/ }),

/***/ "../src/components/amazonwebservices/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AmazonwebservicesOriginal = __webpack_require__("../src/components/amazonwebservices/original/AmazonwebservicesOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AmazonwebservicesOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/amazonwebservices/plain-wordmark/AmazonwebservicesPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AmazonwebservicesPlainWordmark = __webpack_require__("../src/components/amazonwebservices/plain-wordmark/AmazonwebservicesPlainWordmark.svg");
	
	var _AmazonwebservicesPlainWordmark2 = _interopRequireDefault(_AmazonwebservicesPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AmazonwebservicesPlainWordmark */
	function AmazonwebservicesPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AmazonwebservicesPlainWordmark',
	    svg: _AmazonwebservicesPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AmazonwebservicesPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AmazonwebservicesPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/amazonwebservices/plain-wordmark/AmazonwebservicesPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#F7A80D\" d=\"M44.634 57.361c-2.599 0-5.499 1.001-6.107 4.296-.064.351.167.517.391.567l2.663.32c.246-.014.414-.28.461-.533.228-1.134 1.16-1.669 2.201-1.669.563 0 1.193.193 1.527.71.381.576.354 1.359.354 2.024v.391c-1.582.182-3.666.292-5.147.958-1.709.76-2.912 2.307-2.912 4.58 0 2.913 1.785 4.366 4.083 4.366 1.94 0 3.013-.456 4.509-2.022.497.738.656 1.073 1.562 1.846a.55.55 0 0 0 .64-.071v.035c.545-.497 1.535-1.401 2.094-1.881.222-.187.174-.493 0-.746-.5-.707-1.029-1.276-1.029-2.592v-4.366c0-1.85.156-3.556-1.172-4.828-1.046-1.031-2.791-1.385-4.118-1.385zm35.786 0c-2.6 0-5.498 1.001-6.106 4.296-.064.351.166.517.39.567l2.664.32c.246-.014.415-.28.461-.533.229-1.134 1.161-1.669 2.201-1.669.564 0 1.193.193 1.526.71.381.576.319 1.359.319 2.024v.391c-1.582.182-3.63.292-5.112.958-1.711.76-2.91 2.307-2.91 4.58 0 2.913 1.785 4.366 4.082 4.366 1.938 0 3.011-.456 4.509-2.022.495.738.656 1.073 1.563 1.846a.548.548 0 0 0 .639-.071v.035c.546-.497 1.537-1.401 2.095-1.881.222-.187.171-.493 0-.746-.5-.707-1.03-1.276-1.03-2.592v-4.366c0-1.85.12-3.556-1.206-4.828-1.05-1.031-2.759-1.385-4.085-1.385zm-20.13.142c-1.68 0-2.924.848-3.585 2.663h-.036v-1.882a.534.534 0 0 0-.496-.497h-2.557a.54.54 0 0 0-.533.533v14.378a.554.554 0 0 0 .498.497h2.733a.537.537 0 0 0 .532-.533v-7.633c0-1.664-.08-3.94 1.882-3.94 1.937 0 1.668 2.339 1.668 3.94v7.633c0 .271.222.515.498.533h2.733c.29 0 .532-.243.532-.533v-7.633c0-.816-.033-2.006.248-2.733s.971-1.207 1.634-1.207c.789 0 1.394.275 1.598 1.242.126.575.071 2.094.071 2.698v7.633c0 .271.222.515.496.533h2.734c.29 0 .532-.243.532-.533v-9.088c0-1.545.154-3.298-.71-4.509-.765-1.088-2.015-1.563-3.16-1.563-1.605 0-3.101.848-3.763 2.663-.764-1.814-1.842-2.662-3.549-2.662zm46.472 0c-3.949 0-6.142 3.473-6.142 7.953 0 4.448 2.167 8.022 6.142 8.022 3.823 0 6.249-3.492 6.249-7.881 0-4.537-2.198-8.094-6.249-8.094zm15.585 0c-1.887 0-2.966.943-3.728 2.911h-.035v-2.201c-.049-.222-.258-.377-.497-.39h-2.521a.525.525 0 0 0-.533.461v14.378c0 .271.225.515.497.533h2.699a.54.54 0 0 0 .531-.533v-7.739c0-.97.083-1.855.463-2.733.306-.697.899-1.137 1.562-1.137 1.883 0 1.703 2.295 1.703 3.87v7.811a.545.545 0 0 0 .498.462h2.733a.537.537 0 0 0 .532-.462v-9.053c0-1.392.003-3.324-.71-4.474-.764-1.241-1.975-1.704-3.194-1.704zm-32.803.249c-.278 0-.497.22-.498.532v2.059c.001.31.213.531.498.533h4.686l-5.361 7.916c-.326.511-.354 1.089-.354 1.421v2.095c0 .302.328.63.639.461 3.056-1.668 6.717-1.52 9.479-.035.336.183.675-.16.675-.462V70.07a.934.934 0 0 0-.497-.781c-1.568-.901-3.388-1.178-5.111-1.136l4.65-6.815c.43-.613.67-.981.674-1.279v-1.774c0-.306-.209-.532-.496-.532h-8.984zm17.218 2.698c.865 0 1.504.386 1.811 1.384.354 1.152.391 2.588.391 3.799 0 1.846-.086 4.899-2.201 4.899-2.139 0-2.13-3.78-2.13-5.538-.001-1.753.117-4.544 2.129-4.544zm-60.673 5.254v.604c0 1.092.04 2.01-.497 2.981-.434.79-1.116 1.279-1.881 1.279-1.045 0-1.668-.849-1.668-2.06-.001-2.387 2.074-2.804 4.046-2.804zm35.786 0v.604c0 1.092.04 2.01-.496 2.981-.435.79-1.112 1.279-1.882 1.279-1.047 0-1.669-.849-1.669-2.06 0-2.387 2.073-2.804 4.047-2.804zm17.715 7.952v2.06h1.386v-2.06H99.59zm-40.152.356v14.662h1.278V87.36c.272.521.582.91.958 1.171.376.262.806.391 1.277.391.939 0 1.75-.479 2.45-1.455.701-.977 1.065-2.392 1.065-4.189 0-1.178-.151-2.154-.462-2.981-.311-.826-.725-1.441-1.242-1.847-.519-.406-1.107-.639-1.739-.639-.452 0-.874.118-1.244.354-.368.236-.666.622-.958 1.101v-5.254h-1.383zm13.135 3.443c-.962 0-1.728.285-2.271.852s-.815 1.296-.815 2.202c0 .525.115.972.318 1.384.202.413.49.748.852.994.364.246 1.09.57 2.166.923.745.24 1.19.444 1.385.604.281.233.427.538.427.959 0 .486-.17.892-.498 1.207-.328.317-.786.461-1.385.461-.6 0-1.094-.168-1.455-.532-.362-.364-.557-.918-.64-1.668l-1.384.283c.313 2.278 1.449 3.41 3.408 3.408 1.045 0 1.844-.295 2.449-.923.604-.628.924-1.471.924-2.485 0-.548-.098-1.022-.284-1.419a2.251 2.251 0 0 0-.782-.924c-.336-.229-1.089-.536-2.236-.923-.834-.292-1.321-.506-1.49-.64-.284-.224-.427-.53-.427-.922 0-.4.133-.739.427-.995.294-.255.747-.39 1.349-.39 1.058 0 1.65.581 1.774 1.739l1.35-.213c-.094-.732-.253-1.312-.496-1.705a2.665 2.665 0 0 0-1.065-.958c-.465-.232-.992-.319-1.601-.319zm8.486 0c-1.109 0-2.046.457-2.77 1.42-.723.963-1.063 2.358-1.063 4.189 0 1.764.348 3.146 1.063 4.083.718.934 1.646 1.384 2.806 1.384.921 0 1.685-.276 2.307-.852.624-.575 1.077-1.423 1.313-2.557l-1.42-.248c-.407 1.451-1.16 2.163-2.2 2.165-.664 0-1.206-.281-1.669-.887-.464-.607-.726-1.507-.78-2.698h6.105v-.497c0-1.792-.357-3.137-1.065-4.083-.709-.945-1.569-1.419-2.627-1.419zm8.414 0c-.331 0-.621.112-.888.355-.267.242-.567.744-.888 1.49v-1.633h-1.243v10.615h1.385v-5.538c0-.772.074-1.516.249-2.201.1-.394.289-.703.532-.923.244-.221.523-.32.816-.32.326 0 .65.131.994.391l.462-1.668c-.482-.386-.955-.568-1.419-.568zm16.969 0c-1.096 0-1.999.462-2.699 1.385-.696.923-1.063 2.309-1.063 4.153 0 1.831.372 3.218 1.063 4.154.693.934 1.559 1.384 2.628 1.384.884 0 1.642-.328 2.272-.994.63-.665 1.014-1.646 1.172-2.911l-1.35-.213c-.101.905-.336 1.557-.71 1.988-.373.43-.823.639-1.349.639-.67 0-1.241-.313-1.67-.958-.427-.646-.638-1.68-.638-3.124 0-1.4.227-2.41.674-3.053.448-.644 1.021-.994 1.704-.994.457 0 .847.177 1.172.531.327.356.543.918.674 1.634l1.351-.283c-.162-1.119-.521-1.962-1.102-2.521-.58-.56-1.284-.817-2.129-.817zm7.917 0c-1.11 0-2.046.457-2.77 1.42-.723.963-1.065 2.358-1.065 4.189 0 1.764.349 3.146 1.065 4.083.719.934 1.646 1.384 2.805 1.384.918 0 1.685-.276 2.308-.852.622-.575 1.075-1.423 1.314-2.557l-1.42-.248c-.41 1.451-1.128 2.163-2.166 2.165-.664 0-1.241-.281-1.704-.887-.463-.607-.725-1.507-.781-2.698h6.106v-.497c0-1.792-.357-3.137-1.065-4.083-.706-.945-1.568-1.419-2.627-1.419zm8.202 0c-.966 0-1.729.285-2.272.852-.545.566-.817 1.296-.817 2.202 0 .525.082.972.284 1.384.2.413.489.748.853.994.361.246 1.09.57 2.166.923.743.24 1.226.444 1.42.604.281.233.426.538.426.959 0 .486-.168.892-.497 1.207-.326.317-.785.461-1.384.461-.602 0-1.094-.168-1.456-.532-.361-.364-.595-.918-.675-1.668l-1.384.283c.313 2.278 1.446 3.41 3.407 3.408 1.047 0 1.881-.295 2.485-.923s.922-1.471.922-2.485c0-.548-.096-1.022-.282-1.419a2.322 2.322 0 0 0-.817-.924c-.336-.229-1.054-.536-2.2-.923-.835-.292-1.357-.506-1.527-.64-.283-.224-.426-.53-.426-.922 0-.4.167-.739.462-.995.294-.255.75-.39 1.35-.39 1.058 0 1.649.581 1.774 1.739l1.349-.213c-.094-.732-.252-1.312-.497-1.705a2.662 2.662 0 0 0-1.064-.958c-.463-.232-.994-.319-1.6-.319zm-31.668.213l3.09 10.615h1.313l3.089-10.615h-1.42l-1.811 6.497c-.219.785-.413 1.464-.533 2.023-.15-.705-.296-1.446-.496-2.166l-1.775-6.354h-1.457zm8.697 0v10.615h1.386V77.668H99.59zm-45.513.143c-1.098 0-1.981.492-2.697 1.455-.717.963-1.102 2.358-1.102 4.189 0 1.765.355 3.113 1.065 4.047.709.935 1.657 1.42 2.806 1.42.911 0 1.655-.312 2.271-.888.616-.575 1.042-1.423 1.279-2.556l-1.385-.213c-.404 1.451-1.136 2.163-2.165 2.165-.659 0-1.21-.281-1.669-.888-.46-.606-.727-1.506-.781-2.697h6.035l.036-.497c0-1.792-.364-3.172-1.065-4.119-.701-.945-1.581-1.418-2.628-1.418zm-15.584.248l2.485 10.615h1.455l1.634-8.165.284 1.81 1.313 6.355h1.42l2.521-10.615h-1.313L46.906 84.2l-.462 2.06-.426-2.06-1.207-6.142h-1.42l-1.278 6.213-.426 2.201-.496-2.272-1.279-6.142h-1.419zm42.53.852c.69 0 1.258.333 1.704.994.306.452.506 1.14.567 2.059h-4.58c.044-.932.307-1.65.747-2.201.44-.55.943-.852 1.562-.852zm33.3 0c.688 0 1.258.333 1.704.994.308.452.506 1.14.569 2.059h-4.581c.044-.932.308-1.65.746-2.201.437-.55.943-.852 1.562-.852zm-60.246.39c.682 0 1.23.334 1.67.995.304.452.505 1.14.567 2.059h-4.51c.043-.932.275-1.687.711-2.236.434-.552.948-.818 1.562-.818zm8.805 0c.615 0 1.14.342 1.563.995.423.652.604 1.659.604 3.053 0 1.357-.2 2.37-.64 3.053-.439.684-.96 1.029-1.526 1.029-.416 0-.794-.14-1.136-.426-.344-.286-.595-.696-.782-1.242-.186-.546-.283-1.387-.283-2.485 0-1.294.231-2.263.674-2.947.443-.684.96-1.03 1.526-1.03zM18.594 68.048l-5.29 2.271 4.899 2.095 5.681-2.095-5.29-2.271zm-7.952 2.839l-.178 10.226 7.74 3.408V73.905l-7.562-3.018zm15.904 0l-6.994 2.663v10.012l6.994-2.84v-9.835zm8.343-31.809l-5.326 2.271 4.935 2.095 5.681-2.095-5.29-2.271zm-7.385 3.018V52.32l6.604 1.917.213-9.302-6.817-2.839zm14.769.567l-6.249 2.663v10.047l6.249-2.84v-9.87zM9.877 53.468l-5.29 2.272 4.899 2.095 5.68-2.095-5.289-2.272zm-7.951 2.841l-.178 10.224 7.739 3.408V59.326l-7.561-3.017zm15.904 0l-6.994 2.662v10.012l6.994-2.84v-9.834zm9.088-3.218l-5.29 2.271 4.899 2.094 5.68-2.094-5.289-2.271zm-7.952 2.839l-.177 10.225 7.739 3.408V58.948l-7.562-3.018zm15.905 0l-6.994 2.663v10.012l6.994-2.841V55.93zm16.662-16.852l-5.289 2.271 4.899 2.095 5.681-2.095-5.291-2.271zm-7.952 2.84l-.178 10.225 7.74 3.407V44.936l-7.562-3.018zm15.904 0l-6.994 2.663v10.011l6.994-2.84v-9.834z\"/></svg>"

/***/ }),

/***/ "../src/components/amazonwebservices/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AmazonwebservicesPlainWordmark = __webpack_require__("../src/components/amazonwebservices/plain-wordmark/AmazonwebservicesPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AmazonwebservicesPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/android/original-wordmark/AndroidOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AndroidOriginalWordmark = __webpack_require__("../src/components/android/original-wordmark/AndroidOriginalWordmark.svg");
	
	var _AndroidOriginalWordmark2 = _interopRequireDefault(_AndroidOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AndroidOriginalWordmark */
	function AndroidOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AndroidOriginalWordmark',
	    svg: _AndroidOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AndroidOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AndroidOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/android/original-wordmark/AndroidOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#fff\" d=\"M13.699 108.645h8.047v17.421h-3.492V112.04l-3.116.012h-.749c-1.74 0-2.707.073-2.9.218-1.039.282-1.917.882-2.634 1.8-.772 1.104-1.159 2.203-1.159 3.298 0 1.353.523 2.598 1.57 3.733.701.668 1.305 1.071 1.813 1.208.507.258 1.381.387 2.621.387h2.429v3.371h-2.911c-2.159 0-3.983-.568-5.474-1.704-1.079-.854-1.8-1.627-2.162-2.319-.902-1.434-1.354-2.9-1.354-4.398v-.507c0-2.094.785-4.015 2.356-5.763.95-.926 1.728-1.51 2.331-1.752.436-.242 1.035-.471 1.801-.688.684-.195 1.679-.291 2.983-.291zm25.625 3.479c.346.467.596.866.749 1.196.226.395.438.926.641 1.595.241.806.362 1.901.362 3.286v7.865h-3.492v-8.24c0-2.771-1.252-4.623-3.757-5.557-.572-.161-1.075-.246-1.511-.254-.435.008-.934.093-1.498.254-2.505.934-3.757 2.787-3.757 5.557v8.24h-3.504v-7.865c0-1.385.121-2.48.362-3.286.201-.668.415-1.2.641-1.595.153-.338.406-.737.761-1.196 1.877-2.304 4.209-3.456 6.995-3.456 2.788 0 5.123 1.152 7.008 3.456zm9.798-3.467c2.345 0 3.689.052 4.036.157.95.113 2.021.512 3.213 1.196.652.403 1.346 1.019 2.078 1.848 1.305 1.619 1.957 3.459 1.957 5.521a8.461 8.461 0 0 1-.7 3.419c-.918 2.086-2.429 3.592-4.53 4.519-.975.5-2.473.749-4.494.749h-7.406l-.387-.073v-3.31h8.167c.87 0 1.542-.077 2.018-.229 1.265-.427 2.19-1.063 2.778-1.909.717-1.071 1.075-2.114 1.075-3.129 0-1.023-.31-2.03-.93-3.021-.387-.572-.813-1.006-1.28-1.305-.854-.701-2.074-1.051-3.661-1.051h-8.167v-3.383h6.233zm13.097 0h11.188c1.973 0 3.52.592 4.639 1.776.5.467.846.918 1.039 1.353.436.87.652 1.72.652 2.549v.495c0 1.273-.552 2.517-1.654 3.733-.709.676-1.354 1.111-1.934 1.305 1.466 1.563 2.199 3.628 2.199 6.198h-3.516v-.266c0-1.901-.77-3.411-2.308-4.531-.878-.62-2.026-.93-3.443-.93h-6.862v-3.359h11.405c1.248 0 2.094-.616 2.537-1.848.048-.25.08-.459.096-.628 0-.685-.285-1.305-.857-1.86-.491-.387-1.015-.58-1.57-.58 0-.032-.169-.048-.508-.048H62.219v-3.359zm28.041.011h.12c2.675 0 4.958 1.096 6.851 3.286 1.225 1.643 1.836 3.431 1.836 5.364v.121c0 2.674-1.119 4.945-3.358 6.813-1.627 1.208-3.411 1.813-5.352 1.813h-.121c-2.658 0-4.934-1.087-6.826-3.262-.66-.926-1.123-1.776-1.39-2.549a9.19 9.19 0 0 1-.471-2.839v-.121c0-2.626 1.083-4.873 3.25-6.742 1.466-1.047 2.803-1.635 4.011-1.764.37-.079.853-.12 1.45-.12zm-5.232 8.675c0 1.514.592 2.843 1.776 3.987 1.055.902 2.162 1.353 3.322 1.353h.338c.935 0 1.885-.318 2.852-.955.998-.733 1.675-1.667 2.029-2.803.112-.298.193-.81.241-1.534 0-1.482-.575-2.791-1.728-3.927-1.079-.958-2.263-1.438-3.552-1.438-1.506 0-2.843.628-4.011 1.885-.491.645-.802 1.192-.931 1.643-.223.629-.336 1.225-.336 1.789zm15.851-8.675h3.491v17.397h-3.491v-17.397zm11.61-.011c2.344 0 3.688.052 4.035.157.95.113 2.021.512 3.213 1.196.652.403 1.346 1.019 2.078 1.848 1.305 1.619 1.957 3.459 1.957 5.521a8.461 8.461 0 0 1-.7 3.419c-.918 2.086-2.429 3.592-4.53 4.519-.975.5-2.473.749-4.494.749h-7.406l-.387-.073v-3.31h8.167c.87 0 1.542-.077 2.018-.229 1.265-.427 2.19-1.063 2.778-1.909.717-1.071 1.075-2.114 1.075-3.129 0-1.023-.31-2.03-.93-3.021-.387-.572-.813-1.006-1.28-1.305-.854-.701-2.074-1.051-3.661-1.051h-8.167v-3.383h6.234zM29.19 76.835c-4.484.002-8.128-3.646-8.129-8.13l-.001-24.891c-.001-4.479 3.642-8.127 8.121-8.128a8.072 8.072 0 0 1 5.753 2.377 8.078 8.078 0 0 1 2.384 5.749l-.002 24.892a8.037 8.037 0 0 1-2.373 5.744 8.065 8.065 0 0 1-5.753 2.387m-.006-38.964a5.945 5.945 0 0 0-5.943 5.944l.004 24.889a5.943 5.943 0 1 0 11.887.001V43.812a5.947 5.947 0 0 0-5.948-5.941\"/><path fill=\"#fff\" d=\"M92.942 39.104l-2.186-.001-53.54.007-2.186.001-.001-2.186c-.005-8.972 4.883-17.316 12.889-22.246l-3.112-5.682a2.995 2.995 0 0 1 1.214-4.093 2.92 2.92 0 0 1 1.424-.362c1.103 0 2.113.599 2.645 1.565l3.258 5.935a30.63 30.63 0 0 1 10.607-1.866c3.729-.001 7.307.629 10.691 1.871l3.253-5.944a3.003 3.003 0 0 1 2.642-1.564c.496-.001.99.12 1.426.354a3.007 3.007 0 0 1 1.467 1.819 2.977 2.977 0 0 1-.258 2.293l-3.11 5.678c7.993 4.94 12.875 13.279 12.874 22.235l.003 2.186zM77.115 15.52l4.148-7.576a.825.825 0 1 0-1.444-.794l-4.191 7.652a28.588 28.588 0 0 0-11.646-2.442 28.521 28.521 0 0 0-11.619 2.434l-4.194-7.635a.818.818 0 0 0-1.117-.328.816.816 0 0 0-.327 1.117l4.149 7.569c-8.154 4.206-13.663 12.214-13.658 21.409l53.539-.006c.002-9.193-5.497-17.184-13.64-21.4M51.806 27.227a2.245 2.245 0 0 1 .003-4.49 2.251 2.251 0 0 1 2.246 2.247 2.248 2.248 0 0 1-2.249 2.243m24.379-.005a2.24 2.24 0 0 1-2.245-2.244 2.259 2.259 0 0 1 2.245-2.25 2.258 2.258 0 0 1 2.24 2.25 2.241 2.241 0 0 1-2.24 2.244m-22.136 77.983c-4.48-.001-8.126-3.645-8.127-8.128L45.92 86.09l-2.136.002a8.457 8.457 0 0 1-6.031-2.496 8.45 8.45 0 0 1-2.497-6.034l-.008-38.566v-2.188h2.186l53.138-.008 2.187-.001v2.186l.006 38.571c0 4.704-3.826 8.532-8.529 8.531l-2.148.001.002 10.981c0 4.481-3.646 8.129-8.124 8.129a8.048 8.048 0 0 1-5.748-2.378 8.06 8.06 0 0 1-2.386-5.746V86.088h-3.653v10.985c-.002 4.482-3.648 8.133-8.13 8.132\"/><path fill=\"#fff\" d=\"M37.444 77.563a6.332 6.332 0 0 0 6.341 6.346h4.318l.005 13.169a5.948 5.948 0 0 0 5.94 5.945 5.945 5.945 0 0 0 5.941-5.95V83.908l8.024-.002-.001 13.168a5.946 5.946 0 0 0 11.891-.004l-.004-13.166 4.334-.001a6.346 6.346 0 0 0 6.343-6.346l-.007-38.573-53.136.009.011 38.57zm61.372-.738c-4.483.001-8.13-3.642-8.129-8.126l-.006-24.89c.001-4.484 3.642-8.131 8.122-8.131 4.486-.001 8.135 3.646 8.135 8.128l.002 24.889c.001 4.481-3.642 8.131-8.124 8.13m-.007-38.962a5.94 5.94 0 0 0-5.941 5.945l.002 24.889a5.94 5.94 0 0 0 5.945 5.943 5.94 5.94 0 0 0 5.941-5.946l-.006-24.889a5.94 5.94 0 0 0-5.941-5.942\"/><path fill=\"#A4C439\" d=\"M29.184 37.871a5.945 5.945 0 0 0-5.943 5.944l.004 24.889a5.942 5.942 0 0 0 5.945 5.946 5.936 5.936 0 0 0 5.942-5.945V43.812a5.947 5.947 0 0 0-5.948-5.941M77.115 15.52l4.148-7.576a.829.829 0 0 0-.325-1.124.827.827 0 0 0-1.119.33l-4.19 7.655a28.504 28.504 0 0 0-11.646-2.444 28.51 28.51 0 0 0-11.619 2.434L48.17 7.16a.82.82 0 0 0-1.116-.329.816.816 0 0 0-.328 1.117l4.149 7.57c-8.154 4.206-13.663 12.214-13.658 21.409l53.539-.006c.001-9.194-5.498-17.185-13.641-21.401M51.806 27.227a2.245 2.245 0 0 1 .003-4.49 2.251 2.251 0 0 1 2.246 2.247 2.248 2.248 0 0 1-2.249 2.243m24.379-.005a2.243 2.243 0 0 1-2.245-2.244 2.263 2.263 0 0 1 2.245-2.25 2.258 2.258 0 0 1 2.24 2.25 2.24 2.24 0 0 1-2.24 2.244m-38.75 11.771l.008 38.572a6.334 6.334 0 0 0 6.342 6.341l4.318.001.005 13.169a5.948 5.948 0 0 0 5.94 5.945 5.95 5.95 0 0 0 5.945-5.949l-.003-13.164 8.024-.002.003 13.168c0 3.277 2.667 5.948 5.942 5.942a5.946 5.946 0 0 0 5.945-5.946L79.9 83.904l4.334-.003a6.345 6.345 0 0 0 6.345-6.344l-.007-38.572-53.137.008zm67.317 4.813a5.941 5.941 0 0 0-5.943-5.943 5.94 5.94 0 0 0-5.941 5.945l.005 24.89a5.937 5.937 0 0 0 5.942 5.942 5.94 5.94 0 0 0 5.941-5.946l-.004-24.888z\"/></svg>"

/***/ }),

/***/ "../src/components/android/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AndroidOriginalWordmark = __webpack_require__("../src/components/android/original-wordmark/AndroidOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AndroidOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/android/original/AndroidOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AndroidOriginal = __webpack_require__("../src/components/android/original/AndroidOriginal.svg");
	
	var _AndroidOriginal2 = _interopRequireDefault(_AndroidOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AndroidOriginal */
	function AndroidOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AndroidOriginal',
	    svg: _AndroidOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AndroidOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AndroidOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/android/original/AndroidOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#fff\" d=\"M21.012 91.125c-5.538.003-10.038-4.503-10.039-10.04l-.002-30.739c-.002-5.532 4.497-10.037 10.028-10.038 2.689-.002 5.207 1.041 7.105 2.937s2.942 4.418 2.944 7.099l-.003 30.74a9.924 9.924 0 0 1-2.931 7.094 9.962 9.962 0 0 1-7.102 2.947m-.008-48.12c-4.053-.002-7.338 3.291-7.339 7.341l.005 30.736a7.347 7.347 0 0 0 7.341 7.348 7.338 7.338 0 0 0 7.339-7.347V50.342a7.345 7.345 0 0 0-7.346-7.337\"/><path fill=\"#fff\" d=\"M99.742 44.527l-2.698-.001-66.119.009-2.699.001-.002-2.699c-.006-11.08 6.03-21.385 15.917-27.473l-3.844-7.017c-.47-.822-.588-1.863-.314-2.815a3.732 3.732 0 0 1 1.814-2.239 3.605 3.605 0 0 1 1.759-.447c1.362 0 2.609.739 3.267 1.933l4.023 7.329a37.842 37.842 0 0 1 13.099-2.305c4.606-.002 9.023.777 13.204 2.311l4.017-7.341a3.711 3.711 0 0 1 3.263-1.932 3.712 3.712 0 0 1 1.761.438A3.706 3.706 0 0 1 88 4.524a3.69 3.69 0 0 1-.318 2.832l-3.842 7.013c9.871 6.101 15.9 16.398 15.899 27.459l.003 2.699zM80.196 15.403l5.123-9.355a1.019 1.019 0 0 0-1.783-.981l-5.176 9.45c-4.354-1.934-9.229-3.021-14.382-3.016-5.142-.005-10.008 1.078-14.349 3.005l-5.181-9.429a1.009 1.009 0 0 0-1.379-.405c-.497.266-.68.891-.403 1.379l5.125 9.348c-10.07 5.194-16.874 15.084-16.868 26.439l66.118-.008c.003-11.351-6.789-21.221-16.845-26.427M48.94 29.86a2.772 2.772 0 0 1 .003-5.545 2.78 2.78 0 0 1 2.775 2.774 2.775 2.775 0 0 1-2.778 2.771m30.107-.006a2.767 2.767 0 0 1-2.772-2.771 2.788 2.788 0 0 1 2.773-2.778 2.79 2.79 0 0 1 2.767 2.779 2.769 2.769 0 0 1-2.768 2.77m-27.336 96.305c-5.533-.001-10.036-4.501-10.037-10.038l-.002-13.567-2.638.003a10.453 10.453 0 0 1-7.448-3.082 10.437 10.437 0 0 1-3.083-7.452l-.01-47.627v-2.701h2.699l65.623-.01 2.7-.002v2.699l.007 47.633c.001 5.809-4.725 10.536-10.532 10.535l-2.654.002.003 13.562c0 5.534-4.502 10.039-10.033 10.039a9.933 9.933 0 0 1-7.098-2.937 9.952 9.952 0 0 1-2.947-7.096v-13.568H61.75v13.565c-.002 5.535-4.503 10.043-10.039 10.042\"/><path fill=\"#fff\" d=\"M31.205 92.022a7.82 7.82 0 0 0 7.831 7.837h5.333l.006 16.264c-.001 4.05 3.289 7.341 7.335 7.342a7.342 7.342 0 0 0 7.338-7.348l.001-16.259 9.909-.003-.001 16.263c.004 4.051 3.298 7.346 7.343 7.338 4.056.003 7.344-3.292 7.343-7.344l-.005-16.259 5.353-.001c4.319.001 7.832-3.508 7.832-7.837l-.009-47.635-65.621.012.012 47.63zm75.791-.91c-5.536.001-10.039-4.498-10.038-10.036l-.008-30.738c.002-5.537 4.498-10.041 10.031-10.041 5.54-.001 10.046 4.502 10.045 10.038l.003 30.736c.001 5.534-4.498 10.042-10.033 10.041m-.01-48.116c-4.053-.004-7.337 3.287-7.337 7.342l.003 30.737a7.336 7.336 0 0 0 7.342 7.34 7.338 7.338 0 0 0 7.338-7.343l-.008-30.736a7.335 7.335 0 0 0-7.338-7.34\"/><path fill=\"#A4C439\" d=\"M21.004 43.005c-4.053-.002-7.338 3.291-7.339 7.341l.005 30.736a7.338 7.338 0 0 0 7.342 7.343 7.33 7.33 0 0 0 7.338-7.342V50.342a7.345 7.345 0 0 0-7.346-7.337m59.192-27.602l5.123-9.355a1.023 1.023 0 0 0-.401-1.388 1.022 1.022 0 0 0-1.382.407l-5.175 9.453c-4.354-1.938-9.227-3.024-14.383-3.019-5.142-.005-10.013 1.078-14.349 3.005l-5.181-9.429a1.01 1.01 0 0 0-1.378-.406 1.007 1.007 0 0 0-.404 1.38l5.125 9.349c-10.07 5.193-16.874 15.083-16.868 26.438l66.118-.008c.003-11.351-6.789-21.221-16.845-26.427M48.94 29.86a2.772 2.772 0 0 1 .003-5.545 2.78 2.78 0 0 1 2.775 2.774 2.775 2.775 0 0 1-2.778 2.771m30.107-.006a2.77 2.77 0 0 1-2.772-2.771 2.793 2.793 0 0 1 2.773-2.778 2.79 2.79 0 0 1 2.767 2.779 2.767 2.767 0 0 1-2.768 2.77M31.193 44.392l.011 47.635a7.822 7.822 0 0 0 7.832 7.831l5.333.002.006 16.264c-.001 4.05 3.291 7.342 7.335 7.342 4.056 0 7.342-3.295 7.343-7.347l-.004-16.26 9.909-.003.004 16.263c0 4.047 3.293 7.346 7.338 7.338 4.056.003 7.344-3.292 7.343-7.344l-.005-16.259 5.352-.004a7.835 7.835 0 0 0 7.836-7.834l-.009-47.635-65.624.011zm83.134 5.943a7.338 7.338 0 0 0-7.341-7.339c-4.053-.004-7.337 3.287-7.337 7.342l.006 30.738a7.334 7.334 0 0 0 7.339 7.339 7.337 7.337 0 0 0 7.338-7.343l-.005-30.737z\"/></svg>"

/***/ }),

/***/ "../src/components/android/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AndroidOriginal = __webpack_require__("../src/components/android/original/AndroidOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AndroidOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/android/plain-wordmark/AndroidPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AndroidPlainWordmark = __webpack_require__("../src/components/android/plain-wordmark/AndroidPlainWordmark.svg");
	
	var _AndroidPlainWordmark2 = _interopRequireDefault(_AndroidPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AndroidPlainWordmark */
	function AndroidPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AndroidPlainWordmark',
	    svg: _AndroidPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AndroidPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AndroidPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/android/plain-wordmark/AndroidPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#A4C439\" d=\"M13.699 107.138h8.047v17.421h-3.492v-14.026l-3.116.012h-.749c-1.74 0-2.707.073-2.9.218-1.039.282-1.917.882-2.634 1.8-.772 1.104-1.159 2.203-1.159 3.299 0 1.353.523 2.598 1.57 3.733.701.668 1.305 1.071 1.813 1.208.507.258 1.381.387 2.621.387h2.429v3.37h-2.911c-2.159 0-3.983-.567-5.474-1.703-1.079-.854-1.8-1.627-2.162-2.319-.902-1.434-1.354-2.9-1.354-4.398v-.507c0-2.095.785-4.016 2.356-5.763.95-.927 1.728-1.511 2.331-1.752.436-.242 1.035-.472 1.801-.688.684-.196 1.679-.292 2.983-.292zm25.625 3.479c.346.467.596.865.749 1.195.226.396.438.927.641 1.595.241.806.362 1.901.362 3.286v7.865h-3.492v-8.239c0-2.771-1.252-4.623-3.757-5.558-.572-.161-1.075-.245-1.511-.254-.435.009-.934.093-1.498.254-2.505.935-3.757 2.787-3.757 5.558v8.239h-3.504v-7.865c0-1.385.121-2.48.362-3.286.201-.668.415-1.199.641-1.595.153-.338.406-.736.761-1.195 1.877-2.304 4.209-3.456 6.995-3.456 2.788 0 5.123 1.152 7.008 3.456zm9.798-3.468c2.345 0 3.689.053 4.036.157.95.113 2.021.512 3.213 1.196.652.402 1.346 1.019 2.078 1.848 1.305 1.619 1.957 3.46 1.957 5.521a8.461 8.461 0 0 1-.7 3.419c-.918 2.086-2.429 3.593-4.53 4.519-.975.5-2.473.749-4.494.749h-7.406l-.387-.072v-3.311h8.167c.87 0 1.542-.076 2.018-.229 1.265-.427 2.19-1.063 2.778-1.909.717-1.07 1.075-2.114 1.075-3.129 0-1.022-.31-2.029-.93-3.021-.387-.571-.813-1.006-1.28-1.305-.854-.7-2.074-1.051-3.661-1.051h-8.167v-3.383h6.233zm13.097 0h11.188c1.973 0 3.52.592 4.639 1.776.5.467.846.918 1.039 1.353.436.87.652 1.72.652 2.55v.495c0 1.272-.552 2.517-1.654 3.733-.709.676-1.354 1.111-1.934 1.305 1.466 1.563 2.199 3.628 2.199 6.197h-3.516v-.266c0-1.9-.77-3.411-2.308-4.53-.878-.62-2.026-.931-3.443-.931h-6.862v-3.358h11.405c1.248 0 2.094-.616 2.537-1.849a6.82 6.82 0 0 0 .096-.628c0-.685-.285-1.305-.857-1.86-.491-.387-1.015-.58-1.57-.58 0-.032-.169-.049-.508-.049H62.219v-3.358zm28.041.012h.12c2.675 0 4.958 1.096 6.851 3.286 1.225 1.644 1.836 3.432 1.836 5.364v.121c0 2.674-1.119 4.945-3.358 6.813-1.627 1.209-3.411 1.813-5.352 1.813h-.121c-2.658 0-4.934-1.087-6.826-3.262-.66-.926-1.123-1.776-1.39-2.549a9.192 9.192 0 0 1-.471-2.84v-.12c0-2.626 1.083-4.873 3.25-6.742 1.466-1.047 2.803-1.635 4.011-1.764.37-.079.853-.12 1.45-.12zm-5.232 8.675c0 1.515.592 2.844 1.776 3.987 1.055.901 2.162 1.353 3.322 1.353h.338c.935 0 1.885-.318 2.852-.954.998-.733 1.675-1.667 2.029-2.803.112-.298.193-.81.241-1.534 0-1.482-.575-2.791-1.728-3.927-1.079-.959-2.263-1.438-3.552-1.438-1.506 0-2.843.628-4.011 1.885-.491.645-.802 1.191-.931 1.643-.223.628-.336 1.224-.336 1.788zm15.851-8.675h3.491v17.397h-3.491v-17.397zm11.61-.012c2.344 0 3.688.053 4.035.157.95.113 2.021.512 3.213 1.196.652.402 1.346 1.019 2.078 1.848 1.305 1.619 1.957 3.46 1.957 5.521a8.461 8.461 0 0 1-.7 3.419c-.918 2.086-2.429 3.593-4.53 4.519-.975.5-2.473.749-4.494.749h-7.406l-.387-.072v-3.311h8.167c.87 0 1.542-.076 2.018-.229 1.265-.427 2.19-1.063 2.778-1.909.717-1.07 1.075-2.114 1.075-3.129 0-1.022-.31-2.029-.93-3.021-.387-.571-.813-1.006-1.28-1.305-.854-.7-2.074-1.051-3.661-1.051h-8.167v-3.383h6.234zM29.184 36.363a5.944 5.944 0 0 0-5.942 5.943l.004 24.889c.001 3.291 2.662 5.947 5.945 5.947s5.944-2.656 5.941-5.945V42.305a5.947 5.947 0 0 0-5.948-5.942m47.931-22.351l4.148-7.574a.83.83 0 0 0-.325-1.125.829.829 0 0 0-1.119.33l-4.19 7.654a28.536 28.536 0 0 0-11.646-2.443 28.51 28.51 0 0 0-11.619 2.434L48.17 5.653a.82.82 0 0 0-1.116-.33.816.816 0 0 0-.327 1.117l4.149 7.57c-8.154 4.205-13.663 12.215-13.658 21.408l53.539-.006c0-9.193-5.499-17.183-13.642-21.4M51.806 25.719a2.244 2.244 0 0 1 .003-4.49 2.253 2.253 0 0 1 2.246 2.248 2.246 2.246 0 0 1-2.249 2.242m24.379-.004a2.243 2.243 0 0 1-2.245-2.244 2.263 2.263 0 0 1 2.245-2.25 2.26 2.26 0 0 1 2.24 2.252 2.24 2.24 0 0 1-2.24 2.242m-38.75 11.771l.009 38.572a6.333 6.333 0 0 0 6.342 6.34l4.318.002.006 13.17a5.947 5.947 0 0 0 5.939 5.945 5.95 5.95 0 0 0 5.945-5.949L59.99 82.4l8.024-.002.003 13.168c0 3.277 2.667 5.947 5.942 5.941a5.945 5.945 0 0 0 5.945-5.945L79.9 82.396l4.334-.004a6.344 6.344 0 0 0 6.345-6.344l-.007-38.572-53.137.01zm67.317 4.813a5.94 5.94 0 0 0-5.943-5.943 5.941 5.941 0 0 0-5.941 5.945l.005 24.891a5.937 5.937 0 0 0 5.942 5.941 5.939 5.939 0 0 0 5.941-5.945l-.004-24.889z\"/></svg>"

/***/ }),

/***/ "../src/components/android/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AndroidPlainWordmark = __webpack_require__("../src/components/android/plain-wordmark/AndroidPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AndroidPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/android/plain/AndroidPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AndroidPlain = __webpack_require__("../src/components/android/plain/AndroidPlain.svg");
	
	var _AndroidPlain2 = _interopRequireDefault(_AndroidPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AndroidPlain */
	function AndroidPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AndroidPlain',
	    svg: _AndroidPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AndroidPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AndroidPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/android/plain/AndroidPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#A4C439\" d=\"M21.005 43.003c-4.053-.002-7.338 3.291-7.339 7.341l.005 30.736a7.338 7.338 0 0 0 7.342 7.343 7.33 7.33 0 0 0 7.338-7.342V50.34a7.345 7.345 0 0 0-7.346-7.337m59.193-27.602l5.123-9.355a1.023 1.023 0 0 0-.401-1.388 1.022 1.022 0 0 0-1.382.407l-5.175 9.453c-4.354-1.938-9.227-3.024-14.383-3.019-5.142-.005-10.013 1.078-14.349 3.005L44.45 5.075a1.01 1.01 0 0 0-1.378-.406 1.007 1.007 0 0 0-.404 1.38l5.125 9.349c-10.07 5.193-16.874 15.083-16.868 26.438l66.118-.008c.002-11.351-6.79-21.221-16.845-26.427M48.942 29.858a2.772 2.772 0 0 1 .003-5.545 2.78 2.78 0 0 1 2.775 2.774 2.776 2.776 0 0 1-2.778 2.771m30.106-.005a2.77 2.77 0 0 1-2.772-2.771 2.793 2.793 0 0 1 2.773-2.778 2.79 2.79 0 0 1 2.767 2.779 2.767 2.767 0 0 1-2.768 2.77M31.195 44.39l.011 47.635a7.822 7.822 0 0 0 7.832 7.831l5.333.002.006 16.264c-.001 4.05 3.291 7.342 7.335 7.342 4.056 0 7.342-3.295 7.343-7.347l-.004-16.26 9.909-.003.004 16.263c0 4.047 3.293 7.346 7.338 7.338 4.056.003 7.344-3.292 7.343-7.344l-.005-16.259 5.352-.004a7.835 7.835 0 0 0 7.836-7.834l-.009-47.635-65.624.011zm83.134 5.943a7.338 7.338 0 0 0-7.341-7.339c-4.053-.004-7.337 3.287-7.337 7.342l.006 30.738a7.334 7.334 0 0 0 7.339 7.339 7.337 7.337 0 0 0 7.338-7.343l-.005-30.737z\"/></svg>"

/***/ }),

/***/ "../src/components/android/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AndroidPlain = __webpack_require__("../src/components/android/plain/AndroidPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AndroidPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/angularjs/original-wordmark/AngularjsOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AngularjsOriginalWordmark = __webpack_require__("../src/components/angularjs/original-wordmark/AngularjsOriginalWordmark.svg");
	
	var _AngularjsOriginalWordmark2 = _interopRequireDefault(_AngularjsOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AngularjsOriginalWordmark */
	function AngularjsOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AngularjsOriginalWordmark',
	    svg: _AngularjsOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AngularjsOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AngularjsOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/angularjs/original-wordmark/AngularjsOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#ccc\" d=\"M33.427 71.28V58.318h1.677l7.932 10.442V58.318h1.585V71.28h-1.677l-7.93-10.533V71.28zm24.064-.508c-1.045.399-2.172.599-3.381.599-4.694 0-7.042-2.251-7.042-6.753 0-4.26 2.266-6.391 6.797-6.391 1.301 0 2.509.182 3.626.545v1.45a9.653 9.653 0 0 0-3.444-.635c-3.534 0-5.301 1.678-5.301 5.03 0 3.595 1.738 5.394 5.22 5.394.556 0 1.172-.073 1.85-.219v-4.404h1.676v5.384h-.001zm2.675-4.495v-7.958h1.676v7.958c0 2.489 1.239 3.735 3.717 3.735 2.477 0 3.716-1.246 3.716-3.735v-7.958h1.677v7.958c0 3.396-1.798 5.095-5.393 5.095s-5.393-1.698-5.393-5.095zm15.453-7.959v11.603H82.4v1.359h-8.457V58.318zm9.2 12.962h-1.74l6.444-14.671 6.445 14.671H94.11l-1.677-4.079h-4.287l.462-1.358h3.264l-2.421-5.874zm12.916 0V58.318h5.529c2.466 0 3.698 1.037 3.698 3.109 0 1.687-1.205 2.935-3.616 3.743l4.45 6.109h-2.212l-4.123-5.828v-1.096c2.477-.394 3.715-1.346 3.715-2.855 0-1.196-.688-1.795-2.065-1.795h-3.699V71.28h-1.677zm16.343-12.962v9.228c0 2.489-1.465 3.734-4.396 3.734v-1.359c1.813 0 2.72-.793 2.72-2.375v-9.228h1.676zm2.991 12.509v-1.541c1.36.483 2.828.726 4.405.726 2.23 0 3.346-.815 3.346-2.449 0-1.387-.823-2.084-2.467-2.084h-1.668c-2.713 0-4.07-1.177-4.07-3.534 0-2.478 1.738-3.717 5.214-3.717 1.51 0 2.915.183 4.214.545v1.541c-1.3-.484-2.704-.727-4.214-.727-2.357 0-3.535.786-3.535 2.357 0 1.39.797 2.084 2.392 2.084h1.668c2.761 0 4.143 1.18 4.143 3.534 0 2.539-1.674 3.809-5.021 3.809-1.579 0-3.046-.182-4.407-.544z\"/><path d=\"M33.852 70.856v-12.96h1.676l7.931 10.441V57.896h1.587v12.96h-1.677l-7.931-10.533v10.533zm24.064-.507c-1.045.399-2.172.599-3.381.599-4.694 0-7.043-2.25-7.043-6.752 0-4.261 2.267-6.392 6.799-6.392 1.299 0 2.508.183 3.625.545v1.45a9.653 9.653 0 0 0-3.444-.635c-3.534 0-5.302 1.678-5.302 5.03 0 3.596 1.74 5.394 5.221 5.394.556 0 1.173-.072 1.85-.218v-4.405h1.676v5.384h-.001zm2.674-4.495v-7.959h1.676v7.958c0 2.489 1.239 3.735 3.717 3.735s3.717-1.246 3.717-3.735v-7.958h1.676v7.958c0 3.397-1.797 5.095-5.393 5.095s-5.393-1.698-5.393-5.094zm15.453-7.959v11.602h6.78v1.359h-8.456V57.895zm9.201 12.961h-1.741l6.445-14.671 6.445 14.671h-1.86l-1.677-4.079H88.57l.463-1.359h3.262l-2.42-5.874zm12.915 0v-12.96h5.529c2.466 0 3.697 1.036 3.697 3.108 0 1.686-1.204 2.935-3.615 3.743l4.45 6.109h-2.212l-4.123-5.827v-1.098c2.477-.394 3.716-1.345 3.716-2.855 0-1.196-.689-1.794-2.067-1.794h-3.698v11.574h-1.677z\"/><path fill=\"#A6120D\" d=\"M114.502 57.895v9.228c0 2.49-1.465 3.734-4.396 3.734v-1.359c1.813 0 2.72-.793 2.72-2.375v-9.228h1.676zm2.991 12.508v-1.541c1.36.482 2.827.726 4.405.726 2.229 0 3.345-.816 3.345-2.448 0-1.389-.822-2.084-2.466-2.084h-1.668c-2.713 0-4.07-1.179-4.07-3.535 0-2.478 1.737-3.717 5.213-3.717 1.511 0 2.915.183 4.215.544v1.542c-1.3-.484-2.704-.727-4.215-.727-2.356 0-3.535.786-3.535 2.357 0 1.389.797 2.084 2.393 2.084h1.668c2.761 0 4.143 1.179 4.143 3.535 0 2.538-1.674 3.808-5.022 3.808-1.578 0-3.046-.182-4.406-.544z\"/><path fill=\"#B3B3B3\" d=\"M16.218 47.913L1.08 53.24l2.392 19.833 12.762 7.014 12.828-7.108 2.391-19.833z\"/><path fill=\"#A6120D\" d=\"M29.942 54.292L16.183 49.6v28.811l11.531-6.382z\"/><path fill=\"#DD1B16\" d=\"M2.778 54.377l2.051 17.737 11.354 6.297V49.6z\"/><path fill=\"#F2F2F2\" d=\"M19.971 64.938l-3.788 1.771H12.19l-1.877 4.694-3.49.064 9.359-20.821 3.789 14.292zm-.367-.892l-3.396-6.724-2.786 6.608h2.761l3.421.116z\"/><path fill=\"#B3B3B3\" d=\"M16.183 50.646l.024 6.676 3.162 6.614h-3.18l-.006 2.769 4.395.004 2.055 4.759 3.34.062z\"/></svg>"

/***/ }),

/***/ "../src/components/angularjs/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AngularjsOriginalWordmark = __webpack_require__("../src/components/angularjs/original-wordmark/AngularjsOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AngularjsOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/angularjs/original/AngularjsOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AngularjsOriginal = __webpack_require__("../src/components/angularjs/original/AngularjsOriginal.svg");
	
	var _AngularjsOriginal2 = _interopRequireDefault(_AngularjsOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AngularjsOriginal */
	function AngularjsOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AngularjsOriginal',
	    svg: _AngularjsOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AngularjsOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AngularjsOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/angularjs/original/AngularjsOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#B3B3B3\" d=\"M63.81 1.026L4.553 21.88l9.363 77.637 49.957 27.457 50.214-27.828 9.36-77.635z\"/><path fill=\"#A6120D\" d=\"M117.536 25.998L63.672 7.629v112.785l45.141-24.983z\"/><path fill=\"#DD1B16\" d=\"M11.201 26.329l8.026 69.434 44.444 24.651V7.627z\"/><path fill=\"#F2F2F2\" d=\"M78.499 67.67l-14.827 6.934H48.044l-7.347 18.374-13.663.254 36.638-81.508L78.499 67.67zm-1.434-3.491L63.77 37.858 52.864 63.726h10.807l13.394.453z\"/><path fill=\"#B3B3B3\" d=\"M63.671 11.724l.098 26.134 12.375 25.888H63.698l-.027 10.841 17.209.017 8.042 18.63 13.074.242z\"/></svg>"

/***/ }),

/***/ "../src/components/angularjs/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AngularjsOriginal = __webpack_require__("../src/components/angularjs/original/AngularjsOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AngularjsOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/angularjs/plain-wordmark/AngularjsPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AngularjsPlainWordmark = __webpack_require__("../src/components/angularjs/plain-wordmark/AngularjsPlainWordmark.svg");
	
	var _AngularjsPlainWordmark2 = _interopRequireDefault(_AngularjsPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AngularjsPlainWordmark */
	function AngularjsPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AngularjsPlainWordmark',
	    svg: _AngularjsPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AngularjsPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AngularjsPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/angularjs/plain-wordmark/AngularjsPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#C4473A\" d=\"M33.852 70.856v-12.96h1.676l7.931 10.441V57.896h1.587v12.96h-1.677l-7.931-10.533v10.533zm24.064-.507c-1.045.399-2.172.599-3.381.599-4.694 0-7.043-2.25-7.043-6.752 0-4.261 2.267-6.392 6.799-6.392 1.299 0 2.508.183 3.625.545v1.45a9.653 9.653 0 0 0-3.444-.635c-3.534 0-5.302 1.678-5.302 5.03 0 3.596 1.74 5.394 5.221 5.394.556 0 1.173-.072 1.85-.218v-4.405h1.676v5.384h-.001zm2.674-4.495v-7.959h1.676v7.958c0 2.489 1.239 3.735 3.717 3.735s3.717-1.246 3.717-3.735v-7.958h1.676v7.958c0 3.397-1.797 5.095-5.393 5.095s-5.393-1.698-5.393-5.094zm15.453-7.959v11.602h6.78v1.359h-8.456V57.895zm9.201 12.961h-1.741l6.445-14.671 6.445 14.671h-1.86l-1.677-4.079H88.57l.463-1.359h3.262l-2.42-5.874zm12.915 0v-12.96h5.529c2.466 0 3.697 1.036 3.697 3.108 0 1.686-1.204 2.935-3.615 3.743l4.45 6.109h-2.212l-4.123-5.827v-1.098c2.477-.394 3.716-1.345 3.716-2.855 0-1.196-.689-1.794-2.067-1.794h-3.698v11.574h-1.677zm16.343-12.961v9.228c0 2.49-1.465 3.734-4.396 3.734v-1.359c1.813 0 2.72-.793 2.72-2.375v-9.228h1.676zm2.991 12.508v-1.541c1.36.482 2.827.726 4.405.726 2.229 0 3.345-.816 3.345-2.448 0-1.389-.822-2.084-2.466-2.084h-1.668c-2.713 0-4.07-1.179-4.07-3.535 0-2.478 1.737-3.717 5.213-3.717 1.511 0 2.915.183 4.215.544v1.542c-1.3-.484-2.704-.727-4.215-.727-2.356 0-3.535.786-3.535 2.357 0 1.389.797 2.084 2.393 2.084h1.668c2.761 0 4.143 1.179 4.143 3.535 0 2.538-1.674 3.808-5.022 3.808-1.578 0-3.046-.182-4.406-.544zM16.183 64h3.186l-3.161-6.61L13.422 64zm.035-16.087L1.08 53.24l2.392 19.833 12.763 7.014 12.827-7.108 2.392-19.832-15.236-5.234zM12.19 67l-1.877 4.549-3.49-.081 9.359-20.821 9.79 20.902-3.34-.044-2.055-4.722-4.387.069\"/></svg>"

/***/ }),

/***/ "../src/components/angularjs/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AngularjsPlainWordmark = __webpack_require__("../src/components/angularjs/plain-wordmark/AngularjsPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AngularjsPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/angularjs/plain/AngularjsPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AngularjsPlain = __webpack_require__("../src/components/angularjs/plain/AngularjsPlain.svg");
	
	var _AngularjsPlain2 = _interopRequireDefault(_AngularjsPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AngularjsPlain */
	function AngularjsPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AngularjsPlain',
	    svg: _AngularjsPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AngularjsPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AngularjsPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/angularjs/plain/AngularjsPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#C4473A\" d=\"M52.864 64h23.28L63.769 38.123zM63.81 1.026L4.553 21.88l9.363 77.637 49.957 27.457 50.214-27.828 9.36-77.635L63.81 1.026zM48.044 75l-7.265 18.176-13.581.056 36.608-81.079-.07-.153h-.064l.001-.133.063.133h.141l.123-.274V12h-.124l-.069.153 38.189 81.417-13.074-.287-8.042-18.58-17.173.082\"/></svg>"

/***/ }),

/***/ "../src/components/angularjs/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AngularjsPlain = __webpack_require__("../src/components/angularjs/plain/AngularjsPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AngularjsPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apache/line-wordmark/ApacheLineWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ApacheLineWordmark = __webpack_require__("../src/components/apache/line-wordmark/ApacheLineWordmark.svg");
	
	var _ApacheLineWordmark2 = _interopRequireDefault(_ApacheLineWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ApacheLineWordmark */
	function ApacheLineWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ApacheLineWordmark',
	    svg: _ApacheLineWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ApacheLineWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ApacheLineWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apache/line-wordmark/ApacheLineWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M24 41.3v-.1zM125.8 59l-.2-.1v-.4l-.1-.4-.2-.3-.4-.2-.1-.1-.3-.3-.3-.2-.4-.1h-.1l-.4-.3-.5-.3-.6-.3-.6-.2h-.1l-.5-.5-.6-.4-.6-.3-.6-.2h-.1l-.6-.4-.8-.3-.4-.1-.5-.3-.5-.2h-.1l-.5-.1-.5-.1h-.5l-.7.1-.3-.5-.7-.5-.9-.2h-.9l-1 .2-.3.1-.7-.3-.8-.2-.8-.1h-.8l-.8.1h-.1l-.9-.3-.9-.3-.9-.1h-.6l-.8-.8-.9-.6-.8-.4-.8-.2h-.8l-.5.1-.5-.4-.7-.3-.8-.1-.5.1-.7-.3-.8-.1-.7-.1H93l-1-.4-1.2-.4h-1.3l-1.1-.6-1.2-.3h-.8l-1.8-.4-1.1-.1H83l-.6-.6-.8-.5-.9-.2-.9.1-.6.2-.8-.1H77v-.1l-1.7-.3-1.5-.2-1.3-.1H72l-1-.1-1-.1h-.1l-1-.6-1.1-.3-1-.1H66l-1-.5-.9-.2-.9-.1H63l-1.1-.7-.9-.3-.7-.1-.8-.4-1.1-.3h-1l-1.1-.5-1-.2h-.5l-1.1-.6-1-.3-1-.1h-.2l-1.5-.7-1-.4-1.1-.1h-.1l-.7-.5-.6-.3-.6-.2-.7-.1-.6.1-.7-.5-.7-.3-.9-.1h-.8l-.9.2-.1.1-1-.4-1-.3h-.9l-.8-.5-.9-.3-.8-.1-.7.1-.7.2-.6-.6-.6-.4-.8-.1-.7.2-.6.3-.4-.3-.3-.2-.3-.1-.4-.1h-.5l-.3.1-.5.3-.1.1-.9-.2h-.8l-.7.2-.5.6-.4.5-.3.8-.3.7-.2.8-.1.8-.1 1.6.3 1.3.3.7-.1-2 .1-1.5.1-.8.2-.7.2-.7.3-.6.4-.5.5-.4.6-.2h.7l.5.1-.3.4-.3.4-.5 1-.6 1.7-.7 2.3-.4 1.8-.6-.2v.1c-1-.2-1.1-.3-1.6-.5l-.1-.6v-.6l.1-2.5v-.6l-.1-1.2-.1-.5-.2-.5-.2-.5-.2-.5-.2-.4-.3-.4-.9-.6v-.1l.1-.7.1-.3.2-.6-.5-.3-.5.6-.3.7-.3.7-.1.7-.1.7v.7l.1.7.1.2-.1-.2-.3-.4-.4-.9-.2-.5-.1-.6-.1-1.2-.9.8-.3.6-.2.7v.6l.1.6.2.6.3.6h-.1l-.6-.1-.1.4.4.2 1.4 1 .3.3 2.2 2.5.1.1C15.1 38 9.1 35.3 1.8 31.9c1.5 2.5 7 5.1 9.3 6.8 2.3 1.2 5.5 2.6 8.3 3.7l-2.3.5-1.4.3-1.4.5-.7.3-.6.2-.6.4-.5.4-.5.5-.4.5-.3.6-.2.7.4.2.2-.2.7-.7.9-.6.9-.5.4-.1.3-.1 1.4-.3.6-.2 2.5-1.5.5-.3.4-.2.3-.1-.1-.2c.2.1.4.1.5.2l-.1.1-2.4 1.2-1.3.8-1.2.9-.6.5-.5.6-.3.6-.2.6-.1.7.1.7.4 1.1.6-1.2.4-.6.4-.5.4-.4.4-.3 1-.6v.1l-.1.8v.9l.1 1 .3 1.1h.4l.1-.5.4-1.5.2-.5.6-1.4 1-1.8 1.2-1.9c.3.1.7.2 1 .4l-.9 1.7-.3.6-.4.6-.2.7-.2.7-.1.7v.7l.1.6.3.6.5.6.8.5.7.2.2.5.4.5.4.4.4.3.4.2.4.2.9.1h.2l.4.6.6.5.7.3h.8l.7-.2.1.2.6.6.6.4.6.3.8.1h.6l.6.4.7.3.8.2.6.5.8.4 1 .2 1.1.1.1.1.7.6.8.4.7.3.9.1.8-.2.4.2.6.3.6.1h.6l.6-.1.3.2 1 .3 1.1.1 1.3-.1.3.2.9.3 1 .1 1.4-.1.9.3 1 .1 1.1-.1.4.3 1 .4 1.1.1 1.1-.1v-.1l.6.1h1l1.1-.2.6.2.8.2.8.1h1l.2.1 1 .3 1 .2 1.1.1 1.1-.1v-.1l.6.2.9.1.9.1v-.1l.6.2 1.2.1 1.3-.1 1.4.1.2.1.9.2.8.1h.9l.1.1.8.3.8.1h.1l-.7-.3-.8-.4-.8-.5-.8-.7-.8-.7-.1-.1-2.8-3.7-1.8-1.9-.9-.9-.4-.3h.4l2.1.4 1.4 1.2 2 2 1.7 1.8.7.7.8.7.8.6.8.6.4.2.4.2.6.3.1.1-.3.2-.8.5.8-.1.7-.4.9.3 1.1.2h1.2l.3.1 1.1.2 1.1-.1 1.1-.4 1 .1h1.2l.9-.1.6.1h.7l1.5-.2.5.2.6.1.6-.1.5-.3h.1l.8.3.8.1h.8l.9-.2.8-.4.9-.6h.7l.9-.1.8-.1.5.2.8.1.8.1.8-.1.8-.2.4.3.9.1.8-.1h.1l-.8-.1-.9-.3-.9-.5-.9-.5-.9-.6-4.7-3.6 2.7.2.7.4.4.2 3.4 2.4.5.3 1.2.8.9.6.4.3.2.1-.2.2-.5.1.7.1.5-.3.3.2.5.2.5.1h.5l.5-.1.4-.1.7.1.8-.1.7-.3h.7l.6-.1.6-.3.5-.4h.6l.6-.1.5-.3.6-.4h-.1l-.3-.1-.1-.1-.4-.1-1-.3-.3-.1-.7-.4-.3-.2-.1-.1-.2-.1-.6-.6-.1-.1 1.2.1.3.3.4.3.6.4.5-.1.2.2.9.5.4.2.1.1-.1.1.4.1h.3l.1-.1.3-.1.3-.2.2-.4.1-.4h.2l.4-.3.1-.3h.1v-1l-.2-.4zM17.2 43.8l-1.2.7-.5.2-.7.1-1.4.4-1 .5-.9.6-.1.1.4-.7.4-.5.5-.4.5-.4.6-.3.6-.3 1.3-.4 2.6-.6-1.1 1zM16 47.2l-.4.4-.4.4-.4.5-.4.6-.1.3-.1-.1-.1-.6.1-.5.2-.5.3-.5.4-.5.5-.5 1.2-.9 1.3-.8 2-1.1-.1.3-.8.5-.4.3-.4.4-.4.4-.3.5-.2.5-1.5.9zm3.5-2.7l-.5.7-.7.6.1-.2.3-.4.4-.4.4-.3zm.7-.2l-1.1 1.9-.9 1.9-.5 1.5v.1l-.2-1v-.8l.1-.7.2-.6.6-.4.9-.7.9-1.2.2-.4.1-.1-.3.5zm.3-11.2l.1.6.1.6.1.6-.1-.3-.3-1-.1-.7v-.8l.2 1zm-2.9 2.8l-.2-.4-.3-.6-.2-.6-.1-.5v-.6l.1-.5.3-.5.1-.1v.3l.1.7.2.6.5 1 .3.4.7.9v.1l.2.7.1.2-.4-.5-.4-.3-.5-.2-.5-.1zm2.5 2.9l-.9-1-.6-.6-.5-.7.2.1.4.2.7.5.3.3.5.7.1.3.2.6-.4-.4zm.5-1.5l-.2-.5-.6-.8-.2-.1-.3-1.1-.3-.8v-.7l.2-.6.2-.6.3-.6.1-.2v1l.1 1.1.1.4.3 1 .2.6.1.2.1.3.1.6.1 1.1v.5l-.1-.2-.2-.6zm.2 5.9l.1-.3h.1l-.2.3zm.7-2.6l-.1-.3h.1V39l.3 1.7c-.2 0-.3-.1-.3-.1zm.4-1.2l-.3-2.1-.1-.5-.2-1.5-.1-.6-.2-1.1-.1-.5.4.5.2.4.2.5.1.5.1.5.1 1.7-.1 2.2zM121 56.2l.4.1.6.2.5.2.2.1h-1l-.7.2h-.1l-.5.2h-.1l-.3.1-.5.2-.5.5-.3.3-.2.3-.8-.1h-.4l-.8-.1h-.3l-.4-.1.1-.2.3-.4.4-.4.4-.3.5-.3.5-.2.2-.1.7-.2.4-.1h.9l.8.1zm-2.5-1.4h.6l.5.1.5.3.5.4.1.1h-1l-.6.1-.6.1-.3.1h-.2l-.4.1-.8.4-.3.2-.2.1-.1.1-.3.4-.1.1-.3.5-.2.3-2.2-.3-.5-.1h-.1l.6-.4.1-.1 1.7-1.1.7-.5 1.2-.6.6-.2.6-.1h.5zm-2.8-.7l.7-.1h.5l.7.1.7.2h-.2l-.5.1-.5.1-.5.2-1 .5-.9.6-.7.5-.5.3-1.1.8-.4.3-.3.2-2.5-.3.1-.1 1.8-1.3.6-.4 1.3-.8.7-.3.7-.3.7-.2.6-.1zm-9.7-2l.8-.1h.8l.8.1.7.2.1.1-.8.3-2.1 1-2.2 1.2-1.8 1.1-.7.5-.1.1-3-.3.2-.2.5-.5 1.3-1 1.5-1 1.5-.8.8-.3.8-.2.9-.2zm-3.4-.7h.4l.8.1.9.2.2.1-.8.3-.7.3-.7.3-.7.4-.6.4-1.1.8-1.3 1.1-.1.1-.3.3-.6.3V56l-3.7-.3h.1l.8-1 .6-.6.6-.6.6-.5.7-.4.7-.4.7-.3.5-.2.9-.2.9-.1h1.2zm-4.8-2l.5-.1h.7l.8.2.8.4.8.6.4.4h-.5l-.8.1-.8.2-.2.1h-.1l-.5.2-.6.2-.6.3-.5.3-.6.4-.6.5-.6.5-.6.6-.6.7-.1.2-.4.5-1.9-.3-.9-.1 1.7-2.1 1.2-1.3.7-.6.5-.4 1-.7.6-.3.6-.3.6-.2zm-2.4-.6l.6-.1h.6l.5.2.2.2-.6.2-.7.4-.8.5-.7.6-.7.7-.1.1-.2.2-.5.6-.7.6-.5.6-1.6 1.8-2.4-.3.2-.1 1-.9 1.9-1.9.4-.4 1.1-1 .5-.4.5-.4.5-.4L95 49l.4-.2zm-2.8-.6l.6.1v-.1h.1l.6.1.7.2.2.1-.2.1-.7.4-.2.1-.7.4-.4.4-.3.2-.4.3-.5.4-.4.5-.3.3-.6.6-1.3 1.4-1.1 1.1-.5.2-2.2-.3-.9-.1 1.5-1.9.8-.9.8-.8.8-.7.5-.4.6-.4.7-.4h.1l.6-.3.1-.1.2-.1.6-.2.7-.1.5-.1zm-2.9-.8l1.1.1 1.1.3-.7.2-.4.2h-.1l-.1.1h-.1l-.1.1-.4.2-.2.1-.4.2-.7.5-.2.1-.1.1-.7.6-1.3 1.2-1.7 1.8-1 1.3-3.8-.4-.3-.1h-.3l.4-.3.7-.6 1.3-1.1.7-.7.4-.4 1.6-1.4.8-.6.8-.5.2-.1.7-.3.8-.3.9-.3.5-.1.6.1zm-3.6-.9h1l1.1.2.5.3h-.1l-1 .2-1 .4-.9.5h-.1l-.5.3-.6.4-.6.4-.5.5-1.2 1.1-1.4 1.3-1.6 1.3-.8.6h-.9l-.6-.1-.6-.1-1-.2.3-.1.6-.4.6-.5 1-.9 3-2.6 1-.8 1.1-.7L84 47l1.1-.4 1-.1zm-9.4-1.7h1.8l-.5.2-.9.6-1 .7-.7.6-.2.1-.7.6-3.4 2.9-1.2 1-1.1.8-.5.3h-.1l-1.6-.4-.4-.1h-.1l.4-.8.6-1 .7-.9.7-.8.8-.8.9-.7.9-.6.6-.4 1.4-.7.8-.3.2-.1.7-.2.9-.2 1 .2zm-5.1-.6l1-.1 1.2.1 1.3.2.5.1-.9.3-.7.1-.2.1-1 .4-1 .5-.3.1-.1.1-.7.4-.8.5-.7.5-.6.5-.6.6-.6.7-.6.7-.5.7-.5.8-.4.7H65l-.6-.2H64l-.4-.1h-.2l.4-.8.4-.7.8-1.4.3-.5.6-.8.6-.8.7-.7.7-.6.8-.5.6-.3.8-.3.9-.3h.6zm-1.8-.3h.8l-.3.1-1 .4-.2.1-.7.3-.6.4-.6.4-.6.4-.5.5-.4.5-.8 1.3-.5.9-.5.9-.3.7-.6.9-1.7-.3H61l.2-.7.6-1.4.4-.7.4-.6.5-.6.5-.6.6-.5.6-.5.7-.4.7-.4.7-.3.8-.3.8-.2.8-.1.5-.2zm-3.1-.9l1 .1 1 .3.2.1-.7.1-.9.2-.9.3-.8.4-.8.5-.8.5-.7.6-.6.7-.7.8-.5.9-.5.9-.4 1-.2.7-2.5-.4.3-.8.4-1 .5-1 .6-.9.6-.8.6-.7.7-.7.7-.6.6-.4h.1l.8-.4.7-.2.3-.1.9-.1h1zm-3.5-.7l.8.1.8.2.1.1h-.2l-.9.3-.8.3-.2.1-.7.4-.7.5-.6.5-1 1.1-.4.6-.4.6-.6 1.2-.6 1.4-.4.9-1.6-.4-.8-.1.2-.4.3-.7.6-1.3.8-1.3.1-.2.5-.6.6-.7.7-.7.7-.6.7-.5.7-.4.7-.2.8-.2h.8zm-2.7-1v-.1h.4l.8.3.5.3-1 .3-.7.3-.7.4-.6.4-.6.5-.6.6-.5.6-.5.6-.3.5-.2.2-.6.8-1 2.1-.4.9-1.5-.5 1.3-2.6.8-1.4.8-1.2.5-.7.6-.6.6-.6.4-.4.6-.4.6-.2.6-.1h.7zm-3.1-.8h1l.9.2.2.1-.3.1-.8.4-.8.5-.7.6-.7.8-.7.8-.6.9-.2.4-.2.3-1.3 2.2-.8 1.6-2.6-.5.2-.5.3-.6.9-1.6.6-.9.5-.7.4-.6 1.1-1.2.6-.6.6-.5.6-.4.4-.3.5-.2.9-.3zm-2.2-.7l.9.2.5.2-.6.3-.2.1-.4.2-.9.7-.9.8-.8.9-.8.9-.1.2-.1.1-1 1.4-.4.7-.7 1.3-.3.6-.1.4-2.1-.5.4-.9 1-2 .5-.9.9-1.5.5-.7.2-.3.7-.7.7-.6.7-.5.7-.3.8-.2.9.1zm-3.6-1h.9l.9.3.5.2-.5.1-.5.2-.5.2-.5.3-.5.4-.4.6-.5.5-.3.4-.4.5-.6.9-.5.9-1 1.8-.7 1.1-.3 1-2.5-.5.6-1.3.4-.8.9-1.9.5-.9.6-.9.6-.8.7-.7.7-.6.7-.4.1-.1.7-.3.9-.2zm-4.5-1l.8-.1.9.1 1 .3.8.4-.7.4h-.1l-.1.1h-.1l-.6.4-.6.5-.5.5-.9 1.1-.5.5-1.1 1.9-1.4 3-.3.6-.6-.1-1.6-.4h-.1l2.1-5.2.5-.9.3-.5.3-.4.4-.6.5-.5.4-.4.5-.3.7-.4zm-1.9-1.1h.6l.6.2.5.2.1.1-.8.4-.6.4-.1.1-.2.1-.6.7-.6.8-.2.4-.2.2-.3.7-1.1 2.2-1.5 3.5-2.9-.9-.7-.1.6-1.5 1-2 .8-1.4.5-.7.5-.7.6-.6.6-.6.6-.5.7-.4.5-.3.4-.2.7-.2.5.1zm-4.3-.8l.5-.1h.8l.8.1.7.3.3.2-.4.2-.2.1H43l-.8.4-.8.6-.8.7-.6.9-.7 1-.7 1.1-.7 1.3-.6 1.5-.3.9-.2.5-2.5-.7.1-1 .2-.8.3-1 .2-.5.5-1 .6-1 .6-.9.7-.8.8-.7.8-.6.7-.4 1.1-.3zm-3.4-.6h.8l.9.2.5.2-.1.1-.4.2-.9.5-.8.6-.7.7-.6.7-.6.8-.4.8-.4.8-.3.8-.1.3-.2.6-.1.4v.1l-.1.6-.1.5-.1.4v.2l-.4-.1-.9-.3-.6-.2.2-.5.3-.9.3-.9.7-1.8.6-1.4.3-.6.4-.6.4-.6.4-.5.4-.4.3-.2.5-.2.8-.3zm-3.6-.6l.7-.2.6-.1.7.1.6.2.3.2-.6.3-.2.1h-.1l-.6.5-.6.6-.5.7-.4.9-.1.4-.4.6-1.5 3.6-.2.7-.2.5-.4-.1-.3-.1-.7-.3-.8-.2.1-.8.2-1 .3-1 .4-.9.4-.9.4-.7.7-1 .8-.9.9-.8h.1l.4-.4zm-3.4-.7l.6-.3.6-.1.6.1.5.3.5.5-.3.1h-.1l-.7.5-.6.6-.6.7-.6.8-.2.3-.1.5-.3.6-.5 1.2-.4 1.3-.3 1.4-.1.5-.7-.2-1.3-.5.1-.5v-.2l.5-1.9.2-.6.4-1.1.5-1 .3-.5.6-.9.4-.4.7-.8.3-.4zm-5.3 7.1l.3-1.4.3-1.2.4-1.3.4-1.1.4-.9.4-.7.4-.5.3-.3.4-.2.3-.1h.5l.3.1.3.1.2.2-.4.3-.6.6-.5.8-.6.9-.5.9-.4.9-.4 1-.3.8-.2.9-.1.6-.1.5h-.3l-.5-.2h-.1l.1-.7zM23 45.5l-.2 1.5-.1 1.2v1.1l.1 1 .2.8.1.2-.4-.1-.7-.4-.4-.5-.3-.5-.3-.5v-.6l.1-.6.2-.7.5-1.3.3-.6.3-.5.5-1 .4.1.2.1-.1.6v.1l-.4.6zm2.4 7.9l-.4-.1-.3-.2-.3-.2-.3-.3-.3-.4-.1-.3-.2-.6-.2-.9-.1-.5v-1l.2-2.1.1-.5.1-.5.1-.3.1-.3.2-.8 1.8.6-.3 1-.2 1.2-.1 1.2v.6l.1 1.2.2 1.3.1.3.3 1 .2.6h-.7zm3.3 1.5h-.6l-.6-.2-.5-.4-.4-.5-.4-.7-.3-.8-.2-.8v-.1l-.1-.9-.1-.9v-1l.1-1.8.1-.8.2-.7.1-.4 1.9.7-.1.4-.2 1.2-.1 1.3v1.2l.1.6.2 1.2.3 1.2.5 1.1.4.7v.1l-.3.3zm3.7 1.4l-.7-.1-.6-.3-.6-.4-.5-.5-.4-.6-.1-.2-.3-.6-.4-.8-.3-.8-.2-.9-.1-.9-.1-.9v-.9l.1-.9.2-.9.2-.6 2.3.7.1 4.2.1.6v.6l.1.8.1.8.2.7.2.7.3.6.3.5.2.2-.1-.1zm1.4.4l-.1-.1h.2l-.9-.5-.2-.2-.4-.5-.2-.5-.2-.5-.2-.7-.2-1.5-.1-1V50l-.1-2.8v-.6l.5.2.3.1 1 .3v1.7l-.2 2.2v.4l.2 1 .2.9.1.6v.3l.2.9v.2l.2.6.3.6.2.3-.6-.2zm3.8 1.5l-.9-.2-.8-.3-.5-.4-.2-.2-.4-.5-.4-.7-.3-.7-.3-1.1-.1-.7v-2.2l.1-1.5v-.9l-.2-1.3 1.7.5-.2.9L35 50v1.4l.1.8.1.9.3.9.3.9.3.5.1.2.5 1 .6.9.6.8.1.1-.4-.2zm4.1 1.4H41l-.7-.2-.7-.4-.6-.6-.2-.2-.8-.8-.7-.9-.6-1-.1-.5-.3-.8-.3-1.1-.2-1.1-.3-1v-1.1l.1-1.1.1-.7 2.2.7v1.4l.1 1.4.3 1.6.2.8.3.8.2.2.1.3.4 1 .1.2.2.3.2.4.3.4.2.4.6.7.6.6.3.2-.3.1zm3.1.5h-.5l-.6-.1-.6-.2-.6-.4-.5-.5-.5-.5-.6-.7-.2-.3-.2-.4-.3-.5-.2-.4-.5-1.2-.2-.5-.1-.5-.2-1.1-.2-1.3-.1-1.4v-1.2l.6.2.6.2.6.2.6.2 1.1.3h.2l.2 2.6.1.5v.1l.2 1.9.1 1 .2.9.3.9.4.8.5.7.4.3.1.1-.1.3zm3 .6l-1-.1-.9-.3-.7-.4-.2-.3-.3-.4-.4-.5-.3-.5-.2-.6-.2-.7-.2-.7-.1-.7-.2-1.5-.1-.7v-1.2l-.1-1.7V50l.4.1.3.1 1.6.4.2 2.1.1.7.1.7.1.7.3 1.3.2.6.2.6.1.2.4.9.5.8.6.7.5.5-.7.3zm3.6.6l-.9-.1-.8-.3-.5-.3-.4-.4-.5-.5-.4-.6-.4-.6-.5-1-.3-.8v-.1l-.2-.9-.2-.9-.3-1.9-.2-2 .8.2.3.1.3.1h.3l.4.1h.2l.1.9.2 1.1v.1l.1.3.3 1.4.2.8.3.8.1.3v.1l.1.3v.1l.2.5.3.7.3.6.7.9.4.4.4.3.2.2-.6.1zm3.3.4l-.9-.1-.8-.3-.8-.4-.6-.6-.6-.7-.5-.8-.4-.8-.1-.3-.4-.7-.3-.8-.3-.9-.4-1.5-.1-.4-.2-1.2-.1-.6 2.2.6v.4l.2 1.2.4 1.4.6 1.5.3.8.2.4.2.4.6 1 .6 1 .5.6.2.3.1.1.1.1.5.4-.2-.1zm3.5.7l-.9-.1-.9-.3-.8-.5-.6-.6-.3-.4-.8-1.2-.8-1.3-.2-.4-.4-.6-.4-1-.3-1-.3-.9-.4-1.8v-.1l1.7.4 1 .2.6 2.3.5 1.6.2.7.4.9.4.9.2.4.1.2.4.7.4.6.5.6.5.5.3.2h-.1zm2.7-.4h-1.6l-.7-.3-.6-.5-.6-.6-.5-.8-.2-.4-.3-.6-.3-.8-.6-1.6-.5-1.8-.6-1.6 1.7.3.1.5.1.7.3 1.3.2.7.2.7.3.6.3.5.3.6v.2l.4.6.1.2.4.6.6.6.6.6.2.1.7.2zm2.6.6l-.8-.2-.7-.3-.7-.4-.4-.3-.1-.1-.5-.4-.5-.5-.4-.5-.4-.3-.1-.1-.5-.7-.3-.6-.1-.3-.5-.9-.3-.9-.3-1-.3-1-.1-.7 1.5.3.4.1.3.1.2.1.2.8v.2l.2 1 .3 1 .1.2.1.3.5 1.2.7 1.2.4.6.5.6.6.5.4.4.8.6.3.2.2.1-.7-.3zm5.1.7l-1-.1-1-.2-.9-.3-.9-.4-.5-.3-.8-.6-.7-.5-.3-.3-.5-.5-.6-.8-.5-.8-.4-.9-.3-.8-.6-2-.1-.4-.1-.4 2.3.4.1.6v.4l.1.3.1.2.1.1H62v.4l.4.7.5.9.5.8.6.8.6.7.7.7.7.6.8.5.8.5.3.2h.1l.6.3v.2zm1.8 0l-.9-.2-.9-.3-.5-.2-.7-.4-.7-.4-.6-.5-.6-.5-.6-.5-1-1.2-.4-.6-.4-.7-.1-.9-.3-.7-.1-.5-.1-.5V55l-.1-.6 1.9.3.7 1.7.4.9.5.8.4.8.3.6.8 1.1 1 1 .3.2.3.3.8.6.9.5.3.1h-.6zm4.9.5l-1.3-.1-1.1-.2-1-.3-.6-.2-.8-.4-.7-.4-.6-.5-.2-.2-.4-.4-.7-.7-.6-.8-.5-.8-.3-.5-1.7-3.5 1.5.2.9.1.4.9.3.6.9 1.5 1 1.3.5.6.6.6.6.5 1.3 1 .7.5.7.4.5.2.5.3.3.1.2.1-.4.1zm-4.2-7.5l1.1 1 1.1 1.2 1.7 1.9 2.1 2.1.1.1.1.1.2.2 1.3 1.1.1.1-1-.1-.8-.2-.9-.3-.6-.2-.8-.4-.3-.2-.9-.5-.9-.6-.8-.7-.8-.7-.8-.8-.7-.8-.6-.9-.6-.9-.5-.9-.1-.1-.2-.6 1.8.2.6.1 1.1.8zm-.8-3.4l-1.4-.1.1-.1.4-.3 1-.8 1-.8 2.8-2.4 1.3-1.1 1.5-1.1.7-.5.8-.4.7-.4.7-.2.8-.1.7.2.7.1h.3l-1 .5v.2l-.1.1-.8.3-.8.3-.7.5-.7.4-1.3 1-3.3 3-1.5 1.2-.7.5h-1.2zm2.5.2l-.4.1h-.5l1.3-.9 1.6-1.4 1.6-1.5 1.6-1.3.8-.6.9-.5.9-.4.9-.3.7-.1 1.3-.1 1.1.1.4.1-.4.1-1 .5-1 .5-.9.6-.9.6-.8.7-1.5 1.3-1.6 1.4-.1.1-.7.6-.7.5-.5.2-.2-.2-.4-.2H74l-1.2.1zm11.8 11.3l-1-.3-.9-.4-.5-.2-.2-.1-.6-.4-.6-.4-1.2-1.1-2.3-2.3-1.4-1.5-.7-.8-.8-.7-.2-.2 1.8.2h.1l.3.1.3.1h.1l.5.3.6.6.7.7 2.4 2.7.9.9 1 .9 1 .9 1 .7.8.4-1.1-.1zm4.6.3l-1 .1-1-.2-.6-.3-.7-.3-.9-.6-.9-.6-.8-.7-.8-.7-.7-.7-1.3-1.4-.6-.7-1.1-1.2-.5-.5-.5-.4-.2-.1 1.7.2h.8l.7.6.7.7 2.8 3.1.7.7.1.1 1.1 1 .1.1.2.1.9.6.9.5 1 .4.3.1-.4.1zm2.2-.3l-1-.1-.5-.1-.5-.2-.8-.4-.7-.4-.7-.4-.5-.4-1.3-1.1-.3-.3-1-1.1-1.7-2-.6-.6-.9-.8h.5l.6.1 1.3.1.3.1 1 .1h.5l.7 1.1.8 1 .7 1 .7.9 1.3 1.4.7.6.7.5.4.3.1.1.1.1.5.3.4.2h-.8zm3.3 0h-.6l-.3-.1v-.1h-.4l-.5-.1-.6-.2-.6-.3-.2-.2-.6-.4-.6-.5-1.3-1.2-.6-.6-1.6-2-.4-.6-.7-1.2 2.3.1h1l.4.5 1.7 2 .4.6.4.5.4.5L94 63l1.5 1.3-.8.1zm3.3 0l-.5.1-.5-.1-.6-.2-.6-.4-.6-.5-.6-.6-.6-.7-1.3-1.4-1.8-2.2-.5-.6-.5-.6 2.3.2 2.3 3 .2.3.1.1.1.2.1.1.9 1.1 1.4 1.3.7.5.2.1-.2.3zm4.6-.4l-.8.4-.8.2h-.7l-.7-.1-.7-.2-.4-.2-.8-.6-1.4-1.3-1.1-1.2-.2-.3-.2-.3-2-3.1L94 57h.2l.7.4.5.9 1.1 1.5.6.6.4.4.3.3.3.3.2.2.2.2.5.4.2.1.3.2.9.5.2.1 1.1.4.5.2.5.1h.2l-.3.2zm1.9-.6l-.8-.1-.8-.1-.7-.2-.7-.2-.7-.3-1.1-.7-.8-.6-.4-.3-.5-.2-.5-.5-.5-.6-1.1-1.4-.2-.4 3.1.3.9 1.1 1.2 1.2.6.6.7.5 1.4 1 .8.5.7.4.2.1-.8-.1zm-1.6-4.2l.6.5.7.6 1.8 1.3 1 .7.9.6.5.3.6.4-.8.1-.7-.1-.7-.1-.2-.1-.9-.4-.7-.3-1.3-.8-.6-.4-1.7-1.4-.5-.5-1.4-1.5h1.1l1.3.1h.1l.4.4.1.1.4.5zm2.5-2.1l-.9-.1-1.6-.1-.7-.1 2.1-1.4 1.9-1.1 1.1-.5 1-.5 1.1-.4.9-.3.4-.1.6-.1h.8l.7.1.5.3.2.3-.3.1-.5.2-.7.3-.5.3-.9.4-2.7 1.5-1.2.6-1.3.6zm2.5-.7l1.1-.6.9-.5 2.2-1.1.5-.2.5-.2 1-.3.5-.1h.8l-.2.1-.9.4-.8.4-.8.4-1.5.9-1.8 1.2-.8.7-1.4-.2-.6-.1 1.3-.8zm7.1 7.4l-.4-.1-.5-.1-.5-.2-.5-.3-.2-.1-2.7-1.8-1.7-1.1-.3-.2-.7-.4-.7-.5-.4-.6.1-.4h.5l1.4.5.3.4 1.6 1.6 1.3 1.1 1.5 1.1.8.5.8.4.4.1h.1l.3.1h-.5zm2.1-.3h-.8l-.6-.2-.4-.1-.5-.2-.6-.3-1.3-.8-1.8-1.3-1.4-1.2-.3-.3-.1-.1 1.1.1 1.7.1 2.1 1.9 1.6 1.3.8.5.9.4.2.1-.6.1zm2.7-.5l-.5.1h-.5l-.5-.1-.5-.2-.5-.2-.6-.3-.7-.3-1.1-.9-2.1-1.9 1.1.1 1.2.1.1.2.3.5.1.2.4.4.4.4.5.4.5.3.2.1.1.1.2.1.1.1.2.1.4.2.4.1.9.2h.3l-.4.2zm-.5-2.4l.2.2.1.1.5.4.3.2.9.4.2.1.9.2h-.2l-.5-.1h-.6l-.3.2-.5.1h-.4l-1.2-.3-.4-.2-.2-.1-.3-.1-.5-.3h-.1l-.9-.8-.2-.3-.1-.2-.2-.3-.1-.1.7.1 1.9.1.2.3.3.4h.5zm1.5-1.9l-.3.1-.1.1h-.1l-1.3-.2.1-.1.4-.4.3-.2.4-.2.2-.1.5-.2.8-.2 1-.1h.4l.5.1.3.1.3.1h-.7l-.5.1h-.1l-.3.1-.7.2-.4.2-.7.6zm.5.2l1.7-.6.4-.1.5-.1h.9l.2.1.1.2.1.3v.2h-.5l-.4.1-1.5.4-.1.1-1.5-.3.1-.3zm3.6 2.4l-.1.2-.1.1h-.2l-.6-.2-.7-.3-1-.6-1-.7 1.4.2 1.6.8.2.1.2.1.2.1.1.1h.1l-.1.1zm.6-.7l-.1.1h-.3l-.7-.2-.6-.3 1.2.1h.1l.5.1-.1.2zm.1-.7l-.5-.1-1.4-.3 1-.2h.5l.3.1.2.3-.1.2zM14.8 71L7.4 91h5.2l1.4-4h7.5l1.4 4h5.4l-7.4-20h-6.1zm.5 12l2.5-7.2 2.5 7.2h-5zm25.5-7.8c-1 0-1.8.2-2.6.6-.8.4-1.2.9-2.2 1.4V76h-5v20h5v-5.9c0 .3 1.1.6 1.7.8.6.2 1.3.3 2.1.3.9 0 1.8-.2 2.6-.5s1.5-.9 2.2-1.6c.6-.7 1.1-1.5 1.5-2.5.4-1 .6-2.2.6-3.4 0-2.4-.5-4.3-1.6-5.7s-2.4-2.3-4.3-2.3zm0 11.4c-.6.8-1.6 1.1-2.9 1.1-.4 0-.6 0-1-.1-.4 0-.9-.1-.9-.2v-7.6c0-.3.8-.5 1.3-.6s.9-.2 1.4-.2c1.1 0 1.9.3 2.4 1s.7 1.7.7 3.2c-.1 1.5-.4 2.6-1 3.4zm21.5-10.1c-1.2-.9-3.2-1.3-5.9-1.3-1.2 0-2.5.1-3.7.3-1.2.2-1.7.4-2.7.5v4h.9c.4 0 1.1-.5 2-.8s1.8-.5 2.6-.5c1.3 0 2.1.1 2.8.4s.7.9.7 1.7v.1c-1 .1-2.6.2-3.9.4s-2.3.5-3.2.9c-.9.4-1.6 1-2 1.7-.5.7-.7 1.6-.7 2.7 0 1.4.5 2.5 1.5 3.4 1 .9 2.2 1.3 3.6 1.3.6 0 1.2-.1 1.7-.2s1-.3 1.5-.5c.3-.2.5-.4.9-.7s.7-.5.7-.7V91h5V80.5c-.1-1.8-.6-3.1-1.8-4zM59 86.9c0 .3-.6.6-1.1.8-.5.2-.9.3-1.4.3-.6 0-1 0-1.3-.1-.3-.1-.5-.2-.7-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.8 0-.5.1-.9.4-1.2.3-.3.6-.5 1.1-.7.4-.1.7-.2 1.5-.3l1.9-.2v3.2zm17.5-11.7c-1.2 0-2.3.1-3.3.4-1.1.3-2 .8-2.8 1.4-.8.7-1.5 1.5-2 2.6s-.7 2.3-.7 3.7c0 1.3.2 2.5.7 3.5s1.1 1.8 1.9 2.5c.8.7 1.8 1.1 2.9 1.5 1.1.3 2.3.5 3.6.5 1 0 2-.1 2.8-.3.8-.2 1.5-.5 2.5-.9V86h-.8c-.2 0-.4.4-.6.6-.2.2-.5.4-.8.6-.3.2-.7.3-1.2.5-.5.1-1 .2-1.7.2-1.3 0-2.3-.4-3-1.1s-1.1-1.9-1.1-3.3.3-2.5 1-3.4c.7-.8 1.7-1.2 3-1.2.6 0 1.1.1 1.5.2.4.1.8.3 1.2.5.4.2.7.6 1 .8.3.2.5-.2.7.8h.7v-4.5c-1-.4-1.6-.7-2.5-.9-.9-.4-1.9-.6-3-.6zm18.6 0c-1 0-1.8.2-2.6.5-.8.4-1.5.9-2.5 1.6V70h-5v21h5V80.1c1-.3 1-.5 1.5-.7.5-.1.9-.2 1.3-.2.6 0 1.1.1 1.5.2.3.2.6.4.8.7.2.3 0 .7.1 1.3.1.6-.1 1.2-.1 1.8V91h5V81c0-1.9-.3-3.3-1.2-4.3-1-1-2.1-1.5-3.8-1.5zm17.3 0c-2.7 0-4.8.7-6.3 2.2-1.5 1.5-2.3 3.5-2.3 6s.8 4.5 2.4 5.9c1.6 1.4 4 2.1 7 2.1 1.2 0 2.5-.1 3.5-.3s1.4-.5 3.4-1v-4h-1c-.6 1-1.3.9-2.3 1.2-1 .4-2 .6-3 .6-1.6 0-2.9-.4-3.7-1-.8-.6-1.3-1.8-1.4-2.8H120v-1.5c0-2.3-.7-4.1-2-5.4-1.2-1.4-3.2-2-5.6-2zm-3.8 5.8c.1-1 .4-1.7 1-2.2.6-.5 1.4-.7 2.3-.7 1 0 1.8.1 2.2.7.5.5.7 1.2.8 2.2h-6.3z\" fill=\"#303284\"/></svg>"

/***/ }),

/***/ "../src/components/apache/line-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ApacheLineWordmark = __webpack_require__("../src/components/apache/line-wordmark/ApacheLineWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ApacheLineWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apache/line/ApacheLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ApacheLine = __webpack_require__("../src/components/apache/line/ApacheLine.svg");
	
	var _ApacheLine2 = _interopRequireDefault(_ApacheLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ApacheLine */
	function ApacheLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ApacheLine',
	    svg: _ApacheLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ApacheLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ApacheLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apache/line/ApacheLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#303284\" d=\"M126.1 72.2l-.3-.5-.2-.1v-.4l-.1-.4-.2-.3-.4-.2-.1-.1-.3-.3-.3-.2-.4-.1h-.1l-.4-.3-.5-.3-.6-.3-.6-.2h-.1l-.5-.5-.6-.4-.6-.3-.6-.2h-.1l-.6-.4-.8-.3-.4-.1-.5-.3-.5-.2-.5-.1-.5-.1h-.5l-.6.1-.3-.5-.7-.4-.9-.2h-.9l-1 .2-.3.1-.7-.3-.8-.2-.8-.1h-.8l-.8.1h-.1l-.9-.3-.9-.3-.9-.1h-.6l-.8-.8-.9-.6-.8-.4-.8-.2h-.8l-.5.1-.5-.4-1-.4-.7-.1-.6.1-.7-.3-.7-.1-.7-.1H93l-1-.4-1.2-.3-1.1-.1h-.2l-1.1-.7-1.2-.3h-.8l-1.8-.4-1.1-.1H83l-.6-.6-.8-.5-.9-.1-.9.1-.6.2-.8-.1h-1.5.1v-.1l-1.7-.3-1.5-.2-1.3-.1H72l-1-.1-1-.1h-.1l-1.1-.4-1.1-.3-1-.1h-.8l-.9-.7-.9-.2-.9-.1H63l-1.1-.7-.9-.3-.7-.1-.8-.4-1.1-.3h-1l-1.1-.5-1-.2h-.5l-1.1-.6-1-.3-1-.1h-.2l-1.5-.7-1-.3-1.1-.1h-.1l-.7-.5-.6-.3-.6-.1-.7-.1-.6.1-.7-.5-.7-.3-1-.2h-.8l-.9.2-.1.1-1-.4-1-.3h-.9l-.9-.6-.7-.3-.8-.1-.7.1-.7.3-.6-.6-.7-.4-.8-.1-.6.1-.6.3-.4-.3-.3-.2-.3-.1-.4-.1h-.5l-.3.1-.5.3-.1.1-.8-.1H26l-.7.2-.6.5-.4.5-.3.8-.2.8-.2.8-.1.8-.1 1.6.3 1.3.3.7v.1c-1-.2-1.1-.3-1.6-.5l-.1-.6v-.6l.1-2.5v-.6l-.1-1.2-.1-.5-.2-.5-.2-.5-.2-.5-.3-.4-.3-.4-.8-.7v-.1l.1-.7.1-.3.2-.6-.4-.2-.5.6-.4.7-.3.7-.1.7-.1.6v.7l.1.7.1.3-.1-.2-.3-.4-.4-.9-.2-.5-.1-.6-.1-1.2-.9.8-.3.6-.2.7v.6l.1.6.2.6.3.6h-.1l-.6-.1-.1.4.4.2 1.4 1 .3.3 2.2 2.5.1.1C15 50.6 9 47.9 1.7 44.4c1.5 2.5 7 5.1 9.3 6.8 2.3 1.2 5.5 2.6 8.3 3.7l-2.3.5-1.4.3-1.4.5-.7.3-.5.5-.6.4-.5.4-.5.5-.4.5-.3.6-.2.7.4.2.2-.2.7-.7.9-.6.9-.5.4-.1.3-.1 1.4-.3.6-.2 2.5-1.5.5-.3.4-.2.3-.1-.1-.2c.2.1.4.1.5.2l-.1.1-2.3 1.2-1.3.8-1.2.9-.7.5-.5.6-.3.6-.2.6-.1.7.1.7.4 1.1.6-1.2.4-.6.4-.5.4-.4.4-.3 1-.6v.1l-.1.8v.9l.1 1 .3 1.1h.4l.1-.5.4-1.5.2-.5.6-1.4 1-1.8 1.2-1.9c.3.1.7.2 1 .4l-.9 1.7-.3.6-.4.5-.2.7-.2.7-.1.7v.7l.1.6.3.6.5.6.8.5.7.2.2.5.4.5.4.4.4.3.4.2.4.3.9.3h.2v-.1l.4.5.6.4.8.2h.8l.7-.2.1.2.6.6.6.4.6.3.8.1h.6l.6.4.7.3.8.2.6.5.8.4 1 .2 1.1.1.1.1.7.6.8.4.7.3.9.1.8-.2.4.2.6.3.6.1h.6l.6-.1.3.2 1 .3 1.1.1 1.3-.1.3.2.9.3 1 .1 1.4-.1.9.3 1 .1 1.1-.1.4.3 1 .4 1.1.1 1.1-.1v-.1l.6.1h1l1.1-.2.6.2.8.2.8.1h1l.2.1 1 .3 1 .2 1.1.1 1.1-.1v-.1l.6.2.9.1.9.1v-.1l.6.2 1.2.2 1.3.1 1.4-.1.7.2.9.2.8.1h.9l.1.1.8.4.8.2h.8l.8-.2.7-.5.9.4 1.1.3h1.2v-.2h.3l1.1.1 1.1-.1 1.1-.4 1 .1h1.2l.9-.2.6.1h.7l1.5-.2.5.2.6.1.6-.1.5-.3h.1l.8.4.8.3h.8l.9-.3.8-.5.9-.6h.7l.9-.1.8-.1.5.2.8.1.8.1.8-.1.8-.2.2.1.9.2.8.1h.8l.7-.1.5-.4.3.1.5.2.5.1h.5l.5-.1.4-.2.7.1.8-.1.7-.3h.7l.6-.1.6-.3.5-.4h.6l.6-.1.5-.2.6-.3h.7l.3-.1.1-.1.3-.1.3-.2.2-.3.1-.3h.2l.4-.4.1-.3h.1l.1-.6zM17.2 56.5l-1.2.7-.5.2-.7.1-1.4.5-1 .5-.9.6-.1.1.4-.7.4-.5.5-.4.5-.4.6-.3.6-.3 1.3-.4 2.6-.6-1.1.9zm105 17.4l.9.5.4.2.1.2-.1.2h-.3l-.3-.2-.1-.1-.4-.1-1-.4-.3-.1-.7-.4-.3-.3-.1-.1-.2-.1-.6-.6-.1-.1 1.2.1.3.3.4.3.6.4.3.2.3.1zm-1.7-3.5l.5-.2.8-.2 1-.1h.4l.5.1.3.1.3.1h-.7l-.5.1h-.1l-.3.1-.7.2-.4.2-.6.3-.3.1-.1.1h-.1l-1.3-.2.1-.1.4-.4.3-.2.4-.2.1.2zm5.1 2.2l-.5-.1-1.4-.3 1-.2h.5l.3.1.2.3-.1.2zm-.4-1.1h-.5l-.4.1-1.5.4-.1.1-1.5-.3.2-.1 1.6-.7.4-.1.5-.1h.9l.2.1.1.2.1.3v.1zm-2.8-2.1l.2.1h-1l-.7.2h-.1l-.5.2h-.1l-.3.1-.5.2-.4.3-.3.3-.2.3-.8-.1h-.4l-.8-.1h-.3l-.4-.1.1-.2.3-.4.4-.4.4-.3.5-.3.5-.2.2-.1.7-.2.4-.1h.9l.8.1.4.1.6.2.4.4zm-1.9-1.1h-.9l-.6.1-.6.1-.3.1h-.2l-.4.1-.8.4-.3.2-.2.1-.1.1-.3.4-.1.1-.3.5-.2.3-2.2-.3-.5-.1h-.1l.6-.4.1-.1 1.7-1.1.7-.5 1.2-.6.6-.2.6-.1.6-.1h.6l.5.1.5.3.4.6zM118 67l-.5.1-.5.1-.5.2-1 .5-.9.6-.7.5-.5.3-1.1.8-.4.3-.3.2-2.5-.3.1-.1 1.8-1.3.6-.4 1.3-.7.7-.3.7-.3.7-.2h.7l.7.1h.5l.7-.1.7.2-.3-.2zm-3.4-1h1.6-.2l-.9.3-.9.3-.8.3-.8.4-1.5.9-1.8 1.2-.8.7-1.4-.2-.6-.1 1.4-.7 1.1-.6.9-.5 2.2-1.1.5-.2.5-.2 1-.3.5-.2zm-3.3-1h.8l.7.1.5.3.2.3-.3.1-.5.2-.7.3-.5.3-.9.4-2.7 1.5-1.2.6-1.2.6-.9-.1-1.6-.1-.7-.1 2.1-1.4 1.9-1.1 1.1-.5 1-.5 1.1-.4.9-.3.4-.1.5-.1zm-4.5-.3h.8l.8.1.7.2.1.1-.8.3-2.1 1-2.2 1.2-1.8 1.1-.7.5-.1.1-3-.3.2-.2.5-.5 1.3-1 1.5-1 1.5-.8.8-.3.8-.2.8-.2.9-.1zm-3-.5l.9.2.2.1-.8.3-.7.3-.7.3-.7.4-.6.4-1.1.8-1.3 1.1-.1.1-.3.3-.6.5-3.7-.5.1-.1.8-1 .6-.6.6-.6.6-.5.7-.4.7-.4.7-.3.5-.2.9-.2.9-.1h1.5l.9.1zM98.3 62h.7l.8.2.8.4.8.6.4.4h-.5l-.8.1-.8.2-.2.1h-.1l-.5.2-.6.2-.6.3-.5.3-.6.4-.6.5-.6.5-.6.6-.6.7-.1.3-.4.5-1.9-.3-.9-.1 1.7-2.1 1.2-1.3.7-.6.5-.4 1-.7.6-.3.6-.3.6-.2.5-.2zm-1.2-.4l.2.2-.6.2-.7.4-.8.5-.7.6-.7.7-.1.1-.2.2-.5.6-.5.5-.5.6-1.6 1.8-2.4-.3.1-.1 1-.9 1.9-1.9.4-.4 1.1-1 .5-.4.5-.4.5-.4 1.1-.6.5-.2.6-.1h.6l.3.3zm-3.2-.6l.7.2.2.1-.2.1-.7.4-.2.1-.7.4-.4.3-.3.2-.4.3-.5.4-.4.6-.3.3-.6.6-1.3 1.4-1.1 1.1-.5.4-2.2-.5-.9-.1 1.5-1.9.8-.9.8-.8.8-.7.5-.4.6-.4.7-.4h.1l.6-.3.1-.1.2-.1.6-.2.7-.1.6-.1.6.1v-.1h.1l.5.1zm-2.1-.5l-.7.2-.4.2h-.1l-.1.1h-.2l-.4.2-.2.1-.4.2-.7.5-.2.1-.1.1-.7.6-1.3 1.2-1.7 1.8-1 1.3-3.8-.4-.3-.1h-.3l.4-.3.7-.6 1.3-1.1.7-.7.4-.4 1.6-1.4.8-.6.8-.5.2-.1.7-.3.8-.3.9-.3.5-.1h.8l1.1.1.9.5zm-3.6-1l.5.3h-.1l-1 .2-1 .4-.9.5h-.1l-.5.3-.6.4-.6.4-.5.5-1.2 1.1-1.4 1.3-1.6 1.3-.7.5h-.9l-.6-.1-.6-.1-1-.2.3-.1.6-.4.6-.5 1-.9 3-2.6 1-.8 1.1-.7 1.1-.6 1.1-.4 1.1-.2h1l.9.4zm-4.7-.8l1.1.1.4.1-.4.1-1 .5-1 .5-.9.6-.9.6-.8.7-1.5 1.3-1.6 1.4-.1.1-.7.6-.7.5-.5.2H74l-1.2-.1h-.9l1.3-.9 1.6-1.4 1.6-1.5 1.6-1.3.8-.6.9-.5.9-.4.9-.3.7-.1 1.3-.2zm-2.1-1.1l.7.2.3.2-1 .4v.1h-.1l-.8.3-.8.3-.7.4-.7.4-1.3 1-3.3 3-1.5 1.2-.7.5h-1.2l-1.4-.1.1-.1.4-.3 1-.8 1-.8 2.8-2.4 1.3-1.1 1.5-1 .7-.5.8-.4.7-.4.7-.2.8-.1.7.2zm-4.7-.1h1.8l-.5.2-.9.6-1 .7-.7.6-.1.1-.7.6-3.4 2.9-1.2 1-1.1.8-.5.3h-.1l-1.8-.3H66l.4-.8.6-1 .7-.9.7-.8.8-.8.9-.7.9-.6.6-.4 1.4-.7.8-.3.2-.1.7-.2.9-.2h1.1zm-4.2-.7l1.2.1 1.3.1.5.1-.9.3-.6.2-.3.1-1 .4-1 .5-.3.2-.1.1-.7.4-.7.5-.7.5-.7.6-.6.6-.5.5-.5.7-.5.7-.5.8-.4.7h-.4l-.7-.2H64l-.4-.1h-.2l.4-.8.4-.7.8-1.4.3-.5.6-.8.6-.8.7-.7.7-.6.8-.5.6-.3.8-.3.9-.2.6-.1.9-.1zm-1.9-.2l-.3.1-1 .4-.2.1-.7.3-.6.4-.6.4-.5.4-.5.5-.4.5-.9 1.3-.5.9-.5.9-.3.7-.6.9-1.7-.3H61l.2-.7.6-1.4.4-.7.4-.6.5-.6.5-.6.6-.5.6-.5.7-.4.7-.4.7-.3.8-.3.8-.2.8-.1h1.1l.2-.2zm-2.9-.8l1 .3.2.1-.7.1-.9.2-.9.3-.8.4-.8.5-.8.5-.7.6-.6.7-.7.8-.5.9-.5.9-.4 1-.2.7-2.5-.4.3-.8.4-1 .5-1 .6-.9.6-.8.6-.7.7-.7.7-.6.6-.4h.1l.8-.4.7-.2.3-.1.9-.1h1l1 .1zm-2.9-.5l.1.1h-.2l-.9.3-.8.3-.2.1-.7.4-.7.5-.6.5-1 1.1-.4.6-.4.6-.6 1.2-.6 1.4-.4.9-1.6-.3-.8-.2.2-.4.3-.7.6-1.3.8-1.3.1-.2.5-.6.6-.7.7-.7.7-.6.7-.5.7-.4.7-.2.8-.2.8-.1.8.1.8.3zm-3.1-1.1l.5.3-1 .3-.7.3-.7.4-.7.5-.6.5-.5.5-.5.6-.5.6-.3.5-.2.2-.6.9-1 2.1-.3.9-1.6-.6 1.3-2.6.8-1.4.8-1.2.5-.7.6-.6.6-.6.6-.5.6-.4.6-.2.6-.1h.7v-.1h.4l.6.4zm-2.4-.8l.2.1-.3.1-.8.4-.8.5-.7.6-.7.8-.6.8-.6.9-.4.4-.2.3-1.3 2.2-.8 1.6-2.6-.5.2-.5.3-.6.9-1.6.6-.9.5-.7.4-.6 1.1-1.2.6-.6.6-.5.6-.4.4-.3.5-.2.9-.3h1l1 .2zm-2.7-.5l-.6.3-.2.1-.4.2-.9.7-.9.8-.8.9-.8.9-.1.2-.1.1-1 1.4-.4.7-.7 1.3-.3.6-.1.4-2-.5.4-.9 1-2 .5-.9.9-1.5.5-.7.2-.3.7-.7.7-.6.7-.5.7-.3.8-.2h.9l.9.2.4.3zm-5-1.4h.9l.9.3.5.2-.5.1-.5.2-.5.2-.5.5-.5.4-.4.4-.5.5-.3.5-.4.5-.6.9-.5.8-1 1.8-.7 1.1-.3 1-2.5-.5.6-1.3.4-.8.9-1.9.5-.9.6-.9.6-.8.7-.7.7-.6.7-.4.1-.1.7-.3.9-.2zm-1.8-.7l.8.4-.7.4h-.1l-.1.1-.1.1-.6.3-.6.5-.5.5-.9 1.1-.4.6-1.1 1.9-1.5 2.9-.3.6-.6-.1-1.6-.4h-.1l2.1-5.2.5-.9.3-.5.3-.4.4-.6.5-.5.4-.4.5-.3.7-.3.8-.1.9.1 1 .2zm-4-1.4l.6.2.5.2.1.1-.8.4-.6.4-.1.1-.2.1-.6.7-.6.8-.2.4-.1.2-.4.7-1.1 2.2-1.5 3.5-2.9-.9-.7-.1.6-1.5 1-2 .8-1.4.5-.7.5-.7.6-.6.6-.6.6-.5.6-.4.5-.3.4-.2.7-.2.6-.1.6.2zm-4.4-.9h.8l.8.1.7.3.3.2-.4.2-.2.1-.4.1-.8.4-.8.6-.8.7-.6.8-.7 1-.7 1.1-.7 1.3-.6 1.5-.3.9-.2.5-2.5-.7.1-1 .2-.8.3-1 .2-.5.5-1 .6-1 .6-.9.7-.8.8-.7.8-.6.7-.4 1.1-.4h.5zm-2.2-.2l.5.2-.1.1-.3.1-.9.5-.8.6-.7.7-.6.7-.7.8-.4.8-.4.8-.3.8-.1.3-.2.6-.1.4v.1l-.1.6-.1.5-.1.4v.2l-.4-.1-.9-.4-.6-.2.2-.5.3-.9.3-.9.7-1.8.6-1.4.3-.6.4-.6.4-.6.4-.5.4-.4.3-.2.5-.2.7-.1h.8l1 .2zm-4.7-1.1l.6-.1.7.1.6.2.3.2-.6.3-.1.1h-.1l-.6.5-.6.6-.5.7-.4.8-.1.4-.3.7-1.5 3.6-.2.7-.2.5-.5-.1-.3-.1-.8-.3-.8-.2.1-.8.2-1 .3-1 .3-1 .4-.9.4-.7.7-1 .8-.9.9-.8h.1l.6-.3.6-.2zm-3.4-.8l.6-.1.6.1.5.3.5.5-.3.2h-.1l-.7.5-.6.6-.6.7-.5.8-.2.3-.3.4-.3.6-.5 1.2-.4 1.3-.3 1.4-.1.5-.7-.2-1.3-.5.1-.5v-.2l.5-1.9.2-.6.4-1.1.5-1 .3-.5.6-.9.4-.4.7-.8.4-.3.6-.4zm-2.7-.2l.3-.1h.5l.3.1.3.1.2.2-.4.3-.6.6-.5.8-.5.9-.5.9-.4.9-.4 1-.3.9-.2.9-.1.6-.1.4h-.3l-.5-.2h-.1l.1-.6.3-1.4.3-1.2.4-1.3.4-1.1.4-.9.4-.7.4-.5.3-.3.3-.3zm-4.5 4.2l.1-.8.2-.7.2-.7.3-.6.3-.6.5-.4.6-.2h.7l.5.1-.3.4-.3.4-.5 1-.6 1.7-.6 2.4-.4 1.8-.6-.2-.1-2v-1.6zm-5.3-.4l-.5-.7.2.1.4.2.7.5.3.3.5.7.1.3.2.6-.4-.5-.9-1-.6-.5zm2.8 3v-1.3l.3 1.7-.2-.1-.1-.3zm-.1-6.6l.2.4.2.5.1.5.1.5.1 1.7-.1 2.2-.4-2.2-.1-.5-.1-1.5-.1-.6-.2-1-.1-.5.4.5zm-.8-.5l.1.6.1.6.1.6-.1-.3-.3-1-.1-.7v-.8l.2 1zm-1.3 1.5l-.2-.7V46l.2-.6.2-.6.3-.6.1-.2v1l.1 1.1.1.4.3 1 .2.6.1.2.1.3.1.6.1 1.1v.5l-.1-.2-.2-.6-.2-.5-.6-.8-.2-.1-.4-1.2zm-2.3-.3l-.1-.5V46l.1-.5.3-.5.1-.1v.3l.1.7.2.6.5 1 .3.4.7.9v.1l.2.7.1.2-.4-.5-.5-.3-.5-.2-.4-.2-.2-.4-.3-.6-.2-.5zM16 59.9l-.4.4-.4.4-.4.5-.4.6-.1.3-.1-.1-.1-.6.1-.5.2-.5.3-.5.4-.5.5-.5 1.2-.9 1.3-.8 2-1.1-.1.3-.8.5-.4.3-.4.4-.4.4-.3.5-.2.5-1.5.9zm3.5-2.7l-.5.7-.7.6.1-.2.3-.4.4-.4.4-.3zm.7-.1L19.1 59l-.9 1.9-.5 1.5v.1l-.2-1v-.8l.1-.7.2-.6.6-.4.9-.7.9-1.2.2-.4.1-.1-.3.5zm.6-1.2l.1-.3h.1l-.2.3zm1.1 7.6l-.4-.5-.3-.5-.2-.5v-.6l.1-.6.2-.7.5-1.3.3-.6.3-.5.5-1 .4.1.2.1-.1.6v.1l-.4.6-.3 1.4-.1 1.2v1.1l.1 1 .2.8.1.2-.4-.1-.7-.3zm3.5 2.7l-.3-.2-.3-.2-.3-.2-.3-.3-.3-.4-.1-.3-.2-.6-.4-1-.1-.5v-1l.2-2.1.1-.5.1-.5.1-.3.1-.3.2-.8 1.8.6-.3 1-.2 1.2-.1 1.2v.6l.1 1.2.2 1.3.1.3.3 1 .2.6-.6.2zm3.8 1.3l-.5.1h-.6l-.6-.2-.4-.4-.4-.5-.4-.7-.2-.8-.2-.8v-.1l-.1-.9-.1-.9v-1l.1-1.8.1-.8.2-.7.1-.4 1.9.7-.1.4-.3 1.3-.1 1.3v1.2l.1.6.2 1.2.3 1.2.5 1.1.4.7.1.2zm3.2 1.5l-.7-.1-.6-.3-.6-.4-.5-.4-.4-.6-.1-.2-.3-.6-.4-.8-.3-.9-.2-.9-.1-.9-.1-.9v-.9l.1-.9.2-.9.2-.6 2.3.7.1 4.2.1.6v.6l.1.8.1.8.2.7.2.7.3.6.3.5.2.2-.1-.1zm1.4.4l-.1-.1h.2l-.9-.5-.2-.2-.4-.5-.2-.5-.2-.5-.2-.7-.2-1.4-.1-1v-1.2l-.1-2.8v-.6l.5.2.3.1 1 .3v1.7l-.2 2.2v.4l.2 1 .2.9.1.6v.3l.2.9v.2l.2.6.3.6.2.3-.6-.3zm3.8 1.5l-.9-.2-.8-.3-.5-.4-.2-.2-.4-.5-.4-.7-.2-.6-.3-1.1-.1-.7V64l.1-1.5v-.9l-.2-1.3 1.7.5-.2.9-.1 1.1v1.4l.1.8.1.9.3.9.3.9.3.5.1.2.5 1 .6.9.6.8.1.1-.5-.3zm4.1 1.4H41l-.7-.3-.7-.4-.6-.4-.2-.2-.8-.9-.7-.9-.6-1-.2-.4-.3-.8-.3-1.1-.2-1.1-.1-1.1v-1.1l.1-1.1.1-.7 2.2.7v1.4l.1 1.4.3 1.6.2.8.3.8.1.1.1.3.4 1 .1.2.2.3.2.4.3.4.2.4.6.7.6.6.3.2-.3.2zm3.1.5h-.5l-.6-.1-.6-.2-.6-.4-.5-.4-.5-.5-.6-.7-.2-.3-.2-.4-.3-.5-.2-.5-.5-1.2-.2-.6-.1-.5-.2-1.1-.2-1.3-.1-1.4v-1.2l.6.2.6.2.6.2.6.2 1.1.3h.2l.2 2.6.1.5v.1l.2 1.9.1 1 .2.9.3.9.4.8.5.7.4.3.1.1-.1.4zm2 .5l-.9-.3-.7-.4-.2-.3-.3-.4-.4-.5-.3-.5-.2-.6-.2-.7-.2-.7-.1-.7-.2-1.5-.1-.7v-1.2l-.1-1.7v-.4l.4.1.3.1 1.6.4.2 2.1.1.7.1.7.1.7.3 1.3.2.6.2.6.1.2.4.9.5.8.6.7.5.5h-.7l-1 .2zm4.6.7l-.9-.1-.8-.3-.5-.3-.4-.4-.5-.5-.4-.6-.4-.6-.5-1-.3-.8v-.1l-.2-.9-.2-.9-.3-1.9-.2-2 .8.2.3.1.3.1h.3l.4.1h.2l-.1.9.2 1.1v.1l.1.3.3 1.4.2.8.3.8.1.3v.1l.1.3v.1l.2.5.3.7.3.6.7.9.4.4.4.3.2.2-.4.1zm3.3.4l-.9-.1-.8-.3-.8-.4-.6-.6-.6-.7-.5-.8-.4-.8-.1-.3-.3-.7-.3-.7-.3-1-.4-1.5-.1-.4-.2-1.2-.1-.6 2.2.6v.4l.2 1.2.4 1.4.6 1.5.3.8.2.4.2.4.6 1 .6 1 .5.6.2.3.1.1.1.1.5.4-.3-.1zm3.5.7l-.9-.1-.9-.3-.8-.5-.6-.6-.3-.4-1-1.2-.8-1.3-.2-.4-.3-.6-.4-1-.3-1-.3-.9-.3-1.8v-.1l1.7.4 1 .2.6 2.3.5 1.6.2.7.4.9.4.9.2.4.1.2.4.7.4.6.5.6.5.5.3.2h-.1zm2.7-.1H60l-.7-.1-.7-.3-.7-.6-.6-.6-.5-.8-.2-.4-.3-.6-.3-.8-.6-1.6-.5-1.8-.4-1.8 1.5.4.1.5.1.7.3 1.3.2.7.2.7.3.6.3.5.3.6v.2l.4.6.1.2.4.6.6.6.6.6.2.1.6.4.2.1zm2.6.3l-.8-.2-.7-.3-.7-.4-.4-.3-.1-.1-.5-.4-.5-.5-.4-.5-.4-.3-.1-.1-.5-.7-.3-.6-.1-.3-.4-.8-.3-.9-.3-1-.3-1-.1-.7 1.5.3.4.1.3.1.2.1.2.8v.2l.2 1 .3 1 .1.2.1.3.5 1.2.7 1.2.4.6.5.6.6.5.4.4.8.6.3.2.2.1-.8-.4zm5.1.7l-1-.1-1-.2-.9-.3-.9-.4-.5-.3-.8-.6-.7-.5-.3-.3-.5-.5-.6-.8-.5-.8-.4-.9-.3-.8-.6-2-.1-.4-.1-.4 2.3.4.1.6v.4l.1.3.1.2.1.2.1.2H62v.1l.4.7.5.9.5.8.6.8.6.7.7.7.7.6.8.5.8.5.3.2h.1l.6.3v.2zm.9-.2l-.9-.3-.5-.2-.7-.4-.7-.4-.6-.5-.6-.5-.6-.5-1-1.2-.2-.8-.4-.7-.3-.7-.3-.6-.1-.5-.2-.5v-.2l-.1-.6 1.9.3.7 1.7.4.9.5.8.4.8.3.6.8 1.1 1 1 .3.2.3.3.8.6.9.5.3.1-.5-.1-.9-.2zm5.8.7l-1.3-.1-1.1-.2-1-.3-.5-.2-.8-.4-.7-.4-.6-.5-.3-.2-.4-.4-.7-.7-.6-.8-.5-.8-.4-.5-1.7-3.5 1.5.2.9.1.4.9.3.6.9 1.5 1 1.3.5.6.6.6.6.5 1.3 1 .7.5.7.4.5.2.5.3.3.1.2.1-.3.1zm2.6.2l-.8-.2-.9-.3-.6-.2-.8-.4-.3-.2-.9-.5-.9-.6-.8-.7-.8-.7-.8-.8-.7-.8-.6-.8-.6-.9-.5-.9-.1-.1-.2-.6 1.8.2.6.1 1.1.9 1.1 1 1.1 1.2 1.7 1.9 2.1 2.1.1.1.1.1.2.2 1.3 1.1.1.1-1-.3zm4.8.9l-.7.4h-.7l-.7-.4-.8-.5-.8-.6-.8-.7-.8-.7V75L74 71.3l-1.8-1.9-.9-.9-.4-.3h.4l2.1.4 1.4 1.2 2 2 1.7 1.8.7.7.8.7.8.6.8.6.4.2.4.2.6.3.1.1-.4.6zm1.9-.5l-1-.3-.9-.4-.5-.2-.2-.1-.6-.4-.6-.4-1.2-1.1-2.3-2.3-1.4-1.5-.7-.8-.8-.7-.2-.2 1.8.2h.1l.3.1.3.1h.1l.5.3.6.6.7.7 2.4 2.7.9.9 1 .9 1 .9 1 .7.8.4-1.1-.1zm4.6.3l-1 .1-1-.2-.6-.3-.7-.4-.9-.6-.9-.6-.8-.7-.8-.7-.7-.7-1.3-1.3-.6-.7-1.1-1.3-.5-.5-.5-.4-.2-.1 1.7.2h.8l.7.6.7.7 2.8 3.1.7.7.1.1 1.1 1 .1.1.2.1.9.6.9.5 1 .4.3.1-.4.2zm2.2-.3l-1-.1-.5-.1-.5-.2-.8-.4-.8-.3-.7-.4-.5-.4-1.3-1.1-.3-.3-1-1.1-1.7-2-.6-.6-.9-.8h.5l.6.1 1.3.1.3.2 1 .2h.3l.2-.1.7 1 .8 1 .7.9.7.9 1.3 1.4.7.6.7.5.4.3.1.1.1.1.5.3.4.2h-.7zm3.3 0h-.6l-.3-.1v-.1h-.4l-.5-.1-.6-.2-.6-.3-.2-.2-.5-.4-.6-.5L89 74l-.6-.6-1.6-2-.4-.6-.7-1.1 2.3.3h1l.4.4 1.7 1.9.4.5.4.5.4.5 1.7 1.9 1.5 1.3-.8.1zm3.5-.1l-.2.1-.5.1-.5-.1-.6-.2-.6-.4-.6-.5-.6-.6-.6-.7-1.3-1.4-1.8-2.2-.5-.6-.5-.6 2.3.2 2.3 3 .2.3.1.1.1.2.1.1.9 1.1 1.4 1.3.7.5.2.3zm4.4-.3l-.8.4-.8.2h-.7l-.7-.1-.7-.2-.4-.2-.8-.6-1.4-1.3-1.1-1.2-.2-.3-.2-.3-2-3L94 70h.2l.7.3.5.8 1.1 1.5.6.6.4.4.3.3.3.3.2.2.2.2.5.4.2.1.3.2.9.5.2.1 1.1.4.5.2.5.1h.2l-.3.1zm1-.6l-.8-.1-.7-.2-.7-.2-.7-.3-1.1-.7-.9-.6-.4-.3-.3-.3-.5-.5-.5-.6-1.1-1.4-.2-.4 3.1.3.9 1.1 1.2 1.2.6.6.7.5 1.4 1 .8.5.7.4.2.1-.8.1-.9-.2zm4.6.3l-.7-.1-.7-.1-.2-.1-.9-.4-.7-.3-1.3-.8-.6-.4-1.7-1.4-.5-.5-1.4-1.5h1.1l1.3.1h.1l.4.4.1.1.4.4.6.5.7.6 1.8 1.3 1 .7.9.6.5.3.6.4-.8.2zm4.8.3l-.5.3h-.7l-.8-.3-.9-.4-.9-.5-.9-.5-.9-.6-4.7-3.6 2.7.2.7.4.4.2 3.4 2.4.5.3 1.2.8.9.6.4.3.2.2-.1.2zm2-.2l-.4-.1-.5-.1-.5-.2-.5-.3-.2-.1-2.7-1.8-1.7-1.1-.3-.2-.7-.4-.7-.5-.4-.5.1-.2h.5l1.4.3.3.3 1.6 1.5 1.3 1.1 1.5 1 .8.5.8.4.4.1h.1l.3.1-.5.2zm2.1-.2h-.8l-.6-.2-.4-.1-.5-.2-.6-.3-1.3-.8-1.8-1.3-1.4-1.2-.3-.3-.1-.1 1.1.1 1.7.1 2.1 1.9 1.6 1.3.8.5.9.4.2.1-.6.1zm2.7-.5l-.5.1h-.5l-.5-.1-.5-.2-.5-.2-.6-.3-.5-.4-1.1-.9-2.1-1.9 1 .1 1.2.1.1.2.3.5.1.2.4.4.4.4.5.4.5.3.2.1.1.1.2.1.1.1.2.1.4.2.4.1.9.2h.3l-.5.3zm2.4-.8h-2.3l-1.2-.3-.4-.2-.2-.1-.3-.1-.5-.3h-.1l-.9-.8-.2-.3-.1-.2-.2-.3-.1-.1.7.1 1.9.1.2.3.3.4.4.4.2.2.1.1.5.4.3.2.9.4.2.1.9.3-.1-.3zm2.7-1l-.1.2-.1.1h-.2l-.6-.2-.7-.3-1-.6-1-.7 1.4.2 1.6.8.2.1.2.1.2.1.1.1h.1l-.1.1zm.6-.7l-.1.1h-.3l-.7-.2-.6-.3 1.2.1h.1l.5.1-.1.2z\"/></svg>"

/***/ }),

/***/ "../src/components/apache/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ApacheLine = __webpack_require__("../src/components/apache/line/ApacheLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ApacheLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apache/original-wordmark/ApacheOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ApacheOriginalWordmark = __webpack_require__("../src/components/apache/original-wordmark/ApacheOriginalWordmark.svg");
	
	var _ApacheOriginalWordmark2 = _interopRequireDefault(_ApacheOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ApacheOriginalWordmark */
	function ApacheOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ApacheOriginalWordmark',
	    svg: _ApacheOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ApacheOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ApacheOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apache/original-wordmark/ApacheOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".596\" d=\"M126.8 61.4c-10.2-1.4-47.7-3.3-64.4-6-13.5-2.2-26.6-6.2-39.2-10.4-3.2-1.1-9-3.3-12.7-5.3-2.3-1.8-7.9-4.4-9.5-6.9 24.3 11.6 34.1 14.7 62.7 20.5 11.6 2.3 53.7 5.7 63.1 8.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M90.8 65.9l-1.1.3-1.1.1-1-.1-1.1-.5-1-.5-1-.8-1-.8-1-1-.9-.9-.9-1-.8-.9-.8-.8-.7-.8-.7-.5-.5-.4-.6-.2h.5l.4.1h.5l.6.1.5.1h1l.5.1.7.7.7.6.6.6.5.6.6.6.5.7.5.5.5.6.5.5.6.5.5.5.7.4.7.5.8.4.8.4 1 .3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M94.4 65.7l-1.3.2-1.2.1-1.1-.2-1-.2-.9-.4-.9-.5-.9-.6-.7-.6-.8-.7-.7-.8-.8-.8-.7-.8-.7-.7-.7-.8-.7-.7-.8-.7h.6l.3.1h.7l.3.1h.3l.3.1h.7l.3.1h1.4l.3.1.3.4.3.5.4.5.4.6.5.7.6.7.6.7.6.6.6.6.6.6.7.6.6.4.7.4.6.3.6.1h.6z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M96.7 65.8H96l-.7.1h-.6l-.7-.1-.7-.2-.6-.2-.6-.4-.7-.4-.7-.5-.6-.6-.7-.6-.7-.8-.7-.9-.7-1-.8-1-.8-1.2h.9l.5.1h.5l.4.1h1.5l.5.5.4.5.5.4.4.6.4.4.4.6.5.4.4.6.4.5.4.4.5.5.4.5.5.4.5.4.5.5.5.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M99.2 65.6l-.5.3-.6.1-.6-.1-.7-.2-.6-.4-.7-.5-.6-.6-.7-.7-.6-.7-.7-.7-.6-.8-.6-.7-.6-.7-.5-.6-.5-.6-.5-.4 3.1.2.3.5.4.5.4.4.3.5.3.4.4.5.4.5.3.4.4.4.4.5.4.4.5.5.5.4.5.4.5.4.5.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M104.3 65l-.9.5-.8.4-.9.2h-.8l-.7-.2-.8-.2-.7-.4-.7-.5-.7-.7-.7-.6-.6-.8-.7-.8-.6-.8-.7-.9-.6-.8-.6-.9.6.1.4.1h1l.4.1h.5l.5.8.6.7.5.7.6.6.6.5.6.5.6.5.5.4.6.4.6.3.5.2.6.2.5.2.4.1h.5l.4.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M107 64.8l-1 .1-.8.1-.9-.1-.8-.1-.8-.2-.8-.2-.7-.3-.7-.4-.7-.5-.6-.5-.6-.5-.6-.6-.6-.6-.6-.7-.5-.8-.5-.7h.5l.7.1h.6l.6.1h.5l.4.1h.5v.1l.2.1.2.2.3.3.3.4.4.4.5.4.4.5.6.4.6.5.5.5.7.4.6.5.7.4.7.3.7.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M110.5 65l-.8.1-.7.1-.8-.1-.8-.1-.7-.3-.8-.3-.7-.4-.8-.4-.7-.5-.7-.5-.6-.6-.7-.6-.6-.6-.5-.5-.6-.6-.4-.6h.7l.5.1h.9l.5.1h.7v.1l.1.1.3.3.4.3.5.4.6.5.6.5.6.5.7.5.7.5.7.5.6.4.6.4.5.3.4.2.3.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M114.4 65l-.5.4-.6.2h-.7l-.8-.2-1-.3-.9-.5-1-.6-1-.6-1-.7-.9-.7-.8-.6-.8-.7-.7-.5-.4-.4-.4-.3-.1-.1h.8l.4.1h.9l.5.1h.9l.5.3.5.4.6.3.4.3.6.4.4.3.6.4.5.3.5.4.5.3.5.4.5.3.5.3.5.4.5.3.5.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M117.3 65l-.5.2-.5.1h-.5l-.5-.1-.5-.1-.5-.2-.5-.3-.6-.4-.6-.4-.7-.4-.7-.5-.8-.6-.9-.6-1-.6-1-.7-1.1-.7h2l.4.1h.6l.1.1.2.2.3.2.3.4.4.3.5.5.5.4.6.4.6.5.7.5.6.4.7.4.6.3.6.3.6.2.6.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M119.4 64.7l-.7.3-.7.1-.8-.1-.7-.2-.8-.3-.8-.3-.8-.5-.8-.5-.7-.5-.7-.6-.6-.5-.5-.5-.5-.4-.4-.4-.3-.3-.2-.1h1.4l.4.1h.4l.4.1h.9l.4.4.4.3.3.3.4.3.3.4.4.3.4.4.4.3.4.4.4.3.5.3.4.2.4.2.5.2.4.2.5.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M121.9 63.9l-.6.4-.5.3-.6.1h-.6l-.6-.1-.5-.2-.6-.2-.6-.4-.5-.4-.6-.4-.6-.5-.5-.5-.6-.5-.5-.5-.5-.5-.5-.4h.3l.4.1h.7l.5.1h.4l.5.1h.5l.1.3.2.4.2.3.3.3.3.3.3.3.3.3.4.2.3.2.4.2.5.2.4.2.5.1.4.1.5.1h.5z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M124.2 63.5l-.5.2-.5.1-.6.1h-1.2l-.6-.1-.6-.2-.6-.2-.6-.2-.5-.3-.5-.3-.5-.4-.4-.4-.3-.4-.3-.5-.1-.5h.3l.3.1h.8l.4.1h1.3l.2.3.2.3.2.3.3.2.2.2.3.2.2.2.3.2.3.1.3.2.3.1.3.1.4.1.4.2h.4l.4.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M125.3 63.1l-.1.1-.3.1-.3.1h-.8l-.4-.1-.4-.2-.5-.1-.5-.2-.4-.2-.5-.3-.4-.3-.4-.3-.3-.3-.3-.4-.2-.4.2.1h.6l.2.1H121.4v.1l.3.3.4.3.6.4.7.3.7.4.6.3.6.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M126.2 62.3l-.1.4-.1.2-.3.1-.3.1-.3-.1-.5-.1-.4-.2-.5-.2-.4-.3-.5-.3-.4-.2-.3-.3-.3-.2-.3-.2-.1-.1v-.1l2.2.3.2.1.3.1.3.2.4.2.4.2.3.1.4.2.3.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M123.6 61.1h.9l.4.1h1.1l.4.1.4.1-.1.5-.2.3h-.4l-.6-.1-.5-.3-.5-.3-.5-.3-.4-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M123.7 60.8l.5.1h.4l.4.1.3.1.4.1h.3l.4.1.5.1v-.6l-.3-.4-.4-.1-.5-.1-.6.2-.6.1-.5.2-.3.1zM93.8 49.1l-1.3-.5-1.2-.3-1.1-.1-1 .1-1.1.2-.9.4-.9.5-.9.5-.9.6-.8.7-.9.7-.8.8-.8.7-.8.7-.8.7-.8.6h.3l.3.1h.6l.3.1h.7l.3.1h.7l.3.1h.7l.3.1h.4l.3.1.3-.4.4-.5.4-.6.5-.6.6-.6.6-.6.6-.7.7-.6.7-.5.7-.6.7-.4.8-.4.7-.3.7-.2h.7l.7.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M96 49.6l-.8-.2-.6-.2-.7-.1-.7-.1-.7.1-.6.1-.7.2-.7.3-.7.4-.7.6-.8.6-.8.7-.8.8-.8 1-.9 1-1 1.2h.6l.4.1h.5l.4.1h.4l.4.1.5.1.6.1.5-.5.5-.4.5-.5.4-.5.5-.5.5-.5.5-.5.5-.5.4-.4.6-.5.4-.4.6-.4.5-.4.6-.3.6-.3.6-.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M98.4 50.2l-.6-.4-.6-.2-.6-.1-.7.1-.7.3-.7.4-.8.5-.7.7-.8.6-.7.7-.7.7-.7.7-.7.7-.6.6-.5.5-.5.4 3.1.4.4-.5.4-.4.4-.5.4-.4.4-.5.4-.5.4-.5.4-.4.5-.4.4-.4.5-.4.5-.4.6-.4.5-.3.6-.3.7-.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M103.1 52.2l-.9-.8-.8-.6-.8-.4-.8-.2H99l-.8.1-.8.3-.7.3-.8.6-.7.6-.7.6-.7.8-.7.8-.7.8-.7.8-.7.9h1l.4.1h.3l.4.1h.3l.5.1.5.1.6-.8.6-.7.6-.6.5-.6.6-.4.6-.4.6-.4.5-.3.6-.2.5-.2.5-.1.6-.1.4-.1h1l.5-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M106.4 53l-.9-.3-.9-.3-.9-.1-.8-.1h-.9l-.8.1-.7.2-.8.3-.7.3-.7.4-.7.4-.7.6-.6.5-.7.7-.6.7-.6.7.6.1.7.1.7.1.7.1h.6l.5.1h.6l.1-.1.2-.3.3-.2.3-.3.4-.3.4-.4.5-.4.5-.4.6-.4.6-.4.7-.3.7-.4.8-.2.7-.3.8-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M110.7 53.5l-.8-.3-.8-.2-.8-.1h-.8l-.8.1-.9.2-.8.2-.8.3-.8.4-.7.4-.8.5-.7.5-.7.5-.7.6-.6.5-.5.6h.8l.5.1.6.1h.5l.5.1h.8v-.1l.1-.1.3-.2.4-.3.5-.3.6-.4.7-.4.8-.4.7-.4.7-.4.8-.4.7-.3.6-.3.6-.2.4-.2.4-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M114.7 54.4l-.4-.7-.6-.3-.7-.2h-.9l-.9.2-1.1.3-1.1.5-1 .5-1.1.5-1 .6-1 .5-.8.6-.8.4-.5.4-.4.2-.1.1.4.1.4.1h1l.6.1.5.1.5.1h.5l.6-.2.5-.3.6-.3.5-.3.5-.2.5-.3.5-.3.6-.3.5-.2.5-.3.5-.3.6-.2.5-.3.5-.2.6-.2.5-.2zM119.9 55.7l-.7-.4-.7-.3-.7-.1h-.8l-.9.2-.8.2-.9.3-.8.4-.8.4-.8.5-.6.4-.6.4-.6.4-.4.3-.3.3-.2.1.4.1h.5l.4.1h.7l.4.1.4.1h.5l.4-.2.4-.3.4-.3.5-.3.4-.3.5-.3.4-.4.5-.2.5-.3.4-.3.5-.2.5-.2.5-.1.4-.1h1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M118 54.9l-.5-.3-.5-.2-.5-.2h-1.1l-.5.1-.6.2-.6.3-.7.3-.8.3-.8.5-.8.4-1 .5-1 .5-1.1.6-1.3.6h.5l.5.1h.5l.6.1.4.1h.8l.2-.2.3-.2.3-.3.4-.3.5-.3.6-.4.6-.4.6-.4.7-.3.7-.3.7-.3.8-.3.7-.1.7-.1h.7zM122.2 57.2l-.6-.6-.5-.4-.6-.3-.5-.2h-.6l-.6.1-.6.1-.6.2-.7.3-.6.3-.6.4-.6.5-.7.4-.6.4-.6.4-.6.4h.4l.3.1.5.1h.4l.5.1h.5l.5.1h.5l.2-.3.2-.3.2-.4.3-.2.3-.3.3-.2.4-.2.3-.2.5-.1.4-.1.4-.1.5-.1h1.4l.6.1zM125.7 59.1l-.2-.2-.2-.2-.3-.2-.3-.1-.5-.1h-1.4l-.5.1-.5.1-.5.2-.4.2-.5.2-.4.3-.3.3-.3.3.3.1.3.1h.3l.3.1H121.5l.3-.2.5-.2.5-.3.7-.2.7-.2.8-.1h.7z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M126.4 60.3v-.5l-.1-.3-.2-.3-.3-.1-.4-.1-.4.1h-.5l-.5.1-.5.2-.5.2-.4.2-.4.1-.4.2-.3.1-.1.1-.1.1 2.3.4.2-.1.3-.1.4-.1.4-.1.4-.1.4-.1h.4l.3.1zM124.5 58.3l-.5-.3-.5-.3-.5-.3-.6-.1-.6-.2h-1.9l-.6.1-.6.2-.5.3-.6.3-.4.3-.4.4-.4.5-.2.5h.4l.3.1h.8l.4.1h.4l.5.1.5.1.1-.3.2-.2.3-.2.2-.2.3-.2.3-.2.3-.1.4-.1.3-.1.4-.1.3-.1H124.5zM22.3 44.6l-.1.1-.2.2-.2.4-.2.5-.3.5-.3.6-.2.7-.3.7-.1.7-.1.7v.7l.2.6.3.6.5.5.7.4.9.3-.2-.4-.1-.5-.1-.4v-2.7l.1-.5v-.6l.1-.5.1-.5.1-.5.1-.4.2-.4.1-.4-.2-.1H23l-.1-.1h-.2l-.2-.1h-.1l-.1-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M23.2 45l-.4 1.6-.3 1.4-.1 1.3v2l.2.8.2.7.3.6.3.4.4.4.4.3.4.2.4.1.3.1h.6l-.2-.5-.1-.4-.2-.5-.1-.6-.1-.5-.1-.6-.1-.6v-.6l-.1-.6v-.6l.1-.6v-.7l.1-.6.1-.6.2-.6.1-.6-.3-.1-.4-.1-.3-.1-.3-.1-.3-.1-.2-.1h-.3l-.2-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M25.6 45.7l-.2.6-.2.7-.1.8-.1.9v2l.1.9.1 1 .2.9.3.8.4.7.4.6.6.4.6.3h.7l.8-.2-.3-.5-.3-.6-.3-.6-.2-.5-.2-.6-.1-.6-.1-.6-.2-.6V49l.1-.6.1-.6.1-.6.2-.6-.3-.1-.4-.2-.3-.1-.4-.1-.3-.1-.3-.1-.2-.1-.2-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M32.9 57.6l-.8.1-.8-.1-.6-.3-.6-.4-.6-.5-.5-.7-.4-.8-.4-.8-.3-.9-.2-.9-.1-1-.1-1v-.9l.1-1 .2-1 .2-.9.3.2.4.1.3.1.3.1.4.1.4.1.3.1.4.1v2.8l.1.8v.8l.1.8.1.8.1.8.1.7.2.7.2.6.2.5.3.4.3.3.4.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M30.8 47.5l.3.1.3.1h.2l.3.1.3.1.3.1.3.1.2.1.1.5v.7l.1.7v3l.1.7v.7l.1.8.1.7.2.6.2.6.3.6.3.4.4.4-.8-.2-.7-.3-.6-.4-.5-.5-.4-.5-.3-.6-.2-.7-.2-.7-.1-.8-.1-.9v-.8l-.1-1v-2.8l-.1-.9z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M38.4 59.7h-1.1l-1-.3-.8-.3-.7-.5-.5-.7-.4-.7-.3-.8-.2-.9-.1-.9-.1-.9v-3.9l-.1-.8v-.8l.3.1h.3l.2.1.3.1.3.1.3.1h.3l.3.1-.1.1v.2l-.1.3-.1.4v.5l-.1.6v1.4l.1.8.2.9.2.9.3.9.5.9.6 1 .7 1 .8 1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M42.3 60.9l-.7.2-.8-.1-.8-.2-.7-.4-.7-.6-.7-.6-.7-.8-.5-.9-.5-1-.4-1-.4-1.1-.2-1.1-.2-1.1V51l.1-1.1.2-1.1 2.8.9-.1.4v1.2l.1.7.1.7.1.8.2.8.2.8.3.8.3.8.3.9.5.7.4.8.6.7.6.6.6.5z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M38 49.6l.4.2.6.1.6.2.6.2.6.2.6.2.6.1.4.1v1.4l.1.7v.7l.1.8.1.8.1.7.1.7.1.8.2.7.2.6.3.7.3.6.4.5.4.5.5.4-.6.1h-.6l-.6-.2-.6-.2-.6-.4-.6-.5-.6-.5-.6-.8-.5-.7-.5-.9-.4-1.1-.4-1.1-.2-1.2-.3-1.4-.1-1.4-.1-1.6z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M49 62.1h-1.3l-1.1-.1-.9-.3-.8-.5-.6-.6-.5-.7-.4-.8-.3-.9-.2-.9-.1-1-.1-1-.1-1v-1l-.1-.9-.1-.8v-.7h.4l.3.1.3.1.3.1.4.1.3.1.4.1.4.1.1.8.1.8.1.7.1.7.1.7.1.7.1.7.2.6.2.7.2.6.3.6.3.6.4.6.4.6.5.5.6.6z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M52.5 62.7l-1.2.1-1-.2-.8-.3-.8-.5-.7-.6-.6-.7-.4-.8-.4-.9-.4-.9-.2-1-.2-1-.2-.9-.1-1-.1-.8-.1-.8v-.7l.4.1.3.1h.3l.3.1.3.1h.3l.4.2h.4l.2 1.2.2 1 .2 1 .2.9.2.9.3.8.2.7.3.6.3.6.3.6.4.4.3.4.3.5.4.3.4.3.3.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M55.8 63.1l-1.1.1-1-.1-.9-.4-.8-.4-.6-.6-.6-.7-.5-.8-.5-.9-.4-.9-.3-.9-.3-1-.2-.9-.2-.9-.2-.9-.1-.7-.1-.7h.4l.3.1.3.1.4.1.3.1.4.1h.3l.4.1v.6l.1.6.1.6.2.7.2.8.3.7.3.7.3.8.4.7.4.8.4.6.4.6.5.6.4.6.5.4.5.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M59.4 63.8l-1.2.1-1-.1-.9-.4-.9-.5-.8-.8-.7-.8-.6-1-.6-1-.5-1.1-.4-1-.3-1-.3-.9-.2-.8-.1-.7-.1-.5V53l.4.1.4.1.4.1.4.1.4.1.4.1.4.1.4.1.1.4.1.6.2.7.2.7.2.8.3.8.3.8.3.8.4.8.3.8.4.7.5.6.5.6.4.4.6.3.6.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M62 63.7l-1.1.2H60l-.8-.2-.8-.4-.6-.6-.7-.6-.5-.8-.5-.9-.4-.9-.4-1-.2-.9-.3-.9-.3-.9-.1-.8-.2-.6-.2-.6.4.1h.3l.3.1h.2l.3.1h.3l.2.1h.3v.7l.2.7.2.6.1.7.3.7.2.7.3.6.4.6.3.7.4.6.5.5.4.5.6.6.5.4.6.5.7.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M65.2 64.2h-.8l-.8-.1-.8-.2-.8-.3-.7-.4-.8-.5-.6-.6-.6-.6-.6-.7-.5-.8-.5-.9-.4-.8-.3-1-.3-1-.3-1-.1-1.1.3.1.4.1h.4l.4.1.3.1h.4l.4.1.3.1.2.6.1.6.2.6.1.6.2.6.2.6.2.6.3.6.3.6.3.6.5.6.5.5.6.6.7.5.8.6.8.6z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M69.9 64.7l-1.1.1-1.1-.1-1-.1-1-.3-.9-.4-.8-.5-.8-.6-.7-.6-.6-.8-.6-.8-.5-.8-.4-.9-.4-1-.3-1-.2-1.1-.2-1 .3.1.4.1h.3l.3.1h.4l.4.1.3.1.4.1.1.7.2.7.2.7.3.7.4.7.3.7.5.6.5.7.5.6.5.6.7.5.6.5.7.5.7.4.8.4.8.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M72.5 65l-1-.1-.9-.1-.9-.2-.9-.4-.9-.4-.8-.5-.8-.5-.7-.6-.6-.7-.7-.8-.5-.8-.5-.8-.4-.9-.4-.9-.2-1-.2-.9h.6l.3.1h.5l.3.1h.3l.4.1.4.8.4.8.3.7.3.7.4.7.3.6.3.6.4.5.4.6.5.5.5.5.6.4.6.5.8.5.8.4 1 .5z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M77 65.3h-2.7l-1.2-.2-1-.3-1.1-.5-.8-.5-.9-.6-.7-.7-.7-.7-.6-.8-.6-.9-.5-.8-.5-.9-.4-.9-.4-.9-.4-.9h.3l.3.1h.4l.5.1.4.1h.4l.4.1h.2l.4.8.3.8.5.8.4.7.5.6.5.7.6.6.6.6.6.5.6.6.7.5.7.4.8.5.8.4.8.3.8.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M79.8 65.7l-.8-.1-.8-.1-.9-.2-.9-.3-.8-.4-.9-.4-.9-.6-.9-.6-.9-.6-.8-.8-.8-.8-.7-.8-.7-.9-.6-1-.5-1-.4-1 .4.1h.9l.4.1h.4l.4.1h.3l.1.1.5.4.5.5.6.5.5.5.6.6.6.6.5.6.6.6.6.7.6.6.6.7.6.6.7.6.6.6.6.6.7.5z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M84 65.7l-.8.5-.8.2h-.7l-.8-.2-.8-.4-.8-.6-.9-.7-.8-.7-.8-.9-.9-1-.9-.9-.9-1-.9-1-.9-.9-.9-.9-.9-.7h.7l.4.1h.4l.5.1.4.1.5.1h.3l.8.7.7.6.7.7.7.7.6.7.7.7.6.7.7.6.6.6.6.6.6.5.6.5.6.4.6.3.6.3.6.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M87.2 66H86l-1.1-.1-1-.3-1-.3-.9-.5-.8-.6-.8-.6-.7-.7-.8-.7-.7-.8-.7-.8-.7-.8-.7-.8-.8-.8-.8-.7-.8-.7.3.1h.4l.4.1h.9l.3.1h.5l.5.1.4.2.5.4.6.4.5.5.5.6.6.6.6.7.6.7.7.8.7.7.8.7.8.7.9.7 1 .6 1 .5zM23.3 42.4v-.9l-.1-.6v-1.5l.1-.8v-.8l.2-.8.2-.8.3-.6.5-.6.4-.4.7-.2h.7l.9.2-.3.3-.2.3-.3.5-.2.4-.2.5-.2.5-.2.6-.2.6-.2.6-.1.6-.2.6-.1.6-.1.6-.2.5v.5l-.1.4H24.1l-.1-.1h-.1l-.2-.1h-.2l-.2-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M24.4 42.8l.3-1.8.4-1.6.4-1.4.4-1.1.5-.9.4-.7.4-.5.3-.4.4-.2.4-.2h.3l.4.1.3.1.3.1.2.2.3.2-.4.4-.4.4-.4.4-.4.4-.3.5-.3.5-.3.5-.2.5-.3.5-.2.6-.3.6-.2.6-.1.6-.2.7-.2.6-.1.7-.4-.1H25l-.1-.1h-.1l-.1-.1h-.2l-.1-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M25.8 43.4l.1-.7.1-.8.3-.8.3-1 .3-.9.5-.9.4-.9.5-.9.6-.7.6-.6.6-.5.6-.3.6-.2.7.2.6.3.7.7-.5.4-.5.4-.5.4-.4.5-.4.4-.4.5-.3.6-.4.5-.3.5-.2.6-.3.6-.2.7-.2.6-.1.7-.2.7-.1.8-.3-.1-.4-.1-.3-.1-.4-.2-.3-.1-.4-.1-.2-.2h-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M37 35.8l-.7-.4-.7-.3-.7-.1-.7.1-.7.3-.7.3-.7.6-.6.6-.6.6-.5.9-.5.8-.4 1-.4.9-.3 1.1-.2 1-.1 1.1.3.1h.3l.4.2.3.1.4.1.4.1.3.1.4.1.3-.7.2-.7.3-.7.2-.7.3-.8.3-.7.3-.8.4-.6.3-.7.4-.6.4-.6.4-.5.4-.4.5-.3.5-.3.5-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M40.2 36.7l-1.1-.5-1-.2-.9-.1-.7.2-.7.3-.6.5-.6.6-.5.7-.4.8-.4.9-.3.9-.4.9-.3 1-.3.9-.4.9-.4.9h.4l.2.1.3.1.3.1.3.1.3.1.3.1h.3l.1-.1v-.3l.1-.4.1-.5.1-.6.2-.7.2-.7.3-.8.4-.8.4-.7.6-.8.6-.7.7-.7.8-.6.9-.5 1.1-.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M44.2 37.3l-.6-.5-.8-.3-.8-.1h-.8l-.8.2-.9.3-.8.5-.9.6-.8.7-.7.8-.7.9-.6 1-.5 1.1-.4 1.1-.2 1.2-.2 1.3 3 .7.1-.4.3-.6.2-.6.3-.7.3-.7.4-.7.4-.7.4-.7.5-.7.5-.7.6-.7.6-.6.7-.5.7-.5.7-.4.8-.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M36.6 46.9l.5.1.5.1.6.2.6.2.5.2.6.1.5.2.4.1.3-.7.3-.8.3-.7.3-.8.3-.8.4-.7.3-.8.4-.7.4-.7.4-.6.5-.7.5-.5.5-.5.5-.4.6-.3.6-.2-.5-.4-.6-.2-.6-.2-.6-.1-.7.1-.7.2-.8.3-.7.4-.7.5-.8.7-.7.9-.8 1-.6 1.1-.7 1.3-.7 1.5-.6 1.6z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M51 39.4l-1.1-.6-1.1-.4-1-.1-.9.2-.7.3-.8.5-.6.7-.6.8-.5.9-.5.9-.4 1-.5 1-.4 1-.3 1-.4.8-.3.8h.4l.3.1.4.1.3.1.3.1.3.1h.4l.4.1.4-.8.3-.8.4-.7.3-.7.4-.7.4-.7.3-.7.4-.6.4-.6.5-.5.4-.5.6-.5.5-.5.6-.4.7-.4.7-.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M54.6 40.4l-1.1-.5-1-.3-.9-.1-.9.2-.9.3-.8.5-.7.7-.7.7-.6.9-.6.9-.6.9-.5.9-.4 1-.4.8-.4.9-.3.7.4.1.4.1h.4l.3.1.3.1.4.1h.4l.4.1.5-1.1.6-1.1.4-1 .5-.9.5-.8.4-.7.5-.6.4-.6.5-.5.4-.4.5-.4.5-.3.5-.3.5-.2.5-.1.6-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M57.3 41.2l-1-.5-1-.2h-.9l-.9.2-.8.3-.8.5-.7.6-.7.7-.6.8-.6.9-.5.9-.5.9-.4.9-.4.8-.4.8-.3.7.4.1.3.1.3.1.3.1h.3l.3.1.4.1h.3l.2-.6.3-.6.3-.6.4-.7.4-.7.5-.7.4-.7.6-.7.6-.6.6-.6.6-.6.6-.5.6-.5.6-.3.6-.3.6-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M60.6 42l-1.1-.5-1-.3h-1.1l-1 .3-.9.5-.9.6-.9.8-.8.9-.7.9-.7.9-.6 1-.5.9-.4.7-.3.7-.2.5-.1.3.5.1h.3l.4.1.4.1.4.1.3.1h.4l.4.1.2-.5.3-.6.3-.7.5-.7.4-.8.4-.7.5-.8.5-.7.6-.8.6-.6.6-.6.6-.5.6-.4.6-.3.7-.1h.7z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M62.9 42.9l-.9-.6-1-.3-.8-.1-.9.1-.8.4-.8.5-.7.6-.7.8-.6.8-.6.9-.5.9-.6 1-.4.8-.4.8-.3.7-.3.6.3.1h.3l.3.1.2.1.3.1.2.1h.2l.3.1.3-.7.3-.7.3-.7.3-.7.4-.7.4-.6.5-.7.5-.6.5-.6.6-.5.5-.4.7-.5.7-.3.7-.3.7-.3.8-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M65.9 43.6l-.8-.3-.9-.2h-1.6l-.9.2-.7.3-.8.4-.8.4-.7.6-.7.7-.7.8-.6.8-.6.9-.5 1-.5 1.1-.5 1.1.4.1h.4l.4.1.3.1.4.1.4.1.4.1.3.1.3-.7.2-.6.3-.7.3-.6.3-.7.3-.6.4-.6.4-.6.5-.5.5-.6.6-.5.6-.4.8-.4.8-.4 1-.3 1-.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M70.1 44.6l-1-.4-1.1-.3-1-.1-1-.1-1 .2-.9.2-.9.4-.8.5-.8.6-.7.7-.7.8-.6.8-.6 1-.5 1-.4 1-.4 1.1.3.1h.4l.4.1.4.1h.4l.4.1h.4l.4.1.2-.8.2-.8.4-.7.4-.7.4-.7.5-.6.5-.6.6-.6.6-.5.7-.4.7-.4.8-.4.8-.2.8-.3.9-.1.8-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M72.2 44.9l-.9-.2-1-.1-.9.1-1 .1-.9.2-.8.3-.9.4-.8.4-.7.6-.7.6-.7.7-.6.8-.5.8-.4 1-.4 1-.3 1 .3.1h.6l.3.1.3.1h.3l.3.1.4.1.5-.9.4-.8.4-.7.4-.7.4-.6.4-.7.4-.5.4-.5.5-.5.5-.5.5-.4.7-.3.7-.4.8-.2 1-.3 1-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M76.8 45.5l-1.4-.4-1.4-.2h-1.2l-1.2.1-1 .2-1 .4-.9.4-.8.6-.8.6-.7.7-.6.8-.6.8-.5.9-.6.9-.4.9-.5 1h.6l.3.1.4.1.4.1h.3l.3.1h.3l.4-.9.5-.7.5-.8.5-.7.6-.6.6-.6.7-.6.7-.5.7-.5.7-.4.8-.4.8-.3.8-.4.9-.2.9-.3.9-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M79.5 45.7l-.8-.1H77l-1 .2-.9.2-1 .2-1 .4-.9.5-1 .5-.9.7-.9.6-.9.8-.8.9-.7.9-.6 1-.6 1.1h.4l.4.1.4.1.5.1h.3l.3.1.2.1.2-.1.5-.3.6-.4.6-.5.6-.5.7-.5.6-.6.7-.6.7-.6.7-.6.7-.6.8-.6.7-.6.8-.5.8-.5.8-.4.7-.5z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M83.4 46.8l-.8-.7-.7-.4-.8-.2-.9.1-.8.2-1 .4-.9.6-1 .7-.9.8-1 .8-1 .9-1 .9-1.1.9-1 .8-1 .8-1.1.7h.3l.4.1h.9l.5.1h1.3l.8-.6.7-.6.8-.6.7-.7.7-.6.6-.6.7-.6.6-.5.7-.6.7-.4.7-.5.7-.4.7-.3.8-.2.8-.2.9-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M86.2 47.2l-1.2-.3-1.1-.1h-1.1l-1 .2-.9.4-.9.4-.9.6-.9.6-.8.7-.8.6-.9.8-.8.7-.8.8-.8.7-.9.6-.9.6h.3l.3.1.5.1h.8l.4.1h.3l.2.1h.5l.5-.2.5-.2.6-.4.6-.5.6-.5.7-.6.7-.7.7-.6.8-.7.8-.7.8-.6 1-.6 1-.6 1-.4 1.1-.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M89.8 48.2l-1-.6-1.1-.3h-1.1l-1.1.3-1.2.4-1.1.6-1.1.7-1 .8-1 .8-1 .9-1 .8-.8.8-.8.6-.7.5-.7.3-.5.1h.5l.4.1.6.1.6.1h.5l.6.1h.6l.5.1.8-.6.7-.6.6-.6.7-.5.5-.6.6-.5.6-.5.5-.5.5-.5.6-.4.7-.4.7-.4.7-.3.8-.3.9-.3 1-.2zM20.3 36.4l-.2-.3-.1-.3-.1-.3-.1-.3-.1-.4v-.3l-.1-.4v-.4l-.1-.3v-1.1l.1-.3v-.4l.1-.3.1-.3-.5.6-.3.6-.3.6-.1.7-.1.7v.7l.1.7.2.7.1.7.3.6.2.7.3.6.3.7.2.6.3.6.3.5-.1-.1V41l-.1-.2V38.1l-.1-.4v-.3l-.1-.4v-.3l-.1-.3zM11.5 48.3l.6-.3.5-.3.5-.3.6-.4.5-.3.4-.3.5-.3.5-.3.5-.3.4-.2.5-.4.5-.2.4-.3.5-.3.5-.3.5-.3-.4.5-.5.4-.4.5-.5.4-.5.5-.5.4-.5.4-.5.4-.5.3-.5.3-.5.3-.5.2-.5.1-.5.1-.5.1-.6-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M15.8 36.8l.4.3.4.2.4.3.3.2.4.3.3.3.3.3.3.3.3.3.3.3.3.3.2.4.3.3.3.3.2.4.3.3-.1-.3-.2-.4-.1-.4-.2-.4-.2-.4-.2-.4-.2-.4-.3-.3-.2-.4-.4-.3-.4-.3-.4-.2-.4-.2-.5-.2-.6-.1-.6-.1zM20.1 33.4l.1.6.1.5.1.6.1.5v.6l.1.5.1.5.1.5v.5l.1.6.1.4.1.6.1.5v.5l.2.5.1.6v-.7l.1-.6.1-.6v-.6l.1-.6v-1.2l-.1-.6v-.6l-.1-.5-.2-.5-.1-.5-.2-.4-.3-.4-.3-.4-.4-.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M17 32.4l-.5.5-.3.6-.2.6v.6l.1.6.3.6.3.6.3.7.5.6.4.6.5.5.5.6.5.5.4.4.3.4.3.3v-.8l-.2-.8-.1-.6-.2-.6-.3-.5-.3-.4-.2-.4-.4-.4-.2-.4-.4-.3-.3-.4-.2-.5-.2-.5-.2-.6-.1-.7-.1-.8z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M20.7 41.6v-1.1l.1-.6v-1.1l.1-.6v-.5l.1-.5.1-.6.1-.5.1-.5.1-.5.2-.6.2-.5.1-.5.3-.5-.9.8-.7.8-.5.7-.3.7-.2.6-.1.6-.1.6.1.6.1.5.2.5.2.5.2.4.2.4.1.3.1.3.1.3zM12.3 43.6l.4.1.5.1h.5l.4.1h.5l.4.1h.9l.5-.1h.9l.4-.1h.9l.5-.1.4-.1-.4.2-.4.2-.4.1-.4.2-.4.1-.4.1-.5.2h-1.9l-.5-.1-.5-.1-.4-.3-.5-.2-.5-.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M15 45.9l-.4.1-.3.1H14l-.4.1-.3.2-.4.1-.3.1-.3.2-.4.2-.3.2-.3.2-.2.2-.3.2-.2.2-.3.3-.2.2.2-.7.4-.6.3-.5.5-.5.5-.4.6-.3.6-.4.7-.2.7-.2.6-.3.8-.2.7-.1.7-.2.7-.1.6-.1.6-.2-.3.1-.4.3-.5.3-.6.4-.7.4-.6.4-.7.3-.5.2zM13.6 51.1l-.2-.7-.1-.6.1-.6.2-.6.4-.6.4-.5.6-.5.6-.5.6-.4.7-.4.6-.4.7-.4.6-.3.6-.3.5-.3.3-.2-.4.8-.4.7-.4.6-.4.5-.4.3-.5.4-.4.2-.4.3-.4.3-.5.3-.4.2-.4.4-.4.4-.4.5-.4.6-.4.8z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M20.9 44l-.3.5-.4.5-.3.5-.3.4-.2.5-.3.5-.2.4-.3.5-.2.5-.2.5-.2.4-.2.5-.1.5-.2.5-.1.6-.1.5-.3-1.1-.1-.9v-1.6l.2-.7.3-.6.3-.4.3-.4.4-.4.4-.3.5-.3.4-.2.3-.3.4-.2.2-.2.3-.2z\"/><path fill=\"#231F20\" stroke=\"#231F20\" stroke-width=\".596\" d=\"M126.8 58.7c-10.2-1.4-47.7-3.3-64.4-6-13.5-2.2-26.6-6.2-39.2-10.4-3.2-1.1-9-3.3-12.7-5.3-2.3-1.8-7.9-4.4-9.5-6.9 24.3 11.6 34.1 14.7 62.7 20.5 11.7 2.3 53.8 5.7 63.1 8.1z\"/><defs><path id=\"a\" d=\"M90.8 63.1l-1.1.4-1 .1-1.1-.2-1-.4-1.1-.6-1-.7-1-.9-1-.9-.9-.9-.8-1-.9-.9-.8-.9-.7-.7-.6-.6-.6-.3-.5-.2h.4l.5.1h.5l.5.1h.5l.5.1h.5l.5.1.7.6.7.7.6.6.6.6.5.6.5.6.5.6.5.5.5.6.6.5.6.5.6.4.7.5.8.4.9.3.9.3\"/></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#b)\"><defs><path id=\"c\" d=\"M76.7 54.4h14.2v9.2H76.7z\"/></defs><clipPath id=\"d\"><use xlink:href=\"#c\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#d)\"><image overflow=\"visible\" width=\"44\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHoAAACKwAAAtP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEALwMBIgACEQEDEQH/ xACcAAADAQEBAAAAAAAAAAAAAAAABAYBBQMBAAIDAQAAAAAAAAAAAAAAAAADAQQFAhAAAAYBBAMA AAAAAAAAAAAAAAECAwQFFSAREgYQExQRAAAEAwUDDQAAAAAAAAAAAAABEQISAwQxoTKSEyCRNCFB UWFx0WLCg8MUdAUSAAEDAwMFAAAAAAAAAAAAAAEAEQIhEjIgMZFRcaGxA//aAAwDAQACEQMRAAAA t10OBX0a7ZLVtrfSQ6HStl62cuOVGtLKnUW6MKtQIxAAAAP/2gAIAQIAAQUAcN3lu+EG9zJG5esg aNtH/9oACAEDAAEFAI8L2NY4PQuDcSSlDH2pEmUlTHn/2gAIAQEAAQUAlzCijLJGWSMqgZRAanJc HapXzgrMgVmQKzSCs0irnE4O66aIduhy5Qw9sMPbDD2ww9sKatsWtf8A/9oACAECAgY/ADaWHZZH gIXSLPWidbhPo//aAAgBAwIGPwCP0Z7n8FliVKbYh1CJIDXeyshypxEhWPXR/9oACAEBAQY/AGKS xrzpYneMBbxhvGG8Ybw9CwNN9vQKXxal0AtFotGIVnLgpZrtyCi9X29n9H6M/wAopPjSXzoNSKAj NFgRU7Bwc7IY4OdkMcHOyGODnZDFdq00xmpRzmMiaZRPdCjS6z2//9k=\" transform=\"matrix(.3599 0 0 -.3599 75.72 64.586)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M90.8 63.1l-1.1.4-1 .1-1.1-.2-1-.4-1.1-.6-1-.7-1-.9-1-.9-.9-.9-.8-1-.9-.9-.8-.9-.7-.7-.6-.6-.6-.3-.5-.2h.4l.5.1h.5l.5.1h.5l.5.1h.5l.5.1.7.6.7.7.6.6.6.6.5.6.5.6.5.6.5.5.5.6.6.5.6.5.6.4.7.5.8.4.9.3.9.3z\"/><defs><path id=\"e\" d=\"M94.4 63l-1.3.2H92l-1.1-.1-1.1-.2-.9-.4-.9-.5-.8-.6-.8-.7-.8-.7-.7-.7-.7-.8-.7-.8-.7-.8-.8-.7-.7-.7-.7-.7h.6l.3.1h.6l.3.1h.6l.4.1h.6l.4.1h1l.3.1.3.4.3.4.4.6.5.6.5.7.5.6.6.7.6.7.6.6.7.6.6.6.7.4.6.4.6.3.6.1h.6\"/></defs><clipPath id=\"f\"><use xlink:href=\"#e\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#f)\"><defs><path id=\"g\" d=\"M80.6 54.8h13.8v8.4H80.6z\"/></defs><clipPath id=\"h\"><use xlink:href=\"#g\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#h)\"><image overflow=\"visible\" width=\"44\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHbAAACIwAAAtv/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8ALwMBIgACEQEDEQH/ xACVAAEAAwEBAAAAAAAAAAAAAAAGAAIFAwQBAAIDAAAAAAAAAAAAAAAAAAIEAAEFEAAABgIDAAMA AAAAAAAAAAAAAQIDBAURFhITBiMUNhEAAQIEAggHAQAAAAAAAAAAAQIDABESBDKSICExsdFy0zVR YSJi0rMFExIAAgIBBAMAAAAAAAAAAAAAAAERAjEhcaEDEjIz/9oADAMBAAIRAxEAAABRi+spWuhs clMo9YMmi1yL7Dbzz0QwjPKOGyAf/9oACAECAAEFADQZjrUCSZG2tskdjIcU2af/2gAIAQMAAQUA htRlMdEMTWY6WEOmlP2DDjxqT//aAAgBAQABBQD0Fs/WI2+cNvmjb5Y26UK64dl1ntT+LIyMjIof zvuDw1yMchzHMefPPm/RV8OcjXKUa5SjXKUa5SisrYMep//aAAgBAgIGPwCVJlktsStkzwRXJ//a AAgBAwIGPwCr7KVtbWW9z51Hbrqq2lCUwex4zJ//2gAIAQEBBj8AYUyEn+pUDUJ4ZeY8YwIyn5Rg RlPGMKMp4xhRlPGLu8UE1W4WRIavSiuLTmXuTo/p8rv1RZ8zm5Oj+ofa79UMC7vEWYQVFJWUiqcp yqUnZHeWczfUjvLOZvqR3lnM31I7yzmb6kXlszeofZeCw4+kppbqRSZyURqGvbH/2Q==\" transform=\"matrix(.3599 0 0 -.3599 79.821 64.232)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M94.4 63l-1.3.2H92l-1.1-.1-1.1-.2-.9-.4-.9-.5-.8-.6-.8-.7-.8-.7-.7-.7-.7-.8-.7-.8-.7-.8-.8-.7-.7-.7-.7-.7h.6l.3.1h.6l.3.1h.6l.4.1h.6l.4.1h1l.3.1.3.4.3.4.4.6.5.6.5.7.5.6.6.7.6.7.6.6.7.6.6.6.7.4.6.4.6.3.6.1h.6z\"/><defs><path id=\"i\" d=\"M96.7 63l-.7.1-.7.1-.6-.1-.7-.1-.6-.1-.7-.3-.6-.3-.7-.4-.6-.5-.7-.6-.6-.7-.7-.7-.8-.9-.7-1-.8-1-.8-1.2h1.4l.5.1.4.1h1.6l.4.5.5.5.4.4.4.5.4.5.4.5.5.5.4.5.4.5.4.5.5.5.4.5.5.4.5.4.5.5.5.3\"/></defs><clipPath id=\"j\"><use xlink:href=\"#i\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#j)\"><defs><path id=\"k\" d=\"M85.7 55.3h11v7.9h-11z\"/></defs><clipPath id=\"l\"><use xlink:href=\"#k\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#l)\"><image overflow=\"visible\" width=\"36\" height=\"26\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHjAAACJgAAAsv/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AJwMBIgACEQEDEQH/ xACiAAADAQEBAAAAAAAAAAAAAAAABQYBAwQBAQEAAwEAAAAAAAAAAAAAAAMEAAECBRAAAAUDBAID AAAAAAAAAAAAAAEDBAURAhUSFAYWEBMzJDURAAEDAQQFDQAAAAAAAAAAAAEAAgMRMZGhBEES0wU1 ICFRYbEiMkJyojNzsxIAAQMBBQkAAAAAAAAAAAAAAAERMQLwIbHhE0FxkRIyQlLiA//aAAwDAQAC EQMRAAAAuOKpCHo2mxm8JbiIWTzzNuoemfKAxtGZqL//2gAIAQIAAQUAvNXVqXFb/URW002ChV// 2gAIAQMAAQUAbsPaljDG2+y3e2ppZKwbi3d//9oACAEBAAEFAHLxNseVbjKNxk24Sdpq2cqdG3UK UMFKApUhDvCVjeafLUV8cf8Ax+QRrJ7f16HHXocdehxGRjFuw//aAAgBAgIGPwBeWNxkP35l6kjb D//aAAgBAwIGPwCn6eT4kKaFocpoVel8SV4Ka73erH//2gAIAQEBBj8AaHg96tKdSsOCsOCsOCfI 2tIxU3VWWA8wfgWrStKtK3jJX44yfY8rKel/a3kb3+o/nIoDms6zKFgcGh5aNatK+JzbFxiK+PaL jEV8e0XGIr49os9DDnmTxzsLZZWltIhquFTRx6a86//Z\" transform=\"matrix(.3599 0 0 -.3599 84.649 63.974)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M96.7 63l-.7.1-.7.1-.6-.1-.7-.1-.6-.1-.7-.3-.6-.3-.7-.4-.6-.5-.7-.6-.6-.7-.7-.7-.8-.9-.7-1-.8-1-.8-1.2h1.4l.5.1.4.1h1.6l.4.5.5.5.4.4.4.5.4.5.4.5.5.5.4.5.4.5.4.5.5.5.4.5.5.4.5.4.5.5.5.3z\"/><defs><path id=\"m\" d=\"M99.2 62.9l-.5.3-.6.1-.6-.1-.6-.2-.7-.4-.6-.5-.7-.6-.7-.7-.6-.7-.6-.7-.6-.8-.7-.7-.5-.7-.6-.7-.5-.5-.5-.5 3.1.3.4.5.3.4.4.5.3.5.4.4.3.5.4.4.4.5.4.4.4.5.4.4.4.4.5.5.5.4.5.4.5.4\"/></defs><clipPath id=\"n\"><use xlink:href=\"#m\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#n)\"><defs><path id=\"o\" d=\"M89.6 55.5h9.6v7.8h-9.6z\"/></defs><clipPath id=\"p\"><use xlink:href=\"#o\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#p)\"><image overflow=\"visible\" width=\"32\" height=\"25\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHXAAACCQAAAor/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwAJAMBIgACEQEDEQH/ xACcAAACAgMBAAAAAAAAAAAAAAAABgQHAQMFAgEBAQEBAQAAAAAAAAAAAAAABAECBQYQAAEDAwMF AQAAAAAAAAAAAAABAwQRAhIkBQYQIRMzFhQRAAECAwMLBQAAAAAAAAAAAAERAgAQAzESBEFRYbEy cpKiskNzccHRIhMSAAEDAwMFAAAAAAAAAAAAAAEAEAIRMSJhkRJBcTKiA//aAAwDAQACEQMRAAAA Z+HOVJ2O9uW5ERZQGvPqyjanhCavkWRm72gGH//aAAgBAgABBQBbFU8d3Ru6lq3dj//aAAgBAwAB BQCG3HVi5mJiNK7gqv0P/9oACAEBAAEFAORbpI22z6vcT6ueReTzHZJzX1VKkBdcc4WjWRkbfdrx zxGlNKJ+ap//2gAIAQICBj8AqCVeW7DDlrVeHs3/2gAIAQMCBj8AiZwjKWVSRqjT5wsejDiCR3Rx O7f/2gAIAQEBBj8AoOoEA1C4OUA2Jn9Y2hwt+I2hwtilSc4I97Wn6ixxAlhN5+ps8N5afUJYPeqa mzw3mp9QkP0u6Lye8dvljt8sBLi5ESX/2Q==\" transform=\"matrix(.3599 0 0 -.3599 88.84 64.085)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M99.2 62.9l-.5.3-.6.1-.6-.1-.6-.2-.7-.4-.6-.5-.7-.6-.7-.7-.6-.7-.6-.7-.6-.8-.7-.7-.5-.7-.6-.7-.5-.5-.5-.5 3.1.3.4.5.3.4.4.5.3.5.4.4.3.5.4.4.4.5.4.4.4.5.4.4.4.4.5.5.5.4.5.4.5.4z\"/><defs><path id=\"q\" d=\"M104.3 62.2l-.9.6-.8.4-.8.2h-.8l-.8-.2-.8-.2-.7-.4-.7-.6-.7-.6-.7-.6-.6-.8-.7-.8-.6-.8-.6-.9-.6-.8-.6-.9.5.1h.4l.3.1h1.1l.5.1.6.8.5.7.5.7.7.6.5.5.6.5.6.5.6.4.6.3.5.3.6.3.5.2.5.1.5.2h.8\"/></defs><clipPath id=\"r\"><use xlink:href=\"#q\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#r)\"><defs><path id=\"s\" d=\"M92.9 55.8h11.5v7.5H92.9z\"/></defs><clipPath id=\"t\"><use xlink:href=\"#s\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#t)\"><image overflow=\"visible\" width=\"40\" height=\"25\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHiAAACIgAAArT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwAKgMBIgACEQEDEQH/ xACfAAACAgMBAAAAAAAAAAAAAAAFBgMHAAECBAEAAgMBAAAAAAAAAAAAAAAAAwQAAgUBEAABAwME AwEAAAAAAAAAAAAAAgMEARESExQFBiEVJSQRAAAEBAQDCQAAAAAAAAAAAAABEQIQMRIDkaITQyFB siBhcaFygsJzFBIAAQMCAwkBAAAAAAAAAAAAAQARAjESUZEyIUFhoUKSAxMjM//aAAwDAQACEQMR AAAAbIAYtfZcdp263f8A1Ajps5DEWXwZquMsfIUQxRS8Q//aAAgBAgABBQBSHMsHSytO6bXSeL// 2gAIAQMAAQUAZgIW165BoU3bK5NG9SWZObv/2gAIAQEAAQUAncouNJ924U5pZTmVkCVWS2dmfdRz G7eKTXjfPHU3lPQjtNbc1kXLnTK/gHdjn8s+WfLGdvif/9oACAECAgY/ACRI1xWuWaZzc1VRUXBf /9oACAEDAgY/AISNrygDmulenY1zclAR8RMbQxuFF+J7wnt+l2l97Yr/2gAIAQEBBj8AdaJEIin3 komWAmWAmWAc8+Tk4eELrWmhUs6SExOF5zpldTK2F70s6S7F/wC34tgetpanOumrzGxkGxkGxkB/ nopXjpoi+2H/2Q==\" transform=\"matrix(.3599 0 0 -.3599 92.078 64.174)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M104.3 62.2l-.9.6-.8.4-.8.2h-.8l-.8-.2-.8-.2-.7-.4-.7-.6-.7-.6-.7-.6-.6-.8-.7-.8-.6-.8-.6-.9-.6-.8-.6-.9.5.1h.4l.3.1h1.1l.5.1.6.8.5.7.5.7.7.6.5.5.6.5.6.5.6.4.6.3.5.3.6.3.5.2.5.1.5.2h.8z\"/><defs><path id=\"u\" d=\"M107 62.1l-.9.1h-1.8l-.8-.1-.8-.2-.8-.3-.7-.3-.7-.4-.7-.4-.6-.5-.6-.5-.6-.6-.6-.7-.5-.7-.6-.7-.5-.7h.6l.6.1h1.2l.5.1h.5l.3.1h.2l.1.2.2.2.3.3.3.4.5.4.4.4.5.4.5.5.6.5.6.5.6.4.7.4.6.4.7.4.7.3\"/></defs><clipPath id=\"v\"><use xlink:href=\"#u\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#v)\"><defs><path id=\"w\" d=\"M95.8 56.1H107v6.2H95.8z\"/></defs><clipPath id=\"x\"><use xlink:href=\"#w\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#x)\"><image overflow=\"visible\" width=\"36\" height=\"21\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHPAAACBAAAAq7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAJwMBIgACEQEDEQH/ xACaAAEBAQEAAAAAAAAAAAAAAAAABQYBAQADAQEAAAAAAAAAAAAAAAAAAwQCBRAAAAQGAwEAAAAA AAAAAAAAAAMEBQERAhITFCEGFiMRAAECBAIHCQAAAAAAAAAAAAECAwAREgQhMmGS0pPTBTUgMVGx 0cIjc3QSAAEDAgMJAQAAAAAAAAAAAAABEQJBEmHxQiExgTKCogMTM0P/2gAMAwEAAhEDEQAAANVB pY8617sAVa5IEV3KFErpttQKV//aAAgBAgABBQCyMRjqFsQVO3kc5P/aAAgBAwABBQBFQniTiRiw jdKnZCY5zf/aAAgBAQABBQDsDmobU3r3Mevch69xDb2JWro7nGSCYmJhhj8u2lFGotJGNJGNJGGV KmoL/9oACAECAgY/AHQqNUyMjhgf/9oACAEDAgY/AEXyQjKTrtU+UC2yPrs5aOxr6WY/XtNe7C4/ /9oACAEBAQY/AG3bcJKlrpNQmJSJ0eEZGtU7UZGtU+sZG9U7UXinEoBt7dbyJA5k908YY+32q7HM /wAbvlDKXX024DswpYWoE0qw+NKjHUWd2/wo6izu3+FHUWd2/wAKOY0XjbtVo4lRSh0UAjMakDAa MY//2Q==\" transform=\"matrix(.3599 0 0 -.3599 94.973 63.229)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M107 62.1l-.9.1h-1.8l-.8-.1-.8-.2-.8-.3-.7-.3-.7-.4-.7-.4-.6-.5-.6-.5-.6-.6-.6-.7-.5-.7-.6-.7-.5-.7h.6l.6.1h1.2l.5.1h.5l.3.1h.2l.1.2.2.2.3.3.3.4.5.4.4.4.5.4.5.5.6.5.6.5.6.4.7.4.6.4.7.4.7.3z\"/><defs><path id=\"y\" d=\"M110.5 62.3l-.7.1-.8.1-.8-.1-.7-.2-.8-.2-.8-.3-.7-.4-.8-.5-.6-.4-.7-.6-.7-.5-.6-.6-.6-.6-.6-.6-.5-.5-.5-.6H101.3l.5.1h.4l.4.1h.3v.1l.1.1.3.3.4.3.5.4.6.5.6.4.7.5.7.5.7.6.6.4.6.5.6.4.5.3.4.2.3.2\"/></defs><clipPath id=\"z\"><use xlink:href=\"#y\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#z)\"><defs><path id=\"A\" d=\"M99.6 56.4h10.9v6.1H99.6z\"/></defs><clipPath id=\"B\"><use xlink:href=\"#A\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#B)\"><image overflow=\"visible\" width=\"36\" height=\"21\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHRAAACCAAAArD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAJwMBIgACEQEDEQH/ xACZAAEBAQEBAQAAAAAAAAAAAAAABgEEBQcBAAIDAAAAAAAAAAAAAAAAAAMFAAIEEAABBAEDBAMA AAAAAAAAAAADAAECBBQTBQYRIRIVMUEiEQAABAQEBQUAAAAAAAAAAAAAAQIDETESE6HRMgQhIpLT NGFxYiOjEgABAwIEBwAAAAAAAAAAAAAAARECQRIxYTITEKHRIkKiQ//aAAwDAQACEQMRAAAAsuPi mQtbXYraG+gPEGXbOBtQTRSCq7//2gAIAQIAAQUAnAjy8CrpLTb4X3//2gAIAQMAAQUAq0hkB60S 0Gy6vlo/pd8v/9oACAEBAAEFANxvvSXvXTb46be1Xu61Xmc5wWQZNZOss62UxJ8c5gGBVhgWGBYY FsoRw47/AP/aAAgBAgIGPwBVjJUQ1qM/c2JQpw//2gAIAQMCBj8AhOSo8n5KxjE2aX2kW3a6bWxz Pt6nk9+V3Q//2gAIAQEBBj8AbgRHcqn8YZiSccxJOOYknHMObiBfXVKXKmobOk4Rux/MazGsxqG/ cUfMm9A/ZpJjaVvtsQuwuE4dUaJW0LxHnMdL/YHnMdL/AGB5zHS/2Rv20vtuJVei6kl0pi0kuNSE q4ehD//Z\" transform=\"matrix(.3599 0 0 -.3599 98.676 63.368)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M110.5 62.3l-.7.1-.8.1-.8-.1-.7-.2-.8-.2-.8-.3-.7-.4-.8-.5-.6-.4-.7-.6-.7-.5-.6-.6-.6-.6-.6-.6-.5-.5-.5-.6H101.3l.5.1h.4l.4.1h.3v.1l.1.1.3.3.4.3.5.4.6.5.6.4.7.5.7.5.7.6.6.4.6.5.6.4.5.3.4.2.3.2z\"/><defs><path id=\"C\" d=\"M114.4 62.2l-.4.5-.6.2h-.8l-.8-.2-.9-.3-1-.5-1-.6-1-.6-.9-.7-1-.7-.8-.7-.8-.6-.6-.5-.5-.5-.3-.2-.2-.2.4.1h.8l.5.1h.9l.4.1h.5l.6.3.5.3.5.4.5.3.5.3.5.4.5.4.5.3.5.4.5.3.5.4.5.3.5.3.5.3.5.3.5.3\"/></defs><clipPath id=\"D\"><use xlink:href=\"#C\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#D)\"><defs><path id=\"E\" d=\"M102.8 56.6h11.6v6.2h-11.6z\"/></defs><clipPath id=\"F\"><use xlink:href=\"#E\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#F)\"><image overflow=\"visible\" width=\"40\" height=\"22\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHWAAACDwAAAqb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABkALAMBIgACEQEDEQH/ xACWAAEAAwADAAAAAAAAAAAAAAAGAAEHAwQFAQEBAQEAAAAAAAAAAAAAAAAEAgEFEAAABQMEAgMA AAAAAAAAAAAAAQIDBBESBRMUBhYgISQ0FREAAgEBBgUFAQAAAAAAAAAAAQIDABEhMZHRMxBBURKS MDJCssJzEgABAwQCAwEAAAAAAAAAAAABACECETGREqHRQSIyA//aAAwDAQACEQMRAAAAadDhHz1G 9h7lL70gznRnyGnxEZhenTUB3EkH/9oACAECAAEFADJVaOCirUUt9A6Xf//aAAgBAwABBQCHDYdZ /OjBcRopcfW0/khWtuf/2gAIAQEAAQUAyORax7XaIg7NEHZYoh5piY+OZfRqYqYuMcXUo8yOYocX B20obaUNtKHGGX0Zjz//2gAIAQICBj8AYr64Rd1YZVo5Qsv/2gAIAQMCBj8AE512JPlXOVD8QfSU KnnpDQDWpuVaOT0oVA31Z2o6/9oACAEBAQY/AFllUsHbtFl3K2ttsxW22YrbbMUsCIQzAm0kchbw g/r+WrGsaxNRAm7tf6nhAI0ZyJbwoJ+LdK2ZPFtK2ZPBtK2ZPBtKiZ43Ve17ypA9p6+h/9k=\" transform=\"matrix(.3599 0 0 -.3599 101.974 63.906)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M114.4 62.2l-.4.5-.6.2h-.8l-.8-.2-.9-.3-1-.5-1-.6-1-.6-.9-.7-1-.7-.8-.7-.8-.6-.6-.5-.5-.5-.3-.2-.2-.2.4.1h.8l.5.1h.9l.4.1h.5l.6.3.5.3.5.4.5.3.5.3.5.4.5.4.5.3.5.4.5.3.5.4.5.3.5.3.5.3.5.3.5.3z\"/><defs><path id=\"G\" d=\"M117.3 62.3l-.5.2-.5.1h-.5l-.4-.1-.5-.1-.6-.2-.5-.3-.6-.4-.6-.4-.7-.4-.7-.6-.8-.5-.9-.6-.9-.7-1.1-.7-1.1-.7.5.1h1.9l.4.1H109.5l.1.1.1.2.3.2.3.3.5.4.4.4.6.5.6.4.6.5.6.4.6.4.7.4.6.4.7.3.6.2.5.1\"/></defs><clipPath id=\"H\"><use xlink:href=\"#G\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#H)\"><defs><path id=\"I\" d=\"M106.4 56.9h10.9v5.6h-10.9z\"/></defs><clipPath id=\"J\"><use xlink:href=\"#I\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#J)\"><image overflow=\"visible\" width=\"36\" height=\"20\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHFAAAB7AAAAlb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAJwMBIgACEQEDEQH/ xACRAAEAAwEBAAAAAAAAAAAAAAAAAgMEAQYBAQEAAwAAAAAAAAAAAAAAAAMEAQIFEAABAwMDBQAA AAAAAAAAAAACAAEDEhMUESEEECIyQjQRAAEDAwIHAAAAAAAAAAAAAAEAEQIhcTLRMyAxkbESIpIS AAECBgEFAQAAAAAAAAAAAAABETFBYaECEhORIjKCokP/2gAMAwEAAhEDEQAAAPdQ5Rz10KB7bEFx V0EzAedYuH//2gAIAQIAAQUAmnkGTImVRWJqbnatrH//2gAIAQMAAQUAEWdqBWjVBrTuvf8A/9oA CAEBAAEFAJpnjLKJZRLKJDI5Rcrz6x/NyxYjtirYq2KjFm43/9oACAECAgY/AMkTJkRTzU2fu43e rGT6Rns9j8/ok3HVodT/2gAIAQMCBj8ARWIDVEjYnY9j/9oACAEBAQY/AAAHcOsQsQsQjNqgEtZC 3AbSUXmI05EE9luj5lot0fMtFujpJEeT0l7MV//Z\" transform=\"matrix(.3599 0 0 -.3599 105.446 63.537)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M117.3 62.3l-.5.2-.5.1h-.5l-.4-.1-.5-.1-.6-.2-.5-.3-.6-.4-.6-.4-.7-.4-.7-.6-.8-.5-.9-.6-.9-.7-1.1-.7-1.1-.7.5.1h1.9l.4.1H109.5l.1.1.1.2.3.2.3.3.5.4.4.4.6.5.6.4.6.5.6.4.6.4.7.4.6.4.7.3.6.2.5.1z\"/><defs><path id=\"K\" d=\"M119.4 62l-.7.2-.7.1h-.7l-.8-.2-.8-.3-.8-.4-.8-.4-.7-.5-.7-.6-.7-.5-.7-.5-.5-.5-.5-.5-.4-.3-.3-.3-.1-.2.4.1h.9l.4.1h.8l.5.1h.5l.3.3.4.3.3.4.4.3.4.4.4.3.4.4.4.3.4.3.4.3.4.3.4.3.5.2.4.2.4.2.5.1\"/></defs><clipPath id=\"L\"><use xlink:href=\"#K\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#L)\"><defs><path id=\"M\" d=\"M109.5 57.1h9.9v5.2h-9.9z\"/></defs><clipPath id=\"N\"><use xlink:href=\"#M\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#N)\"><image overflow=\"visible\" width=\"36\" height=\"18\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHBAAAB5wAAAj3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABMAJwMBIgACEQEDEQH/ xACVAAEBAAIDAAAAAAAAAAAAAAAABAECAwUGAQEBAAMAAAAAAAAAAAAAAAADAgEEBRAAAQMCBQUA AAAAAAAAAAAAAAECAxETQRIiBBQhMTJCJBEAAQEHAgcAAAAAAAAAAAAAABEBMUGREqJDoQIggbHB MmKCEgABAgMJAQAAAAAAAAAAAAAAAQIQMYERIUFhkTJCgkMz/9oADAMBAAIRAxEAAAD3XEl57Upc HfaNXS19Jw7wJzaHL//aAAgBAgABBQCeSRJbsp6v8jD/2gAIAQMAAQUAYxFbbQxb2Mf/2gAIAQEA AQUAnlcxeTIcmQ5UhmW3vXUXOZxXlfn3VK6TQaDpZ//aAAgBAgIGPwByI5yJdjkb3anUX5dpnhD/ 2gAIAQMCBj8ARbCRU50kekP/2gAIAQEBBj8AZTEhIeyQ9kiqNK6GznwL6djatEfNdEMNxguMFxBK fl3Q/9k=\" transform=\"matrix(.3599 0 0 -.3599 108.59 63.169)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M119.4 62l-.7.2-.7.1h-.7l-.8-.2-.8-.3-.8-.4-.8-.4-.7-.5-.7-.6-.7-.5-.7-.5-.5-.5-.5-.5-.4-.3-.3-.3-.1-.2.4.1h.9l.4.1h.8l.5.1h.5l.3.3.4.3.3.4.4.3.4.4.4.3.4.4.4.3.4.3.4.3.4.3.4.3.5.2.4.2.4.2.5.1z\"/><defs><path id=\"O\" d=\"M121.9 61.2l-.5.4-.6.2-.6.1-.6.1-.5-.1-.6-.2-.6-.3-.6-.3-.5-.4-.6-.4-.5-.5-.6-.5-.5-.5-.5-.5-.6-.5-.5-.4h.7l.4.1h.4l.4.1h.9l.5.1.1.3.2.4.2.3.3.3.3.3.3.3.3.3.4.2.4.2.4.2.4.2.4.2.5.1.5.1h.4l.5.1\"/></defs><clipPath id=\"P\"><use xlink:href=\"#O\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#P)\"><defs><path id=\"Q\" d=\"M113 57.4h8.9V62H113z\"/></defs><clipPath id=\"R\"><use xlink:href=\"#Q\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#R)\"><image overflow=\"visible\" width=\"32\" height=\"17\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG4AAAB3AAAAjD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABMAJAMBIgACEQEDEQH/ xACKAAEBAAMBAAAAAAAAAAAAAAAABAECAwYBAQEBAQEAAAAAAAAAAAAAAAMEAgEFEAABAwQDAQAA AAAAAAAAAAABAAIDESITBDESMhQRAAAFAgYDAAAAAAAAAAAAAAAQARExAhIhcaEyQqJBwcISAAED AwUAAAAAAAAAAAAAAAEAEDERQQKBMkKCM//aAAwDAQACEQMRAAAA95zzLEtOZdz7cPRGeUlVuY1e LQ//2gAIAQIAAQUA2J5GSN2ZS5Te28r/2gAIAQMAAQUAY0EFjaJnk8L/2gAIAQEAAQUAlkxj6gvq CbshzltGyoVQoiMi26dLFYoumVf/2gAIAQICBj8AOOJoKCyAOUkWDHy7yh4TZv/aAAgBAwIGPwCp ChueiO9v/9oACAEBAQY/AEVnfAbdRt1CU2zhJJmdOaFS7T5f5HHuOPcUtbKRd7L/2Q==\" transform=\"matrix(.3599 0 0 -.3599 111.971 62.77)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M121.9 61.2l-.5.4-.6.2-.6.1-.6.1-.5-.1-.6-.2-.6-.3-.6-.3-.5-.4-.6-.4-.5-.5-.6-.5-.5-.5-.5-.5-.6-.5-.5-.4h.7l.4.1h.4l.4.1h.9l.5.1.1.3.2.4.2.3.3.3.3.3.3.3.3.3.4.2.4.2.4.2.4.2.4.2.5.1.5.1h.4l.5.1z\"/><defs><path id=\"S\" d=\"M124.2 60.7l-.5.2-.5.2-.6.1h-.6l-.5-.1h-.7l-.6-.2-.6-.2-.5-.2-.6-.3-.5-.3-.4-.4-.4-.4-.4-.5-.2-.4-.2-.5h.7l.3.1h.8l.4.1h.9l.2.3.2.3.3.3.2.2.2.2.3.2.3.2.2.2.3.1.3.1.3.2.4.1.3.1.4.1.4.1.4.1\"/></defs><clipPath id=\"T\"><use xlink:href=\"#S\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#T)\"><defs><path id=\"U\" d=\"M116.4 57.7h7.8v3.5h-7.8z\"/></defs><clipPath id=\"V\"><use xlink:href=\"#U\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#V)\"><image overflow=\"visible\" width=\"28\" height=\"13\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGmAAABxgAAAg//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABEAHwMBIgACEQEDEQH/ xACEAAEAAgMAAAAAAAAAAAAAAAAAAwQBBQYBAAIDAAAAAAAAAAAAAAAAAAADAQIEEAADAAIDAQAA AAAAAAAAAAABAgMABBATFCARAAICAQMFAAAAAAAAAAAAAAERAAIyICESYXEiEzMSAAEDAwUAAAAA AAAAAAAAAAEAEVEQIQIxQaESIv/aAAwDAQACEQMRAAAA7uPFXI63LrrtosDSoA//2gAIAQIAAQUA rSweD1ZuP//aAAgBAwABBQBEQrRVA4//2gAIAQEAAQUArYSz2JntTBUGW4lHPRsZ0bGIjjU+P//a AAgBAgIGPwAjF+u3lEZ6NDV//9oACAEDAgY/AASeVaZr/9oACAEBAQY/AAw3MTMTPatkSu0rwqbJ tTAz5mGhHnxsF130/wD/2Q==\" transform=\"matrix(.3599 0 0 -.3599 115.594 61.923)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M124.2 60.7l-.5.2-.5.2-.6.1h-.6l-.5-.1h-.7l-.6-.2-.6-.2-.5-.2-.6-.3-.5-.3-.4-.4-.4-.4-.4-.5-.2-.4-.2-.5h.7l.3.1h.8l.4.1h.9l.2.3.2.3.3.3.2.2.2.2.3.2.3.2.2.2.3.1.3.1.3.2.4.1.3.1.4.1.4.1.4.1z\"/><defs><path id=\"W\" d=\"M125.4 60.3l-.2.2-.3.1-.3.1h-.7l-.5-.1-.4-.2-.5-.1-.4-.2-.5-.3-.4-.2-.5-.3-.4-.3-.3-.4-.3-.3-.2-.4.3.1h.7l.3.1H121.4v.1l.3.2.4.4.6.3.7.4.7.4.7.3.6.1\"/></defs><clipPath id=\"X\"><use xlink:href=\"#W\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#X)\"><defs><path id=\"Y\" d=\"M119.5 57.9h5.9v2.8h-5.9z\"/></defs><clipPath id=\"Z\"><use xlink:href=\"#Y\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#Z)\"><image overflow=\"visible\" width=\"24\" height=\"11\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGWAAABsAAAAe3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA4AHAMBIgACEQEDEQH/ xAB9AAADAQAAAAAAAAAAAAAAAAACAwQGAQEBAQAAAAAAAAAAAAAAAAACAAQQAAIDAAIDAAAAAAAA AAAAAAEDAAISESITBBQRAAIBBAMBAAAAAAAAAAAAAAERABBRAhIhkTIzEgACAgEFAAAAAAAAAAAA AAAAASExEUFhEiIj/9oADAMBAAIRAxEAAADdASsra+ehX//aAAgBAgABBQBg9nYD/F//2gAIAQMA AQUAGOOuv//aAAgBAQABBQBzis/VaKeb3j6rJwiJqoXn/9oACAECAgY/AHwfXShpv0zFUf/aAAgB AwIGPwCbNj//2gAIAQEBBj8AAAbnkTUhUG+WtuHPoeo8c2bKn//Z\" transform=\"matrix(.3599 0 0 -.3599 118.514 61.502)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M125.4 60.3l-.2.2-.3.1-.3.1h-.7l-.5-.1-.4-.2-.5-.1-.4-.2-.5-.3-.4-.2-.5-.3-.4-.3-.3-.4-.3-.3-.2-.4.3.1h.7l.3.1H121.4v.1l.3.2.4.4.6.3.7.4.7.4.7.3.6.1z\"/><defs><path id=\"aa\" d=\"M126.2 59.5l-.1.4-.1.3-.2.1-.3.1-.4-.1-.4-.1-.5-.2-.4-.2-.5-.3-.4-.3-.5-.3-.3-.2-.3-.3-.2-.1-.2-.1v-.1l2.2.3.2.1.3.1.3.2.4.2.4.2.4.1.3.1.3.1\"/></defs><clipPath id=\"ab\"><use xlink:href=\"#aa\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ab)\"><defs><path id=\"ac\" d=\"M121.4 58.1h4.8v2.3h-4.8z\"/></defs><clipPath id=\"ad\"><use xlink:href=\"#ac\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ad)\"><image overflow=\"visible\" width=\"20\" height=\"10\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGZAAABrgAAAe7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAsAFgMBIgACEQEDEQH/ xACCAAEBAQAAAAAAAAAAAAAAAAADAAYBAQEBAAAAAAAAAAAAAAAAAAMCBBAAAgICAgMAAAAAAAAA AAAAAgMAAREhMRITQxQRAAECBQUAAAAAAAAAAAAAAAABETGhwRJCAjKCwkMSAAECBQUAAAAAAAAA AAAAAAEAAhExUaEyIXHBQjP/2gAMAwEAAhEDEQAAANyTHkRaln//2gAIAQIAAQUAaDLPBT//2gAI AQMAAQUAG6xqf//aAAgBAQABBQB7DC/obO5eB3Op6f/aAAgBAgIGPwAlr3NFAHcLI+UJHKu91//a AAgBAwIGPwDUCyl2X//aAAgBAQEGPwDTarORkX5NUTZzPKZj1if/2Q==\" transform=\"matrix(.3599 0 0 -.3599 120.655 61.105)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M126.2 59.5l-.1.4-.1.3-.2.1-.3.1-.4-.1-.4-.1-.5-.2-.4-.2-.5-.3-.4-.3-.5-.3-.3-.2-.3-.3-.2-.1-.2-.1v-.1l2.2.3.2.1.3.1.3.2.4.2.4.2.4.1.3.1.3.1z\"/><defs><path id=\"ae\" d=\"M123.6 58.4h1.3l.4.1h.7l.4.1.4.1v.5l-.3.3h-.4l-.5-.2-.5-.2-.6-.3-.5-.3-.4-.1\"/></defs><clipPath id=\"af\"><use xlink:href=\"#ae\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#af)\"><defs><path id=\"ag\" d=\"M123.6 58.4h3.2v1.1h-3.2z\"/></defs><clipPath id=\"ah\"><use xlink:href=\"#ag\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ah)\"><image overflow=\"visible\" width=\"16\" height=\"7\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGHAAABmQAAAcj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAgAEwMBIgACEQEDEQH/ xAB0AAEAAwAAAAAAAAAAAAAAAAAAAwQGAQEAAAAAAAAAAAAAAAAAAAADEAABBAMAAAAAAAAAAAAA AAADAAERAhITBBEAAgEFAAAAAAAAAAAAAAAAEQIBABBBEhMSAAEEAwAAAAAAAAAAAAAAABABETGB MkJD/9oADAMBAAIRAxEAAADdRgJaDn//2gAIAQIAAQUAtOxf/9oACAEDAAEFAGjFf//aAAgBAQAB BQDouarCJ1ORf//aAAgBAgIGPwDozpGI/9oACAEDAgY/ANbkf//aAAgBAQEGPwBeS7Emoh0C5kW/ /9k=\" transform=\"matrix(.3599 0 0 -.3599 122.84 60.22)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M123.6 58.4h1.3l.4.1h.7l.4.1.4.1v.5l-.3.3h-.4l-.5-.2-.5-.2-.6-.3-.5-.3-.4-.1z\"/><defs><path id=\"ai\" d=\"M123.7 58.1l.5.1h.4l.4.1.4.1h.3l.4.1.4.1.4.1v-.6l-.2-.4-.4-.2h-.6l-.6.1-.5.2-.5.2-.4.1\"/></defs><clipPath id=\"aj\"><use xlink:href=\"#ai\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aj)\"><defs><path id=\"ak\" d=\"M123.7 57.5h3.2v1.2h-3.2z\"/></defs><clipPath id=\"al\"><use xlink:href=\"#ak\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#al)\"><image overflow=\"visible\" width=\"16\" height=\"7\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGCAAABkgAAAb//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAgAEwMBIgACEQEDEQH/ xABvAAEAAwAAAAAAAAAAAAAAAAAAAwQGAQEBAAAAAAAAAAAAAAAAAAACBBAAAgMBAAAAAAAAAAAA AAAAAgMAARITEQEAAgMBAAAAAAAAAAAAAAABEQIAEEESEgADAQEAAAAAAAAAAAAAAAAQESESMf/a AAwDAQACEQMRAAAA3kZO7AoH/9oACAECAAEFAD6dJ//aAAgBAwABBQCs5n//2gAIAQEAAQUAcwgo HsI5/9oACAECAgY/AJvM4kP/2gAIAQMCBj8AqY//2gAIAQEBBj8AGtfU4VaQPYdf/9k=\" transform=\"matrix(.3599 0 0 -.3599 122.885 59.45)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M123.7 58.1l.5.1h.4l.4.1.4.1h.3l.4.1.4.1.4.1v-.6l-.2-.4-.4-.2h-.6l-.6.1-.5.2-.5.2-.4.1z\"/><defs><path id=\"am\" d=\"M93.8 46.4l-1.2-.5-1.2-.3-1.2-.1-1 .1-1.1.2-.9.3-.9.5-.9.6-.9.6-.8.7-.8.7-.8.8-.8.7-.8.7-.8.6-.9.6.3.1h.3l.3.1h.6l.4.1h.6l.3.1h.7l.3.1h.4l.3.1h.8l.2-.4.4-.4.4-.6.6-.6.5-.6.6-.7.7-.6.6-.6.7-.6.8-.5.7-.4.7-.4.7-.3.8-.2h.7l.6.1\"/></defs><clipPath id=\"an\"><use xlink:href=\"#am\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#an)\"><defs><path id=\"ao\" d=\"M78.8 45.5h15v7.7h-15z\"/></defs><clipPath id=\"ap\"><use xlink:href=\"#ao\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ap)\"><image overflow=\"visible\" width=\"48\" height=\"26\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHkAAACLgAAAtv/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwANQMBIgACEQEDEQH/ xACWAAADAQEBAAAAAAAAAAAAAAAABQYEAwcBAAMBAQAAAAAAAAAAAAAAAAIEBQMGEAABBAEEAwEA AAAAAAAAAAAAAQIDBAURFQYWEBIzMREAAAQDBwQDAAAAAAAAAAAAAAERAiESAxAxoTKSEwRRsSJy ILIVEgACAAUCBwEAAAAAAAAAAAABAgAQESEx0QNBUWGRobEygv/aAAwDAQACEQMRAAAApELOUOk5 E4Ljnqh1Afo4Bc9MyvoWMbcborumbEvue9MVdYDkb//aAAgBAgABBQBFaiK5BXp4XUcjxWrqf//a AAgBAwABBQCrWa+JtGIdTgRpRke2u6WySvsaH//aAAgBAQABBQDk2VuY1nbMydszB2zMHa8uVOT5 WW0c1+Wnn9MfFIt05p8kRVGVpHEdBVIqKIU6nrYMntWjerjevCbIJtAzb/Y//9oACAECAgY/ALgR gTtGRAqw8y//2gAIAQMCBj8AVioNa+4+F7QxKJg8JIF2Wf6uGUDPUxbYYfpNYNdthbmNZf/aAAgB AQEGPwDju4ptI6huJ0xTZSJO4zU9BDNT0EM1PQQzU9BCjSe5kr6jWuRhXOMiOziez+zfhAcc0gVV n2Kziez+zRAlFyCMRcKRpc9p42U/0pEU9vc6wVB47OI8drEQ28RDbBSSTLBOtn//2Q==\" transform=\"matrix(.3599 0 0 -.3599 77.78 54.184)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M93.8 46.4l-1.2-.5-1.2-.3-1.2-.1-1 .1-1.1.2-.9.3-.9.5-.9.6-.9.6-.8.7-.8.7-.8.8-.8.7-.8.7-.8.6-.9.6.3.1h.3l.3.1h.6l.4.1h.6l.3.1h.7l.3.1h.4l.3.1h.8l.2-.4.4-.4.4-.6.6-.6.5-.6.6-.7.7-.6.6-.6.7-.6.8-.5.7-.4.7-.4.7-.3.8-.2h.7l.6.1z\"/><defs><path id=\"aq\" d=\"M96 46.9l-.7-.3-.7-.1-.7-.2H92.6l-.7.2-.7.2-.7.3-.7.4-.7.5-.7.6-.8.8-.9.8-.8.9-.9 1.1-.9 1.2h.5l.5.1h.8l.4.1.4.1h.5l.6.1.5-.4.5-.5.5-.4.5-.5.4-.5.5-.5.5-.5.5-.5.5-.5.5-.4.5-.4.5-.4.5-.4.6-.3.6-.4.6-.2\"/></defs><clipPath id=\"ar\"><use xlink:href=\"#aq\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ar)\"><defs><path id=\"as\" d=\"M84.1 46.3H96v7.4H84.1z\"/></defs><clipPath id=\"at\"><use xlink:href=\"#as\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#at)\"><image overflow=\"visible\" width=\"40\" height=\"24\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHjAAACHQAAArL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwAKgMBIgACEQEDEQH/ xACeAAACAgMBAAAAAAAAAAAAAAAFBgAHAQIDBAEBAQADAAAAAAAAAAAAAAAAAwIAAQQQAAEDAgUE AwAAAAAAAAAAAAABAgMEBhESFAUlEBM1FiEjNBEAAQIDBAoDAQAAAAAAAAAAAgEDABESECGScyBB cbGCosITQzRCBBQkEgABAwMCBwAAAAAAAAAAAAAAAREhMVESAiJhgTJiggMT/9oADAMBAAIRAxEA AAA+O84HsZmizndPJ5NcgxFA2hos1rtZEPsWXHh3Gf/aAAgBAgABBQCOJisWKJDBncY5+R6yHzj/ AP/aAAgBAwABBQBrW4NiRx2ftYq4RSKhndq//9oACAEBAAEFAN8uWfa633iqPeKo94qjYLhm3apL y8v0RpZaYV5eXl0QRoiFmfuJtDn4s4s4wh0mY//aAAgBAgIGPwDSqpVCdJTbYRtDxV0JRjif/9oA CAEDAgY/AEghDDtcTa/Mj1P5oZfOcOjJLXP/2gAIAQEBBj8AT6zbIOCoIdRKqLeqpq2R6reIo9Vv EUeq3iKHGXGRbQArRRVVneia9tg5Iby0H8rqGwckN5aD+V1DZ/R2q5fOmcuKPByR4OSPByQv5+3V K+imcuGz/9k=\" transform=\"matrix(.3599 0 0 -.3599 83.306 54.51)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M96 46.9l-.7-.3-.7-.1-.7-.2H92.6l-.7.2-.7.2-.7.3-.7.4-.7.5-.7.6-.8.8-.9.8-.8.9-.9 1.1-.9 1.2h.5l.5.1h.8l.4.1.4.1h.5l.6.1.5-.4.5-.5.5-.4.5-.5.4-.5.5-.5.5-.5.5-.5.5-.5.5-.4.5-.4.5-.4.5-.4.6-.3.6-.4.6-.2z\"/><defs><path id=\"au\" d=\"M98.4 47.5l-.5-.4-.6-.3h-.7l-.7.1-.7.3-.7.4-.7.5-.8.6-.7.7-.8.7-.7.7-.7.7-.6.6-.7.7-.5.5-.5.4 3.1.4.4-.5.4-.4.4-.5.4-.5.4-.4.4-.5.4-.5.4-.4.5-.4.4-.5.5-.4.5-.3.6-.4.6-.3.6-.3.6-.3\"/></defs><clipPath id=\"av\"><use xlink:href=\"#au\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#av)\"><defs><path id=\"aw\" d=\"M87.8 46.8h10.6v7.3H87.8z\"/></defs><clipPath id=\"ax\"><use xlink:href=\"#aw\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ax)\"><image overflow=\"visible\" width=\"36\" height=\"25\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHWAAACEAAAAo7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwAJwMBIgACEQEDEQH/ xACcAAACAgMBAAAAAAAAAAAAAAAABAEGAgMFBwEAAgMBAAAAAAAAAAAAAAAAAwUAAgQGEAAABgAG AQUAAAAAAAAAAAAAAQIDBAUQEUETIxYSIhQkNQYRAAEBBAkEAwAAAAAAAAAAAAACAREhAzFBodES QpIzBBBxwWKBsXMSAAECBgEFAAAAAAAAAAAAAAEAAhARITGBA5ESMoKiM//aAAwDAQACEQMRAAAA eWVTj7rHK3UN6MQX5ykYXwC7pzNokIYMjYq//9oACAECAAEFADUQNZFgpJg0ENP/2gAIAQMAAQUA Zhtmj2kchql2ZtrXKGv/2gAIAQEAAQUAsv0VtHsO03Q7RcjtFyPNWxc/agkKUERHFDL49pEU5aNw CDcIiDcMZcR7WfEOMejD/9oACAECAgY/ALR7pYX09TD/2gAIAQMCBj8AaSxpm0GyqzXwFlNlop0i RD22VdRHkIf/2gAIAQEBBj8A5EiVNSyXLmKSlmBLYMb2N5OhNxvJ0JuN5OhNxjzYH/Ljl/qv76QY RgO9PBylVNmqbaUFBQO9fBHC+t7jLYZbCqzp/9k=\" transform=\"matrix(.3599 0 0 -.3599 87.055 55.086)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M98.4 47.5l-.5-.4-.6-.3h-.7l-.7.1-.7.3-.7.4-.7.5-.8.6-.7.7-.8.7-.7.7-.7.7-.6.6-.7.7-.5.5-.5.4 3.1.4.4-.5.4-.4.4-.5.4-.5.4-.4.4-.5.4-.5.4-.4.5-.4.4-.5.5-.4.5-.3.6-.4.6-.3.6-.3.6-.3z\"/><defs><path id=\"ay\" d=\"M103.1 49.5l-.8-.8-.9-.6-.8-.4-.8-.2-.8-.1-.8.1-.7.3-.8.4-.7.5-.8.6-.7.7-.7.8-.7.7-.7.9-.7.8-.7.8.6.1h.8l.4.1h.3l.4.1.4.1h.5l.6-.7.6-.7.6-.7.6-.5.6-.5.5-.4.6-.3.6-.3.5-.2.5-.2.6-.1.5-.2h.5l.5-.1h.9\"/></defs><clipPath id=\"az\"><use xlink:href=\"#ay\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#az)\"><defs><path id=\"aA\" d=\"M91 47.4h12.1v7H91z\"/></defs><clipPath id=\"aB\"><use xlink:href=\"#aA\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aB)\"><image overflow=\"visible\" width=\"40\" height=\"24\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHZAAACDQAAApP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABkAKgMBIgACEQEDEQH/ xACZAAADAQEBAAAAAAAAAAAAAAAABQYHAgMBAQEBAQAAAAAAAAAAAAAAAAMEAgUQAAEDBAEBCQAA AAAAAAAAAAEAAgMREgUGBBQQICExIjQVNRYRAAECBAUEAwAAAAAAAAAAAAIBAwARsQQQkjNz0yAw IUESchMSAAEEAQIFBQAAAAAAAAAAAAEAEQISITFREEHBIoLC0gMTk//aAAwDAQACEQMRAAAAdLvF NXQ/6QdFZavZGuI4VNqYusuNRA6MpVhmL//aAAgBAgABBQBrI7HlgVRX12uqvG3/2gAIAQMAAQUA jjuEXDaV07Os4xNsbpVWX5H/2gAIAQEAAQUAzuy87G5D9rlUN0yqG55Ra9nOXlJlt/3IagEAtM90 ttFcyB2ea06JzJ+//9oACAECAgY/AIkgaLACdDZuP//aAAgBAwIGPwAYWYuvqr21dvF1FowOOciP SsQ+L9D7E9YXrpY1au7dF//aAAgBAQEGPwBbVhtogQRKZoSlNfqaRpW+U+SNK3ynyRpMZT5IebuA bFGxQk/NCRZqsvPyIsC2wp0XO2NcC2wpjJIuCL2CV7H/2Q==\" transform=\"matrix(.3599 0 0 -.3599 90.203 55.353)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M103.1 49.5l-.8-.8-.9-.6-.8-.4-.8-.2-.8-.1-.8.1-.7.3-.8.4-.7.5-.8.6-.7.7-.7.8-.7.7-.7.9-.7.8-.7.8.6.1h.8l.4.1h.3l.4.1.4.1h.5l.6-.7.6-.7.6-.7.6-.5.6-.5.5-.4.6-.3.6-.3.5-.2.5-.2.6-.1.5-.2h.5l.5-.1h.9z\"/><defs><path id=\"aC\" d=\"M106.5 50.3l-1-.3-.9-.3-.9-.1-.8-.1h-.8l-.8.1-.8.2-.7.2-.8.4-.7.4-.7.4-.7.5-.6.6-.6.6-.7.7-.6.8.6.1.7.1h.7l.7.1.6.1.5.1H98.8v-.1l.2-.1.2-.2.2-.2.3-.3.4-.4.4-.3.5-.4.6-.4.5-.4.7-.4.7-.4.6-.3.8-.3.8-.2.8-.2\"/></defs><clipPath id=\"aD\"><use xlink:href=\"#aC\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aD)\"><defs><path id=\"aE\" d=\"M94.4 49.5h12v5.4h-12z\"/></defs><clipPath id=\"aF\"><use xlink:href=\"#aE\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aF)\"><image overflow=\"visible\" width=\"40\" height=\"19\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHYAAACFgAAAsf/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAKgMBIgACEQEDEQH/ xACaAAADAQEAAAAAAAAAAAAAAAAAAwYEBQEAAwEBAAAAAAAAAAAAAAAAAQIDBAUQAAAGAQUBAQAA AAAAAAAAAAABAgMEBRMREiIGFhQ0EQABAgUBBQkAAAAAAAAAAAABAgMAESESBBAxUZLSNEFh0SKC ssJzgxIAAAUBBgcBAAAAAAAAAAAAAAERAhIxIYEyQmITQdGSoiNDFET/2gAMAwEAAhEDEQAAAKbn Knx2qUntCWoqKRrlyz+ECXvCCa+qBzf/2gAIAQIAAQUANREDcIhlLavTU9o44//aAAgBAwABBQCL BZcZOFDSMMX6WN+Be8csv//aAAgBAQABBQC7v11Uj2jo9o6PaOit7S5OmjuX7iSZhEZxQbgGYpYh N2A7AxVuy24lCQRGpwhiqENqCl8f/9oACAECAgY/ABUS1IOF6jJ3DJj1JQf/2gAIAQMCBj8AY9zV NxWmpi1pdR8xGHj2lRTxSqGJ9KJl243LaP0XwHswaZVH/9oACAEBAQY/AG2UsB0LRfMqtlUjcd0d InjPLHSJ4zyx0ieM8sNYpxggOki4LJlIE7Le7Rj6vkqKCcbJRWsMLA2E+06NKzcosOBuSU2KXNMz WaY8ucT+SvCKZhP5qimVP0KhBaevX2C0idNP/9k=\" transform=\"matrix(.3599 0 0 -.3599 93.405 55.648)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M106.5 50.3l-1-.3-.9-.3-.9-.1-.8-.1h-.8l-.8.1-.8.2-.7.2-.8.4-.7.4-.7.4-.7.5-.6.6-.6.6-.7.7-.6.8.6.1.7.1h.7l.7.1.6.1.5.1H98.8v-.1l.2-.1.2-.2.2-.2.3-.3.4-.4.4-.3.5-.4.6-.4.5-.4.7-.4.7-.4.6-.3.8-.3.8-.2.8-.2z\"/><defs><path id=\"aG\" d=\"M110.7 50.8l-.8-.3-.7-.2-.9-.1h-.8l-.8.1-.8.1-.8.3-.9.3-.7.4-.8.4-.8.5-.7.5-.7.5-.6.5-.6.6-.6.5.4.1h.5l.5.1h.5l.6.1h.5l.4.1h.3v-.1l.1-.1.3-.2.5-.3.5-.3.6-.4.7-.4.7-.4.7-.4.7-.4.8-.4.7-.3.6-.3.6-.3.5-.1.3-.1\"/></defs><clipPath id=\"aH\"><use xlink:href=\"#aG\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aH)\"><defs><path id=\"aI\" d=\"M98.7 50.2h12v5.1h-12z\"/></defs><clipPath id=\"aJ\"><use xlink:href=\"#aI\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aJ)\"><image overflow=\"visible\" width=\"40\" height=\"18\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHZAAACEAAAArb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABMALAMBIgACEQEDEQH/ xACeAAADAQEAAAAAAAAAAAAAAAAABQYCBAEAAwEAAAAAAAAAAAAAAAAAAgMEBRAAAAUCBAcAAAAA AAAAAAAAAAECAwUEBhEyExQQMRIjMyQWEQABAQMJCAMAAAAAAAAAAAABAgARAxAhMRKS0hMEFEFR scEygqRFUnJjEgABAwEGBwEAAAAAAAAAAAABABECQRAxgTKCMyFREkIDEzRE/9oADAMBAAIRAxEA AAClRsJRmg8Em1aNJVRtkEiREDJTsAHM3IDJ/9oACAECAAEFACNJJUogThGkKBZP/9oACAEDAAEF AKWmS4hFEwRON0+9YyK5H5f/2gAIAQEAAQUAuSXq4tBXhLj6+WH10qIm5JGskBepdrDg20tw4Ck0 5AXJo9Hpj0wxtsKDS3A//9oACAECAgY/AA4D2GXItZ2akdu+mXFf/9oACAEDAgY/ABIh3dPKEV4o CEfWYHqFCeKH112suC/fquQ3rq58F//aAAgBAQEGPwDLqywQTFKgquCelznOI3tRBsm81EKybzUQ rJvNBy0UQ8OISFVUkGYE/KTKfZfBMrgJt7QFunBM/aZMvi6elTtTiu2dODzb1vlN63ymDtB26jmy Kunf+eJWo2V5pP/Z\" transform=\"matrix(.3599 0 0 -.3599 97.782 56.283)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M110.7 50.8l-.8-.3-.7-.2-.9-.1h-.8l-.8.1-.8.1-.8.3-.9.3-.7.4-.8.4-.8.5-.7.5-.7.5-.6.5-.6.6-.6.5.4.1h.5l.5.1h.5l.6.1h.5l.4.1h.3v-.1l.1-.1.3-.2.5-.3.5-.3.6-.4.7-.4.7-.4.7-.4.7-.4.8-.4.7-.3.6-.3.6-.3.5-.1.3-.1z\"/><defs><path id=\"aK\" d=\"M114.7 51.6l-.4-.6-.6-.4-.7-.1h-.9l-.9.2-1.1.3-1 .4-1.1.5-1.1.6-1 .6-.9.5-.9.5-.7.5-.6.4-.3.2-.2.1.4.1h.4l.5.1h.6l.5.1h.5l.6.1.5.1.5-.2.5-.3.6-.3.5-.3.5-.2.5-.3.6-.3.5-.3.5-.3.5-.2.6-.3.5-.2.5-.3.6-.2.5-.3.5-.2\"/></defs><clipPath id=\"aL\"><use xlink:href=\"#aK\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aL)\"><defs><path id=\"aM\" d=\"M102.3 50.5h12.5v5.3h-12.5z\"/></defs><clipPath id=\"aN\"><use xlink:href=\"#aM\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aN)\"><image overflow=\"visible\" width=\"40\" height=\"19\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHaAAACFwAAArj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAKgMBIgACEQEDEQH/ xACaAAADAQEBAAAAAAAAAAAAAAAABQYEAwEBAAMBAQAAAAAAAAAAAAAAAAECAwQFEAABBAICAwEA AAAAAAAAAAAEAAECAxMFEgYRIhYhEQACAQIDBQkAAAAAAAAAAAABAgMAERAhBDHRgpI0QVGRsRIi YtIzEgAAAwQJBQAAAAAAAAAAAAAAARExAhJCECFRYSIyYqIToYIDM0P/2gAMAwEAAhEDEQAAAKxf mQr2Kf2f1yo+dTFOMqTAAbv3CCa2INn/AP/aAAgBAgABBQCU2ZPczLN62+OT8V64v//aAAgBAwAB BQAUIedEhAorCNno5YZ8l+5P/9oACAEBAAEFANtvatXZ9mKvsxU3chnQXZKyyF3KMpFQFskqwPKr BZlrBeBi31Qll8B9eoUAqFQaGgM1q//aAAgBAgIGPwCiLUgNnUS7hL7NVg//2gAIAQMCBj8Ac8j5 VvEa4jtGUz7jEMODjVIjaocTlZLCjb6x9dony3KP/9oACAEBAQY/AI45ImkMilgVIFrG3bXTScwr pn5hWWmk8RUcC6d0MhsGJFhhprC/sbzrurPOtlQtbY2EJnnELBT6QVZri/xBrLVqeB/rXUqeF91f uDwtupSkgZr5Cxw//9k=\" transform=\"matrix(.3599 0 0 -.3599 101.552 56.866)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M114.7 51.6l-.4-.6-.6-.4-.7-.1h-.9l-.9.2-1.1.3-1 .4-1.1.5-1.1.6-1 .6-.9.5-.9.5-.7.5-.6.4-.3.2-.2.1.4.1h.4l.5.1h.6l.5.1h.5l.6.1.5.1.5-.2.5-.3.6-.3.5-.3.5-.2.5-.3.6-.3.5-.3.5-.3.5-.2.6-.3.5-.2.5-.3.6-.2.5-.3.5-.2z\"/><defs><path id=\"aO\" d=\"M119.9 53l-.7-.4-.7-.3-.7-.1h-.8l-.9.1-.8.3-.8.3-.9.4-.8.4-.7.4-.7.5-.6.4-.6.4-.4.3-.3.3-.2.1.5.1h.4l.4.1h.8l.3.1h.5l.4.1.4-.3.4-.2.5-.3.4-.3.4-.3.5-.4.5-.3.4-.3.5-.2.5-.3.5-.2.4-.2.5-.1.5-.1h.9\"/></defs><clipPath id=\"aP\"><use xlink:href=\"#aO\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aP)\"><defs><path id=\"aQ\" d=\"M109.3 52.2h10.6v4.3h-10.6z\"/></defs><clipPath id=\"aR\"><use xlink:href=\"#aQ\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aR)\"><image overflow=\"visible\" width=\"36\" height=\"16\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG2AAAB2QAAAiz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABMAJwMBIgACEQEDEQH/ xACOAAEAAwEBAAAAAAAAAAAAAAAAAQIDBAYBAAMBAQAAAAAAAAAAAAAAAAECAwQFEAABAwMDBQAA AAAAAAAAAAADAAECEgQUEBFBICETMyQRAAEDAgUFAAAAAAAAAAAAAAEAQQIRoRAhccEyMWGBEgMS AAIABAcAAAAAAAAAAAAAAAABEUESMhAgIWGBAhP/2gAMAwEAAhEDEQAAAPbZaY8+9lSHrQ3R1FFA GQw//9oACAECAAEFACnJEmSRVP4dOP/aAAgBAwABBQCLRppgu1ev/9oACAEBAAEFALm5IKecZZ5l nmUDSlbXXs2ZbMtmQ2+V+jj/2gAIAQICBj8A7JPRMuZVPzq5gSJYf//aAAgBAwIGPwBRRabVZP/a AAgBAQEGPwARjEEEVz1XCN1wjdcI3R+pA9qSNGyqhpuceiI7S3TeUyZNh//Z\" transform=\"matrix(.3599 0 0 -.3599 108.317 57.482)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M119.9 53l-.7-.4-.7-.3-.7-.1h-.8l-.9.1-.8.3-.8.3-.9.4-.8.4-.7.4-.7.5-.6.4-.6.4-.4.3-.3.3-.2.1.5.1h.4l.4.1h.8l.3.1h.5l.4.1.4-.3.4-.2.5-.3.4-.3.4-.3.5-.4.5-.3.4-.3.5-.2.5-.3.5-.2.4-.2.5-.1.5-.1h.9z\"/><defs><path id=\"aS\" d=\"M118 52.2l-.5-.3-.5-.3-.5-.1h-1l-.6.1-.6.2-.6.2-.7.4-.7.3-.8.4-.9.5-.9.5-1.1.5-1.1.6-1.2.6h1l.5.1.5.1h.4l.4.1h.4V56l.2-.1.3-.2.3-.3.5-.3.5-.4.5-.3.6-.4.7-.4.6-.3.8-.4.7-.3.7-.2.7-.1.7-.1h.7\"/></defs><clipPath id=\"aT\"><use xlink:href=\"#aS\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aT)\"><defs><path id=\"aU\" d=\"M106.3 51.5H118v4.7h-11.7z\"/></defs><clipPath id=\"aV\"><use xlink:href=\"#aU\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aV)\"><image overflow=\"visible\" width=\"40\" height=\"17\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG0AAAB2wAAAjD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABMAKgMBIgACEQEDEQH/ xACIAAACAwEAAAAAAAAAAAAAAAAAAQIDBAYBAAMBAAAAAAAAAAAAAAAAAAADBAEQAAEDBAMBAAAA AAAAAAAAAAIAAwQBERMUEDESQREAAQMEAgMBAAAAAAAAAAAAAQARQhAxkQIhgSBxEmISAAIBAwQD AAAAAAAAAAAAAAABETECQhBBEjJRkcH/2gAMAwEAAhEDEQAAAOzpnRBTY4Ne6dePY9daClQwBzDT /9oACAECAAEFAHXToec1kLXr2vn/2gAIAQMAAQUAAR8+QVhyc//aAAgBAQABBQCXKdad3pC3pC3Z CiSHXTU0bvUBUBY1DGxo++R7X//aAAgBAgIGPwC5K5qH5O13s5S55VMTAx+H/9oACAEDAgY/AFKV DqiiiDc30//aAAgBAQEGPwD50ZmB5CuMK4wrjCI3ZgH4FH/I8NvVI93UFBQUeqf/2Q==\" transform=\"matrix(.3599 0 0 -.3599 105.233 57.2)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M118 52.2l-.5-.3-.5-.3-.5-.1h-1l-.6.1-.6.2-.6.2-.7.4-.7.3-.8.4-.9.5-.9.5-1.1.5-1.1.6-1.2.6h1l.5.1.5.1h.4l.4.1h.4V56l.2-.1.3-.2.3-.3.5-.3.5-.4.5-.3.6-.4.7-.4.6-.3.8-.4.7-.3.7-.2.7-.1.7-.1h.7z\"/><defs><path id=\"aW\" d=\"M122.2 54.5l-.5-.6-.6-.4-.5-.3-.6-.2h-1.2l-.6.2-.6.2-.6.3-.6.3-.7.4-.6.4-.6.4-.6.5-.6.4-.6.4h.3l.4.1h.4l.5.1.4.1h.6l.5.1h.4l.2-.3.2-.4.2-.3.3-.3.3-.2.3-.2.4-.2.4-.2.4-.1.4-.2h.4l.5-.1h1.5l.5.1\"/></defs><clipPath id=\"aX\"><use xlink:href=\"#aW\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aX)\"><defs><path id=\"aY\" d=\"M112.7 53h9.5v3.9h-9.5z\"/></defs><clipPath id=\"aZ\"><use xlink:href=\"#aY\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aZ)\"><image overflow=\"visible\" width=\"32\" height=\"15\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGwAAABzgAAAhT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABMAJAMBIgACEQEDEQH/ xACKAAEAAwADAAAAAAAAAAAAAAAAAQIEAwUGAQACAwEAAAAAAAAAAAAAAAABAgADBAUQAAICAgID AAAAAAAAAAAAAAECAAMgBBEVEiIFEQABAgQGAwAAAAAAAAAAAAABABARMUFxIZHhAkIzgRITEgAB AwQDAAAAAAAAAAAAAAABABBBICExAmGhMv/aAAwDAQACEQMRAAAA9xxRlxX65y2Ru0HQzVgBSCWD D//aAAgBAgABBQC291cbNnOH/9oACAEDAAEFAERCprTH/9oACAEBAAEFANjaFB7ETsRF+gCZvry/ hAkRPaNj/9oACAECAgY/ANtQbDheug0KG//aAAgBAwIGPwAEhYp//9oACAEBAQY/AADt9oiM11nP RdZz0QHzOJhNtlnFw1PK4riqN//Z\" transform=\"matrix(.3599 0 0 -.3599 111.58 57.803)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M122.2 54.5l-.5-.6-.6-.4-.5-.3-.6-.2h-1.2l-.6.2-.6.2-.6.3-.6.3-.7.4-.6.4-.6.4-.6.5-.6.4-.6.4h.3l.4.1h.4l.5.1.4.1h.6l.5.1h.4l.2-.3.2-.4.2-.3.3-.3.3-.2.3-.2.4-.2.4-.2.4-.1.4-.2h.4l.5-.1h1.5l.5.1z\"/><defs><path id=\"ba\" d=\"M125.7 56.4l-.1-.3-.3-.2-.3-.1-.3-.1-.4-.1-.5-.1h-.4l-.6.1-.4.1-.6.1-.5.1-.4.2-.4.3-.4.3-.4.3-.2.3.2.1h.3l.3.1.4.1H121.5l.3-.2.5-.3.6-.2.6-.2.8-.2.7-.2.7.1\"/></defs><clipPath id=\"bb\"><use xlink:href=\"#ba\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bb)\"><defs><path id=\"bc\" d=\"M119.5 55.5h6.3v2.1h-6.3z\"/></defs><clipPath id=\"bd\"><use xlink:href=\"#bc\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bd)\"><image overflow=\"visible\" width=\"24\" height=\"10\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGXAAABswAAAf//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA4AHAMBIgACEQEDEQH/ xAB+AAEBAQAAAAAAAAAAAAAAAAADBAYBAQEAAAAAAAAAAAAAAAAAAAEDEAACAwEAAwAAAAAAAAAA AAABAwACBBIRExURAAIBAgQHAQAAAAAAAAAAAAERAgAhENESEzFBkaHh8TIzEgEAAwADAQAAAAAA AAAAAAABACESEUECIv/aAAwDAQACEQMRAAAA3AMMKpXJWn//2gAIAQIAAQUAuH9AN9f/2gAIAQMA AQUAqV+Cadf/2gAIAQEAAQUA06Sg/RtEbLNZNQzk8YIiuUMn/9oACAECAgY/AHCHnqIpvmmf/9oA CAEDAgY/ADRcK+Z//9oACAEBAQY/AIgR1anzXCvzHXxQgYJu7wjvSMTdL1X2e+VDakTO6BeWH//Z\" transform=\"matrix(.3599 0 0 -.3599 118.588 58.645)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M125.7 56.4l-.1-.3-.3-.2-.3-.1-.3-.1-.4-.1-.5-.1h-.4l-.6.1-.4.1-.6.1-.5.1-.4.2-.4.3-.4.3-.4.3-.2.3.2.1h.3l.3.1.4.1H121.5l.3-.2.5-.3.6-.2.6-.2.8-.2.7-.2.7.1z\"/><defs><path id=\"be\" d=\"M126.4 57.5v-.4l-.1-.4-.2-.2-.3-.1-.4-.1h-.4l-.5.1-.5.1-.5.2-.5.2-.4.1-.4.2-.4.2-.2.1-.2.1h-.1l2.3.4h.3l.3-.1.3-.2.4-.1.4-.1h1.1\"/></defs><clipPath id=\"bf\"><use xlink:href=\"#be\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bf)\"><defs><path id=\"bg\" d=\"M121.3 56.3h5.1V58h-5.1z\"/></defs><clipPath id=\"bh\"><use xlink:href=\"#bg\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bh)\"><image overflow=\"visible\" width=\"20\" height=\"9\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGdAAABuQAAAgL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA4AFgMBIgACEQEDEQH/ xACHAAACAwEAAAAAAAAAAAAAAAAAAgEDBAYBAQEAAAAAAAAAAAAAAAAAAAIDEAAABgIDAAAAAAAA AAAAAAAAAQIDEwQREiIjFBEAAQMDAAsAAAAAAAAAAAAAAQARAiExE1FhcaHhEjJCUtIzEgABAwQD AAAAAAAAAAAAAAAAARFBITECohIyM//aAAwDAQACEQMRAAAA7pIphTWIM//aAAgBAgABBQBRP7dg /9oACAEDAAEFACjxxH//2gAIAQEAAQUAdsIaV7WxMmKymsbmlAYY8v8A/9oACAECAgY/AF4ri0F0 89z/2gAIAQMCBj8Aq7k9tT//2gAIAQEBBj8AEZAuQ6sVl7eLIZpGMmoA9nOor6S3+qbmOHyq/Vs0 r//Z\" transform=\"matrix(.3599 0 0 -.3599 120.346 58.956)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M126.4 57.5v-.4l-.1-.4-.2-.2-.3-.1-.4-.1h-.4l-.5.1-.5.1-.5.2-.5.2-.4.1-.4.2-.4.2-.2.1-.2.1h-.1l2.3.4h.3l.3-.1.3-.2.4-.1.4-.1h1.1z\"/><defs><path id=\"bi\" d=\"M124.5 55.6l-.5-.3-.4-.3-.6-.3-.6-.2-.6-.1-.6-.1h-.6l-.7.1-.6.1-.6.2-.5.2-.5.3-.5.4-.4.4-.3.4-.3.6h.7l.4.1h.4l.4.1h.4l.5.1.5.1.2-.3.2-.2.2-.2.2-.2.3-.2.3-.2.4-.1.3-.1.4-.2h.3l.4-.1h.3l.4-.1h.4l.4.1h.3\"/></defs><clipPath id=\"bj\"><use xlink:href=\"#bi\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bj)\"><defs><path id=\"bk\" d=\"M116.2 54.3h8.3v3h-8.3z\"/></defs><clipPath id=\"bl\"><use xlink:href=\"#bk\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bl)\"><image overflow=\"visible\" width=\"28\" height=\"12\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGWAAABtwAAAgP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA4AHwMBIgACEQEDEQH/ xAB7AAEBAQEAAAAAAAAAAAAAAAADBAEGAQADAQAAAAAAAAAAAAAAAAABAgMEEAACAwEBAQAAAAAA AAAAAAACAwABBBIUEREAAgIABgMAAAAAAAAAAAAAAREAAiExkRKiA2GBMxIAAgIDAAAAAAAAAAAA AAAAABEBIVESIv/aAAwDAQACEQMRAAAA7UXHJbKZ6GH/2gAIAQIAAQUAMdHShdRf/9oACAEDAAEF ABJfw7Xdf//aAAgBAQABBQDVqYlnvdPe6KeZ59IotnGScZIoVVn/AP/aAAgBAgIGPwCdWnVnbSyz /9oACAEDAgY/AIcWcxZ//9oACAEBAQY/ANlQEnjMhpMhpL9pW6rXoOPsvtsskTPrxM+vEy4rZ0xd l4n/2Q==\" transform=\"matrix(.3599 0 0 -.3599 115.27 58.264)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M124.5 55.6l-.5-.3-.4-.3-.6-.3-.6-.2-.6-.1-.6-.1h-.6l-.7.1-.6.1-.6.2-.5.2-.5.3-.5.4-.4.4-.3.4-.3.6h.7l.4.1h.4l.4.1h.4l.5.1.5.1.2-.3.2-.2.2-.2.2-.2.3-.2.3-.2.4-.1.3-.1.4-.2h.3l.4-.1h.3l.4-.1h.4l.4.1h.3z\"/><defs><path id=\"bm\" d=\"M22.3 41.9l-.1.1-.1.2-.2.4-.3.4-.3.6-.3.6-.2.7-.2.7-.2.7-.1.7.1.7.1.6.3.6.5.5.7.4.9.3-.2-.5v-.4l-.1-.5-.1-.5v-2.1l.1-.6.1-.5v-.5l.2-.5v-.5l.2-.4.1-.5.1-.3-.1-.1h-.1l-.2-.1h-.1l-.1-.1h-.1l-.2-.1h-.1\"/></defs><clipPath id=\"bn\"><use xlink:href=\"#bm\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bn)\"><defs><path id=\"bo\" d=\"M20.3 41.9h3v8.2h-3z\"/></defs><clipPath id=\"bp\"><use xlink:href=\"#bo\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bp)\"><image overflow=\"visible\" width=\"16\" height=\"27\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGxAAAB2gAAAlT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AEwMBIgACEQEDEQH/ xACNAAADAAMAAAAAAAAAAAAAAAAAAwYBBAUBAQEBAAAAAAAAAAAAAAAAAAIEBRAAAQQDAQEBAAAA AAAAAAAABAABAgMSBQYQETURAAEDAgMGBwAAAAAAAAAAAAERAgMSBAAQEyExUXEzw8EyQqKyc4MS AAIBAgcAAAAAAAAAAAAAAAERECGRUQISIkIDE//aAAwDAQACEQMRAAAAtMzbxoVADz4zaY9X94Aw f//aAAgBAgABBQBs81i3xf/aAAgBAwABBQCQcWDUyouIv//aAAgBAQABBQAzZUh2A7Gk51119lew 4yUpOux/T4rzpNZEw7mAIhef/9oACAECAgY/AKnbDdcI/9oACAEDAgY/APfkspuVA6Qa6QLFx//a AAgBAQEGPwAMkBJIq2JuUjwxIIgRpoqp6l4cso2NKAwtPufi9LivS7mUX0N+cmL38u5lHIby3tyI g2iZ9LijnlQOG3FzTdQ3Opp9B1dNNfm5rl//2Q==\" transform=\"matrix(.3599 0 0 -.3599 19.404 50.978)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M22.3 41.9l-.1.1-.1.2-.2.4-.3.4-.3.6-.3.6-.2.7-.2.7-.2.7-.1.7.1.7.1.6.3.6.5.5.7.4.9.3-.2-.5v-.4l-.1-.5-.1-.5v-2.1l.1-.6.1-.5v-.5l.2-.5v-.5l.2-.4.1-.5.1-.3-.1-.1h-.1l-.2-.1h-.1l-.1-.1h-.1l-.2-.1h-.1z\"/><defs><path id=\"bq\" d=\"M23.3 42.3l-.4 1.6-.3 1.4-.2 1.2v1.1l.1 1 .1.8.3.7.2.5.4.5.3.4.4.2.4.2.4.2h.3l.3.1h.3l-.1-.5-.2-.4-.2-.6-.1-.5-.1-.6-.1-.5-.1-.6V45.4l.1-.6.1-.6.2-.6.2-.6-.4-.1-.3-.1-.4-.1-.3-.1-.2-.1-.3-.1h-.2l-.2-.1\"/></defs><clipPath id=\"br\"><use xlink:href=\"#bq\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#br)\"><defs><path id=\"bs\" d=\"M22.4 42.3h3.5v9.9h-3.5z\"/></defs><clipPath id=\"bt\"><use xlink:href=\"#bs\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bt)\"><image overflow=\"visible\" width=\"16\" height=\"31\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG2AAAB4gAAAl7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAEwMBIgACEQEDEQH/ xACNAAEBAQEAAAAAAAAAAAAAAAAABAYFAQADAQAAAAAAAAAAAAAAAAAAAgUDEAABBAIBBQAAAAAA AAAAAAAEAAEDBQIGECAREhM1EQACAQEFBgcAAAAAAAAAAAABAgMRABAhEgQgMUFRoYPBIqKyI3Oz EgACAAYDAAAAAAAAAAAAAAABERAgkQISEzEDM//aAAwDAQACEQMRAAAA2M/Lhwqbkby8ZL1ZmqbE LLAAD//aAAgBAgABBQDxz9ibBu3P/9oACAEDAAEFAIw2cVMViwnP/9oACAEBAAEFADzshpA7SScx bWXlCdrs8kl2tx+nrX21s9XYGn0NNaC23R//2gAIAQICBj8AeRWXDgSxJ//aAAgBAwIGPwA9pA8r rqCGph6jbWT/2gAIAQEBBj8ACA0qteptHCWBVs1RQcFJ8Lo0XjCp9T20wY4fJh23ui+hffJbTdz8 3ujl0sJlQRKpYEDzBnNMSOdoJ9RpzHEmfMxKmlUZRuPM7P8A/9k=\" transform=\"matrix(.3599 0 0 -.3599 21.343 53.066)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M23.3 42.3l-.4 1.6-.3 1.4-.2 1.2v1.1l.1 1 .1.8.3.7.2.5.4.5.3.4.4.2.4.2.4.2h.3l.3.1h.3l-.1-.5-.2-.4-.2-.6-.1-.5-.1-.6-.1-.5-.1-.6V45.4l.1-.6.1-.6.2-.6.2-.6-.4-.1-.3-.1-.4-.1-.3-.1-.2-.1-.3-.1h-.2l-.2-.1z\"/><defs><path id=\"bu\" d=\"M25.6 43l-.2.6-.2.7-.1.8v.9l-.1 1v.9l.1 1 .2 1 .2.9.2.8.4.7.4.6.6.4.6.2.7.1.9-.3-.4-.5-.3-.5-.2-.6-.3-.5-.1-.6-.2-.6-.1-.6-.1-.6-.1-.6v-1.9l.1-.6.1-.6.1-.7.2-.6-.3-.1-.3-.1-.4-.1-.3-.1-.4-.1-.3-.1-.2-.1-.2-.1\"/></defs><clipPath id=\"bv\"><use xlink:href=\"#bu\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bv)\"><defs><path id=\"bw\" d=\"M25 43h4.2v10.6H25z\"/></defs><clipPath id=\"bx\"><use xlink:href=\"#bw\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bx)\"><image overflow=\"visible\" width=\"20\" height=\"33\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHdAAACFQAAAqP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAGQMBIgACEQEDEQH/ xACfAAACAwEBAAAAAAAAAAAAAAAFBgADBAIHAQACAwAAAAAAAAAAAAAAAAADBQECBBAAAAUCBAYD AAAAAAAAAAAAAAECAwQTBjFBEgURISIUJDU0FSYRAAADBgIJBQAAAAAAAAAAAAERAgAQITESAxME QaHRIkJyssJzkqMURBUSAAECBQQDAAAAAAAAAAAAAAEAEhExQYECYUKiExAhY//aAAwDAQACEQMR AAAAecPCnnYv1w4ibIvJ7gnEZ+gEhhOFubHJYRC2Ssf/2gAIAQIAAQUAcJw189CWjUNPUnDP/9oA CAEDAAEFAIkKqimXcQpCW42vySwz/9oACAEBAAEFAJL9BDm8GkRHjfji5JBR4ju5LUNhWa9oF5fB FvemF5HwgmoW76UTfr6f5cRu2oD/2gAIAQICBj8ALciAp+2z1UQm6wW6yrO6/9oACAEDAgY/ABmR Urrp2s5QQBNck/7O5RW63j//2gAIAQEBBj8ABUIiUWgCde1kXhIBWcpTJ1tQiR3C1C262WUqYpE/ Up1jy9qnZXlV1KdY8vap2V5VdSnJ/QwcM93HppqLRXpb6Hssj4tGBwYRUEfDTCbv/9k=\" transform=\"matrix(.3599 0 0 -.3599 23.975 54.338)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M25.6 43l-.2.6-.2.7-.1.8v.9l-.1 1v.9l.1 1 .2 1 .2.9.2.8.4.7.4.6.6.4.6.2.7.1.9-.3-.4-.5-.3-.5-.2-.6-.3-.5-.1-.6-.2-.6-.1-.6-.1-.6-.1-.6v-1.9l.1-.6.1-.6.1-.7.2-.6-.3-.1-.3-.1-.4-.1-.3-.1-.4-.1-.3-.1-.2-.1-.2-.1z\"/><defs><path id=\"by\" d=\"M32.9 54.9l-.8.1-.7-.1-.7-.3-.6-.4-.6-.6-.5-.6-.4-.8-.3-.8-.3-.9-.3-.9-.1-1-.1-1v-1l.1-.9.2-1 .3-.9.3.1.3.1.3.1.4.1.3.2.4.1.3.1.4.1V46.7l.1.8v1.6l.1.8.1.8.1.7.1.8.2.7.2.6.2.5.3.4.3.3.4.2\"/></defs><clipPath id=\"bz\"><use xlink:href=\"#by\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bz)\"><defs><path id=\"bA\" d=\"M27.5 43.8h5.3V55h-5.3z\"/></defs><clipPath id=\"bB\"><use xlink:href=\"#bA\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bB)\"><image overflow=\"visible\" width=\"20\" height=\"35\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHgAAACGgAAAr7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAFgMBIgACEQEDEQH/ xAChAAADAAMBAAAAAAAAAAAAAAAABQYBAgMEAQACAwAAAAAAAAAAAAAAAAACAwEEBRAAAQMEAgID AQAAAAAAAAAAAwECBAAREgUTBiMUMxUmNhEAAQQBAgILAQAAAAAAAAAAAQARAgMEIRJBchAxcYGR obEispMFNRIAAQIBBw0AAAAAAAAAAAAAEQABEjFBYaHRAiIhUYGxwTKCogMTM6NE/9oADAMBAAIR AxEAAAC85eRFVt1BOhM2l6aZfoNzAS3aMG5jACR//9oACAECAAEFACEKhMi2wVV41oedvLf/2gAI AQMAAQUABEUjfSXOEVrIvsN5G82Hkv8A/9oACAEBAAEFACFaOnTRNps4Th7mTwKbZIlRJyO1PciP YRVVagfz/dPlvUBfz/Zte2Y/6AdRNSMen//aAAgBAgIGPwB2uvkahUwGSc2IsyGjasMKmMVYsX// 2gAIAQMCBj8Aa8JVCH8vb5Il08+LW6J+mL1BMN2ZcVYX/9oACAEBAQY/AA4Jdaup2AHbWz9+irDt uB8mWsln2vpXKrXtkyxREs8Zv4xWpdfqc1HzCxOWfrHo/U5qPmFjmWVRjbBINdPZucjqX9PC+0LP xxnY0xcaibY2Awhtk/vPB+C//9k=\" transform=\"matrix(.3599 0 0 -.3599 26.645 55.991)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M32.9 54.9l-.8.1-.7-.1-.7-.3-.6-.4-.6-.6-.5-.6-.4-.8-.3-.8-.3-.9-.3-.9-.1-1-.1-1v-1l.1-.9.2-1 .3-.9.3.1.3.1.3.1.4.1.3.2.4.1.3.1.4.1V46.7l.1.8v1.6l.1.8.1.8.1.7.1.8.2.7.2.6.2.5.3.4.3.3.4.2z\"/><defs><path id=\"bC\" d=\"M30.8 44.7l.3.1.3.1.3.1.3.1.2.1h.3l.3.1.3.1v.6l.1.7v2.8l.1.8v1.5l.1.8.2.7.1.6.2.6.3.5.3.5.4.4-.8-.2-.7-.3-.6-.4-.5-.5-.4-.5-.3-.7-.2-.6-.2-.8-.1-.8-.1-.8v-1.8l-.1-.9v-1.9l-.1-1\"/></defs><clipPath id=\"bD\"><use xlink:href=\"#bC\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bD)\"><defs><path id=\"bE\" d=\"M30.8 44.7h4.1v11.1h-4.1z\"/></defs><clipPath id=\"bF\"><use xlink:href=\"#bE\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bF)\"><image overflow=\"visible\" width=\"20\" height=\"35\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHPAAACCgAAApL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAGQMBIgACEQEDEQH/ xACTAAADAQADAAAAAAAAAAAAAAAABAYFAgMHAQEBAQEAAAAAAAAAAAAAAAADBAUCEAAABgIDAQEB AAAAAAAAAAAAAQISAwQRBSETBiIjFhEAAgAFAgMJAAAAAAAAAAAAAQIAETEDBBCxUaESYZHBMnJj c9M1EgACAAUEAwAAAAAAAAAAAAAAEQFhoQISMXGBsTJiY//aAAwDAQACEQMRAAAAvOlfHnqqOS7D zz8zQyzafoTiTp52LhgvVayBF//aAAgBAgABBQBZyv5ahGSx9I7W8u//2gAIAQMAAQUAhrvQ37qy tgz+yO1vLv/aAAgBAQABBQCWYoiO8gghRLQNzN1IVdFFTqY9XIaIzmUY1J51g9keInjT86oejoQ3 Ufz9Ea6JMNEf/9oACAECAgY/AI43K3YmqjFMhjpwTdT/2gAIAQMCBj8AhctTH2RbDfsf0dSGPjwT dT//2gAIAQEBBj8ABInOKc4DijCelrtLeEViy3FAeWmNIymX2WKxin2l20xfU+y6YnxJtpYF7Lt4 nQWINwgdU5Umy0j9fG71+yLFpLguqltVFxfKwAqK6f/Z\" transform=\"matrix(.3599 0 0 -.3599 29.832 56.82)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M30.8 44.7l.3.1.3.1.3.1.3.1.2.1h.3l.3.1.3.1v.6l.1.7v2.8l.1.8v1.5l.1.8.2.7.1.6.2.6.3.5.3.5.4.4-.8-.2-.7-.3-.6-.4-.5-.5-.4-.5-.3-.7-.2-.6-.2-.8-.1-.8-.1-.8v-1.8l-.1-.9v-1.9l-.1-1z\"/><defs><path id=\"bG\" d=\"M38.5 57l-1.2-.1-1-.2-.8-.4-.6-.5-.5-.6-.4-.7-.3-.8-.2-.9-.2-.9v-1l-.1-.9v-3.8l-.1-.8.3.1.3.1.3.1.3.1.2.1.3.1h.3l.3.1v.1l-.1.2v.3l-.1.4-.1.5v.6l-.1.7.1.7v.8l.2.8.3.9.3 1 .4.9.6 1 .7 1 .9 1\"/></defs><clipPath id=\"bH\"><use xlink:href=\"#bG\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bH)\"><defs><path id=\"bI\" d=\"M33.1 45.4h5.3v11.5h-5.3z\"/></defs><clipPath id=\"bJ\"><use xlink:href=\"#bI\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bJ)\"><image overflow=\"visible\" width=\"20\" height=\"36\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHSAAACBwAAAqH/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAFgMBIgACEQEDEQH/ xACbAAEBAQEBAAAAAAAAAAAAAAAABQYBBAEBAQEBAAAAAAAAAAAAAAAAAwIEBRAAAQMBCAMBAAAA AAAAAAAAAgABAwQREjITBRU1BhQWJjYRAAAEAwYFBQAAAAAAAAAAAAABEQIxEgMhoTJyExQQIoKy w2KDowREEgABAgMHBQEAAAAAAAAAAAABAAIRQYExEiIyQhMz8FGRgzSE/9oADAMBAAIRAxEAAADa eeFIydbdohQmyKkjcuocTm5OFi6Dj//aAAgBAgABBQAo5XO4SCAXbLFBhX//2gAIAQMAAQUAg0+/ H4rKOrNo84kOFf/aAAgBAQABBQCpq8qUtUsTVltB2Ovkh1Qq+oJBNJ6f2jmbWQP8V2rmkH4nsGxb p8uh2r1b/9oACAECAgY/AHEPcBEwxLMeO7bPugTMRXsu0Qz2LVy9VX//2gAIAQMCBj8AY8wxNDvK l9exRMaNLQF+jcqhmsU+Rf/aAAgBAQEGPwA2zIiWIQxXED+ysDj1SipSaVhEy9pCKB9VeeaPvEQr ZWdpcKh+rzNFbKztLhUzedoqb3da6Nm0dORJSRJ7YD9/wh6bjYLbg1l1S6cVw//Z\" transform=\"matrix(.3599 0 0 -.3599 32.061 58.016)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M38.5 57l-1.2-.1-1-.2-.8-.4-.6-.5-.5-.6-.4-.7-.3-.8-.2-.9-.2-.9v-1l-.1-.9v-3.8l-.1-.8.3.1.3.1.3.1.3.1.2.1.3.1h.3l.3.1v.1l-.1.2v.3l-.1.4-.1.5v.6l-.1.7.1.7v.8l.2.8.3.9.3 1 .4.9.6 1 .7 1 .9 1z\"/><defs><path id=\"bK\" d=\"M42.4 58.2l-.8.2-.8-.1-.7-.3-.8-.4-.7-.5-.7-.7-.6-.8-.6-.9-.5-.9-.4-1-.4-1.1-.2-1.1-.1-1.2-.1-1.1.1-1.1.3-1.1 2.7.9v.4l-.1.6.1.6v.7l.1.7.2.8.1.8.2.8.3.8.3.8.4.8.4.8.5.8.5.6.6.7.7.5\"/></defs><clipPath id=\"bL\"><use xlink:href=\"#bK\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bL)\"><defs><path id=\"bM\" d=\"M35 46.1h7.3v12.3H35z\"/></defs><clipPath id=\"bN\"><use xlink:href=\"#bM\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bN)\"><image overflow=\"visible\" width=\"28\" height=\"38\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHbAAACEgAAApz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAHwMBIgACEQEDEQH/ xACVAAACAwEBAAAAAAAAAAAAAAAFBgADBwIEAQEBAQAAAAAAAAAAAAAAAAADBAAQAAEEAgICAwAA AAAAAAAAAAMAAQIEEgURExQGMxU1EQACAAUABgsAAAAAAAAAAAABAgAQEbEDIUFyE3MEMVGREiIy QtIzRJQSAAEEAQMFAAAAAAAAAAAAABEAAQISMUGhMiFRYYED/9oADAMBAAIRAxEAAAB5rGiIbmj2 Ir05pQM0Drvt07LtR0agHkYutFkM/wD/2gAIAQIAAQUAJ3ZgYjKIHkxB4KHbibNf/9oACAEDAAEF ABU5zharOFAutAN47lePZiXJf//aAAgBAQABBQAxpwn5U15j8rdbBq1om6im3DyIvbv1UL5V7e/G 25dCd+1e0USWNn9UZD1ZmIv/2gAIAQICBj8AlWUgeild3fAKPdN5TCgGqaw1wv/aAAgBAwIGPwCM mjllAsLHZfOI4xZlAtxtumFQmsPS/9oACAEBAQY/AKClKa41RpKyGPvU8APaTHmhQKmpF5DhLdpJ tC8hwlu0k2heQdcmFBulFMmVMbdLel2Bj5+W/Ri98Id9y2hh9jF17cv/2Q==\" transform=\"matrix(.3599 0 0 -.3599 34.297 59.265)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M42.4 58.2l-.8.2-.8-.1-.7-.3-.8-.4-.7-.5-.7-.7-.6-.8-.6-.9-.5-.9-.4-1-.4-1.1-.2-1.1-.1-1.2-.1-1.1.1-1.1.3-1.1 2.7.9v.4l-.1.6.1.6v.7l.1.7.2.8.1.8.2.8.3.8.3.8.4.8.4.8.5.8.5.6.6.7.7.5z\"/><defs><path id=\"bO\" d=\"M38 46.9l.5.1.5.2.6.2.7.2.6.2.6.1.5.2.4.1v.6l.1.7v.8l.1.7v.8l.1.7.1.8.1.7.1.7.2.7.3.7.2.6.3.7.4.5.4.5.5.4-.6.1-.6-.1-.6-.1-.6-.3-.6-.3-.6-.5-.6-.6-.5-.7-.6-.8-.4-.9-.5-1-.3-1.1-.3-1.3-.2-1.3-.2-1.4-.1-1.6\"/></defs><clipPath id=\"bP\"><use xlink:href=\"#bO\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bP)\"><defs><path id=\"bQ\" d=\"M38 46.9h7.2v12H38z\"/></defs><clipPath id=\"bR\"><use xlink:href=\"#bQ\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bR)\"><image overflow=\"visible\" width=\"28\" height=\"37\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHhAAACFAAAAqz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAHwMBIgACEQEDEQH/ xACbAAACAgMAAAAAAAAAAAAAAAAFBwAGAgMEAQEAAwEAAAAAAAAAAAAAAAADAQIEBRAAAQMEAgID AAAAAAAAAAAAAwABAhIEBQYREzM1IxUWEQACAAMEBgsBAAAAAAAAAAABAhCxAwBycwQRMVES0hMh QWEyQoKSMxQ0RJQSAAEEAAYDAAAAAAAAAAAAAAEAEQISITFBUWEDgdET/9oADAMBAAIRAxEAAACx 8PKDr3bPalizpx0oGbBM21nK5oxlqAeRiyYshn//2gAIAQIAAQUAd35blRE7sSFKh20mrX//2gAI AQMAAQUAtrO1mDJACJwXLRDel7Hj2UlqX//aAAgBAQABBQDM7FPGXf7QqhuZZTW3e1QvKtu9qheV be/GV5Qn+VbRYkuMn9UZDxZmIv/aAAgBAgIGPwBYoHdDlBqM2qFm1yX/2gAIAQMCBj8A65S63lKI JLn2uv5Rraz4k5NuoRfKKhw6DVZCzeF//9oACAEBAQY/ABlloCqCgfeLbusnsOy31F9Z4bKvxFGk gd89flgMJZtBLwnAYSzaCXhOAwlm0EvCcA61KKDlKNFSqlNtbeF2Bt7+W/opcdkPOy3Qw/RS234f /9k=\" transform=\"matrix(.3599 0 0 -.3599 37.282 59.608)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M38 46.9l.5.1.5.2.6.2.7.2.6.2.6.1.5.2.4.1v.6l.1.7v.8l.1.7v.8l.1.7.1.8.1.7.1.7.2.7.3.7.2.6.3.7.4.5.4.5.5.4-.6.1-.6-.1-.6-.1-.6-.3-.6-.3-.6-.5-.6-.6-.5-.7-.6-.8-.4-.9-.5-1-.3-1.1-.3-1.3-.2-1.3-.2-1.4-.1-1.6z\"/><defs><path id=\"bS\" d=\"M49.1 59.4h-1.3l-1.1-.1-1-.3-.7-.5-.7-.6-.5-.7-.3-.8-.3-.9-.3-1-.1-1-.1-.9-.1-1v-1l-.1-.9v-.8l-.1-.8.4.1.3.1.3.1.4.1.3.1.3.1.4.1.4.1.1.8.1.7.1.8.1.7.1.7.1.7.1.7.2.6.2.7.2.6.3.6.3.6.4.6.5.6.5.5.6.6\"/></defs><clipPath id=\"bT\"><use xlink:href=\"#bS\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bT)\"><defs><path id=\"bU\" d=\"M42.4 48.1h6.7v11.3h-6.7z\"/></defs><clipPath id=\"bV\"><use xlink:href=\"#bU\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bV)\"><image overflow=\"visible\" width=\"24\" height=\"36\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHZAAACFgAAAq7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAHAMBIgACEQEDEQH/ xACUAAEAAwEBAAAAAAAAAAAAAAAGAAQFBwMBAAMBAQAAAAAAAAAAAAAAAAECBAADEAABBAICAgMA AAAAAAAAAAACAQMEBQATERIUBhU1FhEAAgAFAgQHAQAAAAAAAAAAAQIAEBEDBLESITFyc1FhkaEy 0wU1EgABAwMEAwEAAAAAAAAAAAABABECMUESIbEyA1GBkVL/2gAMAwEAAhEDEQAAAHXnTyIq0lko rckjaI3bbo9C530Q8sDHkeC0tkG//9oACAECAAEFAHSe2Dt1CwpIrPBBu6rt7//aAAgBAwABBQBm KTgFEJHoswW47krmWOzhdnb/2gAIAQEAAQUAeeJtfKPAkkR5cTUjG5cimV1qj1hnuar5OUX2+e6L xK7LlCq/MZ7HWR5r356BlXSQ2LDP/9oACAECAgY/AJCMiBZScnJwxT+UIfpDGlqIPybSi//aAAgB AwIGPwASEXdQ6m1nEn46hG4B3XV2twiRuhjT0g/Ky//aAAgBAQEGPwAAAGvjHIQFIHGVsE03KT7x 8osWga7mpLG6G1li9Y0ljdttZYncGkrLXs21iFFIC3SAW48xVlj+xjeq/ZFi8n6di8yNUWkK7m8h RzL/2Q==\" transform=\"matrix(.3599 0 0 -.3599 41.547 60.43)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M49.1 59.4h-1.3l-1.1-.1-1-.3-.7-.5-.7-.6-.5-.7-.3-.8-.3-.9-.3-1-.1-1-.1-.9-.1-1v-1l-.1-.9v-.8l-.1-.8.4.1.3.1.3.1.4.1.3.1.3.1.4.1.4.1.1.8.1.7.1.8.1.7.1.7.1.7.1.7.2.6.2.7.2.6.3.6.3.6.4.6.5.6.5.5.6.6z\"/><defs><path id=\"bW\" d=\"M52.5 60h-1.1l-1-.1-.9-.3-.8-.5-.7-.6-.5-.7-.5-.9-.4-.8-.3-1-.3-.9-.2-1-.1-1-.2-.9-.1-.8-.1-.8V49l.4.1h.3l.3.1.4.1.2.1h.4l.3.1.5.1.1 1.1.2 1.1.2 1 .2.9.2.8.3.8.3.7.3.7.2.6.4.5.3.5.3.4.4.4.3.3.4.3.3.3\"/></defs><clipPath id=\"bX\"><use xlink:href=\"#bW\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bX)\"><defs><path id=\"bY\" d=\"M45.3 49h7.2v11.1h-7.2z\"/></defs><clipPath id=\"bZ\"><use xlink:href=\"#bY\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bZ)\"><image overflow=\"visible\" width=\"28\" height=\"34\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHjAAACFwAAAqn/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAHwMBIgACEQEDEQH/ xACeAAACAwEBAAAAAAAAAAAAAAAFBgAEBwEDAQACAwEAAAAAAAAAAAAAAAACBAABAwUQAAAFAwQD AAAAAAAAAAAAAAABAgMEEQUGEhMzNSMVFhEAAgADBQIPAAAAAAAAAAAAAQIQsQMAEXJzBBITITFB UWEiMoKS0pMUNAU1EgABBAECBwEAAAAAAAAAAAABABECEgMxYRAhQVGBwSIT/9oADAMBAAIRAxEA AABnpUAY9xsZcw0+1EoGbB6M+mnZfqETA0JCV62SDX//2gAIAQIAAQUAMzqVQTRmS0aQndovWP/a AAgBAwABBQCNBjLZuMdlk48gksz3ScMtyi9Y/9oACAEBAAEFALrkTdslfaNBOZtKUMu7UNcoy7tQ 1yjLzpdaho/KLza7RLmegxwIsOOksf/aAAgBAgIGPwDg6G6DO3RC/hf/2gAIAQMCBj8AxzlB5SiC forH+Ua2s/MnRu6xh9IhQ2t6QZ2Qsv/aAAgBAQEGPwAaZqBqEqH2g13GT0Hmt8RvGPLYL7RheQO2 OXuwGUs2gmITgMpZtBMQnAZSzaCYhOAq63WjT1dgLuy6L1QTcbn4bfpr6tKykfZqSCCBvaUP/9k=\" transform=\"matrix(.3599 0 0 -.3599 44.284 60.808)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M52.5 60h-1.1l-1-.1-.9-.3-.8-.5-.7-.6-.5-.7-.5-.9-.4-.8-.3-1-.3-.9-.2-1-.1-1-.2-.9-.1-.8-.1-.8V49l.4.1h.3l.3.1.4.1.2.1h.4l.3.1.5.1.1 1.1.2 1.1.2 1 .2.9.2.8.3.8.3.7.3.7.2.6.4.5.3.5.3.4.4.4.3.3.4.3.3.3z\"/><defs><path id=\"ca\" d=\"M55.8 60.4l-1.1.1-1-.2-.8-.3-.8-.4-.7-.6-.6-.7-.5-.8-.5-.9-.4-.9-.3-.9-.3-1-.2-.9-.2-.9-.1-.9-.1-.8-.2-.6h.4l.3.1.4.1.3.1.4.1h.3l.4.1.3.1.1.6v.6l.2.6.2.7.2.7.2.7.3.8.4.8.3.7.4.7.4.7.5.6.4.6.5.5.4.5.5.3\"/></defs><clipPath id=\"cb\"><use xlink:href=\"#ca\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cb)\"><defs><path id=\"cc\" d=\"M48 49.7h7.8v10.8H48z\"/></defs><clipPath id=\"cd\"><use xlink:href=\"#cc\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cd)\"><image overflow=\"visible\" width=\"28\" height=\"34\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHcAAACGwAAAqX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAHwMBIgACEQEDEQH/ xACaAAACAwEAAAAAAAAAAAAAAAAABQQGBwIBAQEBAQEAAAAAAAAAAAAAAAQCAwEFEAABAwEHBAMA AAAAAAAAAAADAAECBRExEhMEFCQyFQYmJUUWEQABAwEFBQkBAAAAAAAAAAABABESAjFBMhMUIbFD o8MQYZGhUqJjc4QVEgACAQMFAQAAAAAAAAAAAAAAAREhMQKBEjKCAzP/2gAMAwEAAhEDEQAAALzx FhAS3kV17rNUSOEafZ60DPNC6SAuDcBZwmf/2gAIAQIAAQUAKQzE00iO+U7rLeKj0lu//9oACAED AAEFAIAlKJguNtKYcQVMsZxjcRf/2gAIAQEAAQUAKaQ5bqa3U1ifBUdZEB3qcU9UZZnC8rMSFTfU GdOUjq1+x+XP8rayxMvoq3+d3npa9LXF7d//2gAIAQICBj8AyWOTiaGW9zShMXKqJF9dLC59z//a AAgBAwIGPwBPbdCbUSeacSsEeaxijYvppYXPsf/aAAgBAQEGPwCIAOx1YFYFK9nQoPpB3q1WrN+K XtdCmksMqk+dSxFYinv0vTQ+qnfV2/k6aH9OWogGjNouWwbFxOauJzVfpMnvfKj44V//2Q==\" transform=\"matrix(.3599 0 0 -.3599 47.292 61.458)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M55.8 60.4l-1.1.1-1-.2-.8-.3-.8-.4-.7-.6-.6-.7-.5-.8-.5-.9-.4-.9-.3-.9-.3-1-.2-.9-.2-.9-.1-.9-.1-.8-.2-.6h.4l.3.1.4.1.3.1.4.1h.3l.4.1.3.1.1.6v.6l.2.6.2.7.2.7.2.7.3.8.4.8.3.7.4.7.4.7.5.6.4.6.5.5.4.5.5.3z\"/><g><defs><path id=\"ce\" d=\"M59.4 61.1l-1.1.1-1.1-.1-.9-.4-.9-.6-.8-.7-.7-.8-.6-1-.6-1-.4-1.1-.4-1-.4-1-.3-.9-.1-.9-.2-.6-.1-.5v-.3l.5.1.4.1.4.1.4.1.4.1.3.1.4.1h.4l.1.5.2.6.1.6.2.8.3.8.2.8.3.8.3.8.4.8.4.8.4.7.4.6.5.6.5.4.5.3.6.2\"/></defs><clipPath id=\"cf\"><use xlink:href=\"#ce\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cf)\"><defs><path id=\"cg\" d=\"M50.8 50.3h8.6v10.9h-8.6z\"/></defs><clipPath id=\"ch\"><use xlink:href=\"#cg\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ch)\"><image overflow=\"visible\" width=\"32\" height=\"34\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHwAAACNAAAAt//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAIQMBIgACEQEDEQH/ xAChAAEBAQEBAQAAAAAAAAAAAAAABQYEAgcBAQADAQAAAAAAAAAAAAAAAAMBAgUEEAAABgECBgMA AAAAAAAAAAAAAQIDBAUGEjIQETEVNSYTFBYRAAEBBQQJBQEAAAAAAAAAAAIBABAREgMxMrITYZGh Q3ODswQUIVGBwSIVEgABAgIJBQAAAAAAAAAAAAABAAIQMREhQVGRIoIDMxJCUmJD/9oADAMBAAIR AxEAAADU80aXz7esqfPthYrwbJwUunKXb9bLF7SAvg8vL8R0u0JWKgAf/9oACAECAAEFADSvU2lR GCYMyU0aSCdrm0f/2gAIAQMAAQUAYgIU1NhttMBqWSWpkn5GgnovaP/aAAgBAQABBQCdauR5R3rw O/fFVMXMjjI33EXJyHTBvOGMPUaqwZL5vhh3jBkx8rzUNQw0+dWLj833L08enjH+2/TH/9oACAEC AgY/ADmM71W4mAN9apgOWVkl9NUof//aAAgBAwIGPwDbcQ3MxrsQi9oFPUBVDbb4saMAi32EBySs Xfqh/9oACAEBAQY/ADoiqQGFqe6IrWjqa0dTFVOCqhqPpoQV+3dwIrBEk6YNea8rVVVYrnlgB3c8 vpg+rxywU3dzy+mD6vHLBTdW87N8n85kkZbgyw+INv8Aa2/2sf8ANnyM1Zp7Z5Rjbog7/9k=\" transform=\"matrix(.3599 0 0 -.3599 50.029 62.183)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M59.4 61.1l-1.1.1-1.1-.1-.9-.4-.9-.6-.8-.7-.7-.8-.6-1-.6-1-.4-1.1-.4-1-.4-1-.3-.9-.1-.9-.2-.6-.1-.5v-.3l.5.1.4.1.4.1.4.1.4.1.3.1.4.1h.4l.1.5.2.6.1.6.2.8.3.8.2.8.3.8.3.8.4.8.4.8.4.7.4.6.5.6.5.4.5.3.6.2z\"/><g><defs><path id=\"ci\" d=\"M62 60.9l-1 .3h-.9l-.9-.2-.8-.4-.6-.6-.6-.6-.6-.8-.5-.9-.4-.9-.3-1-.3-.9-.3-.9-.2-.9-.2-.8-.2-.7-.1-.5h.3l.3.1h.3l.2.1h.3l.3.1.2.1h.3l.1.6.1.7.2.7.2.7.2.7.3.6.2.7.4.6.3.6.4.6.5.6.4.5.6.5.5.5.6.4.7.4\"/></defs><clipPath id=\"cj\"><use xlink:href=\"#ci\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cj)\"><defs><path id=\"ck\" d=\"M54.1 51.1H62v10.1h-7.9z\"/></defs><clipPath id=\"cl\"><use xlink:href=\"#ck\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cl)\"><image overflow=\"visible\" width=\"28\" height=\"32\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHVAAACDgAAAr3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAHwMBIgACEQEDEQH/ xACZAAADAQEAAAAAAAAAAAAAAAAABQYEBwEAAgMBAAAAAAAAAAAAAAAAAAMBBAUCEAABBAIBAwUA AAAAAAAAAAADAQIEBQAGECAVNhEhEhM1EQACAQIDBAoDAAAAAAAAAAABAgMAETESBBAhQbEgYdGS 0jNzk7M0EyODEgACAQMEAwEAAAAAAAAAAAABAgARIVEQMUEDkaEiUv/aAAwDAQACEQMRAAAApMip Wjep3PPrLuuhVultmc9lK1sIeALzwAP/2gAIAQIAAQUAVjvVjVRUCio8aNTj/9oACAEDAAEFAAQR OFYxhCCKYjRTJP2j4//aAAgBAQABBQCytjxpi38rF2GVkaaQtPsrnJdfJ2e+V3iOy/t8V3iOxQJ5 rjtdrna7TK+PIZqvR//aAAgBAgIGPwA/bb5l2JtzAai8qCDfX//aAAgBAwIGPwDrYhat1q22RFZA AT2AWFODEX8oo8CBcPX0df/aAAgBAQEGPwCSFHsq5bCwOKg8R115o7q9leaO6vZR1ha8gjkbNYYo Wtuw4VqQCQP1/GlYnY/oajnJWp/n8abX9DUc5K1EkOmlkjbJldI2ZTaNRuIFfTn9p/DX05/afw08 DxOs5hnH4ipD3YyZRlx336P/2Q==\" transform=\"matrix(.3599 0 0 -.3599 53.352 62.008)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M62 60.9l-1 .3h-.9l-.9-.2-.8-.4-.6-.6-.6-.6-.6-.8-.5-.9-.4-.9-.3-1-.3-.9-.3-.9-.2-.9-.2-.8-.2-.7-.1-.5h.3l.3.1h.3l.2.1h.3l.3.1.2.1h.3l.1.6.1.7.2.7.2.7.2.7.3.6.2.7.4.6.3.6.4.6.5.6.4.5.6.5.5.5.6.4.7.4z\"/><g><defs><path id=\"cm\" d=\"M65.3 61.4H63.6l-.8-.2-.8-.3-.7-.4-.7-.5-.7-.6-.6-.6-.5-.7-.6-.8-.4-.9-.4-.9-.4-.9-.3-1-.2-1.1-.2-1 .4.1h.3l.4.1.4.1h.4l.3.1.4.1.3.1.2.6.2.6.1.6.2.6.1.6.2.6.3.6.2.6.3.6.4.6.4.5.5.6.6.6.7.5.8.6.9.5\"/></defs><clipPath id=\"cn\"><use xlink:href=\"#cm\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cn)\"><defs><path id=\"co\" d=\"M56.3 51.5h9v10h-9z\"/></defs><clipPath id=\"cp\"><use xlink:href=\"#co\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cp)\"><image overflow=\"visible\" width=\"32\" height=\"31\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHNAAACAwAAAoz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAJAMBIgACEQEDEQH/ xACMAAEBAQEAAAAAAAAAAAAAAAAABgUEAQEBAQEBAAAAAAAAAAAAAAAAAgUDBhAAAAUDBQEAAAAA AAAAAAAAAAECBAUQAwYgETQVNRYRAAIBAgQFBQAAAAAAAAAAAAECAxEEABCxcjGREpI0ICFBIjIS AQEAAQUAAwAAAAAAAAAAAAECEQAQICEDYZHB/9oADAMBAAIRAxEAAAChx+mcnf2dGV2VXArz0jOV eFetw7PJqUrxyyQAAP/aAAgBAgABBQA99y3olBGRoIi0f//aAAgBAwABBQBk3sKbuW7dNgNnKUWb 7pKrej//2gAIAQEAAQUAyKZeRt76yWH1cuIGekH8gMz5VMU9cZnyaYp64yqPeu3HRTA6KYGNxci1 k9X/2gAIAQICBj8A3zk0uT74/wD/2gAIAQMCBj8A86vziqRyp869GfOBIcIbRLR0furkTuU4/wD/ 2gAIAQEBBj8AhS36aSKWPUK+4NMcY+3H6j7BgW9wVMZVj9VoajK22Nrmux9MrbY2ua7H0yga2haV VQhivwa48STkMeJJyGFluIHjjCMOpuFT6//Z\" transform=\"matrix(.3599 0 0 -.3599 55.497 62.187)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M65.3 61.4H63.6l-.8-.2-.8-.3-.7-.4-.7-.5-.7-.6-.6-.6-.5-.7-.6-.8-.4-.9-.4-.9-.4-.9-.3-1-.2-1.1-.2-1 .4.1h.3l.4.1.4.1h.4l.3.1.4.1.3.1.2.6.2.6.1.6.2.6.1.6.2.6.3.6.2.6.3.6.4.6.4.5.5.6.6.6.7.5.8.6.9.5z\"/><g><defs><path id=\"cq\" d=\"M69.9 62l-1.1.1-1.1-.1-1-.2-.9-.2-.9-.4-.9-.5-.7-.6-.7-.7-.7-.7-.5-.8-.5-.8-.5-1-.4-.9-.3-1-.2-1.1-.2-1h.3l.4.1.3.1h.4l.3.1.4.1h.4l.3.1.2.7.1.8.3.7.2.7.4.7.4.6.4.7.5.6.5.7.6.5.6.6.6.5.7.5.8.4.7.4.8.3\"/></defs><clipPath id=\"cr\"><use xlink:href=\"#cq\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cr)\"><defs><path id=\"cs\" d=\"M59.3 52.1h10.6v10H59.3z\"/></defs><clipPath id=\"ct\"><use xlink:href=\"#cs\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ct)\"><image overflow=\"visible\" width=\"36\" height=\"31\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHxAAACKgAAAsj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAJwMBIgACEQEDEQH/ xACoAAEBAAMBAQAAAAAAAAAAAAAABgEDBQQHAQEAAwEBAAAAAAAAAAAAAAACAAMFAQQQAAADBQcF AQAAAAAAAAAAAAABBBARAgMFQRITNCUGNiExFCQWFREAAQICBQoHAQAAAAAAAAAAAQACEQMgQbES ojFhkXKyE0MENHQhoZIzcxRkBRIAAQIEAwkAAAAAAAAAAAAAAQAREDECQmESEyFBgaGxMpIDY//a AAwDAQACEQMRAAAAruf45wbVdiST0fRXhPD5c5Rzi1TBW3AGL1NRKw7N4J//2gAIAQIAAQUAMze8 xYUszBSjDupMt//aAAgBAwABBQBIgTzJH5qQXIfISTihTmpIXvYLsz//2gAIAQEAAQUAqlbkUyM9 4ox9mkH2aUS6hBHTN55pqbiu8801NxXeeaeHh4TcUn+I/SxpY0sFg4X/2gAIAQICBj8AnF4Niy3q 6H//2gAIAQMCBj8AorrBNVQL7cV2nyK07dXLwzMvWHkD1U1m+r81crof/9oACAEBAQY/AGMmsc8z AXCBAyGC9h+kLp36QummeoI/0QwhglOm3K4NBMPJct8braB7SZsuXLajraB7WZsuXLajraBP5Jmy 5D7G7jVvLsYZry4GBcDAuBgXhd3MDkhcu15oL//Z\" transform=\"matrix(.3599 0 0 -.3599 58.578 62.865)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M69.9 62l-1.1.1-1.1-.1-1-.2-.9-.2-.9-.4-.9-.5-.7-.6-.7-.7-.7-.7-.5-.8-.5-.8-.5-1-.4-.9-.3-1-.2-1.1-.2-1h.3l.4.1.3.1h.4l.3.1.4.1h.4l.3.1.2.7.1.8.3.7.2.7.4.7.4.6.4.7.5.6.5.7.6.5.6.6.6.5.7.5.8.4.7.4.8.3z\"/><g><defs><path id=\"cu\" d=\"M72.5 62.3l-1-.1-.9-.1-.9-.3-.9-.3-.8-.4-.9-.5-.7-.5-.8-.7-.6-.7-.6-.7-.6-.8-.5-.8-.4-.9-.3-.9-.3-1-.2-1 .4.1h.5l.3.1h.2l.3.1h.4l.4.1.4.8.3.8.3.7.4.7.3.7.3.6.4.6.3.5.4.5.5.5.5.5.6.5.7.5.7.5.8.4 1 .5\"/></defs><clipPath id=\"cv\"><use xlink:href=\"#cu\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cv)\"><defs><path id=\"cw\" d=\"M62.1 52.6h10.3v9.6H62.1z\"/></defs><clipPath id=\"cx\"><use xlink:href=\"#cw\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cx)\"><image overflow=\"visible\" width=\"36\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHYAAACEwAAApX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AJwMBIgACEQEDEQH/ xACYAAACAgMBAAAAAAAAAAAAAAAABgMFAQIEBwEAAgMBAAAAAAAAAAAAAAAABAUAAQIDEAABAwMD BAMAAAAAAAAAAAACAAEDEQQFEBUGIUESJCI0RBEAAQIEAwUJAAAAAAAAAAAAAQACESESA0GTBCCh wTI0MVFhkbEiwnODEgACAwACAwAAAAAAAAAAAAABAgARIRBBYRKS/9oADAMBAAIRAxEAAAB5hraQ I9rjUYYT6KaBqhUXmql20rzvN2+GTiq//9oACAECAAEFAJBmeRo5tBjF00cWn//aAAgBAwABBQCC yOQBxjqnWC/GOEsi7rv/AP/aAAgBAQABBQCeUwJ7s2T39EWUZlX48gv2tbg8zVHlpHRZCclX1uZf e0qy/LyjHldXeyGtkNbIS8fX/9oACAECAgY/AG9WYC8ozXb64ssBNYcf/9oACAEDAgY/AFYDGm1K 8xE7UVMIlz//2gAIAQEBBj8AAaYAhTcNym8eS5vRVeEVbYTCpkd5UiSpBdyjjRwVj6vk7Y/PgrTx qLFmm3Cm9cFtx9xmAcF12jz2rrtFntXXaLPaqYjkhHDsX//Z\" transform=\"matrix(.3599 0 0 -.3599 61.414 63.058)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M72.5 62.3l-1-.1-.9-.1-.9-.3-.9-.3-.8-.4-.9-.5-.7-.5-.8-.7-.6-.7-.6-.7-.6-.8-.5-.8-.4-.9-.3-.9-.3-1-.2-1 .4.1h.5l.3.1h.2l.3.1h.4l.4.1.4.8.3.8.3.7.4.7.3.7.3.6.4.6.3.5.4.5.5.5.5.5.6.5.7.5.7.5.8.4 1 .5z\"/><g><defs><path id=\"cy\" d=\"M77.1 62.6h-2.7l-1.2-.2-1.1-.4-1-.4-.9-.5-.8-.6-.8-.7-.7-.7-.6-.8-.6-.9-.5-.9-.5-.9-.4-.8-.4-1-.4-.9.3.1h.3l.5.1h.4l.4.1.5.1h.3l.3.1.3.8.4.8.4.7.4.7.5.7.5.7.6.6.6.6.6.5.7.5.6.5.8.5.7.4.8.4.8.4.9.4\"/></defs><clipPath id=\"cz\"><use xlink:href=\"#cy\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cz)\"><defs><path id=\"cA\" d=\"M64.5 52.9h12.6v9.7H64.5z\"/></defs><clipPath id=\"cB\"><use xlink:href=\"#cA\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cB)\"><image overflow=\"visible\" width=\"40\" height=\"31\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHnAAACGgAAAq7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAKgMBIgACEQEDEQH/ xACeAAEBAQEBAQAAAAAAAAAAAAAABgcCAQUBAAIDAQAAAAAAAAAAAAAAAAADAQIFBBAAAAUFAAMB AAAAAAAAAAAAAAECAwQQERMzBiAFFRYRAAEBAgsIAwAAAAAAAAAAAAECADIQIBEhQZGxcpLSBDAx URIiAxM0YYIUEgABBAACCwEAAAAAAAAAAAACAAERMRAgIUFRYZGx0SKiAxMz/9oADAMBAAIRAxEA AACr+ZxM026fyZHTT1WYafKpSZp5piuXSzvdOzLTRILxQAA//9oACAECAAEFADve5i52JFwTRjEd 6//aAAgBAwABBQCHCjuR/nxAcKLniPkmOcogcks1f//aAAgBAQABBQD3PuvlqPsrA+0UP2jgR2bq ljtNtWto7TbVraOzStTuN0Y3RjdDTbuXz//aAAgBAgIGPwC1eE4Rk//aAAgBAwIGPwADMZIpnS+1 fn5P1Qj8+1/WZO0vbOMa96AZqeatC80BNxccn//aAAgBAQEGPwDtJ8Y7nlCjOZJOWT4PFvWGM5Wm 0oxnK3qDGcrJT+RM5AfNP1g0l1dqYiLwtg0l1dqYiLwtg0nKknpXuEtKWcVUWcVUWcVUWR0KeFB4 7D//2Q==\" transform=\"matrix(.3599 0 0 -.3599 63.588 63.588)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M77.1 62.6h-2.7l-1.2-.2-1.1-.4-1-.4-.9-.5-.8-.6-.8-.7-.7-.7-.6-.8-.6-.9-.5-.9-.5-.9-.4-.8-.4-1-.4-.9.3.1h.3l.5.1h.4l.4.1.5.1h.3l.3.1.3.8.4.8.4.7.4.7.5.7.5.7.6.6.6.6.6.5.7.5.6.5.8.5.7.4.8.4.8.4.9.4z\"/><g><defs><path id=\"cC\" d=\"M79.8 63l-.8-.1-.8-.1-.8-.2-.9-.3-.9-.4-.9-.4-.9-.6-.9-.6-.8-.7-.9-.7-.8-.8-.7-.9-.7-.8-.6-1-.5-1-.4-1h.4l.4.1h.5l.5.1h.4l.3.1h.3l.1.1.6.4.5.4.5.5.6.6.5.5.6.6.6.7.5.6.6.7.6.6.6.6.7.7.6.6.6.6.6.5.7.6\"/></defs><clipPath id=\"cD\"><use xlink:href=\"#cC\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cD)\"><defs><path id=\"cE\" d=\"M67.5 53.4h12.3V63H67.5z\"/></defs><clipPath id=\"cF\"><use xlink:href=\"#cE\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cF)\"><image overflow=\"visible\" width=\"40\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHoAAACKwAAAsX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAKgMBIgACEQEDEQH/ xACbAAEBAAMBAQAAAAAAAAAAAAAABgIDBAUHAQADAAMAAAAAAAAAAAAAAAAAAwQBAgUQAAAGAQMF AAAAAAAAAAAAAAABAgMEBRQQEhMgIxU1BhEAAQIDBwIHAAAAAAAAAAAAAQACESEDEKHRMpMENCCx MDFRYRJCcxIAAQIEBAcAAAAAAAAAAAAAAQAhETECEiBBoRNRYbEiMkJj/9oADAMBAAIRAxEAAAC7 w4vJjro8ZXnw+y6om2aSU3Tz1T9LaZv1fQoG+JgTzAAA/9oACAECAAEFAHHHicJUgx3tiWTUCjkO FO7X/9oACAEDAAEFAGoqnEprVmPHnzRZiG2FWAy1c+v/2gAIAQEAAQUAdeJs8ohlpBzmyCJzS3Bb zSjLcuUkHLogu5MxU2Lj1oPszMpOtF7cfXx5DsnBnjBsBgWApIUxFt1//9oACAECAgY/AKhSWyZT 0C8u67gJKLOnIVsfWOD/2gAIAQMCBj8AFQpmpLa+d8+cFRRmAeqZbnzt1jg//9oACAEBAQY/AAIR ist6y3qYvTaY83GAnZTBMPk0m9ZlmUolbZhEnPhZtgD9Hd+ja/oO1m3NGk+oAwxLGl0J+y41XTdg uNV03YLjVtN2C2r30KjWB8S5zHACXqR4H//Z\" transform=\"matrix(.3599 0 0 -.3599 66.506 63.788)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M79.8 63l-.8-.1-.8-.1-.8-.2-.9-.3-.9-.4-.9-.4-.9-.6-.9-.6-.8-.7-.9-.7-.8-.8-.7-.9-.7-.8-.6-1-.5-1-.4-1h.4l.4.1h.5l.5.1h.4l.3.1h.3l.1.1.6.4.5.4.5.5.6.6.5.5.6.6.6.7.5.6.6.7.6.6.6.6.7.7.6.6.6.6.6.5.7.6z\"/><g><defs><path id=\"cG\" d=\"M84 62.9l-.7.5-.8.2h-.8l-.8-.2-.8-.4-.8-.5-.8-.7-.9-.8-.8-.9-.9-.9-.9-1-.9-.9-.8-1-1-.9-.9-.9-.9-.8h.3l.4.1h.4l.4.1.5.1.5.1h.4l.4.1.7.7.7.6.7.7.7.7.6.7.7.7.7.7.6.6.6.6.7.6.6.5.6.5.6.4.6.3.5.3.6.1\"/></defs><clipPath id=\"cH\"><use xlink:href=\"#cG\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cH)\"><defs><path id=\"cI\" d=\"M70.5 53.7H84v9.9H70.5z\"/></defs><clipPath id=\"cJ\"><use xlink:href=\"#cI\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cJ)\"><image overflow=\"visible\" width=\"44\" height=\"31\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHkAAACIgAAAtL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEALwMBIgACEQEDEQH/ xACZAAEBAQEBAQAAAAAAAAAAAAAABgMFAQQBAAMAAwAAAAAAAAAAAAAAAAACBAEDBRAAAQMDBAID AAAAAAAAAAAABAABAwIFBhAgERQ0NiESFhEAAQIDBAkFAAAAAAAAAAAAAgEDABHREqJzkyAhQVGx wjMENDFhItIFEgACAgAFBQAAAAAAAAAAAAABAgARECAhMQNRoRIiM//aAAwDAQACEQMRAAAAp+Zn PJ3aPydFFD3IKwzF8E9S8F3wbm24WErWEXfCcwAAP//aAAgBAgABBQB+eflNymo5TRqqj6tr/9oA CAEDAAEFABAx64OiIriPBHCKRTTA5VKOnauLX//aAAgBAQABBQC9XyS2zvmM6fMik+ZGL9kcg7pM RZcy87Za/U8y87Za/U8tGJmN6By6J66J66J6tkM1OLbv/9oACAECAgY/ANzN8LwvJ//aAAgBAwIG PwDjd0tmGs+Y7wNxoFbzAsdKM41JGgm4gUG/cHJ//9oACAEBAQY/AAaABJDC18p71TYvtHSbvVjU y3erGphu9WOg1e+0OfokAo6AOmgJOzNu1LbPZDGFzFovYXccDhjC5i0XsLuOBwyTLRuIjUlUBUkn aLckeM7llSPGdyypHjO5ZUjxncsqQ80TZC6rT6ICiqFNbUtXrp//2Q==\" transform=\"matrix(.3599 0 0 -.3599 69.46 64.424)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M84 62.9l-.7.5-.8.2h-.8l-.8-.2-.8-.4-.8-.5-.8-.7-.9-.8-.8-.9-.9-.9-.9-1-.9-.9-.8-1-1-.9-.9-.9-.9-.8h.3l.4.1h.4l.4.1.5.1.5.1h.4l.4.1.7.7.7.6.7.7.7.7.6.7.7.7.7.7.6.6.6.6.7.6.6.5.6.5.6.4.6.3.5.3.6.1z\"/><g><defs><path id=\"cK\" d=\"M87.2 63.3h-1.1l-1.2-.1-1-.3-.9-.4-.9-.4-.9-.6-.8-.6-.7-.7-.8-.7-.7-.8-.7-.8-.7-.8-.7-.8-.7-.8-.8-.7-.8-.7h.3l.3.1h.4l.5.1h.7l.3.1h.2l.5.1.5.2.5.3.5.5.5.5.5.6.6.6.6.7.7.7.6.7.8.8.7.7.9.7.9.7.9.6 1 .5\"/></defs><clipPath id=\"cL\"><use xlink:href=\"#cK\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cL)\"><defs><path id=\"cM\" d=\"M73.8 54.1h13.5v9.2H73.8z\"/></defs><clipPath id=\"cN\"><use xlink:href=\"#cM\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cN)\"><image overflow=\"visible\" width=\"44\" height=\"29\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHeAAACLgAAAt//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8ALwMBIgACEQEDEQH/ xACWAAEAAwEBAAAAAAAAAAAAAAAGAwQFAAEBAAMBAQAAAAAAAAAAAAAAAAIDBAEFEAABBQABBAMA AAAAAAAAAAABAAIDBAUREhMGFjQmNhEAAQMCAwUJAAAAAAAAAAAAAQACAxEEIZESMTJy0zUgsSJC YqLCc7MSAAICAQIHAQAAAAAAAAAAAAECABESITFBUWFxkaEiMv/aAAwDAQACEQMRAAAAdVKxWbor 4iEY1rb4BU5Eo90foVi+bfMLEV5+7k//2gAIAQIAAQUAlZIXiORRscC1sZAEIUhj6f/aAAgBAwAB BQCrSMsbcxiu1Iooa93tRG+4qewZG//aAAgBAQABBQCzL2mHR4TtbhO2yE/feFT0HT5vk9o1qjtS Yp16w5GeZyLnFYv5fzL4PIXIXUupYp+reRUobtX16gvXqC9eoL16gs2hBBif/9oACAECAgY/ADiz AdDNXbyZZZm7y2ajN587z//aAAgBAwIGPwAPwJM1ImS1lkBAnIn3P1KLXrP/2gAIAQEBBj8ADq0q aLeGQW93LAhYOGQU12SCYw+h4W6lE4eaSntKwC20WLisSSr3hn/NQfb8Xdm+Ppn/ADUUc11HaBsm oPkIAJoRQVLV1i2zbzF1i2zbzF1i2zbzF1i2zbzFc2rLuOaOQSh1w0jQzUyhr4ju7dq//9k=\" transform=\"matrix(.3599 0 0 -.3599 72.954 64.078)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M87.2 63.3h-1.1l-1.2-.1-1-.3-.9-.4-.9-.4-.9-.6-.8-.6-.7-.7-.8-.7-.7-.8-.7-.8-.7-.8-.7-.8-.7-.8-.8-.7-.8-.7h.3l.3.1h.4l.5.1h.7l.3.1h.2l.5.1.5.2.5.3.5.5.5.5.5.6.6.6.6.7.7.7.6.7.8.8.7.7.9.7.9.7.9.6 1 .5z\"/><g><defs><path id=\"cO\" d=\"M23.3 39.7v-1.5l-.1-.8.1-.7v-.8l.1-.9.1-.7.3-.8.3-.7.4-.5.5-.4.6-.2.8-.1.9.3-.3.3-.3.3-.2.4-.3.5-.2.5-.2.5-.2.6-.2.6-.2.6-.1.6-.2.6-.1.6-.1.5-.1.6-.1.5-.1.4H24.1l-.1-.1h-.1l-.1-.1h-.1l-.2-.1h-.2\"/></defs><clipPath id=\"cP\"><use xlink:href=\"#cO\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cP)\"><defs><path id=\"cQ\" d=\"M23.2 31.6h4V40h-4z\"/></defs><clipPath id=\"cR\"><use xlink:href=\"#cQ\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cR)\"><image overflow=\"visible\" width=\"16\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGnAAAB0QAAAk3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AEwMBIgACEQEDEQH/ xACCAAADAAMAAAAAAAAAAAAAAAAABAYBBQcBAQEBAAAAAAAAAAAAAAAAAAQBBRAAAQQCAwEAAAAA AAAAAAAABQABAwQCBhESJRMRAAIBAgcBAQAAAAAAAAAAAAECAxIEABARIbETc0EiEgACAgIDAAAA AAAAAAAAAAABERASITFBUTL/2gAMAwEAAhEDEQAAANonhBSekAFNEoVS90aMCZ3/2gAIAQIAAQUA bp812fhf/9oACAEDAAEFAMYnfBR2YGgX/9oACAEBAAEFANmNk6BEXsRmwRW4tyXC4+stvb1gzeqi 4wNat0w+vw21/9oACAECAgY/ABgOvUKP/9oACAEDAgY/AGh5cUJNqLXMf//aAAgBAQEGPwAQWk3X GY1amhG3Jb6yk/MW0E1xVFJIqutEY1BO+4TXJfFOWxZ+qc5DyXlsWnqnOQlvrvomoAo7I0/IJ0Oj gnEMsF92TI4Mad0TVMDsNFXU5f/Z\" transform=\"matrix(.3599 0 0 -.3599 22.264 41.02)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M23.3 39.7v-1.5l-.1-.8.1-.7v-.8l.1-.9.1-.7.3-.8.3-.7.4-.5.5-.4.6-.2.8-.1.9.3-.3.3-.3.3-.2.4-.3.5-.2.5-.2.5-.2.6-.2.6-.2.6-.1.6-.2.6-.1.6-.1.5-.1.6-.1.5-.1.4H24.1l-.1-.1h-.1l-.1-.1h-.1l-.2-.1h-.2z\"/><g><defs><path id=\"cS\" d=\"M24.4 40.1l.4-1.9.4-1.5.4-1.4.4-1.1.4-.9.4-.7.4-.5.4-.4.4-.3.3-.1h.4l.3.1.3.1.3.1.3.2.2.2-.4.3-.4.5-.4.4-.3.4-.4.5-.3.5-.3.5-.2.5-.3.5-.2.6-.2.6-.2.6-.2.6-.2.6-.1.7-.2.7-.3-.1h-.3l-.2-.1h-.2l-.1-.1h-.1l-.2-.1\"/></defs><clipPath id=\"cT\"><use xlink:href=\"#cS\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cT)\"><defs><path id=\"cU\" d=\"M24.4 31.3h5.7v9.2h-5.7z\"/></defs><clipPath id=\"cV\"><use xlink:href=\"#cU\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cV)\"><image overflow=\"visible\" width=\"20\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHLAAAB/QAAApb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAFgMBIgACEQEDEQH/ xACZAAEBAQEBAAAAAAAAAAAAAAAABgUDBAEAAgMBAAAAAAAAAAAAAAAAAAQBAgMFEAAABAYCAwAA AAAAAAAAAAABAwQFABECEhMGEBYiJjYRAAECBAMGBwAAAAAAAAAAAAECAwAREgQQcgUhMbGy0jQg QVEikqITEgABAwIEBwAAAAAAAAAAAAABABECITEQIBJCkaEyUqITFP/aAAwDAQACEQMRAAAApMbv LssWDIVtozNhg4vdXtRNcDjAH//aAAgBAgABBQAukuyVE7xALh5//9oACAEDAAEFACybqcHkjxYZ lZOP/9oACAEBAAEFANifVDTX3dwhNs6s5q3gJmhTCAPXt1CZsoQfP7S2rVxnXnmEjO5Fs3P/2gAI AQICBj8ABIcq2/kybJ//2gAIAQMCBj8ABZM2/T4uoapwia0MgDddcG+juFvVfjj/AP/aAAgBAQEG PwBhLLaHA6FE1z2Uy3SI9Y7dn7dUXt8ppsOWpbCEiqk/oqkz2xZ5XOKcNVzMc4i0yr4pw1TMxziL Y2rRdCAsKkQJTKZbyI7VXyT1RqFutgh54tFtE0+6lc1efg//2Q==\" transform=\"matrix(.3599 0 0 -.3599 23.662 41.41)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M24.4 40.1l.4-1.9.4-1.5.4-1.4.4-1.1.4-.9.4-.7.4-.5.4-.4.4-.3.3-.1h.4l.3.1.3.1.3.1.3.2.2.2-.4.3-.4.5-.4.4-.3.4-.4.5-.3.5-.3.5-.2.5-.3.5-.2.6-.2.6-.2.6-.2.6-.2.6-.1.7-.2.7-.3-.1h-.3l-.2-.1h-.2l-.1-.1h-.1l-.2-.1z\"/><g><defs><path id=\"cW\" d=\"M25.8 40.7l.1-.7.2-.8.2-.9.3-.9.4-.9.4-1 .4-.8.6-.9.5-.7.6-.7.6-.4.6-.4.7-.1.6.1.7.4.6.7-.5.3-.5.5-.4.4-.5.4-.4.5-.4.5-.3.5-.3.5-.3.6-.3.6-.3.6-.2.6-.2.7-.1.7-.1.7-.2.7H28l-.3-.2-.4-.1-.4-.1-.3-.2-.3-.1-.3-.1h-.2\"/></defs><clipPath id=\"cX\"><use xlink:href=\"#cW\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cX)\"><defs><path id=\"cY\" d=\"M25.8 31.5h7.5v10h-7.5z\"/></defs><clipPath id=\"cZ\"><use xlink:href=\"#cY\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cZ)\"><image overflow=\"visible\" width=\"28\" height=\"32\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHNAAACAQAAAnn/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAHwMBIgACEQEDEQH/ xACRAAEAAwEAAAAAAAAAAAAAAAAGAAQFAQEAAgMBAAAAAAAAAAAAAAAAAQIAAwUEEAAABAUFAQAA AAAAAAAAAAABAgMFABESBAYQMjQWNiYRAAECBAUEAwAAAAAAAAAAAAIBAwAQcwQRQXGxshKi0jQT YwUSAAIBAQkAAAAAAAAAAAAAAAABEQIgITFhgbESImL/2gAMAwEAAhEDEQAAAFODeH9VyLeAMFPS K8lVocXElqtt05BnS5IJ/9oACAECAAEFAEiEEiwEAoHkAnnr/9oACAEDAAEFAEyVAolSSxRqRcEq bdPart//2gAIAQEAAQUAyF4XaUe7uEd3cIsHhe6ZM34soAsM4fJ5qE7WUSho8pmfF0aPK3u3RHif /9oACAECAgY/AE6kpOqhyRY//9oACAEDAgY/AMJOUReU1ZvcT9oRqf/aAAgBAQEGPwBlxkBNXCUV Q8ckxyVI9dnu8o9dnu8oe/SMBF1oXSQEx6V+NFVM8YtahcZ3SfXccVi2qFtO6p3HFYtqhbTuqb/F YHWZaFtH/9k=\" transform=\"matrix(.3599 0 0 -.3599 24.879 42.464)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M25.8 40.7l.1-.7.2-.8.2-.9.3-.9.4-.9.4-1 .4-.8.6-.9.5-.7.6-.7.6-.4.6-.4.7-.1.6.1.7.4.6.7-.5.3-.5.5-.4.4-.5.4-.4.5-.4.5-.3.5-.3.5-.3.6-.3.6-.3.6-.2.6-.2.7-.1.7-.1.7-.2.7H28l-.3-.2-.4-.1-.4-.1-.3-.2-.3-.1-.3-.1h-.2z\"/><g><defs><path id=\"da\" d=\"M37 33.1l-.7-.4-.6-.3-.8-.1-.7.1-.7.2-.7.4-.6.5-.7.6-.5.7-.6.8-.5.9-.4.9-.4 1-.3 1-.2 1.1-.1 1 .3.1.4.1.3.1.4.1.3.2.4.1.4.1h.3l.3-.6.2-.7.3-.8.3-.7.2-.7.4-.8.3-.7.3-.7.3-.6.4-.6.4-.6.4-.5.5-.4.4-.4.5-.2.5-.2\"/></defs><clipPath id=\"db\"><use xlink:href=\"#da\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#db)\"><defs><path id=\"dc\" d=\"M28.5 32.3h8.6v10h-8.6z\"/></defs><clipPath id=\"dd\"><use xlink:href=\"#dc\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dd)\"><image overflow=\"visible\" width=\"32\" height=\"32\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHRAAACDAAAApH/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAJAMBIgACEQEDEQH/ xACSAAEBAQEBAAAAAAAAAAAAAAAABgUCBAEAAgMBAQAAAAAAAAAAAAAAAAQBAgMFBhAAAAYDAQAD AAAAAAAAAAAAAAERAgMEEgUGIBM0FhEAAgADBAoDAAAAAAAAAAAAAQIAEQMQEjIEIUFRkbFyksLS cyAxYhIAAgEDBQEAAAAAAAAAAAAAAREAECACITFRsRID/9oADAMBAAIRAxEAAAChxPXMNMbmxGUd dLILpyczUTU9vihwqKutYJ8+AAAB/9oACAECAAEFAI2x4SYIM0LNT8f/2gAIAQMAAQUAjiya+vjG KURHBcY1tbx//9oACAEBAAEFAOl3dzVP/ZbcfstuOc3t7Z2h3BLKTQTRxZJfHaksqBBxv3h2bHOl +KUFBM4cjXliuev/2gAIAQICBj8ABIBMKxAoorf/2gAIAQMCBj8ABUyyWwpgeX3PpqH5t//aAAgB AQEGPwDLrlghFUMWvgnDKUpEbYw0eg+UYaPQfKKtLMhAqU74uKQZzA1k7bMny1OK21/V3LZlOV+K 21/V3LZlLqkyV/oT1rGBtxjQjbjFZnUgGlLSP0Pn/9k=\" transform=\"matrix(.3599 0 0 -.3599 27.609 43.24)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M37 33.1l-.7-.4-.6-.3-.8-.1-.7.1-.7.2-.7.4-.6.5-.7.6-.5.7-.6.8-.5.9-.4.9-.4 1-.3 1-.2 1.1-.1 1 .3.1.4.1.3.1.4.1.3.2.4.1.4.1h.3l.3-.6.2-.7.3-.8.3-.7.2-.7.4-.8.3-.7.3-.7.3-.6.4-.6.4-.6.4-.5.5-.4.4-.4.5-.2.5-.2z\"/><g><defs><path id=\"de\" d=\"M40.2 34l-1.1-.5-1-.3h-.8l-.8.2-.7.3-.6.5-.5.6-.5.7-.5.8-.3.9-.4.9-.4.9-.3 1-.3.9-.4.9-.3.8.3.1h.3l.3.1.2.1.3.1.3.1.3.1.4.1v-.4l.1-.4.1-.5.1-.6.2-.7.3-.7.3-.8.3-.8.5-.8.5-.7.6-.8.7-.6.8-.6 1-.5 1-.4\"/></defs><clipPath id=\"df\"><use xlink:href=\"#de\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#df)\"><defs><path id=\"dg\" d=\"M31.3 33.2h8.9v10.1h-8.9z\"/></defs><clipPath id=\"dh\"><use xlink:href=\"#dg\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dh)\"><image overflow=\"visible\" width=\"32\" height=\"32\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHOAAACCgAAApr/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAIQMBIgACEQEDEQH/ xACQAAEBAQEBAAAAAAAAAAAAAAAABQYDBAEBAQEBAAAAAAAAAAAAAAAAAAIEBRAAAAUEAwEAAAAA AAAAAAAAAAECBAUREgMGIBQWNBEAAgEABwcFAAAAAAAAAAAAAQIDABARIdESc1GxksIzkwQgQWET NBIAAgEEAQUAAAAAAAAAAAAAARECABAgUSExcRIyA//aAAwDAQACEQMRAAAArSe0LZor2sho4vZD NkxEPRRq7fn0Ma/N6sOCAAB//9oACAECAAEFAEFjsyWWi8yK4z4//9oACAEDAAEFAEY7iXgogNca DxOkoJvw/9oACAEBAAEFANknZKPkfWTY9ZNjWJqQkXY3Iqy9oJI0sqPxt5VlqCg037htTVzmk+g+ HQfDUmrnC85f/9oACAECAgY/AIkiLWqKiH2ssv/aAAgBAwIGPwAcVKS6C0CTH13X0Ri/HeP/2gAI AQEBBj8AEHiyBIzGrWFVa8lto+KdZeBcKdZeBcKSxeW4dEjzKAoW/MB7CpdFN7Vz6XMtQ0l3tXPp cy1B4oXkX6lGZVLC21tgp+aXtthT80vbbCkzTRPGpisBZSt+Zdvr/9k=\" transform=\"matrix(.3599 0 0 -.3599 30.234 44.077)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M40.2 34l-1.1-.5-1-.3h-.8l-.8.2-.7.3-.6.5-.5.6-.5.7-.5.8-.3.9-.4.9-.4.9-.3 1-.3.9-.4.9-.3.8.3.1h.3l.3.1.2.1.3.1.3.1.3.1.4.1v-.4l.1-.4.1-.5.1-.6.2-.7.3-.7.3-.8.3-.8.5-.8.5-.7.6-.8.7-.6.8-.6 1-.5 1-.4z\"/><g><defs><path id=\"di\" d=\"M44.3 34.6l-.7-.5-.7-.3-.8-.1h-.8l-.9.2-.9.3-.8.5-.8.5-.8.8-.8.8-.6.9-.6 1-.6 1.1-.4 1.1-.2 1.2-.2 1.3 3 .7.2-.5.2-.5.2-.6.3-.7.4-.7.3-.7.4-.7.4-.7.5-.8.6-.7.5-.6.6-.6.7-.5.7-.5.8-.4.8-.3\"/></defs><clipPath id=\"dj\"><use xlink:href=\"#di\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dj)\"><defs><path id=\"dk\" d=\"M33.7 33.7h10.5v10.5H33.7z\"/></defs><clipPath id=\"dl\"><use xlink:href=\"#dk\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dl)\"><image overflow=\"visible\" width=\"36\" height=\"33\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHWAAACDQAAAn3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAJAMBIgACEQEDEQH/ xACWAAEBAAMBAAAAAAAAAAAAAAAABAEDBwUBAAICAwAAAAAAAAAAAAAAAAEDAgQABQYQAAEDAwIH AQAAAAAAAAAAAAEAAgMQEQUgBBIjFCQlBhY1EQAAAwQLAQEAAAAAAAAAAAABAgMAEBEEICFBodES QpKyM3MidBIAAQMDBQEAAAAAAAAAAAAAEAABITECQkFRkSIyYv/aAAwDAQACEQMRAAAAonjmuW/W z5OV2OpivrObTVynozZSp3RAzltQyeQBsBj/AP/aAAgBAgABBQC0YDnMoZE6UDT/AP/aAAgBAwAB BQBkJcGbQGkMA4LMZp//2gAIAQEAAQUAyHs+Yg3/ANZm19XnEPas3TKt8qGoNVqZQeUtoyn6aZBI 9RbAmh6e/bLt1yaf/9oACAECAgY/AG6202Xm3g1Og//aAAgBAwIGPwBoUsLX+WUuMlkP/9oACAEB AQY/AJlBNUoJpKqEIGQowKUwgFjdxdhcG7i7C4N3F2FwdO/oV5moznurzNRnPdXmLqgg31W4c2SN sYRi2i5tFzabnf/Z\" transform=\"matrix(.3599 0 0 -.3599 33.016 45.132)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M44.3 34.6l-.7-.5-.7-.3-.8-.1h-.8l-.9.2-.9.3-.8.5-.8.5-.8.8-.8.8-.6.9-.6 1-.6 1.1-.4 1.1-.2 1.2-.2 1.3 3 .7.2-.5.2-.5.2-.6.3-.7.4-.7.3-.7.4-.7.4-.7.5-.8.6-.7.5-.6.6-.6.7-.5.7-.5.8-.4.8-.3z\"/><g><defs><path id=\"dm\" d=\"M36.7 44.2l.4.1.5.1.6.2.6.2.6.2.5.1.5.1.4.2.3-.8.3-.7.3-.8.3-.7.4-.8.3-.8.4-.7.3-.7.4-.7.5-.7.4-.6.5-.5.5-.5.6-.4.6-.3.6-.3-.6-.3-.5-.3-.6-.1-.7-.1-.7.1-.7.1-.7.3-.8.5-.7.5-.8.7-.7.9-.7.9-.7 1.2-.7 1.3-.6 1.5-.6 1.6\"/></defs><clipPath id=\"dn\"><use xlink:href=\"#dm\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dn)\"><defs><path id=\"do\" d=\"M36.7 34.6h10.8v10.7H36.7z\"/></defs><clipPath id=\"dp\"><use xlink:href=\"#do\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dp)\"><image overflow=\"visible\" width=\"36\" height=\"34\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAH9AAACOwAAAuz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAJwMBIgACEQEDEQH/ xACuAAEBAQEBAQAAAAAAAAAAAAAABgUBAgQBAAIDAQAAAAAAAAAAAAAAAAIEAQMFABAAAQIEBQEJ AAAAAAAAAAAAAAEFEQIDBBIVBhYmEyAxIkIjM0QlNhEAAAIGBQoHAAAAAAAAAAAAABIBEQIDEwQg MqKDBSGBItJDo7PDFDQxYUJSYnMVEgABAgIFDQAAAAAAAAAAAAAAARExQRAhAhIyUWGxwfEiQjND Y4M0Rf/aAAwDAQACEQMRAAAApcX6ZNu6jTvZsvGcXqS1XLdo870L1QBytLIIN7BY2BOb/9oACAEC AAEFAKVORZFkpIeHqJUhKtQiKKeX/9oACAEDAAEFAJJEVEoROn6tnQxUZbdDD9hbe0vd8n//2gAI AQEAAQUA1E93DQb3cDe7gb3cBse7i8ZtdEDCJKMKcX1wkRJSBAYvzGtuwxR2y/ZMcNOGkmzyyyrL f//aAAgBAgIGPwBFVEeswoQ3XgIlD0cJLUf/2gAIAQMCBj8ASpyBczsWbWV9JAu9ws+5PlYIyPon WxeTaf/aAAgBAQEGPwCXgu2HkY5jryEIpSko9w7dza1h27m1rDt3NrWE3iDx2wy8l4hWWVlTDdoe IWtPmJG+5dDEkffwWRI3vLoYjf8ABZEle8uhiN/wWQ4/VN64RTfE1TMNpvRtN6NE2eIJjpl9Hpxq y6iD+OWqP//Z\" transform=\"matrix(.3599 0 0 -.3599 35.687 46.417)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M36.7 44.2l.4.1.5.1.6.2.6.2.6.2.5.1.5.1.4.2.3-.8.3-.7.3-.8.3-.7.4-.8.3-.8.4-.7.3-.7.4-.7.5-.7.4-.6.5-.5.5-.5.6-.4.6-.3.6-.3-.6-.3-.5-.3-.6-.1-.7-.1-.7.1-.7.1-.7.3-.8.5-.7.5-.8.7-.7.9-.7.9-.7 1.2-.7 1.3-.6 1.5-.6 1.6z\"/><g><defs><path id=\"dq\" d=\"M51.1 36.7l-1.2-.7-1.1-.3-.9-.1-.9.1-.8.4-.8.5-.6.7-.6.8-.5.8-.5 1-.4 1-.4 1-.4 1-.4.9-.3.9-.4.8h.4l.4.1.3.1.3.1h.3l.4.1.3.1.5.1.3-.8.4-.8.3-.7.4-.7.3-.8.4-.6.4-.7.3-.6.5-.6.4-.5.5-.6.5-.4.6-.5.6-.4.7-.4.7-.3\"/></defs><clipPath id=\"dr\"><use xlink:href=\"#dq\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dr)\"><defs><path id=\"ds\" d=\"M40.9 35.6h10.2v10.5H40.9z\"/></defs><clipPath id=\"dt\"><use xlink:href=\"#ds\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dt)\"><image overflow=\"visible\" width=\"36\" height=\"33\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAH5AAACPwAAAun/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAJwMBIgACEQEDEQH/ xACqAAEAAgIDAAAAAAAAAAAAAAAABQYBAgMEBwEAAgMBAAAAAAAAAAAAAAAAAQMCBAUAEAAABQIE BAcAAAAAAAAAAAAAARECAwQFEhUGFhATNCYxQiMzJEQ2EQAABAMFBwUBAAAAAAAAAAAAAQIDERIE oZKyE3MgIUGxIkM0EDJjFAUVEgABAQUECwAAAAAAAAAAAAAAMRABEQISQYGhM2Gx8TJCYoJDYzRE /9oADAMBAAIRAxEAAAC3xKnWW3FT9i30RFkJVC4VLtLXOUb9tZDH7kGB7nIWJsSyv//aAAgBAgAB BQCKNhsOOIgjcZSIRyBQYcPJ/9oACAEDAAEFAGMJxNplHL9WihxQtgIYfn0nsu8Psf/aAAgBAQAB BQC8XiK0xb4pRvilG+KUUl4jqrXrfpUBNBNFnLtPWpLSoECC0flNZ9LwRRaSMtK6gyvk9ogtorHt UUmX5X//2gAIAQICBj8Ac+ZRMSFkSDIs4SxLj//aAAgBAwIGPwBBCjmpJZtL9bKfNDEl9pX5W6p9 153Mzr2n/9oACAEBAQY/AG3HG1OE4o0kSTIoQKPEeK5eSPFcvJHiuXkh39JLakoaS4o2zMonllEU uorDsVRfHUYTFNqK5bFVp1GExTaiuXruFURlvkfwmGf6U8kx5ckYxhxgO/aO/aOnNtDuRN9SVyeP uhDqH//Z\" transform=\"matrix(.3599 0 0 -.3599 39.892 46.856)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M51.1 36.7l-1.2-.7-1.1-.3-.9-.1-.9.1-.8.4-.8.5-.6.7-.6.8-.5.8-.5 1-.4 1-.4 1-.4 1-.4.9-.3.9-.4.8h.4l.4.1.3.1.3.1h.3l.4.1.3.1.5.1.3-.8.4-.8.3-.7.4-.7.3-.8.4-.6.4-.7.3-.6.5-.6.4-.5.5-.6.5-.4.6-.5.6-.4.7-.4.7-.3z\"/><g><defs><path id=\"du\" d=\"M54.6 37.7l-1-.6-1-.3h-1l-.9.1-.8.4-.8.5-.8.6-.7.8-.6.8-.6.9-.5.9-.5 1-.5.9-.4.9-.3.8-.4.8h.5l.4.1.3.1.3.1.4.1h.3l.4.1.5.1.5-1.2.5-1 .5-1 .5-.9.4-.8.5-.7.4-.6.4-.7.5-.4.5-.5.4-.3.5-.4.5-.2.5-.2.6-.1.5-.1\"/></defs><clipPath id=\"dv\"><use xlink:href=\"#du\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dv)\"><defs><path id=\"dw\" d=\"M43.8 36.8h10.8v10H43.8z\"/></defs><clipPath id=\"dx\"><use xlink:href=\"#dw\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dx)\"><image overflow=\"visible\" width=\"36\" height=\"32\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAH3AAACNwAAAuL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAJAMBIgACEQEDEQH/ xACrAAABBQEBAAAAAAAAAAAAAAAAAgMEBQYBBwEAAgMBAAAAAAAAAAAAAAAAAgMBBAUAEAABAgQF AwUAAAAAAAAAAAAAAQISAxMEEBEVBhYFJUYhMiMUNREAAAMEBgcJAQAAAAAAAAAAABESIQITFAEx gYOjBCAis8PjNIRRYZGhQmIDQ2QVEgACAAUBBwUAAAAAAAAAAAAAAREhMUGBoRBRAhIyQgOCQ4M0 hP/aAAwDAQACEQMRAAAAv4lVV2beqMv1dj0cii6WWq7Wsjc4Py1P1Q+HgJSHQ4sBGQAaf//aAAgB AgABBQBGyoXUz0FeOmohEKLh/9oACAEDAAEFAJdvEjLJilNC2kpRV0thEgntXD//2gAIAQEAAQUA 6puvTr/nJzg5ufe7XuhM+uo0yMjxjcyd8yx8Z3N+2jXOJdpMcSrBEIOy3OhV28fE0UTSj46f/9oA CAECAgY/AE2pwV2SWu2p6YlsnYWof//aAAgBAwIGPwBOFUTWp8vJg8b3+PhehNn6Ii+xRU6cHvZL 1P/aAAgBAQEGPwD5cnKxYSdeIk1O0P1Ip7RyONwxyOLwxyOLwx/QR9ExDP2REqLzIZq72bmh0O5G Zu9m5odDuRmbvZuBlBhrA2gxD/KnDIPTcpMMXFhrqoI1NqGrJ2QgyWshhkvYgemEnuSkvAiH/9k=\" transform=\"matrix(.3599 0 0 -.3599 43.019 47.715)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M54.6 37.7l-1-.6-1-.3h-1l-.9.1-.8.4-.8.5-.8.6-.7.8-.6.8-.6.9-.5.9-.5 1-.5.9-.4.9-.3.8-.4.8h.5l.4.1.3.1.3.1.4.1h.3l.4.1.5.1.5-1.2.5-1 .5-1 .5-.9.4-.8.5-.7.4-.6.4-.7.5-.4.5-.5.4-.3.5-.4.5-.2.5-.2.6-.1.5-.1z\"/><g><defs><path id=\"dy\" d=\"M57.3 38.5l-1-.5-1-.2h-.9l-.9.1-.8.4-.8.5-.7.6-.7.7-.6.8-.5.9-.6.9-.4.9-.5.9-.4.8-.3.8-.3.7.3.1.3.1h.3l.3.1.3.1h.4l.3.1.4.1.1-.6.3-.6.3-.7.4-.6.4-.7.5-.7.5-.7.5-.7.6-.6.6-.7.6-.5.6-.5.6-.5.6-.4.6-.2.6-.2\"/></defs><clipPath id=\"dz\"><use xlink:href=\"#dy\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dz)\"><defs><path id=\"dA\" d=\"M46.9 37.8h10.5v9.6H46.9z\"/></defs><clipPath id=\"dB\"><use xlink:href=\"#dA\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dB)\"><image overflow=\"visible\" width=\"36\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHWAAACFQAAArz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AJwMBIgACEQEDEQH/ xACWAAADAQEBAAAAAAAAAAAAAAAABQYBBAIBAQADAQAAAAAAAAAAAAAAAAQAAQIFEAABAwMDAwUA AAAAAAAAAAABAAIFEQMEEgYWEBMVQRQkJjYRAAIBAgIJBQAAAAAAAAAAAAECAwAEESEgQdESkrIz c5MxYbETNBIAAQQBBAMAAAAAAAAAAAAAAQARAhIhEGGRMmITM//aAAwDAQACEQMRAAAApJt1HpQ3 FPq0XByhyklbTdPW6x3LXZ0k5H//2gAIAQIAAQUAtBmgm2qjXqIBcV6f/9oACAEDAAEFALVoua3F qu2O/hvsCyL+KFrZ73//2gAIAQEAAQUA3RJ5kbY5ZNrlk4uVzijZLMyNv73FcUNQaqKIH1Teg+LR U6RH5XdGIcrH8K5eFchCqOw22oD/2gAIAQICBj8ADgErrHhO2HTa/wD/2gAIAQMCBj8ABZZCp51U bzjGTnBO6+sOVdxT3PbZ1//aAAgBAQEGPwCB7RwjSOVbFQ2QGOuusvAuyusvAuyusvAuyp76Vwbi NJirboAxRSVy9Kte43LoXXbuOU1bdxvjQuu3PymoFE0UO65OMziMHLVjX7bPzrX7bPzrWd9Z+dan thNE4ZJR9quGjG8pGbe2uv/Z\" transform=\"matrix(.3599 0 0 -.3599 45.944 48.124)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M57.3 38.5l-1-.5-1-.2h-.9l-.9.1-.8.4-.8.5-.7.6-.7.7-.6.8-.5.9-.6.9-.4.9-.5.9-.4.8-.3.8-.3.7.3.1.3.1h.3l.3.1.3.1h.4l.3.1.4.1.1-.6.3-.6.3-.7.4-.6.4-.7.5-.7.5-.7.5-.7.6-.6.6-.7.6-.5.6-.5.6-.5.6-.4.6-.2.6-.2z\"/><g><defs><path id=\"dC\" d=\"M60.6 39.3l-1.1-.6-1-.2h-1l-1 .3-1 .5-.9.6-.9.8-.8.9-.7.9-.7.9-.6.9-.4.9-.5.8-.3.7-.1.5-.1.2.4.1.4.1.4.1.3.1.4.1h.3l.4.1h.4l.2-.4.3-.6.4-.7.4-.7.4-.8.5-.7.5-.8.5-.8.5-.7.6-.7.6-.6.6-.4.6-.4.7-.3.6-.1h.7\"/></defs><clipPath id=\"dD\"><use xlink:href=\"#dC\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dD)\"><defs><path id=\"dE\" d=\"M49.5 38.5h11.1v9.6H49.5z\"/></defs><clipPath id=\"dF\"><use xlink:href=\"#dE\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dF)\"><image overflow=\"visible\" width=\"36\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHnAAACKgAAAtb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAJwMBIgACEQEDEQH/ xACeAAEAAgMAAAAAAAAAAAAAAAAABQYBAwQBAAMBAQAAAAAAAAAAAAAAAAACBAMFEAAABgAGAgMA AAAAAAAAAAAAAQIDBAUQERITFAYgFiE0NREAAgADAwkJAAAAAAAAAAAAAQIAEQMhBDQgYbHREpLS c5MQMVFxIhMzswUSAAEDAgQHAAAAAAAAAAAAAAEAESExAiBhEhMQcYGhIsID/9oADAMBAAIRAxEA AAC0R2it7V2xVMrVfEOSVW7RBL0+XMj2ZUb0mbkTI0gAAD//2gAIAQIAAQUASTek9A+MzVkFOjUe 3j//2gAIAQMAAQUAZjEtKYCDGwnlwiRxzfZSN0ufj//aAAgBAQABBQC67Aiod94aHu7Q92aEC+RN g91LOURDIZCg/C7p9rAiMxRNrTR9ujSHpKayeoN00oNVTxCvirbr/H//2gAIAQICBj8ABInmoCy4 UK1YP//aAAgBAwIGPwAXEVUjutlvF2bo6+ZuutEGpzUEFbkNq9cH/9oACAEBAQY/AKVNqBre6paY bZlIy8DGDbqDhjBt1BwxhG3xwxer4KJQXVWYoWntbKl++WaLty205H6vLf62i7cttPbYJx+oCLWp vLptF3NGk9QBCCUUtK3NGHqDzRtUeqjU3Tqj4W3TF7plCC6sACLTNSMr/9k=\" transform=\"matrix(.3599 0 0 -.3599 48.547 48.842)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M60.6 39.3l-1.1-.6-1-.2h-1l-1 .3-1 .5-.9.6-.9.8-.8.9-.7.9-.7.9-.6.9-.4.9-.5.8-.3.7-.1.5-.1.2.4.1.4.1.4.1.3.1.4.1h.3l.4.1h.4l.2-.4.3-.6.4-.7.4-.7.4-.8.5-.7.5-.8.5-.8.5-.7.6-.7.6-.6.6-.4.6-.4.7-.3.6-.1h.7z\"/><g><defs><path id=\"dG\" d=\"M62.9 40.2l-.9-.6-.9-.3-.9-.1-.9.1-.8.4-.7.5-.8.6-.6.8-.7.8-.6.9-.5.9-.5.9-.5.9-.4.8-.3.7-.3.6h.4l.3.1.2.1.3.1.2.1.2.1h.3l.2.1.3-.7.3-.8.3-.7.4-.6.4-.7.4-.7.4-.6.5-.6.5-.6.6-.5.6-.5.6-.4.7-.4.7-.3.7-.2.8-.2\"/></defs><clipPath id=\"dH\"><use xlink:href=\"#dG\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dH)\"><defs><path id=\"dI\" d=\"M52.6 39.2h10.3v9.5H52.6z\"/></defs><clipPath id=\"dJ\"><use xlink:href=\"#dI\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dJ)\"><image overflow=\"visible\" width=\"36\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHkAAACJgAAAsn/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAJwMBIgACEQEDEQH/ xACbAAEAAgMBAAAAAAAAAAAAAAAABAYBAgUDAQACAwEAAAAAAAAAAAAAAAAABAEDBQIQAAAFAwQC AwAAAAAAAAAAAAABAgMEEQUGEBITFiEVIBQ2EQABAwIEBAcBAAAAAAAAAAACAAEDEQQgsRI0kXKS cyExQVFxEyMFEgABAwIFBQAAAAAAAAAAAAABABECIRIQIEEDE2GhMpJj/9oADAMBAAIRAxEAAAC0 cWTUmWLJmt7F9/QVCvlVLnXI0+fmfvy73kgYvZEqAAB//9oACAECAAEFAG0t7DJseN28yI1GK+Nf /9oACAEDAAEFAG2tyUxCMcZc8ImuElMENyfu6//aAAgBAQABBQDIL07aEd4lDu8sd2liHdnJFlzg qtEkEkUFq/JZqVWqCmlr/J5VBlzG/RXceiu4Tj92MQIL7WPfH//aAAgBAgIGPwAGQcrxC6OmwfJ/ /9oACAEDAgY/AAWVQuP6W91G6cImtDIDVV3Nv2CucW87vo12T//aAAgBAQEGPwCAo4hl+1yZ9Tu1 NNPb5W1j6iW1j6iW1j6iUn9MoxEwCU2jZ3p+eqnGis+aTIcE3auMjVpzHkOCbtXGRq2a2iKVwc3L T6VYaLaycGW1Pgy8bc2UtmYO0xRzCwv51PVTPF//2Q==\" transform=\"matrix(.3599 0 0 -.3599 51.78 49.544)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M62.9 40.2l-.9-.6-.9-.3-.9-.1-.9.1-.8.4-.7.5-.8.6-.6.8-.7.8-.6.9-.5.9-.5.9-.5.9-.4.8-.3.7-.3.6h.4l.3.1.2.1.3.1.2.1.2.1h.3l.2.1.3-.7.3-.8.3-.7.4-.6.4-.7.4-.7.4-.6.5-.6.5-.6.6-.5.6-.5.6-.4.7-.4.7-.3.7-.2.8-.2z\"/><g><defs><path id=\"dK\" d=\"M65.9 40.9l-.8-.3-.8-.2-.9-.1-.8.1-.8.2-.8.2-.8.4-.8.5-.7.6-.7.7-.6.7-.7.9-.6.9-.5 1-.5 1.1-.4 1.1h.3l.4.1.4.1.4.1.3.1.4.1.4.1h.4l.2-.6.3-.7.2-.6.3-.7.3-.6.3-.6.4-.6.4-.6.5-.5.5-.6.6-.5.7-.4.7-.4.8-.4 1-.3 1-.3\"/></defs><clipPath id=\"dL\"><use xlink:href=\"#dK\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dL)\"><defs><path id=\"dM\" d=\"M54.7 40.3h11.2v9H54.7z\"/></defs><clipPath id=\"dN\"><use xlink:href=\"#dM\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dN)\"><image overflow=\"visible\" width=\"36\" height=\"29\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHiAAACIwAAAuP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AJwMBIgACEQEDEQH/ xACeAAADAAMAAAAAAAAAAAAAAAAABQYBAwQBAQADAQAAAAAAAAAAAAAAAAQBAgMFEAAABgICAQUA AAAAAAAAAAAAAQIDBAUUBhEWEBIiEzM0EQACAQICBQkJAAAAAAAAAAABAgMABBEhURKSM9MQMXGx 0SIycgUggeGishMUNHQSAAEDAwQDAAAAAAAAAAAAAAEAEQIhMSJREoITEEGB/9oADAMBAAIRAxEA AACmR90ps59lCUZYCsoVhKWiGEqdjvqyRoHBPN//2gAIAQIAAQUASaPSakjkgZmFKWPf8f8A/9oA CAEDAAEFAI8YloRBbGOjNhPx0MKnxyGSWb//2gAIAQEAAQUA2O5lVSO6Wo7najuVoKvYZsyNuxct cDjxr/4d0+rwhhxYo4ym4OzwsxtNE2GqeMkN1jBCFEbbY//aAAgBAgIGPwAOA6sE/ikSrZafV//a AAgBAwIGPwASId3VYhdW3FrcXUROcYyG5x7usZAruemvFl//2gAIAQEBBj8Aga2SNzKWDfcBPhw5 tVl01urfZfiVuoNl+JW6g2X4lX00qRBrWEyRhQwBIDHvYsdFWnmfqX2PV/5j9MlWnmfqXlyGFeqA 8725HyvVuPyILfUL5zvqBsQPDka73qNl7pvhWV9aHolHZX7dseiQdlXKrNE4eMglWxC5HNtAr//Z\" transform=\"matrix(.3599 0 0 -.3599 53.807 50.38)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M65.9 40.9l-.8-.3-.8-.2-.9-.1-.8.1-.8.2-.8.2-.8.4-.8.5-.7.6-.7.7-.6.7-.7.9-.6.9-.5 1-.5 1.1-.4 1.1h.3l.4.1.4.1.4.1.3.1.4.1.4.1h.4l.2-.6.3-.7.2-.6.3-.7.3-.6.3-.6.4-.6.4-.6.5-.5.5-.6.6-.5.7-.4.7-.4.8-.4 1-.3 1-.3z\"/><g><defs><path id=\"dO\" d=\"M70.2 41.9l-1.1-.4-1.1-.3-1-.2h-1l-1 .1-.9.3-.8.4-.9.5-.7.6-.8.7-.6.7-.7.9-.5.9-.5 1-.5 1.1-.4 1.1.4.1h.3l.4.1h.4l.4.1h.4l.4.1.4.1.2-.8.3-.8.3-.7.4-.8.4-.6.5-.6.5-.7.6-.5.6-.5.7-.4.7-.5.8-.3.8-.3.8-.2.9-.1.9-.1\"/></defs><clipPath id=\"dP\"><use xlink:href=\"#dO\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dP)\"><defs><path id=\"dQ\" d=\"M57.7 41h12.5v8.8H57.7z\"/></defs><clipPath id=\"dR\"><use xlink:href=\"#dQ\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dR)\"><image overflow=\"visible\" width=\"40\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHcAAACGQAAArr/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8ALAMBIgACEQEDEQH/ xACYAAEAAwEBAAAAAAAAAAAAAAAGAQUHAgMBAAMBAAAAAAAAAAAAAAAAAAIDBAAQAAEDBAEFAQAA AAAAAAAAAAEAAgMREgQFFhAjRBUGExEAAAQDAwsFAAAAAAAAAAAAAAERAhIDBNKTNCAhMYGxwXIT gwU1QVFhIkISAAIBAgYDAAAAAAAAAAAAAAECABEhEHGhEjIDIhMz/9oADAMBAAIRAxEAAABVTexO ihNJmdQmVZhpi8eKNqAG1E23Q2U+lkWIo//aAAgBAgABBQCNsdhEaNtbiASUCV//2gAIAQMAAQUA ihva3DBT8Rokw5YGwjJxApcrHM//2gAIAQEAAQUA327dqGc5lXOJlzeZc2lV/a+3FYg1WqiovF+1 HaoqdfF+mwW5jPQxL0MSGhgTNJhBWj8f/9oACAECAgY/AAWFTOMFrSmBsZ//2gAIAQMCBj8ABpLi dS057tBFDuqteoOc+q6zoYN4p7NxzW0//9oACAEBAQY/AJLmySnc43FndCkKfB+4wbbw7Iwbbw7I wbbw7Iwbbw7I5ifmJNSij4pmxuT09wpOJ+xuT09wpydUyaaA3Gs50ESkWgeTo70h5OjvSH27nR6p pDP3CkPqkIVJIUX00D//2Q==\" transform=\"matrix(.3599 0 0 -.3599 56.783 50.663)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M70.2 41.9l-1.1-.4-1.1-.3-1-.2h-1l-1 .1-.9.3-.8.4-.9.5-.7.6-.8.7-.6.7-.7.9-.5.9-.5 1-.5 1.1-.4 1.1.4.1h.3l.4.1h.4l.4.1h.4l.4.1.4.1.2-.8.3-.8.3-.7.4-.8.4-.6.5-.6.5-.7.6-.5.6-.5.7-.4.7-.5.8-.3.8-.3.8-.2.9-.1.9-.1z\"/><g><defs><path id=\"dS\" d=\"M72.3 42.1l-1-.1-1-.1h-.9l-.9.2-.9.2-.9.3-.8.4-.8.4-.8.6-.7.6-.6.7-.6.8-.5.8-.5.9-.4 1-.3 1.1h.4l.3.1h.3l.2.1h.3l.3.1.4.1h.3l.5-.8.5-.8.4-.7.4-.7.4-.7.3-.6.4-.6.4-.5.5-.5.5-.4.6-.4.6-.4.8-.3.8-.3.9-.2 1.1-.3\"/></defs><clipPath id=\"dT\"><use xlink:href=\"#dS\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dT)\"><defs><path id=\"dU\" d=\"M60.7 41.9h11.5v8.4H60.7z\"/></defs><clipPath id=\"dV\"><use xlink:href=\"#dU\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dV)\"><image overflow=\"visible\" width=\"40\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHaAAACIAAAAs7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8ALAMBIgACEQEDEQH/ xACUAAEBAQEBAAAAAAAAAAAAAAAGBQQAAwEBAQEBAQAAAAAAAAAAAAAAAgQDAQUQAAEEAgEEAwAA AAAAAAAAAAQAAQIDBQYREhM0FhAxNREAAgECBAQGAwAAAAAAAAAAAQIDABEQIdIEMbGiMyBBcYEi c3I0BRIAAgIBAwUBAAAAAAAAAAAAAAERAiExIgNRgZGhEjL/2gAMAwEAAhEDEQAAAFMTcRfoIeP8 bV6IO4Mxsk6kln9V/wB8tcqefQ7B/9oACAECAAEFAGePS8mXKl1KXddNGztf/9oACAEDAAEFABRY 2VxAqUxq2OCLHqonkq1IlnJ//9oACAEBAAEFANgy9+Kp90yC9zPXuZ6wuxlZE5bp4vHzqn663Pxf tQHsmqgOVr4rVHLYAhzKa8LjIqGKBZQxwbIIaiq1f//aAAgBAgIGPwDKyaEmFJio1G6dD//aAAgB AwIGPwBWamZM0Rx8Sqvm1Ja7MrW9t6bxD6m23pleWfyonyf/2gAIAQEBBj8AhkhRXMjFSHv5C/kR XYh6tVdiLq1V2IurVQ20sUaKVZrre+XqcNt9jcvAv4Pyw232NyrKuFq+WdBgLfFsIVn3KbVUYkNI QA2XAXIrL+ltz6Muust9CfddVftxH3Gqg0cySNY5KRfnh//Z\" transform=\"matrix(.3599 0 0 -.3599 59.911 51.41)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M72.3 42.1l-1-.1-1-.1h-.9l-.9.2-.9.2-.9.3-.8.4-.8.4-.8.6-.7.6-.6.7-.6.8-.5.8-.5.9-.4 1-.3 1.1h.4l.3.1h.3l.2.1h.3l.3.1.4.1h.3l.5-.8.5-.8.4-.7.4-.7.4-.7.3-.6.4-.6.4-.5.5-.5.5-.4.6-.4.6-.4.8-.3.8-.3.9-.2 1.1-.3z\"/><g><defs><path id=\"dW\" d=\"M76.8 42.7l-1.4-.3-1.4-.2-1.2-.1-1.1.2-1.1.2-1 .3-.9.5-.8.5-.7.7-.7.7-.7.8-.6.8-.5.9-.5.9-.5.9-.4.9.2.1h.3l.3.1h.4l.4.1.3.1h.4l.2.1.4-.9.5-.8.5-.7.6-.7.5-.7.6-.6.7-.5.7-.5.7-.5.8-.4.7-.4.8-.4.9-.3.8-.3.9-.2.9-.3\"/></defs><clipPath id=\"dX\"><use xlink:href=\"#dW\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dX)\"><defs><path id=\"dY\" d=\"M63.3 42.1h13.6v8.7H63.3z\"/></defs><clipPath id=\"dZ\"><use xlink:href=\"#dY\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dZ)\"><image overflow=\"visible\" width=\"44\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHhAAACJwAAAtn/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8ALwMBIgACEQEDEQH/ xACbAAEBAAMBAAAAAAAAAAAAAAAGBQABAwcBAAMBAQAAAAAAAAAAAAAAAAEDBAACEAABBAICAQUB AAAAAAAAAAACAAEDBBEFBhYSEBMUNBU2EQABAQQGBQ0BAAAAAAAAAAABAgAREgMh0hOTBDQgUSLC czFBYXGBkoOjsxR0BTUVEgACAgIDAQAAAAAAAAAAAAABAgARITEQEgMz/9oADAMBAAIRAxEAAABJ M5nn1ptmdilKg86dqTFPL44rk5Y68Uw3UpBoP//aAAgBAgABBQAWj8X9tO7LLp3JA5Z//9oACAED AAEFAIq/mI0hdXKwxBVmrDD8yoy2FmOUP//aAAgBAQABBQDe8iPU2O8TLu8y7tKu7Sob7lqeaNm/ 4rCwsKP+X5n9/wBWAiUYv1nkmtC5a/BiTaGBBpKbINTVZDCDaz//2gAIAQICBj8AFjM1MDjRhsVP /9oACAEDAgY/AAa3MiKVFW1RA/oqsBkT6AxVQ31a5//aAAgBAQEGPwCXJTIE0TERvKoXUkO5DqbJ pvDVbJpvDVbJpvDVbKJ75qt/RgEVgZ1m+ihMUL2kcHeVon4avTLSOFvK0KAxTz+zUPLLSlqxcjDF MuGGcuEnaJeOhv08Hehtr7PB9k0N+hhD4oajHYY9UwNYxpgsSm0fsOhdE/U3/9k=\" transform=\"matrix(.3599 0 0 -.3599 62.475 51.61)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M76.8 42.7l-1.4-.3-1.4-.2-1.2-.1-1.1.2-1.1.2-1 .3-.9.5-.8.5-.7.7-.7.7-.7.8-.6.8-.5.9-.5.9-.5.9-.4.9.2.1h.3l.3.1h.4l.4.1.3.1h.4l.2.1.4-.9.5-.8.5-.7.6-.7.5-.7.6-.6.7-.5.7-.5.7-.5.8-.4.7-.4.8-.4.9-.3.8-.3.9-.2.9-.3z\"/><g><defs><path id=\"ea\" d=\"M79.6 43l-.8-.1H77l-.9.1-1 .2-1 .3-.9.4-1 .5-1 .5-.9.6-.9.7-.9.8-.7.9-.8.9-.6 1-.5 1.1h.4l.4.1h.4l.4.1.3.1.3.1h.4l.6-.3.5-.4.6-.5.7-.5.6-.6.7-.5.6-.6.7-.6.8-.6.7-.6.7-.6.8-.6.7-.5.8-.5.8-.5.8-.4\"/></defs><clipPath id=\"eb\"><use xlink:href=\"#ea\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eb)\"><defs><path id=\"ec\" d=\"M65.9 42.9h13.7v8.5H65.9z\"/></defs><clipPath id=\"ed\"><use xlink:href=\"#ec\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ed)\"><image overflow=\"visible\" width=\"44\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHZAAACIgAAAuP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8ALwMBIgACEQEDEQH/ xACVAAEBAAMBAAAAAAAAAAAAAAAGBQABAwQBAAMBAAAAAAAAAAAAAAAAAAECBAMQAAAGAgIDAQAA AAAAAAAAAAABAgMEBRESBhYQNBU1EQACAQIDBgMJAAAAAAAAAAABAgMABBEh0jESgpJzBSCxMkFR kSITk7PTNRIBAAICAgIDAAAAAAAAAAAAAQACESExQVEDsUKC/9oADAMBAAIRAxEAAABNAqEN67e4 mxXbsDEma+ok8iKT2IuqVm0nekJP/9oACAECAAEFAEaaGpAMyMZMHsE77f/aAAgBAwABBQBiPuhM NIlRUNsQ5Mdtn6EQhMnNOs//2gAIAQEAAQUA5JbSqtjuNuO4W47hbjt9sKq6mS6zmpZi4GBgYFB+ FzT1fKWnFCjZWikvoMSaz1+nBUFKQRS0pBFTVEIkSK1E/9oACAECAgY/ADILOCaJqcTZgn//2gAI AQMCBj8ALYm6y1yoInzK19lsWF+q9zVl/LH107Trwz//2gAIAQEBBj8AhktgpaRyrb4JyAx9hFem HkOqvTDyHVWyHkOqtkXKdVX13KE+rbKzR7oIGIQtnn76tuo3l4e69N/xtVt1G8vBkK7mp2sj4fba olurpbRUYlWcqN44bPmZa/rxfGP9lZ92iPEmusu5RHiTXWV/GeJNVXEUc6yRyAh3BGCgrhnga//Z\" transform=\"matrix(.3599 0 0 -.3599 64.943 52.275)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M79.6 43l-.8-.1H77l-.9.1-1 .2-1 .3-.9.4-1 .5-1 .5-.9.6-.9.7-.9.8-.7.9-.8.9-.6 1-.5 1.1h.4l.4.1h.4l.4.1.3.1.3.1h.4l.6-.3.5-.4.6-.5.7-.5.6-.6.7-.5.6-.6.7-.6.8-.6.7-.6.7-.6.8-.6.7-.5.8-.5.8-.5.8-.4z\"/><g><defs><path id=\"ee\" d=\"M83.4 44.1l-.7-.7-.8-.4-.8-.2-.8.1-.9.2-.9.4-.9.6-1 .7-1 .8-1 .8-1 .9-1 .9-1 .9-1.1.8-1 .8-1 .7h.6l.5.1H71.8l.8-.5.8-.6.7-.7.7-.6.7-.6.7-.6.6-.6.7-.6.7-.5.6-.5.7-.4.7-.4.8-.3.7-.3.9-.1.8-.1\"/></defs><clipPath id=\"ef\"><use xlink:href=\"#ee\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ef)\"><defs><path id=\"eg\" d=\"M68.5 42.8h14.9v8.7H68.5z\"/></defs><clipPath id=\"eh\"><use xlink:href=\"#eg\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eh)\"><image overflow=\"visible\" width=\"48\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHsAAACNwAAAwP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AMgMBIgACEQEDEQH/ xACcAAADAQADAAAAAAAAAAAAAAAABQYEAQIDAQACAwEAAAAAAAAAAAAAAAACBAADBQEQAAEFAAID AQAAAAAAAAAAAAABAgMEBREGEBIWNREAAQEGAwQKAwAAAAAAAAAAAQIAESESAwQQMdKCkhODIFFh gaEiMsMUBUJSsxIAAQMDAwUBAAAAAAAAAAAAAQARAhAhMaESA0FRkbEiMv/aAAwDAQACEQMRAAAA o0e+Wued8pAW3m2XaVlegTElpe5Uc153vSe9bE04Z6gWZgMZP//aAAgBAgABBQBqt9Vc0VyeF5F9 xEl9j//aAAgBAwABBQCvWR7G0mEtKNsJTtVo4F0qyE+g18Z//9oACAEBAAEFAOy7NzLPsNc+w1z6 /WPr9Yxux6F7SO7pycHHnrP7Z3Xy2KRwyk9xgU0i0zsGfTuiYGMgzFxUGZOUg3NzUKdOpFOf/9oA CAECAgY/AA4DrAWKWVo6oOLOHvT/2gAIAQMCBj8AEiHd/avELklsDx45HwKQjySaQdxtJ6lfJ0Kn EH9RMcd6f//aAAgBAQEGPwC2+KEHjcSecE+iRznEfs3po7h1NlR3DqbKlunU2VLdOpqNrWFPh1Jp pUkHyoUofl2YWXN9vo23M/mvCy5vt4wDRagt0RP4oUMLf5V2i04c8k5SJ5pXumUnJzR+2pHaRraH 2VI7SNbQv6Z2kamhe0z3p1MhdK4TUWHuSCHmB6jh/9k=\" transform=\"matrix(.3599 0 0 -.3599 67.689 52.311)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M83.4 44.1l-.7-.7-.8-.4-.8-.2-.8.1-.9.2-.9.4-.9.6-1 .7-1 .8-1 .8-1 .9-1 .9-1 .9-1.1.8-1 .8-1 .7h.6l.5.1H71.8l.8-.5.8-.6.7-.7.7-.6.7-.6.7-.6.6-.6.7-.6.7-.5.6-.5.7-.4.7-.4.8-.3.7-.3.9-.1.8-.1z\"/><g><defs><path id=\"ei\" d=\"M86.3 44.5l-1.3-.3-1.1-.1h-1l-1 .2-1 .4-.9.4-.9.5-.9.6-.8.7-.8.7-.8.8-.9.7-.8.7-.8.8-.9.6-.9.6h.3l.4.1h.4l.4.1h.5l.3.1h1l.5-.1.6-.3.5-.3.6-.5.6-.5.7-.7.7-.6.7-.6.8-.7.8-.7.9-.6.9-.6 1-.6 1-.5 1.2-.3\"/></defs><clipPath id=\"ej\"><use xlink:href=\"#ei\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ej)\"><defs><path id=\"ek\" d=\"M71.5 44.1h14.8v8.1H71.5z\"/></defs><clipPath id=\"el\"><use xlink:href=\"#ek\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#el)\"><image overflow=\"visible\" width=\"48\" height=\"27\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHnAAACLwAAAtj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwAMgMBIgACEQEDEQH/ xACZAAEBAQEBAQAAAAAAAAAAAAAFAAYCAwQBAAIDAQAAAAAAAAAAAAAAAAMEAQIFBhAAAQMDAwQD AAAAAAAAAAAAAQACBQMEBhESFhATFSYzFDURAAAEAgkEAwEAAAAAAAAAAAERAgMAEhAhMaGxMpIT BCByskNhIhQVEgABAwMEAwAAAAAAAAAAAAABABECECEDYXHRElEykv/aAAwDAQACEQMRAAAAfD+7 LNmc6E6o40hllwM7uqMTI5jcjsOgdPQdMF70WDLNROe//9oACAECAAEFAKTGdt+wJxGqaXdt+5Hd qv/aAAgBAwABBQBjQRStmlVLSk2grYtDaTwrp7zQX//aAAgBAQABBQDJ5m9jKnL5lDLplDLZlcsm FBz8jfSKzn5QEAgOmL/srOBrVAQHQAk4xblkmsi8Lv8AUF6gvUVR4prGeI+wv//aAAgBAgIGPwAE gK0QrUDC1BvT/9oACAEDAgY/ABZXiCskukXjjkQW0oHBJ0blekz88rII45CPSTkmPjen/9oACAEB AQY/AOOniikAdBYqmTNlFJYxmb0BGZvQEZm9ARmb0BDfHfFAtqBQiSSGpIjRw+1zFPSz2r8Ro4fa 5inoILYbWNsqvEaGP6m5MStrbOyozKPffHvvj33x9N4/k4T+SfdISmssro//2Q==\" transform=\"matrix(.3599 0 0 -.3599 70.666 53.155)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M86.3 44.5l-1.3-.3-1.1-.1h-1l-1 .2-1 .4-.9.4-.9.5-.9.6-.8.7-.8.7-.8.8-.9.7-.8.7-.8.8-.9.6-.9.6h.3l.4.1h.4l.4.1h.5l.3.1h1l.5-.1.6-.3.5-.3.6-.5.6-.5.7-.7.7-.6.7-.6.8-.7.8-.7.9-.6.9-.6 1-.6 1-.5 1.2-.3z\"/><g><defs><path id=\"em\" d=\"M89.9 45.5l-1.1-.6-1.1-.3h-1.1l-1.1.2-1.1.5-1.2.6-1.1.7-1 .8-1 .8-1 .9-.9.8-.9.7-.8.7-.7.5-.6.2-.6.1.5.1.5.1.5.1h.6l.6.1.5.1h1.1l.8-.6.7-.5.7-.6.6-.6.6-.5.5-.5.6-.6.5-.5.6-.4.6-.4.6-.4.7-.4.7-.4.8-.2 1-.3 1-.2\"/></defs><clipPath id=\"en\"><use xlink:href=\"#em\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#en)\"><defs><path id=\"eo\" d=\"M74.6 44.6h15.2v8H74.6z\"/></defs><clipPath id=\"ep\"><use xlink:href=\"#eo\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ep)\"><image overflow=\"visible\" width=\"48\" height=\"26\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHyAAACNwAAAt3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwANQMBIgACEQEDEQH/ xACiAAACAgMBAAAAAAAAAAAAAAAABgQFAQIDBwEBAQEBAQAAAAAAAAAAAAAABAMFAgYQAAAFBAIB BQAAAAAAAAAAAAABAgMEEgUGFhARFRMUJDQmEQAABAIECwkAAAAAAAAAAAAAAQIDERIQotITICEx QbEiMjNzowRhgaFCUrJDNBUSAAEEAQIHAAAAAAAAAAAAAAEAESECEDEDUYGhwdEi0v/aAAwDAQAC EQMRAAAAaaKaooQxbLuZvYei3Lir0YDrzy0ov1NTSW8se0tKjuLCYaNoArB//9oACAECAAEFAG0o oXSQUoi4KqlXYcJXY//aAAgBAwABBQBlqsmobZj2UZKRDURIbcEhbxkP/9oACAEBAAEFAMhvD9pZ 3a4As0uA3OeNynhnL5rjwzf6pECLmBHUuSM1L4pFzHims4Ubp0X3xPpfjB+NCNOqa1wM+JqH/9oA CAECAgY/AASHKgZDDEkdcf/aAAgBAwIGPwAQpq6JtSumB62tJ0buVG1uHnT6RfauA3GvnH//2gAI AQEBBj8AZcZQlZuKNJkuOYo5jIfXZrWhuGa1obhqtaG4arWg22bLREtRJMymznD1UdLxFe3BaUeQ lpPxo6biK0YBGou4N4sii00NfqTXcx3cs21DHsD5OaPPzRqzx7bwak1cFdxjEobVH//Z\" transform=\"matrix(.3599 0 0 -.3599 73.86 53.43)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M89.9 45.5l-1.1-.6-1.1-.3h-1.1l-1.1.2-1.1.5-1.2.6-1.1.7-1 .8-1 .8-1 .9-.9.8-.9.7-.8.7-.7.5-.6.2-.6.1.5.1.5.1.5.1h.6l.6.1.5.1h1.1l.8-.6.7-.5.7-.6.6-.6.6-.5.5-.5.6-.6.5-.5.6-.4.6-.4.6-.4.7-.4.7-.4.8-.2 1-.3 1-.2z\"/><g><defs><path id=\"eq\" d=\"M20.3 33.7l-.1-.3-.1-.3-.2-.3v-.4l-.1-.3-.1-.4-.1-.3v-.7l-.1-.4v-.4l.1-.3v-.4l.1-.3v-.4l.1-.3-.4.6-.4.7-.2.6-.2.7v1.4l.1.7.1.6.2.7.2.7.3.7.2.6.3.6.3.7.2.5.3.6-.1-.1v-.7l-.1-.3V35l-.1-.4v-.3l-.1-.3-.1-.3\"/></defs><clipPath id=\"er\"><use xlink:href=\"#eq\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#er)\"><defs><path id=\"es\" d=\"M18.6 28.2h2.2v10.4h-2.2z\"/></defs><clipPath id=\"et\"><use xlink:href=\"#es\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#et)\"><image overflow=\"visible\" width=\"12\" height=\"33\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGfAAABxwAAAh//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQADgMBIgACEQEDEQH/ xACFAAADAQEAAAAAAAAAAAAAAAAAAQQDBgEBAQAAAAAAAAAAAAAAAAAAAQIQAAEEAQEJAAAAAAAA AAAAAAIBEgMFBDIAEUETIyQlBiYRAAECBAQHAQAAAAAAAAAAAAIAARFBYQNRsRITIXHBMmKywgQS AQEBAQAAAAAAAAAAAAAAAAEAEEH/2gAMAwEAAhEDEQAAAOpczuKHuxqAH//aAAgBAgABBQBURq6d v//aAAgBAwABBQBFV6auP//aAAgBAQABBQC5t8ivlC2yCp/Yo3zxx/P3Eb5QDxOeDjEOxPlb+kz/ 2gAIAQICBj8AGM//2gAIAQMCBj8ATk5//9oACAEBAQY/ALYWQA2MXd3KMno6P97gG6JQYOOnuYcY zVmgvmrgeTe4q3QXzRjX6ZByRDXqybchGUVLRPBf/9k=\" transform=\"matrix(.3599 0 0 -.3599 17.567 39.408)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M20.3 33.7l-.1-.3-.1-.3-.2-.3v-.4l-.1-.3-.1-.4-.1-.3v-.7l-.1-.4v-.4l.1-.3v-.4l.1-.3v-.4l.1-.3-.4.6-.4.7-.2.6-.2.7v1.4l.1.7.1.6.2.7.2.7.3.7.2.6.3.6.3.7.2.5.3.6-.1-.1v-.7l-.1-.3V35l-.1-.4v-.3l-.1-.3-.1-.3z\"/><g><defs><path id=\"eu\" d=\"M11.6 45.6l.5-.3.6-.4.5-.3.5-.3.5-.3.5-.3.4-.3.5-.3.5-.3.4-.3.5-.3.5-.3.4-.3.5-.2.5-.3.6-.3-.5.5-.5.4-.4.5-.5.4-.5.5-.4.4-.5.4-.6.4-.4.3-.6.3-.4.2-.6.2-.5.2-.5.1h-1\"/></defs><clipPath id=\"ev\"><use xlink:href=\"#eu\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ev)\"><defs><path id=\"ew\" d=\"M11.6 40.8h7.9v4.8h-7.9z\"/></defs><clipPath id=\"ex\"><use xlink:href=\"#ew\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ex)\"><image overflow=\"visible\" width=\"28\" height=\"18\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGoAAAB1gAAAkL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAHwMBIgACEQEDEQH/ xACDAAADAQEAAAAAAAAAAAAAAAAAAwUEBgEBAQAAAAAAAAAAAAAAAAAAAAIQAAEEAgMBAAAAAAAA AAAAAAIAAQQFMQMREhMGEQAABQIFAgcAAAAAAAAAAAAAARECEiEDMZEyEwRhoVEiUsLS0xQSAAMB AQAAAAAAAAAAAAAAAACBQhAR/9oADAMBAAIRAxEAAADus65NxXfzVU1zgFUQP//aAAgBAgABBQAR Z2IWZhwWP//aAAgBAwABBQAidnEndyyOf//aAAgBAQABBQCRI8U9lwnteFomesa32dGOQjkqt29q ezCCSLTQItHzag66wa3/2gAIAQICBj8AykUz/9oACAEDAgY/ADhLJR//2gAIAQEBBj8AbRZL2Ggs xoLMXL8U25UX0lIWusvaMRiOW/w3O1shb/Y9zElCK1wXBpit+5k74CvIu5O+schvGuvdxTnvPMjk XkKSK0j09B//2Q==\" transform=\"matrix(.3599 0 0 -.3599 10.727 46.66)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M11.6 45.6l.5-.3.6-.4.5-.3.5-.3.5-.3.5-.3.4-.3.5-.3.5-.3.4-.3.5-.3.5-.3.4-.3.5-.2.5-.3.6-.3-.5.5-.5.4-.4.5-.5.4-.5.5-.4.4-.5.4-.6.4-.4.3-.6.3-.4.2-.6.2-.5.2-.5.1h-1z\"/><g><defs><path id=\"ey\" d=\"M15.8 34.1l.4.2.4.3.4.3.3.2.4.3.3.3.3.3.3.3.3.3.3.3.3.3.3.4.2.3.3.3.3.4.2.3-.1-.4-.1-.3-.2-.4-.2-.4-.1-.4-.2-.4-.3-.4-.2-.4-.3-.3-.4-.3-.3-.3-.4-.2-.5-.2-.5-.2-.6-.1-.6-.1\"/></defs><clipPath id=\"ez\"><use xlink:href=\"#ey\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ez)\"><defs><path id=\"eA\" d=\"M15.8 34.1h5v4.8h-5z\"/></defs><clipPath id=\"eB\"><use xlink:href=\"#eA\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eB)\"><image overflow=\"visible\" width=\"20\" height=\"18\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGjAAABxwAAAh7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAFgMBIgACEQEDEQH/ xACEAAEAAgMAAAAAAAAAAAAAAAAAAwQCBQYBAQAAAAAAAAAAAAAAAAAAAAMQAAAGAgIDAAAAAAAA AAAAAAABEQIDBRIEIQYTI0MRAAECAwUJAQAAAAAAAAAAAAERAgADBCFBYRIiEDGBkcFikrLSNBIB AQEBAAAAAAAAAAAAAAAAEAEyof/aAAwDAQACEQMRAAAA6iChSUu5YiXUwCHvwaf/2gAIAQIAAQUA JrUBKg//2gAIAQMAAQUAN7lBoo//2gAIAQEAAQUAsOxQ6G0XbIDGfrv4srVsA+FjDWv3C16gceP/ 2gAIAQICBj8AhNH/2gAIAQMCBj8Apc9P/9oACAEBAQY/AHUrpLnuaAcwIA1BY/M/mIzpcqcFiYcG eo2J29Ie6oqDLmoFYGk3WWgRZVO8D8wi6U34JH//2Q==\" transform=\"matrix(.3599 0 0 -.3599 15.067 39.934)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M15.8 34.1l.4.2.4.3.4.3.3.2.4.3.3.3.3.3.3.3.3.3.3.3.3.3.3.4.2.3.3.3.3.4.2.3-.1-.4-.1-.3-.2-.4-.2-.4-.1-.4-.2-.4-.3-.4-.2-.4-.3-.3-.4-.3-.3-.3-.4-.2-.5-.2-.5-.2-.6-.1-.6-.1z\"/><g><defs><path id=\"eC\" d=\"M20.1 30.7l.1.5.1.6.1.6.1.5.1.6.1.5v.5l.1.5.1.5.1.5v.5l.1.5.1.6.1.5.1.5.1.5.1-.6v-.6l.1-.6.1-.7v-2.3l-.1-.6-.1-.5-.1-.6-.2-.4-.2-.5-.3-.4-.3-.3-.4-.3\"/></defs><clipPath id=\"eD\"><use xlink:href=\"#eC\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eD)\"><defs><path id=\"eE\" d=\"M20.1 30.7h1.7v8.5h-1.7z\"/></defs><clipPath id=\"eF\"><use xlink:href=\"#eE\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eF)\"><image overflow=\"visible\" width=\"12\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGPAAABqwAAAez/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8ADgMBIgACEQEDEQH/ xAB3AAADAAAAAAAAAAAAAAAAAAAEBQYBAQEAAAAAAAAAAAAAAAAAAAECEAAABgMBAAAAAAAAAAAA AAAAAREDBAUhAhIGEQACAgIABwAAAAAAAAAAAAABAhARIQNRscFismMEEgEAAwAAAAAAAAAAAAAA AAAAAWEC/9oADAMBAAIRAxEAAACjeztFUp3ApQ//2gAIAQIAAQUA2RDPH//aAAgBAwABBQDVVIs/ /9oACAEBAAEFALy1nQpY9A33NFs31KEllhxwf//aAAgBAgIGPwDKKf/aAAgBAwIGPwDSbf/aAAgB AQEGPwBNXzlQjawxtbyWYdIQ+oeTQp7BzaA2zYEaqokDFnjH/9k=\" transform=\"matrix(.3599 0 0 -.3599 19.319 40.177)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M20.1 30.7l.1.5.1.6.1.6.1.5.1.6.1.5v.5l.1.5.1.5.1.5v.5l.1.5.1.6.1.5.1.5.1.5.1-.6v-.6l.1-.6.1-.7v-2.3l-.1-.6-.1-.5-.1-.6-.2-.4-.2-.5-.3-.4-.3-.3-.4-.3z\"/><g><defs><path id=\"eG\" d=\"M17 29.7l-.5.5-.3.6-.1.5-.1.6.2.6.2.7.3.6.4.6.4.6.5.6.5.6.4.5.5.5.4.5.4.4.2.3v-.9l-.1-.7-.2-.6-.2-.6-.2-.5-.3-.4-.3-.4-.3-.4-.3-.4-.3-.4-.3-.4-.3-.4-.2-.5-.2-.6-.1-.7-.1-.8\"/></defs><clipPath id=\"eH\"><use xlink:href=\"#eG\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eH)\"><defs><path id=\"eI\" d=\"M16 29.7h4.4v8.7H16z\"/></defs><clipPath id=\"eJ\"><use xlink:href=\"#eI\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eJ)\"><image overflow=\"visible\" width=\"20\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGhAAABxgAAAhj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AFgMBIgACEQEDEQH/ xAB/AAACAgMAAAAAAAAAAAAAAAAABQEEAgMGAQEAAAAAAAAAAAAAAAAAAAADEAABBAMBAQAAAAAA AAAAAAABAgMEBQAQERIGEQABAgQEBwAAAAAAAAAAAAACAQMQEVESACGy0mGhIpIzBDQSAAMBAAAA AAAAAAAAAAAAABABIUH/2gAMAwEAAhEDEQAAAH9aKqj2oBMg0tsUNiAaf//aAAgBAgABBQAJTzAo cz//2gAIAQMAAQUAKldwpPc//9oACAEBAAEFALS/nQ54+nsjq6a9WiWNWTXqelnUiMwt8RI+v//a AAgBAgIGPwBTAh//2gAIAQMCBj8Ad0Mf/9oACAEBAQY/AHfWZBom27bVJCUuoRLORpXHjZ7S3wfW tmgYurW3SkSM3xAllMVlNMk44+gOW6H/2Q==\" transform=\"matrix(.3599 0 0 -.3599 15.022 39.377)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M17 29.7l-.5.5-.3.6-.1.5-.1.6.2.6.2.7.3.6.4.6.4.6.5.6.5.6.4.5.5.5.4.5.4.4.2.3v-.9l-.1-.7-.2-.6-.2-.6-.2-.5-.3-.4-.3-.4-.3-.4-.3-.4-.3-.4-.3-.4-.3-.4-.2-.5-.2-.6-.1-.7-.1-.8z\"/><g><defs><path id=\"eK\" d=\"M20.7 38.9v-.6l.1-.6V36l.1-.5.1-.6v-.5l.1-.5.1-.5.1-.6.1-.5.2-.5.2-.5.2-.5.2-.5-.8.8-.7.7-.5.8-.4.7-.2.6-.1.6v1.2l.2.5.1.5.2.4.2.4.2.4.2.4.1.3v.3\"/></defs><clipPath id=\"eL\"><use xlink:href=\"#eK\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eL)\"><defs><path id=\"eM\" d=\"M19.5 30.3h2.7v8.6h-2.7z\"/></defs><clipPath id=\"eN\"><use xlink:href=\"#eM\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eN)\"><image overflow=\"visible\" width=\"16\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGXAAABvwAAAhT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AEwMBIgACEQEDEQH/ xAB6AAEAAwEBAAAAAAAAAAAAAAAAAQQFAgYBAQAAAAAAAAAAAAAAAAAAAAIQAAEEAgMAAAAAAAAA AAAAAAMAAhIFAREiBAYRAAICAgEDBQAAAAAAAAAAAAECEQMAELExUXJhcRJCExIBAQEAAAAAAAAA AAAAAAAAEBFB/9oADAMBAAIRAxEAAAD1ip0xugPJmzKFsF//2gAIAQIAAQUA1iK3xX//2gAIAQMA AQUA3ma1yX//2gAIAQEAAQUAtrh9cWpt32BF6Icz+eHAquByLUDgRdwLSP6Ymjcv/9oACAECAgY/ ALpD/9oACAEDAgY/AJhT/9oACAEBAQY/AK0WoW/opMloiDHY5YjVCv4AGQ0zJ9hqk9lPOW+qjnVf iecs8RzpS1ipA6MYxirq8j6mdf/Z\" transform=\"matrix(.3599 0 0 -.3599 18.524 39.652)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M20.7 38.9v-.6l.1-.6V36l.1-.5.1-.6v-.5l.1-.5.1-.5.1-.6.1-.5.2-.5.2-.5.2-.5.2-.5-.8.8-.7.7-.5.8-.4.7-.2.6-.1.6v1.2l.2.5.1.5.2.4.2.4.2.4.2.4.1.3v.3z\"/><g><defs><path id=\"eO\" d=\"M12.3 40.9l.5.1.4.1h.5l.5.1h3.1l.4-.1h.5l.4-.1h.5l.4-.1-.4.2-.3.1-.4.2-.4.2-.5.1-.4.1-.4.1-.5.1h-1.4l-.5-.1-.5-.2-.5-.2-.5-.3-.5-.3\"/></defs><clipPath id=\"eP\"><use xlink:href=\"#eO\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eP)\"><defs><path id=\"eQ\" d=\"M12.3 40.9h7.2V42h-7.2z\"/></defs><clipPath id=\"eR\"><use xlink:href=\"#eQ\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eR)\"><image overflow=\"visible\" width=\"28\" height=\"7\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGSAAABqwAAAej/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAsAHwMBIgACEQEDEQH/ xAB9AAEBAQEAAAAAAAAAAAAAAAAEBQMGAQEBAQAAAAAAAAAAAAAAAAABAAIQAAIBAwUBAAAAAAAA AAAAAAABBBECA0ESMgUGFhEAAQIFBQEAAAAAAAAAAAAAAQACEBExE0MhQZEzNEQSAAIDAAAAAAAA AAAAAAAAAAABESEx/9oADAMBAAIRAxEAAADsivxcktT6E//aAAgBAgABBQBO0dD/2gAIAQMAAQUA auFU/9oACAEBAAEFAJnaYomV+ijo+mj7iRzZqf/aAAgBAgIGPwDClB//2gAIAQMCBj8A0tyf/9oA CAEBAQY/ALT2FxkHTBG66nchBtp2plUQw0yVXyoeSH//2Q==\" transform=\"matrix(.3599 0 0 -.3599 11.295 42.864)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M12.3 40.9l.5.1.4.1h.5l.5.1h3.1l.4-.1h.5l.4-.1h.5l.4-.1-.4.2-.3.1-.4.2-.4.2-.5.1-.4.1-.4.1-.5.1h-1.4l-.5-.1-.5-.2-.5-.2-.5-.3-.5-.3z\"/><g><defs><path id=\"eS\" d=\"M15 43.2l-.4.1h-.3l-.3.1-.4.1-.3.2-.3.1-.4.1-.3.2-.3.2-.3.2-.3.2-.3.2-.3.2-.2.2-.2.2-.2.3.2-.7.3-.6.4-.5.4-.5.5-.4.6-.4.6-.3.7-.2.7-.3.7-.2.7-.2.7-.1.7-.2.7-.1.6-.2.7-.1-.3.1-.5.2-.5.4-.6.4-.6.4-.7.3-.6.4-.6.2\"/></defs><clipPath id=\"eT\"><use xlink:href=\"#eS\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eT)\"><defs><path id=\"eU\" d=\"M10.2 40.8h9.2v5h-9.2z\"/></defs><clipPath id=\"eV\"><use xlink:href=\"#eU\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eV)\"><image overflow=\"visible\" width=\"32\" height=\"18\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGyAAAB5AAAAk7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAIQMBIgACEQEDEQH/ xACIAAEAAgMAAAAAAAAAAAAAAAAABAUCAwYBAQADAAAAAAAAAAAAAAAAAAMAAQIQAAEEAwEBAAAA AAAAAAAAAAEAAgMFETEEEgYRAAAFAgMFCQAAAAAAAAAAAAABEQIDITEQEgRhkbHh04GhwTJikqIz QxIAAwEBAAAAAAAAAAAAAAAAABABMkL/2gAMAwEAAhEDEQAAAO51Rq/eLbOgkXXRg0rIQh6pBJeg 0//aAAgBAgABBQANGC0YQ0dL/9oACAEDAAEFAC4ghxyjsbX/2gAIAQEAAQUAm6RE42ACNm0LnsBP MrOXxO/oT+lVE/uwVhHXvndz0idzfPqsgpmdq//aAAgBAgIGPwAq6Lpf/9oACAEDAgY/ACLkmV// 2gAIAQEBBj8Ay5Vot0Hk7+Q+v5cgURMRVqq27MCL0l4i4uI27HcDwXUyvjflKjSontcK6mXcfTFd XNuPpBjtJqJZJyJ2VjiNLV/NvHD/2Q==\" transform=\"matrix(.3599 0 0 -.3599 9.26 46.706)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M15 43.2l-.4.1h-.3l-.3.1-.4.1-.3.2-.3.1-.4.1-.3.2-.3.2-.3.2-.3.2-.3.2-.3.2-.2.2-.2.2-.2.3.2-.7.3-.6.4-.5.4-.5.5-.4.6-.4.6-.3.7-.2.7-.3.7-.2.7-.2.7-.1.7-.2.7-.1.6-.2.7-.1-.3.1-.5.2-.5.4-.6.4-.6.4-.7.3-.6.4-.6.2z\"/><g><defs><path id=\"eW\" d=\"M13.7 48.4l-.3-.7-.1-.6.1-.7.2-.5.4-.6.4-.5.6-.5.6-.5.6-.5.7-.4.7-.4.6-.3.6-.3.6-.3.5-.3.4-.2-.4.8-.4.7-.5.6-.4.4-.4.4-.4.4-.5.2-.4.3-.4.2-.4.3-.5.3-.4.4-.4.4-.4.5-.4.6-.3.8\"/></defs><clipPath id=\"eX\"><use xlink:href=\"#eW\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eX)\"><defs><path id=\"eY\" d=\"M13.3 41.1h6.9v7.3h-6.9z\"/></defs><clipPath id=\"eZ\"><use xlink:href=\"#eY\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eZ)\"><image overflow=\"visible\" width=\"24\" height=\"24\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGlAAABzAAAAhP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABkAHAMBIgACEQEDEQH/ xACAAAACAwAAAAAAAAAAAAAAAAAABgMEBQEBAQEAAAAAAAAAAAAAAAAAAgABEAACAgIDAQAAAAAA AAAAAAABAhEDAAQhEgUgEQABAgQCCwAAAAAAAAAAAAABAAIQESFBIAMxcZGxwRIiMlJiMxIBAQEA AAAAAAAAAAAAAAAAAAEx/9oADAMBAAIRAxEAAAB5ijosaN1fYKxshwEU5xDL/9oACAECAAEFAAOC OVmDPb//2gAIAQMAAQUAJMgmGiRHX//aAAgBAQABBQC+5q2O24xdxy+ehZ0sa/Kr5vz23Zb3tfNe 2w7Xz//aAAgBAgIGPwBExMf/2gAIAQMCBj8AVdXX/9oACAEBAQY/AABKomrJraVIEGj14wyxPS5u +DAAT0W1ldp2FZI5T9GWPkMX/9k=\" transform=\"matrix(.3599 0 0 -.3599 12.471 49.243)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M13.7 48.4l-.3-.7-.1-.6.1-.7.2-.5.4-.6.4-.5.6-.5.6-.5.6-.5.7-.4.7-.4.6-.3.6-.3.6-.3.5-.3.4-.2-.4.8-.4.7-.5.6-.4.4-.4.4-.4.4-.5.2-.4.3-.4.2-.4.3-.5.3-.4.4-.4.4-.4.5-.4.6-.3.8z\"/><g><defs><path id=\"fa\" d=\"M20.9 41.3l-.3.5-.3.5-.3.5-.3.4-.3.5-.2.5-.3.4-.2.5-.3.5-.2.5-.2.4-.1.5-.2.5-.1.5-.1.5-.2.6-.2-1.1-.2-1v-.8l.1-.8.1-.6.3-.6.3-.5.4-.4.4-.3.4-.4.4-.2.4-.2.4-.3.3-.2.3-.2.2-.2\"/></defs><clipPath id=\"fb\"><use xlink:href=\"#fa\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#fb)\"><defs><path id=\"fc\" d=\"M16.9 41.3h4v7.8h-4z\"/></defs><clipPath id=\"fd\"><use xlink:href=\"#fc\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#fd)\"><image overflow=\"visible\" width=\"16\" height=\"25\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGdAAABxAAAAhX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwAEQMBIgACEQEDEQH/ xAB/AAACAwEAAAAAAAAAAAAAAAAAAwQFBgEBAQEAAAAAAAAAAAAAAAAAAAIDEAAABQQDAAAAAAAA AAAAAAAAAhIDBAERFAUiQhURAAECBQUBAQAAAAAAAAAAAAERAgAQMbESIVFhAxQyExIBAAMBAAAA AAAAAAAAAAAAEBExQWH/2gAMAwEAAhEDEQAAAN1yGti3ADz6J6qyvQJV/9oACAECAAEFAE0sOo// 2gAIAQMAAQUAVW4tyH//2gAIAQEAAQUAckUbMSUU5xOdS/EdVKG3eRN1j6tiNj4uVB8DMH//2gAI AQICBj8AkrD/2gAIAQMCBj8Ajpen/9oACAEBAQY/AC0hUgMxReZOHAtHWNybGT28NtHS1ak2Mnez L9kGSZpTT5jq8ufoU4Lmiod9KS//2Q==\" transform=\"matrix(.3599 0 0 -.3599 16.08 49.842)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M20.9 41.3l-.3.5-.3.5-.3.5-.3.4-.3.5-.2.5-.3.4-.2.5-.3.5-.2.5-.2.4-.1.5-.2.5-.1.5-.1.5-.2.6-.2-1.1-.2-1v-.8l.1-.8.1-.6.3-.6.3-.5.4-.4.4-.3.4-.4.4-.2.4-.2.4-.3.3-.2.3-.2.2-.2z\"/><g fill=\"#231F20\"><path d=\"M28.3 91.4h-5.4l-1.4-4.1H14l-1.4 4.1H7.4l7.4-20.2h6l7.5 20.2zm-8.1-7.8l-2.5-7.2-2.5 7.2h5zM46.7 83.6c0 1.3-.2 2.4-.6 3.4-.4 1-.9 1.9-1.5 2.5-.6.7-1.4 1.2-2.2 1.6-.8.4-1.7.5-2.6.5-.9 0-1.6-.1-2.2-.3-.6-.2-1.2-.4-1.9-.8v6.3h-4.9V76.2h4.9v1.6c.7-.6 1.5-1.1 2.3-1.4.8-.4 1.7-.6 2.7-.6 1.9 0 3.4.7 4.4 2.1 1.1 1.3 1.6 3.2 1.6 5.7zm-5 .1c0-1.5-.3-2.5-.8-3.2-.5-.7-1.3-1-2.4-1-.5 0-.9.1-1.4.2-.5.1-.9.3-1.4.6v7.6c.3.1.7.2 1 .2.4 0 .7.1 1.1.1 1.3 0 2.2-.4 2.9-1.1.7-.8 1-1.9 1-3.4zM59.5 89.8c-.3.2-.6.4-1 .7-.4.3-.8.5-1.1.7-.5.2-1 .4-1.5.5-.5.1-1.1.2-1.7.2-1.4 0-2.7-.4-3.6-1.3-1-.9-1.5-2-1.5-3.4 0-1.1.2-2 .7-2.7.5-.7 1.2-1.3 2.1-1.7.9-.4 2-.7 3.4-.9 1.3-.2 2.7-.3 4.2-.4v-.1c0-.8-.3-1.4-1-1.7s-1.7-.5-3-.5c-.8 0-1.7.1-2.6.4-.9.3-1.6.5-2 .7h-.4v-3.7c.5-.1 1.4-.3 2.5-.5 1.2-.2 2.3-.3 3.5-.3 2.8 0 4.8.4 6 1.3s1.8 2.2 1.8 4v10.3h-4.8v-1.6zm0-2.4v-3.2c-.7.1-1.4.1-2.1.2-.8.1-1.3.2-1.7.3-.5.2-.9.4-1.1.7-.3.3-.4.7-.4 1.2 0 .3 0 .6.1.8.1.2.2.4.4.6.2.2.5.3.7.4.3.1.7.1 1.4.1.5 0 1-.1 1.5-.3.3-.2.8-.5 1.2-.8zM76.7 91.8c-1.3 0-2.5-.2-3.6-.5s-2-.8-2.9-1.5c-.8-.7-1.4-1.5-1.9-2.5-.4-1-.7-2.2-.7-3.5 0-1.4.2-2.6.7-3.7s1.1-1.9 2-2.6c.8-.6 1.8-1.1 2.8-1.4 1.1-.3 2.2-.4 3.3-.4 1 0 2 .1 2.9.3.9.2 1.7.5 2.4.9v4.2H81c-.2-.2-.4-.4-.7-.6-.3-.2-.6-.4-1-.6-.4-.2-.8-.4-1.2-.5-.4-.1-1-.2-1.5-.2-1.3 0-2.3.4-3 1.2-.7.8-1 1.9-1 3.4s.4 2.6 1.1 3.3c.7.8 1.7 1.1 3 1.1.6 0 1.2-.1 1.7-.2s.9-.3 1.2-.5c.3-.2.6-.4.8-.6.2-.2.5-.4.6-.6h.7v4.2c-.8.4-1.6.6-2.4.9-.7.3-1.6.4-2.6.4zM100.3 91.4h-4.9v-7.5c0-.6 0-1.2-.1-1.8s-.2-1.1-.3-1.3c-.2-.3-.4-.6-.8-.7-.3-.2-.8-.2-1.5-.2-.4 0-.9.1-1.3.2-.4-.1-.9.2-1.4.5v10.8h-4.9V70.3H90v7.5c.9-.7 1.7-1.2 2.5-1.6.8-.4 1.7-.5 2.7-.5 1.6 0 2.9.5 3.8 1.4.9 1 1.4 2.4 1.4 4.3v10zM119.8 84.7h-11.2c.1 1.2.5 2.1 1.4 2.7.8.6 2.1.9 3.7.9 1 0 2-.2 3-.6 1-.4 1.7-.8 2.3-1.2h.5v3.9c-1.1.4-2.1.8-3.1 1-1 .2-2.1.3-3.2.3-3 0-5.4-.7-7-2.1-1.6-1.4-2.4-3.3-2.4-5.9 0-2.5.8-4.5 2.3-6 1.5-1.5 3.6-2.2 6.3-2.2 2.5 0 4.3.6 5.6 1.9 1.2 1.2 1.9 3 1.9 5.4v1.9zm-4.8-2.9c0-1-.3-1.8-.8-2.3-.5-.5-1.2-.8-2.2-.8-.9 0-1.7.2-2.3.7-.6.5-.9 1.3-1 2.3h6.3z\"/></g></svg>"

/***/ }),

/***/ "../src/components/apache/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ApacheOriginalWordmark = __webpack_require__("../src/components/apache/original-wordmark/ApacheOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ApacheOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apache/original/ApacheOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ApacheOriginal = __webpack_require__("../src/components/apache/original/ApacheOriginal.svg");
	
	var _ApacheOriginal2 = _interopRequireDefault(_ApacheOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ApacheOriginal */
	function ApacheOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ApacheOriginal',
	    svg: _ApacheOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ApacheOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ApacheOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apache/original/ApacheOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".596\" d=\"M126.9 78.1c-10.2-1.4-47.8-3.3-64.5-6-13.5-2.2-26.7-6.2-39.2-10.4-3.3-1.1-9-3.3-12.7-5.3C8.2 54.6 2.6 52 1 49.5 25.4 61 35.2 64.2 63.7 69.9c11.6 2.4 53.8 5.8 63.2 8.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M90.8 82.6l-1 .4-1.1.1-1.1-.2-1-.4-1.1-.6-1-.8-1-.8-1-.9-.9-1-.9-.9-.8-1-.8-.8-.7-.7-.6-.6-.6-.4-.5-.2.4.1h.5l.5.1h.5l.5.1h.5l.5.1h.5l.7.7.7.6.6.6.6.7.5.6.5.6.5.5.5.6.6.5.5.5.6.5.6.5.7.4.8.4.9.4.9.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M94.4 82.5l-1.3.2H92l-1.1-.1-1.1-.3-.9-.4-.9-.5-.8-.6-.8-.6-.8-.7-.7-.7-.7-.9-.7-.7-.7-.8-.8-.8-.7-.7-.7-.7.3.1H81.8l.3.1h.6l.3.1h.7l.3.1h.7l.4.1h.6l.3.4.3.5.4.6.5.6.5.6.5.7.6.7.6.6.6.7.7.6.6.5.7.5.6.4.6.2.6.2h.6z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M96.8 82.5l-.8.1H94.7l-.7-.1-.6-.2-.7-.2-.6-.3-.7-.5-.6-.5-.7-.5-.6-.7-.7-.8-.7-.9-.8-.9-.8-1.1-.8-1.2h1l.4.1h.5l.4.1.5.1h1.1l.4.4.5.5.4.5.4.5.5.5.4.5.4.5.4.5.4.5.5.5.4.5.5.4.4.4.5.5.5.4.6.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M99.3 82.4l-.6.3-.6.1-.6-.1-.6-.3-.7-.4-.6-.5-.7-.5-.6-.7-.7-.8-.6-.7-.6-.7-.6-.8-.6-.7-.6-.6-.5-.6-.4-.4 3 .3.4.4.4.5.3.4.3.5.4.5.4.4.3.5.4.4.4.5.4.4.4.5.5.4.4.4.5.5.5.4.6.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M104.4 81.7l-.9.6-.9.3-.8.2h-.8l-.8-.1-.7-.3-.7-.4-.8-.5-.7-.6-.7-.7-.6-.8-.6-.7-.7-.9-.6-.8-.6-.9-.6-.8.5.1H94.3l.3.1h1.1l.6.8.5.7.6.7.6.6.5.6.6.5.6.4.6.4.6.4.6.3.5.2.5.2.5.2.5.1.5.1h.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M107 81.5l-.9.1-.9.1-.8-.1-.9-.1-.8-.1-.7-.3-.7-.3-.7-.4-.7-.5-.7-.4-.6-.6-.6-.6-.6-.6-.5-.7-.6-.7-.5-.8.6.1h.6l.6.1h.6l.5.1h.9l.1.1.1.1.3.3.3.3.3.3.4.4.4.4.5.5.5.4.6.5.6.5.6.5.7.4.7.4.6.3.7.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M110.6 81.7l-.8.2h-.8l-.7-.1-.8-.1-.8-.3-.7-.3-.8-.4-.7-.4-.7-.5-.7-.5-.7-.6-.6-.5-.6-.6-.6-.6-.5-.6-.5-.6h.4l.4.1h1.4l.5.1h.3l.3.1.2.2.2.2.5.3.4.4.6.5.6.5.7.5.7.5.7.5.7.5.6.4.6.4.5.4.4.2.3.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M114.5 81.7l-.5.5-.6.2h-.7l-.9-.2-.9-.4-.9-.5-1-.6-1-.6-1-.7-.9-.7-.9-.6-.7-.7-.7-.5-.5-.4-.3-.3-.1-.1h.7l.5.1h.4l.5.1h1.4l.5.4.5.3.5.3.5.3.5.4.5.4.5.3.5.3.5.4.5.4.5.3.5.4.6.3.5.3.5.3.5.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M117.4 81.7l-.5.2-.5.1h-.5l-.5-.1-.5-.1-.5-.2-.6-.3-.5-.3-.7-.4-.6-.5-.7-.5-.8-.6-.9-.6-1-.6-1-.7-1.2-.7h1.5l.5.1h1l.1.1.1.1.2.1.2.3.4.3.4.4.5.4.5.4.6.5.6.4.6.5.7.4.6.4.7.3.6.3.6.2.6.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M119.5 81.4l-.7.3-.7.1-.8-.1-.7-.2-.9-.2-.7-.4-.8-.5-.8-.5-.7-.5-.7-.6-.6-.5-.6-.5-.5-.4-.3-.4-.3-.3-.2-.1h.9l.4.1h.9l.4.1h.5l.4.1.4.3.3.3.4.3.4.4.3.3.4.4.4.3.4.4.4.3.4.3.4.3.4.2.5.3.4.2.5.1.5.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M122 80.6l-.6.4-.6.3-.5.1h-.6l-.6-.1-.6-.2-.5-.2-.6-.4-.6-.3-.5-.5-.6-.5-.5-.4-.6-.5-.5-.5-.5-.5-.5-.5h.3l.3.1h.8l.4.1h.5l.5.1h.4l.2.4.2.3.2.3.3.3.2.3.4.3.3.3.3.2.4.3.4.2.5.2.4.1.4.1.5.1.5.1h.5z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M124.3 80.2l-.5.2-.5.1-.6.1h-1.2l-.6-.1-.6-.2-.6-.1-.6-.3-.5-.3-.5-.3-.5-.4-.4-.4-.3-.4-.3-.5-.2-.5h.4l.3.1h.4l.4.1h1.2l.5.1.2.3.2.2.2.3.3.2.2.3.3.1.2.2.3.2.3.2.3.1.3.1.3.2.4.1.4.1.4.1.4.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M125.4 79.8l-.1.2-.3.1h-1.1l-.4-.1-.5-.1-.4-.2-.5-.2-.4-.2-.5-.3-.4-.2-.4-.4-.3-.3-.3-.4-.2-.3h.5l.2.1h1.2v.2l.3.2.4.3.6.4.6.4.7.3.7.3.6.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M126.3 79l-.1.4-.1.2-.3.2h-.7l-.4-.2-.4-.2-.5-.2-.4-.2-.5-.3-.4-.3-.3-.3-.4-.2-.2-.2-.1-.1-.1-.1 2.3.3.2.1.2.2.4.1.4.2.4.2.3.1.4.2.3.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M123.7 77.8h.5l.4.1h1.1l.4.1h.4l.4.1-.1.6-.2.2h-.4l-.6-.1-.5-.3-.5-.3-.5-.2-.4-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M123.8 77.5l.5.1.4.1h.4l.3.1.4.1.3.1.4.1.5.1v-.7l-.3-.4-.4-.1h-.5l-.6.1-.6.1-.5.2-.3.1zM93.8 65.8l-1.2-.5-1.2-.3-1.1-.1-1.1.1-1 .2-1 .4-.9.5-.9.5-.9.6-.8.7-.8.8-.8.7-.8.7-.8.7-.9.7-.8.6h.3l.3.1h.3l.3.1h1l.3.1h.7l.3.1h.7l.3.1h.4l.4.1.2-.4.4-.5.4-.6.6-.6.5-.6.6-.6.7-.7.6-.6.8-.5.7-.6.7-.4.7-.4.8-.3.7-.2h.7l.6.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M96 66.3l-.7-.2-.7-.2-.7-.1-.7-.1-.6.1-.7.1-.7.2-.7.3-.7.4-.7.6-.7.6-.8.7-.8.8-.9 1-.9 1-.9 1.2h.5l.5.1h.4l.4.1h.4l.4.1.5.1.6.1.5-.5.5-.4.5-.5.5-.5.5-.5.4-.5.5-.5.5-.5.5-.4.5-.4.5-.5.5-.4.6-.4.5-.3.6-.3.6-.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M98.4 67l-.5-.5-.6-.2-.7-.1-.6.1-.8.3-.7.4-.7.6-.8.6-.7.6-.8.7-.7.7-.7.7-.6.7-.6.6-.6.5-.5.4 3.1.4.4-.4.4-.5.4-.5.4-.4.4-.5.4-.5.4-.4.4-.5.5-.4.5-.4.4-.4.6-.4.5-.4.6-.3.6-.3.6-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M103.1 69l-.8-.9-.9-.6-.8-.4-.8-.2H99l-.7.1-.8.3-.8.3-.7.6-.7.6-.8.7-.7.7-.7.8-.7.8-.7.9-.7.8h1l.4.1h.4l.3.1h.4l.4.1.5.1.6-.8.6-.7.6-.6.6-.6.6-.4.6-.4.5-.4.6-.3.5-.2.6-.2.5-.1.5-.1.5-.1h1.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M106.5 69.7l-.9-.3-.9-.3-.9-.1-.9-.1h-.8l-.8.1-.8.2-.7.3-.8.3-.7.4-.7.5-.6.5-.7.6-.6.6-.6.7-.6.7.6.1.7.1.6.1.7.1.7.1h1l.2-.1.2-.2.2-.3.4-.3.3-.3.5-.4.4-.4.6-.4.6-.4.6-.4.7-.3.7-.3.7-.3.8-.3.8-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M110.8 70.2l-.8-.3-.8-.2-.8-.1h-.8l-.9.1-.8.2-.8.2-.8.4-.8.3-.8.4-.7.5-.8.5-.6.5-.7.6-.6.5-.6.6h.4l.5.1h.5l.5.1h.6l.5.1h.7l.2-.2.3-.2.4-.3.5-.3.6-.4.7-.4.7-.4.7-.4.8-.4.7-.4.7-.3.7-.3.5-.2.5-.2.4-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M114.8 71.1l-.4-.7-.6-.3-.8-.2h-.8l-1 .2-1 .4-1.1.4-1.1.5-1.1.5-1 .6-.9.5-.9.6-.7.5-.5.3-.4.3h-.2l.4.1.5.1h.5l.5.1h.5l.6.1.5.1.5.1.6-.3.5-.3.5-.3.5-.2.6-.3.5-.3.5-.3.5-.3.6-.2.5-.3.5-.3.5-.2.6-.3.5-.2.5-.2.6-.2zM119.9 72.5l-.6-.5-.7-.3-.8-.1h-.8l-.8.2-.9.2-.8.3-.8.4-.8.5-.8.4-.7.4-.6.4-.5.4-.5.4-.3.2-.1.1.4.1.5.1h.7l.4.1h.4l.4.1h.5l.4-.2.4-.3.4-.3.4-.3.5-.3.5-.3.4-.3.5-.3.4-.3.5-.2.5-.3.5-.1.5-.2.4-.1h.5l.4.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M118 71.6l-.5-.3-.5-.2-.5-.1-.5-.1h-.5l-.5.1-.6.3-.7.2-.7.3-.7.3-.8.5-.8.4-1 .5-1 .5-1.2.6-1.2.6h.5l.5.1h.5l.5.1.5.1h.3l.3.1.1-.1h.1l.2-.2.2-.2.4-.2.4-.4.5-.3.6-.4.6-.4.6-.3.7-.4.7-.3.7-.3.7-.2.8-.2.7-.1h.6zM122.2 73.9l-.5-.6-.5-.4-.6-.3-.5-.1-.6-.1-.6.1-.7.1-.6.2-.6.3-.6.4-.6.4-.7.4-.6.4-.6.4-.6.4-.6.4.3.1h.4l.4.1h.5l.5.1.5.1h.5l.5.1.2-.4.2-.3.2-.3.3-.3.3-.3.3-.2.4-.2.3-.2.4-.1.5-.1.4-.1.5-.1h.9l.5.1h.5zM125.8 75.8l-.2-.2-.2-.2-.3-.2-.4-.1-.4-.1h-1.4l-.5.1-.5.1-.5.2-.5.2-.4.2-.4.3-.3.3-.3.4h.3l.3.1h.3l.3.1h.3l.2.1H121.5l.1-.1.3-.2.5-.2.5-.3.7-.2.7-.2.8-.1h.7z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M126.5 77v-.5l-.1-.3-.2-.2-.3-.2h-1.3l-.5.2-.5.1-.5.2-.5.2-.4.2-.3.1-.3.1-.1.2h-.1l2.3.4.2-.1.3-.1.4-.1.4-.1.4-.1.4-.1h.4l.3.1zM124.6 75.1l-.5-.4-.5-.3-.5-.2-.6-.2-.6-.1-.6-.1H120l-.6.2-.6.2-.6.2-.5.3-.5.3-.4.4-.3.5-.2.5h.3l.4.1h.4l.4.1h.4l.4.1h.4l.5.1.2-.3.2-.2.2-.2.3-.2.3-.2.3-.1.3-.2.4-.1.3-.1.4-.1.3-.1h1.5l.4.1zM22.2 61.3l-.1.1-.1.2-.2.4-.3.5-.3.5-.2.6-.3.7-.2.7-.2.7-.1.7.1.7.1.6.3.6.5.5.7.4.9.3-.1-.4-.1-.5-.1-.4-.1-.6v-2.1l.1-.5.1-.6v-.5l.2-.5v-.5l.2-.4.1-.4.1-.4-.1-.1H23l-.2-.1h-.2l-.1-.1h-.2l-.1-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M23.2 61.7l-.4 1.6-.3 1.4-.2 1.3v1.1l.1.9.1.8.3.7.2.6.4.4.3.4.4.3.4.2.4.1.3.1H25.8l-.1-.5-.2-.4-.1-.5-.2-.5-.1-.6-.1-.6v-.6l-.1-.6v-2.4l.1-.7.2-.6.1-.6.2-.6-.4-.1-.3-.1-.3-.1-.4-.1-.2-.1-.3-.1h-.2l-.2-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M25.5 62.4l-.2.6-.1.7-.2.8v.9l-.1 1 .1 1v1l.2.9.2.9.2.8.4.8.5.5.5.5.6.2h.8l.8-.2-.3-.5-.3-.6-.3-.6-.2-.5-.2-.6-.2-.6-.1-.6-.1-.6-.1-.6v-1.2l.1-.7v-.6l.1-.6.1-.6.2-.6-.3-.1-.3-.2-.4-.1-.3-.1-.4-.1-.2-.1-.3-.1-.2-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M32.8 74.4H32l-.7-.1-.7-.3-.6-.4-.6-.5-.4-.7-.4-.7-.4-.9-.3-.9-.2-.9-.2-1v-2.9l.2-1 .3-.9.3.2.3.1.3.1.4.1.3.1.4.1.4.1.3.1V65.4l.1.7V68.5l.1.8.1.8.1.8.2.7.1.7.2.6.3.5.2.4.4.4.3.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M30.8 64.2l.2.1.3.1h.3l.3.1.3.1.2.1.3.1.3.1.1.5V69l.1.8v.7l.1.8.1.7.1.7.1.6.3.6.2.6.3.4.4.4-.8-.2-.7-.3-.5-.4-.5-.4-.4-.6-.4-.6-.2-.7-.2-.7-.1-.8-.1-.9V68l-.1-1v-2.8z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M38.4 76.4h-1.2l-.9-.3-.8-.3-.7-.5-.5-.7-.4-.7-.3-.8-.2-.9-.1-.9-.1-.9-.1-1v-3.7l-.1-.8.3.1h.3l.3.1.3.1.3.1.2.1h.3l.3.1v.1l-.1.2v.3l-.1.4-.1.6V69l.1.8.1.9.3.9.3.9.5.9.5 1 .7 1 .9 1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M42.3 77.7l-.8.1h-.8l-.7-.3-.7-.4-.8-.6-.7-.6-.6-.8-.6-.9-.5-1-.4-1-.3-1.1-.3-1.1-.1-1.1v-1.2l.1-1.1.2-1.1 2.7.9V68l.1.7.1.7.1.8.1.8.3.8.2.9.3.8.4.8.4.7.5.8.5.7.6.6.7.6z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M38 66.3l.4.2.6.1.6.2.6.2.6.2.6.2.5.1.4.1.1.7v.7l.1.7v.7l.1.8v.8l.1.7.1.8.2.7.2.7.2.7.3.6.3.6.3.5.4.5.5.4-.5.1h-.6l-.6-.1-.7-.3-.6-.4-.6-.4-.5-.6-.6-.7-.5-.8-.5-.9-.4-1-.4-1.2-.3-1.2-.2-1.3-.2-1.5v-1.6z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M49 78.8l-1.3.1-1.1-.1-.9-.4-.8-.5-.6-.6-.5-.7-.4-.8-.3-.9-.2-.9-.2-1-.1-1v-1l-.1-1v-.8l-.1-.9-.1-.7.4.1h.4l.3.2h.3l.3.1.4.1.3.1.5.1.1.8v.8l.1.7.1.7.1.8.1.6.2.7.1.7.2.6.3.6.3.6.3.6.4.6.4.6.5.6.6.5z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M52.5 79.4l-1.2.1-1-.1-.9-.4-.7-.5-.7-.6-.6-.7-.4-.8-.4-.9-.4-.9-.3-1-.2-.9-.1-1-.1-.9-.1-.9-.1-.8-.1-.7.4.1.4.1.3.1h.3l.3.1.3.1.4.1.4.1.2 1.1.1 1 .2 1 .2.9.3.9.2.8.3.7.3.6.3.6.3.6.4.4.3.5.3.4.4.3.3.3.4.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M55.8 79.9h-1.1l-1-.1-.9-.3-.8-.5-.6-.6-.6-.7-.6-.8-.4-.9-.4-.8-.3-1-.3-.9-.2-1-.2-.9-.2-.8-.1-.8-.1-.7h.3l.4.1.3.1.4.1.3.1.4.1.3.1h.4v.6l.1.6.1.6.2.7.2.8.3.7.3.8.3.7.4.8.4.7.4.6.4.7.4.6.5.5.5.4.5.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M59.4 80.5l-1.2.2-1-.2-1-.3-.8-.6-.8-.7-.7-.9-.6-1-.6-1-.5-1-.4-1.1-.3-1-.3-.9-.2-.8-.1-.7-.1-.5v-.3l.4.1.4.1.4.1.4.1.4.1.4.1.4.1.3.1.2.5.1.5.2.7.2.7.2.8.3.8.3.8.3.9.3.8.4.7.4.7.5.7.4.5.5.4.6.4.6.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M62 80.4l-1.1.2H60l-.8-.2-.8-.4-.7-.5-.6-.7-.5-.8-.5-.9-.4-.9-.4-.9-.3-1-.3-.9-.2-.9-.2-.7-.1-.7-.2-.6.3.1h.4l.2.1h.3l.3.1h.3l.2.1h.2l.1.7.2.7.1.7.2.6.2.7.3.7.3.6.3.6.4.7.4.6.5.6.4.5.6.5.5.4.6.5.7.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M65.2 80.9h-.8l-.8-.1-.9-.2-.7-.3-.7-.4-.8-.5-.6-.5-.6-.7-.6-.7-.5-.8-.5-.8-.4-.9-.3-1-.3-1-.3-1-.2-1.1.4.1.4.1.4.1h.4l.3.1.4.1h.4l.3.1.2.6.1.6.2.6.1.6.2.6.2.6.2.6.3.6.3.6.3.6.5.6.5.6.6.5.7.6.8.5.8.6z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M69.9 81.4l-1.1.1h-1.1l-1-.2-1-.3-.9-.4-.8-.5-.8-.5-.7-.7-.6-.7-.6-.8-.5-.9-.4-.9-.4-1-.3-1-.2-1-.2-1.1.3.1.4.1h.3l.3.1h.4l.4.1.3.1.4.1.1.7.2.7.2.7.3.7.4.7.3.7.5.7.5.6.5.6.5.6.7.5.6.6.7.4.8.4.7.4.8.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M72.5 81.7h-1l-.9-.2-.9-.2-.9-.4-.8-.4-.9-.4-.8-.6-.7-.6-.6-.7-.7-.8-.5-.8-.5-.8-.4-.9-.4-.9-.2-1-.2-.9h.3l.3.1h.8l.3.1.3.1h.4l.4.8.4.8.3.8.3.7.4.6.3.6.3.6.4.5.4.6.5.5.5.5.6.5.6.4.8.5.8.5 1 .4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M77.1 82l-1.4.1-1.4-.1-1.1-.2-1.1-.3-1-.4-.9-.6-.9-.6-.7-.6-.7-.8-.6-.8-.6-.8-.5-.9-.5-.9-.4-.9-.4-.9-.4-.9h.3l.3.1h.4l.5.1.4.1h.4l.4.1h.2l.4.8.3.8.5.8.4.7.5.6.5.7.6.6.6.6.6.6.6.5.7.5.7.5.8.4.8.4.8.4.9.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M79.8 82.4H79l-.8-.1-.8-.2-.9-.4-.9-.3-.9-.5-.9-.5-.9-.6-.9-.7-.8-.7-.8-.8-.7-.9-.7-.9-.6-.9-.5-1.1-.4-1 .4.1h.4l.5.1h.8l.4.1.3.1h.1l.5.4.6.5.5.5.6.5.5.6.6.6.5.6.6.7.6.6.6.6.6.7.6.6.7.6.6.6.6.6.7.5z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M84 82.4l-.7.5-.8.2h-.8l-.8-.2-.8-.4-.8-.6-.9-.6-.8-.8-.8-.9-.9-.9-.9-1-.9-1-.9-.9-.9-1-.9-.8-.9-.8h.7l.4.1.4.1h.5l.5.1.4.1h.4l.7.7.7.7.7.7.7.6.6.7.7.7.7.7.6.6.6.7.7.6.6.5.6.4.6.4.5.4.6.2.6.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M87.3 82.8h-1.2l-1.2-.1-1-.3-.9-.4-.9-.5-.9-.5-.8-.7-.7-.7-.8-.7-.7-.8-.7-.8-.7-.8-.7-.8-.8-.7-.7-.8-.8-.6H74.4l.4.1h.5l.4.1h.8l.5.1.5.3.5.3.5.4.5.5.5.6.6.7.6.6.7.8.6.7.8.7.7.7.9.8.9.6.9.6 1.1.6zM23.3 59.1V59l-.1-.3v-1.1l-.1-.7.1-.8v-.8l.1-.9.1-.7.3-.8.3-.6.4-.6.5-.4.6-.2.8-.1.9.3-.3.3-.3.3-.2.4-.3.5-.2.5-.2.5-.2.6-.2.6-.2.6-.1.6-.1.6-.2.6-.1.6-.1.5-.1.5-.1.4h-.2l-.2-.1h-.1l-.1-.1H23.4l-.1-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M24.3 59.5l.4-1.8.4-1.6.4-1.4.4-1.1.4-.9.4-.7.4-.5.4-.4.4-.3.3-.1h.4l.3.1.3.1.3.1.3.2.2.2-.4.3-.4.5-.3.4-.4.4-.3.5-.4.5-.2.5-.3.5-.3.5-.2.6-.2.6-.2.6-.2.6-.2.7-.1.6-.2.7-.3-.1h-.5l-.1-.1h-.1l-.1-.1h-.1l-.2-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M25.8 60.1v-.7l.2-.8.2-.9.3-.9.4-.9.4-.9.5-.9.5-.9.5-.7.6-.7.6-.4.6-.4.7-.1.7.1.6.4.7.7-.6.4-.5.4-.4.4-.4.4-.5.5-.3.5-.4.5-.3.6-.3.5-.3.6-.2.6-.2.6-.2.7-.2.7-.1.7-.1.8-.4-.1-.3-.1-.4-.1-.4-.2-.3-.1-.3-.2-.3-.1h-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M37 52.5l-.7-.4-.7-.3-.7-.1-.7.1-.7.2-.7.4-.7.5-.6.6-.6.7-.6.8-.5.9-.4 1-.4.9-.3 1.1-.2 1-.1 1.1.3.1h.4l.3.2.4.1.4.1.3.1.4.1.3.1.3-.7.2-.7.3-.7.3-.7.3-.8.3-.7.3-.8.3-.7.4-.6.3-.6.4-.6.4-.5.5-.4.5-.4.4-.2.6-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M40.1 53.4l-1.1-.5-.9-.3h-.9l-.8.2-.7.3-.6.5-.5.6-.5.7-.4.8-.4.9-.4.9-.3.9-.4 1-.3.9-.3.9-.4.9h.3l.3.1.3.1.3.1.3.1.2.1.4.1h.3v-.4l.1-.4.1-.5.1-.6.2-.7.3-.7.3-.8.4-.8.4-.8.5-.7.6-.7.8-.7.8-.6.9-.5 1-.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M44.2 54l-.7-.5-.7-.3-.8-.1h-.8l-.9.2-.8.3-.9.5-.8.6-.8.7-.8.8-.6.9-.6 1-.5 1.1-.4 1.1-.3 1.2-.1 1.3 2.9.7.2-.4.2-.6.3-.6.2-.7.4-.7.3-.7.4-.7.5-.7.5-.7.5-.7.6-.7.6-.6.6-.5.8-.5.7-.4.8-.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M36.6 63.6l.4.1.6.1.5.2.6.2.6.2.5.1.5.2.4.1.3-.7.3-.8.4-.7.3-.8.3-.8.3-.7.4-.8.4-.7.4-.7.4-.7.5-.6.5-.5.4-.5.6-.4.6-.3.6-.2-.5-.4-.6-.2-.6-.2-.7-.1-.6.1-.8.2-.7.2-.7.5-.8.5-.7.7-.8.9-.7 1-.7 1.1-.7 1.3-.6 1.5-.6 1.6z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M51 56.1l-1.2-.6-1-.4-1-.1-.9.1-.8.4-.7.5-.6.7-.6.8-.6.9-.5.9-.4 1-.4 1-.4 1-.4 1-.3.8-.3.8.4.1h.3l.3.1.3.1.3.1.4.1h.4l.4.1.4-.8.3-.8.4-.7.3-.7.4-.7.3-.7.4-.7.4-.6.4-.6.5-.5.4-.5.5-.5.6-.5.6-.4.7-.4.7-.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M54.6 57.1l-1.1-.6-1-.2-.9-.1-.9.1-.9.4-.8.5-.7.6-.7.8-.7.9-.6.8-.5 1-.5.9-.5 1-.4.8-.3.9-.3.7.4.1.4.1h.3l.4.1.3.1.3.1h.4l.5.1.5-1.1.5-1.1.5-1 .5-.9.5-.8.4-.7.5-.6.4-.6.5-.5.4-.5.5-.3.5-.3.5-.3.5-.2.5-.1.6-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M57.3 57.9l-1-.5-1-.2h-.9l-.9.2-.8.3-.8.5-.7.6-.7.7-.6.8-.6.9-.5.9-.5.9-.5.9-.3.8-.4.8-.3.7.4.1.3.1.3.1.3.1h.3l.3.1.4.1h.3l.2-.6.3-.6.3-.6.3-.7.4-.7.5-.7.5-.7.6-.7.5-.6.6-.6.6-.6.7-.5.6-.5.6-.3.6-.3.6-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M60.5 58.7l-1-.5-1.1-.3h-1l-1 .3-.9.5-.9.6-.9.8-.8.9-.7.9-.7.9-.6 1-.5.9-.4.7-.3.7-.2.5-.1.3.5.1h.3l.4.1.4.1.4.1.3.1h.4l.3.1.3-.5.3-.6.3-.7.4-.7.5-.7.4-.8.5-.8.5-.7.6-.8.6-.6.6-.6.6-.5.6-.4.6-.3.7-.1h.6z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M62.9 59.6L62 59l-1-.3-.8-.1-.9.1-.8.4-.8.5-.7.6-.7.8-.6.8-.6.9-.6.9-.5 1-.4.8-.4.8-.3.7-.3.6.3.1h.3l.3.1.2.1.3.1.2.1h.2l.3.1.2-.7.4-.7.3-.7.3-.7.4-.7.4-.6.5-.7.5-.6.5-.6.6-.5.5-.4.7-.5.7-.3.7-.4.7-.2.8-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M65.9 60.3l-.8-.3-.9-.2h-1.6l-.9.2-.7.3-.8.4-.8.4-.7.6-.7.7-.7.8-.6.8-.6.9-.5 1-.5 1.1-.5 1.1.4.1h.4l.4.1.3.1.4.1.4.1.3.1.4.1.3-.7.2-.6.3-.7.3-.6.3-.7.3-.6.4-.6.4-.6.4-.5.6-.6.6-.5.6-.4.8-.4.8-.4 1-.3 1-.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M70.2 61.3l-1.1-.4-1.1-.3-1-.2h-1l-1 .2-.9.2-.9.4-.8.5-.8.6-.7.7-.7.8-.6.8-.6 1-.5 1-.4 1-.4 1.1.3.1.4.1h.4l.3.1h.4l.5.1h.4l.4.1.2-.8.2-.8.4-.7.4-.7.4-.7.5-.6.5-.6.6-.6.6-.5.7-.4.7-.4.8-.4.8-.2.8-.3.9-.1.9-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M72.3 61.6l-1-.2-1-.1-.9.1-.9.1-1 .2-.8.3-.9.4-.8.4-.7.6-.7.6-.7.7-.6.8-.5.8-.4 1-.4 1-.3 1 .3.1h.3l.3.1h.3l.3.1h.3l.3.1.4.1.5-.9.4-.8.4-.7.4-.7.4-.6.4-.6.4-.6.4-.5.5-.5.5-.5.6-.4.6-.3.7-.4.8-.2 1-.3 1.1-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M76.8 62.2l-1.4-.4-1.4-.2h-1.2l-1.2.1-1 .2-1 .4-.9.4-.8.6-.8.6-.7.7-.6.8-.6.8-.5.9-.6.9-.4.9-.5 1h.6l.3.1.4.1.4.1.3.1h.6l.4-.9.5-.7.5-.8.5-.7.6-.6.6-.6.7-.6.7-.5.7-.5.7-.4.8-.4.8-.3.9-.4.8-.2.9-.3.9-.2z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M79.6 62.4l-.8-.1H77l-1 .2-.9.2-1 .2-1 .4-.9.5-1 .5-.9.7-.9.7-.9.7-.8.9-.7.9-.6 1-.6 1.1h.4l.4.1.5.1.4.1.3.1h.3l.2.1.2-.1.5-.3.6-.4.6-.5.6-.5.7-.5.6-.6.7-.6.7-.6.7-.6.8-.6.7-.6.8-.5.7-.6.8-.5.8-.4.8-.5z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M83.4 63.5l-.7-.7-.8-.4-.8-.2-.9.1-.8.2-.9.4-1 .6-.9.7-1 .8-1 .8-1 .9-1 .9-1.1.9-1 .8-1 .8-1.1.7.3.1H70l.5.1h1.3l.8-.6.7-.6.8-.6.7-.6.7-.7.6-.6.7-.6.7-.5.6-.6.7-.4.7-.5.7-.4.8-.3.7-.2.8-.2.9-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M86.3 63.9l-1.3-.3-1.1-.1h-1l-1 .2-1 .4-.9.4-.9.6-.9.6-.8.7-.8.7-.8.7-.9.8-.8.7-.8.7-.9.6-.9.6.3.1h.3l.5.1h.4l.4.1h.7l.2.1h.5l.5-.2.6-.2.5-.4.6-.5.6-.5.7-.6.7-.7.7-.6.8-.7.8-.7.9-.6.9-.6 1-.6 1-.4 1.2-.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M89.9 64.9l-1.1-.6-1.1-.3h-1.1l-1.1.3-1.1.4-1.2.6-1.1.7-1 .8-1 .9-1 .8-.9.8-.9.8-.8.6-.7.5-.6.3-.6.1h.5l.5.1.5.1.6.1h.6l.5.1.6.1h.5l.8-.6.7-.6.7-.6.6-.5.6-.6.5-.5.6-.5.5-.5.6-.5.6-.4.6-.4.7-.4.8-.3.8-.3.9-.3 1-.2zM20.2 53.1l-.1-.3-.1-.3-.1-.3-.1-.3-.1-.4-.1-.4-.1-.3v-.7l-.1-.4v-.4l.1-.3v-.4l.1-.3v-.4l.1-.3-.4.6-.4.7-.2.6-.2.7v1.4l.1.7.1.7.2.6.2.7.3.7.2.6.3.7.3.6.2.6.3.5-.1-.1V57.3l-.1-.4v-2.5l-.1-.4v-.3l-.1-.3-.1-.3zM11.5 65l.5-.3.6-.3.5-.3.5-.4.5-.3.5-.3.4-.3.5-.3.5-.3.4-.2.5-.4.5-.3.4-.2.5-.3.5-.3.6-.3-.5.5-.5.4-.4.5-.5.4-.5.5-.4.4-.5.4-.6.4-.4.3-.6.3-.4.3-.6.2-.5.1-.5.1-.5.1-.5-.1z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M15.7 53.5l.4.3.4.2.4.3.3.2.4.3.3.3.3.3.3.3.3.3.3.3.3.3.3.4.2.3.3.3.3.4.2.3-.1-.3-.1-.4-.2-.4-.2-.4-.1-.4-.2-.4-.3-.4-.2-.3-.3-.4-.4-.3-.3-.3-.4-.2-.5-.2-.5-.2-.6-.1-.6-.1zM20 50.1l.1.5.1.6.1.6.1.5.1.6.1.5v.5l.1.5.1.5.1.6v.4l.1.6.1.5.1.5.1.5.1.6.1-.7.1-.6v-.6l.1-.6v-2.4l-.1-.6-.1-.5-.1-.5-.2-.5-.2-.5-.3-.4-.3-.3-.4-.3z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M16.9 49.1l-.5.5-.3.6-.1.5-.1.6.2.6.2.7.3.6.4.6.4.6.5.7.5.5.4.5.5.6.4.4.4.4.2.3v-.9l-.1-.7-.2-.6-.2-.6-.2-.5-.3-.4-.3-.4-.3-.4-.3-.4-.3-.4-.3-.4-.3-.4-.2-.5-.2-.6-.1-.7-.1-.8z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M20.6 58.3v-.6l.1-.6V55.4l.1-.5.1-.5v-.6l.1-.5.1-.5.1-.5.1-.6.2-.5.2-.5.2-.5.2-.5-.8.8-.7.8-.5.7-.4.7-.2.6-.1.6v1.2l.2.5.1.5.2.4.2.4.2.4.2.4.1.3v.3zM12.2 60.3l.5.1.4.1h.5l.4.1h.5l.5.1h.9l.4-.1h.9l.4-.1h.9l.5-.1.4-.1-.3.2-.4.2-.4.1-.4.2-.5.1-.4.1-.4.1-.5.1h-1.4l-.5-.1-.5-.1-.5-.3-.5-.2-.5-.4z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M14.9 62.6l-.4.1-.3.1h-.3l-.4.1-.3.2-.4.1-.3.1-.3.2-.3.2-.4.2-.2.2-.3.2-.3.2-.2.2-.2.3-.2.2.2-.7.3-.6.3-.5.5-.5.5-.4.6-.3.6-.4.7-.2.7-.2.7-.3.7-.2.7-.1.7-.2.7-.1.6-.1.7-.2-.3.1-.5.3-.5.3-.6.4-.6.4-.7.4-.6.3-.6.2zM13.6 67.8l-.3-.7-.1-.6.1-.6.2-.6.4-.6.4-.5.6-.5.6-.5.6-.4.7-.4.7-.4.6-.4.6-.3.6-.3.5-.3.4-.2-.4.8-.4.7-.5.6-.4.5-.4.3-.4.4-.5.3-.4.2-.4.3-.5.3-.4.2-.4.4-.4.4-.4.5-.4.6-.3.8z\"/><path fill=\"#DCDDDE\" stroke=\"#D9D9D9\" stroke-width=\".254\" d=\"M20.8 60.7l-.3.5-.3.5-.3.5-.3.4-.3.5-.2.5-.3.4-.2.5-.3.5-.2.5-.2.4-.1.5-.2.6-.1.4-.1.6-.2.5-.2-1.1-.2-.9v-.9l.1-.7.1-.7.3-.6.3-.4.4-.4.4-.4.4-.3.4-.3.4-.2.4-.3.3-.2.3-.2.2-.2z\"/><path fill=\"#231F20\" stroke=\"#231F20\" stroke-width=\".596\" d=\"M126.9 75.4c-10.2-1.4-47.8-3.3-64.5-6-13.5-2.2-26.7-6.2-39.2-10.4-3.3-1.1-9-3.3-12.7-5.3-2.3-1.8-7.9-4.4-9.5-6.9 24.4 11.6 34.2 14.8 62.8 20.5 11.6 2.3 53.8 5.7 63.1 8.1z\"/><defs><path id=\"a\" d=\"M90.9 79.9l-1.1.3-1.1.1-1-.1-1.1-.5-1-.5-1.1-.8-1-.8-.9-1-1-.9-.8-1-.9-.9-.7-.8-.8-.8-.6-.5-.6-.4-.5-.2h.4l.5.1h.5l.5.1h.5l.6.1h.5l.4.1.7.6.7.7.6.6.6.6.5.6.6.6.4.6.6.6.5.5.5.5.6.5.7.4.7.5.7.4.9.4 1 .3\"/></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#b)\"><defs><path id=\"c\" d=\"M76.7 71.1h14.2v9.2H76.7z\"/></defs><clipPath id=\"d\"><use xlink:href=\"#c\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#d)\"><image overflow=\"visible\" width=\"44\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHmAAACKAAAAsz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEALwMBIgACEQEDEQH/ xACYAAACAwEAAAAAAAAAAAAAAAAABgEEBQMBAAMBAQAAAAAAAAAAAAAAAAACAwQFEAAABgEEAwAA AAAAAAAAAAAAAQIDBAUVIBIGFhARFBEAAAIGCAMJAAAAAAAAAAAAAAIBETESAwRBkdEiQpITMyAh YXGhMsKDwxR0BRIAAgICAQUAAAAAAAAAAAAAAQIAERIyIDFRkaGx/9oADAMBAAIRAxEAAAB0qU1/ P022VKZ2beqfotHqruWFsbKNUNGVqTfJNoC8cAAAD//aAAgBAgABBQBwnN/p4IJ3eSSMtiQaCLR/ /9oACAEDAAEFAI0InGccH4OxuLLS2z9yBImIWz5//9oACAEBAAEFAJ8xUUZhYy6xllDKqDE83Ry2 SbAKyUCsjBWYKzIVM4nBzXTRDlFVNsR1a7HVrsdWux1a7FVQWkbX/9oACAECAgY/ADixAmzQWzVc skTqJdjh/9oACAEDAgY/AFegcr9GprGfHUXEQsBV/ZuvmOoYHJe/D//aAAgBAQEGPwCGpV9beirR hqGEUCgRGXCGPUJRWLU7nAxIpFIakTvPwSkU9TokvV9vh/R+jH8olfiEQfS1H1mQVTzim9g2S5y2 jZLnLaNkucto2S5y2ic1oaC60rFgw75UrOd11HJPTj//2Q==\" transform=\"matrix(.3604 0 0 -.3604 75.738 81.315)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M90.9 79.9l-1.1.3-1.1.1-1-.1-1.1-.5-1-.5-1.1-.8-1-.8-.9-1-1-.9-.8-1-.9-.9-.7-.8-.8-.8-.6-.5-.6-.4-.5-.2h.4l.5.1h.5l.5.1h.5l.6.1h.5l.4.1.7.6.7.7.6.6.6.6.5.6.6.6.4.6.6.6.5.5.5.5.6.5.7.4.7.5.7.4.9.4 1 .3z\"/><defs><path id=\"e\" d=\"M94.4 79.7l-1.2.2-1.2.1-1.1-.2-1-.2-1-.4-.8-.5-.9-.6-.8-.6-.8-.7-.7-.8-.7-.8-.7-.8-.7-.7-.7-.8-.8-.7-.7-.7h.6l.3.1h.6l.3.1h.7l.3.1h.3l.4.1h1.3l.4.1.2.4.4.5.4.5.4.6.5.7.6.7.5.6.6.7.7.6.6.6.7.6.6.5.6.3.7.3.6.1h.5\"/></defs><clipPath id=\"f\"><use xlink:href=\"#e\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#f)\"><defs><path id=\"g\" d=\"M80.6 71.5h13.8v8.4H80.6z\"/></defs><clipPath id=\"h\"><use xlink:href=\"#g\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#h)\"><image overflow=\"visible\" width=\"44\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHvAAACNAAAAuX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEALwMBIgACEQEDEQH/ xACfAAEBAQEAAwAAAAAAAAAAAAAABgUEAQIHAQACAwEAAAAAAAAAAAAAAAAABAECAwUQAAAFBAIB BQAAAAAAAAAAAAABAwQFEQISFhAGIBMzFBU2EQABAQQHBgcAAAAAAAAAAAACAQDRAwQgERIycpIz MXGhsaKzIVFhIkJiBRIBAAECBQQDAAAAAAAAAAAAAQARAiAhMZESYXGhMiJCA//aAAwDAQACEQMR AAAAsuDmlI6tr5iUMW/Z88phb3kredbUymqvplVGZvZ0oguqAAH/2gAIAQIAAQUAMrhS8EV1UvTw okFSTx5//9oACAEDAAEFAGjRuoj9e0Dxmgkiksdtnyrgsud9nP8A/9oACAEBAAEFAJOWbxlu3R42 yPG1MBtLANpVu5ad09rwgfzvdzolmMxmMxAHXrnaYp7JJ6nNjU5sanNjU5sREQ/awvl//9oACAEC AgY/AMpr4mbDkg957W7z4ouD/9oACAEDAgY/ALb/ANOXJrWj1n23jfYvITVhaNKT2I2rg//aAAgB AQEGPwCGUcSJIqqg2avjV572uH0va4fS9rh8HtcPg9o00CEgQEJSRaq/aNppTEfIaP6eGL2mlMR8 ho/qL9YvaaXGUBDWGpqdZIO1Bq27m0Rzi9tEc4vbRHOL20Rzi9p+TjAgx5hIiQxQkVFtQ7KeKetP /9k=\" transform=\"matrix(.3604 0 0 -.3604 79.845 80.96)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M94.4 79.7l-1.2.2-1.2.1-1.1-.2-1-.2-1-.4-.8-.5-.9-.6-.8-.6-.8-.7-.7-.8-.7-.8-.7-.8-.7-.7-.7-.8-.8-.7-.7-.7h.6l.3.1h.6l.3.1h.7l.3.1h.3l.4.1h1.3l.4.1.2.4.4.5.4.5.4.6.5.7.6.7.5.6.6.7.7.6.6.6.7.6.6.5.6.3.7.3.6.1h.5z\"/><defs><path id=\"i\" d=\"M96.8 79.8h-.7l-.7.1h-.7l-.6-.1-.7-.2-.6-.2-.7-.4-.6-.4-.7-.5-.6-.6-.7-.6-.7-.8-.7-.9-.8-1-.7-1-.9-1.2h1l.5.1h.4l.5.1h1.5l.5.5.4.5.4.4.5.5.4.5.4.6.4.4.4.6.5.5.4.4.5.5.4.5.5.4.5.4.5.5.5.4\"/></defs><clipPath id=\"j\"><use xlink:href=\"#i\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#j)\"><defs><path id=\"k\" d=\"M85.7 72h11v7.9h-11z\"/></defs><clipPath id=\"l\"><use xlink:href=\"#k\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#l)\"><image overflow=\"visible\" width=\"36\" height=\"26\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHnAAACJwAAAtj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AJwMBIgACEQEDEQH/ xACmAAADAQEAAAAAAAAAAAAAAAAABQYBBAEBAAIDAAAAAAAAAAAAAAAAAwAEAQIFEAABAgYCAwEA AAAAAAAAAAAAAwQBEQIFFQYTFBIjJDURAAADBAUHDQEAAAAAAAAAAAABAxECEgQx4TKiEyGh0dKj BTUgQWHBIkLCM1Nzg8MUFRIAAQICCAcAAAAAAAAAAAAAAAERoRIhMUFRAiIyExDwYXGB4gP/2gAM AwEAAhEDEQAAALfmXTwdKz2M3RrgQi0slr1U7S5UEbmHJip//9oACAECAAEFAFOXymuezihCmUqC UJ//2gAIAQMAAQUAbMYKo4yB1vrbvaUkslSdmHb/AP/aAAgBAQABBQB49paGZTMwmZZMRfULJ7a5 qQIXKshc6iF0iWV7ysN2JkyZr35l8YWt4YHWDA6wYHWC3WyzN2v/2gAIAQICBj8AWVWTshqghXnv 8lPDof/aAAgBAwIGPwDD9G1PbcrFUTYbmWYw4FfK8VctN+lvWU//2gAIAQEBBj8AcidijbzsoZpF i9ULF6oWM9QVfJ1hJFEeXoM+oSkPexM0AoFBigxvN/0kW3VNAkvl+vkb59jwKhD+hM/mw48PtuJx RQxeYRtYwhxLbo6o4jt0dUcR26OqJ1OVm8VJdOGYfxE3sN1j5Na6THchnSP/2Q==\" transform=\"matrix(.3604 0 0 -.3604 84.68 80.702)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M96.8 79.8h-.7l-.7.1h-.7l-.6-.1-.7-.2-.6-.2-.7-.4-.6-.4-.7-.5-.6-.6-.7-.6-.7-.8-.7-.9-.8-1-.7-1-.9-1.2h1l.5.1h.4l.5.1h1.5l.5.5.4.5.4.4.5.5.4.5.4.6.4.4.4.6.5.5.4.4.5.5.4.5.5.4.5.4.5.5.5.4z\"/><defs><path id=\"m\" d=\"M99.3 79.6l-.5.3-.6.1h-.7l-.6-.3-.6-.4-.7-.5-.6-.6-.7-.7-.6-.7-.7-.7-.6-.8-.6-.7-.6-.7-.5-.6-.6-.6-.4-.4 3.1.2.3.5.4.5.3.4.4.5.3.4.4.5.3.5.4.4.4.4.4.5.4.4.5.5.4.4.5.4.6.4.5.4\"/></defs><clipPath id=\"n\"><use xlink:href=\"#m\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#n)\"><defs><path id=\"o\" d=\"M89.7 72.3h9.6v7.8h-9.6z\"/></defs><clipPath id=\"p\"><use xlink:href=\"#o\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#p)\"><image overflow=\"visible\" width=\"32\" height=\"25\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHRAAACBQAAAoj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwAJAMBIgACEQEDEQH/ xACXAAACAwEAAAAAAAAAAAAAAAAABgIDBQcBAAMBAQAAAAAAAAAAAAAAAAIEBQMBEAAABAUEAwAA AAAAAAAAAAAAAQMEEBECEgUTNAYWJBUmEQABAQYEBgMBAAAAAAAAAAABAgAQERIDE7EyM3Mh0ZJD owQxQVEVEgEAAAUCBwAAAAAAAAAAAAABABAxoQIhEhFBUWHRIgP/2gAMAwEAAhEDEQAAAHHNgpDV cZpdvGOmAHCWVB/w93Fy7dmWzeAtN//aAAgBAgABBQAyqEq4JnRaZpw//9oACAEDAAEFAGbVuoib BpIIGtYdTiQ//9oACAEBAAEFAMrlU8Yn25sO2tgnylsooOZ7WDXdDmxya3i8NKvKGf8AT6PxA+IC PTNYf//aAAgBAgIGPwDRitpHEbRRtL//2gAIAQMCBj8Axy+g7lefeFBp1ZGzFTWH1beZf//aAAgB AQEGPwCmuogrFQlIgYfAi2ieocm0j1DkyUCkYqIGYfZh+O9bcVg+juJxDvW3FYPo7icQ6l/WmtzG 3LNmhxyN3PK3c8rU7dy5MJNXNHg7/9k=\" transform=\"matrix(.3604 0 0 -.3604 88.877 80.813)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M99.3 79.6l-.5.3-.6.1h-.7l-.6-.3-.6-.4-.7-.5-.6-.6-.7-.7-.6-.7-.7-.7-.6-.8-.6-.7-.6-.7-.5-.6-.6-.6-.4-.4 3.1.2.3.5.4.5.3.4.4.5.3.4.4.5.3.5.4.4.4.4.4.5.4.4.5.5.4.4.5.4.6.4.5.4z\"/><defs><path id=\"q\" d=\"M104.4 79l-.9.5-.8.4-.9.2h-.8l-.8-.1-.7-.3-.7-.4-.7-.5-.7-.7-.7-.6-.7-.8-.6-.8-.6-.8-.7-.9-.6-.8-.6-.9.5.1.4.1h1.1l.4.1h.5l.5.8.6.7.5.7.6.6.6.5.6.5.6.5.5.4.6.4.6.3.5.2.5.2.6.2.4.1h.5l.4.1\"/></defs><clipPath id=\"r\"><use xlink:href=\"#q\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#r)\"><defs><path id=\"s\" d=\"M92.9 72.5h11.5v7.6H92.9z\"/></defs><clipPath id=\"t\"><use xlink:href=\"#s\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#t)\"><image overflow=\"visible\" width=\"40\" height=\"25\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHgAAACIQAAArL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwAKgMBIgACEQEDEQH/ xAChAAEBAQEBAQAAAAAAAAAAAAAFBgADAQQBAAIDAAAAAAAAAAAAAAAAAAMFAQIEEAABAgYBAwUA AAAAAAAAAAAAAgMBEQQFFQYUIhMmISQ0JRYRAAEBBgMFCQAAAAAAAAAAAAEAETGhAhIDEBNDICFB URRhIjJyorLCcxUSAAAFAgMJAQAAAAAAAAAAAAABESECMRKh0QMQUWGRMkJSYhMz/9oADAMBAAIR AxEAAAC15zpudpa6M9ra67CtGxQhFZ8BmQWd0GUoSVoWf//aAAgBAgABBQBUXpzfJr7fQdB6H//a AAgBAwABBQBq3QW3jDj+5YW/BruVBNfO/9oACAEBAAEFAKi4tMO5ZgyrBlGCnqEVCTYq1bN1hc1k LoohdYmsVPIpDaY/czJkzTfgl6/O5Dw88PPDzX8Zxj//2gAIAQICBj8ANDZWYVwC96B9nAf/2gAI AQMCBj8AhPyiUq7xTEfH2QaaacjKyKGscx+Uuccwtp339LLQf//aAAgBAQEGPwA2pgSQyK8JTinF GaRwLMLsgG4CSMoTlxXFXZuVxnpGF7yye0bF/wC34y4XOvzepZLVQ2ljAyC14rXiteKufmV5Vffz H1MHPsw//9k=\" transform=\"matrix(.3604 0 0 -.3604 92.12 80.902)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M104.4 79l-.9.5-.8.4-.9.2h-.8l-.8-.1-.7-.3-.7-.4-.7-.5-.7-.7-.7-.6-.7-.8-.6-.8-.6-.8-.7-.9-.6-.8-.6-.9.5.1.4.1h1.1l.4.1h.5l.5.8.6.7.5.7.6.6.6.5.6.5.6.5.5.4.6.4.6.3.5.2.5.2.6.2.4.1h.5l.4.1z\"/><defs><path id=\"u\" d=\"M107.1 78.8l-1 .1-.8.1-.9-.1-.8-.1-.8-.2-.8-.2-.7-.3-.7-.4-.7-.5-.6-.5-.7-.5-.6-.6-.5-.6-.6-.7-.5-.8-.6-.7h.6l.7.1h.6l.6.1h.9l.3.1h.2v.1l.2.1.2.2.3.3.3.4.4.4.4.4.5.5.6.4.6.5.5.5.7.4.6.5.7.4.7.3.7.3\"/></defs><clipPath id=\"v\"><use xlink:href=\"#u\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#v)\"><defs><path id=\"w\" d=\"M95.8 72.8H107V79H95.8z\"/></defs><clipPath id=\"x\"><use xlink:href=\"#w\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#x)\"><image overflow=\"visible\" width=\"36\" height=\"21\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHnAAACGgAAArf/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABkAJAMBIgACEQEDEQH/ xACtAAACAwEAAAAAAAAAAAAAAAAABgQFBwEBAAIDAQAAAAAAAAAAAAAAAAEEAAIDBRAAAQIEBQQD AAAAAAAAAAAAAAQFEQIDFQESFAYWECAhEyMlRhEAAAQCBgQPAQAAAAAAAAAAAAECAxESIdGSEzME IHEUNPAxQWGRobEiMlKiU4OzVBUSAAECAwMNAQAAAAAAAAAAAAABAhExQYGhMxDwIWFxEiIyQpKi E0M0/9oADAMBAAIRAxEAAABoj0VUOw59SyaaGUpEYVbpAyM3NIDdbGQyX//aAAgBAgABBQCExCYh iSxy+en/2gAIAQMAAQUAoo0k1LQoz0UST35cNSfKf//aAAgBAQABBQBfuVGhV8xbzmDecvby7p7X ubH7uJEifidxNrlXeLO7lndyzu5o1fD+3//aAAgBAgIGPwDJZeJyS1kmXnTiZ2H/2gAIAQMCBj8A Y5yO3nMaq8VVTSSd3Ff2emfzGwhCCQ2FCmP5n//aAAgBAQEGPwBzKutuKW3CJphDvJJXKfOMJ3oT WMJzqrGG56ax/UlVc+Wibx3faMz8f1o0OH6BmHWMs440qSVaUmZHBtJHTrG5vWDG5vWDG5vWDGy3 K9p9mBz483Fqp0v/2Q==\" transform=\"matrix(.3604 0 0 -.3604 95.02 79.955)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M107.1 78.8l-1 .1-.8.1-.9-.1-.8-.1-.8-.2-.8-.2-.7-.3-.7-.4-.7-.5-.6-.5-.7-.5-.6-.6-.5-.6-.6-.7-.5-.8-.6-.7h.6l.7.1h.6l.6.1h.9l.3.1h.2v.1l.2.1.2.2.3.3.3.4.4.4.4.4.5.5.6.4.6.5.5.5.7.4.6.5.7.4.7.3.7.3z\"/><defs><path id=\"y\" d=\"M110.6 79l-.8.1-.7.1-.8-.1-.8-.1-.8-.3-.7-.3-.7-.4-.8-.4-.7-.5-.7-.5-.6-.6-.7-.6-.6-.6-.6-.5-.5-.6-.5-.6h.8l.5.1h1.4l.4.1h.3v.1l.1.1.3.3.4.3.5.4.5.5.7.5.6.4.7.6.7.5.7.5.6.4.6.4.5.3.4.3.3.1\"/></defs><clipPath id=\"z\"><use xlink:href=\"#y\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#z)\"><defs><path id=\"A\" d=\"M99.6 73.1h11v6.1h-11z\"/></defs><clipPath id=\"B\"><use xlink:href=\"#A\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#B)\"><image overflow=\"visible\" width=\"36\" height=\"21\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHWAAACDQAAArb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAJwMBIgACEQEDEQH/ xACcAAEBAAIDAQAAAAAAAAAAAAAABgEEAgMFBwEBAAMBAAAAAAAAAAAAAAAAAwECBQQQAAAGAgIC AwAAAAAAAAAAAAABAgMEBRMUEQYhEkEiFREAAAQEBQEJAAAAAAAAAAAAAAECAxESMgQhkdETkzUx ImJyM4PDFAUSAAAFAgQHAAAAAAAAAAAAAAABEQISMWGR8TITECFB0UKiRP/aAAwDAQACEQMRAAAA sNDWmB1rHlGZo/0B4xs3unxmZJegFOD/2gAIAQIAAQUAW2s1YnB6qxlzx5Hz/9oACAEDAAEFAIkR pxj89kYU7cf2xfcedr//2gAIAQEAAQUAtZ6oQK+cBXjgK7WIs03oXdFGQyLBOuDO6KRxaut9qYiP DQqRoVI0KkVDERFD/9oACAECAgY/ADMnOIrGNbsTEVNUqMhlw//aAAgBAwIGPwBj3JI1XExVo2uU ZxDU3uumKVuPo9B5rO0uw//aAAgBAQEGPwBqUyLcmjHwy6iosiFRZEKiyIPXBni3Nj5UkoWUDh6v xio8xUYqMfoKM4qLegftJFr9m6K1l3JYtqcmjJGjsgOqp4HdB1RPA7oOqJ4HdBettXROsq3Z39tS SRFtJH3VYnAsR//Z\" transform=\"matrix(.3604 0 0 -.3604 98.728 80.095)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M110.6 79l-.8.1-.7.1-.8-.1-.8-.1-.8-.3-.7-.3-.7-.4-.8-.4-.7-.5-.7-.5-.6-.6-.7-.6-.6-.6-.6-.5-.5-.6-.5-.6h.8l.5.1h1.4l.4.1h.3v.1l.1.1.3.3.4.3.5.4.5.5.7.5.6.4.7.6.7.5.7.5.6.4.6.4.5.3.4.3.3.1z\"/><defs><path id=\"C\" d=\"M114.5 79l-.4.4-.7.2h-.7l-.8-.2-1-.3-.9-.5-1-.6-1-.6-1-.7-.9-.7-.8-.7-.8-.6-.7-.5-.4-.4-.4-.3-.1-.1H104.1l.4.1h.5l.4.1h1l.5.3.5.4.6.3.4.3.6.4.4.3.6.4.5.3.5.4.5.3.5.4.5.3.5.3.5.4.5.3.5.3\"/></defs><clipPath id=\"D\"><use xlink:href=\"#C\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#D)\"><defs><path id=\"E\" d=\"M102.9 73.4h11.6v6.3h-11.6z\"/></defs><clipPath id=\"F\"><use xlink:href=\"#E\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#F)\"><image overflow=\"visible\" width=\"40\" height=\"22\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHgAAACFwAAArj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABkAKgMBIgACEQEDEQH/ xACjAAACAwEAAAAAAAAAAAAAAAAABQQGBwEBAAIDAQAAAAAAAAAAAAAAAAIDAAQFARAAAAQEAwkA AAAAAAAAAAAAAAIEBQEDFAYREhUQIDFCEyMkNRYRAAECBAMECwAAAAAAAAAAAAECAwAREpIh4QQQ cTM0IDAxUWHBMrJzg7MSAAECAwYHAAAAAAAAAAAAAAABAhEhEjFBgaEyQlFxkcEiAxP/2gAMAwEA AhEDEQAAALNHSKw27h2nHD0WYgflmUldo5YbnBo5GJHYLp//2gAIAQIAAQUAiU4ynGEcsOA5v//a AAgBAwABBQCSjSmlUCUdGXWS6jJ5Q7lR/9oACAEBAAEFAHC4iolkLsIPqiD6kgbV8F8gXN7vZiLO 9YLhbXGe8aO7jR3caO7i1EyhM3b/AP/aAAgBAgIGPwCTlNS9CEZ8RNNhsLux/9oACAEDAgY/APW5 yeTmNVZraqFmany2VwwG00wpSHI25l1dWET/2gAIAQEBBj8Ac0pbCi3TjVL1JCu7xjhC7KOELso4 QuyhTwTTSsokDPsAPns1P1/mjoO/Or2N7NQ6xpnHG1UUrSkkGTaQcd8cm9YY5N6wxyb1hhxvUtqa WXlKCViRlSgTx3dR/9k=\" transform=\"matrix(.3604 0 0 -.3604 102.032 80.634)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M114.5 79l-.4.4-.7.2h-.7l-.8-.2-1-.3-.9-.5-1-.6-1-.6-1-.7-.9-.7-.8-.7-.8-.6-.7-.5-.4-.4-.4-.3-.1-.1H104.1l.4.1h.5l.4.1h1l.5.3.5.4.6.3.4.3.6.4.4.3.6.4.5.3.5.4.5.3.5.4.5.3.5.3.5.4.5.3.5.3z\"/><defs><path id=\"G\" d=\"M117.4 79l-.5.2-.5.1h-.5l-.5-.1-.5-.1-.5-.2-.5-.3-.6-.4-.6-.4-.7-.4-.7-.5-.8-.6-.9-.6-1-.6-1-.7-1.1-.8.4.1h1.6l.4.1h.7v.1l.2.2.3.2.3.4.4.3.5.5.5.4.6.4.6.5.7.5.6.4.7.4.6.3.6.3.6.2.6.1\"/></defs><clipPath id=\"H\"><use xlink:href=\"#G\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#H)\"><defs><path id=\"I\" d=\"M106.5 73.6h10.9v5.7h-10.9z\"/></defs><clipPath id=\"J\"><use xlink:href=\"#I\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#J)\"><image overflow=\"visible\" width=\"36\" height=\"20\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHEAAAB8AAAAlf/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAJwMBIgACEQEDEQH/ xACRAAEBAAMBAAAAAAAAAAAAAAAAAwECBAYBAQADAQAAAAAAAAAAAAAAAAMBAgQFEAABAwQCAwAA AAAAAAAAAAADAAECERIiEwQUIUI0EQABAwIFBQAAAAAAAAAAAAABABECQZIgIXESMzFRocEDEgAB AwEGBwAAAAAAAAAAAAAAARESAjFhoTJCoiFB0SKCE0P/2gAMAwEAAhEDEQAAAPdSzDnNZEc9jRuL WAKsh26RsH//2gAIAQIAAQUAOUjF3lV0uuW2/BeNP//aAAgBAwABBQCMWeNsVTOFbcl7/wD/2gAI AQEAAQUAOWQ37JF2SLskUCSkLlPlVlVlVC+flwHKWoC1gWsCHGDcf//aAAgBAgIGPwCpEqVEQz1E n7oO5U/q8pPgfHeaWhfHqf/aAAgBAwIGPwBOBYNeJmwNW052n//aAAgBAQEGPwACLZ91RUVEZnqH 8KOmCWhUd/02FsgxK5jaVzG0rmNpUgJvFi8m9L//2Q==\" transform=\"matrix(.3604 0 0 -.3604 105.509 80.264)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M117.4 79l-.5.2-.5.1h-.5l-.5-.1-.5-.1-.5-.2-.5-.3-.6-.4-.6-.4-.7-.4-.7-.5-.8-.6-.9-.6-1-.6-1-.7-1.1-.8.4.1h1.6l.4.1h.7v.1l.2.2.3.2.3.4.4.3.5.5.5.4.6.4.6.5.7.5.6.4.7.4.6.3.6.3.6.2.6.1z\"/><defs><path id=\"K\" d=\"M119.5 78.7l-.7.3-.7.1-.7-.1-.8-.2-.8-.3-.8-.3-.8-.5-.8-.5-.7-.5-.7-.6-.6-.5-.5-.5-.5-.4-.4-.4-.3-.3-.2-.2.5.1h.9l.4.1h.8l.5.1h.4l.4.3.4.4.3.3.4.3.4.4.3.3.4.4.4.3.4.4.4.3.5.3.4.2.4.2.5.2.4.2.5.1\"/></defs><clipPath id=\"L\"><use xlink:href=\"#K\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#L)\"><defs><path id=\"M\" d=\"M109.5 73.8h10V79h-10z\"/></defs><clipPath id=\"N\"><use xlink:href=\"#M\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#N)\"><image overflow=\"visible\" width=\"36\" height=\"18\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHFAAAB7gAAAk3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAJwMBIgACEQEDEQH/ xACSAAEAAwADAAAAAAAAAAAAAAAAAQIEAwUGAQADAQAAAAAAAAAAAAAAAAACAwQFEAAABQQCAwAA AAAAAAAAAAAAAQISAxETBBRBIiFCJBEAAQIEBQUAAAAAAAAAAAAAAQAR0QIykiAxYRIzgcEiYhMS AAECBAUFAAAAAAAAAAAAAAABETFhgQIhkaESojJCghND/9oADAMBAAIRAxEAAAD3lKZoW7Ixwsuz VaCeLOStgAe4XT//2gAIAQIAAQUAmnlTJszCptlbc6j1/9oACAEDAAEFAEoIytEOUVb5HP8A/9oA CAEBAAEFAJJSjG0kbSRtJDumYdDeHh4r8+UmJR28UW8UWsQUTY//2gAIAQICBj8AuttXBJEUyHkK /q8tz6Hx5FD/2gAIAQMCBj8ARSAwnVRjv4lT/9oACAEBAQY/AA4d1SVSVSVu0dS9cD+nZS/ScyZs wdcxtMFzG0wXMbTBM/jtq0bNf//Z\" transform=\"matrix(.3604 0 0 -.3604 108.657 79.895)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M119.5 78.7l-.7.3-.7.1-.7-.1-.8-.2-.8-.3-.8-.3-.8-.5-.8-.5-.7-.5-.7-.6-.6-.5-.5-.5-.5-.4-.4-.4-.3-.3-.2-.2.5.1h.9l.4.1h.8l.5.1h.4l.4.3.4.4.3.3.4.3.4.4.3.3.4.4.4.3.4.4.4.3.5.3.4.2.4.2.5.2.4.2.5.1z\"/><defs><path id=\"O\" d=\"M122 77.9l-.6.4-.5.3-.6.1h-.6l-.6-.1-.5-.2-.6-.2-.6-.4-.5-.4-.6-.4-.6-.5-.5-.5-.5-.5-.6-.5-.5-.5-.5-.4h.3l.4.1h.7l.5.1h.4l.5.1h.5l.1.3.2.4.2.3.3.3.3.3.3.3.3.3.4.2.4.2.4.2.4.2.4.2.5.1.4.1.5.1h.5\"/></defs><clipPath id=\"P\"><use xlink:href=\"#O\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#P)\"><defs><path id=\"Q\" d=\"M113.1 74.1h8.9v4.6h-8.9z\"/></defs><clipPath id=\"R\"><use xlink:href=\"#Q\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#R)\"><image overflow=\"visible\" width=\"32\" height=\"17\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG8AAAB4gAAAj7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABMAIQMBIgACEQEDEQH/ xACOAAEBAQADAAAAAAAAAAAAAAAAAwQBAgYBAQEBAQEAAAAAAAAAAAAAAAMBAgQFEAACAgAGAwAA AAAAAAAAAAABAgADEBExEiIEMhMUEQABAwIEBwAAAAAAAAAAAAARAAECEDJBgRKiMWGhscETQxIA AQQBAwUAAAAAAAAAAAAAAQAQEQIxQYEzIbEyQoL/2gAMAwEAAhEDEQAAAPc9Zz85tFMejU0jvLJM BObllw2P/9oACAECAAEFALL7Q9F1jWxtU8p//9oACAEDAAEFAAgydQFg0bSf/9oACAEBAAEFALOw Uf6mn1NKbTZh2CBduE3CdQg4X7fbxnGdbLD/2gAIAQICBj8AsBYwLEBVra0gz2Y8Odc7ocXzlv/a AAgBAwIGPwAdNETDDzXvvhv/2gAIAQEBBj8AeLMzhWsrWTlgBSWXas8vNJH14Xajw5L47l8dykNG Fh6mn//Z\" transform=\"matrix(.3604 0 0 -.3604 112.044 79.497)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M122 77.9l-.6.4-.5.3-.6.1h-.6l-.6-.1-.5-.2-.6-.2-.6-.4-.5-.4-.6-.4-.6-.5-.5-.5-.5-.5-.6-.5-.5-.5-.5-.4h.3l.4.1h.7l.5.1h.4l.5.1h.5l.1.3.2.4.2.3.3.3.3.3.3.3.3.3.4.2.4.2.4.2.4.2.4.2.5.1.4.1.5.1h.5z\"/><defs><path id=\"S\" d=\"M124.3 77.5l-.5.2-.5.1-.6.1h-1.1l-.7-.1-.6-.2-.6-.2-.6-.2-.5-.3-.5-.3-.5-.4-.4-.4-.3-.4-.3-.5-.1-.5h.7l.3.1h.4l.4.1h1.3l.2.3.2.3.3.3.2.2.2.2.3.2.2.2.3.2.3.1.3.2.3.1.4.1.3.1.4.2h.4l.4.2\"/></defs><clipPath id=\"T\"><use xlink:href=\"#S\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#T)\"><defs><path id=\"U\" d=\"M116.5 74.4h7.8v3.5h-7.8z\"/></defs><clipPath id=\"V\"><use xlink:href=\"#U\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#V)\"><image overflow=\"visible\" width=\"28\" height=\"13\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGmAAABxQAAAhH/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABEAHwMBIgACEQEDEQH/ xACFAAEBAQEBAAAAAAAAAAAAAAAAAwQCBgEAAgMAAAAAAAAAAAAAAAAAAAMBAgQQAAICAwADAAAA AAAAAAAAAAIDAAEQBBQgERMRAAIBAgUFAAAAAAAAAAAAAAERADITICFBkaFhcQISIhIAAgEDBQAA AAAAAAAAAAAAARESABBBMVFxIhP/2gAMAwEAAhEDEQAAAPdS6zZHXvg2Wi40qAP/2gAIAQIAAQUA aT6NFussf//aAAgBAwABBQABCxZQVWP/2gAIAQEAAQUAc/5TtndBb7Ttpay+TZnJswFnWr4f/9oA CAECAgY/ADCUcIUfRpZCv//aAAgBAwIGPwAMh811Wu9//9oACAEBAQY/ABk3KeZTzLq0JXaeNsNN 5qUjcSkbiWyPv1IXUvD/AP/Z\" transform=\"matrix(.3604 0 0 -.3604 115.672 78.648)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M124.3 77.5l-.5.2-.5.1-.6.1h-1.1l-.7-.1-.6-.2-.6-.2-.6-.2-.5-.3-.5-.3-.5-.4-.4-.4-.3-.4-.3-.5-.1-.5h.7l.3.1h.4l.4.1h1.3l.2.3.2.3.3.3.2.2.2.2.3.2.2.2.3.2.3.1.3.2.3.1.4.1.3.1.4.2h.4l.4.2z\"/><defs><path id=\"W\" d=\"M125.5 77.1l-.2.1-.3.1-.3.1h-.7l-.5-.1-.4-.2-.5-.1-.4-.2-.5-.2-.5-.3-.4-.3-.4-.3-.3-.3-.3-.4-.2-.4.3.1h.5l.2.1H121.5v.1l.3.3.4.3.6.4.7.3.7.4.7.3.6.2\"/></defs><clipPath id=\"X\"><use xlink:href=\"#W\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#X)\"><defs><path id=\"Y\" d=\"M119.6 74.6h5.9v2.8h-5.9z\"/></defs><clipPath id=\"Z\"><use xlink:href=\"#Y\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#Z)\"><image overflow=\"visible\" width=\"24\" height=\"11\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGWAAABsAAAAfD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA4AHAMBIgACEQEDEQH/ xAB9AAEAAwAAAAAAAAAAAAAAAAADAgQGAQEBAQAAAAAAAAAAAAAAAAACAAQQAAMBAAIDAAAAAAAA AAAAAAECAwAREhMEFBEAAQIEBwEAAAAAAAAAAAAAAQAREFECEvAhQWGh0TITEgACAwEBAAAAAAAA AAAAAAABAgARIUEi/9oADAMBAAIRAxEAAADdEp5XKwDq/9oACAECAAEFAKJcuEt4v//aAAgBAwAB BQAFOOV7f//aAAgBAQABBQC9WmfpppXd31hInr62kIB9/9oACAECAgY/ACUal5sZS3u8N8n/2gAI AQMCBj8A0QZk/9oACAEBAQY/ABa2c1ohSWaA+hIky9HnpCyomrG0P//Z\" transform=\"matrix(.3604 0 0 -.3604 118.596 78.227)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M125.5 77.1l-.2.1-.3.1-.3.1h-.7l-.5-.1-.4-.2-.5-.1-.4-.2-.5-.2-.5-.3-.4-.3-.4-.3-.3-.3-.3-.4-.2-.4.3.1h.5l.2.1H121.5v.1l.3.3.4.3.6.4.7.3.7.4.7.3.6.2z\"/><defs><path id=\"aa\" d=\"M126.3 76.3l-.1.4-.1.2-.2.1-.3.1-.4-.1-.5-.1-.4-.2-.4-.2-.5-.3-.4-.3-.5-.2-.3-.3-.3-.2-.3-.2-.1-.1v-.1l2.2.3.2.1.3.1.3.2.4.2.4.2.4.1.3.2.3.1\"/></defs><clipPath id=\"ab\"><use xlink:href=\"#aa\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ab)\"><defs><path id=\"ac\" d=\"M121.5 74.8h4.8v2.3h-4.8z\"/></defs><clipPath id=\"ad\"><use xlink:href=\"#ac\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ad)\"><image overflow=\"visible\" width=\"20\" height=\"10\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGVAAABrAAAAer/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA4AFgMBIgACEQEDEQH/ xACAAAADAQAAAAAAAAAAAAAAAAAAAgMGAQEBAQAAAAAAAAAAAAAAAAACAQQQAAEEAwEBAAAAAAAA AAAAAAABEgMTESMEIhQRAAECBAcAAAAAAAAAAAAAABEAAYECEjIhMZGh4VITEgABBAIDAAAAAAAA AAAAAAAAATFBEiGhgjOj/9oADAMBAAIRAxEAAADeTaWd3FFP/9oACAECAAEFAJE6H7j/2gAIAQMA AQUARmPJ/9oACAEBAAEFAJZaz6kLdU6RqM5zEdH/2gAIAQICBj8AWipWGI6vQ//aAAgBAwIGPwDL nLR//9oACAEBAQY/AGwJVu69BCIUtczy5gK99OEKno7RX//Z\" transform=\"matrix(.3604 0 0 -.3604 120.74 77.828)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M126.3 76.3l-.1.4-.1.2-.2.1-.3.1-.4-.1-.5-.1-.4-.2-.4-.2-.5-.3-.4-.3-.5-.2-.3-.3-.3-.2-.3-.2-.1-.1v-.1l2.2.3.2.1.3.1.3.2.4.2.4.2.4.1.3.2.3.1z\"/><defs><path id=\"ae\" d=\"M123.7 75.1h.9l.4.1h1.1l.4.1.4.1-.1.5-.2.3h-.4l-.5-.1-.6-.3-.5-.3-.5-.3-.4-.1\"/></defs><clipPath id=\"af\"><use xlink:href=\"#ae\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#af)\"><defs><path id=\"ag\" d=\"M123.7 75.1h3.2v1.1h-3.2z\"/></defs><clipPath id=\"ah\"><use xlink:href=\"#ag\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ah)\"><image overflow=\"visible\" width=\"16\" height=\"7\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGKAAABngAAAdH/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAsAEwMBIgACEQEDEQH/ xAB3AAEBAQEAAAAAAAAAAAAAAAAAAwIGAQEAAAAAAAAAAAAAAAAAAAACEAACAgIDAAAAAAAAAAAA AAACAwABETESMgQRAQAABQUAAAAAAAAAAAAAAAEAEBEhAjGBMoIzEgABBQEAAAAAAAAAAAAAAAAR EAEhUQJx/9oADAMBAAIRAxEAAADu52wFYM//2gAIAQIAAQUAsT5T/9oACAEDAAEFAKscT//aAAgB AQABBQB7xTS/athxmh7T/9oACAECAgY/AC2hmgn/2gAIAQMCBj8Alp6n/9oACAEBAQY/AByK1tBg DVtI49oPPbWX/9k=\" transform=\"matrix(.3604 0 0 -.3604 122.93 76.942)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M123.7 75.1h.9l.4.1h1.1l.4.1.4.1-.1.5-.2.3h-.4l-.5-.1-.6-.3-.5-.3-.5-.3-.4-.1z\"/><defs><path id=\"ai\" d=\"M123.8 74.8l.5.1h.4l.4.1.4.1.3.1h.4l.4.1.4.1v-.6l-.2-.4-.4-.1-.6-.1-.6.2-.5.1-.5.2-.4.1\"/></defs><clipPath id=\"aj\"><use xlink:href=\"#ai\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aj)\"><defs><path id=\"ak\" d=\"M123.8 74.2h3.2v1.2h-3.2z\"/></defs><clipPath id=\"al\"><use xlink:href=\"#ak\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#al)\"><image overflow=\"visible\" width=\"16\" height=\"7\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGHAAABmAAAAcb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAgAEwMBIgACEQEDEQH/ xAB0AAEAAwAAAAAAAAAAAAAAAAAAAwQGAQEBAAAAAAAAAAAAAAAAAAACBBAAAQQDAAAAAAAAAAAA AAAAAgABEgMREwQRAAICAwAAAAAAAAAAAAAAAAERIQIAEBMSAAEEAwAAAAAAAAAAAAAAABARITEy gUIT/9oADAMBAAIRAxEAAADeRk7sCgf/2gAIAQIAAQUAslsX/9oACAEDAAEFAGxFf//aAAgBAQAB BQC4rBED6HJf/9oACAECAgY/AG6o1aj/2gAIAQMCBj8A1zI//9oACAEBAQY/ABzDLnALVQcxr//Z\" transform=\"matrix(.3604 0 0 -.3604 122.974 76.17)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M123.8 74.8l.5.1h.4l.4.1.4.1.3.1h.4l.4.1.4.1v-.6l-.2-.4-.4-.1-.6-.1-.6.2-.5.1-.5.2-.4.1z\"/><defs><path id=\"am\" d=\"M93.9 63.1l-1.3-.5-1.2-.3-1.1-.1-1.1.1-1 .2-1 .4-.9.4-.9.6-.8.6-.9.7-.8.7-.8.8-.8.7-.8.7-.8.7-.9.6h.6l.4.1h.3l.3.1H81.3l.4.1h.3l.4.1h.6l.4.1h.3l.4.1.3-.4.3-.5.5-.6.5-.6.5-.6.6-.7.7-.6.7-.6.7-.6.7-.5.7-.4.8-.4.7-.3.7-.2h.7l.7.1\"/></defs><clipPath id=\"an\"><use xlink:href=\"#am\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#an)\"><defs><path id=\"ao\" d=\"M78.8 62.2h15v7.7h-15z\"/></defs><clipPath id=\"ap\"><use xlink:href=\"#ao\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ap)\"><image overflow=\"visible\" width=\"48\" height=\"26\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHqAAACNgAAAur/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8ANQMBIgACEQEDEQH/ xACaAAACAgMBAAAAAAAAAAAAAAAABgMFAQIEBwEAAgMAAAAAAAAAAAAAAAAAAgQBAwUQAAEFAAIC AwAAAAAAAAAAAAABAgMEBREWEAYSEzMRAAECAgcFCQEAAAAAAAAAAAECAwAEEBEhEoKSNDFRsdFy IHGRoTKy0hNzNRIAAQMDBAMAAAAAAAAAAAAAAQAQIRExAlFhoRKRsSL/2gAMAwEAAhEDEQAAAG6s 1VDfbcqOYabd0/oA/SQJw1lUe6oddalZ5q7lvvup617IBrK//9oACAECAAEFAE+PCq0VyeF5F+wV kyqf/9oACAEDAAEFAK9Vskbc6NRc2FGlO5XigXTgJNBrkP/aAAgBAQABBQDY2Yslvdap3Sqd0qnc 6pB7dWmmPdU5i4OPOeirePdPyEa5wyrI4joFGkjbJu0aNxrcPBQZkYqDczKQbn5qEVOi15//2gAI AQICBj8AkSrPCgcq3Lf/2gAIAQMCBj8AGRF6qQfKJ6mATctjjmT2Faim6+fSIBMjRv/aAAgBAQEG PwBpTjanftKgLpAqu1b++NM5mEaZzMI0zmYRpnMwhtkS6wXFJQCSLLxqolOpfBPZlv1R7hRKdS+C aLBG6LbYZNWxaT5ihkTk0mVCCooKlJTerqr9REf0mzjb+UWT7Zxo5xZOIOJHOLJpBxJ5wkpfSogg gXk7fGj/2Q==\" transform=\"matrix(.3604 0 0 -.3604 77.8 70.897)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M93.9 63.1l-1.3-.5-1.2-.3-1.1-.1-1.1.1-1 .2-1 .4-.9.4-.9.6-.8.6-.9.7-.8.7-.8.8-.8.7-.8.7-.8.7-.9.6h.6l.4.1h.3l.3.1H81.3l.4.1h.3l.4.1h.6l.4.1h.3l.4.1.3-.4.3-.5.5-.6.5-.6.5-.6.6-.7.7-.6.7-.6.7-.6.7-.5.7-.4.8-.4.7-.3.7-.2h.7l.7.1z\"/><defs><path id=\"aq\" d=\"M96 63.6l-.7-.3-.7-.1-.6-.2h-1.4l-.7.2-.6.2-.7.3-.7.4-.8.5-.7.6-.8.8-.8.8-.9.9-.8 1.1-1 1.2h.5l.5.1h.4l.4.1h.4l.5.1.4.1h.6l.5-.4.5-.4.5-.5.5-.5.5-.5.5-.5.4-.5.5-.5.5-.4.5-.5.5-.4.5-.4.6-.4.6-.3.5-.3.6-.3\"/></defs><clipPath id=\"ar\"><use xlink:href=\"#aq\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ar)\"><defs><path id=\"as\" d=\"M84.1 63H96v7.5H84.1z\"/></defs><clipPath id=\"at\"><use xlink:href=\"#as\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#at)\"><image overflow=\"visible\" width=\"40\" height=\"24\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHVAAACDgAAAqf/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABkAKgMBIgACEQEDEQH/ xACWAAADAQEBAAAAAAAAAAAAAAAABQYHAgMBAAMBAAAAAAAAAAAAAAAAAAIDBAEQAAAFBAEEAwAA AAAAAAAAAAABAgMFERIEBhYQICETIxQ1EQACAQIDCAMBAAAAAAAAAAABAgMAEdESkhBRwTKyEzME IDBzdBIAAQMDAgcAAAAAAAAAAAAAAQARMSECEhCRUdEyQpIDE//aAAwDAQACEQMRAAAAdKPaesc7 EnRHYU0Vaz7FodSHBl/WnCrY+wBOf//aAAgBAgABBQBttBoNDZCqfY3fYu8ea//aAAgBAwABBQBK Solq4en5kVo0ahVf2//aAAgBAQABBQDZZ2Qjc7l8yOXzI5fMjWp2Qks4br+r0JI0wqSY3Jh9yULD ygWHlAsTKGosPNyXf//aAAgBAgIGPwC0m0Qum1QGaEGFscVXT//aAAgBAwIGPwAUVAsG7XQoN1S3 1+R5KLMvnGRx3Zf/2gAIAQEBBj8Ajg9UqEaIOcy3OYs68K5o9Armj0CuaPQKkg9oqY1iLjKtjmDI OOyL+deuT4S/g3XHsiaONnHYUXVSRfPJurwyaThXhk0nCvDJpOFStJGyDsMLsCBfOm/6P//Z\" transform=\"matrix(.3604 0 0 -.3604 83.335 71.225)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M96 63.6l-.7-.3-.7-.1-.6-.2h-1.4l-.7.2-.6.2-.7.3-.7.4-.8.5-.7.6-.8.8-.8.8-.9.9-.8 1.1-1 1.2h.5l.5.1h.4l.4.1h.4l.5.1.4.1h.6l.5-.4.5-.4.5-.5.5-.5.5-.5.5-.5.4-.5.5-.5.5-.4.5-.5.5-.4.5-.4.6-.4.6-.3.5-.3.6-.3z\"/><defs><path id=\"au\" d=\"M98.5 64.2l-.6-.4-.6-.3h-.7l-.6.1-.7.3-.8.4-.7.5-.8.6-.7.7-.7.7-.8.7-.7.7-.6.7-.6.6-.6.5-.5.4 3.2.4.4-.5.4-.4.3-.5.4-.5.4-.4.4-.5.5-.5.4-.4.4-.4.5-.5.5-.4.5-.3.5-.4.6-.3.6-.3.7-.3\"/></defs><clipPath id=\"av\"><use xlink:href=\"#au\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#av)\"><defs><path id=\"aw\" d=\"M87.8 63.5h10.6v7.3H87.8z\"/></defs><clipPath id=\"ax\"><use xlink:href=\"#aw\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ax)\"><image overflow=\"visible\" width=\"36\" height=\"25\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHdAAACGAAAAp7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwAJwMBIgACEQEDEQH/ xACiAAABBQEBAAAAAAAAAAAAAAAAAgMEBQYBBwEAAgMBAAAAAAAAAAAAAAAAAwUBAgQGEAABBAEB BwUAAAAAAAAAAAACAAEDBAUVEBEhQRIjFhMURDUGEQAABAIIBAcAAAAAAAAAAAAAARECIRMxEjKS 0gMENLHBYqIQQWGBoUJzEgABAwIEBwAAAAAAAAAAAAACAAEhEDERUdEDYZGhEjJyov/aAAwDAQAC EQMRAAAAv2aGHLnVdyiqG9MElkODZ1YHoc9KvHQhnijYk//aAAgBAgABBQB3FOTbCY0TGuX/2gAI AQMAAQUAix8RA2NrrdxCSf05DsLn/9oACAEBAAEFALn62Ora81iXmkS80iXX28z9rsGMyXxstDIe Vjok6ioMyjpMt3asaB7kdAQ6Kh0tcOn/2gAIAQICBj8AtWHZSTddKf/aAAgBAwIGPwAXcbiz3dSP 06w4oO3aLwGcRy9lO2fMdaf/2gAIAQEBBj8AzdMemc48p5srVyJUNFsjaOvlhG0dfLCNo6+WETE+ tZPZRq/1fx8YEE6OQ1aFCa/iIigUBOnkM2cs6scy1a86BBe4QXuEF+R6IP/Z\" transform=\"matrix(.3604 0 0 -.3604 87.09 71.8)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M98.5 64.2l-.6-.4-.6-.3h-.7l-.6.1-.7.3-.8.4-.7.5-.8.6-.7.7-.7.7-.8.7-.7.7-.6.7-.6.6-.6.5-.5.4 3.2.4.4-.5.4-.4.3-.5.4-.5.4-.4.4-.5.5-.5.4-.4.4-.4.5-.5.5-.4.5-.3.5-.4.6-.3.6-.3.7-.3z\"/><defs><path id=\"ay\" d=\"M103.2 66.2l-.9-.8-.8-.6-.8-.4-.8-.2-.8-.1-.8.2-.8.2-.7.4-.8.5-.7.6-.8.7-.6.8-.8.8-.7.8-.6.8-.7.9h1.3l.4.1.3.1h.4l.4.1.6.1.6-.8.5-.7.6-.6.6-.6.6-.5.6-.4.5-.3.6-.3.6-.2.5-.2.5-.1.5-.2h.5l.5-.1h1\"/></defs><clipPath id=\"az\"><use xlink:href=\"#ay\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#az)\"><defs><path id=\"aA\" d=\"M91.1 64.1h12.1v7H91.1z\"/></defs><clipPath id=\"aB\"><use xlink:href=\"#aA\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aB)\"><image overflow=\"visible\" width=\"40\" height=\"24\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHdAAACGQAAAsD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABkAKgMBIgACEQEDEQH/ xACcAAADAQEBAAAAAAAAAAAAAAAABQYHAgMBAAMBAQAAAAAAAAAAAAAAAAIDBAEFEAAABQQBBAMA AAAAAAAAAAAAAQIEBRESAwYUICJCFTQ1FhEAAgEBBAcJAAAAAAAAAAAAAQIDABHREpIQIUFRM3M0 IDBhsULCE5MEEgAABQMCBwAAAAAAAAAAAAAAAREhAjFREgMTQYGR0UKS0v/aAAwDAQACEQMRAAAA bKfZHZQ36UdKurqSPsEhGJ9LGZmppQnoS1SAx//aAAgBAgABBQBCUWLUgVKvfaqo8f/aAAgBAwAB BQDHjuLE0SY46Oa2NdmM3Arn5/8A/9oACAEBAAEFANknZKPkf1k2C2ucBbTNjWph/IOhuX25JBEK DTfnDa2jrNKFHvh698PXvxqjJw3ddf8A/9oACAECAgY/AImcSpYNGPQKCsgccaj/2gAIAQMCBj8A Jg8SPkNvEkwVEagjiWnTykfYNHQ95fIpp7mFFPFEug//2gAIAQEBBj8AEH5ZAkZjVrCqtrJbePCu MuRbq4y5FurjLkW6pYv1OHRI8SgKF14gNg0LyU827E/K9y6A8UMki/EoxKpYW2ttArppfra6uml+ trq6aXI11SyTRsgaOwYlI9Q39x//2Q==\" transform=\"matrix(.3604 0 0 -.3604 90.243 72.068)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M103.2 66.2l-.9-.8-.8-.6-.8-.4-.8-.2-.8-.1-.8.2-.8.2-.7.4-.8.5-.7.6-.8.7-.6.8-.8.8-.7.8-.6.8-.7.9h1.3l.4.1.3.1h.4l.4.1.6.1.6-.8.5-.7.6-.6.6-.6.6-.5.6-.4.5-.3.6-.3.6-.2.5-.2.5-.1.5-.2h.5l.5-.1h1z\"/><defs><path id=\"aC\" d=\"M106.5 67l-.9-.3-.9-.3-.9-.1-.8-.1h-.9l-.8.1-.7.2-.8.3-.7.3-.7.4-.7.4-.7.6-.7.5-.6.7-.6.7-.6.7.6.1.7.1.7.1h.7l.6.1.5.1h.6l.1-.2.2-.2.3-.2.3-.3.4-.4.4-.3.5-.4.5-.4.6-.4.6-.4.7-.4.7-.3.8-.3.7-.2.8-.2\"/></defs><clipPath id=\"aD\"><use xlink:href=\"#aC\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aD)\"><defs><path id=\"aE\" d=\"M94.5 66.2h12v5.4h-12z\"/></defs><clipPath id=\"aF\"><use xlink:href=\"#aE\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aF)\"><image overflow=\"visible\" width=\"40\" height=\"19\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHdAAACGwAAAsz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAKgMBIgACEQEDEQH/ xACgAAACAwEAAAAAAAAAAAAAAAAABQMEBgIBAAIDAQAAAAAAAAAAAAAAAAEDAAIEBRAAAAYBBQAD AAAAAAAAAAAAAAECAwQFESESEwYWIhQ0EQACAQICBgkFAAAAAAAAAAABAgMAIRHTEEGRkjMEMVFx gbESIjJCcsLScwUSAAECAwcFAQAAAAAAAAAAAAACEgERMWGBMkJiE0MhobHxNET/2gAMAwEAAhED EQAAANCr7QDtvBRZW9zqMpqxkSUwK55QVW0xCZ//2gAIAQIAAQUANWAbpEOX4rxk8DTj/9oACAED AAEFAIkNlbBxoaRsjfaa3cKtw15P/9oACAEBAAEFAL+9mVkn2NmPY2Y9jZiq7NYTZ47l+5La1BEN xQbryFNEJueLtqlckoj9aCWKAJapRFRXE8P/2gAIAQICBj8AKjtUjLfM4u5xY7ZU8n//2gAIAQMC Bj8AQtSExiqFYnVCYkttLNmmp1RH1UyNbcfpvacuGx3o/9oACAEBAQY/AI4eXSNldPOS4YnHEj4s vVXCg3XzK4UG6+ZXCg3XzKh5aWOIRyEhiqsDYE63OiD9X3NVhV7VcY1C2HQT4HRGf6M7xShMEVQS CuJv7G116eakPccurcw+w5dWnfYfwpTDIzP8Qez6Ro//2Q==\" transform=\"matrix(.3604 0 0 -.3604 93.45 72.364)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M106.5 67l-.9-.3-.9-.3-.9-.1-.8-.1h-.9l-.8.1-.7.2-.8.3-.7.3-.7.4-.7.4-.7.6-.7.5-.6.7-.6.7-.6.7.6.1.7.1.7.1h.7l.6.1.5.1h.6l.1-.2.2-.2.3-.2.3-.3.4-.4.4-.3.5-.4.5-.4.6-.4.6-.4.7-.4.7-.3.8-.3.7-.2.8-.2z\"/><defs><path id=\"aG\" d=\"M110.8 67.5l-.8-.3-.8-.2-.8-.1h-.8l-.8.1-.9.2-.8.2-.8.3-.8.4-.8.4-.7.5-.8.5-.6.5-.7.5-.6.6-.5.5.3.1h.5l.5.1h.6l.5.1.5.1h.8v-.1l.1-.1.3-.2.4-.3.5-.3.6-.4.7-.4.7-.4.8-.4.7-.4.8-.4.7-.3.6-.3.6-.2.4-.2.4-.1\"/></defs><clipPath id=\"aH\"><use xlink:href=\"#aG\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aH)\"><defs><path id=\"aI\" d=\"M98.8 66.9h12V72h-12z\"/></defs><clipPath id=\"aJ\"><use xlink:href=\"#aI\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aJ)\"><image overflow=\"visible\" width=\"40\" height=\"18\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHiAAACHQAAAtH/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYALAMBIgACEQEDEQH/ xAChAAADAQEBAAAAAAAAAAAAAAAABQYBAwQBAAMBAQAAAAAAAAAAAAAAAAIDBAAFEAABAwMFAQEA AAAAAAAAAAABAAIEAwUGERITFBYQMREAAQIDAwkJAQAAAAAAAAAAAQIDABEEECESMUFh0aLSEzOT UbHBIjJysnM1BRIAAAQEAwkBAAAAAAAAAAAAAAERITFBAhIyAxMQUWGRocFiM6MU/9oADAMBAAIR AxEAAACvW8pRltjsdq77d1D3ATI0AMx6QVY2eAHN/9oACAECAAEFAAGbXEBB40P4/TQacf8A/9oA CAEDAAEFAI8VtRrLbRKfFoCZE38TuXa7d2P/2gAIAQEAAQUAu95oWlvtIC9nBXsoKg5PEmylmw1p AfACTj0VzbmsmoQKzOhj66GPqPDsAVuo21klf//aAAgBAgIGPwAjOIYGe49kuoqwx4oP/9oACAED AgY/ACqNXDkfMZeUS2VUGdTzcU26yPg00j5OH/X8uwo9qpO26cJD/9oACAEBAQY/AGlPNrc4pIGC V2GWWZHbHIe2d6OQ7s70ch3Z3obpW2nErcJAKsMrgTmOiyk9y+5NsheYp3FZifibKcVtSaUAqwEI U5iuE/Tkj9RXQXqj9RXQXqjyf0Co/UseENlip4iwThTgKZ3abP/Z\" transform=\"matrix(.3604 0 0 -.3604 97.833 73)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M110.8 67.5l-.8-.3-.8-.2-.8-.1h-.8l-.8.1-.9.2-.8.2-.8.3-.8.4-.8.4-.7.5-.8.5-.6.5-.7.5-.6.6-.5.5.3.1h.5l.5.1h.6l.5.1.5.1h.8v-.1l.1-.1.3-.2.4-.3.5-.3.6-.4.7-.4.7-.4.8-.4.7-.4.8-.4.7-.3.6-.3.6-.2.4-.2.4-.1z\"/><defs><path id=\"aK\" d=\"M114.8 68.4l-.4-.7-.6-.4-.7-.1h-.9l-.9.2-1.1.3-1.1.5-1 .4-1.1.6-1 .6-1 .5-.8.6-.8.4-.5.4-.4.2-.2.1.4.1.5.1h1l.6.1.5.1h.5l.5.1.6-.2.5-.3.6-.3.5-.3.5-.2.5-.3.5-.3.6-.3.5-.3.5-.2.5-.3.6-.2.5-.3.5-.2.6-.2.5-.2\"/></defs><clipPath id=\"aL\"><use xlink:href=\"#aK\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aL)\"><defs><path id=\"aM\" d=\"M102.3 67.2h12.5v5.3h-12.5z\"/></defs><clipPath id=\"aN\"><use xlink:href=\"#aM\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aN)\"><image overflow=\"visible\" width=\"40\" height=\"19\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHbAAACGAAAAsX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYALAMBIgACEQEDEQH/ xACZAAACAwEAAAAAAAAAAAAAAAAABQMEBgIBAAIDAQAAAAAAAAAAAAAAAAIDAAEEBRAAAQQCAwEB AAAAAAAAAAAAAgABAwQSBRETBhYUEQABAwEGAwkAAAAAAAAAAAABAAIDERAhMRKCBNGSNFFxkaGx ItITFBIAAAQDBwUAAAAAAAAAAAAAAAERAiGBEjFBMlIDM0NRocGiE//aAAwDAQACEQMRAAAA06qV AHZddLLamMtFmtLeJVSCpNMCRsXgPP8A/9oACAECAAEFACNmRTsyaV3CTjJ8UOPV/9oACAEDAAEF AKlWuVcoKTIxg/TDl1Fkn5z/AP/aAAgBAQABBQDe7uXVH9naX2dpN7C4So+juWbK9jGRyhSMlHr2 UdJmVCrjaW5ioGYV9Mhh1SCLXKEKjGv/2gAIAQICBj8AtEA52UyBrRNfA4vYP20UsyTvH//aAAgB AwIGPwBj9RpG5yrE+o2yOZjTImFQh1NjG0NT734aabblHNOkFj7KP//aAAgBAQEGPwCFscTZPtDi cxIplp2d66aPmK6aPmKu2rPEqKF+3Yxsjg0kE1FbNplFfa/1ar1gsFC6mDgfOyH9cxiIDsgDS6uF cAVduidB+Ku3BOk8FdMTpPBNySVdW4UNn//Z\" transform=\"matrix(.3604 0 0 -.3604 101.61 73.583)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M114.8 68.4l-.4-.7-.6-.4-.7-.1h-.9l-.9.2-1.1.3-1.1.5-1 .4-1.1.6-1 .6-1 .5-.8.6-.8.4-.5.4-.4.2-.2.1.4.1.5.1h1l.6.1.5.1h.5l.5.1.6-.2.5-.3.6-.3.5-.3.5-.2.5-.3.5-.3.6-.3.5-.3.5-.2.5-.3.6-.2.5-.3.5-.2.6-.2.5-.2z\"/><defs><path id=\"aO\" d=\"M120 69.7l-.7-.4-.7-.3-.7-.1h-.8l-.9.1-.8.3-.9.3-.8.4-.8.4-.8.5-.6.4-.6.4-.6.4-.4.3-.3.3-.2.1.4.1h.5l.4.1h.7l.4.1.4.1h.5l.4-.2.4-.3.4-.3.5-.3.4-.3.5-.3.4-.4.5-.2.5-.3.4-.3.5-.2.5-.2.5-.1.4-.1h1\"/></defs><clipPath id=\"aP\"><use xlink:href=\"#aO\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aP)\"><defs><path id=\"aQ\" d=\"M109.4 68.9H120v4.3h-10.6z\"/></defs><clipPath id=\"aR\"><use xlink:href=\"#aQ\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aR)\"><image overflow=\"visible\" width=\"36\" height=\"16\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGqAAABzgAAAh7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABEAJwMBIgACEQEDEQH/ xACGAAEBAQEBAAAAAAAAAAAAAAAAAwEEBgEAAwEBAAAAAAAAAAAAAAAAAAIDBAUQAAEEAgIDAAAA AAAAAAAAAAMAARIEAhQQEyAhIhEAAQMEAgMAAAAAAAAAAAAAAQARkSExQQIgA4HBMhIAAQMDBQAA AAAAAAAAAAAAAQARAiAxEkFhgTIT/9oADAMBAAIRAxEAAAD2sbx598am3S1vhYVUAAP/2gAIAQIA AQUAKUjE7iqT9PP/2gAIAQMAAQUAxjH5XqfP/9oACAEBAAEFALRzDJt2Vt2Vt2UMhMqtlnckclHJ QdYM+t4//9oACAECAgY/AJAGTAq8llr5vy1H/9oACAEDAgY/AA4C6hbZUf/aAAgBAQEGPwAa9bMz 1GXKxCxCxCPYfttj5DsgwentWMKxhWMIhsbUnl//2Q==\" transform=\"matrix(.3604 0 0 -.3604 108.384 74.2)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M120 69.7l-.7-.4-.7-.3-.7-.1h-.8l-.9.1-.8.3-.9.3-.8.4-.8.4-.8.5-.6.4-.6.4-.6.4-.4.3-.3.3-.2.1.4.1h.5l.4.1h.7l.4.1.4.1h.5l.4-.2.4-.3.4-.3.5-.3.4-.3.5-.3.4-.4.5-.2.5-.3.4-.3.5-.2.5-.2.5-.1.4-.1h1z\"/><defs><path id=\"aS\" d=\"M118.1 68.9l-.5-.3-.5-.2-.5-.2h-1.1l-.5.1-.6.2-.6.3-.7.3-.8.3-.8.4-.8.5-1 .5-1 .5-1.1.6-1.3.6h.5l.5.1h.5l.6.1.4.1h.8l.2-.2.2-.2.4-.3.4-.3.5-.3.6-.4.6-.4.7-.4.6-.3.7-.4.8-.2.7-.3.7-.1.7-.1h.7\"/></defs><clipPath id=\"aT\"><use xlink:href=\"#aS\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aT)\"><defs><path id=\"aU\" d=\"M106.3 68.2H118v4.7h-11.7z\"/></defs><clipPath id=\"aV\"><use xlink:href=\"#aU\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aV)\"><image overflow=\"visible\" width=\"40\" height=\"17\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHIAAAB9gAAAlv/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAKgMBIgACEQEDEQH/ xACVAAADAQEBAAAAAAAAAAAAAAAAAwQBAgYBAAIDAAAAAAAAAAAAAAAAAAIDAAEEEAABAwQCAwAA AAAAAAAAAAACAAMEARESEyEVMUIUEQABAgQDCQEAAAAAAAAAAAABABEQMQIyIZGhIGFxscHREoIT IxIAAgEBBQkAAAAAAAAAAAAAAAERMSGBoUJDQVHBAhIygjNE/9oADAMBAAIRAxEAAAD3C1IxaLCT Qu98Vrlz8BU0AIxwNH//2gAIAQIAAQUAcfMT+lxbi0OWz4XGn//aAAgBAwABBQAWwqOsFiOynhe3 /9oACAEBAAEFAH5Ysn2ILsQXYgmJQvEpw3fwVAVAUIbGnqR87Q1aIrRUzRnJf//aAAgBAgIGPwDm Sdie4rgdc2zA/RXNM3nzYmjXwP/aAAgBAwIGPwBNooRsF33GoZuJ/9oACAEBAQY/APA0klnwVhVh zVhzRpFJDB8Yeo2KuHWH6lqm3yVx17KfNTOqPzLlsZw//9k=\" transform=\"matrix(.3604 0 0 -.3604 105.296 73.918)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M118.1 68.9l-.5-.3-.5-.2-.5-.2h-1.1l-.5.1-.6.2-.6.3-.7.3-.8.3-.8.4-.8.5-1 .5-1 .5-1.1.6-1.3.6h.5l.5.1h.5l.6.1.4.1h.8l.2-.2.2-.2.4-.3.4-.3.5-.3.6-.4.6-.4.7-.4.6-.3.7-.4.8-.2.7-.3.7-.1.7-.1h.7z\"/><defs><path id=\"aW\" d=\"M122.3 71.2l-.5-.6-.6-.4-.5-.3-.6-.2h-.6l-.6.1-.6.1-.6.2-.7.3-.6.3-.6.4-.6.4-.7.4-.6.5-.6.4-.6.4h.4l.3.1.5.1h.4l.5.1h.5l.5.1h.5l.2-.3.2-.3.2-.4.3-.3.3-.2.3-.2.4-.2.4-.2.4-.1.4-.1.4-.1.5-.1h1.5l.5.1\"/></defs><clipPath id=\"aX\"><use xlink:href=\"#aW\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aX)\"><defs><path id=\"aY\" d=\"M112.7 69.7h9.5v3.9h-9.5z\"/></defs><clipPath id=\"aZ\"><use xlink:href=\"#aY\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#aZ)\"><image overflow=\"visible\" width=\"32\" height=\"15\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGhAAABwQAAAgD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABEAJAMBIgACEQEDEQH/ xACAAAEBAQADAAAAAAAAAAAAAAAAAwEEBQYBAQADAQAAAAAAAAAAAAAAAAACAwQFEAACAgIDAQAA AAAAAAAAAAACAwABIAQRExUSEQABAwMFAAAAAAAAAAAAAAABABGRAhIyECAhMWESAQACAgMAAAAA AAAAAAAAAAEAIBExIZEC/9oADAMBAAIRAxEAAAD28KcXFffY7XLsx0cwAAH/2gAIAQIAAQUAc1gs 724//9oACAEDAAEFAAELH5Xj/9oACAEBAAEFANrZJF+iyegyVvsu5vBZX1FKUUFRc5f/2gAIAQIC Bj8A9AuCbeq//9oACAEDAgY/ABTmaK//2gAIAQEBBj8ApApBufvxYCVgJQFg0oYOzrEwsTCHB3// 2Q==\" transform=\"matrix(.3604 0 0 -.3604 111.652 74.521)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M122.3 71.2l-.5-.6-.6-.4-.5-.3-.6-.2h-.6l-.6.1-.6.1-.6.2-.7.3-.6.3-.6.4-.6.4-.7.4-.6.5-.6.4-.6.4h.4l.3.1.5.1h.4l.5.1h.5l.5.1h.5l.2-.3.2-.3.2-.4.3-.3.3-.2.3-.2.4-.2.4-.2.4-.1.4-.1.4-.1.5-.1h1.5l.5.1z\"/><defs><path id=\"ba\" d=\"M125.8 73.1l-.1-.2-.3-.2-.3-.2-.3-.1-.4-.1h-1.5l-.5.1-.5.1-.5.2-.4.2-.5.2-.4.3-.3.3-.3.3.3.1.3.1h.3l.3.1H121.6l.3-.2.5-.2.6-.3.6-.2.8-.2.7-.1h.7\"/></defs><clipPath id=\"bb\"><use xlink:href=\"#ba\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bb)\"><defs><path id=\"bc\" d=\"M119.5 72.3h6.3v2.1h-6.3z\"/></defs><clipPath id=\"bd\"><use xlink:href=\"#bc\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bd)\"><image overflow=\"visible\" width=\"24\" height=\"10\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGbAAABtgAAAgb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAsAHAMBIgACEQEDEQH/ xACBAAEBAQAAAAAAAAAAAAAAAAAEAwYBAQEBAAAAAAAAAAAAAAAAAAEDBBAAAQUAAwEAAAAAAAAA AAAAAwABAhIEERMjFREAAQMCBQUAAAAAAAAAAAAAARECEgAyECExQdGRosJDoxIAAQQCAwAAAAAA AAAAAAAAAQARIQJR0YESIv/aAAwDAQACEQMRAAAA257Hz1uwTU//2gAIAQIAAQUAJEryZidf/9oA CAEDAAEFAIvCrvC//9oACAEBAAEFANekgH+gdZ9ZSlWynPks1O1f/9oACAECAgY/AD1sw50iDb08 GdL/2gAIAQMCBj8AD1coFowv/9oACAEBAQY/AGhgBkqqu1Wt6HmgxwaAV0B5wZKO90vGvX9KCQXO 2a92WH//2Q==\" transform=\"matrix(.3604 0 0 -.3604 118.67 75.365)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M125.8 73.1l-.1-.2-.3-.2-.3-.2-.3-.1-.4-.1h-1.5l-.5.1-.5.1-.5.2-.4.2-.5.2-.4.3-.3.3-.3.3.3.1.3.1h.3l.3.1H121.6l.3-.2.5-.2.6-.3.6-.2.8-.2.7-.1h.7z\"/><defs><path id=\"be\" d=\"M126.5 74.3v-.5l-.1-.3-.2-.3-.3-.1-.4-.1-.4.1h-.5l-.5.1-.5.2-.5.2-.4.2-.4.1-.4.2-.3.1-.1.1-.1.1 2.3.4.2-.1.4-.1.3-.1.4-.1.4-.1.4-.1h.4l.3.1\"/></defs><clipPath id=\"bf\"><use xlink:href=\"#be\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bf)\"><defs><path id=\"bg\" d=\"M121.4 73h5.1v1.7h-5.1z\"/></defs><clipPath id=\"bh\"><use xlink:href=\"#bg\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bh)\"><image overflow=\"visible\" width=\"20\" height=\"9\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGfAAABtwAAAgP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAsAFgMBIgACEQEDEQH/ xACIAAADAQEAAAAAAAAAAAAAAAAAAwQBBgEBAQAAAAAAAAAAAAAAAAAAAgMQAAEDBQEAAAAAAAAA AAAAAAEAAgMREhMEFCMRAAEDAgILAAAAAAAAAAAAABEAARIxMiECUWGh4UJigpITQ6MSAAEDAgcA AAAAAAAAAAAAAAEAAjLwESExQVESgqL/2gAMAwEAAhEDEQAAAO5Xk0KXihH/2gAIAQIAAQUAe2cu pKv/2gAIAQMAAQUABjpVi//aAAgBAQABBQCfZELu5q6Bg3bMnkhZxf/aAAgBAgIGPwA8XtDdBQUh C3fdf//aAAgBAwIGPwDEG6yMvK//2gAIAQEBBj8AbK7EsahW7dy8ww0HWFllAjima8i9f1T2x6o3 dy//2Q==\" transform=\"matrix(.3604 0 0 -.3604 120.431 75.677)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M126.5 74.3v-.5l-.1-.3-.2-.3-.3-.1-.4-.1-.4.1h-.5l-.5.1-.5.2-.5.2-.4.2-.4.1-.4.2-.3.1-.1.1-.1.1 2.3.4.2-.1.4-.1.3-.1.4-.1.4-.1.4-.1h.4l.3.1z\"/><defs><path id=\"bi\" d=\"M124.6 72.3l-.5-.3-.4-.3-.6-.3-.6-.2-.6-.1H120l-.6.1-.6.2-.5.3-.5.2-.5.4-.4.4-.4.5-.2.5h.4l.3.1h.8l.4.1h.4l.5.1.5.1.1-.3.2-.2.3-.2.2-.2.3-.2.3-.2.4-.1.3-.1.3-.1.4-.1.4-.1h1.8\"/></defs><clipPath id=\"bj\"><use xlink:href=\"#bi\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bj)\"><defs><path id=\"bk\" d=\"M116.3 71.1h8.3v3h-8.3z\"/></defs><clipPath id=\"bl\"><use xlink:href=\"#bk\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bl)\"><image overflow=\"visible\" width=\"28\" height=\"12\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGgAAABwQAAAg//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABEAHwMBIgACEQEDEQH/ xAB/AAEBAQEBAAAAAAAAAAAAAAAAAwQBBgEAAwEAAAAAAAAAAAAAAAAAAAEDBBAAAgIDAAMAAAAA AAAAAAAAAgMBBAAQFCARFREAAQQCAwEAAAAAAAAAAAAAAQARMQIhoSCBA5ESAQABBAMBAAAAAAAA AAAAAAERABAhAkFxInL/2gAMAwEAAhEDEQAAAPcz7DLa9cehrSNMgD//2gAIAQIAAQUAYx8Go3SW v//aAAgBAwABBQARX6OFxGv/2gAIAQEAAQUAdaBJfQVnerAsAarVY2s4WZwtxKCCv4f/2gAIAQIC Bj8ATUY481G4h8xf/9oACAEDAgY/ACXPdeXN/wD/2gAIAQEBBj8AFbAkkPhQdKDpW9QC1XfoOhao wA2yo2oH1X8yM2duw3H/2Q==\" transform=\"matrix(.3604 0 0 -.3604 115.348 74.984)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M124.6 72.3l-.5-.3-.4-.3-.6-.3-.6-.2-.6-.1H120l-.6.1-.6.2-.5.3-.5.2-.5.4-.4.4-.4.5-.2.5h.4l.3.1h.8l.4.1h.4l.5.1.5.1.1-.3.2-.2.3-.2.2-.2.3-.2.3-.2.4-.1.3-.1.3-.1.4-.1.4-.1h1.8z\"/><defs><path id=\"bm\" d=\"M22.2 58.6v.1l-.2.2-.2.4-.2.4-.3.6-.3.6-.3.7-.2.7-.2.7v1.4l.1.6.4.6.4.5.7.4.9.3-.1-.5-.1-.4-.1-.5v-.5l-.1-.5v-.5l.1-.6v-1.1l.1-.5.1-.5.1-.5.1-.5.1-.4.1-.5.2-.3-.2-.1H23l-.1-.1h-.2l-.1-.1h-.1l-.1-.1h-.2\"/></defs><clipPath id=\"bn\"><use xlink:href=\"#bm\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bn)\"><defs><path id=\"bo\" d=\"M20.3 58.6h3v8.2h-3z\"/></defs><clipPath id=\"bp\"><use xlink:href=\"#bo\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bp)\"><image overflow=\"visible\" width=\"16\" height=\"27\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGzAAAB2wAAAl3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AEwMBIgACEQEDEQH/ xACNAAADAAMAAAAAAAAAAAAAAAAABAYBAwUBAAMBAAAAAAAAAAAAAAAAAAIDBAUQAAEEAgMBAAAA AAAAAAAAAAQAAQIFAwYQERI1EQABAwIEAwkAAAAAAAAAAAABEQISAwQAEFETMSLDIWGisjNzgxQF EgACAQQDAQAAAAAAAAAAAAABERAhUZECMUIDE//aAAwDAQACEQMRAAAAsczrC9GoAZnRjTO4re0A MX//2gAIAQIAAQUAb17XUel//9oACAEDAAEFAJCY2CUymcVf/9oACAEBAAEFAD7WAWWts42Drb8u SNjpbu/G4/T0ri/qgzTNdrhgeP/aAAgBAgIGPwCppaG62j//2gAIAQMCBj8A+/danOygeI5QGC4/ /9oACAEBAQY/ABTcyZLZLJOJI0OmKoayG1Fe2SyXuGmVJrSgNFp8b8XpJX0uplS9hvnqYvfi6mTK tf8AQp2jxTDRTfFSA5xlzPbri4+ve07zchLbTkjJFi9/Fcv/2Q==\" transform=\"matrix(.3604 0 0 -.3604 19.336 67.686)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M22.2 58.6v.1l-.2.2-.2.4-.2.4-.3.6-.3.6-.3.7-.2.7-.2.7v1.4l.1.6.4.6.4.5.7.4.9.3-.1-.5-.1-.4-.1-.5v-.5l-.1-.5v-.5l.1-.6v-1.1l.1-.5.1-.5.1-.5.1-.5.1-.4.1-.5.2-.3-.2-.1H23l-.1-.1h-.2l-.1-.1h-.1l-.1-.1h-.2z\"/><defs><path id=\"bq\" d=\"M23.2 59l-.4 1.6-.3 1.4-.1 1.2-.1 1.1.1 1 .2.8.2.7.3.6.3.4.4.4.4.3.3.2.4.1.4.1h.6l-.2-.5-.2-.4-.1-.6-.1-.5-.1-.6-.1-.5-.1-.6-.1-.6V62.8l.1-.7.1-.6.1-.6.1-.6.2-.6-.3-.1-.4-.1-.3-.1-.3-.1-.3-.1-.3-.1-.2-.1h-.2\"/></defs><clipPath id=\"br\"><use xlink:href=\"#bq\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#br)\"><defs><path id=\"bs\" d=\"M22.3 59h3.5v9.9h-3.5z\"/></defs><clipPath id=\"bt\"><use xlink:href=\"#bs\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bt)\"><image overflow=\"visible\" width=\"16\" height=\"31\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG6AAAB5wAAAkb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAEwMBIgACEQEDEQH/ xACOAAEAAgMAAAAAAAAAAAAAAAAAAwYCBAUBAQEBAAAAAAAAAAAAAAAAAAIFAxAAAQMEAgMAAAAA AAAAAAAAAAEDBBECBQZBMxMUNREAAQIEBQUAAAAAAAAAAAAAARECABCBAyGxcrJzMUFREhMSAAEC AgsAAAAAAAAAAAAAAAEQAiCBESExQVGhEiIDE0P/2gAMAwEAAhEDEQAAALvHxdXChcRvPpUUkSsX sGPo4jfQAH//2gAIAQIAAQUAq75BG1VDg//aAAgBAwABBQC2FWOexakI4P/aAAgBAQABBQCRMsYu j5Jt942OajE3X5lz2XNu+rq/2Tb1pldWWuaJnbE7z//aAAgBAgIGPwC3bqwuQunB/9oACAEDAgY/ ADzEeZegZTX0luSST//aAAgBAQEGPwD1cFKL1gWWtQlcV8BZBi4/NpSpi0zsQ/aZDibm6LOl+0yH E3N0WdL9plQQK5S//9k=\" transform=\"matrix(.3604 0 0 -.3604 21.278 69.778)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M23.2 59l-.4 1.6-.3 1.4-.1 1.2-.1 1.1.1 1 .2.8.2.7.3.6.3.4.4.4.4.3.3.2.4.1.4.1h.6l-.2-.5-.2-.4-.1-.6-.1-.5-.1-.6-.1-.5-.1-.6-.1-.6V62.8l.1-.7.1-.6.1-.6.1-.6.2-.6-.3-.1-.4-.1-.3-.1-.3-.1-.3-.1-.3-.1-.2-.1h-.2z\"/><defs><path id=\"bu\" d=\"M25.5 59.7l-.1.6-.2.7-.1.8-.1.9v2l.1.9.1 1 .2.9.3.8.4.7.4.6.5.4.7.3h.7l.8-.2-.3-.6-.3-.5-.3-.6-.2-.5-.2-.6-.2-.6-.1-.6-.1-.6v-.6l-.1-.7v-.6l.1-.6v-.6l.2-.6.1-.7.1-.6-.2-.1-.4-.1-.3-.1-.4-.1-.3-.1-.3-.1-.3-.1-.2-.1\"/></defs><clipPath id=\"bv\"><use xlink:href=\"#bu\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bv)\"><defs><path id=\"bw\" d=\"M25 59.7h4.2v10.6H25z\"/></defs><clipPath id=\"bx\"><use xlink:href=\"#bw\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bx)\"><image overflow=\"visible\" width=\"20\" height=\"33\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHSAAACBgAAAm//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAGQMBIgACEQEDEQH/ xACUAAACAgMAAAAAAAAAAAAAAAAFBgAEAgMHAQACAwAAAAAAAAAAAAAAAAACBQEDBBAAAAUCBQUB AAAAAAAAAAAAAAECAwQSBRExQRQGIjIjMzU0EQABAgUEAwEAAAAAAAAAAAABEAIAESGxBHGRA3Mx oVJyEgABAwIGAwAAAAAAAAAAAAABABECEBIhMUFhoRNxsWP/2gAMAwEAAhEDEQAAAHcdiqZmfQd1 C/fiW1JtULWXQyA8gKyrUkICOyQY/9oACAECAAEFAHEuGvA6UtGoU9Sctf/aAAgBAwABBQCHCJ1u gtxDkk3Hq85Za//aAAgBAQABBQCZIOOhy8OJER03ow5RJ28dye6sWRRqtI5n+UWL5A5oeEU1Cw/H E3sEf0j/2gAIAQICBj8ALSkB5TPi2adW7tX/2gAIAQMCBj8AEyBiTmuvTtt5ZRjvL2r/AK3c1//a AAgBAQEGPwBrgZTMoo4bCOPlNS8TKcJ+nkeopSMUnyWV3TG7HWTF/AumN2OsmJ1i6N1Rmif/2Q==\" transform=\"matrix(.3604 0 0 -.3604 23.914 71.051)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M25.5 59.7l-.1.6-.2.7-.1.8-.1.9v2l.1.9.1 1 .2.9.3.8.4.7.4.6.5.4.7.3h.7l.8-.2-.3-.6-.3-.5-.3-.6-.2-.5-.2-.6-.2-.6-.1-.6-.1-.6v-.6l-.1-.7v-.6l.1-.6v-.6l.2-.6.1-.7.1-.6-.2-.1-.4-.1-.3-.1-.4-.1-.3-.1-.3-.1-.3-.1-.2-.1z\"/><defs><path id=\"by\" d=\"M32.8 71.6l-.7.1-.8-.1-.6-.3-.7-.4-.5-.6-.5-.6-.4-.8-.4-.8-.3-.9-.2-.9-.2-1v-2l.1-.9.1-1 .3-.9.3.1.3.1.4.1.3.1.4.2.3.1.4.1.4.1V65l.1.8.1.8v.8l.2.8.1.7.2.7.2.6.2.5.3.4.3.3.3.2\"/></defs><clipPath id=\"bz\"><use xlink:href=\"#by\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bz)\"><defs><path id=\"bA\" d=\"M27.5 60.5h5.4v11.2h-5.4z\"/></defs><clipPath id=\"bB\"><use xlink:href=\"#bA\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bB)\"><image overflow=\"visible\" width=\"20\" height=\"35\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHgAAACGgAAAsr/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAFgMBIgACEQEDEQH/ xACkAAACAwEAAAAAAAAAAAAAAAAABgMEBQEBAAMBAQAAAAAAAAAAAAAAAAECBAMFEAABAwQBAwUA AAAAAAAAAAACAQMEABETBQYSIxQiMxYmNhEAAAQDBQQLAAAAAAAAAAAAARECAwASBCExoXIFEEEi slFhkbHhMlKiI9M1EgAABAMECwAAAAAAAAAAAAAAARExIWESQYHRAlGxwSKCogMTQ6NE/9oADAMB AAIRAxEAAAB7gq4ElrSLo7yLDMs7365wfLfxgfl3wCP/2gAIAQIAAQUAcN7Jd2yAqriWgy27t//a AAgBAwABBQBiIrg+F64TwhF8gcg5unuX/9oACAEBAAEFAHXsVFsAGg2AG1u5OBX9mKVDndWn5mZC 5UH8/wA0929QF+v8h1sWcfx3WVG08FvVf//aAAgBAgIGPwAyy5kKyBB40aCdcBAgl20brXCdUnTA f//aAAgBAwIGPwAsyOKU8vb5Kh0yOeswq/TV60BItNjDik6D/9oACAEBAQY/AAsM+sotTj4Q47LY 2QCB+oS6IaAymBWBR5o1B3chTOKyilABIBSs+1OzVMzHOEUmVfenZqmZjnCGBqK1ujFAKBIOS8Rl dMtN0ftMez7oradOpNLaeFsVvhLK3Kowm+QQ4rr4/9k=\" transform=\"matrix(.3604 0 0 -.3604 26.588 72.707)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M32.8 71.6l-.7.1-.8-.1-.6-.3-.7-.4-.5-.6-.5-.6-.4-.8-.4-.8-.3-.9-.2-.9-.2-1v-2l.1-.9.1-1 .3-.9.3.1.3.1.4.1.3.1.4.2.3.1.4.1.4.1V65l.1.8.1.8v.8l.2.8.1.7.2.7.2.6.2.5.3.4.3.3.3.2z\"/><defs><path id=\"bC\" d=\"M30.8 61.4l.3.1.3.1.2.1.3.1.3.1h.3l.2.1.3.1.1.6V64l.1.8v3l.1.7.1.8.1.7.2.6.2.6.3.5.3.5.4.4-.9-.2-.6-.3-.6-.4-.5-.5-.4-.5-.3-.6-.3-.7-.1-.8-.2-.8V67l-.1-.9v-1.8l-.1-.9v-2\"/></defs><clipPath id=\"bD\"><use xlink:href=\"#bC\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bD)\"><defs><path id=\"bE\" d=\"M30.8 61.4h4.1v11.2h-4.1z\"/></defs><clipPath id=\"bF\"><use xlink:href=\"#bE\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bF)\"><image overflow=\"visible\" width=\"20\" height=\"35\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHLAAACAAAAAn3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAFgMBIgACEQEDEQH/ xACVAAEBAAMBAAAAAAAAAAAAAAAABgIDBQQBAQEBAAAAAAAAAAAAAAAAAAIEAxAAAAQFBAMAAAAA AAAAAAAAAAECAxESEwQFIhUGJiMUJREAAQMBBQUJAAAAAAAAAAAAAQARAhIxAxMEFBBRscJkocEy YnKS0mM1EgACAAYCAwAAAAAAAAAAAAAAARExoQISgnGDsSJC/9oADAMBAAIRAxEAAAC60aONPXUP K1x5szRStN9wxCPPjCFAAP/aAAgBAgABBQBZOzwUEIiUAirDUP/aAAgBAwABBQBm3nRTFq7KxME1 ZdQ//9oACAEBAAEFAH3qRHkCIVfBmnqSFXpCp8blizS2bhiPWeZHBqcR6tnrCyvUbBgh6tts/wD/ 2gAIAQICBj8AeNzSJ/NRM2gesjap/9oACAEDAgY/AFdCZ24Fq58nfkLGMDap/9oACAEBAQY/AAd6 sCxvLUyujvMu5WrF+l+xZZizmfCKtT9NyrK+qfCOx+l5VcjOZqOVEDIwMjGNTs/jIX6sPfd/JaXH GmwaNQ4ahmqexf/Z\" transform=\"matrix(.3604 0 0 -.3604 29.78 73.537)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M30.8 61.4l.3.1.3.1.2.1.3.1.3.1h.3l.2.1.3.1.1.6V64l.1.8v3l.1.7.1.8.1.7.2.6.2.6.3.5.3.5.4.4-.9-.2-.6-.3-.6-.4-.5-.5-.4-.5-.3-.6-.3-.7-.1-.8-.2-.8V67l-.1-.9v-1.8l-.1-.9v-2z\"/><defs><path id=\"bG\" d=\"M38.4 73.7l-1.1-.1-1-.2-.8-.4-.7-.4-.5-.7-.4-.7-.3-.8-.2-.9-.1-.9-.1-1v-3.8l-.1-.8v-.9l.3.1.3.1.2.1.3.1.3.1.3.1h.2l.4.1-.1.1v.2l-.1.3-.1.4v.5l-.1.6v1.4l.1.8.2.9.2.8.3 1 .5.9.6 1 .7 1 .8 1\"/></defs><clipPath id=\"bH\"><use xlink:href=\"#bG\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bH)\"><defs><path id=\"bI\" d=\"M33.1 62.1h5.4v11.6h-5.4z\"/></defs><clipPath id=\"bJ\"><use xlink:href=\"#bI\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bJ)\"><image overflow=\"visible\" width=\"20\" height=\"36\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHhAAACEwAAAq7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAFgMBIgACEQEDEQH/ xACmAAEBAAMBAAAAAAAAAAAAAAAABQEDBgQBAQEBAQAAAAAAAAAAAAAAAAMEAgUQAAAEBAUFAAAA AAAAAAAAAAABAgUDEwQUERIiFQYjNRYmRhEAAAQCBAkNAAAAAAAAAAAAAAECEhEDIXEEFBDwMTJC I4OzVEFRYYGR4eITM5PjdDUSAAEDAAgHAAAAAAAAAAAAAAEAEQIhMUGREjKihFGBEzNDgxT/2gAM AwEAAhEDEQAAAO51wZUnR7hEMMOXSlV29WwzJp8Ao3weP//aAAgBAgABBQBR1GbqBNPiUsgmdl1j /9oACAEDAAEFAITepaLUxDrTTCnqCZmGsf/aAAgBAQABBQCJUlDWdeghcpt3t0KncVvCjF2rxPkv ex8Tycz3zEx8O+tNy67CLD1X/9oACAECAgY/AJNKhy1AqVfi18UCTXSvZgQbCzBlZ3NS/9oACAED AgY/AIybNESvW6+dQiBlhEXBbvq80GZmVmfUv//aAAgBAQEGPwA0mWTliKSLt7h5+jX0tE6THNbR WhJiiJi86XztFp2e7Rgx4gWnZ7tGDHiBPnX2ySXM1c2axZQQkqUtPmH6Ng9/wi5XmR9h+o9Z+fDq rH//2Q==\" transform=\"matrix(.3604 0 0 -.3604 32.013 74.735)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M38.4 73.7l-1.1-.1-1-.2-.8-.4-.7-.4-.5-.7-.4-.7-.3-.8-.2-.9-.1-.9-.1-1v-3.8l-.1-.8v-.9l.3.1.3.1.2.1.3.1.3.1.3.1h.2l.4.1-.1.1v.2l-.1.3-.1.4v.5l-.1.6v1.4l.1.8.2.9.2.8.3 1 .5.9.6 1 .7 1 .8 1z\"/><defs><path id=\"bK\" d=\"M42.3 74.9l-.7.2-.8-.1-.8-.2-.7-.4-.7-.6-.7-.6-.7-.8-.5-.9-.5-1-.5-1-.3-1.1-.2-1.1-.2-1.2V65l.1-1.1.2-1.1 2.8.9-.1.4v1.2l.1.7.1.7.1.8.2.8.2.8.3.8.3.8.3.8.5.8.4.8.6.7.6.6.6.5\"/></defs><clipPath id=\"bL\"><use xlink:href=\"#bK\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bL)\"><defs><path id=\"bM\" d=\"M35 62.8h7.3v12.3H35z\"/></defs><clipPath id=\"bN\"><use xlink:href=\"#bM\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bN)\"><image overflow=\"visible\" width=\"28\" height=\"38\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHbAAACEwAAApT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACoAHwMBIgACEQEDEQH/ xACTAAACAwEBAAAAAAAAAAAAAAAFBwADBgIEAQEBAAMAAAAAAAAAAAAAAAAEAwACBRAAAgIBBAID AAAAAAAAAAAAAgMAAQUREhMEFAYQIDMRAAIBAgQFBQAAAAAAAAAAAAECABAxIUGxEiARMnITUYGR InMSAAICAQMEAwAAAAAAAAAAAAERAAIxIUESUWGhA4HhQv/aAAwDAQACEQMRAAAA3fPhHiUevyes tpjARoGnrWM5XtDA4kG0oqKwZ8kp/wD/2gAIAQIAAQUAY11GgmFKQRQl2EXu2P1n/9oACAEDAAEF AF9YjF6CVOv2wBGQfTbDdtdrP//aAAgBAQABBQBjhWXlBPKD4yfdFDzyw1LzFb57axg5SyK4r9Z7 femV3RRXyz24DLK8TYpTeX6//9oACAECAgY/ALCqQOmktz7KNZge8qhXHX6lWBvgz//aAAgBAwIG PwAEVzKsLk/E9ddxUT1r88vKgQGOsDXxP//aAAgBAQEGPwDaQTnLGWNNhvtB1lxFG65FAqsQPEuH u0xJidw1oPyXVqJ3DWgKqSPEuIHPNp0N8GJ9G6hkfXi//9k=\" transform=\"matrix(.3604 0 0 -.3604 34.252 75.986)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M42.3 74.9l-.7.2-.8-.1-.8-.2-.7-.4-.7-.6-.7-.6-.7-.8-.5-.9-.5-1-.5-1-.3-1.1-.2-1.1-.2-1.2V65l.1-1.1.2-1.1 2.8.9-.1.4v1.2l.1.7.1.7.1.8.2.8.2.8.3.8.3.8.3.8.5.8.4.8.6.7.6.6.6.5z\"/><defs><path id=\"bO\" d=\"M38 63.6l.4.2.6.1.6.2.6.2.6.2.6.1.5.2.5.1V66.2l.1.8v.7l.1.8.1.7.1.8.1.7.1.8.2.6.2.7.3.7.3.6.4.5.4.5.5.4-.6.1h-.6l-.6-.2-.6-.2-.6-.4-.6-.5-.6-.5-.6-.8-.5-.7-.5-1-.4-1-.4-1.1-.3-1.3-.2-1.3-.1-1.4-.1-1.6\"/></defs><clipPath id=\"bP\"><use xlink:href=\"#bO\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bP)\"><defs><path id=\"bQ\" d=\"M38 63.6h7.3v12H38z\"/></defs><clipPath id=\"bR\"><use xlink:href=\"#bQ\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bR)\"><image overflow=\"visible\" width=\"28\" height=\"37\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHeAAACEQAAAqb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAHwMBIgACEQEDEQH/ xACZAAADAQEBAAAAAAAAAAAAAAAABQcGAgMBAAMBAQAAAAAAAAAAAAAAAAIDBAEFEAAABQQCAgMA AAAAAAAAAAAAAQIDBRESBAYTMyM1FBUWEQACAAMFAg8AAAAAAAAAAAABAhARAwAhsXIEEnMxQVEy UoKS4iMzk9MUFTUSAAICAgIDAQAAAAAAAAAAAAERAAJhElEDECGBE//aAAwDAQACEQMRAAAAfLuU Y99/spjTtixSN0jez1p0uqIy5VUDFdb0AD//2gAIAQIAAQUAOtSqEtGZOItCOW128f/aAAgBAwAB BQDFxsdTEm002bOSSWs13kNPJa5cP//aAAgBAQABBQCd2DNjc39jJhG4SaljbvahrtG3e1DXaNvO ktUNH5RskX8uQ+hDcFRwf//aAAgBAgIGPwDwDzBmBJL1BusKf//aAAgBAwIGPwDrtbrqbGgJM6/z qKPZr5KV4rKYcCSg2n//2gAIAQEBBj8AGnoJSZCgebhiZknosOS3lUOy/uWVTSoSJA5r8fXgN0uL QTMMYDdLi0EzDGA3S4tBMwxgKvy9LQ8NV2K9XYe4tfKRut+joPX7tlP2OhMiDIV7+HLD/9k=\" transform=\"matrix(.3604 0 0 -.3604 37.241 76.33)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M38 63.6l.4.2.6.1.6.2.6.2.6.2.6.1.5.2.5.1V66.2l.1.8v.7l.1.8.1.7.1.8.1.7.1.8.2.6.2.7.3.7.3.6.4.5.4.5.5.4-.6.1h-.6l-.6-.2-.6-.2-.6-.4-.6-.5-.6-.5-.6-.8-.5-.7-.5-1-.4-1-.4-1.1-.3-1.3-.2-1.3-.1-1.4-.1-1.6z\"/><defs><path id=\"bS\" d=\"M49 76.1h-1.3l-1.1-.1-.9-.3-.8-.5-.6-.6-.5-.7-.4-.8-.3-.9-.2-.9-.1-1.1-.1-.9-.1-1v-1l-.1-.9-.1-.8v-.8l.4.1.3.1.3.1.3.1.4.1.3.1.4.1.4.1.1.8.1.7.1.8.1.7.1.7.1.7.1.7.2.6.2.7.2.6.3.6.3.6.4.6.4.6.6.5.5.6\"/></defs><clipPath id=\"bT\"><use xlink:href=\"#bS\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bT)\"><defs><path id=\"bU\" d=\"M42.4 64.8h6.7v11.3h-6.7z\"/></defs><clipPath id=\"bV\"><use xlink:href=\"#bU\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bV)\"><image overflow=\"visible\" width=\"24\" height=\"36\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHcAAACFwAAAq//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAHAMBIgACEQEDEQH/ xACVAAEAAwEBAAAAAAAAAAAAAAAGAAQFBwMBAAMBAQAAAAAAAAAAAAAAAAACBAEDEAAABgIBBQEA AAAAAAAAAAAAAQIDBAUSExEUNBU1BhYRAAIABAQDCQAAAAAAAAAAAAECABADBBEhsRIxcnNBUaEi MpLSBTUSAAEDAwQDAAAAAAAAAAAAAAEAEQJBEjIhMbEDUZFS/9oADAMBAAIRAxEAAABz5UsWK1Ta IL3CJxEbur0ehc76IccTKkaGynkw/9oACAECAAEFAHd2xJO6ksGojZ4Unbie3P8A/9oACAEDAAEF AGYi3ELiKJ+NMJDC5RnKTs4PZl//2gAIAQEAAQUAfdWg+pcDclSnBeTiiuOXSRWWu6yH2fdCi9uP tD4lZGKEz8wL6trpr35+hFdS07E4f//aAAgBAgIGPwCVspAUZSeUrnDGqu8oQfJC12QfKi//2gAI AQMCBj8AEhHdQ6m1nEn06hD5B5XX2NhEjlBtkHyov//aAAgBAQEGPwABe2OIhVJGZlTUnDcpPjHq i3pZnc+ErbkbWVrzjSVt021ladQaSpNeXi2rIpCqzKu4Y8fORH6tP30/lFGtQ+xStVRsUph6ZLHu yOMv/9k=\" transform=\"matrix(.3604 0 0 -.3604 41.514 77.152)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M49 76.1h-1.3l-1.1-.1-.9-.3-.8-.5-.6-.6-.5-.7-.4-.8-.3-.9-.2-.9-.1-1.1-.1-.9-.1-1v-1l-.1-.9-.1-.8v-.8l.4.1.3.1.3.1.3.1.4.1.3.1.4.1.4.1.1.8.1.7.1.8.1.7.1.7.1.7.1.7.2.6.2.7.2.6.3.6.3.6.4.6.4.6.6.5.5.6z\"/><defs><path id=\"bW\" d=\"M52.5 76.7l-1.1.1-1-.2-.9-.3-.8-.5-.7-.6-.6-.7-.4-.8-.4-.9-.4-.9-.2-1-.2-1-.2-.9-.1-1-.1-.8-.1-.8v-.7l.4.1h.3l.3.1.3.1.3.1h.3l.4.1.4.1.2 1.2.2 1 .2 1 .2.9.2.8.3.9.2.6.3.7.3.6.3.6.4.4.3.4.3.4.4.4.4.3.3.2\"/></defs><clipPath id=\"bX\"><use xlink:href=\"#bW\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bX)\"><defs><path id=\"bY\" d=\"M45.3 65.7h7.3v11.1h-7.3z\"/></defs><clipPath id=\"bZ\"><use xlink:href=\"#bY\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#bZ)\"><image overflow=\"visible\" width=\"28\" height=\"34\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHcAAACDQAAApP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAHwMBIgACEQEDEQH/ xACaAAADAQEBAAAAAAAAAAAAAAAFBgcAAwIBAAMBAQAAAAAAAAAAAAAAAAIDBAEFEAAABQMDBQEA AAAAAAAAAAAAAQIDBBEFBhIyFhMjMxQ1JhEAAgAEBAILAAAAAAAAAAAAAQIQEbESADFyEwNzIUGh 0TKSQwQUNBUSAAECBQMFAAAAAAAAAAAAAAEAAhGBEjIDMWGCEFHBEzP/2gAMAwEAAhEDEQAAAGIf wBj3mRtmNO2JKBmwbaOlOl9QyRcG7NR6c9gD/9oACAECAAEFADM6lUJaMyWjSEbXR//aAAgBAwAB BQCNDjKYuTDTRsSCSzOd6hp2uD//2gAIAQEAAQUAvWRO2yZzOSEZlJUsZd9UNeUZd9UNeUZedLrU NH3RfuP+9+PCOIax/9oACAECAgY/AOke6G6H0lohfyX/2gAIAQMCBj8AxudjBc5oJMSsfqbRVVGU EwR0aEzarwhfJC7kv//aAAgBAQEGPwAe3TgrxAUD3EkZk92PrJ5jhV+MnSQPEeuA5S1aCahWA5S1 aCahWA5S1aCahWA/R3d+xZWTlbMyx6/bhbd+6YlnnD//2Q==\" transform=\"matrix(.3604 0 0 -.3604 44.254 77.531)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M52.5 76.7l-1.1.1-1-.2-.9-.3-.8-.5-.7-.6-.6-.7-.4-.8-.4-.9-.4-.9-.2-1-.2-1-.2-.9-.1-1-.1-.8-.1-.8v-.7l.4.1h.3l.3.1.3.1.3.1h.3l.4.1.4.1.2 1.2.2 1 .2 1 .2.9.2.8.3.9.2.6.3.7.3.6.3.6.4.4.3.4.3.4.4.4.4.3.3.2z\"/><defs><path id=\"ca\" d=\"M55.8 77.1l-1.1.1-1-.1-.8-.4-.8-.4-.7-.6-.6-.7-.5-.8-.5-.9-.4-.9-.3-.9-.3-1-.2-.9-.2-.9-.2-.9-.1-.7-.1-.7h.4l.3.1.4.1.3.1.3.1h.4l.3.1.4.1v.6l.1.6.1.6.2.7.2.7.3.8.3.7.3.8.4.7.4.8.4.6.4.6.5.6.4.6.5.4.5.3\"/></defs><clipPath id=\"cb\"><use xlink:href=\"#ca\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cb)\"><defs><path id=\"cc\" d=\"M48 66.4h7.8v10.8H48z\"/></defs><clipPath id=\"cd\"><use xlink:href=\"#cc\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cd)\"><image overflow=\"visible\" width=\"28\" height=\"34\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHbAAACFwAAApz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAHwMBIgACEQEDEQH/ xACZAAACAwEBAAAAAAAAAAAAAAAABQQGBwIDAQACAwAAAAAAAAAAAAAAAAAEBQECAxAAAQMDAwUB AAAAAAAAAAAAAQACAxMEBRESFDEkRQYmFREAAQIDBQYHAAAAAAAAAAAAAAERAhITMUGRobEQITJD w4RCgqJjcxQVEgABAwMEAwAAAAAAAAAAAAABABECITFBgTKCAxJCM//aAAwDAQACEQMRAAAAvHEO CvLdSK1YNqVRG5RlN+tBzzQpE8ogaLx0FY//2gAIAQIAAQUAldNUtjITSJRjLU3o9f/aAAgBAwAB BQCO3c5s8JjFtcRtgyUzZGjo5f/aAAgBAQABBQCaZ7H8mVcmVbjTyl6ILg5QI5UKp2Htsj25SpIV ucvBe3HTK6hbgvBZL8DkfHr49dtxP//aAAgBAgIGPwCTSkA9KqXmSaZTtdVF0PppZDfyX//aAAgB AwIGPwAERuECQzrrBZxALrEcEob9F7cl/9oACAEBAQY/AGhsYuwLsCa9nyEgfwoupacRV9qb0uIk KqiUodYjiUtU7XpifFDrFt7Tpifo0q8qNO7y72ORmcjMu+rT8tOXSU//2Q==\" transform=\"matrix(.3604 0 0 -.3604 47.267 78.182)\"/></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M55.8 77.1l-1.1.1-1-.1-.8-.4-.8-.4-.7-.6-.6-.7-.5-.8-.5-.9-.4-.9-.3-.9-.3-1-.2-.9-.2-.9-.2-.9-.1-.7-.1-.7h.4l.3.1.4.1.3.1.3.1h.4l.3.1.4.1v.6l.1.6.1.6.2.7.2.7.3.8.3.7.3.8.4.7.4.8.4.6.4.6.5.6.4.6.5.4.5.3z\"/><g><defs><path id=\"ce\" d=\"M59.4 77.8l-1.1.1-1.1-.1-.9-.4-.9-.5-.8-.8-.7-.8-.6-1-.6-1-.5-1.1-.4-1-.3-1-.3-.9-.2-.8-.1-.7-.1-.5V67l.4.1.4.1.4.1.4.1.4.1.4.1.4.1h.4l.1.5.2.6.1.7.2.7.3.8.2.8.3.8.3.8.4.8.3.8.5.7.4.6.5.6.5.4.5.3.6.2\"/></defs><clipPath id=\"cf\"><use xlink:href=\"#ce\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cf)\"><defs><path id=\"cg\" d=\"M50.8 67h8.6v10.9h-8.6z\"/></defs><clipPath id=\"ch\"><use xlink:href=\"#cg\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ch)\"><image overflow=\"visible\" width=\"32\" height=\"34\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHsAAACMwAAAuf/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACcAIQMBIgACEQEDEQH/ xACaAAEBAQADAQAAAAAAAAAAAAAABgUBAwQHAQADAQEAAAAAAAAAAAAAAAACAwUBBBAAAQMEAgID AAAAAAAAAAAAAwABBBECBQYSExU1ECUWEQABAgMDCgcBAAAAAAAAAAABAgMQEQQAIRIxQZEykrLS c4OzYXGhwaITNQUSAAEDBAIDAAAAAAAAAAAAAAERMQIAECFRIgOhMkL/2gAMAwEAAhEDEQAAALPq nsxFaz9fz+sJe4GzYLL1Mor3NlGWeo3wEiT8J0OUgOawSr//2gAIAQIAAQUAdy1sclUwXdOJ7WVv dQnbxX//2gAIAQMAAQUAFjmvHLg2hEgyrbQzpDECm7aX9lF//9oACAEBAAEFAJGTFHL5sC85HUOX ZLEtgm3Cyz5Ajp5xVqZbi45bL7v4071i2Z/u+S5LTXrjFm8OCTk/z8Vfn4q1yGOHBX//2gAIAQIC Bj8AKHC4rkcWVHpTYIiJhq5Nb//aAAgBAwIGPwCE094Rk+xRmNgPu3WFbriPFGIP0LBGSuTW/9oA CAEBAQY/AFNKSSUymfMTtqHSLah0ixcQCAFYZHwAPvCobGbB6oSbZIOKVlDyh8EQqen20Rd56txu FT0+2iLvPVuNwefX/Qp2FLwTacUAtMkJF4nnlO361Jtjit+tSbY4rONN1DdUC6VfY0QpIJSgYbp3 3Q//2Q==\" transform=\"matrix(.3604 0 0 -.3604 50.008 78.908)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M59.4 77.8l-1.1.1-1.1-.1-.9-.4-.9-.5-.8-.8-.7-.8-.6-1-.6-1-.5-1.1-.4-1-.3-1-.3-.9-.2-.8-.1-.7-.1-.5V67l.4.1.4.1.4.1.4.1.4.1.4.1.4.1h.4l.1.5.2.6.1.7.2.7.3.8.2.8.3.8.3.8.4.8.3.8.5.7.4.6.5.6.5.4.5.3.6.2z\"/><g><defs><path id=\"ci\" d=\"M62 77.7l-1 .2h-1l-.8-.2-.8-.4-.6-.6-.6-.6-.6-.8-.5-.9-.4-.9-.3-1-.3-.9-.3-.9-.3-.9-.1-.8-.2-.7-.1-.5.3.1h.6l.2.1.3.1h.3l.2.1h.3l.1.7.1.6.2.7.1.7.3.7.2.6.3.7.4.6.3.6.4.7.5.5.4.5.6.6.5.4.6.5.7.4\"/></defs><clipPath id=\"cj\"><use xlink:href=\"#ci\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cj)\"><defs><path id=\"ck\" d=\"M54.1 67.8H62v10.1h-7.9z\"/></defs><clipPath id=\"cl\"><use xlink:href=\"#ck\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cl)\"><image overflow=\"visible\" width=\"28\" height=\"32\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHkAAACJQAAAtP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAHwMBIgACEQEDEQH/ xACiAAADAQEBAQAAAAAAAAAAAAAABQYEAwIHAQACAwAAAAAAAAAAAAAAAAABBAIDBRAAAQMDAwMF AAAAAAAAAAAAAwECBAAFBhExEhMUJhAVNRY2EQAAAwQFCgcAAAAAAAAAAAAAAQIRIRIEMQMTsxQQ YbEiouIzg6NEQVGBMlJjcxIAAgECBQUBAAAAAAAAAAAAAQIAEUIhMUFRgZGhIjJSA//aAAwDAQAC EQMRAAAAr+E+ro2bPf8APK+dKBWzVMM+rKLtAtv5Ac82gB//2gAIAQIAAQUAXq6s56oBVR4lYibO 2//aAAgBAwABBQANtG8U6GwAgy2tFOkIQSbO2//aAAgBAQABBQCXd2Rj/YB0uRDoU1CwcjklZeFl GWlkGWrc5y4nkvzfpbvyOTLpfOVcqtq+ISvYev4vXi9D7Ds//9oACAECAgY/ADRsK7CeTVwgO+Mr xL5dzP/aAAgBAwIGPwBHI90VszqIHXMuFzOxn5r8oo6CBRo4PYy6Xcz/2gAIAQEBBj8AVUnVxGlj 4mUkR+WccLa3RwdvdBzpJYRJWqFvwb4szCYQk3FBdpFI9wWoz1rCYf61gmeXdoyr/CY01gmeXdoy rP6JjTWBWMwmIdHa2cdBMbG+gdh0R2HRB2VlgoVNhhsYXx0arKWj/9k=\" transform=\"matrix(.3604 0 0 -.3604 53.335 78.733)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M62 77.7l-1 .2h-1l-.8-.2-.8-.4-.6-.6-.6-.6-.6-.8-.5-.9-.4-.9-.3-1-.3-.9-.3-.9-.3-.9-.1-.8-.2-.7-.1-.5.3.1h.6l.2.1.3.1h.3l.2.1h.3l.1.7.1.6.2.7.1.7.3.7.2.6.3.7.4.6.3.6.4.7.5.5.4.5.6.6.5.4.6.5.7.4z\"/><g><defs><path id=\"cm\" d=\"M65.3 78.2h-.9l-.8-.1-.8-.2-.8-.3-.7-.4-.7-.5-.7-.6-.6-.6-.5-.7-.6-.8-.4-.9-.5-.9-.3-.9-.3-1-.3-1-.1-1.1.3.1h.4l.4.1.4.1h.4l.3.1.4.1.3.1.2.6.2.6.1.6.2.6.1.6.2.6.2.6.3.6.3.6.4.6.4.6.5.5.6.6.7.5.8.6.9.6\"/></defs><clipPath id=\"cn\"><use xlink:href=\"#cm\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cn)\"><defs><path id=\"co\" d=\"M56.3 68.2h9v10h-9z\"/></defs><clipPath id=\"cp\"><use xlink:href=\"#co\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cp)\"><image overflow=\"visible\" width=\"32\" height=\"31\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHdAAACFwAAAqX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAJAMBIgACEQEDEQH/ xACXAAEBAAMBAAAAAAAAAAAAAAAABgMEBQEBAAMBAQAAAAAAAAAAAAAAAAECBQADEAABAwMCBwEA AAAAAAAAAAABAAMEEAUGEQIxEhQ0JTUWJBEAAQEGAggHAAAAAAAAAAAAAQIAEBESA3OxwiFBcYKi E0M0UZFCkiMEFBIAAgICAgMAAAAAAAAAAAAAAQIAEBFBMSIhUQP/2gAMAwEAAhEDEQAAAKvR0p5b dbuQ3cxtQ0OPnqCee173OF3DrYc4uDGFmQIzhR//2gAIAQIAAQUAJOoJoGyUWiAhX//aAAgBAwAB BQCLBjOMSYMbYyoz42sSZA3MocKf/9oACAEBAAEFALrfmLW99nEX2cVWvImbnJWZd9TEfarMu+pi PtVmR/dqtViB1uye6Pm8WvFpnoudf//aAAgBAgIGPwC8wn1W5uv/2gAIAQMCBj8AR3UlmHnsZ9HV SGVSR2NIM8COueVrc3X/2gAIAQEBBj8ARSqU1LK0zgpIGsjXsbt6nmG7ap7gx+uiiqmQkrmUQRoh 4bXULWZTzaVil1C1mU82lYpdQtZlPNpWKXD9HLmho5ksYbzdDgbocDfByp4eiWMN13//2Q==\" transform=\"matrix(.3604 0 0 -.3604 55.484 78.912)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M65.3 78.2h-.9l-.8-.1-.8-.2-.8-.3-.7-.4-.7-.5-.7-.6-.6-.6-.5-.7-.6-.8-.4-.9-.5-.9-.3-.9-.3-1-.3-1-.1-1.1.3.1h.4l.4.1.4.1h.4l.3.1.4.1.3.1.2.6.2.6.1.6.2.6.1.6.2.6.2.6.3.6.3.6.4.6.4.6.5.5.6.6.7.5.8.6.9.6z\"/><g><defs><path id=\"cq\" d=\"M69.9 78.7l-1.1.1-1.1-.1-1-.1-.9-.3-.9-.4-.9-.5-.7-.6-.7-.6-.7-.8-.5-.8-.6-.8-.4-.9-.4-1-.3-1-.2-1.1-.2-1 .3.1h.4l.3.1.4.1h.3l.4.1.4.1h.3l.2.8.1.7.3.7.2.7.4.7.4.7.4.6.5.7.5.6.6.6.6.5.6.5.7.5.8.4.7.4.8.3\"/></defs><clipPath id=\"cr\"><use xlink:href=\"#cq\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cr)\"><defs><path id=\"cs\" d=\"M59.3 68.8h10.6v10H59.3z\"/></defs><clipPath id=\"ct\"><use xlink:href=\"#cs\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ct)\"><image overflow=\"visible\" width=\"36\" height=\"31\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHrAAACIQAAArb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAJwMBIgACEQEDEQH/ xACoAAEBAAMAAwAAAAAAAAAAAAAABgECBQMEBwEAAwEBAQAAAAAAAAAAAAAAAAIFAwEEEAAABAMH BQEAAAAAAAAAAAAAAQMEEBECEhMUNAUGFiAhQSM2FREAAQICBQoHAQAAAAAAAAAAAQACEQMgkTKS EyFBsRIistIENHQxUYFy4nMUBRIAAQMCAwkBAAAAAAAAAAAAEQABAjESECBhIVGhsdEiohMzY//a AAwDAQACEQMRAAAAqeb4pxLlMmR6Pob0zwuXOUk61PVthtbZkkXsjmQAAf/aAAgBAgABBQA5zmY8 EnMEkYl3j//aAAgBAwABBQBmybKN8A0FinEtVypQN0Qte+P/2gAIAQEAAQUA1nXPy1D3mY5pWOaK hLUDU0jeeai2+V3nmotvld5U11ObtUXaou1Q3KrivT//2gAIAQICBj8AricBqMn/2gAIAQMCBj8A hOcDKTOdr718/KXVWDt91o0uUImjPzVVd+p45P/aAAgBAQEGPwCXLwhMxGl0SYQgYeRXTC+eFdKL /wAV0jb54Uf6OoARJdNw45NkEwj6LlvrdpoHtJm65ct7HaaB7WZuuXLarSdh3gI51YdUVYdUVYdU URAx/LMyZ7LqX//Z\" transform=\"matrix(.3604 0 0 -.3604 58.57 79.592)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M69.9 78.7l-1.1.1-1.1-.1-1-.1-.9-.3-.9-.4-.9-.5-.7-.6-.7-.6-.7-.8-.5-.8-.6-.8-.4-.9-.4-1-.3-1-.2-1.1-.2-1 .3.1h.4l.3.1.4.1h.3l.4.1.4.1h.3l.2.8.1.7.3.7.2.7.4.7.4.7.4.6.5.7.5.6.6.6.6.5.6.5.7.5.8.4.7.4.8.3z\"/><g><defs><path id=\"cu\" d=\"M72.5 79l-1-.1-.9-.1-.9-.2-.9-.4-.8-.4-.9-.5-.7-.5-.7-.6-.7-.7-.6-.8-.6-.8-.5-.8-.4-.9-.3-.9-.3-1-.2-1 .4.1h.2l.3.1h.5l.3.1h.4l.4.1.4.8.3.8.3.7.4.7.3.7.3.6.4.6.3.5.5.6.4.5.5.5.6.4.7.5.7.5.8.4 1 .5\"/></defs><clipPath id=\"cv\"><use xlink:href=\"#cu\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cv)\"><defs><path id=\"cw\" d=\"M62.1 69.3h10.4V79H62.1z\"/></defs><clipPath id=\"cx\"><use xlink:href=\"#cw\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cx)\"><image overflow=\"visible\" width=\"36\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHZAAACEgAAAov/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAJwMBIgACEQEDEQH/ xACTAAEAAgMBAQAAAAAAAAAAAAAAAgYDBAUBBwEAAgMBAAAAAAAAAAAAAAAAAAQBAgUDEAABBAIB BAMAAAAAAAAAAAABAAIDBBQFERAgIQZBI0QRAAAFAgUDBQAAAAAAAAAAAAABEQIDIaHREjKTNCBR gcFiwhODEgABBAIDAQAAAAAAAAAAAAABABEhAiAxEEFhof/aAAwDAQACEQMRAAAAvcNHlJt2ONV1 4YvaB3NqdesnBts4WV0t9GeuOJlBAAAf/9oACAECAAEFAJJJw8OsHo2EuQrjt//aAAgBAwABBQCK q57W615XHmtcZHA7YL56/wD/2gAIAQEAAQUAlmEZygstqN6MLnxt7orSybloUm6CfuSVz9HuRIvd fy+3V7Mt3BvrB2CwNguDjdv/2gAIAQICBj8AsKmHiFv4OHiVJGP/2gAIAQMCBj8AFhXa0mVK91Ch P7h//9oACAEBAQY/ACJFWo03Gm4qVwvkMaZorVuY1DUKKYzexbCAiOn1fJ3R+foIXQwvkaUSGbGm 4lzO7EONLtuwHGl23YDjTbbsAiVyInjq/9k=\" transform=\"matrix(.3604 0 0 -.3604 61.41 79.785)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M72.5 79l-1-.1-.9-.1-.9-.2-.9-.4-.8-.4-.9-.5-.7-.5-.7-.6-.7-.7-.6-.8-.6-.8-.5-.8-.4-.9-.3-.9-.3-1-.2-1 .4.1h.2l.3.1h.5l.3.1h.4l.4.1.4.8.3.8.3.7.4.7.3.7.3.6.4.6.3.5.5.6.4.5.5.5.6.4.7.5.7.5.8.4 1 .5z\"/><g><defs><path id=\"cy\" d=\"M77.1 79.3h-2.7l-1.2-.2-1.1-.3-1-.5-.9-.5-.8-.6-.8-.7-.7-.7-.6-.8-.6-.9-.5-.9-.5-.8-.4-.9-.4-1-.4-.8h.6l.5.1.4.1h.5l.4.1.3.1h.3l.3.8.4.8.4.7.4.8.5.6.5.7.6.6.6.6.6.5.7.6.7.5.7.4.7.5.8.4.8.3.9.4\"/></defs><clipPath id=\"cz\"><use xlink:href=\"#cy\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cz)\"><defs><path id=\"cA\" d=\"M64.5 69.7h12.6v9.7H64.5z\"/></defs><clipPath id=\"cB\"><use xlink:href=\"#cA\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cB)\"><image overflow=\"visible\" width=\"40\" height=\"31\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHsAAACJAAAAs3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEALAMBIgACEQEDEQH/ xACfAAEBAQADAQAAAAAAAAAAAAAABgcDBAUBAQACAwEAAAAAAAAAAAAAAAAAAgMEBQEQAAAGAQUA AwAAAAAAAAAAAAABAgMEBQYQESEzFSAUFhEAAgEBBAkDBQAAAAAAAAAAAQIDABFy0gQQICFRsRIT kzQwkTIxQYKSMxIAAgACCAcAAAAAAAAAAAAAAQIAERAgITFREjIDgZGhsRMzBP/aAAwDAQACEQMR AAAAp/I5ZlN2g+eALNBY5jp3aspM1c9InVdk0vDp2c6MVQjywAA//9oACAECAAEFAD335HOxI3BN g0c6/wD/2gAIAQMAAQUAhRI64/0oodjRylRJCUMHLSHJCTf1/9oACAEBAAEFAL66eq1HmM0HmVgP 2VkEZhZqWM07dWu0Zp26tdoy6LKkOeXZjy7QeXaBussyc+f/2gAIAQICBj8AvNBidAGNT//aAAgB AwIGPwBHdAzGczxMepY+dRtqFfyZhjIWQikiyfeNQ5xstPRn6ip//9oACAEBAQY/AIViVG6oYnnB Pxs3Eb62RRfq2OtkMPs2Ov5Qez46VTFBYSB8X+/56Mpdfiuol4cdGUuvxXUS8OOjKnLwyTBVfm6a M1lpX68oNeHP2nw14c/afDXhz9p8NITk5wAwtPSffd9D/9k=\" transform=\"matrix(.3604 0 0 -.3604 63.587 80.316)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M77.1 79.3h-2.7l-1.2-.2-1.1-.3-1-.5-.9-.5-.8-.6-.8-.7-.7-.7-.6-.8-.6-.9-.5-.9-.5-.8-.4-.9-.4-1-.4-.8h.6l.5.1.4.1h.5l.4.1.3.1h.3l.3.8.4.8.4.7.4.8.5.6.5.7.6.6.6.6.6.5.7.6.7.5.7.4.7.5.8.4.8.3.9.4z\"/><g><defs><path id=\"cC\" d=\"M79.8 79.7h-.7l-.8-.2-.9-.2-.9-.3-.9-.4-.9-.4-.9-.6-.9-.6-.8-.6-.9-.8-.7-.8-.8-.8-.7-.9-.6-1-.5-1-.4-1h.4l.5.1h.4l.5.1h.4l.3.1h.3l.2.1.5.4.5.4.5.6.6.5.5.6.6.6.6.6.6.6.5.7.6.6.6.6.7.7.6.6.6.6.7.6.6.5\"/></defs><clipPath id=\"cD\"><use xlink:href=\"#cC\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cD)\"><defs><path id=\"cE\" d=\"M67.5 70.1h12.3v9.6H67.5z\"/></defs><clipPath id=\"cF\"><use xlink:href=\"#cE\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cF)\"><image overflow=\"visible\" width=\"40\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHqAAACLgAAAsr/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAKgMBIgACEQEDEQH/ xACdAAEBAAMBAQAAAAAAAAAAAAAABgIDBAUHAQADAQEBAAAAAAAAAAAAAAAAAgQDAQUQAAEEAQME AwAAAAAAAAAAAAMAAQIFBBATFRESFAYgIzQRAAEDAgQEBwAAAAAAAAAAAAEAAgMRBBAhkTQxsdEy IDBBoRJycxIAAQMBBgYDAAAAAAAAAAAAAQARAiEgMWGRoRJBgbEiMgMTM2P/2gAMAwEAAhEDEQAA ALrXw+NHZTYyejlNn2w1zqsjOVfhV68LtO2X0KHuCYMfOAAD/9oACAECAAEFACSNuN5C6F7IiaSY MFtw7tf/2gAIAQMAAQUADiTJCNZJ1x/342bEYJWC8uW/r//aAAgBAQABBQAxnG/lST5nRPYRZCsY EKrvObFIS6ip3KnbEdU+cYtqvc/060Tty69qr87LyODuVwVyuBuFT09oC0+f/9oACAECAgY/AJCJ IHBeR0Xl3br8E7gPiqyGaZw21+dj/9oACAEDAgY/ABIRvVQh6vy36soQesQeqo2a+Rx9e2/F7H// 2gAIAQEBBj8AAArVdoWYGqzomxgCrjTCNpNPk0n3XcsiSsgVbMPAvFdMLb6O5+C1/QcsIHWsLpWt YQ4t9DVbSTQLaSaDqtpJoOqtpZbZ7I2Pq5x4AU8j/9k=\" transform=\"matrix(.3604 0 0 -.3604 66.51 80.516)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M79.8 79.7h-.7l-.8-.2-.9-.2-.9-.3-.9-.4-.9-.4-.9-.6-.9-.6-.8-.6-.9-.8-.7-.8-.8-.8-.7-.9-.6-1-.5-1-.4-1h.4l.5.1h.4l.5.1h.4l.3.1h.3l.2.1.5.4.5.4.5.6.6.5.5.6.6.6.6.6.6.6.5.7.6.6.6.6.7.7.6.6.6.6.7.6.6.5z\"/><g><defs><path id=\"cG\" d=\"M84 79.7l-.7.5-.8.2h-.8l-.8-.2-.8-.4-.8-.6-.8-.7-.9-.7-.8-.9-.9-1-.8-.9-.9-1-.9-1-1-.9-.9-.9-.9-.7h1.1l.5.1.4.1.5.1.4.1h.4l.7.7.7.6.7.7.7.7.7.7.6.7.7.7.6.6.7.6.6.6.6.5.6.5.6.4.6.3.6.3.5.2\"/></defs><clipPath id=\"cH\"><use xlink:href=\"#cG\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cH)\"><defs><path id=\"cI\" d=\"M70.5 70.5H84v9.9H70.5z\"/></defs><clipPath id=\"cJ\"><use xlink:href=\"#cI\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cJ)\"><image overflow=\"visible\" width=\"44\" height=\"31\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHmAAACJwAAAs//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEALwMBIgACEQEDEQH/ xACXAAADAQEBAAAAAAAAAAAAAAAABQYEAgEBAAIDAQAAAAAAAAAAAAAAAAACAQMEBRAAAAYBBAID AAAAAAAAAAAAAAECAwQFBhAgERU0NiEUFhEAAQMBBwMFAAAAAAAAAAAAAQACAxIRIZGScwQ0ILHC MUGBMhMSAQACAQIFBQAAAAAAAAAAAAEAAhEgMRAhQZEDUSIyEzP/2gAMAwEAAhEDEQAAAKJV3PJ3 3nKUjQ5oYWwbDgnqpJYYDf5NmGwnacxvAE5wAAAH/9oACAECAAEFADI+fkFyCRyCbIKQRFr/AP/a AAgBAwABBQCHFYVH+pFFkyyhiNJQlg5iBNkJcb1//9oACAEBAAEFAL+6kV0g8ssAeW2YPLLUfrLc QbKS/QZl52yr9TzLztlX6nlNdOlzOiuB0VwOiuB0VwK6HKaxrd//2gAIAQICBj8A3Zu8M5m5M5NH /9oACAEDAgY/APHa1K2snNSflTtB8dK0fsDNTphlKtgQ9Z8jvCoj7h0f/9oACAEBAQY/AI4oS0B7 KjaLb7SFcW5VdRlVxZlX2jyKTfyEfu2OVwIFgtZVTd8KDS8ndM2luOz1BpeTumbS3HZ6hftoXStb HYS32NRK4kmAXEkwC4kmAXEkwCl2skZbuHRzgRn1JdVTj1//2Q==\" transform=\"matrix(.3604 0 0 -.3604 69.468 81.153)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M84 79.7l-.7.5-.8.2h-.8l-.8-.2-.8-.4-.8-.6-.8-.7-.9-.7-.8-.9-.9-1-.8-.9-.9-1-.9-1-1-.9-.9-.9-.9-.7h1.1l.5.1.4.1.5.1.4.1h.4l.7.7.7.6.7.7.7.7.7.7.6.7.7.7.6.6.7.6.6.6.6.5.6.5.6.4.6.3.6.3.5.2z\"/><g><defs><path id=\"cK\" d=\"M87.3 80h-1.2l-1.1-.1-1-.3-1-.3-.9-.5-.8-.6-.8-.6-.8-.7-.7-.7-.8-.8-.6-.8-.8-.8-.7-.8-.7-.8-.8-.7-.8-.7.3.1h.8l.4.1h.4l.4.1h.4l.5.1.5.2.5.3.5.5.5.5.6.6.5.6.6.7.7.7.6.8.8.7.8.7.8.7.9.7.9.6 1.1.5\"/></defs><clipPath id=\"cL\"><use xlink:href=\"#cK\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cL)\"><defs><path id=\"cM\" d=\"M73.8 70.8h13.5V80H73.8z\"/></defs><clipPath id=\"cN\"><use xlink:href=\"#cM\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cN)\"><image overflow=\"visible\" width=\"44\" height=\"29\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHoAAACOgAAAur/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEALwMBIgACEQEDEQH/ xACXAAEBAAMBAQAAAAAAAAAAAAAABgIEBQMHAQADAQEAAAAAAAAAAAAAAAAAAwQBAhAAAQUAAAUF AAAAAAAAAAAAAgABAwQFEBESBhYgExQ0JhEAAQMBBgQHAAAAAAAAAAAAAQARAgMhoRKS0gQgMTI0 QXFSYsJzsxIBAAEDBAIDAAAAAAAAAAAAAQARIQIgcZESQSKhsTL/2gAMAwEAAhEDEQAAALzy1Jya yswjvHKrPY+f0zV5x9tM0dc9vmM59XxKPJO+ExAAB//aAAgBAgABBQCUputvkKP3OYxsTNDGpABh 4//aAAgBAwABBQCvTKUBy3VuiMMNS40UJaDurNkpA4//2gAIAQEAAQUAlkaNnuCye/EyLUhZFtQM obwTVd621Wse0yPXN0WlOSK5OSxpDLtnvL6PDmy6mWK/5builbu0/HtteO7a8d2l45tLKz7kHb3q /9oACAECAgY/AEwaY7T9fBPbKptKuQbsvkcz1Rd9H//aAAgBAwIGPwAyC1Zf7ncb9ghh5Flk5nVR vXR//9oACAEBAQY/AASHexWi9Wi9cr103qe5AaNPE4f0h1TmS2KbXFWElWAqyxdTLezJeQjXY+VN UPt+MuHen21/zVKntaZqzjUxSAIDDCR4kLtZZo6l2ss0dS7WWaOpdrLNHUt3tKtIx3FQVhCDhzih hjyLc+P/2Q==\" transform=\"matrix(.3604 0 0 -.3604 72.968 80.806)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M87.3 80h-1.2l-1.1-.1-1-.3-1-.3-.9-.5-.8-.6-.8-.6-.8-.7-.7-.7-.8-.8-.6-.8-.8-.8-.7-.8-.7-.8-.8-.7-.8-.7.3.1h.8l.4.1h.4l.4.1h.4l.5.1.5.2.5.3.5.5.5.5.6.6.5.6.6.7.7.7.6.8.8.7.8.7.8.7.9.7.9.6 1.1.5z\"/><g><defs><path id=\"cO\" d=\"M23.3 56.4v-.5l-.1-.4V52.5l.1-.8.2-.8.2-.7.3-.7.4-.5.5-.4.6-.3h.8l.9.2-.3.3-.2.4-.3.4-.2.5-.3.5-.2.5-.2.6-.2.6-.1.6-.2.6-.1.6-.2.5-.1.6-.1.6-.1.5-.1.4h-.2l-.2-.1h-.1l-.1-.1h-.1l-.1-.1h-.2\"/></defs><clipPath id=\"cP\"><use xlink:href=\"#cO\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cP)\"><defs><path id=\"cQ\" d=\"M23.2 48.3h4.1v8.4h-4.1z\"/></defs><clipPath id=\"cR\"><use xlink:href=\"#cQ\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cR)\"><image overflow=\"visible\" width=\"16\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGvAAAB1wAAAkX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AEQMBIgACEQEDEQH/ xACKAAEAAwEBAAAAAAAAAAAAAAAABAUGAwcBAAMBAAAAAAAAAAAAAAAAAAIDBAUQAAAFBAMBAAAA AAAAAAAAAAABAgUGEQMEJRITFBURAAAEBQQDAQAAAAAAAAAAAAECEgMAEBETBGGxcxQhgTJyEgAC AQMFAAAAAAAAAAAAAAAQEQFBAhIhMVFhE//aAAwDAQACEQMRAAAA0PKni0v9GEyMNFuY5amyA5f/ 2gAIAQIAAQUAJFvrHM6D/9oACAEDAAEFACtVSELsFjj/2gAIAQEAAQUAeJR8vNb5f7c0S8qvLAnc iWFuGEtuJC1+pxaWjocR/9oACAECAgY/AHMa481CH//aAAgBAwIGPwBqjCm+3Lz27Q//2gAIAQEB Bj8AHF6t6hSmXcT9aINDOL1Ld4yV3FU9ICRuMm0YnIGwyNxk2jE5A2kZ3uYrFSFBDzqD+NKDGO73 sRxB6obdUc35BMv/2Q==\" transform=\"matrix(.3604 0 0 -.3604 22.2 57.713)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M23.3 56.4v-.5l-.1-.4V52.5l.1-.8.2-.8.2-.7.3-.7.4-.5.5-.4.6-.3h.8l.9.2-.3.3-.2.4-.3.4-.2.5-.3.5-.2.5-.2.6-.2.6-.1.6-.2.6-.1.6-.2.5-.1.6-.1.6-.1.5-.1.4h-.2l-.2-.1h-.1l-.1-.1h-.1l-.1-.1h-.2z\"/><g><defs><path id=\"cS\" d=\"M24.3 56.8l.4-1.9.4-1.5.4-1.4.4-1.1.4-.9.4-.7.4-.6.4-.3.4-.3.3-.1h.7l.4.1.2.2.3.2.2.1-.4.4-.4.4-.3.4-.4.5-.3.5-.3.4-.3.5-.3.6-.2.5-.3.6-.2.6-.2.6-.2.6-.1.6-.2.7-.1.7-.4-.1h-.3L25 57h-.1l-.2-.1h-.2l-.2-.1\"/></defs><clipPath id=\"cT\"><use xlink:href=\"#cS\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cT)\"><defs><path id=\"cU\" d=\"M24.3 48H30v9.2h-5.7z\"/></defs><clipPath id=\"cV\"><use xlink:href=\"#cU\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cV)\"><image overflow=\"visible\" width=\"20\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHHAAAB9wAAApH/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AFgMBIgACEQEDEQH/ xACbAAADAQEAAAAAAAAAAAAAAAAABQYEAwEAAwEAAAAAAAAAAAAAAAAAAQIEAxAAAAUEAQUBAAAA AAAAAAAAAREDBAUAAhIGEyIjFRYmNhEAAQIDBQQLAAAAAAAAAAAAAgEDABEEITEScgUQQbGyUXHR IpITIzOTFDQSAAICAAMJAQAAAAAAAAAAAAERAAIyQhMQITFhkaESogMU/9oADAMBAAIRAxEAAAB8 hZTFVNOYBWYzNghws6m0B//aAAgBAgABBQBPDA7DyEjGv//aAAgBAwABBQBJHK3g6miiAI8qHJ// 2gAIAQEAAQUA2mXfxqntk3TSflFYbeANULaYB89uod0qYfn9pYi7U8LdTSMGyG//2gAIAQICBj8A DAJmEY+yi2f/2gAIAQMCBj8ABUSz+Pq5QX+lK23sE849Sq/Q+OXTT6z/2gAIAQEBBj8ApxpDQEcQ 1OYoVyjK/rj3h8A9kV9WbiK9Tq0jRYRsxnhKyXRFHlc4js1XMxzpFJlPiOzVMzHOkUyo+wzgQ7Hn EbnNRunfH7aP5xjUGftUxearXqC6igOE598t090f/9k=\" transform=\"matrix(.3604 0 0 -.3604 23.6 58.103)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M24.3 56.8l.4-1.9.4-1.5.4-1.4.4-1.1.4-.9.4-.7.4-.6.4-.3.4-.3.3-.1h.7l.4.1.2.2.3.2.2.1-.4.4-.4.4-.3.4-.4.5-.3.5-.3.4-.3.5-.3.6-.2.5-.3.6-.2.6-.2.6-.2.6-.1.6-.2.7-.1.7-.4-.1h-.3L25 57h-.1l-.2-.1h-.2l-.2-.1z\"/><g><defs><path id=\"cW\" d=\"M25.8 57.3l.1-.6.1-.8.2-.9.3-.9.4-1 .4-.9.5-.9.5-.8.6-.7.5-.7.6-.5.7-.3.6-.1.7.1.6.4.7.6-.5.4-.5.5-.5.4-.4.4-.4.5-.4.5-.4.5-.3.5-.3.6-.3.6-.2.6-.2.6-.2.7-.2.7-.1.7-.1.7H28l-.4-.2-.4-.1-.3-.1-.4-.2-.3-.1-.2-.1-.2-.1\"/></defs><clipPath id=\"cX\"><use xlink:href=\"#cW\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cX)\"><defs><path id=\"cY\" d=\"M25.8 48.2h7.5v10h-7.5z\"/></defs><clipPath id=\"cZ\"><use xlink:href=\"#cY\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#cZ)\"><image overflow=\"visible\" width=\"28\" height=\"32\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHLAAACBgAAApX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAHwMBIgACEQEDEQH/ xACVAAEBAQEAAAAAAAAAAAAAAAAGAAUDAQACAwEAAAAAAAAAAAAAAAAAAgEDBQQQAAECBgEFAQAA AAAAAAAAAAMCBQABERIEBhAgIxQWJjYRAAECBAMFCQAAAAAAAAAAAAECAwARsQQhEpIQ0TJyMyBB UYETY3MUBRIBAAIBAwUAAAAAAAAAAAAAAQARIRCxAiBBEiIz/9oADAMBAAIRAxEAAABGf1CPVftJ ATNZ5k15enQ4sCq1TfqMeqD/2gAIAQIAAQUAElFhrLZLpK6vP//aAAgBAwABBQAY7klFajCGmYXF CUg4/9oACAEBAAEFANndsxsH7e8x7e8xgOeUfXt4l2rYkmGqXyO7SqKkUhr/ACW4iIQfi5UeLlQ2 DInVej//2gAIAQICBj8AHkC5nqBmV0f/2gAIAQMCBj8AMXPKqzU4qnfeCJ9DZ1//2gAIAQEBBj8A t1WpSC6VBWYZuECVY4m9Ajib0CHf0HCn7CG3lAgSE282XDyiz5nKJ2vj2bii4tOZdE7XviuKLi19 NClyUueUE9yfCOivSd0dFzSd0PNqSQstPySQZ4hUsOz/AP/Z\" transform=\"matrix(.3604 0 0 -.3604 24.82 59.16)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M25.8 57.3l.1-.6.1-.8.2-.9.3-.9.4-1 .4-.9.5-.9.5-.8.6-.7.5-.7.6-.5.7-.3.6-.1.7.1.6.4.7.6-.5.4-.5.5-.5.4-.4.4-.4.5-.4.5-.4.5-.3.5-.3.6-.3.6-.2.6-.2.6-.2.7-.2.7-.1.7-.1.7H28l-.4-.2-.4-.1-.3-.1-.4-.2-.3-.1-.2-.1-.2-.1z\"/><g><defs><path id=\"da\" d=\"M37 49.8l-.7-.5-.7-.2-.7-.1-.7.1-.7.2-.7.4-.7.5-.6.6-.6.7-.6.8-.4.9-.5.9-.3 1-.3 1-.3 1.1-.1 1 .4.1.3.1.4.1.3.1.4.2.4.1.3.1h.4l.2-.6.3-.7.2-.8.3-.7.3-.7.3-.8.3-.7.3-.7.4-.6.4-.6.4-.6.4-.5.4-.4.5-.4.5-.3.5-.1\"/></defs><clipPath id=\"db\"><use xlink:href=\"#da\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#db)\"><defs><path id=\"dc\" d=\"M28.4 49H37v10h-8.6z\"/></defs><clipPath id=\"dd\"><use xlink:href=\"#dc\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dd)\"><image overflow=\"visible\" width=\"32\" height=\"32\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHsAAACKwAAAsT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAJAMBIgACEQEDEQH/ xACfAAEBAQEBAQAAAAAAAAAAAAAGAAQFAQIBAAIDAQAAAAAAAAAAAAAAAAIDAQQFABAAAAUDAgcB AAAAAAAAAAAAAAECAwQRBQYSFhBBMhMkNBUmEQAABAQEBgMAAAAAAAAAAAABEQIDABCxBEESE3NR oSKSsjRDFBUSAAECAgcJAAAAAAAAAAAAAAEAEBECIVFhgTKDNDFBcbHB0RJCA//aAAwDAQACEQMR AAAAVc7IasuYdEAlFjCpFUgbSnC2vEhxILVtXYHOw1F3631Ebqip/wD/2gAIAQIAAQUAQ22aHEtk Q7lCNdTBjmP/2gAIAQMAAQUAQ1qJcfSgQ2dTMxokxgz0PdA//9oACAEBAAEFALxf2bS7viKN8RRZ 7+zdnBm5eUSQSRhRUlDNSrKoKDDPaGZ+1ww1Kiki5/F7n5EJ2mIHy9Q//9oACAECAgY/AAZtptR8 RTxaCg25evVv/9oACAEDAgY/AAYIzVNJNX3X0Ng5tLq8vDcjqs3De3//2gAIAQEBBj8AbbcaU4Li RUApEAIhLGPVc7kx6rncmHG22VNC2kFCKhATMSwla7avKdztprK221Vnc7aaytttVZ3AiBAKE1kj 9LTzkOnqGZHgUfBzjp0OcK+hkzF15OEv/9k=\" transform=\"matrix(.3604 0 0 -.3604 27.553 59.937)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M37 49.8l-.7-.5-.7-.2-.7-.1-.7.1-.7.2-.7.4-.7.5-.6.6-.6.7-.6.8-.4.9-.5.9-.3 1-.3 1-.3 1.1-.1 1 .4.1.3.1.4.1.3.1.4.2.4.1.3.1h.4l.2-.6.3-.7.2-.8.3-.7.3-.7.3-.8.3-.7.3-.7.4-.6.4-.6.4-.6.4-.5.4-.4.5-.4.5-.3.5-.1z\"/><g><defs><path id=\"de\" d=\"M40.2 50.7l-1.1-.5-1-.3h-.9l-.8.1-.6.4-.7.4-.5.6-.5.8-.4.8-.4.9-.4.9-.3.9-.3 1-.4.9-.3.9-.4.8.3.1h.3l.3.1.3.1.3.1.3.1.3.1.3.1v-.1l.1-.3v-.4l.1-.5.2-.6.2-.7.2-.7.3-.8.4-.8.4-.8.6-.8.6-.7.7-.7.8-.5.9-.6 1.1-.3\"/></defs><clipPath id=\"df\"><use xlink:href=\"#de\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#df)\"><defs><path id=\"dg\" d=\"M31.2 49.9h8.9V60h-8.9z\"/></defs><clipPath id=\"dh\"><use xlink:href=\"#dg\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dh)\"><image overflow=\"visible\" width=\"32\" height=\"32\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHlAAACIQAAArj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAIQMBIgACEQEDEQH/ xACeAAEBAQEBAAAAAAAAAAAAAAAABgUEAgEAAwADAAAAAAAAAAAAAAAAAQIEAAMFEAAABQMBCQAA AAAAAAAAAAAAARECAwQFBhIQIDITNBU1FiYRAAECAwUGBwEAAAAAAAAAAAIBEQAQsRIDE3MEYaLS kzREMUFRIjJyFBUSAAECBAUFAAAAAAAAAAAAAAEAEBExUQIhQYEyNHGxQgOD/9oADAMBAAIRAxEA AACj4szFr3VulA0yNYCeeFxdzGfteaWco1euA4Wbzgsdhg7gZP/aAAgBAgABBQBkUZtkZGTRzEI3 ru//2gAIAQMAAQUAbGRk+BGCmgWKrh00wj4ZeAf/2gAIAQEAAQUAu2Tx2ys95iHvMQsuQMu8oy/z KAmjCSSqGWkt4QIML6oZZ5fZhnVCu7Fz/lR8qKDtOof/2gAIAQICBj8ABImKowGPVgKKD5N//9oA CAEDAgY/ABgjdCTWGE7QvYaAd2HKl4bdEeV9Nurf/9oACAEBAQY/AF0padb1UFCtISD8tjLHRlzE 4Y6MuYnDF7djcLdYQoTqVp3VvRJFlhSepyxrIssKT1OWNZFlhSep+g1kv7sDHZHxLNpvLxjtN2O0 3YL+fg2m9+EzttaX/9k=\" transform=\"matrix(.3604 0 0 -.3604 30.183 60.775)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M40.2 50.7l-1.1-.5-1-.3h-.9l-.8.1-.6.4-.7.4-.5.6-.5.8-.4.8-.4.9-.4.9-.3.9-.3 1-.4.9-.3.9-.4.8.3.1h.3l.3.1.3.1.3.1.3.1.3.1.3.1v-.1l.1-.3v-.4l.1-.5.2-.6.2-.7.2-.7.3-.8.4-.8.4-.8.6-.8.6-.7.7-.7.8-.5.9-.6 1.1-.3z\"/><g><defs><path id=\"di\" d=\"M44.2 51.3l-.6-.5-.8-.3-.8-.2-.8.1-.8.1-.9.4-.8.5-.9.5-.8.8-.7.8-.7.9-.6 1-.5 1.1-.4 1.1-.3 1.2-.1 1.2 3 .8.1-.5.3-.5.2-.6.3-.7.3-.7.4-.7.4-.7.4-.8.5-.7.5-.7.6-.6.6-.6.7-.6.7-.4.7-.4.8-.3\"/></defs><clipPath id=\"dj\"><use xlink:href=\"#di\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dj)\"><defs><path id=\"dk\" d=\"M33.7 50.3h10.5v10.5H33.7z\"/></defs><clipPath id=\"dl\"><use xlink:href=\"#dk\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dl)\"><image overflow=\"visible\" width=\"36\" height=\"33\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAIAAAACRgAAAv7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAJwMBIgACEQEDEQH/ xACuAAACAwEBAAAAAAAAAAAAAAAABgEDBQQHAQADAQEAAAAAAAAAAAAAAAAAAgMFBBAAAAQEBAYD AAAAAAAAAAAAAAECAxESBAUTMwYWECEiFBUmQkM2EQAABAIFCAsAAAAAAAAAAAAAAQIDERIhMXIT BCCxItKTo7M0EEFRYaEyokMUBRUSAAEBBAYLAQAAAAAAAAAAAAABESExAkFhMoITQ1FxgaGx8RJC YjM0RP/aAAwDAQACEQMRAAAAasupX6bNsqcl/QTLIQpWWdaNOCbE72csDF6coC1nSEm0wHz/AP/a AAgBAgABBQBtts0KS0Q5TYkCU4JukwofD//aAAgBAwABBQBDUxJpIjCLHomZmSaSQ5eQpspY+7// 2gAIAQEAAQUAvd+RaFb5aG+WhvhoUV6TV2vXGaSQSQRCyF6trYouwEOFl/L60zeCGHFi0MqRpu++ En9NDe0AjbQpuw7H/9oACAECAgY/AEWZH6yG8qaMIjSgy9p2wun/2gAIAQMCBj8ARWD0MPy6SSbS 3iPcVYpL9tPqsRoP3XjMtX+Z/9oACAEBAQY/AGUqZN6+JR0KlhLDuPtHJq2hao5NW0LVHJq2haof +xJo0EwSzNuaJndpmrh1jB2XM6cjHWX+GMJZXnTkY2y/wxhLK86emgoDGNnWpL3i2Gf1JpoKupZq qI+Qe5vRoTbwaM3rDtzH4sFXldUNKumof//Z\" transform=\"matrix(.3604 0 0 -.3604 32.969 61.83)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M44.2 51.3l-.6-.5-.8-.3-.8-.2-.8.1-.8.1-.9.4-.8.5-.9.5-.8.8-.7.8-.7.9-.6 1-.5 1.1-.4 1.1-.3 1.2-.1 1.2 3 .8.1-.5.3-.5.2-.6.3-.7.3-.7.4-.7.4-.7.4-.8.5-.7.5-.7.6-.6.6-.6.7-.6.7-.4.7-.4.8-.3z\"/><g><defs><path id=\"dm\" d=\"M36.6 60.9l.5.1.5.1.5.2.7.2.5.2.6.1.5.1.4.2.3-.8.3-.7.3-.8.3-.7.3-.8.4-.8.3-.7.4-.8.4-.6.4-.7.5-.6.5-.5.5-.5.5-.4.6-.3.6-.3-.5-.3-.6-.3-.6-.1-.6-.1-.7.1-.7.1-.8.3-.7.4-.8.6-.7.7-.7.8-.8 1-.7 1.2-.6 1.3-.7 1.5-.6 1.6\"/></defs><clipPath id=\"dn\"><use xlink:href=\"#dm\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dn)\"><defs><path id=\"do\" d=\"M36.6 51.3h10.8v10.8H36.6z\"/></defs><clipPath id=\"dp\"><use xlink:href=\"#do\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dp)\"><image overflow=\"visible\" width=\"36\" height=\"34\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAH8AAACQQAAAvb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAJwMBIgACEQEDEQH/ xACuAAEAAgMBAAAAAAAAAAAAAAAABQYBAgQDAQACAwEAAAAAAAAAAAAAAAACBAEDBQAQAAAFAQYE BwAAAAAAAAAAAAABAgMFERITBAYWJiEzFBUQMUEyI0M2EQABAQQFCwUBAAAAAAAAAAACAQARAwQh MRJyEyCBsdEikqIzsxREEEFxYoMVEgABAQUDDQAAAAAAAAAAAAAAARARMQIyIUESUYGRscHxQmKC Y4M0RP/aAAwDAQACEQMRAAAAnoGRqzd0wicldd3KWo8qxaK1GnrnIXrU2Djy/GcDcg+0Sr//2gAI AQIAAQUAaSi7O7IcLwnKEbgrwBj0/9oACAEDAAEFAEIqlLBmLHzYNi0ylghZLr2vYfl9n//aAAgB AQABBQDNMvj41zVk2NWTY1ZNiLlMbiYDPPNoLIJIhC2rnYqu0FBQQv5bOnN8CIzEMkyyvIdortUb VCdMhnt/S//aAAgBAgIGPwBFVEKZdBCx8BEY9lxdsP/aAAgBAwIGPwBLHkEMHM4kmyv1sw90T2fH TmPsOOrr3n//2gAIAQEBBj8AlxlDQEiIam8UKpRdX8tzh3B1Nzh3B1Nzh3B1NNT0Y0WYhJFUCsoi JYC0NCUVtJ3YmkcieT6x+m0pdPSORO3Y/TaUunpH1oadRUpUY9H5sH9HBe5cPFdV7ue3icLeJwts 9rmsseBh9q4sSy6w520/M3//2Q==\" transform=\"matrix(.3604 0 0 -.3604 35.644 63.119)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M36.6 60.9l.5.1.5.1.5.2.7.2.5.2.6.1.5.1.4.2.3-.8.3-.7.3-.8.3-.7.3-.8.4-.8.3-.7.4-.8.4-.6.4-.7.5-.6.5-.5.5-.5.5-.4.6-.3.6-.3-.5-.3-.6-.3-.6-.1-.6-.1-.7.1-.7.1-.8.3-.7.4-.8.6-.7.7-.7.8-.8 1-.7 1.2-.6 1.3-.7 1.5-.6 1.6z\"/><g><defs><path id=\"dq\" d=\"M51.1 53.4l-1.2-.7-1.1-.3-1-.1-.9.1-.7.4-.8.5-.6.6-.6.8-.5.9-.5 1-.5 1-.4 1-.4 1-.3.9-.4.9-.3.8h.4l.3.1.3.1.4.1h.3l.3.1.4.1.4.1.4-.8.3-.8.4-.7.3-.8.4-.7.4-.6.3-.7.4-.6.4-.6.5-.5.5-.6.5-.5.5-.4.6-.4.7-.4.8-.3\"/></defs><clipPath id=\"dr\"><use xlink:href=\"#dq\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dr)\"><defs><path id=\"ds\" d=\"M40.9 52.3h10.2v10.5H40.9z\"/></defs><clipPath id=\"dt\"><use xlink:href=\"#ds\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dt)\"><image overflow=\"visible\" width=\"36\" height=\"33\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAH6AAACQQAAAuz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACQAJwMBIgACEQEDEQH/ xACqAAEAAwADAAAAAAAAAAAAAAAAAQUGAgMEAQACAwEAAAAAAAAAAAAAAAACAwEEBQAQAAAFAgQE BwAAAAAAAAAAAAABEQIDBAUSFAYWIRM0JhAyQiNDFTYRAAAFAQQIBwEAAAAAAAAAAAABEQIDBCES E3MgQaGxIpKyNBAxMoJDFAUVEgABAAcFCQAAAAAAAAAAAAAAARExQYECMhAhYRJCscHxYoITMzRE /9oADAMBAAIRAxEAAADVUfrx9l2lZuSdv3gV0Mjr8lGnCZG/rHJGLaVx0T2AssAVP//aAAgBAgAB BQCJkZsNsRDhjJ6EcgXgYMen/9oACAEDAAEFAI48RNplHL96hhxQtgIghZ+DyOHy/wD/2gAIAQEA AQUAv94ltMO+Kob4qhverFDeJaqy636XCCaCaLOXaetSWlQIEFo/K6z6XwJrjFpY4tLXP6vl9ogt oq3bAhyGT//aAAgBAgIGPwBCZkXlIy5YqxY40xHMgf/aAAgBAwIGPwBixhk5spLNinbYp3f3iPaf 4qT7omurr4n/2gAIAQEBBj8AikjjbIcjjaZOMyRCXUO1j5nDtY+Zw7WPmcJv0nRta+JsrijIzQ8M lIUuY7p0KrLqOkxTZjt2hVZc/SYpsx27xsJRUtMrTZPZ7TDP6Vy4p4eJ5KmofBtFmBtHDg7Q/Bu/ UR19PSicQ//Z\" transform=\"matrix(.3604 0 0 -.3604 39.855 63.558)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M51.1 53.4l-1.2-.7-1.1-.3-1-.1-.9.1-.7.4-.8.5-.6.6-.6.8-.5.9-.5 1-.5 1-.4 1-.4 1-.3.9-.4.9-.3.8h.4l.3.1.3.1.4.1h.3l.3.1.4.1.4.1.4-.8.3-.8.4-.7.3-.8.4-.7.4-.6.3-.7.4-.6.4-.6.5-.5.5-.6.5-.5.5-.4.6-.4.7-.4.8-.3z\"/><g><defs><path id=\"du\" d=\"M54.6 54.4l-1-.6-1-.3h-1l-.9.1-.9.4-.8.5-.7.6-.7.8-.6.8-.6.9-.6.9-.5 1-.4.9-.4.9-.4.8-.3.8h.4l.4.1.4.1.3.1.3.1h.4l.4.1.4.1.6-1.2.5-1 .5-1 .4-.9.5-.8.4-.7.5-.7.4-.6.5-.4.4-.5.5-.4.5-.3.5-.2.5-.2.5-.1.6-.1\"/></defs><clipPath id=\"dv\"><use xlink:href=\"#du\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dv)\"><defs><path id=\"dw\" d=\"M43.8 53.5h10.8v10H43.8z\"/></defs><clipPath id=\"dx\"><use xlink:href=\"#dw\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dx)\"><image overflow=\"visible\" width=\"36\" height=\"32\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHxAAACNgAAAsT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAJwMBIgACEQEDEQH/ xACfAAACAwEBAAAAAAAAAAAAAAAABgEEBQMCAQADAAMAAAAAAAAAAAAAAAACAwQAAQUQAAEDAgQF BQAAAAAAAAAAAAEAAgMEBRESBhYyQhM0FRAjMxQ1EQABAwEFBgcAAAAAAAAAAAACAAEDESAhonME ccLSM7MFQVHBEjJiNBIAAgECBAcAAAAAAAAAAAAAABEBICExQQIS8FEyYoLCE//aAAwDAQACEQMR AAAAasHRTaKWGV+RrdDMFz309xUB6EHe0q3QL5vkbFUDl6ewDOwBK//aAAgBAgABBQCMMyOLFiMx fgnSgLP7ZRXL/9oACAEDAAEFAIYM7WUbSug37duiDoCY2LqN8jHwFc//2gAIAQEAAQUA1BdprVTb 2uC3rcFvS4K13+praDWoxoA1YLBaf/H1n2GHrp8Hw+suxDSVHSyPUVAFaqcMttb8bUEFHwf/2gAI AQICBj8AeqHJ0wPIRibuMaP/2gAIAQMCBj8AaLwfJW5eLI1d0l5N+T9aP//aAAgBAQEGPwCOaEBM jP2Ox1pSjv4O3kvzw4uJciHFxLkQ4uJa7VSRgJ6QHMGGtHdhIr6v9VBnbpWO75T9ORQZu6Vju2U/ TNQZu6SuaqvuV7VWvCnzjdsJIdvpYPYv/9k=\" transform=\"matrix(.3604 0 0 -.3604 42.987 64.419)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M54.6 54.4l-1-.6-1-.3h-1l-.9.1-.9.4-.8.5-.7.6-.7.8-.6.8-.6.9-.6.9-.5 1-.4.9-.4.9-.4.8-.3.8h.4l.4.1.4.1.3.1.3.1h.4l.4.1.4.1.6-1.2.5-1 .5-1 .4-.9.5-.8.4-.7.5-.7.4-.6.5-.4.4-.5.5-.4.5-.3.5-.2.5-.2.5-.1.6-.1z\"/><g><defs><path id=\"dy\" d=\"M57.3 55.2l-1-.5-1-.3h-.9l-.9.2-.8.4-.8.5-.7.6-.7.7-.6.8-.6.9-.5.9-.5.9-.4.9-.4.8-.3.8-.4.7.4.1.3.1h.3l.3.1.3.1h.3l.4.1.4.1.1-.6.3-.6.3-.7.4-.6.4-.7.5-.7.5-.7.5-.7.6-.6.6-.7.6-.5.6-.5.6-.5.6-.4.6-.3.6-.1\"/></defs><clipPath id=\"dz\"><use xlink:href=\"#dy\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dz)\"><defs><path id=\"dA\" d=\"M46.8 54.4h10.5V64H46.8z\"/></defs><clipPath id=\"dB\"><use xlink:href=\"#dA\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dB)\"><image overflow=\"visible\" width=\"36\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHpAAACKgAAAs7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAJwMBIgACEQEDEQH/ xACiAAEBAAIDAQAAAAAAAAAAAAAABgEFAgMEBwEAAgMBAAAAAAAAAAAAAAAAAAQBAwUCEAAABQIF AwUAAAAAAAAAAAAAAQIDBBEFEBIUBhYgISITIyQmNhEAAQIDBQUJAAAAAAAAAAAAAQIDABEEICHR kzQSstITczFBUWGxIpJjBRIAAQMCBQUAAAAAAAAAAAAAAQARMSACECFhEhNBkaEyYv/aAAwDAQAC EQMRAAAArtPzj2bq3MlyL/oTWKF0jZSxped6M8v0rtRi78SmAAH/2gAIAQIAAQUAbbbNBpaIds5L oRrMV7Y//9oACAEDAAEFAG2sxJi1Hp+9CQk2UobIeOux/9oACAEBAAEFAL1eU2hrnLQ5y0OcNCJe EyrVvcvi5QSRlFnL6nvUqxaCgoLR+V3cw89G0E4aCcCt08xa4z7e2un/2gAIAQICBj8ABuGajytH TYPR/9oACAEDAgY/AHZQuP72q0kgZmTqva3upG3mnpNH/9oACAEBAQY/AGnFNF3mqKZBWzKQn4GN GrMHDGjVmDhjRqzBww7+kGikNJcVy9qZPLE+2XfFL1FbtiqH11G6Ypuor0sVXTf3TFOGW1OELJIQ kqld5RpnctWEaZ3LVhF1M78FYRUMLQoOqQ8Aggg+5Jlda//Z\" transform=\"matrix(.3604 0 0 -.3604 45.917 64.828)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M57.3 55.2l-1-.5-1-.3h-.9l-.9.2-.8.4-.8.5-.7.6-.7.7-.6.8-.6.9-.5.9-.5.9-.4.9-.4.8-.3.8-.4.7.4.1.3.1h.3l.3.1.3.1h.3l.4.1.4.1.1-.6.3-.6.3-.7.4-.6.4-.7.5-.7.5-.7.5-.7.6-.6.6-.7.6-.5.6-.5.6-.5.6-.4.6-.3.6-.1z\"/><g><defs><path id=\"dC\" d=\"M60.6 56l-1.1-.6-1-.2h-1.1l-.9.3-1 .4-.9.7-.9.8-.8.8-.7 1-.7.9-.6.9-.5.9-.4.8-.3.7-.2.5v.2l.4.1.4.1.3.1.4.1.4.1h.3l.4.1h.4l.2-.4.3-.6.4-.7.4-.7.4-.8.5-.8.4-.7.6-.8.5-.7.6-.7.6-.6.6-.5.6-.4.7-.2.6-.1h.7\"/></defs><clipPath id=\"dD\"><use xlink:href=\"#dC\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dD)\"><defs><path id=\"dE\" d=\"M49.5 55.2h11.1v9.6H49.5z\"/></defs><clipPath id=\"dF\"><use xlink:href=\"#dE\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dF)\"><image overflow=\"visible\" width=\"36\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHhAAACJgAAAsn/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAJwMBIgACEQEDEQH/ xACYAAEBAQEBAQAAAAAAAAAAAAAABQYBAgQBAAMBAQAAAAAAAAAAAAAAAAACAwQFEAAABgEEAgMA AAAAAAAAAAAAAQIDBAUREBITBhQWIDQ1EQACAQMABwkBAAAAAAAAAAABAgMAEQQgIUGxknM0EDFR kRIiM5MFsxIAAQQABQUAAAAAAAAAAAAAEQABIQIgMYESExBRkSIy/9oADAMBAAIRAxEAAADSSu5y +zR9zhNe3TCZGc1kVejN7Z+qV/Sqbk1hTCAAH//aAAgBAgABBQBOzaZoGSyajIKcMbj49f/aAAgB AwABBQBmMS0ogoMcCfMhKZKOqUwkcxedr//aAAgBAQABBQC/v3ql73aWPdZY90lCtvXpld3UsyiI YGBQfhdz+1olClCjaWmk7VXzZkhPX7Yw316cQbpJSRBhOswfj//aAAgBAgIGPwBi0rJHpDP4RE9s H//aAAgBAwIGPwBrO2amq4h6kDQqm69KuHh7Mc1FqvquUsN2nyMH/9oACAEBAQY/AIo44VlEiliW JFrG2yulj4mrpo+Jq6aPiNZmY0So2KrMqgmzelS+vyrG5bb9D9Xlv/NqxuW2/t1Cv01PeyPb62qB saFpVVCGK7DeteO4r3QNXwkVkxMhDSKwUeN1I0v/2Q==\" transform=\"matrix(.3604 0 0 -.3604 48.524 65.547)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M60.6 56l-1.1-.6-1-.2h-1.1l-.9.3-1 .4-.9.7-.9.8-.8.8-.7 1-.7.9-.6.9-.5.9-.4.8-.3.7-.2.5v.2l.4.1.4.1.3.1.4.1.4.1h.3l.4.1h.4l.2-.4.3-.6.4-.7.4-.7.4-.8.5-.8.4-.7.6-.8.5-.7.6-.7.6-.6.6-.5.6-.4.7-.2.6-.1h.7z\"/><g><defs><path id=\"dG\" d=\"M62.9 56.9l-.9-.6-.9-.4h-.9l-.9.1-.8.3-.7.6-.8.6-.6.8-.7.8-.6.9-.5.9-.5.9-.5.9-.4.8-.3.7-.3.6h.4l.2.1.3.1.2.1.3.1.2.1h.3l.2.1.3-.7.3-.8.3-.7.4-.6.4-.7.4-.7.4-.6.5-.6.5-.6.6-.5.6-.5.6-.4.7-.4.7-.3.7-.2.8-.2\"/></defs><clipPath id=\"dH\"><use xlink:href=\"#dG\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dH)\"><defs><path id=\"dI\" d=\"M52.6 55.9h10.3v9.5H52.6z\"/></defs><clipPath id=\"dJ\"><use xlink:href=\"#dI\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dJ)\"><image overflow=\"visible\" width=\"36\" height=\"30\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHnAAACJgAAAtj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEAJwMBIgACEQEDEQH/ xACfAAEAAwEBAAAAAAAAAAAAAAAABAUGAQIBAAMAAwAAAAAAAAAAAAAAAAABBAIDBRAAAAQGAgMB AAAAAAAAAAAAAAEDBRECEgQGFhAhIBM2FBEAAAMEBgoDAQAAAAAAAAAAARECABIDBCDRMpLSEyEx sSKCM3ODwxRxUmIFEgABAwIFBQEAAAAAAAAAAAABABESIQIgMUFhA6EykjNjFP/aAAwDAQACEQMR AAAA0dFPytNN32k6Ub5FaI4mX2lGulT9t/WFtylnxLQOYAAP/9oACAECAAEFAEyToM0x1VUZEcxi PXP/2gAIAQMAAQUASRqlltCMUF77OZEkSWtSFUv7Of/aAAgBAQABBQDJnm7ahuTuNydxuLuLNyuV sfzkogpQUogG35DNiEBDhu+RyZrvXEas8jVnkS4q6i0b1kWHx//aAAgBAgIGPwAEgE1XaFs6Zap9 sH//2gAIAQMCBj8ABZVCh9I9WVk+Sy26rg3AHNe3j8gpuIfok+kZZ4P/2gAIAQEBBj8AlvVBA52Y ++AjYcIiEPs1mDcHE1mDcHE1mDcHEyv6KwT7AQoywAA3Thit3Qf5aR7vjoL6ExtiNJd3x0F9CY2x GlvVQC8rMfNQJJ5wtfw3JTfTW3KTfTW28hIcaa2VIKAoowoqCMNaxWWnipf/2Q==\" transform=\"matrix(.3604 0 0 -.3604 51.762 66.25)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M62.9 56.9l-.9-.6-.9-.4h-.9l-.9.1-.8.3-.7.6-.8.6-.6.8-.7.8-.6.9-.5.9-.5.9-.5.9-.4.8-.3.7-.3.6h.4l.2.1.3.1.2.1.3.1.2.1h.3l.2.1.3-.7.3-.8.3-.7.4-.6.4-.7.4-.7.4-.6.5-.6.5-.6.6-.5.6-.5.6-.4.7-.4.7-.3.7-.2.8-.2z\"/><g><defs><path id=\"dK\" d=\"M65.9 57.6l-.8-.3-.8-.2-.9-.1-.8.1-.8.2-.8.2-.8.4-.8.5-.7.6-.7.7-.6.7-.7.9-.6.9-.5 1-.5 1.1-.4 1.1h.3l.4.1.4.1.4.1.3.1.4.1.4.1h.4l.2-.6.3-.7.2-.6.3-.7.3-.6.3-.6.4-.6.4-.6.5-.5.5-.6.6-.5.7-.4.7-.4.8-.4 1-.3 1-.3\"/></defs><clipPath id=\"dL\"><use xlink:href=\"#dK\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dL)\"><defs><path id=\"dM\" d=\"M54.7 57H66v9H54.7z\"/></defs><clipPath id=\"dN\"><use xlink:href=\"#dM\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dN)\"><image overflow=\"visible\" width=\"36\" height=\"29\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHfAAACIwAAAuL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AJwMBIgACEQEDEQH/ xACcAAADAQEBAAAAAAAAAAAAAAAABQYEAQMBAAMBAQAAAAAAAAAAAAAAAAEDBAIFEAAABgEEAwEA AAAAAAAAAAAAAQIDBAUGERMUFhAiMzQRAAIABAMFBgcAAAAAAAAAAAECABEDBCExBUHRktIzECBR cbFygRIigqKydBIAAQMCBQUAAAAAAAAAAAAAEQABAiExUZESIhOh4TKCA//aAAwDAQACEQMRAAAA op9vJuvbdU9xbVGAxIwlLhKHofag0qfkHQed/9oACAECAAEFAEmkkmpI1BmYUbg99v8A/9oACAED AAEFAI0cloRCQNhHOhSYzbCrJghyS5n/2gAIAQEAAQUAyi0m1zfarsdpux2m6FRd2MqJmxataDTx j/4c0+QIjMIiuLFJF24ORQGJqE0FaQbpq0girgkIkSO2z//aAAgBAgIGPwBizFWZFUVIq27uv//a AAgBAwIGPwBpOxJVYRyXFpbSLCniVGP0mJMSwfFbX6Ouc0x9Qv/aAAgBAQEGPwC3a0cIahcPNQ2Q WWfnHWXgXdHWXgXdHWXgXdGo1a1QM9vRNSkQqiTBXOwY5Rae5/Re5q/8x/WpFp7n9F7MBOPCNTG1 6BH4vFAVrunaBCxBqED5pyymy5R9Wq25+5eeMNRtz5MvPGF9RPxXmi4VLhHDoQzKRJRI4nGP/9k=\" transform=\"matrix(.3604 0 0 -.3604 53.792 67.088)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M65.9 57.6l-.8-.3-.8-.2-.9-.1-.8.1-.8.2-.8.2-.8.4-.8.5-.7.6-.7.7-.6.7-.7.9-.6.9-.5 1-.5 1.1-.4 1.1h.3l.4.1.4.1.4.1.3.1.4.1.4.1h.4l.2-.6.3-.7.2-.6.3-.7.3-.6.3-.6.4-.6.4-.6.5-.5.5-.6.6-.5.7-.4.7-.4.8-.4 1-.3 1-.3z\"/><g><defs><path id=\"dO\" d=\"M70.2 58.6l-1.1-.4-1.1-.3-1-.2h-1l-1 .1-.9.3-.8.4-.9.5-.7.6-.8.7-.6.7-.7.9-.5.9-.5 1.1-.5 1-.4 1.1.4.1h.3l.4.1h.4l.4.1.4.1h.4l.4.1.2-.8.3-.8.3-.7.4-.8.4-.6.5-.6.5-.7.6-.5.6-.5.7-.4.7-.5.8-.3.8-.3.8-.2.9-.1.9-.1\"/></defs><clipPath id=\"dP\"><use xlink:href=\"#dO\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dP)\"><defs><path id=\"dQ\" d=\"M57.7 57.7h12.5v8.8H57.7z\"/></defs><clipPath id=\"dR\"><use xlink:href=\"#dQ\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dR)\"><image overflow=\"visible\" width=\"40\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHiAAACIAAAAs//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8ALAMBIgACEQEDEQH/ xACcAAADAQEAAAAAAAAAAAAAAAABBQYHBAEAAwEAAAAAAAAAAAAAAAAAAAIEAxAAAAUFAAMBAAAA AAAAAAAAAAEDBAURAhIGFiATRDMRAAADBAUKBwAAAAAAAAAAAAABAhED0wQhMRKSMyBBYbHBcqIT BTVRgSIygoPDEgABAwMBCQAAAAAAAAAAAAABABECIRIDMhBBYaHRIkKiM//aAAwDAQACEQMRAAAA pkXdJ0UvihJS+scx0zMnpS6SIyAvitaDS5mpXH//2gAIAQIAAQUATJPAzTBnbXI6GdwLIf/aAAgB AwABBQBJHO21mRhRraSjRdvYkT1mQVeN7l//2gAIAQEAAQUA2OZdRNnayo7SVHaSo7OVGZ+ndyqk VooKCg+Xdfyp4fLsLBs9s56MHPRgLX4ognCRBDEvV//aAAgBAgIGPwAOAStIQom2Gi//2gAIAQMC Bj8ABZVCxRbXfyCjHJO2QdxaTv4BfT1l0WCQl2477ix8gwX/2gAIAQEBBj8AcKl0O1m9NRK5hGft ZVZUnxGFL3VxBhS91cQYUvdXEGE4uriDmZ7NrQ1jRJ7zzUnJ+vYJTeXqTk/DYHBTE4iTJBqNJvGe prKrS01DvLjgijvLjgiinrDg7hfqKOqOD80RBZbRZY3Qysf/2Q==\" transform=\"matrix(.3604 0 0 -.3604 56.772 67.371)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M70.2 58.6l-1.1-.4-1.1-.3-1-.2h-1l-1 .1-.9.3-.8.4-.9.5-.7.6-.8.7-.6.7-.7.9-.5.9-.5 1.1-.5 1-.4 1.1.4.1h.3l.4.1h.4l.4.1.4.1h.4l.4.1.2-.8.3-.8.3-.7.4-.8.4-.6.5-.6.5-.7.6-.5.6-.5.7-.4.7-.5.8-.3.8-.3.8-.2.9-.1.9-.1z\"/><g><defs><path id=\"dS\" d=\"M72.3 58.8l-1-.1-.9-.1h-1l-.9.2-.9.2-.9.3-.8.3-.8.5-.8.6-.7.6-.6.7-.6.8-.6.8-.4.9-.4 1-.3 1.1h.4l.3.1h.2l.3.1h.3l.3.1.4.1h.3l.5-.8.5-.8.4-.7.4-.7.4-.7.3-.6.4-.6.4-.5.5-.5.5-.4.6-.4.6-.4.8-.3.8-.3.9-.2 1.1-.3\"/></defs><clipPath id=\"dT\"><use xlink:href=\"#dS\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dT)\"><defs><path id=\"dU\" d=\"M60.7 58.6h11.6V67H60.7z\"/></defs><clipPath id=\"dV\"><use xlink:href=\"#dU\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dV)\"><image overflow=\"visible\" width=\"40\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHeAAACJgAAAtD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8ALAMBIgACEQEDEQH/ xACXAAEAAgMAAAAAAAAAAAAAAAAGBAUAAQMBAQEBAQEAAAAAAAAAAAAAAAIEAQMFEAABBQABAwUA AAAAAAAAAAACAAEDBAUGEjQWEBEhExURAAIABAMHBQEAAAAAAAAAAAECABEhAxCxBNESIoKSM3Mg MUFxQoMSAAEDAwIHAAAAAAAAAAAAAAEAEQIhMQNBEmGBkaGxQlL/2gAMAwEAAhEDEQAAAEp25Iv0 rbdThuUKRDcyGyb6uOmJaPtycFJDmbD/AP/aAAgBAgABBQBiFhcmXV8F1IhldMB/V//aAAgBAwAB BQCpWE4xpRI68bX6d2CKA9MHT2Wex//aAAgBAQABBQDk+lczoPKdteU7S8p2lgbmje0VzTtfb14o JfrLmfasJEo6khKKgywqzRXVs06FuMMjBZDm47IaOYyq16kci//aAAgBAgIGPwCoCsE6oFbuiPZ1 /9oACAEDAgY/ABIxBclVhHoseMRjtMHIaliowk+4E6cVQkclHL8hvK//2gAIAQEBBj8AsPpHCM7k NMBqAT+Y7y9C7I7y9C7I7y9C7IWxqbga2UYyCqKj6GGm8jZehTKm4+WGm8jZRQTitIqJwGl+WwtL rr4sKrEoSyrMy9uOOHXIf6W4pq1POkU1KnnWN6zdDtI0BByw/9k=\" transform=\"matrix(.3604 0 0 -.3604 59.905 68.12)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M72.3 58.8l-1-.1-.9-.1h-1l-.9.2-.9.2-.9.3-.8.3-.8.5-.8.6-.7.6-.6.7-.6.8-.6.8-.4.9-.4 1-.3 1.1h.4l.3.1h.2l.3.1h.3l.3.1.4.1h.3l.5-.8.5-.8.4-.7.4-.7.4-.7.3-.6.4-.6.4-.5.5-.5.5-.4.6-.4.6-.4.8-.3.8-.3.9-.2 1.1-.3z\"/><g><defs><path id=\"dW\" d=\"M76.9 59.4l-1.5-.3-1.3-.2-1.3-.1-1.1.2-1.1.2-1 .3-.9.5-.8.5-.7.7-.7.7-.7.8-.6.8-.5.9-.5.9-.5.9-.4 1h.5l.3.1.4.1h.4l.3.1.4.1h.2l.4-.9.5-.8.5-.7.6-.7.5-.7.6-.6.7-.5.7-.5.7-.5.8-.4.7-.4.8-.4.9-.3.8-.3.9-.2 1-.3\"/></defs><clipPath id=\"dX\"><use xlink:href=\"#dW\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dX)\"><defs><path id=\"dY\" d=\"M63.3 58.8h13.6v8.7H63.3z\"/></defs><clipPath id=\"dZ\"><use xlink:href=\"#dY\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#dZ)\"><image overflow=\"visible\" width=\"44\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHiAAACKwAAAvD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8ALwMBIgACEQEDEQH/ xACdAAEBAAIDAAAAAAAAAAAAAAAFBgEDAAQHAQEAAwEAAAAAAAAAAAAAAAAEAAIDARAAAAYDAQAD AQAAAAAAAAAAAAECAwQFERIWBhAUNDYRAAECAwQFCgcAAAAAAAAAAAECAwAREiGS0wQggRMzBTFB UcEiQqLCcxTSo7PDdBU1EgACAgIBBQAAAAAAAAAAAAABAgARITESEMHRMoL/2gAMAwEAAhEDEQAA AHydk8hj2Qc1U9S+eXeWIs/ZlcQDx/dRE5c9FqB//9oACAECAAEFAE6amaAZkYMzB7BG2f/aAAgB AwABBQBmNulMJImx0tIiyYqGfvxCE+W28j//2gAIAQEAAQUA9F6CbVSu0tR2lqOztR2VoETnlUvt CzP1GBgYDf8AL+y/f8pacUG0HzV/WRJsnnqwF5+qIN0lQQRUVpBLLRV//9oACAECAgY/ABai5oTA 6auHkKn/2gAIAQMCBj8ADVuZWKVFW1RFd6YDI4se0w9/LeIqofVr0Z//2gAIAQEBBj8AaZy6GlpW 3WS4FEzmR3VJ6I3WXurxI3WXurxI3TF1eJG6YurxI/YEJ23ty9TI01BBVKU5y1wx6PmVon8NX0zD HpeZWhYIKOf2ih8sw25mM+3lFJRSELpmRMmfaWmP7LHgxYt4wwbg+7FnE2DrRiRZxBo60/HGxDgL WyKdrZTTTKrl64//2Q==\" transform=\"matrix(.3604 0 0 -.3604 62.473 68.32)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M76.9 59.4l-1.5-.3-1.3-.2-1.3-.1-1.1.2-1.1.2-1 .3-.9.5-.8.5-.7.7-.7.7-.7.8-.6.8-.5.9-.5.9-.5.9-.4 1h.5l.3.1.4.1h.4l.3.1.4.1h.2l.4-.9.5-.8.5-.7.6-.7.5-.7.6-.6.7-.5.7-.5.7-.5.8-.4.7-.4.8-.4.9-.3.8-.3.9-.2 1-.3z\"/><g><defs><path id=\"ea\" d=\"M79.6 59.7l-.8-.1H77l-.9.1-1 .2-.9.3-1 .4-1 .5-1 .5-.9.6-.9.7-.9.8-.7.9-.7.9-.7 1-.5 1.1h.4l.4.1.4.1h.4l.3.1.3.1h.4l.6-.3.5-.4.6-.5.7-.5.6-.6.7-.5.7-.6.6-.6.8-.6.7-.6.7-.6.8-.6.8-.5.7-.5.8-.5.8-.4\"/></defs><clipPath id=\"eb\"><use xlink:href=\"#ea\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eb)\"><defs><path id=\"ec\" d=\"M65.9 59.6h13.7v8.5H65.9z\"/></defs><clipPath id=\"ed\"><use xlink:href=\"#ec\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ed)\"><image overflow=\"visible\" width=\"44\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHpAAACNAAAAun/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEALwMBIgACEQEDEQH/ xACZAAEBAQADAQAAAAAAAAAAAAAABgUBAgQDAQADAQEBAAAAAAAAAAAAAAAAAgQDAQUQAAAGAgMA AwEAAAAAAAAAAAABAgMEBREGEBIWIBM0NREAAgADBAgHAQAAAAAAAAAAAQIAEQMh0aIEIEFhsZLS M3MxEiKCkzQFsxIAAgIBBAMBAAAAAAAAAAAAAQIAETEgIRIDYXGhM//aAAwDAQACEQMRAAAAsMvr IbU2SO5KLH3wFJnz1SNxPLRktj6pZhUnOssmsNfGAAD/2gAIAQIAAQUAQls0mTYPqOxkDUYSpRq5 /9oACAEDAAEFAGmO6UwkmJENDbMFbJM/fFSJ0plbHP8A/9oACAEBAAEFALe4YqW/bQB7WAPaQB7S AIV7HmQ92LMUkjAwMCg/hbp+XHJEZihSoqPZa2XYMeXuQWrXBhGq2JBGtTEiBWvR4Py//9oACAEC AgY/AAWzMTaVMGVxIGj/2gAIAQMCBj8ABm9wuAbFfYvPsRWs7MwBzP16z6YRkRlJJGD50f/aAAgB AQEGPwCnUrI7ioxUBJahPWRH162Hmj69bDzR0K2HmjoVcPNGZziU3VMqCzq0pnyqWskdkZbuNu0f 1e2/82jLdxt2hZH6kx403l8bRRTKqHZHJaZC2EbY6K8a3xbTUe9b49SDiW+OmvEL4zVB1AasrBRM a1K6f//Z\" transform=\"matrix(.3604 0 0 -.3604 64.945 68.985)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M79.6 59.7l-.8-.1H77l-.9.1-1 .2-.9.3-1 .4-1 .5-1 .5-.9.6-.9.7-.9.8-.7.9-.7.9-.7 1-.5 1.1h.4l.4.1.4.1h.4l.3.1.3.1h.4l.6-.3.5-.4.6-.5.7-.5.6-.6.7-.5.7-.6.6-.6.8-.6.7-.6.7-.6.8-.6.8-.5.7-.5.8-.5.8-.4z\"/><g><defs><path id=\"ee\" d=\"M83.4 60.8l-.7-.7-.8-.4-.8-.2h-.8l-.9.3-.9.4-.9.6-1 .6-1 .9-1 .8-1 .9-1 .9-1 .9-1.1.8-1 .8-1 .7h.3l.4.1H71.9l.7-.5.8-.6.7-.6.7-.7.7-.6.7-.6.6-.6.7-.6.7-.5.6-.5.7-.4.7-.4.8-.3.8-.3.8-.1.8-.1\"/></defs><clipPath id=\"ef\"><use xlink:href=\"#ee\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ef)\"><defs><path id=\"eg\" d=\"M68.5 59.5h14.9v8.8H68.5z\"/></defs><clipPath id=\"eh\"><use xlink:href=\"#eg\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eh)\"><image overflow=\"visible\" width=\"48\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHpAAACNgAAAwf/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AMgMBIgACEQEDEQH/ xACaAAADAQEAAAAAAAAAAAAAAAAABQYDBAEAAwADAAAAAAAAAAAAAAAAAgMFAAEEEAABBQADAQEB AAAAAAAAAAAAAQIDBAURBhYQEjURAAADBAcGBwEAAAAAAAAAAAECAwAREgQQISLSE4OjMVHRMsM0 IEFxsrMUFTUSAAEDAgUFAAAAAAAAAAAAAAEAEQIQMSFBUZEScbEiMgP/2gAMAwEAAhEDEQAAAH6B tLOoNBYD1tGE40WV6BkKWl7xZqtLaVewPlnDXpDn7wHyv//aAAgBAgABBQBrmo1XtFcnxeRUeI2X 9H//2gAIAQMAAQUArVkfG2mwlqRthKlyvFAupAhNoNew/9oACAEBAAEFAO16l/PPT7p6bdPTbh6b cMLc1beod2Tk4OPvWf7Z3X4iKo2vK4joKpg1Ei0jbo5lwTD6wgzI64g3Mw0G5+OhVq0I5j//2gAI AQICBj8ADgP0VhsrUwWACBNnGdP/2gAIAQMCBj8AjIh3fuvSOy+kuEXj85H1GQpCE+XKLuw1K8RL ZSiCfKJFtaf/2gAIAQEBBj8Alfpq4WLiR2SmfDA7nAd7d1pp3G7rTTuN3OmncbudNO4yEvMLxpHj iLAQHuIYwVlKA7Qoks3p+GWzPjPRJZvToqB7bHNaZE4Bsi9hqEf0Jj68EeHbInE+GLnAXucDf0AH 1XSutZnQHOS4NVNgOanwaqZAcwnBimRWA6gPcERR8twUf//Z\" transform=\"matrix(.3604 0 0 -.3604 67.694 69.022)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M83.4 60.8l-.7-.7-.8-.4-.8-.2h-.8l-.9.3-.9.4-.9.6-1 .6-1 .9-1 .8-1 .9-1 .9-1 .9-1.1.8-1 .8-1 .7h.3l.4.1H71.9l.7-.5.8-.6.7-.6.7-.7.7-.6.7-.6.6-.6.7-.6.7-.5.6-.5.7-.4.7-.4.8-.3.8-.3.8-.1.8-.1z\"/><g><defs><path id=\"ei\" d=\"M86.3 61.2l-1.2-.3-1.1-.1h-1.1l-1 .2-1 .4-.9.4-.9.5-.8.6-.9.7-.8.7-.8.8-.8.7-.9.7-.8.8-.9.6-.9.6h.3l.4.1h.4l.4.1h.5l.3.1h1l.5-.1.6-.3.6-.3.5-.5.7-.5.6-.6.7-.7.7-.6.8-.7.8-.7.9-.6 1-.6.9-.6 1.1-.5 1.1-.3\"/></defs><clipPath id=\"ej\"><use xlink:href=\"#ei\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ej)\"><defs><path id=\"ek\" d=\"M71.5 60.8h14.8v8.1H71.5z\"/></defs><clipPath id=\"el\"><use xlink:href=\"#ek\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#el)\"><image overflow=\"visible\" width=\"48\" height=\"27\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHmAAACLQAAAuf/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AMgMBIgACEQEDEQH/ xACXAAADAAMBAAAAAAAAAAAAAAAABQYBAgMEAQADAQEAAAAAAAAAAAAAAAADBAUCARAAAQQCAgMB AAAAAAAAAAAAAQACAwQFBhEVEBIWNREAAAMGAwUJAAAAAAAAAAAAAQIDABESkhMEENI0IDGDwzUh UWHBMnKyswUSAAIBBAEFAAAAAAAAAAAAAAECABARIVFBMZGhEgP/2gAMAwEAAhEDEQAAAKxZyk2i 2O0dvlmv9MQ1AzegckSctbpDtpcugVBM36OA6fAEhf/aAAgBAgABBQCKJjmPZGESPDZAGOcSj7cr /9oACAEDAAEFAGMBEdVrk+jEIlXdEGx2KoVi7XMK/9oACAEBAAEFAMznIsQvuKq+3qobtVX2lVY7 Z4L9xb0uEAgFwtZ/bW8jlAIDzrMTu3WzY+K6hr9VdBVXQVVHgaYdisdXgtr/2gAIAQICBj8ADEbm B5mKBdUFhzT/2gAIAQMCBj8AGJkR3sbqjMM6FB7sAZn6DsY6I4YsjL0PIp//2gAIAQEBBj8ARqJG VrROhEAdBD3+5tKpMVtKpMVtMpMDaZSYGTtCIHIZSJxhEBAISibywseNy9m24n1nwseNy9m3UHcE fwNhbVLtG1p1HVjAWKKD0vENzm6raThmbqtpOGZuq2k4Zmeb9S1HwjLmZNRO7RWMV7iEMAiLyiHY 4cP/2Q==\" transform=\"matrix(.3604 0 0 -.3604 70.677 69.867)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M86.3 61.2l-1.2-.3-1.1-.1h-1.1l-1 .2-1 .4-.9.4-.9.5-.8.6-.9.7-.8.7-.8.8-.8.7-.9.7-.8.8-.9.6-.9.6h.3l.4.1h.4l.4.1h.5l.3.1h1l.5-.1.6-.3.6-.3.5-.5.7-.5.6-.6.7-.7.7-.6.8-.7.8-.7.9-.6 1-.6.9-.6 1.1-.5 1.1-.3z\"/><g><defs><path id=\"em\" d=\"M89.9 62.2l-1.1-.6-1.1-.3h-1.1l-1.1.2-1.1.5-1.1.6-1.1.7-1.1.8-1 .8-1 .9-.9.8-.9.7-.8.7-.7.5-.6.3h-.6l.5.1.5.1.5.1.6.1h.6l.6.1h.5l.5.1.8-.6.7-.6.7-.6.6-.5.6-.6.5-.5.6-.6.6-.4.5-.5.6-.4.6-.4.7-.4.8-.4.8-.2.9-.3 1-.2\"/></defs><clipPath id=\"en\"><use xlink:href=\"#em\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#en)\"><defs><path id=\"eo\" d=\"M74.6 61.3h15.3v8.1H74.6z\"/></defs><clipPath id=\"ep\"><use xlink:href=\"#eo\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ep)\"><image overflow=\"visible\" width=\"48\" height=\"26\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHrAAACNAAAAtP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwANQMBIgACEQEDEQH/ xACcAAADAAMBAAAAAAAAAAAAAAAABQYCBAcBAQADAQEAAAAAAAAAAAAAAAADBAUCBhAAAQMEAQQD AAAAAAAAAAAAAQACAxEEBQYQEhMVFiEkJhEAAAQCCAUFAAAAAAAAAAAAAAERAhIDEEGhIjKSEwQh gbFDcyAxQrIVEgACAQMBCQEAAAAAAAAAAAABAiEAEDEDEVGBkcHRInKC0v/aAAwDAQACEQMRAAAA pZ5tIMsuskvoqDrNHuAa6KBvnJqR6KuJRjSyyFSlnDnYWBugNQ//2gAIAQIAAQUAjDO28tTn04HV 0uqntNV//9oACAEDAAEFAIYusRWkZRtLdrFaPoxkr1cSTkL/2gAIAQEAAQUA2bK3eMgG35lDbcyh tmYXteXUG05Z863cVtQEBzj7YuuFuo+qBwPlW1qXGyt6SLKeK7f5BfkU31OrPAKPxdV//9oACAEC AgY/AASATNQBeBaWA52//9oACAEDAgY/ABFSinhRLaaY3WHgzZwR1NRoOfpP1R26TKPZe9v/2gAI AQEBBj8AkTNqbSdMebXRFFwIlGKXkIYpeQhil5CGKXkIS2OcyFzmtO4XsZpRtfI76+mU46ntO2jb eR3SlCBG4M4fIutDP04IFPT1FRUqQdi0di0XdBeYuaXJQWnAtSUf/9k=\" transform=\"matrix(.3604 0 0 -.3604 73.876 70.142)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M89.9 62.2l-1.1-.6-1.1-.3h-1.1l-1.1.2-1.1.5-1.1.6-1.1.7-1.1.8-1 .8-1 .9-.9.8-.9.7-.8.7-.7.5-.6.3h-.6l.5.1.5.1.5.1.6.1h.6l.6.1h.5l.5.1.8-.6.7-.6.7-.6.6-.5.6-.6.5-.5.6-.6.6-.4.5-.5.6-.4.6-.4.7-.4.8-.4.8-.2.9-.3 1-.2z\"/><g><defs><path id=\"eq\" d=\"M20.3 50.4l-.2-.3-.1-.3-.1-.4-.1-.3-.1-.3-.1-.4v-.3l-.1-.4V45.9l.1-.3.1-.4.1-.3-.5.6-.3.7-.3.6-.1.7-.1.7v.6l.1.7.1.7.2.7.2.7.3.6.3.7.2.6.3.7.3.5.2.6v-.1l-.1-.2V53.2l-.1-.4v-1.5l-.1-.3-.1-.3v-.3\"/></defs><clipPath id=\"er\"><use xlink:href=\"#eq\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#er)\"><defs><path id=\"es\" d=\"M18.5 44.9h2.2v10.4h-2.2z\"/></defs><clipPath id=\"et\"><use xlink:href=\"#es\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#et)\"><image overflow=\"visible\" width=\"12\" height=\"33\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGaAAABwQAAAhL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACEADgMBIgACEQEDEQH/ xACCAAADAAMAAAAAAAAAAAAAAAAAAQMCBAYBAQEAAAAAAAAAAAAAAAAAAAECEAAABQQCAwAAAAAA AAAAAAABAhIDBQARMgQxJUIkBhEAAgAEBAcBAAAAAAAAAAAAAQIAEWEDMbESBBAhccFissIUEgEB AQAAAAAAAAAAAAAAAAABABD/2gAMAwEAAhEDEQAAAOlc8ri7ux2QJf/aAAgBAgABBQAbIHGv/9oA CAEDAAEFAAusMq//2gAIAQEAAQUAnpHd03iSO6MF9A2t8jfQSzanSk6reIo4E9I/Pj//2gAIAQIC Bj8AIz//2gAIAQMCBj8AZz//2gAIAQEBBj8AtLtnCq6ktNQec6xc3hcfoVpBtIlLWq4YYGLNFOcX E8h7rFuinOHWv0ITpDLXuOP/2Q==\" transform=\"matrix(.3604 0 0 -.3604 17.497 56.1)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M20.3 50.4l-.2-.3-.1-.3-.1-.4-.1-.3-.1-.3-.1-.4v-.3l-.1-.4V45.9l.1-.3.1-.4.1-.3-.5.6-.3.7-.3.6-.1.7-.1.7v.6l.1.7.1.7.2.7.2.7.3.6.3.7.2.6.3.7.3.5.2.6v-.1l-.1-.2V53.2l-.1-.4v-1.5l-.1-.3-.1-.3v-.3z\"/><g><defs><path id=\"eu\" d=\"M11.5 62.3l.5-.3.6-.4.5-.3.5-.3.5-.3.5-.3.5-.3.4-.3.5-.3.5-.3.4-.3.5-.3.5-.3.5-.2.5-.3.5-.3-.5.5-.4.4-.5.5-.4.4-.5.5-.5.4-.5.4-.5.4-.5.3-.5.3-.5.2-.5.2-.6.2-.5.1h-1\"/></defs><clipPath id=\"ev\"><use xlink:href=\"#eu\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ev)\"><defs><path id=\"ew\" d=\"M11.5 57.5h7.9v4.8h-7.9z\"/></defs><clipPath id=\"ex\"><use xlink:href=\"#ew\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ex)\"><image overflow=\"visible\" width=\"28\" height=\"18\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGsAAAB2gAAAj//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABMAHwMBIgACEQEDEQH/ xACHAAACAwEAAAAAAAAAAAAAAAAABQMEBgIBAQADAAAAAAAAAAAAAAAAAAABAgMQAAIBBAMBAAAA AAAAAAAAAAECAwAxBAUSExQVEQAABAQBDQEAAAAAAAAAAAAAARETMQISA2EhUXGBkaHB0SIyBESk IxIAAwEAAAAAAAAAAAAAAAAAAIFCEP/aAAwDAQACEQMRAAAA3FbhTfNtZzLglUgmJuB//9oACAEC AAEFAFUEMoAFmt//2gAIAQMAAQUAZiCrEk3W/wD/2gAIAQEAAQUAychoSdlIKO1lFQZbS4m4k4F8 mnya10nLS7jq5N5KbxVr+n43/9oACAECAgY/AMpFM//aAAgBAwIGPwDJZKP/2gAIAQEBBj8AlQiN ViIS7+Y7Zdh8xcvmRLJUhFDpJRaxI+AiIjyZ8xXd0gtONwNHHcINcR631D1frHkUNNpcqodb7ctT n6aU1D//2Q==\" transform=\"matrix(.3604 0 0 -.3604 10.646 63.362)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M11.5 62.3l.5-.3.6-.4.5-.3.5-.3.5-.3.5-.3.5-.3.4-.3.5-.3.5-.3.4-.3.5-.3.5-.3.5-.2.5-.3.5-.3-.5.5-.4.4-.5.5-.4.4-.5.5-.5.4-.5.4-.5.4-.5.3-.5.3-.5.2-.5.2-.6.2-.5.1h-1z\"/><g><defs><path id=\"ey\" d=\"M15.8 50.8l.4.2.3.3.4.2.4.3.3.3.3.3.3.3.4.3.2.3.3.3.3.3.3.3.3.4.2.3.3.4.2.3-.1-.4-.1-.3-.2-.5-.1-.4-.2-.4-.2-.3-.2-.4-.3-.4-.3-.3-.3-.3-.4-.3-.4-.3-.5-.2-.5-.1-.5-.1-.6-.1\"/></defs><clipPath id=\"ez\"><use xlink:href=\"#ey\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#ez)\"><defs><path id=\"eA\" d=\"M15.8 50.8h5v4.8h-5z\"/></defs><clipPath id=\"eB\"><use xlink:href=\"#eA\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eB)\"><image overflow=\"visible\" width=\"20\" height=\"18\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGuAAAB2QAAAkT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABYAGQMBIgACEQEDEQH/ xACJAAADAQAAAAAAAAAAAAAAAAAABAUGAQEBAQAAAAAAAAAAAAAAAAACAQMQAAEEAgMBAQAAAAAA AAAAAAIAAQQFEgMRMQZBQhEAAgAEBAMJAAAAAAAAAAAAAQIAERIDECExUdJjBGFxgZGxIpLCNBIA AQQDAQAAAAAAAAAAAAAAAAERIUGBwUJh/9oADAMBAAIRAxEAAADXyXc7plr3ZdQtKeFlNoCv/9oA CAECAAEFABFnbhsh6+//2gAIAQMAAQUAMiZ+XxLv8//aAAgBAQABBQC5syrNDet3OqqeVhFXpwzi DoXnxxgKzGEWptVCoAxR0L//2gAIAQICBj8AlBvTrBez/9oACAEDAgY/AIUe2OclaP/aAAgBAQEG PwBLq2xdLvRImmWROx2j8q/M8MG+yC2aitIM9AO7fCyOZ9TgRzG9Bgg6xyiVe0iesuwGMrz+TcES 6Vi1uo5meviBh//Z\" transform=\"matrix(.3604 0 0 -.3604 14.993 56.626)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M15.8 50.8l.4.2.3.3.4.2.4.3.3.3.3.3.3.3.4.3.2.3.3.3.3.3.3.3.3.4.2.3.3.4.2.3-.1-.4-.1-.3-.2-.5-.1-.4-.2-.4-.2-.3-.2-.4-.3-.4-.3-.3-.3-.3-.4-.3-.4-.3-.5-.2-.5-.1-.5-.1-.6-.1z\"/><g><defs><path id=\"eC\" d=\"M20.1 47.3l.1.6.1.6.1.6.1.5v.5l.1.6.1.5v.5l.1.5.1.5v.5l.1.5.1.5.1.6.1.5.1.5.1-.6.1-.6V54l.1-.7v-.6l.1-.6-.1-.6v-.6l-.1-.5-.1-.6-.1-.5-.2-.5-.2-.4-.3-.4-.3-.3-.3-.4\"/></defs><clipPath id=\"eD\"><use xlink:href=\"#eC\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eD)\"><defs><path id=\"eE\" d=\"M20.1 47.3h1.7v8.5h-1.7z\"/></defs><clipPath id=\"eF\"><use xlink:href=\"#eE\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eF)\"><image overflow=\"visible\" width=\"12\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGNAAABqAAAAeX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8ADgMBIgACEQEDEQH/ xAB0AAADAAAAAAAAAAAAAAAAAAAEBQYBAQEAAAAAAAAAAAAAAAAAAAACEAABBAMBAAAAAAAAAAAA AAABAAMEBREhEgIRAQEAAQMFAQAAAAAAAAAAAAECECGxYhExEiIDBBIBAQEAAAAAAAAAAAAAAAAA AAFh/9oADAMBAAIRAxEAAACtZzdJUpXQB5//2gAIAQIAAQUAIGCdf//aAAgBAwABBQAEkgb/AP/a AAgBAQABBQCfdtwZSvW+rNWrfU5TGR7kL//aAAgBAgIGPwCaj//aAAgBAwIGPwC4r//aAAgBAQEG PwCfzV8qtoK8hA9npiHhG7iXjO7gpuZ0NKoHvj//2Q==\" transform=\"matrix(.3604 0 0 -.3604 19.251 56.869)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M20.1 47.3l.1.6.1.6.1.6.1.5v.5l.1.6.1.5v.5l.1.5.1.5v.5l.1.5.1.5.1.6.1.5.1.5.1-.6.1-.6V54l.1-.7v-.6l.1-.6-.1-.6v-.6l-.1-.5-.1-.6-.1-.5-.2-.5-.2-.4-.3-.4-.3-.3-.3-.4z\"/><g><defs><path id=\"eG\" d=\"M17 46.4l-.5.5-.4.5-.1.6v.6l.1.6.2.7.3.6.4.6.4.6.5.6.5.6.5.5.4.5.4.5.4.4.3.3-.1-.9-.1-.7-.1-.7-.3-.5-.2-.5-.3-.5-.3-.4-.3-.3-.3-.4-.3-.4-.3-.4-.2-.4-.3-.6-.1-.5-.2-.7v-.8\"/></defs><clipPath id=\"eH\"><use xlink:href=\"#eG\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eH)\"><defs><path id=\"eI\" d=\"M16 46.4h4.4v8.7H16z\"/></defs><clipPath id=\"eJ\"><use xlink:href=\"#eI\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eJ)\"><image overflow=\"visible\" width=\"20\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGtAAAB4AAAAkX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AGQMBIgACEQEDEQH/ xACFAAEAAwEAAAAAAAAAAAAAAAAFAwQGAgEBAQEAAAAAAAAAAAAAAAAAAgEDEAABBAMBAQEAAAAA AAAAAAACAAESBBEDBSEiBhEBAAECBAQGAwAAAAAAAAAAAQIRAwAQIRKxwWKSMUFRgdEEwjNjEgAB BQAAAAAAAAAAAAAAAAAAEAERIYH/2gAMAwEAAhEDEQAAANWG0DrlpUDkQzin69ndyKUr/9oACAEC AAEFAAZseSEmZs+//9oACAEDAAEFADd5ewIXd8fP/9oACAEBAAEFAO/dtUqzd/sOuLasW6a/RhOq OhcMY0l2QloHSuYMayta9OwGq01XDWAL/9oACAECAgY/ALY1JP/aAAgBAwIGPwCnMSD/2gAIAQEB Bj8At3PqyIzlPbJQlpRfPH7Tsj8Ybv2Jbp70qAaAemVo/p+LknW8DK2dfJyp1PLILs9gNRUNffGl 47o4pblujXxqPDL/2Q==\" transform=\"matrix(.3604 0 0 -.3604 14.947 56.068)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M17 46.4l-.5.5-.4.5-.1.6v.6l.1.6.2.7.3.6.4.6.4.6.5.6.5.6.5.5.4.5.4.5.4.4.3.3-.1-.9-.1-.7-.1-.7-.3-.5-.2-.5-.3-.5-.3-.4-.3-.3-.3-.4-.3-.4-.3-.4-.2-.4-.3-.6-.1-.5-.2-.7v-.8z\"/><g><defs><path id=\"eK\" d=\"M20.7 55.6v-2.3l.1-.6v-.5l.1-.6v-.5l.1-.5.1-.6.2-.5.1-.5.1-.5.2-.5.2-.5.2-.6-.8.8-.7.8-.5.7-.3.7-.3.7-.1.6v.6l.1.6.1.5.1.5.2.4.2.4.2.4.2.4.1.3.1.3\"/></defs><clipPath id=\"eL\"><use xlink:href=\"#eK\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eL)\"><defs><path id=\"eM\" d=\"M19.4 46.9h2.7v8.7h-2.7z\"/></defs><clipPath id=\"eN\"><use xlink:href=\"#eM\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eN)\"><image overflow=\"visible\" width=\"16\" height=\"28\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGbAAABxAAAAiD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAB8AEwMBIgACEQEDEQH/ xAB8AAACAgMAAAAAAAAAAAAAAAAABAMFAQIGAQEBAAAAAAAAAAAAAAAAAAACAxAAAQQDAQAAAAAA AAAAAAAAAwABEgQRAgUGEQACAgEDAwUAAAAAAAAAAAABAhEDABDBEiExYUGh0WJjEgEBAQAAAAAA AAAAAAAAAAARECH/2gAMAwEAAhEDEQAAAOnkUlc7sAUqd2cosgFf/9oACAECAAEFAMNBZaK//9oA CAEDAAEFAMvNYeS//9oACAEBAAEFAOz17dCxxepZv7L0A52vPDhsuuOR+TpB1aCIm9UQxuv/2gAI AQICBj8AYT//2gAIAQMCBj8AHIz/2gAIAQEBBj8ArqoStlZORLgkzJHowy0XqiisKV4AjvPeWOlR /Pc5d5C76Ifrucs8gb6AvaEIEAGPkY3CwPMTEdPc6f/Z\" transform=\"matrix(.3604 0 0 -.3604 18.455 56.344)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M20.7 55.6v-2.3l.1-.6v-.5l.1-.6v-.5l.1-.5.1-.6.2-.5.1-.5.1-.5.2-.5.2-.5.2-.6-.8.8-.7.8-.5.7-.3.7-.3.7-.1.6v.6l.1.6.1.5.1.5.2.4.2.4.2.4.2.4.1.3.1.3z\"/><g><defs><path id=\"eO\" d=\"M12.2 57.6l.5.1.5.1h.4l.5.1H16.8l.4-.1h.9l.5-.1h.4l.5-.1-.4.2-.4.1-.4.2-.4.1-.4.2-.5.1-.4.1-.5.1h-1.4l-.5-.1-.5-.2-.5-.2-.5-.3-.5-.3\"/></defs><clipPath id=\"eP\"><use xlink:href=\"#eO\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eP)\"><defs><path id=\"eQ\" d=\"M12.2 57.6h7.2v1.1h-7.2z\"/></defs><clipPath id=\"eR\"><use xlink:href=\"#eQ\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eR)\"><image overflow=\"visible\" width=\"28\" height=\"7\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGKAAABogAAAdz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAsAHwMBIgACEQEDEQH/ xAB2AAEBAQEAAAAAAAAAAAAAAAAABQQGAQEBAAAAAAAAAAAAAAAAAAABAhABAAIDAQAAAAAAAAAA AAAAAQAEAgMFIBEAAQIFBQAAAAAAAAAAAAAAARECAEFxEgMgIZEENBIAAgMAAAAAAAAAAAAAAAAA AAERITH/2gAMAwEAAhEDEQAAAOvyXFTCug//2gAIAQIAAQUAEik//9oACAEDAAEFAEYDP//aAAgB AQABBQC70d9bdl3bZMO9cy2ef//aAAgBAgIGPwDClB//2gAIAQMCBj8A0tyf/9oACAEBAQY/ADjZ hvCA3bzpHlPDoaw9VA4gEo6Zpq//2Q==\" transform=\"matrix(.3604 0 0 -.3604 11.215 59.56)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M12.2 57.6l.5.1.5.1h.4l.5.1H16.8l.4-.1h.9l.5-.1h.4l.5-.1-.4.2-.4.1-.4.2-.4.1-.4.2-.5.1-.4.1-.5.1h-1.4l-.5-.1-.5-.2-.5-.2-.5-.3-.5-.3z\"/><g><defs><path id=\"eS\" d=\"M14.9 59.9l-.3.1h-.3l-.4.1-.3.1-.4.2-.3.1-.3.1-.4.2-.3.2-.3.2-.3.2-.3.2-.3.2-.2.2-.2.2-.2.3.2-.7.3-.6.4-.5.4-.5.6-.4.5-.4.7-.3.6-.2.7-.3.7-.2.7-.2.7-.2.8-.1.6-.1.7-.2.6-.1-.3.1-.4.2-.6.4-.6.4-.6.4-.7.3-.6.4-.6.2\"/></defs><clipPath id=\"eT\"><use xlink:href=\"#eS\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eT)\"><defs><path id=\"eU\" d=\"M10.1 57.5h9.2v5h-9.2z\"/></defs><clipPath id=\"eV\"><use xlink:href=\"#eU\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eV)\"><image overflow=\"visible\" width=\"32\" height=\"18\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGsAAAB2wAAAjL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABMAIQMBIgACEQEDEQH/ xACDAAEAAwEAAAAAAAAAAAAAAAAAAwQGBQEBAQAAAAAAAAAAAAAAAAAAAwAQAAEDBAMBAAAAAAAA AAAAAAEAAgURMQMEEhMUFREAAQEFBwUBAAAAAAAAAAAAAQARAhIyExAhMUGhQ6NhImKiA6QSAAMB AQAAAAAAAAAAAAAAAAAQATJC/9oADAMBAAIRAxEAAADbw1qCH1ZM/arSA04vPEOC4VpQaf/aAAgB AgABBQANFC0UQsbL/9oACAEDAAEFAC41DjVG4uv/2gAIAQEAAQUAz7RxPMg4IyjwtWQdnzKTy8Nl +wn7Khc/OQUr1ep3nT/MoPo+gv/aAAgBAgIGPwAq6Lpf/9oACAEDAgY/ACLkmV//2gAIAQEBBj8A hABuzUo1UruqHyLoAYS0NysI6BYrFB3xesMVNsImqN9Lls862P0IQUooXpK0XJ22f//Z\" transform=\"matrix(.3604 0 0 -.3604 9.176 63.408)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M14.9 59.9l-.3.1h-.3l-.4.1-.3.1-.4.2-.3.1-.3.1-.4.2-.3.2-.3.2-.3.2-.3.2-.3.2-.2.2-.2.2-.2.3.2-.7.3-.6.4-.5.4-.5.6-.4.5-.4.7-.3.6-.2.7-.3.7-.2.7-.2.7-.2.8-.1.6-.1.7-.2.6-.1-.3.1-.4.2-.6.4-.6.4-.6.4-.7.3-.6.4-.6.2z\"/><g><defs><path id=\"eW\" d=\"M13.6 65.1l-.3-.7-.1-.6.1-.7.3-.5.3-.6.5-.5.5-.5.6-.5.7-.5.6-.4.7-.4.7-.3.6-.3.5-.3.5-.3.4-.2-.4.8-.4.7-.4.6-.4.4-.5.4-.4.4-.4.2-.5.3-.4.2-.4.3-.5.3-.4.4-.4.4-.4.5-.3.6-.4.8\"/></defs><clipPath id=\"eX\"><use xlink:href=\"#eW\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eX)\"><defs><path id=\"eY\" d=\"M13.2 57.8h7v7.3h-7z\"/></defs><clipPath id=\"eZ\"><use xlink:href=\"#eY\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#eZ)\"><image overflow=\"visible\" width=\"24\" height=\"24\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGwAAAB3wAAAjz/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwAHAMBIgACEQEDEQH/ xACHAAEBAAMAAAAAAAAAAAAAAAAFBAIDBgEBAQEAAAAAAAAAAAAAAAAAAgABEAABBAICAgMAAAAA AAAAAAABAAIDBBESISITFhQFFREAAQEFBQgDAAAAAAAAAAAAAREAEDECEqEyYgMTIVFhkcEiUqKj BBQSAQEBAAAAAAAAAAAAAAAAAAABIf/aAAwDAQACEQMRAAAA7zDRGwlQI3kMY7IiZ1ozNv8A/9oA CAECAAEFAA0Y15aeCe3/2gAIAQMAAQUALjnY4cOQOv8A/9oACAEBAAEFAJJmxn5bE23G5yvP1ldM oZs2F9xLpYfZVSxm6r35flPrah9c86//2gAIAQICBj8ASJiY/9oACAEDAgY/AFq6uv/aAAgBAQEG PwBCDBWgWEoBUkDm4DD1Lsob55Ra6UYAbZmi31wsc2QewcP2JqUhFquqfFttPyNl6NOtXLp3769s eLv/2Q==\" transform=\"matrix(.3604 0 0 -.3604 12.393 65.95)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M13.6 65.1l-.3-.7-.1-.6.1-.7.3-.5.3-.6.5-.5.5-.5.6-.5.7-.5.6-.4.7-.4.7-.3.6-.3.5-.3.5-.3.4-.2-.4.8-.4.7-.4.6-.4.4-.5.4-.4.4-.4.2-.5.3-.4.2-.4.3-.5.3-.4.4-.4.4-.4.5-.3.6-.4.8z\"/><g><defs><path id=\"fa\" d=\"M20.8 58l-.3.5-.3.5-.3.5-.3.4-.3.5-.2.5-.3.4-.2.5-.2.5-.2.5-.2.4-.2.5-.2.5-.1.5-.1.5-.1.6-.3-1.1-.2-1v-.8l.1-.8.2-.6.2-.6.3-.5.4-.4.4-.3.4-.4.4-.2.4-.3.4-.2.3-.2.3-.2.2-.2\"/></defs><clipPath id=\"fb\"><use xlink:href=\"#fa\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#fb)\"><defs><path id=\"fc\" d=\"M16.8 58h4v7.8h-4z\"/></defs><clipPath id=\"fd\"><use xlink:href=\"#fc\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#fd)\"><image overflow=\"visible\" width=\"16\" height=\"25\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAyADIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGgAAABxwAAAhr/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABwAEQMBIgACEQEDEQH/ xACBAAACAgMAAAAAAAAAAAAAAAAABQIGAQMEAQEBAAAAAAAAAAAAAAAAAAACAxAAAQQCAgMAAAAA AAAAAAAAAwABEQQSBSIVAhMUEQABAgMJAQAAAAAAAAAAAAARAQIAEBIhMVGhsbIDExRxEgACAwAA AAAAAAAAAAAAAAAQETFBYf/aAAwDAQACEQMRAAAAvGOODDgAOua20aSZgTr/AP/aAAgBAgABBQCG hTxX/9oACAEDAAEFAJeVHJf/2gAIAQEAAQUALZcfmK05CK6XGxSLlbW3Phe1B89mrfS++p0f0r// 2gAIAQICBj8AeCKH/9oACAEDAgY/AFomx//aAAgBAQEGPwBWhFEIwIhOknp80SONuJ2rLlabqdqR wtxq2Ok71dfdZVUTcgyhnl6/RbRSTcpyl//Z\" transform=\"matrix(.3604 0 0 -.3604 16.008 66.548)\"/></g></g></g><path fill=\"none\" stroke=\"#231F20\" stroke-width=\".254\" d=\"M20.8 58l-.3.5-.3.5-.3.5-.3.4-.3.5-.2.5-.3.4-.2.5-.2.5-.2.5-.2.4-.2.5-.2.5-.1.5-.1.5-.1.6-.3-1.1-.2-1v-.8l.1-.8.2-.6.2-.6.3-.5.4-.4.4-.3.4-.4.4-.2.4-.3.4-.2.3-.2.3-.2.2-.2z\"/></svg>"

/***/ }),

/***/ "../src/components/apache/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ApacheOriginal = __webpack_require__("../src/components/apache/original/ApacheOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ApacheOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apache/plain-wordmark/ApachePlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ApachePlainWordmark = __webpack_require__("../src/components/apache/plain-wordmark/ApachePlainWordmark.svg");
	
	var _ApachePlainWordmark2 = _interopRequireDefault(_ApachePlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ApachePlainWordmark */
	function ApachePlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ApachePlainWordmark',
	    svg: _ApachePlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ApachePlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ApachePlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apache/plain-wordmark/ApachePlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#303284\" d=\"M14.8 71L7.4 91h5.2l1.4-4h7.5l1.4 4h5.4l-7.4-20h-6.1zm.5 12l2.5-7.2 2.5 7.2h-5zm25.5-7.8c-1 0-1.8.2-2.6.6-.8.4-1.2.9-2.2 1.4V76h-5v20h5v-5.9c0 .3 1.1.6 1.7.8.6.2 1.3.3 2.1.3.9 0 1.8-.2 2.6-.5s1.5-.9 2.2-1.6c.6-.7 1.1-1.5 1.5-2.5.4-1 .6-2.2.6-3.4 0-2.4-.5-4.3-1.6-5.7s-2.4-2.3-4.3-2.3zm0 11.4c-.6.8-1.6 1.1-2.9 1.1-.4 0-.6 0-1-.1-.4 0-.9-.1-.9-.2v-7.6c0-.3.8-.5 1.3-.6s.9-.2 1.4-.2c1.1 0 1.9.3 2.4 1s.7 1.7.7 3.2c-.1 1.5-.4 2.6-1 3.4zm21.5-10.1c-1.2-.9-3.2-1.3-5.9-1.3-1.2 0-2.5.1-3.7.3-1.2.2-1.7.4-2.7.5v4h.9c.4 0 1.1-.5 2-.8s1.8-.5 2.6-.5c1.3 0 2.1.1 2.8.4s.7.9.7 1.7v.1c-1 .1-2.6.2-3.9.4s-2.3.5-3.2.9c-.9.4-1.6 1-2 1.7-.5.7-.7 1.6-.7 2.7 0 1.4.5 2.5 1.5 3.4 1 .9 2.2 1.3 3.6 1.3.6 0 1.2-.1 1.7-.2s1-.3 1.5-.5c.3-.2.5-.4.9-.7s.7-.5.7-.7V91h5V80.5c-.1-1.8-.6-3.1-1.8-4zM59 86.9c0 .3-.6.6-1.1.8-.5.2-.9.3-1.4.3-.6 0-1 0-1.3-.1-.3-.1-.5-.2-.7-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.8 0-.5.1-.9.4-1.2.3-.3.6-.5 1.1-.7.4-.1.7-.2 1.5-.3l1.9-.2v3.2zm17.5-11.7c-1.2 0-2.3.1-3.3.4-1.1.3-2 .8-2.8 1.4-.8.7-1.5 1.5-2 2.6s-.7 2.3-.7 3.7c0 1.3.2 2.5.7 3.5s1.1 1.8 1.9 2.5c.8.7 1.8 1.1 2.9 1.5 1.1.3 2.3.5 3.6.5 1 0 2-.1 2.8-.3.8-.2 1.5-.5 2.5-.9V86h-.8c-.2 0-.4.4-.6.6-.2.2-.5.4-.8.6-.3.2-.7.3-1.2.5-.5.1-1 .2-1.7.2-1.3 0-2.3-.4-3-1.1s-1.1-1.9-1.1-3.3.3-2.5 1-3.4c.7-.8 1.7-1.2 3-1.2.6 0 1.1.1 1.5.2.4.1.8.3 1.2.5.4.2.7.6 1 .8.3.2.5-.2.7.8h.7v-4.5c-1-.4-1.6-.7-2.5-.9-.9-.4-1.9-.6-3-.6zm18.6 0c-1 0-1.8.2-2.6.5-.8.4-1.5.9-2.5 1.6V70h-5v21h5V80.1c1-.3 1-.5 1.5-.7.5-.1.9-.2 1.3-.2.6 0 1.1.1 1.5.2.3.2.6.4.8.7.2.3 0 .7.1 1.3.1.6-.1 1.2-.1 1.8V91h5V81c0-1.9-.3-3.3-1.2-4.3-1-1-2.1-1.5-3.8-1.5zm17.3 0c-2.7 0-4.8.7-6.3 2.2-1.5 1.5-2.3 3.5-2.3 6s.8 4.5 2.4 5.9c1.6 1.4 4 2.1 7 2.1 1.2 0 2.5-.1 3.5-.3s1.4-.5 3.4-1v-4h-1c-.6 1-1.3.9-2.3 1.2-1 .4-2 .6-3 .6-1.6 0-2.9-.4-3.7-1-.8-.6-1.3-1.8-1.4-2.8H120v-1.5c0-2.3-.7-4.1-2-5.4-1.2-1.4-3.2-2-5.6-2zm-3.8 5.8c.1-1 .4-1.7 1-2.2.6-.5 1.4-.7 2.3-.7 1 0 1.8.1 2.2.7.5.5.7 1.2.8 2.2h-6.3zm18.7-22.6l-.2-.1v-.4l-.1-.4-.2-.3-.4-.2h-.1l-.1-.2-.3-.2-.3-.2-.4-.1h-.2l-.4-.4-.5-.3-.6-.3-.6-.2h-.2l-.5-.6-.6-.4-.6-.3-.6-.2h-.1l-.6-.4-.8-.3-.5-.1-.5-.4-.5-.2-.5-.1-.5-.1h-.5l-.6.1h-.1l-.4-.6-.6-.4-.8-.2h-.9l-1 .2-.4.1-.8-.3-.8-.2h-2.6l-1-.4-.9-.3-.9-.1h-.6l-.8-.8-.9-.6-.8-.4-.8-.2h-.8l-.4.3-.5-.4-.6-.3-.7-.1-.6.1-.7-.3-.7-.2h-1l-1.1-.4-1.2-.3-1.1-.1h-.2l-1.2-.7-1.2-.3h-1.1.1l-1.7-.4-1.1-.1h-.5l-.7-.7-.8-.5-.9-.2-.9.1-.6.2-.8-.1h-1.8v-.2L76 43l-1.4-.2-1.3-.1-.5.1v-.1l-1-.1-1-.1h-.1l-1.1-.5-1.1-.3-1-.1h-.8l-1.1-.4-.9-.2h-1l-1.1-.8-.9-.3-.7-.1-.8-.4-1.2-.2h-1.1l-1.1-.5-1-.2h-.6l-1.2-.6-1-.3-1-.1-.3.1h.1l-1.4-.8-1.1-.4-1-.1h-.1l-.7-.5-.6-.3-.6-.2-.7-.1-.7.1-.8-.6-.7-.3-.9-.1h-.8l-.9.2-.2.1-1-.5-1-.3h-.9l-.8-.5-.7-.3h-.8l-.7.1-.7.2h-.1l-.7-.7-.6-.4-.7-.1-.7.1-.6.3-.2-.1-.3-.2-.3-.1-.3-.1h-.7l-.3.1-.5.3-.1.1-.9-.2h-.8l-.7.2-.6.5-.4.5-.3.7-.3.8-.2.8-.1.8-.1 1.6.1 1.8v.3c-.5-.2-1-.4-1.6-.6v-.4l.1-.6.1-1.3.1-1.2-.1-1.2-.1-.6-.1-.5-.1-.5-.2-.5-.2-.4-.3-.4-.3-.4-.6-.5.2.9.1.6.1.6.1.5.1.6.1.5v.1-.1l-.1-.3-.1-.3-.2-.6-.3-1-.1-.3-.2-1.3v-.4l.1-.7.1-.3.2-.7h-.2l-.5.6-.3.7-.3.7-.1.6V33l.1.7.1.7-.1-.1-.3-.4-.3-.4-.2-.5-.2-.5-.2-.5-.1-.7-.1-1-.7.6-.3.6-.2.6v.6l.1.6.2.6.3.6.1.2-.2.2-.6-.1-.1.2.4.2.4.3 1 .8.3.3.5.6.5.5.5.5.4.4.3.4.2.2c-5.7-2.3-11.7-5-19.1-8.5l-.4-.2.2.4c1 1.7 3.9 3.4 6.4 5 1.2.7 2.3 1.4 3.1 2 2.4 1.3 5.6 2.7 8.4 3.8h-.2l-2 .4-1.4.3-1.4.5-.7.3-.7.2-.6.4-.5.4-.5.5-.4.5-.3.6-.2.7.2.1.2-.2.5-.5.2-.2.6-.4.3-.2.3-.2.6-.3.4-.1.3-.1.7-.2.7-.1.6-.2 1.3-.7.6-.4.6-.4.5-.3.4-.2.3-.1.6.2-2.4 1.2-1.3.8-.7.5-.6.5-.6.5-.5.6-.3.5-.2.6-.1.6.1.7.4.9.5-1 .4-.6.4-.5.4-.4.4-.3.9-.6.4-.2-.1.4-.2.8v.9l.1 1 .3 1.1h.2l.2-1.1.3-1 .2-.5.4-.9.5-.9.8-1.4 1.1-1.8c.4.2.8.3 1.2.4l-.1.2-.7 1.4-.4.6-.3.7-.1.7-.2.7-.1.7v.7l.1.6.3.6.5.5.7.4.8.3.3.6.4.5.4.4.4.3.4.2.4.1h1v.1l.4.6.6.5.7.3h.8l.8-.2.2.2.6.6.6.4.7.3.8.1h.6l.6.4.7.3.8.2.6.5.8.4 1 .2 1.1.1h.2l.7.6.8.4.7.3.8.1.9-.2.4.2.6.3.6.1h.6l.6-.1.3.2 1 .3 1.1.1 1.3-.1.4.2.9.3 1 .1 1.4-.1h.1l.9.3 1 .1 1.1-.1.4.3 1 .4 1 .1 1.1-.1v-.1l.6.2h1l1.1-.2.7.2h.8l.8-.1 1.1.2.3.2 1 .3 1 .2 1.1.1 1.1-.1v-.1l.6.2.9.1.9.1v-.1l.6.2 1.2.4 1.3.3 1.4-.3v-.1h.2l.9.2.8.1h.9l.1.1.8.6.8.4H83l.8-.4.7-.6.9.1 1.1-.1h1.2v.1l.3.2 1.1.2 1.1-.1 1.1-.5h1l1.2.1 1-.1.6.1h1.4l.9-.1.5.2.6.1.6-.1.6-.3.1.1.8.1h2.5l.8-.3 1.1-.4h1.6l.8-.1.5.2.8.2.8.1.8-.1.9-.2.2.1.9.4.8.3h.8l.6-.3.5-.5.3.1.5.1.5.1h.5l.5-.1.5-.2.7.1.8-.1.7-.3h.7l.6-.1.6-.3.5-.4.1-.1.6.1.6-.1.5.1h.9l.4-.3.3-.2.1-.2h.1l.3-.1.3-.2.2-.5.1-.6h.2l.3-.1.1-.3.1.1v-.8l-.3-.4zm-106.4-16l-.3.2.2-.5.3.1-.2.2zm.5-2.9l-.2-.2-.2-.4v-2.4l.1-.8.1.1.1.5.1.5.1.5.3 1.6.2.7c-.3 0-.5-.1-.6-.1z\"/></svg>"

/***/ }),

/***/ "../src/components/apache/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ApachePlainWordmark = __webpack_require__("../src/components/apache/plain-wordmark/ApachePlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ApachePlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apache/plain/ApachePlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ApachePlain = __webpack_require__("../src/components/apache/plain/ApachePlain.svg");
	
	var _ApachePlain2 = _interopRequireDefault(_ApachePlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ApachePlain */
	function ApachePlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ApachePlain',
	    svg: _ApachePlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ApachePlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ApachePlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apache/plain/ApachePlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#303284\" d=\"M127.6 75.9l-.3-.5-.2-.1v-.4l-.1-.4-.2-.3-.4-.2h-.1l-.1-.2-.3-.2-.3-.2-.4-.1h-.2l-.4-.4-.5-.3-.6-.3-.6-.2h-.2l-.5-.6-.6-.4-.6-.3-.6-.2h-.1l-.6-.4-.8-.3-.5-.1-.5-.4-.5-.2-.5-.1-.5-.1h-.5l-.6.1h-.1l-.4-.6-.6-.4-.8-.2h-.9l-1 .2-.4.1-.8-.3-.8-.2h-2.6l-1-.4-.9-.3-.9-.1h-.6l-.8-.8-.9-.6-.8-.4-.8-.2h-.8l-.4.3-.5-.4-.6-.3-.7-.1-.6.1-.7-.3-.7-.2h-1l-1.1-.4-1.2-.3-1.1-.1h-.2l-1.2-.7-1.2-.3h-1.1.1l-1.7-.4-1.1-.1h-.5l-.7-.7-.8-.5-.9-.2-.9.1-.6.2-.8-.1h-1.8v-.2L76 60l-1.4-.2-1.3-.1-.5.1v-.1l-1-.1-1-.1h-.1l-1.1-.5-1.1-.3-1-.1h-.8l-1.1-.4-.9-.2h-1l-1.1-.8-.9-.3-.7-.1-.8-.4-1.2-.2h-1.1l-1.1-.5-1-.2h-.6l-1.2-.6-1-.3-1-.1-.3.1h.1l-1.4-.8-1.1-.4-1-.1h-.1l-.7-.5-.6-.3-.6-.2-.7-.1-.7.1-.8-.6-.7-.3-.9-.1h-.8l-.9.2-.2.1-1-.5-1-.3h-.9l-.8-.5-.7-.3h-.8l-.7.1-.7.2h-.1l-.7-.7-.6-.4-.7-.1-.7.1-.6.3-.2-.1-.3-.2-.3-.1-.3-.1h-.7l-.3.1-.5.3-.1.1-.9-.2h-.8l-.7.2-.6.5-.4.5-.3.7-.3.8-.2.8-.1.8-.1 1.6.1 1.8v.3c-.5-.2-1-.4-1.6-.6v-.4l.1-.6.1-1.3.1-1.2-.1-1.2-.1-.6-.1-.5-.1-.5-.2-.5-.2-.4-.3-.4-.3-.4-.6-.5.2.9.1.6.1.6.1.5.1.6.1.5v.1-.1l-.1-.3-.1-.3-.2-.6-.3-1-.1-.3-.2-1.3v-.4l.1-.7.1-.3.2-.7h-.2l-.5.6-.3.7-.3.7-.1.6V50l.1.7.1.7-.1-.1-.3-.4-.3-.4-.2-.5-.2-.5-.2-.5-.1-.7-.1-1-.7.6-.3.6-.2.6v.6l.1.6.2.6.3.6.1.2-.2.2-.6-.1-.1.2.4.2.4.3 1 .8.3.3.5.6.5.5.5.5.4.4.3.4.2.2c-5.7-2.3-11.7-5-19.1-8.5l-.4-.2.2.4c1 1.7 3.9 3.4 6.4 5 1.2.7 2.3 1.4 3.1 2 2.4 1.3 5.6 2.7 8.4 3.8h-.2l-2 .4-1.4.3-1.4.5-.7.3-.7.2-.6.4-.5.4-.5.5-.4.5-.3.6-.2.7.2.1.2-.2.5-.5.2-.2.6-.4.3-.2.3-.2.6-.3.4-.1.3-.1.7-.2.7-.1.6-.2 1.3-.7.6-.4.6-.4.5-.3.4-.2.3-.1.6.2-2.4 1.2-1.3.8-.7.5-.6.5-.6.5-.5.6-.3.5-.2.6-.1.6.1.7.4.9.5-1 .4-.6.4-.5.4-.4.4-.3.9-.6.4-.2-.1.4-.2.8v.9l.1 1 .3 1.1h.2l.2-1.1.3-1 .2-.5.4-.9.5-.9.8-1.4 1.1-1.8c.4.2.8.3 1.2.4l-.1.2-.7 1.4-.4.6-.3.7-.1.7-.2.7-.1.7v.7l.1.6.3.6.5.5.7.4.8.3.3.6.4.5.4.4.4.3.4.2.4.1h1v.1l.4.6.6.5.7.3h.8l.8-.2.2.2.6.6.6.4.7.3.8.1h.6l.6.4.7.3.8.2.6.5.8.4 1 .2 1.1.1h.2l.7.6.8.4.7.3.8.1.9-.2.4.2.6.3.6.1h.6l.6-.1.3.2 1 .3 1.1.1 1.3-.1.4.2.9.3 1 .1 1.4-.1h.1l.9.3 1 .1 1.1-.1.4.3 1 .4 1 .1 1.1-.1v-.1l.6.2h1l1.1-.2.7.2h.8l.8-.1 1.1.2.3.2 1 .3 1 .2 1.1.1 1.1-.1v-.1l.6.2.9.1.9.1v-.1l.6.2 1.2.4 1.3.3 1.4-.3v-.1h.2l.9.2.8.1h.9l.1.1.8.6.8.4H83l.8-.4.7-.6.9.1 1.1-.1h1.2v.1l.3.2 1.1.2 1.1-.1 1.1-.5h1l1.2.1 1-.1.6.1h1.4l.9-.1.5.2.6.1.6-.1.6-.3.1.1.8.1h2.5l.8-.3 1.1-.4h1.6l.8-.1.5.2.8.2.8.1.8-.1.9-.2.2.1.9.4.8.3h.8l.6-.3.5-.5.3.1.5.1.5.1h.5l.5-.1.5-.2.7.1.8-.1.7-.3h.7l.6-.1.6-.3.5-.4.1-.1.6.1.6-.1.5.1h.9l.4-.3.3-.2.1-.2h.1l.3-.1.3-.2.2-.5.1-.6h.2l.3-.1.1-.3.1.1v-.7zm-107-16.3l.2-.5.3.1-.2.2-.3.2zm.6-6.8l.1.5.1.5.1.5.3 1.6.2.7-.4-.2h.1l-.2-.1-.5-.4v-2.4l.1-.8.1.1z\"/></svg>"

/***/ }),

/***/ "../src/components/apache/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ApachePlain = __webpack_require__("../src/components/apache/plain/ApachePlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ApachePlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/appcelerator/original-wordmark/AppceleratorOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AppceleratorOriginalWordmark = __webpack_require__("../src/components/appcelerator/original-wordmark/AppceleratorOriginalWordmark.svg");
	
	var _AppceleratorOriginalWordmark2 = _interopRequireDefault(_AppceleratorOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AppceleratorOriginalWordmark */
	function AppceleratorOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AppceleratorOriginalWordmark',
	    svg: _AppceleratorOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AppceleratorOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AppceleratorOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/appcelerator/original-wordmark/AppceleratorOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#AC162C\" d=\"M108.722 86.325L66.089 12.483a3.163 3.163 0 1 0-5.487 0L17.966 86.325a3.091 3.091 0 0 0 0 3.132c.567.98 1.612 1.543 2.744 1.543h85.27c1.132 0 2.174-.563 2.742-1.543a3.091 3.091 0 0 0 0-3.132zm-27.125-5.962l.114-3.2-12.302 2.173-.56-.319.16-4.017h-.321s-3.371 5.379-10.837 5.379c-5.538 0-10.756-2.26-10.756-11.248C47.095 60.059 53.916 57 61.062 57H69v-3.836c0-3.612-2.645-5.7-7.141-5.7-5.058 0-11.228.803-11.228.803L50 47.705v-6.101s6.674-.802 13.34-.802c6.102 0 13.66 1.606 13.66 10.596v20.688l3.967-.779-1.24-2.994 10.219 4.498-8.349 7.552zM54.88 68.479c0 4.173 3.126 5.027 5.935 5.027 2.65 0 5.186-.754 8.186-4.045V63h-5.85c-5.463 0-8.271 1.144-8.271 5.479z\"/><path fill=\"#555759\" d=\"M10.819 112.77H8.552l-.178-.178.049-1.351h-.101s-1.069 1.784-3.438 1.784c-1.759 0-3.415-.711-3.415-3.567 0-2.878 2.166-3.848 4.434-3.848h2.472v-1.145c0-1.146-.816-1.809-2.242-1.809-1.606 0-3.541.255-3.541.255l-.18-.177v-1.938s2.039-.254 4.154-.254c1.936 0 4.254.51 4.254 3.362v8.866zm-2.445-5.22H6.565c-1.732 0-2.624.38-2.624 1.757 0 1.326.967 1.605 1.858 1.605.841 0 1.758-.228 2.574-1.275v-2.087zm5.911-6.754h2.293l.177.179-.051 1.351h.102s1.046-1.784 3.415-1.784c1.937 0 3.286.74 3.286 3.593v5.197c0 2.855-2.446 3.694-4.561 3.694-.867 0-1.528-.051-2.191-.102v4.179h-2.47v-16.307zm2.47 9.962a13.97 13.97 0 0 0 2.318.053c1.07-.104 1.987-.536 1.987-2.063v-4.459c0-1.3-.636-1.632-1.579-1.632-.866 0-1.758.356-2.727 1.551v6.55zm9.886-9.962h2.293l.178.179-.052 1.351h.103s1.045-1.784 3.413-1.784c1.938 0 3.288.74 3.288 3.593v5.197c0 2.855-2.447 3.694-4.562 3.694-.865 0-1.529-.051-2.19-.102v4.179h-2.471v-16.307zm2.47 9.962c.661.077 1.631.104 2.317.053 1.07-.104 1.987-.536 1.987-2.063v-4.459c0-1.3-.637-1.632-1.579-1.632-.866 0-1.757.356-2.726 1.551v6.55zm17.707-7.745s-1.451-.254-3.059-.254c-1.426 0-2.624.205-2.624 2.038v4.001c0 1.836 1.198 2.038 2.624 2.038 1.607 0 3.059-.256 3.059-.256l.179.179v2.012s-1.708.256-3.822.256c-2.116 0-4.509-.662-4.509-3.517v-5.427c0-2.852 2.393-3.541 4.509-3.541 2.114 0 3.822.254 3.822.254v2.04l-.179.177zm11.414 4.537h-6.395v1.247c0 1.836 1.197 2.038 2.624 2.038 1.604 0 3.211-.256 3.211-.256l.175.179v2.012s-1.857.256-3.973.256c-2.113 0-4.51-.662-4.51-3.517v-5.17c0-2.981 2.422-3.797 4.689-3.797 2.266 0 4.661.74 4.661 3.797 0 1.3-.205 2.801-.229 2.955l-.253.256zm-6.394-3.391v1.452h4.203c.051-.305.128-.866.103-1.425-.052-1.147-.868-1.529-2.089-1.529-1.301 0-2.217.458-2.217 1.502zm12.227-8.203v16.814h-2.472V95.956h2.472zm11.974 11.594h-6.393v1.247c0 1.836 1.198 2.038 2.622 2.038 1.605 0 3.211-.256 3.211-.256l.177.179v2.012s-1.858.256-3.974.256-4.511-.662-4.511-3.517v-5.17c0-2.981 2.42-3.797 4.688-3.797 2.271 0 4.665.74 4.665 3.797 0 1.3-.204 2.801-.229 2.955l-.256.256zm-6.393-3.391v1.452h4.201c.051-.305.128-.866.101-1.425-.05-1.147-.864-1.529-2.089-1.529-1.296 0-2.213.458-2.213 1.502zm15.946-1.146c-1.044 0-2.344 0-3.718 1.276v8.481h-2.473v-11.974h2.295l.178.179-.052 1.351h.103c-.155 0 1.298-1.935 3.845-1.784v2.294l-.178.177zm11.058 9.757h-2.27l-.178-.178.053-1.351h-.104s-1.069 1.784-3.438 1.784c-1.758 0-3.414-.711-3.414-3.567 0-2.878 2.166-3.848 4.434-3.848h2.469v-1.145c0-1.146-.815-1.809-2.242-1.809-1.604 0-3.54.255-3.54.255l-.177-.177v-1.938s2.037-.254 4.151-.254c1.935 0 4.256.51 4.256 3.362v8.866zm-2.448-5.22h-1.808c-1.731 0-2.622.38-2.622 1.757 0 1.326.964 1.605 1.857 1.605.842 0 1.757-.228 2.572-1.275v-2.087zm6.089-4.792H99.02v-1.962h1.271v-2.548h2.473v2.548h2.879v1.962h-2.879v6.801c0 .97.509 1.353 1.377 1.353.839 0 1.578-.101 1.578-.101l.181.177v1.782s-.894.256-2.242.256c-2.167 0-3.366-1.198-3.366-3.467v-6.801zm16.742 6.498c0 3.081-2.399 3.77-4.663 3.77-2.27 0-4.69-.79-4.69-3.77v-4.917c0-2.981 2.421-3.797 4.69-3.797 2.264 0 4.663.714 4.663 3.797v4.917zm-2.448-4.587c0-1.35-.841-2.012-2.215-2.012-1.506 0-2.217.687-2.217 2.012v4.255c0 1.4.813 1.988 2.217 1.988 1.5 0 2.215-.664 2.215-1.988v-4.255zm11.769-1.656c-1.044 0-2.342 0-3.72 1.276v8.481h-2.47v-11.974h2.293l.177.179-.051 1.351h.102c-.151 0 1.302-1.935 3.846-1.784v2.294l-.177.177z\"/></svg>"

/***/ }),

/***/ "../src/components/appcelerator/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AppceleratorOriginalWordmark = __webpack_require__("../src/components/appcelerator/original-wordmark/AppceleratorOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AppceleratorOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/appcelerator/original/AppceleratorOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AppceleratorOriginal = __webpack_require__("../src/components/appcelerator/original/AppceleratorOriginal.svg");
	
	var _AppceleratorOriginal2 = _interopRequireDefault(_AppceleratorOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AppceleratorOriginal */
	function AppceleratorOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AppceleratorOriginal',
	    svg: _AppceleratorOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AppceleratorOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AppceleratorOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/appcelerator/original/AppceleratorOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#AC162C\" d=\"M125.477 111.872L67.719 11.834a4.29 4.29 0 1 0-7.434 0L2.523 111.872c-.77 1.328-.77 2.81 0 4.141.769 1.328 2.185 1.987 3.718 1.987h115.521c1.534 0 2.945-.659 3.715-1.987.77-1.331.77-2.813 0-4.141zm-36.748-8.075l.155-4.336-16.666 2.944-.758-.699.215-5.706h-.435s-4.567 7.553-14.682 7.553c-7.503 0-14.572-3-14.572-15.176C41.986 76.083 51.228 72 60.908 72H71v-5.052c0-4.895-3.252-7.721-9.343-7.721-6.852 0-15.006 1.087-15.006 1.087L46 59.552v-8.265s8.751-1.086 17.784-1.086C72.049 50.201 82 52.376 82 64.556v28.027l5.625-1.056-1.555-4.057 13.907 6.094-11.248 10.233zM52.534 87.56c0 5.655 3.903 6.879 7.708 6.879 3.59 0 7.758-.954 10.758-5.413V80h-7.262c-7.4 0-11.204 1.686-11.204 7.56z\"/></svg>"

/***/ }),

/***/ "../src/components/appcelerator/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AppceleratorOriginal = __webpack_require__("../src/components/appcelerator/original/AppceleratorOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AppceleratorOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/appcelerator/plain-wordmark/AppceleratorPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AppceleratorPlainWordmark = __webpack_require__("../src/components/appcelerator/plain-wordmark/AppceleratorPlainWordmark.svg");
	
	var _AppceleratorPlainWordmark2 = _interopRequireDefault(_AppceleratorPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AppceleratorPlainWordmark */
	function AppceleratorPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AppceleratorPlainWordmark',
	    svg: _AppceleratorPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AppceleratorPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AppceleratorPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/appcelerator/plain-wordmark/AppceleratorPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#AC162C\" d=\"M108.722 86.324L66.089 12.482a3.166 3.166 0 1 0-5.487 0L17.966 86.324a3.093 3.093 0 0 0 0 3.133c.567.98 1.612 1.543 2.744 1.543h85.27c1.132 0 2.174-.563 2.742-1.543a3.093 3.093 0 0 0 0-3.133zm-27.125-5.961l.114-3.2-12.302 2.173-.56-.319.16-4.017h-.321s-3.371 5.379-10.837 5.379c-5.538 0-10.756-2.26-10.756-11.247C47.095 60.059 53.916 57 61.062 57H69v-3.836c0-3.612-2.645-5.699-7.141-5.699-5.058 0-11.228.803-11.228.803L50 47.705v-6.101s6.674-.802 13.34-.802c6.102 0 13.66 1.605 13.66 10.596v20.688l3.967-.779-1.24-2.994 10.219 4.498-8.349 7.552zM54.88 68.479c0 4.173 3.126 5.026 5.935 5.026 2.65 0 5.186-.754 8.186-4.045V63h-5.85c-5.463 0-8.271 1.144-8.271 5.479zM10.819 112.77H8.552l-.178-.178.049-1.35h-.101s-1.069 1.783-3.438 1.783c-1.759 0-3.415-.711-3.415-3.566 0-2.879 2.166-3.848 4.434-3.848h2.472v-1.146c0-1.146-.816-1.81-2.242-1.81-1.606 0-3.541.256-3.541.256l-.18-.178v-1.938s2.039-.255 4.154-.255c1.936 0 4.254.511 4.254 3.362v8.868zm-2.445-5.22H6.565c-1.732 0-2.624.38-2.624 1.757 0 1.326.967 1.605 1.858 1.605.841 0 1.758-.229 2.574-1.275v-2.087zm5.911-6.753h2.293l.177.178-.051 1.352h.102s1.046-1.784 3.415-1.784c1.937 0 3.286.739 3.286 3.593v5.197c0 2.855-2.446 3.693-4.561 3.693-.867 0-1.528-.051-2.191-.102v4.18h-2.47v-16.307zm2.47 9.961a13.97 13.97 0 0 0 2.318.053c1.07-.104 1.987-.536 1.987-2.063v-4.459c0-1.301-.636-1.633-1.579-1.633-.866 0-1.758.356-2.727 1.552v6.55zm9.886-9.961h2.293l.178.178-.052 1.352h.103s1.045-1.784 3.413-1.784c1.938 0 3.288.739 3.288 3.593v5.197c0 2.855-2.447 3.693-4.562 3.693-.865 0-1.529-.051-2.19-.102v4.18h-2.471v-16.307zm2.47 9.961c.661.077 1.631.104 2.317.053 1.07-.104 1.987-.536 1.987-2.063v-4.459c0-1.301-.637-1.633-1.579-1.633-.866 0-1.757.356-2.726 1.552v6.55zm17.707-7.745s-1.451-.255-3.059-.255c-1.426 0-2.624.205-2.624 2.038v4.001c0 1.836 1.198 2.038 2.624 2.038 1.607 0 3.059-.256 3.059-.256l.179.179v2.012s-1.708.256-3.822.256c-2.116 0-4.509-.662-4.509-3.516v-5.428c0-2.852 2.393-3.54 4.509-3.54 2.114 0 3.822.255 3.822.255v2.039l-.179.177zm11.414 4.537h-6.395v1.247c0 1.836 1.197 2.038 2.624 2.038 1.604 0 3.211-.256 3.211-.256l.175.179v2.012s-1.857.256-3.973.256c-2.113 0-4.51-.662-4.51-3.516v-5.171c0-2.981 2.422-3.797 4.689-3.797 2.266 0 4.661.739 4.661 3.797 0 1.3-.205 2.802-.229 2.955l-.253.256zm-6.394-3.392v1.453h4.203a7.13 7.13 0 0 0 .103-1.426c-.052-1.146-.868-1.529-2.089-1.529-1.301 0-2.217.459-2.217 1.502zm12.227-8.202v16.813h-2.472V95.956h2.472zm11.974 11.594h-6.393v1.247c0 1.836 1.198 2.038 2.622 2.038 1.605 0 3.211-.256 3.211-.256l.177.179v2.012s-1.858.256-3.974.256-4.511-.662-4.511-3.516v-5.171c0-2.981 2.42-3.797 4.688-3.797 2.271 0 4.665.739 4.665 3.797 0 1.3-.204 2.802-.229 2.955l-.256.256zm-6.393-3.392v1.453h4.201c.051-.305.128-.866.101-1.426-.05-1.146-.864-1.529-2.089-1.529-1.296 0-2.213.459-2.213 1.502zm15.946-1.145c-1.044 0-2.344 0-3.718 1.276v8.48h-2.473v-11.973h2.295l.178.178-.052 1.352h.103c-.155 0 1.298-1.936 3.845-1.784v2.294l-.178.177zm11.058 9.757h-2.27l-.178-.178.053-1.35h-.104s-1.069 1.783-3.438 1.783c-1.758 0-3.414-.711-3.414-3.566 0-2.879 2.166-3.848 4.434-3.848h2.469v-1.146c0-1.146-.815-1.81-2.242-1.81-1.604 0-3.54.256-3.54.256l-.177-.178v-1.938s2.037-.255 4.151-.255c1.935 0 4.256.511 4.256 3.362v8.868zm-2.448-5.22h-1.808c-1.731 0-2.622.38-2.622 1.757 0 1.326.964 1.605 1.857 1.605.842 0 1.757-.229 2.572-1.275v-2.087zm6.089-4.792H99.02v-1.961h1.271v-2.549h2.473v2.549h2.879v1.961h-2.879v6.801c0 .971.509 1.354 1.377 1.354.839 0 1.578-.102 1.578-.102l.181.178v1.781s-.894.256-2.242.256c-2.167 0-3.366-1.197-3.366-3.467v-6.801zm16.742 6.498c0 3.08-2.399 3.77-4.663 3.77-2.27 0-4.69-.789-4.69-3.77v-4.917c0-2.981 2.421-3.797 4.69-3.797 2.264 0 4.663.714 4.663 3.797v4.917zm-2.448-4.587c0-1.35-.841-2.013-2.215-2.013-1.506 0-2.217.688-2.217 2.013v4.255c0 1.4.813 1.988 2.217 1.988 1.5 0 2.215-.664 2.215-1.988v-4.255zm11.769-1.656c-1.044 0-2.342 0-3.72 1.276v8.48h-2.47v-11.973h2.293l.177.178-.051 1.352h.102c-.151 0 1.302-1.936 3.846-1.784v2.294l-.177.177z\"/></svg>"

/***/ }),

/***/ "../src/components/appcelerator/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AppceleratorPlainWordmark = __webpack_require__("../src/components/appcelerator/plain-wordmark/AppceleratorPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AppceleratorPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apple/original/AppleOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AppleOriginal = __webpack_require__("../src/components/apple/original/AppleOriginal.svg");
	
	var _AppleOriginal2 = _interopRequireDefault(_AppleOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AppleOriginal */
	function AppleOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AppleOriginal',
	    svg: _AppleOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AppleOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AppleOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/apple/original/AppleOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M97.905 67.885c.174 18.8 16.494 25.057 16.674 25.137-.138.44-2.607 8.916-8.597 17.669-5.178 7.568-10.553 15.108-19.018 15.266-8.318.152-10.993-4.934-20.504-4.934-9.508 0-12.479 4.776-20.354 5.086-8.172.31-14.395-8.185-19.616-15.724C15.822 94.961 7.669 66.8 18.616 47.791c5.438-9.44 15.158-15.417 25.707-15.571 8.024-.153 15.598 5.398 20.503 5.398 4.902 0 14.106-6.676 23.782-5.696 4.051.169 15.421 1.636 22.722 12.324-.587.365-13.566 7.921-13.425 23.639M82.272 21.719c4.338-5.251 7.258-12.563 6.462-19.836-6.254.251-13.816 4.167-18.301 9.416-4.02 4.647-7.54 12.087-6.591 19.216 6.971.54 14.091-3.542 18.43-8.796\"/></svg>"

/***/ }),

/***/ "../src/components/apple/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AppleOriginal = __webpack_require__("../src/components/apple/original/AppleOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AppleOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/atom/original-wordmark/AtomOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AtomOriginalWordmark = __webpack_require__("../src/components/atom/original-wordmark/AtomOriginalWordmark.svg");
	
	var _AtomOriginalWordmark2 = _interopRequireDefault(_AtomOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AtomOriginalWordmark */
	function AtomOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AtomOriginalWordmark',
	    svg: _AtomOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AtomOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AtomOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/atom/original-wordmark/AtomOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#67595D\" d=\"M49.66 53.23h1.14l8.19 21.57H58l-2.79-7.35H45.16l-2.82 7.35h-.99l8.31-21.57zm5.19 13.32L50.23 54.4l-4.71 12.15h9.33zm12.99-12.39h-6.72v-.93h14.46v.93h-6.721V74.8h-1.02V54.16zm14.879 1.95c1.681-2.24 4.11-3.36 7.29-3.36 3.2 0 5.641 1.11 7.32 3.33 1.5 2.021 2.25 4.67 2.25 7.951 0 3.299-.75 5.939-2.25 7.92-1.68 2.199-4.12 3.3-7.32 3.3s-5.63-1.101-7.29-3.3c-1.5-1.98-2.25-4.621-2.25-7.92 0-3.261.75-5.901 2.25-7.921zm.75 15.15c1.48 2.081 3.66 3.12 6.54 3.12 2.9 0 5.09-1.039 6.57-3.12 1.3-1.819 1.95-4.229 1.95-7.229 0-2.98-.66-5.39-1.98-7.23-1.5-2.1-3.68-3.15-6.54-3.15s-5.04 1.05-6.54 3.15c-1.3 1.84-1.949 4.25-1.949 7.23s.649 5.389 1.949 7.229zM106.6 53.23h1.44l7.859 15.179 7.561-15.179h1.41V74.8h-.9V54.49l-7.8 15.15h-.601L107.5 54.49V74.8h-.9V53.23z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#67595D\" d=\"M13.217 64.784l-.572 1.191c-.88 1.89-1.607 3.833-1.984 5.891-.208 1.144-.322 2.297-.023 3.446.257.987.79 1.494 1.704 1.536.4.019.82-.066 1.209-.176 1.03-.292 1.929-.856 2.796-1.467.21-.149.427-.242.689-.144.465.173.634.79.241 1.083-1.418 1.057-2.917 1.967-4.754 2.022-1.504.047-2.592-.76-3.071-2.193-.359-1.07-.38-2.171-.249-3.274.391-3.286 1.66-6.271 3.183-9.166.131-.249.138-.446.046-.711a109.395 109.395 0 0 1-1.081-3.297c-.067-.21-.135-.269-.361-.219-1.491.328-2.961.729-4.286 1.512a6.613 6.613 0 0 0-1.409 1.108c-.68.714-.693 1.503-.138 2.319.484.711 1.168 1.197 1.888 1.638l.69.391c.33.196.443.58.274.897a.653.653 0 0 1-.896.267c-1.014-.52-1.958-1.138-2.715-2.005-.463-.53-.804-1.128-.917-1.835-.14-.882.113-1.66.643-2.357.547-.721 1.265-1.234 2.048-1.66 1.39-.757 2.888-1.208 4.425-1.542l.353-.087c-.072-.411-.15-.809-.213-1.21-.251-1.63-.367-3.263.032-4.889.159-.644.408-1.251.841-1.764.884-1.044 2.021-1.277 3.295-.966 1.261.309 2.318 1.006 3.306 1.818.278.23.286.645.059.912-.233.272-.595.308-.912.092-.496-.338-.98-.7-1.497-1.005-.592-.35-1.228-.599-1.935-.602-.586-.002-1.042.235-1.374.709-.423.601-.573 1.295-.653 2.006-.168 1.505.031 2.984.324 4.456.031.156.092.212.257.195 1.187-.119 2.376-.236 3.564-.335a.759.759 0 0 0 .588-.319c1.546-1.953 3.241-3.761 5.234-5.27 1.111-.84 2.283-1.573 3.635-1.974.846-.25 1.702-.343 2.554-.043 1.063.374 1.658 1.183 1.965 2.227.325 1.107.274 2.237.143 3.366-.034.289-.085.577-.139.863-.074.389-.364.595-.752.55-.354-.041-.584-.325-.546-.72.051-.543.175-1.084.18-1.627.007-.644-.007-1.302-.141-1.926-.278-1.298-1.177-1.807-2.505-1.515-.996.22-1.88.688-2.721 1.243-1.728 1.139-3.203 2.563-4.572 4.103-.255.286-.5.581-.747.874l-.034.123h.359c3.527.035 7.002.455 10.397 1.432 1.616.466 3.178 1.073 4.613 1.966.765.475 1.466 1.025 2.021 1.744 1.131 1.463 1.036 3.108-.266 4.418-.879.886-1.961 1.445-3.115 1.88a.643.643 0 0 1-.811-.37c-.137-.344.012-.698.361-.868.533-.258 1.086-.48 1.59-.788a5.529 5.529 0 0 0 1.145-.922c.705-.75.731-1.57.133-2.409-.447-.628-1.048-1.089-1.695-1.491-1.596-.992-3.348-1.606-5.15-2.085-1.88-.5-3.789-.849-5.729-.987-1.546-.11-3.098-.142-4.646-.215-.224-.01-.376.056-.5.247-.908 1.4-1.826 2.794-2.729 4.197a.497.497 0 0 0-.05.395c1.529 3.638 3.466 7.033 6.031 10.047 1.08 1.27 2.256 2.442 3.683 3.33.669.417 1.367.765 2.178.817.734.051 1.27-.257 1.634-.88.345-.587.481-1.236.544-1.904.198-2.152-.228-4.23-.792-6.286-.579-2.105-1.396-4.123-2.334-6.093-.075-.158-.139-.347-.13-.518.015-.311.26-.531.566-.58.27-.042.552.105.687.395.336.718.677 1.436.983 2.167.949 2.257 1.713 4.573 2.116 6.995.281 1.69.416 3.388.025 5.081a5.819 5.819 0 0 1-.379 1.108c-.666 1.455-2.016 2.112-3.579 1.771-1.271-.278-2.344-.943-3.345-1.736-1.841-1.459-3.335-3.238-4.686-5.145a40.635 40.635 0 0 1-3.931-6.909l-.168-.344zm-.666-5.781l.843 2.677 1.951-2.979-2.794.302zm7.472 6.91a1.913 1.913 0 0 1-1.916-1.908 1.918 1.918 0 0 1 1.937-1.917A1.918 1.918 0 0 1 21.961 64a1.914 1.914 0 0 1-1.938 1.913z\"/></svg>"

/***/ }),

/***/ "../src/components/atom/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AtomOriginalWordmark = __webpack_require__("../src/components/atom/original-wordmark/AtomOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AtomOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/atom/original/AtomOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _AtomOriginal = __webpack_require__("../src/components/atom/original/AtomOriginal.svg");
	
	var _AtomOriginal2 = _interopRequireDefault(_AtomOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** AtomOriginal */
	function AtomOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'AtomOriginal',
	    svg: _AtomOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	AtomOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = AtomOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/atom/original/AtomOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#67595D\" d=\"M38.622 66.979c-.806 1.674-1.508 3.089-2.175 4.522-3.338 7.177-6.103 14.553-7.53 22.367-.794 4.346-1.228 8.724-.093 13.087.975 3.749 3.004 5.674 6.475 5.833 1.519.071 3.108-.251 4.587-.668 3.916-1.109 7.323-3.251 10.618-5.571.8-.564 1.618-.916 2.616-.545 1.768.658 2.408 3.002.917 4.115-5.381 4.009-11.076 7.466-18.049 7.68-5.711.176-9.845-2.887-11.667-8.331-1.36-4.062-1.44-8.24-.941-12.432 1.482-12.478 6.298-23.815 12.081-34.805.497-.944.527-1.694.175-2.703-1.444-4.147-2.787-8.33-4.106-12.519-.25-.794-.506-1.02-1.368-.831-5.666 1.246-11.248 2.767-16.274 5.744-1.941 1.15-3.803 2.578-5.355 4.208-2.581 2.71-2.63 5.709-.521 8.803 1.84 2.701 4.433 4.548 7.169 6.217.856.524 1.759.97 2.621 1.484 1.253.749 1.682 2.201 1.039 3.409-.645 1.209-2.092 1.688-3.406 1.012-3.844-1.976-7.429-4.321-10.304-7.611-1.762-2.016-3.053-4.282-3.48-6.968-.532-3.35.428-6.302 2.44-8.954 2.075-2.733 4.8-4.683 7.775-6.303 5.276-2.873 10.961-4.589 16.801-5.854.4-.087.796-.195 1.338-.33-.275-1.558-.57-3.07-.806-4.593-.957-6.194-1.398-12.393.123-18.567.602-2.442 1.547-4.75 3.191-6.695 3.356-3.967 7.672-4.85 12.512-3.668 4.784 1.169 8.801 3.818 12.547 6.901 1.06.872 1.089 2.447.224 3.462-.883 1.035-2.256 1.17-3.458.351-1.888-1.285-3.724-2.658-5.686-3.819-2.248-1.329-4.662-2.272-7.352-2.285-2.222-.011-3.949.893-5.215 2.693-1.604 2.283-2.177 4.917-2.48 7.618-.641 5.713.12 11.329 1.233 16.918.119.594.347.804.972.741 4.51-.45 9.021-.899 13.538-1.276.982-.081 1.623-.436 2.232-1.206 5.87-7.415 12.305-14.281 19.875-20.01 4.217-3.191 8.673-5.973 13.8-7.492 3.212-.951 6.463-1.303 9.698-.166 4.04 1.42 6.298 4.49 7.462 8.452 1.234 4.206 1.041 8.494.54 12.781a46.552 46.552 0 0 1-.528 3.277c-.281 1.478-1.377 2.261-2.853 2.089-1.342-.156-2.218-1.235-2.077-2.733.195-2.066.666-4.121.687-6.183.025-2.44-.027-4.943-.535-7.313-1.059-4.928-4.468-6.861-9.511-5.749-3.783.833-7.138 2.613-10.332 4.718-6.561 4.324-12.162 9.731-17.362 15.577-.967 1.087-1.897 2.208-2.837 3.318-.057.066-.053.184-.125.465h1.361c13.391.135 26.585 1.727 39.479 5.438 6.14 1.768 12.067 4.072 17.521 7.465 2.902 1.805 5.566 3.894 7.673 6.62 4.297 5.56 3.936 11.802-1.007 16.781-3.338 3.363-7.449 5.487-11.828 7.137-1.239.465-2.603-.218-3.077-1.405-.521-1.304.044-2.653 1.37-3.296 2.022-.98 4.125-1.829 6.037-2.993a21.078 21.078 0 0 0 4.347-3.499c2.677-2.849 2.776-5.963.506-9.151-1.7-2.388-3.984-4.134-6.44-5.66-6.06-3.766-12.71-6.099-19.557-7.92-7.138-1.899-14.39-3.224-21.755-3.748-5.869-.417-11.759-.537-17.639-.816-.849-.041-1.429.21-1.901.938-3.447 5.316-6.933 10.607-10.362 15.935-.25.388-.356 1.086-.185 1.497 5.805 13.814 13.157 26.708 22.9 38.155 4.102 4.817 8.563 9.272 13.98 12.643 2.542 1.581 5.195 2.9 8.272 3.105 2.788.188 4.822-.979 6.206-3.345 1.304-2.229 1.827-4.695 2.061-7.229.756-8.177-.861-16.064-3.005-23.87-2.196-7.996-5.304-15.654-8.865-23.136-.287-.602-.522-1.317-.491-1.965.057-1.179.987-2.018 2.15-2.2 1.022-.16 2.098.402 2.609 1.498 1.274 2.728 2.567 5.451 3.734 8.226 3.602 8.571 6.502 17.365 8.034 26.563 1.069 6.42 1.58 12.863.096 19.294a22.23 22.23 0 0 1-1.439 4.21c-2.527 5.524-7.651 8.02-13.588 6.722-4.827-1.057-8.901-3.579-12.702-6.592-6.991-5.541-12.663-12.297-17.793-19.535-5.848-8.245-10.787-17.013-14.925-26.234-.155-.343-.333-.676-.637-1.295zm-2.528-21.95l3.196 10.164c2.525-3.854 4.879-7.446 7.411-11.313l-10.607 1.149zm28.374 26.238c-4.017-.005-7.286-3.261-7.278-7.249.007-4.052 3.272-7.281 7.356-7.28 4.014.002 7.276 3.255 7.279 7.255.002 4.047-3.267 7.279-7.357 7.274z\"/></svg>"

/***/ }),

/***/ "../src/components/atom/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AtomOriginal = __webpack_require__("../src/components/atom/original/AtomOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AtomOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/babel/original/BabelOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BabelOriginal = __webpack_require__("../src/components/babel/original/BabelOriginal.svg");
	
	var _BabelOriginal2 = _interopRequireDefault(_BabelOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BabelOriginal */
	function BabelOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BabelOriginal',
	    svg: _BabelOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BabelOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BabelOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/babel/original/BabelOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"babel\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#f9dc3e}</style></defs><title>Artboard 3</title><g id=\"original\"><path d=\"M87.44 43.79v-.27H87v.27h.44zm2.94 7.08V51h.31a1.18 1.18 0 0 1 .09-.43v-.27c-.13 0-.26.21-.38.58zM78.9 59.79a14.06 14.06 0 0 0-2.35-3c0-.32.5-.79 1.59-1.42l3.11-2.71a7.79 7.79 0 0 0 1.23-4.31v-.46c-.12-1.38-1.12-2.49-3-3.34q-1.68-1.13-6-1.25A35.58 35.58 0 0 0 64 45.94a38.58 38.58 0 0 1-3.63 2.29v.23a.86.86 0 0 0 .36-.16.21.21 0 0 1 .26.21l.23-.12h.11v.1a12.78 12.78 0 0 1-2.53 2l.13.24h-.11l-.28-.1c0 .08-.11.14-.34.16v.1l.27.34a1 1 0 0 1-.39-.09 1.88 1.88 0 0 0-1.16.63l.16-.69a56.31 56.31 0 0 0 1.16-6.5v-.12a4.73 4.73 0 0 1-1.13-1.05 3.71 3.71 0 0 0 0-.49v-.1H57q-1.84 2.77-7.11 9.45-4 4.75-4.14 5.28c-1.09 1.13-1.61 1.81-1.56 2-.29.19-.41.37-.36.58a.12.12 0 0 1-.16-.09 3.17 3.17 0 0 1-2.08 1.45l-1 .22a.23.23 0 0 0-.19.28v.12l.36-.08v.1l-.82.32-1.45.34h-.76c-.11.11.61 0 .33.06l-1 .22c-.58.13-.89.08-1-.15h-.11a.55.55 0 0 1 0 .24l.12-.16-.76.18q-.08-.53-3.09-3.86c0-.43.67-1.05 2.12-1.86l4.08-3.59q1.37-1.76 1.63-5.65l-.05-.59c-.16-1.83-1.48-3.3-4-4.44-1.47-1-4.12-1.53-7.94-1.61A47.83 47.83 0 0 0 15.69 45a47.39 47.39 0 0 1-4.78 3v.32a1.25 1.25 0 0 0 .48-.19.27.27 0 0 1 .34.26l.32-.18h.16v.15a18.64 18.64 0 0 1-3.34 2.6l.18.28H8.9l-.34-.12c0 .09-.15.16-.48.19v.17l.37.41a1.36 1.36 0 0 1-.5-.1 3.17 3.17 0 0 0-2.13 1.57l.18.28a4.47 4.47 0 0 1 1.06-.85v.46a1.53 1.53 0 0 0-.48.19L7 54a12.62 12.62 0 0 1 2.43-2c.44.11.67.25.68.4h.34a26 26 0 0 1 7.14-3.86v.32q-.66 1-.89 1a1 1 0 0 0 .23.59q.06.6-3.21 8.1Q6.37 75.88 1.34 84.21a1.07 1.07 0 0 0 .2.45 4.16 4.16 0 0 0 1.57-.6h.18v.32h.31l.32-.18c0 .09.11.14.33.12v.32A2.83 2.83 0 0 1 3.77 86a7.36 7.36 0 0 0-1.08 2.4v.15H3a19.54 19.54 0 0 0 3.06-4.41 48.82 48.82 0 0 0 9-3.38 8.39 8.39 0 0 0 4.74-1.63v-.17l-.78.23h-.18v-.17a7.07 7.07 0 0 0 3.17-1q4.46-3.44 6.74-4.87 4.68-3.44 6.07-6.7l.52-.12a6.82 6.82 0 0 0 .75 0c0-.08 0-.13.1-.15.7-.07.36 0 .81-.06l1.17-.27c-.07 0-.1.06-.08.13l.18-.11h-.09.2l-.09.06a1.15 1.15 0 0 0 .43 0l.08.34-5.42 8.33-1.18 1.48-.58 1.92h.11l.58-.24-.19.75.06.22.16.2c-.07 0-.1.07-.08.15v.12l.24-.06q.53-.46.45-.84a2.21 2.21 0 0 0 .76.06v.12c-.23.06-.35.24-.37.56v.12h.13c1.94-2.12 6.69-9.35 10.5-14.27q-.18-.8 6-2.22h.13q.22 1-1 4.67a12.58 12.58 0 0 0-.71 2.44 18.72 18.72 0 0 0-.92 3.22l-1.45 4.76a43.48 43.48 0 0 0-2.16 7.71.94.94 0 0 1 .4 0l.2-.18a.12.12 0 0 0 .16.09l.01-.38h.63c.19 0 .34-.28.48-.71 0-.64.1-1 .39-1.06a10.28 10.28 0 0 1 .72-2.32 10.29 10.29 0 0 1 .81-2.6c.55-2 1-3 1.21-3.06l.06.24-.4 1a50.69 50.69 0 0 1-2.12 7.35l.21.89h.13q2.6-5.59 7.48-22.14a2.89 2.89 0 0 1 1.39-2.25l-.19-.2v-.1a1.27 1.27 0 0 0 .78-.44c0-.08-.34-.21-1-.37l1.62-7a2.4 2.4 0 0 1 .62-.48v.35a.86.86 0 0 0-.36.16l.31.44a10 10 0 0 1 1.83-1.57c.34.09.5.21.52.32h.24a19.75 19.75 0 0 1 5.43-2.91v.23q-.49.74-.67.75a1 1 0 0 0 .15.45 42.43 42.43 0 0 1-2.41 6.16 167.45 167.45 0 0 1-9.44 19.55.87.87 0 0 0 .17.34 3 3 0 0 0 1.18-.46h.11v.23h.26l.23-.12q0 .1.25.08V76a2.11 2.11 0 0 1-.4 1.06 5.31 5.31 0 0 0-.85 1.82V79h.24a14.72 14.72 0 0 0 2.32-3.35 37.54 37.54 0 0 0 6.8-2.56 6.39 6.39 0 0 0 3.62-1.24v-.12l-.61.18h-.13v-.12a5.36 5.36 0 0 0 2.4-.77c2.25-1.73 4-3 5.12-3.7 3.6-2.62 5.27-5.13 5.07-7.55zm-.61.16l.08.94c-.11.23-.23.35-.34.36l-.14-1.6c.26.09.39.19.4.3zM7.73 52.37h-.16v-.29l.62-.08v.15a1.24 1.24 0 0 0-.47.19zM4.59 83.78a2 2 0 0 0-1-.21v-.46c0-.18.08-.3.31-.34s.33.13.34.43a6.79 6.79 0 0 1 .89-1l.34.14c-.11.93-.4 1.41-.86 1.44zm33.55-35.1c-.16 0-.48-.48-.93-1.45v-.29c.3 0 .61.46.93 1.45v.29zm-.44-3.48l-.13.31-4.57-1.9q4.56.15 4.69 1.59zM18.46 61.72l-.64.06v-.29l.64-.06v.29zm-.52-9.92h.16v.46c-.15 0-.34.23-.59.66v-.32c.29-.34.44-.61.42-.79zM16.58 55l.06.61h-.16l-.06-.61zm-.71 1.14h.31c0 .5-.17.77-.42.79h-.16a1.46 1.46 0 0 0 .27-.77zm-.53 1.58h.18v.15l-.29.48h-.31v-.15a.4.4 0 0 0 .42-.49zm-.52 1.43l-.09.76h-.16l-.07-.75h.32zM9.59 74c-.21 1-.43 1.57-.66 1.59v-.15A1.67 1.67 0 0 1 9.59 74zm-1 2.08v.15a.27.27 0 0 1-.28.34v-.15q0-.27.28-.34zm-.28 4.31h.48v.17a1.25 1.25 0 0 0-.48.19H8c0-.16.08-.28.28-.34zm13.79-4.26a25.55 25.55 0 0 0-4.8 2.73q-4.37 1.53-4.3 1.91A48.06 48.06 0 0 0 7.8 83a1.86 1.86 0 0 1-.85-.22 1.37 1.37 0 0 1 .71-1.3 2.75 2.75 0 0 1 1.31.2 12.79 12.79 0 0 1 2.53-.83v-.32l-1 .08a13.15 13.15 0 0 1 2.8-1.31h.48v.15c-.83.07-1.29.32-1.39.75 0 .2.13.28.34.26.62-.39.93-.62.92-.69q1.78-.34 9.81-5.13v.29c0 .14-.45.53-1.37 1.2zm-8.22 2.7a3.17 3.17 0 0 0 2-.93c.22 0 .34.07.35.26a7.16 7.16 0 0 0-2.19 1h-.16v-.31zm13.31-10.19l-4.11 3.26a42 42 0 0 1-4.93 3q-7.3 4-9.07 4.17H8.9q.22-.82 6.5-13.31a35.45 35.45 0 0 0 8.71-2.58l1-.08a5.59 5.59 0 0 1 4.49 1.15l.06.61q-1.12 3.21-2.45 3.76zm-8-4.52l.66-.06v.15l-.66.06v-.15zm9.29-1.57h.48c.45.21.68.4.7.57v.15a1.36 1.36 0 0 1-1.19-.67zm1.31-7.48a19 19 0 0 1-3.52 2.62c-.63.06-3 1-7.07 2.76a1.29 1.29 0 0 0-.65-.11v-.29a3.81 3.81 0 0 1 .79-2.22c.32-1.68.66-2.64 1-2.87l3.4-7.65q-.06-.71 2.18-1.09h.48v.44c1.46-.22 2.38-.35 2.73-.38 2.7-.23 4.11.32 4.22 1.63h.31l-.07-.77L34 47a2.12 2.12 0 0 1 1.28 1.59 2.48 2.48 0 0 1-.69 1.59c-.2 0-.33-.13-.34-.43h-.34l-.07.93q-2.05 3.07-3 3.16c-.56.77-.9 1.16-1 1.16zm2.09 5.36a1.2 1.2 0 0 0-.67-.26v-.46h.31l.68.4a.27.27 0 0 1-.28.34zM34 63c.3.12.48.25.51.37h-.24l-.22.18L34 63zm.21 1.29v-.12l.39-.09v.12l-.39.09zm.94 1.05c.4-.07.6-.09 1.34-.26v.12l-1.42.33a1.8 1.8 0 0 0 0-.19zm1.38.59a6.06 6.06 0 0 0-1.42.2v-.12l1.18-.38.57-.13.06.22c-.25.06-.07.06-.36.21zm1.26-.3a.26.26 0 0 1-.32-.19l.36-.08a.22.22 0 0 1 .3.19l-.34.08zm3.41-3.67v-.12l.59-.14.06.22h-.62zm3.64 22.34a.92.92 0 0 0 0-.37h.13a.21.21 0 0 1 .29.17v.12l-.48.11zm2.56-21.39h-.26a7.4 7.4 0 0 1-1.06.35l-.24.06a.24.24 0 0 1-.31-.17l1.71-.39.56-.26.19.21a1.24 1.24 0 0 0-.58.24zm1.31-.42v-.12a.71.71 0 0 0 .32-.21l1.21-.28V62a9.37 9.37 0 0 0-1.53.48zM48.9 60a1 1 0 0 0-.34.21c0-.08-.19-.08-.5 0-.06-.23.84-.56 2.69-1l.26-.06.06.22c-1.3.38-2 .6-2.17.62zm3.26-3.52C52 58 51.51 58.83 50.58 59v-.12l-.82.32-.36.08a.92.92 0 0 1-.5 0l-.11-.28a49.26 49.26 0 0 1 3.56-4.91h.28a5.09 5.09 0 0 1-.48 2.39zm5.77-4.94h-.11v-.23h.48v.12a1.57 1.57 0 0 0-.36.15zm-2.38 23.9a1.5 1.5 0 0 0-.75-.17v-.35q0-.18.22-.25c.16 0 .25.09.27.34a4.08 4.08 0 0 1 .67-.77l.25.1c-.09.71-.31 1.08-.64 1.11zM81 48.79c-.12 0-.35-.36-.72-1.12v-.23c.23 0 .48.34.72 1.09v.26zm-.34-2.66l-.11.24-3.45-1.44c2.3.07 3.49.48 3.56 1.2zM66.07 58.67h-.48v-.23h.48v.22zm-.4-7.54h.13v.35q-.18 0-.45.5v-.23a1.08 1.08 0 0 0 .31-.62zm-1 2.42v.46h-.13v-.46zm-.55.87h.24q0 .59-.31.62h-.13a1.26 1.26 0 0 0 .2-.61zm-.39 1.19h.11v.12l-.21.37h-.24V56c.25 0 .36-.15.34-.38zm-.39 1.08l-.08.6h-.11v-.59h.24zm-4 11.3q-.24 1.17-.5 1.2v-.1a1.33 1.33 0 0 1 .51-1.1zm-.74 1.57v.1a.21.21 0 0 1-.22.27v-.12q0-.18.22-.25zm-.21 3.28h.37v.12a1.07 1.07 0 0 0-.36.14h-.24q0-.2.22-.25zm10.46-3.23a21.75 21.75 0 0 0-3.65 2.06c-2.24.78-3.34 1.27-3.33 1.46A35.34 35.34 0 0 0 58 74.87a1.45 1.45 0 0 1-.64-.18 1 1 0 0 1 .54-1 2.1 2.1 0 0 1 1 .15 10.82 10.82 0 0 1 1.93-.62v-.23l-.76.06a10 10 0 0 1 2.14-1h.37v.1c-.63.06-1 .24-1.06.58a.21.21 0 0 0 .26.21c.47-.31.69-.48.69-.54q1.34-.24 7.44-3.9v.23c0 .1-.34.4-1 .91zm-6.24 2a2.5 2.5 0 0 0 1.55-.7.21.21 0 0 1 .26.21 5.93 5.93 0 0 0-1.66.71h-.13v-.22zm10.09-7.68l-3.1 2.5a30.14 30.14 0 0 1-3.77 2.3q-5.53 3-6.89 3.16h-.13q.17-.63 4.95-10.1a27.26 27.26 0 0 0 6.61-2l.75-.07a4.2 4.2 0 0 1 3.4.89v.46c-.57 1.6-1.18 2.54-1.85 2.83zm-6.09-3.43h.48v.12h-.48v-.12zm7.05-1.2h.37c.34.17.52.32.53.44v.1a1 1 0 0 1-.91-.51zm1-5.67a14.26 14.26 0 0 1-2.66 2 35.65 35.65 0 0 0-5.37 2.08 1.22 1.22 0 0 0-.49-.07v-.23a2.93 2.93 0 0 1 .59-1.69c.24-1.29.51-2 .79-2.17l2.6-5.81c0-.34.52-.62 1.64-.84h.37v.35q1.65-.27 2.07-.31c2-.18 3.12.23 3.21 1.24h.24v-.56h.24a1.55 1.55 0 0 1 1 1.18 1.93 1.93 0 0 1-.6 1.2c-.16 0-.25-.09-.27-.34h-.24l-.07.7c-1 1.57-1.79 2.39-2.26 2.42-.42.57-.68.86-.8.87zm1.09 3.88v-.35h.24l.52.32a.22.22 0 0 1-.22.25 1 1 0 0 0-.51-.2zM32.36 80.13l-.24.06-.21.18a.21.21 0 0 0 .29.17c.16 0 .22-.13.19-.28v-.12zm-.92-1.84v.12c.16 0 .22-.13.19-.28v-.12a.22.22 0 0 0-.19.28zM38 62.69l.28-.07-.06-.24-.28.07.06.24zm84.55 7.1a15.73 15.73 0 0 1-3.78.57v.23h.4l.31-.12c2.8-.31 3.13-.2 3.1-.51v-.11zm-15.25 2v.23-.23zm-1.75-6.14l-.25-.08a4.21 4.21 0 0 0-.3 1v.1c.2 0 .37-.34.54-1zm17.58 4.07v.23l.41.07v-.23l-.41-.07zm-19.29 2.38l-.63-.07-.11.24v.12l3.77-.32v-.23l-3 .26zm-1.71-8.26v-.12H102l-.23.15.13.22c.18 0 .26-.1.24-.26zM124.91 68h.18c.1 0 .15-.09.14-.24l-.1-.22a3 3 0 0 0-1.46.37v-.11l-.77.07c0-.23-.08-.35-.19-.34h-.4c-.47 0-.69 0-.92.2 0-.08 0-.12-.08-.12h-.45l-.26.15c0-.08 0-.12-.08-.12l-.16.14v-.12h-.77v.23l.32.08h.3a.54.54 0 0 0 .34.07l.26-.13V68a19.08 19.08 0 0 1-2.46.47.42.42 0 0 0-.25-.1.2.2 0 0 1-.19-.21l.52-.07a3.26 3.26 0 0 0 .35.09c.42-.21.44-.29.66-.31v-.23a15.16 15.16 0 0 1-2.66.25h-.08v-.23c2.31-.28 1.54-.12 2.33-.34 0 .08 0 .12.08.12a.54.54 0 0 1 .32-.16h.16a8.46 8.46 0 0 0 2.68-.35v.1l.26-.13h.24c0-.23.34-.27.46-.28v-.25c-2.81.57-3.55.41-4.33.63v-.1a3.41 3.41 0 0 1-1 .08.49.49 0 0 0-.23.15c0-.08 0-.12-.09-.12l-2.39.39c0-.07 0-.1-.09-.09a12.17 12.17 0 0 1-2.56.46.78.78 0 0 0-.31.13c0-.07 0-.1-.13-.09l-1 .08-.68.17c0-.07 0-.1-.13-.09a5.43 5.43 0 0 1-1 .19c-.17 0 .08 0 0-.1l-.21.12h-1.16c-1.8.22-1.6.25-1.8.26h-.67a.09.09 0 0 1-.1.11c-.76-.1-1.16-.22-1.16-.36q.15-1.09.53-1.12h.13l-.11.24h.13c.24-.13.35-.25.34-.36v-.25h-.24v-.23a.84.84 0 0 1 .07-.47l.55-.89v.23h.26v-.23l-.15-.21a1 1 0 0 1 .47-.27v-.12h-.35v-.35a10 10 0 0 0 1-2.57l.25.1c.16 0 .23-.1.22-.27h-.24v-.1a.89.89 0 0 1 .09-.49 1.56 1.56 0 0 0 .52-1.22c.07 0 .11 0 .12.11.33-.19.58-.68.76-1.5a46.85 46.85 0 0 0 2.27-6.22c2-5.52 2-6.1 2.25-7.41h-.24a.84.84 0 0 1-.09.48 1 1 0 0 0-.39-.09v-.1a2.83 2.83 0 0 1 .61-1.71h.05l.21.8h.24a7.33 7.33 0 0 1 .19-1c0-.12-.1-.2-.29-.21l-.23.15v-1.3H113a.91.91 0 0 1-.32-.51l-1.33.13a1.23 1.23 0 0 0-.15-.41c0-.12.29-.24.9-.36l.27.1.25-.15c0 .08.06.12.15.11l.25-.15c0 .08.06.12.15.11h.12v-.27h-1.46l-.25.17v-.18q-9.38.77-10.65.89h-1.32c0 .1-.08.16-.27.18l-.27-.12-.91.23a6.08 6.08 0 0 1-1.08 0 .93.93 0 0 1-.51.2l2.67-.17a1.22 1.22 0 0 1-.65.21.9.9 0 0 1-.53-.09 15.14 15.14 0 0 1-2 .47l-.27-.1-4.36.67a1.09 1.09 0 0 0-.59-.09 7.26 7.26 0 0 0-1.16.25l-2.11.88.16.26a1.16 1.16 0 0 0 .43-.17l.75.07-.09.7a1.88 1.88 0 0 0-1.2 1.34c-1 .46-1.55.78-1.55 1v.12h.16l.28-.15.33.39v.54q0 .25-5.21 11c-3 6.9-4.6 10.67-4.75 11.35-1 .29-1.63.71-1.81 1.27 0 .18.33.3.92.34v.27l-.27.45v.54q0 .42 2.26.64c0-.09 0-.15.14-.16a8.14 8.14 0 0 1-.28 2H78a3.47 3.47 0 0 0 1-1.92h.13c.15 0 .31.16.49.52q-.28.11-2 4.45l.16.26H78q2.05-5.2 2.58-5.75 2.7-.24 9.33-1l.28-.17a.13.13 0 0 0 .17.13h.29l.28-.17a.13.13 0 0 0 .17.13l3.35-.29c.89-.07 1.3-.34 1.27-.8 0-.12.51-.26 1.57-.41a1.28 1.28 0 0 1 .46.08c0-.08.52-.17 1.58-.26 0-.56.21-.86.52-.89v-.27a4.63 4.63 0 0 0-1 .23 6.27 6.27 0 0 1-1.33-.16 1.23 1.23 0 0 1-.43.17l-2.33.07-.28.15q0-.13-.17-.11h-.13l-.3.15c0-.08-.25-.15-.74-.21l-.3.18h-.58v-.15q4.5-.49 4.44-1.22a.26.26 0 0 1 .32.27l.88-.22v-.27l-7.18.2c0 .09 0 .15-.14.16l-.88-.07a1.06 1.06 0 0 0-.56.2l-.33-.12a10 10 0 0 0-2 .33 12.73 12.73 0 0 0-2 0l-1.61.14-.75-.08c0-.48.89-2.81 2.79-7a6.11 6.11 0 0 1 1.54-2.64 1.08 1.08 0 0 1 .46.11l1.15-.39.59.09a13.45 13.45 0 0 0 3.45-.85 1.61 1.61 0 0 1 .75.07l.88-.21 2.61-.22a17.3 17.3 0 0 0 3.62-.74v-.27c-.48 0-.74 0-.75-.23 0-.36-.38-.51-1.06-.46v-.27l.72-.21 1.88-.16v-.27h-1.16v-.29l.73-.07c.2 0 .28-.11.26-.3-1 0-1.47 0-1.48-.15q-10.23.5-10.26.19a1.17 1.17 0 0 0-.43.19l-.18-.28q2.71-5.76 3.18-5.8a1.61 1.61 0 0 1-.23.72v.12h.29c.72-1.71 1.32-2.6 1.83-2.64 2.14-.19-.3-.33 4.29-1a.9.9 0 0 0 .41.11q2.7-.54 7.52-1.14v-.27l-1.71.16v-.27a.93.93 0 0 0 .51-.2v.15a1 1 0 0 0 .39-.19 1.22 1.22 0 0 1 .68.08 9.92 9.92 0 0 1 1.43-.29l1.07-.1c.26-.17.38-.32.37-.46v-.12a3.38 3.38 0 0 1-.94-.06.27.27 0 0 1 .24-.3l2-.19.91-.23c0 .1.06.14.13.14a1 1 0 0 0 .39-.19h.15a7.42 7.42 0 0 0-.4 1.09h-.26a1.14 1.14 0 0 0-.15-.48h-.13c-2.42 6.75-3.5 9.89-5.74 15.07-.41 1.32-.75 2.06-1.05 2.22a.21.21 0 0 0 .26.21 3.25 3.25 0 0 1-.46 1.93c-1 3-1.72 4.61-2.08 4.91l.23 1.41a.22.22 0 0 1-.22.25h-.24c0-.39-.18-.58-.43-.55h-.13a5.54 5.54 0 0 0-.72 1.72h.24a.81.81 0 0 0 .45-.75h.48l.28.1a1.5 1.5 0 0 0-.31.85l.13.22-.32.75v.12a1.51 1.51 0 0 1 .91.26 1.63 1.63 0 0 0 .74-.3h3.12l.9-.31a21 21 0 0 0 1.93-.08h.39l.21-.14v.12a6.11 6.11 0 0 1 1.9.02v.12h-.55v.23a.79.79 0 0 0 .44-.17c.14 0 .22.07.23.23a3.28 3.28 0 0 0-.75.17l-.24-.08c-.38.1-.3.13-.56.15l-.38-.07a.09.09 0 0 1-.09.11.2.2 0 0 0 .23.21h.39l2-.18.77-.17c0 .07 0 .1.1.09l.37-.14.7-.06c.54 0 .53-.08 1.7-.27 0-.07 0-.1.07-.11v.1a17.2 17.2 0 0 0 2.34-.45v.06c.48-.11.21-.08.34-.18 0 .08 0 .12.08.12h.34v-.25h-.84a3.59 3.59 0 0 1-.76.06l-1.71.09v-.12l1-.13h.34l.2-.14v.12c1.34-.11 1.82.22 8-1.1.34 0 .31-.31.52-.89a.58.58 0 0 1-.33-.07 9.7 9.7 0 0 1-1.77.26c-.08 0-.15-.07-.18-.21v-.1h1a2.4 2.4 0 0 0 1-.34c0 .08-.19.13-.07.12zM79 68.77h-.44a8.27 8.27 0 0 1 .7-2h.29a7.62 7.62 0 0 1-.55 2zm.53-2.12v-.12c0-.15.08-.25.29-.3v.12c0 .18-.08.28-.29.3zm5.82 4.5v.12l-.73.07v-.12l.73-.07zm-.88-.07c0 .15-.21.32-.7.48l-.89-.07h-.29v-.27l1.91-.18zM90.4 44H90v-.15c0-.15.07-.25.26-.3h.16l.3.12a.26.26 0 0 1-.27.3zm6.66-1.3h.14v.27h-.4a.27.27 0 0 1 .24-.3zm-1.68.59l-.66-.07V43a7.16 7.16 0 0 0 1.69-.32c0 .1.1.14.27.12v.27h-.26a.9.9 0 0 1-.53-.09 1.14 1.14 0 0 1-.51.19zm.83 2.41v-.12l1.07-.1v.12l-1.07.1zm1.15-.93v-.15h.52v.15h-.52zm.12-1.83h-.14l.12-.29 1.19-.11v.15a7.18 7.18 0 0 0-1.18.24zm.61 2.57v-.27h.52q.27 0 .28.25l-.78.07zm3.16-4.3l-.67.19h-.12a6.85 6.85 0 0 1-1.21 0c.87-.06 1.7-.12 2-.17zm-.72 3v.12l-.92.08v-.12l.92-.08zm1.51.72c0-.11-.19-.19-.55-.22l-.92.26h-.71c-.16-.11-.24-.19-.25-.24h.82l1.84-.3h.94v.15a5.29 5.29 0 0 0-1.18.24zm9.49-2.45h.21a3.58 3.58 0 0 1 1.11-.75 6.55 6.55 0 0 1-1.57 3.27l-.52-.32a17.07 17.07 0 0 0 .77-2.22zm-1.6 2.75h.13c-.18.34-.34.51-.47.52v-.35a.8.8 0 0 0 .36-.16zm-1 2.47a3.5 3.5 0 0 1 .72-1.72V46c-.13.93-.34 1.43-.61 1.46v.59a1.32 1.32 0 0 0-.32.75h-.13l-.07-.81c.15 0 .27-.15.35-.39zm-.4 1.34a3.4 3.4 0 0 1-.27 1h-.13v-.35c.18-.41.33-.62.43-.62zM101 70.8v-.1h.24v.35c-.13 0-.22-.07-.26-.23zm10.74.28c0-.08 0-.12-.13-.11L111 71v-.1l1.43-.12v.12a1.26 1.26 0 0 0-.75.18zm-.72-.3c.06 0 0 .06 0 .07s-.07 0 0-.07zm.07-1.68l-.8.07V69h.71l.63-.16c0 .07 0 .1.13.09.75-.13.68-.17 1-.2.12 0 .2.07.21.21l-1.93.17zm2.8-.24a3.19 3.19 0 0 0-.79-.06v-.1l.72-.07v.1c-.07 0 .2 0 .07.12zm.06-.13v-.1h.39v.1h-.39zm.87-.07v-.1a.68.68 0 0 0 .28-.15.28.28 0 0 1 .32.26zm1.11-.14v-.12h.48v.12h-.48zm.66-.06c0-.14 0-.22.17-.24l.16.21a.09.09 0 0 1 .07-.11l.12.22-.52-.07zm-7 3v-.23h-.07v.23zm16.37-4.24c.07 0 .11-.09-.07-.12s.09.12-.09.13v.08l.1-.07-.1.08-.2.25.39-.14v-.23zm.68.53h-.07v.23h.55c0-.15-.37-.2-.49-.2zm-.85-.41z\"/><path class=\"cls-1\" d=\"M90 50.13v.15h.31a1.18 1.18 0 0 1 .09-.43v-.27c-.13 0-.26.21-.38.58zM87 43v-.27h-.44V43H87zm-8.52 16a14.07 14.07 0 0 0-2.35-3c0-.32.5-.79 1.59-1.42L80.84 52a7.79 7.79 0 0 0 1.23-4.31v-.46c-.12-1.38-1.12-2.49-3-3.34q-1.68-1.13-6-1.25a35.58 35.58 0 0 0-9.41 2.58 38.64 38.64 0 0 1-3.63 2.29v.23a.87.87 0 0 0 .36-.16.21.21 0 0 1 .26.21l.23-.12h.11v.1a12.79 12.79 0 0 1-2.52 2l.13.24h-.11l-.28-.1c0 .08-.11.14-.34.16v.1l.27.34a1 1 0 0 1-.39-.09 1.88 1.88 0 0 0-1.16.63l.16-.69a56.27 56.27 0 0 0 1.16-6.5v-.12a4.73 4.73 0 0 1-1.13-1.05 3.71 3.71 0 0 0 0-.49v-.1h-.11q-1.85 2.77-7.11 9.45-4 4.75-4.14 5.28c-1.09 1.13-1.61 1.81-1.56 2-.29.19-.41.37-.36.58a.12.12 0 0 1-.16-.09 3.17 3.17 0 0 1-2.08 1.45l-1 .22a.23.23 0 0 0-.19.28v.12l.36-.08v.1l-.82.32-1.45.34h-.76c-.11.11.61 0 .33.06l-1 .22c-.58.13-.89.08-1-.15h-.11a.54.54 0 0 1 0 .24l-.06-.23-.76.18q-.08-.53-3.09-3.86c0-.43.67-1.05 2.12-1.86L38 53.14q1.37-1.76 1.63-5.65l-.06-.61c-.16-1.83-1.48-3.3-4-4.44-1.47-1-4.12-1.53-7.94-1.61a47.82 47.82 0 0 0-12.36 3.37 47.39 47.39 0 0 1-4.78 3v.32a1.25 1.25 0 0 0 .48-.19.27.27 0 0 1 .34.26l.32-.18h.16v.15a18.64 18.64 0 0 1-3.34 2.6l.18.28h-.14l-.34-.12c0 .09-.15.16-.48.19v.17l.37.41a1.36 1.36 0 0 1-.5-.1 3.17 3.17 0 0 0-2.13 1.57l.18.28A4.47 4.47 0 0 1 6.66 52v.46a1.53 1.53 0 0 0-.48.19l.38.58a12.63 12.63 0 0 1 2.43-2c.44.11.67.25.68.4h.34a26 26 0 0 1 7.14-3.86v.32q-.66 1-.89 1a1 1 0 0 0 .23.59q.06.6-3.21 8.1Q6 75.13.92 83.47a1.08 1.08 0 0 0 .2.45 4.17 4.17 0 0 0 1.57-.6h.18v.32h.31l.32-.18c0 .09.11.14.33.12v.32a2.83 2.83 0 0 1-.52 1.42 7.37 7.37 0 0 0-1.08 2.4v.15h.31a19.55 19.55 0 0 0 3.06-4.41 48.85 48.85 0 0 0 9-3.38 8.39 8.39 0 0 0 4.74-1.63v-.17l-.78.23h-.18v-.17a7.07 7.07 0 0 0 3.17-1q4.46-3.44 6.74-4.87 4.68-3.44 6.08-6.7l.52-.12a6.81 6.81 0 0 0 .75 0c0-.08 0-.13.1-.15.7-.07.36 0 .81-.06l1.14-.44h.2l-.09.06a1.14 1.14 0 0 0 .43 0l.08.34L33 73.85l-1.18 1.48-.58 1.94h.11l.58-.24-.19.75.06.22.16.2c-.07 0-.1.07-.08.15v.12l.24-.06q.53-.46.45-.84a2.21 2.21 0 0 0 .76.06v.12c-.23.06-.35.24-.37.56v.12h.13c1.94-2.12 6.69-9.35 10.5-14.27q-.18-.8 6-2.22h.13q.22 1-1 4.67a12.58 12.58 0 0 0-.65 2.39 18.69 18.69 0 0 0-.92 3.22L45.69 77a43.46 43.46 0 0 0-2.16 7.71 1 1 0 0 1 .4 0l.21-.18a.12.12 0 0 0 .16.09l-.08-.34h.63c.19 0 .34-.28.48-.71 0-.64.1-1 .39-1.06a10.29 10.29 0 0 1 .72-2.32 10.29 10.29 0 0 1 .81-2.6c.55-2 1-3 1.21-3.06l.06.24-.4 1A50.68 50.68 0 0 1 46 83.14l.21.89h.13q2.6-5.59 7.48-22.14a2.89 2.89 0 0 1 1.39-2.25l-.19-.2v-.1a1.27 1.27 0 0 0 .78-.44c0-.08-.34-.21-1-.37l1.62-7a2.41 2.41 0 0 1 .62-.48v.35a.87.87 0 0 0-.36.16L57 52a10 10 0 0 1 1.83-1.57c.34.09.5.21.52.32h.24a19.75 19.75 0 0 1 5.41-2.9v.23q-.49.74-.67.75a1 1 0 0 0 .15.45 42.49 42.49 0 0 1-2.41 6.16A167.41 167.41 0 0 1 52.66 75a.87.87 0 0 0 .17.34 3 3 0 0 0 1.17-.46h.11v.23h.26l.23-.12q0 .1.25.08v.25a2.12 2.12 0 0 1-.4 1.06 5.31 5.31 0 0 0-.85 1.82v.12h.24a14.72 14.72 0 0 0 2.32-3.35A37.55 37.55 0 0 0 63 72.36a6.39 6.39 0 0 0 3.62-1.24V71l-.61.18h-.11v-.12a5.36 5.36 0 0 0 2.4-.77c2.25-1.73 4-3 5.12-3.7C77 64 78.68 61.46 78.48 59zm-.62.16l.08.94c-.11.23-.23.35-.34.36l-.14-1.6c.26.09.39.19.4.3zM7.31 51.62h-.16v-.29l.64-.06v.15a1.24 1.24 0 0 0-.47.19zM4.17 83a2 2 0 0 0-1-.21v-.46c0-.18.08-.3.31-.34s.33.13.34.43a6.78 6.78 0 0 1 .89-1l.34.14c-.11.93-.4 1.41-.86 1.44zm33.55-35.1c-.16 0-.48-.48-.93-1.45v-.29c.3 0 .61.46.93 1.45v.29zm-.45-3.48l-.13.31-4.56-1.9q4.56.15 4.69 1.59zM18 61l-.64.06v-.29l.64-.06V61zm-.52-9.92h.16v.46c-.15 0-.34.23-.59.66v-.32c.29-.34.44-.61.42-.79zm-1.35 3.19l.06.61h-.16l-.03-.63zm-.71 1.14h.31c0 .5-.17.77-.42.79h-.16a1.46 1.46 0 0 0 .27-.77zm-.5 1.59h.18v.15l-.29.48h-.31v-.15a.4.4 0 0 0 .42-.49zm-.52 1.43l-.09.76h-.16l-.07-.75h.32zM9.17 73.25c-.21 1-.43 1.57-.66 1.59v-.15a1.67 1.67 0 0 1 .67-1.44zm-1 2.08v.15a.27.27 0 0 1-.28.34v-.15q0-.27.28-.34zm-.28 4.31h.48v.17a1.25 1.25 0 0 0-.48.19h-.31c0-.16.08-.28.28-.34zm13.79-4.26a25.56 25.56 0 0 0-4.8 2.73q-4.37 1.54-4.33 1.89a48 48 0 0 0-5.17 2.3 1.86 1.86 0 0 1-.85-.22 1.37 1.37 0 0 1 .71-1.3 2.75 2.75 0 0 1 1.31.22 12.78 12.78 0 0 1 2.53-.83v-.32l-1 .08a13.17 13.17 0 0 1 2.8-1.31h.48v.15c-.83.07-1.29.32-1.39.75 0 .2.13.28.34.26.62-.39.93-.62.92-.69q1.77-.34 9.81-5.13v.29c0 .14-.45.53-1.37 1.2zm-8.22 2.7a3.17 3.17 0 0 0 2-.93c.22 0 .34.07.35.26a7.17 7.17 0 0 0-2.19 1h-.16v-.31zM26.77 67.9l-4.11 3.26a40.68 40.68 0 0 1-4.94 3q-7.3 4-9.07 4.17h-.18q.22-.82 6.5-13.31a35.47 35.47 0 0 0 8.71-2.58l1-.08a5.59 5.59 0 0 1 4.49 1.15l.06.61c-.74 2.13-1.56 3.38-2.44 3.75zm-8-4.52l.66-.06v.15l-.66.06v-.15zM28 61.81h.48c.45.21.68.4.7.57v.15a1.36 1.36 0 0 1-1.18-.72zm1.31-7.48a19 19 0 0 1-3.52 2.62c-.63.06-3 1-7.07 2.76a1.29 1.29 0 0 0-.65-.11v-.29a3.81 3.81 0 0 1 .79-2.22c.32-1.68.66-2.64 1-2.87l3.4-7.65q-.06-.71 2.18-1.09h.48v.44c1.46-.22 2.38-.35 2.73-.38 2.7-.23 4.11.32 4.22 1.63h.31l-.07-.77h.34a2.12 2.12 0 0 1 1.28 1.59 2.48 2.48 0 0 1-.69 1.59c-.21 0-.33-.13-.34-.43h-.34l-.07.93q-2.05 3.07-3 3.16c-.56.77-.9 1.16-1 1.16zm2.09 5.36a1.2 1.2 0 0 0-.67-.26v-.46h.31l.68.4a.27.27 0 0 1-.28.34zm2.16 2.56c.3.12.48.25.51.37h-.24l-.22.18-.06-.62zm.2 1.29v-.12l.39-.09v.12l-.39.09zm.94 1.05c.4-.07.6-.09 1.34-.26v.12l-1.42.33a1.87 1.87 0 0 0 0-.19zm1.38.59a6.06 6.06 0 0 0-1.42.2v-.12l1.19-.38.57-.13.06.22c-.26.06-.07.06-.37.21zm1.26-.3a.26.26 0 0 1-.32-.19l.36-.08a.22.22 0 0 1 .3.19l-.34.08zm3.41-3.67v-.12l.59-.14.06.22h-.62zm3.64 22.34a.92.92 0 0 0 0-.37h.13a.21.21 0 0 1 .29.17v.12l-.48.11zM47 62.16h-.26a7.38 7.38 0 0 1-1.06.35l-.24.06a.24.24 0 0 1-.31-.17l1.68-.4.56-.26.19.21a1.25 1.25 0 0 0-.58.24zm1.31-.42v-.12a.71.71 0 0 0 .32-.21l1.21-.28v.12a9.36 9.36 0 0 0-1.53.48zm.19-2.45a1 1 0 0 0-.34.21c0-.08-.19-.08-.5 0-.06-.23.84-.56 2.69-1l.26-.06.06.22c-1.3.38-2 .6-2.17.62zm3.26-3.52c-.13 1.48-.65 2.32-1.57 2.53v-.12l-.82.32-.36.08a.91.91 0 0 1-.5 0l-.07-.33A49.32 49.32 0 0 1 52 53.34h.28a5.09 5.09 0 0 1-.48 2.39zm5.77-4.94h-.11v-.23h.48v.12a1.57 1.57 0 0 0-.36.15zm-2.4 23.86a1.49 1.49 0 0 0-.75-.17v-.35q0-.18.22-.25c.16 0 .25.09.27.34a4.09 4.09 0 0 1 .67-.77l.25.1c-.09.71-.31 1.08-.64 1.11zM80.6 48c-.12 0-.35-.36-.72-1.12v-.23c.23 0 .48.34.72 1.09V48zm-.34-2.66l-.11.24-3.45-1.44c2.3.07 3.49.48 3.56 1.2zM65.65 57.93h-.48v-.23h.48v.23zm-.4-7.54h.13v.35q-.18 0-.45.5v-.23a1.08 1.08 0 0 0 .31-.62zm-1 2.42v.46h-.13v-.46zm-.55.87h.24q0 .59-.31.61h-.13a1.26 1.26 0 0 0 .2-.61zm-.39 1.19h.11V55l-.21.37h-.24v-.12c.25 0 .36-.15.34-.38zM62.9 56l-.08.6h-.12v-.59h.24zm-4 11.3q-.24 1.17-.5 1.2v-.1a1.33 1.33 0 0 1 .51-1.1zm-.74 1.57v.1a.21.21 0 0 1-.22.27v-.12q0-.18.22-.25zM58 72.11h.37v.12a1.07 1.07 0 0 0-.36.14h-.24q0-.2.22-.25zm10.46-3.23a21.75 21.75 0 0 0-3.65 2.06c-2.24.78-3.34 1.27-3.33 1.46a35.33 35.33 0 0 0-3.9 1.72 1.45 1.45 0 0 1-.64-.18 1 1 0 0 1 .54-1 2.1 2.1 0 0 1 1 .15 10.83 10.83 0 0 1 1.93-.62v-.23l-.75.07a10 10 0 0 1 2.14-1h.37v.1c-.63.06-1 .24-1.06.58a.21.21 0 0 0 .26.21c.47-.31.69-.48.69-.54q1.34-.24 7.44-3.9v.23c0 .09-.34.39-1 .9zm-6.24 2a2.5 2.5 0 0 0 1.55-.7c.16 0 .25.06.26.21a5.92 5.92 0 0 0-1.66.71h-.13v-.22zm10.08-7.74l-3.1 2.5A30.16 30.16 0 0 1 65.41 68q-5.53 3-6.89 3.16h-.13q.17-.63 4.95-10.1a27.26 27.26 0 0 0 6.61-2l.75-.06a4.2 4.2 0 0 1 3.4.89v.46c-.53 1.65-1.1 2.55-1.82 2.83zm-6.09-3.43h.48v.12h-.48v-.12zm7.05-1.2h.37c.34.17.52.32.53.44v.1a1 1 0 0 1-.91-.51zm1-5.67a14.26 14.26 0 0 1-2.66 2A35.66 35.66 0 0 0 66.2 57a1.23 1.23 0 0 0-.49-.07v-.23a2.92 2.92 0 0 1 .56-1.7c.24-1.29.51-2 .79-2.17L69.67 47c0-.34.52-.62 1.64-.84h.37v.35q1.65-.27 2.07-.31c2-.18 3.12.23 3.21 1.24h.24v-.56h.24a1.55 1.55 0 0 1 1 1.18 1.93 1.93 0 0 1-.49 1.22c-.16 0-.25-.09-.27-.34h-.24l-.07.7C76.25 51.16 75.5 52 75 52c-.42.57-.68.86-.8.87zm1.09 3.88v-.35h.24l.52.32a.22.22 0 0 1-.22.25 1 1 0 0 0-.51-.2zM31.94 79.39l-.24.06-.21.18a.21.21 0 0 0 .29.17c.16 0 .22-.13.19-.28v-.12zM31 77.55v.12c.16 0 .22-.13.19-.28v-.12a.22.22 0 0 0-.19.28zm6.6-12.39l.18-.11h-.09a.11.11 0 0 0-.08.13zm0-3.21l.28-.07-.06-.24-.28.07.06.24zm65.85 9.41l-.63-.07-.11.24v.12l3.77-.32v-.23l-3 .26zm3.45-.29v.23-.23zM122.7 69v.23l.41.07v-.23l-.41-.07zm-.58 0a15.72 15.72 0 0 1-3.78.57v.23h.4l.31-.12c2.8-.31 3.13-.2 3.1-.51V69zm-17-4.12l-.25-.08a4.2 4.2 0 0 0-.3 1v.1c.2 0 .37-.34.54-1zm-3.41-1.84V63h-.13l-.23.15.13.22c.18 0 .26-.1.24-.26zm7.41 7.66v-.23H109v.23zm15.37-3.47h.18c.1 0 .15-.09.14-.24l-.1-.22a3 3 0 0 0-1.46.37v-.12l-.77.07c0-.23-.08-.35-.19-.34h-.4c-.47 0-.69 0-.92.2 0-.08 0-.12-.08-.12h-.45l-.26.15c0-.08 0-.12-.08-.12l-.16.14h-.77v.23l.32.08h.3a.54.54 0 0 0 .34.07l.26-.13v.1a19.08 19.08 0 0 1-2.46.47.43.43 0 0 0-.25-.1.2.2 0 0 1-.19-.21l.52-.07a3.19 3.19 0 0 0 .35.09c.42-.21.44-.29.66-.31v-.23a15.19 15.19 0 0 1-2.66.25h-.08v-.23c2.31-.28 1.54-.12 2.33-.34 0 .08 0 .12.08.12a.54.54 0 0 1 .32-.16h.16a8.46 8.46 0 0 0 2.68-.35v.1l.26-.13h.24c0-.23.34-.27.46-.28v-.25c-2.81.57-3.55.41-4.33.63v-.1a3.41 3.41 0 0 1-1 .08.49.49 0 0 0-.23.15c0-.08 0-.12-.09-.12l-2.39.39c0-.07 0-.1-.09-.09a12.17 12.17 0 0 1-2.56.46.78.78 0 0 0-.31.13c0-.07 0-.1-.13-.09l-1 .08-.68.17c0-.07 0-.1-.13-.09a5.41 5.41 0 0 1-1 .19c-.17 0 .08 0 0-.1l-.21.12h-1.16c-1.8.22-1.6.25-1.8.26h-.67a.09.09 0 0 1-.1.11c-.76-.1-1.16-.22-1.16-.36q.15-1.09.53-1.12h.13l-.11.24h.13c.24-.13.35-.25.34-.36v-.25h-.24v-.23a.84.84 0 0 1 .07-.47l.55-.89v.23h.26v-.23l-.15-.21a1 1 0 0 1 .47-.27v-.12h-.35v-.35a10 10 0 0 0 1-2.57l.25.1c.16 0 .23-.1.22-.27h-.24v-.1a.89.89 0 0 1 .09-.49 1.56 1.56 0 0 0 .52-1.22c.07 0 .11 0 .12.11.33-.19.58-.68.76-1.5a46.87 46.87 0 0 0 2.47-6.25c2.05-5.52 2-6.1 2.25-7.41h-.24a.84.84 0 0 1-.09.48 1 1 0 0 0-.39-.09v-.1a2.83 2.83 0 0 1 .61-1.71h.11l.21.8h.24a7.3 7.3 0 0 1 .19-1c0-.12-.1-.2-.29-.21l-.23.15v-1.3h-.12a.91.91 0 0 1-.32-.51l-1.33.13a1.22 1.22 0 0 0-.15-.41c0-.12.29-.24.9-.36l.27.1.25-.15c0 .08.06.12.15.11l.25-.15c0 .08.06.12.15.11h.12v-.27h-1.46l-.25.17v-.15q-9.38.77-10.65.89h-1.32c0 .1-.08.16-.27.18l-.27-.12-.91.23a6.06 6.06 0 0 1-1.08 0 .93.93 0 0 1-.51.2l2.67-.17a1.22 1.22 0 0 1-.65.21.9.9 0 0 1-.53-.09 15.15 15.15 0 0 1-2 .47l-.27-.1-4.36.67a1.09 1.09 0 0 0-.59-.09 7.24 7.24 0 0 0-1.16.25l-2.11.88.16.26a1.17 1.17 0 0 0 .43-.17l.75.07-.09.7A1.88 1.88 0 0 0 87.24 45c-1 .46-1.55.78-1.55 1v.12h.16l.28-.15.33.39v.54q0 .25-5.21 11c-3 6.9-4.6 10.67-4.75 11.35-1 .29-1.63.71-1.81 1.27 0 .18.33.3.92.34v.27l-.27.45v.54q0 .42 2.26.64c0-.09 0-.15.14-.16a8.16 8.16 0 0 1-.28 2h.16a3.47 3.47 0 0 0 .88-1.73h.13c.15 0 .31.16.49.52q-.28.11-2 4.45l.16.26h.16q2.05-5.2 2.58-5.75 2.7-.24 9.33-1l.28-.17a.13.13 0 0 0 .17.13h.29l.28-.17a.13.13 0 0 0 .17.13l3.46-.4c.89-.07 1.3-.34 1.27-.8 0-.12.51-.26 1.57-.41a1.28 1.28 0 0 1 .46.08c0-.08.52-.17 1.58-.26 0-.56.2-.86.52-.89v-.27a4.63 4.63 0 0 0-1 .23 6.26 6.26 0 0 1-1.33-.16 1.23 1.23 0 0 1-.43.17l-2.33.07-.28.15q0-.13-.17-.11h-.13l-.3.15c0-.08-.25-.15-.74-.21l-.3.18h-.58v-.09q4.5-.49 4.44-1.22a.26.26 0 0 1 .32.27l.88-.22v-.27l-7.18.2c0 .09 0 .15-.14.16l-.88-.07a1.06 1.06 0 0 0-.56.2l-.33-.12a10 10 0 0 0-2 .33 12.73 12.73 0 0 0-2 0l-1.61.14-.85-.1c0-.48.89-2.81 2.79-7a6.11 6.11 0 0 1 1.54-2.64 1.08 1.08 0 0 1 .46.11l1.15-.39.59.09a13.45 13.45 0 0 0 3.45-.85 1.62 1.62 0 0 1 .75.07l.88-.21 2.58-.18a17.3 17.3 0 0 0 3.62-.74v-.27c-.48 0-.74 0-.75-.23 0-.36-.38-.51-1.06-.46v-.27l.72-.21 1.88-.16v-.27h-1.16v-.29l.73-.07c.2 0 .28-.11.26-.3-1 0-1.47 0-1.48-.15q-10.23.5-10.26.19a1.17 1.17 0 0 0-.43.19l-.18-.28q2.71-5.76 3.18-5.8a1.69 1.69 0 0 1-.22.72v.12h.29c.72-1.71 1.32-2.6 1.83-2.64 2.14-.19-.3-.33 4.29-1a.89.89 0 0 0 .41.11q2.7-.55 7.52-1.14v-.27l-1.71.16v-.27a.93.93 0 0 0 .51-.2v.15a1 1 0 0 0 .39-.19 1.23 1.23 0 0 1 .68.08 9.92 9.92 0 0 1 1.44-.29l1.07-.1c.26-.17.38-.32.37-.46v-.12a3.38 3.38 0 0 1-.94-.06.27.27 0 0 1 .24-.3l2-.19.91-.23c0 .1.06.14.13.14a1 1 0 0 0 .39-.19h.15a7.45 7.45 0 0 0-.4 1.09h-.26a1.14 1.14 0 0 0-.15-.48h-.13c-2.42 6.75-3.5 9.89-5.74 15.07-.41 1.32-.75 2.06-1.05 2.22a.21.21 0 0 0 .26.21 3.25 3.25 0 0 1-.46 1.93c-1 3-1.72 4.61-2.08 4.91L101 68a.22.22 0 0 1-.22.25h-.24c0-.39-.18-.58-.43-.55h-.13a5.54 5.54 0 0 0-.72 1.72h.24a.81.81 0 0 0 .45-.75h.48l.28.1a1.49 1.49 0 0 0-.31.85l.13.22-.32.75v.12a1.51 1.51 0 0 1 .91.26 1.63 1.63 0 0 0 .74-.3h3.12l.9-.31a20.9 20.9 0 0 0 2.23-.07h.39l.21-.14v.12a6.11 6.11 0 0 1 1.84.07v.12H110v.23a.79.79 0 0 0 .44-.17c.14 0 .22.07.23.23a3.28 3.28 0 0 0-.75.17l-.24-.08c-.38.1-.3.13-.56.15l-.38-.07a.09.09 0 0 1-.09.11.2.2 0 0 0 .23.21h.39l2-.18.77-.17c0 .07 0 .1.1.09l.37-.14.7-.06c.54 0 .53-.08 1.71-.27 0-.07 0-.1.07-.11v.1a17.2 17.2 0 0 0 2.41-.5v.06c.48-.11.21-.08.34-.18 0 .08 0 .12.08.12h.34v-.25h-.84a3.59 3.59 0 0 1-.76.06l-1.71.09v-.12l1-.13h.34l.2-.14v.12c1.34-.11 1.82.22 8-1.1.34 0 .31-.31.52-.89a.58.58 0 0 1-.33-.07 9.7 9.7 0 0 1-1.77.26c-.08 0-.15-.07-.18-.21v-.1h1a2.4 2.4 0 0 0 1-.34c0 .08-.2.13-.08.12zM78.61 68h-.44a8.26 8.26 0 0 1 .7-2h.29a7.62 7.62 0 0 1-.55 2zm.53-2.12v-.12c0-.15.08-.25.29-.3v.12c0 .18-.08.28-.29.3zM85 70.4v.12l-.73.07v-.12l.73-.07zm-.88-.07c0 .15-.21.32-.7.48l-.89-.07h-.29v-.27l1.91-.18zM90 43.22h-.44v-.15c0-.15.07-.25.26-.3h.16l.3.12a.26.26 0 0 1-.27.3zm6.66-1.3h.14v.27h-.4a.27.27 0 0 1 .24-.3zM95 42.5l-.66-.07v-.13A7.15 7.15 0 0 0 96 42c0 .1.1.14.27.12v.27h-.26a.9.9 0 0 1-.53-.09 1.14 1.14 0 0 1-.51.19zm.83 2.41v-.12l1.07-.1v.12l-1.07.1zm1.11-.91v-.15h.52V44h-.52zm.12-1.83h-.14l.12-.29 1.19-.11v.15a7.2 7.2 0 0 0-1.18.24zm.61 2.57v-.27h.52q.27 0 .28.25l-.78.07zm3.16-4.3l-.67.19H100a6.85 6.85 0 0 1-1.21 0c.87-.06 1.7-.12 2-.17zm-.72 3v.12l-.92.08v-.12l.92-.08zm1.51.72c0-.11-.19-.19-.55-.22l-.92.26h-.71c-.16-.11-.24-.19-.25-.24h.82l1.84-.3h.94v.15a5.28 5.28 0 0 0-1.18.24zm9.49-2.45h.21a3.57 3.57 0 0 1 1.11-.75 6.55 6.55 0 0 1-1.57 3.27l-.52-.32a17 17 0 0 0 .77-2.22zm-1.6 2.75h.13c-.18.34-.34.51-.47.52v-.35a.79.79 0 0 0 .36-.16zm-1 2.47a3.5 3.5 0 0 1 .72-1.72v.12c-.13.93-.34 1.43-.61 1.46v.59a1.32 1.32 0 0 0-.32.75h-.13l-.07-.81c.15 0 .27-.15.35-.39zm-.4 1.34a3.41 3.41 0 0 1-.27 1h-.13v-.35c.18-.41.33-.62.43-.62zm-7.52 21.82v-.1h.24v.35c-.13 0-.22-.07-.26-.23zm10.74.28c0-.08 0-.12-.13-.11l-.61.06v-.12h.06L112 70v.12a1.26 1.26 0 0 0-.75.18zm-.72-.3c.06 0 0 .06 0 .07s-.07 0 0-.07zm.07-1.68l-.8.07v-.16l.73-.07.63-.16c0 .07 0 .1.13.09.75-.13.68-.17 1-.2.12 0 .2.07.21.21l-1.93.17zm2.8-.24a3.19 3.19 0 0 0-.79-.06V68l.72-.07V68c-.07 0 .2 0 .07.12zm.06-.13v-.1h.39v.1h-.39zm.87-.07v-.1a.68.68 0 0 0 .28-.15.28.28 0 0 1 .32.26zm1.11-.14v-.12h.48v.12h-.48zm.66-.06c0-.14 0-.22.17-.24l.16.21a.09.09 0 0 1 .07-.11l.12.22-.52-.07zm9.17-1.08zm.17-.12c.07 0 .11-.09-.07-.12s.09.12-.09.13v.08l.1-.07-.1.08-.2.25.39-.14v-.23zm.68.53h-.07v.23h.55c0-.15-.37-.2-.49-.2z\"/></g></svg>"

/***/ }),

/***/ "../src/components/babel/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BabelOriginal = __webpack_require__("../src/components/babel/original/BabelOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BabelOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/babel/plain/BabelPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BabelPlain = __webpack_require__("../src/components/babel/plain/BabelPlain.svg");
	
	var _BabelPlain2 = _interopRequireDefault(_BabelPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BabelPlain */
	function BabelPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BabelPlain',
	    svg: _BabelPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BabelPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BabelPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/babel/plain/BabelPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"babel\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#000305}</style></defs><title>Artboard 4</title><path class=\"cls-1\" d=\"M90.18 50.5v.15h.31a1.18 1.18 0 0 1 .09-.43v-.27c-.13 0-.26.21-.38.58zm-2.94-7.08v-.27h-.44v.27h.44zm-8.54 16a14.07 14.07 0 0 0-2.35-3c0-.32.5-.79 1.59-1.42L81 52.34A7.79 7.79 0 0 0 82.28 48v-.46c-.12-1.38-1.12-2.49-3-3.34q-1.68-1.13-6-1.25a35.58 35.58 0 0 0-9.41 2.58 38.64 38.64 0 0 1-3.63 2.29v.23a.87.87 0 0 0 .36-.16.21.21 0 0 1 .26.21L61 48h.11v.1a12.79 12.79 0 0 1-2.52 2l.13.24h-.11l-.28-.1c0 .08-.11.14-.34.16v.1l.27.34a1 1 0 0 1-.39-.09 1.88 1.88 0 0 0-1.16.63l.16-.69a56.27 56.27 0 0 0 1.16-6.5L58 44a4.73 4.73 0 0 1-1.09-1 3.71 3.71 0 0 0 0-.49v-.1h-.11q-1.85 2.77-7.11 9.45-4 4.75-4.14 5.28c-1.09 1.13-1.61 1.81-1.56 2-.29.19-.41.37-.36.58a.12.12 0 0 1-.16-.09 3.17 3.17 0 0 1-2.08 1.45l-1 .22a.23.23 0 0 0-.19.28v.12l.36-.08v.1l-.82.32-1.45.34h-.76c-.11.11.61 0 .33.06l-1 .22c-.58.13-.89.08-1-.15h-.11a.54.54 0 0 1 0 .24l-.06-.23-.76.18Q35 62.29 32 59c0-.43.67-1.05 2.12-1.86l4.08-3.59q1.37-1.76 1.63-5.65l-.06-.61c-.16-1.83-1.48-3.3-4-4.44-1.47-1-4.12-1.53-7.94-1.61a47.82 47.82 0 0 0-12.39 3.36 47.39 47.39 0 0 1-4.78 3v.32a1.25 1.25 0 0 0 .48-.19.27.27 0 0 1 .34.26l.32-.18h.2V48a18.64 18.64 0 0 1-3.34 2.6l.18.28H8.7l-.34-.12c0 .09-.15.16-.48.19v.17l.37.41a1.36 1.36 0 0 1-.5-.1A3.17 3.17 0 0 0 5.63 53l.18.28a4.47 4.47 0 0 1 1.06-.85v.46a1.53 1.53 0 0 0-.48.19l.38.58a12.63 12.63 0 0 1 2.43-2c.44.11.67.25.68.4h.34a26 26 0 0 1 7.14-3.86v.32q-.66 1-.89 1a1 1 0 0 0 .23.59q.06.6-3.21 8.1Q6.17 75.5 1.13 83.84a1.08 1.08 0 0 0 .2.45 4.17 4.17 0 0 0 1.57-.6h.18v.32h.31l.32-.18c0 .09.11.14.33.12v.32a2.83 2.83 0 0 1-.52 1.42A7.37 7.37 0 0 0 2.48 88v.15h.31a19.55 19.55 0 0 0 3.06-4.41 48.85 48.85 0 0 0 9-3.38 8.39 8.39 0 0 0 4.74-1.63v-.17l-.78.23h-.18v-.17a7.07 7.07 0 0 0 3.17-1q4.46-3.44 6.74-4.87 4.68-3.44 6.08-6.7l.52-.12a6.81 6.81 0 0 0 .75 0c0-.08 0-.13.1-.15.7-.07.36 0 .81-.06l1.17-.27h.2l-.09.06a1.14 1.14 0 0 0 .43 0l.08.34-5.34 8.49L32 75.71l-.58 1.94h.11l.58-.24-.19.75.06.22.16.2c-.07 0-.1.07-.08.15v.12l.24-.06q.53-.46.45-.84a2.21 2.21 0 0 0 .76.06v.12c-.23.06-.35.24-.37.56v.12h.13c1.94-2.12 6.69-9.35 10.5-14.27q-.18-.8 6-2.22h.13q.22 1-1 4.67a12.58 12.58 0 0 0-.71 2.44 18.69 18.69 0 0 0-.92 3.22l-1.37 4.69A43.46 43.46 0 0 0 43.74 85a1 1 0 0 1 .4 0l.21-.18a.12.12 0 0 0 .16.09l-.08-.34h.63c.19 0 .34-.28.48-.71 0-.64.1-1 .39-1.06a10.29 10.29 0 0 1 .72-2.32 10.29 10.29 0 0 1 .81-2.6c.55-2 1-3 1.21-3.06l.06.24-.4 1a50.68 50.68 0 0 1-2.12 7.35l.21.89h.13q2.6-5.59 7.48-22.14A2.89 2.89 0 0 1 55.4 60l-.19-.2v-.1a1.27 1.27 0 0 0 .78-.44c0-.08-.34-.21-1-.37l1.62-7a2.41 2.41 0 0 1 .62-.48v.35a.87.87 0 0 0-.36.16l.31.44A10 10 0 0 1 59 50.83c.34.09.5.21.52.32h.24a19.75 19.75 0 0 1 5.43-2.91v.23q-.49.74-.67.75a1 1 0 0 0 .15.45 42.49 42.49 0 0 1-2.41 6.16 167.41 167.41 0 0 1-9.44 19.55.87.87 0 0 0 .17.34 3 3 0 0 0 1.18-.46h.11v.23h.26l.23-.12q0 .1.25.08v.25a2.12 2.12 0 0 1-.4 1.06 5.31 5.31 0 0 0-.85 1.82v.12h.24a14.72 14.72 0 0 0 2.32-3.35 37.55 37.55 0 0 0 6.8-2.56 6.39 6.39 0 0 0 3.62-1.24v-.12l-.61.18h-.13v-.12a5.36 5.36 0 0 0 2.4-.77c2.25-1.73 4-3 5.12-3.7 3.6-2.62 5.27-5.13 5.07-7.55zm-.62.16l.08.94c-.11.23-.23.35-.34.36l-.14-1.6c.26.09.39.19.4.3zM7.52 52h-.16v-.29l.64-.05v.15a1.24 1.24 0 0 0-.47.19zM4.38 83.4a2 2 0 0 0-1-.21v-.46c0-.18.08-.3.31-.34s.33.13.34.43a6.78 6.78 0 0 1 .89-1l.34.14c-.11.93-.4 1.41-.86 1.44zm33.55-35.1c-.16 0-.48-.48-.93-1.45v-.29c.3 0 .61.46.93 1.45v.29zm-.45-3.48l-.13.31-4.56-1.9q4.56.15 4.69 1.59zM18.25 61.35l-.64.06v-.29l.64-.06v.29zm-.52-9.92h.16v.46c-.15 0-.34.23-.59.66v-.32c.29-.34.44-.61.42-.79zm-1.35 3.19l.06.61h-.16l-.06-.61zm-.71 1.14h.31c0 .5-.17.77-.42.79h-.16a1.46 1.46 0 0 0 .27-.77zm-.53 1.58h.18v.15l-.29.48h-.31v-.15a.4.4 0 0 0 .42-.49zm-.52 1.43l-.09.76h-.16l-.07-.75h.32zM9.38 73.62c-.21 1-.43 1.57-.66 1.59v-.15a1.67 1.67 0 0 1 .67-1.44zm-1 2.08v.15a.27.27 0 0 1-.28.34V76q0-.27.28-.34zM8.15 80h.48v.17a1.25 1.25 0 0 0-.48.19h-.31c0-.16.08-.28.28-.34zm13.79-4.26a25.56 25.56 0 0 0-4.8 2.73q-4.42 1.53-4.38 1.92a48 48 0 0 0-5.17 2.27 1.86 1.86 0 0 1-.85-.22 1.37 1.37 0 0 1 .71-1.3 2.75 2.75 0 0 1 1.31.21 12.78 12.78 0 0 1 2.53-.83v-.32l-1 .08A13.17 13.17 0 0 1 13.1 79h.48v.15c-.83.07-1.29.32-1.39.75 0 .2.13.28.34.26.62-.39.93-.62.92-.69q1.77-.34 9.81-5.13v.29c0 .14-.45.53-1.37 1.2zm-8.22 2.7a3.17 3.17 0 0 0 2-.93c.22 0 .34.07.35.26a7.17 7.17 0 0 0-2.19 1h-.16v-.31zM27 68.27l-4.11 3.26a40.68 40.68 0 0 1-4.94 3q-7.3 4-9.07 4.17H8.7q.22-.82 6.5-13.31a35.47 35.47 0 0 0 8.71-2.58l1-.08a5.59 5.59 0 0 1 4.49 1.15l.06.61c-.74 2.13-1.56 3.38-2.44 3.75zm-8-4.52l.66-.06v.15l-.66.06v-.15zm9.29-1.57h.48c.45.21.68.4.7.57v.15a1.36 1.36 0 0 1-1.19-.67zm1.31-7.48a19 19 0 0 1-3.6 2.61c-.63.06-3 1-7.07 2.76a1.29 1.29 0 0 0-.63-.07v-.29a3.81 3.81 0 0 1 .79-2.22c.32-1.68.66-2.64 1-2.87l3.4-7.65q-.06-.71 2.18-1.09h.48v.44c1.46-.22 2.38-.35 2.73-.38 2.7-.23 4.11.32 4.22 1.63h.31l-.07-.77h.34A2.12 2.12 0 0 1 35 48.25a2.48 2.48 0 0 1-.69 1.59c-.21 0-.33-.13-.34-.43h-.34l-.07.93q-2.05 3.07-3 3.16c-.56.77-.9 1.16-1 1.16zm2.09 5.36a1.2 1.2 0 0 0-.67-.26v-.46h.31l.68.4a.27.27 0 0 1-.28.34zm2.16 2.56c.3.12.48.25.51.37h-.24l-.22.18-.06-.62zM34 63.9v-.12l.39-.09v.12l-.39.09zm.94 1.1c.4-.07.6-.09 1.34-.26v.12l-1.42.33a1.87 1.87 0 0 0 0-.19zm1.38.59a6.06 6.06 0 0 0-1.42.2v-.12l1.19-.38.57-.13.06.22c-.26.06-.07.06-.37.21zm1.26-.3a.26.26 0 0 1-.32-.19l.36-.08a.22.22 0 0 1 .3.19l-.34.08zM41 61.57v-.12l.59-.14.06.22h-.62zm3.64 22.34a.92.92 0 0 0 0-.37h.13a.21.21 0 0 1 .29.17v.12l-.48.11zm2.55-21.38h-.26a7.38 7.38 0 0 1-1.06.35l-.24.06a.24.24 0 0 1-.31-.17l1.68-.43.56-.26.19.21a1.25 1.25 0 0 0-.58.24zm1.31-.42v-.12a.71.71 0 0 0 .32-.21l1.18-.27v.12a9.36 9.36 0 0 0-1.53.48zm.19-2.45a1 1 0 0 0-.34.21c0-.08-.19-.08-.5 0-.06-.23.84-.56 2.69-1l.26-.06.06.22c-1.3.38-2 .6-2.17.62zm3.26-3.52c-.13 1.48-.65 2.32-1.57 2.53v-.12l-.82.32-.36.08a.91.91 0 0 1-.5 0l-.07-.33a49.32 49.32 0 0 1 3.56-4.91h.28a5.09 5.09 0 0 1-.48 2.39zm5.77-4.94h-.12v-.23h.48v.12a1.57 1.57 0 0 0-.36.15zm-2.38 23.86a1.49 1.49 0 0 0-.75-.17v-.35q0-.18.22-.25c.16 0 .25.09.27.34a4.09 4.09 0 0 1 .67-.77L56 74c-.09.71-.31 1.08-.64 1.11zm25.47-26.64c-.12 0-.35-.36-.72-1.12v-.23c.23 0 .48.34.72 1.09v.26zm-.34-2.66l-.11.24-3.45-1.44c2.3.07 3.49.48 3.56 1.2zM65.86 58.3h-.48v-.23h.48v.23zm-.4-7.54h.13v.35q-.18 0-.45.5v-.23a1.08 1.08 0 0 0 .31-.62zm-1 2.42v.46h-.13v-.46zm-.55.87h.24q0 .59-.31.61h-.14a1.26 1.26 0 0 0 .2-.61zm-.39 1.19h.11v.12l-.21.37h-.24v-.12c.25 0 .36-.15.34-.38zm-.39 1.08l-.08.6h-.11v-.59h.24zm-4 11.3q-.24 1.17-.5 1.2v-.1a1.33 1.33 0 0 1 .51-1.1zm-.73 1.58v.1a.21.21 0 0 1-.22.27v-.12q0-.18.22-.25zm-.21 3.28h.37v.12a1.07 1.07 0 0 0-.36.14h-.24q0-.2.22-.25zm10.46-3.23A21.75 21.75 0 0 0 65 71.31c-2.24.78-3.34 1.27-3.33 1.46a35.33 35.33 0 0 0-3.9 1.72 1.45 1.45 0 0 1-.64-.18 1 1 0 0 1 .54-1 2.1 2.1 0 0 1 1 .15 10.83 10.83 0 0 1 1.93-.62v-.23l-.75.07a10 10 0 0 1 2.14-1h.37v.1c-.63.06-1 .24-1.06.58a.21.21 0 0 0 .26.21c.47-.31.69-.48.69-.54q1.34-.24 7.44-3.9v.23c0 .09-.34.39-1 .9zm-6.24 2A2.5 2.5 0 0 0 64 70.6c.16 0 .25.06.26.21a5.92 5.92 0 0 0-1.66.71h-.13v-.22zm10.08-7.74l-3.1 2.5a30.16 30.16 0 0 1-3.77 2.3q-5.53 3-6.89 3.16h-.13q.17-.63 4.95-10.1a27.26 27.26 0 0 0 6.61-2l.75-.07a4.2 4.2 0 0 1 3.4.89v.46c-.57 1.6-1.18 2.54-1.85 2.83zm-6.09-3.38h.48v.12h-.48v-.12zm7.05-1.2h.37c.34.17.52.32.53.44v.1a1 1 0 0 1-.91-.51zm1-5.67a14.26 14.26 0 0 1-2.66 2 35.66 35.66 0 0 0-5.37 2.08 1.23 1.23 0 0 0-.49-.07v-.23a2.92 2.92 0 0 1 .59-1.69c.24-1.29.51-2 .79-2.17l2.6-5.81c0-.34.52-.62 1.64-.84h.37v.35q1.65-.27 2.07-.31c2-.18 3.12.23 3.21 1.24h.24v-.56h.24a1.55 1.55 0 0 1 1 1.18 1.93 1.93 0 0 1-.49 1.22c-.16 0-.25-.09-.27-.34h-.24l-.07.7c-1 1.57-1.79 2.39-2.26 2.42-.42.57-.68.86-.8.87zm1.09 3.88v-.35h.24l.52.32a.22.22 0 0 1-.22.25 1 1 0 0 0-.51-.2zM32.15 79.76l-.24.06-.21.18a.21.21 0 0 0 .29.17c.16 0 .22-.13.19-.28v-.12zm-.92-1.84v.12c.16 0 .22-.13.19-.28v-.12a.22.22 0 0 0-.19.28zm6.6-12.39l.18-.11h-.09a.11.11 0 0 0-.08.13zm0-3.21l.28-.07L38 62l-.28.07.06.24zm65.85 9.41l-.63-.07-.11.24v.1l3.77-.32v-.23l-3 .26zm3.45-.29v.23-.23zm15.83-2.07v.23l.41.07v-.23l-.41-.07zm-.58 0a15.72 15.72 0 0 1-3.78.57v.23h.4l.31-.12c2.8-.31 3.13-.2 3.1-.51v-.11zm-17-4.12l-.25-.08a4.2 4.2 0 0 0-.3 1v.1c.2 0 .37-.34.54-1zm-3.41-1.84v-.12h-.13l-.23.15.13.22c.18 0 .26-.1.24-.26zm7.41 7.66v-.23h-.07v.23zm15.37-3.47h.18c.1 0 .15-.09.14-.24l-.1-.22a3 3 0 0 0-1.46.37v-.12l-.77.07c0-.23-.08-.35-.19-.34h-.4c-.47 0-.69 0-.92.2 0-.08 0-.12-.08-.12h-.45l-.26.15c0-.08 0-.12-.08-.12l-.16.14v-.12h-.77v.23l.32.08h.3a.54.54 0 0 0 .34.07l.26-.13v.1a19.08 19.08 0 0 1-2.46.47.43.43 0 0 0-.25-.1.2.2 0 0 1-.19-.21l.52-.07a3.19 3.19 0 0 0 .35.09c.42-.21.44-.29.66-.31v-.23a15.19 15.19 0 0 1-2.66.25h-.08v-.23c2.31-.28 1.54-.12 2.33-.34 0 .08 0 .12.08.12a.54.54 0 0 1 .32-.16h.16a8.46 8.46 0 0 0 2.57-.28v.1l.26-.13h.24c0-.23.34-.27.46-.28v-.25c-2.81.57-3.55.41-4.33.63v-.1a3.41 3.41 0 0 1-1 .08.49.49 0 0 0-.23.15c0-.08 0-.12-.09-.12l-2.39.39c0-.07 0-.1-.09-.09a12.17 12.17 0 0 1-2.56.46.78.78 0 0 0-.31.13c0-.07 0-.1-.13-.09l-1 .08-.68.17c0-.07 0-.1-.13-.09a5.41 5.41 0 0 1-1 .19c-.17 0 .08 0 0-.1l-.21.12h-1.16c-1.8.22-1.6.25-1.8.26h-.67a.09.09 0 0 1-.1.11c-.76-.1-1.16-.22-1.16-.36q.15-1.09.53-1.12h.13l-.11.24h.13c.24-.13.35-.25.34-.36v-.25h-.24v-.23a.84.84 0 0 1 .07-.47l.55-.89v.23h.26v-.23l-.15-.21a1 1 0 0 1 .47-.27v-.12h-.35v-.35a10 10 0 0 0 1-2.57l.25.1c.16 0 .23-.1.22-.27h-.24v-.1a.89.89 0 0 1 .09-.49 1.56 1.56 0 0 0 .52-1.22c.07 0 .11 0 .12.11.33-.19.58-.68.76-1.5a46.87 46.87 0 0 0 2.47-6.25c2.05-5.52 2-6.1 2.25-7.41h-.24a.84.84 0 0 1-.09.48 1 1 0 0 0-.39-.09v-.1a2.83 2.83 0 0 1 .61-1.71h.11l.21.8h.24a7.3 7.3 0 0 1 .19-1c0-.12-.1-.2-.29-.21l-.23.15v-1.3h-.12a.91.91 0 0 1-.32-.51l-1.33.13a1.22 1.22 0 0 0-.15-.41c0-.12.29-.24.9-.36l.27.1.25-.15c0 .08.06.12.15.11l.25-.15c0 .08.06.12.15.11h.12v-.27h-1.46l-.25.17v-.15q-9.38.77-10.65.89H99.6c0 .1-.08.16-.27.18l-.27-.12L98 41a6.06 6.06 0 0 1-1.08 0 .93.93 0 0 1-.51.2l2.65-.2a1.22 1.22 0 0 1-.65.21.9.9 0 0 1-.53-.09 15.15 15.15 0 0 1-2 .47l-.27-.1-4.36.67a1.09 1.09 0 0 0-.59-.09 7.24 7.24 0 0 0-1.16.25l-2.11.88.16.26a1.17 1.17 0 0 0 .43-.17l.75.07-.09.7a1.88 1.88 0 0 0-1.2 1.34c-1 .46-1.55.78-1.55 1v.12h.16l.28-.15.33.39v.54q0 .25-5.21 11c-3 6.9-4.6 10.67-4.75 11.35-1 .29-1.63.71-1.81 1.27 0 .18.33.3.92.34v.27l-.27.45v.54q0 .42 2.26.64c0-.09 0-.15.14-.16a8.16 8.16 0 0 1-.28 2H78a3.47 3.47 0 0 0 .88-1.73H79c.15 0 .31.16.49.52q-.28.11-2 4.45l.16.26h.16q2.05-5.2 2.58-5.75 2.7-.24 9.33-1l.28-.17a.13.13 0 0 0 .17.13h.29l.28-.17a.13.13 0 0 0 .17.13l3.35-.29c.89-.07 1.3-.34 1.27-.8 0-.12.51-.26 1.57-.41a1.28 1.28 0 0 1 .46.08c0-.08.52-.17 1.58-.26 0-.56.2-.86.52-.89v-.27a4.63 4.63 0 0 0-1 .23 6.26 6.26 0 0 1-1.33-.16 1.23 1.23 0 0 1-.43.17L94.51 69l-.28.15q0-.13-.17-.11h-.13l-.3.15c0-.08-.25-.15-.74-.21l-.3.18h-.58v-.15q4.5-.49 4.44-1.22a.26.26 0 0 1 .32.27l.88-.22v-.27l-7.18.2c0 .09 0 .15-.14.16l-.88-.07a1.06 1.06 0 0 0-.56.2l-.35-.06a10 10 0 0 0-2 .33 12.73 12.73 0 0 0-2 0l-1.61.14-.75-.08c0-.48.89-2.81 2.79-7a6.11 6.11 0 0 1 1.54-2.64 1.08 1.08 0 0 1 .46.11l1.03-.39.59.09a13.45 13.45 0 0 0 3.45-.85 1.62 1.62 0 0 1 .75.07l.88-.21 2.61-.22a17.3 17.3 0 0 0 3.62-.74v-.27c-.48 0-.74 0-.75-.23 0-.36-.38-.51-1.06-.46v-.27l.72-.21 1.88-.16v-.27h-1.16v-.29l.73-.07c.2 0 .28-.11.26-.3-1 0-1.47 0-1.48-.15q-10.23.5-10.26.19a1.17 1.17 0 0 0-.43.19l-.29-.31q2.71-5.76 3.18-5.8a1.69 1.69 0 0 1-.22.72V49h.29c.72-1.71 1.32-2.6 1.83-2.64 2.14-.19-.3-.33 4.29-1a.89.89 0 0 0 .41.11q2.7-.55 7.52-1.14v-.27l-1.71.16v-.27a.93.93 0 0 0 .51-.2v.15a1 1 0 0 0 .39-.19 1.23 1.23 0 0 1 .68.08 9.92 9.92 0 0 1 1.44-.29l1.07-.1c.26-.17.38-.32.37-.46v-.12a3.38 3.38 0 0 1-.94-.06.27.27 0 0 1 .24-.3l2-.19.91-.23c0 .1.06.14.13.14a1 1 0 0 0 .39-.19h.15a7.45 7.45 0 0 0-.4 1.09h-.26a1.14 1.14 0 0 0-.15-.48H110c-2.42 6.75-3.5 9.89-5.74 15.07-.41 1.32-.75 2.06-1.05 2.22a.21.21 0 0 0 .26.21 3.25 3.25 0 0 1-.46 1.93c-1 3-1.72 4.61-2.08 4.91l.23 1.41a.22.22 0 0 1-.22.25h-.24c0-.39-.18-.58-.43-.55h-.13a5.54 5.54 0 0 0-.72 1.72h.24a.81.81 0 0 0 .45-.75h.48l.28.1a1.49 1.49 0 0 0-.31.85l.13.22-.32.75v.12a1.51 1.51 0 0 1 .91.26A1.63 1.63 0 0 0 102 71h3.12l.9-.31a20.9 20.9 0 0 0 2.23-.07h.39l.21-.14v.12a6.11 6.11 0 0 1 1.84.07v.12h-.55v.23a.79.79 0 0 0 .44-.17c.14 0 .22.07.23.23a3.28 3.28 0 0 0-.75.17l-.24-.08c-.38.1-.3.13-.56.15l-.38-.07a.09.09 0 0 1-.09.11.2.2 0 0 0 .23.21h.39l2-.18.77-.17c0 .07 0 .1.1.09l.37-.14.7-.06c.54 0 .53-.08 1.71-.27 0-.07 0-.1.07-.11v.1a17.2 17.2 0 0 0 2.34-.45v.06c.48-.11.21-.08.34-.18 0 .08 0 .12.08.12h.34v-.25h-.84a3.59 3.59 0 0 1-.76.06l-1.71.09v-.12l1-.13h.34l.2-.14V70c1.34-.11 1.82.22 8-1.1.34 0 .31-.31.52-.89a.58.58 0 0 1-.33-.07 9.7 9.7 0 0 1-1.77.26c-.08 0-.15-.07-.18-.21v-.1h1a2.4 2.4 0 0 0 1-.34c0 .08-.2.13-.08.12zm-45.88.74h-.44a8.26 8.26 0 0 1 .7-2h.29a7.62 7.62 0 0 1-.55 2zm.53-2.12v-.12c0-.15.08-.25.29-.3v.2c0 .18-.08.28-.29.3zm5.82 4.5v.12l-.73.07v-.12l.73-.07zm-.88-.07c0 .15-.21.32-.7.48l-.89-.07h-.29v-.27l1.91-.18zm5.89-27.11h-.44v-.15c0-.15.07-.25.26-.3h.16l.3.12a.26.26 0 0 1-.27.3zm6.66-1.3H97v.27h-.4a.27.27 0 0 1 .24-.3zm-1.68.59l-.66-.07v-.12a7.15 7.15 0 0 0 1.69-.32c0 .1.1.14.27.12v.27h-.26a.9.9 0 0 1-.53-.09 1.14 1.14 0 0 1-.51.19zm.79 2.46v-.12l1.07-.1v.12l-1.07.1zm1.15-.93v-.16h.52v.15h-.52zm.12-1.83h-.14l.12-.29 1.19-.11v.15a7.2 7.2 0 0 0-1.18.24zm.61 2.57v-.27h.52q.27 0 .28.25l-.78.07zm3.16-4.3l-.67.19h-.12A6.85 6.85 0 0 1 99 41c.87-.06 1.7-.12 2-.17zm-.72 3v.12l-.92.08v-.12l.92-.08zm1.51.72c0-.11-.19-.19-.55-.22l-.92.26h-.71c-.16-.11-.24-.19-.25-.24h.82l1.84-.3h.94v.15a5.28 5.28 0 0 0-1.18.24zm9.49-2.52h.21a3.57 3.57 0 0 1 1.11-.75 6.55 6.55 0 0 1-1.57 3.27l-.52-.32a17 17 0 0 0 .77-2.22zm-1.6 2.75h.13c-.18.34-.34.51-.47.52v-.35a.79.79 0 0 0 .36-.16zm-1 2.47a3.5 3.5 0 0 1 .72-1.72v.12c-.13.93-.34 1.43-.61 1.46v.59a1.32 1.32 0 0 0-.32.75h-.13l-.07-.81c.15 0 .27-.15.35-.39zm-.4 1.34a3.41 3.41 0 0 1-.27 1h-.13v-.35c.18-.41.33-.62.43-.62zm-7.52 21.82v-.1h.24v.35c-.13 0-.22-.07-.26-.23zm10.74.28c0-.08 0-.12-.13-.11l-.61.06v-.12h.06l1.43-.12v.12a1.26 1.26 0 0 0-.75.18zm-.72-.3c.06 0 0 .06 0 .07s-.07 0 0-.07zm.07-1.68l-.8.07v-.12l.73-.07.63-.16c0 .07 0 .1.13.09.75-.13.68-.17 1-.2.12 0 .2.07.21.21l-1.93.17zm2.8-.24a3.19 3.19 0 0 0-.79-.06v-.1l.72-.07v.1c-.07 0 .2 0 .07.12zm.06-.13v-.1h.39v.1h-.39zm.87-.07v-.1a.68.68 0 0 0 .28-.15.28.28 0 0 1 .32.26zm1.11-.14V68h.48v.12h-.48zm.66-.06c0-.14 0-.22.17-.24l.16.21a.09.09 0 0 1 .07-.11l.12.22-.52-.07zm9.14-1.04zm.17-.12c.07 0 .11-.09-.07-.12s.09.12-.09.13V67l.1-.07-.1.08-.2.25.39-.14v-.23zm.68.53h-.07v.23h.55c0-.15-.37-.2-.49-.2z\" id=\"plain\"/></svg>"

/***/ }),

/***/ "../src/components/babel/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BabelPlain = __webpack_require__("../src/components/babel/plain/BabelPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BabelPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/backbonejs/original-wordmark/BackbonejsOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BackbonejsOriginalWordmark = __webpack_require__("../src/components/backbonejs/original-wordmark/BackbonejsOriginalWordmark.svg");
	
	var _BackbonejsOriginalWordmark2 = _interopRequireDefault(_BackbonejsOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BackbonejsOriginalWordmark */
	function BackbonejsOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BackbonejsOriginalWordmark',
	    svg: _BackbonejsOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BackbonejsOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BackbonejsOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/backbonejs/original-wordmark/BackbonejsOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#002A41\" d=\"M22.579 2.502v55.647l41.42 23.61V65.71l-27.71-15.795v-24.81L63.999 40.9V26.113L22.579 2.502z\"/><path fill=\"#0071B5\" d=\"M105.42 2.502v55.647L64 81.759V65.71l27.709-15.795v-24.81L64 40.9V26.113l41.42-23.611zM22.579 105.397V49.749l41.42-23.611v16.051l-27.71 15.794v23.548l27.71-15.795v16.049l-41.42 23.611z\"/><path fill=\"#002A41\" d=\"M105.42 105.397V49.749L64 26.138v16.051l27.709 15.794v23.548L64 65.736v16.049l41.42 23.611zm-93.509 6.225h3.39c1.592 0 2.744.238 3.455.714s1.067 1.228 1.067 2.257c0 .711-.199 1.298-.596 1.76s-.975.762-1.735.898v.082c1.822.312 2.732 1.27 2.732 2.873 0 1.072-.362 1.91-1.087 2.511-.726.602-1.738.903-3.041.903H11.91v-11.998zm1.396 5.137h2.298c.985 0 1.693-.155 2.126-.464.432-.309.648-.83.648-1.563 0-.673-.241-1.158-.723-1.457-.481-.298-1.247-.447-2.298-.447h-2.052v3.931zm0 1.182v4.489h2.503c.969 0 1.697-.188 2.188-.562.489-.375.734-.962.734-1.761 0-.744-.25-1.291-.751-1.641s-1.263-.525-2.285-.525h-2.389zm17.037 5.679l-1.493-3.816h-4.81l-1.477 3.816h-1.412l4.744-12.047h1.173l4.72 12.047h-1.445zm-1.928-5.072l-1.396-3.718a20.157 20.157 0 0 1-.559-1.731c-.12.525-.292 1.103-.517 1.731l-1.411 3.718h3.883zm10.159-5.851c-1.318 0-2.359.439-3.122 1.317-.764.878-1.146 2.081-1.146 3.607 0 1.57.368 2.783 1.104 3.64.735.856 1.784 1.284 3.146 1.284.838 0 1.792-.15 2.864-.451v1.223c-.831.312-1.857.468-3.077.468-1.768 0-3.131-.536-4.091-1.608-.961-1.072-1.44-2.596-1.44-4.571 0-1.236.23-2.32.693-3.25a4.983 4.983 0 0 1 2.002-2.15c.873-.503 1.9-.755 3.082-.755 1.258 0 2.358.23 3.299.689l-.591 1.198c-.906-.428-1.815-.641-2.723-.641zm14.132 10.923h-1.641l-4.375-5.819-1.255 1.116v4.703H44.04v-11.999h1.396v5.95l5.44-5.95h1.649l-4.825 5.211 5.007 6.788zm1.649-11.998h3.39c1.592 0 2.744.238 3.455.714s1.067 1.228 1.067 2.257c0 .711-.199 1.298-.596 1.76s-.975.762-1.735.898v.082c1.822.312 2.732 1.27 2.732 2.873 0 1.072-.362 1.91-1.087 2.511-.726.602-1.738.903-3.041.903h-4.186v-11.998zm1.396 5.137h2.298c.985 0 1.693-.155 2.126-.464.432-.309.648-.83.648-1.563 0-.673-.241-1.158-.723-1.457-.481-.298-1.247-.447-2.298-.447h-2.052v3.931zm0 1.182v4.489h2.503c.969 0 1.697-.188 2.188-.562.489-.375.734-.962.734-1.761 0-.744-.25-1.291-.751-1.641s-1.263-.525-2.285-.525h-2.389zm19.91-.336c0 1.92-.485 3.431-1.457 4.53-.971 1.1-2.321 1.649-4.05 1.649-1.768 0-3.131-.54-4.091-1.621-.961-1.081-1.44-2.606-1.44-4.576 0-1.953.481-3.467 1.444-4.542.963-1.075 2.33-1.613 4.104-1.613 1.723 0 3.069.547 4.037 1.641.969 1.096 1.453 2.606 1.453 4.532zm-9.561 0c0 1.625.347 2.857 1.038 3.697.692.84 1.698 1.26 3.017 1.26 1.329 0 2.333-.418 3.012-1.256.679-.837 1.018-2.071 1.018-3.701 0-1.614-.338-2.838-1.014-3.672s-1.676-1.251-2.999-1.251c-1.33 0-2.341.42-3.033 1.26-.693.838-1.039 2.06-1.039 3.663zm21.608 6.015h-1.592l-6.557-10.07h-.066a44.04 44.04 0 0 1 .132 3.25v6.82h-1.289v-11.999h1.576l6.541 10.029h.065a84.968 84.968 0 0 1-.074-1.424 24.85 24.85 0 0 1-.041-1.719v-6.886h1.305v11.999zm9.988 0h-6.688v-11.999h6.688v1.239h-5.293v3.866h4.973v1.231h-4.973v4.415h5.293v1.248zm2.257-.87c0-.366.083-.644.25-.833.167-.188.406-.283.718-.283.317 0 .565.094.743.283.178.189.267.467.267.833 0 .356-.091.629-.271.821-.181.191-.427.287-.739.287-.278 0-.51-.086-.693-.258s-.275-.456-.275-.85zm3.127 4.03c-.515 0-.919-.074-1.215-.222v-1.19c.389.109.794.164 1.215.164.542 0 .953-.164 1.235-.492.281-.329.422-.802.422-1.42v-11.999h1.396v11.884c0 1.039-.263 1.845-.788 2.417-.525.572-1.281.858-2.265.858zm13.008-6.352c0 1.056-.384 1.879-1.149 2.47s-1.806.886-3.118.886c-1.423 0-2.518-.183-3.283-.55v-1.346a8.592 8.592 0 0 0 1.608.492c.58.121 1.154.181 1.724.181.93 0 1.63-.177 2.101-.529.471-.353.706-.844.706-1.473 0-.416-.083-.756-.25-1.022-.167-.265-.446-.51-.837-.734-.392-.224-.986-.479-1.785-.763-1.116-.399-1.914-.873-2.393-1.42-.479-.547-.718-1.261-.718-2.142 0-.924.347-1.66 1.042-2.208.694-.547 1.614-.821 2.758-.821 1.192 0 2.289.219 3.291.657l-.436 1.215c-.99-.416-1.953-.624-2.889-.624-.738 0-1.315.159-1.731.476s-.624.758-.624 1.321c0 .416.077.756.229 1.022.153.265.412.509.776.73.363.222.92.467 1.67.735 1.258.449 2.124.93 2.598 1.444.473.515.71 1.182.71 2.003z\"/></svg>"

/***/ }),

/***/ "../src/components/backbonejs/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BackbonejsOriginalWordmark = __webpack_require__("../src/components/backbonejs/original-wordmark/BackbonejsOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BackbonejsOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/backbonejs/original/BackbonejsOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BackbonejsOriginal = __webpack_require__("../src/components/backbonejs/original/BackbonejsOriginal.svg");
	
	var _BackbonejsOriginal2 = _interopRequireDefault(_BackbonejsOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BackbonejsOriginal */
	function BackbonejsOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BackbonejsOriginal',
	    svg: _BackbonejsOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BackbonejsOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BackbonejsOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/backbonejs/original/BackbonejsOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#002A41\" d=\"M14.646 2.701v66.305l49.353 28.132V78.015l-33.017-18.82V29.633l33.017 18.821v-17.62L14.646 2.701z\"/><path fill=\"#0071B5\" d=\"M113.353 2.701v66.305L64 97.138V78.015l33.016-18.82V29.633L64 48.454v-17.62l49.353-28.133zM14.646 125.303V58.998l49.353-28.134v19.125L30.982 68.808v28.059l33.017-18.82v19.124l-49.353 28.133z\"/><path fill=\"#002A41\" d=\"M113.353 125.303V58.998L64 30.864v19.125l33.016 18.819v28.059L64 78.047v19.124l49.353 28.133z\"/></svg>"

/***/ }),

/***/ "../src/components/backbonejs/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BackbonejsOriginal = __webpack_require__("../src/components/backbonejs/original/BackbonejsOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BackbonejsOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/backbonejs/plain-wordmark/BackbonejsPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BackbonejsPlainWordmark = __webpack_require__("../src/components/backbonejs/plain-wordmark/BackbonejsPlainWordmark.svg");
	
	var _BackbonejsPlainWordmark2 = _interopRequireDefault(_BackbonejsPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BackbonejsPlainWordmark */
	function BackbonejsPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BackbonejsPlainWordmark',
	    svg: _BackbonejsPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BackbonejsPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BackbonejsPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/backbonejs/plain-wordmark/BackbonejsPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#002A41\" d=\"M63.5 27.652L23 4.5v100.895l40.5-23.152 40.5 23.152V4.5L63.5 27.652zm-19 27.294l20.233-11.532 20.231 11.532L64.733 66.48 44.5 54.946zM37 26.663l14.474 8.25L37 43.165V26.663zm0 40.067l13.389 7.631L37 81.993V66.73zm54 15.263l-13.39-7.632L91 66.73v15.263zm-14.475-47.08L91 26.663v16.501l-14.475-8.251zm-64.614 75.709h3.39c1.592 0 2.744.238 3.455.714s1.067 1.228 1.067 2.257c0 .711-.199 1.298-.596 1.76s-.975.762-1.735.898v.082c1.822.312 2.732 1.27 2.732 2.873 0 1.072-.362 1.91-1.087 2.511-.726.602-1.738.903-3.041.903H11.91v-11.998zm1.396 5.137h2.298c.985 0 1.693-.155 2.126-.464.432-.309.648-.83.648-1.563 0-.673-.241-1.158-.723-1.457-.481-.298-1.247-.447-2.298-.447h-2.052v3.931zm0 1.182v4.489h2.503c.969 0 1.697-.188 2.188-.562.489-.375.734-.962.734-1.761 0-.744-.25-1.291-.751-1.641s-1.263-.525-2.285-.525h-2.389zm17.037 5.679l-1.493-3.816h-4.81l-1.477 3.816h-1.412l4.744-12.047h1.173l4.72 12.047h-1.445zm-1.928-5.072l-1.396-3.718a20.157 20.157 0 0 1-.559-1.731c-.12.525-.292 1.103-.517 1.731l-1.411 3.718h3.883zm10.159-5.851c-1.318 0-2.359.439-3.122 1.317-.764.878-1.146 2.081-1.146 3.607 0 1.57.368 2.783 1.104 3.64.735.856 1.784 1.284 3.146 1.284.838 0 1.792-.15 2.864-.451v1.223c-.831.312-1.857.468-3.077.468-1.768 0-3.131-.536-4.091-1.608-.961-1.072-1.44-2.596-1.44-4.571 0-1.236.23-2.32.693-3.25a4.983 4.983 0 0 1 2.002-2.15c.873-.503 1.9-.755 3.082-.755 1.258 0 2.358.23 3.299.689l-.591 1.198c-.906-.428-1.815-.641-2.723-.641zm14.132 10.923h-1.641l-4.375-5.819-1.255 1.116v4.703H44.04v-11.999h1.396v5.95l5.44-5.95h1.649l-4.825 5.211 5.007 6.788zm1.649-11.998h3.39c1.592 0 2.744.238 3.455.714s1.067 1.228 1.067 2.257c0 .711-.199 1.298-.596 1.76s-.975.762-1.735.898v.082c1.822.312 2.732 1.27 2.732 2.873 0 1.072-.362 1.91-1.087 2.511-.726.602-1.738.903-3.041.903h-4.186v-11.998zm1.396 5.137h2.298c.985 0 1.693-.155 2.126-.464.432-.309.648-.83.648-1.563 0-.673-.241-1.158-.723-1.457-.481-.298-1.247-.447-2.298-.447h-2.052v3.931zm0 1.182v4.489h2.503c.969 0 1.697-.188 2.188-.562.489-.375.734-.962.734-1.761 0-.744-.25-1.291-.751-1.641s-1.263-.525-2.285-.525h-2.389zm19.91-.337c0 1.92-.485 3.431-1.457 4.53-.971 1.1-2.321 1.649-4.05 1.649-1.768 0-3.131-.54-4.091-1.621-.961-1.081-1.44-2.606-1.44-4.576 0-1.953.481-3.467 1.444-4.542.963-1.075 2.33-1.613 4.104-1.613 1.723 0 3.069.547 4.037 1.641.969 1.097 1.453 2.607 1.453 4.532zm-9.561 0c0 1.625.347 2.857 1.038 3.697.692.84 1.698 1.26 3.017 1.26 1.329 0 2.333-.418 3.012-1.256.679-.837 1.018-2.071 1.018-3.701 0-1.614-.338-2.838-1.014-3.672s-1.676-1.251-2.999-1.251c-1.33 0-2.341.42-3.033 1.26-.693.839-1.039 2.06-1.039 3.663zm21.608 6.016h-1.592l-6.557-10.07h-.066a44.04 44.04 0 0 1 .132 3.25v6.82h-1.289v-11.999h1.576l6.541 10.029h.065a84.968 84.968 0 0 1-.074-1.424 24.85 24.85 0 0 1-.041-1.719v-6.886h1.305v11.999zm9.988 0h-6.688v-11.999h6.688v1.239h-5.293v3.866h4.973v1.231h-4.973v4.415h5.293v1.248zm2.257-.87c0-.366.083-.644.25-.833.167-.188.406-.283.718-.283.317 0 .565.094.743.283.178.189.267.467.267.833 0 .356-.091.629-.271.821-.181.191-.427.287-.739.287-.278 0-.51-.086-.693-.258s-.275-.456-.275-.85zm3.127 4.03c-.515 0-.919-.074-1.215-.222v-1.19c.389.109.794.164 1.215.164.542 0 .953-.164 1.235-.492.281-.329.422-.802.422-1.42v-11.999h1.396v11.884c0 1.039-.263 1.845-.788 2.417-.525.572-1.281.858-2.265.858zm13.008-6.352c0 1.056-.384 1.879-1.149 2.47s-1.806.886-3.118.886c-1.423 0-2.518-.183-3.283-.55v-1.346a8.592 8.592 0 0 0 1.608.492c.58.121 1.154.181 1.724.181.93 0 1.63-.177 2.101-.529.471-.353.706-.844.706-1.473 0-.416-.083-.756-.25-1.022-.167-.265-.446-.51-.837-.734-.392-.224-.986-.479-1.785-.763-1.116-.399-1.914-.873-2.393-1.42-.479-.547-.718-1.261-.718-2.142 0-.924.347-1.66 1.042-2.208.694-.547 1.614-.821 2.758-.821 1.192 0 2.289.219 3.291.657l-.436 1.215c-.99-.416-1.953-.624-2.889-.624-.738 0-1.315.159-1.731.476s-.624.758-.624 1.321c0 .416.077.756.229 1.022.153.265.412.509.776.73.363.222.92.467 1.67.735 1.258.449 2.124.93 2.598 1.444.473.514.71 1.182.71 2.003z\"/></svg>"

/***/ }),

/***/ "../src/components/backbonejs/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BackbonejsPlainWordmark = __webpack_require__("../src/components/backbonejs/plain-wordmark/BackbonejsPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BackbonejsPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/backbonejs/plain/BackbonejsPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BackbonejsPlain = __webpack_require__("../src/components/backbonejs/plain/BackbonejsPlain.svg");
	
	var _BackbonejsPlain2 = _interopRequireDefault(_BackbonejsPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BackbonejsPlain */
	function BackbonejsPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BackbonejsPlain',
	    svg: _BackbonejsPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BackbonejsPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BackbonejsPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/backbonejs/plain/BackbonejsPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#002A41\" d=\"M64 31.124L15 3.239v121.522l49-27.885 49 27.885V3.239L64 31.124zM40.714 63.999l24.369-13.89 24.368 13.89-24.368 13.892-24.369-13.892zM32 29.934l17.433 9.937L32 49.809V29.934zm0 48.257l16.126 9.191L32 96.575V78.191zm65 18.384l-16.127-9.192L97 78.191v18.384zM79.566 39.87L97 29.934v19.875L79.566 39.87z\"/></svg>"

/***/ }),

/***/ "../src/components/backbonejs/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BackbonejsPlain = __webpack_require__("../src/components/backbonejs/plain/BackbonejsPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BackbonejsPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/behance/original-wordmark/BehanceOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BehanceOriginalWordmark = __webpack_require__("../src/components/behance/original-wordmark/BehanceOriginalWordmark.svg");
	
	var _BehanceOriginalWordmark2 = _interopRequireDefault(_BehanceOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BehanceOriginalWordmark */
	function BehanceOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BehanceOriginalWordmark',
	    svg: _BehanceOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BehanceOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BehanceOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/behance/original-wordmark/BehanceOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Behance\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#0071e0}</style></defs><title>Artboard 13</title><g id=\"orignal-wordmark\"><path id=\"path12\" class=\"cls-1\" d=\"M12.7 52.5a11.13 11.13 0 0 1 2.93.33 6.35 6.35 0 0 1 2.28.89 3.76 3.76 0 0 1 1.46 1.71 6.46 6.46 0 0 1 .49 2.6 4.54 4.54 0 0 1-.86 2.84 5.88 5.88 0 0 1-2.28 1.87 5.44 5.44 0 0 1 3.09 2.11 6.4 6.4 0 0 1 1.06 3.58 6.48 6.48 0 0 1-.65 2.93 5.41 5.41 0 0 1-1.79 2 8.42 8.42 0 0 1-2.6 1.14 12.09 12.09 0 0 1-2.93.41H2.06V52.5zm-.65 9.1a3.7 3.7 0 0 0 2.2-.6 2.37 2.37 0 0 0 .81-2 3.09 3.09 0 0 0-.24-1.3 2.31 2.31 0 0 0-.73-.81A4.08 4.08 0 0 0 13 56.4a6.57 6.57 0 0 0-1.3-.08H7v5.28zm.24 9.59a7.16 7.16 0 0 0 1.39-.19 2.85 2.85 0 0 0 1.14-.49 2.9 2.9 0 0 0 .81-.89 3.88 3.88 0 0 0 .37-1.43 3.13 3.13 0 0 0-1-2.52 4.29 4.29 0 0 0-2.6-.73H7v6.26z\"/><path id=\"path14\" class=\"cls-1\" d=\"M28 71.11a4 4 0 0 0 2.93 1 4.44 4.44 0 0 0 2.36-.65A3.25 3.25 0 0 0 34.48 70h4a7.93 7.93 0 0 1-2.93 4.23 8.68 8.68 0 0 1-4.71 1.3 9.56 9.56 0 0 1-3.49-.65 6.49 6.49 0 0 1-2.6-1.79 6.45 6.45 0 0 1-1.63-2.68 9.56 9.56 0 0 1-.57-3.49 9.41 9.41 0 0 1 .57-3.41 8.76 8.76 0 0 1 1.71-2.76 8.25 8.25 0 0 1 2.6-1.79 9.12 9.12 0 0 1 3.41-.65 7.58 7.58 0 0 1 3.66.81 6.6 6.6 0 0 1 2.5 2.16 9.85 9.85 0 0 1 1.46 3.09 17.05 17.05 0 0 1 .16 3.58H26.84A4.67 4.67 0 0 0 28 71.11zm5.12-8.53a3.52 3.52 0 0 0-2.52-.89 3.87 3.87 0 0 0-1.79.41 4.27 4.27 0 0 0-1.14.89 2.17 2.17 0 0 0-.57 1.14 5.59 5.59 0 0 0-.16 1.06h7.31a4.31 4.31 0 0 0-1.15-2.61z\"/><path id=\"path16\" class=\"cls-1\" d=\"M45 52.5V61a4.78 4.78 0 0 1 2.19-2 6.15 6.15 0 0 1 2.6-.65 7.31 7.31 0 0 1 2.93.49 4.41 4.41 0 0 1 1.79 1.38 5.54 5.54 0 0 1 .89 2.11 14 14 0 0 1 .3 2.67v10h-4.47v-9.17a5.69 5.69 0 0 0-.65-3 2.38 2.38 0 0 0-2.19-1 3.12 3.12 0 0 0-2.6 1.06 6 6 0 0 0-.79 3.59V75h-4.5V52.5z\"/><path id=\"path18\" class=\"cls-1\" d=\"M58.95 61.11a6 6 0 0 1 1.79-1.71 7.94 7.94 0 0 1 2.44-.89 15 15 0 0 1 2.68-.24c.81 0 1.63.08 2.52.16a6.74 6.74 0 0 1 2.28.65 4.75 4.75 0 0 1 1.71 1.38 4.05 4.05 0 0 1 .63 2.36v8.53a17.16 17.16 0 0 0 .16 2.11 3.41 3.41 0 0 0 .58 1.54h-4.55a2 2 0 0 1-.33-.73 2.76 2.76 0 0 1-.08-.81A6.23 6.23 0 0 1 66.26 75a9.09 9.09 0 0 1-2.93.41 6.53 6.53 0 0 1-2.19-.33 5.28 5.28 0 0 1-1.79-.89 4.68 4.68 0 0 1-1.22-1.54 5.87 5.87 0 0 1-.41-2.19 4.72 4.72 0 0 1 .49-2.28 5.32 5.32 0 0 1 1.22-1.46 6 6 0 0 1 1.79-.81 15 15 0 0 1 2-.41l2-.24q1-.12 1.71-.24a4.25 4.25 0 0 0 1.22-.57 1.16 1.16 0 0 0 .41-1.06 2.15 2.15 0 0 0-.24-1.14 2.47 2.47 0 0 0-.65-.65 2.91 2.91 0 0 0-.89-.33 5 5 0 0 0-1.14-.08 3 3 0 0 0-2 .57 2.73 2.73 0 0 0-.89 1.87h-4.53a4.85 4.85 0 0 1 .73-2.52zm8.86 6.34c-.24.08-.57.16-.89.24s-.65.08-1.06.16-.73.08-1.06.16l-1 .24a1.91 1.91 0 0 0-.81.41 2.19 2.19 0 0 0-.57.65 1.58 1.58 0 0 0-.24 1.06 1.73 1.73 0 0 0 .24 1A2.19 2.19 0 0 0 63 72a2.91 2.91 0 0 0 .89.33 4.29 4.29 0 0 0 1.06.08A4.48 4.48 0 0 0 67 72a3.27 3.27 0 0 0 1-1.05 2.42 2.42 0 0 0 .41-1.22 4.66 4.66 0 0 0 .08-1V67a3.29 3.29 0 0 1-.68.45z\"/><path id=\"path20\" class=\"cls-1\" d=\"M79.75 58.68V61h.08a4.78 4.78 0 0 1 2.19-2 6.86 6.86 0 0 1 2.76-.65 7.31 7.31 0 0 1 2.93.49 3.93 3.93 0 0 1 1.79 1.38 7.26 7.26 0 0 1 1 2.11 14 14 0 0 1 .22 2.67v10h-4.47v-9.17a5.69 5.69 0 0 0-.65-3 2.48 2.48 0 0 0-2.28-1.06A3.25 3.25 0 0 0 80.65 63a6 6 0 0 0-.81 3.58v8.53h-4.48V58.68z\"/><path id=\"path22\" class=\"cls-1\" d=\"M100.72 61.6a3.09 3.09 0 0 0-1.79.49 3.76 3.76 0 0 0-1.22 1.3 5.33 5.33 0 0 0-.65 1.71 7.28 7.28 0 0 0-.16 1.9 13.29 13.29 0 0 0 .16 1.79 4.87 4.87 0 0 0 .65 1.63 4.08 4.08 0 0 0 1.14 1.22 3.09 3.09 0 0 0 1.79.49 3.66 3.66 0 0 0 2.52-.89 3.77 3.77 0 0 0 1.06-2.44h4.31a7.5 7.5 0 0 1-2.52 5 8.16 8.16 0 0 1-5.36 1.71 8.7 8.7 0 0 1-3.33-.65 7.25 7.25 0 0 1-2.6-1.71A8 8 0 0 1 93 70.46a9 9 0 0 1-.57-3.33 9.56 9.56 0 0 1 .57-3.5 9 9 0 0 1 1.63-2.84 8.49 8.49 0 0 1 2.6-1.87 9.56 9.56 0 0 1 3.49-.65 10.32 10.32 0 0 1 2.76.41 7.07 7.07 0 0 1 2.36 1.14 5 5 0 0 1 1.71 2 6.9 6.9 0 0 1 .73 2.76h-4.39a2.84 2.84 0 0 0-3.17-2.98z\"/><path id=\"rect24\" class=\"cls-1\" d=\"M25.95 54.04h9.1v2.19h-9.1z\"/><path id=\"path26\" class=\"cls-1\" d=\"M115.27 71.11a4.1 4.1 0 0 0 2.93 1 4.44 4.44 0 0 0 2.36-.65 3.25 3.25 0 0 0 1.21-1.46h3.9a7.93 7.93 0 0 1-2.93 4.23A8.68 8.68 0 0 1 118 75.5a9.56 9.56 0 0 1-3.49-.65 7.48 7.48 0 0 1-4.23-4.47 9.56 9.56 0 0 1-.57-3.49 9.41 9.41 0 0 1 .57-3.41 8.76 8.76 0 0 1 1.72-2.77 8.25 8.25 0 0 1 2.6-1.79 9.45 9.45 0 0 1 3.41-.65 7.05 7.05 0 0 1 3.58.81 6.6 6.6 0 0 1 2.52 2.19 9.85 9.85 0 0 1 1.46 3.09 10.79 10.79 0 0 1 .33 3.66h-11.77a4.61 4.61 0 0 0 1.14 3.09zm5.2-8.53a3.52 3.52 0 0 0-2.52-.89 3.87 3.87 0 0 0-1.79.41 3.28 3.28 0 0 0-1.16.9 3 3 0 0 0-.57 1.14 5.59 5.59 0 0 0-.16 1.06h7.31a5.55 5.55 0 0 0-1.14-2.6z\"/></g></svg>"

/***/ }),

/***/ "../src/components/behance/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BehanceOriginalWordmark = __webpack_require__("../src/components/behance/original-wordmark/BehanceOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BehanceOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/behance/original/BehanceOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BehanceOriginal = __webpack_require__("../src/components/behance/original/BehanceOriginal.svg");
	
	var _BehanceOriginal2 = _interopRequireDefault(_BehanceOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BehanceOriginal */
	function BehanceOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BehanceOriginal',
	    svg: _BehanceOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BehanceOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BehanceOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/behance/original/BehanceOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Behance\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:url(#linear-gradient)}.cls-2{fill:#fff}</style><linearGradient id=\"linear-gradient\" x1=\"64\" y1=\"2.16\" x2=\"64\" y2=\"125.84\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#005cff\"/><stop offset=\"1\" stop-color=\"#0047ad\"/></linearGradient></defs><title>Artboard 12</title><g id=\"original\"><rect class=\"cls-1\" x=\"2.16\" y=\"2.16\" width=\"123.68\" height=\"123.67\" rx=\"14.59\" ry=\"14.59\"/><path class=\"cls-2\" d=\"M52.63 60.28s10.5-.78 10.5-13.09-8.59-18.32-19.47-18.32H7.86v68.8h35.8s21.85.69 21.85-20.31c0 0 .96-17.08-12.88-17.08zm-29-19.18h20s4.87 0 4.87 7.16-2.86 8.2-6.11 8.2H23.64zm19.1 44.34H23.64V67.06h20s7.25-.1 7.25 9.45c.02 7.95-5.28 8.85-8.15 8.93zM94.66 46.38c-26.46 0-26.43 26.43-26.43 26.43s-1.82 26.3 26.43 26.3c0 0 23.54 1.34 23.54-18.29h-12.1s.4 7.4-11 7.4c0 0-12.11.81-12.11-12h35.65s3.87-29.84-23.98-29.84zm10.76 20.68h-22.6s1.48-10.6 12.11-10.6 10.49 10.6 10.49 10.6zM79.86 32.93h28.38v8.47H79.86z\"/></g></svg>"

/***/ }),

/***/ "../src/components/behance/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BehanceOriginal = __webpack_require__("../src/components/behance/original/BehanceOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BehanceOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/behance/plain-wordmark/BehancePlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BehancePlainWordmark = __webpack_require__("../src/components/behance/plain-wordmark/BehancePlainWordmark.svg");
	
	var _BehancePlainWordmark2 = _interopRequireDefault(_BehancePlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BehancePlainWordmark */
	function BehancePlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BehancePlainWordmark',
	    svg: _BehancePlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BehancePlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BehancePlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/behance/plain-wordmark/BehancePlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><title>Artboard 15</title><path d=\"M12.7 52.5a11.13 11.13 0 0 1 2.93.33 6.35 6.35 0 0 1 2.28.89 3.76 3.76 0 0 1 1.46 1.71 6.46 6.46 0 0 1 .49 2.6 4.54 4.54 0 0 1-.86 2.84 5.88 5.88 0 0 1-2.28 1.87 5.44 5.44 0 0 1 3.09 2.11 6.4 6.4 0 0 1 1.06 3.58 6.48 6.48 0 0 1-.65 2.93 5.41 5.41 0 0 1-1.79 2 8.42 8.42 0 0 1-2.6 1.14 12.09 12.09 0 0 1-2.93.41H2.06V52.5zm-.65 9.1a3.7 3.7 0 0 0 2.2-.6 2.37 2.37 0 0 0 .81-2 3.09 3.09 0 0 0-.24-1.3 2.31 2.31 0 0 0-.73-.81A4.08 4.08 0 0 0 13 56.4a6.57 6.57 0 0 0-1.3-.08H7v5.28zm.24 9.59a7.16 7.16 0 0 0 1.39-.19 2.85 2.85 0 0 0 1.14-.49 2.9 2.9 0 0 0 .81-.89 3.88 3.88 0 0 0 .37-1.43 3.13 3.13 0 0 0-1-2.52 4.29 4.29 0 0 0-2.6-.73H7v6.26zM28 71.11a4 4 0 0 0 2.93 1 4.44 4.44 0 0 0 2.36-.65A3.25 3.25 0 0 0 34.48 70h4a7.93 7.93 0 0 1-2.93 4.23 8.68 8.68 0 0 1-4.71 1.3 9.56 9.56 0 0 1-3.49-.65 6.49 6.49 0 0 1-2.6-1.79 6.45 6.45 0 0 1-1.63-2.68 9.56 9.56 0 0 1-.57-3.49 9.41 9.41 0 0 1 .57-3.41 8.76 8.76 0 0 1 1.71-2.76 8.25 8.25 0 0 1 2.6-1.79 9.12 9.12 0 0 1 3.41-.65 7.58 7.58 0 0 1 3.66.81 6.6 6.6 0 0 1 2.5 2.16 9.85 9.85 0 0 1 1.46 3.09 17.05 17.05 0 0 1 .16 3.58H26.84A4.67 4.67 0 0 0 28 71.11zm5.12-8.53a3.52 3.52 0 0 0-2.52-.89 3.87 3.87 0 0 0-1.79.41 4.27 4.27 0 0 0-1.14.89 2.17 2.17 0 0 0-.57 1.14 5.59 5.59 0 0 0-.16 1.06h7.31a4.31 4.31 0 0 0-1.15-2.61zM45 52.5V61a4.78 4.78 0 0 1 2.19-2 6.15 6.15 0 0 1 2.6-.65 7.31 7.31 0 0 1 2.93.49 4.41 4.41 0 0 1 1.79 1.38 5.54 5.54 0 0 1 .89 2.11 14 14 0 0 1 .3 2.67v10h-4.47v-9.17a5.69 5.69 0 0 0-.65-3 2.38 2.38 0 0 0-2.19-1 3.12 3.12 0 0 0-2.6 1.06 6 6 0 0 0-.79 3.59V75h-4.5V52.5zM58.95 61.11a6 6 0 0 1 1.79-1.71 7.94 7.94 0 0 1 2.44-.89 15 15 0 0 1 2.68-.24c.81 0 1.63.08 2.52.16a6.74 6.74 0 0 1 2.28.65 4.75 4.75 0 0 1 1.71 1.38 4.05 4.05 0 0 1 .63 2.36v8.53a17.16 17.16 0 0 0 .16 2.11 3.41 3.41 0 0 0 .58 1.54h-4.55a2 2 0 0 1-.33-.73 2.76 2.76 0 0 1-.08-.81A6.23 6.23 0 0 1 66.26 75a9.09 9.09 0 0 1-2.93.41 6.53 6.53 0 0 1-2.19-.33 5.28 5.28 0 0 1-1.79-.89 4.68 4.68 0 0 1-1.22-1.54 5.87 5.87 0 0 1-.41-2.19 4.72 4.72 0 0 1 .49-2.28 5.32 5.32 0 0 1 1.22-1.46 6 6 0 0 1 1.79-.81 15 15 0 0 1 2-.41l2-.24q1-.12 1.71-.24a4.25 4.25 0 0 0 1.22-.57 1.16 1.16 0 0 0 .41-1.06 2.15 2.15 0 0 0-.24-1.14 2.47 2.47 0 0 0-.65-.65 2.91 2.91 0 0 0-.89-.33 5 5 0 0 0-1.14-.08 3 3 0 0 0-2 .57 2.73 2.73 0 0 0-.89 1.87h-4.53a4.85 4.85 0 0 1 .73-2.52zm8.86 6.34c-.24.08-.57.16-.89.24s-.65.08-1.06.16-.73.08-1.06.16l-1 .24a1.91 1.91 0 0 0-.81.41 2.19 2.19 0 0 0-.57.65 1.58 1.58 0 0 0-.24 1.06 1.73 1.73 0 0 0 .24 1A2.19 2.19 0 0 0 63 72a2.91 2.91 0 0 0 .89.33 4.29 4.29 0 0 0 1.06.08A4.48 4.48 0 0 0 67 72a3.27 3.27 0 0 0 1-1.05 2.42 2.42 0 0 0 .41-1.22 4.66 4.66 0 0 0 .08-1V67a3.29 3.29 0 0 1-.68.45zM79.75 58.68V61h.08a4.78 4.78 0 0 1 2.19-2 6.86 6.86 0 0 1 2.76-.65 7.31 7.31 0 0 1 2.93.49 3.93 3.93 0 0 1 1.79 1.38 7.26 7.26 0 0 1 1 2.11 14 14 0 0 1 .22 2.67v10h-4.47v-9.17a5.69 5.69 0 0 0-.65-3 2.48 2.48 0 0 0-2.28-1.06A3.25 3.25 0 0 0 80.65 63a6 6 0 0 0-.81 3.58v8.53h-4.48V58.68zM100.72 61.6a3.09 3.09 0 0 0-1.79.49 3.76 3.76 0 0 0-1.22 1.3 5.33 5.33 0 0 0-.65 1.71 7.28 7.28 0 0 0-.16 1.9 13.29 13.29 0 0 0 .16 1.79 4.87 4.87 0 0 0 .65 1.63 4.08 4.08 0 0 0 1.14 1.22 3.09 3.09 0 0 0 1.79.49 3.66 3.66 0 0 0 2.52-.89 3.77 3.77 0 0 0 1.06-2.44h4.31a7.5 7.5 0 0 1-2.52 5 8.16 8.16 0 0 1-5.36 1.71 8.7 8.7 0 0 1-3.33-.65 7.25 7.25 0 0 1-2.6-1.71A8 8 0 0 1 93 70.46a9 9 0 0 1-.57-3.33 9.56 9.56 0 0 1 .57-3.5 9 9 0 0 1 1.63-2.84 8.49 8.49 0 0 1 2.6-1.87 9.56 9.56 0 0 1 3.49-.65 10.32 10.32 0 0 1 2.76.41 7.07 7.07 0 0 1 2.36 1.14 5 5 0 0 1 1.71 2 6.9 6.9 0 0 1 .73 2.76h-4.39a2.84 2.84 0 0 0-3.17-2.98zM25.95 54.04h9.1v2.19h-9.1zM115.27 71.11a4.1 4.1 0 0 0 2.93 1 4.44 4.44 0 0 0 2.36-.65 3.25 3.25 0 0 0 1.21-1.46h3.9a7.93 7.93 0 0 1-2.93 4.23A8.68 8.68 0 0 1 118 75.5a9.56 9.56 0 0 1-3.49-.65 7.48 7.48 0 0 1-4.23-4.47 9.56 9.56 0 0 1-.57-3.49 9.41 9.41 0 0 1 .57-3.41 8.76 8.76 0 0 1 1.72-2.77 8.25 8.25 0 0 1 2.6-1.79 9.45 9.45 0 0 1 3.41-.65 7.05 7.05 0 0 1 3.58.81 6.6 6.6 0 0 1 2.52 2.19 9.85 9.85 0 0 1 1.46 3.09 10.79 10.79 0 0 1 .33 3.66h-11.77a4.61 4.61 0 0 0 1.14 3.09zm5.2-8.53a3.52 3.52 0 0 0-2.52-.89 3.87 3.87 0 0 0-1.79.41 3.28 3.28 0 0 0-1.16.9 3 3 0 0 0-.57 1.14 5.59 5.59 0 0 0-.16 1.06h7.31a5.55 5.55 0 0 0-1.14-2.6z\"/></svg>"

/***/ }),

/***/ "../src/components/behance/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BehancePlainWordmark = __webpack_require__("../src/components/behance/plain-wordmark/BehancePlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BehancePlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/behance/plain/BehancePlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BehancePlain = __webpack_require__("../src/components/behance/plain/BehancePlain.svg");
	
	var _BehancePlain2 = _interopRequireDefault(_BehancePlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BehancePlain */
	function BehancePlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BehancePlain',
	    svg: _BehancePlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BehancePlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BehancePlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/behance/plain/BehancePlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Behance\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#1d1d1b}</style></defs><title>Artboard 14</title><g id=\"plain\"><path class=\"cls-1\" d=\"M48.53 48.26c0-7.16-4.87-7.16-4.87-7.16h-20v15.35h18.76c3.24 0 6.11-1.04 6.11-8.19zM43.66 67.06h-20v18.38h19.1c2.87-.08 8.18-1 8.18-8.94-.03-9.5-7.28-9.44-7.28-9.44zM94.93 56.45c-10.63 0-12.11 10.6-12.11 10.6h22.6s.14-10.6-10.49-10.6z\"/><path class=\"cls-1\" d=\"M111.25 2.16h-94.5A14.59 14.59 0 0 0 2.16 16.75v94.49a14.59 14.59 0 0 0 14.59 14.59h94.49a14.59 14.59 0 0 0 14.59-14.59V16.75a14.59 14.59 0 0 0-14.58-14.59zM79.86 32.92h28.38v8.48H79.86zM65.51 77.36c0 21-21.85 20.31-21.85 20.31H7.86v-68.8h35.8c10.88 0 19.47 6 19.47 18.32s-10.5 13.09-10.5 13.09c13.84 0 12.88 17.08 12.88 17.08zm53.09-1.12H83c0 12.78 12.11 12 12.11 12 11.43 0 11-7.4 11-7.4h12.09c0 19.64-23.54 18.29-23.54 18.29-28.25 0-26.43-26.3-26.43-26.3s0-26.43 26.43-26.43c27.85-.02 23.95 29.84 23.95 29.84z\"/></g></svg>"

/***/ }),

/***/ "../src/components/behance/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BehancePlain = __webpack_require__("../src/components/behance/plain/BehancePlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BehancePlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bitbucket/original-wordmark/BitbucketOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BitbucketOriginalWordmark = __webpack_require__("../src/components/bitbucket/original-wordmark/BitbucketOriginalWordmark.svg");
	
	var _BitbucketOriginalWordmark2 = _interopRequireDefault(_BitbucketOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BitbucketOriginalWordmark */
	function BitbucketOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BitbucketOriginalWordmark',
	    svg: _BitbucketOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BitbucketOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BitbucketOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bitbucket/original-wordmark/BitbucketOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#205081\" d=\"M47.962 108.392c-1.767 0-3.553.436-4.763.89v-6.622a.604.604 0 0 0-.605-.603h-3.57a.6.6 0 0 0-.6.603v22.802c0 .29.21.54.495.592 2.202.402 4.8.542 6.36.542 6.702 0 8.073-2.85 8.073-7.13v-4.99c0-4.04-1.814-6.084-5.39-6.084zm-2.477 14.06c-.904 0-1.652-.035-2.287-.11v-8.92c.983-.44 2.365-.884 3.474-.884 1.352 0 1.904.53 1.904 1.833v5.234c0 1.888-.477 2.848-3.09 2.848zM69.77 108.74h-3.564a.603.603 0 0 0-.603.6v11.294c-1.286.652-3.095 1.328-4.173 1.328-.803 0-1.1-.297-1.1-1.1V109.34c0-.328-.274-.6-.61-.6h-3.562a.6.6 0 0 0-.604.6v11.977c0 3.503 1.38 5.28 4.094 5.28 1.89 0 4.466-.65 6.64-1.672l.262.89c.078.257.31.434.58.434l2.64-.002c.333 0 .603-.27.603-.603V109.34c0-.33-.27-.6-.603-.6zm14.36 13.817a.612.612 0 0 0-.255-.41.615.615 0 0 0-.478-.09c-1.023.234-2.096.36-3.103.36-2.26 0-2.915-.576-2.915-2.566v-4.712c0-1.992.653-2.568 2.914-2.568.538 0 1.877.077 3.103.358a.602.602 0 0 0 .733-.5l.424-2.822a.6.6 0 0 0-.424-.666c-1.375-.405-2.986-.548-3.937-.548-5.39 0-7.588 1.963-7.588 6.78v4.644c0 4.816 2.198 6.78 7.588 6.78 1.308 0 2.817-.21 3.937-.546a.603.603 0 0 0 .424-.667l-.424-2.826zm24.572-14.165c-4.784 0-7.31 2.382-7.31 6.886v4.502c0 4.65 2.37 6.816 7.452 6.816 2.068 0 4.273-.362 6.048-.99a.613.613 0 0 0 .392-.695l-.53-2.55a.607.607 0 0 0-.754-.458c-1.642.463-3.197.69-4.772.69-2.597 0-3.06-.843-3.06-2.604v-.616h8.854a.6.6 0 0 0 .603-.605v-3.282c0-4.84-2.2-7.093-6.923-7.093zm-2.535 7.045v-.578c0-1.68.82-2.464 2.57-2.464 1.936 0 2.323.944 2.323 2.463v.577h-4.893zm-83.254-6.704h-3.565a.605.605 0 0 0-.604.603v16.302c0 .334.27.604.604.604h3.565c.34 0 .607-.27.607-.604v-16.302a.602.602 0 0 0-.607-.603zm0-6.678h-3.565a.607.607 0 0 0-.604.605v3.07c0 .34.27.606.604.606h3.565a.6.6 0 0 0 .607-.605v-3.07a.604.604 0 0 0-.607-.605zm-8.979 11.755c1.478-.812 2.12-1.95 2.12-3.703v-2.398c0-3.512-2.108-5.216-6.433-5.216H.82c-.33 0-.6.27-.6.602v22.54c0 .334.27.604.6.604h9.43c4.198 0 6.608-2.04 6.608-5.597v-2.476c0-2.12-1.077-3.705-2.922-4.356zm-8.803-7.17h3.965c1.795 0 2.045.783 2.045 1.62v2.055c0 1.336-.624 1.906-2.08 1.906h-.857a.605.605 0 0 0-.608.606v2.832c0 .335.27.606.608.606h1.55c1.557 0 2.188.602 2.188 2.08v1.742c0 1.503-.646 2.01-2.57 2.01H5.13V106.64zm31.176 16.137a.6.6 0 0 0-.258-.415.606.606 0 0 0-.484-.083c-.63.156-1.234.242-1.7.242-.882 0-1.273-.384-1.273-1.24v-8.64h3.463c.333 0 .603-.27.603-.603v-2.697a.604.604 0 0 0-.604-.603h-3.463v-4.153a.606.606 0 0 0-.69-.597l-3.566.496a.606.606 0 0 0-.52.6v3.654h-1.944a.605.605 0 0 0-.604.603v2.696c0 .333.27.603.603.603h1.944v9.198c0 3.157 1.657 4.76 4.93 4.76.934 0 2.516-.217 3.55-.576a.6.6 0 0 0 .4-.662l-.39-2.585zm91.077-.001a.6.6 0 0 0-.74-.497c-.636.155-1.235.242-1.705.242-.88 0-1.278-.385-1.278-1.242v-8.638h3.467a.6.6 0 0 0 .6-.603v-2.697a.6.6 0 0 0-.6-.603h-3.468v-4.154a.59.59 0 0 0-.204-.454.606.606 0 0 0-.482-.143l-3.565.495a.605.605 0 0 0-.52.597v3.658h-1.942c-.33 0-.603.27-.603.603v2.696c0 .33.273.602.603.602h1.942v9.2c0 3.154 1.66 4.756 4.933 4.756.936 0 2.515-.216 3.55-.574a.606.606 0 0 0 .402-.662l-.39-2.586zm-26.546 2.458l-4.767-7.87 4.6-7.75a.602.602 0 0 0-.52-.912h-3.937a.603.603 0 0 0-.523.302l-4.375 7.584v-13.925a.603.603 0 0 0-.604-.604h-3.564a.604.604 0 0 0-.604.603v22.975c0 .333.27.604.604.604h3.565c.334 0 .605-.27.605-.604v-7.52l4.655 7.79c.11.182.306.294.518.294h3.869a.605.605 0 0 0 .48-.968z\"/><g fill=\"#205081\"><path d=\"M64 4.43c-22 0-39.624 5.87-39.624 13.156 0 1.92 4.776 29.44 6.665 40.356.848 4.895 13.468 12.072 32.97 12.072l-.01-.058v.058c20 0 32.187-7.177 33.034-12.072 1.89-10.914 6.636-38.436 6.636-40.356C103.67 10.3 86 4.43 64 4.43zm.063 56.742c-6.962 0-12.606-5.645-12.606-12.606 0-6.963 5.644-12.606 12.606-12.606S76.67 41.603 76.67 48.566c0 6.962-5.645 12.606-12.607 12.606zm-.007-39.52c-14.026-.022-25.393-2.458-25.388-5.443.005-2.986 11.38-5.386 25.406-5.364 14.026.022 25.392 2.46 25.388 5.444-.005 2.986-11.38 5.385-25.406 5.363z\"/><path d=\"M92.565 68.88c-.603 0-1.086.428-1.086.428s-9.767 7.733-27.417 7.734c-17.65 0-27.416-7.734-27.416-7.734s-.483-.427-1.086-.427c-.72 0-1.402.485-1.402 1.552 0 .113.01.225.032.335 1.516 8.112 2.623 13.877 2.818 14.753C38.33 91.488 50.004 96 64.062 96h.002c14.058 0 25.732-4.512 27.055-10.48.193-.875 1.3-6.635 2.817-14.748.02-.11.032-.225.032-.338-.002-1.067-.685-1.553-1.405-1.553z\"/><circle cx=\"64.051\" cy=\"48.562\" r=\"6.318\"/></g></svg>"

/***/ }),

/***/ "../src/components/bitbucket/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BitbucketOriginalWordmark = __webpack_require__("../src/components/bitbucket/original-wordmark/BitbucketOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BitbucketOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bitbucket/original/BitbucketOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BitbucketOriginal = __webpack_require__("../src/components/bitbucket/original/BitbucketOriginal.svg");
	
	var _BitbucketOriginal2 = _interopRequireDefault(_BitbucketOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BitbucketOriginal */
	function BitbucketOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BitbucketOriginal',
	    svg: _BitbucketOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BitbucketOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BitbucketOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bitbucket/original/BitbucketOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#205081\"><path d=\"M64 1.023v.002-.002c-30 0-54.557 8.074-54.557 18.1 0 2.64 6.55 40.504 9.147 55.52 1.165 6.733 18.56 16.607 45.39 16.607l.02-.08v.08c27 0 44.238-9.874 45.403-16.61 2.598-15.015 9.15-52.878 9.15-55.518C118.554 9.097 94 1.022 64 1.022zm0 78.062c-9.578 0-17.343-7.766-17.343-17.343C46.657 52.164 54.422 44.4 64 44.4s17.343 7.764 17.343 17.343c0 9.577-7.765 17.342-17.343 17.342zm-.01-54.368c-19.296-.03-34.934-3.384-34.928-7.49.007-4.107 15.656-7.41 34.952-7.378 19.296.03 34.934 3.382 34.927 7.49-.005 4.106-15.653 7.407-34.95 7.377z\"/><path d=\"M103.212 89.69c-.83 0-1.494.588-1.494.588S88.283 100.918 64 100.918s-37.718-10.64-37.718-10.64-.665-.587-1.494-.587c-.99 0-1.93.666-1.93 2.135 0 .155.015.31.044.462 2.085 11.16 3.61 19.09 3.876 20.296 1.82 8.21 17.88 14.417 37.22 14.417H64c19.342 0 35.402-6.207 37.222-14.417.268-1.205 1.79-9.13 3.876-20.29.028-.153.044-.31.044-.465 0-1.47-.94-2.137-1.93-2.137z\"/><circle cx=\"63.983\" cy=\"61.737\" r=\"8.691\"/></g></svg>"

/***/ }),

/***/ "../src/components/bitbucket/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BitbucketOriginal = __webpack_require__("../src/components/bitbucket/original/BitbucketOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BitbucketOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bootstrap/plain-wordmark/BootstrapPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BootstrapPlainWordmark = __webpack_require__("../src/components/bootstrap/plain-wordmark/BootstrapPlainWordmark.svg");
	
	var _BootstrapPlainWordmark2 = _interopRequireDefault(_BootstrapPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BootstrapPlainWordmark */
	function BootstrapPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BootstrapPlainWordmark',
	    svg: _BootstrapPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BootstrapPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BootstrapPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bootstrap/plain-wordmark/BootstrapPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#5B4282\" d=\"M9.531 112.586h4.161c1.896 0 3.273.27 4.129.81.857.54 1.285 1.398 1.285 2.575 0 .799-.188 1.454-.563 1.966s-.874.82-1.496.924v.091c.848.189 1.459.543 1.834 1.061s.563 1.207.563 2.067c0 1.22-.44 2.171-1.322 2.854-.881.683-2.078 1.024-3.59 1.024H9.531v-13.372zm2.835 5.296h1.646c.768 0 1.325-.119 1.669-.356.345-.238.517-.631.517-1.18 0-.512-.187-.879-.562-1.102s-.968-.334-1.779-.334h-1.491v2.972zm0 2.25v3.485h1.848c.78 0 1.356-.149 1.729-.448s.558-.756.558-1.372c0-1.109-.793-1.665-2.378-1.665h-1.757zm21.886-.878c0 2.213-.549 3.915-1.646 5.104s-2.67 1.784-4.719 1.784-3.622-.595-4.719-1.784c-1.098-1.189-1.646-2.896-1.646-5.122s.55-3.925 1.651-5.099 2.678-1.761 4.733-1.761 3.626.592 4.715 1.774c1.087 1.183 1.631 2.885 1.631 5.104zm-9.758 0c0 1.494.283 2.619.851 3.375.567.756 1.414 1.134 2.542 1.134 2.262 0 3.393-1.503 3.393-4.509 0-3.012-1.125-4.518-3.375-4.518-1.128 0-1.979.379-2.552 1.139s-.859 1.885-.859 3.379zm24.667 0c0 2.213-.549 3.915-1.646 5.104s-2.67 1.784-4.719 1.784-3.622-.595-4.719-1.784c-1.098-1.189-1.646-2.896-1.646-5.122s.55-3.925 1.651-5.099 2.678-1.761 4.733-1.761 3.626.592 4.715 1.774c1.086 1.183 1.631 2.885 1.631 5.104zm-9.759 0c0 1.494.283 2.619.851 3.375.567.756 1.414 1.134 2.542 1.134 2.262 0 3.393-1.503 3.393-4.509 0-3.012-1.125-4.518-3.375-4.518-1.128 0-1.979.379-2.552 1.139s-.859 1.885-.859 3.379zm17.688 6.704h-2.835v-11.012h-3.631v-2.36h10.097v2.36H57.09v11.012zm13.581-3.713c0 1.208-.434 2.159-1.303 2.854-.869.695-2.078 1.043-3.626 1.043-1.427 0-2.689-.269-3.786-.805v-2.634c.902.402 1.666.686 2.291.851s1.196.247 1.715.247c.622 0 1.099-.119 1.431-.356.333-.238.499-.591.499-1.061 0-.262-.073-.495-.219-.7-.146-.204-.361-.401-.645-.59s-.861-.491-1.733-.905c-.817-.384-1.43-.753-1.838-1.107a4.158 4.158 0 0 1-.979-1.234c-.244-.47-.366-1.019-.366-1.646 0-1.183.401-2.113 1.203-2.79s1.91-1.015 3.325-1.015c.695 0 1.358.082 1.989.247.631.165 1.291.396 1.98.695l-.915 2.204c-.713-.292-1.303-.497-1.77-.613a5.69 5.69 0 0 0-1.376-.174c-.537 0-.948.125-1.235.375-.287.25-.43.576-.43.979 0 .25.058.468.174.654.116.186.3.366.553.54.253.174.852.486 1.797.938 1.25.598 2.107 1.197 2.57 1.797s.694 1.334.694 2.206zm7.583 3.713h-2.835v-11.012h-3.631v-2.36h10.097v2.36h-3.631v11.012zm8.524-5.131v5.131h-2.835v-13.372h3.896c1.817 0 3.161.331 4.033.992.872.662 1.308 1.667 1.308 3.014 0 .787-.216 1.486-.649 2.099s-1.046 1.093-1.838 1.44c2.012 3.006 3.323 4.948 3.933 5.826H91.48l-3.192-5.131h-1.51zm0-2.305h.915c.896 0 1.558-.149 1.985-.448s.64-.769.64-1.409c0-.634-.218-1.085-.654-1.354-.436-.268-1.111-.402-2.026-.402h-.86v3.613zm17.716 7.436l-.97-3.183h-4.875l-.97 3.183h-3.055l4.719-13.426h3.466l4.738 13.426h-3.053zm-1.647-5.561a1027.84 1027.84 0 0 1-1.514-4.893 13.862 13.862 0 0 1-.242-.896c-.201.78-.777 2.71-1.729 5.789h3.485zm15.622-3.64c0 1.439-.45 2.54-1.349 3.301-.899.763-2.178 1.144-3.837 1.144h-1.216v4.756h-2.835v-13.372h4.271c1.622 0 2.855.349 3.7 1.047.844.699 1.266 1.74 1.266 3.124zm-6.402 2.122H113c.872 0 1.524-.172 1.957-.517.433-.345.649-.846.649-1.504 0-.665-.182-1.156-.544-1.473-.363-.317-.932-.476-1.706-.476h-1.29v3.97zm-38.116-62.12c-1.983-.653-4.838-.759-8.565-.759H52v20h14.424c2.502 0 4.259-.249 5.271-.437 1.783-.318 3.274-.93 4.472-1.676 1.198-.744 2.183-1.869 2.955-3.293.771-1.424 1.158-3.087 1.158-4.951 0-2.184-.559-3.98-1.677-5.59-1.117-1.611-2.668-2.642-4.652-3.294zm-2.056-8.612c1.97-.586 3.455-1.646 4.452-3.003.999-1.357 1.498-3.103 1.498-5.154 0-1.943-.466-3.675-1.398-5.154-.932-1.478-2.263-2.481-3.992-3.027-1.732-.544-4.7-.809-8.906-.809H52v18h12.507c3.435 0 5.897-.399 7.388-.853zM117 16.126C117 8.324 110.675 2 102.873 2H25.127C17.325 2 11 8.324 11 16.126v77.748C11 101.676 17.325 108 25.127 108h77.746c7.802 0 14.127-6.324 14.127-14.126V16.126zM86.57 73.27c-1.157 2.356-2.589 4.173-4.292 5.451-1.704 1.277-3.841 2.446-6.41 3.098A38.022 38.022 0 0 1 66.424 83H44V24h22.065c4.473 0 8.059.62 10.761 1.804 2.703 1.185 4.818 3.021 6.351 5.483 1.53 2.463 2.296 5.046 2.296 7.735 0 2.502-.68 4.861-2.036 7.071-1.358 2.21-3.408 3.995-6.15 5.352 3.54 1.038 6.263 2.811 8.166 5.313 1.903 2.503 2.855 5.458 2.855 8.866-.001 2.742-.579 5.291-1.738 7.646z\"/></svg>"

/***/ }),

/***/ "../src/components/bootstrap/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BootstrapPlainWordmark = __webpack_require__("../src/components/bootstrap/plain-wordmark/BootstrapPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BootstrapPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bootstrap/plain/BootstrapPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BootstrapPlain = __webpack_require__("../src/components/bootstrap/plain/BootstrapPlain.svg");
	
	var _BootstrapPlain2 = _interopRequireDefault(_BootstrapPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BootstrapPlain */
	function BootstrapPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BootstrapPlain',
	    svg: _BootstrapPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BootstrapPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BootstrapPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bootstrap/plain/BootstrapPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#5B4282\" d=\"M75.701 65.603c-2.334-.768-5.694-.603-10.08-.603H48v23h18.844c2.944 0 5.012-.315 6.203-.535 2.099-.376 3.854-1.104 5.264-1.982 1.409-.876 2.568-2.205 3.478-3.881.908-1.676 1.363-3.637 1.363-5.83 0-2.568-.658-4.54-1.975-6.436-1.316-1.896-3.141-2.965-5.476-3.733zm-2.419-10.516c2.317-.688 4.064-1.89 5.239-3.487 1.176-1.598 1.763-3.631 1.763-6.044 0-2.286-.549-4.314-1.646-6.054s-2.662-2.413-4.699-3.056c-2.037-.641-5.53-.446-10.48-.446H48v20h16.587c4.042 0 6.939-.38 8.695-.913zM126 18.625C126 9.443 118.557 2 109.375 2h-91.75C8.443 2 1 9.443 1 18.625v91.75C1 119.557 8.443 127 17.625 127h91.75c9.182 0 16.625-7.443 16.625-16.625v-91.75zm-35.447 66.12c-1.362 2.773-3.047 4.911-5.052 6.415-2.006 1.504-4.521 2.78-7.544 3.548C74.935 95.477 71.229 96 66.844 96H39V27h27.42c5.264 0 9.485.609 12.665 2.002 3.181 1.395 5.671 3.497 7.474 6.395 1.801 2.898 2.702 5.907 2.702 9.071 0 2.945-.8 5.708-2.397 8.308-1.598 2.602-4.011 4.694-7.237 6.292 4.166 1.222 7.37 3.304 9.61 6.248 2.24 2.945 3.36 6.422 3.36 10.432 0 3.227-.681 6.225-2.044 8.997z\"/></svg>"

/***/ }),

/***/ "../src/components/bootstrap/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BootstrapPlain = __webpack_require__("../src/components/bootstrap/plain/BootstrapPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BootstrapPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bower/line-wordmark/BowerLineWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BowerLineWordmark = __webpack_require__("../src/components/bower/line-wordmark/BowerLineWordmark.svg");
	
	var _BowerLineWordmark2 = _interopRequireDefault(_BowerLineWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BowerLineWordmark */
	function BowerLineWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BowerLineWordmark',
	    svg: _BowerLineWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BowerLineWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BowerLineWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bower/line-wordmark/BowerLineWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#EF5734\" d=\"M114.438 46.444c-1.13-.454-2.26-.97-3.44-1.226-6.697-1.449-13.388-2.96-20.126-4.19-4.928-.9-9.929-1.403-14.896-2.084.506-3.458.967-3.889 4.677-4.464 1.892 3.269 1.892 3.269 5.797 2.811 8.009-.938 13.13-5.553 14.583-13.769 1.076-6.09 2.336-11.974 6.948-16.522.056-.054-.037-.258-.059-.387-8.48-2.603-19.382 3.244-26.171 14.104-3.104-.412-5.083-1.412-6.466-4.675C71.582 7.299 64.754 2.03 55.049 1.671c-17.564-.649-33.537 9.542-40.413 25.758-6.821 16.09-4.64 31.756 3.094 46.925 3.143 6.165 7.156 11.728 13.104 15.558 5.095 3.281 9.794 2.241 13.206-2.77.142-.208.402-.335.715-.587l1.522 3.988c.515 1.35.978 2.723 1.554 4.046 1.173 2.69 4.312 3.976 7.041 3.062.702-.235 1.606-.26 2.31-.038 3.04.956 5.825.984 8.263-1.48.388-.393 1.211-.519 1.823-.498 4.184.132 6.499-1.241 8.296-4.999.151-.318.383-.636.657-.853 2.803-2.21 3.491-4.511 2.083-7.74-.85-1.947-1.911-3.805-2.909-5.685-.717-1.352-1.486-2.673-2.436-4.371 4.636 1.53 8.773 3.11 12.594-.37.786.406 1.444.794 2.14 1.097 3.83 1.667 8.946 1.117 11.127-1.442.902-1.061 1.715-1.135 2.923-1.041 4.771.365 10.347-1.146 11.13-6.816 5.07-1.029 7.385-3.273 7.801-7.564.45-4.661-1.397-7.462-6.236-9.407zM84.892 34.415c-.505.009-1.215-.906-1.495-1.543-.375-.851-.423-1.846-.769-3.563l4.022 1.556c1.836-1.362 3.702.739 6.352.971-2.794 1.93-5.4 2.531-8.11 2.579zm17.064-25.106l-6.081 20.86c-2.499-2.09-4.295-3.592-6.513-5.444l7.403-11.42c-4.114 2.514-6.505 6.371-8.764 10.603l-3.315-1.849c2.462-6.599 10.894-12.653 17.27-12.75zM74.032 21.991c5.603.313 10.389 2.691 14.749 6.052.29.224.337.76.741 1.755-5.086-1.738-9.416-1.123-13.745.506-1.267.478-2.808.227-4.224.31l.024.654 7.976-.492.073.573c-2.765 1.269-5.53 2.538-8.293 3.808-2.146-2.944-1.29-10.052.97-12.424.404-.425 1.16-.773 1.729-.742zM86.543 50.7l-.089.596 25.909 5.1c-1.015 2.749-3.085 3.601-8.134 3.513-.193 4.702-2.376 5.948-9.479 5.413-1.442 4.273-5.277 5.201-11.832 2.824-3.508 3.815-7.485 2.437-11.585.833-.811 6.34-3.74 11.29-9.306 14.445-5.174 2.936-10.724 2.613-16.249 1.408-22.28-4.857-35.102-26.561-29.174-49.269C21.042 18.568 34.906 7.01 51.985 6.066c8.255-.457 15.595 3.843 19.044 11.285.33.712.358 2.019-.079 2.563-4.607 5.735-4.691 11.885-1.7 18.232.688 1.46.465 2.316-.411 3.421-3.946 4.975-9.221 7.857-15.14 9.755l-.8.24c6.852-.144 13.413-1.241 18.207-6.677 1.258-1.426 2.449-1.808 4.137-1.539 9.246 1.475 18.501 2.887 27.734 4.427 2.377.396 4.706 1.116 7.024 1.8 1.789.527 3.002 1.683 3.329 3.888L86.543 50.7zM58.722 26.294c-.004-3.122-2.643-5.694-5.734-5.59-2.889.097-5.539 2.899-5.433 5.746.111 3.032 2.666 5.471 5.682 5.424a5.563 5.563 0 0 0 5.485-5.58zm-8.865-2.55c.004-1.973 1.926-2.236 3.568-2.162 1.467.065 3.233.43 3.141 2.204-.104 2.005-2.035 2.089-4.104 2.684-.919-.908-2.606-1.819-2.605-2.726zm-30.922 91.861c.49-.42.898-.938 1.223-1.551s.486-1.218.486-1.814c0-.254-.021-.51-.065-.769s-.132-.548-.263-.867a4.422 4.422 0 0 0-.507-.907 4.281 4.281 0 0 0-.841-.842 5.57 5.57 0 0 0-1.217-.709c-.455-.197-1.015-.598-1.676-.721S14.684 107 13.888 107H7v19h6.375c1.042 0 1.999.001 2.872-.157.871-.157 1.605-.322 2.201-.571.596-.25 1.122-.53 1.577-.88.456-.351.817-.692 1.084-1.048a5.22 5.22 0 0 0 .651-1.119c.167-.395.277-.739.336-1.042a4.818 4.818 0 0 0-.803-3.692 5.219 5.219 0 0 0-2.358-1.886zM10 110h3.138c.789 0 1.455.208 1.998.359.544.148.939.417 1.189.67.25.255.423.536.52.777s.145.519.145.8l-.013.296c-.123 1.183-1.133 1.945-2.955 2.279-.756.131-2.021.223-4.021.267V110zm8.626 11.422c-.163.285-.359.52-.592.704-.232.184-.537.341-.914.473-.377.131-.723.23-1.038.296s-.692.116-1.13.151c-.438.035-.783-.001-1.032.003l-.9-.049H10v-5.305c2-.096 3.24-.145 3.311-.145 1.691 0 3.053.259 4.047.776.995.517 1.502 1.227 1.502 2.129-.001.36-.073.683-.234.967zm22.971-13.02c-1.481-.745-3.173-1.117-5.074-1.117-1.919 0-3.624.388-5.113 1.163a8.484 8.484 0 0 0-3.497 3.352c-.841 1.46-1.262 3.148-1.262 5.067 0 1.542.27 2.927.809 4.154.538 1.227 1.266 2.224 2.182 2.99s1.952 1.35 3.109 1.748c1.156.399 2.379.599 3.667.599 1.954 0 3.685-.408 5.192-1.223a8.696 8.696 0 0 0 3.51-3.438c.832-1.477 1.248-3.17 1.248-5.08 0-1.884-.425-3.538-1.274-4.963a8.405 8.405 0 0 0-3.497-3.252zm.814 11.37c-.377.859-.876 1.538-1.499 2.038a6.78 6.78 0 0 1-2.031 1.13 6.856 6.856 0 0 1-2.267.381c-1.875 0-3.439-.613-4.692-1.84-1.254-1.227-1.88-2.853-1.88-4.877 0-.85.122-1.627.368-2.333.245-.705.573-1.299.985-1.781a5.86 5.86 0 0 1 1.439-1.216 6.477 6.477 0 0 1 1.716-.723c.596-.153 1.209-.23 1.84-.23s1.251.077 1.86.23c.608.153 1.2.4 1.774.742.573.342 1.078.758 1.512 1.249s.782 1.106 1.045 1.847.395 1.558.395 2.451c.001 1.097-.188 2.074-.565 2.932zm28.261 1.582L66.229 107H63.18l-5.403 14.354L53.479 107h-3.497l6.165 19h3.168l5.285-14.288L69.095 126h3.168l7.164-19h-3.496zM84 126h13v-3H87v-5h9v-3h-9v-4h10v-4H84zm30.963-8.542a4.87 4.87 0 0 0 1.275-1.354c.311-.5.539-1.025.684-1.564a6.535 6.535 0 0 0 .217-1.705c0-.691-.084-1.317-.25-1.874s-.379-1.018-.637-1.381a3.93 3.93 0 0 0-.974-.954 5.428 5.428 0 0 0-1.13-.618c-.364-.14-.78-.252-1.249-.335s-.867-.376-1.196-.398c-.328-.021-.689-.275-1.084-.275H103v19h3v-7h3.146l5.232 7h4.311l-5.639-7.728c.737-.218 1.375-.42 1.913-.814zm-3.293-1.858c-.429.109-.845.247-1.248.283-.403.034-.868.118-1.394.118H106v-5h3.646c2.689 0 4.035.632 4.035 2.375 0 .465-.09.748-.27 1.089s-.407.53-.684.722c-.275.192-.627.302-1.057.413z\"/></svg>"

/***/ }),

/***/ "../src/components/bower/line-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BowerLineWordmark = __webpack_require__("../src/components/bower/line-wordmark/BowerLineWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BowerLineWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bower/line/BowerLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BowerLine = __webpack_require__("../src/components/bower/line/BowerLine.svg");
	
	var _BowerLine2 = _interopRequireDefault(_BowerLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BowerLine */
	function BowerLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BowerLine',
	    svg: _BowerLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BowerLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BowerLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bower/line/BowerLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#EF5734\" d=\"M118.852 60.078c-1.272-.512-2.545-1.092-3.874-1.38-7.542-1.633-15.074-3.333-22.661-4.719-5.55-1.014-11.181-1.581-16.773-2.347.57-3.894 1.089-4.379 5.266-5.026 2.131 3.681 2.131 3.681 6.528 3.165 9.018-1.058 14.784-6.252 16.419-15.504 1.214-6.857 2.631-13.482 7.824-18.604.063-.061-.041-.29-.065-.436-9.549-2.931-21.825 3.653-29.47 15.881-3.496-.464-5.724-1.59-7.28-5.264-4.17-9.846-11.858-15.777-22.786-16.182C32.2 8.93 14.215 20.407 6.473 38.667c-7.681 18.116-5.224 35.757 3.483 52.837 3.539 6.941 8.059 13.205 14.757 17.519 5.736 3.694 11.028 2.523 14.87-3.119.158-.234.453-.378.805-.66l1.714 4.49c.58 1.52 1.102 3.065 1.75 4.555 1.319 3.03 4.854 4.478 7.928 3.448.79-.265 1.809-.292 2.601-.043 3.423 1.076 6.56 1.108 9.304-1.668.437-.441 1.363-.583 2.053-.561 4.712.149 7.318-1.396 9.341-5.628.172-.358.432-.716.741-.96 3.156-2.488 3.932-5.08 2.345-8.716-.957-2.193-2.151-4.284-3.275-6.401-.808-1.521-1.674-3.01-2.743-4.921 5.22 1.723 9.88 3.501 14.182-.417.885.457 1.626.894 2.409 1.234 4.313 1.877 10.073 1.258 12.528-1.624 1.017-1.194 1.932-1.277 3.291-1.173 5.372.412 11.65-1.289 12.533-7.675 5.709-1.158 8.315-3.687 8.783-8.518.506-5.245-1.573-8.399-7.021-10.588zM85.581 46.533c-.568.01-1.367-1.021-1.683-1.737-.423-.959-.477-2.079-.865-4.012l4.529 1.751c2.067-1.533 4.168.833 7.15 1.094-3.145 2.171-6.079 2.85-9.131 2.904zm19.215-28.271l-6.848 23.489c-2.813-2.354-4.836-4.045-7.332-6.131l8.335-12.858c-4.633 2.829-7.324 7.173-9.868 11.938l-3.732-2.082c2.772-7.429 12.266-14.246 19.445-14.356zM73.354 32.543c6.308.351 11.698 3.03 16.608 6.814.326.251.378.855.834 1.976-5.727-1.957-10.604-1.265-15.478.57-1.426.537-3.161.254-4.755.348l.027.736 8.979-.554.083.645-9.338 4.289c-2.417-3.315-1.453-11.319 1.092-13.99.455-.478 1.306-.87 1.948-.834zM87.44 64.87l-.1.671 29.174 5.741c-1.143 3.096-3.474 4.055-9.158 3.956-.218 5.295-2.676 6.698-10.674 6.095-1.623 4.813-5.941 5.857-13.322 3.18-3.95 4.297-8.429 2.744-13.045.939-.913 7.138-4.212 12.712-10.478 16.265-5.827 3.306-12.075 2.943-18.297 1.586-25.088-5.47-39.524-29.907-32.85-55.477 4.995-19.137 20.605-32.152 39.838-33.215 9.294-.514 17.56 4.327 21.443 12.706.372.802.403 2.273-.09 2.887-5.188 6.459-5.282 13.383-1.914 20.53.774 1.644.523 2.608-.463 3.853-4.442 5.602-10.383 8.847-17.047 10.983l-.901.271c7.716-.162 15.104-1.397 20.501-7.518 1.417-1.605 2.758-2.035 4.659-1.733 10.41 1.66 20.831 3.25 31.229 4.985 2.676.446 5.3 1.256 7.91 2.025 2.014.594 3.379 1.896 3.748 4.378L87.44 64.87zM56.114 37.387c-.005-3.515-2.976-6.411-6.457-6.294-3.252.109-6.237 3.265-6.118 6.471.126 3.414 3.002 6.159 6.397 6.107a6.266 6.266 0 0 0 6.178-6.284zm-9.981-2.871c.005-2.221 2.169-2.518 4.018-2.434 1.652.074 3.641.483 3.537 2.481-.118 2.258-2.292 2.353-4.621 3.021-1.037-1.021-2.935-2.046-2.934-3.068z\"/></svg>"

/***/ }),

/***/ "../src/components/bower/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BowerLine = __webpack_require__("../src/components/bower/line/BowerLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BowerLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bower/original-wordmark/BowerOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BowerOriginalWordmark = __webpack_require__("../src/components/bower/original-wordmark/BowerOriginalWordmark.svg");
	
	var _BowerOriginalWordmark2 = _interopRequireDefault(_BowerOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BowerOriginalWordmark */
	function BowerOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BowerOriginalWordmark',
	    svg: _BowerOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BowerOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BowerOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bower/original-wordmark/BowerOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#543828\" d=\"M20.033 115.859c.49-.421.897-.938 1.223-1.552.323-.613.485-1.218.485-1.813 0-.255-.021-.511-.065-.77a4.167 4.167 0 0 0-.263-.867 4.465 4.465 0 0 0-.506-.907 4.259 4.259 0 0 0-.842-.841c-.354-.276-.761-.513-1.216-.71s-1.015-.223-1.676-.346c-.661-.123-1.391-.053-2.188-.053H8v18h6.473c1.043 0 2 .128 2.872-.03.872-.157 1.605-.258 2.202-.508.596-.248 1.121-.498 1.577-.849.455-.35.816-.675 1.084-1.031.268-.354.484-.716.65-1.111.167-.395.278-.737.336-1.04a4.82 4.82 0 0 0-.802-3.689 5.208 5.208 0 0 0-2.359-1.883zM11 111h3.236c.788 0 1.454-.164 1.998-.016.543.148.939.231 1.188.485.251.255.424.442.521.683.096.24.145.471.145.752l-.014.274c-.123 1.184-1.183 1.933-3.005 2.266-.754.131-2.069.212-4.069.256V111zm8.724 10.674c-.162.285-.359.52-.591.704-.232.184-.537.341-.914.473s-.723.23-1.038.296a9.168 9.168 0 0 1-1.13.151c-.438.035-.783-.127-1.032-.123-.25.004-.551-.176-.901-.176H11v-5.051c2-.097 3.29-.145 3.36-.145 1.691 0 3.078.258 4.072.775.995.517 1.514 1.227 1.514 2.129-.001.361-.06.683-.222.967zm22.97-13.019c-1.481-.745-3.172-1.117-5.074-1.117-1.919 0-3.623.388-5.112 1.163-1.49.776-2.655 1.894-3.497 3.353s-1.262 3.147-1.262 5.067c0 1.542.27 2.927.809 4.153.538 1.227 1.266 2.224 2.182 2.99a9.72 9.72 0 0 0 3.108 1.748c1.157.399 2.38.599 3.667.599 1.955 0 3.686-.407 5.193-1.223a8.681 8.681 0 0 0 3.509-3.438c.833-1.477 1.249-3.17 1.249-5.08 0-1.884-.425-3.538-1.275-4.962a8.383 8.383 0 0 0-3.497-3.253zm.815 11.37c-.377.859-.876 1.538-1.498 2.038a6.835 6.835 0 0 1-4.298 1.512c-1.876 0-3.439-.613-4.693-1.841-1.253-1.227-1.879-2.853-1.879-4.876 0-.851.122-1.628.368-2.334.245-.705.573-1.299.985-1.781a5.873 5.873 0 0 1 1.438-1.216c.549-.328 1.12-.569 1.716-.723s1.21-.23 1.841-.23 1.251.077 1.859.23c.609.153 1.2.401 1.775.743a6.357 6.357 0 0 1 1.512 1.248c.434.491.781 1.106 1.044 1.848.264.74.396 1.557.396 2.451 0 1.095-.189 2.073-.566 2.931zm28.262 2.329L67.327 108h-3.05l-5.402 14.354L54.577 108h-3.496l6.164 18h3.169l5.283-14.288L70.193 126h3.167l7.164-18h-3.496zM85 126h13v-3H88v-5h9v-3h-9v-4h10v-3H85zm31.062-8.29a4.866 4.866 0 0 0 1.274-1.354c.312-.5.539-1.024.684-1.563s.218-1.109.218-1.706c0-.691-.084-1.317-.25-1.874-.167-.557-.379-1.018-.638-1.381s-.583-.682-.973-.954a5.356 5.356 0 0 0-1.131-.617 6.76 6.76 0 0 0-1.248-.336c-.47-.083-.868-.001-1.196-.025-.329-.021-.69.1-1.085.1H104v18h3v-7h3.245l5.231 7h4.312l-5.639-7.602c.736-.218 1.373-.293 1.913-.688zm-3.293-1.858c-.43.109-.846.121-1.248.156-.404.035-.868-.008-1.394-.008H107v-5h3.745c2.689 0 4.035.758 4.035 2.502 0 .465-.091.809-.27 1.152-.18.341-.407.561-.684.753s-.628.336-1.057.445zM48.079 1.389h6.563c.107.072.205.179.322.21 2.17.572 4.451.878 6.493 1.747 6.855 2.916 11.06 8.295 13.492 15.2.121.342.335.828.606.911 1.488.448 3.008.792 4.517 1.173l.144-.152C84.363 12.387 91.037 7.729 99.89 6.109c2.313-.423 4.654-.341 7.025.395l-.491.592c-2.982 3.243-5.321 6.823-5.982 11.301a114.721 114.721 0 0 1-.739 4.303c-.739 3.934-2.077 7.586-5.095 10.398-3.86 3.599-8.62 4.464-13.661 4.394-.283-.004-.667-.371-.821-.665-.416-.795-.732-1.643-1.082-2.451-3.38.699-4.373 1.64-4.71 4.452 1.008.126 2.015.261 3.024.379 8.716 1.021 17.398 2.256 25.96 4.212 4.041.923 8.053 1.956 11.777 3.878 1.988 1.026 3.158 2.615 3.658 4.758.11.473.278.933.419 1.397v3.063c-.139.354-.31.699-.41 1.063-.428 1.557-1.225 2.876-2.486 3.89-1.559 1.252-3.403 1.747-5.409 1.922.418 2.507-.911 4.091-2.871 5.169-1.223.673-2.593 1.279-3.955 1.448-1.955.244-3.964.063-5.922.063-1.484 2.748-4.074 3.338-6.83 3.532-2.769.195-5.31-.561-7.57-2.156-.918 1.402-2.013 1.987-3.837 2.139-2.863.238-5.57-.319-8.145-1.573l-.343-.137.144.311c1.752 3.222 3.595 6.398 5.203 9.689.527 1.078.639 2.459.604 3.691-.064 2.273-1.265 3.734-3.198 4.301-.196 1.848-1.156 3.243-2.685 4.266-1.827 1.222-3.847 1.65-6.024 1.425-.38-.04-.983-.146-1.12.043-1.111 1.528-2.725 2.17-4.425 2.696h-2.406c-1.482-.382-2.828-1.831-4.534-.538-.258.195-.698.181-1.059.204-1.905.126-5.026-1.066-5.891-3.678-.888-2.684-1.994-5.295-3.024-7.987l-.202.335c-2.408 4.693-7.52 6.379-12.23 4.044a20.977 20.977 0 0 1-6.597-5.143C11.761 71.382 6.684 55.106 10.039 36.602 13.18 19.276 26.598 5.802 43.76 2.209c1.433-.299 2.879-.547 4.319-.82zm20.782 28.877c2.665.185 5.303.225 7.828-.903 2.338-1.045 4.798-1.139 7.282-.669 1.651.313 3.288.698 4.931 1.051-.746-.815-1.575-1.51-2.446-2.145-4.195-3.056-8.767-5.184-14.022-5.552-.461-.032-1.161.009-1.375.296-1.642 2.206-2.615 4.669-2.488 7.48-.244 1.868.288 3.58.972 5.217l8.743-3.941-.081-.856c-1.51.35-2.942.774-4.406.994-1.732.261-3.486.332-4.938-.972zm26.872-17.32l.158.17c-3.468 3.372-5.82 7.493-7.952 11.705l5.727 4.846c1.698-2.239 2.396-4.789 2.988-7.389 1.041-4.567 1.261-9.424 4.754-13.176-6.549-.278-16.302 6.563-18.435 12.862l3.369 1.866c.184-.344.332-.669.521-.968 1.088-1.72 2.086-3.508 3.305-5.131 1.489-1.982 3.236-3.742 5.565-4.785zM83.554 50.42c2.019.2 4.038.396 6.056.602 6.356.646 12.712 1.298 19.068 1.945.911.094 1.823.176 2.92.281-.52-1.636-1.2-2.849-2.674-3.353-1.371-.468-2.786-.812-4.181-1.21-5.525-1.103-11.025-2.363-16.583-3.265-5.417-.879-10.894-1.397-16.347-2.044-.337-.04-.81.084-1.042.313-1.034 1.018-2.004 2.102-2.997 3.162-5.515 4.004-11.853 5.063-18.464 5.146 1.666-.593 3.375-1.066 5.025-1.693 5.271-2.001 9.917-4.881 13.267-9.57.505-.706.601-1.236.15-2.046a17.754 17.754 0 0 1-2.282-9.005c.057-3.813 1.367-7.196 3.973-10.027.449-.487.537-.923.255-1.554-1.777-3.978-4.477-7.134-8.221-9.378-4.596-2.754-9.612-2.99-14.71-2.232-11.446 1.702-20.283 7.571-26.476 17.28-5.694 8.926-7.525 18.757-6.043 29.197.455 3.206 1.266 6.348 2.76 9.265.328.765.596 1.563.995 2.289 6.969 12.654 17.619 19.67 32.06 20.746 8.491.633 15.815-4.221 18.455-12.092.601-1.79 1.216-3.605.284-5.487 1.887 1.654 4.141 2.324 6.593 2.559 2.479.237 4.513-.639 5.585-2.576.289.103.599.188.889.318 2.008.902 4.111 1.184 6.292 1.011 2.822-.224 4.146-1.465 4.434-4.132 1.402.131 2.808.402 4.204.363 4.038-.115 5.973-2.375 5.104-5.63 1.589-.076 3.223-.029 4.815-.266 1.65-.244 2.984-1.148 4.069-2.797L95.368 53.5l-15.413-2.954.021-.126h3.578zm-2.559-20.801c.389 1.542.712 2.785 1.011 4.034.158.657.56.825 1.195.771 2.445-.204 4.804-.715 6.994-1.862.299-.157.58-.349 1.164-.703l-6.03-1.611-.794 1.46-.178-.043v-1.58l-3.362-.466z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E95927\" d=\"M17.009 62.234c-1.494-2.917-2.305-6.059-2.76-9.265-1.482-10.44.349-20.271 6.043-29.197 6.192-9.709 15.029-15.578 26.476-17.28 5.098-.758 10.114-.521 14.71 2.232 3.744 2.244 6.443 5.4 8.221 9.378.282.631.194 1.066-.255 1.554-2.605 2.831-3.916 6.214-3.973 10.027a17.764 17.764 0 0 0 2.282 9.005c.45.81.354 1.34-.15 2.046-3.35 4.689-7.996 7.569-13.267 9.57-1.65.627-3.359 1.101-5.025 1.693 6.611-.083 12.949-1.142 18.464-5.146-1.163 1.965-2.145 4.067-3.519 5.871-6.575 8.632-15.474 12.659-26.677 9.514-1.141-.32-2.118-.461-3.107.384-.42.358-1.041.517-1.597.676-5.414 1.551-10.708 1.234-15.866-1.062zm34.519-45.557c-5.416.008-9.582 4.217-9.575 9.673.007 5.242 4.396 9.603 9.642 9.577 5.301-.026 9.6-4.398 9.591-9.756-.009-5.293-4.291-9.502-9.658-9.494z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FBCD00\" d=\"M17.009 62.234c5.158 2.296 10.452 2.613 15.866 1.063.556-.159 1.177-.317 1.597-.676.989-.845 1.967-.704 3.107-.384 11.203 3.146 20.102-.882 26.677-9.514 1.374-1.804 2.355-3.906 3.519-5.871.993-1.061 1.963-2.145 2.997-3.162.232-.229.705-.353 1.042-.313 5.453.646 10.93 1.165 16.347 2.044 5.558.901 11.058 2.162 16.582 3.265-.208.055-.412.145-.623.16-6.854.529-13.71 1.051-20.565 1.574h-3.577l-.021.126L95.37 53.5c-.196.629-.204 1.471-.626 1.844-.848.747-1.855 1.508-2.918 1.764-1.249.302-2.626.074-3.947.075l-.038-.071.059.057c.221 1.333.043 2.583-1.063 3.465-.757.604-1.59 1.172-2.479 1.531-2.313.932-4.641.95-6.869-.368-.58 2.418-2.447 3.047-4.425 3.4-2.021.361-3.953.02-5.632-1.355l-.206.21 1.579 3.639c.932 1.882.316 3.697-.284 5.487-2.64 7.871-9.964 12.725-18.455 12.092-14.44-1.076-25.091-8.092-32.06-20.746-.402-.727-.669-1.525-.997-2.29zm50.221 1.353l-.045.067.066.011-.021-.078z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#3DAF00\" d=\"M87.876 57.183c1.322-.001 2.699.227 3.948-.075 1.063-.256 2.07-1.017 2.918-1.764.422-.373.43-1.215.626-1.844l15.419 3.04c-1.085 1.648-2.419 2.553-4.069 2.797-1.593.236-3.227.189-4.815.266.869 3.255-1.065 5.515-5.104 5.63-1.396.039-2.802-.232-4.204-.363-.287 2.667-1.611 3.908-4.434 4.132-2.181.173-4.284-.108-6.292-1.011-.29-.131-.6-.216-.889-.318-1.072 1.938-3.106 2.813-5.585 2.576-2.452-.234-4.706-.904-6.593-2.559l-1.579-3.639.206-.21c1.679 1.375 3.611 1.717 5.632 1.355 1.978-.354 3.845-.982 4.425-3.4 2.229 1.318 4.557 1.3 6.869.368.89-.359 1.723-.928 2.479-1.531 1.105-.882 1.283-2.132 1.063-3.465l-.021.015z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#25A7F0\" d=\"M95.733 12.946c-2.329 1.043-4.076 2.803-5.564 4.786-1.219 1.623-2.217 3.411-3.305 5.131-.189.299-.338.624-.521.968l-3.369-1.866c2.133-6.299 11.886-13.141 18.435-12.862-3.493 3.752-3.713 8.608-4.754 13.176-.592 2.6-1.29 5.149-2.988 7.389l-5.727-4.846c2.132-4.212 4.484-8.333 7.952-11.705l.177-.295-.336.124z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#CBCBCA\" d=\"M68.57 29.825c-.127-2.812.847-5.274 2.488-7.48.214-.287.914-.328 1.375-.296 5.256.368 9.827 2.496 14.022 5.552.871.635 1.7 1.329 2.446 2.145-1.643-.353-3.279-.738-4.931-1.051-2.484-.47-4.944-.376-7.282.669-2.525 1.128-5.163 1.088-7.828.903l-.29-.442z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#3EAE00\" d=\"M83.554 50.42c6.855-.523 13.711-1.045 20.565-1.574.211-.016.415-.105.623-.16 1.396.398 2.811.742 4.182 1.21 1.474.504 2.154 1.717 2.674 3.353-1.097-.105-2.009-.188-2.92-.281-6.356-.647-12.712-1.299-19.068-1.945-2.018-.207-4.038-.402-6.056-.603z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#25A5EC\" d=\"M80.995 29.619l3.362.466v1.58l.178.043.794-1.46 6.03 1.611c-.584.354-.865.546-1.164.703-2.19 1.147-4.549 1.658-6.994 1.862-.636.054-1.037-.114-1.195-.771-.299-1.249-.622-2.492-1.011-4.034z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#C9C8C7\" d=\"M68.57 29.825l.291.441c1.451 1.304 3.206 1.232 4.937.972 1.464-.22 2.896-.645 4.406-.994l.081.856-8.743 3.941c-.684-1.636-1.216-3.348-.972-5.216z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FBCB00\" d=\"M51.528 16.677c5.366-.008 9.648 4.201 9.657 9.494.009 5.357-4.29 9.729-9.591 9.756-5.245.025-9.635-4.335-9.642-9.577-.006-5.456 4.16-9.665 9.576-9.673zm5.773 9.602c.003-3.229-2.517-5.793-5.717-5.818-3.151-.025-5.756 2.574-5.785 5.773a5.717 5.717 0 0 0 5.736 5.78c3.234.006 5.763-2.511 5.766-5.735z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#3DAF00\" d=\"M87.897 57.168l-.059-.057.038.071.021-.014zM67.23 63.587l.022.079-.066-.011z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#543828\" d=\"M95.733 12.946l.335-.125-.177.295-.158-.17z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#553928\" d=\"M57.301 26.279c-.003 3.225-2.532 5.741-5.766 5.735a5.716 5.716 0 0 1-5.736-5.78c.029-3.199 2.634-5.799 5.785-5.773 3.2.025 5.72 2.589 5.717 5.818zm-5.777-.218c.948-.373 1.92-.6 2.712-1.107.986-.632.904-1.832-.022-2.56-1.33-1.045-4.015-1.042-5.319.005-.921.738-.995 1.934-.012 2.57.761.494 1.698.716 2.641 1.092z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M51.524 26.061c-.943-.376-1.881-.598-2.642-1.092-.983-.637-.909-1.832.012-2.57 1.305-1.047 3.989-1.05 5.319-.005.927.728 1.009 1.928.022 2.56-.791.507-1.762.734-2.711 1.107z\"/></svg>"

/***/ }),

/***/ "../src/components/bower/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BowerOriginalWordmark = __webpack_require__("../src/components/bower/original-wordmark/BowerOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BowerOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bower/original/BowerOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BowerOriginal = __webpack_require__("../src/components/bower/original/BowerOriginal.svg");
	
	var _BowerOriginal2 = _interopRequireDefault(_BowerOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BowerOriginal */
	function BowerOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BowerOriginal',
	    svg: _BowerOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BowerOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BowerOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bower/original/BowerOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#543828\" d=\"M46.101 9.864h7.332c.12.08.229.199.36.234 2.424.639 4.973.98 7.255 1.951 7.659 3.259 12.356 9.269 15.074 16.983.135.383.374.926.679 1.018 1.661.502 3.359.886 5.046 1.311l.159-.17c4.635-9.04 12.091-14.244 21.982-16.054 2.585-.473 5.199-.382 7.849.44-.24.292-.386.483-.548.66-3.333 3.625-5.945 7.624-6.685 12.627a124.667 124.667 0 0 1-.826 4.807c-.826 4.396-2.32 8.477-5.692 11.619-4.313 4.021-9.632 4.987-15.263 4.909-.317-.005-.746-.415-.918-.743-.465-.889-.819-1.835-1.209-2.739-3.777.782-4.886 1.832-5.263 4.975 1.126.142 2.251.292 3.379.424 9.738 1.141 19.439 2.521 29.006 4.706 4.515 1.03 8.997 2.186 13.158 4.332 2.222 1.146 3.528 2.922 4.087 5.316.123.528.311 1.042.469 1.562v3.422c-.154.396-.346.781-.458 1.188-.479 1.738-1.369 3.213-2.778 4.345-1.741 1.399-3.803 1.953-6.044 2.147.467 2.801-1.018 4.57-3.207 5.775-1.366.752-2.897 1.429-4.42 1.618-2.185.273-4.428.07-6.615.07-1.659 3.07-4.553 3.729-7.632 3.946-3.094.219-5.933-.626-8.458-2.409-1.026 1.567-2.249 2.221-4.288 2.39-3.199.267-6.224-.357-9.1-1.758l-.383-.152.16.347c1.957 3.599 4.017 7.148 5.813 10.825.59 1.205.714 2.747.675 4.125-.073 2.54-1.413 4.173-3.574 4.805-.219 2.064-1.291 3.624-2.999 4.767-2.042 1.364-4.298 1.845-6.73 1.592-.425-.044-1.099-.162-1.252.049-1.242 1.707-3.045 2.424-4.943 3.012h-2.688c-1.657-.427-3.16-2.046-5.066-.602-.288.219-.78.202-1.183.229-2.129.141-5.616-1.191-6.581-4.109-.993-2.997-2.229-5.916-3.381-8.925l-.225.375c-2.691 5.244-8.401 7.127-13.666 4.519a23.427 23.427 0 0 1-7.37-5.746C5.522 88.066-.151 69.882 3.598 49.206c3.51-19.357 18.501-34.412 37.677-38.426 1.602-.335 3.217-.612 4.826-.916zm23.22 32.264c2.978.206 5.924.25 8.746-1.01 2.612-1.167 5.361-1.271 8.137-.747 1.845.349 3.673.78 5.509 1.174-.833-.911-1.76-1.687-2.733-2.396-4.688-3.413-9.795-5.791-15.667-6.202-.516-.035-1.297.01-1.536.33-1.835 2.465-2.922 5.218-2.78 8.358-.272 2.088.322 3.999 1.086 5.828l9.769-4.403-.091-.956c-1.687.39-3.287.864-4.923 1.109-1.935.291-3.896.372-5.517-1.085zm30.023-19.352l.178.189c-3.875 3.768-6.503 8.372-8.886 13.078l6.398 5.414c1.897-2.502 2.677-5.352 3.339-8.255 1.163-5.104 1.409-10.529 5.312-14.722-7.317-.312-18.214 7.333-20.596 14.37l3.764 2.086c.205-.384.371-.748.582-1.082 1.216-1.921 2.331-3.919 3.692-5.732 1.664-2.215 3.616-4.181 6.217-5.346zm-13.608 41.87c2.256.224 4.512.441 6.767.671l21.305 2.175c1.018.104 2.037.196 3.264.314-.581-1.829-1.342-3.184-2.988-3.746-1.532-.523-3.112-.907-4.672-1.352-6.173-1.232-12.317-2.641-18.527-3.648-6.053-.981-12.171-1.562-18.265-2.283-.376-.045-.904.094-1.163.349-1.156 1.138-2.239 2.349-3.35 3.533-6.162 4.474-13.242 5.656-20.63 5.749 1.862-.662 3.771-1.191 5.615-1.892 5.889-2.235 11.081-5.454 14.823-10.692.564-.79.671-1.383.167-2.286-1.735-3.113-2.602-6.507-2.549-10.062.063-4.262 1.527-8.041 4.438-11.203.503-.546.601-1.032.286-1.737-1.986-4.443-5.002-7.97-9.186-10.477-5.135-3.078-10.739-3.342-16.436-2.495-12.789 1.902-22.662 8.46-29.581 19.308-6.361 9.973-8.408 20.957-6.752 32.622.509 3.582 1.414 7.092 3.083 10.351.368.855.666 1.747 1.113 2.559 7.785 14.139 19.685 21.977 35.819 23.179 9.486.707 17.671-4.715 20.619-13.509.672-2.001 1.359-4.029.318-6.132 2.107 1.849 4.627 2.597 7.365 2.858 2.771.266 5.042-.714 6.24-2.878.323.114.67.21.994.355 2.243 1.009 4.593 1.323 7.029 1.13 3.153-.25 4.634-1.637 4.954-4.616 1.566.145 3.137.449 4.696.404 4.513-.128 6.674-2.652 5.703-6.289 1.774-.086 3.601-.033 5.38-.297 1.844-.273 3.334-1.283 4.547-3.125l-17.228-3.397-17.222-3.3.023-.141h4.001zm-2.859-23.242c.434 1.724.796 3.112 1.13 4.508.177.734.625.921 1.335.862 2.732-.229 5.367-.8 7.814-2.082.334-.175.648-.389 1.301-.784l-6.737-1.802-.887 1.631-.199-.047v-1.766l-3.757-.52z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E95927\" d=\"M11.385 77.845c-1.669-3.259-2.574-6.769-3.083-10.351-1.656-11.665.391-22.649 6.752-32.622 6.919-10.848 16.792-17.405 29.581-19.308 5.696-.847 11.301-.583 16.436 2.495 4.184 2.507 7.199 6.033 9.186 10.477.314.705.217 1.191-.286 1.737-2.91 3.162-4.374 6.941-4.438 11.203-.053 3.555.813 6.948 2.549 10.062.504.903.397 1.496-.167 2.286-3.742 5.238-8.935 8.457-14.823 10.692-1.844.7-3.753 1.229-5.615 1.892 7.388-.093 14.468-1.275 20.63-5.749-1.299 2.195-2.396 4.545-3.932 6.561-7.346 9.644-17.288 14.144-29.805 10.629-1.274-.357-2.367-.515-3.473.43-.47.399-1.163.576-1.784.755-6.049 1.732-11.963 1.376-17.728-1.189zm38.57-50.9c-6.052.009-10.706 4.711-10.698 10.808.008 5.856 4.912 10.729 10.771 10.7 5.923-.03 10.727-4.915 10.717-10.9-.01-5.913-4.794-10.617-10.79-10.608z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FBCD00\" d=\"M11.385 77.845c5.765 2.565 11.679 2.921 17.728 1.188.621-.179 1.314-.355 1.784-.755 1.105-.944 2.198-.787 3.473-.43 12.517 3.515 22.459-.985 29.805-10.629 1.535-2.016 2.633-4.365 3.932-6.561 1.11-1.185 2.193-2.396 3.35-3.533.259-.255.787-.394 1.163-.349 6.094.722 12.212 1.302 18.265 2.283 6.21 1.008 12.354 2.416 18.527 3.647-.232.062-.461.161-.696.18-7.659.591-15.318 1.174-22.979 1.759H81.74l-.023.141c5.74 1.101 11.48 2.2 17.221 3.3-.218.703-.228 1.645-.699 2.061-.946.835-2.073 1.685-3.26 1.971-1.396.337-2.935.083-4.41.085l-.042-.081.064.064c.247 1.488.049 2.885-1.188 3.871-.845.674-1.775 1.31-2.77 1.71-2.583 1.042-5.186 1.062-7.675-.411-.648 2.701-2.735 3.404-4.944 3.8-2.257.403-4.417.021-6.292-1.515l-.229.234 1.763 4.065c1.042 2.103.354 4.131-.317 6.132-2.948 8.794-11.133 14.216-20.619 13.509-16.135-1.202-28.034-9.04-35.819-23.179-.45-.81-.748-1.702-1.116-2.557zm56.113 1.512l-.05.076.075.012-.025-.088z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#3DAF00\" d=\"M90.566 72.203c1.477-.002 3.016.252 4.411-.085 1.187-.286 2.313-1.136 3.26-1.971.472-.416.481-1.357.699-2.061l17.229 3.397c-1.213 1.842-2.703 2.852-4.547 3.125-1.779.264-3.605.211-5.38.297.971 3.637-1.19 6.161-5.703 6.289-1.56.045-3.13-.26-4.696-.404-.32 2.979-1.801 4.366-4.954 4.616-2.437.193-4.786-.121-7.029-1.13-.324-.146-.671-.241-.994-.355-1.198 2.164-3.47 3.144-6.24 2.878-2.738-.262-5.258-1.01-7.365-2.858l-1.764-4.065.229-.234c1.875 1.536 4.035 1.918 6.292 1.515 2.209-.396 4.296-1.099 4.944-3.8 2.489 1.473 5.092 1.453 7.675.411.994-.4 1.925-1.036 2.77-1.71 1.236-.986 1.435-2.383 1.188-3.871l-.025.016z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#25A7F0\" d=\"M99.344 22.776c-2.602 1.165-4.554 3.131-6.217 5.347-1.361 1.813-2.477 3.812-3.692 5.732-.211.334-.377.698-.582 1.082l-3.764-2.086c2.382-7.037 13.278-14.682 20.596-14.37-3.902 4.192-4.148 9.618-5.312 14.722-.662 2.903-1.441 5.753-3.339 8.255l-6.398-5.414c2.383-4.706 5.011-9.311 8.886-13.078l.196-.329-.374.139z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#CBCBCA\" d=\"M68.996 41.635c-.142-3.141.945-5.894 2.78-8.358.239-.32 1.021-.365 1.536-.33 5.872.411 10.979 2.789 15.667 6.202.974.71 1.9 1.485 2.733 2.396-1.836-.394-3.664-.825-5.509-1.174-2.775-.524-5.524-.42-8.137.747-2.822 1.26-5.769 1.216-8.746 1.01l-.324-.493z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#3EAE00\" d=\"M85.736 64.646c7.66-.585 15.319-1.168 22.979-1.759.235-.019.464-.118.696-.18 1.56.445 3.14.829 4.672 1.353 1.646.563 2.407 1.917 2.988 3.746-1.227-.118-2.246-.211-3.264-.314l-21.305-2.175c-2.254-.229-4.51-.447-6.766-.671z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#25A5EC\" d=\"M82.877 41.404l3.757.521v1.766l.199.047.887-1.631 6.737 1.802c-.652.396-.967.609-1.301.784-2.447 1.282-5.082 1.854-7.814 2.082-.71.059-1.158-.128-1.335-.862-.334-1.396-.696-2.785-1.13-4.509z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#C9C8C7\" d=\"M68.996 41.635l.325.493c1.621 1.457 3.582 1.376 5.516 1.085 1.636-.245 3.236-.72 4.923-1.109l.091.956-9.769 4.403c-.764-1.829-1.359-3.74-1.086-5.828z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FBCB00\" d=\"M49.955 26.945c5.996-.01 10.78 4.694 10.79 10.607.01 5.985-4.794 10.87-10.717 10.9-5.859.028-10.764-4.844-10.771-10.7-.008-6.096 4.646-10.798 10.698-10.807zm6.45 10.728c.003-3.607-2.813-6.472-6.389-6.501-3.521-.028-6.431 2.876-6.463 6.451a6.387 6.387 0 0 0 6.408 6.458c3.614.006 6.441-2.806 6.444-6.408z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#3DAF00\" d=\"M90.589 72.187l-.064-.064.042.081.022-.017zm-23.091 7.17l.025.088-.075-.011z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#543828\" d=\"M99.344 22.776l.374-.14-.196.329-.178-.189z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#553928\" d=\"M56.405 37.673c-.003 3.603-2.83 6.414-6.443 6.408a6.387 6.387 0 0 1-6.408-6.458c.032-3.575 2.942-6.479 6.463-6.451 3.575.029 6.391 2.893 6.388 6.501zm-6.454-.243c1.059-.417 2.145-.67 3.029-1.237 1.103-.707 1.011-2.047-.024-2.86-1.486-1.167-4.486-1.164-5.944.006-1.027.825-1.11 2.16-.013 2.872.849.551 1.897.798 2.952 1.219z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M49.951 37.43c-1.055-.421-2.103-.668-2.952-1.22-1.098-.712-1.015-2.047.013-2.872 1.458-1.17 4.458-1.173 5.944-.006 1.035.813 1.127 2.153.024 2.86-.885.568-1.971.821-3.029 1.238z\"/></svg>"

/***/ }),

/***/ "../src/components/bower/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BowerOriginal = __webpack_require__("../src/components/bower/original/BowerOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BowerOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bower/plain-wordmark/BowerPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BowerPlainWordmark = __webpack_require__("../src/components/bower/plain-wordmark/BowerPlainWordmark.svg");
	
	var _BowerPlainWordmark2 = _interopRequireDefault(_BowerPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BowerPlainWordmark */
	function BowerPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BowerPlainWordmark',
	    svg: _BowerPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BowerPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BowerPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bower/plain-wordmark/BowerPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#EF5734\" d=\"M21.199 114.812c.479-.41.876-.915 1.193-1.514.315-.599.474-1.189.474-1.771 0-.248-.021-.498-.063-.75s-.129-.535-.257-.846a4.38 4.38 0 0 0-.494-.886 4.187 4.187 0 0 0-.821-.822 5.425 5.425 0 0 0-1.187-.692c-.445-.193-.99-.79-1.636-.91-.646-.121-1.358-.621-2.137-.621H9v19h6.771c1.018 0 1.952-.02 2.804-.174.851-.154 1.566-.324 2.149-.567.581-.244 1.094-.522 1.539-.865.444-.342.797-.68 1.059-1.027.261-.346.473-.708.636-1.092a5.15 5.15 0 0 0 .327-1.018 4.704 4.704 0 0 0-.783-3.606 5.092 5.092 0 0 0-2.303-1.839zM12 109h3.541c.769 0 1.419.374 1.95.52.529.146.917.492 1.161.74.244.249.411.565.507.801.094.236.141.526.141.801l-.013.301c-.12 1.154-1.345 1.904-3.124 2.23-.736.127-2.163.222-4.163.265V109zm8.896 11.489a2.368 2.368 0 0 1-.576.688 3.05 3.05 0 0 1-.893.461 8.19 8.19 0 0 1-1.013.289 9.036 9.036 0 0 1-1.104.148c-.427.034-.764-.016-1.007-.011l-.879-.063H12v-5.148c3-.094 3.403-.141 3.469-.141 1.653 0 3.1.252 4.071.758.97.504 1.524 1.197 1.524 2.078 0 .349-.009.663-.168.941zm22.423-12.709c-1.445-.727-3.098-1.09-4.953-1.09-1.873 0-3.537.378-4.99 1.135a8.276 8.276 0 0 0-3.414 3.271c-.821 1.425-1.231 3.073-1.231 4.946 0 1.505.264 2.857.789 4.055.525 1.197 1.235 2.17 2.13 2.919a9.503 9.503 0 0 0 3.034 1.706c1.13.39 2.323.584 3.579.584 1.909 0 3.598-.398 5.068-1.193a8.495 8.495 0 0 0 3.427-3.355c.813-1.441 1.219-3.094 1.219-4.959 0-1.838-.415-3.454-1.245-4.844a8.192 8.192 0 0 0-3.413-3.175zm.795 11.099c-.368.839-.855 1.501-1.463 1.989a6.623 6.623 0 0 1-4.194 1.475c-1.832 0-3.358-.599-4.582-1.796-1.223-1.197-1.834-2.785-1.834-4.761 0-.829.119-1.588.358-2.277.239-.688.561-1.268.963-1.739a5.72 5.72 0 0 1 1.404-1.187 6.343 6.343 0 0 1 1.675-.706 7.206 7.206 0 0 1 1.797-.225c.616 0 1.221.076 1.814.225.596.15 1.172.391 1.732.725s1.053.74 1.476 1.219c.425.479.764 1.08 1.021 1.802.257.723.385 1.521.385 2.393 0 1.071-.184 2.025-.552 2.863zm27.587 1.133L67.363 106h-2.976l-5.274 14.012L54.918 106h-3.413l6.017 19h3.092l5.158-13.947L70.161 125h3.092l6.993-19h-3.413zM84 125h13v-3H87v-5h9v-3h-9v-4h10v-4H84zm29.066-7.564a6.056 6.056 0 0 0 1.866-.918c.527-.386.942-.783 1.245-1.27a5.51 5.51 0 0 0 .668-1.502 6.304 6.304 0 0 0 .212-1.651c0-.675-.082-1.28-.244-1.823-.163-.543-.369-.99-.622-1.345s-.569-.666-.95-.931a5.23 5.23 0 0 0-1.104-.602 6.584 6.584 0 0 0-1.218-.326c-.459-.081-.848-.573-1.169-.594-.32-.021-.673-.474-1.058-.474H103v19h3v-7h3.257l5.106 7h4.208l-5.505-7.564zm-1.346-2.63c-.42.107-.825.142-1.219.178-.395.033-.847.016-1.36.016H106v-5h3.744c2.626 0 3.939.775 3.939 2.476 0 .454-.089.81-.265 1.143a2.018 2.018 0 0 1-.666.745c-.269.188-.613.334-1.032.442zm-4.255-45.612c1.934-1.064 3.245-2.627 2.833-5.102 1.979-.171 3.801-.661 5.339-1.896 1.246-1 1.784-2.303 2.207-3.837a3.92 3.92 0 0 0 .157-1.051v-3.021c0-.459-.058-.914-.167-1.379-.493-2.115-1.524-3.684-3.488-4.697-3.674-1.896-7.571-2.916-11.56-3.826-8.449-1.93-16.987-3.148-25.588-4.157-.996-.116-1.976-.25-2.97-.374.332-2.776 1.32-3.703 4.655-4.395.346.799.662 1.635 1.073 2.419.151.29.532.652.813.657 4.974.07 9.672-.785 13.482-4.336 2.978-2.776 4.298-6.38 5.029-10.262.265-1.412.52-2.827.729-4.247.653-4.418 2.961-7.952 5.904-11.153.145-.156.272-.326.485-.583-2.34-.726-4.65-.806-6.933-.39-8.737 1.6-15.324 6.196-19.418 14.181l-.141.151c-1.489-.376-2.989-.715-4.457-1.158-.27-.081-.479-.562-.599-.899-2.401-6.815-6.55-12.124-13.316-15.001-2.015-.858-4.267-1.113-6.407-1.678L54.81 3h-6.477c-1.422 0-2.848.467-4.263.762-16.938 3.546-30.18 16.821-33.28 33.919-3.312 18.262 1.7 34.313 13.728 48.277a20.66 20.66 0 0 0 6.511 5.069c4.649 2.304 9.693.638 12.07-3.994l.198-.331c1.018 2.658 2.109 5.233 2.985 7.882.854 2.576 3.934 3.752 5.814 3.629.354-.024.79.221 1.045.028 1.683-1.276 3.011.759 4.474.759h2.376c1.677-1 3.27-1.38 4.367-2.889.134-.186.729-.196 1.105-.156 2.147.223 4.142-.26 5.945-1.465 1.508-1.008 2.454-2.416 2.649-4.239 1.908-.559 3.092-2.014 3.155-4.258.035-1.216-.075-2.585-.596-3.65-1.587-3.248-3.405-6.387-5.135-9.566l-.141-.308.337.131c2.54 1.239 5.213 1.791 8.039 1.554 1.801-.148 2.881-.727 3.786-2.111 2.231 1.576 4.739 2.321 7.472 2.128 2.72-.192 5.275-.774 6.741-3.486 1.932 0 3.914.179 5.843-.062 1.348-.167 2.701-.764 3.907-1.429zm-56.15-36.507a5.642 5.642 0 0 1-5.661-5.704c.029-3.157 2.6-5.722 5.709-5.699 3.159.027 5.646 2.557 5.644 5.744-.003 3.181-2.501 5.665-5.692 5.659zm17.347 4.571c-.722-1.727-1.283-3.535-1.026-5.507-.133-2.966.894-5.567 2.628-7.896.226-.303.964-.346 1.45-.312 5.548.388 10.373 2.634 14.802 5.86.92.67 1.795 1.403 2.583 2.264-1.734-.373-3.462-.78-5.205-1.108-2.622-.496-5.219-.397-7.687.705-2.666 1.191-5.451 1.149-8.264.955 1.531 1.375 3.385 1.3 5.211 1.024 1.546-.231 3.059-.681 4.651-1.048l.086.903-9.229 4.16z\"/></svg>"

/***/ }),

/***/ "../src/components/bower/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BowerPlainWordmark = __webpack_require__("../src/components/bower/plain-wordmark/BowerPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BowerPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bower/plain/BowerPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _BowerPlain = __webpack_require__("../src/components/bower/plain/BowerPlain.svg");
	
	var _BowerPlain2 = _interopRequireDefault(_BowerPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** BowerPlain */
	function BowerPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'BowerPlain',
	    svg: _BowerPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	BowerPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = BowerPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/bower/plain/BowerPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#EF5734\" d=\"M124.797 65.636c-.559-2.396-1.734-4.17-3.956-5.316-4.161-2.147-8.577-3.302-13.091-4.333-9.566-2.186-19.235-3.564-28.973-4.706-1.127-.132-2.237-.282-3.363-.424.376-3.143 1.495-4.192 5.271-4.975.391.905.749 1.851 1.214 2.739.172.328.603.738.919.743 5.632.079 10.951-.888 15.265-4.908 3.371-3.144 4.867-7.224 5.693-11.619.3-1.598.588-3.199.825-4.808.739-5.002 3.353-9.002 6.685-12.626.163-.177.308-.369.549-.661-2.649-.822-5.265-.913-7.849-.44-9.892 1.81-17.349 7.015-21.982 16.055l-.16.17c-1.686-.426-3.384-.81-5.046-1.311-.304-.092-.543-.636-.678-1.018-2.718-7.715-7.416-13.725-15.075-16.983-2.281-.972-4.83-.826-7.254-1.465-.132-.035-.241.25-.36.25h-7.332c-1.609 0-3.225.096-4.826.432C22.097 14.445 7.105 29.256 3.596 48.614-.153 69.289 5.52 87.352 19.137 103.162c2.047 2.377 4.519 4.271 7.37 5.685 5.264 2.608 10.975.695 13.666-4.549l.225-.389c1.151 3.009 2.388 5.919 3.38 8.917.966 2.917 4.453 4.246 6.582 4.105.401-.026.895.338 1.182.12 1.907-1.445 3.41.949 5.067.949h2.688c1.898-1 3.701-1.653 4.943-3.361.152-.211.827-.269 1.252-.225 2.432.253 4.688-.314 6.73-1.679 1.708-1.143 2.779-2.746 2.999-4.811 2.161-.632 3.501-2.286 3.573-4.827.04-1.377-.084-2.93-.674-4.135-1.797-3.678-3.856-7.232-5.813-10.832l-.16-.348.383.15c2.876 1.401 5.9 2.024 9.1 1.758 2.039-.169 3.262-.823 4.288-2.391 2.525 1.783 5.364 2.628 8.458 2.409 3.079-.217 5.973-.876 7.631-3.946 2.188 0 4.432.203 6.615-.069 1.522-.189 3.054-.866 4.421-1.619 2.189-1.205 3.674-2.974 3.206-5.775 2.242-.194 4.304-.748 6.045-2.146 1.409-1.132 2.035-2.607 2.513-4.346.111-.407.193-.793.193-1.188v-3.421c0-.521-.08-1.034-.203-1.562zM49.475 42.744a6.386 6.386 0 0 1-6.408-6.457c.032-3.575 2.942-6.479 6.463-6.452 3.576.029 6.392 2.895 6.389 6.502-.005 3.602-2.831 6.414-6.444 6.407zm19.638 5.175c-.817-1.956-1.452-4.001-1.161-6.234-.151-3.359 1.012-6.303 2.974-8.939.256-.342 1.092-.392 1.643-.353 6.281.439 11.744 2.982 16.758 6.634 1.041.759 2.032 1.588 2.924 2.563-1.964-.421-3.92-.882-5.893-1.255-2.969-.562-5.908-.449-8.703.799-3.019 1.348-6.17 1.301-9.355 1.08 1.735 1.558 3.833 1.472 5.901 1.16 1.749-.262 3.461-.77 5.265-1.187l.097 1.022-10.45 4.71z\"/></svg>"

/***/ }),

/***/ "../src/components/bower/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BowerPlain = __webpack_require__("../src/components/bower/plain/BowerPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BowerPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/c/line/CLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CLine = __webpack_require__("../src/components/c/line/CLine.svg");
	
	var _CLine2 = _interopRequireDefault(_CLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CLine */
	function CLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CLine',
	    svg: _CLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/c/line/CLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M116.5 32.3c-.6-1.1-1.4-2.1-2.3-2.6L66.1 1.9c-.8-.5-1.9-.7-3.1-.7-1.2 0-2.3.3-3.1.7L11.4 29.7c-1.7 1-3.4 3.5-3.4 5.4v55.7c0 1.1.7 2.3 1.4 3.4l.1.1c.5.8 1.3 1.5 2 1.9l48.3 27.9c.8.5 2 .7 3.2.7 1.2 0 2.3-.3 3.1-.7l47.5-27.9c1.7-1 2.4-3.5 2.4-5.4V35.1c0-.8.4-1.8 0-2.6l.5-.2zm-4.2 2.1c0 .3-.3.5-.3.7v55.7c0 .8-.2 1.7-.4 2L64 120.6c-.1.1-.5.2-1.1.2-.6 0-1-.1-1.1-.2L13.6 92.8s-.1-.1-.2-.1l-.6-.6c-.4-.7.2-1.1-.8-1.2V35.2c1-.5.9-1.7 1.4-1.9L61.7 5.4c.1 0 .6-.2 1.2-.2s1 .1 1.1.2l48 27.7.4.9c.1.1-.1.3-.1.4zM63 38.5c9.1 0 17.1 5 21.3 12.5l13-7.5c-6.8-11.9-19.6-20-34.3-20-21.8 0-39.5 17.7-39.5 39.5s17.7 39.5 39.5 39.5c14.6 0 27.4-8 34.2-19.8l-12.9-7.6C80.1 82.5 72.1 87.5 63 87.5c-13.5 0-24.5-11-24.5-24.5s11-24.5 24.5-24.5z\" fill=\"#03599C\"/></svg>"

/***/ }),

/***/ "../src/components/c/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CLine = __webpack_require__("../src/components/c/line/CLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/c/original/COriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _COriginal = __webpack_require__("../src/components/c/original/COriginal.svg");
	
	var _COriginal2 = _interopRequireDefault(_COriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** COriginal */
	function COriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'COriginal',
	    svg: _COriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	COriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = COriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/c/original/COriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#659AD3\" d=\"M115.4 30.7L67.1 2.9c-.8-.5-1.9-.7-3.1-.7-1.2 0-2.3.3-3.1.7l-48 27.9c-1.7 1-2.9 3.5-2.9 5.4v55.7c0 1.1.2 2.4 1 3.5l106.8-62c-.6-1.2-1.5-2.1-2.4-2.7z\"/><path fill=\"#03599C\" d=\"M10.7 95.3c.5.8 1.2 1.5 1.9 1.9l48.2 27.9c.8.5 1.9.7 3.1.7 1.2 0 2.3-.3 3.1-.7l48-27.9c1.7-1 2.9-3.5 2.9-5.4V36.1c0-.9-.1-1.9-.6-2.8l-106.6 62z\"/><path fill=\"#fff\" d=\"M85.3 76.1C81.1 83.5 73.1 88.5 64 88.5c-13.5 0-24.5-11-24.5-24.5s11-24.5 24.5-24.5c9.1 0 17.1 5 21.3 12.5l13-7.5c-6.8-11.9-19.6-20-34.3-20-21.8 0-39.5 17.7-39.5 39.5s17.7 39.5 39.5 39.5c14.6 0 27.4-8 34.2-19.8l-12.9-7.6z\"/></svg>"

/***/ }),

/***/ "../src/components/c/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _COriginal = __webpack_require__("../src/components/c/original/COriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_COriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/c/plain/CPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CPlain = __webpack_require__("../src/components/c/plain/CPlain.svg");
	
	var _CPlain2 = _interopRequireDefault(_CPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CPlain */
	function CPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CPlain',
	    svg: _CPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/c/plain/CPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#03599C\" d=\"M117.5 33.5l.3-.2c-.6-1.1-1.5-2.1-2.4-2.6L67.1 2.9c-.8-.5-1.9-.7-3.1-.7-1.2 0-2.3.3-3.1.7l-48 27.9c-1.7 1-2.9 3.5-2.9 5.4v55.7c0 1.1.2 2.3.9 3.4l-.2.1c.5.8 1.2 1.5 1.9 1.9l48.2 27.9c.8.5 1.9.7 3.1.7 1.2 0 2.3-.3 3.1-.7l48-27.9c1.7-1 2.9-3.5 2.9-5.4V36.1c.1-.8 0-1.7-.4-2.6zM64 88.5c9.1 0 17.1-5 21.3-12.4l12.9 7.6c-6.8 11.8-19.6 19.8-34.2 19.8-21.8 0-39.5-17.7-39.5-39.5S42.2 24.5 64 24.5c14.7 0 27.5 8.1 34.3 20l-13 7.5C81.1 44.5 73.1 39.5 64 39.5c-13.5 0-24.5 11-24.5 24.5s11 24.5 24.5 24.5z\"/></svg>"

/***/ }),

/***/ "../src/components/c/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CPlain = __webpack_require__("../src/components/c/plain/CPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cakephp/original-wordmark/CakephpOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CakephpOriginalWordmark = __webpack_require__("../src/components/cakephp/original-wordmark/CakephpOriginalWordmark.svg");
	
	var _CakephpOriginalWordmark2 = _interopRequireDefault(_CakephpOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CakephpOriginalWordmark */
	function CakephpOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CakephpOriginalWordmark',
	    svg: _CakephpOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CakephpOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CakephpOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cakephp/original-wordmark/CakephpOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Devicon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#d43d44}.cls-2{fill:#414143}</style></defs><title>Artboard 13</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M17.73 61.51l12.49 3.1c2.17-.85 3.48-1.93 3.48-3.1v-5c0-2.75-7.15-5-16-5s-16 2.23-16 5v5c0 2.75 7.15 5 16 5v-5z\"/><path class=\"cls-1\" d=\"M30.23 69.6l-12.49-3.1v5l12.49 3.11c2.17-.85 3.48-1.93 3.48-3.11v-5c0 1.17-1.31 2.25-3.48 3.1zM1.77 66.5v5c0 2.75 7.15 5 16 5v-5c-8.85-.02-16-2.25-16-5z\"/><path class=\"cls-2\" d=\"M47.42 71a6.69 6.69 0 0 1-6.8-6.82 6.74 6.74 0 0 1 6.91-6.85 6.84 6.84 0 0 1 5.22 2L50.9 61.5a4.89 4.89 0 0 0-3.39-1.5 3.93 3.93 0 0 0-3.84 4.13 3.93 3.93 0 0 0 3.84 4.16A4.78 4.78 0 0 0 51 66.78l1.86 1.87A6.76 6.76 0 0 1 47.42 71zM60.82 70.8v-1.1a3.89 3.89 0 0 1-3.07 1.3c-1.91 0-3.48-1.1-3.48-3.11 0-2.22 1.68-3.24 4.09-3.24a7.19 7.19 0 0 1 2.48.42v-.17c0-1.19-.74-1.86-2.18-1.86a7.46 7.46 0 0 0-2.8.55l-.72-2.2a9 9 0 0 1 3.94-.82c3.14 0 4.52 1.63 4.52 4.38v5.85h-2.78zm.06-4.09a4.42 4.42 0 0 0-1.88-.38c-1.23 0-2 .49-2 1.4 0 .78.64 1.23 1.57 1.23 1.34 0 2.25-.73 2.25-1.78zM72.61 70.8L70 66.65l-1 1.06v3.09h-2.92V57H69v7.37l3.37-3.69h3.44l-3.86 4 4 6.15h-3.34zM86.24 66.73h-7.06a2.35 2.35 0 0 0 2.48 2 3.33 3.33 0 0 0 2.46-1l1.65 1.46a5.36 5.36 0 0 1-9.45-3.35 5.05 5.05 0 0 1 5-5.28c3.39 0 4.94 2.63 4.94 5.51.01.22 0 .39-.02.66zm-4.9-4a2.26 2.26 0 0 0-2.2 2.16h4.34a2.17 2.17 0 0 0-2.15-2.12z\"/><path class=\"cls-1\" d=\"M93.85 66.82h-2.22v4h-2.91V57.54h5.41c3.16 0 5.07 1.87 5.07 4.58 0 3.11-2.38 4.7-5.35 4.7zm2.4-4.64c0-1.31-.91-2-2.37-2h-2.25v4.05h2.31a2.05 2.05 0 0 0 2.31-2zM109.65 70.8v-5.33h-5.38v5.33h-2.91V57.54h2.91v5.24h5.38v-5.24h2.92V70.8zM120.88 66.82h-2.21v4h-2.92V57.54h5.41c3.16 0 5.07 1.87 5.07 4.58 0 3.11-2.38 4.7-5.35 4.7zm2.4-4.64c0-1.31-.91-2-2.37-2h-2.25v4.05H121a2.05 2.05 0 0 0 2.31-2z\"/></g></svg>"

/***/ }),

/***/ "../src/components/cakephp/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CakephpOriginalWordmark = __webpack_require__("../src/components/cakephp/original-wordmark/CakephpOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CakephpOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cakephp/original/CakephpOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CakephpOriginal = __webpack_require__("../src/components/cakephp/original/CakephpOriginal.svg");
	
	var _CakephpOriginal2 = _interopRequireDefault(_CakephpOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CakephpOriginal */
	function CakephpOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CakephpOriginal',
	    svg: _CakephpOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CakephpOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CakephpOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cakephp/original/CakephpOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Devicon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#d43d44}</style></defs><title>Artboard 14</title><g id=\"plain\"><path class=\"cls-1\" d=\"M2 73.69V93c0 10.69 27.75 19.35 62 19.35V93C29.75 93 2 84.36 2 73.69zM64 54.34l48.5 12c8.44-3.3 13.51-7.5 13.51-12V35c0-10.68-27.76-19.35-62-19.35S2 24.29 2 35v19.34C2 65 29.75 73.69 64 73.69V54.34zM112.49 85.74L64 73.69V93l48.5 12.05c8.43-3.27 13.5-7.46 13.5-12.05V73.69c0 4.55-5.07 8.74-13.51 12.05z\"/></g></svg>"

/***/ }),

/***/ "../src/components/cakephp/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CakephpOriginal = __webpack_require__("../src/components/cakephp/original/CakephpOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CakephpOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cakephp/plain-wordmark/CakephpPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CakephpPlainWordmark = __webpack_require__("../src/components/cakephp/plain-wordmark/CakephpPlainWordmark.svg");
	
	var _CakephpPlainWordmark2 = _interopRequireDefault(_CakephpPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CakephpPlainWordmark */
	function CakephpPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CakephpPlainWordmark',
	    svg: _CakephpPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CakephpPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CakephpPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cakephp/plain-wordmark/CakephpPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Devicon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#d43d44}</style></defs><title>Artboard 15</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M17.73 61.51l12.49 3.1c2.17-.85 3.48-1.93 3.48-3.1v-5c0-2.75-7.15-5-16-5s-16 2.23-16 5v5c0 2.75 7.15 5 16 5v-5z\"/><path class=\"cls-1\" d=\"M30.23 69.6l-12.49-3.1v5l12.49 3.11c2.17-.85 3.48-1.93 3.48-3.11v-5c0 1.17-1.31 2.25-3.48 3.1zM1.77 66.5v5c0 2.75 7.15 5 16 5v-5c-8.85-.02-16-2.25-16-5zM47.42 71a6.69 6.69 0 0 1-6.8-6.82 6.74 6.74 0 0 1 6.91-6.85 6.84 6.84 0 0 1 5.22 2L50.9 61.5a4.89 4.89 0 0 0-3.39-1.5 3.93 3.93 0 0 0-3.84 4.13 3.93 3.93 0 0 0 3.84 4.16A4.78 4.78 0 0 0 51 66.78l1.86 1.87A6.76 6.76 0 0 1 47.42 71zM60.82 70.8v-1.1a3.89 3.89 0 0 1-3.07 1.3c-1.91 0-3.48-1.1-3.48-3.11 0-2.22 1.68-3.24 4.09-3.24a7.19 7.19 0 0 1 2.48.42v-.17c0-1.19-.74-1.86-2.18-1.86a7.46 7.46 0 0 0-2.8.55l-.72-2.2a9 9 0 0 1 3.94-.82c3.14 0 4.52 1.63 4.52 4.38v5.85h-2.78zm.06-4.09a4.42 4.42 0 0 0-1.88-.38c-1.23 0-2 .49-2 1.4 0 .78.64 1.23 1.57 1.23 1.34 0 2.25-.73 2.25-1.78zM72.61 70.8L70 66.65l-1 1.06v3.09h-2.92V57H69v7.37l3.37-3.69h3.44l-3.86 4 4 6.15h-3.34zM86.24 66.73h-7.06a2.35 2.35 0 0 0 2.48 2 3.33 3.33 0 0 0 2.46-1l1.65 1.46a5.36 5.36 0 0 1-9.45-3.35 5.05 5.05 0 0 1 5-5.28c3.39 0 4.94 2.63 4.94 5.51.01.22 0 .39-.02.66zm-4.9-4a2.26 2.26 0 0 0-2.2 2.16h4.34a2.17 2.17 0 0 0-2.15-2.12zM93.85 66.82h-2.22v4h-2.91V57.54h5.41c3.16 0 5.07 1.87 5.07 4.58 0 3.11-2.38 4.7-5.35 4.7zm2.4-4.64c0-1.31-.91-2-2.37-2h-2.25v4.05h2.31a2.05 2.05 0 0 0 2.31-2zM109.65 70.8v-5.33h-5.38v5.33h-2.91V57.54h2.91v5.24h5.38v-5.24h2.92V70.8zM120.88 66.82h-2.21v4h-2.92V57.54h5.41c3.16 0 5.07 1.87 5.07 4.58 0 3.11-2.38 4.7-5.35 4.7zm2.4-4.64c0-1.31-.91-2-2.37-2h-2.25v4.05H121a2.05 2.05 0 0 0 2.31-2z\"/></g></svg>"

/***/ }),

/***/ "../src/components/cakephp/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CakephpPlainWordmark = __webpack_require__("../src/components/cakephp/plain-wordmark/CakephpPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CakephpPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cakephp/plain/CakephpPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CakephpPlain = __webpack_require__("../src/components/cakephp/plain/CakephpPlain.svg");
	
	var _CakephpPlain2 = _interopRequireDefault(_CakephpPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CakephpPlain */
	function CakephpPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CakephpPlain',
	    svg: _CakephpPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CakephpPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CakephpPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cakephp/plain/CakephpPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Devicon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#d43d44}</style></defs><title>Artboard 12</title><g id=\"original\"><path class=\"cls-1\" d=\"M2 73.69V93c0 10.69 27.75 19.35 62 19.35V93C29.75 93 2 84.36 2 73.69zM64 54.34l48.5 12c8.44-3.3 13.51-7.5 13.51-12V35c0-10.68-27.76-19.35-62-19.35S2 24.29 2 35v19.34C2 65 29.75 73.69 64 73.69V54.34zM112.49 85.74L64 73.69V93l48.5 12.05c8.43-3.27 13.5-7.46 13.5-12.05V73.69c0 4.55-5.07 8.74-13.51 12.05z\"/></g></svg>"

/***/ }),

/***/ "../src/components/cakephp/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CakephpPlain = __webpack_require__("../src/components/cakephp/plain/CakephpPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CakephpPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ceylon/original-wordmark/CeylonOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CeylonOriginalWordmark = __webpack_require__("../src/components/ceylon/original-wordmark/CeylonOriginalWordmark.svg");
	
	var _CeylonOriginalWordmark2 = _interopRequireDefault(_CeylonOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CeylonOriginalWordmark */
	function CeylonOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CeylonOriginalWordmark',
	    svg: _CeylonOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CeylonOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CeylonOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ceylon/original-wordmark/CeylonOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Ceylon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#ab710a}.cls-2{fill:#e3a835}.cls-3{opacity:.45;isolation:isolate;fill:url(#radial-gradient)}.cls-4{fill:url(#radial-gradient-2)}</style><radialGradient id=\"radial-gradient\" cx=\"39.14\" cy=\"1098.91\" r=\"27.32\" gradientTransform=\"matrix(1 0 0 -1 0 1148.01)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#ab710a\"/></radialGradient><radialGradient id=\"radial-gradient-2\" cx=\"46.35\" cy=\"1093.1\" r=\"14.18\" gradientTransform=\"matrix(1 0 0 -1 0 1148.01)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#d5d5d5\"/><stop offset=\"1\" stop-color=\"#141006\"/></radialGradient></defs><title>Artboard 13</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M18.4 71a6 6 0 0 1-1.09-.39c-.8 1.26-2.66 4.45-2.93 7.33h4.81A24.34 24.34 0 0 1 18.4 71zM34 68.43a35.87 35.87 0 0 0-2.24 6.72c-.21.93.42 1.86.3 2.78h6.05c-1.59-4.4-2-10.81-2.78-13.37-.02-.04-1.33 3.9-1.33 3.87z\"/><path class=\"cls-2\" d=\"M51.22 53.27c-1.38-2-4.52-3.6-5.25-5.83a3.3 3.3 0 0 1 .14-2.29c.33-.5-.21-.38-.21-.38-.78.3-1.12-.56-1.12-.56-.12-.3 0-1.22-.63-.72-1.21.91-.81 3.12-.59 4a9.3 9.3 0 0 0 2.31 4c.37.37 2.86 3.07 2.52 4.47a1.11 1.11 0 0 1-.84 1c-1.8.36-2.38-1.84-2.38-1.84-1.35-5.75-3.52-7.76-3.52-7.76a42.66 42.66 0 0 0-10.51.91A62.3 62.3 0 0 0 7.57 52c-3 4.24-4.69 12.12-4.69 12.12a.11.11 0 0 0 .1 0 24.8 24.8 0 0 1 3.74-3.78C6.48 71.26 9 77.93 9 77.93h4.7c.33-3.94 3.43-8.31 3.43-8.31 1.75 1.32 5.69.93 5.69.93.69 2.65 2.11 7.37 2.11 7.37h5.66a35.77 35.77 0 0 1 3.08-10.42 23.05 23.05 0 0 0 1.45-4.12 2.39 2.39 0 0 1 2.51-2.16c.85 0 4.73 2.17 7.63 2 5.05-.25 7-2.59 7.14-5.25a8.09 8.09 0 0 0-1.18-4.7zM35 58.92a.87.87 0 0 1-.11.21.58.58 0 0 1-.2.18.54.54 0 0 1-.29.06.84.84 0 0 1-.26-.06 2.46 2.46 0 0 1-.74-.52l-.3-.3-.27-.29a1.75 1.75 0 0 0-.58-.31c-.23-.08-.48-.15-.74-.21s-.52-.13-.81-.22l-.22-.09-.12-.06-.15-.1a1 1 0 0 1-.22-.28 1.19 1.19 0 0 1-.11-.29 1.93 1.93 0 0 1 0-.51 3.41 3.41 0 0 1 .05-.46 6.63 6.63 0 0 1 .22-.83q.13-.4.29-.78l.16-.39a4.17 4.17 0 0 1 .2-.39A4.4 4.4 0 0 1 31.9 52a5 5 0 0 1 .71-.45 4 4 0 0 1 .77-.31 7.16 7.16 0 0 0-1.21 1.06 4.81 4.81 0 0 0-.85 1.27 3.39 3.39 0 0 0-.13.35l-.12.38c-.08.25-.15.51-.22.76a7 7 0 0 0-.16.75 3.05 3.05 0 0 0 0 .35 1.11 1.11 0 0 0 0 .29.25.25 0 0 0 .06.13h.06l.15.06c.23.08.49.15.75.24a7 7 0 0 1 .8.29 2.16 2.16 0 0 1 .79.55c.1.12.17.23.25.34l.24.32.25.29a1.43 1.43 0 0 0 .26.23.32.32 0 0 0 .24.07.44.44 0 0 0 .23-.2 1.86 1.86 0 0 0 .17-.35c.05-.12.09-.25.13-.39a2.32 2.32 0 0 1-.07.89zm5-3.49a.86.86 0 1 1-.34-1 .75.75 0 0 1 .34 1z\"/><path class=\"cls-3\" d=\"M51.22 53.27c-1.38-2-4.52-3.6-5.25-5.83a3.3 3.3 0 0 1 .14-2.29c.33-.5-.21-.38-.21-.38-.78.3-1.12-.56-1.12-.56-.12-.3 0-1.22-.63-.72-1.21.91-.81 3.12-.59 4a9.3 9.3 0 0 0 2.31 4c.37.37 2.86 3.07 2.52 4.47a1.11 1.11 0 0 1-.84 1c-1.8.36-2.38-1.84-2.38-1.84-1.35-5.75-3.52-7.76-3.52-7.76a42.66 42.66 0 0 0-10.51.91A62.3 62.3 0 0 0 7.57 52c-3 4.24-4.69 12.12-4.69 12.12a.11.11 0 0 0 .1 0 24.8 24.8 0 0 1 3.74-3.78C6.48 71.26 9 77.93 9 77.93h4.7c.33-3.94 3.43-8.31 3.43-8.31 1.75 1.32 5.69.93 5.69.93.69 2.65 2.11 7.37 2.11 7.37h5.66a35.77 35.77 0 0 1 3.08-10.42 23.05 23.05 0 0 0 1.45-4.12 2.39 2.39 0 0 1 2.51-2.16c.85 0 4.73 2.17 7.63 2 5.05-.25 7-2.59 7.14-5.25a8.09 8.09 0 0 0-1.18-4.7zM35 58.92a.87.87 0 0 1-.11.21.58.58 0 0 1-.2.18.54.54 0 0 1-.29.06.84.84 0 0 1-.26-.06 2.46 2.46 0 0 1-.74-.52l-.3-.3-.27-.29a1.75 1.75 0 0 0-.58-.31c-.23-.08-.48-.15-.74-.21s-.52-.13-.81-.22l-.22-.09-.12-.06-.15-.1a1 1 0 0 1-.22-.28 1.19 1.19 0 0 1-.11-.29 1.93 1.93 0 0 1 0-.51 3.41 3.41 0 0 1 .05-.46 6.63 6.63 0 0 1 .22-.83q.13-.4.29-.78l.16-.39a4.17 4.17 0 0 1 .2-.39A4.4 4.4 0 0 1 31.9 52a5 5 0 0 1 .71-.45 4 4 0 0 1 .77-.31 7.16 7.16 0 0 0-1.21 1.06 4.81 4.81 0 0 0-.85 1.27 3.39 3.39 0 0 0-.13.35l-.12.38c-.08.25-.15.51-.22.76a7 7 0 0 0-.16.75 3.05 3.05 0 0 0 0 .35 1.11 1.11 0 0 0 0 .29.25.25 0 0 0 .06.13h.06l.15.06c.23.08.49.15.75.24a7 7 0 0 1 .8.29 2.16 2.16 0 0 1 .79.55c.1.12.17.23.25.34l.24.32.25.29a1.43 1.43 0 0 0 .26.23.32.32 0 0 0 .24.07.44.44 0 0 0 .23-.2 1.86 1.86 0 0 0 .17-.35c.05-.12.09-.25.13-.39a2.32 2.32 0 0 1-.07.89zm5-3.49a.86.86 0 1 1-.34-1 .75.75 0 0 1 .34 1z\"/><path class=\"cls-4\" d=\"M118.41 61.43a7.61 7.61 0 0 0-5.41 2.46l-2.46-2.12h-1.14v3.57a8.45 8.45 0 0 0-14.24 0V57l-4.28-3.71h-1.17v8.52h-3.23l-3.82 7.51-3.84-7.51H73l1.26 2.48a8.15 8.15 0 0 0-6.24-2.82c-5.29 0-8.86 3.78-8.86 8.43a8.75 8.75 0 0 0 .13 1.49 9.16 9.16 0 0 1-4.52 1.21 4.15 4.15 0 0 1-4.3-4.33 4.2 4.2 0 0 1 4.3-4.37c2.48 0 3.59 1 5 1.48V59.9a9.1 9.1 0 0 0-5.63-1.74 12.25 12.25 0 0 0-1.41.08c-.13 1.71-1.2 5.15-7.57 5.47h-.55a10 10 0 0 0-1.06 4.51c0 5.52 4.41 10.07 10.59 10.07a8.91 8.91 0 0 0 5.63-1.81v-3.35c1.25 3 4.27 5 8.61 5a9.81 9.81 0 0 0 7-2.89l-2.06-2.37a5.64 5.64 0 0 1-3.81 1.35c-3 0-4.86-1.54-4.71-3.72H76a7.72 7.72 0 0 0-.08-3.11L79.74 75l-4.92 9.69h5.63l9.26-18.17v11.31h5.45v-3.55a8.45 8.45 0 0 0 14.24 0v3.57h5.48V67.43a3.06 3.06 0 0 1 2.8-1.78c1.35 0 2 .83 2 3.35v8.83h5.48V67.49c-.04-3.14-1.95-6.06-6.75-6.06zm-53.34 5.91a3.4 3.4 0 0 1 3-2.46 2.39 2.39 0 0 1 2.61 2.46zm37.19 6.86c-1.45 0-2.68-2-2.68-4.4s1.23-4.4 2.68-4.4 2.71 2 2.71 4.4-1.23 4.4-2.71 4.4z\"/></g></svg>"

/***/ }),

/***/ "../src/components/ceylon/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CeylonOriginalWordmark = __webpack_require__("../src/components/ceylon/original-wordmark/CeylonOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CeylonOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ceylon/original/CeylonOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CeylonOriginal = __webpack_require__("../src/components/ceylon/original/CeylonOriginal.svg");
	
	var _CeylonOriginal2 = _interopRequireDefault(_CeylonOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CeylonOriginal */
	function CeylonOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CeylonOriginal',
	    svg: _CeylonOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CeylonOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CeylonOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ceylon/original/CeylonOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Ceylon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#ab710a}.cls-2{fill:#e3a835}.cls-3{opacity:.45;isolation:isolate;fill:url(#radial-gradient)}</style><radialGradient id=\"radial-gradient\" cx=\"93.44\" cy=\"1113.51\" r=\"69.83\" gradientTransform=\"matrix(1 0 0 -1 0 1148.01)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#ab710a\"/></radialGradient></defs><title>Artboard 12</title><g id=\"original\"><path class=\"cls-1\" d=\"M40.42 90.46a15.35 15.35 0 0 1-2.8-1c-2.05 3.22-6.8 11.37-7.48 18.75h12.3a62.21 62.21 0 0 1-2.02-17.75zM80.28 83.92a91.7 91.7 0 0 0-5.71 17.18c-.53 2.38 1.08 4.75.78 7.11h15.47c-4.08-11.26-5-27.64-7.11-34.19-.05-.09-3.37 9.98-3.43 9.9z\"/><path class=\"cls-2\" d=\"M124.32 45.19c-3.52-5-11.55-9.2-13.42-14.91-.48-1.46-.56-4.46.36-5.86s-.54-1-.54-1c-2 .77-2.86-1.43-2.86-1.43-.3-.77.11-3.12-1.61-1.84-3.1 2.33-2.08 8-1.5 10.28a23.76 23.76 0 0 0 5.9 10.34c1 .93 7.3 7.86 6.44 11.41a2.85 2.85 0 0 1-2.15 2.62c-4.59.92-6.08-4.71-6.08-4.71-3.44-14.69-9-19.83-9-19.83A109.06 109.06 0 0 0 73 32.62c-34.37-1.29-60.23 9.27-60.23 9.27-7.56 10.85-12 31-12 31s0 .1.07.11a.27.27 0 0 0 .26-.13 63.4 63.4 0 0 1 9.57-9.66c-.72 28 5.62 45 5.62 45h12C29.14 98.12 37.06 87 37.06 87c4.46 3.38 14.54 2.38 14.54 2.38 1.78 6.74 5.4 18.82 5.4 18.82h14.46a91.43 91.43 0 0 1 7.87-26.64S82.91 73.44 83 71c.23-4.25 4.25-5.51 6.43-5.51s12.1 5.54 19.51 5.17c12.91-.65 18-6.62 18.25-13.43.2-4.68-.9-9.23-2.87-12.04zM82.83 59.62a2.23 2.23 0 0 1-.27.54 1.48 1.48 0 0 1-.51.47 1.39 1.39 0 0 1-.73.16 2.16 2.16 0 0 1-.66-.15 6.29 6.29 0 0 1-1.88-1.32c-.27-.25-.52-.51-.76-.76l-.7-.73a4.47 4.47 0 0 0-1.48-.83c-.59-.21-1.23-.38-1.9-.54s-1.34-.33-2.07-.57a4.96 4.96 0 0 1-.58-.23l-.29-.11a2.44 2.44 0 0 1-.38-.27 2.49 2.49 0 0 1-.56-.7 3.05 3.05 0 0 1-.28-.74 4.93 4.93 0 0 1-.1-1.32 8.71 8.71 0 0 1 .13-1.16 17 17 0 0 1 .55-2.13q.33-1 .73-2c.13-.33.26-.65.41-1a10.66 10.66 0 0 1 .52-1A11.25 11.25 0 0 1 74.94 42a12.89 12.89 0 0 1 1.81-1.14 10.3 10.3 0 0 1 2-.8 18.29 18.29 0 0 0-3.08 2.71A12.3 12.3 0 0 0 73.48 46a8.65 8.65 0 0 0-.34.89l-.31 1c-.2.65-.4 1.3-.56 1.95a18 18 0 0 0-.41 1.91 7.8 7.8 0 0 0-.09.9 2.84 2.84 0 0 0 .06.75.65.65 0 0 0 .16.34l.14.08.39.16c.58.22 1.25.39 1.92.6a17.92 17.92 0 0 1 2.05.75 5.53 5.53 0 0 1 2 1.4c.25.31.43.58.64.86l.61.81c.2.26.41.51.63.74a3.66 3.66 0 0 0 .67.58.81.81 0 0 0 .61.17 1.12 1.12 0 0 0 .59-.51 4.75 4.75 0 0 0 .44-.89c.13-.32.23-.65.34-1a5.93 5.93 0 0 1-.19 2.13zm12.78-8.92a2.19 2.19 0 1 1-.88-2.52 1.92 1.92 0 0 1 .88 2.52z\"/><path class=\"cls-3\" d=\"M124.32 45.19c-3.52-5-11.55-9.2-13.42-14.91-.48-1.46-.56-4.46.36-5.86s-.54-1-.54-1c-2 .77-2.86-1.43-2.86-1.43-.3-.77.11-3.12-1.61-1.84-3.1 2.33-2.08 8-1.5 10.28a23.76 23.76 0 0 0 5.9 10.34c1 .93 7.3 7.86 6.44 11.41a2.85 2.85 0 0 1-2.15 2.62c-4.59.92-6.08-4.71-6.08-4.71-3.44-14.69-9-19.83-9-19.83A109.06 109.06 0 0 0 73 32.62c-34.37-1.29-60.23 9.27-60.23 9.27-7.56 10.85-12 31-12 31s0 .1.07.11a.27.27 0 0 0 .26-.13 63.4 63.4 0 0 1 9.57-9.66c-.72 28 5.62 45 5.62 45h12C29.14 98.12 37.06 87 37.06 87c4.46 3.38 14.54 2.38 14.54 2.38 1.78 6.74 5.4 18.82 5.4 18.82h14.46a91.43 91.43 0 0 1 7.87-26.64S82.91 73.44 83 71c.23-4.25 4.25-5.51 6.43-5.51s12.1 5.54 19.51 5.17c12.91-.65 18-6.62 18.25-13.43.2-4.68-.9-9.23-2.87-12.04zM82.83 59.62a2.23 2.23 0 0 1-.27.54 1.48 1.48 0 0 1-.51.47 1.39 1.39 0 0 1-.73.16 2.16 2.16 0 0 1-.66-.15 6.29 6.29 0 0 1-1.88-1.32c-.27-.25-.52-.51-.76-.76l-.7-.73a4.47 4.47 0 0 0-1.48-.83c-.59-.21-1.23-.38-1.9-.54s-1.34-.33-2.07-.57a4.96 4.96 0 0 1-.58-.23l-.29-.11a2.44 2.44 0 0 1-.38-.27 2.49 2.49 0 0 1-.56-.7 3.05 3.05 0 0 1-.28-.74 4.93 4.93 0 0 1-.1-1.32 8.71 8.71 0 0 1 .13-1.16 17 17 0 0 1 .55-2.13q.33-1 .73-2c.13-.33.26-.65.41-1a10.66 10.66 0 0 1 .52-1A11.25 11.25 0 0 1 74.94 42a12.89 12.89 0 0 1 1.81-1.14 10.3 10.3 0 0 1 2-.8 18.29 18.29 0 0 0-3.08 2.71A12.3 12.3 0 0 0 73.48 46a8.65 8.65 0 0 0-.34.89l-.31 1c-.2.65-.4 1.3-.56 1.95a18 18 0 0 0-.41 1.91 7.8 7.8 0 0 0-.09.9 2.84 2.84 0 0 0 .06.75.65.65 0 0 0 .16.34l.14.08.39.16c.58.22 1.25.39 1.92.6a17.92 17.92 0 0 1 2.05.75 5.53 5.53 0 0 1 2 1.4c.25.31.43.58.64.86l.61.81c.2.26.41.51.63.74a3.66 3.66 0 0 0 .67.58.81.81 0 0 0 .61.17 1.12 1.12 0 0 0 .59-.51 4.75 4.75 0 0 0 .44-.89c.13-.32.23-.65.34-1a5.93 5.93 0 0 1-.19 2.13zm12.78-8.92a2.19 2.19 0 1 1-.88-2.52 1.92 1.92 0 0 1 .88 2.52z\"/></g></svg>"

/***/ }),

/***/ "../src/components/ceylon/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CeylonOriginal = __webpack_require__("../src/components/ceylon/original/CeylonOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CeylonOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ceylon/plain-wordmark/CeylonPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CeylonPlainWordmark = __webpack_require__("../src/components/ceylon/plain-wordmark/CeylonPlainWordmark.svg");
	
	var _CeylonPlainWordmark2 = _interopRequireDefault(_CeylonPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CeylonPlainWordmark */
	function CeylonPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CeylonPlainWordmark',
	    svg: _CeylonPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CeylonPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CeylonPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ceylon/plain-wordmark/CeylonPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Ceylon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1,.cls-2{fill:#34495e}.cls-2{opacity:.45;isolation:isolate}</style></defs><title>Artboard 15</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M18.4 71a6 6 0 0 1-1.09-.39c-.8 1.26-2.66 4.45-2.93 7.33h4.81A24.34 24.34 0 0 1 18.4 71zM34 68.43a35.87 35.87 0 0 0-2.24 6.72c-.21.93.42 1.86.3 2.78h6.05c-1.59-4.4-2-10.81-2.78-13.37-.02-.04-1.33 3.9-1.33 3.87z\"/><path class=\"cls-1\" d=\"M51.22 53.27c-1.38-2-4.52-3.6-5.25-5.83a3.3 3.3 0 0 1 .14-2.29c.33-.5-.21-.38-.21-.38-.78.3-1.12-.56-1.12-.56-.12-.3 0-1.22-.63-.72-1.21.91-.81 3.12-.59 4a9.3 9.3 0 0 0 2.31 4c.37.37 2.86 3.07 2.52 4.47a1.11 1.11 0 0 1-.84 1c-1.8.36-2.38-1.84-2.38-1.84-1.35-5.75-3.52-7.76-3.52-7.76a42.66 42.66 0 0 0-10.51.91A62.3 62.3 0 0 0 7.57 52c-3 4.24-4.69 12.12-4.69 12.12a.11.11 0 0 0 .1 0 24.8 24.8 0 0 1 3.74-3.78C6.48 71.26 9 77.93 9 77.93h4.7c.33-3.94 3.43-8.31 3.43-8.31 1.75 1.32 5.69.93 5.69.93.69 2.65 2.11 7.37 2.11 7.37h5.66a35.77 35.77 0 0 1 3.08-10.42 23.05 23.05 0 0 0 1.45-4.12 2.39 2.39 0 0 1 2.51-2.16c.85 0 4.73 2.17 7.63 2 5.05-.25 7-2.59 7.14-5.25a8.09 8.09 0 0 0-1.18-4.7zM35 58.92a.87.87 0 0 1-.11.21.58.58 0 0 1-.2.18.54.54 0 0 1-.29.06.84.84 0 0 1-.26-.06 2.46 2.46 0 0 1-.74-.52l-.3-.3-.27-.29a1.75 1.75 0 0 0-.58-.31c-.23-.08-.48-.15-.74-.21s-.52-.13-.81-.22l-.22-.09-.12-.06-.15-.1a1 1 0 0 1-.22-.28 1.19 1.19 0 0 1-.11-.29 1.93 1.93 0 0 1 0-.51 3.41 3.41 0 0 1 .05-.46 6.63 6.63 0 0 1 .22-.83q.13-.4.29-.78l.16-.39a4.17 4.17 0 0 1 .2-.39A4.4 4.4 0 0 1 31.9 52a5 5 0 0 1 .71-.45 4 4 0 0 1 .77-.31 7.16 7.16 0 0 0-1.21 1.06 4.81 4.81 0 0 0-.85 1.27 3.39 3.39 0 0 0-.13.35l-.12.38c-.08.25-.15.51-.22.76a7 7 0 0 0-.16.75 3.05 3.05 0 0 0 0 .35 1.11 1.11 0 0 0 0 .29.25.25 0 0 0 .06.13h.06l.15.06c.23.08.49.15.75.24a7 7 0 0 1 .8.29 2.16 2.16 0 0 1 .79.55c.1.12.17.23.25.34l.24.32.25.29a1.43 1.43 0 0 0 .26.23.32.32 0 0 0 .24.07.44.44 0 0 0 .23-.2 1.86 1.86 0 0 0 .17-.35c.05-.12.09-.25.13-.39a2.32 2.32 0 0 1-.07.89zm5-3.49a.86.86 0 1 1-.34-1 .75.75 0 0 1 .34 1z\"/><path class=\"cls-2\" d=\"M51.22 53.27c-1.38-2-4.52-3.6-5.25-5.83a3.3 3.3 0 0 1 .14-2.29c.33-.5-.21-.38-.21-.38-.78.3-1.12-.56-1.12-.56-.12-.3 0-1.22-.63-.72-1.21.91-.81 3.12-.59 4a9.3 9.3 0 0 0 2.31 4c.37.37 2.86 3.07 2.52 4.47a1.11 1.11 0 0 1-.84 1c-1.8.36-2.38-1.84-2.38-1.84-1.35-5.75-3.52-7.76-3.52-7.76a42.66 42.66 0 0 0-10.51.91A62.3 62.3 0 0 0 7.57 52c-3 4.24-4.69 12.12-4.69 12.12a.11.11 0 0 0 .1 0 24.8 24.8 0 0 1 3.74-3.78C6.48 71.26 9 77.93 9 77.93h4.7c.33-3.94 3.43-8.31 3.43-8.31 1.75 1.32 5.69.93 5.69.93.69 2.65 2.11 7.37 2.11 7.37h5.66a35.77 35.77 0 0 1 3.08-10.42 23.05 23.05 0 0 0 1.45-4.12 2.39 2.39 0 0 1 2.51-2.16c.85 0 4.73 2.17 7.63 2 5.05-.25 7-2.59 7.14-5.25a8.09 8.09 0 0 0-1.18-4.7zM35 58.92a.87.87 0 0 1-.11.21.58.58 0 0 1-.2.18.54.54 0 0 1-.29.06.84.84 0 0 1-.26-.06 2.46 2.46 0 0 1-.74-.52l-.3-.3-.27-.29a1.75 1.75 0 0 0-.58-.31c-.23-.08-.48-.15-.74-.21s-.52-.13-.81-.22l-.22-.09-.12-.06-.15-.1a1 1 0 0 1-.22-.28 1.19 1.19 0 0 1-.11-.29 1.93 1.93 0 0 1 0-.51 3.41 3.41 0 0 1 .05-.46 6.63 6.63 0 0 1 .22-.83q.13-.4.29-.78l.16-.39a4.17 4.17 0 0 1 .2-.39A4.4 4.4 0 0 1 31.9 52a5 5 0 0 1 .71-.45 4 4 0 0 1 .77-.31 7.16 7.16 0 0 0-1.21 1.06 4.81 4.81 0 0 0-.85 1.27 3.39 3.39 0 0 0-.13.35l-.12.38c-.08.25-.15.51-.22.76a7 7 0 0 0-.16.75 3.05 3.05 0 0 0 0 .35 1.11 1.11 0 0 0 0 .29.25.25 0 0 0 .06.13h.06l.15.06c.23.08.49.15.75.24a7 7 0 0 1 .8.29 2.16 2.16 0 0 1 .79.55c.1.12.17.23.25.34l.24.32.25.29a1.43 1.43 0 0 0 .26.23.32.32 0 0 0 .24.07.44.44 0 0 0 .23-.2 1.86 1.86 0 0 0 .17-.35c.05-.12.09-.25.13-.39a2.32 2.32 0 0 1-.07.89zm5-3.49a.86.86 0 1 1-.34-1 .75.75 0 0 1 .34 1z\"/><path class=\"cls-1\" d=\"M118.41 61.43a7.61 7.61 0 0 0-5.41 2.46l-2.46-2.12h-1.14v3.57a8.45 8.45 0 0 0-14.24 0V57l-4.28-3.71h-1.17v8.52h-3.23l-3.82 7.51-3.84-7.51H73l1.26 2.48a8.15 8.15 0 0 0-6.24-2.82c-5.29 0-8.86 3.78-8.86 8.43a8.75 8.75 0 0 0 .13 1.49 9.16 9.16 0 0 1-4.52 1.21 4.15 4.15 0 0 1-4.3-4.33 4.2 4.2 0 0 1 4.3-4.37c2.48 0 3.59 1 5 1.48V59.9a9.1 9.1 0 0 0-5.63-1.74 12.25 12.25 0 0 0-1.41.08c-.13 1.71-1.2 5.15-7.57 5.47h-.55a10 10 0 0 0-1.06 4.51c0 5.52 4.41 10.07 10.59 10.07a8.91 8.91 0 0 0 5.63-1.81v-3.35c1.25 3 4.27 5 8.61 5a9.81 9.81 0 0 0 7-2.89l-2.06-2.37a5.64 5.64 0 0 1-3.81 1.35c-3 0-4.86-1.54-4.71-3.72H76a7.72 7.72 0 0 0-.08-3.11L79.74 75l-4.92 9.69h5.63l9.26-18.17v11.31h5.45v-3.55a8.45 8.45 0 0 0 14.24 0v3.57h5.48V67.43a3.06 3.06 0 0 1 2.8-1.78c1.35 0 2 .83 2 3.35v8.83h5.48V67.49c-.04-3.14-1.95-6.06-6.75-6.06zm-53.34 5.91a3.4 3.4 0 0 1 3-2.46 2.39 2.39 0 0 1 2.61 2.46zm37.19 6.86c-1.45 0-2.68-2-2.68-4.4s1.23-4.4 2.68-4.4 2.71 2 2.71 4.4-1.23 4.4-2.71 4.4z\"/></g></svg>"

/***/ }),

/***/ "../src/components/ceylon/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CeylonPlainWordmark = __webpack_require__("../src/components/ceylon/plain-wordmark/CeylonPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CeylonPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ceylon/plain/CeylonPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CeylonPlain = __webpack_require__("../src/components/ceylon/plain/CeylonPlain.svg");
	
	var _CeylonPlain2 = _interopRequireDefault(_CeylonPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CeylonPlain */
	function CeylonPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CeylonPlain',
	    svg: _CeylonPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CeylonPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CeylonPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ceylon/plain/CeylonPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Ceylon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#34495e}</style></defs><title>Artboard 14</title><g id=\"plain\"><path class=\"cls-1\" d=\"M40.42 90.46a15.35 15.35 0 0 1-2.8-1c-2.05 3.22-6.8 11.37-7.48 18.75h12.3a62.21 62.21 0 0 1-2.02-17.75zM80.28 83.92a91.7 91.7 0 0 0-5.71 17.18c-.53 2.38 1.08 4.75.78 7.11h15.47c-4.08-11.26-5-27.64-7.11-34.19-.05-.09-3.37 9.98-3.43 9.9z\"/><path class=\"cls-1\" d=\"M124.32 45.19c-3.52-5-11.55-9.2-13.42-14.91-.48-1.46-.56-4.46.36-5.86s-.54-1-.54-1c-2 .77-2.86-1.43-2.86-1.43-.3-.77.11-3.12-1.61-1.84-3.1 2.33-2.08 8-1.5 10.28a23.76 23.76 0 0 0 5.9 10.34c1 .93 7.3 7.86 6.44 11.41a2.85 2.85 0 0 1-2.15 2.62c-4.59.92-6.08-4.71-6.08-4.71-3.44-14.69-9-19.83-9-19.83A109.06 109.06 0 0 0 73 32.62c-34.37-1.29-60.23 9.27-60.23 9.27-7.56 10.85-12 31-12 31s0 .1.07.11a.27.27 0 0 0 .26-.13 63.4 63.4 0 0 1 9.57-9.66c-.72 28 5.62 45 5.62 45h12C29.14 98.12 37.06 87 37.06 87c4.46 3.38 14.54 2.38 14.54 2.38 1.78 6.74 5.4 18.82 5.4 18.82h14.46a91.43 91.43 0 0 1 7.87-26.64S82.91 73.44 83 71c.23-4.25 4.25-5.51 6.43-5.51s12.1 5.54 19.51 5.17c12.91-.65 18-6.62 18.25-13.43.2-4.68-.9-9.23-2.87-12.04zM82.83 59.62a2.23 2.23 0 0 1-.27.54 1.48 1.48 0 0 1-.51.47 1.39 1.39 0 0 1-.73.16 2.16 2.16 0 0 1-.66-.15 6.29 6.29 0 0 1-1.88-1.32c-.27-.25-.52-.51-.76-.76l-.7-.73a4.47 4.47 0 0 0-1.48-.83c-.59-.21-1.23-.38-1.9-.54s-1.34-.33-2.07-.57a4.96 4.96 0 0 1-.58-.23l-.29-.11a2.44 2.44 0 0 1-.38-.27 2.49 2.49 0 0 1-.56-.7 3.05 3.05 0 0 1-.28-.74 4.93 4.93 0 0 1-.1-1.32 8.71 8.71 0 0 1 .13-1.16 17 17 0 0 1 .55-2.13q.33-1 .73-2c.13-.33.26-.65.41-1a10.66 10.66 0 0 1 .52-1A11.25 11.25 0 0 1 74.94 42a12.89 12.89 0 0 1 1.81-1.14 10.3 10.3 0 0 1 2-.8 18.29 18.29 0 0 0-3.08 2.71A12.3 12.3 0 0 0 73.48 46a8.65 8.65 0 0 0-.34.89l-.31 1c-.2.65-.4 1.3-.56 1.95a18 18 0 0 0-.41 1.91 7.8 7.8 0 0 0-.09.9 2.84 2.84 0 0 0 .06.75.65.65 0 0 0 .16.34l.14.08.39.16c.58.22 1.25.39 1.92.6a17.92 17.92 0 0 1 2.05.75 5.53 5.53 0 0 1 2 1.4c.25.31.43.58.64.86l.61.81c.2.26.41.51.63.74a3.66 3.66 0 0 0 .67.58.81.81 0 0 0 .61.17 1.12 1.12 0 0 0 .59-.51 4.75 4.75 0 0 0 .44-.89c.13-.32.23-.65.34-1a5.93 5.93 0 0 1-.19 2.13zm12.78-8.92a2.19 2.19 0 1 1-.88-2.52 1.92 1.92 0 0 1 .88 2.52z\"/></g></svg>"

/***/ }),

/***/ "../src/components/ceylon/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CeylonPlain = __webpack_require__("../src/components/ceylon/plain/CeylonPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CeylonPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/chrome/original-wordmark/ChromeOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ChromeOriginalWordmark = __webpack_require__("../src/components/chrome/original-wordmark/ChromeOriginalWordmark.svg");
	
	var _ChromeOriginalWordmark2 = _interopRequireDefault(_ChromeOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ChromeOriginalWordmark */
	function ChromeOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ChromeOriginalWordmark',
	    svg: _ChromeOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ChromeOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ChromeOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/chrome/original-wordmark/ChromeOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#77787A\" d=\"M23.649 125.01c-.782.374-2.52.953-4.732.953-4.972 0-8.206-3.371-8.206-8.41 0-5.074 3.473-8.786 8.853-8.786 1.771 0 3.337.443 4.154.886l-.681 2.281c-.715-.374-1.839-.784-3.474-.784-3.78 0-5.823 2.828-5.823 6.232 0 3.813 2.452 6.162 5.721 6.162a8.58 8.58 0 0 0 3.678-.783l.51 2.249zm3.508-23.597h2.996v10.317h.068a5.647 5.647 0 0 1 2.146-2.146 6.137 6.137 0 0 1 3.064-.817c2.213 0 5.754 1.362 5.754 7.015v9.806h-2.996v-9.466c0-2.655-.987-4.868-3.814-4.868-1.94 0-3.438 1.361-4.018 2.961-.17.443-.204.886-.204 1.431v9.942h-2.996v-24.175zm18.898 12.836c0-1.941-.034-3.61-.136-5.142h2.622l.136 3.269h.102c.75-2.212 2.589-3.61 4.598-3.61.307 0 .544.035.816.069v2.827c-.307-.068-.612-.068-1.021-.068-2.111 0-3.609 1.566-4.019 3.813-.067.41-.102.919-.102 1.396v8.784h-2.997v-11.338zm25.709 2.963c0 6.094-4.257 8.751-8.207 8.751-4.426 0-7.899-3.269-7.899-8.479 0-5.482 3.644-8.717 8.173-8.717 4.732 0 7.933 3.439 7.933 8.445zm-13.041.171c0 3.608 2.043 6.332 4.971 6.332 2.86 0 5.005-2.689 5.005-6.401 0-2.792-1.396-6.3-4.937-6.3-3.508.001-5.039 3.269-5.039 6.369zm16.82-3.815a82.28 82.28 0 0 0-.136-4.461h2.621l.137 2.69h.103c.92-1.566 2.452-3.031 5.21-3.031 2.212 0 3.915 1.362 4.63 3.303h.068a6.492 6.492 0 0 1 1.873-2.145c.987-.75 2.043-1.159 3.609-1.159 2.213 0 5.447 1.431 5.447 7.151v9.67h-2.927v-9.296c0-3.2-1.193-5.073-3.576-5.073-1.736 0-3.03 1.26-3.575 2.689a5.096 5.096 0 0 0-.238 1.499v10.181H85.86v-9.875c0-2.622-1.158-4.495-3.438-4.495-1.839 0-3.235 1.498-3.712 2.996-.17.409-.238.954-.238 1.465v9.908h-2.929v-12.017zm30.066 4.324c.068 4.052 2.622 5.721 5.652 5.721 2.146 0 3.473-.375 4.563-.851l.545 2.146c-1.055.476-2.894 1.055-5.516 1.055-5.073 0-8.104-3.371-8.104-8.342 0-4.972 2.928-8.853 7.729-8.853 5.415 0 6.811 4.699 6.811 7.729 0 .614-.034 1.056-.103 1.396h-11.577v-.001zm8.786-2.144c.034-1.872-.783-4.836-4.154-4.836-3.064 0-4.358 2.759-4.597 4.836h8.751z\"/><circle fill=\"#fff\" cx=\"64.114\" cy=\"49.495\" r=\"46.537\"/><path fill-opacity=\".1\" d=\"M93.729 57.956c0-16.356-13.26-29.615-29.614-29.615C47.759 28.341 34.5 41.6 34.5 57.956h8.461c0-11.683 9.471-21.153 21.152-21.153 11.683 0 21.153 9.47 21.153 21.153\"/><circle fill-opacity=\".1\" cx=\"66.229\" cy=\"55.417\" r=\"16.077\"/><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"395.19\" y1=\"337.859\" x2=\"395.19\" y2=\"338.282\" gradientTransform=\"matrix(82 0 0 82 -32341.5 -27672.313)\"><stop offset=\"0\" stop-color=\"#81B4E0\"/><stop offset=\"1\" stop-color=\"#0C5A94\"/></linearGradient><circle fill=\"url(#a)\" cx=\"64.114\" cy=\"49.494\" r=\"17.346\"/><linearGradient id=\"b\" gradientUnits=\"userSpaceOnUse\" x1=\"-609.405\" y1=\"-597.665\" x2=\"-609.405\" y2=\"-559.165\" gradientTransform=\"translate(675 599.775)\"><stop offset=\"0\" stop-color=\"#F06B59\"/><stop offset=\"1\" stop-color=\"#DF2227\"/></linearGradient><path fill=\"url(#b)\" d=\"M106.421 28.341C94.773 4.908 66.334-4.648 42.9 6.999a47.373 47.373 0 0 0-18.131 15.843l19.038 33c-3.507-11.144 2.686-23.021 13.83-26.527a21.146 21.146 0 0 1 6.053-.973\"/><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"-646.731\" y1=\"-516.6\" x2=\"-627.271\" y2=\"-548.753\" gradientTransform=\"translate(675 599.775)\"><stop offset=\"0\" stop-color=\"#388B41\"/><stop offset=\"1\" stop-color=\"#4CB749\"/></linearGradient><path fill=\"url(#c)\" d=\"M24.77 22.841c-14.572 21.737-8.764 51.171 12.974 65.743a47.397 47.397 0 0 0 22.563 7.871L80.19 62.61c-7.435 9.012-20.767 10.29-29.778 2.854a21.14 21.14 0 0 1-6.604-9.623\"/><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"-581.539\" y1=\"-513.181\" x2=\"-602.269\" y2=\"-563.102\" gradientTransform=\"translate(675 599.775)\"><stop offset=\"0\" stop-color=\"#E4B022\"/><stop offset=\".3\" stop-color=\"#FCD209\"/></linearGradient><path fill=\"url(#d)\" d=\"M60.307 96.455c26.094 1.973 48.847-17.582 50.819-43.676a47.378 47.378 0 0 0-4.706-24.438H63.69c11.683.054 21.11 9.567 21.056 21.251A21.146 21.146 0 0 1 80.19 62.61\"/><linearGradient id=\"e\" gradientUnits=\"userSpaceOnUse\" x1=\"-640.289\" y1=\"-545.204\" x2=\"-640.289\" y2=\"-579.049\" gradientTransform=\"translate(675 599.775)\"><stop offset=\"0\" stop-opacity=\".15\"/><stop offset=\".3\" stop-opacity=\".06\"/><stop offset=\"1\" stop-opacity=\".03\"/></linearGradient><path fill=\"url(#e)\" d=\"M24.77 22.841l19.038 33a21.153 21.153 0 0 1 .845-14.385L25.615 21.572\"/><linearGradient id=\"f\" gradientUnits=\"userSpaceOnUse\" x1=\"-593.573\" y1=\"-534.274\" x2=\"-616.841\" y2=\"-510.583\" gradientTransform=\"translate(675 599.775)\"><stop offset=\"0\" stop-opacity=\".15\"/><stop offset=\".3\" stop-opacity=\".06\"/><stop offset=\"1\" stop-opacity=\".03\"/></linearGradient><path fill=\"url(#f)\" d=\"M60.307 96.455L80.19 62.61a21.161 21.161 0 0 1-12.269 7.192L59.46 96.455\"/><linearGradient id=\"g\" gradientUnits=\"userSpaceOnUse\" x1=\"-593.91\" y1=\"-527.459\" x2=\"-590.526\" y2=\"-560.879\" gradientTransform=\"translate(675 599.775)\"><stop offset=\"0\" stop-opacity=\".15\"/><stop offset=\".3\" stop-opacity=\".06\"/><stop offset=\"1\" stop-opacity=\".03\"/></linearGradient><path fill=\"url(#g)\" d=\"M106.421 28.341H63.69a21.153 21.153 0 0 1 16.5 8.038l27.076-6.769\"/></svg>"

/***/ }),

/***/ "../src/components/chrome/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ChromeOriginalWordmark = __webpack_require__("../src/components/chrome/original-wordmark/ChromeOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ChromeOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/chrome/original/ChromeOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ChromeOriginal = __webpack_require__("../src/components/chrome/original/ChromeOriginal.svg");
	
	var _ChromeOriginal2 = _interopRequireDefault(_ChromeOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ChromeOriginal */
	function ChromeOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ChromeOriginal',
	    svg: _ChromeOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ChromeOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ChromeOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/chrome/original/ChromeOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><circle fill=\"#fff\" cx=\"64.149\" cy=\"64.236\" r=\"60.999\"/><path fill-opacity=\".1\" d=\"M102.966 75.327c0-21.439-17.379-38.819-38.817-38.819s-38.818 17.38-38.818 38.819h11.09c0-15.314 12.415-27.727 27.727-27.727 15.313 0 27.727 12.413 27.727 27.727\"/><circle fill-opacity=\".1\" cx=\"66.922\" cy=\"71.999\" r=\"21.072\"/><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"395.191\" y1=\"484.168\" x2=\"395.191\" y2=\"484.723\" gradientTransform=\"matrix(82 0 0 82 -32341.5 -39660.313)\"><stop offset=\"0\" stop-color=\"#81B4E0\"/><stop offset=\"1\" stop-color=\"#0C5A94\"/></linearGradient><circle fill=\"url(#a)\" cx=\"64.149\" cy=\"64.235\" r=\"22.736\"/><linearGradient id=\"b\" gradientUnits=\"userSpaceOnUse\" x1=\"-608.91\" y1=\"-597.648\" x2=\"-608.91\" y2=\"-547.185\" gradientTransform=\"translate(675 599.775)\"><stop offset=\"0\" stop-color=\"#F06B59\"/><stop offset=\"1\" stop-color=\"#DF2227\"/></linearGradient><path fill=\"url(#b)\" d=\"M119.602 36.508C104.336 5.792 67.06-6.732 36.343 8.534A62.105 62.105 0 0 0 12.578 29.3l24.955 43.253c-4.597-14.606 3.521-30.174 18.127-34.77a27.676 27.676 0 0 1 7.935-1.274\"/><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"-657.835\" y1=\"-491.393\" x2=\"-632.327\" y2=\"-533.537\" gradientTransform=\"translate(675 599.775)\"><stop offset=\"0\" stop-color=\"#388B41\"/><stop offset=\"1\" stop-color=\"#4CB749\"/></linearGradient><path fill=\"url(#c)\" d=\"M12.578 29.3c-19.1 28.492-11.486 67.071 17.005 86.171a62.133 62.133 0 0 0 29.575 10.319l26.063-44.363c-9.745 11.811-27.22 13.486-39.032 3.74a27.717 27.717 0 0 1-8.657-12.613\"/><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"-572.385\" y1=\"-486.91\" x2=\"-599.557\" y2=\"-552.345\" gradientTransform=\"translate(675 599.775)\"><stop offset=\"0\" stop-color=\"#E4B022\"/><stop offset=\".3\" stop-color=\"#FCD209\"/></linearGradient><path fill=\"url(#d)\" d=\"M59.158 125.791c34.204 2.585 64.027-23.047 66.613-57.25a62.097 62.097 0 0 0-6.17-32.031H63.595c15.312.07 27.67 12.541 27.598 27.854a27.725 27.725 0 0 1-5.972 17.064\"/><linearGradient id=\"e\" gradientUnits=\"userSpaceOnUse\" x1=\"-649.391\" y1=\"-528.885\" x2=\"-649.391\" y2=\"-573.247\" gradientTransform=\"translate(675 599.775)\"><stop offset=\"0\" stop-opacity=\".15\"/><stop offset=\".3\" stop-opacity=\".06\"/><stop offset=\"1\" stop-opacity=\".03\"/></linearGradient><path fill=\"url(#e)\" d=\"M12.578 29.3l24.955 43.253a27.725 27.725 0 0 1 1.107-18.854L13.686 27.636\"/><linearGradient id=\"f\" gradientUnits=\"userSpaceOnUse\" x1=\"-588.158\" y1=\"-514.559\" x2=\"-618.657\" y2=\"-483.505\" gradientTransform=\"translate(675 599.775)\"><stop offset=\"0\" stop-opacity=\".15\"/><stop offset=\".3\" stop-opacity=\".06\"/><stop offset=\"1\" stop-opacity=\".03\"/></linearGradient><path fill=\"url(#f)\" d=\"M59.158 125.791l26.063-44.363a27.731 27.731 0 0 1-16.082 9.426l-11.091 34.937\"/><linearGradient id=\"g\" gradientUnits=\"userSpaceOnUse\" x1=\"-588.6\" y1=\"-505.621\" x2=\"-584.163\" y2=\"-549.431\" gradientTransform=\"translate(675 599.775)\"><stop offset=\"0\" stop-opacity=\".15\"/><stop offset=\".3\" stop-opacity=\".06\"/><stop offset=\"1\" stop-opacity=\".03\"/></linearGradient><path fill=\"url(#g)\" d=\"M119.602 36.508H63.595a27.727 27.727 0 0 1 21.626 10.537l35.491-8.873\"/></svg>"

/***/ }),

/***/ "../src/components/chrome/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ChromeOriginal = __webpack_require__("../src/components/chrome/original/ChromeOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ChromeOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/chrome/plain-wordmark/ChromePlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ChromePlainWordmark = __webpack_require__("../src/components/chrome/plain-wordmark/ChromePlainWordmark.svg");
	
	var _ChromePlainWordmark2 = _interopRequireDefault(_ChromePlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ChromePlainWordmark */
	function ChromePlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ChromePlainWordmark',
	    svg: _ChromePlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ChromePlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ChromePlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/chrome/plain-wordmark/ChromePlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><circle fill=\"#CE4E4E\" cx=\"64.499\" cy=\"51.614\" r=\"18.557\"/><path fill=\"#CE4E4E\" d=\"M64 30h45.23C101.077 13 84.111 1.972 64.499 1.972c-15.876 0-30.021 7.292-39.158 18.848l16.913 29.444C43.102 38.865 52 30 64 30zm-6.688 70.987l17.212-29.66a22.008 22.008 0 0 1-10.025 2.398c-9.569 0-17.718-6.078-20.796-14.584l-20.648-35.31a49.658 49.658 0 0 0-8.446 27.782c-.001 25.114 18.555 45.889 42.703 49.374zM110.821 33H76.527c6.069 4 10.083 10.809 10.083 18.584 0 3.824-.971 7.435-2.679 10.574l.012.016-22.755 39.214c1.094.071 2.197.114 3.311.114 27.554 0 49.891-22.364 49.891-49.918 0-6.559-1.267-11.584-3.569-18.584zm-87.172 91.822c-.782.374-2.52.953-4.732.953-4.972 0-8.206-3.371-8.206-8.41 0-5.074 3.473-8.786 8.853-8.786 1.771 0 3.337.443 4.154.886l-.681 2.281c-.715-.374-1.839-.784-3.474-.784-3.78 0-5.823 2.828-5.823 6.232 0 3.813 2.452 6.162 5.721 6.162a8.58 8.58 0 0 0 3.678-.783l.51 2.249zm3.508-23.597h2.996v10.317h.068a5.647 5.647 0 0 1 2.146-2.146 6.137 6.137 0 0 1 3.064-.817c2.213 0 5.754 1.362 5.754 7.015v9.806h-2.996v-9.466c0-2.655-.987-4.868-3.814-4.868-1.94 0-3.438 1.361-4.018 2.961-.17.443-.204.886-.204 1.431v9.942h-2.996v-24.175zm18.898 12.837c0-1.941-.034-3.61-.136-5.142h2.622l.136 3.269h.102c.75-2.212 2.589-3.61 4.598-3.61.307 0 .544.035.816.069v2.827c-.307-.068-.612-.068-1.021-.068-2.111 0-3.609 1.566-4.019 3.813-.067.41-.102.919-.102 1.396v8.784h-2.997v-11.338zm25.709 2.962c0 6.094-4.257 8.751-8.207 8.751-4.426 0-7.899-3.269-7.899-8.479 0-5.482 3.644-8.717 8.173-8.717 4.732.001 7.933 3.44 7.933 8.445zm-13.041.171c0 3.608 2.043 6.332 4.971 6.332 2.86 0 5.005-2.689 5.005-6.401 0-2.792-1.396-6.3-4.937-6.3-3.508.002-5.039 3.269-5.039 6.369zm16.82-3.814a82.28 82.28 0 0 0-.136-4.461h2.621l.137 2.69h.103c.92-1.566 2.452-3.031 5.21-3.031 2.212 0 3.915 1.362 4.63 3.303h.068a6.492 6.492 0 0 1 1.873-2.145c.987-.75 2.043-1.159 3.609-1.159 2.213 0 5.447 1.431 5.447 7.151v9.67h-2.927v-9.296c0-3.2-1.193-5.073-3.576-5.073-1.736 0-3.03 1.26-3.575 2.689a5.096 5.096 0 0 0-.238 1.499V125.4H85.86v-9.875c0-2.622-1.158-4.495-3.438-4.495-1.839 0-3.235 1.498-3.712 2.996-.17.409-.238.954-.238 1.465v9.908h-2.929v-12.018zm30.066 4.324c.068 4.052 2.622 5.721 5.652 5.721 2.146 0 3.473-.375 4.563-.851l.545 2.146c-1.055.476-2.894 1.055-5.516 1.055-5.073 0-8.104-3.371-8.104-8.342 0-4.972 2.928-8.853 7.729-8.853 5.415 0 6.811 4.699 6.811 7.729 0 .614-.034 1.056-.103 1.396h-11.577v-.001zm8.786-2.145c.034-1.872-.783-4.836-4.154-4.836-3.064 0-4.358 2.759-4.597 4.836h8.751z\"/></svg>"

/***/ }),

/***/ "../src/components/chrome/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ChromePlainWordmark = __webpack_require__("../src/components/chrome/plain-wordmark/ChromePlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ChromePlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/chrome/plain/ChromePlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ChromePlain = __webpack_require__("../src/components/chrome/plain/ChromePlain.svg");
	
	var _ChromePlain2 = _interopRequireDefault(_ChromePlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ChromePlain */
	function ChromePlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ChromePlain',
	    svg: _ChromePlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ChromePlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ChromePlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/chrome/plain/ChromePlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><circle fill=\"#CE4E4E\" cx=\"63.624\" cy=\"64.474\" r=\"22.634\"/><path fill=\"#CE4E4E\" d=\"M64 37h54.186c-9.944-20-30.64-33.633-54.562-33.633-19.367 0-36.619 9.173-47.764 23.271l21.123 35.748C38.015 48.48 48 37.07 64 37zm56.126 4H78.294c7.403 6 12.299 13.884 12.299 23.369 0 4.663-1.183 8.631-3.268 13.631h.015l-27.757 47.511c1.335.087 2.682-.022 4.04-.022 33.609 0 60.855-27.746 60.855-61.355.001-8-1.546-15.134-4.352-23.134zM63.624 91.445c-11.672 0-21.611-7.414-25.368-17.789L13.07 30.585C6.565 40.271 2.767 51.93 2.767 64.474c0 30.632 22.634 55.972 52.089 60.224l20.996-36.179a26.853 26.853 0 0 1-12.228 2.926z\"/></svg>"

/***/ }),

/***/ "../src/components/chrome/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ChromePlain = __webpack_require__("../src/components/chrome/plain/ChromePlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ChromePlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/codeigniter/plain-wordmark/CodeigniterPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CodeigniterPlainWordmark = __webpack_require__("../src/components/codeigniter/plain-wordmark/CodeigniterPlainWordmark.svg");
	
	var _CodeigniterPlainWordmark2 = _interopRequireDefault(_CodeigniterPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CodeigniterPlainWordmark */
	function CodeigniterPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CodeigniterPlainWordmark',
	    svg: _CodeigniterPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CodeigniterPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CodeigniterPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/codeigniter/plain-wordmark/CodeigniterPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#EE4323\" d=\"M16.399 120.213c-2.156 0-2.783-1.255-2.783-3.136 0-.627.079-1.334.176-2.079.472-3.253 1.625-5.114 4.408-5.114 1.882 0 2.8.842 2.8 2.371V113h1.867c.021 0 .021-.686.021-.842 0-2.234-1.353-4.353-4.685-4.353-4.528 0-6.39 2.46-7.076 7.282a12.392 12.392 0 0 0-.157 1.896c0 2.842 1.118 5.427 5.116 5.427 3.038 0 4.842-1.481 5.9-3.304l-1.784-1.201c-1.156 1.823-2.411 2.308-3.803 2.308zm12.251-8.977c-3.627 0-5.194 1.861-5.723 5.565-.06.433-.099.883-.099 1.294 0 2.391 1.117 4.293 4.213 4.293 3.627 0 5.215-1.941 5.744-5.587.059-.47.098-.901.098-1.332.001-2.43-1.155-4.233-4.233-4.233zm1.509 5.566c-.392 2.686-1.234 3.509-2.823 3.509-1.273 0-1.9-.529-1.9-2.117 0-.392.04-.862.118-1.392.392-2.665 1.176-3.488 2.783-3.488 1.294 0 1.94.529 1.94 2.136 0 .392-.04.843-.118 1.352zM42 108l-.607 3.598c-.039.313-.019.209.099.503-.568-.431-1.588-.716-2.274-.716-3.254 0-5.076 1.473-5.664 5.589-.078.49-.098.903-.098 1.314 0 3 1.764 4.118 4.135 4.118 1.001 0 1.98.021 2.744-.625L40.53 123h1.882l2.195-15H42zm-1.862 11.742a4.496 4.496 0 0 1-2.272.647c-1.431 0-1.823-.745-1.823-1.94 0-.451.059-.979.138-1.549.45-3.116 1.45-3.666 2.744-3.666.842 0 1.488.138 2.097.472l-.884 6.036zm10.193-8.506c-3.588 0-5.272 1.704-5.841 5.565-.06.471-.099.922-.099 1.353 0 2.646 1.353 4.234 4.331 4.234 2.313 0 4.039-.961 4.96-2.725l-1.98-.804c-.568.862-1.332 1.45-2.685 1.45-1.45 0-2.038-.39-2.038-1.684 0-.255.02-.626.059-.626h7.075c.099-1 .215-1.707.215-2.293 0-1.959-.744-4.47-3.997-4.47zM51.683 116h-4.312c.432-1 1.156-2.548 2.646-2.548 1.156 0 1.725.676 1.725 1.832-.001.196-.019.716-.059.716zm10.188-5l.235-2h-5.528l-.234 2h1.45l-1.567 10h-1.452l-.234 2h5.527l.236-2h-1.451l1.567-10zm11.232 3l.706-2h-1.901l-1.371.283c-.765-.489-1.804-.856-2.783-.856-2.804 0-5.194 1.354-5.194 4.432 0 .863.313 1.56.685 2.031-.587.313-1.097.837-1.097 1.544 0 .313.117.634.353.927-1.177.707-1.9 1.878-1.9 3.249 0 2.647 2.763 3.212 4.88 3.212 2.665 0 5.841-.609 5.841-4 0-1.156-.725-2.059-2.822-2.451l-3.783-.707c-.431-.079-.529-.216-.529-.412 0-.294.178-.45.471-.45l.255.039c.51.117 1.098.177 1.705.177 2.725 0 5.155-1.177 5.155-4.234 0-.432-.078-.724-.274-1.195.333.157.765.412.94.412h.663zm-5.389 8.113c.744.138.998.412.998.902 0 1.588-1.705 1.784-2.939 1.784-1.882 0-2.587-.45-2.587-1.451 0-.882.254-1.293.843-1.921l3.685.686zm-.805-5.134c-1.137 0-1.764-.411-1.764-1.392 0-1.45.843-2.293 2.313-2.293 1.176 0 1.745.49 1.745 1.449 0 1.451-.824 2.236-2.294 2.236zm13.157-5.743c-1.098 0-2.077.539-3.293 1.498l-.176-.734H74.44l-1.509 11h2.607l1.137-8.342c.765-.47 1.705-1.153 2.509-1.153.979 0 1.333.473 1.333 1.374 0 .216-.021.855-.06 1.09L79.498 123h2.607l.959-7.088c.04-.332.079-.878.079-1.191.001-1.864-.882-3.485-3.077-3.485zm8.029 9.008l.02-.269L89.251 112h-4.332l-.273 2h1.9c-.157 0-.255.175-.274.333l-.784 5.311a9.195 9.195 0 0 0-.058 1.002c0 1.372.744 2.354 2.272 2.354h1.333l.294-2h-.842c-.295 0-.392-.521-.392-.756zM89.78 108h-2.548c-.157 0-.157-.577-.176-.381l-.354 2.818c-.02.177-.02.563.137.563h2.549c.157 0 .157-.685.176-.863l.354-2.175c.02-.196.02.038-.138.038zm5.316 12.311c-.646 0-.96-.275-.96-.862l.02-.04.823-5.409h2.979l.901-2h-3.606l.607-4.401-2.743.877-.491 3.524h-1.587l-.274 2h1.842c-.176 1-.353.351-.372.548l-.706 4.743c-.039.216-.039.373-.039.568 0 1.862 1.372 2.559 3.02 2.559 1.528 0 2.763-.446 3.724-1.251l-1.216-1.496c-.609.372-1.02.64-1.922.64zm9.565-9.075c-3.587 0-5.272 1.704-5.841 5.565-.059.471-.098.922-.098 1.353 0 2.646 1.352 4.234 4.331 4.234 2.313 0 4.039-.961 4.959-2.725l-1.979-.804c-.568.862-1.333 1.45-2.686 1.45-1.449 0-2.038-.39-2.038-1.684 0-.255.021-.626.06-.626h7.075c.098-1 .216-1.707.216-2.293 0-1.959-.745-4.47-3.999-4.47zm1.353 4.764h-4.312c.431-1 1.155-2.548 2.646-2.548 1.156 0 1.725.676 1.725 1.832-.001.196-.02.716-.059.716zm9.859-4.764c-.941 0-1.823.539-2.705 1.38l-.157-.616h-2.155l-1.51 11h2.627l1.156-8.518c.686-.411 1.47-.762 2.215-.762.471 0 .921-.075 1.352-.016l.335-2.273c-.394-.078-.786-.195-1.158-.195zM49.31 100.121c-5.933-2.564-11.485-9.082-11.498-15.751-.016-7.271 4.592-13.444 10.323-17.501-.689 2.603-1.065 4.984.642 7.312a6.913 6.913 0 0 0 6.99 2.646c6.132-1.342 6.413-8.083 2.778-12.01-3.594-3.889-7.071-8.282-5.703-13.922.685-2.827 2.421-5.475 4.62-7.368-1.69 4.442 3.113 8.823 6.278 11.005 5.49 3.786 11.513 6.647 16.561 11.085 5.31 4.664 9.231 10.971 8.439 18.285-.858 7.928-7.158 13.442-14.224 16.226 14.932-3.296 30.361-14.885 30.677-31.446.262-13.624-9.084-24.109-20.662-30.112l-.605-.33c.318.771.422 1.427.41 2.014a7.02 7.02 0 0 0 .194-1.337 6.516 6.516 0 0 1-.212 1.616l.018-.279a6.788 6.788 0 0 1-.857 2.043l.17-.183c-2.31 3.831-8.563 4.663-11.652.696-4.966-6.381.104-13.261.813-20.018.888-8.469-4.423-16.69-11.008-21.61 3.627 5.867-1.151 13.629-4.974 17.968-3.707 4.207-8.215 7.719-12.307 11.541-4.396 4.105-8.622 8.429-12.235 13.247-7.226 9.643-11.65 21.771-8.399 33.802 3.249 12.022 13.663 19.675 25.423 22.381z\"/></svg>"

/***/ }),

/***/ "../src/components/codeigniter/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CodeigniterPlainWordmark = __webpack_require__("../src/components/codeigniter/plain-wordmark/CodeigniterPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CodeigniterPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/codeigniter/plain/CodeigniterPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CodeigniterPlain = __webpack_require__("../src/components/codeigniter/plain/CodeigniterPlain.svg");
	
	var _CodeigniterPlain2 = _interopRequireDefault(_CodeigniterPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CodeigniterPlain */
	function CodeigniterPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CodeigniterPlain',
	    svg: _CodeigniterPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CodeigniterPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CodeigniterPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/codeigniter/plain/CodeigniterPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#EE4323\" d=\"M89.708 48.868l-.758-.414c.399.964.529 1.786.515 2.521a8.627 8.627 0 0 0 .248-1.847 8.22 8.22 0 0 1-.273 2.231l.025-.385a8.52 8.52 0 0 1-1.074 2.558l.235-.25c-2.88 4.819-10.737 5.872-14.612.895-6.22-7.99.128-16.604 1.017-25.065 1.111-10.604-5.538-20.899-13.783-27.06 4.541 7.346-1.442 17.066-6.229 22.498-4.642 5.269-10.286 9.667-15.41 14.451-5.503 5.143-10.797 10.555-15.319 16.588-9.049 12.074-14.59 27.26-10.518 42.325 4.068 15.056 17.108 24.639 31.834 28.027-7.429-3.212-14.381-11.373-14.397-19.723-.019-9.106 5.75-16.835 12.927-21.914-.863 3.259-1.334 6.24.803 9.155 1.988 2.711 5.468 4.027 8.753 3.312 7.679-1.679 8.03-10.12 3.479-15.038-4.501-4.868-8.855-10.371-7.143-17.433.858-3.54 3.032-6.854 5.787-9.226-2.118 5.563 3.897 11.049 7.859 13.779 6.876 4.741 14.416 8.325 20.738 13.881 6.648 5.84 11.559 13.736 10.567 22.896-1.076 9.927-8.964 16.832-17.811 20.317 18.696-4.128 38.018-18.639 38.411-39.376.329-17.058-11.373-30.187-25.871-37.703z\"/></svg>"

/***/ }),

/***/ "../src/components/codeigniter/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CodeigniterPlain = __webpack_require__("../src/components/codeigniter/plain/CodeigniterPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CodeigniterPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/coffeescript/original-wordmark/CoffeescriptOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CoffeescriptOriginalWordmark = __webpack_require__("../src/components/coffeescript/original-wordmark/CoffeescriptOriginalWordmark.svg");
	
	var _CoffeescriptOriginalWordmark2 = _interopRequireDefault(_CoffeescriptOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CoffeescriptOriginalWordmark */
	function CoffeescriptOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CoffeescriptOriginalWordmark',
	    svg: _CoffeescriptOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CoffeescriptOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CoffeescriptOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/coffeescript/original-wordmark/CoffeescriptOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M113.7 105.8c-1.4 0-2.4.5-3.2 1.2l.4-2.1-3.8.2-2.1 9.8c-.4 1-1.4 2.2-2.4 2.2-.7 0-1.1-.3-1.1-1.1 0-.2 0-.6.1-.9l2-9.2h-4l-1.8 8.7c-.1.7-.2 1.2-.2 1.8 0 2.3 1.3 3.2 2.9 3.2 1 0 2.6-.3 4-2l-1.8 8.6 4.1-1 1.4-6.6c.3.5 1 1 2.3 1 5.2 0 6.6-5.9 6.6-9.6-.1-3.1-1.5-4.2-3.4-4.2zm-4.2 11.5c-.6 0-.9-.3-1-.6l1.6-7.6c.5-.8 1.3-1.3 1.9-1.3.5 0 1.3.1 1.3 2.2 0 2.6-.9 7.3-3.8 7.3zm14-11.3c.5-3 .9-4.3.9-4.3l-4 .6-.8 3.7h-.9l-.2 1h.9l-1.7 8.1c-.1.5-.2 1-.2 1.4 0 1.8.8 3.1 2.7 3.1.9 0 2.1-.3 2.9-2.7-.2.1-.5.1-.7.1-.7 0-.9-.4-.9-1l.1-.9 1.7-8.2h1.6l.2-1h-1.6zm-23.3-3.7c0 1.2.9 2.1 2.1 2.1 1.2 0 2.1-.9 2.1-2.1s-1-2.1-2.1-2.1-2.1.9-2.1 2.1zm-38.4 6c0-1.3-.6-2.6-3-2.6-5.4 0-7.2 6.2-7.3 9.4-1.2 1.3-2.5 2.3-4.4 2.3-1.3 0-1.9-.4-1.9-2.3 0-.3 0-.7.1-1.1 3.2-.2 6.2-2.6 6.2-5.7 0-1.3-.6-2.6-3-2.6-5.6 0-7.3 6.5-7.3 9.6 0 3.1 1.7 4.3 4.2 4.3 2.8 0 4.7-1.5 6.2-3.3.4 2.3 1.9 3.3 4.1 3.3 2.2 0 4.1-.9 4.7-4-.9.7-2.2 1.4-3.2 1.4-.9 0-1.7-.6-1.7-2.3 0-.2 0-.5.1-.8 3.2-.1 6.2-2.4 6.2-5.6zm-2.8-1.1c.5 0 .7.4.7 1.1 0 2.3-1.8 4.4-4 4.5.6-2.6 2-5.6 3.3-5.6zm-10.4 0c.5 0 .7.4.7 1.1 0 2.3-1.8 4.3-3.9 4.5.5-2.8 1.9-5.6 3.2-5.6zm24.4-2.6c.4.4.7.6 1.3.6 1.3 0 2.2-1.2 2.2-2.8 0-3-3.1-3.2-4.4-3.2-3.5 0-6.3 2-6.3 4.9 0 4 5.5 5.6 5.5 10.3 0 2.3-1.3 3.6-3.2 3.6-1.7 0-2.6-1.3-2.6-2.6 0-1.8 1.7-2.5 3.2-2.5-.1-1.4-1.5-1.8-2.4-1.8-1.9 0-4 1.5-4 4.4 0 3.3 2.7 4.7 5.8 4.7 4 0 7.6-2.2 7.6-6.8 0-5.8-6.1-6.4-6.1-10.4 0-1.6 1-2.4 2.5-2.4s2 .9 2 1.8c.2.8-.3 1.7-1.1 2.2zM42.8 106H40l.5-2.3c.4-1.8 1.3-2.1 1.8-2.1s1 .2 1 .8c0 .2 0 .6-.1.6h1.3c.1 0 .1-.5.1-1 0-1.8-1.6-2.9-3.2-2.9-1.2 0-2.6.4-3.7 1.7-.5-1-1.7-1.7-2.9-1.7-1.8 0-4.1.8-4.9 4.6l-1.2 5.7c-.8.3-1.5.5-2.2.5-.1 0-.2 0-.3-.1 0-2.8-1.1-4.3-3.5-4.4-5.5 0-7.3 6.2-7.4 9.4-1.2 1.4-3 2.2-4.9 2.2-2.6 0-3.2-1.8-3.2-4.2 0-5.5 2.7-12.6 5.6-12.6 1.2 0 1.7.8 1.7 1.7 0 1-.6 2.1-1.3 2.5.5.6 1.1.7 1.6.7 1.4 0 1.9-1 1.9-2.5 0-2.6-2-3.6-4.5-3.6-7.1 0-9.4 9.2-9.4 14.1s1.9 6.6 5.9 6.6c2.1 0 5-1 6.8-3.4.4 2.1 2.1 3 4.2 3 3.3 0 6-3.1 6.5-8.1.8-.1 1.6-.3 2.3-.6l-1.8 8.5c-2.6.8-4.7 1.6-4.7 4.1 0 1.8 1.6 2.9 3.2 2.9 1.2 0 2.6-.3 3.7-1.7.4 1 1.4 1.7 2.9 1.7 1.8 0 4.1-.7 4.9-4.6l3.1-14.6h2.7l.3-.9zM24 111.5c-.4 3.2-1.8 5.7-3.1 5.6-1 0-1.4-.4-1.4-2.2 0-2.7 1.6-7.6 3.6-7.6.7 0 1 .4 1 1.6-.5.2-.8.7-.8 1.5 0 .5.1 1 .7 1.1zm2.4 10.3c-.4 1.6-1 2.1-1.6 2.1-.6 0-1.1-.5-1.1-.9 0-1.5 1.3-2.2 3-2.8l-.3 1.6zm6.4 0c-.4 1.6-1 2.1-1.6 2.1-.7 0-1.3-.1-1.6-.5.2-.5.4-1 .5-1.7l.5-2.5 2.8-.5-.6 3.1zm.8-3.8l-2.8.5 2.4-11.5h2.7l-2.3 11zm3.1-14.9l-.6 2.9h-2.7l.5-2.2c.4-1.8 1.3-2.1 1.8-2.1.6 0 1 .3 1 .9.1.1.1.3 0 .5zm61.4 4.9c0-1.1-.7-2.1-1.9-2.1-1.3 0-2.4.9-3.3 1.7l.4-1.7-3.9.1-1.8 8.6c-1.3 1.5-2.7 2.7-4.8 2.7-1.3 0-2-.4-2-2.3 0-3 1.8-8 3.5-8 .5 0 .7.4.7 1.1 0 .5-.1 1-.3 1.6.3.2.6.3.9.3.8 0 1.4-.7 1.4-2 0-1.2-.6-2.5-3-2.5-5.5 0-7.3 6.5-7.3 9.6 0 3.1 1.7 4.3 4.2 4.3 2.7 0 4.6-1.2 6.1-2.9l-.7 3.3h3.9l2.1-10.5c.7-.6 1.2-1.1 2-1.1s.1 1.7 1.6 1.7c1.6.2 2.2-1 2.2-1.9zM52.3 18c10-.9 12.9-7.3 24.6-8.3 5.8-.5 9.4.7 9.8 2.7.4 1.9-2.5 3.2-5.9 3.5-4.8.5-6.8-1.2-7.2-2.9-3.6.4-4.1 1.9-3.9 3 .4 2 4.7 4 12.1 3.4 8.3-.7 11.1-3.9 10.5-7.3-.9-4.3-7.3-7.9-18.8-6.8-14.8 1.3-14.7 8.2-24.8 9-4.1.4-6.4-.6-6.8-2.2-.3-1.6 1.7-2.4 4.1-2.6 2.2-.2 4.9.2 6.1.9 1-.5 1.2-1 1.2-1.5-.4-1.5-3.5-2.2-7.3-1.9-7.5.7-7.5 4-7.2 5.5.6 3.5 6.4 6.1 13.5 5.5zm-20.7 9.5c9.2 2.3 21 3.6 35.2 3.6 14.5 0 26-1.2 35.2-3.6 9.8-2.3 14.5-5.4 14.5-8.3 0-2.1-2.1-4.1-5.9-5.7.9.6 1.5 1.5 1.5 2.6 0 3-4.4 5.4-13.3 7.4-8.3 1.8-18.8 3.1-31.7 3.1-12.4 0-23.4-1.2-31.4-3-8.5-2.1-13.1-4.4-13.1-7.4 0-1.2.6-2.3 2.3-3.6-5.4 2.1-8.3 3.8-8.3 6.5.4 3.1 5.2 6.1 15 8.4zM17.5 73.9c3.8 3 8 3.8 12.7 3 1.8-.3 3.8-1.2 5.7-1.8-3.8 0-7.1-1.2-10.4-3.8-3.6-2.6-5.9-6.2-6.5-10.7-.9-4.1 0-8 2.3-11.3l1.6-1.8c1.3 3.2 2.8 6.4 4.4 9.3C30.9 62.2 34.4 66.9 38 72c1.5 3 2.6 5.9 3.3 8.9 2.3 3.3 5.7 5.5 9.8 6.7 5.1 1.8 10.4 2.4 15.7 2.4h.6c5.4 0 11-.7 16.2-2.4 3.8-1.2 7.1-3.6 9.5-6.6h.3c.6-3 1.5-6 3-9 3.6-5.1 7.1-9.8 10.7-15.2 4.7-8.5 8-18.3 9.8-28.8-1.9 2.7-6.3 5-14.3 6.8-9.2 2.1-21 3.5-35.2 3.5-14.5 0-26.3-1.5-35.5-3.6-8.3-2.1-12.7-4.4-14.2-6.8.8 5.4 2.1 10.6 3.9 15.6-2.1 1.3-4 3-5.7 5.1-3.3 4.1-4.7 8.9-4.4 13.6s2.4 8.7 6 11.7z\" fill=\"#28334C\"/></svg>"

/***/ }),

/***/ "../src/components/coffeescript/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CoffeescriptOriginalWordmark = __webpack_require__("../src/components/coffeescript/original-wordmark/CoffeescriptOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CoffeescriptOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/coffeescript/original/CoffeescriptOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CoffeescriptOriginal = __webpack_require__("../src/components/coffeescript/original/CoffeescriptOriginal.svg");
	
	var _CoffeescriptOriginal2 = _interopRequireDefault(_CoffeescriptOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CoffeescriptOriginal */
	function CoffeescriptOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CoffeescriptOriginal',
	    svg: _CoffeescriptOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CoffeescriptOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CoffeescriptOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/coffeescript/original/CoffeescriptOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M50.3 29.6c11.7-1 15-8.5 28.7-9.8 6.7-.6 11 .8 11.4 3.1.4 2.2-2.9 3.7-7 4-5.6.6-8-1.5-8.4-3.4-4.1.4-4.8 2.2-4.6 3.5.4 2.4 5.5 4.7 14.1 3.9 9.8-.8 13-4.6 12.2-8.5-1-5-8.5-9.2-22-8-17.3 1.6-17.2 9.5-28.9 10.5-4.8.4-7.5-.7-8-2.6-.3-1.9 2-2.8 4.8-3 2.6-.2 5.7.2 7.2 1 1.1-.6 1.5-1.1 1.3-1.8-.4-1.8-4-2.6-8.5-2.2-8.7.8-8.7 4.7-8.4 6.4 1.1 4.7 7.8 7.7 16.1 6.9zm58.6 19.8c-10.8 2.5-24.6 4.1-41.2 4.1-16.9 0-30.7-1.8-41.5-4.1-9.6-2.5-14.8-5.2-16.6-8 .9 6.3 2.5 12.4 4.6 18.2-2.4 1.5-4.7 3.5-6.7 6C3.7 70.4 2 76 2.3 81.5c.3 5.5 3 10 7.3 13.5 4.5 3.5 9.3 4.5 14.8 3.5 2.1-.3 4.5-1.5 6.6-2.1-4.5 0-8.3-1.5-12.1-4.5-4.1-3-7-7.3-7.6-12.4-1-4.8 0-9.3 2.7-13.2.6-.8 1.2-1.4 1.9-2 1.5 3.8 3.3 7.4 5.2 10.9 4.1 6.3 8.3 11.8 12.4 17.7 1.8 3.5 3 7 3.8 10.4 2.7 3.8 6.6 6.5 11.4 7.9 5.9 2.1 12.1 2.9 18.4 2.9h.7c6.3 0 12.9-1 19-3 4.5-1.5 8.3-4 11.1-8h.3c.7-3 1.8-6.8 3.5-10.3 4.1-5.9 8.3-11.4 12.4-17.7 5.5-10 9.3-21.4 11.4-33.6-2.1 3-7.3 5.8-16.6 7.9zm-82.7-8.7c10.8 2.7 24.6 4.1 41.2 4.1 16.9 0 30.4-1.5 41.2-4.1 11.4-2.7 16.9-6.3 16.9-9.6 0-2.5-2.5-4.8-7-6.6 1 .7 1.8 1.8 1.8 3 0 3.5-5.2 6.3-15.6 8.6-9.6 2.1-22 3.6-37 3.6-14.5 0-27.4-1.5-36.7-3.5-10-2.5-15.3-5.2-15.3-8.6 0-1.5.7-2.7 2.7-4.1-6.3 2.5-9.6 4.5-9.6 7.6.3 3.5 5.9 7 17.4 9.6z\" fill=\"#28334C\"/></svg>"

/***/ }),

/***/ "../src/components/coffeescript/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CoffeescriptOriginal = __webpack_require__("../src/components/coffeescript/original/CoffeescriptOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CoffeescriptOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/confluence/original-wordmark/ConfluenceOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ConfluenceOriginalWordmark = __webpack_require__("../src/components/confluence/original-wordmark/ConfluenceOriginalWordmark.svg");
	
	var _ConfluenceOriginalWordmark2 = _interopRequireDefault(_ConfluenceOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ConfluenceOriginalWordmark */
	function ConfluenceOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ConfluenceOriginalWordmark',
	    svg: _ConfluenceOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ConfluenceOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ConfluenceOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/confluence/original-wordmark/ConfluenceOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#205081\"><path d=\"M20.795 111.42c-4.277 0-6.538 2.054-6.538 5.94v3.665c0 3.887 2.26 5.942 6.538 5.942 4.277 0 6.538-2.055 6.538-5.942v-3.664c0-3.886-2.26-5.94-6.538-5.94zm-2.46 5.822c0-1.6.736-2.282 2.46-2.282 1.725 0 2.46.682 2.46 2.282v3.903c0 1.6-.735 2.282-2.46 2.282s-2.46-.682-2.46-2.282v-3.903zm20.058-5.822c-1.614 0-3.813.556-5.67 1.428l-.223-.76a.516.516 0 0 0-.495-.37H29.75a.516.516 0 0 0-.516.515v13.92c0 .285.23.516.516.516h3.046a.517.517 0 0 0 .516-.517v-9.64c1.097-.56 2.64-1.136 3.563-1.136.686 0 .94.255.94.94v9.836c0 .285.232.516.517.516h3.046a.517.517 0 0 0 .516-.517V115.93c-.002-2.993-1.18-4.51-3.5-4.51zm14.483-5.478c-.82-.21-1.766-.325-2.66-.325-3.256 0-4.84 1.544-4.84 4.72v1.805h-1.69a.516.516 0 0 0-.516.516v2.3c0 .286.23.516.516.516h1.69v10.68c0 .284.232.515.517.515h3.046a.517.517 0 0 0 .515-.517v-10.68h2.99c.27 0 .496-.208.515-.477v-2.3a.516.516 0 0 0-.514-.554h-2.992v-1.596c0-1.112.214-1.507 1.418-1.507.372 0 .94.057 1.48.15a.514.514 0 0 0 .598-.438l.31-2.24a.514.514 0 0 0-.384-.57zm5.506.075h-3.046a.516.516 0 0 0-.516.516v19.62c0 .286.23.517.516.517h3.046c.285 0 .516-.23.516-.516v-19.62a.515.515 0 0 0-.516-.517zm14.918 5.7h-3.045a.516.516 0 0 0-.516.516v9.64c-1.098.56-2.64 1.136-3.564 1.136-.686 0-.94-.256-.94-.942v-9.835a.516.516 0 0 0-.517-.516h-3.047a.516.516 0 0 0-.516.516v10.222c0 2.994 1.177 4.51 3.5 4.51 1.613 0 3.812-.556 5.67-1.428l.223.76c.064.22.266.37.495.37H73.3c.285 0 .516-.23.516-.515v-13.92a.516.516 0 0 0-.515-.515zm8.528-.297c-4.082 0-6.24 2.033-6.24 5.88v3.844c0 3.972 2.02 5.822 6.36 5.822 1.767 0 3.65-.31 5.165-.848a.515.515 0 0 0 .332-.59l-.45-2.18a.516.516 0 0 0-.645-.39c-1.398.395-2.73.587-4.075.587-2.22 0-2.61-.717-2.61-2.222v-.524h7.56a.517.517 0 0 0 .515-.517v-2.803c0-4.135-1.88-6.06-5.912-6.06zm-2.163 6.018v-.494c0-1.435.696-2.103 2.192-2.103 1.652 0 1.984.805 1.984 2.104v.494h-4.175zm19.079-6.018c-1.614 0-3.813.556-5.67 1.428l-.224-.76a.515.515 0 0 0-.495-.37H90.1a.516.516 0 0 0-.517.515v13.92c0 .285.23.516.516.516h3.045a.517.517 0 0 0 .516-.517v-9.64c1.098-.56 2.64-1.136 3.564-1.136.686 0 .94.255.94.94v9.836c0 .285.232.516.517.516h3.047a.517.517 0 0 0 .516-.517V115.93c0-2.993-1.177-4.51-3.5-4.51zm15.229 12.096a.515.515 0 0 0-.626-.427c-.874.2-1.79.305-2.65.305-1.932 0-2.49-.492-2.49-2.192v-4.022c0-1.7.56-2.19 2.49-2.19.532 0 1.677.08 2.65.303a.52.52 0 0 0 .626-.426l.362-2.41a.515.515 0 0 0-.364-.57c-1.172-.347-2.543-.47-3.362-.47-4.6 0-6.478 1.68-6.478 5.794v3.963c0 4.114 1.877 5.793 6.478 5.793 1.12 0 2.41-.18 3.366-.467a.516.516 0 0 0 .36-.57l-.36-2.414zm7.717-12.096c-4.082 0-6.24 2.033-6.24 5.88v3.844c0 3.972 2.02 5.822 6.36 5.822 1.767 0 3.65-.31 5.165-.848a.515.515 0 0 0 .332-.59l-.45-2.18a.516.516 0 0 0-.645-.39c-1.398.395-2.73.587-4.075.587-2.22 0-2.61-.717-2.61-2.222v-.524h7.56a.517.517 0 0 0 .516-.517v-2.803c0-4.135-1.88-6.06-5.913-6.06zm-2.163 6.018v-.494c0-1.435.697-2.103 2.192-2.103 1.65 0 1.983.805 1.983 2.104v.494h-4.176zM7.8 109.958c1.22 0 2.908.168 4.515.448a.516.516 0 0 0 .6-.442l.345-2.68a.515.515 0 0 0-.39-.567 22.957 22.957 0 0 0-5.188-.598C2.85 106.12.4 108.127.4 112.09v8.938c0 3.962 2.45 5.97 7.282 5.97 1.732 0 3.574-.212 5.187-.597a.516.516 0 0 0 .39-.567l-.344-2.68a.514.514 0 0 0-.6-.442c-1.607.282-3.295.45-4.515.45-2.396 0-3.204-.704-3.204-2.788v-7.627c0-2.083.807-2.787 3.204-2.787zM86.21 66.063c-1.343-2.646-2.934-5.32-4.794-8.04a91.415 91.415 0 0 0-4.253-5.705c-.607-.756-.352-1.696.11-2.164l1.383-1.412c6.378-6.505 12.975-13.23 18.032-20.497 5.38-7.73 8.36-15.062 9.112-22.606a2.33 2.33 0 0 0-.88-2.03 2.278 2.278 0 0 0-2.19-.317c-4.905 1.876-9.885 3.3-14.432 4.36a2.837 2.837 0 0 0-1.986 1.73C83 18.458 74.542 27.097 65.668 36.146c-.356.338-.856.784-1.667.784-.81 0-1.304-.433-1.666-.785-8.873-9.05-17.33-17.658-20.644-26.732a2.84 2.84 0 0 0-1.986-1.73c-4.55-1.06-9.533-2.606-14.43-4.48a2.266 2.266 0 0 0-3.07 2.345c.752 7.544 3.732 14.967 9.113 22.697 5.057 7.267 11.653 13.993 18.03 20.497 11.753 11.98 22.854 23.3 23.828 36.428a2.27 2.27 0 0 0 2.263 2.103h13.807a2.273 2.273 0 0 0 2.268-2.383 41.576 41.576 0 0 0-1.062-7.43l.006-.005a.905.905 0 0 1 .872-1.143c.044 0 .086.008.13.014 11.27 1.65 18.4 4.286 18.41 7.19v.005c0 2.736-6.408 6.866-16.823 9.89l-.004.003c-.925.264-1.6 1.1-1.6 2.095 0 1.204.994 2.183 2.224 2.183.17 0 .334-.02.492-.054 14-3.24 23.28-8.68 23.28-14.824 0-7.296-12.546-13.812-31.227-16.75zm-37.023-7.116a2.272 2.272 0 0 0-1.612-.69c-1.03 0-1.642.664-1.873 1.017a70.313 70.313 0 0 0-3.96 6.797c-18.654 2.942-31.178 9.452-31.178 16.742 0 6.15 9.215 11.58 23.24 14.817l.02-.002c.166.04.336.064.513.064 1.23 0 2.223-.98 2.223-2.183 0-.992-.676-1.82-1.598-2.085l-.007-.014c-10.415-3.02-16.823-7.15-16.823-9.886v-.006c.01-2.9 7.12-5.53 18.363-7.183a.69.69 0 0 1 .12-.013.915.915 0 0 1 .88 1.155l.01.01a41.57 41.57 0 0 0-1.053 7.398c-.03.618.197 1.232.626 1.684.428.45 1.03.707 1.65.707h13.808a2.288 2.288 0 0 0 2.272-2.11c.3-4.04 1.563-8.09 3.852-12.345.793-1.473.177-2.856-.28-3.447-2.272-2.955-5.054-6.106-9.193-10.426z\"/><path d=\"M62.408 24.84a2.22 2.22 0 0 0 1.59.63h.005c.427 0 1.046-.098 1.592-.63 4.87-4.734 7.484-10.254 8.058-11.788a2.25 2.25 0 0 0 .168-.84c0-1.224-1.02-2.1-2.087-2.1-.882 0-3.39.26-7.717.26h-.03c-4.324 0-6.833-.26-7.714-.26-1.068 0-2.09.876-2.09 2.1 0 .36.084.614.17.84.57 1.534 3.188 7.054 8.056 11.788z\"/></g></svg>"

/***/ }),

/***/ "../src/components/confluence/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ConfluenceOriginalWordmark = __webpack_require__("../src/components/confluence/original-wordmark/ConfluenceOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ConfluenceOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/confluence/original/ConfluenceOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ConfluenceOriginal = __webpack_require__("../src/components/confluence/original/ConfluenceOriginal.svg");
	
	var _ConfluenceOriginal2 = _interopRequireDefault(_ConfluenceOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ConfluenceOriginal */
	function ConfluenceOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ConfluenceOriginal',
	    svg: _ConfluenceOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ConfluenceOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ConfluenceOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/confluence/original/ConfluenceOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#205081\"><path d=\"M89.976 82.353c-1.57-3.094-3.43-6.223-5.606-9.405a106.98 106.98 0 0 0-4.974-6.672c-.71-.884-.412-1.984.13-2.53.536-.55 1.075-1.098 1.617-1.653 7.46-7.61 15.175-15.475 21.09-23.974 6.293-9.042 9.78-17.618 10.66-26.44a2.723 2.723 0 0 0-1.03-2.375 2.663 2.663 0 0 0-2.56-.368c-5.738 2.194-11.563 3.86-16.88 5.098a3.318 3.318 0 0 0-2.324 2.026C86.223 26.674 76.33 36.778 65.953 47.363c-.417.395-1 .917-1.95.917-.948 0-1.526-.506-1.95-.918-10.38-10.586-20.27-20.654-24.146-31.268a3.323 3.323 0 0 0-2.323-2.025c-5.32-1.24-11.15-3.047-16.878-5.24a2.655 2.655 0 0 0-3.592 2.742c.88 8.824 4.365 17.506 10.66 26.547 5.914 8.498 13.63 16.365 21.09 23.973C60.607 76.106 73.59 89.347 74.73 104.7a2.654 2.654 0 0 0 2.647 2.46h16.148a2.658 2.658 0 0 0 2.653-2.788 48.635 48.635 0 0 0-1.242-8.69l.006-.007a1.06 1.06 0 0 1 1.02-1.337c.05 0 .1.01.15.017h.002c13.183 1.93 21.52 5.013 21.533 8.41v.007c0 3.2-7.495 8.03-19.677 11.565l-.005.005c-1.083.31-1.873 1.288-1.873 2.45 0 1.408 1.163 2.554 2.6 2.554.2 0 .39-.023.577-.065 16.375-3.787 27.23-10.152 27.23-17.338-.002-8.533-14.676-16.154-36.526-19.59zM46.675 74.03a2.66 2.66 0 0 0-1.886-.808c-1.206 0-1.92.778-2.19 1.19a82.094 82.094 0 0 0-4.632 7.95C16.148 85.803 1.5 93.418 1.5 101.943c0 7.194 10.777 13.546 27.182 17.332.002 0 .018 0 .024-.002.193.046.392.075.6.075 1.436 0 2.6-1.145 2.6-2.554 0-1.16-.792-2.126-1.87-2.438l-.007-.017c-12.183-3.536-19.678-8.367-19.678-11.565v-.008c.012-3.39 8.327-6.47 21.477-8.4a.833.833 0 0 1 .14-.016A1.07 1.07 0 0 1 33 95.7l.01.01a48.544 48.544 0 0 0-1.23 8.653c-.036.723.23 1.44.732 1.97a2.68 2.68 0 0 0 1.93.827h16.15a2.676 2.676 0 0 0 2.657-2.468c.35-4.725 1.827-9.46 4.505-14.438.928-1.722.207-3.34-.328-4.03-2.658-3.457-5.912-7.142-10.752-12.194z\"/><path d=\"M62.138 34.137c.64.62 1.362.738 1.86.738h.005c.5 0 1.223-.116 1.862-.738C71.56 28.6 74.62 22.144 75.29 20.35a2.64 2.64 0 0 0 .197-.98c0-1.434-1.194-2.457-2.443-2.457-1.03 0-3.967.304-9.026.304h-.033c-5.06 0-7.993-.304-9.024-.304-1.248 0-2.443 1.024-2.443 2.456 0 .417.1.716.198.98.67 1.794 3.73 8.25 9.423 13.787z\"/></g></svg>"

/***/ }),

/***/ "../src/components/confluence/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ConfluenceOriginal = __webpack_require__("../src/components/confluence/original/ConfluenceOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ConfluenceOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/couchdb/original-wordmark/CouchdbOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CouchdbOriginalWordmark = __webpack_require__("../src/components/couchdb/original-wordmark/CouchdbOriginalWordmark.svg");
	
	var _CouchdbOriginalWordmark2 = _interopRequireDefault(_CouchdbOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CouchdbOriginalWordmark */
	function CouchdbOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CouchdbOriginalWordmark',
	    svg: _CouchdbOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CouchdbOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CouchdbOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/couchdb/original-wordmark/CouchdbOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"CouchDB\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#444}.cls-2{fill:#e42528}</style></defs><title>Artboard 13</title><g id=\"original-wordmark\"><path id=\"Shape\" class=\"cls-1\" d=\"M57.9 63.22c-3.19 0-4.71 2.2-4.71 5.56s1.52 5.55 4.71 5.55 4.64-2.26 4.64-5.55-1.46-5.56-4.64-5.56zm0 9.63c-2.1 0-2.74-1.68-2.74-4.07 0-2.59.7-4.07 2.74-4.07s2.73 1.48 2.73 4.07c0 2.39-.71 4.07-2.73 4.07z\"/><path id=\"Shape-2\" data-name=\"Shape\" class=\"cls-1\" d=\"M73.92 63.35H72v8.53c-.25.19-.51.32-.82.51a4.8 4.8 0 0 1-2.1.52c-1.53 0-2-1-2-3.36v-6.13h-1.87v6.2c0 3.29 1.09 4.78 3.44 4.78a5 5 0 0 0 2.67-.71 4.06 4.06 0 0 0 1-.71l.25 1.35 1.4-.13V63.35z\"/><path id=\"Shape-3\" data-name=\"Shape\" class=\"cls-1\" d=\"M76.6 68.84c0 4.07 2.29 5.49 4.51 5.49a9.53 9.53 0 0 0 2.17-.26 8 8 0 0 0 .82-.26l.2-1.48c-.26.06-.58.19-.9.26a8.58 8.58 0 0 1-2 .26c-1.85 0-2.87-1.23-2.87-4s1-4.13 2.87-4.13a8.58 8.58 0 0 1 2 .26c.32.06.58.19.9.26l-.13-1.43a3 3 0 0 0-.83-.25 8.94 8.94 0 0 0-2.16-.26c-2.28-.08-4.58 1.21-4.58 5.54z\"/><path id=\"Shape-4\" data-name=\"Shape\" class=\"cls-1\" d=\"M86.78 74.33h1.92V66a7.93 7.93 0 0 1 3-1.1c1.27 0 1.91.71 1.91 3.55v5.88h1.91v-6c0-3.49-1-4.85-3.31-4.85a5.18 5.18 0 0 0-3.56 1.23v-5.43l-1.91.2v14.85z\"/><path id=\"Shape-5\" data-name=\"Shape\" class=\"cls-1\" d=\"M108 60.51a7.33 7.33 0 0 0-4.71-1.23H99v15h4.7c5.16 0 6.37-3.1 6.37-7.82.01-3.24-.83-4.92-2.07-5.95zm-4.9 12.34H101v-12h2.8c3.43 0 4.39 1.88 4.39 5.75-.02 4.83-1.1 6.25-5.11 6.25z\"/><path id=\"Shape-6\" data-name=\"Shape\" class=\"cls-1\" d=\"M121.59 66.71a5.1 5.1 0 0 0-1.66-.52 2.93 2.93 0 0 0 2.61-3c0-2.84-1.4-3.94-5.22-3.94h-4.07v15.02h4.84c3.43 0 5.15-1.36 5.15-4.33a3.5 3.5 0 0 0-1.65-3.23zm-6.49-5.88h2c2.61 0 3.63.46 3.63 2.33 0 1.61-.83 2.52-3.19 2.52h-2.44v-4.85zm2.48 12h-2.48V67h2.48c2.61 0 3.82.65 3.82 3s-1.27 2.85-3.81 2.85z\"/><path id=\"Shape-7\" data-name=\"Shape\" class=\"cls-1\" d=\"M46.94 74.33a15.48 15.48 0 0 0 2.94-.33 9.12 9.12 0 0 1 1.12-.31l.19-1.62-1.14.39a11.54 11.54 0 0 1-2.86.39c-2.74 0-4.08-1.81-4.08-6.27 0-4.65 1.59-6.13 4.27-6.13a14.42 14.42 0 0 1 2.73.32c.45.06.77.26 1.15.32l-.19-1.68c-.32-.13-.7-.19-1.08-.32a16.12 16.12 0 0 0-2.87-.32c-3.5 0-6.11 1.87-6.11 7.68 0 3 .64 5 1.72 6.2a5.29 5.29 0 0 0 4.21 1.68z\"/><path id=\"Shape-8\" data-name=\"Shape\" class=\"cls-2\" d=\"M30 67.42a1.82 1.82 0 0 1-2 2H12.52a1.76 1.76 0 0 1-2-2 1.82 1.82 0 0 1 2-2h15.59a1.77 1.77 0 0 1 1.89 2zm-1.91 3H12.52a1.77 1.77 0 0 0-2 2 1.82 1.82 0 0 0 2 2h15.59a1.77 1.77 0 0 0 2-2c-.11-1.42-.72-2.03-2-2.03zm4.84-10.91a1.74 1.74 0 0 0-2 1.93v10.89a1.82 1.82 0 0 0 2 2c1.91-.06 2.93-2 2.93-5.94v-4.91c.02-2.65-1-3.94-2.91-4zm-25.26 0c-1.91.06-2.93 1.35-2.93 4v4.91c0 3.94 1 5.88 2.93 5.94a1.76 1.76 0 0 0 2-2V61.48a1.85 1.85 0 0 0-1.98-2zm25.26-1c0-3.3-1.72-4.85-4.84-4.91H12.52c-3.18.06-4.83 1.68-4.83 4.91a2.63 2.63 0 0 1 2.92 3 2.64 2.64 0 0 0 2.93 3h13.62a2.64 2.64 0 0 0 2.93-3c-.07-2 1-2.91 2.86-3z\"/></g></svg>"

/***/ }),

/***/ "../src/components/couchdb/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CouchdbOriginalWordmark = __webpack_require__("../src/components/couchdb/original-wordmark/CouchdbOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CouchdbOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/couchdb/original/CouchdbOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CouchdbOriginal = __webpack_require__("../src/components/couchdb/original/CouchdbOriginal.svg");
	
	var _CouchdbOriginal2 = _interopRequireDefault(_CouchdbOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CouchdbOriginal */
	function CouchdbOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CouchdbOriginal',
	    svg: _CouchdbOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CouchdbOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CouchdbOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/couchdb/original/CouchdbOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"CouchDB\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#e42528}</style></defs><title>Artboard 12</title><path class=\"cls-1\" d=\"M101.4 77.2c0 5-2.7 7.5-7.6 7.7H33.9c-4.9 0-7.6-2.5-7.6-7.7 0-5 2.7-7.5 7.6-7.7h60.2c4.9.2 7.3 2.7 7.3 7.7zm-7.3 11.5H33.9c-4.9 0-7.6 2.4-7.6 7.7 0 5 2.7 7.4 7.6 7.7h60.2c4.9 0 7.6-2.5 7.6-7.7-.3-5.3-2.7-7.7-7.6-7.7zm18.6-42.1c-4.9 0-7.6 2.5-7.6 7.4v42.1c0 5 2.7 7.5 7.6 7.7 7.4-.2 11.3-7.7 11.3-22.9V62c0-10.2-3.9-15.2-11.3-15.4zm-97.4 0C7.9 46.8 4 51.8 4 62v18.9c0 15.2 3.9 22.7 11.3 22.9 4.9 0 7.6-2.4 7.6-7.7V54.3c-.2-5-2.7-7.5-7.6-7.7zm97.4-3.8c0-12.7-6.6-18.7-18.6-18.9H33.9c-12.2.2-18.6 6.5-18.6 18.9 7.4 0 11.3 4 11.3 11.5s3.9 11.4 11.3 11.4h52.5c7.3 0 11.3-3.9 11.3-11.4-.3-7.7 3.9-11.2 11-11.5z\" id=\"original\"/></svg>"

/***/ }),

/***/ "../src/components/couchdb/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CouchdbOriginal = __webpack_require__("../src/components/couchdb/original/CouchdbOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CouchdbOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/couchdb/plain-wordmark/CouchdbPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CouchdbPlainWordmark = __webpack_require__("../src/components/couchdb/plain-wordmark/CouchdbPlainWordmark.svg");
	
	var _CouchdbPlainWordmark2 = _interopRequireDefault(_CouchdbPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CouchdbPlainWordmark */
	function CouchdbPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CouchdbPlainWordmark',
	    svg: _CouchdbPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CouchdbPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CouchdbPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/couchdb/plain-wordmark/CouchdbPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"CouchDB\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#444}</style></defs><title>Artboard 15</title><g id=\"plain-wordmark\"><path id=\"Shape\" class=\"cls-1\" d=\"M57.9 63.22c-3.19 0-4.71 2.2-4.71 5.56s1.52 5.55 4.71 5.55 4.64-2.26 4.64-5.55-1.46-5.56-4.64-5.56zm0 9.63c-2.1 0-2.74-1.68-2.74-4.07 0-2.59.7-4.07 2.74-4.07s2.73 1.48 2.73 4.07c0 2.39-.71 4.07-2.73 4.07z\"/><path id=\"Shape-2\" data-name=\"Shape\" class=\"cls-1\" d=\"M73.92 63.35H72v8.53c-.25.19-.51.32-.82.51a4.8 4.8 0 0 1-2.1.52c-1.53 0-2-1-2-3.36v-6.13h-1.87v6.2c0 3.29 1.09 4.78 3.44 4.78a5 5 0 0 0 2.67-.71 4.06 4.06 0 0 0 1-.71l.25 1.35 1.4-.13V63.35z\"/><path id=\"Shape-3\" data-name=\"Shape\" class=\"cls-1\" d=\"M76.6 68.84c0 4.07 2.29 5.49 4.51 5.49a9.53 9.53 0 0 0 2.17-.26 8 8 0 0 0 .82-.26l.2-1.48c-.26.06-.58.19-.9.26a8.58 8.58 0 0 1-2 .26c-1.85 0-2.87-1.23-2.87-4s1-4.13 2.87-4.13a8.58 8.58 0 0 1 2 .26c.32.06.58.19.9.26l-.13-1.43a3 3 0 0 0-.83-.25 8.94 8.94 0 0 0-2.16-.26c-2.28-.08-4.58 1.21-4.58 5.54z\"/><path id=\"Shape-4\" data-name=\"Shape\" class=\"cls-1\" d=\"M86.78 74.33h1.92V66a7.93 7.93 0 0 1 3-1.1c1.27 0 1.91.71 1.91 3.55v5.88h1.91v-6c0-3.49-1-4.85-3.31-4.85a5.18 5.18 0 0 0-3.56 1.23v-5.43l-1.91.2v14.85z\"/><path id=\"Shape-5\" data-name=\"Shape\" class=\"cls-1\" d=\"M108 60.51a7.33 7.33 0 0 0-4.71-1.23H99v15h4.7c5.16 0 6.37-3.1 6.37-7.82.01-3.24-.83-4.92-2.07-5.95zm-4.9 12.34H101v-12h2.8c3.43 0 4.39 1.88 4.39 5.75-.02 4.83-1.1 6.25-5.11 6.25z\"/><path id=\"Shape-6\" data-name=\"Shape\" class=\"cls-1\" d=\"M121.59 66.71a5.1 5.1 0 0 0-1.66-.52 2.93 2.93 0 0 0 2.61-3c0-2.84-1.4-3.94-5.22-3.94h-4.07v15.02h4.84c3.43 0 5.15-1.36 5.15-4.33a3.5 3.5 0 0 0-1.65-3.23zm-6.49-5.88h2c2.61 0 3.63.46 3.63 2.33 0 1.61-.83 2.52-3.19 2.52h-2.44v-4.85zm2.48 12h-2.48V67h2.48c2.61 0 3.82.65 3.82 3s-1.27 2.85-3.81 2.85z\"/><path id=\"Shape-7\" data-name=\"Shape\" class=\"cls-1\" d=\"M46.94 74.33a15.48 15.48 0 0 0 2.94-.33 9.12 9.12 0 0 1 1.12-.31l.19-1.62-1.14.39a11.54 11.54 0 0 1-2.86.39c-2.74 0-4.08-1.81-4.08-6.27 0-4.65 1.59-6.13 4.27-6.13a14.42 14.42 0 0 1 2.73.32c.45.06.77.26 1.15.32l-.19-1.68c-.32-.13-.7-.19-1.08-.32a16.12 16.12 0 0 0-2.87-.32c-3.5 0-6.11 1.87-6.11 7.68 0 3 .64 5 1.72 6.2a5.29 5.29 0 0 0 4.21 1.68z\"/><path id=\"Shape-8\" data-name=\"Shape\" class=\"cls-1\" d=\"M30 67.42a1.82 1.82 0 0 1-2 2H12.52a1.76 1.76 0 0 1-2-2 1.82 1.82 0 0 1 2-2h15.59a1.77 1.77 0 0 1 1.89 2zm-1.91 3H12.52a1.77 1.77 0 0 0-2 2 1.82 1.82 0 0 0 2 2h15.59a1.77 1.77 0 0 0 2-2c-.11-1.42-.72-2.03-2-2.03zm4.84-10.91a1.74 1.74 0 0 0-2 1.93v10.89a1.82 1.82 0 0 0 2 2c1.91-.06 2.93-2 2.93-5.94v-4.91c.02-2.65-1-3.94-2.91-4zm-25.26 0c-1.91.06-2.93 1.35-2.93 4v4.91c0 3.94 1 5.88 2.93 5.94a1.76 1.76 0 0 0 2-2V61.48a1.85 1.85 0 0 0-1.98-2zm25.26-1c0-3.3-1.72-4.85-4.84-4.91H12.52c-3.18.06-4.83 1.68-4.83 4.91a2.63 2.63 0 0 1 2.92 3 2.64 2.64 0 0 0 2.93 3h13.62a2.64 2.64 0 0 0 2.93-3c-.07-2 1-2.91 2.86-3z\"/></g></svg>"

/***/ }),

/***/ "../src/components/couchdb/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CouchdbPlainWordmark = __webpack_require__("../src/components/couchdb/plain-wordmark/CouchdbPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CouchdbPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/couchdb/plain/CouchdbPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CouchdbPlain = __webpack_require__("../src/components/couchdb/plain/CouchdbPlain.svg");
	
	var _CouchdbPlain2 = _interopRequireDefault(_CouchdbPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CouchdbPlain */
	function CouchdbPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CouchdbPlain',
	    svg: _CouchdbPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CouchdbPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CouchdbPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/couchdb/plain/CouchdbPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"CouchDB\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#444}</style></defs><title>Artboard 14</title><path class=\"cls-1\" d=\"M101.4 77.2c0 5-2.7 7.5-7.6 7.7H33.9c-4.9 0-7.6-2.5-7.6-7.7 0-5 2.7-7.5 7.6-7.7h60.2c4.9.2 7.3 2.7 7.3 7.7zm-7.3 11.5H33.9c-4.9 0-7.6 2.4-7.6 7.7 0 5 2.7 7.4 7.6 7.7h60.2c4.9 0 7.6-2.5 7.6-7.7-.3-5.3-2.7-7.7-7.6-7.7zm18.6-42.1c-4.9 0-7.6 2.5-7.6 7.4v42.1c0 5 2.7 7.5 7.6 7.7 7.4-.2 11.3-7.7 11.3-22.9V62c0-10.2-3.9-15.2-11.3-15.4zm-97.4 0C7.9 46.8 4 51.8 4 62v18.9c0 15.2 3.9 22.7 11.3 22.9 4.9 0 7.6-2.4 7.6-7.7V54.3c-.2-5-2.7-7.5-7.6-7.7zm97.4-3.8c0-12.7-6.6-18.7-18.6-18.9H33.9c-12.2.2-18.6 6.5-18.6 18.9 7.4 0 11.3 4 11.3 11.5s3.9 11.4 11.3 11.4h52.5c7.3 0 11.3-3.9 11.3-11.4-.3-7.7 3.9-11.2 11-11.5z\" id=\"plain\"/></svg>"

/***/ }),

/***/ "../src/components/couchdb/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CouchdbPlain = __webpack_require__("../src/components/couchdb/plain/CouchdbPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CouchdbPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cplusplus/line/CplusplusLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CplusplusLine = __webpack_require__("../src/components/cplusplus/line/CplusplusLine.svg");
	
	var _CplusplusLine2 = _interopRequireDefault(_CplusplusLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CplusplusLine */
	function CplusplusLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CplusplusLine',
	    svg: _CplusplusLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CplusplusLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CplusplusLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cplusplus/line/CplusplusLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M87 70v-5h5v-4h-5v-5h-5v5h-5v4h5v5zm18-14h-4v5h-6v4h6v5h4v-5h5v-4h-5zm11.5-23.7c-.6-1.1-1.4-2.1-2.3-2.6L66.1 1.9c-.8-.5-1.9-.7-3.1-.7-1.2 0-2.3.3-3.1.7L11.4 29.7c-1.7 1-3.4 3.5-3.4 5.4v55.7c0 1.1.7 2.3 1.4 3.4l.1.1c.5.8 1.3 1.5 2 1.9l48.3 27.9c.8.5 2 .7 3.2.7 1.2 0 2.3-.3 3.1-.7l47.5-27.9c1.7-1 2.4-3.5 2.4-5.4V35.1c0-.8.4-1.8 0-2.6l.5-.2zm-4.2 2.1c0 .3-.3.5-.3.7v55.7c0 .8-.2 1.7-.4 2L64 120.6c-.1.1-.5.2-1.1.2-.6 0-1-.1-1.1-.2L13.6 92.8s-.1-.1-.2-.1l-.6-.6c-.4-.7.2-1.1-.8-1.2V35.2c1-.5.9-1.7 1.4-1.9L61.7 5.4c.1 0 .6-.2 1.2-.2s1 .1 1.1.2l48 27.7.4.9c.1.1-.1.3-.1.4zM63 87.5c-13.5 0-24.5-11-24.5-24.5s11-24.5 24.5-24.5c9.1 0 17.1 5 21.3 12.5l13-7.5c-6.8-11.9-19.6-20-34.3-20-21.8 0-39.5 17.7-39.5 39.5s17.7 39.5 39.5 39.5c14.6 0 27.4-8 34.2-19.8l-12.9-7.6C80.1 82.5 72.1 87.5 63 87.5z\" fill=\"#9C033A\"/></svg>"

/***/ }),

/***/ "../src/components/cplusplus/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CplusplusLine = __webpack_require__("../src/components/cplusplus/line/CplusplusLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CplusplusLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cplusplus/original/CplusplusOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CplusplusOriginal = __webpack_require__("../src/components/cplusplus/original/CplusplusOriginal.svg");
	
	var _CplusplusOriginal2 = _interopRequireDefault(_CplusplusOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CplusplusOriginal */
	function CplusplusOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CplusplusOriginal',
	    svg: _CplusplusOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CplusplusOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CplusplusOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cplusplus/original/CplusplusOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#D26383\" d=\"M115.4 30.7L67.1 2.9c-.8-.5-1.9-.7-3.1-.7-1.2 0-2.3.3-3.1.7l-48 27.9c-1.7 1-2.9 3.5-2.9 5.4v55.7c0 1.1.2 2.4 1 3.5l106.8-62c-.6-1.2-1.5-2.1-2.4-2.7z\"/><path fill=\"#9C033A\" d=\"M10.7 95.3c.5.8 1.2 1.5 1.9 1.9l48.2 27.9c.8.5 1.9.7 3.1.7 1.2 0 2.3-.3 3.1-.7l48-27.9c1.7-1 2.9-3.5 2.9-5.4V36.1c0-.9-.1-1.9-.6-2.8l-106.6 62z\"/><path fill=\"#fff\" d=\"M85.3 76.1C81.1 83.5 73.1 88.5 64 88.5c-13.5 0-24.5-11-24.5-24.5s11-24.5 24.5-24.5c9.1 0 17.1 5 21.3 12.5l13-7.5c-6.8-11.9-19.6-20-34.3-20-21.8 0-39.5 17.7-39.5 39.5s17.7 39.5 39.5 39.5c14.6 0 27.4-8 34.2-19.8l-12.9-7.6z\"/><path d=\"M82.1 61.8h5.2v-5.3h4.4v5.3H97v4.4h-5.3v5.2h-4.4v-5.2h-5.2v-4.4zm18.5 0h5.2v-5.3h4.4v5.3h5.3v4.4h-5.3v5.2h-4.4v-5.2h-5.2v-4.4z\" fill=\"#fff\"/></svg>"

/***/ }),

/***/ "../src/components/cplusplus/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CplusplusOriginal = __webpack_require__("../src/components/cplusplus/original/CplusplusOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CplusplusOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cplusplus/plain/CplusplusPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CplusplusPlain = __webpack_require__("../src/components/cplusplus/plain/CplusplusPlain.svg");
	
	var _CplusplusPlain2 = _interopRequireDefault(_CplusplusPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CplusplusPlain */
	function CplusplusPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CplusplusPlain',
	    svg: _CplusplusPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CplusplusPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CplusplusPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cplusplus/plain/CplusplusPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#9C033A\" d=\"M117.5 33.5l.3-.2c-.6-1.1-1.5-2.1-2.4-2.6L67.1 2.9c-.8-.5-1.9-.7-3.1-.7-1.2 0-2.3.3-3.1.7l-48 27.9c-1.7 1-2.9 3.5-2.9 5.4v55.7c0 1.1.2 2.3.9 3.4l-.2.1c.5.8 1.2 1.5 1.9 1.9l48.2 27.9c.8.5 1.9.7 3.1.7 1.2 0 2.3-.3 3.1-.7l48-27.9c1.7-1 2.9-3.5 2.9-5.4V36.1c.1-.8 0-1.7-.4-2.6zM82 66v-4h5v-5h5v5h5v4h-5v5h-5v-5h-5zm3.3-14C81.1 44.5 73.1 39.5 64 39.5c-13.5 0-24.5 11-24.5 24.5s11 24.5 24.5 24.5c9.1 0 17.1-5 21.3-12.4l12.9 7.6c-6.8 11.8-19.6 19.8-34.2 19.8-21.8 0-39.5-17.7-39.5-39.5S42.2 24.5 64 24.5c14.7 0 27.5 8.1 34.3 20l-13 7.5zM115 66h-5v5h-4v-5h-6v-4h6v-5h4v5h5v4z\"/></svg>"

/***/ }),

/***/ "../src/components/cplusplus/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CplusplusPlain = __webpack_require__("../src/components/cplusplus/plain/CplusplusPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CplusplusPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/csharp/line/CsharpLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CsharpLine = __webpack_require__("../src/components/csharp/line/CsharpLine.svg");
	
	var _CsharpLine2 = _interopRequireDefault(_CsharpLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CsharpLine */
	function CsharpLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CsharpLine',
	    svg: _CsharpLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CsharpLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CsharpLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/csharp/line/CsharpLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M109 50h-4.8l-1.2 6h-3.8l1.2-6h-4.9l-1.2 6H89v5h4.4l-.9 4H89v5h2.5l-1.2 6h4.8l1.2-6h3.8l-1.2 6h4.9l1.2-6h5v-5h-4.1l.9-4h3.2v-5h-2.2l1.2-6zm-7.9 15h-3.8l.9-4h3.8l-.9 4zm15.4-32.7c-.6-1.1-1.4-2.1-2.3-2.6L66.1 1.9c-.8-.5-1.9-.7-3.1-.7-1.2 0-2.3.3-3.1.7L11.4 29.7c-1.7 1-3.4 3.5-3.4 5.4v55.7c0 1.1.7 2.3 1.4 3.4l.1.1c.5.8 1.3 1.5 2 1.9l48.3 27.9c.8.5 2 .7 3.2.7 1.2 0 2.3-.3 3.1-.7l47.5-27.9c1.7-1 2.4-3.5 2.4-5.4V35.1c0-.8.4-1.8 0-2.6l.5-.2zm-4.2 2.1c0 .3-.3.5-.3.7v55.7c0 .8-.2 1.7-.4 2L64 120.6c-.1.1-.5.2-1.1.2-.6 0-1-.1-1.1-.2L13.6 92.8s-.1-.1-.2-.1l-.6-.6c-.4-.7.2-1.1-.8-1.2V35.2c1-.5.9-1.7 1.4-1.9L61.7 5.4c.1 0 .6-.2 1.2-.2s1 .1 1.1.2l48 27.7.4.9c.1.1-.1.3-.1.4zM63 87.5c-13.5 0-24.5-11-24.5-24.5s11-24.5 24.5-24.5c9.1 0 17.1 5 21.3 12.5l13-7.5c-6.8-11.9-19.6-20-34.3-20-21.8 0-39.5 17.7-39.5 39.5s17.7 39.5 39.5 39.5c14.6 0 27.4-8 34.2-19.8l-12.9-7.6C80.1 82.5 72.1 87.5 63 87.5z\" fill=\"#68217A\"/></svg>"

/***/ }),

/***/ "../src/components/csharp/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CsharpLine = __webpack_require__("../src/components/csharp/line/CsharpLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CsharpLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/csharp/original/CsharpOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CsharpOriginal = __webpack_require__("../src/components/csharp/original/CsharpOriginal.svg");
	
	var _CsharpOriginal2 = _interopRequireDefault(_CsharpOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CsharpOriginal */
	function CsharpOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CsharpOriginal',
	    svg: _CsharpOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CsharpOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CsharpOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/csharp/original/CsharpOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#9B4F96\" d=\"M115.4 30.7L67.1 2.9c-.8-.5-1.9-.7-3.1-.7-1.2 0-2.3.3-3.1.7l-48 27.9c-1.7 1-2.9 3.5-2.9 5.4v55.7c0 1.1.2 2.4 1 3.5l106.8-62c-.6-1.2-1.5-2.1-2.4-2.7z\"/><path fill=\"#68217A\" d=\"M10.7 95.3c.5.8 1.2 1.5 1.9 1.9l48.2 27.9c.8.5 1.9.7 3.1.7 1.2 0 2.3-.3 3.1-.7l48-27.9c1.7-1 2.9-3.5 2.9-5.4V36.1c0-.9-.1-1.9-.6-2.8l-106.6 62z\"/><path fill=\"#fff\" d=\"M85.3 76.1C81.1 83.5 73.1 88.5 64 88.5c-13.5 0-24.5-11-24.5-24.5s11-24.5 24.5-24.5c9.1 0 17.1 5 21.3 12.5l13-7.5c-6.8-11.9-19.6-20-34.3-20-21.8 0-39.5 17.7-39.5 39.5s17.7 39.5 39.5 39.5c14.6 0 27.4-8 34.2-19.8l-12.9-7.6zM97 66.2l.9-4.3h-4.2v-4.7h5.1L100 51h4.9l-1.2 6.1h3.8l1.2-6.1h4.8l-1.2 6.1h2.4v4.7h-3.3l-.9 4.3h4.2v4.7h-5.1l-1.2 6h-4.9l1.2-6h-3.8l-1.2 6h-4.8l1.2-6h-2.4v-4.7H97zm4.8 0h3.8l.9-4.3h-3.8l-.9 4.3z\"/></svg>"

/***/ }),

/***/ "../src/components/csharp/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CsharpOriginal = __webpack_require__("../src/components/csharp/original/CsharpOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CsharpOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/csharp/plain/CsharpPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CsharpPlain = __webpack_require__("../src/components/csharp/plain/CsharpPlain.svg");
	
	var _CsharpPlain2 = _interopRequireDefault(_CsharpPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CsharpPlain */
	function CsharpPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CsharpPlain',
	    svg: _CsharpPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CsharpPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CsharpPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/csharp/plain/CsharpPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M117.5 33.5l.3-.2c-.6-1.1-1.5-2.1-2.4-2.6L67.1 2.9c-.8-.5-1.9-.7-3.1-.7-1.2 0-2.3.3-3.1.7l-48 27.9c-1.7 1-2.9 3.5-2.9 5.4v55.7c0 1.1.2 2.3.9 3.4l-.2.1c.5.8 1.2 1.5 1.9 1.9l48.2 27.9c.8.5 1.9.7 3.1.7 1.2 0 2.3-.3 3.1-.7l48-27.9c1.7-1 2.9-3.5 2.9-5.4V36.1c.1-.8 0-1.7-.4-2.6zm-53.5 70c-21.8 0-39.5-17.7-39.5-39.5S42.2 24.5 64 24.5c14.7 0 27.5 8.1 34.3 20l-13 7.5C81.1 44.5 73.1 39.5 64 39.5c-13.5 0-24.5 11-24.5 24.5s11 24.5 24.5 24.5c9.1 0 17.1-5 21.3-12.4l12.9 7.6c-6.8 11.8-19.6 19.8-34.2 19.8zM115 62h-3.2l-.9 4h4.1v5h-5l-1.2 6h-4.9l1.2-6h-3.8l-1.2 6h-4.8l1.2-6H94v-5h3.5l.9-4H94v-5h5.3l1.2-6h4.9l-1.2 6h3.8l1.2-6h4.8l-1.2 6h2.2v5zm-12.7 4h3.8l.9-4h-3.8z\" fill=\"#68217A\"/></svg>"

/***/ }),

/***/ "../src/components/csharp/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CsharpPlain = __webpack_require__("../src/components/csharp/plain/CsharpPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CsharpPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/css3/original-wordmark/Css3OriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _Css3OriginalWordmark = __webpack_require__("../src/components/css3/original-wordmark/Css3OriginalWordmark.svg");
	
	var _Css3OriginalWordmark2 = _interopRequireDefault(_Css3OriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Css3OriginalWordmark */
	function Css3OriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'Css3OriginalWordmark',
	    svg: _Css3OriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	Css3OriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = Css3OriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/css3/original-wordmark/Css3OriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#131313\" d=\"M89.234 5.856H81.85l7.679 8.333v3.967H73.713v-4.645h7.678l-7.678-8.333V1.207h15.521v4.649zm-18.657 0h-7.384l7.679 8.333v3.967H55.055v-4.645h7.679l-7.679-8.333V1.207h15.522v4.649zm-18.474.19h-7.968v7.271h7.968v4.839H38.471V1.207h13.632v4.839z\"/><path fill=\"#1572B6\" d=\"M27.613 116.706l-8.097-90.813h88.967l-8.104 90.798-36.434 10.102-36.332-10.087z\"/><path fill=\"#33A9DC\" d=\"M64.001 119.072l29.439-8.162 6.926-77.591H64.001v85.753z\"/><path fill=\"#fff\" d=\"M64 66.22h14.738l1.019-11.405H64V43.677h27.929l-.267 2.988-2.737 30.692H64V66.22z\"/><path fill=\"#EBEBEB\" d=\"M64.067 95.146l-.049.014-12.404-3.35-.794-8.883H39.641l1.561 17.488 22.814 6.333.052-.015V95.146z\"/><path fill=\"#fff\" d=\"M77.792 76.886L76.45 91.802l-12.422 3.353v11.588l22.833-6.328.168-1.882 1.938-21.647H77.792z\"/><path fill=\"#EBEBEB\" d=\"M64.039 43.677v11.137H37.136l-.224-2.503-.507-5.646-.267-2.988h27.901zM64 66.221v11.138H51.753l-.223-2.503-.508-5.647-.267-2.988H64z\"/></svg>"

/***/ }),

/***/ "../src/components/css3/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Css3OriginalWordmark = __webpack_require__("../src/components/css3/original-wordmark/Css3OriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Css3OriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/css3/original/Css3Original.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _Css3Original = __webpack_require__("../src/components/css3/original/Css3Original.svg");
	
	var _Css3Original2 = _interopRequireDefault(_Css3Original);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Css3Original */
	function Css3Original(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'Css3Original',
	    svg: _Css3Original2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	Css3Original.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = Css3Original;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/css3/original/Css3Original.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#1572B6\" d=\"M18.814 114.123L8.76 1.352h110.48l-10.064 112.754-45.243 12.543-45.119-12.526z\"/><path fill=\"#33A9DC\" d=\"M64.001 117.062l36.559-10.136 8.601-96.354h-45.16v106.49z\"/><path fill=\"#fff\" d=\"M64.001 51.429h18.302l1.264-14.163H64.001V23.435h34.682l-.332 3.711-3.4 38.114h-30.95V51.429z\"/><path fill=\"#EBEBEB\" d=\"M64.083 87.349l-.061.018-15.403-4.159-.985-11.031H33.752l1.937 21.717 28.331 7.863.063-.018v-14.39z\"/><path fill=\"#fff\" d=\"M81.127 64.675l-1.666 18.522-15.426 4.164v14.39l28.354-7.858.208-2.337 2.406-26.881H81.127z\"/><path fill=\"#EBEBEB\" d=\"M64.048 23.435v13.831H30.64l-.277-3.108-.63-7.012-.331-3.711h34.646zm-.047 27.996v13.831H48.792l-.277-3.108-.631-7.012-.33-3.711h16.447z\"/></svg>"

/***/ }),

/***/ "../src/components/css3/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Css3Original = __webpack_require__("../src/components/css3/original/Css3Original.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Css3Original).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/css3/plain-wordmark/Css3PlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _Css3PlainWordmark = __webpack_require__("../src/components/css3/plain-wordmark/Css3PlainWordmark.svg");
	
	var _Css3PlainWordmark2 = _interopRequireDefault(_Css3PlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Css3PlainWordmark */
	function Css3PlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'Css3PlainWordmark',
	    svg: _Css3PlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	Css3PlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = Css3PlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/css3/plain-wordmark/Css3PlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#1572B6\" d=\"M19.67 26l8.069 90.493 36.206 10.05 36.307-10.063L108.33 26H19.67zm69.21 50.488L86.53 98.38l.009 1.875L64 106.55v.001l-.018.015-22.719-6.225L39.726 83h11.141l.79 8.766 12.347 3.295-.004.015v-.032l12.394-3.495L77.702 77H51.795l-.222-2.355-.506-5.647L50.802 66h27.886l1.014-11H37.229l-.223-2.589-.506-6.03L36.235 43h55.597l-.267 3.334-2.685 30.154M89 14.374L81.851 6H89V1H73v4.363L81.39 13H73v5h16zm-19 0L63.193 6H70V1H55v4.363L62.733 13H55v5h15zM52 13h-8V6h8V1H38v17h14z\"/></svg>"

/***/ }),

/***/ "../src/components/css3/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Css3PlainWordmark = __webpack_require__("../src/components/css3/plain-wordmark/Css3PlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Css3PlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/css3/plain/Css3Plain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _Css3Plain = __webpack_require__("../src/components/css3/plain/Css3Plain.svg");
	
	var _Css3Plain2 = _interopRequireDefault(_Css3Plain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Css3Plain */
	function Css3Plain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'Css3Plain',
	    svg: _Css3Plain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	Css3Plain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = Css3Plain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/css3/plain/Css3Plain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#1572B6\" d=\"M8.76 1l10.055 112.883 45.118 12.58 45.244-12.626L119.24 1H8.76zm89.591 25.862l-3.347 37.605.01.203-.014.467v-.004l-2.378 26.294-.262 2.336L64 101.607v.001l-.022.019-28.311-7.888L33.75 72h13.883l.985 11.054 15.386 4.17-.004.008v-.002l15.443-4.229L81.075 65H48.792l-.277-3.043-.631-7.129L47.553 51h34.749l1.264-14H30.64l-.277-3.041-.63-7.131L29.401 23h69.281l-.331 3.862z\"/></svg>"

/***/ }),

/***/ "../src/components/css3/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Css3Plain = __webpack_require__("../src/components/css3/plain/Css3Plain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Css3Plain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cucumber/plain-wordmark/CucumberPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CucumberPlainWordmark = __webpack_require__("../src/components/cucumber/plain-wordmark/CucumberPlainWordmark.svg");
	
	var _CucumberPlainWordmark2 = _interopRequireDefault(_CucumberPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CucumberPlainWordmark */
	function CucumberPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CucumberPlainWordmark',
	    svg: _CucumberPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CucumberPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CucumberPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cucumber/plain-wordmark/CucumberPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 362.8 362.8\"><style>.st0{fill:#00a818}</style><title>cucumber-plain-wordmark</title><path id=\"Logos\" class=\"st0\" d=\"M315.2 188.5c-3.7 0-7.1 2-8.8 5.3 0-.8.4-1.8.4-2.5v-1.5h-7v34.9h7v-20.1c0-5.6 3.1-9.2 8.5-9.2h1.4v-7h-1.5v.1zM31.8 201.3c-1.8-3.2-5.1-5.2-8.8-5.2-6.1 0-11 5-11 11.1s4.9 11 11 11c3.6.1 7-1.9 8.8-5l6.4 3.8c-3.4 5.1-9.1 8.2-15.2 8.3-9.9.6-18.3-7-18.9-16.9-.6-9.9 7-18.3 16.9-18.9h2c6.2-.1 11.9 3 15.2 8.3l-6.4 3.5zm12.5-11h7.2v19c-.2 4.5 3.3 8.3 7.8 8.4h.4c4.6-.1 8.2-3.9 8.2-8.5v-19h7.2v19.6c.2 8.3-6.4 15.1-14.7 15.3h-.8c-8.3.3-15.2-6.2-15.5-14.4V190.3h.2zm65 11c-1.8-3.2-5.1-5.2-8.8-5.2-6.1 0-11 5-11 11.1s4.9 11 11 11c3.6.1 7-1.9 8.8-5l6.4 3.8c-3.4 5.1-9.1 8.2-15.2 8.3-9.9.6-18.3-7-18.9-16.9-.6-9.9 7-18.3 16.9-18.9h2c6.2-.1 11.9 3 15.2 8.3l-6.4 3.5zm12.5-11h7.2v19c-.2 4.5 3.3 8.3 7.8 8.4h.4c4.6-.1 8.2-3.9 8.2-8.5v-19h7.2v19.6c0 8.6-6.9 15.5-15.5 15.5s-15.5-6.9-15.5-15.5l.2-19.5zm40 12.7c0-8.7 5.6-13.6 12.4-13.6 4.3-.3 8.3 2.1 10.1 6 1.7-4 5.8-6.4 10.2-6 6.7 0 12.4 5 12.4 13.6v21.2h-7V203c.4-3.1-1.7-5.9-4.8-6.4-.3 0-.6-.1-.8-.1-3.5 0-6 2.1-6 7.4V224h-7.2v-20.2c0-5.3-2.5-7.4-6-7.4-3.1 0-5.7 2.5-5.7 5.6 0 .3 0 .6.1.8V224h-7.7v-21zm54.3-22.8h7.2v14.3c2.7-3.3 6.8-5.2 11-5 9.9 0 17.9 8 17.9 17.9 0 9.9-8 17.9-17.9 17.9-4.3.2-8.4-1.7-11-5v4.2h-7.2v-44.3zm17.7 16.1c-6.1-.2-11.2 4.5-11.5 10.6-.2 6.1 4.5 11.2 10.6 11.5s11.2-4.5 11.5-10.6v-.4c.3-5.8-4.2-10.7-10-11-.2-.1-.4-.1-.6-.1zm57.3 20.5c-3.7 5.1-9.5 8.1-15.8 8.3-9.8.4-18.1-7.3-18.5-17.1s7.3-18.1 17.1-18.5h1.4c10.1.4 18 8.9 17.6 19v1.3h-28c.7 5.2 5.1 9 10.3 9 3.9-.1 7.6-2.1 9.8-5.3l6.1 3.3zm-6.7-13.1c-1-4.7-5.2-8-10-8-4.7 0-8.7 3.4-9.6 8h19.6zm63.4-63.2l-1.3-.7-1.4-.7h-.5l-1.2-.5c-2.3-.8-4.7-1.1-7.1-1.1-12.6 0-22.9 10.3-22.9 22.9 0 10.9 7.8 20.4 18.5 22.4v6.6c13.7-2.1 25.8-12.9 26.7-27.2.7-8.7-3.5-17-10.8-21.7zm-16.9 5.6c.8-.1 1.6.2 2.1.9 1.8 2 1.9 4.9.4 7.1-2-.4-3.7-1.9-4.5-3.8-.3-.6-.4-1.2-.4-1.8.1-1.3 1.1-2.3 2.4-2.4zm-6.9 6.8h.4c.7 0 1.4.2 2 .5 1.9.8 3.3 2.4 3.8 4.3-1.7 1.2-4 1.4-5.9.6-.6-.3-1.1-.6-1.7-1-1.1-.7-1.4-2.2-.7-3.3.6-.8 1.4-1.3 2.1-1.1zm2.4 14.1c-.6.3-1.3.5-2 .5-1.4.1-2.6-.8-2.7-2.2-.1-.8.2-1.6.8-2.1.5-.4 1-.8 1.7-1 .7-.3 1.5-.5 2.3-.5 1.3 0 2.5.3 3.6 1-.4 1.9-1.7 3.4-3.5 4.1l-.2.2zm7.7 4.5c-.3.6-.6 1.1-1 1.7-1 1-2.6 1.1-3.7.1-.5-.5-.8-1.2-.8-1.9 0-.6.2-1.2.4-1.8.8-2 2.5-3.4 4.6-3.8 1.1 1.7 1.3 3.8.5 5.6v.1zm3.8-22.8c.3-.6.6-1.1 1-1.7.5-.6 1.3-1 2.2-.9 1.4.1 2.5 1.3 2.5 2.7 0 .6-.2 1.3-.4 1.8-.8 1.9-2.5 3.2-4.5 3.6-1.3-1.7-1.6-3.9-.6-5.8l-.2.3zm1.3 24.2c-1.8-2-1.9-4.9-.4-7.1 2 .4 3.7 1.8 4.6 3.6.3.6.4 1.2.4 1.8-.3 1.5-1.7 2.6-3.3 2.3-.5-.1-.9-.3-1.3-.6zm8.4-5.9c-.7 0-1.4-.2-2-.5-1.9-.8-3.3-2.4-3.8-4.3 1.1-.7 2.3-1.1 3.6-1 .8 0 1.5.2 2.3.5.6.3 1.1.6 1.7 1 1.1.8 1.3 2.3.5 3.4-.5.7-1.3 1.1-2.1 1l-.2-.1z\"/></svg>"

/***/ }),

/***/ "../src/components/cucumber/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CucumberPlainWordmark = __webpack_require__("../src/components/cucumber/plain-wordmark/CucumberPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CucumberPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cucumber/plain/CucumberPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _CucumberPlain = __webpack_require__("../src/components/cucumber/plain/CucumberPlain.svg");
	
	var _CucumberPlain2 = _interopRequireDefault(_CucumberPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** CucumberPlain */
	function CucumberPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'CucumberPlain',
	    svg: _CucumberPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	CucumberPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = CucumberPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/cucumber/plain/CucumberPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><style>.st0{fill:#00a818}</style><path class=\"st0\" d=\"M92.2 8.3c-1-.6-2-1.2-3-1.7l-3.3-1.5c-.4-.1-.7-.3-1.1-.4-1-.4-1.9-.8-2.9-1.1C76.5 1.8 70.8.9 64.8.9 34.3.9 9.7 25.6 9.7 56.1c0 26.9 19.2 49.2 44.5 54.2v15.8c32.9-5 62.1-31.2 64.3-65.6 1.3-20.8-9-42-26.3-52.2zM51.6 21.6c1.8-.2 3.8.5 5.1 2.1 1 1 1.6 2.3 2.3 3.7 2 4.7 1.3 9.8-1.4 13.5-4.7-1-9-4-11-8.7-.7-1.3-1.1-3.1-1.1-4.4.1-3.4 3-5.9 6.1-6.2zM35.1 37.9h1.1c1.7 0 3 .4 4.7 1.1 4.7 2 8.1 6 9.1 10.4-4 2.7-9.5 3.4-14.2 1.4-1.3-.7-2.6-1.4-4-2.4-4.4-3.6-2-10.3 3.3-10.5zm1.1 34.7c-6.1.3-9-6.7-4.6-10.4 1-1 2.3-1.7 4-2.4 1.8-.8 3.6-1.1 5.5-1.2 3.1-.1 6.1.8 8.6 2.5-.7 4.4-4 8.4-8.7 10.4-1.5.8-3.2 1.1-4.8 1.1zm23.2 9.8c-.7 1.3-1.3 2.7-2.3 4-3.4 4.4-11.2 1.3-10.8-4.4 0-1.3.4-3 1.1-4.3 2-4.7 6-7.7 10.7-8.7 2.6 4 3.3 9.1 1.3 13.4zm9.1-55c.7-1.3 1.3-2.7 2.3-4 1.4-1.6 3.4-2.3 5.3-2.1 3.1.3 6.1 2.8 5.9 6.4 0 1.3-.4 3.1-1.1 4.4-2 4.7-6 7.7-10.7 8.7-3-3.6-3.7-8.6-1.7-13.4zm3 59c-1-1-1.6-2.3-2.3-3.7-2-4.7-1.3-9.8 1.4-13.5 4.7 1 9 4 11 8.7.7 1.3 1.1 3.1 1.1 4.4.2 5.2-7.5 8.2-11.2 4.1zm20.6-14.1c-1.7 0-3-.4-4.7-1.1-4.7-2-8.1-6-9.1-10.4 2.5-1.7 5.6-2.6 8.7-2.5 1.8 0 3.7.4 5.5 1.2 1.3.7 2.6 1.3 4 2.3 4.6 3.4 1.6 10.9-4.4 10.5z\"/></svg>"

/***/ }),

/***/ "../src/components/cucumber/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CucumberPlain = __webpack_require__("../src/components/cucumber/plain/CucumberPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CucumberPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/d3js/original/D3jsOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _D3jsOriginal = __webpack_require__("../src/components/d3js/original/D3jsOriginal.svg");
	
	var _D3jsOriginal2 = _interopRequireDefault(_D3jsOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** D3jsOriginal */
	function D3jsOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'D3jsOriginal',
	    svg: _D3jsOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	D3jsOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = D3jsOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/d3js/original/D3jsOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"-201.009\" y1=\"376.844\" x2=\"-200.098\" y2=\"375.873\" gradientTransform=\"matrix(82.4907 0 0 -81.4303 16634.416 30700.326)\"><stop offset=\"0\" stop-color=\"#f9a03c\"/><stop offset=\"1\" stop-color=\"#f7974e\"/></linearGradient><path fill=\"url(#a)\" d=\"M126.334 90.59a37.18 37.18 0 0 0 .128-1.647C126.5 88.288 87.094 50.9 87.094 50.9h-.942s39.94 42.13 40.182 39.69z\"/><linearGradient id=\"b\" gradientUnits=\"userSpaceOnUse\" x1=\"-199.257\" y1=\"373.615\" x2=\"-197.514\" y2=\"371.916\" gradientTransform=\"matrix(40.2105 0 0 -40.4122 8003.203 15127)\"><stop offset=\"0\" stop-color=\"#f9a03c\"/><stop offset=\"1\" stop-color=\"#f7974e\"/></linearGradient><path fill=\"url(#b)\" d=\"M42.26 77.62a26.282 26.282 0 0 1-.328.702c-1.256 2.62 17.585 21.038 19.1 18.8.07-.098.14-.202.208-.3.077-.118.152-.23.228-.348 1.213-1.84-18.67-20.05-19.207-18.854z\"/><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"-199.836\" y1=\"374.252\" x2=\"-198.286\" y2=\"372.475\" gradientTransform=\"matrix(41.0403 0 0 -39.9333 8224.5 14997.683)\"><stop offset=\"0\" stop-color=\"#f9a03c\"/><stop offset=\"1\" stop-color=\"#f7974e\"/></linearGradient><path fill=\"url(#c)\" d=\"M68.886 103.52c-.053.118-.433.76-.78 1.098-.058.117 18.394 18.417 18.394 18.417h1.66c.002 0-17.32-18.74-19.274-19.514z\"/><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"-201.143\" y1=\"379.263\" x2=\"-200.795\" y2=\"378.804\" gradientTransform=\"matrix(255.8347 0 0 -242.016 51476.605 91789.102)\"><stop offset=\"0\" stop-color=\"#f26d58\"/><stop offset=\"1\" stop-color=\"#f9a03c\"/></linearGradient><path fill=\"url(#d)\" d=\"M126.488 88.61c-.863 19.13-16.69 34.425-36.024 34.425H87.85l-19.31-19.022a69.313 69.313 0 0 0 4.38-6.98h17.544c5.55 0 10.064-4.514 10.064-10.065 0-5.55-4.515-10.064-10.064-10.064H80.082A69.373 69.373 0 0 0 81.306 64c0-4.48-.44-8.852-1.26-13.1h6.45l39.88 39.295a48.62 48.62 0 0 0 .112-1.585zM11.962 4.772H1.472v26.003h10.49c18.32 0 33.23 14.903 33.23 33.225 0 4.984-1.113 9.716-3.088 13.964L61.24 96.82A58.882 58.882 0 0 0 71.2 64c0-32.658-26.574-59.228-59.236-59.228z\"/><linearGradient id=\"e\" gradientUnits=\"userSpaceOnUse\" x1=\"-200.962\" y1=\"378.553\" x2=\"-200.452\" y2=\"378.218\" gradientTransform=\"matrix(160.7307 0 0 -174.8133 32360.78 66184.883)\"><stop offset=\"0\" stop-color=\"#b84e51\"/><stop offset=\"1\" stop-color=\"#f68e48\"/></linearGradient><path fill=\"url(#e)\" d=\"M90.464 4.772H47.986a69.81 69.81 0 0 1 24.82 26.003h17.658c5.55 0 10.064 4.513 10.064 10.064 0 5.55-4.515 10.06-10.064 10.06h-3.968l39.88 39.296a36.65 36.65 0 0 0 .152-3.228c0-8.766-3.146-16.807-8.368-23.066 5.223-6.256 8.368-14.3 8.368-23.063 0-19.887-16.177-36.068-36.064-36.068z\"/><linearGradient id=\"f\" gradientUnits=\"userSpaceOnUse\" x1=\"-200.619\" y1=\"377.137\" x2=\"-200.595\" y2=\"376.532\" gradientTransform=\"matrix(176.7653 0 0 -92.6293 35504.598 35022.56)\"><stop offset=\"0\" stop-color=\"#f9a03c\"/><stop offset=\"1\" stop-color=\"#f7974e\"/></linearGradient><path fill=\"url(#f)\" d=\"M87.85 123.035H48.29a69.95 69.95 0 0 0 20.25-19.022l19.31 19.022zM61.24 96.82L42.106 77.965c-5.287 11.362-16.807 19.264-30.143 19.264H1.472v26h10.49c20.53 0 38.648-10.5 49.28-26.407z\"/></svg>"

/***/ }),

/***/ "../src/components/d3js/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _D3jsOriginal = __webpack_require__("../src/components/d3js/original/D3jsOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_D3jsOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/d3js/plain/D3jsPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _D3jsPlain = __webpack_require__("../src/components/d3js/plain/D3jsPlain.svg");
	
	var _D3jsPlain2 = _interopRequireDefault(_D3jsPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** D3jsPlain */
	function D3jsPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'D3jsPlain',
	    svg: _D3jsPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	D3jsPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = D3jsPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/d3js/plain/D3jsPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"85.24\" y1=\"97.604\" x2=\"91.053\" y2=\"-49.515\"><stop offset=\"0\" stop-color=\"#f9a03c\"/><stop offset=\"1\" stop-color=\"#f7974e\"/></linearGradient><path fill=\"url(#a)\" d=\"M118.16 63.966c5.223-6.256 8.368-14.217 8.368-22.98C126.528 21.097 110.352 5 90.464 5H47.986c10.375 7 18.966 16 24.82 26h17.658c5.55 0 10.064 4.45 10.064 10s-4.515 10-10.064 10H80.047c.82 5 1.26 8.62 1.26 13.098 0 4.41-.433 8.902-1.224 12.902h10.382c5.55 0 10.064 4.95 10.064 10.5S96.013 98 90.464 98H72.92c-1.315 2-2.79 4.74-4.38 6.98C63.137 112.59 56.253 119 48.29 124h42.173c19.335 0 35.16-15.746 36.024-34.876-.017.31-.043.39-.066.698.062-.848.107-1.813.107-2.678-.002-8.766-3.148-16.92-8.37-23.178z\"/><linearGradient id=\"b\" gradientUnits=\"userSpaceOnUse\" x1=\"33.627\" y1=\"97.714\" x2=\"39.382\" y2=\"-47.925\"><stop offset=\"0\" stop-color=\"#f9a03c\"/><stop offset=\"1\" stop-color=\"#f7974e\"/></linearGradient><path fill=\"url(#b)\" d=\"M61.03 97.543l.003-.18c.07-.1.138-.292.207-.39.077-.118.152-.275.228-.392.002-.002 0-.03.003-.034 6.14-9.33 9.727-20.41 9.727-32.39C71.197 31.5 44.624 5 11.962 5H1v26h10.962c18.32 0 33.23 14.823 33.23 33.144 0 4.984-1.113 9.675-3.088 13.924-.006.013-.013.36-.02.374C36.79 89.782 25.283 98 11.963 98H1v26h10.962c20.396 0 38.41-10.722 49.068-26.457z\"/></svg>"

/***/ }),

/***/ "../src/components/d3js/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _D3jsPlain = __webpack_require__("../src/components/d3js/plain/D3jsPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_D3jsPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/debian/original-wordmark/DebianOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DebianOriginalWordmark = __webpack_require__("../src/components/debian/original-wordmark/DebianOriginalWordmark.svg");
	
	var _DebianOriginalWordmark2 = _interopRequireDefault(_DebianOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DebianOriginalWordmark */
	function DebianOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DebianOriginalWordmark',
	    svg: _DebianOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DebianOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DebianOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/debian/original-wordmark/DebianOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#A80030\" d=\"M69.687 42.927c-1.289.018.243.663 1.926.923.467-.364.886-.73 1.263-1.087-1.048.257-2.114.262-3.189.164m6.917-1.724c.771-1.061 1.33-2.221 1.527-3.419-.174.854-.636 1.591-1.074 2.372-2.409 1.518-.228-.9-.002-1.823-2.589 3.265-.356 1.958-.451 2.87m2.557-6.649c.157-2.321-.457-1.586-.663-.701.24.125.431 1.637.663.701M64.795 2.819c.689.123 1.488.217 1.373.383.756-.167.926-.318-1.373-.383m1.374.383l-.483.101.451-.043.032-.058m21.46 32.233c.077 2.085-.609 3.098-1.229 4.89l-1.115.555c-.912 1.772.091 1.125-.563 2.534-1.425 1.266-4.319 3.959-5.246 4.206-.677-.014.458-.798.607-1.105-1.906 1.308-1.53 1.964-4.445 2.76l-.085-.191c-7.188 3.383-17.173-3.319-17.043-12.463-.075.581-.218.435-.377.668-.37-4.704 2.173-9.428 6.464-11.361 4.195-2.075 9.115-1.225 12.119 1.58-1.649-2.163-4.938-4.455-8.829-4.243-3.815.063-7.385 2.486-8.575 5.119-1.954 1.229-2.182 4.742-3.033 5.386-1.146 8.421 2.155 12.059 7.741 16.339.876.592.246.683.364 1.134-1.856-.868-3.554-2.18-4.951-3.786.742 1.084 1.541 2.139 2.576 2.967-1.751-.591-4.088-4.24-4.77-4.388 3.016 5.4 12.234 9.47 17.064 7.45-2.236.083-5.073.046-7.583-.882-1.057-.542-2.488-1.665-2.232-1.874 6.589 2.46 13.394 1.862 19.095-2.708 1.451-1.13 3.035-3.052 3.493-3.078-.688 1.038.118.499-.412 1.415 1.443-2.331-.628-.95 1.493-4.024l.784 1.079c-.294-1.937 2.403-4.285 2.129-7.345.618-.936.688 1.008.033 3.16.91-2.388.241-2.771.474-4.743.251.663.585 1.367.755 2.066-.593-2.308.607-3.885.905-5.227-.295-.129-.915 1.02-1.059-1.705.021-1.185.33-.621.448-.912-.23-.134-.841-1.042-1.211-2.782.267-.41.718 1.06 1.084 1.12-.236-1.383-.641-2.438-.658-3.501-1.069-2.234-.378.299-1.244-.959-1.14-3.55.943-.824 1.085-2.436 1.725 2.498 2.706 6.372 3.16 7.977-.346-1.956-.902-3.852-1.583-5.686.526.222-.845-4.023.683-1.212-1.629-5.993-6.971-11.593-11.885-14.219.601.55 1.358 1.24 1.088 1.349-2.445-1.454-2.017-1.569-2.366-2.183-1.989-.81-2.122.067-3.438.002-3.753-1.992-4.476-1.781-7.93-3.026l.156.735c-2.486-.828-2.896.312-5.583.001-.163-.126.861-.462 1.705-.583-2.403.316-2.292-.476-4.644.086.578-.407 1.192-.677 1.811-1.022-1.959.119-4.68 1.141-3.841.21-3.196 1.428-8.875 3.43-12.063 6.418l-.1-.669c-1.459 1.752-6.367 5.234-6.759 7.506l-.391.091c-.758 1.286-1.25 2.744-1.853 4.067-.993 1.694-1.457.652-1.315.918-1.954 3.962-2.927 7.292-3.765 10.023.597.893.015 5.377.239 8.966-.979 17.728 12.441 34.938 27.112 38.91 2.15.771 5.348.744 8.067.819-3.208-.918-3.622-.485-6.75-1.575-2.254-1.063-2.748-2.276-4.346-3.663l.633 1.117c-3.133-1.108-1.822-1.372-4.371-2.179l.676-.88c-1.016-.077-2.689-1.711-3.147-2.617l-1.111.044c-1.334-1.645-2.046-2.833-1.993-3.753l-.359.64c-.405-.698-4.91-6.177-2.574-4.901-.434-.396-1.011-.645-1.636-1.782l.475-.543c-1.122-1.447-2.068-3.301-1.996-3.92.6.81 1.016.962 1.428 1.101-2.84-7.045-2.999-.388-5.148-7.171l.454-.035c-.349-.527-.562-1.096-.841-1.657l.198-1.971c-2.043-2.361-.571-10.049-.275-14.264.203-1.714 1.706-3.539 2.848-6.4l-.695-.12c1.33-2.319 7.595-9.317 10.498-8.958 1.405-1.767-.28-.008-.555-.451 3.088-3.196 4.059-2.258 6.143-2.833 2.246-1.333-1.928.521-.864-.508 3.886-.991 2.753-2.256 7.821-2.759.535.304-1.241.47-1.686.864 3.235-1.584 10.241-1.223 14.795.879 5.277 2.469 11.211 9.762 11.446 16.625l.267.071c-.134 2.729.418 5.885-.541 8.782l.648-1.376m-32.017 9.262l-.182.903c.848 1.152 1.521 2.399 2.603 3.296-.779-1.516-1.357-2.144-2.421-4.199m2.002-.077c-.448-.497-.712-1.095-1.012-1.689.285 1.045.868 1.943 1.41 2.858l-.398-1.169m35.451-7.706l-.189.476a22.912 22.912 0 0 1-2.247 7.17c1.27-2.388 2.089-5 2.436-7.646M65.052 2.2c.871-.318 2.143-.175 3.068-.385-1.206.102-2.406.161-3.591.313l.523.072M34.444 18.475c.201 1.859-1.398 2.582.354 1.354.94-2.117-.365-.583-.354-1.354m-2.06 8.607c.404-1.239.478-1.984.631-2.702-1.116 1.428-.514 1.732-.631 2.702\"/><path d=\"M28.672 110.113c-.039.041-.039 6.477-.12 8.157-.079 1.358-.199 4.277-3.078 4.277-2.959 0-3.679-3.399-3.918-4.877-.28-1.639-.28-3-.28-3.599 0-1.919.12-7.279 4.639-7.279 1.359 0 2.119.401 2.719.72l.038 2.601zm-11.595 4.719c0 11.275 5.998 11.275 6.877 11.275 2.479 0 4.079-1.36 4.758-3.718l.081 3.558c.76-.041 1.519-.121 2.759-.121.439 0 .798 0 1.119.041.32 0 .64.039 1 .08-.64-1.279-1.12-4.158-1.12-10.397 0-6.077 0-16.353.52-19.472-1.438.681-2.679 1.121-5.397 1.36 1.079 1.16 1.079 1.76 1.079 7.036-.759-.238-1.719-.519-3.358-.519-7.159 0-8.318 6.237-8.318 10.877m21.684-2.041c.041-3.318.721-6.278 3.56-6.278 3.119 0 3.356 3.438 3.277 6.278h-6.837zm10.795.401c0-4.679-.918-9.277-6.837-9.277-8.155 0-8.155 9.038-8.155 10.956 0 8.116 3.638 11.314 9.756 11.314 2.717 0 4.038-.397 4.758-.599-.04-1.439.159-2.359.401-3.598-.841.521-1.921 1.2-4.319 1.2-6.238 0-6.318-5.68-6.318-7.638H49.48l.076-2.358m13.008 1.719c0 3.718-.68 8.716-5.317 8.716-.641 0-1.439-.121-1.959-.24-.08-1.439-.08-3.919-.08-6.797 0-3.44.359-5.236.641-6.118.839-2.837 2.718-2.877 3.076-2.877 3.039 0 3.639 4.198 3.639 7.316zM51.09 119.27c0 2.959 0 4.638-.479 5.917 1.639.639 3.677.998 6.117.998 1.56 0 6.077 0 8.516-4.997 1.16-2.319 1.56-5.438 1.56-7.797 0-1.44-.16-4.597-1.319-6.598-1.118-1.877-2.918-2.838-4.836-2.838-3.84 0-4.958 3.199-5.558 4.839 0-2.039.039-9.157.357-12.795-2.598 1.2-4.198 1.399-5.916 1.559 1.559.639 1.559 3.28 1.559 11.877v9.835m23.398 6.677c-.801-.121-1.361-.201-2.521-.201-1.277 0-2.158.081-3.077.201.399-.76.56-1.121.68-3.719.16-3.56.2-13.076-.08-15.075-.2-1.521-.559-1.76-1.118-2.159 3.277-.32 4.197-.56 5.717-1.279-.319 1.758-.361 2.641-.361 5.317-.081 13.797-.121 15.275.76 16.915m12.804-11.318c-.079 2.52-.12 4.28-.8 5.678-.841 1.8-2.24 2.319-3.278 2.319-2.402 0-2.92-1.999-2.92-3.957 0-3.759 3.359-4.041 4.877-4.041h2.121zm-10.997 4.92c0 2.52.76 5.038 3.001 6.118.998.44 1.998.44 2.319.44 3.679 0 4.918-2.72 5.678-4.399-.04 1.759 0 2.838.12 4.239.719-.041 1.438-.121 2.64-.121.679 0 1.318.08 1.998.121-.44-.679-.68-1.081-.801-2.64-.079-1.519-.079-3.038-.079-5.158l.04-8.156c0-3.04-.801-6.039-6.799-6.039-3.957 0-6.275 1.2-7.436 1.8.48.88.881 1.637 1.24 3.36 1.561-1.36 3.6-2.08 5.677-2.08 3.321 0 3.321 2.199 3.321 5.317-.76-.04-1.401-.119-2.481-.119-5.079.001-8.438 1.958-8.438 7.317m34.027 2.439c.041 1.36.041 2.799.6 3.959-.88-.08-1.4-.2-3.037-.2-.961 0-1.48.081-2.241.2.159-.519.241-.72.32-1.401.121-.917.2-3.998.2-5.078v-4.318c0-1.879 0-4.599-.122-5.559-.079-.678-.277-2.518-2.599-2.518-2.278 0-3.038 1.679-3.318 3.039-.318 1.399-.318 2.919-.318 8.836.038 5.118.038 5.597.438 6.998-.68-.08-1.52-.159-2.718-.159-.961 0-1.601.039-2.398.159.279-.641.439-.961.519-3.199.082-2.199.241-12.996-.121-15.554-.199-1.56-.6-1.919-1.038-2.319 3.239-.161 4.277-.681 5.278-1.199v4.237c.479-1.241 1.479-4 5.478-4 4.999 0 5.037 3.639 5.078 6.036v12.04\"/><path fill=\"#A80030\" d=\"M74.827 98.056l-3.313 3.31-3.31-3.31 3.31-3.31 3.313 3.31\"/></svg>"

/***/ }),

/***/ "../src/components/debian/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DebianOriginalWordmark = __webpack_require__("../src/components/debian/original-wordmark/DebianOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DebianOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/debian/original/DebianOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DebianOriginal = __webpack_require__("../src/components/debian/original/DebianOriginal.svg");
	
	var _DebianOriginal2 = _interopRequireDefault(_DebianOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DebianOriginal */
	function DebianOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DebianOriginal',
	    svg: _DebianOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DebianOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DebianOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/debian/original/DebianOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#A80030\" d=\"M73.776 67.531c-2.065.028.391 1.063 3.087 1.479a27.453 27.453 0 0 0 2.023-1.741c-1.679.41-3.387.419-5.11.262m11.086-2.763c1.229-1.697 2.127-3.556 2.442-5.478-.276 1.369-1.019 2.553-1.72 3.801-3.86 2.431-.363-1.443-.002-2.916-4.15 5.225-.57 3.133-.72 4.593m4.093-10.648c.249-3.72-.733-2.544-1.063-1.125.384.201.69 2.622 1.063 1.125M65.944 3.283c1.102.198 2.381.35 2.202.612 1.206-.263 1.48-.506-2.202-.612m2.202.613l-.779.161.725-.064.054-.097m34.372 51.634c.123 3.34-.978 4.961-1.969 7.829l-1.786.892c-1.46 2.838.142 1.802-.903 4.059-2.281 2.027-6.921 6.345-8.406 6.738-1.084-.023.734-1.278.972-1.771-3.052 2.098-2.449 3.147-7.118 4.422l-.136-.305c-11.516 5.417-27.51-5.318-27.299-19.966-.123.931-.349.697-.605 1.074-.594-7.537 3.481-15.107 10.353-18.196 6.722-3.329 14.602-1.963 19.417 2.524-2.644-3.465-7.909-7.137-14.148-6.793-6.111.097-11.828 3.98-13.735 8.196-3.132 1.972-3.495 7.6-4.859 8.628-1.835 13.491 3.453 19.318 12.398 26.175 1.407.949.396 1.093.587 1.815-2.972-1.392-5.694-3.493-7.931-6.065 1.186 1.739 2.468 3.429 4.125 4.756-2.803-.949-6.546-6.79-7.64-7.028 4.832 8.649 19.599 15.169 27.333 11.935-3.579.131-8.124.073-12.145-1.413-1.688-.869-3.984-2.669-3.574-3.007 10.553 3.944 21.456 2.988 30.586-4.333 2.323-1.81 4.861-4.887 5.594-4.93-1.105 1.661.188.8-.66 2.266 2.316-3.733-1.005-1.521 2.394-6.448l1.256 1.729c-.467-3.098 3.848-6.861 3.41-11.762.99-1.499 1.104 1.612.054 5.061 1.457-3.825.384-4.44.759-7.597.404 1.062.935 2.188 1.208 3.308-.95-3.696.975-6.226 1.45-8.373-.467-.208-1.464 1.634-1.692-2.732.034-1.896.528-.993.718-1.46-.373-.215-1.349-1.668-1.944-4.456.431-.655 1.151 1.698 1.739 1.795-.378-2.217-1.028-3.907-1.053-5.609-1.713-3.579-.606.478-1.996-1.536-1.823-5.687 1.513-1.32 1.738-3.903 2.763 4.003 4.339 10.208 5.062 12.777-.552-3.133-1.443-6.168-2.532-9.105.839.354-1.352-6.446 1.091-1.943-2.609-9.6-11.166-18.569-19.038-22.778.962.881 2.179 1.989 1.743 2.162-3.915-2.331-3.227-2.513-3.787-3.498-3.19-1.297-3.399.104-5.511.003-6.012-3.188-7.171-2.85-12.703-4.848l.252 1.177c-3.984-1.327-4.641.503-8.945.004-.263-.205 1.379-.74 2.73-.937-3.85.508-3.67-.759-7.438.14.929-.651 1.909-1.082 2.9-1.637-3.139.191-7.495 1.828-6.151.339-5.121 2.286-14.218 5.493-19.322 10.28l-.161-1.073c-2.339 2.809-10.2 8.387-10.826 12.022l-.625.146c-1.218 2.06-2.004 4.396-2.97 6.517-1.592 2.713-2.334 1.044-2.107 1.469-3.132 6.349-4.687 11.683-6.03 16.057.958 1.432.022 8.614.385 14.364-1.572 28.394 19.928 55.962 43.43 62.329 3.445 1.23 8.567 1.184 12.924 1.311-5.141-1.471-5.806-.778-10.813-2.525-3.614-1.701-4.405-3.644-6.964-5.864l1.014 1.79c-5.019-1.775-2.918-2.198-7.002-3.491l1.083-1.412c-1.627-.123-4.309-2.74-5.042-4.191l-1.779.07c-2.138-2.638-3.277-4.538-3.194-6.011l-.575 1.024c-.652-1.119-7.865-9.893-4.123-7.85-.696-.637-1.62-1.035-2.622-2.856l.762-.871c-1.802-2.316-3.315-5.287-3.2-6.276.96 1.298 1.627 1.54 2.287 1.763-4.548-11.285-4.803-.622-8.248-11.487l.729-.059c-.559-.842-.898-1.756-1.347-2.652l.316-3.161c-3.274-3.786-.916-16.098-.443-22.851.328-2.746 2.733-5.669 4.563-10.252l-1.114-.192c2.131-3.717 12.167-14.928 16.815-14.351 2.251-2.829-.446-.011-.886-.723 4.945-5.119 6.5-3.617 9.838-4.537 3.6-2.137-3.089.833-1.383-.815 6.223-1.589 4.41-3.613 12.528-4.42.857.487-1.987.752-2.701 1.385 5.185-2.536 16.408-1.959 23.697 1.408 8.458 3.952 17.961 15.638 18.336 26.631l.427.114c-.216 4.37.669 9.424-.865 14.066l1.043-2.201M51.233 70.366l-.29 1.448c1.357 1.845 2.435 3.843 4.167 5.283-1.246-2.434-2.173-3.44-3.877-6.731m3.208-.126c-.718-.795-1.144-1.751-1.62-2.704.456 1.675 1.388 3.114 2.255 4.578l-.635-1.874m56.785-12.343l-.304.762a36.72 36.72 0 0 1-3.599 11.487 36.107 36.107 0 0 0 3.903-12.249M66.353 2.293c1.396-.513 3.433-.281 4.914-.617-1.93.162-3.852.259-5.75.503l.836.114M17.326 28.362c.322 2.979-2.242 4.135.567 2.171 1.506-3.39-.588-.935-.567-2.171M14.025 42.15c.646-1.986.764-3.18 1.011-4.328-1.788 2.285-.823 2.773-1.011 4.328\"/></svg>"

/***/ }),

/***/ "../src/components/debian/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DebianOriginal = __webpack_require__("../src/components/debian/original/DebianOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DebianOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/debian/plain-wordmark/DebianPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DebianPlainWordmark = __webpack_require__("../src/components/debian/plain-wordmark/DebianPlainWordmark.svg");
	
	var _DebianPlainWordmark2 = _interopRequireDefault(_DebianPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DebianPlainWordmark */
	function DebianPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DebianPlainWordmark',
	    svg: _DebianPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DebianPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DebianPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/debian/plain-wordmark/DebianPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#A80030\" d=\"M71.439 43.961c.464-.362.88-.726 1.254-1.08-1.04.255-2.1.26-3.168.163-1.281.018.242.659 1.914.917zm4.959-2.63c.765-1.055 1.322-2.206 1.518-3.397-.172.848-.632 1.58-1.066 2.355-2.395 1.509-.227-.895-.002-1.811-2.574 3.245-.356 1.946-.45 2.853zm2.541-6.606c.155-2.307-.454-1.575-.659-.697.239.124.428 1.626.659.697zM64.666 3.194c.684.122 1.479.216 1.364.38.75-.166.92-.315-1.364-.38zm1.333.438l.031-.058-.48.101zm-1.665 47.236l.019-.06-.019.06zm-.079.438c-1.844-.862-3.531-2.166-4.92-3.761.738 1.076 1.533 2.124 2.561 2.947-1.74-.587-4.062-4.212-4.739-4.359 2.997 5.365 12.155 9.409 16.954 7.402-2.221.083-5.04.046-7.533-.877-.963-.494-2.234-1.47-2.244-1.79-.047.125-.128.25-.079.438zm27.617-21.484c.021-1.178.328-.617.445-.906-.229-.134-.836-1.035-1.203-2.765.265-.407.713 1.054 1.076 1.112-.234-1.374-.636-2.422-.653-3.479-1.063-2.22-.376.297-1.237-.953-1.132-3.526.938-.818 1.079-2.42 1.712 2.481 2.688 6.331 3.14 7.926-.344-1.943-.896-3.827-1.573-5.65.522.222-.839-3.996.678-1.204-1.619-5.954-6.925-11.518-11.808-14.127.597.546 1.35 1.231 1.081 1.34-2.429-1.445-2.003-1.559-2.351-2.169-1.977-.806-2.108.065-3.416.002-3.729-1.979-4.448-1.77-7.88-3.007l.156.73c-2.47-.822-2.877.31-5.546.001-.163-.126.855-.459 1.694-.579-2.389.314-2.277-.473-4.614.086.575-.404 1.186-.673 1.798-1.016-1.946.118-4.649 1.134-3.815.209-3.176 1.419-8.817 3.408-11.984 6.377l-.1-.665c-1.45 1.741-6.326 5.201-6.715 7.458l-.388.09c-.753 1.278-1.242 2.727-1.841 4.041-.988 1.683-1.448.648-1.307.912-1.942 3.937-2.908 7.244-3.739 9.959.592.887.013 5.342.237 8.907-.974 17.613 12.361 34.713 26.937 38.66 2.137.766 5.313.738 8.015.813-3.188-.912-3.599-.482-6.706-1.565-2.24-1.056-2.731-2.261-4.318-3.639l.629 1.11c-3.111-1.102-1.81-1.363-4.343-2.165l.671-.874c-1.009-.077-2.672-1.7-3.127-2.601l-1.104.044c-1.325-1.635-2.033-2.815-1.98-3.729l-.356.636c-.403-.693-4.879-6.137-2.558-4.87-.431-.393-1.004-.641-1.626-1.771l.473-.539c-1.115-1.438-2.056-3.28-1.983-3.895.595.804 1.008.955 1.418 1.094-2.822-7-2.979-.386-5.116-7.126l.452-.035c-.346-.523-.558-1.089-.836-1.646l.198-1.959c-2.03-2.346-.567-9.983-.273-14.171.201-1.703 1.695-3.517 2.829-6.359l-.691-.119c1.322-2.304 7.546-9.258 10.43-8.901 1.396-1.754-.278-.008-.551-.447 3.068-3.175 4.033-2.243 6.103-2.815 2.232-1.324-1.916.519-.858-.504 3.861-.985 2.735-2.242 7.771-2.742.532.302-1.232.467-1.675.859 3.215-1.574 10.176-1.215 14.7.873 5.244 2.452 11.139 9.699 11.373 16.518l.265.07c-.133 2.711.415 5.847-.538 8.726l.644-1.364c.077 2.071-.604 3.078-1.22 4.857l-1.108.552c-.906 1.761.09 1.118-.559 2.518-1.416 1.258-4.292 3.935-5.213 4.18-.672-.014.456-.793.604-1.098-1.894 1.3-1.52 1.951-4.417 2.742l-.084-.19c-7.142 3.362-17.062-3.297-16.933-12.382-.075.576-.216.433-.374.664-.368-4.673 2.158-9.367 6.422-11.287 4.169-2.063 9.056-1.218 12.041 1.569-1.639-2.149-4.905-4.427-8.773-4.216-3.79.062-7.336 2.469-8.519 5.085-1.942 1.222-2.167 4.712-3.013 5.352-1.14 8.367 2.141 11.981 7.691 16.234.448.303.499.474.459.629l.007-.012c6.546 2.443 13.307 1.85 18.971-2.69 1.441-1.122 3.016-3.032 3.471-3.059-.685 1.032.118.496-.409 1.406 1.435-2.316-.624-.943 1.484-3.999l.779 1.071c-.292-1.924 2.387-4.257 2.115-7.298.614-.929.685 1.002.033 3.14.905-2.372.24-2.753.471-4.712.249.659.581 1.357.75 2.053-.589-2.293.603-3.86.899-5.193-.3-.128-.916 1.014-1.058-1.693zM55.361 45.699c.842 1.145 1.511 2.384 2.585 3.275-.773-1.507-1.347-2.131-2.404-4.173l-.181.898zm2.17-.974c-.445-.493-.708-1.088-1.005-1.678.284 1.038.862 1.931 1.4 2.84l-.395-1.162zm32.802-.059a22.42 22.42 0 0 0 2.42-7.598l-.188.473a22.737 22.737 0 0 1-2.232 7.125zM67.969 2.196c-1.199.101-2.391.16-3.568.312l.519.071c.866-.316 2.128-.174 3.049-.383zM34.518 18.84l-.007-.091.007.091zm.343 1.255c.891-2.006-.246-.715-.344-1.255.14 1.779-1.367 2.454.344 1.255zm-2.398 7.206c.402-1.231.474-1.972.627-2.685-1.108 1.418-.51 1.721-.627 2.685zm.682 68.551c-1.429.677-2.662 1.113-5.363 1.352 1.072 1.151 1.072 1.748 1.072 6.99-.753-.237-1.708-.516-3.337-.516-7.111 0-8.263 6.197-8.263 10.808 0 11.202 5.959 11.202 6.833 11.202 2.463 0 4.053-1.352 4.728-3.694l.08 3.535c.755-.041 1.509-.12 2.741-.12.437 0 .793 0 1.112.041.318 0 .635.038.994.079-.636-1.271-1.113-4.131-1.113-10.33 0-6.039 0-16.248.516-19.347zm-4.489 22.049c-.078 1.349-.198 4.249-3.058 4.249-2.94 0-3.656-3.377-3.893-4.846-.278-1.628-.278-2.98-.278-3.575 0-1.906.119-7.231 4.608-7.231 1.352 0 2.106.398 2.701.715l.04 2.583c-.041.041-.041 6.435-.12 8.105zm14.076-14.263c-8.104 0-8.104 8.98-8.104 10.886 0 8.063 3.615 11.241 9.693 11.241 2.7 0 4.012-.395 4.728-.595-.04-1.43.158-2.344.398-3.575-.836.518-1.908 1.093-4.292 1.093-6.197 0-6.278-5.688-6.278-7.688h10.569l.077-2.243c.001-4.648-.912-9.119-6.791-9.119zm2.86 9.362h-6.793c.041-3 .717-6.237 3.536-6.237 3.1 0 3.335 3.237 3.257 6.237zm14.952-9.322c-3.814 0-4.926 3.179-5.521 4.808 0-2.026.039-9.098.355-12.713-2.581 1.192-4.196 1.39-5.902 1.549 1.548.634 1.524 3.258 1.524 11.8V119h.048c0 3 0 4.555-.476 5.826 1.628.635 3.653.966 6.078.966 1.549 0 6.038-.014 8.461-4.979 1.152-2.305 1.549-5.41 1.549-7.754 0-1.431-.159-4.572-1.311-6.558-1.111-1.866-2.899-2.823-4.805-2.823zm-3.378 19.546c-.636 0-1.43-.12-1.945-.239-.08-1.43-.08-3.894-.08-6.753 0-3.418.357-5.202.636-6.078.833-2.82 2.701-2.858 3.058-2.858 3.02 0 3.615 4.171 3.615 7.269-.001 3.693-.676 8.659-5.284 8.659zm16.375-14.501c0-2.66.042-3.537.358-5.284-1.509.716-2.422.954-5.679 1.271.556.397.913.634 1.111 2.146.278 1.986.237 11.441.079 14.978-.119 2.581-.278 2.94-.675 3.695.913-.119 1.789-.2 3.058-.2 1.152 0 1.709.08 2.505.2-.876-1.631-.837-3.098-.757-16.806zm17.331 9.057l.041-8.104c0-3.021-.796-5.999-6.755-5.999-3.932 0-6.236 1.191-7.388 1.788.478.874.875 1.626 1.232 3.338 1.55-1.351 3.576-2.066 5.64-2.066 3.3 0 3.3 2.185 3.3 5.282-.755-.039-1.392-.118-2.465-.118-5.047.002-8.384 1.945-8.384 7.271 0 2.504.755 5.005 2.981 6.078.993.438 1.985.438 2.304.438 3.655 0 4.886-2.703 5.642-4.371-.04 1.748 0 2.819.119 4.212.715-.041 1.43-.12 2.624-.12.675 0 1.31.079 1.985.12-.437-.675-.675-1.074-.795-2.623-.081-1.51-.081-3.019-.081-5.126zm-4.649 2.003c-.834 1.788-2.225 2.376-3.257 2.376-2.386 0-2.9-2.093-2.9-4.039 0-3.734 3.338-4.121 4.846-4.121h2.107c-.079 3.001-.12 4.394-.796 5.784zM110 121.595v-11.961c0-2.382-.335-5.997-5.302-5.997-3.974 0-4.698 2.74-5.698 3.974v-4.21c-1 .516-1.819 1.032-5.037 1.192.435.396.936.753 1.134 2.304.36 2.541.253 13.268.172 15.453-.079 2.224-.212 2.542-.49 3.179.793-.12 1.441-.158 2.396-.158 1.192 0 2.032.079 2.706.158-.396-1.393-.394-1.867-.432-6.952 0-5.88.001-7.39.318-8.78.278-1.351 1.034-3.019 3.298-3.019 2.307 0 2.62 1.828 2.698 2.501.122.953.237 3.656.237 5.523v4.289c0 1.073-.195 4.134-.315 5.045-.078.677-.218.877-.376 1.393.757-.118 1.244-.199 2.198-.199 1.626 0 2.178.12 3.053.199-.555-1.153-.56-2.583-.56-3.934zM71.342 101.1l-3.289-3.289 3.29-3.289 3.289 3.289z\"/></svg>"

/***/ }),

/***/ "../src/components/debian/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DebianPlainWordmark = __webpack_require__("../src/components/debian/plain-wordmark/DebianPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DebianPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/debian/plain/DebianPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DebianPlain = __webpack_require__("../src/components/debian/plain/DebianPlain.svg");
	
	var _DebianPlain2 = _interopRequireDefault(_DebianPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DebianPlain */
	function DebianPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DebianPlain',
	    svg: _DebianPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DebianPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DebianPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/debian/plain/DebianPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#A80030\" d=\"M76.77 68.974a27.05 27.05 0 0 0 2.008-1.729c-1.667.408-3.363.417-5.073.261-2.049.028.388 1.056 3.065 1.468zm7.94-4.212c1.222-1.685 2.111-3.53 2.425-5.438-.274 1.359-1.011 2.534-1.707 3.773-3.833 2.414-.36-1.433-.002-2.895-4.12 5.188-.566 3.111-.716 4.56zm4.063-10.57c.248-3.693-.727-2.525-1.055-1.117.383.199.685 2.603 1.055 1.117zM65.93 3.722c1.094.196 2.365.347 2.186.608 1.197-.262 1.469-.504-2.186-.608zm2.133.704l.053-.095-.773.159zM65.27 80.73c-2.951-1.381-5.653-3.468-7.874-6.021 1.178 1.726 2.451 3.403 4.096 4.721-2.783-.942-6.499-6.742-7.584-6.978 4.796 8.587 19.457 15.059 27.135 11.848-3.553.13-8.065.073-12.057-1.402-1.536-.791-3.573-2.355-3.589-2.869-.077.201-.206.4-.127.701zm.156-.797l-.03.097.03-.097zm44.049-33.588c.033-1.882.523-.986.713-1.449-.37-.213-1.339-1.656-1.93-4.424.428-.651 1.143 1.686 1.726 1.781-.375-2.201-1.02-3.878-1.045-5.568-1.7-3.553-.602.474-1.981-1.525-1.81-5.646 1.502-1.311 1.725-3.875 2.743 3.974 4.308 10.134 5.026 12.685-.549-3.11-1.433-6.123-2.514-9.04.833.352-1.342-6.399 1.083-1.929-2.591-9.531-11.085-18.436-18.901-22.614.956.875 2.164 1.975 1.73 2.146-3.887-2.314-3.204-2.495-3.76-3.472-3.167-1.288-3.375.103-5.472.002-5.968-3.165-7.118-2.829-12.611-4.813l.251 1.168c-3.955-1.317-4.607.5-8.88.004-.261-.203 1.369-.735 2.71-.93-3.823.504-3.644-.753-7.384.139.921-.646 1.896-1.075 2.879-1.625-3.116.189-7.441 1.814-6.106.336C51.65 5.613 42.619 8.798 37.551 13.55l-.159-1.065C35.07 15.272 27.266 20.81 26.645 24.42l-.621.145c-1.209 2.046-1.991 4.365-2.949 6.47-1.581 2.693-2.317 1.036-2.091 1.459-3.109 6.302-4.653 11.598-5.986 15.94.951 1.421.022 8.553.382 14.26-1.561 28.19 19.784 55.559 43.115 61.879 3.42 1.222 8.506 1.176 12.832 1.302-5.105-1.46-5.765-.773-10.735-2.508-3.587-1.689-4.373-3.617-6.914-5.821l1.006 1.777c-4.982-1.763-2.897-2.182-6.951-3.466l1.074-1.402c-1.615-.123-4.277-2.721-5.004-4.161l-1.767.069c-2.122-2.618-3.253-4.505-3.171-5.967l-.571 1.018c-.647-1.111-7.807-9.822-4.092-7.793-.691-.632-1.608-1.028-2.603-2.835l.756-.865c-1.788-2.299-3.291-5.249-3.177-6.231.954 1.289 1.616 1.529 2.271 1.75-4.515-11.204-4.768-.618-8.188-11.405l.723-.058c-.555-.836-.891-1.743-1.337-2.633l.314-3.138c-3.25-3.759-.91-15.982-.44-22.686.325-2.727 2.713-5.628 4.529-10.178l-1.106-.191c2.115-3.69 12.079-14.82 16.693-14.247 2.235-2.809-.443-.01-.88-.718 4.91-5.082 6.453-3.591 9.767-4.504 3.573-2.121-3.066.827-1.373-.809 6.178-1.578 4.378-3.587 12.438-4.388.851.484-1.973.747-2.682 1.375 5.148-2.518 16.289-1.946 23.525 1.397 8.397 3.925 17.832 15.525 18.204 26.439l.423.113c-.213 4.339.665 9.356-.858 13.965l1.037-2.182c.121 3.316-.971 4.925-1.955 7.773l-1.772.884c-1.45 2.817.14 1.789-.897 4.03-2.265 2.013-6.871 6.298-8.345 6.689-1.077-.024.729-1.269.964-1.759-3.029 2.082-2.431 3.125-7.065 4.39l-.136-.302C71.6 82.675 55.72 72.017 55.93 57.475c-.123.924-.347.692-.601 1.067-.589-7.483 3.456-14.998 10.278-18.065 6.674-3.305 14.497-1.948 19.276 2.507-2.625-3.44-7.851-7.085-14.046-6.744-6.066.096-11.742 3.952-13.636 8.137-3.109 1.957-3.469 7.544-4.824 8.565-1.822 13.394 3.428 19.179 12.309 25.985.718.484.801.757.739 1.005l.011-.02c10.477 3.915 21.301 2.966 30.366-4.302 2.306-1.796 4.825-4.852 5.553-4.895-1.096 1.649.188.793-.655 2.249 2.298-3.707-.999-1.509 2.375-6.401l1.247 1.716c-.463-3.075 3.819-6.812 3.385-11.676.982-1.488 1.097 1.601.053 5.024 1.446-3.798.381-4.408.754-7.542.401 1.053.928 2.173 1.199 3.284-.943-3.67.967-6.181 1.439-8.313-.462-.204-1.451 1.624-1.677-2.711zM51.037 71.758c1.348 1.831 2.417 3.814 4.138 5.245-1.238-2.417-2.157-3.415-3.85-6.683l-.288 1.438zm3.473-1.563c-.713-.789-1.136-1.738-1.608-2.685.453 1.663 1.377 3.091 2.239 4.545l-.631-1.86zm52.5-.093a35.857 35.857 0 0 0 3.875-12.16l-.302.756a36.496 36.496 0 0 1-3.573 11.404zM71.214 2.126c-1.917.161-3.825.257-5.709.499l.83.114c1.387-.509 3.408-.279 4.879-.613zM18.227 30.775c1.424-3.207-.395-1.149-.552-2.007.221 2.846-2.19 3.924.552 2.007zm-2.838 7.237c-1.775 2.269-.817 2.752-1.004 4.296.642-1.972.76-3.156 1.004-4.296z\"/></svg>"

/***/ }),

/***/ "../src/components/debian/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DebianPlain = __webpack_require__("../src/components/debian/plain/DebianPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DebianPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/devicon/original-wordmark/DeviconOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DeviconOriginalWordmark = __webpack_require__("../src/components/devicon/original-wordmark/DeviconOriginalWordmark.svg");
	
	var _DeviconOriginalWordmark2 = _interopRequireDefault(_DeviconOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DeviconOriginalWordmark */
	function DeviconOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DeviconOriginalWordmark',
	    svg: _DeviconOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DeviconOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DeviconOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/devicon/original-wordmark/DeviconOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Devicon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#558d6c}.cls-2{fill:#5aa579}.cls-3{fill:#60be86}.cls-4{fill:#65d693}</style></defs><title>Artboard 13</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M12.69 26.57l8.82 75.57 42.47 21.6V26.57H12.69z\"/><path class=\"cls-2\" d=\"M63.98 26.57v-.05 97.22l.05.04 42.51-21.61 8.77-75.6H63.98z\"/><path class=\"cls-3\" d=\"M24.78 38.98l5.63 56.5 33.57 16.11V38.98h-39.2z\"/><path class=\"cls-4\" d=\"M63.98 38.98v72.61l.05.04 33.61-16.18 5.58-56.47H63.98z\"/><path class=\"cls-2\" d=\"M100.15 67.23L71.9 53.79 70.33 53l-1 2L64 65.94v12.94l8-15.7 18.68 8.31-20 9-.89.41-.11 1.36v5.37l.15 2.73 2-1 28.42-13.63c.64-.3.75-1 .75-1.75V69c-.11-.78-.21-1.46-.85-1.77z\"/><path class=\"cls-1\" d=\"M57 79.82l-18.91-8.34 20.27-9 1.4-.6-.12-1.16v-8.37L56.8 53.6 27.29 67.23A2 2 0 0 0 26.14 69v5a2 2 0 0 0 1.19 1.75l29.1 13.45 1.77.8 1.05-2L64 78.88V65.94zM14.57 20.49v-16h5.51a13.36 13.36 0 0 1 2.85.23 5.42 5.42 0 0 1 2.34 1.15 6.51 6.51 0 0 1 1.89 2.73 10.73 10.73 0 0 1 .63 3.8 11.17 11.17 0 0 1-.43 3.23A7.83 7.83 0 0 1 26.27 18a5.79 5.79 0 0 1-1.46 1.45 5.92 5.92 0 0 1-1.91.8 10.89 10.89 0 0 1-2.57.27zm2.12-1.89h3.41a8.28 8.28 0 0 0 2.48-.29 3.55 3.55 0 0 0 1.42-.83 5 5 0 0 0 1.17-2 9.89 9.89 0 0 0 .42-3.08 7.44 7.44 0 0 0-.82-3.86 4.14 4.14 0 0 0-2-1.8A8.27 8.27 0 0 0 20 6.39h-3.32zM30.74 20.49v-16H42.3v1.9h-9.44v4.9h8.84v1.88h-8.84v5.44h9.81v1.89zM50.16 20.49L44 4.51h2.29l4.15 11.61q.5 1.4.84 2.62.37-1.31.86-2.62l4.29-11.61h2.16l-6.26 16zM60.85 20.49v-16H63v16zM78.1 14.89l2.12.53a7.12 7.12 0 0 1-2.39 4 6.6 6.6 0 0 1-4.23 1.37 7.59 7.59 0 0 1-4.2-1.05 6.57 6.57 0 0 1-2.46-3 10.88 10.88 0 0 1-.85-4.29A9.42 9.42 0 0 1 67 8a6.54 6.54 0 0 1 2.76-2.8 7.93 7.93 0 0 1 3.88-1 6.56 6.56 0 0 1 4 1.22 6.34 6.34 0 0 1 2.28 3.44l-2.08.49a4.94 4.94 0 0 0-1.61-2.54A4.3 4.3 0 0 0 73.59 6a5.17 5.17 0 0 0-3.08.88 4.66 4.66 0 0 0-1.74 2.42 9.55 9.55 0 0 0-.5 3.07 9.76 9.76 0 0 0 .59 3.56 4.43 4.43 0 0 0 1.85 2.27 5.18 5.18 0 0 0 2.72.75 4.55 4.55 0 0 0 3-1 5.24 5.24 0 0 0 1.67-3.06zM82.18 12.71a8.69 8.69 0 0 1 2.14-6.23 7.27 7.27 0 0 1 5.52-2.25 7.66 7.66 0 0 1 4 1.06 6.91 6.91 0 0 1 2.71 2.95 9.58 9.58 0 0 1 .93 4.29 9.42 9.42 0 0 1-1 4.35 6.7 6.7 0 0 1-2.78 2.91 7.94 7.94 0 0 1-3.88 1 7.56 7.56 0 0 1-4-1.09 7 7 0 0 1-2.69-3 9 9 0 0 1-.95-3.99zm2.18 0a6.4 6.4 0 0 0 1.55 4.55 5.42 5.42 0 0 0 7.83 0 6.79 6.79 0 0 0 1.54-4.77 8.19 8.19 0 0 0-.66-3.41 5.07 5.07 0 0 0-1.92-2.24A5.23 5.23 0 0 0 89.85 6 5.41 5.41 0 0 0 86 7.59q-1.64 1.54-1.64 5.15zM100.18 20.49v-16h2.17l8.4 12.55V4.51h2v16h-2.15l-8.4-12.58v12.56z\"/></g></svg>"

/***/ }),

/***/ "../src/components/devicon/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DeviconOriginalWordmark = __webpack_require__("../src/components/devicon/original-wordmark/DeviconOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DeviconOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/devicon/original/DeviconOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DeviconOriginal = __webpack_require__("../src/components/devicon/original/DeviconOriginal.svg");
	
	var _DeviconOriginal2 = _interopRequireDefault(_DeviconOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DeviconOriginal */
	function DeviconOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DeviconOriginal',
	    svg: _DeviconOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DeviconOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DeviconOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/devicon/original/DeviconOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Devicon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#558d6c}.cls-2{fill:#5aa579}.cls-3{fill:#60be86}.cls-4{fill:#65d693}</style></defs><title>Artboard 15</title><g id=\"original\"><path class=\"cls-1\" d=\"M4.92 8l10.17 87.05L64 119.95V8H4.92z\"/><path class=\"cls-2\" d=\"M64 8v111.95l.05.05 48.93-24.91L123.08 8H64z\"/><path class=\"cls-3\" d=\"M18.84 22.11l6.49 65.18L64 105.97V22.11H18.84z\"/><path class=\"cls-4\" d=\"M64 22.11v83.86l.05.05 38.69-18.76 6.42-65.15H64z\"/><path class=\"cls-2\" d=\"M105.72 54.9L73.14 39.42l-1.83-.9-1.12 2.28L64 53.41V68.3l9.15-18.08 21.5 9.57-23.09 10.37-.87.47v10.88L73 80.38l32.78-15.69a2 2 0 0 0 .92-2v-5.78a2 2 0 0 0-.98-2.01z\"/><path class=\"cls-1\" d=\"M56 69.39l-21.79-9.6 23.3-10.37 1.76-.7V37.76l-3.4 1.44-33.93 15.69a2.26 2.26 0 0 0-1.28 2v5.77a2.22 2.22 0 0 0 1.24 2l33.44 15.52 2 .9 1.21-2.26L64 68.3V53.41z\"/></g></svg>"

/***/ }),

/***/ "../src/components/devicon/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DeviconOriginal = __webpack_require__("../src/components/devicon/original/DeviconOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DeviconOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/devicon/plain-wordmark/DeviconPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DeviconPlainWordmark = __webpack_require__("../src/components/devicon/plain-wordmark/DeviconPlainWordmark.svg");
	
	var _DeviconPlainWordmark2 = _interopRequireDefault(_DeviconPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DeviconPlainWordmark */
	function DeviconPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DeviconPlainWordmark',
	    svg: _DeviconPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DeviconPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DeviconPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/devicon/plain-wordmark/DeviconPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Devicon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#60be86}</style></defs><title>Artboard 12</title><g id=\"plain-wordmark\"><path id=\"plain\" class=\"cls-1\" d=\"M64 24.2H11.6l9 77.23L64 123.55h.05l43.41-22.12 9-77.27zm37.84 48.53c0 .78 0 1.48-.68 1.79l-29 13.92-2.14 1-.24-2.79v-5.47l.22-1.39 1-.41 20.5-9.19-19.07-8.49-8.12 16-4.82 9.32-1.08 2-1.82-.8L26.8 74.53a2.14 2.14 0 0 1-1.29-1.79v-5.12a2.11 2.11 0 0 1 1.25-1.79l30.1-13.91 2.84-1.28v8.55l.21 1.18-1.38.63-20.68 9.17 19.33 8.52 7.12-14.17 5.5-11.2 1-2 1.6.8 28.77 13.73c.65.31.67 1 .67 1.79z\"/><path class=\"cls-1\" d=\"M14.29 20.55V4.69h5.57a13.76 13.76 0 0 1 2.88.23 5.53 5.53 0 0 1 2.36 1.14A6.45 6.45 0 0 1 27 8.77a10.45 10.45 0 0 1 .63 3.77 10.87 10.87 0 0 1-.43 3.2A7.7 7.7 0 0 1 26.12 18a5.8 5.8 0 0 1-1.47 1.44 6 6 0 0 1-1.93.79 11.22 11.22 0 0 1-2.6.27zm2.14-1.87h3.45a8.53 8.53 0 0 0 2.51-.29 3.6 3.6 0 0 0 1.45-.82 5 5 0 0 0 1.19-2 9.63 9.63 0 0 0 .42-3.06 7.26 7.26 0 0 0-.83-3.82 4.16 4.16 0 0 0-2-1.79 8.52 8.52 0 0 0-2.77-.32h-3.4zM30.64 20.55V4.69h11.69v1.87h-9.55v4.86h8.94v1.86h-8.94v5.4h9.92v1.87zM50.28 20.55L44 4.69h2.32l4.2 11.52q.51 1.38.85 2.6.37-1.3.87-2.6l4.38-11.52h2.18l-6.33 15.86zM61.08 20.55V4.69h2.14v15.86zM78.52 15l2.14.53a7 7 0 0 1-2.42 3.94A6.76 6.76 0 0 1 74 20.82a7.79 7.79 0 0 1-4.25-1 6.54 6.54 0 0 1-2.49-3 10.61 10.61 0 0 1-.85-4.25 9.19 9.19 0 0 1 1-4.32 6.54 6.54 0 0 1 2.75-2.8 8.15 8.15 0 0 1 3.92-1 6.72 6.72 0 0 1 4.08 1.21A6.28 6.28 0 0 1 80.39 9l-2.11.49A4.89 4.89 0 0 0 76.65 7 4.41 4.41 0 0 0 74 6.22a5.3 5.3 0 0 0-3.11.88 4.63 4.63 0 0 0-1.76 2.35 9.31 9.31 0 0 0-.51 3 9.51 9.51 0 0 0 .6 3.53 4.41 4.41 0 0 0 1.78 2.3 5.32 5.32 0 0 0 2.75.75 4.66 4.66 0 0 0 3-1A5.18 5.18 0 0 0 78.52 15zM82.65 12.83a8.51 8.51 0 0 1 2.16-6.18 7.42 7.42 0 0 1 5.58-2.23 7.86 7.86 0 0 1 4 1 6.9 6.9 0 0 1 2.74 2.93 9.35 9.35 0 0 1 .94 4.26 9.19 9.19 0 0 1-1 4.31 6.7 6.7 0 0 1-2.81 2.88 8.15 8.15 0 0 1-3.93 1 7.76 7.76 0 0 1-4.08-1.08 7 7 0 0 1-2.72-3 8.81 8.81 0 0 1-.88-3.89zm2.21 0a6.28 6.28 0 0 0 1.57 4.51 5.56 5.56 0 0 0 7.92 0 6.65 6.65 0 0 0 1.56-4.73 8 8 0 0 0-.67-3.38 5.06 5.06 0 0 0-2-2.24 5.37 5.37 0 0 0-2.88-.79 5.53 5.53 0 0 0-3.91 1.53q-1.6 1.55-1.6 5.13zM100.84 20.55V4.69H103l8.49 12.45V4.69h2.05v15.86h-2.19l-8.46-12.46v12.46z\"/></g></svg>"

/***/ }),

/***/ "../src/components/devicon/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DeviconPlainWordmark = __webpack_require__("../src/components/devicon/plain-wordmark/DeviconPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DeviconPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/devicon/plain/DeviconPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DeviconPlain = __webpack_require__("../src/components/devicon/plain/DeviconPlain.svg");
	
	var _DeviconPlain2 = _interopRequireDefault(_DeviconPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DeviconPlain */
	function DeviconPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DeviconPlain',
	    svg: _DeviconPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DeviconPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DeviconPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/devicon/plain/DeviconPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Devicon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#60be86}</style></defs><title>Artboard 14</title><path id=\"plain\" class=\"cls-1\" d=\"M64 7.83H4.77l10.18 87.3 49 25h.06l49.07-25 10.15-87.3zm42.77 54.86c0 .88 0 1.67-.77 2L73.25 80.44l-2.42 1.13-.27-3.15v-6.19l.24-1.57 1.09-.47 23.18-10.38-21.54-9.6-9.18 18.13-5.45 10.53-1.22 2.27-2.05-.9L22 64.71a2.42 2.42 0 0 1-1.45-2v-5.8a2.39 2.39 0 0 1 1.42-2l34-15.73 3.21-1.44v9.66l.24 1.34-1.56.7-23.41 10.35 21.85 9.63 8.05-16 6.21-12.65 1.13-2.28 1.81.91L106 54.89c.73.35.76 1.14.76 2z\"/></svg>"

/***/ }),

/***/ "../src/components/devicon/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DeviconPlain = __webpack_require__("../src/components/devicon/plain/DeviconPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DeviconPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/django/line/DjangoLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DjangoLine = __webpack_require__("../src/components/django/line/DjangoLine.svg");
	
	var _DjangoLine2 = _interopRequireDefault(_DjangoLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DjangoLine */
	function DjangoLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DjangoLine',
	    svg: _DjangoLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DjangoLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DjangoLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/django/line/DjangoLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M127 44.9c0-4.3-3.5-7.9-7.9-7.9H8.9C4.5 37 1 40.5 1 44.9v39.3C1 88.5 4.5 92 8.9 92h110.3c4.3 0 7.9-3.5 7.9-7.9V44.9zm-2 39.2c0 3.2-2.6 5.9-5.9 5.9H8.9C5.6 90 3 87.4 3 84.1V44.9C3 41.6 5.6 39 8.9 39h110.2c3.2 0 5.9 2.6 5.9 5.9v39.2zM30 46h-6v9.2c-1-.2-1.7-.3-2.6-.3-6.1 0-10.1 3.9-10.1 9.9 0 6.2 3.9 9.4 11 9.4 2.4 0 4.8-.2 7.8-.8V46zm-6 23.3c-1 .1-1.5.2-2.1.2-3 0-4.7-1.7-4.7-4.8 0-3.2 1.8-5 4.8-5 .7 0 1.1.1 2.1.3v9.3zM33 46h6v6h-6zm0 20.9c0 5.1-.2 7-1 8.7-.8 1.6-2 2.7-4.6 3.9l5.5 2.6c2.6-1.3 3.9-2.5 4.8-4.3 1-1.9 1.4-4.2 1.4-8.9V55h-6v11.9zm17.5-12c-2.7 0-4.5.5-7.5 1.8v4.5c2-1.2 4.3-1.8 6.4-1.8 1.5 0 1.6.4 1.6 1.4v1.3c-6 .6-9.9 2.5-9.9 6.6 0 3.8 1.9 5.5 6.8 5.5 2.4 0 6.1-.3 8.1-.6V61.7c0-2.4.4-3.6-.1-4.5-.9-1.5-2.4-2.3-5.4-2.3zm.5 15c-1 .2-1.6.3-2.5.3-1.6 0-2.5-.5-2.5-1.7 0-1.5 2-2.1 5-2.5v3.9zm17.5-15c-2.9 0-5.5.4-9.5 1.3V74h6V60.1c1-.3 2.1-.4 2.9-.4 2.1 0 3.1.8 3.1 3.1V74h6V62.5c0-2.9-.6-4.3-1.8-5.6-1.3-1.3-3.7-2-6.7-2zm29 5.1l2.1-4.2c-2.8-.6-5.1-.8-7.6-.8-8.6 0-13.4 3.8-13.4 10.4 0 5.4 3.3 8.8 8.4 8.8 1.5 0 2.8-.2 3.8-.8v.1c0 3.7-1.8 5.3-5.6 5.3-2.2 0-4.4-.5-6.4-1.6v5.4c2 .8 4.1 1.1 6.4 1.1 4.5 0 7.9-1.4 9.7-4.3 1.3-1.9 1.9-4.3 1.9-9.3v-1.6l-.2-2.4-.2-3.1-.4-2.5v-.6c2 .1 0-.2 1.5.1zM91 68.6v.4c-1 .2-1.4.4-2.2.4-2.6 0-4-1.7-4-4.6 0-2.1.7-3.8 2.1-4.6.9-.6 2.2-1.2 3.4-1.2h.7v9.6zm17.9-13.7c-6 0-9.7 3.8-9.7 10 0 5.9 3.6 9.6 9.5 9.6s9.7-3.8 9.7-10c-.1-6-3.7-9.6-9.5-9.6zm-.1 14.9c-2.3 0-3.6-1.9-3.6-5.1 0-3.2 1.3-5.1 3.7-5.1 2.2 0 3.5 1.9 3.5 5.1-.1 3.2-1.4 5.1-3.6 5.1z\" fill=\"#003A2B\"/></svg>"

/***/ }),

/***/ "../src/components/django/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DjangoLine = __webpack_require__("../src/components/django/line/DjangoLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DjangoLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/django/original/DjangoOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DjangoOriginal = __webpack_require__("../src/components/django/original/DjangoOriginal.svg");
	
	var _DjangoOriginal2 = _interopRequireDefault(_DjangoOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DjangoOriginal */
	function DjangoOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DjangoOriginal',
	    svg: _DjangoOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DjangoOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DjangoOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/django/original/DjangoOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#003A2B\" d=\"M126.5 83.8c0 3.8-3.1 6.9-6.9 6.9H8.4c-3.8 0-6.9-3.1-6.9-6.9V44.2c0-3.8 3.1-6.9 6.9-6.9h111.2c3.8 0 6.9 3.1 6.9 6.9v39.6z\"/><path fill=\"#fff\" d=\"M23 45.6h6V73c-3 .6-5.3.8-7.7.8-7.2 0-11-3.3-11-9.5 0-6 4-10 10.2-10 1 0 1.7.1 2.6.3v-9H23zm0 13.8c-.7-.2-1.3-.3-2-.3-3 0-4.7 1.8-4.7 5.1 0 3.2 1.7 4.9 4.7 4.9.7 0 1.2 0 2-.2v-9.5zm15.4-4.6v13.7c0 4.7-.3 7-1.4 9-1 1.9-2.2 3.1-4.8 4.4l-5.5-2.6c2.6-1.2 3.9-2.3 4.7-4 .8-1.7 1.1-3.7 1.1-8.8V54.8h5.9zm-5.9-9.1h5.9v6.1h-5.9v-6.1zM42 56.1c2.6-1.2 5.1-1.8 7.8-1.8 3 0 5 .8 5.9 2.4.5.9.7 2 .7 4.5v12c-2.7.4-6 .7-8.5.7-5 0-7.2-1.7-7.2-5.6 0-4.2 3-6.1 10.2-6.7v-1.3c0-1.1-.5-1.5-2-1.5-2.2 0-4.7.6-7 1.8v-4.5h.1zm9.2 9.4c-3.9.4-5.2 1-5.2 2.5 0 1.2.7 1.7 2.3 1.7.9 0 1.7-.1 2.8-.3v-3.9h.1zm8.1-9.8c3.5-.9 6.4-1.3 9.3-1.3 3 0 5.2.7 6.5 2 1.2 1.3 1.6 2.7 1.6 5.6v11.6h-5.9V62.2c0-2.3-.8-3.1-2.9-3.1-.8 0-1.5.1-2.7.4v14.1h-5.9V55.7zM79 76.8c2.1 1.1 4.2 1.6 6.3 1.6 3.9 0 5.5-1.6 5.5-5.3V73c-1.2.6-2.3.8-3.8.8-5.2 0-8.5-3.4-8.5-8.8 0-6.7 4.9-10.5 13.5-10.5 2.5 0 4.9.3 7.7.8l-2 4.3c-1.6-.3-.1 0-1.3-.2v.6l.1 2.5v3.2c0 .8 0 1.6.1 2.4v1.6c0 5.1-.4 7.5-1.7 9.4-1.8 2.9-5 4.3-9.6 4.3-2.3 0-4.3-.3-6.4-1.2v-5.4h.1zm11.8-17.6h-.6c-1.2 0-2.5.3-3.4.8-1.4.8-2.2 2.3-2.2 4.3 0 3 1.5 4.7 4.1 4.7.8 0 1.5-.2 2.2-.4v-9.4h-.1zm18.2-4.9c5.9 0 9.5 3.7 9.5 9.8 0 6.2-3.8 10.1-9.8 10.1-5.9 0-9.6-3.7-9.6-9.7.1-6.3 3.9-10.2 9.9-10.2zm-.1 15c2.3 0 3.6-1.9 3.6-5.2 0-3.2-1.3-5.2-3.6-5.2s-3.7 1.9-3.7 5.2c.1 3.4 1.4 5.2 3.7 5.2z\"/></svg>"

/***/ }),

/***/ "../src/components/django/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DjangoOriginal = __webpack_require__("../src/components/django/original/DjangoOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DjangoOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/django/plain/DjangoPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DjangoPlain = __webpack_require__("../src/components/django/plain/DjangoPlain.svg");
	
	var _DjangoPlain2 = _interopRequireDefault(_DjangoPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DjangoPlain */
	function DjangoPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DjangoPlain',
	    svg: _DjangoPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DjangoPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DjangoPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/django/plain/DjangoPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M90.9 61.6l.1-2V59h-.8c-1.2 0-2.5.3-3.4.9-1.4.8-2.2 2.3-2.2 4.4 0 3 1.5 4.7 4.1 4.7.8 0 1.3-.1 2.3-.4v-4.3l-.1-2.7zm-74.6 2.6c0 3.2 1.6 4.9 4.7 4.9.7 0 1 0 2-.2v-9.5c-1-.2-1.2-.3-2-.3-3 0-4.7 1.9-4.7 5.1zm29.6 3.9c0 1.2.7 1.7 2.3 1.7.9 0 1.8-.1 2.8-.3v-4c-4 .4-5.1 1-5.1 2.6zm63-9.1c-2.3 0-3.7 1.9-3.7 5.2 0 3.3 1.3 5.2 3.7 5.2 2.3 0 3.6-1.9 3.6-5.2 0-3.2-1.3-5.2-3.6-5.2zM126 43.9c0-3.8-3.1-6.9-6.9-6.9H7.9C4.1 37 1 40.1 1 43.9V84c0 3.9 3.1 7 6.9 7H119c3.8 0 6.9-3.1 6.9-6.9V43.9zM10.3 64.3c0-6 4-10 10.2-10 1 0 1.6.1 2.6.3V46h6v27c-3 .6-5.3.8-7.7.8-7.3 0-11.1-3.2-11.1-9.5zM38 68.5c0 4.7-.2 7-1.2 9-1 1.9-2.1 3.1-4.7 4.4l-5.5-2.6c2.6-1.2 3.7-2.3 4.5-4 .8-1.7.9-3.7.9-8.8V55h6v13.5zM38 52h-6v-6h6v6zm18 21.3c-2 .4-5.8.7-8.3.7-5 0-7.1-1.7-7.1-5.6 0-4.2 3.3-6.1 10.3-6.7v-1.3c0-1.1-.5-1.5-2-1.5-2.2 0-5 .6-7 1.8v-4.6c3-1.2 5.1-1.8 7.8-1.8 3 0 4.8.8 5.7 2.4.5.9.5 2 .5 4.5v12.1zm21 .7h-6V62.2c0-2.3-1-3.1-3.1-3.1-.8 0-1.9.1-2.9.4V74h-6V55.7c4-.9 6.5-1.3 9.4-1.3 3 0 5.4.7 6.7 2C76.4 57.7 77 59 77 62v12zm19.3-11.6L97 68v1.7c0 5.1-.6 7.5-1.9 9.4-1.8 2.9-5.1 4.3-9.7 4.3-2.3 0-4.5-.3-6.5-1.2v-5.5c2 1.1 4.2 1.6 6.4 1.6 3.9 0 5.6-1.6 5.6-5.3v-.1c-1 .6-2.4.8-3.9.8-5.2 0-8.5-3.4-8.5-8.8 0-6.7 4.9-10.5 13.5-10.5 2.5 0 4.9.3 7.7.8l-2.3 4.3c-1.6-.3 1.3 0-.7-.2m12.1 14.8c-5.9 0-9.6-3.7-9.6-9.7 0-6.2 3.8-10.1 9.8-10.1 5.9 0 9.5 3.7 9.5 9.8.1 6.1-3.7 10-9.7 10z\" fill=\"#003A2B\"/></svg>"

/***/ }),

/***/ "../src/components/django/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DjangoPlain = __webpack_require__("../src/components/django/plain/DjangoPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DjangoPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/docker/original-wordmark/DockerOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DockerOriginalWordmark = __webpack_require__("../src/components/docker/original-wordmark/DockerOriginalWordmark.svg");
	
	var _DockerOriginalWordmark2 = _interopRequireDefault(_DockerOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DockerOriginalWordmark */
	function DockerOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DockerOriginalWordmark',
	    svg: _DockerOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DockerOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DockerOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/docker/original-wordmark/DockerOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#3A4D54\" d=\"M20 96.9v-8.1c0-1.1.7-1.9 1.8-1.9h.3c1.1 0 1.8.9 1.8 1.9v17c0 4.1-2 7.4-5.6 9.5-1.7 1-3.5 1.5-5.4 1.5h-.8c-4.1 0-7.4-2-9.5-5.6-1-1.7-1.5-3.5-1.5-5.4v-.8c0-4.1 2-7.4 5.6-9.5 1.7-1 3.5-1.5 5.4-1.5h.8c2.7.1 5.1 1.1 7.1 2.9zm-15.1 8.5c0 3 1.5 5.2 4.1 6.7 1.1.6 2.2.9 3.4.9 2.9 0 5.1-1.4 6.6-3.9.7-1.2 1-2.4 1-3.8 0-2.6-1.2-4.6-3.3-6.1-1.3-.9-2.7-1.4-4.2-1.4-3.2 0-5.5 1.6-6.9 4.5-.5 1-.7 2.1-.7 3.1zm32.2-11.3h.5c4.4 0 7.8 2.1 9.9 6 .9 1.5 1.3 3.2 1.3 5v.8c0 4.1-2 7.4-5.6 9.5-1.7 1-3.5 1.5-5.4 1.5H37c-4.1 0-7.4-2-9.5-5.6-1-1.7-1.5-3.5-1.5-5.4v-.8c0-4.1 2.1-7.4 5.6-9.5 1.7-1.1 3.6-1.5 5.5-1.5zm-7.2 11.3c0 2.9 1.4 5 3.9 6.5 1.2.7 2.4 1 3.8 1 2.9 0 5-1.5 6.5-3.9.7-1.2 1-2.4 1-3.8 0-2.7-1.3-4.8-3.5-6.3-1.2-.8-2.6-1.2-4-1.2-3.2 0-5.5 1.6-6.9 4.5-.6 1.1-.8 2.2-.8 3.2zm34.8-7.2c-.6-.3-1.7-.4-2.3-.4-3.2-.1-5.5 1.7-6.9 4.5-.5 1-.7 2-.7 3.1 0 3.3 1.7 5.6 4.6 7 1.1.5 2.4.6 3.6.6 1 0 2.5-.6 3.4-1.1l.2-.1h.8c.9.2 1.5.7 1.5 1.7v.4c0 2.3-4.3 2.9-5.9 3-5.7.4-10-2.7-11.6-8.2-.3-.9-.4-1.9-.4-2.9v-.8c0-4.1 2.1-7.4 5.6-9.5 1.7-1 3.5-1.5 5.4-1.5h.8c2 0 3.9.6 5.6 1.7l.1.1.1.1c.2.3.3.6.3 1v.4c0 1-.7 1.5-1.6 1.7H67c-.5 0-1.8-.6-2.3-.8zm12.4 2.6c1.5-1.5 3-3 4.5-4.4.4-.4 2-2.1 2.6-2.1h.8c.9.2 1.5.7 1.5 1.7v.4c0 .6-.7 1.4-1.2 1.8l-2.7 2.7-4.6 4.7c2 2 4 4 5.9 6l1.6 1.7c.2.2.5.4.6.7.2.3.3.6.3.9v.5c-.2.9-.8 1.6-1.7 1.6h-.3c-.6 0-1.3-.7-1.8-1.1-.9-.8-1.8-1.7-2.6-2.6l-2.9-2.9v4.6c0 1.1-.7 1.9-1.8 1.9H75c-1.1 0-1.8-.9-1.8-1.9V88.9c0-1.1.7-1.9 1.8-1.9h.3c1.1 0 1.8.8 1.8 1.9v11.9zm47.6-6.6h.4c1.1 0 1.9.8 1.9 1.9 0 1.6-1.5 2-2.8 2-1.7 0-3.4 1-4.5 2.2-1.5 1.5-2.1 3.3-2.1 5.4v9.2c0 1.1-.7 1.9-1.8 1.9h-.3c-1.1 0-1.8-.9-1.8-1.9v-9.8c0-3.8 1.8-6.8 4.9-9 1.8-1.2 3.9-1.9 6.1-1.9zm-27.1 18.3c1.4.5 3 .4 4.4.2.7-.3 2.6-1.1 3.3-1h.2c.4.2.8.5 1 .9.5 1 .3 2-.7 2.6l-.3.2c-3.6 2.1-7.5 1.8-11.1-.2-1.7-.9-3-2.3-4-4l-.2-.4c-2.3-4-2-8.3.6-12.1.9-1.3 2.1-2.3 3.5-3.1l.5-.3c3.4-2 7.1-1.8 10.6-.1 1.9.9 3.4 2.3 4.5 4.1l.2.3c.8 1.3-.2 2.5-1.2 3.3-1.2.9-2.4 2-3.5 3-2.7 2.2-5.3 4.4-7.8 6.6zm-3.3-2.3l8.5-7.3c1-.8 2-1.7 3-2.6-.8-1-2.1-1.7-3.1-2.1-2.2-.8-4.4-.6-6.4.6-2.6 1.5-3.8 4-3.7 7 0 1.2.4 2.3 1 3.4.2.4.4.7.7 1M73.7 33.7H85v11.5h5.7c2.6 0 5.3-.5 7.8-1.3 1.2-.4 2.6-1 3.8-1.7-1.6-2.1-2.4-4.7-2.6-7.3-.3-3.5.4-8.1 2.8-10.8l1.2-1.4 1.4 1.1c3.6 2.9 6.5 6.8 7.1 11.4 4.3-1.3 9.3-1 13.1 1.2l1.5.9-.8 1.6c-3.2 6.2-9.9 8.2-16.4 7.8-9.8 24.3-31 35.8-56.8 35.8-13.3 0-25.5-5-32.5-16.8l-.1-.2-1-2.1c-2.4-5.2-3.1-10.9-2.6-16.6l.2-1.7h9.6V33.7h11.3V22.4h22.5V11.1h13.5v22.6z\"/><path fill=\"#00AADA\" d=\"M110.2 37.9c.8-5.9-3.6-10.5-6.4-12.7-3.1 3.6-3.6 13.2 1.3 17.2-2.8 2.4-8.5 4.7-14.5 4.7H18.4c-.6 6.2.5 11.9 3 16.8l.8 1.5c.5.9 1.1 1.7 1.7 2.6 3 .2 5.7.3 8.2.2 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5 1.1-8.3 1.3h-.6c-1.3.1-2.7.1-4.2.1-1.6 0-3.1 0-4.9-.1 6 6.8 15.4 10.8 27.2 10.8 25 0 46.2-11.1 55.5-35.9 6.7.7 13.1-1 16-6.7-4.5-2.6-10.5-1.8-13.9-.1z\"/><path fill=\"#28B8EB\" d=\"M110.2 37.9c.8-5.9-3.6-10.5-6.4-12.7-3.1 3.6-3.6 13.2 1.3 17.2-2.8 2.4-8.5 4.7-14.5 4.7h-68c-.3 9.5 3.2 16.7 9.5 21 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5.2 1.2-8.5 1.4l-.1-.1c8.5 4.4 20.8 4.3 35-1.1 15.8-6.1 30.6-17.7 40.9-30.9-.2.1-.3.2-.5.2z\"/><path fill=\"#028BB8\" d=\"M18.5 54.6c.4 3.3 1.4 6.4 2.9 9.3l.8 1.5c.5.9 1.1 1.7 1.7 2.6 3 .2 5.7.3 8.2.2 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5.2 1.2-8.5 1.4h-.4c-1.3.1-2.7.1-4.1.1-1.6 0-3.2 0-4.9-.1 6 6.8 15.5 10.8 27.3 10.8 21.4 0 40-8.1 50.8-26H18.5v-.1z\"/><path fill=\"#019BC6\" d=\"M23.3 54.6c1.3 5.8 4.3 10.4 8.8 13.5 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5.2 1.2-8.6 1.4 8.5 4.4 20.8 4.3 34.9-1.1 8.5-3.3 16.8-8.2 24.2-14.1H23.3z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#00ACD3\" d=\"M28.2 35.5H38v9.8h-9.8v-9.8zm.8.9h.8v8.1H29v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1H32v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm3.1-12.1h9.8V34h-9.8v-9.7zm.8.8h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#23C2EE\" d=\"M39.5 35.5h9.8v9.8h-9.8v-9.8zm.8.9h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#00ACD3\" d=\"M50.8 35.5h9.8v9.8h-9.8v-9.8zm.8.9h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1H53v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1H56v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#23C2EE\" d=\"M50.8 24.3h9.8V34h-9.8v-9.7zm.8.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1H53v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1H56v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zM62 35.5h9.8v9.8H62v-9.8zm.9.9h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#00ACD3\" d=\"M62 24.3h9.8V34H62v-9.7zm.9.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#23C2EE\" d=\"M62 13h9.8v9.8H62V13zm.9.8h.8V22h-.8v-8.2zm1.4 0h.8V22h-.8v-8.2zm1.5 0h.8V22h-.8v-8.2zm1.5 0h.8V22h-.8v-8.2zm1.4 0h.8V22h-.8v-8.2zm1.5 0h.8V22h-.8v-8.2z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#00ACD3\" d=\"M73.3 35.5h9.8v9.8h-9.8v-9.8zm.8.9h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1H80v-8.1zm1.5 0h.8v8.1h-.8v-8.1z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D4EEF1\" d=\"M48.6 61.2c1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7-1.5 0-2.7-1.2-2.7-2.7.1-1.5 1.3-2.7 2.7-2.7\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#3A4D54\" d=\"M48.6 61.9c.2 0 .5 0 .7.1-.2.1-.4.4-.4.7 0 .4.4.8.8.8.3 0 .6-.2.7-.4.1.2.1.5.1.7 0 1.1-.9 1.9-1.9 1.9-1.1 0-1.9-.9-1.9-1.9 0-1 .9-1.9 1.9-1.9M1 55.6h125.3c-2.7-.7-8.6-1.6-7.7-5.2-5 5.7-16.9 4-20 1.2-3.4 4.9-23 3-24.3-.8-4.2 5-17.3 5-21.5 0-1.4 3.8-21 5.7-24.3.8-3 2.8-15 4.5-20-1.2 1.1 3.5-4.8 4.5-7.5 5.2\"/><path fill=\"#BFDBE0\" d=\"M55.8 80.6c-6.7-3.2-10.3-7.5-12.4-12.2-2.5.7-5.5 1.2-8.9 1.4-1.3.1-2.7.1-4.1.1-1.7 0-3.4 0-5.2-.1 6.1 6.1 13.7 10.8 27.6 10.9 1-.1 2-.1 3-.1z\"/><path fill=\"#D4EEF1\" d=\"M45.9 72.7c-.9-1.3-1.8-2.8-2.5-4.3-2.5.7-5.5 1.2-8.9 1.4 2.4 1.3 5.8 2.5 11.4 2.9z\"/></svg>"

/***/ }),

/***/ "../src/components/docker/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DockerOriginalWordmark = __webpack_require__("../src/components/docker/original-wordmark/DockerOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DockerOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/docker/original/DockerOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DockerOriginal = __webpack_require__("../src/components/docker/original/DockerOriginal.svg");
	
	var _DockerOriginal2 = _interopRequireDefault(_DockerOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DockerOriginal */
	function DockerOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DockerOriginal',
	    svg: _DockerOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DockerOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DockerOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/docker/original/DockerOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#3A4D54\" d=\"M73.8 50.8h11.3v11.5h5.7c2.6 0 5.3-.5 7.8-1.3 1.2-.4 2.6-1 3.8-1.7-1.6-2.1-2.4-4.7-2.6-7.3-.3-3.5.4-8.1 2.8-10.8l1.2-1.4 1.4 1.1c3.6 2.9 6.5 6.8 7.1 11.4 4.3-1.3 9.3-1 13.1 1.2l1.5.9-.8 1.6c-3.2 6.2-9.9 8.2-16.4 7.8-9.8 24.3-31 35.8-56.8 35.8-13.3 0-25.5-5-32.5-16.8l-.1-.2-1-2.1c-2.4-5.2-3.1-10.9-2.6-16.6l.2-1.7h9.6V50.8h11.3V39.6h22.5V28.3h13.5v22.5z\"/><path fill=\"#00AADA\" d=\"M110.4 55.1c.8-5.9-3.6-10.5-6.4-12.7-3.1 3.6-3.6 13.2 1.3 17.2-2.8 2.4-8.5 4.7-14.5 4.7H18.6c-.6 6.2.5 11.9 3 16.8l.8 1.5c.5.9 1.1 1.7 1.7 2.6 3 .2 5.7.3 8.2.2 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5 1.1-8.3 1.3h-.6c-1.3.1-2.7.1-4.2.1-1.6 0-3.1 0-4.9-.1 6 6.8 15.4 10.8 27.2 10.8 25 0 46.2-11.1 55.5-35.9 6.7.7 13.1-1 16-6.7-4.5-2.7-10.5-1.8-13.9-.1z\"/><path fill=\"#28B8EB\" d=\"M110.4 55.1c.8-5.9-3.6-10.5-6.4-12.7-3.1 3.6-3.6 13.2 1.3 17.2-2.8 2.4-8.5 4.7-14.5 4.7h-68c-.3 9.5 3.2 16.7 9.5 21 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5.2 1.2-8.5 1.4l-.1-.1c8.5 4.4 20.8 4.3 35-1.1 15.8-6.1 30.6-17.7 40.9-30.9-.2.1-.4.1-.5.2z\"/><path fill=\"#028BB8\" d=\"M18.7 71.8c.4 3.3 1.4 6.4 2.9 9.3l.8 1.5c.5.9 1.1 1.7 1.7 2.6 3 .2 5.7.3 8.2.2 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5.2 1.2-8.5 1.4h-.4c-1.3.1-2.7.1-4.1.1-1.6 0-3.2 0-4.9-.1 6 6.8 15.5 10.8 27.3 10.8 21.4 0 40-8.1 50.8-26H18.7v-.1z\"/><path fill=\"#019BC6\" d=\"M23.5 71.8c1.3 5.8 4.3 10.4 8.8 13.5 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5.2 1.2-8.6 1.4 8.5 4.4 20.8 4.3 34.9-1.1 8.5-3.3 16.8-8.2 24.2-14.1H23.5z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#00ACD3\" d=\"M28.4 52.7h9.8v9.8h-9.8v-9.8zm.8.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm3-12h9.8v9.8h-9.8v-9.8zm.9.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#23C2EE\" d=\"M39.6 52.7h9.8v9.8h-9.8v-9.8zm.9.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#00ACD3\" d=\"M50.9 52.7h9.8v9.8h-9.8v-9.8zm.8.8h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#23C2EE\" d=\"M50.9 41.5h9.8v9.8h-9.8v-9.8zm.8.8h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm3.1 10.4H72v9.8h-9.8v-9.8zm.8.8h.8v8.1H63v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#00ACD3\" d=\"M62.2 41.5H72v9.8h-9.8v-9.8zm.8.8h.8v8.1H63v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#23C2EE\" d=\"M62.2 30.2H72V40h-9.8v-9.8zm.8.8h.8v8.1H63V31zm1.5 0h.8v8.1h-.8V31zm1.4 0h.8v8.1h-.8V31zm1.5 0h.8v8.1h-.8V31zm1.5 0h.8v8.1h-.8V31zm1.5 0h.8v8.1h-.8V31z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#00ACD3\" d=\"M73.5 52.7h9.8v9.8h-9.8v-9.8zm.8.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D4EEF1\" d=\"M48.8 78.3c1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#3A4D54\" d=\"M48.8 79.1c.2 0 .5 0 .7.1-.2.1-.4.4-.4.7 0 .4.4.8.8.8.3 0 .6-.2.7-.4.1.2.1.5.1.7 0 1.1-.9 1.9-1.9 1.9-1.1 0-1.9-.9-1.9-1.9 0-1 .8-1.9 1.9-1.9M1.1 72.8h125.4c-2.7-.7-8.6-1.6-7.7-5.2-5 5.7-16.9 4-20 1.2-3.4 4.9-23 3-24.3-.8-4.2 5-17.3 5-21.5 0-1.4 3.8-21 5.7-24.3.8-3 2.8-15 4.5-20-1.2 1.1 3.5-4.9 4.5-7.6 5.2\"/><path fill=\"#BFDBE0\" d=\"M56 97.8c-6.7-3.2-10.3-7.5-12.4-12.2-2.5.7-5.5 1.2-8.9 1.4-1.3.1-2.7.1-4.1.1-1.7 0-3.4 0-5.2-.1 6 6 13.6 10.7 27.5 10.8H56z\"/><path fill=\"#D4EEF1\" d=\"M46.1 89.9c-.9-1.3-1.8-2.8-2.5-4.3-2.5.7-5.5 1.2-8.9 1.4 2.3 1.2 5.7 2.4 11.4 2.9z\"/></svg>"

/***/ }),

/***/ "../src/components/docker/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DockerOriginal = __webpack_require__("../src/components/docker/original/DockerOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DockerOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/docker/plain-wordmark/DockerPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DockerPlainWordmark = __webpack_require__("../src/components/docker/plain-wordmark/DockerPlainWordmark.svg");
	
	var _DockerPlainWordmark2 = _interopRequireDefault(_DockerPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DockerPlainWordmark */
	function DockerPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DockerPlainWordmark',
	    svg: _DockerPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DockerPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DockerPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/docker/plain-wordmark/DockerPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M86 118.4c0-.3.1-.6 0-.9-.2-.3-.3-.5-.5-.7-.5-.6-1-1.1-1.6-1.7l-5.9-6 4.6-4.7 2.5-2.7c.4-.4.9-1.2.9-1.8v-.4c0-.9-.4-1.4-1.3-1.6l.2.1h-.7c-.6 0-2.3 1.6-2.7 2.1-1.5 1.5-2.5 2.9-4.5 4.4V92.6c0-1.1-.6-1.6-1.7-1.6H75c-1.1 0-2 .5-2 1.6v25.9c0 1.1.9 1.5 2 1.5h.3c1.1 0 1.7-.5 1.7-1.5v-4.6l3 2.9c.9.9 1.8 1.5 2.6 2.3.4.4 1.2.9 1.8.9h.3c1 0 1.3-.5 1.5-1.3l-.2.1v-.4zM125.1 98h-.4c-2.2 0-4.2.6-6 1.9-3 2.2-4.7 5.1-4.7 8.9v9.8c0 1.1.4 1.4 1.5 1.4h.3c1.1 0 2.2-.4 2.2-1.4v-9.2c0-2 .4-3.9 1.9-5.4 1.2-1.2 2.7-2.2 4.4-2.2 1.3 0 2.8-.3 2.8-1.9 0-1.2-.9-1.9-2-1.9zm-15.4 5c-1.1-1.8-2.6-3.2-4.5-4.1-3.5-1.7-7.2-1.9-10.6.1l-.5.3c-1.4.8-2.6 1.8-3.5 3.1-2.6 3.8-2.9 8.1-.6 12.1l.2.4c1 1.7 2.3 3.1 4 4 3.6 2 7.5 2.2 11.1.2l.3-.2c1-.6 1.2-1.6.7-2.6-.2-.4-.6-.7-1-.9h-.2c-.7-.1-2.6.7-3.3 1-1.4.2-3 .3-4.4-.2l7.6-6.6c1.1-1 2.3-2.1 3.5-3 1-.8 2-1.9 1.2-3.3v-.3zm-6.9 3.6l-8.5 7.3c-.3-.3-.5-.7-.7-1-.6-1-1-2.2-1-3.4-.1-3 1-5.5 3.7-7 2-1.2 4.2-1.4 6.4-.6 1.1.4 2.4 1.1 3.1 2.1-1 .9-2.1 1.7-3 2.6zM22 91h-.3c-1.1 0-1.7.4-1.7 1.5v8.1c-2-1.8-4.4-2.5-7.2-2.5H12c-1.9 0-3.7.3-5.4 1.3-3.6 2.1-5.6 5.2-5.6 9.4v.8c0 1.9.5 3.5 1.5 5.2 2.1 3.6 5.4 5.4 9.5 5.4h.8c1.9 0 3.9-.3 5.5-1.2 3.6-2.1 5.7-5.2 5.7-9.3v-17c0-1.3-.9-1.7-2-1.7zm-3.1 21.8c-1.5 2.5-3.7 3.9-6.6 3.9-1.2 0-2.4-.3-3.4-.9-2.6-1.4-4.1-3.7-4.1-6.7 0-1.1.2-2.1.7-3.1 1.4-2.9 3.7-4.5 6.9-4.5 1.6 0 3 .5 4.2 1.4 2.1 1.5 3.3 3.5 3.3 6.1.1 1.4-.3 2.6-1 3.8zM37.6 98H37c-1.9 0-3.8.3-5.4 1.3-3.6 2.1-5.6 5.2-5.6 9.4v.8c0 1.9.5 3.5 1.5 5.2 2.1 3.6 5.4 5.4 9.6 5.4h.8c1.9 0 3.8-.3 5.5-1.2 3.6-2.1 5.7-5.2 5.7-9.3v-.8c0-1.8-.6-3.3-1.4-4.8-2.2-4-5.7-6-10.1-6zm6.4 14.8c-1.5 2.4-3.6 3.9-6.5 3.9-1.3 0-2.6-.3-3.8-1-2.5-1.5-3.9-3.6-3.9-6.5 0-1.1.2-2.1.7-3.1 1.4-2.9 3.7-4.5 6.9-4.5 1.5 0 2.8.4 4 1.2 2.2 1.5 3.5 3.6 3.5 6.3.1 1.2-.2 2.5-.9 3.7zm24.5-13.4l-.1.1c-1.7-1.1-3.6-1.5-5.6-1.5H62c-1.9 0-3.8.3-5.4 1.3-3.6 2.1-5.6 5.2-5.6 9.3v.8c0 1 .2 1.9.4 2.9 1.6 5.5 5.9 8.6 11.7 8.2 1.6-.1 5.9-.6 5.9-3v-.4c0-.9-.7-1.7-1.5-1.9l-.1-.2h-.7l-.2.3c-.9.4-2.4 1.2-3.4 1.2-1.2 0-2.5 0-3.6-.6-2.9-1.4-4.6-3.7-4.6-6.9 0-1.1.2-2.1.7-3.1 1.4-2.8 3.7-4.6 6.9-4.5.6 0 1.7.3 2.3.6.5.2 1.8 1 2.4 1h.2l.1-.2c.9-.2 1.6-.9 1.6-1.8v-.4c0-.4-.2-.7-.4-1l-.2-.2zM5.8 68.2l.1.2c7.9 13.4 21.7 19 36.8 19 29.2 0 53.3-13.1 64.3-40.6 7.4.4 15-1.8 18.6-8.9l.9-1.8-1.8-1c-4.3-2.5-10-2.8-14.8-1.4-.6-5.2-4-9.7-8-12.9l-1.6-1.3-1.3 1.6c-2.7 3.1-3.5 8.3-3.1 12.3.3 2.9 1.2 5.9 3 8.3-1.4.8-2.9 1.9-4.3 2.4-2.8 1-5.9 2-8.9 2H79V32H66V7H51v12H26v13H13v14H1.8l-.2 1.5c-.5 6.4.3 12.6 3 18.5l1.2 2.2zM66 35h11v11H66V35zM53 9h11v11H53V9zm0 13h11v11H53V22zm0 13h11v11H53V35zM40 22h11v11H40V22zm0 13h11v11H40V35zm1.1 31.2c0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1 1.7.1 3.1 1.4 3.1 3.1zM28 22h10v11H28V22zm0 13h10v11H28V35zm-13 0h11v11H15V35zm2.4 38c1.6 0 3.2 0 4.7-.1 3.9-.2 7.3-.7 10.1-1.5 2.3 5.3 6.5 10.2 14 13.8l-3.5.1c-15.8-.1-24.3-5.4-31.3-12.4 2.1.1 4.1.1 6 .1zM38 68.4c1.2 0 2.2-1 2.2-2.2 0-.3-.1-.6-.2-.8-.2.3-.4.5-.8.5-.5 0-.9-.4-.9-.9 0-.3.2-.6.4-.8-.1-.1-.4-.2-.7-.2-1.2 0-2.2 1-2.2 2.2.1 1.2 1 2.2 2.2 2.2z\" fill=\"#019BC6\"/></svg>"

/***/ }),

/***/ "../src/components/docker/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DockerPlainWordmark = __webpack_require__("../src/components/docker/plain-wordmark/DockerPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DockerPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/docker/plain/DockerPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DockerPlain = __webpack_require__("../src/components/docker/plain/DockerPlain.svg");
	
	var _DockerPlain2 = _interopRequireDefault(_DockerPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DockerPlain */
	function DockerPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DockerPlain',
	    svg: _DockerPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DockerPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DockerPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/docker/plain/DockerPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M124.8 52.1c-4.3-2.5-10-2.8-14.8-1.4-.6-5.2-4-9.7-8-12.9l-1.6-1.3-1.4 1.6c-2.7 3.1-3.5 8.3-3.1 12.3.3 2.9 1.2 5.9 3 8.3-1.4.8-2.9 1.9-4.3 2.4-2.8 1-5.9 2-8.9 2H79V49H66V24H51v12H26v13H13v14H1.8l-.2 1.5c-.5 6.4.3 12.6 3 18.5l1.1 2.2.1.2c7.9 13.4 21.7 19 36.8 19 29.2 0 53.3-13.1 64.3-40.6 7.4.4 15-1.8 18.6-8.9l.9-1.8-1.6-1zM28 39h10v11H28V39zm13.1 44.2c0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1 1.7.1 3.1 1.4 3.1 3.1zM28 52h10v11H28V52zm-13 0h11v11H15V52zm27.7 50.2c-15.8-.1-24.3-5.4-31.3-12.4 2.1.1 4.1.2 5.9.2 1.6 0 3.2 0 4.7-.1 3.9-.2 7.3-.7 10.1-1.5 2.3 5.3 6.5 10.2 14 13.8h-3.4zM51 63H40V52h11v11zm0-13H40V39h11v11zm13 13H53V52h11v11zm0-13H53V39h11v11zm0-13H53V26h11v11zm13 26H66V52h11v11zM38.8 81.2c-.2-.1-.5-.2-.8-.2-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2c0-.3-.1-.6-.2-.8-.2.3-.4.5-.8.5-.5 0-.9-.4-.9-.9.1-.4.3-.7.5-.8z\" fill=\"#019BC6\"/></svg>"

/***/ }),

/***/ "../src/components/docker/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DockerPlain = __webpack_require__("../src/components/docker/plain/DockerPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DockerPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/doctrine/line-wordmark/DoctrineLineWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DoctrineLineWordmark = __webpack_require__("../src/components/doctrine/line-wordmark/DoctrineLineWordmark.svg");
	
	var _DoctrineLineWordmark2 = _interopRequireDefault(_DoctrineLineWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DoctrineLineWordmark */
	function DoctrineLineWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DoctrineLineWordmark',
	    svg: _DoctrineLineWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DoctrineLineWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DoctrineLineWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/doctrine/line-wordmark/DoctrineLineWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M100.5 61.2c-.1-2.3-.5-4.7-1.1-7.2-1.5-5.8-4.5-11.1-9-16.2-2.2-2.5-4.6-5.1-6.8-7.5l-3-3.3-4.7-5.1c-4.6-5.1-9.3-10.1-14-15.2-1.2-1.3-2.6-2.8-4.1-4C54.9.4 51.4-.2 47.7 1c-1.1.3-2 .9-2.9 1.3-.7.4-1.4 1-1.9 1.6-1.8 2.1-2.5 4.8-2.1 8.1.2 2.2 1.2 4.3 3.1 6.3l6.7 7.3 2.5 2.8c-5.6 2.7-10.5 6.1-14.6 10.1-3.6 3.4-6 6.7-7.6 10.2-2.7 5.7-3.7 12-3.2 19.3.2 2.7.8 5.5 1.9 8.3 1.6 4.1 4 7.8 7.4 11.5 6.6 7.1 14.9 11 24.6 11.5l1.9.1c1.3 0 2.5-.1 3.7-.1 2.3-.1 4.8-.5 7.5-1.2 6.9-1.8 12.8-5.5 17.3-11 5.9-7.5 8.8-16.2 8.5-25.9zm-11 23.9c-4.1 5-9.4 8.4-15.7 10-2.5.6-4.8 1-6.9 1.1-1.8.1-3.5.2-5.3.1-8.9-.5-16.5-4.1-22.5-10.6-3.1-3.4-5.3-6.8-6.8-10.5-1-2.5-1.5-5-1.7-7.4-.5-6.8.5-12.6 2.9-17.8 1.5-3.2 3.7-6.1 7-9.3 4.2-4.1 9.1-7.4 14.8-10.1l.6-.3c.3-.1.4-.3.6-.5l1-1-4.8-5.2-6.7-7.3c-1.4-1.5-2.1-3-2.3-4.6-.3-2.5.2-4.4 1.4-5.9.3-.3.7-.7 1.1-.9.7-.4 1.5-.8 2.2-1.1 1-.3 1.9-.4 2.7-.4 1.7 0 3.2.5 4.5 1.7 1.4 1.1 2.6 2.4 3.8 3.7l14 15.2 4.7 5.1 3 3.3c2.2 2.4 4.6 4.9 6.8 7.4 4.2 4.8 7 9.7 8.4 15 .6 2.3.9 4.4 1 6.5.5 9-2.2 16.9-7.8 23.8zm-8-31.6l-6.2-6.3-1.2-1.2-1.9-1.9c-1.7-1.7-3.4-3.5-5.2-5.2-2-1.9-4.1-2.7-6.5-2.6-2.9.2-5.1 1.4-6.5 3.7-.6 1-1 2.2-.9 3.4.1 2.1 1 4.1 2.7 5.8l4.2 4.2c.7.7 1.4 1.4 2.1 2H47c-1.1 0-2.1 0-2.9.1-1.7.1-3.3.7-4.4 1.9-2.1 2-2.9 4.7-2.3 7.7.6 3 2.4 5 5.3 5.6 1 .2 2 .2 2.8.3 2.4.1 4.8.2 7.2.2h9.4l-4.2 4.2c-1.7 1.7-2.9 3.3-3.7 5-.8 1.7-1 3.3-.4 4.8 1 2.9 3.9 4.9 7.1 4.9 1.4 0 2.8-.4 3.9-1.2 1.2-.8 2.3-1.8 3.2-2.7l13.5-12.7c2.5-2.4 4.3-5 5.3-7.8.3-.7.4-1.6.4-2.4 0-1.7-.7-3.1-1.3-4.1-1.3-2.4-3-4.3-4.4-5.7zM84 64.6c-.9 2.4-2.4 4.6-4.6 6.7-4.5 4.3-9 8.5-13.5 12.7-.9.9-1.9 1.8-2.9 2.5-.6.4-1.3.6-2.2.6-1.6 0-3.6-.9-4.3-2.9-.3-.8-.2-1.6.3-2.6.7-1.4 1.7-2.7 3.1-4.2 1.4-1.5 2.9-2.9 4.3-4.3l2-1.9.3-.4 2.6-2.8h-5.4l-1.7.1c-1.3 0-2.6 0-3.9.1-.7 0-1.3 0-2 .1l-2.9.1h-.6c-2.4 0-4.7-.1-7.1-.2-.7 0-1.6-.1-2.3-.2-1.6-.3-2.6-1.4-2.9-3.2-.4-2.1.1-3.7 1.4-5 .8-.8 1.8-1 2.5-1 .8 0 1.7-.1 2.7-.1l1.8.2c.6 0 1.2.2 1.9.2l18.5-.2-3.1-3.5-1.6-1.8-2.3-2.2c-1.4-1.3-2.8-2.7-4.1-4.1-1.1-1.2-1.8-2.5-1.8-3.9 0-.6.1-1.2.5-1.7.9-1.5 2.2-2.2 4.1-2.3 1.5-.1 2.9.5 4.2 1.8 1.7 1.7 3.5 3.4 5.1 5.1l1.9 1.9 1.2 1.2c2.1 2.1 4.2 4.2 6.2 6.3 1.2 1.3 2.8 2.9 3.9 5 .6 1.1.9 2 .9 2.8 0 .3-.1.7-.2 1.1zm-71 45.8c-1-1.6-2.8-2.3-4.6-2.3-2 0-3.6.7-5 2.2-1.3 1.5-2 3.6-2 6.5 0 2.8.7 4.9 2.1 6.5 1.4 1.6 3 2.3 5 2.3.9 0 2-.2 2.9-.7.9-.5 1.6-1.2 2.6-2.1v2.3h4v-23h-5v8.3zm-.6 10.3c-.7.9-1.6 1.3-2.6 1.3-1.3 0-2.3-.6-3-1.7-.5-.8-.7-2.1-.7-3.9 0-1.7.4-2.9 1.1-3.8.7-.8 1.6-1.3 2.6-1.3 1.1 0 2 .4 2.7 1.3.7.8 1 2.2 1 4.2 0 1.8-.4 3.1-1.1 3.9zM29.9 108c-1.6 0-3.1.4-4.5 1.1-1.3.7-2.4 1.8-3.1 3.2-.7 1.4-1.1 2.8-1.1 4.3 0 1.9.4 3.6 1.1 4.9.7 1.3 1.8 2.4 3.2 3.1 1.4.7 2.9 1 4.4 1 2.5 0 4.5-.8 6.2-2.5 1.6-1.7 2.5-3.8 2.5-6.3s-.8-4.6-2.4-6.2c-1.7-1.8-3.8-2.6-6.3-2.6zm2.9 12.6c-.8.9-1.8 1.3-2.9 1.3-1.2 0-2.1-.4-2.9-1.3-.8-.9-1.2-2.2-1.2-3.8s.4-2.9 1.2-3.8c.8-.9 1.8-1.3 2.9-1.3 1.2 0 2.1.4 2.9 1.3.8.9 1.2 2.1 1.2 3.8 0 1.6-.4 2.9-1.2 3.8zm18.6.6c-.5.5-1.2.7-2.1.7-1.1 0-2-.4-2.7-1.2-.7-.8-1-2.2-1-4.2 0-1.8.3-3.1 1-3.8.7-.8 1.5-1.1 2.6-1.1.8 0 1.5.2 2 .7s.9 1.1 1 2l4.4-.8c-.5-1.8-1.4-3.1-2.6-4-1.2-.9-2.8-1.3-4.9-1.3-2.5 0-4.5.8-5.9 2.3-1.5 1.5-2.2 3.7-2.2 6.5 0 2.7.7 4.9 2.2 6.4 1.5 1.5 3.4 2.3 5.9 2.3 2.2 0 3.9-.5 5.2-1.5 1.3-1 2.2-2.5 2.6-4.5l-4.4-.7c-.2.9-.6 1.7-1.1 2.2zm14.5.7c-.3 0-.5-.1-.8-.2-.2-.1-.2-.3-.2-.6-.1-.2.1-1 .1-2.4V112h3v-4h-3v-5.5l-5 2.6v2.9h-2v4h2v7.3c0 1.6.2 2.6.2 3.1.1.7.4 1.3.7 1.7.3.4.8.8 1.4 1 .6.3 1.4.4 2.2.4 1.3 0 2.5-.2 3.5-.7l-.4-3.4c-.7.3-1.3.5-1.7.5zm10.9-13.3c-.6.4-1.8 1.1-1.8 2.2V108h-4v17h4v-5c0-2.9.1-4.7.4-5.6s.6-1.5 1-1.9c.4-.3 1-.5 1.6-.5.6 0 1.3.2 2.1.7l1.4-3.9c-.9-.6-1.8-.8-2.9-.8-.7 0-1.3.2-1.8.6zM83 102h5v4h-5zm0 6h5v17h-5zm23.5 1.9c-.4-.5-1-1-1.8-1.4-.8-.4-1.9-.5-2.9-.5-2.2 0-3.8.9-5.8 2.8V108h-4v17h5v-7.4c0-1.9 0-3.2.2-3.9.2-.7.6-1.3 1.2-1.7.6-.4 1.3-.6 2-.6.6 0 1.1.1 1.5.4.4.3.6.7.8 1.2.2.5.2 1.7.2 3.5v8.4h5v-10.2c0-1.3-.3-2.3-.4-3-.1-.6-.6-1.2-1-1.8zm14.3 11.8c-.5.4-1.1.6-1.8.6-1 0-1.9-.4-2.6-1.1-.7-.7-1-2.1-1.1-3.1h11.1c.1-3-.6-5.9-2.1-7.5-1.4-1.6-3.4-2.5-5.9-2.5-2.2 0-4.1.8-5.5 2.4-1.5 1.6-2.2 3.8-2.2 6.5 0 2.3.6 4.3 1.7 5.8 1.4 1.9 3.6 2.9 6.5 2.9 1.8 0 3.4-.4 4.6-1.3 1.2-.8 2.1-2.1 2.7-3.7l-4.4-.7c-.2.7-.6 1.3-1 1.7zm-4.4-9.4c.6-.7 1.4-1 2.4-1 .9 0 1.7.2 2.3.9s1 1.8 1 2.8h-6.6c-.1-1 .3-2 .9-2.7z\" fill=\"#F56D39\"/></svg>"

/***/ }),

/***/ "../src/components/doctrine/line-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DoctrineLineWordmark = __webpack_require__("../src/components/doctrine/line-wordmark/DoctrineLineWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DoctrineLineWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/doctrine/line/DoctrineLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DoctrineLine = __webpack_require__("../src/components/doctrine/line/DoctrineLine.svg");
	
	var _DoctrineLine2 = _interopRequireDefault(_DoctrineLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DoctrineLine */
	function DoctrineLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DoctrineLine',
	    svg: _DoctrineLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DoctrineLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DoctrineLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/doctrine/line/DoctrineLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M110.1 78.5c-.1-2.9-.6-5.9-1.4-9-2-7.3-5.7-14-11.4-20.6-2.8-3.2-5.8-6.5-8.7-9.6-1.3-1.4-2.6-2.8-3.8-4.2l-6.1-6.6L61 9.2c-1.6-1.7-3.3-3.5-5.2-5.1C52.2 1.3 47.9.6 43.3 2c-1.3.4-2.5 1.1-3.6 1.7-.9.5-1.7 1.2-2.3 1.9-2.2 2.6-3 5.9-2.6 10.1.3 2.8 1.5 5.3 3.8 7.8l8.1 8.9 4.1 4.4c-7.3 3.5-13.7 7.9-19.1 13.1-4.5 4.4-7.6 8.4-9.7 12.9-3.4 7.2-4.7 15.2-4.1 24.4.2 3.4 1.1 6.9 2.4 10.4 2 5.2 5 9.9 9.3 14.5 8.4 9 18.8 13.9 31.1 14.6.8 0 1.5.1 2.4.1 1.6 0 3.2-.1 4.7-.2 2.9-.2 6-.6 9.4-1.5 8.8-2.2 16.1-6.9 21.9-13.9 7.8-9.5 11.5-20.4 11-32.7zm-13.2 30.7c-5.3 6.5-12.2 10.9-20.3 12.9-3.2.8-6.1 1.3-8.9 1.4-2.2.1-4.5.2-6.8.1-11.5-.7-21.3-5.2-29.1-13.7-4-4.3-6.9-8.8-8.7-13.6-1.2-3.2-2-6.5-2.2-9.6-.6-8.7.6-16.2 3.8-22.9 1.9-4.1 4.8-7.9 9-12 5.4-5.2 11.6-9.5 19.1-12.9l.8-.4c.3-.1.5-.3.6-.5l.9-1-6.3-6.8-8.1-8.9c-1.8-2-2.8-4-3-6.1-.3-3.2.3-5.7 1.9-7.7.4-.5 1-.9 1.6-1.3.9-.5 1.9-1.1 3-1.4 1.3-.4 2.5-.6 3.6-.6 2.2.1 4.2.8 6.1 2.3 1.8 1.4 3.4 3.1 4.9 4.8l17.7 19.3 6.1 6.6 3.9 4.2c2.9 3.1 5.8 6.3 8.7 9.5 5.4 6.2 9 12.5 10.8 19.4.8 2.9 1.2 5.7 1.3 8.4.3 11.4-3.1 21.7-10.4 30.5zM86 68.9c-2.6-2.7-5.2-5.3-7.9-7.9l-1.6-1.6c-.8-.8-1.6-1.6-2.4-2.5-2.1-2.2-4.4-4.4-6.6-6.6-2.4-2.3-5-3.4-7.9-3.2-3.5.2-6.2 1.7-8 4.6-.8 1.3-1.2 2.7-1.1 4.1.1 2.6 1.2 5 3.3 7.1 1.7 1.8 3.6 3.6 5.3 5.3L62 71l.5.5H42.2c-1.4 0-2.6 0-3.7.1-2.1.1-4 .9-5.4 2.3-2.5 2.5-3.5 5.8-2.8 9.5.7 3.6 3 6 6.4 6.8 1.2.3 2.4.3 3.5.3l9.2.3h.8c1.2 0 2.5 0 3.7-.1h8.5l-.4.5c-1.9 1.8-3.7 3.7-5.6 5.6-2.1 2.2-3.6 4.2-4.6 6.3-1 2.1-1.2 4-.5 5.9 1.2 3.6 4.7 6 8.7 6 1.7 0 3.4-.5 4.7-1.4 1.5-1 2.8-2.3 4.1-3.4 5.9-5.5 11.7-11 17.3-16.3 3.2-3 5.4-6.2 6.7-9.8.3-.9.5-1.9.5-2.8-.1-2-.9-3.8-1.6-5.1-1.8-3.1-3.9-5.5-5.7-7.3zm3.9 14c-1.2 3.2-3.1 6-6 8.7-5.6 5.3-11.4 10.8-17.2 16.3-1.2 1.1-2.4 2.2-3.7 3.2-.8.6-1.9.9-3 .9-2.2 0-4.9-1.3-5.9-4-.4-1.1-.2-2.3.4-3.6.9-1.8 2.2-3.6 4.1-5.5 1.8-1.9 3.7-3.7 5.6-5.5l2.5-2.5.4-.4 2.6-2.7H54.1l-3.7.1h-.8c-3 0-6-.1-9.1-.3-1 0-2-.1-3-.3-2.3-.5-3.6-1.9-4.1-4.4-.5-2.8.1-5 2-6.8 1.1-1.1 2.5-1.4 3.5-1.4 1-.1 2.1-.1 3.5-.1h27.2l-3.3-3.4-2.1-2.2c-1-1-1.9-1.9-2.9-2.8L56 61c-1.5-1.6-2.4-3.4-2.4-5.2 0-.8.2-1.6.6-2.4 1.2-2 3.1-3 5.6-3.2 2.1-.1 3.9.7 5.7 2.4 2.2 2.1 4.4 4.3 6.6 6.5.8.8 1.6 1.6 2.4 2.5l1.6 1.6c2.6 2.6 5.2 5.3 7.9 7.9 1.6 1.6 3.6 3.8 5 6.4.8 1.5 1.2 2.6 1.2 3.7 0 .6-.1 1.2-.3 1.7z\" fill=\"#F56D39\"/></svg>"

/***/ }),

/***/ "../src/components/doctrine/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DoctrineLine = __webpack_require__("../src/components/doctrine/line/DoctrineLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DoctrineLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/doctrine/original-wordmark/DoctrineOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DoctrineOriginalWordmark = __webpack_require__("../src/components/doctrine/original-wordmark/DoctrineOriginalWordmark.svg");
	
	var _DoctrineOriginalWordmark2 = _interopRequireDefault(_DoctrineOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DoctrineOriginalWordmark */
	function DoctrineOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DoctrineOriginalWordmark',
	    svg: _DoctrineOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DoctrineOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DoctrineOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/doctrine/original-wordmark/DoctrineOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#F56D39\" d=\"M55.4 28c-.8-.9-1.6-1.8-2.4-2.6l-8.3-9c-1.4-1.6-2.5-3.4-2.7-5.5-.3-2.6 0-5 1.8-7.1.4-.5 1-.9 1.5-1.3.8-.5 1.7-.9 2.6-1.2 3.2-1 6.2-.6 8.8 1.5 1.4 1.2 2.7 2.5 4 3.9 6.3 6.8 12.6 13.7 18.9 20.6 3.3 3.6 6.7 7.2 9.9 10.9 4.1 4.6 7.2 9.8 8.8 15.8.6 2.3 1 4.6 1.1 6.9.4 9.4-2.4 17.8-8.4 25.1-4.4 5.4-10 8.9-16.7 10.7-2.4.6-4.8 1-7.3 1.2-1.8.1-3.7.2-5.5.1-9.4-.5-17.4-4.3-23.9-11.2-3.1-3.3-5.5-6.9-7.2-11.1-1-2.6-1.6-5.2-1.8-7.9-.5-6.5.3-12.8 3.1-18.7 1.8-3.8 4.4-7 7.4-9.9 4.5-4.4 9.7-7.8 15.4-10.5l.6-.3c.2-.2.2-.3.3-.4zm10.3 41.4c-.2.2-.3.3-.4.5l-6.4 6.3c-1.4 1.4-2.6 2.9-3.4 4.7-.6 1.2-.8 2.5-.4 3.8 1.3 3.7 5.9 5.1 8.8 3.1C65 87 66 86.1 67 85.2l13.7-12.9c2.2-2.1 4-4.5 5-7.4.2-.6.3-1.2.3-1.8 0-1.3-.5-2.4-1.1-3.5-1.1-2-2.6-3.7-4.2-5.4l-7.5-7.5c-2.4-2.4-4.7-4.8-7.2-7.1-1.5-1.4-3.3-2.3-5.4-2.2-2.3.1-4.2 1.1-5.4 3.1-.5.8-.7 1.7-.7 2.6.1 1.9 1 3.6 2.3 4.9 2.1 2.2 4.3 4.3 6.5 6.4.8.8 1.6 1.7 2.3 2.4H50.4c-2.2 0-4.4-.1-6.5 0-1.3.1-2.5.5-3.5 1.5-1.8 1.8-2.3 4-1.9 6.5.4 2.3 1.8 3.9 4.2 4.4.8.2 1.7.2 2.6.2 2.4.1 4.8.2 7.2.2l5.6-.1h4.4c1-.1 2-.1 3.2-.1z\"/><path fill=\"#fff\" d=\"M65.7 69.4h-7.6l-5.6.1c-2.4 0-4.8-.1-7.2-.2-.9 0-1.7-.1-2.6-.2-2.4-.5-3.7-2.1-4.2-4.4-.5-2.4.1-4.7 1.9-6.5 1-.9 2.2-1.4 3.5-1.5 2.2-.1 4.3 0 6.5 0h15.2c-.7-.8-1.5-1.6-2.3-2.4-2.2-2.2-4.4-4.2-6.5-6.4-1.3-1.4-2.2-3-2.3-4.9 0-.9.2-1.8.7-2.6 1.2-2 3.1-2.9 5.4-3.1 2.2-.1 3.9.8 5.4 2.2 2.4 2.3 4.8 4.7 7.2 7.1l7.5 7.5c1.6 1.6 3.1 3.4 4.2 5.4.6 1.1 1.1 2.2 1.1 3.5 0 .6-.1 1.2-.3 1.8-1.1 2.9-2.8 5.3-5 7.4-4.5 4.3-9.1 8.6-13.7 12.9-1 .9-2 1.8-3.1 2.6-2.9 2-7.6.6-8.8-3.1-.4-1.3-.2-2.6.4-3.8.9-1.8 2.1-3.3 3.4-4.7l6.4-6.3c.1-.1.2-.3.4-.4z\"/><path d=\"M17.9 125.2h-4.1v-2.5c-.7 1-1.5 1.7-2.4 2.1-.9.5-1.9.7-2.8.7-1.9 0-3.6-.8-5-2.3-1.4-1.6-2.1-3.7-2.1-6.5s.7-5 2-6.5 3-2.2 5.1-2.2c1.9 0 3.5.8 4.9 2.3V102h4.4v23.2zM6 116.4c0 1.8.2 3.1.7 3.9.7 1.2 1.7 1.7 3 1.7 1 0 1.9-.4 2.6-1.3.7-.9 1.1-2.2 1.1-3.9 0-1.9-.3-3.3-1-4.2-.7-.8-1.6-1.3-2.7-1.3s-1.9.4-2.6 1.3c-.7.9-1.1 2.2-1.1 3.8zm15.2.2c0-1.5.4-2.9 1.1-4.3.7-1.4 1.8-2.4 3.1-3.2 1.3-.7 2.8-1.1 4.5-1.1 2.5 0 4.6.8 6.2 2.5 1.6 1.6 2.4 3.7 2.4 6.2s-.8 4.6-2.5 6.3c-1.6 1.7-3.7 2.5-6.2 2.5-1.5 0-3-.3-4.4-1-1.4-.7-2.5-1.7-3.2-3.1-.6-1.3-1-2.9-1-4.8zm4.6.2c0 1.7.4 2.9 1.2 3.8.8.9 1.8 1.3 2.9 1.3 1.2 0 2.1-.4 2.9-1.3.8-.9 1.2-2.2 1.2-3.9 0-1.6-.4-2.9-1.2-3.8-.8-.9-1.8-1.3-2.9-1.3-1.2 0-2.1.4-2.9 1.3-.8 1-1.2 2.2-1.2 3.9zm30.8-3.4l-4.4.8c-.1-.9-.5-1.5-1-2s-1.2-.7-2-.7c-1.1 0-2 .4-2.6 1.1-.7.8-1 2-1 3.8 0 2 .3 3.4 1 4.2.7.8 1.6 1.2 2.7 1.2.8 0 1.5-.2 2.1-.7.5-.5.9-1.3 1.1-2.5l4.4.7c-.5 2-1.3 3.5-2.6 4.5s-3 1.5-5.2 1.5c-2.5 0-4.4-.8-5.9-2.3-1.5-1.5-2.2-3.7-2.2-6.4 0-2.8.7-4.9 2.2-6.5 1.5-1.5 3.4-2.3 5.9-2.3 2 0 3.7.4 4.9 1.3 1.3 1.1 2.1 2.5 2.6 4.3zm11.1-5v3.5h-3v6.8c0 1.4 0 2.2.1 2.4.1.2.2.4.4.6.2.1.5.2.8.2.4 0 1-.1 1.8-.4l.4 3.4c-1 .4-2.2.7-3.5.7-.8 0-1.5-.1-2.2-.4-.6-.3-1.1-.6-1.4-1-.3-.4-.5-1-.6-1.7-.1-.5-.1-1.6-.1-3.1v-7.3h-2v-3.5h2v-3.3l4.5-2.6v5.9h2.8zm7.3 16.8h-4.4v-16.8h4.1v2.4c.7-1.1 1.3-1.9 1.9-2.2s1.2-.5 1.9-.5c1 0 2 .3 2.9.8l-1.4 3.9c-.7-.5-1.4-.7-2.1-.7-.6 0-1.1.2-1.6.5-.4.3-.8 1-1 1.9s-.3 2.6-.3 5.5v5.2zm8.4-19.1V102h4.4v4.1h-4.4zm0 19.1v-16.8h4.4v16.8h-4.4zm24.2 0h-4.4v-8.6c0-1.8-.1-3-.3-3.5-.2-.5-.5-.9-.9-1.2-.4-.3-.9-.4-1.5-.4-.8 0-1.5.2-2.1.6-.6.4-1 1-1.3 1.7-.2.7-.3 2-.3 3.9v7.6h-4.4v-16.8h4.1v2.5c1.5-1.9 3.3-2.8 5.5-2.8 1 0 1.9.2 2.7.5.8.4 1.4.8 1.8 1.4.4.5.7 1.2.9 1.9.2.7.2 1.7.2 3v10.2zm14.2-5.4l4.4.7c-.6 1.6-1.5 2.9-2.7 3.7-1.2.8-2.8 1.3-4.6 1.3-2.9 0-5.1-1-6.5-2.9-1.1-1.5-1.7-3.5-1.7-5.8 0-2.8.7-5 2.2-6.5 1.5-1.6 3.3-2.4 5.5-2.4 2.5 0 4.5.8 5.9 2.5 1.4 1.6 2.1 4.2 2.1 7.6h-11.1c0 1.3.4 2.3 1.1 3.1.7.7 1.5 1.1 2.6 1.1.7 0 1.3-.2 1.8-.6.4-.3.8-.9 1-1.8zm.3-4.4c0-1.3-.4-2.3-1-2.9s-1.4-1-2.3-1c-1 0-1.8.4-2.4 1.1s-.9 1.7-.9 2.9h6.6z\" fill=\"#141414\"/></svg>"

/***/ }),

/***/ "../src/components/doctrine/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DoctrineOriginalWordmark = __webpack_require__("../src/components/doctrine/original-wordmark/DoctrineOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DoctrineOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/doctrine/original/DoctrineOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DoctrineOriginal = __webpack_require__("../src/components/doctrine/original/DoctrineOriginal.svg");
	
	var _DoctrineOriginal2 = _interopRequireDefault(_DoctrineOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DoctrineOriginal */
	function DoctrineOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DoctrineOriginal',
	    svg: _DoctrineOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DoctrineOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DoctrineOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/doctrine/original/DoctrineOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#F56D39\" d=\"M52.8 36.3c-1.1-1.2-2.1-2.3-3.1-3.4-3.6-3.9-7.2-7.8-10.7-11.7-1.9-2-3.2-4.4-3.5-7.1-.4-3.3.1-6.6 2.3-9.2.5-.7 1.3-1.2 2-1.7 1.1-.6 2.2-1.2 3.4-1.6 4.1-1.3 8.1-.8 11.5 2 1.9 1.5 3.5 3.3 5.2 5.1l24.6 26.8c4.3 4.7 8.7 9.3 12.9 14.2 5.3 6 9.4 12.8 11.5 20.6.8 3 1.3 5.9 1.4 9 .5 12.3-3.2 23.1-10.9 32.6-5.7 7-13 11.6-21.8 13.9-3.1.8-6.3 1.4-9.5 1.5-2.4.1-4.8.2-7.2.1-12.3-.7-22.7-5.5-31.1-14.6-4-4.3-7.2-9-9.3-14.5-1.3-3.3-2.1-6.8-2.4-10.3-.6-8.5.4-16.7 4.1-24.4 2.3-5 5.8-9.1 9.7-12.9C37.8 45 44.6 40.5 52 37.1c.3-.1.5-.2.8-.4-.2-.2-.1-.3 0-.4zm13.4 53.8l-.6.6c-2.8 2.8-5.6 5.5-8.3 8.3-1.8 1.8-3.4 3.8-4.5 6.1-.8 1.6-1.1 3.2-.5 4.9 1.6 4.8 7.7 6.6 11.5 4 1.4-1 2.8-2.2 4-3.4 6-5.6 11.9-11.2 17.8-16.8 2.9-2.7 5.2-5.9 6.6-9.6.3-.7.4-1.6.4-2.4 0-1.6-.7-3.1-1.5-4.6-1.4-2.6-3.4-4.9-5.5-7l-9.7-9.8c-3.1-3.1-6.1-6.3-9.3-9.3-1.9-1.8-4.3-3-7.1-2.9-3 .2-5.4 1.4-7 4-.6 1-1 2.2-.9 3.4.1 2.5 1.3 4.6 3 6.4 2.8 2.9 5.6 5.6 8.5 8.4 1.1 1.1 2.1 2.2 3 3.2H46.3c-2.8 0-5.7-.1-8.5.1-1.7.1-3.3.7-4.6 1.9-2.4 2.3-3.1 5.2-2.5 8.4.6 3 2.3 5.1 5.4 5.8 1.1.2 2.2.3 3.4.3l9.4.3c2.4 0 4.8-.1 7.3-.1h5.7c1.4-.2 2.8-.2 4.3-.2z\"/><path fill=\"#fff\" d=\"M66.2 90.1h-9.9c-2.4 0-4.8.1-7.3.1-3.1 0-6.3-.1-9.4-.3-1.1 0-2.3-.1-3.4-.3-3.1-.7-4.9-2.8-5.4-5.8-.6-3.2.1-6.1 2.5-8.4 1.3-1.2 2.9-1.8 4.6-1.9 2.8-.1 5.7-.1 8.5-.1h19.8c-1-1-2-2.1-3-3.2-2.8-2.8-5.7-5.5-8.5-8.4-1.7-1.8-2.8-3.9-3-6.4-.1-1.2.3-2.3.9-3.4 1.6-2.6 4-3.8 7-4 2.8-.2 5.1 1 7.1 2.9 3.2 3 6.2 6.2 9.3 9.3 3.3 3.3 6.5 6.5 9.7 9.8 2.1 2.1 4 4.4 5.5 7 .8 1.4 1.4 2.9 1.5 4.6 0 .8-.1 1.6-.4 2.4-1.4 3.7-3.7 6.9-6.6 9.6l-17.8 16.8c-1.3 1.2-2.6 2.4-4 3.4-3.7 2.6-9.8.8-11.5-4-.6-1.6-.3-3.3.5-4.9 1.1-2.3 2.7-4.3 4.5-6.1 2.7-2.8 5.5-5.5 8.3-8.3l.5-.4z\"/></svg>"

/***/ }),

/***/ "../src/components/doctrine/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DoctrineOriginal = __webpack_require__("../src/components/doctrine/original/DoctrineOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DoctrineOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/doctrine/plain-wordmark/DoctrinePlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DoctrinePlainWordmark = __webpack_require__("../src/components/doctrine/plain-wordmark/DoctrinePlainWordmark.svg");
	
	var _DoctrinePlainWordmark2 = _interopRequireDefault(_DoctrinePlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DoctrinePlainWordmark */
	function DoctrinePlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DoctrinePlainWordmark',
	    svg: _DoctrinePlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DoctrinePlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DoctrinePlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/doctrine/plain-wordmark/DoctrinePlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M89.2 86.8c6-7.3 8.8-15.7 8.5-25.2-.1-2.4-.5-4.7-1.1-7-1.6-6.1-4.8-11.3-8.9-15.9-3.3-3.7-6.7-7.3-10-10.9L58.7 7c-1.3-1.4-2.6-2.7-4-3.9C52 1 49 .6 45.8 1.6c-.9.3-1.8.7-2.6 1.2-.6.3-1.1.8-1.5 1.3-1.7 2.1-2.1 4.6-1.8 7.1.2 2.1 1.3 3.9 2.7 5.5 2.8 3 5.5 6 8.3 9.1l2.4 2.7c-.1.1-.1.2-.2.2l-.6.3c-5.7 2.7-11 6.1-15.5 10.5-3 2.9-5.7 6.1-7.5 9.9-2.8 6-3.6 12.3-3.1 18.9.2 2.8.9 5.4 1.8 8 1.6 4.2 4.1 7.9 7.2 11.2 6.5 7 14.5 10.7 24 11.3 1.8.1 3.7 0 5.6-.1 2.5-.1 4.9-.6 7.3-1.2 6.9-1.7 12.5-5.3 16.9-10.7zm-5.4-21.3c-1.1 2.9-2.9 5.3-5.1 7.4l-13.8 13c-1 .9-2 1.9-3.1 2.6-2.9 2-7.6.6-8.9-3.1-.4-1.3-.2-2.6.4-3.8.9-1.8 2.1-3.3 3.5-4.7 2.1-2.2 4.3-4.3 6.4-6.4.1-.1.3-.3.4-.5H56l-5.6.1c-2.4 0-4.8-.1-7.3-.2-.9 0-1.8-.1-2.6-.2-2.4-.5-3.7-2.1-4.2-4.5s.1-4.7 1.9-6.5c1-1 2.2-1.4 3.5-1.5 2.2-.1 4.4 0 6.6 0h15.3c-.7-.8-1.5-1.6-2.4-2.4-2.2-2.2-4.4-4.3-6.5-6.5-1.3-1.4-2.2-3-2.3-4.9 0-.9.2-1.8.7-2.6 1.2-2 3.1-3 5.4-3.1 2.2-.1 4 .8 5.5 2.2 2.5 2.3 4.8 4.8 7.2 7.2 2.5 2.5 5 5 7.5 7.6 1.6 1.6 3.1 3.4 4.2 5.4.6 1.1 1.1 2.3 1.1 3.5.1.7 0 1.3-.2 1.9zM15 110.4c-1-1.6-2.8-2.3-4.6-2.3-2 0-3.6.7-5 2.2-1.3 1.5-2 3.6-2 6.5 0 2.8.7 4.9 2.1 6.5 1.4 1.6 3 2.3 5 2.3.9 0 2-.2 2.9-.7.9-.5 1.6-1.2 2.6-2.1v2.3h4v-23h-5v8.3zm-.6 10.3c-.7.9-1.6 1.3-2.6 1.3-1.3 0-2.3-.6-3-1.7-.5-.8-.7-2.1-.7-3.9 0-1.7.4-2.9 1.1-3.8.7-.8 1.6-1.3 2.6-1.3 1.1 0 2 .4 2.7 1.3.7.8 1 2.2 1 4.2 0 1.8-.4 3.1-1.1 3.9zM31.9 108c-1.6 0-3.1.4-4.5 1.1-1.3.7-2.4 1.8-3.1 3.2-.7 1.4-1.1 2.8-1.1 4.3 0 1.9.4 3.6 1.1 4.9.7 1.3 1.8 2.4 3.2 3.1 1.4.7 2.9 1 4.4 1 2.5 0 4.5-.8 6.2-2.5 1.6-1.7 2.5-3.8 2.5-6.3s-.8-4.6-2.4-6.2c-1.7-1.8-3.8-2.6-6.3-2.6zm2.9 12.6c-.8.9-1.8 1.3-2.9 1.3-1.2 0-2.1-.4-2.9-1.3-.8-.9-1.2-2.2-1.2-3.8s.4-2.9 1.2-3.8c.8-.9 1.8-1.3 2.9-1.3 1.2 0 2.1.4 2.9 1.3.8.9 1.2 2.1 1.2 3.8 0 1.6-.4 2.9-1.2 3.8zm18.6.6c-.5.5-1.2.7-2.1.7-1.1 0-2-.4-2.7-1.2-.7-.8-1-2.2-1-4.2 0-1.8.3-3.1 1-3.8.7-.8 1.5-1.1 2.6-1.1.8 0 1.5.2 2 .7s.9 1.1 1 2l4.4-.8c-.5-1.8-1.4-3.1-2.6-4-1.2-.9-2.8-1.3-4.9-1.3-2.5 0-4.5.8-5.9 2.3-1.5 1.5-2.2 3.7-2.2 6.5 0 2.7.7 4.9 2.2 6.4 1.5 1.5 3.4 2.3 5.9 2.3 2.2 0 3.9-.5 5.2-1.5 1.3-1 2.2-2.5 2.6-4.5l-4.4-.7c-.2.9-.6 1.7-1.1 2.2zm14.5.7c-.3 0-.5-.1-.8-.2-.2-.1-.2-.3-.2-.6-.1-.2.1-1 .1-2.4V112h3v-4h-3v-5.5l-5 2.6v2.9h-2v4h2v7.3c0 1.6.2 2.6.2 3.1.1.7.4 1.3.7 1.7.3.4.8.8 1.4 1 .6.3 1.4.4 2.2.4 1.3 0 2.5-.2 3.5-.7l-.4-3.4c-.7.3-1.3.5-1.7.5zm10.9-13.3c-.6.4-1.8 1.1-1.8 2.2V108h-4v17h4v-5c0-2.9.1-4.7.4-5.6s.6-1.5 1-1.9c.4-.3 1-.5 1.6-.5.6 0 1.3.2 2.1.7l1.4-3.9c-.9-.6-1.8-.8-2.9-.8-.7 0-1.3.2-1.8.6zm6.2-.6h5v17h-5zm0-6h5v4h-5zm23.5 7.9c-.4-.5-1-1-1.8-1.4-.8-.4-1.9-.5-2.9-.5-2.2 0-3.8.9-5.8 2.8V108h-4v17h5v-7.4c0-1.9 0-3.2.2-3.9.2-.7.6-1.3 1.2-1.7.6-.4 1.3-.6 2-.6.6 0 1.1.1 1.5.4.4.3.6.7.8 1.2.2.5.2 1.7.2 3.5v8.4h5v-10.2c0-1.3-.3-2.3-.4-3-.1-.6-.6-1.2-1-1.8zm14.3 11.8c-.5.4-1.1.6-1.8.6-1 0-1.9-.4-2.6-1.1-.7-.7-1-2.1-1.1-3.1h11.1c.1-3-.6-5.9-2.1-7.5-1.4-1.6-3.4-2.5-5.9-2.5-2.2 0-4.1.8-5.5 2.4-1.5 1.6-2.2 3.8-2.2 6.5 0 2.3.6 4.3 1.7 5.8 1.4 1.9 3.6 2.9 6.5 2.9 1.8 0 3.4-.4 4.6-1.3 1.2-.8 2.1-2.1 2.7-3.7l-4.4-.7c-.2.7-.6 1.3-1 1.7zm-4.4-9.4c.6-.7 1.4-1 2.4-1 .9 0 1.7.2 2.3.9s1 1.8 1 2.8h-6.6c-.1-1 .3-2 .9-2.7z\" fill=\"#F56D39\"/></svg>"

/***/ }),

/***/ "../src/components/doctrine/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DoctrinePlainWordmark = __webpack_require__("../src/components/doctrine/plain-wordmark/DoctrinePlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DoctrinePlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/doctrine/plain/DoctrinePlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DoctrinePlain = __webpack_require__("../src/components/doctrine/plain/DoctrinePlain.svg");
	
	var _DoctrinePlain2 = _interopRequireDefault(_DoctrinePlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DoctrinePlain */
	function DoctrinePlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DoctrinePlain',
	    svg: _DoctrinePlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DoctrinePlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DoctrinePlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/doctrine/plain/DoctrinePlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#F56D39\" d=\"M112.3 79.1c-.1-3.1-.6-6.1-1.4-9-2.1-7.8-6.2-14.6-11.5-20.6-4.2-4.8-8.6-9.4-12.9-14.2L61.9 8.5c-1.6-1.8-3.3-3.5-5.2-5.1-3.4-2.8-7.3-3.2-11.5-2-1.2.4-2.3 1-3.4 1.6-.7.4-1.4 1-2 1.7-2.3 2.7-2.7 5.9-2.3 9.2.3 2.8 1.7 5.1 3.5 7.1 3.6 3.9 7.2 7.8 10.7 11.7l3.1 3.4-.2.2-.8.4c-7.4 3.5-14.2 7.9-20.1 13.6-3.9 3.8-7.3 7.9-9.7 12.9-3.7 7.8-4.7 16-4.1 24.4.3 3.6 1.1 7 2.4 10.3 2.1 5.5 5.3 10.2 9.3 14.5 8.4 9 18.8 13.9 31.1 14.6 2.4.1 4.8 0 7.2-.1 3.2-.2 6.3-.7 9.5-1.5 8.8-2.2 16.1-6.9 21.8-13.9 8-9.3 11.6-20.2 11.1-32.4zm-17.9 5c-1.4 3.7-3.7 6.9-6.6 9.6-5.9 5.6-11.8 11.2-17.8 16.8-1.3 1.2-2.6 2.4-4 3.4-3.7 2.6-9.8.8-11.5-4-.6-1.6-.3-3.3.5-4.9 1.1-2.3 2.7-4.3 4.5-6.1 2.7-2.8 5.5-5.5 8.3-8.3l.6-.6h-9.9c-2.4 0-4.8.1-7.3.1-3.1 0-6.3-.1-9.4-.3-1.1 0-2.3-.1-3.4-.3-3.1-.7-4.9-2.8-5.4-5.8-.6-3.2.1-6.1 2.5-8.4 1.3-1.2 2.9-1.8 4.6-1.9 2.8-.1 5.7-.1 8.5-.1h19.8c-1-1-2-2.1-3-3.2-2.8-2.8-5.7-5.5-8.5-8.4-1.7-1.8-2.8-3.9-3-6.4-.1-1.2.3-2.3.9-3.4 1.6-2.6 4-3.8 7-4 2.8-.2 5.1 1 7.1 2.9 3.2 3 6.2 6.2 9.3 9.3 3.3 3.3 6.5 6.5 9.7 9.8 2.1 2.1 4 4.4 5.5 7 .8 1.4 1.4 2.9 1.5 4.6-.1 1-.2 1.9-.5 2.6z\"/></svg>"

/***/ }),

/***/ "../src/components/doctrine/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DoctrinePlain = __webpack_require__("../src/components/doctrine/plain/DoctrinePlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DoctrinePlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/dot-net/original-wordmark/DotNetOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DotNetOriginalWordmark = __webpack_require__("../src/components/dot-net/original-wordmark/DotNetOriginalWordmark.svg");
	
	var _DotNetOriginalWordmark2 = _interopRequireDefault(_DotNetOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DotNetOriginalWordmark */
	function DotNetOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DotNetOriginalWordmark',
	    svg: _DotNetOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DotNetOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DotNetOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/dot-net/original-wordmark/DotNetOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M30.762 77.907h-1.74v-9.963c0-.787.051-1.745.144-2.875h-.039c-.164.661-.313 1.14-.444 1.436l-5.061 11.402h-.848l-5.071-11.319c-.142-.316-.292-.825-.443-1.519h-.038c.054.594.084 1.558.084 2.895v9.943h-1.679V63.07h2.296l4.552 10.347c.343.779.565 1.372.673 1.776h.071c.298-.811.534-1.42.711-1.82l4.651-10.303h2.179v14.837h.002zM36.118 77.907h-1.692V67.312h1.692v10.595zm.292-14.394c0 .313-.11.573-.328.787a1.074 1.074 0 0 1-.788.322c-.303 0-.566-.104-.782-.311-.216-.208-.322-.473-.322-.799 0-.306.106-.567.322-.779.216-.212.479-.314.782-.314.31 0 .575.103.788.314.218.213.328.474.328.78M46.691 77.417c-.812.499-1.781.746-2.902.746-1.52 0-2.742-.504-3.676-1.511-.908-.978-1.364-2.24-1.364-3.786 0-1.736.496-3.141 1.497-4.209.996-1.069 2.334-1.603 4.018-1.603.92 0 1.737.18 2.452.538v1.741c-.791-.555-1.627-.831-2.525-.831-1.079 0-1.957.377-2.637 1.128-.709.77-1.068 1.798-1.068 3.082 0 1.232.328 2.209.979 2.929.653.717 1.523 1.076 2.621 1.076.926 0 1.794-.305 2.606-.911v1.611h-.001zM54.786 69.031c-.299-.23-.729-.341-1.296-.341-.689 0-1.269.308-1.737.93-.532.694-.796 1.656-.796 2.886v5.401H49.26V67.311h1.697v2.185h.041c.249-.773.634-1.368 1.148-1.79a2.535 2.535 0 0 1 1.623-.58c.452 0 .787.049 1.016.145v1.759l.001.001zM64.237 72.628c0-1.356-.306-2.393-.918-3.103-.594-.683-1.425-1.024-2.495-1.024-1.054 0-1.9.345-2.533 1.036-.668.739-1.002 1.781-1.002 3.134 0 1.268.317 2.263.96 2.973.638.714 1.497 1.072 2.575 1.072 1.115 0 1.969-.364 2.554-1.085.573-.708.859-1.707.859-3.003m1.739-.059c0 1.688-.477 3.045-1.427 4.061-.954 1.021-2.237 1.531-3.852 1.531-1.59 0-2.856-.51-3.784-1.531-.91-.983-1.366-2.283-1.366-3.898 0-1.844.516-3.264 1.552-4.273.958-.936 2.24-1.407 3.846-1.407 1.58 0 2.814.493 3.704 1.469.882.98 1.327 2.33 1.327 4.048M74.387 75.073c0 .868-.323 1.585-.973 2.159-.709.62-1.683.93-2.908.93-1.002 0-1.881-.21-2.628-.638V75.7c.83.675 1.748 1.015 2.754 1.015 1.343 0 2.016-.495 2.016-1.48a1.31 1.31 0 0 0-.445-1.023c-.298-.271-.878-.594-1.739-.974-.887-.388-1.52-.787-1.893-1.2-.448-.491-.673-1.129-.673-1.915 0-.879.352-1.611 1.046-2.194.697-.585 1.592-.877 2.691-.877.842 0 1.596.164 2.266.497v1.707c-.699-.504-1.498-.755-2.405-.755-.562 0-1.013.14-1.349.412a1.32 1.32 0 0 0-.51 1.068c0 .469.142.834.425 1.096.252.241.786.536 1.591.879.904.379 1.558.772 1.956 1.174.517.508.778 1.156.778 1.943M84.753 72.628c0-1.356-.307-2.393-.92-3.103-.594-.683-1.426-1.024-2.494-1.024-1.055 0-1.9.345-2.536 1.036-.667.739-1 1.781-1 3.134 0 1.268.319 2.263.954 2.973.646.714 1.506 1.072 2.582 1.072 1.117 0 1.968-.364 2.554-1.085.572-.708.86-1.707.86-3.003m1.742-.059c0 1.688-.481 3.045-1.433 4.061-.95 1.021-2.233 1.531-3.848 1.531-1.592 0-2.857-.51-3.786-1.531-.909-.983-1.366-2.283-1.366-3.898 0-1.844.521-3.264 1.551-4.273.958-.936 2.241-1.407 3.849-1.407 1.581 0 2.813.493 3.7 1.469.883.98 1.333 2.33 1.333 4.048M93.968 63.711a2.278 2.278 0 0 0-1.126-.278c-1.188 0-1.777.747-1.777 2.245v1.633h2.483v1.438h-2.483v9.158h-1.698v-9.158h-1.802v-1.438h1.802v-1.717c0-1.166.357-2.081 1.084-2.74.622-.573 1.383-.857 2.289-.857.524 0 .932.063 1.228.184v1.53zM100.662 77.801c-.4.229-.934.343-1.593.343-1.85 0-2.774-1.042-2.774-3.128V68.75h-1.818v-1.439h1.818v-2.585c.542-.171 1.105-.357 1.7-.55v3.135h2.667v1.439h-2.667v5.979c0 .71.116 1.218.359 1.513.245.305.646.454 1.211.454.423 0 .788-.113 1.097-.342v1.447zM8.978 119.262c0 .831-.295 1.548-.895 2.155a2.939 2.939 0 0 1-2.17.909 2.823 2.823 0 0 1-2.116-.909 3.009 3.009 0 0 1-.868-2.155c0-.854.289-1.575.868-2.171a2.832 2.832 0 0 1 2.116-.896c.85 0 1.574.301 2.17.907.6.607.895 1.327.895 2.16M46.953 121.702h-5.532L21.342 90.694a14.226 14.226 0 0 1-1.217-2.442h-.165c.144.831.216 2.613.216 5.343v28.107h-4.559V82.799h5.918l19.478 30.52c.775 1.211 1.306 2.079 1.575 2.601h.108c-.18-1.119-.274-3.027-.274-5.72V82.8h4.532v38.902h-.001zM76.186 121.702H55.567V82.799h19.724v4.123H60.123v12.941h14.054v4.124H60.123v13.591h16.063v4.124zM107.46 86.922H96.254v34.781h-4.558V86.922H80.468v-4.125h26.992v4.125z\"/><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"62.394\" y1=\"415.348\" x2=\"62.782\" y2=\"415.348\" gradientTransform=\"matrix(0 149.735 149.735 0 -62135.543 -9336.014)\"><stop offset=\"0\" stop-color=\"#0994DC\"/><stop offset=\".35\" stop-color=\"#66CEF5\"/><stop offset=\".35\" stop-color=\"#66CEF5\"/><stop offset=\".846\" stop-color=\"#127BCA\"/><stop offset=\".846\" stop-color=\"#127BCA\"/><stop offset=\"1\" stop-color=\"#127BCA\"/></linearGradient><path fill=\"url(#a)\" d=\"M45.407 15.604c4.399 13.452 6.064 37.449 18.928 37.449.979 0 1.969-.095 2.962-.285-11.693-2.727-13.079-26.462-20.214-38.754a59.736 59.736 0 0 0-1.676 1.59\"/><linearGradient id=\"b\" gradientUnits=\"userSpaceOnUse\" x1=\"62.447\" y1=\"415.34\" x2=\"62.836\" y2=\"415.34\" gradientTransform=\"matrix(0 153.551 153.551 0 -63717.234 -9583.969)\"><stop offset=\"0\" stop-color=\"#0E76BC\"/><stop offset=\".36\" stop-color=\"#36AEE8\"/><stop offset=\".36\" stop-color=\"#36AEE8\"/><stop offset=\".846\" stop-color=\"#00ADEF\"/><stop offset=\".846\" stop-color=\"#00ADEF\"/><stop offset=\"1\" stop-color=\"#00ADEF\"/></linearGradient><path fill=\"url(#b)\" d=\"M47.083 14.014c7.135 12.292 8.521 36.027 20.214 38.754a18.54 18.54 0 0 0 2.762-.746c-10.496-5.143-13.397-28.192-21.5-39.289-.491.41-.984.837-1.476 1.281\"/><path fill=\"#14559A\" d=\"M57.364 6.704c-.977 0-1.969.096-2.964.285-2.603.491-5.247 1.611-7.913 3.308a19.648 19.648 0 0 1 2.073 2.438c2.711-2.249 5.404-3.911 8.087-4.911a18.1 18.1 0 0 1 3.017-.838 9.23 9.23 0 0 0-2.3-.282\"/><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"66.554\" y1=\"416.985\" x2=\"66.942\" y2=\"416.985\" gradientTransform=\"matrix(0 -122.178 -122.178 0 51016.945 8183.043)\"><stop offset=\"0\" stop-color=\"#1C63B7\"/><stop offset=\".5\" stop-color=\"#33BDF2\"/><stop offset=\"1\" stop-color=\"#33BDF2\" stop-opacity=\".42\"/></linearGradient><path fill=\"url(#c)\" d=\"M78.251 47.282a47.07 47.07 0 0 0 3.228-2.829c-4.47-13.389-6.07-37.729-19.023-37.729-.926 0-1.861.086-2.792.259 11.798 2.934 13.309 28.605 18.587 40.299\"/><path fill=\"#3092C4\" d=\"M59.664 6.984a9.28 9.28 0 0 0-2.301-.281l5.094.019c-.927 0-1.861.086-2.793.262\"/><path fill=\"#1969BC\" d=\"M78.026 50.126a19.144 19.144 0 0 1-1.46-1.579c-2.179 1.543-4.351 2.713-6.507 3.475.767.375 1.572.653 2.426.826a10.22 10.22 0 0 0 2.067.205c2.421 0 4.334-.286 5.963-1.068-.897-.485-1.72-1.112-2.489-1.859\"/><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"62.568\" y1=\"415.281\" x2=\"62.957\" y2=\"415.281\" gradientTransform=\"matrix(0 159.425 159.425 0 -66138.813 -9976.116)\"><stop offset=\"0\" stop-color=\"#166AB8\"/><stop offset=\".4\" stop-color=\"#36AEE8\"/><stop offset=\".4\" stop-color=\"#36AEE8\"/><stop offset=\".846\" stop-color=\"#0798DD\"/><stop offset=\".846\" stop-color=\"#0798DD\"/><stop offset=\"1\" stop-color=\"#0798DD\"/></linearGradient><path fill=\"url(#d)\" d=\"M56.646 7.825c10.569 5.528 11.487 30.56 19.92 40.723.565-.398 1.125-.82 1.684-1.265-5.279-11.695-6.788-37.368-18.585-40.3a18.21 18.21 0 0 0-3.019.842\"/><linearGradient id=\"e\" gradientUnits=\"userSpaceOnUse\" x1=\"62.648\" y1=\"415.368\" x2=\"63.037\" y2=\"415.368\" gradientTransform=\"matrix(0 169.528 169.528 0 -70353.656 -10621.372)\"><stop offset=\"0\" stop-color=\"#124379\"/><stop offset=\".39\" stop-color=\"#1487CB\"/><stop offset=\".39\" stop-color=\"#1487CB\"/><stop offset=\".78\" stop-color=\"#165197\"/><stop offset=\".78\" stop-color=\"#165197\"/><stop offset=\"1\" stop-color=\"#165197\"/></linearGradient><path fill=\"url(#e)\" d=\"M48.559 12.734c8.103 11.097 11.004 34.146 21.5 39.289 2.158-.762 4.328-1.932 6.507-3.475-8.433-10.163-9.352-35.195-19.92-40.723-2.683.998-5.376 2.66-8.087 4.909\"/><linearGradient id=\"f\" gradientUnits=\"userSpaceOnUse\" x1=\"1006.493\" y1=\"-1588.315\" x2=\"1008.801\" y2=\"-1588.315\" gradientTransform=\"matrix(4.038 0 0 -4.038 -4028.633 -6394.98)\"><stop offset=\"0\" stop-color=\"#33BDF2\" stop-opacity=\".698\"/><stop offset=\"1\" stop-color=\"#1DACD8\"/></linearGradient><path fill=\"url(#f)\" d=\"M40.222 15.28c-1.271 2.872-2.568 6.646-4.136 11.574 3.118-4.395 6.228-8.181 9.32-11.25a33.912 33.912 0 0 0-1.376-3.592 46.51 46.51 0 0 0-3.808 3.268\"/><path fill=\"#2B74B1\" d=\"M45.157 11.184c-.373.267-.749.54-1.125.828a33.784 33.784 0 0 1 1.375 3.592 65.928 65.928 0 0 1 1.677-1.59 22.658 22.658 0 0 0-1.927-2.83\"/><path fill=\"#125A9E\" d=\"M46.486 10.296c-.443.281-.884.577-1.331.887a22.376 22.376 0 0 1 1.928 2.833c.493-.446.985-.875 1.476-1.282a19.563 19.563 0 0 0-2.073-2.438\"/><linearGradient id=\"g\" gradientUnits=\"userSpaceOnUse\" x1=\"66.607\" y1=\"417.481\" x2=\"66.996\" y2=\"417.481\" gradientTransform=\"matrix(0 -119.018 -119.018 0 49793.875 7977.832)\"><stop offset=\"0\" stop-color=\"#136AB4\"/><stop offset=\".6\" stop-color=\"#59CAF5\" stop-opacity=\".549\"/><stop offset=\"1\" stop-color=\"#59CAF5\" stop-opacity=\".235\"/></linearGradient><path fill=\"url(#g)\" d=\"M118.572 5.68c-5.977 23.05-18.461 41.565-28.927 46.232h-.021l-.565.241-.068.027-.161.062-.072.03-.261.092-.108.038-.13.043-.126.044-.112.037-.223.068-.095.025-.151.041-.102.028-.164.042-.201.044c.473.175.966.263 1.497.263 9.924 0 19.932-17.786 36.489-47.363h-6.501l.002.006z\"/><linearGradient id=\"h\" gradientUnits=\"userSpaceOnUse\" x1=\"998.304\" y1=\"-1591.054\" x2=\"1006.863\" y2=\"-1591.054\" gradientTransform=\"matrix(4.038 0 0 -4.038 -4028.633 -6394.98)\"><stop offset=\"0\" stop-color=\"#05A1E6\" stop-opacity=\".247\"/><stop offset=\"1\" stop-color=\"#05A1E6\"/></linearGradient><path fill=\"url(#h)\" d=\"M33.931 7.64l.018-.017.023-.015h.013l.161-.062.032-.016.041-.018.173-.062h.009l.381-.133.056-.015.164-.049.075-.024.164-.049.063-.016.545-.142.075-.017.159-.031.079-.024.16-.03h.037l.332-.062h.066l.153-.026.086-.016.146-.022.082-.015.357-.032a11.398 11.398 0 0 0-1.057-.054c-11.177 0-26.576 20.738-33.513 47.594h1.337a388.226 388.226 0 0 0 6.037-11.22c4.859-19.022 14.754-31.996 23.544-35.433\"/><path fill=\"#0D82CA\" d=\"M40.222 15.28a46.677 46.677 0 0 1 3.808-3.268 17.903 17.903 0 0 0-.907-1.753c-1.022 1.241-1.956 2.877-2.901 5.021M41.141 7.797c.73.611 1.383 1.454 1.982 2.462a9.1 9.1 0 0 1 .578-.646A11.294 11.294 0 0 0 41 7.724l.119.057.022.016\"/><linearGradient id=\"i\" gradientUnits=\"userSpaceOnUse\" x1=\"66.556\" y1=\"416.357\" x2=\"66.944\" y2=\"416.357\" gradientTransform=\"matrix(0 -121.865 -121.865 0 50761.691 8162.488)\"><stop offset=\"0\" stop-color=\"#318ED5\"/><stop offset=\"1\" stop-color=\"#38A7E4\"/></linearGradient><path fill=\"url(#i)\" d=\"M10.388 43.072c10.191-19.64 15.02-32.069 23.544-35.433-8.789 3.439-18.686 16.412-23.544 35.433\"/><path fill=\"#127BCA\" d=\"M43.7 9.614c-.199.203-.387.415-.578.646.32.536.618 1.119.909 1.753.376-.289.752-.561 1.125-.829a15.339 15.339 0 0 0-1.456-1.57\"/><linearGradient id=\"j\" gradientUnits=\"userSpaceOnUse\" x1=\"66.632\" y1=\"416.408\" x2=\"67.021\" y2=\"416.408\" gradientTransform=\"matrix(0 -118.46 -118.46 0 49352.684 7945.017)\"><stop offset=\"0\" stop-color=\"#05A1E6\"/><stop offset=\"1\" stop-color=\"#05A1E6\" stop-opacity=\".549\"/></linearGradient><path fill=\"url(#j)\" d=\"M15.015 54.203l-.185.022h-.035l-.157.016h-.026l-.374.025h-.039c10.314-.289 15.03-5.453 17.37-12.944 1.777-5.678 3.238-10.462 4.518-14.476-4.32 6.081-8.661 13.33-13.024 21.451-2.104 3.914-5.304 5.549-8.048 5.898\"/><linearGradient id=\"k\" gradientUnits=\"userSpaceOnUse\" x1=\"67.153\" y1=\"416.523\" x2=\"67.542\" y2=\"416.523\" gradientTransform=\"matrix(0 -100.1 -100.1 0 41721.719 6776.301)\"><stop offset=\"0\" stop-color=\"#1959A6\"/><stop offset=\".5\" stop-color=\"#05A1E6\"/><stop offset=\".5\" stop-color=\"#05A1E6\"/><stop offset=\".918\" stop-color=\"#7EC5EA\"/><stop offset=\"1\" stop-color=\"#7EC5EA\"/></linearGradient><path fill=\"url(#k)\" d=\"M15.015 54.199c2.744-.35 5.944-1.983 8.048-5.899 4.363-8.118 8.706-15.369 13.022-21.451 1.571-4.929 2.866-8.701 4.138-11.573-8.604 8.189-17.24 21.806-25.208 38.919\"/><path fill=\"#05A1E6\" d=\"M10.388 43.072a389.833 389.833 0 0 1-6.039 11.22h3.889a94.927 94.927 0 0 1 2.149-11.218\"/><linearGradient id=\"l\" gradientUnits=\"userSpaceOnUse\" x1=\"66.874\" y1=\"415.998\" x2=\"67.262\" y2=\"415.998\" gradientTransform=\"scale(-110.211 110.211) rotate(-80 -214.299 248.239)\"><stop offset=\"0\" stop-color=\"#165096\"/><stop offset=\"1\" stop-color=\"#0D82CA\"/></linearGradient><path fill=\"url(#l)\" d=\"M37.225 6.791l-.083.016-.146.021-.085.015-.153.027-.066.016-.332.058h-.037l-.162.032-.081.021-.157.031-.074.018-.546.142-.063.019-.165.049-.075.019-.163.048-.06.016-.379.133-.172.06-.072.03-.16.06-.053.026c-8.523 3.364-13.352 15.793-23.543 35.432a94.598 94.598 0 0 0-2.15 11.218h.546l3.739-.016h1.714l.374-.025h.024l.157-.016h.038l.185-.022c7.967-17.112 16.604-30.729 25.208-38.918.945-2.144 1.878-3.781 2.898-5.02-.597-1.008-1.25-1.853-1.98-2.465L41.13 7.8l-.122-.059-.12-.061-.117-.057-.138-.058-.108-.047-.226-.094-.096-.037-.168-.067-.091-.03-.234-.08h-.019l-.271-.077-.061-.019-.228-.064-.053-.015a6.956 6.956 0 0 0-.567-.124l-.059-.016-.246-.04-.048-.015-.291-.038h-.051l-.224-.025-.357.033\"/><linearGradient id=\"m\" gradientUnits=\"userSpaceOnUse\" x1=\"68.837\" y1=\"418.884\" x2=\"69.226\" y2=\"418.884\" gradientTransform=\"matrix(0 -56.721 -56.721 0 23857.477 3932.282)\"><stop offset=\"0\" stop-color=\"#05A1E6\"/><stop offset=\".874\" stop-color=\"#0495D6\"/><stop offset=\"1\" stop-color=\"#0495D6\"/></linearGradient><path fill=\"url(#m)\" d=\"M95.226 18.441c-1.961 6.281-3.549 11.463-4.931 15.727 5.381-7.404 10.68-16.718 15.728-27.467-5.889 1.849-9.029 6.081-10.797 11.74\"/><linearGradient id=\"n\" gradientUnits=\"userSpaceOnUse\" x1=\"62.48\" y1=\"414.361\" x2=\"62.868\" y2=\"414.361\" gradientTransform=\"scale(-132.813 132.813) rotate(80 277.722 169.477)\"><stop offset=\"0\" stop-color=\"#38A7E4\" stop-opacity=\".329\"/><stop offset=\".962\" stop-color=\"#0E88D3\"/><stop offset=\".962\" stop-color=\"#0E88D3\"/><stop offset=\"1\" stop-color=\"#0E88D3\"/></linearGradient><path fill=\"url(#n)\" d=\"M90.465 51.52c-.274.14-.55.272-.82.393 10.466-4.668 22.951-23.183 28.927-46.233h-1.211c-13.733 24.53-18.149 40.952-26.896 45.84\"/><path fill=\"#079AE1\" d=\"M83.631 49.459c2.277-2.779 4.132-7.504 6.665-15.292-2.921 4.012-5.861 7.462-8.804 10.274l-.015.025c.642 1.923 1.346 3.622 2.149 4.992\"/><path fill=\"#1969BC\" d=\"M83.631 49.459c-.775.946-1.596 1.666-2.509 2.2-.2.117-.402.227-.608.326.964.52 2.016.868 3.193 1.007l.522.046h.031l.251.016h.852l.096-.016.188-.016h.091l.205-.022h.015l.063-.015.218-.034h.064l.245-.041h.039l.489-.104c-1.351-.493-2.481-1.66-3.455-3.32\"/><path fill=\"#1E5CB3\" d=\"M64.335 53.053c.979 0 1.968-.096 2.961-.287.919-.167 1.84-.422 2.762-.744a10.093 10.093 0 0 0 4.494 1.031H64.335zM74.552 53.053c2.419 0 4.334-.287 5.962-1.068a8.8 8.8 0 0 0 3.193 1.007l.522.045h.031l.251.016h.301-10.26z\"/><path fill=\"#1D60B5\" d=\"M84.812 53.053h.559l.096-.016.19-.016h.093l.203-.022h.017l.062-.015.218-.033.066-.015.246-.04h.039l.489-.104a4.28 4.28 0 0 0 1.498.263l-3.773.016-.003-.018z\"/><path fill=\"#175FAB\" d=\"M81.482 44.467v-.016a46.856 46.856 0 0 1-3.228 2.83c-.561.445-1.12.867-1.686 1.265a19.14 19.14 0 0 0 1.461 1.579c.77.746 1.591 1.374 2.488 1.859.205-.1.408-.21.607-.326.915-.534 1.734-1.254 2.51-2.2-.803-1.37-1.507-3.069-2.148-4.992\"/><linearGradient id=\"o\" gradientUnits=\"userSpaceOnUse\" x1=\"62.071\" y1=\"414.653\" x2=\"62.459\" y2=\"414.653\" gradientTransform=\"matrix(0 123.742 123.742 0 -51209.754 -7675.189)\"><stop offset=\"0\" stop-color=\"#168CD4\"/><stop offset=\".5\" stop-color=\"#1C87CC\"/><stop offset=\"1\" stop-color=\"#154B8D\"/></linearGradient><path fill=\"url(#o)\" d=\"M113.525 5.68h-6.096l-.966.047-.45.962c-5.046 10.749-10.346 20.063-15.727 27.468-2.53 7.786-4.387 12.511-6.664 15.291.973 1.661 2.106 2.829 3.452 3.324l.106-.023h.022l.074-.017.169-.042.1-.029.151-.04.094-.026.224-.068.112-.037.126-.046.129-.041.105-.04.263-.092.073-.027.161-.063.069-.025.565-.241h.019c.271-.12.546-.253.819-.393 8.75-4.888 13.166-21.31 26.898-45.84h-3.835l.007-.002z\"/><path fill=\"#7DCBEC\" d=\"M37.583 6.758l.063.016.159.017h.054l.29.037.05.016.245.041.061.015.566.125.051.016.227.064.063.019.269.077.02.016.236.081.09.029.169.069.096.034.224.094.11.047.135.059.12.056.119.062a11.284 11.284 0 0 1 2.702 1.89c.305-.322.625-.61.958-.87-1.815-1.288-3.874-2.022-6.246-2.022-.275 0-.549.016-.829.037\"/><path fill=\"#5EC5ED\" d=\"M43.7 9.614c.508.473.995 1.001 1.456 1.57.445-.31.887-.608 1.331-.887a13.917 13.917 0 0 0-1.831-1.553 8.418 8.418 0 0 0-.956.87\"/><g transform=\"matrix(5.048 0 0 -5.048 -9064.26 2270.61)\"><linearGradient id=\"p\" gradientUnits=\"userSpaceOnUse\" x1=\"1807.241\" y1=\"366.152\" x2=\"1807.63\" y2=\"366.152\" gradientTransform=\"scale(30.857 -30.857) rotate(22.527 1888.666 -4214.769)\"><stop offset=\"0\" stop-color=\"#97D6EE\"/><stop offset=\".703\" stop-color=\"#55C1EA\"/><stop offset=\"1\" stop-color=\"#55C1EA\"/></linearGradient><path fill=\"url(#p)\" d=\"M1803.007 448.452l.164.007c.47 0 .878-.145 1.237-.4.38.299.838.404 1.476.404h-3.086l.209-.011\"/></g><g transform=\"matrix(5.048 0 0 -5.048 -9064.26 2270.61)\"><linearGradient id=\"q\" gradientUnits=\"userSpaceOnUse\" x1=\"1808.472\" y1=\"365.322\" x2=\"1808.861\" y2=\"365.322\" gradientTransform=\"scale(24.717 -24.717) rotate(-24.385 53.536 4189.483)\"><stop offset=\"0\" stop-color=\"#7ACCEC\"/><stop offset=\"1\" stop-color=\"#3FB7ED\"/></linearGradient><path fill=\"url(#q)\" d=\"M1805.884 448.463c-.637 0-1.096-.105-1.476-.404.126-.089.247-.192.362-.307.528.336 1.052.558 1.568.656.197.037.393.056.587.056h-1.041v-.001z\"/></g><linearGradient id=\"r\" gradientUnits=\"userSpaceOnUse\" x1=\"61.991\" y1=\"414.706\" x2=\"62.38\" y2=\"414.706\" gradientTransform=\"matrix(0 121.032 121.032 0 -50098.906 -7494.747)\"><stop offset=\"0\" stop-color=\"#1DA7E7\"/><stop offset=\"1\" stop-color=\"#37ABE7\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#r)\" d=\"M90.295 34.172c1.384-4.267 2.968-9.447 4.933-15.73 1.771-5.661 4.905-9.894 10.792-11.741l.454-.962c-9.597.575-14.082 5.457-16.339 12.687-3.947 12.622-6.339 20.803-8.641 26.017 2.94-2.812 5.88-6.263 8.801-10.271\"/></svg>"

/***/ }),

/***/ "../src/components/dot-net/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DotNetOriginalWordmark = __webpack_require__("../src/components/dot-net/original-wordmark/DotNetOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DotNetOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/dot-net/original/DotNetOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DotNetOriginal = __webpack_require__("../src/components/dot-net/original/DotNetOriginal.svg");
	
	var _DotNetOriginal2 = _interopRequireDefault(_DotNetOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DotNetOriginal */
	function DotNetOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DotNetOriginal',
	    svg: _DotNetOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DotNetOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DotNetOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/dot-net/original/DotNetOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"61.631\" y1=\"563.347\" x2=\"62.022\" y2=\"563.347\" gradientTransform=\"matrix(0 149.735 149.735 0 -84296.266 -9188.014)\"><stop offset=\"0\" stop-color=\"#0994DC\"/><stop offset=\".35\" stop-color=\"#66CEF5\"/><stop offset=\".35\" stop-color=\"#66CEF5\"/><stop offset=\".846\" stop-color=\"#127BCA\"/><stop offset=\".846\" stop-color=\"#127BCA\"/><stop offset=\"1\" stop-color=\"#127BCA\"/></linearGradient><path fill=\"url(#a)\" d=\"M45.288 49.559c4.417 13.507 6.09 37.601 19.006 37.601.982 0 1.977-.096 2.974-.286-11.74-2.737-13.132-26.569-20.297-38.912a61.601 61.601 0 0 0-1.683 1.597\"/><linearGradient id=\"b\" gradientUnits=\"userSpaceOnUse\" x1=\"61.705\" y1=\"563.34\" x2=\"62.095\" y2=\"563.34\" gradientTransform=\"matrix(0 153.551 153.551 0 -86442.719 -9435.969)\"><stop offset=\"0\" stop-color=\"#0E76BC\"/><stop offset=\".36\" stop-color=\"#36AEE8\"/><stop offset=\".36\" stop-color=\"#36AEE8\"/><stop offset=\".846\" stop-color=\"#00ADEF\"/><stop offset=\".846\" stop-color=\"#00ADEF\"/><stop offset=\"1\" stop-color=\"#00ADEF\"/></linearGradient><path fill=\"url(#b)\" d=\"M46.971 47.962c7.165 12.342 8.557 36.174 20.297 38.912a18.621 18.621 0 0 0 2.773-.749C59.502 80.961 56.59 57.819 48.453 46.678c-.492.41-.987.839-1.482 1.284\"/><path fill=\"#14559A\" d=\"M57.294 40.623c-.98 0-1.977.096-2.977.286-2.612.493-5.268 1.618-7.944 3.321.73.722 1.427 1.547 2.081 2.448 2.723-2.259 5.427-3.928 8.12-4.932a18.177 18.177 0 0 1 3.029-.842 9.393 9.393 0 0 0-2.309-.281\"/><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"67.486\" y1=\"564.985\" x2=\"67.876\" y2=\"564.985\" gradientTransform=\"matrix(0 -122.178 -122.178 0 69099.289 8331.043)\"><stop offset=\"0\" stop-color=\"#1C63B7\"/><stop offset=\".5\" stop-color=\"#33BDF2\"/><stop offset=\"1\" stop-color=\"#33BDF2\" stop-opacity=\".42\"/></linearGradient><path fill=\"url(#c)\" d=\"M78.268 81.366a47.16 47.16 0 0 0 3.24-2.84c-4.488-13.443-6.095-37.883-19.101-37.883-.93 0-1.868.087-2.804.26C71.45 43.85 72.968 69.625 78.268 81.366\"/><path fill=\"#3092C4\" d=\"M59.604 40.904a9.355 9.355 0 0 0-2.311-.282l5.114.019c-.929 0-1.867.086-2.803.263\"/><path fill=\"#1969BC\" d=\"M78.04 84.221a19.441 19.441 0 0 1-1.466-1.584c-2.188 1.549-4.368 2.724-6.533 3.489.771.376 1.578.656 2.436.829.664.136 1.353.206 2.075.206 2.431 0 4.353-.288 5.987-1.072-.9-.488-1.726-1.118-2.499-1.868\"/><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"61.852\" y1=\"563.281\" x2=\"62.243\" y2=\"563.281\" gradientTransform=\"matrix(0 159.425 159.425 0 -89733.742 -9828.116)\"><stop offset=\"0\" stop-color=\"#166AB8\"/><stop offset=\".4\" stop-color=\"#36AEE8\"/><stop offset=\".4\" stop-color=\"#36AEE8\"/><stop offset=\".846\" stop-color=\"#0798DD\"/><stop offset=\".846\" stop-color=\"#0798DD\"/><stop offset=\"1\" stop-color=\"#0798DD\"/></linearGradient><path fill=\"url(#d)\" d=\"M56.573 41.748c10.611 5.55 11.534 30.684 20.001 40.889.568-.4 1.13-.824 1.691-1.271-5.3-11.741-6.815-37.519-18.66-40.463-1.011.189-2.02.469-3.032.845\"/><linearGradient id=\"e\" gradientUnits=\"userSpaceOnUse\" x1=\"61.975\" y1=\"563.367\" x2=\"62.366\" y2=\"563.367\" gradientTransform=\"matrix(0 169.528 169.528 0 -95443.742 -10473.372)\"><stop offset=\"0\" stop-color=\"#124379\"/><stop offset=\".39\" stop-color=\"#1487CB\"/><stop offset=\".39\" stop-color=\"#1487CB\"/><stop offset=\".78\" stop-color=\"#165197\"/><stop offset=\".78\" stop-color=\"#165197\"/><stop offset=\"1\" stop-color=\"#165197\"/></linearGradient><path fill=\"url(#e)\" d=\"M48.453 46.678c8.137 11.141 11.049 34.284 21.588 39.448 2.166-.765 4.346-1.939 6.533-3.489-8.467-10.205-9.39-35.338-20.001-40.889-2.693 1.002-5.397 2.671-8.12 4.93\"/><linearGradient id=\"f\" gradientUnits=\"userSpaceOnUse\" x1=\"1006.454\" y1=\"-1412.08\" x2=\"1008.771\" y2=\"-1412.08\" gradientTransform=\"matrix(4.038 0 0 -4.038 -4028.633 -5649.283)\"><stop offset=\"0\" stop-color=\"#33BDF2\" stop-opacity=\".698\"/><stop offset=\"1\" stop-color=\"#1DACD8\"/></linearGradient><path fill=\"url(#f)\" d=\"M40.083 49.234c-1.275 2.883-2.578 6.674-4.152 11.621 3.131-4.413 6.253-8.214 9.357-11.295a33.873 33.873 0 0 0-1.382-3.606 46.113 46.113 0 0 0-3.823 3.28\"/><path fill=\"#2B74B1\" d=\"M45.037 45.121c-.374.268-.751.542-1.13.832.495 1.08.953 2.292 1.38 3.607a66.502 66.502 0 0 1 1.684-1.597 22.346 22.346 0 0 0-1.934-2.842\"/><path fill=\"#125A9E\" d=\"M46.373 44.229c-.445.282-.888.58-1.337.891.695.855 1.333 1.81 1.936 2.844.495-.448.989-.879 1.482-1.287-.654-.9-1.35-1.726-2.081-2.448\"/><linearGradient id=\"g\" gradientUnits=\"userSpaceOnUse\" x1=\"67.564\" y1=\"565.48\" x2=\"67.954\" y2=\"565.48\" gradientTransform=\"matrix(0 -119.018 -119.018 0 67408.578 8125.832)\"><stop offset=\"0\" stop-color=\"#136AB4\"/><stop offset=\".6\" stop-color=\"#59CAF5\" stop-opacity=\".549\"/><stop offset=\"1\" stop-color=\"#59CAF5\" stop-opacity=\".235\"/></linearGradient><path fill=\"url(#g)\" d=\"M118.751 39.594c-6.001 23.144-18.536 41.734-29.044 46.42h-.021l-.567.243-.069.027-.161.062-.072.03-.263.093-.108.038-.131.043-.126.044-.112.038-.224.068-.096.025-.151.041-.103.028-.165.043-.201.044c.475.175.97.264 1.503.264 9.965 0 20.013-17.858 36.638-47.556h-6.528l.001.005z\"/><linearGradient id=\"h\" gradientUnits=\"userSpaceOnUse\" x1=\"998.231\" y1=\"-1414.829\" x2=\"1006.826\" y2=\"-1414.829\" gradientTransform=\"matrix(4.038 0 0 -4.038 -4028.633 -5649.283)\"><stop offset=\"0\" stop-color=\"#05A1E6\" stop-opacity=\".247\"/><stop offset=\"1\" stop-color=\"#05A1E6\"/></linearGradient><path fill=\"url(#h)\" d=\"M33.766 41.563l.019-.016.023-.015h.013l.161-.062.032-.016.042-.017.173-.062h.009l.383-.134.057-.015.164-.049.075-.024.165-.049.063-.017.548-.142.075-.017.16-.031.078-.024.161-.03h.038l.333-.062h.066l.154-.027.087-.015.147-.022.081-.016.358-.032a11.467 11.467 0 0 0-1.061-.054c-11.223 0-26.685 20.822-33.649 47.788h1.343a390.312 390.312 0 0 0 6.062-11.266c4.879-19.1 14.814-32.126 23.64-35.577\"/><path fill=\"#0D82CA\" d=\"M40.083 49.234a46.488 46.488 0 0 1 3.823-3.281 17.961 17.961 0 0 0-.911-1.761c-1.026 1.246-1.964 2.89-2.912 5.042\"/><path fill=\"#0D82CA\" d=\"M41.005 41.72c.733.614 1.39 1.46 1.99 2.473.189-.232.381-.447.58-.649a11.263 11.263 0 0 0-2.712-1.897l.12.057.022.016\"/><linearGradient id=\"i\" gradientUnits=\"userSpaceOnUse\" x1=\"67.491\" y1=\"564.359\" x2=\"67.881\" y2=\"564.359\" gradientTransform=\"matrix(0 -121.865 -121.865 0 68797.742 8310.488)\"><stop offset=\"0\" stop-color=\"#318ED5\"/><stop offset=\"1\" stop-color=\"#38A7E4\"/></linearGradient><path fill=\"url(#i)\" d=\"M10.127 77.138c10.233-19.719 15.081-32.199 23.64-35.577-8.825 3.454-18.762 16.479-23.64 35.577\"/><path fill=\"#127BCA\" d=\"M43.574 43.544c-.199.204-.389.417-.58.649.322.538.621 1.124.913 1.76.378-.29.756-.563 1.129-.832a15.351 15.351 0 0 0-1.462-1.577\"/><linearGradient id=\"j\" gradientUnits=\"userSpaceOnUse\" x1=\"67.593\" y1=\"564.41\" x2=\"67.984\" y2=\"564.41\" gradientTransform=\"matrix(0 -118.46 -118.46 0 66884.703 8093.017)\"><stop offset=\"0\" stop-color=\"#05A1E6\"/><stop offset=\"1\" stop-color=\"#05A1E6\" stop-opacity=\".549\"/></linearGradient><path fill=\"url(#j)\" d=\"M14.773 88.315l-.186.022h-.035l-.158.016h-.026l-.376.025h-.039c10.356-.29 15.091-5.475 17.44-12.997 1.785-5.701 3.252-10.505 4.537-14.535-4.338 6.106-8.696 13.384-13.077 21.539-2.112 3.93-5.325 5.572-8.08 5.922\"/><linearGradient id=\"k\" gradientUnits=\"userSpaceOnUse\" x1=\"68.291\" y1=\"564.525\" x2=\"68.682\" y2=\"564.525\" gradientTransform=\"matrix(0 -100.1 -100.1 0 56536.551 6924.301)\"><stop offset=\"0\" stop-color=\"#1959A6\"/><stop offset=\".5\" stop-color=\"#05A1E6\"/><stop offset=\".5\" stop-color=\"#05A1E6\"/><stop offset=\".918\" stop-color=\"#7EC5EA\"/><stop offset=\"1\" stop-color=\"#7EC5EA\"/></linearGradient><path fill=\"url(#k)\" d=\"M14.773 88.311c2.755-.351 5.968-1.991 8.08-5.923 4.381-8.151 8.741-15.431 13.075-21.538 1.577-4.949 2.878-8.737 4.154-11.621-8.639 8.223-17.311 21.896-25.31 39.077\"/><path fill=\"#05A1E6\" d=\"M10.127 77.139a388.004 388.004 0 0 1-6.063 11.266h3.904a95.502 95.502 0 0 1 2.158-11.264\"/><linearGradient id=\"l\" gradientUnits=\"userSpaceOnUse\" x1=\"67.892\" y1=\"563.82\" x2=\"68.282\" y2=\"563.82\" gradientTransform=\"scale(-110.211 110.211) rotate(-80 -301.688 322.91)\"><stop offset=\"0\" stop-color=\"#165096\"/><stop offset=\"1\" stop-color=\"#0D82CA\"/></linearGradient><path fill=\"url(#l)\" d=\"M37.073 40.709l-.083.016-.146.021-.086.015-.154.027-.066.016-.333.058h-.038l-.162.032-.081.022-.157.031-.074.018-.549.142-.063.018-.166.049-.075.021-.163.049-.06.016-.381.134-.173.06-.072.03-.161.06-.054.026c-8.558 3.377-13.406 15.857-23.639 35.576A94.655 94.655 0 0 0 7.979 88.41h.547l3.755-.016h1.723l.375-.025h.024l.158-.016h.037l.186-.022c8-17.182 16.672-30.854 25.31-39.077.95-2.152 1.887-3.796 2.911-5.04-.6-1.013-1.256-1.861-1.988-2.476l-.021-.016-.122-.059-.121-.061-.117-.057-.139-.058-.108-.047-.227-.095-.097-.036-.169-.068-.091-.03-.235-.081h-.019l-.272-.077-.061-.019-.229-.064-.053-.015a7.851 7.851 0 0 0-.569-.125l-.059-.016-.247-.04-.049-.015-.292-.039h-.051l-.226-.025-.358.033\"/><linearGradient id=\"m\" gradientUnits=\"userSpaceOnUse\" x1=\"70.847\" y1=\"566.882\" x2=\"71.237\" y2=\"566.882\" gradientTransform=\"matrix(0 -56.721 -56.721 0 32252.127 4080.282)\"><stop offset=\"0\" stop-color=\"#05A1E6\"/><stop offset=\".874\" stop-color=\"#0495D6\"/><stop offset=\"1\" stop-color=\"#0495D6\"/></linearGradient><path fill=\"url(#m)\" d=\"M95.311 52.407c-1.97 6.307-3.563 11.51-4.952 15.791 5.403-7.435 10.725-16.787 15.792-27.579-5.913 1.857-9.065 6.107-10.84 11.788\"/><linearGradient id=\"n\" gradientUnits=\"userSpaceOnUse\" x1=\"61.634\" y1=\"562.213\" x2=\"62.024\" y2=\"562.213\" gradientTransform=\"scale(-132.813 132.813) rotate(80 365.248 244.034)\"><stop offset=\"0\" stop-color=\"#38A7E4\" stop-opacity=\".329\"/><stop offset=\".962\" stop-color=\"#0E88D3\"/><stop offset=\".962\" stop-color=\"#0E88D3\"/><stop offset=\"1\" stop-color=\"#0E88D3\"/></linearGradient><path fill=\"url(#n)\" d=\"M90.53 85.621c-.275.14-.552.273-.823.394 10.508-4.687 23.044-23.277 29.044-46.421h-1.216c-13.788 24.631-18.222 41.12-27.005 46.027\"/><path fill=\"#079AE1\" d=\"M83.668 83.552c2.287-2.791 4.148-7.535 6.691-15.354-2.933 4.029-5.885 7.492-8.84 10.316l-.015.025c.645 1.931 1.352 3.636 2.158 5.012\"/><path fill=\"#1969BC\" d=\"M83.668 83.552c-.778.95-1.603 1.673-2.519 2.209-.2.117-.404.227-.61.327a8.839 8.839 0 0 0 3.206 1.011l.524.046h.031l.252.016h.855l.097-.016.189-.016h.092l.205-.022h.017l.063-.015.219-.034h.064l.246-.041h.04l.491-.104c-1.357-.496-2.492-1.667-3.469-3.334\"/><path fill=\"#1E5CB3\" d=\"M64.295 87.161c.982 0 1.976-.096 2.973-.288a18.309 18.309 0 0 0 2.773-.747c.771.376 1.579.656 2.435.831.664.135 1.354.205 2.077.205H64.295zM74.553 87.161c2.429 0 4.353-.288 5.986-1.073a8.84 8.84 0 0 0 3.206 1.012l.524.045h.031l.252.016h.302-10.301z\"/><path fill=\"#1D60B5\" d=\"M84.854 87.161h.561l.097-.016.191-.016h.092l.204-.022h.017l.062-.016.219-.033.067-.015.247-.04h.039l.491-.104c.475.175.97.264 1.503.264l-3.788.016-.002-.018z\"/><path fill=\"#175FAB\" d=\"M81.511 78.54v-.016a47.16 47.16 0 0 1-3.24 2.84 36.81 36.81 0 0 1-1.693 1.271c.476.568.959 1.1 1.468 1.585.772.749 1.597 1.38 2.498 1.867.205-.101.41-.211.609-.327.918-.536 1.741-1.26 2.52-2.209-.806-1.376-1.513-3.082-2.157-5.012\"/><linearGradient id=\"o\" gradientUnits=\"userSpaceOnUse\" x1=\"61.149\" y1=\"562.654\" x2=\"61.539\" y2=\"562.654\" gradientTransform=\"matrix(0 123.742 123.742 0 -69523.625 -7527.189)\"><stop offset=\"0\" stop-color=\"#168CD4\"/><stop offset=\".5\" stop-color=\"#1C87CC\"/><stop offset=\"1\" stop-color=\"#154B8D\"/></linearGradient><path fill=\"url(#o)\" d=\"M113.685 39.594h-6.121l-.97.047-.451.966c-5.068 10.793-10.388 20.145-15.791 27.58-2.54 7.818-4.404 12.563-6.69 15.353.977 1.668 2.114 2.84 3.466 3.337l.106-.023h.022l.075-.016.17-.042.101-.029.151-.039.094-.027.226-.068.112-.038.126-.046.13-.041.106-.04.264-.093.073-.027.162-.063.068-.025.568-.243h.02c.271-.119.547-.254.821-.394 8.785-4.908 13.22-21.396 27.008-46.026h-3.851l.005-.003z\"/><path fill=\"#7DCBEC\" d=\"M37.433 40.677l.063.016.16.017h.054l.292.038.049.016.246.041.062.015.567.126.052.016.228.064.063.019.271.077.021.016.237.081.09.029.17.069.096.034.226.094.11.047.136.059.12.057.119.062c.979.48 1.879 1.121 2.713 1.898.308-.323.628-.613.962-.874-1.823-1.293-3.89-2.03-6.271-2.03-.276 0-.552.016-.832.037\"/><path fill=\"#5EC5ED\" d=\"M43.574 43.544c.511.475 1 1.005 1.462 1.577.448-.311.892-.611 1.337-.891a14.13 14.13 0 0 0-1.839-1.56c-.333.26-.652.552-.96.874\"/><g transform=\"matrix(5.048 0 0 -5.048 -9064.26 2270.61)\"><linearGradient id=\"p\" gradientUnits=\"userSpaceOnUse\" x1=\"1806.96\" y1=\"336.158\" x2=\"1807.35\" y2=\"336.158\" gradientTransform=\"scale(30.857 -30.857) rotate(22.527 1812.675 -4228.953)\"><stop offset=\"0\" stop-color=\"#97D6EE\"/><stop offset=\".703\" stop-color=\"#55C1EA\"/><stop offset=\"1\" stop-color=\"#55C1EA\"/></linearGradient><path fill=\"url(#p)\" d=\"M1802.977 441.733l.165.007c.472 0 .881-.146 1.242-.402.381.301.842.406 1.482.406h-3.099l.21-.011\"/></g><g transform=\"matrix(5.048 0 0 -5.048 -9064.26 2270.61)\"><linearGradient id=\"q\" gradientUnits=\"userSpaceOnUse\" x1=\"1808.848\" y1=\"335.171\" x2=\"1809.238\" y2=\"335.171\" gradientTransform=\"scale(24.717 -24.717) rotate(-24.385 124.122 4175.416)\"><stop offset=\"0\" stop-color=\"#7ACCEC\"/><stop offset=\"1\" stop-color=\"#3FB7ED\"/></linearGradient><path fill=\"url(#q)\" d=\"M1805.866 441.744c-.64 0-1.1-.105-1.482-.406.126-.089.248-.193.364-.309.531.337 1.056.561 1.574.658.198.037.395.056.589.056h-1.045v.001z\"/></g><linearGradient id=\"r\" gradientUnits=\"userSpaceOnUse\" x1=\"61.049\" y1=\"562.706\" x2=\"61.439\" y2=\"562.706\" gradientTransform=\"matrix(0 121.032 121.032 0 -68011.711 -7346.748)\"><stop offset=\"0\" stop-color=\"#1DA7E7\"/><stop offset=\"1\" stop-color=\"#37ABE7\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#r)\" d=\"M90.359 68.202c1.391-4.284 2.98-9.485 4.954-15.794 1.777-5.684 4.925-9.934 10.835-11.788l.456-.966c-9.636.577-14.14 5.479-16.405 12.738-3.964 12.673-6.365 20.888-8.677 26.123 2.952-2.823 5.904-6.288 8.837-10.313\"/></svg>"

/***/ }),

/***/ "../src/components/dot-net/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DotNetOriginal = __webpack_require__("../src/components/dot-net/original/DotNetOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DotNetOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/dot-net/plain-wordmark/DotNetPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DotNetPlainWordmark = __webpack_require__("../src/components/dot-net/plain-wordmark/DotNetPlainWordmark.svg");
	
	var _DotNetPlainWordmark2 = _interopRequireDefault(_DotNetPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DotNetPlainWordmark */
	function DotNetPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DotNetPlainWordmark',
	    svg: _DotNetPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DotNetPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DotNetPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/dot-net/plain-wordmark/DotNetPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#1384C8\" d=\"M40.335 78.188H38.65v-9.65c0-.762.05-1.69.14-2.785h-.038c-.158.64-.303 1.104-.43 1.391L33.42 78.188h-.821l-4.911-10.964c-.138-.306-.283-.799-.43-1.471h-.036c.052.576.081 1.509.081 2.804v9.631h-1.626V63.817h2.225l4.409 10.021c.332.754.547 1.328.651 1.72h.069a32.45 32.45 0 0 1 .688-1.762l4.505-9.979h2.11v14.371h.001zm5.188 0h-1.639V67.925h1.639v10.263zm.283-13.942c0 .303-.106.555-.317.763a1.04 1.04 0 0 1-.764.312 1.06 1.06 0 0 1-.757-.301 1.025 1.025 0 0 1-.313-.774c0-.296.104-.549.313-.754s.464-.305.757-.305c.3 0 .557.099.764.305.211.205.317.458.317.754M55.764 77.713c-.786.483-1.726.722-2.812.722-1.472 0-2.655-.488-3.561-1.464-.879-.947-1.321-2.169-1.321-3.667 0-1.681.48-3.042 1.45-4.077.964-1.036 2.261-1.553 3.892-1.553.892 0 1.683.174 2.375.521v1.687c-.766-.538-1.576-.805-2.445-.805-1.045 0-1.896.365-2.555 1.093-.687.745-1.034 1.742-1.034 2.985 0 1.194.317 2.14.948 2.837.633.694 1.476 1.042 2.538 1.042.897 0 1.738-.295 2.524-.882v1.561h.001zm7.84-8.123c-.289-.223-.706-.331-1.255-.331-.668 0-1.229.298-1.683.901-.516.673-.771 1.604-.771 2.795v5.232h-1.644V67.925h1.644v2.116h.039c.241-.749.614-1.325 1.112-1.733a2.456 2.456 0 0 1 1.572-.561c.438 0 .762.047.984.14l.002 1.703zm9.154 3.485c0-1.313-.296-2.317-.89-3.006-.575-.662-1.38-.992-2.416-.992-1.021 0-1.841.334-2.453 1.003-.647.715-.971 1.725-.971 3.035 0 1.228.308 2.192.93 2.879.618.692 1.45 1.039 2.494 1.039 1.08 0 1.907-.352 2.474-1.051.555-.684.832-1.652.832-2.907m1.685-.057c0 1.635-.462 2.949-1.382 3.934-.924.989-2.167 1.483-3.73 1.483-1.54 0-2.767-.494-3.665-1.483-.881-.953-1.323-2.211-1.323-3.776 0-1.786.5-3.162 1.503-4.139.929-.906 2.17-1.363 3.726-1.363 1.53 0 2.726.477 3.587 1.422.853.95 1.284 2.258 1.284 3.922m8.146 2.424c0 .84-.313 1.536-.942 2.091-.687.601-1.63.901-2.816.901-.971 0-1.822-.203-2.545-.618V76.05c.804.654 1.692.983 2.667.983 1.301 0 1.952-.479 1.952-1.434a1.27 1.27 0 0 0-.431-.991c-.289-.262-.851-.576-1.685-.943-.859-.376-1.472-.762-1.833-1.163-.434-.476-.652-1.093-.652-1.854 0-.852.341-1.561 1.014-2.125.675-.567 1.542-.85 2.606-.85.815 0 1.546.159 2.194.481v1.654c-.677-.488-1.451-.732-2.329-.732-.544 0-.981.136-1.307.399-.329.27-.494.614-.494 1.034 0 .455.138.808.412 1.061.244.233.761.519 1.541.852.876.367 1.509.748 1.895 1.137.5.494.753 1.121.753 1.883m10.04-2.367c0-1.313-.297-2.317-.892-3.006-.575-.662-1.381-.992-2.415-.992-1.021 0-1.841.334-2.456 1.003-.646.715-.969 1.725-.969 3.035 0 1.228.309 2.192.924 2.879.626.692 1.459 1.039 2.501 1.039 1.082 0 1.906-.352 2.474-1.051.555-.684.833-1.652.833-2.907m1.688-.057c0 1.635-.466 2.949-1.388 3.934-.92.989-2.163 1.483-3.727 1.483-1.542 0-2.768-.494-3.667-1.483-.881-.953-1.323-2.211-1.323-3.776 0-1.786.504-3.162 1.502-4.139.928-.906 2.171-1.363 3.728-1.363 1.531 0 2.725.477 3.584 1.422.855.95 1.291 2.258 1.291 3.922M101.555 64.438a2.2 2.2 0 0 0-1.091-.27c-1.15 0-1.721.724-1.721 2.175v1.582h2.405v1.392h-2.405v8.871h-1.645v-8.871h-1.745v-1.392h1.745v-1.664c0-1.129.346-2.016 1.05-2.654.603-.555 1.34-.831 2.217-.831.508 0 .902.061 1.189.178v1.484zm6.484 13.647c-.388.222-.904.333-1.543.333-1.791 0-2.687-1.01-2.687-3.029v-6.07h-1.761v-1.394h1.761v-2.504l1.646-.533v3.037h2.583v1.394h-2.583v5.791c0 .688.112 1.18.348 1.465.237.295.625.439 1.173.439.409 0 .763-.109 1.063-.331v1.402zm-88.802 40.157c0 .805-.286 1.5-.867 2.087a2.845 2.845 0 0 1-2.102.88 2.736 2.736 0 0 1-2.05-.88 2.915 2.915 0 0 1-.841-2.087c0-.827.279-1.525.841-2.103a2.742 2.742 0 0 1 2.05-.867c.823 0 1.524.292 2.102.878.581.588.867 1.286.867 2.092M56.018 120.606H50.66L31.212 90.572a13.803 13.803 0 0 1-1.179-2.365h-.16c.139.804.209 2.531.209 5.175v27.224h-4.416v-37.68h5.732l18.865 29.56c.751 1.173 1.265 2.013 1.525 2.519h.104c-.175-1.083-.266-2.932-.266-5.54V82.926h4.39v37.68h.002zm28.314 0H64.361v-37.68h19.104v3.993h-14.69v12.534h13.612v3.995H68.774v13.164h15.558v3.994zm30.291-33.687h-10.854v33.688h-4.415V86.919H88.479v-3.995h26.144v3.995z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#1384C8\" d=\"M82.108 46.33c.479-1.232 1.022-2.445 1.427-3.701 2.288-7.097 4.554-14.2 6.805-21.309.865-2.731 1.813-5.42 3.515-7.767 2.692-3.709 6.442-5.652 10.88-6.331a37.456 37.456 0 0 1 5.28-.406c5.267-.05 10.536-.015 15.804-.01.28 0 .56.029.957.052-.129.304-.199.525-.311.724-1.955 3.494-3.872 7.009-5.885 10.468-3.505 6.022-7.016 12.042-10.631 17.998-2.319 3.819-4.834 7.52-7.687 10.974-2.105 2.548-4.321 4.984-7.146 6.77-1.925 1.217-3.981 1.929-6.315 1.917-8.278-.045-16.556-.012-24.834-.024-2.461-.004-4.568-.941-6.356-2.603-2.563-2.381-4.093-5.412-5.345-8.608-2.284-5.835-3.563-11.951-5.031-18.014-.688-2.838-1.47-5.654-2.215-8.478-.048-.183-.142-.354-.25-.617l-.577.542c-3.228 3.207-6.071 6.741-8.615 10.498-.693 1.024-.926 2.374-1.313 3.591-1.424 4.47-2.722 8.983-4.264 13.411-1.477 4.242-4.125 7.616-8.264 9.61a18.565 18.565 0 0 1-7.689 1.855c-3.98.088-7.962.098-11.943.134-.952.009-.996-.069-.748-.99 1.707-6.338 3.87-12.514 6.58-18.492 2.794-6.167 6.085-12.048 10.231-17.419 2.823-3.657 5.941-7.031 9.843-9.582 1.979-1.293 4.083-2.315 6.477-2.584.394-.045.793-.073 1.189-.073 8.478-.004 16.956.082 25.433-.039 4.547-.065 7.839 1.855 10.304 5.515 1.533 2.276 2.63 4.761 3.553 7.328 1.861 5.178 3.018 10.547 4.325 15.878.748 3.051 1.581 6.081 2.379 9.12.06.228.157.446.238.668l.199-.006z\"/></svg>"

/***/ }),

/***/ "../src/components/dot-net/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DotNetPlainWordmark = __webpack_require__("../src/components/dot-net/plain-wordmark/DotNetPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DotNetPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/dot-net/plain/DotNetPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DotNetPlain = __webpack_require__("../src/components/dot-net/plain/DotNetPlain.svg");
	
	var _DotNetPlain2 = _interopRequireDefault(_DotNetPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DotNetPlain */
	function DotNetPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DotNetPlain',
	    svg: _DotNetPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DotNetPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DotNetPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/dot-net/plain/DotNetPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#1384C8\" d=\"M82.108 78.432c.479-1.232 1.022-2.445 1.427-3.701 2.288-7.097 4.554-14.2 6.805-21.309.865-2.731 1.813-5.42 3.515-7.767 2.692-3.709 6.442-5.652 10.88-6.331a37.456 37.456 0 0 1 5.28-.406c5.267-.05 10.536-.015 15.804-.01.28 0 .56.029.957.052-.129.304-.199.525-.311.724-1.955 3.494-3.872 7.009-5.885 10.468-3.505 6.022-7.016 12.042-10.631 17.998-2.319 3.819-4.834 7.52-7.687 10.974-2.105 2.548-4.321 4.984-7.146 6.77-1.925 1.217-3.981 1.929-6.315 1.917-8.278-.045-16.556-.012-24.834-.024-2.461-.004-4.568-.941-6.356-2.603-2.563-2.381-4.093-5.412-5.345-8.608-2.284-5.835-3.563-11.951-5.031-18.014-.688-2.838-1.47-5.654-2.215-8.478-.048-.183-.142-.354-.25-.617l-.577.542c-3.228 3.207-6.071 6.741-8.615 10.498-.693 1.024-.926 2.374-1.313 3.591-1.424 4.47-2.722 8.983-4.264 13.411-1.477 4.242-4.125 7.616-8.264 9.61a18.565 18.565 0 0 1-7.689 1.855c-3.98.088-7.962.098-11.943.134-.952.009-.996-.069-.748-.99 1.707-6.338 3.87-12.514 6.58-18.492 2.794-6.167 6.085-12.048 10.231-17.419 2.823-3.657 5.941-7.031 9.843-9.582 1.979-1.293 4.083-2.315 6.477-2.584.394-.045.793-.073 1.189-.073 8.478-.004 16.956.082 25.433-.039 4.547-.065 7.839 1.855 10.304 5.515 1.533 2.276 2.63 4.761 3.553 7.328 1.861 5.178 3.018 10.547 4.325 15.878.748 3.051 1.581 6.081 2.379 9.12.06.228.157.446.238.668l.199-.006z\"/></svg>"

/***/ }),

/***/ "../src/components/dot-net/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DotNetPlain = __webpack_require__("../src/components/dot-net/plain/DotNetPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DotNetPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/drupal/original-wordmark/DrupalOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DrupalOriginalWordmark = __webpack_require__("../src/components/drupal/original-wordmark/DrupalOriginalWordmark.svg");
	
	var _DrupalOriginalWordmark2 = _interopRequireDefault(_DrupalOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DrupalOriginalWordmark */
	function DrupalOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DrupalOriginalWordmark',
	    svg: _DrupalOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DrupalOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DrupalOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/drupal/original-wordmark/DrupalOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#0073BA\" d=\"M66.835 101.194h-5.009l.009 9.371c0 2.739-1.174 4.955-3.913 4.955s-3.924-2.216-3.924-4.955v-9.362h-4.996l-.001 9.362c0 5.412 3.479 9.798 8.891 9.798 5.411 0 8.941-4.386 8.941-9.798l.002-9.371zm45.16-5.71h4.984v24.395h-4.984zm-67.066 5.507c-4.296-.992-7.006 3.276-7.118 3.505-.056.112-.058.178-.249.173-.156-.004-.175-.173-.175-.173l-.533-3.266h-4.463v18.632h5.004v-10.085c0-.822 2.219-4.774 6.519-3.757 2.175.514 3.097 1.436 3.097 1.436v-5.676c-.805-.419-1.357-.622-2.082-.789zM73.626 126v-6.704l.002.001v-2.51s.008-.201.189-.204c.161-.002.197.106.237.204.379.943 2.466 4.541 7.097 3.412 4.145-1.168 7.186-4.975 7.186-9.495 0-5.446-4.417-9.864-9.865-9.864s-9.864 4.418-9.864 9.864v15.295l5.018.001zm4.851-20.287a4.993 4.993 0 1 1-4.993 4.991 4.992 4.992 0 0 1 4.993-4.991zm26.477 14.159h5.018v-9.168c0-5.446-4.415-9.863-9.864-9.863-5.448 0-9.865 4.417-9.865 9.863 0 4.521 3.042 8.327 7.187 9.495 4.631 1.129 6.717-2.468 7.097-3.412.04-.098.075-.205.237-.203.182.002.188.203.188.203m.144-6.083a4.994 4.994 0 1 1-9.988.002 4.994 4.994 0 0 1 9.988-.002zm-88.383 9.129h-5.692V95.475h6.108c7.396 0 13.006 1.357 13.006 12.178 0 10.719-5.943 12.18-13.422 12.18zm1.36-20.136h-2.012v15.909l2.066.053c4.238 0 6.967-.386 6.967-8.007 0-7.306-2.409-7.955-7.021-7.955z\"/><path fill=\"#00598E\" d=\"M83.539 20.706c-4.58-2.853-8.901-3.975-13.221-6.826-2.679-1.815-6.395-6.136-9.506-9.852-.604 5.962-2.419 8.383-4.493 10.11-4.407 3.457-7.173 4.494-10.975 6.567-3.198 1.643-20.566 12.012-20.566 34.306S43.53 93.724 64.355 93.724c20.826 0 38.886-15.122 38.886-38.021S86.304 22.435 83.539 20.706z\"/><path fill=\"#fff\" d=\"M76.52 74.358c1.382 0 2.852.086 3.889.777 1.037.691 1.642 2.248 1.987 3.111.346.863 0 1.382-.691 1.728-.604.346-.691.173-1.296-.949-.605-1.124-1.124-2.248-4.148-2.248s-3.975 1.037-5.444 2.248c-1.469 1.21-1.988 1.642-2.506.949-.518-.691-.346-1.382.604-2.247.951-.864 2.506-2.245 3.975-2.852 1.47-.603 2.248-.517 3.63-.517zm-14.344 9.851c1.729 1.382 4.32 2.506 9.851 2.506s9.419-1.556 11.147-2.852c.778-.605 1.123-.085 1.21.259.086.347.259.865-.346 1.469-.432.433-4.407 3.198-9.073 3.631-4.667.431-10.974.691-14.777-2.766-.604-.605-.431-1.469 0-1.814.433-.346.779-.605 1.296-.605.518-.001.433-.001.692.172z\"/><path fill=\"#0073BA\" d=\"M41.005 77.642c6.567-.086 7.777-1.21 13.566-3.801 31.282-13.999 37.07-26.789 38.194-29.727 1.123-2.938 2.765-7.691 1.037-12.962a47.63 47.63 0 0 1-.753-2.493c-4.157-4.647-8.284-7.184-9.53-7.962-4.494-2.853-8.9-3.977-13.222-6.828-2.678-1.728-6.394-6.135-9.504-9.85-.606 5.96-2.333 8.468-4.495 10.108-4.406 3.458-7.171 4.494-10.974 6.569-3.197 1.727-20.566 12.01-20.566 34.305 0 7.117 1.912 13.637 5.192 19.215l.857-.032c1.816 1.643 4.667 3.544 10.198 3.458z\"/><path fill=\"#004975\" d=\"M83.52 20.697c-4.494-2.853-8.9-3.977-13.222-6.828-2.678-1.728-6.394-6.135-9.504-9.85-.606 5.96-2.333 8.468-4.495 10.108-4.406 3.458-7.171 4.494-10.974 6.569-3.197 1.727-20.566 12.01-20.566 34.305 0 7.117 1.912 13.637 5.192 19.215 6.994 11.891 20.208 19.498 34.384 19.498 20.826 0 38.886-15.122 38.886-38.021 0-12.576-5.107-21.371-10.171-27.034-4.157-4.647-8.284-7.183-9.53-7.962zm10.503 10.115c5.673 7.094 8.551 15.465 8.551 24.882 0 5.465-1.042 10.626-3.094 15.343a35.278 35.278 0 0 1-8.333 11.781c-7.083 6.61-16.604 10.249-26.811 10.249A39.259 39.259 0 0 1 49.609 90.2a39.463 39.463 0 0 1-12.425-7.952C29.59 75.07 25.408 65.394 25.408 55.003c0-9.256 3.004-17.48 8.93-24.445 4.526-5.32 9.408-8.269 11.296-9.29a110.9 110.9 0 0 1 2.609-1.368c2.607-1.338 5.07-2.603 8.458-5.26 1.806-1.372 3.73-3.546 4.549-9.068 2.855 3.396 6.167 7.21 8.698 8.844 2.247 1.483 4.551 2.522 6.78 3.527 2.107.95 4.288 1.933 6.445 3.302l.082.05c6.304 3.935 9.663 8.137 10.768 9.517z\"/><path fill=\"#93C5E4\" d=\"M61.225 5.747c1.209 3.542 1.037 5.357 1.037 6.136 0 .777-.432 2.852-1.815 3.888-.605.433-.777.777-.777.865 0 .344.777.604.777 1.381 0 .951-.431 2.853-5.011 7.432-4.58 4.58-11.147 8.642-16.246 11.146-5.098 2.507-7.517 2.335-8.208 1.125-.692-1.21.259-3.889 3.456-7.432 3.197-3.544 13.308-8.642 13.308-8.642l12.617-8.813.69-3.37\"/><path fill=\"#fff\" d=\"M61.225 5.659c-.778 5.704-2.506 7.434-4.839 9.246-3.889 2.939-7.69 4.753-8.555 5.186-2.247 1.123-10.369 5.617-14.604 12.099-1.296 1.987 0 2.765.259 2.938.26.173 3.197.519 9.505-3.283 6.309-3.803 9.074-6.049 12.617-9.765 1.901-1.988 2.16-3.111 2.16-3.63 0-.604-.432-.863-1.123-1.037-.347-.086-.432-.259 0-.518s2.246-1.124 2.679-1.469c.432-.347 2.506-1.728 2.592-3.976.086-2.247-.086-3.803-.691-5.791zM41.782 68.481c.086-6.74 6.395-13.048 14.345-13.135 10.11-.085 17.109 10.024 22.208 9.938 4.32-.086 12.616-8.554 16.678-8.554 4.32 0 5.531 4.494 5.531 7.172 0 2.679-.865 7.518-2.939 10.542s-3.37 4.148-5.789 3.975c-3.111-.259-9.333-9.938-13.308-10.109-5.011-.173-15.9 10.455-24.455 10.455-5.184 0-6.739-.776-8.468-1.901-2.593-1.814-3.889-4.581-3.803-8.383z\"/><path d=\"M93.803 31.152c1.728 5.271.086 10.023-1.037 12.962-1.124 2.938-6.913 15.728-38.194 29.727-5.79 2.591-7 3.715-13.566 3.801-5.531.086-8.382-1.814-10.197-3.457l-.857.032c6.994 11.891 20.208 19.498 34.384 19.498 20.826 0 38.886-15.122 38.886-38.021 0-12.576-5.107-21.371-10.171-27.034.174.657.418 1.474.752 2.492z\" fill=\"none\"/></svg>"

/***/ }),

/***/ "../src/components/drupal/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DrupalOriginalWordmark = __webpack_require__("../src/components/drupal/original-wordmark/DrupalOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DrupalOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/drupal/original/DrupalOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DrupalOriginal = __webpack_require__("../src/components/drupal/original/DrupalOriginal.svg");
	
	var _DrupalOriginal2 = _interopRequireDefault(_DrupalOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DrupalOriginal */
	function DrupalOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DrupalOriginal',
	    svg: _DrupalOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DrupalOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DrupalOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/drupal/original/DrupalOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#00598E\" d=\"M91.1 24.935c-6.352-3.956-12.345-5.513-18.337-9.469-3.716-2.516-8.869-8.51-13.185-13.663-.838 8.27-3.355 11.625-6.231 14.022-6.112 4.795-9.948 6.232-15.222 9.109C33.69 27.212 9.601 41.595 9.601 72.516c0 30.923 26.008 53.694 54.892 53.694 28.886 0 53.934-20.974 53.934-52.734-.001-31.762-23.491-46.143-27.327-48.541z\"/><path fill=\"#fff\" d=\"M81.365 99.35c1.917 0 3.955.119 5.394 1.079 1.438.958 2.277 3.116 2.756 4.314.479 1.199 0 1.917-.959 2.396-.838.48-.958.24-1.797-1.317-.839-1.558-1.559-3.117-5.753-3.117-4.195 0-5.514 1.439-7.551 3.117-2.038 1.678-2.757 2.277-3.476 1.317-.719-.958-.479-1.917.839-3.116s3.476-3.116 5.513-3.955c2.038-.838 3.117-.718 5.034-.718zM61.47 113.013c2.397 1.917 5.992 3.475 13.663 3.475s13.063-2.157 15.461-3.954c1.079-.84 1.558-.12 1.678.359.12.479.36 1.199-.479 2.037-.599.6-6.112 4.435-12.584 5.034-6.473.599-15.221.959-20.495-3.835-.839-.839-.599-2.037 0-2.516.6-.479 1.079-.84 1.798-.84s.598-.001.958.24z\"/><path fill=\"#0073BA\" d=\"M32.106 103.903c9.108-.119 10.786-1.678 18.816-5.273 43.387-19.416 51.416-37.153 52.975-41.229 1.558-4.076 3.835-10.667 1.438-17.979a66.4 66.4 0 0 1-1.045-3.456c-5.765-6.447-11.489-9.965-13.218-11.045-6.232-3.955-12.345-5.513-18.338-9.468-3.715-2.397-8.868-8.51-13.183-13.663-.84 8.269-3.236 11.746-6.233 14.022-6.112 4.795-9.947 6.233-15.221 9.109-4.433 2.397-28.523 16.66-28.523 47.581 0 9.873 2.651 18.915 7.201 26.649l1.188-.042c2.517 2.278 6.473 4.914 14.143 4.794z\"/><path fill=\"#004975\" d=\"M91.073 24.922c-6.232-3.955-12.345-5.513-18.338-9.468-3.715-2.397-8.868-8.51-13.183-13.663-.84 8.269-3.236 11.746-6.233 14.022-6.112 4.795-9.947 6.233-15.221 9.109-4.434 2.396-28.524 16.659-28.524 47.58 0 9.873 2.651 18.915 7.201 26.649 9.7 16.492 28.028 27.044 47.69 27.044 28.885 0 53.934-20.974 53.934-52.735 0-17.441-7.084-29.641-14.108-37.494-5.765-6.446-11.489-9.964-13.218-11.044zm14.569 14.03c7.868 9.838 11.859 21.448 11.859 34.509 0 7.58-1.444 14.739-4.291 21.281a48.926 48.926 0 0 1-11.559 16.34c-9.823 9.168-23.029 14.216-37.186 14.216-7.003 0-13.875-1.338-20.427-3.977a54.728 54.728 0 0 1-17.232-11.029c-10.533-9.955-16.334-23.375-16.334-37.789 0-12.837 4.167-24.244 12.386-33.905 6.278-7.379 13.049-11.469 15.668-12.885a152.775 152.775 0 0 1 3.618-1.898c3.616-1.856 7.032-3.609 11.73-7.295 2.505-1.903 5.174-4.919 6.31-12.576 3.96 4.708 8.554 10 12.064 12.264 3.116 2.058 6.312 3.499 9.403 4.892 2.923 1.319 5.947 2.682 8.938 4.581l.113.07c8.748 5.46 13.407 11.286 14.94 13.201z\"/><path fill=\"#93C5E4\" d=\"M60.151 4.187c1.678 4.914 1.438 7.431 1.438 8.51s-.6 3.956-2.518 5.393c-.839.6-1.078 1.079-1.078 1.199 0 .479 1.078.839 1.078 1.917 0 1.319-.599 3.956-6.951 10.308-6.353 6.352-15.461 11.985-22.532 15.46-7.071 3.476-10.427 3.237-11.386 1.559-.959-1.678.359-5.393 4.794-10.307 4.435-4.915 18.457-11.986 18.457-11.986l17.499-12.224.958-4.675\"/><path fill=\"#fff\" d=\"M60.151 4.067c-1.079 7.911-3.476 10.308-6.712 12.824-5.394 4.076-10.667 6.592-11.865 7.191-3.116 1.558-14.382 7.791-20.255 16.78-1.798 2.756 0 3.835.359 4.074.36.24 4.435.719 13.184-4.554 8.75-5.274 12.585-8.39 17.499-13.544 2.637-2.756 2.996-4.314 2.996-5.034 0-.838-.6-1.198-1.558-1.438-.48-.12-.6-.36 0-.719.599-.359 3.115-1.558 3.715-2.037.6-.479 3.476-2.396 3.596-5.513.119-3.116-.12-5.274-.959-8.03zM33.185 91.199c.12-9.349 8.869-18.098 19.896-18.218 14.022-.119 23.73 13.903 30.802 13.783 5.991-.118 17.497-11.864 23.131-11.864 5.992 0 7.671 6.232 7.671 9.948 0 3.715-1.199 10.427-4.076 14.621-2.876 4.196-4.674 5.753-8.029 5.513-4.314-.359-12.944-13.783-18.458-14.022-6.95-.24-22.053 14.501-33.918 14.501-7.19 0-9.348-1.078-11.745-2.637-3.597-2.515-5.394-6.351-5.274-11.625z\"/><path d=\"M105.336 39.423c2.396 7.311.119 13.903-1.438 17.979-1.559 4.075-9.588 21.813-52.975 41.229-8.03 3.595-9.708 5.154-18.816 5.273-7.671.12-11.626-2.516-14.143-4.793l-1.188.042c9.7 16.492 28.028 27.044 47.69 27.044 28.885 0 53.934-20.974 53.934-52.735 0-17.441-7.084-29.641-14.108-37.494.243.91.581 2.044 1.044 3.455z\" fill=\"none\"/></svg>"

/***/ }),

/***/ "../src/components/drupal/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DrupalOriginal = __webpack_require__("../src/components/drupal/original/DrupalOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DrupalOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/drupal/plain-wordmark/DrupalPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DrupalPlainWordmark = __webpack_require__("../src/components/drupal/plain-wordmark/DrupalPlainWordmark.svg");
	
	var _DrupalPlainWordmark2 = _interopRequireDefault(_DrupalPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DrupalPlainWordmark */
	function DrupalPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DrupalPlainWordmark',
	    svg: _DrupalPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DrupalPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DrupalPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/drupal/plain-wordmark/DrupalPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#0073BA\" d=\"M66.835 101.194h-5.009l.009 9.371c0 2.739-1.175 4.955-3.913 4.955-2.739 0-3.924-2.216-3.924-4.955v-9.362h-4.996l-.001 9.362c0 5.412 3.479 9.798 8.892 9.798 5.41 0 8.94-4.386 8.94-9.798l.002-9.371zm45.159-5.71h4.984v24.395h-4.984zm-67.065 5.507c-4.296-.992-7.006 3.276-7.118 3.505-.056.112-.058.178-.249.173-.156-.004-.175-.173-.175-.173l-.533-3.266h-4.463v18.632h5.004v-10.085c0-.822 2.219-4.774 6.519-3.757 2.175.514 3.097 1.436 3.097 1.436v-5.676c-.805-.419-1.357-.622-2.082-.789zM73.626 126v-6.704l.002.001v-2.51s.009-.201.189-.204c.161-.002.197.106.237.204.379.943 2.465 4.541 7.097 3.412 4.146-1.168 7.187-4.975 7.187-9.495 0-5.446-4.418-9.864-9.865-9.864-5.448 0-9.865 4.418-9.865 9.864v15.295l5.018.001zm4.851-20.287a4.993 4.993 0 1 1 .002 9.986 4.993 4.993 0 0 1-.002-9.986zm26.477 14.159h5.018v-9.168c0-5.446-4.415-9.863-9.864-9.863-5.448 0-9.865 4.417-9.865 9.863 0 4.521 3.041 8.327 7.187 9.495 4.632 1.129 6.717-2.468 7.097-3.412.04-.098.075-.205.237-.203.182.002.188.203.188.203m.144-6.083a4.993 4.993 0 1 1-9.987.003 4.993 4.993 0 0 1 9.987-.003zm-88.383 9.129h-5.692V95.475h6.108c7.396 0 13.006 1.357 13.006 12.178 0 10.719-5.943 12.18-13.422 12.18zm1.36-20.136h-2.012v15.909l2.066.053c4.238 0 6.967-.386 6.967-8.007 0-7.306-2.409-7.955-7.021-7.955zm65.684-80.82c-4.632-2.887-9.004-4.022-13.374-6.907-2.711-1.835-6.469-6.207-9.618-9.966-.611 6.031-2.447 8.479-4.545 10.228-4.459 3.497-7.257 4.547-11.103 6.646-3.235 1.66-20.807 12.15-20.807 34.704 0 22.557 18.971 39.166 40.039 39.166 21.071 0 39.342-15.299 39.342-38.466S86.556 20.625 83.757 18.877zm.507 65.644c-.438.438-4.46 3.234-9.18 3.672-4.722.438-11.103.7-14.95-2.797-.611-.612-.436-1.486 0-1.835.438-.351.788-.613 1.312-.613s.438 0 .7.175c1.747 1.398 4.37 2.535 9.965 2.535 5.597 0 9.53-1.574 11.277-2.885.789-.612 1.137-.087 1.224.263.088.349.263.873-.348 1.485zm-15.301-7.956c.963-.874 2.537-2.272 4.022-2.885 1.485-.611 2.274-.524 3.672-.524 1.398 0 2.884.086 3.935.787 1.049.698 1.661 2.272 2.01 3.147.35.874 0 1.397-.698 1.747-.612.351-.7.175-1.312-.96-.612-1.138-1.138-2.274-4.197-2.274-3.061 0-4.021 1.05-5.508 2.274-1.486 1.224-2.01 1.661-2.534.96-.525-.698-.351-1.398.61-2.272zm23.169.7c-3.147-.262-9.443-10.054-13.465-10.229-5.069-.175-16.086 10.578-24.74 10.578-5.244 0-6.819-.786-8.567-1.923-2.623-1.836-3.934-4.634-3.847-8.48.089-6.819 6.47-13.201 14.512-13.289 10.229-.085 17.31 10.143 22.469 10.055 4.371-.087 12.764-8.654 16.872-8.654 4.371 0 5.597 4.546 5.597 7.256s-.876 7.605-2.974 10.664c-2.099 3.06-3.41 4.196-5.857 4.022z\"/></svg>"

/***/ }),

/***/ "../src/components/drupal/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DrupalPlainWordmark = __webpack_require__("../src/components/drupal/plain-wordmark/DrupalPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DrupalPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/drupal/plain/DrupalPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _DrupalPlain = __webpack_require__("../src/components/drupal/plain/DrupalPlain.svg");
	
	var _DrupalPlain2 = _interopRequireDefault(_DrupalPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** DrupalPlain */
	function DrupalPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'DrupalPlain',
	    svg: _DrupalPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	DrupalPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = DrupalPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/drupal/plain/DrupalPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#0073BA\" d=\"M91.086 24.929c-6.352-3.956-12.344-5.514-18.336-9.469-3.717-2.517-8.869-8.51-13.186-13.663-.838 8.27-3.355 11.626-6.23 14.022-6.113 4.795-9.949 6.232-15.222 9.109-4.435 2.277-28.524 16.659-28.524 47.58 0 30.923 26.008 53.693 54.891 53.693 28.887 0 53.934-20.974 53.934-52.734S94.922 27.325 91.086 24.929zm.693 89.994c-.6.6-6.113 4.435-12.584 5.034-6.473.599-15.221.96-20.496-3.835-.838-.84-.598-2.037 0-2.517.6-.479 1.08-.84 1.799-.84s.6 0 .959.24c2.396 1.917 5.992 3.476 13.662 3.476 7.672 0 13.064-2.158 15.461-3.955 1.08-.84 1.559-.119 1.678.359.121.48.361 1.2-.479 2.038zm-20.974-10.906c1.318-1.199 3.477-3.115 5.514-3.955 2.037-.838 3.117-.719 5.033-.719 1.918 0 3.955.119 5.395 1.079 1.438.958 2.277 3.116 2.756 4.314s0 1.917-.959 2.396c-.838.48-.959.24-1.797-1.316-.84-1.559-1.559-3.117-5.754-3.117s-5.514 1.438-7.551 3.117c-2.037 1.678-2.756 2.277-3.475 1.316-.719-.958-.481-1.916.838-3.115zm31.761.959c-4.314-.359-12.945-13.783-18.459-14.022-6.949-.24-22.053 14.501-33.918 14.501-7.19 0-9.347-1.077-11.745-2.637-3.596-2.516-5.393-6.352-5.273-11.625.12-9.349 8.869-18.098 19.895-18.218 14.023-.118 23.73 13.903 30.803 13.783 5.992-.119 17.498-11.864 23.131-11.864 5.992 0 7.672 6.232 7.672 9.947s-1.199 10.427-4.076 14.621c-2.877 4.195-4.674 5.754-8.03 5.514z\"/></svg>"

/***/ }),

/***/ "../src/components/drupal/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DrupalPlain = __webpack_require__("../src/components/drupal/plain/DrupalPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DrupalPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/electron/original-wordmark/ElectronOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ElectronOriginalWordmark = __webpack_require__("../src/components/electron/original-wordmark/ElectronOriginalWordmark.svg");
	
	var _ElectronOriginalWordmark2 = _interopRequireDefault(_ElectronOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ElectronOriginalWordmark */
	function ElectronOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ElectronOriginalWordmark',
	    svg: _ElectronOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ElectronOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ElectronOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/electron/original-wordmark/ElectronOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Electron\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#47848f}</style></defs><title>Artboard 7</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M29 69.59h6.65a.35.35 0 1 0 0-.7h-6.26V64.8h5.55a.35.35 0 1 0 0-.7h-5.55v-4h6.2a.35.35 0 1 0 0-.7H29a.39.39 0 0 0-.38.38v9.43a.39.39 0 0 0 .38.38zm11.62-.38a.39.39 0 0 0 .38.38h6.07a.35.35 0 0 0 0-.7h-5.68v-9.17a.38.38 0 0 0-.76 0zm11.64.38h6.65a.35.35 0 1 0 0-.7h-6.27V64.8h5.55a.35.35 0 1 0 0-.7h-5.55v-4h6.2a.35.35 0 0 0 0-.7h-6.58a.39.39 0 0 0-.38.38v9.43a.39.39 0 0 0 .38.38zm16.24.17a5.28 5.28 0 0 0 3.86-1.59.37.37 0 0 0 .12-.26.38.38 0 0 0-.36-.36.37.37 0 0 0-.26.12 4.49 4.49 0 0 1-3.32 1.41 4.39 4.39 0 0 1-4.31-4.59 4.36 4.36 0 0 1 4.29-4.56 4.55 4.55 0 0 1 3.25 1.32.39.39 0 0 0 .26.1.4.4 0 0 0 .39-.38.44.44 0 0 0-.15-.31 5.32 5.32 0 0 0-3.74-1.43 5.12 5.12 0 0 0-5.09 5.27 5.06 5.06 0 0 0 5.07 5.24zm11.2-.49a.38.38 0 0 0 .76 0V60.1h3.26a.35.35 0 1 0 0-.7h-7.28a.35.35 0 1 0 0 .7h3.26zm8.85 0a.38.38 0 0 0 .76 0v-3.9h3.33l3.13 4.08a.42.42 0 0 0 .33.2.41.41 0 0 0 .39-.39.42.42 0 0 0-.12-.26l-2.9-3.76c1.72-.23 3-1.21 3-2.91a2.69 2.69 0 0 0-.77-1.89 4 4 0 0 0-2.87-1h-3.9a.39.39 0 0 0-.38.38zm.76-4.59V60.1h3.48c1.85 0 2.93.86 2.93 2.23 0 1.47-1.27 2.33-3 2.33zM106 69.76a5.13 5.13 0 0 0 5.14-5.27 5.13 5.13 0 1 0-10.25 0 5.08 5.08 0 0 0 5.11 5.27zm0-.68a4.41 4.41 0 0 1-4.35-4.59 4.36 4.36 0 0 1 4.35-4.58 4.41 4.41 0 0 1 4.35 4.59 4.36 4.36 0 0 1-4.35 4.58zm9.93.2a.36.36 0 0 0 .73 0V60.5l7 8.88a.52.52 0 0 0 .38.25h.06a.31.31 0 0 0 .31-.32V59.7a.36.36 0 0 0-.73 0v8.59l-6.87-8.72a.47.47 0 0 0-.38-.22h-.12a.39.39 0 0 0-.38.38zM9.58 58.75c-2.41-.44-4.31 0-5.07 1.33a3.67 3.67 0 0 0 .39 3.67.25.25 0 0 0 .43-.25 3.21 3.21 0 0 1-.39-3.18c.63-1.09 2.33-1.5 4.55-1.09a.25.25 0 0 0 .09-.49zm-3.43 6.69a15.44 15.44 0 0 0 3.68 2.9c3.49 2 7.21 2.55 9 1.31a.25.25 0 0 0-.28-.41c-1.64 1.12-5.17.61-8.51-1.32a15 15 0 0 1-3.56-2.81.25.25 0 0 0-.36.33z\"/><path class=\"cls-1\" d=\"M18.29 65.14c1.58-1.86 2.13-3.73 1.37-5a3.63 3.63 0 0 0-3.3-1.49.25.25 0 0 0 0 .49 3.17 3.17 0 0 1 2.88 1.25c.63 1.09.14 2.76-1.32 4.48a.25.25 0 1 0 .38.32zm-4-6.31a15.41 15.41 0 0 0-4.4 1.74c-3.6 2.08-6 5.15-5.63 7.37a.25.25 0 0 0 .49-.07C4.41 65.9 6.64 63 10.09 61a14.92 14.92 0 0 1 4.25-1.69.25.25 0 1 0-.1-.48z\"/><path class=\"cls-1\" d=\"M8.4 69.49c.82 2.3 2.17 3.72 3.69 3.72A3.61 3.61 0 0 0 15 71.13a.25.25 0 1 0-.42-.25 3.15 3.15 0 0 1-2.5 1.84c-1.26 0-2.46-1.26-3.22-3.39a.25.25 0 0 0-.46.17zm7.52-.49a15.49 15.49 0 0 0 .66-4.57c0-4.09-1.43-7.61-3.47-8.52a.25.25 0 0 0-.2.45c1.82.81 3.18 4.15 3.18 8.06a15 15 0 0 1-.63 4.43.25.25 0 0 0 .47.15zM20.57 68.8a1.18 1.18 0 1 0-1.18 1.2 1.18 1.18 0 0 0 1.18-1.18zm-.49 0a.69.69 0 1 1-.69-.69.69.69 0 0 1 .69.69zM4.77 70a1.18 1.18 0 1 0-1.18-1.2A1.18 1.18 0 0 0 4.77 70zm0-.49a.69.69 0 1 1 .69-.69.69.69 0 0 1-.69.69z\"/><path class=\"cls-1\" d=\"M12.09 57.16A1.18 1.18 0 1 0 10.91 56a1.18 1.18 0 0 0 1.18 1.18zm0-.49a.69.69 0 1 1 .69-.69.69.69 0 0 1-.69.69zM12.27 65.3a.85.85 0 1 1 .65-1 .85.85 0 0 1-.65 1z\"/></g></svg>"

/***/ }),

/***/ "../src/components/electron/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ElectronOriginalWordmark = __webpack_require__("../src/components/electron/original-wordmark/ElectronOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ElectronOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/electron/original/ElectronOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ElectronOriginal = __webpack_require__("../src/components/electron/original/ElectronOriginal.svg");
	
	var _ElectronOriginal2 = _interopRequireDefault(_ElectronOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ElectronOriginal */
	function ElectronOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ElectronOriginal',
	    svg: _ElectronOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ElectronOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ElectronOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/electron/original/ElectronOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Electron\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#47848f}</style></defs><title>Artboard 5</title><g id=\"original\"><path class=\"cls-1\" d=\"M49.07 32.66c-14.37-2.62-25.72.12-30.25 8-3.38 5.85-2.41 13.61 2.34 21.9a1.47 1.47 0 0 0 2.56-1.47c-4.28-7.47-5.12-14.17-2.35-19 3.76-6.51 13.89-9 27.17-6.54a1.47 1.47 0 1 0 .53-2.9zM28.63 72.61a92.2 92.2 0 0 0 22 17.34c20.84 12 43 15.25 54 7.79a1.47 1.47 0 0 0-1.66-2.43C93.11 102 72 98.92 52.07 87.39a89.27 89.27 0 0 1-21.26-16.77 1.47 1.47 0 0 0-2.18 2z\"/><path class=\"cls-1\" d=\"M101.06 70.81c9.41-11.11 12.69-22.29 8.17-30.11-3.32-5.76-10.35-8.8-19.69-8.92a1.47 1.47 0 0 0 0 2.95c8.4.11 14.45 2.73 17.18 7.45 3.75 6.5.82 16.47-7.87 26.74a1.47 1.47 0 1 0 2.25 1.9zM76.89 33.15a92 92 0 0 0-26.25 10.4C29.13 56 15.09 74.29 17 87.57a1.47 1.47 0 0 0 3-.43C18.23 75.35 31.53 58 52.11 46.11A89.07 89.07 0 0 1 77.51 36a1.47 1.47 0 1 0-.62-2.88z\"/><path class=\"cls-1\" d=\"M42 96.78C47 110.51 55 119 64.05 119c6.6 0 12.7-4.5 17.46-12.42A1.47 1.47 0 1 0 79 105c-4.28 7.12-9.53 11-14.94 11-7.52 0-14.69-7.54-19.24-20.24a1.47 1.47 0 0 0-2.77 1zm45-2.69a92.5 92.5 0 0 0 3.91-27.3c0-24.41-8.54-45.44-20.71-50.85a1.47 1.47 0 0 0-1.2 2.7c10.85 4.82 19 24.78 19 48.15a89.57 89.57 0 0 1-3.78 26.42 1.47 1.47 0 0 0 2.81.88zM114.71 92.65a7.05 7.05 0 1 0-7.05 7.05 7.05 7.05 0 0 0 7.05-7.05zm-2.95 0a4.1 4.1 0 1 1-4.1-4.1 4.1 4.1 0 0 1 4.1 4.1zM20.34 99.7a7.05 7.05 0 1 0-7.05-7.05 7.05 7.05 0 0 0 7.05 7.05zm0-2.95a4.1 4.1 0 1 1 4.1-4.1 4.1 4.1 0 0 1-4.1 4.1z\"/><path class=\"cls-1\" d=\"M64.05 23.13A7.05 7.05 0 1 0 57 16.08a7.05 7.05 0 0 0 7.05 7.05zm0-2.95a4.1 4.1 0 1 1 4.1-4.1 4.1 4.1 0 0 1-4.1 4.1zM65.13 71.77A5.1 5.1 0 1 1 69 65.71a5.1 5.1 0 0 1-3.87 6.06z\"/></g></svg>"

/***/ }),

/***/ "../src/components/electron/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ElectronOriginal = __webpack_require__("../src/components/electron/original/ElectronOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ElectronOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/elm/original-wordmark/ElmOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ElmOriginalWordmark = __webpack_require__("../src/components/elm/original-wordmark/ElmOriginalWordmark.svg");
	
	var _ElmOriginalWordmark2 = _interopRequireDefault(_ElmOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ElmOriginalWordmark */
	function ElmOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ElmOriginalWordmark',
	    svg: _ElmOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ElmOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ElmOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/elm/original-wordmark/ElmOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Elm\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#efa500}.cls-2{fill:#8dd737}.cls-3{fill:#60b5cc}.cls-4{fill:#34495e}</style></defs><title>Artboard 13</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M27.29 62.59l11.15-11.15h-22.3l11.15 11.15z\"/><path class=\"cls-2\" d=\"M2.92 38.21l11.22 11.23h24.41L27.32 38.21H2.92z\"/><path class=\"cls-2\" transform=\"rotate(-45 40.877 63.968)\" d=\"M32.25 55.38h17.26v17.18H32.25z\"/><path class=\"cls-3\" d=\"M53.08 61.14V38.21H30.15l22.93 22.93z\"/><path class=\"cls-4\" d=\"M25.87 64L1.5 39.63v48.74L25.87 64z\"/><path class=\"cls-1\" d=\"M42.27 77.56l10.81 10.81V66.75L42.27 77.56z\"/><path class=\"cls-3\" d=\"M27.29 65.42L2.92 89.79h48.74L27.29 65.42z\"/><path class=\"cls-4\" d=\"M62.74 50.22h16.7v3.09h-13v9.1h11v3.14h-11v10.52h13.44v3.13H62.74zM85.58 47.74h3.62v27.4c0 1.15.49 1.59 1 1.59a3.08 3.08 0 0 0 .8-.09l.49 2.74a4.89 4.89 0 0 1-2.08.35c-2.74 0-3.84-1.72-3.84-4.86zM96.85 57.73h3l.31 3.09h.13c1.86-2 4.11-3.62 6.67-3.62 3.27 0 5 1.55 5.92 4.11 2.25-2.43 4.46-4.11 7.07-4.11 4.42 0 6.54 2.92 6.54 8.39V79.2h-3.62V66.08c0-4-1.28-5.74-4-5.74-1.68 0-3.4 1.11-5.39 3.31V79.2h-3.62V66.08c0-4-1.28-5.74-4-5.74-1.59 0-3.4 1.11-5.39 3.31V79.2h-3.62z\"/></g></svg>"

/***/ }),

/***/ "../src/components/elm/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ElmOriginalWordmark = __webpack_require__("../src/components/elm/original-wordmark/ElmOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ElmOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/elm/original/ElmOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ElmOriginal = __webpack_require__("../src/components/elm/original/ElmOriginal.svg");
	
	var _ElmOriginal2 = _interopRequireDefault(_ElmOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ElmOriginal */
	function ElmOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ElmOriginal',
	    svg: _ElmOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ElmOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ElmOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/elm/original/ElmOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Elm\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#efa500}.cls-2{fill:#8dd737}.cls-3{fill:#60b5cc}.cls-4{fill:#34495e}</style></defs><title>Artboard 12</title><g id=\"original\"><path class=\"cls-1\" d=\"M64 60.74l25.65-25.65h-51.3L64 60.74z\"/><path class=\"cls-2\" d=\"M7.91 4.65l25.83 25.84h56.17L64.07 4.65H7.91z\"/><path class=\"cls-2\" transform=\"rotate(-45 95.27 63.928)\" d=\"M75.42 44.17h39.71V83.7H75.42z\"/><path class=\"cls-3\" d=\"M123.35 57.42V4.65H70.58l52.77 52.77z\"/><path class=\"cls-4\" d=\"M60.74 64L4.65 7.91V120.1L60.74 64z\"/><path class=\"cls-1\" d=\"M98.47 95.21l24.88 24.89V70.33L98.47 95.21z\"/><path class=\"cls-3\" d=\"M64 67.26L7.91 123.35h112.18L64 67.26z\"/></g></svg>"

/***/ }),

/***/ "../src/components/elm/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ElmOriginal = __webpack_require__("../src/components/elm/original/ElmOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ElmOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/elm/plain-wordmark/ElmPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ElmPlainWordmark = __webpack_require__("../src/components/elm/plain-wordmark/ElmPlainWordmark.svg");
	
	var _ElmPlainWordmark2 = _interopRequireDefault(_ElmPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ElmPlainWordmark */
	function ElmPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ElmPlainWordmark',
	    svg: _ElmPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ElmPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ElmPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/elm/plain-wordmark/ElmPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Elm\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#34495e}</style></defs><title>Artboard 15</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M27.29 62.59l11.15-11.15h-22.3l11.15 11.15zM2.92 38.21l11.22 11.23h24.41L27.32 38.21H2.92z\"/><path class=\"cls-1\" transform=\"rotate(-45 40.877 63.968)\" d=\"M32.25 55.38h17.26v17.18H32.25z\"/><path class=\"cls-1\" d=\"M53.08 61.14V38.21H30.15l22.93 22.93zM25.87 64L1.5 39.63v48.74L25.87 64zM42.27 77.56l10.81 10.81V66.75L42.27 77.56zM27.29 65.42L2.92 89.79h48.74L27.29 65.42zM62.74 50.22h16.7v3.09h-13v9.1h11v3.14h-11v10.52h13.44v3.13H62.74zM85.58 47.74h3.62v27.4c0 1.15.49 1.59 1 1.59a3.08 3.08 0 0 0 .8-.09l.49 2.74a4.89 4.89 0 0 1-2.08.35c-2.74 0-3.84-1.72-3.84-4.86zM96.85 57.73h3l.31 3.09h.13c1.86-2 4.11-3.62 6.67-3.62 3.27 0 5 1.55 5.92 4.11 2.25-2.43 4.46-4.11 7.07-4.11 4.42 0 6.54 2.92 6.54 8.39V79.2h-3.62V66.08c0-4-1.28-5.74-4-5.74-1.68 0-3.4 1.11-5.39 3.31V79.2h-3.62V66.08c0-4-1.28-5.74-4-5.74-1.59 0-3.4 1.11-5.39 3.31V79.2h-3.62z\"/></g></svg>"

/***/ }),

/***/ "../src/components/elm/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ElmPlainWordmark = __webpack_require__("../src/components/elm/plain-wordmark/ElmPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ElmPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/elm/plain/ElmPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ElmPlain = __webpack_require__("../src/components/elm/plain/ElmPlain.svg");
	
	var _ElmPlain2 = _interopRequireDefault(_ElmPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ElmPlain */
	function ElmPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ElmPlain',
	    svg: _ElmPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ElmPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ElmPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/elm/plain/ElmPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Elm\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#34495e}</style></defs><title>Artboard 14</title><g id=\"plain\"><path class=\"cls-1\" d=\"M64 60.74l25.65-25.65h-51.3L64 60.74zM7.91 4.65l25.83 25.84h56.17L64.07 4.65H7.91z\"/><path class=\"cls-1\" transform=\"rotate(-45 95.27 63.928)\" d=\"M75.42 44.17h39.71V83.7H75.42z\"/><path class=\"cls-1\" d=\"M123.35 57.42V4.65H70.58l52.77 52.77zM60.74 64L4.65 7.91V120.1L60.74 64zM98.47 95.21l24.88 24.89V70.33L98.47 95.21zM64 67.26L7.91 123.35h112.18L64 67.26z\"/></g></svg>"

/***/ }),

/***/ "../src/components/elm/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ElmPlain = __webpack_require__("../src/components/elm/plain/ElmPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ElmPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ember/original-wordmark/EmberOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _EmberOriginalWordmark = __webpack_require__("../src/components/ember/original-wordmark/EmberOriginalWordmark.svg");
	
	var _EmberOriginalWordmark2 = _interopRequireDefault(_EmberOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** EmberOriginalWordmark */
	function EmberOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'EmberOriginalWordmark',
	    svg: _EmberOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	EmberOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = EmberOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ember/original-wordmark/EmberOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Ember\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1,.cls-2{fill:#dd3f24}.cls-2{font-size:8.5px;font-family:MyriadPro-Regular,Myriad Pro}</style></defs><title>Artboard 5</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M127.28 72.53a1.46 1.46 0 0 0-2.13-1.34s-3.08 2.39-5.79 2.12S117.5 67 117.5 67s.58-5.55-1-6-3.56 1.45-3.56 1.45a20 20 0 0 0-3.61 6.17l-.32.11s.37-6.06-.05-7.44c-.32-.69-3.24-.64-3.72.58s-2.82 9.73-3 13.29c0 0-4.57 3.88-8.56 4.52s-4.94-1.86-4.94-1.86 10.84-3 10.47-11.69-8.74-5.46-9.69-4.75-5.81 3.62-7.23 11.77c0 .28-.13 1.49-.13 1.49a37.47 37.47 0 0 1-6.54 3.56s6.54-11-1.44-16c-3.61-2.2-6.48 2.4-6.48 2.4s10.79-12 8.4-22.16c-1.14-4.83-3.56-5.35-5.77-4.57a10.06 10.06 0 0 0-4.64 3.3 37.12 37.12 0 0 0-5.37 15.73c-1 9.41-2.5 20.78-2.5 20.78s-2.07 2-4 2.13-1.06-5.69-1.06-5.69 1.49-8.82 1.38-10.31-.21-2.29-2-2.82-3.67 1.7-3.67 1.7-5 7.65-5.47 8.82l-.27.48-.27-.32s3.56-10.42.16-10.58S37 64.81 37 64.81 33.15 71.3 33 72l-.27-.32s1.59-7.55 1.28-9.41a1.71 1.71 0 0 0-2.07-1.49s-2.23-.27-2.82 1.17a105.2 105.2 0 0 0-3 14s-5.58 4-9.25 4-3.3-2.33-3.3-2.33S27 73.09 23.37 64a6.66 6.66 0 0 0-6.27-3c-2.71.05-6 1.71-8.17 6.6a21.21 21.21 0 0 0-1.55 6.22s-2.43.48-3.71-.58-2 0-2 0-2.21 2.75 0 3.6A26.67 26.67 0 0 0 7.22 78a10.25 10.25 0 0 0 3.87 6.07c4 3 11.64-.26 11.64-.26l3.14-1.75S26 85 28.26 85.39s3.24 0 7.23-9.68C37.83 70.77 38 71 38 71l.27-.05s-1.81 9.46-1.12 12 3.72 2.29 3.72 2.29 1.65.28 3-4.4A70 70 0 0 1 47.71 71H48s-1.12 9.71.58 12.8 6.11 1.06 6.11 1.06a30.71 30.71 0 0 0 3.56-2 12.53 12.53 0 0 0 8.82 2.55c11.54-2.27 15.64-5.33 15.64-5.33a9.52 9.52 0 0 0 8.12 5.49 13.48 13.48 0 0 0 10.84-3.88s-.05 2.87 2.39 3.88 4.09-4.7 4.09-4.7l4.09-11.32h.37s.21 7.38 4.25 8.54 9.3-2.72 9.3-2.72a2.72 2.72 0 0 0 1.12-2.84zM13 73.58c.16-6.32 4.31-9.09 5.74-7.71s.9 4.36-1.81 6.22S13 73.58 13 73.58zm53.9-24.5s3.77-9.83 4.68-5-7.92 19-7.92 19c.1-3.21 3.24-14 3.24-14zm4.52 27.37c-2.5 6.54-8.56 3.88-8.56 3.88s-.69-2.34 1.28-8.88 6.59-4 6.59-4 3.18 2.47.69 9zm16.74-2.87s-.58-2.07 1.59-6.06 3.88-1.81 3.88-1.81 1.86 2-.27 5a6.26 6.26 0 0 1-5.2 2.87z\"/><text class=\"cls-2\" transform=\"translate(108.17 88.31)\">®</text></g></svg>"

/***/ }),

/***/ "../src/components/ember/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _EmberOriginalWordmark = __webpack_require__("../src/components/ember/original-wordmark/EmberOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EmberOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/erlang/original-wordmark/ErlangOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ErlangOriginalWordmark = __webpack_require__("../src/components/erlang/original-wordmark/ErlangOriginalWordmark.svg");
	
	var _ErlangOriginalWordmark2 = _interopRequireDefault(_ErlangOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ErlangOriginalWordmark */
	function ErlangOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ErlangOriginalWordmark',
	    svg: _ErlangOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ErlangOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ErlangOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/erlang/original-wordmark/ErlangOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#A90533\" d=\"M20.7 88.6C11 78.2 5.2 63.9 5.3 46.8c0-15.1 4.7-28.1 12.9-38H1v79.7l19.7.1zm90.4 0c4.2-4.5 8-9.8 11.4-15.9l-19-9.5C96.8 74 87.1 84 73.6 84.1 54 84 46.3 67.2 46.3 45.6h73.3c.1-2.4.1-3.6 0-4.7.5-12.9-2.9-23.7-9.1-32.1H127v79.7l-15.9.1zM47.5 27.1c.8-9.8 8.5-16.4 17.6-16.4 9.1 0 15.7 6.6 15.9 16.4H47.5z\"/><path d=\"M11.4 102.1v-3.3H1.2v19.7h10.2v-3.3H5v-5.3h6.2v-3.3H5v-4.5zm17.4 8.1c2.5-.4 3.9-2.9 4-5.5-.1-4.2-2.8-5.9-6.6-5.9H21v19.7h3.8v-7.8l4.7 7.8h4.7l-5.4-8.3zm-4.1-8.3h.5c2.1.1 3.6.6 3.6 3.1.1 2.3-1.4 3-3.6 2.8h-.5v-5.9zm21.4-3.1h-3.8v19.7h9.2v-3.3h-5.4zM71 114.4l1.7 4h4l-7.4-20.2h-3.1l-7.8 20.2h4l1.7-4H71zm-.9-3h-4.7l2.1-7.4 2.6 7.4zm13.7 7.1h4.1v-13.3L98.3 119h2.8V98.8h-4v13.3L86.7 98.3h-2.9zm34-10.5v3.1h4.3c-.1 2.5-2.1 4.6-4.5 4.5-3.8.1-5.6-3.6-5.7-6.9 0-3.3 1.9-7.1 5.7-7.1 2 .1 3.7 1.4 4.5 3.1l3.3-1.7c-1.5-3.1-4.4-4.8-7.8-4.7-5.9 0-9.7 4.8-9.7 10.4.1 5.5 3.7 10.4 9.5 10.4 6.2-.1 9.1-5 9-10.7v-.4h-8.6z\"/></svg>"

/***/ }),

/***/ "../src/components/erlang/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ErlangOriginalWordmark = __webpack_require__("../src/components/erlang/original-wordmark/ErlangOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ErlangOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/erlang/original/ErlangOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ErlangOriginal = __webpack_require__("../src/components/erlang/original/ErlangOriginal.svg");
	
	var _ErlangOriginal2 = _interopRequireDefault(_ErlangOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ErlangOriginal */
	function ErlangOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ErlangOriginal',
	    svg: _ErlangOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ErlangOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ErlangOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/erlang/original/ErlangOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M20.7 103.9C11 93.5 5.2 79.2 5.3 62.1 5.2 47 10 34 18.2 24.1H1v79.7l19.7.1zm90.4 0c4.2-4.5 8-9.8 11.4-15.9l-19-9.5c-6.7 10.8-16.4 20.8-29.9 20.9-19.6-.1-27.3-16.9-27.3-38.5h73.3c.1-2.4.1-3.6 0-4.7.5-12.9-2.9-23.7-9.1-32.1H127v79.7l-15.9.1zM47.5 42.4c.8-9.8 8.5-16.3 17.6-16.4 9.1 0 15.7 6.6 15.9 16.4H47.5z\" fill=\"#A90533\"/></svg>"

/***/ }),

/***/ "../src/components/erlang/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ErlangOriginal = __webpack_require__("../src/components/erlang/original/ErlangOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ErlangOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/erlang/plain-wordmark/ErlangPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ErlangPlainWordmark = __webpack_require__("../src/components/erlang/plain-wordmark/ErlangPlainWordmark.svg");
	
	var _ErlangPlainWordmark2 = _interopRequireDefault(_ErlangPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ErlangPlainWordmark */
	function ErlangPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ErlangPlainWordmark',
	    svg: _ErlangPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ErlangPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ErlangPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/erlang/plain-wordmark/ErlangPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M18.2 8.9L1 9v80h19.7v-.2C11 78.4 5.2 64 5.3 47 5.2 31.8 10 18.8 18.2 8.9zm92.3-.1zm.1.2c6.2 8 9.6 19.3 9.1 32.1.1 1.2.1 1.9 0 4.9H46.3c0 21 7.7 38.2 27.3 38.3 13.5-.1 23.2-10.1 29.9-21l19 9.7c-3.4 6-7.2 11-11.4 16H127V9h-16.4zm.5 79.6zm-46-78c-9 0-16.8 6.4-17.6 16.4H81c-.3-10-6.8-16.4-15.9-16.4zM1 118h10v-3H5v-5h6v-3H5v-5h6v-3H1zm31.8-13.2c-.1-4.2-2.8-5.8-6.6-5.8H21v19h4v-7.4l4.5 7.4h4.7l-5.5-8c2.6-.4 4-2.6 4.1-5.2zm-7.6 3.2H25v-6h.2c2.1 0 3.6.6 3.6 3.1 0 2.3-1.5 2.9-3.6 2.9zM46 99h-4v19h10v-3h-6zm20.3-1l-7.8 20h4l1.7-4H71l1.7 4h4l-7.4-20h-3zm-1 13l2.1-7.4L70 111h-4.7zm31.7 1.1L86.7 98H84v20h4v-12.8L98.3 119h2.7V99h-4zm21-4.1v3h4c-.1 3-2.1 4.6-4.5 4.6-3.8.1-5.6-3.5-5.7-6.9 0-3.3 1.9-7.1 5.7-7.1 2 .1 3.7 1.4 4.5 3.1l3.3-1.7c-1.5-3.1-4.4-4.8-7.8-4.7-5.9 0-9.7 4.8-9.7 10.4.1 5.5 3.6 10.4 9.3 10.4 6.2-.1 8.9-5 8.9-10.7v-.4h-8.2.2z\" fill=\"#A90533\"/></svg>"

/***/ }),

/***/ "../src/components/erlang/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ErlangPlainWordmark = __webpack_require__("../src/components/erlang/plain-wordmark/ErlangPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ErlangPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/erlang/plain/ErlangPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ErlangPlain = __webpack_require__("../src/components/erlang/plain/ErlangPlain.svg");
	
	var _ErlangPlain2 = _interopRequireDefault(_ErlangPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ErlangPlain */
	function ErlangPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ErlangPlain',
	    svg: _ErlangPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ErlangPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ErlangPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/erlang/plain/ErlangPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M18.2 24.1L1 24v80h19.7v-.1C11 93.6 5.2 79.2 5.3 62.1 5.2 47 10 33.9 18.2 24.1zm92.9 79.8zM127 24h-16.4c6.2 9 9.6 19.3 9.1 32.1.1 1.2.1 1.9 0 4.9H46.3c0 22 7.7 38.3 27.3 38.4 13.5-.1 23.2-10.1 29.9-20.9l19 9.5c-3.4 6.1-7.2 11-11.4 16H127V24zm-16.5.1zm-45.4 1.5c-9 0-16.8 7.4-17.6 16.4H81c-.3-9-6.8-16.4-15.9-16.4z\" fill=\"#A90533\"/></svg>"

/***/ }),

/***/ "../src/components/erlang/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ErlangPlain = __webpack_require__("../src/components/erlang/plain/ErlangPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ErlangPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/express/original-wordmark/ExpressOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ExpressOriginalWordmark = __webpack_require__("../src/components/express/original-wordmark/ExpressOriginalWordmark.svg");
	
	var _ExpressOriginalWordmark2 = _interopRequireDefault(_ExpressOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ExpressOriginalWordmark */
	function ExpressOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ExpressOriginalWordmark',
	    svg: _ExpressOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ExpressOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ExpressOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/express/original-wordmark/ExpressOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><title>Artboard 12</title><path d=\"M40.53 77.82V50.74H42V55a5.57 5.57 0 0 0 .48-.6 7.28 7.28 0 0 1 6.64-4.12c3.35-.1 6.07 1.14 7.67 4.12a13.24 13.24 0 0 1 .32 12.14c-1.49 3.34-5.17 5-9.11 4.39a7.37 7.37 0 0 1-5.88-3.88v10.77zM42 60.32c.13 1.32.18 2.26.33 3.18.58 3.62 2.72 5.77 6.08 6.16A6.91 6.91 0 0 0 56 65.27a11.77 11.77 0 0 0-.26-9.68 6.77 6.77 0 0 0-7.13-3.94 6.59 6.59 0 0 0-5.89 4.87 33.4 33.4 0 0 0-.72 3.8zM88.41 64a7.92 7.92 0 0 1-7.74 7c-6.16.31-9.05-3.78-9.51-8.5a13.62 13.62 0 0 1 1.2-7.5 8.37 8.37 0 0 1 8.71-4.67 8 8 0 0 1 7.1 6.09 41.09 41.09 0 0 1 .69 4.5H72.67c-.3 4.28 2 7.72 5.26 8.55 4.06 1 7.53-.76 8.79-4.62.28-.99.79-1.13 1.69-.85zm-15.74-4.45h14.47c-.09-4.56-2.93-7.86-6.78-7.91-4.36-.07-7.5 3.11-7.69 7.91zM91.39 64.1h1.42a5.69 5.69 0 0 0 3.34 4.9 8.73 8.73 0 0 0 7.58-.2 3.41 3.41 0 0 0 2-3.35 3.09 3.09 0 0 0-2.08-3.09c-1.56-.58-3.22-.9-4.81-1.41A35.25 35.25 0 0 1 94 59.18c-2.56-1.25-2.72-6.12.18-7.66a10.21 10.21 0 0 1 9.76-.15 5.14 5.14 0 0 1 2.6 5.24h-1.22c0-.06-.11-.11-.11-.17-.15-3.89-3.41-5.09-6.91-4.75a9.17 9.17 0 0 0-3 .91 3 3 0 0 0-1.74 3 3 3 0 0 0 2 2.82c1.54.56 3.15.92 4.73 1.36 1.27.35 2.59.58 3.82 1a4.51 4.51 0 0 1 3.1 4.07 4.81 4.81 0 0 1-2.59 5c-3.34 1.89-8.84 1.39-11.29-1a6.67 6.67 0 0 1-1.94-4.75zM125.21 56.61h-1.33c0-.18-.07-.34-.09-.49a4.35 4.35 0 0 0-3.54-4.18 8.73 8.73 0 0 0-5.61.27 3.41 3.41 0 0 0-2.47 3.25 3.14 3.14 0 0 0 2.4 3.16c2 .62 4.05 1 6.08 1.56a17 17 0 0 1 1.94.59 5 5 0 0 1 .27 9.31 11.13 11.13 0 0 1-9 .09 6.24 6.24 0 0 1-3.76-6.06h1.3a7.29 7.29 0 0 0 11.1 4.64 3.57 3.57 0 0 0 1.92-3.34 3.09 3.09 0 0 0-2.11-3.07c-1.56-.58-3.22-.89-4.81-1.4a35.43 35.43 0 0 1-4.87-1.75c-2.5-1.23-2.7-6.06.15-7.6a10.07 10.07 0 0 1 9.92-.11 5.23 5.23 0 0 1 2.51 5.13zM38.1 70.51a2.29 2.29 0 0 1-2.84-1.08c-1.63-2.44-3.43-4.77-5.16-7.15l-.75-1c-2.06 2.76-4.12 5.41-6 8.16a2.2 2.2 0 0 1-2.7 1.06l7.73-10.37-7.19-9.37a2.39 2.39 0 0 1 2.85 1c1.67 2.44 3.52 4.77 5.36 7.24 1.85-2.45 3.68-4.79 5.39-7.21a2.15 2.15 0 0 1 2.68-1l-2.79 3.7c-1.25 1.65-2.48 3.31-3.78 4.92a1 1 0 0 0 0 1.49c2.39 3.17 4.76 6.35 7.2 9.61zM70.92 50.66v1.4a7.25 7.25 0 0 0-7.72 7.49v11h-1.43V50.74h1.4v4.06c1.73-2.96 4.4-4.06 7.75-4.14zM2.13 60c.21-1 .34-2.09.63-3.11 1.73-6.15 8.78-8.71 13.63-4.9 2.84 2.23 3.55 5.39 3.41 8.95h-16c-.26 6.36 4.33 10.2 10.2 8.24a6.09 6.09 0 0 0 3.87-4.31c.31-1 .81-1.17 1.76-.88a8.12 8.12 0 0 1-3.88 5.93 9.4 9.4 0 0 1-10.95-1.4 9.85 9.85 0 0 1-2.46-5.78c0-.34-.13-.68-.2-1q-.01-.89-.01-1.74zm1.69-.43h14.47c-.09-4.61-3-7.88-6.88-7.91-4.32-.06-7.41 3.14-7.6 7.89z\"/></svg>"

/***/ }),

/***/ "../src/components/express/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExpressOriginalWordmark = __webpack_require__("../src/components/express/original-wordmark/ExpressOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpressOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/express/original/ExpressOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ExpressOriginal = __webpack_require__("../src/components/express/original/ExpressOriginal.svg");
	
	var _ExpressOriginal2 = _interopRequireDefault(_ExpressOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ExpressOriginal */
	function ExpressOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ExpressOriginal',
	    svg: _ExpressOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ExpressOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ExpressOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/express/original/ExpressOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><title>Artboard 16</title><path d=\"M126.67 98.44c-4.56 1.16-7.38.05-9.91-3.75-5.68-8.51-11.95-16.63-18-24.9-.78-1.07-1.59-2.12-2.6-3.45C89 76 81.85 85.2 75.14 94.77c-2.4 3.42-4.92 4.91-9.4 3.7l26.92-36.13L67.6 29.71c4.31-.84 7.29-.41 9.93 3.45 5.83 8.52 12.26 16.63 18.67 25.21 6.45-8.55 12.8-16.67 18.8-25.11 2.41-3.42 5-4.72 9.33-3.46-3.28 4.35-6.49 8.63-9.72 12.88-4.36 5.73-8.64 11.53-13.16 17.14-1.61 2-1.35 3.3.09 5.19C109.9 76 118.16 87.1 126.67 98.44zM1.33 61.74c.72-3.61 1.2-7.29 2.2-10.83 6-21.43 30.6-30.34 47.5-17.06C60.93 41.64 63.39 52.62 62.9 65H7.1c-.84 22.21 15.15 35.62 35.53 28.78 7.15-2.4 11.36-8 13.47-15 1.07-3.51 2.84-4.06 6.14-3.06-1.69 8.76-5.52 16.08-13.52 20.66-12 6.86-29.13 4.64-38.14-4.89C5.26 85.89 3 78.92 2 71.39c-.15-1.2-.46-2.38-.7-3.57q.03-3.04.03-6.08zm5.87-1.49h50.43c-.33-16.06-10.33-27.47-24-27.57-15-.12-25.78 11.02-26.43 27.57z\"/></svg>"

/***/ }),

/***/ "../src/components/express/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExpressOriginal = __webpack_require__("../src/components/express/original/ExpressOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpressOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/facebook/original/FacebookOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _FacebookOriginal = __webpack_require__("../src/components/facebook/original/FacebookOriginal.svg");
	
	var _FacebookOriginal2 = _interopRequireDefault(_FacebookOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** FacebookOriginal */
	function FacebookOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'FacebookOriginal',
	    svg: _FacebookOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	FacebookOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = FacebookOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/facebook/original/FacebookOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"facebook\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#3d5a98}.cls-2{fill:#fff}</style></defs><title>facebook</title><g id=\"original\"><rect id=\"Blue\" class=\"cls-1\" x=\"4.83\" y=\"4.83\" width=\"118.35\" height=\"118.35\" rx=\"6.53\" ry=\"6.53\"/><path id=\"f\" class=\"cls-2\" d=\"M86.48 123.17V77.34h15.38l2.3-17.86H86.48v-11.4c0-5.17 1.44-8.7 8.85-8.7h9.46v-16A126.56 126.56 0 0 0 91 22.7c-13.62 0-23 8.3-23 23.61v13.17H52.62v17.86H68v45.83z\"/></g></svg>"

/***/ }),

/***/ "../src/components/facebook/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FacebookOriginal = __webpack_require__("../src/components/facebook/original/FacebookOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FacebookOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/facebook/plain/FacebookPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _FacebookPlain = __webpack_require__("../src/components/facebook/plain/FacebookPlain.svg");
	
	var _FacebookPlain2 = _interopRequireDefault(_FacebookPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** FacebookPlain */
	function FacebookPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'FacebookPlain',
	    svg: _FacebookPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	FacebookPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = FacebookPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/facebook/plain/FacebookPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"facebook\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#3d5a98}</style></defs><title>facebook-plain</title><path id=\"original-plain\" class=\"cls-1\" d=\"M116.42 5.07H11.58a6.5 6.5 0 0 0-6.5 6.5v104.85a6.5 6.5 0 0 0 6.5 6.5H68V77.29H52.66V59.5H68V46.38c0-15.22 9.3-23.51 22.88-23.51a126 126 0 0 1 13.72.7v15.91h-9.39c-7.39 0-8.82 3.51-8.82 8.66V59.5H104l-2.29 17.79H86.39v45.64h30a6.51 6.51 0 0 0 6.5-6.5V11.58a6.5 6.5 0 0 0-6.47-6.51z\"/></svg>"

/***/ }),

/***/ "../src/components/facebook/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FacebookPlain = __webpack_require__("../src/components/facebook/plain/FacebookPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FacebookPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/firefox/original-wordmark/FirefoxOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _FirefoxOriginalWordmark = __webpack_require__("../src/components/firefox/original-wordmark/FirefoxOriginalWordmark.svg");
	
	var _FirefoxOriginalWordmark2 = _interopRequireDefault(_FirefoxOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** FirefoxOriginalWordmark */
	function FirefoxOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'FirefoxOriginalWordmark',
	    svg: _FirefoxOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	FirefoxOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = FirefoxOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/firefox/original-wordmark/FirefoxOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><ellipse fill=\"#110070\" cx=\"63.861\" cy=\"50.32\" rx=\"48.925\" ry=\"48.956\"/><radialGradient id=\"a\" cx=\"-407.967\" cy=\"653.678\" r=\"85.933\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#67C5D5\"/><stop offset=\".16\" stop-color=\"#66C2D3\"/><stop offset=\".28\" stop-color=\"#62B9CE\"/><stop offset=\".385\" stop-color=\"#5CA8C6\"/><stop offset=\".483\" stop-color=\"#5392BA\"/><stop offset=\".576\" stop-color=\"#4874AA\"/><stop offset=\".665\" stop-color=\"#3A5097\"/><stop offset=\".749\" stop-color=\"#2A2781\"/><stop offset=\".815\" stop-color=\"#1B006D\"/><stop offset=\"1\" stop-color=\"#596AAD\"/></radialGradient><ellipse fill=\"url(#a)\" cx=\"63.861\" cy=\"50.32\" rx=\"48.001\" ry=\"48.032\"/><radialGradient id=\"b\" cx=\"-407.981\" cy=\"647.95\" r=\"43.068\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></radialGradient><path fill=\"url(#b)\" d=\"M56.977 75.114c-.06-.26-.707-1.017-1.202-1.186-.494-.168-.979.73-1.298-.762-1.043.6-1.494-.165-1.494-.165s-1.125.066-1.343 1.443c-.535.635-1.909 2.941-1.18.542.734-2.414-.774-.188-.915 1.023-.262.539-.705.593-.427-1.829-.967-.334-1.461-2.578-.931-2.622-.616-.859-.132-2.171.381-2.101.513.066 1.393-1.122 1.366-1.397-.027-.274.397-.078.371-1.926-.027-1.852.698-2.311.758-.762.062 1.544.984-.505.89-1.291-.096-.782.092-2.551.654-1.505-.654-2.587-.139-2.688.254-.967.984.077 1.018.601 1.018.601 1.088-.268 1.61.552 1.695 1.013 1.008-1.191 2.027.093 2.027.093s.703-.233.368.99c-.338 1.218 1.46.559 1.031-.317.884-.448 2.198.909 2.612 1.835.414.929-.709 2.245.167 2.563.88.316.495 1.847.495 1.847s1.841 1.021.563 1.899l-.435 1.042s.832.929 1.116.376c.283-.554.384.563.384.563-.106-.197.205 1.15 1.353 1.434 1.152.282 1.882 2.104.602 2.126-1.275.021-1.374-.014-1.719.73-.344.741-1.971.768-2.814-.192-.896.304-2.491-.088-2.022-.805-.773.452-1.503-.759-.899-1.3.605-.539-.34-1.236-.658-.464-.313.771-1.982 1.151-1.865-.161.035-.39.923-.617.935-.292.163.378.229-.027.162-.076z\"/><radialGradient id=\"c\" cx=\"-407.981\" cy=\"647.944\" r=\"43.063\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></radialGradient><path fill=\"url(#c)\" d=\"M96.667 37.573c.254.253.756.197 1.033.12.28-.08.241-.279.481-.356.237-.079 1.152.356.913 1.306-.555.078-.756.752-.756.752s-.555.237-.836.12c-.279-.12-.279-.081-.676-.042-.398.042-1.355-.512-.319-.512s-.118-.477-.557-.477c-.438 0-.08-.435.438-.316-.359-.595-.16-1.032.279-.595z\"/><radialGradient id=\"d\" cx=\"-407.984\" cy=\"647.958\" r=\"43.076\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></radialGradient><path fill=\"url(#d)\" d=\"M93.077 39.724c-.277.275.041 1.109.398 1.067.357-.039.916-.197.916-.197s.277.554 0 .713c-.278.159-1.088.088-.039.475 1.075.395 1.352.276 1.432.078.081-.197.438-.87.638-.83.16-.355-.557-.672-.159-.911.396-.238.08-1.107.08-1.107s-.559.039-.797.436c-.239.396-.556-.038-.795-.038-.041.237-.2.434-.2.434l-.158-.358c-.001-.001-1.118-.04-1.316.238z\"/><radialGradient id=\"e\" cx=\"-407.277\" cy=\"643.871\" r=\"47.313\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".264\" stop-color=\"#0B629B\"/><stop offset=\".844\" stop-color=\"#031747\"/><stop offset=\"1\" stop-color=\"#00022F\"/></radialGradient><path fill=\"url(#e)\" d=\"M85.638 40.376c-.035-.102.316-.512.222.019-.216.378.872.718 1.177.297 1.023-1.402-.964-2.08-1.827-1.429-.872.658-1.351-.751-.351-.952.997-.201 1.082-2.003-.017-2.01.969-.479-.374-1.912-1.483-2.157-.18-1.541-1.806-2.521-2.661-1.962-.863.561-.938.463-2.203-.305-1.26-.764-1.866 1.59-.939 2.619.933 1.035.256 2.705.294 2.419 0 0-.351.631-.328.868-1.066.361-1.378-1.141-2.041-1.473-.482.63-1.261.965-1.261.965l.059-1.281s-3.312-1.803-4.33-1.299c-1.253.388-1.551 3.291-.412 3.717 1.141.429-1.43 1.498 1.149 4.217 2.649 2.792 3.673 2.873 4.213 2.417a8.14 8.14 0 0 1 .647-.477.903.903 0 0 0 .134.308c.663.997-1.541 1.783-1.849 3.211-.313 1.443-.024 4.128 1.283 4.219.249-1.431 2.696-.925 1.364.372-1.355 1.321-.404 1.555-.404 1.555s.064 2.476 2.137 1.684c-.06.142-.109.323-.138.521-.58-.117-1.996-.294-2.342.694-.437 1.247-2.288-.423-3.583.137-1.288.556-3.169 2.38-2.536 3.664 1.217-.577 2.148 2.024.449 1.492-1.707-.537-1.375.479-1.375.479s-1.776 1.401-.113 2.892c-.639.099-1.773.81-1.391 2.371 0 0-.73.026-.828 1.423-2.381.479-2.235 1.218 1.346.409-1.445.75 1.011 1.104 2.099 1.003 1.09-.099 3.952 1.312 1.802 1.327-2.153.013-1.512 1.066 1.067 1.117 2.576.053 2.305.649 2.687.625.383-.028 2.048 1.286 1.958 2.014-.093.729 1.744 1.485 2.94.65.061.757 3.205.166 3.669-1.201 3.403.521 3.325-.115 2.568-.519-1.705-.26-4.832-2.526-1.44-1.36 3.375 1.164.124-.916-.766-1.714-1.938-.377-2.037-1.992-2.037-1.992s1.071-.608.227-2.132c2.093-.389.829-1.125 1.064-1.827.235-.704 1.298-1.601 1.663-1.673.068-.095.639.019.11.233-.457.005-.132 1.291.414 1.357 1.849.224 1.308-2.189.222-2.674-1.089-.49-.11-1.817.653-.924.764.893 2.468-.109 1.829-1.24 1.016.705 1.564-1.575 1.132-2.882 1.358-1.178 1.314-3.526.264-4.053-.517-.259-.767-.425-.892-.747.624-.295 1.452-.512 1.777-.221.528.478 2-.84 1.906-2.379.619.339 1.606-2.799.768-3.897 1.918-2.682 1.401-2.925.76-2.476-.964 1.338-4.134 2.938-1.678.567 2.384-2.301-.635-.556-1.644-.182-1.189 1.488-2.449.773-2.449.773s.053-1.219-1.481-1.245c.708-1.956-.434-1.25-.833-1.783-.399-.532-.544-1.836-.421-2.169z\"/><radialGradient id=\"f\" cx=\"-407.982\" cy=\"647.95\" r=\"43.071\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></radialGradient><path fill=\"url(#f)\" d=\"M60.771 20.773c-.297.776.972 2.037 1.609 1.631.64-.409 1.554-1.222 1.554-1.222s.971.779.579 1.335c-.396.554-1.968 1.177.308.925 2.335-.258 2.759-.74 2.749-1.185-.012-.444.116-2.036.52-2.146.012-.816-1.587-.74-1.033-1.557.554-.814-.746-2.149-.746-2.149s-1.013.593-1.14 1.556c-.127.963-1.075.444-1.523.666.115.481-.022.999-.022.999l-.586-.519c0-.001-2.122.962-2.269 1.666z\"/><radialGradient id=\"g\" cx=\"-407.981\" cy=\"647.95\" r=\"43.069\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></radialGradient><path fill=\"url(#g)\" d=\"M64.567 61.526c-.278.276.041 1.107.397 1.068.358-.04.916-.198.916-.198s.278.554 0 .713c-.28.158-1.088.09-.041.475 1.074.396 1.354.277 1.433.08.079-.198.437-.871.636-.833.161-.354-.557-.671-.159-.908.398-.24.082-1.109.082-1.109s-.558.039-.797.435-.558-.041-.797-.041c-.041.238-.197.437-.197.437l-.159-.356s-1.115-.04-1.314.237z\"/><defs><ellipse id=\"h\" cx=\"63.861\" cy=\"50.32\" rx=\"48.001\" ry=\"48.032\"/></defs><clipPath id=\"i\"><use xlink:href=\"#h\" overflow=\"visible\"/></clipPath><linearGradient id=\"j\" gradientUnits=\"userSpaceOnUse\" x1=\"-398.235\" y1=\"645.955\" x2=\"-384.333\" y2=\"644.77\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></linearGradient><path clip-path=\"url(#i)\" fill=\"url(#j)\" d=\"M64.938 2.189c-.751.168.506 2.888.506 2.888s-.045 1.828.265 1.921c.308.093 2.352.604 3.419 1.934 1.073 1.33.515 2.031-.378 1.646-.894-.383-.657.791-.657.791s2.697.876.661.82c-2.041-.054 1.374 1.437 1.148 1.592-.225.158-.353 1.015-.353 1.015s-1.801.15-.275.791c5.162 2.174-.552 1.587-.552 1.587l-.729.896 1.441 1.809 1.11.793s2.335-.779 3.064-.901c.729-.121 2.567-1.498 2.567-1.498s.552.395.14-.409c-.413-.805 1.518-.446 1.999.153l3.409 1.54c.044.118.12.225.241.309.664.465-.601 1.266-.473 2.112.129.838.901 2.229 1.749 2.083-.148-.799 1.527-.896.944-.006-.582.888.063.871.063.871s.538 1.254 1.677.557c-.046.382.188 1.153 1.165 1.203 0 0-.104.418.7.713-.11 1.433.349 1.478.461-.698.203.955.818-.388.94-1.031.125-.646 1.449-2.064 1.091-.811-.355 1.243 3.904 1.698 4.376.213.476-1.496 2.174-2.278 2.225-2.504.052-.232-3.779-.587-3.355-.407.424.18 1.212-.781.919-1.637.475.096.684-1.898-.069-2.413.943-1.983.538-2.045.151-1.65-.47.994-2.409 2.493-1.094.646 1.328-1.866-.538-.234-1.186.172-.568 1.105-1.566.89-1.566.89s-.183-.751-1.25-.5c.125-1.329-.538-.69-.923-.952-.234-.159-.46-.517-.599-.824.919.373 2.154.769 1.941.086-.137-.447 1.741.53 1.807.327l2.349-.327 2.283-1.442C81.698 1.499 64.938 2.189 64.938 2.189z\"/><defs><ellipse id=\"k\" cx=\"63.861\" cy=\"50.32\" rx=\"48.001\" ry=\"48.032\"/></defs><clipPath id=\"l\"><use xlink:href=\"#k\" overflow=\"visible\"/></clipPath><linearGradient id=\"m\" gradientUnits=\"userSpaceOnUse\" x1=\"-429.469\" y1=\"643.85\" x2=\"-437.152\" y2=\"632.566\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></linearGradient><path clip-path=\"url(#l)\" fill=\"url(#m)\" d=\"M43.247 6.39c-8.718 3.913-15.296 11.98-15.296 11.98s.773 1.769 1.042 1.639c.273-.128-1.946 4.64-.317 4.908 1.637.27 6.346-2.95 5.472-2.654-.87.293.492-1.742.492-1.742s2.45-1.087 1.001.167c-1.438 1.246 1.911.154 1.859.409-.054.256.432.945.432.945s-1.148 1.232.335.736c5.089-1.712.67 1.467.67 1.467l.087 1.082 2.202.383 1.3-.124s1.139-2.008 1.579-2.554c.441-.546.848-2.708.848-2.708s.663-.07-.175-.386c-.838-.317.801-1.306 1.555-1.183l3.548-1.102a.669.669 0 0 0 .387.068c.813-.095.404 1.321 1.067 1.854.657.532 2.167 1.044 2.707.388-.647-.491.555-1.659.709-.621.154 1.031.632.596.632.596s1.272-2.188 1.679-3.443c.223.311 2.299-2.729 1.67-4.179-.636-1.468.395-2.849.28-3.063-.118-.211-.739.436-.28.281.462-.159-1.31.637-1.545-1.699-.238-2.383-.583.2-.813.964.31 1.243 3.537-5.024 3.537-5.024l4.159-1.696c-.002.004-9.467-.788-20.823 4.311z\"/><linearGradient id=\"n\" gradientUnits=\"userSpaceOnUse\" x1=\"-409.548\" y1=\"631.152\" x2=\"-409.548\" y2=\"649.829\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".014\" stop-opacity=\"0\"/><stop offset=\".65\" stop-color=\"#C4E0E3\" stop-opacity=\".2\"/><stop offset=\".822\" stop-color=\"#C4E0E3\"/><stop offset=\".85\" stop-color=\"#CDE5E8\"/><stop offset=\".944\" stop-color=\"#E8F4F7\"/><stop offset=\"1\" stop-color=\"#F2FAFC\"/></linearGradient><ellipse opacity=\".5\" fill=\"url(#n)\" cx=\"62.952\" cy=\"20.551\" rx=\"25.416\" ry=\"16.467\"/><linearGradient id=\"o\" gradientUnits=\"userSpaceOnUse\" x1=\"-408.041\" y1=\"613.214\" x2=\"-396.507\" y2=\"619.988\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#DF731B\"/><stop offset=\".545\" stop-color=\"#DF731B\"/><stop offset=\".701\" stop-color=\"#EC8811\"/><stop offset=\".859\" stop-color=\"#F4950B\"/><stop offset=\"1\" stop-color=\"#F79A09\"/></linearGradient><path fill=\"url(#o)\" d=\"M114.625 36.888l-1.176 7.545s-1.681-13.968-3.741-19.19c-3.158-8.001-4.563-7.937-4.572-7.925 2.115 5.375 1.731 8.262 1.731 8.262s-3.747-10.214-13.656-13.463C81.477 8.271 75.499 9.66 75.542 9.714c.045.053 12.128 2.112 14.272 5.058 0 0-5.133 0-10.241 1.471-.23.066 18.793 2.376 22.683 21.387 0 0-2.085-4.352-4.665-5.091 1.696 5.16 1.261 14.951-.354 19.818-.208.626-.421-2.706-3.603-4.141 1.018 7.303-.061 18.887-5.128 22.077-.395.248 3.176-11.435.718-6.917-14.674 22.499-32.12 9.103-39.196 4.327 5.68 1.392 11.712.39 15.206-1.997 3.525-2.41 5.609-4.17 7.482-3.755 1.872.419 3.118-1.46 1.664-3.126-1.455-1.669-4.989-3.965-9.77-2.713-3.372.882-7.55 4.613-13.928.835-5.441-3.224-5.404-5.842-5.404-7.51 0-1.668 1.484-4.205 4.186-3.789 2.418.375 1.144-1.047 3.748 0 .709.285-.071-3.404-1.08-5.768 1.943-4.056 8.249-5.262 8.719-5.618.853-.644.384-.966.675-1.938.271-.904.446-3.348-6.61-2.673-3.248.311-5.313-3.897-5.99-4.918.22-1.301.571-2.489 1.048-3.577.484-.991 1.012-1.9 1.541-2.587l.438-.581c1.052-1.227 2.343-2.276 3.894-3.148.808-.457-9.044-.028-13.479 5.75-1.189.156-2.822-.188-4.646-.188-2.288 0-4.085.251-5.747.668-.267.067-.696.03-1.222-.094-1.463-1.516-5.604-5.161-5.793-10.104 0 0-6.02 4.627-5.12 17.242-.08 6.978-2.139 4.983-3.199 8.769-.493 1.794.742 3.146.742 3.199-.002.027 1.48-1.604 1.48-1.604s-9.336 16.174 2.722 36.823c10.392 17.801 27.832 25.667 45.928 24.136a56.149 56.149 0 0 0 9.536-1.446c42.16-10.193 37.576-61.103 37.576-61.103z\"/><linearGradient id=\"p\" gradientUnits=\"userSpaceOnUse\" x1=\"-426.709\" y1=\"629.16\" x2=\"-417.756\" y2=\"628.393\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".011\" stop-color=\"#941403\"/><stop offset=\".897\" stop-color=\"#E85C0A\"/></linearGradient><path fill=\"url(#p)\" d=\"M48.785 24.128s1.822 4.979 5.909 4.964c7.798-.031 7.954.077 8.004 1.024.155 2.886-1.27 3.832-1.815 4.243-.547.409-7.971 4.714-8.245 5.945-.272 1.23-8.568-11.707-8.568-11.707l4.715-4.469z\"/><linearGradient id=\"q\" gradientUnits=\"userSpaceOnUse\" x1=\"-441.047\" y1=\"631.643\" x2=\"-408.731\" y2=\"627.603\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".011\" stop-color=\"#941403\"/><stop offset=\".136\" stop-color=\"#A32104\"/><stop offset=\".498\" stop-color=\"#C84107\"/><stop offset=\".789\" stop-color=\"#DF5509\"/><stop offset=\".972\" stop-color=\"#E85C0A\"/></linearGradient><path fill=\"url(#q)\" d=\"M52.936 29.497s2.533 3.234.618 4.527c-2.34 1.58 3.308 1.924 5.355.776 2.046-1.148 3.302-2.835 3.374-3.087.072-.252.745-2.519-3.527-1.729-2.702.5-3.692.616-5.82-.487z\"/><linearGradient id=\"r\" gradientUnits=\"userSpaceOnUse\" x1=\"-421.025\" y1=\"623.094\" x2=\"-418.449\" y2=\"624.227\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#F2C8A9\"/><stop offset=\"1\" stop-color=\"#ffc\"/></linearGradient><path fill=\"url(#r)\" d=\"M60.883 34.359c.414-.313 1.333-.938 1.684-2.483-.256.104-.28-.19-.582-.063-5.735 5.983-5.955 1.816-9.084 2.655-2.853.781-3.494 1.852-3.614 1.936l.128.182c.822.418 1.609 1.75 2.202 2.939.579.689.967 1.028 1.022.779.273-1.231 7.698-5.536 8.244-5.945z\"/><linearGradient id=\"s\" gradientUnits=\"userSpaceOnUse\" x1=\"-429.241\" y1=\"591.544\" x2=\"-385.895\" y2=\"589.759\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#B30000\"/><stop offset=\"1\" stop-color=\"#DF731B\"/></linearGradient><path fill=\"url(#s)\" d=\"M18.038 39.112c-1.17 2.457-8.683 15.153 3.578 36.284 11.999 20.683 32.765 27.437 53.966 22.848 6.051-1.309 13.03-6.045 17.477-9.519-2.857-7.207-1.166-6.937-2.697-5.988-17.079 10.574-30.656.143-41.164-1.189-38.656-4.899-31.023-42.511-31.023-42.511l-.137.075z\"/><linearGradient id=\"t\" gradientUnits=\"userSpaceOnUse\" x1=\"-418.926\" y1=\"598.271\" x2=\"-396.325\" y2=\"590.202\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#941403\"/><stop offset=\"1\" stop-color=\"#DF731B\"/></linearGradient><path fill=\"url(#t)\" d=\"M50.228 68.096c3.643 1.091 11.593.15 15.007-2.39 2.3-1.71 4.039-2.999 5.5-3.539-2.583-1.755-2.625.733-8.058 1.992-11.32 2.625-16.815-3.047-16.815-3.047.802 4.488 3.605 6.674 4.866 7.45a7.089 7.089 0 0 1-.5-.466z\"/><linearGradient id=\"u\" gradientUnits=\"userSpaceOnUse\" x1=\"-467.668\" y1=\"536.09\" x2=\"-445.635\" y2=\"536.09\" gradientTransform=\"scale(1 -1) rotate(-2.8 -12633.86 -9647.041)\"><stop offset=\".056\" stop-color=\"#B30000\"/><stop offset=\"1\" stop-color=\"#DE5C01\"/></linearGradient><path fill=\"url(#u)\" d=\"M37.953 88.593S28.531 77.961 25.9 66.053c-3.879-3.663-6.631-6.762-8.459-9.002 1.056 8.474 5.375 21.63 20.512 31.542z\"/><linearGradient id=\"v\" gradientUnits=\"userSpaceOnUse\" x1=\"-277.505\" y1=\"677.591\" x2=\"-265.517\" y2=\"640.451\" gradientTransform=\"matrix(.993 .119 .119 -.993 220.04 770.077)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#v)\" d=\"M30.092 78.937s-6.503-9.258-4.065-17.119c2.194-7.067-.466-2.863-2.013-1.353-1.562 1.527-2.365-4.504-2.325-5.2l-.001-.022c-.098-.021-3.096 14.451 8.404 23.694z\"/><linearGradient id=\"w\" gradientUnits=\"userSpaceOnUse\" x1=\"-461.347\" y1=\"562.033\" x2=\"-461.347\" y2=\"520.52\" gradientTransform=\"matrix(.999 .045 .045 -.999 457.68 633.724)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#w)\" d=\"M20.459 70.867s-1.482-18.79 3.203-21.445c7.441-4.219.621-3.232-1.537-2.062-2.181 1.182-1.979-6.596-1.67-7.334.302-.729-7.681 7.353.004 30.841z\"/><path fill=\"#A40000\" d=\"M53.015 15.577s-5.891 5.984-5.847 6.005c.044.021.169 7.679.362 9.851.705.834 2.905 6.256 1.222 5.053-1.72-1.229-.48-1.255-.33-.631v.031c-.115.053-4.276-9.008 4.593-20.309z\"/><linearGradient id=\"x\" gradientUnits=\"userSpaceOnUse\" x1=\"-446.078\" y1=\"634.203\" x2=\"-450.582\" y2=\"645.745\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".011\" stop-color=\"#941403\"/><stop offset=\".472\" stop-color=\"#E85C0A\"/><stop offset=\"1\" stop-color=\"#F9BD5F\"/></linearGradient><path fill=\"url(#x)\" d=\"M24.992 10.966s-6.262 4.804-5.066 17.98c4.847-4.351 11.701-7.604 11.701-7.604-1.15-.725-6.426-4.946-6.635-10.376z\"/><linearGradient id=\"y\" gradientUnits=\"userSpaceOnUse\" x1=\"-426.819\" y1=\"631.556\" x2=\"-416.027\" y2=\"645.741\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".197\" stop-color=\"#DE7210\"/><stop offset=\".843\" stop-color=\"#F9BD5F\"/><stop offset=\"1\" stop-color=\"#FFFCCF\"/></linearGradient><path fill=\"url(#y)\" d=\"M40.423 25.375l9.405 11.696c-2.714-11.486-.628-18.377 6.052-22.135.988-.559-13.955.2-15.457 10.439z\"/><linearGradient id=\"z\" gradientUnits=\"userSpaceOnUse\" x1=\"-432.525\" y1=\"612.191\" x2=\"-421.585\" y2=\"590.311\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".017\" stop-color=\"#941403\"/><stop offset=\".5\" stop-color=\"#E35100\"/><stop offset=\"1\" stop-color=\"#DF731B\"/></linearGradient><path fill=\"url(#z)\" d=\"M33.797 54.268c1.604-10.105 15.667-8.619 15.667-8.619-.627.466-3.037.745-3.727 2.672-2.277 6.365-.105 20.268 14.081 26.098 1.498.618-28.391-5.217-26.021-20.151z\"/><linearGradient id=\"A\" gradientUnits=\"userSpaceOnUse\" x1=\"-416\" y1=\"625.61\" x2=\"-413.269\" y2=\"623.135\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#EEA272\"/><stop offset=\".186\" stop-color=\"#EFA777\"/><stop offset=\".406\" stop-color=\"#F2B585\"/><stop offset=\".643\" stop-color=\"#F6CD9C\"/><stop offset=\".89\" stop-color=\"#FCEEBB\"/><stop offset=\"1\" stop-color=\"#ffc\"/></linearGradient><path fill=\"url(#A)\" d=\"M62.486 32.15c-.069-.012-.13-.011-.161.03-.173.231-.841 1.021-2.431 2.317-2.955 2.403-4.2 1.794-6.401 2.287-1.001.224-1.954.896-2.595 1.436.259.42.501.871.718 1.304.579.689.968 1.028 1.022.779.273-1.23 7.699-5.535 8.245-5.945.388-.291 1.211-.869 1.603-2.208z\"/><linearGradient id=\"B\" gradientUnits=\"userSpaceOnUse\" x1=\"-431.935\" y1=\"619.762\" x2=\"-419.384\" y2=\"606.955\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".197\" stop-color=\"#DF731B\"/><stop offset=\".843\" stop-color=\"#F9BD5F\"/><stop offset=\"1\" stop-color=\"#FFFCCF\"/></linearGradient><path fill=\"url(#B)\" d=\"M53.419 47.426c.082-2.135-.066-7.322-2.287-9.574-1.696-1.719-2.094-3.689-2.322-5.938-18.439 6.889-21.072 15.891-19.228 15.599 14.748-2.339 18.894-2.624 23.837-.087z\"/><linearGradient id=\"C\" gradientUnits=\"userSpaceOnUse\" x1=\"354.63\" y1=\"1457.727\" x2=\"354.63\" y2=\"1410.678\" gradientTransform=\"scale(1 -1) rotate(-14.72 -5590.445 1996.955)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#C)\" d=\"M14.106 60.046s1.281-16.649 9.615-22.742c6.543-4.786 1.461-3.048-1.064-2.85-2.665.211-4.085 1.831-3.571 1.235l.025-.045c-.087-.103-6.252 5.071-5.005 24.402z\"/><linearGradient id=\"D\" gradientUnits=\"userSpaceOnUse\" x1=\"-431.743\" y1=\"663.266\" x2=\"-447.649\" y2=\"637.36\" gradientTransform=\"matrix(.99 -.08 -.095 -1.173 514.173 774.676)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C06E\"/></linearGradient><path fill=\"url(#D)\" d=\"M13.229 47.255S17.695 33.08 26.72 33.2c5.986.08 1.238-5.058-.573-5.839-1.89-.809-2.341-.777-2.782-.387-.661.586-6.599.359-10.136 20.281z\"/><linearGradient id=\"E\" gradientUnits=\"userSpaceOnUse\" x1=\"-394.478\" y1=\"603.697\" x2=\"-411.376\" y2=\"600.47\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".005\" stop-color=\"#FFFAEE\"/><stop offset=\".276\" stop-color=\"#F5F89B\"/><stop offset=\".31\" stop-color=\"#F3ED91\"/><stop offset=\".467\" stop-color=\"#ECC267\"/><stop offset=\".618\" stop-color=\"#E6A046\"/><stop offset=\".761\" stop-color=\"#E2872E\"/><stop offset=\".892\" stop-color=\"#E07820\"/><stop offset=\"1\" stop-color=\"#DF731B\"/></linearGradient><path fill=\"url(#E)\" d=\"M74.11 61.131c.679-.666.206-3.219-4.06-4.767-3.87-1.405-9.911 2.169-11.704 2.874 0 0 6.843-1.282 9.408-.855 3.479.58 4.701 4.371 6.356 2.748z\"/><linearGradient id=\"F\" gradientUnits=\"userSpaceOnUse\" x1=\"-898.399\" y1=\"104.881\" x2=\"-898.399\" y2=\"65.558\" gradientTransform=\"matrix(.992 .126 .126 -.992 901.777 251.637)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C06E\"/></linearGradient><path fill=\"url(#F)\" d=\"M19.821 56.46s-.741-13.937 5.504-19.889c4.904-4.675.882-2.684-1.19-2.247-2.184.464-3.187 1.96-2.824 1.411l.015-.04c-.085-.075-4.633 4.881-1.505 20.765z\"/><linearGradient id=\"G\" gradientUnits=\"userSpaceOnUse\" x1=\"-897.832\" y1=\"-152.461\" x2=\"-897.832\" y2=\"-191.78\" gradientTransform=\"scale(1 -1) rotate(-21.23 -112.77 -2552.822)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C06E\"/></linearGradient><path fill=\"url(#G)\" d=\"M15.011 52.033s2.64-13.705 10.136-17.976c5.887-3.355 1.503-2.392-.614-2.466-2.232-.077-3.564 1.134-3.082.688l.025-.035c-.063-.094-5.672 3.619-6.465 19.789z\"/><linearGradient id=\"H\" gradientUnits=\"userSpaceOnUse\" x1=\"-102.703\" y1=\"1179.761\" x2=\"-113.653\" y2=\"1163.336\" gradientTransform=\"scale(1 -1) rotate(35.88 1858.323 760.77)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C072\"/></linearGradient><path fill=\"url(#H)\" d=\"M23.912 57.658s-1.443-8.307 1.667-12.395c2.481-3.262.302-1.667-.85-1.196-1.203.491-1.658 1.46-1.494 1.104.159-.347-5.35 3.921.677 12.487z\"/><linearGradient id=\"I\" gradientUnits=\"userSpaceOnUse\" x1=\"-96.778\" y1=\"1185.141\" x2=\"-107.727\" y2=\"1168.718\" gradientTransform=\"scale(1 -1) rotate(35.88 1858.323 760.77)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C072\"/></linearGradient><path fill=\"url(#I)\" d=\"M25.56 49.825s-1.442-8.306 1.667-12.395c2.482-3.263.303-1.667-.849-1.197-1.202.492-1.658 1.461-1.493 1.104.158-.346-5.35 3.923.675 12.488z\"/><linearGradient id=\"J\" gradientUnits=\"userSpaceOnUse\" x1=\"-451.053\" y1=\"628.417\" x2=\"-455.844\" y2=\"619.475\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#EED8A5\"/></linearGradient><path fill=\"url(#J)\" d=\"M16.838 38.47s3.371-6.906 7.851-8.266c3.575-1.083 1.112-1.067.011-1.336-1.151-.279-2.004.193-1.694.017.304-.171-6.044.04-6.168 9.585z\"/><linearGradient id=\"K\" gradientUnits=\"userSpaceOnUse\" x1=\"-451.535\" y1=\"622.951\" x2=\"-456.324\" y2=\"614.011\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#EED8A5\"/></linearGradient><path fill=\"url(#K)\" d=\"M16.358 43.935s3.37-6.905 7.85-8.265c3.575-1.084 1.113-1.069.012-1.338-1.15-.279-2.004.193-1.693.018.302-.172-6.046.041-6.169 9.585z\"/><linearGradient id=\"L\" gradientUnits=\"userSpaceOnUse\" x1=\"-446.107\" y1=\"626.746\" x2=\"-450.737\" y2=\"615.251\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C072\"/></linearGradient><path fill=\"url(#L)\" d=\"M18.805 42.427s5.944-12.181 13.847-14.581c6.308-1.913 1.964-1.886.02-2.358-2.03-.492-3.536.341-2.988.032.536-.302-10.662.071-10.879 16.907z\"/><linearGradient id=\"M\" gradientUnits=\"userSpaceOnUse\" x1=\"-444.346\" y1=\"632.342\" x2=\"-455.296\" y2=\"615.918\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C072\"/></linearGradient><path fill=\"url(#M)\" d=\"M22.868 35.866s3.698-7.576 8.613-9.068c3.922-1.19 1.221-1.173.012-1.467-1.263-.306-2.198.212-1.858.02.332-.189-6.632.043-6.767 10.515z\"/><linearGradient id=\"N\" gradientUnits=\"userSpaceOnUse\" x1=\"-443.609\" y1=\"629.025\" x2=\"-453.589\" y2=\"614.056\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C072\"/></linearGradient><path fill=\"url(#N)\" d=\"M24.074 38.543s3.37-6.905 7.849-8.264c3.576-1.085 1.113-1.07.012-1.338-1.151-.279-2.005.193-1.693.019.301-.173-6.045.04-6.168 9.583z\"/><linearGradient id=\"O\" gradientUnits=\"userSpaceOnUse\" x1=\"-411.498\" y1=\"631.357\" x2=\"-410.707\" y2=\"629.948\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#8B8B89\"/><stop offset=\"1\" stop-color=\"#120500\"/></linearGradient><path fill=\"url(#O)\" d=\"M62.698 30.116c-.039-.72-.146-.955-3.591-1.013a8.377 8.377 0 0 1 1.825 1.153c.99.812 1.15 1.716 1.253 2.652.336-.638.582-1.517.513-2.792z\"/><linearGradient id=\"P\" gradientUnits=\"userSpaceOnUse\" x1=\"-442.606\" y1=\"636.144\" x2=\"-442.606\" y2=\"640.47\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#P)\" d=\"M42.463 20.498l-2.989 4.81s-11.952-1.875-22.085 7.928c-.838.809 6.627-17.335 25.074-12.738z\"/><linearGradient id=\"Q\" gradientUnits=\"userSpaceOnUse\" x1=\"-451.273\" y1=\"588.951\" x2=\"-442.219\" y2=\"599.533\" gradientTransform=\"matrix(.999 .04 .04 -.999 457.406 636.091)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#Q)\" d=\"M31.729 29.106s3.185-5.913 7.315-7.701c-2.134.068-6.928 1.737-7.315 7.701z\"/><linearGradient id=\"R\" gradientUnits=\"userSpaceOnUse\" x1=\"-448.419\" y1=\"632.009\" x2=\"-453.209\" y2=\"623.067\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#EED8A5\"/></linearGradient><path fill=\"url(#R)\" d=\"M19.473 34.878s3.37-6.906 7.85-8.265c3.575-1.085 1.113-1.069.011-1.338-1.151-.279-2.003.193-1.692.018.302-.171-6.046.04-6.169 9.585z\"/><linearGradient id=\"S\" gradientUnits=\"userSpaceOnUse\" x1=\"-468\" y1=\"519.769\" x2=\"-459.156\" y2=\"530.105\" gradientTransform=\"scale(1 -1) rotate(-5.97 -5497.41 -4480.916)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#S)\" d=\"M26.533 30.012s3.477-5.566 7.614-7.048c-2.083-.069-6.863 1.258-7.614 7.048z\"/><linearGradient id=\"T\" gradientUnits=\"userSpaceOnUse\" x1=\"-468.3\" y1=\"544.95\" x2=\"-457.672\" y2=\"543.495\" gradientTransform=\"matrix(.996 .09 .09 -.996 439.675 604.212)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#T)\" d=\"M32.495 20.504s-2.623 1.146-7.246-.777l4.122 2.073 3.124-1.296z\"/><linearGradient id=\"U\" gradientUnits=\"userSpaceOnUse\" x1=\"-455.448\" y1=\"640.582\" x2=\"-440.446\" y2=\"638.528\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#U)\" d=\"M31.227 21.239s-3.494 1.354-10.219-.662l5.752 2.289c.712-.658 4.467-1.627 4.467-1.627z\"/><linearGradient id=\"V\" gradientUnits=\"userSpaceOnUse\" x1=\"-466.231\" y1=\"545.484\" x2=\"-456.465\" y2=\"544.147\" gradientTransform=\"matrix(.996 .09 .09 -.996 439.675 604.212)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#V)\" d=\"M33.777 20.129s-2.319.706-6.604-.951l4.122 2.071c.436-.386 2.482-1.12 2.482-1.12z\"/><linearGradient id=\"W\" gradientUnits=\"userSpaceOnUse\" x1=\"-448.672\" y1=\"637.424\" x2=\"-457.478\" y2=\"638.328\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#W)\" d=\"M26.545 22.795s-1.723 1.431-6.138 1.489l3.818.125 2.32-1.614z\"/><linearGradient id=\"X\" gradientUnits=\"userSpaceOnUse\" x1=\"-472.449\" y1=\"518.702\" x2=\"-460.268\" y2=\"532.938\" gradientTransform=\"scale(1 -1) rotate(-5.97 -5497.41 -4480.916)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#X)\" d=\"M22.352 30.116s5.898-7.684 10.755-9.422c-2.447-.081-9.874 2.625-10.755 9.422z\"/><linearGradient id=\"Y\" gradientUnits=\"userSpaceOnUse\" x1=\"-388.375\" y1=\"562.863\" x2=\"-364.518\" y2=\"599.659\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#DE5C01\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#Y)\" d=\"M113.7 43.216s.635 14.254-19.166 34.057c-2.201 2.2-14.149 13.395-13.729 16.752.149 1.187 31.351-4.786 32.895-50.809z\"/><linearGradient id=\"Z\" gradientUnits=\"userSpaceOnUse\" x1=\"-374.502\" y1=\"640.89\" x2=\"-390.123\" y2=\"647.75\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#F79A09\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#Z)\" d=\"M75.31 9.688c23.851 1.833 28.47 18.982 28.471 17.931.061-16.671-22.628-17.937-28.471-17.931z\"/><linearGradient id=\"aa\" gradientUnits=\"userSpaceOnUse\" x1=\"-364.008\" y1=\"625.231\" x2=\"-385.878\" y2=\"645.533\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#DE5C01\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#aa)\" d=\"M82.574 16.207s16.534 3.38 21.198 20.905c.618 2.321-1.992-14.237-1.187-12.666.805 1.581-6.654-7.714-20.011-8.239z\"/><linearGradient id=\"ab\" gradientUnits=\"userSpaceOnUse\" x1=\"-471.877\" y1=\"551.26\" x2=\"-481.034\" y2=\"560.73\" gradientTransform=\"matrix(1 -.028 -.028 -1 589.242 572.679)\"><stop offset=\"0\" stop-color=\"#F79A09\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#ab)\" d=\"M89.182 15.778s14.933 3.113 15.082 26.805c.104 16.77 2.589 6.295 5.055 2.527 2.126-3.257.673-7.224.622-7.213-.009.001-1.076-3.087-.356-1.778.032.058-1.003-.853-.995-.854.165-.024-.576-17.028-19.408-19.487z\"/><linearGradient id=\"ac\" gradientUnits=\"userSpaceOnUse\" x1=\"-367.675\" y1=\"613.599\" x2=\"-362.522\" y2=\"631.327\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#F79A09\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#ac)\" d=\"M105.998 18.989s5.363 13.971-.321 20.919c-1.855 2.268-2.063 13.884.204 12.817 2.272-1.068 1.778 6.169 1.481 6.991l-.005.026c.147.091 11.206-17.859-1.359-40.753z\"/><linearGradient id=\"ad\" gradientUnits=\"userSpaceOnUse\" x1=\"-520.821\" y1=\"501.143\" x2=\"-521.009\" y2=\"514.627\" gradientTransform=\"scale(1 -1) rotate(2.35 13262.46 15386.547)\"><stop offset=\"0\" stop-color=\"#F79A09\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#ad)\" d=\"M98.541 33.697s3.376 9.886-.159 16.953l2.674 5.973c1.963-4.818 4.46-15.009-2.515-22.926z\"/><linearGradient id=\"ae\" gradientUnits=\"userSpaceOnUse\" x1=\"-631.671\" y1=\"415.278\" x2=\"-622.382\" y2=\"433.574\" gradientTransform=\"scale(1 -1) rotate(4.07 6466.584 10445.929)\"><stop offset=\"0\" stop-color=\"#F79A09\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#ae)\" d=\"M104.479 32.521s2.335 15.69-6.09 29.854c.13 3.276-.445 6.242-1.234 8.685.367.482.858.813 1.506.871-.286.264-.571.511-.846.746-.506.224-1.024.459-1.527.703l-.32.726a26.727 26.727 0 0 0 1.846-1.428c1.721-.761 3.27-1.351 3.267-1.353l-1.075.393c-.511.185-.957.249-1.346.214 6.507-5.931 15.424-19.191 5.819-39.411zm-9.817 41.713c-.744.437-1.286.846-1.401 1.161-.085.23.422.097 1.299-.395.045-.263.083-.521.102-.766z\"/><linearGradient id=\"af\" gradientUnits=\"userSpaceOnUse\" x1=\"-357.475\" y1=\"662.826\" x2=\"-356.226\" y2=\"683.091\" gradientTransform=\"scale(1 -1) rotate(4.07 10302.395 6569.262)\"><stop offset=\"0\" stop-color=\"#DE5C01\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#af)\" d=\"M94.086 49.239s6.643 18.909-14.588 36.636c-1.252 1.046 8.618.598 9.482.206 2.544-1.156 5.552-8.869 5.196-7.947-.351.924 9.86-13.633-.09-28.895z\"/><linearGradient id=\"ag\" gradientUnits=\"userSpaceOnUse\" x1=\"-413.079\" y1=\"565.756\" x2=\"-373.909\" y2=\"589.168\" gradientTransform=\"matrix(1 0 0 -1 472.5 661)\"><stop offset=\"0\" stop-color=\"#B9120D\"/><stop offset=\".078\" stop-color=\"#BB180D\"/><stop offset=\".182\" stop-color=\"#C0290C\"/><stop offset=\".301\" stop-color=\"#C8450A\"/><stop offset=\".431\" stop-color=\"#D36C08\"/><stop offset=\".571\" stop-color=\"#E29E05\"/><stop offset=\".715\" stop-color=\"#F4DA02\"/><stop offset=\".792\" stop-color=\"#FEFD00\"/><stop offset=\".814\" stop-color=\"#FEFD07\"/><stop offset=\".846\" stop-color=\"#FEFD1B\"/><stop offset=\".884\" stop-color=\"#FEFE3C\"/><stop offset=\".927\" stop-color=\"#FFFE69\"/><stop offset=\".974\" stop-color=\"#FFFFA3\"/><stop offset=\"1\" stop-color=\"#FFFFC7\"/></linearGradient><path fill=\"url(#ag)\" d=\"M103.377 61.232S99.371 85.756 71.665 87.73c-10.848.774-26.424-1.766-25.045 2.373.428 1.282 2.467 6.631 7.121 7.873 12.594 3.359 46.103 2.259 49.636-36.744z\"/><linearGradient id=\"ah\" gradientUnits=\"userSpaceOnUse\" x1=\"-437.16\" y1=\"476.669\" x2=\"-397.033\" y2=\"471.232\" gradientTransform=\"matrix(.995 .099 .099 -.995 444.604 595.129)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#ah)\" d=\"M80.272 79.792s-16.952 3.874-27.934-5.476c-10.049-8.556-5.064-1.355-3.7 2.197 1.4 3.643-6.476.86-7.66.274-1.179-.578 18.654 11.86 39.294 3.005z\"/><linearGradient id=\"ai\" gradientUnits=\"userSpaceOnUse\" x1=\"-455.591\" y1=\"430.233\" x2=\"-408.998\" y2=\"415.59\" gradientTransform=\"matrix(.99 .145 .145 -.99 432.678 566.234)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#ai)\" d=\"M69.348 89.032s-20.222-3.974-26.624-17.677c-5.471-11.706-4.023-3.116-4.27.794-.259 4.021-5.929-1.471-6.687-2.426l-.038-.035c-.112.075 10.429 16.601 37.619 19.344z\"/><linearGradient id=\"aj\" gradientUnits=\"userSpaceOnUse\" x1=\"-1003.024\" y1=\"229.792\" x2=\"-980.869\" y2=\"187.376\" gradientTransform=\"scale(1 -1) rotate(10.37 1165.464 5770.996)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#aj)\" d=\"M47.257 87.259s-9.658-7.48-14.013-17.738c-3.659-1.271-8.524-4.178-8.621-4.676 1.546 7.971 9.686 17.277 22.634 22.414z\"/><path fill=\"#383838\" d=\"M28.687 111.18v4.908h5.389v3.121h-5.389v7.337h-4.375v-18.489H35.33l-.454 3.123h-6.189zm13.218-5.59c.471.453.708 1.027.708 1.721s-.236 1.267-.708 1.721c-.471.453-1.071.68-1.8.68-.73 0-1.326-.227-1.787-.68-.463-.454-.694-1.027-.694-1.721s.231-1.268.694-1.721c.461-.454 1.057-.68 1.787-.68.729 0 1.329.226 1.8.68zm-3.881 20.956v-14.167h4.215v14.167h-4.215zm16.621-14.379l-.667 4.082c-.533-.125-.96-.187-1.28-.187-.836 0-1.472.289-1.908.867-.437.578-.778 1.445-1.027 2.602v7.016h-4.215V112.38h3.682l.347 2.748c.32-.977.804-1.747 1.454-2.307.649-.561 1.383-.84 2.201-.84.515-.001.985.061 1.413.186zm13.605 8.536h-8.777c.142 1.192.48 2.027 1.014 2.508s1.271.721 2.214.721c.569 0 1.12-.103 1.654-.307s1.111-.521 1.734-.947l1.734 2.348c-1.654 1.316-3.494 1.974-5.522 1.974-2.294 0-4.055-.675-5.282-2.027-1.227-1.352-1.841-3.166-1.841-5.442 0-1.441.258-2.735.774-3.882.515-1.147 1.271-2.054 2.267-2.721.996-.667 2.188-1 3.575-1 2.045 0 3.646.64 4.802 1.92 1.156 1.28 1.734 3.06 1.734 5.335 0 .587-.026 1.093-.08 1.52zm-4.055-2.721c-.036-2.169-.8-3.255-2.294-3.255-.729 0-1.294.267-1.694.8-.4.534-.646 1.415-.734 2.641h4.722v-.186zm11.738-8.137c-.267.285-.399.766-.399 1.441v1.093h3.334l-.454 2.936h-2.881v11.231h-4.215v-11.231h-2.135v-2.936h2.135v-1.253c0-1.423.466-2.583 1.401-3.482.934-.898 2.271-1.347 4.014-1.347 1.405 0 2.695.303 3.869.907l-1.147 2.748a4.907 4.907 0 0 0-2.215-.534c-.605 0-1.04.143-1.307.427zm15.287 4.068c1.227 1.326 1.841 3.18 1.841 5.563 0 1.513-.28 2.833-.84 3.962-.561 1.129-1.361 2.005-2.401 2.628-1.041.622-2.272.933-3.695.933-2.152 0-3.846-.662-5.083-1.987-1.236-1.324-1.854-3.179-1.854-5.562 0-1.512.28-2.833.84-3.961.561-1.13 1.361-2.006 2.401-2.628 1.041-.623 2.271-.934 3.695-.934 2.169 0 3.868.662 5.096 1.986zm-7.017 2.188c-.426.721-.64 1.837-.64 3.349 0 1.547.209 2.677.627 3.388.418.711 1.063 1.067 1.935 1.067.854 0 1.494-.359 1.92-1.08.427-.721.64-1.836.64-3.349 0-1.547-.209-2.676-.626-3.388-.418-.711-1.063-1.067-1.934-1.067-.854 0-1.495.36-1.922 1.08zm18.328 10.445l-2.454-5.309-2.401 5.309h-4.589l4.563-7.443-4.108-6.724h4.722l1.974 4.536 1.895-4.536h4.482l-3.869 6.59 4.563 7.577h-4.778z\"/></svg>"

/***/ }),

/***/ "../src/components/firefox/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FirefoxOriginalWordmark = __webpack_require__("../src/components/firefox/original-wordmark/FirefoxOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FirefoxOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/firefox/original/FirefoxOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _FirefoxOriginal = __webpack_require__("../src/components/firefox/original/FirefoxOriginal.svg");
	
	var _FirefoxOriginal2 = _interopRequireDefault(_FirefoxOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** FirefoxOriginal */
	function FirefoxOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'FirefoxOriginal',
	    svg: _FirefoxOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	FirefoxOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = FirefoxOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/firefox/original/FirefoxOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><ellipse fill=\"#110070\" cx=\"63.833\" cy=\"63.79\" rx=\"59.102\" ry=\"59.14\"/><radialGradient id=\"a\" cx=\"-407.857\" cy=\"945.153\" r=\"103.81\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#67C5D5\"/><stop offset=\".16\" stop-color=\"#66C2D3\"/><stop offset=\".28\" stop-color=\"#62B9CE\"/><stop offset=\".385\" stop-color=\"#5CA8C6\"/><stop offset=\".483\" stop-color=\"#5392BA\"/><stop offset=\".576\" stop-color=\"#4874AA\"/><stop offset=\".665\" stop-color=\"#3A5097\"/><stop offset=\".749\" stop-color=\"#2A2781\"/><stop offset=\".815\" stop-color=\"#1B006D\"/><stop offset=\"1\" stop-color=\"#596AAD\"/></radialGradient><ellipse fill=\"url(#a)\" cx=\"63.833\" cy=\"63.79\" rx=\"57.985\" ry=\"58.024\"/><radialGradient id=\"b\" cx=\"-407.874\" cy=\"938.23\" r=\"52.024\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></radialGradient><path fill=\"url(#b)\" d=\"M55.516 93.741c-.072-.314-.854-1.227-1.452-1.432-.598-.204-1.184.881-1.568-.92-1.261.724-1.805-.199-1.805-.199s-1.359.08-1.623 1.744c-.647.767-2.306 3.552-1.425.655.887-2.915-.936-.229-1.105 1.236-.316.65-.851.715-.515-2.209-1.168-.404-1.766-3.115-1.125-3.167-.744-1.037-.16-2.622.46-2.538.62.08 1.683-1.354 1.651-1.688-.033-.331.479-.094.448-2.327-.033-2.237.843-2.792.915-.92.075 1.864 1.189-.611 1.075-1.561-.116-.944.11-3.082.79-1.818-.79-3.125-.167-3.247.307-1.168 1.189.094 1.23.727 1.23.727 1.315-.324 1.945.667 2.048 1.223 1.218-1.438 2.45.113 2.45.113s.849-.282.443 1.195c-.409 1.472 1.765.676 1.246-.382 1.068-.541 2.655 1.097 3.155 2.216.5 1.123-.857 2.712.201 3.096 1.063.382.597 2.232.597 2.232s2.224 1.234.68 2.293l-.525 1.26s1.006 1.122 1.349.454c.342-.669.463.68.463.68-.128-.238.247 1.391 1.634 1.733 1.392.34 2.273 2.541.728 2.567-1.54.026-1.659-.016-2.076.883-.416.895-2.381.927-3.4-.232-1.083.367-3.009-.106-2.442-.972-.934.545-1.816-.918-1.087-1.572.73-.649-.41-1.491-.793-.56-.379.932-2.395 1.391-2.254-.194.042-.47 1.116-.745 1.129-.352.197.453.277-.037.196-.096z\"/><radialGradient id=\"c\" cx=\"-407.873\" cy=\"938.23\" r=\"52.023\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></radialGradient><path fill=\"url(#c)\" d=\"M103.462 48.392c.307.306.914.237 1.249.144.337-.097.29-.336.581-.43.286-.097 1.392.43 1.103 1.578-.67.093-.914.908-.914.908s-.671.286-1.01.144c-.336-.144-.336-.097-.817-.051-.481.051-1.637-.618-.386-.618 1.252 0-.142-.576-.672-.576-.528 0-.096-.526.531-.381-.436-.718-.195-1.247.335-.718z\"/><radialGradient id=\"d\" cx=\"-407.877\" cy=\"938.233\" r=\"52.031\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></radialGradient><path fill=\"url(#d)\" d=\"M99.125 50.989c-.335.333.05 1.339.482 1.29.43-.047 1.105-.238 1.105-.238s.335.669 0 .862c-.335.19-1.314.106-.046.574 1.298.477 1.633.333 1.729.093.098-.237.528-1.05.771-1.001.192-.43-.673-.813-.192-1.102.478-.287.097-1.337.097-1.337s-.675.047-.963.526c-.289.478-.671-.047-.96-.047a1.295 1.295 0 0 1-.242.524l-.191-.433c-.002.001-1.35-.046-1.59.289z\"/><radialGradient id=\"e\" cx=\"-407.023\" cy=\"933.306\" r=\"57.157\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".264\" stop-color=\"#0B629B\"/><stop offset=\".844\" stop-color=\"#031747\"/><stop offset=\"1\" stop-color=\"#00022F\"/></radialGradient><path fill=\"url(#e)\" d=\"M90.139 51.777c-.042-.123.382-.619.269.023-.261.457 1.054.867 1.423.359 1.235-1.693-1.166-2.513-2.208-1.726-1.051.794-1.631-.908-.423-1.151 1.204-.243 1.306-2.42-.021-2.428 1.171-.578-.451-2.31-1.792-2.605-.217-1.862-2.181-3.046-3.214-2.371-1.043.678-1.132.56-2.661-.369-1.522-.923-2.255 1.92-1.135 3.164 1.126 1.251.309 3.267.355 2.923 0 0-.424.763-.396 1.048-1.289.437-1.665-1.377-2.465-1.779-.583.76-1.523 1.166-1.523 1.166l.07-1.547s-4.001-2.179-5.23-1.569c-1.515.467-1.873 3.975-.498 4.489 1.378.519-1.728 1.811 1.388 5.095 3.2 3.373 4.438 3.469 5.09 2.92.162-.138.441-.345.781-.576.031.13.083.254.163.372.801 1.204-1.862 2.154-2.233 3.879-.377 1.744-.029 4.987 1.55 5.098.301-1.729 3.257-1.118 1.648.448-1.637 1.596-.488 1.878-.488 1.878s.077 2.991 2.582 2.035c-.073.171-.131.39-.167.629-.7-.141-2.411-.356-2.83.838-.528 1.506-2.763-.511-4.328.166-1.556.671-3.829 2.875-3.063 4.425 1.47-.697 2.595 2.447.542 1.802-2.061-.647-1.661.58-1.661.58s-2.146 1.693-.137 3.494c-.771.119-2.143.978-1.681 2.864 0 0-.881.031-1 1.719-2.877.58-2.701 1.472 1.626.494-1.746.905 1.221 1.333 2.536 1.212 1.317-.12 4.773 1.584 2.176 1.602-2.601.016-1.827 1.289 1.29 1.349 3.111.064 2.784.785 3.246.754.462-.033 2.473 1.554 2.365 2.434-.113.88 2.107 1.794 3.551.785.074.916 3.871.202 4.433-1.449 4.112.628 4.017-.139 3.102-.626-2.059-.314-5.837-3.052-1.74-1.643 4.077 1.405.149-1.107-.925-2.072-2.341-.455-2.46-2.406-2.46-2.406s1.293-.736.273-2.576c2.528-.469 1.001-1.358 1.285-2.207.284-.85 1.568-1.934 2.008-2.021.083-.114.772.023.133.283-.552.005-.16 1.559.5 1.639 2.232.271 1.58-2.644.268-3.23-1.315-.591-.134-2.195.789-1.115.923 1.078 2.982-.133 2.209-1.498 1.228.851 1.89-1.902 1.367-3.481 1.642-1.423 1.588-4.26.319-4.896-.625-.312-.926-.513-1.078-.901.754-.356 1.754-.619 2.147-.268.638.577 2.415-1.014 2.302-2.874.748.41 1.939-3.381.927-4.708 2.317-3.239 1.693-3.533.918-2.99-1.166 1.616-4.994 3.548-2.026.685 2.88-2.779-.767-.671-1.986-.219-1.436 1.797-2.958.933-2.958.933s.064-1.472-1.79-1.503c.857-2.363-.523-1.51-1.007-2.154-.481-.648-.656-2.224-.507-2.626z\"/><radialGradient id=\"f\" cx=\"-407.875\" cy=\"938.233\" r=\"52.03\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></radialGradient><path fill=\"url(#f)\" d=\"M60.1 28.097c-.359.938 1.173 2.461 1.943 1.971.772-.495 1.877-1.477 1.877-1.477s1.172.942.699 1.613c-.477.669-2.376 1.421.372 1.116 2.82-.311 3.334-.893 3.32-1.431-.015-.536.14-2.458.628-2.592.015-.986-1.917-.895-1.248-1.881.669-.982-.901-2.596-.901-2.596s-1.223.716-1.376 1.88c-.154 1.163-1.298.536-1.84.803.141.582-.026 1.207-.026 1.207l-.708-.626s-2.562 1.164-2.74 2.013z\"/><radialGradient id=\"g\" cx=\"-407.873\" cy=\"938.232\" r=\"52.027\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></radialGradient><path fill=\"url(#g)\" d=\"M64.685 77.327c-.335.333.049 1.337.48 1.291.433-.049 1.106-.239 1.106-.239s.336.669 0 .861c-.337.19-1.314.108-.048.573 1.297.478 1.635.335 1.731.097.096-.239.528-1.053.769-1.006.194-.429-.673-.812-.193-1.097.482-.29.1-1.34.1-1.34s-.674.047-.963.526c-.288.478-.673-.049-.962-.049a1.31 1.31 0 0 1-.238.526l-.193-.43c-.002 0-1.35-.048-1.589.287z\"/><defs><ellipse id=\"h\" cx=\"63.833\" cy=\"63.79\" rx=\"57.985\" ry=\"58.024\"/></defs><clipPath id=\"i\"><use xlink:href=\"#h\" overflow=\"visible\"/></clipPath><linearGradient id=\"j\" gradientUnits=\"userSpaceOnUse\" x1=\"-396.101\" y1=\"935.823\" x2=\"-379.307\" y2=\"934.391\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></linearGradient><path clip-path=\"url(#i)\" fill=\"url(#j)\" d=\"M65.133 5.647c-.907.203.611 3.49.611 3.49s-.054 2.207.32 2.319c.373.113 2.84.729 4.13 2.337 1.297 1.606.623 2.453-.456 1.988-1.08-.462-.794.956-.794.956s3.258 1.059.798.991c-2.466-.065 1.66 1.735 1.387 1.923-.273.19-.427 1.226-.427 1.226s-2.175.181-.332.955c6.235 2.626-.666 1.917-.666 1.917l-.881 1.083 1.743 2.186 1.34.958s2.821-.941 3.701-1.088c.88-.145 3.102-1.808 3.102-1.808s.666.477.168-.495c-.499-.972 1.834-.539 2.415.185l4.118 1.86a.778.778 0 0 0 .291.374c.803.563-.726 1.529-.571 2.552.155 1.012 1.088 2.693 2.113 2.516-.179-.965 1.844-1.082 1.14-.005-.703 1.071.077 1.051.077 1.051s.65 1.515 2.025.673c-.055.462.227 1.392 1.408 1.453 0 0-.125.505.845.862-.132 1.73.422 1.785.559-.843.244 1.154.988-.469 1.136-1.245.15-.78 1.75-2.494 1.317-.979-.429 1.502 4.716 2.051 5.288.258.575-1.808 2.626-2.751 2.687-3.025.063-.28-4.564-.71-4.053-.492.512.217 1.464-.943 1.11-1.978.574.116.827-2.292-.083-2.915 1.139-2.396.649-2.471.182-1.994-.568 1.2-2.911 3.011-1.322.78 1.603-2.254-.651-.282-1.433.208-.686 1.334-1.891 1.075-1.891 1.075s-.221-.908-1.511-.604c.15-1.606-.65-.834-1.115-1.149-.284-.193-.556-.625-.724-.996 1.111.45 2.602.929 2.345.104-.167-.541 2.103.64 2.182.394l2.838-.394 2.757-1.743C85.38 4.813 65.133 5.647 65.133 5.647z\"/><defs><ellipse id=\"k\" cx=\"63.833\" cy=\"63.79\" rx=\"57.985\" ry=\"58.024\"/></defs><clipPath id=\"l\"><use xlink:href=\"#k\" overflow=\"visible\"/></clipPath><linearGradient id=\"m\" gradientUnits=\"userSpaceOnUse\" x1=\"-433.831\" y1=\"933.28\" x2=\"-443.112\" y2=\"919.649\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#0F80BC\"/><stop offset=\".338\" stop-color=\"#0A5F9E\"/><stop offset=\"1\" stop-color=\"#00145A\"/></linearGradient><path clip-path=\"url(#l)\" fill=\"url(#m)\" d=\"M38.929 10.721c-10.531 4.728-18.477 14.473-18.477 14.473s.934 2.137 1.259 1.979c.329-.155-2.351 5.606-.384 5.93 1.978.325 7.666-3.564 6.611-3.206-1.052.354.593-2.105.593-2.105s2.96-1.313 1.209.202c-1.736 1.505 2.309.186 2.246.494-.064.31.522 1.142.522 1.142s-1.387 1.488.404.889c6.147-2.068.81 1.771.81 1.771l.105 1.307 2.659.463 1.572-.15s1.375-2.426 1.907-3.085c.533-.661 1.024-3.271 1.024-3.271s.799-.083-.212-.466c-1.013-.383.967-1.577 1.878-1.429l4.285-1.331a.812.812 0 0 0 .468.082c.981-.114.487 1.596 1.289 2.241.794.641 2.618 1.26 3.27.468-.781-.592.671-2.003.857-.749.186 1.245.764.719.764.719s1.537-2.643 2.028-4.159c.269.375 2.777-3.296 2.017-5.047-.768-1.773.477-3.442.338-3.701-.142-.254-.893.528-.338.34.559-.191-1.583.769-1.866-2.053-.287-2.878-.705.242-.982 1.165.376 1.502 4.273-6.069 4.273-6.069l5.024-2.049c.001.003-11.434-.954-25.153 5.205z\"/><linearGradient id=\"n\" gradientUnits=\"userSpaceOnUse\" x1=\"-409.766\" y1=\"917.94\" x2=\"-409.766\" y2=\"940.502\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".014\" stop-opacity=\"0\"/><stop offset=\".65\" stop-color=\"#C4E0E3\" stop-opacity=\".2\"/><stop offset=\".822\" stop-color=\"#C4E0E3\"/><stop offset=\".85\" stop-color=\"#CDE5E8\"/><stop offset=\".944\" stop-color=\"#E8F4F7\"/><stop offset=\"1\" stop-color=\"#F2FAFC\"/></linearGradient><ellipse opacity=\".5\" fill=\"url(#n)\" cx=\"62.734\" cy=\"27.828\" rx=\"30.703\" ry=\"19.892\"/><linearGradient id=\"o\" gradientUnits=\"userSpaceOnUse\" x1=\"-407.946\" y1=\"896.271\" x2=\"-394.013\" y2=\"904.454\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#DF731B\"/><stop offset=\".545\" stop-color=\"#DF731B\"/><stop offset=\".701\" stop-color=\"#EC8811\"/><stop offset=\".859\" stop-color=\"#F4950B\"/><stop offset=\"1\" stop-color=\"#F79A09\"/></linearGradient><path fill=\"url(#o)\" d=\"M125.156 47.563l-1.421 9.114s-2.03-16.873-4.519-23.182c-3.815-9.666-5.513-9.588-5.523-9.573 2.554 6.493 2.091 9.981 2.091 9.981s-4.527-12.338-16.498-16.264c-14.175-4.646-21.396-2.968-21.343-2.902.054.065 14.651 2.551 17.24 6.109 0 0-6.201 0-12.372 1.777-.278.08 22.703 2.871 27.402 25.836 0 0-2.519-5.257-5.635-6.149 2.048 6.233 1.523 18.061-.428 23.94-.25.757-.508-3.269-4.352-5 1.23 8.821-.074 22.815-6.195 26.668-.477.3 3.837-13.812.868-8.356-17.727 27.18-38.802 10.997-47.351 5.229 6.862 1.681 14.149.471 18.369-2.414 4.258-2.912 6.776-5.038 9.039-4.536 2.261.506 3.767-1.763 2.01-3.776-1.758-2.018-6.027-4.79-11.802-3.278-4.072 1.066-9.12 5.573-16.825 1.01-6.572-3.895-6.528-7.057-6.528-9.071 0-2.016 1.793-5.08 5.056-4.578 2.922.452 1.382-1.264 4.527 0 .857.345-.086-4.112-1.305-6.968 2.348-4.9 9.964-6.356 10.532-6.786 1.03-.778.464-1.167.815-2.34.329-1.093.539-4.046-7.985-3.229-3.923.375-6.418-4.708-7.236-5.941.265-1.572.69-3.007 1.267-4.322.584-1.197 1.222-2.295 1.86-3.126l.53-.701c1.27-1.482 2.831-2.75 4.703-3.802.977-.552-10.926-.035-16.282 6.945-1.437.188-3.409-.227-5.614-.227-2.762 0-4.933.302-6.942.806-.322.082-.84.037-1.476-.113-1.767-1.832-6.77-6.234-6.999-12.206 0 0-7.273 5.59-6.185 20.828-.096 8.429-2.583 6.02-3.863 10.593-.596 2.167.895 3.799.895 3.863-.002.033 1.788-1.938 1.788-1.938s-11.277 19.539 3.289 44.483c12.553 21.503 33.621 31.006 55.481 29.157a67.807 67.807 0 0 0 11.519-1.747c50.935-12.314 45.398-73.814 45.398-73.814z\"/><linearGradient id=\"p\" gradientUnits=\"userSpaceOnUse\" x1=\"-430.496\" y1=\"915.535\" x2=\"-419.681\" y2=\"914.609\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".011\" stop-color=\"#941403\"/><stop offset=\".897\" stop-color=\"#E85C0A\"/></linearGradient><path fill=\"url(#p)\" d=\"M45.619 32.149s2.201 6.015 7.138 5.996c9.42-.038 9.609.094 9.669 1.238.188 3.487-1.534 4.629-2.192 5.125-.661.494-9.629 5.694-9.959 7.182-.329 1.487-10.349-14.143-10.349-14.143l5.693-5.398z\"/><linearGradient id=\"q\" gradientUnits=\"userSpaceOnUse\" x1=\"-447.82\" y1=\"918.532\" x2=\"-408.777\" y2=\"913.652\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".011\" stop-color=\"#941403\"/><stop offset=\".136\" stop-color=\"#A32104\"/><stop offset=\".498\" stop-color=\"#C84107\"/><stop offset=\".789\" stop-color=\"#DF5509\"/><stop offset=\".972\" stop-color=\"#E85C0A\"/></linearGradient><path fill=\"url(#q)\" d=\"M50.634 38.634s3.06 3.907.746 5.47c-2.826 1.909 3.996 2.325 6.468.938 2.472-1.387 3.991-3.426 4.077-3.729.086-.304.898-3.043-4.262-2.088-3.262.603-4.458.742-7.029-.591z\"/><linearGradient id=\"r\" gradientUnits=\"userSpaceOnUse\" x1=\"-423.63\" y1=\"908.206\" x2=\"-420.517\" y2=\"909.576\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#F2C8A9\"/><stop offset=\"1\" stop-color=\"#ffc\"/></linearGradient><path fill=\"url(#r)\" d=\"M60.235 44.509c.5-.378 1.61-1.133 2.034-3-.309.125-.338-.23-.703-.076-6.927 7.227-7.193 2.194-10.974 3.208-3.446.943-4.221 2.237-4.366 2.337l.155.22c.993.505 1.944 2.113 2.66 3.55.699.833 1.168 1.242 1.235.94.329-1.485 9.3-6.685 9.959-7.179z\"/><linearGradient id=\"s\" gradientUnits=\"userSpaceOnUse\" x1=\"-433.555\" y1=\"870.093\" x2=\"-381.191\" y2=\"867.937\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#B30000\"/><stop offset=\"1\" stop-color=\"#DF731B\"/></linearGradient><path fill=\"url(#s)\" d=\"M8.478 50.25C7.064 53.218-2.012 68.555 12.8 94.081c14.495 24.985 39.58 33.144 65.191 27.601 7.311-1.582 15.74-7.302 21.113-11.5-3.452-8.706-1.409-8.379-3.259-7.234-20.631 12.773-37.032.173-49.726-1.437C-.58 95.593 8.642 50.158 8.642 50.158l-.164.092z\"/><linearGradient id=\"t\" gradientUnits=\"userSpaceOnUse\" x1=\"-421.095\" y1=\"878.22\" x2=\"-393.792\" y2=\"868.471\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#941403\"/><stop offset=\"1\" stop-color=\"#DF731B\"/></linearGradient><path fill=\"url(#t)\" d=\"M47.362 85.263c4.401 1.319 14.005.182 18.129-2.886 2.779-2.066 4.878-3.624 6.645-4.275-3.122-2.121-3.171.885-9.735 2.405-13.674 3.172-20.313-3.68-20.313-3.68.969 5.422 4.354 8.062 5.879 9-.404-.358-.616-.568-.605-.564z\"/><linearGradient id=\"u\" gradientUnits=\"userSpaceOnUse\" x1=\"-483.865\" y1=\"813.412\" x2=\"-457.248\" y2=\"813.412\" gradientTransform=\"matrix(.999 .049 .049 -.999 450.28 926.467)\"><stop offset=\".056\" stop-color=\"#B30000\"/><stop offset=\"1\" stop-color=\"#DE5C01\"/></linearGradient><path fill=\"url(#u)\" d=\"M32.535 110.025S21.152 97.18 17.974 82.795c-4.685-4.425-8.01-8.167-10.218-10.873 1.275 10.236 6.494 26.128 24.779 38.103z\"/><linearGradient id=\"v\" gradientUnits=\"userSpaceOnUse\" x1=\"-301.198\" y1=\"955.307\" x2=\"-286.717\" y2=\"910.443\" gradientTransform=\"scale(1 -1) rotate(-6.83 -8816.783 -2227.993)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#v)\" d=\"M23.039 98.359s-7.855-11.184-4.91-20.679c2.65-8.538-.563-3.459-2.432-1.634-1.887 1.844-2.858-5.442-2.809-6.282l-.001-.027c-.119-.026-3.74 17.457 10.152 28.622z\"/><linearGradient id=\"w\" gradientUnits=\"userSpaceOnUse\" x1=\"-476.095\" y1=\"843.773\" x2=\"-476.095\" y2=\"793.626\" gradientTransform=\"matrix(.999 .045 .045 -.999 451.05 929.576)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#w)\" d=\"M11.401 88.61s-1.791-22.698 3.87-25.906c8.99-5.094.75-3.903-1.857-2.489-2.634 1.427-2.39-7.968-2.018-8.86.365-.881-9.278 8.882.005 37.255z\"/><path fill=\"#A40000\" d=\"M50.73 21.819s-7.116 7.229-7.063 7.255c.054.025.204 9.277.437 11.9.853 1.008 3.51 7.558 1.476 6.104-2.078-1.484-.58-1.516-.398-.763v.037c-.139.065-5.165-10.879 5.548-24.533z\"/><linearGradient id=\"x\" gradientUnits=\"userSpaceOnUse\" x1=\"-453.894\" y1=\"921.626\" x2=\"-459.335\" y2=\"935.568\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".011\" stop-color=\"#941403\"/><stop offset=\".472\" stop-color=\"#E85C0A\"/><stop offset=\"1\" stop-color=\"#F9BD5F\"/></linearGradient><path fill=\"url(#x)\" d=\"M16.877 16.25s-7.564 5.804-6.119 21.72c5.855-5.256 14.134-9.185 14.134-9.185-1.389-.876-7.762-5.975-8.015-12.535z\"/><linearGradient id=\"y\" gradientUnits=\"userSpaceOnUse\" x1=\"-430.631\" y1=\"918.428\" x2=\"-417.593\" y2=\"935.565\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".197\" stop-color=\"#DE7210\"/><stop offset=\".843\" stop-color=\"#F9BD5F\"/><stop offset=\"1\" stop-color=\"#FFFCCF\"/></linearGradient><path fill=\"url(#y)\" d=\"M35.519 33.656L46.88 47.785c-3.277-13.875-.758-22.199 7.311-26.741 1.194-.673-16.858.243-18.672 12.612z\"/><linearGradient id=\"z\" gradientUnits=\"userSpaceOnUse\" x1=\"-437.523\" y1=\"895.036\" x2=\"-424.307\" y2=\"868.604\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".017\" stop-color=\"#941403\"/><stop offset=\".5\" stop-color=\"#E35100\"/><stop offset=\"1\" stop-color=\"#DF731B\"/></linearGradient><path fill=\"url(#z)\" d=\"M27.514 68.56c1.938-12.208 18.927-10.413 18.927-10.413-.757.563-3.668.899-4.501 3.229-2.752 7.688-.127 24.483 17.01 31.527 1.807.745-34.299-6.303-31.436-24.343z\"/><linearGradient id=\"A\" gradientUnits=\"userSpaceOnUse\" x1=\"-417.561\" y1=\"911.246\" x2=\"-414.261\" y2=\"908.255\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#EEA272\"/><stop offset=\".186\" stop-color=\"#EFA777\"/><stop offset=\".406\" stop-color=\"#F2B585\"/><stop offset=\".643\" stop-color=\"#F6CD9C\"/><stop offset=\".89\" stop-color=\"#FCEEBB\"/><stop offset=\"1\" stop-color=\"#ffc\"/></linearGradient><path fill=\"url(#A)\" d=\"M62.171 41.84c-.083-.015-.157-.013-.194.037-.209.28-1.017 1.233-2.938 2.8-3.568 2.902-5.074 2.167-7.732 2.762-1.21.271-2.361 1.083-3.135 1.734.313.506.606 1.053.868 1.576.699.833 1.168 1.242 1.235.94.33-1.486 9.3-6.686 9.959-7.182.47-.351 1.464-1.049 1.937-2.667z\"/><linearGradient id=\"B\" gradientUnits=\"userSpaceOnUse\" x1=\"-436.81\" y1=\"904.181\" x2=\"-421.649\" y2=\"888.71\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".197\" stop-color=\"#DF731B\"/><stop offset=\".843\" stop-color=\"#F9BD5F\"/><stop offset=\"1\" stop-color=\"#FFFCCF\"/></linearGradient><path fill=\"url(#B)\" d=\"M51.218 60.294c.101-2.58-.081-8.846-2.762-11.565-2.05-2.077-2.53-4.458-2.805-7.173C23.376 49.877 20.196 60.753 22.423 60.4c17.815-2.826 22.823-3.171 28.795-.106z\"/><linearGradient id=\"C\" gradientUnits=\"userSpaceOnUse\" x1=\"311.259\" y1=\"1736.858\" x2=\"311.259\" y2=\"1680.021\" gradientTransform=\"scale(1 -1) rotate(-14.72 -6736.722 1996.747)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#C)\" d=\"M3.728 75.539s1.548-20.113 11.615-27.473c7.903-5.782 1.765-3.682-1.286-3.442-3.218.254-4.934 2.212-4.313 1.492l.031-.055c-.107-.124-7.555 6.127-6.047 29.478z\"/><linearGradient id=\"D\" gradientUnits=\"userSpaceOnUse\" x1=\"-428.861\" y1=\"929.136\" x2=\"-448.077\" y2=\"897.842\" gradientTransform=\"matrix(.99 -.08 -.095 -1.173 528.218 1096.236)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C06E\"/></linearGradient><path fill=\"url(#D)\" d=\"M2.667 60.087s5.395-17.125 16.297-16.979c7.23.096 1.495-6.111-.692-7.054-2.282-.977-2.827-.939-3.36-.467-.799.708-7.972.435-12.245 24.5z\"/><linearGradient id=\"E\" gradientUnits=\"userSpaceOnUse\" x1=\"-391.562\" y1=\"884.775\" x2=\"-411.976\" y2=\"880.876\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".005\" stop-color=\"#FFFAEE\"/><stop offset=\".276\" stop-color=\"#F5F89B\"/><stop offset=\".31\" stop-color=\"#F3ED91\"/><stop offset=\".467\" stop-color=\"#ECC267\"/><stop offset=\".618\" stop-color=\"#E6A046\"/><stop offset=\".761\" stop-color=\"#E2872E\"/><stop offset=\".892\" stop-color=\"#E07820\"/><stop offset=\"1\" stop-color=\"#DF731B\"/></linearGradient><path fill=\"url(#E)\" d=\"M76.213 76.849c.82-.803.249-3.888-4.904-5.757-4.675-1.699-11.973 2.619-14.138 3.471 0 0 8.266-1.548 11.365-1.033 4.202.7 5.677 5.281 7.677 3.319z\"/><linearGradient id=\"F\" gradientUnits=\"userSpaceOnUse\" x1=\"-924.082\" y1=\"388.59\" x2=\"-924.082\" y2=\"341.086\" gradientTransform=\"matrix(.992 .126 .126 -.992 883.114 546.453)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C06E\"/></linearGradient><path fill=\"url(#F)\" d=\"M10.631 71.208s-.895-16.836 6.649-24.026c5.924-5.647 1.065-3.243-1.438-2.713-2.64.56-3.85 2.367-3.413 1.704l.019-.049c-.101-.092-5.595 5.894-1.817 25.084z\"/><linearGradient id=\"G\" gradientUnits=\"userSpaceOnUse\" x1=\"-955.606\" y1=\"121.617\" x2=\"-955.606\" y2=\"74.12\" gradientTransform=\"matrix(.932 .362 .362 -.932 862.955 499.986)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C06E\"/></linearGradient><path fill=\"url(#G)\" d=\"M4.82 65.859s3.188-16.555 12.244-21.714c7.111-4.053 1.816-2.89-.742-2.979-2.697-.092-4.306 1.37-3.723.831l.029-.042c-.074-.115-6.85 4.371-7.808 23.904z\"/><linearGradient id=\"H\" gradientUnits=\"userSpaceOnUse\" x1=\"-30.438\" y1=\"1441.928\" x2=\"-43.666\" y2=\"1422.086\" gradientTransform=\"scale(1 -1) rotate(35.88 2315.534 760.698)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C072\"/></linearGradient><path fill=\"url(#H)\" d=\"M15.572 72.655s-1.743-10.035 2.014-14.974c2.998-3.941.366-2.014-1.026-1.445-1.452.593-2.002 1.764-1.804 1.334.191-.419-6.464 4.738.816 15.085z\"/><linearGradient id=\"I\" gradientUnits=\"userSpaceOnUse\" x1=\"-23.279\" y1=\"1448.429\" x2=\"-36.506\" y2=\"1428.588\" gradientTransform=\"scale(1 -1) rotate(35.88 2315.534 760.698)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C072\"/></linearGradient><path fill=\"url(#I)\" d=\"M17.564 63.193s-1.743-10.035 2.013-14.975c2.998-3.941.366-2.013-1.026-1.445-1.452.593-2.003 1.765-1.804 1.335.192-.42-6.462 4.737.817 15.085z\"/><linearGradient id=\"J\" gradientUnits=\"userSpaceOnUse\" x1=\"-459.905\" y1=\"914.636\" x2=\"-465.692\" y2=\"903.834\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#EED8A5\"/></linearGradient><path fill=\"url(#J)\" d=\"M7.028 49.475s4.072-8.342 9.483-9.985c4.318-1.31 1.344-1.29.014-1.615-1.39-.337-2.421.232-2.046.021.367-.206-7.301.049-7.451 11.579z\"/><linearGradient id=\"K\" gradientUnits=\"userSpaceOnUse\" x1=\"-460.486\" y1=\"908.034\" x2=\"-466.272\" y2=\"897.234\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#EED8A5\"/></linearGradient><path fill=\"url(#K)\" d=\"M6.447 56.076s4.071-8.342 9.483-9.984c4.318-1.31 1.344-1.292.013-1.617-1.39-.336-2.421.234-2.045.022.366-.206-7.302.05-7.451 11.579z\"/><linearGradient id=\"L\" gradientUnits=\"userSpaceOnUse\" x1=\"-453.93\" y1=\"912.618\" x2=\"-459.523\" y2=\"898.731\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C072\"/></linearGradient><path fill=\"url(#L)\" d=\"M9.403 54.255s7.181-14.715 16.728-17.614c7.619-2.311 2.373-2.278.024-2.849-2.453-.594-4.271.413-3.61.039.647-.364-12.879.085-13.142 20.424z\"/><linearGradient id=\"M\" gradientUnits=\"userSpaceOnUse\" x1=\"-451.803\" y1=\"919.379\" x2=\"-465.029\" y2=\"899.54\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C072\"/></linearGradient><path fill=\"url(#M)\" d=\"M14.312 46.33s4.466-9.152 10.404-10.955c4.739-1.438 1.475-1.417.015-1.772-1.526-.369-2.656.256-2.245.023.402-.228-8.011.052-8.174 12.704z\"/><linearGradient id=\"N\" gradientUnits=\"userSpaceOnUse\" x1=\"-450.913\" y1=\"915.373\" x2=\"-462.969\" y2=\"897.289\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F2C072\"/></linearGradient><path fill=\"url(#N)\" d=\"M15.768 49.563s4.071-8.342 9.482-9.983c4.319-1.311 1.345-1.292.014-1.617-1.391-.337-2.422.233-2.046.022.365-.208-7.301.05-7.45 11.578z\"/><linearGradient id=\"O\" gradientUnits=\"userSpaceOnUse\" x1=\"-412.122\" y1=\"918.189\" x2=\"-411.167\" y2=\"916.487\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#8B8B89\"/><stop offset=\"1\" stop-color=\"#120500\"/></linearGradient><path fill=\"url(#O)\" d=\"M62.428 39.383c-.047-.87-.176-1.153-4.339-1.225.477.216 1.3.65 2.206 1.393 1.196.98 1.39 2.073 1.514 3.204.404-.769.701-1.833.619-3.372z\"/><linearGradient id=\"P\" gradientUnits=\"userSpaceOnUse\" x1=\"-449.701\" y1=\"923.971\" x2=\"-449.701\" y2=\"929.197\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#P)\" d=\"M37.982 27.764l-3.611 5.81s-14.438-2.265-26.679 9.577c-1.011.978 8.007-20.94 30.29-15.387z\"/><linearGradient id=\"Q\" gradientUnits=\"userSpaceOnUse\" x1=\"-463.88\" y1=\"875.39\" x2=\"-452.942\" y2=\"888.172\" gradientTransform=\"matrix(.999 .04 .04 -.999 451.516 931.973)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#Q)\" d=\"M25.016 38.163s3.848-7.144 8.837-9.303c-2.579.081-8.37 2.098-8.837 9.303z\"/><linearGradient id=\"R\" gradientUnits=\"userSpaceOnUse\" x1=\"-456.723\" y1=\"918.976\" x2=\"-462.51\" y2=\"908.175\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#EED8A5\"/></linearGradient><path fill=\"url(#R)\" d=\"M10.211 45.135s4.071-8.342 9.483-9.985c4.318-1.31 1.344-1.291.014-1.616-1.391-.336-2.421.234-2.046.021.365-.205-7.303.05-7.451 11.58z\"/><linearGradient id=\"S\" gradientUnits=\"userSpaceOnUse\" x1=\"-490.528\" y1=\"804.837\" x2=\"-479.844\" y2=\"817.323\" gradientTransform=\"matrix(.995 .104 .104 -.995 420.84 891.22)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#S)\" d=\"M18.739 39.257s4.201-6.724 9.198-8.514c-2.516-.083-8.29 1.519-9.198 8.514z\"/><linearGradient id=\"T\" gradientUnits=\"userSpaceOnUse\" x1=\"-489.629\" y1=\"832.599\" x2=\"-476.791\" y2=\"830.84\" gradientTransform=\"matrix(.996 .09 .09 -.996 426.311 899.606)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#T)\" d=\"M25.94 27.771s-3.167 1.384-8.752-.938l4.979 2.504 3.773-1.566z\"/><linearGradient id=\"U\" gradientUnits=\"userSpaceOnUse\" x1=\"-465.214\" y1=\"929.332\" x2=\"-447.092\" y2=\"926.85\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#U)\" d=\"M24.409 28.66s-4.22 1.635-12.345-.799l6.949 2.765c.861-.795 5.396-1.966 5.396-1.966z\"/><linearGradient id=\"V\" gradientUnits=\"userSpaceOnUse\" x1=\"-487.129\" y1=\"833.244\" x2=\"-475.332\" y2=\"831.628\" gradientTransform=\"matrix(.996 .09 .09 -.996 426.311 899.606)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#V)\" d=\"M27.49 27.318s-2.801.853-7.977-1.149l4.979 2.502c.526-.464 2.998-1.353 2.998-1.353z\"/><linearGradient id=\"W\" gradientUnits=\"userSpaceOnUse\" x1=\"-457.029\" y1=\"925.518\" x2=\"-467.666\" y2=\"926.609\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#W)\" d=\"M18.753 30.54s-2.082 1.728-7.414 1.798l4.611.151 2.803-1.949z\"/><linearGradient id=\"X\" gradientUnits=\"userSpaceOnUse\" x1=\"-495.902\" y1=\"803.548\" x2=\"-481.188\" y2=\"820.743\" gradientTransform=\"matrix(.995 .104 .104 -.995 420.84 891.22)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#X)\" d=\"M13.688 39.382S20.813 30.101 26.68 28c-2.955-.097-11.927 3.173-12.992 11.382z\"/><linearGradient id=\"Y\" gradientUnits=\"userSpaceOnUse\" x1=\"-384.188\" y1=\"835.447\" x2=\"-355.369\" y2=\"879.898\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#DE5C01\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#Y)\" d=\"M124.039 55.208s.768 17.22-23.152 41.141c-2.659 2.658-17.093 16.18-16.585 20.236.178 1.435 37.87-5.781 39.737-61.377z\"/><linearGradient id=\"Z\" gradientUnits=\"userSpaceOnUse\" x1=\"-367.43\" y1=\"929.703\" x2=\"-386.301\" y2=\"937.991\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#F79A09\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#Z)\" d=\"M77.663 14.705c28.813 2.214 34.391 22.931 34.393 21.662.074-20.139-27.335-21.669-34.393-21.662z\"/><linearGradient id=\"aa\" gradientUnits=\"userSpaceOnUse\" x1=\"-354.754\" y1=\"910.786\" x2=\"-381.173\" y2=\"935.312\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#DE5C01\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#aa)\" d=\"M86.438 22.581s19.974 4.083 25.607 25.254c.747 2.804-2.407-17.199-1.434-15.3.972 1.908-8.038-9.321-24.173-9.954z\"/><linearGradient id=\"ab\" gradientUnits=\"userSpaceOnUse\" x1=\"-460.091\" y1=\"836.71\" x2=\"-471.153\" y2=\"848.15\" gradientTransform=\"matrix(1 -.028 -.028 -1 593.415 868.62)\"><stop offset=\"0\" stop-color=\"#F79A09\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#ab)\" d=\"M94.42 22.063s18.039 3.761 18.218 32.381c.126 20.258 3.128 7.605 6.106 3.053 2.568-3.934.813-8.726.751-8.713-.009.002-1.299-3.729-.43-2.148.039.07-1.211-1.03-1.203-1.031.202-.031-.693-20.572-23.442-23.542z\"/><linearGradient id=\"ac\" gradientUnits=\"userSpaceOnUse\" x1=\"-359.183\" y1=\"896.737\" x2=\"-352.957\" y2=\"918.154\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#F79A09\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#ac)\" d=\"M114.733 25.94s6.479 16.878-.388 25.271c-2.241 2.739-2.492 16.772.246 15.483 2.745-1.291 2.149 7.452 1.789 8.446l-.006.031c.179.112 13.538-21.573-1.641-49.231z\"/><linearGradient id=\"ad\" gradientUnits=\"userSpaceOnUse\" x1=\"-507.61\" y1=\"782.982\" x2=\"-507.837\" y2=\"799.272\" gradientTransform=\"scale(1 -1) rotate(2.35 20479.11 15387.252)\"><stop offset=\"0\" stop-color=\"#F79A09\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#ad)\" d=\"M105.726 43.709s4.079 11.942-.192 20.479l3.231 7.215c2.369-5.82 5.387-18.131-3.039-27.694z\"/><linearGradient id=\"ae\" gradientUnits=\"userSpaceOnUse\" x1=\"-615.186\" y1=\"694.292\" x2=\"-603.965\" y2=\"716.393\" gradientTransform=\"scale(1 -1) rotate(4.07 10630.367 10445.371)\"><stop offset=\"0\" stop-color=\"#F79A09\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#ae)\" d=\"M112.899 42.289s2.821 18.954-7.357 36.065c.158 3.958-.537 7.54-1.49 10.491.444.583 1.037.982 1.82 1.052-.345.319-.689.618-1.022.901-.61.271-1.237.555-1.844.849l-.387.876a32.265 32.265 0 0 0 2.23-1.724c2.079-.919 3.95-1.631 3.946-1.636l-1.298.476c-.617.224-1.156.3-1.625.258 7.859-7.163 18.63-23.184 7.027-47.608zm-11.859 50.39c-.898.527-1.552 1.021-1.691 1.403-.104.278.509.117 1.568-.477.055-.319.1-.63.123-.926z\"/><linearGradient id=\"af\" gradientUnits=\"userSpaceOnUse\" x1=\"-343.207\" y1=\"938.701\" x2=\"-341.697\" y2=\"963.181\" gradientTransform=\"scale(1 -1) rotate(4.07 14466.179 6568.719)\"><stop offset=\"0\" stop-color=\"#DE5C01\"/><stop offset=\".736\" stop-color=\"#FEFD00\"/><stop offset=\".778\" stop-color=\"#FEFE26\"/><stop offset=\".837\" stop-color=\"#FFFE54\"/><stop offset=\".889\" stop-color=\"#FFFF76\"/><stop offset=\".932\" stop-color=\"#FFFF8B\"/><stop offset=\".961\" stop-color=\"#FFFF92\"/></linearGradient><path fill=\"url(#af)\" d=\"M100.345 62.484s8.025 22.841-17.623 44.257c-1.513 1.263 10.411.722 11.454.249 3.074-1.396 6.707-10.714 6.278-9.6-.425 1.115 11.91-16.469-.109-34.906z\"/><linearGradient id=\"ag\" gradientUnits=\"userSpaceOnUse\" x1=\"-414.032\" y1=\"838.941\" x2=\"-366.714\" y2=\"867.224\" gradientTransform=\"matrix(1 0 0 -1 472.5 957)\"><stop offset=\"0\" stop-color=\"#B9120D\"/><stop offset=\".078\" stop-color=\"#BB180D\"/><stop offset=\".182\" stop-color=\"#C0290C\"/><stop offset=\".301\" stop-color=\"#C8450A\"/><stop offset=\".431\" stop-color=\"#D36C08\"/><stop offset=\".571\" stop-color=\"#E29E05\"/><stop offset=\".715\" stop-color=\"#F4DA02\"/><stop offset=\".792\" stop-color=\"#FEFD00\"/><stop offset=\".814\" stop-color=\"#FEFD07\"/><stop offset=\".846\" stop-color=\"#FEFD1B\"/><stop offset=\".884\" stop-color=\"#FEFE3C\"/><stop offset=\".927\" stop-color=\"#FFFE69\"/><stop offset=\".974\" stop-color=\"#FFFFA3\"/><stop offset=\"1\" stop-color=\"#FFFFC7\"/></linearGradient><path fill=\"url(#ag)\" d=\"M111.568 76.972s-4.84 29.626-38.309 32.011c-13.104.935-31.921-2.133-30.254 2.866.517 1.549 2.98 8.011 8.602 9.509 15.214 4.059 55.693 2.73 59.961-44.386z\"/><linearGradient id=\"ah\" gradientUnits=\"userSpaceOnUse\" x1=\"-451.41\" y1=\"752.749\" x2=\"-402.936\" y2=\"746.182\" gradientTransform=\"matrix(.995 .099 .099 -.995 429.966 890.404)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#ah)\" d=\"M83.656 99.393s-20.478 4.678-33.744-6.615c-12.139-10.335-6.117-1.637-4.47 2.654 1.691 4.401-7.823 1.039-9.252.331-1.425-.699 22.534 14.327 47.466 3.63z\"/><linearGradient id=\"ai\" gradientUnits=\"userSpaceOnUse\" x1=\"-478.422\" y1=\"705.757\" x2=\"-422.136\" y2=\"688.067\" gradientTransform=\"matrix(.99 .145 .145 -.99 411.248 860.68)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#ai)\" d=\"M70.46 110.554S46.032 105.753 38.298 89.2c-6.609-14.141-4.86-3.764-5.158.959-.313 4.858-7.163-1.776-8.078-2.93l-.046-.042c-.136.089 12.599 20.054 45.444 23.367z\"/><linearGradient id=\"aj\" gradientUnits=\"userSpaceOnUse\" x1=\"-986.556\" y1=\"507.388\" x2=\"-959.793\" y2=\"456.149\" gradientTransform=\"scale(1 -1) rotate(10.37 2796.5 5770.96)\"><stop offset=\".056\" stop-color=\"#DE7210\"/><stop offset=\"1\" stop-color=\"#F6C08F\"/></linearGradient><path fill=\"url(#aj)\" d=\"M43.775 108.414s-11.667-9.037-16.928-21.429c-4.421-1.536-10.298-5.046-10.414-5.648 1.867 9.629 11.699 20.871 27.342 27.077z\"/></svg>"

/***/ }),

/***/ "../src/components/firefox/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FirefoxOriginal = __webpack_require__("../src/components/firefox/original/FirefoxOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FirefoxOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/firefox/plain-wordmark/FirefoxPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _FirefoxPlainWordmark = __webpack_require__("../src/components/firefox/plain-wordmark/FirefoxPlainWordmark.svg");
	
	var _FirefoxPlainWordmark2 = _interopRequireDefault(_FirefoxPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** FirefoxPlainWordmark */
	function FirefoxPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'FirefoxPlainWordmark',
	    svg: _FirefoxPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	FirefoxPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = FirefoxPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/firefox/plain-wordmark/FirefoxPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DD732A\" d=\"M14.782 41.322l-2.794 2.237c-.414-1.684-.04-3.155.395-4.579.897-2.942 2.48-5.541 4.282-8.01.653-.896 1.119-1.781 1.099-2.987-.074-4.268.378-8.484 1.841-12.531.746-2.064 1.754-3.985 3.477-5.652.68 3.32 1.296 6.51 3.111 8.903 1.31-1.162 2.621-2.268 3.867-3.44C37.544 8.225 46.354 3.828 56.51 2.38c12.738-1.816 24.495.916 35.167 8.184 1.008.687 2.166 1.156 3.265 1.703 5.054 2.51 8.869 6.246 11.258 11.383.401.86.712 1.761 1.064 2.643l.318-.055-1.375-8.242c5.509 7.732 7.247 16.313 7.717 25.317 1.029-1.436 1.021-3.137 1.579-4.763.183 1.182.412 2.359.542 3.546.508 4.666-.396 9.191-1.256 13.748-2.029 10.764-6.691 20.29-13.717 28.569-8 9.427-17.993 15.721-30.492 17.214-18.138 2.167-33.375-3.661-45.681-17.148-5.905-6.47-9.81-14-11.558-22.575-1.323-6.491-1.004-12.946 1.15-19.261l.337-.968-.046-.353zm82.112-8.608l.344-.296 3.873 2.991c-.051-.908-.012-1.863-.169-2.783-.69-4.016-3.124-6.927-6.148-9.424-3.791-3.13-8.141-5.284-12.649-7.153-.443-.184-.878-.389-1.315-.584l.054-.454 6.355-.376c-2.348-3.875-6.383-4.956-10.471-6.067l.509-.27C68.99 5.71 60.778 5.507 52.503 7.624 44.807 9.593 33.25 16.61 31.464 20.396l.521-.127c2.904-.713 5.805-.909 8.73-.061.318.092.849-.119 1.124-.366 2.741-2.454 5.789-4.376 9.32-5.464 1.113-.343 2.26-.571 3.391-.851-.094.383-.264.538-.453.668-3.661 2.517-6.129 5.826-6.817 10.306-.037.246 0 .615.157.763 1.622 1.525 3.231 3.068 4.94 4.491.59.491 1.423.821 2.19.942 1.48.236 2.993.28 4.492.385.922.065 1.52.717 1.189 1.463-.491 1.112-1.025 2.144-2.151 2.895-2.129 1.421-4.1 3.081-6.154 4.617-.512.384-.533.733-.266 1.3.492 1.048.962 2.123 1.277 3.233.399 1.404.535 2.855.17 4.34-1.16-.256-2.223-.509-3.292-.721-1.075-.213-2.158-.379-3.234-.578-1.347-.247-2.496.225-3.186 1.323-.801 1.274-.813 2.605.042 3.696 1.745 2.222 3.721 4.215 6.053 5.824 1.93 1.333 4.1 2.074 6.41 1.58 1.607-.343 3.182-1.032 4.646-1.805 4.436-2.343 9.439-1.553 12.508 2.094.549.651.878 1.391.412 2.156-.448.735-1.199.908-2.063.691-.897-.225-1.727-.07-2.537.468-2.139 1.42-4.239 2.931-6.507 4.116-3.654 1.91-7.635 2.553-11.748 2.4-.422-.016-.845-.002-1.417-.002l.38.447c2.97 2.88 6.375 5.093 10.304 6.389 4.327 1.426 8.75 2.011 13.239.771 5.031-1.389 8.983-4.438 12.364-8.289 1.362-1.553 2.598-3.217 3.892-4.829l.324.07-1.142 7.793c6.203-7.589 6.4-16.264 5.528-25.412 1.784 1.988 2.326 4.318 3.35 6.654 2.09-7.251 1.056-14.158-.556-21.052z\"/><path fill=\"#DD732A\" d=\"M26.877 109.18v4.908h5.39v3.121h-5.39v7.337h-4.375v-18.489h11.019l-.454 3.123h-6.19zm13.219-5.59c.472.453.708 1.027.708 1.721s-.236 1.267-.708 1.721c-.471.453-1.071.68-1.8.68-.73 0-1.326-.227-1.787-.68-.463-.454-.694-1.027-.694-1.721s.231-1.268.694-1.721c.461-.454 1.057-.68 1.787-.68.728 0 1.329.226 1.8.68zm-3.881 20.956v-14.167h4.215v14.167h-4.215zm16.62-14.379l-.667 4.082c-.533-.125-.96-.187-1.28-.187-.836 0-1.472.289-1.907.867-.437.578-.778 1.445-1.027 2.602v7.016h-4.216V110.38h3.683l.347 2.748c.319-.977.804-1.747 1.453-2.307.649-.561 1.384-.84 2.201-.84.516-.001.986.061 1.413.186zm13.605 8.536h-8.776c.142 1.192.479 2.027 1.014 2.508.533.48 1.271.721 2.214.721.569 0 1.12-.103 1.654-.307.533-.205 1.111-.521 1.734-.947l1.733 2.348C64.36 124.342 62.519 125 60.491 125c-2.294 0-4.055-.675-5.282-2.027-1.227-1.352-1.841-3.166-1.841-5.442 0-1.441.258-2.735.774-3.882.516-1.147 1.271-2.054 2.268-2.721.995-.667 2.188-1 3.574-1 2.045 0 3.646.64 4.803 1.92 1.155 1.28 1.733 3.06 1.733 5.335.001.587-.026 1.093-.08 1.52zm-4.054-2.721c-.035-2.169-.8-3.255-2.294-3.255-.729 0-1.294.267-1.694.8-.4.534-.646 1.415-.733 2.641h4.722v-.186zm11.737-8.137c-.267.285-.399.766-.399 1.441v1.093h3.335l-.454 2.936h-2.881v11.231h-4.215v-11.231h-2.135v-2.936h2.135v-1.253c0-1.423.466-2.583 1.4-3.482.934-.898 2.271-1.347 4.015-1.347 1.405 0 2.694.303 3.868.907l-1.146 2.748a4.907 4.907 0 0 0-2.215-.534c-.606 0-1.04.143-1.308.427zm15.287 4.068c1.227 1.326 1.841 3.18 1.841 5.563 0 1.513-.28 2.833-.84 3.962-.561 1.129-1.361 2.005-2.401 2.628-1.041.622-2.272.933-3.695.933-2.151 0-3.846-.662-5.082-1.987-1.236-1.324-1.854-3.179-1.854-5.562 0-1.512.28-2.833.841-3.961.561-1.13 1.36-2.006 2.401-2.628 1.04-.623 2.271-.934 3.694-.934 2.169 0 3.868.662 5.095 1.986zm-7.016 2.188c-.427.721-.641 1.837-.641 3.349 0 1.547.21 2.677.627 3.388.419.711 1.063 1.067 1.935 1.067.854 0 1.494-.359 1.921-1.08s.64-1.836.64-3.349c0-1.547-.209-2.676-.626-3.388-.418-.711-1.063-1.067-1.935-1.067-.854 0-1.495.36-1.921 1.08zm18.328 10.445l-2.454-5.309-2.401 5.309h-4.589l4.563-7.443-4.108-6.724h4.722l1.975 4.536 1.895-4.536h4.481l-3.868 6.59 4.563 7.577h-4.779z\"/></svg>"

/***/ }),

/***/ "../src/components/firefox/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FirefoxPlainWordmark = __webpack_require__("../src/components/firefox/plain-wordmark/FirefoxPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FirefoxPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/firefox/plain/FirefoxPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _FirefoxPlain = __webpack_require__("../src/components/firefox/plain/FirefoxPlain.svg");
	
	var _FirefoxPlain2 = _interopRequireDefault(_FirefoxPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** FirefoxPlain */
	function FirefoxPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'FirefoxPlain',
	    svg: _FirefoxPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	FirefoxPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = FirefoxPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/firefox/plain/FirefoxPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DD732A\" d=\"M7.275 51.747l-3.221 2.579c-.477-1.941-.046-3.636.455-5.277 1.034-3.391 2.858-6.386 4.936-9.232.753-1.032 1.29-2.053 1.267-3.443-.085-4.919.436-9.778 2.122-14.443.86-2.379 2.022-4.592 4.008-6.514.783 3.826 1.493 7.503 3.586 10.261 1.51-1.339 3.021-2.613 4.457-3.965 8.624-8.111 18.778-13.179 30.482-14.847 14.681-2.093 28.23 1.056 40.53 9.432 1.162.792 2.496 1.333 3.763 1.962 5.825 2.893 10.222 7.198 12.976 13.119.462.991.82 2.03 1.227 3.046l.366-.063-1.584-9.499c6.35 8.911 8.353 18.801 8.895 29.179 1.186-1.655 1.177-3.615 1.819-5.49.211 1.362.475 2.719.624 4.087.586 5.377-.457 10.593-1.447 15.845-2.339 12.405-7.712 23.385-15.81 32.926-9.22 10.864-20.737 18.118-35.143 19.84-20.904 2.498-38.465-4.219-52.648-19.764C12.129 94.031 7.628 85.353 5.613 75.47c-1.524-7.481-1.157-14.921 1.326-22.198l.389-1.116c.022-.065-.016-.15-.053-.409zm94.636-9.92l.396-.342 4.464 3.447c-.059-1.046-.014-2.147-.195-3.208-.795-4.628-3.6-7.983-7.086-10.862-4.369-3.608-9.383-6.09-14.579-8.244-.511-.212-1.012-.449-1.516-.674l.062-.522 7.325-.434c-2.706-4.465-7.356-5.711-12.068-6.993l.587-.311c-9.55-2.982-19.015-3.216-28.551-.776-8.871 2.27-22.19 10.357-24.248 14.72l.6-.146c3.348-.822 6.69-1.048 10.062-.07.367.106.979-.137 1.295-.421 3.159-2.829 6.672-5.044 10.742-6.297 1.282-.395 2.604-.658 3.908-.981-.108.441-.305.621-.521.77-4.22 2.9-7.064 6.714-7.857 11.877-.043.283 0 .708.181.879 1.869 1.758 3.724 3.537 5.693 5.176.681.566 1.641.946 2.524 1.086 1.706.271 3.449.322 5.178.444 1.063.075 1.751.826 1.37 1.687-.565 1.282-1.182 2.471-2.479 3.336-2.454 1.638-4.726 3.551-7.093 5.322-.591.443-.614.845-.307 1.499.567 1.208 1.109 2.447 1.473 3.727.46 1.618.616 3.291.196 5.002-1.337-.295-2.562-.586-3.794-.831-1.238-.246-2.486-.438-3.728-.667-1.552-.285-2.876.259-3.672 1.524-.923 1.468-.938 3.002.049 4.26 2.011 2.561 4.288 4.858 6.977 6.712 2.225 1.536 4.726 2.39 7.388 1.82 1.853-.396 3.668-1.189 5.354-2.081 5.112-2.701 10.879-1.79 14.416 2.414.633.751 1.012 1.603.475 2.485-.516.847-1.382 1.046-2.377.797-1.034-.259-1.99-.081-2.924.539-2.465 1.636-4.886 3.378-7.5 4.744-4.211 2.201-8.8 2.942-13.539 2.766-.488-.016-.976 0-1.635 0 .244.289.331.412.438.515 3.423 3.319 7.347 5.87 11.876 7.363 4.987 1.644 10.084 2.317 15.258.888 5.799-1.601 10.354-5.114 14.25-9.553 1.57-1.79 2.994-3.707 4.485-5.565l.373.081-1.316 8.981c7.149-8.746 7.377-18.745 6.371-29.287 2.057 2.291 2.681 4.977 3.86 7.669 2.408-8.36 1.217-16.32-.641-24.265z\"/></svg>"

/***/ }),

/***/ "../src/components/firefox/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FirefoxPlain = __webpack_require__("../src/components/firefox/plain/FirefoxPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FirefoxPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/foundation/original-wordmark/FoundationOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _FoundationOriginalWordmark = __webpack_require__("../src/components/foundation/original-wordmark/FoundationOriginalWordmark.svg");
	
	var _FoundationOriginalWordmark2 = _interopRequireDefault(_FoundationOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** FoundationOriginalWordmark */
	function FoundationOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'FoundationOriginalWordmark',
	    svg: _FoundationOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	FoundationOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = FoundationOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/foundation/original-wordmark/FoundationOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D3EDF6\" d=\"M29.205 103.762c.019.297-.12.355-.342.197-.47-.335-.998-.624-1.378-1.045-1.907-2.106-3.288-4.511-3.941-7.3-.266-1.137-.285-2.275-.2-3.448.162-2.252 0-4.498-.606-6.69-.041-.146-.131-.278-.29-.607l-1.155 1.409-.139-.084c.035-3.245-.076-6.48-.656-9.719l-1.278 3.021-.212-.037c-.094-.483-.2-.965-.282-1.45-.481-2.843-.563-5.717-.403-8.578.247-4.425.977-8.766 3.038-12.77.58-1.126 1.281-2.177 2.215-3.137-.477.144-.961.268-1.43.437-.492.177-.968.397-1.555.641.614-1.613 1.43-3.028 2.491-4.287 1.047-1.242 2.166-2.425 3.295-3.681l-2.622-.979-.185-.174c.182-.096.38-.168.542-.291 2.56-1.94 5.488-3.045 8.569-3.814.979-.244.808-.062.876-1.086.111-1.657.292-3.31.444-4.965l.151-.013 2.249 4.28c-.245-6.564.227-13.029 2.041-19.35l.154-.002c.011.211.039.423.031.633-.054 1.386.082 2.738.637 4.029.385.896.947 1.633 1.866 2.192.384-3.874 1.419-7.541 2.639-11.271l1.828 2.061a30.598 30.598 0 0 1 1.758-7.444l2.603 3.315 1.543-7.301 1.096 2.403c-.077 3.817 1.789 6.741 4.405 9.4l-2.895 1.462c3.035-.247 5.217-1.294 6.772-3.231.459-.719.991-1.403 1.361-2.165.556-1.144.514-1.175-.531-1.875-2.793-1.872-4.687-4.412-5.688-7.619 1.194-1.534 2.853-2.334 4.581-2.943l.221 3.428 1.121-.594c2.869-1.58 5.923-2.642 9.131-3.271.617-.121 1.24-.205 1.863-.295.071-.011.153.051.229.08l-3 2.392C69.071 4.5 68.2 5.57 67.443 6.741l-.105.106-.002.105c-.108.112-.249.207-.319.338-.571 1.067-1.161 2.127-1.68 3.22-.302.637-.484 1.331-.73 2.028l4.821.459.085.185c-3.464 3.119-6.934 6.232-10.153 9.737l3.448.472c-.978.4-1.857.704-2.687 1.111-2.415 1.185-4.672 2.579-6.305 4.807-1.264 1.725-2.577 3.415-3.868 5.119l-3.032-3.041-.774 3.535 2.152 1.938-.341.655c-.672 1.412-1.402 2.8-1.995 4.245-.618 1.505-.757 3.127-.872 4.741-.132 1.854-.339 3.704-.397 5.56-.07 2.249-.083 4.503.296 6.737.333 1.967.589 3.949.98 5.903.241 1.207.673 2.375 1.02 3.561l.146-.029 1.436-2.881.144.037c.519 2.485 1.256 4.902 2.313 7.207 1.052 2.294 2.264 4.496 4.172 6.276v-3.04l.211.002c.39.204.782.405 1.164.623a67.073 67.073 0 0 0 8.32 4.011c3.467 1.386 6.919 2.807 10.212 4.576 1.02.548 2.045 1.132 2.936 1.861 2.022 1.656 3.962 3.413 5.936 5.129l-.164.386c-.646 1.293-1.304 2.58-1.94 3.877-.563 1.146-1.103 2.302-1.652 3.453l-.143-.021v-3.991c-.227.512-.317 1.031-.455 1.536a557.875 557.875 0 0 1-1.702 6.146c-.175.616-.617.972-1.223 1.213-.71.281-1.373.191-2.054-.023l.006.004-.197-.091c-1.035-.771-2.068-1.543-3.105-2.31-.265-.195-.543-.372-.805-.551l.375 3.818-.199.103c-4.23-3.448-9.404-5.158-14.093-7.761-1.524-.97-3.053-1.934-4.57-2.915-.405-.262-.773-.579-1.249-.939l.232 1.879-.127.09-4.333-2.975c.076-.591.189-1.179.22-1.771.056-1.081.19-2.179.067-3.244-.298-2.573-1.634-4.545-3.769-6.008a28.963 28.963 0 0 1-2.501-1.927c-.439-.377-.779-.877-.876-1.419l2.49.223c-.74-1.381-1.478-2.603-2.063-3.894-.586-1.294-1.144-2.628-1.073-4.266.436.592.719 1.143 1.367 1.405-.222-2.183.097-4.249.452-6.298.354-2.047.847-4.071 1.279-6.105-1.509 2.643-3.049 5.264-3.512 8.455l-1.246-1.312c-.055.791-.159 1.506-.143 2.219.035 1.599.096 3.198.208 4.792.128 1.819.625 3.552 1.343 5.229.819 1.915 2.222 3.404 3.521 4.974.826.998 1.534 2.078 1.722 3.391.203 1.42.336 2.851.5 4.277l.329 4.827c-.945.195-3.583-.443-4.137-1.044l.444-.237c-.475-.41-.999-.768-1.398-1.232-.607-.706-.725-1.617-.867-2.509-.037-.229-.222-.434-.339-.649-.221.2-.511.364-.641.612-.108.208-.082.525-.023.772.109.46.25.92.44 1.352.577 1.304 1.202 2.586 1.773 3.893.701 1.603 1.278 3.242 1.239 5.029-.012.523-.119.623-.601.43a22.976 22.976 0 0 1-1.913-.884c-.491-.251-.955-.554-1.491-.869v.563l-.043.037c-.153-.077-.327-.129-.457-.235-.552-.451-1.091-.919-1.635-1.38l.004.005-.11-.222-.975-2.424-.089.357-.157.331c-.731-1.342-1.117-2.685-1.315-4.099-.356 1.21.025 2.362.185 3.6l.321-.349c.277.56.518 1.103.809 1.616.294.518.62 1.021.969 1.503.177.244.436.431.657.644.514 1.295 1.043 2.584 1.302 4.1l-2.784-.825c-1.123-.503-2.271-.961-3.173-1.844l-.196-.062-.041-.139-.041.027.079.113.925 1.93-.066.136-1.446-.505-.896-.29-.045-.024.045.024zm1.132-1.745l-1.089-2.627-.358.243-.731-3.423c-.7 1.341.676 5.166 2.178 5.807zm11.975-42.722l-.015-.044-.038.01.015.045.038-.011z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E9F5FA\" d=\"M83.972 92.034c-1.974-1.716-3.914-3.473-5.936-5.129-.89-.729-1.916-1.313-2.936-1.861-3.293-1.769-6.745-3.189-10.212-4.576a67.147 67.147 0 0 1-8.32-4.011c-.382-.218-.773-.419-1.164-.623l-.211-.002v3.04c-1.908-1.78-3.12-3.982-4.172-6.276-1.057-2.305-1.795-4.722-2.313-7.207l-.144-.037-1.436 2.881-.146.029c-.347-1.186-.778-2.354-1.02-3.561-.392-1.955-.647-3.937-.98-5.903-.379-2.234-.366-4.488-.296-6.737.058-1.855.265-3.706.397-5.56.115-1.614.254-3.235.872-4.741.593-1.445 1.323-2.833 1.995-4.245l.341-.655.213.156c1.346 1.108 2.706 2.201 4.025 3.339.251.217.44.602.493.936.102.641.093 1.3.115 1.952.037 1.093.32 1.558 1.352 1.888 3.524 1.126 7.112 1.763 10.833 1.329 1.036-.121 1.903-.513 2.506-1.383a65.944 65.944 0 0 0 1.55-2.333c.57-.903.725-.964 1.769-.806.47.071.623.29.612.729-.017.669-.003 1.339-.011 2.009-.017 1.49.802 2.342 2.167 2.657 1.163.269 2.352.465 3.539.576 1.505.141 3.029.277 4.499-.281-.359.93-.715 1.862-1.079 2.79-.16.408-.306.826-.51 1.212-.299.564-.396 1.07.209 1.494l.11.117-.001-.003.289.553c.681 1.387 1.438 2.743 2.022 4.169.92 2.25 1.247 4.636 1.311 7.058.104 2.845-.439 5.573-1.512 8.197-.313.763-.59 1.601-1.114 2.204-2.363 2.72-5.368 3.957-8.988 3.584l-1.043-.121a.52.52 0 0 0 .24.243c2.436 1.417 4.872 2.835 7.31 4.249.132.076.286.114.429.169.456.4.914.796 1.366 1.2l2.155 1.938.166.116c.73-.63 1.431-1.265 2.165-1.86 2.168-1.76 4.552-3.157 7.1-4.309 1.859-.84 3.651-1.829 5.473-2.751.107-.054.216-.103.477-.088l-.651 2.487-.142.501-.044.024.02.02.024-.044c.845-.4 1.714-.756 2.526-1.215.674-.38 1.28-.882 1.917-1.329-.121.271-.219.556-.367.813-1.101 1.916-2.571 3.529-4.173 5.028-.456.426-.947.814-1.484 1.272l.137-2.422c-2.349 1.954-4.316 4.053-6.221 6.217l-.143-.046-.198-2.84c-2.073 1.866-4.12 3.615-5.757 5.779zM56.075 48.828c.031.292.036.501.077.703.289 1.458 1.119 2.577 2.264 3.468 2.361 1.836 5.124 2.712 8.019 3.196 2.609.436 5.246.253 7.874.185l.46-.083-.604-1.263c-.3-.615-.615-1.223-.901-1.846-.207-.451-.066-.765.363-1.062.904-.625 1.76-1.321 2.672-2.015a3.847 3.847 0 0 0-2.205-.88c-2.249-.173-4.501-.348-6.754-.386-3.722-.063-7.445-.017-11.265-.017zm11.841 15.338l.208-.042c.302-.61.645-1.204.896-1.833.309-.774.6-1.513 1.471-1.85.472-.182.901-.477 1.349-.721l-.043-.167c-3.907.242-7.735-.184-11.583-1.428.103 1.651.521 3.049 1.21 4.455l1.485-1.654c.467 1.262.78 2.49 1.729 3.555l1.816-2.683 1.462 2.368zm3.487 14.667l-.01-.031-.045-.009.013.053.042-.013zM49.944 34.429c1.292-1.705 2.605-3.394 3.869-5.119 1.632-2.228 3.89-3.623 6.305-4.807.829-.407 1.709-.71 2.687-1.111l-3.448-.472c3.22-3.504 6.689-6.618 10.153-9.737l-.085-.185-4.821-.459c.247-.697.428-1.392.73-2.028.519-1.093 1.108-2.152 1.68-3.22.071-.132.211-.226.319-.338.179.071.352.167.537.208l7.85 1.689c.713.154.724.158.724-.606V4.307c.861-.236 1.714-.515 2.586-.699 2.02-.428 4.044-.837 6.076-1.2 1.013-.181 2.046-.245 3.155-.372l-2.148 3.709.121.086c.913-.27 1.816-.589 2.743-.793.933-.206 1.891-.296 2.928-.451v1.508c2.547-.316 5-.263 7.52.215l-.422.86c-.43.926-.853 1.855-1.285 2.779-.185.394-.092.61.345.736 1.028.296 2.047.627 3.068.948.199.063.391.146.666.251-.442.539-.865 1.019-1.25 1.529-1.087 1.442-2.16 2.896-3.233 4.349-.06.081-.074.195-.109.293l-2.165 3.373c-.661 1.123-1.324 2.244-1.976 3.372-.047.082-.014.21-.019.318-.324.471-.695.917-.962 1.418-1.258 2.363-2.526 4.722-3.716 7.119-1.166 2.349-2.244 4.742-3.355 7.118-.065.141-.083.303-.123.456l-5.366-1.098c-.587-.801-1.459-.874-2.125-.176-1.495.048-2.991.121-4.487.133-.768.006-1.557-.007-2.301-.171-2.301-.508-4.586-1.093-6.877-1.648-.378-.917-1.692-1.058-2.336-.479l-.158-.005c-2.839-.484-5.69-.817-8.58-.701-.134.006-.309-.083-.405-.184-.778-.814-1.542-1.645-2.31-2.471zm9.765 1.653l.283-.123c1.221-.639 2.488-1.024 3.886-.74.271.055.551.069.877.108-.821-1.252-2.891-1.363-4.038-.619-.498.325-.98.689-1.008 1.374l-.025.044.025-.044zm5.261-2.811c-.492-1.18-2.046-1.765-3.437-1.382-1.167.321-2.266 1.57-2.145 2.543 1.559-1.758 3.441-1.915 5.582-1.161zm15.344 2.253c1.517.142 2.833.642 3.773 1.976.067-1.103-.361-1.749-1.253-2.238-.835-.458-1.852-.331-2.52.262zm2.676 4.235c-.128-1.228-.512-2.22-1.733-2.57-.629-.18-1.264-.077-1.798.43 1.599.442 2.165.491 3.531 2.14z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#B3E0EE\" d=\"M84.303 65.018c-.064-2.422-.39-4.808-1.311-7.058-.584-1.427-1.341-2.783-2.022-4.169l-.289-.553c.519.156 1.035.325 1.558.465.762.205 1.521.441 2.298.56.415.063.864-.086 1.295-.151.166-.025.328-.083.586-.152l-.21 1.039c1.735-.807 2.989-2.045 4.004-3.496 1.011-1.445 1.875-2.993 2.785-4.467l.408.684c.733-1.146.228-4.532-.981-6.547.307 0 .561-.018.812.003 1.59.129 3.212.114 4.651.966 1.141.675 1.955 1.633 2.501 2.897l-1.218-.068c1.214 1.964 1.681 3.998 1.49 6.325l-.938-.746c-.045.223-.077.452-.139.672-.188.66-.394 1.314-.576 1.975-.049.176-.034.37-.049.555.197.006.415.068.588.006.994-.353 1.977-.737 2.965-1.108.412-.154.832-.29 1.239-.458.43-.176.59-.023.56.41-1.119.39-2.239.777-3.355 1.172-.143.051-.273.138-.41.208 1.415-.157 1.976-.082 2.699.423.527.368.604.825.135 1.272-.363.347-.799.622-1.22.903-.253.168-.539.287-.888.47l.486.184c-.771.506-1.514.942-2.197 1.457-.85.639-1.703 1.291-2.457 2.037-.601.594-.417 1.008.423 1.075 1.032.083 2.07.087 3.105.123l.665.001-.49.635-.024.041.021-.044c.388 0 .781.038 1.162-.015.239-.034.575-.147.665-.326.195-.389.509-.438.853-.502.671-.127 1.345-.239 2.011-.39.533-.12 1.055-.288 1.583-.435l.078.11-1.179 1.099-.176-.648c-1.871.86-3.718 1.638-5.494 2.555-.857.442-1.58 1.144-2.363 1.729l-.043.049.049-.043.502.036-1.964 1.657c.313.272.564.631.901.753.635.231 1.313.41 1.983.458 1.011.072 2.032.013 3.049.01l.027-.223-.795-.326 4.054-.488c-2.765 1.702-5.958 1.523-9.016 2.036.005.827.698 1.216 1.141 1.785l-.33.273.959.806c.183.287.015.308-.223.32-1.765.088-3.472-.21-5.109-.841-.998-.384-1.952-.882-2.927-1.323l-.303-.065-.015-.039-.03-.008.043.05.425.952c-.563-.106-1.121-.269-1.688-.307-1.314-.088-2.557.275-3.78.713l-.448.135c.035-.454.099-.906.1-1.359.004-1.84-.008-3.68-.026-5.52-.002-.071-.115-.14-.176-.209z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#65C1DD\" d=\"M83.972 92.034c1.637-2.164 3.684-3.913 5.754-5.778l.198 2.84.143.046c1.905-2.164 3.872-4.263 6.221-6.217l-.137 2.422c.537-.458 1.029-.846 1.484-1.272 1.602-1.5 3.073-3.112 4.173-5.028.147-.256.246-.541.367-.813l.104-.005.016.014c-.354 1.156-.67 2.324-1.071 3.463-.876 2.494-2.535 4.529-3.959 6.707-1.434 2.191-2.747 4.463-4.103 6.704-.105.174-.136.393-.202.591l-.042.061.056-.047c.623-.322 1.243-.647 1.868-.966.575-.294 1.154-.581 1.824-.781l-.426.802c-1.486 2.862-2.957 5.733-4.465 8.585-.601 1.136-1.27 2.237-1.95 3.328-.118.189-.442.352-.672.353-3.017.019-6.035-.047-9.05.017-2.183.046-3.839-.979-5.394-2.314l-.072-.135c.682.215 1.344.305 2.054.023.606-.241 1.048-.597 1.223-1.213a548.176 548.176 0 0 0 1.702-6.146c.137-.505.228-1.024.455-1.536v3.991l.143.021c.55-1.151 1.09-2.308 1.652-3.453.636-1.297 1.294-2.584 1.94-3.877l.166-.387z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#65C2DD\" d=\"M46.573 92.961l4.333 2.975.127-.09-.232-1.879c.475.36.844.678 1.249.939 1.517.981 3.046 1.945 4.57 2.915l-3.239.883c3.778 1.617 7.187 3.898 8.825 8.215-1.113.074-2.128.162-3.145.206-2.185.095-4.37.186-6.556.246-3.156.089-6.313.148-9.47.223-.917.021-1.834.04-2.75.076-1.458.059-2.603-.503-3.439-1.699l-.354-.442-1.01.701c-.599-.51-1.111-1.09-1.423-1.835l2.784.825c-.259-1.516-.789-2.805-1.302-4.1l-.299-.963c.544.461 1.083.929 1.635 1.38.13.106.304.158.458.235l.072.116-.03-.153v-.563c.536.315 1 .618 1.491.869a23.15 23.15 0 0 0 1.913.884c.482.193.589.094.601-.43.039-1.787-.539-3.427-1.239-5.029-.571-1.307-1.196-2.589-1.773-3.893a7.88 7.88 0 0 1-.44-1.352c-.059-.247-.085-.564.023-.772.13-.248.42-.412.641-.612.117.216.302.421.339.649.142.892.26 1.803.867 2.509.399.465.924.822 1.398 1.232l-.444.237c.554.601 3.192 1.239 4.137 1.044l-.329-4.827.317.165 1.694 1.115z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#EBF7FE\" d=\"M98.458 72.518l-.959-.806.33-.273c-.442-.569-1.135-.958-1.141-1.785 3.058-.513 6.25-.333 9.016-2.036l-4.054.488.795.326-.027.223c-1.017.003-2.038.062-3.049-.01-.671-.048-1.349-.228-1.983-.458-.337-.123-.588-.481-.901-.753l1.964-1.657-.502-.036-.006-.006c.784-.584 1.506-1.287 2.363-1.729 1.776-.917 3.623-1.695 5.494-2.555l.176.648L107.153 61l-.078-.11c-.527.146-1.05.314-1.583.435-.666.151-1.34.263-2.011.39-.344.064-.658.113-.853.502-.09.179-.426.292-.665.326-.38.053-.774.015-1.162.015l.003.003.49-.635-.665-.001c-1.036-.036-2.074-.039-3.105-.123-.841-.067-1.024-.481-.423-1.075.754-.746 1.607-1.397 2.457-2.037.683-.514 1.426-.951 2.197-1.457l-.486-.184c.35-.183.635-.301.888-.47.421-.281.857-.556 1.22-.903.468-.447.392-.905-.135-1.272-.723-.505-1.285-.58-2.699-.423.136-.07.267-.158.41-.208 1.117-.395 2.236-.783 3.355-1.172.913.037 1.836.001 2.737.128 1.239.174 1.897 1.138 2.577 2.035l-.074.135-1.245-.4c.739 1.262 1.402 2.447 1.448 3.907l-.221-.127-.131-.334c-.343.823-.506 1.53-.895 2.077-.656.924-.628 1.727-.139 2.727.35.714.364 1.593.528 2.398l-.206.082-.524-.646c-.065 1.108-.079 2.105-.625 3.011l-.238-.547c-.389.358-.776.683-1.118 1.051-.094.101-.094.337-.063.498.179.925.485 1.84.137 2.818l-.404-.189c-.566 1.243-1.589 1.874-2.857 2.014-1.377.152-2.733-.091-4.036-.583-.16-.063-.333-.093-.501-.138z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#515053\" d=\"M79.523 40.132l5.366 1.098.45.147c.367.121.503.378.394.739-.139.453-.269.915-.478 1.336a1.245 1.245 0 0 1-.586.552c-.407.171-.647.439-.825.828-.248.542-.499 1.092-.83 1.584-.297.442-.704.811-1.062 1.211-1.47.559-2.994.422-4.499.281a26.986 26.986 0 0 1-3.539-.576c-1.365-.315-2.183-1.167-2.167-2.657.007-.669-.006-1.339.011-2.009.011-.439-.142-.658-.612-.729-1.044-.158-1.198-.097-1.769.806a65.037 65.037 0 0 1-1.55 2.333c-.603.87-1.471 1.263-2.506 1.383-3.721.434-7.309-.203-10.833-1.329-1.032-.33-1.315-.794-1.352-1.888-.022-.652-.014-1.311-.115-1.952-.053-.333-.241-.718-.493-.936-1.319-1.139-2.679-2.231-4.025-3.339l-.213-.156-2.152-1.938.774-3.535 3.032 3.041c.768.826 1.531 1.657 2.309 2.474.096.101.271.189.405.184 2.889-.116 5.74.217 8.58.701l.158.005 2.336.479c2.292.555 4.576 1.14 6.877 1.648.744.164 1.533.177 2.301.171 1.496-.012 2.992-.085 4.487-.133l2.126.176zm-19.274-1.433c-1.564-.09-3.127-.21-4.692-.255-.628-.018-.983.34-1.058.962a58.604 58.604 0 0 0-.309 3.316c-.07 1.128.04 1.266 1.13 1.634 3.009 1.017 6.114 1.34 9.276 1.288 1.155-.02 2.005-.534 2.583-1.477.478-.778.885-1.602 1.282-2.426.346-.717.237-1.042-.53-1.295-1.168-.384-2.367-.675-3.552-1.006l-4.13-.741zm17.409 2.258l-.018.115c-.599 0-1.2-.025-1.798.008a14.05 14.05 0 0 0-1.57.193c-.684.117-1.119.519-1.186 1.225-.07.735-.13 1.474-.128 2.211.002 1.284.237 1.568 1.471 1.865 1.758.423 3.545.591 5.351.506.437-.021.871-.119 1.303-.202.573-.109.983-.413 1.218-.975.421-1.006.896-1.989 1.309-2.999.343-.84.259-1.06-.623-1.206-1.77-.293-3.552-.499-5.329-.741z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4F4E51\" d=\"M60.877 16.491c-1.555 1.938-3.737 2.984-6.772 3.231L57 18.26c-2.616-2.659-4.482-5.583-4.405-9.4.132-2.343.849-4.484 2.209-6.401.131-.185.295-.345.443-.517l.083.04.006.207c-.093.154-.234.298-.272.465-.532 2.323-.524 4.636.236 6.911.824 2.465 2.378 4.402 4.416 5.978.396.304.775.631 1.161.948z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#66C2DD\" d=\"M84.303 65.018c.061.069.174.138.174.208.018 1.839.03 3.679.026 5.52-.001.453-.065.905-.1 1.359-.389 1.601-.696 3.228-1.187 4.797-.761 2.436-2.021 4.63-3.592 6.642-.143-.056-.297-.093-.429-.169-2.438-1.414-4.874-2.832-7.31-4.249a.52.52 0 0 1-.24-.243l1.043.121c3.62.373 6.625-.864 8.988-3.584.524-.604.801-1.441 1.114-2.204 1.074-2.625 1.617-5.354 1.513-8.198z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#EBF7FD\" d=\"M76.443 4.308v3.937c0 .764-.011.76-.724.606-2.616-.568-5.234-1.123-7.85-1.689-.186-.04-.358-.137-.537-.208l.002-.105.105-.106c.757-1.17 1.628-2.241 2.724-3.115l3-2.392c-.006.177.026.366-.025.529-.232.749-.489 1.49-.786 2.382 1.454-.542 2.719-1.208 4.09-1.437l.001 1.598z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#737F84\" d=\"M60.877 16.491c-.386-.316-.765-.644-1.16-.95-2.038-1.576-3.592-3.513-4.416-5.978-.761-2.275-.769-4.588-.236-6.911.038-.167.179-.311.272-.465l.681 2.645c1.001 3.208 2.895 5.748 5.688 7.619 1.045.7 1.087.731.531 1.875-.369.761-.901 1.446-1.36 2.165z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4F4E51\" d=\"M93.045 25.119c.004-.107-.029-.236.019-.318.652-1.128 1.315-2.249 1.976-3.372 1.149-.235 2.319-.401 3.444-.72 2.502-.708 4.715-1.935 6.483-3.885l.648-.68c-.898 2.548-2.243 4.821-4.196 6.702-1.863 1.795-4.158 2.435-6.686 2.382-.563-.011-1.125-.071-1.688-.109z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#737F84\" d=\"M105.615 16.145l-.648.68c-1.769 1.951-3.981 3.178-6.483 3.885-1.125.318-2.295.485-3.444.72l2.165-3.373c3.063.494 5.751-.446 8.241-2.15l.353-.222-.184.46z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#65C1DD\" d=\"M102.279 78.229l.023-.148.048.013-.056.148-.015-.013zm-27.831 26.293l.197.091-.197-.091z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#B3E0EE\" d=\"M90.318 71.563l.044.024-.044-.024zM80.682 53.24l-.11-.117.11.117z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#737F84\" d=\"M55.248 1.941l.052-.059.032.098-.084-.039z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#B3E0EE\" d=\"M46.573 92.961c-.565-.372-1.129-.745-1.695-1.113l-.317-.165c-.164-1.426-.297-2.856-.5-4.277-.188-1.313-.896-2.394-1.722-3.391-1.299-1.57-2.702-3.06-3.521-4.974-.717-1.677-1.215-3.41-1.343-5.229a98.262 98.262 0 0 1-.208-4.792c-.016-.713.088-1.428.143-2.219l1.246 1.312c.463-3.191 2.002-5.812 3.512-8.455-.432 2.034-.924 4.058-1.279 6.105-.355 2.05-.674 4.116-.452 6.298-.648-.262-.932-.813-1.367-1.405-.071 1.638.486 2.971 1.073 4.266.585 1.291 1.322 2.512 2.063 3.894l-2.49-.223c.097.542.437 1.042.876 1.419a28.963 28.963 0 0 0 2.501 1.927c2.134 1.463 3.471 3.436 3.769 6.008.124 1.065-.011 2.163-.067 3.244-.033.592-.146 1.18-.222 1.77zm-11.331 7.197l.299.963c-.222-.213-.48-.399-.657-.644a16.23 16.23 0 0 1-.969-1.503c-.292-.514-.532-1.057-.809-1.616l-.321.349c-.16-1.237-.541-2.39-.185-3.6.198 1.414.584 2.757 1.315 4.099l.157-.331.089-.357.975 2.424.11.222-.004-.006z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#B4E1EE\" d=\"M30.337 102.017c-1.502-.641-2.878-4.466-2.178-5.807l.731 3.423.358-.243 1.089 2.627z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#B3E0EE\" d=\"M42.312 59.295l-.038.01-.015-.045.038-.01.015.045z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#65C2DD\" d=\"M35.246 100.163l-.11-.222.11.222z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E9F5FA\" d=\"M67.44 6.742l-.105.106.105-.106z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4F4E51\" d=\"M56.075 48.828c3.819 0 7.543-.045 11.265.017 2.253.038 4.506.213 6.754.386a3.847 3.847 0 0 1 2.205.88c-.912.694-1.768 1.39-2.672 2.015-.429.297-.569.61-.363 1.062.286.623.601 1.23.901 1.846l.604 1.263-.46.083c-2.628.068-5.265.25-7.874-.185-2.895-.484-5.658-1.359-8.019-3.196-1.145-.891-1.975-2.009-2.264-3.468-.041-.202-.046-.412-.077-.703z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D3EDF6\" d=\"M67.916 64.166l-1.462-2.368-1.816 2.683c-.949-1.065-1.262-2.293-1.729-3.555l-1.485 1.654c-.689-1.406-1.108-2.803-1.21-4.455 3.849 1.244 7.677 1.67 11.583 1.428l.043.167c-.448.244-.877.539-1.349.721-.871.337-1.162 1.076-1.471 1.85-.252.629-.594 1.224-.896 1.833l-.208.042z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#66C2DD\" d=\"M71.403 78.833l-.042.013-.013-.053.045.009.01.031z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D4EDF6\" d=\"M64.97 33.271c-2.141-.755-4.023-.597-5.581 1.161-.122-.973.978-2.222 2.145-2.543 1.39-.382 2.944.202 3.436 1.382zm-5.262 2.811c.028-.684.51-1.048 1.01-1.373 1.147-.745 3.216-.634 4.038.619-.326-.039-.606-.053-.877-.108-1.398-.284-2.666.101-3.886.74l-.285.122zm20.606-.558c.668-.593 1.685-.72 2.52-.263.893.489 1.321 1.136 1.253 2.238-.939-1.333-2.255-1.833-3.773-1.975z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#CDEBF4\" d=\"M82.99 39.759c-1.366-1.649-1.932-1.699-3.532-2.14.534-.507 1.169-.61 1.798-.43 1.222.351 1.605 1.343 1.734 2.57z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D4EDF6\" d=\"M59.709 36.082l-.025.044.025-.044z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#EBF7FE\" d=\"M100.803 62.559l-.021.044.024-.041-.003-.003zm-2.856 3.182l-.049.043.043-.049.006.006z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D3EDF6\" d=\"M37.376 101.736l.03.153-.072-.116.042-.037z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E8F4F8\" d=\"M64.378 39.439c1.186.331 2.384.622 3.552 1.006.768.252.876.578.53 1.295-.397.824-.805 1.648-1.282 2.426-.579.943-1.428 1.458-2.583 1.477-3.162.052-6.267-.271-9.276-1.288-1.09-.368-1.2-.506-1.13-1.634.069-1.107.177-2.213.309-3.316.075-.622.429-.98 1.058-.962 1.565.045 3.128.166 4.692.256l-.431 1.348a4.896 4.896 0 0 0-.199 3.046c.276 1.099 1.23 1.682 2.226 1.419.906-.239 1.897-1.426 1.992-2.383.467-.838.527-1.759.542-2.69z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#ECF5F9\" d=\"M77.658 40.957c1.777.242 3.56.448 5.328.742.882.146.966.366.623 1.206-.412 1.01-.888 1.993-1.309 2.999-.235.562-.646.865-1.218.975-.432.083-.867.181-1.303.202a18.968 18.968 0 0 1-5.351-.506c-1.233-.296-1.468-.581-1.471-1.865-.002-.737.059-1.477.128-2.211.067-.706.502-1.108 1.186-1.225.52-.088 1.044-.164 1.57-.193.598-.033 1.199-.008 1.798-.008l.019-.116zm2.358 2.217c-.088.187-.129.318-.205.425-.332.473-.611 1.005-1.025 1.393-.89.834-1.999.586-2.501-.526-.2-.444-.304-.932-.456-1.415-.115 1.275.009 2.173.382 2.801.375.631.901.875 1.6.743 1.242-.237 2.301-1.835 2.205-3.421zm-3.483-.241l-.102.097c.209.263.369.644.641.762.38.165.623-.208.8-.52a1.37 1.37 0 0 0 .155-.442c.087-.507-.143-1.034-.473-1.123-.361-.097-.791.271-.944.815l-.077.411z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#778287\" d=\"M59.817 40.047c.042.612.023 1.236.14 1.833.141.713.499 1.321 1.277 1.537.78.215 1.414-.074 1.965-.602.225-.215.424-.456.636-.686-.094.957-1.086 2.144-1.992 2.383-.995.263-1.95-.32-2.226-1.419a4.91 4.91 0 0 1 .2-3.046zm20.199 3.127c.097 1.585-.962 3.184-2.205 3.42-.698.133-1.224-.111-1.6-.743-.374-.628-.497-1.525-.382-2.801.152.483.255.971.456 1.415.502 1.112 1.611 1.361 2.501.526.414-.388.693-.92 1.025-1.393.075-.106.116-.237.205-.424z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#1C1C1C\" d=\"M76.533 42.933l.077-.411c.153-.544.583-.912.944-.815.33.089.56.616.473 1.123a1.362 1.362 0 0 1-.155.442c-.177.312-.42.684-.8.52-.272-.119-.432-.499-.641-.762l.102-.097zm-16.007-2.028c.023-.59.417-1.082.869-1.085.379-.003.694.455.671.975-.025.582-.477 1.122-.923 1.105-.401-.014-.641-.4-.617-.995z\"/><path fill=\"#4F4E51\" d=\"M14.044 126.805h-1.66v-14.277h7.959v1.475h-6.299v5.225h5.918v1.475h-5.918v6.102zm17.656-5.362c0 1.745-.439 3.107-1.318 4.087S28.289 127 26.739 127c-.957 0-1.807-.225-2.549-.674s-1.315-1.094-1.719-1.934-.605-1.823-.605-2.949c0-1.745.436-3.104 1.309-4.077s2.083-1.46 3.633-1.46c1.498 0 2.687.498 3.569 1.494s1.323 2.344 1.323 4.043zm-8.154 0c0 1.367.273 2.409.82 3.125s1.351 1.074 2.412 1.074 1.867-.356 2.417-1.069.825-1.756.825-3.13c0-1.361-.275-2.394-.825-3.101s-1.362-1.06-2.437-1.06c-1.061 0-1.862.348-2.402 1.045s-.81 1.736-.81 3.116zm12.519-5.341v6.943c0 .873.199 1.523.596 1.953s1.019.645 1.865.645c1.12 0 1.938-.306 2.456-.918s.776-1.611.776-2.998v-5.625h1.621v10.703h-1.338l-.234-1.436h-.087c-.332.527-.792.931-1.382 1.211s-1.261.42-2.017.42c-1.302 0-2.277-.309-2.925-.928s-.972-1.608-.972-2.969v-7.002h1.641zm18.077 10.703v-6.924c0-.873-.199-1.523-.596-1.953s-1.019-.645-1.865-.645c-1.12 0-1.94.303-2.461.908s-.781 1.605-.781 2.998v5.615h-1.621v-10.703h1.318l.264 1.465h.078c.332-.527.797-.936 1.396-1.226s1.266-.435 2.002-.435c1.289 0 2.259.311 2.91.933s.977 1.616.977 2.983v6.982h-1.621zm12.236-1.436h-.088c-.749 1.087-1.869 1.631-3.359 1.631-1.4 0-2.489-.479-3.267-1.436s-1.167-2.318-1.167-4.082.391-3.135 1.172-4.111 1.869-1.465 3.262-1.465c1.452 0 2.565.527 3.34 1.582h.127l-.068-.771-.039-.752v-4.355h1.621v15.195h-1.318l-.216-1.436zm-3.242.274c1.107 0 1.909-.301 2.407-.903s.747-1.574.747-2.915v-.342c0-1.517-.252-2.599-.757-3.247s-1.31-.972-2.417-.972c-.951 0-1.678.37-2.183 1.108s-.757 1.782-.757 3.13c0 1.367.25 2.399.752 3.096s1.238 1.045 2.208 1.045zm14.795 1.162l-.322-1.523h-.079c-.534.67-1.066 1.125-1.597 1.362s-1.192.356-1.987.356c-1.061 0-1.893-.273-2.495-.82s-.903-1.325-.903-2.334c0-2.162 1.729-3.294 5.186-3.398l1.816-.059v-.664c0-.84-.181-1.46-.542-1.86s-.939-.601-1.733-.601c-.892 0-1.901.273-3.027.82l-.498-1.24c.527-.287 1.105-.511 1.733-.674s1.258-.244 1.89-.244c1.276 0 2.222.283 2.837.85s.923 1.475.923 2.725v7.305h-1.202zm-3.662-1.143c1.009 0 1.802-.277 2.378-.83s.864-1.328.864-2.324v-.967l-1.621.068c-1.289.045-2.218.246-2.788.601s-.854.907-.854 1.655c0 .586.177 1.032.532 1.338s.85.459 1.489.459zm11.66 0c.287 0 .563-.021.83-.063s.479-.086.635-.132v1.24c-.176.084-.435.155-.776.21s-.65.083-.924.083c-2.07 0-3.105-1.09-3.105-3.271v-6.367h-1.533v-.781l1.533-.674.684-2.285h.938v2.48h3.105v1.26H84.21v6.299c0 .645.153 1.139.459 1.484s.726.517 1.26.517zm3.467-12.461c0-.371.091-.643.273-.815s.41-.259.684-.259c.26 0 .485.088.674.264s.283.446.283.811-.094.636-.283.815-.414.269-.674.269c-.273 0-.501-.089-.684-.269s-.273-.451-.273-.816zm1.757 13.604h-1.621v-10.703h1.621v10.703zm12.676-5.362c0 1.745-.439 3.107-1.318 4.087s-2.093 1.47-3.643 1.47c-.957 0-1.807-.225-2.549-.674s-1.315-1.094-1.719-1.934-.605-1.823-.605-2.949c0-1.745.436-3.104 1.309-4.077s2.083-1.46 3.633-1.46c1.498 0 2.687.498 3.569 1.494s1.323 2.344 1.323 4.043zm-8.154 0c0 1.367.273 2.409.82 3.125s1.351 1.074 2.412 1.074 1.867-.356 2.417-1.069.825-1.756.825-3.13c0-1.361-.275-2.394-.825-3.101s-1.362-1.06-2.437-1.06c-1.061 0-1.862.348-2.402 1.045s-.81 1.736-.81 3.116zm18.32 5.362v-6.924c0-.873-.199-1.523-.596-1.953s-1.019-.645-1.865-.645c-1.12 0-1.94.303-2.461.908s-.781 1.605-.781 2.998v5.615h-1.621v-10.703h1.318l.264 1.465h.078c.332-.527.797-.936 1.396-1.226s1.266-.435 2.002-.435c1.289 0 2.259.311 2.91.933s.977 1.616.977 2.983v6.982h-1.621z\"/></svg>"

/***/ }),

/***/ "../src/components/foundation/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FoundationOriginalWordmark = __webpack_require__("../src/components/foundation/original-wordmark/FoundationOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FoundationOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/foundation/original/FoundationOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _FoundationOriginal = __webpack_require__("../src/components/foundation/original/FoundationOriginal.svg");
	
	var _FoundationOriginal2 = _interopRequireDefault(_FoundationOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** FoundationOriginal */
	function FoundationOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'FoundationOriginal',
	    svg: _FoundationOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	FoundationOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = FoundationOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/foundation/original/FoundationOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D3EDF6\" d=\"M23.025 122.111c.023.349-.141.419-.402.233-.554-.395-1.175-.736-1.623-1.23-2.246-2.481-3.872-5.313-4.642-8.597-.313-1.338-.335-2.679-.236-4.062.191-2.651 0-5.295-.714-7.877-.047-.172-.154-.328-.342-.714l-1.36 1.659-.164-.099c.041-3.821-.09-7.631-.773-11.445l-1.505 3.558-.25-.044c-.111-.569-.235-1.136-.332-1.707-.567-3.348-.662-6.733-.475-10.102.29-5.21 1.15-10.322 3.577-15.037.683-1.326 1.509-2.563 2.609-3.694-.562.169-1.132.315-1.684.514-.579.208-1.14.467-1.832.755.723-1.9 1.684-3.566 2.933-5.048 1.233-1.463 2.55-2.856 3.88-4.335l-3.087-1.154-.218-.205c.214-.112.448-.198.638-.342 3.014-2.285 6.463-3.586 10.091-4.492 1.153-.287.951-.073 1.032-1.279.131-1.952.344-3.898.523-5.847l.178-.015 2.647 5.041c-.288-7.73.268-15.343 2.403-22.787l.181-.002c.014.249.046.498.037.746-.063 1.632.096 3.225.75 4.745.454 1.056 1.116 1.923 2.197 2.582.453-4.562 1.672-8.88 3.108-13.274l2.152 2.427a36.028 36.028 0 0 1 2.07-8.766l3.064 3.904 1.817-8.597 1.29 2.83c-.09 4.495 2.107 7.938 5.188 11.07l-3.409 1.722c3.574-.291 6.144-1.523 7.975-3.805.541-.847 1.167-1.652 1.603-2.55.655-1.346.605-1.383-.625-2.208-3.29-2.204-5.52-5.195-6.699-8.972 1.407-1.806 3.359-2.748 5.394-3.466l.26 4.037c.545-.289.936-.488 1.32-.7 3.378-1.86 6.975-3.112 10.753-3.853.727-.142 1.461-.242 2.194-.349.083-.012.18.061.27.094L71.255 4.19c-1.291 1.029-2.317 2.29-3.208 3.668l-.125.125-.002.124c-.127.132-.293.243-.376.398-.673 1.257-1.367 2.504-1.978 3.792-.356.75-.57 1.567-.86 2.389l5.678.541.1.217c-4.079 3.673-8.165 7.339-11.957 11.466l4.061.556c-1.151.471-2.188.829-3.164 1.308-2.843 1.395-5.502 3.037-7.424 5.661-1.488 2.032-3.035 4.021-4.556 6.028-1.188-1.19-2.375-2.381-3.57-3.581l-.912 4.163 2.535 2.281c-.134.257-.276.51-.401.771-.792 1.663-1.651 3.298-2.35 4.999-.727 1.772-.891 3.682-1.027 5.583-.156 2.183-.399 4.362-.468 6.547-.083 2.647-.098 5.302.349 7.933.393 2.316.694 4.65 1.155 6.952.285 1.421.792 2.797 1.201 4.193l.171-.034 1.691-3.393.169.043c.61 2.926 1.479 5.772 2.724 8.487 1.239 2.702 2.666 5.294 4.913 7.391v-3.58l.25.003c.459.239.92.476 1.37.732a78.895 78.895 0 0 0 9.798 4.724c4.083 1.632 8.148 3.305 12.026 5.389 1.201.645 2.409 1.333 3.458 2.191 2.381 1.95 4.666 4.019 6.99 6.04l-.193.455c-.761 1.522-1.535 3.037-2.285 4.565-.662 1.349-1.298 2.71-1.946 4.066l-.168-.026v-4.699c-.267.603-.373 1.213-.535 1.808a661.507 661.507 0 0 1-2.004 7.238c-.207.726-.727 1.144-1.441 1.428-.836.332-1.616.226-2.418-.027l.007.004-.232-.107c-1.218-.907-2.435-1.816-3.656-2.72-.312-.23-.64-.439-.948-.649l.442 4.497-.235.121c-4.982-4.061-11.074-6.074-16.596-9.138-1.795-1.143-3.595-2.277-5.382-3.434-.477-.309-.911-.682-1.471-1.106l.274 2.213-.15.105-5.103-3.503c.089-.695.222-1.388.259-2.085.066-1.273.224-2.566.079-3.82-.351-3.029-1.925-5.353-4.438-7.075a34.016 34.016 0 0 1-2.946-2.269c-.517-.444-.917-1.034-1.032-1.672l2.932.263c-.872-1.626-1.74-3.065-2.429-4.585-.69-1.525-1.348-3.095-1.263-5.023.513.697.846 1.345 1.609 1.654-.261-2.57.114-5.003.533-7.417.417-2.411.997-4.794 1.506-7.19-1.777 3.112-3.59 6.199-4.135 9.956l-1.467-1.544c-.064.932-.187 1.774-.168 2.614.042 1.882.113 3.766.246 5.644.151 2.142.736 4.183 1.582 6.158.964 2.255 2.616 4.009 4.146 5.858.973 1.174 1.806 2.447 2.027 3.993.239 1.673.396 3.357.589 5.037l.388 5.684c-1.113.229-4.221-.522-4.873-1.23l.523-.279c-.559-.483-1.177-.904-1.647-1.452-.714-.831-.854-1.904-1.021-2.954-.043-.27-.262-.511-.399-.765-.26.236-.602.429-.754.721-.128.245-.097.62-.027.911.129.541.294 1.083.519 1.59.679 1.536 1.415 3.046 2.087 4.584.826 1.887 1.505 3.818 1.459 5.922-.014.617-.14.733-.708.506a27.14 27.14 0 0 1-2.252-1.041c-.578-.296-1.124-.653-1.755-1.024v.663l-.051.043c-.18-.091-.385-.152-.538-.277-.65-.531-1.285-1.082-1.925-1.625l.004.005-.13-.26-1.147-2.854-.104.42-.185.39c-.862-1.58-1.316-3.162-1.549-4.826-.419 1.423.029 2.781.217 4.238l.378-.41c.327.659.609 1.298.953 1.903.347.61.73 1.202 1.142 1.77.208.289.513.508.773.758.605 1.524 1.229 3.043 1.534 4.827l-3.279-.972c-1.322-.592-2.674-1.131-3.737-2.171-.052-.05-.153-.049-.231-.072l-.048-.163-.047.032.093.133 1.09 2.272-.078.16-1.703-.594-1.053-.337-.053-.029.053.029zm1.334-2.055l-1.282-3.093-.421.287-.861-4.031c-.825 1.579.795 6.083 2.564 6.837zM38.46 69.748l-.018-.053-.045.012.018.053.045-.012z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E9F5FA\" d=\"M87.519 108.3c-2.324-2.021-4.609-4.089-6.99-6.04-1.049-.858-2.257-1.546-3.458-2.191-3.877-2.083-7.943-3.756-12.026-5.389a78.895 78.895 0 0 1-9.798-4.724c-.45-.256-.911-.493-1.37-.732l-.25-.003v3.58c-2.247-2.096-3.673-4.689-4.913-7.391-1.245-2.714-2.114-5.561-2.724-8.487l-.169-.043-1.691 3.393-.171.034c-.408-1.396-.916-2.772-1.201-4.193-.461-2.302-.762-4.636-1.155-6.952-.446-2.631-.431-5.286-.349-7.933.068-2.185.312-4.365.468-6.547.136-1.9.3-3.81 1.027-5.583.698-1.701 1.558-3.336 2.35-4.999.125-.262.267-.514.401-.771l.25.184c1.585 1.305 3.186 2.591 4.74 3.933.296.255.518.708.58 1.102.12.754.11 1.531.136 2.299.043 1.288.377 1.834 1.592 2.223 4.15 1.326 8.375 2.076 12.757 1.565 1.22-.143 2.242-.604 2.952-1.629a76.008 76.008 0 0 0 1.825-2.747c.671-1.064.853-1.136 2.083-.95.554.084.734.341.721.858-.02.788-.004 1.577-.013 2.365-.019 1.754.944 2.758 2.552 3.129 1.37.315 2.769.547 4.168.679 1.772.166 3.567.326 5.297-.331-.423 1.095-.842 2.191-1.27 3.285-.188.481-.36.973-.601 1.428-.352.664-.467 1.259.247 1.758l.129.138-.001-.003.34.651c.802 1.633 1.694 3.23 2.382 4.91 1.084 2.65 1.468 5.459 1.543 8.312.123 3.35-.517 6.563-1.781 9.653-.368.897-.694 1.885-1.312 2.595-2.782 3.204-6.32 4.659-10.584 4.22l-1.229-.143a.611.611 0 0 0 .283.287c2.869 1.669 5.737 3.339 8.609 5.003.155.09.336.134.504.2.536.471 1.076.937 1.608 1.413l2.539 2.283.195.136c.86-.741 1.686-1.489 2.549-2.189 2.553-2.073 5.361-3.718 8.36-5.074 2.189-.989 4.3-2.154 6.446-3.24.125-.063.254-.122.562-.104l-.767 2.929-.167.59-.052.028.023.023.028-.052c.995-.472 2.019-.891 2.975-1.431.794-.449 1.507-1.039 2.257-1.565-.142.32-.258.655-.432.957-1.296 2.256-3.028 4.155-4.915 5.921-.537.502-1.116.959-1.748 1.499l.162-2.853c-2.766 2.301-5.083 4.773-7.326 7.321l-.168-.054-.232-3.345c-2.439 2.196-4.849 4.256-6.777 6.804zM54.668 57.42c.036.344.042.59.09.828.34 1.718 1.318 3.035 2.666 4.083 2.78 2.164 6.034 3.194 9.443 3.764 3.072.514 6.177.299 9.271.218.139-.003.276-.048.542-.098l-.71-1.487c-.353-.725-.725-1.441-1.061-2.174-.244-.532-.079-.9.427-1.25 1.064-.736 2.073-1.556 3.146-2.373a4.53 4.53 0 0 0-2.596-1.037c-2.647-.204-5.3-.41-7.954-.454-4.382-.073-8.766-.02-13.264-.02zm13.943 18.062l.245-.049c.356-.718.759-1.417 1.056-2.159.364-.912.707-1.781 1.732-2.178.556-.215 1.061-.562 1.588-.849l-.051-.196c-4.601.285-9.108-.217-13.641-1.682.121 1.944.614 3.59 1.426 5.246l1.749-1.948c.55 1.486.919 2.933 2.036 4.186l2.139-3.159 1.721 2.788zm4.107 17.272l-.012-.037-.053-.011.015.063.05-.015zm-25.27-52.289c1.521-2.008 3.067-3.997 4.556-6.028 1.922-2.624 4.581-4.266 7.424-5.661.976-.479 2.012-.837 3.164-1.308l-4.061-.556c3.792-4.127 7.878-7.793 11.957-11.466l-.1-.217-5.678-.541c.291-.821.504-1.639.86-2.389.611-1.287 1.305-2.535 1.978-3.792.083-.155.249-.267.376-.398.21.083.414.197.632.244 3.081.667 6.164 1.321 9.244 1.989.84.182.853.187.853-.713V4.994c1.014-.278 2.018-.606 3.045-.824a231.84 231.84 0 0 1 7.155-1.414c1.193-.213 2.41-.288 3.716-.438l-2.53 4.368.142.101c1.076-.317 2.139-.694 3.231-.934 1.099-.243 2.227-.349 3.448-.531v1.776c2.999-.373 5.888-.31 8.855.253-.193.392-.352.699-.497 1.013-.506 1.09-1.004 2.185-1.513 3.272-.217.464-.108.719.406.867 1.21.349 2.41.738 3.612 1.117.234.074.46.173.784.296-.52.634-1.019 1.2-1.471 1.801-1.281 1.698-2.544 3.41-3.808 5.121-.07.095-.086.229-.128.346l-2.549 3.972c-.778 1.322-1.559 2.643-2.327 3.971-.056.097-.017.248-.021.375-.381.555-.819 1.08-1.134 1.67-1.481 2.782-2.974 5.561-4.375 8.383-1.373 2.767-2.643 5.584-3.951 8.382-.078.166-.098.357-.145.537l-6.319-1.292c-.691-.944-1.718-1.029-2.502-.207-1.761.056-3.522.143-5.284.156-.904.007-1.833-.008-2.71-.202-2.71-.598-5.4-1.287-8.099-1.94-.445-1.08-1.992-1.246-2.751-.563l-.186-.006c-3.344-.569-6.701-.962-10.104-.825-.158.006-.364-.097-.478-.216-.914-.963-1.813-1.941-2.717-2.914zm11.499 1.946l.333-.144c1.438-.753 2.93-1.206 4.577-.872.319.065.649.082 1.033.128-.967-1.475-3.403-1.606-4.754-.729-.589.382-1.156.811-1.189 1.617l-.029.052.029-.052zm6.195-3.309c-.58-1.39-2.409-2.078-4.047-1.627-1.374.377-2.669 1.849-2.525 2.995 1.834-2.072 4.051-2.258 6.572-1.368zm18.069 2.652c1.787.167 3.337.756 4.444 2.326.08-1.298-.425-2.06-1.476-2.635-.984-.539-2.18-.389-2.968.309zm3.151 4.988c-.151-1.446-.603-2.614-2.042-3.026-.74-.212-1.489-.091-2.117.507 1.884.518 2.55.577 4.159 2.519z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#B3E0EE\" d=\"M87.909 76.486c-.076-2.853-.459-5.662-1.543-8.312-.688-1.68-1.58-3.277-2.382-4.91l-.34-.651c.611.184 1.218.382 1.834.547.897.241 1.792.519 2.707.659.488.075 1.017-.101 1.525-.178.196-.03.386-.099.69-.179l-.247 1.223c2.042-.949 3.52-2.408 4.715-4.116 1.19-1.702 2.208-3.524 3.28-5.262l.479.807c.863-1.35.268-5.337-1.156-7.71.362 0 .661-.021.956.003 1.873.152 3.783.134 5.477 1.138 1.343.795 2.302 1.923 2.945 3.412l-1.434-.08c1.429 2.313 1.979 4.708 1.755 7.449l-1.105-.878c-.053.262-.091.532-.164.792-.221.777-.464 1.547-.678 2.326-.057.208-.04.435-.057.653.232.006.488.08.693.007 1.171-.416 2.329-.868 3.492-1.305.485-.182.979-.342 1.458-.539.506-.208.694-.028.659.482-1.317.459-2.636.916-3.951 1.381-.168.06-.322.163-.482.246 1.666-.185 2.327-.097 3.179.498.62.433.71.972.159 1.499-.428.409-.941.733-1.437 1.063-.297.199-.634.338-1.046.553l.572.217c-.908.596-1.782 1.11-2.587 1.715-1.001.753-2.006 1.521-2.894 2.398-.708.699-.492 1.187.499 1.267 1.215.098 2.438.102 3.657.144l.783.001-.578.747-.029.048.025-.051c.457 0 .92.044 1.368-.018.282-.04.678-.173.784-.384.229-.458.599-.515 1.003-.591.79-.149 1.584-.281 2.368-.458.627-.142 1.243-.34 1.863-.513l.092.13-1.388 1.293-.208-.762c-2.202 1.012-4.377 1.929-6.469 3.008-1.009.521-1.86 1.347-2.783 2.036l-.051.058.058-.05.591.042-2.313 1.951c.369.321.665.743 1.062.887.747.272 1.545.483 2.335.54 1.191.085 2.393.016 3.59.012l.031-.262-.937-.385 4.774-.575c-3.257 2.004-7.016 1.793-10.617 2.397.006.974.822 1.433 1.344 2.102l-.389.322 1.13.948c.215.338.017.362-.262.376-2.078.104-4.089-.248-6.017-.99-1.175-.452-2.298-1.039-3.447-1.559-.108-.049-.237-.052-.357-.077l-.018-.046-.036-.01.051.059.5 1.122c-.662-.125-1.32-.316-1.987-.361-1.547-.104-3.011.324-4.451.839l-.528.159c.042-.533.117-1.067.118-1.601.005-2.167-.01-4.333-.03-6.5.001-.08-.132-.162-.203-.243z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#65C1DD\" d=\"M87.519 108.3c1.928-2.547 4.338-4.608 6.776-6.804l.232 3.345.168.054c2.243-2.547 4.56-5.02 7.326-7.321l-.162 2.853c.632-.54 1.211-.997 1.748-1.499 1.887-1.766 3.619-3.665 4.915-5.921.173-.302.29-.637.432-.957l.123-.006.019.016c-.417 1.361-.79 2.737-1.261 4.079-1.032 2.936-2.985 5.333-4.663 7.897-1.688 2.581-3.234 5.255-4.832 7.895-.124.205-.161.462-.238.695l-.049.072.066-.055c.733-.379 1.464-.762 2.199-1.137.677-.346 1.359-.684 2.148-.92l-.501.945c-1.75 3.371-3.481 6.752-5.258 10.109-.708 1.338-1.496 2.635-2.296 3.92-.138.223-.521.414-.792.415-3.553.021-7.106-.056-10.657.02-2.57.054-4.521-1.152-6.351-2.725l-.085-.159c.803.253 1.583.359 2.418.027.714-.284 1.234-.702 1.441-1.428a645.675 645.675 0 0 0 2.004-7.238c.162-.595.268-1.206.535-1.808v4.699l.168.026c.648-1.356 1.284-2.718 1.946-4.066.75-1.528 1.524-3.043 2.285-4.565l.196-.458z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#65C2DD\" d=\"M43.479 109.392l5.103 3.503.15-.105-.274-2.213c.56.424.994.797 1.471 1.106 1.787 1.156 3.587 2.291 5.382 3.434l-3.814 1.039c4.449 1.905 8.463 4.59 10.392 9.673-1.311.087-2.506.19-3.703.243-2.573.112-5.146.218-7.72.29-3.717.104-7.435.174-11.152.262-1.08.025-2.16.047-3.238.09-1.718.068-3.065-.593-4.05-2.001-.116-.167-.254-.318-.417-.521l-1.19.826c-.705-.6-1.309-1.283-1.676-2.161l3.279.972c-.305-1.784-.929-3.303-1.534-4.827l-.352-1.134c.64.543 1.275 1.093 1.925 1.625.153.125.357.187.538.277l.086.137-.035-.18v-.663c.631.371 1.177.728 1.755 1.024a27.14 27.14 0 0 0 2.252 1.041c.568.227.694.11.708-.506.046-2.104-.634-4.036-1.459-5.922-.673-1.539-1.409-3.048-2.087-4.584a9.206 9.206 0 0 1-.519-1.59c-.069-.292-.101-.666.027-.911.152-.292.494-.484.754-.721.138.254.356.496.399.765.167 1.05.307 2.123 1.021 2.954.47.547 1.088.968 1.647 1.452l-.523.279c.652.708 3.76 1.459 4.873 1.23l-.388-5.684.374.193c.665.432 1.329.871 1.995 1.308z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#EBF7FE\" d=\"M104.579 85.318l-1.13-.948.389-.322c-.521-.669-1.337-1.128-1.344-2.102 3.602-.604 7.36-.393 10.617-2.397l-4.774.575.937.385-.031.262c-1.197.004-2.399.073-3.59-.012-.79-.057-1.588-.268-2.335-.54-.397-.145-.692-.566-1.062-.887l2.313-1.951-.591-.042-.007-.008c.922-.688 1.773-1.515 2.783-2.035 2.091-1.079 4.267-1.996 6.469-3.008l.208.762 1.388-1.293-.092-.13c-.621.173-1.236.371-1.863.513-.784.177-1.578.309-2.368.458-.404.076-.774.134-1.003.591-.106.211-.501.344-.784.384-.448.063-.911.018-1.368.018l.004.003.578-.747-.783-.001c-1.219-.042-2.442-.046-3.657-.144-.99-.08-1.206-.567-.499-1.267.888-.878 1.892-1.646 2.894-2.398.805-.605 1.679-1.119 2.587-1.715l-.572-.217c.412-.215.749-.354 1.046-.553.496-.331 1.009-.655 1.437-1.063.551-.527.461-1.065-.159-1.499-.852-.595-1.513-.682-3.179-.498.161-.083.314-.186.482-.246 1.315-.465 2.634-.922 3.951-1.381 1.076.043 2.163.002 3.223.151 1.458.205 2.234 1.34 3.035 2.396l-.087.159-1.466-.472c.87 1.486 1.651 2.882 1.705 4.601-.112-.062-.213-.086-.261-.151-.061-.082-.08-.195-.154-.394-.404.969-.596 1.802-1.054 2.446-.772 1.088-.74 2.034-.164 3.21.412.841.429 1.876.622 2.825l-.242.096-.618-.76c-.077 1.305-.093 2.478-.735 3.546l-.281-.645c-.458.422-.914.805-1.316 1.238-.11.118-.111.397-.074.585.21 1.089.571 2.167.161 3.319l-.476-.222c-.667 1.463-1.871 2.206-3.364 2.371-1.622.179-3.218-.107-4.753-.686-.193-.071-.396-.107-.593-.16z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#515053\" d=\"M82.28 47.181l6.319 1.292.53.174c.433.141.593.445.463.869-.163.533-.316 1.078-.562 1.574-.133.27-.414.534-.69.65-.479.202-.762.517-.972.975-.292.638-.587 1.286-.978 1.866-.35.52-.828.954-1.25 1.427-1.73.657-3.525.497-5.297.331a31.78 31.78 0 0 1-4.168-.679c-1.607-.371-2.571-1.375-2.552-3.129.009-.788-.007-1.577.013-2.365.013-.517-.167-.774-.721-.858-1.229-.186-1.411-.115-2.083.95a76.008 76.008 0 0 1-1.825 2.747c-.71 1.025-1.731 1.487-2.952 1.629-4.381.51-8.606-.24-12.757-1.565-1.215-.389-1.548-.935-1.592-2.223-.026-.768-.016-1.544-.136-2.299-.062-.393-.284-.846-.58-1.102-1.554-1.342-3.155-2.628-4.74-3.933l-.25-.184-2.535-2.281.912-4.163 3.57 3.581c.904.973 1.803 1.951 2.719 2.913.114.119.319.223.478.216 3.402-.137 6.76.255 10.104.825l.186.006 2.751.563c2.698.653 5.389 1.342 8.099 1.94.876.194 1.806.209 2.71.202 1.761-.013 3.522-.1 5.284-.156l2.502.207zm-22.698-1.688c-1.841-.106-3.682-.248-5.525-.301-.74-.021-1.158.401-1.246 1.133a69.929 69.929 0 0 0-.364 3.905c-.083 1.328.047 1.49 1.33 1.924 3.544 1.198 7.201 1.579 10.923 1.517 1.36-.022 2.361-.628 3.042-1.739.563-.917 1.042-1.887 1.51-2.857.407-.844.28-1.228-.624-1.525-1.375-.453-2.787-.795-4.183-1.185l-4.863-.872zm20.501 2.659l-.02.136c-.706 0-1.414-.03-2.118.009-.619.034-1.237.124-1.849.228-.805.137-1.318.611-1.396 1.442-.083.865-.153 1.736-.151 2.604.003 1.512.279 1.846 1.731 2.196 2.071.498 4.175.696 6.302.595.514-.024 1.026-.14 1.535-.237.674-.129 1.158-.487 1.435-1.147.496-1.185 1.056-2.343 1.541-3.531.404-.99.305-1.249-.734-1.421-2.084-.346-4.183-.589-6.276-.874z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4F4E51\" d=\"M60.322 19.341c-1.831 2.282-4.401 3.514-7.975 3.805l3.409-1.722c-3.081-3.131-5.278-6.575-5.188-11.07.156-2.759 1-5.28 2.602-7.539.154-.217.348-.406.522-.608l.098.046.007.243c-.11.182-.276.351-.321.547-.626 2.735-.617 5.459.278 8.138.97 2.903 2.8 5.184 5.2 7.04.467.362.913.747 1.368 1.12z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#66C2DD\" d=\"M87.909 76.486c.072.082.205.163.205.245.021 2.166.035 4.333.03 6.5-.001.534-.077 1.067-.118 1.601-.458 1.886-.819 3.801-1.397 5.649-.896 2.869-2.38 5.452-4.229 7.822-.168-.065-.35-.109-.504-.2-2.872-1.665-5.74-3.334-8.609-5.003a.616.616 0 0 1-.283-.287c.41.048.818.101 1.229.143 4.264.439 7.802-1.017 10.584-4.22.617-.71.944-1.698 1.312-2.595 1.263-3.092 1.903-6.305 1.78-9.655z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#EBF7FD\" d=\"M78.653 4.994v4.635c0 .9-.013.896-.853.713-3.08-.668-6.163-1.322-9.244-1.989-.218-.047-.421-.161-.632-.244l.002-.124.125-.125c.891-1.378 1.917-2.639 3.208-3.668l3.532-2.816c-.006.208.031.431-.028.624-.274.881-.576 1.755-.925 2.805 1.712-.638 3.202-1.422 4.816-1.692l-.001 1.881z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#737F84\" d=\"M60.322 19.341c-.455-.373-.901-.758-1.366-1.119-2.399-1.855-4.23-4.137-5.2-7.04-.896-2.679-.905-5.403-.278-8.138.045-.197.211-.366.321-.547l.802 3.114c1.179 3.777 3.409 6.768 6.699 8.972 1.231.824 1.281.861.625 2.208-.436.897-1.062 1.703-1.603 2.55z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4F4E51\" d=\"M98.204 29.501c.005-.126-.035-.278.021-.375.768-1.328 1.549-2.648 2.327-3.971 1.354-.277 2.73-.473 4.056-.848 2.946-.833 5.552-2.278 7.635-4.575.248-.273.508-.534.763-.8-1.058 3-2.641 5.677-4.941 7.893-2.193 2.113-4.896 2.867-7.873 2.805-.663-.013-1.325-.084-1.988-.129z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#737F84\" d=\"M113.006 18.933c-.255.266-.516.527-.763.8-2.083 2.297-4.688 3.742-7.635 4.575-1.326.375-2.703.571-4.056.848l2.549-3.972c3.606.582 6.773-.525 9.705-2.532l.416-.262-.216.543z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#65C1DD\" d=\"M109.078 92.043l.028-.174.056.016-.065.174-.019-.016zm-32.775 30.963l.232.107-.232-.107z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#B3E0EE\" d=\"M94.992 84.194l.052.029-.052-.029zM83.645 62.616l-.129-.138.129.138z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#737F84\" d=\"M53.693 2.208l.061-.069.037.116-.098-.047z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#B3E0EE\" d=\"M43.479 109.392l-1.997-1.311-.374-.193c-.193-1.68-.35-3.364-.589-5.037-.221-1.546-1.054-2.819-2.027-3.993-1.531-1.849-3.182-3.603-4.146-5.858-.845-1.975-1.431-4.016-1.582-6.158a118.048 118.048 0 0 1-.246-5.644c-.019-.839.104-1.682.168-2.614l1.467 1.544c.545-3.757 2.358-6.844 4.135-9.956-.509 2.396-1.088 4.779-1.506 7.19-.418 2.414-.794 4.847-.533 7.417-.763-.309-1.097-.957-1.609-1.654-.084 1.928.573 3.498 1.263 5.023.688 1.52 1.557 2.958 2.429 4.585L35.4 92.47c.114.638.515 1.228 1.032 1.672a34.418 34.418 0 0 0 2.946 2.269c2.513 1.723 4.087 4.046 4.438 7.075.145 1.254-.013 2.547-.079 3.82-.036.698-.169 1.391-.258 2.086zm-13.345 8.475l.352 1.134c-.261-.25-.565-.47-.773-.758a19.336 19.336 0 0 1-1.142-1.77c-.343-.605-.626-1.244-.953-1.903l-.378.41c-.188-1.457-.637-2.814-.217-4.238.233 1.664.688 3.246 1.549 4.826l.185-.39.104-.42 1.147 2.854.13.26-.004-.005z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#B4E1EE\" d=\"M24.359 120.056c-1.769-.753-3.389-5.257-2.564-6.837l.861 4.031.421-.287 1.282 3.093z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#B3E0EE\" d=\"M38.46 69.748l-.045.012-.018-.053.045-.012.018.053z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#65C2DD\" d=\"M30.139 117.872l-.13-.26.13.26z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E9F5FA\" d=\"M68.051 7.86l-.125.125.125-.125z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4F4E51\" d=\"M54.668 57.42c4.498 0 8.882-.053 13.265.02 2.653.044 5.306.25 7.954.454a4.522 4.522 0 0 1 2.596 1.037c-1.074.817-2.082 1.637-3.146 2.373-.505.35-.67.718-.427 1.25.336.733.708 1.449 1.061 2.174l.71 1.487c-.266.05-.403.095-.542.098-3.095.081-6.199.295-9.271-.218-3.41-.569-6.663-1.6-9.443-3.764-1.348-1.048-2.326-2.365-2.666-4.083-.049-.237-.055-.484-.091-.828z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D3EDF6\" d=\"M68.611 75.482l-1.722-2.788-2.139 3.159c-1.117-1.253-1.486-2.7-2.036-4.186l-1.749 1.948c-.812-1.656-1.305-3.301-1.426-5.246 4.533 1.464 9.04 1.967 13.641 1.682l.051.196c-.528.288-1.033.634-1.588.849-1.025.396-1.369 1.266-1.732 2.178-.297.742-.7 1.441-1.056 2.159l-.244.049z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#66C2DD\" d=\"M72.718 92.754l-.05.015-.015-.063.053.011.012.037z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D4EDF6\" d=\"M65.142 39.102c-2.521-.889-4.738-.703-6.572 1.367-.144-1.146 1.151-2.617 2.525-2.995 1.638-.451 3.467.238 4.047 1.628zm-6.196 3.308c.034-.805.601-1.234 1.189-1.616 1.351-.877 3.787-.746 4.754.729-.384-.046-.713-.063-1.033-.128-1.646-.334-3.139.118-4.577.872l-.333.143zm24.265-.656c.787-.699 1.984-.849 2.968-.309 1.051.575 1.555 1.337 1.476 2.635-1.106-1.57-2.656-2.159-4.444-2.326z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#CDEBF4\" d=\"M86.362 46.742c-1.609-1.942-2.275-2.001-4.159-2.52.628-.598 1.377-.719 2.117-.507 1.439.413 1.891 1.581 2.042 3.027z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D4EDF6\" d=\"M58.947 42.411l-.029.052.029-.052z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#EBF7FE\" d=\"M107.339 73.59l-.025.051.029-.048-.004-.003zm-3.362 3.748l-.058.05.051-.058.007.008z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D3EDF6\" d=\"M32.648 119.725l.035.18-.086-.137.051-.043z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E8F4F8\" d=\"M64.446 46.365c1.396.39 2.808.732 4.183 1.185.904.297 1.031.681.624 1.525-.467.97-.947 1.94-1.51 2.857-.682 1.111-1.682 1.717-3.042 1.739-3.723.062-7.379-.319-10.923-1.517-1.283-.434-1.413-.596-1.33-1.924.082-1.304.209-2.607.364-3.905.088-.732.505-1.155 1.246-1.133 1.843.054 3.684.195 5.525.301l-.507 1.587a5.76 5.76 0 0 0-.234 3.587c.325 1.294 1.449 1.981 2.621 1.671 1.066-.282 2.234-1.679 2.345-2.806.549-.986.62-2.071.638-3.167z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#ECF5F9\" d=\"M80.083 48.152c2.093.285 4.192.527 6.274.873 1.039.172 1.138.431.734 1.421-.485 1.188-1.045 2.346-1.541 3.531-.276.661-.76 1.019-1.435 1.147-.508.097-1.021.213-1.535.237a22.314 22.314 0 0 1-6.302-.595c-1.452-.35-1.729-.684-1.731-2.196-.002-.869.069-1.739.151-2.604.079-.831.591-1.305 1.396-1.442.612-.104 1.23-.194 1.849-.228.704-.039 1.412-.009 2.118-.009l.022-.135zm2.777 2.611c-.104.22-.152.375-.241.5-.391.557-.72 1.184-1.207 1.641-1.049.983-2.355.69-2.946-.62-.235-.523-.357-1.098-.537-1.666-.135 1.502.011 2.559.45 3.298.442.744 1.062 1.032 1.884.875 1.464-.279 2.711-2.161 2.597-4.028zm-4.101-.284l-.12.114c.247.311.434.758.755.897.447.194.733-.244.942-.611a1.63 1.63 0 0 0 .182-.522c.102-.597-.168-1.217-.557-1.322-.425-.114-.932.319-1.111.96l-.091.484z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#778287\" d=\"M59.075 47.081c.049.721.027 1.455.165 2.158.166.84.587 1.557 1.504 1.81.918.254 1.665-.087 2.314-.708.265-.253.5-.537.749-.807-.111 1.127-1.279 2.524-2.345 2.806-1.172.31-2.296-.377-2.621-1.671a5.755 5.755 0 0 1 .234-3.588zm23.785 3.682c.114 1.867-1.133 3.749-2.596 4.027-.822.157-1.441-.131-1.884-.875-.439-.739-.585-1.796-.45-3.298.179.568.301 1.143.537 1.666.591 1.31 1.897 1.604 2.946.62.487-.457.816-1.084 1.207-1.641.088-.124.136-.279.24-.499z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#1C1C1C\" d=\"M78.759 50.479l.091-.483c.18-.641.687-1.074 1.111-.96.388.105.659.725.557 1.322a1.63 1.63 0 0 1-.182.522c-.208.367-.495.805-.942.611-.321-.139-.509-.587-.755-.897l.12-.115zm-18.85-2.388c.027-.694.492-1.273 1.023-1.277.446-.003.817.536.791 1.149-.03.684-.561 1.321-1.087 1.301-.472-.018-.755-.473-.727-1.173z\"/></svg>"

/***/ }),

/***/ "../src/components/foundation/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FoundationOriginal = __webpack_require__("../src/components/foundation/original/FoundationOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FoundationOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/foundation/plain-wordmark/FoundationPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _FoundationPlainWordmark = __webpack_require__("../src/components/foundation/plain-wordmark/FoundationPlainWordmark.svg");
	
	var _FoundationPlainWordmark2 = _interopRequireDefault(_FoundationPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** FoundationPlainWordmark */
	function FoundationPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'FoundationPlainWordmark',
	    svg: _FoundationPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	FoundationPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = FoundationPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/foundation/plain-wordmark/FoundationPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#008CBA\" d=\"M108.009 54.298l1.237.397.073-.134c-.675-.891-1.33-1.849-2.56-2.021-.894-.125-1.811-.091-2.719-.127.03-.43-.129-.583-.556-.407-.405.166-.822.301-1.23.454-.981.369-1.958.75-2.945 1.101-.172.062-.389-.001-.584-.006.014-.184 0-.376.048-.551.181-.657.386-1.307.572-1.961.062-.219.093-.447.138-.668l.932.741c.19-2.312-.275-4.332-1.48-6.283l1.209.068c-.542-1.256-1.351-2.208-2.484-2.878-1.429-.847-3.04-.832-4.62-.96-.249-.021-.501-.003-.807-.003 1.201 2.001 1.703 5.365.975 6.504l-.405-.68c-.904 1.465-1.762 3.002-2.767 4.438-1.008 1.441-2.254 2.67-3.978 3.472l.208-1.032c-.256.068-.417.126-.582.151-.429.065-.875.213-1.287.15-.771-.118-1.526-.353-2.283-.556-.52-.14-1.032-.307-1.547-.462l.001.003-.11-.117c-.601-.42-.504-.923-.207-1.483.203-.383.348-.798.506-1.204.361-.922.715-1.847 1.071-2.771.356-.398.76-.765 1.055-1.203.328-.49.578-1.036.824-1.574.177-.386.416-.652.82-.822.233-.098.47-.321.583-.548.207-.418.336-.877.474-1.327.109-.358-.026-.614-.391-.733l-.447-.147c.04-.151.057-.313.122-.453 1.104-2.36 2.174-4.737 3.333-7.07 1.183-2.381 2.441-4.725 3.691-7.071.265-.498.635-.941.956-1.409.559.038 1.118.097 1.677.109 2.511.052 4.791-.583 6.641-2.366 1.94-1.869 3.276-4.127 4.168-6.658l.181-.457-.35.221c-2.473 1.692-5.144 2.626-8.186 2.135.035-.098.049-.211.108-.292 1.066-1.443 2.132-2.886 3.212-4.319.382-.507.802-.984 1.242-1.519-.273-.104-.464-.188-.662-.25-1.014-.319-2.026-.647-3.047-.942-.434-.125-.525-.34-.342-.731.43-.918.849-1.841 1.276-2.761.123-.265-.103-.523.06-.854-2.5-.475-4.826-.528-7.826-.215V4.719c-1 .153-1.623.243-2.549.447-.921.203-1.639.521-2.545.789l-.03-.085 2.179-3.684c-1.102.126-2.105.189-3.112.369-2.019.361-4.199.768-6.205 1.193-.866.183-1.738.46-2.738.694V2.855c-2 .228-2.438.889-3.882 1.427.295-.886.639-1.623.871-2.366.051-.163.063-.35.069-.526l-.204-.079c-.619.089-1.227.174-1.839.293-3.188.625-6.215 1.68-9.065 3.25l-1.11.59-.218-3.405c-1.716.605-3.362 1.4-4.549 2.923l-.677-2.626-.006-.206-.031-.097-.052.058c-.147.17-.31.33-.44.513-1.352 1.905-2.063 4.032-2.195 6.358l-1.088-2.387-1.532 7.252-2.585-3.293a30.338 30.338 0 0 0-1.746 7.394l-1.816-2.047c-1.211 3.707-2.24 7.349-2.621 11.197-.913-.556-1.471-1.288-1.854-2.178-.551-1.283-.685-2.626-.632-4.003.008-.208-.021-.419-.031-.629l-.154.002c-1.801 6.279-2.27 12.7-2.026 19.221l-2.233-4.251-.15.013c-.151 1.643-.331 3.285-.441 4.931-.067 1.017.103.836-.87 1.079-3.061.763-5.969 1.861-8.512 3.789-.161.121-.358.193-.539.289l.184.172 2.604.973c-1.122 1.248-2.233 2.422-3.273 3.657-1.054 1.25-1.864 2.655-2.475 4.258.583-.243 1.057-.461 1.545-.637.465-.167.946-.291 1.42-.434-.928.954-1.625 1.998-2.201 3.116-2.047 3.977-2.773 8.289-3.018 12.684-.159 2.842-.078 5.697.4 8.521.082.482.186.96.28 1.44l.21.037 1.27-3.001c.576 3.217.686 6.431.652 9.654l.138.083 1.147-1.399c.158.326.248.457.288.602.603 2.178.763 4.408.603 6.645-.083 1.166-.065 2.298.199 3.426.649 2.77 2.021 5.159 3.915 7.252.377.417.902.704 1.369 1.037.22.157.358.099.339-.196l-.044-.023.045.022.889.29 1.436.501.066-.135-.919-1.917-.079-.112.041-.027.041.138.195.062c.897.877 2.037 1.331 3.152 1.831.311.74.82 1.317 1.414 1.822l1.004-.696.352.44c.83 1.188 1.967 1.745 3.416 1.688.91-.036 1.821-.055 2.731-.075 3.135-.074 6.271-.134 9.407-.222a442.15 442.15 0 0 0 6.512-.244c1.01-.044 2.018-.132 3.123-.205-1.626-4.288-5.012-6.553-8.766-8.159l3.218-.877c4.659 2.584 9.797 4.283 14 7.708l.198-.102-.373-3.793c.26.177.537.353.8.547a1173.5 1173.5 0 0 1 3.084 2.295l.19.088.071.132c1.543 1.327 3.188 2.345 5.357 2.299 2.995-.063 5.992.002 8.989-.017.229-.001.551-.162.668-.35.675-1.085 1.339-2.179 1.937-3.307 1.499-2.832 2.959-5.684 4.436-8.527l.423-.797c-.666.199-1.241.484-1.813.776l-1.854.959-.056.047.041-.061c.065-.196.096-.414.201-.586 1.347-2.227 2.651-4.483 4.075-6.66 1.415-2.163 3.063-4.185 3.933-6.662.397-1.132.712-2.293 1.063-3.44l-.016-.014-.103.005c-.632.444-1.234.942-1.904 1.32-.806.456-1.67.809-2.509 1.207l-.024.044-.019-.02.043-.024.141-.498.646-2.471c-.259-.014-.367.035-.474.088-1.81.916-3.589 1.898-5.437 2.733-2.53 1.144-4.898 2.531-7.052 4.28-.729.591-1.424 1.222-2.149 1.847l-.165-.114c-.714-.642-1.425-1.287-2.141-1.927-.448-.401-.903-.794-1.356-1.191 1.56-1.999 2.812-4.178 3.568-6.597.487-1.559.792-3.175 1.178-4.765l.446-.135c1.214-.435 2.449-.795 3.754-.708.563.038 1.118.199 1.676.305l-.422-.946-.043-.049.03.008.015.039.302.065c.97.438 1.917.933 2.907 1.314 1.627.626 3.323.923 5.076.835.236-.012.403-.032.221-.317.167.044.338.075.499.136 1.294.488 2.641.729 4.008.579 1.26-.139 2.277-.765 2.839-2l.401.188c.346-.972.042-1.88-.136-2.799-.031-.159-.031-.394.063-.494.34-.365.725-.688 1.11-1.044l.237.543c.542-.9.556-1.89.621-2.99l.521.641.204-.081c-.163-.8-.177-1.673-.525-2.383-.486-.992-.514-1.79.138-2.708.386-.543.548-1.246.889-2.063l.13.332.22.127c-.049-1.451-.707-2.628-1.441-3.882zM14.044 126h-1.66v-14.277h7.959v1.475h-6.299v5.225h5.918v1.475h-5.918V126zm17.656-5.361c0 1.745-.439 3.107-1.318 4.087s-2.093 1.47-3.643 1.47c-.957 0-1.807-.225-2.549-.674s-1.315-1.094-1.719-1.934-.605-1.823-.605-2.949c0-1.745.436-3.104 1.309-4.077s2.083-1.46 3.633-1.46c1.498 0 2.687.498 3.569 1.494s1.323 2.343 1.323 4.043zm-8.154 0c0 1.367.273 2.409.82 3.125s1.351 1.074 2.412 1.074 1.867-.356 2.417-1.069.825-1.756.825-3.13c0-1.361-.275-2.394-.825-3.101s-1.362-1.06-2.437-1.06c-1.061 0-1.862.348-2.402 1.045s-.81 1.735-.81 3.116zm12.519-5.342v6.943c0 .873.199 1.523.596 1.953s1.019.645 1.865.645c1.12 0 1.938-.306 2.456-.918s.776-1.611.776-2.998v-5.625h1.621V126h-1.338l-.234-1.436h-.087c-.332.527-.792.931-1.382 1.211s-1.261.42-2.017.42c-1.302 0-2.277-.309-2.925-.928s-.972-1.608-.972-2.969v-7.002h1.641zM54.142 126v-6.924c0-.873-.199-1.523-.596-1.953s-1.019-.645-1.865-.645c-1.12 0-1.94.303-2.461.908s-.781 1.605-.781 2.998V126h-1.621v-10.703h1.318l.264 1.465h.078c.332-.527.797-.936 1.396-1.226s1.266-.435 2.002-.435c1.289 0 2.259.311 2.91.933s.977 1.616.977 2.983V126h-1.621zm12.236-1.436h-.088c-.749 1.087-1.869 1.631-3.359 1.631-1.4 0-2.489-.479-3.267-1.436s-1.167-2.318-1.167-4.082.391-3.135 1.172-4.111 1.869-1.465 3.262-1.465c1.452 0 2.565.527 3.34 1.582h.127l-.068-.771-.039-.752v-4.355h1.621V126h-1.318l-.216-1.436zm-3.242.274c1.107 0 1.909-.301 2.407-.903s.747-1.574.747-2.915v-.342c0-1.517-.252-2.599-.757-3.247s-1.31-.972-2.417-.972c-.951 0-1.678.37-2.183 1.108s-.757 1.782-.757 3.13c0 1.367.25 2.399.752 3.096s1.238 1.045 2.208 1.045zM77.931 126l-.322-1.523h-.079c-.534.67-1.066 1.125-1.597 1.362s-1.193.356-1.987.356c-1.061 0-1.893-.273-2.495-.82s-.903-1.325-.903-2.334c0-2.162 1.729-3.294 5.186-3.398l1.816-.059v-.664c0-.84-.181-1.46-.542-1.86s-.939-.601-1.733-.601c-.892 0-1.901.273-3.027.82l-.498-1.24c.527-.287 1.105-.511 1.733-.674s1.258-.244 1.89-.244c1.276 0 2.222.283 2.837.85s.923 1.475.923 2.725V126h-1.202zm-3.662-1.143c1.009 0 1.802-.277 2.378-.83s.864-1.328.864-2.324v-.967l-1.621.068c-1.289.045-2.218.246-2.788.601s-.854.907-.854 1.655c0 .586.177 1.032.532 1.338s.85.459 1.489.459zm11.66 0c.287 0 .563-.021.83-.063s.479-.086.635-.132v1.24c-.176.084-.435.155-.776.21s-.649.083-.923.083c-2.07 0-3.105-1.09-3.105-3.271v-6.367h-1.533v-.781l1.533-.674.684-2.285h.938v2.48h3.105v1.26H84.21v6.299c0 .645.153 1.139.459 1.484s.726.517 1.26.517zm3.467-12.461c0-.371.091-.643.273-.815s.41-.259.684-.259c.26 0 .485.088.674.264s.283.446.283.811-.094.636-.283.815-.414.269-.674.269c-.273 0-.501-.089-.684-.269s-.273-.451-.273-.816zM91.153 126h-1.621v-10.703h1.621V126zm12.676-5.361c0 1.745-.439 3.107-1.318 4.087s-2.093 1.47-3.643 1.47c-.957 0-1.807-.225-2.549-.674s-1.315-1.094-1.719-1.934-.605-1.823-.605-2.949c0-1.745.436-3.104 1.309-4.077s2.083-1.46 3.633-1.46c1.498 0 2.687.498 3.569 1.494s1.323 2.343 1.323 4.043zm-8.154 0c0 1.367.273 2.409.82 3.125s1.351 1.074 2.412 1.074 1.867-.356 2.417-1.069.825-1.756.825-3.13c0-1.361-.275-2.394-.825-3.101s-1.362-1.06-2.437-1.06c-1.061 0-1.862.348-2.402 1.045s-.81 1.735-.81 3.116zm18.32 5.361v-6.924c0-.873-.199-1.523-.596-1.953s-1.019-.645-1.865-.645c-1.12 0-1.94.303-2.461.908s-.781 1.605-.781 2.998V126h-1.621v-10.703h1.318l.264 1.465h.078c.332-.527.797-.936 1.396-1.226s1.266-.435 2.002-.435c1.289 0 2.259.311 2.91.933s.977 1.616.977 2.983V126h-1.621z\"/></svg>"

/***/ }),

/***/ "../src/components/foundation/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FoundationPlainWordmark = __webpack_require__("../src/components/foundation/plain-wordmark/FoundationPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FoundationPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/foundation/plain/FoundationPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _FoundationPlain = __webpack_require__("../src/components/foundation/plain/FoundationPlain.svg");
	
	var _FoundationPlain2 = _interopRequireDefault(_FoundationPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** FoundationPlain */
	function FoundationPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'FoundationPlain',
	    svg: _FoundationPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	FoundationPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = FoundationPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/foundation/plain/FoundationPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#008CBA\" d=\"M116.173 64.1l1.466.472.087-.159c-.8-1.056-1.576-2.191-3.034-2.396-1.061-.149-2.147-.108-3.223-.151.035-.51-.153-.69-.66-.482-.479.196-.973.356-1.458.539-1.163.437-2.321.889-3.491 1.305-.205.073-.461-.001-.693-.007.017-.218 0-.446.057-.653.214-.779.458-1.549.678-2.326.073-.259.11-.529.164-.792l1.105.878c.225-2.741-.326-5.136-1.755-7.449l1.433.08c-.644-1.489-1.602-2.617-2.945-3.412-1.694-1.004-3.604-.986-5.477-1.138-.295-.024-.594-.003-.956-.003 1.423 2.374 2.019 6.36 1.156 7.71l-.479-.807c-1.073 1.737-2.09 3.56-3.281 5.262-1.195 1.708-2.672 3.167-4.715 4.116l.248-1.223c-.304.08-.494.149-.69.179-.509.077-1.037.252-1.526.178-.915-.14-1.809-.418-2.707-.659-.616-.166-1.223-.364-1.834-.547l.001.003-.129-.138c-.713-.499-.598-1.094-.246-1.758.241-.455.412-.947.601-1.428.428-1.093.847-2.19 1.27-3.285.422-.473.9-.907 1.25-1.427.39-.58.686-1.228.978-1.866.209-.458.493-.773.972-.975a1.46 1.46 0 0 0 .69-.65c.246-.496.398-1.041.562-1.574.129-.424-.031-.728-.463-.869l-.53-.174c.046-.18.068-.371.145-.537 1.309-2.798 2.578-5.615 3.952-8.382 1.401-2.823 2.894-5.601 4.375-8.383.314-.591.752-1.116 1.133-1.67.663.044 1.325.115 1.988.129 2.977.062 5.679-.691 7.873-2.805 2.3-2.215 3.884-4.893 4.941-7.893l.214-.543-.416.262c-2.932 2.006-6.098 3.113-9.705 2.532.042-.116.058-.251.128-.346 1.264-1.711 2.527-3.422 3.808-5.121.453-.601.951-1.167 1.472-1.801-.324-.123-.55-.222-.784-.296-1.202-.378-2.401-.768-3.612-1.117-.515-.148-.623-.403-.406-.867.51-1.088 1.007-2.183 1.514-3.272l.567-1.013C102.818 6.79 100 6.727 97 7.099V5.323c-2 .182-2.419.288-3.519.531-1.092.24-2.189.617-3.265.934l-.159-.101 2.521-4.368c-1.306.149-2.527.224-3.72.438-2.393.428-5.106.91-7.484 1.414A61.242 61.242 0 0 0 78 4.994V3.112c-1 .271-2.777 1.055-4.489 1.692.35-1.05.814-1.924 1.088-2.805.06-.192.104-.415.111-.624-.09-.033-.145-.106-.229-.094-.733.106-1.447.207-2.173.349-3.778.741-7.366 1.992-10.744 3.853-.384.212-.77.411-1.314.7l-.256-4.037c-2.035.718-3.987 1.66-5.394 3.466l-.801-3.114-.007-.243-.037-.116-.061.069c-.175.202-.368.391-.522.608-1.603 2.258-2.446 4.78-2.602 7.539l-1.29-2.83-1.817 8.597-3.064-3.904a36.03 36.03 0 0 0-2.071 8.766l-2.152-2.427c-1.436 4.394-2.656 8.712-3.108 13.274-1.082-.659-1.744-1.526-2.197-2.582-.654-1.521-.813-3.113-.75-4.745.009-.248-.024-.497-.037-.746l-.182.002c-2.136 7.443-2.69 15.056-2.403 22.787l-2.648-5.041-.178.015c-.179 1.949-.392 3.895-.522 5.847-.081 1.206.121.992-1.032 1.279-3.628.905-7.076 2.207-10.091 4.492-.19.144-.424.229-.638.342l.218.205 3.087 1.154c-1.331 1.479-2.647 2.872-3.88 4.335-1.249 1.482-2.21 3.148-2.933 5.048.691-.288 1.252-.547 1.832-.755.551-.199 1.122-.345 1.683-.514-1.1 1.13-1.926 2.368-2.609 3.694-2.427 4.715-3.288 9.827-3.577 15.037-.188 3.369-.093 6.754.475 10.102.097.571.221 1.138.332 1.707l.25.044 1.505-3.558c.684 3.814.814 7.624.773 11.445l.163.099 1.361-1.659c.188.386.294.542.341.714.714 2.582.905 5.227.714 7.877-.099 1.382-.077 2.723.236 4.062.77 3.284 2.396 6.116 4.642 8.597.447.495 1.069.835 1.622 1.23.262.186.426.116.403-.233l-.053-.029.054.028 1.053.343 1.703.594.078-.16-1.09-2.272-.093-.133.048-.032.048.163c.078.023.18.022.231.072 1.063 1.04 2.415 1.579 3.737 2.171.368.877.972 1.561 1.676 2.161l1.19-.826c.164.203.301.355.417.521.984 1.409 2.332 2.07 4.049 2.001 1.079-.043 2.159-.065 3.239-.09 3.717-.087 7.435-.158 11.151-.262 2.574-.072 5.147-.178 7.72-.29 1.197-.053 2.392-.156 3.703-.243-1.928-5.083-5.942-7.769-10.392-9.673l3.814-1.039c5.522 3.064 11.615 5.078 16.597 9.138l.234-.121-.442-4.497c.308.21.636.418.948.649 1.221.903 2.438 1.813 3.656 2.72l.226.104.084.157c1.831 1.573 3.78 2.779 6.351 2.725 3.55-.075 7.104.002 10.657-.02.271-.001.654-.192.792-.415.8-1.285 1.588-2.582 2.296-3.92 1.776-3.357 3.507-6.738 5.258-10.109l.501-.945c-.789.236-1.471.574-2.148.92-.735.375-1.466.758-2.199 1.137l-.065.055.049-.072c.077-.233.114-.49.238-.695 1.597-2.64 3.143-5.314 4.832-7.895 1.677-2.564 3.631-4.961 4.663-7.897.471-1.342.843-2.718 1.26-4.079l-.019-.016-.122.006c-.75.527-1.463 1.117-2.257 1.565-.956.54-1.98.959-2.975 1.431l-.029.052-.023-.023.052-.028.167-.59.767-2.929c-.307-.018-.436.041-.562.104-2.146 1.086-4.256 2.251-6.445 3.24-3 1.356-5.807 3-8.361 5.074-.863.701-1.688 1.448-2.548 2.189l-.195-.136c-.847-.76-1.69-1.525-2.539-2.283-.532-.476-1.072-.941-1.608-1.413 1.849-2.37 3.333-4.953 4.229-7.822.577-1.848.939-3.763 1.397-5.649l.528-.159c1.439-.516 2.903-.943 4.451-.839.667.045 1.325.236 1.987.361l-.5-1.121-.05-.059.035.01.018.046c.12.024.249.028.357.077 1.15.52 2.272 1.106 3.447 1.559 1.929.742 3.939 1.094 6.018.99.279-.014.478-.039.262-.376.198.052.401.088.592.16 1.534.579 3.131.865 4.752.686 1.493-.165 2.698-.907 3.365-2.371l.475.222c.411-1.152.049-2.229-.161-3.319-.036-.188-.036-.467.075-.585.402-.433.858-.816 1.316-1.238l.281.645c.642-1.068.658-2.241.735-3.546l.618.76.241-.096c-.193-.949-.209-1.983-.622-2.825-.576-1.176-.609-2.122.164-3.21.458-.644.65-1.477 1.054-2.446.074.199.093.312.154.394.048.064.148.089.261.151-.057-1.719-.838-3.115-1.708-4.6z\"/></svg>"

/***/ }),

/***/ "../src/components/foundation/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FoundationPlain = __webpack_require__("../src/components/foundation/plain/FoundationPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FoundationPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gatling/plain-wordmark/GatlingPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GatlingPlainWordmark = __webpack_require__("../src/components/gatling/plain-wordmark/GatlingPlainWordmark.svg");
	
	var _GatlingPlainWordmark2 = _interopRequireDefault(_GatlingPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GatlingPlainWordmark */
	function GatlingPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GatlingPlainWordmark',
	    svg: _GatlingPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GatlingPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GatlingPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gatling/plain-wordmark/GatlingPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><style>.st0{fill:#e77500}</style><path class=\"st0\" d=\"M25.5 43.6H8.8c-4.6 0-8.3 3.7-8.3 8.3v16.7c0 4.6 3.7 8.3 8.3 8.3h16.7c4.6 0 8.3-3.7 8.3-8.3V51.9c0-4.5-3.8-8.3-8.3-8.3zm-7 27.7c-6.2.9-12.2-3.5-12.8-9.3-.8-6.8 3.7-12.3 10.5-12.8 3-.2 6-.1 9 0h2.3v.9c.1.9-.2 2.2-.9 2.7-1 .8-2.4 1.3-3.7 1.5-1.7.2-3.4 0-5.2.1-3.8.1-6.3 1.8-6.8 4.6-.5 2.9.4 5.3 3.2 6.6 3.1 1.5 6.2.6 8.9-2.7-3.4-.7-7.8 1.1-8.3-4.7h13.9c1 6.8-3.1 12.2-10.1 13.1zm18.3-5.2c0-.4 0-.7.1-1.1.1-.4.3-.9.6-1.4.3-.6.7-1.1 1.2-1.5S40 61.3 41 61c1-.3 2.2-.5 3.6-.5 1 0 2 .1 3.2.2 0-2.3-1.3-3.4-3.8-3.4-2 0-3.8.3-5.3.9v-3.6c1.7-.6 3.5-.9 5.5-.9 2.6 0 4.5.7 5.9 2s2 3.2 2 5.7v4.9c0 1.7-.6 3.1-1.9 4.3s-3.1 1.8-5.7 1.8c-2.7 0-4.6-.6-5.9-1.8-1.2-1.3-1.8-2.8-1.8-4.5zm4.3-.6c0 1.9 1.1 2.9 3.4 2.9 2.2 0 3.2-.9 3.2-2.7v-2.3c-1-.1-1.9-.2-2.6-.2-2.6 0-4 .8-4 2.3zm13.7-7.8V54h3v-5.3h4.3V54h4.3v3.7h-4.3v8.9c0 .8.2 1.3.5 1.6s.9.4 1.7.4c.8 0 1.5-.1 2.1-.4v3.6c-.8.4-1.8.5-2.8.5h-.1c-1.8 0-3.2-.5-4.2-1.6s-1.5-2.5-1.5-4.4v-8.6h-3zM71.1 72V47.2h4.3V72h-4.3zm10.2-20.4v-4h4.4v4h-4.4zm0 20.4V54h4.3v18h-4.3zm10.1 0V55.7c2.6-1.3 5.4-2 8.2-2 2.5 0 4.5.7 5.9 2 1.4 1.3 2.1 3.1 2.1 5.5V72h-4.3V60.8c0-.5 0-.9-.1-1.2s-.3-.7-.5-1-.7-.6-1.3-.8-1.4-.3-2.3-.3c-1.1 0-2.2.1-3.3.3V72h-4.4zm21-9.1c0-1.6.2-3 .6-4.1s.9-2.1 1.5-2.7c.6-.6 1.2-1.1 2-1.5s1.4-.6 2-.7c.6-.1 1.1-.1 1.7-.1 2.5 0 4.4.6 5.6 1.7s1.8 2.5 1.8 4.2v12.8c0 .6-.1 1.1-.2 1.6s-.3 1.1-.7 1.7-.8 1.2-1.4 1.6-1.4.8-2.4 1.1-2.2.5-3.6.5c-1.9 0-3.6-.2-5.2-.7v-3.9c1.4.5 3 .7 4.7.7 1 0 1.8-.1 2.5-.2.6-.2 1.1-.4 1.3-.7.2-.3.4-.6.4-.8.1-.2.1-.5.1-.9v-1c-1 .2-1.9.3-2.7.3-2.6 0-4.6-.8-6-2.3-1.3-1.6-2-3.7-2-6.6zm4.3.1c0 2 .3 3.4 1 4.1s1.6 1.1 3 1.1c.9 0 1.7-.1 2.6-.2v-8.3c0-1.3-1-2-3-2h-.1c-1.1 0-2 .4-2.6 1.3s-.9 2.1-.9 4z\"/></svg>"

/***/ }),

/***/ "../src/components/gatling/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GatlingPlainWordmark = __webpack_require__("../src/components/gatling/plain-wordmark/GatlingPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GatlingPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gatling/plain/GatlingPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GatlingPlain = __webpack_require__("../src/components/gatling/plain/GatlingPlain.svg");
	
	var _GatlingPlain2 = _interopRequireDefault(_GatlingPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GatlingPlain */
	function GatlingPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GatlingPlain',
	    svg: _GatlingPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GatlingPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GatlingPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gatling/plain/GatlingPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><style>.st0{fill:#e77500}</style><path class=\"st0\" d=\"M94.3 3.9H33.7C17.1 3.9 3.5 17.5 3.5 34.1v60.6c0 16.6 13.6 30.2 30.2 30.2h60.6c16.6 0 30.2-13.6 30.2-30.2V34.1c0-16.6-13.6-30.2-30.2-30.2zM68.9 104.7c-22.4 3-44.2-12.9-46.6-34.1-2.8-24.8 13.4-44.8 38.2-46.4 10.8-.7 21.8-.4 32.7 0 1.8.1 8.2.1 8.2.1v3.1c.2 3.3-.9 8-3.3 9.9-3.7 2.9-8.7 4.7-13.4 5.4-6.2.9-12.5.1-18.8.3-13.9.3-22.8 6.4-24.6 16.9-1.8 10.6 1.5 19.1 11.6 23.9C64 89.1 75.3 86 85.2 73.9 72.7 71.5 56.7 77.8 55 56.8h50.4c4.1 25-10.9 44.4-36.5 47.9z\"/></svg>"

/***/ }),

/***/ "../src/components/gatling/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GatlingPlain = __webpack_require__("../src/components/gatling/plain/GatlingPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GatlingPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gimp/original-wordmark/GimpOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GimpOriginalWordmark = __webpack_require__("../src/components/gimp/original-wordmark/GimpOriginalWordmark.svg");
	
	var _GimpOriginalWordmark2 = _interopRequireDefault(_GimpOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GimpOriginalWordmark */
	function GimpOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GimpOriginalWordmark',
	    svg: _GimpOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GimpOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GimpOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gimp/original-wordmark/GimpOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><radialGradient id=\"a\" cx=\"359.596\" cy=\"-303.644\" r=\"45.158\" gradientTransform=\"matrix(1 0 0 -.435 -297.375 -72.152)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\"/><stop offset=\"1\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#a)\" d=\"M107.4 59.9c0 10.8-20.2 19.6-45.2 19.6S17 70.7 17 59.9s20.2-19.6 45.2-19.6 45.2 8.8 45.2 19.6z\"/><radialGradient id=\"b\" cx=\"202.968\" cy=\"-16.74\" r=\"47.581\" gradientTransform=\"matrix(1.773 0 0 -1.297 -313.84 14.359)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#857C63\"/><stop offset=\"1\" stop-color=\"#221F19\"/></radialGradient><path fill=\"url(#b)\" stroke=\"#2E3436\" stroke-miterlimit=\"10\" d=\"M30.7 11.7S37.8 26.4 54.5 26c34.9-.9 41-19.1 41.9-21.7.9-2.6 2.2-2.2 2.5.2C110.3 107.7 20 63.4 16.8 45.9c17.9-5.2 13.6-15.3 13.6-15.3l.3-18.9z\"/><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"377.399\" y1=\"-70.445\" x2=\"349.841\" y2=\"-75.913\" gradientTransform=\"matrix(1 0 0 -1 -301.337 -16.654)\"><stop offset=\"0\"/><stop offset=\"1\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#c)\" d=\"M43.9 55.3c16.7 3.3 25.2.2 30.1-3.6-1.3-1.7-3.6-3.6-3.6-3.6s5.8 1.6 7.9 4.3c2 2.6.8 4.3.2 7.6-1.2-3-3.4-4.1-3.7-5.3-4.4 6.3-15.5 6-30.9.6z\"/><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"349.459\" y1=\"-38.103\" x2=\"407.97\" y2=\"-104.522\" gradientTransform=\"matrix(1 0 0 -1 -297.5 -17)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".185\" stroke=\"url(#d)\" stroke-miterlimit=\"10\" d=\"M96.5 10.2c-1.4 2.3-3.5 5-6.6 7.7-6.5 5.4-17.4 10.3-35.3 10.7-10.5.3-17.2-4.8-21.3-9.3L33 30.4c.3 1 1 3.4-.2 6.7-1.3 3.5-5.3 7.2-12.3 9.9.6 1.3 1.2 2.6 3.1 4.4 2.5 2.5 6.1 5.2 10.3 7.6 8.4 4.8 19.3 8.6 29.5 8.8 10.2.2 19.4-3.1 25.8-12.4 5.7-8.6 9-23.1 7.3-45.2z\" fill=\"none\"/><radialGradient id=\"e\" cx=\"260.968\" cy=\"17.46\" r=\"8.698\" gradientTransform=\"matrix(1.685 0 0 -1.685 -400.899 56.163)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#B9B9B0\"/></radialGradient><path fill=\"url(#e)\" stroke=\"#888A85\" stroke-width=\".783\" stroke-miterlimit=\"10\" d=\"M48.8 33.8c0 5.6-4.5 10.1-10.1 10.1s-10.1-4.5-10.1-10.1 4.5-10.1 10.1-10.1 10.1 4.6 10.1 10.1z\"/><radialGradient id=\"f\" cx=\"209.674\" cy=\"-170.214\" r=\"11.954\" gradientTransform=\"matrix(.797 -.46 -.537 -.931 -242.623 -23.267)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#5B676B\"/><stop offset=\"1\" stop-color=\"#141718\"/></radialGradient><path fill=\"url(#f)\" stroke=\"#000\" stroke-miterlimit=\"10\" d=\"M28.8 37.6c4.9 6.8 4.9 15 .1 18.5-4.8 3.5-12.6.8-17.5-6s-4.9-15-.1-18.5c4.8-3.4 12.6-.7 17.5 6z\"/><path fill=\"#2E3436\" stroke=\"#000\" stroke-width=\"1.174\" stroke-miterlimit=\"10\" d=\"M46 35.3c0 2.7-2.2 4.8-4.8 4.8-2.7 0-4.8-2.2-4.8-4.8s2.2-4.8 4.8-4.8c2.6 0 4.8 2.1 4.8 4.8z\"/><linearGradient id=\"g\" gradientUnits=\"userSpaceOnUse\" x1=\"157.619\" y1=\"-207.564\" x2=\"156.868\" y2=\"-226.784\" gradientTransform=\"scale(1 -1) rotate(37 -170.853 -336.45)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".281\" stroke=\"url(#g)\" stroke-miterlimit=\"10\" d=\"M12.1 33.9C10.6 35 9.7 37 9.8 39.8c.1 2.7 1.1 6 3.4 9 2.2 2.9 5.1 4.9 7.7 5.7 2.6.8 4.7.6 6.3-.6 1.6-1.2 2.4-3.3 2.4-6s-1.1-6-3.3-8.9-5-4.9-7.6-5.7c-2.7-.8-5-.6-6.6.6z\" fill=\"none\"/><path fill=\"#fff\" d=\"M19.4 38.4c0 2.9-2 5.2-4.4 5.2s-4.4-2.3-4.4-5.2c0-2.9 2-5.2 4.4-5.2 2.5 0 4.4 2.3 4.4 5.2zM42.6 33.1c0 1.9-1.5 3.4-3.4 3.4s-3.4-1.5-3.4-3.4 1.5-3.4 3.4-3.4 3.4 1.5 3.4 3.4z\"/><radialGradient id=\"h\" cx=\"238.858\" cy=\"30.974\" r=\"8.698\" gradientTransform=\"matrix(1.978 0 0 -1.978 -412.858 87.869)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#B9B9B0\"/></radialGradient><path fill=\"url(#h)\" stroke=\"#888A85\" stroke-width=\".667\" stroke-miterlimit=\"10\" d=\"M71.4 34.9c0 6.5-5.3 11.8-11.8 11.8s-11.8-5.3-11.8-11.8S53 23.1 59.5 23.1s11.9 5.3 11.9 11.8z\"/><path fill=\"#2E3436\" stroke=\"#000\" stroke-miterlimit=\"10\" d=\"M68 36.7c0 3.1-2.5 5.7-5.7 5.7-3.1 0-5.7-2.5-5.7-5.7s2.5-5.7 5.7-5.7c3.1 0 5.7 2.5 5.7 5.7z\"/><path fill=\"#fff\" d=\"M64.1 34c0 2.2-1.8 3.9-3.9 3.9s-3.9-1.8-3.9-3.9c0-2.2 1.8-3.9 3.9-3.9s3.9 1.8 3.9 3.9z\"/><g transform=\"matrix(-.115 -.39 .39 -.115 24.715 29.689)\"><linearGradient id=\"i\" gradientUnits=\"userSpaceOnUse\" x1=\"1915.16\" y1=\"-1061.496\" x2=\"1892.237\" y2=\"-1081.433\" gradientTransform=\"matrix(-.115 .39 .39 .115 524.484 -501.144)\"><stop offset=\"0\" stop-color=\"#6E3D09\"/><stop offset=\".242\" stop-color=\"#EA8113\"/><stop offset=\".621\" stop-color=\"#5C3307\"/><stop offset=\"1\" stop-color=\"#E07C12\"/></linearGradient><path fill=\"url(#i)\" stroke=\"#673907\" stroke-width=\"2.461\" stroke-linecap=\"round\" d=\"M-144.8 139l9.2 8.6c20.7-15.8 42.3-49.7 42.3-49.7 4.9-5.5-.3-9.3-5.4-5.9 0-.1-32.1 24.9-46.1 47z\"/><linearGradient id=\"j\" gradientUnits=\"userSpaceOnUse\" x1=\"2014.528\" y1=\"-1149.438\" x2=\"2023.719\" y2=\"-1140.932\" gradientTransform=\"matrix(-.115 .39 .39 .115 527.382 -504.824)\"><stop offset=\"0\" stop-color=\"#BDBDBD\"/><stop offset=\".333\" stop-color=\"#E2E2E2\"/><stop offset=\".667\" stop-color=\"#A3A3A3\"/><stop offset=\"1\" stop-color=\"#ddd\"/></linearGradient><path fill=\"url(#j)\" stroke=\"#888A85\" stroke-width=\"2.461\" stroke-linecap=\"round\" d=\"M-162.4 161.9l5.6 4.8 21-18.2.7-1.7h2.7c-1.1-3.9-7.3-10.8-11.9-10.8l.2 2.7-1.7.9-16.6 22.3z\"/><path stroke=\"#fff\" stroke-width=\"2.461\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M-145.9 150.9l-10.8 13\" fill=\"none\"/><radialGradient id=\"k\" cx=\"1284.155\" cy=\"-757.829\" r=\"18.754\" gradientTransform=\"matrix(-.181 .598 .613 .176 532.577 -472.016)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#696969\"/><stop offset=\"1\"/></radialGradient><path fill=\"url(#k)\" d=\"M-199.2 186.5c25.8 0 45.5 3.1 49.2-15.7 3-15.2-17.8-22.4-28.2-8.9-10 13-21 24.6-21 24.6z\"/><path opacity=\".528\" fill=\"#fff\" d=\"M-152.3 171.3c0 3.5-2.9 6.4-6.4 6.4-3.5 0-6.4-2.9-6.4-6.4 0-3.5 2.9-6.4 6.4-6.4 3.5 0 6.4 2.9 6.4 6.4z\"/><path fill=\"#fff\" d=\"M-135.7 147.1c0 2.4-1.9 4.3-4.3 4.3s-4.3-1.9-4.3-4.3 1.9-4.3 4.3-4.3 4.3 1.9 4.3 4.3z\"/><linearGradient id=\"l\" gradientUnits=\"userSpaceOnUse\" x1=\"2769.363\" y1=\"1.109\" x2=\"2755.794\" y2=\"12.318\" gradientTransform=\"matrix(-.241 .249 .249 .241 502.979 -510.793)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".428\" fill=\"url(#l)\" d=\"M-182.4 181.9s9.2.2 15.1-3.5c2.1-1.3 3.8 1.6 1.2 2.7-5.4 2.3-16.3.8-16.3.8z\"/></g><linearGradient id=\"m\" gradientUnits=\"userSpaceOnUse\" x1=\"367.057\" y1=\"-72.712\" x2=\"362.519\" y2=\"-73.805\" gradientTransform=\"matrix(1 0 0 -1 -297.5 -17)\"><stop offset=\"0\"/><stop offset=\"1\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#m)\" d=\"M61.9 59.4c3.7.4 7.1-.7 8.4-1.2.2-1.4 1.3-4 5.1-4.2l-1.3-2.3S69.2 55 64 56l-2.1 3.4z\"/><g fill=\"#1A1A1A\"><path d=\"M32.3 85.1l-4.8 27.8 9-.2-.7 2.5-9 .4-.9 6.2 15.7-.5L47.8 85l-15.5.1zm5.3 21l-3.1.1L37 91.9l3-.1-2.4 14.3zm11.8-14.9l6.2-.1-4.7 26.9H45zm4.4 26.2L59.6 85l24.4.3-5.6 32.1-6.2.1 4.5-25.3-2.8.1-4.6 25.7H63l4.5-25.9-2.8-.2-4.4 25.6zm33.4-31.9L80.7 122h6.2l.7-4.1 9.2-.2 5.9-32-15.5-.2zm4.5 26l-3 .1 3.6-19.7 2.8-.1-3.4 19.7zM51 82h6l-.7 6H50z\"/></g></svg>"

/***/ }),

/***/ "../src/components/gimp/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GimpOriginalWordmark = __webpack_require__("../src/components/gimp/original-wordmark/GimpOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GimpOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gimp/original/GimpOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GimpOriginal = __webpack_require__("../src/components/gimp/original/GimpOriginal.svg");
	
	var _GimpOriginal2 = _interopRequireDefault(_GimpOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GimpOriginal */
	function GimpOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GimpOriginal',
	    svg: _GimpOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GimpOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GimpOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gimp/original/GimpOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><radialGradient id=\"a\" cx=\"359.382\" cy=\"134.83\" r=\"50.57\" gradientTransform=\"matrix(1 0 0 -.435 -297.375 140.218)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\"/><stop offset=\"1\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#a)\" d=\"M112.6 81.6c0 12.1-22.6 22-50.6 22s-50.6-9.8-50.6-22 22.6-22 50.6-22 50.6 9.8 50.6 22z\"/><radialGradient id=\"b\" cx=\"201.749\" cy=\"230.895\" r=\"53.284\" gradientTransform=\"matrix(1.773 0 0 -1.297 -313.84 354.268)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#857C63\"/><stop offset=\"1\" stop-color=\"#221F19\"/></radialGradient><path fill=\"url(#b)\" stroke=\"#2E3436\" stroke-miterlimit=\"10\" d=\"M26.7 27.6s8 16.4 26.6 16c39.1-1 45.9-21.4 46.9-24.3 1-2.9 2.5-2.5 2.8.2 12.7 115.6-88.4 66-92 46.3C31.1 60 26.2 48.7 26.2 48.7l.5-21.1z\"/><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"378.844\" y1=\"204.625\" x2=\"347.984\" y2=\"198.502\" gradientTransform=\"matrix(1 0 0 -1 -301.337 279.346)\"><stop offset=\"0\"/><stop offset=\"1\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#c)\" d=\"M41.5 76.4c18.7 3.7 28.2.3 33.7-4-1.5-1.9-4-4-4-4s6.5 1.8 8.8 4.8c2.3 3 .9 4.8.3 8.6-1.3-3.3-3.8-4.6-4.2-5.9-4.9 6.9-17.4 6.6-34.6.5z\"/><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"348.046\" y1=\"240.776\" x2=\"413.386\" y2=\"166.604\" gradientTransform=\"matrix(1 0 0 -1 -297.5 279)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".185\" stroke=\"url(#d)\" stroke-miterlimit=\"10\" d=\"M100.4 25.9c-1.6 2.6-3.9 5.6-7.4 8.6-7.3 6-19.5 11.5-39.6 12-11.7.3-19.3-5.4-23.9-10.4l-.3 12.4c.4 1.2 1.2 3.9-.2 7.5-1.4 4-6 8-13.8 11.1.7 1.4 1.4 2.9 3.5 4.9 2.8 2.8 6.8 5.8 11.5 8.5 9.4 5.4 21.6 9.7 33 9.9 11.4.2 21.8-3.4 28.9-13.9 6.5-9.6 10.2-25.8 8.3-50.6z\" fill=\"none\"/><radialGradient id=\"e\" cx=\"259.173\" cy=\"242.809\" r=\"9.741\" gradientTransform=\"matrix(1.685 0 0 -1.685 -400.899 453.504)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#B9B9B0\"/></radialGradient><path fill=\"url(#e)\" stroke=\"#888A85\" stroke-width=\".783\" stroke-miterlimit=\"10\" d=\"M47 52.4c0 6.2-5 11.3-11.3 11.3s-11.3-5-11.3-11.3 5-11.3 11.3-11.3S47 46.1 47 52.4z\"/><radialGradient id=\"f\" cx=\"274.252\" cy=\"84.308\" r=\"13.387\" gradientTransform=\"matrix(.797 -.46 -.537 -.931 -163.086 262.495)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#5B676B\"/><stop offset=\"1\" stop-color=\"#141718\"/></radialGradient><path fill=\"url(#f)\" stroke=\"#000\" stroke-miterlimit=\"10\" d=\"M24.6 56.6c5.5 7.6 5.5 16.8.2 20.7-5.4 3.9-14.2.9-19.6-6.7C-.3 63-.3 53.8 5 49.9s14.1-.9 19.6 6.7z\"/><path fill=\"#2E3436\" stroke=\"#000\" stroke-width=\"1.174\" stroke-miterlimit=\"10\" d=\"M43.8 54c0 3-2.4 5.4-5.4 5.4-3 0-5.4-2.4-5.4-5.4 0-3 2.4-5.4 5.4-5.4 3 0 5.4 2.4 5.4 5.4z\"/><linearGradient id=\"g\" gradientUnits=\"userSpaceOnUse\" x1=\"230.297\" y1=\"47.32\" x2=\"229.46\" y2=\"25.884\" gradientTransform=\"scale(1 -1) rotate(37 273.194 -336.595)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".281\" stroke=\"url(#g)\" stroke-miterlimit=\"10\" d=\"M5.9 52.4C4.2 53.7 3.2 56 3.3 59c.1 3 1.3 6.8 3.8 10.1s5.7 5.5 8.6 6.4c2.9.9 5.3.7 7.1-.7 1.8-1.3 2.7-3.7 2.6-6.7s-1.2-6.7-3.7-10-5.6-5.4-8.6-6.4c-2.9-.9-5.4-.6-7.2.7z\" fill=\"none\"/><path fill=\"#fff\" d=\"M14.1 57.5c0 3.2-2.2 5.9-4.9 5.9s-4.9-2.6-4.9-5.9c0-3.2 2.2-5.9 4.9-5.9s4.9 2.7 4.9 5.9zM40 51.5c0 2.1-1.7 3.8-3.8 3.8-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8 2.2.1 3.8 1.8 3.8 3.8z\"/><radialGradient id=\"h\" cx=\"238.588\" cy=\"244.872\" r=\"9.741\" gradientTransform=\"matrix(1.978 0 0 -1.978 -412.858 528.573)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#B9B9B0\"/></radialGradient><path fill=\"url(#h)\" stroke=\"#888A85\" stroke-width=\".667\" stroke-miterlimit=\"10\" d=\"M72.2 53.6c0 7.3-5.9 13.2-13.2 13.2s-13.2-5.9-13.2-13.2S51.7 40.4 59 40.4s13.2 5.9 13.2 13.2z\"/><path fill=\"#2E3436\" stroke=\"#000\" stroke-miterlimit=\"10\" d=\"M68.5 55.5c0 3.5-2.9 6.4-6.4 6.4-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4c3.5.1 6.4 2.9 6.4 6.4z\"/><path fill=\"#fff\" d=\"M64.1 52.6c0 2.4-2 4.4-4.4 4.4s-4.4-2-4.4-4.4c0-2.4 2-4.4 4.4-4.4 2.4 0 4.4 2 4.4 4.4z\"/><g transform=\"matrix(-.115 -.39 .39 -.115 24.715 29.689)\"><linearGradient id=\"i\" gradientUnits=\"userSpaceOnUse\" x1=\"1581.422\" y1=\"-398.274\" x2=\"1555.752\" y2=\"-420.6\" gradientTransform=\"matrix(-.115 .39 .39 .115 175.179 -456.047)\"><stop offset=\"0\" stop-color=\"#6E3D09\"/><stop offset=\".242\" stop-color=\"#EA8113\"/><stop offset=\".621\" stop-color=\"#5C3307\"/><stop offset=\"1\" stop-color=\"#E07C12\"/></linearGradient><path fill=\"url(#i)\" stroke=\"#673907\" stroke-width=\"2.461\" stroke-linecap=\"round\" d=\"M-201.5 132l10.3 9.6c23.1-17.7 47.4-55.7 47.4-55.7 5.5-6.2-.3-10.4-6-6.6 0 0-36 28-51.7 52.7z\"/><linearGradient id=\"j\" gradientUnits=\"userSpaceOnUse\" x1=\"1691.417\" y1=\"-496.243\" x2=\"1701.71\" y2=\"-486.718\" gradientTransform=\"matrix(-.115 .39 .39 .115 178.077 -459.728)\"><stop offset=\"0\" stop-color=\"#BDBDBD\"/><stop offset=\".333\" stop-color=\"#E2E2E2\"/><stop offset=\".667\" stop-color=\"#A3A3A3\"/><stop offset=\"1\" stop-color=\"#ddd\"/></linearGradient><path fill=\"url(#j)\" stroke=\"#888A85\" stroke-width=\"2.461\" stroke-linecap=\"round\" d=\"M-221.1 157.6l6.2 5.4 23.5-20.4.8-2h3c-1.2-4.3-8.2-12.1-13.3-12.1l.2 3-1.9 1.1-18.5 25z\"/><path stroke=\"#fff\" stroke-width=\"2.461\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M-202.7 145.3l-12.1 14.6\" fill=\"none\"/><radialGradient id=\"k\" cx=\"958.406\" cy=\"-380.262\" r=\"21.002\" gradientTransform=\"matrix(-.181 .598 .613 .176 183.272 -348.089)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#696969\"/><stop offset=\"1\"/></radialGradient><path fill=\"url(#k)\" d=\"M-262.4 185.2c28.9 0 50.9 3.4 55.1-17.6 3.4-17-20-25.1-31.5-10-11.2 14.6-23.6 27.6-23.6 27.6z\"/><path opacity=\".528\" fill=\"#fff\" d=\"M-209.8 168.2c0 4-3.2 7.2-7.2 7.2s-7.2-3.2-7.2-7.2 3.2-7.2 7.2-7.2 7.2 3.2 7.2 7.2z\"/><path fill=\"#fff\" d=\"M-191.2 141.1c0 2.7-2.2 4.8-4.8 4.8s-4.8-2.2-4.8-4.8c0-2.7 2.2-4.8 4.8-4.8 2.6-.1 4.8 2.1 4.8 4.8z\"/><linearGradient id=\"l\" gradientUnits=\"userSpaceOnUse\" x1=\"2046.356\" y1=\"702.985\" x2=\"2031.16\" y2=\"715.537\" gradientTransform=\"matrix(-.241 .249 .249 .241 95.193 -501.932)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".428\" fill=\"url(#l)\" d=\"M-243.6 180s10.3.3 16.9-3.9c2.3-1.5 4.2 1.8 1.4 3-6.1 2.6-18.3.9-18.3.9z\"/></g><linearGradient id=\"m\" gradientUnits=\"userSpaceOnUse\" x1=\"367.723\" y1=\"202.128\" x2=\"362.641\" y2=\"200.904\" gradientTransform=\"matrix(1 0 0 -1 -297.5 279)\"><stop offset=\"0\"/><stop offset=\"1\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#m)\" d=\"M61.7 81c4.1.4 7.9-.8 9.5-1.3.3-1.5 1.5-4.5 5.7-4.7l-1.5-2.6s-5.4 3.7-11.3 4.8L61.7 81z\"/></svg>"

/***/ }),

/***/ "../src/components/gimp/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GimpOriginal = __webpack_require__("../src/components/gimp/original/GimpOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GimpOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gimp/plain-wordmark/GimpPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GimpPlainWordmark = __webpack_require__("../src/components/gimp/plain-wordmark/GimpPlainWordmark.svg");
	
	var _GimpPlainWordmark2 = _interopRequireDefault(_GimpPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GimpPlainWordmark */
	function GimpPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GimpPlainWordmark',
	    svg: _GimpPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GimpPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GimpPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gimp/plain-wordmark/GimpPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M38.8 37.3c-1 0-2-.6-2.5-1.5l-.8-1.4-.1 1.6-.1.7c0 3 2.4 5.4 5.4 5.4 3 0 5.4-2.4 5.4-5.4 0-2.9-2.2-5.2-5.1-5.4l-1.6-.1 1.2 1c.7.5 1.1 1.3 1.1 2.2 0 1.7-1.3 2.9-2.9 2.9zm-.5-12.1c4.6 0 8.4 3.1 9.7 7.2.7-2 1.9-3.7 3.5-5.1-14.9-1-21.3-14.2-21.3-14.2l-.4 16.7c1.8-2.8 5-4.6 8.5-4.6zm23.6 19c3.4 0 6.1-2.8 6.1-6.1s-2.6-6-5.8-6.1l-1.4-.1 1.1.9c.8.7 1.3 1.7 1.3 2.7 0 1.9-1.6 3.5-3.5 3.5-1.3 0-2.4-.7-3.1-1.8l-.6-1.3-.2 1.4-.1.8c.1 3.4 2.8 6.1 6.2 6.1zm58.6 43.1l-1.1-3.8c-2.3-8.2-4.1-14.6-11.2-14-1.1.1-2 .4-2.8 1L98.2 66H98l-.6-1.7-1.1.7c-2.2-1.4-4.8-2.8-7.3-3.9 8.2-9.8 12.7-27 9.5-55.2-.3-2.5-1.6-2.9-2.5-.3-.8 2.4-5.6 16.7-30.5 20.8 3.3 2.1 5.5 5.8 5.5 10 0 6.5-5.3 11.8-11.8 11.8-5.6 0-10.3-3.9-11.5-9.1-1.5 3.7-5.1 6.2-9.3 6.2-4.2 0-7.8-2.6-9.3-6.2l-.3.5-.4-.6c-4.9-6.8-12.7-9.4-17.6-6-4.8 3.5-4.8 11.8.1 18.6 4.1 5.7 10.2 8.4 14.9 7.2C39.7 69 65 77.9 82.1 67c3.4 1.9 7.2 3.8 10.7 5v.1l.3 1.1 1.5-.6.2.2 8 2.9c.1 2.5 1.6 5.3 4.9 6.6 6.1 2.3 11.9 5.3 12 5.4l.9.5-.1-.9zM19 39.8c0 2.9-2 5.3-4.4 5.3-2.4 0-4.4-2.4-4.4-5.3s2-5.3 4.4-5.3 4.4 2.4 4.4 5.3zm60.2 17.3c-2.9-1-5.1-1.7-5.6-1.8-1.8-.8-3.5-.3-4.1 1.1-.4 1 0 2.2.8 3.1-5.7 2.5-15 1.4-26.9-2.8 16.7 3.3 25.2.2 30.2-3.6-1.3-1.7-3.6-3.6-3.6-3.6s5.8 1.6 7.9 4.3c1.1 1.3 1.3 2.2 1.3 3.3zm-47.1 28l-4.8 27.8 9-.2-.7 2.5-9 .4-.9 6.2 15.7-.5L47.6 85l-15.5.1zm5.3 21l-3.1.1 2.5-14.3 3-.1-2.4 14.3zm11.8-14.9L44.8 118h5.9l4.8-26.9zM59.4 85l-5.8 32.4 6.5.1 4.4-25.6 2.8.2-4.5 25.9h6.3l4.6-25.7 2.9-.1-4.6 25.3 6.2-.1 5.6-32.1zm21.1 37h6.2l.7-4.1 9.2-.2 5.9-32-15.5-.2-6.5 36.5zm11.6-30.1l2.8-.1-3.4 19.7-3 .1 3.6-19.7zM56.8 82h-6l-1 6h6.3z\" fill=\"#716955\"/></svg>"

/***/ }),

/***/ "../src/components/gimp/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GimpPlainWordmark = __webpack_require__("../src/components/gimp/plain-wordmark/GimpPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GimpPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gimp/plain/GimpPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GimpPlain = __webpack_require__("../src/components/gimp/plain/GimpPlain.svg");
	
	var _GimpPlain2 = _interopRequireDefault(_GimpPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GimpPlain */
	function GimpPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GimpPlain',
	    svg: _GimpPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GimpPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GimpPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gimp/plain/GimpPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M36.4 54.4c-1.1 0-2.2-.6-2.7-1.6l-.8-1.6-.3 1.8-.1.8c0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-3.1-2.5-5.7-5.6-5.9l-1.7-.1 1.4 1.1c.7.6 1.2 1.5 1.2 2.4-.1 1.7-1.5 3.1-3.2 3.1zM35.9 41c5 0 9.3 3.4 10.6 7.9.8-2.2 2.1-4.1 3.8-5.6C34 42.3 27 27.8 27 27.8l-.4 18.3c1.9-3 5.3-5.1 9.3-5.1zm25.8 21c3.7 0 6.7-3 6.7-6.7 0-3.6-2.8-6.6-6.4-6.7l-1.5-.1 1.2.9c.9.7 1.4 1.8 1.4 3 0 2.1-1.7 3.8-3.8 3.8-1.4 0-2.7-.8-3.4-2l-.7-1.3-.2 1.5-.1.9C55 58.9 58 62 61.7 62zm64.3 47.2c-.4-1.4-.8-2.8-1.2-4.1-2.5-9-4.4-16-12.3-15.3-1.2.1-2.2.5-3.1 1.1l-7.9-5h-.3l-.6-1.9-1.2.8c-2.5-1.6-5.3-3-8.1-4.3 9-10.7 13.9-29.6 10.5-60.5-.3-2.7-1.8-3.1-2.8-.2-.8 2.5-6.1 18.3-33.4 22.7 3.6 2.3 6 6.3 6 10.9 0 7.2-5.8 13-13 13-6.1 0-11.3-4.3-12.6-10-1.7 4-5.6 6.8-10.2 6.8s-8.5-2.8-10.2-6.8c-.1.2-.2.4-.3.5-.1-.2-.3-.4-.4-.7-5.4-7.4-14-10.4-19.3-6.6C.3 53.5.4 62.6 5.8 70c4.5 6.2 11.2 9.3 16.4 7.9 15.1 11.2 43 20.9 61.7 9 3.7 2.1 7.9 4.1 11.8 5.5v.1l.4 1.2 1.6-.6.2.2 8.8 3.2c.1 2.8 1.8 5.9 5.4 7.3 6.7 2.6 13.1 5.8 13.1 5.9l1 .5-.2-1zM5 57.1c0-3.2 2.2-5.8 4.8-5.8 2.7 0 4.8 2.6 4.8 5.8 0 3.2-2.2 5.8-4.8 5.8-2.7 0-4.8-2.6-4.8-5.8zm36.6 18.6c18.3 3.7 27.7.3 33.1-4-1.4-1.9-3.9-3.9-3.9-3.9s6.4 1.8 8.7 4.7c1 1.3 1.3 2.4 1.2 3.5-3.2-1.1-5.6-1.8-6.1-2-2-.9-3.9-.3-4.4 1.2-.4 1.1-.1 2.4.9 3.4-6.3 2.9-16.6 1.7-29.5-2.9z\" fill=\"#716955\"/></svg>"

/***/ }),

/***/ "../src/components/gimp/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GimpPlain = __webpack_require__("../src/components/gimp/plain/GimpPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GimpPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/git/original-wordmark/GitOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GitOriginalWordmark = __webpack_require__("../src/components/git/original-wordmark/GitOriginalWordmark.svg");
	
	var _GitOriginalWordmark2 = _interopRequireDefault(_GitOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GitOriginalWordmark */
	function GitOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GitOriginalWordmark',
	    svg: _GitOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GitOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GitOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/git/original-wordmark/GitOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#31251C\" d=\"M76.397 55.676c-2.737 0-4.775 1.344-4.775 4.579 0 2.437 1.343 4.129 4.628 4.129 2.784 0 4.676-1.641 4.676-4.23 0-2.934-1.693-4.478-4.529-4.478zm-5.471 22.84c-.648.795-1.294 1.64-1.294 2.637 0 1.989 2.536 2.587 6.021 2.587 2.885 0 6.816-.202 6.816-2.885 0-1.595-1.892-1.693-4.281-1.843l-7.262-.496zm14.725-22.69c.895 1.145 1.842 2.737 1.842 5.026 0 5.522-4.329 8.756-10.597 8.756-1.594 0-3.037-.198-3.932-.447l-1.642 2.637 4.875.297c8.608.549 13.682.798 13.682 7.413 0 5.723-5.024 8.955-13.682 8.955-9.006 0-12.438-2.289-12.438-6.218 0-2.24.996-3.431 2.737-5.076-1.643-.694-2.189-1.937-2.189-3.281 0-1.095.547-2.09 1.443-3.036.896-.944 1.891-1.891 3.084-2.985-2.438-1.194-4.278-3.781-4.278-7.464 0-5.721 3.781-9.65 11.393-9.65 2.14 0 3.435.197 4.578.498h9.703v4.228l-4.579.347zm13.332-9.04c-2.837 0-4.479-1.643-4.479-4.48 0-2.833 1.642-4.377 4.479-4.377 2.886 0 4.527 1.543 4.527 4.377.001 2.837-1.641 4.48-4.527 4.48zm-6.42 29.9v-3.929l2.539-.348c.696-.1.795-.249.795-.997V56.785c0-.546-.148-.896-.647-1.044l-2.687-.946.547-4.028h10.301v20.646c0 .798.048.896.796.997l2.538.348v3.929H92.563v-.001zm33.857-1.93c-2.141 1.043-5.274 1.99-8.112 1.99-5.92 0-8.158-2.386-8.158-8.011V55.7c0-.297 0-.497-.399-.497h-3.482v-4.428c4.38-.499 6.12-2.688 6.667-8.111h4.728v7.067c0 .347 0 .498.398.498h7.015v4.975h-7.413v11.89c0 2.935.697 4.079 3.383 4.079 1.395 0 2.836-.347 4.03-.795l1.343 4.378z\"/><path fill=\"#F34F29\" d=\"M52.7 61.7L29.951 38.952a3.355 3.355 0 0 0-4.744 0l-4.724 4.724 5.991 5.992a3.983 3.983 0 0 1 4.1.956 3.988 3.988 0 0 1 .947 4.125l5.775 5.775a3.988 3.988 0 0 1 4.125 6.593 3.992 3.992 0 0 1-6.516-4.342l-5.386-5.386-.001 14.174a3.992 3.992 0 0 1 1.056 6.401 3.993 3.993 0 1 1-4.339-6.518V57.141a3.99 3.99 0 0 1-2.167-5.236l-5.906-5.908L2.563 61.595a3.356 3.356 0 0 0 0 4.747L25.312 89.09a3.357 3.357 0 0 0 4.746 0L52.7 66.446a3.355 3.355 0 0 0 0-4.746z\"/><path fill=\"none\" d=\"M1.58 37.928h124.84v52.143H1.58z\"/></svg>"

/***/ }),

/***/ "../src/components/git/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GitOriginalWordmark = __webpack_require__("../src/components/git/original-wordmark/GitOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GitOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/git/original/GitOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GitOriginal = __webpack_require__("../src/components/git/original/GitOriginal.svg");
	
	var _GitOriginal2 = _interopRequireDefault(_GitOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GitOriginal */
	function GitOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GitOriginal',
	    svg: _GitOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GitOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GitOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/git/original/GitOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#F34F29\" d=\"M124.737 58.378L69.621 3.264c-3.172-3.174-8.32-3.174-11.497 0L46.68 14.71l14.518 14.518c3.375-1.139 7.243-.375 9.932 2.314 2.703 2.706 3.461 6.607 2.294 9.993l13.992 13.993c3.385-1.167 7.292-.413 9.994 2.295 3.78 3.777 3.78 9.9 0 13.679a9.673 9.673 0 0 1-13.683 0 9.677 9.677 0 0 1-2.105-10.521L68.574 47.933l-.002 34.341a9.708 9.708 0 0 1 2.559 1.828c3.778 3.777 3.778 9.898 0 13.683-3.779 3.777-9.904 3.777-13.679 0-3.778-3.784-3.778-9.905 0-13.683a9.65 9.65 0 0 1 3.167-2.11V47.333a9.581 9.581 0 0 1-3.167-2.111c-2.862-2.86-3.551-7.06-2.083-10.576L41.056 20.333 3.264 58.123a8.133 8.133 0 0 0 0 11.5l55.117 55.114c3.174 3.174 8.32 3.174 11.499 0l54.858-54.858a8.135 8.135 0 0 0-.001-11.501z\"/></svg>"

/***/ }),

/***/ "../src/components/git/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GitOriginal = __webpack_require__("../src/components/git/original/GitOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GitOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/git/plain-wordmark/GitPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GitPlainWordmark = __webpack_require__("../src/components/git/plain-wordmark/GitPlainWordmark.svg");
	
	var _GitPlainWordmark2 = _interopRequireDefault(_GitPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GitPlainWordmark */
	function GitPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GitPlainWordmark',
	    svg: _GitPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GitPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GitPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/git/plain-wordmark/GitPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#F34F29\" d=\"M76.004 50.588c-7.655 0-11.459 3.996-11.459 9.75 0 3.704 1.852 6.328 4.304 7.529-1.201 1.101-2.201 2.064-3.102 3.014-.902.952-1.452 1.957-1.452 3.059 0 1.352.55 2.605 2.202 3.303-1.751 1.654-2.753 2.854-2.753 5.107 0 3.953 3.453 6.256 12.511 6.256 8.708 0 13.761-3.251 13.761-9.007 0-6.653-5.103-6.904-13.761-7.456l-4.904-.3 1.652-2.652c.899.25 2.352.45 3.955.45 6.304 0 10.658-3.252 10.658-8.808 0-2.302-1.137-3.903-2.037-5.055l4.421-.35V51h-9.391c-1.15 0-2.453-.412-4.605-.412zm2.252 28.511c2.404.15 4.306.25 4.306 1.854 0 2.699-3.955 2.902-6.856 2.902-3.504 0-6.056-.602-6.056-2.603 0-1.002.65-1.852 1.302-2.652l7.304.499zm-1.949-14.712c-3.304 0-4.655-1.703-4.655-4.154 0-3.253 2.051-4.605 4.804-4.605 2.852 0 4.554 1.552 4.554 4.504 0 2.604-1.902 4.255-4.703 4.255zm22.866-17.702c2.902 0 4.554-1.652 4.554-4.506 0-2.85-1.652-4.403-4.554-4.403-2.853 0-4.505 1.553-4.505 4.403 0 2.853 1.652 4.506 4.505 4.506zM103 71.455V51h-9.733l-.55 3.896 2.667.874c.502.149.616.423.616.973v14.712c0 .752-.422.902-1.123 1.003l-2.877.35V77h15v-4.192l-2.876-.35c-.753-.101-1.124-.2-1.124-1.003zm22.418-1.04c-1.202.45-2.632.799-4.035.799-2.701 0-3.383-1.15-3.383-4.103V55h7v-5h-6.638c-.401 0-.362-.003-.362-.353V43h-4.793c-.55 5-3.207 7.196-7.207 7.698V55h4.003c.401 0-.003.353-.003.652v13.111c0 5.657 2.454 8.058 8.408 8.058 2.854 0 6.107-.951 8.26-2.001l-1.25-4.405zm-95.68-31.609a3.375 3.375 0 0 0-4.773 0l-4.751 4.751 6.027 6.027a4.007 4.007 0 0 1 5.076 5.11l5.809 5.809a4.012 4.012 0 0 1 4.149 6.632 4.014 4.014 0 0 1-5.68 0c-1.18-1.181-1.624-2.914-1.025-4.368L29 57.35v14.257c0 .189.895.441 1.214.759 1.568 1.568 1.644 4.11.075 5.681a3.972 3.972 0 0 1-5.642 0c-1.568-1.571-1.549-4.112.02-5.681.388-.387.333-.68 1.333-.876V57.101c-1-.196-.927-.487-1.314-.876a4.016 4.016 0 0 1-.865-4.39l-5.942-5.943L2.19 61.581a3.374 3.374 0 0 0 0 4.774l22.882 22.881a3.377 3.377 0 0 0 4.773 0L52.62 66.46a3.378 3.378 0 0 0 0-4.774l-22.882-22.88z\"/></svg>"

/***/ }),

/***/ "../src/components/git/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GitPlainWordmark = __webpack_require__("../src/components/git/plain-wordmark/GitPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GitPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/git/plain/GitPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GitPlain = __webpack_require__("../src/components/git/plain/GitPlain.svg");
	
	var _GitPlain2 = _interopRequireDefault(_GitPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GitPlain */
	function GitPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GitPlain',
	    svg: _GitPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GitPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GitPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/git/plain/GitPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#F34F29\" d=\"M124.742 58.378L69.625 3.264c-3.172-3.174-8.32-3.174-11.497 0L46.685 14.71l14.518 14.518c3.375-1.139 7.243-.375 9.932 2.314a9.66 9.66 0 0 1 2.293 9.993L87.42 55.529c3.385-1.167 7.292-.413 9.994 2.295 3.78 3.777 3.78 9.9 0 13.679a9.673 9.673 0 0 1-13.683 0 9.677 9.677 0 0 1-2.105-10.521L68.578 47.933l-.002 34.341a9.708 9.708 0 0 1 2.559 1.828c3.779 3.777 3.779 9.898 0 13.683-3.779 3.777-9.904 3.777-13.679 0-3.778-3.784-4.088-9.905-.311-13.683.934-.933 1.855-1.638 2.855-2.11V47.333c-1-.472-1.92-1.172-2.856-2.111-2.861-2.86-3.396-7.06-1.928-10.576L40.983 20.333 3.229 58.123c-3.175 3.177-3.155 8.325.02 11.5l55.126 55.114c3.173 3.174 8.325 3.174 11.503 0l54.86-54.858c3.175-3.176 3.178-8.327.004-11.501z\"/></svg>"

/***/ }),

/***/ "../src/components/git/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GitPlain = __webpack_require__("../src/components/git/plain/GitPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GitPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/github/original-wordmark/GithubOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GithubOriginalWordmark = __webpack_require__("../src/components/github/original-wordmark/GithubOriginalWordmark.svg");
	
	var _GithubOriginalWordmark2 = _interopRequireDefault(_GithubOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GithubOriginalWordmark */
	function GithubOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GithubOriginalWordmark',
	    svg: _GithubOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GithubOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GithubOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/github/original-wordmark/GithubOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#181616\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M64 1.512c-23.493 0-42.545 19.047-42.545 42.545 0 18.797 12.19 34.745 29.095 40.37 2.126.394 2.907-.923 2.907-2.047 0-1.014-.04-4.366-.058-7.92-11.837 2.573-14.334-5.02-14.334-5.02-1.935-4.918-4.724-6.226-4.724-6.226-3.86-2.64.29-2.586.29-2.586 4.273.3 6.523 4.385 6.523 4.385 3.794 6.504 9.953 4.623 12.38 3.536.383-2.75 1.485-4.628 2.702-5.69-9.45-1.075-19.384-4.724-19.384-21.026 0-4.645 1.662-8.44 4.384-11.42-.442-1.072-1.898-5.4.412-11.26 0 0 3.572-1.142 11.7 4.363 3.395-.943 7.035-1.416 10.65-1.432 3.616.017 7.258.49 10.658 1.432 8.12-5.504 11.688-4.362 11.688-4.362 2.316 5.86.86 10.187.418 11.26 2.728 2.978 4.378 6.774 4.378 11.42 0 16.34-9.953 19.938-19.427 20.99 1.526 1.32 2.886 3.91 2.886 7.88 0 5.692-.048 10.273-.048 11.674 0 1.13.766 2.458 2.922 2.04 16.896-5.632 29.07-21.574 29.07-40.365C106.545 20.56 87.497 1.512 64 1.512z\"/><path d=\"M37.57 62.596c-.095.212-.428.275-.73.13-.31-.14-.482-.427-.382-.64.09-.216.424-.277.733-.132.31.14.486.43.38.642zM39.293 64.52c-.203.187-.6.1-.87-.198-.278-.297-.33-.694-.124-.884.208-.188.593-.1.87.197.28.3.335.693.123.884zm1.677 2.448c-.26.182-.687.012-.95-.367-.262-.377-.262-.83.005-1.013.264-.182.684-.018.95.357.262.385.262.84-.005 1.024zm2.298 2.368c-.233.257-.73.188-1.093-.163-.372-.343-.475-.83-.242-1.087.237-.257.736-.185 1.102.163.37.342.482.83.233 1.086zm3.172 1.374c-.104.334-.582.485-1.064.344-.482-.146-.796-.536-.7-.872.1-.336.582-.493 1.067-.342.48.144.795.53.696.87zm3.48.255c.013.35-.396.642-.902.648-.508.012-.92-.272-.926-.618 0-.354.4-.642.908-.65.506-.01.92.272.92.62zm3.24-.551c.06.342-.29.694-.793.787-.494.092-.95-.12-1.014-.46-.06-.35.297-.7.79-.792.503-.088.953.118 1.017.466zm0 0\"/></g><path d=\"M24.855 108.302h-10.7a.5.5 0 0 0-.5.5v5.232a.5.5 0 0 0 .5.5h4.173v6.5s-.937.32-3.53.32c-3.056 0-7.327-1.116-7.327-10.508 0-9.393 4.448-10.63 8.624-10.63 3.614 0 5.17.636 6.162.943.31.094.6-.216.6-.492l1.193-5.055a.468.468 0 0 0-.192-.39c-.403-.288-2.857-1.66-9.058-1.66-7.144 0-14.472 3.038-14.472 17.65 0 14.61 8.39 16.787 15.46 16.787 5.854 0 9.405-2.502 9.405-2.502.146-.08.162-.285.162-.38v-16.316a.5.5 0 0 0-.5-.5zM79.506 94.81H73.48a.5.5 0 0 0-.498.503l.002 11.644h-9.392V95.313a.5.5 0 0 0-.497-.503H57.07a.5.5 0 0 0-.498.503v31.53c0 .277.224.503.498.503h6.025a.5.5 0 0 0 .497-.504v-13.486h9.392l-.016 13.486c0 .278.224.504.5.504h6.038a.5.5 0 0 0 .497-.504v-31.53a.497.497 0 0 0-.497-.502zm-47.166.717c-2.144 0-3.884 1.753-3.884 3.923 0 2.167 1.74 3.925 3.884 3.925 2.146 0 3.885-1.758 3.885-3.925 0-2.17-1.74-3.923-3.885-3.923zm2.956 9.608H29.29c-.276 0-.522.284-.522.56v20.852c0 .613.382.795.876.795h5.41c.595 0 .74-.292.74-.805v-20.899a.5.5 0 0 0-.498-.502zm67.606.047h-5.98a.5.5 0 0 0-.496.504v15.46s-1.52 1.11-3.675 1.11-2.727-.977-2.727-3.088v-13.482a.5.5 0 0 0-.497-.504h-6.068a.502.502 0 0 0-.498.504v14.502c0 6.27 3.495 7.804 8.302 7.804 3.944 0 7.124-2.18 7.124-2.18s.15 1.15.22 1.285c.07.136.247.273.44.273l3.86-.017a.502.502 0 0 0 .5-.504l-.003-21.166a.504.504 0 0 0-.5-.502zm16.342-.708c-3.396 0-5.706 1.515-5.706 1.515V95.312a.5.5 0 0 0-.497-.503H107a.5.5 0 0 0-.5.503v31.53a.5.5 0 0 0 .5.503h4.192c.19 0 .332-.097.437-.268.103-.17.254-1.454.254-1.454s2.47 2.34 7.148 2.34c5.49 0 8.64-2.784 8.64-12.502s-5.03-10.988-8.428-10.988zm-2.36 17.764c-2.073-.063-3.48-1.004-3.48-1.004v-9.985s1.388-.85 3.09-1.004c2.153-.193 4.228.458 4.228 5.594 0 5.417-.935 6.486-3.837 6.398zm-63.689-.118c-.263 0-.937.107-1.63.107-2.22 0-2.973-1.032-2.973-2.368v-8.866h4.52a.5.5 0 0 0 .5-.504v-4.856a.5.5 0 0 0-.5-.502h-4.52l-.007-5.97c0-.227-.116-.34-.378-.34h-6.16c-.238 0-.367.106-.367.335v6.17s-3.087.745-3.295.805a.5.5 0 0 0-.36.48v3.877a.5.5 0 0 0 .497.503h3.158v9.328c0 6.93 4.86 7.61 8.14 7.61 1.497 0 3.29-.48 3.586-.59.18-.067.283-.252.283-.453l.004-4.265a.51.51 0 0 0-.5-.502z\" fill=\"#100E0F\"/></svg>"

/***/ }),

/***/ "../src/components/github/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GithubOriginalWordmark = __webpack_require__("../src/components/github/original-wordmark/GithubOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GithubOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/github/original/GithubOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GithubOriginal = __webpack_require__("../src/components/github/original/GithubOriginal.svg");
	
	var _GithubOriginal2 = _interopRequireDefault(_GithubOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GithubOriginal */
	function GithubOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GithubOriginal',
	    svg: _GithubOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GithubOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GithubOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/github/original/GithubOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#181616\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M64 5.103c-33.347 0-60.388 27.035-60.388 60.388 0 26.682 17.303 49.317 41.297 57.303 3.017.56 4.125-1.31 4.125-2.905 0-1.44-.056-6.197-.082-11.243-16.8 3.653-20.345-7.125-20.345-7.125-2.747-6.98-6.705-8.836-6.705-8.836-5.48-3.748.413-3.67.413-3.67 6.063.425 9.257 6.223 9.257 6.223 5.386 9.23 14.127 6.562 17.573 5.02.542-3.903 2.107-6.568 3.834-8.076-13.413-1.525-27.514-6.704-27.514-29.843 0-6.593 2.36-11.98 6.223-16.21-.628-1.52-2.695-7.662.584-15.98 0 0 5.07-1.623 16.61 6.19C53.7 35 58.867 34.327 64 34.304c5.13.023 10.3.694 15.127 2.033 11.526-7.813 16.59-6.19 16.59-6.19 3.287 8.317 1.22 14.46.593 15.98 3.872 4.23 6.215 9.617 6.215 16.21 0 23.194-14.127 28.3-27.574 29.796 2.167 1.874 4.097 5.55 4.097 11.183 0 8.08-.07 14.583-.07 16.572 0 1.607 1.088 3.49 4.148 2.897 23.98-7.994 41.263-30.622 41.263-57.294C124.388 32.14 97.35 5.104 64 5.104z\"/><path d=\"M26.484 91.806c-.133.3-.605.39-1.035.185-.44-.196-.685-.605-.543-.906.13-.31.603-.395 1.04-.188.44.197.69.61.537.91zm2.446 2.729c-.287.267-.85.143-1.232-.28-.396-.42-.47-.983-.177-1.254.298-.266.844-.14 1.24.28.394.426.472.984.17 1.255zM31.312 98.012c-.37.258-.976.017-1.35-.52-.37-.538-.37-1.183.01-1.44.373-.258.97-.025 1.35.507.368.545.368 1.19-.01 1.452zm3.261 3.361c-.33.365-1.036.267-1.552-.23-.527-.487-.674-1.18-.343-1.544.336-.366 1.045-.264 1.564.23.527.486.686 1.18.333 1.543zm4.5 1.951c-.147.473-.825.688-1.51.486-.683-.207-1.13-.76-.99-1.238.14-.477.823-.7 1.512-.485.683.206 1.13.756.988 1.237zm4.943.361c.017.498-.563.91-1.28.92-.723.017-1.308-.387-1.315-.877 0-.503.568-.91 1.29-.924.717-.013 1.306.387 1.306.88zm4.598-.782c.086.485-.413.984-1.126 1.117-.7.13-1.35-.172-1.44-.653-.086-.498.422-.997 1.122-1.126.714-.123 1.354.17 1.444.663zm0 0\"/></g></svg>"

/***/ }),

/***/ "../src/components/github/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GithubOriginal = __webpack_require__("../src/components/github/original/GithubOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GithubOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gitlab/original-wordmark/GitlabOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GitlabOriginalWordmark = __webpack_require__("../src/components/gitlab/original-wordmark/GitlabOriginalWordmark.svg");
	
	var _GitlabOriginalWordmark2 = _interopRequireDefault(_GitlabOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GitlabOriginalWordmark */
	function GitlabOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GitlabOriginalWordmark',
	    svg: _GitlabOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GitlabOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GitlabOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gitlab/original-wordmark/GitlabOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#FC6D26\" d=\"M109.757 49.765l-5.14-15.82L94.43 2.596c-.523-1.614-2.805-1.614-3.33 0l-10.187 31.35H47.087L36.9 2.596c-.524-1.614-2.806-1.614-3.33 0l-10.187 31.35-5.14 15.82a3.502 3.502 0 0 0 1.272 3.915L64 86l44.485-32.32a3.502 3.502 0 0 0 1.272-3.915\"/><path fill=\"#E24329\" d=\"M64 86l16.913-52.054H47.087L64 86z\"/><path fill=\"#FC6D26\" d=\"M64 86L47.087 33.946H23.383L64 86z\"/><path fill=\"#FCA326\" d=\"M23.383 33.946l-5.14 15.82a3.502 3.502 0 0 0 1.272 3.914L64 86 23.383 33.946z\"/><path fill=\"#E24329\" d=\"M23.383 33.946h23.704L36.9 2.594c-.524-1.613-2.806-1.613-3.33 0L23.383 33.946z\"/><path fill=\"#FC6D26\" d=\"M64 86l16.913-52.054h23.704L64 86z\"/><path fill=\"#FCA326\" d=\"M104.617 33.946l5.14 15.82a3.502 3.502 0 0 1-1.272 3.914L64 86l40.617-52.054z\"/><path fill=\"#E24329\" d=\"M104.617 33.946H80.913L91.1 2.594c.524-1.613 2.806-1.613 3.33 0l10.187 31.352z\"/><path fill=\"#5C5C5C\" d=\"M65.387 93.983h-4.49l.015 33.405h18.16v-4.13H65.4l-.015-29.275zm30.976 27.54a7.648 7.648 0 0 1-5.56 2.346c-3.418 0-4.795-1.684-4.795-3.877 0-3.315 2.295-4.896 7.192-4.896.918 0 2.397.102 3.162.255v6.17zm-4.642-20.247c-3.624 0-6.95 1.285-9.543 3.423l1.587 2.747c1.836-1.07 4.08-2.142 7.294-2.142 3.673 0 5.305 1.887 5.305 5.05v1.63c-.714-.152-2.193-.254-3.11-.254-7.857 0-11.835 2.755-11.835 8.518 0 5.15 3.162 7.752 7.957 7.752 3.23 0 6.325-1.48 7.396-3.876l.817 3.264h3.163v-17.085c0-5.406-2.347-9.027-9.03-9.027zm23.513 22.746c-1.683 0-3.163-.204-4.285-.714v-15.452c1.53-1.275 3.417-2.193 5.814-2.193 4.336 0 6.02 3.06 6.02 8.007 0 7.037-2.704 10.352-7.55 10.352m1.886-22.746c-4.012 0-6.17 2.73-6.17 2.73v-4.31l-.015-5.713h-4.386l.014 32.59c2.193.917 5.203 1.427 8.467 1.427 8.364 0 12.394-5.355 12.394-14.586 0-7.293-3.723-12.138-10.304-12.138M16.592 97.604c3.98 0 6.53 1.326 8.212 2.652l1.93-3.34c-2.63-2.306-6.167-3.545-9.94-3.545-9.538 0-16.22 5.815-16.22 17.545C.574 123.205 7.784 128 16.03 128c4.132 0 7.652-.97 9.947-1.938l-.094-13.132v-4.13H13.64v4.13h7.805l.094 9.97c-1.02.51-2.806.918-5.204.918-6.63 0-11.07-4.17-11.07-12.954.002-8.925 4.593-13.26 11.326-13.26m31.569-3.621h-4.387l.014 5.61v19.379c0 5.407 2.347 9.028 9.03 9.028.922 0 1.825-.084 2.702-.243v-3.94a13.47 13.47 0 0 1-2.04.154c-3.674 0-5.306-1.886-5.306-5.048V105.56h7.345v-3.672h-7.346l-.014-7.905zm-15.518 33.405h4.387v-25.5H32.64v25.5zm0-29.018h4.387v-4.387H32.64v4.386z\"/></svg>"

/***/ }),

/***/ "../src/components/gitlab/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GitlabOriginalWordmark = __webpack_require__("../src/components/gitlab/original-wordmark/GitlabOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GitlabOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gitlab/original/GitlabOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GitlabOriginal = __webpack_require__("../src/components/gitlab/original/GitlabOriginal.svg");
	
	var _GitlabOriginal2 = _interopRequireDefault(_GitlabOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GitlabOriginal */
	function GitlabOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GitlabOriginal',
	    svg: _GitlabOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GitlabOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GitlabOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gitlab/original/GitlabOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#FC6D26\" d=\"M126.615 72.31l-7.034-21.647L105.64 7.76c-.716-2.206-3.84-2.206-4.556 0l-13.94 42.903H40.856L26.916 7.76c-.717-2.206-3.84-2.206-4.557 0L8.42 50.664 1.385 72.31a4.792 4.792 0 0 0 1.74 5.358L64 121.894l60.874-44.227a4.793 4.793 0 0 0 1.74-5.357\"/><path fill=\"#E24329\" d=\"M64 121.894l23.144-71.23H40.856L64 121.893z\"/><path fill=\"#FC6D26\" d=\"M64 121.894l-23.144-71.23H8.42L64 121.893z\"/><path fill=\"#FCA326\" d=\"M8.42 50.663L1.384 72.31a4.79 4.79 0 0 0 1.74 5.357L64 121.894 8.42 50.664z\"/><path fill=\"#E24329\" d=\"M8.42 50.663h32.436L26.916 7.76c-.717-2.206-3.84-2.206-4.557 0L8.42 50.664z\"/><path fill=\"#FC6D26\" d=\"M64 121.894l23.144-71.23h32.437L64 121.893z\"/><path fill=\"#FCA326\" d=\"M119.58 50.663l7.035 21.647a4.79 4.79 0 0 1-1.74 5.357L64 121.894l55.58-71.23z\"/><path fill=\"#E24329\" d=\"M119.58 50.663H87.145l13.94-42.902c.717-2.206 3.84-2.206 4.557 0l13.94 42.903z\"/></svg>"

/***/ }),

/***/ "../src/components/gitlab/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GitlabOriginal = __webpack_require__("../src/components/gitlab/original/GitlabOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GitlabOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gitlab/plain-wordmark/GitlabPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GitlabPlainWordmark = __webpack_require__("../src/components/gitlab/plain-wordmark/GitlabPlainWordmark.svg");
	
	var _GitlabPlainWordmark2 = _interopRequireDefault(_GitlabPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GitlabPlainWordmark */
	function GitlabPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GitlabPlainWordmark',
	    svg: _GitlabPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GitlabPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GitlabPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gitlab/plain-wordmark/GitlabPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M18.732 52.895c.213.296.476.562.782.785L64 86l44.485-32.32a3.5 3.5 0 0 0 1.272-3.915l-5.14-15.82L94.43 2.596c0-.006-.004-.01-.006-.015-.368-1.1-1.552-1.423-2.428-1-.394.19-.733.542-.895 1.04L80.914 34H47.087L39.65 11.087l-2.75-8.48c-.393-1.21-1.775-1.518-2.663-.913a1.71 1.71 0 0 0-.668.904L23.38 33.948l-1.702 5.24-3.437 10.578a3.5 3.5 0 0 0 .49 3.13zM65.387 94h-4.49l.016 33H79v-4H65.4zm26.459 7.276a15.13 15.13 0 0 0-9.607 3.423l1.554 2.747c1.836-1.07 3.884-2.142 7.097-2.142 3.674 0 5.11 1.887 5.11 5.05v1.63c0-.152-2.013-.254-2.93-.254-7.857 0-11.744 2.755-11.744 8.518 0 5.15 3.208 7.752 8.003 7.752 3.23 0 6.347-1.673 7.418-4.07l.84 3.07H101v-16.697c0-5.406-2.47-9.027-9.154-9.027zM96 121.523c-1 1.173-2.828 2.346-5.378 2.346-3.418 0-4.704-1.684-4.704-3.877 0-3.315 2.16-4.896 7.056-4.896.918 0 3.026.102 3.026.255v6.17zm21.146-20.247c-4.012 0-6.146 2.73-6.146 2.73v-4.31L110.934 94h-4.387l.014 32.58c2.194.918 5.204 1.424 8.468 1.424 8.365 0 12.408-5.357 12.408-14.588.002-7.293-3.71-12.14-10.29-12.14zm-1.887 22.746c-1.684 0-3.26-.204-4.26-.714v-15.452c1-1.275 3.392-2.193 5.79-2.193 4.336 0 6.02 3.06 6.02 8.007 0 7.037-2.705 10.352-7.55 10.352zM16.592 97.604c3.98 0 6.53 1.326 8.213 2.652l1.93-3.34c-2.63-2.306-6.167-3.545-9.94-3.545-9.538 0-16.22 5.815-16.22 17.545C.575 123.205 7.785 128 16.03 128c4.133 0 7.71-.97 10.006-1.938L26 112.93V109H14v4h7.446l.094 9.935c-1.02.51-2.805.9-5.203.9-6.63 0-11.07-4.18-11.07-12.963 0-8.924 4.592-13.268 11.325-13.268zM48.16 94h-4.387L44 99.593v19.379c0 5.407 2.48 9.028 9.163 9.028.923 0 1.837-.084 2.837-.243v-3.94c-1 .098-1.64.154-2.368.154-3.673 0-5.632-1.886-5.632-5.048V106h8v-4h-7.825l-.015-8zM33 102h4v25h-4zm0-8h4v4h-4z\" fill=\"#E24329\"/></svg>"

/***/ }),

/***/ "../src/components/gitlab/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GitlabPlainWordmark = __webpack_require__("../src/components/gitlab/plain-wordmark/GitlabPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GitlabPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gitlab/plain/GitlabPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GitlabPlain = __webpack_require__("../src/components/gitlab/plain/GitlabPlain.svg");
	
	var _GitlabPlain2 = _interopRequireDefault(_GitlabPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GitlabPlain */
	function GitlabPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GitlabPlain',
	    svg: _GitlabPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GitlabPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GitlabPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gitlab/plain/GitlabPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#E24329\" d=\"M126.615 72.31l-7.034-21.646-13.94-42.902c-.54-1.662-2.44-2.07-3.654-1.23-.4.276-.724.853-.902 1.398L87.144 51H40.856L31.62 22.41 26.917 7.847a2.748 2.748 0 0 0-.372-.767c-.078-.104-.18-.194-.27-.28-.937-.89-2.465-.876-3.36.072a2.336 2.336 0 0 0-.556.894l-13.94 42.9-2.946 9.068L1.385 72.31a4.78 4.78 0 0 0 .85 4.496c.26.317.55.613.89.86L64 121.895l60.874-44.227a4.785 4.785 0 0 0 1.74-5.357zm-7.034-21.647z\"/></svg>"

/***/ }),

/***/ "../src/components/gitlab/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GitlabPlain = __webpack_require__("../src/components/gitlab/plain/GitlabPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GitlabPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/go/line/GoLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GoLine = __webpack_require__("../src/components/go/line/GoLine.svg");
	
	var _GoLine2 = _interopRequireDefault(_GoLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GoLine */
	function GoLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GoLine',
	    svg: _GoLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GoLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GoLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/go/line/GoLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M108.7 64.4c-1.6-1.2-3.8-1.9-6-1.9-.1-3.6-.2-7.2-.2-10.7-.1-9.5-.1-19.3-2.6-28.6 6.5-2.5 6.2-7.6 5.9-9.2-.7-3.8-4-7.9-9-7.9-1.9 0-3.9.6-5.8 1.9C83.4 1.6 73 .5 62.5.5 53 1.3 46.4 2.8 41 5.4c-2.3 1.1-4.2 2.4-6 3.9-1.8-1.1-3.7-1.7-5.5-1.7-5.1 0-8.8 4.1-9.4 8.1-.6 4 1.6 7.3 6 8.9-2.2 8.9-1.5 18.1-.7 27 .3 3.7.6 7.6.7 11.4h-.5c-2.3 0-4.6.7-6.3 1.9-.7.5-2.1 2-2 3.3 0 .4.2.9.9 1.3.2 2.1 1.5 2.4 2.3 2.4 1.6 0 3.4-1.1 3.9-1.5.5-.3.9-.5 1.2-.6l.5-.2c-.1 2.2-.3 4.5-.5 7-.9 11.7-2 25 3.9 34.6 1.2 1.9 2.6 3.6 4.3 5.1l-.9.6c-2.7 1.9-6.7 4.7-4.3 8.5v.1c.4.4.6.5.9.5h.1c.3.5.9 1.6 2.4 1.6.6 0 1.3-.2 2-.6 1.1-.6 2.1-1.4 3-2.2 1.5-1.3 3-2.6 5-2.9l.6-.1.7.3c6.4 2.6 12.9 3.3 17.3 3.4h2.6c7.7 0 14.8-1.2 20.5-3.5 1.2-.5 2.4-1.1 3.5-1.7 1.2.5 2.3 1.7 3.4 3 1.4 1.6 2.8 3.2 4.5 3.2.8 0 1.6-.4 2.4-1.1 1.2-.7 1.8-1.7 1.8-2.9 0-2.6-2.9-5.7-5.2-7.2 2-2 3.6-4.2 4.9-6.7 5.9-11.8 5-26.2 4.2-39l.5.3c.5.4 2.3 1.5 3.9 1.5.8 0 2.1-.3 2.3-2.4.7-.4.8-.9.9-1.3 0-1.3-1.4-2.8-2.1-3.3zm-17.1-56c1.7-1.1 3.4-1.7 5.2-1.7 4.4 0 7.7 3.7 8.3 7.3.6 3.7-1.4 6.8-5.4 8.4 0-.2-.1-.3-.2-.5l-.6-2.1-.3-.8-.9-2.4c0-.1 0-.1-.1-.2 0 0 0-.1-.1-.1-.4-.7-.7-1.4-1.1-2l-.2-.3-1.2-1.8c-.1-.1-.2-.2-.3-.4-.4-.5-.8-1-1.3-1.5-.1-.2-.3-.3-.5-.5l-1.2-1.2c.1.1 0-.1-.1-.2zM26.3 23.9c-4-1.5-6.1-4.5-5.5-8.1.6-3.7 4-7.5 8.7-7.5 1.7 0 3.3.5 4.9 1.4l-.1.1-.3.3c-.5.5-1 1-1.4 1.5l-.3.3c-.5.6-1 1.2-1.5 1.9l-.2.3c-.5.7-.9 1.3-1.3 2 0 0 0 .1-.1.1-.4.7-.8 1.5-1.1 2.3 0 .2-.1.4-.1.5-.3.8-.7 1.6-.9 2.4 0 .1 0 .1-.1.2l-.6 2-.1.3zm-.9 45.2c-.3.1-.8.3-1.4.7-1 .7-2.4 1.4-3.5 1.4-.6 0-1.4-.2-1.6-1.7.5-.2 1-.4 1.4-.9.1-.2.1-.4-.1-.5-.2-.1-.4-.1-.5.1-.3.3-.6.5-1.1.6h-.1c-.3-.2-.5-.4-.6-.7.1-.9 1.1-2.1 1.8-2.7 1.6-1.2 3.7-1.8 5.9-1.8h.6v2.9l-.1 1c-.1 1.4-.2 1.4-.7 1.6zm15.8 52l.1.1c-1.9.5-3.4 1.7-4.8 2.9-.9.8-1.8 1.6-2.9 2.1-.6.4-1.1.5-1.6.5-1 0-1.5-.8-1.7-1.2.1-.8.5-1.5 1-2.2.3-.4.6-.9.8-1.4.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2-.2.4-.5.8-.7 1.3-.4.7-.9 1.4-1.1 2.2h-.1c-.1 0-.2-.1-.4-.3-2-3.2 1.4-5.5 4.2-7.5l.9-.6h.2l.2.1 1.2.9.4.3c.4.3.8.6 1.3.9l.5.3 1.3.8.6.3c.4.3.8.5 1.3.8zm52.3-5.3c2.1 1.4 5 4.4 5 6.7 0 .8-.4 1.5-1.1 2-.1-.3-.2-.6-.4-.9-.3-.9-.7-1.9-1.5-2.6-.1-.1-.4-.1-.5 0-.1.1-.1.4 0 .5.7.6 1 1.5 1.3 2.4l.4 1.1c-.6.5-1.2.8-1.8.8-1.4 0-2.6-1.5-3.9-3-1-1.1-2-2.3-3.1-3l.3-.2c.3-.1.5-.3.7-.5l1.3-.9.8-.6 1.4-1.1c.2-.2.4-.4.7-.6.2.1.3 0 .4-.1zm4.7-7.5c-1.2 2.5-3.4 5.7-7.1 8.5l-.2.1c-.3.3-.7.5-1.1.8l-1.1.7-.2.1-1.6.9-.7.4c-5.4 2.8-12.8 4.8-23.2 4.8h-2.6c-8.1-.3-14.3-2-18.9-4.2h-.1c-1.1-.5-2.1-1.1-3.1-1.7-4.6-2.9-7.1-6.1-8.3-8-5.8-9.4-4.8-22.5-3.8-34.1.2-3 .5-5.7.6-8.4l.1-1.8.1-.1v-.1l-.1-.5V63c-.1-4-.4-7.7-.7-11.5-.8-9-1.5-18.4.9-27.4.2-.8.4-1.6.7-2.3v-.1l.1-.3c.1-.4.3-.8.5-1.2.1-.3.2-.5.3-.7l.3-.8.4-.8.3-.6c.1-.3.3-.6.4-.8.1-.2.2-.4.3-.5.2-.4.5-.8.7-1.1.2-.3.4-.6.6-.8.1-.2.2-.3.4-.5l.6-.8c.1-.1.2-.2.3-.4l.9-1 .1-.1 1.2-1.2.2-.2c7-6 17-7.8 27.1-8.6 5.9 0 13.5.3 20 2.7 3.2 1.2 6 2.8 8.4 4.9.3.3.6.6.9.8l.9.9 1 1.2.6.7 1 1.4.5.7.9 1.5.4.8c.3.6.5 1.3.7 2 0 .1.1.2.1.4.2.6.4 1.2.6 1.7l.1.3c3 9.9 3.1 20.2 3.1 30.4 0 3.5 0 7.4.2 10.4v.6c0 .9.1 1.8.1 2.5v.1l.1 1.9c0 .6.1 1.3.1 2v.3c.9 12.6 1.9 27.1-4 38.8zm11.2-40c-.5-.2-.9-.3-1.2-.7-.1-.2-.3-.2-.5-.1s-.2.3-.1.5c.4.5.9.7 1.4.9-.2 1.5-1 1.7-1.6 1.7-1.1 0-2.5-.7-3.5-1.4-.4-.3-.7-.4-1-.5l-.2-2.4c0-.4 0-.8-.1-1.1 0-.6-.1-1.3-.1-2 2.1.1 4.1.7 5.6 1.8.7.5 1.8 1.8 1.7 2.6.1.3-.1.6-.4.7zM77.7 7.2c-3.8 0-7.5 1.6-9.9 4.1-2.2 2.4-3.3 5.4-3.1 8.8v.1C66 27.4 72 30 76.8 30c4.2 0 8.1-1.8 10.4-4.7 2-2.5 2.7-5.8 1.8-9.3-1.5-6.4-6.8-8.8-11.3-8.8zm8.9 17.5c-2.1 2.7-5.9 4.3-9.9 4.3-2.7 0-5.2-.7-7.2-2.1-2.2-1.6-3.6-3.9-4.1-6.9-.2-3.2.8-6 2.9-8.2 2.3-2.5 5.8-3.9 9.4-3.9 4.2 0 9.2 2.1 10.6 8.1.8 3.4.2 6.4-1.7 8.7zm-27-5.5c-.4-7.3-6.2-10.6-11.8-10.6-4.1 0-7.9 1.7-10.3 4.5-2.1 2.6-2.8 5.9-2.1 9.6 1.6 6.3 7 8.5 11.5 8.5 3.8 0 7.4-1.5 9.8-4 2.1-2.2 3.1-5 2.9-8zM47 30.5c-4.2 0-9.3-2.1-10.8-8-.7-3.5 0-6.6 2-9 2.2-2.7 5.8-4.3 9.7-4.3 7.7 0 10.8 5.4 11.1 10 .2 2.9-.7 5.5-2.6 7.5-2.3 2.4-5.8 3.8-9.4 3.8zm-5.4-13.9c-1.9 0-3.5 1.7-3.5 3.8 0 2.1 1.6 3.8 3.5 3.8s3.5-1.7 3.5-3.8c0-2.1-1.6-3.8-3.5-3.8zm1.6 5.7c-.5 0-.8-.4-.8-1 0-.5.4-1 .8-1 .5 0 .8.4.8 1 0 .5-.4 1-.8 1zm27.9-6.6c-1.9 0-3.5 1.7-3.5 3.8 0 2.1 1.6 3.8 3.5 3.8s3.5-1.7 3.5-3.8c0-2.1-1.5-3.8-3.5-3.8zm1.6 5.6c-.5 0-.8-.4-.8-1 0-.5.4-1 .8-1 .5 0 .8.4.8 1s-.3 1-.8 1zm-4.2 9c.1-.3.1-.7 0-1.1-1.1-4.1-10.4-3.5-10.4 1.3 0-.4-.1-.6-.1-.8 0 .3.1.6.1.8-1.5.2-2.8 1.2-3.6 2.7-.7 1.4-.8 2.9-.1 4.2.6 1.1 1.6 1.7 2.8 1.7-.4 2.1 0 4.6 1 6 .5.7 1.2 1.1 1.8 1.1.9 0 1.9-.7 2.8-1.8.6 1 1.5 1.7 2.7 1.9h.2c.2-.1.4-.2.6-.2.7-.2 1.4-.5 1.9-1.3v-.1c.3-1.4.1-2.9 0-4.3l-.1-1.2c.5.2 1 .3 1.5.3 1 0 1.8-.4 2.5-1.2.9-1 1.2-2 1-3-.1-2.3-2.4-4-4.6-5zm-5.9 13.2c-.9 1.1-1.7 1.7-2.4 1.7-.5 0-.9-.3-1.3-.7-.9-1.2-1.3-3.7-.9-5.6l.5-.1h.2l.6-.1h.1l1.2-.4.6-.2c.1 0 .1 0 .2-.1.2-.1.3-.1.5-.1.2-.1.4-.1.7-.2h.2l-.1 1.3c-.1 1.3-.2 2.9-.1 4.5zm5.2-3.3c.1 1.3.2 2.7 0 4-.3.6-.8.7-1.5 1l-.6.2c-1-.2-1.8-.8-2.2-1.8-.2-1.5-.1-3 .1-4.6l.1-1.5h.1c1.1 0 2.1.5 3.1.9l.7.3c.1.4.2.9.2 1.5zm4.1-2.7c-.6.7-1.3 1-2 1-.6 0-1.1-.2-1.7-.4-.3-.1-.6-.2-.9-.4-1.1-.4-2.2-.9-3.4-.9h-1.3l-.4.1c-.1 0-.2 0-.3.1-.2 0-.3.1-.5.2-.1 0-.2 0-.2.1l-.8.3c-.1.1-.3.1-.4.1l-.3.1-.3.1c-.2.1-.3.1-.5.1-.1 0-.2 0-.3.1l-.5.1h-.2l-.6.1c-1 0-1.7-.4-2.2-1.3-.6-1-.6-2.3.1-3.5.7-1.2 1.9-2.1 3.1-2.3 1.2 2.5 8.1 2.2 9.9-.2 2 .9 4.2 2.5 4.5 4.2.2.7-.1 1.5-.8 2.3zM58 29.4z\"/></svg>"

/***/ }),

/***/ "../src/components/go/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GoLine = __webpack_require__("../src/components/go/line/GoLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GoLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/go/original/GoOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GoOriginal = __webpack_require__("../src/components/go/original/GoOriginal.svg");
	
	var _GoOriginal2 = _interopRequireDefault(_GoOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GoOriginal */
	function GoOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GoOriginal',
	    svg: _GoOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GoOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GoOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/go/original/GoOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><defs><path id=\"a\" d=\"M18.8 1h90.5v126H18.8z\"/></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"/></clipPath><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#F6D2A2\" d=\"M21.1 68.7c.2 3.5 3.7 1.9 5.3.8 1.5-1.1 2-.2 2.1-2.3.1-1.4.2-2.7.2-4.1-2.3-.2-4.8.3-6.7 1.7-.9.7-2.8 3-.9 3.9\" clip-path=\"url(#b)\"/><path d=\"M23 71.2c-.7 0-2-.3-2.2-2.3-.6-.4-.8-.9-.8-1.2-.1-1.2 1.2-2.6 1.9-3.1 1.6-1.2 3.7-1.8 5.9-1.8h1.3v.3c.1 1.1 0 2.2-.1 3.2 0 .3 0 .6-.1.9-.1 1.5-.4 1.7-1.1 2-.3.1-.6.2-1.1.6-.5.3-2.2 1.4-3.7 1.4zm4.8-7.8c-2.1 0-4 .6-5.5 1.7-.7.5-1.7 1.7-1.6 2.5 0 .3.2.6.6.8l.2.1v.2c.1 1.6.9 1.8 1.5 1.8 1 0 2.4-.7 3.3-1.3.6-.4 1-.5 1.3-.6.5-.2.6-.2.7-1.4 0-.3 0-.6.1-.9.1-.9.1-1.9.1-2.8-.3-.1-.5-.1-.7-.1z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#C6B198\" d=\"M21.1 68.7c.5-.2 1.1-.3 1.4-.8\" clip-path=\"url(#b)\"/><path d=\"M21.1 69c-.1 0-.3-.1-.3-.2-.1-.2 0-.4.2-.4.1 0 .2-.1.2-.1.4-.2.8-.3 1-.6.1-.1.3-.2.5-.1.1.1.2.3.1.5-.4.5-.9.7-1.3.8l-.2.1h-.2z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#6AD7E5\" d=\"M29.3 26.4c-13.6-3.8-3.5-21.1 7.4-14l-7.4 14z\" clip-path=\"url(#b)\"/><path d=\"M29.5 26.8l-.3-.1c-7-2-6.9-7-6.7-8.5.5-3.8 4.1-7.8 8.9-7.8 1.9 0 3.7.6 5.5 1.8l.3.2-7.7 14.4zm1.9-15.7c-4.5 0-7.8 3.7-8.3 7.2-.5 3.6 1.7 6.4 6 7.7l7.1-13.5c-1.5-.9-3.1-1.4-4.8-1.4z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#6AD7E5\" d=\"M89.6 11.1c10.7-7.5 20.5 9.5 8 13.8l-8-13.8z\" clip-path=\"url(#b)\"/><path d=\"M97.5 25.3L89.2 11l.3-.2c1.9-1.3 3.8-2 5.7-2 4.6 0 7.9 3.8 8.6 7.5.3 1.5.6 6.6-6 8.8l-.3.2zm-7.4-14l7.7 13.3c3.9-1.4 5.9-4.4 5.3-8-.6-3.4-3.7-6.9-7.9-6.9-1.7-.1-3.4.4-5.1 1.6z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#F6D2A2\" d=\"M92 112.3c2.7 1.7 7.7 6.8 3.6 9.3-3.9 3.6-6.1-4-9.6-5 1.5-2 3.4-3.9 6-4.3\" clip-path=\"url(#b)\"/><path d=\"M93.5 122.9c-1.6 0-3-1.6-4.2-3.1-1.1-1.2-2.2-2.5-3.4-2.9l-.5-.1.3-.4c1.2-1.7 3.2-3.9 6.2-4.4h.1l.1.1c1.7 1.1 5.4 4.2 5.3 7.1 0 1.1-.6 2-1.7 2.7-.7.7-1.4 1-2.2 1zm-7-6.5c1.2.5 2.2 1.8 3.2 2.9 1.2 1.5 2.4 2.8 3.7 2.8.6 0 1.2-.3 1.8-.9h.1c.9-.6 1.4-1.3 1.4-2.2 0-2.3-2.9-5.2-4.9-6.5-1.8.5-3.6 1.7-5.3 3.9zm9.1 5.5c-.1 0-.2-.1-.3-.2-.2-.4-.4-.9-.5-1.3-.3-.8-.6-1.6-1.2-2.2-.1-.1-.1-.3 0-.5.1-.1.3-.1.5 0 .7.7 1.1 1.6 1.4 2.5l.5 1.2c.1.2 0 .4-.1.5h-.3z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#F6D2A2\" d=\"M43.2 118.1c-3.2.5-5 3.4-7.7 4.9-2.5 1.5-3.5-.5-3.7-.9-.4-.2-.4.2-1-.4-2.3-3.7 2.4-6.4 4.9-8.2 3.5-.8 5.7 2.2 7.5 4.6\" clip-path=\"url(#b)\"/><path d=\"M33.8 123.8c-1.3 0-2-1.1-2.2-1.5h-.1c-.3 0-.5-.1-.9-.5v-.1c-2.2-3.5 1.6-6.2 4.1-8l.9-.6h.2c.4-.1.7-.1 1.1-.1 3 0 4.9 2.6 6.5 4.7l.5.7-.6.1c-1.9.3-3.3 1.5-4.7 2.7-.9.8-1.8 1.5-2.8 2.1-.8.3-1.4.5-2 .5zm-2.2-2.1c.1 0 .2 0 .4.1h.1l.1.1c.2.3.7 1.2 1.7 1.2.5 0 1-.2 1.5-.5 1-.5 1.9-1.3 2.7-2 1.3-1.1 2.7-2.3 4.5-2.8-1.5-2-3.3-4.2-5.8-4.2-.3 0-.6 0-.9.1l-.8.6c-2.6 1.8-5.8 4.1-3.9 7.1.1.2.2.3.4.3zm.2.7c-.2 0-.4-.2-.3-.4.1-1 .6-1.7 1.1-2.5.3-.4.5-.8.7-1.2.1-.2.3-.2.4-.2.2.1.2.3.2.4-.2.5-.5.9-.8 1.3-.5.7-.9 1.3-1 2.1 0 .4-.1.5-.3.5z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.9 21.7c-1.8-.9-3.1-2.2-2-4.3 1-1.9 2.9-1.7 4.7-.8l-2.7 5.1zm64.9-1.8c1.8-.9 3.1-2.2 2-4.3-1-1.9-2.9-1.7-4.7-.8l2.7 5.1z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#F6D2A2\" d=\"M107.1 68.2c-.2 3.5-3.7 1.9-5.3.8-1.5-1.1-2-.2-2.1-2.3-.1-1.4-.2-2.7-.2-4.1 2.3-.2 4.8.3 6.7 1.7 1 .8 2.8 3 .9 3.9\" clip-path=\"url(#b)\"/><path d=\"M105.3 70.7c-1.5 0-3.2-1.1-3.7-1.4-.5-.3-.8-.5-1.1-.6-.8-.3-1-.5-1.1-2 0-.3 0-.6-.1-.9-.1-1-.2-2.1-.1-3.2v-.3h1.3c2.2 0 4.3.6 5.9 1.8.7.5 2 1.9 1.9 3.1 0 .4-.2.9-.8 1.2-.2 2-1.5 2.3-2.2 2.3zM99.8 63c0 .9 0 1.9.1 2.8 0 .3 0 .6.1.9.1 1.2.2 1.2.7 1.4.3.1.7.3 1.3.6.9.6 2.3 1.3 3.3 1.3.6 0 1.4-.2 1.5-1.8V68l.2-.1c.4-.2.6-.4.6-.8.1-.8-.9-2-1.6-2.5-1.5-1.1-3.5-1.7-5.5-1.7-.2.1-.4.1-.7.1z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#C6B198\" d=\"M107.1 68.2c-.5-.2-1.1-.3-1.4-.8\" clip-path=\"url(#b)\"/><path d=\"M107.1 68.6h-.1l-.2-.1c-.5-.2-1-.3-1.3-.8-.1-.1-.1-.4.1-.5.1-.1.4-.1.5.1.2.3.6.4 1 .6.1 0 .2.1.2.1.2.1.3.3.2.4-.1.1-.3.2-.4.2z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#6AD7E5\" d=\"M62.8 4c13.6 0 26.3 1.9 33 15 6 14.6 3.8 30.4 4.8 45.9.8 13.3 2.5 28.6-3.6 40.9-6.5 12.9-22.7 16.2-36 15.7-10.5-.4-23.1-3.8-29.1-13.4-6.9-11.2-3.7-27.9-3.2-40.4.6-14.8-4-29.7.9-44.1C34.5 8.5 48.1 5.1 62.8 4\" clip-path=\"url(#b)\"/><path d=\"M63.3 121.9h-2.5c-4.1-.1-10.3-.8-16.4-3.3-5.9-2.4-10.2-5.8-13-10.3-5.6-9.1-4.6-21.6-3.7-32.7.2-2.8.4-5.4.5-7.9.2-5.2-.2-10.6-.7-15.7-.8-9.4-1.6-19.1 1.5-28.5 2.4-7 6.7-12 13.2-15.2 5.1-2.5 11.4-3.9 20.4-4.6C76 3.6 89.3 5.5 96 18.8c4.4 10.7 4.4 22.2 4.5 33.3 0 4.2 0 8.5.3 12.7.1 1.3.2 2.6.2 3.9.8 12.2 1.7 26-3.9 37.2-2.8 5.7-7.7 9.9-14.4 12.6-5.4 2.2-12.2 3.4-19.4 3.4zM62.8 4.3c-14.1 1.1-27.9 4.2-33 19.4-3.1 9.3-2.3 18.9-1.5 28.2.4 5.2.9 10.5.7 15.8-.1 2.5-.3 5.1-.5 7.9-.9 11-1.9 23.4 3.6 32.3 2.3 3.7 9.7 12.5 28.8 13.2h2.5c22.1 0 30.3-9.8 33.3-15.6 5.5-11 4.6-24.8 3.9-36.9-.1-1.3-.2-2.6-.2-3.9-.2-4.2-.3-8.5-.3-12.7-.1-11-.1-22.5-4.4-33.1C92.7 13 88.2 9 82 6.7c-6.4-2.1-13.6-2.4-19.2-2.4z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M65.2 22.2c2.4 14.2 25.6 10.4 22.3-3.9-3-12.8-23.1-9.2-22.3 3.9\" clip-path=\"url(#b)\"/><path d=\"M76.2 31.5c-4.5 0-10.2-2.4-11.4-9.2-.2-3.2.8-6.1 2.9-8.3 2.3-2.5 5.8-3.9 9.4-3.9 4.2 0 9.2 2.2 10.6 8.3.8 3.4.2 6.4-1.7 8.8-2.1 2.6-5.8 4.3-9.8 4.3zm-10.7-9.3c.5 2.8 1.8 5 3.9 6.6 1.8 1.4 4.3 2.1 6.8 2.1 3.7 0 7.3-1.6 9.3-4.1 1.8-2.2 2.3-5.1 1.6-8.3-1.3-5.7-6-7.7-10-7.7-3.4 0-6.7 1.4-8.9 3.7-1.9 2-2.9 4.7-2.7 7.7z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M37.5 24.5c3.2 12.3 22.9 9.2 22.2-3.2-.9-14.8-25.3-12-22.2 3.2\" clip-path=\"url(#b)\"/><path d=\"M48 32.7c-4.3 0-9.3-2.1-10.9-8.1-.7-3.5 0-6.7 2-9.1 2.2-2.7 5.8-4.3 9.7-4.3 5.2 0 10.7 3.1 11.1 10.1.2 2.9-.7 5.5-2.7 7.6-2.1 2.3-5.6 3.8-9.2 3.8zm.8-20.8c-3.7 0-7.1 1.5-9.2 4-1.9 2.3-2.5 5.2-1.8 8.5C39.2 30 44 32 48 32c3.4 0 6.7-1.3 8.8-3.6 1.8-1.9 2.7-4.4 2.5-7.1-.2-4.3-3.1-9.4-10.5-9.4z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M68 39.2c0 1.8.4 3.9.1 5.9-.5.9-1.4 1-2.2 1.3-1.1-.2-2-.9-2.5-1.9-.3-2.2.1-4.4.2-6.6l4.4 1.3z\" clip-path=\"url(#b)\"/><path d=\"M65.9 46.8c-1.3-.2-2.3-1-2.8-2.1-.2-1.6-.1-3.1 0-4.6.1-.7.1-1.4.1-2.1v-.4l5.1 1.6v.2c0 .6.1 1.2.1 1.9.1 1.3.2 2.7 0 4v.1c-.4.8-1.1 1-1.8 1.3-.2-.1-.4 0-.7.1zm-2.2-2.4c.4.9 1.2 1.5 2.1 1.7.2-.1.4-.1.5-.2.6-.2 1.1-.4 1.4-.9.2-1.2.1-2.5 0-3.8 0-.6-.1-1.2-.1-1.7l-3.8-1.2c0 .6-.1 1.2-.1 1.7-.1 1.6-.2 3 0 4.4z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M46.3 22.5c0 2-1.5 3.6-3.3 3.6-1.8 0-3.3-1.6-3.3-3.6s1.5-3.6 3.3-3.6c1.8 0 3.3 1.6 3.3 3.6\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M45.2 23.3c0 .5-.4.9-.8.9s-.8-.4-.8-.9.4-.9.8-.9c.5 0 .8.4.8.9\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M74.2 21.6c0 2-1.5 3.6-3.3 3.6-1.8 0-3.3-1.6-3.3-3.6s1.5-3.6 3.3-3.6c1.8 0 3.3 1.6 3.3 3.6\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M73.2 22.4c0 .5-.3.9-.8.9-.4 0-.8-.4-.8-.9s.3-.9.8-.9c.4 0 .8.4.8.9M58.4 39c-1.5 3.5.8 10.6 4.8 5.4-.3-2.2.1-4.4.2-6.6l-5 1.2z\" clip-path=\"url(#b)\"/><path d=\"M60.5 46.6c-.7 0-1.4-.4-1.9-1.2-1.1-1.6-1.3-4.6-.5-6.5l.1-.2 5.5-1.4v.4l-.1 2.2c-.1 1.5-.2 2.9 0 4.4v.1l-.1.1c-1 1.4-2 2.1-3 2.1zm-1.8-7.3c-.6 1.7-.4 4.4.5 5.7.4.6.8.9 1.3.9.7 0 1.5-.6 2.3-1.6-.2-1.5-.1-3 .1-4.4l.1-1.7-4.3 1.1z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#F6D2A2\" d=\"M58.9 32.2c-2.7.2-4.9 3.5-3.5 6 1.9 3.4 6-.3 8.6 0 3 .1 5.4 3.2 7.8.6 2.7-2.9-1.2-5.7-4.1-7l-8.8.4z\" clip-path=\"url(#b)\"/><path fill=\"#231F20\" d=\"M69.7 40.2c-.9 0-1.8-.4-2.7-.8-.9-.4-1.9-.8-3-.8h-.3c-.8 0-1.7.3-2.7.7-1.1.4-2.2.7-3.2.7-1.2 0-2.1-.5-2.7-1.6-.7-1.2-.6-2.6.1-3.9.8-1.5 2.2-2.4 3.7-2.6l8.9-.4h.1c2.2.9 4.7 2.6 5.2 4.6.2 1-.1 2-.9 2.9-.8.9-1.6 1.2-2.5 1.2zM64.1 38c1.1 0 2.2.5 3.2.9.9.4 1.7.7 2.5.7.7 0 1.3-.3 1.9-.9.7-.7.9-1.5.8-2.3-.4-1.7-2.8-3.3-4.7-4.1l-8.7.4c-1.3.1-2.5 1-3.2 2.2-.6 1.1-.6 2.3-.1 3.3.5.9 1.1 1.3 2.1 1.3.9 0 1.9-.4 2.9-.7 1.1-.4 2-.7 3-.7 0-.2.1-.2.3-.1z\" clip-path=\"url(#b)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M58.6 32.1c-.2-4.7 8.8-5.3 9.8-1.4 1.1 4-9.4 4.9-9.8 1.4\" clip-path=\"url(#b)\"/></svg>"

/***/ }),

/***/ "../src/components/go/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GoOriginal = __webpack_require__("../src/components/go/original/GoOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GoOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/go/plain/GoPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GoPlain = __webpack_require__("../src/components/go/plain/GoPlain.svg");
	
	var _GoPlain2 = _interopRequireDefault(_GoPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GoPlain */
	function GoPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GoPlain',
	    svg: _GoPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GoPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GoPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/go/plain/GoPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M108.2 64.8c-.1-.1-.2-.2-.4-.2l-.1-.1c-.1-.1-.2-.1-.2-.2l-.1-.1c-.1 0-.2-.1-.2-.1l-.2-.1c-.1 0-.2-.1-.2-.1l-.2-.1c-.1 0-.2-.1-.2-.1-.1 0-.1 0-.2-.1l-.3-.1c-.1 0-.1 0-.2-.1l-.3-.1h-.1l-.4-.1h-.2c-.1 0-.2 0-.3-.1h-2.3c-.6-13.3.6-26.8-2.8-39.6 12.9-4.6 2.8-22.3-8.4-14.4-7.4-6.4-17.6-7.8-28.3-7.8-10.5.7-20.4 2.9-27.4 8.4-2.8-1.4-5.5-1.8-7.9-1.1v.1c-.1 0-.3.1-.4.2-.1 0-.3.1-.4.2h-.1c-.1 0-.2.1-.4.2h-.1l-.3.2h-.1l-.3.2h-.1l-.3.2s-.1 0-.1.1l-.3.2s-.1 0-.1.1l-.3.2s-.1 0-.1.1l-.3.2-.1.1c-.1.1-.2.1-.2.2l-.1.1-.2.2-.1.1c-.1.1-.1.2-.2.2l-.1.1c-.1.1-.1.2-.2.2l-.1.1c-.1.1-.1.2-.2.2l-.1.1c-.1.1-.1.2-.2.2l-.1.1c-.1.1-.1.2-.2.2l-.1.1-.1.3s0 .1-.1.1l-.1.3s0 .1-.1.1l-.1.3s0 .1-.1.1l-.1.3s0 .1-.1.1c.4.3.4.4.4.4v.1l-.1.3v.1c0 .1 0 .2-.1.3v3.1c0 .1 0 .2.1.3v.1l.1.3v.1l.1.3s0 .1.1.1l.1.3s0 .1.1.1l.1.3s0 .1.1.1l.2.3s0 .1.1.1l.2.3s0 .1.1.1l.2.3.1.1.3.3.3.3h.1c1 .9 2 1.6 4 2.2v-.2C23 37.3 26.5 50 26.7 63c-.6 0-.7.4-1.7.5h-.5c-.1 0-.3 0-.5.1-.1 0-.3 0-.4.1l-.4.1h-.1l-.4.1h-.1l-.3.1h-.1l-.3.1s-.1 0-.1.1l-.3.1-.2.1c-.1 0-.2.1-.2.1l-.2.1-.2.1c-.1 0-.2.1-.2.1l-.2.1-.4.3c-.1.1-.2.2-.3.2l-.4.4-.1.1c-.1.2-.3.4-.4.5l-.2.3-.3.6-.1.3v.3c0 .5.2.9.9 1.2.2 3.7 3.9 2 5.6.8l.1-.1c.2-.2.5-.3.6-.3h.1l.2-.1c.1 0 .1 0 .2-.1.2-.1.4-.1.5-.2.1 0 .1-.1.1-.2l.1-.1c.1-.2.2-.6.2-1.2l.1-1.3v1.8c-.5 13.1-4 30.7 3.3 42.5 1.3 2.1 2.9 3.9 4.7 5.4h-.5c-.2.2-.5.4-.8.6l-.9.6-.3.2-.6.4-.9.7-1.1 1c-.2.2-.3.4-.4.5l-.4.6-.2.3c-.1.2-.2.4-.2.6l-.1.3c-.2.8 0 1.7.6 2.7l.4.4h.2c.1 0 .2 0 .4.1.2.4 1.2 2.5 3.9.9 2.8-1.5 4.7-4.6 8.1-5.1l-.5-.6c5.9 2.8 12.8 4 19 4.2 8.7.3 18.6-.9 26.5-5.2 2.2.7 3.9 3.9 5.8 5.4l.1.1.1.1.1.1.1.1s.1 0 .1.1c0 0 .1 0 .1.1 0 0 .1 0 .1.1h2.1s.1 0 .1-.1h.1s.1 0 .1-.1h.1s.1 0 .1-.1c0 0 .1 0 .1-.1l.1-.1s.1 0 .1-.1l.1-.1h.1l.2-.2.2-.1h.1l.1-.1h.1l.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1v-.1s0-.1.1-.1v-.1s0-.1.1-.1v-.1s0-.1.1-.1v-1.4s-.3 0-.3-.1l-.3-.1v-.1l.3-.1s.2 0 .2-.1l.1-.1v-2.1s0-.1-.1-.1v-.1s0-.1-.1-.1v-.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1v-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1c2-1.9 3.8-4.2 5.1-6.9 5.9-11.8 4.9-26.2 4.1-39.2h.1c.1 0 .2.1.2.1h.3s.1 0 .1.1h.1s.1 0 .1.1l.2.1c1.7 1.2 5.4 2.9 5.6-.8 1.6.6-.3-1.8-1.3-2.5zM36 23C32.8 7 58.4 4 59.3 19.6c.8 13-20 16.3-23.3 3.4zm36.1 15c-1.3 1.4-2.7 1.2-4.1.7 0 1.9.4 3.9.1 5.9-.5.9-1.5 1-2.3 1.4-1.2-.2-2.1-.9-2.6-2l-.2-.1c-3.9 5.2-6.3-1.1-5.2-5-1.2.1-2.2-.2-3-1.5-1.4-2.6.7-5.8 3.4-6.3.7 3 8.7 2.6 10.1-.2 3.1 1.5 6.5 4.3 3.8 7.1zm-7-17.5c-.9-13.8 20.3-17.5 23.4-4 3.5 15-20.8 18.9-23.4 4zM41.7 17c-1.9 0-3.5 1.7-3.5 3.8 0 2.1 1.6 3.8 3.5 3.8s3.5-1.7 3.5-3.8c0-2.1-1.5-3.8-3.5-3.8zm1.6 5.7c-.5 0-.8-.4-.8-1 0-.5.4-1 .8-1 .5 0 .8.4.8 1 0 .5-.3 1-.8 1zm27.8-6.6c-1.9 0-3.4 1.7-3.4 3.8 0 2.1 1.5 3.8 3.4 3.8s3.4-1.7 3.4-3.8c0-2.1-1.5-3.8-3.4-3.8zm1.6 5.6c-.4 0-.8-.4-.8-1 0-.5.4-1 .8-1s.8.4.8 1-.4 1-.8 1z\"/></svg>"

/***/ }),

/***/ "../src/components/go/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GoPlain = __webpack_require__("../src/components/go/plain/GoPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GoPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/google/original-wordmark/GoogleOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GoogleOriginalWordmark = __webpack_require__("../src/components/google/original-wordmark/GoogleOriginalWordmark.svg");
	
	var _GoogleOriginalWordmark2 = _interopRequireDefault(_GoogleOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GoogleOriginalWordmark */
	function GoogleOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GoogleOriginalWordmark',
	    svg: _GoogleOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GoogleOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GoogleOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/google/original-wordmark/GoogleOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"google\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#4885ed}.cls-2{fill:#db3236}.cls-3{fill:#f4c20d}.cls-4{fill:#3cba54}</style></defs><title>google</title><g id=\"original-wordmark\"><path id=\"path2998\" class=\"cls-1\" d=\"M31.85 57.91H17.09v4.38h10.47c-.52 6.14-5.63 8.76-10.45 8.76a11.7 11.7 0 0 1 0-23.4A11.36 11.36 0 0 1 25 50.82l3.07-3.18A15.59 15.59 0 0 0 17 43.26a16.09 16.09 0 1 0 .23 32.18c8.61 0 14.92-5.9 14.92-14.63a13.13 13.13 0 0 0-.27-2.9z\"/><path id=\"path3000\" class=\"cls-2\" d=\"M43.94 54.74a10.34 10.34 0 1 0 10.38 10.38 10.22 10.22 0 0 0-10.38-10.38zM44 58.8a6.29 6.29 0 1 1-5.92 6.26A5.95 5.95 0 0 1 44 58.8z\"/><path id=\"path3005\" class=\"cls-3\" d=\"M66.56 54.74a10.34 10.34 0 1 0 10.37 10.38 10.22 10.22 0 0 0-10.37-10.38zm.06 4.06a6.29 6.29 0 1 1-5.92 6.26 5.95 5.95 0 0 1 5.92-6.26z\"/><path id=\"path3007\" class=\"cls-1\" d=\"M88.73 54.75c-5.56 0-9.93 4.87-9.93 10.33a10.2 10.2 0 0 0 9.83 10.35 6.83 6.83 0 0 0 5.67-2.51v2c0 3.57-2.17 5.7-5.44 5.7A5.73 5.73 0 0 1 83.58 77l-4 1.66a10 10 0 0 0 9.3 6.09c5.53 0 9.74-3.48 9.74-10.78v-18.6h-4.31v1.75a7.32 7.32 0 0 0-5.58-2.37zm.4 4.05c2.73 0 5.52 2.33 5.52 6.3s-2.79 6.27-5.58 6.27a5.88 5.88 0 0 1-5.72-6.23c0-4 2.86-6.34 5.78-6.34z\"/><path id=\"path3011\" class=\"cls-2\" d=\"M117.93 54.72c-5.24 0-9.65 4.17-9.65 10.33a10 10 0 0 0 10.15 10.38 10.49 10.49 0 0 0 8.66-4.54l-3.58-2.38a5.79 5.79 0 0 1-5.07 2.85 5.32 5.32 0 0 1-5.07-3.13l13.87-5.75-.72-1.69a9.36 9.36 0 0 0-8.6-6.06zm.18 4a4.12 4.12 0 0 1 3.83 2.21l-9.26 3.87a5.74 5.74 0 0 1 5.43-6.08z\"/><path id=\"path3015\" class=\"cls-4\" d=\"M101.67 74.82h4.56V44.33h-4.56z\"/></g></svg>"

/***/ }),

/***/ "../src/components/google/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GoogleOriginalWordmark = __webpack_require__("../src/components/google/original-wordmark/GoogleOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GoogleOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/google/original/GoogleOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GoogleOriginal = __webpack_require__("../src/components/google/original/GoogleOriginal.svg");
	
	var _GoogleOriginal2 = _interopRequireDefault(_GoogleOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GoogleOriginal */
	function GoogleOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GoogleOriginal',
	    svg: _GoogleOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GoogleOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GoogleOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/google/original/GoogleOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"google\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#fff}.cls-2{fill:#e33629}.cls-3{fill:#f8bd00}.cls-4{fill:#587dbd}.cls-5{fill:#319f43}</style></defs><title>google</title><g id=\"original\"><path class=\"cls-1\" d=\"M44.59 4.21a63.28 63.28 0 0 0 4.33 120.9 67.6 67.6 0 0 0 32.36.35 57.13 57.13 0 0 0 25.9-13.46 57.44 57.44 0 0 0 16-26.26 74.33 74.33 0 0 0 1.61-33.58H65.27v24.69h34.47a29.72 29.72 0 0 1-12.66 19.52 36.16 36.16 0 0 1-13.93 5.5 41.29 41.29 0 0 1-15.1 0A37.16 37.16 0 0 1 44 95.74a39.3 39.3 0 0 1-14.5-19.42 38.31 38.31 0 0 1 0-24.63 39.25 39.25 0 0 1 9.18-14.91A37.17 37.17 0 0 1 76.13 27a34.28 34.28 0 0 1 13.64 8q5.83-5.8 11.64-11.63c2-2.09 4.18-4.08 6.15-6.22A61.22 61.22 0 0 0 87.2 4.59a64 64 0 0 0-42.61-.38z\"/><path class=\"cls-2\" d=\"M44.59 4.21a64 64 0 0 1 42.61.37 61.22 61.22 0 0 1 20.35 12.62c-2 2.14-4.11 4.14-6.15 6.22Q95.58 29.23 89.77 35a34.28 34.28 0 0 0-13.64-8 37.17 37.17 0 0 0-37.46 9.74 39.25 39.25 0 0 0-9.18 14.91L8.76 35.6A63.53 63.53 0 0 1 44.59 4.21z\"/><path class=\"cls-3\" d=\"M3.26 51.5a62.93 62.93 0 0 1 5.5-15.9l20.73 16.09a38.31 38.31 0 0 0 0 24.63q-10.36 8-20.73 16.08a63.33 63.33 0 0 1-5.5-40.9z\"/><path class=\"cls-4\" d=\"M65.27 52.15h59.52a74.33 74.33 0 0 1-1.61 33.58 57.44 57.44 0 0 1-16 26.26c-6.69-5.22-13.41-10.4-20.1-15.62a29.72 29.72 0 0 0 12.66-19.54H65.27c-.01-8.22 0-16.45 0-24.68z\"/><path class=\"cls-5\" d=\"M8.75 92.4q10.37-8 20.73-16.08A39.3 39.3 0 0 0 44 95.74a37.16 37.16 0 0 0 14.08 6.08 41.29 41.29 0 0 0 15.1 0 36.16 36.16 0 0 0 13.93-5.5c6.69 5.22 13.41 10.4 20.1 15.62a57.13 57.13 0 0 1-25.9 13.47 67.6 67.6 0 0 1-32.36-.35 63 63 0 0 1-23-11.59A63.73 63.73 0 0 1 8.75 92.4z\"/></g></svg>"

/***/ }),

/***/ "../src/components/google/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GoogleOriginal = __webpack_require__("../src/components/google/original/GoogleOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GoogleOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/google/plain-wordmark/GooglePlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GooglePlainWordmark = __webpack_require__("../src/components/google/plain-wordmark/GooglePlainWordmark.svg");
	
	var _GooglePlainWordmark2 = _interopRequireDefault(_GooglePlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GooglePlainWordmark */
	function GooglePlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GooglePlainWordmark',
	    svg: _GooglePlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GooglePlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GooglePlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/google/plain-wordmark/GooglePlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"google\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#587dbd}</style></defs><title>google</title><g id=\"plain-wordmark\"><path id=\"path2998\" class=\"cls-1\" d=\"M31.85 57.91H17.09v4.38h10.47c-.52 6.14-5.63 8.76-10.45 8.76a11.7 11.7 0 0 1 0-23.4A11.36 11.36 0 0 1 25 50.82l3.07-3.18A15.59 15.59 0 0 0 17 43.26a16.09 16.09 0 1 0 .23 32.18c8.61 0 14.92-5.9 14.92-14.63a13.13 13.13 0 0 0-.27-2.9z\"/><path id=\"path3000\" class=\"cls-1\" d=\"M43.94 54.74a10.34 10.34 0 1 0 10.38 10.38 10.22 10.22 0 0 0-10.38-10.38zM44 58.8a6.29 6.29 0 1 1-5.92 6.26A5.95 5.95 0 0 1 44 58.8z\"/><path id=\"path3005\" class=\"cls-1\" d=\"M66.56 54.74a10.34 10.34 0 1 0 10.37 10.38 10.22 10.22 0 0 0-10.37-10.38zm.06 4.06a6.29 6.29 0 1 1-5.92 6.26 5.95 5.95 0 0 1 5.92-6.26z\"/><path id=\"path3007\" class=\"cls-1\" d=\"M88.73 54.75c-5.56 0-9.93 4.87-9.93 10.33a10.2 10.2 0 0 0 9.83 10.35 6.83 6.83 0 0 0 5.67-2.51v2c0 3.57-2.17 5.7-5.44 5.7A5.73 5.73 0 0 1 83.58 77l-4 1.66a10 10 0 0 0 9.3 6.09c5.53 0 9.74-3.48 9.74-10.78v-18.6h-4.31v1.75a7.32 7.32 0 0 0-5.58-2.37zm.4 4.05c2.73 0 5.52 2.33 5.52 6.3s-2.79 6.27-5.58 6.27a5.88 5.88 0 0 1-5.72-6.23c0-4 2.86-6.34 5.78-6.34z\"/><path id=\"path3011\" class=\"cls-1\" d=\"M117.93 54.72c-5.24 0-9.65 4.17-9.65 10.33a10 10 0 0 0 10.15 10.38 10.49 10.49 0 0 0 8.66-4.54l-3.58-2.38a5.79 5.79 0 0 1-5.07 2.85 5.32 5.32 0 0 1-5.07-3.13l13.87-5.75-.72-1.69a9.36 9.36 0 0 0-8.6-6.06zm.18 4a4.12 4.12 0 0 1 3.83 2.21l-9.26 3.87a5.74 5.74 0 0 1 5.43-6.08z\"/><path id=\"path3015\" class=\"cls-1\" d=\"M101.67 74.82h4.56V44.33h-4.56z\"/></g></svg>"

/***/ }),

/***/ "../src/components/google/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GooglePlainWordmark = __webpack_require__("../src/components/google/plain-wordmark/GooglePlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GooglePlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/google/plain/GooglePlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GooglePlain = __webpack_require__("../src/components/google/plain/GooglePlain.svg");
	
	var _GooglePlain2 = _interopRequireDefault(_GooglePlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GooglePlain */
	function GooglePlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GooglePlain',
	    svg: _GooglePlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GooglePlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GooglePlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/google/plain/GooglePlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"google\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#587dbd}</style></defs><title>google</title><path class=\"cls-1\" d=\"M44.59 4.21a63.28 63.28 0 0 0 4.33 120.9 67.6 67.6 0 0 0 32.36.35 57.13 57.13 0 0 0 25.9-13.46 57.44 57.44 0 0 0 16-26.26 74.33 74.33 0 0 0 1.61-33.58H65.27v24.69h34.47a29.72 29.72 0 0 1-12.66 19.52 36.16 36.16 0 0 1-13.93 5.5 41.29 41.29 0 0 1-15.1 0A37.16 37.16 0 0 1 44 95.74a39.3 39.3 0 0 1-14.5-19.42 38.31 38.31 0 0 1 0-24.63 39.25 39.25 0 0 1 9.18-14.91A37.17 37.17 0 0 1 76.13 27a34.28 34.28 0 0 1 13.64 8q5.83-5.8 11.64-11.63c2-2.09 4.18-4.08 6.15-6.22A61.22 61.22 0 0 0 87.2 4.59a64 64 0 0 0-42.61-.38z\" id=\"plain\"/></svg>"

/***/ }),

/***/ "../src/components/google/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GooglePlain = __webpack_require__("../src/components/google/plain/GooglePlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GooglePlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gradle/plain-wordmark/GradlePlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GradlePlainWordmark = __webpack_require__("../src/components/gradle/plain-wordmark/GradlePlainWordmark.svg");
	
	var _GradlePlainWordmark2 = _interopRequireDefault(_GradlePlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GradlePlainWordmark */
	function GradlePlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GradlePlainWordmark',
	    svg: _GradlePlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GradlePlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GradlePlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gradle/plain-wordmark/GradlePlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><style>.st0{fill:#363636}</style><path class=\"st0\" d=\"M39.2 49.5c1 .7 2 1.3 3 2 .2.2.6.2.9.2 3.1-.5 6.1 0 8.6 2 1.6 1.3 2.7 3 3.2 5 .1.6 0 .8-.6.7h-.7c-1.5.2-2.6 0-3.4-1.7-1-2.1-3.4-2.9-5.8-2.4-.1 1 0 2.1-.2 3.1-.7 3.3-2.4 6.1-5.6 7.7-.5.2-.5.5-.3.9 1.1 4 4.5 6.1 8.6 5.5 1.2-.2 4.3-1.5 4.2-2v-2.9c0-.6-.2-.8-.7-.8H46c-.6 0-.8-.2-.7-.8v-1.8c0-.5.1-.7.6-.6h8.5c.5 0 .6.2.6.6v7.3c0 1.3-1 2.1-1.9 2.8-1.7 1.2-3.7 1.7-5.7 1.8-2.4.2-4.9.2-7.1-1-2.9-1.5-4.8-3.8-5.8-6.9-.3-.9-.5-1-1.3-.5-.7.4-1 1.1-1 1.9-.1 1.8 0 3.7-.1 5.5v.9H28c-.2 0-.4-.4-.6-.5-1.3-1.2-2.4-2.5-3.7-3.5-2-1.6-3.9-1.1-5.2 1.1-.5.9-.9 1.9-1.4 3h-3.7c-.2-.6-.2-1.2-.5-1.8-.3-.6-.6-1.2-1.1-1.7-.9-1-2.1-1-3.1-.1-1.1.9-1.5 2.2-1.8 3.6H2c-.1-.8-.2-1.6-.4-2.4v-4.3c.1-.7.2-1.5.3-2.2.4-2.7 1.2-5.3 3.1-7.5 1.1-1.4 2.5-2.3 4.2-2.9.7 1.3 1.3 2.5 1.9 3.6.7 1.3 1.8 2.2 3.4 2.1 1.6-.1 3.7-1.6 4.2-2.9-.2.2-.4.3-.5.4-.8.5-1.6 1.1-2.5 1.4-1.3.5-2.5.3-3.2-.8-1.1-1.8-2.1-3.7-3.1-5.6-.5-1-.2-1.9.8-2.6.3-.2.6-.4.9-.5 2.1-.6 4.2-1.3 6.3-1.7 5.3-.9 10.1.4 14 4.3 1 1 2.2 1.9 3.5 3 1-1.9 2.3-3.4 4.1-4.5-.6-.4-1.1-.7-1.5-1.1-.7-.5-.7-.8-.1-1.4.4-.4.8-.7 1.1-1h.7zm-10.9 8.9c-.6-.2-1.2-.4-1.7-.6-.6 1.8.1 3.1 1.7 3.6 1.5.4 3.2-.4 3.6-1.8-.4-.1-.8-.3-1.4-.5.1.9-.2 1.5-1 1.7-.6.1-1.1 0-1.5-.6-.4-.6-.2-1.1.3-1.8zm68.6 2v-.9V53c0-.6.2-.8.7-.8h2.4c.6 0 .8.2.7.8v16.2c0 2-.1 4-.1 6 0 .5-.2.7-.7.7h-2.2c-.7 0-1-.1-.9-.9 0-.2 0-.3-.1-.6-.2.1-.4.1-.5.2-2.7 2.8-8.1 2-10.3-1.7-2.1-3.6-1.5-9.5 1.5-12.4 2.3-2.2 6.7-2.5 8.8-.3.3 0 .5 0 .7.2zm-.4 4.2c-.5-1.6-1.7-2.5-3.4-2.5-1.5 0-2.7.6-3.5 2-1.2 2.3-1.1 4.6.1 6.8 1.4 2.6 5.1 2.5 6.4-.1.9-1.3 1-5 .4-6.2zM83.2 75.7h-3.7c-.5 0-.6-.2-.7-.6 0-.2-.1-.4-.1-.7-.3.2-.6.3-.9.5-2.2 1.2-4.5 1.6-6.9.6-2-.8-3.1-2.4-3.2-4.5 0-1.9.8-3.6 2.6-4.4 1.4-.6 2.9-.9 4.3-1.3 1-.3 2.1-.5 3.1-.8.4-.1.8-.6.9-1 .2-.6-.1-1.2-.7-1.6-1.3-.8-3.7-.6-4.8.3-.3.2-.6.6-.6.9-.1.7-.5.7-1.1.7h-2.2c-.7 0-.8-.3-.7-.8.3-1.5 1-2.7 2.4-3.5 1.8-1 3.7-1.2 5.7-1 .9.1 1.7.2 2.6.4 2.4.6 3.5 2.1 3.5 4.5v10.7c.2.6.4 1 .5 1.6zm-4.3-8.3c-1.3.3-2.5.6-3.7.9-.7.2-1.4.3-2 .5-1 .4-1.4 1.1-1.3 2.2.1.8.6 1.4 1.5 1.6 1.4.4 2.7.2 3.9-.5 1.6-.8 2.1-2.5 1.6-4.7zm35.1.8c-.2 1.5 1.1 3.3 2.6 3.9 1.7.7 4.7.6 5.9-1.4.1-.2.5-.3.7-.2.9.4 1.7.9 2.6 1.4-.6 1.3-1.5 2.2-2.6 3-2.9 2.1-9.3 1.9-11.9-2.2-.9-1.4-1.3-3-1.4-4.7-.1-2.1.2-4.1 1.4-5.9 1.3-2 3.2-3 5.5-3.4 1.6-.2 3.2 0 4.7.5 2.9 1.1 4.1 3.5 4.6 6.4.1.6.1 1.1.2 1.7.1.6-.2.8-.8.8H115c-.4.1-.7.1-1 .1zm.1-2.8h7.8c.2-1.7-1.4-3.5-3.1-3.6-2.6-.2-4.6 1.2-4.7 3.6zm-10.2 9.4c0 .7.2 1 .9.9.7-.1 1.4 0 2.1 0 .7 0 .9-.2.9-.9v-9.1c0-4.3.1-8.7.1-13 0-.5-.2-.6-.6-.6h-2.5c-.7 0-.9.2-.9.9v21.8zM61.3 61.1v-1.5c0-.4-.2-.6-.6-.6h-2.5c-.5 0-.7.2-.7.7v15.4c0 .5.2.7.7.7h2.2c.7.1.9-.2.9-.9 0-2.6.1-5.3.1-7.9.1-2 1.3-3.6 3.3-4.1.4-.1.9-.1 1.4-.2.5-.1.7-.3.7-.8v-2.5c0-.5-.2-.7-.7-.7-1.6.1-3.1.6-4.1 1.9-.1.2-.3.4-.5.6 0-.1-.1-.1-.2-.1z\"/></svg>"

/***/ }),

/***/ "../src/components/gradle/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GradlePlainWordmark = __webpack_require__("../src/components/gradle/plain-wordmark/GradlePlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GradlePlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gradle/plain/GradlePlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GradlePlain = __webpack_require__("../src/components/gradle/plain/GradlePlain.svg");
	
	var _GradlePlain2 = _interopRequireDefault(_GradlePlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GradlePlain */
	function GradlePlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GradlePlain',
	    svg: _GradlePlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GradlePlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GradlePlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gradle/plain/GradlePlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><style>.st0{fill:#02303a}</style><path class=\"st0\" d=\"M99.5 112.5H85.3c-.5 0-.8-.2-1.1-.5-3.2-4-6.7-7.7-10.9-10.6-2.1-1.5-4.3-2.8-6.8-3.5-2-.6-4.1-.9-6.2-.4-2.1.5-3.9 1.7-5.4 3.2-1.9 1.9-3.2 4.2-4.2 6.7-.6 1.5-1.1 3-1.6 4.5-.1.2-.1.4-.2.6H37.5c-.1-.6-.2-1.2-.3-1.9-.4-2-1-4-2-5.8-.7-1.4-1.6-2.6-2.8-3.6-1.3-1.1-2.8-1.7-4.5-1.7-1.3 0-2.4.5-3.5 1.2-1.5 1-2.7 2.3-3.6 3.8-1.4 2.2-2.2 4.7-2.9 7.2-.1.2-.1.5-.2.8H2.8c-.1-.7-.2-1.5-.3-2.2-.5-4.7-.8-9.4-.7-14.1.1-5.5.7-10.9 2-16.3C5 75 6.7 70.4 9.3 66.2c3.6-5.7 8.4-9.8 14.7-12.3.2-.1.3-.1.5-.2h.2l.3.6c1.8 4 3.7 7.9 6 11.5 1.4 2.3 3.4 4 5.9 4.8 2.7.9 5.3.6 7.9-.5 2.3-1 4.2-2.5 6-4.2 2.1-2 3.8-4.2 5.5-6.6.1-.1.1-.2.1-.3-.2.2-.4.4-.7.6-2.5 2.5-5.2 4.7-8.3 6.4-1.5.9-3.2 1.6-4.9 1.9-2.5.5-4.8.2-6.8-1.6-.8-.7-1.4-1.5-2-2.3-3-4.7-5.6-9.6-8-14.6-.5-1-.9-2-1-3.2-.2-1.7.3-3.2 1.5-4.5.9-.9 1.9-1.6 3.1-2.2 2.2-1.1 4.5-1.9 6.8-2.7 3.4-1.1 6.9-1.9 10.5-2.4 4.1-.6 8.3-.7 12.5-.2 9 .9 17 4.2 24.3 9.5 2.5 1.8 5.1 3.3 8.1 4.2 11.9 3.8 21.4-4.4 23.6-12.8.6-2.3.8-4.6-.1-6.8-1.3-3.4-3.6-6-7.3-7-2.8-.7-5.5-.4-8.1 1-.5.3-1 .5-1.5.7-1.2.4-2 .1-2.6-1-.8-1.4-1.4-2.8-2.1-4.3-.3-.6-.2-1.1.1-1.6.3-.7.8-1.2 1.4-1.7 1.5-1.2 3.3-2 5.3-2.4 4.9-1.1 9.5-.4 13.9 1.8 3.5 1.7 6.2 4.3 8.2 7.7 1.9 3.2 3.2 6.6 3.8 10.3.4 2.9.4 5.7.1 8.6-.6 5-2 9.7-4 14.3-2.6 6-5.6 11.8-9.3 17.2-1.8 2.6-3.7 5.1-5.5 7.6-1.9 2.7-3.8 5.4-5.2 8.4-1.9 3.9-3 7.9-3.4 12.2-.3 3.7-.1 7.3.5 11 .1.6.2 1 .2 1.4zm-8.2-51.4c.3 2.4-.5 4-2.7 4.9-1.6.6-3.6.1-4.6-1.3-1.6-2.1-1.1-4 .7-5.8-1.8-.6-3.6-1.2-5.3-1.7-.4 1-.6 2.5-.5 3.7.2 2.4 1.1 4.4 3.1 5.7 2.1 1.4 4.5 2 7 1.5 2.6-.5 4.6-2 6-4.2.3-.4.5-.8.5-1.4-1.4-.4-2.8-.9-4.2-1.4z\"/></svg>"

/***/ }),

/***/ "../src/components/gradle/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GradlePlain = __webpack_require__("../src/components/gradle/plain/GradlePlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GradlePlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/grunt/line-wordmark/GruntLineWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GruntLineWordmark = __webpack_require__("../src/components/grunt/line-wordmark/GruntLineWordmark.svg");
	
	var _GruntLineWordmark2 = _interopRequireDefault(_GruntLineWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GruntLineWordmark */
	function GruntLineWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GruntLineWordmark',
	    svg: _GruntLineWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GruntLineWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GruntLineWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/grunt/line-wordmark/GruntLineWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FCAA1A\" d=\"M91.297 53.219c2.281-1.318 4.646-2.624 6.586-4.368 3.227-2.9 2.787-7.137-.643-9.78-.637-.491-1.438-1.124-1.596-1.82-.625-2.773-1.171-5.58.727-8.201.613-.847.979-1.921 1.272-2.944.902-3.161-.547-5.824-3.661-6.847-.553-.182-1.137-.284-1.715-.366-.781-.11-1.17-.46-1.283-1.303-.418-3.113.385-4.815 3.287-6.123 1.515-.683 3.167-1.06 4.762-1.576-2.269-3.861-8.606-6.065-13.902-4.635-4.264 1.151-7.256 3.941-10.056 7.102-.296.335-.944.539-1.41.51-1.358-.085-1.313-1.164-1.109-2.064.425-1.874.992-3.715 1.521-5.641-2.446.072-4.301 1.407-6.135 2.864-.123-.195-.213.223-.264.1C66.764 5.949 66.975 4 67.363 2h-.296c-3.344 1-6.437 2.998-7.125 7.192l-.527-.328-1.102-5.303c-3.026 2.051-4.691 4.642-5.149 8.093-.063.476-.334.892-.508 1.353-.46-.254-1.04-.421-1.362-.794-3.148-3.658-6.71-6.549-11.712-7.315-4.44-.68-9.92 1.482-11.991 4.921 1.828.695 3.759 1.239 5.506 2.14 2.098 1.082 2.8 2.862 2.576 4.863-.162 1.444-.74 2.019-2.236 2.21-3.291.422-5.209 3.014-4.736 6.278.164 1.134.499 2.417 1.199 3.265 1.628 1.969 1.451 4.192 1.404 6.442-.036 1.759-.662 3.146-2.184 4.242-3.28 2.365-3.674 6.706-.664 9.423 1.973 1.782 4.359 3.14 6.671 4.501 1.716 1.011 2.858 2.413 2.947 4.287.146 3.081-.028 6.179-.126 9.268-.039 1.241-.231 2.476-.381 3.986-2.659-2.4-4.088-5.11-4.825-8.408-2.824 2.809-4.029 6.037-4.188 9.773-.285 6.681 2.575 11.449 8.595 14.239.511.237.964.774 1.254 1.281 2.519 4.407 6.12 7.343 11.161 8.381.567.117 1.239.134 1.669.455 2.761 2.065 5.904 3.066 9.274 3.366 5.091.453 9.994-.088 14.364-3.084.425-.292.94-.531 1.443-.617 5.249-.891 9.015-3.812 11.699-8.326.41-.691 1.12-1.335 1.844-1.688 3.021-1.468 5.418-3.518 6.773-6.653 1.363-3.155 1.72-6.458 1.082-9.8-.526-2.761-1.67-5.277-3.988-7.264-.716 3.298-2.162 5.997-4.849 8.099-.317-4.426-.565-8.831-.436-13.224.052-1.687 1.218-3.088 2.858-4.035zm1.879-44.168c-.906.164-1.814.477-2.718.464-4.265-.061-7.352 1.974-9.767 5.287l-.327.481-.247.194-1.987-.954c3.26-5.974 9.806-8.412 15.046-5.472zm-4.46 2.849c-.326 1.88-.646 3.687-.95 5.496-.142.85-.309 1.608-1.347 1.866-.984.244-1.591.071-2.38-.708-1.035-1.023-.938-1.823-.354-2.922 1.128-2.123 2.693-3.55 5.031-3.732zM33.393 8.917c5.118-2.763 11.431-.518 15.027 5.567l-2.068 1.043.532-.699c-1.398-1.077-2.79-2.162-4.195-3.229-1.946-1.48-4.161-2.073-6.592-2.084-.91-.005-1.821-.293-2.704-.598zm9.874 7.993c.045.826-1.019 2.022-1.877 2.469-.489.254-1.849-.467-2.339-1.111-.503-.662-.433-1.764-.593-2.677-.108-.624-.137-1.265-.284-1.878-.136-.563-.383-1.099-.614-1.736 2.664.074 5.568 2.412 5.707 4.933zM33.191 79.563c-2.362-3.517-2.231-7.436-1.222-11.44 2.752 6.3 8.262 7.83 14.535 8.516-2.108 2.42-3.934 4.813-2.477 8.256-4.507-.316-8.342-1.619-10.836-5.332zm13.67 12.922l-5.296-4.545c4.079-1.061 4.506 1.983 5.716 4.093l-.42.452zm20.354 4.307c-9.971 1.922-17.789-2.612-20.744-13.266-.757-2.727.873-4.512 3.986-4.551 4.277-.054 8.557-.014 12.835-.014 4.131-.004 8.262-.009 12.393.002.485.001.985.035 1.454.149 2.589.631 3.607 1.979 2.86 4.51-1.94 6.584-5.544 11.775-12.784 13.17zm11.852-4.398c.744-1.499 1.284-2.731 1.969-3.878.2-.338.79-.53 1.235-.617.753-.147 1.533-.158 2.419-.236-1.348 2.127-3.113 3.606-5.623 4.731zm15.361-24.446c2.782 9.331-2.383 16.664-11.862 16.8 1.292-3.254-.347-5.656-2.604-8.086 6.248-.729 11.791-2.205 14.466-8.714zm-9-9.808c-.017 3.93.227 7.866.49 11.79.171 2.554.232 2.72-2.262 3.259-1.473.318-3.013.417-4.522.415-.406 0-.983-.659-1.189-1.14-1.599-3.739-3.122-7.51-4.681-11.266-.183-.44-.437-.853-.657-1.277l-.481.48C73.59 65.87 75.055 72 76.482 77h-26.45c1.414-5 2.873-11.073 4.332-16.529l-.579-.354c-.88 1.998-1.795 3.898-2.632 5.914a223.264 223.264 0 0 0-2.637 6.664c-.277.737-.646 1.123-1.502.989a227.871 227.871 0 0 0-5.078-.713c-1.327-.176-1.513-.965-1.437-2.179.261-4.171.492-8.351.551-12.528.045-3.348-1.416-5.926-4.468-7.561-1.725-.925-3.459-1.902-4.982-3.115-2.452-1.953-2.263-5.208.324-6.665l-.177 1.936c2.611-3.15 3.928-9.635 2.051-15.829l-.207 1.77-.469.151c-.581-1.502-1.37-2.963-1.684-4.519-.304-1.508 1.387-2.717 3.465-2.795 3.77-.142 7.33.76 10.576 2.572 3.328 1.858 6.49 4.016 9.549 5.932-.592-2.128-3.198-4.644-10.04-9.494 7.527-7.848 29.097-7.783 36.592.08-4.344 2.219-7.872 5.299-10.18 9.709 1.115-.812 2.222-1.635 3.348-2.431 4.193-2.963 8.574-5.563 13.783-6.215 1.525-.19 3.15-.104 4.654.211 1.607.337 2.251 1.733 1.716 3.307-.414 1.221-1.039 2.371-1.57 3.553l-.383-.078-.306-1.725c-1.468 5.761-1.045 10.968 2.151 15.809l-.264-1.889c2.014.861 2.777 3.386 1.458 5.276-.733 1.049-1.844 1.876-2.898 2.647-.983.719-2.096 1.276-3.19 1.828-3.052 1.539-4.457 4.163-4.471 7.411zm-2.573-23.604c-3.685 1.011-6.605 3.189-9.117 5.976-1.169 1.297-2.55 2.188-4.312 2.271-.844.04-1.698-.171-2.582-.273.332 2.392 2.015 3.175 3.587 3.528.925 2.152 1.738 4.045 2.553 5.938l.457-.208c-.457-1.92-.843-3.835.309-5.725 2.826 2.005 5.662 1.518 8.514.125 3.061-1.497 4.021-4.333 4.792-7.361l.564 2.186c1.197-2.012 1.415-3.883-.19-5.766l2.054-.827c-2.388-.604-4.509-.446-6.629.136zm-.838 9.17c-1.819 1.805-4.81 2.072-7.534.557 2.235-3.089 5.27-5.042 8.375-6.939.949 1.794.486 5.064-.841 6.382zm-29.474-3.407c-2.211-2.507-4.854-4.444-8.055-5.516-2.385-.8-4.813-1.099-7.507-.348l2.085.752c-1.526 1.851-1.344 3.718-.237 5.844l.664-2.291c.621 3.154 1.149 5.89 4.149 7.408C46.496 47.593 49 48.063 52 45.776v5.857c0 .043.91.086 1.08.129.77-1.843 1.823-3.686 2.668-5.71 2.646-.871 3.604-1.671 3.617-3.631-2.814.904-4.914.041-6.822-2.122zm-7.786 3.641c-1.521-1.23-2.117-4.36-1.19-6.668 3.207 1.99 6.264 3.905 8.389 6.979-2.328 1.475-5.171 1.329-7.199-.311zM68.34 33.91c-3.481 1.814-6.712 1.796-10.184.003 3.785 4.215 6.301 4.36 10.184-.003zm7.068 48.015C74.33 81.876 72 81.916 72 81.916V82h-2.755l-.224-.039c-1.434.101-1.99.899-1.323 2.106.658 1.192 1.411 2.406 2.392 3.317.615.572 1.788.891 2.645.793 2.319-.266 3.319-2.15 4.243-4.008.626-1.259-.113-2.178-1.57-2.244zm-17.843.01c-1.124-.073-2.257-.015-3.385-.015-1.129 0-2.261-.049-3.386.015-1.007.057-1.669.525-1.514 1.69.207 1.551 2.512 4.12 4.049 4.525 1.307.344 2.465.111 3.305-.969.778-1 1.523-2.043 2.134-3.151.643-1.167.135-2.009-1.203-2.095zm33.999 23.933h5.162v20.628c-2.364.339-4.352.308-6.016-1.937-2.459-3.316-5.282-6.362-8.213-9.836v11.826H77.43v-20.65c2.329-.285 4.325-.296 5.985 1.956 2.447 3.318 5.268 6.361 8.149 9.782v-11.769zm-57.068.152c3.491 0 6.893-.204 10.257.062 2.858.227 5.174 1.617 5.862 4.746.61 2.771-.526 5.05-3.401 6.985l5.718 8.722c-2.235 0-4.13.097-6.004-.063-.534-.045-1.123-.755-1.484-1.296a73.629 73.629 0 0 1-2.93-4.78c-.529-.939-1.164-1.438-2.405-1.076v7.218h-5.613V106.02zm5.65 9.173c1.735.076 3.522.382 4.491-1.235.428-.716.438-2.17-.021-2.83-1.051-1.511-2.825-1.116-4.469-1.058l-.001 5.123zm-14.944 4.448h-2.819v-4.053h8.245c0 2.804.028 5.562-.033 8.317-.008.384-.372.936-.721 1.111-4.789 2.405-9.647 2.788-14.375-.041-3.7-2.214-5.383-6.531-4.545-10.892.824-4.286 3.886-7.355 8.268-8.209 3.599-.702 7.069-.408 10.259 1.578.487.304.907.717 1.429 1.136l-2.51 3.682c-.979-.515-1.824-1.002-2.704-1.415-3.872-1.819-7.87-.248-8.856 3.462-1.247 4.685 1.605 8.368 6.296 8.134 2.308-.115 2.44-.284 2.066-2.81zm42.43-13.794h5.489c.088.109.2.184.2.257-.017 4.529.161 9.071-.131 13.583-.246 3.798-3.31 6.437-7.597 7.061-2.539.37-5.017.065-7.291-1.243-2.398-1.379-3.826-3.515-3.962-6.215-.199-3.935-.082-7.886-.098-11.829v-1.564h5.63c.021.45.062.923.063 1.396.007 3.55-.024 7.1.018 10.648.03 2.592 1.263 4.057 3.406 4.202 2.672.181 4.229-1.195 4.261-3.879.043-3.599.012-7.198.013-10.798l-.001-1.619zm49.625.053v4.338h-5.901c0 4.226.013 8.302-.007 12.378-.007 1.269.381 3.088-.277 3.663-.778.679-2.495.284-3.805.354l-.147.001c-1.196.189-1.609-.248-1.589-1.518.075-4.877.03-9.757.03-14.832H99.65V105.9h17.607z\"/></svg>"

/***/ }),

/***/ "../src/components/grunt/line-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GruntLineWordmark = __webpack_require__("../src/components/grunt/line-wordmark/GruntLineWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GruntLineWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/grunt/line/GruntLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GruntLine = __webpack_require__("../src/components/grunt/line/GruntLine.svg");
	
	var _GruntLine2 = _interopRequireDefault(_GruntLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GruntLine */
	function GruntLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GruntLine',
	    svg: _GruntLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GruntLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GruntLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/grunt/line/GruntLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FCAA1A\" d=\"M99.463 67.214c2.884-1.667 5.873-3.317 8.326-5.522 4.079-3.666 3.524-9.022-.812-12.363-.806-.621-1.819-1.421-2.018-2.301-.791-3.506-1.48-7.054.918-10.367.775-1.071 1.238-2.429 1.608-3.722 1.142-3.996-.69-7.363-4.627-8.655-.699-.229-1.438-.359-2.169-.462-.987-.139-1.479-.581-1.621-1.647-.529-3.935.484-6.088 4.154-7.741 1.914-.863 4.004-1.339 6.02-1.992-2.868-4.881-10.88-7.668-17.574-5.86-5.391 1.456-9.173 4.982-12.712 8.978-.375.423-1.193.682-1.783.646-1.718-.108-1.66-1.471-1.402-2.61.537-2.369 1.254-4.697 1.922-7.13-3.092.091-5.437 1.778-7.755 3.621-.156-.246-.269.048-.334-.107C68.45 7.225 68.716 5 69.208 2h-.374c-4.228 2-8.137 4.022-9.008 9.325l-.666-.298c-.447-2.097-.894-4.3-1.394-6.646-3.825 2.593-5.93 5.898-6.509 10.261-.08.602-.422 1.142-.643 1.725-.581-.321-1.314-.525-1.721-.998-3.981-4.624-8.483-8.275-14.807-9.244C28.475 5.266 21.548 8 18.929 12.349c2.312.878 4.752 1.567 6.961 2.707 2.652 1.367 3.539 3.618 3.256 6.147-.205 1.826-.936 2.551-2.827 2.793-4.16.533-6.585 3.811-5.987 7.938.208 1.434.631 3.056 1.517 4.127 2.058 2.49 1.834 5.3 1.775 8.145-.046 2.224-.838 3.976-2.76 5.362-4.147 2.991-4.646 8.477-.841 11.913 2.493 2.252 5.512 3.97 8.434 5.69 2.169 1.278 3.614 3.05 3.725 5.419.185 3.895-.035 7.812-.158 11.717-.049 1.568-.293 3.129-.481 5.039-3.361-3.034-5.168-6.46-6.1-10.629-3.57 3.551-5.095 7.632-5.296 12.354-.359 8.446 3.257 14.474 10.865 18.001.646.299 1.22.979 1.586 1.62 3.185 5.572 7.736 9.282 14.109 10.595.717.148 1.566.168 2.109.575 3.49 2.61 7.465 3.875 11.725 4.254 6.436.573 12.634-.111 18.158-3.898.537-.369 1.188-.672 1.825-.78 6.636-1.126 11.396-4.819 14.789-10.525.52-.874 1.416-1.688 2.331-2.133 3.818-1.856 6.849-4.447 8.563-8.411 1.724-3.987 2.175-8.163 1.368-12.388-.666-3.49-2.11-6.672-5.042-9.184-.904 4.169-2.732 7.581-6.13 10.238-.4-5.594-.714-11.163-.549-16.717.063-2.136 1.536-3.906 3.609-5.104zm2.375-55.835c-1.145.206-2.293.603-3.436.586-5.39-.076-9.292 2.495-12.346 6.684l-.414.608-.312.246-2.513-1.206c4.123-7.552 12.398-10.635 19.021-6.918zm-5.637 3.601c-.411 2.377-.815 4.661-1.2 6.948-.18 1.074-.391 2.033-1.703 2.358-1.244.309-2.011.09-3.008-.896-1.309-1.293-1.188-2.304-.448-3.694 1.424-2.681 3.403-4.486 6.359-4.716zm-69.937-3.771c6.471-3.493 14.449-.654 18.997 7.038l-2.614 1.318.671-.883c-1.767-1.362-3.526-2.733-5.303-4.083-2.461-1.871-5.26-2.621-8.333-2.634-1.151-.006-2.301-.37-3.418-.756zm12.482 10.104c.057 1.044-1.286 2.557-2.371 3.121-.619.321-2.339-.59-2.958-1.404-.636-.836-.548-2.23-.749-3.384-.138-.788-.173-1.599-.359-2.374-.172-.711-.484-1.389-.776-2.194 3.367.093 7.038 3.048 7.213 6.235zm-12.737 79.205c-2.985-4.447-2.82-9.4-1.544-14.463 3.479 7.964 10.443 9.898 18.374 10.765-2.665 3.06-4.972 6.085-3.13 10.437-5.7-.399-10.547-2.046-13.7-6.739zm17.283 16.335l-6.696-5.745c5.157-1.342 5.696 2.506 7.227 5.174l-.531.571zm25.729 5.445c-12.604 2.429-22.489-3.302-26.225-16.771-.957-3.448 1.104-5.704 5.04-5.753 5.407-.068 10.816-.018 16.225-.018 5.223-.005 10.444-.011 15.666.003.614.002 1.245.044 1.839.188 3.272.797 4.56 2.502 3.616 5.701-2.453 8.324-7.009 14.886-16.161 16.65zm14.983-5.561c.94-1.895 1.623-3.453 2.487-4.903.255-.427 1-.67 1.562-.78.953-.187 1.938-.199 3.059-.298-1.705 2.69-3.936 4.559-7.108 5.981zm19.418-30.904c3.518 11.796-3.013 21.066-14.996 21.238 1.633-4.114-.439-7.15-3.293-10.222 7.9-.92 14.908-2.786 18.289-11.016zM92.044 73.435c-.021 4.968.287 9.944.62 14.905.216 3.229.294 3.438-2.859 4.12-1.862.401-3.81.527-5.717.524-.514-.001-1.243-.833-1.503-1.442-2.021-4.726-3.948-9.493-5.918-14.242-.231-.557-.552-1.078-.832-1.615l-.607.468C77.08 83.067 78.932 91 80.736 97H47.299c1.787-6 3.631-13.86 5.476-20.757l-.732-.378c-1.112 2.525-2.269 4.962-3.326 7.51a280.662 280.662 0 0 0-3.333 8.443c-.352.932-.816 1.428-1.898 1.259-2.135-.332-4.278-.614-6.42-.898-1.678-.222-1.912-1.217-1.816-2.751.33-5.273.622-10.556.696-15.836.058-4.232-1.791-7.491-5.647-9.558-2.181-1.169-4.374-2.403-6.299-3.938-3.1-2.468-2.86-6.584.41-8.424l-.225 2.447c3.302-3.982 4.966-12.18 2.594-20.011l-.263 2.237-.592.191c-.734-1.899-1.732-3.746-2.129-5.712-.384-1.906 1.753-3.435 4.381-3.534 4.766-.18 9.266.961 13.369 3.252 4.208 2.348 8.206 5.076 12.071 7.498-.749-2.69-4.043-5.871-12.692-12.001 9.517-9.921 36.784-9.839 46.259.101-5.492 2.805-9.952 6.699-12.869 12.274 1.41-1.026 2.809-2.067 4.232-3.074 5.3-3.745 10.839-7.033 17.424-7.856 1.928-.241 3.981-.131 5.884.268 2.032.425 2.846 2.191 2.169 4.181-.524 1.543-1.313 2.997-1.985 4.491l-.484-.099-.386-2.18c-1.855 7.283-1.321 13.866 2.72 19.985l-.334-2.389c2.547 1.089 3.512 4.281 1.844 6.67-.927 1.327-2.331 2.372-3.664 3.346-1.243.909-2.649 1.613-4.033 2.311-3.863 1.944-5.638 5.261-5.657 9.367zm-3.251-29.839c-4.658 1.279-8.351 4.032-11.526 7.555-1.478 1.641-3.223 2.767-5.451 2.872-1.065.05-2.146-.217-3.264-.345.42 3.023 2.548 4.013 4.534 4.46l3.228 7.507.578-.262c-.578-2.428-1.066-4.849.391-7.238 3.571 2.535 7.157 1.919 10.762.158 3.869-1.892 5.085-5.479 6.059-9.305l.713 2.763c1.514-2.543 1.789-4.91-.241-7.29l2.597-1.045c-3.02-.766-5.702-.566-8.38.17zm-1.061 11.592c-2.3 2.281-6.079 2.619-9.523.704 2.825-3.905 6.66-6.374 10.587-8.772 1.199 2.268.615 6.402-1.064 8.068zm-37.259-4.307c-2.795-3.169-6.138-5.617-10.183-6.973-3.015-1.011-6.084-1.389-9.49-.439l2.636.951c-1.929 2.339-1.698 4.7-.3 7.388l.839-2.896c.786 3.987 2.061 7.446 5.853 9.365C43.434 60.102 46 60.696 51 57.805v7.405c0 .054.544.109.758.163.973-2.33 2.002-4.659 3.07-7.218 3.344-1.101 4.405-2.113 4.421-4.591-3.559 1.142-6.365.052-8.776-2.683zm-9.843 4.603c-1.923-1.555-2.678-5.512-1.505-8.43 4.054 2.515 7.918 4.937 10.604 8.822-2.941 1.865-6.535 1.681-9.099-.392zm29.813-12.679c-4.4 2.294-8.485 2.271-12.874.004 4.786 5.328 7.965 5.511 12.874-.004zm8.901 60.699c-1.364-.063-3.344-.013-4.344-.013V104h-3.475l-.252-.25c-1.813.127-2.5 1.035-1.657 2.562.832 1.508 1.793 2.992 3.031 4.143.779.723 2.265 1.102 3.348.978 2.932-.335 4.181-2.731 5.347-5.079.793-1.593-.157-2.767-1.998-2.85zm-22.522.012c-1.421-.092-2.853-.019-4.279-.019s-2.856-.062-4.279.019c-1.273.072-2.11.665-1.914 2.137.262 1.961 3.176 5.208 5.119 5.72 1.651.435 3.115.14 4.178-1.225.983-1.264 1.926-2.583 2.696-3.983.813-1.476.17-2.54-1.521-2.649z\"/></svg>"

/***/ }),

/***/ "../src/components/grunt/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GruntLine = __webpack_require__("../src/components/grunt/line/GruntLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GruntLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/grunt/original-wordmark/GruntOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GruntOriginalWordmark = __webpack_require__("../src/components/grunt/original-wordmark/GruntOriginalWordmark.svg");
	
	var _GruntOriginalWordmark2 = _interopRequireDefault(_GruntOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GruntOriginalWordmark */
	function GruntOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GruntOriginalWordmark',
	    svg: _GruntOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GruntOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GruntOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/grunt/original-wordmark/GruntOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#493310\" d=\"M88.395 70.763c2.874-2.139 4.346-4.844 5.031-8.193 3.332 3.295 4.506 7.17 4.231 11.547-.373 5.936-3.099 10.261-8.728 12.585-.44.183-.838.663-1.081 1.102-2.638 4.78-6.519 7.805-11.988 8.67-.458.073-.916.333-1.31.6-6.504 4.389-16.842 4.373-23.379-.03a3.888 3.888 0 0 0-1.465-.592c-4.917-.85-8.654-3.444-11.181-7.701-.736-1.239-1.59-2.073-2.918-2.679-9.492-4.332-9.33-18.376-3.392-23.269.579 1.43 1.026 2.933 1.775 4.268.755 1.347 1.808 2.526 2.73 3.78l.452-.124c.156-1.57.365-3.136.455-4.71.128-2.215.225-4.435.231-6.654.008-2.708-1.005-4.817-3.563-6.135-1.873-.964-3.743-2.032-5.373-3.353-3.984-3.226-3.884-7.575.144-10.695.967-.749 1.54-1.604 1.653-2.814.238-2.55.639-5.093-1.188-7.342-.506-.623-.761-1.489-1.003-2.283-1.179-3.86.72-6.938 4.719-7.564 1.154-.181 1.781-.479 1.918-1.822.246-2.393-.268-4.035-2.471-5.188-1.754-.918-3.71-1.452-5.647-2.183 2.263-3.252 5.628-4.735 9.573-4.972 5.215-.315 9.304 2.065 12.782 5.717.577.606 1.062 1.306 1.669 1.877.3.283.796.517 1.18.485.199-.016.468-.647.5-1.019.261-3.062 1.645-5.533 3.902-7.548.385-.343.872-.572 1.321-.859l1.108 5.186.481-.005c.793-4.154 3.629-6.272 7.34-7.607-.078 1.244-.259 2.408-.191 3.559.066 1.102.391 2.189.643 3.493 2.112-1.473 3.95-3.001 6.358-2.938-.519 1.973-1.082 3.894-1.513 5.844-.221 1.001.056 1.95 1.329 1.923.465-.01 1.04-.373 1.363-.749 2.744-3.189 5.786-5.917 10.019-6.965 5.398-1.338 10.833.473 13.908 4.771-.583.144-1.133.233-1.652.415-1.339.469-2.758.813-3.975 1.507-2.577 1.469-2.99 2.857-2.373 6.152.056.297.529.61.874.737.547.2 1.163.206 1.727.372 3.291.969 4.864 3.695 3.923 6.986a13.182 13.182 0 0 1-1.503 3.347c-1.675 2.665-1.054 5.41-.367 8.125.152.602.951 1.08 1.519 1.533 3.47 2.765 3.804 6.983.472 9.934-1.854 1.641-4.101 2.873-6.274 4.108-1.996 1.134-3.169 2.791-3.177 4.975-.014 4.131.239 8.263.382 12.395zM74.05 63.654l-.016.012a.242.242 0 0 0 .089.229l.251.601c.891 2.339 1.745 4.693 2.682 7.014 1.118 2.77.344 2.668 3.888 2.348l2.93-.536c1.533-.03 1.932-.795 1.812-2.287-.293-3.627-.399-7.27-.605-10.905-.262-4.633 1.55-7.94 5.894-9.906 1.577-.714 3.077-1.812 4.301-3.044 1.863-1.874 1.333-4.721-.94-6.025l-.195 1.605c-1.727-2.7-2.227-5.443-2.677-8.203l-.046-1.472a.224.224 0 0 0 .021-.277l.705-5.334.273.04.396 1.671c.57-.997 1.039-1.686 1.376-2.433 1.327-2.936.133-4.9-3.128-4.857-1.944.025-3.927.313-5.814.792-4.926 1.249-8.965 4.195-12.986 7.137-.402.294-.822.563-1.234.844l-.19-.223 2.086-2.988.514-.599a.282.282 0 0 0 .128-.193l7.803-6.251-4.744-2.53-.064.011-.343-.254c-5.479-2.57-11.305-3.094-17.182-2.392-3.222.385-6.348 1.579-9.517 2.408-1.867.726-3.642 1.591-4.852 2.925l7.799 6.338-.004-.013.281.387 2.196 3.164c-2.479-1.388-4.714-2.971-7.015-4.453-3.563-2.295-7.427-3.83-11.688-4.129-1.804-.126-3.936-.343-4.873 1.589-.971 2.001.352 3.768 1.466 5.412.042.062.172.064.315.113l.18-1.56c.36.764.582 1.519.67 2.289.173 1.512.273 3.032.403 4.548-.294 1.438-.486 2.906-.911 4.304-.434 1.427-1.095 2.785-1.657 4.173l-.32-.148-.092-1.429c-2.564 1.563-2.712 4.768-.248 6.733 1.489 1.188 3.19 2.14 4.882 3.035 3.184 1.683 4.631 4.376 4.581 7.839-.058 3.986-.298 7.97-.528 11.952-.124 2.143-.188 2.14 1.76 2.595l3.212.548c1.021-.083 2.339.86 2.96-.656 1.226-2.993 2.354-6.026 3.523-9.042a.402.402 0 0 0 .073-.24l.297-.633 1.19-2.27.355.125c-.531 5.319-2.405 10.332-4 15.545 8.902 0 17.561.001 26.219-.004.139 0 .278-.066.372-.09L71.736 60.19l.487-.149 1.613 3.256.214.357zm10.143 24.528c-3.268-.162-4.405.8-5.18 4.488 2.129-1.13 3.996-2.404 5.157-4.507l.044-.11-.021.129zm9.498-18.942c-2.802 5.742-8.112 7.053-13.639 7.684l2.637 5.03-.409 3.296c4.428-.274 8.312-1.603 10.812-5.416 2.327-3.551 2.225-7.478.99-11.476l-.391.882zm-61.883-.45c-.017-.093-.018-.26-.052-.267-.101-.021-.307.009-.311.041-.209 1.639-.591 3.284-.563 4.921.097 5.716 3.184 9.62 8.701 11.133 1.269.348 2.601.466 3.958.7l-.5-3.364 2.721-5.057c-5.853-.549-11.168-2.159-13.954-8.107zm45.853 19.962l.316-.581c.471-1.075 1.021-2.122 1.397-3.229 1.215-3.566-.156-5.51-3.929-5.665l-.738-.015c-7.876-.001-15.752-.008-23.628.011-.779.002-1.575.093-2.333.271-2.338.549-3.256 1.927-2.641 4.237.401 1.504 1.112 2.926 1.685 4.385l.296.543.223.366c1.281 1.657 2.305 3.63 3.889 4.912 5.208 4.216 11.17 4.564 17.297 2.428 3.778-1.318 6.5-3.982 8.167-7.662l-.001-.001zM93.153 8.998c-5.852-2.559-11.877-.32-15.35 5.707l2.039.989c2.671-3.968 6.372-6.429 10.977-5.957.653.067 1.363-.415 2.334-.739zm-60.149.249c.87.164 1.741.477 2.608.465 2.616-.035 4.998.592 6.972 2.333 1.235 1.09 2.33 2.339 3.549 3.579l1.86-.955c-3.134-5.752-9.587-8.28-14.989-5.422zm55.386 2.842c-.247.039-.669.069-1.07.175-2.076.556-3.341 2.017-4.104 3.914-.233.58-.361 1.528-.05 1.931.645.837 1.21 1.985 2.815 1.443 1.076-.364 1.359-.986 1.509-1.885.297-1.773.574-3.551.9-5.578zm-51.047.082c.24 1.361.469 2.645.693 3.93.117.675.21 1.354.338 2.027.268 1.404 1.618 1.775 2.46 1.493.885-.296 1.997-1.443 2.082-2.31.23-2.346-3.087-5.154-5.573-5.14zm4.167 76.022c1.299 1.932 3.024 3.416 5.542 4.55-1.364-2.495-1.789-5.487-5.542-4.55z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#473312\" d=\"M91.564 105.665h5.162v20.628c-2.364.339-4.352.308-6.016-1.937-2.459-3.316-5.282-6.362-8.213-9.836v11.826H77.43v-20.65c2.329-.285 4.325-.296 5.985 1.956 2.447 3.318 5.268 6.361 8.149 9.782v-11.769z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#46310F\" d=\"M34.496 105.817c3.491 0 6.893-.204 10.257.062 2.858.227 5.174 1.617 5.862 4.746.61 2.771-.526 5.05-3.401 6.985l5.718 8.722c-2.235 0-4.13.097-6.004-.063-.534-.045-1.123-.755-1.484-1.296a73.629 73.629 0 0 1-2.93-4.78c-.529-.939-1.164-1.438-2.405-1.076v7.218h-5.613v-20.518zm5.65 9.173c1.735.076 3.522.382 4.491-1.235.428-.716.438-2.17-.021-2.83-1.051-1.511-2.825-1.116-4.469-1.058l-.001 5.123z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#483413\" d=\"M25.202 119.438h-2.819v-4.053h8.245c0 2.804.028 5.562-.033 8.317-.008.384-.372.936-.721 1.111-4.789 2.405-9.647 2.788-14.375-.041-3.7-2.214-5.383-6.531-4.545-10.892.824-4.286 3.886-7.355 8.268-8.209 3.599-.702 7.069-.408 10.259 1.578.487.304.907.717 1.429 1.136l-2.51 3.682c-.979-.515-1.824-1.002-2.704-1.415-3.872-1.819-7.87-.248-8.856 3.462-1.247 4.685 1.605 8.368 6.296 8.134 2.308-.114 2.44-.283 2.066-2.81z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#473312\" d=\"M67.632 105.645h5.489c.088.109.2.184.2.257-.017 4.529.161 9.071-.131 13.583-.246 3.798-3.31 6.437-7.597 7.061-2.539.37-5.017.065-7.291-1.243-2.398-1.379-3.826-3.515-3.962-6.215-.199-3.935-.082-7.886-.098-11.829v-1.564h5.63c.021.45.062.923.063 1.396.007 3.55-.024 7.1.018 10.648.03 2.592 1.263 4.057 3.406 4.202 2.672.181 4.229-1.195 4.261-3.879.043-3.599.012-7.198.013-10.798l-.001-1.619z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#483413\" d=\"M117.257 105.697v4.338h-5.901c0 4.226.013 8.302-.007 12.378-.007 1.269.381 3.088-.277 3.663-.778.679-2.495.284-3.805.354l-.147.001c-1.196.189-1.609-.248-1.589-1.518.075-4.877.03-9.757.03-14.832H99.65v-4.384h17.607z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#F5A900\" d=\"M34.396 34.266c-.13-1.517-.229-3.037-.403-4.548a7.263 7.263 0 0 0-.67-2.289l-.18 1.56c-.144-.049-.274-.051-.315-.113-1.115-1.644-2.437-3.411-1.466-5.412.937-1.932 3.069-1.715 4.873-1.589 4.261.3 8.125 1.834 11.688 4.129 2.301 1.482 4.536 3.065 7.015 4.453l-2.196-3.165-.281-.386.004.013c-.484-1.15-.886-2.342-1.469-3.439-.974-1.834-2.361-3.53-1.479-5.824 3.169-.829 6.294-2.023 9.517-2.408 5.876-.702 11.702-.178 17.182 2.393l.343.254.063-.01c.071 2.022-.705 3.746-1.724 5.447-.607 1.013-.899 2.216-1.333 3.333a.282.282 0 0 1-.128.193l-.514.599-2.086 2.988.19.223c.412-.281.832-.55 1.234-.844 4.021-2.942 8.06-5.888 12.986-7.137 1.887-.479 3.871-.767 5.814-.792 3.261-.042 4.455 1.921 3.128 4.857-.338.747-.807 1.436-1.376 2.433l-.396-1.671-.273-.04-.705 5.334-.066.081.044.196.046 1.472c-.157.419-.446.837-.45 1.258-.03 3.412.274 6.749 2.891 9.748-2.074 1.055-3.91 2.07-5.813 2.933-1.727.783-3.52 1.484-4.14 3.472-.515 1.65-.81 3.369-1.199 5.044l-.959-2.66c-.28 6.486.017 12.836 2.081 18.97l-2.93.536c-1.957-2.976-3.908-5.956-5.883-8.92-.138-.208-.454-.297-.687-.441l-.251-.601.126-.178-.215-.051.017-.012-.215-.359-1.613-3.256-.487.149 4.328 16.414c-.093.024-.232.09-.372.09-8.658.005-17.317.004-26.219.004 1.595-5.213 3.469-10.227 4-15.545l-.355-.125-1.19 2.27-.297.633a.398.398 0 0 1-.073.24c-.289.23-.656.407-.853.699a314.858 314.858 0 0 0-4.261 6.468c-.515.807-.916 1.686-1.37 2.532l-3.212-.548c2.159-6.118 2.428-12.454 2.142-18.865l-1.016 2.654c-.217-4.336-1.509-7.608-6.088-8.946-1.746-.51-3.264-1.8-4.521-2.525.784-1.991 1.676-3.469 1.91-5.045.308-2.071.096-4.217.107-6.328zm33.198.327l.297-.308.724-.84c-1.882.184-3.714.512-5.544.502-1.846-.01-3.691-.354-5.537-.552l-.385-.107.385.107.589 1.185c3.291 3.741 6.039 3.815 9.349.25l.142-.253-.02.016zm-18.351 19.82l3.529-2.182c.792-1.558 1.738-3.063 2.31-4.697.273-.782.421-1.211 1.271-1.434 1.866-.489 2.825-1.749 2.778-3.374l-1.87.229c-2-1.136-3.515-2.713-4.745-4.676-.685-1.092-1.749-1.984-2.759-2.826-2.152-1.794-4.846-2.203-7.478-2.259-1.617-.034-3.251.736-4.877 1.145-.05.048-.104.054-.164.018l-.428.183-.083.121.04.126c.585.208 1.172.41 1.863.647-1.568 1.969-1.371 3.839-.173 5.884l.622-2.19.299.028.151 1.548.198.687.115.459c-.163 4.962 4.275 8.535 10.872 8.413l-1.467 4.154-.067.12.063-.124zm27.241 0l.117.07-.122-.065-1.415-4.2c7.689.76 10.844-4.467 11.121-9.241l.304-1.802.25.01.577 2.145c1.163-2.066 1.461-3.948-.165-5.855l1.929-.757-.803-.315c-.393-.239-.769-.649-1.18-.687-1.772-.167-3.563-.384-5.332-.287-3.512.194-6.402 1.725-8.382 4.685-1.316 1.968-2.735 3.78-4.918 4.843l-2.022-.229c.323 1.924 1.42 2.925 3.107 3.459.399.126.803.556 1 .949.843 1.679 1.61 3.397 2.404 5.102 1.178.724 2.354 1.45 3.53 2.175z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#F5A800\" d=\"M47.789 88.167c-.572-1.458-1.283-2.88-1.685-4.385-.616-2.31.302-3.688 2.641-4.237a10.407 10.407 0 0 1 2.333-.271c7.876-.019 15.752-.012 23.628-.011l.738.015c3.773.155 5.144 2.099 3.929 5.665-.376 1.106-.926 2.154-1.397 3.229l-.316.581v.001c-1.019.662-2.01 1.372-3.062 1.976-2.644 1.517-5.525 2.206-8.542 2.567-4.127.496-8.155.182-12.017-1.299-1.991-.764-3.826-1.935-5.732-2.921l-.223-.366-.295-.544zm28.365-2.383l.325-.583c.903-2.323.498-2.954-1.958-2.982a163.693 163.693 0 0 0-5.473.004c-1.77.039-2.164.61-1.692 2.306.214.885.304 1.824.665 2.645.919 2.089 2.582 3.255 4.052 3.009 2.003-.334 3.798-2.271 4.089-4.41l-.008.011zm-26.59-.002l-.004-.008c.334 2.222 1.678 3.589 3.743 4.257 1.456.471 2.737-.187 3.445-1.323.773-1.241 1.117-2.749 1.648-4.14.506-1.734.149-2.289-1.614-2.341-1.575-.047-3.152-.022-4.728-.01-3.382.026-3.448.108-2.796 3.258l.306.307z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E08700\" d=\"M34.396 34.266c-.011 2.112.201 4.257-.105 6.326-.234 1.576-1.126 3.054-1.91 5.045 1.258.725 2.775 2.015 4.521 2.525 4.579 1.338 5.871 4.61 6.088 8.946l1.016-2.654c.286 6.411.017 12.748-2.142 18.865-1.947-.455-1.883-.452-1.76-2.595.229-3.981.47-7.966.528-11.952.05-3.463-1.397-6.156-4.581-7.839-1.692-.895-3.394-1.847-4.882-3.035-2.464-1.965-2.316-5.169.248-6.733l.092 1.429.32.148c.562-1.388 1.223-2.746 1.657-4.173.424-1.398.616-2.866.91-4.303zm49.478 39.055c-2.064-6.134-2.361-12.483-2.081-18.97l.959 2.66c.389-1.675.684-3.394 1.199-5.044.62-1.988 2.413-2.688 4.14-3.472 1.904-.863 3.739-1.878 5.813-2.933-2.617-2.999-2.921-6.336-2.891-9.748.003-.42.293-.838.45-1.258.451 2.76.951 5.503 2.677 8.203l.195-1.605c2.273 1.304 2.803 4.151.94 6.025-1.224 1.232-2.724 2.33-4.301 3.044-4.343 1.966-6.156 5.272-5.894 9.906.206 3.635.312 7.277.605 10.905.121 1.492-.279 2.258-1.811 2.287zm10.523-30.377l-.042.079.062.008-.02-.087z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E08600\" d=\"M48.308 89.076c1.906.987 3.741 2.158 5.732 2.921 3.862 1.48 7.889 1.795 12.017 1.299 3.018-.361 5.899-1.05 8.542-2.567 1.052-.604 2.042-1.313 3.062-1.976-1.667 3.68-4.388 6.344-8.167 7.662-6.126 2.136-12.088 1.788-17.297-2.428-1.584-1.281-2.609-3.254-3.889-4.911z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M31.808 68.79c2.786 5.948 8.101 7.559 13.953 8.108l-2.721 5.057c-7-.573-11.509-5.858-11.232-13.165zM82.69 81.954l-2.637-5.03c5.526-.631 10.837-1.942 13.639-7.684.088.364.263.73.251 1.091-.208 6.014-4.333 11.079-11.253 11.623z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#C7C6C6\" d=\"M31.808 68.79c-.277 7.307 4.232 12.593 11.232 13.165l.5 3.364c-1.357-.234-2.688-.353-3.958-.7-5.518-1.513-8.604-5.417-8.701-11.133-.028-1.638.354-3.282.563-4.921.004-.031.21-.062.311-.041.035.006.037.172.053.266zM82.69 81.954c6.92-.544 11.045-5.609 11.252-11.624.012-.36-.163-.727-.251-1.091l.391-.881c1.235 3.998 1.337 7.925-.99 11.476-2.5 3.813-6.384 5.142-10.812 5.416l.41-3.296z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#F0A500\" d=\"M93.153 8.998c-.971.324-1.681.807-2.334.74-4.605-.473-8.306 1.989-10.977 5.957l-2.039-.989c3.473-6.028 9.498-8.267 15.35-5.708zm-60.149.249c5.402-2.857 11.855-.329 14.989 5.422l-1.86.955c-1.219-1.24-2.314-2.489-3.549-3.579-1.974-1.741-4.355-2.368-6.972-2.333-.867.011-1.738-.301-2.608-.465z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DE8500\" d=\"M88.39 12.089c-.326 2.027-.604 3.804-.899 5.578-.15.899-.434 1.521-1.509 1.885-1.604.542-2.17-.606-2.815-1.443-.312-.403-.183-1.352.05-1.931.762-1.897 2.028-3.358 4.104-3.914.4-.106.822-.136 1.069-.175zm-51.047.082c2.486-.014 5.803 2.794 5.573 5.14-.085.867-1.196 2.014-2.082 2.31-.842.282-2.192-.088-2.46-1.493-.128-.673-.221-1.352-.338-2.027-.224-1.285-.453-2.569-.693-3.93z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E08600\" d=\"M49.517 17.656c-.882 2.294.505 3.99 1.479 5.824.583 1.097.985 2.289 1.469 3.439l-7.799-6.338c1.209-1.334 2.984-2.2 4.851-2.925z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DE8600\" d=\"M73.563 26.665c.434-1.118.726-2.32 1.333-3.333 1.019-1.701 1.795-3.424 1.724-5.447 1.604.853 3.206 1.708 4.746 2.529l-7.803 6.251zm.812 37.831c.233.145.548.234.687.441 1.975 2.964 3.926 5.944 5.883 8.92-3.543.32-2.77.422-3.888-2.348-.937-2.32-1.792-4.674-2.682-7.013zm-29.299 9.371c.454-.846.854-1.725 1.37-2.532a317.609 317.609 0 0 1 4.261-6.468c.197-.292.564-.469.853-.699-1.169 3.016-2.297 6.049-3.523 9.042-.622 1.517-1.94.574-2.961.657z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#ECA200\" d=\"M41.51 88.193c3.753-.937 4.178 2.054 5.542 4.55-2.518-1.134-4.242-2.618-5.542-4.55zm42.661-.03c-1.161 2.103-3.028 3.377-5.157 4.507.774-3.688 1.912-4.65 5.18-4.488l-.023-.019zm.022.019l.021-.13-.044.111.023.019z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DE8600\" d=\"M74.034 63.666l.215.051-.126.178a.244.244 0 0 1-.089-.229z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E08700\" d=\"M91.416 33.085l-.044-.196.066-.081a.226.226 0 0 1-.022.277z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#49330E\" d=\"M72.956 52.236c-.794-1.704-1.561-3.422-2.404-5.102-.197-.393-.601-.822-1-.949-1.687-.534-2.784-1.535-3.107-3.459l2.022.229c.38.026.768.118 1.137.068 1.769-.24 2.977-1.36 4.152-2.599 3.939-4.154 8.561-6.72 14.523-6.022l.803.315-1.929.757c1.625 1.907 1.327 3.789.165 5.855l-.577-2.145-.25-.01-.304 1.803c-.848 1.992-1.655 4.002-3.723 5.119-3.01 1.625-6.032 2.335-9.076.176-1.299 1.977-.531 3.992-.432 5.964zm9.963-11.17v-3.708c-3.12 1.836-5.784 3.622-7.919 6.102l-.88 1.063c2.979 2.234 8.805.764 8.799-3.457z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#49330F\" d=\"M39.841 41.85l-.115-.459-.198-.687-.151-1.548-.299-.028-.622 2.19c-1.198-2.045-1.395-3.916.173-5.884-.69-.238-1.278-.439-1.863-.647l-.04-.126.083-.121.428-.183c.059.036.114.03.164-.019 2.233.245 4.535.229 6.683.796 3.373.891 5.977 3.125 8.307 5.674 1.296 1.417 2.785 2.48 4.87 2.147l1.87-.229c.047 1.625-.912 2.884-2.778 3.374-.851.223-.999.652-1.271 1.434-.571 1.635-1.517 3.14-2.309 4.696.197-1.995.876-4.028-.434-5.989-1.587 1.185-3.316 1.62-5.188 1.284-3.415-.613-5.941-2.408-7.31-5.675zm10.908 1.581c-2.136-2.473-4.794-4.26-7.911-6.077v3.706c.049 4.311 5.937 5.679 8.754 3.498-.084-.155-.155-.333-.268-.478-.176-.228-.382-.434-.575-.649z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E08700\" d=\"M72.956 52.236c-.099-1.973-.867-3.987.431-5.964 3.044 2.159 6.066 1.449 9.076-.176 2.068-1.117 2.875-3.127 3.723-5.119-.277 4.773-3.432 10-11.121 9.241l1.415 4.2.004-.005-3.528-2.177zM39.841 41.85c1.369 3.267 3.895 5.062 7.309 5.675 1.872.336 3.601-.099 5.188-1.284 1.31 1.961.631 3.994.434 5.989l-3.529 2.183.004.004 1.467-4.154c-6.598.122-11.035-3.451-10.873-8.413z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DE8600\" d=\"M57.26 42.955c-2.085.333-3.574-.73-4.87-2.147-2.33-2.548-4.934-4.783-8.307-5.674-2.148-.567-4.45-.551-6.683-.796 1.626-.408 3.26-1.178 4.877-1.144 2.632.056 5.326.465 7.478 2.259 1.01.842 2.074 1.734 2.759 2.826 1.232 1.963 2.747 3.54 4.746 4.676z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DF8600\" d=\"M88.278 34.402c-5.962-.698-10.584 1.869-14.523 6.022-1.175 1.239-2.383 2.359-4.152 2.599-.369.05-.757-.042-1.137-.068 2.183-1.063 3.602-2.875 4.918-4.843 1.98-2.96 4.871-4.49 8.382-4.685 1.768-.097 3.56.12 5.332.287.412.039.788.449 1.18.688zm-30.154.177l-.589-1.185c1.845.198 3.69.542 5.537.552 1.831.01 3.663-.318 5.544-.502l-.724.84-.297.308.021-.017c-1.848.311-3.691.817-5.546.865-1.308.036-2.631-.551-3.946-.861z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#52380B\" d=\"M58.124 34.579c1.315.31 2.638.897 3.944.862 1.855-.048 3.698-.555 5.546-.865l-.142.253c-3.309 3.565-6.057 3.491-9.348-.25z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#47310D\" d=\"M67.356 84.528c-.472-1.695-.078-2.267 1.692-2.306 1.824-.041 3.649-.025 5.473-.004 2.456.028 2.861.659 1.958 2.982l-.325.583.008-.012c-.426.461-.841.936-1.282 1.383-2.001 2.032-4.198 1.901-5.93-.368-.559-.731-1.064-1.504-1.594-2.258z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#47310E\" d=\"M49.258 85.476c-.652-3.15-.586-3.232 2.796-3.258 1.576-.012 3.153-.038 4.728.01 1.763.053 2.121.607 1.614 2.341-.598.84-1.165 1.704-1.799 2.516-1.485 1.898-3.593 2.017-5.365.329-.565-.538-1.115-1.092-1.672-1.639l.003.008-.305-.307z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DC8400\" d=\"M49.561 85.774c.557.546 1.107 1.101 1.672 1.639 1.771 1.688 3.88 1.57 5.365-.329.634-.812 1.202-1.676 1.799-2.516-.531 1.392-.875 2.899-1.648 4.14-.708 1.136-1.989 1.794-3.445 1.323-2.066-.668-3.409-2.035-3.743-4.257z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DE8500\" d=\"M67.356 84.528c.53.754 1.035 1.526 1.594 2.259 1.732 2.269 3.929 2.4 5.93.368.441-.447.855-.921 1.282-1.383-.291 2.139-2.086 4.076-4.089 4.41-1.471.246-3.133-.92-4.052-3.009-.361-.82-.451-1.76-.665-2.645z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#493310\" d=\"M94.397 42.944l.02.087-.062-.008z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M75 43.459c2.135-2.48 4.799-4.265 7.919-6.102v3.708c-1.287 1.641-2.742 3.105-4.982 3.102-.979 0-1.958-.458-2.937-.708z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#C5C4C3\" d=\"M75 43.459c.979.25 1.958.708 2.937.709 2.24.003 3.695-1.461 4.982-3.102.006 4.221-5.82 5.691-8.799 3.457l.88-1.064z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M42.838 41.06v-3.706c3.117 1.817 5.774 3.604 7.911 6.077-1.231 1.11-3.729 1.144-5.531-.094-.893-.613-1.593-1.509-2.38-2.277z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#C5C4C3\" d=\"M42.838 41.06c.787.768 1.486 1.664 2.379 2.277 1.803 1.238 4.3 1.204 5.531.094.193.215.399.421.576.649.113.145.183.323.268.478-2.817 2.18-8.704.813-8.754-3.498z\"/></svg>"

/***/ }),

/***/ "../src/components/grunt/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GruntOriginalWordmark = __webpack_require__("../src/components/grunt/original-wordmark/GruntOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GruntOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/grunt/original/GruntOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GruntOriginal = __webpack_require__("../src/components/grunt/original/GruntOriginal.svg");
	
	var _GruntOriginal2 = _interopRequireDefault(_GruntOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GruntOriginal */
	function GruntOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GruntOriginal',
	    svg: _GruntOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GruntOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GruntOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/grunt/original/GruntOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#493310\" d=\"M95.829 88.914c3.585-2.669 5.424-6.045 6.278-10.224 4.158 4.112 5.623 8.948 5.28 14.41-.465 7.407-3.867 12.805-10.891 15.705-.55.228-1.046.827-1.349 1.375-3.292 5.965-8.135 9.74-14.96 10.819-.572.09-1.143.416-1.635.749-8.116 5.477-21.017 5.457-29.175-.038a4.822 4.822 0 0 0-1.828-.738c-6.137-1.061-10.799-4.298-13.954-9.611-.917-1.546-1.983-2.586-3.641-3.343-11.845-5.406-11.643-22.932-4.233-29.038.723 1.785 1.281 3.66 2.215 5.326.942 1.681 2.256 3.153 3.407 4.717l.564-.154c.195-1.959.455-3.914.568-5.877.159-2.764.28-5.535.288-8.304.01-3.38-1.254-6.012-4.446-7.656-2.337-1.204-4.67-2.537-6.704-4.184-4.972-4.026-4.846-9.453.18-13.347 1.207-.934 1.923-2.001 2.064-3.511.297-3.182.797-6.355-1.482-9.161-.632-.778-.95-1.858-1.252-2.849-1.472-4.817.898-8.657 5.89-9.44 1.439-.226 2.222-.598 2.394-2.273.307-2.985-.334-5.035-3.084-6.473-2.189-1.146-4.63-1.812-7.047-2.725C22.1 9.011 26.3 7.161 31.222 6.864c6.508-.394 11.61 2.577 15.951 7.134.721.756 1.324 1.63 2.083 2.342.375.353.993.645 1.472.606.249-.021.584-.809.624-1.271.326-3.821 2.052-6.905 4.869-9.419.48-.428 1.088-.713 1.649-1.072l1.382 6.472.6-.006c.99-5.185 4.528-7.827 9.161-9.493-.097 1.552-.324 3.006-.239 4.441.083 1.375.488 2.732.803 4.359 2.635-1.838 4.929-3.746 7.934-3.667-.647 2.462-1.35 4.859-1.888 7.293-.276 1.249.069 2.433 1.658 2.4.581-.012 1.298-.465 1.701-.934 3.424-3.979 7.22-7.383 12.502-8.692 6.737-1.67 13.518.59 17.356 5.953-.729.179-1.415.292-2.062.518-1.671.586-3.442 1.015-4.96 1.88-3.216 1.833-3.731 3.565-2.961 7.677.07.371.66.762 1.09.92.683.25 1.452.256 2.155.464 4.107 1.209 6.069 4.611 4.896 8.717a16.461 16.461 0 0 1-1.876 4.177c-2.089 3.325-1.314 6.75-.458 10.14.19.751 1.187 1.348 1.896 1.913 4.33 3.451 4.747 8.714.589 12.396-2.313 2.048-5.117 3.585-7.829 5.126-2.491 1.415-3.956 3.483-3.964 6.208-.021 5.155.295 10.311.473 15.468zm-17.901-8.872l-.02.015a.304.304 0 0 0 .112.285l.313.75c1.112 2.919 2.178 5.857 3.347 8.752 1.395 3.457.43 3.329 4.852 2.93l3.656-.669c1.913-.037 2.411-.992 2.261-2.854-.366-4.526-.499-9.071-.755-13.607-.327-5.783 1.935-9.909 7.354-12.362 1.968-.891 3.84-2.261 5.368-3.798 2.324-2.339 1.663-5.892-1.174-7.519l-.244 2.003c-2.154-3.37-2.778-6.792-3.341-10.236l-.058-1.837a.282.282 0 0 0 .027-.346l.879-6.657.34.05.495 2.085c.711-1.244 1.296-2.104 1.718-3.035 1.656-3.664.166-6.115-3.903-6.062-2.426.031-4.901.391-7.256.988-6.147 1.559-11.187 5.234-16.205 8.906-.501.367-1.026.703-1.54 1.053l-.238-.278 2.604-3.729.641-.748a.351.351 0 0 0 .161-.241l9.737-7.8-5.92-3.158-.08.013-.429-.317c-6.837-3.207-14.108-3.861-21.441-2.985-4.021.48-7.921 1.971-11.876 3.005-2.329.905-4.544 1.985-6.054 3.649l9.732 7.91-.004-.016.351.483 2.74 3.949c-3.093-1.732-5.883-3.707-8.754-5.557-4.446-2.864-9.268-4.779-14.585-5.153-2.251-.158-4.912-.428-6.082 1.983-1.211 2.496.439 4.702 1.83 6.753.052.077.214.08.394.141l.225-1.946c.449.953.726 1.895.836 2.856.216 1.886.34 3.783.503 5.676-.367 1.793-.607 3.626-1.137 5.37-.541 1.781-1.366 3.475-2.067 5.208l-.399-.185-.115-1.783c-3.2 1.951-3.384 5.95-.309 8.402 1.858 1.481 3.981 2.67 6.093 3.787 3.973 2.1 5.779 5.461 5.716 9.782-.071 4.974-.372 9.946-.658 14.915-.154 2.674-.234 2.67 2.196 3.238l4.008.685c1.275-.103 2.919 1.074 3.694-.819 1.53-3.735 2.938-7.52 4.396-11.284a.494.494 0 0 0 .091-.3l.371-.789 1.484-2.832.443.156c-.663 6.637-3.001 12.894-4.993 19.399 11.109 0 21.915.001 32.72-.006.174 0 .347-.083.463-.113l-5.401-20.483.608-.187 2.013 4.064.266.45zm12.658 30.609c-4.079-.202-5.498.998-6.464 5.601 2.658-1.411 4.987-3 6.436-5.625l.056-.138-.028.162zm11.852-23.638c-3.496 7.166-10.123 8.802-17.019 9.588l3.291 6.277-.511 4.114c5.525-.342 10.373-2 13.492-6.758 2.904-4.432 2.777-9.332 1.235-14.321l-.488 1.1zm-77.224-.562c-.02-.116-.022-.324-.064-.333-.126-.026-.383.012-.388.05-.262 2.045-.738 4.098-.703 6.142.122 7.133 3.973 12.004 10.859 13.893 1.583.434 3.245.582 4.938.874l-.625-4.198 3.395-6.311c-7.302-.684-13.935-2.694-17.412-10.117zm57.22 24.912l.394-.725c.587-1.341 1.273-2.649 1.744-4.029 1.516-4.451-.194-6.876-4.903-7.07a21.765 21.765 0 0 0-.921-.018c-9.829-.001-19.658-.011-29.486.014-.972.002-1.965.115-2.911.337-2.918.685-4.064 2.405-3.295 5.288.5 1.877 1.388 3.651 2.102 5.472l.37.678.277.457c1.599 2.067 2.877 4.529 4.854 6.129 6.5 5.262 13.94 5.696 21.585 3.03 4.715-1.645 8.111-4.97 10.191-9.562l-.001-.001zm19.333-99.527c-7.302-3.192-14.822-.398-19.156 7.122l2.544 1.235c3.333-4.952 7.951-8.023 13.699-7.434.815.084 1.701-.518 2.913-.923zm-75.06.311c1.085.205 2.172.595 3.255.581 3.265-.044 6.236.738 8.7 2.911 1.542 1.359 2.908 2.918 4.429 4.466l2.321-1.191c-3.911-7.178-11.964-10.332-18.705-6.767zm69.116 3.548c-.308.048-.834.085-1.335.219-2.59.693-4.169 2.517-5.121 4.884-.291.723-.451 1.907-.063 2.41.805 1.044 1.511 2.477 3.513 1.8 1.343-.454 1.697-1.23 1.884-2.352.369-2.214.716-4.432 1.122-6.961zm-63.702.101c.3 1.698.586 3.301.865 4.904.146.843.263 1.69.422 2.53.334 1.752 2.019 2.214 3.07 1.862 1.105-.37 2.492-1.801 2.598-2.883.287-2.925-3.853-6.43-6.955-6.413zm5.201 94.87c1.622 2.41 3.773 4.262 6.916 5.677-1.702-3.114-2.233-6.847-6.916-5.677z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#F5A900\" d=\"M28.444 43.369c-.163-1.894-.287-3.79-.503-5.676a9.068 9.068 0 0 0-.836-2.856l-.225 1.946c-.18-.061-.342-.063-.394-.141-1.391-2.051-3.041-4.257-1.83-6.753 1.17-2.411 3.831-2.141 6.082-1.983 5.317.375 10.14 2.29 14.585 5.153 2.871 1.85 5.661 3.825 8.754 5.557l-2.74-3.949-.351-.482.005.016c-.604-1.435-1.105-2.923-1.833-4.292-1.216-2.289-2.946-4.406-1.846-7.268 3.955-1.035 7.855-2.525 11.876-3.005 7.333-.876 14.604-.222 21.441 2.986l.429.316.078-.012c.088 2.524-.88 4.675-2.152 6.797-.758 1.265-1.122 2.765-1.663 4.16a.357.357 0 0 1-.16.242l-.642.747-2.604 3.729.238.278c.514-.35 1.039-.686 1.54-1.053 5.018-3.672 10.057-7.348 16.205-8.906 2.355-.597 4.831-.957 7.256-.988 4.069-.053 5.559 2.398 3.903 6.062-.422.932-1.007 1.792-1.718 3.035l-.495-2.085-.34-.05-.879 6.657-.083.102.055.245.058 1.837c-.195.523-.557 1.045-.561 1.569-.037 4.258.342 8.422 3.608 12.165-2.589 1.316-4.879 2.583-7.255 3.66-2.155.978-4.393 1.852-5.167 4.333-.642 2.06-1.01 4.205-1.496 6.294l-1.197-3.32c-.349 8.095.021 16.019 2.597 23.672l-3.656.669c-2.442-3.714-4.877-7.432-7.341-11.131-.173-.259-.566-.371-.857-.551l-.313-.75.157-.222-.269-.063.021-.015-.268-.448-2.013-4.064-.608.187 5.401 20.483c-.116.03-.29.113-.463.113-10.805.007-21.61.006-32.72.006 1.991-6.506 4.33-12.762 4.993-19.399l-.443-.156-1.485 2.832-.371.789a.502.502 0 0 1-.09.3c-.36.287-.819.508-1.065.872a392.517 392.517 0 0 0-5.316 8.071c-.643 1.007-1.144 2.104-1.709 3.16l-4.008-.685c2.695-7.634 3.03-15.542 2.673-23.542l-1.268 3.312c-.271-5.412-1.882-9.494-7.597-11.164-2.179-.637-4.073-2.247-5.643-3.151.979-2.485 2.092-4.329 2.383-6.296.386-2.583.121-5.261.135-7.896zm41.428.407l.371-.383.904-1.048c-2.348.23-4.634.638-6.918.626-2.304-.013-4.607-.443-6.91-.689l-.48-.134.48.133.736 1.479c4.106 4.667 7.536 4.76 11.666.313.08-.086.119-.21.177-.316l-.026.019zM46.971 68.511l4.404-2.722c.989-1.944 2.169-3.822 2.882-5.862.34-.975.525-1.511 1.586-1.79 2.329-.61 3.526-2.182 3.467-4.209l-2.333.285c-2.496-1.417-4.387-3.386-5.922-5.834-.854-1.362-2.183-2.476-3.443-3.527-2.685-2.24-6.047-2.75-9.332-2.82-2.018-.042-4.057.918-6.086 1.428-.062.061-.13.067-.204.023l-.535.228-.103.15c-.009.05.017.146.05.158.73.259 1.463.51 2.324.808-1.957 2.457-1.711 4.791-.216 7.343l.776-2.733.374.035.189 1.932.247.857.144.573c-.203 6.192 5.334 10.651 13.567 10.499l-1.831 5.184-.084.149.079-.155zm33.995-.001l.146.088-.152-.082-1.766-5.241c9.595.948 13.532-5.575 13.878-11.533l.379-2.249.312.012.72 2.677c1.45-2.578 1.823-4.927-.206-7.306l2.408-.946-1.002-.393c-.49-.298-.959-.81-1.472-.857-2.212-.208-4.447-.479-6.653-.357-4.382.242-7.989 2.152-10.46 5.846-1.643 2.456-3.413 4.716-6.137 6.043l-2.523-.286c.403 2.402 1.772 3.651 3.877 4.317.498.158 1.002.693 1.247 1.184 1.052 2.096 2.009 4.24 3 6.367l4.404 2.716z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#F5A800\" d=\"M45.156 110.632c-.714-1.82-1.602-3.594-2.102-5.472-.769-2.883.377-4.603 3.295-5.288a12.963 12.963 0 0 1 2.911-.337c9.829-.024 19.658-.015 29.486-.014.307 0 .615.005.921.018 4.709.193 6.419 2.619 4.903 7.07-.47 1.38-1.156 2.688-1.744 4.029l-.394.725-.001.002c-1.271.826-2.508 1.711-3.82 2.466-3.299 1.893-6.894 2.751-10.66 3.203-5.151.619-10.176.227-14.996-1.621-2.485-.953-4.775-2.415-7.153-3.646l-.277-.457-.369-.678zm35.398-2.974l.405-.728c1.126-2.9.622-3.686-2.443-3.722-2.276-.025-4.554-.044-6.83.006-2.209.048-2.7.762-2.111 2.877.266 1.104.379 2.277.83 3.3 1.147 2.607 3.221 4.062 5.057 3.755 2.499-.417 4.74-2.834 5.103-5.503l-.011.015zm-33.181-.002l-.005-.009c.417 2.772 2.093 4.478 4.67 5.313 1.817.588 3.416-.232 4.299-1.65.964-1.549 1.394-3.43 2.057-5.167.632-2.164.186-2.856-2.014-2.921-1.965-.059-3.933-.028-5.9-.012-4.222.033-4.304.135-3.49 4.065l.383.381z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E08700\" d=\"M28.444 43.369c-.014 2.635.251 5.313-.132 7.893-.292 1.967-1.405 3.811-2.383 6.296 1.57.904 3.464 2.514 5.643 3.151 5.714 1.67 7.326 5.752 7.597 11.164l1.268-3.312c.356 8 .021 15.907-2.673 23.542-2.43-.567-2.35-.563-2.196-3.238.287-4.968.587-9.941.658-14.915.063-4.321-1.743-7.682-5.716-9.782-2.112-1.116-4.234-2.305-6.093-3.787-3.075-2.453-2.891-6.451.309-8.402l.115 1.783.399.185c.701-1.732 1.526-3.427 2.067-5.208.53-1.744.77-3.576 1.137-5.37zm61.743 48.737c-2.576-7.654-2.946-15.578-2.597-23.672l1.197 3.32c.485-2.09.854-4.235 1.496-6.294.774-2.48 3.012-3.355 5.167-4.333 2.375-1.077 4.666-2.343 7.255-3.66-3.266-3.743-3.645-7.907-3.608-12.165.004-.524.366-1.046.561-1.569.563 3.444 1.187 6.867 3.341 10.236l.244-2.003c2.836 1.627 3.498 5.18 1.174 7.519-1.527 1.538-3.399 2.907-5.368 3.798-5.42 2.453-7.682 6.579-7.354 12.362.256 4.536.389 9.081.755 13.607.148 1.862-.35 2.817-2.263 2.854zm13.132-37.907l-.051.098.077.01-.026-.108z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E08600\" d=\"M45.804 111.767c2.378 1.231 4.668 2.693 7.153 3.646 4.819 1.848 9.845 2.24 14.996 1.621 3.766-.452 7.361-1.31 10.66-3.203 1.313-.754 2.549-1.64 3.82-2.466-2.08 4.592-5.476 7.917-10.191 9.562-7.645 2.666-15.085 2.231-21.585-3.03-1.976-1.601-3.255-4.063-4.853-6.13z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M25.214 86.451c3.478 7.423 10.11 9.433 17.412 10.118l-3.395 6.311c-8.735-.714-14.363-7.31-14.017-16.429zm63.496 16.428a9549.906 9549.906 0 0 0-3.291-6.277c6.896-.787 13.523-2.423 17.019-9.588.11.454.329.911.313 1.361-.258 7.505-5.405 13.825-14.041 14.504z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#C7C6C6\" d=\"M25.214 86.451c-.346 9.119 5.282 15.714 14.017 16.428l.625 4.198c-1.694-.292-3.355-.44-4.938-.874-6.886-1.888-10.737-6.76-10.859-13.893-.035-2.043.441-4.096.703-6.142.005-.039.262-.077.388-.05.042.009.044.217.064.333zm63.496 16.428c8.636-.679 13.783-6.999 14.042-14.505.016-.45-.204-.907-.313-1.361l.488-1.1c1.542 4.989 1.669 9.889-1.235 14.321-3.119 4.759-7.967 6.416-13.492 6.758l.51-4.113z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#F0A500\" d=\"M101.767 11.836c-1.212.405-2.098 1.007-2.913.923-5.748-.589-10.365 2.482-13.699 7.434l-2.544-1.235c4.334-7.52 11.854-10.314 19.156-7.122zm-75.06.311c6.741-3.565 14.794-.411 18.705 6.766l-2.321 1.191c-1.521-1.548-2.888-3.106-4.429-4.466-2.464-2.172-5.435-2.955-8.7-2.911-1.083.015-2.17-.375-3.255-.58z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DE8500\" d=\"M95.823 15.695c-.407 2.529-.753 4.747-1.122 6.961-.187 1.122-.541 1.898-1.884 2.352-2.001.677-2.708-.756-3.513-1.8-.388-.503-.229-1.687.063-2.41.951-2.367 2.53-4.191 5.121-4.884.501-.134 1.027-.171 1.335-.219zm-63.702.101c3.102-.017 7.242 3.487 6.955 6.414-.106 1.082-1.493 2.513-2.598 2.883-1.051.352-2.736-.11-3.07-1.862-.159-.84-.276-1.688-.422-2.53-.279-1.604-.565-3.207-.865-4.905z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E08600\" d=\"M47.313 22.641c-1.1 2.862.63 4.979 1.846 7.268.727 1.369 1.229 2.856 1.833 4.292l-9.732-7.91c1.508-1.665 3.723-2.745 6.053-3.65z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DE8600\" d=\"M77.321 33.883c.541-1.395.905-2.895 1.663-4.16 1.272-2.123 2.24-4.273 2.152-6.797 2.001 1.065 4 2.131 5.922 3.157l-9.737 7.8zm1.012 47.21c.291.18.684.292.857.551 2.464 3.699 4.899 7.417 7.341 11.131-4.422.399-3.457.527-4.852-2.93-1.168-2.895-2.234-5.833-3.346-8.752zM41.771 92.787c.566-1.056 1.066-2.153 1.709-3.16a398.037 398.037 0 0 1 5.316-8.071c.246-.364.705-.585 1.065-.872-1.459 3.764-2.867 7.549-4.396 11.284-.775 1.893-2.419.716-3.694.819z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#ECA200\" d=\"M37.322 110.666c4.683-1.17 5.214 2.563 6.916 5.677-3.143-1.416-5.295-3.267-6.916-5.677zm53.236-.039c-1.449 2.624-3.778 4.214-6.436 5.625.967-4.603 2.386-5.803 6.464-5.601l-.028-.024zm.028.024l.027-.163-.056.139.029.024z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DE8600\" d=\"M77.908 80.057l.269.063-.157.222a.303.303 0 0 1-.112-.285z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E08700\" d=\"M99.599 41.896l-.055-.245.083-.102a.283.283 0 0 1-.028.347z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#49330E\" d=\"M76.563 65.794c-.991-2.126-1.948-4.271-3-6.367-.245-.49-.749-1.026-1.247-1.184-2.105-.667-3.474-1.916-3.877-4.317l2.523.286c.474.033.958.147 1.419.085 2.207-.299 3.714-1.697 5.181-3.243 4.916-5.184 10.683-8.387 18.124-7.516l1.002.393-2.408.946c2.028 2.379 1.656 4.728.206 7.306l-.72-2.677-.312-.012-.379 2.25c-1.058 2.485-2.065 4.994-4.646 6.388-3.756 2.028-7.527 2.915-11.326.22-1.623 2.466-.664 4.981-.54 7.442zm12.433-13.94v-4.628c-3.894 2.292-7.218 4.52-9.882 7.614l-1.099 1.328c3.718 2.788 10.989.954 10.981-4.314z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#49330F\" d=\"M35.239 52.833l-.144-.573-.247-.857-.189-1.932-.374-.035-.776 2.733c-1.495-2.552-1.741-4.886.216-7.343-.861-.297-1.594-.548-2.324-.808-.033-.012-.06-.108-.05-.158l.103-.15.535-.228c.073.044.142.038.204-.023 2.786.306 5.659.286 8.339.993 4.209 1.111 7.459 3.9 10.367 7.081 1.617 1.768 3.475 3.095 6.077 2.679l2.333-.285c.059 2.028-1.138 3.599-3.467 4.209-1.061.279-1.246.815-1.586 1.79-.713 2.041-1.893 3.918-2.882 5.861.247-2.49 1.094-5.026-.542-7.473-1.98 1.479-4.139 2.021-6.474 1.602-4.258-.766-7.411-3.006-9.119-7.083zm13.612 1.973c-2.666-3.085-5.982-5.317-9.872-7.583v4.625c.062 5.38 7.409 7.086 10.925 4.365-.105-.193-.193-.416-.334-.597-.221-.285-.478-.542-.719-.81z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#E08700\" d=\"M76.563 65.794c-.124-2.462-1.083-4.976.539-7.443 3.799 2.694 7.57 1.808 11.326-.22 2.581-1.395 3.588-3.903 4.646-6.388-.346 5.957-4.284 12.48-13.878 11.532l1.766 5.241.005-.006-4.404-2.716zM35.239 52.833c1.708 4.077 4.86 6.317 9.12 7.083 2.335.42 4.494-.123 6.474-1.602 1.635 2.447.788 4.983.542 7.473l-4.404 2.724.005.005 1.831-5.184c-8.233.152-13.771-4.307-13.568-10.499z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DE8600\" d=\"M56.977 54.212c-2.602.416-4.46-.911-6.077-2.679-2.908-3.181-6.158-5.97-10.367-7.081-2.68-.708-5.553-.688-8.339-.993 2.029-.51 4.068-1.471 6.085-1.428 3.285.07 6.647.58 9.332 2.82 1.261 1.051 2.589 2.165 3.443 3.527 1.536 2.448 3.427 4.417 5.923 5.834z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DF8600\" d=\"M95.684 43.538c-7.44-.871-13.208 2.332-18.124 7.516-1.466 1.546-2.974 2.944-5.181 3.243-.461.063-.945-.052-1.419-.085 2.724-1.327 4.495-3.587 6.137-6.043 2.471-3.694 6.078-5.604 10.46-5.846 2.207-.122 4.441.15 6.653.357.515.049.984.56 1.474.858zm-37.63.222l-.736-1.479v.001c2.303.247 4.605.676 6.91.689 2.284.012 4.57-.396 6.918-.626l-.903 1.048-.371.383.025-.021c-2.306.388-4.606 1.02-6.921 1.08-1.63.044-3.281-.689-4.922-1.075z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#52380B\" d=\"M58.054 43.76c1.641.387 3.292 1.119 4.921 1.076 2.315-.061 4.615-.692 6.921-1.08-.058.106-.097.23-.177.316-4.129 4.448-7.558 4.355-11.665-.312z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#47310D\" d=\"M69.575 106.091c-.589-2.115-.098-2.829 2.111-2.877 2.276-.05 4.554-.031 6.83-.006 3.065.036 3.57.822 2.443 3.722l-.405.728.01-.015c-.532.576-1.049 1.167-1.6 1.726-2.498 2.536-5.238 2.372-7.4-.459-.697-.913-1.328-1.877-1.989-2.819z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#47310E\" d=\"M46.99 107.274c-.814-3.931-.732-4.033 3.49-4.065 1.967-.016 3.935-.047 5.9.012 2.2.065 2.646.758 2.014 2.921-.746 1.048-1.454 2.126-2.246 3.139-1.853 2.369-4.484 2.518-6.695.41-.704-.671-1.391-1.363-2.086-2.044l.004.009-.381-.382z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DC8400\" d=\"M47.368 107.647c.695.682 1.382 1.373 2.086 2.044 2.211 2.107 4.842 1.959 6.695-.41.792-1.013 1.5-2.091 2.246-3.139-.663 1.737-1.092 3.618-2.057 5.167-.884 1.418-2.482 2.238-4.299 1.65-2.578-.834-4.254-2.54-4.671-5.312z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DE8500\" d=\"M69.575 106.091c.661.941 1.292 1.905 1.989 2.819 2.162 2.831 4.902 2.995 7.4.459.551-.559 1.067-1.15 1.6-1.726-.363 2.669-2.604 5.086-5.103 5.503-1.835.307-3.91-1.148-5.057-3.755-.449-1.023-.563-2.196-.829-3.3z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#493310\" d=\"M103.319 54.199l.026.108-.077-.01z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M79.114 54.841c2.664-3.095 5.989-5.323 9.882-7.614v4.628c-1.606 2.047-3.421 3.875-6.217 3.872-1.222-.003-2.444-.574-3.665-.886z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#C5C4C3\" d=\"M79.114 54.841c1.222.312 2.443.883 3.665.885 2.796.004 4.611-1.824 6.217-3.872.008 5.268-7.263 7.102-10.981 4.314l1.099-1.327z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\" d=\"M38.979 51.847v-4.625c3.889 2.267 7.206 4.498 9.872 7.583-1.536 1.385-4.652 1.428-6.902-.117-1.115-.765-1.988-1.883-2.97-2.841z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#C5C4C3\" d=\"M38.979 51.847c.982.958 1.855 2.077 2.97 2.842 2.25 1.545 5.366 1.502 6.902.117.242.269.499.525.719.81.141.181.229.403.334.597-3.516 2.72-10.863 1.014-10.925-4.366z\"/></svg>"

/***/ }),

/***/ "../src/components/grunt/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GruntOriginal = __webpack_require__("../src/components/grunt/original/GruntOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GruntOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/grunt/plain-wordmark/GruntPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GruntPlainWordmark = __webpack_require__("../src/components/grunt/plain-wordmark/GruntPlainWordmark.svg");
	
	var _GruntPlainWordmark2 = _interopRequireDefault(_GruntPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GruntPlainWordmark */
	function GruntPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GruntPlainWordmark',
	    svg: _GruntPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GruntPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GruntPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/grunt/plain-wordmark/GruntPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FCAA1A\" d=\"M92.462 53.242c2.167-1.232 4.408-2.46 6.257-4.097 3.323-2.942 2.99-7.149-.471-9.907-.566-.451-1.363-.928-1.516-1.529-.684-2.708-1.304-5.447.366-8.104a13.124 13.124 0 0 0 1.5-3.337c.938-3.282-.63-6.001-3.912-6.968-.563-.166-1.177-.171-1.723-.371-.344-.126-.815-.439-.871-.735-.615-3.287-.203-4.671 2.367-6.136 1.213-.692 2.628-1.035 3.964-1.503.517-.181 1.065-.271 1.647-.414-3.067-4.287-8.487-6.093-13.872-4.758-4.222 1.046-7.255 3.767-9.992 6.947-.322.375-.895.737-1.359.747-1.271.026-1.546-.92-1.325-1.918.43-1.945.991-3.861 1.509-5.829-2.401-.063-4.235 1.462-6.341 2.93-.252-1.301-.576-2.385-.642-3.484-.068-1.147.112-2.309.19-3.549-3.702 1.331-6.53 3.443-7.321 7.587l-.479.005-1.105-5.172c-.447.286-.934.514-1.317.856-2.251 2.009-3.631 4.474-3.892 7.528-.032.37-.3 1-.498 1.016-.383.031-.877-.202-1.177-.484-.606-.57-1.089-1.268-1.665-1.873-3.469-3.641-7.546-6.016-12.748-5.701-3.934.237-7.291 1.715-9.548 4.959 1.933.729 3.883 1.261 5.633 2.177 2.198 1.15 2.71 2.788 2.465 5.174-.137 1.339-.762 1.637-1.913 1.817-3.989.625-5.883 3.694-4.707 7.545.242.792.496 1.655 1.001 2.276 1.821 2.243 1.422 4.779 1.185 7.322-.113 1.207-.685 2.06-1.649 2.807-4.017 3.112-4.117 7.45-.144 10.667 1.626 1.316 3.491 2.381 5.358 3.344 2.552 1.314 3.562 3.417 3.554 6.118-.007 2.213-.104 4.428-.23 6.637-.091 1.569-.299 3.132-.454 4.698l-.451.123c-.92-1.25-1.97-2.427-2.723-3.77-.746-1.332-1.193-2.831-1.771-4.257-5.922 4.88-6.083 18.888 3.384 23.208 1.324.605 2.176 1.436 2.909 2.672 2.521 4.246 6.248 6.833 11.152 7.681a3.882 3.882 0 0 1 1.461.59c6.521 4.391 16.831 4.408 23.317.03.395-.266.85-.526 1.307-.599 5.455-.863 9.326-3.879 11.957-8.647.242-.438.639-.917 1.078-1.099 5.614-2.318 8.333-6.632 8.705-12.552.274-4.365-.897-8.229-4.221-11.517-.683 3.34-2.151 6.039-5.018 8.172-.142-4.121-.395-8.242-.381-12.362.009-2.178 1.179-3.83 3.17-4.961zM38.756 12.128c2.479-.014 5.788 2.787 5.559 5.126-.085.864-1.193 2.008-2.076 2.304-.84.281-2.187-.088-2.454-1.488-.127-.672-.22-1.349-.337-2.022-.224-1.282-.452-2.563-.692-3.92zm6.182 72.955c-1.354-.233-2.682-.352-3.947-.698-5.503-1.509-8.581-5.403-8.678-11.104-.028-1.633.353-3.273.562-4.909.004-.031.209-.061.31-.041.035.007.036.173.053.266 2.778 5.933 8.079 7.539 13.915 8.086l-2.713 5.043.498 3.357zM44 40.94v-3.696c3 1.812 5.879 3.595 8.008 6.061.193.215.458.42.635.647.113.145.093.322.178.477C50.01 46.604 44 45.24 44 40.94zm15.755 43.395c-.597.838-1.162 1.7-1.795 2.509-1.48 1.894-3.584 2.012-5.352.328-.563-.537-1.111-1.089-1.667-1.634l.004.007-.306-.305c-.649-3.142-.585-3.224 2.789-3.25 1.572-.013 3.146-.037 4.716.01 1.759.053 2.115.605 1.611 2.335zm18.034.63l-.319.574.004-.004-.008.012.004-.008c-.424.459-.836.93-1.274 1.375-1.997 2.027-4.187 1.896-5.915-.367-.558-.73-1.061-1.501-1.59-2.253-.471-1.69-.078-2.26 1.688-2.299 1.819-.041 3.64-.025 5.459-.005 2.448.029 2.852.658 1.951 2.975zm-2.46-40.57l.825-1.061C78.284 40.86 80 39.08 84 37.248v3.699c0 4.21-5.699 5.676-8.671 3.448zm19.627 24.652l.39-.879c1.232 3.987 1.334 7.904-.986 11.445-2.493 3.804-6.367 5.128-10.783 5.402l.408-3.288-2.63-5.017c5.51-.628 10.807-1.936 13.601-7.663zM88.772 17.61c-.149.896-.433 1.517-1.506 1.88-1.6.541-2.164-.604-2.808-1.439-.311-.402-.183-1.348.05-1.926.761-1.892 2.022-3.35 4.093-3.903.4-.106.821-.136 1.067-.175-.323 2.021-.601 3.794-.896 5.563zm2.792 88.296h5.162v20.628c-2.364.339-4.352.308-6.016-1.937-2.459-3.316-5.282-6.362-8.213-9.836v11.826H77.43v-20.65c2.329-.285 4.325-.296 5.985 1.956 2.447 3.318 5.268 6.361 8.149 9.782v-11.769zm-57.068.153c3.491 0 6.893-.204 10.257.062 2.858.227 5.174 1.617 5.862 4.746.61 2.771-.526 5.05-3.401 6.985l5.718 8.722c-2.235 0-4.13.097-6.004-.063-.534-.045-1.123-.755-1.484-1.296a73.629 73.629 0 0 1-2.93-4.78c-.529-.939-1.164-1.438-2.405-1.076v7.218h-5.613v-20.518zm5.65 9.172c1.735.076 3.522.382 4.491-1.235.428-.716.438-2.17-.021-2.83-1.051-1.511-2.825-1.116-4.469-1.058l-.001 5.123zm-14.944 4.449h-2.819v-4.053h8.245c0 2.804.028 5.562-.033 8.317-.008.384-.372.936-.721 1.111-4.789 2.405-9.647 2.788-14.375-.041-3.7-2.214-5.383-6.531-4.545-10.892.824-4.286 3.886-7.355 8.268-8.209 3.599-.702 7.069-.408 10.259 1.578.487.304.907.717 1.429 1.136l-2.51 3.682c-.979-.515-1.824-1.002-2.704-1.415-3.872-1.819-7.87-.248-8.856 3.462-1.247 4.685 1.605 8.368 6.296 8.134 2.308-.115 2.44-.284 2.066-2.81zm42.43-13.794h5.489c.088.109.2.184.2.257-.017 4.529.161 9.071-.131 13.583-.246 3.798-3.31 6.437-7.597 7.061-2.539.37-5.017.065-7.291-1.243-2.398-1.379-3.826-3.515-3.962-6.215-.199-3.935-.082-7.886-.098-11.829v-1.564h5.63c.021.45.062.923.063 1.396.007 3.55-.024 7.1.018 10.648.03 2.592 1.263 4.057 3.406 4.202 2.672.181 4.229-1.195 4.261-3.879.043-3.599.012-7.198.013-10.798l-.001-1.619zm49.625.052v4.338h-5.901c0 4.226.013 8.302-.007 12.378-.007 1.269.381 3.088-.277 3.663-.778.679-2.495.284-3.805.354l-.147.001c-1.196.189-1.609-.248-1.589-1.518.075-4.877.03-9.757.03-14.832H99.65v-4.384h17.607z\"/></svg>"

/***/ }),

/***/ "../src/components/grunt/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GruntPlainWordmark = __webpack_require__("../src/components/grunt/plain-wordmark/GruntPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GruntPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/grunt/plain/GruntPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GruntPlain = __webpack_require__("../src/components/grunt/plain/GruntPlain.svg");
	
	var _GruntPlain2 = _interopRequireDefault(_GruntPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GruntPlain */
	function GruntPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GruntPlain',
	    svg: _GruntPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GruntPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GruntPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/grunt/plain/GruntPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FCAA1A\" d=\"M99.317 67.238c2.712-1.541 5.517-3.078 7.829-5.126 4.158-3.682 3.741-8.945-.589-12.396-.709-.564-1.706-1.161-1.896-1.913-.856-3.389-1.632-6.815.458-10.14a16.461 16.461 0 0 0 1.876-4.177c1.174-4.106-.788-7.508-4.896-8.717-.703-.208-1.472-.214-2.154-.464-.431-.158-1.021-.549-1.09-.92-.771-4.112-.255-5.844 2.961-7.677 1.518-.865 3.289-1.294 4.96-1.88.646-.227 1.333-.339 2.061-.518C105 7.947 98.218 5.687 91.482 7.357c-5.282 1.309-9.078 4.713-12.503 8.692-.402.469-1.119.922-1.7.934-1.589.033-1.935-1.151-1.658-2.4.538-2.434 1.24-4.831 1.888-7.293-3.005-.079-5.299 1.829-7.935 3.667-.314-1.627-.72-2.984-.803-4.359-.085-1.435.142-2.889.239-4.441-4.632 1.666-8.171 4.309-9.161 9.493l-.6.006-1.383-6.472c-.561.358-1.169.644-1.648 1.072-2.817 2.514-4.544 5.598-4.869 9.419-.04.463-.375 1.251-.624 1.271-.479.039-1.097-.253-1.472-.606-.758-.712-1.362-1.586-2.083-2.342-4.34-4.557-9.442-7.527-15.95-7.134-4.922.296-9.122 2.146-11.946 6.205 2.418.913 4.858 1.579 7.048 2.725 2.75 1.438 3.391 3.488 3.084 6.473-.172 1.675-.954 2.048-2.395 2.273-4.99.783-7.36 4.623-5.889 9.44.303.991.62 2.071 1.252 2.849 2.279 2.806 1.779 5.979 1.482 9.161-.142 1.51-.856 2.577-2.063 3.512-5.025 3.894-5.151 9.321-.18 13.347 2.034 1.647 4.367 2.98 6.704 4.184 3.192 1.644 4.456 4.276 4.446 7.656-.009 2.769-.13 5.54-.288 8.304-.113 1.963-.374 3.918-.568 5.877l-.564.154c-1.15-1.563-2.465-3.036-3.407-4.717-.934-1.666-1.492-3.542-2.215-5.326-7.409 6.106-7.611 23.632 4.233 29.038 1.657.757 2.724 1.796 3.642 3.343 3.153 5.313 7.816 8.55 13.953 9.611a4.824 4.824 0 0 1 1.827.738c8.158 5.494 21.059 5.515 29.176.038.492-.333 1.063-.659 1.635-.749 6.825-1.08 11.668-4.854 14.96-10.819.303-.548.799-1.147 1.35-1.375 7.023-2.9 10.426-8.298 10.891-15.705.343-5.461-1.122-10.297-5.28-14.41-.854 4.179-2.692 7.555-6.278 10.224-.177-5.156-.494-10.313-.476-15.467.008-2.727 1.473-4.795 3.963-6.21zM32.121 15.796c3.103-.017 7.242 3.487 6.955 6.414-.106 1.082-1.493 2.513-2.599 2.883-1.051.352-2.735-.11-3.069-1.862-.159-.84-.275-1.688-.422-2.53-.279-1.604-.566-3.207-.865-4.905zm7.734 91.281c-1.693-.292-3.355-.44-4.938-.874-6.886-1.888-10.736-6.76-10.858-13.893-.035-2.043.441-4.096.703-6.142.005-.039.262-.077.388-.05.043.008.045.216.065.333 3.477 7.423 10.109 9.433 17.411 10.118l-3.395 6.311.624 4.197zM39 51.847v-4.625c3 2.267 7.195 4.498 9.861 7.583.241.269.492.525.712.81.143.181.238.403.343.597C46.401 58.933 39 57.227 39 51.847zm19.394 54.295c-.746 1.048-1.454 2.126-2.246 3.139-1.853 2.369-4.483 2.518-6.694.41-.705-.671-1.392-1.363-2.086-2.044l.004.009-.382-.382c-.813-3.931-.731-4.033 3.489-4.065 1.968-.016 3.936-.047 5.9.012 2.201.065 2.647.758 2.015 2.921zm22.564.789l-.399.718.005-.005-.01.015.005-.009c-.53.575-1.046 1.164-1.595 1.721-2.498 2.536-5.238 2.372-7.4-.459-.697-.914-1.328-1.878-1.989-2.819-.589-2.115-.098-2.829 2.111-2.877 2.276-.05 4.554-.031 6.83-.006 3.065.035 3.57.821 2.442 3.721zm-2.94-50.763l1.099-1.328C81.78 51.746 85 49.518 89 47.227v4.628c0 5.267-7.266 7.101-10.982 4.313zm24.42 30.845l.488-1.1c1.542 4.989 1.669 9.889-1.235 14.321-3.119 4.759-7.967 6.416-13.492 6.758l.511-4.114-3.29-6.277c6.896-.786 13.522-2.422 17.018-9.588zm-7.737-64.357c-.187 1.122-.541 1.898-1.883 2.352-2.002.677-2.709-.756-3.514-1.8-.389-.503-.229-1.687.063-2.41.951-2.367 2.53-4.191 5.121-4.884.501-.133 1.027-.17 1.335-.219-.406 2.529-.753 4.747-1.122 6.961z\"/></svg>"

/***/ }),

/***/ "../src/components/grunt/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GruntPlain = __webpack_require__("../src/components/grunt/plain/GruntPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GruntPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gulp/plain/GulpPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _GulpPlain = __webpack_require__("../src/components/gulp/plain/GulpPlain.svg");
	
	var _GulpPlain2 = _interopRequireDefault(_GulpPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** GulpPlain */
	function GulpPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'GulpPlain',
	    svg: _GulpPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	GulpPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = GulpPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/gulp/plain/GulpPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#EB4A4B\" d=\"M36.965 35.459c.877 9.232 1.747 18.412 2.637 27.798 1.451-2.495 2.501-4.888 4.085-6.848 1.475-1.826 3.334-3.511 5.357-4.678 2.641-1.524 6.104-.089 6.96 2.614.23.725-.319 1.697-.511 2.556-.646-.341-1.479-.529-1.901-1.051-1.793-2.217-2.873-2.479-4.856-.563-3.699 3.576-5.779 8.056-6.573 13.091-.153.974.456 2.067.713 3.105 1.011-.348 2.185-.476 3.002-1.084 2.656-1.977 4.302-4.666 5.21-7.88.197-.696 1.265-1.145 1.933-1.708.32.658 1.05 1.433.897 1.954a373.814 373.814 0 0 1-4.536 14.429c-.162.484-1.051.725-1.604 1.079-.223-.636-.692-1.302-.617-1.901.168-1.358.605-2.683.91-3.927l-7.24 3.333c.405 4.622.825 9.807 1.323 14.985.382 3.954 1.029 4.978 4.923 5.728 4.544.875 9.173 1.434 13.792 1.774a60.391 60.391 0 0 0 20.23-1.904c2.472-.664 3.458-2.29 3.635-4.717.162-2.235.524-4.456.775-6.685.493-4.391.972-8.783 1.476-13.358-1.667 1.056-2.978 2.238-4.511 2.739-1.116.365-2.524-.169-3.803-.303.245-1.174.23-2.497.796-3.487.922-1.618 2.224-3.021 3.364-4.515l-.491-.591c-.817.483-1.832.8-2.413 1.485-1.182 1.394-2.339 2.886-3.13 4.52-1.324 2.735-2.333 5.622-3.518 8.426-.515 1.216-.959 3.076-2.684 2.366-1.845-.761-.547-2.386-.114-3.542.689-1.844 1.599-3.606 2.215-4.962-1.746.208-3.516.459-5.294.614-.752.064-1.646-.348-2.261-.07-2.045.924-3.341.553-3.766-1.711-.947.615-1.749 1.448-2.694 1.672-1.147.273-2.703.452-3.543-.121-.673-.459-.918-2.184-.688-3.196.457-2.012 1.311-3.946 2.122-5.859.502-1.185 1.007-3.077 2.701-2.253 1.674.813.154 2.185-.232 3.286-.599 1.702-1.209 3.401-1.813 5.101l.96.58c.914-.794 2.053-1.441 2.693-2.415 1.048-1.592 1.681-3.452 2.673-5.086.411-.677 1.296-1.065 1.967-1.584.136.862.462 1.748.354 2.58-.107.841-.698 1.61-.981 2.442-.425 1.246-.768 2.52-1.2 3.969 2.043.078 2.918-.782 3.495-2.299 1.826-4.793 3.672-9.581 5.679-14.3.343-.808 1.509-1.264 2.296-1.884.091.974.525 2.078.216 2.899-1.645 4.349-3.492 8.62-5.228 12.935-.293.727-.387 1.534-.572 2.304 3.059-1.375 5.612-2.895 6.544-6.146.228-.79 1.162-1.377 1.771-2.058l1.416 1.5c.43-.362.824-.774 1.291-1.075 1.47-.947 3.053-1.782 4.603-.315 1.604 1.517.39 2.995-.448 4.307-.912 1.431-2.029 2.73-3.057 4.086 2.312-1.49 5.469-2.158 5.889-5.378 1.024-7.865 1.924-15.746 2.837-23.625.271-2.332.416-4.679.627-7.109-18.21 4.409-36.029 4.436-54.088-.069zm7.816 61.369c.877 2.317 2.209 4.593 2.558 7.011.737 5.147.924 10.372 1.446 15.554.076.755.565 1.792 1.175 2.124 8.98 4.88 18.047 5.726 27.209.389 1.367-.796 1.62-1.847 1.797-3.325.857-7.181-1.051-14.798 3.54-21.56-12.856 3.189-25.403 3.288-37.725-.193zm30.991-60.08c4.362-.421 8.671-1.445 12.985-2.291.813-.159 1.535-.778 2.299-1.185-1.007-.885-1.878-1.311-2.788-1.418-4.53-.535-9.076-.947-13.603-1.508-.684-.085-1.905-.929-1.854-1.083 1.321-3.98 1.256-8.485 4.254-11.839 3.789-4.24 7.617-8.443 11.416-12.648-2.826-3.04-2.864-3.044-5.425-.383-1.448 1.504-2.771 3.15-4.342 4.512-5.813 5.038-9.896 11.005-10.692 18.872-.183 1.805-1.174 2.457-3.069 2.485-6.256.091-12.519.263-18.761.674-3.093.203-6.148.997-9.221 1.523l-.028 1.149c1.923.593 3.809 1.372 5.773 1.749 10.944 2.098 21.991 2.458 33.056 1.391zM72.276 34c-2.477 2-4.524 2-6.501 0h6.501z\"/></svg>"

/***/ }),

/***/ "../src/components/gulp/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GulpPlain = __webpack_require__("../src/components/gulp/plain/GulpPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GulpPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/handlebars/original-wordmark/HandlebarsOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _HandlebarsOriginalWordmark = __webpack_require__("../src/components/handlebars/original-wordmark/HandlebarsOriginalWordmark.svg");
	
	var _HandlebarsOriginalWordmark2 = _interopRequireDefault(_HandlebarsOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** HandlebarsOriginalWordmark */
	function HandlebarsOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'HandlebarsOriginalWordmark',
	    svg: _HandlebarsOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	HandlebarsOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = HandlebarsOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/handlebars/original-wordmark/HandlebarsOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><title>Artboard 5</title><g data-name=\"handlebars\"><path d=\"M6.53 41.21v4.5a6.47 6.47 0 0 1 1.13-1.05 4 4 0 0 1 1.22-.58 5.1 5.1 0 0 1 1.43-.19 4.21 4.21 0 0 1 2 .49A3.79 3.79 0 0 1 14.19 47a9.57 9.57 0 0 1 .11 1.55v5.81a2 2 0 0 1-.42 1.38 1.41 1.41 0 0 1-1.1.47q-1.5 0-1.5-1.84v-5.13a4.69 4.69 0 0 0-.43-2.24 1.71 1.71 0 0 0-1.64-.78 2.46 2.46 0 0 0-1.46.46 2.78 2.78 0 0 0-1 1.26 8.09 8.09 0 0 0-.24 2.41v4a2 2 0 0 1-.41 1.37 1.4 1.4 0 0 1-1.1.48q-1.5 0-1.5-1.84V41.21a2.08 2.08 0 0 1 .39-1.38A1.38 1.38 0 0 1 5 39.37a1.41 1.41 0 0 1 1.13.47 2 2 0 0 1 .4 1.37zM25 54.49a9.37 9.37 0 0 1-2.13 1.28 6 6 0 0 1-2.3.43 4.36 4.36 0 0 1-2-.46 3.37 3.37 0 0 1-1.36-1.25 3.24 3.24 0 0 1-.48-1.71 3.06 3.06 0 0 1 .79-2.12 3.94 3.94 0 0 1 2.16-1.18l1.43-.3q1.14-.23 2-.43t1.77-.47a3.17 3.17 0 0 0-.48-1.76 2.16 2.16 0 0 0-1.89-.52 3.69 3.69 0 0 0-1.74.32 2.84 2.84 0 0 0-1 1q-.42.64-.59.85a1 1 0 0 1-.74.21 1.29 1.29 0 0 1-.88-.33 1.07 1.07 0 0 1-.37-.84 2.57 2.57 0 0 1 .57-1.55 4.05 4.05 0 0 1 1.77-1.24 8 8 0 0 1 3-.49 8.46 8.46 0 0 1 3.14.47 2.93 2.93 0 0 1 1.62 1.49 6.53 6.53 0 0 1 .47 2.71v3.46a6.1 6.1 0 0 0 .24 1.71 5.64 5.64 0 0 1 .28 1.23 1.12 1.12 0 0 1-.44.85 1.47 1.47 0 0 1-1 .38 1.34 1.34 0 0 1-.92-.44 6.46 6.46 0 0 1-.92-1.3zm-.2-4.38a15.3 15.3 0 0 1-1.94.52q-1.27.27-1.76.4a2.4 2.4 0 0 0-.93.5 1.28 1.28 0 0 0-.44 1 1.54 1.54 0 0 0 .52 1.17 1.93 1.93 0 0 0 1.37.48 3.55 3.55 0 0 0 1.66-.39 2.63 2.63 0 0 0 1.12-1 4.64 4.64 0 0 0 .41-2.26zM33.57 45.55v.37a5.31 5.31 0 0 1 1.75-1.55 4.66 4.66 0 0 1 2.18-.49 4.35 4.35 0 0 1 2.14.52A3.31 3.31 0 0 1 41 45.88a3.51 3.51 0 0 1 .39 1.2 12.36 12.36 0 0 1 .09 1.64v5.64a2 2 0 0 1-.42 1.38 1.5 1.5 0 0 1-2.18 0 2 2 0 0 1-.42-1.37v-5.06a5.05 5.05 0 0 0-.37-2.31 1.7 1.7 0 0 0-1.66-.79 2.46 2.46 0 0 0-1.43.49 2.78 2.78 0 0 0-1 1.3 9.48 9.48 0 0 0-.22 2.53v3.8a2 2 0 0 1-.43 1.38 1.44 1.44 0 0 1-1.1.46 1.37 1.37 0 0 1-1.08-.48 2 2 0 0 1-.42-1.37V45.6a1.91 1.91 0 0 1 .38-1.29 1.31 1.31 0 0 1 1-.43 1.4 1.4 0 0 1 .72.19 1.35 1.35 0 0 1 .52.57 2 2 0 0 1 .2.91zM52.85 54.47v-.3a7.71 7.71 0 0 1-1.2 1.14 4.53 4.53 0 0 1-1.29.67 4.84 4.84 0 0 1-1.52.23 4.47 4.47 0 0 1-2-.46 4.7 4.7 0 0 1-1.6-1.32 6 6 0 0 1-1-2 8.57 8.57 0 0 1-.35-2.5 6.51 6.51 0 0 1 1.39-4.43 4.61 4.61 0 0 1 3.65-1.59 4.91 4.91 0 0 1 2.21.45 6.17 6.17 0 0 1 1.75 1.38v-4.48a2.26 2.26 0 0 1 .37-1.41 1.27 1.27 0 0 1 1.06-.48 1.31 1.31 0 0 1 1.06.44 2 2 0 0 1 .37 1.29v13.37a1.86 1.86 0 0 1-.4 1.3 1.34 1.34 0 0 1-1 .43 1.32 1.32 0 0 1-1-.45 1.85 1.85 0 0 1-.5-1.28zm-6-4.45a5.16 5.16 0 0 0 .38 2.1 2.92 2.92 0 0 0 1 1.3 2.59 2.59 0 0 0 1.45.44 2.68 2.68 0 0 0 1.46-.42 2.86 2.86 0 0 0 1.05-1.28 5.16 5.16 0 0 0 .49-2.16 5 5 0 0 0-.39-2.08 3.13 3.13 0 0 0-1.07-1.33 2.55 2.55 0 0 0-1.47-.46 2.48 2.48 0 0 0-1.49.47 3 3 0 0 0-1 1.35 5.39 5.39 0 0 0-.37 2.05zM58.75 54.36V41.21a2 2 0 0 1 .41-1.38 1.37 1.37 0 0 1 1.09-.47 1.43 1.43 0 0 1 1.11.46 2 2 0 0 1 .42 1.38v13.16a2 2 0 0 1-.43 1.38 1.44 1.44 0 0 1-1.1.46 1.37 1.37 0 0 1-1.08-.48 2 2 0 0 1-.42-1.36zM73.38 50.78h-5.93a4 4 0 0 0 .42 1.82 2.78 2.78 0 0 0 2.56 1.59 3.64 3.64 0 0 0 1-.13 3.23 3.23 0 0 0 .87-.4 6.6 6.6 0 0 0 .78-.58q.36-.31.92-.84a1 1 0 0 1 .67-.2 1.1 1.1 0 0 1 .75.26.91.91 0 0 1 .29.72 2 2 0 0 1-.32 1 3.81 3.81 0 0 1-1 1.05 5.51 5.51 0 0 1-1.63.84 7 7 0 0 1-2.26.33 6 6 0 0 1-4.5-1.71A6.2 6.2 0 0 1 64.35 50a7.53 7.53 0 0 1 .4-2.49 5.5 5.5 0 0 1 1.17-2 5.06 5.06 0 0 1 1.89-1.26 6.77 6.77 0 0 1 2.49-.44 5.9 5.9 0 0 1 3 .75 4.93 4.93 0 0 1 1.9 1.94 5.1 5.1 0 0 1 .67 2.5q0 1.14-.65 1.48a4.08 4.08 0 0 1-1.84.3zm-5.93-1.72h5.5a3.68 3.68 0 0 0-.84-2.33 2.51 2.51 0 0 0-1.92-.73 2.43 2.43 0 0 0-1.86.78 3.9 3.9 0 0 0-.88 2.28zM80.92 41.1v4.63a7 7 0 0 1 1.74-1.36 4.65 4.65 0 0 1 2.2-.47 4.86 4.86 0 0 1 2.65.72 4.7 4.7 0 0 1 1.77 2.08 7.64 7.64 0 0 1 .63 3.22 8.63 8.63 0 0 1-.35 2.53 6 6 0 0 1-1 2 4.59 4.59 0 0 1-1.62 1.3 4.73 4.73 0 0 1-2.09.46 5 5 0 0 1-1.33-.21 3.83 3.83 0 0 1-1-.44 4.7 4.7 0 0 1-.74-.56q-.31-.29-.8-.87v.3a1.83 1.83 0 0 1-.41 1.29 1.37 1.37 0 0 1-1 .44 1.3 1.3 0 0 1-1-.44 1.92 1.92 0 0 1-.38-1.29V41.24a2.22 2.22 0 0 1 .37-1.39 1.25 1.25 0 0 1 1-.47 1.33 1.33 0 0 1 1.08.45 1.94 1.94 0 0 1 .28 1.27zm.14 9a4.17 4.17 0 0 0 .83 2.78 2.71 2.71 0 0 0 2.17 1 2.49 2.49 0 0 0 2-1 4.34 4.34 0 0 0 .8-2.88 5.58 5.58 0 0 0-.34-2 3 3 0 0 0-1-1.34 2.4 2.4 0 0 0-1.48-.47 2.63 2.63 0 0 0-1.54.47A3.14 3.14 0 0 0 81.46 48a5.31 5.31 0 0 0-.39 2.11zM100 54.49a9.37 9.37 0 0 1-2.13 1.28 6 6 0 0 1-2.3.43 4.36 4.36 0 0 1-2-.46 3.37 3.37 0 0 1-1.36-1.25 3.24 3.24 0 0 1-.48-1.71 3.06 3.06 0 0 1 .79-2.12 3.94 3.94 0 0 1 2.16-1.18l1.43-.3q1.14-.23 2-.43t1.77-.47a3.17 3.17 0 0 0-.48-1.76 2.16 2.16 0 0 0-1.86-.52 3.69 3.69 0 0 0-1.74.32 2.84 2.84 0 0 0-1 1q-.42.64-.59.85a1 1 0 0 1-.74.21 1.29 1.29 0 0 1-.87-.38 1.07 1.07 0 0 1-.37-.84 2.57 2.57 0 0 1 .57-1.55 4.05 4.05 0 0 1 1.77-1.24 8 8 0 0 1 3-.49 8.46 8.46 0 0 1 3.14.47 2.93 2.93 0 0 1 1.62 1.49 6.53 6.53 0 0 1 .47 2.71v3.46a6.1 6.1 0 0 0 .28 1.78 5.64 5.64 0 0 1 .28 1.19 1.12 1.12 0 0 1-.44.85 1.47 1.47 0 0 1-1 .38 1.34 1.34 0 0 1-.92-.44 6.46 6.46 0 0 1-1-1.28zm-.2-4.38a15.3 15.3 0 0 1-1.94.52q-1.27.27-1.76.4a2.4 2.4 0 0 0-.93.5 1.28 1.28 0 0 0-.44 1 1.54 1.54 0 0 0 .52 1.17 1.93 1.93 0 0 0 1.37.48 3.55 3.55 0 0 0 1.66-.39 2.63 2.63 0 0 0 1.12-1 4.64 4.64 0 0 0 .41-2.26zM108.85 51.83v2.53a2 2 0 0 1-.43 1.38 1.44 1.44 0 0 1-1.1.46 1.39 1.39 0 0 1-1.08-.47 2 2 0 0 1-.42-1.38v-8.43q0-2 1.48-2a1.23 1.23 0 0 1 1.09.48 2.62 2.62 0 0 1 .37 1.41 5.31 5.31 0 0 1 1.12-1.41 2.3 2.3 0 0 1 1.53-.48 3.9 3.9 0 0 1 1.85.48 1.43 1.43 0 0 1 .9 1.27 1.2 1.2 0 0 1-.38.92 1.19 1.19 0 0 1-.83.36 3.81 3.81 0 0 1-.8-.21 3.74 3.74 0 0 0-1.13-.21 1.65 1.65 0 0 0-1.09.35 2.24 2.24 0 0 0-.66 1 7.22 7.22 0 0 0-.32 1.64q-.1.94-.1 2.31zM125 52.24a3.51 3.51 0 0 1-2.42 3.5 8.08 8.08 0 0 1-2.9.46 7.08 7.08 0 0 1-2.8-.5 4.07 4.07 0 0 1-1.72-1.25 2.52 2.52 0 0 1-.55-1.5 1.17 1.17 0 0 1 .35-.85 1.22 1.22 0 0 1 .9-.35 1 1 0 0 1 .73.23 2.57 2.57 0 0 1 .49.66 3.32 3.32 0 0 0 1.12 1.21 3.37 3.37 0 0 0 1.77.4 2.56 2.56 0 0 0 1.49-.41 1.14 1.14 0 0 0 .58-.93 1.26 1.26 0 0 0-.61-1.17 7.49 7.49 0 0 0-2-.7 16.46 16.46 0 0 1-2.55-.82 4.18 4.18 0 0 1-1.57-1.13 2.58 2.58 0 0 1-.59-1.72 3 3 0 0 1 .54-1.72 3.73 3.73 0 0 1 1.6-1.29 6.14 6.14 0 0 1 2.56-.48 8.41 8.41 0 0 1 2.11.24 5.27 5.27 0 0 1 1.57.66 3.24 3.24 0 0 1 1 .91 1.78 1.78 0 0 1 .33 1 1.13 1.13 0 0 1-.35.85 1.38 1.38 0 0 1-1 .33 1.22 1.22 0 0 1-.79-.27 5.23 5.23 0 0 1-.75-.8 2.75 2.75 0 0 0-.81-.71 2.55 2.55 0 0 0-1.27-.27 2.48 2.48 0 0 0-1.37.35 1 1 0 0 0-.54.87.94.94 0 0 0 .4.78 3.31 3.31 0 0 0 1.08.5q.68.2 1.86.49a10 10 0 0 1 2.3.82 3.83 3.83 0 0 1 1.35 1.13 2.5 2.5 0 0 1 .46 1.48z\"/></g><path d=\"M30.95 80.31a4.85 4.85 0 0 0 1.57-2.37 2.8 2.8 0 0 0-1.57-3.6c-4.6-2.33-7.57 1.82-8 2.79s-1.19 2.5-.71 6 2.17 6.73 7.45 8a22.37 22.37 0 0 0 15-1.75c4.66-2.22 13.4-6.12 15.61-6.51a19.14 19.14 0 0 1 4.41-.55V77a12.21 12.21 0 0 0-11.82-6.22c-8.43.66-11.78 5-13.83 6.86s-5.86 6.24-8.41 5.47-3.27-3.92-2.37-4.89 1.61-.8 2.17 0a4.24 4.24 0 0 1 .5 2.09z\"/><path d=\"M98.17 80.31a4.85 4.85 0 0 1-1.57-2.37 2.8 2.8 0 0 1 1.57-3.6c4.6-2.33 7.57 1.82 8 2.79s1.19 2.5.71 6-2.17 6.73-7.45 8a22.37 22.37 0 0 1-15-1.75c-4.66-2.22-13.4-6.12-15.61-6.51a19.14 19.14 0 0 0-4.41-.55V77a12.21 12.21 0 0 1 11.82-6.22c8.43.66 11.78 5 13.83 6.86s5.86 6.24 8.41 5.47 3.27-3.92 2.37-4.89-1.61-.8-2.17 0a4.24 4.24 0 0 0-.5 2.09z\"/></svg>"

/***/ }),

/***/ "../src/components/handlebars/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HandlebarsOriginalWordmark = __webpack_require__("../src/components/handlebars/original-wordmark/HandlebarsOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HandlebarsOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/handlebars/original/HandlebarsOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _HandlebarsOriginal = __webpack_require__("../src/components/handlebars/original/HandlebarsOriginal.svg");
	
	var _HandlebarsOriginal2 = _interopRequireDefault(_HandlebarsOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** HandlebarsOriginal */
	function HandlebarsOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'HandlebarsOriginal',
	    svg: _HandlebarsOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	HandlebarsOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = HandlebarsOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/handlebars/original/HandlebarsOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><title>Artboard 7</title><path d=\"M14.59 62.67a7.14 7.14 0 0 0 2.31-3.48c.46-2 .36-3.94-2.31-5.3C7.82 50.47 3.45 56.57 2.77 58s-1.74 3.68-1 8.84 3.19 9.9 11 11.73a32.89 32.89 0 0 0 22-2.57c6.84-3.26 19.7-9 22.94-9.58a28.15 28.15 0 0 1 6.49-.81v-7.85a18 18 0 0 0-17.38-9.15C34.43 49.59 29.51 56 26.49 58.7s-8.61 9.17-12.37 8-4.81-5.7-3.48-7.14 2.37-1.18 3.18 0a6.24 6.24 0 0 1 .77 3.11z\"/><path d=\"M113.41 62.67a7.14 7.14 0 0 1-2.31-3.48c-.46-2-.36-3.94 2.31-5.3 6.76-3.43 11.13 2.67 11.81 4.11s1.74 3.68 1 8.84-3.19 9.9-11 11.73A32.89 32.89 0 0 1 93.23 76c-6.84-3.26-19.7-9-22.94-9.58a28.15 28.15 0 0 0-6.49-.81v-7.85a18 18 0 0 1 17.38-9.15c12.39 1 17.32 7.38 20.34 10.08s8.61 9.17 12.37 8 4.81-5.76 3.48-7.19-2.37-1.18-3.18 0a6.24 6.24 0 0 0-.78 3.17z\"/></svg>"

/***/ }),

/***/ "../src/components/handlebars/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HandlebarsOriginal = __webpack_require__("../src/components/handlebars/original/HandlebarsOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HandlebarsOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/heroku/original-wordmark/HerokuOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _HerokuOriginalWordmark = __webpack_require__("../src/components/heroku/original-wordmark/HerokuOriginalWordmark.svg");
	
	var _HerokuOriginalWordmark2 = _interopRequireDefault(_HerokuOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** HerokuOriginalWordmark */
	function HerokuOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'HerokuOriginalWordmark',
	    svg: _HerokuOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	HerokuOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = HerokuOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/heroku/original-wordmark/HerokuOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M35.3 101.8c-4 0-7.3.5-9.7 1.4-.9 3.2-1.3 6.6-1.3 10.4 0 7 1.2 11.3 9.2 11.3 3.7 0 6.8-1.1 9.3-2.3L42 119c-2.4.9-5.5 1.7-8.2 1.7-3.5 0-4.6-.9-4.8-6.9h15v-2.2c0-6.1-2.2-9.8-8.7-9.8zM29 111c.1-3 .3-3.8.5-4.7 1.9-.4 4.1-.4 5.6-.4 3.3 0 3.9 2.1 3.9 5.1H29zm-15.1-9.2c-2.7 0-4.9.7-7.9 1.5V93H2v31h4v-16.6c3-1 5-1.5 7-1.5 1 0 2 .5 2 1.7v16.9l.4-.4H20v-15.8c0-3.8-1.8-6.5-6.1-6.5zm108.1.2v17.4c-3 1-5.6 1.5-7.7 1.5-1 0-2.3-.5-2.3-1.7V102h-4v16.7c0 3.7 1.3 6.3 5.6 6.3 2.7 0 7.4-.4 12.4-3.5V102h-4zm-18.2 0h-5.4c-1.3 3-3.2 7-5.6 9H91V93h-5v31h5v-10h2.1c2.8 3 4.6 7 6 10h5.6c-2.1-4-4.5-8.4-7.7-12.4 2.6-2.7 5-5.6 6.8-9.6zM48 124h4v-16.6c2-.8 5-1.1 7-1.2v-4c-3 .2-7 .9-11 3.1V124zm23.4-22.2c-6.1 0-10.3 3.2-10.3 11.7 0 8 3.2 11.5 10.3 11.5 6.1 0 10.3-3.2 10.3-11.7 0-8-3.2-11.5-10.3-11.5zm0 19.2c-4 0-5.7-1.4-5.7-7.5 0-5.6 2-7.7 5.7-7.7 4 0 5.7 1.4 5.7 7.5-.1 5.6-2.1 7.7-5.7 7.7zM99 10.3C99 5.7 95.3 2 90.7 2H37.3C32.7 2 29 5.7 29 10.3v70.4c0 4.6 3.7 8.3 8.3 8.3h53.4c4.6 0 8.3-3.7 8.3-8.3V10.3zm-67 .5C32 7.5 34.5 5 37.7 5h52.5c3.3 0 5.8 2.6 5.8 5.8v69.4c0 3.3-2.5 5.9-5.7 5.9H37.7c-3.3 0-5.7-2.6-5.7-5.9V10.8zM85.9 14H75.2s-3.4 8-7.1 12h10.4c5.6-7 7.4-12 7.4-12zM45 76.9l9.8-9.9-9.8-9.8zm28-34.5v34.5l-.1.1H82V42.5c0-18.9-27-8.2-27-8.2V13.8l-9.8.1s0 32 .1 31.9C75.2 34.2 73 42.4 73 42.4z\" fill=\"#6762A6\"/></svg>"

/***/ }),

/***/ "../src/components/heroku/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HerokuOriginalWordmark = __webpack_require__("../src/components/heroku/original-wordmark/HerokuOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HerokuOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/heroku/original/HerokuOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _HerokuOriginal = __webpack_require__("../src/components/heroku/original/HerokuOriginal.svg");
	
	var _HerokuOriginal2 = _interopRequireDefault(_HerokuOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** HerokuOriginal */
	function HerokuOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'HerokuOriginal',
	    svg: _HerokuOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	HerokuOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = HerokuOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/heroku/original/HerokuOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M114 13.9C114 7.3 108.7 2 102.1 2H25.9C19.3 2 14 7.3 14 13.9v100.3c0 6.6 5.3 11.9 11.9 11.9h76.3c6.6 0 11.9-5.3 11.9-11.9V13.9zm-4 .1v99.3c0 4.7-3.5 8.7-8.2 8.7H26.5c-4.7 0-8.5-4-8.5-8.7V14c0-4.7 3.9-8 8.5-8h75.2c4.7 0 8.4 3.6 8.4 8.3l-.1-.3zm-73 94.7l14.1-14.1L37 80.5zm14-60.9V18.4l-13.9.1s.1 45.9.2 45.7C80.1 47.5 77 59.4 77 59.4v49.4l-.1.2H90V59.5c0-27.1-39-11.7-39-11.7zM70 36h14.8c8-10 10.7-17 10.7-17H80.2S75.3 30 70 36z\" fill=\"#6762A6\"/></svg>"

/***/ }),

/***/ "../src/components/heroku/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HerokuOriginal = __webpack_require__("../src/components/heroku/original/HerokuOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HerokuOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/heroku/plain-wordmark/HerokuPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _HerokuPlainWordmark = __webpack_require__("../src/components/heroku/plain-wordmark/HerokuPlainWordmark.svg");
	
	var _HerokuPlainWordmark2 = _interopRequireDefault(_HerokuPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** HerokuPlainWordmark */
	function HerokuPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'HerokuPlainWordmark',
	    svg: _HerokuPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	HerokuPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = HerokuPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/heroku/plain-wordmark/HerokuPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M39.3 89h53.3c4.6 0 8.3-3.7 8.3-8.3V10.3c0-4.6-3.7-8.3-8.3-8.3H39.3C34.7 2 31 5.7 31 10.3v70.3c0 4.7 3.7 8.4 8.3 8.4zm38.2-75h10.8s-1.8 5-7.5 12H70.4c3.7-4 7.1-12 7.1-12zM57 13.6v20.7s27-10.8 27 8.2V77h-8.8l-.2.1V42.3s2.3-8.3-27.8 3.4c-.1.1-.1-32.1-.1-32.1H57zM47 57.2l9.9 9.9L47 77V57.2zm-11.7 45.6c-4 0-7.3.5-9.7 1.4-.9 3.2-1.3 6.6-1.3 10.4 0 7 1.2 11.3 9.2 11.3 3.7 0 6.8-1.1 9.3-2.3L42 120c-2.4.9-5.5 1.7-8.2 1.7-3.5 0-4.6-.9-4.8-6.9h15v-2.2c0-6.1-2.2-9.8-8.7-9.8zM29 112c.1-3 .3-3.8.5-4.7 1.9-.4 4.1-.4 5.6-.4 3.3 0 3.9 2.1 3.9 5.1H29zm-15.1-9.2c-2.7 0-4.9.7-7.9 1.5V94H2v31h4v-16.6c3-1 5-1.5 7-1.5 1 0 2 .5 2 1.7v16.9l.4-.4H20v-15.8c0-3.8-1.8-6.5-6.1-6.5zm108.1.2v17.4c-3 1-5.6 1.5-7.7 1.5-1 0-2.3-.5-2.3-1.7V103h-4v16.7c0 3.7 1.3 6.3 5.6 6.3 2.7 0 7.4-.4 12.4-3.5V103h-4zm-18.2 0h-5.4c-1.3 3-3.2 7-5.6 9H91V94h-5v31h5v-10h2.1c2.8 3 4.6 7 6 10h5.6c-2.1-4-4.5-8.4-7.7-12.4 2.6-2.7 5-5.6 6.8-9.6zM48 125h4v-16.6c2-.8 5-1.1 7-1.2v-4c-3 .2-7 .9-11 3.1V125zm23.4-22.2c-6.1 0-10.3 3.2-10.3 11.7 0 8 3.2 11.5 10.3 11.5 6.1 0 10.3-3.2 10.3-11.7 0-8-3.2-11.5-10.3-11.5zm0 19.2c-4 0-5.7-1.4-5.7-7.5 0-5.6 2-7.7 5.7-7.7 4 0 5.7 1.4 5.7 7.5-.1 5.6-2.1 7.7-5.7 7.7z\" fill=\"#6762A6\"/></svg>"

/***/ }),

/***/ "../src/components/heroku/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HerokuPlainWordmark = __webpack_require__("../src/components/heroku/plain-wordmark/HerokuPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HerokuPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/heroku/plain/HerokuPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _HerokuPlain = __webpack_require__("../src/components/heroku/plain/HerokuPlain.svg");
	
	var _HerokuPlain2 = _interopRequireDefault(_HerokuPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** HerokuPlain */
	function HerokuPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'HerokuPlain',
	    svg: _HerokuPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	HerokuPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = HerokuPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/heroku/plain/HerokuPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#6762A6\" d=\"M102.1 2H25.9C19.3 2 14 7.3 14 13.9v100.3c0 6.6 5.3 11.9 11.9 11.9h76.3c6.6 0 11.9-5.3 11.9-11.9V13.9C114 7.3 108.7 2 102.1 2zM37 108.7V80.5l14.1 14.1L37 108.7zm53 .3H76.9l.1-.2V59.4s3.1-11.8-39.7 4.8c-.1.2-.2-45.7-.2-45.7l13.9-.1v29.4s39-15.4 39 11.7V109zm-5.2-73H70c5.3-6 10.2-17 10.2-17h15.3s-2.6 7-10.7 17z\"/></svg>"

/***/ }),

/***/ "../src/components/heroku/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HerokuPlain = __webpack_require__("../src/components/heroku/plain/HerokuPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HerokuPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/html5/original-wordmark/Html5OriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _Html5OriginalWordmark = __webpack_require__("../src/components/html5/original-wordmark/Html5OriginalWordmark.svg");
	
	var _Html5OriginalWordmark2 = _interopRequireDefault(_Html5OriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Html5OriginalWordmark */
	function Html5OriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'Html5OriginalWordmark',
	    svg: _Html5OriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	Html5OriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = Html5OriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/html5/original-wordmark/Html5OriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#E44D26\" d=\"M27.854 116.354l-8.043-90.211h88.378l-8.051 90.197-36.192 10.033z\"/><path fill=\"#F16529\" d=\"M64 118.704l29.244-8.108 6.881-77.076H64z\"/><path fill=\"#EBEBEB\" d=\"M64 66.978H49.359l-1.01-11.331H64V44.583H36.257l.264 2.969 2.72 30.489H64zm0 28.733l-.049.013-12.321-3.328-.788-8.823H39.735l1.55 17.372 22.664 6.292.051-.015z\"/><path d=\"M28.034 1.627h5.622v5.556H38.8V1.627h5.623v16.822H38.8v-5.633h-5.143v5.633h-5.623V1.627zm23.782 5.579h-4.95V1.627h15.525v5.579h-4.952v11.243h-5.623V7.206zm13.039-5.579h5.862l3.607 5.911 3.603-5.911h5.865v16.822h-5.601v-8.338l-3.867 5.981h-.098l-3.87-5.981v8.338h-5.502V1.627zm21.736 0h5.624v11.262h7.907v5.561H86.591V1.627z\"/><path fill=\"#fff\" d=\"M63.962 66.978v11.063h13.624L76.302 92.39l-12.34 3.331v11.51l22.682-6.286.166-1.87 2.6-29.127.27-2.97h-2.982zm0-22.395v11.064h26.725l.221-2.487.505-5.608.265-2.969z\"/></svg>"

/***/ }),

/***/ "../src/components/html5/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Html5OriginalWordmark = __webpack_require__("../src/components/html5/original-wordmark/Html5OriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Html5OriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/html5/original/Html5Original.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _Html5Original = __webpack_require__("../src/components/html5/original/Html5Original.svg");
	
	var _Html5Original2 = _interopRequireDefault(_Html5Original);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Html5Original */
	function Html5Original(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'Html5Original',
	    svg: _Html5Original2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	Html5Original.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = Html5Original;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/html5/original/Html5Original.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#E44D26\" d=\"M19.037 113.876L9.032 1.661h109.936l-10.016 112.198-45.019 12.48z\"/><path fill=\"#F16529\" d=\"M64 116.8l36.378-10.086 8.559-95.878H64z\"/><path fill=\"#EBEBEB\" d=\"M64 52.455H45.788L44.53 38.361H64V24.599H29.489l.33 3.692 3.382 37.927H64zm0 35.743l-.061.017-15.327-4.14-.979-10.975H33.816l1.928 21.609 28.193 7.826.063-.017z\"/><path fill=\"#fff\" d=\"M63.952 52.455v13.763h16.947l-1.597 17.849-15.35 4.143v14.319l28.215-7.82.207-2.325 3.234-36.233.335-3.696h-3.708zm0-27.856v13.762h33.244l.276-3.092.628-6.978.329-3.692z\"/></svg>"

/***/ }),

/***/ "../src/components/html5/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Html5Original = __webpack_require__("../src/components/html5/original/Html5Original.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Html5Original).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/html5/plain-wordmark/Html5PlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _Html5PlainWordmark = __webpack_require__("../src/components/html5/plain-wordmark/Html5PlainWordmark.svg");
	
	var _Html5PlainWordmark2 = _interopRequireDefault(_Html5PlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Html5PlainWordmark */
	function Html5PlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'Html5PlainWordmark',
	    svg: _Html5PlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	Html5PlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = Html5PlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/html5/plain-wordmark/Html5PlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#E44D26\" d=\"M19.569 27l8.087 89.919 36.289 9.682 36.39-9.499L108.431 27H19.569zM91.61 47.471l-.507 5.834L90.88 56H48.311l1.017 12h40.54l-.271 2.231-2.615 28.909-.192 1.69L64 106.964v-.005l-.027.012-22.777-5.916L39.65 84h11.168l.791 8.46 12.385 3.139.006-.234v.012l12.412-2.649L77.708 79H39.153l-2.734-30.836L36.152 45h55.724l-.266 2.471zM27.956 1.627h5.622v5.556h5.144V1.627h5.623v16.822h-5.623v-5.633h-5.143v5.633h-5.623V1.627zm23.782 5.579h-4.95V1.627h15.525v5.579h-4.952v11.243h-5.623V7.206zm13.039-5.579h5.862l3.607 5.911 3.603-5.911h5.865v16.822h-5.601v-8.338l-3.867 5.981h-.098l-3.87-5.981v8.338h-5.502V1.627zm21.736 0h5.624v11.262h7.907v5.561H86.513V1.627z\"/></svg>"

/***/ }),

/***/ "../src/components/html5/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Html5PlainWordmark = __webpack_require__("../src/components/html5/plain-wordmark/Html5PlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Html5PlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/html5/plain/Html5Plain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _Html5Plain = __webpack_require__("../src/components/html5/plain/Html5Plain.svg");
	
	var _Html5Plain2 = _interopRequireDefault(_Html5Plain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Html5Plain */
	function Html5Plain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'Html5Plain',
	    svg: _Html5Plain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	Html5Plain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = Html5Plain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/html5/plain/Html5Plain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#E44D26\" d=\"M9.032 2l10.005 112.093 44.896 12.401 45.02-12.387L118.968 2H9.032zm89.126 26.539l-.627 7.172L97.255 39H44.59l1.257 14h50.156l-.336 3.471-3.233 36.119-.238 2.27L64 102.609v.002l-.034.018-28.177-7.423L33.876 74h13.815l.979 10.919L63.957 89H64v-.546l15.355-3.875L80.959 67H33.261l-3.383-38.117L29.549 25h68.939l-.33 3.539z\"/></svg>"

/***/ }),

/***/ "../src/components/html5/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Html5Plain = __webpack_require__("../src/components/html5/plain/Html5Plain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Html5Plain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ie10/original/Ie10Original.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _Ie10Original = __webpack_require__("../src/components/ie10/original/Ie10Original.svg");
	
	var _Ie10Original2 = _interopRequireDefault(_Ie10Original);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Ie10Original */
	function Ie10Original(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'Ie10Original',
	    svg: _Ie10Original2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	Ie10Original.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = Ie10Original;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ie10/original/Ie10Original.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#1EBBEE\" d=\"M126.11 66.834c0-9.82-2.539-19.034-6.991-27.051C138.097-3.167 98.785 3.13 96.596 3.558c-8.328 1.629-16.034 4.249-23.142 7.566a56.276 56.276 0 0 0-3.166-.09c-26.525 0-48.729 18.501-54.411 43.303 13.98-15.684 23.765-22.012 29.624-24.544-.936.835-1.851 1.681-2.751 2.532l-.885.855c-.594.571-1.186 1.143-1.765 1.72-.344.343-.68.689-1.019 1.035-.514.522-1.026 1.044-1.527 1.569l-1.052 1.122c-.468.501-.934 1.003-1.39 1.506l-1.053 1.175a143.278 143.278 0 0 0-3.516 4.099c-.347.419-.692.838-1.031 1.256-.367.453-.726.905-1.083 1.356-.348.438-.695.875-1.034 1.312l-.953 1.246c-.356.469-.715.938-1.063 1.404l-.731.998a173.801 173.801 0 0 0-6.041 8.796l-.013.021c-.479.747-.941 1.482-1.395 2.211l-.074.12c-.454.732-.892 1.451-1.319 2.164l-.045.075a181.942 181.942 0 0 0-3.172 5.501C7.562 80.977 5.114 87.343 5.008 87.72c-15.876 56.759 33.674 32.791 40.588 29.213 7.445 3.678 15.827 5.973 24.692 5.973C94.563 122.905 115.213 107 122.9 86H93.569c-4.34 7-12.694 12.049-22.293 12.049C57.211 98.049 45.81 87 45.81 74h79.842c.303-2 .458-4.73.458-7.166zM13.526 116.817c-3.916-4.015-4.608-13.795 4.032-31.616 4.36 12.537 13.061 23.041 24.307 29.708-5.593 3.079-20.441 10.009-28.339 1.908zM45.687 59c.446-13 11.564-23.005 25.226-23.005C84.574 35.995 95.694 46 96.14 59H45.687zm44.776-44.204c5.166-2.495 17.958-7.771 25.22-2.871 4.807 3.245 8.663 8.34 2.042 25.499-6.351-10.213-15.905-18.224-27.262-22.628z\"/></svg>"

/***/ }),

/***/ "../src/components/ie10/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Ie10Original = __webpack_require__("../src/components/ie10/original/Ie10Original.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Ie10Original).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/illustrator/line/IllustratorLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _IllustratorLine = __webpack_require__("../src/components/illustrator/line/IllustratorLine.svg");
	
	var _IllustratorLine2 = _interopRequireDefault(_IllustratorLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** IllustratorLine */
	function IllustratorLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'IllustratorLine',
	    svg: _IllustratorLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	IllustratorLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = IllustratorLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/illustrator/line/IllustratorLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FAA625\" d=\"M1 1v125.792c1 .082.99.235 1.359.235 36.269.011 72.665.011 108.934.011 4.994 0 9.859.004 14.854-.011.328-.001.854-.153.854-.235L127 1H1zm114 62.914v48.551c0 1.688-.253 1.535-1.88 1.535H15.771c-1.627 0-1.771.154-1.771-1.534V15.24c0-1.689.144-2.24 1.894-2.24h97.103c1.751 0 2.003.551 2.003 2.363v48.551zM64.414 40.368c-.214-.662-.612-.696-1.193-.693-3.114.019-6.229.069-9.341 0-.984-.021-1.411.274-1.715 1.233-4.385 13.785-8.817 27.561-13.233 41.336-.72 2.246-1.417 4.501-2.185 6.939 2.911 0 5.571-.04 8.229.026.903.022 1.279-.275 1.525-1.126 1.138-3.924 2.37-7.821 3.497-11.748.265-.926.694-1.176 1.625-1.165 4.424.052 8.85.052 13.274 0 .861-.01 1.211.268 1.455 1.062 1.213 3.949 2.502 7.874 3.714 11.823.251.816.566 1.13 1.507 1.062a54.147 54.147 0 0 1 3.93-.117h4.592l-.021-.331c-5.222-16.107-10.451-32.19-15.66-48.301zM52.001 68c2.037-7 4.059-13.848 6.051-20.644C60.105 54.128 62.193 61 64.312 68H52.001zM82 89h10V53H82v36zm5.071-50.445c-2.963.003-5.151 2.107-5.131 4.936.02 2.837 2.122 4.857 5.057 4.862 3.051.004 5.208-2.015 5.187-4.856-.022-2.91-2.127-4.945-5.113-4.942z\"/></svg>"

/***/ }),

/***/ "../src/components/illustrator/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _IllustratorLine = __webpack_require__("../src/components/illustrator/line/IllustratorLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IllustratorLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/illustrator/plain/IllustratorPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _IllustratorPlain = __webpack_require__("../src/components/illustrator/plain/IllustratorPlain.svg");
	
	var _IllustratorPlain2 = _interopRequireDefault(_IllustratorPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** IllustratorPlain */
	function IllustratorPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'IllustratorPlain',
	    svg: _IllustratorPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	IllustratorPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = IllustratorPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/illustrator/plain/IllustratorPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FAA625\" d=\"M47.955 69h15.371c-2.646-9-5.252-17.32-7.816-25.776C53.022 51.71 50.498 60 47.955 69zm76.157-68H2.873C.687 1 1 1.476 1 3.585v121.394C1 127.086.687 127 2.719 127h121.547c2.031 0 2.734.086 2.734-2.022V3.739C127 1.476 126.298 1 124.112 1zM77.298 96c-1.637 0-3.28-.133-4.909-.016-1.175.088-1.568-.406-1.881-1.426-1.514-4.931-3.123-9.86-4.638-14.79-.305-.992-.741-1.354-1.816-1.341-5.523.064-11.049.058-16.573-.007-1.163-.014-1.698.296-2.03 1.45-1.406 4.904-2.944 9.768-4.365 14.667-.308 1.062-.776 1.433-1.904 1.404-3.318-.083-6.641-.032-10.274-.032.959-3.045 1.829-5.861 2.729-8.665 5.514-17.2 11.047-34.4 16.521-51.611.382-1.198.913-1.567 2.143-1.54 3.886.086 7.775.022 11.663 0 .727-.005 1.223.038 1.489.864 6.505 20.116 13.033 40.356 19.555 60.47.028.091.01.573.025.573h-5.735zM98 96H86V51h12v45zm-6.35-51.071c-3.665-.005-6.289-2.528-6.314-6.07-.024-3.532 2.707-6.159 6.406-6.163 3.728-.004 6.355 2.537 6.384 6.171.026 3.545-2.667 6.068-6.476 6.062z\"/></svg>"

/***/ }),

/***/ "../src/components/illustrator/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _IllustratorPlain = __webpack_require__("../src/components/illustrator/plain/IllustratorPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IllustratorPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.YiiPlainWordmark = exports.YiiOriginalWordmark = exports.ZendPlainWordmark = exports.ZendPlain = exports.YiiPlain = exports.YarnOriginalWordmark = exports.YiiOriginal = exports.WordpressPlain = exports.YarnOriginal = exports.RedisPlainWordmark = exports.WebstormPlainWordmark = exports.WordpressPlainWordmark = exports.WordpressOriginal = exports.Windows8OriginalWordmark = exports.WebstormPlain = exports.WebstormOriginalWordmark = exports.Windows8Original = exports.WebstormOriginal = exports.WebpackPlainWordmark = exports.VuejsLineWordmark = exports.WebpackPlain = exports.WebpackOriginalWordmark = exports.VuejsPlainWordmark = exports.VuejsLine = exports.WebpackOriginal = exports.VuejsPlain = exports.VuejsOriginalWordmark = exports.VisualstudioPlainWordmark = exports.VuejsOriginal = exports.VagrantPlain = exports.VagrantPlainWordmark = exports.VisualstudioPlain = exports.VimPlain = exports.VimOriginal = exports.VagrantOriginal = exports.VagrantOriginalWordmark = exports.UbuntuPlainWordmark = exports.TypescriptPlain = exports.UbuntuPlain = exports.TwitterOriginal = exports.TrelloPlain = exports.TypescriptOriginal = exports.TravisPlain = exports.TrelloPlainWordmark = exports.TravisPlainWordmark = exports.TomcatLine = exports.TomcatLineWordmark = exports.TomcatOriginalWordmark = exports.SwiftPlainWordmark = exports.TomcatOriginal = exports.SwiftOriginalWordmark = exports.SymfonyOriginalWordmark = exports.SymfonyOriginal = exports.SwiftPlain = exports.SwiftOriginal = exports.StylusOriginal = exports.SourcetreeOriginalWordmark = exports.SshOriginalWordmark = exports.SshOriginal = exports.SlackPlainWordmark = exports.SlackPlain = exports.SourcetreeOriginal = exports.SlackOriginalWordmark = exports.SlackOriginal = exports.SketchLineWordmark = exports.SketchOriginalWordmark = exports.SketchLine = exports.SketchOriginal = exports.SafariLine = exports.SequelizePlainWordmark = exports.SequelizePlain = undefined;
	exports.SafariLineWordmark = exports.SequelizeOriginalWordmark = exports.SafariPlainWordmark = exports.SassOriginal = exports.SequelizeOriginal = exports.SafariOriginalWordmark = exports.SafariPlain = exports.SafariOriginal = exports.RubyPlainWordmark = exports.RubyminePlain = exports.RubyminePlainWordmark = exports.RubymineOriginalWordmark = exports.RubyPlain = exports.RubyOriginalWordmark = exports.RubymineOriginal = exports.RubyOriginal = exports.RedhatOriginalWordmark = exports.RedhatPlainWordmark = exports.RedisPlain = exports.RedisOriginalWordmark = exports.RedhatPlain = exports.RedhatOriginal = exports.RedisOriginal = exports.ReactOriginal = exports.RailsPlainWordmark = exports.ReactOriginalWordmark = exports.RailsPlain = exports.PycharmOriginalWordmark = exports.AppleOriginal = exports.RailsOriginalWordmark = exports.PycharmPlainWordmark = exports.PythonPlain = exports.PycharmPlain = exports.PycharmOriginal = exports.PythonPlainWordmark = exports.PostgresqlOriginalWordmark = exports.PythonOriginalWordmark = exports.PostgresqlPlainWordmark = exports.PythonOriginal = exports.PhpstormPlainWordmark = exports.PostgresqlPlain = exports.PostgresqlOriginal = exports.ProtractorPlain = exports.PhpstormOriginal = exports.PhpstormPlain = exports.ProtractorPlainWordmark = exports.PhpstormOriginalWordmark = exports.PhpPlain = exports.PhotoshopPlain = exports.NodewebkitLineWordmark = exports.NodewebkitPlainWordmark = exports.NodewebkitLine = exports.PhpOriginal = exports.OracleOriginal = exports.PhotoshopLine = exports.NpmOriginalWordmark = exports.NodewebkitOriginal = exports.NodewebkitOriginalWordmark = exports.NodejsOriginalWordmark = exports.NodejsPlainWordmark = exports.NodewebkitPlain = exports.MysqlPlainWordmark = exports.NodejsPlain = exports.MysqlOriginalWordmark = exports.NodejsOriginal = exports.NginxOriginal = exports.MysqlPlain = exports.MoodleOriginalWordmark = exports.MysqlOriginal = exports.MongodbPlainWordmark = exports.MoodlePlain = exports.MongodbOriginalWordmark = exports.MoodlePlainWordmark = exports.MongodbOriginal = exports.MoodleOriginal = exports.LinuxOriginal = exports.MeteorPlainWordmark = exports.MongodbPlain = exports.MeteorOriginalWordmark = exports.MeteorPlain = exports.MochaPlain = exports.MeteorOriginal = exports.LinuxPlain = exports.LinkedinPlainWordmark = exports.LinkedinPlain = exports.LaravelPlainWordmark = exports.LinkedinOriginalWordmark = exports.LaravelPlain = exports.KrakenjsPlainWordmark = exports.LinkedinOriginal = exports.LessPlainWordmark = exports.KrakenjsOriginalWordmark = exports.KrakenjsPlain = exports.JqueryPlainWordmark = exports.JetbrainsPlain = exports.KrakenjsOriginal = exports.JqueryPlain = exports.JetbrainsOriginal = exports.JeetPlain = exports.JqueryOriginal = undefined;
	exports.JeetPlainWordmark = exports.JeetOriginal = exports.JqueryOriginalWordmark = exports.JeetOriginalWordmark = exports.JavaPlainWordmark = exports.JavascriptPlain = exports.JavaPlain = exports.JavascriptOriginal = exports.JasminePlain = exports.JavaOriginalWordmark = exports.JasminePlainWordmark = exports.JavaOriginal = exports.IonicOriginalWordmark = exports.IntellijPlainWordmark = exports.IonicOriginal = exports.InkscapePlain = exports.IntellijPlain = exports.IntellijOriginalWordmark = exports.InkscapePlainWordmark = exports.IntellijOriginal = exports.InkscapeOriginalWordmark = exports.InkscapeOriginal = exports.Html5PlainWordmark = exports.IllustratorPlain = exports.IllustratorLine = exports.HerokuPlainWordmark = exports.Ie10Original = exports.Html5Plain = exports.Html5OriginalWordmark = exports.Html5Original = exports.HerokuPlain = exports.HandlebarsOriginal = exports.HerokuOriginalWordmark = exports.GruntLineWordmark = exports.HandlebarsOriginalWordmark = exports.GruntOriginalWordmark = exports.HerokuOriginal = exports.GruntPlainWordmark = exports.GulpPlain = exports.GruntLine = exports.GooglePlainWordmark = exports.GruntPlain = exports.GooglePlain = exports.GruntOriginal = exports.GradlePlain = exports.GradlePlainWordmark = exports.GoogleOriginalWordmark = exports.GoogleOriginal = exports.GoPlain = exports.GitlabPlainWordmark = exports.GoLine = exports.GitlabOriginal = exports.GitOriginal = exports.GitlabOriginalWordmark = exports.GoOriginal = exports.GitlabPlain = exports.GithubOriginalWordmark = exports.GithubOriginal = exports.GitPlain = exports.GimpPlainWordmark = exports.GitPlainWordmark = exports.GimpOriginal = exports.GitOriginalWordmark = exports.GimpPlain = exports.GatlingPlainWordmark = exports.FoundationPlainWordmark = exports.GimpOriginalWordmark = exports.GatlingPlain = exports.FirefoxPlainWordmark = exports.FoundationOriginal = exports.FoundationOriginalWordmark = exports.FirefoxPlain = exports.FirefoxOriginal = exports.FoundationPlain = exports.FirefoxOriginalWordmark = exports.ErlangOriginalWordmark = exports.FacebookPlain = exports.FacebookOriginal = exports.ErlangPlain = exports.ExpressOriginalWordmark = exports.ExpressOriginal = exports.ErlangPlainWordmark = exports.DrupalPlain = exports.ElmPlain = exports.ErlangOriginal = exports.DrupalPlainWordmark = exports.EmberOriginalWordmark = exports.ElmOriginalWordmark = exports.ElmPlainWordmark = exports.ElmOriginal = exports.DrupalOriginalWordmark = exports.ElectronOriginalWordmark = exports.ElectronOriginal = exports.DrupalOriginal = exports.DotNetPlain = exports.DotNetOriginalWordmark = exports.DoctrineLineWordmark = exports.DotNetPlainWordmark = exports.DoctrinePlainWordmark = exports.DotNetOriginal = undefined;
	exports.DoctrineOriginalWordmark = exports.DoctrineLine = exports.DockerPlain = exports.DoctrinePlain = exports.DoctrineOriginal = exports.DockerPlainWordmark = exports.DockerOriginal = exports.DjangoLine = exports.DockerOriginalWordmark = exports.DjangoOriginal = exports.DeviconPlainWordmark = exports.DjangoPlain = exports.DeviconPlain = exports.DebianPlainWordmark = exports.DeviconOriginalWordmark = exports.DebianPlain = exports.DeviconOriginal = exports.DebianOriginalWordmark = exports.D3jsPlain = exports.DebianOriginal = exports.D3jsOriginal = exports.CucumberPlainWordmark = exports.Css3PlainWordmark = exports.CucumberPlain = exports.Css3OriginalWordmark = exports.Css3Plain = exports.CsharpLine = exports.Css3Original = exports.CsharpOriginal = exports.CplusplusPlain = exports.CsharpPlain = exports.CplusplusLine = exports.CouchdbPlainWordmark = exports.CouchdbPlain = exports.CplusplusOriginal = exports.CoffeescriptOriginalWordmark = exports.CouchdbOriginal = exports.ConfluenceOriginal = exports.ConfluenceOriginalWordmark = exports.CouchdbOriginalWordmark = exports.ChromePlain = exports.CoffeescriptOriginal = exports.CodeigniterPlainWordmark = exports.ChromePlainWordmark = exports.CodeigniterPlain = exports.ChromeOriginalWordmark = exports.CeylonOriginalWordmark = exports.ChromeOriginal = exports.CakephpPlain = exports.CeylonPlain = exports.CeylonPlainWordmark = exports.CeylonOriginal = exports.CakephpOriginalWordmark = exports.CakephpPlainWordmark = exports.BowerPlainWordmark = exports.CakephpOriginal = exports.BowerLineWordmark = exports.CPlain = exports.BowerLine = exports.COriginal = exports.CLine = exports.BowerOriginalWordmark = exports.BowerPlain = exports.BitbucketOriginalWordmark = exports.BowerOriginal = exports.BitbucketOriginal = exports.BootstrapPlain = exports.BehancePlainWordmark = exports.BootstrapPlainWordmark = exports.BehanceOriginalWordmark = exports.BackbonejsPlainWordmark = exports.BackbonejsOriginal = exports.BehancePlain = exports.BackbonejsOriginalWordmark = exports.BehanceOriginal = exports.BabelOriginal = exports.ApacheOriginalWordmark = exports.AtomOriginal = exports.BackbonejsPlain = exports.BabelPlain = exports.AtomOriginalWordmark = exports.ApachePlain = exports.AppceleratorOriginalWordmark = exports.ApacheLine = exports.AppceleratorOriginal = exports.AppceleratorPlainWordmark = exports.ApacheLineWordmark = exports.AngularjsPlainWordmark = exports.ApachePlainWordmark = exports.AngularjsOriginalWordmark = exports.ApacheOriginal = exports.AndroidOriginal = exports.AmazonwebservicesPlainWordmark = exports.AngularjsPlain = exports.AngularjsOriginal = exports.AndroidPlain = exports.AndroidPlainWordmark = exports.AmazonwebservicesOriginal = exports.AndroidOriginalWordmark = exports.AmazonwebservicesOriginalWordmark = undefined;
	
	var _originalWordmark = __webpack_require__("../src/components/amazonwebservices/original-wordmark/index.js");
	
	var _originalWordmark2 = _interopRequireDefault(_originalWordmark);
	
	var _originalWordmark3 = __webpack_require__("../src/components/android/original-wordmark/index.js");
	
	var _originalWordmark4 = _interopRequireDefault(_originalWordmark3);
	
	var _original = __webpack_require__("../src/components/amazonwebservices/original/index.js");
	
	var _original2 = _interopRequireDefault(_original);
	
	var _plainWordmark = __webpack_require__("../src/components/android/plain-wordmark/index.js");
	
	var _plainWordmark2 = _interopRequireDefault(_plainWordmark);
	
	var _plain = __webpack_require__("../src/components/android/plain/index.js");
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _original3 = __webpack_require__("../src/components/angularjs/original/index.js");
	
	var _original4 = _interopRequireDefault(_original3);
	
	var _plain3 = __webpack_require__("../src/components/angularjs/plain/index.js");
	
	var _plain4 = _interopRequireDefault(_plain3);
	
	var _plainWordmark3 = __webpack_require__("../src/components/amazonwebservices/plain-wordmark/index.js");
	
	var _plainWordmark4 = _interopRequireDefault(_plainWordmark3);
	
	var _original5 = __webpack_require__("../src/components/android/original/index.js");
	
	var _original6 = _interopRequireDefault(_original5);
	
	var _original7 = __webpack_require__("../src/components/apache/original/index.js");
	
	var _original8 = _interopRequireDefault(_original7);
	
	var _originalWordmark5 = __webpack_require__("../src/components/angularjs/original-wordmark/index.js");
	
	var _originalWordmark6 = _interopRequireDefault(_originalWordmark5);
	
	var _plainWordmark5 = __webpack_require__("../src/components/apache/plain-wordmark/index.js");
	
	var _plainWordmark6 = _interopRequireDefault(_plainWordmark5);
	
	var _plainWordmark7 = __webpack_require__("../src/components/angularjs/plain-wordmark/index.js");
	
	var _plainWordmark8 = _interopRequireDefault(_plainWordmark7);
	
	var _lineWordmark = __webpack_require__("../src/components/apache/line-wordmark/index.js");
	
	var _lineWordmark2 = _interopRequireDefault(_lineWordmark);
	
	var _plainWordmark9 = __webpack_require__("../src/components/appcelerator/plain-wordmark/index.js");
	
	var _plainWordmark10 = _interopRequireDefault(_plainWordmark9);
	
	var _original9 = __webpack_require__("../src/components/appcelerator/original/index.js");
	
	var _original10 = _interopRequireDefault(_original9);
	
	var _line = __webpack_require__("../src/components/apache/line/index.js");
	
	var _line2 = _interopRequireDefault(_line);
	
	var _originalWordmark7 = __webpack_require__("../src/components/appcelerator/original-wordmark/index.js");
	
	var _originalWordmark8 = _interopRequireDefault(_originalWordmark7);
	
	var _plain5 = __webpack_require__("../src/components/apache/plain/index.js");
	
	var _plain6 = _interopRequireDefault(_plain5);
	
	var _originalWordmark9 = __webpack_require__("../src/components/atom/original-wordmark/index.js");
	
	var _originalWordmark10 = _interopRequireDefault(_originalWordmark9);
	
	var _plain7 = __webpack_require__("../src/components/babel/plain/index.js");
	
	var _plain8 = _interopRequireDefault(_plain7);
	
	var _plain9 = __webpack_require__("../src/components/backbonejs/plain/index.js");
	
	var _plain10 = _interopRequireDefault(_plain9);
	
	var _original11 = __webpack_require__("../src/components/atom/original/index.js");
	
	var _original12 = _interopRequireDefault(_original11);
	
	var _originalWordmark11 = __webpack_require__("../src/components/apache/original-wordmark/index.js");
	
	var _originalWordmark12 = _interopRequireDefault(_originalWordmark11);
	
	var _original13 = __webpack_require__("../src/components/babel/original/index.js");
	
	var _original14 = _interopRequireDefault(_original13);
	
	var _original15 = __webpack_require__("../src/components/behance/original/index.js");
	
	var _original16 = _interopRequireDefault(_original15);
	
	var _originalWordmark13 = __webpack_require__("../src/components/backbonejs/original-wordmark/index.js");
	
	var _originalWordmark14 = _interopRequireDefault(_originalWordmark13);
	
	var _plain11 = __webpack_require__("../src/components/behance/plain/index.js");
	
	var _plain12 = _interopRequireDefault(_plain11);
	
	var _original17 = __webpack_require__("../src/components/backbonejs/original/index.js");
	
	var _original18 = _interopRequireDefault(_original17);
	
	var _plainWordmark11 = __webpack_require__("../src/components/backbonejs/plain-wordmark/index.js");
	
	var _plainWordmark12 = _interopRequireDefault(_plainWordmark11);
	
	var _originalWordmark15 = __webpack_require__("../src/components/behance/original-wordmark/index.js");
	
	var _originalWordmark16 = _interopRequireDefault(_originalWordmark15);
	
	var _plainWordmark13 = __webpack_require__("../src/components/bootstrap/plain-wordmark/index.js");
	
	var _plainWordmark14 = _interopRequireDefault(_plainWordmark13);
	
	var _plainWordmark15 = __webpack_require__("../src/components/behance/plain-wordmark/index.js");
	
	var _plainWordmark16 = _interopRequireDefault(_plainWordmark15);
	
	var _plain13 = __webpack_require__("../src/components/bootstrap/plain/index.js");
	
	var _plain14 = _interopRequireDefault(_plain13);
	
	var _original19 = __webpack_require__("../src/components/bitbucket/original/index.js");
	
	var _original20 = _interopRequireDefault(_original19);
	
	var _original21 = __webpack_require__("../src/components/bower/original/index.js");
	
	var _original22 = _interopRequireDefault(_original21);
	
	var _originalWordmark17 = __webpack_require__("../src/components/bitbucket/original-wordmark/index.js");
	
	var _originalWordmark18 = _interopRequireDefault(_originalWordmark17);
	
	var _plain15 = __webpack_require__("../src/components/bower/plain/index.js");
	
	var _plain16 = _interopRequireDefault(_plain15);
	
	var _originalWordmark19 = __webpack_require__("../src/components/bower/original-wordmark/index.js");
	
	var _originalWordmark20 = _interopRequireDefault(_originalWordmark19);
	
	var _line3 = __webpack_require__("../src/components/c/line/index.js");
	
	var _line4 = _interopRequireDefault(_line3);
	
	var _original23 = __webpack_require__("../src/components/c/original/index.js");
	
	var _original24 = _interopRequireDefault(_original23);
	
	var _line5 = __webpack_require__("../src/components/bower/line/index.js");
	
	var _line6 = _interopRequireDefault(_line5);
	
	var _plain17 = __webpack_require__("../src/components/c/plain/index.js");
	
	var _plain18 = _interopRequireDefault(_plain17);
	
	var _lineWordmark3 = __webpack_require__("../src/components/bower/line-wordmark/index.js");
	
	var _lineWordmark4 = _interopRequireDefault(_lineWordmark3);
	
	var _original25 = __webpack_require__("../src/components/cakephp/original/index.js");
	
	var _original26 = _interopRequireDefault(_original25);
	
	var _plainWordmark17 = __webpack_require__("../src/components/bower/plain-wordmark/index.js");
	
	var _plainWordmark18 = _interopRequireDefault(_plainWordmark17);
	
	var _plainWordmark19 = __webpack_require__("../src/components/cakephp/plain-wordmark/index.js");
	
	var _plainWordmark20 = _interopRequireDefault(_plainWordmark19);
	
	var _originalWordmark21 = __webpack_require__("../src/components/cakephp/original-wordmark/index.js");
	
	var _originalWordmark22 = _interopRequireDefault(_originalWordmark21);
	
	var _original27 = __webpack_require__("../src/components/ceylon/original/index.js");
	
	var _original28 = _interopRequireDefault(_original27);
	
	var _plainWordmark21 = __webpack_require__("../src/components/ceylon/plain-wordmark/index.js");
	
	var _plainWordmark22 = _interopRequireDefault(_plainWordmark21);
	
	var _plain19 = __webpack_require__("../src/components/ceylon/plain/index.js");
	
	var _plain20 = _interopRequireDefault(_plain19);
	
	var _plain21 = __webpack_require__("../src/components/cakephp/plain/index.js");
	
	var _plain22 = _interopRequireDefault(_plain21);
	
	var _original29 = __webpack_require__("../src/components/chrome/original/index.js");
	
	var _original30 = _interopRequireDefault(_original29);
	
	var _originalWordmark23 = __webpack_require__("../src/components/ceylon/original-wordmark/index.js");
	
	var _originalWordmark24 = _interopRequireDefault(_originalWordmark23);
	
	var _originalWordmark25 = __webpack_require__("../src/components/chrome/original-wordmark/index.js");
	
	var _originalWordmark26 = _interopRequireDefault(_originalWordmark25);
	
	var _plain23 = __webpack_require__("../src/components/codeigniter/plain/index.js");
	
	var _plain24 = _interopRequireDefault(_plain23);
	
	var _plainWordmark23 = __webpack_require__("../src/components/chrome/plain-wordmark/index.js");
	
	var _plainWordmark24 = _interopRequireDefault(_plainWordmark23);
	
	var _plainWordmark25 = __webpack_require__("../src/components/codeigniter/plain-wordmark/index.js");
	
	var _plainWordmark26 = _interopRequireDefault(_plainWordmark25);
	
	var _original31 = __webpack_require__("../src/components/coffeescript/original/index.js");
	
	var _original32 = _interopRequireDefault(_original31);
	
	var _plain25 = __webpack_require__("../src/components/chrome/plain/index.js");
	
	var _plain26 = _interopRequireDefault(_plain25);
	
	var _originalWordmark27 = __webpack_require__("../src/components/couchdb/original-wordmark/index.js");
	
	var _originalWordmark28 = _interopRequireDefault(_originalWordmark27);
	
	var _originalWordmark29 = __webpack_require__("../src/components/confluence/original-wordmark/index.js");
	
	var _originalWordmark30 = _interopRequireDefault(_originalWordmark29);
	
	var _original33 = __webpack_require__("../src/components/confluence/original/index.js");
	
	var _original34 = _interopRequireDefault(_original33);
	
	var _original35 = __webpack_require__("../src/components/couchdb/original/index.js");
	
	var _original36 = _interopRequireDefault(_original35);
	
	var _originalWordmark31 = __webpack_require__("../src/components/coffeescript/original-wordmark/index.js");
	
	var _originalWordmark32 = _interopRequireDefault(_originalWordmark31);
	
	var _original37 = __webpack_require__("../src/components/cplusplus/original/index.js");
	
	var _original38 = _interopRequireDefault(_original37);
	
	var _plain27 = __webpack_require__("../src/components/couchdb/plain/index.js");
	
	var _plain28 = _interopRequireDefault(_plain27);
	
	var _plainWordmark27 = __webpack_require__("../src/components/couchdb/plain-wordmark/index.js");
	
	var _plainWordmark28 = _interopRequireDefault(_plainWordmark27);
	
	var _line7 = __webpack_require__("../src/components/cplusplus/line/index.js");
	
	var _line8 = _interopRequireDefault(_line7);
	
	var _plain29 = __webpack_require__("../src/components/csharp/plain/index.js");
	
	var _plain30 = _interopRequireDefault(_plain29);
	
	var _plain31 = __webpack_require__("../src/components/cplusplus/plain/index.js");
	
	var _plain32 = _interopRequireDefault(_plain31);
	
	var _original39 = __webpack_require__("../src/components/csharp/original/index.js");
	
	var _original40 = _interopRequireDefault(_original39);
	
	var _original41 = __webpack_require__("../src/components/css3/original/index.js");
	
	var _original42 = _interopRequireDefault(_original41);
	
	var _line9 = __webpack_require__("../src/components/csharp/line/index.js");
	
	var _line10 = _interopRequireDefault(_line9);
	
	var _plain33 = __webpack_require__("../src/components/css3/plain/index.js");
	
	var _plain34 = _interopRequireDefault(_plain33);
	
	var _originalWordmark33 = __webpack_require__("../src/components/css3/original-wordmark/index.js");
	
	var _originalWordmark34 = _interopRequireDefault(_originalWordmark33);
	
	var _plain35 = __webpack_require__("../src/components/cucumber/plain/index.js");
	
	var _plain36 = _interopRequireDefault(_plain35);
	
	var _plainWordmark29 = __webpack_require__("../src/components/css3/plain-wordmark/index.js");
	
	var _plainWordmark30 = _interopRequireDefault(_plainWordmark29);
	
	var _plainWordmark31 = __webpack_require__("../src/components/cucumber/plain-wordmark/index.js");
	
	var _plainWordmark32 = _interopRequireDefault(_plainWordmark31);
	
	var _original43 = __webpack_require__("../src/components/d3js/original/index.js");
	
	var _original44 = _interopRequireDefault(_original43);
	
	var _original45 = __webpack_require__("../src/components/debian/original/index.js");
	
	var _original46 = _interopRequireDefault(_original45);
	
	var _plain37 = __webpack_require__("../src/components/d3js/plain/index.js");
	
	var _plain38 = _interopRequireDefault(_plain37);
	
	var _originalWordmark35 = __webpack_require__("../src/components/debian/original-wordmark/index.js");
	
	var _originalWordmark36 = _interopRequireDefault(_originalWordmark35);
	
	var _original47 = __webpack_require__("../src/components/devicon/original/index.js");
	
	var _original48 = _interopRequireDefault(_original47);
	
	var _plain39 = __webpack_require__("../src/components/debian/plain/index.js");
	
	var _plain40 = _interopRequireDefault(_plain39);
	
	var _originalWordmark37 = __webpack_require__("../src/components/devicon/original-wordmark/index.js");
	
	var _originalWordmark38 = _interopRequireDefault(_originalWordmark37);
	
	var _plainWordmark33 = __webpack_require__("../src/components/debian/plain-wordmark/index.js");
	
	var _plainWordmark34 = _interopRequireDefault(_plainWordmark33);
	
	var _plain41 = __webpack_require__("../src/components/devicon/plain/index.js");
	
	var _plain42 = _interopRequireDefault(_plain41);
	
	var _plain43 = __webpack_require__("../src/components/django/plain/index.js");
	
	var _plain44 = _interopRequireDefault(_plain43);
	
	var _plainWordmark35 = __webpack_require__("../src/components/devicon/plain-wordmark/index.js");
	
	var _plainWordmark36 = _interopRequireDefault(_plainWordmark35);
	
	var _original49 = __webpack_require__("../src/components/django/original/index.js");
	
	var _original50 = _interopRequireDefault(_original49);
	
	var _originalWordmark39 = __webpack_require__("../src/components/docker/original-wordmark/index.js");
	
	var _originalWordmark40 = _interopRequireDefault(_originalWordmark39);
	
	var _line11 = __webpack_require__("../src/components/django/line/index.js");
	
	var _line12 = _interopRequireDefault(_line11);
	
	var _original51 = __webpack_require__("../src/components/docker/original/index.js");
	
	var _original52 = _interopRequireDefault(_original51);
	
	var _plainWordmark37 = __webpack_require__("../src/components/docker/plain-wordmark/index.js");
	
	var _plainWordmark38 = _interopRequireDefault(_plainWordmark37);
	
	var _original53 = __webpack_require__("../src/components/doctrine/original/index.js");
	
	var _original54 = _interopRequireDefault(_original53);
	
	var _plain45 = __webpack_require__("../src/components/doctrine/plain/index.js");
	
	var _plain46 = _interopRequireDefault(_plain45);
	
	var _plain47 = __webpack_require__("../src/components/docker/plain/index.js");
	
	var _plain48 = _interopRequireDefault(_plain47);
	
	var _line13 = __webpack_require__("../src/components/doctrine/line/index.js");
	
	var _line14 = _interopRequireDefault(_line13);
	
	var _originalWordmark41 = __webpack_require__("../src/components/doctrine/original-wordmark/index.js");
	
	var _originalWordmark42 = _interopRequireDefault(_originalWordmark41);
	
	var _original55 = __webpack_require__("../src/components/dot-net/original/index.js");
	
	var _original56 = _interopRequireDefault(_original55);
	
	var _plainWordmark39 = __webpack_require__("../src/components/doctrine/plain-wordmark/index.js");
	
	var _plainWordmark40 = _interopRequireDefault(_plainWordmark39);
	
	var _plainWordmark41 = __webpack_require__("../src/components/dot-net/plain-wordmark/index.js");
	
	var _plainWordmark42 = _interopRequireDefault(_plainWordmark41);
	
	var _lineWordmark5 = __webpack_require__("../src/components/doctrine/line-wordmark/index.js");
	
	var _lineWordmark6 = _interopRequireDefault(_lineWordmark5);
	
	var _originalWordmark43 = __webpack_require__("../src/components/dot-net/original-wordmark/index.js");
	
	var _originalWordmark44 = _interopRequireDefault(_originalWordmark43);
	
	var _plain49 = __webpack_require__("../src/components/dot-net/plain/index.js");
	
	var _plain50 = _interopRequireDefault(_plain49);
	
	var _original57 = __webpack_require__("../src/components/drupal/original/index.js");
	
	var _original58 = _interopRequireDefault(_original57);
	
	var _original59 = __webpack_require__("../src/components/electron/original/index.js");
	
	var _original60 = _interopRequireDefault(_original59);
	
	var _originalWordmark45 = __webpack_require__("../src/components/electron/original-wordmark/index.js");
	
	var _originalWordmark46 = _interopRequireDefault(_originalWordmark45);
	
	var _originalWordmark47 = __webpack_require__("../src/components/drupal/original-wordmark/index.js");
	
	var _originalWordmark48 = _interopRequireDefault(_originalWordmark47);
	
	var _original61 = __webpack_require__("../src/components/elm/original/index.js");
	
	var _original62 = _interopRequireDefault(_original61);
	
	var _plainWordmark43 = __webpack_require__("../src/components/elm/plain-wordmark/index.js");
	
	var _plainWordmark44 = _interopRequireDefault(_plainWordmark43);
	
	var _originalWordmark49 = __webpack_require__("../src/components/elm/original-wordmark/index.js");
	
	var _originalWordmark50 = _interopRequireDefault(_originalWordmark49);
	
	var _originalWordmark51 = __webpack_require__("../src/components/ember/original-wordmark/index.js");
	
	var _originalWordmark52 = _interopRequireDefault(_originalWordmark51);
	
	var _plainWordmark45 = __webpack_require__("../src/components/drupal/plain-wordmark/index.js");
	
	var _plainWordmark46 = _interopRequireDefault(_plainWordmark45);
	
	var _original63 = __webpack_require__("../src/components/erlang/original/index.js");
	
	var _original64 = _interopRequireDefault(_original63);
	
	var _plain51 = __webpack_require__("../src/components/elm/plain/index.js");
	
	var _plain52 = _interopRequireDefault(_plain51);
	
	var _plain53 = __webpack_require__("../src/components/drupal/plain/index.js");
	
	var _plain54 = _interopRequireDefault(_plain53);
	
	var _plainWordmark47 = __webpack_require__("../src/components/erlang/plain-wordmark/index.js");
	
	var _plainWordmark48 = _interopRequireDefault(_plainWordmark47);
	
	var _original65 = __webpack_require__("../src/components/express/original/index.js");
	
	var _original66 = _interopRequireDefault(_original65);
	
	var _originalWordmark53 = __webpack_require__("../src/components/express/original-wordmark/index.js");
	
	var _originalWordmark54 = _interopRequireDefault(_originalWordmark53);
	
	var _plain55 = __webpack_require__("../src/components/erlang/plain/index.js");
	
	var _plain56 = _interopRequireDefault(_plain55);
	
	var _original67 = __webpack_require__("../src/components/facebook/original/index.js");
	
	var _original68 = _interopRequireDefault(_original67);
	
	var _plain57 = __webpack_require__("../src/components/facebook/plain/index.js");
	
	var _plain58 = _interopRequireDefault(_plain57);
	
	var _originalWordmark55 = __webpack_require__("../src/components/erlang/original-wordmark/index.js");
	
	var _originalWordmark56 = _interopRequireDefault(_originalWordmark55);
	
	var _originalWordmark57 = __webpack_require__("../src/components/firefox/original-wordmark/index.js");
	
	var _originalWordmark58 = _interopRequireDefault(_originalWordmark57);
	
	var _plain59 = __webpack_require__("../src/components/foundation/plain/index.js");
	
	var _plain60 = _interopRequireDefault(_plain59);
	
	var _original69 = __webpack_require__("../src/components/firefox/original/index.js");
	
	var _original70 = _interopRequireDefault(_original69);
	
	var _plain61 = __webpack_require__("../src/components/firefox/plain/index.js");
	
	var _plain62 = _interopRequireDefault(_plain61);
	
	var _originalWordmark59 = __webpack_require__("../src/components/foundation/original-wordmark/index.js");
	
	var _originalWordmark60 = _interopRequireDefault(_originalWordmark59);
	
	var _original71 = __webpack_require__("../src/components/foundation/original/index.js");
	
	var _original72 = _interopRequireDefault(_original71);
	
	var _plainWordmark49 = __webpack_require__("../src/components/firefox/plain-wordmark/index.js");
	
	var _plainWordmark50 = _interopRequireDefault(_plainWordmark49);
	
	var _plain63 = __webpack_require__("../src/components/gatling/plain/index.js");
	
	var _plain64 = _interopRequireDefault(_plain63);
	
	var _originalWordmark61 = __webpack_require__("../src/components/gimp/original-wordmark/index.js");
	
	var _originalWordmark62 = _interopRequireDefault(_originalWordmark61);
	
	var _plainWordmark51 = __webpack_require__("../src/components/foundation/plain-wordmark/index.js");
	
	var _plainWordmark52 = _interopRequireDefault(_plainWordmark51);
	
	var _plainWordmark53 = __webpack_require__("../src/components/gatling/plain-wordmark/index.js");
	
	var _plainWordmark54 = _interopRequireDefault(_plainWordmark53);
	
	var _plain65 = __webpack_require__("../src/components/gimp/plain/index.js");
	
	var _plain66 = _interopRequireDefault(_plain65);
	
	var _originalWordmark63 = __webpack_require__("../src/components/git/original-wordmark/index.js");
	
	var _originalWordmark64 = _interopRequireDefault(_originalWordmark63);
	
	var _original73 = __webpack_require__("../src/components/gimp/original/index.js");
	
	var _original74 = _interopRequireDefault(_original73);
	
	var _plainWordmark55 = __webpack_require__("../src/components/git/plain-wordmark/index.js");
	
	var _plainWordmark56 = _interopRequireDefault(_plainWordmark55);
	
	var _plainWordmark57 = __webpack_require__("../src/components/gimp/plain-wordmark/index.js");
	
	var _plainWordmark58 = _interopRequireDefault(_plainWordmark57);
	
	var _plain67 = __webpack_require__("../src/components/git/plain/index.js");
	
	var _plain68 = _interopRequireDefault(_plain67);
	
	var _original75 = __webpack_require__("../src/components/github/original/index.js");
	
	var _original76 = _interopRequireDefault(_original75);
	
	var _originalWordmark65 = __webpack_require__("../src/components/github/original-wordmark/index.js");
	
	var _originalWordmark66 = _interopRequireDefault(_originalWordmark65);
	
	var _plain69 = __webpack_require__("../src/components/gitlab/plain/index.js");
	
	var _plain70 = _interopRequireDefault(_plain69);
	
	var _original77 = __webpack_require__("../src/components/go/original/index.js");
	
	var _original78 = _interopRequireDefault(_original77);
	
	var _originalWordmark67 = __webpack_require__("../src/components/gitlab/original-wordmark/index.js");
	
	var _originalWordmark68 = _interopRequireDefault(_originalWordmark67);
	
	var _original79 = __webpack_require__("../src/components/git/original/index.js");
	
	var _original80 = _interopRequireDefault(_original79);
	
	var _original81 = __webpack_require__("../src/components/gitlab/original/index.js");
	
	var _original82 = _interopRequireDefault(_original81);
	
	var _line15 = __webpack_require__("../src/components/go/line/index.js");
	
	var _line16 = _interopRequireDefault(_line15);
	
	var _plainWordmark59 = __webpack_require__("../src/components/gitlab/plain-wordmark/index.js");
	
	var _plainWordmark60 = _interopRequireDefault(_plainWordmark59);
	
	var _plain71 = __webpack_require__("../src/components/go/plain/index.js");
	
	var _plain72 = _interopRequireDefault(_plain71);
	
	var _original83 = __webpack_require__("../src/components/google/original/index.js");
	
	var _original84 = _interopRequireDefault(_original83);
	
	var _originalWordmark69 = __webpack_require__("../src/components/google/original-wordmark/index.js");
	
	var _originalWordmark70 = _interopRequireDefault(_originalWordmark69);
	
	var _plainWordmark61 = __webpack_require__("../src/components/gradle/plain-wordmark/index.js");
	
	var _plainWordmark62 = _interopRequireDefault(_plainWordmark61);
	
	var _plain73 = __webpack_require__("../src/components/gradle/plain/index.js");
	
	var _plain74 = _interopRequireDefault(_plain73);
	
	var _original85 = __webpack_require__("../src/components/grunt/original/index.js");
	
	var _original86 = _interopRequireDefault(_original85);
	
	var _plain75 = __webpack_require__("../src/components/google/plain/index.js");
	
	var _plain76 = _interopRequireDefault(_plain75);
	
	var _plain77 = __webpack_require__("../src/components/grunt/plain/index.js");
	
	var _plain78 = _interopRequireDefault(_plain77);
	
	var _plainWordmark63 = __webpack_require__("../src/components/google/plain-wordmark/index.js");
	
	var _plainWordmark64 = _interopRequireDefault(_plainWordmark63);
	
	var _line17 = __webpack_require__("../src/components/grunt/line/index.js");
	
	var _line18 = _interopRequireDefault(_line17);
	
	var _plain79 = __webpack_require__("../src/components/gulp/plain/index.js");
	
	var _plain80 = _interopRequireDefault(_plain79);
	
	var _plainWordmark65 = __webpack_require__("../src/components/grunt/plain-wordmark/index.js");
	
	var _plainWordmark66 = _interopRequireDefault(_plainWordmark65);
	
	var _original87 = __webpack_require__("../src/components/heroku/original/index.js");
	
	var _original88 = _interopRequireDefault(_original87);
	
	var _originalWordmark71 = __webpack_require__("../src/components/grunt/original-wordmark/index.js");
	
	var _originalWordmark72 = _interopRequireDefault(_originalWordmark71);
	
	var _originalWordmark73 = __webpack_require__("../src/components/handlebars/original-wordmark/index.js");
	
	var _originalWordmark74 = _interopRequireDefault(_originalWordmark73);
	
	var _lineWordmark7 = __webpack_require__("../src/components/grunt/line-wordmark/index.js");
	
	var _lineWordmark8 = _interopRequireDefault(_lineWordmark7);
	
	var _originalWordmark75 = __webpack_require__("../src/components/heroku/original-wordmark/index.js");
	
	var _originalWordmark76 = _interopRequireDefault(_originalWordmark75);
	
	var _original89 = __webpack_require__("../src/components/handlebars/original/index.js");
	
	var _original90 = _interopRequireDefault(_original89);
	
	var _plain81 = __webpack_require__("../src/components/heroku/plain/index.js");
	
	var _plain82 = _interopRequireDefault(_plain81);
	
	var _original91 = __webpack_require__("../src/components/html5/original/index.js");
	
	var _original92 = _interopRequireDefault(_original91);
	
	var _originalWordmark77 = __webpack_require__("../src/components/html5/original-wordmark/index.js");
	
	var _originalWordmark78 = _interopRequireDefault(_originalWordmark77);
	
	var _plain83 = __webpack_require__("../src/components/html5/plain/index.js");
	
	var _plain84 = _interopRequireDefault(_plain83);
	
	var _original93 = __webpack_require__("../src/components/ie10/original/index.js");
	
	var _original94 = _interopRequireDefault(_original93);
	
	var _plainWordmark67 = __webpack_require__("../src/components/heroku/plain-wordmark/index.js");
	
	var _plainWordmark68 = _interopRequireDefault(_plainWordmark67);
	
	var _line19 = __webpack_require__("../src/components/illustrator/line/index.js");
	
	var _line20 = _interopRequireDefault(_line19);
	
	var _plain85 = __webpack_require__("../src/components/illustrator/plain/index.js");
	
	var _plain86 = _interopRequireDefault(_plain85);
	
	var _plainWordmark69 = __webpack_require__("../src/components/html5/plain-wordmark/index.js");
	
	var _plainWordmark70 = _interopRequireDefault(_plainWordmark69);
	
	var _original95 = __webpack_require__("../src/components/inkscape/original/index.js");
	
	var _original96 = _interopRequireDefault(_original95);
	
	var _originalWordmark79 = __webpack_require__("../src/components/inkscape/original-wordmark/index.js");
	
	var _originalWordmark80 = _interopRequireDefault(_originalWordmark79);
	
	var _original97 = __webpack_require__("../src/components/intellij/original/index.js");
	
	var _original98 = _interopRequireDefault(_original97);
	
	var _plainWordmark71 = __webpack_require__("../src/components/inkscape/plain-wordmark/index.js");
	
	var _plainWordmark72 = _interopRequireDefault(_plainWordmark71);
	
	var _originalWordmark81 = __webpack_require__("../src/components/intellij/original-wordmark/index.js");
	
	var _originalWordmark82 = _interopRequireDefault(_originalWordmark81);
	
	var _plain87 = __webpack_require__("../src/components/intellij/plain/index.js");
	
	var _plain88 = _interopRequireDefault(_plain87);
	
	var _plain89 = __webpack_require__("../src/components/inkscape/plain/index.js");
	
	var _plain90 = _interopRequireDefault(_plain89);
	
	var _original99 = __webpack_require__("../src/components/ionic/original/index.js");
	
	var _original100 = _interopRequireDefault(_original99);
	
	var _plainWordmark73 = __webpack_require__("../src/components/intellij/plain-wordmark/index.js");
	
	var _plainWordmark74 = _interopRequireDefault(_plainWordmark73);
	
	var _originalWordmark83 = __webpack_require__("../src/components/ionic/original-wordmark/index.js");
	
	var _originalWordmark84 = _interopRequireDefault(_originalWordmark83);
	
	var _original101 = __webpack_require__("../src/components/java/original/index.js");
	
	var _original102 = _interopRequireDefault(_original101);
	
	var _plainWordmark75 = __webpack_require__("../src/components/jasmine/plain-wordmark/index.js");
	
	var _plainWordmark76 = _interopRequireDefault(_plainWordmark75);
	
	var _originalWordmark85 = __webpack_require__("../src/components/java/original-wordmark/index.js");
	
	var _originalWordmark86 = _interopRequireDefault(_originalWordmark85);
	
	var _plain91 = __webpack_require__("../src/components/jasmine/plain/index.js");
	
	var _plain92 = _interopRequireDefault(_plain91);
	
	var _original103 = __webpack_require__("../src/components/javascript/original/index.js");
	
	var _original104 = _interopRequireDefault(_original103);
	
	var _plain93 = __webpack_require__("../src/components/java/plain/index.js");
	
	var _plain94 = _interopRequireDefault(_plain93);
	
	var _plain95 = __webpack_require__("../src/components/javascript/plain/index.js");
	
	var _plain96 = _interopRequireDefault(_plain95);
	
	var _plainWordmark77 = __webpack_require__("../src/components/java/plain-wordmark/index.js");
	
	var _plainWordmark78 = _interopRequireDefault(_plainWordmark77);
	
	var _originalWordmark87 = __webpack_require__("../src/components/jeet/original-wordmark/index.js");
	
	var _originalWordmark88 = _interopRequireDefault(_originalWordmark87);
	
	var _originalWordmark89 = __webpack_require__("../src/components/jquery/original-wordmark/index.js");
	
	var _originalWordmark90 = _interopRequireDefault(_originalWordmark89);
	
	var _original105 = __webpack_require__("../src/components/jeet/original/index.js");
	
	var _original106 = _interopRequireDefault(_original105);
	
	var _plainWordmark79 = __webpack_require__("../src/components/jeet/plain-wordmark/index.js");
	
	var _plainWordmark80 = _interopRequireDefault(_plainWordmark79);
	
	var _original107 = __webpack_require__("../src/components/jquery/original/index.js");
	
	var _original108 = _interopRequireDefault(_original107);
	
	var _plain97 = __webpack_require__("../src/components/jeet/plain/index.js");
	
	var _plain98 = _interopRequireDefault(_plain97);
	
	var _original109 = __webpack_require__("../src/components/jetbrains/original/index.js");
	
	var _original110 = _interopRequireDefault(_original109);
	
	var _plain99 = __webpack_require__("../src/components/jquery/plain/index.js");
	
	var _plain100 = _interopRequireDefault(_plain99);
	
	var _original111 = __webpack_require__("../src/components/krakenjs/original/index.js");
	
	var _original112 = _interopRequireDefault(_original111);
	
	var _plain101 = __webpack_require__("../src/components/jetbrains/plain/index.js");
	
	var _plain102 = _interopRequireDefault(_plain101);
	
	var _plainWordmark81 = __webpack_require__("../src/components/jquery/plain-wordmark/index.js");
	
	var _plainWordmark82 = _interopRequireDefault(_plainWordmark81);
	
	var _plain103 = __webpack_require__("../src/components/krakenjs/plain/index.js");
	
	var _plain104 = _interopRequireDefault(_plain103);
	
	var _originalWordmark91 = __webpack_require__("../src/components/krakenjs/original-wordmark/index.js");
	
	var _originalWordmark92 = _interopRequireDefault(_originalWordmark91);
	
	var _plainWordmark83 = __webpack_require__("../src/components/less/plain-wordmark/index.js");
	
	var _plainWordmark84 = _interopRequireDefault(_plainWordmark83);
	
	var _original113 = __webpack_require__("../src/components/linkedin/original/index.js");
	
	var _original114 = _interopRequireDefault(_original113);
	
	var _plainWordmark85 = __webpack_require__("../src/components/krakenjs/plain-wordmark/index.js");
	
	var _plainWordmark86 = _interopRequireDefault(_plainWordmark85);
	
	var _plain105 = __webpack_require__("../src/components/laravel/plain/index.js");
	
	var _plain106 = _interopRequireDefault(_plain105);
	
	var _originalWordmark93 = __webpack_require__("../src/components/linkedin/original-wordmark/index.js");
	
	var _originalWordmark94 = _interopRequireDefault(_originalWordmark93);
	
	var _plainWordmark87 = __webpack_require__("../src/components/laravel/plain-wordmark/index.js");
	
	var _plainWordmark88 = _interopRequireDefault(_plainWordmark87);
	
	var _plain107 = __webpack_require__("../src/components/linkedin/plain/index.js");
	
	var _plain108 = _interopRequireDefault(_plain107);
	
	var _plainWordmark89 = __webpack_require__("../src/components/linkedin/plain-wordmark/index.js");
	
	var _plainWordmark90 = _interopRequireDefault(_plainWordmark89);
	
	var _plain109 = __webpack_require__("../src/components/linux/plain/index.js");
	
	var _plain110 = _interopRequireDefault(_plain109);
	
	var _original115 = __webpack_require__("../src/components/meteor/original/index.js");
	
	var _original116 = _interopRequireDefault(_original115);
	
	var _plain111 = __webpack_require__("../src/components/mocha/plain/index.js");
	
	var _plain112 = _interopRequireDefault(_plain111);
	
	var _plain113 = __webpack_require__("../src/components/meteor/plain/index.js");
	
	var _plain114 = _interopRequireDefault(_plain113);
	
	var _originalWordmark95 = __webpack_require__("../src/components/meteor/original-wordmark/index.js");
	
	var _originalWordmark96 = _interopRequireDefault(_originalWordmark95);
	
	var _plain115 = __webpack_require__("../src/components/mongodb/plain/index.js");
	
	var _plain116 = _interopRequireDefault(_plain115);
	
	var _plainWordmark91 = __webpack_require__("../src/components/meteor/plain-wordmark/index.js");
	
	var _plainWordmark92 = _interopRequireDefault(_plainWordmark91);
	
	var _original117 = __webpack_require__("../src/components/linux/original/index.js");
	
	var _original118 = _interopRequireDefault(_original117);
	
	var _original119 = __webpack_require__("../src/components/moodle/original/index.js");
	
	var _original120 = _interopRequireDefault(_original119);
	
	var _original121 = __webpack_require__("../src/components/mongodb/original/index.js");
	
	var _original122 = _interopRequireDefault(_original121);
	
	var _plainWordmark93 = __webpack_require__("../src/components/moodle/plain-wordmark/index.js");
	
	var _plainWordmark94 = _interopRequireDefault(_plainWordmark93);
	
	var _originalWordmark97 = __webpack_require__("../src/components/mongodb/original-wordmark/index.js");
	
	var _originalWordmark98 = _interopRequireDefault(_originalWordmark97);
	
	var _plain117 = __webpack_require__("../src/components/moodle/plain/index.js");
	
	var _plain118 = _interopRequireDefault(_plain117);
	
	var _plainWordmark95 = __webpack_require__("../src/components/mongodb/plain-wordmark/index.js");
	
	var _plainWordmark96 = _interopRequireDefault(_plainWordmark95);
	
	var _original123 = __webpack_require__("../src/components/mysql/original/index.js");
	
	var _original124 = _interopRequireDefault(_original123);
	
	var _originalWordmark99 = __webpack_require__("../src/components/moodle/original-wordmark/index.js");
	
	var _originalWordmark100 = _interopRequireDefault(_originalWordmark99);
	
	var _plain119 = __webpack_require__("../src/components/mysql/plain/index.js");
	
	var _plain120 = _interopRequireDefault(_plain119);
	
	var _original125 = __webpack_require__("../src/components/nginx/original/index.js");
	
	var _original126 = _interopRequireDefault(_original125);
	
	var _original127 = __webpack_require__("../src/components/nodejs/original/index.js");
	
	var _original128 = _interopRequireDefault(_original127);
	
	var _originalWordmark101 = __webpack_require__("../src/components/mysql/original-wordmark/index.js");
	
	var _originalWordmark102 = _interopRequireDefault(_originalWordmark101);
	
	var _plain121 = __webpack_require__("../src/components/nodejs/plain/index.js");
	
	var _plain122 = _interopRequireDefault(_plain121);
	
	var _plainWordmark97 = __webpack_require__("../src/components/mysql/plain-wordmark/index.js");
	
	var _plainWordmark98 = _interopRequireDefault(_plainWordmark97);
	
	var _plain123 = __webpack_require__("../src/components/nodewebkit/plain/index.js");
	
	var _plain124 = _interopRequireDefault(_plain123);
	
	var _plainWordmark99 = __webpack_require__("../src/components/nodejs/plain-wordmark/index.js");
	
	var _plainWordmark100 = _interopRequireDefault(_plainWordmark99);
	
	var _originalWordmark103 = __webpack_require__("../src/components/nodejs/original-wordmark/index.js");
	
	var _originalWordmark104 = _interopRequireDefault(_originalWordmark103);
	
	var _originalWordmark105 = __webpack_require__("../src/components/nodewebkit/original-wordmark/index.js");
	
	var _originalWordmark106 = _interopRequireDefault(_originalWordmark105);
	
	var _original129 = __webpack_require__("../src/components/nodewebkit/original/index.js");
	
	var _original130 = _interopRequireDefault(_original129);
	
	var _originalWordmark107 = __webpack_require__("../src/components/npm/original-wordmark/index.js");
	
	var _originalWordmark108 = _interopRequireDefault(_originalWordmark107);
	
	var _line21 = __webpack_require__("../src/components/photoshop/line/index.js");
	
	var _line22 = _interopRequireDefault(_line21);
	
	var _original131 = __webpack_require__("../src/components/oracle/original/index.js");
	
	var _original132 = _interopRequireDefault(_original131);
	
	var _original133 = __webpack_require__("../src/components/php/original/index.js");
	
	var _original134 = _interopRequireDefault(_original133);
	
	var _line23 = __webpack_require__("../src/components/nodewebkit/line/index.js");
	
	var _line24 = _interopRequireDefault(_line23);
	
	var _plainWordmark101 = __webpack_require__("../src/components/nodewebkit/plain-wordmark/index.js");
	
	var _plainWordmark102 = _interopRequireDefault(_plainWordmark101);
	
	var _lineWordmark9 = __webpack_require__("../src/components/nodewebkit/line-wordmark/index.js");
	
	var _lineWordmark10 = _interopRequireDefault(_lineWordmark9);
	
	var _plain125 = __webpack_require__("../src/components/photoshop/plain/index.js");
	
	var _plain126 = _interopRequireDefault(_plain125);
	
	var _plain127 = __webpack_require__("../src/components/php/plain/index.js");
	
	var _plain128 = _interopRequireDefault(_plain127);
	
	var _originalWordmark109 = __webpack_require__("../src/components/phpstorm/original-wordmark/index.js");
	
	var _originalWordmark110 = _interopRequireDefault(_originalWordmark109);
	
	var _plainWordmark103 = __webpack_require__("../src/components/protractor/plain-wordmark/index.js");
	
	var _plainWordmark104 = _interopRequireDefault(_plainWordmark103);
	
	var _plain129 = __webpack_require__("../src/components/phpstorm/plain/index.js");
	
	var _plain130 = _interopRequireDefault(_plain129);
	
	var _original135 = __webpack_require__("../src/components/phpstorm/original/index.js");
	
	var _original136 = _interopRequireDefault(_original135);
	
	var _plain131 = __webpack_require__("../src/components/protractor/plain/index.js");
	
	var _plain132 = _interopRequireDefault(_plain131);
	
	var _original137 = __webpack_require__("../src/components/postgresql/original/index.js");
	
	var _original138 = _interopRequireDefault(_original137);
	
	var _plain133 = __webpack_require__("../src/components/postgresql/plain/index.js");
	
	var _plain134 = _interopRequireDefault(_plain133);
	
	var _plainWordmark105 = __webpack_require__("../src/components/phpstorm/plain-wordmark/index.js");
	
	var _plainWordmark106 = _interopRequireDefault(_plainWordmark105);
	
	var _original139 = __webpack_require__("../src/components/python/original/index.js");
	
	var _original140 = _interopRequireDefault(_original139);
	
	var _plainWordmark107 = __webpack_require__("../src/components/postgresql/plain-wordmark/index.js");
	
	var _plainWordmark108 = _interopRequireDefault(_plainWordmark107);
	
	var _originalWordmark111 = __webpack_require__("../src/components/python/original-wordmark/index.js");
	
	var _originalWordmark112 = _interopRequireDefault(_originalWordmark111);
	
	var _originalWordmark113 = __webpack_require__("../src/components/postgresql/original-wordmark/index.js");
	
	var _originalWordmark114 = _interopRequireDefault(_originalWordmark113);
	
	var _plainWordmark109 = __webpack_require__("../src/components/python/plain-wordmark/index.js");
	
	var _plainWordmark110 = _interopRequireDefault(_plainWordmark109);
	
	var _original141 = __webpack_require__("../src/components/pycharm/original/index.js");
	
	var _original142 = _interopRequireDefault(_original141);
	
	var _plain135 = __webpack_require__("../src/components/pycharm/plain/index.js");
	
	var _plain136 = _interopRequireDefault(_plain135);
	
	var _plain137 = __webpack_require__("../src/components/python/plain/index.js");
	
	var _plain138 = _interopRequireDefault(_plain137);
	
	var _plainWordmark111 = __webpack_require__("../src/components/pycharm/plain-wordmark/index.js");
	
	var _plainWordmark112 = _interopRequireDefault(_plainWordmark111);
	
	var _originalWordmark115 = __webpack_require__("../src/components/rails/original-wordmark/index.js");
	
	var _originalWordmark116 = _interopRequireDefault(_originalWordmark115);
	
	var _original143 = __webpack_require__("../src/components/apple/original/index.js");
	
	var _original144 = _interopRequireDefault(_original143);
	
	var _originalWordmark117 = __webpack_require__("../src/components/pycharm/original-wordmark/index.js");
	
	var _originalWordmark118 = _interopRequireDefault(_originalWordmark117);
	
	var _plain139 = __webpack_require__("../src/components/rails/plain/index.js");
	
	var _plain140 = _interopRequireDefault(_plain139);
	
	var _originalWordmark119 = __webpack_require__("../src/components/react/original-wordmark/index.js");
	
	var _originalWordmark120 = _interopRequireDefault(_originalWordmark119);
	
	var _plainWordmark113 = __webpack_require__("../src/components/rails/plain-wordmark/index.js");
	
	var _plainWordmark114 = _interopRequireDefault(_plainWordmark113);
	
	var _original145 = __webpack_require__("../src/components/react/original/index.js");
	
	var _original146 = _interopRequireDefault(_original145);
	
	var _original147 = __webpack_require__("../src/components/redis/original/index.js");
	
	var _original148 = _interopRequireDefault(_original147);
	
	var _original149 = __webpack_require__("../src/components/redhat/original/index.js");
	
	var _original150 = _interopRequireDefault(_original149);
	
	var _plain141 = __webpack_require__("../src/components/redhat/plain/index.js");
	
	var _plain142 = _interopRequireDefault(_plain141);
	
	var _originalWordmark121 = __webpack_require__("../src/components/redis/original-wordmark/index.js");
	
	var _originalWordmark122 = _interopRequireDefault(_originalWordmark121);
	
	var _plain143 = __webpack_require__("../src/components/redis/plain/index.js");
	
	var _plain144 = _interopRequireDefault(_plain143);
	
	var _plainWordmark115 = __webpack_require__("../src/components/redhat/plain-wordmark/index.js");
	
	var _plainWordmark116 = _interopRequireDefault(_plainWordmark115);
	
	var _originalWordmark123 = __webpack_require__("../src/components/redhat/original-wordmark/index.js");
	
	var _originalWordmark124 = _interopRequireDefault(_originalWordmark123);
	
	var _original151 = __webpack_require__("../src/components/ruby/original/index.js");
	
	var _original152 = _interopRequireDefault(_original151);
	
	var _original153 = __webpack_require__("../src/components/rubymine/original/index.js");
	
	var _original154 = _interopRequireDefault(_original153);
	
	var _originalWordmark125 = __webpack_require__("../src/components/ruby/original-wordmark/index.js");
	
	var _originalWordmark126 = _interopRequireDefault(_originalWordmark125);
	
	var _plain145 = __webpack_require__("../src/components/ruby/plain/index.js");
	
	var _plain146 = _interopRequireDefault(_plain145);
	
	var _originalWordmark127 = __webpack_require__("../src/components/rubymine/original-wordmark/index.js");
	
	var _originalWordmark128 = _interopRequireDefault(_originalWordmark127);
	
	var _plainWordmark117 = __webpack_require__("../src/components/rubymine/plain-wordmark/index.js");
	
	var _plainWordmark118 = _interopRequireDefault(_plainWordmark117);
	
	var _plain147 = __webpack_require__("../src/components/rubymine/plain/index.js");
	
	var _plain148 = _interopRequireDefault(_plain147);
	
	var _plainWordmark119 = __webpack_require__("../src/components/ruby/plain-wordmark/index.js");
	
	var _plainWordmark120 = _interopRequireDefault(_plainWordmark119);
	
	var _original155 = __webpack_require__("../src/components/safari/original/index.js");
	
	var _original156 = _interopRequireDefault(_original155);
	
	var _plain149 = __webpack_require__("../src/components/safari/plain/index.js");
	
	var _plain150 = _interopRequireDefault(_plain149);
	
	var _originalWordmark129 = __webpack_require__("../src/components/safari/original-wordmark/index.js");
	
	var _originalWordmark130 = _interopRequireDefault(_originalWordmark129);
	
	var _original157 = __webpack_require__("../src/components/sequelize/original/index.js");
	
	var _original158 = _interopRequireDefault(_original157);
	
	var _original159 = __webpack_require__("../src/components/sass/original/index.js");
	
	var _original160 = _interopRequireDefault(_original159);
	
	var _plainWordmark121 = __webpack_require__("../src/components/safari/plain-wordmark/index.js");
	
	var _plainWordmark122 = _interopRequireDefault(_plainWordmark121);
	
	var _originalWordmark131 = __webpack_require__("../src/components/sequelize/original-wordmark/index.js");
	
	var _originalWordmark132 = _interopRequireDefault(_originalWordmark131);
	
	var _lineWordmark11 = __webpack_require__("../src/components/safari/line-wordmark/index.js");
	
	var _lineWordmark12 = _interopRequireDefault(_lineWordmark11);
	
	var _plain151 = __webpack_require__("../src/components/sequelize/plain/index.js");
	
	var _plain152 = _interopRequireDefault(_plain151);
	
	var _plainWordmark123 = __webpack_require__("../src/components/sequelize/plain-wordmark/index.js");
	
	var _plainWordmark124 = _interopRequireDefault(_plainWordmark123);
	
	var _line25 = __webpack_require__("../src/components/safari/line/index.js");
	
	var _line26 = _interopRequireDefault(_line25);
	
	var _original161 = __webpack_require__("../src/components/sketch/original/index.js");
	
	var _original162 = _interopRequireDefault(_original161);
	
	var _line27 = __webpack_require__("../src/components/sketch/line/index.js");
	
	var _line28 = _interopRequireDefault(_line27);
	
	var _originalWordmark133 = __webpack_require__("../src/components/sketch/original-wordmark/index.js");
	
	var _originalWordmark134 = _interopRequireDefault(_originalWordmark133);
	
	var _lineWordmark13 = __webpack_require__("../src/components/sketch/line-wordmark/index.js");
	
	var _lineWordmark14 = _interopRequireDefault(_lineWordmark13);
	
	var _original163 = __webpack_require__("../src/components/slack/original/index.js");
	
	var _original164 = _interopRequireDefault(_original163);
	
	var _originalWordmark135 = __webpack_require__("../src/components/slack/original-wordmark/index.js");
	
	var _originalWordmark136 = _interopRequireDefault(_originalWordmark135);
	
	var _original165 = __webpack_require__("../src/components/sourcetree/original/index.js");
	
	var _original166 = _interopRequireDefault(_original165);
	
	var _plain153 = __webpack_require__("../src/components/slack/plain/index.js");
	
	var _plain154 = _interopRequireDefault(_plain153);
	
	var _plainWordmark125 = __webpack_require__("../src/components/slack/plain-wordmark/index.js");
	
	var _plainWordmark126 = _interopRequireDefault(_plainWordmark125);
	
	var _original167 = __webpack_require__("../src/components/ssh/original/index.js");
	
	var _original168 = _interopRequireDefault(_original167);
	
	var _originalWordmark137 = __webpack_require__("../src/components/ssh/original-wordmark/index.js");
	
	var _originalWordmark138 = _interopRequireDefault(_originalWordmark137);
	
	var _originalWordmark139 = __webpack_require__("../src/components/sourcetree/original-wordmark/index.js");
	
	var _originalWordmark140 = _interopRequireDefault(_originalWordmark139);
	
	var _original169 = __webpack_require__("../src/components/stylus/original/index.js");
	
	var _original170 = _interopRequireDefault(_original169);
	
	var _original171 = __webpack_require__("../src/components/swift/original/index.js");
	
	var _original172 = _interopRequireDefault(_original171);
	
	var _plain155 = __webpack_require__("../src/components/swift/plain/index.js");
	
	var _plain156 = _interopRequireDefault(_plain155);
	
	var _original173 = __webpack_require__("../src/components/symfony/original/index.js");
	
	var _original174 = _interopRequireDefault(_original173);
	
	var _originalWordmark141 = __webpack_require__("../src/components/symfony/original-wordmark/index.js");
	
	var _originalWordmark142 = _interopRequireDefault(_originalWordmark141);
	
	var _originalWordmark143 = __webpack_require__("../src/components/swift/original-wordmark/index.js");
	
	var _originalWordmark144 = _interopRequireDefault(_originalWordmark143);
	
	var _original175 = __webpack_require__("../src/components/tomcat/original/index.js");
	
	var _original176 = _interopRequireDefault(_original175);
	
	var _plainWordmark127 = __webpack_require__("../src/components/swift/plain-wordmark/index.js");
	
	var _plainWordmark128 = _interopRequireDefault(_plainWordmark127);
	
	var _originalWordmark145 = __webpack_require__("../src/components/tomcat/original-wordmark/index.js");
	
	var _originalWordmark146 = _interopRequireDefault(_originalWordmark145);
	
	var _lineWordmark15 = __webpack_require__("../src/components/tomcat/line-wordmark/index.js");
	
	var _lineWordmark16 = _interopRequireDefault(_lineWordmark15);
	
	var _line29 = __webpack_require__("../src/components/tomcat/line/index.js");
	
	var _line30 = _interopRequireDefault(_line29);
	
	var _plainWordmark129 = __webpack_require__("../src/components/travis/plain-wordmark/index.js");
	
	var _plainWordmark130 = _interopRequireDefault(_plainWordmark129);
	
	var _plainWordmark131 = __webpack_require__("../src/components/trello/plain-wordmark/index.js");
	
	var _plainWordmark132 = _interopRequireDefault(_plainWordmark131);
	
	var _plain157 = __webpack_require__("../src/components/travis/plain/index.js");
	
	var _plain158 = _interopRequireDefault(_plain157);
	
	var _original177 = __webpack_require__("../src/components/typescript/original/index.js");
	
	var _original178 = _interopRequireDefault(_original177);
	
	var _plain159 = __webpack_require__("../src/components/trello/plain/index.js");
	
	var _plain160 = _interopRequireDefault(_plain159);
	
	var _original179 = __webpack_require__("../src/components/twitter/original/index.js");
	
	var _original180 = _interopRequireDefault(_original179);
	
	var _plain161 = __webpack_require__("../src/components/ubuntu/plain/index.js");
	
	var _plain162 = _interopRequireDefault(_plain161);
	
	var _plain163 = __webpack_require__("../src/components/typescript/plain/index.js");
	
	var _plain164 = _interopRequireDefault(_plain163);
	
	var _plainWordmark133 = __webpack_require__("../src/components/ubuntu/plain-wordmark/index.js");
	
	var _plainWordmark134 = _interopRequireDefault(_plainWordmark133);
	
	var _originalWordmark147 = __webpack_require__("../src/components/vagrant/original-wordmark/index.js");
	
	var _originalWordmark148 = _interopRequireDefault(_originalWordmark147);
	
	var _original181 = __webpack_require__("../src/components/vagrant/original/index.js");
	
	var _original182 = _interopRequireDefault(_original181);
	
	var _original183 = __webpack_require__("../src/components/vim/original/index.js");
	
	var _original184 = _interopRequireDefault(_original183);
	
	var _plain165 = __webpack_require__("../src/components/vim/plain/index.js");
	
	var _plain166 = _interopRequireDefault(_plain165);
	
	var _plain167 = __webpack_require__("../src/components/visualstudio/plain/index.js");
	
	var _plain168 = _interopRequireDefault(_plain167);
	
	var _plainWordmark135 = __webpack_require__("../src/components/vagrant/plain-wordmark/index.js");
	
	var _plainWordmark136 = _interopRequireDefault(_plainWordmark135);
	
	var _plain169 = __webpack_require__("../src/components/vagrant/plain/index.js");
	
	var _plain170 = _interopRequireDefault(_plain169);
	
	var _original185 = __webpack_require__("../src/components/vuejs/original/index.js");
	
	var _original186 = _interopRequireDefault(_original185);
	
	var _plainWordmark137 = __webpack_require__("../src/components/visualstudio/plain-wordmark/index.js");
	
	var _plainWordmark138 = _interopRequireDefault(_plainWordmark137);
	
	var _originalWordmark149 = __webpack_require__("../src/components/vuejs/original-wordmark/index.js");
	
	var _originalWordmark150 = _interopRequireDefault(_originalWordmark149);
	
	var _plain171 = __webpack_require__("../src/components/vuejs/plain/index.js");
	
	var _plain172 = _interopRequireDefault(_plain171);
	
	var _original187 = __webpack_require__("../src/components/webpack/original/index.js");
	
	var _original188 = _interopRequireDefault(_original187);
	
	var _line31 = __webpack_require__("../src/components/vuejs/line/index.js");
	
	var _line32 = _interopRequireDefault(_line31);
	
	var _plainWordmark139 = __webpack_require__("../src/components/vuejs/plain-wordmark/index.js");
	
	var _plainWordmark140 = _interopRequireDefault(_plainWordmark139);
	
	var _originalWordmark151 = __webpack_require__("../src/components/webpack/original-wordmark/index.js");
	
	var _originalWordmark152 = _interopRequireDefault(_originalWordmark151);
	
	var _plain173 = __webpack_require__("../src/components/webpack/plain/index.js");
	
	var _plain174 = _interopRequireDefault(_plain173);
	
	var _lineWordmark17 = __webpack_require__("../src/components/vuejs/line-wordmark/index.js");
	
	var _lineWordmark18 = _interopRequireDefault(_lineWordmark17);
	
	var _plainWordmark141 = __webpack_require__("../src/components/webpack/plain-wordmark/index.js");
	
	var _plainWordmark142 = _interopRequireDefault(_plainWordmark141);
	
	var _original189 = __webpack_require__("../src/components/webstorm/original/index.js");
	
	var _original190 = _interopRequireDefault(_original189);
	
	var _original191 = __webpack_require__("../src/components/windows8/original/index.js");
	
	var _original192 = _interopRequireDefault(_original191);
	
	var _originalWordmark153 = __webpack_require__("../src/components/webstorm/original-wordmark/index.js");
	
	var _originalWordmark154 = _interopRequireDefault(_originalWordmark153);
	
	var _plain175 = __webpack_require__("../src/components/webstorm/plain/index.js");
	
	var _plain176 = _interopRequireDefault(_plain175);
	
	var _originalWordmark155 = __webpack_require__("../src/components/windows8/original-wordmark/index.js");
	
	var _originalWordmark156 = _interopRequireDefault(_originalWordmark155);
	
	var _original193 = __webpack_require__("../src/components/wordpress/original/index.js");
	
	var _original194 = _interopRequireDefault(_original193);
	
	var _plainWordmark143 = __webpack_require__("../src/components/wordpress/plain-wordmark/index.js");
	
	var _plainWordmark144 = _interopRequireDefault(_plainWordmark143);
	
	var _plainWordmark145 = __webpack_require__("../src/components/webstorm/plain-wordmark/index.js");
	
	var _plainWordmark146 = _interopRequireDefault(_plainWordmark145);
	
	var _plainWordmark147 = __webpack_require__("../src/components/redis/plain-wordmark/index.js");
	
	var _plainWordmark148 = _interopRequireDefault(_plainWordmark147);
	
	var _original195 = __webpack_require__("../src/components/yarn/original/index.js");
	
	var _original196 = _interopRequireDefault(_original195);
	
	var _plain177 = __webpack_require__("../src/components/wordpress/plain/index.js");
	
	var _plain178 = _interopRequireDefault(_plain177);
	
	var _original197 = __webpack_require__("../src/components/yii/original/index.js");
	
	var _original198 = _interopRequireDefault(_original197);
	
	var _originalWordmark157 = __webpack_require__("../src/components/yarn/original-wordmark/index.js");
	
	var _originalWordmark158 = _interopRequireDefault(_originalWordmark157);
	
	var _plain179 = __webpack_require__("../src/components/yii/plain/index.js");
	
	var _plain180 = _interopRequireDefault(_plain179);
	
	var _plain181 = __webpack_require__("../src/components/zend/plain/index.js");
	
	var _plain182 = _interopRequireDefault(_plain181);
	
	var _plainWordmark149 = __webpack_require__("../src/components/zend/plain-wordmark/index.js");
	
	var _plainWordmark150 = _interopRequireDefault(_plainWordmark149);
	
	var _originalWordmark159 = __webpack_require__("../src/components/yii/original-wordmark/index.js");
	
	var _originalWordmark160 = _interopRequireDefault(_originalWordmark159);
	
	var _plainWordmark151 = __webpack_require__("../src/components/yii/plain-wordmark/index.js");
	
	var _plainWordmark152 = _interopRequireDefault(_plainWordmark151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AmazonwebservicesOriginalWordmark = _originalWordmark2.default;
	exports.AndroidOriginalWordmark = _originalWordmark4.default;
	exports.AmazonwebservicesOriginal = _original2.default;
	exports.AndroidPlainWordmark = _plainWordmark2.default;
	exports.AndroidPlain = _plain2.default;
	exports.AngularjsOriginal = _original4.default;
	exports.AngularjsPlain = _plain4.default;
	exports.AmazonwebservicesPlainWordmark = _plainWordmark4.default;
	exports.AndroidOriginal = _original6.default;
	exports.ApacheOriginal = _original8.default;
	exports.AngularjsOriginalWordmark = _originalWordmark6.default;
	exports.ApachePlainWordmark = _plainWordmark6.default;
	exports.AngularjsPlainWordmark = _plainWordmark8.default;
	exports.ApacheLineWordmark = _lineWordmark2.default;
	exports.AppceleratorPlainWordmark = _plainWordmark10.default;
	exports.AppceleratorOriginal = _original10.default;
	exports.ApacheLine = _line2.default;
	exports.AppceleratorOriginalWordmark = _originalWordmark8.default;
	exports.ApachePlain = _plain6.default;
	exports.AtomOriginalWordmark = _originalWordmark10.default;
	exports.BabelPlain = _plain8.default;
	exports.BackbonejsPlain = _plain10.default;
	exports.AtomOriginal = _original12.default;
	exports.ApacheOriginalWordmark = _originalWordmark12.default;
	exports.BabelOriginal = _original14.default;
	exports.BehanceOriginal = _original16.default;
	exports.BackbonejsOriginalWordmark = _originalWordmark14.default;
	exports.BehancePlain = _plain12.default;
	exports.BackbonejsOriginal = _original18.default;
	exports.BackbonejsPlainWordmark = _plainWordmark12.default;
	exports.BehanceOriginalWordmark = _originalWordmark16.default;
	exports.BootstrapPlainWordmark = _plainWordmark14.default;
	exports.BehancePlainWordmark = _plainWordmark16.default;
	exports.BootstrapPlain = _plain14.default;
	exports.BitbucketOriginal = _original20.default;
	exports.BowerOriginal = _original22.default;
	exports.BitbucketOriginalWordmark = _originalWordmark18.default;
	exports.BowerPlain = _plain16.default;
	exports.BowerOriginalWordmark = _originalWordmark20.default;
	exports.CLine = _line4.default;
	exports.COriginal = _original24.default;
	exports.BowerLine = _line6.default;
	exports.CPlain = _plain18.default;
	exports.BowerLineWordmark = _lineWordmark4.default;
	exports.CakephpOriginal = _original26.default;
	exports.BowerPlainWordmark = _plainWordmark18.default;
	exports.CakephpPlainWordmark = _plainWordmark20.default;
	exports.CakephpOriginalWordmark = _originalWordmark22.default;
	exports.CeylonOriginal = _original28.default;
	exports.CeylonPlainWordmark = _plainWordmark22.default;
	exports.CeylonPlain = _plain20.default;
	exports.CakephpPlain = _plain22.default;
	exports.ChromeOriginal = _original30.default;
	exports.CeylonOriginalWordmark = _originalWordmark24.default;
	exports.ChromeOriginalWordmark = _originalWordmark26.default;
	exports.CodeigniterPlain = _plain24.default;
	exports.ChromePlainWordmark = _plainWordmark24.default;
	exports.CodeigniterPlainWordmark = _plainWordmark26.default;
	exports.CoffeescriptOriginal = _original32.default;
	exports.ChromePlain = _plain26.default;
	exports.CouchdbOriginalWordmark = _originalWordmark28.default;
	exports.ConfluenceOriginalWordmark = _originalWordmark30.default;
	exports.ConfluenceOriginal = _original34.default;
	exports.CouchdbOriginal = _original36.default;
	exports.CoffeescriptOriginalWordmark = _originalWordmark32.default;
	exports.CplusplusOriginal = _original38.default;
	exports.CouchdbPlain = _plain28.default;
	exports.CouchdbPlainWordmark = _plainWordmark28.default;
	exports.CplusplusLine = _line8.default;
	exports.CsharpPlain = _plain30.default;
	exports.CplusplusPlain = _plain32.default;
	exports.CsharpOriginal = _original40.default;
	exports.Css3Original = _original42.default;
	exports.CsharpLine = _line10.default;
	exports.Css3Plain = _plain34.default;
	exports.Css3OriginalWordmark = _originalWordmark34.default;
	exports.CucumberPlain = _plain36.default;
	exports.Css3PlainWordmark = _plainWordmark30.default;
	exports.CucumberPlainWordmark = _plainWordmark32.default;
	exports.D3jsOriginal = _original44.default;
	exports.DebianOriginal = _original46.default;
	exports.D3jsPlain = _plain38.default;
	exports.DebianOriginalWordmark = _originalWordmark36.default;
	exports.DeviconOriginal = _original48.default;
	exports.DebianPlain = _plain40.default;
	exports.DeviconOriginalWordmark = _originalWordmark38.default;
	exports.DebianPlainWordmark = _plainWordmark34.default;
	exports.DeviconPlain = _plain42.default;
	exports.DjangoPlain = _plain44.default;
	exports.DeviconPlainWordmark = _plainWordmark36.default;
	exports.DjangoOriginal = _original50.default;
	exports.DockerOriginalWordmark = _originalWordmark40.default;
	exports.DjangoLine = _line12.default;
	exports.DockerOriginal = _original52.default;
	exports.DockerPlainWordmark = _plainWordmark38.default;
	exports.DoctrineOriginal = _original54.default;
	exports.DoctrinePlain = _plain46.default;
	exports.DockerPlain = _plain48.default;
	exports.DoctrineLine = _line14.default;
	exports.DoctrineOriginalWordmark = _originalWordmark42.default;
	exports.DotNetOriginal = _original56.default;
	exports.DoctrinePlainWordmark = _plainWordmark40.default;
	exports.DotNetPlainWordmark = _plainWordmark42.default;
	exports.DoctrineLineWordmark = _lineWordmark6.default;
	exports.DotNetOriginalWordmark = _originalWordmark44.default;
	exports.DotNetPlain = _plain50.default;
	exports.DrupalOriginal = _original58.default;
	exports.ElectronOriginal = _original60.default;
	exports.ElectronOriginalWordmark = _originalWordmark46.default;
	exports.DrupalOriginalWordmark = _originalWordmark48.default;
	exports.ElmOriginal = _original62.default;
	exports.ElmPlainWordmark = _plainWordmark44.default;
	exports.ElmOriginalWordmark = _originalWordmark50.default;
	exports.EmberOriginalWordmark = _originalWordmark52.default;
	exports.DrupalPlainWordmark = _plainWordmark46.default;
	exports.ErlangOriginal = _original64.default;
	exports.ElmPlain = _plain52.default;
	exports.DrupalPlain = _plain54.default;
	exports.ErlangPlainWordmark = _plainWordmark48.default;
	exports.ExpressOriginal = _original66.default;
	exports.ExpressOriginalWordmark = _originalWordmark54.default;
	exports.ErlangPlain = _plain56.default;
	exports.FacebookOriginal = _original68.default;
	exports.FacebookPlain = _plain58.default;
	exports.ErlangOriginalWordmark = _originalWordmark56.default;
	exports.FirefoxOriginalWordmark = _originalWordmark58.default;
	exports.FoundationPlain = _plain60.default;
	exports.FirefoxOriginal = _original70.default;
	exports.FirefoxPlain = _plain62.default;
	exports.FoundationOriginalWordmark = _originalWordmark60.default;
	exports.FoundationOriginal = _original72.default;
	exports.FirefoxPlainWordmark = _plainWordmark50.default;
	exports.GatlingPlain = _plain64.default;
	exports.GimpOriginalWordmark = _originalWordmark62.default;
	exports.FoundationPlainWordmark = _plainWordmark52.default;
	exports.GatlingPlainWordmark = _plainWordmark54.default;
	exports.GimpPlain = _plain66.default;
	exports.GitOriginalWordmark = _originalWordmark64.default;
	exports.GimpOriginal = _original74.default;
	exports.GitPlainWordmark = _plainWordmark56.default;
	exports.GimpPlainWordmark = _plainWordmark58.default;
	exports.GitPlain = _plain68.default;
	exports.GithubOriginal = _original76.default;
	exports.GithubOriginalWordmark = _originalWordmark66.default;
	exports.GitlabPlain = _plain70.default;
	exports.GoOriginal = _original78.default;
	exports.GitlabOriginalWordmark = _originalWordmark68.default;
	exports.GitOriginal = _original80.default;
	exports.GitlabOriginal = _original82.default;
	exports.GoLine = _line16.default;
	exports.GitlabPlainWordmark = _plainWordmark60.default;
	exports.GoPlain = _plain72.default;
	exports.GoogleOriginal = _original84.default;
	exports.GoogleOriginalWordmark = _originalWordmark70.default;
	exports.GradlePlainWordmark = _plainWordmark62.default;
	exports.GradlePlain = _plain74.default;
	exports.GruntOriginal = _original86.default;
	exports.GooglePlain = _plain76.default;
	exports.GruntPlain = _plain78.default;
	exports.GooglePlainWordmark = _plainWordmark64.default;
	exports.GruntLine = _line18.default;
	exports.GulpPlain = _plain80.default;
	exports.GruntPlainWordmark = _plainWordmark66.default;
	exports.HerokuOriginal = _original88.default;
	exports.GruntOriginalWordmark = _originalWordmark72.default;
	exports.HandlebarsOriginalWordmark = _originalWordmark74.default;
	exports.GruntLineWordmark = _lineWordmark8.default;
	exports.HerokuOriginalWordmark = _originalWordmark76.default;
	exports.HandlebarsOriginal = _original90.default;
	exports.HerokuPlain = _plain82.default;
	exports.Html5Original = _original92.default;
	exports.Html5OriginalWordmark = _originalWordmark78.default;
	exports.Html5Plain = _plain84.default;
	exports.Ie10Original = _original94.default;
	exports.HerokuPlainWordmark = _plainWordmark68.default;
	exports.IllustratorLine = _line20.default;
	exports.IllustratorPlain = _plain86.default;
	exports.Html5PlainWordmark = _plainWordmark70.default;
	exports.InkscapeOriginal = _original96.default;
	exports.InkscapeOriginalWordmark = _originalWordmark80.default;
	exports.IntellijOriginal = _original98.default;
	exports.InkscapePlainWordmark = _plainWordmark72.default;
	exports.IntellijOriginalWordmark = _originalWordmark82.default;
	exports.IntellijPlain = _plain88.default;
	exports.InkscapePlain = _plain90.default;
	exports.IonicOriginal = _original100.default;
	exports.IntellijPlainWordmark = _plainWordmark74.default;
	exports.IonicOriginalWordmark = _originalWordmark84.default;
	exports.JavaOriginal = _original102.default;
	exports.JasminePlainWordmark = _plainWordmark76.default;
	exports.JavaOriginalWordmark = _originalWordmark86.default;
	exports.JasminePlain = _plain92.default;
	exports.JavascriptOriginal = _original104.default;
	exports.JavaPlain = _plain94.default;
	exports.JavascriptPlain = _plain96.default;
	exports.JavaPlainWordmark = _plainWordmark78.default;
	exports.JeetOriginalWordmark = _originalWordmark88.default;
	exports.JqueryOriginalWordmark = _originalWordmark90.default;
	exports.JeetOriginal = _original106.default;
	exports.JeetPlainWordmark = _plainWordmark80.default;
	exports.JqueryOriginal = _original108.default;
	exports.JeetPlain = _plain98.default;
	exports.JetbrainsOriginal = _original110.default;
	exports.JqueryPlain = _plain100.default;
	exports.KrakenjsOriginal = _original112.default;
	exports.JetbrainsPlain = _plain102.default;
	exports.JqueryPlainWordmark = _plainWordmark82.default;
	exports.KrakenjsPlain = _plain104.default;
	exports.KrakenjsOriginalWordmark = _originalWordmark92.default;
	exports.LessPlainWordmark = _plainWordmark84.default;
	exports.LinkedinOriginal = _original114.default;
	exports.KrakenjsPlainWordmark = _plainWordmark86.default;
	exports.LaravelPlain = _plain106.default;
	exports.LinkedinOriginalWordmark = _originalWordmark94.default;
	exports.LaravelPlainWordmark = _plainWordmark88.default;
	exports.LinkedinPlain = _plain108.default;
	exports.LinkedinPlainWordmark = _plainWordmark90.default;
	exports.LinuxPlain = _plain110.default;
	exports.MeteorOriginal = _original116.default;
	exports.MochaPlain = _plain112.default;
	exports.MeteorPlain = _plain114.default;
	exports.MeteorOriginalWordmark = _originalWordmark96.default;
	exports.MongodbPlain = _plain116.default;
	exports.MeteorPlainWordmark = _plainWordmark92.default;
	exports.LinuxOriginal = _original118.default;
	exports.MoodleOriginal = _original120.default;
	exports.MongodbOriginal = _original122.default;
	exports.MoodlePlainWordmark = _plainWordmark94.default;
	exports.MongodbOriginalWordmark = _originalWordmark98.default;
	exports.MoodlePlain = _plain118.default;
	exports.MongodbPlainWordmark = _plainWordmark96.default;
	exports.MysqlOriginal = _original124.default;
	exports.MoodleOriginalWordmark = _originalWordmark100.default;
	exports.MysqlPlain = _plain120.default;
	exports.NginxOriginal = _original126.default;
	exports.NodejsOriginal = _original128.default;
	exports.MysqlOriginalWordmark = _originalWordmark102.default;
	exports.NodejsPlain = _plain122.default;
	exports.MysqlPlainWordmark = _plainWordmark98.default;
	exports.NodewebkitPlain = _plain124.default;
	exports.NodejsPlainWordmark = _plainWordmark100.default;
	exports.NodejsOriginalWordmark = _originalWordmark104.default;
	exports.NodewebkitOriginalWordmark = _originalWordmark106.default;
	exports.NodewebkitOriginal = _original130.default;
	exports.NpmOriginalWordmark = _originalWordmark108.default;
	exports.PhotoshopLine = _line22.default;
	exports.OracleOriginal = _original132.default;
	exports.PhpOriginal = _original134.default;
	exports.NodewebkitLine = _line24.default;
	exports.NodewebkitPlainWordmark = _plainWordmark102.default;
	exports.NodewebkitLineWordmark = _lineWordmark10.default;
	exports.PhotoshopPlain = _plain126.default;
	exports.PhpPlain = _plain128.default;
	exports.PhpstormOriginalWordmark = _originalWordmark110.default;
	exports.ProtractorPlainWordmark = _plainWordmark104.default;
	exports.PhpstormPlain = _plain130.default;
	exports.PhpstormOriginal = _original136.default;
	exports.ProtractorPlain = _plain132.default;
	exports.PostgresqlOriginal = _original138.default;
	exports.PostgresqlPlain = _plain134.default;
	exports.PhpstormPlainWordmark = _plainWordmark106.default;
	exports.PythonOriginal = _original140.default;
	exports.PostgresqlPlainWordmark = _plainWordmark108.default;
	exports.PythonOriginalWordmark = _originalWordmark112.default;
	exports.PostgresqlOriginalWordmark = _originalWordmark114.default;
	exports.PythonPlainWordmark = _plainWordmark110.default;
	exports.PycharmOriginal = _original142.default;
	exports.PycharmPlain = _plain136.default;
	exports.PythonPlain = _plain138.default;
	exports.PycharmPlainWordmark = _plainWordmark112.default;
	exports.RailsOriginalWordmark = _originalWordmark116.default;
	exports.AppleOriginal = _original144.default;
	exports.PycharmOriginalWordmark = _originalWordmark118.default;
	exports.RailsPlain = _plain140.default;
	exports.ReactOriginalWordmark = _originalWordmark120.default;
	exports.RailsPlainWordmark = _plainWordmark114.default;
	exports.ReactOriginal = _original146.default;
	exports.RedisOriginal = _original148.default;
	exports.RedhatOriginal = _original150.default;
	exports.RedhatPlain = _plain142.default;
	exports.RedisOriginalWordmark = _originalWordmark122.default;
	exports.RedisPlain = _plain144.default;
	exports.RedhatPlainWordmark = _plainWordmark116.default;
	exports.RedhatOriginalWordmark = _originalWordmark124.default;
	exports.RubyOriginal = _original152.default;
	exports.RubymineOriginal = _original154.default;
	exports.RubyOriginalWordmark = _originalWordmark126.default;
	exports.RubyPlain = _plain146.default;
	exports.RubymineOriginalWordmark = _originalWordmark128.default;
	exports.RubyminePlainWordmark = _plainWordmark118.default;
	exports.RubyminePlain = _plain148.default;
	exports.RubyPlainWordmark = _plainWordmark120.default;
	exports.SafariOriginal = _original156.default;
	exports.SafariPlain = _plain150.default;
	exports.SafariOriginalWordmark = _originalWordmark130.default;
	exports.SequelizeOriginal = _original158.default;
	exports.SassOriginal = _original160.default;
	exports.SafariPlainWordmark = _plainWordmark122.default;
	exports.SequelizeOriginalWordmark = _originalWordmark132.default;
	exports.SafariLineWordmark = _lineWordmark12.default;
	exports.SequelizePlain = _plain152.default;
	exports.SequelizePlainWordmark = _plainWordmark124.default;
	exports.SafariLine = _line26.default;
	exports.SketchOriginal = _original162.default;
	exports.SketchLine = _line28.default;
	exports.SketchOriginalWordmark = _originalWordmark134.default;
	exports.SketchLineWordmark = _lineWordmark14.default;
	exports.SlackOriginal = _original164.default;
	exports.SlackOriginalWordmark = _originalWordmark136.default;
	exports.SourcetreeOriginal = _original166.default;
	exports.SlackPlain = _plain154.default;
	exports.SlackPlainWordmark = _plainWordmark126.default;
	exports.SshOriginal = _original168.default;
	exports.SshOriginalWordmark = _originalWordmark138.default;
	exports.SourcetreeOriginalWordmark = _originalWordmark140.default;
	exports.StylusOriginal = _original170.default;
	exports.SwiftOriginal = _original172.default;
	exports.SwiftPlain = _plain156.default;
	exports.SymfonyOriginal = _original174.default;
	exports.SymfonyOriginalWordmark = _originalWordmark142.default;
	exports.SwiftOriginalWordmark = _originalWordmark144.default;
	exports.TomcatOriginal = _original176.default;
	exports.SwiftPlainWordmark = _plainWordmark128.default;
	exports.TomcatOriginalWordmark = _originalWordmark146.default;
	exports.TomcatLineWordmark = _lineWordmark16.default;
	exports.TomcatLine = _line30.default;
	exports.TravisPlainWordmark = _plainWordmark130.default;
	exports.TrelloPlainWordmark = _plainWordmark132.default;
	exports.TravisPlain = _plain158.default;
	exports.TypescriptOriginal = _original178.default;
	exports.TrelloPlain = _plain160.default;
	exports.TwitterOriginal = _original180.default;
	exports.UbuntuPlain = _plain162.default;
	exports.TypescriptPlain = _plain164.default;
	exports.UbuntuPlainWordmark = _plainWordmark134.default;
	exports.VagrantOriginalWordmark = _originalWordmark148.default;
	exports.VagrantOriginal = _original182.default;
	exports.VimOriginal = _original184.default;
	exports.VimPlain = _plain166.default;
	exports.VisualstudioPlain = _plain168.default;
	exports.VagrantPlainWordmark = _plainWordmark136.default;
	exports.VagrantPlain = _plain170.default;
	exports.VuejsOriginal = _original186.default;
	exports.VisualstudioPlainWordmark = _plainWordmark138.default;
	exports.VuejsOriginalWordmark = _originalWordmark150.default;
	exports.VuejsPlain = _plain172.default;
	exports.WebpackOriginal = _original188.default;
	exports.VuejsLine = _line32.default;
	exports.VuejsPlainWordmark = _plainWordmark140.default;
	exports.WebpackOriginalWordmark = _originalWordmark152.default;
	exports.WebpackPlain = _plain174.default;
	exports.VuejsLineWordmark = _lineWordmark18.default;
	exports.WebpackPlainWordmark = _plainWordmark142.default;
	exports.WebstormOriginal = _original190.default;
	exports.Windows8Original = _original192.default;
	exports.WebstormOriginalWordmark = _originalWordmark154.default;
	exports.WebstormPlain = _plain176.default;
	exports.Windows8OriginalWordmark = _originalWordmark156.default;
	exports.WordpressOriginal = _original194.default;
	exports.WordpressPlainWordmark = _plainWordmark144.default;
	exports.WebstormPlainWordmark = _plainWordmark146.default;
	exports.RedisPlainWordmark = _plainWordmark148.default;
	exports.YarnOriginal = _original196.default;
	exports.WordpressPlain = _plain178.default;
	exports.YiiOriginal = _original198.default;
	exports.YarnOriginalWordmark = _originalWordmark158.default;
	exports.YiiPlain = _plain180.default;
	exports.ZendPlain = _plain182.default;
	exports.ZendPlainWordmark = _plainWordmark150.default;
	exports.YiiOriginalWordmark = _originalWordmark160.default;
	exports.YiiPlainWordmark = _plainWordmark152.default;

/***/ }),

/***/ "../src/components/inkscape/original-wordmark/InkscapeOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _InkscapeOriginalWordmark = __webpack_require__("../src/components/inkscape/original-wordmark/InkscapeOriginalWordmark.svg");
	
	var _InkscapeOriginalWordmark2 = _interopRequireDefault(_InkscapeOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** InkscapeOriginalWordmark */
	function InkscapeOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'InkscapeOriginalWordmark',
	    svg: _InkscapeOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	InkscapeOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = InkscapeOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/inkscape/original-wordmark/InkscapeOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><path d=\"M13.5 120.7c1-.1 1.6-.6 1.6-1.4v-10.5c0-1.1 0-1.3-1.6-1.6v-.6h1.7c2 0 2.5-.1 2.5-.1l.1.1s-.7.8-.7 2.7v10c0 .6-.1 1.1-.1 1.1l2.1.2-.1.6-5.4.1v-.6zm7.3 0c1-.1 1.6-.6 1.6-1.4v-9.9c0-1.5-.4-2-1.8-2.2v-.6h.7c1.1 0 2.2-.1 2.2-.1s.3.5.8 1.1l8 9.2.9 1.2v-9.2c0-1 0-1.5-1.8-1.7v-.6h4.2l.1.3s-1.5.4-1.5 2.2v12.2h-.6l-9.4-11c-.3-.3-.6-.7-.8-1.1v10c0 .7-.1 1.2-.1 1.2l2 .1-.1.6-4.3.1v-.4zm16.9 0c1-.1 1.6-.6 1.6-1.4v-10.5c0-1.1 0-1.3-1.6-1.6v-.6h1.7c2 0 2.5-.1 2.5-.1l.1.1s-.7.8-.7 2.7v3.9h.4s.4-.2.7-.6l4.3-4.3c.4-.4.4-1-.6-1.1v-.6h4.1l.1.3s-1.2.3-2.8 1.9l-4.2 4.1v.2l5.3 6.1c1 1.1 1.2 1.2 1.9 1.3h.2l-.1.7h-3.2l-.1-.1s-.2-.7-1.7-2.3l-4.1-4.8h-.4v5.2c0 .6-.1 1.1-.1 1.1l2 .2-.1.6-5.3.1v-.5zm14.4-3.3h.7c0 2.7 1.7 3.4 3.2 3.4 1.4 0 2.8-.6 2.8-2.3 0-3.8-6.9-3.8-6.9-8.2 0-2.2 1.6-3.8 4.9-3.8 1.6 0 3.1.4 3.6.4l-.7 3.4H59c.2-1.6-.6-3-2.5-3-1.5 0-2.7.7-2.7 2.3 0 3.9 6.9 3.5 6.9 8.2 0 2.6-2.3 3.9-4.9 3.9-1.9 0-4.2-.7-4.2-2.3 0-.4.1-.7.5-2zm18.7-11c1.6 0 3.6.4 4.8.5l-.7 3.3h-.7c0-2.3-1.9-3-3.7-3-3.4 0-5.6 2.7-5.6 6.3 0 4 2.8 6.6 6.4 6.6 2.8 0 4.4-1.6 4.4-1.6l.3.5s-1.7 2.6-5.5 2.6c-3.9 0-7.7-2.7-7.7-7.4 0-4.5 3.3-7.8 8-7.8zm5.6 14.3c.9-.1 1.3-.5 1.5-1l5.2-13 .9-.2 4.9 12.5c.6 1.5 1 1.6 1.7 1.7l-.1.6h-.9c-.8 0-3.3.1-3.3.1v-.7c.6 0 1.2-.2.9-.9l-1.3-3.5h-5.3l-.3.2-1.5 4 1.9.3-.1.6h-4.1v-.7zm6.7-11.7l-2.4 6.4h4.8l-1.9-5c-.2-.5-.4-1.1-.5-1.4zm8.5 11.7c1-.1 1.6-.6 1.6-1.4v-10.5c0-1.1-.1-1.3-1.8-1.6v-.6h5.5c2.5 0 5.4.8 5.4 4 0 3.5-3.3 4.7-5.7 4.5v-.6c2.6-.1 3.5-1.7 3.5-3.4 0-2.6-2.1-3.7-4.4-3.7h-.3l-.2.2v11.6c0 .6-.1 1.1-.1 1.1l2.1.2-.1.6-5.4.1v-.5zm12.4 0c1-.1 1.6-.6 1.6-1.4v-10.5c0-1.1-.1-1.3-1.8-1.6v-.6h9.1c.9 0 1.6-.1 1.6-.1l-.7 3.7h-.8c.1-2.3-.6-2.7-2.4-2.7h-2.9l-.2.2v5.7h4.1l.2-1.3.8-.1v3.9h-1v-1.6h-3.8l-.2.2v4.7c0 .7-.1 1.2-.1 1.2h3.5c1.9 0 2.2-.4 3.3-2.7h.7l-.8 3.6h-6.9c-1.1 0-3.2.1-3.2.1v-.7z\"/><g transform=\"matrix(.994 0 0 .994 .389 -1.445)\"><g opacity=\".783\"><path d=\"M55.1 8.288l-37.2 38.1c-14.1 14.1 9.1 12.9 17.5 18.2 3.9 2.5-12.5 5.8-9.1 9.1l22.8 9.7c3.2 3.3-6.6 6.9-3.3 10.2 3.2 3.3 10.7.2 12.1 7.8 1 5.6 13.9 2.8 19.7-2l-3-6.4c8.1-8.2 15.3-3.7 18.3-11.3 1.6-4.1-12.3-6.9-8.6-9.6 8.8-6.2 41.3-9.4 26.3-24.4l-38.5-39.4c-4.8-4.5-12.6-4.5-17 0zm42.6 73.4c0 1.9 14.7 3 13.9-.5-1.1-5.7-12.2-5.3-13.9.5zm-62.7 10c3.3 2.9 8.4-.6 10-4.7-3.2-4.2-15.2.3-10 4.7zm60.9-6c-4.2 3.8.7 7.8 4.8 5.1 1.1-.7-.1-4.2-4.8-5.1z\"/><path opacity=\".576\" d=\"M55.1 9.188l-37.2 38.1c-14.1 14.1 9.1 12.9 17.5 18.2 3.9 2.5-12.5 5.8-9.1 9.1l22.8 9.7c3.2 3.3-6.6 6.9-3.3 10.2 3.2 3.3 10.7.2 12.1 7.8 1 5.6 13.9 2.8 19.7-2l-3-6.4c8.1-8.2 15.3-3.7 18.3-11.3 1.6-4.1-12.3-6.9-8.6-9.6 8.8-6.2 41.3-9.4 26.3-24.4l-38.5-39.4c-4.8-4.5-12.6-4.5-17 0zm42.6 73.4c0 1.9 14.7 3 13.9-.5-1.1-5.8-12.2-5.3-13.9.5zm-62.7 10c3.3 2.9 8.4-.6 10-4.7-3.2-4.3-15.2.3-10 4.7zm60.9-6.1c-4.2 3.8.7 7.8 4.8 5.1 1.1-.6-.1-4.2-4.8-5.1z\"/></g><path d=\"M55.1 7.4L17.9 45.5C3.8 59.6 27 58.4 35.4 63.7c3.9 2.5-12.5 5.8-9.1 9.1l22.8 9.7c3.2 3.3-6.6 6.9-3.3 10.2 3.2 3.3 10.7.2 12.1 7.8 1 5.6 13.9 2.8 19.7-2l-3-6.4c8.1-8.2 15.3-3.7 18.3-11.3 1.6-4.1-12.3-6.9-8.6-9.6 8.8-6.2 41.3-9.4 26.3-24.4L72.1 7.4c-4.8-4.5-12.6-4.5-17 0zm42.6 73.4c0 1.9 14.7 3 13.9-.5-1.1-5.7-12.2-5.3-13.9.5zM35 90.8c3.3 2.9 8.4-.6 10-4.7-3.2-4.2-15.2.3-10 4.7zm60.9-6c-4.2 3.8.7 7.8 4.8 5.1 1.1-.7-.1-4.2-4.8-5.1z\"/><path d=\"M55.1 7.4L17.9 45.5C3.8 59.6 27 58.4 35.4 63.7c3.9 2.5-12.5 5.8-9.1 9.1l22.8 9.7c3.2 3.3-6.6 6.9-3.3 10.2 3.2 3.3 10.7.2 12.1 7.8 1 5.6 13.9 2.8 19.7-2l-3-6.4c8.1-8.2 15.3-3.7 18.3-11.3 1.6-4.1-12.3-6.9-8.6-9.6 8.8-6.2 41.3-9.4 26.3-24.4L72.1 7.4c-4.8-4.5-12.6-4.5-17 0zm42.6 73.4c0 1.9 14.7 3 13.9-.5-1.1-5.7-12.2-5.3-13.9.5zM35 90.8c3.3 2.9 8.4-.6 10-4.7-3.2-4.2-15.2.3-10 4.7zm60.9-6c-4.2 3.8.7 7.8 4.8 5.1 1.1-.7-.1-4.2-4.8-5.1z\" fill=\"none\"/><defs><path id=\"a\" d=\"M55.2 7.9L18.3 45.6c-13.9 13.9 9 12.8 17.3 18.1 3.8 2.5-12.3 5.7-9 9C29.9 76 46 79 49.3 82.2L46 92.3c3.1 3.3 10.6.2 12 7.7 1 5.5 13.8 2.8 19.5-2 3.6-3-6.2-3-2.9-6.3 8-8.1 15.2-3.7 18.1-11.2 1.6-4-12.2-6.9-8.5-9.5 8.8-6.2 40.9-9.3 26.1-24.1L72 7.9c-4.7-4.5-12.5-4.5-16.8 0zm-8.9 57.8c.8 0 27.5 3.6 17.2 6.3-3.9 1.1-21.9-6.3-17.2-6.3zm51.1 14.8c0 1.9 14.6 2.9 13.8-.4-1.2-5.7-12.2-5.3-13.8.4zm-62.1 10c3.3 2.9 8.3-.6 9.9-4.6-3.2-4.3-15.1.2-9.9 4.6zm60.3-6c-4.1 3.8.7 7.7 4.7 5.1 1.1-.8 0-4.2-4.7-5.1z\"/></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"/></clipPath><g transform=\"matrix(.991 0 0 .991 .605 .604)\" clip-path=\"url(#b)\"><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"91.626\" y1=\"-56.37\" x2=\"71.669\" y2=\"-74.414\" gradientTransform=\"matrix(.985 0 0 -.985 6.128 -23.064)\"><stop offset=\"0\" stop-color=\"#C0CDF9\"/><stop offset=\"1\" stop-color=\"#07092D\" stop-opacity=\".288\"/></linearGradient><path fill=\"url(#c)\" d=\"M55.2 7.9L18.3 45.6c-13.9 13.9 9 12.8 17.3 18.1 3.8 2.5-12.3 5.7-9 9C29.9 76 46 79 49.3 82.2L46 92.3c3.1 3.3 10.6.2 12 7.7 1 5.5 13.8 2.8 19.5-2 3.6-3-6.2-3-2.9-6.3 8-8.1 15.2-3.7 18.1-11.2 1.6-4-12.2-6.9-8.5-9.5 8.8-6.2 40.9-9.3 26.1-24.1L72 7.9c-4.7-4.5-12.5-4.5-16.8 0zm-8.9 57.8c.8 0 27.5 3.6 17.2 6.3-3.9 1.1-21.9-6.3-17.2-6.3zm51.1 14.8c0 1.9 14.6 2.9 13.8-.4-1.2-5.7-12.2-5.3-13.8.4zm-62.1 10c3.3 2.9 8.3-.6 9.9-4.6-3.2-4.3-15.1.2-9.9 4.6zm60.3-6c-4.1 3.8.7 7.7 4.7 5.1 1.1-.8 0-4.2-4.7-5.1z\"/></g><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"38.411\" y1=\"-47.051\" x2=\"60.967\" y2=\"-69.606\" gradientTransform=\"matrix(1.003 0 0 -1.003 -.413 -21.676)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".505\" fill=\"url(#d)\" d=\"M21.2 47.6c-10.1 10 7.6 7.2 21.3 12.6l28.2-49.6c-4.3-4.4-9.7-4-13.7 0l-35.8 37z\"/><linearGradient id=\"e\" gradientUnits=\"userSpaceOnUse\" x1=\"50.814\" y1=\"-44.11\" x2=\"77.881\" y2=\"-71.177\" gradientTransform=\"matrix(.994 0 0 -.994 2.709 -22.463)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#e)\" d=\"M69.9 10.1l14.7 15c1.4 1.4 1.4 4.2.5 5l-7.3-6-1.4 8.8-6-3.2-9.8 6.2-3.2-13.1L52 34.1 38.9 34c-2.5 0-2.2-2.6.5-5.2 5.1-5.7 15.2-15.3 18.3-18.7 3.2-3.3 8.9-3.2 12.2 0z\"/><radialGradient id=\"f\" cx=\"55.343\" cy=\"-368.06\" r=\"27.608\" gradientTransform=\"matrix(.827 0 0 -.553 1.123 -104.537)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path opacity=\".217\" fill=\"url(#f)\" d=\"M49.7 80.9s1.6 2.4 1.4 3.6c-.3 2.3-5.2 3.4-4.1 5.4 1.1 2 4.9.9 8.1 2.9 3.2 2.1 2.3 6.3 4.7 7.3 4.5 2.1 16.4-3.6 15.8-3.4-.6.1-11.7 2.4-14.2.4-2.9-2.3-3.7-3.9-5.8-5.3-2-1.3-4.8-1.8-5.4-2.9-.6-1.1 1.3-2.4 1.4-4.4.1-1.2-1.9-3.6-1.9-3.6z\"/><g opacity=\".276\"><radialGradient id=\"g\" cx=\"148.42\" cy=\"-316.346\" r=\"27.608\" gradientTransform=\"matrix(1.055 0 0 -.706 -97.55 -123.665)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#g)\" d=\"M49.7 80.9s1.6 2.4 1.4 3.6c-.3 2.3-5.2 3.4-4.1 5.4 1.1 2 4.9.9 8.1 2.9 3.2 2.1 2.3 6.3 4.7 7.3 4.5 2.1 16.4-3.6 15.8-3.4-19.8.1-16.1-5-23.7-8.4-1.1-.5-.5-1.8-.3-3.8.1-1.2-1.9-3.6-1.9-3.6z\"/></g><radialGradient id=\"h\" cx=\"-66.136\" cy=\"-663.625\" r=\"30.901\" gradientTransform=\"matrix(.526 0 0 -.223 130.969 -83.733)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path opacity=\".453\" fill=\"url(#h)\" d=\"M83.2 70.5c17.7-6.5 23.4-7.4 29.3-13.3-6.7 5.8-21.1 8.8-32.7 13.9l3.4-.6z\"/><g opacity=\".512\"><radialGradient id=\"i\" cx=\"-59.555\" cy=\"-676.361\" r=\"30.901\" gradientTransform=\"matrix(.526 0 0 -.223 130.969 -84.659)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#i)\" d=\"M83.2 69.7c29.2-10.3 24.3-10.3 29.3-13.3-9.3 3.6-26.6 3.9-32.7 13.9l3.4-.6z\"/></g><linearGradient id=\"j\" gradientUnits=\"userSpaceOnUse\" x1=\"-48.211\" y1=\"-329.198\" x2=\"-48.099\" y2=\"-334.893\" gradientTransform=\"matrix(.526 0 0 -.526 130.306 -97.198)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".286\" fill=\"url(#j)\" d=\"M108.8 77.9c0 .6-1.7 1.2-3.8 1.2-2.1 0-3.8-.5-3.8-1.2 0-.6 1.7-1.2 3.8-1.2 2.1.1 3.8.6 3.8 1.2z\"/><g opacity=\".621\"><linearGradient id=\"k\" gradientUnits=\"userSpaceOnUse\" x1=\"100.816\" y1=\"-189.809\" x2=\"100.816\" y2=\"-193.824\" gradientTransform=\"matrix(.709 0 0 -1.134 33.501 -139.476)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#k)\" d=\"M110.1 79.3c0 1.4-2.3 2.5-5.1 2.5s-5.1-1.1-5.1-2.5 2.3-2.5 5.1-2.5 5.1 1.1 5.1 2.5z\"/></g><radialGradient id=\"l\" cx=\"-49.825\" cy=\"-1837.368\" r=\"12.716\" gradientTransform=\"matrix(.526 0 0 -.078 130.969 -61.714)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#l)\" d=\"M98 80.7c1.8 1.7 11.8 2.5 13.5-.5-3.2 2.3-10.4 1.5-13.5.5z\"/><linearGradient id=\"m\" gradientUnits=\"userSpaceOnUse\" x1=\"-930.712\" y1=\"-38.355\" x2=\"-930.6\" y2=\"-44.05\" gradientTransform=\"matrix(.203 -.103 -.238 -.469 275.813 -28.596)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".286\" fill=\"url(#m)\" d=\"M98 86.2c.4.7.1 1.6-.5 1.9-.7.3-1.5 0-1.9-.7-.4-.7-.1-1.6.5-1.9s1.6 0 1.9.7z\"/><g opacity=\".621\"><linearGradient id=\"n\" gradientUnits=\"userSpaceOnUse\" x1=\"-554.563\" y1=\"-54.844\" x2=\"-554.563\" y2=\"-58.859\" gradientTransform=\"matrix(.273 -.139 -.513 -1.011 218.865 -48.039)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#n)\" d=\"M98.8 86.6c.6 1.1.2 2.4-.8 2.9s-2.2 0-2.7-1.1c-.6-1.2-.3-2.4.7-2.9s2.2 0 2.8 1.1z\"/></g><radialGradient id=\"o\" cx=\"-932.326\" cy=\"131.174\" r=\"12.716\" gradientTransform=\"matrix(.203 -.103 -.035 -.069 292.115 2.923)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#o)\" d=\"M95.5 89.6c1.4 1.1 6.9 1.3 4.8-2 .6 2.6-3.1 2.3-4.8 2z\"/><radialGradient id=\"p\" cx=\"-175.404\" cy=\"-702.254\" r=\"20.526\" gradientTransform=\"matrix(.526 0 0 -.214 130.969 -74.982)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\" stop-opacity=\".33\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#p)\" d=\"M28.3 72.5c0-.3 18.6 5.7 21.7 8.8-2.6-2.6-15.8-8.4-17.9-8.5-1.9 0-3.6-.1-3.8-.3z\"/><g transform=\"matrix(.879 -.193 .234 .696 -20.21 36.726)\"><linearGradient id=\"q\" gradientUnits=\"userSpaceOnUse\" x1=\"-46.833\" y1=\"-423.586\" x2=\"-46.72\" y2=\"-429.281\" gradientTransform=\"matrix(.463 .102 .123 -.366 118.863 -68.93)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".286\" fill=\"url(#q)\" d=\"M48.9 83.3c0 .6-1.7 1.2-3.8 1.2-2.1 0-3.8-.5-3.8-1.2 0-.6 1.7-1.2 3.8-1.2s3.8.6 3.8 1.2z\"/><g opacity=\".621\"><linearGradient id=\"r\" gradientUnits=\"userSpaceOnUse\" x1=\"107.319\" y1=\"-242.262\" x2=\"107.319\" y2=\"-246.277\" gradientTransform=\"matrix(.623 .219 .166 -.789 18.372 -133.516)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#r)\" d=\"M50.2 84.7c0 1.4-2.3 2.5-5.1 2.5S40 86.1 40 84.7s2.3-2.5 5.1-2.5 5.1 1.1 5.1 2.5z\"/></g></g><g opacity=\".616\"><radialGradient id=\"s\" cx=\"-108.767\" cy=\"-316.224\" r=\"9.445\" gradientTransform=\"matrix(.624 -.173 -.065 -.233 86.317 -1.652)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#s)\" d=\"M34.2 88.3s1 2.7 3.8 2.8c2.8.1 6-3.3 6.2-4.6-.5 1.1-3.1 4.3-6.6 4.3-1.9 0-3.4-2.5-3.4-2.5z\"/></g><radialGradient id=\"t\" cx=\"192.543\" cy=\"21.454\" r=\"49.468\" gradientTransform=\"matrix(1.712 0 0 -1.685 -261.607 52.03)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path stroke=\"url(#t)\" stroke-width=\".488\" d=\"M63.5 5.4c-2.8 0-5.5 1-7.5 3l-37.2 38c-3.4 3.4-4.2 5.6-4 6.9.1.6.4 1.2 1.1 1.7.7.6 1.7 1.1 2.8 1.6 2.4 1 5.6 1.8 8.8 2.7s6.3 1.8 8.6 3.3c.4.2.7.5.9.9.2.4.3 1 .2 1.4-.2.9-.8 1.4-1.3 1.8-1.1.9-2.7 1.6-4.3 2.4s-3.2 1.6-4 2.2c-.4.3-.5.6-.5.6s-.1-.2.1-.1c.5.5 2.1 1.4 4 2.2s4.4 1.6 6.9 2.4c2.4.8 4.9 1.6 7 2.4 2.1.8 3.8 1.6 4.9 2.7.6.6 1 1.3 1 2 .1.7-.1 1.4-.4 2-.6 1.2-1.5 2-2.3 2.9-.8.9-1.6 1.7-1.8 2.2-.1.3-.2.5-.1.6s0 .2.3.5c1.1 1.1 3.4 1.3 6.1 1.9 1.3.3 2.7.8 3.9 1.8 1.2 1 2.1 2.6 2.5 4.7.2.9.6 1.3 1.8 1.7 1.1.4 2.9.4 4.8.1 3.8-.6 8.4-2.4 11-4.6.2-.1.1-.1.2-.2-.2-.1-.6-.4-1.3-.7-.8-.4-1.8-.8-2.5-1.7-.4-.5-.6-1.2-.5-1.9.1-.7.5-1.3 1-1.8 4.3-4.3 8.5-5.4 11.7-6.2 1.6-.4 2.9-.8 3.9-1.4 1-.6 1.8-1.5 2.5-3.2.1-.2.1-.2 0-.5s-.4-.6-.8-.9c-.8-.7-2.3-1.5-3.7-2.3-1.4-.8-2.8-1.5-3.7-2.4-.5-.5-1-1-1.1-1.9-.1-.9.5-1.7 1.2-2.1 2.5-1.7 6.2-3.1 10.3-4.5 4.1-1.4 8.4-2.9 12-4.5 3.6-1.7 6.2-3.6 7-5.5.4-1 .5-1.9.1-3.2-.4-1.3-1.4-2.8-3.2-4.6L71.2 8.4c-2.1-2-5-3-7.7-3zm41.4 72.2c-2.4.1-4.6 1.2-5.5 2.9.3.1.5.2.9.3 1.2.3 3 .5 4.7.5 1.7 0 3.4-.1 4.5-.4.5-.1.7-.3.8-.3-.2-1-.8-1.7-1.7-2.2-1-.6-2.3-.9-3.7-.8zm-63.6 8.1c-1.9-.1-4.3.6-5.4 1.6-.6.5-.8.9-.8 1.2 0 .3.1.7.8 1.3 1.2 1.1 2.6.9 4.2.1 1.3-.7 2.5-2.1 3.3-3.5-.6-.3-1.2-.6-2.1-.7zm55 .6c-.4.5-.6 1-.6 1.3 0 .5.1.8.5 1.2.7.6 2.1.9 3.6.1 0-.2-.1-.4-.3-.8-.5-.6-1.6-1.3-3.2-1.8z\" fill=\"none\"/><g opacity=\".325\"><linearGradient id=\"u\" gradientUnits=\"userSpaceOnUse\" x1=\"-216.308\" y1=\"-354.586\" x2=\"-163.979\" y2=\"-368.423\" gradientTransform=\"matrix(.485 0 0 -.485 149.184 -95.38)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#u)\" d=\"M43.1 65c-2.2.7-9.5 3.4-8.5 5.5 1 2 17.9 2.8 20.5 8.8 1.1 2.6-2.6 4.6-1.7 7.3.7 2.1 6.3 7.3 9.9 9.7 2.8 1.9 6.5-1.6 5-4.4-2.4-4.6 8.1-10.2 12.9-12.8 2.8-1.5-5.7-8.8-5.7-8.8L43.1 65z\"/></g><linearGradient id=\"v\" gradientUnits=\"userSpaceOnUse\" x1=\"15.146\" y1=\"-105.339\" x2=\"11.904\" y2=\"-112.767\" gradientTransform=\"matrix(.88 0 0 -.88 42.035 -27.857)\"><stop offset=\"0\" stop-color=\"#EEEEEC\"/><stop offset=\"1\" stop-color=\"#EEEEEC\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#v)\" d=\"M43.9 67c2 1.5 6 .6 8.4 1.7 5.7 2.6 12.8 5.5 11.5.4l-1.5 1.2V68l-3.4.8s-2.6-2.1-3.8-2.8c-.3-.1-1.5 1.2-1.5 1.2l-.2-1.4c-1.7-.2-3.3-.3-4.8-.2-3.6-.1-6 .5-4.7 1.4z\"/><g opacity=\".478\"><radialGradient id=\"w\" cx=\"21.139\" cy=\"-251.475\" r=\"20.27\" gradientTransform=\"matrix(.656 0 0 -.834 66.991 -125.902)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#w)\" d=\"M81.5 71.7c-.8 2.9 9.5 6.7 8.8 8.7-1.7 4.3-11 1.4-18.1 10.5-1 1.3 1.4 5.9 1.1 5.4s-2.8-4.4-2.2-6.3c2-5.9 21.6-8.1 18-11-2.1-1.6-9.5-6.1-7.6-7.3z\"/></g><path opacity=\".586\" fill=\"#fff\" d=\"M104.7 77.6c0 .3-.5.5-1.1.5-.6 0-1.1-.2-1.1-.5s.5-.5 1.1-.5c.6 0 1.1.2 1.1.5zM97.2 86.2c0 .3-.3.5-.7.5-.4 0-.7-.2-.7-.5s.3-.5.7-.5c.3 0 .7.3.7.5zM40.1 85.8c0 .3-.6.5-1.3.5-.7 0-1.3-.2-1.3-.5s.6-.5 1.3-.5c.7 0 1.3.2 1.3.5z\"/><linearGradient id=\"x\" gradientUnits=\"userSpaceOnUse\" x1=\"-233.056\" y1=\"-336.04\" x2=\"-224.899\" y2=\"-342.521\" gradientTransform=\"matrix(.49 0 0 -.49 147.66 -96.827)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".251\" fill=\"url(#x)\" d=\"M39.3 65.2c-6.5 4-16.5 5.4-5.5 8.1-1.3-2.9 2.9-2.6 5.5-8.1z\"/><g opacity=\".363\"><linearGradient id=\"y\" gradientUnits=\"userSpaceOnUse\" x1=\"-125.584\" y1=\"-365.933\" x2=\"-150.045\" y2=\"-300.07\" gradientTransform=\"matrix(.485 0 0 -.485 149.184 -95.38)\"><stop offset=\"0\" stop-color=\"#729FCF\"/><stop offset=\"1\" stop-color=\"#729FCF\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#y)\" d=\"M62.3 101.6s10-.9 12.3-3.8c1.3-1.7-5.4-3.6-3.9-5.3 5.4-6.2 10-5.9 16.3-8.5s4-3.9 1.9-5c-3.5-2-11.3-4-8.7-8.7 2.6-4.7 25.3-11.1 25.3-11.1 6.9-2.3 6-6.6 2.6-10.1L87.8 28.9s1 19.1-3.1 27.3c-5.1 10.1-32 21.4-20.7 22.7 4 .4 5.9 1.8 7.5 4.8 3.3 6.3-9.2 17.9-9.2 17.9z\"/></g></g></svg>"

/***/ }),

/***/ "../src/components/inkscape/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _InkscapeOriginalWordmark = __webpack_require__("../src/components/inkscape/original-wordmark/InkscapeOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InkscapeOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/inkscape/original/InkscapeOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _InkscapeOriginal = __webpack_require__("../src/components/inkscape/original/InkscapeOriginal.svg");
	
	var _InkscapeOriginal2 = _interopRequireDefault(_InkscapeOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** InkscapeOriginal */
	function InkscapeOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'InkscapeOriginal',
	    svg: _InkscapeOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	InkscapeOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = InkscapeOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/inkscape/original/InkscapeOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><g transform=\"matrix(.994 0 0 .994 .389 -1.445)\"><g opacity=\".783\"><path d=\"M53.3 10.088l-44.8 45.8c-16.9 16.9 11 15.5 21.1 21.9 4.7 3-15 6.9-11 11 3.9 4 23.6 7.7 27.5 11.6 3.9 4-7.9 8.2-4 12.3 3.8 4 12.9.2 14.5 9.3 1.2 6.7 16.7 3.4 23.7-2.4 4.3-3.7-7.5-3.7-3.6-7.7 9.8-9.9 18.5-4.5 22-13.6 2-4.9-14.8-8.4-10.3-11.5 10.7-7.5 49.7-11.3 31.7-29.3l-46.3-47.4c-5.8-5.4-15.2-5.4-20.5 0zm51.3 88.2c0 2.3 17.7 3.6 16.7-.5-1.4-7-14.8-6.4-16.7.5zm-75.4 12.1c4 3.5 10.1-.8 12-5.6-3.9-5.2-18.3.2-12 5.6zm73.2-7.3c-5 4.6.9 9.3 5.8 6.2 1.3-.9-.1-5.1-5.8-6.2z\"/><path opacity=\".576\" d=\"M53.3 11.088l-44.8 45.8c-16.9 17 11 15.6 21.1 22 4.7 3-15 6.9-11 11 3.9 4 23.6 7.7 27.5 11.6 3.9 4-7.9 8.2-4 12.3 3.8 4 12.9.2 14.5 9.3 1.2 6.7 16.7 3.4 23.7-2.4 4.3-3.7-7.5-3.7-3.6-7.7 9.8-9.9 18.5-4.5 22-13.6 2-4.9-14.8-8.4-10.3-11.5 10.6-7.5 49.7-11.3 31.7-29.3l-46.3-47.5c-5.8-5.4-15.2-5.4-20.5 0zm51.3 88.3c0 2.3 17.7 3.6 16.7-.5-1.4-7-14.8-6.5-16.7.5zm-75.4 12c4 3.5 10.1-.8 12-5.6-3.9-5.1-18.3.3-12 5.6zm73.2-7.2c-5 4.6.9 9.3 5.8 6.2 1.3-.9-.1-5.2-5.8-6.2z\"/></g><path d=\"M53.3 9L8.5 54.8c-16.9 16.9 11 15.5 21.1 21.9 4.7 3-15 6.9-11 11 3.9 4 23.6 7.7 27.5 11.6 3.9 4-7.9 8.2-4 12.3 3.8 4 12.9.2 14.5 9.3 1.2 6.7 16.7 3.4 23.7-2.4 4.3-3.7-7.5-3.7-3.6-7.7 9.8-9.9 18.5-4.5 22-13.6 2-4.9-14.8-8.4-10.3-11.5 10.6-7.5 49.7-11.3 31.7-29.3L73.8 9C68 3.6 58.6 3.6 53.3 9zm51.3 88.2c0 2.3 17.7 3.6 16.7-.5-1.4-6.9-14.8-6.4-16.7.5zm-75.4 12.1c4 3.5 10.1-.8 12-5.6-3.9-5.2-18.3.3-12 5.6zm73.2-7.3c-5 4.6.9 9.3 5.8 6.2 1.3-.9-.1-5.1-5.8-6.2z\"/><path d=\"M53.3 9L8.5 54.8c-16.9 16.9 11 15.5 21.1 21.9 4.7 3-15 6.9-11 11 3.9 4 23.6 7.7 27.5 11.6 3.9 4-7.9 8.2-4 12.3 3.8 4 12.9.2 14.5 9.3 1.2 6.7 16.7 3.4 23.7-2.4 4.3-3.7-7.5-3.7-3.6-7.7 9.8-9.9 18.5-4.5 22-13.6 2-4.9-14.8-8.4-10.3-11.5 10.6-7.5 49.7-11.3 31.7-29.3L73.8 9C68 3.6 58.6 3.6 53.3 9zm51.3 88.2c0 2.3 17.7 3.6 16.7-.5-1.4-6.9-14.8-6.4-16.7.5zm-75.4 12.1c4 3.5 10.1-.8 12-5.6-3.9-5.2-18.3.3-12 5.6zm73.2-7.3c-5 4.6.9 9.3 5.8 6.2 1.3-.9-.1-5.1-5.8-6.2z\" fill=\"none\"/><defs><path id=\"a\" d=\"M53.4 9.5L9.1 54.9C-7.7 71.7 19.9 70.3 29.9 76.6c4.6 3-14.8 6.9-10.9 10.9 3.9 4 23.3 7.6 27.2 11.5 3.9 4-7.8 8.2-4 12.1 3.8 4 12.8.2 14.4 9.2 1.2 6.7 16.6 3.3 23.4-2.4l-3.5-7.6c9.7-9.8 18.3-4.4 21.8-13.4 1.9-4.8-14.6-8.3-10.2-11.4 10.5-7.4 49.2-11.2 31.4-29l-45.9-47c-5.6-5.3-15-5.3-20.2 0zM42.7 79.1c1 0 33.1 4.3 20.7 7.6-4.7 1.3-26.4-7.6-20.7-7.6zm61.5 17.8c0 2.3 17.5 3.5 16.6-.5-1.4-6.9-14.7-6.3-16.6.5zm-74.7 12c4 3.4 10-.8 11.9-5.6-3.8-5.1-18.1.3-11.9 5.6zm72.6-7.2c-4.9 4.5.9 9.2 5.7 6.1 1.2-.9-.2-5.1-5.7-6.1z\"/></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"/></clipPath><g transform=\"matrix(.991 0 0 .991 .605 .604)\" clip-path=\"url(#b)\"><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"98.293\" y1=\"237.026\" x2=\"74.286\" y2=\"215.319\" gradientTransform=\"matrix(.985 0 0 -.985 6.128 272.439)\"><stop offset=\"0\" stop-color=\"#C0CDF9\"/><stop offset=\"1\" stop-color=\"#07092D\" stop-opacity=\".288\"/></linearGradient><path fill=\"url(#c)\" d=\"M53.4 9.5L9.1 54.9C-7.7 71.7 19.9 70.3 29.9 76.6c4.6 3-14.8 6.9-10.9 10.9 3.9 4 23.3 7.6 27.2 11.5 3.9 4-7.8 8.2-4 12.1 3.8 4 12.8.2 14.4 9.2 1.2 6.7 16.6 3.3 23.4-2.4l-3.5-7.6c9.7-9.8 18.3-4.4 21.8-13.4 1.9-4.8-14.6-8.3-10.2-11.4 10.5-7.4 49.2-11.2 31.4-29l-45.9-47c-5.6-5.3-15-5.3-20.2 0zM42.7 79.1c1 0 33.1 4.3 20.7 7.6-4.7 1.3-26.4-7.6-20.7-7.6zm61.5 17.8c0 2.3 17.5 3.5 16.6-.5-1.4-6.9-14.7-6.3-16.6.5zm-74.7 12c4 3.4 10-.8 11.9-5.6-3.8-5.1-18.1.3-11.9 5.6zm72.6-7.2c-4.9 4.5.9 9.2 5.7 6.1 1.2-.9-.2-5.1-5.7-6.1z\"/></g><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"33.173\" y1=\"245.076\" x2=\"60.308\" y2=\"217.941\" gradientTransform=\"matrix(1.003 0 0 -1.003 -.413 276.586)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".505\" fill=\"url(#d)\" d=\"M12.5 57.3C.3 69.3 21.7 66 38.1 72.4l34-59.7c-5.1-5.3-11.7-4.8-16.4 0L12.5 57.3z\"/><linearGradient id=\"e\" gradientUnits=\"userSpaceOnUse\" x1=\"48.612\" y1=\"250.177\" x2=\"81.173\" y2=\"217.616\" gradientTransform=\"matrix(.994 0 0 -.994 2.709 274.439)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#e)\" d=\"M71.1 12.3l17.7 18c1.6 1.6 1.6 5 .7 6l-8.8-7.2L79 39.6l-7.3-3.9-11.8 7.5L56 27.5l-6.3 13.7-15.9-.2c-3 0-2.6-3.1.5-6.3 6.2-6.8 18.2-18.5 22-22.5 4-4 10.8-3.8 14.8.1z\"/><radialGradient id=\"f\" cx=\"51.136\" cy=\"13.518\" r=\"33.212\" gradientTransform=\"matrix(.827 0 0 -.553 1.123 126.746)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path opacity=\".217\" fill=\"url(#f)\" d=\"M46.8 97.4s1.9 2.9 1.7 4.3c-.4 2.7-6.2 4.1-4.9 6.5 1.3 2.4 5.9 1 9.7 3.5 3.8 2.5 2.8 7.5 5.6 8.8 5.4 2.5 19.8-4.3 19-4.1-.7.1-14.1 2.9-17.1.5-3.4-2.8-4.4-4.7-7-6.4-2.4-1.5-5.7-2.2-6.5-3.4-.8-1.3 1.6-2.9 1.7-5.3.2-1.6-2.2-4.4-2.2-4.4z\"/><g opacity=\".276\"><radialGradient id=\"g\" cx=\"147.452\" cy=\"14.758\" r=\"33.212\" gradientTransform=\"matrix(1.055 0 0 -.706 -97.55 130.348)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#g)\" d=\"M46.8 97.4s1.9 2.9 1.7 4.3c-.4 2.7-6.2 4.1-4.9 6.5 1.3 2.4 5.9 1 9.7 3.5 3.8 2.5 2.8 7.5 5.6 8.8 5.4 2.5 19.8-4.3 19-4.1-23.8.1-19.3-6-28.5-10.1-1.3-.6-.6-2.2-.4-4.6.2-1.5-2.2-4.3-2.2-4.3z\"/></g><radialGradient id=\"h\" cx=\"-53.737\" cy=\"94.673\" r=\"37.174\" gradientTransform=\"matrix(.526 0 0 -.223 130.969 98.356)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path opacity=\".453\" fill=\"url(#h)\" d=\"M87.2 84.9c21.3-7.8 28.2-8.9 35.2-16C114.2 75.8 97 79.5 83 85.6l4.2-.7z\"/><g opacity=\".512\"><radialGradient id=\"i\" cx=\"-45.82\" cy=\"80.197\" r=\"37.174\" gradientTransform=\"matrix(.526 0 0 -.223 130.969 97.429)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#i)\" d=\"M87.2 83.9c35.1-12.4 29.2-12.4 35.2-16-11.2 4.3-32 4.7-39.4 16.7l4.2-.7z\"/></g><linearGradient id=\"j\" gradientUnits=\"userSpaceOnUse\" x1=\"-32.429\" y1=\"73.095\" x2=\"-32.293\" y2=\"66.244\" gradientTransform=\"matrix(.526 0 0 -.526 130.306 130.092)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".286\" fill=\"url(#j)\" d=\"M117.8 93.8c0 .8-2 1.4-4.6 1.4-2.5 0-4.6-.6-4.6-1.4 0-.8 2-1.4 4.6-1.4 2.6 0 4.6.6 4.6 1.4z\"/><g opacity=\".621\"><linearGradient id=\"k\" gradientUnits=\"userSpaceOnUse\" x1=\"112.548\" y1=\"76.804\" x2=\"112.548\" y2=\"71.974\" gradientTransform=\"matrix(.709 0 0 -1.134 33.501 178.262)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#k)\" d=\"M119.4 95.4c0 1.7-2.8 3-6.1 3-3.4 0-6.1-1.4-6.1-3 0-1.7 2.8-3 6.1-3 3.4 0 6.1 1.4 6.1 3z\"/></g><radialGradient id=\"l\" cx=\"-34.115\" cy=\"13.297\" r=\"15.297\" gradientTransform=\"matrix(.526 0 0 -.078 130.969 98.77)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#l)\" d=\"M104.9 97.1c2.2 2 14.2 3 16.2-.6-3.9 2.8-12.5 1.8-16.2.6z\"/><linearGradient id=\"m\" gradientUnits=\"userSpaceOnUse\" x1=\"-643.912\" y1=\"327.836\" x2=\"-643.777\" y2=\"320.984\" gradientTransform=\"matrix(.203 -.103 -.238 -.469 311.261 190.221)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".286\" fill=\"url(#m)\" d=\"M104.9 103.8c.4.9.2 1.9-.6 2.3-.8.4-1.8 0-2.2-.8-.4-.9-.2-1.9.6-2.3.8-.5 1.8-.1 2.2.8z\"/><g opacity=\".621\"><linearGradient id=\"n\" gradientUnits=\"userSpaceOnUse\" x1=\"-341.635\" y1=\"195.138\" x2=\"-341.635\" y2=\"190.308\" gradientTransform=\"matrix(.273 -.139 -.513 -1.011 295.216 251.45)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#n)\" d=\"M105.8 104.2c.7 1.3.3 2.8-.9 3.4-1.2.6-2.6 0-3.3-1.3-.7-1.3-.3-2.8.9-3.4 1.2-.6 2.6 0 3.3 1.3z\"/></g><radialGradient id=\"o\" cx=\"-645.599\" cy=\"1737.484\" r=\"15.297\" gradientTransform=\"matrix(.203 -.103 -.035 -.069 297.352 162.155)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#o)\" d=\"M101.9 107.8c1.7 1.4 8.3 1.5 5.8-2.4.7 3.1-3.8 2.8-5.8 2.4z\"/><radialGradient id=\"p\" cx=\"-185.187\" cy=\"69.66\" r=\"24.692\" gradientTransform=\"matrix(.526 0 0 -.214 130.969 105.831)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\" stop-opacity=\".33\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#p)\" d=\"M21 87.3c0-.3 22.4 6.8 26.2 10.7-3.1-3.1-19.1-10.1-21.5-10.2-2.4-.1-4.4-.3-4.7-.5z\"/><g transform=\"matrix(.879 -.193 .234 .696 -20.21 36.726)\"><linearGradient id=\"q\" gradientUnits=\"userSpaceOnUse\" x1=\"-136.743\" y1=\"250.438\" x2=\"-136.607\" y2=\"243.586\" gradientTransform=\"matrix(.463 .102 .123 -.366 65.856 208.72)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".286\" fill=\"url(#q)\" d=\"M38 105.3c0 .8-2 1.4-4.6 1.4s-4.6-.6-4.6-1.4c0-.8 2-1.4 4.6-1.4s4.6.6 4.6 1.4z\"/><g opacity=\".621\"><linearGradient id=\"r\" gradientUnits=\"userSpaceOnUse\" x1=\"60.343\" y1=\"183.942\" x2=\"60.343\" y2=\"179.112\" gradientTransform=\"matrix(.623 .219 .166 -.789 -34.636 234.581)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#r)\" d=\"M39.6 106.9c0 1.7-2.8 3-6.1 3s-6.1-1.4-6.1-3c0-1.7 2.8-3 6.1-3s6.1 1.3 6.1 3z\"/></g></g><g opacity=\".616\"><radialGradient id=\"s\" cx=\"-62.572\" cy=\"357.021\" r=\"11.363\" gradientTransform=\"matrix(.624 -.173 -.065 -.233 95.948 182.007)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#s)\" d=\"M28.2 106.3s1.2 3.2 4.5 3.4c3.4.2 7.2-4 7.5-5.5-.6 1.3-3.8 5.2-7.9 5.1-2.4 0-4.1-3-4.1-3z\"/></g><radialGradient id=\"t\" cx=\"193.011\" cy=\"256.754\" r=\"59.425\" gradientTransform=\"matrix(1.712 0 0 -1.685 -261.607 451.789)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path stroke=\"url(#t)\" stroke-width=\".488\" d=\"M63.4 6.5c-3.4 0-6.7 1.2-9 3.6L9.7 55.9c-4.1 4.1-5.1 6.8-4.8 8.3.1.8.5 1.4 1.3 2.1.8.7 2 1.4 3.4 2 2.9 1.2 6.7 2.2 10.5 3.2s7.5 2.1 10.3 3.9c.4.3.8.6 1.1 1.1.3.5.4 1.1.3 1.7-.2 1.1-.9 1.7-1.6 2.2-1.4 1.1-3.3 1.9-5.2 2.8s-3.8 1.9-4.8 2.6c-.5.4-.7.7-.6.7 0 0-.1-.3.1-.1.6.6 2.5 1.7 4.9 2.6s5.3 1.9 8.2 2.8c2.9 1 5.9 1.9 8.4 2.9s4.6 1.9 5.9 3.3c.7.7 1.2 1.6 1.3 2.4.1.9-.1 1.7-.5 2.4-.7 1.4-1.8 2.5-2.7 3.5-1 1-1.9 2-2.2 2.7-.2.3-.2.5-.2.7 0 .1 0 .3.3.6 1.3 1.4 4.1 1.6 7.3 2.3 1.6.4 3.3.9 4.7 2.2s2.5 3.1 3 5.7c.2 1.1.8 1.6 2.1 2 1.4.4 3.5.5 5.8.2 4.6-.7 10.1-2.9 13.2-5.5l.2-.2c-.2-.2-.7-.5-1.5-.9-1-.5-2.1-.9-3-2-.4-.6-.7-1.4-.6-2.3.1-.9.6-1.6 1.2-2.2 5.2-5.2 10.2-6.5 14-7.5 1.9-.5 3.5-1 4.7-1.7 1.2-.8 2.2-1.8 3-3.8.1-.2.1-.3 0-.5-.1-.3-.4-.7-.9-1.1-1-.9-2.7-1.8-4.4-2.8-1.7-.9-3.3-1.8-4.5-2.9-.6-.6-1.2-1.2-1.3-2.3-.1-1.1.6-2 1.4-2.6 3-2.1 7.5-3.7 12.4-5.4 4.9-1.7 10.2-3.5 14.4-5.5 4.3-2 7.4-4.3 8.4-6.6.5-1.2.6-2.3.1-3.9s-1.7-3.4-3.9-5.5L72.7 10.2c-2.6-2.5-6-3.7-9.3-3.7zm49.8 86.9c-2.9.1-5.5 1.4-6.6 3.5.3.1.6.3 1.1.4 1.5.3 3.6.6 5.6.6s4.1-.1 5.4-.5c.5-.2.8-.3 1-.4-.3-1.2-.9-2-2.1-2.6-1.1-.8-2.8-1.1-4.4-1zm-76.5 9.8c-2.3-.2-5.1.7-6.5 1.9-.7.6-1 1.1-1 1.4 0 .3.1.8 1 1.6 1.5 1.3 3.1 1.1 5 .1 1.6-.9 3-2.5 3.9-4.2-.6-.4-1.4-.7-2.4-.8zm66.2.7c-.5.6-.7 1.2-.8 1.6 0 .6.1 1 .5 1.4.8.8 2.5 1.1 4.3.1 0-.2-.1-.5-.4-.9-.4-.8-1.7-1.7-3.6-2.2z\" fill=\"none\"/><g opacity=\".325\"><linearGradient id=\"u\" gradientUnits=\"userSpaceOnUse\" x1=\"-224.589\" y1=\"68.903\" x2=\"-161.637\" y2=\"52.258\" gradientTransform=\"matrix(.485 0 0 -.485 149.184 125.791)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#u)\" d=\"M38.8 78.2c-2.7.8-11.4 4.1-10.2 6.6 1.2 2.4 21.5 3.4 24.6 10.6 1.4 3.1-3.1 5.5-2 8.7.9 2.5 7.6 8.7 11.9 11.7 3.4 2.3 7.8-1.9 6-5.3-2.8-5.5 9.9-12.2 15.6-15.3 3.3-1.8-6.9-10.6-6.9-10.6l-39-6.4z\"/></g><linearGradient id=\"v\" gradientUnits=\"userSpaceOnUse\" x1=\"13.153\" y1=\"197.768\" x2=\"9.253\" y2=\"188.832\" gradientTransform=\"matrix(.88 0 0 -.88 42.035 252.063)\"><stop offset=\"0\" stop-color=\"#EEEEEC\"/><stop offset=\"1\" stop-color=\"#EEEEEC\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#v)\" d=\"M39.8 80.7c2.4 1.8 7.2.7 10.1 2 6.9 3.1 15.4 6.6 13.8.4L62 84.6v-2.8l-4.1 1s-3.2-2.5-4.6-3.4c-.3-.2-1.9 1.4-1.9 1.4l-.3-1.7c-2-.2-4-.3-5.8-.3-4.2.1-7 .7-5.5 1.9z\"/><g opacity=\".478\"><radialGradient id=\"w\" cx=\"26.356\" cy=\"55.589\" r=\"24.385\" gradientTransform=\"matrix(.656 0 0 -.834 66.991 147.128)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#w)\" d=\"M85.1 86.3c-.9 3.4 11.5 8.1 10.5 10.5-2 5.2-13.2 1.7-21.8 12.6-1.2 1.6 1.7 7.2 1.3 6.5s-3.4-5.3-2.6-7.6c2.4-7.1 26-9.8 21.7-13.2-2.5-1.9-11.4-7.3-9.1-8.8z\"/></g><path opacity=\".586\" fill=\"#fff\" d=\"M113 93.4c0 .3-.6.6-1.4.6-.8 0-1.4-.3-1.4-.6s.6-.6 1.4-.6c.8 0 1.4.3 1.4.6zM103.9 103.8c0 .3-.4.6-.9.6s-.9-.3-.9-.6.4-.6.9-.6.9.3.9.6zM35.2 103.3c0 .3-.7.6-1.5.6s-1.5-.3-1.5-.6.7-.6 1.5-.6 1.5.3 1.5.6z\"/><linearGradient id=\"x\" gradientUnits=\"userSpaceOnUse\" x1=\"-245.694\" y1=\"88.661\" x2=\"-235.88\" y2=\"80.864\" gradientTransform=\"matrix(.49 0 0 -.49 147.66 125.008)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\"/></linearGradient><path opacity=\".251\" fill=\"url(#x)\" d=\"M34.3 78.5c-7.8 4.8-19.8 6.5-6.6 9.7-1.6-3.5 3.4-3.1 6.6-9.7z\"/><g opacity=\".363\"><linearGradient id=\"y\" gradientUnits=\"userSpaceOnUse\" x1=\"-115.448\" y1=\"55.254\" x2=\"-144.875\" y2=\"134.487\" gradientTransform=\"matrix(.485 0 0 -.485 149.184 125.791)\"><stop offset=\"0\" stop-color=\"#729FCF\"/><stop offset=\"1\" stop-color=\"#729FCF\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#y)\" d=\"M61.9 122.2s12-1.1 14.7-4.6c1.6-2-6.4-4.4-4.7-6.4 6.5-7.4 12-7.1 19.6-10.3 7.6-3.1 4.8-4.6 2.3-6-4.2-2.3-13.6-4.8-10.5-10.4 3.1-5.6 30.4-13.4 30.4-13.4 8.3-2.8 7.2-7.9 3.2-12.2L92.6 34.8s1.2 23-3.7 32.9C82.8 79.8 50.5 93.4 64 94.9c4.8.5 7.1 2.2 9 5.8 4 7.6-11.1 21.5-11.1 21.5z\"/></g></g></svg>"

/***/ }),

/***/ "../src/components/inkscape/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _InkscapeOriginal = __webpack_require__("../src/components/inkscape/original/InkscapeOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InkscapeOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/inkscape/plain-wordmark/InkscapePlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _InkscapePlainWordmark = __webpack_require__("../src/components/inkscape/plain-wordmark/InkscapePlainWordmark.svg");
	
	var _InkscapePlainWordmark2 = _interopRequireDefault(_InkscapePlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** InkscapePlainWordmark */
	function InkscapePlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'InkscapePlainWordmark',
	    svg: _InkscapePlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	InkscapePlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = InkscapePlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/inkscape/plain-wordmark/InkscapePlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M13.4 120.7c1-.1 1.6-.6 1.6-1.4v-10.5c0-1.1 0-1.3-1.6-1.6v-.6H15c2 0 2.5-.1 2.5-.1l.1.1s-.7.8-.7 2.7v10c0 .6-.1 1.1-.1 1.1l2.1.2-.1.6-5.4.1v-.6zm7.3 0c1-.1 1.6-.6 1.6-1.4v-9.9c0-1.5-.4-2-1.8-2.2v-.6h.7c1.1 0 2.2-.1 2.2-.1s.3.5.8 1.1l8 9.2.9 1.2v-9.2c0-1 0-1.5-1.8-1.7v-.6h4.2l.1.3s-1.5.4-1.5 2.2v12.2h-.6l-9.4-11c-.3-.3-.6-.7-.8-1.1v10c0 .7-.1 1.2-.1 1.2l2 .1-.1.6-4.3.1v-.4zm16.8 0c1-.1 1.6-.6 1.6-1.4v-10.5c0-1.1 0-1.3-1.6-1.6v-.6h1.7c2 0 2.5-.1 2.5-.1l.1.1s-.7.8-.7 2.7v3.9h.4s.4-.2.7-.6l4.3-4.3c.4-.4.4-1-.6-1.1v-.6H50l.1.3s-1.2.3-2.8 1.9l-4.2 4.1v.2l5.3 6.1c1 1.1 1.2 1.2 1.9 1.3h.2l-.1.7h-3.2l-.1-.1s-.2-.7-1.7-2.3l-4.1-4.8H41v5.2c0 .6-.1 1.1-.1 1.1l2 .2-.1.6-5.3.1v-.5zm14.5-3.3h.7c0 2.7 1.7 3.4 3.2 3.4 1.4 0 2.8-.6 2.8-2.3 0-3.8-6.9-3.8-6.9-8.2 0-2.2 1.6-3.8 4.9-3.8 1.6 0 3.1.4 3.6.4l-.7 3.4h-.7c.2-1.6-.6-3-2.5-3-1.5 0-2.7.7-2.7 2.3 0 3.9 6.9 3.5 6.9 8.2 0 2.6-2.3 3.9-4.9 3.9-1.9 0-4.2-.7-4.2-2.3-.1-.4 0-.7.5-2zm18.7-11c1.6 0 3.6.4 4.8.5l-.7 3.3H74c0-2.3-1.9-3-3.7-3-3.4 0-5.6 2.7-5.6 6.3 0 4 2.8 6.6 6.4 6.6 2.8 0 4.4-1.6 4.4-1.6l.3.5s-1.7 2.6-5.5 2.6c-3.9 0-7.7-2.7-7.7-7.4 0-4.5 3.3-7.8 8.1-7.8zm5.6 14.3c.9-.1 1.3-.5 1.5-1l5.2-13 .9-.2 4.9 12.5c.6 1.5 1 1.6 1.7 1.7l-.1.6h-.9c-.8 0-3.3.1-3.3.1v-.7c.6 0 1.2-.2.9-.9l-1.3-3.5h-5.3l-.3.2-1.5 4 1.9.3-.1.6h-4.1v-.7zm6.6-11.7l-2.4 6.4h4.8l-1.9-5c-.2-.5-.4-1.1-.5-1.4zm8.5 11.7c1-.1 1.6-.6 1.6-1.4v-10.5c0-1.1-.1-1.3-1.8-1.6v-.6h5.5c2.5 0 5.4.8 5.4 4 0 3.5-3.3 4.7-5.7 4.5v-.6c2.6-.1 3.5-1.7 3.5-3.4 0-2.6-2.1-3.7-4.4-3.7h-.3l-.2.2v11.6c0 .6-.1 1.1-.1 1.1l2.1.2-.1.6-5.4.1v-.5zm12.4 0c1-.1 1.6-.6 1.6-1.4v-10.5c0-1.1-.1-1.3-1.8-1.6v-.6h9.1c.9 0 1.6-.1 1.6-.1l-.7 3.7h-.7c.1-2.3-.6-2.7-2.4-2.7h-2.9l-.2.2v5.7h4.1l.2-1.3.8-.1v3.9h-1v-1.6h-3.8l-.2.2v4.7c0 .7-.1 1.2-.1 1.2h3.5c1.9 0 2.2-.4 3.3-2.7h.7l-.8 3.6H107c-1.1 0-3.2.1-3.2.1v-.7zm-3.5-31.4c.9-.9 0-4.2-4.6-5.2-4.3 3.8.4 7.6 4.6 5.2zm-55.4-3.8c-3.2-4.2-15.1.2-9.9 4.7 3.3 2.8 8.4-.7 9.9-4.7zm66.3-5.7c-2-5.7-12.2-5.3-13.8.4 0 1.9 13.8 3.1 13.8-.4zM84 70.6c9.3-5.4 41.4-9 26.2-24.2L71.9 7.2c-4.7-4.5-12.5-4.6-17 0l-37 37.9C5.4 60.6 26.4 58.8 35.4 63.2l-9.2 9c3.2 3.3 19.5 6.4 22.8 9.7L45.6 92c3.2 3.3 10.7.2 12.1 7.8 1 5.4 13.5 2.3 19.6-2.1l-3-6.3c8-8.2 15.5-3 18.3-11.2 1.4-4.1-11.8-6.3-8.6-9.6zM64.3 72c-3.9 1-23-6.7-18.2-6.7 1 .6 15.9 3.7 19.6 4.3 1.2.2.3 1.5-1.4 2.4zm11.9-39.5l-6.1-3.2-9.7 6.1-3.2-12.7-5.3 9.3h-8c-3.3 0-3.6-4.4-.7-7.3 5.2-5.6 11.1-11.4 14.3-14.7 3.2-3.3 8.9-3.3 12.1-.1l14.6 14.8c1.4 1.4 1.4 4.1.6 4.9l-7.3-5.8-1.3 8.7z\"/></svg>"

/***/ }),

/***/ "../src/components/inkscape/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _InkscapePlainWordmark = __webpack_require__("../src/components/inkscape/plain-wordmark/InkscapePlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InkscapePlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/inkscape/plain/InkscapePlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _InkscapePlain = __webpack_require__("../src/components/inkscape/plain/InkscapePlain.svg");
	
	var _InkscapePlain2 = _interopRequireDefault(_InkscapePlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** InkscapePlain */
	function InkscapePlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'InkscapePlain',
	    svg: _InkscapePlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	InkscapePlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = InkscapePlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/inkscape/plain/InkscapePlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M102.4 101.5c-5.1 4.6.6 9.3 5.6 6.3 1.1-1.2 0-5.2-5.6-6.3zm-73.8 7.4c4 3.4 10.2-.9 12-5.7-3.9-5.1-18.3.2-12 5.7zm75.9-12.1c0 2.3 16.8 3.8 16.8-.5-2.4-7-14.8-6.6-16.8.5zm15.6-41.1L73.4 7.9c-5.7-5.5-15.2-5.5-20.6 0L7.7 54C-7.5 72.9 18.1 70.7 29 76.1c3.9 4-15.1 7-11.1 11 3.9 4 23.8 7.7 27.7 11.8l-4.1 12.3c3.9 4 13 .2 14.7 9.5 1.2 6.6 16.4 2.8 23.8-2.6 3.9-4-7.5-3.6-3.6-7.7 9.8-10 18.9-3.6 22.2-13.7 1.7-5-14.4-7.6-10.5-11.7 11.4-6.5 50.5-10.8 32-29.3zm-56 31.1c-4.8 1.3-28-8.2-22.2-8.2 1.2.7 19.4 4.4 23.9 5.2 1.6.3.5 1.9-1.7 3zm25.1-51.5l-8.8-7.1-1.7 10.5-7.4-3.9-11.8 7.5-3.9-15.5L49.1 38h-9.7c-4 0-4.4-5.3-.8-8.9 6.3-6.8 13.5-13.8 17.4-17.8 3.9-4 10.8-4 14.7-.1l17.8 18.1c1.7 1.7 1.7 5 .7 6z\"/></svg>"

/***/ }),

/***/ "../src/components/inkscape/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _InkscapePlain = __webpack_require__("../src/components/inkscape/plain/InkscapePlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InkscapePlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/intellij/original-wordmark/IntellijOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _IntellijOriginalWordmark = __webpack_require__("../src/components/intellij/original-wordmark/IntellijOriginalWordmark.svg");
	
	var _IntellijOriginalWordmark2 = _interopRequireDefault(_IntellijOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** IntellijOriginalWordmark */
	function IntellijOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'IntellijOriginalWordmark',
	    svg: _IntellijOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	IntellijOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = IntellijOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/intellij/original-wordmark/IntellijOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"intelij\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#136ba2}.cls-2{fill:#fa930d}</style></defs><title>Artboard 12</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M38.71 61.21V73h-1.59V61.21zM41.63 66.85c0-.88 0-1.6-.07-2.3H43l.09 1.4A3.28 3.28 0 0 1 46 64.36c1.23 0 3.13.7 3.13 3.62V73h-1.57v-4.9c0-1.37-.53-2.51-2.05-2.51a2.28 2.28 0 0 0-2.16 1.58 2.14 2.14 0 0 0-.11.72V73h-1.61v-6.2zM53.66 62.11v2.44H56v1.18h-2.34v4.58c0 1.05.31 1.65 1.21 1.65a3.72 3.72 0 0 0 .93-.11l.08 1.15a4.09 4.09 0 0 1-1.43.21 2.29 2.29 0 0 1-1.74-.65 3.05 3.05 0 0 1-.62-2.21v-4.62h-1.38v-1.18h1.37v-2zM58.57 69.08a2.79 2.79 0 0 0 3 2.95 6.05 6.05 0 0 0 2.45-.44l.28 1.11a7.46 7.46 0 0 1-2.95.53A4 4 0 0 1 57 68.94c0-2.56 1.58-4.58 4.16-4.58 2.9 0 3.66 2.44 3.66 4a5.72 5.72 0 0 1-.05.72zM63.3 68a2.23 2.23 0 0 0-2.24-2.51A2.61 2.61 0 0 0 58.59 68zM66.85 60.58h1.61V73h-1.61zM71.17 60.58h1.61V73h-1.61zM77.29 62.16a1 1 0 0 1-2 0 1 1 0 0 1 1-1 .94.94 0 0 1 1 1zM75.5 73v-8.5h1.61V73zM82.37 61.21H84v7.92c0 3.14-1.61 4.11-3.74 4.11a5.36 5.36 0 0 1-1.7-.28l.24-1.25a4 4 0 0 0 1.34.23c1.43 0 2.27-.61 2.27-2.93v-7.8zM91.18 61.21V73h-2.8V61.21zM93.6 61.37a26 26 0 0 1 3.77-.25 8.2 8.2 0 0 1 5.06 1.26 5.15 5.15 0 0 1 2.09 4.46 5.89 5.89 0 0 1-2.05 4.79 9.14 9.14 0 0 1-5.7 1.53A25.2 25.2 0 0 1 93.6 73V61.37zM96.4 71a5.4 5.4 0 0 0 1 .05c2.53 0 4.18-1.32 4.18-4.14 0-2.46-1.48-3.76-3.88-3.76a6.06 6.06 0 0 0-1.26.1zM113.69 68h-4.54v2.81h5.08V73h-7.88V61.21H114v2.19h-4.82v2.46h4.54V68zM119 70l-.88 3h-2.9L119 61.21h3.66L126.5 73h-3l-1-3zm3.13-2l-.77-2.51c-.22-.7-.44-1.58-.62-2.28-.18.7-.37 1.6-.57 2.28l-.76 2.51z\"/><path class=\"cls-2\" d=\"M1.5 64.14a3.29 3.29 0 0 0 3.35 3.21 3.21 3.21 0 1 0 0-6.42 3.28 3.28 0 0 0-3.35 3.21z\"/><path class=\"cls-1\" d=\"M21.48 52.87c-1.84 0-2.94 1.42-2.94 3.8v14.61c0 2.38 1.1 3.8 2.93 3.8s2.94-1.42 2.94-3.8V56.67c.01-2.38-1.09-3.8-2.93-3.8zM16.34 53.18h-12a2.8 2.8 0 1 0 0 5.6h6.16v5.33a5.51 5.51 0 0 1-5.62 5.39h-.45a2.81 2.81 0 1 0 0 5.61h.42a11.26 11.26 0 0 0 11.48-11v-.1-1.8l.01-9.03z\"/></g></svg>"

/***/ }),

/***/ "../src/components/intellij/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _IntellijOriginalWordmark = __webpack_require__("../src/components/intellij/original-wordmark/IntellijOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IntellijOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/intellij/original/IntellijOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _IntellijOriginal = __webpack_require__("../src/components/intellij/original/IntellijOriginal.svg");
	
	var _IntellijOriginal2 = _interopRequireDefault(_IntellijOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** IntellijOriginal */
	function IntellijOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'IntellijOriginal',
	    svg: _IntellijOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	IntellijOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = IntellijOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/intellij/original/IntellijOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"intelij\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#fa930d}.cls-2{fill:#136ba2}</style></defs><title>Artboard 14</title><g id=\"original\"><path class=\"cls-1\" d=\"M5.55 64.73a17.08 17.08 0 1 0 17.08-17.09A17.11 17.11 0 0 0 5.55 64.73z\"/><path class=\"cls-2\" d=\"M107.48 4.73c-9.39 0-15 7.56-15 20.23v77.8c0 12.66 5.59 20.23 15 20.23s15-7.56 15-20.23V25c-.03-12.7-5.63-20.27-15-20.27zM81.25 6.38H19.88a14.92 14.92 0 0 0 0 29.81v.11h31.41v28.4a28.7 28.7 0 0 1-28.63 28.7h-.77l-.08.1c-.42 0-.85-.07-1.29-.07a14.94 14.94 0 1 0 0 29.87c.45 0 .9 0 1.34-.07v.05h.78a58.65 58.65 0 0 0 58.61-58.55v-.54-9.59-.11V6.38z\"/></g></svg>"

/***/ }),

/***/ "../src/components/intellij/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _IntellijOriginal = __webpack_require__("../src/components/intellij/original/IntellijOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IntellijOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/intellij/plain-wordmark/IntellijPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _IntellijPlainWordmark = __webpack_require__("../src/components/intellij/plain-wordmark/IntellijPlainWordmark.svg");
	
	var _IntellijPlainWordmark2 = _interopRequireDefault(_IntellijPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** IntellijPlainWordmark */
	function IntellijPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'IntellijPlainWordmark',
	    svg: _IntellijPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	IntellijPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = IntellijPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/intellij/plain-wordmark/IntellijPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"intelij\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#136ba2}</style></defs><title>Artboard 13</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M38.51 61.26V72.9h-1.6V61.26zM41.45 66.81c0-.86 0-1.57-.07-2.26h1.44l.09 1.38a3.33 3.33 0 0 1 3-1.57c1.24 0 3.16.69 3.16 3.56v5h-1.64v-4.84c0-1.35-.54-2.47-2.07-2.47a2.29 2.29 0 0 0-2.18 1.55 2.06 2.06 0 0 0-.11.71v5h-1.62zM53.58 62.14v2.4h2.33v1.16h-2.33v4.51c0 1 .31 1.62 1.22 1.62a3.84 3.84 0 0 0 .94-.1l.07 1.14a4.22 4.22 0 0 1-1.44.21 2.34 2.34 0 0 1-1.75-.64 3 3 0 0 1-.62-2.18V65.7h-1.39v-1.16H52v-2zM58.53 69a2.78 2.78 0 0 0 3.07 2.9 6.23 6.23 0 0 0 2.47-.43l.28 1.09a7.68 7.68 0 0 1-3 .52c-2.75 0-4.4-1.69-4.4-4.22s1.59-4.51 4.19-4.51c2.92 0 3.69 2.4 3.69 3.94a5.49 5.49 0 0 1-.05.71zm4.76-1.09A2.21 2.21 0 0 0 61 65.44a2.59 2.59 0 0 0-2.49 2.47zM66.87 60.64h1.63V72.9h-1.63zM71.23 60.64h1.63V72.9h-1.63zM77.4 62.19a1 1 0 0 1-2 0 1 1 0 0 1 1-1 .93.93 0 0 1 1 1zM75.59 72.9v-8.36h1.63v8.36h-1.63zM82.51 61.26h1.61v7.79c0 3.09-1.63 4-3.77 4a5.52 5.52 0 0 1-1.72-.28l.24-1.23a4.07 4.07 0 0 0 1.35.22c1.44 0 2.29-.6 2.29-2.89v-7.61zM91.4 61.26V72.9h-2.83V61.26zM93.83 61.41a26.81 26.81 0 0 1 3.8-.24 8.42 8.42 0 0 1 5.1 1.24 5 5 0 0 1 2.11 4.39 5.74 5.74 0 0 1-2.07 4.72A9.38 9.38 0 0 1 97 73a26 26 0 0 1-3.2-.17V61.41zm2.83 9.5a5.58 5.58 0 0 0 1 .05c2.55 0 4.21-1.3 4.21-4.08 0-2.42-1.5-3.7-3.92-3.7a6.25 6.25 0 0 0-1.27.1zM114.09 68h-4.58v2.76h5.12v2.14h-7.94V61.26h7.68v2.16h-4.86v2.42h4.58V68zM119.44 69.91l-.89 3h-2.92l3.8-11.64h3.69L127 72.9h-3l-1-3zm3.16-2l-.78-2.47c-.22-.69-.44-1.55-.63-2.25-.18.69-.37 1.57-.57 2.25l-.74 2.47zM1 64.13a3.28 3.28 0 0 0 3.38 3.16 3.16 3.16 0 1 0 0-6.32A3.28 3.28 0 0 0 1 64.13zM21.14 53c-1.85 0-3 1.4-3 3.74v14.42c0 2.34 1.1 3.74 3 3.74s3-1.4 3-3.74V56.78C24.1 54.44 23 53 21.14 53z\"/><path class=\"cls-1\" d=\"M16 53.35H3.83a2.76 2.76 0 1 0 0 5.51H10V64.1a5.5 5.5 0 0 1-5.67 5.3H4A2.77 2.77 0 1 0 4 75h.42C10.76 75 16 70.1 16 64.14v-.1-1.77-8.92z\"/></g></svg>"

/***/ }),

/***/ "../src/components/intellij/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _IntellijPlainWordmark = __webpack_require__("../src/components/intellij/plain-wordmark/IntellijPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IntellijPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/intellij/plain/IntellijPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _IntellijPlain = __webpack_require__("../src/components/intellij/plain/IntellijPlain.svg");
	
	var _IntellijPlain2 = _interopRequireDefault(_IntellijPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** IntellijPlain */
	function IntellijPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'IntellijPlain',
	    svg: _IntellijPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	IntellijPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = IntellijPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/intellij/plain/IntellijPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"intelij\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#136ba2}</style></defs><title>Artboard 15</title><g id=\"plain\"><path class=\"cls-1\" d=\"M4.87 64.74a17.28 17.28 0 1 0 17.28-17.29A17.31 17.31 0 0 0 4.87 64.74zM108 4c-9.5 0-15.16 7.65-15.16 20.46v78.7c0 12.81 5.65 20.46 15.14 20.46s15.16-7.65 15.16-20.46V24.51C123.13 11.7 117.47 4 108 4z\"/><path class=\"cls-1\" d=\"M81.45 5.71H19.37a15.09 15.09 0 0 0 0 30.16V36h31.77V64.74a29 29 0 0 1-29 29h-.78l-.08.1c-.43 0-.86-.07-1.3-.07A15.11 15.11 0 1 0 20 124c.45 0 .91 0 1.35-.07v.05h.79a59.33 59.33 0 0 0 59.31-59.24v-.55-9.7-.11V5.71z\"/></g></svg>"

/***/ }),

/***/ "../src/components/intellij/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _IntellijPlain = __webpack_require__("../src/components/intellij/plain/IntellijPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IntellijPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ionic/original-wordmark/IonicOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _IonicOriginalWordmark = __webpack_require__("../src/components/ionic/original-wordmark/IonicOriginalWordmark.svg");
	
	var _IonicOriginalWordmark2 = _interopRequireDefault(_IonicOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** IonicOriginalWordmark */
	function IonicOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'IonicOriginalWordmark',
	    svg: _IonicOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	IonicOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = IonicOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ionic/original-wordmark/IonicOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Ionic\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#4e8ef7}</style></defs><title>Artboard 7</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M57.01 58.34h.91v17.19h-.91zM70.83 57.92a9 9 0 1 0 9.05 9 8.85 8.85 0 0 0-9.05-9zm0 17.19A8.18 8.18 0 1 1 79 66.94a8 8 0 0 1-8.17 8.17zM97 59.64a8.56 8.56 0 0 0-5.48-1.72c-2.72 0-5.74 1.27-6.81 3.73h-.07v-3.31h-.91v17.19h.91v-9.89c0-4.31 2.66-6.88 7-6.88a6.82 6.82 0 0 1 4.87 1.62c1.3 1.17 2.11 3.08 2.11 6.07v9.08h.91v-9.08c.01-3.08-.8-5.39-2.53-6.81zM104.57 58.34h.91v17.19h-.91zM118.38 75.11a8 8 0 0 1-8.14-8.18 8.18 8.18 0 0 1 2.37-5.87 7.9 7.9 0 0 1 5.81-2.3 7.77 7.77 0 0 1 7.53 5.16h1a9.06 9.06 0 1 0-8.56 12 8.72 8.72 0 0 0 8.53-5.84h-1a7.78 7.78 0 0 1-7.54 5.03z\"/><circle class=\"cls-1\" cx=\"57.46\" cy=\"53.01\" r=\".98\"/><circle class=\"cls-1\" cx=\"105.02\" cy=\"53.01\" r=\".98\"/><circle class=\"cls-1\" cx=\"22.97\" cy=\"63.99\" r=\"8.97\"/><path class=\"cls-1\" d=\"M41.27 48.77a3.08 3.08 0 0 0-5.1-2.33 22 22 0 1 0 4.35 4.35 3.07 3.07 0 0 0 .75-2.02zM23 85.22A21.23 21.23 0 1 1 35.67 47a3.08 3.08 0 0 0 4.3 4.3A21.22 21.22 0 0 1 23 85.22z\"/></g></svg>"

/***/ }),

/***/ "../src/components/ionic/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _IonicOriginalWordmark = __webpack_require__("../src/components/ionic/original-wordmark/IonicOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IonicOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ionic/original/IonicOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _IonicOriginal = __webpack_require__("../src/components/ionic/original/IonicOriginal.svg");
	
	var _IonicOriginal2 = _interopRequireDefault(_IonicOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** IonicOriginal */
	function IonicOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'IonicOriginal',
	    svg: _IonicOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	IonicOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = IonicOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ionic/original/IonicOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Ionic\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#4e8ef7}</style></defs><title>Artboard 5</title><g id=\"original\"><circle class=\"cls-1\" cx=\"64\" cy=\"64\" r=\"24.08\"/><path class=\"cls-1\" d=\"M113.14 23.14a8.27 8.27 0 0 0-13.7-6.25 59 59 0 1 0 11.67 11.67 8.24 8.24 0 0 0 2.03-5.42zM64 121A57 57 0 1 1 98.1 18.36a8.27 8.27 0 0 0 11.53 11.53A57 57 0 0 1 64 121z\"/></g></svg>"

/***/ }),

/***/ "../src/components/ionic/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _IonicOriginal = __webpack_require__("../src/components/ionic/original/IonicOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IonicOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jasmine/plain-wordmark/JasminePlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JasminePlainWordmark = __webpack_require__("../src/components/jasmine/plain-wordmark/JasminePlainWordmark.svg");
	
	var _JasminePlainWordmark2 = _interopRequireDefault(_JasminePlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JasminePlainWordmark */
	function JasminePlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JasminePlainWordmark',
	    svg: _JasminePlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JasminePlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JasminePlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jasmine/plain-wordmark/JasminePlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#8a4182}</style></defs><title>jasmine-wordmark</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M67.17 42.93H60.5l-1.79-2.31V22.46h10.15v18.16l-1.69 2.31zM58.16 44.62l-2.06 6.34-2.76.99-17.26-5.6 3.13-9.65 17.27 5.61 1.68 2.31zM56.97 53.54l5.4 3.92.09 2.93-10.67 14.68-8.21-5.96 10.67-14.69 2.72-.88zM65.24 57.49l5.4-3.91 2.81.81 10.67 14.69-8.21 5.96-10.67-14.69v-2.86zM71.65 51.07l-2.06-6.34 1.64-2.42L88.5 36.7l3.13 9.65-17.26 5.6-2.72-.88z\"/><path class=\"cls-1\" d=\"M64 6.74a44.17 44.17 0 1 0 44.17 44.17A44.17 44.17 0 0 0 64 6.74zm-.24 78.69A34.93 34.93 0 1 1 98.69 50.5a34.93 34.93 0 0 1-34.93 34.93z\"/><path class=\"cls-1\" d=\"M62.29 64.31h2.76v13.77h-2.76z\"/><path class=\"cls-1\" transform=\"rotate(-72 84.266 56.628)\" d=\"M82.89 49.74h2.76v13.77h-2.76z\"/><path class=\"cls-1\" transform=\"rotate(-144 76.64 32.566)\" d=\"M75.26 25.68h2.76v13.77h-2.76z\"/><path class=\"cls-1\" transform=\"rotate(144 51.314 32.566)\" d=\"M49.93 25.68h2.76v13.77h-2.76z\"/><path class=\"cls-1\" transform=\"rotate(72 43.338 56.625)\" d=\"M41.95 49.74h2.76v13.77h-2.76z\"/><path id=\"path22\" class=\"cls-1\" d=\"M5.07 114.65a2.56 2.56 0 0 0 2.4 2.74 2.28 2.28 0 0 0 2.06-1.2 6 6 0 0 0 .43-2.77v-11H7.57v-3.56h9v3.51h-2.42v11.57c0 2-.12 3.51-1.51 5.11a7 7 0 0 1-5.14 2.22c-3.94 0-7-2.62-6.8-6.62h4.37\"/><path id=\"path24\" class=\"cls-1\" d=\"M30.49 112.52a4.94 4.94 0 0 0-5-4.89 5 5 0 0 0-5 5.08 5 5 0 0 0 4.89 4.89 5 5 0 0 0 5.11-5.08zm-.06 6.09a6.08 6.08 0 0 1-5.29 2.65 8.51 8.51 0 0 1-8.43-8.55 8.69 8.69 0 0 1 8.61-8.71 5.9 5.9 0 0 1 5.11 2.77v-2.37h5.88v3.51h-2.06v9.42h2.06v3.51h-5.88v-2.22\"/><path id=\"path26\" class=\"cls-1\" d=\"M41.26 116.06a2.51 2.51 0 0 0 2.65 2.46 2.14 2.14 0 0 0 2.25-2c0-1.63-1.54-1.91-2.8-2.25-2.86-.74-6-1.63-6-5.23 0-3.14 2.65-5 5.57-5a4.38 4.38 0 0 1 3.72 1.48v-1.12h2.77v4.46h-3.63a2 2 0 0 0-2.12-1.94 1.89 1.89 0 0 0-2.09 1.72c0 1.54 1.51 1.88 2.71 2.15 3 .68 6.12 1.6 6.12 5.29 0 3.32-2.8 5.17-5.88 5.17a5.35 5.35 0 0 1-4.25-1.78v1.35h-2.86v-4.77h3.85\"/><path id=\"path28\" class=\"cls-1\" d=\"M53.54 107.91h-2.12v-3.51H57v2.46a5.45 5.45 0 0 1 4.69-2.86 5.59 5.59 0 0 1 5.11 3.45 5.9 5.9 0 0 1 5.39-3.45 6.34 6.34 0 0 1 4.74 2.09c1.29 1.51 1.29 3.14 1.29 5v6.22h2.12v3.51h-8v-3.51h2.12V112a6.13 6.13 0 0 0-.49-3 3.22 3.22 0 0 0-2.68-1.35 3.64 3.64 0 0 0-2.77 1.23 4.43 4.43 0 0 0-.77 3.11v5.29h2.12v3.51h-8v-3.51H64v-5a6.5 6.5 0 0 0-.49-3.08 3 3 0 0 0-2.71-1.51 3.21 3.21 0 0 0-2.62 1.2 4.8 4.8 0 0 0-.89 3.35v5.08h2.12v3.51h-8v-3.51h2.12v-9.42\"/><path id=\"path30\" class=\"cls-1\" d=\"M87.45 102.83H83.7v-4h3.75zm0 14.49h2.12v3.51h-8v-3.51h2.13v-9.42h-2.13v-3.5h5.88v12.92\"/><path id=\"path32\" class=\"cls-1\" d=\"M92.84 107.91h-2.13v-3.51h5.88v2.34a5.32 5.32 0 0 1 4.86-2.71 6.51 6.51 0 0 1 4.74 2c1.35 1.51 1.38 3 1.38 4.83v6.43h2.12v3.51h-8v-3.51h2.12V112a4.76 4.76 0 0 0-.65-3 3.59 3.59 0 0 0-2.89-1.32 3.69 3.69 0 0 0-3 1.38 5.79 5.79 0 0 0-.71 3.45v4.77h2.12v3.51h-8v-3.51h2.12v-9.42\"/><path id=\"path34\" class=\"cls-1\" d=\"M123.82 111.14a5.25 5.25 0 0 0-5.17-3.88 5.09 5.09 0 0 0-4.8 3.88zm2.86 4.86a8.43 8.43 0 0 1-7.75 5.26 8.68 8.68 0 0 1-.09-17.36 8.8 8.8 0 0 1 6.15 2.65 8.58 8.58 0 0 1 2.31 6.15l-.12 1.32h-13.3a5.07 5.07 0 0 0 4.92 3.94 4.57 4.57 0 0 0 4-2h3.91\"/></g></svg>"

/***/ }),

/***/ "../src/components/jasmine/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JasminePlainWordmark = __webpack_require__("../src/components/jasmine/plain-wordmark/JasminePlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JasminePlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jasmine/plain/JasminePlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JasminePlain = __webpack_require__("../src/components/jasmine/plain/JasminePlain.svg");
	
	var _JasminePlain2 = _interopRequireDefault(_JasminePlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JasminePlain */
	function JasminePlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JasminePlain',
	    svg: _JasminePlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JasminePlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JasminePlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jasmine/plain/JasminePlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#8a4182}</style></defs><title>jasmine-plain</title><g id=\"plain\"><path class=\"cls-1\" d=\"M68.49 52.7h-9.44l-2.55-3.28V23.7h14.38v25.72l-2.39 3.28zM55.72 55.1l-2.92 8.98-3.9 1.41-24.47-7.95 4.45-13.67 24.46 7.94 2.38 3.29zM54.04 67.74l7.64 5.55.13 4.14L46.7 98.25 35.06 89.8l15.13-20.82 3.85-1.24zM65.76 73.33l7.65-5.55 3.98 1.16 15.12 20.81-11.63 8.45-15.12-20.81v-4.06zM74.84 64.23l-2.92-8.99 2.33-3.43 24.46-7.94 4.45 13.67-24.47 7.95-3.85-1.26z\"/><path class=\"cls-1\" d=\"M64 1.41A62.59 62.59 0 1 0 126.59 64 62.59 62.59 0 0 0 64 1.41zm-.34 111.5a49.5 49.5 0 1 1 49.5-49.5 49.5 49.5 0 0 1-49.5 49.51z\"/><path class=\"cls-1\" d=\"M61.58 82.99h3.92v19.51h-3.92z\"/><path class=\"cls-1\" transform=\"rotate(-72 92.722 72.109)\" d=\"M90.77 62.35h3.92v19.51h-3.92z\"/><path class=\"cls-1\" transform=\"rotate(-144 81.908 38.013)\" d=\"M79.95 28.25h3.92v19.51h-3.92z\"/><path class=\"cls-1\" transform=\"rotate(144 46.029 38.012)\" d=\"M44.07 28.25h3.92v19.51h-3.92z\"/><path class=\"cls-1\" transform=\"rotate(72 34.723 72.106)\" d=\"M32.76 62.35h3.92v19.51h-3.92z\"/></g></svg>"

/***/ }),

/***/ "../src/components/jasmine/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JasminePlain = __webpack_require__("../src/components/jasmine/plain/JasminePlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JasminePlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/java/original-wordmark/JavaOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JavaOriginalWordmark = __webpack_require__("../src/components/java/original-wordmark/JavaOriginalWordmark.svg");
	
	var _JavaOriginalWordmark2 = _interopRequireDefault(_JavaOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JavaOriginalWordmark */
	function JavaOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JavaOriginalWordmark',
	    svg: _JavaOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JavaOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JavaOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/java/original-wordmark/JavaOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#0074BD\" d=\"M52.581 67.817s-3.284 1.911 2.341 2.557c6.814.778 10.297.666 17.805-.753 0 0 1.979 1.237 4.735 2.309-16.836 7.213-38.104-.418-24.881-4.113zm-2.059-9.415s-3.684 2.729 1.945 3.311c7.28.751 13.027.813 22.979-1.103 0 0 1.373 1.396 3.536 2.157-20.352 5.954-43.021.469-28.46-4.365z\"/><path fill=\"#EA2D2E\" d=\"M67.865 42.431c4.151 4.778-1.088 9.074-1.088 9.074s10.533-5.437 5.696-12.248c-4.519-6.349-7.982-9.502 10.771-20.378.001 0-29.438 7.35-15.379 23.552z\"/><path fill=\"#0074BD\" d=\"M90.132 74.781s2.432 2.005-2.678 3.555c-9.716 2.943-40.444 3.831-48.979.117-3.066-1.335 2.687-3.187 4.496-3.576 1.887-.409 2.965-.334 2.965-.334-3.412-2.403-22.055 4.719-9.469 6.762 34.324 5.563 62.567-2.506 53.665-6.524zm-35.97-26.134s-15.629 3.713-5.534 5.063c4.264.57 12.758.439 20.676-.225 6.469-.543 12.961-1.704 12.961-1.704s-2.279.978-3.93 2.104c-15.874 4.175-46.533 2.23-37.706-2.038 7.463-3.611 13.533-3.2 13.533-3.2zM82.2 64.317c16.135-8.382 8.674-16.438 3.467-15.353-1.273.266-1.845.496-1.845.496s.475-.744 1.378-1.063c10.302-3.62 18.223 10.681-3.322 16.345 0 0 .247-.224.322-.425z\"/><path fill=\"#EA2D2E\" d=\"M72.474 1.313s8.935 8.939-8.476 22.682c-13.962 11.027-3.184 17.313-.006 24.498-8.15-7.354-14.128-13.828-10.118-19.852 5.889-8.842 22.204-13.131 18.6-27.328z\"/><path fill=\"#0074BD\" d=\"M55.749 87.039c15.484.99 39.269-.551 39.832-7.878 0 0-1.082 2.777-12.799 4.981-13.218 2.488-29.523 2.199-39.191.603 0 0 1.98 1.64 12.158 2.294z\"/><path fill=\"#EA2D2E\" d=\"M94.866 100.181h-.472v-.264h1.27v.264h-.47v1.317h-.329l.001-1.317zm2.535.066h-.006l-.468 1.251h-.216l-.465-1.251h-.005v1.251h-.312v-1.581h.457l.431 1.119.432-1.119h.454v1.581h-.302v-1.251zm-44.19 14.79c-1.46 1.266-3.004 1.978-4.391 1.978-1.974 0-3.045-1.186-3.045-3.085 0-2.055 1.146-3.56 5.738-3.56h1.697v4.667h.001zm4.031 4.548v-14.077c0-3.599-2.053-5.973-6.997-5.973-2.886 0-5.416.714-7.473 1.622l.592 2.493c1.62-.595 3.715-1.147 5.771-1.147 2.85 0 4.075 1.147 4.075 3.521v1.779h-1.424c-6.921 0-10.044 2.685-10.044 6.723 0 3.479 2.058 5.456 5.933 5.456 2.49 0 4.351-1.028 6.088-2.533l.316 2.137h3.163v-.001zm13.452 0h-5.027l-6.051-19.689h4.391l3.756 12.099.835 3.635c1.896-5.258 3.24-10.596 3.912-15.733h4.271c-1.143 6.481-3.203 13.598-6.087 19.688zm19.288-4.548c-1.465 1.266-3.01 1.978-4.392 1.978-1.976 0-3.046-1.186-3.046-3.085 0-2.055 1.149-3.56 5.736-3.56h1.701v4.667h.001zm4.033 4.548v-14.077c0-3.599-2.059-5.973-6.999-5.973-2.889 0-5.418.714-7.475 1.622l.593 2.493c1.62-.595 3.718-1.147 5.774-1.147 2.846 0 4.074 1.147 4.074 3.521v1.779h-1.424c-6.923 0-10.045 2.685-10.045 6.723 0 3.479 2.056 5.456 5.93 5.456 2.491 0 4.349-1.028 6.091-2.533l.318 2.137h3.163v-.001zm-56.693 3.346c-1.147 1.679-3.005 3.008-5.037 3.757l-1.989-2.345c1.547-.794 2.872-2.075 3.489-3.269.532-1.063.753-2.43.753-5.701V92.891h4.284v22.173c0 4.375-.348 6.144-1.5 7.867z\"/></svg>"

/***/ }),

/***/ "../src/components/java/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JavaOriginalWordmark = __webpack_require__("../src/components/java/original-wordmark/JavaOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JavaOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/java/original/JavaOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JavaOriginal = __webpack_require__("../src/components/java/original/JavaOriginal.svg");
	
	var _JavaOriginal2 = _interopRequireDefault(_JavaOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JavaOriginal */
	function JavaOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JavaOriginal',
	    svg: _JavaOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JavaOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JavaOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/java/original/JavaOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#0074BD\" d=\"M47.617 98.12s-4.767 2.774 3.397 3.71c9.892 1.13 14.947.968 25.845-1.092 0 0 2.871 1.795 6.873 3.351-24.439 10.47-55.308-.607-36.115-5.969zm-2.988-13.665s-5.348 3.959 2.823 4.805c10.567 1.091 18.91 1.18 33.354-1.6 0 0 1.993 2.025 5.132 3.131-29.542 8.64-62.446.68-41.309-6.336z\"/><path fill=\"#EA2D2E\" d=\"M69.802 61.271c6.025 6.935-1.58 13.17-1.58 13.17s15.289-7.891 8.269-17.777c-6.559-9.215-11.587-13.792 15.635-29.58 0 .001-42.731 10.67-22.324 34.187z\"/><path fill=\"#0074BD\" d=\"M102.123 108.229s3.529 2.91-3.888 5.159c-14.102 4.272-58.706 5.56-71.094.171-4.451-1.938 3.899-4.625 6.526-5.192 2.739-.593 4.303-.485 4.303-.485-4.953-3.487-32.013 6.85-13.743 9.815 49.821 8.076 90.817-3.637 77.896-9.468zM49.912 70.294s-22.686 5.389-8.033 7.348c6.188.828 18.518.638 30.011-.326 9.39-.789 18.813-2.474 18.813-2.474s-3.308 1.419-5.704 3.053c-23.042 6.061-67.544 3.238-54.731-2.958 10.832-5.239 19.644-4.643 19.644-4.643zm40.697 22.747c23.421-12.167 12.591-23.86 5.032-22.285-1.848.385-2.677.72-2.677.72s.688-1.079 2-1.543c14.953-5.255 26.451 15.503-4.823 23.725 0-.002.359-.327.468-.617z\"/><path fill=\"#EA2D2E\" d=\"M76.491 1.587S89.459 14.563 64.188 34.51c-20.266 16.006-4.621 25.13-.007 35.559-11.831-10.673-20.509-20.07-14.688-28.815C58.041 28.42 81.722 22.195 76.491 1.587z\"/><path fill=\"#0074BD\" d=\"M52.214 126.021c22.476 1.437 57-.8 57.817-11.436 0 0-1.571 4.032-18.577 7.231-19.186 3.612-42.854 3.191-56.887.874 0 .001 2.875 2.381 17.647 3.331z\"/></svg>"

/***/ }),

/***/ "../src/components/java/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JavaOriginal = __webpack_require__("../src/components/java/original/JavaOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JavaOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/java/plain-wordmark/JavaPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JavaPlainWordmark = __webpack_require__("../src/components/java/plain-wordmark/JavaPlainWordmark.svg");
	
	var _JavaPlainWordmark2 = _interopRequireDefault(_JavaPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JavaPlainWordmark */
	function JavaPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JavaPlainWordmark',
	    svg: _JavaPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JavaPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JavaPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/java/plain-wordmark/JavaPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#EA2D2E\" d=\"M53.595 67.817c-13.224 3.694 8.044 11.325 24.88 4.112-2.757-1.071-4.735-2.309-4.735-2.309-7.508 1.419-10.99 1.531-17.805.753-5.625-.644-2.34-2.556-2.34-2.556zm22.864-7.207c-9.95 1.915-15.698 1.854-22.979 1.103-5.629-.582-1.944-3.311-1.944-3.311-14.563 4.834 8.106 10.318 28.459 4.365-2.162-.761-3.536-2.157-3.536-2.157zm7.799-41.731s-29.439 7.351-15.38 23.552c4.151 4.778-1.088 9.074-1.088 9.074s10.533-5.437 5.696-12.248c-4.518-6.349-7.982-9.502 10.772-20.378zM37.48 81.305c34.324 5.563 62.567-2.506 53.666-6.523 0 0 2.431 2.005-2.679 3.555-9.715 2.943-40.444 3.831-48.979.117-3.066-1.335 2.687-3.187 4.496-3.576 1.887-.409 2.965-.334 2.965-.334-3.412-2.404-22.055 4.718-9.469 6.761zm41.868-27.42c1.65-1.126 3.93-2.104 3.93-2.104s-6.492 1.161-12.961 1.704c-7.918.664-16.412.795-20.676.225-10.095-1.35 5.534-5.063 5.534-5.063s-6.07-.411-13.533 3.199c-8.827 4.269 21.832 6.214 37.706 2.039zm3.865 10.432c-.074.2-.322.425-.322.425 21.546-5.664 13.624-19.965 3.322-16.345-.903.319-1.378 1.063-1.378 1.063s.571-.23 1.845-.496c5.207-1.084 12.669 6.972-3.467 15.353zM65.006 48.492c-3.179-7.186-13.957-13.471.005-24.498 17.41-13.742 8.476-22.682 8.476-22.682 3.604 14.197-12.711 18.486-18.6 27.328-4.01 6.024 1.969 12.499 10.119 19.852zm18.79 35.651c-13.219 2.488-29.524 2.199-39.191.603 0 0 1.98 1.64 12.157 2.294 15.484.99 39.269-.551 39.832-7.878 0-.001-1.082 2.776-12.798 4.981zM51.131 99.535c-2.887 0-5.351.714-7.408 1.622l.624 2.493c1.619-.595 3.618-1.147 5.674-1.147 2.85 0 3.979 1.147 3.979 3.521V108h-1.2c-6.921 0-10.044 2.585-10.044 6.624 0 3.479 2.059 5.407 5.933 5.407 2.49 0 4.351-.845 6.088-2.35l.316 2.319H58v-14.492c0-3.599-1.924-5.973-6.869-5.973zM54 115.037c-1 1.266-2.893 1.978-4.279 1.978-1.973 0-2.988-1.371-2.988-3.27 0-2.056 1.202-3.745 5.794-3.745H54v5.037zm15.611.644l-.835-3.608L65.02 100h-4.39l6.051 20h5.026c2.884-7 4.943-14 6.086-20h-4.271c-.671 5-2.016 10.424-3.911 15.681zm18.404-16.146c-2.889 0-5.411.714-7.467 1.622l.596 2.493c1.621-.595 3.722-1.147 5.778-1.147 2.846 0 4.078 1.147 4.078 3.521V108h-1.428c-6.923 0-10.045 2.585-10.045 6.624 0 3.479 2.056 5.407 5.93 5.407 2.492 0 4.349-.845 6.091-2.35l.318 2.319H95v-14.492c0-3.599-2.044-5.973-6.985-5.973zm-1.411 17.462c-1.975 0-3.046-1.363-3.046-3.261 0-2.055 1.149-3.736 5.736-3.736H91v5h-.067c-1.465 1-2.947 1.997-4.329 1.997zM36 115.373c0 3.271-.445 4.638-.979 5.701-.615 1.193-2.053 2.475-3.601 3.269l1.934 2.345c2.032-.749 3.943-2.078 5.092-3.757 1.15-1.723 1.554-3.491 1.554-7.867V93h-4v22.373z\"/></svg>"

/***/ }),

/***/ "../src/components/java/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JavaPlainWordmark = __webpack_require__("../src/components/java/plain-wordmark/JavaPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JavaPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/java/plain/JavaPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JavaPlain = __webpack_require__("../src/components/java/plain/JavaPlain.svg");
	
	var _JavaPlain2 = _interopRequireDefault(_JavaPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JavaPlain */
	function JavaPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JavaPlain',
	    svg: _JavaPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JavaPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JavaPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/java/plain/JavaPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#EA2D2E\" d=\"M47.617 98.12c-19.192 5.362 11.677 16.439 36.115 5.969-4.003-1.556-6.874-3.351-6.874-3.351-10.897 2.06-15.952 2.222-25.844 1.092-8.164-.935-3.397-3.71-3.397-3.71zm33.189-10.46c-14.444 2.779-22.787 2.69-33.354 1.6-8.171-.845-2.822-4.805-2.822-4.805-21.137 7.016 11.767 14.977 41.309 6.336-3.14-1.106-5.133-3.131-5.133-3.131zm11.319-60.575c.001 0-42.731 10.669-22.323 34.187 6.024 6.935-1.58 13.17-1.58 13.17s15.289-7.891 8.269-17.777c-6.559-9.215-11.587-13.793 15.634-29.58zm9.998 81.144s3.529 2.91-3.888 5.159c-14.102 4.272-58.706 5.56-71.095.171-4.45-1.938 3.899-4.625 6.526-5.192 2.739-.593 4.303-.485 4.303-.485-4.952-3.487-32.013 6.85-13.742 9.815 49.821 8.076 90.817-3.637 77.896-9.468zM85 77.896c2.395-1.634 5.703-3.053 5.703-3.053s-9.424 1.685-18.813 2.474c-11.494.964-23.823 1.154-30.012.326-14.652-1.959 8.033-7.348 8.033-7.348s-8.812-.596-19.644 4.644C17.455 81.134 61.958 83.958 85 77.896zm5.609 15.145c-.108.29-.468.616-.468.616 31.273-8.221 19.775-28.979 4.822-23.725-1.312.464-2 1.543-2 1.543s.829-.334 2.678-.72c7.559-1.575 18.389 10.119-5.032 22.286zM64.181 70.069c-4.614-10.429-20.26-19.553.007-35.559C89.459 14.563 76.492 1.587 76.492 1.587c5.23 20.608-18.451 26.833-26.999 39.667-5.821 8.745 2.857 18.142 14.688 28.815zm27.274 51.748c-19.187 3.612-42.854 3.191-56.887.874 0 0 2.874 2.38 17.646 3.331 22.476 1.437 57-.8 57.816-11.436.001 0-1.57 4.032-18.575 7.231z\"/></svg>"

/***/ }),

/***/ "../src/components/java/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JavaPlain = __webpack_require__("../src/components/java/plain/JavaPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JavaPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/javascript/original/JavascriptOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JavascriptOriginal = __webpack_require__("../src/components/javascript/original/JavascriptOriginal.svg");
	
	var _JavascriptOriginal2 = _interopRequireDefault(_JavascriptOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JavascriptOriginal */
	function JavascriptOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JavascriptOriginal',
	    svg: _JavascriptOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JavascriptOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JavascriptOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/javascript/original/JavascriptOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#F0DB4F\" d=\"M1.408 1.408h125.184v125.185H1.408z\"/><path fill=\"#323330\" d=\"M116.347 96.736c-.917-5.711-4.641-10.508-15.672-14.981-3.832-1.761-8.104-3.022-9.377-5.926-.452-1.69-.512-2.642-.226-3.665.821-3.32 4.784-4.355 7.925-3.403 2.023.678 3.938 2.237 5.093 4.724 5.402-3.498 5.391-3.475 9.163-5.879-1.381-2.141-2.118-3.129-3.022-4.045-3.249-3.629-7.676-5.498-14.756-5.355l-3.688.477c-3.534.893-6.902 2.748-8.877 5.235-5.926 6.724-4.236 18.492 2.975 23.335 7.104 5.332 17.54 6.545 18.873 11.531 1.297 6.104-4.486 8.08-10.234 7.378-4.236-.881-6.592-3.034-9.139-6.949-4.688 2.713-4.688 2.713-9.508 5.485 1.143 2.499 2.344 3.63 4.26 5.795 9.068 9.198 31.76 8.746 35.83-5.176.165-.478 1.261-3.666.38-8.581zM69.462 58.943H57.753l-.048 30.272c0 6.438.333 12.34-.714 14.149-1.713 3.558-6.152 3.117-8.175 2.427-2.059-1.012-3.106-2.451-4.319-4.485-.333-.584-.583-1.036-.667-1.071l-9.52 5.83c1.583 3.249 3.915 6.069 6.902 7.901 4.462 2.678 10.459 3.499 16.731 2.059 4.082-1.189 7.604-3.652 9.448-7.401 2.666-4.915 2.094-10.864 2.07-17.444.06-10.735.001-21.468.001-32.237z\"/></svg>"

/***/ }),

/***/ "../src/components/javascript/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JavascriptOriginal = __webpack_require__("../src/components/javascript/original/JavascriptOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JavascriptOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/javascript/plain/JavascriptPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JavascriptPlain = __webpack_require__("../src/components/javascript/plain/JavascriptPlain.svg");
	
	var _JavascriptPlain2 = _interopRequireDefault(_JavascriptPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JavascriptPlain */
	function JavascriptPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JavascriptPlain',
	    svg: _JavascriptPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JavascriptPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JavascriptPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/javascript/plain/JavascriptPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#F0DB4F\" d=\"M2 1v125h125V1H2zm66.119 106.513c-1.845 3.749-5.367 6.212-9.448 7.401-6.271 1.44-12.269.619-16.731-2.059-2.986-1.832-5.318-4.652-6.901-7.901l9.52-5.83c.083.035.333.487.667 1.071 1.214 2.034 2.261 3.474 4.319 4.485 2.022.69 6.461 1.131 8.175-2.427 1.047-1.81.714-7.628.714-14.065C58.433 78.073 58.48 68 58.48 58h11.709c0 11 .06 21.418 0 32.152.025 6.58.596 12.446-2.07 17.361zm48.574-3.308c-4.07 13.922-26.762 14.374-35.83 5.176-1.916-2.165-3.117-3.296-4.26-5.795 4.819-2.772 4.819-2.772 9.508-5.485 2.547 3.915 4.902 6.068 9.139 6.949 5.748.702 11.531-1.273 10.234-7.378-1.333-4.986-11.77-6.199-18.873-11.531-7.211-4.843-8.901-16.611-2.975-23.335 1.975-2.487 5.343-4.343 8.877-5.235l3.688-.477c7.081-.143 11.507 1.727 14.756 5.355.904.916 1.642 1.904 3.022 4.045-3.772 2.404-3.76 2.381-9.163 5.879-1.154-2.486-3.069-4.046-5.093-4.724-3.142-.952-7.104.083-7.926 3.403-.285 1.023-.226 1.975.227 3.665 1.273 2.903 5.545 4.165 9.377 5.926 11.031 4.474 14.756 9.271 15.672 14.981.882 4.916-.213 8.105-.38 8.581z\"/></svg>"

/***/ }),

/***/ "../src/components/javascript/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JavascriptPlain = __webpack_require__("../src/components/javascript/plain/JavascriptPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JavascriptPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jeet/original-wordmark/JeetOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JeetOriginalWordmark = __webpack_require__("../src/components/jeet/original-wordmark/JeetOriginalWordmark.svg");
	
	var _JeetOriginalWordmark2 = _interopRequireDefault(_JeetOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JeetOriginalWordmark */
	function JeetOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JeetOriginalWordmark',
	    svg: _JeetOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JeetOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JeetOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jeet/original-wordmark/JeetOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><path d=\"M53.635 90.29c9.072 0 12.84 4.92 12.52 10.99-.19 7.282-7.35 11.686-14.06 11.69-4.146 0-5.784-1.68-6.203-2.957-.24-.73-1.056-.486-1.074.145-.104 3.742 1.98 8.304 8.433 8.304 4.92 0 8.88-2.81 8.88-2.81 1.343 1.34 1.853 2.81 1.79 4.47-.255 3.514-4.92 6.582-12.457 6.582-11.946 0-16.418-8.242-15.907-16.994.64-11.37 7.73-19.42 18.08-19.42M49.8 106.518c3.705 0 7.09-1.405 7.155-4.792.064-2.108-1.47-3.577-4.09-3.577-4.28 0-6.643 3.45-7.218 6.39-.065.51-.193 1.212-.193 1.212.32.128 1.79.767 4.345.767M85.577 90.29c9.072 0 12.84 4.92 12.52 10.99-.19 7.282-7.35 11.686-14.06 11.69-4.146 0-5.784-1.68-6.203-2.957-.24-.73-1.056-.486-1.074.145-.104 3.742 1.98 8.304 8.433 8.304 4.92 0 8.88-2.81 8.88-2.81 1.342 1.34 1.852 2.81 1.79 4.47-.256 3.514-4.92 6.582-12.458 6.582-11.946 0-16.418-8.242-15.907-16.994.64-11.37 7.73-19.42 18.08-19.42m-3.834 16.227c3.705 0 7.09-1.405 7.155-4.792.063-2.108-1.47-3.577-4.09-3.577-4.28 0-6.644 3.45-7.22 6.39-.063.51-.19 1.212-.19 1.212.32.128 1.79.767 4.344.767m21.65-7.475c-4.518 0-4.09-2.457-4.124-3.87-.036-1.467 1.46-3.348 2.89-3.623 4.14-.796 4.274-4.136 4.85-5.988.382-1.15.957-1.597 2.043-1.597h3.194c1.342 0 2.3.895 2.045 2.62a76.994 76.994 0 0 1-.64 4.343c1.343.063 1.006 0 3.18 0 3.22 0 4.47 1.697 4.46 4.32-.005 1.48-1.458 3.73-4.6 3.73h-4.06c-.767 5.174-1.725 12.01-2.172 15.906-.255 2.683.932 3.302 2.784 3.302 1.342.064 3.365-.996 4.083-1.574 2.826 3.317 2.094 10.09-7.046 10.09-6.643 0-9.845-5.093-9.08-11.673.448-3.578 2.193-15.988 2.193-15.988M32.91 82.624H22.414c-1.277 0-5.06.37-5.32 4.265-.23 3.47 1.528 5.08 5.462 5.08 2.022 0 4.147-1.476 5.084-2.012 1.08-.617 1.688.21.926.865-1.42 1.223-2.732 2.61-3.537 7.002l-2.132 13.034c-.64 4.407-2.555 6.515-5.75 6.515-2.874 0-4.896-1.613-6.593-3.85-3.393 1.08-5.167 5.786-2.687 8.91 1.13 1.422 3.467 4.268 9.408 4.268 6.16 0 13.178-2.996 14.913-14.885.847-5.81 3.21-21.018 3.593-23.7.32-2.427.704-5.494-2.873-5.494\" fill=\"#FF664A\"/><defs><path id=\"a\" d=\"M74.773 38.578a14.728 14.728 0 0 1-.47 2.37c-.094 5.356-4.308 9.706-9.61 10.016a14.71 14.71 0 0 1-2.956.65l-5.86 5.86 17.22 17.222 5.46-5.46c.422-7.52 6.444-13.54 13.963-13.962l4.582-4.582-17.222-17.22-5.107 5.106z\"/></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"/></clipPath><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"-284.432\" y1=\"-141.754\" x2=\"-284.009\" y2=\"-141.754\" gradientTransform=\"rotate(130.9 -7705.164 -218.84) scale(44.3)\"><stop offset=\"0\" stop-color=\"#09e09c\"/><stop offset=\"1\" stop-color=\"#00bfff\"/></linearGradient><path clip-path=\"url(#b)\" fill=\"url(#c)\" d=\"M117.5 51.13L79.443 95.096 35.477 57.037l38.06-43.965z\"/><defs><path id=\"d\" d=\"M31.353 50.173l5.107 5.107c6.835.778 12.258 6.2 13.037 13.036l5.86 5.86 17.222-17.22-5.462-5.46a14.743 14.743 0 0 1-3.116-.516c-5.395-.046-9.79-4.272-10.11-9.598a14.805 14.805 0 0 1-.736-3.848l-4.582-4.582-17.22 17.22z\"/></defs><clipPath id=\"e\"><use xlink:href=\"#d\" overflow=\"visible\"/></clipPath><linearGradient id=\"f\" gradientUnits=\"userSpaceOnUse\" x1=\"-279.176\" y1=\"-131.559\" x2=\"-278.753\" y2=\"-131.559\" gradientTransform=\"matrix(29.5 31 -31 29.5 4203.172 12582.555)\"><stop offset=\"0\" stop-color=\"#ffc800\"/><stop offset=\"1\" stop-color=\"#00bfff\"/></linearGradient><path clip-path=\"url(#e)\" fill=\"url(#f)\" d=\"M52.987 12.365l40.178 42.22-42.22 40.18-40.18-42.222z\"/><defs><path id=\"g\" d=\"M49.63 12.604c-.42 7.518-6.442 13.54-13.96 13.962l-4.584 4.582 17.22 17.22 5.108-5.106c.09-.8.248-1.582.462-2.338 0-.053-.004-.105-.004-.158 0-5.643 4.574-10.217 10.218-10.217.166 0 .33.004.495.01.608-.15 1.23-.262 1.866-.334l5.862-5.86-17.22-17.223-5.46 5.46z\"/></defs><clipPath id=\"h\"><use xlink:href=\"#g\" overflow=\"visible\"/></clipPath><linearGradient id=\"i\" gradientUnits=\"userSpaceOnUse\" x1=\"-291.496\" y1=\"-124.258\" x2=\"-291.073\" y2=\"-124.258\" gradientTransform=\"matrix(29 -29.5 29.5 29 12164.318 -4961.38)\"><stop offset=\"0\" stop-color=\"#ffc800\"/><stop offset=\"1\" stop-color=\"#ff664a\"/></linearGradient><path clip-path=\"url(#h)\" fill=\"url(#i)\" d=\"M10.477 28.108l40.87-41.574 41.575 40.87-40.87 41.574z\"/><defs><path id=\"j\" d=\"M55.315 24.888l5.46 5.46c.72.04 1.425.133 2.114.272.393-.046.794-.073 1.2-.073 5.643 0 10.218 4.574 10.218 10.217 0 .22-.01.44-.023.657.24.93.397 1.897.453 2.89l4.582 4.58 17.22-17.22-5.107-5.106c-6.835-.778-12.258-6.2-13.037-13.037l-5.86-5.86-17.22 17.22z\"/></defs><clipPath id=\"k\"><use xlink:href=\"#j\" overflow=\"visible\"/></clipPath><linearGradient id=\"l\" gradientUnits=\"userSpaceOnUse\" x1=\"-295.916\" y1=\"-137.458\" x2=\"-295.493\" y2=\"-137.458\" gradientTransform=\"rotate(-135.8 -5725.665 -6191.177) scale(48.1)\"><stop offset=\"0\" stop-color=\"#09e09c\"/><stop offset=\"1\" stop-color=\"#ff664a\"/></linearGradient><path clip-path=\"url(#k)\" fill=\"url(#l)\" d=\"M76.533 69.495l-41.82-40.61 40.608-41.82 41.824 40.608z\"/><path fill=\"#FFC800\" d=\"M38.69 55.596c-8.19 0-14.83-6.64-14.83-14.83 0-8.192 6.64-14.832 14.83-14.832s14.83 6.64 14.83 14.83c0 8.192-6.64 14.832-14.83 14.832\"/><path fill=\"#FF664A\" d=\"M63.702 30.584c-8.19 0-14.83-6.64-14.83-14.83 0-8.19 6.64-14.83 14.83-14.83 8.19 0 14.83 6.64 14.83 14.83 0 8.19-6.64 14.83-14.83 14.83\"/><path fill=\"#00BFFF\" d=\"M64.09 80.896c-8.19 0-14.83-6.64-14.83-14.83 0-8.19 6.64-14.83 14.83-14.83s14.83 6.64 14.83 14.83c0 8.19-6.64 14.83-14.83 14.83\"/><path fill=\"#09E09C\" d=\"M89.31 56.093c-8.19 0-14.83-6.64-14.83-14.83 0-8.19 6.64-14.83 14.83-14.83s14.83 6.64 14.83 14.83c0 8.19-6.64 14.83-14.83 14.83\"/><g><defs><path id=\"m\" d=\"M81.048-87.69a23.305 23.305 0 0 1-.744 3.75c-.15 8.476-6.817 15.36-15.206 15.85a23.25 23.25 0 0 1-4.68 1.03l-9.274 9.273 27.25 27.252 8.642-8.64c.667-11.898 10.196-21.428 22.093-22.094l7.25-7.25-27.25-27.25-8.082 8.08z\"/></defs><clipPath id=\"n\"><use xlink:href=\"#m\" overflow=\"visible\"/></clipPath><linearGradient id=\"o\" gradientUnits=\"userSpaceOnUse\" x1=\"-286.663\" y1=\"-140.146\" x2=\"-285.993\" y2=\"-140.146\" gradientTransform=\"rotate(130.9 -7705.164 -218.84) scale(44.3)\"><stop offset=\"0\" stop-color=\"#09e09c\"/><stop offset=\"1\" stop-color=\"#00bfff\"/></linearGradient><path clip-path=\"url(#n)\" fill=\"url(#o)\" d=\"M148.662-67.825L88.436 1.745 18.864-58.48l60.227-69.572z\"/><defs><path id=\"p\" d=\"M12.338-69.342l8.08 8.08c10.818 1.232 19.4 9.814 20.63 20.63l9.275 9.274L77.575-58.61l-8.64-8.642a23.367 23.367 0 0 1-4.932-.815c-8.537-.072-15.494-6.76-15.996-15.19a23.41 23.41 0 0 1-1.166-6.088l-7.25-7.25L12.34-69.342z\"/></defs><clipPath id=\"q\"><use xlink:href=\"#p\" overflow=\"visible\"/></clipPath><linearGradient id=\"r\" gradientUnits=\"userSpaceOnUse\" x1=\"-281.399\" y1=\"-133.334\" x2=\"-280.73\" y2=\"-133.334\" gradientTransform=\"matrix(29.5 31 -31 29.5 4203.172 12582.555)\"><stop offset=\"0\" stop-color=\"#ffc800\"/><stop offset=\"1\" stop-color=\"#00bfff\"/></linearGradient><path clip-path=\"url(#q)\" fill=\"url(#r)\" d=\"M46.572-129.17l63.58 66.812L43.34 1.222-20.24-65.59z\"/></g></svg>"

/***/ }),

/***/ "../src/components/jeet/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JeetOriginalWordmark = __webpack_require__("../src/components/jeet/original-wordmark/JeetOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JeetOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jeet/original/JeetOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JeetOriginal = __webpack_require__("../src/components/jeet/original/JeetOriginal.svg");
	
	var _JeetOriginal2 = _interopRequireDefault(_JeetOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JeetOriginal */
	function JeetOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JeetOriginal',
	    svg: _JeetOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JeetOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JeetOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jeet/original/JeetOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><defs><path id=\"a\" d=\"M81.048 60.31a23.305 23.305 0 0 1-.744 3.75c-.15 8.476-6.817 15.36-15.206 15.85a23.25 23.25 0 0 1-4.68 1.03l-9.274 9.273 27.25 27.252 8.642-8.64c.667-11.898 10.196-21.428 22.093-22.094l7.25-7.25-27.25-27.25-8.082 8.08z\"/></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"/></clipPath><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"-286.663\" y1=\"7.854\" x2=\"-285.993\" y2=\"7.854\" gradientTransform=\"rotate(130.9 -6240.933 3133.735) scale(44.3)\"><stop offset=\"0\" stop-color=\"#09e09c\"/><stop offset=\"1\" stop-color=\"#00bfff\"/></linearGradient><path clip-path=\"url(#b)\" fill=\"url(#c)\" d=\"M148.662 80.175l-60.226 69.57L18.864 89.52 79.09 19.948z\"/><defs><path id=\"d\" d=\"M12.338 78.658l8.08 8.08c10.818 1.232 19.4 9.814 20.63 20.63l9.275 9.274L77.575 89.39l-8.64-8.642a23.367 23.367 0 0 1-4.932-.815c-8.537-.072-15.494-6.76-15.996-15.19a23.41 23.41 0 0 1-1.166-6.088l-7.25-7.25L12.34 78.658z\"/></defs><clipPath id=\"e\"><use xlink:href=\"#d\" overflow=\"visible\"/></clipPath><linearGradient id=\"f\" gradientUnits=\"userSpaceOnUse\" x1=\"-281.399\" y1=\"14.666\" x2=\"-280.73\" y2=\"14.666\" gradientTransform=\"matrix(29.5 31 -31 29.5 8791.172 8364.555)\"><stop offset=\"0\" stop-color=\"#ffc800\"/><stop offset=\"1\" stop-color=\"#00bfff\"/></linearGradient><path clip-path=\"url(#e)\" fill=\"url(#f)\" d=\"M46.572 18.83l63.58 66.812-66.812 63.58-63.58-66.813z\"/><defs><path id=\"g\" d=\"M41.26 19.207C40.595 31.104 31.066 40.633 19.17 41.3l-7.252 7.25L39.17 75.802l8.082-8.082c.144-1.267.393-2.503.73-3.7 0-.084-.006-.166-.006-.25 0-8.93 7.24-16.168 16.17-16.168.26 0 .522.007.782.02a23.327 23.327 0 0 1 2.954-.53l9.274-9.275L49.9 10.567l-8.64 8.64z\"/></defs><clipPath id=\"h\"><use xlink:href=\"#g\" overflow=\"visible\"/></clipPath><linearGradient id=\"i\" gradientUnits=\"userSpaceOnUse\" x1=\"-289.46\" y1=\"21.371\" x2=\"-288.79\" y2=\"21.371\" gradientTransform=\"matrix(29 -29.5 29.5 29 7798.318 -9105.38)\"><stop offset=\"0\" stop-color=\"#ffc800\"/><stop offset=\"1\" stop-color=\"#ff664a\"/></linearGradient><path clip-path=\"url(#h)\" fill=\"url(#i)\" d=\"M-20.698 43.742l64.675-65.79 65.79 64.675-64.674 65.79z\"/><defs><path id=\"j\" d=\"M50.257 38.646l8.642 8.64a23.46 23.46 0 0 1 3.343.43 16.348 16.348 0 0 1 1.9-.114c8.93 0 16.17 7.24 16.17 16.168 0 .35-.014.695-.036 1.04.38 1.47.628 3 .716 4.57l7.25 7.25 27.252-27.252-8.082-8.082c-10.817-1.23-19.398-9.813-20.63-20.63l-9.274-9.274-27.253 27.254z\"/></defs><clipPath id=\"k\"><use xlink:href=\"#j\" overflow=\"visible\"/></clipPath><linearGradient id=\"l\" gradientUnits=\"userSpaceOnUse\" x1=\"-294.236\" y1=\"12.616\" x2=\"-293.566\" y2=\"12.616\" gradientTransform=\"rotate(-135.8 -7139.432 -2558.264) scale(48.1)\"><stop offset=\"0\" stop-color=\"#09e09c\"/><stop offset=\"1\" stop-color=\"#ff664a\"/></linearGradient><path clip-path=\"url(#k)\" fill=\"url(#l)\" d=\"M83.834 109.235L17.652 44.972 81.916-21.21l66.182 64.264z\"/><path fill=\"#FFC800\" d=\"M23.948 87.24C10.988 87.24.48 76.732.48 63.77c0-12.96 10.507-23.468 23.468-23.468s23.468 10.507 23.468 23.47c0 12.96-10.507 23.468-23.468 23.468\"/><path fill=\"#FF664A\" d=\"M63.528 47.66c-12.96 0-23.468-10.507-23.468-23.468C40.06 11.23 50.566.722 63.528.722c12.96 0 23.468 10.508 23.468 23.47 0 12.96-10.508 23.468-23.468 23.468\"/><path fill=\"#00BFFF\" d=\"M64.143 127.277c-12.96 0-23.468-10.507-23.468-23.468 0-12.963 10.507-23.47 23.468-23.47S87.61 90.847 87.61 103.81c0 12.96-10.506 23.467-23.467 23.467\"/><path fill=\"#09E09C\" d=\"M104.052 88.027c-12.96 0-23.468-10.507-23.468-23.468 0-12.963 10.507-23.47 23.468-23.47s23.468 10.507 23.468 23.47c0 12.96-10.507 23.467-23.468 23.467\"/></svg>"

/***/ }),

/***/ "../src/components/jeet/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JeetOriginal = __webpack_require__("../src/components/jeet/original/JeetOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JeetOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jeet/plain-wordmark/JeetPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JeetPlainWordmark = __webpack_require__("../src/components/jeet/plain-wordmark/JeetPlainWordmark.svg");
	
	var _JeetPlainWordmark2 = _interopRequireDefault(_JeetPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JeetPlainWordmark */
	function JeetPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JeetPlainWordmark',
	    svg: _JeetPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JeetPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JeetPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jeet/plain-wordmark/JeetPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M53.635 90.29c-10.35 0-17.44 8.05-18.08 19.42-.51 8.753 3.96 16.995 15.908 16.995 7.54 0 12.202-3.067 12.457-6.58.064-1.662-.447-3.13-1.79-4.473 0 0-3.96 2.81-8.88 2.81-6.45 0-8.536-4.56-8.432-8.303.018-.633.834-.877 1.074-.146.42 1.278 2.057 2.958 6.204 2.956 6.708-.003 13.868-4.408 14.06-11.69.32-6.07-3.45-10.99-12.52-10.99zm-3.833 16.227c-2.555 0-4.025-.64-4.344-.767 0 0 .128-.702.192-1.213.575-2.94 2.94-6.388 7.22-6.388 2.618 0 4.152 1.468 4.088 3.576-.065 3.386-3.45 4.79-7.156 4.79zM85.577 90.29c-10.35 0-17.44 8.05-18.08 19.42-.51 8.753 3.96 16.995 15.908 16.995 7.54 0 12.202-3.067 12.457-6.58.064-1.662-.447-3.13-1.79-4.473 0 0-3.96 2.81-8.88 2.81-6.45 0-8.536-4.56-8.432-8.303.018-.633.834-.877 1.074-.146.42 1.278 2.057 2.958 6.204 2.956 6.708-.003 13.868-4.408 14.06-11.69.32-6.07-3.45-10.99-12.52-10.99zm-3.833 16.227c-2.555 0-4.024-.64-4.344-.767 0 0 .128-.702.192-1.213.575-2.94 2.94-6.388 7.22-6.388 2.618 0 4.152 1.468 4.088 3.576-.065 3.386-3.45 4.79-7.156 4.79zM112.63 99h4.062c3.142 0 4.594-2.26 4.6-3.74.008-2.623-1.24-4.325-4.462-4.325-2.173 0-1.836.06-3.178-.003a75.26 75.26 0 0 0 .64-4.328c.254-1.725-.703-2.604-2.045-2.604h-3.194c-1.086 0-1.66.43-2.044 1.58-.576 1.852-.71 5.184-4.85 5.98-1.43.273-2.926 2.15-2.89 3.616.032 1.414-.395 3.868 4.123 3.868 0 0-1.746 12.41-2.193 15.987-.766 6.58 2.436 11.675 9.08 11.675 9.14 0 9.872-6.775 7.046-10.09-.718.577-2.74 1.637-4.083 1.573-1.852 0-3.04-.608-2.784-3.29.446-3.9 1.404-10.898 2.17-15.898zM32.91 83H22.414c-1.277 0-5.06.183-5.32 4.077-.23 3.47 1.528 4.987 5.462 4.987 2.022 0 4.147-1.523 5.084-2.06 1.08-.616 1.688.187.926.843-1.42 1.223-2.732 2.6-3.537 6.99l-2.132 13.028c-.64 4.408-2.555 6.513-5.75 6.513-2.874 0-4.896-1.614-6.593-3.85-3.393 1.08-5.167 5.783-2.687 8.907 1.13 1.422 3.467 4.267 9.408 4.267 6.16 0 13.178-2.996 14.913-14.885.847-5.81 3.21-20.83 3.593-23.513.32-2.425.704-5.304-2.873-5.304zm59.21-55.992l-.025-.026c-7-.797-12.554-6.35-13.35-13.35l-.04-.04C77.59 6.306 71.296.723 63.696.723c-8.39 0-15.19 6.8-15.19 15.19 0 .238.008.475.02.712a15.205 15.205 0 0 1-10.018 9.724c-.143-.004-.285-.01-.428-.01-8.39 0-15.19 6.8-15.19 15.187 0 8.2 6.498 14.877 14.625 15.174 5.75 1.34 10.248 5.933 11.426 11.744.52 7.918 7.103 14.18 15.152 14.18 8.12 0 14.75-6.372 15.167-14.388A15.202 15.202 0 0 1 89.08 57.2c.278.014.557.023.838.023 8.388 0 15.188-6.8 15.188-15.188 0-7.64-5.642-13.96-12.987-15.027zM53.63 41.525c0-5.384 4.068-9.814 9.297-10.395.083-.01.167-.015.25-.023.095-.008.192-.01.287-.014.078 0 .154.006.232.006.256 0 .51-.008.763-.02 5.61.194 10.1 4.79 10.1 10.445 0 .08-.006.156-.008.234-.12 5.463-4.425 9.894-9.84 10.21-.115.038-.233.07-.35.106-.12-.03-.24-.057-.36-.09-5.524-.046-10.026-4.374-10.35-9.83-.027-.078-.047-.16-.072-.24.02-.075.034-.153.055-.228-.002-.055-.005-.108-.005-.163z\" fill=\"#FF664A\"/></svg>"

/***/ }),

/***/ "../src/components/jeet/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JeetPlainWordmark = __webpack_require__("../src/components/jeet/plain-wordmark/JeetPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JeetPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jeet/plain/JeetPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JeetPlain = __webpack_require__("../src/components/jeet/plain/JeetPlain.svg");
	
	var _JeetPlain2 = _interopRequireDefault(_JeetPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JeetPlain */
	function JeetPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JeetPlain',
	    svg: _JeetPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JeetPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JeetPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jeet/plain/JeetPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#FF664A\" d=\"M107.453 41.338l-.04-.04c-10.817-1.23-19.398-9.813-20.63-20.63l-.058-.058C85 9.35 75.27.723 63.528.723c-12.962 0-23.47 10.507-23.468 23.47 0 .368.01.735.028 1.1A23.49 23.49 0 0 1 24.61 40.318c-.22-.006-.44-.017-.66-.017C10.987 40.3.48 50.81.48 63.77c0 12.67 10.04 22.988 22.598 23.447 8.885 2.07 15.835 9.17 17.655 18.148.802 12.234 10.974 21.91 23.41 21.91 12.548 0 22.794-9.845 23.437-22.23a23.49 23.49 0 0 1 15.178-17.056c.43.022.86.036 1.295.036 12.96 0 23.468-10.507 23.468-23.468 0-11.806-8.718-21.572-20.067-23.22zM47.973 63.77c0-8.32 6.285-15.164 14.366-16.062.127-.014.257-.023.387-.035.146-.013.295-.014.442-.022.12.003.238.01.358.01.395 0 .788-.01 1.178-.03 8.667.3 15.606 7.4 15.606 16.14 0 .12-.01.24-.013.36-.187 8.444-6.837 15.29-15.202 15.78-.18.058-.362.108-.542.163-.185-.046-.372-.088-.555-.138-8.536-.072-15.493-6.76-15.995-15.19-.04-.12-.072-.247-.11-.37.03-.117.052-.238.085-.354 0-.083-.007-.165-.007-.25z\"/></svg>"

/***/ }),

/***/ "../src/components/jeet/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JeetPlain = __webpack_require__("../src/components/jeet/plain/JeetPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JeetPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jetbrains/original/JetbrainsOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JetbrainsOriginal = __webpack_require__("../src/components/jetbrains/original/JetbrainsOriginal.svg");
	
	var _JetbrainsOriginal2 = _interopRequireDefault(_JetbrainsOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JetbrainsOriginal */
	function JetbrainsOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JetbrainsOriginal',
	    svg: _JetbrainsOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JetbrainsOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JetbrainsOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jetbrains/original/JetbrainsOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><path fill=\"#00619E\" d=\"M126.7 56.4c-2.7-1.5-3.7-2-5.3-2-1.5 0-2.2.7-2.2 1.9 0 3.5 8.3 2.5 8.3 10.6 0 4.4-2.4 7.1-6.6 7.1-2.5 0-3.7-1.1-5.6-2.3v-5c2.7 2.2 3.7 3 5.7 3 1.5 0 2.2-.8 2.2-2.2 0-3.8-8.3-2.4-8.3-10.7 0-4 1.7-6.6 5.9-6.6 2.1 0 3.4.5 5.7 1.8v4.4h.2zm-64.4-6.1c3.8 0 5.5 3.2 5.5 6.6 0 2.5-1 4.4-3.2 5.6-.6.3-.9.3-1.3.4l6.4 10.4h-4.5l-6-9.4v9.4h-4.1v-23h7.2zm-3.1 9.5h1.9c1.3 0 2.6-.7 2.6-2.6 0-1.8-.9-2.6-2.7-2.6h-1.8v5.2zm29.9 13.6h-4.4l-1.5-4.6H76l-1.4 4.6h-4.3l6.9-23.1h4.3l7.6 23.1zm-9.7-17.6l-2.2 9h4.6l-2.4-9zm15.1 17.6h-4.1V50.3h4.1v23.1zm18.8 0H110l-8.6-14.8v14.8h-4V50.3h3.6l8.3 14.1V50.3h4v23.1zm-64-12.7c1.6-.9 2.6-2.6 2.6-4.6 0-1-.2-2.1-.7-3.1-1.5 1.3-3.1 2.8-3.6 3.2.1.3.1.5.1.8 0 1.2-.7 2.5-2.3 2.5H44v-5.6l4.8-3.2c-.7-.3-1.5-.5-2.5-.5h-6.4v23.1h6.8c5.4 0 6.6-4.1 6.6-6.8 0-2.6-1.3-5-4-5.8m-3.9 8.4H44v-5.4h2.1c1.6 0 2.8.9 2.8 2.6 0 2-.9 2.8-3.5 2.8\"/><defs><path id=\"a\" d=\"M.4 40.9h127.2V87H.4z\"/></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"/></clipPath><path clip-path=\"url(#b)\" fill=\"#F68B1F\" d=\"M55.1 47.6c-.3-.2-3.2 1.7-5.1 3l-.7.4-4.8 3.2v3.6c1-.7 1.8-1.4 2.4-1.9l3.6-3.1s1.8-1.6 2.7-2.5l.3-.3c.3-.2.4-.4.4-.6.1-.3 1.3-1.8 1.2-1.8M36.3 62.7l2.9-2v-3.6l-2.6 1.7s-2.3 1.5-3.1 2c.1-.5.1-.9.1-.9.4-3 .8-6 .8-8.1 0-1-.1-1.7-.3-2.1-.2-.3-.4-.4-.7-.5-.4-.1-.8.1-1.2.4-1.3.9-2 3.6-2 8.2 0 1.5.1 3.2.2 5.1-.2.1-.9.8-.9.8l-1.3 1.2-.1.1c-1.2 1.1-2 1.7-2.3 1.8-.4.1-.7.2-1 .2 1.7-1.2 3-3.9 3-5.4 0-.2 0-.3-.1-.5-.3-1.1-.8-1.9-1.6-2.3-.7-.4-1.6-.4-2.7 0l-.4.2c-1.8.8-7.5 4-9.2 5 .2-2.5 1.2-13.7 1.5-19.6.2-3.8 0-1.5 0-2.2 0-2.8-3.5 0-5.4 1.9-.8.8-3.3 3.1-2.4 4.9 1 1.9 2 1.3 2.6 4.5 1 5.7.2 11.6.2 12-.3.1-2.7 1.3-2.7 1.3C3.5 68.7.3 70.2.3 72.6c0 .4.1.8.2 1.2 3.4 9 8.1 13.8 10 13.3 2.7-.7 2.8-4.2 3-9.6.1-2.7.2-5.7.6-9 .2-.1 4.7-3.5 5.6-4-.4.8-.4 1.6-.4 2 0 1.1.2 1.9.4 2.4.4.8.7 1.3 1.5 1.7 1.1.5 2 .6 3.8-.1.8-.3 2.2-1.3 3.7-2.6.3.5 1.6 2.8 1.6 2.8l1.2 2.1c.5 1 1.4 1.3 2.4.8.7-.4 1.2-.7 1.4-1.2v-.3c0-.3-.1-.6-.3-.9-1.4-2.5-1.5-4.7-1.5-6.3v-.3c.3-.2 2.8-1.9 2.8-1.9M9 79.7c-1.1-.9-1.6-1.6-2.4-3.6-1.4-3.3.5-4.3 3.9-6.2-.4 3.5-.7 10.6-1.5 9.8m13.6-14.1c0-1.2-.3-2.8 1.3-3.7.6-.3 1-.1 1.2.1.4.5-.6 2.4-2.5 3.6\"/></svg>"

/***/ }),

/***/ "../src/components/jetbrains/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JetbrainsOriginal = __webpack_require__("../src/components/jetbrains/original/JetbrainsOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JetbrainsOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jetbrains/plain/JetbrainsPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JetbrainsPlain = __webpack_require__("../src/components/jetbrains/plain/JetbrainsPlain.svg");
	
	var _JetbrainsPlain2 = _interopRequireDefault(_JetbrainsPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JetbrainsPlain */
	function JetbrainsPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JetbrainsPlain',
	    svg: _JetbrainsPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JetbrainsPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JetbrainsPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jetbrains/plain/JetbrainsPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M119.2 54.2c0-1.2.8-1.9 2.3-1.9 1.6 0 2.5.5 5.5 2v-4.5c-3-1.3-3.8-1.8-5.8-1.8-4.3 0-6 2.6-6 6.6 0 8.3 8.2 6.9 8.2 10.7 0 1.4-.9 2.2-2.4 2.2-2 0-3-.8-6-3v5c2 1.2 3.3 2.3 5.8 2.3 4.1 0 6.7-2.6 6.7-7.1 0-8-8.3-7-8.3-10.5zm-54.6 6.3c2.1-1.2 3.2-3.3 3.2-5.8 0-3.5-1.7-6.8-5.5-6.8H55v23h4v-9l6.2 9h4.5l-6.4-10.2c.5 0 .8.1 1.3-.2zM61.1 58H59v-6h2c1.7 0 2.7 1.2 2.7 3-.1 2-1.3 3-2.6 3zm16-10l-6.9 23h4.3l1.4-4h7.2l1.5 4H89l-7.6-23h-4.3zm.1 15l2.2-9 2.4 9h-4.6zM90 48h4v23h-4zm19 14.4L101 48h-4v23h4V56.5l9 14.5h3V48h-4zm-59.7-3.8c1.6-1 2.6-2.6 2.6-4.6 0-1-.2-2.1-.7-3.1-1.5 1.3-3.1 2.8-3.6 3.2.1.3.1.3.1.6 0 1.2-.7 2.3-2.3 2.3H44v-5.2l4.8-3.3c-.7-.3-1.6-.6-2.6-.6H40v23h6.7c5.4 0 6.6-3.9 6.6-6.6 0-2.6-1.3-4.8-4-5.7zM45.4 67H44v-5h2.1c1.6 0 2.8.7 2.8 2.4 0 2-.9 2.6-3.5 2.6zM50 48.5l-.5.5-4.5 3.2v3.6c1-.7 1.6-1.4 2.2-1.9l3.5-3.1s1.7-1.6 2.7-2.5l.3-.3c.3-.2.4-.4.4-.6 0-.1 1.1-1.6 1-1.7-.3-.3-3.3 1.5-5.1 2.8zM33.5 58.9c.1-.5.1-.9.1-.9.4-3 .8-6 .8-8.1 0-1-.1-1.7-.3-2.1-.2-.3-.4-.4-.7-.5-.4-.1-.8.1-1.2.4-1.3.9-2 3.6-2 8.2 0 1.5.1 3.2.2 5.1-.2.1-.9.8-.9.8L28.2 63l-.1.1c-1.2 1.1-2 1.7-2.3 1.8-.4.1-.7.2-1 .2 1.7-1.2 3-3.9 3-5.4 0-.2 0-.3-.1-.5-.3-1.1-.8-1.9-1.6-2.3-.7-.4-1.6-.4-2.7 0l-.4.2c-1.8.8-7.5 4-9.2 5 .2-2.5 1.2-13.7 1.5-19.6.2-3.8 0-1.5 0-2.2 0-2.8-3.5 0-5.4 1.9-.8.8-3.3 3.1-2.4 4.9 1 1.9 2 1.3 2.6 4.5 1 5.7.2 11.6.2 12-.3.1-2.7 1.3-2.7 1.3C3.5 66.8.3 68.3.3 70.7c0 .4.1.8.2 1.2 3.4 9 8.1 13.8 10 13.3 2.7-.7 2.8-4.2 3-9.6.1-2.7.2-5.7.6-9 .2-.1 4.7-3.5 5.6-4-.4.8-.4 1.6-.4 2 0 1.1.2 1.9.4 2.4.4.8.7 1.3 1.5 1.7 1.1.5 2 .6 3.8-.1.8-.3 2.2-1.3 3.7-2.6.3.5 1.6 2.8 1.6 2.8l1.2 2.1c.5 1 1.4 1.3 2.4.8.7-.4 1.2-.7 1.4-1.2v-.3c0-.3.1-.6-.1-.9-1.4-2.5-1.3-4.7-1.3-6.3v-.3c0-.2 2.4-1.9 2.4-1.9l2.6-2v-3.6l-2.5 1.7c.1-.1-2.1 1.4-2.9 2zM9 77.7c-1.1-.9-1.6-1.6-2.4-3.6-1.4-3.3.5-4.3 3.9-6.2-.4 3.4-.7 10.6-1.5 9.8zm13.6-14.1c0-1.2-.3-2.8 1.3-3.7.6-.3 1-.1 1.2.1.4.5-.6 2.4-2.5 3.6z\" fill=\"#F68B1F\"/></svg>"

/***/ }),

/***/ "../src/components/jetbrains/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JetbrainsPlain = __webpack_require__("../src/components/jetbrains/plain/JetbrainsPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JetbrainsPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jquery/original-wordmark/JqueryOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JqueryOriginalWordmark = __webpack_require__("../src/components/jquery/original-wordmark/JqueryOriginalWordmark.svg");
	
	var _JqueryOriginalWordmark2 = _interopRequireDefault(_JqueryOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JqueryOriginalWordmark */
	function JqueryOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JqueryOriginalWordmark',
	    svg: _JqueryOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JqueryOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JqueryOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jquery/original-wordmark/JqueryOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#0868AC\" d=\"M27.758 20.421c-7.352 10.565-6.437 24.312-.82 35.54l.411.798.263.506.164.291.293.524c.174.307.353.612.536.919l.306.504c.203.326.41.65.622.973l.265.409c.293.437.592.872.901 1.301l.026.033.152.205c.267.368.542.732.821 1.093l.309.393c.249.313.502.623.759.934l.29.346c.345.406.698.812 1.057 1.208l.021.022.041.045c.351.383.71.758 1.075 1.133l.344.347c.282.284.569.563.858.841l.351.334c.387.364.777.722 1.176 1.07l.018.016.205.174c.351.305.708.605 1.068.902l.442.353c.294.235.591.468.89.696l.477.361c.33.243.663.482.999.717l.363.258.101.072c.318.22.645.431.97.642l.42.28c.5.315 1.007.628 1.519.93l.42.237c.377.217.756.431 1.14.639l.631.326.816.424.188.091.334.161c.427.204.858.405 1.293.599l.273.122c.498.218 1.001.427 1.508.628l.368.144c.469.182.945.359 1.423.527l.179.062c.524.184 1.054.353 1.587.52l.383.114c.542.164 1.079.358 1.638.462 35.553 6.483 45.88-21.364 45.88-21.364-8.674 11.3-24.069 14.28-38.656 10.962-.553-.125-1.089-.298-1.628-.456l-.406-.124a44.793 44.793 0 0 1-1.568-.51l-.215-.077a49.537 49.537 0 0 1-1.382-.513l-.388-.152c-.501-.198-1-.405-1.492-.62l-.298-.133a55.398 55.398 0 0 1-1.259-.585l-.364-.175c-.327-.159-.65-.328-.974-.495l-.649-.341c-.395-.21-.782-.43-1.167-.654l-.394-.219a58.203 58.203 0 0 1-1.52-.932l-.41-.273a40.515 40.515 0 0 1-1.081-.719l-.349-.245a54.203 54.203 0 0 1-1.022-.738l-.453-.343c-.31-.237-.618-.476-.922-.721l-.411-.33c-.388-.318-.771-.64-1.149-.969l-.126-.105a54.797 54.797 0 0 1-1.208-1.098l-.34-.328a33.158 33.158 0 0 1-.868-.851l-.34-.34c-.362-.37-.717-.745-1.065-1.126l-.053-.057a41.973 41.973 0 0 1-1.08-1.229l-.283-.336a44.66 44.66 0 0 1-.777-.961l-.285-.355a52.469 52.469 0 0 1-.898-1.195c-8.098-11.047-11.008-26.283-4.535-38.795m17.081-1.626c-5.316 7.65-5.028 17.893-.88 25.983a33.747 33.747 0 0 0 2.351 3.925c.796 1.143 1.68 2.501 2.737 3.418.383.422.784.834 1.193 1.238l.314.311c.397.385.801.764 1.218 1.132l.05.043.012.012c.462.405.939.794 1.423 1.178l.323.252c.486.372.981.738 1.489 1.087l.043.033.68.447.322.213c.363.233.73.459 1.104.676l.156.092c.322.185.648.367.975.545l.347.18.682.354.103.047c.469.23.941.453 1.424.663l.314.13c.386.163.775.323 1.167.473l.5.184c.356.132.712.253 1.072.373l.484.155c.511.158 1.017.359 1.549.448 27.45 4.547 33.787-16.588 33.787-16.588-5.712 8.228-16.775 12.153-28.58 9.089a34.726 34.726 0 0 1-1.555-.449l-.467-.151a29 29 0 0 1-1.087-.374l-.491-.183a38.673 38.673 0 0 1-1.171-.473l-.315-.133a32.78 32.78 0 0 1-1.432-.666l-.718-.365-.414-.213c-.306-.166-.61-.338-.909-.514l-.217-.123a30.75 30.75 0 0 1-1.1-.672l-.332-.221-.712-.472a37.364 37.364 0 0 1-1.484-1.085l-.334-.264c-5.167-4.079-9.263-9.655-11.21-15.977-2.041-6.557-1.601-13.917 1.935-19.891m14.847-.518c-3.134 4.612-3.442 10.341-1.267 15.435 2.293 5.407 6.992 9.648 12.477 11.66l.682.235.3.096c.323.102.644.22.978.282 15.157 2.929 19.268-7.777 20.362-9.354-3.601 5.185-9.653 6.43-17.079 4.627a18.837 18.837 0 0 1-1.796-.555 22.303 22.303 0 0 1-2.134-.886 22.19 22.19 0 0 1-3.741-2.282c-6.645-5.042-10.772-14.659-6.436-22.492\"/><path fill=\"#131B28\" d=\"M66.359 96.295h-4.226a.556.556 0 0 0-.517.417l-1.5 6.94-1.5 6.94a.554.554 0 0 1-.516.417h-2.991c-2.959 0-2.617-2.047-2.011-4.851l.018-.085.066-.354.012-.066.135-.72.145-.771.154-.785.682-3.332.683-3.332a.336.336 0 0 0-.341-.419h-4.337a.55.55 0 0 0-.514.418l-.933 4.424-.932 4.425-.002.006-.086.412c-1.074 4.903-.79 9.58 5.048 9.727l.17.003h9.163a.554.554 0 0 0 .516-.417l1.976-9.289 1.976-9.29c.049-.23-.103-.417-.338-.418zm-45.256-.049h-4.64a.562.562 0 0 0-.521.416l-.44 1.942-.44 1.942c-.051.229.098.416.333.416h4.676a.556.556 0 0 0 .518-.417l.425-1.941.425-1.941c.049-.229-.101-.417-.336-.417zm-1.346 6.044H15.08a.563.563 0 0 0-.521.416l-.657 2.91-.656 2.909-.183.834-.631 2.97-.63 2.971c-.049.229-.15.599-.225.821 0 0-.874 2.6-2.343 2.57l-.184-.004-1.271-.023h-.001a.558.558 0 0 0-.524.407l-.485 2.039-.484 2.038c-.055.228.093.416.326.42.833.01 2.699.031 3.828.031 3.669 0 5.604-2.033 6.843-7.883l1.451-6.714 1.361-6.297c.049-.227-.103-.415-.337-.415zm86.117-1.574l-.194-.801-.191-.82-.097-.414c-.38-1.477-1.495-2.328-3.917-2.328l-3.77-.004-3.472-.005h-3.907a.552.552 0 0 0-.515.417l-.173.816-.204.964-.057.271-1.759 8.24-1.67 7.822c-.05.23-.066.512-.038.626.028.115.479.209.713.209h3.524c.235 0 .532-.042.66-.094s.317-.513.364-.742l.626-3.099.627-3.1.001-.005.084-.413.76-3.56.671-3.144a.555.555 0 0 1 .515-.417l11.089-.005c.235.002.383-.185.33-.414zm14.275-7.24l-.854.003h-3.549a.904.904 0 0 0-.667.353l-7.849 11.498c-.132.194-.283.166-.335-.062l-.578-2.533a.562.562 0 0 0-.522-.416h-5.045c-.235 0-.374.184-.31.409l2.261 7.921c.064.226.069.596.011.824l-.985 3.833c-.059.228.085.413.32.413h4.987a.58.58 0 0 0 .532-.413l.986-3.833a2.52 2.52 0 0 1 .363-.755l12.742-16.911c.142-.188.065-.341-.169-.339l-1.339.008zm-40.086 9.919v-.004a.514.514 0 0 1-.499.441h-6.397c-.222 0-.334-.15-.301-.336l.006-.015-.004.002.003-.021.029-.109c.611-1.624 1.855-2.69 4.194-2.69 2.634-.001 3.148 1.285 2.969 2.732zm-1.877-7.384c-8.211 0-10.157 4.984-11.249 10.015-1.091 5.128-.998 9.921 7.5 9.921h1.03l.256-.001h.06l1.02-.003h.018c2.244-.009 4.495-.026 5.406-.033a.553.553 0 0 0 .509-.42l.344-1.681.067-.327.41-2.006a.335.335 0 0 0-.341-.418h-7.639c-3.039 0-3.941-.807-3.608-3.181H84.18l-.001.001.008-.001a.503.503 0 0 0 .445-.315l.029-.106-.001.001c1.813-6.839 1.293-11.445-6.474-11.446zm-38.81 7.358l-.116.409v.001l-.922 3.268-.922 3.267a.596.596 0 0 1-.543.411h-4.88c-3.702 0-4.604-2.896-3.702-7.166.901-4.368 2.668-7.083 6.312-7.358 4.98-.376 5.976 3.126 4.773 7.168zm3.348 7.105s2.301-5.588 2.823-8.814c.713-4.319-1.45-10.585-9.804-10.585-8.306 0-11.914 5.981-13.29 12.484-1.376 6.55.427 12.293 8.686 12.246l6.516-.024 6.089-.022a.59.59 0 0 0 .534-.414l1.061-4.046c.059-.228-.084-.414-.319-.416l-1.017-.006-1.017-.006c-.199-.001-.313-.131-.289-.302l.027-.095zm41.12-3.741a.28.28 0 1 1-.56.001.28.28 0 0 1 .56-.001z\"/></svg>"

/***/ }),

/***/ "../src/components/jquery/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JqueryOriginalWordmark = __webpack_require__("../src/components/jquery/original-wordmark/JqueryOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JqueryOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jquery/original/JqueryOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JqueryOriginal = __webpack_require__("../src/components/jquery/original/JqueryOriginal.svg");
	
	var _JqueryOriginal2 = _interopRequireDefault(_JqueryOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JqueryOriginal */
	function JqueryOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JqueryOriginal',
	    svg: _JqueryOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JqueryOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JqueryOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jquery/original/JqueryOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#0868AC\" d=\"M9.625 32.181C-1.404 48.032-.031 68.657 8.394 85.501c.2.404.41.801.617 1.198l.394.759.246.437.439.786c.262.461.53.92.804 1.379l.459.756c.304.491.615.976.933 1.46l.398.614c.439.655.888 1.309 1.352 1.951l.039.05.228.308c.401.553.814 1.099 1.232 1.639l.464.59c.373.469.752.935 1.138 1.399l.435.52a75.27 75.27 0 0 0 1.586 1.812l.033.033.061.068a80.44 80.44 0 0 0 1.612 1.699l.517.521c.423.426.853.845 1.287 1.262l.527.5c.58.547 1.166 1.083 1.764 1.607l.028.022.307.262c.527.456 1.063.909 1.603 1.353l.664.529c.441.354.887.702 1.336 1.044l.714.543c.496.365.995.724 1.499 1.075l.546.387.15.107c.478.329.967.646 1.456.963l.63.42c.75.474 1.51.943 2.279 1.396l.63.355c.565.326 1.134.646 1.71.959.312.168.632.327.946.488.407.213.811.429 1.225.636l.283.137.501.242c.641.306 1.287.607 1.94.897l.41.184a66.92 66.92 0 0 0 2.263.941l.551.217c.704.271 1.418.539 2.135.791l.268.093c.787.275 1.581.53 2.381.779l.575.172c.814.245 1.619.538 2.458.693 53.339 9.727 68.833-32.053 68.833-32.053-13.013 16.953-36.111 21.425-57.996 16.446-.829-.187-1.633-.446-2.442-.685l-.609-.185a72.498 72.498 0 0 1-2.352-.765l-.323-.117a72.245 72.245 0 0 1-2.074-.769l-.582-.229c-.752-.297-1.5-.607-2.239-.931l-.447-.198a92.857 92.857 0 0 1-1.889-.879l-.546-.262c-.491-.239-.977-.493-1.461-.743-.324-.171-.654-.332-.975-.51a58.591 58.591 0 0 1-1.751-.982l-.591-.33a81.221 81.221 0 0 1-2.28-1.397l-.615-.41a59.283 59.283 0 0 1-1.623-1.079l-.522-.367a89.287 89.287 0 0 1-1.534-1.109l-.679-.514a64.473 64.473 0 0 1-1.384-1.082l-.617-.495a82.693 82.693 0 0 1-1.724-1.453l-.189-.159a83.466 83.466 0 0 1-1.812-1.647l-.511-.491c-.441-.42-.875-.843-1.302-1.277l-.51-.509a70.541 70.541 0 0 1-1.598-1.69l-.079-.084a67.39 67.39 0 0 1-1.621-1.844l-.424-.504a70.602 70.602 0 0 1-1.167-1.442l-.427-.532a78.406 78.406 0 0 1-1.347-1.794c-12.15-16.574-16.516-39.432-6.805-58.204m25.629-2.434c-7.977 11.478-7.543 26.844-1.321 38.983a50.581 50.581 0 0 0 3.528 5.889c1.195 1.713 2.52 3.751 4.106 5.127a48.111 48.111 0 0 0 1.79 1.858l.472.465a51.69 51.69 0 0 0 1.828 1.698l.074.064.018.018a55.268 55.268 0 0 0 2.135 1.767l.485.378a54.08 54.08 0 0 0 2.233 1.631l.065.049c.336.232.678.448 1.019.672l.483.319c.544.349 1.095.689 1.655 1.015l.235.136c.483.278.972.552 1.463.818l.521.271c.339.177.678.358 1.023.53l.155.07c.703.346 1.412.68 2.136.995l.472.194c.579.246 1.164.486 1.75.71l.75.275c.533.198 1.068.378 1.607.559l.727.233c.767.238 1.525.539 2.324.672 41.183 6.823 50.691-24.886 50.691-24.886-8.57 12.343-25.168 18.233-42.879 13.635a50.376 50.376 0 0 1-2.333-.674l-.701-.227a45.423 45.423 0 0 1-1.631-.562l-.736-.274a56.418 56.418 0 0 1-1.756-.708l-.473-.2a47.728 47.728 0 0 1-2.148-.999c-.363-.177-.72-.364-1.078-.548l-.622-.32a44.502 44.502 0 0 1-1.363-.77l-.326-.185a47.844 47.844 0 0 1-1.651-1.008l-.498-.332a61.759 61.759 0 0 1-1.069-.707 57.456 57.456 0 0 1-2.226-1.628l-.501-.395c-7.752-6.12-13.898-14.486-16.819-23.971-3.062-9.836-2.402-20.878 2.903-29.84m22.278-.775c-4.702 6.92-5.164 15.514-1.901 23.156 3.441 8.113 10.491 14.476 18.72 17.495.339.125.679.237 1.022.354l.451.143c.485.152.966.329 1.467.424 22.74 4.394 28.908-11.669 30.549-14.034-5.402 7.779-14.482 9.646-25.623 6.942-.88-.213-1.847-.531-2.695-.832a33.242 33.242 0 0 1-3.201-1.329 33.215 33.215 0 0 1-5.612-3.424c-9.969-7.565-16.162-21.994-9.657-33.745\"/></svg>"

/***/ }),

/***/ "../src/components/jquery/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JqueryOriginal = __webpack_require__("../src/components/jquery/original/JqueryOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JqueryOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jquery/plain-wordmark/JqueryPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JqueryPlainWordmark = __webpack_require__("../src/components/jquery/plain-wordmark/JqueryPlainWordmark.svg");
	
	var _JqueryPlainWordmark2 = _interopRequireDefault(_JqueryPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JqueryPlainWordmark */
	function JqueryPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JqueryPlainWordmark',
	    svg: _JqueryPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JqueryPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JqueryPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jquery/plain-wordmark/JqueryPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#0868AC\" d=\"M47.961 79.02l.193.094.344.166c.439.209.882.416 1.329.615l.281.125c.513.225 1.029.439 1.551.645l.378.148c.482.188.972.37 1.463.543l.184.063c.539.188 1.083.363 1.632.534l.395.117c.558.169 1.109.37 1.685.477 36.554 6.665 47.171-21.967 47.171-21.967-8.918 11.618-24.747 14.683-39.745 11.271-.568-.128-1.12-.306-1.674-.47l-.417-.126a51.381 51.381 0 0 1-1.612-.524l-.221-.08a51.147 51.147 0 0 1-1.421-.527l-.398-.156a43.031 43.031 0 0 1-1.534-.638l-.307-.136a61.098 61.098 0 0 1-1.294-.602l-.375-.18c-.336-.164-.669-.339-1.001-.51l-.668-.35a37.935 37.935 0 0 1-1.199-.673l-.405-.226a58.779 58.779 0 0 1-1.563-.958l-.421-.28a41.205 41.205 0 0 1-1.112-.739l-.358-.252c-.354-.25-.704-.503-1.051-.76l-.466-.353a47.401 47.401 0 0 1-.948-.74l-.423-.34a62.157 62.157 0 0 1-1.182-.995l-.129-.109A49.53 49.53 0 0 1 43.399 60l-.35-.337c-.303-.287-.6-.577-.893-.874l-.35-.35a49.681 49.681 0 0 1-1.095-1.158l-.054-.058a44.217 44.217 0 0 1-1.111-1.264l-.291-.346c-.27-.325-.538-.655-.799-.988l-.293-.364a53.218 53.218 0 0 1-.923-1.229c-8.326-11.358-11.318-27.023-4.663-39.888l-5.899 7.482c-7.559 10.863-6.617 24.997-.844 36.541l.423.821.271.52.168.299.301.539c.179.316.362.63.55.944l.315.519c.208.336.421.668.64 1l.272.422c.301.448.609.896.926 1.336l.027.035.156.211c.275.379.558.753.844 1.123l.318.404c.255.321.516.641.78.959l.298.355c.355.419.717.835 1.087 1.242l.022.023.042.046c.36.394.73.778 1.104 1.164l.354.357c.29.292.584.579.882.865l.361.343c.397.374.798.741 1.208 1.101l.02.015.21.18c.361.312.729.623 1.099.928l.455.362c.302.242.608.481.916.716l.489.372c.34.25.682.496 1.027.737l.375.266.103.073c.328.226.663.442.998.659l.432.288c.513.325 1.035.646 1.562.956l.432.244c.388.223.777.442 1.172.656l.648.336.84.437zm3.693-36.795c.819 1.174 1.726 2.57 2.813 3.514.394.434.806.856 1.226 1.273l.324.318c.409.396.824.785 1.252 1.164l.052.044.012.013c.475.416.965.816 1.463 1.21l.333.26c.5.383 1.009.759 1.531 1.118l.045.033.698.46.332.22c.373.238.75.472 1.135.694l.16.093c.331.191.667.379 1.003.561l.356.187.702.363.106.048c.482.237.968.465 1.464.682l.323.133c.396.168.797.333 1.199.487l.514.188c.366.136.732.26 1.102.383l.499.16c.526.163 1.045.369 1.593.46 28.222 4.677 34.738-17.054 34.738-17.054-5.874 8.459-17.248 12.494-29.386 9.344a33.73 33.73 0 0 1-1.598-.462l-.481-.155c-.375-.121-.748-.25-1.118-.385l-.504-.188a39.777 39.777 0 0 1-1.204-.485l-.324-.138a32.331 32.331 0 0 1-1.472-.685l-.739-.376-.426-.219c-.314-.17-.626-.348-.934-.527l-.223-.127a35.907 35.907 0 0 1-1.132-.689l-.341-.229-.732-.484a37.97 37.97 0 0 1-1.525-1.115l-.343-.271c-5.313-4.193-9.524-9.927-11.527-16.428-2.098-6.74-1.646-14.308 1.989-20.449l-4.466 6.306c-5.466 7.865-5.169 18.396-.905 26.715a34.709 34.709 0 0 0 2.416 4.035zm29.747-9.731l.701.243.309.098c.333.104.662.226 1.005.29 15.583 3.011 19.811-7.997 20.936-9.617-3.703 5.331-9.925 6.61-17.56 4.757a19.346 19.346 0 0 1-1.848-.57 22.91 22.91 0 0 1-2.193-.91 22.678 22.678 0 0 1-3.846-2.347c-6.832-5.185-11.076-15.072-6.618-23.126l-2.412 3.324c-3.222 4.743-3.539 10.633-1.303 15.869 2.358 5.56 7.19 9.92 12.829 11.989zM66.359 96.295h-4.226a.556.556 0 0 0-.517.417l-1.5 6.94-1.5 6.94a.554.554 0 0 1-.516.417h-2.991c-2.959 0-2.617-2.047-2.011-4.851l.018-.085.066-.354.012-.066.135-.72.145-.771.154-.785.682-3.332.683-3.332a.336.336 0 0 0-.341-.419h-4.337a.55.55 0 0 0-.514.418l-.933 4.424-.932 4.425-.002.006-.086.412c-1.074 4.903-.79 9.58 5.048 9.727l.17.003h9.163a.554.554 0 0 0 .516-.417l1.976-9.289 1.976-9.29c.049-.23-.103-.417-.338-.418zm-45.256-.049h-4.64a.562.562 0 0 0-.521.416l-.44 1.942-.44 1.942c-.051.229.098.416.333.416h4.676a.556.556 0 0 0 .518-.417l.425-1.941.425-1.941c.049-.229-.101-.417-.336-.417zm-1.346 6.044H15.08a.563.563 0 0 0-.521.416l-.657 2.91-.656 2.909-.183.834-.631 2.97-.63 2.971c-.049.229-.15.599-.225.821 0 0-.874 2.6-2.343 2.57l-.184-.004-1.271-.023h-.001a.558.558 0 0 0-.524.407l-.485 2.039-.484 2.038c-.055.228.093.416.326.42.833.01 2.699.031 3.828.031 3.669 0 5.604-2.033 6.843-7.883l1.451-6.714 1.361-6.297c.049-.227-.103-.415-.337-.415zm86.117-1.574l-.194-.801-.191-.82-.097-.414c-.38-1.477-1.495-2.328-3.917-2.328l-3.77-.004-3.472-.005h-3.907a.552.552 0 0 0-.515.417l-.173.816-.204.964-.057.271-1.759 8.24-1.67 7.822c-.05.23-.066.512-.038.626.028.115.479.209.713.209h3.524c.235 0 .532-.042.66-.094s.317-.513.364-.742l.626-3.099.627-3.1.001-.005.084-.413.76-3.56.671-3.144a.555.555 0 0 1 .515-.417l11.089-.005c.235.002.383-.185.33-.414zm14.275-7.24l-.854.003h-3.549a.904.904 0 0 0-.667.353l-7.849 11.498c-.132.194-.283.166-.335-.062l-.578-2.533a.562.562 0 0 0-.522-.416h-5.045c-.235 0-.374.184-.31.409l2.261 7.921c.064.226.069.596.011.824l-.985 3.833c-.059.228.085.413.32.413h4.987a.58.58 0 0 0 .532-.413l.986-3.833a2.52 2.52 0 0 1 .363-.755l12.742-16.911c.142-.188.065-.341-.169-.339l-1.339.008zm-40.086 9.919v-.004a.514.514 0 0 1-.499.441h-6.397c-.222 0-.334-.15-.301-.336l.006-.015-.004.002.003-.021.029-.109c.611-1.624 1.855-2.69 4.194-2.69 2.634-.001 3.148 1.285 2.969 2.732zm-1.877-7.384c-8.211 0-10.157 4.984-11.249 10.015-1.091 5.128-.998 9.921 7.5 9.921h1.03l.256-.001h.06l1.02-.003h.018c2.244-.009 4.495-.026 5.406-.033a.553.553 0 0 0 .509-.42l.344-1.681.067-.327.41-2.006a.335.335 0 0 0-.341-.418h-7.639c-3.039 0-3.941-.807-3.608-3.181H84.18l-.001.001.008-.001a.503.503 0 0 0 .445-.315l.029-.106-.001.001c1.813-6.839 1.293-11.445-6.474-11.446zm-38.81 7.358l-.116.409v.001l-.922 3.268-.922 3.267a.596.596 0 0 1-.543.411h-4.88c-3.702 0-4.604-2.896-3.702-7.166.901-4.368 2.668-7.083 6.312-7.358 4.98-.376 5.976 3.126 4.773 7.168zm3.348 7.105s2.301-5.588 2.823-8.814c.713-4.319-1.45-10.585-9.804-10.585-8.306 0-11.914 5.981-13.29 12.484-1.376 6.55.427 12.293 8.686 12.246l6.516-.024 6.089-.022a.59.59 0 0 0 .534-.414l1.061-4.046c.059-.228-.084-.414-.319-.416l-1.017-.006-1.017-.006c-.199-.001-.313-.131-.289-.302l.027-.095zm41.12-3.741a.28.28 0 1 1-.56.001.28.28 0 0 1 .56-.001z\"/></svg>"

/***/ }),

/***/ "../src/components/jquery/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JqueryPlainWordmark = __webpack_require__("../src/components/jquery/plain-wordmark/JqueryPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JqueryPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jquery/plain/JqueryPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _JqueryPlain = __webpack_require__("../src/components/jquery/plain/JqueryPlain.svg");
	
	var _JqueryPlain2 = _interopRequireDefault(_JqueryPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** JqueryPlain */
	function JqueryPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'JqueryPlain',
	    svg: _JqueryPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	JqueryPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = JqueryPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/jquery/plain/JqueryPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#0868AC\" d=\"M65.283 106.928c-.828-.187-1.633-.446-2.441-.685l-.609-.185a72.498 72.498 0 0 1-2.352-.765l-.323-.117a71.149 71.149 0 0 1-2.074-.769l-.582-.229c-.752-.297-1.5-.607-2.238-.931l-.447-.198a92.857 92.857 0 0 1-1.889-.879l-.546-.262c-.491-.239-.977-.493-1.461-.743-.324-.171-.654-.332-.975-.51a57.368 57.368 0 0 1-1.751-.982l-.591-.33a79.8 79.8 0 0 1-2.28-1.397l-.615-.41a57.785 57.785 0 0 1-1.623-1.079l-.523-.367a93.376 93.376 0 0 1-1.534-1.109l-.679-.514a67.061 67.061 0 0 1-1.384-1.082l-.617-.495a85.378 85.378 0 0 1-1.724-1.453l-.188-.159a81.186 81.186 0 0 1-1.812-1.647l-.51-.491c-.441-.42-.875-.843-1.302-1.277l-.51-.509a72.65 72.65 0 0 1-1.599-1.69l-.078-.084a65.735 65.735 0 0 1-1.621-1.844l-.424-.504a67.378 67.378 0 0 1-1.167-1.442l-.427-.532a78.406 78.406 0 0 1-1.347-1.794C12.89 62.89 8.524 40.032 18.236 21.26L9.625 32.181C-1.404 48.032-.031 68.657 8.394 85.501c.2.404.411.801.617 1.198l.395.759.245.437.439.786c.262.461.53.92.805 1.379l.458.756c.304.491.615.976.934 1.46l.398.614c.438.655.888 1.309 1.352 1.951l.039.05.228.308c.4.553.814 1.099 1.232 1.639l.463.59c.373.469.752.935 1.139 1.399l.435.52a75.27 75.27 0 0 0 1.586 1.812l.032.033.062.068a77.952 77.952 0 0 0 1.612 1.699l.517.521c.423.426.853.845 1.287 1.262l.526.5c.58.547 1.166 1.083 1.764 1.607l.028.022.307.262c.526.456 1.062.909 1.603 1.353l.664.529c.441.354.887.702 1.336 1.044l.714.543c.495.365.995.724 1.499 1.075l.546.387.15.107c.478.329.967.646 1.456.963l.63.42c.749.474 1.51.943 2.278 1.396l.63.355a74.53 74.53 0 0 0 1.711.959c.312.168.632.327.946.488.407.213.811.429 1.225.636l.283.137.501.242c.641.306 1.287.607 1.94.897l.41.184a66.92 66.92 0 0 0 2.263.941l.551.217c.704.271 1.418.539 2.135.791l.268.093c.786.275 1.581.53 2.381.779l.575.172c.814.245 1.618.538 2.458.693 53.339 9.727 68.833-32.053 68.833-32.053-13.014 16.954-36.112 21.426-57.997 16.447zM46.069 63.697c1.195 1.713 2.52 3.751 4.105 5.127a48.111 48.111 0 0 0 1.79 1.858l.472.465a52.581 52.581 0 0 0 1.828 1.698l.074.064.018.018a55.268 55.268 0 0 0 2.135 1.767l.484.378a54.08 54.08 0 0 0 2.233 1.631l.065.049c.336.232.679.448 1.02.672l.482.319c.544.349 1.096.689 1.656 1.015l.234.136c.483.278.973.552 1.463.818l.521.271c.339.177.678.358 1.024.53l.155.07c.702.346 1.411.68 2.136.995l.472.194a50.02 50.02 0 0 0 1.75.71l.75.275c.533.198 1.068.378 1.608.559l.727.233c.767.238 1.525.539 2.324.672 41.183 6.823 50.69-24.886 50.69-24.886-8.57 12.343-25.168 18.233-42.879 13.635a50.376 50.376 0 0 1-2.333-.674l-.7-.227a46.162 46.162 0 0 1-1.632-.562l-.736-.274a57.432 57.432 0 0 1-1.756-.708l-.473-.2a47.728 47.728 0 0 1-2.148-.999c-.364-.177-.721-.364-1.078-.548l-.622-.32a44.502 44.502 0 0 1-1.363-.77l-.326-.185a47.802 47.802 0 0 1-1.65-1.008l-.498-.332a65.856 65.856 0 0 1-1.069-.707 58.235 58.235 0 0 1-2.226-1.628l-.501-.395c-7.752-6.12-13.897-14.486-16.819-23.971-3.062-9.836-2.401-20.878 2.903-29.84l-6.517 9.2c-7.977 11.478-7.543 26.844-1.321 38.983a50.37 50.37 0 0 0 3.528 5.892zm43.407-14.199c.339.125.678.237 1.022.354l.451.143c.484.152.966.329 1.467.424 22.739 4.394 28.908-11.669 30.549-14.034-5.403 7.779-14.482 9.646-25.623 6.942-.88-.213-1.848-.531-2.696-.832a33.242 33.242 0 0 1-3.201-1.329 33.175 33.175 0 0 1-5.612-3.424c-9.969-7.565-16.162-21.994-9.657-33.745l-3.52 4.851c-4.702 6.92-5.164 15.514-1.901 23.156 3.441 8.112 10.492 14.475 18.721 17.494z\"/></svg>"

/***/ }),

/***/ "../src/components/jquery/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _JqueryPlain = __webpack_require__("../src/components/jquery/plain/JqueryPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JqueryPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/krakenjs/original-wordmark/KrakenjsOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _KrakenjsOriginalWordmark = __webpack_require__("../src/components/krakenjs/original-wordmark/KrakenjsOriginalWordmark.svg");
	
	var _KrakenjsOriginalWordmark2 = _interopRequireDefault(_KrakenjsOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** KrakenjsOriginalWordmark */
	function KrakenjsOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'KrakenjsOriginalWordmark',
	    svg: _KrakenjsOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	KrakenjsOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = KrakenjsOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/krakenjs/original-wordmark/KrakenjsOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#0081C2\" d=\"M109.629 24.573c-4.109-2.039-8.184-4.111-12.34-6.064-8.096-3.804-15.935-8.12-24.076-11.843-2.642-1.208-5.193-2.604-7.773-3.943-.863-.448-1.644-.451-2.519-.004-3.361 1.717-6.773 3.33-10.171 4.97-8.057 3.889-16.109 8.078-24.204 11.9C25.027 21.25 22 23.025 18 24.713V77.98c1 .035.443.035.546.085 2.554 1.258 5.191 2.491 7.723 3.793 2.583 1.329 5.255 2.539 7.875 3.788 8.129 3.875 16.164 7.987 24.229 11.998 1.559.776 3.175 1.459 4.706 2.285.777.419 1.374.381 2.163.004 2.409-1.148 4.83-2.289 7.225-3.458 9.292-4.537 18.458-9.263 27.804-13.693C103.525 81.239 106 79.564 110 77.9V24.657l-.371-.084zM97.648 73.802c-1.935 2.021-4.201 3.551-6.69 4.776-.623.306-1.262.669-1.93.774-1.027.16-1.384.971-1.862 1.644-.818 1.153-2.786 2.32-4.15 2.338-.376.005-.755-.025-1.129.005-1.477.119-2.819-.246-4.145-.912-1.816-.912-3.786-1.064-5.808-1.009-1.064.03-1.995.275-2.887.788-1.186.682-1.823 2.242-1.567 3.526.063.314-.243.702-.446 1.231-.44-.371-.92-.579-.939-.823-.134-1.636-.232-3.336.924-4.676 1.583-1.835 3.644-2.845 6.079-3.02.625-.044 1.256.01 1.883-.01 1.518-.048 2.953.235 4.431.645 1.225.339 2.668.41 3.902-.38.433-1.626-.426-2.804-1.614-3.568-1.253-.807-2.513-1.659-4.059-2.015-1.104-.253-2.077-1.031-3.16-1.438-1.086-.406-2.172-.847-3.257-1.241-1.036-.377-2.215-.361-3.142-1.039-1.721.081-3.39-.688-5.114-.367-2.25.419-4.521.787-6.656 1.653-1.611.654-3.242 1.26-4.788 2.083-.915.487-1.96.723-2.903 1.166-.739.347-1.459.776-2.101 1.28-1.104.867-1.842 1.948-1.495 3.479 1.361.634 2.732.717 4.189.228 1.576-.53 3.241-.418 4.882-.518 2.08-.125 3.9.525 5.574 1.569 1.591.992 2.684 2.416 2.624 4.451-.013.439.065.893-.022 1.313-.077.372-.326.708-.586 1.239-.522-.543-1.365-.672-.596-1.496-.492-.905-.204-2.154-1.191-2.83-.874-.597-1.727-1.265-2.892-1.204-.688.036-1.385.061-2.069-.004-1.617-.15-3.072.396-4.442 1.103-1.892.978-3.895.763-5.887.791-1.124-.633-2.466-.924-3.309-1.992-.427-.541-.612-1.509-1.12-1.692-.663-.239-1.269-.694-1.924-.798-1.656-.263-2.816-1.425-4.188-2.167-1.155-.625-2.079-1.695-3.062-2.615-1.076-1.008-1.632-2.272-1.88-3.741-.369-2.178.479-4.201 1.648-5.433 1.539-1.621 3.455-2.458 5.521-3.22-.505-1.002-.895-2.125-1.577-3.026-.654-.863-.719-1.878-.983-2.797-.299-1.044-.274-2.29-.011-3.355.257-1.042.899-2.031 1.542-2.92.581-.803 1.368-1.467 2.117-2.133.239-.213.646-.237.952-.34.412.574.284.966-.122 1.379-.422.431-.772.932-1.158 1.398-1.09 1.322-.746 2.9-.73 4.395.011.961.583 1.762 1.134 2.535 1.056 1.481 2.135 2.875 3.934 3.611.964.394 1.872.729 2.915.696.932-.03 1.865-.006 3.256-.006-.816-.365-1.228-.543-1.635-.733-2.861-1.331-4.351-3.593-4.353-6.604-.001-1.067.106-2.148-.032-3.196-.12-.908.405-1.631.431-2.483.022-.767-.353-1.624.354-2.293-.192-1.458.358-2.954-.291-4.398-.342-.761-.057-1.609-.398-2.469-.656-1.656-1.127-3.268-3.271-3.469-.229-.021-.425-.398-.627-.6.374-.811.756-.973 1.606-.704 2.172.686 3.472 2.152 4.517 4.087 1.122 2.078 1.499 4.291 1.911 6.567.415 2.287.182 4.552.338 6.819.052.756.257 1.514.488 2.24.224.706.815 1.125 1.54 1.195 1.049.103 1.858.03 2.858-.937v-1.912c-1-.39-.911-1.368-2.029-1.331-.424.014-.639-.615-.624-1.185.045-1.63.125-3.272-.018-4.892-.155-1.748.243-3.442.502-5.103.229-1.468.396-3.013.995-4.458.554-1.34.659-2.863 1.196-4.212.988-2.484 2.099-4.912 3.484-7.225.791-1.321 1.849-2.454 2.516-3.845.051-.105.115-.208.192-.296.974-1.104 1.896-2.261 2.941-3.293 1.26-1.242 2.625-2.377 3.997-3.606 1.435 1.274 2.93 2.378 4.15 3.729 3.314 3.668 6.225 7.658 8.099 12.26.873 2.143 1.702 4.326 2.143 6.656.397 2.103.81 4.192 1.159 6.306.451 2.735.087 5.437.305 8.141.043.536-.486 1.047-.771 1.024-1.124-.086-1.237.928-2.237 1.329v1.932c1 .723 1.661.981 2.639.95 1.179-.038 1.867-.672 2.188-1.892a11.61 11.61 0 0 0 .355-3.995c-.168-1.929.227-3.812.49-5.674a16.806 16.806 0 0 1 2.208-6.228c.767-1.286 3.054-3.045 4.397-3.312.591-.117 1.09.087 1.308.903-.225.174-.478.539-.765.567-1.898.186-2.462 1.664-3.025 3.093-.306.773-.235 1.699-.465 2.451-.396 1.292-.279 2.55-.284 3.819-.002.764.216 1.529.356 2.291.129.701-.309 1.475.339 2.131.158.16.033.602.033.914.001 1.192-.024 2.386.006 3.577.074 2.987-1.998 6.306-5.616 7.212 2.249.191 4.437.372 6.557-.928 2.065-1.267 3.169-3.209 4.327-5.167.028-2.252.336-4.59-1.757-6.232-.454-.356-.583-.764-.436-1.496.389.055.8-.013.956.155 1.152 1.241 2.675 2.181 3.224 3.927.155.495.631.96.611 1.423-.052 1.217.2 2.42-.171 3.673-.283.958-.583 1.899-1.009 2.789-.403.842-.939 1.62-1.446 2.475.71.346 1.389.796 2.135 1.017 1.591.47 2.682 1.573 3.779 2.702 1.092 1.125 1.227 2.632 1.647 4.026-.584 1.517-.714 3.205-1.933 4.477zm-58.602-6.295c-.622.055-1.256-.028-1.88.017-1.012.072-1.952.437-2.781.993-.835.56-.897 1.079-.502 2.047.392.962.977 1.759 1.719 2.495 1.324 1.313 2.704 2.535 4.33 3.447.579-3.218 2.38-5.551 5.124-7.266-.479-.235-.855-.396-1.207-.597-1.49-.855-3.069-1.291-4.803-1.136zm55.063 1.127c-.461-.41-2.231-1.103-2.923-1.115-.877-.016-1.761.056-2.633-.018-1.312-.111-2.443.403-3.588.892-.533.228-1.036.526-1.664.849 2.738 1.711 4.539 4.044 5.129 7.328.721-.517 1.47-.966 2.114-1.534a57.01 57.01 0 0 0 3.368-3.209c.343-.355.486-.917.679-1.401.274-.689.1-1.275-.482-1.792zM58.458 50.566c-.853.024-1.104.381-1.062 1.511.032.861.4 1.19 1.26 1.126.699-.052 1.451-.827 1.376-1.417-.076-.612-.887-1.239-1.574-1.22zm11.471 0c-.807-.038-1.65.681-1.609 1.371.037.623.816 1.269 1.528 1.266.827-.004 1.1-.317 1.108-1.277.009-1.003-.233-1.323-1.027-1.36z\"/><path d=\"M26.053 114.115h.048c.292-.413.681-.947 1.021-1.337l3.476-4.06h2.553l-4.546 4.838 5.178 6.929h-2.601l-4.036-5.665-1.094 1.24v4.425h-2.139v-17.261h2.139v10.891zm9.7-1.726c0-1.386-.024-2.577-.097-3.671h1.872l.097 2.31h.073c.535-1.58 1.848-2.577 3.282-2.577.219 0 .389.024.583.073v1.993c-.243-.024-.462-.048-.753-.048-1.507 0-2.577 1.143-2.869 2.723a6.68 6.68 0 0 0-.073 1.021v6.272h-2.139l.024-8.096zm16.07 5.276c0 1.021.049 2.018.17 2.82h-1.92l-.195-1.483h-.072c-.632.924-1.921 1.75-3.599 1.75-2.382 0-3.598-1.677-3.598-3.379 0-2.844 2.528-4.4 7.074-4.376v-.242c0-.973-.267-2.748-2.674-2.724-1.118 0-2.261.316-3.087.875l-.486-1.434c.972-.608 2.407-1.021 3.89-1.021 3.623 0 4.498 2.455 4.498 4.814v4.4zm-2.091-3.185c-2.334-.049-4.984.364-4.984 2.649 0 1.41.924 2.043 1.994 2.043 1.556 0 2.553-.973 2.893-1.97.073-.219.097-.462.097-.681v-2.041zm7.659-.365h.049c.292-.413.681-.947 1.021-1.337l3.477-4.06h2.552l-4.546 4.838 5.178 6.929h-2.601l-4.036-5.665-1.094 1.24v4.425h-2.139v-17.261h2.139v10.891zm10.648.851c.049 2.893 1.872 4.084 4.011 4.084 1.531 0 2.479-.268 3.257-.583l.389 1.507c-.753.34-2.066.754-3.938.754-3.598 0-5.786-2.407-5.786-5.932 0-3.574 2.115-6.37 5.543-6.37 3.841 0 4.838 3.38 4.838 5.543 0 .438-.024.778-.073 1.021l-8.241-.024zm6.248-1.531c.024-1.337-.56-3.477-2.942-3.477-2.188 0-3.112 1.994-3.282 3.477h6.224zm4.716-1.532c0-1.239-.024-2.212-.097-3.185h1.896l.121 1.921h.049c.583-1.094 1.945-2.188 3.89-2.188 1.629 0 4.157.973 4.157 5.008v7.026H86.88v-6.783c0-1.896-.706-3.5-2.723-3.5-1.386 0-2.479.997-2.869 2.188-.097.268-.146.656-.146.997v7.099h-2.139v-8.583z\"/><path fill=\"#0081C2\" d=\"M89.604 123.937c.997-.073 1.823-.341 2.334-.9.583-.656.826-1.604.826-4.424v-9.895h2.14v10.721c0 2.286-.365 3.769-1.41 4.838-.948.948-2.504 1.337-3.646 1.337l-.244-1.677zm4.181-17.383c-.802 0-1.337-.632-1.337-1.385s.559-1.361 1.386-1.361 1.361.608 1.361 1.361-.51 1.385-1.386 1.385h-.024zm4.327 11.767c.656.389 1.774.827 2.844.827 1.532 0 2.261-.753 2.261-1.75 0-1.021-.607-1.58-2.164-2.163-2.139-.778-3.136-1.921-3.136-3.331 0-1.896 1.556-3.452 4.06-3.452 1.191 0 2.237.316 2.869.729l-.51 1.531c-.462-.267-1.313-.681-2.407-.681-1.264 0-1.945.729-1.945 1.604 0 .997.681 1.435 2.212 2.018 2.018.753 3.088 1.775 3.088 3.549 0 2.091-1.629 3.549-4.376 3.549-1.289 0-2.48-.34-3.307-.826l.511-1.604z\"/></svg>"

/***/ }),

/***/ "../src/components/krakenjs/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _KrakenjsOriginalWordmark = __webpack_require__("../src/components/krakenjs/original-wordmark/KrakenjsOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_KrakenjsOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/krakenjs/original/KrakenjsOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _KrakenjsOriginal = __webpack_require__("../src/components/krakenjs/original/KrakenjsOriginal.svg");
	
	var _KrakenjsOriginal2 = _interopRequireDefault(_KrakenjsOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** KrakenjsOriginal */
	function KrakenjsOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'KrakenjsOriginal',
	    svg: _KrakenjsOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	KrakenjsOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = KrakenjsOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/krakenjs/original/KrakenjsOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#0081C2\" d=\"M120.935 30.631c-5.13-2.544-10.016-5.131-15.203-7.569C95.627 18.314 85.941 12.926 75.78 8.281c-3.298-1.507-6.433-3.25-9.654-4.923-1.077-.559-2.027-.562-3.119-.004-4.195 2.143-8.442 4.156-12.683 6.203-10.055 4.854-20.583 10.082-30.685 14.853C15.247 26.484 11 28.698 6 30.806v66.486c1 .043 1.035.043 1.163.106 3.188 1.571 6.721 3.109 9.88 4.735 3.224 1.66 6.681 3.169 9.951 4.729 10.146 4.837 20.235 9.969 30.301 14.975 1.946.968 3.993 1.821 5.905 2.852.97.522 1.729.475 2.715.005 3.007-1.433 6.036-2.857 9.025-4.316 11.598-5.663 22.644-11.561 34.309-17.091C113.311 101.36 117 99.27 121 97.193V30.737c0-.044.062-.043-.065-.106zm-14.556 61.447c-2.415 2.523-5.244 4.431-8.351 5.96-.777.382-1.575.835-2.409.966-1.281.2-1.728 1.212-2.324 2.052-1.021 1.439-3.477 2.896-5.181 2.918-.47.007-.942-.031-1.409.007-1.844.148-3.52-.307-5.173-1.138-2.266-1.139-4.725-1.328-7.25-1.26-1.328.037-2.489.343-3.603.983-1.479.852-2.275 2.798-1.956 4.401.078.393-.303.876-.558 1.537-.549-.463-1.148-.722-1.173-1.027-.167-2.042-.289-4.164 1.154-5.836 1.977-2.292 4.548-3.552 7.587-3.77.779-.055 1.567.012 2.35-.012 1.895-.06 3.687.293 5.531.804 1.528.423 3.33.512 4.87-.474.541-2.03-.532-3.5-2.014-4.454-1.564-1.007-3.137-2.071-5.066-2.515-1.378-.316-2.593-1.287-3.945-1.793-1.355-.508-2.711-1.057-4.065-1.55-1.293-.471-2.765-.452-3.921-1.297-2.147.101-4.23-.858-6.383-.458-2.808.522-5.643.981-8.308 2.063-2.011.816-4.047 1.573-5.976 2.6-1.142.608-2.446.903-3.623 1.456-.922.433-1.822.969-2.623 1.597-1.378 1.083-2.299 2.431-1.866 4.343 1.7.79 3.411.895 5.229.284 1.968-.662 4.046-.522 6.094-.646 2.596-.157 4.868.655 6.958 1.958 1.985 1.238 3.349 3.015 3.274 5.555-.016.548.081 1.114-.027 1.64-.096.464-.406.884-.732 1.546-.651-.678-1.703-.839-.744-1.868-.614-1.13-.255-2.689-1.487-3.532-1.09-.746-2.156-1.579-3.609-1.503-.859.045-1.729.075-2.583-.005-2.019-.188-3.834.494-5.544 1.377-2.362 1.221-4.862.952-7.349.987-1.402-.79-3.078-1.154-4.13-2.487-.533-.675-.765-1.884-1.398-2.112-.827-.298-1.584-.867-2.401-.997-2.066-.328-3.515-1.778-5.228-2.705-1.441-.78-2.595-2.116-3.821-3.265-1.343-1.257-2.037-2.836-2.347-4.669-.46-2.718.598-5.242 2.057-6.78 1.92-2.023 4.312-3.068 6.892-4.019-.631-1.25-1.117-2.652-1.969-3.777-.816-1.077-.897-2.344-1.227-3.492-.374-1.303-.341-2.858-.014-4.188.321-1.299 1.122-2.535 1.925-3.645.725-1.002 1.708-1.832 2.642-2.663.299-.266.807-.296 1.188-.424.514.717.354 1.207-.152 1.722-.526.538-.964 1.162-1.445 1.745-1.361 1.65-.932 3.62-.911 5.485.013 1.199.727 2.199 1.414 3.163 1.318 1.849 2.665 3.59 4.911 4.507 1.203.491 2.335.91 3.638.869 1.163-.037 2.328-.008 4.064-.008-1.019-.455-1.533-.678-2.042-.915-3.571-1.661-5.43-4.484-5.433-8.242-.001-1.332.133-2.681-.04-3.99-.15-1.133.506-2.035.538-3.1.029-.957-.439-2.027.443-2.861-.24-1.82.447-3.688-.362-5.49-.427-.95-.072-2.009-.497-3.082-.819-2.067-1.407-4.078-4.083-4.33-.287-.026-.531-.497-.783-.749.466-1.011.943-1.214 2.004-.879 2.711.856 4.333 2.687 5.637 5.101 1.4 2.593 1.871 5.356 2.386 8.198.518 2.854.228 5.681.421 8.511.065.943.321 1.89.609 2.797.28.88.941 1.404 1.845 1.492 1.313.132 1.495.04 3.495-1.166v-2.386c-2-.487-1.061-1.707-2.456-1.662-.529.017-.76-.769-.74-1.478.057-2.035.176-4.085-.003-6.106-.193-2.182.312-4.297.637-6.37.286-1.832.5-3.76 1.246-5.564.691-1.672.825-3.573 1.495-5.257 1.234-3.1 2.622-6.13 4.35-9.018.987-1.648 2.309-3.063 3.141-4.799.063-.131.144-.26.24-.37 1.215-1.378 2.367-2.822 3.671-4.109 1.572-1.551 3.276-2.968 4.989-4.502 1.791 1.591 3.657 2.969 5.181 4.655 4.136 4.579 7.77 9.559 10.108 15.302 1.089 2.674 2.125 5.4 2.675 8.308.496 2.624 1.011 5.232 1.446 7.871.564 3.414.109 6.786.38 10.161.054.669-.91 1.307-1.266 1.279C81.692 63.375 81 64.641 80 65.142v2.41c1 .902 2.376 1.225 3.597 1.186 1.472-.047 2.481-.839 2.883-2.362.439-1.669.663-3.33.519-4.985-.21-2.408.322-4.758.649-7.082.382-2.715 1.341-5.365 2.775-7.772.956-1.605 3.821-3.801 5.498-4.133.737-.146 1.366.107 1.637 1.126-.28.217-.594.673-.953.708-2.369.231-3.072 2.076-3.775 3.86-.381.965-.292 2.121-.58 3.06-.493 1.611-.348 3.182-.354 4.767-.003.953.271 1.909.446 2.859.161.875-.386 1.841.423 2.66.197.2.041.751.042 1.141.001 1.488-.03 2.978.006 4.464.093 3.729-2.494 7.871-7.01 9.002 2.807.238 5.538.464 8.185-1.158 2.578-1.581 3.956-4.006 5.401-6.45.035-2.811.42-5.729-2.193-7.779-.566-.445-.729-.954-.544-1.868.486.069.999-.016 1.194.194 1.438 1.549 3.339 2.722 4.023 4.902.194.617.788 1.197.762 1.776-.065 1.519.25 3.021-.213 4.584-.354 1.196-.729 2.371-1.26 3.481-.503 1.051-1.172 2.022-1.805 3.089.886.432 1.733.994 2.665 1.269 1.986.587 3.348 1.963 4.718 3.373 1.363 1.403 1.531 3.285 2.055 5.025-.729 1.893-.892 4-2.412 5.589zm-73.145-7.859c-.777.069-1.568-.034-2.347.021-1.263.089-2.437.545-3.471 1.238-1.043.699-1.12 1.347-.627 2.555.489 1.2 1.219 2.195 2.146 3.114 1.653 1.639 3.375 3.165 5.405 4.302.723-4.017 2.971-6.929 6.395-9.069-.598-.294-1.068-.494-1.507-.746-1.86-1.064-3.831-1.608-5.994-1.415zm68.727 1.407c-.576-.511-2.785-1.376-3.649-1.392-1.095-.02-2.198.07-3.286-.022-1.637-.138-3.05.503-4.479 1.114-.666.284-1.293.656-2.076 1.059 3.417 2.136 5.666 5.048 6.402 9.147.9-.645 1.835-1.205 2.638-1.915a70.97 70.97 0 0 0 4.204-4.005c.428-.444.606-1.145.847-1.75.343-.859.126-1.59-.601-2.236zM57.462 63.075c-1.064.029-1.378.476-1.325 1.886.04 1.074.5 1.485 1.573 1.405.872-.065 1.811-1.032 1.717-1.769-.095-.764-1.107-1.547-1.965-1.522zm14.317 0c-1.007-.047-2.06.85-2.009 1.711.046.777 1.019 1.583 1.907 1.58 1.033-.004 1.373-.396 1.384-1.594.012-1.251-.29-1.651-1.282-1.697z\"/></svg>"

/***/ }),

/***/ "../src/components/krakenjs/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _KrakenjsOriginal = __webpack_require__("../src/components/krakenjs/original/KrakenjsOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_KrakenjsOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/krakenjs/plain-wordmark/KrakenjsPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _KrakenjsPlainWordmark = __webpack_require__("../src/components/krakenjs/plain-wordmark/KrakenjsPlainWordmark.svg");
	
	var _KrakenjsPlainWordmark2 = _interopRequireDefault(_KrakenjsPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** KrakenjsPlainWordmark */
	function KrakenjsPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'KrakenjsPlainWordmark',
	    svg: _KrakenjsPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	KrakenjsPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = KrakenjsPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/krakenjs/plain-wordmark/KrakenjsPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#0081C2\" d=\"M109.689 24.573c-4.11-2.039-8.154-4.111-12.31-6.064-8.096-3.804-15.92-8.12-24.062-11.843-2.642-1.208-5.185-2.604-7.766-3.943-.863-.448-1.64-.451-2.515-.004-3.361 1.717-6.771 3.33-10.169 4.97-8.057 3.889-16.169 8.078-24.263 11.9C25.086 21.25 22 23.025 18 24.713V77.98c1 .035.503.035.606.085 2.554 1.258 5.221 2.491 7.752 3.793 2.582 1.329 5.271 2.539 7.891 3.788 8.129 3.875 16.171 7.987 24.236 11.998 1.559.776 3.178 1.459 4.709 2.285.777.419 1.375.381 2.166.004 2.409-1.148 4.831-2.289 7.226-3.458 9.292-4.537 18.398-9.263 27.744-13.693 3.254-1.543 6.67-3.218 9.67-4.882V24.657l-.311-.084zm-11.92 49.229c-1.935 2.021-4.201 3.551-6.69 4.776-.623.306-1.262.669-1.93.774-1.027.16-1.384.971-1.862 1.644-.818 1.153-2.786 2.32-4.15 2.338-.377.005-.755-.025-1.129.005-1.477.119-2.82-.246-4.145-.912-1.816-.912-3.786-1.064-5.808-1.009-1.064.03-1.995.275-2.887.788-1.186.682-1.823 2.242-1.567 3.526.062.314-.243.702-.446 1.231-.44-.371-.92-.579-.939-.823-.134-1.636-.232-3.336.924-4.676 1.583-1.835 3.644-2.845 6.079-3.02.625-.044 1.256.01 1.883-.01 1.518-.048 2.953.235 4.431.645 1.225.339 2.668.41 3.902-.38.433-1.626-.426-2.804-1.613-3.568-1.253-.807-2.513-1.659-4.059-2.015-1.104-.253-2.077-1.031-3.16-1.438-1.086-.406-2.172-.847-3.257-1.241-1.036-.377-2.215-.361-3.142-1.039-1.721.081-3.39-.688-5.114-.367-2.25.419-4.521.787-6.656 1.653-1.611.654-3.242 1.26-4.788 2.083-.915.487-1.96.723-2.902 1.166-.739.347-1.46.776-2.101 1.28-1.104.867-1.842 1.948-1.495 3.479 1.362.634 2.732.717 4.189.228 1.577-.53 3.241-.418 4.882-.518 2.08-.125 3.9.525 5.574 1.569 1.591.992 2.684 2.416 2.624 4.451-.013.439.065.893-.022 1.313-.077.372-.326.708-.586 1.239-.522-.543-1.364-.672-.597-1.496-.492-.905-.204-2.154-1.191-2.83-.873-.597-1.727-1.265-2.891-1.204-.688.036-1.385.061-2.069-.004-1.617-.15-3.072.396-4.442 1.103-1.892.978-3.895.763-5.888.791-1.124-.633-2.465-.924-3.309-1.992-.427-.541-.613-1.509-1.121-1.692-.663-.239-1.269-.694-1.924-.798-1.655-.263-2.816-1.425-4.188-2.167-1.154-.625-2.079-1.695-3.061-2.615-1.077-1.008-1.633-2.272-1.881-3.741-.368-2.178.479-4.201 1.648-5.433 1.539-1.621 3.455-2.458 5.521-3.22-.505-1.002-.895-2.125-1.577-3.026-.654-.863-.719-1.878-.982-2.797-.3-1.044-.274-2.29-.012-3.355.257-1.042.899-2.031 1.542-2.92.581-.803 1.368-1.467 2.117-2.133.239-.213.646-.237.952-.34.412.574.284.966-.122 1.379-.422.431-.772.932-1.158 1.398-1.09 1.322-.746 2.9-.729 4.395.011.961.582 1.762 1.134 2.535 1.056 1.481 2.135 2.875 3.934 3.611.964.394 1.871.729 2.915.696.932-.03 1.865-.006 3.256-.006-.816-.365-1.229-.543-1.635-.733-2.861-1.331-4.351-3.593-4.354-6.604-.001-1.067.106-2.148-.032-3.196-.12-.908.405-1.631.432-2.483.022-.767-.353-1.624.354-2.293-.192-1.458.357-2.954-.291-4.398-.342-.761-.058-1.609-.398-2.469-.657-1.656-1.128-3.268-3.271-3.469-.229-.021-.425-.398-.628-.6.374-.811.756-.973 1.606-.704 2.172.686 3.472 2.152 4.517 4.087 1.122 2.078 1.499 4.291 1.911 6.567.414 2.287.182 4.552.338 6.819.052.756.257 1.514.488 2.24.224.706.755 1.125 1.479 1.195 1.048.103 1.798.03 2.798-.937v-1.912c-1-.39-.851-1.368-1.969-1.331-.424.014-.61-.615-.593-1.185.045-1.63.14-3.272-.003-4.892-.155-1.748.25-3.442.51-5.103.229-1.468.4-3.013.998-4.458.554-1.34.661-2.863 1.198-4.212.989-2.484 2.1-4.912 3.485-7.225.791-1.321 1.85-2.454 2.516-3.845a1.31 1.31 0 0 1 .193-.296c.974-1.104 1.896-2.261 2.94-3.293 1.26-1.242 2.625-2.377 3.997-3.606 1.436 1.274 2.93 2.378 4.151 3.729 3.314 3.668 6.225 7.658 8.098 12.26.873 2.143 1.703 4.326 2.144 6.656.397 2.103.81 4.192 1.159 6.306.452 2.735.087 5.437.305 8.141.043.536-.547 1.047-.831 1.024-1.125-.086-1.298.928-2.298 1.329v1.932c1 .723 1.721.981 2.699.95 1.179-.038 1.896-.672 2.218-1.892.352-1.337.486-2.668.37-3.995-.168-1.929.235-3.812.498-5.674a16.812 16.812 0 0 1 2.211-6.228c.766-1.286 3.056-3.045 4.399-3.312.59-.117 1.091.087 1.308.903-.225.174-.477.539-.764.567-1.898.186-2.462 1.664-3.026 3.093-.305.773-.235 1.699-.464 2.451-.396 1.292-.279 2.55-.284 3.819-.002.764.217 1.529.357 2.291.129.701-.309 1.475.339 2.131.158.16.033.602.033.914.001 1.192-.024 2.386.006 3.577.074 2.987-1.998 6.306-5.616 7.212 2.248.191 4.437.372 6.557-.928 2.065-1.267 3.169-3.209 4.328-5.167.028-2.252.336-4.59-1.757-6.232-.454-.356-.583-.764-.436-1.496.389.055.8-.013.957.155 1.152 1.241 2.675 2.181 3.224 3.927.155.495.631.96.61 1.423-.052 1.217.2 2.42-.17 3.673-.284.958-.583 1.899-1.009 2.789-.403.842-.939 1.62-1.446 2.475.71.346 1.389.796 2.136 1.017 1.591.47 2.682 1.573 3.779 2.702 1.092 1.125 1.227 2.632 1.647 4.026-.587 1.517-.717 3.205-1.935 4.477zm-58.602-6.295c-.622.055-1.256-.028-1.88.017-1.012.072-1.953.437-2.781.993-.835.56-.897 1.079-.502 2.047.392.962.976 1.759 1.719 2.495 1.324 1.313 2.703 2.535 4.33 3.447.579-3.218 2.38-5.551 5.124-7.266-.479-.235-.855-.396-1.208-.597-1.49-.855-3.069-1.291-4.802-1.136zm55.062 1.127c-.461-.41-2.231-1.103-2.923-1.115-.878-.016-1.761.056-2.633-.018-1.312-.111-2.443.403-3.588.892-.533.228-1.036.526-1.663.849 2.738 1.711 4.539 4.044 5.129 7.328.721-.517 1.47-.966 2.114-1.534a56.701 56.701 0 0 0 3.368-3.209c.343-.355.486-.917.678-1.401.274-.689.1-1.275-.482-1.792zM58.578 50.566c-.853.024-1.104.381-1.062 1.511.032.861.4 1.19 1.26 1.126.699-.052 1.451-.827 1.376-1.417-.076-.612-.887-1.239-1.574-1.22zm11.471 0c-.807-.038-1.65.681-1.609 1.371.037.623.816 1.269 1.527 1.266.828-.004 1.1-.317 1.109-1.277.009-1.003-.233-1.323-1.027-1.36zm-44.595 63.549h.048c.292-.413.681-.947 1.021-1.337l3.476-4.06h2.553l-4.546 4.838 5.178 6.929h-2.601l-4.036-5.665-1.094 1.24v4.425h-2.139v-17.261h2.139v10.891zm9.7-1.726c0-1.386-.024-2.577-.097-3.671h1.872l.097 2.31h.073c.535-1.58 1.848-2.577 3.282-2.577.219 0 .389.024.583.073v1.993c-.243-.024-.462-.048-.753-.048-1.507 0-2.577 1.143-2.869 2.723a6.68 6.68 0 0 0-.073 1.021v6.272H35.13l.024-8.096zm16.07 5.276c0 1.021.049 2.018.17 2.82h-1.92l-.195-1.483h-.072c-.632.924-1.921 1.75-3.599 1.75-2.382 0-3.598-1.677-3.598-3.379 0-2.844 2.528-4.4 7.074-4.376v-.242c0-.973-.267-2.748-2.674-2.724-1.118 0-2.261.316-3.087.875l-.486-1.434c.972-.608 2.407-1.021 3.89-1.021 3.623 0 4.498 2.455 4.498 4.814v4.4zm-2.091-3.185c-2.334-.049-4.984.364-4.984 2.649 0 1.41.924 2.043 1.994 2.043 1.556 0 2.553-.973 2.893-1.97.073-.219.097-.462.097-.681v-2.041zm7.659-.365h.049c.292-.413.681-.947 1.021-1.337l3.477-4.06h2.552l-4.546 4.838 5.178 6.929h-2.601l-4.036-5.665-1.094 1.24v4.425h-2.139v-17.261h2.139v10.891zm10.648.851c.049 2.893 1.872 4.084 4.011 4.084 1.531 0 2.479-.268 3.257-.583l.389 1.507c-.753.34-2.066.754-3.938.754-3.598 0-5.786-2.407-5.786-5.932 0-3.574 2.115-6.37 5.543-6.37 3.841 0 4.838 3.38 4.838 5.543 0 .438-.024.778-.073 1.021l-8.241-.024zm6.248-1.531c.024-1.337-.56-3.477-2.942-3.477-2.188 0-3.112 1.994-3.282 3.477h6.224zm4.716-1.532c0-1.239-.024-2.212-.097-3.185h1.896l.121 1.921h.049c.583-1.094 1.945-2.188 3.89-2.188 1.629 0 4.157.973 4.157 5.008v7.026h-2.139v-6.783c0-1.896-.706-3.5-2.723-3.5-1.386 0-2.479.997-2.869 2.188-.097.268-.146.656-.146.997v7.099h-2.139v-8.583zm10.6 12.034c.997-.073 1.823-.341 2.334-.9.583-.656.826-1.604.826-4.424v-9.895h2.14v10.721c0 2.286-.365 3.769-1.41 4.838-.948.948-2.504 1.337-3.646 1.337l-.244-1.677zm4.182-17.383c-.802 0-1.337-.632-1.337-1.385s.559-1.361 1.386-1.361 1.361.608 1.361 1.361-.51 1.385-1.386 1.385h-.024zm4.327 11.767c.656.389 1.774.827 2.844.827 1.532 0 2.261-.753 2.261-1.75 0-1.021-.607-1.58-2.164-2.163-2.139-.778-3.136-1.921-3.136-3.331 0-1.896 1.556-3.452 4.06-3.452 1.191 0 2.237.316 2.869.729l-.51 1.531c-.462-.267-1.313-.681-2.407-.681-1.264 0-1.945.729-1.945 1.604 0 .997.681 1.435 2.212 2.018 2.018.753 3.088 1.775 3.088 3.549 0 2.091-1.629 3.549-4.376 3.549-1.289 0-2.48-.34-3.307-.826l.511-1.604z\"/></svg>"

/***/ }),

/***/ "../src/components/krakenjs/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _KrakenjsPlainWordmark = __webpack_require__("../src/components/krakenjs/plain-wordmark/KrakenjsPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_KrakenjsPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/krakenjs/plain/KrakenjsPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _KrakenjsPlain = __webpack_require__("../src/components/krakenjs/plain/KrakenjsPlain.svg");
	
	var _KrakenjsPlain2 = _interopRequireDefault(_KrakenjsPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** KrakenjsPlain */
	function KrakenjsPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'KrakenjsPlain',
	    svg: _KrakenjsPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	KrakenjsPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = KrakenjsPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/krakenjs/plain/KrakenjsPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#0081C2\" d=\"M120.559 30.631c-5.13-2.544-10.203-5.131-15.391-7.569-10.106-4.748-19.884-10.136-30.046-14.781-3.297-1.507-6.479-3.25-9.7-4.923-1.077-.559-2.051-.562-3.143-.004-4.195 2.143-8.454 4.156-12.694 6.203-10.056 4.854-20.214 10.082-30.316 14.853C14.877 26.484 10 28.698 6 30.806v66.486c0 .043.66.043.788.106 3.187 1.571 6.533 3.109 9.692 4.735 3.224 1.66 6.586 3.169 9.856 4.729 10.146 4.837 20.188 9.969 30.255 14.975 1.946.968 3.969 1.821 5.881 2.852.97.522 1.718.475 2.704.005 3.007-1.433 6.03-2.857 9.019-4.316 11.598-5.663 23.018-11.561 34.682-17.091C112.938 101.36 116 99.27 121 97.193V30.737c-1-.044-.313-.043-.441-.106zm-14.932 61.447c-2.415 2.523-5.244 4.431-8.351 5.96-.777.382-1.575.835-2.409.966-1.281.2-1.728 1.212-2.324 2.052-1.021 1.439-3.477 2.896-5.181 2.918-.47.007-.942-.031-1.409.007-1.844.148-3.52-.307-5.173-1.138-2.266-1.139-4.725-1.328-7.25-1.26-1.328.037-2.49.343-3.603.983-1.479.852-2.276 2.798-1.956 4.401.078.393-.303.876-.558 1.537-.549-.463-1.148-.722-1.173-1.027-.167-2.042-.289-4.164 1.154-5.836 1.977-2.292 4.549-3.552 7.588-3.77.779-.055 1.567.012 2.35-.012 1.895-.06 3.686.293 5.531.804 1.528.423 3.33.512 4.869-.474.541-2.03-.531-3.5-2.014-4.454-1.564-1.007-3.137-2.071-5.066-2.515-1.378-.316-2.592-1.287-3.944-1.793-1.355-.508-2.711-1.057-4.065-1.55-1.293-.471-2.764-.452-3.921-1.297-2.147.101-4.23-.858-6.383-.458-2.809.522-5.644.981-8.308 2.063-2.011.816-4.047 1.573-5.976 2.6-1.142.608-2.446.903-3.623 1.456a13.71 13.71 0 0 0-2.623 1.597c-1.378 1.083-2.299 2.431-1.866 4.343 1.699.79 3.41.895 5.229.284 1.968-.662 4.046-.522 6.094-.646 2.596-.157 4.868.655 6.958 1.958 1.985 1.238 3.349 3.015 3.274 5.555-.016.548.081 1.114-.027 1.64-.096.464-.406.884-.732 1.546-.652-.678-1.703-.839-.744-1.868-.614-1.13-.254-2.689-1.487-3.532-1.09-.746-2.156-1.579-3.609-1.503-.859.045-1.729.075-2.583-.005-2.019-.188-3.834.494-5.544 1.377-2.362 1.221-4.862.952-7.349.987-1.402-.79-3.078-1.154-4.13-2.487-.533-.675-.765-1.884-1.398-2.112-.827-.298-1.584-.867-2.401-.997-2.066-.328-3.515-1.778-5.228-2.705-1.441-.78-2.595-2.116-3.821-3.265-1.343-1.257-2.037-2.836-2.347-4.669-.46-2.718.598-5.242 2.057-6.78 1.921-2.023 4.312-3.068 6.893-4.019-.631-1.25-1.117-2.652-1.969-3.777-.816-1.077-.897-2.344-1.227-3.492-.374-1.303-.341-2.858-.014-4.188.321-1.299 1.122-2.535 1.925-3.645.725-1.002 1.708-1.832 2.642-2.663.299-.266.807-.296 1.188-.424.515.717.354 1.207-.151 1.722-.527.538-.964 1.162-1.445 1.745-1.361 1.65-.931 3.62-.911 5.485.013 1.199.727 2.199 1.414 3.163 1.318 1.849 2.665 3.59 4.911 4.507 1.203.491 2.335.91 3.638.869 1.162-.037 2.328-.008 4.064-.008-1.018-.455-1.533-.678-2.042-.915-3.571-1.661-5.43-4.484-5.433-8.242-.001-1.332.132-2.681-.04-3.99-.15-1.133.506-2.035.538-3.1.029-.957-.439-2.027.443-2.861-.24-1.82.446-3.688-.362-5.49-.427-.95-.072-2.009-.497-3.082-.819-2.067-1.407-4.078-4.083-4.33-.287-.026-.531-.497-.784-.749.466-1.011.944-1.214 2.005-.879 2.711.856 4.333 2.687 5.637 5.101 1.4 2.593 1.871 5.356 2.386 8.198.518 2.854.228 5.681.421 8.511.065.943.321 1.89.609 2.797.279.88.816 1.404 1.721 1.492 1.31.132 2.368.04 3.368-1.166v-2.386c-1-.487-.938-1.707-2.332-1.662-.529.017-.698-.769-.678-1.478.056-2.035.207-4.085.028-6.106-.193-2.182.329-4.297.653-6.37.286-1.832.506-3.76 1.253-5.564.691-1.672.828-3.573 1.499-5.257 1.234-3.1 2.624-6.13 4.353-9.018.987-1.648 2.309-3.063 3.141-4.799.063-.131.144-.26.241-.37 1.216-1.378 2.366-2.822 3.671-4.109 1.573-1.551 3.276-2.968 4.989-4.502 1.791 1.591 3.657 2.969 5.181 4.655 4.136 4.579 7.77 9.559 10.108 15.302 1.089 2.674 2.125 5.4 2.675 8.308.496 2.624 1.011 5.232 1.446 7.871.564 3.414.109 6.786.381 10.161.053.669-.534 1.307-.89 1.279C81.316 63.375 81 64.641 80 65.142v2.41c1 .902 2 1.225 3.221 1.186 1.472-.047 2.294-.839 2.695-2.362.439-1.669.57-3.33.425-4.985-.21-2.408.274-4.758.602-7.082a20.924 20.924 0 0 1 2.751-7.772c.956-1.605 3.81-3.801 5.486-4.133.737-.146 1.36.107 1.631 1.126-.28.217-.597.673-.956.708-2.37.231-3.073 2.076-3.776 3.86-.381.965-.293 2.121-.581 3.06-.493 1.611-.349 3.182-.354 4.767-.003.953.271 1.909.445 2.859.162.875-.386 1.841.424 2.66.197.2.041.751.042 1.141.001 1.488-.03 2.978.006 4.464.092 3.729-2.494 7.871-7.01 9.002 2.807.238 5.539.464 8.185-1.158 2.579-1.581 3.956-4.006 5.401-6.45.035-2.811.42-5.729-2.193-7.779-.566-.445-.729-.954-.544-1.868.486.069.999-.016 1.193.194 1.438 1.549 3.339 2.722 4.024 4.902.194.617.788 1.197.762 1.776-.065 1.519.25 3.021-.213 4.584-.354 1.196-.729 2.371-1.26 3.481-.503 1.051-1.173 2.022-1.805 3.089.886.432 1.734.994 2.666 1.269 1.986.587 3.348 1.963 4.718 3.373 1.363 1.403 1.531 3.285 2.055 5.025-.73 1.893-.893 4-2.413 5.589zm-73.146-7.859c-.776.069-1.567-.034-2.346.021-1.263.089-2.437.545-3.471 1.238-1.043.699-1.12 1.347-.627 2.555.489 1.2 1.219 2.195 2.146 3.114 1.653 1.639 3.375 3.165 5.405 4.302.722-4.017 2.971-6.929 6.395-9.069-.598-.294-1.068-.494-1.507-.746-1.86-1.064-3.831-1.608-5.995-1.415zm68.727 1.407c-.576-.511-2.785-1.376-3.648-1.392-1.095-.02-2.198.07-3.286-.022-1.637-.138-3.05.503-4.479 1.114-.666.284-1.293.656-2.077 1.059 3.417 2.136 5.666 5.048 6.403 9.147.9-.645 1.835-1.205 2.638-1.915a70.97 70.97 0 0 0 4.204-4.005c.428-.444.606-1.145.847-1.75.343-.859.126-1.59-.602-2.236zM56.711 63.075c-1.065.029-1.378.476-1.326 1.886.04 1.074.5 1.485 1.574 1.405.872-.065 1.81-1.032 1.717-1.769-.096-.764-1.108-1.547-1.965-1.522zm14.316 0c-1.007-.047-2.06.85-2.009 1.711.047.777 1.019 1.583 1.907 1.58 1.033-.004 1.373-.396 1.384-1.594.012-1.251-.29-1.651-1.282-1.697z\"/></svg>"

/***/ }),

/***/ "../src/components/krakenjs/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _KrakenjsPlain = __webpack_require__("../src/components/krakenjs/plain/KrakenjsPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_KrakenjsPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/laravel/plain-wordmark/LaravelPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _LaravelPlainWordmark = __webpack_require__("../src/components/laravel/plain-wordmark/LaravelPlainWordmark.svg");
	
	var _LaravelPlainWordmark2 = _interopRequireDefault(_LaravelPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** LaravelPlainWordmark */
	function LaravelPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'LaravelPlainWordmark',
	    svg: _LaravelPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	LaravelPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = LaravelPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/laravel/plain-wordmark/LaravelPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#FD4F31\" d=\"M14.887 18.316l2.72 4.523 2.507 4.182c1.301 2.17 2.602 4.34 3.901 6.51l2.662 4.44 3.882 6.465 4.749 7.936c1.369 2.285 2.741 4.569 4.112 6.853l.184.267c.199.062.357.009.521-.03 1.807-.434 3.614-.865 5.421-1.296 2.931-.7 5.862-1.398 8.792-2.099l4.592-1.098c2.962-.708 5.926-1.414 8.889-2.124 2.996-.716 5.99-1.436 8.985-2.154 1.514-.363 3.028-.725 4.543-1.086l8.792-2.096 9.575-2.28.517-.14-.141-.28c-.869-1.232-1.742-2.462-2.613-3.693l-2.581-3.654-2.76-3.898-2.639-3.737-2.614-3.693-2.701-3.816-2.646-3.731-1.396-1.969a3.647 3.647 0 0 1-.497-.982c-.275-.856.039-1.425.538-1.846a3.018 3.018 0 0 1 1.1-.593 17.382 17.382 0 0 1 1.702-.432c1.151-.217 2.309-.402 3.465-.594 1.304-.217 2.609-.424 3.915-.639.825-.136 1.65-.279 2.476-.419l3.367-.567a927.64 927.64 0 0 1 3.269-.543l3.568-.583 2.477-.417c.94-.157 1.882-.314 2.823-.468 1.174-.191 2.346-.384 3.521-.568.698-.109 1.399-.148 2.093.052.521.151.994.395 1.436.706l.61.426c.061-.141-.027-.217-.067-.298a14.062 14.062 0 0 0-3.606-4.592 13.894 13.894 0 0 0-4.773-2.616c-1.04-.33-2.109-.483-3.199-.565l-.535-.08H24.561l-.429.069c-.954.075-1.892.217-2.815.47a13.74 13.74 0 0 0-5.401 2.885 13.768 13.768 0 0 0-2.435 2.727 13.743 13.743 0 0 0-2.156 5.189l.461.803c1.033 1.726 2.067 3.449 3.101 5.173zm5.241 87.825c.97.373 1.972.635 3.006.762l1.047.047c.163.021.32.05.48.05h32.288c-.052 0-.099-.149-.157-.25-1.271-2.168-2.554-4.296-3.81-6.472a1113.602 1113.602 0 0 1-4.705-8.233c-1.664-2.944-3.313-5.89-4.965-8.842a4986.932 4986.932 0 0 1-4.698-8.42c-.944-1.698-1.883-3.396-2.825-5.095l-.252-.388-.458.091c-.908.234-1.814.471-2.721.709-1.262.332-2.522.67-3.785 1-2.834.738-5.669 1.471-8.503 2.207-2.883.748-5.704 1.498-8.589 2.243-.175.046.519.062-.481.092v17.905c1 .104.136.294.158.477.066.53.085 1.064.179 1.59a13.427 13.427 0 0 0 2.224 5.378c1.664 2.392 3.852 4.103 6.567 5.149zm-6.122-40.39l10.008-2.377 4.396-1.039c.732-.174 1.468-.341 2.194-.537.646-.175.727-.389.394-.973-.481-.844-.97-1.682-1.458-2.522l-4.288-7.383-4.287-7.385-4.364-7.513-3.736-6.427-1.553-2.781c-.1-.17.689-.371-.311-.461v40.135c0-.027.204-.05.333-.081l2.672-.656zm102.671 28.688c-1.308.465-2.615.933-3.923 1.401a31869.44 31869.44 0 0 0-8.93 3.202c-1.652.593-3.304 1.193-4.959 1.784-3.371 1.204-6.744 2.403-10.117 3.604-1.955.696-3.91 1.325-5.863 2.024-.535.193-1.063.546-1.593.546h22.431l.484-.046a12.14 12.14 0 0 0 1.691-.181 13.742 13.742 0 0 0 6.191-2.815 13.962 13.962 0 0 0 3.438-4.016c.92-1.606 1.466-3.329 1.728-5.153.023-.157.072-.328-.06-.491-.184-.014-.349.08-.518.141zm-1.927-30.121c-.99-1.353-1.98-2.704-2.968-4.058-1.362-1.869-2.723-3.74-4.083-5.609-.553-.759-1.113-1.512-1.654-2.279-.162-.231-.348-.292-.601-.224l-.145.042-7.517 1.823-4.489 1.089-8.782 2.133-8.687 2.111c-3.01.729-6.02 1.456-9.028 2.186-2.961.719-5.921 1.44-8.881 2.16l-8.589 2.085c-1.513.367-3.025.733-4.537 1.103-.223.054-.463.067-.699.247l.202.385c1.268 2.19 2.535 4.379 3.806 6.567 1.438 2.478 2.878 4.955 4.321 7.43 1.587 2.72 3.178 5.439 4.768 8.159.913 1.562 1.821 3.127 2.742 4.685a543.92 543.92 0 0 0 3.094 5.178c.312.515.666 1.006 1.023 1.49.24.323.537.599.887.81.36.218.75.286 1.159.194.212-.048.419-.118.624-.189l.754-.279c2.74-.938 5.48-1.875 8.223-2.809 2.139-.729 4.28-1.453 6.421-2.177 2.125-.72 4.251-1.438 6.376-2.155l6.329-2.137c2.157-.729 4.314-1.458 6.471-2.189 2.647-.898 5.294-1.8 7.942-2.696 2.553-.864 5.107-1.723 7.662-2.584.156-.053.329-.075.459-.247l.016-.372c0-5.296-.001-10.594.006-15.891a1.16 1.16 0 0 0-.246-.738c-.801-1.077-1.588-2.162-2.379-3.244zm-.439-49.907c-.595-.753-1.352-.992-2.279-.75-.404.106-.819.172-1.23.248-1.351.247-2.701.49-4.052.735-1.976.359-3.951.722-5.928 1.077-1.564.282-3.131.558-4.696.833l-6.281 1.099c-.264.046-.53.092-.783.173-.37.119-.478.351-.309.699.139.284.311.556.497.812 1.298 1.79 2.604 3.576 3.908 5.362 1.798 2.463 3.598 4.926 5.397 7.388 1.522 2.083 3.046 4.166 4.57 6.248 1.197 1.637 2.395 3.272 3.593 4.908l.237.286c3.447-.853 6.889-1.703 10.39-2.568l.024-.538c0-7.208-.001-14.415.006-21.622 0-.318-.078-.574-.277-.826-.875-1.103-1.732-2.219-2.597-3.33l-.19-.234zm2.795 34.922c-1.572.377-3.149.737-4.759 1.163.171.303 4.585 6.262 4.842 6.544l.162.089.018-.363v-2.51c.002-1.455.006-2.911.002-4.366 0-.178.049-.367-.072-.547l-.193-.01zM12.93 127v-17.133h3.633V124h6.949v3H12.93zm24.047 0l-1.242-4.078h-6.246L28.246 127h-3.914l6.047-17.203h4.441L40.891 127h-3.914zm-2.11-7.125c-1.148-3.695-1.795-5.785-1.939-6.27s-.248-.867-.311-1.148c-.258 1-.996 3.473-2.215 7.418h4.465zm11.813.551V127h-3.633v-17.133h4.992c2.328 0 4.051.424 5.168 1.271s1.676 2.135 1.676 3.861c0 1.008-.277 1.904-.832 2.689s-1.34 1.4-2.355 1.846c2.578 3.852 4.258 6.34 5.039 7.465h-4.031l-4.09-6.574H46.68zm0-2.953h1.172c1.148 0 1.996-.191 2.543-.574s.82-.984.82-1.805c0-.812-.279-1.391-.838-1.734s-1.424-.516-2.596-.516H46.68v4.629zM69.379 127l-1.242-4.078h-6.246L60.648 127h-3.914l6.047-17.203h4.441L73.293 127h-3.914zm-2.109-7.125c-1.148-3.695-1.795-5.785-1.939-6.27s-.248-.867-.311-1.148c-.258 1-.996 3.473-2.215 7.418h4.465zm17.953-10.008h3.668L83.066 127h-3.961l-5.812-17.133h3.668l3.223 10.195c.18.602.365 1.303.557 2.104s.311 1.357.357 1.67c.086-.719.379-1.977.879-3.773l3.246-10.196zM100.914 127h-9.867v-17.133h9.867v2.977H94.68v3.762h5.801v2.977H94.68V124h6.234v3zm3.574 0v-17.133h3.633V124h6.949v3h-10.582z\"/></svg>"

/***/ }),

/***/ "../src/components/laravel/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LaravelPlainWordmark = __webpack_require__("../src/components/laravel/plain-wordmark/LaravelPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LaravelPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/laravel/plain/LaravelPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _LaravelPlain = __webpack_require__("../src/components/laravel/plain/LaravelPlain.svg");
	
	var _LaravelPlain2 = _interopRequireDefault(_LaravelPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** LaravelPlain */
	function LaravelPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'LaravelPlain',
	    svg: _LaravelPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	LaravelPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = LaravelPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/laravel/plain/LaravelPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FD4F31\" d=\"M16.934 1.719c-1.127.088-2.234.074-3.325.373-2.387.655-4.508 1.702-6.379 3.316-1.1.948-2.06 1.97-2.875 3.174-1.258 1.859-2.115 3.857-2.545 6.106.172.301.353.617.545.938 1.219 2.038 2.439 4.062 3.661 6.098l3.212 5.341c.988 1.646 1.974 3.293 2.96 4.939l4.608 7.688 3.143 5.244c1.527 2.545 3.058 5.088 4.583 7.634l5.609 9.371c1.617 2.699 3.237 5.396 4.857 8.093l.216.314c.235.075.422.011.616-.035 2.134-.512 4.268-1.021 6.402-1.531 3.461-.827 6.922-1.651 10.383-2.479l5.421-1.297c3.499-.836 6.999-1.67 10.498-2.508 3.537-.846 7.073-1.696 10.611-2.543 1.788-.429 3.576-.856 5.365-1.283 3.461-.826 6.922-1.65 10.383-2.474l11.308-2.693.611-.165-.167-.331-3.086-4.362-3.048-4.315-3.26-4.604-3.116-4.413-3.088-4.361-3.188-4.507c-1.041-1.47-2.084-2.938-3.126-4.407l-1.647-2.326a4.275 4.275 0 0 1-.587-1.159c-.326-1.011.046-1.684.636-2.181.382-.323.822-.56 1.298-.7a20.898 20.898 0 0 1 2.01-.51c1.359-.257 2.727-.475 4.091-.702l4.624-.754c.975-.161 1.949-.33 2.924-.495 1.325-.224 2.65-.449 3.976-.67 1.287-.216 2.574-.43 3.861-.642l4.213-.689 2.924-.491c1.112-.186 2.223-.371 3.334-.553 1.386-.226 2.771-.454 4.157-.671.826-.129 1.652-.174 2.472.062a5.63 5.63 0 0 1 1.696.833l.721.503c.072-.166-.032-.256-.08-.351a16.543 16.543 0 0 0-4.26-5.422 16.399 16.399 0 0 0-5.636-3.09c-1.229-.389-2.492-.208-3.778-.305M55.689 127c-.062 0-.117-.45-.187-.569-1.5-2.56-3.016-5.308-4.498-7.877a1335.74 1335.74 0 0 1-5.557-9.74c-1.965-3.478-3.913-6.966-5.863-10.452a5709.989 5709.989 0 0 1-5.549-9.948c-1.115-2.005-2.223-4.014-3.337-6.02l-.296-.459-.542.107c-1.072.277-2.142.556-3.212.838-1.49.392-2.979.791-4.47 1.18-3.347.871-6.694 1.737-10.041 2.605-3.404.884-6.951 1.77-10.356 2.65-.207.053.219.071-.781.106v21.145c.412.656.373.347.399.563.079.626.207 1.257.317 1.877.412 2.31 1.339 4.425 2.679 6.351 1.965 2.826 4.582 4.846 7.788 6.082 1.145.44 2.34.75 3.562.9l1.241.328\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FD4F31\" d=\"M4.976 77.742c3.939-.937 7.879-1.873 11.818-2.808 1.73-.41 3.461-.815 5.191-1.227.865-.206 1.732-.402 2.59-.634.764-.206.858-.459.465-1.148-.568-.996-1.146-1.986-1.721-2.979l-5.064-8.72-5.062-8.721c-1.717-2.958-3.436-5.916-5.154-8.873l-4.412-7.59c-.636-1.094-1.408-2.191-2.047-3.284-.119-.199.42-.437-.58-.543v47.396c0-.032.453-.059.606-.096l3.37-.773zm121.248 33.878c-1.544.549-3.089 1.102-4.632 1.655l-10.545 3.781c-1.953.701-3.902 1.41-5.856 2.108-3.982 1.421-7.966 2.837-11.949 4.255-2.308.822-4.617 1.838-6.924 2.664-.632.227-1.255.917-1.881.917h26.49l.57-.327c.674-.029 1.337-.229 1.999-.35 2.719-.497 5.154-1.673 7.311-3.392 1.657-1.321 3.005-2.936 4.061-4.778 1.086-1.896 1.731-3.947 2.041-6.101.027-.186.085-.397-.071-.589-.22-.017-.414.086-.614.157zm-2.275-35.571c-1.168-1.598-2.339-3.193-3.505-4.792-1.609-2.207-3.215-4.416-4.822-6.624-.653-.896-1.315-1.785-1.952-2.691-.192-.273-.411-.346-.71-.265l-.171.049c-2.958.719-5.917 1.436-8.876 2.153l-5.302 1.287-10.372 2.519c-3.419.831-6.838 1.663-10.258 2.492l-10.662 2.582c-3.497.849-6.992 1.701-10.488 2.551l-10.142 2.462c-1.787.434-3.574.866-5.359 1.302-.263.064-.546.08-.826.292l.239.455a5999.968 5999.968 0 0 0 9.598 16.529c1.874 3.213 3.753 6.424 5.63 9.636 1.079 1.845 2.151 3.692 3.239 5.532a661.851 661.851 0 0 0 3.653 6.115c.369.607.788 1.187 1.21 1.759a3.64 3.64 0 0 0 1.046.957c.426.257.885.338 1.369.229.25-.057.495-.139.737-.223l.89-.33c3.237-1.107 6.473-2.214 9.711-3.317 2.526-.86 5.055-1.716 7.583-2.571 2.509-.851 5.02-1.698 7.53-2.545l7.474-2.524c2.548-.861 5.095-1.722 7.642-2.585 3.126-1.061 6.251-2.126 9.379-3.185 3.015-1.02 6.033-2.034 9.049-3.052.185-.062.389-.088.542-.291l.019-.439c.001-6.255-.001-12.511.006-18.766a1.38 1.38 0 0 0-.289-.873c-.948-1.269-1.877-2.551-2.812-3.828zm-.519-58.938c-.702-.889-1.596-1.171-2.692-.885-.477.125-.967.204-1.453.293-1.594.292-3.19.579-4.784.868-2.334.424-4.667.852-7.001 1.272-1.848.332-3.697.659-5.546.983l-7.418 1.298c-.311.054-.625.108-.925.204-.437.14-.563.414-.363.825.163.336.366.657.586.959 1.534 2.114 3.075 4.223 4.616 6.333 2.124 2.909 4.249 5.817 6.374 8.724 1.798 2.46 3.598 4.92 5.397 7.379 1.414 1.932 2.828 3.864 4.244 5.795l.279.338 12.271-3.033.029-.636c.001-8.511-.001-17.022.006-25.534 0-.376-.091-.678-.328-.976-1.032-1.303-2.045-2.621-3.066-3.933l-.226-.274zm3.301 41.241c-1.856.446-3.719.87-5.62 1.373.201.357 5.415 7.395 5.718 7.729l.19.105.021-.429.001-2.963c.001-1.719.005-3.438.001-5.157 0-.209.059-.434-.085-.646l-.226-.012z\"/></svg>"

/***/ }),

/***/ "../src/components/laravel/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LaravelPlain = __webpack_require__("../src/components/laravel/plain/LaravelPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LaravelPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/less/plain-wordmark/LessPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _LessPlainWordmark = __webpack_require__("../src/components/less/plain-wordmark/LessPlainWordmark.svg");
	
	var _LessPlainWordmark2 = _interopRequireDefault(_LessPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** LessPlainWordmark */
	function LessPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'LessPlainWordmark',
	    svg: _LessPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	LessPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = LessPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/less/plain-wordmark/LessPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#2A4D80\" d=\"M122.301 58.635c-.6-1.299-.89-2.836-.952-4.283-.154-3.561-.023-7.135-.184-10.696-.144-3.189-1.282-6.063-4.344-7.707-2.696-1.447-5.821-1.591-8.821-1.625v5.691c1 .034.754.065.998.078 4.029.198 5.379 1.476 5.43 5.473.038 2.972.012 5.946.06 8.917.059 3.605.597 7.046 3.894 9.322.056.039.051.182.083.348-1.678 1.192-3.006 2.727-3.392 4.822a34.53 34.53 0 0 0-.54 5.153c-.096 3.118.003 6.243-.086 9.361-.07 2.442-1.227 3.588-3.604 4.132-.895.206-1.843.279-2.843.406v5.677c2-.12 3.017-.199 4.387-.347 5.156-.558 8.059-3.241 8.654-8.243.186-1.568.165-3.166.2-4.75.066-2.969.032-5.952.298-8.903.271-3.011 2.461-4.675 5.461-4.509v-5.951c-2 .358-3.843-.507-4.699-2.366zM28.314 70.768C28.313 59.219 28 47.67 28 36.122v-1.817c-3 0-6.226-.029-9.391.014-1.285.017-2.418.127-3.692.301-4.877.664-7.228 2.953-8.092 7.812-.25 1.402-.2 2.859-.221 4.293-.039 2.726.039 5.453-.005 8.178-.055 3.432-1.672 6.092-5.172 6.294-.124.007.573.15-.427.236v5.305c4 .628 5.273 2.243 5.539 5.959.042.592.053 1.189.059 1.784.034 3.32-.004 6.645.146 9.959.141 3.093.828 5.857 3.751 7.48C13.225 93.436 17 93.559 19 93.638v-5.664c0-.048-.21-.092-.405-.104-4.339-.265-5.317-1.443-5.343-5.785-.017-2.875.106-5.75.06-8.625-.058-3.612-.586-7.038-3.856-9.324-.05-.035-.001-.183-.017-.383 2.199-1.39 3.368-3.516 3.686-6.094.176-1.422.235-2.864.26-4.299.05-2.973-.003-5.949.078-8.92.057-2.088 1.39-3.61 3.091-3.952 1.612-.325 2.446-.315 5.446-.466v2.056c0 10.31-.367 20.619-.313 30.929.019 3.531.41 7.012 4.195 8.537 2.058.829 4.263 1.084 6.627 1.642.395-2.312.524-4.23.847-6.128-4.357-1.25-5.042-1.898-5.042-6.29zm26.674-19.893c-7.34-3.51-16.248-.441-19.666 6.921-2.574 5.544-2.482 11.25-.216 16.872 1.229 3.048 3.45 5.33 6.473 6.672 5.904 2.621 11.879 1.984 17.832.144.321-.1.731-.718.692-1.046-.203-1.661-.54-3.306-.841-5.021-1.417.357-2.601.722-3.811.949-3.197.601-6.401.6-9.512-.637-3.072-1.22-5.135-4.73-4.622-7.73h20.872c.255-3 .154-7.125-1.123-10.536-1.14-3.049-3.108-5.167-6.078-6.588zM54.944 63H41.228c.007-4 3.264-7.59 7.537-7.508 3.753.072 6.349 3.508 6.179 7.508zm56.108 12.279c.492-5.054-1.034-7.898-5.534-10.094-1.596-.779-3.29-1.356-4.916-2.078-1.217-.54-2.442-1.087-3.58-1.771-1.108-.665-1.572-1.769-1.408-3.062.161-1.277.982-2.119 2.168-2.359 1.437-.292 2.943-.542 4.388-.424 2.042.167 4.056.69 6.163 1.075l1.332-5.818c-2.851-.434-5.509-.995-8.195-1.207-2.987-.235-5.896.261-8.63 1.67-5.777 2.977-5.883 12.116-.574 15.116 1.586.896 3.283 1.596 4.933 2.38 1.737.827 3.537 1.546 5.199 2.504 1.262.727 1.713 1.996 1.375 3.475-.313 1.375-1.354 1.988-2.577 2.105-1.86.177-3.768.347-5.609.128-2.217-.264-4.387-.937-6.658-1.451l-1.158 5.79c5.333 2.002 10.61 2.33 15.938 1.149 4.459-.988 6.999-3.596 7.343-7.128zm-28.415-9.452c-1.959-1.039-4.066-1.797-6.088-2.723-1.255-.575-2.584-1.074-3.69-1.871-2.127-1.533-1.731-4.472.746-5.258 1.421-.452 3.028-.592 4.521-.48 2.034.153 4.041.679 6.162 1.063l1.258-5.546c-1.077-.293-2.052-.612-3.051-.822-3.971-.836-7.963-1.16-11.874.215-3.36 1.182-5.691 3.392-6.152 7.11-.516 4.152.861 7.43 4.696 9.402 1.535.79 3.18 1.363 4.747 2.095 1.564.73 3.161 1.427 4.614 2.343 1.111.7 1.549 1.885 1.236 3.255-.311 1.358-1.301 2.042-2.533 2.169-1.86.191-3.769.368-5.611.153-2.226-.26-4.403-.935-6.714-1.455-.341 1.613-.741 3.238-.99 4.885-.054.358.345 1.046.681 1.163 5.384 1.866 10.864 2.134 16.34.521 3.27-.962 5.557-3.051 6.018-6.623.523-4.055-.444-7.544-4.316-9.596z\"/></svg>"

/***/ }),

/***/ "../src/components/less/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LessPlainWordmark = __webpack_require__("../src/components/less/plain-wordmark/LessPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LessPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/linkedin/original-wordmark/LinkedinOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _LinkedinOriginalWordmark = __webpack_require__("../src/components/linkedin/original-wordmark/LinkedinOriginalWordmark.svg");
	
	var _LinkedinOriginalWordmark2 = _interopRequireDefault(_LinkedinOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** LinkedinOriginalWordmark */
	function LinkedinOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'LinkedinOriginalWordmark',
	    svg: _LinkedinOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	LinkedinOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = LinkedinOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/linkedin/original-wordmark/LinkedinOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Linkedin\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#1d1d1b}.cls-2{fill:#0076b2}.cls-3{fill:#fff}</style></defs><title>Artboard 13</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M.85 52.73h4.94v17.98h9.14v4.56H.85V52.73zM17.11 60h4.74v15.26h-4.74zm2.37-7.59a2.75 2.75 0 1 1-2.75 2.75 2.75 2.75 0 0 1 2.75-2.75M41.69 52.73h4.74V66.2l5.38-6.22h5.81l-6.22 7.07 6.09 8.22h-5.96l-5.04-7.55h-.06v7.55h-4.74V52.73zM24.48 60H29v2.09h.06a5 5 0 0 1 4.49-2.47c4.81 0 5.69 3.16 5.69 7.27v8.38h-4.7v-7.43c0-1.77 0-4-2.47-4s-2.85 1.93-2.85 3.92v7.55h-4.74z\"/><path class=\"cls-1\" d=\"M67.61 65.85a2.84 2.84 0 0 0-2.91-2.91 3.16 3.16 0 0 0-3.35 2.91zm4 6.77a8.35 8.35 0 0 1-6.48 3c-4.74 0-8.54-3.16-8.54-8.07s3.8-8.06 8.54-8.06c4.43 0 7.21 3.16 7.21 8.06v1.49h-11a3.54 3.54 0 0 0 3.57 3 4 4 0 0 0 3.38-1.87zM82.23 63.68A3.89 3.89 0 1 0 86 67.57a3.6 3.6 0 0 0-3.8-3.89m8.2 11.58H86v-2a6 6 0 0 1-4.71 2.4c-4.56 0-7.56-3.29-7.56-7.94 0-4.27 2.66-8.19 7-8.19a5.73 5.73 0 0 1 4.87 2h.06v-8.8h4.74z\"/><path class=\"cls-2\" d=\"M124.78 48H97.51a2.34 2.34 0 0 0-2.36 2.31v27.38A2.34 2.34 0 0 0 97.51 80h27.27a2.34 2.34 0 0 0 2.37-2.31V50.31a2.34 2.34 0 0 0-2.37-2.31z\"/><path class=\"cls-3\" d=\"M99.89 60h4.75v15.27h-4.75zm2.37-7.59a2.75 2.75 0 1 1-2.75 2.75 2.75 2.75 0 0 1 2.75-2.75M107.61 60h4.55v2.09h.06a5 5 0 0 1 4.49-2.47c4.81 0 5.69 3.16 5.69 7.27v8.38h-4.74v-7.43c0-1.77 0-4-2.47-4s-2.85 1.93-2.85 3.92v7.55h-4.74z\"/></g></svg>"

/***/ }),

/***/ "../src/components/linkedin/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LinkedinOriginalWordmark = __webpack_require__("../src/components/linkedin/original-wordmark/LinkedinOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkedinOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/linkedin/original/LinkedinOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _LinkedinOriginal = __webpack_require__("../src/components/linkedin/original/LinkedinOriginal.svg");
	
	var _LinkedinOriginal2 = _interopRequireDefault(_LinkedinOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** LinkedinOriginal */
	function LinkedinOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'LinkedinOriginal',
	    svg: _LinkedinOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	LinkedinOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = LinkedinOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/linkedin/original/LinkedinOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Linkedin\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#0076b2}.cls-2{fill:#fff}</style></defs><title>Artboard 12</title><g id=\"original\"><path class=\"cls-1\" d=\"M116 3H12a8.91 8.91 0 0 0-9 8.8v104.42a8.91 8.91 0 0 0 9 8.78h104a8.93 8.93 0 0 0 9-8.81V11.77A8.93 8.93 0 0 0 116 3z\"/><path class=\"cls-2\" d=\"M21.06 48.73h18.11V107H21.06zm9.06-29a10.5 10.5 0 1 1-10.5 10.49 10.5 10.5 0 0 1 10.5-10.49M50.53 48.73h17.36v8h.24c2.42-4.58 8.32-9.41 17.13-9.41C103.6 47.28 107 59.35 107 75v32H88.89V78.65c0-6.75-.12-15.44-9.41-15.44s-10.87 7.36-10.87 15V107H50.53z\"/></g></svg>"

/***/ }),

/***/ "../src/components/linkedin/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LinkedinOriginal = __webpack_require__("../src/components/linkedin/original/LinkedinOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkedinOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/linkedin/plain-wordmark/LinkedinPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _LinkedinPlainWordmark = __webpack_require__("../src/components/linkedin/plain-wordmark/LinkedinPlainWordmark.svg");
	
	var _LinkedinPlainWordmark2 = _interopRequireDefault(_LinkedinPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** LinkedinPlainWordmark */
	function LinkedinPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'LinkedinPlainWordmark',
	    svg: _LinkedinPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	LinkedinPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = LinkedinPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/linkedin/plain-wordmark/LinkedinPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Linkedin\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#1d1d1b}</style></defs><title>Artboard 15</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M.85 51.73h4.94v17.98h9.14v4.56H.85V51.73zM17.11 59h4.74v15.26h-4.74zm2.37-7.59a2.75 2.75 0 1 1-2.75 2.75 2.75 2.75 0 0 1 2.75-2.75M41.69 51.73h4.74V65.2l5.38-6.22h5.81l-6.22 7.07 6.09 8.22h-5.96l-5.04-7.55h-.06v7.55h-4.74V51.73zM24.48 59H29v2.09h.06a5 5 0 0 1 4.49-2.47c4.81 0 5.69 3.16 5.69 7.27v8.38h-4.7v-7.43c0-1.77 0-4-2.47-4s-2.85 1.93-2.85 3.92v7.55h-4.74z\"/><path class=\"cls-1\" d=\"M67.61 64.85a2.84 2.84 0 0 0-2.91-2.91 3.16 3.16 0 0 0-3.35 2.91zm4 6.77a8.35 8.35 0 0 1-6.48 3c-4.74 0-8.54-3.16-8.54-8.07s3.8-8.06 8.54-8.06c4.43 0 7.21 3.16 7.21 8.06v1.49h-11a3.54 3.54 0 0 0 3.57 3 4 4 0 0 0 3.38-1.87zM82.23 62.68A3.89 3.89 0 1 0 86 66.57a3.6 3.6 0 0 0-3.8-3.89m8.2 11.58H86v-2a6 6 0 0 1-4.71 2.4c-4.56 0-7.56-3.29-7.56-7.94 0-4.27 2.66-8.19 7-8.19a5.73 5.73 0 0 1 4.87 2h.06v-8.8h4.74z\"/><path id=\"plain\" d=\"M124.6 47H97.36A2.33 2.33 0 0 0 95 49.34v27.35A2.33 2.33 0 0 0 97.36 79h27.24a2.34 2.34 0 0 0 2.4-2.31V49.34a2.34 2.34 0 0 0-2.4-2.34zm-20.12 27.27h-4.74V59h4.74zm-2.37-17.34a2.75 2.75 0 1 1 2.75-2.75 2.75 2.75 0 0 1-2.75 2.75zm20.13 17.34h-4.74v-7.42c0-1.77 0-4-2.46-4s-2.85 1.93-2.85 3.92v7.55h-4.74V59H112v2.1h.06a5 5 0 0 1 4.49-2.46c4.8 0 5.69 3.16 5.69 7.27z\"/></g></svg>"

/***/ }),

/***/ "../src/components/linkedin/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LinkedinPlainWordmark = __webpack_require__("../src/components/linkedin/plain-wordmark/LinkedinPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkedinPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/linkedin/plain/LinkedinPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _LinkedinPlain = __webpack_require__("../src/components/linkedin/plain/LinkedinPlain.svg");
	
	var _LinkedinPlain2 = _interopRequireDefault(_LinkedinPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** LinkedinPlain */
	function LinkedinPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'LinkedinPlain',
	    svg: _LinkedinPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	LinkedinPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = LinkedinPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/linkedin/plain/LinkedinPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><title>Artboard 14</title><path d=\"M116 3H12a8.91 8.91 0 0 0-9 8.8v104.42a8.91 8.91 0 0 0 9 8.78h104a8.93 8.93 0 0 0 9-8.81V11.77A8.93 8.93 0 0 0 116 3zM39.17 107H21.06V48.73h18.11zm-9-66.21a10.5 10.5 0 1 1 10.49-10.5 10.5 10.5 0 0 1-10.54 10.48zM107 107H88.89V78.65c0-6.75-.12-15.44-9.41-15.44s-10.87 7.36-10.87 15V107H50.53V48.73h17.36v8h.24c2.42-4.58 8.32-9.41 17.13-9.41C103.6 47.28 107 59.35 107 75z\"/></svg>"

/***/ }),

/***/ "../src/components/linkedin/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LinkedinPlain = __webpack_require__("../src/components/linkedin/plain/LinkedinPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkedinPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/linux/original/LinuxOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _LinuxOriginal = __webpack_require__("../src/components/linux/original/LinuxOriginal.svg");
	
	var _LinuxOriginal2 = _interopRequireDefault(_LinuxOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** LinuxOriginal */
	function LinuxOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'LinuxOriginal',
	    svg: _LinuxOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	LinuxOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = LinuxOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/linux/original/LinuxOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><radialGradient id=\"a\" cx=\"-992.915\" cy=\"-952.952\" r=\"43.267\" gradientTransform=\"matrix(.7 0 0 .35 782.303 444.575)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-opacity=\".502\"/><stop offset=\"1\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#a)\" d=\"M117.641 111.137c0 8.362-13.557 15.14-30.28 15.14-16.722 0-30.279-6.778-30.279-15.14s13.556-15.14 30.278-15.14c16.723.001 30.281 6.779 30.281 15.14z\"/><radialGradient id=\"b\" cx=\"-770.661\" cy=\"-951.636\" r=\"43.267\" gradientTransform=\"matrix(.719 0 0 .35 595.327 443.952)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-opacity=\".502\"/><stop offset=\"1\" stop-opacity=\"0\"/></radialGradient><path fill=\"url(#b)\" d=\"M72.546 110.974c0 8.362-13.921 15.14-31.094 15.14s-31.093-6.778-31.093-15.14c0-8.361 13.921-15.14 31.093-15.14 17.173 0 31.094 6.779 31.094 15.14z\"/><path d=\"M108.095 81.343c-1.534 6.324-9.322 19.527-13.459 25.338-4.138 5.835-3.626 11.089-11.275 9.043-7.625-2.045-9.763-1.673-17.644-1.208-7.833.464-6.137-.233-11.042 1.976-4.882 2.208-21.27-26.78-22.595-32.173-1.301-5.393-1.93-4.743 1.464-10.577 3.395-5.834 3.883-11.6 8.368-18.667 4.487-7.09 9.671-10.693 9.299-16.109-1.464-20.108-2.626-30.15 6.301-34.8 8.507-4.417 15.621-1.79 18.434-.279 1.208.651 3.673 1.906 5.509 4.115 1.836 2.162 3.487 5.44 4.417 9.577 1.906 8.299-.791 5.556 1.371 15.064 2.139 9.484 6.485 14.133 11.787 21.642 5.299 7.508 10.832 19.898 9.065 27.058z\"/><path fill=\"#666\" d=\"M57.644 32.088c1.394-.558 1.16-.632 2.089-2.655.744-1.557 1.398-2.227 1.375-4.598 0-2.325-.722-3.115-1.814-4.626-1.045-1.441-2.719-1.511-3.765-1.325-.604.093-1.395.86-1.93 2-.348.767-.628 1.744-.651 2.766-.07 2.743.163 3.79.791 5.649.743 2.185 2.556 3.325 3.905 2.789z\"/><path fill=\"#6D6D6D\" d=\"M57.644 32.08c1.385-.554 1.15-.631 2.074-2.641.739-1.547 1.392-2.215 1.379-4.573.009-2.309-.698-3.133-1.771-4.585-1.065-1.403-2.705-1.456-3.743-1.276-.619.091-1.406.829-1.95 1.927a6.637 6.637 0 0 0-.673 2.755c-.068 2.724.176 3.775.794 5.624.732 2.173 2.55 3.3 3.89 2.769z\"/><path fill=\"#757575\" d=\"M57.644 32.071c1.376-.551 1.141-.629 2.059-2.626.735-1.537 1.387-2.202 1.384-4.547.017-2.294-.676-3.15-1.731-4.544-1.082-1.364-2.688-1.401-3.719-1.227-.633.089-1.417.798-1.969 1.854-.401.725-.675 1.713-.698 2.745-.067 2.706.191 3.761.798 5.598.721 2.16 2.545 3.275 3.876 2.747z\"/><path fill=\"#7C7C7C\" d=\"M57.644 32.063c1.367-.547 1.132-.628 2.044-2.611.729-1.528 1.381-2.191 1.389-4.522.026-2.278-.653-3.167-1.69-4.503-1.099-1.325-2.673-1.345-3.695-1.178-.648.088-1.429.769-1.989 1.783-.427.703-.697 1.697-.72 2.733-.066 2.687.205 3.747.802 5.573.707 2.147 2.537 3.248 3.859 2.725z\"/><path fill=\"#848484\" d=\"M57.644 32.054c1.359-.544 1.123-.627 2.028-2.598.726-1.518 1.378-2.179 1.395-4.497.034-2.263-.629-3.185-1.649-4.462-1.117-1.287-2.658-1.29-3.672-1.129-.662.086-1.44.737-2.01 1.709-.453.683-.721 1.682-.744 2.723-.064 2.668.22 3.732.808 5.548.694 2.137 2.531 3.227 3.844 2.706z\"/><path fill=\"#8C8C8C\" d=\"M57.644 32.046c1.35-.54 1.113-.626 2.013-2.583.721-1.507 1.373-2.167 1.4-4.472.043-2.248-.608-3.202-1.609-4.422-1.134-1.248-2.643-1.235-3.649-1.08-.676.085-1.45.707-2.029 1.637-.479.662-.744 1.667-.766 2.712-.063 2.65.233 3.718.81 5.522.683 2.125 2.526 3.203 3.83 2.686z\"/><path fill=\"#939393\" d=\"M57.644 32.037c1.34-.536 1.104-.624 1.998-2.569.715-1.497 1.367-2.154 1.405-4.446.052-2.232-.584-3.22-1.567-4.381-1.152-1.209-2.625-1.18-3.625-1.032-.691.084-1.462.676-2.049 1.565-.505.641-.768 1.651-.791 2.702-.06 2.631.249 3.704.815 5.497.67 2.112 2.517 3.178 3.814 2.664z\"/><path fill=\"#9B9B9B\" d=\"M57.644 32.028c1.333-.533 1.095-.624 1.983-2.554.71-1.488 1.361-2.143 1.41-4.421.061-2.217-.562-3.237-1.528-4.339-1.168-1.171-2.609-1.125-3.602-.983-.705.082-1.473.646-2.069 1.492-.531.619-.79 1.636-.813 2.691-.06 2.613.261 3.689.818 5.472.66 2.099 2.514 3.153 3.801 2.642z\"/><path fill=\"#A3A3A3\" d=\"M57.644 32.02c1.323-.529 1.086-.622 1.968-2.54.706-1.478 1.356-2.13 1.415-4.396.069-2.202-.54-3.254-1.487-4.299-1.187-1.132-2.594-1.07-3.579-.934-.719.081-1.484.615-2.088 1.42-.557.598-.814 1.621-.836 2.681-.059 2.593.275 3.674.822 5.446.649 2.087 2.507 3.129 3.785 2.622z\"/><path fill=\"#aaa\" d=\"M57.644 32.011c1.314-.525 1.077-.62 1.953-2.526.7-1.467 1.351-2.119 1.419-4.37.078-2.187-.516-3.272-1.445-4.258-1.205-1.094-2.58-1.015-3.556-.885-.733.079-1.496.584-2.109 1.347-.583.578-.837 1.606-.859 2.669-.057 2.576.289 3.661.826 5.422.638 2.075 2.5 3.105 3.771 2.601z\"/><path fill=\"#B2B2B2\" d=\"M57.644 32.002c1.305-.522 1.067-.62 1.937-2.512.696-1.457 1.346-2.106 1.425-4.345.086-2.171-.493-3.29-1.404-4.217-1.223-1.055-2.563-.959-3.532-.836-.749.077-1.507.554-2.128 1.275-.61.556-.861 1.591-.883 2.659-.055 2.556.304 3.646.831 5.396.624 2.064 2.493 3.081 3.754 2.58z\"/><path fill=\"#BABABA\" d=\"M57.644 31.994c1.296-.518 1.058-.618 1.922-2.497.692-1.448 1.341-2.095 1.43-4.32.096-2.156-.47-3.307-1.363-4.176-1.239-1.016-2.547-.903-3.508-.787-.763.075-1.518.522-2.148 1.202-.637.535-.885 1.576-.906 2.648-.054 2.538.317 3.632.834 5.371.611 2.051 2.486 3.055 3.739 2.559z\"/><path fill=\"#C1C1C1\" d=\"M57.644 31.985c1.288-.515 1.049-.616 1.907-2.483.686-1.437 1.336-2.082 1.435-4.294.104-2.141-.448-3.324-1.322-4.135-1.257-.978-2.533-.849-3.486-.738-.776.074-1.529.492-2.168 1.13-.662.513-.907 1.56-.929 2.636-.052 2.519.333 3.618.839 5.346.599 2.039 2.481 3.031 3.724 2.538z\"/><path fill=\"#C9C9C9\" d=\"M57.644 31.976c1.278-.511 1.04-.615 1.892-2.468.681-1.427 1.33-2.071 1.439-4.269.114-2.125-.424-3.342-1.281-4.094-1.274-.939-2.516-.794-3.462-.69-.79.072-1.54.462-2.188 1.058-.688.492-.931 1.544-.953 2.626-.05 2.5.346 3.603.843 5.32.588 2.027 2.475 3.007 3.71 2.517z\"/><path fill=\"#D1D1D1\" d=\"M57.645 31.968c1.269-.508 1.029-.614 1.875-2.454.678-1.417 1.327-2.059 1.446-4.244.121-2.11-.402-3.359-1.241-4.053-1.292-.901-2.501-.739-3.438-.641-.806.07-1.552.431-2.208.985-.714.471-.955 1.529-.976 2.616-.049 2.481.36 3.588.847 5.295.575 2.014 2.467 2.983 3.695 2.496z\"/><path fill=\"#D8D8D8\" d=\"M57.645 31.96c1.259-.504 1.02-.613 1.86-2.44.672-1.407 1.321-2.046 1.451-4.218.129-2.095-.38-3.376-1.199-4.013-1.311-.862-2.486-.683-3.416-.591-.819.069-1.563.399-2.228.913-.74.45-.978 1.514-.999 2.604-.048 2.463.374 3.575.851 5.27.565 2.001 2.462 2.957 3.68 2.475z\"/><path fill=\"#E0E0E0\" d=\"M57.645 31.95c1.251-.5 1.011-.611 1.845-2.425.667-1.397 1.315-2.034 1.455-4.193.139-2.079-.356-3.395-1.159-3.972-1.327-.823-2.47-.628-3.392-.542-.833.067-1.573.369-2.247.841-.766.429-1.001 1.499-1.022 2.594-.047 2.445.389 3.561.855 5.245.553 1.988 2.455 2.932 3.665 2.452z\"/><path fill=\"#E8E8E8\" d=\"M57.645 31.942c1.242-.497 1.002-.61 1.83-2.411.662-1.387 1.311-2.022 1.46-4.167.147-2.064-.334-3.412-1.118-3.931-1.345-.784-2.454-.573-3.369-.494a4.872 4.872 0 0 0-2.268.768c-.791.408-1.024 1.483-1.044 2.583-.045 2.426.403 3.546.858 5.219.541 1.978 2.45 2.909 3.651 2.433z\"/><path fill=\"#EFEFEF\" d=\"M57.645 31.934c1.232-.494.992-.609 1.814-2.397.658-1.376 1.305-2.01 1.466-4.142.156-2.048-.312-3.429-1.077-3.89-1.362-.746-2.439-.518-3.345-.444a5.373 5.373 0 0 0-2.287.695c-.818.386-1.048 1.468-1.069 2.572-.044 2.408.417 3.532.863 5.194.528 1.965 2.442 2.884 3.635 2.412z\"/><path fill=\"#F7F7F7\" d=\"M57.645 31.925c1.225-.49.984-.607 1.799-2.383.653-1.367 1.3-1.998 1.471-4.117.165-2.033-.289-3.447-1.036-3.849-1.38-.707-2.423-.462-3.322-.396a6.03 6.03 0 0 0-2.308.623c-.844.366-1.071 1.453-1.092 2.562-.042 2.388.431 3.518.868 5.168.516 1.954 2.436 2.861 3.62 2.392z\"/><path fill=\"#fff\" d=\"M57.645 31.916c1.215-.486.974-.606 1.784-2.368.648-1.356 1.295-1.986 1.475-4.091.174-2.018-.266-3.464-.995-3.808-1.397-.669-2.407-.408-3.298-.348a6.878 6.878 0 0 0-2.326.551c-.871.344-1.095 1.438-1.116 2.551-.04 2.37.446 3.503.871 5.144.504 1.94 2.431 2.835 3.605 2.369z\"/><path d=\"M56.342 22.627c.698 0 1.581.465 1.999 1.092.442.628.767 1.511.767 2.511 0 1.488-.163 3.138-1.046 3.649-.279.163-.884.302-1.232.302-.79 0-.86-.512-1.604-1.279-.255-.279-1.023-1.627-1.023-2.743 0-.697-.163-1.697.441-2.581.42-.649.954-.951 1.698-.951zm-.186 1.247c.272-.421 1.363-.223 1.759.645.397.868.322 2.752.049 2.851-.718.223-.495-.818-1.115-1.76-.619-.892-.966-1.314-.693-1.736z\"/><path fill=\"#070707\" d=\"M56.173 23.893c.269-.416 1.346-.22 1.737.636.392.856.318 2.717.049 2.814-.709.22-.489-.808-1.101-1.738-.611-.88-.954-1.296-.685-1.712z\"/><path fill=\"#0F0F0F\" d=\"M56.191 23.91c.266-.411 1.329-.217 1.715.628.387.845.314 2.682.049 2.778-.701.217-.484-.797-1.088-1.715-.604-.869-.942-1.28-.676-1.691z\"/><path fill=\"#161616\" d=\"M56.208 23.928c.263-.406 1.312-.215 1.692.62.382.834.311 2.647.048 2.742-.692.214-.477-.788-1.073-1.693-.595-.858-.929-1.263-.667-1.669z\"/><path fill=\"#1E1E1E\" d=\"M56.226 23.945c.258-.399 1.293-.211 1.67.612.376.824.306 2.613.047 2.707-.683.211-.471-.776-1.059-1.67-.587-.848-.917-1.248-.658-1.649z\"/><path fill=\"#262626\" d=\"M56.243 23.963c.255-.395 1.277-.208 1.648.604.371.812.301 2.577.046 2.67-.672.209-.464-.767-1.044-1.648-.58-.836-.905-1.231-.65-1.626z\"/><path fill=\"#2D2D2D\" d=\"M56.26 23.981c.253-.39 1.26-.206 1.627.595.366.802.297 2.542.046 2.634-.665.206-.458-.756-1.031-1.627-.572-.823-.894-1.212-.642-1.602z\"/><path fill=\"#353535\" d=\"M56.278 23.999c.249-.384 1.243-.203 1.604.587.361.791.293 2.507.046 2.598-.656.204-.452-.745-1.017-1.604-.565-.813-.882-1.197-.633-1.581z\"/><path fill=\"#3D3D3D\" d=\"M56.295 24.017c.246-.378 1.226-.2 1.582.579.356.78.29 2.472.045 2.562-.646.201-.446-.735-1.002-1.581-.558-.802-.87-1.181-.625-1.56z\"/><path fill=\"#444\" d=\"M56.313 24.034c.241-.373 1.208-.197 1.559.571.352.769.286 2.438.044 2.526-.637.198-.439-.725-.988-1.559-.549-.791-.857-1.164-.615-1.538z\"/><path fill=\"#4C4C4C\" d=\"M56.33 24.052c.238-.368 1.19-.194 1.537.563.347.758.281 2.403.044 2.489-.628.195-.433-.714-.974-1.537-.543-.779-.845-1.147-.607-1.515z\"/><path fill=\"#545454\" d=\"M56.347 24.07c.235-.362 1.174-.192 1.515.554.341.747.276 2.368.042 2.454-.619.191-.426-.705-.96-1.515-.533-.767-.831-1.13-.597-1.493z\"/><path fill=\"#5B5B5B\" d=\"M56.365 24.088c.231-.357 1.157-.189 1.493.546.336.735.273 2.333.042 2.417-.609.189-.42-.694-.946-1.492-.526-.756-.82-1.114-.589-1.471z\"/><path fill=\"#636363\" d=\"M56.383 24.106c.228-.352 1.139-.186 1.47.539.332.725.269 2.298.041 2.381-.6.187-.413-.684-.931-1.47-.518-.746-.808-1.098-.58-1.45z\"/><path fill=\"#6B6B6B\" d=\"M56.4 24.124c.224-.347 1.122-.183 1.448.53.326.714.265 2.263.041 2.345-.591.184-.408-.673-.918-1.447-.51-.735-.795-1.082-.571-1.428z\"/><path fill=\"#727272\" d=\"M56.417 24.141c.221-.341 1.104-.181 1.425.522.321.703.261 2.229.04 2.308-.582.181-.401-.663-.903-1.425-.502-.722-.783-1.064-.562-1.405z\"/><path fill=\"#7A7A7A\" d=\"M56.434 24.159c.218-.336 1.087-.178 1.403.514.316.692.256 2.193.04 2.272-.574.178-.395-.653-.889-1.403-.494-.711-.771-1.047-.554-1.383z\"/><path fill=\"#828282\" d=\"M56.452 24.177c.213-.331 1.07-.175 1.38.505.312.681.252 2.158.039 2.236-.564.175-.388-.642-.875-1.38-.486-.699-.758-1.031-.544-1.361z\"/><path fill=\"#898989\" d=\"M56.47 24.194c.21-.325 1.053-.172 1.358.498.307.669.25 2.124.039 2.201-.555.172-.383-.632-.861-1.358-.479-.69-.746-1.015-.536-1.341z\"/><path fill=\"#919191\" d=\"M56.487 24.212c.207-.32 1.035-.169 1.335.49.301.658.246 2.088.038 2.164-.546.17-.376-.621-.846-1.335-.471-.678-.734-.999-.527-1.319z\"/><path fill=\"#999\" d=\"M56.504 24.23c.204-.314 1.018-.167 1.314.481.295.647.239 2.054.036 2.128-.536.167-.369-.611-.832-1.314-.462-.666-.721-.98-.518-1.295z\"/><path fill=\"#666\" d=\"M72.056 32.391c3.487-.372 4.719-1.72 5.347-4.068.558-2.092.582-4.417-.976-7.137-1.465-2.603-2.301-3.022-4.417-3.185-3.254-.278-4.789 1.999-5.51 3.626-.767 1.767-.604 1.511-.558 3.743.047 2.348 1.37 3.002 2.185 4.467.813 1.442 3.534 2.577 3.929 2.554z\"/><path fill=\"#6D6D6D\" d=\"M72.058 32.377c3.474-.365 4.719-1.729 5.332-4.058.549-2.106.576-4.419-.969-7.075-1.432-2.517-2.272-2.932-4.363-3.094-3.244-.278-4.824 1.896-5.547 3.511-.744 1.705-.606 1.523-.557 3.726.052 2.346 1.378 2.978 2.191 4.442.813 1.446 3.518 2.572 3.913 2.548z\"/><path fill=\"#757575\" d=\"M72.059 32.364c3.461-.358 4.721-1.737 5.318-4.048.541-2.121.572-4.42-.962-7.013-1.398-2.431-2.243-2.842-4.308-3.002-3.235-.277-4.86 1.792-5.585 3.395-.719 1.643-.608 1.536-.556 3.708.057 2.346 1.385 2.953 2.196 4.419.813 1.449 3.503 2.565 3.897 2.541z\"/><path fill=\"#7C7C7C\" d=\"M72.061 32.351c3.447-.352 4.721-1.745 5.303-4.038.532-2.136.567-4.423-.955-6.951-1.365-2.345-2.213-2.751-4.254-2.911-3.224-.275-4.894 1.69-5.622 3.28-.697 1.581-.611 1.548-.555 3.691.062 2.344 1.391 2.929 2.202 4.395.813 1.451 3.486 2.558 3.881 2.534z\"/><path fill=\"#848484\" d=\"M72.063 32.337c3.434-.345 4.721-1.753 5.287-4.027.524-2.151.563-4.425-.947-6.889-1.333-2.259-2.186-2.661-4.201-2.819-3.214-.275-4.929 1.587-5.66 3.164-.672 1.518-.612 1.56-.554 3.674.068 2.343 1.399 2.904 2.209 4.37.815 1.455 3.471 2.552 3.866 2.527z\"/><path fill=\"#8C8C8C\" d=\"M72.065 32.324c3.42-.338 4.721-1.762 5.272-4.018.516-2.165.558-4.426-.94-6.827-1.299-2.172-2.156-2.571-4.146-2.727-3.205-.273-4.964 1.484-5.697 3.048-.649 1.457-.615 1.573-.553 3.658.073 2.341 1.406 2.879 2.214 4.346.813 1.458 3.455 2.545 3.85 2.52z\"/><path fill=\"#939393\" d=\"M72.066 32.311c3.407-.332 4.724-1.77 5.258-4.008.507-2.179.553-4.428-.934-6.765-1.266-2.086-2.125-2.48-4.09-2.636-3.194-.273-5 1.381-5.736 2.933-.625 1.394-.616 1.585-.552 3.64.078 2.34 1.413 2.855 2.221 4.322.813 1.461 3.439 2.538 3.833 2.514z\"/><path fill=\"#9B9B9B\" d=\"M72.068 32.297c3.393-.326 4.723-1.778 5.243-3.998.498-2.194.547-4.43-.926-6.704-1.233-2-2.098-2.39-4.038-2.544-3.184-.271-5.034 1.277-5.773 2.817-.602 1.333-.619 1.598-.551 3.624.083 2.339 1.42 2.831 2.226 4.299.815 1.464 3.424 2.532 3.819 2.506z\"/><path fill=\"#A3A3A3\" d=\"M72.069 32.284c3.381-.318 4.724-1.787 5.23-3.988.489-2.209.542-4.432-.921-6.641-1.2-1.914-2.068-2.301-3.982-2.453-3.174-.271-5.069 1.174-5.811 2.702-.579 1.269-.621 1.61-.551 3.606.089 2.337 1.427 2.805 2.233 4.274.815 1.468 3.408 2.525 3.802 2.5z\"/><path fill=\"#aaa\" d=\"M72.072 32.27c3.366-.312 4.724-1.795 5.213-3.978.481-2.224.538-4.434-.912-6.58-1.167-1.828-2.04-2.209-3.929-2.361-3.164-.27-5.104 1.071-5.848 2.586-.555 1.208-.623 1.622-.549 3.589.093 2.336 1.433 2.781 2.239 4.25.814 1.473 3.39 2.52 3.786 2.494z\"/><path fill=\"#B2B2B2\" d=\"M72.073 32.257c3.353-.305 4.725-1.803 5.199-3.967.472-2.238.533-4.436-.906-6.519-1.134-1.741-2.01-2.12-3.874-2.269-3.153-.269-5.138.968-5.886 2.47-.531 1.146-.625 1.635-.548 3.572.099 2.335 1.441 2.756 2.246 4.226.813 1.475 3.374 2.513 3.769 2.487z\"/><path fill=\"#BABABA\" d=\"M72.075 32.243c3.34-.298 4.726-1.811 5.184-3.958.464-2.252.529-4.438-.898-6.456-1.101-1.656-1.981-2.03-3.82-2.178-3.144-.268-5.173.865-5.923 2.354-.507 1.084-.627 1.648-.547 3.555.104 2.334 1.448 2.732 2.251 4.202.813 1.48 3.358 2.508 3.753 2.481z\"/><path fill=\"#C1C1C1\" d=\"M72.076 32.231c3.327-.292 4.727-1.82 5.17-3.948.455-2.268.524-4.439-.891-6.395-1.068-1.569-1.952-1.939-3.766-2.086-3.133-.267-5.21.761-5.962 2.239-.483 1.021-.627 1.66-.545 3.538.109 2.332 1.455 2.708 2.257 4.177.814 1.482 3.343 2.501 3.737 2.475z\"/><path fill=\"#C9C9C9\" d=\"M72.078 32.217c3.313-.285 4.727-1.829 5.155-3.938.446-2.282.518-4.441-.884-6.332-1.035-1.483-1.922-1.849-3.711-1.995-3.124-.266-5.244.659-6 2.124-.46.959-.631 1.672-.545 3.521.115 2.331 1.461 2.682 2.263 4.153.814 1.485 3.327 2.494 3.722 2.467z\"/><path fill=\"#D1D1D1\" d=\"M72.079 32.203c3.3-.278 4.728-1.836 5.141-3.928.438-2.296.513-4.443-.877-6.27-1.002-1.396-1.893-1.759-3.657-1.903-3.114-.265-5.279.555-6.037 2.008-.437.897-.633 1.685-.544 3.504.119 2.329 1.469 2.658 2.27 4.129.813 1.489 3.31 2.488 3.704 2.46z\"/><path fill=\"#D8D8D8\" d=\"M72.081 32.19c3.286-.272 4.728-1.845 5.126-3.918.429-2.311.509-4.445-.87-6.208-.969-1.311-1.864-1.668-3.604-1.812-3.103-.263-5.314.453-6.074 1.893-.413.835-.634 1.697-.543 3.487.125 2.328 1.476 2.633 2.276 4.105.814 1.492 3.295 2.481 3.689 2.453z\"/><path fill=\"#E0E0E0\" d=\"M72.083 32.176c3.273-.264 4.729-1.853 5.111-3.907.42-2.326.504-4.447-.863-6.147-.936-1.224-1.835-1.578-3.548-1.72-3.094-.262-5.349.349-6.112 1.776-.389.773-.637 1.709-.542 3.47.13 2.327 1.482 2.609 2.281 4.082.814 1.495 3.279 2.475 3.673 2.446z\"/><path fill=\"#E8E8E8\" d=\"M72.085 32.164c3.259-.259 4.729-1.862 5.097-3.897.411-2.341.498-4.449-.856-6.084-.903-1.138-1.805-1.488-3.495-1.628-3.083-.262-5.384.246-6.149 1.661-.366.711-.639 1.722-.541 3.453.135 2.325 1.489 2.583 2.287 4.057.814 1.495 3.262 2.465 3.657 2.438z\"/><path fill=\"#EFEFEF\" d=\"M72.086 32.149c3.247-.251 4.73-1.87 5.082-3.887.404-2.355.495-4.451-.848-6.022-.87-1.052-1.776-1.398-3.441-1.538-3.072-.26-5.418.143-6.187 1.545-.342.649-.641 1.734-.54 3.436.141 2.324 1.497 2.56 2.294 4.033.813 1.502 3.246 2.463 3.64 2.433z\"/><path fill=\"#F7F7F7\" d=\"M72.088 32.136c3.233-.244 4.731-1.878 5.067-3.877.395-2.369.49-4.453-.841-5.96-.837-.965-1.748-1.308-3.386-1.445-3.062-.26-5.455.04-6.225 1.429-.318.587-.642 1.748-.539 3.419.146 2.323 1.504 2.535 2.3 4.009.813 1.504 3.23 2.455 3.624 2.425z\"/><path fill=\"#fff\" d=\"M72.089 32.123c3.221-.238 4.732-1.887 5.053-3.868.386-2.384.485-4.455-.834-5.898-.803-.879-1.718-1.218-3.332-1.354-3.053-.258-5.488-.062-6.262 1.314-.295.524-.645 1.759-.538 3.402.151 2.321 1.511 2.51 2.306 3.985.813 1.507 3.213 2.448 3.607 2.419z\"/><path d=\"M71.778 22.534c1.743 0 2.766 1.558 3.114 3.557.14.907-.07 1.953-.627 2.674-.628.836-1.744 1.348-2.649 1.348-.86 0-1.837.14-2.348-.558-.511-.72-.628-2.325-.628-3.464 0-1.278.373-2.185 1.023-2.906.487-.535 1.37-.651 2.115-.651zm.111.718c.316-.211.843 0 1.45.685.658.738.948 1.317.158 1.739-.606.316-.79-.633-1.16-1.028-.579-.632-1.08-.975-.448-1.396z\"/><path fill=\"#070707\" d=\"M71.901 23.271c.311-.209.832 0 1.428.675.648.727.925 1.298.156 1.712-.593.316-.776-.623-1.139-1.012-.57-.622-1.063-.957-.445-1.375z\"/><path fill=\"#0F0F0F\" d=\"M71.914 23.29c.303-.209.818 0 1.407.665.637.715.901 1.278.152 1.687-.581.314-.761-.614-1.118-.997-.56-.612-1.047-.941-.441-1.355z\"/><path fill=\"#161616\" d=\"M71.927 23.308c.296-.207.806 0 1.385.655.629.705.878 1.258.151 1.661-.568.314-.748-.604-1.097-.981-.554-.601-1.032-.924-.439-1.335z\"/><path fill=\"#1E1E1E\" d=\"M71.94 23.327c.291-.206.793 0 1.363.645.62.693.855 1.239.148 1.635-.555.313-.732-.595-1.076-.966-.544-.591-1.014-.906-.435-1.314z\"/><path fill=\"#262626\" d=\"M71.953 23.346c.283-.204.78 0 1.341.634.61.684.833 1.219.147 1.609-.543.312-.719-.584-1.055-.951-.536-.579-.999-.887-.433-1.292z\"/><path fill=\"#2D2D2D\" d=\"M71.966 23.365c.277-.203.769 0 1.32.624.6.672.808 1.2.144 1.584-.53.31-.704-.576-1.034-.936-.528-.57-.984-.871-.43-1.272z\"/><path fill=\"#353535\" d=\"M71.979 23.384c.271-.202.755 0 1.298.614.589.661.785 1.18.142 1.558-.517.309-.688-.567-1.013-.921-.518-.56-.968-.854-.427-1.251z\"/><path fill=\"#3D3D3D\" d=\"M71.992 23.403c.264-.201.743 0 1.276.603.581.651.763 1.162.14 1.533-.504.309-.674-.557-.992-.905-.511-.55-.952-.837-.424-1.231z\"/><path fill=\"#444\" d=\"M72.004 23.422c.258-.199.731 0 1.256.594.571.639.738 1.141.137 1.506-.492.308-.66-.548-.971-.89-.502-.539-.936-.819-.422-1.21z\"/><path fill=\"#4C4C4C\" d=\"M72.017 23.441c.251-.198.719 0 1.234.583.561.628.716 1.122.135 1.481-.479.306-.646-.539-.95-.875-.494-.529-.92-.802-.419-1.189z\"/><path fill=\"#545454\" d=\"M72.03 23.46c.245-.197.706 0 1.213.573.55.617.691 1.103.132 1.455-.466.305-.631-.529-.929-.86-.485-.518-.904-.785-.416-1.168z\"/><path fill=\"#5B5B5B\" d=\"M72.043 23.479c.238-.196.694 0 1.192.563.541.606.667 1.083.129 1.429-.454.305-.617-.52-.908-.844-.477-.509-.888-.768-.413-1.148z\"/><path fill=\"#636363\" d=\"M72.056 23.498c.231-.195.681 0 1.169.553.532.595.646 1.063.128 1.404-.44.303-.602-.511-.887-.83-.468-.498-.872-.751-.41-1.127z\"/><path fill=\"#6B6B6B\" d=\"M72.069 23.517c.224-.193.668 0 1.148.542.521.585.622 1.044.125 1.378-.428.303-.586-.501-.866-.814-.46-.488-.856-.733-.407-1.106z\"/><path fill=\"#727272\" d=\"M72.082 23.535c.218-.191.656 0 1.127.533.512.574.599 1.024.123 1.352-.416.302-.573-.492-.846-.798-.451-.478-.84-.717-.404-1.087z\"/><path fill=\"#7A7A7A\" d=\"M72.095 23.555c.211-.19.643 0 1.104.522.502.563.576 1.004.121 1.326-.403.301-.559-.482-.825-.783-.441-.468-.823-.7-.4-1.065z\"/><path fill=\"#828282\" d=\"M72.108 23.574c.205-.189.63 0 1.083.512.493.551.552.985.119 1.299-.39.3-.544-.472-.804-.767-.434-.457-.808-.682-.398-1.044z\"/><path fill=\"#898989\" d=\"M72.121 23.592c.198-.188.618 0 1.062.502.482.541.528.965.116 1.274-.378.299-.53-.463-.784-.752-.425-.447-.792-.664-.394-1.024z\"/><path fill=\"#919191\" d=\"M72.133 23.611c.193-.187.606 0 1.041.492.473.53.505.946.114 1.249-.364.298-.515-.454-.761-.737-.418-.437-.777-.648-.394-1.004z\"/><path fill=\"#999\" d=\"M72.147 23.631c.185-.186.592 0 1.018.481.464.519.482.926.112 1.223-.353.297-.501-.444-.742-.722-.407-.426-.759-.631-.388-.982z\"/><path d=\"M63.141 24.293c.546-.211.972-.223 1.817.334 1.022.674.551 1.694-.251 1.485-.693-.179-.78-.22-1.417-.351-1.002-.207-1.175-1.071-.149-1.468z\"/><path fill=\"#050505\" d=\"M63.162 24.335c.536-.204.96-.212 1.793.331.99.648.534 1.618-.26 1.415-.688-.177-.757-.212-1.383-.34-.986-.205-1.157-1.025-.15-1.406z\"/><path fill=\"#0A0A0A\" d=\"M63.184 24.376c.524-.195.947-.201 1.77.328.957.623.517 1.543-.269 1.343-.684-.174-.733-.203-1.349-.329-.971-.2-1.14-.977-.152-1.342z\"/><path fill=\"#0F0F0F\" d=\"M63.205 24.417c.512-.187.934-.189 1.746.324.924.598.5 1.468-.277 1.271-.679-.171-.71-.195-1.315-.317-.956-.194-1.122-.928-.154-1.278z\"/><path fill=\"#141414\" d=\"M63.226 24.457c.501-.178.922-.178 1.721.321.893.572.484 1.393-.284 1.2-.676-.168-.688-.187-1.281-.306-.941-.19-1.106-.879-.156-1.215z\"/><path fill=\"#191919\" d=\"M63.247 24.499c.491-.171.91-.168 1.697.317.86.546.468 1.317-.292 1.129-.671-.166-.666-.179-1.247-.295-.926-.186-1.088-.831-.158-1.151z\"/><path fill=\"#1E1E1E\" d=\"M63.269 24.539c.478-.163.896-.156 1.672.314.828.521.451 1.242-.299 1.058-.667-.163-.643-.171-1.213-.285-.912-.179-1.072-.782-.16-1.087z\"/><path fill=\"#232323\" d=\"M63.29 24.58c.467-.154.884-.145 1.649.312.795.496.434 1.167-.308.986-.664-.16-.62-.163-1.18-.273-.896-.176-1.053-.735-.161-1.025z\"/><path fill=\"#282828\" d=\"M63.311 24.621c.456-.146.872-.135 1.625.308.762.47.417 1.091-.316.916-.659-.157-.596-.155-1.145-.263-.882-.171-1.036-.686-.164-.961z\"/><path fill=\"#2D2D2D\" d=\"M63.332 24.662c.445-.139.86-.124 1.602.304.731.445.401 1.016-.325.843-.654-.154-.572-.146-1.11-.25-.867-.165-1.02-.638-.167-.897z\"/><path fill=\"#333\" d=\"M63.354 24.703c.433-.13.847-.112 1.577.301.698.418.384.94-.333.772-.65-.152-.55-.138-1.077-.24-.852-.16-1.001-.589-.167-.833z\"/><path fill=\"#383838\" d=\"M63.375 24.743c.422-.122.834-.101 1.553.298.667.394.368.865-.34.701-.646-.148-.527-.13-1.043-.229-.838-.156-.984-.54-.17-.77z\"/><path fill=\"#3D3D3D\" d=\"M63.396 24.784c.411-.113.822-.09 1.53.295.633.368.352.791-.349.63-.642-.146-.504-.122-1.008-.218-.824-.152-.967-.492-.173-.707z\"/><path fill=\"#424242\" d=\"M63.418 24.826c.399-.106.81-.08 1.505.291.601.343.334.715-.357.558-.638-.143-.481-.114-.974-.207-.809-.146-.951-.444-.174-.642z\"/><path fill=\"#474747\" d=\"M63.439 24.866c.388-.098.796-.068 1.481.288.569.317.318.64-.365.487-.634-.14-.457-.105-.94-.196-.794-.141-.933-.395-.176-.579z\"/><path fill=\"#4C4C4C\" d=\"M63.46 24.908c.377-.089.785-.057 1.457.284.536.292.302.564-.373.416-.629-.138-.434-.097-.905-.185-.78-.136-.916-.347-.179-.515z\"/><path fill=\"#515151\" d=\"M63.482 24.948c.365-.081.771-.046 1.432.281.504.266.285.489-.381.345-.625-.135-.411-.089-.871-.174-.764-.131-.898-.298-.18-.452z\"/><path fill=\"#565656\" d=\"M63.503 24.989c.354-.073.758-.035 1.408.278.472.241.269.414-.389.273-.621-.132-.388-.081-.837-.162-.749-.127-.881-.251-.182-.389z\"/><path fill=\"#5B5B5B\" d=\"M63.524 25.03c.343-.065.747-.023 1.385.275.438.215.25.338-.398.202-.617-.129-.364-.073-.803-.151-.734-.123-.863-.203-.184-.326z\"/><path fill=\"#606060\" d=\"M63.545 25.071c.332-.057.734-.013 1.361.271.407.189.235.263-.406.13-.612-.126-.341-.064-.769-.14-.719-.117-.846-.153-.186-.261z\"/><path fill=\"#666\" d=\"M63.567 25.111c.32-.049.72-.001 1.336.268.375.164.219.188-.414.059-.607-.124-.318-.056-.734-.129-.705-.111-.829-.104-.188-.198zM61.363 43.13c-3.022.117-7.811-8.345-7.927-4.834-.093 2.975.07 2.929.07 5.811 0 1.93-.883 2.069-2.79 4.975-.977 1.535-1.743 3.185-2.348 4.858-.372 1-.72 2.046-1 3.069l-.441 1.557c-.953 3.51-4.347 7.835-5.137 11.345-.792 3.487-1.72 5.718-1.604 10.391.117 4.673.163 3.324 1.581 4.487 1.395 1.163 2.836 2.255 5.044 4.208 2.325 2.022 7.16 5.556 7.811 6.648.697 1.116.674 3.627.255 4.44-.418.79-4.068 1.232-4.045 1.232-.023 0 3.185 4.416 3.813 5.043.604.604 3.208 3.511 13.808 1.535 5.975-1.116 10.6-4.463 13.948-7.695 4.323-4.208 2.138-5.416 2.696-7.532.814-3.045 3.464-4.184 4.068-7.625.07-.488.232-.86.674-1.58.674-1.023.512-3.046.512-4.905 0-4.835-.559-9.763-1.674-13.389-1.023-3.395-2.649-5.765-4.045-8.834-2.789-6.114-2.649-8.857-5.137-12.762-2.836-4.51-1.441-7.508-5.207-7.323-4.696.255-8.485 6.694-12.925 6.88z\"/><path fill=\"#6D6D6D\" d=\"M61.357 43.481c-2.996.114-7.666-8.237-7.827-4.901-.102 2.827.032 2.802.01 5.568-.049 1.895-.954 2.143-2.818 4.998-.972 1.538-1.703 3.168-2.257 4.804-.313 1.05-.504 2.073-.785 3.075-.135.53-.484 1.029-.706 1.628-1.051 3.481-4.374 7.807-5.153 11.261-.796 3.49-1.734 5.713-1.602 10.377.118 4.52.127 3.286 1.541 4.46 1.383 1.168 2.854 2.282 5.056 4.23 2.319 2.017 7.18 5.559 7.827 6.647.694 1.112.688 3.654.273 4.463-.416.787-4.062 1.251-4.039 1.251-.023 0 3.168 4.38 3.796 5.007.604.604 3.196 3.49 13.779 1.519 5.98-1.115 10.694-4.44 13.908-7.702 4.128-4.12 1.972-5.415 2.527-7.519.811-3.041 3.64-4.186 4.243-7.621.07-.487.243-.857.683-1.575.676-1.034.504-3.05.511-4.903.021-4.852-.551-9.762-1.667-13.377-1.023-3.384-2.648-5.752-4.04-8.816-2.785-6.104-2.654-8.852-5.146-12.745-2.771-4.395-1.485-7.291-5.169-7.1-4.637.269-8.512 6.787-12.945 6.971z\"/><path fill=\"#757575\" d=\"M61.351 43.831c-2.971.111-7.522-8.128-7.726-4.967-.112 2.678-.006 2.675-.051 5.325-.097 1.861-1.023 2.217-2.845 5.022-.969 1.542-1.662 3.151-2.167 4.748-.253 1.101-.288 2.101-.57 3.083-.152.549-.641 1.012-.969 1.698-1.147 3.451-4.398 7.781-5.169 11.178-.801 3.493-1.747 5.708-1.599 10.362.12 4.368.092 3.248 1.501 4.437 1.37 1.172 2.871 2.31 5.069 4.252 2.313 2.012 7.199 5.561 7.844 6.646.691 1.108.701 3.681.288 4.486-.41.784-4.054 1.27-4.03 1.27-.023 0 3.153 4.343 3.779 4.97.603.603 3.186 3.469 13.75 1.502 5.988-1.115 10.789-4.417 13.869-7.709 3.935-4.034 1.805-5.415 2.357-7.509.809-3.034 3.818-4.185 4.419-7.615.069-.484.254-.854.69-1.567.679-1.044.497-3.055.51-4.9.043-4.868-.543-9.76-1.658-13.365-1.025-3.375-2.647-5.74-4.037-8.798-2.779-6.095-2.657-8.846-5.15-12.728-2.708-4.28-1.53-7.074-5.131-6.877-4.588.277-8.548 6.875-12.974 7.056z\"/><path fill=\"#7C7C7C\" d=\"M61.346 44.182c-2.946.108-7.378-8.02-7.627-5.033-.119 2.529-.042 2.548-.11 5.083-.146 1.827-1.094 2.291-2.873 5.045a18.713 18.713 0 0 0-2.078 4.693c-.193 1.15-.07 2.128-.354 3.089-.17.567-.799.995-1.233 1.769-1.245 3.421-4.424 7.754-5.185 11.094-.807 3.496-1.76 5.702-1.598 10.349.123 4.216.057 3.209 1.462 4.41 1.359 1.178 2.89 2.338 5.083 4.276 2.307 2.007 7.218 5.563 7.86 6.645.688 1.104.715 3.71.305 4.51-.406.78-4.047 1.288-4.024 1.288-.023 0 3.137 4.307 3.762 4.931.603.603 3.174 3.449 13.721 1.488 5.994-1.115 10.882-4.394 13.83-7.717 3.74-3.946 1.638-5.415 2.188-7.498.806-3.029 3.996-4.184 4.594-7.61.069-.483.265-.85.698-1.561.681-1.057.489-3.061.509-4.899.065-4.883-.535-9.757-1.649-13.352-1.025-3.366-2.646-5.728-4.032-8.78-2.774-6.085-2.663-8.841-5.156-12.71-2.646-4.166-1.575-6.857-5.095-6.655-4.534.289-8.58 6.966-12.998 7.145z\"/><path fill=\"#848484\" d=\"M61.34 44.532c-2.919.107-7.234-7.911-7.526-5.099-.128 2.381-.08 2.421-.17 4.84-.194 1.792-1.163 2.365-2.9 5.069a17.056 17.056 0 0 0-1.987 4.638c-.134 1.202.147 2.156-.14 3.097-.188.586-.957.977-1.498 1.839-1.341 3.391-4.45 7.728-5.199 11.011-.813 3.5-1.774 5.696-1.596 10.334.125 4.064.022 3.17 1.423 4.385 1.347 1.184 2.907 2.365 5.095 4.298 2.302 2.002 7.238 5.566 7.876 6.643.685 1.101.729 3.738.322 4.534-.403.777-4.042 1.307-4.019 1.307-.023 0 3.122 4.271 3.746 4.895.601.601 3.164 3.427 13.692 1.472 6-1.114 10.977-4.372 13.791-7.725 3.544-3.859 1.471-5.414 2.017-7.486.805-3.025 4.173-4.185 4.77-7.606.07-.481.276-.847.707-1.554.683-1.067.481-3.065.509-4.897.086-4.898-.529-9.755-1.643-13.339-1.027-3.357-2.645-5.715-4.028-8.763-2.769-6.076-2.667-8.835-5.163-12.692-2.581-4.051-1.619-6.64-5.057-6.432-4.479.298-8.61 7.055-13.022 7.231z\"/><path fill=\"#8C8C8C\" d=\"M61.335 44.882c-2.894.104-7.091-7.802-7.427-5.164-.138 2.232-.118 2.293-.23 4.596-.242 1.758-1.233 2.439-2.929 5.094a15.58 15.58 0 0 0-1.896 4.583c-.076 1.252.363 2.184.075 3.104-.206.604-1.114.959-1.761 1.909-1.438 3.362-4.476 7.702-5.215 10.928-.818 3.502-1.787 5.69-1.593 10.319.127 3.912-.014 3.132 1.383 4.36 1.334 1.188 2.924 2.392 5.105 4.32 2.298 1.998 7.259 5.569 7.894 6.643.681 1.097.742 3.765.338 4.557-.398.773-4.035 1.325-4.012 1.325-.023 0 3.106 4.234 3.73 4.857.601.6 3.153 3.407 13.664 1.456 6.007-1.113 11.07-4.348 13.75-7.732 3.35-3.772 1.305-5.413 1.847-7.475.802-3.019 4.35-4.184 4.945-7.601.069-.479.288-.843.714-1.547.687-1.078.474-3.069.508-4.894.107-4.915-.52-9.753-1.635-13.327-1.027-3.349-2.643-5.703-4.022-8.745-2.765-6.066-2.671-8.831-5.17-12.675-2.517-3.937-1.663-6.423-5.019-6.21-4.425.31-8.64 7.146-13.044 7.319z\"/><path fill=\"#939393\" d=\"M61.329 45.232c-2.869.102-6.947-7.694-7.326-5.23-.147 2.083-.155 2.166-.291 4.353-.292 1.724-1.304 2.513-2.957 5.117a14.206 14.206 0 0 0-1.806 4.527c-.016 1.303.581 2.212.291 3.111-.224.623-1.272.942-2.025 1.979-1.536 3.332-4.501 7.675-5.231 10.844-.825 3.505-1.801 5.685-1.591 10.306.128 3.759-.049 3.094 1.343 4.334 1.322 1.193 2.942 2.419 5.119 4.343 2.292 1.992 7.277 5.571 7.91 6.641.678 1.094.756 3.793.355 4.581-.396.771-4.029 1.344-4.005 1.344-.023 0 3.09 4.197 3.712 4.82.6.599 3.141 3.386 13.635 1.44 6.013-1.113 11.164-4.325 13.711-7.74 3.155-3.685 1.137-5.413 1.676-7.463.8-3.013 4.528-4.184 5.121-7.596.069-.478.298-.84.722-1.542.689-1.089.467-3.074.507-4.892.128-4.931-.512-9.751-1.626-13.314-1.028-3.339-2.643-5.69-4.019-8.727-2.759-6.057-2.675-8.825-5.176-12.658-2.454-3.821-1.708-6.206-4.981-5.987-4.371.323-8.671 7.239-13.068 7.409z\"/><path fill=\"#9B9B9B\" d=\"M61.323 45.583c-2.842.1-6.802-7.585-7.226-5.295-.156 1.935-.192 2.039-.351 4.11-.34 1.689-1.373 2.587-2.984 5.14a12.977 12.977 0 0 0-1.716 4.473c.044 1.354.798 2.239.506 3.118-.242.641-1.43.925-2.289 2.049-1.633 3.303-4.527 7.648-5.247 10.761-.83 3.509-1.814 5.679-1.589 10.292.131 3.607-.083 3.056 1.305 4.309 1.31 1.199 2.959 2.447 5.131 4.365 2.287 1.988 7.297 5.575 7.926 6.642.676 1.088.771 3.82.372 4.602-.391.768-4.021 1.363-3.999 1.363-.023 0 3.076 4.161 3.697 4.783.599.598 3.129 3.365 13.605 1.424 6.019-1.113 11.258-4.302 13.671-7.748 2.962-3.598.971-5.412 1.508-7.452.798-3.008 4.705-4.185 5.295-7.592.07-.475.31-.835.731-1.533.692-1.101.459-3.08.507-4.89.149-4.948-.506-9.749-1.619-13.302-1.029-3.33-2.641-5.678-4.015-8.709-2.754-6.047-2.68-8.819-5.184-12.64-2.389-3.707-1.751-5.988-4.943-5.765-4.316.331-8.702 7.327-13.092 7.495z\"/><path fill=\"#A3A3A3\" d=\"M61.318 45.933c-2.818.098-6.658-7.476-7.126-5.361-.165 1.786-.229 1.911-.41 3.867-.388 1.654-1.443 2.661-3.012 5.164-.948 1.563-1.418 3.051-1.625 4.417.102 1.405 1.014 2.267.719 3.125-.259.66-1.588.908-2.553 2.119-1.729 3.273-4.552 7.622-5.262 10.678-.836 3.512-1.828 5.674-1.586 10.278.134 3.454-.119 3.016 1.265 4.283 1.298 1.205 2.977 2.475 5.144 4.389 2.28 1.982 7.316 5.576 7.941 6.639.673 1.086.785 3.849.389 4.627-.387.763-4.015 1.381-3.992 1.381-.022 0 3.06 4.124 3.68 4.745.598.598 3.119 3.345 13.576 1.409 6.026-1.113 11.352-4.279 13.632-7.755 2.767-3.511.804-5.412 1.338-7.441.795-3.003 4.882-4.184 5.47-7.586.07-.474.32-.833.739-1.527.694-1.111.451-3.084.506-4.888.172-4.963-.498-9.747-1.61-13.289-1.029-3.32-2.639-5.666-4.01-8.691-2.75-6.038-2.684-8.814-5.189-12.623-2.326-3.592-1.796-5.771-4.906-5.542-4.264.342-8.736 7.416-13.118 7.582z\"/><path fill=\"#aaa\" d=\"M61.312 46.283c-2.791.095-6.514-7.367-7.025-5.427l-.471 3.624c-.437 1.621-1.513 2.735-3.04 5.188-.944 1.566-1.376 3.034-1.536 4.361.162 1.456 1.231 2.295.936 3.133-.277.677-1.746.89-2.817 2.189-1.827 3.244-4.579 7.595-5.278 10.594-.841 3.515-1.841 5.668-1.585 10.263.136 3.303-.153 2.979 1.226 4.258 1.286 1.209 2.995 2.502 5.156 4.41 2.275 1.978 7.336 5.579 7.958 6.638.668 1.083.798 3.877.405 4.65-.383.76-4.008 1.4-3.985 1.4-.023 0 3.044 4.087 3.664 4.708.598.596 3.107 3.324 13.547 1.393 6.033-1.112 11.446-4.256 13.594-7.763 2.571-3.423.637-5.411 1.167-7.43.792-2.998 5.059-4.183 5.645-7.581.07-.472.332-.83.748-1.521.697-1.123.444-3.09.505-4.885.194-4.98-.49-9.746-1.603-13.276-1.03-3.312-2.638-5.654-4.005-8.674-2.745-6.028-2.689-8.809-5.197-12.605-2.262-3.478-1.84-5.555-4.868-5.32-4.209.356-8.765 7.511-13.141 7.673z\"/><path fill=\"#B2B2B2\" d=\"M61.306 46.633c-2.766.092-6.37-7.259-6.925-5.493l-.531 3.381c-.486 1.586-1.584 2.809-3.068 5.211-.941 1.57-1.336 3.017-1.446 4.306.222 1.506 1.449 2.323 1.15 3.139-.295.697-1.904.874-3.081 2.26-1.924 3.213-4.604 7.569-5.294 10.51-.847 3.52-1.855 5.664-1.582 10.25.137 3.15-.189 2.94 1.186 4.233 1.274 1.215 3.013 2.529 5.168 4.433 2.271 1.972 7.356 5.581 7.976 6.637.665 1.077.812 3.904.421 4.672-.378.757-4.001 1.419-3.978 1.419-.023 0 3.029 4.052 3.647 4.67.596.597 3.097 3.304 13.518 1.378 6.04-1.112 11.54-4.233 13.554-7.77 2.376-3.336.47-5.411.997-7.418.791-2.992 5.237-4.184 5.822-7.578.069-.47.342-.825.755-1.514.699-1.132.436-3.094.504-4.883.216-4.996-.482-9.743-1.594-13.263-1.032-3.302-2.636-5.641-4.001-8.657-2.739-6.019-2.692-8.803-5.202-12.587-2.199-3.363-1.885-5.337-4.831-5.097-4.154.368-8.796 7.601-13.165 7.761z\"/><path fill=\"#BABABA\" d=\"M61.302 46.983c-2.741.09-6.226-7.15-6.826-5.558l-.59 3.137c-.535 1.553-1.653 2.884-3.096 5.236-.936 1.573-1.294 3-1.354 4.25.279 1.558 1.665 2.351 1.365 3.147-.313.715-2.061.856-3.345 2.33-2.021 3.184-4.629 7.542-5.309 10.427-.854 3.521-1.868 5.657-1.58 10.234.14 2.998-.224 2.901 1.147 4.208 1.262 1.219 3.03 2.557 5.18 4.455 2.265 1.967 7.375 5.584 7.991 6.636.663 1.074.826 3.932.439 4.696-.375.753-3.995 1.438-3.972 1.438-.023 0 3.012 4.015 3.63 4.633.596.596 3.085 3.283 13.488 1.362 6.046-1.112 11.635-4.21 13.515-7.778 2.182-3.25.304-5.41.829-7.406.788-2.986 5.414-4.184 5.996-7.572.069-.469.353-.823.763-1.508.702-1.144.429-3.099.504-4.881.237-5.011-.475-9.741-1.585-13.25-1.033-3.293-2.636-5.628-3.997-8.639-2.735-6.009-2.697-8.797-5.21-12.57-2.134-3.248-1.929-5.12-4.793-4.875-4.103.378-8.831 7.691-13.19 7.848z\"/><path fill=\"#C1C1C1\" d=\"M61.295 47.334c-2.714.088-6.081-7.042-6.725-5.624-.199 1.19-.379 1.403-.65 2.895-.584 1.518-1.724 2.958-3.124 5.26-.933 1.577-1.254 2.983-1.265 4.195.339 1.607 1.882 2.378 1.581 3.154-.332.733-2.22.839-3.609 2.4-2.118 3.154-4.656 7.516-5.324 10.344-.859 3.524-1.882 5.651-1.578 10.221.141 2.845-.26 2.862 1.106 4.182 1.25 1.225 3.048 2.584 5.193 4.479 2.258 1.962 7.395 5.586 8.007 6.634.659 1.07.84 3.96.455 4.719-.371.75-3.988 1.457-3.965 1.457-.023 0 2.997 3.979 3.615 4.596.594.595 3.074 3.263 13.459 1.346 6.052-1.111 11.729-4.187 13.475-7.786 1.987-3.161.137-5.409.658-7.395.787-2.982 5.591-4.183 6.172-7.567.069-.466.364-.818.772-1.5.704-1.155.421-3.104.503-4.878.257-5.028-.468-9.74-1.579-13.239-1.033-3.284-2.634-5.616-3.992-8.621-2.73-6-2.702-8.793-5.216-12.553-2.071-3.133-1.974-4.903-4.756-4.652-4.047.386-8.859 7.777-13.213 7.933z\"/><path fill=\"#C9C9C9\" d=\"M61.29 47.684c-2.689.085-5.938-6.933-6.626-5.689-.209 1.041-.417 1.275-.71 2.651-.632 1.483-1.794 3.032-3.152 5.284-.929 1.58-1.212 2.966-1.174 4.14.399 1.658 2.1 2.406 1.796 3.162-.349.751-2.377.821-3.873 2.47-2.214 3.124-4.682 7.489-5.34 10.261-.864 3.528-1.896 5.646-1.576 10.206.144 2.693-.295 2.825 1.068 4.158 1.239 1.229 3.065 2.611 5.205 4.5 2.253 1.957 7.415 5.589 8.024 6.633.656 1.067.854 3.989.472 4.743-.367.747-3.981 1.475-3.959 1.475-.022 0 2.981 3.942 3.598 4.558.595.594 3.063 3.243 13.431 1.331 6.06-1.111 11.822-4.164 13.435-7.793 1.793-3.074-.03-5.408.489-7.384.785-2.976 5.768-4.183 6.347-7.562.069-.465.375-.816.779-1.495.707-1.166.414-3.108.503-4.876.279-5.043-.46-9.737-1.571-13.225-1.034-3.275-2.631-5.604-3.988-8.604-2.725-5.99-2.705-8.787-5.222-12.535-2.007-3.019-2.019-4.686-4.718-4.43-3.994.397-8.891 7.868-13.238 8.021z\"/><path fill=\"#D1D1D1\" d=\"M61.285 48.035c-2.664.083-5.793-6.825-6.525-5.755-.218.893-.453 1.148-.771 2.408-.681 1.449-1.863 3.106-3.178 5.307-.927 1.584-1.173 2.95-1.085 4.085.458 1.708 2.316 2.434 2.011 3.167-.367.771-2.535.805-4.136 2.541-2.312 3.095-4.708 7.462-5.356 10.177-.87 3.532-1.909 5.641-1.574 10.192.146 2.541-.332 2.786 1.029 4.131 1.226 1.234 3.083 2.64 5.216 4.522 2.249 1.953 7.435 5.593 8.041 6.632.653 1.063.867 4.017.489 4.767-.364.744-3.975 1.493-3.952 1.493-.023 0 2.966 3.905 3.582 4.521.591.593 3.05 3.222 13.401 1.315 6.065-1.11 11.917-4.14 13.396-7.801 1.598-2.987-.197-5.408.317-7.372.783-2.972 5.946-4.183 6.523-7.558.069-.463.386-.812.788-1.487.708-1.177.406-3.114.502-4.875.3-5.059-.452-9.734-1.563-13.211-1.035-3.267-2.63-5.592-3.982-8.586-2.722-5.98-2.711-8.782-5.23-12.518-1.943-2.904-2.062-4.469-4.679-4.207-3.943.411-8.926 7.961-13.264 8.112z\"/><path fill=\"#D8D8D8\" d=\"M61.279 48.385c-2.638.081-5.649-6.715-6.425-5.821-.227.743-.491 1.021-.831 2.165-.729 1.415-1.933 3.18-3.207 5.331-.922 1.588-1.131 2.933-.994 4.029.518 1.76 2.534 2.462 2.227 3.175-.385.789-2.693.788-4.401 2.611-2.409 3.065-4.733 7.436-5.372 10.093-.875 3.534-1.922 5.636-1.571 10.178.148 2.389-.366 2.748.989 4.106 1.213 1.241 3.1 2.667 5.229 4.546 2.243 1.947 7.455 5.594 8.057 6.631.65 1.059.881 4.043.505 4.789-.359.741-3.968 1.513-3.945 1.513-.023 0 2.95 3.868 3.564 4.483.592.593 3.041 3.201 13.372 1.299 6.072-1.109 12.011-4.117 13.357-7.808 1.403-2.9-.364-5.407.147-7.361.78-2.966 6.124-4.183 6.698-7.553.069-.462.397-.808.796-1.48.711-1.189.399-3.119.501-4.873.322-5.075-.445-9.733-1.555-13.2-1.036-3.257-2.63-5.58-3.979-8.568-2.715-5.972-2.714-8.777-5.235-12.5-1.879-2.79-2.108-4.251-4.644-3.985-3.883.422-8.951 8.052-13.283 8.2z\"/><path fill=\"#E0E0E0\" d=\"M61.273 48.735c-2.612.078-5.505-6.606-6.325-5.886-.235.595-.529.893-.89 1.922-.778 1.381-2.004 3.253-3.235 5.354-.919 1.591-1.091 2.916-.904 3.974.577 1.811 2.75 2.49 2.441 3.183-.403.808-2.85.77-4.664 2.681-2.506 3.036-4.758 7.41-5.387 10.011-.882 3.537-1.936 5.63-1.569 10.164.15 2.237-.402 2.708.949 4.081 1.201 1.245 3.117 2.694 5.241 4.567 2.239 1.941 7.474 5.598 8.074 6.629.646 1.055.895 4.071.521 4.813-.354.737-3.96 1.531-3.938 1.531-.022 0 2.935 3.832 3.547 4.446.592.591 3.03 3.18 13.344 1.284 6.079-1.109 12.105-4.095 13.316-7.815 1.208-2.814-.531-5.407-.021-7.35.777-2.96 6.3-4.183 6.874-7.549.068-.459.408-.805.804-1.473.713-1.2.391-3.124.5-4.871.343-5.091-.437-9.73-1.548-13.187-1.036-3.247-2.627-5.566-3.974-8.55-2.71-5.962-2.719-8.771-5.242-12.483-1.815-2.674-2.152-4.034-4.604-3.762-3.831.432-8.986 8.14-13.31 8.286z\"/><path fill=\"#E8E8E8\" d=\"M61.267 49.086c-2.586.075-5.361-6.499-6.224-5.953-.245.446-.567.766-.951 1.679-.826 1.346-2.073 3.328-3.262 5.378-.915 1.595-1.05 2.899-.813 3.919.636 1.861 2.967 2.517 2.655 3.19-.42.826-3.009.752-4.929 2.751-2.603 3.006-4.784 7.383-5.402 9.927-.888 3.542-1.95 5.624-1.567 10.15.152 2.084-.437 2.67.91 4.055 1.19 1.25 3.136 2.722 5.254 4.592 2.232 1.937 7.492 5.599 8.09 6.627.643 1.052.909 4.1.538 4.837-.35.733-3.954 1.549-3.931 1.549-.023 0 2.918 3.796 3.531 4.409.59.59 3.019 3.159 13.315 1.267 6.084-1.109 12.199-4.07 13.277-7.822 1.014-2.727-.697-5.406-.191-7.338.775-2.955 6.478-4.182 7.048-7.543.069-.457.419-.802.812-1.467.716-1.21.384-3.128.5-4.868.365-5.108-.43-9.729-1.539-13.175-1.038-3.238-2.626-5.554-3.97-8.532-2.706-5.953-2.723-8.766-5.249-12.465-1.751-2.561-2.196-3.817-4.567-3.539-3.778.44-9.017 8.228-13.335 8.372z\"/><path fill=\"#EFEFEF\" d=\"M61.262 49.436c-2.562.073-5.217-6.39-6.125-6.019-.253.297-.604.639-1.011 1.436-.874 1.312-2.144 3.401-3.29 5.402-.911 1.598-1.009 2.882-.723 3.863.694 1.911 3.184 2.545 2.87 3.197-.438.844-3.167.735-5.192 2.821-2.7 2.977-4.809 7.356-5.417 9.844-.894 3.544-1.963 5.618-1.565 10.136.155 1.932-.472 2.633.87 4.03 1.178 1.255 3.153 2.749 5.266 4.613 2.228 1.932 7.513 5.603 8.107 6.627.64 1.047.922 4.127.555 4.86-.347.729-3.948 1.567-3.925 1.567-.023 0 2.903 3.758 3.515 4.371.59.59 3.008 3.139 13.285 1.252 6.092-1.108 12.293-4.047 13.239-7.831.819-2.639-.864-5.405-.361-7.326.773-2.95 6.655-4.183 7.224-7.539.069-.456.43-.798.82-1.461.719-1.221.376-3.133.499-4.865.386-5.124-.422-9.727-1.531-13.163-1.038-3.229-2.625-5.541-3.964-8.514-2.702-5.943-2.729-8.761-5.256-12.449-1.688-2.445-2.24-3.599-4.529-3.316-3.728.456-9.05 8.323-13.361 8.464z\"/><path fill=\"#F7F7F7\" d=\"M61.257 49.786c-2.536.07-5.074-6.281-6.025-6.083-.262.148-.641.511-1.069 1.192-.924 1.278-2.215 3.476-3.319 5.426-.908 1.602-.968 2.865-.633 3.809.754 1.961 3.401 2.573 3.087 3.204-.457.863-3.325.718-5.457 2.891-2.797 2.947-4.836 7.33-5.434 9.761-.899 3.546-1.976 5.613-1.562 10.122.156 1.781-.507 2.593.831 4.004 1.165 1.262 3.17 2.777 5.279 4.635 2.222 1.927 7.532 5.605 8.124 6.626.635 1.044.935 4.155.571 4.883-.343.728-3.941 1.587-3.918 1.587-.023 0 2.887 3.722 3.498 4.333.59.588 2.997 3.118 13.257 1.237 6.099-1.109 12.387-4.025 13.199-7.839.625-2.551-1.032-5.404-.531-7.314.771-2.944 6.832-4.183 7.398-7.534.069-.453.441-.794.83-1.454.72-1.232.369-3.137.498-4.863.408-5.14-.415-9.725-1.523-13.149-1.039-3.22-2.624-5.53-3.961-8.497-2.695-5.934-2.732-8.756-5.262-12.431-1.624-2.331-2.284-3.383-4.492-3.095-3.675.464-9.084 8.411-13.386 8.549z\"/><path fill=\"#fff\" d=\"M61.25 50.137c-2.51.068-4.93-6.173-5.924-6.15-.271 0-.678.385-1.131.95-.972 1.244-2.282 3.55-3.345 5.45-.905 1.605-.927 2.849-.543 3.753.813 2.012 3.618 2.601 3.301 3.211-.475.882-3.482.701-5.721 2.962-2.894 2.917-4.861 7.303-5.449 9.677-.905 3.55-1.99 5.607-1.561 10.107.159 1.628-.543 2.555.792 3.98 1.153 1.266 3.188 2.804 5.291 4.657 2.216 1.922 7.552 5.608 8.14 6.626.633 1.04.949 4.182.587 4.906-.339.723-3.934 1.605-3.912 1.605-.022 0 2.872 3.685 3.482 4.296.587.588 2.984 3.098 13.229 1.221 6.104-1.108 12.48-4.002 13.158-7.846.43-2.464-1.198-5.403-.7-7.303.768-2.939 7.009-4.183 7.574-7.53.068-.451.452-.791.837-1.446.723-1.244.361-3.143.497-4.862a33.816 33.816 0 0 0-1.515-13.137c-1.04-3.211-2.623-5.517-3.957-8.479-2.691-5.924-2.736-8.75-5.269-12.413-1.56-2.216-2.328-3.166-4.454-2.872-3.616.474-9.11 8.501-13.407 8.637z\"/><path fill=\"#995900\" d=\"M62.967 27.183c1.697-.209 4.021.209 5.091 1 .999.745 1.696 1.14 2.603 1.441 3.045 1 7.044 1.465 6.858 4.208-.209 3.277-1.162 4.742-3.882 5.602-2.185.674-6.09 4.463-9.112 4.463-1.348 0-3.231.07-4.324-.325-1.046-.372-2.511-2.139-4.231-3.557-1.721-1.395-3.324-2.882-3.37-4.835-.07-2.068 1.278-2.743 3.185-4.394 1-.883 2.813-2.348 4.068-2.999 1.161-.581 1.906-.465 3.114-.604z\"/><path fill=\"#9E5F00\" d=\"M63.003 27.214c1.687-.208 3.998.208 5.062.994.993.74 1.688 1.134 2.589 1.433 3.026.994 7.015 1.462 6.832 4.188-.208 3.258-1.186 4.708-3.888 5.561-2.171.669-6.06 4.387-9.063 4.404-1.359.01-3.204.076-4.29-.315-1.038-.369-2.498-2.134-4.207-3.542-1.708-1.385-3.312-2.833-3.331-4.767-.049-2.018 1.263-2.715 3.155-4.354.992-.875 2.775-2.358 4.024-3.014 1.149-.582 1.914-.449 3.117-.588z\"/><path fill=\"#A36400\" d=\"M63.038 27.244c1.677-.207 3.975.207 5.032.988.988.736 1.677 1.128 2.574 1.425 3.008.988 6.986 1.46 6.805 4.169-.204 3.237-1.206 4.673-3.893 5.519-2.157.664-6.029 4.311-9.014 4.344-1.369.021-3.178.082-4.255-.305-1.03-.366-2.486-2.129-4.184-3.526-1.697-1.376-3.3-2.784-3.292-4.699-.03-1.969 1.248-2.689 3.126-4.316.984-.867 2.737-2.368 3.98-3.028 1.139-.584 1.926-.433 3.121-.571z\"/><path fill=\"#A86A00\" d=\"M63.073 27.274c1.668-.206 3.953.206 5.004.982.982.731 1.667 1.123 2.559 1.417 2.99.982 6.959 1.458 6.779 4.15-.203 3.219-1.229 4.639-3.898 5.479-2.142.659-5.998 4.235-8.964 4.284-1.381.031-3.151.087-4.222-.295-1.022-.362-2.473-2.124-4.161-3.511-1.684-1.368-3.289-2.734-3.251-4.631-.01-1.919 1.232-2.662 3.097-4.278.976-.859 2.699-2.378 3.936-3.042 1.125-.585 1.933-.418 3.121-.555z\"/><path fill=\"#AD7000\" d=\"M63.109 27.304c1.657-.204 3.929.205 4.974.977.976.727 1.659 1.117 2.543 1.408 2.971.977 6.931 1.456 6.753 4.131-.199 3.198-1.25 4.604-3.904 5.437-2.126.654-5.966 4.159-8.915 4.225-1.392.041-3.125.093-4.188-.285-1.014-.359-2.461-2.118-4.138-3.495-1.672-1.358-3.276-2.685-3.21-4.564.01-1.869 1.216-2.634 3.065-4.239.969-.851 2.663-2.389 3.893-3.058 1.116-.584 1.945-.401 3.127-.537z\"/><path fill=\"#B27600\" d=\"M63.143 27.335c1.649-.204 3.907.203 4.945.971.971.722 1.647 1.111 2.529 1.399 2.953.97 6.903 1.453 6.727 4.112-.198 3.178-1.272 4.57-3.909 5.395-2.113.649-5.936 4.083-8.867 4.165-1.401.052-3.097.099-4.152-.275-1.006-.356-2.449-2.113-4.115-3.48-1.66-1.349-3.264-2.635-3.17-4.496.03-1.819 1.201-2.607 3.037-4.201.96-.842 2.624-2.398 3.848-3.071 1.103-.584 1.954-.384 3.127-.519z\"/><path fill=\"#B77B00\" d=\"M63.18 27.364c1.639-.203 3.882.202 4.915.965.965.718 1.639 1.105 2.514 1.391 2.934.965 6.875 1.451 6.702 4.093-.196 3.158-1.296 4.535-3.916 5.354-2.097.645-5.905 4.007-8.816 4.105-1.413.062-3.07.104-4.119-.265-.998-.353-2.437-2.108-4.092-3.465-1.648-1.34-3.252-2.585-3.13-4.427.05-1.769 1.185-2.58 3.007-4.161.953-.835 2.586-2.409 3.804-3.087 1.09-.585 1.963-.368 3.131-.503z\"/><path fill=\"#BC8100\" d=\"M63.214 27.395c1.629-.201 3.86.201 4.886.96.96.713 1.629 1.1 2.499 1.383 2.915.959 6.847 1.449 6.675 4.074-.194 3.138-1.316 4.5-3.92 5.312-2.083.64-5.874 3.931-8.768 4.046-1.423.072-3.044.11-4.085-.255-.99-.35-2.424-2.103-4.067-3.449-1.637-1.332-3.241-2.536-3.091-4.36.071-1.719 1.169-2.553 2.978-4.123.945-.826 2.549-2.419 3.76-3.101 1.079-.588 1.974-.354 3.133-.487z\"/><path fill=\"#C18700\" d=\"M63.249 27.425c1.62-.2 3.837.2 4.857.954.954.709 1.62 1.095 2.484 1.375 2.897.954 6.819 1.446 6.649 4.055-.191 3.119-1.339 4.467-3.926 5.271-2.067.635-5.843 3.855-8.718 3.987-1.433.082-3.017.116-4.051-.245-.982-.347-2.411-2.098-4.043-3.435-1.625-1.322-3.229-2.486-3.052-4.292.09-1.668 1.155-2.526 2.948-4.083.937-.818 2.511-2.429 3.716-3.116 1.068-.589 1.984-.338 3.136-.471z\"/><path fill=\"#C68D00\" d=\"M63.285 27.455c1.609-.198 3.813.198 4.828.948.947.706 1.609 1.09 2.468 1.367 2.879.947 6.79 1.444 6.625 4.036-.19 3.098-1.362 4.432-3.932 5.229-2.054.63-5.812 3.778-8.669 3.926-1.445.093-2.99.122-4.017-.234-.973-.344-2.399-2.093-4.021-3.419-1.613-1.314-3.217-2.438-3.011-4.224.11-1.619 1.138-2.5 2.918-4.046.929-.81 2.473-2.439 3.672-3.13 1.055-.589 1.993-.321 3.139-.453z\"/><path fill=\"#CC9200\" d=\"M63.32 27.485c1.6-.197 3.79.197 4.798.942.943.701 1.6 1.083 2.455 1.358 2.859.942 6.761 1.442 6.596 4.018-.187 3.079-1.383 4.397-3.936 5.187-2.039.625-5.782 3.703-8.62 3.868-1.455.103-2.963.127-3.982-.225-.966-.34-2.387-2.088-3.999-3.404-1.601-1.304-3.206-2.387-2.971-4.156.129-1.569 1.123-2.471 2.888-4.006.922-.802 2.435-2.45 3.629-3.146 1.044-.589 2.003-.305 3.142-.436z\"/><path fill=\"#D19800\" d=\"M63.356 27.515c1.589-.196 3.767.196 4.769.937.936.696 1.589 1.078 2.439 1.35 2.841.936 6.733 1.439 6.57 3.998-.184 3.06-1.405 4.363-3.942 5.146-2.024.62-5.75 3.626-8.57 3.807-1.466.114-2.936.134-3.948-.214-.957-.337-2.374-2.083-3.975-3.389-1.589-1.295-3.193-2.338-2.932-4.088.151-1.52 1.108-2.444 2.859-3.968.914-.793 2.398-2.459 3.584-3.16 1.034-.59 2.013-.288 3.146-.419z\"/><path fill=\"#D69E00\" d=\"M63.391 27.545c1.581-.194 3.744.195 4.74.931.93.692 1.58 1.073 2.423 1.342 2.823.931 6.706 1.438 6.545 3.979-.183 3.04-1.427 4.329-3.948 5.105-2.01.615-5.719 3.55-8.52 3.748-1.478.124-2.91.14-3.915-.205-.949-.333-2.362-2.077-3.951-3.372-1.577-1.287-3.182-2.289-2.891-4.021.169-1.469 1.092-2.418 2.829-3.929.906-.785 2.36-2.47 3.541-3.174 1.02-.592 2.022-.274 3.147-.404z\"/><path fill=\"#DBA300\" d=\"M63.427 27.575c1.57-.193 3.72.194 4.71.925.925.688 1.57 1.067 2.409 1.333 2.804.925 6.678 1.436 6.519 3.96-.181 3.02-1.45 4.294-3.953 5.063-1.995.61-5.689 3.474-8.471 3.688-1.488.134-2.883.145-3.88-.194-.941-.331-2.349-2.072-3.928-3.358-1.565-1.277-3.169-2.239-2.851-3.952.189-1.419 1.076-2.391 2.799-3.891.898-.777 2.322-2.48 3.497-3.189 1.007-.591 2.03-.256 3.149-.385z\"/><path fill=\"#E0A900\" d=\"M63.462 27.606c1.561-.192 3.698.192 4.681.919.919.684 1.561 1.062 2.394 1.325 2.786.919 6.649 1.433 6.493 3.94-.179 3-1.472 4.26-3.958 5.021-1.981.606-5.657 3.399-8.422 3.629-1.499.145-2.856.151-3.846-.184-.933-.328-2.337-2.067-3.905-3.342-1.553-1.269-3.157-2.189-2.811-3.885.209-1.369 1.061-2.363 2.771-3.852.89-.769 2.283-2.49 3.452-3.204.995-.591 2.039-.24 3.151-.367z\"/><path fill=\"#E5AF00\" d=\"M63.498 27.635c1.551-.191 3.674.191 4.651.914.913.68 1.551 1.056 2.379 1.317 2.767.913 6.62 1.431 6.467 3.921-.176 2.979-1.494 4.225-3.964 4.979-1.966.601-5.627 3.323-8.373 3.57-1.51.154-2.83.156-3.812-.174-.925-.324-2.325-2.062-3.882-3.327-1.54-1.259-3.145-2.14-2.77-3.816.229-1.319 1.044-2.336 2.739-3.813.882-.761 2.246-2.5 3.409-3.218.985-.593 2.051-.225 3.156-.353z\"/><path fill=\"#EAB500\" d=\"M63.533 27.666c1.541-.189 3.651.19 4.623.908.908.675 1.541 1.05 2.364 1.309 2.748.907 6.592 1.428 6.44 3.903-.174 2.958-1.516 4.19-3.97 4.938-1.951.596-5.595 3.247-8.323 3.509-1.521.165-2.802.163-3.778-.164-.916-.321-2.312-2.057-3.857-3.312-1.53-1.25-3.134-2.091-2.732-3.749.249-1.269 1.03-2.309 2.711-3.775.875-.752 2.208-2.51 3.364-3.232.973-.594 2.06-.208 3.158-.335z\"/><path fill=\"#EFBA00\" d=\"M63.569 27.695c1.531-.188 3.627.189 4.592.902.902.671 1.532 1.045 2.349 1.3 2.73.902 6.564 1.426 6.415 3.884-.172 2.939-1.539 4.156-3.976 4.896-1.936.591-5.563 3.17-8.273 3.45-1.532.175-2.776.168-3.744-.154-.909-.318-2.3-2.052-3.835-3.296-1.517-1.241-3.121-2.041-2.691-3.681.271-1.22 1.014-2.282 2.682-3.736.867-.745 2.171-2.521 3.321-3.248.96-.593 2.069-.191 3.16-.317z\"/><path fill=\"#F4C000\" d=\"M63.603 27.726c1.521-.187 3.606.188 4.564.896.896.667 1.521 1.04 2.334 1.292 2.711.896 6.536 1.424 6.389 3.864-.168 2.919-1.56 4.122-3.981 4.855-1.921.586-5.533 3.095-8.224 3.391-1.542.186-2.75.174-3.71-.144-.9-.315-2.287-2.047-3.811-3.281-1.505-1.232-3.109-1.992-2.651-3.613.29-1.17.999-2.255 2.651-3.698.859-.736 2.133-2.531 3.276-3.262.95-.594 2.08-.175 3.163-.3z\"/><path fill=\"#F9C600\" d=\"M63.639 27.755c1.512-.186 3.583.187 4.535.891.891.663 1.512 1.035 2.32 1.284 2.692.89 6.507 1.421 6.361 3.845-.167 2.9-1.582 4.088-3.985 4.814-1.907.581-5.503 3.018-8.175 3.331-1.553.196-2.722.18-3.675-.133-.893-.312-2.276-2.042-3.788-3.266-1.493-1.223-3.098-1.942-2.611-3.545.309-1.119.983-2.228 2.621-3.659.853-.729 2.095-2.542 3.233-3.277.936-.595 2.088-.16 3.164-.285z\"/><path fill=\"#fc0\" d=\"M63.675 27.786c1.5-.185 3.559.186 4.504.885.885.658 1.502 1.029 2.304 1.275 2.674.884 6.48 1.42 6.337 3.826-.165 2.879-1.604 4.053-3.992 4.772-1.892.576-5.472 2.942-8.125 3.271-1.564.206-2.696.185-3.642-.124-.884-.309-2.263-2.037-3.764-3.25-1.482-1.214-3.086-1.893-2.572-3.477.33-1.07.967-2.201 2.592-3.621.843-.72 2.057-2.551 3.188-3.292.927-.594 2.1-.142 3.17-.265zm.268.932c.327.674 1.163.767 1.721 1.069.535.303.837.372 1.046.256.465-.256.117-1.093-.349-1.395-.441-.302-2.604-.372-2.418.07z\"/><path fill=\"#F9C600\" d=\"M63.99 28.725c.316.657 1.133.748 1.677 1.043.521.294.815.362 1.02.249.452-.249.113-1.065-.34-1.359-.432-.296-2.539-.364-2.357.067z\"/><path fill=\"#F4C000\" d=\"M64.035 28.731c.309.64 1.103.729 1.633 1.016.508.287.794.353.993.243.442-.243.11-1.037-.331-1.324-.419-.287-2.471-.353-2.295.065z\"/><path fill=\"#EFBA00\" d=\"M64.081 28.739c.301.623 1.074.708 1.59.988.494.279.773.344.966.236.429-.236.108-1.01-.322-1.289-.408-.279-2.406-.343-2.234.065z\"/><path fill=\"#EAB500\" d=\"M64.127 28.746c.292.605 1.044.689 1.545.961.481.271.752.334.941.229.417-.229.104-.982-.314-1.253-.396-.271-2.339-.335-2.172.063z\"/><path fill=\"#E5AF00\" d=\"M64.173 28.752c.285.589 1.015.67 1.502.934.467.264.731.325.914.224.406-.224.101-.955-.304-1.219-.386-.263-2.274-.324-2.112.061z\"/><path fill=\"#E0A900\" d=\"M64.219 28.759c.277.572.986.651 1.459.907.453.256.71.315.887.217.395-.217.099-.927-.296-1.183-.374-.256-2.207-.315-2.05.059z\"/><path fill=\"#DBA300\" d=\"M64.265 28.767c.268.555.956.631 1.416.88.44.249.688.306.861.21.382-.21.095-.899-.287-1.148-.364-.249-2.142-.306-1.99.058z\"/><path fill=\"#D69E00\" d=\"M64.311 28.773c.26.538.927.612 1.372.853.427.241.667.296.834.204.371-.204.093-.871-.277-1.111-.353-.242-2.078-.298-1.929.054z\"/><path fill=\"#D19800\" d=\"M64.357 28.78c.25.521.897.592 1.329.826.412.233.646.287.807.197.358-.197.09-.843-.27-1.077-.34-.232-2.01-.287-1.866.054z\"/><path fill=\"#CC9200\" d=\"M64.403 28.788c.244.503.869.573 1.286.799.398.226.625.277.78.19.347-.19.087-.816-.26-1.042-.33-.226-1.945-.277-1.806.053z\"/><path fill=\"#C68C00\" d=\"M64.449 28.794c.235.486.839.553 1.241.771.385.218.604.269.754.184.335-.184.084-.788-.251-1.006-.319-.217-1.878-.267-1.744.051z\"/><path fill=\"#C18700\" d=\"M64.495 28.801c.226.469.809.535 1.197.745.372.21.583.259.729.178.323-.178.081-.761-.243-.971-.308-.21-1.812-.259-1.683.048z\"/><path fill=\"#BC8100\" d=\"M64.541 28.809c.218.452.779.514 1.153.717.359.203.562.249.703.171.312-.171.078-.733-.234-.935-.297-.203-1.747-.25-1.622.047z\"/><path fill=\"#B77B00\" d=\"M64.587 28.815c.21.435.75.495 1.11.69.345.195.54.24.675.165.3-.165.076-.706-.225-.9-.285-.194-1.68-.24-1.56.045z\"/><path fill=\"#B27500\" d=\"M64.634 28.822c.201.418.719.476 1.065.663.333.188.519.23.649.159.288-.159.073-.677-.216-.865-.274-.187-1.614-.231-1.498.043z\"/><path fill=\"#AD7000\" d=\"M64.68 28.829c.193.401.69.456 1.022.636.317.18.497.221.622.152.276-.152.069-.649-.208-.83-.262-.178-1.547-.22-1.436.042z\"/><path fill=\"#A86A00\" d=\"M64.725 28.836c.185.384.662.437.979.608.304.173.476.212.596.146.264-.146.066-.622-.199-.794-.251-.171-1.483-.211-1.376.04z\"/><path fill=\"#A36400\" d=\"M64.771 28.843c.176.367.631.417.936.582.29.164.455.202.569.139.252-.139.062-.594-.19-.759-.24-.164-1.417-.202-1.315.038z\"/><path fill=\"#9E5E00\" d=\"M64.817 28.85c.168.35.603.398.892.555.277.157.434.192.543.132.24-.132.061-.566-.182-.724-.228-.155-1.35-.192-1.253.037z\"/><path fill=\"#995900\" d=\"M64.863 28.857c.161.333.573.378.848.528.264.148.413.183.517.125.229-.125.057-.539-.173-.688-.217-.148-1.284-.182-1.192.035z\"/><path fill=\"#fc0\" d=\"M59.066 29.584c-.105.262.629.761.998.42a10.91 10.91 0 0 1 1.025-.762c.708-.473.447-.814-.735-.604-1.183.21-1.183.682-1.288.946z\"/><path fill=\"#F9C600\" d=\"M59.085 29.58c-.103.257.615.744.975.41.384-.333.846-.641 1.001-.744.692-.462.436-.795-.719-.59-1.155.205-1.155.667-1.257.924z\"/><path fill=\"#F4C000\" d=\"M59.104 29.576c-.1.25.601.727.952.401.375-.325.826-.626.977-.727.676-.451.426-.776-.702-.576-1.127.201-1.127.652-1.227.902z\"/><path fill=\"#EFBA00\" d=\"M59.123 29.573c-.098.245.586.708.929.391.366-.318.806-.611.953-.709.659-.439.415-.757-.684-.562-1.1.196-1.1.635-1.198.88z\"/><path fill=\"#EAB500\" d=\"M59.142 29.57c-.096.238.572.691.905.381.358-.31.787-.596.93-.692.644-.428.405-.739-.667-.548-1.073.191-1.073.62-1.168.859z\"/><path fill=\"#E5AF00\" d=\"M59.161 29.566c-.093.232.558.673.882.372.349-.302.767-.58.906-.673.628-.418.395-.72-.65-.535-1.046.186-1.045.604-1.138.836z\"/><path fill=\"#E0A900\" d=\"M59.18 29.564c-.09.226.543.656.859.362.339-.294.747-.565.882-.656.611-.407.384-.702-.634-.52-1.017.18-1.017.587-1.107.814z\"/><path fill=\"#DBA300\" d=\"M59.199 29.56c-.088.219.528.638.836.352.33-.286.727-.55.858-.638.594-.396.374-.683-.616-.506-.991.175-.991.571-1.078.792z\"/><path fill=\"#D69E00\" d=\"M59.218 29.556c-.086.214.513.621.813.343.321-.278.707-.535.834-.621.578-.386.364-.664-.599-.492-.962.171-.962.556-1.048.77z\"/><path fill=\"#D19800\" d=\"M59.237 29.553c-.083.208.499.604.791.333.311-.27.686-.52.81-.604.562-.374.354-.645-.582-.478-.936.167-.936.541-1.019.749z\"/><path fill=\"#CC9200\" d=\"M59.256 29.55c-.081.202.484.586.766.323.304-.263.667-.505.789-.585.545-.363.342-.626-.566-.464-.909.16-.909.524-.989.726z\"/><path fill=\"#C68C00\" d=\"M59.275 29.546c-.079.196.47.568.743.313.294-.254.647-.49.765-.568.528-.353.332-.607-.549-.45-.882.158-.882.509-.959.705z\"/><path fill=\"#C18700\" d=\"M59.293 29.543c-.076.189.455.55.721.303.286-.247.626-.474.741-.55.512-.342.322-.588-.532-.437-.854.153-.854.494-.93.684z\"/><path fill=\"#BC8100\" d=\"M59.312 29.54c-.074.184.44.532.698.294.275-.239.605-.459.716-.533.496-.33.312-.57-.515-.422-.825.147-.825.477-.899.661z\"/><path fill=\"#B77B00\" d=\"M59.331 29.537c-.071.177.426.514.675.283.266-.23.585-.444.692-.515.479-.319.302-.55-.497-.408s-.799.462-.87.64z\"/><path fill=\"#B27500\" d=\"M59.35 29.533c-.069.171.411.497.652.274.257-.222.565-.428.668-.497.463-.309.292-.532-.48-.395s-.771.447-.84.618z\"/><path fill=\"#AD7000\" d=\"M59.369 29.53c-.066.166.397.48.627.265.249-.215.546-.414.646-.48.447-.297.28-.513-.463-.38-.744.132-.744.429-.81.595z\"/><path fill=\"#A86A00\" d=\"M59.389 29.526c-.063.159.382.462.605.255.239-.207.525-.398.621-.462.43-.287.271-.494-.446-.366-.717.128-.717.414-.78.573z\"/><path fill=\"#A36400\" d=\"M59.407 29.523c-.061.153.368.444.582.246.23-.2.506-.383.598-.445.414-.276.262-.475-.429-.352-.689.122-.689.398-.751.551z\"/><path fill=\"#9E5E00\" d=\"M59.426 29.52c-.059.146.354.427.559.235.22-.191.486-.368.574-.427.397-.265.25-.457-.412-.338-.662.118-.662.383-.721.53z\"/><path fill=\"#995900\" d=\"M59.445 29.517c-.056.141.339.409.536.226a5.48 5.48 0 0 1 .55-.409c.381-.255.24-.438-.396-.325-.633.113-.633.366-.69.508z\"/><path fill=\"#fc0\" d=\"M60.381 36.556c-.074.923 2.049-1.384 2.178-1.587.276-.498 1.199-1.9 1.347-2.491.276-1.033.775-1.79.461-2.878-.111-.35-.885-.442-1.236-.221-.996.59-.848 1.31-.959 1.974-.37 1.882-1.661 3.782-1.791 5.203z\"/><path fill=\"#FFCC02\" d=\"M60.469 36.412c-.072.899 1.994-1.352 2.12-1.55.269-.486 1.167-1.855 1.309-2.431.269-1.008.753-1.746.446-2.807-.109-.342-.864-.431-1.206-.214-.971.577-.825 1.278-.933 1.926-.356 1.835-1.613 3.69-1.736 5.076z\"/><path fill=\"#FFCC05\" d=\"M60.555 36.268c-.068.877 1.942-1.32 2.063-1.514.263-.475 1.135-1.809 1.272-2.371.259-.982.731-1.702.43-2.736-.107-.333-.843-.418-1.176-.207-.945.564-.802 1.247-.906 1.878-.343 1.79-1.564 3.6-1.683 4.95z\"/><path fill=\"#FFCC07\" d=\"M60.642 36.124c-.064.854 1.889-1.289 2.008-1.477.253-.462 1.101-1.764 1.234-2.311.251-.957.708-1.659.414-2.665-.105-.324-.821-.405-1.145-.199-.92.551-.779 1.216-.879 1.831-.333 1.742-1.519 3.506-1.632 4.821z\"/><path fill=\"#FFCD0A\" d=\"M60.728 35.98c-.061.831 1.835-1.258 1.95-1.441.247-.45 1.069-1.718 1.198-2.25.243-.932.687-1.616.397-2.594-.101-.314-.799-.394-1.114-.192-.894.538-.756 1.184-.852 1.783-.319 1.696-1.471 3.414-1.579 4.694z\"/><path fill=\"#FFCD0C\" d=\"M60.815 35.836c-.058.808 1.782-1.227 1.894-1.405.238-.438 1.035-1.672 1.16-2.19.234-.907.666-1.572.383-2.523-.1-.306-.778-.38-1.084-.185-.867.524-.733 1.153-.825 1.735-.309 1.65-1.425 3.323-1.528 4.568z\"/><path fill=\"#FFCD0F\" d=\"M60.902 35.691c-.055.785 1.729-1.195 1.836-1.369.23-.426 1.002-1.626 1.124-2.129.226-.881.643-1.529.366-2.451-.097-.297-.756-.369-1.053-.177-.842.511-.709 1.122-.798 1.688-.296 1.602-1.378 3.229-1.475 4.438z\"/><path fill=\"#FFCD11\" d=\"M60.989 35.547c-.052.762 1.675-1.163 1.78-1.332.223-.415.97-1.581 1.085-2.069.217-.855.621-1.485.351-2.38-.095-.289-.734-.356-1.022-.17-.816.498-.688 1.09-.771 1.639-.285 1.557-1.331 3.139-1.423 4.312z\"/><path fill=\"#FFCE14\" d=\"M61.076 35.403c-.048.739 1.622-1.132 1.723-1.296.216-.402.936-1.535 1.048-2.009.208-.83.599-1.441.335-2.309-.093-.28-.715-.345-.992-.163-.79.484-.664 1.059-.744 1.591-.272 1.512-1.284 3.048-1.37 4.186z\"/><path fill=\"#FFCE16\" d=\"M61.162 35.259c-.045.717 1.569-1.1 1.667-1.259.208-.39.904-1.489 1.011-1.949.201-.805.577-1.398.318-2.237-.09-.271-.693-.332-.961-.156-.765.471-.64 1.027-.718 1.543-.259 1.464-1.236 2.955-1.317 4.058z\"/><path fill=\"#FFCE19\" d=\"M61.249 35.115c-.043.693 1.515-1.068 1.61-1.223.2-.377.871-1.443.974-1.888.191-.78.555-1.355.302-2.167-.088-.262-.671-.319-.93-.148-.739.458-.618.996-.691 1.496-.249 1.417-1.188 2.862-1.265 3.93z\"/><path fill=\"#FFCE1C\" d=\"M61.336 34.971c-.039.67 1.462-1.037 1.553-1.187.193-.366.839-1.398.936-1.829.184-.754.533-1.311.288-2.095-.086-.252-.65-.308-.9-.141-.713.444-.595.964-.664 1.448-.237 1.372-1.143 2.771-1.213 3.804z\"/><path fill=\"#FFCF1E\" d=\"M61.422 34.826c-.035.648 1.41-1.005 1.498-1.15.184-.354.806-1.353.898-1.769.176-.728.511-1.267.271-2.023-.084-.244-.628-.295-.869-.133-.688.432-.572.933-.637 1.4-.225 1.324-1.096 2.678-1.161 3.675z\"/><path fill=\"#FFCF21\" d=\"M61.509 34.683c-.032.624 1.356-.975 1.44-1.114.176-.342.773-1.306.861-1.708.167-.703.489-1.224.256-1.953-.082-.235-.607-.282-.839-.126-.663.418-.548.902-.611 1.353-.212 1.277-1.047 2.585-1.107 3.548z\"/><path fill=\"#FFCF23\" d=\"M61.596 34.539c-.028.601 1.304-.943 1.383-1.078.169-.33.741-1.261.824-1.648.159-.677.467-1.18.241-1.882-.08-.226-.586-.27-.81-.118-.636.404-.525.87-.583 1.304-.2 1.232-1 2.494-1.055 3.422z\"/><path fill=\"#FFCF26\" d=\"M61.682 34.394c-.026.579 1.25-.911 1.326-1.041.162-.317.708-1.215.788-1.588.149-.652.444-1.137.224-1.81-.077-.217-.564-.257-.778-.111-.61.392-.502.839-.556 1.256-.189 1.185-.955 2.402-1.004 3.294z\"/><path fill=\"#FFD028\" d=\"M61.769 34.25c-.022.556 1.196-.879 1.27-1.005.154-.306.675-1.169.75-1.527.142-.627.424-1.093.208-1.739-.075-.208-.542-.245-.748-.104-.584.378-.478.808-.529 1.208-.177 1.139-.907 2.311-.951 3.167z\"/><path fill=\"#FFD02B\" d=\"M61.856 34.106c-.02.533 1.144-.848 1.212-.969.146-.293.643-1.124.712-1.467.134-.602.401-1.05.193-1.668-.073-.199-.521-.232-.718-.096-.558.364-.455.775-.502 1.161-.163 1.091-.859 2.218-.897 3.039z\"/><path fill=\"#FFD02D\" d=\"M61.943 33.962c-.016.51 1.089-.816 1.155-.932.14-.282.61-1.079.676-1.407.125-.576.378-1.006.177-1.597-.07-.19-.499-.22-.687-.088-.533.351-.432.744-.475 1.112-.153 1.046-.813 2.126-.846 2.912z\"/><path fill=\"#FFD030\" d=\"M62.03 33.817c-.013.487 1.037-.785 1.099-.895.131-.27.577-1.033.638-1.347.117-.55.357-.962.162-1.526-.068-.181-.478-.208-.657-.082-.507.338-.409.713-.448 1.065-.142 1-.766 2.035-.794 2.785z\"/><path fill=\"#FFD133\" d=\"M62.116 33.673c-.009.464.985-.753 1.043-.859.124-.257.544-.987.601-1.287.108-.525.334-.919.145-1.455-.066-.173-.456-.196-.626-.074-.481.325-.385.681-.421 1.017-.13.954-.719 1.944-.742 2.658z\"/><path fill=\"#fc0\" d=\"M67.709 32.716c-1.022 1.116-1.743 2.185-2.324 2.906-.605.744-2.093 1.627-1.349 2.487.627.767 3.208-.627 5.208-2.115 1.975-1.488 5.067-2.813 3.557-4.509-.791-.86-2.651-.675-3.371-.209-.559.348-.884.534-1.721 1.44z\"/><path fill=\"#FFCC02\" d=\"M67.753 32.766c-1.007 1.091-1.715 2.14-2.287 2.844-.595.726-2.059 1.597-1.334 2.432.611.746 3.139-.627 5.1-2.088 1.937-1.461 4.966-2.769 3.493-4.417-.77-.835-2.589-.645-3.296-.188-.546.341-.861.538-1.676 1.417z\"/><path fill=\"#FFCC05\" d=\"M67.797 32.815c-.99 1.066-1.688 2.095-2.25 2.783-.585.708-2.026 1.566-1.319 2.377.595.725 3.071-.627 4.993-2.062 1.899-1.434 4.863-2.724 3.43-4.325-.75-.811-2.53-.616-3.222-.168-.536.338-.839.544-1.632 1.395z\"/><path fill=\"#FFCC07\" d=\"M67.841 32.865c-.975 1.04-1.66 2.049-2.214 2.721-.575.69-1.991 1.535-1.304 2.323.579.703 3.004-.627 4.886-2.035 1.86-1.407 4.761-2.679 3.366-4.232-.729-.787-2.469-.587-3.146-.147-.524.33-.816.547-1.588 1.37z\"/><path fill=\"#FFCD0A\" d=\"M67.885 32.915c-.958 1.014-1.63 2.003-2.177 2.659-.565.672-1.957 1.504-1.29 2.268.563.681 2.935-.627 4.778-2.008 1.822-1.381 4.659-2.635 3.303-4.141-.71-.762-2.41-.557-3.073-.127-.511.326-.791.554-1.541 1.349z\"/><path fill=\"#FFCD0C\" d=\"M67.929 32.964c-.942.99-1.603 1.959-2.141 2.598-.555.654-1.923 1.473-1.275 2.213.547.66 2.867-.627 4.671-1.981 1.783-1.354 4.558-2.591 3.239-4.048-.689-.738-2.349-.528-2.998-.105-.498.318-.768.556-1.496 1.323z\"/><path fill=\"#FFCD0F\" d=\"M67.973 33.014c-.927.964-1.576 1.913-2.104 2.537-.545.636-1.89 1.442-1.26 2.158.531.639 2.798-.627 4.563-1.955 1.744-1.327 4.456-2.546 3.176-3.955-.67-.714-2.29-.5-2.924-.085-.487.312-.745.56-1.451 1.3z\"/><path fill=\"#FFCD11\" d=\"M68.017 33.063c-.911.939-1.548 1.868-2.068 2.476-.535.618-1.856 1.412-1.245 2.102.514.617 2.729-.626 4.456-1.927 1.707-1.301 4.354-2.502 3.113-3.863-.65-.689-2.229-.47-2.848-.064-.476.306-.723.565-1.408 1.276z\"/><path fill=\"#FFCE14\" d=\"M68.061 33.112c-.895.914-1.519 1.823-2.031 2.414-.525.6-1.822 1.381-1.231 2.047.498.596 2.662-.626 4.349-1.9 1.668-1.273 4.252-2.458 3.048-3.771-.628-.665-2.167-.44-2.773-.043-.464.301-.699.57-1.362 1.253z\"/><path fill=\"#FFCE16\" d=\"M68.105 33.162c-.879.888-1.491 1.777-1.994 2.353-.515.583-1.788 1.35-1.216 1.993.481.574 2.593-.625 4.241-1.874 1.628-1.247 4.149-2.414 2.986-3.679-.61-.641-2.109-.412-2.699-.023-.452.295-.677.575-1.318 1.23z\"/><path fill=\"#FFCE19\" d=\"M68.149 33.212c-.863.863-1.462 1.732-1.958 2.291-.504.564-1.754 1.319-1.202 1.938.465.553 2.525-.625 4.134-1.847 1.591-1.22 4.048-2.369 2.922-3.586-.589-.616-2.048-.382-2.625-.002-.439.288-.652.578-1.271 1.206z\"/><path fill=\"#FFCE1C\" d=\"M68.193 33.261c-.846.838-1.435 1.687-1.921 2.229-.495.546-1.72 1.289-1.187 1.882.449.531 2.457-.625 4.027-1.82 1.552-1.193 3.946-2.325 2.859-3.494-.57-.591-1.988-.353-2.551.019-.427.284-.629.584-1.227 1.184z\"/><path fill=\"#FFCF1E\" d=\"M68.237 33.311c-.831.813-1.407 1.642-1.884 2.168-.485.529-1.687 1.258-1.172 1.828.433.51 2.388-.625 3.919-1.792 1.514-1.167 3.843-2.28 2.795-3.402-.549-.566-1.927-.324-2.476.039-.416.276-.606.587-1.182 1.159z\"/><path fill=\"#FFCF21\" d=\"M68.281 33.36c-.814.788-1.378 1.597-1.847 2.106-.475.511-1.654 1.227-1.158 1.773.416.489 2.32-.624 3.812-1.766 1.475-1.14 3.741-2.236 2.732-3.31-.529-.542-1.867-.295-2.402.06-.404.272-.583.593-1.137 1.137z\"/><path fill=\"#FFCF23\" d=\"M68.326 33.41c-.8.763-1.352 1.551-1.811 2.045-.465.493-1.62 1.196-1.143 1.717.4.468 2.251-.624 3.704-1.739 1.437-1.113 3.64-2.191 2.669-3.217-.509-.519-1.808-.266-2.327.081-.394.266-.561.597-1.092 1.113z\"/><path fill=\"#FFCF26\" d=\"M68.369 33.459c-.783.737-1.324 1.505-1.774 1.983-.456.475-1.586 1.166-1.129 1.663.384.446 2.184-.624 3.598-1.712 1.398-1.086 3.538-2.147 2.605-3.125-.489-.493-1.748-.236-2.252.101-.382.26-.537.602-1.048 1.09z\"/><path fill=\"#FFD028\" d=\"M68.412 33.509c-.766.711-1.294 1.46-1.736 1.921-.446.457-1.553 1.135-1.114 1.607.368.425 2.115-.624 3.49-1.685 1.36-1.061 3.436-2.104 2.543-3.033-.469-.47-1.688-.208-2.178.122-.371.255-.515.607-1.005 1.068z\"/><path fill=\"#FFD02B\" d=\"M68.456 33.559c-.75.687-1.265 1.415-1.699 1.86-.436.439-1.519 1.104-1.1 1.553.353.403 2.047-.623 3.383-1.658 1.321-1.033 3.334-2.058 2.479-2.94-.448-.445-1.627-.178-2.103.143-.359.247-.492.609-.96 1.042z\"/><path fill=\"#FFD02D\" d=\"M68.501 33.608c-.735.661-1.238 1.37-1.664 1.799-.426.421-1.485 1.073-1.084 1.498.335.381 1.978-.624 3.275-1.632 1.284-1.006 3.232-2.014 2.416-2.848-.429-.42-1.566-.149-2.029.163-.347.242-.468.615-.914 1.02z\"/><path fill=\"#FFD030\" d=\"M68.545 33.657c-.719.636-1.21 1.324-1.627 1.737-.415.403-1.451 1.043-1.069 1.443.318.36 1.91-.623 3.168-1.605 1.243-.979 3.129-1.97 2.352-2.756-.41-.396-1.507-.12-1.955.184-.335.238-.445.621-.869.997z\"/><path fill=\"#FFD133\" d=\"M68.589 33.707c-.704.611-1.183 1.278-1.591 1.676-.405.385-1.417 1.012-1.055 1.388.302.338 1.841-.623 3.061-1.578 1.206-.953 3.028-1.926 2.289-2.664-.388-.372-1.446-.091-1.879.205l-.825.973z\"/><path fill=\"#fff\" d=\"M69.894 56.148c.278-.907 9.322-3.045 10.81-2.348 1.464.697 8.484 10.903 7.23 11.461-1.255.535-3.953-3.395-7.881-5.208-3.929-1.813-10.438-2.975-10.159-3.905z\"/><path fill=\"#F9F9F9\" d=\"M70.161 56.167c.273-.892 9.087-2.931 10.554-2.26 1.445.671 8.319 10.622 7.084 11.168-1.234.525-3.863-3.34-7.729-5.125-3.867-1.783-10.183-2.869-9.909-3.783z\"/><path fill=\"#F4F4F4\" d=\"M70.427 56.186c.268-.876 8.853-2.816 10.299-2.17 1.426.645 8.155 10.339 6.94 10.875-1.214.515-3.774-3.287-7.579-5.043-3.804-1.756-9.929-2.765-9.66-3.662z\"/><path fill=\"#EFEFEF\" d=\"M70.693 56.204c.264-.861 8.618-2.701 10.044-2.082 1.407.619 7.989 10.059 6.796 10.583-1.193.505-3.686-3.233-7.428-4.96-3.742-1.727-9.675-2.66-9.412-3.541z\"/><path fill=\"#EAEAEA\" d=\"M70.959 56.222c.258-.847 8.382-2.585 9.79-1.993 1.387.593 7.824 9.778 6.651 10.291-1.173.495-3.597-3.179-7.277-4.878-3.681-1.699-9.422-2.556-9.164-3.42z\"/><path fill=\"#E5E5E5\" d=\"M71.226 56.24c.252-.831 8.148-2.47 9.534-1.903 1.368.566 7.659 9.497 6.507 9.998-1.153.484-3.509-3.125-7.127-4.796-3.618-1.67-9.168-2.451-8.914-3.299z\"/><path fill=\"#E0E0E0\" d=\"M71.491 56.258c.249-.816 7.914-2.355 9.28-1.815 1.349.541 7.495 9.216 6.363 9.707-1.132.474-3.42-3.073-6.977-4.714-3.556-1.642-8.914-2.345-8.666-3.178z\"/><path fill=\"#DBDBDB\" d=\"M71.758 56.277c.243-.801 7.678-2.241 9.024-1.727 1.33.515 7.33 8.934 6.218 9.414-1.11.464-3.331-3.019-6.825-4.631s-8.66-2.24-8.417-3.056z\"/><path fill=\"#D6D6D6\" d=\"M72.024 56.295c.237-.786 7.444-2.126 8.769-1.638 1.312.489 7.164 8.653 6.074 9.122-1.09.454-3.242-2.965-6.675-4.549-3.432-1.584-8.406-2.135-8.168-2.935z\"/><path fill=\"#D1D1D1\" d=\"M72.29 56.313c.233-.77 7.209-2.011 8.514-1.548 1.292.462 6.999 8.372 5.93 8.829-1.07.445-3.154-2.911-6.523-4.466-3.371-1.556-8.153-2.031-7.921-2.815z\"/><path fill=\"#ccc\" d=\"M72.556 56.331c.228-.755 6.976-1.896 8.259-1.459 1.273.436 6.835 8.091 5.786 8.537-1.05.434-3.066-2.858-6.374-4.385-3.307-1.527-7.898-1.925-7.671-2.693z\"/><path fill=\"#C6C6C6\" d=\"M72.823 56.35c.222-.74 6.74-1.781 8.004-1.371 1.253.41 6.669 7.809 5.64 8.244-1.028.424-2.977-2.805-6.222-4.302-3.246-1.498-7.644-1.82-7.422-2.571z\"/><path fill=\"#C1C1C1\" d=\"M73.089 56.369c.217-.726 6.505-1.667 7.749-1.283 1.233.384 6.503 7.528 5.496 7.952-1.008.415-2.887-2.75-6.071-4.221-3.185-1.469-7.391-1.714-7.174-2.448z\"/><path fill=\"#BCBCBC\" d=\"M73.355 56.387c.21-.71 6.27-1.552 7.494-1.194 1.215.358 6.338 7.248 5.352 7.66-.987.404-2.799-2.697-5.92-4.137-3.122-1.442-7.137-1.61-6.926-2.329z\"/><path fill=\"#B7B7B7\" d=\"M73.621 56.406c.208-.695 6.035-1.437 7.239-1.105 1.196.332 6.174 6.965 5.208 7.367-.967.394-2.711-2.643-5.771-4.056-3.06-1.412-6.882-1.505-6.676-2.206z\"/><path fill=\"#B2B2B2\" d=\"M73.887 56.423c.202-.679 5.801-1.321 6.984-1.016 1.177.305 6.008 6.685 5.063 7.075-.946.385-2.622-2.589-5.62-3.973-2.997-1.383-6.627-1.4-6.427-2.086z\"/><path fill=\"#ADADAD\" d=\"M74.154 56.442c.196-.665 5.565-1.207 6.728-.928 1.159.28 5.844 6.404 4.919 6.783-.925.373-2.533-2.536-5.469-3.892-2.935-1.354-6.374-1.294-6.178-1.963z\"/><path fill=\"#A8A8A8\" d=\"M74.42 56.46c.19-.649 5.331-1.092 6.474-.839 1.137.253 5.678 6.123 4.774 6.491-.905.364-2.445-2.482-5.319-3.809-2.873-1.326-6.12-1.19-5.929-1.843z\"/><path fill=\"#A3A3A3\" d=\"M74.685 56.479c.186-.634 5.097-.977 6.219-.75 1.12.228 5.514 5.842 4.629 6.198-.883.354-2.355-2.429-5.167-3.727-2.81-1.298-5.865-1.084-5.681-1.721z\"/><path fill=\"#9E9E9E\" d=\"M74.952 56.497c.181-.62 4.862-.862 5.963-.661 1.1.201 5.348 5.56 4.486 5.905-.863.344-2.267-2.375-5.017-3.644-2.748-1.269-5.612-.979-5.432-1.6z\"/><path fill=\"#999\" d=\"M75.219 56.515c.174-.604 4.627-.747 5.708-.572 1.082.175 5.184 5.279 4.341 5.613s-2.178-2.321-4.866-3.562c-2.687-1.241-5.358-.874-5.183-1.479z\"/><path fill=\"#fff\" d=\"M58.503 70.05c.93.046.047 5.253.047 10.624 0 5.37.72 7.252.047 7.926-.674.675-1.836-1.743-1.836-7.113-.001-5.37.813-11.484 1.742-11.437z\"/><path fill=\"#F9F9F9\" d=\"M58.494 70.176c.898.052.035 5.182.031 10.467-.003 5.284.707 7.17.054 7.825-.652.656-1.796-1.738-1.791-7.023.004-5.284.808-11.321 1.706-11.269z\"/><path fill=\"#F4F4F4\" d=\"M58.484 70.302c.868.058.025 5.111.017 10.31-.008 5.199.691 7.087.06 7.725-.63.635-1.755-1.732-1.745-6.933.008-5.199.802-11.16 1.668-11.102z\"/><path fill=\"#EFEFEF\" d=\"M58.475 70.428c.835.064.013 5.042.001 10.154-.011 5.112.677 7.004.066 7.622-.609.616-1.714-1.728-1.699-6.843.012-5.112.797-10.996 1.632-10.933z\"/><path fill=\"#EAEAEA\" d=\"M58.465 70.555c.804.069.003 4.97-.013 9.996-.016 5.028.663 6.923.072 7.522-.587.597-1.673-1.723-1.654-6.753.017-5.027.792-10.835 1.595-10.765z\"/><path fill=\"#E5E5E5\" d=\"M58.456 70.681c.772.074-.009 4.898-.029 9.84-.02 4.942.648 6.839.079 7.42-.565.577-1.632-1.718-1.608-6.663.02-4.942.785-10.672 1.558-10.597z\"/><path fill=\"#E0E0E0\" d=\"M58.447 70.807c.742.08-.02 4.827-.045 9.682-.024 4.856.634 6.757.086 7.319-.544.558-1.591-1.711-1.562-6.572.024-4.856.779-10.509 1.521-10.429z\"/><path fill=\"#DBDBDB\" d=\"M58.437 70.933c.709.086-.031 4.756-.059 9.527-.028 4.77.618 6.673.091 7.217-.521.538-1.55-1.707-1.516-6.483.028-4.77.774-10.347 1.484-10.261z\"/><path fill=\"#D6D6D6\" d=\"M58.428 71.059c.679.091-.042 4.685-.074 9.37-.032 4.685.604 6.591.098 7.116-.5.519-1.509-1.702-1.471-6.393.033-4.684.768-10.184 1.447-10.093z\"/><path fill=\"#D1D1D1\" d=\"M58.418 71.186c.648.097-.053 4.614-.089 9.212-.036 4.6.59 6.507.104 7.014-.477.5-1.468-1.695-1.425-6.302.036-4.598.763-10.022 1.41-9.924z\"/><path fill=\"#ccc\" d=\"M58.409 71.312c.617.103-.063 4.542-.103 9.056s.574 6.425.111 6.914c-.457.479-1.428-1.691-1.38-6.213.039-4.513.756-9.86 1.372-9.757z\"/><path fill=\"#C6C6C6\" d=\"M58.399 71.439c.585.107-.075 4.472-.119 8.899-.044 4.427.56 6.342.117 6.811-.434.462-1.386-1.684-1.333-6.122.044-4.427.751-9.697 1.335-9.588z\"/><path fill=\"#C1C1C1\" d=\"M58.389 71.564c.554.114-.086 4.4-.134 8.743-.047 4.342.546 6.259.124 6.71-.412.441-1.345-1.68-1.288-6.033.048-4.341.746-9.534 1.298-9.42z\"/><path fill=\"#BCBCBC\" d=\"M58.38 71.691c.522.119-.098 4.33-.148 8.586-.052 4.257.531 6.177.13 6.609-.392.422-1.305-1.675-1.243-5.942.052-4.257.74-9.374 1.261-9.253z\"/><path fill=\"#B7B7B7\" d=\"M58.37 71.817c.491.125-.108 4.258-.164 8.429-.056 4.171.517 6.094.137 6.507-.37.403-1.264-1.669-1.197-5.851.056-4.171.735-9.211 1.224-9.085z\"/><path fill=\"#B2B2B2\" d=\"M58.362 71.944c.459.13-.12 4.187-.179 8.271-.061 4.085.502 6.011.142 6.407-.347.383-1.223-1.665-1.15-5.762.059-4.085.727-9.047 1.187-8.916z\"/><path fill=\"#ADADAD\" d=\"M58.351 72.069c.428.136-.13 4.116-.193 8.116-.064 4 .487 5.928.148 6.305-.325.363-1.182-1.66-1.104-5.672.064-3.999.722-8.885 1.149-8.749z\"/><path fill=\"#A8A8A8\" d=\"M58.343 72.196c.396.142-.142 4.044-.208 7.959-.068 3.914.472 5.845.154 6.203-.303.344-1.14-1.654-1.059-5.582.068-3.914.716-8.722 1.113-8.58z\"/><path fill=\"#A3A3A3\" d=\"M58.332 72.322c.365.148-.152 3.974-.223 7.802-.072 3.829.458 5.763.162 6.102-.282.325-1.1-1.648-1.014-5.492.071-3.827.711-8.561 1.075-8.412z\"/><path fill=\"#9E9E9E\" d=\"M58.324 72.448c.333.154-.164 3.903-.24 7.646-.076 3.743.444 5.679.169 6-.261.306-1.059-1.644-.968-5.401.075-3.743.705-8.399 1.039-8.245z\"/><path fill=\"#999\" d=\"M58.314 72.574c.302.159-.175 3.831-.254 7.489-.08 3.657.429 5.597.175 5.899-.238.286-1.018-1.638-.922-5.311.078-3.657.699-8.236 1.001-8.077z\"/><path fill=\"#fff\" d=\"M60.538 55.693c.56.062 4.015-.716 4.14-.405.125.249-2.148.935-2.895 1.712-.249.25-.902.84-1.308.778-.311-.031-.498-.685-.965-1.183-1.121-1.121-1.836-1.027-1.619-1.463.188-.341 1.682.468 2.647.561z\"/><path fill=\"#FBFBFB\" d=\"M60.552 55.707c.549.061 3.932-.701 4.053-.396.122.244-2.103.914-2.834 1.676-.244.244-.883.823-1.279.762-.304-.03-.488-.67-.945-1.157-1.098-1.097-1.798-1.006-1.585-1.433.183-.336 1.646.456 2.59.548z\"/><path fill=\"#F8F8F8\" d=\"M60.567 55.719c.537.06 3.847-.686 3.966-.388.12.239-2.057.896-2.773 1.641-.239.239-.864.806-1.252.746-.298-.029-.477-.656-.924-1.133-1.074-1.073-1.759-.984-1.551-1.401.179-.329 1.61.446 2.534.535z\"/><path fill=\"#F5F5F5\" d=\"M60.582 55.732c.525.058 3.762-.67 3.879-.379.116.234-2.012.875-2.712 1.604-.233.233-.845.787-1.225.729-.291-.029-.467-.642-.905-1.108-1.05-1.05-1.721-.962-1.516-1.371.175-.32 1.575.438 2.479.525z\"/><path fill=\"#F2F2F2\" d=\"M60.596 55.746c.514.057 3.678-.656 3.792-.371.114.228-1.967.855-2.651 1.567-.228.229-.828.77-1.198.713-.284-.028-.456-.627-.884-1.083-1.026-1.026-1.681-.941-1.482-1.34.171-.314 1.54.428 2.423.514z\"/><path fill=\"#EFEFEF\" d=\"M60.611 55.758c.502.056 3.594-.641 3.705-.362.112.223-1.921.836-2.59 1.532-.223.223-.808.752-1.169.697-.279-.028-.446-.613-.864-1.059-1.003-1.002-1.644-.919-1.448-1.31.165-.306 1.502.418 2.366.502z\"/><path fill=\"#EBEBEB\" d=\"M60.625 55.772c.49.054 3.51-.626 3.618-.354.109.218-1.877.816-2.529 1.497-.218.217-.79.734-1.143.68-.271-.027-.435-.599-.843-1.034-.979-.979-1.605-.897-1.414-1.278.162-.301 1.469.406 2.311.489z\"/><path fill=\"#E8E8E8\" d=\"M60.64 55.784c.478.053 3.425-.611 3.53-.345.107.211-1.831.796-2.468 1.46-.212.212-.771.717-1.115.663-.265-.026-.425-.583-.823-1.008-.956-.956-1.567-.876-1.38-1.248.159-.292 1.433.398 2.256.478z\"/><path fill=\"#E5E5E5\" d=\"M60.655 55.797c.466.052 3.34-.596 3.444-.337.103.207-1.786.777-2.408 1.424-.208.207-.75.699-1.088.647-.258-.026-.414-.57-.802-.984-.932-.932-1.528-.854-1.346-1.217.154-.284 1.397.389 2.2.467z\"/><path fill=\"#E2E2E2\" d=\"M60.669 55.81c.455.051 3.256-.58 3.357-.328.101.202-1.741.757-2.347 1.388-.202.202-.732.682-1.06.631-.252-.025-.404-.555-.783-.959-.908-.908-1.489-.833-1.312-1.186.152-.278 1.362.377 2.145.454z\"/><path fill=\"#DFDFDF\" d=\"M60.683 55.822c.442.049 3.171-.565 3.27-.319.099.197-1.696.737-2.286 1.352-.196.197-.713.664-1.032.614-.245-.024-.393-.541-.762-.934-.885-.885-1.45-.811-1.278-1.155.147-.27 1.326.369 2.088.442z\"/><path fill=\"#DBDBDB\" d=\"M60.698 55.835c.432.048 3.087-.551 3.184-.311.095.19-1.652.717-2.227 1.315-.19.191-.693.646-1.005.599-.239-.024-.382-.526-.742-.91-.861-.861-1.412-.79-1.244-1.125.143-.261 1.292.36 2.034.432z\"/><path fill=\"#D8D8D8\" d=\"M60.713 55.849c.419.046 3.002-.535 3.095-.303.093.186-1.605.698-2.164 1.28-.186.186-.675.629-.977.582-.233-.023-.373-.512-.722-.885-.838-.837-1.373-.768-1.209-1.094.138-.255 1.255.349 1.977.42z\"/><path fill=\"#D5D5D5\" d=\"M60.727 55.861c.407.045 2.918-.52 3.008-.294.091.181-1.561.679-2.104 1.244-.181.181-.656.611-.95.566-.226-.023-.361-.498-.7-.86-.814-.813-1.335-.746-1.177-1.062.136-.249 1.222.338 1.923.406z\"/><path fill=\"#D2D2D2\" d=\"M60.742 55.874c.396.044 2.833-.505 2.922-.285.088.175-1.516.659-2.042 1.208-.176.175-.637.593-.922.549-.221-.022-.352-.483-.682-.834-.79-.791-1.295-.725-1.142-1.032.13-.243 1.185.328 1.866.394z\"/><path fill=\"#CFCFCF\" d=\"M60.757 55.887c.384.043 2.749-.49 2.834-.277.086.17-1.47.64-1.982 1.172-.169.171-.618.575-.895.533-.213-.021-.34-.469-.66-.81-.768-.768-1.258-.704-1.109-1.002.128-.233 1.151.32 1.812.384z\"/><path fill=\"#ccc\" d=\"M60.771 55.9c.372.042 2.665-.475 2.748-.268.082.165-1.426.62-1.921 1.135-.166.166-.599.558-.869.517-.207-.021-.33-.454-.64-.785-.743-.744-1.218-.682-1.074-.971.125-.227 1.116.31 1.756.372z\"/><path fill=\"#C8C8C8\" d=\"M60.785 55.913c.36.04 2.581-.46 2.661-.26.08.16-1.38.6-1.86 1.1-.16.16-.58.54-.84.5-.2-.02-.32-.44-.621-.76-.72-.72-1.18-.66-1.039-.94.12-.221 1.08.3 1.699.36z\"/><path fill=\"#C5C5C5\" d=\"M60.801 55.926c.348.038 2.496-.445 2.573-.252.077.154-1.335.581-1.799 1.064-.155.155-.562.522-.813.483-.194-.02-.31-.425-.599-.735-.698-.696-1.142-.639-1.007-.91.116-.211 1.045.292 1.645.35z\"/><path fill=\"#C2C2C2\" d=\"M60.815 55.939c.336.038 2.411-.43 2.486-.243.075.15-1.289.561-1.738 1.028-.15.149-.543.505-.785.467-.187-.019-.3-.411-.58-.71-.672-.673-1.103-.618-.972-.879.112-.205 1.01.28 1.589.337z\"/><path fill=\"#BFBFBF\" d=\"M60.829 55.951c.325.036 2.327-.415 2.4-.235.072.145-1.245.542-1.678.993-.145.144-.523.487-.758.451-.181-.018-.288-.396-.559-.685-.65-.649-1.064-.596-.938-.849.108-.198.974.271 1.533.325z\"/><path d=\"M72.425 5.573c-.394.849-1.23 7.494-.08 6.745 1.161-.756 4.381-1.715 6.42-2.265 2.261-.608-5.548-6.283-6.34-4.48z\"/><path fill=\"#060606\" d=\"M72.5 5.696c-.391.838-1.196 7.186-.076 6.459 1.128-.73 4.222-1.646 6.147-2.189 2.128-.614-5.306-6.008-6.071-4.27z\"/><path fill=\"#0C0C0C\" d=\"M72.575 5.821c-.386.826-1.161 6.875-.071 6.174 1.095-.706 4.063-1.578 5.874-2.115 1.994-.621-5.064-5.733-5.803-4.059z\"/><path fill=\"#131313\" d=\"M72.65 5.945c-.383.814-1.125 6.566-.067 5.889 1.062-.679 3.905-1.51 5.602-2.041 1.86-.627-4.822-5.458-5.535-3.848z\"/><path fill=\"#191919\" d=\"M72.724 6.069c-.38.802-1.09 6.257-.062 5.603s3.745-1.441 5.328-1.966c1.727-.633-4.579-5.182-5.266-3.637z\"/><path fill=\"#1F1F1F\" d=\"M72.8 6.193c-.375.79-1.056 5.947-.058 5.318.996-.629 3.585-1.373 5.056-1.892 1.592-.638-4.337-4.907-4.998-3.426z\"/><path fill=\"#262626\" d=\"M72.874 6.317c-.372.778-1.021 5.638-.053 5.033.963-.604 3.427-1.305 4.782-1.817 1.459-.645-4.093-4.632-4.729-3.216z\"/><path fill=\"#2C2C2C\" d=\"M72.95 6.441c-.369.766-.987 5.328-.05 4.747.931-.578 3.269-1.235 4.51-1.742 1.326-.651-3.852-4.356-4.46-3.005z\"/><path fill=\"#333\" d=\"M73.025 6.565c-.365.754-.951 5.018-.045 4.461.897-.553 3.108-1.167 4.235-1.668 1.193-.655-3.607-4.08-4.19-2.793z\"/><path fill=\"#393939\" d=\"M73.1 6.69c-.361.742-.916 4.708-.041 4.176.865-.528 2.951-1.099 3.963-1.594C78.08 8.61 73.656 5.467 73.1 6.69z\"/><path fill=\"#3F3F3F\" d=\"M73.175 6.814c-.357.73-.881 4.399-.036 3.89.831-.502 2.791-1.03 3.689-1.52.925-.667-3.124-3.529-3.653-2.37z\"/><path fill=\"#464646\" d=\"M73.249 6.938c-.354.718-.846 4.089-.032 3.605.799-.478 2.632-.962 3.417-1.445.792-.673-2.881-3.254-3.385-2.16z\"/><path fill=\"#4C4C4C\" d=\"M73.325 7.063c-.351.706-.812 3.779-.027 3.319.767-.452 2.473-.895 3.144-1.37.657-.68-2.639-2.979-3.117-1.949z\"/><path fill=\"#525252\" d=\"M73.399 7.187c-.346.694-.776 3.47-.023 3.034.733-.427 2.314-.826 2.871-1.295.524-.687-2.396-2.704-2.848-1.739z\"/><path fill=\"#595959\" d=\"M73.474 7.311c-.342.682-.741 3.161-.018 2.749.701-.402 2.156-.757 2.598-1.222.39-.691-2.154-2.428-2.58-1.527z\"/><path fill=\"#5F5F5F\" d=\"M73.549 7.435c-.338.671-.706 2.851-.014 2.462.667-.376 1.997-.688 2.324-1.147.258-.696-1.91-2.151-2.31-1.315z\"/><path fill=\"#666\" d=\"M73.624 7.559c-.334.659-.671 2.541-.009 2.177.636-.351 1.837-.62 2.052-1.072.122-.703-1.669-1.877-2.043-1.105z\"/><path fill=\"#6C6C6C\" d=\"M73.699 7.683c-.331.647-.637 2.231-.005 1.892.603-.325 1.678-.551 1.778-.997-.009-.71-1.425-1.602-1.773-.895z\"/><path fill=\"#727272\" d=\"M73.773 7.807c-.328.635-.601 1.922-.001 1.606.571-.3 1.52-.483 1.506-.923-.143-.714-1.182-1.325-1.505-.683z\"/><path fill=\"#797979\" d=\"M73.849 7.931c-.325.623-.567 1.612.003 1.321.537-.275 1.361-.415 1.232-.849-.277-.72-.939-1.05-1.235-.472z\"/><path fill=\"#7F7F7F\" d=\"M73.924 8.055c-.321.611-.532 1.303.007 1.035.505-.25 1.202-.346.96-.774-.411-.726-.697-.774-.967-.261z\"/><path d=\"M56.039 16.7c-.232.697 2.813 1.65 3.488 2.255.906.813.976 2.417 2.045 1.767.697-.418.163-1.348-1.117-2.766-1.882-2.094-4.206-1.838-4.416-1.256z\"/><path fill=\"#050505\" d=\"M56.197 16.763c-.23.669 2.672 1.583 3.338 2.177.886.793.956 2.34 1.984 1.715.677-.405.145-1.315-1.08-2.673-1.799-2.003-4.032-1.778-4.242-1.219z\"/><path fill=\"#0A0A0A\" d=\"M56.355 16.826c-.229.642 2.532 1.514 3.188 2.098.865.773.935 2.263 1.923 1.664.654-.391.126-1.281-1.043-2.581-1.717-1.912-3.859-1.717-4.068-1.181z\"/><path fill=\"#0F0F0F\" d=\"M56.513 16.89c-.227.613 2.39 1.445 3.039 2.02.845.752.915 2.185 1.861 1.612.635-.378.111-1.248-1.005-2.488-1.635-1.824-3.686-1.659-3.895-1.144z\"/><path fill=\"#141414\" d=\"M56.67 16.954c-.226.585 2.25 1.376 2.889 1.94.825.731.895 2.108 1.799 1.561.613-.365.093-1.214-.968-2.395-1.551-1.733-3.51-1.599-3.72-1.106z\"/><path fill=\"#191919\" d=\"M56.827 17.017c-.224.557 2.109 1.308 2.739 1.862.805.711.875 2.031 1.739 1.51.592-.351.075-1.18-.931-2.302-1.469-1.645-3.337-1.54-3.547-1.07z\"/><path fill=\"#1E1E1E\" d=\"M56.985 17.08c-.222.53 1.968 1.24 2.59 1.784.784.691.854 1.954 1.676 1.458.571-.338.058-1.147-.894-2.209-1.386-1.554-3.162-1.48-3.372-1.033z\"/><path fill=\"#232323\" d=\"M57.143 17.144c-.222.501 1.827 1.172 2.441 1.706.764.67.833 1.877 1.615 1.407.55-.324.04-1.114-.856-2.117-1.305-1.465-2.99-1.421-3.2-.996z\"/><path fill=\"#282828\" d=\"M57.301 17.208c-.22.473 1.686 1.103 2.291 1.627.744.65.814 1.799 1.555 1.355.528-.311.022-1.08-.82-2.024-1.223-1.375-2.816-1.362-3.026-.958z\"/><path fill=\"#2D2D2D\" d=\"M57.459 17.272c-.22.445 1.544 1.034 2.141 1.548.724.629.792 1.722 1.492 1.304.508-.297.005-1.046-.783-1.931-1.138-1.286-2.64-1.303-2.85-.921z\"/><path fill=\"#333\" d=\"M57.616 17.335c-.217.417 1.404.965 1.992 1.469.704.609.772 1.645 1.431 1.253.486-.284-.013-1.013-.747-1.838-1.055-1.196-2.466-1.243-2.676-.884z\"/><path fill=\"#383838\" d=\"M57.774 17.398c-.216.389 1.263.897 1.842 1.391.683.589.752 1.568 1.369 1.202.465-.27-.03-.979-.709-1.746-.972-1.106-2.292-1.183-2.502-.847z\"/><path fill=\"#3D3D3D\" d=\"M57.931 17.461c-.214.361 1.123.829 1.692 1.313.663.568.732 1.49 1.308 1.149.444-.256-.048-.945-.672-1.652-.89-1.017-2.117-1.124-2.328-.81z\"/><path fill=\"#424242\" d=\"M58.089 17.525c-.212.333.982.76 1.542 1.234.642.547.712 1.413 1.247 1.098.423-.243-.065-.912-.636-1.56-.807-.926-1.942-1.064-2.153-.772z\"/><path fill=\"#474747\" d=\"M58.248 17.589c-.211.305.84.691 1.392 1.155.622.527.691 1.336 1.186 1.047.401-.229-.083-.878-.599-1.466-.725-.838-1.77-1.006-1.979-.736z\"/><path fill=\"#4C4C4C\" d=\"M58.406 17.652c-.21.278.698.624 1.242 1.078.602.506.671 1.258 1.124.995.381-.216-.1-.845-.561-1.374-.643-.748-1.596-.946-1.805-.699z\"/><path fill=\"#515151\" d=\"M58.563 17.715c-.208.25.558.555 1.093.999.582.486.652 1.181 1.063.944.359-.202-.118-.811-.525-1.281-.559-.658-1.42-.887-1.631-.662z\"/><path fill=\"#565656\" d=\"M58.72 17.779c-.206.221.418.486.944.92.562.465.63 1.104 1.001.893.338-.189-.135-.777-.487-1.188-.477-.569-1.247-.828-1.458-.625z\"/><path fill=\"#5B5B5B\" d=\"M58.877 17.843c-.204.193.277.417.794.841.542.445.611 1.027.94.841.317-.176-.152-.744-.45-1.095-.394-.479-1.072-.768-1.284-.587z\"/><path fill=\"#606060\" d=\"M59.036 17.906c-.204.166.136.349.644.763.521.425.591.95.878.791.296-.162-.17-.71-.413-1.002-.312-.391-.899-.71-1.109-.552z\"/><path fill=\"#666\" d=\"M59.194 17.969c-.202.137-.006.281.494.685.501.404.571.872.816.739.275-.149-.188-.677-.376-.91-.228-.3-.724-.65-.934-.514z\"/><path d=\"M72.173 16.444c-.024.349.953.558 1.581.791.628.209 1.859 1.046 2.441 1.697.581.627 1.836 2.487 2.116 1.999.278-.441-.651-1.72-.907-2.255-.255-.535-1.045-1.697-2.301-2.092-1.094-.326-2.907-.419-2.93-.14z\"/><path fill=\"#060606\" d=\"M72.273 16.469c-.023.338.926.543 1.536.771.611.204 1.807 1.021 2.372 1.654.564.611 1.786 2.419 2.058 1.946.271-.429-.625-1.67-.884-2.194-.257-.524-1.025-1.644-2.244-2.034-1.061-.322-2.815-.415-2.838-.143z\"/><path fill=\"#0C0C0C\" d=\"M72.372 16.494c-.023.33.899.529 1.491.751.593.199 1.755.995 2.302 1.61.547.595 1.738 2.351 2.002 1.893.262-.416-.599-1.62-.862-2.133-.26-.513-1.004-1.59-2.188-1.977-1.026-.318-2.723-.408-2.745-.144z\"/><path fill=\"#131313\" d=\"M72.472 16.518c-.023.32.873.516 1.446.732.576.194 1.702.968 2.233 1.567.53.578 1.688 2.283 1.944 1.839.254-.403-.573-1.571-.84-2.072-.264-.502-.983-1.537-2.13-1.918-.992-.314-2.631-.404-2.653-.148z\"/><path fill=\"#191919\" d=\"M72.572 16.543c-.023.31.845.502 1.402.712.558.19 1.649.943 2.164 1.524.512.562 1.639 2.215 1.887 1.786.248-.39-.547-1.521-.817-2.011-.266-.491-.961-1.483-2.074-1.861-.96-.31-2.54-.399-2.562-.15z\"/><path fill=\"#1F1F1F\" d=\"M72.672 16.568c-.023.3.817.487 1.358.692.54.185 1.596.918 2.093 1.481.494.545 1.589 2.146 1.831 1.732.237-.376-.522-1.471-.796-1.95-.269-.479-.94-1.43-2.017-1.803-.926-.305-2.447-.393-2.469-.152z\"/><path fill=\"#262626\" d=\"M72.77 16.592c-.022.291.792.474 1.314.673.523.18 1.545.893 2.025 1.438.477.529 1.54 2.079 1.772 1.679.231-.364-.495-1.421-.773-1.89-.271-.468-.919-1.376-1.96-1.745-.891-.301-2.356-.387-2.378-.155z\"/><path fill=\"#2C2C2C\" d=\"M72.87 16.617c-.021.282.765.46 1.27.654.504.175 1.492.867 1.955 1.394.46.512 1.49 2.011 1.716 1.626.222-.351-.47-1.372-.751-1.829-.273-.457-.898-1.323-1.904-1.687-.859-.298-2.264-.383-2.286-.158z\"/><path fill=\"#333\" d=\"M72.97 16.642c-.022.272.737.446 1.226.634.487.17 1.439.841 1.886 1.351.442.496 1.44 1.942 1.658 1.573.214-.338-.445-1.322-.729-1.768-.276-.446-.878-1.27-1.846-1.629-.827-.294-2.173-.378-2.195-.161z\"/><path fill=\"#393939\" d=\"M73.07 16.667c-.021.263.712.432 1.181.615.47.166 1.387.815 1.817 1.308.425.479 1.39 1.875 1.601 1.519.207-.324-.418-1.271-.706-1.707-.279-.436-.856-1.216-1.789-1.571-.794-.291-2.083-.374-2.104-.164z\"/><path fill=\"#3F3F3F\" d=\"M73.17 16.691c-.022.253.684.418 1.136.595.453.161 1.335.79 1.747 1.265.408.463 1.342 1.806 1.545 1.466.197-.312-.393-1.222-.685-1.646-.281-.424-.834-1.162-1.731-1.513-.761-.287-1.991-.369-2.012-.167z\"/><path fill=\"#464646\" d=\"M73.269 16.716c-.021.243.658.404 1.092.576.435.155 1.282.764 1.678 1.221.391.447 1.292 1.738 1.488 1.413.189-.299-.367-1.172-.663-1.585-.284-.414-.814-1.109-1.676-1.455-.726-.283-1.899-.364-1.919-.17z\"/><path fill=\"#4C4C4C\" d=\"M73.369 16.741c-.021.234.629.39 1.047.557.417.15 1.229.738 1.608 1.178.373.43 1.243 1.67 1.43 1.359.182-.286-.341-1.122-.64-1.525-.287-.402-.792-1.055-1.619-1.397-.691-.279-1.806-.359-1.826-.172z\"/><path fill=\"#525252\" d=\"M73.469 16.766c-.021.223.604.375 1.002.536.4.146 1.178.713 1.54 1.135.356.414 1.194 1.602 1.375 1.306.172-.273-.315-1.072-.618-1.464-.29-.391-.772-1.002-1.563-1.339-.66-.274-1.716-.353-1.736-.174z\"/><path fill=\"#595959\" d=\"M73.569 16.791c-.021.214.576.362.958.517.382.141 1.125.687 1.47 1.091.338.397 1.144 1.534 1.316 1.253.166-.26-.29-1.022-.596-1.403-.291-.38-.75-.949-1.504-1.282-.627-.27-1.624-.348-1.644-.176z\"/><path fill=\"#5F5F5F\" d=\"M73.669 16.815c-.021.205.549.348.913.498.365.135 1.072.662 1.401 1.049.32.38 1.094 1.465 1.258 1.199.158-.247-.262-.973-.573-1.342-.294-.368-.73-.895-1.448-1.223-.592-.267-1.532-.344-1.551-.181z\"/><path fill=\"#666\" d=\"M73.768 16.84c-.02.194.522.333.869.478.347.131 1.019.636 1.332 1.005.303.364 1.043 1.397 1.201 1.146.15-.234-.237-.922-.551-1.281-.296-.358-.708-.841-1.391-1.166-.559-.263-1.441-.338-1.46-.182z\"/><path fill=\"#6C6C6C\" d=\"M73.868 16.865c-.021.185.495.32.825.458.329.126.967.61 1.261.961.286.348.995 1.329 1.146 1.093.141-.221-.211-.873-.529-1.22-.299-.347-.688-.788-1.334-1.108-.528-.258-1.35-.333-1.369-.184z\"/><path fill=\"#727272\" d=\"M73.968 16.889c-.021.176.468.306.779.439.312.122.914.584 1.192.919.27.331.946 1.261 1.088 1.039.133-.208-.186-.823-.506-1.16-.302-.335-.667-.734-1.277-1.05-.494-.254-1.258-.327-1.276-.187z\"/><path fill=\"#797979\" d=\"M74.068 16.914c-.021.167.441.292.735.419.294.117.861.559 1.123.876.251.315.896 1.193 1.031.986.124-.194-.161-.773-.484-1.098-.305-.324-.646-.681-1.221-.992-.46-.251-1.166-.324-1.184-.191z\"/><path fill=\"#7F7F7F\" d=\"M74.167 16.939c-.02.157.415.278.691.4.277.111.809.533 1.054.832.234.298.846 1.125.974.933.117-.182-.135-.724-.462-1.038-.308-.313-.625-.628-1.164-.934-.427-.247-1.075-.318-1.093-.193z\"/><path fill=\"#995900\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.462 3.742-10.042 6.183-4.511 3.091-6.067 4.464-7.532 5.927-2.278 2.279-4.44 3.045-7.904 3.045s-5.021-.72-6.09-1.674c-1.07-.93-2.254-3.301-2.139-6.834.093-3.511 1.208-6.719 1.744-12.182.232-2.348.208-5.253.208-7.833 0-3.255.047-6.021.745-6.439 1.255-.79 1.534-.836 3.021-.836s2.162.092 2.65.581c.464.464.279 1.534.116 3.045-.14 1.511.582 1.999 1.302 2.627.721.604 1.372 1.372 3.65 1.558 2.278.162 3.114-.209 4.184-.884 1.07-.674 2.58-1.882 3.139-2.58.534-.674 1.859-2.999 2.115-2.999.232 0 1.767-.534 2.627.721z\"/><path fill=\"#9E5E00\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.496 3.73-10.093 6.136-4.483 3.025-6.104 4.372-7.594 5.78-2.231 2.176-4.331 2.933-7.721 2.912-3.361-.016-4.881-.704-5.945-1.653-1.064-.925-2.237-3.218-2.135-6.644.066-3.503 1.194-6.678 1.696-12.036.216-2.382.132-5.263.109-7.87-.025-3.25-.024-6.014.673-6.432 1.255-.789 1.534-.837 3.021-.837s2.164.094 2.65.581c.481.481.248 1.578.066 3.037-.204 1.504.471 2.094 1.226 2.779.755.665 1.449 1.443 3.723 1.621 2.335.156 3.234-.269 4.315-1.002 1.066-.713 2.509-1.905 3.071-2.637.53-.689 1.849-3.031 2.105-3.031.232.001 1.767-.533 2.627.722z\"/><path fill=\"#A36400\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.53 3.719-10.143 6.09-4.456 2.958-6.14 4.279-7.657 5.632-2.186 2.074-4.221 2.82-7.54 2.778-3.258-.03-4.74-.688-5.8-1.632-1.06-.92-2.219-3.134-2.131-6.453.04-3.496 1.18-6.637 1.65-11.891.198-2.417.053-5.275.007-7.906-.049-3.248-.093-6.007.602-6.425 1.255-.788 1.535-.837 3.021-.837 1.488 0 2.165.095 2.65.581.498.498.217 1.621.017 3.029-.268 1.497.36 2.189 1.147 2.931.791.726 1.528 1.516 3.799 1.686 2.392.149 3.352-.328 4.445-1.123 1.062-.75 2.438-1.929 3.003-2.694.526-.703 1.839-3.062 2.094-3.062.235.001 1.77-.533 2.63.722z\"/><path fill=\"#A86A00\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.563 3.707-10.193 6.043-4.43 2.894-6.175 4.188-7.72 5.485-2.139 1.971-4.112 2.707-7.356 2.644-3.157-.045-4.599-.671-5.655-1.611-1.056-.916-2.203-3.049-2.128-6.262.012-3.489 1.167-6.596 1.604-11.745.18-2.453-.024-5.285-.094-7.942-.074-3.244-.163-6 .531-6.418 1.255-.787 1.534-.836 3.021-.836s2.166.096 2.65.581c.513.515.185 1.664-.034 3.021-.332 1.49.25 2.285 1.072 3.083.825.786 1.604 1.588 3.873 1.75 2.449.142 3.471-.388 4.574-1.243 1.059-.79 2.368-1.953 2.936-2.751.521-.716 1.828-3.092 2.084-3.092.234-.002 1.769-.536 2.629.719z\"/><path fill=\"#AD7000\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.597 3.695-10.243 5.997-4.403 2.827-6.211 4.096-7.783 5.337-2.092 1.869-4.002 2.594-7.174 2.511-3.054-.061-4.458-.656-5.508-1.59-1.051-.912-2.186-2.966-2.125-6.072-.013-3.483 1.153-6.556 1.558-11.601.163-2.487-.102-5.295-.194-7.979-.098-3.24-.233-5.993.46-6.411 1.255-.786 1.534-.836 3.021-.836s2.167.097 2.65.58c.53.531.154 1.707-.083 3.013-.396 1.483.14 2.38.995 3.235.86.847 1.683 1.661 3.947 1.813 2.507.135 3.59-.446 4.706-1.362 1.056-.827 2.296-1.976 2.869-2.808.516-.729 1.817-3.124 2.074-3.124.229.002 1.764-.532 2.624.723z\"/><path fill=\"#B27500\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.631 3.684-10.292 5.951-4.376 2.761-6.247 4.004-7.846 5.19-2.046 1.767-3.894 2.481-6.991 2.376-2.952-.075-4.318-.639-5.364-1.568-1.045-.907-2.167-2.883-2.121-5.881-.041-3.477 1.139-6.516 1.511-11.456.145-2.522-.181-5.306-.296-8.014-.123-3.238-.303-5.986.389-6.405 1.255-.784 1.534-.836 3.021-.836s2.167.099 2.65.581c.546.547.122 1.75-.133 3.005-.459 1.476.029 2.476.918 3.388.895.907 1.76 1.731 4.021 1.877 2.562.128 3.708-.505 4.835-1.482 1.053-.866 2.227-1.999 2.801-2.865.512-.744 1.808-3.155 2.063-3.155.233-.001 1.768-.535 2.628.72z\"/><path fill=\"#B77B00\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.665 3.673-10.342 5.904-4.35 2.695-6.283 3.913-7.909 5.042-1.999 1.665-3.785 2.369-6.809 2.243-2.849-.091-4.178-.623-5.218-1.548-1.042-.902-2.15-2.799-2.119-5.69-.067-3.468 1.125-6.475 1.465-11.31.128-2.557-.258-5.316-.397-8.05-.147-3.233-.373-5.979.317-6.397 1.256-.783 1.535-.836 3.022-.836 1.487 0 2.168.1 2.649.581.563.563.091 1.793-.184 2.997-.523 1.469-.081 2.571.842 3.541.929.967 1.838 1.803 4.096 1.941 2.621.121 3.827-.565 4.966-1.602 1.049-.904 2.155-2.022 2.734-2.922.506-.758 1.796-3.187 2.052-3.187.234-.002 1.769-.536 2.629.719z\"/><path fill=\"#BC8100\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.699 3.661-10.392 5.858-4.323 2.628-6.32 3.821-7.972 4.895-1.953 1.562-3.675 2.256-6.626 2.11-2.748-.106-4.037-.607-5.074-1.528-1.037-.897-2.132-2.715-2.114-5.5-.094-3.461 1.111-6.434 1.419-11.165.11-2.592-.336-5.326-.499-8.086-.171-3.23-.442-5.972.248-6.391 1.255-.782 1.534-.837 3.021-.837s2.17.102 2.65.581c.579.579.059 1.836-.233 2.988-.587 1.462-.192 2.667.765 3.693.964 1.028 1.917 1.876 4.17 2.005 2.676.114 3.944-.625 5.095-1.722 1.045-.942 2.083-2.045 2.667-2.979.502-.772 1.786-3.218 2.042-3.218.232.001 1.767-.533 2.627.722z\"/><path fill=\"#C18700\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.733 3.649-10.442 5.811-4.296 2.563-6.356 3.729-8.035 4.748-1.906 1.46-3.565 2.144-6.443 1.976-2.646-.121-3.896-.59-4.929-1.507-1.032-.892-2.116-2.63-2.111-5.309-.121-3.454 1.097-6.393 1.372-11.018.093-2.627-.414-5.338-.6-8.123-.196-3.227-.512-5.965.176-6.383 1.256-.781 1.535-.837 3.022-.837 1.487 0 2.171.103 2.649.581.596.596.029 1.878-.283 2.98-.651 1.455-.302 2.761.688 3.845.999 1.088 1.994 1.948 4.244 2.069 2.734.107 4.063-.684 5.226-1.841 1.042-.981 2.013-2.069 2.599-3.036.498-.786 1.776-3.25 2.032-3.25.234-.001 1.769-.535 2.629.72z\"/><path fill=\"#C68C00\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.766 3.637-10.492 5.764-4.269 2.496-6.392 3.638-8.097 4.6-1.86 1.357-3.457 2.03-6.261 1.843-2.544-.137-3.756-.575-4.783-1.486-1.028-.888-2.098-2.548-2.107-5.12-.147-3.447 1.083-6.352 1.325-10.873.076-2.662-.491-5.347-.701-8.158-.22-3.223-.581-5.958.106-6.376 1.255-.78 1.534-.836 3.021-.836s2.172.103 2.65.58c.612.612-.004 1.921-.333 2.972-.716 1.448-.413 2.857.612 3.998 1.034 1.148 2.071 2.02 4.319 2.132 2.79.1 4.181-.742 5.356-1.961 1.038-1.019 1.942-2.092 2.532-3.093.492-.8 1.765-3.281 2.021-3.281.231 0 1.766-.534 2.626.721z\"/><path fill=\"#CC9200\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.8 3.626-10.542 5.718-4.243 2.43-6.428 3.545-8.16 4.452-1.813 1.255-3.347 1.917-6.078 1.708-2.441-.151-3.615-.558-4.637-1.464-1.023-.883-2.081-2.465-2.105-4.929-.173-3.44 1.07-6.312 1.278-10.728.059-2.697-.569-5.358-.801-8.194-.245-3.22-.65-5.952.035-6.37 1.255-.779 1.534-.836 3.021-.836s2.173.104 2.65.58c.628.628-.035 1.964-.384 2.964-.779 1.441-.523 2.952.535 4.15 1.07 1.209 2.15 2.092 4.394 2.197 2.847.093 4.3-.802 5.485-2.081 1.035-1.057 1.871-2.116 2.465-3.149.488-.814 1.754-3.313 2.011-3.313.232 0 1.767-.534 2.627.721z\"/><path fill=\"#D19800\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.833 3.614-10.593 5.671-4.215 2.363-6.463 3.454-8.222 4.305-1.767 1.153-3.238 1.805-5.896 1.575-2.338-.167-3.474-.542-4.492-1.444-1.019-.879-2.064-2.381-2.101-4.738-.202-3.433 1.056-6.271 1.231-10.583.041-2.731-.647-5.368-.902-8.229-.27-3.216-.721-5.944-.037-6.363 1.255-.777 1.535-.836 3.021-.836 1.488 0 2.176.105 2.65.581.645.644-.066 2.008-.434 2.957-.842 1.434-.632 3.047.459 4.301 1.104 1.27 2.228 2.164 4.468 2.26 2.905.086 4.419-.861 5.617-2.2 1.031-1.096 1.8-2.138 2.397-3.207.483-.828 1.744-3.344 2-3.344.233-.001 1.768-.535 2.628.72z\"/><path fill=\"#D69E00\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.868 3.603-10.642 5.625-4.189 2.297-6.5 3.362-8.286 4.157-1.719 1.051-3.128 1.692-5.713 1.441-2.236-.181-3.334-.525-4.348-1.422-1.013-.874-2.045-2.296-2.097-4.547-.228-3.426 1.042-6.229 1.187-10.438.023-2.766-.725-5.379-1.005-8.267-.292-3.212-.79-5.937-.106-6.355 1.255-.776 1.534-.836 3.021-.836s2.177.106 2.65.581c.66.66-.098 2.051-.484 2.948-.906 1.428-.743 3.143.381 4.454 1.14 1.33 2.306 2.236 4.542 2.325 2.962.079 4.538-.921 5.747-2.32a16.361 16.361 0 0 0 2.329-3.263c.478-.842 1.733-3.376 1.99-3.376.233-.002 1.768-.536 2.628.719z\"/><path fill=\"#DBA300\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.9 3.591-10.691 5.578-4.164 2.231-6.537 3.27-8.348 4.01-1.675.948-3.02 1.579-5.533 1.307-2.134-.196-3.192-.509-4.201-1.402-1.009-.869-2.028-2.213-2.093-4.356-.255-3.42 1.027-6.189 1.139-10.293.006-2.801-.803-5.39-1.105-8.302-.317-3.209-.86-5.93-.179-6.349 1.256-.775 1.535-.836 3.022-.836 1.487 0 2.177.107 2.649.581.677.677-.128 2.094-.533 2.94-.971 1.42-.854 3.238.304 4.606 1.174 1.39 2.384 2.308 4.617 2.388 3.019.072 4.656-.979 5.876-2.44 1.024-1.173 1.659-2.186 2.263-3.321.474-.855 1.723-3.406 1.979-3.406.233 0 1.768-.534 2.628.721z\"/><path fill=\"#E0A900\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.935 3.58-10.743 5.532-4.135 2.165-6.571 3.178-8.41 3.862-1.627.846-2.91 1.467-5.349 1.174-2.032-.211-3.052-.493-4.056-1.381-1.005-.865-2.011-2.129-2.09-4.166-.282-3.413 1.015-6.149 1.093-10.147-.011-2.835-.881-5.4-1.206-8.338-.342-3.205-.93-5.923-.25-6.342 1.255-.774 1.535-.837 3.021-.837 1.488 0 2.179.109 2.65.581.693.693-.161 2.136-.583 2.932-1.034 1.413-.964 3.333.229 4.758 1.208 1.451 2.461 2.381 4.69 2.453 3.076.066 4.775-1.039 6.008-2.559 1.02-1.211 1.587-2.209 2.194-3.379.469-.869 1.712-3.437 1.969-3.437.232-.001 1.767-.535 2.627.72z\"/><path fill=\"#E5AF00\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-6.968 3.568-10.792 5.485-4.108 2.098-6.607 3.086-8.473 3.714-1.581.744-2.801 1.353-5.167 1.04-1.93-.227-2.912-.477-3.911-1.36-1-.86-1.994-2.046-2.087-3.976-.307-3.405 1-6.107 1.046-10.001-.029-2.871-.959-5.411-1.307-8.375-.366-3.202-1-5.916-.32-6.334 1.256-.773 1.535-.836 3.022-.836 1.487 0 2.18.11 2.649.581.709.709-.191 2.18-.632 2.924-1.099 1.406-1.076 3.428.15 4.911 1.244 1.511 2.54 2.453 4.765 2.516 3.133.058 4.894-1.098 6.137-2.679 1.017-1.25 1.517-2.232 2.128-3.435.465-.883 1.702-3.47 1.958-3.47.233 0 1.768-.534 2.628.721z\"/><path fill=\"#EAB500\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-7.002 3.557-10.842 5.439-4.083 2.032-6.643 2.994-8.536 3.566-1.534.642-2.691 1.241-4.985.907-1.826-.242-2.77-.46-3.765-1.339-.995-.855-1.976-1.962-2.083-3.785-.335-3.398.986-6.067.999-9.856-.046-2.906-1.036-5.422-1.408-8.411-.391-3.199-1.07-5.91-.391-6.328 1.256-.772 1.535-.837 3.022-.837 1.487 0 2.181.112 2.649.581.726.726-.222 2.223-.684 2.915-1.162 1.399-1.185 3.524.075 5.063 1.278 1.572 2.617 2.525 4.84 2.581 3.189.051 5.012-1.158 6.267-2.798 1.014-1.289 1.446-2.255 2.06-3.492.46-.898 1.692-3.501 1.948-3.501.233 0 1.768-.534 2.628.721z\"/><path fill=\"#EFBA00\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-7.035 3.544-10.892 5.393-4.056 1.965-6.68 2.902-8.598 3.418-1.488.54-2.583 1.129-4.802.773-1.725-.256-2.63-.444-3.622-1.318-.989-.85-1.958-1.878-2.079-3.593-.361-3.392.972-6.027.953-9.711-.064-2.941-1.115-5.432-1.51-8.447-.414-3.195-1.139-5.902-.462-6.32 1.256-.77 1.535-.837 3.022-.837 1.487 0 2.182.113 2.649.581.743.742-.254 2.266-.732 2.907-1.227 1.394-1.296 3.62-.003 5.216 1.313 1.632 2.696 2.597 4.915 2.644 3.246.045 5.13-1.216 6.397-2.918 1.01-1.326 1.374-2.278 1.992-3.548.455-.912 1.682-3.533 1.937-3.533.234-.002 1.769-.536 2.629.719z\"/><path fill=\"#F4C000\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-7.069 3.533-10.942 5.347-4.029 1.899-6.716 2.81-8.662 3.271-1.441.437-2.473 1.016-4.619.639-1.623-.272-2.49-.428-3.476-1.297-.986-.847-1.941-1.794-2.076-3.404-.389-3.384.957-5.985.907-9.565-.082-2.976-1.194-5.442-1.612-8.482-.439-3.192-1.208-5.896-.533-6.314 1.256-.769 1.535-.836 3.022-.836 1.487 0 2.183.114 2.649.581.759.758-.285 2.308-.782 2.899-1.291 1.386-1.407 3.714-.08 5.368 1.348 1.692 2.773 2.669 4.988 2.708 3.303.037 5.249-1.276 6.527-3.039 1.007-1.364 1.305-2.301 1.925-3.605.451-.925 1.671-3.563 1.927-3.563.236-.003 1.771-.537 2.631.718z\"/><path fill=\"#F9C600\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-7.103 3.521-10.992 5.299-4.001 1.833-6.752 2.719-8.725 3.124-1.394.335-2.364.904-4.436.505-1.521-.287-2.349-.411-3.33-1.276-.981-.842-1.924-1.711-2.072-3.213-.415-3.377.944-5.945.86-9.42-.099-3.011-1.27-5.453-1.711-8.519-.464-3.188-1.279-5.888-.604-6.307 1.255-.768 1.534-.836 3.021-.836s2.185.115 2.65.581c.773.774-.317 2.351-.833 2.891-1.354 1.378-1.517 3.81-.156 5.52 1.383 1.753 2.851 2.741 5.062 2.771 3.361.031 5.368-1.335 6.658-3.157 1.003-1.403 1.233-2.324 1.857-3.663.447-.939 1.662-3.595 1.917-3.595.233 0 1.768-.534 2.628.721z\"/><path fill=\"#fc0\" d=\"M107.74 86.485c1.441 2.092-.047 4.812 1 6.486 1.72 2.743 5.184 5.508 6.509 6.276.953.581 2.301 1.139 2.254 2.836-.07 1.93-1.023 2.44-1.557 2.976-1.07 1.069-7.137 3.51-11.042 5.253-3.976 1.767-6.788 2.627-8.788 2.976-1.348.233-2.254.79-4.254.372-1.418-.302-2.208-.396-3.184-1.255-.976-.836-1.906-1.627-2.069-3.022-.442-3.371.93-5.905.813-9.275-.116-3.045-1.348-5.463-1.813-8.554-.488-3.185-1.348-5.882-.673-6.3 1.255-.767 1.534-.836 3.021-.836s2.186.116 2.65.58c.791.791-.349 2.395-.883 2.883-1.418 1.372-1.628 3.905-.233 5.671 1.418 1.814 2.929 2.813 5.138 2.837 3.417.023 5.485-1.395 6.787-3.278 1-1.442 1.164-2.348 1.791-3.72.442-.953 1.65-3.625 1.906-3.625.232-.002 1.767-.536 2.627.719zm-21.751 4.273c-.229-.084-1.27-4.911-.708-5.244 1.082-.645 1.373-.749 2.704-.749 1.333 0 1.956.104 2.372.52.687.687-.374 2.164-.79 2.581-1.206 1.185-3.349 2.974-3.578 2.892z\"/><path fill=\"#FFCC02\" d=\"M86.063 90.604c-.249-.106-1.324-4.752-.764-5.083 1.08-.643 1.381-.713 2.686-.713 1.333 0 1.93.087 2.352.518.679.689-.361 2.121-.774 2.535-1.204 1.181-3.256 2.843-3.5 2.743z\"/><path fill=\"#FFCC05\" d=\"M86.137 90.449c-.268-.126-1.379-4.593-.822-4.922 1.078-.64 1.39-.678 2.669-.678 1.333 0 1.904.069 2.331.514.673.693-.348 2.08-.758 2.491-1.201 1.178-3.16 2.714-3.42 2.595z\"/><path fill=\"#FFCC07\" d=\"M86.211 90.296c-.289-.149-1.435-4.436-.879-4.762 1.076-.639 1.398-.644 2.651-.644 1.333 0 1.877.052 2.31.511.667.696-.333 2.039-.741 2.445-1.197 1.177-3.066 2.586-3.341 2.45z\"/><path fill=\"#FFCD0A\" d=\"M86.285 90.142c-.309-.171-1.49-4.278-.936-4.603 1.074-.637 1.406-.608 2.633-.608 1.332 0 1.851.034 2.29.507.661.7-.321 1.998-.725 2.402-1.195 1.173-2.971 2.456-3.262 2.302z\"/><path fill=\"#FFCD0C\" d=\"M86.358 89.987c-.327-.193-1.545-4.119-.993-4.442 1.071-.635 1.414-.572 2.615-.572 1.333 0 1.825.016 2.268.504.655.703-.307 1.956-.707 2.357-1.191 1.17-2.876 2.326-3.183 2.153z\"/><path fill=\"#FFCD0F\" d=\"M86.432 89.834c-.347-.214-1.6-3.962-1.051-4.282 1.07-.632 1.423-.537 2.599-.537 1.332 0 1.799-.002 2.247.501.649.706-.292 1.915-.691 2.311-1.188 1.167-2.782 2.196-3.104 2.007z\"/><path fill=\"#FFCD11\" d=\"M86.506 89.679c-.368-.236-1.656-3.802-1.108-4.122 1.067-.63 1.431-.501 2.581-.501 1.332 0 1.773-.02 2.227.498.643.708-.281 1.873-.675 2.267-1.185 1.164-2.687 2.065-3.025 1.858z\"/><path fill=\"#FFCE14\" d=\"M86.58 89.526c-.386-.259-1.71-3.646-1.165-3.962 1.064-.629 1.44-.466 2.562-.466 1.331 0 1.748-.037 2.206.495.637.711-.267 1.831-.658 2.223-1.181 1.161-2.591 1.935-2.945 1.71z\"/><path fill=\"#FFCE16\" d=\"M86.654 89.372c-.407-.279-1.765-3.487-1.223-3.801 1.064-.626 1.448-.431 2.546-.431 1.331 0 1.722-.055 2.185.492.631.714-.252 1.789-.641 2.177-1.179 1.158-2.498 1.806-2.867 1.563z\"/><path fill=\"#FFCE19\" d=\"M86.727 89.218c-.426-.302-1.82-3.329-1.279-3.641 1.061-.625 1.456-.396 2.528-.396 1.331 0 1.695-.073 2.164.489.625.718-.239 1.748-.624 2.133-1.176 1.155-2.403 1.675-2.789 1.415z\"/><path fill=\"#FFCE1C\" d=\"M86.802 89.064c-.446-.323-1.876-3.171-1.337-3.48 1.059-.622 1.465-.36 2.511-.36 1.331 0 1.669-.09 2.143.486.618.721-.226 1.707-.608 2.088-1.173 1.15-2.31 1.544-2.709 1.266z\"/><path fill=\"#FFCF1E\" d=\"M86.875 88.91c-.466-.344-1.931-3.012-1.393-3.32 1.056-.621 1.473-.325 2.492-.325 1.332 0 1.644-.108 2.123.482.612.725-.212 1.665-.591 2.043-1.17 1.149-2.215 1.416-2.631 1.12z\"/><path fill=\"#FFCF21\" d=\"M86.949 88.756c-.486-.367-1.986-2.854-1.451-3.161 1.055-.618 1.481-.289 2.475-.289 1.331 0 1.618-.126 2.102.48.605.727-.2 1.622-.575 1.998-1.167 1.146-2.119 1.285-2.551.972z\"/><path fill=\"#FFCF23\" d=\"M87.023 88.602c-.505-.389-2.041-2.697-1.508-3 1.053-.616 1.489-.254 2.457-.254 1.331 0 1.592-.144 2.081.477.599.73-.186 1.582-.558 1.955-1.164 1.14-2.025 1.153-2.472.822z\"/><path fill=\"#FFCF26\" d=\"M87.097 88.448c-.525-.411-2.096-2.538-1.565-2.839 1.051-.614 1.498-.219 2.44-.219 1.331 0 1.565-.161 2.06.473.593.733-.171 1.54-.541 1.909-1.162 1.139-1.931 1.025-2.394.676z\"/><path fill=\"#FFD028\" d=\"M87.171 88.294c-.545-.433-2.152-2.381-1.623-2.681 1.049-.612 1.506-.182 2.422-.182 1.331 0 1.54-.18 2.039.47.587.735-.158 1.498-.524 1.863-1.158 1.137-1.836.896-2.314.53z\"/><path fill=\"#FFD02B\" d=\"M87.244 88.14c-.565-.455-2.207-2.222-1.68-2.52 1.046-.609 1.514-.147 2.404-.147 1.331 0 1.513-.197 2.018.468.58.739-.145 1.455-.508 1.818-1.153 1.134-1.739.764-2.234.381z\"/><path fill=\"#FFD02D\" d=\"M87.318 87.985c-.584-.476-2.261-2.062-1.737-2.359 1.045-.607 1.523-.112 2.387-.112 1.331 0 1.487-.215 1.997.464.575.743-.131 1.414-.491 1.774-1.151 1.132-1.646.635-2.156.233z\"/><path fill=\"#FFD030\" d=\"M87.392 87.832c-.604-.498-2.317-1.905-1.794-2.199 1.042-.606 1.531-.077 2.368-.077 1.332 0 1.462-.232 1.977.461.568.746-.117 1.372-.475 1.729-1.147 1.128-1.551.506-2.076.086z\"/><path fill=\"#FFD133\" d=\"M87.466 87.678c-.624-.52-2.372-1.748-1.851-2.039 1.04-.603 1.54-.042 2.351-.042 1.331 0 1.435-.25 1.956.458.561.749-.104 1.331-.458 1.685-1.145 1.125-1.457.375-1.998-.062z\"/><path fill=\"#fc0\" d=\"M107.461 86.758c1.208 1.763-.02 4.12.853 5.526-2.199-2.021-3.209-2.852-6.24.119.833-1.208 1.011-2.021 1.526-3.169.356-.792 1.406-3.09 1.624-3.09.198 0 1.525-.436 2.237.614z\"/><path fill=\"#FFCC02\" d=\"M107.449 86.77c1.181 1.722.012 4.068.833 5.4-2.153-1.969-3.141-2.798-6.105.104.781-1.139.977-1.968 1.487-3.097.362-.795 1.37-3.003 1.599-3.006.202-.003 1.49-.426 2.186.599z\"/><path fill=\"#FFCC05\" d=\"M107.436 86.782c1.152 1.682.042 4.016.812 5.273-2.106-1.917-3.074-2.745-5.971.089.732-1.069.944-1.916 1.449-3.025.368-.797 1.334-2.917 1.574-2.923.208-.005 1.456-.415 2.136.586z\"/><path fill=\"#FFCC07\" d=\"M107.424 86.794c1.124 1.643.074 3.966.793 5.146-2.062-1.865-3.005-2.69-5.835.075.681-1.001.91-1.863 1.41-2.954.375-.799 1.298-2.829 1.549-2.839.211-.006 1.419-.404 2.083.572z\"/><path fill=\"#FFCD0A\" d=\"M107.411 86.806c1.096 1.602.104 3.915.773 5.021-2.016-1.814-2.939-2.636-5.702.061.632-.933.877-1.812 1.373-2.883.379-.801 1.263-2.743 1.523-2.755.216-.01 1.386-.395 2.033.556z\"/><path fill=\"#FFCD0C\" d=\"M107.399 86.818c1.067 1.562.136 3.863.754 4.894-1.971-1.763-2.871-2.583-5.567.046.581-.863.843-1.76 1.334-2.812.385-.803 1.227-2.655 1.497-2.671.221-.011 1.35-.384 1.982.543z\"/><path fill=\"#FFCD0F\" d=\"M107.386 86.83c1.04 1.521.167 3.812.735 4.767-1.926-1.711-2.804-2.528-5.434.032.531-.794.811-1.708 1.296-2.74.391-.806 1.19-2.569 1.472-2.588.226-.013 1.317-.373 1.931.529z\"/><path fill=\"#FFCD11\" d=\"M107.374 86.843c1.011 1.48.197 3.759.715 4.639-1.88-1.658-2.736-2.473-5.299.017.481-.725.776-1.654 1.257-2.668.397-.808 1.154-2.482 1.446-2.504.231-.015 1.282-.362 1.881.516z\"/><path fill=\"#FFCE14\" d=\"M107.361 86.855c.983 1.44.229 3.708.695 4.513-1.834-1.607-2.667-2.419-5.164.003.431-.656.744-1.603 1.221-2.597.402-.811 1.118-2.395 1.42-2.421.235-.017 1.246-.351 1.828.502z\"/><path fill=\"#FFCE16\" d=\"M107.348 86.867c.955 1.399.26 3.657.676 4.387-1.788-1.555-2.601-2.365-5.029-.012.38-.587.709-1.551 1.181-2.526.409-.812 1.083-2.308 1.395-2.336.24-.02 1.212-.341 1.777.487z\"/><path fill=\"#FFCE19\" d=\"M107.336 86.879c.926 1.359.292 3.605.657 4.26-1.743-1.503-2.533-2.311-4.896-.026.33-.518.678-1.498 1.144-2.454.414-.815 1.047-2.222 1.37-2.253.244-.022 1.175-.332 1.725.473z\"/><path fill=\"#FFCE1C\" d=\"M107.324 86.891c.897 1.319.321 3.554.637 4.133-1.697-1.452-2.465-2.257-4.761-.041.28-.449.644-1.446 1.105-2.383.421-.817 1.011-2.134 1.345-2.168.248-.024 1.14-.32 1.674.459z\"/><path fill=\"#FFCF1E\" d=\"M107.311 86.904c.869 1.277.352 3.502.618 4.006-1.653-1.4-2.398-2.204-4.627-.056.229-.379.61-1.393 1.068-2.31.425-.819.974-2.048 1.319-2.087.252-.024 1.105-.309 1.622.447z\"/><path fill=\"#FFCF21\" d=\"M107.298 86.915c.841 1.238.384 3.451.599 3.88-1.606-1.349-2.33-2.148-4.494-.07.18-.31.577-1.342 1.03-2.239.432-.821.938-1.96 1.294-2.002.258-.027 1.071-.299 1.571.431z\"/><path fill=\"#FFCF23\" d=\"M107.286 86.927c.813 1.198.415 3.401.578 3.754-1.561-1.298-2.262-2.095-4.358-.084.129-.243.544-1.29.99-2.168.438-.824.903-1.875 1.27-1.919.261-.029 1.035-.289 1.52.417z\"/><path fill=\"#FFCF26\" d=\"M107.273 86.939c.786 1.157.446 3.349.559 3.628-1.515-1.245-2.195-2.042-4.225-.099.079-.173.51-1.237.953-2.096.443-.826.867-1.787 1.244-1.835.267-.034 1.001-.279 1.469.402z\"/><path fill=\"#FFD028\" d=\"M107.261 86.952c.756 1.117.476 3.297.539 3.501-1.47-1.194-2.127-1.987-4.089-.114.029-.104.477-1.185.914-2.024.449-.828.831-1.701 1.217-1.751.272-.035.967-.269 1.419.388z\"/><path fill=\"#FFD02B\" d=\"M107.248 86.963c.729 1.077.508 3.246.52 3.375-1.425-1.142-2.06-1.933-3.956-.127-.021-.036.443-1.133.876-1.954.455-.83.795-1.613 1.192-1.668.277-.037.933-.257 1.368.374z\"/><path fill=\"#FFD02D\" d=\"M107.235 86.976c.702 1.036.54 3.194.501 3.248-1.379-1.091-1.992-1.879-3.821-.142-.072.033.41-1.082.838-1.883.46-.833.758-1.526 1.167-1.583.281-.04.897-.248 1.315.36z\"/><path fill=\"#FFD030\" d=\"M107.223 86.987c.671.996.571 3.144.481 3.122-1.334-1.039-1.925-1.825-3.688-.157-.122.103.377-1.03.8-1.81.466-.835.723-1.44 1.142-1.501.286-.041.862-.236 1.265.346z\"/><path fill=\"#FFD133\" d=\"M107.21 87c.645.956.602 3.092.462 2.996-1.289-.988-1.857-1.771-3.554-.171-.172.171.344-.978.762-1.74.472-.837.688-1.352 1.117-1.417.291-.044.827-.227 1.213.332z\"/><path fill=\"#fc0\" d=\"M108.46 93.25c1.93 2.534 5.51 5.253 6.788 5.998.929.535 2.278 1.162 2.254 2.836-.047 1.906-1.023 2.44-1.557 2.976-1.07 1.069-7.161 3.533-11.042 5.253-3.952 1.743-6.812 2.65-8.788 2.976-1.325.209-2.278.767-4.254.372-1.395-.279-2.231-.418-3.184-1.255-.953-.813-1.93-1.674-2.069-3.022-.396-3.348 1.186-5.462 2.719-8.369 1.255-2.325 3.789-2.79 5.37-2.58 5.672.767 5.3-2.79 6.857-4.347 1.443-1.443 5.558-2.606 6.906-.838z\"/><path fill=\"#FFCC02\" d=\"M108.443 93.272c1.925 2.529 5.497 5.242 6.772 5.983.928.534 2.272 1.16 2.25 2.83-.047 1.902-1.021 2.435-1.555 2.969-1.066 1.066-7.212 3.549-11.054 5.194-3.958 1.671-6.666 2.542-8.654 2.893-1.316.221-2.311.773-4.28.38-1.39-.276-2.186-.398-3.134-1.231-.949-.811-1.858-1.602-1.997-2.944-.391-3.338 1.087-5.378 2.598-8.282 1.255-2.381 3.806-2.723 5.38-2.51 5.655.779 5.233-2.893 6.787-4.447 1.437-1.436 5.542-2.597 6.887-.835z\"/><path fill=\"#FFCC05\" d=\"M108.428 93.297c1.92 2.522 5.482 5.229 6.756 5.969.925.532 2.267 1.157 2.244 2.823-.047 1.897-1.019 2.43-1.551 2.962-1.064 1.064-7.266 3.565-11.068 5.135-3.964 1.599-6.521 2.435-8.519 2.809-1.309.233-2.343.779-4.308.388-1.383-.273-2.137-.377-3.083-1.206-.944-.807-1.788-1.53-1.924-2.866-.387-3.329.987-5.293 2.474-8.194 1.256-2.438 3.825-2.657 5.392-2.442 5.636.792 5.164-2.996 6.714-4.545 1.435-1.435 5.529-2.592 6.873-.833z\"/><path fill=\"#FFCC07\" d=\"M108.41 93.321c1.916 2.515 5.47 5.216 6.74 5.955.923.531 2.263 1.154 2.239 2.816-.046 1.893-1.015 2.424-1.546 2.954-1.062 1.062-7.319 3.582-11.081 5.078-3.971 1.525-6.378 2.325-8.386 2.725-1.299.244-2.376.785-4.334.396-1.379-.27-2.089-.355-3.033-1.18-.94-.804-1.717-1.459-1.852-2.787-.382-3.321.888-5.209 2.352-8.107 1.256-2.495 3.842-2.59 5.402-2.373 5.618.805 5.097-3.1 6.643-4.646 1.432-1.431 5.517-2.586 6.856-.831z\"/><path fill=\"#FFCD0A\" d=\"M108.393 93.344c1.911 2.51 5.458 5.205 6.724 5.941.921.53 2.256 1.151 2.233 2.81-.046 1.887-1.013 2.417-1.543 2.947-1.059 1.06-7.372 3.598-11.093 5.018-3.977 1.453-6.234 2.218-8.253 2.642-1.29.256-2.408.791-4.361.404-1.372-.268-2.042-.334-2.982-1.155-.935-.801-1.646-1.388-1.779-2.71-.378-3.312.79-5.124 2.229-8.02 1.256-2.551 3.86-2.524 5.413-2.304 5.602.817 5.029-3.202 6.571-4.745 1.43-1.427 5.505-2.578 6.841-.828z\"/><path fill=\"#FFCD0C\" d=\"M108.376 93.368c1.907 2.504 5.445 5.192 6.708 5.927.919.528 2.251 1.148 2.228 2.802-.046 1.884-1.011 2.413-1.54 2.941-1.057 1.056-7.425 3.613-11.106 4.959-3.983 1.379-6.088 2.109-8.119 2.558-1.281.268-2.44.797-4.387.412-1.367-.264-1.995-.313-2.931-1.13-.931-.798-1.575-1.315-1.707-2.632-.374-3.302.689-5.038 2.106-7.932 1.257-2.607 3.878-2.458 5.423-2.234 5.583.83 4.961-3.304 6.5-4.844 1.427-1.424 5.493-2.573 6.825-.827z\"/><path fill=\"#FFCD0F\" d=\"M108.36 93.391c1.903 2.498 5.432 5.179 6.693 5.913.916.527 2.247 1.146 2.223 2.796-.045 1.879-1.008 2.406-1.535 2.934-1.055 1.054-7.479 3.63-11.119 4.9-3.99 1.308-5.945 2.002-7.985 2.476-1.273.278-2.472.802-4.414.42-1.362-.262-1.947-.293-2.881-1.105-.926-.795-1.503-1.245-1.635-2.554-.369-3.294.591-4.954 1.984-7.845 1.258-2.664 3.896-2.392 5.435-2.166 5.564.843 4.892-3.408 6.429-4.944 1.419-1.421 5.475-2.566 6.805-.825z\"/><path fill=\"#FFCD11\" d=\"M108.344 93.415c1.897 2.492 5.418 5.167 6.676 5.899.914.525 2.24 1.143 2.217 2.789-.046 1.875-1.006 2.4-1.532 2.926-1.052 1.053-7.53 3.646-11.132 4.842-3.996 1.234-5.8 1.893-7.852 2.392-1.264.29-2.504.808-4.44.427-1.355-.259-1.9-.272-2.829-1.08-.922-.792-1.433-1.173-1.562-2.476-.366-3.285.491-4.869 1.86-7.758 1.258-2.72 3.913-2.325 5.445-2.096 5.547.855 4.825-3.511 6.356-5.043 1.419-1.417 5.466-2.56 6.793-.822z\"/><path fill=\"#FFCE14\" d=\"M108.326 93.438c1.893 2.486 5.406 5.155 6.66 5.885.912.524 2.235 1.14 2.212 2.783-.046 1.87-1.003 2.395-1.528 2.92-1.05 1.049-7.584 3.662-11.145 4.783-4.003 1.161-5.656 1.784-7.718 2.307-1.256.303-2.537.815-4.467.436-1.351-.255-1.853-.25-2.779-1.054-.917-.79-1.362-1.102-1.49-2.398-.36-3.276.394-4.784 1.738-7.671 1.259-2.778 3.931-2.259 5.456-2.026 5.529.867 4.757-3.615 6.285-5.144 1.416-1.414 5.453-2.554 6.776-.821z\"/><path fill=\"#FFCE16\" d=\"M108.31 93.462c1.889 2.48 5.393 5.143 6.644 5.871.91.523 2.23 1.138 2.208 2.776-.046 1.866-1.001 2.389-1.525 2.912-1.047 1.047-7.636 3.679-11.158 4.724-4.008 1.089-5.511 1.677-7.584 2.225-1.247.315-2.57.821-4.494.444-1.345-.253-1.805-.23-2.729-1.029-.912-.786-1.29-1.03-1.417-2.32-.356-3.267.293-4.699 1.616-7.583 1.258-2.833 3.949-2.192 5.466-1.958 5.512.881 4.689-3.717 6.214-5.242 1.411-1.412 5.439-2.55 6.759-.82z\"/><path fill=\"#FFCE19\" d=\"M108.293 93.485c1.884 2.475 5.38 5.13 6.628 5.857.908.522 2.226 1.135 2.202 2.77-.045 1.861-.998 2.383-1.52 2.905-1.045 1.044-7.69 3.694-11.17 4.665-4.015 1.016-5.367 1.568-7.451 2.141-1.239.327-2.603.828-4.521.453-1.339-.25-1.758-.209-2.678-1.005-.909-.783-1.219-.958-1.345-2.242-.352-3.258.195-4.615 1.494-7.497 1.258-2.89 3.965-2.125 5.476-1.888 5.495.893 4.621-3.821 6.142-5.342 1.408-1.407 5.426-2.541 6.743-.817z\"/><path fill=\"#FFCE1C\" d=\"M108.276 93.509c1.88 2.469 5.367 5.118 6.613 5.842.905.521 2.219 1.133 2.196 2.764-.046 1.856-.997 2.377-1.517 2.898-1.042 1.042-7.743 3.71-11.184 4.607-4.021.942-5.222 1.46-7.316 2.057-1.23.338-2.635.833-4.547.46-1.334-.248-1.711-.188-2.627-.979-.904-.78-1.148-.888-1.272-2.165-.348-3.249.095-4.529 1.37-7.409 1.26-2.947 3.984-2.059 5.488-1.819 5.477.905 4.554-3.923 6.071-5.441 1.403-1.404 5.411-2.535 6.725-.815z\"/><path fill=\"#FFCF1E\" d=\"M108.26 93.532c1.875 2.462 5.354 5.106 6.597 5.829.904.52 2.213 1.129 2.191 2.756-.045 1.853-.994 2.372-1.514 2.892-1.039 1.039-7.794 3.726-11.196 4.547-4.026.87-5.077 1.352-7.184 1.974-1.221.351-2.665.839-4.572.468-1.328-.245-1.664-.167-2.577-.954-.899-.777-1.078-.816-1.2-2.086-.344-3.239-.005-4.445 1.248-7.322 1.259-3.004 4-1.993 5.498-1.75 5.458.918 4.487-4.028 6-5.541 1.4-1.399 5.398-2.529 6.709-.813z\"/><path fill=\"#FFCF21\" d=\"M108.243 93.556c1.87 2.457 5.341 5.094 6.58 5.814.902.518 2.208 1.127 2.187 2.75-.045 1.849-.992 2.367-1.51 2.885-1.037 1.037-7.849 3.742-11.209 4.488-4.033.797-4.934 1.245-7.05 1.891-1.213.361-2.698.844-4.599.476-1.323-.241-1.617-.146-2.526-.929-.895-.774-1.007-.744-1.128-2.008-.34-3.231-.103-4.36 1.125-7.234 1.26-3.061 4.019-1.927 5.508-1.682 5.442.931 4.418-4.129 5.928-5.64 1.398-1.397 5.386-2.524 6.694-.811z\"/><path fill=\"#FFCF23\" d=\"M108.226 93.58c1.866 2.451 5.328 5.081 6.564 5.8.9.517 2.203 1.125 2.181 2.743-.045 1.843-.99 2.361-1.507 2.877-1.034 1.034-7.901 3.759-11.222 4.431-4.04.725-4.788 1.136-6.917 1.808-1.204.373-2.73.85-4.625.484-1.318-.239-1.57-.126-2.476-.904-.891-.771-.935-.672-1.055-1.93-.335-3.222-.202-4.275 1.002-7.148 1.261-3.116 4.038-1.86 5.519-1.611 5.424.943 4.351-4.233 5.858-5.74 1.395-1.395 5.374-2.519 6.678-.81z\"/><path fill=\"#FFCF26\" d=\"M108.21 93.604c1.861 2.445 5.315 5.069 6.548 5.786.897.516 2.198 1.122 2.175 2.736-.044 1.839-.986 2.354-1.502 2.871-1.032 1.031-7.955 3.774-11.235 4.37-4.045.652-4.644 1.029-6.783 1.724-1.196.385-2.763.857-4.652.493-1.312-.236-1.522-.105-2.425-.88-.886-.767-.865-.601-.982-1.851-.332-3.213-.302-4.19.879-7.06 1.26-3.174 4.055-1.794 5.529-1.543 5.406.956 4.283-4.336 5.785-5.838 1.392-1.391 5.362-2.514 6.663-.808z\"/><path fill=\"#FFD028\" d=\"M108.192 93.628c1.858 2.438 5.303 5.055 6.534 5.772.894.514 2.192 1.118 2.17 2.729-.045 1.835-.985 2.349-1.499 2.863-1.03 1.03-8.007 3.791-11.249 4.312-4.052.579-4.499.92-6.648 1.641-1.188.396-2.796.862-4.68.499-1.307-.232-1.474-.083-2.374-.854-.882-.765-.793-.529-.91-1.774-.327-3.204-.401-4.105.758-6.973 1.26-3.23 4.071-1.728 5.54-1.473 5.388.968 4.215-4.44 5.714-5.938 1.387-1.387 5.347-2.506 6.644-.804z\"/><path fill=\"#FFD02B\" d=\"M108.176 93.651c1.852 2.433 5.289 5.043 6.516 5.758.894.513 2.188 1.116 2.165 2.723-.044 1.831-.981 2.344-1.495 2.857-1.027 1.026-8.061 3.807-11.261 4.253-4.058.506-4.354.812-6.515 1.557-1.178.408-2.828.868-4.706.508-1.301-.23-1.427-.063-2.323-.829-.877-.762-.722-.458-.837-1.696-.324-3.195-.5-4.02.633-6.886 1.262-3.286 4.09-1.661 5.551-1.404 5.371.982 4.147-4.542 5.642-6.038 1.385-1.384 5.336-2.5 6.63-.803z\"/><path fill=\"#FFD02D\" d=\"M108.159 93.675c1.848 2.426 5.276 5.031 6.501 5.743.89.513 2.182 1.114 2.159 2.717-.044 1.826-.979 2.338-1.491 2.85-1.025 1.024-8.114 3.823-11.273 4.194-4.064.434-4.21.704-6.382 1.474-1.169.42-2.86.875-4.732.517-1.296-.228-1.38-.042-2.273-.805-.872-.759-.652-.386-.764-1.618-.319-3.186-.599-3.936.511-6.799 1.262-3.343 4.107-1.595 5.562-1.335 5.353.994 4.08-4.646 5.571-6.137 1.379-1.38 5.32-2.494 6.611-.801z\"/><path fill=\"#FFD030\" d=\"M108.143 93.698c1.843 2.421 5.263 5.02 6.485 5.73.888.511 2.176 1.11 2.154 2.709-.045 1.822-.978 2.332-1.488 2.843-1.022 1.022-8.167 3.839-11.287 4.136-4.069.361-4.065.596-6.248 1.391-1.161.431-2.892.88-4.759.524-1.29-.225-1.332-.021-2.221-.779-.868-.756-.581-.314-.693-1.54-.314-3.177-.698-3.851.389-6.711 1.262-3.399 4.125-1.529 5.572-1.266 5.335 1.006 4.011-4.749 5.5-6.236 1.376-1.378 5.307-2.489 6.596-.801z\"/><path fill=\"#FFD133\" d=\"M108.125 93.722c1.839 2.414 5.251 5.007 6.47 5.715.886.51 2.171 1.108 2.148 2.703-.044 1.817-.975 2.326-1.484 2.836-1.019 1.019-8.22 3.855-11.299 4.076-4.077.288-3.921.487-6.114 1.308-1.153.443-2.925.886-4.785.531-1.285-.221-1.285 0-2.171-.753-.864-.754-.51-.244-.621-1.462-.311-3.168-.797-3.766.266-6.624 1.263-3.457 4.143-1.462 5.583-1.197 5.317 1.019 3.944-4.852 5.429-6.336 1.372-1.373 5.294-2.481 6.578-.797z\"/><path fill=\"#995900\" d=\"M26.657 90.065c-2.093 1.511-7.393 1.371-8.741 3.138-1.325 1.767.047 4.324.023 9.066 0 2.023-.348 3.558-.581 4.789-.325 1.558-.535 2.651.116 3.766 1.187 1.977 3.091 2.465 13.995 4.743 5.834 1.208 11.344 4.347 15.04 4.649 3.696.279 4.487-.953 6.742-2.952 2.231-1.999 2.952-1.372 2.882-5.765-.069-4.37-2.882-5.672-6.067-10.717-3.185-5.044-3.695-5.974-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.046-2.976.977-4.162 2.186-1.186 1.208-2.651 4.276-4.742 5.787z\"/><path fill=\"#9E5E00\" d=\"M26.689 90.158c-2.065 1.518-7.256 1.223-8.737 3.071-1.341 1.749.074 4.287.032 9.026-.008 2.011-.372 3.513-.625 4.803-.335 1.573-.542 2.647.113 3.751 1.222 1.99 3.129 2.3 14.03 4.574 5.832 1.207 11.153 4.296 14.963 4.557 3.611.255 4.379-.913 6.607-2.893 2.226-2 2.913-1.381 2.859-5.62-.024-4.365-2.682-5.602-5.866-10.646-3.185-5.043-3.696-5.974-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.046-2.975.977-4.162 2.186-1.184 1.209-2.631 4.351-4.708 5.881z\"/><path fill=\"#A36400\" d=\"M26.723 90.251c-2.038 1.525-7.12 1.075-8.733 3.004-1.357 1.729.101 4.249.04 8.985-.016 2.001-.395 3.47-.669 4.818-.343 1.588-.549 2.646.11 3.736 1.259 2.003 3.168 2.136 14.065 4.407 5.828 1.205 10.961 4.245 14.885 4.464 3.527.232 4.272-.874 6.472-2.834 2.223-2.001 2.876-1.39 2.839-5.475.02-4.361-2.48-5.531-5.666-10.575-3.185-5.043-3.695-5.974-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.046-2.976.977-4.162 2.186s-2.616 4.426-4.676 5.974z\"/><path fill=\"#A86A00\" d=\"M26.757 90.344c-2.012 1.532-6.984.925-8.73 2.936-1.374 1.711.127 4.212.048 8.944-.025 1.991-.419 3.428-.714 4.834-.354 1.603-.556 2.644.106 3.721 1.297 2.018 3.207 1.972 14.103 4.24 5.824 1.202 10.769 4.193 14.807 4.371 3.441.209 4.166-.835 6.337-2.775 2.217-2.002 2.837-1.399 2.816-5.329.066-4.356-2.28-5.46-5.464-10.504-3.185-5.043-3.696-5.974-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.046-2.975.977-4.162 2.186-1.185 1.208-2.597 4.499-4.641 6.066z\"/><path fill=\"#AD7000\" d=\"M26.791 90.437c-1.985 1.539-6.849.777-8.727 2.869-1.39 1.693.154 4.175.056 8.904-.033 1.981-.441 3.384-.757 4.849-.362 1.618-.563 2.642.102 3.707 1.334 2.031 3.245 1.808 14.138 4.072 5.821 1.2 10.577 4.142 14.729 4.277 3.357.186 4.059-.795 6.203-2.715 2.212-2.003 2.798-1.409 2.793-5.183.112-4.353-2.079-5.389-5.263-10.434-3.185-5.044-3.696-5.975-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.047-2.975.976-4.162 2.185-1.184 1.208-2.579 4.573-4.606 6.159z\"/><path fill=\"#B27500\" d=\"M26.825 90.53c-1.959 1.545-6.713.627-8.724 2.802-1.406 1.673.181 4.137.064 8.861-.041 1.971-.465 3.342-.802 4.864-.371 1.634-.569 2.639.1 3.691 1.372 2.046 3.283 1.645 14.174 3.905 5.818 1.197 10.385 4.092 14.651 4.185 3.272.162 3.952-.756 6.067-2.657 2.208-2.005 2.76-1.418 2.772-5.039.157-4.347-1.877-5.318-5.062-10.362-3.186-5.043-3.696-5.974-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.046-2.975.977-4.162 2.186-1.184 1.21-2.561 4.649-4.572 6.254z\"/><path fill=\"#B77B00\" d=\"M26.859 90.622c-1.932 1.554-6.577.479-8.72 2.734-1.423 1.655.207 4.1.072 8.822-.049 1.959-.488 3.299-.846 4.879-.381 1.648-.576 2.637.095 3.676 1.409 2.06 3.322 1.481 14.211 3.737 5.814 1.196 10.193 4.042 14.573 4.092 3.188.14 3.845-.716 5.933-2.596 2.204-2.007 2.723-1.428 2.75-4.894.203-4.342-1.676-5.247-4.861-10.292-3.186-5.043-3.696-5.974-5.812-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.906-.046-2.976.977-4.162 2.186-1.185 1.21-2.545 4.725-4.539 6.346z\"/><path fill=\"#BC8100\" d=\"M26.892 90.716c-1.905 1.56-6.441.33-8.716 2.667-1.439 1.636.233 4.063.08 8.782-.057 1.948-.511 3.254-.89 4.893-.39 1.664-.583 2.634.092 3.661 1.446 2.074 3.36 1.317 14.247 3.57 5.811 1.193 10.002 3.989 14.495 3.998 3.103.117 3.738-.676 5.798-2.537 2.199-2.007 2.684-1.436 2.728-4.748.248-4.338-1.475-5.175-4.66-10.22s-3.696-5.975-5.812-9.322c-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.047-2.975.976-4.162 2.185-1.185 1.209-2.527 4.797-4.506 6.439z\"/><path fill=\"#C18700\" d=\"M26.926 90.808c-1.878 1.567-6.304.182-8.713 2.6-1.455 1.618.261 4.026.089 8.74-.065 1.939-.535 3.212-.935 4.909-.399 1.679-.59 2.632.089 3.646 1.483 2.087 3.398 1.153 14.282 3.403 5.806 1.19 9.81 3.938 14.417 3.905 3.018.093 3.631-.636 5.664-2.478 2.194-2.008 2.645-1.446 2.705-4.603.292-4.333-1.274-5.105-4.458-10.149-3.186-5.044-3.696-5.975-5.812-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.906-.047-2.976.976-4.162 2.186-1.186 1.208-2.51 4.872-4.472 6.531z\"/><path fill=\"#C68C00\" d=\"M26.959 90.901c-1.85 1.574-6.167.033-8.709 2.531-1.471 1.6.288 3.989.097 8.7-.074 1.929-.558 3.169-.979 4.924-.409 1.694-.598 2.63.085 3.63 1.521 2.102 3.438.99 14.319 3.236 5.804 1.188 9.618 3.887 14.339 3.813 2.933.07 3.524-.599 5.528-2.419 2.189-2.009 2.606-1.455 2.684-4.458.338-4.328-1.073-5.034-4.258-10.079-3.185-5.044-3.695-5.975-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.047-2.976.976-4.162 2.186-1.185 1.21-2.493 4.948-4.439 6.626z\"/><path fill=\"#CC9200\" d=\"M26.993 90.994c-1.825 1.581-6.032-.116-8.706 2.465-1.488 1.581.313 3.952.104 8.659-.082 1.917-.582 3.127-1.023 4.939-.419 1.708-.604 2.628.081 3.615 1.558 2.115 3.476.825 14.355 3.068 5.8 1.186 9.426 3.836 14.262 3.719 2.847.046 3.417-.558 5.393-2.359 2.186-2.011 2.569-1.464 2.662-4.312.384-4.324-.871-4.963-4.057-10.007-3.185-5.044-3.695-5.975-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.047-2.976.976-4.162 2.185s-2.474 5.022-4.404 6.718z\"/><path fill=\"#D19800\" d=\"M27.027 91.088c-1.798 1.588-5.896-.264-8.702 2.397-1.504 1.562.34 3.914.113 8.618-.089 1.907-.604 3.083-1.067 4.955-.428 1.724-.611 2.625.078 3.6 1.595 2.131 3.514.662 14.39 2.901 5.797 1.184 9.235 3.785 14.184 3.626 2.763.023 3.311-.518 5.259-2.299 2.181-2.013 2.53-1.475 2.64-4.167.429-4.32-.67-4.893-3.856-9.938-3.185-5.043-3.695-5.974-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.046-2.976.977-4.162 2.186s-2.458 5.096-4.372 6.811z\"/><path fill=\"#D69E00\" d=\"M27.06 91.181c-1.771 1.595-5.76-.414-8.698 2.329-1.521 1.544.367 3.877.12 8.578-.097 1.897-.626 3.04-1.111 4.97-.437 1.74-.618 2.623.075 3.585 1.631 2.145 3.551.498 14.426 2.734 5.793 1.181 9.043 3.733 14.106 3.533 2.678 0 3.204-.479 5.123-2.241 2.177-2.013 2.493-1.483 2.618-4.021.475-4.314-.469-4.821-3.654-9.866-3.185-5.044-3.695-5.975-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.047-2.976.976-4.162 2.185s-2.441 5.169-4.338 6.904z\"/><path fill=\"#DBA300\" d=\"M27.095 91.273c-1.745 1.603-5.625-.562-8.696 2.262-1.536 1.525.395 3.84.129 8.537-.104 1.886-.65 2.997-1.154 4.984-.447 1.755-.626 2.62.071 3.57 1.668 2.157 3.59.333 14.463 2.566 5.789 1.178 8.851 3.682 14.028 3.44 2.592-.023 3.097-.439 4.988-2.182 2.172-2.015 2.454-1.493 2.596-3.876.519-4.311-.27-4.751-3.454-9.796-3.185-5.044-3.696-5.975-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.047-2.975.976-4.162 2.186-1.185 1.211-2.423 5.247-4.303 6.999z\"/><path fill=\"#E0A900\" d=\"M27.128 91.366c-1.718 1.609-5.488-.711-8.692 2.195-1.553 1.507.42 3.803.137 8.496-.114 1.876-.673 2.955-1.199 5-.455 1.77-.632 2.618.068 3.555 1.706 2.171 3.628.17 14.499 2.399 5.786 1.177 8.659 3.632 13.95 3.348 2.509-.047 2.99-.399 4.854-2.122 2.167-2.016 2.415-1.502 2.573-3.732.565-4.305-.067-4.68-3.253-9.724-3.185-5.043-3.695-5.974-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.046-2.976.977-4.162 2.186-1.185 1.209-2.405 5.318-4.27 7.089z\"/><path fill=\"#E5AF00\" d=\"M27.162 91.459c-1.691 1.616-5.353-.859-8.689 2.128-1.569 1.488.447 3.766.146 8.455-.123 1.865-.697 2.912-1.244 5.015-.465 1.785-.639 2.616.063 3.541 1.744 2.184 3.667.005 14.535 2.231 5.783 1.174 8.468 3.58 13.873 3.254 2.423-.07 2.882-.361 4.718-2.063 2.162-2.017 2.377-1.512 2.552-3.586.609-4.3.132-4.609-3.052-9.653-3.185-5.043-3.696-5.974-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.046-2.975.977-4.162 2.186-1.183 1.209-2.386 5.393-4.234 7.182z\"/><path fill=\"#EAB500\" d=\"M27.196 91.553c-1.665 1.622-5.217-1.009-8.685 2.06-1.585 1.469.474 3.728.154 8.415-.131 1.855-.72 2.868-1.288 5.03-.474 1.8-.647 2.614.061 3.524 1.78 2.2 3.706-.158 14.571 2.064 5.779 1.172 8.276 3.529 13.794 3.162 2.338-.093 2.775-.32 4.584-2.004 2.157-2.018 2.338-1.52 2.529-3.44.656-4.296.334-4.539-2.85-9.583-3.185-5.043-3.696-5.974-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.046-2.975.977-4.161 2.186-1.186 1.209-2.372 5.467-4.203 7.276z\"/><path fill=\"#EFBA00\" d=\"M27.229 91.646c-1.638 1.63-5.081-1.157-8.682 1.992-1.602 1.451.502 3.692.162 8.375-.138 1.845-.744 2.826-1.331 5.045-.484 1.815-.654 2.611.057 3.509 1.817 2.213 3.743-.321 14.607 1.896 5.775 1.17 8.083 3.478 13.715 3.069 2.254-.116 2.669-.281 4.45-1.944 2.153-2.02 2.301-1.53 2.508-3.296.701-4.291.535-4.466-2.649-9.511-3.185-5.044-3.696-5.975-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.047-2.975.976-4.162 2.185-1.185 1.21-2.354 5.543-4.169 7.37z\"/><path fill=\"#F4C000\" d=\"M27.263 91.739c-1.61 1.635-4.944-1.307-8.678 1.924-1.618 1.433.528 3.654.169 8.334-.146 1.834-.768 2.782-1.376 5.061-.493 1.83-.661 2.609.053 3.494 1.855 2.227 3.782-.486 14.644 1.729 5.772 1.167 7.892 3.427 13.639 2.976 2.168-.14 2.562-.242 4.314-1.885 2.147-2.02 2.262-1.54 2.485-3.15.747-4.287.736-4.396-2.448-9.441-3.185-5.043-3.696-5.974-5.812-9.322-2.115-3.301-6.299-9.298-8.694-9.368-1.906-.046-2.975.977-4.162 2.186-1.184 1.209-2.335 5.616-4.134 7.462z\"/><path fill=\"#F9C600\" d=\"M27.296 91.831c-1.584 1.644-4.808-1.455-8.674 1.857-1.633 1.413.555 3.618.179 8.294-.156 1.823-.791 2.739-1.421 5.075-.502 1.845-.667 2.606.05 3.479 1.892 2.241 3.821-.65 14.68 1.562 5.768 1.165 7.7 3.375 13.56 2.884 2.085-.163 2.456-.203 4.18-1.826 2.144-2.022 2.224-1.548 2.463-3.006.792-4.281.938-4.325-2.247-9.37-3.185-5.043-3.695-5.974-5.811-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.907-.046-2.976.977-4.162 2.186-1.186 1.21-2.32 5.691-4.103 7.555z\"/><path fill=\"#fc0\" d=\"M27.33 91.924c-1.557 1.65-4.672-1.604-8.67 1.79-1.65 1.394.581 3.58.186 8.252-.163 1.813-.813 2.697-1.464 5.091-.512 1.86-.675 2.604.046 3.464 1.93 2.255 3.859-.813 14.715 1.395 5.765 1.162 7.508 3.324 13.483 2.79 1.999-.186 2.347-.162 4.045-1.767 2.138-2.022 2.184-1.558 2.441-2.859.836-4.277 1.139-4.254-2.046-9.298-3.186-5.044-3.696-5.975-5.812-9.322-2.116-3.301-6.3-9.298-8.694-9.368-1.906-.047-2.976.976-4.162 2.185-1.185 1.209-2.301 5.765-4.068 7.647zm1.007 1.816c-1.381 1.466-5.902-.439-8.036 1.173-1.528 1.13.774 2.553.46 6.739-.125 1.59-1.234 1.883-.774 4.081.356 1.653.733 1.611 1.361 2.365 1.715 2.009 1.318.544 11.092 2.511 5.169 1.047 6.76 2.993 12.139 2.512 1.799-.167 2.135-.146 3.642-1.59 1.925-1.8.942-1.424 1.15-2.574.733-3.83.147-4.5-2.721-9.042-2.867-4.542-2.616-4.793-4.499-7.785-1.884-2.952-4.479-8.33-6.635-8.372-1.694-.042-2.679.879-3.746 1.967-1.068 1.089-1.863 6.342-3.433 8.015z\"/><path fill=\"#FFCC02\" d=\"M28.432 93.771c-1.441 1.518-6.006-.386-8.091 1.196-1.518 1.134.832 2.599.519 6.677-.129 1.58-1.205 1.897-.793 4.079.318 1.644.76 1.594 1.399 2.324 1.836 1.98 1.509.59 11.016 2.5 5.139 1.037 6.72 2.976 12.066 2.497 1.789-.166 2.092-.149 3.602-1.565 1.893-1.746.923-1.384 1.102-2.602.667-3.805.143-4.514-2.644-8.926-2.851-4.515-2.629-4.745-4.501-7.721-1.872-2.933-4.423-8.332-6.566-8.373-1.685-.042-2.663.873-3.723 1.955-1.063 1.082-1.824 6.297-3.386 7.959z\"/><path fill=\"#FFCC05\" d=\"M28.528 93.799c-1.5 1.571-6.112-.333-8.146 1.221-1.507 1.138.891 2.645.579 6.615-.134 1.57-1.176 1.91-.813 4.076.281 1.636.791 1.578 1.438 2.286 1.956 1.949 1.7.635 10.94 2.488 5.109 1.027 6.681 2.957 11.993 2.481 1.778-.164 2.048-.152 3.562-1.54 1.862-1.691.905-1.346 1.053-2.628.602-3.783.14-4.529-2.567-8.814-2.835-4.488-2.642-4.699-4.503-7.656-1.86-2.916-4.368-8.334-6.498-8.375-1.675-.041-2.647.868-3.702 1.944-1.055 1.077-1.782 6.254-3.336 7.902z\"/><path fill=\"#FFCC07\" d=\"M28.622 93.829c-1.559 1.624-6.216-.279-8.2 1.245-1.498 1.143.949 2.69.638 6.552-.137 1.562-1.146 1.925-.832 4.075.244 1.626.819 1.561 1.477 2.245 2.076 1.92 1.89.681 10.864 2.478 5.079 1.016 6.641 2.939 11.922 2.466 1.768-.162 2.005-.155 3.521-1.515 1.83-1.638.886-1.307 1.003-2.656.537-3.758.136-4.543-2.49-8.7-2.818-4.46-2.655-4.651-4.505-7.591-1.849-2.898-4.313-8.335-6.43-8.376-1.665-.041-2.63.863-3.679 1.932s-1.742 6.209-3.289 7.845z\"/><path fill=\"#FFCD0A\" d=\"M28.717 93.859c-1.618 1.676-6.321-.226-8.254 1.269-1.488 1.148 1.007 2.736.697 6.491-.142 1.553-1.117 1.938-.853 4.072.208 1.618.848 1.543 1.516 2.205 2.195 1.891 2.08.727 10.788 2.467 5.049 1.007 6.602 2.921 11.849 2.452 1.756-.16 1.962-.158 3.481-1.491 1.798-1.583.868-1.267.954-2.681.472-3.736.131-4.559-2.413-8.586-2.802-4.434-2.667-4.605-4.507-7.526-1.838-2.881-4.258-8.337-6.362-8.379-1.654-.041-2.615.859-3.656 1.92-1.042 1.061-1.7 6.162-3.24 7.787z\"/><path fill=\"#FFCD0C\" d=\"M28.813 93.888c-1.676 1.729-6.427-.173-8.309 1.293-1.478 1.151 1.063 2.781.755 6.427-.145 1.543-1.088 1.952-.871 4.07.169 1.609.876 1.527 1.555 2.166 2.315 1.861 2.269.772 10.71 2.455 5.021.997 6.563 2.904 11.778 2.437 1.745-.158 1.919-.161 3.441-1.465 1.766-1.529.849-1.229.904-2.71.407-3.711.129-4.572-2.334-8.472-2.787-4.406-2.682-4.558-4.509-7.461-1.828-2.863-4.203-8.34-6.294-8.381-1.646-.04-2.6.854-3.635 1.909s-1.659 6.121-3.191 7.732z\"/><path fill=\"#FFCD0F\" d=\"M28.908 93.917c-1.736 1.783-6.531-.119-8.363 1.319-1.467 1.156 1.123 2.827.814 6.365-.148 1.533-1.058 1.965-.89 4.067.133 1.6.905 1.51 1.594 2.126 2.435 1.833 2.461.817 10.635 2.443 4.99.987 6.523 2.886 11.705 2.422 1.735-.156 1.876-.164 3.401-1.44 1.735-1.475.83-1.189.855-2.737.341-3.687.125-4.587-2.258-8.358-2.77-4.379-2.694-4.51-4.511-7.396-1.816-2.845-4.147-8.341-6.226-8.381-1.633-.041-2.583.847-3.611 1.897-1.032 1.049-1.622 6.075-3.145 7.673z\"/><path fill=\"#FFCD11\" d=\"M29.002 93.946c-1.795 1.836-6.637-.066-8.417 1.342-1.458 1.161 1.181 2.873.874 6.303-.153 1.524-1.029 1.979-.91 4.066.096 1.59.935 1.492 1.633 2.085 2.554 1.802 2.651.863 10.558 2.432 4.96.977 6.485 2.868 11.632 2.407 1.725-.155 1.833-.167 3.361-1.415 1.703-1.421.812-1.151.806-2.764.276-3.664.121-4.603-2.182-8.245-2.754-4.352-2.707-4.464-4.513-7.332-1.804-2.828-4.091-8.343-6.157-8.383-1.625-.041-2.566.842-3.589 1.885-1.023 1.046-1.579 6.034-3.096 7.619z\"/><path fill=\"#FFCE14\" d=\"M29.097 93.975c-1.854 1.89-6.741-.013-8.473 1.367-1.447 1.165 1.239 2.918.933 6.241-.157 1.515-.999 1.993-.929 4.063.059 1.582.963 1.476 1.672 2.046 2.673 1.773 2.841.908 10.482 2.421 4.931.967 6.446 2.85 11.56 2.392 1.714-.152 1.79-.168 3.321-1.389 1.671-1.368.793-1.112.756-2.792.211-3.64.118-4.616-2.105-8.131-2.737-4.324-2.72-4.416-4.513-7.266-1.793-2.81-4.037-8.346-6.089-8.386-1.614-.04-2.551.837-3.568 1.873-1.016 1.038-1.537 5.989-3.047 7.561z\"/><path fill=\"#FFCE16\" d=\"M29.192 94.005c-1.913 1.943-6.846.041-8.526 1.391-1.438 1.169 1.297 2.964.991 6.179-.16 1.505-.969 2.006-.948 4.061.021 1.574.992 1.459 1.71 2.006 2.793 1.744 3.032.955 10.406 2.411 4.9.957 6.405 2.832 11.487 2.376 1.703-.15 1.746-.172 3.28-1.364 1.64-1.313.775-1.073.708-2.818.146-3.616.115-4.632-2.026-8.017-2.723-4.298-2.733-4.37-4.516-7.202-1.782-2.792-3.982-8.348-6.021-8.388-1.604-.039-2.535.832-3.545 1.862-1.011 1.03-1.498 5.944-3 7.503z\"/><path fill=\"#FFCE19\" d=\"M29.287 94.034c-1.972 1.996-6.951.094-8.58 1.416-1.428 1.174 1.354 3.01 1.051 6.117-.165 1.496-.94 2.02-.968 4.059-.016 1.564 1.021 1.441 1.75 1.966 2.913 1.713 3.221 1 10.33 2.398 4.87.947 6.367 2.814 11.415 2.361 1.693-.148 1.704-.174 3.24-1.339 1.608-1.258.757-1.035.658-2.845.081-3.593.111-4.646-1.95-7.904-2.706-4.271-2.747-4.322-4.517-7.136-1.771-2.776-3.927-8.349-5.954-8.389-1.594-.04-2.519.827-3.523 1.85-1.004 1.024-1.457 5.9-2.952 7.446z\"/><path fill=\"#FFCE1C\" d=\"M29.383 94.064c-2.032 2.048-7.056.147-8.636 1.439-1.417 1.178 1.414 3.056 1.11 6.055-.167 1.485-.91 2.033-.987 4.056-.053 1.556 1.05 1.425 1.788 1.926 3.034 1.685 3.412 1.046 10.254 2.388 4.841.937 6.327 2.796 11.342 2.347 1.683-.146 1.661-.177 3.2-1.314 1.577-1.205.739-.995.61-2.872.016-3.569.106-4.662-1.873-7.79-2.689-4.243-2.759-4.275-4.52-7.072-1.759-2.757-3.87-8.351-5.885-8.391-1.584-.039-2.503.822-3.501 1.839-.996 1.017-1.416 5.854-2.902 7.389z\"/><path fill=\"#FFCF1E\" d=\"M29.477 94.092c-2.089 2.102-7.161.201-8.69 1.464-1.407 1.183 1.472 3.101 1.168 5.992-.171 1.478-.881 2.048-1.006 4.056-.09 1.545 1.078 1.407 1.827 1.886 3.153 1.655 3.602 1.092 10.177 2.375 4.81.928 6.287 2.779 11.271 2.333 1.67-.145 1.617-.181 3.159-1.29 1.545-1.151.72-.957.561-2.899-.051-3.544.102-4.675-1.797-7.675-2.672-4.217-2.771-4.229-4.521-7.009-1.749-2.739-3.815-8.353-5.817-8.392-1.574-.039-2.488.816-3.478 1.827-.989 1.012-1.375 5.811-2.854 7.332z\"/><path fill=\"#FFCF21\" d=\"M29.572 94.122c-2.148 2.155-7.266.253-8.744 1.489-1.397 1.187 1.529 3.146 1.228 5.93-.176 1.467-.851 2.062-1.026 4.053-.128 1.537 1.106 1.39 1.866 1.846 3.272 1.626 3.792 1.137 10.101 2.365 4.781.917 6.248 2.761 11.199 2.317 1.659-.142 1.574-.183 3.119-1.264 1.513-1.097.701-.918.511-2.926-.116-3.521.099-4.69-1.72-7.562-2.657-4.19-2.785-4.181-4.522-6.942-1.737-2.723-3.76-8.356-5.749-8.395-1.564-.038-2.471.811-3.456 1.815-.985 1.003-1.335 5.765-2.807 7.274z\"/><path fill=\"#FFCF23\" d=\"M29.667 94.151c-2.208 2.208-7.371.307-8.798 1.514-1.388 1.19 1.586 3.192 1.286 5.867-.181 1.458-.822 2.074-1.046 4.05-.164 1.527 1.137 1.374 1.905 1.806 3.393 1.597 3.983 1.183 10.025 2.354 4.751.908 6.209 2.743 11.126 2.301 1.65-.14 1.531-.186 3.08-1.238 1.481-1.042.683-.879.462-2.954-.181-3.498.096-4.704-1.643-7.447-2.64-4.163-2.797-4.135-4.524-6.878-1.727-2.704-3.705-8.357-5.68-8.396-1.555-.039-2.456.806-3.434 1.803-.977.998-1.294 5.723-2.759 7.218z\"/><path fill=\"#FFCF26\" d=\"M29.763 94.181c-2.268 2.261-7.477.36-8.854 1.538-1.377 1.195 1.646 3.237 1.346 5.805-.184 1.448-.793 2.088-1.065 4.047-.202 1.52 1.165 1.357 1.944 1.768 3.512 1.566 4.173 1.227 9.948 2.342 4.721.897 6.169 2.726 11.054 2.288 1.639-.139 1.487-.189 3.039-1.214 1.45-.988.665-.839.412-2.979-.246-3.475.092-4.72-1.564-7.334-2.625-4.136-2.812-4.087-4.527-6.813-1.715-2.687-3.649-8.359-5.612-8.398-1.544-.038-2.44.801-3.412 1.792-.971.988-1.252 5.675-2.709 7.158z\"/><path fill=\"#FFD028\" d=\"M29.858 94.21c-2.326 2.314-7.582.414-8.908 1.562-1.367 1.2 1.704 3.283 1.405 5.743-.188 1.438-.764 2.102-1.085 4.046-.237 1.511 1.195 1.339 1.984 1.726 3.632 1.538 4.363 1.274 9.872 2.332 4.691.886 6.13 2.707 10.981 2.271 1.628-.136 1.445-.191 3-1.188 1.418-.936.646-.801.363-3.008-.312-3.45.088-4.734-1.488-7.22-2.609-4.109-2.824-4.042-4.528-6.749-1.704-2.67-3.594-8.361-5.544-8.399-1.534-.038-2.424.795-3.389 1.78-.967.984-1.215 5.634-2.663 7.104z\"/><path fill=\"#FFD02B\" d=\"M29.952 94.239c-2.385 2.367-7.686.467-8.961 1.586-1.358 1.204 1.761 3.329 1.463 5.68-.191 1.43-.733 2.116-1.103 4.043-.275 1.502 1.223 1.323 2.022 1.688 3.751 1.508 4.553 1.319 9.795 2.319 4.661.878 6.09 2.69 10.909 2.257 1.618-.135 1.401-.195 2.959-1.164 1.386-.881.627-.762.313-3.034-.375-3.427.086-4.749-1.41-7.107-2.593-4.081-2.837-3.994-4.53-6.683-1.693-2.652-3.54-8.363-5.477-8.401-1.524-.038-2.408.79-3.367 1.768-.957.979-1.171 5.591-2.613 7.048z\"/><path fill=\"#FFD02D\" d=\"M30.047 94.269c-2.444 2.419-7.791.52-9.015 1.61-1.348 1.208 1.819 3.374 1.522 5.618-.195 1.419-.705 2.129-1.123 4.042-.312 1.492 1.251 1.306 2.061 1.646 3.871 1.479 4.744 1.366 9.72 2.309 4.631.867 6.051 2.671 10.836 2.242 1.607-.133 1.358-.197 2.919-1.138 1.354-.828.609-.723.265-3.061-.441-3.402.081-4.764-1.334-6.993-2.576-4.054-2.849-3.946-4.532-6.617-1.681-2.636-3.483-8.366-5.408-8.404-1.514-.037-2.392.786-3.344 1.756-.953.972-1.132 5.544-2.567 6.99z\"/><path fill=\"#FFD030\" d=\"M30.142 94.298c-2.502 2.472-7.895.573-9.07 1.635-1.337 1.212 1.877 3.421 1.582 5.556-.199 1.41-.675 2.143-1.142 4.039-.35 1.484 1.279 1.289 2.099 1.607 3.992 1.449 4.935 1.411 9.644 2.296 4.602.858 6.012 2.655 10.765 2.228 1.596-.131 1.314-.201 2.879-1.113 1.322-.773.59-.684.214-3.088-.506-3.379.078-4.778-1.256-6.879-2.561-4.027-2.863-3.899-4.533-6.553-1.671-2.617-3.429-8.368-5.34-8.404-1.503-.038-2.375.78-3.322 1.744-.948.965-1.093 5.5-2.52 6.932z\"/><path fill=\"#FFD133\" d=\"M30.238 94.327c-2.563 2.526-8 .627-9.125 1.659-1.327 1.217 1.935 3.466 1.64 5.494-.201 1.4-.645 2.156-1.161 4.037-.387 1.474 1.309 1.272 2.139 1.567 4.11 1.419 5.125 1.456 9.567 2.286 4.571.848 5.973 2.636 10.691 2.212 1.585-.129 1.272-.203 2.839-1.088 1.291-.718.572-.645.166-3.115-.572-3.356.074-4.793-1.179-6.766-2.544-4.001-2.876-3.853-4.535-6.489-1.66-2.6-3.374-8.37-5.272-8.406-1.494-.037-2.36.774-3.3 1.733-.94.961-1.051 5.456-2.47 6.876z\"/><path d=\"M38.372 72.328c-.302.673-.558 6.462.953 8.717 1.511 2.231 1.07 3.51-.604 1.813-1.744-1.65-2.883-4.138-2.906-5.858 0-.999.768-5.114 1.07-5.556.324-.465 1.719.372 1.487.884z\"/><path fill=\"#030303\" d=\"M38.343 72.441c-.292.755-.535 6.359.972 8.609 1.506 2.229 1.029 3.387-.594 1.73-1.689-1.614-2.779-4.026-2.822-5.743-.014-1.005.721-4.978 1.011-5.421.311-.449 1.656.32 1.433.825z\"/><path fill=\"#070707\" d=\"M38.314 72.554c-.282.836-.511 6.258.99 8.503 1.502 2.225.988 3.264-.584 1.646-1.633-1.576-2.675-3.914-2.738-5.627-.028-1.011.677-4.843.954-5.287.294-.435 1.59.267 1.378.765z\"/><path fill=\"#0B0B0B\" d=\"M38.285 72.666c-.271.918-.488 6.156 1.009 8.396 1.497 2.222.947 3.141-.573 1.563-1.58-1.54-2.573-3.803-2.656-5.514-.042-1.017.632-4.706.895-5.151.282-.419 1.526.215 1.325.706z\"/><path fill=\"#0F0F0F\" d=\"M38.256 72.779c-.26 1-.465 6.053 1.028 8.29 1.492 2.217.907 3.017-.562 1.479-1.525-1.501-2.469-3.692-2.571-5.398-.056-1.023.585-4.569.836-5.016.264-.405 1.46.161 1.269.645z\"/><path fill=\"#131313\" d=\"M38.227 72.891c-.25 1.082-.442 5.952 1.046 8.183 1.488 2.214.866 2.895-.552 1.395-1.471-1.463-2.366-3.58-2.488-5.282-.07-1.029.541-4.435.78-4.882.25-.39 1.394.11 1.214.586z\"/><path fill=\"#161616\" d=\"M38.198 73.004c-.239 1.163-.418 5.849 1.065 8.076 1.483 2.211.825 2.771-.542 1.311-1.417-1.427-2.263-3.468-2.404-5.167-.084-1.034.495-4.298.721-4.747.235-.374 1.329.058 1.16.527z\"/><path fill=\"#1A1A1A\" d=\"M38.169 73.117c-.229 1.244-.396 5.747 1.083 7.969 1.478 2.207.784 2.647-.532 1.227-1.361-1.39-2.158-3.357-2.32-5.052-.098-1.04.451-4.163.663-4.612.22-.359 1.265.005 1.106.468z\"/><path fill=\"#1E1E1E\" d=\"M38.139 73.23c-.219 1.326-.371 5.645 1.102 7.862 1.474 2.204.745 2.525-.52 1.144-1.307-1.353-2.056-3.245-2.238-4.938-.11-1.046.405-4.026.605-4.477.205-.344 1.201-.047 1.051.409z\"/><path fill=\"#222\" d=\"M38.111 73.343c-.208 1.406-.349 5.542 1.121 7.755 1.469 2.201.704 2.401-.51 1.06-1.252-1.315-1.952-3.134-2.153-4.823-.125-1.052.358-3.89.546-4.342.189-.329 1.134-.099.996.35z\"/><path fill=\"#262626\" d=\"M38.081 73.455c-.197 1.488-.325 5.44 1.139 7.647 1.465 2.197.664 2.278-.499.977-1.198-1.279-1.849-3.021-2.07-4.707-.139-1.058.314-3.755.489-4.208.175-.313 1.069-.15.941.291z\"/><path fill=\"#2A2A2A\" d=\"M38.053 73.568c-.187 1.569-.302 5.337 1.158 7.541 1.46 2.193.622 2.155-.489.893-1.143-1.242-1.745-2.911-1.985-4.593-.153-1.063.268-3.618.429-4.073.159-.298 1.004-.203.887.232z\"/><path fill=\"#2D2D2D\" d=\"M38.024 73.681c-.177 1.65-.279 5.234 1.177 7.434 1.455 2.19.581 2.032-.479.809-1.088-1.204-1.642-2.799-1.902-4.477-.167-1.069.224-3.482.372-3.938.143-.284.939-.256.832.172z\"/><path fill=\"#313131\" d=\"M37.995 73.794c-.167 1.731-.257 5.133 1.194 7.326 1.451 2.187.541 1.909-.468.726-1.034-1.167-1.538-2.688-1.818-4.362-.182-1.075.178-3.346.314-3.804.129-.268.874-.307.778.114z\"/><path fill=\"#353535\" d=\"M37.966 73.906c-.155 1.813-.232 5.03 1.213 7.22 1.447 2.183.501 1.786-.457.643-.979-1.131-1.434-2.576-1.735-4.248-.194-1.081.133-3.21.256-3.668.113-.254.809-.36.723.053z\"/><path fill=\"#393939\" d=\"M37.937 74.019c-.146 1.895-.209 4.929 1.231 7.114 1.441 2.179.459 1.662-.448.558-.923-1.093-1.33-2.464-1.65-4.132-.208-1.087.088-3.074.199-3.534.098-.238.743-.413.668-.006z\"/><path fill=\"#3D3D3D\" d=\"M37.908 74.132c-.136 1.976-.187 4.825 1.25 7.005 1.436 2.176.418 1.54-.437.475-.87-1.056-1.228-2.353-1.567-4.017-.224-1.092.041-2.938.139-3.398.084-.223.68-.465.615-.065z\"/><path fill=\"#414141\" d=\"M37.878 74.245c-.124 2.057-.163 4.724 1.27 6.899 1.432 2.172.377 1.416-.427.391-.814-1.018-1.124-2.241-1.483-3.902-.237-1.099-.004-2.802.081-3.264.069-.208.614-.517.559-.124z\"/><path fill=\"#444\" d=\"M37.849 74.357c-.114 2.138-.14 4.621 1.289 6.792 1.427 2.17.336 1.293-.416.307-.761-.981-1.021-2.128-1.4-3.786-.25-1.104-.048-2.667.023-3.129.053-.193.549-.569.504-.184z\"/><path fill=\"#484848\" d=\"M37.82 74.47c-.104 2.22-.116 4.52 1.306 6.686 1.423 2.166.296 1.169-.405.223-.707-.944-.918-2.018-1.316-3.672-.265-1.11-.094-2.53-.035-2.994.039-.178.484-.622.45-.243z\"/><path fill=\"#4C4C4C\" d=\"M37.791 74.583c-.093 2.301-.093 4.416 1.325 6.579 1.418 2.162.255 1.046-.395.14-.652-.907-.814-1.906-1.233-3.557-.278-1.116-.14-2.394-.093-2.859.024-.164.419-.676.396-.303z\"/><path d=\"M38.372 72.328c1.395-3.046 2.163-6.324 4.162-9.508 1.976-3.161 1.186-4.394-.279-2.79-1.465 1.604-3.068 4.999-3.068 4.999s-1.883 2.975-2.301 6.416c-.072.58 1.253 1.371 1.486.883z\"/><path fill=\"#020202\" d=\"M38.432 72.13c1.382-3.066 2.136-6.213 4.063-9.299 1.906-3.063 1.166-4.287-.247-2.735-1.421 1.565-3.002 4.919-3.024 4.966 0 0-1.819 2.904-2.221 6.211-.066.572 1.202 1.339 1.429.857z\"/><path fill=\"#050505\" d=\"M38.492 71.933c1.368-3.088 2.11-6.104 3.966-9.09 1.835-2.965 1.146-4.181-.213-2.681-1.379 1.525-2.938 4.84-2.981 4.934 0 0-1.757 2.831-2.14 6.007-.065.563 1.147 1.305 1.368.83z\"/><path fill=\"#070707\" d=\"M38.552 71.736c1.356-3.111 2.083-5.997 3.868-8.882 1.765-2.866 1.125-4.075-.182-2.626-1.335 1.486-2.872 4.761-2.937 4.902 0 0-1.693 2.757-2.058 5.802-.062.554 1.093 1.272 1.309.804z\"/><path fill=\"#0A0A0A\" d=\"M38.612 71.54c1.342-3.132 2.058-5.888 3.771-8.674 1.693-2.768 1.104-3.968-.15-2.571-1.292 1.447-2.806 4.682-2.892 4.87 0 0-1.632 2.685-1.978 5.597-.061.543 1.039 1.239 1.249.778z\"/><path fill=\"#0C0C0C\" d=\"M38.671 71.342c1.33-3.154 2.032-5.778 3.672-8.465 1.624-2.67 1.086-3.862-.116-2.517-1.25 1.408-2.741 4.604-2.848 4.838 0 0-1.568 2.613-1.897 5.393-.057.534.986 1.205 1.189.751z\"/><path fill=\"#0F0F0F\" d=\"M38.731 71.145c1.316-3.175 2.006-5.669 3.575-8.256 1.554-2.571 1.064-3.756-.084-2.463-1.207 1.369-2.675 4.524-2.804 4.807 0 0-1.506 2.54-1.816 5.188-.055.524.931 1.171 1.129.724z\"/><path fill=\"#111\" d=\"M38.791 70.948c1.303-3.197 1.979-5.561 3.478-8.048 1.483-2.472 1.044-3.649-.052-2.408-1.164 1.33-2.61 4.446-2.76 4.774 0 0-1.443 2.468-1.735 4.985-.054.514.876 1.137 1.069.697z\"/><path fill=\"#141414\" d=\"M38.851 70.75c1.291-3.219 1.953-5.452 3.38-7.839 1.412-2.374 1.024-3.543-.019-2.354-1.122 1.291-2.545 4.367-2.718 4.742 0 0-1.379 2.395-1.653 4.78-.05.506.823 1.105 1.01.671z\"/><path fill=\"#161616\" d=\"M38.911 70.553c1.276-3.24 1.928-5.343 3.282-7.631 1.342-2.276 1.004-3.437.014-2.3-1.079 1.252-2.479 4.289-2.673 4.711 0 0-1.317 2.323-1.574 4.576-.047.495.769 1.071.951.644z\"/><path fill=\"#191919\" d=\"M38.971 70.356c1.265-3.262 1.902-5.233 3.185-7.422 1.271-2.178.984-3.331.047-2.246-1.036 1.212-2.414 4.21-2.629 4.679 0 0-1.254 2.25-1.493 4.372-.046.485.714 1.037.89.617z\"/><path fill=\"#1C1C1C\" d=\"M39.03 70.159c1.251-3.285 1.876-5.125 3.087-7.215 1.202-2.079.964-3.224.079-2.19-.992 1.173-2.348 4.13-2.584 4.646 0 0-1.192 2.178-1.412 4.167-.043.476.661 1.005.83.592z\"/><path fill=\"#1E1E1E\" d=\"M39.09 69.961c1.238-3.306 1.85-5.016 2.991-7.006 1.129-1.98.943-3.118.111-2.136-.949 1.134-2.283 4.052-2.541 4.615 0 0-1.128 2.106-1.331 3.962-.041.468.607.972.77.565z\"/><path fill=\"#212121\" d=\"M39.149 69.764c1.226-3.328 1.824-4.907 2.892-6.797 1.061-1.881.923-3.011.144-2.082-.906 1.095-2.217 3.973-2.497 4.583 0 0-1.066 2.032-1.25 3.758-.037.459.554.938.711.538z\"/><path fill=\"#232323\" d=\"M39.209 69.567c1.212-3.349 1.798-4.798 2.794-6.588.99-1.783.903-2.906.177-2.027-.863 1.055-2.151 3.894-2.453 4.551 0 0-1.003 1.96-1.17 3.553-.034.447.5.904.652.511z\"/><path fill=\"#262626\" d=\"M39.269 69.37c1.198-3.371 1.772-4.689 2.696-6.38.92-1.685.883-2.799.209-1.973-.82 1.017-2.087 3.815-2.409 4.52 0 0-.941 1.888-1.088 3.349-.032.437.445.87.592.484z\"/><path fill=\"#282828\" d=\"M39.329 69.173c1.187-3.393 1.747-4.581 2.6-6.171.848-1.587.862-2.693.242-1.918-.778.977-2.022 3.736-2.366 4.487 0 0-.876 1.815-1.007 3.144-.031.428.39.837.531.458z\"/><path fill=\"#2B2B2B\" d=\"M39.388 68.975c1.173-3.414 1.72-4.471 2.502-5.963.779-1.488.842-2.586.273-1.864-.734.938-1.956 3.657-2.321 4.456 0 0-.814 1.742-.927 2.94-.026.419.339.804.473.431z\"/><path fill=\"#2D2D2D\" d=\"M39.449 68.778c1.16-3.437 1.694-4.363 2.404-5.754.708-1.39.822-2.48.306-1.81-.692.9-1.89 3.579-2.278 4.424 0 0-.75 1.67-.845 2.735-.025.41.284.771.413.405z\"/><path fill=\"#303030\" d=\"M39.509 68.581c1.146-3.458 1.667-4.253 2.306-5.546.638-1.29.802-2.374.339-1.755-.648.86-1.824 3.5-2.233 4.392 0 0-.688 1.597-.765 2.531-.023.4.23.736.353.378z\"/><path fill=\"#333\" d=\"M39.568 68.383c1.134-3.479 1.643-4.144 2.209-5.337.567-1.193.783-2.268.372-1.701-.606.821-1.759 3.421-2.188 4.359 0 0-.627 1.526-.686 2.327-.02.392.176.704.293.352z\"/><path d=\"M97.859 74.559c.675-1.906.605-6.764-1.116-9.902-.604-1.14-1.186-2.464-1.534-2.535-.372-.069-1.047.675-.977.791.094.186 3.232 4.604 2.581 10.601-.046.488.884 1.488 1.046 1.045z\"/><path fill=\"#030303\" d=\"M97.829 74.314c.654-1.847.566-6.58-1.08-9.577-.586-1.1-1.142-2.381-1.484-2.451-.362-.069-1.009.653-.944.764.084.181 3.101 4.449 2.496 10.252-.041.48.855 1.438 1.012 1.012z\"/><path fill=\"#070707\" d=\"M97.799 74.067c.635-1.786.529-6.396-1.042-9.252-.569-1.061-1.098-2.297-1.434-2.367-.352-.067-.971.632-.911.739.073.177 2.971 4.293 2.41 9.903-.038.472.825 1.39.977.977z\"/><path fill=\"#0B0B0B\" d=\"M97.768 73.821c.615-1.727.49-6.21-1.006-8.925-.551-1.022-1.054-2.214-1.382-2.284-.343-.068-.935.61-.881.712.064.172 2.841 4.139 2.326 9.554-.033.465.797 1.341.943.943z\"/><path fill=\"#0F0F0F\" d=\"M97.738 73.574c.595-1.667.451-6.025-.969-8.599-.533-.983-1.011-2.13-1.333-2.201-.332-.067-.897.589-.848.687.054.167 2.711 3.984 2.241 9.205-.029.458.767 1.292.909.908z\"/><path fill=\"#131313\" d=\"M97.708 73.328c.574-1.606.412-5.841-.933-8.273-.515-.944-.967-2.047-1.282-2.117-.323-.066-.86.566-.815.66.044.163 2.581 3.83 2.156 8.856-.026.45.737 1.243.874.874z\"/><path fill=\"#161616\" d=\"M97.677 73.082c.556-1.547.375-5.656-.895-7.948-.497-.905-.923-1.963-1.231-2.034-.313-.066-.823.546-.783.634.034.159 2.45 3.675 2.071 8.508-.022.442.707 1.194.838.84z\"/><path fill=\"#1A1A1A\" d=\"M97.646 72.836c.536-1.487.337-5.472-.858-7.623-.479-.866-.879-1.88-1.181-1.951-.303-.065-.786.525-.75.609.024.154 2.319 3.52 1.986 8.159-.018.434.678 1.145.803.806z\"/><path fill=\"#1E1E1E\" d=\"M97.616 72.589c.516-1.427.298-5.287-.822-7.297-.462-.826-.835-1.796-1.131-1.866-.292-.063-.749.502-.719.583.014.149 2.189 3.365 1.901 7.81-.013.426.651 1.096.771.77z\"/><path fill=\"#222\" d=\"M97.585 72.343c.496-1.367.261-5.102-.785-6.97-.443-.788-.792-1.713-1.081-1.784-.283-.063-.711.482-.687.557.005.145 2.06 3.211 1.816 7.462-.006.417.622 1.045.737.735z\"/><path fill=\"#262626\" d=\"M97.555 72.096c.476-1.307.223-4.917-.75-6.645-.424-.748-.748-1.629-1.029-1.7-.273-.062-.673.46-.655.53-.005.141 1.93 3.057 1.731 7.113-.003.412.593.998.703.702z\"/><path fill=\"#2A2A2A\" d=\"M97.524 71.85c.456-1.247.185-4.732-.713-6.319-.407-.709-.703-1.546-.979-1.617-.263-.062-.637.439-.623.504-.015.136 1.8 2.902 1.646 6.764.002.404.565.95.669.668z\"/><path fill=\"#2D2D2D\" d=\"M97.493 71.604c.437-1.188.147-4.547-.674-5.994-.39-.67-.661-1.462-.929-1.533-.253-.061-.6.417-.591.479-.024.132 1.669 2.747 1.562 6.415.005.396.534.9.632.633z\"/><path fill=\"#313131\" d=\"M97.463 71.357c.416-1.127.108-4.362-.639-5.667-.372-.631-.617-1.38-.878-1.451-.243-.061-.562.396-.559.452-.034.127 1.54 2.593 1.477 6.067.01.39.505.852.599.599z\"/><path fill=\"#353535\" d=\"M97.432 71.112c.397-1.068.07-4.178-.602-5.342-.353-.592-.572-1.296-.827-1.367-.234-.06-.525.375-.527.426-.044.123 1.409 2.438 1.392 5.718.015.38.477.803.564.565z\"/><path fill=\"#393939\" d=\"M97.402 70.865c.377-1.007.031-3.993-.565-5.016-.335-.554-.529-1.213-.778-1.284-.223-.059-.487.354-.494.401-.054.118 1.279 2.284 1.307 5.369.018.373.448.753.53.53z\"/><path fill=\"#3D3D3D\" d=\"M97.371 70.619c.357-.948-.007-3.808-.529-4.69-.317-.514-.485-1.128-.727-1.2-.214-.058-.451.333-.462.375-.064.114 1.148 2.128 1.221 5.02.024.364.421.704.497.495z\"/><path fill=\"#414141\" d=\"M97.342 70.373c.338-.888-.045-3.624-.492-4.364-.3-.475-.441-1.045-.676-1.117-.206-.058-.414.31-.43.348-.074.109 1.018 1.974 1.136 4.672.028.356.39.654.462.461z\"/><path fill=\"#444\" d=\"M97.31 70.127c.318-.828-.083-3.439-.455-4.039-.282-.436-.397-.962-.625-1.033-.195-.058-.376.289-.398.322-.083.104.888 1.82 1.053 4.324.03.348.358.605.425.426z\"/><path fill=\"#484848\" d=\"M97.281 69.88c.297-.767-.122-3.253-.419-3.713-.264-.396-.354-.878-.575-.95-.185-.057-.339.268-.366.296-.093.1.759 1.665.967 3.974.035.342.331.558.393.393z\"/><path fill=\"#4C4C4C\" d=\"M97.25 69.633c.277-.708-.16-3.068-.382-3.386-.247-.357-.311-.795-.525-.866-.175-.056-.301.246-.333.27-.103.096.628 1.511.882 3.625.039.333.302.508.358.357z\"/><path d=\"M95.21 62.122c-3.301-4.509-7.578-5.974-7.137-4.556 0 0 3.278 1.86 6.16 5.346.558.675 1.488-.092.977-.79z\"/><path fill=\"#030303\" d=\"M95.064 61.998c-3.205-4.356-7.392-5.783-6.954-4.423.005.004 3.196 1.812 6.007 5.189.543.651 1.443-.093.947-.766z\"/><path fill=\"#070707\" d=\"M94.919 61.873c-3.107-4.205-7.206-5.592-6.772-4.29.012.007 3.116 1.765 5.856 5.031.526.627 1.397-.091.916-.741z\"/><path fill=\"#0B0B0B\" d=\"M94.774 61.748c-3.011-4.052-7.019-5.4-6.59-4.156.018.011 3.036 1.717 5.705 4.873.509.604 1.35-.091.885-.717z\"/><path fill=\"#0F0F0F\" d=\"M94.628 61.623c-2.913-3.899-6.832-5.209-6.408-4.023.023.015 2.955 1.67 5.552 4.715.495.581 1.306-.09.856-.692z\"/><path fill=\"#131313\" d=\"M94.482 61.499c-2.816-3.746-6.645-5.018-6.224-3.89.028.018 2.873 1.623 5.401 4.557.477.556 1.258-.09.823-.667z\"/><path fill=\"#161616\" d=\"M94.338 61.373c-2.719-3.593-6.459-4.825-6.042-3.756.034.022 2.792 1.576 5.248 4.398.46.534 1.213-.087.794-.642z\"/><path fill=\"#1A1A1A\" d=\"M94.192 61.249c-2.623-3.441-6.272-4.635-5.86-3.624.04.025 2.711 1.528 5.096 4.242a.491.491 0 0 0 .764-.618z\"/><path fill=\"#1E1E1E\" d=\"M94.047 61.124c-2.527-3.289-6.086-4.443-5.679-3.491.047.029 2.632 1.481 4.945 4.083.43.488 1.122-.086.734-.592z\"/><path fill=\"#222\" d=\"M93.902 60.999c-2.429-3.135-5.9-4.252-5.496-3.357.051.032 2.551 1.433 4.793 3.925.412.464 1.076-.086.703-.568z\"/><path fill=\"#262626\" d=\"M93.756 60.874c-2.332-2.982-5.713-4.061-5.312-3.224.057.036 2.47 1.386 4.64 3.767.396.441 1.03-.084.672-.543z\"/><path fill=\"#2A2A2A\" d=\"M93.611 60.75c-2.235-2.83-5.526-3.87-5.131-3.091.062.04 2.389 1.339 4.489 3.609.381.417.985-.084.642-.518z\"/><path fill=\"#2D2D2D\" d=\"M93.466 60.625c-2.139-2.678-5.34-3.679-4.949-2.958.069.043 2.308 1.292 4.337 3.451.364.394.939-.082.612-.493z\"/><path fill=\"#313131\" d=\"M93.32 60.5c-2.041-2.524-5.153-3.487-4.766-2.824.074.046 2.228 1.244 4.185 3.294.348.369.893-.083.581-.47z\"/><path fill=\"#353535\" d=\"M93.175 60.375c-1.945-2.372-4.967-3.296-4.584-2.691.08.05 2.146 1.196 4.034 3.135.33.347.847-.081.55-.444z\"/><path fill=\"#393939\" d=\"M93.03 60.25c-1.847-2.219-4.78-3.104-4.402-2.558.085.054 2.065 1.149 3.881 2.978.316.324.802-.081.521-.42z\"/><path fill=\"#3D3D3D\" d=\"M92.885 60.126c-1.751-2.067-4.594-2.913-4.22-2.425.091.058 1.985 1.102 3.729 2.819.299.3.757-.08.491-.394z\"/><path fill=\"#414141\" d=\"M92.739 60.001c-1.655-1.914-4.407-2.722-4.038-2.292.098.061 1.904 1.055 3.578 2.662.283.277.711-.079.46-.37z\"/><path fill=\"#444\" d=\"M92.593 59.876c-1.557-1.762-4.221-2.53-3.855-2.158.103.064 1.824 1.007 3.425 2.504.268.253.666-.079.43-.346z\"/><path fill=\"#484848\" d=\"M92.449 59.751c-1.461-1.608-4.035-2.339-3.673-2.025.109.068 1.742.96 3.273 2.346.251.229.62-.077.4-.321z\"/><path fill=\"#4C4C4C\" d=\"M92.303 59.626c-1.363-1.456-3.848-2.147-3.491-1.892.114.072 1.662.913 3.122 2.188.235.206.574-.076.369-.296z\"/><path d=\"M97.859 74.559c.047 2.023-1.859 7.183-2.58 6.998-.814-.187.163-1.697.906-4.254.302-1.07.535-3.696.628-3.789.303-.303 1.046.557 1.046 1.045z\"/><path fill=\"#050505\" d=\"M97.801 74.728c.033 1.964-1.82 6.972-2.518 6.786-.781-.183.177-1.661.909-4.174.29-1.026.515-3.534.609-3.632.295-.299 1.015.493 1 1.02z\"/><path fill=\"#0A0A0A\" d=\"M97.741 74.897c.021 1.906-1.78 6.761-2.454 6.575-.75-.18.191-1.626.91-4.095.279-.981.496-3.372.592-3.474.286-.297.985.428.952.994z\"/><path fill=\"#0F0F0F\" d=\"M97.682 75.065c.006 1.847-1.742 6.549-2.391 6.364-.719-.178.205-1.591.913-4.015.265-.938.475-3.211.572-3.317.279-.294.955.364.906.968z\"/><path fill=\"#141414\" d=\"M97.622 75.233c-.006 1.788-1.701 6.338-2.328 6.153-.686-.175.22-1.555.916-3.935.253-.894.455-3.049.554-3.159.271-.29.924.298.858.941z\"/><path fill=\"#191919\" d=\"M97.563 75.401c-.021 1.73-1.661 6.127-2.265 5.942-.655-.172.233-1.52.918-3.854.242-.851.436-2.887.535-3.002.264-.288.894.233.812.914z\"/><path fill=\"#1E1E1E\" d=\"M97.503 75.57c-.033 1.672-1.621 5.916-2.202 5.731-.622-.169.248-1.485.92-3.775.229-.808.416-2.726.517-2.845.256-.285.864.169.765.889z\"/><path fill=\"#232323\" d=\"M97.443 75.738c-.046 1.614-1.582 5.705-2.138 5.52-.591-.167.262-1.448.921-3.694.217-.764.397-2.565.499-2.688.249-.283.835.104.718.862z\"/><path fill=\"#282828\" d=\"M97.385 75.907c-.06 1.555-1.542 5.493-2.076 5.309-.559-.164.276-1.413.924-3.614.205-.721.377-2.403.48-2.53.241-.281.804.037.672.835z\"/><path fill=\"#2D2D2D\" d=\"M97.325 76.075c-.073 1.497-1.502 5.282-2.011 5.097-.527-.16.288-1.376.925-3.534l.463-2.373c.232-.277.772-.026.623.81z\"/><path fill=\"#333\" d=\"M97.265 76.243c-.086 1.438-1.463 5.071-1.949 4.888-.495-.158.303-1.342.928-3.455.18-.634.337-2.081.443-2.216.227-.274.744-.091.578.783z\"/><path fill=\"#383838\" d=\"M97.206 76.412c-.099 1.38-1.422 4.859-1.885 4.676-.464-.155.317-1.307.929-3.375.169-.59.318-1.918.426-2.059.218-.271.713-.155.53.758z\"/><path fill=\"#3D3D3D\" d=\"M97.147 76.58c-.113 1.322-1.383 4.648-1.822 4.465-.432-.152.332-1.271.931-3.295.157-.546.298-1.756.407-1.9.211-.269.683-.222.484.73z\"/><path fill=\"#424242\" d=\"M97.087 76.749c-.125 1.264-1.343 4.437-1.759 4.254-.399-.15.347-1.235.934-3.216.145-.501.279-1.594.389-1.743.202-.266.652-.286.436.705z\"/><path fill=\"#474747\" d=\"M97.028 76.918c-.14 1.205-1.304 4.225-1.696 4.042-.369-.146.36-1.199.936-3.135.132-.458.259-1.433.37-1.586.195-.263.622-.351.39.679z\"/><path fill=\"#4C4C4C\" d=\"M96.968 77.085c-.152 1.147-1.264 4.015-1.633 3.833-.335-.145.374-1.165.939-3.056.121-.416.239-1.272.351-1.429.189-.26.592-.416.343.652z\"/><path fill=\"#515151\" d=\"M96.91 77.254c-.166 1.088-1.225 3.803-1.57 3.621-.304-.142.387-1.129.94-2.976.109-.372.22-1.111.333-1.272.181-.256.561-.48.297.627z\"/><path fill=\"#565656\" d=\"M96.849 77.422c-.179 1.03-1.185 3.591-1.507 3.41-.272-.139.403-1.093.943-2.896.096-.328.2-.949.315-1.114.174-.254.531-.545.249.6z\"/><path fill=\"#5B5B5B\" d=\"M96.791 77.59c-.193.972-1.146 3.381-1.444 3.199-.24-.136.416-1.058.945-2.816.083-.284.18-.787.296-.957.165-.251.5-.61.203.574z\"/><path fill=\"#606060\" d=\"M96.731 77.759c-.206.913-1.106 3.169-1.38 2.987-.208-.132.43-1.022.947-2.735.072-.242.161-.626.278-.8.157-.248.469-.675.155.548z\"/><path fill=\"#666\" d=\"M96.672 77.928c-.219.854-1.066 2.958-1.318 2.776-.176-.129.445-.986.949-2.656.06-.197.141-.464.261-.642.149-.246.438-.739.108.522z\"/><path d=\"M90.769 62.378c-.496.523-.938 3.226.303 4.163 1.24.91 3.419-.772 3.419-1.736-.028-2.179-3.225-2.978-3.722-2.427z\"/><path fill=\"#010101\" d=\"M90.814 62.424c-.504.52-.929 3.171.277 4.09 1.204.893 3.341-.734 3.353-1.705-.016-2.123-3.126-2.932-3.63-2.385z\"/><path fill=\"#030303\" d=\"M90.858 62.469c-.511.517-.92 3.117.25 4.016 1.17.875 3.264-.695 3.286-1.671-.003-2.068-3.025-2.888-3.536-2.345z\"/><path fill=\"#050505\" d=\"M90.902 62.515c-.518.513-.911 3.062.224 3.942 1.134.856 3.187-.658 3.22-1.64.01-2.011-2.925-2.841-3.444-2.302z\"/><path fill=\"#070707\" d=\"M90.946 62.56c-.525.51-.902 3.008.198 3.87 1.097.839 3.109-.619 3.153-1.607.023-1.958-2.825-2.798-3.351-2.263z\"/><path fill=\"#090909\" d=\"M90.991 62.605c-.532.507-.894 2.954.171 3.797 1.061.821 3.032-.582 3.087-1.574.035-1.903-2.725-2.753-3.258-2.223z\"/><path fill=\"#0B0B0B\" d=\"M91.035 62.65c-.539.502-.885 2.898.144 3.723 1.026.804 2.954-.543 3.022-1.542.047-1.846-2.626-2.707-3.166-2.181z\"/><path fill=\"#0D0D0D\" d=\"M91.078 62.696c-.547.499-.876 2.844.118 3.649.989.787 2.876-.505 2.955-1.509.061-1.792-2.525-2.662-3.073-2.14z\"/><path fill=\"#0F0F0F\" d=\"M91.123 62.741c-.554.496-.868 2.791.091 3.576.953.769 2.799-.467 2.889-1.476.073-1.737-2.425-2.617-2.98-2.1z\"/><path fill=\"#111\" d=\"M91.167 62.787c-.561.492-.859 2.734.064 3.502.919.75 2.722-.43 2.823-1.443.086-1.682-2.325-2.573-2.887-2.059z\"/><path fill=\"#131313\" d=\"M91.211 62.832c-.568.489-.85 2.681.038 3.429.881.733 2.644-.392 2.756-1.411.099-1.627-2.224-2.527-2.794-2.018z\"/><path fill=\"#151515\" d=\"M91.255 62.877c-.575.486-.841 2.625.012 3.354.846.716 2.567-.353 2.69-1.377.111-1.571-2.125-2.482-2.702-1.977z\"/><path fill=\"#161616\" d=\"M91.3 62.922c-.583.481-.833 2.572-.015 3.281.81.699 2.489-.314 2.624-1.345.124-1.515-2.025-2.437-2.609-1.936z\"/><path fill=\"#181818\" d=\"M91.344 62.968c-.59.479-.824 2.518-.042 3.208.774.68 2.412-.277 2.558-1.313.136-1.461-1.924-2.392-2.516-1.895z\"/><path fill=\"#1A1A1A\" d=\"M91.388 63.013c-.598.475-.815 2.462-.068 3.135.738.663 2.334-.24 2.492-1.28.148-1.406-1.825-2.347-2.424-1.855z\"/><path fill=\"#1C1C1C\" d=\"M91.432 63.058c-.604.471-.807 2.408-.094 3.061.703.646 2.256-.2 2.425-1.248.162-1.348-1.725-2.301-2.331-1.813z\"/><path fill=\"#1E1E1E\" d=\"M91.477 63.104c-.613.467-.798 2.353-.122 2.987.667.627 2.18-.163 2.36-1.214.174-1.295-1.626-2.257-2.238-1.773z\"/><path fill=\"#202020\" d=\"M91.52 63.149c-.619.464-.789 2.3-.147 2.914.631.61 2.102-.124 2.293-1.182.187-1.239-1.525-2.212-2.146-1.732z\"/><path fill=\"#222\" d=\"M91.564 63.194c-.625.46-.78 2.245-.173 2.841.595.592 2.025-.086 2.226-1.15.2-1.184-1.424-2.166-2.053-1.691z\"/><path fill=\"#242424\" d=\"M91.608 63.24c-.632.457-.771 2.19-.2 2.768.559.573 1.947-.049 2.16-1.117.213-1.13-1.324-2.122-1.96-1.651z\"/><path fill=\"#262626\" d=\"M91.653 63.285c-.641.454-.763 2.136-.228 2.694.523.557 1.87-.01 2.094-1.084.226-1.074-1.223-2.077-1.866-1.61z\"/><path d=\"M90.653 84.603c.488.488.907-.721 1.396-1.117.488-.395 1.278-1.255 2.859-1.255s1.464-.046 1.394-.651c-.046-.581-.511-.535-1.906-.326a4.533 4.533 0 0 0-2.882 1.557c-.535.628-1.14 1.512-.861 1.792z\"/><path fill=\"#050505\" d=\"M90.761 84.484c.471.468.872-.685 1.357-1.068s1.269-1.205 2.789-1.205c1.521 0 1.426-.042 1.359-.626-.045-.562-.498-.515-1.856-.316a4.417 4.417 0 0 0-2.812 1.5c-.522.607-1.11 1.445-.837 1.715z\"/><path fill=\"#0A0A0A\" d=\"M90.869 84.364c.453.449.839-.648 1.319-1.019.482-.371 1.26-1.155 2.72-1.155 1.46 0 1.386-.036 1.322-.601-.042-.545-.484-.495-1.805-.307a4.302 4.302 0 0 0-2.743 1.443c-.509.585-1.081 1.38-.813 1.639z\"/><path fill=\"#0F0F0F\" d=\"M90.976 84.245c.437.429.805-.611 1.283-.97.478-.359 1.25-1.105 2.649-1.105 1.4 0 1.347-.03 1.286-.576-.04-.526-.471-.474-1.755-.298a4.2 4.2 0 0 0-2.673 1.388c-.495.562-1.052 1.311-.79 1.561z\"/><path fill=\"#141414\" d=\"M91.083 84.127c.42.409.771-.576 1.246-.922.475-.348 1.24-1.055 2.58-1.056 1.34 0 1.308-.025 1.251-.552-.039-.508-.458-.453-1.707-.29a4.08 4.08 0 0 0-2.604 1.332c-.48.543-1.021 1.247-.766 1.488z\"/><path fill=\"#191919\" d=\"M91.19 84.009c.403.387.738-.54 1.209-.875.47-.335 1.23-1.004 2.51-1.005 1.279-.001 1.269-.02 1.214-.527-.037-.491-.445-.433-1.655-.28a3.976 3.976 0 0 0-2.534 1.274c-.467.521-.992 1.18-.744 1.413z\"/><path fill=\"#1E1E1E\" d=\"M91.298 83.89c.386.368.705-.504 1.171-.826.467-.323 1.222-.954 2.441-.955 1.218-.001 1.229-.014 1.178-.502-.034-.472-.431-.412-1.606-.27a3.858 3.858 0 0 0-2.464 1.217c-.454.499-.962 1.114-.72 1.336z\"/><path fill=\"#232323\" d=\"M91.406 83.771c.37.349.67-.467 1.135-.778.464-.311 1.211-.903 2.37-.903 1.159-.002 1.189-.009 1.143-.478-.033-.454-.418-.393-1.556-.263a3.755 3.755 0 0 0-2.394 1.161c-.443.478-.936 1.048-.698 1.261z\"/><path fill=\"#282828\" d=\"M91.514 83.652c.352.329.637-.431 1.097-.729.46-.299 1.202-.853 2.3-.854 1.099-.002 1.151-.004 1.106-.454-.03-.436-.404-.372-1.505-.252a3.638 3.638 0 0 0-2.324 1.104c-.429.457-.906.981-.674 1.185z\"/><path fill=\"#2D2D2D\" d=\"M91.62 83.533c.335.308.603-.395 1.06-.681.457-.286 1.193-.802 2.23-.803 1.039-.002 1.112.002 1.07-.428-.028-.418-.391-.352-1.455-.244a3.539 3.539 0 0 0-2.254 1.047c-.414.434-.875.915-.651 1.109z\"/><path fill=\"#333\" d=\"M91.728 83.415c.318.288.568-.358 1.022-.633.453-.275 1.183-.752 2.161-.754s1.072.007 1.034-.403c-.026-.399-.378-.331-1.406-.234a3.434 3.434 0 0 0-2.184.99c-.401.413-.846.85-.627 1.034z\"/><path fill=\"#383838\" d=\"M91.836 83.296c.301.268.535-.322.985-.584.45-.263 1.174-.702 2.092-.704s1.033.013.997-.379c-.024-.38-.364-.31-1.355-.224-.99.07-1.715.531-2.114.934-.389.391-.819.782-.605.957z\"/><path fill=\"#3D3D3D\" d=\"M91.943 83.177c.284.249.502-.286.949-.536.446-.25 1.164-.653 2.021-.654.857-.003.994.018.962-.354-.022-.363-.351-.29-1.306-.217-.953.06-1.661.497-2.045.877-.375.372-.788.719-.581.884z\"/><path fill=\"#424242\" d=\"M92.051 83.059c.267.229.467-.25.911-.487.443-.239 1.154-.603 1.951-.604.797-.002.954.024.926-.329-.021-.345-.338-.27-1.255-.207-.918.049-1.606.462-1.975.82-.362.349-.76.651-.558.807z\"/><path fill=\"#474747\" d=\"M92.158 82.94c.25.208.434-.213.874-.44.44-.226 1.145-.551 1.882-.553.737-.003.915.029.889-.304-.019-.327-.324-.25-1.206-.198-.88.039-1.55.429-1.905.764-.347.327-.729.584-.534.731z\"/><path fill=\"#4C4C4C\" d=\"M92.265 82.821c.233.188.4-.178.836-.391.437-.215 1.136-.501 1.812-.504.677-.003.876.035.854-.279-.016-.308-.312-.229-1.155-.188-.844.028-1.495.395-1.836.707-.333.305-.7.518-.511.655z\"/><path fill=\"#515151\" d=\"M92.373 82.702c.215.168.366-.14.799-.343.433-.201 1.125-.45 1.742-.452.617-.004.836.039.817-.255-.015-.29-.298-.208-1.105-.179-.807.017-1.439.36-1.766.65-.321.284-.67.452-.487.579z\"/><path fill=\"#565656\" d=\"M92.481 82.584c.198.148.332-.104.761-.294.43-.19 1.117-.4 1.672-.403.556-.003.797.045.782-.23-.013-.272-.285-.188-1.056-.17-.771.007-1.384.326-1.695.593-.308.262-.642.386-.464.504z\"/><path fill=\"#5B5B5B\" d=\"M92.587 82.465c.183.128.299-.068.726-.247.425-.178 1.106-.35 1.602-.353.496-.003.758.05.746-.206-.01-.253-.271-.168-1.005-.161-.733-.003-1.329.292-1.625.536-.297.244-.614.322-.444.431z\"/><path fill=\"#606060\" d=\"M92.695 82.346c.165.108.266-.033.688-.198.423-.166 1.097-.3 1.533-.303s.719.057.708-.181c-.008-.234-.257-.146-.955-.152-.696-.014-1.273.258-1.556.479-.281.221-.582.256-.418.355z\"/><path fill=\"#666\" d=\"M92.803 82.228c.147.088.23.003.649-.15.42-.154 1.088-.249 1.463-.252.375-.003.68.062.673-.155-.006-.217-.245-.127-.905-.143-.66-.024-1.217.224-1.486.423-.267.197-.554.187-.394.277z\"/><path d=\"M96.953 81.557c0 .744 1.511 1 2.952 1.208 1.418.209 2.558.489 2.626 1.977.07 1.464-.301 2.51.35 2.395 1.395-.256 1.906-1.768 1.883-2.465 0-.698-1.023-1.953-2.859-2.65-1.348-.512-2.325-.744-3.511-.791-1.58-.069-1.441.326-1.441.326z\"/><path fill=\"#030303\" d=\"M96.994 81.569c.003.723 1.499.959 2.921 1.174 1.405.218 2.503.488 2.619 1.938.112 1.426-.275 2.427.367 2.321 1.338-.238 1.836-1.679 1.811-2.367-.005-.694-1.007-1.908-2.82-2.595-1.333-.504-2.295-.742-3.468-.792-1.535-.069-1.433.308-1.43.321z\"/><path fill=\"#070707\" d=\"M97.034 81.582c.008.702 1.487.918 2.891 1.14 1.392.226 2.447.487 2.61 1.901.153 1.386-.249 2.341.384 2.248 1.281-.222 1.768-1.592 1.738-2.271-.009-.693-.991-1.864-2.78-2.541-1.317-.498-2.268-.74-3.425-.793-1.488-.071-1.424.289-1.418.316z\"/><path fill=\"#0B0B0B\" d=\"M97.075 81.593c.012.681 1.475.878 2.86 1.107 1.379.235 2.392.487 2.603 1.862.194 1.348-.222 2.256.402 2.174 1.226-.206 1.698-1.504 1.666-2.173-.014-.69-.974-1.82-2.74-2.486-1.302-.491-2.238-.738-3.383-.794-1.444-.071-1.416.27-1.408.31z\"/><path fill=\"#0F0F0F\" d=\"M97.116 81.606c.015.66 1.463.838 2.829 1.073 1.366.244 2.338.486 2.596 1.824.233 1.309-.197 2.173.419 2.102 1.168-.189 1.627-1.417 1.594-2.078-.019-.687-.959-1.774-2.702-2.431-1.287-.485-2.208-.736-3.34-.795-1.398-.072-1.407.252-1.396.305z\"/><path fill=\"#131313\" d=\"M97.157 81.619c.019.639 1.451.797 2.798 1.04 1.353.252 2.283.485 2.587 1.786.276 1.27-.17 2.087.438 2.029 1.112-.173 1.557-1.33 1.521-1.981-.024-.684-.943-1.73-2.662-2.376-1.272-.479-2.181-.733-3.298-.797-1.351-.074-1.399.232-1.384.299z\"/><path fill=\"#161616\" d=\"M97.197 81.631c.023.618 1.44.757 2.768 1.006 1.34.26 2.229.484 2.58 1.747.316 1.231-.143 2.002.455 1.956 1.056-.155 1.488-1.242 1.449-1.885-.028-.682-.927-1.686-2.623-2.322-1.257-.471-2.151-.731-3.255-.797-1.307-.073-1.391.215-1.374.295z\"/><path fill=\"#1A1A1A\" d=\"M97.238 81.644c.027.597 1.428.716 2.736.972 1.328.269 2.174.484 2.573 1.71.357 1.191-.117 1.918.472 1.882 1-.14 1.419-1.156 1.377-1.788-.034-.679-.911-1.641-2.583-2.268-1.243-.465-2.124-.729-3.212-.799-1.26-.073-1.383.197-1.363.291z\"/><path fill=\"#1E1E1E\" d=\"M97.279 81.656c.03.575 1.416.675 2.707.938 1.313.277 2.118.483 2.562 1.671.399 1.152-.09 1.833.491 1.809.943-.123 1.349-1.067 1.305-1.691-.038-.676-.896-1.597-2.544-2.213-1.227-.458-2.094-.727-3.169-.8-1.216-.073-1.375.179-1.352.286z\"/><path fill=\"#222\" d=\"M97.32 81.668c.034.555 1.404.636 2.674.905 1.301.286 2.064.482 2.556 1.633.44 1.113-.063 1.749.508 1.736.887-.106 1.279-.98 1.232-1.595-.043-.674-.879-1.552-2.505-2.158-1.211-.452-2.064-.726-3.126-.802-1.169-.073-1.365.161-1.339.281z\"/><path fill=\"#262626\" d=\"M97.36 81.68c.038.533 1.391.595 2.644.87 1.289.295 2.01.481 2.548 1.596.482 1.074-.037 1.664.526 1.663.831-.09 1.209-.893 1.161-1.499-.048-.671-.863-1.508-2.465-2.104-1.196-.446-2.037-.723-3.084-.803-1.124-.073-1.359.144-1.33.277z\"/><path fill=\"#2A2A2A\" d=\"M97.4 81.692c.042.513 1.38.555 2.614.836 1.275.303 1.955.481 2.54 1.558.523 1.036-.011 1.58.544 1.59.773-.074 1.14-.805 1.088-1.402-.053-.669-.847-1.463-2.426-2.049-1.18-.439-2.007-.721-3.042-.805-1.077-.073-1.349.127-1.318.272z\"/><path fill=\"#2D2D2D\" d=\"M97.441 81.706c.046.491 1.368.513 2.583.801 1.263.312 1.9.481 2.532 1.52.564.996.016 1.495.562 1.517.716-.057 1.07-.718 1.015-1.305-.057-.666-.83-1.419-2.386-1.995-1.166-.432-1.978-.718-2.999-.805-1.032-.075-1.34.107-1.307.267z\"/><path fill=\"#313131\" d=\"M97.482 81.717c.049.47 1.356.473 2.552.769 1.248.32 1.845.48 2.523 1.482.605.957.043 1.41.579 1.443.661-.04 1.001-.63.943-1.208-.062-.664-.814-1.375-2.346-1.94-1.151-.425-1.95-.716-2.957-.807-.985-.074-1.332.089-1.294.261z\"/><path fill=\"#353535\" d=\"M97.523 81.73c.053.449 1.343.433 2.521.734 1.236.329 1.791.479 2.516 1.444.647.918.069 1.325.597 1.37.604-.024.931-.543.871-1.111-.067-.661-.799-1.331-2.307-1.885-1.136-.419-1.92-.715-2.914-.809-.94-.075-1.325.071-1.284.257z\"/><path fill=\"#393939\" d=\"M97.563 81.742c.057.428 1.333.393 2.491.701 1.222.337 1.735.478 2.509 1.406.687.879.095 1.241.613 1.297.548-.007.861-.456.798-1.016-.072-.658-.783-1.285-2.267-1.83-1.121-.413-1.892-.713-2.872-.811-.894-.074-1.315.054-1.272.253z\"/><path fill=\"#3D3D3D\" d=\"M97.604 81.754c.061.407 1.32.352 2.459.667 1.21.346 1.682.478 2.501 1.368.729.84.122 1.155.631 1.223.492.01.792-.368.727-.918-.076-.655-.766-1.241-2.229-1.775-1.104-.406-1.862-.712-2.828-.812-.848-.075-1.307.035-1.261.247z\"/><path fill=\"#414141\" d=\"M97.645 81.767c.064.386 1.308.312 2.428.633 1.198.354 1.627.477 2.493 1.331.769.8.148 1.069.649 1.149.435.026.722-.28.654-.821-.081-.653-.75-1.198-2.188-1.722-1.09-.399-1.834-.708-2.786-.812-.803-.076-1.299.016-1.25.242z\"/><path fill=\"#444\" d=\"M97.686 81.78c.068.364 1.296.27 2.397.599 1.185.363 1.572.477 2.485 1.292.81.761.174.986.667 1.077.378.043.652-.193.582-.726-.086-.65-.736-1.151-2.15-1.666-1.075-.393-1.805-.707-2.744-.814-.756-.076-1.289-.002-1.237.238z\"/><path fill=\"#484848\" d=\"M97.725 81.792c.073.344 1.286.231 2.367.565 1.172.372 1.518.476 2.477 1.254.852.723.202.901.686 1.003.322.06.582-.106.509-.628-.091-.648-.719-1.108-2.109-1.611-1.06-.387-1.776-.705-2.702-.816-.71-.076-1.281-.02-1.228.233z\"/><path fill=\"#4C4C4C\" d=\"M97.766 81.804c.076.323 1.272.189 2.336.531 1.159.381 1.462.475 2.469 1.216.893.684.228.817.703.931.265.075.513-.019.437-.532-.095-.645-.703-1.063-2.07-1.557-1.045-.38-1.747-.703-2.659-.816-.665-.078-1.272-.039-1.216.227zm4.787 1.557c.531.324.437.665.778.894.171.114.456.114.286-.323-.229-.513-.418-.798-1.596-1.273-.759-.304-.608.018.532.702z\"/><path fill=\"#505050\" d=\"M102.567 83.366c.518.314.426.648.759.87.167.111.445.111.278-.315-.223-.5-.408-.778-1.557-1.242-.74-.296-.592.019.52.687z\"/><path fill=\"#545454\" d=\"M102.58 83.369c.506.307.416.631.741.849.163.108.434.108.271-.308-.217-.487-.397-.758-1.518-1.21-.722-.288-.577.019.506.669z\"/><path fill=\"#575757\" d=\"M102.595 83.373c.493.298.405.616.722.827.159.105.423.105.263-.299-.21-.475-.387-.739-1.478-1.179-.704-.282-.563.017.493.651z\"/><path fill=\"#5B5B5B\" d=\"M102.61 83.377c.479.292.393.599.701.805.155.103.411.103.258-.291-.206-.462-.377-.72-1.439-1.148-.686-.275-.548.017.48.634z\"/><path fill=\"#5F5F5F\" d=\"M102.622 83.38c.467.284.384.584.684.784.15.1.4.1.25-.283-.201-.45-.367-.701-1.4-1.117-.666-.266-.533.017.466.616z\"/><path fill=\"#636363\" d=\"M102.638 83.384c.453.276.372.568.664.762.146.097.389.097.244-.275-.195-.438-.356-.681-1.361-1.086-.649-.259-.52.017.453.599z\"/><path fill=\"#676767\" d=\"M102.651 83.389c.44.267.362.551.645.739.142.094.378.094.236-.267-.188-.425-.346-.661-1.322-1.055-.628-.252-.503.016.441.583z\"/><path fill=\"#6B6B6B\" d=\"M102.665 83.393c.428.259.351.534.627.717.137.091.366.091.229-.259-.184-.412-.336-.642-1.284-1.023-.61-.244-.488.015.428.565z\"/><path fill=\"#6E6E6E\" d=\"M102.68 83.397c.414.251.341.518.606.696.134.088.356.088.223-.251-.178-.399-.325-.622-1.245-.992-.591-.238-.473.013.416.547z\"/><path fill=\"#727272\" d=\"M102.693 83.4c.401.244.331.501.589.674.129.085.343.085.215-.244-.172-.387-.315-.602-1.205-.961-.573-.229-.459.015.401.531z\"/><path fill=\"#767676\" d=\"M102.707 83.404c.388.236.319.486.57.653.125.083.332.083.208-.236-.167-.375-.305-.583-1.166-.93-.555-.222-.444.014.388.513z\"/><path fill=\"#7A7A7A\" d=\"M102.722 83.408c.376.228.308.469.55.63.121.081.322.081.201-.228-.161-.362-.295-.563-1.126-.898-.537-.215-.43.013.375.496z\"/><path fill=\"#7E7E7E\" d=\"M102.736 83.412c.362.22.297.453.53.608.117.078.312.078.195-.22-.155-.35-.285-.543-1.087-.867-.518-.206-.415.013.362.479z\"/><path fill=\"#828282\" d=\"M102.75 83.416c.349.212.287.437.512.586.112.075.299.075.187-.212-.149-.336-.274-.524-1.048-.835-.5-.201-.399.012.349.461z\"/><path fill=\"#858585\" d=\"M102.764 83.42c.336.204.275.419.492.564.108.072.289.072.181-.204-.145-.325-.265-.505-1.009-.805-.481-.192-.384.013.336.445z\"/><path fill=\"#898989\" d=\"M102.778 83.424c.323.197.266.404.473.543.104.069.277.069.173-.197-.139-.311-.254-.485-.97-.773-.461-.185-.368.011.324.427z\"/><path fill=\"#8D8D8D\" d=\"M102.792 83.428c.31.189.255.388.454.521.1.066.265.066.167-.188-.133-.299-.245-.466-.931-.743-.443-.177-.354.011.31.41z\"/><path fill=\"#919191\" d=\"M102.806 83.432c.297.181.245.372.435.5.096.063.256.063.16-.181-.127-.286-.233-.446-.892-.711-.424-.171-.34.01.297.392z\"/><path fill=\"#959595\" d=\"M102.821 83.435c.283.172.232.356.416.478.091.061.243.061.152-.173-.122-.274-.224-.426-.854-.68-.404-.163-.324.011.286.375z\"/><path fill=\"#999\" d=\"M102.834 83.439c.271.165.223.339.397.455.088.058.232.058.146-.164-.117-.262-.213-.407-.814-.65-.387-.154-.31.011.271.359z\"/><path d=\"M81.472 36.408c-.239.292.186 2.701 1.748 4.289 1.562 1.562 2.516 1.562 3.151.874 1.217-1.297.237-2.515-.503-3.362-.743-.847-1.695-.556-2.569-1.403s-1.482-.796-1.827-.398z\"/><path fill=\"#050505\" d=\"M81.495 36.429c-.236.289.184 2.68 1.733 4.256 1.551 1.55 2.496 1.55 3.126.867 1.208-1.287.236-2.495-.499-3.336s-1.682-.552-2.549-1.392c-.865-.841-1.469-.789-1.811-.395z\"/><path fill=\"#0A0A0A\" d=\"M81.518 36.451c-.234.286.183 2.659 1.72 4.223 1.538 1.538 2.476 1.538 3.102.86 1.199-1.277.235-2.477-.495-3.311-.73-.834-1.669-.547-2.529-1.381-.86-.834-1.459-.782-1.798-.391z\"/><path fill=\"#0F0F0F\" d=\"M81.54 36.473c-.232.284.182 2.638 1.708 4.189 1.526 1.525 2.456 1.525 3.078.853 1.189-1.267.232-2.457-.492-3.284-.724-.828-1.654-.543-2.509-1.37-.853-.828-1.448-.776-1.785-.388z\"/><path fill=\"#141414\" d=\"M81.563 36.495c-.23.282.18 2.616 1.693 4.155 1.514 1.514 2.437 1.514 3.053.847 1.18-1.257.23-2.438-.488-3.258-.718-.821-1.642-.539-2.488-1.36-.846-.821-1.437-.77-1.77-.384z\"/><path fill=\"#191919\" d=\"M81.586 36.516c-.229.28.179 2.596 1.68 4.123 1.5 1.501 2.418 1.501 3.028.84 1.171-1.247.229-2.418-.484-3.232-.712-.813-1.628-.534-2.468-1.348-.84-.815-1.426-.765-1.756-.383z\"/><path fill=\"#1E1E1E\" d=\"M81.609 36.537c-.228.278.177 2.575 1.666 4.09 1.49 1.489 2.399 1.489 3.004.833 1.162-1.237.228-2.398-.48-3.206-.706-.808-1.615-.53-2.448-1.338-.834-.808-1.414-.757-1.742-.379z\"/><path fill=\"#232323\" d=\"M81.631 36.559c-.225.275.176 2.554 1.652 4.056 1.477 1.477 2.379 1.477 2.98.826 1.151-1.227.226-2.378-.476-3.179-.701-.801-1.602-.526-2.428-1.327-.826-.801-1.403-.751-1.728-.376z\"/><path fill=\"#282828\" d=\"M81.654 36.581c-.223.273.173 2.533 1.64 4.023 1.465 1.464 2.359 1.464 2.955.819 1.142-1.217.223-2.359-.472-3.154-.696-.794-1.589-.521-2.409-1.315-.82-.795-1.391-.746-1.714-.373z\"/><path fill=\"#2D2D2D\" d=\"M81.677 36.602c-.222.271.172 2.512 1.625 3.989 1.453 1.453 2.339 1.453 2.93.812 1.132-1.207.221-2.34-.468-3.127-.689-.788-1.576-.517-2.388-1.305-.813-.787-1.379-.738-1.699-.369z\"/><path fill=\"#333\" d=\"M81.7 36.624c-.221.269.17 2.491 1.612 3.957 1.441 1.44 2.32 1.44 2.906.806 1.123-1.196.22-2.32-.464-3.101-.685-.781-1.564-.513-2.369-1.294-.807-.783-1.368-.735-1.685-.368z\"/><path fill=\"#383838\" d=\"M81.722 36.645c-.218.267.169 2.47 1.599 3.923 1.429 1.429 2.3 1.429 2.881.799 1.115-1.187.219-2.3-.46-3.076-.678-.774-1.55-.508-2.348-1.283-.8-.774-1.357-.726-1.672-.363z\"/><path fill=\"#3D3D3D\" d=\"M81.745 36.667c-.216.264.168 2.449 1.584 3.89 1.417 1.417 2.28 1.417 2.857.792 1.104-1.176.216-2.281-.456-3.048-.673-.769-1.537-.504-2.33-1.272-.791-.77-1.343-.722-1.655-.362z\"/><path fill=\"#424242\" d=\"M81.768 36.689c-.214.262.167 2.428 1.571 3.856 1.405 1.404 2.261 1.404 2.832.785 1.096-1.167.214-2.262-.452-3.023-.666-.762-1.523-.5-2.308-1.261-.786-.762-1.334-.715-1.643-.357z\"/><path fill=\"#474747\" d=\"M81.791 36.71c-.212.26.165 2.407 1.557 3.823 1.393 1.392 2.242 1.392 2.808.778 1.086-1.157.213-2.242-.448-2.997s-1.511-.495-2.29-1.25c-.778-.755-1.321-.708-1.627-.354z\"/><path fill=\"#4C4C4C\" d=\"M81.814 36.732c-.21.257.164 2.386 1.544 3.789 1.38 1.38 2.221 1.38 2.783.772 1.076-1.146.209-2.222-.445-2.971s-1.497-.491-2.268-1.24c-.773-.747-1.311-.701-1.614-.35z\"/><path fill=\"#515151\" d=\"M81.836 36.753c-.208.255.163 2.365 1.531 3.756 1.367 1.368 2.203 1.368 2.758.765 1.067-1.136.208-2.202-.44-2.944-.649-.742-1.484-.487-2.25-1.229-.764-.742-1.298-.695-1.599-.348z\"/><path fill=\"#565656\" d=\"M81.859 36.775c-.207.253.161 2.344 1.517 3.723 1.355 1.356 2.184 1.356 2.734.758 1.057-1.126.207-2.183-.436-2.918-.644-.735-1.472-.482-2.23-1.218-.758-.735-1.287-.689-1.585-.345z\"/><path fill=\"#5B5B5B\" d=\"M81.882 36.797c-.206.25.159 2.323 1.503 3.689 1.343 1.343 2.164 1.343 2.71.751 1.047-1.116.205-2.164-.433-2.893s-1.457-.478-2.209-1.207c-.752-.727-1.276-.682-1.571-.34z\"/><path fill=\"#606060\" d=\"M81.905 36.818c-.204.249.158 2.302 1.489 3.656 1.333 1.331 2.145 1.331 2.686.745 1.038-1.106.203-2.144-.429-2.866-.632-.723-1.444-.474-2.188-1.196s-1.266-.677-1.558-.339z\"/><path fill=\"#666\" d=\"M81.927 36.84c-.201.246.157 2.281 1.476 3.623 1.319 1.318 2.125 1.318 2.661.737 1.029-1.096.201-2.124-.425-2.84-.626-.716-1.431-.47-2.17-1.186-.737-.714-1.252-.67-1.542-.334z\"/><g transform=\"translate(-3.405 19.001)\"><path fill=\"#fc0\" d=\"M57.6 18.004c.639.441.656.519 1.598 1.135 1.498 1.216 4.16 1.49 5.464 1.533 2.98.474 8.31-2.312 10.419-3.587 1.063-.795 3.029-2.438 3.765-2.466.453.479-.213.579-1.158 1.219-1.262.897-2.341 1.665-4.253 2.75-2.046 1.07-5.19 2.839-9.217 2.601-2.113-.31-2.12-.331-3.424-.997-.776-.56-2.552-1.488-3.194-2.188z\"/><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.579\" y1=\"-130.856\" x2=\"-240.246\" y2=\"-130.856\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#FAC700\"/><stop offset=\".415\" stop-color=\"#F7C400\"/><stop offset=\"1\" stop-color=\"#F7C400\"/></linearGradient><path fill=\"url(#c)\" d=\"M57.585 17.999c.622.411.699.53 1.641 1.147 1.491 1.206 4.105 1.49 5.423 1.538 3.024.469 8.411-2.354 10.447-3.603 1.084-.809 3.017-2.42 3.743-2.455.441.476-.235.571-1.19 1.231-1.255.889-2.298 1.636-4.188 2.707-2.031 1.062-5.191 2.84-9.213 2.616-2.119-.305-2.212-.345-3.474-.994-.798-.567-2.543-1.481-3.189-2.187z\"/><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.591\" y1=\"-130.857\" x2=\"-240.258\" y2=\"-130.857\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#F6C200\"/><stop offset=\".415\" stop-color=\"#EFBC00\"/><stop offset=\"1\" stop-color=\"#EFBC00\"/></linearGradient><path fill=\"url(#d)\" d=\"M57.569 17.992c.605.382.742.542 1.684 1.161 1.483 1.195 4.052 1.491 5.382 1.542 3.067.464 8.513-2.398 10.475-3.619 1.105-.823 3.004-2.403 3.722-2.444.428.47-.257.563-1.224 1.245-1.25.879-2.256 1.605-4.124 2.663-2.016 1.055-5.191 2.84-9.209 2.633-2.124-.3-2.303-.361-3.522-.992-.818-.575-2.534-1.474-3.184-2.189z\"/><linearGradient id=\"e\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.604\" y1=\"-130.859\" x2=\"-240.269\" y2=\"-130.859\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#F1BD00\"/><stop offset=\".415\" stop-color=\"#E8B500\"/><stop offset=\"1\" stop-color=\"#E8B500\"/></linearGradient><path fill=\"url(#e)\" d=\"M57.553 17.986c.59.353.786.553 1.729 1.174 1.475 1.183 3.997 1.49 5.341 1.545 3.109.46 8.613-2.441 10.501-3.633 1.128-.838 2.994-2.387 3.702-2.434.415.466-.279.555-1.256 1.257-1.244.872-2.215 1.577-4.058 2.622-2.001 1.046-5.191 2.84-9.206 2.649-2.132-.296-2.395-.376-3.572-.99-.841-.582-2.527-1.468-3.181-2.19z\"/><linearGradient id=\"f\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.618\" y1=\"-130.86\" x2=\"-240.282\" y2=\"-130.86\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#EDB800\"/><stop offset=\".415\" stop-color=\"#E0AD00\"/><stop offset=\"1\" stop-color=\"#E0AD00\"/></linearGradient><path fill=\"url(#f)\" d=\"M57.537 17.98c.573.323.83.566 1.772 1.187 1.467 1.172 3.942 1.49 5.301 1.55 3.153.455 8.713-2.484 10.527-3.648 1.148-.852 2.983-2.37 3.679-2.423.403.46-.299.546-1.288 1.269-1.238.863-2.173 1.547-3.993 2.579-1.985 1.039-5.191 2.841-9.202 2.665-2.138-.292-2.487-.391-3.62-.988-.861-.59-2.518-1.462-3.176-2.191z\"/><linearGradient id=\"g\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.629\" y1=\"-130.862\" x2=\"-240.292\" y2=\"-130.862\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#E9B300\"/><stop offset=\".415\" stop-color=\"#D8A500\"/><stop offset=\"1\" stop-color=\"#D8A500\"/></linearGradient><path fill=\"url(#g)\" d=\"M57.523 17.974c.557.293.872.577 1.815 1.2 1.46 1.162 3.888 1.49 5.26 1.554 3.195.45 8.814-2.527 10.555-3.664 1.169-.866 2.97-2.353 3.658-2.413.39.456-.321.539-1.321 1.282-1.231.854-2.13 1.517-3.929 2.536-1.97 1.031-5.19 2.841-9.198 2.681-2.144-.287-2.579-.405-3.668-.985-.884-.597-2.512-1.455-3.172-2.191z\"/><linearGradient id=\"h\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.642\" y1=\"-130.863\" x2=\"-240.304\" y2=\"-130.863\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#E4AE00\"/><stop offset=\".415\" stop-color=\"#D19E00\"/><stop offset=\"1\" stop-color=\"#D19E00\"/></linearGradient><path fill=\"url(#h)\" d=\"M57.506 17.968c.54.264.916.589 1.859 1.213 1.452 1.15 3.834 1.49 5.219 1.559 3.238.445 8.916-2.571 10.582-3.68 1.191-.88 2.959-2.335 3.638-2.402.377.451-.342.531-1.354 1.295-1.225.845-2.088 1.488-3.864 2.493-1.955 1.023-5.191 2.842-9.195 2.697-2.15-.282-2.67-.421-3.716-.984-.906-.604-2.503-1.447-3.169-2.191z\"/><linearGradient id=\"i\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.655\" y1=\"-130.864\" x2=\"-240.315\" y2=\"-130.864\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#E0A900\"/><stop offset=\".415\" stop-color=\"#C99600\"/><stop offset=\"1\" stop-color=\"#C99600\"/></linearGradient><path fill=\"url(#i)\" d=\"M57.491 17.962c.523.234.959.601 1.902 1.226 1.445 1.14 3.779 1.49 5.178 1.562 3.281.44 9.017-2.614 10.609-3.696 1.213-.893 2.948-2.317 3.616-2.39.365.446-.364.522-1.386 1.307-1.22.837-2.047 1.458-3.799 2.45-1.939 1.015-5.191 2.843-9.191 2.713-2.156-.277-2.761-.436-3.766-.981-.927-.611-2.494-1.44-3.163-2.191z\"/><linearGradient id=\"j\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.667\" y1=\"-130.866\" x2=\"-240.325\" y2=\"-130.866\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#DCA400\"/><stop offset=\".415\" stop-color=\"#C18E00\"/><stop offset=\"1\" stop-color=\"#C18E00\"/></linearGradient><path fill=\"url(#j)\" d=\"M57.475 17.957c.507.205 1.003.612 1.946 1.239 1.436 1.128 3.724 1.489 5.137 1.566 3.324.436 9.118-2.657 10.636-3.711 1.234-.908 2.936-2.301 3.596-2.38.352.441-.386.515-1.419 1.32-1.213.828-2.005 1.429-3.734 2.408-1.923 1.006-5.191 2.843-9.187 2.729-2.162-.272-2.853-.451-3.814-.979-.951-.62-2.488-1.435-3.161-2.192z\"/><linearGradient id=\"k\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.68\" y1=\"-130.866\" x2=\"-240.336\" y2=\"-130.866\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#D79F00\"/><stop offset=\".415\" stop-color=\"#BA8700\"/><stop offset=\"1\" stop-color=\"#BA8700\"/></linearGradient><path fill=\"url(#k)\" d=\"M57.46 17.95c.491.175 1.047.624 1.989 1.252 1.43 1.117 3.67 1.49 5.097 1.571 3.367.431 9.22-2.7 10.663-3.726 1.257-.922 2.925-2.284 3.574-2.37.34.437-.407.506-1.451 1.332-1.208.819-1.962 1.4-3.669 2.365-1.908.999-5.19 2.843-9.183 2.746-2.167-.268-2.944-.466-3.863-.977-.974-.626-2.481-1.427-3.157-2.193z\"/><linearGradient id=\"l\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.693\" y1=\"-130.867\" x2=\"-240.346\" y2=\"-130.867\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#D39B00\"/><stop offset=\".415\" stop-color=\"#B27F00\"/><stop offset=\"1\" stop-color=\"#B27F00\"/></linearGradient><path fill=\"url(#l)\" d=\"M57.443 17.944c.475.146 1.091.636 2.033 1.266 1.422 1.106 3.617 1.489 5.058 1.575 3.409.425 9.32-2.744 10.69-3.742 1.277-.936 2.912-2.267 3.552-2.359.327.432-.429.499-1.484 1.345-1.202.811-1.921 1.37-3.605 2.322-1.892.991-5.19 2.844-9.179 2.761-2.173-.263-3.037-.48-3.912-.975-.994-.633-2.472-1.42-3.153-2.193z\"/><linearGradient id=\"m\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.705\" y1=\"-130.868\" x2=\"-240.357\" y2=\"-130.868\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#CF9600\"/><stop offset=\".415\" stop-color=\"#a70\"/><stop offset=\"1\" stop-color=\"#a70\"/></linearGradient><path fill=\"url(#m)\" d=\"M57.428 17.938c.458.116 1.134.647 2.077 1.278 1.414 1.095 3.562 1.489 5.016 1.579 3.452.421 9.421-2.786 10.717-3.757 1.299-.95 2.901-2.25 3.532-2.349.314.427-.45.491-1.517 1.357-1.196.802-1.878 1.34-3.54 2.28-1.877.982-5.19 2.844-9.175 2.778-2.18-.259-3.128-.496-3.961-.973-1.017-.64-2.464-1.412-3.149-2.193z\"/><linearGradient id=\"n\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.718\" y1=\"-130.869\" x2=\"-240.367\" y2=\"-130.869\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#CA9100\"/><stop offset=\".415\" stop-color=\"#A37000\"/><stop offset=\"1\" stop-color=\"#A37000\"/></linearGradient><path fill=\"url(#n)\" d=\"M57.413 17.932c.442.086 1.176.659 2.12 1.291 1.407 1.084 3.507 1.49 4.976 1.583 3.495.416 9.522-2.829 10.744-3.773 1.321-.964 2.889-2.231 3.51-2.337.302.422-.471.483-1.549 1.371-1.189.793-1.836 1.311-3.475 2.237-1.862.974-5.19 2.844-9.171 2.794-2.186-.255-3.22-.511-4.009-.971-1.041-.648-2.458-1.407-3.146-2.195z\"/><linearGradient id=\"o\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.731\" y1=\"-130.869\" x2=\"-240.377\" y2=\"-130.869\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#C68C00\"/><stop offset=\".415\" stop-color=\"#9B6800\"/><stop offset=\"1\" stop-color=\"#9B6800\"/></linearGradient><path fill=\"url(#o)\" d=\"M57.397 17.926c.426.057 1.221.67 2.164 1.305 1.399 1.073 3.454 1.489 4.935 1.587 3.538.412 9.623-2.873 10.772-3.788 1.342-.979 2.877-2.215 3.488-2.327.289.417-.493.475-1.582 1.383-1.184.785-1.794 1.281-3.41 2.194-1.847.966-5.191 2.845-9.168 2.81-2.194-.25-3.312-.525-4.059-.968-1.061-.657-2.448-1.401-3.14-2.196z\"/><linearGradient id=\"p\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.744\" y1=\"-130.87\" x2=\"-240.387\" y2=\"-130.87\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#C28700\"/><stop offset=\".415\" stop-color=\"#936000\"/><stop offset=\"1\" stop-color=\"#936000\"/></linearGradient><path fill=\"url(#p)\" d=\"M57.381 17.92c.409.027 1.263.682 2.207 1.318 1.392 1.062 3.399 1.489 4.894 1.592 3.581.406 9.725-2.916 10.798-3.804 1.364-.992 2.866-2.198 3.468-2.316.275.413-.516.467-1.615 1.396-1.177.776-1.752 1.252-3.345 2.151-1.832.959-5.191 2.846-9.164 2.826-2.2-.245-3.403-.541-4.106-.966-1.083-.664-2.441-1.394-3.137-2.197z\"/><linearGradient id=\"q\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.756\" y1=\"-130.871\" x2=\"-240.396\" y2=\"-130.871\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#BD8200\"/><stop offset=\".415\" stop-color=\"#8C5900\"/><stop offset=\"1\" stop-color=\"#8C5900\"/></linearGradient><path fill=\"url(#q)\" d=\"M57.366 17.914c.393-.002 1.306.694 2.25 1.331 1.384 1.051 3.345 1.489 4.853 1.596 3.624.402 9.826-2.958 10.826-3.819 1.385-1.006 2.855-2.181 3.447-2.306.262.408-.537.458-1.647 1.408-1.172.768-1.71 1.222-3.28 2.109-1.816.95-5.19 2.845-9.16 2.842-2.204-.241-3.495-.556-4.155-.964-1.106-.671-2.435-1.386-3.134-2.197z\"/><linearGradient id=\"r\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.769\" y1=\"-130.871\" x2=\"-240.406\" y2=\"-130.871\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#B97D00\"/><stop offset=\".415\" stop-color=\"#845100\"/><stop offset=\"1\" stop-color=\"#845100\"/></linearGradient><path fill=\"url(#r)\" d=\"M57.351 17.908c.376-.032 1.349.706 2.293 1.344 1.376 1.04 3.29 1.489 4.812 1.6 3.666.397 9.926-3.002 10.853-3.834 1.406-1.021 2.842-2.163 3.424-2.295.25.403-.558.451-1.68 1.421-1.166.759-1.668 1.193-3.215 2.066-1.8.942-5.19 2.846-9.156 2.858-2.211-.235-3.586-.571-4.204-.962-1.126-.679-2.425-1.38-3.127-2.198z\"/><linearGradient id=\"s\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.782\" y1=\"-130.872\" x2=\"-240.415\" y2=\"-130.872\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#B57800\"/><stop offset=\".415\" stop-color=\"#7C4900\"/><stop offset=\"1\" stop-color=\"#7C4900\"/></linearGradient><path fill=\"url(#s)\" d=\"M57.335 17.901c.36-.061 1.393.718 2.337 1.357 1.368 1.029 3.235 1.489 4.772 1.604 3.709.392 10.027-3.045 10.879-3.851 1.428-1.034 2.831-2.146 3.404-2.284.238.398-.58.443-1.712 1.434-1.16.75-1.626 1.163-3.15 2.023-1.785.935-5.191 2.847-9.153 2.875-2.217-.231-3.679-.586-4.253-.959-1.148-.685-2.417-1.373-3.124-2.199z\"/><linearGradient id=\"t\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.794\" y1=\"-130.872\" x2=\"-240.424\" y2=\"-130.872\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#B07300\"/><stop offset=\".415\" stop-color=\"#754200\"/><stop offset=\"1\" stop-color=\"#754200\"/></linearGradient><path fill=\"url(#t)\" d=\"M57.319 17.896c.343-.091 1.437.729 2.381 1.37 1.361 1.018 3.181 1.489 4.731 1.608 3.752.387 10.128-3.089 10.907-3.866 1.45-1.048 2.819-2.128 3.383-2.273.225.393-.601.435-1.745 1.446-1.153.742-1.584 1.134-3.086 1.98-1.769.926-5.19 2.847-9.149 2.891-2.223-.227-3.769-.602-4.301-.958-1.171-.693-2.41-1.365-3.121-2.198z\"/><linearGradient id=\"u\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.807\" y1=\"-130.872\" x2=\"-240.433\" y2=\"-130.872\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#AC6E00\"/><stop offset=\".415\" stop-color=\"#6D3A00\"/><stop offset=\"1\" stop-color=\"#6D3A00\"/></linearGradient><path fill=\"url(#u)\" d=\"M57.303 17.89c.327-.12 1.481.74 2.425 1.383 1.354 1.006 3.126 1.488 4.69 1.612 3.795.382 10.229-3.132 10.934-3.881 1.471-1.062 2.807-2.112 3.361-2.263.212.389-.623.427-1.777 1.459-1.149.732-1.542 1.104-3.021 1.938-1.755.918-5.191 2.847-9.145 2.906-2.23-.222-3.862-.616-4.351-.956-1.192-.699-2.401-1.358-3.116-2.198z\"/><linearGradient id=\"v\" gradientUnits=\"userSpaceOnUse\" x1=\"-257.82\" y1=\"-130.873\" x2=\"-240.441\" y2=\"-130.873\" gradientTransform=\"translate(375.489 179.416) scale(1.234)\"><stop offset=\"0\" stop-color=\"#A86A00\"/><stop offset=\".415\" stop-color=\"#663200\"/><stop offset=\"1\" stop-color=\"#663200\"/></linearGradient><path fill=\"url(#v)\" d=\"M57.288 17.884c.311-.15 1.523.752 2.468 1.396 1.345.996 3.073 1.489 4.649 1.617 3.838.377 10.331-3.175 10.961-3.896 1.493-1.076 2.796-2.095 3.34-2.252.2.384-.645.419-1.809 1.472-1.143.724-1.501 1.075-2.957 1.895-1.738.91-5.19 2.848-9.141 2.922-2.236-.217-3.953-.631-4.399-.953-1.215-.709-2.394-1.354-3.112-2.201z\"/></g></svg>"

/***/ }),

/***/ "../src/components/linux/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LinuxOriginal = __webpack_require__("../src/components/linux/original/LinuxOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinuxOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/linux/plain/LinuxPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _LinuxPlain = __webpack_require__("../src/components/linux/plain/LinuxPlain.svg");
	
	var _LinuxPlain2 = _interopRequireDefault(_LinuxPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** LinuxPlain */
	function LinuxPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'LinuxPlain',
	    svg: _LinuxPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	LinuxPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = LinuxPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/linux/plain/LinuxPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M113.823 104.595c-1.795-1.478-3.629-2.921-5.308-4.525-1.87-1.785-3.045-3.944-2.789-6.678.147-1.573-.216-2.926-2.113-3.452.446-1.154.864-1.928 1.033-2.753.188-.92.178-1.887.204-2.834.264-9.96-3.334-18.691-8.663-26.835-2.454-3.748-5.017-7.429-7.633-11.066-4.092-5.688-5.559-12.078-5.633-18.981a47.564 47.564 0 0 0-1.081-9.475C80.527 11.956 77.291 7.233 71.422 4.7c-4.497-1.942-9.152-2.327-13.901-1.084-6.901 1.805-11.074 6.934-10.996 14.088.074 6.885.417 13.779.922 20.648.288 3.893-.312 7.252-2.895 10.34-2.484 2.969-4.706 6.172-6.858 9.397-1.229 1.844-2.317 3.853-3.077 5.931-2.07 5.663-3.973 11.373-7.276 16.5-1.224 1.9-1.363 4.026-.494 6.199.225.563.363 1.429.089 1.882-2.354 3.907-5.011 7.345-10.066 8.095-3.976.591-4.172 1.314-4.051 5.413.1 3.337.061 6.705-.28 10.021-.363 3.555.008 4.521 3.442 5.373 7.924 1.968 15.913 3.647 23.492 6.854 3.227 1.365 6.465.891 9.064-1.763 2.713-2.771 6.141-3.855 9.844-3.859 6.285-.005 12.572.298 18.86.369 1.702.02 2.679.653 3.364 2.199.84 1.893 2.26 3.284 4.445 3.526 4.193.462 8.013-.16 11.19-3.359 3.918-3.948 8.436-7.066 13.615-9.227 1.482-.619 2.878-1.592 4.103-2.648 2.231-1.922 2.113-3.146-.135-5zM62.426 24.12c.758-2.601 2.537-4.289 5.243-4.801 2.276-.43 4.203.688 5.639 3.246 1.546 2.758 2.054 5.64.734 8.658-1.083 2.474-1.591 2.707-4.123 1.868-.474-.157-.937-.343-1.777-.652.708-.594 1.154-1.035 1.664-1.382 1.134-.772 1.452-1.858 1.346-3.148-.139-1.694-1.471-3.194-2.837-3.175-1.225.017-2.262 1.167-2.4 2.915-.086 1.089.095 2.199.173 3.589-3.446-1.023-4.711-3.525-3.662-7.118zm-12.75-2.251c1.274-1.928 3.197-2.314 5.101-1.024 2.029 1.376 3.547 5.256 2.763 7.576-.285.844-1.127 1.5-1.716 2.241l-.604-.374c-.23-1.253-.276-2.585-.757-3.733-.304-.728-1.257-1.184-1.919-1.762-.622.739-1.693 1.443-1.757 2.228-.088 1.084.477 2.28.969 3.331.311.661 1.001 1.145 1.713 1.916l-1.922 1.51c-3.018-2.7-3.915-8.82-1.871-11.909zM87.34 86.075c-.203 2.604-.5 2.713-3.118 3.098-1.859.272-2.359.756-2.453 2.964a101.744 101.744 0 0 0-.012 7.753c.061 1.77-.537 3.158-1.755 4.393-6.764 6.856-14.845 10.105-24.512 8.926-4.17-.509-6.896-3.047-9.097-6.639.98-.363 1.705-.607 2.412-.894 3.122-1.27 3.706-3.955 1.213-6.277-1.884-1.757-3.986-3.283-6.007-4.892-1.954-1.555-3.934-3.078-5.891-4.629-1.668-1.323-2.305-3.028-2.345-5.188-.094-5.182.972-10.03 3.138-14.747 1.932-4.209 3.429-8.617 5.239-12.885.935-2.202 1.906-4.455 3.278-6.388 1.319-1.854 2.134-3.669 1.988-5.94-.084-1.276-.016-2.562-.016-3.843l.707-.352c1.141.985 2.302 1.949 3.423 2.959 4.045 3.646 7.892 3.813 12.319.67 1.888-1.341 3.93-2.47 5.927-3.652.497-.294 1.092-.423 1.934-.738 2.151 5.066 4.262 10.033 6.375 15 1.072 2.524 1.932 5.167 3.264 7.547 2.671 4.775 4.092 9.813 4.07 15.272-.012 2.83.137 5.67-.081 8.482z\"/></svg>"

/***/ }),

/***/ "../src/components/linux/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LinuxPlain = __webpack_require__("../src/components/linux/plain/LinuxPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinuxPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/meteor/original-wordmark/MeteorOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MeteorOriginalWordmark = __webpack_require__("../src/components/meteor/original-wordmark/MeteorOriginalWordmark.svg");
	
	var _MeteorOriginalWordmark2 = _interopRequireDefault(_MeteorOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MeteorOriginalWordmark */
	function MeteorOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MeteorOriginalWordmark',
	    svg: _MeteorOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MeteorOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MeteorOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/meteor/original-wordmark/MeteorOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M10.3 67.8C8.7 65.2 7.1 62 5.5 60H1v19h4V66c1 .8 1.2 1.8 1.8 2.6.6.9 1.2 1.8 1.8 2.6.6.8.9 1.7 1.5 2.6 1.7-2.7 2.9-5.2 4.9-8V79h5V60h-4.8c-1.6 2-3.2 5.2-4.9 7.8zM123 71.9c.6-.4 1.2-.9 1.7-1.3 1.4-.9 2-2.4 2.2-4 .1-.7 0-1.5 0-2.2l-.1-.7c-.2-.8-.6-1.5-1.1-2.2-.5-.8-1.3-1-1.9-1.5-1.1-.3-2.2-.7-3.4-.7-2.7.1-5.6 0-8.4 0h-.9v19.6h5v-6h2.7c1.3 2 2.7 4 3.9 6h4.7c-1.4-1.9-3-4.8-4.4-7zm-.6-5c-.4.7-.9 1.2-1.8 1.3-.6.1-.9.2-1.5.2h-3.2v-5.5h3.9c.5 0 .9.1 1.3.3.7.3 1.2.9 1.5 1.6.5.8.4 1.2-.2 2.1zM25 79h14v-4H29v-4.4c0-.1.1.4.2.4H38v-3h-9v-4h10v-4H25v19zm43.9-4.7c.1-1.3.1-2.5.1-3.7 0-.1-.1.4 0 .4h9v-3h-9v-4h10v-4H65v19h14v-4.7H68.9zM44 63.1h5.7s.2 0 .2.1v14.6h4V63.9h5v-4h-15c.1 1.1.1 2 .1 3.2z\"/><path d=\"M105.7 64.3c.3 0 .5-.2.5-.5 0-.1 0-.2-.1-.3l-6.6-6.1 5.8 6.6c.1.2.2.3.4.3zm1.4 3.4L92.7 54.6l13.1 14.3c.2.1.4.2.6.2.5 0 .8-.4.8-.8.1-.3 0-.5-.1-.6zm-6.3 8.8L80.1 57.4l19.1 20.8c.2.2.5.4.9.4.6 0 1.2-.5 1.2-1.2-.1-.3-.3-.7-.5-.9zM77.7 49.4l25.3 27c.2.2.5.3.8.3.6 0 1.2-.5 1.2-1.2 0-.2-.1-.5-.2-.7-.1 0-27.1-25.4-27.1-25.4zm28.8 21.8L85.8 52.1l19.1 20.8c.2.2.5.4.9.4.6 0 1.2-.5 1.2-1.2-.1-.3-.3-.7-.5-.9zm-10 5.9c0-.1-.1-.1 0 0L82.1 64l13.1 14.3c.2.1.4.2.6.2.5 0 .8-.4.8-.8.1-.3 0-.5-.1-.6zm-11-6.6l5.8 6.6c.1.1.2.3.4.3.3 0 .5-.2.5-.5 0-.1 0-.2-.1-.3-.1-.1-6.6-6.1-6.6-6.1z\" fill=\"#DF5052\"/></svg>"

/***/ }),

/***/ "../src/components/meteor/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MeteorOriginalWordmark = __webpack_require__("../src/components/meteor/original-wordmark/MeteorOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MeteorOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/meteor/original/MeteorOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MeteorOriginal = __webpack_require__("../src/components/meteor/original/MeteorOriginal.svg");
	
	var _MeteorOriginal2 = _interopRequireDefault(_MeteorOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MeteorOriginal */
	function MeteorOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MeteorOriginal',
	    svg: _MeteorOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MeteorOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MeteorOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/meteor/original/MeteorOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M120.3 65.4c1.2 0 2.1-.9 2.1-2.1 0-.5-.2-1-.5-1.3-.1-.2-28-25.8-28-25.8l24.6 28.1c.3.7 1 1.1 1.8 1.1zm5.7 14.3l-.2-.2L65 24l55.7 60.6.2.2c.6.6 1.5 1 2.5 1 2 0 3.6-1.6 3.6-3.6 0-.9-.4-1.8-1-2.5zm-26.9 37.6l-88-81.5 81.1 88.5c.9 1 2.2 1.7 3.7 1.7 2.7 0 4.9-2.2 4.9-4.9 0-1.5-.6-2.9-1.7-3.8zM1 2l107.6 114.6.1.1c.9.9 2.1 1.4 3.4 1.4 2.7 0 4.9-2.2 4.9-4.9 0-1-.3-2-.9-2.8C115.8 109.9 1 2 1 2zm122.4 92.8l-88-81.5 81.1 88.5c.9 1 2.2 1.7 3.7 1.7 2.7 0 4.9-2.2 4.9-4.9 0-1.6-.7-2.9-1.7-3.8zm-42.5 24.8l-.2-.2-60.8-55.5 55.7 60.6.2.2c.6.6 1.5 1 2.5 1 2 0 3.6-1.6 3.6-3.6 0-1-.4-1.8-1-2.5zM34.1 91.7l24.6 28.1c.4.6 1 1.1 1.8 1.1 1.2 0 2.1-.9 2.1-2.1 0-.5-.2-1-.5-1.3-.2-.1-28-25.8-28-25.8z\" fill=\"#DF5052\"/></svg>"

/***/ }),

/***/ "../src/components/meteor/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MeteorOriginal = __webpack_require__("../src/components/meteor/original/MeteorOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MeteorOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/meteor/plain-wordmark/MeteorPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MeteorPlainWordmark = __webpack_require__("../src/components/meteor/plain-wordmark/MeteorPlainWordmark.svg");
	
	var _MeteorPlainWordmark2 = _interopRequireDefault(_MeteorPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MeteorPlainWordmark */
	function MeteorPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MeteorPlainWordmark',
	    svg: _MeteorPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MeteorPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MeteorPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/meteor/plain-wordmark/MeteorPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M10.2 67.8C8.5 65.2 6.9 62 5.3 60H1v19h4V66c1 .8 1.1 1.8 1.7 2.6.6.9 1.2 1.8 1.8 2.6.6.8.9 1.7 1.6 2.6 1.7-2.7 3-5.2 5-8C15 70 15 75 15 79h5V60h-5c-1.6 2-3.2 5.2-4.8 7.8zm112.6 4.1c.6-.4 1.2-.9 1.7-1.3 1.4-.9 2-2.4 2.2-4 .1-.7 0-1.5 0-2.2l-.1-.7c-.2-.8-.6-1.5-1.1-2.2-.5-.8-1.3-1-1.9-1.5-1.1-.3-2.2-.7-3.4-.7-2.7.1-5.5 0-8.3 0h-.8v19.6h5v-6h2.5c1.3 2 2.7 4 3.9 6h4.7c-1.4-1.9-3-4.8-4.4-7zm-.6-5c-.4.7-.9 1.2-1.8 1.3-.6.1-.8.2-1.4.2h-3.1v-5.5h3.8c.5 0 .8.1 1.3.3.7.3 1.1.9 1.4 1.6.5.8.4 1.2-.2 2.1zM25 79h14v-4H29v-4h9v-3h-9v-4h10v-4H25v19zm40 0h14v-4.7H68.8l.2-.1V71h9v-3h-9v-4h10v-4H65v19zM44 63.1h5.7s.3 0 .3.1v14.6h4V63.9h5v-4H44v3.2zm61.6 1.2c.3 0 .5-.2.5-.5 0-.1 0-.2-.1-.3l-6.6-6.1 5.8 6.6c0 .2.2.3.4.3zm1.3 3.4L92.6 54.6l13.1 14.3c.2.1.4.2.6.2.5 0 .8-.4.8-.8 0-.3-.1-.5-.2-.6zm-27-10.3L99 78.2c.2.2.5.4.9.4.6 0 1.2-.5 1.2-1.2 0-.4-.2-.7-.4-.9L79.9 57.4zm-2.4-8l25.3 26.9c.2.2.5.3.8.3.6 0 1.2-.5 1.2-1.2 0-.2-.1-.5-.2-.7-.1.1-27.1-25.3-27.1-25.3zm8.1 2.7l19.1 20.8c.2.2.5.4.9.4.6 0 1.2-.5 1.2-1.2 0-.4-.2-.7-.4-.9L85.6 52.1zm10.7 25L82 64l13.1 14.3c.2.1.4.2.6.2.5 0 .8-.4.8-.8 0-.3-.1-.5-.2-.6zm-11-6.6l5.8 6.6c.1.1.2.3.4.3.3 0 .5-.2.5-.5 0-.1 0-.2-.1-.3-.1-.1-6.6-6.1-6.6-6.1z\" fill=\"#DF5052\"/></svg>"

/***/ }),

/***/ "../src/components/meteor/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MeteorPlainWordmark = __webpack_require__("../src/components/meteor/plain-wordmark/MeteorPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MeteorPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/meteor/plain/MeteorPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MeteorPlain = __webpack_require__("../src/components/meteor/plain/MeteorPlain.svg");
	
	var _MeteorPlain2 = _interopRequireDefault(_MeteorPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MeteorPlain */
	function MeteorPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MeteorPlain',
	    svg: _MeteorPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MeteorPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MeteorPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/meteor/plain/MeteorPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M120.3 65.4c1.2 0 2.1-.9 2.1-2.1 0-.5-.2-1-.5-1.3-.1-.2-28-25.8-28-25.8l24.6 28.1c.3.7 1 1.1 1.8 1.1zm5.7 14.3l-.2-.2L65 24l55.7 60.6.2.2c.6.6 1.5 1 2.5 1 2 0 3.6-1.6 3.6-3.6 0-.9-.4-1.8-1-2.5zm-26.9 37.6l-88-81.5 81.1 88.5c.9 1 2.2 1.7 3.7 1.7 2.7 0 4.9-2.2 4.9-4.9 0-1.5-.6-2.9-1.7-3.8zM1 2l107.6 114.6.1.1c.9.9 2.1 1.4 3.4 1.4 2.7 0 4.9-2.2 4.9-4.9 0-1-.3-2-.9-2.8C115.8 109.9 1 2 1 2zm122.4 92.8l-88-81.5 81.1 88.5c.9 1 2.2 1.7 3.7 1.7 2.7 0 4.9-2.2 4.9-4.9 0-1.6-.7-2.9-1.7-3.8zm-42.5 24.8l-.2-.2-60.8-55.5 55.7 60.6.2.2c.6.6 1.5 1 2.5 1 2 0 3.6-1.6 3.6-3.6 0-1-.4-1.8-1-2.5zM34.1 91.7l24.6 28.1c.4.6 1 1.1 1.8 1.1 1.2 0 2.1-.9 2.1-2.1 0-.5-.2-1-.5-1.3-.2-.1-28-25.8-28-25.8z\" fill=\"#DF5052\"/></svg>"

/***/ }),

/***/ "../src/components/meteor/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MeteorPlain = __webpack_require__("../src/components/meteor/plain/MeteorPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MeteorPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mocha/plain/MochaPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MochaPlain = __webpack_require__("../src/components/mocha/plain/MochaPlain.svg");
	
	var _MochaPlain2 = _interopRequireDefault(_MochaPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MochaPlain */
	function MochaPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MochaPlain',
	    svg: _MochaPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MochaPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MochaPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mocha/plain/MochaPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 112 126.38\"><defs><style>.cls-1{fill:#8d6748}</style></defs><title>mocha</title><g id=\"plain\"><path class=\"cls-1\" d=\"M91.78 58.77l-2.3 5.42h4.61l-2.31-5.42z\"/><path class=\"cls-1\" d=\"M60.91 52h4a1 1 0 0 0 .54-.24C67.77 49 68.1 43.6 68.1 41.7a.7.7 0 0 0-.68-.7h-9a.68.68 0 0 0-.68.68c.07 1.9.34 7.36 2.65 10.08a.65.65 0 0 0 .52.24zm4.41-5.16C67 46.23 67 45.62 67 45.62a10.69 10.69 0 0 1-2 5.24.51.51 0 0 1-.41.15h-3.34c-.14 0-.34 0-.41-.15a9.6 9.6 0 0 1-1.7-3.77s3.94.56 6.18-.25z\" transform=\"translate(-8 -.81)\"/><path class=\"cls-1\" d=\"M116.42 29.94L67.48 1.72a6.83 6.83 0 0 0-6.83 0L11.6 29.94A6.9 6.9 0 0 0 8 35.78v56.44a7 7 0 0 0 3.58 5.83l48.94 28.22a6.83 6.83 0 0 0 6.83 0l49.05-28.21a7.14 7.14 0 0 0 3.6-5.83V35.78a7 7 0 0 0-3.58-5.84zM112 88.29a5.77 5.77 0 0 1-2.94 5l-42.2 24.37a5.65 5.65 0 0 1-5.84 0L18.87 93.31a5.63 5.63 0 0 1-2.87-5V39.58a5.71 5.71 0 0 1 2.87-5L61 10.2a5.6 5.6 0 0 1 5.82 0l42.21 24.35a5.69 5.69 0 0 1 2.93 5z\" transform=\"translate(-8 -.81)\"/><circle class=\"cls-1\" cx=\"40\" cy=\"62.53\" r=\"4.84\"/><path class=\"cls-1\" d=\"M108.06 36.32L65.85 12a3.87 3.87 0 0 0-1.91-.54A4.06 4.06 0 0 0 62 12L19.87 36.32A3.88 3.88 0 0 0 18 39.65v48.7a3.87 3.87 0 0 0 1.87 3.32L62 116a3.62 3.62 0 0 0 1.89.54 3.82 3.82 0 0 0 1.9-.54l42.23-24.35a3.94 3.94 0 0 0 1.98-3.3v-48.7a3.94 3.94 0 0 0-1.94-3.33zM67 68.19a4.8 4.8 0 0 0 3.65-1.69l1.52 1.5a7.7 7.7 0 0 1-1.08 1 5.9 5.9 0 0 1-1.22.75 5 5 0 0 1-1.42.47 8.33 8.33 0 0 1-1.83.14 6.72 6.72 0 0 1-4.88-2 6.1 6.1 0 0 1-1.3-2.24 7.34 7.34 0 0 1-.44-2.73v-.07a7.12 7.12 0 0 1 .42-2.71 7.63 7.63 0 0 1 1.36-2.24A6.35 6.35 0 0 1 64 56.88a7.53 7.53 0 0 1 2.83-.54 13.09 13.09 0 0 1 1.69.14c.54.14.95.27 1.42.41a6.43 6.43 0 0 1 1.15.68 11.79 11.79 0 0 1 1 .88l-1.56 1.63A4.83 4.83 0 1 0 67 68.19zm-2.83-37.63c-.34.47.07 1.63.95 3a2.83 2.83 0 0 1-.95 4 3.83 3.83 0 0 0-.75-2.31c-1.62-2.46-.13-3.61.75-4.69zm-2.71 2.51c-.27.27 0 1.09.61 2a1.91 1.91 0 0 1-.61 2.71 2.74 2.74 0 0 0-.46-1.53c-1.1-1.69-.15-2.44.46-3.18zM56.5 39h12.76a.64.64 0 0 1 .68.63c0 2.37-.34 10.37-3.74 14.14a.64.64 0 0 1-.47.23H60a.67.67 0 0 1-.47-.26c-3.37-3.86-3.7-11.74-3.7-14.08a.66.66 0 0 1 .67-.66zM21 49h34.35s.07 0 .07 1H21zm34 14.32v.07a7.37 7.37 0 0 1-.47 2.71 6.7 6.7 0 0 1-1.46 2.24 6.4 6.4 0 0 1-2.22 1.49 6.63 6.63 0 0 1-2.84.54 7.86 7.86 0 0 1-2.84-.54 6.47 6.47 0 0 1-2.24-1.49 6.3 6.3 0 0 1-1.41-2.24 7.16 7.16 0 0 1-.52-2.71v-.07a7.43 7.43 0 0 1 .53-2.71A6.79 6.79 0 0 1 43 58.37a6.46 6.46 0 0 1 2.23-1.49 6.66 6.66 0 0 1 2.85-.54 7.88 7.88 0 0 1 2.85.54 6.48 6.48 0 0 1 2.24 1.49 6.18 6.18 0 0 1 1.35 2.24 7.14 7.14 0 0 1 .48 2.71zM29.1 67H29l-4-6.46V70h-3V57h3l4.14 6.38L33.23 57H36v13h-3v-9.53zm77.9 8H21v-1h86zM86 62v-5h2v13h-2v-6h-7v6h-2V57h2v5zm6.73 8l6-13h2.17l6 13h-2.51L103 67h-6.4l-1.42 3zM107 50H70.41c0-1 .07-1 .07-1H107z\" transform=\"translate(-8 -.81)\"/></g></svg>"

/***/ }),

/***/ "../src/components/mocha/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MochaPlain = __webpack_require__("../src/components/mocha/plain/MochaPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MochaPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mongodb/original-wordmark/MongodbOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MongodbOriginalWordmark = __webpack_require__("../src/components/mongodb/original-wordmark/MongodbOriginalWordmark.svg");
	
	var _MongodbOriginalWordmark2 = _interopRequireDefault(_MongodbOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MongodbOriginalWordmark */
	function MongodbOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MongodbOriginalWordmark',
	    svg: _MongodbOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MongodbOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MongodbOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mongodb/original-wordmark/MongodbOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#94795D\" d=\"M87.259 100.139c.169-.325.331-.612.469-.909.087-.19.221-.228.41-.223 1.133.032 2.266.067 3.4.078.963.01 1.928-.008 2.892-.019 1.086-.013 2.172-.07 3.257-.039 1.445.042 2.853.325 4.16.968 1.561.769 2.742 1.94 3.547 3.483a8.71 8.71 0 0 1 .931 3.14c.172 1.608.059 3.179-.451 4.717-.632 1.906-1.832 3.365-3.499 4.458-1.283.841-2.69 1.338-4.198 1.622-1.596.301-3.197.204-4.798.209-1.756.007-3.511-.031-5.267-.051-.307-.003-.351-.061-.27-.354l.075-.27c.171-.538.263-.562.809-.652a2.83 2.83 0 0 0 1.087-.413c.184-.122.26-.44.332-.685.062-.214.065-.449.067-.675.025-3.425.051-6.849.065-10.272a44.077 44.077 0 0 0-.065-2.596c-.034-.605-.357-1.019-1.077-1.162-.56-.111-1.124-.197-1.687-.296l-.189-.059zm16.076 8.293c-.076-.682-.113-1.37-.235-2.042-.292-1.613-.998-3.018-2.238-4.119-2.005-1.779-4.419-2.053-6.949-1.841-.576.048-.7.245-.709.837-.014.84-.028 1.68-.029 2.52-.004 2.664-.004 5.328 0 7.992.001.758.009 1.516.031 2.272.024.774.305 1.429 1.063 1.729 1.195.473 2.452.529 3.706.336 2.003-.307 3.404-1.474 4.344-3.223.744-1.388.954-2.903 1.016-4.461zm4.869 9.071c-.024-.415.146-.758.356-1.073.057-.085.253-.081.388-.108l1.146-.227c.405-.086.618-.358.675-.755.038-.262.074-.527.077-.792a879.6 879.6 0 0 0 .059-6.291c.01-2.1.002-4.2.002-6.3l-.009-.401c-.041-.675-.367-1.025-1.037-1.124l-1.453-.221c-.179-.024-.244-.11-.179-.269.112-.271.219-.552.377-.796.059-.09.258-.125.392-.122.694.01 1.388.062 2.082.061l6.041-.036c1.164-.001 2.288.202 3.332.759 1.149.612 1.792 1.559 1.976 2.849.192 1.355-.219 2.497-1.209 3.404-.407.374-.934.618-1.406.922l-.154.096c.438.161.855.3 1.261.466 1.188.487 2.133 1.248 2.633 2.463.395.959.395 1.959.161 2.953-.364 1.556-1.389 2.591-2.722 3.374-1.251.735-2.605 1.163-4.047 1.235-1.33.067-2.666.042-3.999.057l-.772.004a996.106 996.106 0 0 1-3.854-.096l-.117-.032zm5.537-6.089h.013c0 .658-.009 1.316.003 1.974.008.426-.007.864.085 1.274.138.613.418 1.166 1.106 1.342a6.671 6.671 0 0 0 2.818.124c1.177-.205 2.116-.795 2.631-1.916.382-.833.439-1.716.308-2.618-.174-1.188-.805-2.05-1.854-2.615-.688-.371-1.422-.598-2.204-.628-.876-.033-1.753-.035-2.629-.062-.246-.007-.28.118-.279.32.005.934.002 1.869.002 2.805zm1.865-4.475c.479-.024 1.021-.031 1.56-.085 1.032-.103 1.759-.622 2.138-1.609.193-.501.185-1.017.19-1.538.015-1.357-.777-2.469-2.066-2.929-.995-.355-2.021-.361-3.053-.333-.418.011-.605.194-.611.615l-.062 5.489c-.003.218.091.312.303.319l1.601.071z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#50382B\" d=\"M10.543 116.448l-.073.944c-.68 0-1.307-.005-1.934.002-1.181.012-2.362.031-3.544.048l-.114.007c-.169-.02-.476-.02-.484-.07-.05-.281-.034-.576-.021-.867.001-.033.116-.075.183-.091l.919-.205c.573-.149.775-.396.802-.988.031-.667.062-1.335.065-2.002.009-1.642-.001-3.282.006-4.924.001-.384-.132-.67-.49-.826a43.787 43.787 0 0 0-1.285-.546c-.204-.082-.469-.127-.445-.401.024-.279.281-.352.523-.407 1.002-.229 2.005-.452 3.004-.696.322-.079.63-.212 1.015-.346.02.208.057.406.053.604l-.059.941c-.001.106.054.248.133.307.048.037.209-.03.289-.092.854-.65 1.758-1.211 2.789-1.538 1.597-.507 2.968-.037 3.928 1.34.338.485.339.485.808.146.805-.585 1.647-1.101 2.589-1.441 2.068-.747 4.055.201 4.774 2.284.262.756.362 1.537.36 2.335l-.019 5.298c-.001.437.144.686.56.822.467.153.951.258 1.477.396l-.122.911c-.598 0-1.148-.004-1.698.001-1.344.012-2.688.019-4.031.05-.234.006-.295-.052-.307-.271-.039-.701-.045-.7.615-.858l.222-.057c.645-.176.86-.374.865-1.028.015-1.878.054-3.761-.041-5.635-.099-1.944-1.642-2.979-3.526-2.481a5.194 5.194 0 0 0-1.69.814c-.175.125-.208.269-.194.488.053.828.086 1.657.093 2.486.012 1.451-.006 2.902 0 4.354.002.588.203.813.784.949l.863.199.16.036c.012.276.023.552.01.828-.008.173-.142.188-.292.185-.839-.021-1.679-.049-2.518-.047-1.021.002-2.041.031-3.061.049h-.24c0-.293-.014-.573.01-.852.005-.067.123-.161.204-.182l1.006-.213c.427-.105.631-.324.655-.758.114-2.01.196-4.021.007-6.03a3.695 3.695 0 0 0-.326-1.145c-.515-1.138-1.674-1.613-3.011-1.271-.635.162-1.208.453-1.75.82a.795.795 0 0 0-.378.695c0 2.005.007 4.01.013 6.014l.011.773c.012.539.241.823.776.939.344.078.692.131 1.082.203z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4F382B\" d=\"M71.001 105.285c.155.754.152 1.432-.402 1.946-.55.511-1.246.339-1.925.225.063.358.133.662.167.97.247 2.289-.738 3.988-2.861 4.959-.802.366-1.653.502-2.522.572-.432.034-.81.364-.851.719-.042.36.184.73.636.838.533.127 1.089.163 1.636.226 1.174.134 2.361.195 3.521.405 1.754.316 2.733 1.847 2.424 3.609-.275 1.568-1.183 2.709-2.449 3.584-2.133 1.478-4.473 1.91-6.965 1.156-1.425-.432-2.43-1.369-2.777-2.885-.174-.759.011-1.446.582-1.961.679-.61 1.418-1.154 2.129-1.73l.23-.231-.264-.185c-.725-.344-1.305-.815-1.53-1.633-.077-.277.003-.459.238-.601.4-.241.798-.486 1.193-.735.186-.116.37-.236.543-.37.236-.18.215-.314-.067-.418-.656-.242-1.239-.593-1.691-1.133-.755-.901-.969-1.974-.907-3.107.097-1.77 1.058-2.936 2.62-3.686 1.857-.891 3.72-.947 5.613-.135.7.3 1.438.364 2.189.312.561-.04 1.051-.252 1.49-.711zm-6.843 12.681c-1.394-.012-1.831.16-2.649.993-.916.934-.911 2.229.003 3.167.694.711 1.56 1.044 2.523 1.144 1.125.116 2.233.069 3.255-.494 1.09-.603 1.632-1.723 1.387-2.851-.203-.931-.889-1.357-1.724-1.602-.95-.278-1.932-.331-2.795-.357zm-2.738-8.908c.051.387.072.779.158 1.158.223.982.65 1.845 1.627 2.282 1.147.515 2.612.294 3.114-1.316a4.853 4.853 0 0 0-.113-3.274 2.512 2.512 0 0 0-.91-1.184c-.996-.695-2.793-.787-3.525.749-.238.499-.331 1.03-.351 1.585z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4F372B\" d=\"M47.35 105.038c.037.171.111.365.113.56.003.371-.037.742-.058 1.113v.322l.314-.24c.86-.708 1.784-1.311 2.86-1.636 1.942-.585 3.882.478 4.515 2.456.24.752.335 1.525.344 2.311.02 1.746.032 3.492.05 5.238.006.627.078.739.671.92a7.4 7.4 0 0 0 1.03.229c.191.03.273.105.263.292l.002.172c-.007.723-.057.756-.758.754-1.678-.003-3.355.007-5.033.021-.5.004-.501.019-.551-.475l-.01-.284c.031-.426.041-.422.46-.484.282-.042.562-.107.837-.179.283-.073.419-.282.457-.562.019-.142.044-.284.043-.426-.024-1.908.007-3.818-.097-5.723-.084-1.541-1.26-2.459-2.807-2.354a4.047 4.047 0 0 0-2.071.743c-.413.289-.496.706-.494 1.155.008 1.784.025 3.568.044 5.353.004.391.015.782.052 1.17.039.424.188.595.604.687.398.088.804.139 1.229.21l.036.328c.014.765-.066.822-.809.819-1.735-.007-3.47.004-5.204.023-.273.004-.389-.082-.382-.348l-.004-.114c-.045-.689-.025-.715.627-.827l.308-.062c.706-.159.887-.347.897-1.064.033-2.271.045-4.541.068-6.812.003-.326-.12-.579-.424-.714a53.88 53.88 0 0 0-1.287-.544c-.238-.098-.51-.16-.519-.489-.006-.232.242-.437.581-.506.681-.138 1.368-.253 2.041-.422.67-.167 1.328-.391 2.062-.611z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4F382B\" d=\"M84.865 110.97c-.032 2.121-.583 3.836-2.083 5.123-1.9 1.633-4.864 2.188-7.287.967-1.034-.521-1.794-1.32-2.289-2.357-.759-1.595-.949-3.272-.553-4.99.392-1.699 1.421-2.93 2.961-3.727 1.584-.819 3.252-1.139 5.011-.709 2.225.543 3.824 2.357 4.142 4.667.057.405.079.815.098 1.026zm-2.577 1.149l-.086-.01c0-.2.011-.4-.002-.6-.073-1.246-.353-2.433-1.075-3.476-.685-.988-1.618-1.571-2.832-1.656-1.359-.096-2.501.664-2.902 2.052-.602 2.084-.398 4.115.66 6.024.461.832 1.144 1.446 2.059 1.769 1.793.631 3.383-.186 3.85-2.022.172-.678.222-1.387.328-2.081z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4F372B\" d=\"M40.819 111.134c-.037 1.522-.396 2.929-1.336 4.152-1.007 1.31-2.391 2.01-3.965 2.305-1.861.348-3.609.032-5.104-1.217-.71-.594-1.195-1.355-1.515-2.221-.525-1.42-.656-2.875-.333-4.358.345-1.587 1.241-2.8 2.63-3.614 1.606-.939 3.339-1.358 5.19-.936 2.38.544 3.754 2.095 4.262 4.443.102.474.116.964.171 1.446zm-2.606 1.004l-.069-.01v-.286c-.039-1.396-.312-2.726-1.145-3.886-.617-.861-1.443-1.401-2.502-1.552-1.726-.246-2.854.778-3.228 2.169-.488 1.817-.335 3.612.42 5.335.471 1.074 1.215 1.911 2.358 2.317 1.782.633 3.396-.205 3.847-2.034.166-.669.216-1.367.319-2.053z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#439934\" d=\"M82.362 33.544c1.227 3.547 2.109 7.168 2.4 10.92.36 4.656.196 9.28-.786 13.859l-.126.366c-.308.001-.622-.038-.923.009-2.543.4-5.083.814-7.624 1.226-2.627.426-5.256.835-7.878 1.289-.929.16-2.079-.031-2.454 1.253l-.18.061.127-7.678-.129-18.526 1.224-.21c2.001-.327 4.002-.66 6.006-.979 2.39-.379 4.782-.749 7.174-1.119 1.056-.162 2.113-.313 3.169-.471z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#45A538\" d=\"M62.265 84.911c-1.291-1.11-2.627-2.171-3.864-3.339-6.658-6.28-11.529-13.673-13.928-22.586-.661-2.452-1.101-4.945-1.243-7.479-.1-1.774-.243-3.563-.117-5.328.333-4.693 1.012-9.341 2.388-13.862l.076-.105c.134.178.326.336.394.537 1.344 3.956 2.677 7.916 4.004 11.879 4.169 12.451 8.333 24.905 12.509 37.354.082.243.293.442.445.661l-.664 2.268z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#46A037\" d=\"M82.362 33.544c-1.057.157-2.114.309-3.169.471-2.392.37-4.784.74-7.174 1.119-2.003.318-4.004.651-6.006.979l-1.224.21-.01-.798c-.041-.656-.109-1.312-.118-1.968l-.137-12.554c-.032-2.619-.08-5.238-.133-7.856a198.423 198.423 0 0 0-.141-4.88c-.04-.873-.181-1.742-.237-2.615-.033-.502.011-1.008.022-1.512.624 1.209 1.235 2.427 1.876 3.627 1.013 1.897 2.628 3.295 4.083 4.82 5.746 6.031 9.825 13.039 12.368 20.957z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#409433\" d=\"M64.792 62.527l.18-.061c.375-1.284 1.525-1.093 2.454-1.253 2.622-.454 5.251-.863 7.878-1.289 2.541-.411 5.081-.825 7.624-1.226.301-.047.615-.008.923-.009-.475 1.696-.849 3.429-1.452 5.078-.685 1.87-1.513 3.696-2.392 5.486a37.595 37.595 0 0 1-4.853 7.458c-1.466 1.762-3.1 3.393-4.737 5.002-.906.889-1.972 1.614-2.966 2.414l-.258-.176-.927-.792-.959-2.104a31.65 31.65 0 0 1-1.065-7.516l.018-.428.131-1.854c.043-.633.101-1.265.128-1.898.096-2.276.182-4.554.273-6.832z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4FAA41\" d=\"M64.792 62.527c-.09 2.278-.176 4.557-.273 6.835-.027.634-.084 1.266-.128 1.898l-.584.221c-1.298-3.821-2.597-7.602-3.867-11.392-2.101-6.271-4.176-12.551-6.274-18.824a3423.013 3423.013 0 0 0-5.118-15.176c-.081-.236-.311-.422-.471-.631l3.74-6.877c.129.223.298.432.379.672 1.73 5.12 3.457 10.241 5.169 15.367 2.228 6.67 4.441 13.343 6.667 20.014.089.266.235.512.375.811l.512-.596-.127 7.678z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4AA73C\" d=\"M48.076 25.458c.161.209.391.395.471.631a3379.774 3379.774 0 0 1 5.118 15.176c2.098 6.273 4.173 12.553 6.274 18.824 1.27 3.79 2.569 7.57 3.867 11.392l.584-.221-.131 1.854-.119.427c-.203 2.029-.374 4.062-.622 6.087-.124 1.015-.389 2.011-.59 3.015-.151-.219-.363-.418-.445-.661-4.177-12.449-8.34-24.903-12.509-37.354a3010.791 3010.791 0 0 0-4.004-11.879c-.068-.201-.26-.359-.394-.537l2.5-6.754z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#57AE47\" d=\"M64.918 54.849l-.512.596c-.14-.299-.286-.545-.375-.811-2.226-6.671-4.439-13.344-6.667-20.014a4618.057 4618.057 0 0 0-5.169-15.367c-.081-.24-.25-.449-.379-.672l4.625-6.084c.146.194.354.367.429.586 1.284 3.76 2.556 7.523 3.822 11.289 1.182 3.518 2.346 7.04 3.542 10.552.08.235.359.401.545.601l.01.798.129 18.526z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#60B24F\" d=\"M64.779 35.525c-.187-.199-.465-.365-.545-.601-1.195-3.512-2.36-7.034-3.542-10.552a2495.581 2495.581 0 0 0-3.822-11.289c-.075-.219-.283-.392-.429-.586 1.504-1.473 2.961-2.999 4.526-4.404 1.391-1.248 2.509-2.586 2.561-4.559l.11-.393.396.998c-.01.504-.055 1.01-.022 1.512.057.873.198 1.742.237 2.615.073 1.625.108 3.253.141 4.88.053 2.618.101 5.237.133 7.856l.137 12.554c.01.657.079 1.313.119 1.969z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#A9AA88\" d=\"M62.929 82.642c.201-1.004.466-2 .59-3.015.248-2.024.419-4.058.622-6.087l.051-.008.05.009a31.65 31.65 0 0 0 1.065 7.516c-.135.178-.324.335-.396.535-.555 1.566-1.079 3.145-1.637 4.71-.076.214-.29.381-.439.568l-.571-1.96.665-2.268z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#B6B598\" d=\"M62.835 86.871c.149-.188.363-.354.439-.568.558-1.565 1.082-3.144 1.637-4.71.071-.2.261-.357.396-.535l.959 2.104c-.189.268-.451.511-.556.81l-1.836 5.392c-.076.217-.333.369-.507.552l-.532-3.045z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#C2C1A7\" d=\"M63.367 89.915c.173-.183.431-.335.507-.552l1.836-5.392c.104-.299.367-.542.556-.81l.928.791c-.448.443-.697.955-.547 1.602l-.282.923c-.128.158-.314.296-.377.477-.641 1.836-1.252 3.682-1.898 5.517-.082.232-.309.415-.468.621l-.255-3.177z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#CECDB7\" d=\"M63.621 93.091c.16-.206.387-.389.468-.621.646-1.835 1.258-3.681 1.898-5.517.063-.181.249-.318.377-.477l-.389 4.236c-.104.12-.254.225-.304.364l-1.294 3.708c-.091.253-.265.479-.401.716-.121-.158-.337-.311-.347-.475-.038-.642-.011-1.289-.008-1.934z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DBDAC7\" d=\"M63.977 95.501c.136-.237.31-.463.401-.716l1.294-3.708c.05-.14.201-.244.304-.364l.01 2.78-.931 2.387-1.078-.379z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#EBE9DC\" d=\"M65.055 95.88l.931-2.387.192 2.824-1.123-.437z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#CECDB7\" d=\"M66.646 85.554c-.149-.646.099-1.158.547-1.602l.258.176-.805 1.426z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4FAA41\" d=\"M64.242 73.542l-.05-.009-.051.008.119-.427-.018.428z\"/></svg>"

/***/ }),

/***/ "../src/components/mongodb/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MongodbOriginalWordmark = __webpack_require__("../src/components/mongodb/original-wordmark/MongodbOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MongodbOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mongodb/original/MongodbOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MongodbOriginal = __webpack_require__("../src/components/mongodb/original/MongodbOriginal.svg");
	
	var _MongodbOriginal2 = _interopRequireDefault(_MongodbOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MongodbOriginal */
	function MongodbOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MongodbOriginal',
	    svg: _MongodbOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MongodbOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MongodbOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mongodb/original/MongodbOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#439934\" d=\"M88.038 42.812c1.605 4.643 2.761 9.383 3.141 14.296.472 6.095.256 12.147-1.029 18.142-.035.165-.109.32-.164.48-.403.001-.814-.049-1.208.012-3.329.523-6.655 1.065-9.981 1.604-3.438.557-6.881 1.092-10.313 1.687-1.216.21-2.721-.041-3.212 1.641-.014.046-.154.054-.235.08l.166-10.051-.169-24.252 1.602-.275c2.62-.429 5.24-.864 7.862-1.281 3.129-.497 6.261-.98 9.392-1.465 1.381-.215 2.764-.412 4.148-.618z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#45A538\" d=\"M61.729 110.054c-1.69-1.453-3.439-2.842-5.059-4.37-8.717-8.222-15.093-17.899-18.233-29.566-.865-3.211-1.442-6.474-1.627-9.792-.13-2.322-.318-4.665-.154-6.975.437-6.144 1.325-12.229 3.127-18.147l.099-.138c.175.233.427.439.516.702 1.759 5.18 3.505 10.364 5.242 15.551 5.458 16.3 10.909 32.604 16.376 48.9.107.318.384.579.583.866l-.87 2.969z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#46A037\" d=\"M88.038 42.812c-1.384.206-2.768.403-4.149.616-3.131.485-6.263.968-9.392 1.465-2.622.417-5.242.852-7.862 1.281l-1.602.275-.012-1.045c-.053-.859-.144-1.717-.154-2.576-.069-5.478-.112-10.956-.18-16.434-.042-3.429-.105-6.857-.175-10.285-.043-2.13-.089-4.261-.185-6.388-.052-1.143-.236-2.28-.311-3.423-.042-.657.016-1.319.029-1.979.817 1.583 1.616 3.178 2.456 4.749 1.327 2.484 3.441 4.314 5.344 6.311 7.523 7.892 12.864 17.068 16.193 27.433z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#409433\" d=\"M65.036 80.753c.081-.026.222-.034.235-.08.491-1.682 1.996-1.431 3.212-1.641 3.432-.594 6.875-1.13 10.313-1.687 3.326-.539 6.652-1.081 9.981-1.604.394-.062.805-.011 1.208-.012-.622 2.22-1.112 4.488-1.901 6.647-.896 2.449-1.98 4.839-3.131 7.182a49.142 49.142 0 0 1-6.353 9.763c-1.919 2.308-4.058 4.441-6.202 6.548-1.185 1.165-2.582 2.114-3.882 3.161l-.337-.23-1.214-1.038-1.256-2.753a41.402 41.402 0 0 1-1.394-9.838l.023-.561.171-2.426c.057-.828.133-1.655.168-2.485.129-2.982.241-5.964.359-8.946z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4FAA41\" d=\"M65.036 80.753c-.118 2.982-.23 5.964-.357 8.947-.035.83-.111 1.657-.168 2.485l-.765.289c-1.699-5.002-3.399-9.951-5.062-14.913-2.75-8.209-5.467-16.431-8.213-24.642a4498.887 4498.887 0 0 0-6.7-19.867c-.105-.31-.407-.552-.617-.826l4.896-9.002c.168.292.39.565.496.879a6167.476 6167.476 0 0 1 6.768 20.118c2.916 8.73 5.814 17.467 8.728 26.198.116.349.308.671.491 1.062l.67-.78-.167 10.052z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4AA73C\" d=\"M43.155 32.227c.21.274.511.516.617.826a4498.887 4498.887 0 0 1 6.7 19.867c2.746 8.211 5.463 16.433 8.213 24.642 1.662 4.961 3.362 9.911 5.062 14.913l.765-.289-.171 2.426-.155.559c-.266 2.656-.49 5.318-.814 7.968-.163 1.328-.509 2.632-.772 3.947-.198-.287-.476-.548-.583-.866-5.467-16.297-10.918-32.6-16.376-48.9a3888.972 3888.972 0 0 0-5.242-15.551c-.089-.263-.34-.469-.516-.702l3.272-8.84z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#57AE47\" d=\"M65.202 70.702l-.67.78c-.183-.391-.375-.714-.491-1.062-2.913-8.731-5.812-17.468-8.728-26.198a6167.476 6167.476 0 0 0-6.768-20.118c-.105-.314-.327-.588-.496-.879l6.055-7.965c.191.255.463.482.562.769 1.681 4.921 3.347 9.848 5.003 14.778 1.547 4.604 3.071 9.215 4.636 13.813.105.308.47.526.714.786l.012 1.045c.058 8.082.115 16.167.171 24.251z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#60B24F\" d=\"M65.021 45.404c-.244-.26-.609-.478-.714-.786-1.565-4.598-3.089-9.209-4.636-13.813-1.656-4.93-3.322-9.856-5.003-14.778-.099-.287-.371-.514-.562-.769 1.969-1.928 3.877-3.925 5.925-5.764 1.821-1.634 3.285-3.386 3.352-5.968.003-.107.059-.214.145-.514l.519 1.306c-.013.661-.072 1.322-.029 1.979.075 1.143.259 2.28.311 3.423.096 2.127.142 4.258.185 6.388.069 3.428.132 6.856.175 10.285.067 5.478.111 10.956.18 16.434.008.861.098 1.718.152 2.577z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#A9AA88\" d=\"M62.598 107.085c.263-1.315.609-2.62.772-3.947.325-2.649.548-5.312.814-7.968l.066-.01.066.011a41.402 41.402 0 0 0 1.394 9.838c-.176.232-.425.439-.518.701-.727 2.05-1.412 4.116-2.143 6.166-.1.28-.378.498-.574.744l-.747-2.566.87-2.969z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#B6B598\" d=\"M62.476 112.621c.196-.246.475-.464.574-.744.731-2.05 1.417-4.115 2.143-6.166.093-.262.341-.469.518-.701l1.255 2.754c-.248.352-.59.669-.728 1.061l-2.404 7.059c-.099.283-.437.483-.663.722l-.695-3.985z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#C2C1A7\" d=\"M63.171 116.605c.227-.238.564-.439.663-.722l2.404-7.059c.137-.391.48-.709.728-1.061l1.215 1.037c-.587.58-.913 1.25-.717 2.097l-.369 1.208c-.168.207-.411.387-.494.624-.839 2.403-1.64 4.819-2.485 7.222-.107.305-.404.544-.614.812-.109-1.387-.22-2.771-.331-4.158z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#CECDB7\" d=\"M63.503 120.763c.209-.269.506-.508.614-.812.845-2.402 1.646-4.818 2.485-7.222.083-.236.325-.417.494-.624l-.509 5.545c-.136.157-.333.294-.398.477-.575 1.614-1.117 3.24-1.694 4.854-.119.333-.347.627-.525.938-.158-.207-.441-.407-.454-.623-.051-.841-.016-1.688-.013-2.533z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DBDAC7\" d=\"M63.969 123.919c.178-.312.406-.606.525-.938.578-1.613 1.119-3.239 1.694-4.854.065-.183.263-.319.398-.477l.012 3.64-1.218 3.124-1.411-.495z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#EBE9DC\" d=\"M65.38 124.415l1.218-3.124.251 3.696-1.469-.572z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#CECDB7\" d=\"M67.464 110.898c-.196-.847.129-1.518.717-2.097l.337.23-1.054 1.867z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4FAA41\" d=\"M64.316 95.172l-.066-.011-.066.01.155-.559-.023.56z\"/></svg>"

/***/ }),

/***/ "../src/components/mongodb/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MongodbOriginal = __webpack_require__("../src/components/mongodb/original/MongodbOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MongodbOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mongodb/plain-wordmark/MongodbPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MongodbPlainWordmark = __webpack_require__("../src/components/mongodb/plain-wordmark/MongodbPlainWordmark.svg");
	
	var _MongodbPlainWordmark2 = _interopRequireDefault(_MongodbPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MongodbPlainWordmark */
	function MongodbPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MongodbPlainWordmark',
	    svg: _MongodbPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MongodbPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MongodbPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mongodb/plain-wordmark/MongodbPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4FAA41\" d=\"M82.803 34.23c-2.604-8.108-6.781-15.284-12.667-21.459-1.488-1.562-3.142-2.993-4.18-4.936-.656-1.23-1.281-2.477-1.92-3.715l-.406-1.021-.113.402c-.053 2.02-1.197 3.389-2.621 4.668-1.604 1.438-3.096 3-4.636 4.509l-4.736 6.229-3.829 7.042-2.561 6.915-.077.107c-1.409 4.629-2.104 9.389-2.445 14.195-.129 1.807.019 3.639.12 5.455.145 2.596.596 5.147 1.272 7.66 2.457 9.126 7.444 16.695 14.263 23.127 1.266 1.195 2.635 2.282 3.956 3.418l.585 2.008.544 3.116.26 3.253c-.003.66-.03 1.323.009 1.981.011.169.231.325.355.487l1.104.388 1.149.447-.197-2.891-.009-2.848.397-4.338.288-.944.825-1.461c1.018-.818 2.109-1.562 3.036-2.473 1.677-1.647 3.351-3.317 4.852-5.122a38.489 38.489 0 0 0 4.969-7.636c.899-1.833 1.747-3.703 2.448-5.618.618-1.688 1.001-3.463 1.488-5.2l.128-.375c1.005-4.688 1.174-9.424.805-14.19-.297-3.841-1.2-7.548-2.456-11.18zm-19.9 50.275c.154-.771.345-1.538.484-2.312-.139.774-.329 1.541-.484 2.312zm3.417.532l-.646-1.415.646 1.415.949.811-.949-.811zm40.154 17.927c-.826-1.583-2.038-2.785-3.64-3.574-1.342-.66-2.785-.95-4.269-.992-1.112-.032-2.228.025-3.342.039-.989.012-1.979.029-2.968.02-1.163-.012-2.326-.047-3.489-.08-.193-.006-.33.033-.42.229-.141.305-.308.599-.481.933l.194.062c.577.102 1.157.189 1.731.304.738.147 1.07.571 1.104 1.193.05.886.07 1.774.067 2.662-.015 3.514-.04 7.028-.066 10.541-.002.232-.006.474-.069.692-.073.252-.152.578-.34.702a2.907 2.907 0 0 1-1.115.425c-.561.092-.655.117-.83.669l-.076.276c-.084.301-.039.36.275.363 1.802.02 3.603.059 5.404.053 1.643-.006 3.286.094 4.923-.215 1.547-.291 2.991-.801 4.309-1.664 1.71-1.121 2.94-2.619 3.589-4.574.524-1.579.641-3.19.463-4.841a8.928 8.928 0 0 0-.954-3.223zm-3.157 9.661c-.964 1.794-2.402 2.992-4.457 3.308-1.287.197-2.576.14-3.803-.347-.777-.308-1.066-.979-1.09-1.772a82.426 82.426 0 0 1-.033-2.332c-.004-2.734-.004-5.468 0-8.201.002-.861.017-1.724.031-2.586.01-.606.137-.809.728-.858 2.596-.218 5.073.062 7.13 1.889 1.272 1.13 1.996 2.571 2.297 4.226.125.69.163 1.396.241 2.096-.063 1.598-.279 3.153-1.044 4.577zm21.789-2.961c-.512-1.246-1.482-2.027-2.701-2.527-.416-.171-.845-.312-1.294-.478l.157-.1c.485-.311 1.025-.562 1.443-.945 1.016-.931 1.438-2.102 1.24-3.493-.188-1.323-.848-2.294-2.027-2.924-1.07-.57-2.224-.778-3.418-.777-2.066.002-4.133.033-6.199.037-.712.001-1.424-.052-2.136-.062-.138-.002-.343.033-.402.125-.163.25-.271.538-.387.816-.067.162-.001.251.184.275.497.068.993.153 1.491.227.688.103 1.021.461 1.063 1.154l.009.411c.001 2.155.008 4.31-.001 6.465a926.932 926.932 0 0 1-.061 6.456c-.003.271-.04.543-.079.812-.059.406-.276.686-.692.774l-1.177.232c-.139.028-.34.024-.397.11-.216.323-.39.676-.366 1.102l.121.033 3.953.097.793-.003c1.368-.016 2.738.011 4.104-.059 1.479-.074 2.868-.513 4.152-1.268 1.367-.805 2.419-1.866 2.793-3.462.24-1.019.241-2.044-.166-3.028zm-10.043-9.181c.006-.433.197-.621.627-.632 1.059-.029 2.111-.023 3.133.342 1.322.472 2.135 1.612 2.12 3.005-.007.535.001 1.065-.196 1.579-.389 1.012-1.135 1.546-2.193 1.65-.552.056-1.109.062-1.601.088l-1.642-.072c-.218-.008-.313-.104-.312-.328l.064-5.632zm6.806 13.494c-.529 1.151-1.493 1.756-2.7 1.966a6.823 6.823 0 0 1-2.892-.127c-.706-.181-.994-.748-1.135-1.377-.095-.421-.079-.922-.087-1.36-.013-.676-.003-2.079-.003-2.079h-.014c0-1 .003-1.866-.003-2.825-.001-.207.034-.31.287-.302.898.027 1.799.042 2.697.077.803.031 1.555.269 2.262.65 1.076.58 1.724 1.468 1.902 2.688.136.925.078 1.835-.314 2.689zm-98.587 1.078l.019-5.437c.003-.818-.101-1.62-.369-2.396-.739-2.137-2.777-3.11-4.899-2.343-.965.349-1.83.878-2.656 1.478-.481.35-.481.35-.829-.149-.985-1.412-2.392-1.895-4.03-1.374-1.059.336-1.985.911-2.862 1.579-.082.062-.247.131-.296.094-.082-.061-.139-.206-.137-.315l.06-.966c.005-.203-.034-.407-.054-.62-.396.137-.712.274-1.043.354-1.023.25-2.053.48-3.082.715-.249.057-.512.132-.536.418-.025.281.246.328.456.412.442.178.881.367 1.318.559.367.162.504.455.502.849-.007 1.685.004 3.368-.006 5.053-.004.685-.036 1.369-.067 2.054-.028.607-.235.861-.823 1.014-.312.082-.629.137-.943.211-.069.016-.187.06-.188.094-.013.297-.029.601.021.89.01.052.324.052.498.072l.117-.007c1.212-.018 2.424-.037 3.637-.05.643-.007 1.285-.001 1.983-.001l.075-.97c-.4-.073-.757-.128-1.109-.205-.549-.12-.783-.411-.797-.965l-.01-.793c-.006-2.057-.014-4.113-.014-6.17 0-.299.124-.536.387-.715.557-.376 1.145-.675 1.796-.842 1.372-.351 2.562.137 3.09 1.304.167.368.298.775.335 1.175.194 2.062.11 4.126-.007 6.188-.025.445-.234.669-.673.778l-1.032.218c-.083.021-.204-.035-.21.034-.023.285-.01.722-.01.722h.246l3.142.103c.861-.002 1.723.102 2.583.124.154.003.291.026.3-.152a8.492 8.492 0 0 0-.011-.829l-.164-.029-.885-.199c-.597-.141-.803-.368-.805-.972-.007-1.489.013-2.977 0-4.465a45.225 45.225 0 0 0-.095-2.551c-.015-.226.02-.374.2-.501a5.311 5.311 0 0 1 1.732-.835c1.935-.51 3.519.551 3.619 2.546.098 1.924.057 3.855.042 5.783-.005.671-.227.874-.888 1.054l-.228.059c-.677.162-.671.162-.631.881.013.225.075.283.315.277 1.379-.031 2.758-.039 4.137-.051.564-.005 1.128 0 1.742 0l.125-.936c-.539-.143-1.036-.249-1.516-.406-.424-.144-.574-.4-.572-.848zm47.489-8.241c.568-.527.572-1.223.413-1.996-.45.471-.954.688-1.529.729-.771.055-1.528-.012-2.246-.319-1.942-.834-3.854-.775-5.76.14-1.603.768-2.589 1.965-2.688 3.78-.063 1.163.155 2.264.931 3.189.465.554 1.062.913 1.735 1.161.29.107.312.245.069.43a7.01 7.01 0 0 1-.557.38 73.2 73.2 0 0 1-1.226.754c-.241.146-.323.332-.244.617.231.838.826 1.322 1.57 1.675l.271.189-.237.237c-.729.591-1.487 1.149-2.185 1.776-.586.527-.775 1.233-.598 2.012.357 1.555 1.388 2.517 2.851 2.959 2.557.774 4.958.33 7.147-1.185 1.298-.899 2.229-2.069 2.512-3.679.317-1.809-.688-3.379-2.487-3.703-1.19-.216-2.408-.278-3.612-.416-.562-.064-1.132-.102-1.679-.231-.465-.11-.696-.489-.653-.859.043-.364.43-.703.873-.738.892-.072 1.766-.211 2.588-.587 2.178-.996 3.189-2.74 2.936-5.088-.033-.316-.105-.628-.17-.996.697.117 1.41.294 1.975-.231zm-6.609 11.017c.886.026 1.894.081 2.868.366.857.25 1.562.688 1.77 1.645.251 1.156-.305 2.306-1.424 2.924-1.048.578-2.186.626-3.34.507-.988-.102-1.877-.444-2.589-1.174-.938-.961-.943-2.291-.004-3.249.839-.856 1.288-1.033 2.719-1.019zm2.217-6.962c-.516 1.651-2.018 1.879-3.195 1.351-1.003-.449-1.44-1.333-1.669-2.342-.089-.388-.11-.791-.162-1.188.021-.569.115-1.115.36-1.627.751-1.577 2.596-1.483 3.617-.769.438.306.743.722.934 1.215a4.998 4.998 0 0 1 .115 3.36zm-9.37 5.263a7.984 7.984 0 0 1-1.057-.236c-.608-.186-.682-.3-.689-.943-.018-1.792-.03-3.584-.05-5.375-.01-.806-.106-1.601-.353-2.371-.65-2.03-2.641-3.12-4.633-2.521-1.104.333-2.052.952-2.935 1.679l-.322.247.001-.331c.021-.381.062-.762.059-1.143-.002-.199-.078-.399-.115-.574-.753.227-1.428.455-2.117.629-.691.174-1.396.292-2.095.434-.347.07-.602.28-.596.519.009.337.288.402.532.503.442.181.883.364 1.32.558.312.139.439.397.436.732-.022 2.329-.036 4.659-.07 6.989-.01.736-.196.93-.92 1.092l-.316.063c-.67.115-.689.142-.643.849l.004.117c-.008.272.111.36.391.357 1.78-.021 3.561-.031 5.341-.024.763.003.845-.057.829-.841l-.036-.337c-.436-.073-.853-.126-1.261-.216-.427-.095-.58-.27-.62-.704-.037-.397-.049-.8-.053-1.2-.02-1.831-.036-3.662-.045-5.492-.002-.461.083-.889.507-1.186a4.14 4.14 0 0 1 2.125-.762c1.588-.109 2.795.832 2.881 2.415.106 1.953.074 3.913.099 5.87.002.146-.024.293-.044.438-.038.286-.178.501-.468.575-.283.074-.57.14-.859.184-.431.064-.44.061-.473.496l.011.293c.051.506.052.491.564.486 1.722-.014 3.443-.023 5.164-.021.72.002.771-.032.777-.774l-.002-.176c.011-.19-.074-.267-.269-.298zm24.052-11.323c-1.805-.441-3.517-.113-5.143.728-1.58.817-2.636 2.08-3.038 3.824-.406 1.763-.212 3.483.567 5.12.507 1.063 1.287 1.885 2.349 2.419 2.486 1.252 5.527.684 7.477-.991 1.539-1.321 2.104-3.08 2.138-5.257-.021-.218-.042-.638-.1-1.054-.327-2.37-1.968-4.231-4.25-4.789zm1.367 9.155c-.479 1.886-2.11 2.724-3.95 2.076-.939-.33-1.641-.961-2.113-1.814-1.086-1.96-1.295-4.044-.677-6.182.412-1.424 1.584-2.203 2.978-2.105 1.246.087 2.204.685 2.907 1.699.741 1.07 1.027 2.287 1.103 3.565.013.205.002.41.002.616l.088.01c-.11.713-.162 1.44-.338 2.135zm-46.764-9.186c-1.899-.434-3.678-.005-5.326.96-1.425.834-2.346 2.08-2.699 3.708-.331 1.521-.196 3.016.343 4.473.328.888.825 1.669 1.554 2.278 1.535 1.281 3.329 1.605 5.238 1.248 1.616-.303 3.036-1.021 4.068-2.364.966-1.256 1.334-2.698 1.372-4.261-.057-.495-.071-.999-.176-1.482-.522-2.411-1.932-4.003-4.374-4.56zm1.549 9.18c-.463 1.876-2.12 2.735-3.947 2.087-1.173-.417-1.937-1.276-2.42-2.377-.774-1.769-.932-3.61-.431-5.476.384-1.427 1.541-2.478 3.312-2.226 1.087.154 1.935.709 2.567 1.592.854 1.191 1.135 2.555 1.174 3.988v.293l.072.011c-.105.704-.157 1.42-.327 2.108z\"/></svg>"

/***/ }),

/***/ "../src/components/mongodb/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MongodbPlainWordmark = __webpack_require__("../src/components/mongodb/plain-wordmark/MongodbPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MongodbPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mongodb/plain/MongodbPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MongodbPlain = __webpack_require__("../src/components/mongodb/plain/MongodbPlain.svg");
	
	var _MongodbPlain2 = _interopRequireDefault(_MongodbPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MongodbPlain */
	function MongodbPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MongodbPlain',
	    svg: _MongodbPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MongodbPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MongodbPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mongodb/plain/MongodbPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4FAA41\" d=\"M90.491 57.282c-.37-4.79-1.496-9.409-3.062-13.934-3.244-10.104-8.45-19.046-15.783-26.74-1.854-1.946-3.916-3.729-5.209-6.151-.818-1.532-1.597-3.085-2.394-4.629l-.505-1.273c-.085.292-.139.396-.142.501-.065 2.517-1.491 4.224-3.267 5.817-1.997 1.793-3.856 3.739-5.775 5.618l-5.901 7.763c-1.592 2.925-3.182 5.85-4.772 8.775l-3.19 8.617-.096.134c-1.756 5.768-2.622 11.698-3.048 17.688-.16 2.251.022 4.535.149 6.798.181 3.235.743 6.415 1.586 9.545 3.062 11.372 9.276 20.805 17.771 28.819 1.579 1.489 3.199 2.843 4.847 4.26.282-.965.507-1.93.763-2.895.256-.961.515-1.917.688-2.881-.174.964-.369 1.92-.562 2.881l-.826 2.895.738 2.501.684 3.884.326 4.053c-.003.823-.036 1.648.014 2.47.012.21.288.404.442.606l1.376.483 1.434.558-.246-3.603-.011-3.548.495-5.405.359-1.177 1.027-1.82c1.268-1.02 2.629-1.946 3.784-3.081 2.09-2.054 4.175-4.134 6.045-6.383a47.846 47.846 0 0 0 6.191-9.516c1.122-2.284 2.178-4.614 3.052-7.001.77-2.104 1.247-4.315 1.854-6.479.054-.156.126-.309.16-.468 1.254-5.841 1.465-11.741 1.004-17.682zm-23.599 49.375l-.805-1.763.805 1.763 1.183 1.01-1.183-1.01z\"/></svg>"

/***/ }),

/***/ "../src/components/mongodb/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MongodbPlain = __webpack_require__("../src/components/mongodb/plain/MongodbPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MongodbPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/moodle/original-wordmark/MoodleOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MoodleOriginalWordmark = __webpack_require__("../src/components/moodle/original-wordmark/MoodleOriginalWordmark.svg");
	
	var _MoodleOriginalWordmark2 = _interopRequireDefault(_MoodleOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MoodleOriginalWordmark */
	function MoodleOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MoodleOriginalWordmark',
	    svg: _MoodleOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MoodleOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MoodleOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/moodle/original-wordmark/MoodleOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><radialGradient id=\"a\" cx=\"365.269\" cy=\"-236.049\" r=\"59.206\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -164.9)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#FAAF40\"/><stop offset=\".043\" stop-color=\"#F9A538\"/><stop offset=\".112\" stop-color=\"#F89D31\"/><stop offset=\".227\" stop-color=\"#F89A2F\"/><stop offset=\".528\" stop-color=\"#F7922D\"/><stop offset=\"1\" stop-color=\"#F37B28\"/></radialGradient><path fill=\"url(#a)\" d=\"M31.26 79.361V68.416c0-2.304-.96-3.456-2.832-3.456s-2.832 1.152-2.832 3.456v10.945h-5.617V68.416c0-2.304-.912-3.456-2.784-3.456s-2.833 1.152-2.833 3.456v10.945H8.795V67.792c0-2.4.816-4.177 2.496-5.425 1.44-1.104 3.457-1.632 5.905-1.632 2.544 0 4.368.624 5.568 1.92 1.008-1.296 2.88-1.92 5.616-1.92 2.496 0 4.465.528 5.905 1.632 1.68 1.248 2.496 3.024 2.496 5.425v11.616H31.26v-.047z\"/><radialGradient id=\"b\" cx=\"365.266\" cy=\"-236.049\" r=\"59.201\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -164.9)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#FAAF40\"/><stop offset=\".043\" stop-color=\"#F9A538\"/><stop offset=\".112\" stop-color=\"#F89D31\"/><stop offset=\".227\" stop-color=\"#F89A2F\"/><stop offset=\".528\" stop-color=\"#F7922D\"/><stop offset=\"1\" stop-color=\"#F37B28\"/></radialGradient><path fill=\"url(#b)\" d=\"M47.389 79.841c-2.832 0-5.136-.913-7.008-2.689-1.824-1.776-2.784-4.08-2.784-6.912 0-2.833.912-5.136 2.784-6.913 1.824-1.776 4.176-2.688 7.008-2.688 2.833 0 5.185.912 7.009 2.688 1.872 1.776 2.784 4.08 2.784 6.913 0 2.832-.912 5.136-2.784 6.912-1.872 1.777-4.225 2.689-7.009 2.689zm0-14.737c-1.344 0-2.4.528-3.12 1.536-.72 1.008-1.104 2.208-1.104 3.648 0 1.393.336 2.592 1.008 3.552.768 1.104 1.825 1.632 3.168 1.632 1.344 0 2.4-.528 3.168-1.632.72-.96 1.056-2.16 1.056-3.552s-.336-2.592-1.008-3.552c-.72-1.104-1.824-1.632-3.168-1.632z\"/><radialGradient id=\"c\" cx=\"365.268\" cy=\"-236.049\" r=\"59.204\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -164.9)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#FAAF40\"/><stop offset=\".043\" stop-color=\"#F9A538\"/><stop offset=\".112\" stop-color=\"#F89D31\"/><stop offset=\".227\" stop-color=\"#F89A2F\"/><stop offset=\".528\" stop-color=\"#F7922D\"/><stop offset=\"1\" stop-color=\"#F37B28\"/></radialGradient><path fill=\"url(#c)\" d=\"M67.55 79.841c-2.832 0-5.136-.913-7.008-2.689-1.824-1.776-2.784-4.08-2.784-6.912 0-2.833.912-5.136 2.784-6.913 1.824-1.776 4.176-2.688 7.008-2.688 2.833 0 5.185.912 7.009 2.688 1.872 1.776 2.784 4.08 2.784 6.913 0 2.832-.912 5.136-2.784 6.912-1.872 1.777-4.225 2.689-7.009 2.689zm0-14.737c-1.344 0-2.4.528-3.12 1.536-.72 1.008-1.104 2.208-1.104 3.648 0 1.393.336 2.592 1.008 3.552.769 1.104 1.825 1.632 3.168 1.632 1.344 0 2.4-.528 3.168-1.632.72-.96 1.056-2.16 1.056-3.552s-.336-2.592-1.008-3.552c-.719-1.104-1.823-1.632-3.168-1.632z\"/><radialGradient id=\"d\" cx=\"365.267\" cy=\"-236.049\" r=\"59.205\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -164.9)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#FAAF40\"/><stop offset=\".043\" stop-color=\"#F9A538\"/><stop offset=\".112\" stop-color=\"#F89D31\"/><stop offset=\".227\" stop-color=\"#F89A2F\"/><stop offset=\".528\" stop-color=\"#F7922D\"/><stop offset=\"1\" stop-color=\"#F37B28\"/></radialGradient><path fill=\"url(#d)\" d=\"M92.416 79.313v-1.824c-.48.672-1.344 1.2-2.544 1.584a8.737 8.737 0 0 1-3.024.528c-2.64 0-4.8-.912-6.385-2.736-1.632-1.824-2.4-4.08-2.4-6.769 0-2.64.768-4.896 2.353-6.672 1.584-1.776 3.696-2.688 6.288-2.688 2.976 0 4.848.816 5.712 2.4V48.063h5.424v31.25h-5.424zm0-10.369c0-1.008-.48-1.968-1.44-2.88-.96-.912-1.92-1.392-2.928-1.392-1.44 0-2.544.576-3.408 1.728-.72 1.007-1.104 2.304-1.104 3.792 0 1.44.384 2.688 1.104 3.745.816 1.2 1.968 1.776 3.408 1.776.864 0 1.776-.384 2.832-1.2 1.008-.816 1.536-1.632 1.536-2.496v-3.073z\"/><radialGradient id=\"e\" cx=\"365.266\" cy=\"-236.048\" r=\"59.205\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -164.9)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#FAAF40\"/><stop offset=\".043\" stop-color=\"#F9A538\"/><stop offset=\".112\" stop-color=\"#F89D31\"/><stop offset=\".227\" stop-color=\"#F89A2F\"/><stop offset=\".528\" stop-color=\"#F7922D\"/><stop offset=\"1\" stop-color=\"#F37B28\"/></radialGradient><path fill=\"url(#e)\" d=\"M99.809 79.313v-31.25h5.567v31.25h-5.567z\"/><radialGradient id=\"f\" cx=\"365.269\" cy=\"-236.049\" r=\"59.201\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -164.9)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#FAAF40\"/><stop offset=\".043\" stop-color=\"#F9A538\"/><stop offset=\".112\" stop-color=\"#F89D31\"/><stop offset=\".227\" stop-color=\"#F89A2F\"/><stop offset=\".528\" stop-color=\"#F7922D\"/><stop offset=\"1\" stop-color=\"#F37B28\"/></radialGradient><path fill=\"url(#f)\" d=\"M112.049 71.92c.24 1.152.816 2.112 1.68 2.928.913.816 1.873 1.248 2.977 1.248.768 0 1.584-.192 2.496-.576 1.104-.48 1.632-1.008 1.632-1.632l5.856-.048c-.815 1.968-2.255 3.504-4.223 4.561-1.873 1.008-3.89 1.536-6.145 1.536-2.833 0-5.233-.912-7.104-2.64-1.872-1.776-2.832-4.081-2.832-6.961 0-2.976.959-5.28 2.832-7.056 1.872-1.728 4.319-2.592 7.296-2.592 3.264 0 5.809 1.056 7.633 3.217 1.68 1.968 2.543 4.656 2.543 8.016h-14.641v-.001zm9.12-3.456c-.24-1.2-.72-2.16-1.488-2.928-.865-.816-1.872-1.248-2.976-1.248-1.152 0-2.112.385-2.929 1.2-.768.816-1.296 1.776-1.583 2.976h8.976z\"/><path fill=\"#58595B\" d=\"M9.323 63.52l-.576 2.88c5.28 1.775 10.272.047 12.913-4.561-3.889-2.687-7.489.049-12.337 1.681\"/><linearGradient id=\"g\" gradientUnits=\"userSpaceOnUse\" x1=\"306.394\" y1=\"-228.257\" x2=\"319.001\" y2=\"-228.257\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -164.9)\"><stop offset=\"0\" stop-color=\"#929497\"/><stop offset=\".124\" stop-color=\"#757578\"/><stop offset=\".279\" stop-color=\"#575658\"/><stop offset=\".44\" stop-color=\"#403E3F\"/><stop offset=\".609\" stop-color=\"#302D2E\"/><stop offset=\".788\" stop-color=\"#262223\"/><stop offset=\"1\" stop-color=\"#231F20\"/></linearGradient><path fill=\"url(#g)\" d=\"M9.323 62.8l-.528 3.264c5.04 1.729 9.985.24 12.625-4.272-3.361-3.889-7.105-.672-12.097 1.008\"/><linearGradient id=\"h\" gradientUnits=\"userSpaceOnUse\" x1=\"308.813\" y1=\"-224.051\" x2=\"314.048\" y2=\"-231.526\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -164.9)\"><stop offset=\"0\" stop-color=\"#231F20\"/><stop offset=\"1\" stop-color=\"#231F20\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#h)\" d=\"M15.324 64.096c-2.304-.48-4.801.72-6.529 1.968-1.104-8.064 3.889-7.873 10.416-5.856-.432 1.968-1.152 4.608-2.4 6.193-.047-1.057-.527-1.777-1.487-2.305\"/><linearGradient id=\"i\" gradientUnits=\"userSpaceOnUse\" x1=\"299.482\" y1=\"-224.263\" x2=\"322.523\" y2=\"-224.263\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -164.9)\"><stop offset=\"0\" stop-color=\"#929497\"/><stop offset=\".124\" stop-color=\"#757578\"/><stop offset=\".279\" stop-color=\"#575658\"/><stop offset=\".44\" stop-color=\"#403E3F\"/><stop offset=\".609\" stop-color=\"#302D2E\"/><stop offset=\".788\" stop-color=\"#262223\"/><stop offset=\"1\" stop-color=\"#231F20\"/></linearGradient><path fill=\"url(#i)\" d=\"M1.883 62.8c8.448-5.089 13.201-6.049 23.041-7.057C13.499 64.768 13.211 62.8 1.883 62.8\"/><path stroke=\"#4A4A4C\" stroke-width=\".5\" fill=\"none\" d=\"M24.924 55.792l-9.073 6.576\"/><path opacity=\".23\" fill=\"#231F20\" d=\"M14.123 59.295c.096 1.057-.144-1.007 0 0\"/><path stroke=\"#A8ABAD\" stroke-width=\".5\" fill=\"none\" d=\"M1.883 62.8l13.968-.432\"/><path stroke=\"#F16922\" stroke-width=\".5\" d=\"M13.259 59.392c-2.4.672-10.272 2.4-10.369 3.409-.24 1.872-.047 4.848-.047 4.848\" fill=\"none\"/><path fill=\"#F16922\" d=\"M3.563 74.801c-.864-2.16-1.92-4.561-.673-7.537.817 2.784.673 4.897.673 7.537\"/><ellipse transform=\"rotate(-109.63 12.915 59.236)\" fill=\"#6D6E70\" cx=\"12.926\" cy=\"59.245\" rx=\".192\" ry=\".384\"/></svg>"

/***/ }),

/***/ "../src/components/moodle/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MoodleOriginalWordmark = __webpack_require__("../src/components/moodle/original-wordmark/MoodleOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MoodleOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/moodle/original/MoodleOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MoodleOriginal = __webpack_require__("../src/components/moodle/original/MoodleOriginal.svg");
	
	var _MoodleOriginal2 = _interopRequireDefault(_MoodleOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MoodleOriginal */
	function MoodleOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MoodleOriginal',
	    svg: _MoodleOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MoodleOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MoodleOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/moodle/original/MoodleOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><radialGradient id=\"a\" cx=\"532.855\" cy=\"-537.557\" r=\"209.76\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -460.9)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#FAAF40\"/><stop offset=\".043\" stop-color=\"#F9A538\"/><stop offset=\".112\" stop-color=\"#F89D31\"/><stop offset=\".227\" stop-color=\"#F89A2F\"/><stop offset=\".528\" stop-color=\"#F7922D\"/><stop offset=\"1\" stop-color=\"#F37B28\"/></radialGradient><path fill=\"url(#a)\" d=\"M106.259 105.754V66.975c0-8.164-3.397-12.244-10.034-12.244-6.629 0-10.034 4.08-10.034 12.244v38.779H66.294V66.975c0-8.164-3.228-12.244-9.862-12.244-6.633 0-10.036 4.08-10.036 12.244v38.779H26.667V64.768c0-8.504 2.891-14.801 8.844-19.223 5.102-3.91 12.246-5.777 20.92-5.777 9.015 0 15.478 2.207 19.727 6.801 3.57-4.594 10.207-6.801 19.897-6.801 8.844 0 15.819 1.867 20.922 5.777 5.951 4.422 8.843 10.719 8.843 19.223v41.152h-19.563v-.166z\"/><path fill=\"#58595B\" d=\"M28.539 49.627l-2.041 10.207c18.708 6.291 36.395.166 45.751-16.158-13.778-9.522-26.535.17-43.71 5.951\"/><linearGradient id=\"b\" gradientUnits=\"userSpaceOnUse\" x1=\"324.268\" y1=\"-509.952\" x2=\"368.932\" y2=\"-509.952\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -460.9)\"><stop offset=\"0\" stop-color=\"#929497\"/><stop offset=\".124\" stop-color=\"#757578\"/><stop offset=\".279\" stop-color=\"#575658\"/><stop offset=\".44\" stop-color=\"#403E3F\"/><stop offset=\".609\" stop-color=\"#302D2E\"/><stop offset=\".788\" stop-color=\"#262223\"/><stop offset=\"1\" stop-color=\"#231F20\"/></linearGradient><path fill=\"url(#b)\" d=\"M28.539 47.08c-.681 3.91-1.192 7.65-1.872 11.563 17.857 6.125 35.375.85 44.73-15.137-11.909-13.776-25.17-2.383-42.858 3.574\"/><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"332.834\" y1=\"-495.051\" x2=\"351.377\" y2=\"-521.534\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -460.9)\"><stop offset=\"0\" stop-color=\"#231F20\"/><stop offset=\"1\" stop-color=\"#231F20\" stop-opacity=\"0\"/></linearGradient><path fill=\"url(#c)\" d=\"M49.799 51.668c-8.164-1.701-17.009 2.555-23.131 6.975-3.912-28.57 13.777-27.893 36.903-20.75-1.529 6.975-4.083 16.33-8.502 21.941-.169-3.744-1.869-6.293-5.27-8.166\"/><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"299.778\" y1=\"-495.802\" x2=\"381.412\" y2=\"-495.802\" gradientTransform=\"matrix(1 0 0 -1 -297.6 -460.9)\"><stop offset=\"0\" stop-color=\"#929497\"/><stop offset=\".124\" stop-color=\"#757578\"/><stop offset=\".279\" stop-color=\"#575658\"/><stop offset=\".44\" stop-color=\"#403E3F\"/><stop offset=\".609\" stop-color=\"#302D2E\"/><stop offset=\".788\" stop-color=\"#262223\"/><stop offset=\"1\" stop-color=\"#231F20\"/></linearGradient><path fill=\"url(#d)\" d=\"M2.178 47.08c29.932-18.031 46.77-21.43 81.634-25-40.478 31.969-41.499 25-81.634 25\"/><path stroke=\"#4A4A4C\" stroke-width=\".5\" fill=\"none\" d=\"M83.812 22.246L51.667 45.545\"/><path opacity=\".23\" fill=\"#231F20\" d=\"M45.545 34.66c.34 3.744-.511-3.572 0 0\"/><path stroke=\"#A8ABAD\" stroke-width=\".5\" fill=\"none\" d=\"M2.178 47.08l49.489-1.535\"/><path stroke=\"#F16922\" stroke-width=\".5\" d=\"M42.484 35.002C33.98 37.383 6.09 43.506 5.747 47.08c-.849 6.631-.167 17.176-.167 17.176\" fill=\"none\"/><path fill=\"#F16922\" d=\"M8.131 89.596c-3.063-7.652-6.804-16.158-2.384-26.703C8.64 72.756 8.131 80.24 8.131 89.596\"/><path fill=\"#6D6E70\" d=\"M41.076 33.844c.708-.25 1.384-.17 1.509.184.126.355-.344.846-1.052 1.096-.709.256-1.384.172-1.51-.184-.127-.352.344-.844 1.053-1.096z\"/></svg>"

/***/ }),

/***/ "../src/components/moodle/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MoodleOriginal = __webpack_require__("../src/components/moodle/original/MoodleOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MoodleOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/moodle/plain-wordmark/MoodlePlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MoodlePlainWordmark = __webpack_require__("../src/components/moodle/plain-wordmark/MoodlePlainWordmark.svg");
	
	var _MoodlePlainWordmark2 = _interopRequireDefault(_MoodlePlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MoodlePlainWordmark */
	function MoodlePlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MoodlePlainWordmark',
	    svg: _MoodlePlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MoodlePlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MoodlePlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/moodle/plain-wordmark/MoodlePlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#F7931E\" d=\"M34.395 65.632C32.955 64.528 30.931 64 28.435 64c-2.736 0-4.635.624-5.644 1.92a5.325 5.325 0 0 0-1.686-1.199c-.693-.704-1.411-1.132-2.146-1.338 1.632-1.048 3.546-2.463 5.968-4.375-9.84 1.008-14.595 1.968-23.043 7.057l1.006.005c-.202 1.581-.097 3.938-.059 4.635-1.132 2.893-.115 5.244.731 7.36 0-2.547.125-4.608-.598-7.25l5.744-4.553c-.092.858-.079 1.859.086 3.065l.018.005-.066.331.256.045c-.063.429-.002.873-.002 1.349V83h5V71.68c0-.563.241-1.055.355-1.48.784-.132 1.628-.356 2.345-.663l.066.127.153-.188a9.889 9.889 0 0 0 1.671-.94c.925.479 1.41 1.519 1.41 3.144V83h6V71.68c0-2.304.628-3.456 2.5-3.456S31 69.376 31 71.68V83h6V71.057c0-2.401-.925-4.177-2.605-5.425zm12.995-1.728c-2.832 0-5.184.912-7.008 2.688-1.872 1.776-2.784 4.08-2.784 6.913 0 2.832.96 5.136 2.784 6.912 1.872 1.776 4.176 2.689 7.008 2.689 2.784 0 5.137-.913 7.009-2.689 1.872-1.776 2.783-4.08 2.783-6.912 0-2.833-.911-5.136-2.783-6.913-1.825-1.776-4.176-2.688-7.009-2.688zm3.12 13.2c-.768 1.104-1.824 1.632-3.168 1.632s-2.4-.528-3.168-1.632c-.672-.96-1.008-2.16-1.008-3.552 0-1.44.384-2.64 1.104-3.648.72-1.008 1.776-1.536 3.12-1.536s2.448.528 3.169 1.632c.672.96 1.008 2.161 1.008 3.552-.001 1.393-.337 2.593-1.057 3.552zm17.041-13.2c-2.832 0-5.184.912-7.008 2.688-1.873 1.776-2.785 4.08-2.785 6.913 0 2.832.961 5.136 2.785 6.912 1.871 1.776 4.176 2.689 7.008 2.689 2.784 0 5.137-.913 7.008-2.689 1.873-1.776 2.785-4.08 2.785-6.912 0-2.833-.912-5.136-2.785-6.913-1.824-1.776-4.176-2.688-7.008-2.688zm3.121 13.2c-.769 1.104-1.824 1.632-3.169 1.632-1.344 0-2.399-.528-3.169-1.632-.672-.96-1.008-2.16-1.008-3.552 0-1.44.385-2.64 1.104-3.648.72-1.008 1.776-1.536 3.12-1.536s2.448.528 3.168 1.632c.672.96 1.008 2.161 1.008 3.552.001 1.393-.335 2.593-1.054 3.552zM92 66.4c0-1.584-2.528-2.4-5.505-2.4-2.592 0-4.599.912-6.183 2.688-1.584 1.776-2.302 4.032-2.302 6.672 0 2.688.795 4.944 2.426 6.769 1.584 1.824 3.758 2.736 6.398 2.736.961 0 1.767-.144 2.821-.528 1.202-.384 2.345-.912 2.345-1.584V83h6V51h-6v15.4zm0 8.881c0 .864-.319 1.68-1.327 2.496-1.057.816-1.864 1.2-2.728 1.2-1.441 0-2.542-.576-3.356-1.776-.721-1.056-1.08-2.304-1.08-3.745 0-1.488.398-2.784 1.119-3.792.863-1.152 1.973-1.728 3.414-1.728 1.008 0 1.763.48 2.724 1.392.959.912 1.234 1.872 1.234 2.88v3.073zM100 51h5v32h-5zm19.201 27.785c-.912.384-1.729.576-2.496.576-1.104 0-2.063-.524-2.977-1.34-.863-.816-1.439-2.021-1.68-3.021h14.641c0-3-.863-5.956-2.543-7.924-1.824-2.161-4.369-3.171-7.633-3.171-2.977 0-5.426.888-7.297 2.616-1.871 1.776-2.832 4.091-2.832 7.067 0 2.88.961 5.19 2.832 6.967 1.871 1.728 4.271 2.643 7.105 2.643 2.254 0 4.271-.527 6.145-1.535 1.967-1.056 3.408-2.591 4.223-4.56l-5.855.048c0 .625-.527 1.154-1.633 1.634zm-5.424-9.897c.816-.815 1.775-1.268 2.928-1.268 1.105 0 2.111.534 2.977 1.35.768.768 1.248 2.03 1.488 3.03h-8.977c.287-1 .817-2.296 1.584-3.112z\"/></svg>"

/***/ }),

/***/ "../src/components/moodle/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MoodlePlainWordmark = __webpack_require__("../src/components/moodle/plain-wordmark/MoodlePlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MoodlePlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/moodle/plain/MoodlePlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MoodlePlain = __webpack_require__("../src/components/moodle/plain/MoodlePlain.svg");
	
	var _MoodlePlain2 = _interopRequireDefault(_MoodlePlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MoodlePlain */
	function MoodlePlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MoodlePlain',
	    svg: _MoodlePlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MoodlePlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MoodlePlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/moodle/plain/MoodlePlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#F7931E\" d=\"M116.659 45.061c-5.075-3.895-12.286-5.754-21.087-5.754-9.648 0-16.383 2.199-19.939 6.77-1.626-1.76-3.659-3.162-5.963-4.229-2.444-2.479-4.981-3.986-7.574-4.717 5.754-3.695 12.497-8.684 21.036-15.426-34.694 3.555-51.459 6.94-81.245 24.881 1.219 0 2.396.006 3.546.02-.711 5.572-.341 13.883-.208 16.342-3.991 10.197-.406 18.488 2.579 25.945 0-8.979.44-16.244-2.109-25.557l20.25-16.051c-.326 3.025-.277 6.555.305 10.807l.063.021-.232 1.162.918.162c-.227 1.506.001 3.073.001 4.749V106h18V66.383c0-1.982.65-3.719 1.053-5.217 2.765-.465 5.64-1.256 8.167-2.338l.182.447c.162-.203.357-.447.515-.66 2.034-.908 4.166-2.014 6.001-3.316C64.178 56.986 66 60.654 66 66.383V106h21V66.383c0-8.123 2.4-12.182 9-12.182s9 4.059 9 12.182V106h21V64.186c0-8.463-3.419-14.725-9.341-19.125z\"/></svg>"

/***/ }),

/***/ "../src/components/moodle/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MoodlePlain = __webpack_require__("../src/components/moodle/plain/MoodlePlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MoodlePlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mysql/original-wordmark/MysqlOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MysqlOriginalWordmark = __webpack_require__("../src/components/mysql/original-wordmark/MysqlOriginalWordmark.svg");
	
	var _MysqlOriginalWordmark2 = _interopRequireDefault(_MysqlOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MysqlOriginalWordmark */
	function MysqlOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MysqlOriginalWordmark',
	    svg: _MysqlOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MysqlOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MysqlOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mysql/original-wordmark/MysqlOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#00618A\" d=\"M2.001 90.458h4.108V74.235l6.36 14.143c.75 1.712 1.777 2.317 3.792 2.317s3.003-.605 3.753-2.317l6.36-14.143v16.223h4.108V74.262c0-1.58-.632-2.345-1.936-2.739-3.121-.974-5.215-.131-6.163 1.976l-6.241 13.958-6.043-13.959c-.909-2.106-3.042-2.949-6.163-1.976C2.632 71.917 2 72.681 2 74.261v16.197zm31.898-13.206h4.107v8.938c-.038.485.156 1.625 2.406 1.661 1.148.018 8.862 0 8.934 0V77.208h4.117c.019 0-.004 14.514-.004 14.574.022 3.58-4.441 4.357-6.499 4.417H33.988v-2.764c.022 0 12.963.003 12.995-.001 2.645-.279 2.332-1.593 2.331-2.035v-1.078h-8.731c-4.062-.037-6.65-1.81-6.683-3.85-.002-.187.089-9.129-.001-9.219z\"/><path fill=\"#E48E00\" d=\"M56.63 90.458h11.812c1.383 0 2.727-.289 3.793-.789 1.777-.816 2.646-1.922 2.646-3.372v-3.002c0-1.185-.987-2.292-2.923-3.028-1.027-.396-2.292-.605-3.517-.605h-4.978c-1.659 0-2.449-.5-2.646-1.606-.039-.132-.039-.237-.039-.369v-1.87c0-.105 0-.211.039-.342.197-.843.632-1.08 2.094-1.212l.395-.026h11.733v-2.738H63.504c-1.659 0-2.528.105-3.318.342-2.449.764-3.517 1.975-3.517 4.082v2.396c0 1.844 2.095 3.424 5.61 3.793.396.025.79.053 1.185.053h4.267c.158 0 .316 0 .435.025 1.304.105 1.856.343 2.252.816a.98.98 0 0 1 .315.737v2.397c0 .289-.197.658-.592.974-.355.316-.948.527-1.738.58l-.435.026H56.63v2.738zm43.881-4.766c0 2.817 2.094 4.397 6.32 4.714.395.026.79.052 1.185.052h10.706V87.72h-10.784c-2.41 0-3.318-.606-3.318-2.055V71.497h-4.108v14.195zm-23.008.142v-9.765c0-2.48 1.742-3.985 5.186-4.46a7.8 7.8 0 0 1 1.108-.079h7.799c.396 0 .752.026 1.147.079 3.444.475 5.187 1.979 5.187 4.46v9.765c0 2.014-.74 3.09-2.445 3.792l4.048 3.653h-4.771l-3.274-2.956-3.296.209h-4.395a9.075 9.075 0 0 1-2.414-.343c-2.613-.712-3.88-2.085-3.88-4.355zm4.434-.237c0 .132.039.265.079.423.237 1.135 1.307 1.768 2.929 1.768h3.732l-3.428-3.095h4.771l2.989 2.7c.552-.295.914-.743 1.041-1.32.039-.132.039-.264.039-.396v-9.368c0-.105 0-.238-.039-.37-.238-1.056-1.307-1.662-2.89-1.662h-6.216c-1.82 0-3.008.792-3.008 2.032v9.288z\"/><path fill=\"#00618A\" d=\"M122.336 66.952c-2.525-.069-4.454.166-6.104.861-.469.198-1.216.203-1.292.79.257.271.297.674.502 1.006.394.637 1.059 1.491 1.652 1.938.647.489 1.315 1.013 2.011 1.437 1.235.754 2.615 1.184 3.806 1.938.701.446 1.397 1.006 2.082 1.509.339.247.565.634 1.006.789v-.071c-.231-.294-.291-.698-.503-1.006l-.934-.934c-.913-1.212-2.071-2.275-3.304-3.159-.982-.705-3.18-1.658-3.59-2.801l-.072-.071c.696-.079 1.512-.331 2.154-.503 1.08-.29 2.045-.215 3.16-.503l1.508-.432v-.286c-.563-.578-.966-1.344-1.58-1.867-1.607-1.369-3.363-2.737-5.17-3.879-1.002-.632-2.241-1.043-3.304-1.579-.356-.181-.984-.274-1.221-.575-.559-.711-.862-1.612-1.293-2.441a93.068 93.068 0 0 1-2.585-5.458c-.544-1.245-.9-2.473-1.579-3.59-3.261-5.361-6.771-8.597-12.208-11.777-1.157-.677-2.55-.943-4.021-1.292l-2.37-.144c-.481-.201-.983-.791-1.436-1.077-1.802-1.138-6.422-3.613-7.756-.358-.842 2.054 1.26 4.058 2.011 5.099.527.73 1.203 1.548 1.58 2.369.248.54.29 1.081.503 1.652.521 1.406.976 2.937 1.651 4.236.341.658.718 1.351 1.149 1.939.264.36.718.52.789 1.077-.443.62-.469 1.584-.718 2.369-1.122 3.539-.699 7.938.934 10.557.501.805 1.681 2.529 3.303 1.867 1.419-.578 1.103-2.369 1.509-3.95.092-.357.035-.621.215-.861v.072l1.293 2.585c.957 1.541 2.654 3.15 4.093 4.237.746.563 1.334 1.538 2.298 1.867v-.073h-.071c-.188-.291-.479-.411-.719-.646-.562-.551-1.187-1.235-1.651-1.867-1.309-1.776-2.465-3.721-3.519-5.745-.503-.966-.94-2.032-1.364-3.016-.164-.379-.162-.953-.502-1.148-.466.72-1.149 1.303-1.509 2.154-.574 1.36-.648 3.019-.861 4.739l-.144.071c-1.001-.241-1.352-1.271-1.724-2.154-.94-2.233-1.115-5.83-.287-8.401.214-.666 1.181-2.761.789-3.376-.187-.613-.804-.967-1.148-1.437a11.222 11.222 0 0 1-1.149-2.011c-.77-1.741-1.129-3.696-1.938-5.457-.388-.842-1.042-1.693-1.58-2.441-.595-.83-1.262-1.44-1.724-2.442-.164-.356-.387-.927-.144-1.293.077-.247.188-.35.432-.431.416-.321 1.576.107 2.01.287 1.152.479 2.113.934 3.089 1.58.468.311.941.911 1.508 1.077h.646c1.011.232 2.144.071 3.088.358 1.67.508 3.166 1.297 4.524 2.155 4.139 2.614 7.522 6.334 9.838 10.772.372.715.534 1.396.861 2.154.662 1.528 1.496 3.101 2.154 4.596.657 1.491 1.298 2.996 2.227 4.237.488.652 2.374 1.002 3.231 1.364.601.254 1.585.519 2.154.861 1.087.656 2.141 1.437 3.16 2.155.509.362 2.076 1.149 2.154 1.798zM90.237 39.593a5.124 5.124 0 0 0-1.293.144v.071h.072c.251.517.694.849 1.005 1.293l.719 1.508.071-.071c.445-.313.648-.814.646-1.58-.179-.188-.205-.423-.359-.646-.204-.3-.602-.468-.861-.719z\"/></svg>"

/***/ }),

/***/ "../src/components/mysql/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MysqlOriginalWordmark = __webpack_require__("../src/components/mysql/original-wordmark/MysqlOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MysqlOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mysql/original/MysqlOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MysqlOriginal = __webpack_require__("../src/components/mysql/original/MysqlOriginal.svg");
	
	var _MysqlOriginal2 = _interopRequireDefault(_MysqlOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MysqlOriginal */
	function MysqlOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MysqlOriginal',
	    svg: _MysqlOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MysqlOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MysqlOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mysql/original/MysqlOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#00618A\" d=\"M116.948 97.807c-6.863-.187-12.104.452-16.585 2.341-1.273.537-3.305.552-3.513 2.147.7.733.809 1.829 1.365 2.731 1.07 1.73 2.876 4.052 4.488 5.268 1.762 1.33 3.577 2.751 5.465 3.902 3.358 2.047 7.107 3.217 10.34 5.268 1.906 1.21 3.799 2.733 5.658 4.097.92.675 1.537 1.724 2.732 2.147v-.194c-.628-.8-.79-1.898-1.366-2.733l-2.537-2.537c-2.48-3.292-5.629-6.184-8.976-8.585-2.669-1.916-8.642-4.504-9.755-7.609l-.195-.195c1.892-.214 4.107-.898 5.854-1.367 2.934-.786 5.556-.583 8.585-1.365l4.097-1.171v-.78c-1.531-1.571-2.623-3.651-4.292-5.073-4.37-3.72-9.138-7.437-14.048-10.537-2.724-1.718-6.089-2.835-8.976-4.292-.971-.491-2.677-.746-3.318-1.562-1.517-1.932-2.342-4.382-3.511-6.633-2.449-4.717-4.854-9.868-7.024-14.831-1.48-3.384-2.447-6.72-4.293-9.756-8.86-14.567-18.396-23.358-33.169-32-3.144-1.838-6.929-2.563-10.929-3.513-2.145-.129-4.292-.26-6.438-.391-1.311-.546-2.673-2.149-3.902-2.927C17.811 4.565 5.257-2.16 1.633 6.682c-2.289 5.581 3.421 11.025 5.462 13.854 1.434 1.982 3.269 4.207 4.293 6.438.674 1.467.79 2.938 1.367 4.489 1.417 3.822 2.652 7.98 4.487 11.511.927 1.788 1.949 3.67 3.122 5.268.718.981 1.951 1.413 2.145 2.927-1.204 1.686-1.273 4.304-1.95 6.44-3.05 9.615-1.899 21.567 2.537 28.683 1.36 2.186 4.567 6.871 8.975 5.073 3.856-1.57 2.995-6.438 4.098-10.732.249-.973.096-1.689.585-2.341v.195l3.513 7.024c2.6 4.187 7.212 8.562 11.122 11.514 2.027 1.531 3.623 4.177 6.244 5.073v-.196h-.195c-.508-.791-1.303-1.119-1.951-1.755-1.527-1.497-3.225-3.358-4.487-5.073-3.556-4.827-6.698-10.11-9.561-15.609-1.368-2.627-2.557-5.523-3.709-8.196-.444-1.03-.438-2.589-1.364-3.122-1.263 1.958-3.122 3.542-4.098 5.854-1.561 3.696-1.762 8.204-2.341 12.878-.342.122-.19.038-.391.194-2.718-.655-3.672-3.452-4.683-5.853-2.554-6.07-3.029-15.842-.781-22.829.582-1.809 3.21-7.501 2.146-9.172-.508-1.666-2.184-2.63-3.121-3.903-1.161-1.574-2.319-3.646-3.124-5.464-2.09-4.731-3.066-10.044-5.267-14.828-1.053-2.287-2.832-4.602-4.293-6.634-1.617-2.253-3.429-3.912-4.683-6.635-.446-.968-1.051-2.518-.391-3.513.21-.671.508-.951 1.171-1.17 1.132-.873 4.284.29 5.462.779 3.129 1.3 5.741 2.538 8.392 4.294 1.271.844 2.559 2.475 4.097 2.927h1.756c2.747.631 5.824.195 8.391.975 4.536 1.378 8.601 3.523 12.292 5.854 11.246 7.102 20.442 17.21 26.732 29.269 1.012 1.942 1.45 3.794 2.341 5.854 1.798 4.153 4.063 8.426 5.852 12.488 1.786 4.052 3.526 8.141 6.05 11.513 1.327 1.772 6.451 2.723 8.781 3.708 1.632.689 4.307 1.409 5.854 2.34 2.953 1.782 5.815 3.903 8.586 5.855 1.383.975 5.64 3.116 5.852 4.879zM29.729 23.466c-1.431-.027-2.443.156-3.513.389v.195h.195c.683 1.402 1.888 2.306 2.731 3.513.65 1.367 1.301 2.732 1.952 4.097l.194-.193c1.209-.853 1.762-2.214 1.755-4.294-.484-.509-.555-1.147-.975-1.755-.556-.811-1.635-1.272-2.339-1.952z\"/></svg>"

/***/ }),

/***/ "../src/components/mysql/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MysqlOriginal = __webpack_require__("../src/components/mysql/original/MysqlOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MysqlOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mysql/plain-wordmark/MysqlPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MysqlPlainWordmark = __webpack_require__("../src/components/mysql/plain-wordmark/MysqlPlainWordmark.svg");
	
	var _MysqlPlainWordmark2 = _interopRequireDefault(_MysqlPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MysqlPlainWordmark */
	function MysqlPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MysqlPlainWordmark',
	    svg: _MysqlPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MysqlPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MysqlPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mysql/plain-wordmark/MysqlPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#00618A\" d=\"M2.001 90.458h4.108V74.235l6.36 14.143c.75 1.712 1.777 2.317 3.792 2.317s3.003-.605 3.753-2.317l6.36-14.143v16.223h4.108V74.262c0-1.58-.632-2.345-1.936-2.739-3.121-.974-5.215-.131-6.163 1.976l-6.241 13.958-6.043-13.959c-.909-2.106-3.042-2.949-6.163-1.976C2.632 71.917 2 72.681 2 74.261v16.197zm31.898-13.206h4.107v8.938c-.038.485.156 1.625 2.406 1.661 1.148.018 8.862 0 8.934 0V77.208h4.117c.019 0-.004 14.514-.004 14.574.022 3.58-4.441 4.357-6.499 4.417H33.988v-2.764c.022 0 12.963.003 12.995-.001 2.645-.279 2.332-1.593 2.331-2.035v-1.078h-8.731c-4.062-.037-6.65-1.81-6.683-3.85-.002-.187.089-9.129-.001-9.219zM56.63 90.458h11.812c1.383 0 2.727-.289 3.793-.789 1.777-.816 2.646-1.922 2.646-3.372v-3.002c0-1.185-.987-2.292-2.923-3.028-1.027-.396-2.292-.605-3.517-.605h-4.978c-1.659 0-2.449-.5-2.646-1.606-.039-.132-.039-.237-.039-.369v-1.87c0-.105 0-.211.039-.342.197-.843.632-1.08 2.094-1.212l.395-.026h11.733v-2.738H63.504c-1.659 0-2.528.105-3.318.342-2.449.764-3.517 1.975-3.517 4.082v2.396c0 1.844 2.095 3.424 5.61 3.793.396.025.79.053 1.185.053h4.267c.158 0 .316 0 .435.025 1.304.105 1.856.343 2.252.816a.98.98 0 0 1 .315.737v2.397c0 .289-.197.658-.592.974-.355.316-.948.527-1.738.58l-.435.026H56.63v2.738zm43.881-4.766c0 2.817 2.094 4.397 6.32 4.714.395.026.79.052 1.185.052h10.706V87.72h-10.784c-2.41 0-3.318-.606-3.318-2.055V71.497h-4.108v14.195zm-23.008.142v-9.765c0-2.48 1.742-3.985 5.186-4.46a7.8 7.8 0 0 1 1.108-.079h7.799c.396 0 .752.026 1.147.079 3.444.475 5.187 1.979 5.187 4.46v9.765c0 2.014-.74 3.09-2.445 3.792l4.048 3.653h-4.771l-3.274-2.956-3.296.209h-4.395a9.075 9.075 0 0 1-2.414-.343c-2.613-.712-3.88-2.085-3.88-4.355zm4.435-.237c0 .132.039.265.079.423.237 1.135 1.307 1.768 2.929 1.768h3.732l-3.428-3.095h4.771l2.989 2.7c.552-.295.914-.743 1.041-1.32.039-.132.039-.264.039-.396v-9.368c0-.105 0-.238-.039-.37-.238-1.056-1.307-1.662-2.89-1.662h-6.216c-1.82 0-3.008.792-3.008 2.032v9.288zm40.398-18.645c-2.525-.069-4.454.166-6.104.861-.469.198-1.216.203-1.292.79.257.271.297.674.502 1.006.394.637 1.059 1.491 1.652 1.938.647.489 1.315 1.013 2.011 1.437 1.235.754 2.615 1.184 3.806 1.938.701.446 1.397 1.006 2.082 1.509.339.247.565.634 1.006.789v-.071c-.231-.294-.291-.698-.503-1.006l-.934-.934c-.913-1.212-2.071-2.275-3.304-3.159-.982-.705-3.18-1.658-3.59-2.801l-.072-.071c.696-.079 1.512-.331 2.154-.503 1.08-.29 2.045-.215 3.16-.503l1.508-.432v-.286c-.563-.578-.966-1.344-1.58-1.867-1.607-1.369-3.363-2.737-5.17-3.879-1.002-.632-2.241-1.043-3.304-1.579-.356-.181-.984-.274-1.221-.575-.559-.711-.862-1.612-1.293-2.441a93.068 93.068 0 0 1-2.585-5.458c-.544-1.245-.9-2.473-1.579-3.59-3.261-5.361-6.771-8.597-12.208-11.777-1.157-.677-2.55-.943-4.021-1.292l-2.37-.144c-.481-.201-.983-.791-1.436-1.077-1.802-1.138-6.422-3.613-7.756-.358-.842 2.054 1.26 4.058 2.011 5.099.527.73 1.203 1.548 1.58 2.369.248.54.29 1.081.503 1.652.521 1.406.976 2.937 1.651 4.236.341.658.718 1.351 1.149 1.939.264.36.718.52.789 1.077-.443.62-.469 1.584-.718 2.369-1.122 3.539-.699 7.938.934 10.557.501.805 1.681 2.529 3.303 1.867 1.419-.578 1.103-2.369 1.509-3.95.092-.357.035-.621.215-.861v.072l1.293 2.585c.957 1.541 2.654 3.15 4.093 4.237.746.563 1.334 1.538 2.298 1.867v-.073h-.071c-.188-.291-.479-.411-.719-.646-.562-.551-1.187-1.235-1.651-1.867-1.309-1.776-2.465-3.721-3.519-5.745-.503-.966-.94-2.032-1.364-3.016-.164-.379-.162-.953-.502-1.148-.466.72-1.149 1.303-1.509 2.154-.574 1.36-.648 3.019-.861 4.739l-.144.071c-1.001-.241-1.352-1.271-1.724-2.154-.94-2.233-1.115-5.83-.287-8.401.214-.666 1.181-2.761.789-3.376-.187-.613-.804-.967-1.148-1.437a11.222 11.222 0 0 1-1.149-2.011c-.77-1.741-1.129-3.696-1.938-5.457-.388-.842-1.042-1.693-1.58-2.441-.595-.83-1.262-1.44-1.724-2.442-.164-.356-.387-.927-.144-1.293.077-.247.188-.35.432-.431.416-.321 1.576.107 2.01.287 1.152.479 2.113.934 3.089 1.58.468.311.941.911 1.508 1.077h.646c1.011.232 2.144.071 3.088.358 1.67.508 3.166 1.297 4.524 2.155 4.139 2.614 7.522 6.334 9.838 10.772.372.715.534 1.396.861 2.154.662 1.528 1.496 3.101 2.154 4.596.657 1.491 1.298 2.996 2.227 4.237.488.652 2.374 1.002 3.231 1.364.601.254 1.585.519 2.154.861 1.087.656 2.141 1.437 3.16 2.155.509.362 2.076 1.149 2.154 1.798zM90.237 39.593a5.124 5.124 0 0 0-1.293.144v.071h.072c.251.517.694.849 1.005 1.293l.719 1.508.071-.071c.445-.313.648-.814.646-1.58-.179-.188-.205-.423-.359-.646-.204-.3-.602-.468-.861-.719z\"/></svg>"

/***/ }),

/***/ "../src/components/mysql/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MysqlPlainWordmark = __webpack_require__("../src/components/mysql/plain-wordmark/MysqlPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MysqlPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mysql/plain/MysqlPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _MysqlPlain = __webpack_require__("../src/components/mysql/plain/MysqlPlain.svg");
	
	var _MysqlPlain2 = _interopRequireDefault(_MysqlPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** MysqlPlain */
	function MysqlPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'MysqlPlain',
	    svg: _MysqlPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	MysqlPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = MysqlPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/mysql/plain/MysqlPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#00618A\" d=\"M125.477 122.783l-2.616-2.537c-2.479-3.292-5.668-6.184-9.015-8.585-2.669-1.916-8.661-4.504-9.775-7.609l-.205-.195c1.893-.214 4.103-.898 5.85-1.367 2.934-.786 5.356-.583 8.386-1.365 1.366-.39 2.899-.781 3.899-1.171v-.78c-1-1.571-2.427-3.651-4.097-5.073-4.369-3.72-9.041-7.437-13.951-10.537-2.723-1.718-6.041-2.835-8.926-4.292-.971-.491-2.652-.746-3.294-1.562-1.517-1.932-2.328-4.382-3.498-6.633-2.449-4.717-4.849-9.868-7.019-14.831-1.48-3.384-2.443-6.72-4.289-9.756-8.86-14.567-18.395-23.358-33.167-32-3.145-1.838-6.929-2.563-10.929-3.513-2.144-.129-4.291-.26-6.437-.391-1.311-.546-2.674-2.149-3.902-2.927-4.896-3.092-17.449-9.817-21.074-.975-2.289 5.581 3.42 11.025 5.462 13.854 1.435 1.982 3.27 4.207 4.293 6.438.675 1.467.79 2.938 1.367 4.489 1.418 3.822 2.651 7.98 4.487 11.511.927 1.788 1.949 3.67 3.122 5.268.718.981 1.95 1.413 2.145 2.927-1.204 1.686-1.273 4.304-1.95 6.44-3.05 9.615-1.898 21.567 2.537 28.683 1.36 2.186 4.566 6.871 8.975 5.073 3.856-1.57 3.226-6.438 4.329-10.732.249-.972-.185-1.688.815-2.341v.195a128.6 128.6 0 0 0 3.282 7.024c2.6 4.187 6.889 8.562 10.798 11.514 2.027 1.531 3.92 4.177 5.92 5.073v-.101h.221c-.507-1-1.302-1.167-1.95-1.804-1.527-1.496-3.226-3.382-4.487-5.097-3.556-4.827-6.698-10.122-9.561-15.622-1.368-2.626-2.557-5.529-3.709-8.201-.443-1.03-.438-2.592-1.364-3.125-1.263 1.958-3.122 3.54-4.099 5.853-1.561 3.696-1.762 8.204-2.341 12.877-.343.122-.19.038-.391.194-2.718-.655-3.672-3.452-4.683-5.853-2.555-6.07-3.029-15.843-.781-22.829.582-1.809 3.211-7.501 2.146-9.172-.508-1.665-2.184-2.63-3.121-3.903-1.161-1.574-2.319-3.646-3.123-5.464-2.091-4.731-3.066-10.044-5.268-14.828-1.053-2.287-2.832-4.602-4.293-6.634-1.617-2.253-3.429-3.912-4.684-6.635-.445-.968-1.051-2.518-.39-3.513.21-.671.507-.951 1.171-1.17 1.133-.873 4.283.29 5.463.779 3.129 1.3 5.741 2.5 8.392 4.256 1.271.844 2.559 1.89 4.097 2.89h1.756c2.747 0 5.824.232 8.391 1.012 4.535 1.379 8.6 3.542 12.292 5.873 11.246 7.102 20.441 17.22 26.732 29.278 1.012 1.942 1.45 3.799 2.341 5.858 1.798 4.153 4.064 8.428 5.853 12.489 1.786 4.053 3.526 8.142 6.05 11.514 1.327 1.772 6.451 2.724 8.78 3.709 1.633.689 4.308 1.409 5.854 2.34 2.953 1.782 5.814 3.904 8.586 5.855 1.384.974 5.64 3.114 5.853 4.878-6.863-.188-12.104.452-16.585 2.341-1.273.537-3.305.552-3.513 2.147.7.733.809 1.829 1.365 2.731 1.069 1.73 2.876 4.052 4.488 5.268 1.762 1.33 3.576 2.751 5.464 3.902 3.359 2.047 7.107 3.217 10.341 5.268 1.906 1.21 3.958 2.733 5.815 4.097.92.675.891 1.724 2.891 2.147v-.194c-.999-.795-.946-1.893-1.522-2.728zM29.514 23.465c-1.431-.027-2.514.157-3.514.389V24h.198c.683 1 1.888 2.33 2.731 3.538l1.952 4.108.193-.187c1.209-.853 1.763-2.211 1.756-4.291-.483-.509-.556-1.146-.974-1.754-.558-.809-1.639-1.268-2.342-1.949z\"/></svg>"

/***/ }),

/***/ "../src/components/mysql/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MysqlPlain = __webpack_require__("../src/components/mysql/plain/MysqlPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MysqlPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nginx/original/NginxOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _NginxOriginal = __webpack_require__("../src/components/nginx/original/NginxOriginal.svg");
	
	var _NginxOriginal2 = _interopRequireDefault(_NginxOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** NginxOriginal */
	function NginxOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'NginxOriginal',
	    svg: _NginxOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	NginxOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = NginxOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nginx/original/NginxOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M24.5 50.5c-1.5 0-2.5 1.2-2.5 2.7v14.1l-15.9-16c-.8-.8-2.2-1-3.2-.6S1 52.1 1 53.2v20.7c0 1.5 1.5 2.7 3 2.7s3-1.2 3-2.7V59.8l16.1 16c.5.5 1.2.8 1.9.8.3 0 .4-.1.7-.2 1-.4 1.3-1.4 1.3-2.5V53.3c0-1.5-1-2.8-2.5-2.8zm19.7 11.8c-1.4 0-2.7 1.4-2.7 2.8s1.3 2.8 2.7 2.8l6.6.4-1.5 3.7h-8.5l-4.2-7.9 4.3-8.1H50l2.1 4h5.5L54 52.1l-.8-1.1H37.6l-.7 1.2L31 62.5l-.7 1.3.7 1.3 5.8 10.3.8 1.6h15.1l.7-1.7 4.3-9 1.9-4.3h-4.4l-11 .3zM65 50.5c-1.4 0-3 1.3-3 2.7V60h6v-6.7c0-1.5-1.6-2.8-3-2.8zm30.4.3c-1-.4-2.4-.2-3.1.6L76 67.4V53.3c0-1.5-1-2.7-2.5-2.7S71 51.8 71 53.3V74c0 1.1.7 2.1 1.7 2.5.3.1.7.2 1 .2.7 0 1.6-.3 2.1-.8l16.2-16V74c0 1.5 1 2.7 2.5 2.7S97 75.5 97 74V53.3c0-1.1-.6-2.1-1.6-2.5zm21.8 12.8l8.4-8.4c1.1-1.1 1.1-2.8 0-3.8-1.1-1.1-2.8-1.1-3.8 0l-8.4 8.4-8.4-8.4c-1.1-1.1-2.8-1.1-3.8 0-1.1 1.1-1.1 2.8 0 3.8l8.4 8.4-8.4 8.4c-1.1 1.1-1.1 2.8 0 3.8.5.5 1.2.8 1.9.8s1.4-.3 1.9-.8l8.4-8.4 8.4 8.4c.5.5 1.2.8 1.9.8s1.4-.3 1.9-.8c1.1-1.1 1.1-2.8 0-3.8l-8.4-8.4zM62 73.9c0 1.4 1.5 2.7 3 2.7 1.4 0 3-1.3 3-2.7V62h-6v11.9z\" fill=\"#090\"/></svg>"

/***/ }),

/***/ "../src/components/nginx/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NginxOriginal = __webpack_require__("../src/components/nginx/original/NginxOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NginxOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodejs/original-wordmark/NodejsOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _NodejsOriginalWordmark = __webpack_require__("../src/components/nodejs/original-wordmark/NodejsOriginalWordmark.svg");
	
	var _NodejsOriginalWordmark2 = _interopRequireDefault(_NodejsOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** NodejsOriginalWordmark */
	function NodejsOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'NodejsOriginalWordmark',
	    svg: _NodejsOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	NodejsOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = NodejsOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodejs/original-wordmark/NodejsOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#83CD29\" d=\"M114.325 80.749c-.29 0-.578-.076-.832-.224l-2.65-1.568c-.396-.221-.203-.3-.072-.345.528-.184.635-.227 1.198-.545.059-.033.136-.021.197.015l2.035 1.209a.261.261 0 0 0 .246 0l7.937-4.581a.248.248 0 0 0 .122-.215v-9.16a.256.256 0 0 0-.123-.219l-7.934-4.577a.254.254 0 0 0-.245 0l-7.933 4.578a.259.259 0 0 0-.125.218v9.16c0 .088.049.171.125.212l2.174 1.257c1.18.589 1.903-.105 1.903-.803v-9.045c0-.127.103-.228.23-.228h1.007c.125 0 .229.101.229.228v9.045c0 1.574-.857 2.477-2.35 2.477-.459 0-.82 0-1.828-.496l-2.081-1.198a1.676 1.676 0 0 1-.832-1.448v-9.16c0-.595.317-1.15.832-1.446l7.937-4.587a1.743 1.743 0 0 1 1.667 0l7.937 4.587c.514.297.833.852.833 1.446v9.16a1.68 1.68 0 0 1-.833 1.448l-7.937 4.582a1.651 1.651 0 0 1-.834.223m2.453-6.311c-3.475 0-4.202-1.595-4.202-2.932a.23.23 0 0 1 .23-.229h1.026a.23.23 0 0 1 .228.194c.154 1.045.617 1.572 2.718 1.572 1.671 0 2.383-.378 2.383-1.266 0-.512-.202-.891-2.8-1.146-2.172-.215-3.515-.694-3.515-2.433 0-1.601 1.35-2.557 3.612-2.557 2.543 0 3.801.883 3.96 2.777a.235.235 0 0 1-.06.176.236.236 0 0 1-.168.073h-1.031a.228.228 0 0 1-.223-.179c-.248-1.1-.848-1.451-2.479-1.451-1.825 0-2.037.637-2.037 1.112 0 .577.25.745 2.715 1.071 2.439.323 3.598.779 3.598 2.494.001 1.733-1.441 2.724-3.955 2.724\"/><path fill=\"#404137\" d=\"M97.982 68.43c.313-.183.506-.517.506-.88v-2.354c0-.362-.192-.696-.506-.879l-8.364-4.856a1.017 1.017 0 0 0-1.019-.002l-8.416 4.859a1.018 1.018 0 0 0-.508.88v9.716c0 .365.196.703.514.884l8.363 4.765c.308.177.686.178.997.006l5.058-2.812a.508.508 0 0 0 .006-.885l-8.468-4.86a.507.507 0 0 1-.256-.44v-3.046c0-.182.097-.349.254-.439l2.637-1.52a.505.505 0 0 1 .507 0l2.637 1.52a.507.507 0 0 1 .255.439v2.396a.507.507 0 0 0 .764.44l5.039-2.932\"/><path fill=\"#83CD29\" d=\"M88.984 67.974a.2.2 0 0 1 .195 0l1.615.933c.06.035.097.1.097.169v1.865c0 .07-.037.134-.097.169l-1.615.932a.194.194 0 0 1-.195 0l-1.614-.932a.194.194 0 0 1-.098-.169v-1.865c0-.069.037-.134.098-.169l1.614-.933\"/><path fill=\"#404137\" d=\"M67.083 71.854c0 .09-.048.174-.127.22l-2.89 1.666a.251.251 0 0 1-.254 0l-2.89-1.666a.255.255 0 0 1-.127-.22v-3.338c0-.09.049-.175.127-.221l2.89-1.668a.248.248 0 0 1 .255 0l2.891 1.668a.258.258 0 0 1 .126.221v3.338zm.781-24.716a.511.511 0 0 0-.756.444v12.915a.359.359 0 0 1-.177.308.359.359 0 0 1-.356 0l-2.108-1.215a1.017 1.017 0 0 0-1.015 0l-8.418 4.858a1.018 1.018 0 0 0-.509.881v9.719c0 .363.194.698.508.881l8.418 4.861c.314.182.702.182 1.017 0l8.42-4.861a1.02 1.02 0 0 0 .508-.881V50.821c0-.368-.2-.708-.521-.888l-5.011-2.795\"/><path fill=\"#83CD29\" d=\"M38.238 59.407a1.014 1.014 0 0 1 1.016 0l8.418 4.857c.314.182.508.518.508.881v9.722c0 .363-.194.699-.508.881l-8.417 4.861a1.02 1.02 0 0 1-1.017 0l-8.415-4.861a1.02 1.02 0 0 1-.508-.881v-9.723c0-.362.194-.698.508-.88l8.415-4.857\"/><path fill=\"#404137\" d=\"M22.93 65.064c0-.366-.192-.702-.508-.883l-8.415-4.843a.99.99 0 0 0-.464-.133h-.087a.993.993 0 0 0-.464.133l-8.416 4.843a1.02 1.02 0 0 0-.509.883l.018 13.04c0 .182.095.351.254.439a.487.487 0 0 0 .505 0l5-2.864c.316-.188.509-.519.509-.882v-6.092c0-.364.192-.699.507-.881l2.13-1.226a.994.994 0 0 1 .508-.137c.174 0 .352.044.507.137l2.128 1.226c.315.182.509.517.509.881v6.092c0 .363.195.696.509.882l5 2.864a.508.508 0 1 0 .76-.439l.019-13.04\"/></svg>"

/***/ }),

/***/ "../src/components/nodejs/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NodejsOriginalWordmark = __webpack_require__("../src/components/nodejs/original-wordmark/NodejsOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NodejsOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodejs/original/NodejsOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _NodejsOriginal = __webpack_require__("../src/components/nodejs/original/NodejsOriginal.svg");
	
	var _NodejsOriginal2 = _interopRequireDefault(_NodejsOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** NodejsOriginal */
	function NodejsOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'NodejsOriginal',
	    svg: _NodejsOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	NodejsOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = NodejsOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodejs/original/NodejsOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#83CD29\" d=\"M112.771 30.334L68.674 4.729c-2.781-1.584-6.402-1.584-9.205 0L14.901 30.334C12.031 31.985 10 35.088 10 38.407v51.142c0 3.319 2.084 6.423 4.954 8.083l11.775 6.688c5.628 2.772 7.617 2.772 10.178 2.772 8.333 0 13.093-5.039 13.093-13.828v-50.49c0-.713-.371-1.774-1.071-1.774h-5.623C42.594 41 41 42.061 41 42.773v50.49c0 3.896-3.524 7.773-10.11 4.48L18.723 90.73c-.424-.23-.723-.693-.723-1.181V38.407c0-.482.555-.966.982-1.213l44.424-25.561c.415-.235 1.025-.235 1.439 0l43.882 25.555c.42.253.272.722.272 1.219v51.142c0 .488.183.963-.232 1.198l-44.086 25.576c-.378.227-.847.227-1.261 0l-11.307-6.749c-.341-.198-.746-.269-1.073-.086-3.146 1.783-3.726 2.02-6.677 3.043-.726.253-1.797.692.41 1.929l14.798 8.754a9.294 9.294 0 0 0 4.647 1.246c1.642 0 3.25-.426 4.667-1.246l43.885-25.582c2.87-1.672 4.23-4.764 4.23-8.083V38.407c0-3.319-1.36-6.414-4.229-8.073zM77.91 81.445c-11.726 0-14.309-3.235-15.17-9.066-.1-.628-.633-1.379-1.272-1.379h-5.731c-.709 0-1.279.86-1.279 1.566 0 7.466 4.059 16.512 23.453 16.512 14.039 0 22.088-5.455 22.088-15.109 0-9.572-6.467-12.084-20.082-13.886-13.762-1.819-15.16-2.738-15.16-5.962 0-2.658 1.184-6.203 11.374-6.203 9.105 0 12.461 1.954 13.842 8.091.118.577.645.991 1.24.991h5.754c.354 0 .692-.143.94-.396.24-.272.367-.613.335-.979-.891-10.568-7.912-15.493-22.112-15.493-12.631 0-20.166 5.334-20.166 14.275 0 9.698 7.497 12.378 19.622 13.577 14.505 1.422 15.633 3.542 15.633 6.395 0 4.955-3.978 7.066-13.309 7.066z\"/></svg>"

/***/ }),

/***/ "../src/components/nodejs/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NodejsOriginal = __webpack_require__("../src/components/nodejs/original/NodejsOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NodejsOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodejs/plain-wordmark/NodejsPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _NodejsPlainWordmark = __webpack_require__("../src/components/nodejs/plain-wordmark/NodejsPlainWordmark.svg");
	
	var _NodejsPlainWordmark2 = _interopRequireDefault(_NodejsPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** NodejsPlainWordmark */
	function NodejsPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'NodejsPlainWordmark',
	    svg: _NodejsPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	NodejsPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = NodejsPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodejs/plain-wordmark/NodejsPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#83CD29\" d=\"M114.325 80.749c-.29 0-.578-.076-.832-.224l-2.65-1.568c-.396-.221-.203-.3-.072-.345.528-.184.635-.227 1.198-.545.059-.033.136-.021.197.015l2.035 1.209a.261.261 0 0 0 .246 0l7.937-4.581a.248.248 0 0 0 .122-.215v-9.16a.256.256 0 0 0-.123-.219l-7.934-4.577a.254.254 0 0 0-.245 0l-7.933 4.578a.259.259 0 0 0-.125.218v9.16c0 .088.049.171.125.212l2.174 1.257c1.18.589 1.903-.105 1.903-.803v-9.045c0-.127.103-.228.23-.228h1.007c.125 0 .229.101.229.228v9.045c0 1.574-.857 2.477-2.35 2.477-.459 0-.82 0-1.828-.496l-2.081-1.198a1.676 1.676 0 0 1-.832-1.448v-9.16c0-.595.317-1.15.832-1.446l7.937-4.587a1.743 1.743 0 0 1 1.667 0l7.937 4.587c.514.297.833.852.833 1.446v9.16a1.68 1.68 0 0 1-.833 1.448l-7.937 4.582a1.651 1.651 0 0 1-.834.223m2.453-6.311c-3.475 0-4.202-1.595-4.202-2.932a.23.23 0 0 1 .23-.229h1.026a.23.23 0 0 1 .228.194c.154 1.045.617 1.572 2.718 1.572 1.671 0 2.383-.378 2.383-1.266 0-.512-.202-.891-2.8-1.146-2.172-.215-3.515-.694-3.515-2.433 0-1.601 1.35-2.557 3.612-2.557 2.543 0 3.801.883 3.96 2.777a.235.235 0 0 1-.06.176.236.236 0 0 1-.168.073h-1.031a.228.228 0 0 1-.223-.179c-.248-1.1-.848-1.451-2.479-1.451-1.825 0-2.037.637-2.037 1.112 0 .577.25.745 2.715 1.071 2.439.323 3.598.779 3.598 2.494.001 1.733-1.441 2.724-3.955 2.724M97.982 68.43c.313-.183.506-.517.506-.88v-2.354c0-.362-.192-.696-.506-.879l-8.364-4.856a1.017 1.017 0 0 0-1.019-.002l-8.416 4.859a1.018 1.018 0 0 0-.508.88v9.716c0 .365.196.703.514.884l8.363 4.765c.308.177.686.178.997.006l5.058-2.812a.508.508 0 0 0 .006-.885l-8.468-4.86a.507.507 0 0 1-.256-.44v-3.046c0-.182.097-.349.254-.439l2.637-1.52a.505.505 0 0 1 .507 0l2.637 1.52a.507.507 0 0 1 .255.439v2.396a.507.507 0 0 0 .764.44l5.039-2.932m-8.998-.456a.2.2 0 0 1 .195 0l1.615.933c.06.035.097.1.097.169v1.865c0 .07-.037.134-.097.169l-1.615.932a.194.194 0 0 1-.195 0l-1.614-.932a.194.194 0 0 1-.098-.169v-1.865c0-.069.037-.134.098-.169l1.614-.933m-21.901 3.88c0 .09-.048.174-.127.22l-2.89 1.666a.251.251 0 0 1-.254 0l-2.89-1.666a.255.255 0 0 1-.127-.22v-3.338c0-.09.049-.175.127-.221l2.89-1.668a.248.248 0 0 1 .255 0l2.891 1.668a.258.258 0 0 1 .126.221v3.338zm.781-24.716a.511.511 0 0 0-.756.444v12.915a.359.359 0 0 1-.177.308.359.359 0 0 1-.356 0l-2.108-1.215a1.017 1.017 0 0 0-1.015 0l-8.418 4.858a1.018 1.018 0 0 0-.509.881v9.719c0 .363.194.698.508.881l8.418 4.861c.314.182.702.182 1.017 0l8.42-4.861a1.02 1.02 0 0 0 .508-.881V50.821c0-.368-.2-.708-.521-.888l-5.011-2.795M38.238 59.407a1.014 1.014 0 0 1 1.016 0l8.418 4.857c.314.182.508.518.508.881v9.722c0 .363-.194.699-.508.881l-8.417 4.861a1.02 1.02 0 0 1-1.017 0l-8.415-4.861a1.02 1.02 0 0 1-.508-.881v-9.723c0-.362.194-.698.508-.88l8.415-4.857M22.93 65.064c0-.366-.192-.702-.508-.883l-8.415-4.843a.99.99 0 0 0-.464-.133h-.087a.993.993 0 0 0-.464.133l-8.416 4.843a1.02 1.02 0 0 0-.509.883l.018 13.04c0 .182.095.351.254.439a.487.487 0 0 0 .505 0l5-2.864c.316-.188.509-.519.509-.882v-6.092c0-.364.192-.699.507-.881l2.13-1.226a.994.994 0 0 1 .508-.137c.174 0 .352.044.507.137l2.128 1.226c.315.182.509.517.509.881v6.092c0 .363.195.696.509.882l5 2.864a.508.508 0 1 0 .76-.439l.019-13.04\"/></svg>"

/***/ }),

/***/ "../src/components/nodejs/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NodejsPlainWordmark = __webpack_require__("../src/components/nodejs/plain-wordmark/NodejsPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NodejsPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodejs/plain/NodejsPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _NodejsPlain = __webpack_require__("../src/components/nodejs/plain/NodejsPlain.svg");
	
	var _NodejsPlain2 = _interopRequireDefault(_NodejsPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** NodejsPlain */
	function NodejsPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'NodejsPlain',
	    svg: _NodejsPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	NodejsPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = NodejsPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodejs/plain/NodejsPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#83CD29\" d=\"M112.678 30.334L68.535 4.729c-2.781-1.584-6.424-1.584-9.227 0L14.82 30.334C11.951 31.985 10 35.088 10 38.407v51.142c0 3.319 1.992 6.423 4.862 8.083l11.729 6.688c5.627 2.772 7.186 2.772 9.746 2.772 8.334 0 12.662-5.039 12.662-13.828v-50.49C49 42.061 49.445 41 48.744 41h-5.622C42.41 41 41 42.061 41 42.773v50.49c0 3.896-3.616 7.773-10.202 4.48L18.676 90.73c-.422-.23-.676-.693-.676-1.181V38.407c0-.482.463-.966.891-1.213l44.378-25.561a1.508 1.508 0 0 1 1.415 0l43.963 25.555c.421.253.354.722.354 1.219v51.142c0 .488.092.963-.323 1.198l-44.133 25.576c-.378.227-.87.227-1.285 0l-11.317-6.749c-.341-.198-.752-.269-1.08-.086-3.145 1.783-3.729 2.02-6.679 3.043-.727.253-1.799.692.408 1.929l14.798 8.754a9.29 9.29 0 0 0 4.647 1.246 9.303 9.303 0 0 0 4.666-1.246l43.976-25.582c2.871-1.672 4.322-4.764 4.322-8.083V38.407c-.001-3.319-1.452-6.414-4.323-8.073zM77.727 81.445c-11.727 0-14.309-3.235-15.17-9.066-.102-.628-.634-1.379-1.274-1.379h-5.73c-.709 0-1.28.86-1.28 1.566 0 7.466 4.06 16.512 23.454 16.512 14.038 0 22.088-5.455 22.088-15.109 0-9.572-6.467-12.084-20.082-13.886-13.762-1.819-15.16-2.738-15.16-5.962 0-2.658 1.184-6.203 11.374-6.203 9.104 0 12.46 1.954 13.841 8.091.119.577.646.991 1.241.991h5.754c.354 0 .691-.143.939-.396.241-.272.367-.613.336-.979-.893-10.569-7.913-15.494-22.112-15.494-12.632 0-20.166 5.334-20.166 14.275 0 9.698 7.497 12.378 19.622 13.577 14.505 1.422 15.633 3.542 15.633 6.395 0 4.956-3.978 7.067-13.308 7.067z\"/></svg>"

/***/ }),

/***/ "../src/components/nodejs/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NodejsPlain = __webpack_require__("../src/components/nodejs/plain/NodejsPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NodejsPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodewebkit/line-wordmark/NodewebkitLineWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _NodewebkitLineWordmark = __webpack_require__("../src/components/nodewebkit/line-wordmark/NodewebkitLineWordmark.svg");
	
	var _NodewebkitLineWordmark2 = _interopRequireDefault(_NodewebkitLineWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** NodewebkitLineWordmark */
	function NodewebkitLineWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'NodewebkitLineWordmark',
	    svg: _NodewebkitLineWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	NodewebkitLineWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = NodewebkitLineWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodewebkit/line-wordmark/NodewebkitLineWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#3D3B47\"><path d=\"M21.6 81.1l39.2 22.5c.9.5 2.1.7 3.3.7 1.1 0 2.3-.2 3.2-.7l38.8-22.5c1.7-1 2.9-3.4 2.9-5.4v-45c0-2-1.2-4.4-2.9-5.4L67.2 2.7c-.8-.5-1.9-.7-3-.7s-2.2.2-3.1.7L21.6 25.2c-1.7 1-3.6 3.4-3.6 5.4v45c0 2 1.9 4.5 3.6 5.5zM21 30.6c0-1.1 1.2-2.8 2.1-3.3L62.2 4.8c.5-.3 1.2-.4 2-.4s1.5.2 1.9.4l39 22.5c1 .6 1.9 2.2 1.9 3.3v45c0 1.1-.9 2.8-1.9 3.3l-39 22.5c-.5.3-1.2.4-1.9.4s-1.5-.2-1.9-.4L23.1 79c-1-.6-2.1-2.2-2.1-3.3V30.6zm40 24.3c.6 1.1 1.7 1.8 3 1.9h.2c1.9 0 3.6-1.5 3.7-3.4 0-.7-.1-1.5-.5-2.1-.6-1.1-1.7-2-3-2.1l-.3-.2c-1.9 0-3.6 1.7-3.7 3.7.1.7.3 1.6.6 2.2zm3.2-4.9c.1 0 .2-.2.2-.2 1.2.1 2.2.6 2.8 1.6.3.6.5 1.2.5 1.9-.1 1.8-1.6 3.2-3.5 3.2H64c-1.2-.1-2.2-.7-2.8-1.7-.3-.6-.5-1.1-.5-1.8.2-1.7 1.7-3 3.5-3zm1 7.6h-.1z\"/><circle cx=\"64.2\" cy=\"53.1\" r=\"1.2\"/><path d=\"M65.3 57.9c-.3.1-.7.1-1 .1H64c-1.6-.1-3.1-1-3.9-2.4-.5-.9-.7-1.8-.7-2.8.1-1.2.6-2.2 1.3-3L28.6 74.1l36.7-16.2zm-.7-9.7c1.6.1 3.1 1 3.9 2.4.5.9.7 1.8.7 2.8-.1 1.2-.6 2.3-1.4 3.1l32.3-23.8L63 48.3c.5-.1 1-.1 1.6-.1zM8.5 108.7c-1.1 0-1.8.3-2.5.8-.4.3-1.1.8-1.1 1.4V109H1v13h4v-7.1c0-.8 0-1.4.2-2 .4-1 1.1-1.4 2.3-1.4.9 0 1.7.3 2 1 .2.4.4.9.4 1.6v7.9h3v-8.8c0-1.6-.4-2.8-1.2-3.5s-1.8-1-3.2-1zm13.4-.1c-2.2 0-3.9.7-4.9 2-1.1 1.4-1.6 3-1.6 4.8 0 1.9.5 3.5 1.6 4.8 1.1 1.3 2.7 2 4.9 2s3.9-.7 4.9-2c1.1-1.3 1.6-2.9 1.6-4.8s-.5-3.5-1.6-4.8c-1-1.3-2.7-2-4.9-2zm2.3 9.8c-.5.7-1.3 1-2.3 1s-1.7-.3-2.3-1-.8-1.7-.8-3 .3-2.3.8-3c.5-.7 1.3-1 2.3-1s1.7.3 2.3 1c.5.7.8 1.7.8 3s-.3 2.4-.8 3zm14.8-7.7c0-.6-.8-1.1-1.4-1.4-.6-.3-1.3-.5-2-.5-1.7 0-3 .6-4 1.9-1 1.3-1.5 3-1.5 5.2 0 1.9.5 3.5 1.5 4.7 1 1.2 2.3 1.8 3.8 1.8.9 0 1.5-.2 2.1-.5s1.5-.9 1.5-1.7v1.9h4v-17h-4v5.6zm-.5 7.7c-.5.7-1.2 1.1-2.2 1.1s-1.7-.4-2.1-1.1c-.5-.7-.7-1.7-.7-2.8 0-1.1.2-2 .7-2.8.5-.7 1.2-1.1 2.2-1.1.6 0 1.2.2 1.7.6.8.7 1.2 1.8 1.2 3.4 0 1.1-.3 2-.8 2.7zm17.7-7.2c-.6-.9-1.3-1.5-2.2-1.9-.9-.4-1.9-.6-3-.6-1.9 0-3.4.6-4.6 1.8-1.2 1.2-1.8 2.9-1.8 5.1 0 2.4.7 4.1 2 5.1 1.3 1.1 2.8 1.6 4.5 1.6 2.1 0 3.7-.7 4.8-1.9.7-.8 1.2-1.4 1.2-2.4h-3.4c-.2 0-.4.7-.7.9-.5.4-1.1.6-1.9.6-.7 0-1.3-.3-1.9-.7-.8-.5-1.3-.9-1.3-2.9h9.3c0-1 0-1.8-.1-2.3 0-1-.4-1.6-.9-2.4zm-8.1 2.8c.1-1 .4-1.4.9-1.9s1.1-.7 2-.7c.8 0 1.5.2 2 .6.5.5.8 1 .9 2h-5.8zm21.7 5.6L67 109h-1.6l-2.9 10.7-3.2-10.7h-1.5l3.8 13h1.8l2.7-11h.1l2.7 11h1.6l4-13H73zm16-8.8c-1-1.2-2.3-1.8-4.1-1.8-.9 0-1.7.2-2.4.5s-1.3.8-1.8 1.4c-.5.6-.9 1.3-1.1 2.1-.3.8-.4 1.7-.4 2.6s.1 1.8.3 2.6c.2.8.6 1.5 1 2.1.5.6 1.1 1 1.8 1.4.7.3 1.6.5 2.6.5.8 0 1.5-.1 2.1-.3.6-.2 1.1-.5 1.5-.9s.8-.8 1.1-1.3.5-.7.7-1.7h-1.6c-.2 1-.7 1.6-1.4 2.1s-1.5.8-2.4.8c-.7 0-1.3-.1-1.8-.4-.5-.3-1-.6-1.3-1.1-.3-.4-.6-.9-.8-1.5-.2-.6-.3-.9-.3-1.9h9.7c0-2-.5-4-1.4-5.2zm-8.3 4.2c.1-1 .2-1.3.4-1.8s.5-1.1.8-1.5c.3-.4.8-.8 1.3-1 .5-.2 1.1-.4 1.7-.4s1.2.1 1.7.3c.5.2.9.5 1.2.9.3.4.6 1 .7 1.5.2.5.3.8.3 1.8h-8.1zm22.8-4c-.5-.6-1-1.1-1.7-1.4-.7-.4-1.5-.5-2.5-.5-.9 0-1.5.2-2.4.6-.8.4-1.7 1-1.7 1.7V105h-2v17h2v-2h-.3c.2 0 .5.6.8.9s.7.5 1.1.7c.4.2.8.3 1.2.4.4.1.8.1 1.2.1 1 0 1.9-.2 2.6-.5.7-.3 1.3-.8 1.7-1.4.5-.6.8-1.3 1-2.1.2-.8.3-1.7.3-2.6 0-.9-.1-1.7-.3-2.5-.2-.7-.5-1.4-1-2zm-.5 7.1c-.2.6-.5 1.1-.9 1.5-.4.4-.8.7-1.4 1-.5.2-1.1.3-1.7.3-.7 0-1.3-.1-1.8-.4-.5-.3-1-.6-1.3-1.1-.4-.5-.6-1-.8-1.7-.2-.7-.3-1.4-.3-2.1 0-.7.1-1.4.3-2 .2-.6.5-1.2.8-1.7.4-.5.8-.9 1.3-1.1.5-.3 1.1-.4 1.8-.4s1.4.1 1.9.4 1 .7 1.4 1.2c.4.5.6 1.1.8 1.8.2.7.2 1.4.2 2.2 0 .8-.1 1.5-.3 2.1zm14.4-9.1h-2l-6.2 6.3V105h-1v17h1v-4.9l2.4-2.1 4.7 7h1.7l-5.3-8.2zm2.8 0h1v13h-1zm0-4h2v2h-2zm9.2 15.9h-.7c-.3 0-.6 0-.8-.1-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.6 0-.2-.1-.5-.1-.8V111h2v-2h-2v-3h-1v3h-2v2h2v8.7c0 .9 0 1.6.4 1.9.4.4.8.5 1.6.5.4 0 .9 0 1.1-.1.3-.1-.1-.1.9-.2v-1.2c-1 .2-.6.2-.8.3z\"/></g></svg>"

/***/ }),

/***/ "../src/components/nodewebkit/line-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NodewebkitLineWordmark = __webpack_require__("../src/components/nodewebkit/line-wordmark/NodewebkitLineWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NodewebkitLineWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodewebkit/line/NodewebkitLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _NodewebkitLine = __webpack_require__("../src/components/nodewebkit/line/NodewebkitLine.svg");
	
	var _NodewebkitLine2 = _interopRequireDefault(_NodewebkitLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** NodewebkitLine */
	function NodewebkitLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'NodewebkitLine',
	    svg: _NodewebkitLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	NodewebkitLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = NodewebkitLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodewebkit/line/NodewebkitLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#3D3B47\"><path d=\"M115.1 28.4L66.9.6C65.8 0 64.4-.3 63-.3s-2.8.3-3.9.9L10.9 28.4C8.7 29.7 7 32.7 7 35.1v55.7c0 2.5 1.7 5.5 3.9 6.7l48.2 27.9c1.1.6 2.5.9 3.9.9s2.8-.3 3.9-.9l48.2-27.9c2.1-1.2 3.9-4.2 3.9-6.7V35.1c0-2.4-1.7-5.4-3.9-6.7zm.9 62.5c0 1.4-1.2 3.4-2.4 4.1l-48.2 27.9c-.6.3-1.5.5-2.4.5-.9 0-1.8-.2-2.4-.5L12.4 95c-1.2-.7-2.4-2.7-2.4-4.1V35.1c0-1.4 1.2-3.4 2.4-4.1L60.6 3.2c.6-.3 1.5-.5 2.4-.5.9 0 1.8.2 2.4.5L113.6 31c1.2.7 2.4 2.7 2.4 4.1v55.8zM67 60.7c-.8-1.3-2.1-2.4-3.7-2.5L63 58c-2.4 0-4.4 2.1-4.6 4.5-.1.9.1 1.9.6 2.7.8 1.3 2.1 2.2 3.7 2.3h.3c2.4 0 4.4-1.9 4.6-4.3 0-.8-.2-1.7-.6-2.5zm-4 6.6h-.3c-1.4-.1-2.7-.9-3.5-2.1-.4-.7-.6-1.4-.6-2.3.2-2.3 2-3.9 4.3-3.9l.3-.2c1.4.1 2.7.8 3.5 2.1.4.7.6 1.6.6 2.4-.1 2.3-2 4-4.3 4zm1.1 1.2z\"/><circle cx=\"63\" cy=\"63\" r=\"1.5\"/><path d=\"M63 69h-.4c-2-.1-3.9-1.2-4.9-3-.6-1.1-.9-2.2-.8-3.5.1-1.4.7-2.7 1.6-3.7L19 88.9l45.4-20v-.1c-.5.2-.9.2-1.4.2zm-1.5-11.9c.6-.1 1.2-.2 1.9-.2 2 .1 3.9 1.3 4.9 3 .6 1.1.9 2.3.8 3.5-.1 1.5-.7 2.8-1.7 3.8l39.9-29.4-45.8 19.3z\"/></g></svg>"

/***/ }),

/***/ "../src/components/nodewebkit/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NodewebkitLine = __webpack_require__("../src/components/nodewebkit/line/NodewebkitLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NodewebkitLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodewebkit/original-wordmark/NodewebkitOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _NodewebkitOriginalWordmark = __webpack_require__("../src/components/nodewebkit/original-wordmark/NodewebkitOriginalWordmark.svg");
	
	var _NodewebkitOriginalWordmark2 = _interopRequireDefault(_NodewebkitOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** NodewebkitOriginalWordmark */
	function NodewebkitOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'NodewebkitOriginalWordmark',
	    svg: _NodewebkitOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	NodewebkitOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = NodewebkitOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodewebkit/original-wordmark/NodewebkitOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#3D3B47\" d=\"M64 99.6c-.9 0-1.7-.2-2.3-.5L24.3 77.4c-1.2-.7-2.3-2.5-2.3-3.9V30.2c0-1.4 1.1-3.2 2.3-3.9L61.7 4.7c.6-.3 1.4-.5 2.3-.5s1.7.2 2.3.5l37.5 21.6c1.2.7 2.3 2.5 2.3 3.9v43.3c0 1.4-1.1 3.2-2.3 3.9L66.3 99.1c-.6.3-1.4.5-2.3.5z\"/><path fill=\"#ccc\" d=\"M64 5.7c.7 0 1.2.2 1.5.3L103 27.6c.7.4 1.5 1.8 1.5 2.6v43.3c0 .8-.8 2.2-1.5 2.6L65.5 97.8c-.3.2-.8.3-1.5.3s-1.2-.2-1.5-.3L25 76.1c-.7-.4-1.5-1.8-1.5-2.6V30.2c0-.8.8-2.2 1.5-2.6L62.5 6c.3-.2.8-.3 1.5-.3m0-3c-1.1 0-2.2.2-3 .7L23.5 25c-1.7 1-3 3.3-3 5.2v43.3c0 1.9 1.4 4.3 3 5.2L61 100.4c.8.5 1.9.7 3 .7s2.2-.2 3-.7l37.5-21.6c1.7-1 3-3.3 3-5.2V30.2c0-1.9-1.4-4.3-3-5.2L67 3.4c-.8-.5-1.9-.7-3-.7z\"/><path fill=\"#EFF3F3\" d=\"M64 48.5h.2c1.1.1 2.1.7 2.7 1.7.3.6.5 1.2.4 1.9-.1 1.8-1.6 3.1-3.4 3.1h-.2c-1.1-.1-2.1-.7-2.7-1.7-.3-.6-.5-1.2-.4-1.9.2-1.7 1.6-3.1 3.4-3.1m0-.2c-1.9 0-3.4 1.5-3.6 3.3 0 .7.1 1.4.5 2 .6 1 1.7 1.7 2.8 1.8h.2c1.9 0 3.4-1.5 3.6-3.3 0-.7-.1-1.4-.5-2-.6-1-1.7-1.7-2.8-1.8H64z\"/><path fill=\"#A1A1A4\" d=\"M64.8 56.2h.1-.1z\"/><path fill=\"#EFF3F3\" d=\"M64.1 50.7c.6 0 1.1.6 1.1 1.3 0 .6-.6 1.1-1.3 1.1-.6 0-1.1-.6-1.1-1.3.1-.7.6-1.1 1.3-1.1zM64 56.6h-.3c-1.6-.1-3-1-3.8-2.4-.5-.8-.7-1.7-.6-2.7.1-1.1.5-2.1 1.2-2.9L29.8 72l35.3-15.5c-.4.1-.7.1-1.1.1z\"/><path fill=\"#0977F7\" d=\"M62.9 47.3c.5-.1 1-.2 1.5-.1 1.6.1 3 1 3.8 2.4.5.8.7 1.8.6 2.7-.1 1.1-.6 2.2-1.3 3l31-22.9-35.6 14.9z\"/><path d=\"M12.3 109.8c.8.7 1.3 1.8 1.3 3.5v8.6h-3.4v-7.8c0-.7-.1-1.2-.3-1.6-.3-.7-1-1-1.9-1-1.1 0-1.9.5-2.3 1.4-.2.5-.3 1.2-.3 2v6.9H2V109h3.2v1.9c.4-.7.8-1.1 1.2-1.4.7-.5 1.6-.8 2.6-.8 1.4 0 2.4.4 3.3 1.1zm15.1 10.5c-1.1 1.3-2.7 2-4.9 2s-3.9-.7-4.9-2c-1.1-1.3-1.6-2.9-1.6-4.8s.5-3.5 1.6-4.8c1.1-1.4 2.7-2 4.9-2s3.9.7 4.9 2c1.1 1.4 1.6 3 1.6 4.8 0 1.9-.6 3.5-1.6 4.8zm-2.7-1.9c.5-.7.8-1.7.8-3s-.3-2.3-.8-3c-.5-.7-1.3-1-2.3-1s-1.7.3-2.3 1c-.5.7-.8 1.7-.8 3s.3 2.3.8 3 1.3 1 2.3 1 1.8-.3 2.3-1zm13.5-9.2c.6.3 1.1.8 1.5 1.4v-6.1h3.4v17.3h-3.3V120c-.5.8-1 1.3-1.6 1.7s-1.4.5-2.3.5c-1.5 0-2.8-.6-3.8-1.8-1-1.2-1.5-2.8-1.5-4.7 0-2.2.5-3.9 1.5-5.2 1-1.3 2.4-1.9 4-1.9.8.1 1.5.3 2.1.6zm.8 9.2c.5-.7.7-1.6.7-2.7 0-1.6-.4-2.7-1.2-3.4-.5-.4-1.1-.6-1.7-.6-1 0-1.7.4-2.2 1.1-.5.7-.7 1.7-.7 2.8 0 1.2.2 2.1.7 2.8.5.7 1.2 1.1 2.1 1.1s1.8-.4 2.3-1.1zm15.5-9.1c.9.4 1.6 1 2.2 1.9.5.8.9 1.6 1 2.7.1.6.1 1.4.1 2.5h-9.3c.1 1.3.5 2.2 1.3 2.7.5.3 1.1.5 1.9.5.8 0 1.4-.2 1.9-.6.3-.2.5-.5.7-.9h3.4c-.1.8-.5 1.5-1.2 2.3-1.1 1.2-2.8 1.9-4.8 1.9-1.7 0-3.2-.5-4.5-1.6-1.3-1.1-2-2.8-2-5.1 0-2.2.6-3.9 1.8-5.1 1.2-1.2 2.7-1.8 4.6-1.8 1 0 2 .2 2.9.6zm-5 2.9c-.5.5-.8 1.2-.9 2h5.8c-.1-.9-.4-1.6-.9-2-.5-.5-1.2-.7-2-.7-.9 0-1.6.2-2 .7zm20.8 7.7l3.3-10.6H75l-4 12.6h-1.5l-2.7-10.5-2.8 10.5h-1.7l-3.8-12.5h1.4L63 120l2.9-10.7h1.6l2.8 10.6zM78 116c0 .7.1 1.3.3 1.9.2.6.4 1.1.8 1.6.3.4.8.8 1.3 1.1.5.3 1.1.4 1.8.4.9 0 1.8-.2 2.4-.7.7-.5 1.1-1.2 1.4-2.1h1.6c-.2.6-.4 1.1-.7 1.7s-.7.9-1.1 1.3-.9.7-1.5.9c-.6.2-1.3.3-2.1.3-1 0-1.9-.2-2.6-.5-.7-.3-1.3-.8-1.8-1.4-.5-.6-.8-1.3-1-2.1-.2-.8-.3-1.7-.3-2.6s.1-1.8.4-2.6c.3-.8.6-1.5 1.1-2.1.5-.6 1.1-1.1 1.8-1.4s1.5-.5 2.4-.5c1.7 0 3.1.6 4.1 1.8 1 1.2 1.5 2.9 1.4 5.1H78zm8.2-1.2c0-.6-.1-1.2-.3-1.7-.2-.5-.4-1-.7-1.4-.3-.4-.7-.7-1.2-.9-.5-.2-1.1-.3-1.7-.3s-1.2.1-1.7.4c-.5.2-.9.6-1.3 1-.3.4-.6.9-.8 1.4-.2.5-.3 1.1-.4 1.7h8.1zm5.9 7.1h-1.4v-17.4h1.4v6.9c.5-.8 1.1-1.4 1.9-1.7.8-.4 1.7-.6 2.5-.6.9 0 1.8.2 2.5.5.7.4 1.3.8 1.7 1.4.5.6.8 1.3 1 2.1.2.8.3 1.6.3 2.5 0 .9-.1 1.8-.3 2.6-.2.8-.5 1.5-1 2.1-.5.6-1 1-1.7 1.4-.7.3-1.6.5-2.6.5-.4 0-.8-.1-1.2-.2-.4-.1-.8-.3-1.2-.5-.4-.2-.8-.5-1.1-.8s-.6-.7-.8-1.1v2.3zm0-6.3c0 .8.1 1.5.3 2.1.2.7.5 1.2.8 1.7.4.5.8.8 1.3 1.1.5.3 1.1.4 1.8.4.6 0 1.2-.1 1.7-.3.5-.2 1-.5 1.4-1 .4-.4.7-.9.9-1.5.2-.6.3-1.3.3-2.1s0-1.5-.2-2.2c-.2-.7-.4-1.3-.8-1.8s-.8-.9-1.4-1.2-1.2-.4-1.9-.4-1.2.1-1.8.4c-.5.3-1 .7-1.3 1.1-.4.5-.6 1-.8 1.7-.2.6-.3 1.3-.3 2zm13.1 6.3v-17.4h1.4v10.8l6.1-5.9h2l-4.7 4.5 5.2 8h-1.6l-4.7-7-2.4 2.2v4.7h-1.3zm12.3-15.2v-2.1h1.6v2.1h-1.6zm0 15.2v-12.5h1.4v12.5h-1.4zm9.6 0c-.2 0-.4.1-.7.2-.3.1-.6.1-1 .1-.7 0-1.3-.2-1.7-.5-.4-.4-.6-1-.6-1.9v-9.1h-1.8v-1.2h1.8V106h1.4v3.5h2.3v1.2h-2.3v9.4l.1.6c.1.1.2.2.4.3.2.1.4.1.7.1h.6l.6-.1v.9z\" fill=\"#3D3B47\"/></svg>"

/***/ }),

/***/ "../src/components/nodewebkit/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NodewebkitOriginalWordmark = __webpack_require__("../src/components/nodewebkit/original-wordmark/NodewebkitOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NodewebkitOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodewebkit/original/NodewebkitOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _NodewebkitOriginal = __webpack_require__("../src/components/nodewebkit/original/NodewebkitOriginal.svg");
	
	var _NodewebkitOriginal2 = _interopRequireDefault(_NodewebkitOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** NodewebkitOriginal */
	function NodewebkitOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'NodewebkitOriginal',
	    svg: _NodewebkitOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	NodewebkitOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = NodewebkitOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodewebkit/original/NodewebkitOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#3D3B47\" d=\"M64 125.8c-1.2 0-2.3-.3-3.1-.7L12.6 97.3c-1.7-1-3.1-3.5-3.1-5.4V36.1c0-1.9 1.5-4.4 3.1-5.4L60.9 2.9c.8-.5 1.9-.7 3.1-.7 1.2 0 2.3.3 3.1.7l48.2 27.9c1.7 1 3.1 3.5 3.1 5.4v55.7c0 1.9-1.5 4.4-3.1 5.4l-48.2 27.9c-.8.4-1.9.6-3.1.6z\"/><path fill=\"#ccc\" d=\"M64 3.7c.9 0 1.8.2 2.4.5L114.6 32c1.2.7 2.4 2.7 2.4 4.1v55.7c0 1.4-1.2 3.4-2.4 4.1l-48.2 27.9c-.6.3-1.5.5-2.4.5-.9 0-1.8-.2-2.4-.5L13.4 96c-1.2-.7-2.4-2.7-2.4-4.1V36.1c0-1.4 1.2-3.4 2.4-4.1L61.6 4.2c.6-.3 1.5-.5 2.4-.5m0-3c-1.4 0-2.8.3-3.9.9L11.9 29.4C9.8 30.7 8 33.7 8 36.1v55.7c0 2.5 1.7 5.5 3.9 6.7l48.2 27.9c1.1.6 2.5.9 3.9.9s2.8-.3 3.9-.9l48.2-27.9c2.1-1.2 3.9-4.2 3.9-6.7V36.1c0-2.5-1.7-5.5-3.9-6.7L67.9 1.6C66.8 1 65.4.7 64 .7z\"/><path fill=\"#EFF3F3\" d=\"M64 59.7h.3c1.4.1 2.7.9 3.5 2.1.4.7.6 1.6.6 2.5-.2 2.3-2 4-4.3 4h-.3c-1.4-.1-2.7-.9-3.5-2.1-.4-.7-.6-1.6-.6-2.5.1-2.2 2-4 4.3-4m0-.3c-2.4 0-4.4 1.9-4.6 4.3-.1.9.1 1.8.6 2.6.8 1.3 2.1 2.2 3.7 2.3h.3c2.4 0 4.4-1.9 4.6-4.3.1-.9-.2-1.8-.6-2.6-.8-1.3-2.1-2.2-3.7-2.3H64z\"/><path fill=\"#EFF3F3\" d=\"M64.1 62.5c.8.1 1.5.8 1.4 1.6-.1.8-.8 1.5-1.6 1.4-.8-.1-1.5-.8-1.4-1.6 0-.8.8-1.5 1.6-1.4zM64 70.1h-.4c-2-.1-3.9-1.3-4.9-3-.6-1.1-.9-2.3-.8-3.5.1-1.4.7-2.7 1.6-3.7v-.1L20 89.9l45.4-20c-.5.1-.9.2-1.4.2z\"/><path fill=\"#0977F7\" d=\"M62.5 58.1c.6-.1 1.2-.2 1.9-.2 2 .1 3.9 1.3 4.9 3 .6 1.1.9 2.3.8 3.5-.1 1.5-.7 2.8-1.7 3.8l39.9-29.4-45.8 19.3z\"/></svg>"

/***/ }),

/***/ "../src/components/nodewebkit/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NodewebkitOriginal = __webpack_require__("../src/components/nodewebkit/original/NodewebkitOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NodewebkitOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodewebkit/plain-wordmark/NodewebkitPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _NodewebkitPlainWordmark = __webpack_require__("../src/components/nodewebkit/plain-wordmark/NodewebkitPlainWordmark.svg");
	
	var _NodewebkitPlainWordmark2 = _interopRequireDefault(_NodewebkitPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** NodewebkitPlainWordmark */
	function NodewebkitPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'NodewebkitPlainWordmark',
	    svg: _NodewebkitPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	NodewebkitPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = NodewebkitPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodewebkit/plain-wordmark/NodewebkitPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M61 52.9c.6 1 1.6 1.6 2.7 1.7h.2c1.8 0 3.3-1.4 3.4-3.2 0-.7-.1-1.4-.5-1.9-.6-1-1.6-1.5-2.7-1.6-.1 0-.2.1-.2.1-1.8 0-3.3 1.3-3.4 3.1 0 .7.2 1.2.5 1.8zm3.1-2.9c.7 0 1.2.6 1.1 1.3 0 .7-.6 1.2-1.3 1.1-.7 0-1.2-.6-1.1-1.3 0-.7.6-1.2 1.3-1.1zM22.9 78.5L61 100.6c1.7 1 4.4 1 6.1 0l38-22.1c1.7-1 2.9-3.4 2.9-5.3V29.1c0-1.9-1.2-4.3-2.9-5.3L67 1.8c-1.7-1-4.4-1-6.1 0l-38 22.1c-1.7 1-2.9 3.4-2.9 5.3v44.1c0 1.9 1.2 4.3 2.9 5.2zm76.2-47.3L67.5 54.5c.8-.8 1.3-1.8 1.3-3 .1-1-.2-1.9-.6-2.7-.8-1.4-2.3-2.3-3.9-2.4-.5 0-1 0-1.5.1l36.3-15.3zM64 48l.3-.2c1.2.1 2.3.6 2.9 1.7.4.6.5 1.3.5 2-.1 1.9-1.7 3.4-3.6 3.4h-.2c-1.2-.1-2.3-.8-2.9-1.8-.4-.6-.5-1.1-.5-1.8 0-2 1.6-3.3 3.5-3.3zm-3.6-.1c-.7.8-1.2 1.8-1.3 3-.1 1 .2 1.9.6 2.7.8 1.4 2.3 2.3 3.9 2.4h.3c.4 0 .7 0 1-.1l-36 15.8 31.5-23.8zM8.5 108.7c-1.1 0-1.8.3-2.5.8-.4.3-1.1.8-1.1 1.4V109H1v13h4v-7.1c0-.8 0-1.4.2-2 .4-1 1.1-1.4 2.3-1.4.9 0 1.7.3 2 1 .2.4.4.9.4 1.6v7.9h3v-8.8c0-1.6-.4-2.8-1.2-3.5s-1.8-1-3.2-1zm13.4-.1c-2.2 0-3.9.7-4.9 2-1.1 1.4-1.6 3-1.6 4.8 0 1.9.5 3.5 1.6 4.8 1.1 1.3 2.7 2 4.9 2s3.9-.7 4.9-2c1.1-1.3 1.6-2.9 1.6-4.8s-.5-3.5-1.6-4.8c-1-1.3-2.7-2-4.9-2zm2.3 9.8c-.5.7-1.3 1-2.3 1s-1.7-.3-2.3-1-.8-1.7-.8-3 .3-2.3.8-3c.5-.7 1.3-1 2.3-1s1.7.3 2.3 1c.5.7.8 1.7.8 3s-.3 2.4-.8 3zm14.8-7.7c0-.6-.8-1.1-1.4-1.4-.6-.3-1.3-.5-2-.5-1.7 0-3 .6-4 1.9-1 1.3-1.5 3-1.5 5.2 0 1.9.5 3.5 1.5 4.7 1 1.2 2.3 1.8 3.8 1.8.9 0 1.5-.2 2.1-.5s1.5-.9 1.5-1.7v1.9h4v-17h-4v5.6zm-.5 7.7c-.5.7-1.2 1.1-2.2 1.1s-1.7-.4-2.1-1.1c-.5-.7-.7-1.7-.7-2.8 0-1.1.2-2 .7-2.8.5-.7 1.2-1.1 2.2-1.1.6 0 1.2.2 1.7.6.8.7 1.2 1.8 1.2 3.4 0 1.1-.3 2-.8 2.7zm17.7-7.2c-.6-.9-1.3-1.5-2.2-1.9-.9-.4-1.9-.6-3-.6-1.9 0-3.4.6-4.6 1.8-1.2 1.2-1.8 2.9-1.8 5.1 0 2.4.7 4.1 2 5.1 1.3 1.1 2.8 1.6 4.5 1.6 2.1 0 3.7-.7 4.8-1.9.7-.8 1.2-1.4 1.2-2.4h-3.4c-.2 0-.4.7-.7.9-.5.4-1.1.6-1.9.6-.7 0-1.3-.3-1.9-.7-.8-.5-1.3-.9-1.3-2.9h9.3c0-1 0-1.8-.1-2.3 0-1-.4-1.6-.9-2.4zm-8.1 2.8c.1-1 .4-1.4.9-1.9s1.1-.7 2-.7c.8 0 1.5.2 2 .6.5.5.8 1 .9 2h-5.8zm21.7 5.6L67 109h-1.6l-2.9 10.7-3.2-10.7h-1.5l3.8 13h1.8l2.7-11h.1l2.7 11h1.6l4-13H73zm16-8.8c-1-1.2-2.3-1.8-4.1-1.8-.9 0-1.7.2-2.4.5s-1.3.8-1.8 1.4c-.5.6-.9 1.3-1.1 2.1-.3.8-.4 1.7-.4 2.6s.1 1.8.3 2.6c.2.8.6 1.5 1 2.1.5.6 1.1 1 1.8 1.4.7.3 1.6.5 2.6.5.8 0 1.5-.1 2.1-.3.6-.2 1.1-.5 1.5-.9s.8-.8 1.1-1.3.5-.7.7-1.7h-1.6c-.2 1-.7 1.6-1.4 2.1s-1.5.8-2.4.8c-.7 0-1.3-.1-1.8-.4-.5-.3-1-.6-1.3-1.1-.3-.4-.6-.9-.8-1.5-.2-.6-.3-.9-.3-1.9h9.7c0-2-.5-4-1.4-5.2zm-8.3 4.2c.1-1 .2-1.3.4-1.8s.5-1.1.8-1.5c.3-.4.8-.8 1.3-1 .5-.2 1.1-.4 1.7-.4s1.2.1 1.7.3c.5.2.9.5 1.2.9.3.4.6 1 .7 1.5.2.5.3.8.3 1.8h-8.1zm22.8-4c-.5-.6-1-1.1-1.7-1.4-.7-.4-1.5-.5-2.5-.5-.9 0-1.5.2-2.4.6-.8.4-1.7 1-1.7 1.7V105h-2v17h2v-2h-.3c.2 0 .5.6.8.9s.7.5 1.1.7c.4.2.8.3 1.2.4.4.1.8.1 1.2.1 1 0 1.9-.2 2.6-.5.7-.3 1.3-.8 1.7-1.4.5-.6.8-1.3 1-2.1.2-.8.3-1.7.3-2.6 0-.9-.1-1.7-.3-2.5-.2-.7-.5-1.4-1-2zm-.5 7.1c-.2.6-.5 1.1-.9 1.5-.4.4-.8.7-1.4 1-.5.2-1.1.3-1.7.3-.7 0-1.3-.1-1.8-.4-.5-.3-1-.6-1.3-1.1-.4-.5-.6-1-.8-1.7-.2-.7-.3-1.4-.3-2.1 0-.7.1-1.4.3-2 .2-.6.5-1.2.8-1.7.4-.5.8-.9 1.3-1.1.5-.3 1.1-.4 1.8-.4s1.4.1 1.9.4 1 .7 1.4 1.2c.4.5.6 1.1.8 1.8.2.7.2 1.4.2 2.2 0 .8-.1 1.5-.3 2.1zm14.4-9.1h-2l-6.2 6.3V105h-1v17h1v-4.9l2.4-2.1 4.7 7h1.7l-5.3-8.2zm2.8 0h1v13h-1zm0-4h2v2h-2zm9.2 15.9h-.7c-.3 0-.6 0-.8-.1-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.6 0-.2-.1-.5-.1-.8V111h2v-2h-2v-3h-1v3h-2v2h2v8.7c0 .9 0 1.6.4 1.9.4.4.8.5 1.6.5.4 0 .9 0 1.1-.1.3-.1-.1-.1.9-.2v-1.2c-1 .2-.6.2-.8.3z\" fill=\"#3D3B47\"/></svg>"

/***/ }),

/***/ "../src/components/nodewebkit/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NodewebkitPlainWordmark = __webpack_require__("../src/components/nodewebkit/plain-wordmark/NodewebkitPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NodewebkitPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodewebkit/plain/NodewebkitPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _NodewebkitPlain = __webpack_require__("../src/components/nodewebkit/plain/NodewebkitPlain.svg");
	
	var _NodewebkitPlain2 = _interopRequireDefault(_NodewebkitPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** NodewebkitPlain */
	function NodewebkitPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'NodewebkitPlain',
	    svg: _NodewebkitPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	NodewebkitPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = NodewebkitPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/nodewebkit/plain/NodewebkitPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#3D3B47\" d=\"M69.7 61.8c-.7-1.2-2-2.1-3.5-2.1h-.3c-2.3 0-4.1 1.8-4.3 4-.1.9.1 1.7.6 2.5.7 1.2 2 2.1 3.5 2.1h.3c2.3 0 4.2-1.8 4.3-4 .1-.9-.1-1.7-.6-2.5zm-3.8 3.7c-.8-.1-1.5-.8-1.4-1.6.1-.8.8-1.5 1.6-1.4.8.1 1.5.8 1.4 1.6 0 .8-.8 1.5-1.6 1.4zm52.2-36.1L69.9 1.6c-2.1-1.2-5.6-1.2-7.7 0L13.9 29.4c-2.1 1.2-3.9 4.2-3.9 6.7v55.7c0 2.5 1.7 5.5 3.9 6.7l48.2 27.9c2.1 1.2 5.6 1.2 7.7 0L118 98.5c2.1-1.2 3.9-4.2 3.9-6.7V36.1c.1-2.4-1.7-5.4-3.8-6.7zM22 89.9l39.5-30.1v.1c-.9 1-1.5 2.3-1.6 3.7-.1 1.2.2 2.4.8 3.5 1 1.8 2.8 2.9 4.9 3h.4c.5 0 .9-.1 1.3-.2L22 89.9zm44-21.3h-.3c-1.5-.1-2.9-.9-3.7-2.3-.5-.8-.7-1.7-.6-2.6.2-2.4 2.2-4.3 4.6-4.3h.3c1.5.1 2.9 1 3.7 2.3.5.8.7 1.7.6 2.6-.2 2.4-2.2 4.3-4.6 4.3zm4.4-.4c1-1 1.6-2.3 1.7-3.8.1-1.2-.2-2.4-.8-3.5-1-1.8-2.9-2.9-4.9-3-.6 0-1.3 0-1.9.2l45.8-19.3-39.9 29.4z\"/></svg>"

/***/ }),

/***/ "../src/components/nodewebkit/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NodewebkitPlain = __webpack_require__("../src/components/nodewebkit/plain/NodewebkitPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NodewebkitPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/npm/original-wordmark/NpmOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _NpmOriginalWordmark = __webpack_require__("../src/components/npm/original-wordmark/NpmOriginalWordmark.svg");
	
	var _NpmOriginalWordmark2 = _interopRequireDefault(_NpmOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** NpmOriginalWordmark */
	function NpmOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'NpmOriginalWordmark',
	    svg: _NpmOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	NpmOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = NpmOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/npm/original-wordmark/NpmOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"NPM\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#cb3837}</style></defs><title>Artboard 5</title><path id=\"original-wordmark\" class=\"cls-1\" d=\"M2 38.5h124v43.71H64v7.29H36.44v-7.29H2zm6.89 36.43h13.78V53.07h6.89v21.86h6.89V45.79H8.89zm34.44-29.14v36.42h13.78v-7.28h13.78V45.79zm13.78 7.29H64v14.56h-6.89zm20.67-7.29v29.14h13.78V53.07h6.89v21.86h6.89V53.07h6.89v21.86h6.89V45.79z\"/></svg>"

/***/ }),

/***/ "../src/components/npm/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NpmOriginalWordmark = __webpack_require__("../src/components/npm/original-wordmark/NpmOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NpmOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/oracle/original/OracleOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _OracleOriginal = __webpack_require__("../src/components/oracle/original/OracleOriginal.svg");
	
	var _OracleOriginal2 = _interopRequireDefault(_OracleOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** OracleOriginal */
	function OracleOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'OracleOriginal',
	    svg: _OracleOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	OracleOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = OracleOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/oracle/original/OracleOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#EA1B22\" d=\"M55.387 66.469h8.333l-4.407-7.09-8.088 12.819h-3.681L57.382 56.8a2.324 2.324 0 0 1 1.931-.998c.765 0 1.478.363 1.892.972l9.876 15.424H67.4l-1.736-2.865h-8.438l-1.839-2.864zm38.235 2.864V55.958h-3.123v14.685c0 .402.156.791.454 1.089.298.298.7.466 1.141.466h14.244l1.841-2.865H93.622zm-51.677-2.397c3.033 0 5.496-2.449 5.496-5.482s-2.462-5.496-5.496-5.496H28.28v16.241h3.123V58.822h10.335c1.452 0 2.618 1.18 2.618 2.631s-1.167 2.631-2.618 2.631l-8.806-.013 9.324 8.127h4.538l-6.274-5.263h1.425zM9.059 72.198c-4.483 0-8.122-3.629-8.122-8.114s3.638-8.127 8.122-8.127h9.439c4.485 0 8.121 3.643 8.121 8.127s-3.636 8.114-8.121 8.114H9.059zm9.229-2.865a5.25 5.25 0 0 0 5.258-5.249 5.262 5.262 0 0 0-5.258-5.263H9.267a5.262 5.262 0 0 0-5.256 5.263 5.25 5.25 0 0 0 5.256 5.249h9.021zm59.314 2.865c-4.484 0-8.126-3.629-8.126-8.114s3.642-8.127 8.126-8.127h11.212l-1.829 2.864H77.81a5.267 5.267 0 0 0-5.264 5.263c0 2.903 2.36 5.249 5.264 5.249h11.263l-1.84 2.865h-9.631zm38.197-2.865a5.25 5.25 0 0 1-5.055-3.824h13.35l1.84-2.864h-15.19a5.266 5.266 0 0 1 5.055-3.824h9.163l1.854-2.864h-11.225c-4.484 0-8.126 3.643-8.126 8.127s3.642 8.114 8.126 8.114h9.631l1.841-2.865h-11.264\"/></svg>"

/***/ }),

/***/ "../src/components/oracle/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _OracleOriginal = __webpack_require__("../src/components/oracle/original/OracleOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OracleOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/photoshop/line/PhotoshopLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PhotoshopLine = __webpack_require__("../src/components/photoshop/line/PhotoshopLine.svg");
	
	var _PhotoshopLine2 = _interopRequireDefault(_PhotoshopLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PhotoshopLine */
	function PhotoshopLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PhotoshopLine',
	    svg: _PhotoshopLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PhotoshopLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PhotoshopLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/photoshop/line/PhotoshopLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#80B5E2\" d=\"M126.216.727C89.993.716 53.932.717 17.708.717 12.527.717 7.257.713 2.076.728 1.748.729 1 .881 1 .964V127h126V.964c0-.083-.414-.237-.784-.237zM113.48 114.666c-32.641-.038-65.271-.03-97.912-.03-1.576 0-1.569-.003-1.569-1.627V15.212C14 13.605 13.984 14 15.577 14h97.798c1.638 0 1.625-.396 1.625 1.291v48.837c0 16.32-.007 32.64.036 48.959.004 1.243-.289 1.58-1.556 1.579zM56.82 39.644c-6.668-1.563-13.38-.792-20.085-.107-1.423.146-1.695.755-1.691 2.018C35.087 56.762 35 71.969 35 87.176V88h9V70.139c5 .375 9.576.286 14.049-1.31 7.169-2.558 10.752-8.111 10.365-16.219-.313-6.548-4.426-11.286-11.594-12.966zm-1.953 22.344c-3.194 1.557-6.59 1.52-10.005 1.058-.266-.036-.675-.511-.677-.784-.04-5.331-.03-10.661-.03-16.138 3.131-.488 6.1-.726 9.062.018 3.673.923 5.804 3.319 6.201 6.917.436 3.954-1.247 7.319-4.551 8.929zm33.301 7.106c-1.469-.805-3.08-1.347-4.606-2.053-1.41-.653-2.833-1.296-4.174-2.076-.935-.543-1.36-1.492-1.36-2.611 0-1.892 1.294-3.417 3.504-3.598 1.649-.135 3.361.035 4.994.34 1.376.256 2.681.899 4.082 1.395l1.767-6.269c-3.345-1.624-6.749-2.235-10.285-2.11-3.006.105-5.814.871-8.352 2.599-4.743 3.229-7.057 11.807.051 16.416 1.805 1.171 3.893 1.905 5.851 2.841 1.218.583 2.489 1.079 3.641 1.772 1.452.874 1.946 2.297 1.694 3.94-.247 1.615-1.33 2.638-2.836 2.874-1.68.264-3.466.435-5.118.144-2.339-.411-4.599-1.281-6.974-1.979-.426 1.59-.831 3.349-1.384 5.06-.303.938-.125 1.401.795 1.768 5.617 2.231 11.334 2.69 17.082.717 4.296-1.475 6.915-4.524 7.256-9.169.332-4.527-1.708-7.851-5.628-10.001z\"/></svg>"

/***/ }),

/***/ "../src/components/photoshop/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PhotoshopLine = __webpack_require__("../src/components/photoshop/line/PhotoshopLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PhotoshopLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/photoshop/plain/PhotoshopPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PhotoshopPlain = __webpack_require__("../src/components/photoshop/plain/PhotoshopPlain.svg");
	
	var _PhotoshopPlain2 = _interopRequireDefault(_PhotoshopPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PhotoshopPlain */
	function PhotoshopPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PhotoshopPlain',
	    svg: _PhotoshopPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PhotoshopPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PhotoshopPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/photoshop/plain/PhotoshopPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#80B5E2\" d=\"M50.246 41.616c-3.682-.925-7.369-.628-11.26-.022 0 6.805-.014 13.427.037 20.05.002.339.511.929.841.974 4.243.573 8.463.619 12.431-1.315 4.105-2 6.196-6.182 5.654-11.092-.492-4.471-3.139-7.448-7.703-8.595zM127 63.963V3.285c0-2.096.023-2.285-2.012-2.285H3.479C1.5 1 1 1.19 1 3.186v121.509c0 2.018.252 2.021 2.209 2.021 40.555.001 81.231-.009 121.786.037 1.573.002 1.995-.417 1.991-1.959-.054-20.277.014-40.556.014-60.831zm-70.648 5.84C50.795 71.785 45 71.896 39 71.431V94H28v-1.402c0-18.895-.087-37.788-.14-56.682-.006-1.569.243-2.327 2.011-2.507 8.332-.852 16.617-1.81 24.902.133 8.906 2.087 14.041 7.975 14.431 16.11.483 10.074-3.944 16.974-12.852 20.151zm44.31 12.754c-.424 5.771-3.678 9.56-9.015 11.392-7.142 2.452-14.245 1.883-21.225-.891-1.143-.455-1.364-1.031-.987-2.196.687-2.126 1.19-4.312 1.72-6.286 2.951.866 5.757 1.947 8.664 2.458 2.053.361 4.272.149 6.359-.178 1.871-.294 3.217-1.564 3.524-3.572.312-2.041-.303-3.809-2.105-4.895-1.432-.862-3.01-1.479-4.523-2.202-2.433-1.163-5.026-2.075-7.27-3.53-8.831-5.727-5.956-16.383-.063-20.396 3.153-2.146 6.642-3.098 10.377-3.229 4.393-.154 8.623.604 12.778 2.623l-2.195 7.789c-1.74-.616-3.36-1.416-5.07-1.734-2.029-.378-4.157-.589-6.205-.422-2.746.225-4.354 2.12-4.354 4.47 0 1.392.528 2.57 1.689 3.245 1.666.969 3.434 1.768 5.186 2.579 1.896.877 3.898 1.551 5.723 2.552 4.87 2.67 7.405 6.8 6.992 12.423z\"/></svg>"

/***/ }),

/***/ "../src/components/photoshop/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PhotoshopPlain = __webpack_require__("../src/components/photoshop/plain/PhotoshopPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PhotoshopPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/php/original/PhpOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PhpOriginal = __webpack_require__("../src/components/php/original/PhpOriginal.svg");
	
	var _PhpOriginal2 = _interopRequireDefault(_PhpOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PhpOriginal */
	function PhpOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PhpOriginal',
	    svg: _PhpOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PhpOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PhpOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/php/original/PhpOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><defs><path id=\"a\" d=\"M64.026 96.076c33.676 0 60.976-14.361 60.976-32.076s-27.3-32.075-60.976-32.075S3.051 46.285 3.051 64s27.3 32.076 60.975 32.076\"/></defs><defs><path id=\"c\" d=\"M2.998 31.924h122.004v64.1H2.998z\"/></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"/></clipPath><clipPath id=\"d\" clip-path=\"url(#b)\"><use xlink:href=\"#c\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#d)\"><defs><path id=\"e\" d=\"M2.998 31.924h122.004v64.1H2.998z\"/></defs><clipPath id=\"f\"><use xlink:href=\"#e\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#f)\"><image overflow=\"visible\" width=\"1160\" height=\"609\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgECqAKoAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAABe6AAAnEwAALd7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAmYEkwMBIgACEQEDEQH/ xAClAAEBAQADAQEAAAAAAAAAAAAAAQIEBgcFAwEBAQEBAAAAAAAAAAAAAAAAAAEDAhABAQEAAQAJ BQEBAQADAAAAAAERECBgAzM0BRUmBzBAUCUWBgInEhMEEQAAAwUIAgICAgMBAAAAAAAAAQIQkaFD NHCx0XKyA3MEQkQRohITITFBYXEVEgABBQEBAAIDAQAAAAAAAAAAYAExQUKBQzACQJAygv/aAAwD AQACEQMRAAAA775/6B5h1PoOA6nPcCnPcAc9wKc68BXPcCnOcEnOcEc9wRznBVznBHOcEc68Ac9w RznBHOcEc5wRznBWc5wRznBHOcEc5wRznBHOcEc5wRznBLznBRznBHOcEc5wYc5wRznBHOcEc5wU c6cEc5wRznBLznAHOcFHOcAc+cEc5wBznBkc+cEvOcAc5wBznAkc9wIc9wIc+cCHPfPh9CfPkv0J 8+H0J8/J9HPz4fQz8/MfRz87K/SfLh9V8ofVfKH1Xyh9V8ofVfKH1Xyh9V8ofVfKH1Xyh9V8ofVf KH1Xyh9V8ofV7n5v387iEx5j6d5j1FOoFKAqSgFFAAAWFEoAABQAAAAAAAAAAAAAQABFEWAKEJRF gBFRARYqURZEWCUSVElLJRlZEmoZmoZmoZmpLmahiahjP6ZPzz+mY/PP6ZXIAAAAAAAAAAAAHf8A oHfzuITHmXpvmXUF7gIUBQoAALZKAAAUAACCkURVSgAAAABFEVEUQAKAAAEJRFEChCUQCURZCUsB FkJRJRJqRJSyUZWRJqGZqGZqGZqS5zuGM7hjO4flN5jGd5WAAAAAAAAAAAAd/wCgd/O4hMeZ+meZ 9wXrmUoUlAAWyUAAoAAEKJSgAAAAAAAAAAAAAAIoiyAUAAIAiiBQiLACKiSiLFSokogJNSJNRZKM rIk1DM1DM1DM1JcTUMTeTGf0yfnneYxNZUAAAAAAAAAAB3/oHfzuITHmfpnmncDvkUACikACgABU lKAAABAoAAAAAAAAAAAAJQAAIqIAFACEoiwCVKIBKiAixUqJKICLIkpZKMrIk1DM1DOd5MzUlzne TOd5MZ/TBjO8y4WAAAAAAAAAADv/AEDv53EJjzT0vzTvlTuAC2SgAFACoFAABYAAAAFCIBUFQVBU FgLBQohRAAAASgARRBAKAERRAoRFglEWRFipRJUQEmpElLJYSakZmoZmoZmoZzuS4zvJnO8mMfpm Pzz+mVyAAAAAAAAAB3/oHfzuITHmvpXmvfIdwWwAKAFSUoAALAACWkEqAAAAKBAAAAAlAAWCwKlC WUAAIBQIqIFACEogAliwAiyIsVKJKiAkqJKXKwk1IzNQzNQznUjM1FxNZM4/TJ+ef0xGJrKgAAAA AAAAO/8AQO/ncQmPNfSvNe+VNOQAoApAoALABCkssAAALAAAAAQAAAFAAAAACVYKgpFogAJQEoiy AUIAiwCWLACLIixUqJKJKJKiSxZNQmdSMzUMzUMzUlxNQxneTGf0wYx+mZcLAAAAAAAAB3/oHfzu ITHm3pPm2nId8hQIpQAIFAJZZYAAWAABYAURRFsuWhFEUSaGWhlRFWQAASgAAoRYFEoAASgRZAKA ERYBLFgBBEWKlRJYJRlZLJqElhJqRmWEzqGZqS4zvJnO8n55/TEYzvKwAAAAAAADv/QO/ncQmPNv SfNtOQ05FQKACwAKQQALAAQKKJali0iiLSKIoiiKIoiiTQyok0MqMtQiywAJQAUIqUCUAJQIqIFA CIsAliwSiCIsWLIiwiwk1JZLCTUjM1DM1DE1Jc53kzneTGP0yfnneZcLAAAAAAAB3/oHfzuITHm3 pPm2nIunAUAFgCFgAWAAgtSrLFpFBRLSxRLRFEURpGWhlqEVUUZahFGWoSaiSaGZoZVZABKAEoFE oAQCpRBKAERYBLFglRJRAsWRASVEliyahM6kZmoZmskzqS4moYzvJjH6YjGd5WAAAAAAAd/6B387 iEx5t6T5vpyGvAAWCAWABYAFhbLKpKpKqyqRQVEtEURaRRFLFEUkmhlRFGVEmoRVZUZUmVGZqEWW BAKChFQtEBAKlEEoCVECpUQEWQlipUSUSUZWSyahJZEzqGZqGZrJmazLnO8mM7yfnneZcLAAAAAA B3/oHfzuITHm/pHm+vAachYIBYAFgILRUqqSqsqkqxKpKpFqxRLRFEURoZaGWoRRFGWoSaGVGVJl RlVZUZUmZqEmoQWBKAEqwtEBALFkAoQlEEqUQEERYqWRFhFkSUuVhJZGZqGZqGc6kuc6hjO8n55/ TEYzvKwAAAAADv8A0Dv53EJjzf0jzfXgNeBALAAsCwqFVShVWVYlUKUoKJaiLSKI0IoiiKIok0Mt Qk0MqMtSpNQk1DLUTKjKqzNQk1EzNQgsCUBYlWFogIBYsgFCIsAliwSokogWSokokslk1CSyJnUM zUMywzneZc51DGP0wYx+mZcAAAAAAd/6B387iEx5v6R5vrwGvEFgAWBYqyyqKqiirEqhSlBbEWkU FLLRFEWmWhloZaGVEUZUSahJomZoZmoSalZahlSZmoZVWZqJlRlZYEoAS1KoQEoEEAoRABLARZEW KlkRYRZElLlYSWRmahmayZmpLjO8mcbyYzvEYmsqAAAAA7/0Dv53EJjzf0jzfXhDbMALAsVZVBVV VJVhVWVQqFUlVZVJVItIqJaIoiiKIoijLUJNDKqyoyoypMzUJNSsqMzUTKwk1KzNRJKMrLAlAWJa llACVKIJQhKIJUsEogiBZKiSiSyWTUJLImdQzNQxNSXOdQxneTGP0xGM7wsAAAAA7/0Dv53EJjzb 0nzbbgNcwsBFlFVVVVUKhVVVJVhVWVSWgqCgoloi0y0WKIok0MtEyoy1CTUJNQk1Ky1DKjM1Eyoz NSszUJKTM1KzNRMrCCwJQlFAlACWLIBQiLAJYBLISxUsiLCLIksWTUJnUjM1kmdQznUlxNZM4/TB jG8y4WAAAADv/QO/ncQmPNvSfNtsw2zAFsVZVVVUWWFVVUVYlVVUlqFBVJaWWiLSKiLTNoijLQyo k0rKjLUMzRMzUJNQyqszUMqTM1DM1KzNQksSTUrM1EzNQgsCUJahaICUCCAVKiCVLBKJKiBZKiSj KyWSwk1IzLCZ1DOdSXOdZM53k/PO8x+c1lQAAAHf+gd/O4hMebek+bbZhtmFlsstspbKqrCqqqKs KqyqKsFCqpQVBaRaZtEWmWhloZaGVGWoSahJqEmpWWoZmokmoZmpWVGZqJmahmalZmomZqGVlSWJ JZYEoCxLUsoASpZAKERYBLARZEWKlkQElRJYslhJZGZqGc6kuc6hjO8mMfpiMY/TCwAAADv/AEDv 53EJjzb0nzbbMN8lWVVFVVWFVVUVYVVFFWFUVVKgtJaJaJaJaItjLQy0MtDKjLUrLUMtQzNDM1DL UrM1EzNQzNSpKMzUTM1DM1KzNRMzUrM1DM1EyssCUJagolCUCCUBLICWLBLISxUqJLBLCSpcrCZ1 IzNZJnUM51JcTWTGd4MZ3iXIAAAHf+gd/O4hMebek+bbZi75KsqqqrCqUqqsUq0oqwqiqqrCqS0F pLUS0stEWmWhloZaGVGWoZahmaJmalZmhmahmalZmoZmomZqVmahmaiZmoZmpWZqJmalZmomZqEF gSrEtSygBLFkAoRAqVEBBECyVElElkslhJqRmWEzrJM6kuM7yZxvJ+ed5jEsUAAB3/oHfzuITHm3 pPm2+SrrwqjUq2yxbKts1CqqqKsKoqqqwqiqKsS2rKpLRLRGkZtEUZaGWoZalZm4ZmoZahmalmZq GZqGZqVmahmaiZmpWZqGZrKSWVJYZmomZqVmaiZWWBKEtSgShKlEEoQlgEsBFkRYqWRASWRFiyWR M6hmWGZrMuc7yZxvJjG8xjOsqAAA7/0Dv53EJjzb0nzfbNV2zVVtli2VbVFWFVWpYtlLVVVhVFUV qWVRVC2JaJaJaIoiiTQy1DLUMzcMzUrM1DM1DM1EzNSszUMzUrM1lJLDM1KzNQzNRMyypLEmdSsz UTM1kBAVZZQlCAWCAVKiCVLBLISxUshLCLIksWSwk1mJLDMsjOdRcTWTGP0xGMbysAAA7/0Dv53E Jjzf0jzfbO1ds1VbZYtlW1YVVtlLVhVW2WLVFUVqVVFUVYLSWiWpZaI0MtDLUMtQy1KzNEzNQzNQ zNSs53kzNSzM1DM1kmdSszUTM1kmdSszUTM1mpLDM1EzNSszWUgsCUJVJQAlSyAUIgVLIAkqIFks hLCSpZLCSyMywmdZJnWZc51DGN5MY3mXIAAHf+gd/O4hMecej+cbZ2y7Z2rK1KWyrasNSrbNQqls 0qrDUpasNSraoqwrRLbLKpLaRoZtEahloZmhhqGZqGZvNmZqGZqGc7zWZqGZrNmZqGZrJM6lZmom ZZWZqGZrKSWVmaiZms1JYkllgShLUoEoSpYBKERYBLAQRAsESWEWSyWElkTOoZlhmWS5zrJnG8mM bxLkAADv/QO/ncQmPOfRvOds7ZduLZYupVtli1ValLZYupVtmoalLVLZqVVLVhWhVlVRaFWItItM tDM0MzQzNQzNSszUM53KxNRM53kzNSsTUMzWbMzUMyyszWUksMzUrMsSSyszWUksqSxMzWQABZZQ lCUCCUISwCWAiyIFiyICSyWSwk1IzLCZ1kmdZlzneTON4MZ1mXCwAAd/6B387iEx5z6N5ztnau3F ssWzStSxbKt1KWyxdSrbNRbNDUstqlqxao1NSqpasKoWktqxURRJoYm5ZhqGZqGJvNZmoYmpZnOo ZzvNZmsmZqWZzqGZYZms2SWGZrNSWJmalZlhM6iZllSWJBYEqyyhKEAsEAqWQEsAlkJYqWRASWRF iyWRmaySWGZZLnOsmc6yYzrMYligAO/9A7+dxCY869F862ztl24tmotlW2ai2VbZqGpS6lW2ai2a LZZbqUupqGpoallupoVYaUVZS0jQy0MzcMNQzNQxN5szNQxNZrM1kzNZszNZMzWazNRM51KzLDM1 mszUTMsrM1DMsSZ1KzLEksqZ1lILAlCWpZQAlggFSoglSwSyEsVLIiwkshLFksiZ1DMsMyyXOdZM 53k/PO8RiWKAA7/0Dv53EJjzr0XzrbO2a24tli2VbqWLZpbZYus6LZZdWU1ZY1ZVupqLZotmpbZo tWLWhVlaUW2ItMtDM0MTeaxN5M53DGd5szneaznUM51LM51DE1mpnWSZ1myZ1kksrMsSZ1KzLDM1 lJLKmdRMyypLEyssCUJaFCAlSyAUIglSwSyEsVLISwgiSxZLCSyMzWSZ1mXM1kznWTGN4jOdZUAB 3/oHfzuITHnXovnW2d1LrxbKt1KWyxdSrbLGrKt1LF1KXWdRdZ0t1LGrKas1LdZ0XUsas1LapdTU K0GiybkYm5ZiahjO81nOoZzrNmZrJnOpWc6zUzrKZms1mWGZZZmayZms1M6yklhmazUliZms1JYk zrNSWJJZYEoS0KEBKlkAoRAqWQlRJYqWQlglkSWLJYSWRM6yTOsyzOsmc6yYzrMYzrKgAO/9A7+d xCY869F862z1ZdeLZpbZYtlXVlLrOotmltljVlNWWXVlNazqLrOi6zqXWs6i6zo1ZqW6mi6ljWpq VWiTcMTUMZ3izOd5MZ3ms51msyxM51mszWTMssznWamdZJnWbJnWSZ1KzLEzLCZ1mpLEmdZqSxJn UrMsSSywJQloUICVLIBQiBUsgIksVLISwSyJLFksJLIksM51Jc51kznWTGd4jGdZUAB3/oHfzuIT Hnfonne2dsuvF1nS2yxbKurKXWdRdZ0tssaspqyy6sprWdRdZ0assutZ1F1nRrWdS61nRrWdRrWd S63jZrNkYzrNZzrNmc6yZzrNZzrNZliZzrNTOsmZZZnOskzrNTOs2TOskllZliZlhJZWZYkllZli SWVmWJJZYEoS0KEBKlkAoRAqWQESWKlkJYJZEliyWElkSWGZZGc6yuc6yZxvEYzrKgAO/wDQO/nc QmPOvRfOts9WXXi6zV1ZYtlXVlLrOous1dWWNWU1ZZdWU1rNjWs6LrOpdazTWs6jWs2XesaNazY/ S40u7mxqSFzcjFzZJckzc1M6zWZcpM6zWZYZlzZM6zUzrJM6zZM6ySXNSWJmWEzrNSWJM6zUliTO s1JYkllgShLQoQEqWQChECpZARJYqWQlglkSWLJYSWRJcklzLM6yZzrJjOsxjOsqAA7/ANA7+dxC Y869F862z1c614tlW6zotljVzpbZY1ZV1c6i6zous6i6zpdXOo1c6NazZdazo1c6jWsal1rGjdzY 3rFN3FXTIuURlBm5qRCZubGbDMuamdZqZsSZsrMsMyyzMsJmypnWUksJmypLEmbKksSZsqSxJLLA lCWhQgJUsgFCIFSyBISxUshLBLIksWSwksiZ1kmdZlmdZM51kxnWIznWVAAd/wCgd/O4hMedei+d bZ2y7caudRbKurnUWyrqyxdZ0Wyy6spq51GrnS6udRq50a1jUutY0bubGtY0bubLrWKbuKbZsVBZ IWSUiDNzUiJJc1IhM2WTNhM2VM2EzZZM6ySWVmWJM6zUlhM2JJZUzYkllSWJIWBKEtChASpZAKEQ SpYJZCWKlkJYQRJYslhJZEzYTOsyzNhnOsmMbxGc6yoADv8A0Dv53EJjzr0XzrbO2Xbi2WNWVbZY 1c6W6zY1c6NXNXWs2NXOjVzqXVzo1c6jVzTdzZd3NN3NjWsU3cpds01cU0zDUgskLJKREkQZuaZu RmyyZsJmypmxJEqS5GbKkRJLKmbCSxJnWaksSSypmxILAlCVSUAJYIBUsgJUsEshLFSyECSyEsWS yJnWSSwzLJc51kmNZM41mMSxQAHf+gd/O4hMec+jec7Z3Wbtxq51Fsq6ubGrKurmmrLGrnS3WbGr nRq5sbuautZsa1jRq5q7ubG7im7ixu4ptku2UaZGpJWpIiIWSCJTKDNlkiEiVJcjNlkiElhM2WSX JJZUlyjNlSWEiJJZZJYQWBKssoShALBASpYBLAJZCWKlkQElkILJZEzYSXJJZLnOsmc6yYzrEZli gAO/9A7+dxCY859G842z1ZduLZYus1dWWLrNXVzTVljVzpbZY1c01rNNXOpdXNN3Go1c01rFl3cU 3cU2zY0g0yNMjUgsgskqyQuUESxEJEpmwkRJLmmbCS5pmxJLkZsqSxJEqSxJLKkuUZsAAFiWiUJQ IJQhLAJYBCIFgiAkslksESJLCZ1kmdZlzLkmNZMZ1mXAAAHf+gd/O4hJ8Q65U6igoqgBQUFEUCiq CgoKQoAUFABQAAAIAEAgAQEFQEBAQIgICFICABAkBBSAAEAoCkQAAKAEQAAEAEQALAQEBBEgIEgQ AAD64fTB/9oACAECAAEFAP8AljGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGR kZGMYxjPu/8AnqV/z1K/46lf8dSv+OpX/HUr/jqV2fUrs+pXZ9Suz6ldl1K7LqV2XUrsupXZdSux 6ldj1K7HqV2PUrsepXY9Sux6ldj1K7HqV2PUrsepXY9Sux6ldj1K7HqV2PUrsepXY9Sux6ldj1K7 HqV/z1K//9oACAEDAAEFAL9HWta1rWta1rWta1rWta1rW/iL1KvUq9Sr1KvUr/rqV/11K/66lf8A XUr/AK6lf9dSv++pX/fUr/vqV/31K/76ldp1K7TqV2nUrtOpXadSu06ldp1K7TqV2nUrtOpXadSu 06ldp1K7TqV2nUrtOpXadSu06ldp1K7TqV2nUr/rqV//2gAIAQEAAQUA7S2dn675u9d83eu+bvXf N3rvm713zd655u9d83euebvXPN3rnm71zzd655u9c82euebPXPNnrnmz1zzZ655s9c82et+bPXPN nrnmz1zzZ635s9b82et+bPW/Nnrfmz1vzZ635s9b82et+bPW/Nnrfmz1vzZ635s9b82et+bPW/Nn rfmz1vzZ635s9b82et+bPW/Nnrfmz1vzZ635s9b82et+bPW/Nnrfmz1vzZ635s9b82et+bPW/Nnr fmz1vzZ635s9b82et+bPXPNnrnmz1zzZ635s9c82euebPXPNnrnmz1zzZ655s9c82euebvXPN3rn m71zzd655u9d83euebvXfN3rvm713zd675u9d83eu+bvXfOHr3nD17zh695w9e84evecPXvOXr/n L1/zl6/5y9f85f0HnT+g86f0HnT+g86f0Pnb+h87f0Xnb+i88f0Xnj+j88f0fnq/6Tz1f9J58v8A pfPn9N5+v+n8/X/T/wCgf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf 1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1H+gf1 H+gf1H+gf1H+gf4bzH/93mH/AOR2vddZs6FixeLFixYsWfe/HHgna911ns6FixZxYsWKs+9+OPBO 17rrRZ0KsWcWLFixZ958ceCdr3XWm81VWKsWLFiz7v448E7XuutVnNVVirFixYs+6+OPBO17rrXY vFWKqxYsVYs+5+OPBO17rrZV4sWKqxYsVZ9z8ceCdr3XW2rxVi8WLFixZ9x8ceCdr3XW68VVVVix YsWfb/HHgna911svFXiqqqsWKs+3+OPBO17rrfV4qqqxYsVZ9t8ceCdr3XXCrxVVVixViz7X448E 7XuuuFXiqqqsWKs+1+OPBO17rrfeKvFVVWLFirPtPjjwTte665VeKqqsWKsX7P448E7XuvxOMYxn UWrxVVVWLFWfZ/HHgna91+CzjGMYxjGMYxnGM4z87eKvFVVWLFWL9l8ceCdr3X32cYxnGMYxnSxj GM4xjOM/OVeKqqsWKs+y+OPBO17v73GMYzpYxjGMYxnSxjGc5+XvFXiqqqsVYv2Pxx4J2vd/d4xn RzoYxjGMYxjGdDOjnGfmLxV4qqqxYqz7H448E7Xu/uM4zoZzjGfYYxnOdDPzNXiqqqsVV+w+OPBO 17v7bPoYzoYxn1MYzoYz85eKvFVVVYqz7D448E7Xu/u8ZzjOc5xjGMYxjGM5znGc4z83VVVVVWKq /X+OPBO17v7nOlnGMYz62MYzjOM6GfmLxV4qqqrFWfX+OPBO17v7fOc6GM6OM+pjOjjOhnOfmaqq qqqqv1vjjwTte7+1zp50MZzjGMYxjGMYxjGc4zoZ0M/MXirxVVVVV+t8ceCdr3f3OM5znGMYxjGM 6WMYxjGMZ0s6WflLxVVVVVVV+t8ceCdr3f3Gc5zjGMZzjGM6OMYxnOMYxnOc5+ZvFXiqqqqr9X44 8E7Xu/ts5zjGM6GM6GMYxjGMYxnQxnOMYzjOc/LXmrxVVVVV+r8ceCdr3f2udHOhjOcYxjGMYxjG MYxjGM5xnOM/OXiqqqqqqr9T448E7Xu/s8+jnOMYxjPrYxjGM5z6Ofl6vFVVVVX6nxx4J2vd/ZZ9 DOcYxnRxjGMYxjGMYzo4xjOc+hn5Oqqqqqqqqr9T448E7Xu/u84zo4xjGMYxjGMYxjGMZ0c4z89e KvFVVVVX6fxx4J2vd/d50MYxjGMYxjGMYxjGMYxjGM6GM5z8zV4q8VVVVVfp/HHgna9391nOMZxj GcYxjGMYxjGMZxjGcYxnOfnavFVVVVVV+n8ceCdr3f3GdDGcYznGMYxjGMYxjGMYxnOcYzoZ+cvF Xiqqqqr9L448E7Xu/qz6uM6OMYxjOMYxjGMYxjGMYxnRxnOfSv5CrxV4qqqqq/S+OPBO17v6k+rn RxjGMYxjGMYxjGMYxjOMYxnSz6t/H1VVVVVVVVfpfHHgna939xnRxjOMYxjGMYxjGMYxjOMYzjGd LPzt4qqqqqqv0vjjwTte76c+wzo4znGMYxjGMYxjGMYxjGMYznGdHPsL+Lq8VeKqqqqv0fjjwTte 75nTn1JOjjOM4xjGMYxjGMYxjGMYxjGMYzjGdGz6l6dX8NVVV4qqqqq/R+OPBO17vpT6k5n0M4xn OMYxjGMYxjGMYxnGMZxnOdGz69/GXiqqqqqq/R+OPBO17ridOczozmdPOMZzjGMYxjGMYxjGMYxj GcYxn0bPp3i9G/h6vFVVVVVV+j8ceCdr3XRnM4nRnQnTk4xnGMYxjGMYxjGMYxjGMYxjOcZ9G9C9 O838VV4q8VVVVX6Pxx4J2vdp0ZxOZxOjOjOJOMZxnGM4xnGMYxjGMYxjGMYxnGcZ9K9G8Xm8XoVf w1XirxVVVVV+h8ceCdr3fQnM5nQicROhOJ0cYzjGcYxjGMYxjGMYxjGMYs4s6N4vQvNXo3i838TV VVVVVVVV+h8ceCdr3adCcTmcTozoToToSJOM4xjGMYxjGMYxjGMYzjOLFnNnRvQvRvF5vF6F/D1e Kqqqqqr9D448E7Xu5zOZxETmJxOhE4iJxIkSc4xjGMYxjGMYxjGMYxjOhZxeLxeKvNXir0KvRvNX 8LV4qqqqqqv0PjjwTte75nM5nE6M6E4iJxESc4xjGMYxjGMYxjGMYxjGM6F4vF4vF6F6N4vN5v4m rxV4qqqqv0PjjwTte7nQnE5nMTiJzETicTiToSM4xjGMYxjGMYxjGMYzjFnQs4qrxVXmrxV5vN4v Qv4arxV4qqqqv0PjjwTte74nM4icTiczmJxETiJxOInGJGMYxjGMYxjGMYxixZxYs4vFXiqvFXm8 Veaq8Xm8VfwtVVXiqqqqr0/jjwTte7ROZzEROYicRE4nERE4icSJEnGMYxjGMYxjGMZxixZxV4qq vF4qrxVXiqqrzeavFX8JVVV4qqqqq9P448E7Xu+IiJzOYnE4iJxEREROIiIk6GJGMYxjGMYxixjO KsXirzV4qrxVXi8VebzVVeb+Gq8VVVVVVXp/HHgna93zOYicxOInERERERERERE5kScYxjGMYxjG cWLOaqqqqqqqqqrxV4q81V5vQq/havFVVVVVV6fxx4J2vd9CcRETicRE4iIiIiJxEREREScYxjGM YxjGMZxYqqqqqqqqqqqqqqvF4qqvTq/havFVVVVVV6fxx4J2vdxOZzERE4iIiIiIiIiIiIiIk4kS JGMYxjGMYsWc2Kqqqqqqqqqqqqq8VVVebzVVfwtXiqqqqqq9P448E7Xu4nM5iIicRERERERERERE REREiRIxjGMYxjFixVVVVVVVVVVVXiqqrxVVV5vNXir+Eq8VVVVVVXp/HHgnad3E5nM5icRERERE RERERERERESJxIxjGMWcVViqqqqqqqqqqqqqqrxV5vN5q8Vfwt4q8VVVVXp/HHgnad2iInM5icRO IiIiIiIiIiIiIiIiRIxjGMWLFVVVVVVVVVVVVVVXirxV5vNVV5q/hKvFVVVVVV6fxx4J2ndoiJxE 5icROIiIiIiIiIiIiIiIiREjGMWLFiqqqqqqqqqqqqqqrxV4q81eKqr0L+EvNVVVVVV6fxx4J2nd oiIiJzE4icREREREREREREREREREjFiqqqqqqqqqqqqqqqqrxV4q81VVVXoX8JeavFVVVV6fxx4J 2ndoiIiJzE4iIiIiIiIiIiIiIiIiIiIxVVVVVVVVVVVVVVVVVVVXirxVVV4q81fwlXirxVVVVen8 ceCdp3aIiIicxOIiIiIiIiIiIiIiIiIiIiVq1VVVVVVVVVVVVVVVVVVV4q8VVVVVeav4SrxV4qqq qvT+OPBO07tEROInMTiJxEREREREREREREREREStWrVVVVVVVVVVVVVVVVV4q8Veaqqqr0L+EvNV VVVVV6fxx4J2ndoiJzOYnETiIiIiIiIiIiIiIiIlRK1rVqrVVVVVVVVVVVVVVVXirxV5q8VVXmr+ EvNVVVVVV6fxx4J2ndxOInM5icROIiIiIiIiIiIiIiIiVK1rWtWrVVVVVVVVVVVVVVVXirxV5vNX i81fwlXiqqqqqq9P448E7Tu4nM5nMTiIiIiIiIiIiIiIiIiVLxrWta1rVq1VVVVVVVVVVVVVVVXi rzebzV4q/hKvFXiqqqq9P448E7Xu4nM5iIicRERERERERERERERESpWta1rWta1aqqqqqqqqqqqq qqqrxVVV5vNVVX8JV4qqqqqqvT+OPBO17tOZzEROYiIiIiJxEREREREvMrWta1rWtatbzaqqqqvF VVVVVeKq8VVVebzeKv4WrxVVVVVVen8ceCdr3fM5iInE5icRERERERERETiJeda1rWta1rW8W81V VVVVXiqqrxV5vFVV5vQv4arxVVVVVVen8ceCdr3fETmInMTiIiJxEREROIiIl6ErWta1rWta1rVq 3m1VVeKqqqrxVVV4q81eLxV5q/havFVVVVVV6fxx4J2vd8TmcziInETiIiInETiIiIlS861rWta1 rWta1vNq1VVVVV4qqqqqrxVXi81eL+JqqqqqqqqvT+OPBO17tE5nMRE6ETiJxE4iInE5iVK3jWta 1rWta1rebWreKvFVVVVVV4q9GqvN5q8VfwlVVXiqqqqr0/jjwTte7nTiJzE4nMTiInERE4nMrWta 1rWta1rWta1a1vN4qqvFVeKvN4q81V6dX8LV4q8VVVVVen8ceCdr3c6E4nM5iczmJxETmcTjW8a1 rWta1rWta1rWta3i3i8W81V4q8VV4qrxebxV5v4arxV4qqqqv0PjjwT/AKz/AOPtV7We1ntd7Ye2 Htl7ae2ntt7ce3Ht17ee3nt9+gfoX6F+ifo36N+kfpX6Z+mfp36h+ofqX6p+qfq36x+sfrX61+uf rn65+vfr369+vfr369+vfrn65+ufrX61+sfrH6t+qfqn6l+ofqH6d+mfpn6V+kfo36N+ifoX6F+g e33t57ee3Xtx7ce23tp7ae2Xth7Ye13tZ7We1XtR7Ue03tR7Ue1HtR7Ue1HtR7Ue1HtR7Ue1HtR7 Ue1HtN7Te03tN7Te0ntJ7Se0ntF7Re0XtB7Qe0Hs97Pezns57NezHst7Leynsl7Iex3sZ7Few3sJ 7Af+fv8Az9/5+/8AP3/n7/z9/wCfvJfQ/wD6n//aAAgBAgIGPwD4YIIIIIIIIIIIIIIIIIIIIIII IIIWLop0U6KdFOinRTop0U6KdFOinRTop0U6KdFPxFPxFPxFfbiK+3EU/EU/EU/EU/EU/EU/EU/E U/EU/EU/EU/EU/EU/EU/EU/EU/8AX+T0PQ2bNmzZs2bNGjRo0aNGjRZZZZZo0aNGjRo0bNmzZs2b Nnoeh6Hoeh6GzZs2bNGjRo0WWWWWX8n/2gAIAQMCBj8A/ZcyKZFMimRTIpkUyKZFMimRTIpkUyKZ FMimRTIpkUyKZFMimRTIpkUyKZFMiq6ZMmTJkyZKKKKKKKKKKK+CiiiiiiiiijJkyZMmTJkwYMmT JkyUUUUUUV+D/9oACAEBAQY/AFGX9kRmThV7jyFXuPIVe48hV7jyFUt5CqW8hVLeQqlvIVS3kKpb yFUt5CqW8hVLeQqlvIVS3kKpbyFUt5CqW8hVLeQqlvIVS3kKpbyFUt5CqW8hVLgKpcBVLeQqlvIV S3kKpbyFUt5CqW8hVLeQqlwFUuAqlwFUuAqlwFUuAqlwFUuAqlwFUuAqlwFUuAqlwFUuAqlwFUuA qlwFUuAqlwFUuAqlwFUt5CqW8hVLeQqlvIVS3kKpbyFUt5CqXAVS4CqW8hVLeQqlvIVS3kKpbyFU t5CqW8hVLeQqlvIVS3kKpbyFUt5CqW8hVLeQqlvIVS3kKpbyFUt5CqW8hVLeQq9x5Cq3HkKvceQq 9x5Cr3HkKvceQq9x5Cr3HkKvceWAq9x5YCr3HlgKvceWAq9x5YCr3HlgKvceWArNx5YCs3HlgKzc eWArNx5YCs3HlgKzceWArNx5YCs3HlgK3ceWArdx5YCt3HlgK3ceWArd15YCu3XlgK7deWArt15Y Cu3XlgK7deWArt15YCu3XlgK7deWArt15YCu3XlgK7deWArt15YCu3XlgK7deWArt15YCu3XlgK7 deWArt15YCu3XlgK7deWArt15YCu3XlgK7deWArt15YCu3XlgK7deWArt15YCu3XlgK7deWArt15 YCu3XlgK7deWArt15YDtL7u8rfUjcSSTV/gjSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7r Ee5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sX lO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucq dLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR 7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU 7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0 sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHu cqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5Tu sR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSx eU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5y p0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6x HucqdLF5TusR7nKnSxeU7rEe5yp0sXlO6xHucqdLF5TusR7nKnSw/wAv6+P5/wCCTESYiTESYiTE SYiTESYiTESoiVESoiVESoiVESoiVESoiVES4iXES4iXES4iXES4iXES4jwiPCI8IjwiPCI8B4Dw HgPAeA8B4jxHiPEeI8R4jwHgPAeA8B4DwHgPCI8IjwiPCIlxEuIlxEuIlxEuIlxEuIlxEqIlREqI lREqIlREqIlREqIlREmIkxEmIkxEmIkxEmIkxEmIkxEiIkREiIkREiIkREiIkREiIkREiIkREiIk REiIkREiIkREiIkREiIkREiIkREiIkREiIkREiIkREiIkREiIkREiI9eI9eI9eI9eI9eI9eI9eI9 eI9eI9aI9aI9b7D1vsPW+w9X7D1fsPV+w9X7D1fsPV+w9X7Dd/8AF/X+v8i/b+r5+Py+P4+fn/TP /9k=\" transform=\"matrix(.106 0 0 -.106 2.825 96.168)\"/></g></g><path fill=\"#6181B6\" d=\"M64.026 93.694c32.36 0 58.594-13.295 58.594-29.694S96.387 34.306 64.026 34.306 5.433 47.601 5.433 64s26.233 29.694 58.593 29.694z\"/><path fill=\"#fff\" d=\"M75.896 73.598l2.906-14.958c.656-3.377.11-5.896-1.62-7.486-1.677-1.54-4.523-2.288-8.703-2.288h-5.033l1.44-7.412a.955.955 0 0 0-.935-1.135h-6.947a.954.954 0 0 0-.936.771l-3.086 15.881c-.28-1.787-.973-3.323-2.079-4.591-2.038-2.332-5.261-3.515-9.58-3.515H27.856a.951.951 0 0 0-.935.771L20.674 81.78a.953.953 0 0 0 .935 1.134h7.002a.953.953 0 0 0 .936-.771l1.511-7.775h5.213c2.735 0 5.032-.296 6.827-.881 1.834-.596 3.522-1.607 5.011-3.001a15.364 15.364 0 0 0 2.96-3.676l-1.248 6.424a.95.95 0 0 0 .935 1.134h6.947a.954.954 0 0 0 .936-.771l3.429-17.645h4.767c2.031 0 2.626.404 2.787.578.147.159.452.718.11 2.48l-2.764 14.223a.95.95 0 0 0 .935 1.134h7.058a.951.951 0 0 0 .935-.769zm-32.208-12.36c-.437 2.242-1.259 3.842-2.444 4.755-1.205.927-3.132 1.397-5.727 1.397h-3.104l2.244-11.548h4.012c2.948 0 4.136.63 4.612 1.158.662.734.802 2.199.407 4.238zm61.916-8.858c-2.038-2.332-5.261-3.515-9.581-3.515H82.559a.952.952 0 0 0-.936.771L75.375 81.78a.953.953 0 0 0 .935 1.134h7.003a.953.953 0 0 0 .935-.771l1.512-7.775h5.212c2.735 0 5.033-.296 6.827-.881 1.835-.596 3.522-1.607 5.011-3.001 1.241-1.141 2.264-2.421 3.037-3.806a15.404 15.404 0 0 0 1.65-4.588c.797-4.094.16-7.363-1.893-9.712zm-7.262 8.858c-.437 2.242-1.259 3.842-2.444 4.755-1.204.927-3.131 1.397-5.727 1.397h-3.104l2.245-11.548h4.012c2.948 0 4.136.63 4.612 1.158.662.734.801 2.199.406 4.238z\"/><path fill=\"#000004\" d=\"M38.67 54.89c2.66 0 4.434.491 5.32 1.474.885.982 1.097 2.668.633 5.057-.484 2.488-1.416 4.264-2.798 5.328-1.382 1.063-3.485 1.595-6.308 1.595h-4.26l2.614-13.453h4.799v-.001zM21.609 81.962h7.002l1.661-8.546h5.998c2.646 0 4.823-.277 6.532-.834 1.709-.556 3.263-1.488 4.661-2.797a14.369 14.369 0 0 0 2.85-3.569c.727-1.3 1.242-2.734 1.547-4.305.741-3.811.182-6.778-1.676-8.904s-4.812-3.189-8.862-3.189H27.856l-6.247 32.144zm35.394-40.691h6.947l-1.661 8.546h6.189c3.894 0 6.58.68 8.059 2.037 1.479 1.359 1.921 3.561 1.33 6.603l-2.906 14.959h-7.058l2.763-14.223c.314-1.618.199-2.722-.347-3.311-.546-.587-1.708-.882-3.485-.882h-5.553l-3.578 18.416h-6.947l6.247-32.145zM93.324 54.89c2.66 0 4.434.491 5.319 1.474.887.982 1.097 2.668.634 5.057-.484 2.488-1.417 4.264-2.799 5.328-1.382 1.063-3.484 1.595-6.308 1.595h-4.259l2.614-13.453h4.799v-.001zm-17.06 27.072h7.002l1.661-8.546h5.997c2.646 0 4.823-.277 6.532-.834 1.71-.556 3.264-1.488 4.661-2.797a14.35 14.35 0 0 0 2.851-3.569c.726-1.3 1.242-2.734 1.547-4.305.74-3.811.182-6.778-1.676-8.904s-4.812-3.189-8.863-3.189H82.511l-6.247 32.144z\"/></svg>"

/***/ }),

/***/ "../src/components/php/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PhpOriginal = __webpack_require__("../src/components/php/original/PhpOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PhpOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/php/plain/PhpPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PhpPlain = __webpack_require__("../src/components/php/plain/PhpPlain.svg");
	
	var _PhpPlain2 = _interopRequireDefault(_PhpPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PhpPlain */
	function PhpPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PhpPlain',
	    svg: _PhpPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PhpPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PhpPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/php/plain/PhpPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#6181B6\" d=\"M64 33.039C30.26 33.039 2.906 46.901 2.906 64S30.26 94.961 64 94.961 125.094 81.099 125.094 64 97.74 33.039 64 33.039zM48.103 70.032c-1.458 1.364-3.077 1.927-4.86 2.507-1.783.581-4.052.461-6.811.461h-6.253l-1.733 10h-7.301l6.515-34H41.7c4.224 0 7.305 1.215 9.242 3.432 1.937 2.217 2.519 5.364 1.747 9.337-.319 1.637-.856 3.159-1.614 4.515a15.118 15.118 0 0 1-2.972 3.748zM69.414 73l2.881-14.42c.328-1.688.208-2.942-.361-3.555-.57-.614-1.782-1.025-3.635-1.025h-5.79l-3.731 19h-7.244l6.515-33h7.244l-1.732 9h6.453c4.061 0 6.861.815 8.402 2.231s2.003 3.356 1.387 6.528L76.772 73h-7.358zm40.259-11.178c-.318 1.637-.856 3.133-1.613 4.488-.758 1.357-1.748 2.598-2.971 3.722-1.458 1.364-3.078 1.927-4.86 2.507-1.782.581-4.053.461-6.812.461h-6.253l-1.732 10h-7.301l6.514-34h14.041c4.224 0 7.305 1.215 9.241 3.432 1.935 2.217 2.518 5.418 1.746 9.39zM95.919 54h-5.001l-2.727 14h4.442c2.942 0 5.136-.29 6.576-1.4 1.442-1.108 2.413-2.828 2.918-5.421.484-2.491.264-4.434-.66-5.458-.925-1.024-2.774-1.721-5.548-1.721zm-56.985 0h-5.002l-2.727 14h4.441c2.943 0 5.136-.29 6.577-1.4 1.441-1.108 2.413-2.828 2.917-5.421.484-2.491.264-4.434-.66-5.458S41.708 54 38.934 54z\"/></svg>"

/***/ }),

/***/ "../src/components/php/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PhpPlain = __webpack_require__("../src/components/php/plain/PhpPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PhpPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/phpstorm/original-wordmark/PhpstormOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PhpstormOriginalWordmark = __webpack_require__("../src/components/phpstorm/original-wordmark/PhpstormOriginalWordmark.svg");
	
	var _PhpstormOriginalWordmark2 = _interopRequireDefault(_PhpstormOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PhpstormOriginalWordmark */
	function PhpstormOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PhpstormOriginalWordmark',
	    svg: _PhpstormOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PhpstormOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PhpstormOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/phpstorm/original-wordmark/PhpstormOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M3.68 98.837c1.197-.2 2.767-.37 4.764-.37 2.453 0 4.25.57 5.392 1.597 1.056.913 1.684 2.31 1.684 4.023 0 1.74-.514 3.11-1.483 4.11-1.313 1.397-3.453 2.11-5.878 2.11-.743 0-1.427-.03-1.998-.17v7.703H3.68V98.837zm2.48 9.273c.543.143 1.228.2 2.056.2 2.996 0 4.822-1.456 4.822-4.11 0-2.538-1.798-3.765-4.537-3.765-1.084 0-1.91.086-2.34.2v7.475zm12.466-10.53h2.51v8.618h.058a4.666 4.666 0 0 1 1.797-1.77c.743-.427 1.628-.713 2.57-.713 1.855 0 4.822 1.14 4.822 5.907v8.217H27.87v-7.933c0-2.226-.827-4.11-3.195-4.11-1.627 0-2.91 1.142-3.367 2.512-.143.342-.17.713-.17 1.198v8.332h-2.512V97.58zm15.831 10.958c0-1.77-.057-3.195-.114-4.508h2.255l.114 2.37h.057c1.026-1.685 2.652-2.684 4.906-2.684 3.34 0 5.85 2.825 5.85 7.02 0 4.963-3.025 7.418-6.277 7.418-1.827 0-3.425-.8-4.254-2.17h-.056v7.505h-2.482v-14.952zm2.483 3.68c0 .372.057.714.114 1.028.457 1.74 1.97 2.94 3.766 2.94 2.653 0 4.195-2.17 4.195-5.336 0-2.768-1.456-5.136-4.11-5.136-1.71 0-3.308 1.227-3.795 3.11-.085.314-.17.685-.17 1.027v2.37zm13.692 1.142c1.17.6 2.968 1.2 4.822 1.2 1.997 0 3.053-.828 3.053-2.084 0-1.2-.912-1.883-3.225-2.71-3.195-1.114-5.278-2.883-5.278-5.68 0-3.28 2.738-5.79 7.275-5.79 2.168 0 3.765.456 4.908.97l-.97 3.51a9.133 9.133 0 0 0-4.024-.915c-1.883 0-2.797.858-2.797 1.856 0 1.227 1.085 1.77 3.567 2.71 3.396 1.256 4.994 3.025 4.994 5.736 0 3.225-2.482 5.964-7.76 5.964-2.198 0-4.366-.57-5.45-1.17l.884-3.596zM70.46 99.893v3.994h3.11v3.196h-3.11v5.05c0 1.683.4 2.454 1.712 2.454.542 0 .97-.057 1.284-.114l.028 3.28c-.57.23-1.598.372-2.825.372-1.398 0-2.568-.485-3.253-1.2-.798-.826-1.198-2.168-1.198-4.136v-5.708h-1.856v-3.196h1.855v-3.024l4.25-.97zm19.256 10.814c0 5.107-3.623 7.447-7.36 7.447-4.08 0-7.22-2.682-7.22-7.19 0-4.51 2.968-7.39 7.447-7.39 4.28 0 7.133 2.938 7.133 7.133zm-10.1.142c0 2.395 1 4.193 2.853 4.193 1.683 0 2.767-1.683 2.767-4.194 0-2.084-.798-4.196-2.768-4.196-2.083 0-2.854 2.14-2.854 4.195zm12.78-2.369c0-2.053-.057-3.394-.114-4.593h3.737l.14 2.568h.115c.715-2.025 2.426-2.88 3.766-2.88.4 0 .6 0 .915.056v4.08a6.22 6.22 0 0 0-1.17-.113c-1.598 0-2.683.856-2.967 2.197a5.125 5.125 0 0 0-.086.97v7.076h-4.336v-9.36zm10.84-.142c0-1.74-.057-3.224-.114-4.45h3.652l.2 1.882h.084c.6-.884 1.826-2.197 4.223-2.197 1.8 0 3.226.913 3.824 2.368h.057a6.238 6.238 0 0 1 1.8-1.682c.77-.457 1.625-.685 2.652-.685 2.68 0 4.708 1.883 4.708 6.05v8.216h-4.223v-7.59c0-2.026-.656-3.196-2.055-3.196-1 0-1.712.685-1.997 1.512-.114.314-.17.77-.17 1.113v8.16h-4.224v-7.82c0-1.768-.626-2.967-1.995-2.967-1.113 0-1.77.856-2.027 1.57-.142.342-.17.74-.17 1.083v8.132h-4.223v-9.5zM66.257 69.99c1.415 1.838 2.833 2.626 4.538 2.626 2.962 0 5.543-2.54 5.543-6.38V55.99c0-4.542-2.29-7.04-5.543-7.04-1.83 0-3.83 1.04-5.168 3.286V49.57h-5.704v34.44H30.16V69.99c1.414 1.838 2.834 2.626 4.54 2.626 2.96 0 5.543-2.54 5.543-6.38V55.99c0-4.542-2.287-7.04-5.542-7.04-1.832 0-3.833 1.04-5.167 3.286V49.57h-5.706v34.44H19.24V33.53h22.624v38.462h6.333V56.197c0-1.293.536-2.083 1.75-2.083 1.086 0 1.664.666 1.664 2.083v15.795h6.338V54.03c0-3.5-2.335-5.082-5.046-5.082-1.67 0-3.46.54-4.706 2.12V33.532h24.39c-.003.087-.01.154-.01.24l.07 2.147c0 3.138 1.513 6.986 2.26 8.693 0 0 2.148 4.405 3.81 6.135 1.66 1.725 2.883 3.018 4.293 4.378 1.304 1.25 2.53 2.438 3.192 3.254 1.1 1.358 1.168 2.518 1.267 4.204.194 3.286-1.014 5.194-2.88 7.734-1.897 2.59-2.94 3.71-4.144 5.007-.604.655-1.236 1.334-1.992 2.208l-.608.704c-1.215 1.4-2.242 2.59-3.11 3.682l-1.947 2.093h-6.534V69.99zm3.746-5.043V56.86c0-1.79-.624-2.746-1.87-2.746-1.254 0-1.876.956-1.876 2.747v8.087c0 1.793.622 2.627 1.875 2.627 1.247 0 1.87-.833 1.87-2.627zm-36.097 0V56.86c0-1.79-.622-2.746-1.87-2.746-1.25 0-1.877.956-1.877 2.747v8.087c0 1.793.625 2.627 1.876 2.627 1.248 0 1.87-.833 1.87-2.627z\" fill=\"#5058A6\"/><path fill=\"#F58A1F\" d=\"M103.69 16.55c1.454-1.684 2.654-3.048 3.64-4.288H85.257c-1.312 1.677-3.98 4.908-5.502 7.775-2.01 3.794-3.666 6.642-3.828 13.628l.07 2.253c0 3.33 2.387 8.22 2.387 8.22.372.87 1.63 2.7 2.436 3.82h-.018c.267.354.44.58.44.58 2.38 2.725 5.98 5.77 7.568 7.727 1.858 2.297 1.906 4.445 2.003 6.116.273 4.522-1.56 7.25-3.518 9.92-2.957 4.036-4.025 4.785-6.3 7.425-1.455 1.68-2.65 3.044-3.635 4.285h22.8c1.338-1.723 3.238-4.89 4.77-7.775 2.01-3.794 3.668-6.644 3.83-13.624l-.073-2.252c0-3.33-2.38-8.225-2.38-8.225-.375-.868-1.634-2.692-2.445-3.82h.017c-.26-.348-.44-.58-.44-.58-2.373-2.723-5.978-5.768-7.562-7.725-1.86-2.293-1.91-4.44-2.01-6.118-.27-4.52 1.56-7.25 3.517-9.92 2.962-4.032 4.03-4.786 6.304-7.42z\"/></svg>"

/***/ }),

/***/ "../src/components/phpstorm/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PhpstormOriginalWordmark = __webpack_require__("../src/components/phpstorm/original-wordmark/PhpstormOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PhpstormOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/phpstorm/original/PhpstormOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PhpstormOriginal = __webpack_require__("../src/components/phpstorm/original/PhpstormOriginal.svg");
	
	var _PhpstormOriginal2 = _interopRequireDefault(_PhpstormOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PhpstormOriginal */
	function PhpstormOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PhpstormOriginal',
	    svg: _PhpstormOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PhpstormOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PhpstormOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/phpstorm/original/PhpstormOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#5058A6\" d=\"M67.145 94.463c1.973 2.56 3.948 3.66 6.325 3.66 4.13 0 7.726-3.543 7.726-8.892V74.946c0-6.33-3.19-9.81-7.726-9.81-2.552 0-5.34 1.445-7.203 4.577v-3.714h-7.95V114H16.833V94.463c1.973 2.56 3.95 3.66 6.33 3.66 4.127 0 7.725-3.543 7.725-8.892V74.946c0-6.33-3.188-9.81-7.724-9.81-2.555 0-5.344 1.445-7.203 4.577v-3.714H8.01V114H1.614V43.646h31.533v53.607h8.827V75.237c0-1.803.747-2.903 2.44-2.903 1.514 0 2.32.928 2.32 2.903v22.015h8.832V72.217c0-4.88-3.255-7.083-7.033-7.083-2.326 0-4.82.752-6.56 2.957V43.647H75.97c-.005.12-.016.213-.016.335l.1 2.992c0 4.374 2.107 9.736 3.15 12.116 0 0 2.994 6.14 5.312 8.55 2.313 2.405 4.018 4.207 5.982 6.103 1.82 1.745 3.528 3.4 4.45 4.537 1.532 1.893 1.628 3.51 1.766 5.86.27 4.58-1.412 7.237-4.012 10.78-2.646 3.61-4.097 5.17-5.778 6.978-.843.912-1.723 1.858-2.776 3.076l-.848.982c-1.694 1.952-3.124 3.61-4.337 5.13L76.253 114h-9.107V94.463zm5.222-7.03v-11.27c0-2.497-.87-3.83-2.608-3.83-1.748 0-2.614 1.333-2.614 3.83v11.27c0 2.5.867 3.662 2.613 3.662 1.738 0 2.607-1.162 2.607-3.662zm-50.312 0v-11.27c0-2.497-.867-3.83-2.606-3.83-1.745 0-2.617 1.333-2.617 3.83v11.27c0 2.5.872 3.662 2.616 3.662 1.738 0 2.605-1.162 2.605-3.662z\"/><path fill=\"#F58A1F\" d=\"M119.32 19.977c2.028-2.348 3.7-4.25 5.072-5.977H93.63c-1.83 2.337-5.547 6.84-7.67 10.837-2.8 5.288-5.11 9.258-5.335 18.994l.098 3.14c0 4.64 3.326 11.458 3.326 11.458.517 1.212 2.272 3.765 3.394 5.325h-.026c.372.492.614.808.614.808 3.315 3.798 8.333 8.04 10.547 10.77 2.59 3.2 2.655 6.194 2.79 8.523.38 6.3-2.174 10.103-4.902 13.826-4.12 5.622-5.61 6.667-8.782 10.347-2.026 2.343-3.69 4.243-5.065 5.972h31.78c1.867-2.402 4.515-6.818 6.65-10.838 2.802-5.288 5.113-9.26 5.336-18.99l-.1-3.14c0-4.64-3.32-11.464-3.32-11.464-.52-1.21-2.275-3.752-3.405-5.323h.025a49.958 49.958 0 0 0-.612-.808c-3.307-3.797-8.333-8.04-10.54-10.768-2.59-3.197-2.663-6.19-2.8-8.528-.376-6.302 2.174-10.103 4.902-13.826 4.126-5.617 5.612-6.667 8.784-10.34z\"/></svg>"

/***/ }),

/***/ "../src/components/phpstorm/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PhpstormOriginal = __webpack_require__("../src/components/phpstorm/original/PhpstormOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PhpstormOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/phpstorm/plain-wordmark/PhpstormPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PhpstormPlainWordmark = __webpack_require__("../src/components/phpstorm/plain-wordmark/PhpstormPlainWordmark.svg");
	
	var _PhpstormPlainWordmark2 = _interopRequireDefault(_PhpstormPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PhpstormPlainWordmark */
	function PhpstormPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PhpstormPlainWordmark',
	    svg: _PhpstormPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PhpstormPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PhpstormPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/phpstorm/plain-wordmark/PhpstormPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#5058A6\"><path d=\"M13.836 100.063c-1.14-1.026-2.778-1.598-5.23-1.598-2 0-3.606.172-4.606.372V118h2v-7.864c1 .143 1.335.17 2.078.17 2.425 0 4.605-.712 5.918-2.11.97-1 1.504-2.37 1.504-4.11 0-1.71-.608-3.11-1.664-4.023zm-5.7 8.246c-.828 0-1.136-.057-2.136-.2v-7.476c1-.114 1.335-.2 2.42-.2 2.74 0 4.538 1.227 4.538 3.766 0 2.655-1.827 4.11-4.823 4.11zm17.234-4.593c-.943 0-1.732.186-2.474.615-.77.43-1.302.67-1.7 1.67H21v-8h-2v20h2v-8.49c0-.486.096-.857.24-1.2.457-1.37 1.84-2.51 3.466-2.51 2.368 0 3.294 1.882 3.294 4.108V118h2v-8.378c0-4.765-2.776-5.906-4.63-5.906zm16.307-.2c-2.254 0-3.88 1.484-4.907 2.484h-.057l-.114-2h-2.256c.056 1-.344 2.77-.344 4.538V123h3v-7h-.003c.83 1 2.426 2.16 4.253 2.16 3.252 0 6.276-2.557 6.276-7.52 0-4.195-2.51-7.124-5.85-7.124zm-.857 12.67c-1.797 0-3.28-1.2-3.736-2.94A5.762 5.762 0 0 1 37 112.22v-2.37c0-.342.056-.712.14-1.026.487-1.883 2.07-3.11 3.782-3.11 2.653 0 4.1 2.37 4.1 5.136 0 3.166-1.548 5.335-4.202 5.335zm17.145-9.759c-2.482-.942-3.567-1.484-3.567-2.71 0-1 .914-1.856 2.797-1.856a9.14 9.14 0 0 1 4.023.915l.97-3.51c-1.14-.513-2.74-.97-4.908-.97-4.537 0-7.275 2.51-7.275 5.792 0 2.796 2.082 4.565 5.278 5.678 2.312.827 3.225 1.512 3.225 2.71 0 1.257-1.056 2.084-3.053 2.084-1.854 0-3.652-.6-4.822-1.2l-.884 3.595c1.084.6 3.253 1.17 5.45 1.17 5.278 0 7.76-2.74 7.76-5.964 0-2.71-1.6-4.478-4.995-5.733zM70 99.893l-4 .97V104h-2v3h2v5.79c0 1.968.504 3.31 1.302 4.137.685.713 1.907 1.2 3.305 1.2 1.227 0 2.28-.144 2.85-.372l-.014-3.28c-.315.056-.966.113-1.507.113-1.312 0-1.935-.77-1.935-2.454V107h4v-3h-4v-4.107zm12.583 3.681c-4.48 0-7.446 2.88-7.446 7.39 0 4.508 3.138 7.19 7.22 7.19 3.736 0 7.36-2.34 7.36-7.447 0-4.195-2.853-7.133-7.134-7.133zm-.114 11.47c-1.855 0-2.854-1.8-2.854-4.195 0-2.056.77-4.196 2.853-4.196 1.97 0 2.767 2.112 2.767 4.195 0 2.51-1.084 4.193-2.768 4.193zM96.275 106h-.114l-.14-2H92.28c.057 1-.282 2.427-.282 4.48V118h5v-7.236c0-.343-.105-.685-.048-.97.284-1.34 1.325-2.197 2.922-2.197.485 0 1.125.057 1.125.114v-4.08c0-.056-.537-.284-.937-.284-1.34 0-3.073.654-3.788 2.654zm23.178-2.426c-1.028 0-1.803.257-2.573.714-.657.4-1.204.713-1.718 1.713h-.057c-.6-2-2.025-2.28-3.823-2.28-2.397 0-3.623 1.28-4.223 2.28h-.086l-.2-2h-3.65c.056 1-.122 2.6-.122 4.34V118h4v-8.292c0-.343.258-.742.4-1.084.256-.713 1.202-1.57 2.315-1.57 1.37 0 2.285 1.2 2.285 2.97V118h4v-8.32c0-.344-.005-.8.11-1.114.285-.827.917-1.512 1.916-1.512 1.4 0 1.974 1.17 1.974 3.195V118h4v-8.378c-.002-4.165-1.868-6.048-4.55-6.048zM34 64.947V56.86c0-1.79-.75-2.746-1.996-2.746-1.25 0-2.004.956-2.004 2.747v8.087c0 1.793.752 2.627 2.004 2.627 1.247 0 1.996-.833 1.996-2.627z\"/><path d=\"M78.456 77.53c.755-.874 1.387-1.553 1.992-2.207 1.206-1.297 2.247-2.417 4.145-5.007 1.866-2.54 3.073-4.448 2.878-7.733-.098-1.686-.167-2.846-1.266-4.204-.662-.818-1.89-2.004-3.193-3.255-1.408-1.36-2.63-2.653-4.29-4.378-1.665-1.73-3.812-6.135-3.812-6.135-.748-1.707-2.26-5.555-2.26-8.693l-.07-1.913c0-.088.007-.006.01-.006H48v17.07c1-1.58 3.16-2.12 4.83-2.12 2.71 0 5.17 1.58 5.17 5.082V72h-6V56.197c0-1.417-.87-2.083-1.956-2.083-1.215 0-2.044.79-2.044 2.083V72h-6V34H19v50h5V50h6v2.233c1-2.247 2.98-3.285 4.813-3.285 3.254 0 5.187 2.497 5.187 7.04v10.248c0 3.838-2.54 6.38-5.5 6.38-1.707 0-2.5-.79-4.5-2.626V84h30V50h6v2.233c1-2.247 2.98-3.285 4.812-3.285 3.254 0 5.188 2.497 5.188 7.04v10.248c0 3.838-2.54 6.38-5.503 6.38-1.705 0-2.497-.79-4.497-2.626V84h6.79l1.946-2.09c.87-1.09 1.896-2.278 3.11-3.68l.61-.7z\"/><path d=\"M70 64.947V56.86c0-1.79-.75-2.746-1.998-2.746-1.253 0-2.002.956-2.002 2.747v8.087c0 1.793.748 2.627 2.002 2.627 1.247 0 1.998-.833 1.998-2.627zm8.385-20.789c.372.87 1.63 2.842 2.436 3.842h-.018c.267 0 .44.56.44.56 2.38 2.723 5.98 5.757 7.568 7.714 1.858 2.297 1.906 4.44 2.003 6.11.273 4.522-1.56 7.247-3.518 9.918-2.957 4.034-4.025 4.78-6.3 7.42C79.54 81.4 78.346 83 77.36 84h22.8c1.34-2 3.24-4.887 4.77-7.77 2.012-3.795 3.67-6.643 3.83-13.623l-.072-2.252c0-3.33-2.38-8.38-2.38-8.38-.375-.87-1.634-2.975-2.445-3.975h.017c-.26 0-.44-.424-.44-.424-2.372-2.724-5.977-5.69-7.56-7.648-1.86-2.293-1.912-4.402-2.012-6.08-.27-4.52 1.56-7.228 3.518-9.9 2.96-4.03 4.027-4.904 6.303-7.54 1.454-1.683 2.654-2.408 3.64-4.408H85.257c-1.312 2-3.98 5.04-5.502 7.906-2.01 3.794-3.666 6.708-3.828 13.693l.07 2.295c0 3.33 2.387 8.263 2.387 8.263z\"/></g></svg>"

/***/ }),

/***/ "../src/components/phpstorm/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PhpstormPlainWordmark = __webpack_require__("../src/components/phpstorm/plain-wordmark/PhpstormPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PhpstormPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/phpstorm/plain/PhpstormPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PhpstormPlain = __webpack_require__("../src/components/phpstorm/plain/PhpstormPlain.svg");
	
	var _PhpstormPlain2 = _interopRequireDefault(_PhpstormPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PhpstormPlain */
	function PhpstormPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PhpstormPlain',
	    svg: _PhpstormPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PhpstormPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PhpstormPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/phpstorm/plain/PhpstormPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#5058A6\"><path d=\"M72 82.433v-11.27c0-2.497-.76-3.83-2.497-3.83-1.747 0-2.503 1.333-2.503 3.83v11.27c0 2.5.756 3.662 2.503 3.662 1.738 0 2.497-1.162 2.497-3.662z\"/><path d=\"M84.148 99.97c1.053-1.217 1.933-2.163 2.776-3.075 1.68-1.808 3.132-3.37 5.778-6.98 2.6-3.54 4.283-6.2 4.012-10.778-.138-2.35-.234-3.967-1.765-5.86-.924-1.138-2.633-2.792-4.452-4.536-1.964-1.895-3.67-3.697-5.982-6.1-2.32-2.412-5.312-8.552-5.312-8.552-1.042-2.38-3.15-7.743-3.15-12.116l-.1-2.814c0-.122.01-.158.016-.158H42v24.09c2-2.203 4.437-2.956 6.763-2.956 3.778 0 7.237 2.204 7.237 7.083V92h-9V70.237c0-1.976-.926-2.903-2.44-2.903-1.693 0-2.56 1.1-2.56 2.903V92h-9V39H2v70h6V61h8v3.712c2-3.132 4.684-4.578 7.24-4.578 4.536 0 7.76 3.48 7.76 9.81V84.23c0 5.35-3.57 8.89-7.697 8.89-2.38 0-4.303-1.097-6.303-3.658V109h41V61h8v3.712c2-3.132 4.686-4.578 7.238-4.578 4.536 0 7.762 3.48 7.762 9.81V84.23c0 5.35-3.572 8.89-7.7 8.89-2.378 0-4.3-1.097-6.3-3.658V109h9.252l2.712-2.917c1.212-1.52 2.643-3.18 4.337-5.13l.848-.982z\"/><path d=\"M22 82.433v-11.27c0-2.497-.756-3.83-2.495-3.83-1.744 0-2.505 1.333-2.505 3.83v11.27c0 2.5.76 3.662 2.505 3.662 1.74 0 2.495-1.162 2.495-3.662zm104.285-6.399c0-4.64-3.318-11.588-3.318-11.588-.52-1.21-2.276-3.446-3.406-5.446h.025c-.362 0-.612-.685-.612-.685-3.307-3.797-8.333-7.98-10.54-10.707-2.59-3.196-2.663-6.16-2.8-8.496-.376-6.302 2.174-10.088 4.902-13.81 4.126-5.618 5.613-6.66 8.785-10.332 2.03-2.348 3.7-4.24 5.073-5.97H93.63c-1.83 2.338-5.547 6.842-7.67 10.838-2.8 5.29-5.11 9.258-5.335 18.994l.098 3.14c0 4.64 3.326 11.58 3.326 11.58.518 1.212 2.273 3.448 3.395 5.448h-.026c.37 0 .613.685.613.685 3.315 3.797 8.332 7.98 10.547 10.707 2.59 3.2 2.656 6.164 2.792 8.493.38 6.3-2.175 10.088-4.903 13.81-4.122 5.624-5.61 6.662-8.783 10.34-2.026 2.344-3.69 4.237-5.065 5.965H114.4c1.867-2.4 4.515-6.817 6.65-10.837 2.802-5.288 5.113-9.26 5.336-18.99l-.1-3.14z\"/></g></svg>"

/***/ }),

/***/ "../src/components/phpstorm/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PhpstormPlain = __webpack_require__("../src/components/phpstorm/plain/PhpstormPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PhpstormPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/postgresql/original-wordmark/PostgresqlOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PostgresqlOriginalWordmark = __webpack_require__("../src/components/postgresql/original-wordmark/PostgresqlOriginalWordmark.svg");
	
	var _PostgresqlOriginalWordmark2 = _interopRequireDefault(_PostgresqlOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PostgresqlOriginalWordmark */
	function PostgresqlOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PostgresqlOriginalWordmark',
	    svg: _PostgresqlOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PostgresqlOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PostgresqlOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/postgresql/original-wordmark/PostgresqlOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M85.988 76.075c.632-5.262.443-6.034 4.362-5.182l.995.088c3.014.137 6.957-.485 9.272-1.561 4.986-2.313 7.942-6.177 3.026-5.162-11.215 2.313-11.986-1.483-11.986-1.483C103.5 45.204 108.451 22.9 104.178 17.44 92.524 2.548 72.35 9.59 72.012 9.773l-.108.021c-2.216-.461-4.695-.735-7.481-.78-5.075-.083-8.926 1.331-11.847 3.546 0 0-35.989-14.827-34.315 18.646.356 7.121 10.207 53.882 21.956 39.758 4.294-5.164 8.444-9.531 8.444-9.531 2.061 1.369 4.528 2.067 7.116 1.816l.2-.17c-.062.641-.035 1.268.081 2.01-3.027 3.383-2.137 3.977-8.189 5.222-6.122 1.262-2.525 3.508-.178 4.095 2.848.713 9.433 1.722 13.884-4.509l-.177.711c1.188.95 1.107 6.827 1.275 11.026.168 4.199.45 8.117 1.306 10.429.856 2.31 1.866 8.261 9.819 6.557 6.646-1.426 11.727-3.476 12.19-22.545\"/><path d=\"M71.208 102.77c-3.518 0-5.808-1.36-7.2-2.674-2.1-1.981-2.933-4.534-3.43-6.059l-.215-.637c-1.002-2.705-1.341-6.599-1.542-11.613a199.25 199.25 0 0 1-.075-2.352c-.017-.601-.038-1.355-.068-2.146a15.157 15.157 0 0 1-3.997 1.264c-2.48.424-5.146.286-7.926-.409-1.961-.49-3.999-1.506-5.16-3.076-3.385 2.965-6.614 2.562-8.373 1.976-3.103-1.035-5.88-3.942-8.491-8.89-1.859-3.523-3.658-8.115-5.347-13.646-2.94-9.633-4.808-19.779-4.974-23.109-.522-10.427 2.284-17.883 8.34-22.16 9.555-6.749 24.03-2.781 29.307-.979 3.545-2.137 7.716-3.178 12.43-3.102 2.532.041 4.942.264 7.181.662 2.335-.734 6.949-1.788 12.23-1.723 9.73.116 17.793 3.908 23.316 10.966 3.941 5.036 1.993 15.61.48 21.466-2.127 8.235-5.856 16.996-10.436 24.622 1.244.009 3.045-.141 5.607-.669 5.054-1.044 6.531 1.666 6.932 2.879 1.607 4.867-5.378 8.544-7.557 9.555-2.792 1.297-7.343 2.086-11.071 1.915l-.163-.011-.979-.086-.097.816-.093.799c-.25 9.664-1.631 15.784-4.472 19.829-2.977 4.239-7.116 5.428-10.761 6.209a16.146 16.146 0 0 1-3.396.383zm-7.402-35.174c2.271 1.817 2.47 5.236 2.647 11.626.022.797.043 1.552.071 2.257.086 2.134.287 7.132 1.069 9.244.111.298.21.602.314.922.872 2.672 1.31 4.011 5.081 3.203 3.167-.678 4.794-1.287 6.068-3.101 1.852-2.638 2.888-7.941 3.078-15.767l3.852.094-3.826-.459.112-.955c.367-3.148.631-5.424 2.736-6.928 1.688-1.207 3.613-1.09 5.146-.814-1.684-1.271-2.15-2.765-2.274-3.377l-.321-1.582.902-1.34c5.2-7.716 9.489-17.199 11.767-26.018 2.34-9.062 1.626-13.875.913-14.785-9.446-12.071-25.829-7.088-27.539-6.521l-.29.156-1.45.271-.743-.154c-2.047-.425-4.321-.66-6.76-.7-3.831-.064-6.921.841-9.455 2.764l-1.758 1.333-2.041-.841c-4.358-1.782-17.162-5.365-23.918-.58-3.75 2.656-5.458 7.861-5.078 15.47.125 2.512 1.833 12.021 4.647 21.245 3.891 12.746 7.427 16.979 8.903 17.472.257.087.926-.433 1.591-1.231 4.326-5.203 8.44-9.54 8.613-9.723l2.231-2.347 2.697 1.792c1.087.723 2.286 1.132 3.518 1.209l6.433-5.486-.932 9.51c-.021.214-.031.504.053 1.044l.28 1.803-1.213 1.358-.14.157 3.534 1.632 1.482-1.853z\"/><path fill=\"#336791\" d=\"M103.646 64.258c-11.216 2.313-11.987-1.484-11.987-1.484 11.842-17.571 16.792-39.876 12.52-45.335C92.524 2.547 72.35 9.59 72.013 9.773l-.109.019c-2.216-.459-4.695-.733-7.482-.778-5.075-.083-8.925 1.33-11.846 3.545 0 0-35.99-14.826-34.316 18.647.356 7.121 10.207 53.882 21.956 39.758 4.294-5.164 8.443-9.531 8.443-9.531 2.061 1.369 4.528 2.067 7.115 1.816l.201-.17c-.062.641-.034 1.268.08 2.01-3.026 3.383-2.138 3.977-8.188 5.222-6.123 1.262-2.526 3.508-.177 4.095 2.847.713 9.433 1.722 13.883-4.509l-.178.711c1.186.95 2.019 6.179 1.879 10.919s-.233 7.994.702 10.536c.935 2.541 1.866 8.261 9.82 6.557 6.646-1.425 10.09-5.116 10.57-11.272.34-4.377 1.109-3.73 1.158-7.644l.618-1.853c.711-5.934.113-7.848 4.208-6.957l.995.087c3.014.138 6.958-.485 9.273-1.561 4.986-2.314 7.943-6.177 3.028-5.162z\"/><path fill=\"#fff\" d=\"M71.61 100.394c-6.631.001-8.731-5.25-9.591-7.397-1.257-3.146-1.529-15.358-1.249-25.373a1.286 1.286 0 0 1 2.57.072c-.323 11.551.136 22.018 1.066 24.346 1.453 3.632 3.656 6.809 9.887 5.475 5.915-1.269 8.13-3.512 9.116-9.23.758-4.389 2.254-16.874 2.438-19.338a1.285 1.285 0 0 1 2.563.191c-.192 2.564-1.682 15.026-2.469 19.584-1.165 6.755-4.176 9.819-11.11 11.306a15.462 15.462 0 0 1-3.221.364zM35.659 74.749a5.343 5.343 0 0 1-1.704-.281c-4.307-1.437-8.409-8.451-12.193-20.849-2.88-9.438-4.705-19.288-4.865-22.489-.475-9.49 1.97-16.205 7.265-19.957 10.476-7.423 28.1-.354 28.845-.05a1.285 1.285 0 0 1-.972 2.379v.001c-.17-.07-17.07-6.84-26.392-.229-4.528 3.211-6.607 9.175-6.18 17.729.135 2.696 1.84 12.311 4.757 21.867 3.378 11.067 7.223 18.052 10.548 19.16.521.175 2.109.704 4.381-2.026 4.272-5.14 8.197-9.242 8.236-9.283a1.286 1.286 0 0 1 1.856 1.778c-.039.04-3.904 4.081-8.116 9.148-1.995 2.398-3.908 3.102-5.466 3.102zm55.92-10.829a1.284 1.284 0 0 1-1.065-2.004c11.971-17.764 16.173-39.227 12.574-43.825-4.53-5.788-10.927-8.812-19.012-8.985-5.987-.13-10.746 1.399-11.523 1.666l-.195.079c-.782.246-1.382-.183-1.608-.684a1.29 1.29 0 0 1 .508-1.631l.346-.142-.017.005.018-.006c1.321-.483 6.152-1.933 12.137-1.864 8.947.094 16.337 3.545 21.371 9.977 2.382 3.044 2.387 10.057.015 19.24-2.418 9.362-6.968 19.425-12.482 27.607a1.282 1.282 0 0 1-1.067.567zm.611 8.223c-2.044 0-3.876-.287-4.973-.945-1.128-.675-1.343-1.594-1.371-2.081-.308-5.404 2.674-6.345 4.195-6.774-.212-.32-.514-.697-.825-1.086-.887-1.108-2.101-2.626-3.037-4.896-.146-.354-.606-1.179-1.138-2.133-2.883-5.169-8.881-15.926-5.028-21.435 1.784-2.549 5.334-3.552 10.566-2.992-1.539-4.689-8.869-19.358-26.259-19.643-5.231-.088-9.521 1.521-12.744 4.775-7.217 7.289-6.955 20.477-6.952 20.608a1.284 1.284 0 1 1-2.569.067c-.016-.585-.286-14.424 7.695-22.484 3.735-3.772 8.651-5.634 14.612-5.537C75.49 7.77 82.651 13.426 86.7 18.14c4.412 5.136 6.576 10.802 6.754 12.692.133 1.406-.876 1.688-1.08 1.729l-.463.011c-5.135-.822-8.429-.252-9.791 1.695-2.931 4.188 2.743 14.363 5.166 18.709.619 1.108 1.065 1.909 1.269 2.404.796 1.93 1.834 3.227 2.668 4.269.733.917 1.369 1.711 1.597 2.645.105.185 1.603 2.399 10.488.565 2.227-.459 3.562-.066 3.97 1.168.803 2.429-3.702 5.261-6.196 6.42-2.238 1.039-5.805 1.696-8.892 1.696zm-3.781-3.238c.281.285 1.691.775 4.612.65 2.596-.112 5.335-.677 6.979-1.439 2.102-.976 3.504-2.067 4.231-2.812l-.404.074c-5.681 1.173-9.699 1.017-11.942-.465a4.821 4.821 0 0 1-.435-.323c-.243.096-.468.159-.628.204-1.273.357-2.589.726-2.413 4.111zm-36.697 7.179c-1.411 0-2.896-.191-4.413-.572-1.571-.393-4.221-1.576-4.18-3.519.045-2.181 3.216-2.835 4.411-3.081 4.312-.888 4.593-1.244 5.941-2.955.393-.499.882-1.12 1.548-1.865.99-1.107 2.072-1.669 3.216-1.669.796 0 1.45.271 1.881.449 1.376.57 2.524 1.948 2.996 3.598.426 1.488.223 2.92-.572 4.032-2.608 3.653-6.352 5.582-10.828 5.582zm-5.817-3.98c.388.299 1.164.699 2.027.916 1.314.328 2.588.495 3.79.495 3.662 0 6.601-1.517 8.737-4.506.445-.624.312-1.415.193-1.832-.25-.872-.87-1.665-1.509-1.931-.347-.144-.634-.254-.898-.254-.142 0-.573 0-1.3.813-.614.686-1.055 1.246-1.446 1.741-1.678 2.131-2.447 2.854-7.441 3.883-1.218.252-1.843.506-2.153.675zm9.882-5.928a1.286 1.286 0 0 1-1.269-1.09 6.026 6.026 0 0 1-.064-.644c-3.274-.062-6.432-1.466-8.829-3.968-3.031-3.163-4.411-7.545-3.785-12.022.68-4.862.426-9.154.289-11.46a25.514 25.514 0 0 1-.063-1.425c.002-.406.01-1.485 3.615-3.312 1.282-.65 3.853-1.784 6.661-2.075 4.654-.48 7.721 1.592 8.639 5.836 2.478 11.46.196 16.529-1.47 20.23-.311.688-.604 1.34-.838 1.97l-.207.557c-.88 2.36-1.641 4.399-1.407 5.923a1.287 1.287 0 0 1-1.075 1.466l-.197.014zM44.634 35.922l.051.918c.142 2.395.406 6.853-.31 11.969-.516 3.692.612 7.297 3.095 9.888 1.962 2.048 4.546 3.178 7.201 3.178h.055c.298-1.253.791-2.575 1.322-4l.206-.553c.265-.712.575-1.401.903-2.13 1.604-3.564 3.6-8 1.301-18.633-.456-2.105-1.56-3.324-3.375-3.726-3.728-.824-9.283 1.98-10.449 3.089zm7.756-.545c-.064.454.833 1.667 2.001 1.829 1.167.163 2.166-.785 2.229-1.239.063-.455-.833-.955-2.002-1.118-1.167-.163-2.166.073-2.228.528zm2.27 2.277l-.328-.023c-.725-.101-1.458-.558-1.959-1.223-.176-.233-.464-.687-.407-1.091.082-.593.804-.947 1.933-.947.253 0 .515.019.78.055.616.086 1.189.264 1.612.5.733.41.787.866.754 1.103-.091.653-1.133 1.626-2.385 1.626zm-1.844-2.201c.037.28.73 1.205 1.634 1.33l.209.015c.834 0 1.458-.657 1.531-.872-.077-.146-.613-.511-1.631-.651a4.72 4.72 0 0 0-.661-.048c-.652-.001-1.001.146-1.082.226zm35.121-1.003c.063.455-.832 1.668-2.001 1.83-1.168.162-2.167-.785-2.231-1.24-.062-.454.834-.955 2.002-1.117 1.168-.164 2.166.074 2.23.527zm-2.27 2.062c-1.125 0-2.094-.875-2.174-1.442-.092-.681 1.029-1.199 2.185-1.359.254-.036.506-.054.749-.054.997 0 1.657.293 1.723.764.043.306-.191.777-.595 1.201-.266.28-.826.765-1.588.87l-.3.02zm.759-2.427c-.223 0-.455.017-.69.049-1.162.161-1.853.628-1.82.878.039.274.78 1.072 1.75 1.072l.239-.017c.634-.089 1.11-.502 1.337-.741.356-.375.498-.727.481-.848-.021-.157-.449-.393-1.297-.393zm3.194 26.453a1.285 1.285 0 0 1-1.067-2c2.736-4.087 2.235-8.256 1.751-12.286-.207-1.718-.42-3.493-.364-5.198.056-1.753.278-3.199.494-4.599.255-1.657.496-3.224.396-5.082a1.286 1.286 0 0 1 2.567-.138c.114 2.124-.159 3.896-.423 5.611-.204 1.323-.415 2.691-.466 4.29-.049 1.509.144 3.112.348 4.808.516 4.287 1.099 9.146-2.167 14.023-.248.37-.655.571-1.069.571z\"/><path d=\"M2.835 103.184a26.23 26.23 0 0 1 4.343-.338c2.235 0 3.874.52 4.914 1.456.962.832 1.534 2.106 1.534 3.667 0 1.586-.469 2.834-1.353 3.744-1.196 1.274-3.146 1.924-5.356 1.924-.676 0-1.3-.026-1.819-.156v7.021H2.835v-17.318zm2.263 8.45c.494.13 1.118.182 1.872.182 2.729 0 4.394-1.326 4.394-3.744 0-2.314-1.638-3.432-4.134-3.432-.988 0-1.742.078-2.132.182v6.812zm22.23 2.47c0 4.654-3.225 6.683-6.267 6.683-3.406 0-6.032-2.496-6.032-6.475 0-4.212 2.756-6.682 6.24-6.682 3.615-.001 6.059 2.626 6.059 6.474zm-9.984.13c0 2.756 1.586 4.836 3.822 4.836 2.184 0 3.821-2.054 3.821-4.888 0-2.132-1.065-4.836-3.77-4.836s-3.873 2.496-3.873 4.888zm12.557 3.926c.676.442 1.872.91 3.016.91 1.664 0 2.444-.832 2.444-1.872 0-1.092-.649-1.69-2.34-2.314-2.262-.806-3.328-2.054-3.328-3.562 0-2.028 1.638-3.692 4.342-3.692 1.274 0 2.393.364 3.095.78l-.572 1.664a4.897 4.897 0 0 0-2.574-.728c-1.352 0-2.106.78-2.106 1.716 0 1.04.755 1.508 2.393 2.132 2.184.832 3.302 1.924 3.302 3.796 0 2.21-1.716 3.77-4.706 3.77-1.378 0-2.652-.338-3.536-.858l.57-1.742zm13.365-13.859v3.614h3.275v1.742h-3.275v6.786c0 1.56.441 2.444 1.716 2.444a5.09 5.09 0 0 0 1.326-.156l.104 1.716c-.441.182-1.144.312-2.027.312-1.066 0-1.925-.338-2.471-.962-.649-.676-.884-1.794-.884-3.276v-6.864h-1.95v-1.742h1.95v-3.016l2.236-.598zm16.536 3.615c-.053.91-.104 1.924-.104 3.458v7.306c0 2.886-.572 4.654-1.794 5.747-1.222 1.144-2.99 1.508-4.576 1.508-1.508 0-3.172-.364-4.187-1.04l.572-1.742c.832.52 2.132.988 3.692.988 2.34 0 4.056-1.222 4.056-4.394v-1.404h-.052c-.702 1.17-2.054 2.106-4.004 2.106-3.12 0-5.356-2.652-5.356-6.137 0-4.264 2.782-6.682 5.668-6.682 2.185 0 3.381 1.144 3.927 2.184h.052l.104-1.898h2.002zm-2.366 4.966c0-.39-.026-.728-.13-1.04-.416-1.326-1.534-2.418-3.198-2.418-2.185 0-3.744 1.846-3.744 4.758 0 2.47 1.248 4.524 3.718 4.524 1.404 0 2.678-.884 3.172-2.34.13-.39.183-.832.183-1.222v-2.262zm5.901-1.04c0-1.482-.026-2.756-.104-3.926h2.003l.077 2.47h.104c.572-1.69 1.95-2.756 3.484-2.756.26 0 .441.026.649.078v2.158a3.428 3.428 0 0 0-.779-.078c-1.612 0-2.757 1.222-3.068 2.938a6.44 6.44 0 0 0-.104 1.066v6.708h-2.262v-8.658zm9.517 2.782c.052 3.094 2.027 4.368 4.315 4.368 1.639 0 2.626-.286 3.484-.65l.39 1.638c-.806.364-2.184.78-4.186.78-3.874 0-6.188-2.548-6.188-6.344 0-3.796 2.236-6.787 5.902-6.787 4.108 0 5.2 3.614 5.2 5.928 0 .468-.052.832-.078 1.066h-8.839zm6.708-1.638c.025-1.456-.599-3.718-3.172-3.718-2.314 0-3.328 2.132-3.511 3.718h6.683z\"/><path fill=\"#336791\" d=\"M84.371 117.744a8.016 8.016 0 0 0 4.056 1.144c2.314 0 3.666-1.222 3.666-2.99 0-1.638-.936-2.574-3.302-3.484-2.86-1.014-4.628-2.496-4.628-4.966 0-2.73 2.262-4.758 5.668-4.758 1.794 0 3.094.416 3.874.858l-.624 1.846a6.98 6.98 0 0 0-3.328-.832c-2.392 0-3.302 1.43-3.302 2.626 0 1.638 1.065 2.444 3.484 3.38 2.964 1.145 4.472 2.574 4.472 5.148 0 2.704-2.002 5.044-6.136 5.044-1.69 0-3.536-.494-4.473-1.118l.573-1.898zm27.586 5.33a94.846 94.846 0 0 1-6.708-2.028c-.364-.13-.728-.26-1.066-.26-4.16-.156-7.722-3.224-7.722-8.866 0-5.616 3.432-9.23 8.164-9.23 4.758 0 7.853 3.692 7.853 8.866 0 4.498-2.08 7.384-4.992 8.398v.104c1.742.442 3.64.858 5.122 1.118l-.651 1.898zm-1.872-11.414c0-3.51-1.819-7.125-5.538-7.125-3.822 0-5.694 3.536-5.668 7.333-.026 3.718 2.028 7.072 5.564 7.072 3.615 0 5.642-3.276 5.642-7.28zm5.329-8.684h2.263v15.626h7.488v1.898h-9.751v-17.524z\"/></svg>"

/***/ }),

/***/ "../src/components/postgresql/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PostgresqlOriginalWordmark = __webpack_require__("../src/components/postgresql/original-wordmark/PostgresqlOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PostgresqlOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/postgresql/original/PostgresqlOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PostgresqlOriginal = __webpack_require__("../src/components/postgresql/original/PostgresqlOriginal.svg");
	
	var _PostgresqlOriginal2 = _interopRequireDefault(_PostgresqlOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PostgresqlOriginal */
	function PostgresqlOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PostgresqlOriginal',
	    svg: _PostgresqlOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PostgresqlOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PostgresqlOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/postgresql/original/PostgresqlOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M93.809 92.112c.785-6.533.55-7.492 5.416-6.433l1.235.108c3.742.17 8.637-.602 11.513-1.938 6.191-2.873 9.861-7.668 3.758-6.409-13.924 2.873-14.881-1.842-14.881-1.842 14.703-21.815 20.849-49.508 15.543-56.287-14.47-18.489-39.517-9.746-39.936-9.52l-.134.025c-2.751-.571-5.83-.912-9.289-.968-6.301-.104-11.082 1.652-14.709 4.402 0 0-44.683-18.409-42.604 23.151.442 8.841 12.672 66.898 27.26 49.362 5.332-6.412 10.484-11.834 10.484-11.834 2.558 1.699 5.622 2.567 8.834 2.255l.249-.212c-.078.796-.044 1.575.099 2.497-3.757 4.199-2.653 4.936-10.166 6.482-7.602 1.566-3.136 4.355-.221 5.084 3.535.884 11.712 2.136 17.238-5.598l-.22.882c1.474 1.18 1.375 8.477 1.583 13.69.209 5.214.558 10.079 1.621 12.948 1.063 2.868 2.317 10.256 12.191 8.14 8.252-1.764 14.561-4.309 15.136-27.985\"/><path d=\"M75.458 125.256c-4.367 0-7.211-1.689-8.938-3.32-2.607-2.46-3.641-5.629-4.259-7.522l-.267-.79c-1.244-3.358-1.666-8.193-1.916-14.419-.038-.935-.064-1.898-.093-2.919-.021-.747-.047-1.684-.085-2.664a18.8 18.8 0 0 1-4.962 1.568c-3.079.526-6.389.356-9.84-.507-2.435-.609-4.965-1.871-6.407-3.82-4.203 3.681-8.212 3.182-10.396 2.453-3.853-1.285-7.301-4.896-10.542-11.037-2.309-4.375-4.542-10.075-6.638-16.943-3.65-11.96-5.969-24.557-6.175-28.693C4.292 23.698 7.777 14.44 15.296 9.129 27.157.751 45.128 5.678 51.68 7.915c4.402-2.653 9.581-3.944 15.433-3.851 3.143.051 6.136.327 8.916.823 2.9-.912 8.628-2.221 15.185-2.139 12.081.144 22.092 4.852 28.949 13.615 4.894 6.252 2.474 19.381.597 26.651-2.642 10.226-7.271 21.102-12.957 30.57 1.544.011 3.781-.174 6.961-.831 6.274-1.295 8.109 2.069 8.607 3.575 1.995 6.042-6.677 10.608-9.382 11.864-3.466 1.609-9.117 2.589-13.745 2.377l-.202-.013-1.216-.107-.12 1.014-.116.991c-.311 11.999-2.025 19.598-5.552 24.619-3.697 5.264-8.835 6.739-13.361 7.709-1.544.33-2.947.474-4.219.474zm-9.19-43.671c2.819 2.256 3.066 6.501 3.287 14.434.028.99.054 1.927.089 2.802.106 2.65.355 8.855 1.327 11.477.137.371.26.747.39 1.146 1.083 3.316 1.626 4.979 6.309 3.978 3.931-.843 5.952-1.599 7.534-3.851 2.299-3.274 3.585-9.86 3.821-19.575l4.783.116-4.75-.57.14-1.186c.455-3.91.783-6.734 3.396-8.602 2.097-1.498 4.486-1.353 6.389-1.01-2.091-1.58-2.669-3.433-2.823-4.193l-.399-1.965 1.121-1.663c6.457-9.58 11.781-21.354 14.609-32.304 2.906-11.251 2.02-17.226 1.134-18.356-11.729-14.987-32.068-8.799-34.192-8.097l-.359.194-1.8.335-.922-.191c-2.542-.528-5.366-.82-8.393-.869-4.756-.08-8.593 1.044-11.739 3.431l-2.183 1.655-2.533-1.043c-5.412-2.213-21.308-6.662-29.696-.721-4.656 3.298-6.777 9.76-6.305 19.207.156 3.119 2.275 14.926 5.771 26.377 4.831 15.825 9.221 21.082 11.054 21.693.32.108 1.15-.537 1.976-1.529a270.708 270.708 0 0 1 10.694-12.07l2.77-2.915 3.349 2.225c1.35.897 2.839 1.406 4.368 1.502l7.987-6.812-1.157 11.808c-.026.265-.039.626.065 1.296l.348 2.238-1.51 1.688-.174.196 4.388 2.025 1.836-2.301z\"/><path fill=\"#336791\" d=\"M115.731 77.44c-13.925 2.873-14.882-1.842-14.882-1.842 14.703-21.816 20.849-49.51 15.545-56.287C101.924.823 76.875 9.566 76.457 9.793l-.135.024c-2.751-.571-5.83-.911-9.291-.967-6.301-.103-11.08 1.652-14.707 4.402 0 0-44.684-18.408-42.606 23.151.442 8.842 12.672 66.899 27.26 49.363 5.332-6.412 10.483-11.834 10.483-11.834 2.559 1.699 5.622 2.567 8.833 2.255l.25-.212c-.078.796-.042 1.575.1 2.497-3.758 4.199-2.654 4.936-10.167 6.482-7.602 1.566-3.136 4.355-.22 5.084 3.534.884 11.712 2.136 17.237-5.598l-.221.882c1.473 1.18 2.507 7.672 2.334 13.557-.174 5.885-.29 9.926.871 13.082 1.16 3.156 2.316 10.256 12.192 8.14 8.252-1.768 12.528-6.351 13.124-13.995.422-5.435 1.377-4.631 1.438-9.49l.767-2.3c.884-7.367.14-9.743 5.225-8.638l1.235.108c3.742.17 8.639-.602 11.514-1.938 6.19-2.871 9.861-7.667 3.758-6.408z\"/><path fill=\"#fff\" d=\"M75.957 122.307c-8.232 0-10.84-6.519-11.907-9.185-1.562-3.907-1.899-19.069-1.551-31.503a1.59 1.59 0 0 1 1.64-1.55 1.594 1.594 0 0 1 1.55 1.639c-.401 14.341.168 27.337 1.324 30.229 1.804 4.509 4.54 8.453 12.275 6.796 7.343-1.575 10.093-4.359 11.318-11.46.94-5.449 2.799-20.951 3.028-24.01a1.593 1.593 0 0 1 1.71-1.472 1.597 1.597 0 0 1 1.472 1.71c-.239 3.185-2.089 18.657-3.065 24.315-1.446 8.387-5.185 12.191-13.794 14.037-1.463.313-2.792.453-4 .454zM31.321 90.466a6.71 6.71 0 0 1-2.116-.35c-5.347-1.784-10.44-10.492-15.138-25.885-3.576-11.717-5.842-23.947-6.041-27.922-.589-11.784 2.445-20.121 9.02-24.778 13.007-9.216 34.888-.44 35.813-.062a1.596 1.596 0 0 1-1.207 2.955c-.211-.086-21.193-8.492-32.768-.285-5.622 3.986-8.203 11.392-7.672 22.011.167 3.349 2.284 15.285 5.906 27.149 4.194 13.742 8.967 22.413 13.096 23.79.648.216 2.62.873 5.439-2.517A245.272 245.272 0 0 1 45.88 73.046a1.596 1.596 0 0 1 2.304 2.208c-.048.05-4.847 5.067-10.077 11.359-2.477 2.979-4.851 3.853-6.786 3.853zm69.429-13.445a1.596 1.596 0 0 1-1.322-2.487c14.863-22.055 20.08-48.704 15.612-54.414-5.624-7.186-13.565-10.939-23.604-11.156-7.433-.16-13.341 1.738-14.307 2.069l-.243.099c-.971.305-1.716-.227-1.997-.849a1.6 1.6 0 0 1 .631-2.025c.046-.027.192-.089.429-.176l-.021.006.021-.007c1.641-.601 7.639-2.4 15.068-2.315 11.108.118 20.284 4.401 26.534 12.388 2.957 3.779 2.964 12.485.019 23.887-3.002 11.625-8.651 24.118-15.497 34.277-.306.457-.81.703-1.323.703zm.76 10.21c-2.538 0-4.813-.358-6.175-1.174-1.4-.839-1.667-1.979-1.702-2.584-.382-6.71 3.32-7.878 5.208-8.411-.263-.398-.637-.866-1.024-1.349-1.101-1.376-2.609-3.26-3.771-6.078-.182-.44-.752-1.463-1.412-2.648-3.579-6.418-11.026-19.773-6.242-26.612 2.214-3.165 6.623-4.411 13.119-3.716C97.6 28.837 88.5 10.625 66.907 10.271c-6.494-.108-11.82 1.889-15.822 5.93-8.96 9.049-8.636 25.422-8.631 25.586a1.595 1.595 0 1 1-3.19.084c-.02-.727-.354-17.909 9.554-27.916C53.455 9.272 59.559 6.96 66.96 7.081c13.814.227 22.706 7.25 27.732 13.101 5.479 6.377 8.165 13.411 8.386 15.759.165 1.746-1.088 2.095-1.341 2.147l-.576.013c-6.375-1.021-10.465-.312-12.156 2.104-3.639 5.201 3.406 17.834 6.414 23.229.768 1.376 1.322 2.371 1.576 2.985.988 2.396 2.277 4.006 3.312 5.3.911 1.138 1.7 2.125 1.982 3.283.131.23 1.99 2.98 13.021.703 2.765-.57 4.423-.083 4.93 1.45.997 3.015-4.597 6.532-7.694 7.97-2.775 1.29-7.204 2.106-11.036 2.106zm-4.696-4.021c.35.353 2.101.962 5.727.806 3.224-.138 6.624-.839 8.664-1.786 2.609-1.212 4.351-2.567 5.253-3.492l-.5.092c-7.053 1.456-12.042 1.262-14.828-.577a6.162 6.162 0 0 1-.54-.401c-.302.119-.581.197-.78.253-1.58.443-3.214.902-2.996 5.105zm-45.562 8.915c-1.752 0-3.596-.239-5.479-.71-1.951-.488-5.24-1.957-5.19-4.37.057-2.707 3.994-3.519 5.476-3.824 5.354-1.103 5.703-1.545 7.376-3.67.488-.619 1.095-1.39 1.923-2.314 1.229-1.376 2.572-2.073 3.992-2.073.989 0 1.8.335 2.336.558 1.708.708 3.133 2.42 3.719 4.467.529 1.847.276 3.625-.71 5.006-3.237 4.533-7.886 6.93-13.443 6.93zm-7.222-4.943c.481.372 1.445.869 2.518 1.137 1.631.408 3.213.615 4.705.615 4.546 0 8.196-1.882 10.847-5.594.553-.774.387-1.757.239-2.274-.31-1.083-1.08-2.068-1.873-2.397-.43-.178-.787-.314-1.115-.314-.176 0-.712 0-1.614 1.009a41.146 41.146 0 0 0-1.794 2.162c-2.084 2.646-3.039 3.544-9.239 4.821-1.513.31-2.289.626-2.674.835zm12.269-7.36a1.596 1.596 0 0 1-1.575-1.354 8.218 8.218 0 0 1-.08-.799c-4.064-.076-7.985-1.82-10.962-4.926-3.764-3.927-5.477-9.368-4.699-14.927.845-6.037.529-11.366.359-14.229-.047-.796-.081-1.371-.079-1.769.003-.505.013-1.844 4.489-4.113 1.592-.807 4.784-2.215 8.271-2.576 5.777-.597 9.585 1.976 10.725 7.246 3.077 14.228.244 20.521-1.825 25.117-.385.856-.749 1.664-1.04 2.447l-.257.69c-1.093 2.931-2.038 5.463-1.748 7.354a1.595 1.595 0 0 1-1.335 1.819l-.244.02zM42.464 42.26l.062 1.139c.176 2.974.504 8.508-.384 14.86-.641 4.585.759 9.06 3.843 12.276 2.437 2.542 5.644 3.945 8.94 3.945h.068c.369-1.555.982-3.197 1.642-4.966l.255-.686c.329-.884.714-1.74 1.122-2.646 1.991-4.424 4.47-9.931 1.615-23.132-.565-2.615-1.936-4.128-4.189-4.627-4.628-1.022-11.525 2.459-12.974 3.837zm9.63-.677c-.08.564 1.033 2.07 2.485 2.271 1.449.203 2.689-.975 2.768-1.539.079-.564-1.033-1.186-2.485-1.388-1.451-.202-2.691.092-2.768.656zm2.818 2.826l-.407-.028c-.9-.125-1.81-.692-2.433-1.518-.219-.29-.576-.852-.505-1.354.101-.736.999-1.177 2.4-1.177.313 0 .639.023.967.069.766.106 1.477.327 2.002.62.91.508.977 1.075.936 1.368-.112.813-1.405 2.02-2.96 2.02zm-2.289-2.732c.045.348.907 1.496 2.029 1.651l.261.018c1.036 0 1.81-.815 1.901-1.082-.096-.182-.762-.634-2.025-.81a5.823 5.823 0 0 0-.821-.059c-.812 0-1.243.183-1.345.282zm43.605-1.245c.079.564-1.033 2.07-2.484 2.272-1.45.202-2.691-.975-2.771-1.539-.076-.564 1.036-1.187 2.486-1.388 1.45-.203 2.689.092 2.769.655zm-2.819 2.56c-1.396 0-2.601-1.086-2.7-1.791-.115-.846 1.278-1.489 2.712-1.688.316-.044.629-.066.93-.066 1.238 0 2.058.363 2.14.949.053.379-.238.964-.739 1.492-.331.347-1.026.948-1.973 1.079l-.37.025zm.943-3.013c-.276 0-.564.021-.856.061-1.441.201-2.301.779-2.259 1.089.048.341.968 1.332 2.173 1.332l.297-.021c.787-.109 1.378-.623 1.66-.919.443-.465.619-.903.598-1.052-.028-.198-.56-.49-1.613-.49zm3.965 32.843a1.594 1.594 0 0 1-1.324-2.483c3.398-5.075 2.776-10.25 2.175-15.255-.257-2.132-.521-4.337-.453-6.453.07-2.177.347-3.973.614-5.71.317-2.058.617-4.002.493-6.31a1.595 1.595 0 1 1 3.186-.172c.142 2.638-.197 4.838-.525 6.967-.253 1.643-.515 3.342-.578 5.327-.061 1.874.178 3.864.431 5.97.64 5.322 1.365 11.354-2.691 17.411a1.596 1.596 0 0 1-1.328.708z\"/></svg>"

/***/ }),

/***/ "../src/components/postgresql/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PostgresqlOriginal = __webpack_require__("../src/components/postgresql/original/PostgresqlOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PostgresqlOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/postgresql/plain-wordmark/PostgresqlPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PostgresqlPlainWordmark = __webpack_require__("../src/components/postgresql/plain-wordmark/PostgresqlPlainWordmark.svg");
	
	var _PostgresqlPlainWordmark2 = _interopRequireDefault(_PostgresqlPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PostgresqlPlainWordmark */
	function PostgresqlPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PostgresqlPlainWordmark',
	    svg: _PostgresqlPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PostgresqlPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PostgresqlPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/postgresql/plain-wordmark/PostgresqlPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#336791\" d=\"M63.409 100.219c1.792 1.482 3.893 2.114 6.161 2.231.938.049 1.903.003 2.826-.165 1.464-.266 2.924-.6 4.348-1.029 2.9-.875 5.406-2.387 7.277-4.829 1.066-1.392 1.941-2.897 2.503-4.561.464-1.373.9-2.76 1.247-4.165.274-1.107.41-2.25.576-3.381.111-.748.178-1.504.247-2.259.112-1.225.229-2.448.31-3.676.057-.854.055-1.712.088-2.567.011-.261.053-.52.078-.779.021-.241.143-.324.389-.32.864.013 1.73.035 2.593-.004.967-.043 1.941-.085 2.893-.244a46.368 46.368 0 0 0 4.028-.86c1.568-.411 3.007-1.146 4.393-1.982 1.612-.975 3.084-2.118 4.275-3.591 1.039-1.282 1.531-2.768 1.28-4.389-.364-2.355-2.343-3.898-4.644-4.003-.834-.038-1.68.05-2.51.155-1.005.128-1.995.354-2.997.503-.692.104-1.393.15-2.083.222l-.019-.09c1.29-2.437 2.634-4.846 3.854-7.316.937-1.896 1.737-3.859 2.564-5.809 1.37-3.228 2.463-6.555 3.369-9.938.867-3.238 1.609-6.511 1.844-9.871.094-1.341.159-2.688.15-4.031-.006-1.072-.122-2.145-.229-3.213-.122-1.224-.492-2.384-1.004-3.5-.674-1.472-1.721-2.679-2.822-3.825-.881-.918-1.851-1.754-2.812-2.59-1.371-1.192-2.913-2.145-4.513-2.99a26.013 26.013 0 0 0-5.724-2.22 71.525 71.525 0 0 0-3.658-.821C87.251 4.224 86.811 4 86.372 4h-8.268c-.299 0-.595.196-.896.229a31.429 31.429 0 0 0-5.835 1.205c-.71.219-1.358.091-2.033.028-.518-.048-1.027-.181-1.545-.207-1.971-.098-3.944-.24-5.916-.219-1.888.02-3.757.332-5.584.85-1.529.436-3.026.965-4.398 1.77-.586.344-1.052.279-1.659.105a104.514 104.514 0 0 0-6.166-1.604c-1.291-.289-2.62-.435-3.939-.571a46.155 46.155 0 0 0-3.809-.237c-1.242-.027-2.492-.026-3.729.084-1.969.175-3.9.575-5.778 1.221a19.252 19.252 0 0 0-5.72 3.121c-1.75 1.385-3.154 3.074-4.281 5.005-1.189 2.037-2.006 4.218-2.512 6.507-.275 1.241-.174 2.517-.363 3.777-.058.39.059.782.059 1.174v5.485c0 .364-.107.729-.061 1.095.113.879.074 1.765.223 2.638.234 1.382.445 2.759.729 4.131.397 1.917.776 3.832 1.216 5.74.32 1.389.667 2.77 1.048 4.143.58 2.098 1.146 4.199 1.803 6.272.611 1.927 1.307 3.826 2.002 5.726a50.846 50.846 0 0 0 3.49 7.607c1.195 2.111 2.558 4.088 4.388 5.713 1.207 1.072 2.548 1.895 4.109 2.307a8.13 8.13 0 0 0 3.733.104 8.864 8.864 0 0 0 3.895-1.865c.132-.107.275-.19.432.008.594.752 1.388 1.254 2.219 1.687 2.242 1.17 4.685 1.521 7.166 1.663.602.034 1.208-.052 1.813-.068 1.181-.033 2.327-.263 3.454-.589.592-.171 1.169-.389 1.771-.591.031.641.071 1.257.091 1.874l.083 3.363c.016.512.036 1.024.083 1.534.122 1.314.241 2.628.398 3.938.108.903.222 1.812.434 2.694a30.922 30.922 0 0 0 1.742 5.188 11.127 11.127 0 0 0 3.148 4.184zm-3.591-16.768a208.11 208.11 0 0 1-.159-4.739c-.042-1.942-.056-3.885-.083-5.827l-.005-.074c-.987.593-1.96 1.241-2.989 1.776-1.207.627-2.517.99-3.874 1.093-1.063.08-2.142.153-3.2.069-1.736-.141-3.472-.412-5.026-1.268-.63-.347-1.288-.77-1.723-1.323-1.041-1.329-.542-3.008 1.028-3.816 1.085-.56 2.269-.793 3.445-1.065a35.84 35.84 0 0 0 3.036-.83c.986-.323 1.608-1.123 2.223-1.908l.974-1.252-1.171-.122c-1.162-.108-2.271-.429-3.331-.899-.906-.401-.92-.445-1.586.277-1.11 1.205-2.19 2.44-3.279 3.666-.801.902-1.596 1.809-2.395 2.714-.788.895-1.528 1.84-2.379 2.672-1.262 1.236-2.784 1.979-4.6 1.895-1.165-.054-2.231-.462-3.191-1.129-1.979-1.378-3.312-3.308-4.527-5.333-1.555-2.596-2.75-5.361-3.771-8.201-.707-1.964-1.418-3.929-2.034-5.921-.671-2.165-1.26-4.355-1.839-6.547-.438-1.653-.826-3.32-1.196-4.99a173.85 173.85 0 0 1-1.182-5.715c-.241-1.291-.38-2.601-.575-3.9-.263-1.753-.311-3.52-.215-5.279.085-1.585.312-3.165.538-4.739.313-2.178 1.031-4.233 2.063-6.174a16.315 16.315 0 0 1 2.323-3.274c1.49-1.649 3.293-2.84 5.299-3.735 1.401-.625 2.882-1 4.391-1.295 2.24-.436 4.5-.418 6.76-.372.988.021 1.973.2 2.96.299 2.126.211 4.209.659 6.266 1.21 1.5.402 2.969.924 4.455 1.376.148.045.367.041.49-.038 2.015-1.316 4.216-2.184 6.559-2.681.889-.188 1.807-.271 2.716-.329 1.104-.069 2.219-.135 3.321-.07 1.325.076 2.646.271 3.963.451.64.088 1.264.309 1.904.369.308.029.633-.194.957-.27 1.654-.383 3.301-.808 4.97-1.109 1.242-.224 2.512-.33 3.774-.402 1.41-.081 2.828-.14 4.236-.072 1.78.086 3.547.339 5.291.745 2.162.503 4.234 1.233 6.205 2.247 1.473.759 2.872 1.637 4.133 2.717.826.709 1.672 1.408 2.417 2.198.92.974 1.858 1.947 2.436 3.194.435.941.745 1.915.831 2.944.106 1.281.235 2.566.224 3.849-.011 1.226-.179 2.451-.297 3.675-.271 2.788-.876 5.516-1.613 8.208a93.794 93.794 0 0 1-2.089 6.596c-.709 2.003-1.528 3.969-2.355 5.928a65.327 65.327 0 0 1-1.984 4.281c-1.354 2.652-2.762 5.277-4.391 7.777-.281.431-.548.873-.822 1.314.711.479 1.516.648 2.326.736.771.083 1.557.134 2.327.076 1.233-.092 2.462-.268 3.688-.439 1.214-.17 2.403-.515 3.651-.424 1.244.091 2.136 1.037 2.051 2.203-.054.738-.393 1.371-.883 1.912-2.315 2.554-5.221 4.102-8.545 4.865-1.263.29-2.565.439-3.858.56a25.74 25.74 0 0 1-3.321.078c-.812-.03-1.617-.216-2.447-.336-.084.759-.163 1.55-.259 2.338l-.387 3.023c-.117.958-.208 1.92-.329 2.878-.118.93-.265 1.855-.389 2.784-.115.865-.2 1.735-.33 2.599-.197 1.324-.386 2.651-.645 3.965-.31 1.57-.784 3.09-1.561 4.507-.946 1.729-2.287 3.046-3.995 4.021-1.76 1.005-3.685 1.528-5.634 1.966-1.382.311-2.803.361-4.202.234-2.425-.219-4.495-1.256-6.06-3.137-1.493-1.795-2.504-3.851-2.865-6.18a49.257 49.257 0 0 1-.396-3.339 86.327 86.327 0 0 1-.244-3.732zm2.726-15.954c.015.83-.071 1.66-.067 2.49.017 3.863.045 7.727.078 11.591.006.631.037 1.264.082 1.894.095 1.32.189 2.641.317 3.957.092.935.217 1.867.364 2.795.21 1.313.808 2.483 1.486 3.602.584.962 1.345 1.778 2.346 2.342 1.702.957 3.533 1.037 5.379.685 1.247-.237 2.473-.62 3.683-1.015a8.166 8.166 0 0 0 3.178-1.901c.849-.822 1.451-1.825 1.857-2.932.787-2.146 1.034-4.407 1.359-6.649.122-.84.228-1.682.339-2.523.127-.957.255-1.913.377-2.87.092-.714.174-1.427.261-2.14.125-1.024.256-2.047.375-3.071.091-.792.167-1.587.249-2.381.104-1.015.215-2.027.306-3.044.068-.77.04-1.555.177-2.312.251-1.387.907-2.567 2.137-3.331.514-.318 1.096-.528 1.666-.798l-.098-.149c-.527-.684-1.067-1.357-1.584-2.049-.812-1.086-1.396-2.297-1.983-3.514-.556-1.154-1.236-2.246-1.821-3.387-1.021-1.99-2.061-3.975-3.002-6.002-1.183-2.55-2.115-5.188-2.408-8.012-.125-1.194-.157-2.388.086-3.571.387-1.89 1.373-3.368 3.033-4.382 1.54-.94 3.255-1.244 5.012-1.339 1.09-.059 2.187-.011 3.318-.011l-.037-.191c-.704-1.472-1.361-2.969-2.132-4.405-1.086-2.028-2.478-3.856-4.026-5.553a27.94 27.94 0 0 0-3.75-3.45c-1.338-1.013-2.748-1.918-4.253-2.657a24.95 24.95 0 0 0-5.624-2c-1.885-.418-3.78-.674-5.714-.695-1.648-.018-3.286.058-4.892.429-2.424.561-4.641 1.559-6.568 3.175a17.016 17.016 0 0 0-2.839 3.044c-.967 1.325-1.745 2.759-2.411 4.26-.914 2.061-1.541 4.204-1.971 6.408-.214 1.1-.382 2.207-.553 3.314-.06.389-.064.784-.1 1.229l.732-.381.714-.32c2.417-1.105 4.92-1.816 7.61-1.735 1.144.034 2.236.261 3.254.762 1.95.962 3.09 2.597 3.586 4.665.342 1.428.577 2.884.805 4.337.178 1.134.361 2.28.381 3.424.029 1.672-.055 3.348-.146 5.019a13.997 13.997 0 0 1-.872 4.154c-.904 2.416-1.912 4.793-2.853 7.195-.311.794-.55 1.615-.843 2.488l1.188.001c.144.003.291.007.43.04 1.081.255 2.02.745 2.789 1.577 1.028 1.104 1.566 2.396 1.593 3.893zM41.897 56.042a14.187 14.187 0 0 1-1.094-4.538c-.104-1.474.071-2.94.223-4.408.146-1.421.27-2.849.312-4.275.071-2.347-.087-4.688-.199-7.033-.067-1.396.095-2.809.219-4.208.112-1.26.252-2.523.491-3.765.399-2.084.93-4.138 1.685-6.129.715-1.888 1.539-3.725 2.699-5.38.797-1.136 1.699-2.195 2.566-3.305l-.258-.092c-2.823-.896-5.693-1.598-8.646-1.903-1.395-.145-2.796-.229-4.195-.313-.43-.025-.866.033-1.297.074-1.067.103-2.148.143-3.198.343-1.787.34-3.502.912-5.089 1.843a12.632 12.632 0 0 0-3.626 3.211c-1.107 1.431-1.854 3.049-2.389 4.773-.632 2.035-.934 4.13-1.015 6.243-.071 1.853-.106 3.716.214 5.562.237 1.373.396 2.762.658 4.131a122.89 122.89 0 0 0 1.186 5.573c.633 2.644 1.267 5.29 2.018 7.902.718 2.501 1.527 4.98 2.407 7.43.718 1.999 1.549 3.961 2.424 5.896.57 1.261 1.26 2.475 1.984 3.655.769 1.254 1.645 2.444 2.831 3.354 1.499 1.148 2.658 1.327 4.182.066.652-.539 1.203-1.207 1.771-1.842.901-1.008 1.771-2.046 2.669-3.059 1.143-1.289 2.3-2.565 3.449-3.85.243-.271.478-.551.714-.825l-.393-.343a14.33 14.33 0 0 1-3.303-4.788zm43.341-38.403a49.306 49.306 0 0 1 2.672 3.394 30.638 30.638 0 0 1 3.855 7.336c.42 1.155.756 2.321.606 3.584-.104.885-.097 1.782-.174 2.672-.065.74-.183 1.476-.278 2.214-.144 1.112-.352 2.222-.414 3.339-.06 1.064.003 2.138.07 3.203.067 1.083.213 2.161.312 3.241.112 1.227.264 2.451.298 3.68.028 1.008-.062 2.021-.149 3.029a12.063 12.063 0 0 1-.87 3.512c-.323.794-.708 1.562-1.071 2.356l.146.154.222.172.225-.4a75.33 75.33 0 0 0 5.021-9.277 147.495 147.495 0 0 0 2.654-6.27 69.833 69.833 0 0 0 3.151-10.094c.36-1.544.636-3.112.88-4.68.191-1.226.349-2.466.385-3.703.037-1.312-.035-2.634-.156-3.942-.091-.988-.335-1.982-.953-2.787-.996-1.293-2.07-2.529-3.391-3.508-1.113-.823-2.223-1.67-3.416-2.362-1.893-1.099-3.942-1.829-6.083-2.327-2.091-.487-4.207-.697-6.337-.742-1.256-.027-2.518.108-3.771.227-1.136.106-2.265.288-3.408.438 1.227.69 2.438 1.304 3.578 2.027 2.4 1.52 4.552 3.349 6.396 5.514zm-31.18 42.563c.775-2.48 1.832-4.85 2.855-7.232.831-1.933 1.284-3.968 1.435-6.06.075-1.031.055-2.075.004-3.109a35.642 35.642 0 0 0-.316-3.438c-.215-1.454-.459-2.909-.803-4.336-.373-1.544-1.313-2.62-2.925-3.017-.981-.241-1.957-.231-2.95-.074-2.423.381-4.641 1.274-6.707 2.582-.416.263-.646.476-.573 1.071.152 1.264.185 2.548.179 3.823-.008 1.805-.085 3.61-.153 5.414-.022.587-.107 1.173-.171 1.758-.096.896-.283 1.791-.277 2.686.006.922.1 1.865.324 2.758.711 2.832 2.215 5.148 4.682 6.783 1.517 1.006 3.195 1.512 5.038 1.609.122-.423.235-.822.358-1.218zm-2.896-24.289c-.325-.681-.139-1.246.613-1.508.184-.063.372-.133.562-.151.263-.026.528-.007.793-.007.955.006 1.873.139 2.66.745.506.39.642.905.314 1.437-.465.753-1.172 1.131-2.042 1.203-1.369.113-2.33-.525-2.9-1.719zm37.975-.249l.311-2.725c.045-.364-.146-.464-.452-.473-.963-.026-1.925-.061-2.888-.077-1.084-.02-2.141.154-3.145.566-1.114.459-1.962 1.193-2.309 2.406a7.266 7.266 0 0 0-.236 2.752 16.29 16.29 0 0 0 .963 4.18c.674 1.793 1.378 3.585 2.221 5.303 1.141 2.325 2.431 4.577 3.643 6.867.323.611.597 1.25.934 1.963a11.11 11.11 0 0 0 1.09-4.538c.033-1.301-.07-2.605-.146-3.906-.047-.796-.16-1.588-.237-2.382-.107-1.106-.271-2.213-.297-3.322-.025-1.128.055-2.262.151-3.389.09-1.078.268-2.149.397-3.225zm-2.169-.874c-.358.987-1.122 1.545-2.114 1.708-.924.153-1.734-.188-2.336-.926-.429-.525-.265-1.146.378-1.502.738-.408 1.549-.511 2.506-.573.261.047.651.088 1.023.193.539.152.739.56.543 1.1zM58.37 65.193c-.528-.432-1.228-.457-1.73.017-.624.59-1.173 1.264-1.722 1.928-.633.768-1.229 1.566-2.045 2.161-1.189.865-2.578 1.223-3.972 1.562-1.108.27-2.222.521-3.333.779l-.014.144c.33.152.649.343.994.452 1.695.536 3.42.804 5.212.652 1.292-.111 2.524-.393 3.691-.946 1.607-.761 2.844-1.968 3.895-3.37.176-.234.256-.58.276-.882.071-1.066-.47-1.859-1.252-2.497zm30.945-.462c-.831.279-1.507.704-1.708 1.603-.137.608-.187 1.237-.24 1.86-.01.11.127.312.231.34.64.169 1.284.368 1.938.427.805.073 1.623.05 2.433.01.874-.044 1.754-.101 2.616-.245 2.029-.342 3.994-.896 5.738-2.048.63-.415 1.252-.839 1.878-1.261l-.052-.089c-.667.099-1.332.22-2.002.291-1.364.146-2.729.3-4.098.379-.661.038-1.331-.089-1.997-.143-1.118-.091-2.21-.339-3.155-.937-.545-.344-1.001-.382-1.582-.187z\"/><path fill=\"#336791\" d=\"M2.835 103.184a26.23 26.23 0 0 1 4.343-.338c2.235 0 3.874.52 4.914 1.456.962.832 1.534 2.106 1.534 3.667 0 1.586-.469 2.834-1.353 3.744-1.196 1.274-3.146 1.924-5.356 1.924-.676 0-1.3-.026-1.819-.156v7.021H2.835v-17.318zm2.263 8.45c.494.13 1.118.182 1.872.182 2.729 0 4.394-1.326 4.394-3.744 0-2.314-1.638-3.432-4.134-3.432-.988 0-1.742.078-2.132.182v6.812zm22.23 2.47c0 4.654-3.225 6.683-6.267 6.683-3.406 0-6.032-2.496-6.032-6.475 0-4.212 2.756-6.682 6.24-6.682 3.615-.001 6.059 2.626 6.059 6.474zm-9.984.13c0 2.756 1.586 4.836 3.822 4.836 2.184 0 3.821-2.054 3.821-4.888 0-2.132-1.065-4.836-3.77-4.836s-3.873 2.496-3.873 4.888zm12.557 3.926c.676.442 1.872.91 3.016.91 1.664 0 2.444-.832 2.444-1.872 0-1.092-.649-1.69-2.34-2.314-2.262-.806-3.328-2.054-3.328-3.562 0-2.028 1.638-3.692 4.342-3.692 1.274 0 2.393.364 3.095.78l-.572 1.664a4.897 4.897 0 0 0-2.574-.728c-1.352 0-2.106.78-2.106 1.716 0 1.04.755 1.508 2.393 2.132 2.184.832 3.302 1.924 3.302 3.796 0 2.21-1.716 3.77-4.706 3.77-1.378 0-2.652-.338-3.536-.858l.57-1.742zm13.365-13.859v3.614h3.275v1.742h-3.275v6.786c0 1.56.441 2.444 1.716 2.444a5.09 5.09 0 0 0 1.326-.156l.104 1.716c-.441.182-1.144.312-2.027.312-1.066 0-1.925-.338-2.471-.962-.649-.676-.884-1.794-.884-3.276v-6.864h-1.95v-1.742h1.95v-3.016l2.236-.598zm16.536 3.615c-.053.91-.104 1.924-.104 3.458v7.306c0 2.886-.572 4.654-1.794 5.747-1.222 1.144-2.99 1.508-4.576 1.508-1.508 0-3.172-.364-4.187-1.04l.572-1.742c.832.52 2.132.988 3.692.988 2.34 0 4.056-1.222 4.056-4.394v-1.404h-.052c-.702 1.17-2.054 2.106-4.004 2.106-3.12 0-5.356-2.652-5.356-6.137 0-4.264 2.782-6.682 5.668-6.682 2.185 0 3.381 1.144 3.927 2.184h.052l.104-1.898h2.002zm-2.366 4.966c0-.39-.026-.728-.13-1.04-.416-1.326-1.534-2.418-3.198-2.418-2.185 0-3.744 1.846-3.744 4.758 0 2.47 1.248 4.524 3.718 4.524 1.404 0 2.678-.884 3.172-2.34.13-.39.183-.832.183-1.222v-2.262zm5.901-1.04c0-1.482-.026-2.756-.104-3.926h2.003l.077 2.47h.104c.572-1.69 1.95-2.756 3.484-2.756.26 0 .441.026.649.078v2.158a3.428 3.428 0 0 0-.779-.078c-1.612 0-2.757 1.222-3.068 2.938a6.44 6.44 0 0 0-.104 1.066v6.708h-2.262v-8.658zm9.517 2.782c.052 3.094 2.027 4.368 4.315 4.368 1.639 0 2.626-.286 3.484-.65l.39 1.638c-.806.364-2.184.78-4.186.78-3.874 0-6.188-2.548-6.188-6.344 0-3.796 2.236-6.787 5.902-6.787 4.108 0 5.2 3.614 5.2 5.928 0 .468-.052.832-.078 1.066h-8.839zm6.708-1.638c.025-1.456-.599-3.718-3.172-3.718-2.314 0-3.328 2.132-3.511 3.718h6.683zm4.809 4.758a8.016 8.016 0 0 0 4.056 1.144c2.314 0 3.666-1.222 3.666-2.99 0-1.638-.936-2.574-3.302-3.484-2.86-1.014-4.628-2.496-4.628-4.966 0-2.73 2.262-4.758 5.668-4.758 1.794 0 3.094.416 3.874.858l-.624 1.846a6.98 6.98 0 0 0-3.328-.832c-2.392 0-3.302 1.43-3.302 2.626 0 1.638 1.065 2.444 3.484 3.38 2.964 1.145 4.472 2.574 4.472 5.148 0 2.704-2.002 5.044-6.136 5.044-1.69 0-3.536-.494-4.473-1.118l.573-1.898zm27.586 5.33a94.846 94.846 0 0 1-6.708-2.028c-.364-.13-.728-.26-1.066-.26-4.16-.156-7.722-3.224-7.722-8.866 0-5.616 3.432-9.23 8.164-9.23 4.758 0 7.853 3.692 7.853 8.866 0 4.498-2.08 7.384-4.992 8.398v.104c1.742.442 3.64.858 5.122 1.118l-.651 1.898zm-1.872-11.414c0-3.51-1.819-7.125-5.538-7.125-3.822 0-5.694 3.536-5.668 7.333-.026 3.718 2.028 7.072 5.564 7.072 3.615 0 5.642-3.276 5.642-7.28zm5.329-8.684h2.263v15.626h7.488v1.898h-9.751v-17.524z\"/></svg>"

/***/ }),

/***/ "../src/components/postgresql/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PostgresqlPlainWordmark = __webpack_require__("../src/components/postgresql/plain-wordmark/PostgresqlPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PostgresqlPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/postgresql/plain/PostgresqlPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PostgresqlPlain = __webpack_require__("../src/components/postgresql/plain/PostgresqlPlain.svg");
	
	var _PostgresqlPlain2 = _interopRequireDefault(_PostgresqlPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PostgresqlPlain */
	function PostgresqlPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PostgresqlPlain',
	    svg: _PostgresqlPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PostgresqlPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PostgresqlPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/postgresql/plain/PostgresqlPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#336791\" d=\"M123.258 76.784c-.45-2.918-2.901-4.829-5.752-4.958-1.032-.047-2.08.061-3.109.192-1.243.158-2.471.438-3.711.623-.857.128-1.726.187-2.582.275l-.021-.111c1.598-3.018 3.263-6.003 4.775-9.064 1.159-2.348 2.151-4.781 3.176-7.194 1.696-3.998 3.051-8.12 4.173-12.309 1.075-4.011 1.995-8.066 2.284-12.227.116-1.662.196-3.331.187-4.995-.008-1.327-.151-2.656-.284-3.979-.15-1.516-.608-2.953-1.242-4.336-.836-1.822-2.132-3.317-3.496-4.737-1.092-1.137-2.293-2.173-3.484-3.208-1.698-1.477-3.607-2.656-5.59-3.703a32.18 32.18 0 0 0-7.09-2.75c-1.493-.381-3.02-.664-4.532-.966-.544-.11-1.089-.337-1.633-.337H85.086c-.37 0-.737.191-1.11.233-2.452.273-4.875.735-7.228 1.464-.88.273-1.684.101-2.52.024-.641-.059-1.271-.231-1.912-.263-2.442-.122-4.887-.301-7.328-.275-2.339.024-4.654.409-6.918 1.052-1.895.538-3.749 1.195-5.447 2.191-.727.426-1.303.346-2.055.129-2.527-.729-5.072-1.414-7.639-1.989-1.6-.358-3.245-.536-4.879-.707a57.214 57.214 0 0 0-4.718-.294c-1.538-.033-3.087-.032-4.618.104a30.16 30.16 0 0 0-7.158 1.513 23.813 23.813 0 0 0-7.086 3.865c-2.167 1.715-3.905 3.809-5.303 6.2-1.473 2.523-2.483 5.224-3.111 8.061-.34 1.537-.555 3.117-.788 4.678-.073.486.732.972-.268 1.456v6.794c1 .452.208.903.266 1.356.139 1.089.262 2.187.446 3.268.291 1.711.636 3.417.988 5.117a324.86 324.86 0 0 0 1.546 7.111c.396 1.72.847 3.43 1.319 5.131.721 2.598 1.431 5.201 2.246 7.77.757 2.387 1.624 4.74 2.484 7.093 1.191 3.255 2.617 6.405 4.327 9.424 1.479 2.614 3.169 5.062 5.436 7.076 1.494 1.327 3.157 2.347 5.093 2.857 1.521.4 3.067.448 4.624.129a10.979 10.979 0 0 0 4.824-2.311c.163-.134.342-.236.535.01.735.931 1.719 1.552 2.748 2.089 2.777 1.448 5.803 1.882 8.877 2.059.744.043 1.496-.064 2.246-.085 1.461-.04 2.881-.325 4.278-.729.732-.212 1.447-.481 2.192-.732.039.793.089 1.557.112 2.321l.104 4.166c.019.634.044 1.27.103 1.901.151 1.627.299 3.255.493 4.877.135 1.118.275 2.245.538 3.336a38.176 38.176 0 0 0 2.158 6.428 13.81 13.81 0 0 0 3.9 5.185c2.22 1.836 4.822 2.619 7.632 2.764 1.162.061 2.357.004 3.501-.204a49.01 49.01 0 0 0 5.387-1.275c3.591-1.084 6.695-2.956 9.014-5.981 1.32-1.724 2.404-3.589 3.1-5.648.574-1.701 1.115-3.419 1.545-5.16.34-1.372.508-2.787.715-4.188.137-.927.219-1.863.305-2.797.14-1.517.283-3.033.384-4.553.07-1.058.067-2.121.109-3.181.013-.323.065-.644.095-.966.028-.298.178-.401.482-.396 1.071.016 2.144.044 3.212-.004 1.197-.054 2.405-.105 3.583-.303a56.542 56.542 0 0 0 4.99-1.067c1.943-.508 3.725-1.418 5.44-2.455 1.998-1.207 3.819-2.623 5.297-4.447 1.285-1.591 1.894-3.43 1.584-5.438zm-3.412.982c-.066.915-.485 1.699-1.093 2.369-2.869 3.163-6.468 5.082-10.585 6.027-1.564.358-3.178.544-4.779.692a32.093 32.093 0 0 1-4.114.097c-1.006-.038-2.004-.268-3.032-.416-.103.94-.201 1.919-.32 2.896l-.479 3.745c-.145 1.187-.258 2.378-.407 3.564-.146 1.151-.328 2.298-.481 3.449-.143 1.072-.248 2.149-.407 3.219-.245 1.64-.479 3.284-.799 4.911-.384 1.945-.973 3.829-1.934 5.583-1.172 2.141-2.834 3.772-4.949 4.98-2.18 1.246-4.563 1.894-6.979 2.436-1.71.384-3.472.447-5.204.291-3.004-.272-5.568-1.557-7.506-3.886-1.85-2.223-3.102-4.771-3.55-7.655a63.102 63.102 0 0 1-.491-4.136 108.067 108.067 0 0 1-.299-4.62 250.203 250.203 0 0 1-.197-5.871c-.053-2.406-.07-4.812-.104-7.218l-.006-.092c-1.224.734-2.427 1.538-3.703 2.2a12.392 12.392 0 0 1-4.798 1.353c-1.318.1-2.653.191-3.965.086-2.151-.173-4.3-.51-6.226-1.569-.781-.43-1.596-.953-2.134-1.64-1.29-1.646-.672-3.726 1.273-4.727 1.344-.693 2.811-.982 4.268-1.319a44.368 44.368 0 0 0 3.761-1.029c1.222-.4 1.993-1.391 2.754-2.363l1.206-1.551c-.503-.053-.977-.107-1.451-.151-1.439-.136-2.812-.532-4.125-1.114-1.124-.497-1.141-.551-1.965.343-1.376 1.494-2.714 3.023-4.062 4.542-.992 1.117-1.978 2.241-2.965 3.361-.978 1.108-1.894 2.279-2.947 3.31-1.564 1.531-3.449 2.452-5.698 2.348-1.443-.066-2.764-.572-3.952-1.399-2.452-1.708-4.104-4.097-5.608-6.606-1.927-3.215-3.406-6.64-4.672-10.159-.876-2.432-1.756-4.866-2.521-7.333-.831-2.681-1.56-5.396-2.277-8.11a157.373 157.373 0 0 1-1.482-6.182 216.117 216.117 0 0 1-1.464-7.079c-.298-1.599-.471-3.221-.712-4.831-.325-2.17-.385-4.36-.267-6.539.105-1.963.387-3.921.667-5.871.388-2.698 1.277-5.244 2.556-7.648.783-1.473 1.755-2.812 2.879-4.056 1.845-2.042 4.078-3.518 6.562-4.626 1.736-.774 3.57-1.24 5.439-1.604 2.774-.54 5.573-.519 8.373-.461 1.224.025 2.443.248 3.666.369 2.633.262 5.214.816 7.762 1.5 1.857.498 3.676 1.143 5.518 1.703.185.056.456.051.607-.048 2.496-1.629 5.224-2.704 8.125-3.319 1.101-.233 2.237-.335 3.363-.407 1.369-.087 2.749-.167 4.115-.088 1.642.094 3.276.336 4.908.56.792.108 1.565.383 2.359.458.38.036.783-.242 1.185-.335 2.049-.473 4.089-1 6.156-1.374 1.539-.278 3.111-.409 4.676-.499 1.745-.1 3.503-.173 5.247-.089a36.66 36.66 0 0 1 6.555.923c2.677.623 5.245 1.528 7.686 2.784 1.824.938 3.558 2.026 5.119 3.364 1.023.878 2.07 1.745 2.994 2.723 1.14 1.206 2.303 2.413 3.018 3.958.538 1.165.922 2.371 1.028 3.647.132 1.586.292 3.178.277 4.766-.014 1.519-.221 3.037-.368 4.552-.334 3.454-1.085 6.833-1.997 10.167a116.972 116.972 0 0 1-2.589 8.17c-.879 2.481-1.893 4.917-2.918 7.343a80.07 80.07 0 0 1-2.458 5.303c-1.677 3.286-3.421 6.538-5.438 9.633-.348.535-.678 1.083-1.018 1.629.88.594 1.877.803 2.881.911.955.104 1.929.166 2.883.095 1.527-.113 3.049-.331 4.567-.544 1.504-.21 2.978-.638 4.522-.525 1.542.112 2.645 1.284 2.54 2.729zm-22.013-3.353c-.655-.846-1.323-1.682-1.964-2.538-1.006-1.344-1.729-2.845-2.455-4.353-.688-1.429-1.532-2.782-2.257-4.195-1.265-2.465-2.553-4.922-3.718-7.435-1.465-3.157-2.62-6.426-2.984-9.923-.154-1.48-.193-2.958.106-4.424.479-2.341 1.702-4.172 3.758-5.428 1.907-1.165 4.032-1.541 6.209-1.659 1.351-.073 2.708-.013 4.11-.013l-.047-.237c-.872-1.823-1.687-3.677-2.641-5.457-1.346-2.512-3.068-4.777-4.986-6.877-1.421-1.555-2.96-2.998-4.646-4.273-1.658-1.255-3.405-2.376-5.269-3.293-2.223-1.093-4.538-1.938-6.967-2.477-2.334-.518-4.683-.835-7.077-.861-2.042-.022-4.071.07-6.06.531-3.002.695-5.748 1.931-8.137 3.933a21.143 21.143 0 0 0-3.517 3.77c-1.196 1.643-2.161 3.417-2.986 5.277-1.132 2.552-1.909 5.208-2.44 7.938-.266 1.361-.474 2.734-.686 4.106-.074.48-.08.971-.123 1.521.369-.192.635-.34.907-.472l.885-.397c2.993-1.369 6.094-2.25 9.427-2.149 1.416.043 2.771.323 4.03.943 2.415 1.191 3.828 3.216 4.442 5.779.424 1.769.714 3.573.996 5.372.221 1.405.447 2.825.473 4.242.037 2.071-.068 4.146-.181 6.216a17.386 17.386 0 0 1-1.08 5.146c-1.12 2.993-2.368 5.937-3.534 8.913-.385.983-.681 2.001-1.045 3.082.562 0 1.018-.004 1.474.002.178.003.36.008.532.049 1.34.316 2.502.923 3.455 1.954 1.271 1.372 1.938 2.973 1.972 4.826.019 1.027-.089 2.057-.084 3.084.021 4.786.057 9.572.097 14.357.007.782.046 1.565.102 2.346.117 1.635.235 3.271.395 4.902.112 1.157.268 2.312.451 3.461.259 1.628 1 3.077 1.841 4.462.724 1.191 1.665 2.203 2.905 2.901 2.107 1.186 4.376 1.285 6.663.848 1.545-.295 3.062-.769 4.562-1.258a10.128 10.128 0 0 0 3.937-2.354c1.051-1.019 1.797-2.261 2.3-3.632.976-2.659 1.28-5.459 1.684-8.237.151-1.04.282-2.083.42-3.125.157-1.186.316-2.371.468-3.556.112-.883.214-1.768.322-2.651.154-1.268.317-2.535.464-3.804.113-.981.209-1.966.309-2.949.129-1.256.268-2.512.379-3.77.086-.955.051-1.927.22-2.864.311-1.718 1.123-3.18 2.646-4.125.637-.395 1.356-.655 2.063-.989l-.12-.186zm-57.597-7.052a17.526 17.526 0 0 1-1.354-5.622c-.128-1.825.089-3.643.276-5.46.182-1.76.333-3.528.386-5.296.088-2.906-.108-5.808-.247-8.712-.084-1.729.117-3.479.271-5.212.139-1.561.312-3.126.607-4.664.495-2.581 1.152-5.125 2.086-7.591.887-2.338 1.906-4.615 3.345-6.665.986-1.406 2.105-2.72 3.18-4.094l-.319-.113c-3.498-1.111-7.053-1.979-10.709-2.358-1.729-.179-3.464-.284-5.198-.387-.532-.032-1.072.04-1.606.091-1.322.126-2.66.176-3.961.424-2.214.421-4.338 1.129-6.305 2.282-1.766 1.035-3.249 2.373-4.491 3.978-1.372 1.772-2.295 3.776-2.958 5.913-.783 2.521-1.156 5.115-1.257 7.733-.088 2.295-.132 4.603.264 6.889.295 1.702.492 3.422.817 5.117.443 2.311.918 4.617 1.467 6.904.785 3.274 1.569 6.553 2.499 9.787.89 3.099 1.894 6.17 2.982 9.204.89 2.476 1.919 4.906 3.003 7.304.706 1.562 1.561 3.065 2.457 4.528.953 1.553 2.037 3.027 3.508 4.154 1.856 1.423 3.293 1.644 5.179.083.808-.669 1.491-1.495 2.194-2.282 1.117-1.25 2.195-2.534 3.307-3.788 1.416-1.598 2.85-3.179 4.273-4.769.301-.336.59-.682.883-1.022l-.484-.425a17.695 17.695 0 0 1-4.095-5.931zm53.688-47.569a61.488 61.488 0 0 1 3.309 4.204c2 2.809 3.598 5.842 4.775 9.087.521 1.43.937 2.874.751 4.439-.129 1.096-.118 2.208-.215 3.31-.081.917-.226 1.829-.345 2.743-.178 1.378-.436 2.752-.513 4.136-.073 1.317.003 2.648.086 3.968.084 1.341.265 2.676.388 4.015.139 1.518.326 3.036.369 4.557.035 1.249-.076 2.506-.185 3.753-.13 1.502-.511 2.956-1.079 4.351-.399.982-.876 1.934-1.327 2.917l.181.192.275.213.277-.496a93.621 93.621 0 0 0 6.222-11.493 186.333 186.333 0 0 0 3.287-7.766c1.624-4.064 2.909-8.242 3.903-12.503.446-1.913.787-3.855 1.09-5.797.236-1.518.433-3.054.477-4.586.047-1.625-.043-3.263-.193-4.884-.112-1.224-.414-2.456-1.181-3.451-1.233-1.602-2.564-3.134-4.201-4.346-1.378-1.021-2.751-2.068-4.23-2.927-2.345-1.36-4.883-2.266-7.535-2.883-2.588-.603-5.21-.863-7.849-.918-1.556-.033-3.119.134-4.672.28-1.407.132-2.805.357-4.222.543 1.52.855 3.019 1.615 4.433 2.511 2.973 1.883 5.637 4.149 7.924 6.831zM55.299 72.514c.961-3.073 2.27-6.007 3.538-8.959 1.028-2.394 1.59-4.916 1.777-7.506.093-1.277.067-2.57.004-3.851a44.628 44.628 0 0 0-.392-4.259c-.266-1.801-.569-3.603-.995-5.371-.462-1.913-1.627-3.245-3.623-3.736-1.216-.299-2.424-.287-3.653-.093-3.002.473-5.75 1.579-8.31 3.199-.515.326-.798.589-.709 1.328.188 1.565.229 3.155.222 4.735-.01 2.236-.105 4.472-.19 6.707-.028.728-.133 1.452-.211 2.177-.12 1.11-.351 2.219-.344 3.327.007 1.142.124 2.311.401 3.417.88 3.507 2.744 6.377 5.799 8.402 1.879 1.245 3.958 1.873 6.24 1.992.155-.524.293-1.019.446-1.509zm-3.586-30.087c-.402-.844-.172-1.543.76-1.867.227-.08.461-.165.697-.188.324-.032.654-.008.982-.008 1.182.006 2.319.171 3.295.923.626.482.794 1.122.389 1.779-.575.932-1.452 1.4-2.529 1.49-1.697.141-2.888-.65-3.594-2.129zm47.04-.308c.136-1.124.245-2.251.384-3.375.056-.452-.182-.574-.561-.585-1.192-.033-2.384-.075-3.576-.097-1.344-.024-2.652.192-3.896.703-1.38.568-2.431 1.478-2.86 2.98a9.042 9.042 0 0 0-.293 3.41 20.11 20.11 0 0 0 1.193 5.176c.834 2.221 1.707 4.441 2.75 6.569 1.413 2.881 3.012 5.67 4.513 8.507.401.757.738 1.547 1.156 2.431a13.783 13.783 0 0 0 1.351-5.622c.041-1.61-.088-3.227-.182-4.838-.059-.986-.198-1.966-.294-2.95-.134-1.371-.337-2.741-.368-4.115-.031-1.397.068-2.802.188-4.197.113-1.338.334-2.665.495-3.997zm-2.689-1.082c-.443 1.223-1.39 1.913-2.618 2.116-1.145.188-2.148-.235-2.894-1.148-.531-.65-.328-1.42.468-1.859.914-.506 1.919-.634 3.104-.711.322.059.807.108 1.268.24.669.189.916.692.672 1.362zm-35.422 37.66c-.655-.535-1.521-.566-2.144.021-.773.73-1.453 1.565-2.133 2.388-.785.951-1.521 1.94-2.534 2.677-1.474 1.071-3.192 1.515-4.919 1.935-1.373.334-2.752.644-4.129.965l-.017.178c.409.189.805.425 1.231.56 2.1.665 4.236.996 6.455.808 1.602-.136 3.128-.485 4.574-1.171 1.99-.943 3.521-2.437 4.823-4.175.218-.29.317-.719.343-1.093.089-1.321-.582-2.303-1.55-3.093zm51.751.526c-1.69.181-3.382.373-5.077.47-.818.047-1.648-.109-2.474-.176-1.385-.112-2.737-.42-3.908-1.16-.678-.427-1.241-.475-1.961-.233-1.028.346-1.867.872-2.115 1.986-.169.753-.23 1.533-.298 2.304-.013.136.157.386.287.42.793.209 1.59.456 2.401.529.996.09 2.01.061 3.013.011 1.083-.054 2.173-.124 3.24-.304 2.515-.422 4.948-1.11 7.109-2.536.779-.515 1.551-1.041 2.325-1.562l-.064-.11c-.826.123-1.648.273-2.478.361z\"/></svg>"

/***/ }),

/***/ "../src/components/postgresql/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PostgresqlPlain = __webpack_require__("../src/components/postgresql/plain/PostgresqlPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PostgresqlPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/protractor/plain-wordmark/ProtractorPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ProtractorPlainWordmark = __webpack_require__("../src/components/protractor/plain-wordmark/ProtractorPlainWordmark.svg");
	
	var _ProtractorPlainWordmark2 = _interopRequireDefault(_ProtractorPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ProtractorPlainWordmark */
	function ProtractorPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ProtractorPlainWordmark',
	    svg: _ProtractorPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ProtractorPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ProtractorPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/protractor/plain-wordmark/ProtractorPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><style>.st0{fill:#b7111d}</style><path class=\"st0\" d=\"M18.8 59.5c1.6 1.7 1.7 3.8 1.8 4.3H8.3c0-.4.1-2.7 2-4.5 1.7-1.6 3.7-1.7 4.2-1.7.3 0 2.6.1 4.3 1.9zm8.1 3.3c0 6.9-5.6 12.5-12.5 12.5S1.9 69.7 1.9 62.8s5.6-12.5 12.5-12.5 12.5 5.6 12.5 12.5zm-3.1 3.3c0-.5.1-1.2 0-2H22v-.6h1.7c-.1-1.6-.5-4-2.3-6.1 0-.1-.1-.1-.1-.2L20 58.6l-.5-.5 1.4-1.4c-2.3-2.1-5.1-2.5-6.1-2.5v1.9h-.6v-1.9c-1 0-3.9.4-6.2 2.6l1.3 1.3-.5.5-1.3-1.3c-1.9 2.1-2.3 4.6-2.4 6.2h1.7v.6H5v.1c-.1.8 0 1.5 0 2l18.8-.1zm13.1-10.2c-.6-.1-1.2-.2-1.7-.2h-4.6V70h2.3v-5.3c.6 0 1.1.1 1.7 0 .9-.1 1.9-.2 2.8-.5 1.9-.6 2.8-2.3 2.7-4.4-.2-2.1-1.2-3.4-3.2-3.9zm-.7 6.4c-1 .3-2.1.3-3.3.5v-5.2c1 .1 2 .1 3 .3s1.6 1 1.6 2.1c.2 1.1-.3 2-1.3 2.3zm8.3 7.7h-2.3V59.1h1.5c.1 0 .3.3.4.4.1.4.1.9.2 1.3.7-.5 1.3-1.1 2-1.6.8-.5 1.6-.4 2.6-.2-.1.7-.1 1.4-.2 2.1h-.6c-2.1-.2-3.5 1.1-3.6 3.2V70zm15.1-2.6c-.7 1.9-2.5 2.9-4.7 2.8-2.1 0-3.8-1-4.6-3-.7-1.7-.7-3.5-.1-5.2.8-2.3 3.1-3.4 5.6-3 2.4.4 4 2.2 4.2 4.7v.9c.1 0-.1 1.9-.4 2.8zm-6.9-.4c.4 1 1.3 1.4 2.2 1.4 1 0 1.9-.3 2.3-1.3.7-1.6.7-3.3 0-4.9-.5-1-1.5-1.3-2.5-1.2s-1.7.5-2 1.4c-.3.7-.3 3.8 0 4.6zm10.2-6.1h-1.4c-.2-.7-.1-1.2.6-1.4.8-.2 1.1-.9 1.3-1.6.4-1.3.4-1.2 1.8-1.1v2.3h3.1v1.8h-3.1v5.6c0 1.4.6 1.9 2 1.8.4 0 .7-.1 1.2-.2v1.5c0 .1-.2.3-.4.4-1 .1-2 .3-3 .1-1.3-.3-2-1.4-2-3.1v-5.3c-.1-.2-.1-.5-.1-.8zM73 70h-2.3V59.2h1.8c.1.6.2 1.2.3 1.9 1.1-1.7 2.5-2.5 4.5-2-.1.7-.1 1.4-.2 2.1h-1.3c-1.6.1-2.7 1.2-2.8 2.8-.1 1.8 0 3.7 0 5.5v.5zm14.1 0h-1.6c-.2-.5-.3-.9-.5-1.5-.7.8-1.4 1.5-2.4 1.6-.7.1-1.5.1-2.3 0-1.3-.2-2.2-1.1-2.3-2.4-.3-1.7.3-2.9 1.5-3.5 1.4-.7 2.9-.7 4.4-.8 1 0 1-.1.9-1.1s-.7-1.5-1.7-1.6c-.6 0-1.1.1-1.7.2-.5.1-1.1.4-1.7.6-.2-.5-.5-1.1-.8-1.7 2-.9 4.1-1.3 6.2-.5 1.1.4 1.8 1.3 1.8 2.5.2 2.7.2 5.4.2 8.2zm-2.4-5.2c-.6 0-1.1 0-1.6.1-.6.1-1.2.2-1.8.4-.7.3-1.1 1.1-.9 1.9.2.7.6 1.1 1.5 1.1 2.1.2 3.2-1.2 2.8-3.5zm12.9-5.2c-.2.7-.5 1.2-.7 1.8-.6-.2-1.2-.3-1.8-.5-1.7-.3-3.1.5-3.3 2.3-.1 1-.1 2.1.1 3.1.3 1.4 1.3 2.1 2.7 1.9.9-.1 1.7-.4 2.7-.6v1.7c0 .1-.2.3-.4.4-1.8.7-3.7.7-5.4-.2-1-.5-1.6-1.4-1.9-2.5-.5-1.6-.5-3.2 0-4.8.5-1.8 1.7-2.9 3.6-3.2 1.5-.2 2.9 0 4.4.6zm4.8-.5h3v1.8h-3v6.2c0 .8.6 1.2 1.3 1.2.6 0 1.2-.1 1.8-.2v1.5c0 .1-.2.3-.4.4-1 .1-2 .3-3 .1-1.3-.2-2.1-1.1-2.1-2.5-.1-1.8-.1-3.6-.1-5.4V61h-1.4c-.2-.7-.1-1.2.6-1.4.8-.2 1.1-.8 1.3-1.6.1-.4.3-.8.4-1.2h1.5c.1.7.1 1.5.1 2.3zm14.5 8.3c-.7 1.9-2.6 3-4.8 2.9-2.3-.1-4-1.3-4.6-3.3-.5-1.5-.5-3-.1-4.6.7-2.5 3-3.8 5.8-3.4 2.4.4 4 2.2 4.2 4.7v.9s-.2 1.9-.5 2.8zm-1.8-2.9c-.2-.7-.3-1.5-.5-2.2-.4-1.1-1.4-1.4-2.5-1.4s-1.8.5-2.2 1.5c-.5 1.4-.5 2.9 0 4.3.4 1.1 1.3 1.7 2.5 1.6 1.2 0 2.1-.6 2.4-1.8.1-.6.2-1.2.3-2zm11.6-5.2l-.3 1.8H125c-1.4.1-2.5 1.1-2.6 2.5s-.1 2.8-.1 4.2v2.1H120V59.2c.1 0 .1-.1.1-.1 1.6-.1 1.6-.1 1.9 1.4 0 .1.1.2.1.4 1.1-1.7 2.6-2.4 4.5-2 .1.3.1.4.1.4z\"/></svg>"

/***/ }),

/***/ "../src/components/protractor/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ProtractorPlainWordmark = __webpack_require__("../src/components/protractor/plain-wordmark/ProtractorPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProtractorPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/protractor/plain/ProtractorPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ProtractorPlain = __webpack_require__("../src/components/protractor/plain/ProtractorPlain.svg");
	
	var _ProtractorPlain2 = _interopRequireDefault(_ProtractorPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ProtractorPlain */
	function ProtractorPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ProtractorPlain',
	    svg: _ProtractorPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ProtractorPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ProtractorPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/protractor/plain/ProtractorPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><style>.st0{fill:#b7111d}</style><path class=\"st0\" d=\"M86.1 47.5c8.2 8.5 8.7 18.8 8.7 21.2H33.7c0-2.1.5-13.5 9.8-22.3 8.5-8 18.5-8.3 20.8-8.3 2 0 13 .3 21.8 9.4zM125.9 64c0 34.2-27.7 61.9-61.9 61.9S2 98.2 2 64 29.8 2 64 2s61.9 27.8 61.9 62zm-15.2 16.3c.2-2.4.3-5.9 0-10v-.1h-8.9V67h8.6c-.7-8-2.6-19.9-11.3-30-.2-.3-.5-.5-.7-.8L91.6 43l-2.3-2.3 6.8-6.8C85 23.3 70.8 21.6 65.8 21.3v9.3h-3.2v-9.4c-4.9.2-19.1 1.8-30.5 12.9l6.5 6.5-2.2 2.4-6.5-6.5C20.7 46.8 18.6 59.1 17.8 67h8.3v3.2h-8.6v.4c-.3 4-.2 7.4 0 9.7h93.2z\"/></svg>"

/***/ }),

/***/ "../src/components/protractor/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ProtractorPlain = __webpack_require__("../src/components/protractor/plain/ProtractorPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProtractorPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/pycharm/original-wordmark/PycharmOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PycharmOriginalWordmark = __webpack_require__("../src/components/pycharm/original-wordmark/PycharmOriginalWordmark.svg");
	
	var _PycharmOriginalWordmark2 = _interopRequireDefault(_PycharmOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PycharmOriginalWordmark */
	function PycharmOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PycharmOriginalWordmark',
	    svg: _PycharmOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PycharmOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PycharmOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/pycharm/original-wordmark/PycharmOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"pycharm\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#4d8548}.cls-2{fill:#fa930d}</style></defs><title>Artboard 12</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M43.18 59.67a22 22 0 0 1 3.66-.29A6.07 6.07 0 0 1 51 60.61a4 4 0 0 1 1.29 3.09 4.36 4.36 0 0 1-1.14 3.16 6.13 6.13 0 0 1-4.52 1.62 6.52 6.52 0 0 1-1.54-.13v5.92h-1.91zm1.91 7.13a6.38 6.38 0 0 0 1.58.15c2.3 0 3.71-1.12 3.71-3.16S49 60.9 46.89 60.9a8 8 0 0 0-1.8.15zM55.57 63.66l2.32 6.27c.24.7.5 1.54.68 2.17.2-.64.42-1.45.68-2.22l2.11-6.23h2l-2.9 7.57c-1.38 3.64-2.33 5.51-3.64 6.65a5.23 5.23 0 0 1-2.37 1.25l-.48-1.62a5.11 5.11 0 0 0 1.69-.94 5.87 5.87 0 0 0 1.62-2.15 1.38 1.38 0 0 0 .15-.46 1.69 1.69 0 0 0-.13-.5l-3.93-9.78zM75.9 73.86a9.53 9.53 0 0 1-3.8.64c-5.11 0-7.74-3.18-7.74-7.39 0-5 3.6-7.85 8.07-7.85a8.72 8.72 0 0 1 3.64.66l-.68 2.65a7.2 7.2 0 0 0-2.8-.57c-2.65 0-4.72 1.6-4.72 4.89 0 3 1.75 4.82 4.74 4.82a8.35 8.35 0 0 0 2.79-.48zM77.92 58.71h3.33v6.12a4 4 0 0 1 1.32-1.1 3.74 3.74 0 0 1 1.73-.42c2.13 0 3.75 1.47 3.75 4.69v6.27h-3.29v-5.9C84.76 67 84.28 66 83 66a1.77 1.77 0 0 0-1.67 1.16 2.12 2.12 0 0 0-.11.75v6.36h-3.3V58.71zM96.86 74.28l-.2-1.07h-.06a3.86 3.86 0 0 1-3.07 1.32 3.29 3.29 0 0 1-3.47-3.29c0-2.79 2.5-4.12 6.3-4.1V67c0-.57-.31-1.38-2-1.38a6 6 0 0 0-3 .81l-.61-2.15a8.86 8.86 0 0 1 4.25-.97c3.58 0 4.72 2.11 4.72 4.63v3.73a16.55 16.55 0 0 0 .15 2.61zm-.39-5.07c-1.75 0-3.11.39-3.11 1.69a1.2 1.2 0 0 0 1.32 1.27 1.82 1.82 0 0 0 1.73-1.23 2.39 2.39 0 0 0 .07-.57v-1.16zM102.35 67.08c0-1.58 0-2.61-.09-3.53h2.87l.11 2h.09a3.15 3.15 0 0 1 2.9-2.22 3.43 3.43 0 0 1 .7 0v3.14a4.76 4.76 0 0 0-.9-.09 2.14 2.14 0 0 0-2.28 1.69 3.91 3.91 0 0 0-.07.75v5.44h-3.33v-7.2zM110.68 67c0-1.34 0-2.48-.09-3.42h2.81l.15 1.45h.07a3.72 3.72 0 0 1 3.25-1.69 3 3 0 0 1 2.94 1.82 4.77 4.77 0 0 1 1.38-1.29 3.86 3.86 0 0 1 2-.53c2.06 0 3.62 1.45 3.62 4.65v6.32h-3.25v-5.87c0-1.56-.5-2.46-1.58-2.46a1.63 1.63 0 0 0-1.54 1.16 2.79 2.79 0 0 0-.13.86v6.27h-3.25v-6c0-1.36-.48-2.28-1.53-2.28a1.7 1.7 0 0 0-1.56 1.21 2.22 2.22 0 0 0-.13.83v6.25h-3.25V67z\"/><path class=\"cls-2\" d=\"M24 57.63h-.1A5.83 5.83 0 0 0 18.22 62a5 5 0 0 1-9.9-.94 4 4 0 0 1 0-.55v-.11-.21a15.81 15.81 0 0 1 8.38-10.82A12.16 12.16 0 0 0 1.16 60l-.05.13v17.78h7.2v-5.75A12.16 12.16 0 0 0 25 57.63h-1z\"/><path class=\"cls-1\" d=\"M17 61.76a7 7 0 0 1 6.8-5.32h3.44a3.73 3.73 0 0 0 1.55-.44h-.36a4.92 4.92 0 0 1-3.73-3.33 4.89 4.89 0 0 0 5.9 1.5 3.76 3.76 0 0 0-3.44-5.26h-3.34A14.55 14.55 0 0 0 9.61 60.32a3.71 3.71 0 0 0-.1.73 3.77 3.77 0 0 0 7.48.71zm9-10.71a1.17 1.17 0 1 1 .92 1.37 1.17 1.17 0 0 1-.92-1.37zm4.93 23.15a3.77 3.77 0 0 1-3.77 3.8h-3.34a14.47 14.47 0 0 1-9.52-3.56 13.35 13.35 0 0 0 8.6-4 7.26 7.26 0 0 0 .91.06h3.34a3.77 3.77 0 0 1 3.78 3.71z\"/></g></svg>"

/***/ }),

/***/ "../src/components/pycharm/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PycharmOriginalWordmark = __webpack_require__("../src/components/pycharm/original-wordmark/PycharmOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PycharmOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/pycharm/original/PycharmOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PycharmOriginal = __webpack_require__("../src/components/pycharm/original/PycharmOriginal.svg");
	
	var _PycharmOriginal2 = _interopRequireDefault(_PycharmOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PycharmOriginal */
	function PycharmOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PycharmOriginal',
	    svg: _PycharmOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PycharmOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PycharmOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/pycharm/original/PycharmOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"pycharm\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#fa930d}.cls-2{fill:#4d8548}</style></defs><title>Artboard 14</title><g id=\"original\"><path class=\"cls-1\" d=\"M96.25 40.67h-.51a23.45 23.45 0 0 0-22.86 17.57h-.12a20.1 20.1 0 0 1-39.85-3.78 15.9 15.9 0 0 1 .16-2.21c0-.15 0-.3.06-.45s.1-.57.16-.85A63.63 63.63 0 0 1 66.75 7.43a48.94 48.94 0 0 0-62.54 42.8c-.06.18-.15.35-.21.53v71.55h29V99.18a49 49 0 0 0 67-58.51h-3.8z\"/><path class=\"cls-2\" d=\"M67.92 57.32l.09-.15A28.23 28.23 0 0 1 95.4 35.75h13.85a15 15 0 0 0 6.16-1.51c-.48-.06-1-.13-1.44-.23a19.82 19.82 0 0 1-15-13.41A19.83 19.83 0 0 0 110.8 28a19.64 19.64 0 0 0 11.88-1.35 15.13 15.13 0 0 0-13.82-21.17H95.4a58.54 58.54 0 0 0-57.18 46.04 15 15 0 0 0-.39 3 15.18 15.18 0 0 0 30.09 2.86zm36.23-43.1a4.7 4.7 0 1 1 3.69 5.52 4.71 4.71 0 0 1-3.68-5.52zM124 107.4a15.15 15.15 0 0 1-15.15 15.15H95.4a58.23 58.23 0 0 1-38.3-14.34A53.72 53.72 0 0 0 91.72 92a29.19 29.19 0 0 0 3.68.26h13.45A15.16 15.16 0 0 1 124 107.4z\"/></g></svg>"

/***/ }),

/***/ "../src/components/pycharm/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PycharmOriginal = __webpack_require__("../src/components/pycharm/original/PycharmOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PycharmOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/pycharm/plain-wordmark/PycharmPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PycharmPlainWordmark = __webpack_require__("../src/components/pycharm/plain-wordmark/PycharmPlainWordmark.svg");
	
	var _PycharmPlainWordmark2 = _interopRequireDefault(_PycharmPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PycharmPlainWordmark */
	function PycharmPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PycharmPlainWordmark',
	    svg: _PycharmPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PycharmPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PycharmPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/pycharm/plain-wordmark/PycharmPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"pycharm\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#4d8548}</style></defs><title>Artboard 13</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M43.35 59.71a21.85 21.85 0 0 1 3.65-.29 6 6 0 0 1 4.11 1.22 3.94 3.94 0 0 1 1.28 3.07 4.32 4.32 0 0 1-1.13 3.13 6.08 6.08 0 0 1-4.48 1.61 6.47 6.47 0 0 1-1.52-.13v5.87h-1.91V59.71zm1.89 7.07a6.33 6.33 0 0 0 1.57.15c2.28 0 3.68-1.11 3.68-3.13s-1.37-2.87-3.49-2.87a8 8 0 0 0-1.78.15v5.7zM55.64 63.67l2.31 6.22c.24.7.5 1.52.67 2.15.2-.63.41-1.44.67-2.2l2.09-6.18h2l-2.87 7.5c-1.37 3.61-2.31 5.46-3.61 6.59A5.19 5.19 0 0 1 54.62 79l-.48-1.61a5.06 5.06 0 0 0 1.68-.93 5.82 5.82 0 0 0 1.61-2.13 1.37 1.37 0 0 0 .15-.46 1.67 1.67 0 0 0-.13-.5l-3.89-9.7h2.09zM75.8 73.78a9.45 9.45 0 0 1-3.76.63c-5.07 0-7.68-3.15-7.68-7.33 0-5 3.57-7.79 8-7.79a8.64 8.64 0 0 1 3.61.65l-.67 2.63a7.14 7.14 0 0 0-2.78-.57c-2.63 0-4.68 1.59-4.68 4.85 0 2.94 1.74 4.78 4.7 4.78a8.28 8.28 0 0 0 2.76-.48zM77.8 58.75h3.31v6.07a4 4 0 0 1 1.3-1.09 3.71 3.71 0 0 1 1.72-.41c2.11 0 3.72 1.46 3.72 4.66v6.22h-3.26v-5.86c0-1.39-.48-2.35-1.72-2.35a1.76 1.76 0 0 0-1.65 1.15 2.11 2.11 0 0 0-.11.74v6.31H77.8V58.75zM96.59 74.19l-.2-1.06h-.07a3.83 3.83 0 0 1-3 1.3 3.26 3.26 0 0 1-3.44-3.26c0-2.76 2.48-4.09 6.24-4.07v-.15c0-.57-.3-1.37-1.94-1.37a6 6 0 0 0-2.94.8l-.61-2.13a8.78 8.78 0 0 1 4.13-.94c3.55 0 4.68 2.09 4.68 4.59v3.7a16.41 16.41 0 0 0 .15 2.59h-3zm-.39-5c-1.74 0-3.09.39-3.09 1.68a1.19 1.19 0 0 0 1.3 1.26 1.81 1.81 0 0 0 1.72-1.22 2.37 2.37 0 0 0 .06-.57v-1.17zM102 67.06c0-1.57 0-2.59-.09-3.5h2.85l.11 2h.13a3.13 3.13 0 0 1 2.87-2.2 3.4 3.4 0 0 1 .7 0v3.11a4.72 4.72 0 0 0-.89-.09 2.13 2.13 0 0 0-2.26 1.68 3.88 3.88 0 0 0-.07.74v5.39H102v-7.13zM110.29 67c0-1.33 0-2.46-.09-3.39h2.8l.15 1.44h.06a3.69 3.69 0 0 1 3.22-1.67 3 3 0 0 1 2.91 1.81 4.73 4.73 0 0 1 1.37-1.28 3.83 3.83 0 0 1 2-.52c2 0 3.59 1.44 3.59 4.61v6.26h-3.22v-5.85c0-1.54-.5-2.44-1.57-2.44a1.62 1.62 0 0 0-1.52 1.15 2.76 2.76 0 0 0-.13.85v6.22h-3.22v-6c0-1.35-.48-2.26-1.52-2.26a1.68 1.68 0 0 0-1.54 1.2 2.2 2.2 0 0 0-.13.83v6.2h-3.22V67zM24.36 57.68h-.13A5.78 5.78 0 0 0 18.61 62a5 5 0 0 1-9.82-.93 3.92 3.92 0 0 1 0-.55v-.11-.21a15.68 15.68 0 0 1 8.31-10.71A12.06 12.06 0 0 0 1.69 60l-.05.13V77.8h7.14v-5.7A12.06 12.06 0 0 0 25.3 57.68h-.94z\"/><path class=\"cls-1\" d=\"M17.38 61.78a7 7 0 0 1 6.75-5.28h3.41a3.7 3.7 0 0 0 1.52-.37l-.33-.13a4.88 4.88 0 0 1-3.7-3.3 4.85 4.85 0 0 0 5.85 1.49A3.73 3.73 0 0 0 27.47 49h-3.32a14.42 14.42 0 0 0-14.08 11.35 3.68 3.68 0 0 0-.1.73 3.74 3.74 0 0 0 7.41.7zm8.93-10.62a1.16 1.16 0 1 1 .91 1.36 1.16 1.16 0 0 1-.91-1.36zm4.89 23a3.73 3.73 0 0 1-3.73 3.73h-3.32a14.35 14.35 0 0 1-9.44-3.53 13.24 13.24 0 0 0 8.53-4 7.19 7.19 0 0 0 .91.06h3.31a3.73 3.73 0 0 1 3.74 3.7z\"/></g></svg>"

/***/ }),

/***/ "../src/components/pycharm/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PycharmPlainWordmark = __webpack_require__("../src/components/pycharm/plain-wordmark/PycharmPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PycharmPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/pycharm/plain/PycharmPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PycharmPlain = __webpack_require__("../src/components/pycharm/plain/PycharmPlain.svg");
	
	var _PycharmPlain2 = _interopRequireDefault(_PycharmPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PycharmPlain */
	function PycharmPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PycharmPlain',
	    svg: _PycharmPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PycharmPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PycharmPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/pycharm/plain/PycharmPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"pycharm\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#4d8548}</style></defs><title>Artboard 15</title><g id=\"plain\"><path class=\"cls-1\" d=\"M96.44 40.53h-.52a23.59 23.59 0 0 0-23 17.68h-.12a20.22 20.22 0 0 1-40.08-3.8 16 16 0 0 1 .16-2.23c0-.15 0-.3.06-.45s.1-.57.16-.85A64 64 0 0 1 66.77 7.09 49.23 49.23 0 0 0 3.86 50.15c-.06.18-.15.35-.21.54v72h29.16v-23.3a49.24 49.24 0 0 0 67.45-58.86h-3.82z\"/><path class=\"cls-1\" d=\"M67.95 57.28l.09-.15a28.4 28.4 0 0 1 27.54-21.55h13.94a15.1 15.1 0 0 0 6.19-1.58c-.48-.06-1-.13-1.45-.23a19.93 19.93 0 0 1-15.12-13.44 20 20 0 0 0 11.94 7.45A19.76 19.76 0 0 0 123 26.42a15.22 15.22 0 0 0-13.88-21.28L98 5.11h-2.4a58.89 58.89 0 0 0-57.53 46.33 15 15 0 0 0-.39 3 15.27 15.27 0 0 0 30.27 2.87zm36.45-43.36a4.73 4.73 0 1 1 3.72 5.56 4.74 4.74 0 0 1-3.73-5.55zm20 93.73a15.24 15.24 0 0 1-15.24 15.24H95.58a58.57 58.57 0 0 1-38.52-14.42 54 54 0 0 0 34.82-16.32 29.37 29.37 0 0 0 3.7.26h13.53a15.25 15.25 0 0 1 15.24 15.25z\"/></g></svg>"

/***/ }),

/***/ "../src/components/pycharm/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PycharmPlain = __webpack_require__("../src/components/pycharm/plain/PycharmPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PycharmPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/python/original-wordmark/PythonOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PythonOriginalWordmark = __webpack_require__("../src/components/python/original-wordmark/PythonOriginalWordmark.svg");
	
	var _PythonOriginalWordmark2 = _interopRequireDefault(_PythonOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PythonOriginalWordmark */
	function PythonOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PythonOriginalWordmark',
	    svg: _PythonOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PythonOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PythonOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/python/original-wordmark/PythonOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#646464\" d=\"M52.458 61.139c0-4.071-1.161-6.161-3.483-6.275a6.526 6.526 0 0 0-2.703.443c-.701.251-1.172.499-1.42.75v9.718c1.485.932 2.804 1.364 3.954 1.297 2.433-.162 3.652-2.137 3.652-5.933zm2.863.169c0 2.068-.484 3.785-1.46 5.15-1.087 1.546-2.594 2.34-4.521 2.385-1.453.047-2.949-.409-4.488-1.363v8.833l-2.491-.889V55.818c.409-.5.935-.931 1.572-1.296 1.482-.864 3.284-1.308 5.404-1.33l.036.035c1.938-.024 3.431.771 4.479 2.385.979 1.48 1.469 3.377 1.469 5.696zM70.544 67.104c0 2.773-.278 4.694-.834 5.763-.559 1.068-1.622 1.921-3.191 2.557-1.272.501-2.649.773-4.126.819l-.412-1.569c1.501-.204 2.559-.409 3.172-.613 1.207-.408 2.036-1.035 2.491-1.875.365-.684.545-1.988.545-3.921v-.648a12.81 12.81 0 0 1-5.354 1.158c-1.227 0-2.309-.385-3.24-1.158-1.046-.842-1.57-1.911-1.57-3.205V54.045l2.491-.853v10.435c0 1.114.359 1.973 1.079 2.574.72.603 1.651.892 2.793.87 1.142-.024 2.365-.467 3.665-1.33V53.568h2.491v13.536zM80.267 68.706c-.297.024-.569.035-.82.035-1.409 0-2.507-.334-3.292-1.008-.783-.674-1.175-1.603-1.175-2.788v-9.811h-1.706v-1.566h1.706v-4.161l2.488-.886v5.047h2.798v1.566h-2.798v9.743c0 .935.25 1.597.752 1.982.43.32 1.115.502 2.046.549v1.298zM95.347 68.502h-2.49v-9.614c0-.978-.229-1.82-.684-2.524-.526-.795-1.256-1.193-2.194-1.193-1.142 0-2.57.603-4.284 1.808v11.524h-2.491v-22.98l2.491-.785v10.467c1.591-1.158 3.33-1.738 5.218-1.738 1.319 0 2.387.444 3.205 1.33.82.886 1.229 1.989 1.229 3.308v10.397zM108.586 60.747c0-1.565-.297-2.856-.888-3.879-.704-1.245-1.796-1.902-3.273-1.97-2.731.157-4.094 2.114-4.094 5.864 0 1.72.284 3.155.856 4.308.73 1.47 1.826 2.193 3.287 2.169 2.741-.02 4.112-2.184 4.112-6.492zm2.728.016c0 2.227-.57 4.079-1.707 5.56-1.25 1.656-2.978 2.487-5.183 2.487-2.186 0-3.889-.831-5.118-2.487-1.114-1.48-1.671-3.333-1.671-5.56 0-2.093.603-3.853 1.808-5.287 1.272-1.521 2.945-2.283 5.014-2.283 2.068 0 3.752.763 5.049 2.283 1.205 1.434 1.808 3.194 1.808 5.287zM125.593 68.502h-2.491V58.343c0-1.114-.335-1.984-1.006-2.61-.67-.625-1.564-.928-2.679-.903-1.183.022-2.308.41-3.376 1.159v12.514h-2.491V55.681c1.433-1.044 2.752-1.726 3.957-2.044 1.136-.297 2.139-.444 3.003-.444.591 0 1.147.058 1.67.172.979.226 1.774.646 2.387 1.261.684.682 1.025 1.5 1.025 2.456v11.42z\"/><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"54.862\" y1=\"755.717\" x2=\"85.342\" y2=\"729.493\" gradientTransform=\"matrix(.563 0 0 -.568 -29.215 475.753)\"><stop offset=\"0\" stop-color=\"#5A9FD4\"/><stop offset=\"1\" stop-color=\"#306998\"/></linearGradient><path fill=\"url(#a)\" d=\"M17.761 45.612a21.479 21.479 0 0 0-3.583.307c-3.172.561-3.748 1.734-3.748 3.896v2.857h7.496v.952H7.617c-2.179 0-4.086 1.31-4.683 3.8-.688 2.856-.719 4.639 0 7.619.533 2.219 1.805 3.801 3.984 3.801h2.577V65.42c0-2.475 2.141-4.657 4.683-4.657h7.488c2.084 0 3.748-1.717 3.748-3.809v-7.139c0-2.031-1.714-3.558-3.748-3.896a23.525 23.525 0 0 0-3.905-.307zm-4.054 2.299c.774 0 1.407.643 1.407 1.433 0 .787-.632 1.425-1.407 1.425a1.415 1.415 0 0 1-1.406-1.425c-.001-.79.629-1.433 1.406-1.433z\"/><linearGradient id=\"b\" gradientUnits=\"userSpaceOnUse\" x1=\"97.124\" y1=\"713.621\" x2=\"86.24\" y2=\"729.02\" gradientTransform=\"matrix(.563 0 0 -.568 -29.215 475.753)\"><stop offset=\"0\" stop-color=\"#FFD43B\"/><stop offset=\"1\" stop-color=\"#FFE873\"/></linearGradient><path fill=\"url(#b)\" d=\"M26.349 53.625v3.329c0 2.58-2.188 4.752-4.683 4.752h-7.488c-2.051 0-3.748 1.756-3.748 3.81v7.139c0 2.03 1.767 3.227 3.748 3.809 2.373.698 4.648.824 7.488 0 1.887-.546 3.748-1.646 3.748-3.809v-2.857h-7.488v-.952h11.236c2.179 0 2.991-1.52 3.749-3.801.782-2.348.749-4.606 0-7.619-.539-2.168-1.567-3.8-3.749-3.8h-2.813zm-4.212 18.077c.777 0 1.407.636 1.407 1.424a1.42 1.42 0 0 1-1.407 1.432c-.774 0-1.406-.642-1.406-1.432 0-.788.632-1.424 1.406-1.424z\"/><radialGradient id=\"c\" cx=\"1368.324\" cy=\"340.26\" r=\"8.119\" gradientTransform=\"matrix(0 -.24 -1.055 0 376.883 409.576)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#B8B8B8\" stop-opacity=\".498\"/><stop offset=\"1\" stop-color=\"#7F7F7F\" stop-opacity=\"0\"/></radialGradient><path opacity=\".444\" fill=\"url(#c)\" d=\"M28.057 81.315c0 1.075-4.498 1.948-10.045 1.948-5.548 0-10.046-.873-10.046-1.948 0-1.076 4.498-1.948 10.046-1.948 5.548 0 10.045.872 10.045 1.948z\"/></svg>"

/***/ }),

/***/ "../src/components/python/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PythonOriginalWordmark = __webpack_require__("../src/components/python/original-wordmark/PythonOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PythonOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/python/original/PythonOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PythonOriginal = __webpack_require__("../src/components/python/original/PythonOriginal.svg");
	
	var _PythonOriginal2 = _interopRequireDefault(_PythonOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PythonOriginal */
	function PythonOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PythonOriginal',
	    svg: _PythonOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PythonOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PythonOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/python/original/PythonOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"70.252\" y1=\"1237.476\" x2=\"170.659\" y2=\"1151.089\" gradientTransform=\"matrix(.563 0 0 -.568 -29.215 707.817)\"><stop offset=\"0\" stop-color=\"#5A9FD4\"/><stop offset=\"1\" stop-color=\"#306998\"/></linearGradient><path fill=\"url(#a)\" d=\"M63.391 1.988c-4.222.02-8.252.379-11.8 1.007-10.45 1.846-12.346 5.71-12.346 12.837v9.411h24.693v3.137H29.977c-7.176 0-13.46 4.313-15.426 12.521-2.268 9.405-2.368 15.275 0 25.096 1.755 7.311 5.947 12.519 13.124 12.519h8.491V67.234c0-8.151 7.051-15.34 15.426-15.34h24.665c6.866 0 12.346-5.654 12.346-12.548V15.833c0-6.693-5.646-11.72-12.346-12.837-4.244-.706-8.645-1.027-12.866-1.008zM50.037 9.557c2.55 0 4.634 2.117 4.634 4.721 0 2.593-2.083 4.69-4.634 4.69-2.56 0-4.633-2.097-4.633-4.69-.001-2.604 2.073-4.721 4.633-4.721z\"/><linearGradient id=\"b\" gradientUnits=\"userSpaceOnUse\" x1=\"209.474\" y1=\"1098.811\" x2=\"173.62\" y2=\"1149.537\" gradientTransform=\"matrix(.563 0 0 -.568 -29.215 707.817)\"><stop offset=\"0\" stop-color=\"#FFD43B\"/><stop offset=\"1\" stop-color=\"#FFE873\"/></linearGradient><path fill=\"url(#b)\" d=\"M91.682 28.38v10.966c0 8.5-7.208 15.655-15.426 15.655H51.591c-6.756 0-12.346 5.783-12.346 12.549v23.515c0 6.691 5.818 10.628 12.346 12.547 7.816 2.297 15.312 2.713 24.665 0 6.216-1.801 12.346-5.423 12.346-12.547v-9.412H63.938v-3.138h37.012c7.176 0 9.852-5.005 12.348-12.519 2.578-7.735 2.467-15.174 0-25.096-1.774-7.145-5.161-12.521-12.348-12.521h-9.268zM77.809 87.927c2.561 0 4.634 2.097 4.634 4.692 0 2.602-2.074 4.719-4.634 4.719-2.55 0-4.633-2.117-4.633-4.719 0-2.595 2.083-4.692 4.633-4.692z\"/><radialGradient id=\"c\" cx=\"1825.678\" cy=\"444.45\" r=\"26.743\" gradientTransform=\"matrix(0 -.24 -1.055 0 532.979 557.576)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#B8B8B8\" stop-opacity=\".498\"/><stop offset=\"1\" stop-color=\"#7F7F7F\" stop-opacity=\"0\"/></radialGradient><path opacity=\".444\" fill=\"url(#c)\" d=\"M97.309 119.597c0 3.543-14.816 6.416-33.091 6.416-18.276 0-33.092-2.873-33.092-6.416 0-3.544 14.815-6.417 33.092-6.417 18.275 0 33.091 2.872 33.091 6.417z\"/></svg>"

/***/ }),

/***/ "../src/components/python/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PythonOriginal = __webpack_require__("../src/components/python/original/PythonOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PythonOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/python/plain-wordmark/PythonPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PythonPlainWordmark = __webpack_require__("../src/components/python/plain-wordmark/PythonPlainWordmark.svg");
	
	var _PythonPlainWordmark2 = _interopRequireDefault(_PythonPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PythonPlainWordmark */
	function PythonPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PythonPlainWordmark',
	    svg: _PythonPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PythonPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PythonPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/python/plain-wordmark/PythonPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#FFD845\" d=\"M40 68V57.921C40 50.948 46.218 45 53.383 45h21.102C80.359 45 84 39.96 84 34.062V13.945c0-5.726-4.306-10.026-10.04-10.981a62.801 62.801 0 0 0-10.743-.862c-3.611.017-7.339.324-10.374.862C43.902 4.542 42 7.848 42 13.945V22h21v3H34.891c-6.14 0-11.516 3.53-13.198 10.552-1.939 8.047-2.025 13.202 0 21.605C23.195 63.411 26.782 68 32.921 68H40zm12.054-51.372c-2.19 0-3.964-1.795-3.964-4.013 0-2.229 1.773-4.039 3.964-4.039 2.182 0 3.964 1.811 3.964 4.039 0 2.218-1.782 4.013-3.964 4.013zm54.121 18.924C104.658 29.438 101.759 25 95.612 25H87v9.062C87 41.335 81.516 48 74.485 48H53.383C47.603 48 42 52.403 42 58.193V78.31c0 5.725 5.388 9.093 10.974 10.734 6.686 1.967 12.781 2.322 20.782 0C79.074 87.504 84 84.406 84 78.31V71H63v-3h32.611c6.14 0 8.428-4.416 10.563-10.843 2.206-6.618 2.112-13.115.001-21.605zM75.814 75.625c2.19 0 3.965 1.795 3.965 4.015 0 2.227-1.774 4.037-3.965 4.037-2.182 0-3.963-1.811-3.963-4.037 0-2.22 1.781-4.015 3.963-4.015zM34.911 112.049c0-3.757-1.072-5.686-3.214-5.791a6.03 6.03 0 0 0-2.495.409c-.646.231-1.082.461-1.311.692v8.968c1.371.86 2.588 1.26 3.649 1.197 2.247-.148 3.371-1.971 3.371-5.475zm2.643.157c0 1.909-.447 3.493-1.348 4.753-1.003 1.427-2.394 2.16-4.172 2.201-1.34.043-2.721-.378-4.142-1.258v8.151l-2.298-.82V107.14c.377-.462.862-.859 1.451-1.196 1.368-.798 3.031-1.207 4.987-1.228l.033.032c1.788-.022 3.166.712 4.134 2.201.902 1.366 1.355 3.117 1.355 5.257zM51.603 117.555c0 2.56-.257 4.333-.77 5.318-.516.986-1.497 1.773-2.945 2.359-1.174.463-2.444.714-3.808.757l-.38-1.448c1.386-.188 2.362-.378 2.928-.566 1.114-.377 1.878-.955 2.298-1.73.337-.631.503-1.835.503-3.618v-.599a11.809 11.809 0 0 1-4.941 1.068c-1.132 0-2.13-.354-2.99-1.068-.966-.777-1.449-1.764-1.449-2.958v-9.566l2.299-.787v9.63c0 1.028.332 1.82.996 2.376s1.524.822 2.578.803c1.054-.022 2.183-.431 3.382-1.228v-11.234h2.299v12.491zM60.576 119.034a9.457 9.457 0 0 1-.757.032c-1.3 0-2.314-.309-3.038-.93-.722-.622-1.084-1.479-1.084-2.573v-9.054h-1.574v-1.446h1.574v-3.84l2.296-.817v4.657h2.583v1.446h-2.583v8.991c0 .862.231 1.474.694 1.83.397.295 1.029.463 1.889.506v1.198zM74.493 118.845h-2.298v-8.873c0-.902-.211-1.68-.631-2.329-.485-.734-1.159-1.102-2.024-1.102-1.054 0-2.372.556-3.954 1.668v10.636h-2.298V97.637l2.298-.725v9.659c1.469-1.068 3.073-1.604 4.816-1.604 1.218 0 2.203.41 2.958 1.228.757.817 1.134 1.836 1.134 3.053v9.597h-.001zM86.711 111.688c0-1.444-.274-2.636-.82-3.579-.649-1.149-1.657-1.756-3.021-1.818-2.52.146-3.778 1.951-3.778 5.412 0 1.587.262 2.912.79 3.976.674 1.356 1.685 2.024 3.033 2.002 2.531-.02 3.796-2.017 3.796-5.993zm2.518.015c0 2.055-.526 3.765-1.575 5.131-1.154 1.528-2.749 2.296-4.783 2.296-2.017 0-3.589-.768-4.723-2.296-1.028-1.366-1.542-3.076-1.542-5.131 0-1.932.556-3.556 1.668-4.879 1.174-1.403 2.718-2.107 4.627-2.107 1.909 0 3.463.704 4.66 2.107 1.111 1.323 1.668 2.947 1.668 4.879zM102.407 118.845h-2.299v-9.376c0-1.028-.31-1.831-.928-2.409-.619-.576-1.443-.855-2.472-.833-1.091.021-2.13.378-3.116 1.069v11.549h-2.299v-11.833c1.323-.963 2.54-1.592 3.652-1.886 1.049-.274 1.974-.41 2.771-.41.545 0 1.059.053 1.542.158.903.209 1.637.596 2.203 1.164.631.629.946 1.384.946 2.267v10.54z\"/></svg>"

/***/ }),

/***/ "../src/components/python/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PythonPlainWordmark = __webpack_require__("../src/components/python/plain-wordmark/PythonPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PythonPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/python/plain/PythonPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _PythonPlain = __webpack_require__("../src/components/python/plain/PythonPlain.svg");
	
	var _PythonPlain2 = _interopRequireDefault(_PythonPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** PythonPlain */
	function PythonPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'PythonPlain',
	    svg: _PythonPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	PythonPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = PythonPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/python/plain/PythonPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#FFD845\" d=\"M49.33 62h29.159C86.606 62 93 55.132 93 46.981V19.183c0-7.912-6.632-13.856-14.555-15.176-5.014-.835-10.195-1.215-15.187-1.191-4.99.023-9.612.448-13.805 1.191C37.098 6.188 35 10.758 35 19.183V30h29v4H23.776c-8.484 0-15.914 5.108-18.237 14.811-2.681 11.12-2.8 17.919 0 29.53C7.614 86.983 12.569 93 21.054 93H31V79.952C31 70.315 39.428 62 49.33 62zm-1.838-39.11c-3.026 0-5.478-2.479-5.478-5.545 0-3.079 2.451-5.581 5.478-5.581 3.015 0 5.479 2.502 5.479 5.581-.001 3.066-2.465 5.545-5.479 5.545zm74.789 25.921C120.183 40.363 116.178 34 107.682 34H97v12.981C97 57.031 88.206 65 78.489 65H49.33C41.342 65 35 72.326 35 80.326v27.8c0 7.91 6.745 12.564 14.462 14.834 9.242 2.717 17.994 3.208 29.051 0C85.862 120.831 93 116.549 93 108.126V97H64v-4h43.682c8.484 0 11.647-5.776 14.599-14.66 3.047-9.145 2.916-17.799 0-29.529zm-41.955 55.606c3.027 0 5.479 2.479 5.479 5.547 0 3.076-2.451 5.579-5.479 5.579-3.015 0-5.478-2.502-5.478-5.579 0-3.068 2.463-5.547 5.478-5.547z\"/></svg>"

/***/ }),

/***/ "../src/components/python/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PythonPlain = __webpack_require__("../src/components/python/plain/PythonPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PythonPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rails/original-wordmark/RailsOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RailsOriginalWordmark = __webpack_require__("../src/components/rails/original-wordmark/RailsOriginalWordmark.svg");
	
	var _RailsOriginalWordmark2 = _interopRequireDefault(_RailsOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RailsOriginalWordmark */
	function RailsOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RailsOriginalWordmark',
	    svg: _RailsOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RailsOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RailsOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rails/original-wordmark/RailsOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#A62C39\" d=\"M17.444 125.054s.188-29.538.188-59.564c0-58.159-4.901-62.491 21.194-62.491h72.635v83.889c0 27.615 5.162 38.433-23.859 38.433-29.021.001-70.158-.267-70.158-.267z\"/><g transform=\"translate(-273.273 -435.955)\"><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"681.437\" y1=\"2170.426\" x2=\"703.949\" y2=\"2182.218\" gradientTransform=\"matrix(1 0 0 -1 -320.773 2656.956)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#C0815E\"/></linearGradient><path fill=\"url(#a)\" d=\"M350.603 449.926s4.655.932 8.688 7.757c4.034 6.826 25.444 59.886 25.444 59.886v-43.131l-19.858-32.27 5.585 6.827 10.55-8.689-13.653-.93-16.756 10.55z\"/></g><g transform=\"translate(-273.273 -435.955)\"><radialGradient id=\"b\" cx=\"668.118\" cy=\"1679.3\" r=\"38.406\" gradientTransform=\"matrix(1 0 0 -1.582 -320.773 3155.877)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"1\" stop-color=\"#A94436\"/></radialGradient><path opacity=\".668\" fill=\"url(#b)\" d=\"M309.335 439.686s30.719 20.479 45.613 24.513a4339.783 4339.783 0 0 1 30.408 8.378l-35.373 86.88 15.204.621 19.86-49.026-.622-71.676-75.09.31z\"/><path fill=\"#fff\" fill-opacity=\".44\" d=\"M337.881 531.221l31.956 30.733-59.571-1.256s-1.861-18.927-1.241-28.856l3.723-9.929 25.133 9.308z\"/></g><path fill-opacity=\".362\" d=\"M94.085 125.365L65.229 95.577l-26.375-9.929-20.479-45.612L40.096 3.732l-14.584-.621-5.896 5.586-2.172 4.344-1.552 112.945 78.193-.621z\"/><path opacity=\".5\" fill=\"#83222D\" d=\"M111.773 77.89S82.606 87.199 65.23 95.887c-17.376 8.688-26.685 29.787-26.685 29.787s37.234-1.861 51.197-1.241c13.963.621 20.479.621 21.72-18.927 1.241-19.548.311-27.616.311-27.616z\"/><g fill=\"#fff\"><path d=\"M26.435 96.422v18.326h4.674v-4.773l4.254 4.254h7.172l-5.688-5.688s4.093-.067 4.402-5.984c0-5.43-4.097-6.134-8.83-6.134h-5.984zm4.897 4.971h4.031v3.265h-4.031v-3.265zM51.562 96.496c-2.559-.015-6.108.223-6.108 5.045v12.737h4.797v-3.116h4.65v3.042h4.822V100.85c0-4.189-4.654-4.353-7.147-4.353l-1.014-.001zm-1.237 4.6h4.501v5.021h-4.501v-5.021zM64.531 96.507h4.964v17.531h-4.964zM74.692 96.741v17.531h11.947v-4.654H79.58V96.663l-4.888.078zM102.463 96.585v4.732h-7.99v1.707h3.413c1.785 0 5.508-.077 5.508 5.508s-2.561 5.896-7.758 5.896h-6.283v-4.267h7.214c2.172 0 2.292-.708 2.292-1.324 0-.615-1.11-.902-3.369-.902s-6.447-1.11-6.447-5.454 2.172-5.973 6.516-5.973c4.345-.001 6.904.077 6.904.077z\"/></g><g fill=\"#fff\"><path d=\"M30.787 91.233h41.269S62.902 70.444 65.23 51.36c2.326-19.082 17.376-27.771 25.909-28.702 8.533-.931 13.187 4.344 13.187 4.344l1.861-2.792S93.931 11.798 78.416 13.195C62.902 14.59 52.197 24.83 45.526 37.241c-6.671 12.412-10.55 21.101-13.188 34.132-2.637 13.033-1.551 19.86-1.551 19.86zM22.565 70.444l8.066.62-1.396 8.068-7.602-.931.932-7.757zM35.286 53.377l2.172-6.05-7.137-2.793-2.327 6.516 7.292 2.327zM45.37 32.588l4.189-4.965-5.43-3.568-4.343 4.81 5.584 3.723zM56.385 13.351l3.724 4.499 5.12-2.947-3.724-4.189-5.12 2.637zM74.538 8.231l.93 4.499 6.361-.155-.62-4.034-6.671-.31z\"/><path d=\"M96.102 13.04l-.155 2.792 4.343 2.328.931-1.396-5.119-3.724zM95.172 24.986v2.327l4.189.465v-1.861l-4.189-.931zM81.829 27.002l2.017 3.724 2.948-2.327-.621-2.482-4.344 1.085zM75.468 31.812l3.103 4.655-1.862 3.257-4.499-4.965 3.258-2.947zM69.262 44.69l-2.017 4.033 5.275 4.5 1.241-5.121-4.499-3.412zM67.09 58.807l-.31 5.43 6.516 2.792-.311-5.119-5.895-3.103zM68.952 78.045l1.552 5.586 8.223.465-2.949-6.051h-6.826z\"/></g><path stroke=\"#5E000E\" stroke-width=\"3\" d=\"M17.444 125.054s.188-29.538.188-59.564c0-58.159-4.901-62.491 21.194-62.491h72.635v83.889c0 27.615 3.921 38.433-23.859 38.433-27.78.001-70.158-.267-70.158-.267z\" fill=\"none\"/></svg>"

/***/ }),

/***/ "../src/components/rails/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RailsOriginalWordmark = __webpack_require__("../src/components/rails/original-wordmark/RailsOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RailsOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rails/plain-wordmark/RailsPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RailsPlainWordmark = __webpack_require__("../src/components/rails/plain-wordmark/RailsPlainWordmark.svg");
	
	var _RailsPlainWordmark2 = _interopRequireDefault(_RailsPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RailsPlainWordmark */
	function RailsPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RailsPlainWordmark',
	    svg: _RailsPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RailsPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RailsPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rails/plain-wordmark/RailsPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#A62C46\"><path d=\"M18.922 104.532V126h5.476v-5.591l4.983 4.983h8.402l-6.664-6.664s4.795-.078 5.157-7.01c0-6.361-4.8-7.186-10.343-7.186h-7.011zm5.737 5.824h4.722v3.824h-4.722v-3.824zM48.358 104.619c-2.997-.017-7.155.261-7.155 5.911v14.92h5.62v-3.65h5.447v3.563h5.649v-15.644c0-4.907-5.452-5.1-8.373-5.1h-1.188zm-1.449 5.388h5.273v5.882h-5.273v-5.882zM63.55 104.632h5.815v20.537H63.55zM75.454 104.905v20.537h13.995v-5.452H81.18v-15.175l-5.726.09zM107.986 104.722v5.543h-9.36v1.999h3.999s6.453-.09 6.453 6.452c0 6.543-3 6.907-9.088 6.907h-7.36v-4.998h8.451c2.544 0 2.685-.829 2.685-1.551 0-.721-1.3-1.056-3.946-1.056s-7.553-1.301-7.553-6.389c0-5.089 2.545-6.998 7.633-6.998 5.088.001 8.086.091 8.086.091z\"/></g><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#A62C46\" d=\"M100.556 10.818c-9.749-4.811-19.734-5.3-29.958-1.687-9.408 3.326-16.913 9.277-22.491 17.381-9.44 13.716-16.296 28.682-20.141 44.938-1.966 8.322-3.241 16.304-2.898 24.897.028.698.131 1.653.2 1.653h48.214c-.137 0-.229-.288-.348-.593-2.536-6.475-4.545-12.891-5.933-19.705-1.995-9.784-3.039-19.541-.979-29.416 2.884-13.829 10.767-23.702 24.055-28.873 7.527-2.932 14.67-2.044 20.937 3.455.058.051.175.048.328.073l2.05-3.087c-3.946-3.758-8.282-6.69-13.036-9.036zM25.067 75.154l-9.45-.714-1.07 9.146 8.891 1.068 1.629-9.5zm8.002-28.019c-2.889-1.129-5.58-2.183-8.363-3.273-.928 2.638-1.794 5.093-2.704 7.675l8.524 2.731 2.543-7.133zm39.473 42.858c2.855.212 5.716.36 8.867.543-1.145-2.379-2.16-4.53-3.226-6.657-.116-.231-.51-.454-.777-.458-2.422-.035-4.847-.021-7.421-.021.579 2.1 1.084 4.035 1.674 5.945.088.288.563.624.883.648zM47.243 23.889l-6.353-4.207-5.08 5.675 6.532 4.39 4.901-5.858zm20.234 42.626c-.009.257.222.665.446.767 2.289 1.028 4.601 2.008 7.119 3.093-.105-1.99-.176-3.654-.294-5.314-.022-.298-.163-.729-.384-.852-2.101-1.164-4.231-2.274-6.562-3.51-.128 2.129-.257 3.97-.325 5.816zM65.595 8.871l-4.35-4.936-5.989 3.113 4.356 5.307 5.983-3.484zm2.728 39.277c-.129.3.043.932.298 1.163 1.737 1.567 3.534 3.066 5.532 4.777.458-1.917.889-3.625 1.255-5.345.065-.307-.025-.813-.238-.983-1.555-1.254-3.159-2.446-4.822-3.716-.731 1.451-1.439 2.751-2.025 4.104zm9.944-41.872c2.22.062 4.443.034 6.788.034-.234-1.632-.345-2.87-.624-4.067-.083-.355-.621-.831-.982-.86-2.225-.181-4.46-.25-6.91-.367.327 1.647.576 3.099.928 4.526.076.304.518.728.8.734zm2.704 28.494c.113-.212.142-.598.023-.784-1.092-1.706-2.224-3.387-3.398-5.154l-3.803 3.491 5.259 5.827c.705-1.23 1.337-2.292 1.919-3.38zm4.1-11.602c.808 1.499 1.54 2.858 2.271 4.219 3.553-1.946 3.894-2.653 2.635-5.458l-4.906 1.239zm17.002-12.997c1.479.912 3.04 1.688 4.627 2.544l1.062-1.654-5.921-4.334c-.082.881-.206 1.499-.174 2.106.025.465.104 1.151.406 1.338zM106 21.868c-3-.351-4-.698-6-1.058v2.714c2 .173 3 .339 6 .513v-2.169z\"/></svg>"

/***/ }),

/***/ "../src/components/rails/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RailsPlainWordmark = __webpack_require__("../src/components/rails/plain-wordmark/RailsPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RailsPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rails/plain/RailsPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RailsPlain = __webpack_require__("../src/components/rails/plain/RailsPlain.svg");
	
	var _RailsPlain2 = _interopRequireDefault(_RailsPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RailsPlain */
	function RailsPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RailsPlain',
	    svg: _RailsPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RailsPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RailsPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rails/plain/RailsPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#A62C46\" d=\"M109.682 14.737c-12.206-6.023-24.708-6.636-37.508-2.111-11.779 4.164-21.175 11.615-28.16 21.763C32.195 51.561 23.61 70.298 18.799 90.652c-2.464 10.417-4.06 21.466-3.631 32.224.035.873.165 1.124.251 3.124h60.366c-.173-2-.287-1.416-.437-1.797a153.86 153.86 0 0 1-7.428-25.198c-2.498-12.251-3.806-24.729-1.226-37.093 3.611-17.313 13.48-29.805 30.117-36.283 9.424-3.667 18.369-2.624 26.214 4.262.072.063.22.025.412.056l2.565-3.883c-4.94-4.703-10.368-8.389-16.32-11.327zM3.336 94.394c-.46 3.923-.89 7.596-1.34 11.451l11.132 1.336 2.039-11.893-11.831-.894zm21.85-34.186l-10.471-4.097-3.384 9.607 10.671 3.42c1.08-3.031 2.096-5.882 3.184-8.93zm49.419 53.659c3.575.266 7.157.449 11.103.679-1.433-2.979-2.706-5.673-4.039-8.335-.146-.289-.639-.568-.974-.573-3.033-.044-6.068-.025-9.291-.025.726 2.628 1.357 5.053 2.096 7.443.111.361.707.782 1.105.811zM42.933 31.103l-7.955-5.268-6.359 7.105 8.178 5.496 6.136-7.333zm25.334 53.369c-.013.321.276.832.558.959 2.865 1.288 5.76 2.515 8.912 3.873-.131-2.492-.219-4.575-.368-6.654-.027-.374-.203-.912-.48-1.066-2.631-1.456-5.299-2.847-8.216-4.395-.159 2.665-.321 4.972-.406 7.283zM65.91 12.3l-5.446-6.181-7.499 3.898 5.455 6.644 7.49-4.361zm3.415 49.176c-.163.374.052 1.167.373 1.456 2.175 1.962 4.424 3.84 6.926 5.981.573-2.4 1.113-4.539 1.571-6.693.081-.383-.032-1.016-.298-1.23-1.946-1.569-3.955-3.063-6.037-4.651-.915 1.815-1.802 3.443-2.535 5.137zm12.45-52.424c2.78.075 5.563.042 8.499.042-.293-2.044-.433-3.593-.782-5.092-.104-.446-.775-1.04-1.228-1.078-2.787-.226-5.585-.313-8.651-.459.409 2.063.721 3.881 1.162 5.668.093.379.647.909 1 .919zm3.385 35.675c.142-.266.178-.749.029-.981-1.366-2.137-2.785-4.241-4.254-6.455l-4.76 4.372 6.582 7.294c.884-1.539 1.675-2.868 2.403-4.23zM90.295 30.2l2.843 5.281c4.449-2.438 4.875-3.32 3.3-6.834L90.295 30.2zm21.287-16.273c1.851 1.142 3.806 2.115 5.792 3.185l1.33-2.07c-2.422-1.771-4.76-3.484-7.413-5.426-.104 1.104-.259 1.875-.219 2.637.032.581.129 1.44.51 1.674zM109 30.646c2 .217 5 .424 7 .643v-2.718c-2-.438-5-.872-7-1.323v3.398z\"/></svg>"

/***/ }),

/***/ "../src/components/rails/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RailsPlain = __webpack_require__("../src/components/rails/plain/RailsPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RailsPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/react/original-wordmark/ReactOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ReactOriginalWordmark = __webpack_require__("../src/components/react/original-wordmark/ReactOriginalWordmark.svg");
	
	var _ReactOriginalWordmark2 = _interopRequireDefault(_ReactOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ReactOriginalWordmark */
	function ReactOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ReactOriginalWordmark',
	    svg: _ReactOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ReactOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ReactOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/react/original-wordmark/ReactOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#61DAFB\"><circle cx=\"64\" cy=\"47.5\" r=\"9.3\"/><path d=\"M64 81.7C71.3 88.8 78.5 93 84.3 93c1.9 0 3.7-.4 5.2-1.3 5.2-3 7.1-10.5 5.3-21.2-.3-1.9-.7-3.8-1.2-5.8 2-.6 3.8-1.2 5.6-1.8 10.1-3.9 15.7-9.3 15.7-15.2 0-6-5.6-11.4-15.7-15.2-1.8-.7-3.6-1.3-5.6-1.8.5-2 .9-3.9 1.2-5.8 1.7-10.9-.2-18.5-5.4-21.5-1.5-.9-3.3-1.3-5.2-1.3-5.7 0-13 4.2-20.3 11.3C56.7 6.3 49.5 2.1 43.7 2.1c-1.9 0-3.7.4-5.2 1.3-5.2 3-7.1 10.5-5.3 21.2.3 1.9.7 3.8 1.2 5.8-2 .6-3.8 1.2-5.6 1.8-10.1 3.9-15.7 9.3-15.7 15.2 0 6 5.6 11.4 15.7 15.2 1.8.7 3.6 1.3 5.6 1.8-.5 2-.9 3.9-1.2 5.8-1.7 10.7.2 18.3 5.3 21.2 1.5.9 3.3 1.3 5.2 1.3 5.8.2 13-4 20.3-11zm-5.6-13.5c1.8.1 3.7.1 5.6.1 1.9 0 3.8 0 5.6-.1-1.8 2.4-3.7 4.6-5.6 6.7-1.9-2.1-3.8-4.3-5.6-6.7zM46 57.9c1 1.7 1.9 3.3 3 4.9-3.1-.4-6-.9-8.8-1.5.9-2.7 1.9-5.5 3.1-8.3.8 1.6 1.7 3.3 2.7 4.9zm-5.8-24.1c2.8-.6 5.7-1.1 8.8-1.5-1 1.6-2 3.2-3 4.9-1 1.7-1.9 3.3-2.7 5-1.3-2.9-2.3-5.7-3.1-8.4zm5.5 13.7c1.3-2.7 2.7-5.4 4.3-8.1 1.5-2.6 3.2-5.2 4.9-7.8 3-.2 6-.3 9.1-.3 3.2 0 6.2.1 9.1.3 1.8 2.6 3.4 5.2 4.9 7.8 1.6 2.7 3 5.4 4.3 8.1-1.3 2.7-2.7 5.4-4.3 8.1-1.5 2.6-3.2 5.2-4.9 7.8-3 .2-6 .3-9.1.3-3.2 0-6.2-.1-9.1-.3-1.8-2.6-3.4-5.2-4.9-7.8-1.6-2.7-3-5.4-4.3-8.1zm39.1-5.4l-2.7-5c-1-1.7-1.9-3.3-3-4.9 3.1.4 6 .9 8.8 1.5-.9 2.8-1.9 5.6-3.1 8.4zm0 10.8c1.2 2.8 2.2 5.6 3.1 8.3-2.8.6-5.7 1.1-8.8 1.5 1-1.6 2-3.2 3-4.9.9-1.5 1.8-3.2 2.7-4.9zm2.3 34.7c-.8.5-1.8.7-2.9.7-4.9 0-11-4-17-10 2.9-3.1 5.7-6.6 8.5-10.5 4.7-.4 9.2-1.1 13.4-2.1.5 1.8.8 3.6 1.1 5.4 1.4 8.5.3 14.6-3.1 16.5zm5.2-52.7c11.2 3.2 17.9 8.1 17.9 12.6 0 3.9-4.6 7.8-12.7 10.9-1.6.6-3.4 1.2-5.2 1.7-1.3-4.1-2.9-8.3-4.9-12.6 2-4.3 3.7-8.5 4.9-12.6zm-8-28.2c1.1 0 2 .2 2.9.7 3.3 1.9 4.5 7.9 3.1 16.5-.3 1.7-.7 3.5-1.1 5.4-4.2-.9-8.7-1.6-13.4-2.1-2.7-3.9-5.6-7.4-8.5-10.5 6-5.9 12.1-10 17-10zM69.6 26.8c-1.8-.1-3.7-.1-5.6-.1s-3.8 0-5.6.1c1.8-2.4 3.7-4.6 5.6-6.7 1.9 2.1 3.8 4.4 5.6 6.7zM40.9 7.4c.8-.5 1.8-.7 2.9-.7 4.9 0 11 4 17 10-2.9 3.1-5.7 6.6-8.5 10.5-4.7.4-9.2 1.1-13.4 2.1-.5-1.8-.8-3.6-1.1-5.4-1.4-8.5-.3-14.5 3.1-16.5zm-5.2 52.7C24.5 56.9 17.8 52 17.8 47.5c0-3.9 4.6-7.8 12.7-10.9 1.6-.6 3.4-1.2 5.2-1.7 1.3 4.1 2.9 8.3 4.9 12.6-2 4.3-3.7 8.6-4.9 12.6zm2.1 11c.3-1.7.7-3.5 1.1-5.4 4.2.9 8.7 1.6 13.4 2.1 2.7 3.9 5.6 7.4 8.5 10.5-6 5.9-12.1 10-17 10-1.1 0-2-.2-2.9-.7-3.4-1.9-4.5-8-3.1-16.5zm-4.2 41.2c2.2-2.7 2.3-5.7 1.1-8.7-1.2-3-3.7-4.4-6.8-4.5-3.7-.1-7.5 0-11.2 0H16V125h3v-9.8h4.7c.6 0 1.1.2 1.4.7l6 9.3c.1.2.4.5.6.5h3.9c-2.4-3.7-4.7-7.2-7.1-10.8 2.1-.3 3.9-1 5.1-2.6zm-14.6-.2v-9.9h1.1c2.3 0 4.7-.1 7 .1 2.7.1 4.6 2.2 4.6 4.9s-2.2 4.8-4.9 4.9c-2.4.1-4.8 0-7.8 0zm38.7 1.3c-1.6-7-8-8.8-12.9-6.6-3.8 1.7-5.5 5-5.6 9.1-.1 3.1.8 5.9 3.2 8 2.7 2.4 6 2.7 9.4 2.1 1.9-.4 3.6-1.3 4.9-2.7-.5-.7-1-1.4-1.5-2-2.8 2.4-5.9 3.2-9.3 1.6-2.2-1.1-3.3-3.8-3.5-5.8h15.5v-1.3c.1-.9 0-1.7-.2-2.4zM42.6 115c-.3-3 2.7-6.2 6-6.2 3.8-.1 6.2 2.2 6.3 6.2H42.6zm30.7-8.7c-1.5-.3-3.1-.4-4.6-.3-2.4.2-4.5 1.3-6.2 3.1.5.7.9 1.4 1.5 2.2.2-.2.4-.4.6-.5 1.6-1.5 3.5-2.3 5.8-2.1 1.8.1 3.5.7 4 2.5.4 1.4.3 2.9.4 4.4-.3 0-.4-.1-.5-.2-2.4-2-5.1-2.4-8-1.7-2.7.7-4.4 2.8-4.6 5.5-.2 3.1 1.2 5.4 3.9 6.5 1.7.7 3.6.7 5.4.3 1.4-.3 2-1.1 4-2.2v1.3h2.8c0-4 .1-8.9 0-13.5 0-2.9-1.7-4.7-4.5-5.3zm1.4 12.6c-.1.3 0 .6 0 .9 0 2.1-.5 2.8-2.5 3.6-1.4.5-2.9.7-4.4.2-1.7-.5-2.9-2-2.9-3.7-.1-1.7 1-3.4 2.7-3.9 2.3-.8 4.4-.3 6.3 1.1.6.5 1 1 .8 1.8zm15.6-9.9c2.6-.8 5-.3 6.8 1.9l.3.2c.7-.6 1.3-1.2 2.1-1.9-.3-.3-.4-.5-.6-.8-2.9-3.1-8.6-3.5-12.1-1-4.9 3.6-4.8 10.6-2.4 14.3 2.3 3.5 5.6 4.7 9.5 4.2 2.3-.3 4.2-1.4 5.7-3.3-.7-.6-1.4-1.2-2.1-1.9-.2.2-.3.3-.4.5-2.7 3-7.2 2.7-9.6-.5-1.4-1.9-1.7-4.1-1.3-6.3.2-2.5 1.5-4.5 4.1-5.4zm20.8 13.6c-.2.1-.3.2-.3.2-.8.6-1.6.7-2.5.4-.9-.4-1-1.2-1.1-2v-11.4c0-.2 0 .2.1-.8h3.8v-3h-4v-5h-3v5.4h-2.6c-.2 0-.5.2-.5.4-.1.7 0 1.2 0 2.2h3.2v12.8c0 1.6.4 3 1.8 3.8 1.5.9 4.4.7 5.7-.4.2-.1.3-.5.3-.6-.3-.6-.6-1.3-.9-2z\"/></g></svg>"

/***/ }),

/***/ "../src/components/react/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ReactOriginalWordmark = __webpack_require__("../src/components/react/original-wordmark/ReactOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ReactOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/react/original/ReactOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ReactOriginal = __webpack_require__("../src/components/react/original/ReactOriginal.svg");
	
	var _ReactOriginal2 = _interopRequireDefault(_ReactOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ReactOriginal */
	function ReactOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ReactOriginal',
	    svg: _ReactOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ReactOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ReactOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/react/original/ReactOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#61DAFB\"><circle cx=\"64\" cy=\"64\" r=\"11.4\"/><path d=\"M107.3 45.2c-2.2-.8-4.5-1.6-6.9-2.3.6-2.4 1.1-4.8 1.5-7.1 2.1-13.2-.2-22.5-6.6-26.1-1.9-1.1-4-1.6-6.4-1.6-7 0-15.9 5.2-24.9 13.9-9-8.7-17.9-13.9-24.9-13.9-2.4 0-4.5.5-6.4 1.6-6.4 3.7-8.7 13-6.6 26.1.4 2.3.9 4.7 1.5 7.1-2.4.7-4.7 1.4-6.9 2.3C8.2 50 1.4 56.6 1.4 64s6.9 14 19.3 18.8c2.2.8 4.5 1.6 6.9 2.3-.6 2.4-1.1 4.8-1.5 7.1-2.1 13.2.2 22.5 6.6 26.1 1.9 1.1 4 1.6 6.4 1.6 7.1 0 16-5.2 24.9-13.9 9 8.7 17.9 13.9 24.9 13.9 2.4 0 4.5-.5 6.4-1.6 6.4-3.7 8.7-13 6.6-26.1-.4-2.3-.9-4.7-1.5-7.1 2.4-.7 4.7-1.4 6.9-2.3 12.5-4.8 19.3-11.4 19.3-18.8s-6.8-14-19.3-18.8zM92.5 14.7c4.1 2.4 5.5 9.8 3.8 20.3-.3 2.1-.8 4.3-1.4 6.6-5.2-1.2-10.7-2-16.5-2.5-3.4-4.8-6.9-9.1-10.4-13 7.4-7.3 14.9-12.3 21-12.3 1.3 0 2.5.3 3.5.9zM81.3 74c-1.8 3.2-3.9 6.4-6.1 9.6-3.7.3-7.4.4-11.2.4-3.9 0-7.6-.1-11.2-.4-2.2-3.2-4.2-6.4-6-9.6-1.9-3.3-3.7-6.7-5.3-10 1.6-3.3 3.4-6.7 5.3-10 1.8-3.2 3.9-6.4 6.1-9.6 3.7-.3 7.4-.4 11.2-.4 3.9 0 7.6.1 11.2.4 2.2 3.2 4.2 6.4 6 9.6 1.9 3.3 3.7 6.7 5.3 10-1.7 3.3-3.4 6.6-5.3 10zm8.3-3.3c1.5 3.5 2.7 6.9 3.8 10.3-3.4.8-7 1.4-10.8 1.9 1.2-1.9 2.5-3.9 3.6-6 1.2-2.1 2.3-4.2 3.4-6.2zM64 97.8c-2.4-2.6-4.7-5.4-6.9-8.3 2.3.1 4.6.2 6.9.2 2.3 0 4.6-.1 6.9-.2-2.2 2.9-4.5 5.7-6.9 8.3zm-18.6-15c-3.8-.5-7.4-1.1-10.8-1.9 1.1-3.3 2.3-6.8 3.8-10.3 1.1 2 2.2 4.1 3.4 6.1 1.2 2.2 2.4 4.1 3.6 6.1zm-7-25.5c-1.5-3.5-2.7-6.9-3.8-10.3 3.4-.8 7-1.4 10.8-1.9-1.2 1.9-2.5 3.9-3.6 6-1.2 2.1-2.3 4.2-3.4 6.2zM64 30.2c2.4 2.6 4.7 5.4 6.9 8.3-2.3-.1-4.6-.2-6.9-.2-2.3 0-4.6.1-6.9.2 2.2-2.9 4.5-5.7 6.9-8.3zm22.2 21l-3.6-6c3.8.5 7.4 1.1 10.8 1.9-1.1 3.3-2.3 6.8-3.8 10.3-1.1-2.1-2.2-4.2-3.4-6.2zM31.7 35c-1.7-10.5-.3-17.9 3.8-20.3 1-.6 2.2-.9 3.5-.9 6 0 13.5 4.9 21 12.3-3.5 3.8-7 8.2-10.4 13-5.8.5-11.3 1.4-16.5 2.5-.6-2.3-1-4.5-1.4-6.6zM7 64c0-4.7 5.7-9.7 15.7-13.4 2-.8 4.2-1.5 6.4-2.1 1.6 5 3.6 10.3 6 15.6-2.4 5.3-4.5 10.5-6 15.5C15.3 75.6 7 69.6 7 64zm28.5 49.3c-4.1-2.4-5.5-9.8-3.8-20.3.3-2.1.8-4.3 1.4-6.6 5.2 1.2 10.7 2 16.5 2.5 3.4 4.8 6.9 9.1 10.4 13-7.4 7.3-14.9 12.3-21 12.3-1.3 0-2.5-.3-3.5-.9zM96.3 93c1.7 10.5.3 17.9-3.8 20.3-1 .6-2.2.9-3.5.9-6 0-13.5-4.9-21-12.3 3.5-3.8 7-8.2 10.4-13 5.8-.5 11.3-1.4 16.5-2.5.6 2.3 1 4.5 1.4 6.6zm9-15.6c-2 .8-4.2 1.5-6.4 2.1-1.6-5-3.6-10.3-6-15.6 2.4-5.3 4.5-10.5 6-15.5 13.8 4 22.1 10 22.1 15.6 0 4.7-5.8 9.7-15.7 13.4z\"/></g></svg>"

/***/ }),

/***/ "../src/components/react/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ReactOriginal = __webpack_require__("../src/components/react/original/ReactOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ReactOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redhat/original-wordmark/RedhatOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RedhatOriginalWordmark = __webpack_require__("../src/components/redhat/original-wordmark/RedhatOriginalWordmark.svg");
	
	var _RedhatOriginalWordmark2 = _interopRequireDefault(_RedhatOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RedhatOriginalWordmark */
	function RedhatOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RedhatOriginalWordmark',
	    svg: _RedhatOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RedhatOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RedhatOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redhat/original-wordmark/RedhatOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#fff\" d=\"M101.2 69.8c-1.7-.4-3.5-.6-5.3-.6-3.1 0-6 .5-8.1 1.4-.2.1-.4.4-.4.6 0 .1 0 .2.1.3.2.7-.2 1.5-2.2 1.9-3 .7-4.9 3.8-6 4.8-1.3 1.2-4.9 2-4.3 1.2.4-.6 2.1-2.3 3-4.2.9-1.7 1.7-2.2 2.8-3.8.3-.5 1.6-2.2 1.9-3.5.4-1.3.3-2.9.4-3.6.2-1 1.1-3.1 1.2-4.2 0-.7-2.8 1-4.1 1-1.3 0-2.7-.8-3.9-.9-1.5-.1-2.4 1.1-3.8.9-.8-.1-1.4-.8-2.8-.8-1.9-.1-4.2 1.1-8.6.9-4.3-.1-8.3-5.5-8.8-6.3-.6-1-1.4-1-2.3-.2-.8.8-1.9.2-2.2-.4-.6-1-2.1-3.9-4.4-4.5-3.2-.8-4.9 1.8-4.7 3.9.2 2.1 1.6 2.7 2.2 3.9.6 1.1 1 1.9 2.2 2.4.9.4 1.2.9.9 1.6-.2.6-1.1.7-1.7.8-1.2.1-2.1-.3-2.7-.7-.7-.5-1.3-1.1-2-2.2-.7-1.2-1.9-1.7-3.3-1.7-.6 0-1.3.2-1.8.4-2.1 1.1-4.7 1.8-7.4 1.8H22c5.9 17.4 22.5 30 42 30 15.6 0 29.3-8.1 37.2-20.2\"/><path d=\"M101.2 69.8c-1.7-.4-3.5-.6-5.3-.6-3.1 0-6 .5-8.1 1.4-.2.1-.4.4-.4.6 0 .1 0 .2.1.3.2.7-.2 1.5-2.2 2-3 .7-4.9 3.8-6 4.8-1.3 1.2-4.9 2-4.3 1.2.4-.6 2.1-2.3 3-4.2.9-1.7 1.7-2.2 2.8-3.8.3-.5 1.6-2.2 1.9-3.5.4-1.3.3-2.9.4-3.6.2-1 1.1-3.1 1.2-4.2 0-.7-2.8 1-4.1 1-1.3 0-2.7-.8-3.9-.9-1.5-.1-2.4 1.1-3.8.9-.8-.1-1.4-.8-2.8-.8-1.9-.1-4.2 1.1-8.6.9-4.3-.1-8.3-5.4-8.8-6.3-.6-1-1.4-1-2.3-.2-.8.8-1.9.2-2.2-.4-.6-1-2.1-3.9-4.4-4.5-3.2-.8-4.9 1.8-4.7 3.9.2 2.1 1.6 2.7 2.2 3.9.6 1.1 1 1.9 2.2 2.4.9.4 1.2.9.9 1.6-.2.6-1.1.7-1.7.8-1.2.1-2.1-.3-2.7-.7-.7-.5-1.3-1.1-2-2.2-.7-1.2-1.9-1.7-3.3-1.7-.6 0-1.3.2-1.8.4-2.1 1.1-4.7 1.8-7.4 1.8H22c-1.5-4.4-2.3-9.2-2.3-14.1C19.7 21.3 39.5 1.5 64 1.5c24.5 0 44.3 19.8 44.3 44.3 0 8.8-2.6 17-7.1 24m-27.4-4.1c.2.2.6 1 .1 1.9-.3.5-.6.9-1.1 1.3-.6.5-1.8 1.1-3.5 0-.9-.6-1-.8-2.2-.6-.9.1-1.2-.8-.9-1.5.3-.7 1.6-1.3 3.3-.4.7.4 1.9 1.3 2.9.5.4-.3.7-.5 1.2-1.2h.2\"/><path fill=\"#E93442\" d=\"M60.6 22.5c-5.1.4-5.6.9-6.6 1.9-1.3 1.4-3.1-1.9-3.1-1.9-1.1-.2-2.4-1.9-1.7-3.6.7-1.6 2-1.1 2.4-.6.4.7 1.4 1.7 2.8 1.7 1.3 0 2.9-.3 5.1-.3 2.2 0 3.7.8 3.7 1.5 0 .6-.2 1.2-2.6 1.3m5.3-8.4c-.1 0-.2-.1-.2-.1 0-.1 0-.1.1-.1 1-.5 2.5-.9 4.2-1.1.5-.1 1-.1 1.5-.1h.3c2.8.1 5.1 1.2 5.1 2.5s-2.4 2.3-5.2 2.3c-.9 0-1.8-.2-2.5-.4-.1 0-.2-.1-.2-.2s.1-.2.2-.2c1.8-.4 3-1.1 2.9-1.7-.1-.8-2.4-1.3-5.2-1-.4 0-.7 0-1 .1M89 33.9c-.4 1.5-1.1 3.3-3.8 4.8-.4.2-.6-.1-.4-.4 1-1.8 1.2-2.2 1.5-2.9.4-1 .7-2.5-.2-5.5-1.7-6-5.1-14-7.7-16.6C76 10.7 71.6 10 67.6 11c-1.5.4-4.3 1.9-9.7.7-9.2-2.1-10.6 2.5-11.1 4.6-.5 2-1.8 7.7-1.8 7.7-.4 2.3-1 6.4 13.4 9.1 6.7 1.3 7 3 7.3 4.2.5 2.2 1.4 3.5 2.3 4.1 1 .6 0 1.2-1.1 1.3-2.8.3-13.3-2.7-19.5-6.2-5.1-3.1-5.2-5.9-4-8.3-7.7-.8-13.5.7-14.5 4.4-1.8 6.2 13.7 16.9 31.4 22.2 18.5 5.6 37.6 1.7 39.7-10 1-5.2-3.5-9.2-11-10.9\"/><path d=\"M1.9 109.8c0-3.2-.1-5.5-.2-7.7H7l.2 4.5h.2c1.2-3.4 4-5.1 6.5-5.1.6 0 .9 0 1.4.1v5.7c-.6-.1-1.1-.2-1.8-.2-2.9 0-4.9 1.8-5.4 4.6-.1.5-.2 1.2-.2 1.8V126h-6v-16.2zm20.7 5.9c.2 4.3 3.5 6.2 7.4 6.2 2.8 0 4.8-.4 6.6-1.1l.9 4.1c-2 .9-4.9 1.5-8.3 1.5-7.7 0-12.3-4.8-12.3-12.1 0-6.6 4-12.8 11.7-12.8 7.7 0 10.3 6.4 10.3 11.6 0 1.1-.1 2-.2 2.6H22.6zm10.4-4.2c0-2.2-.9-5.8-5-5.8-3.7 0-5.3 3.4-5.5 5.8H33zm25.7 4.2c0 .6 0 1.2-.2 1.8-.6 2.6-2.7 4.3-5.2 4.3-3.8 0-6-3.2-6-7.6 0-4.4 2.2-7.8 6-7.8 2.7 0 4.7 1.9 5.2 4.2.1.5.1 1.1.1 1.6.1-.1.1 3.5.1 3.5zm6-22.7l-6-1.7v13.4h-.1c-1.1-1.8-3.4-3.1-6.7-3.1-5.7 0-10.7 4.7-10.7 12.7 0 7.3 4.5 12.2 10.2 12.2 3.4 0 6.3-1.6 7.7-4.3h.1l.3 3.8h5.4c-.1-1.6-.2-4.2-.2-6.7V93zm15.9 8.6c-1.8 0-3.4.5-4.8 1.4-1.4.8-2.6 2.1-3.3 3.4h-.1V95.3l-2.4-.7V126h2.4v-14.6c0-1 .1-1.6.3-2.3 1-3 3.8-5.4 7.2-5.4 4.9 0 6.6 3.9 6.6 8.2V126h2.4v-14.4c0-8.9-6-10-8.3-10M110.1 120.3c0 1.9.1 3.8.3 5.7h-2.2l-.3-3.4h-.1c-1.2 1.8-3.8 4-7.6 4-4.8 0-7-3.4-7-6.6 0-5.5 4.9-8.8 14.6-8.7v-.6c0-2.4-.5-7.1-6.1-7-2.1 0-4.3.6-6 1.8l-.7-1.7c2.2-1.5 4.8-2.1 7-2.1 6.9 0 8.2 5.2 8.2 9.4-.1-.1-.1 9.2-.1 9.2zm-2.4-7c-5.2-.1-12.1.6-12.1 6.4 0 3.4 2.3 5 4.7 5 4 0 6.2-2.5 7.1-4.8.2-.5.2-1 .2-1.4.1-.1.1-5.2.1-5.2zm11.8-16.4v5.3h6.8v1.9h-6.8v15.5c0 3 .9 4.9 3.5 4.9 1.2 0 2.1-.2 2.7-.4l.3 1.8c-.8.3-1.9.6-3.3.6-1.7 0-3.2-.5-4.1-1.7-1.1-1.3-1.4-3.3-1.4-5.7V104h-4v-1.9h4v-4.4l2.3-.8z\"/></svg>"

/***/ }),

/***/ "../src/components/redhat/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RedhatOriginalWordmark = __webpack_require__("../src/components/redhat/original-wordmark/RedhatOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RedhatOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redhat/original/RedhatOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RedhatOriginal = __webpack_require__("../src/components/redhat/original/RedhatOriginal.svg");
	
	var _RedhatOriginal2 = _interopRequireDefault(_RedhatOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RedhatOriginal */
	function RedhatOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RedhatOriginal',
	    svg: _RedhatOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RedhatOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RedhatOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redhat/original/RedhatOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#fff\" d=\"M116.4 97.9c-2.4-.5-5-.9-7.5-.9-4.4 0-8.4.8-11.4 2-.3.2-.6.5-.6.9 0 .1 0 .3.1.4.3 1-.2 2.1-3.1 2.7-4.3.9-6.9 5.3-8.5 6.8-1.8 1.7-6.9 2.8-6.1 1.7.6-.8 2.9-3.3 4.3-6 1.3-2.4 2.4-3.1 3.9-5.4.5-.7 2.2-3 2.7-4.9.6-1.8.4-4.1.6-5.1.3-1.4 1.6-4.3 1.7-6 .1-.9-3.9 1.4-5.8 1.4s-3.7-1.1-5.4-1.2c-2.1-.1-3.4 1.6-5.3 1.3-1.1-.2-2-1.1-3.9-1.2-2.7-.1-6 1.5-12.2 1.3-6.1-.2-11.7-7.7-12.5-8.9-.9-1.4-2-1.4-3.2-.3-1.2 1.1-2.7.2-3.1-.5-.8-1.4-2.9-5.5-6.2-6.3-4.6-1.2-6.9 2.5-6.6 5.5.3 3 2.2 3.8 3.1 5.4.9 1.6 1.4 2.6 3 3.3 1.2.5 1.6 1.2 1.3 2.2-.3.9-1.6 1.1-2.4 1.1-1.7.1-3-.4-3.8-1-1-.7-1.9-1.6-2.8-3.1-1-1.7-2.7-2.5-4.6-2.5-.9 0-1.8.2-2.5.6-3 1.6-6.6 2.5-10.4 2.5H4.9c8.3 24.7 31.7 42.4 59.2 42.4 21.9.3 41.2-11 52.3-28.2\"/><path d=\"M116.4 97.9c-2.4-.6-5-.9-7.5-.9-4.4 0-8.4.8-11.4 2-.3.2-.6.5-.6.9 0 .1 0 .3.1.4.3 1-.2 2.1-3.1 2.8-4.3.9-6.9 5.3-8.5 6.8-1.8 1.7-6.9 2.8-6.1 1.7.6-.8 2.9-3.3 4.3-6 1.3-2.4 2.4-3.1 3.9-5.4.5-.7 2.2-3 2.7-4.9.6-1.8.4-4.1.6-5.1.3-1.4 1.6-4.3 1.7-6 .1-.9-3.9 1.3-5.8 1.3s-3.7-1.1-5.4-1.2c-2.1-.1-3.4 1.6-5.3 1.3-1.1-.2-2-1.1-3.9-1.2-2.7-.1-6 1.5-12.2 1.3-6.1-.2-11.7-7.7-12.5-8.9-.9-1.4-2-1.4-3.2-.3-1.2 1.1-2.7.2-3.1-.5-.8-1.4-2.9-5.5-6.2-6.3-4.6-1.2-6.9 2.5-6.6 5.5.3 3 2.2 3.8 3.1 5.4.9 1.6 1.4 2.6 3 3.3 1.2.5 1.6 1.2 1.3 2.2-.3.9-1.6 1.1-2.4 1.1-1.7.1-3-.4-3.8-1-1-.7-1.9-1.6-2.8-3.1-1-1.7-2.7-2.5-4.6-2.5-.9 0-1.8.2-2.5.6-3 1.6-6.6 2.5-10.4 2.5H4.8C2.7 77.7 1.6 71 1.6 64 1.6 29.5 29.5 1.6 64 1.6s62.4 27.9 62.4 62.4c0 12.5-3.7 24.1-10 33.9m-38.7-5.7c.3.3.9 1.4.2 2.7-.4.7-.8 1.2-1.5 1.8-.9.7-2.6 1.5-4.9 0-1.3-.8-1.3-1.1-3.1-.8-1.2.2-1.7-1.1-1.3-2.1.5-1 2.3-1.9 4.6-.5 1 .6 2.6 1.9 4 .7.6-.5.9-.8 1.7-1.7l.1-.1c.2-.1.2 0 .2 0\"/><path fill=\"#E93442\" d=\"M59.1 31.3c-7.2.5-8 1.3-9.3 2.7-1.9 2-4.4-2.6-4.4-2.6-1.5-.3-3.3-2.7-2.3-5 1-2.2 2.8-1.6 3.3-.9.7.8 2.1 2.2 4 2.2 1.9-.1 4.1-.4 7.1-.4 3.1 0 5.2 1.1 5.3 2.1.1.9-.2 1.7-3.7 1.9m7.6-11.9c-.1 0-.2-.1-.2-.2s0-.1.1-.2c1.4-.7 3.5-1.3 5.9-1.6.7-.1 1.4-.1 2.1-.1h.4c4 .1 7.2 1.7 7.2 3.6-.1 1.9-3.3 3.3-7.3 3.2-1.3 0-2.5-.2-3.6-.5-.1 0-.2-.1-.2-.3 0-.1.1-.2.2-.3 2.5-.6 4.2-1.5 4.1-2.4-.2-1.2-3.4-1.8-7.3-1.4-.6.1-1 .2-1.4.2m32.5 28c-.6 2.1-1.5 4.7-5.4 6.7-.6.3-.8-.2-.5-.6 1.5-2.5 1.7-3.1 2.2-4.1.6-1.4.9-3.5-.3-7.8-2.3-8.4-7.2-19.7-10.8-23.4-3.4-3.5-9.7-4.5-15.3-3.1-2.1.5-6.1 2.6-13.6.9-13-2.9-14.9 3.6-15.7 6.4-.8 2.8-2.5 10.9-2.5 10.9-.6 3.3-1.4 9 18.8 12.8 9.4 1.8 9.9 4.2 10.3 6 .7 3.1 1.9 4.9 3.3 5.8 1.3.9 0 1.6-1.5 1.8-4 .4-18.8-3.8-27.6-8.8-7.2-4.4-7.3-8.3-5.6-11.7-10.8-1.2-19 1-20.4 6.1-2.6 9 19.2 24 44.1 31.5 26.1 7.9 53 2.4 56-14 1.4-7.5-4.9-13-15.5-15.4\"/></svg>"

/***/ }),

/***/ "../src/components/redhat/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RedhatOriginal = __webpack_require__("../src/components/redhat/original/RedhatOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RedhatOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redhat/plain-wordmark/RedhatPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RedhatPlainWordmark = __webpack_require__("../src/components/redhat/plain-wordmark/RedhatPlainWordmark.svg");
	
	var _RedhatPlainWordmark2 = _interopRequireDefault(_RedhatPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RedhatPlainWordmark */
	function RedhatPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RedhatPlainWordmark',
	    svg: _RedhatPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RedhatPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RedhatPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redhat/plain-wordmark/RedhatPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M72.9 68.9c.5-.4.8-.8 1.1-1.3.5-1 .1-1.7-.1-1.9h-.2c-.6.7-.8.9-1.2 1.2-1 .8-2.1-.1-2.9-.5-1.6-1-2.9-.4-3.3.4-.3.7 0 1.6.9 1.5 1.2-.2 1.3 0 2.2.6 1.7 1.1 2.9.5 3.5 0zM59.6 19.7c-2.2 0-3.7.3-5.1.3-1.3 0-2.4-1-2.9-1.6-.4-.5-1.7-1-2.4.6s.6 3.3 1.7 3.6c0 0 1.8 3.3 3.1 1.9 1-1 1.5-1.6 6.6-1.9 2.4-.2 2.7-.7 2.6-1.3 0-.8-1.5-1.6-3.6-1.6zM72.1 15c.1.6-1.1 1.3-2.9 1.7-.1 0-.2.1-.2.2s.1.2.2.2c.7.2 1.6.3 2.5.4 2.8.1 5.2-.8 5.2-2.1s-2.2-2.3-5.1-2.3h-.3c-.5 0-1-.2-1.5-.1-1.7.2-3.2.5-4.2 1h-.1c0 .1.1 0 .1 0 .3 0 .6 0 .9-.1 3-.2 5.3.2 5.4 1.1zm-28 46.5c.3-.7-.1-1.2-.9-1.6-1.2-.5-1.5-1.2-2.2-2.4-.6-1.1-2-1.7-2.2-3.9-.2-2.1 1.4-4.7 4.7-3.9 2.3.6 3.9 3.5 4.4 4.5.3.5 1.3 1.1 2.2.4.8-.8 1.6-.8 2.3.2.5.8 4.5 6.1 8.8 6.3 4.4.1 6.7-1 8.6-.9 1.3.1 2 .7 2.8.8 1.3.2 2.3-1 3.8-.9 1.2.1 2.5.9 3.9.9s4.2-1.6 4.1-1c-.1 1.2-1 3.3-1.2 4.2-.2.7 0 2.3-.4 3.6-.4 1.3-1.6 3-1.9 3.5-1.1 1.6-1.9 2.1-2.8 3.8-1 1.9-2.6 3.7-3 4.2-.5.7 3.1 0 4.3-1.2 1.1-1 3-4.1 6-4.8 2-.4 2.4-1.2 2.2-2l-.1-.3c0-.3.2-.5.4-.6 2.1-.9 5-1.4 8.1-1.4 1.8 0 3.6.2 5.3.6 4.5-6.9 7.1-15.2 7.1-24.1 0-24.4-19.8-44.3-44.3-44.3-24.5 0-44.3 19.9-44.3 44.3 0 4.9.8 9.2 2.3 14.2h3.1c2.7 0 5.3-.7 7.4-1.8.5-.3 1.1-.5 1.8-.5 1.4 0 2.5.5 3.3 1.7.6 1.1 1.2 1.7 2 2.2.6.4 1.5.7 2.7.7.6.3 1.5.1 1.7-.5zM29 32.6c1-3.6 6.8-5.2 14.5-4.4-1.2 2.4-1.1 5.2 4 8.3 6.2 3.5 16.7 6.5 19.6 6.2 1.1-.1 2-.6 1.1-1.3-1-.6-1.8-1.9-2.3-4.1-.3-1.2-.6-3-7.3-4.2-14.3-2.7-13.8-6.8-13.4-9.1 0 0 1.3-5.7 1.8-7.7s1.9-6.6 11.1-4.6c5.3 1.2 8.2-.3 9.7-.7 4-1 8.4-.3 10.8 2.2 2.5 2.6 6 10.6 7.7 16.6.8 3 .6 4.5.2 5.5-.3.7-.5 1.1-1.5 2.9-.2.3 0 .7.4.4 2.8-1.4 3.4-3.3 3.8-4.8 7.5 1.7 12 5.6 11 10.9-2.1 11.7-21.2 15.6-39.7 10C42.7 49.5 27.2 38.8 29 32.6zM7.5 107h-.2l-.2-5H1.9c.1 2 .2 4.6.2 7.7L2 126h6v-12.3c0-.6.1-1.3.2-1.8.5-2.7 2.3-4.6 5.2-4.6.7 0 1.6.1 1.6.2v-5.7c0-.1-.6 0-1.2 0-2.6 0-5.1 1.2-6.3 5.2zm21.1-5.4c-7.7 0-11.7 6.2-11.7 12.8 0 7.3 4.5 12.1 12.3 12.1 3.5 0 6.3-.6 8.3-1.5l-.9-4.1c-1.8.7-3.8 1.1-6.6 1.1-3.9 0-7.2-1.9-7.4-6.2h15.9c.1-.6.2-1.5.2-2.6.1-5.2-2.4-11.6-10.1-11.6zM22.7 112c.3-3 1.8-5.8 5.5-5.8 4 0 5 2.8 5 5.8H22.7zM65 93l-6-1.7V105h-.3c-1.1-2-3.4-3.2-6.7-3.2-5.7 0-10.7 4.7-10.7 12.7 0 7.3 4.5 12 10.2 12 3.4 0 6.3-1.5 7.7-4.5h.1l.3 4H65c-.1-2 0-4.2 0-6.7V93zm-6 22.7c0 .6-.2 1.2-.3 1.8-.6 2.6-2.8 4.3-5.3 4.3-3.8 0-6-3.2-6-7.6 0-4.4 2.1-7.8 6-7.8 2.7 0 4.8 1.9 5.3 4.2.1.5.2 1.1.2 1.6v3.5zm21.7-14.1c-1.8 0-3.4.3-4.8 1.2-1.4.8-2.6 2.2-3.3 3.2H72V95.3l-2-.7V126h2v-14.6c0-1 .4-1.6.6-2.3 1-3 4.1-5.4 7.5-5.4 4.9 0 6.9 3.9 6.9 8.2V126h2v-14.4c0-8.9-6-10-8.3-10zM110 111c0-4.3-1.2-9.4-8.1-9.4-2.2 0-4.8.6-7 2.1l.8 1.7c1.7-1.2 4-1.8 6.1-1.8 5.6 0 6.2 4.7 6.2 7v.6c-10-.1-14.6 3.2-14.6 8.7 0 3.2 2.2 6.8 7 6.8 3.8 0 6.4-2.8 7.6-3.8h.1l.3 3h2.2c-.3-2-.5-3.8-.5-5.7V111zm-2 7.4c0 .4-.2.9-.3 1.4-.8 2.3-3.1 4.8-7.1 4.8-2.5 0-4.7-1.5-4.7-5 0-5.7 7.1-6.5 12.1-6.4v5.2zm18-14.4v-2h-7v-5.1l-2 .9v4.2h-4v2h4v15.2c0 2.4.5 4.4 1.6 5.7.9 1.1 2.4 1.7 4.2 1.7 1.4 0 2.5-.2 3.3-.6l-.3-1.8c-.6.2-1.8.4-3 .4-2.6 0-3.8-1.9-3.8-4.9V104h7z\" fill=\"#E93442\"/></svg>"

/***/ }),

/***/ "../src/components/redhat/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RedhatPlainWordmark = __webpack_require__("../src/components/redhat/plain-wordmark/RedhatPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RedhatPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redhat/plain/RedhatPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RedhatPlain = __webpack_require__("../src/components/redhat/plain/RedhatPlain.svg");
	
	var _RedhatPlain2 = _interopRequireDefault(_RedhatPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RedhatPlain */
	function RedhatPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RedhatPlain',
	    svg: _RedhatPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RedhatPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RedhatPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redhat/plain/RedhatPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M77.6 92.4c-.1 0-.1 0-.1.1-.8.9-1.2 1.3-1.7 1.7-1.4 1.1-3-.1-4-.7-2.3-1.3-4.1-.5-4.6.5-.4 1 .1 2.3 1.3 2.1 1.7-.2 1.8 0 3.1.8 2.4 1.5 4.1.7 4.9 0 .7-.6 1.1-1.1 1.5-1.8.7-1.3.1-2.4-.2-2.7h-.2zM74.9 17h-.4c-.7 0-1.4.3-2.1.4-2.4.2-4.5 1-5.9 1.7-.1 0-.1-.1-.1-.1l.2-.1 1.2.2c3.9-.4 7.1.4 7.3 1.6.1.9-1.6 1.9-4.1 2.5-.1 0-.2.2-.2.3 0 .1.1.3.2.3 1 .3 2.3.5 3.6.5 4 .1 7.3-1.6 7.3-3.5.2-1.8-3-3.8-7-3.8zM64 1.8C29.5 1.8 1.6 29.7 1.6 64.1c0 7 1.1 13.9 3.3 19.9h4.3c3.8 0 7.4-.9 10.4-2.4.8-.4 1.6-.6 2.5-.6 1.9 0 3.6.8 4.6 2.5.9 1.6 1.7 2.5 2.8 3.1.9.6 2.1 1 3.8 1 .8 0 2.1-.2 2.4-1.1.4-1-.1-1.7-1.3-2.2-1.7-.7-2.1-1.7-3-3.3-.9-1.6-2.8-2.4-3.1-5.4-.3-3 2-6.7 6.6-5.5 3.3.9 5.4 4.9 6.2 6.3.4.7 1.9 1.6 3.1.5 1.2-1.1 2.3-1.1 3.2.3.8 1.2 6.4 8.7 12.5 8.9 6.2.2 9.5-1.4 12.2-1.3 1.9.1 2.8 1 3.9 1.2 1.9.3 3.2-1.4 5.3-1.3 1.7.1 3.5 1.2 5.4 1.2s5.9-2.3 5.8-1.3c-.1 1.7-1.4 4.6-1.7 6-.2.9 0 3.2-.6 5.1-.5 1.9-2.2 4.2-2.7 4.9-1.5 2.3-2.6 3-3.9 5.4-1.4 2.7-3.7 5.2-4.3 6-.8 1 4.3 0 6.1-1.7 1.5-1.4 4.2-5.8 8.5-6.8 2.9-.6 3.4-1.7 3.1-2.8-.1-.1-.1-.3-.1-.4 0-.4.2-.7.6-.9 3-1.2 7-2 11.4-2 2.6 0 5.1.3 7.5.9 6.3-9.8 10-21.4 10-33.9 0-34.6-27.9-62.6-62.4-62.6zM114.8 63c-3 16.4-29.9 21.9-56 14-25-7.5-46.8-22.5-44.3-31.3 1.5-5.1 9.6-7.3 20.4-6.1-1.6 3.3-1.5 7.3 5.6 11.7 8.8 5 23.6 9.2 27.6 8.8 1.5-.1 2.8-.9 1.5-1.8-1.3-.9-2.5-2.7-3.3-5.8-.4-1.7-.9-4.2-10.3-6-20.2-3.9-19.4-9.6-18.8-12.8 0 0 1.8-8.1 2.5-10.9.7-2.8 2.7-9.3 15.7-6.4 7.5 1.7 11.6-.4 13.6-.9 5.6-1.4 11.9-.4 15.3 3.1 3.6 3.7 8.5 14.9 10.8 23.4 1.2 4.3.9 6.3.3 7.8-.4 1-.7 1.6-2.2 4.1-.3.4 0 .9.5.6 3.9-2 4.8-4.7 5.4-6.7 10.7 2.2 17 7.7 15.7 15.2zM57.6 27.5c-3 0-5.2.4-7.1.4s-3.4-1.3-4-2.2c-.6-.7-2.4-1.4-3.3.9-1 2.3.8 4.7 2.3 5 0 0 2.5 4.7 4.4 2.6 1.3-1.4 2.1-2.2 9.3-2.7 3.4-.3 3.8-1 3.7-1.9-.2-1-2.3-2.1-5.3-2.1z\" fill=\"#E93442\"/></svg>"

/***/ }),

/***/ "../src/components/redhat/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RedhatPlain = __webpack_require__("../src/components/redhat/plain/RedhatPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RedhatPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redis/original-wordmark/RedisOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RedisOriginalWordmark = __webpack_require__("../src/components/redis/original-wordmark/RedisOriginalWordmark.svg");
	
	var _RedisOriginalWordmark2 = _interopRequireDefault(_RedisOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RedisOriginalWordmark */
	function RedisOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RedisOriginalWordmark',
	    svg: _RedisOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RedisOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RedisOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redis/original-wordmark/RedisOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M21.4 97.6c0 1.8-1.5 3.5-3.5 3.5-1.5 0-2.8.4-4 1.3-1.3.8-2.2 1.9-3 3.2-1.6 2.1-2.4 4.6-2.7 5.5v12.5c0 1.9-1.6 3.5-3.6 3.5-1.9 0-3.5-1.6-3.5-3.5v-26c0-1.9 1.6-3.4 3.5-3.4 2 0 3.6 1.5 3.6 3.4v.5c.4-.5.9-1 1.4-1.3 2.2-1.4 5-2.6 8.3-2.6 2 0 3.5 1.5 3.5 3.4zm-1.9 13c.1-9 7-16.5 16.1-16.5 8.6 0 15.3 6.4 15.9 15.3v.3c0 .1 0 .5-.1.6-.2 1.6-1.6 2.6-3.4 2.6H27c.3 1.5 1.1 3.2 2.2 4.3 1.4 1.6 4 2.8 6.3 3 2.4.2 5.2-.4 6.8-1.6 1.4-1.4 4.1-1.3 4.9-.2.9.9 1.5 2.9 0 4.3-3.2 3-7.1 4.3-11.8 4.3-8.9 0-15.9-7.5-15.9-16.4zm7.1-3.2h18.6c-.7-2.6-4-6.5-9.7-7-5.6.2-8.3 4.3-8.9 7zm58.3 16.1c0 1.9-1.6 3.6-3.6 3.6-1.8 0-3.2-1.3-3.5-2.8-2.5 1.7-5.7 2.8-9 2.8-8.9 0-16-7.5-16-16.4 0-9 7.1-16.5 16-16.5 3.2 0 6.4 1.1 8.8 2.8V84.5c0-1.9 1.6-3.6 3.6-3.6s3.6 1.6 3.6 3.6v26.2l.1 12.8zm-16-22.2c-2.4 0-4.5 1-6.2 2.7-1.6 1.6-2.6 4-2.6 6.6 0 2.5 1 4.9 2.6 6.5 1.6 1.7 3.8 2.7 6.2 2.7 2.4 0 4.5-1 6.2-2.7 1.6-1.6 2.6-4 2.6-6.5 0-2.6-1-5-2.6-6.6-1.6-1.7-3.7-2.7-6.2-2.7zm28.6-15.4c0 2-1.5 3.6-3.6 3.6-2 0-3.6-1.6-3.6-3.6v-1.4c0-2 1.6-3.6 3.6-3.6s3.6 1.6 3.6 3.6v1.4zm0 11.9v25.7c0 2-1.5 3.6-3.6 3.6-2 0-3.6-1.6-3.6-3.6V97.8c0-2.1 1.6-3.6 3.6-3.6 2.1 0 3.6 1.5 3.6 3.6zm4.5 19.8c1.2-1.6 3.5-1.8 4.9-.5 1.7 1.4 4.7 3 7.2 2.9 1.8 0 3.4-.6 4.5-1.3.9-.8 1.2-1.4 1.2-2 0-.3-.1-.5-.2-.7-.1-.2-.3-.5-.9-.8-.9-.7-2.9-1.4-5.3-1.8h-.1c-2-.4-4-.9-5.7-1.7-1.8-.9-3.4-2-4.5-3.8-.7-1.2-1.1-2.6-1.1-4.1 0-3 1.7-5.6 3.9-7.2 2.3-1.6 5.1-2.4 8.1-2.4 4.5 0 7.8 2.2 9.9 3.6 1.6 1.1 2 3.2 1.1 4.9-1.1 1.6-3.2 2-4.9.9-2.1-1.4-4-2.4-6.1-2.4-1.6 0-3.1.5-4 1.2-.9.6-1.1 1.2-1.1 1.5 0 .3 0 .3.1.5.1.1.3.4.7.7.9.6 2.6 1.2 4.8 1.6l.1.1h.1c2.2.4 4.2 1 6.1 1.9 1.8.8 3.6 2 4.7 3.9.8 1.3 1.3 2.8 1.3 4.3 0 3.2-1.8 5.9-4.1 7.6-2.4 1.6-5.3 2.6-8.6 2.6-5.1-.1-9.1-2.4-11.7-4.5-1.4-1.3-1.6-3.5-.4-5z\" fill=\"#636466\"/><path fill=\"#A41E11\" d=\"M106.9 62.7c-5 2.6-30.7 13.2-36.2 16-5.5 2.9-8.5 2.8-12.8.8-4.4-2.1-31.7-13.1-36.7-15.5-2.5-1.2-3.8-2.2-3.8-3.1v-9.4s35.6-7.8 41.4-9.8c5.8-2.1 7.8-2.1 12.6-.3 4.9 1.8 34.2 7.1 39 8.8v9.3c.1.9-1 1.9-3.5 3.2z\"/><path fill=\"#D82C20\" d=\"M106.9 53.3c-5 2.6-30.7 13.2-36.2 16-5.5 2.9-8.5 2.8-12.8.8C53.5 68 26.2 57 21.2 54.6c-4.9-2.4-5-4-.2-5.9 4.8-1.9 32.1-12.6 37.8-14.6 5.8-2.1 7.8-2.1 12.6-.3 4.9 1.8 30.5 12 35.3 13.7 5 1.8 5.2 3.2.2 5.8z\"/><path fill=\"#A41E11\" d=\"M106.9 47.4c-5 2.6-30.7 13.2-36.2 16-5.5 2.9-8.5 2.8-12.8.8-4.4-2.1-31.7-13.2-36.7-15.5-2.5-1.2-3.8-2.2-3.8-3.1v-9.4s35.6-7.8 41.4-9.8c5.8-2.1 7.8-2.1 12.6-.3 4.9 1.8 34.2 7.1 39 8.8v9.3c.1.9-1 1.9-3.5 3.2z\"/><path fill=\"#D82C20\" d=\"M106.9 38c-5 2.6-30.7 13.2-36.2 16-5.5 2.9-8.5 2.8-12.8.8-4.3-2.1-31.7-13.1-36.6-15.5-4.9-2.4-5-4-.2-5.9 4.8-1.9 32.1-12.6 37.8-14.6 5.8-2.1 7.8-2.1 12.6-.3 4.9 1.8 30.5 12 35.3 13.7 4.9 1.7 5.1 3.2.1 5.8z\"/><path fill=\"#A41E11\" d=\"M106.9 31.5c-5 2.6-30.7 13.2-36.2 16-5.5 2.9-8.5 2.8-12.8.8-4.3-2.1-31.7-13.1-36.6-15.5-2.5-1.2-3.8-2.2-3.8-3.1v-9.4s35.6-7.8 41.4-9.8c5.8-2.1 7.8-2.1 12.6-.3 4.9 1.8 34.2 7.1 39 8.8v9.3c0 .8-1.1 1.9-3.6 3.2z\"/><path fill=\"#D82C20\" d=\"M106.9 22.1c-5 2.6-30.7 13.2-36.2 16-5.5 2.9-8.5 2.8-12.8.8-4.3-2.1-31.7-13.1-36.6-15.5s-5-4-.2-5.9c4.8-1.9 32.1-12.6 37.8-14.6C64.7.8 66.7.8 71.5 2.6c4.9 1.8 30.5 12 35.3 13.7 4.9 1.7 5.1 3.2.1 5.8z\"/><path fill=\"#fff\" d=\"M76.2 13l-8.1.8-1.8 4.4-2.9-4.9-9.3-.8L61 10l-2-3.8 6.5 2.5 6.1-2-1.7 4zM65.8 34.1l-15-6.3 21.6-3.3z\"/><ellipse fill=\"#fff\" cx=\"45\" cy=\"19.9\" rx=\"11.5\" ry=\"4.5\"/><path fill=\"#7A0C00\" d=\"M85.7 14.2l12.8 5-12.8 5.1z\"/><path fill=\"#AD2115\" d=\"M71.6 19.8l14.1-5.6v10.1l-1.3.5z\"/></svg>"

/***/ }),

/***/ "../src/components/redis/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RedisOriginalWordmark = __webpack_require__("../src/components/redis/original-wordmark/RedisOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RedisOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redis/original/RedisOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RedisOriginal = __webpack_require__("../src/components/redis/original/RedisOriginal.svg");
	
	var _RedisOriginal2 = _interopRequireDefault(_RedisOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RedisOriginal */
	function RedisOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RedisOriginal',
	    svg: _RedisOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RedisOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RedisOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redis/original/RedisOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#A41E11\" d=\"M121.8 93.1c-6.7 3.5-41.4 17.7-48.8 21.6-7.4 3.9-11.5 3.8-17.3 1S13 98.1 6.3 94.9c-3.3-1.6-5-2.9-5-4.2V78s48-10.5 55.8-13.2c7.8-2.8 10.4-2.9 17-.5s46.1 9.5 52.6 11.9v12.5c0 1.3-1.5 2.7-4.9 4.4z\"/><path fill=\"#D82C20\" d=\"M121.8 80.5C115.1 84 80.4 98.2 73 102.1c-7.4 3.9-11.5 3.8-17.3 1-5.8-2.8-42.7-17.7-49.4-20.9C-.3 79-.5 76.8 6 74.3c6.5-2.6 43.2-17 51-19.7 7.8-2.8 10.4-2.9 17-.5s41.1 16.1 47.6 18.5c6.7 2.4 6.9 4.4.2 7.9z\"/><path fill=\"#A41E11\" d=\"M121.8 72.5C115.1 76 80.4 90.2 73 94.1c-7.4 3.8-11.5 3.8-17.3 1C49.9 92.3 13 77.4 6.3 74.2c-3.3-1.6-5-2.9-5-4.2V57.3s48-10.5 55.8-13.2c7.8-2.8 10.4-2.9 17-.5s46.1 9.5 52.6 11.9V68c0 1.3-1.5 2.7-4.9 4.5z\"/><path fill=\"#D82C20\" d=\"M121.8 59.8c-6.7 3.5-41.4 17.7-48.8 21.6-7.4 3.8-11.5 3.8-17.3 1C49.9 79.6 13 64.7 6.3 61.5s-6.8-5.4-.3-7.9c6.5-2.6 43.2-17 51-19.7 7.8-2.8 10.4-2.9 17-.5s41.1 16.1 47.6 18.5c6.7 2.4 6.9 4.4.2 7.9z\"/><path fill=\"#A41E11\" d=\"M121.8 51c-6.7 3.5-41.4 17.7-48.8 21.6-7.4 3.8-11.5 3.8-17.3 1C49.9 70.9 13 56 6.3 52.8c-3.3-1.6-5.1-2.9-5.1-4.2V35.9s48-10.5 55.8-13.2c7.8-2.8 10.4-2.9 17-.5s46.1 9.5 52.6 11.9v12.5c.1 1.3-1.4 2.6-4.8 4.4z\"/><path fill=\"#D82C20\" d=\"M121.8 38.3C115.1 41.8 80.4 56 73 59.9c-7.4 3.8-11.5 3.8-17.3 1S13 43.3 6.3 40.1s-6.8-5.4-.3-7.9c6.5-2.6 43.2-17 51-19.7 7.8-2.8 10.4-2.9 17-.5s41.1 16.1 47.6 18.5c6.7 2.4 6.9 4.4.2 7.8z\"/><path fill=\"#fff\" d=\"M80.4 26.1l-10.8 1.2-2.5 5.8-3.9-6.5-12.5-1.1 9.3-3.4-2.8-5.2 8.8 3.4 8.2-2.7L72 23zM66.5 54.5l-20.3-8.4 29.1-4.4z\"/><ellipse fill=\"#fff\" cx=\"38.4\" cy=\"35.4\" rx=\"15.5\" ry=\"6\"/><path fill=\"#7A0C00\" d=\"M93.3 27.7l17.2 6.8-17.2 6.8z\"/><path fill=\"#AD2115\" d=\"M74.3 35.3l19-7.6v13.6l-1.9.8z\"/></svg>"

/***/ }),

/***/ "../src/components/redis/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RedisOriginal = __webpack_require__("../src/components/redis/original/RedisOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RedisOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redis/plain-wordmark/RedisPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RedisPlainWordmark = __webpack_require__("../src/components/redis/plain-wordmark/RedisPlainWordmark.svg");
	
	var _RedisPlainWordmark2 = _interopRequireDefault(_RedisPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RedisPlainWordmark */
	function RedisPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RedisPlainWordmark',
	    svg: _RedisPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RedisPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RedisPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redis/plain-wordmark/RedisPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M21.8 31.9C26.6 34.2 53.4 45 57.6 47c4.2 2 7.2 2 12.6-.7 5.3-2.8 30.5-13.1 35.3-15.6 2.5-1.3 3.6-2.3 3.6-3.2v-9.1c0-.9-1.2-1.7-3.6-2.6L71 2.4C66.2.6 64.3.7 58.7 2.7c-5.7 2-32.3 12.5-37 14.3-2.3.9-3.6 1.8-3.6 2.7H18v9.1c0 1 1.4 2 3.8 3.1zm43.6 1.3l-14.7-6.1 21.1-3.2-6.4 9.3zm31.9-14.5l-12.5 4.9-1.3.5-12.4-4.9 13.8-5.5 12.4 5zm-36.5-9l-2-3.8 6.3 2.5 6-2-1.6 3.9 6.1 2.3-7.9.8-1.8 4.2-2.8-4.6-9.1-.8 6.8-2.5zM45.1 15c6.2 0 11.3 2 11.3 4.4 0 2.4-5 4.4-11.3 4.4-6.2 0-11.3-2-11.3-4.4 0-2.4 5.1-4.4 11.3-4.4zM21.8 47.5c4.8 2.3 31.6 13.1 35.8 15.1 4.2 2 7.2 2 12.6-.7 5.3-2.8 30.5-13.1 35.3-15.6 2.5-1.3 3.6-2.3 3.6-3.2V34c0 .9-1.2 1.8-3.5 3.1-4.8 2.5-30 12.9-35.3 15.6-5.3 2.8-8.3 2.8-12.5.7-4.2-2-31.1-12.8-35.9-15.1-2.4-1.1-3.8-2.1-3.8-3v9.2c-.1.9 1.3 1.8 3.7 3zm0 15c4.8 2.3 31.6 13.1 35.8 15.1 4.2 2 7.2 2 12.6-.7 5.3-2.8 30.5-13.1 35.3-15.6 2.5-1.3 3.6-2.3 3.6-3.2V49c0 .9-1.2 1.8-3.5 3.1-4.8 2.5-30 12.9-35.3 15.6-5.3 2.8-8.3 2.8-12.5.7-4.2-2-31.1-12.8-35.9-15.1-2.4-1.1-3.8-2.1-3.8-3v9.2c-.1.8 1.3 1.8 3.7 3zm-.4 35.1c0-1.9-1.5-3.4-3.5-3.4-3.3-.1-6.2 1.1-8.4 2.6C9 97 9 97.6 8 98v-.5c0-1.9-1.6-3.4-3.6-3.4-1.9 0-3.4 1.5-3.4 3.4v25.9c0 1.9 1.5 3.5 3.4 3.5 2 0 3.6-1.6 3.6-3.5V111c1-.9 1.2-3.4 2.8-5.5.8-1.3 1.8-2.4 3.1-3.2 1.1-.9 2.5-1.3 4-1.3 2 .1 3.5-1.6 3.5-3.4zm13.9-3.5c-9 0-15.9 7.5-16 16.5.1 9 7.1 16.4 16.1 16.5 4.7 0 8.6-1.4 11.8-4.3 1.5-1.4.9-3.4 0-4.3-.9-1.1-3.5-1.3-4.9.2-1.6 1.3-4.5 1.8-6.8 1.6-2.3-.2-4.9-1.3-6.3-2.9-1.2-1.1-1.9-3.3-2.2-4.3h20.9c1.8 0 3-1.1 3.2-2.7.1-.1-.1-.5-.1-.6v-.3c0-9-7.1-15.4-15.7-15.4zM26.6 107c.5-2 3.3-6.7 8.9-7 5.7.5 9.1 5 9.7 7H26.6zm58.4 3.6V84.5c0-1.9-1.5-3.6-3.5-3.6S78 82.5 78 84.5v12.4c-3-1.7-5.7-2.8-8.9-2.8-8.9 0-16.1 7.5-16.1 16.5 0 8.9 7.1 16.4 16 16.4 3.3 0 6.4-1.1 8.9-2.8.3 1.6 1.7 2.8 3.5 2.8 2 0 3.6-1.6 3.6-3.6v-12.8zm-9.9 6.5c-1.6 1.7-3.8 2.7-6.2 2.7-2.4 0-4.5-1-6.2-2.7-1.6-1.6-2.6-4-2.6-6.5 0-2.6 1-5 2.6-6.6 1.6-1.7 3.8-2.7 6.2-2.7 2.4 0 4.5 1 6.2 2.7 1.6 1.6 2.6 4 2.6 6.6.1 2.5-.9 4.9-2.6 6.5zm18.4-36.2c-2 0-3.5 1.6-3.5 3.6v1.4c0 2 1.5 3.6 3.5 3.6s3.5-1.6 3.5-3.6v-1.4c0-2-1.5-3.6-3.5-3.6zm0 13.2c-2 0-3.5 1.5-3.5 3.6v25.7c0 2 1.5 3.6 3.5 3.6s3.5-1.6 3.5-3.6V97.8c0-2.1-1.5-3.7-3.5-3.7zm32.1 18.3c-1.1-1.8-2.9-2.9-4.7-3.7-1.9-.9-3.9-1.7-6.1-1.7h-.1l-.1-.3c-2.2-.4-3.9-1.1-4.8-1.7-.5-.3-.7-.6-.7-.7-.1-.2-.1-.3-.1-.6s.2-.9 1.1-1.5c.9-.7 2.3-1.2 4-1.2 2.1 0 4 1.1 6.1 2.4 1.6 1.1 3.8.7 4.9-.9 1-1.6.5-3.8-1.1-4.9-2.1-1.4-5.3-3.6-9.9-3.6-3 0-5.8.9-8.1 2.4-2.2 1.6-3.9 4.2-3.9 7.2 0 1.5.4 3 1.1 4.1 1.2 1.8 2.8 2.7 4.5 3.6 1.7.8 3.7 1.5 5.7 1.5h.1c2.4 1 4.3 1.4 5.3 2.1.5.3.8.7.9.9.1.2.2.4.2.7 0 .5-.3 1.2-1.2 2-1.1.7-2.7 1.3-4.5 1.3-2.6.1-5.5-1.4-7.2-2.9-1.4-1.3-3.8-1-4.9.5-1.2 1.4-1 3.7.5 4.9 2.6 2.1 6.6 4.5 11.7 4.5 3.2 0 6.2-1 8.6-2.6 2.4-1.7 4.1-4.4 4.1-7.6-.1-1.4-.6-2.9-1.4-4.2z\" fill=\"#D82C20\"/></svg>"

/***/ }),

/***/ "../src/components/redis/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RedisPlainWordmark = __webpack_require__("../src/components/redis/plain-wordmark/RedisPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RedisPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redis/plain/RedisPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RedisPlain = __webpack_require__("../src/components/redis/plain/RedisPlain.svg");
	
	var _RedisPlain2 = _interopRequireDefault(_RedisPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RedisPlain */
	function RedisPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RedisPlain',
	    svg: _RedisPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RedisPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RedisPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/redis/plain/RedisPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M6.2 52.7c6.7 3.2 43.7 18.1 49.5 20.9 5.8 2.8 10 2.8 17.4-1 7.4-3.9 42.2-18.1 48.9-21.6 3.4-1.8 4.9-3.2 4.9-4.4V34.1c0-1.3-1.7-2.4-5-3.6-6.5-2.4-41.1-16.1-47.7-18.6-6.6-2.4-9.3-2.3-17.1.5C49.3 15.2 12.6 29.6 6 32.2c-3.2 1.3-5 2.4-5 3.7H.8v12.7c.2 1.2 2.1 2.5 5.4 4.1zm60.4 1.8l-20.3-8.4 29.1-4.5-8.8 12.9zm44.1-20l-17.2 6.8-1.9.7-17.2-6.8 19.1-7.5 17.2 6.8zM60.1 22l-2.8-5.2 8.8 3.4 8.3-2.7-2.2 5.4 8.4 3.2-10.9 1.1-2.4 5.9-3.9-6.5-12.6-1.1 9.3-3.5zm-21.7 7.3c8.6 0 15.6 2.7 15.6 6s-7 6-15.6 6-15.6-2.7-15.6-6 7-6 15.6-6zM122 59.8c-6.7 3.5-41.4 17.8-48.8 21.6-7.4 3.9-11.5 3.8-17.3 1-5.8-2.8-43-17.7-49.6-20.9C2.9 59.9 1 58.6 1 57.3V70c0 1.3 1.9 2.6 5.2 4.2 6.7 3.2 43.7 18.1 49.5 20.9 5.8 2.8 10 2.8 17.4-1 7.4-3.9 42.2-18.1 48.9-21.6 3.4-1.8 4.9-3.2 4.9-4.4V55.6c0 1.1-1.6 2.5-4.9 4.2zm0 20.7c-6.7 3.5-41.4 17.8-48.8 21.6-7.4 3.9-11.5 3.8-17.3 1-5.8-2.8-43-17.7-49.6-20.9C2.9 80.7 1 79.3 1 78v12.7c0 1.3 1.9 2.6 5.2 4.2 6.7 3.2 43.7 18.1 49.5 20.9 5.8 2.8 10 2.8 17.4-1 7.4-3.9 42.2-18.1 48.9-21.6 3.4-1.8 4.9-3.2 4.9-4.4V76.3c0 1.2-1.6 2.5-4.9 4.2z\" fill=\"#D82C20\"/></svg>"

/***/ }),

/***/ "../src/components/redis/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RedisPlain = __webpack_require__("../src/components/redis/plain/RedisPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RedisPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ruby/original-wordmark/RubyOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RubyOriginalWordmark = __webpack_require__("../src/components/ruby/original-wordmark/RubyOriginalWordmark.svg");
	
	var _RubyOriginalWordmark2 = _interopRequireDefault(_RubyOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RubyOriginalWordmark */
	function RubyOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RubyOriginalWordmark',
	    svg: _RubyOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RubyOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RubyOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ruby/original-wordmark/RubyOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M30.217 109.422v8.547h-4.724V95.692h6.491c3.026 0 5.266.551 6.719 1.653 1.453 1.103 2.179 2.776 2.179 5.02 0 1.311-.361 2.477-1.083 3.497-.721 1.021-1.742 1.822-3.063 2.401l6.552 9.705h-5.242l-5.317-8.547h-2.512zm0-3.84h1.524c1.492 0 2.595-.25 3.306-.747.71-.498 1.066-1.28 1.066-2.346 0-1.057-.363-1.808-1.089-2.255-.726-.447-1.851-.671-3.375-.671h-1.432v6.019zm27.578 12.387l-.625-2.179h-.244c-.498.793-1.205 1.404-2.118 1.836-.915.432-1.957.647-3.124.647-2.002 0-3.509-.535-4.526-1.607-1.016-1.072-1.524-2.613-1.524-4.624v-11.108h4.648v9.95c0 1.229.218 2.151.656 2.766.436.615 1.131.921 2.086.921 1.301 0 2.24-.435 2.819-1.302.579-.869.869-2.308.869-4.319v-8.015h4.647v17.035h-3.564zm17.918-17.356c2.011 0 3.586.786 4.725 2.355 1.137 1.569 1.706 3.72 1.706 6.453 0 2.813-.587 4.992-1.759 6.535-1.173 1.545-2.771 2.316-4.793 2.316-2 0-3.57-.727-4.708-2.18h-.32l-.776 1.875h-3.551V94.26h4.647v5.516c0 .701-.062 1.823-.184 3.368h.184c1.086-1.686 2.697-2.531 4.829-2.531zm-1.493 3.719c-1.147 0-1.985.353-2.513 1.059-.528.707-.803 1.872-.823 3.498v.502c0 1.829.271 3.139.814 3.932.544.792 1.405 1.188 2.583 1.188.955 0 1.713-.44 2.278-1.318.564-.878.846-2.156.846-3.832 0-1.676-.286-2.934-.854-3.772-.568-.838-1.345-1.257-2.331-1.257zm9.021-3.398h5.088l3.215 9.584c.275.833.463 1.818.564 2.956h.092c.111-1.046.329-2.032.654-2.956l3.154-9.584h4.983l-7.207 19.214c-.661 1.777-1.602 3.108-2.826 3.992-1.225.884-2.654 1.325-4.29 1.325-.803 0-1.59-.086-2.361-.259v-3.687a7.992 7.992 0 0 0 1.828.197c.822 0 1.541-.251 2.156-.754.615-.502 1.095-1.261 1.44-2.277l.274-.839-6.764-16.912z\"/><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"143.917\" y1=\"2125.439\" x2=\"125.854\" y2=\"2157.331\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#FB7655\"/><stop offset=\"0\" stop-color=\"#FB7655\"/><stop offset=\".41\" stop-color=\"#E42B1E\"/><stop offset=\".99\" stop-color=\"#900\"/><stop offset=\"1\" stop-color=\"#900\"/></linearGradient><path fill=\"url(#a)\" d=\"M87.524 58.767L38.638 87.795l63.3-4.294 4.875-63.828z\"/><linearGradient id=\"b\" gradientUnits=\"userSpaceOnUse\" x1=\"152.913\" y1=\"2152.229\" x2=\"129.634\" y2=\"2167.85\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#871101\"/><stop offset=\"0\" stop-color=\"#871101\"/><stop offset=\".99\" stop-color=\"#911209\"/><stop offset=\"1\" stop-color=\"#911209\"/></linearGradient><path fill=\"url(#b)\" d=\"M102.041 83.457L96.6 45.905l-14.818 19.57z\"/><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"134.287\" y1=\"2124.472\" x2=\"111.008\" y2=\"2140.093\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#871101\"/><stop offset=\"0\" stop-color=\"#871101\"/><stop offset=\".99\" stop-color=\"#911209\"/><stop offset=\"1\" stop-color=\"#911209\"/></linearGradient><path fill=\"url(#c)\" d=\"M102.114 83.457l-39.858-3.129-23.405 7.385z\"/><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"85.411\" y1=\"2163.54\" x2=\"89.02\" y2=\"2140.086\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\".23\" stop-color=\"#E57252\"/><stop offset=\".46\" stop-color=\"#DE3B20\"/><stop offset=\".99\" stop-color=\"#A60003\"/><stop offset=\"1\" stop-color=\"#A60003\"/></linearGradient><path fill=\"url(#d)\" d=\"M38.906 87.722l9.957-32.62-21.91 4.686z\"/><linearGradient id=\"e\" gradientUnits=\"userSpaceOnUse\" x1=\"110.233\" y1=\"2185.439\" x2=\"111.563\" y2=\"2161.502\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\".23\" stop-color=\"#E4714E\"/><stop offset=\".56\" stop-color=\"#BE1A0D\"/><stop offset=\".99\" stop-color=\"#A80D00\"/><stop offset=\"1\" stop-color=\"#A80D00\"/></linearGradient><path fill=\"url(#e)\" d=\"M81.777 65.582l-9.162-35.887-26.219 24.577z\"/><linearGradient id=\"f\" gradientUnits=\"userSpaceOnUse\" x1=\"132.261\" y1=\"2207.563\" x2=\"136.242\" y2=\"2190.407\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\".18\" stop-color=\"#E46342\"/><stop offset=\".4\" stop-color=\"#C82410\"/><stop offset=\".99\" stop-color=\"#A80D00\"/><stop offset=\"1\" stop-color=\"#A80D00\"/></linearGradient><path fill=\"url(#f)\" d=\"M104.734 30.201L79.949 9.958l-6.901 22.313z\"/><linearGradient id=\"g\" gradientUnits=\"userSpaceOnUse\" x1=\"120.105\" y1=\"2213.604\" x2=\"137.258\" y2=\"2222.18\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\".54\" stop-color=\"#C81F11\"/><stop offset=\".99\" stop-color=\"#BF0905\"/><stop offset=\"1\" stop-color=\"#BF0905\"/></linearGradient><path fill=\"url(#g)\" d=\"M93.142 2.741l-14.576 8.056-9.197-8.164z\"/><linearGradient id=\"h\" gradientUnits=\"userSpaceOnUse\" x1=\"70.375\" y1=\"2169.518\" x2=\"71.787\" y2=\"2155.382\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\".31\" stop-color=\"#DE4024\"/><stop offset=\".99\" stop-color=\"#BF190B\"/><stop offset=\"1\" stop-color=\"#BF190B\"/></linearGradient><path fill=\"url(#h)\" d=\"M21.188 70.73l6.107-11.137-4.941-13.267z\"/><path fill=\"#fff\" d=\"M22.026 45.905l4.97 14.098 21.595-4.845 24.655-22.913 6.958-22.1-10.955-7.737-18.627 6.971c-5.868 5.458-17.256 16.258-17.667 16.461-.406.208-7.519 13.653-10.929 20.065z\"/><linearGradient id=\"i\" gradientUnits=\"userSpaceOnUse\" x1=\"60.669\" y1=\"2151.563\" x2=\"127.036\" y2=\"2219.806\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#BD0012\"/><stop offset=\"0\" stop-color=\"#BD0012\"/><stop offset=\".07\" stop-color=\"#fff\"/><stop offset=\".17\" stop-color=\"#fff\"/><stop offset=\".27\" stop-color=\"#C82F1C\"/><stop offset=\".33\" stop-color=\"#820C01\"/><stop offset=\".46\" stop-color=\"#A31601\"/><stop offset=\".72\" stop-color=\"#B31301\"/><stop offset=\".99\" stop-color=\"#E82609\"/><stop offset=\"1\" stop-color=\"#E82609\"/></linearGradient><path fill=\"url(#i)\" d=\"M39.477 20.581C52.196 7.97 68.592.52 74.884 6.869c6.289 6.348-.38 21.776-13.099 34.382C49.067 53.858 32.873 61.719 26.586 55.37c-6.294-6.344.173-22.183 12.891-34.789z\"/><linearGradient id=\"j\" gradientUnits=\"userSpaceOnUse\" x1=\"111.505\" y1=\"2144.677\" x2=\"91.514\" y2=\"2149.611\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#8C0C01\"/><stop offset=\"0\" stop-color=\"#8C0C01\"/><stop offset=\".54\" stop-color=\"#990C00\"/><stop offset=\".99\" stop-color=\"#A80D0E\"/><stop offset=\"1\" stop-color=\"#A80D0E\"/></linearGradient><path fill=\"url(#j)\" d=\"M38.906 87.709l9.879-32.724 32.811 10.541c-11.864 11.125-25.058 20.528-42.69 22.183z\"/><linearGradient id=\"k\" gradientUnits=\"userSpaceOnUse\" x1=\"145.839\" y1=\"2168.67\" x2=\"128.08\" y2=\"2184.586\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#7E110B\"/><stop offset=\"0\" stop-color=\"#7E110B\"/><stop offset=\".99\" stop-color=\"#9E0C00\"/><stop offset=\"1\" stop-color=\"#9E0C00\"/></linearGradient><path fill=\"url(#k)\" d=\"M73.289 32.181l8.423 33.363c9.91-10.419 18.804-21.621 23.159-35.476l-31.582 2.113z\"/><linearGradient id=\"l\" gradientUnits=\"userSpaceOnUse\" x1=\"152.364\" y1=\"2197.874\" x2=\"143.518\" y2=\"2207.331\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#79130D\"/><stop offset=\"0\" stop-color=\"#79130D\"/><stop offset=\".99\" stop-color=\"#9E120B\"/><stop offset=\"1\" stop-color=\"#9E120B\"/></linearGradient><path fill=\"url(#l)\" d=\"M104.785 30.236c3.371-10.174 4.148-24.768-11.746-27.477L79.996 9.963l24.789 20.273z\"/><path fill=\"#9E1209\" d=\"M21.188 70.583c.467 16.789 12.581 17.04 17.741 17.188l-11.92-27.837-5.821 10.649z\"/><radialGradient id=\"m\" cx=\"130.847\" cy=\"2184.281\" r=\"21.762\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#A80D00\"/><stop offset=\"0\" stop-color=\"#A80D00\"/><stop offset=\".99\" stop-color=\"#7E0E08\"/><stop offset=\"1\" stop-color=\"#7E0E08\"/></radialGradient><path fill=\"url(#m)\" d=\"M73.337 32.232c7.615 4.68 22.96 14.08 23.271 14.253.484.272 6.617-10.342 8.008-16.34l-31.279 2.087z\"/><radialGradient id=\"n\" cx=\"100.707\" cy=\"2155.602\" r=\"28.932\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#A30C00\"/><stop offset=\"0\" stop-color=\"#A30C00\"/><stop offset=\".99\" stop-color=\"#800E08\"/><stop offset=\"1\" stop-color=\"#800E08\"/></radialGradient><path fill=\"url(#n)\" d=\"M48.772 54.986l13.207 25.48c7.81-4.235 13.924-9.395 19.526-14.922L48.772 54.986z\"/><linearGradient id=\"o\" gradientUnits=\"userSpaceOnUse\" x1=\"80.214\" y1=\"2133.309\" x2=\"73.005\" y2=\"2157.766\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#8B2114\"/><stop offset=\"0\" stop-color=\"#8B2114\"/><stop offset=\".43\" stop-color=\"#9E100A\"/><stop offset=\".99\" stop-color=\"#B3100C\"/><stop offset=\"1\" stop-color=\"#B3100C\"/></linearGradient><path fill=\"url(#o)\" d=\"M26.957 59.969l-1.872 22.282c3.532 4.823 8.389 5.241 13.485 4.866-3.687-9.175-11.051-27.521-11.613-27.148z\"/><linearGradient id=\"p\" gradientUnits=\"userSpaceOnUse\" x1=\"135.518\" y1=\"2214.356\" x2=\"151.68\" y2=\"2207.222\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2221)\"><stop offset=\"0\" stop-color=\"#B31000\"/><stop offset=\"0\" stop-color=\"#B31000\"/><stop offset=\".44\" stop-color=\"#910F08\"/><stop offset=\".99\" stop-color=\"#791C12\"/><stop offset=\"1\" stop-color=\"#791C12\"/></linearGradient><path fill=\"url(#p)\" d=\"M79.919 10.02l26.237 3.683c-1.401-5.935-5.701-9.763-13.03-10.961L79.919 10.02z\"/></svg>"

/***/ }),

/***/ "../src/components/ruby/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RubyOriginalWordmark = __webpack_require__("../src/components/ruby/original-wordmark/RubyOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RubyOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ruby/original/RubyOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RubyOriginal = __webpack_require__("../src/components/ruby/original/RubyOriginal.svg");
	
	var _RubyOriginal2 = _interopRequireDefault(_RubyOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RubyOriginal */
	function RubyOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RubyOriginal',
	    svg: _RubyOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RubyOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RubyOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ruby/original/RubyOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"157.08\" y1=\"2382.05\" x2=\"131.682\" y2=\"2426.892\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#FB7655\"/><stop offset=\"0\" stop-color=\"#FB7655\"/><stop offset=\".41\" stop-color=\"#E42B1E\"/><stop offset=\".99\" stop-color=\"#900\"/><stop offset=\"1\" stop-color=\"#900\"/></linearGradient><path fill=\"url(#a)\" d=\"M97.078 83.214L28.34 124.031l89.003-6.04 6.855-89.745z\"/><linearGradient id=\"b\" gradientUnits=\"userSpaceOnUse\" x1=\"169.731\" y1=\"2419.72\" x2=\"136.998\" y2=\"2441.685\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#871101\"/><stop offset=\"0\" stop-color=\"#871101\"/><stop offset=\".99\" stop-color=\"#911209\"/><stop offset=\"1\" stop-color=\"#911209\"/></linearGradient><path fill=\"url(#b)\" d=\"M117.488 117.93l-7.649-52.799-20.837 27.514z\"/><linearGradient id=\"c\" gradientUnits=\"userSpaceOnUse\" x1=\"143.542\" y1=\"2380.69\" x2=\"110.81\" y2=\"2402.655\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#871101\"/><stop offset=\"0\" stop-color=\"#871101\"/><stop offset=\".99\" stop-color=\"#911209\"/><stop offset=\"1\" stop-color=\"#911209\"/></linearGradient><path fill=\"url(#c)\" d=\"M117.592 117.93l-56.044-4.399-32.91 10.385z\"/><linearGradient id=\"d\" gradientUnits=\"userSpaceOnUse\" x1=\"74.817\" y1=\"2435.622\" x2=\"79.891\" y2=\"2402.644\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\".23\" stop-color=\"#E57252\"/><stop offset=\".46\" stop-color=\"#DE3B20\"/><stop offset=\".99\" stop-color=\"#A60003\"/><stop offset=\"1\" stop-color=\"#A60003\"/></linearGradient><path fill=\"url(#d)\" d=\"M28.717 123.928l14.001-45.867-30.81 6.588z\"/><linearGradient id=\"e\" gradientUnits=\"userSpaceOnUse\" x1=\"109.719\" y1=\"2466.413\" x2=\"111.589\" y2=\"2432.757\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\".23\" stop-color=\"#E4714E\"/><stop offset=\".56\" stop-color=\"#BE1A0D\"/><stop offset=\".99\" stop-color=\"#A80D00\"/><stop offset=\"1\" stop-color=\"#A80D00\"/></linearGradient><path fill=\"url(#e)\" d=\"M88.996 92.797l-12.882-50.46-36.866 34.558z\"/><linearGradient id=\"f\" gradientUnits=\"userSpaceOnUse\" x1=\"140.691\" y1=\"2497.523\" x2=\"146.289\" y2=\"2473.401\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\".18\" stop-color=\"#E46342\"/><stop offset=\".4\" stop-color=\"#C82410\"/><stop offset=\".99\" stop-color=\"#A80D00\"/><stop offset=\"1\" stop-color=\"#A80D00\"/></linearGradient><path fill=\"url(#f)\" d=\"M121.275 43.047L86.426 14.585l-9.704 31.373z\"/><linearGradient id=\"g\" gradientUnits=\"userSpaceOnUse\" x1=\"123.6\" y1=\"2506.018\" x2=\"147.719\" y2=\"2518.077\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\".54\" stop-color=\"#C81F11\"/><stop offset=\".99\" stop-color=\"#BF0905\"/><stop offset=\"1\" stop-color=\"#BF0905\"/></linearGradient><path fill=\"url(#g)\" d=\"M104.978 4.437L84.481 15.764 71.551 4.285z\"/><linearGradient id=\"h\" gradientUnits=\"userSpaceOnUse\" x1=\"53.674\" y1=\"2444.028\" x2=\"55.66\" y2=\"2424.153\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\"0\" stop-color=\"#fff\"/><stop offset=\".31\" stop-color=\"#DE4024\"/><stop offset=\".99\" stop-color=\"#BF190B\"/><stop offset=\"1\" stop-color=\"#BF190B\"/></linearGradient><path fill=\"url(#h)\" d=\"M3.802 100.034l8.586-15.659L5.442 65.72z\"/><path fill=\"#fff\" d=\"M4.981 65.131l6.987 19.821 30.365-6.812L77 45.922l9.783-31.075L71.38 3.969l-26.19 9.802c-8.252 7.675-24.263 22.86-24.84 23.146-.573.291-10.575 19.195-15.369 28.214z\"/><linearGradient id=\"i\" gradientUnits=\"userSpaceOnUse\" x1=\"40.026\" y1=\"2418.781\" x2=\"133.345\" y2=\"2514.739\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#BD0012\"/><stop offset=\"0\" stop-color=\"#BD0012\"/><stop offset=\".07\" stop-color=\"#fff\"/><stop offset=\".17\" stop-color=\"#fff\"/><stop offset=\".27\" stop-color=\"#C82F1C\"/><stop offset=\".33\" stop-color=\"#820C01\"/><stop offset=\".46\" stop-color=\"#A31601\"/><stop offset=\".72\" stop-color=\"#B31301\"/><stop offset=\".99\" stop-color=\"#E82609\"/><stop offset=\"1\" stop-color=\"#E82609\"/></linearGradient><path fill=\"url(#i)\" d=\"M29.519 29.521c17.882-17.73 40.937-28.207 49.785-19.28 8.843 8.926-.534 30.62-18.418 48.345-17.884 17.725-40.653 28.779-49.493 19.852-8.849-8.92.242-31.191 18.126-48.917z\"/><linearGradient id=\"j\" gradientUnits=\"userSpaceOnUse\" x1=\"111.507\" y1=\"2409.102\" x2=\"83.398\" y2=\"2416.039\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#8C0C01\"/><stop offset=\"0\" stop-color=\"#8C0C01\"/><stop offset=\".54\" stop-color=\"#990C00\"/><stop offset=\".99\" stop-color=\"#A80D0E\"/><stop offset=\"1\" stop-color=\"#A80D0E\"/></linearGradient><path fill=\"url(#j)\" d=\"M28.717 123.909l13.89-46.012 46.135 14.82c-16.68 15.642-35.233 28.865-60.025 31.192z\"/><linearGradient id=\"k\" gradientUnits=\"userSpaceOnUse\" x1=\"159.785\" y1=\"2442.837\" x2=\"134.814\" y2=\"2465.217\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#7E110B\"/><stop offset=\"0\" stop-color=\"#7E110B\"/><stop offset=\".99\" stop-color=\"#9E0C00\"/><stop offset=\"1\" stop-color=\"#9E0C00\"/></linearGradient><path fill=\"url(#k)\" d=\"M77.062 45.831l11.844 46.911c13.934-14.65 26.439-30.401 32.563-49.883l-44.407 2.972z\"/><linearGradient id=\"l\" gradientUnits=\"userSpaceOnUse\" x1=\"168.959\" y1=\"2483.901\" x2=\"156.521\" y2=\"2497.199\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#79130D\"/><stop offset=\"0\" stop-color=\"#79130D\"/><stop offset=\".99\" stop-color=\"#9E120B\"/><stop offset=\"1\" stop-color=\"#9E120B\"/></linearGradient><path fill=\"url(#l)\" d=\"M121.348 43.097c4.74-14.305 5.833-34.825-16.517-38.635l-18.339 10.13 34.856 28.505z\"/><path fill=\"#9E1209\" d=\"M3.802 99.828c.656 23.608 17.689 23.959 24.945 24.167l-16.759-39.14-8.186 14.973z\"/><radialGradient id=\"m\" cx=\"138.703\" cy=\"2464.789\" r=\"30.601\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#A80D00\"/><stop offset=\"0\" stop-color=\"#A80D00\"/><stop offset=\".99\" stop-color=\"#7E0E08\"/><stop offset=\"1\" stop-color=\"#7E0E08\"/></radialGradient><path fill=\"url(#m)\" d=\"M77.128 45.904c10.708 6.581 32.286 19.798 32.723 20.041.68.383 9.304-14.542 11.261-22.976l-43.984 2.935z\"/><radialGradient id=\"n\" cx=\"96.325\" cy=\"2424.465\" r=\"40.679\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#A30C00\"/><stop offset=\"0\" stop-color=\"#A30C00\"/><stop offset=\".99\" stop-color=\"#800E08\"/><stop offset=\"1\" stop-color=\"#800E08\"/></radialGradient><path fill=\"url(#n)\" d=\"M42.589 77.897l18.57 35.828c10.98-5.955 19.579-13.211 27.454-20.983L42.589 77.897z\"/><linearGradient id=\"o\" gradientUnits=\"userSpaceOnUse\" x1=\"67.509\" y1=\"2393.115\" x2=\"57.373\" y2=\"2427.506\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#8B2114\"/><stop offset=\"0\" stop-color=\"#8B2114\"/><stop offset=\".43\" stop-color=\"#9E100A\"/><stop offset=\".99\" stop-color=\"#B3100C\"/><stop offset=\"1\" stop-color=\"#B3100C\"/></linearGradient><path fill=\"url(#o)\" d=\"M11.914 84.904l-2.631 31.331c4.964 6.781 11.794 7.371 18.96 6.842-5.184-12.9-15.538-38.696-16.329-38.173z\"/><linearGradient id=\"p\" gradientUnits=\"userSpaceOnUse\" x1=\"145.272\" y1=\"2507.076\" x2=\"167.996\" y2=\"2497.045\" gradientTransform=\"matrix(1 0 0 -1 -47.5 2517)\"><stop offset=\"0\" stop-color=\"#B31000\"/><stop offset=\"0\" stop-color=\"#B31000\"/><stop offset=\".44\" stop-color=\"#910F08\"/><stop offset=\".99\" stop-color=\"#791C12\"/><stop offset=\"1\" stop-color=\"#791C12\"/></linearGradient><path fill=\"url(#p)\" d=\"M86.384 14.67l36.891 5.177c-1.969-8.343-8.015-13.727-18.32-15.41L86.384 14.67z\"/></svg>"

/***/ }),

/***/ "../src/components/ruby/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RubyOriginal = __webpack_require__("../src/components/ruby/original/RubyOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RubyOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ruby/plain-wordmark/RubyPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RubyPlainWordmark = __webpack_require__("../src/components/ruby/plain-wordmark/RubyPlainWordmark.svg");
	
	var _RubyPlainWordmark2 = _interopRequireDefault(_RubyPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RubyPlainWordmark */
	function RubyPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RubyPlainWordmark',
	    svg: _RubyPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RubyPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RubyPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ruby/plain-wordmark/RubyPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#D91404\" d=\"M82.518 54.655c-12.92 8.326-25.722 16.577-38.862 25.043l58.715 8.016-19.853-33.059zm25.409-36.843c-1.735 2.604-3.473 5.207-5.205 7.813A46257.18 46257.18 0 0 0 84.881 52.48c-.331.5-.76.896-.294 1.664 5.744 9.483 11.441 18.996 17.152 28.498.901 1.501 1.813 2.996 2.979 4.436l3.463-69.191-.254-.075zM29.529 47.38c.269.255.94.402 1.251.249 5.509-2.708 11.053-5.355 16.442-8.286 1.756-.954 3.106-2.667 4.621-4.055a9782.293 9782.293 0 0 0 15.021-13.812c.307-.283.668-.556.852-.913 1.797-3.513 3.562-7.042 5.391-10.675-2.181-.817-4.248-1.62-6.34-2.35-.284-.099-.73.098-1.04.27-4.843 2.706-9.777 5.267-14.467 8.218-2.347 1.476-4.259 3.651-6.337 5.547-3.347 3.056-6.692 6.119-9.992 9.229a17.14 17.14 0 0 0-2.355 2.76c-2.258 3.286-4.446 6.619-6.737 10.048 1.282 1.326 2.445 2.592 3.69 3.77zm20.133-4.493c-2.739 11.577-5.465 23.088-8.279 34.978L80.284 52.8l-30.622-9.913zm21.837-19.441l11.22 27.292c7.324-11.001 14.502-21.785 21.843-32.815l-33.063 5.523zM50.122 40.519l30.012 9.743c-3.761-9.163-7.393-18.005-11.101-27.035L50.122 40.519zM29.944 54.131L19.44 79.24l20.005-.591-9.501-24.518zm9.739 18.695l.248-.054c2.401-9.988 4.838-19.907 7.291-30.284l-16.05 8.341c2.735 7.112 5.653 14.612 8.511 21.997zm60.842-56.522c-3.195-.846-6.387-1.696-9.585-2.536-4.593-1.207-9.19-2.401-13.781-3.62-.573-.152-.989-.251-1.326.44-1.622 3.324-3.296 6.624-4.944 9.935-.051.103-.041.237-.08.492l29.71-4.502.006-.209zM81.993 8.742l26.037 7.203-4.302-12.258-21.696 4.811-.039.244zM89.875 88.1l-21.361-2.916c-8.873-1.211-17.73-2.544-26.623-3.569-3.225-.371-6.536-.029-9.806.026-2.687.046-5.374.148-8.06.233-.277.008-.553.064-.828.361 22.21 2.054 44.422 4.107 66.631 6.162l.047-.297zM19.878 71.576c2.864-6.641 5.712-13.287 8.586-19.922.288-.667.267-1.118-.296-1.653-1.203-1.145-2.319-2.378-3.634-3.744l-5.241 25.871.193.092c.133-.214.294-.414.392-.644zM76.29 6.989c4.827-1.246 9.724-2.218 14.592-3.305.314-.071.622-.175.932-.264l-.047-.238-20.916 2.813c1.965.859 3.478 1.5 5.439.994zM30.975 109.422v8.547h-4.724V95.692h6.491c3.026 0 5.266.551 6.719 1.653s2.18 2.776 2.18 5.02c0 1.311-.361 2.477-1.083 3.497-.721 1.021-1.741 1.822-3.063 2.401l6.553 9.705h-5.242l-5.317-8.547h-2.514zm0-3.84h1.524c1.492 0 2.595-.25 3.306-.747.71-.498 1.066-1.28 1.066-2.346 0-1.057-.363-1.808-1.09-2.255-.726-.447-1.851-.671-3.374-.671h-1.433v6.019zm27.578 12.387l-.624-2.179h-.244c-.498.793-1.204 1.404-2.117 1.836-.915.432-1.957.647-3.124.647-2.002 0-3.51-.535-4.526-1.607s-1.523-2.613-1.523-4.624v-11.108h4.647v9.95c0 1.229.219 2.151.656 2.766.436.615 1.131.921 2.086.921 1.301 0 2.24-.435 2.819-1.302.579-.869.869-2.308.869-4.319v-8.015h4.647v17.035h-3.566zm17.919-17.356c2.011 0 3.586.786 4.725 2.355 1.137 1.569 1.705 3.72 1.705 6.453 0 2.813-.587 4.992-1.759 6.535-1.174 1.545-2.771 2.316-4.793 2.316-2.001 0-3.57-.727-4.708-2.18h-.32l-.776 1.875h-3.551V94.26h4.647v5.516c0 .701-.062 1.823-.184 3.368h.184c1.086-1.686 2.697-2.531 4.83-2.531zm-1.494 3.719c-1.147 0-1.985.353-2.513 1.059-.528.707-.804 1.872-.823 3.498v.502c0 1.829.271 3.139.814 3.932.544.792 1.405 1.188 2.584 1.188.954 0 1.713-.44 2.277-1.318s.846-2.156.846-3.832c0-1.676-.285-2.934-.854-3.772-.568-.838-1.345-1.257-2.331-1.257zm9.021-3.398h5.089l3.215 9.584c.274.833.463 1.818.563 2.956h.092c.111-1.046.329-2.032.654-2.956l3.154-9.584h4.982l-7.207 19.214c-.66 1.777-1.602 3.108-2.825 3.992-1.225.884-2.654 1.325-4.29 1.325-.803 0-1.59-.086-2.361-.259v-3.687a8.004 8.004 0 0 0 1.828.197c.822 0 1.541-.251 2.156-.754.615-.502 1.095-1.261 1.439-2.277l.274-.839-6.763-16.912z\"/></svg>"

/***/ }),

/***/ "../src/components/ruby/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RubyPlainWordmark = __webpack_require__("../src/components/ruby/plain-wordmark/RubyPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RubyPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ruby/plain/RubyPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RubyPlain = __webpack_require__("../src/components/ruby/plain/RubyPlain.svg");
	
	var _RubyPlain2 = _interopRequireDefault(_RubyPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RubyPlain */
	function RubyPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RubyPlain',
	    svg: _RubyPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RubyPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RubyPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ruby/plain/RubyPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#D91404\" d=\"M35.971 111.33l81.958 11.188c-9.374-15.606-18.507-30.813-27.713-46.144L35.971 111.33zm89.71-86.383c-2.421 3.636-4.847 7.269-7.265 10.907a67619.72 67619.72 0 0 0-24.903 37.485c-.462.696-1.061 1.248-.41 2.321 8.016 13.237 15.969 26.513 23.942 39.777 1.258 2.095 2.53 4.182 4.157 6.192l4.834-96.58-.355-.102zM16.252 66.22c.375.355 1.311.562 1.747.347 7.689-3.779 15.427-7.474 22.948-11.564 2.453-1.333 4.339-3.723 6.452-5.661 6.997-6.417 13.983-12.847 20.966-19.278.427-.395.933-.777 1.188-1.275 2.508-4.902 4.973-9.829 7.525-14.898-3.043-1.144-5.928-2.263-8.849-3.281-.396-.138-1.02.136-1.449.375-6.761 3.777-13.649 7.353-20.195 11.472-3.275 2.061-5.943 5.098-8.843 7.743-4.674 4.266-9.342 8.542-13.948 12.882a24.011 24.011 0 0 0-3.288 3.854c-3.15 4.587-6.206 9.24-9.402 14.025 1.786 1.847 3.41 3.613 5.148 5.259zm28.102-6.271l-11.556 48.823 54.3-34.987-42.744-13.836zm76.631-34.846l-46.15 7.71 15.662 38.096c10.221-15.359 20.24-30.41 30.488-45.806zM44.996 56.644l41.892 13.6c-5.25-12.79-10.32-25.133-15.495-37.737L44.996 56.644zM16.831 75.643L2.169 110.691l27.925-.825-13.263-34.223zm13.593 26.096l.346-.076c3.353-13.941 6.754-27.786 10.177-42.272L18.544 71.035c3.819 9.926 7.891 20.397 11.88 30.704zm84.927-78.897c-4.459-1.181-8.918-2.366-13.379-3.539-6.412-1.686-12.829-3.351-19.237-5.052-.801-.213-1.38-.352-1.851.613-2.265 4.64-4.6 9.245-6.901 13.868-.071.143-.056.328-.111.687l41.47-6.285.009-.292zM89.482 12.288l36.343 10.054-6.005-17.11-30.285 6.715-.053.341zM33.505 114.007c-4.501-.519-9.122-.042-13.687.037-3.75.063-7.5.206-11.25.323-.386.012-.771.09-1.156.506 31.003 2.866 62.005 5.732 93.007 8.6l.063-.414-29.815-4.07c-12.384-1.691-24.747-3.551-37.162-4.982zM2.782 99.994c3.995-9.27 7.973-18.546 11.984-27.809.401-.929.37-1.56-.415-2.308-1.678-1.597-3.237-3.318-5.071-5.226-2.479 12.24-4.897 24.177-7.317 36.113l.271.127c.185-.297.411-.578.548-.897zm78.74-90.153c6.737-1.738 13.572-3.097 20.367-4.613.44-.099.87-.244 1.303-.368l-.067-.332-29.194 3.928c2.741 1.197 4.853 2.091 7.591 1.385z\"/></svg>"

/***/ }),

/***/ "../src/components/ruby/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RubyPlain = __webpack_require__("../src/components/ruby/plain/RubyPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RubyPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rubymine/original-wordmark/RubymineOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RubymineOriginalWordmark = __webpack_require__("../src/components/rubymine/original-wordmark/RubymineOriginalWordmark.svg");
	
	var _RubymineOriginalWordmark2 = _interopRequireDefault(_RubymineOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RubymineOriginalWordmark */
	function RubymineOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RubymineOriginalWordmark',
	    svg: _RubymineOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RubymineOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RubymineOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rubymine/original-wordmark/RubymineOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"ruby_mine\" data-name=\"ruby mine\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#c12c4c}.cls-2{fill:#fa930d}</style></defs><title>Artboard 12</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M40.29 59.66a26.92 26.92 0 0 1 4.08-.28c2 0 3.42.3 4.38 1.07A3.44 3.44 0 0 1 50 63.28a3.6 3.6 0 0 1-2.39 3.34v.06a3.42 3.42 0 0 1 1.81 2.53c.42 1.53.84 3.3 1.11 3.82h-3.14a17 17 0 0 1-.94-3.16c-.36-1.69-.94-2.15-2.19-2.17h-.92V73h-3V59.66zm3 5.83h1.21c1.53 0 2.43-.76 2.43-1.95s-.85-1.87-2.25-1.89a7.64 7.64 0 0 0-1.39.1zM61.37 69.87c0 1.29 0 2.33.08 3.16H58.8l-.14-1.39h-.06a3.51 3.51 0 0 1-3.08 1.61c-2 0-3.46-1.25-3.46-4.28V63.2h3.08v5.29c0 1.43.46 2.29 1.53 2.29a1.64 1.64 0 0 0 1.53-1.07 1.71 1.71 0 0 0 .1-.66V63.2h3.08zM63.74 73c0-.64.08-1.83.08-2.93V58.76h3.05v5.61a3.46 3.46 0 0 1 3-1.39c2.35 0 4.08 1.95 4.06 5 0 3.54-2.25 5.31-4.5 5.31a3.26 3.26 0 0 1-3-1.59l-.09 1.3zm3.14-4.18a2.23 2.23 0 0 0 .06.54 1.85 1.85 0 0 0 1.79 1.45c1.31 0 2.11-1 2.11-2.77 0-1.53-.68-2.73-2.11-2.73a1.89 1.89 0 0 0-1.79 1.51 2.53 2.53 0 0 0-.06.56zM78 63.2l1.42 4.8c.16.58.36 1.31.48 1.83h.1c.14-.52.3-1.27.44-1.83l1.21-4.82h3.28l-2.33 6.49c-1.41 3.9-2.35 5.47-3.46 6.45a5.63 5.63 0 0 1-3 1.35l-.64-2.59a3.87 3.87 0 0 0 1.33-.52 3.51 3.51 0 0 0 1.27-1.23.79.79 0 0 0 .16-.44 1.11 1.11 0 0 0-.14-.5l-3.6-9H78zM97.89 67.08c-.1-1.89-.22-4.16-.2-5.85h-.06c-.46 1.59-1 3.28-1.71 5.15l-2.39 6.57H92.2L90 66.49c-.64-1.91-1.19-3.66-1.57-5.27 0 1.69-.14 4-.26 6L87.78 73h-1.67l.94-13.55h2.23L91.6 66c.56 1.67 1 3.16 1.37 4.56H93c.34-1.37.82-2.85 1.43-4.56l2.41-6.55h2.26L99.94 73h-1.71zM104.78 60.56a1.1 1.1 0 0 1-2.19 0 1.08 1.08 0 0 1 1.11-1.11 1 1 0 0 1 1.08 1.11zm-2 12.46V63.3h1.77V73zM107.51 65.93c0-1 0-1.83-.08-2.63H109l.1 1.61a3.58 3.58 0 0 1 3.22-1.83c1.35 0 3.44.8 3.44 4.14V73H114v-5.58c0-1.57-.58-2.87-2.25-2.87a2.51 2.51 0 0 0-2.37 1.81 2.55 2.55 0 0 0-.12.82V73h-1.77v-7.1zM119.65 68.48a3.12 3.12 0 0 0 3.35 3.38 6.4 6.4 0 0 0 2.69-.5l.3 1.27a7.88 7.88 0 0 1-3.24.6c-3 0-4.78-2-4.78-4.91s1.73-5.25 4.56-5.25c3.18 0 4 2.79 4 4.58a6.82 6.82 0 0 1-.06.82zm5.19-1.27c0-1.13-.46-2.87-2.45-2.87-1.79 0-2.57 1.65-2.71 2.87zM28.91 70.77c-.29-.46-3-4.17-3.23-4.62l-.09-.15.15-.11a8.81 8.81 0 0 0 3.74-7.18v-.24a7.75 7.75 0 0 0-1.91-5.21 8.56 8.56 0 0 0-5.79-2.62v5.75a3 3 0 0 1 2.06 3c0 1.69-1.31 2.59-2.41 3.25l-.44.26a3.12 3.12 0 0 0-1.48 2.72 4.74 4.74 0 0 0 .42 1.89l.38.67 4 5.7.07.1.54.78a2.39 2.39 0 0 0 1.38.89 3 3 0 0 0 2.29-.41 2.48 2.48 0 0 0 1.12-1.69v-.48a4.27 4.27 0 0 0-.8-2.3z\"/><path class=\"cls-2\" d=\"M20.49 50.57a8.52 8.52 0 0 0-2.08.42l-.18.07c-.2.07-.4.15-.6.24l-.22.11c-.2.1-.39.18-.58.29a8.43 8.43 0 0 0-1.32.95A8.46 8.46 0 0 0 1.45 59v16.21h5.77V59a2.7 2.7 0 0 1 5.4 0v16.18h5.76V59a2 2 0 0 1 0-.21v-.14a2.69 2.69 0 0 1 2.07-2.25v-5.83z\"/></g></svg>"

/***/ }),

/***/ "../src/components/rubymine/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RubymineOriginalWordmark = __webpack_require__("../src/components/rubymine/original-wordmark/RubymineOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RubymineOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rubymine/original/RubymineOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RubymineOriginal = __webpack_require__("../src/components/rubymine/original/RubymineOriginal.svg");
	
	var _RubymineOriginal2 = _interopRequireDefault(_RubymineOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RubymineOriginal */
	function RubymineOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RubymineOriginal',
	    svg: _RubymineOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RubymineOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RubymineOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rubymine/original/RubymineOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"ruby_mine\" data-name=\"ruby mine\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#c12c4c}.cls-2{fill:#fa930d}</style></defs><title>Artboard 14</title><g id=\"original\"><path class=\"cls-1\" d=\"M122.19 97.45c-1.28-2-13.17-18.24-14.14-20.19l-.35-.69.64-.46a38.51 38.51 0 0 0 16.33-31.41v-1.06c0-8.69-3-17-8.34-22.77-6.2-6.76-15.11-10.73-25.33-11.47v25.14c5.37 1.54 9 6.52 9 13 0 7.4-5.73 11.34-10.54 14.19l-1.91 1.16a13.63 13.63 0 0 0-6.49 11.89 20.74 20.74 0 0 0 1.85 8.27l1.7 2.95 17.44 25 .28.43 2.35 3.42a10.44 10.44 0 0 0 6 3.88 12.94 12.94 0 0 0 10-1.79 10.83 10.83 0 0 0 4.91-7.37l.21-2.08a18.65 18.65 0 0 0-3.61-10.04z\"/><path class=\"cls-2\" d=\"M85.39 9.14A37.23 37.23 0 0 0 76.28 11c-.26.09-.51.21-.77.3-.89.32-1.76.65-2.62 1-.33.15-.65.33-1 .49-.85.42-1.72.8-2.54 1.28a36.86 36.86 0 0 0-5.76 4.14A37 37 0 0 0 2.15 46a.61.61 0 0 0 0 .12v70.78h25.19V46.15a.78.78 0 0 1 0-.12A11.82 11.82 0 0 1 51 45.92V46a.63.63 0 0 0 0 .12v70.78h25.2V46.14v-.08-.1a8.8 8.8 0 0 1 .1-.92v-.64a11.75 11.75 0 0 1 9.06-9.85V9.14z\"/></g></svg>"

/***/ }),

/***/ "../src/components/rubymine/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RubymineOriginal = __webpack_require__("../src/components/rubymine/original/RubymineOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RubymineOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rubymine/plain-wordmark/RubyminePlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RubyminePlainWordmark = __webpack_require__("../src/components/rubymine/plain-wordmark/RubyminePlainWordmark.svg");
	
	var _RubyminePlainWordmark2 = _interopRequireDefault(_RubyminePlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RubyminePlainWordmark */
	function RubyminePlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RubyminePlainWordmark',
	    svg: _RubyminePlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RubyminePlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RubyminePlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rubymine/plain-wordmark/RubyminePlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"ruby_mine\" data-name=\"ruby mine\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#c12c4c}</style></defs><title>Artboard 13</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M40.64 60.2a29.74 29.74 0 0 1 4-.25 7.46 7.46 0 0 1 4.32.93 2.89 2.89 0 0 1 1.23 2.48 3.22 3.22 0 0 1-2.36 2.93v.05a3 3 0 0 1 1.78 2.22 32.35 32.35 0 0 0 1.09 3.35h-3.07a13.72 13.72 0 0 1-.93-2.77c-.36-1.48-.93-1.89-2.16-1.9h-.91v4.67h-3V60.2zm3 5.11h1.19c1.51 0 2.4-.67 2.4-1.71S46.38 62 45 61.94a8.42 8.42 0 0 0-1.37.09v3.28zM61.41 69.15c0 1.13 0 2 .08 2.77h-2.61l-.14-1.22h-.06a3.56 3.56 0 0 1-3 1.41c-2 0-3.41-1.09-3.41-3.75V63.3h3v4.63c0 1.25.46 2 1.51 2a1.62 1.62 0 0 0 1.5-.93 1.35 1.35 0 0 0 .1-.58V63.3h3v5.85zM63.75 71.91c0-.56.08-1.6.08-2.57V59.4h3v4.92a3.58 3.58 0 0 1 2.93-1.22c2.32 0 4 1.71 4 4.35a4.36 4.36 0 0 1-4.44 4.65 3.34 3.34 0 0 1-2.91-1.39l-.12 1.2h-2.54zm3.09-3.67a1.75 1.75 0 0 0 .06.48A1.78 1.78 0 0 0 68.66 70c1.29 0 2.08-.88 2.08-2.43 0-1.34-.67-2.4-2.08-2.4a1.82 1.82 0 0 0-1.76 1.32 2 2 0 0 0-.06.49zM77.74 63.3l1.45 4.23c.16.51.36 1.15.48 1.6h.06c.14-.46.3-1.11.44-1.6l1.19-4.23h3.23L82.32 69c-1.39 3.42-2.32 4.79-3.41 5.66A5.9 5.9 0 0 1 76 75.81l-.63-2.27a4.11 4.11 0 0 0 1.31-.46A3.31 3.31 0 0 0 77.92 72a.65.65 0 0 0 .16-.39.89.89 0 0 0-.14-.44L74.4 63.3h3.35zM97.39 66.7c-.1-1.66-.22-3.65-.2-5.13h-.06c-.46 1.39-1 2.87-1.68 4.51l-2.36 5.76h-1.31l-2.16-5.66c-.62-1.67-1.17-3.18-1.54-4.61 0 1.48-.14 3.47-.26 5.25l-.36 5.09h-1.68L86.71 60h2.2l2.28 5.75c.55 1.46 1 2.77 1.35 4h.06a41.54 41.54 0 0 1 1.41-4L96.38 60h2.2l.83 11.88h-1.69zM104.17 61c0 .53-.42 1-1.11 1a1 1 0 0 1-1-1 1 1 0 0 1 1.09-1 1 1 0 0 1 1.02 1zm-1.94 10.93v-8.54H104v8.53h-1.74zM106.87 65.69c0-.88 0-1.6-.08-2.31h1.54l.1 1.41a3.61 3.61 0 0 1 3.17-1.6 3.26 3.26 0 0 1 3.4 3.63v5.09h-1.74V67c0-1.37-.57-2.52-2.22-2.52a2.45 2.45 0 0 0-2.34 1.59 2 2 0 0 0-.12.72v5.13h-1.74v-6.23zM118.82 67.93c0 2.1 1.54 3 3.29 3a7 7 0 0 0 2.65-.44l.3 1.11a8.6 8.6 0 0 1-3.19.53c-3 0-4.71-1.73-4.71-4.3a4.34 4.34 0 0 1 4.5-4.6 3.77 3.77 0 0 1 4 4 5.35 5.35 0 0 1-.06.72h-6.73zm5.11-1.11a2.29 2.29 0 0 0-2.42-2.52 2.71 2.71 0 0 0-2.67 2.52zM29.43 69.93c-.29-.4-3-3.66-3.19-4l-.08-.14.14-.09a7.51 7.51 0 0 0 3.7-6.34v-.21a6.37 6.37 0 0 0-1.88-4.57 8.92 8.92 0 0 0-5.71-2.3v5a2.62 2.62 0 0 1 2 2.62c0 1.48-1.29 2.27-2.38 2.85l-.43.23a2.67 2.67 0 0 0-1.46 2.38 3.79 3.79 0 0 0 .42 1.66l.38.59 3.93 5 .06.09.53.69a2.39 2.39 0 0 0 1.36.78 3.22 3.22 0 0 0 2.26-.36 2.18 2.18 0 0 0 1.11-1.48v-.42a3.49 3.49 0 0 0-.76-1.98z\"/><path class=\"cls-1\" d=\"M21.14 52.23a9.3 9.3 0 0 0-2.05.37l-.17.06-.59.21-.22.1c-.19.08-.39.16-.57.26a8.36 8.36 0 0 0-1.3.83 8.91 8.91 0 0 0-5.5-1.85c-4.61 0-8.35 3.33-8.35 7.43v14.19h5.67V59.64a2.53 2.53 0 0 1 2.66-2.37 2.53 2.53 0 0 1 2.66 2.35V73.81h5.68V59.65a1.58 1.58 0 0 1 0-.18v-.12a2.49 2.49 0 0 1 2-2v-5.12z\"/></g></svg>"

/***/ }),

/***/ "../src/components/rubymine/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RubyminePlainWordmark = __webpack_require__("../src/components/rubymine/plain-wordmark/RubyminePlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RubyminePlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rubymine/plain/RubyminePlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _RubyminePlain = __webpack_require__("../src/components/rubymine/plain/RubyminePlain.svg");
	
	var _RubyminePlain2 = _interopRequireDefault(_RubyminePlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RubyminePlain */
	function RubyminePlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'RubyminePlain',
	    svg: _RubyminePlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	RubyminePlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = RubyminePlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/rubymine/plain/RubyminePlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"ruby_mine\" data-name=\"ruby mine\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#c12c4c}</style></defs><title>Artboard 15</title><g id=\"plain\"><path class=\"cls-1\" d=\"M118 97.51c-1.19-2-12.23-18.28-13.13-20.23l-.33-.69.6-.47a39.57 39.57 0 0 0 15.18-31.47V43.6c0-8.71-2.82-17-7.75-22.81-5.72-6.79-14-10.79-23.48-11.5v25.2c5 1.54 8.38 6.53 8.38 13.07 0 7.42-5.32 11.36-9.79 14.22l-1.78 1.15a14 14 0 0 0-6 11.91 22.11 22.11 0 0 0 1.72 8.29l1.55 2.93 16.2 25 .26.44 2.18 3.42a9.67 9.67 0 0 0 5.61 3.89 11.29 11.29 0 0 0 9.3-1.8 10.92 10.92 0 0 0 4.56-7.38l.19-2.08A19.64 19.64 0 0 0 118 97.51z\"/><path class=\"cls-1\" d=\"M83.87 9a32.38 32.38 0 0 0-8.46 1.83c-.24.09-.47.21-.71.3-.82.32-1.64.65-2.43 1-.31.15-.6.33-.91.49-.79.42-1.6.8-2.36 1.28a34.43 34.43 0 0 0-5.35 4.15A32.84 32.84 0 0 0 41 8.86C22 8.86 6.55 25.48 6.55 46a.66.66 0 0 0 0 .12V117H30V46.1a.84.84 0 0 1 0-.1c0-6.55 4.92-11.85 11-11.85S51.92 39.4 52 45.9v.1a.68.68 0 0 0 0 .12v70.89h23.32v-70.9-.08-.1c0-.32.06-.61.09-.92v-.61a11.47 11.47 0 0 1 8.42-9.87V9z\"/></g></svg>"

/***/ }),

/***/ "../src/components/rubymine/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RubyminePlain = __webpack_require__("../src/components/rubymine/plain/RubyminePlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RubyminePlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/safari/line-wordmark/SafariLineWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SafariLineWordmark = __webpack_require__("../src/components/safari/line-wordmark/SafariLineWordmark.svg");
	
	var _SafariLineWordmark2 = _interopRequireDefault(_SafariLineWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SafariLineWordmark */
	function SafariLineWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SafariLineWordmark',
	    svg: _SafariLineWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SafariLineWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SafariLineWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/safari/line-wordmark/SafariLineWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M32.7 112.6c-3.3-1.3-4.8-2.4-4.8-4.7 0-1.7 1.3-3.6 4.6-3.6 2.2 0 3.8.7 4.6 1.2l.9-2.6c-1.1-.6-2.9-1.2-5.4-1.2-4.7 0-7.8 2.8-7.8 6.6 0 3.4 2.4 5.5 6.4 6.9 3.3 1.3 4.6 2.6 4.6 4.8 0 2.4-1.9 4.1-5.1 4.1-2.2 0-4.2-.7-5.6-1.6l-.8 2.6c1.3.9 3.9 1.5 6.2 1.5 5.7 0 8.5-3.2 8.5-7-.1-3.5-2.2-5.4-6.3-7zm22.3 3c0-3.5-1.1-7.1-6.4-7.1-2.2 0-4.2.6-5.6 1.5l.8 2.1c1.2-.8 2.8-1.3 4.4-1.3 3.6 0 3.9 2.6 3.9 4v.4c-6 0-10.3 2.3-10.3 6.5 0 2.5 1.9 4.9 5.4 4.9 2.5 0 4.4-.7 5.4-2.7h.1l.3 2h2.9c-.2-1-.7-2.3-.7-3.8v-6.5zm-3 4.9c0 .3.1.7 0 1-.5 1.5-1.9 2.9-4.1 2.9-1.6 0-3.1-1-3.1-3 0-3.4 4.3-4 7.3-3.9v3zm15.4-17.6c.9 0 1.5.2 2 .4l.4-2.4c-.6-.3-1.6-.5-2.7-.5-1.5 0-3 .5-4.2 1.6-1.5 1.4-1.9 3.6-1.9 6.1v.9h-3v2h3v15h3v-15h4v-2h-4v-1c0-2.7.7-5.1 3.4-5.1zM83 115.6c0-3.5-1.2-7.1-6.5-7.1-2.2 0-4.2.6-5.7 1.5l.8 2.1c1.2-.8 2.9-1.3 4.5-1.3 3.6 0 3.9 2.6 3.9 4v.4c-7 0-10.4 2.3-10.4 6.5 0 2.5 1.8 4.9 5.4 4.9 2.5 0 4.4-.7 5.4-2.7h.1l.3 2h2.9c-.2-1-.5-2.3-.5-3.8v-6.5zm-3 4.9c0 .3 0 .7-.1 1-.5 1.5-1.9 2.9-4.2 2.9-1.6 0-3.1-1-3.1-3 0-3.4 4.3-4 7.3-3.9v3zm11.3-8.5h-.1l-.1-3h-2.8c.1 2-.2 3.3-.2 5.3V126h4v-9c0-.5-.2-1-.1-1.5.4-2.4 1.9-4.1 4.1-4.1.4 0 1 0 1 .1v-3c0-.1-.6-.3-.9-.3-2.2.2-4.2 1.8-4.9 3.8zm8.7-3h3v17h-3zm1.9-7c-1.2 0-2 .9-2 2s.8 1.9 1.9 1.9c1.3 0 2.1-.9 2-1.9 0-1.1-.7-2-1.9-2zM64 2.3c-26.2 0-47.5 21.3-47.5 47.5S37.8 97.3 64 97.3s47.5-21.3 47.5-47.5S90.2 2.3 64 2.3zm0 93.4c-25.3 0-45.9-20.6-45.9-45.9s20.6-46 45.9-46 45.9 20.6 45.9 45.9-20.6 46-45.9 46zM64 7h1v7h-1zm0 78h1v6h-1zm6.898-76.721l.69.121-1.192 6.796-.69-.121zM57.086 91.171l-.689-.121 1.192-6.796.689.121zm20.918-81.096l.658.24-2.365 6.482-.658-.24zM50.026 89.299l-.658-.24 2.365-6.482.658.24zm7.092-81l1.192 6.796-.689.121-1.192-6.796zm13.81 82.793l-1.192-6.797.69-.121 1.192 6.797zM49.977 10.126l2.363 6.483-.658.24-2.363-6.483zm28.087 79.197l-2.363-6.483.658-.24 2.363 6.483zM43.336 13.144l3.464 5.968-.605.351-3.464-5.968zM84.655 86.24l-3.448-5.977.606-.35 3.448 5.977zM37.278 17.31l4.432 5.289-.537.45-4.432-5.289zm53.423 64.761l-4.432-5.289.537-.45 4.432 5.289zM32.062 22.384l5.289 4.432-.45.537-5.289-4.432zm63.895 54.621l-5.289-4.431.45-.537 5.289 4.431zM27.864 28.358l5.977 3.448-.35.606-5.977-3.448zm72.293 42.673l-5.977-3.448.35-.606 5.977 3.448zM24.646 34.939l6.483 2.363-.24.658-6.483-2.363zm78.699 29.479l-6.483-2.363.24-.658 6.483 2.363zM22.721 42.016l6.796 1.192-.121.69-6.796-1.192zm82.613 15.376L98.537 56.2l.121-.69 6.797 1.192zM22 49h7v1h-7zm77 0h7v1h-7zm-76.419 7.599l6.796-1.192.121.69-6.796 1.192zm82.894-13.833l-6.797 1.192-.121-.69 6.797-1.192zm-81.096 20.94l6.483-2.363.24.658-6.483 2.363zm79.232-27.994l-6.483 2.363-.24-.658 6.483-2.363zM27.459 70.349l5.977-3.448.35.606-5.977 3.448zm73.1-41.277l-5.977 3.448-.35-.606 5.977-3.448zM36.896 71.981l.45.536-5.288 4.432-.45-.536zM96.461 22.99l-5.289 4.432-.45-.537 5.289-4.432zM36.753 81.639l4.432-5.289.537.45-4.432 5.289zm54.472-63.886l-4.432 5.289-.537-.45 4.432-5.289zM42.659 85.848l3.464-5.968.605.351-3.464 5.968zm42.676-72.305l-3.448 5.977-.606-.35 3.448-5.977zm-24.597-5.76l.329 3.685-.697.062-.329-3.685zm6.557 83.824l-.329-3.685.697-.062.329 3.685zM53.429 9.005l.991 3.669-.676.183-.991-3.669zm21.115 81.371l-.991-3.669.676-.183.991 3.669zM46.636 11.485l1.606 3.444-.634.296-1.606-3.444zM81.43 87.912l-1.623-3.436.633-.299 1.623 3.436zM40.237 15.043l2.17 3.119-.575.4-2.17-3.119zm47.529 69.244l-2.171-3.119.575-.4 2.171 3.119zM34.546 19.67l2.617 2.616-.495.495-2.617-2.616zm58.908 60.011l-2.617-2.616.495-.495 2.617 2.616zM29.751 25.272l3.119 2.171-.4.575-3.119-2.171zm68.438 48.875l-3.119-2.171.4-.575 3.119 2.171zm-72.13-42.62l3.354 1.563-.296.634-3.354-1.563zm75.86 36.246l-3.436-1.623.299-.633 3.436 1.623zM23.568 38.434l3.669.991-.182.676-3.669-.991zm80.892 22.513l-3.669-.991.183-.676 3.669.991zM22.142 45.629l3.685.329-.062.697-3.685-.329zm83.683 8.131l-3.685-.329.062-.697 3.685.329zm-83.753-.789l3.685-.329.062.697-3.685.329zm83.823-6.558l-3.685.329-.062-.697 3.685-.329zM23.363 60.192l3.669-.991.183.676-3.669.991zM104.666 39.2l-3.669.991-.182-.676 3.669-.991zM25.725 67.147l3.353-1.564.296.634-3.353 1.564zm76.523-34.84l-3.354 1.563-.296-.634 3.354-1.563zM29.302 73.47l3.119-2.171.4.575-3.119 2.171zm69.332-47.589l-3.119 2.171-.4-.575 3.119-2.171zM40.2 84.332l-.574-.4 2.171-3.118.574.4zm47.573-69.329l.573.403-2.185 3.109-.573-.403zM46.545 87.898l-.633-.299 1.622-3.437.633.299zM81.45 11.427l.633.299-1.622 3.436-.633-.299zM53.518 90.354l-.676-.182.991-3.669.676.182zM74.494 9.062l.676.182-.99 3.669-.676-.182zM60.728 91.583l-.697-.062.329-3.685.697.062zm6.54-83.812l.697.062-.329 3.685-.697-.062zM60 45.8L31.9 81.7l36.5-27.5 27.5-36.5z\" fill=\"#1B88CA\"/></svg>"

/***/ }),

/***/ "../src/components/safari/line-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SafariLineWordmark = __webpack_require__("../src/components/safari/line-wordmark/SafariLineWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SafariLineWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/safari/line/SafariLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SafariLine = __webpack_require__("../src/components/safari/line/SafariLine.svg");
	
	var _SafariLine2 = _interopRequireDefault(_SafariLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SafariLine */
	function SafariLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SafariLine',
	    svg: _SafariLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SafariLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SafariLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/safari/line/SafariLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M64 1.3C29.4 1.3 1.3 29.4 1.3 64s28.1 62.7 62.7 62.7 62.7-28.1 62.7-62.7S98.6 1.3 64 1.3zm0 123.4C30.5 124.7 3.3 97.5 3.3 64S30.5 3.3 64 3.3s60.7 27.2 60.7 60.7-27.2 60.7-60.7 60.7zM64 8h1v9h-1zm0 102h1v9h-1zM73.19 9.193l.985.173-1.572 8.963-.985-.173zM54.806 118.522l-.985-.173 1.572-8.963.985.173zM82.477 11.6l.939.343-3.119 8.549-.939-.343zM45.506 116.113l-.939-.343 3.119-8.549.939.343zM54.87 9.148l1.572 8.964-.985.173-1.572-8.964zM73.143 118.58l-1.572-8.963.985-.173 1.572 8.963zM45.503 11.528l3.117 8.549-.94.343-3.117-8.549zm36.969 104.593l-3.117-8.549.94-.343 3.117 8.549zM36.656 15.608l4.568 7.871-.865.502-4.568-7.871zm54.713 96.558l-4.547-7.882.866-.5 4.547 7.882zM28.748 20.994l5.845 6.975-.766.642-5.845-6.975zm70.522 85.673l-5.845-6.975.766-.642 5.845 6.975zM21.808 27.786l6.975 5.845-.642.766-6.975-5.845zm84.362 72.098l-6.975-5.844.642-.766 6.975 5.844zM16.259 35.721l7.882 4.547-.5.866-7.882-4.547zm95.474 56.338l-7.882-4.547.5-.866 7.882 4.547zM12.028 44.467l8.549 3.117-.343.94-8.549-3.117zm103.933 38.811l-8.549-3.117.343-.94 8.549 3.117zM9.459 53.722l8.963 1.572-.173.985-8.963-1.572zm109.067 20.284l-8.963-1.572.173-.985 8.963 1.572zM9 63h9v1H9zm102 0h9v1h-9zM9.277 72.997l8.963-1.572.173.985-8.963 1.572zm109.432-18.273l-8.963 1.572-.173-.985 8.963-1.572zM11.714 82.386l8.549-3.117.343.94-8.549 3.117zm104.56-37.066l-8.549 3.117-.343-.94 8.549-3.117zM15.732 91.119l7.882-4.547.5.866-7.882 4.547zm96.525-54.52l-7.882 4.547-.5-.866 7.882-4.547zM28.118 93.347l.642.766-6.974 5.846-.642-.766zm78.709-64.715l-6.975 5.845-.642-.766 6.975-5.845zm-78.863 77.446l5.845-6.975.766.642-5.845 6.975zm72.09-84.366l-5.845 6.975-.766-.642 5.845-6.975zm-64.195 89.941l4.568-7.871.865.502-4.568 7.871zm56.308-95.627l-4.547 7.882-.866-.5 4.547-7.882zm-32.54-7.461l.436 4.88-.996.089-.436-4.88zm8.761 110.543l-.436-4.88.996-.089.436 4.88zM50.099 10.168l1.304 4.827-.965.261-1.304-4.827zM77.86 117.615l-1.304-4.827.965-.261 1.304 4.827zM41.026 13.352l2.113 4.532-.906.423-2.113-4.532zm45.999 101.004l-2.135-4.521.904-.427 2.135 4.521zm-54.49-96.21l2.856 4.104-.821.571-2.856-4.104zm62.91 91.453l-2.857-4.104.821-.571 2.857 4.104zM25.077 24.262l3.465 3.465-.707.707-3.465-3.465zm77.845 79.143l-3.465-3.465.707-.707 3.465 3.465zM18.805 31.664l4.104 2.857-.571.821-4.104-2.857zm90.409 64.427l-4.104-2.856.571-.821 4.104 2.856zM13.925 39.999l4.532 2.112-.422.906-4.532-2.112zm100.183 47.755l-4.521-2.135.427-.904 4.521 2.135zM10.528 48.96l4.827 1.303-.261.965-4.827-1.303zm106.916 29.739l-4.827-1.304.261-.965 4.827 1.304zM8.757 58.477l4.88.436-.089.996-4.88-.436zm110.47 10.719l-4.88-.436.089-.996 4.88.436zM8.666 68.223l4.88-.436.089.996-4.88.436zm110.652-8.67l-4.88.436-.089-.996 4.88-.436zM10.262 77.775l4.827-1.304.261.965-4.827 1.304zm107.451-27.761l-4.827 1.303-.261-.965 4.827-1.303zM13.532 86.888l4.532-2.113.423.906-4.532 2.113zm100.879-46.053l-4.532 2.112-.422-.906 4.532-2.112zM18.279 95.301l4.104-2.856.571.821-4.104 2.856zm91.455-62.903l-4.104 2.857-.571-.821 4.104-2.857zm-77.148 77.194l-.821-.572 2.857-4.103.821.572zm62.808-91.433l.818.575-2.875 4.091-.818-.575zm-54.395 96.199l-.904-.427 2.134-4.521.904.427zM86.991 13.424l.904.427-2.134 4.522-.904-.427zM50.098 117.526l-.965-.261 1.303-4.827.965.261zm27.765-107.38l.965.261-1.303 4.827-.965-.261zm-18.23 108.993l-.996-.089.436-4.88.996.089zM68.319 8.563l.996.089-.435 4.88-.996-.089zM58.8 58.8l-37.2 47.3 48.2-36.3 36.3-48.2z\" fill=\"#1B88CA\"/></svg>"

/***/ }),

/***/ "../src/components/safari/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SafariLine = __webpack_require__("../src/components/safari/line/SafariLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SafariLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/safari/original-wordmark/SafariOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SafariOriginalWordmark = __webpack_require__("../src/components/safari/original-wordmark/SafariOriginalWordmark.svg");
	
	var _SafariOriginalWordmark2 = _interopRequireDefault(_SafariOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SafariOriginalWordmark */
	function SafariOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SafariOriginalWordmark',
	    svg: _SafariOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SafariOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SafariOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/safari/original-wordmark/SafariOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><text transform=\"translate(22.295 126)\" fill=\"#333\" font-family=\"'MyriadPro-Regular'\" font-size=\"36\">Safari</text><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"295.835\" y1=\"124.728\" x2=\"295.835\" y2=\"123.889\" gradientTransform=\"matrix(112 0 0 -112 -33069.5 13971)\"><stop offset=\"0\" stop-color=\"#19D7FF\"/><stop offset=\"1\" stop-color=\"#1E64F0\"/></linearGradient><circle fill=\"url(#a)\" cx=\"64\" cy=\"48.5\" r=\"47\"/><path stroke=\"#fff\" fill=\"none\" d=\"M64 6.1V13m0 70.7v6.9m7.3-83.8l-1.2 6.8M57.9 83.2L56.7 90M78.5 8.7l-2.4 6.5M51.9 81.6l-2.4 6.5m7.2-81.3l1.2 6.8m12.2 69.6l1.2 6.8M49.5 8.7l2.4 6.5m24.2 66.4l2.4 6.5M42.9 11.8l3.4 6M81.7 79l3.4 6M36.8 16l4.5 5.3m45.4 54.1l4.5 5.4M31.6 21.2l5.3 4.5m54.2 45.4l5.3 4.4m-69-48.2l6 3.4m61.2 35.4l6 3.4M24.3 33.9l6.5 2.4m66.4 24.2l6.5 2.3M22.4 41l6.8 1.2m69.6 12.3l6.8 1.2m-83.9-7.3h7m70.6 0h7m-83.9 7.3l6.8-1.2m69.6-12.3l6.8-1.2M24.3 62.8l6.5-2.3m66.4-24.2l6.5-2.4M27.4 69.5l6-3.4m61.2-35.4l6-3.4m-69 48.2l5.3-4.4m54.2-45.4l5.3-4.5M36.8 80.8l4.5-5.4m45.4-54.1l4.5-5.3M42.9 85l3.4-6m35.4-61.2l3.4-6M60.3 6.3l.3 3.7m6.8 76.7l.3 3.8M53.1 7.6l.9 3.6m20 74.3l.9 3.7M46.1 10.1l1.6 3.4m32.6 69.8l1.6 3.4m-42.1-73l2.1 3.2m44.2 63l2.1 3.1M34.1 18.5l2.7 2.7m54.4 54.4l2.7 2.7M29.4 24.1l3.1 2.2m63 44.2l3.1 2.1M25.7 30.5l3.4 1.6m69.8 32.5l3.4 1.6M23.2 37.4l3.6 1m74.4 19.9l3.6 1M21.9 44.7l3.8.3m76.6 6.7l3.8.4m-84.2 0l3.8-.4m76.6-6.7l3.8-.3M23.2 59.3l3.6-1m74.4-19.9l3.6-1M25.7 66.2l3.4-1.6m69.8-32.5l3.4-1.6M29.4 72.6l3.1-2.1m63-44.2l3.1-2.2M39.8 83l2.1-3.1m44.2-63l2.1-3.2m-42.1 73l1.6-3.4m32.6-69.8l1.6-3.4M53.1 89.2l.9-3.7m20-74.3l.9-3.6M60.3 90.5l.3-3.8M67.4 10l.3-3.7\"/><path fill=\"red\" d=\"M96.1 16.2L60 44.5l3.9 3.9z\"/><path fill=\"#D01414\" d=\"M63.9 48.4l4.5 4.5 27.7-36.7z\"/><path fill=\"#fff\" d=\"M60 44.5L31.7 80.6l32.2-32.2z\"/><path fill=\"#ACACAC\" d=\"M31.7 80.6l36.7-27.7-4.5-4.5z\"/></svg>"

/***/ }),

/***/ "../src/components/safari/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SafariOriginalWordmark = __webpack_require__("../src/components/safari/original-wordmark/SafariOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SafariOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/safari/original/SafariOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SafariOriginal = __webpack_require__("../src/components/safari/original/SafariOriginal.svg");
	
	var _SafariOriginal2 = _interopRequireDefault(_SafariOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SafariOriginal */
	function SafariOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SafariOriginal',
	    svg: _SafariOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SafariOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SafariOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/safari/original/SafariOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><linearGradient id=\"a\" gradientUnits=\"userSpaceOnUse\" x1=\"295.835\" y1=\"274.049\" x2=\"295.835\" y2=\"272.933\" gradientTransform=\"matrix(112 0 0 -112 -33069.5 30695)\"><stop offset=\"0\" stop-color=\"#19D7FF\"/><stop offset=\"1\" stop-color=\"#1E64F0\"/></linearGradient><circle fill=\"url(#a)\" cx=\"64\" cy=\"64\" r=\"62.5\"/><path stroke=\"#fff\" fill=\"none\" d=\"M64 7.6v9.2m0 94.1v9.2M73.8 8.5l-1.6 9.1m-16.4 92.5l-1.6 9.1M83.2 11l-3.1 8.7M47.9 108l-3.1 8.7M54.2 8.5l1.6 9.1m16.4 92.5l1.6 9.1M44.8 11l3.1 8.7M80.1 108l3.1 8.7M35.9 15.2l4.6 8m47 81.4l4.6 7.9M27.9 20.8l5.9 7m60.4 72.1l5.9 7M20.9 27.7l7.1 5.9m72 60.5l7.1 5.9M15.3 35.8l8 4.6m81.4 47l8 4.6M11.2 44.6l8.6 3.2m88.4 32.1l8.6 3.2M8.6 54.1l9.1 1.6M110.3 72l9.1 1.6M7.8 63.9H17m94 0h9.2M8.6 73.6l9.1-1.6m92.6-16.3l9.1-1.6m-108.2 29l8.6-3.2m88.4-32.1l8.6-3.2M15.3 92l8-4.6m81.4-47l8-4.6M20.9 100l7.1-5.9m72-60.5l7.1-5.9m-79.2 79.2l5.9-7m60.4-72.1l5.9-7m-64.2 91.7l4.6-7.9m47-81.4l4.6-8m-33-7.3l.4 5m9 102l.4 5M49.4 9.6l1.3 4.8m26.6 98.9l1.3 4.9M40.2 12.9l2.1 4.6m43.3 92.8l2.2 4.5m-56.1-97l2.9 4.1m58.8 83.9l2.9 4.1M24.2 24.1l3.6 3.5m72.4 72.5l3.6 3.5m-85.9-72l4.2 2.9m83.8 58.7l4.2 2.9m-97-56l4.5 2.1m92.8 43.3l4.5 2.1M9.7 49.3l4.9 1.3m98.8 26.5l4.9 1.3M8 58.9l5 .5m102 8.9l5 .5m-112 0l5-.5m102-8.9l5-.5M9.7 78.4l4.9-1.3m98.8-26.5l4.9-1.3M13.1 87.6l4.5-2.1m92.8-43.3l4.5-2.1m-97 56l4.2-2.9m83.8-58.7l4.2-2.9m-78.4 78.3l2.9-4.1m58.8-83.9l2.9-4.1m-56.1 97l2.2-4.5m43.2-92.8l2.2-4.6M49.4 118.2l1.3-4.9m26.6-98.9l1.3-4.8M59.1 119.9l.4-5m9-102l.4-5\"/><path fill=\"red\" d=\"M106.7 21l-48 37.7 5.2 5.2z\"/><path fill=\"#D01414\" d=\"M63.9 63.9l6 6L106.7 21z\"/><path fill=\"#fff\" d=\"M58.7 58.7l-37.7 48 42.9-42.8z\"/><path fill=\"#ACACAC\" d=\"M21 106.7l48.9-36.8-6-6z\"/></svg>"

/***/ }),

/***/ "../src/components/safari/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SafariOriginal = __webpack_require__("../src/components/safari/original/SafariOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SafariOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/safari/plain-wordmark/SafariPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SafariPlainWordmark = __webpack_require__("../src/components/safari/plain-wordmark/SafariPlainWordmark.svg");
	
	var _SafariPlainWordmark2 = _interopRequireDefault(_SafariPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SafariPlainWordmark */
	function SafariPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SafariPlainWordmark',
	    svg: _SafariPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SafariPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SafariPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/safari/plain-wordmark/SafariPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M32.7 112.2c-3.3-1.3-4.8-2.4-4.8-4.7 0-1.7 1.3-3.6 4.6-3.6 2.2 0 3.8.7 4.6 1.2l.9-2.6c-1.1-.6-2.9-1.2-5.4-1.2-4.7 0-7.8 2.8-7.8 6.6 0 3.4 2.4 5.5 6.4 6.9 3.3 1.3 4.6 2.6 4.6 4.8 0 2.4-1.9 4.1-5.1 4.1-2.2 0-4.2-.7-5.6-1.6l-.8 2.6c1.3.9 3.9 1.5 6.2 1.5 5.7 0 8.5-3.2 8.5-7-.1-3.4-2.2-5.4-6.3-7zm22.3 3.1c0-3.5-1.1-7.1-6.4-7.1-2.2 0-4.2.6-5.6 1.5l.8 2.1c1.2-.8 2.8-1.3 4.4-1.3 3.6 0 3.9 2.6 3.9 4v.4c-6 0-10.3 2.3-10.3 6.5 0 2.5 1.9 5.1 5.4 5.1 2.5 0 4.4-1.5 5.4-2.5h.1l.3 2h2.9c-.2-1.2-.7-2.7-.7-4.2v-6.5zm-3 4.8c0 .3.1.7 0 1-.5 1.5-1.9 2.9-4.1 2.9-1.6 0-3.1-1-3.1-3 0-3.4 4.3-4 7.3-3.9v3zm15.4-17.5c.9 0 1.5.2 2 .4l.4-2.4c-.6-.3-1.6-.5-2.7-.5-1.5 0-3 .5-4.2 1.6-1.5 1.4-1.9 3.6-1.9 6.1v1.2h-3v2h3v15h3v-15h4v-2h-4v-1.4c0-2.6.7-5 3.4-5zM83 115.3c0-3.5-1.2-7.1-6.5-7.1-2.2 0-4.2.6-5.7 1.5l.8 2.1c1.2-.8 2.9-1.3 4.5-1.3 3.6 0 3.9 2.6 3.9 4v.4c-7 0-10.4 2.3-10.4 6.5 0 2.5 1.8 5.1 5.4 5.1 2.5 0 4.4-1.5 5.4-2.5h.1l.3 2h2.9c-.2-1.2-.5-2.7-.5-4.2v-6.5zm-3 4.8c0 .3 0 .7-.1 1-.5 1.5-1.9 2.9-4.2 2.9-1.6 0-3.1-1-3.1-3 0-3.4 4.3-4 7.3-3.9v3zm11.3-8.1h-.1l-.1-3h-2.8c.1 1-.2 3-.2 5v12h4v-9.3c0-.5-.2-1-.1-1.5.4-2.4 1.9-4.1 4.1-4.1.4 0 1 0 1 .1v-3c0-.1-.6-.1-.9-.1-2.2.1-4.2 1.9-4.9 3.9zm10.6-10.3c-1.2 0-2 .9-2 2s.8 1.9 1.9 1.9c1.3 0 2.1-.9 2-1.9 0-1.1-.7-2-1.9-2zM100 109h3v17h-3zM64 1.5c-25.9 0-47 21-47 47s21 47 47 47 47-21 47-47-21.1-47-47-47zm42.1 43.6l-3.8.3-.1-.7 3.8-.3.1.7zM106 48v1h-7v-1h7zm-.3-6.6l-6.8 1.2-.1-.7 6.8-1.2.1.7zm-.8-3.6l-3.6 1-.2-.7 3.6-1 .2.7zm-1.1-3.5l-6.5 2.4-.3-.7 6.5-2.4.3.7zm-1.3-3.5L99 32.4l-.3-.7 3.4-1.6.4.7zm-1.7-3.2l-6 3.5-.4-.7 6-3.5.4.7zm-2.4-3.8l.4.6-3.1 2.2-.4-.6 3.1-2.2zm-1.8-2.3l-5.3 4.4-.5-.6 5.3-4.4.5.6zm-5.2-5.3L87 21.5l-.6-.5 4.4-5.3.6.5zm-3.5-2.7l.6.4-2.2 3.1-.6-.4 2.2-3.1zM85.5 12L82 18l-.7-.4 3.5-6 .7.4zm-4-2.1l.7.3-1.6 3.4-.7-.3 1.6-3.4zm-3.4-1.4l.7.3-2.4 6.5-.7-.3 2.4-6.5zm-3.5-1l.7.2-1 3.6-.7-.2 1-3.6zM71 6.7l.7.1-1.2 6.8-.7-.1L71 6.7zm-3.7-.5l.7.1-.3 3.8-.7-.1.3-3.8zM63 7h1v6h-1V7zm-2.3-.8L61 10l-.7.1-.3-3.8.7-.1zm-3.7.5l1.2 6.8-.7.1-1.2-6.8.7-.1zm-3.6.8l1 3.6-.7.2-1-3.6.7-.2zm-3.5 1l2.4 6.5-.7.3-2.4-6.5.7-.3zm-3.4 1.4l1.6 3.4-.7.3-1.6-3.4.7-.3zm-3.3 1.7l3.5 6-.7.4-3.5-6 .7-.4zm-3.1 1.9l2.2 3.1-.6.4-2.3-3 .7-.5zm-3 2.3l4.4 5.3-.5.4-4.4-5.3.5-.4zm-2.7 2.4l2.7 2.7-.5.5-2.7-2.7.5-.5zm-2.5 2.7l5.3 4.4-.5.6-5.3-4.4.5-.6zm-2.3 2.9l3.1 2.2-.4.6-3.1-2.2.4-.6zm-2 3.1l6 3.5-.4.6-6-3.5.4-.6zm-1.7 3.3l3.4 1.6-.3.6-3.4-1.6.3-.6zm-1.5 3.4l6.5 2.4-.3.7-6.5-2.4.3-.7zm-1.1 3.5l3.6 1-.2.7-3.6-1 .2-.7zm-.8 3.6l6.8 1.2-.1.7-6.8-1.2.1-.7zm-.6 3.6l3.8.3-.1.7-3.8-.3.1-.7zM28 48v1h-6v-1h6zm-6.1 3.7l3.8-.3.1.7-3.8.3-.1-.7zm.4 3.6l6.8-1.2.1.7-6.8 1.2-.1-.7zm.8 3.7l3.6-1 .2.7-3.6 1-.2-.7zm1.1 3.5l6.5-2.4.3.7-6.5 2.4-.3-.7zm1.3 3.4l3.4-1.6.3.7-3.4 1.6-.3-.7zm1.7 3.3l6-3.5.4.7-6 3.5-.4-.7zm2.4 3.7l-.4-.6 3.1-2.2.4.6-3.1 2.2zm7.1-2.1l.5.6-5.3 4.4-.5-.6 5.3-4.4zm-.1 9.7l4.4-5.3.6.5-4.5 5.3-.5-.5zm3.5 2.7l-.6-.4 2.2-3.1.6.4-2.2 3.1zm2.4 1.6l3.5-6 .7.4-3.5 6-.7-.4zm4 2l-.7-.3 1.6-3.4.7.3-1.6 3.4zm3.4 1.4l-.7-.3 2.4-6.5.7.3-2.4 6.5zm3.5 1.1l-.7-.2 1-3.6.7.2-1 3.6zm3.6.7l-.7-.1 1.2-6.8.7.1L57 90zm3.7.5l-.7-.1.3-3.8.7.1-.3 3.8zm3.3.5h-1v-7h1v7zm3.3-.5l-.3-3.8.7-.1.3 3.8-.7.1zm-35.6-9.9L60 44.5l36.1-28.3-27.7 36.7-36.7 27.7zM71 90l-1.2-6.8.7-.1 1.2 6.8-.7.1zm3.6-.7l-1-3.6.7-.2 1 3.6-.7.2zm3.5-1.1l-2.4-6.5.7-.3 2.4 6.5-.7.3zm3.4-1.4l-1.6-3.4.7-.3 1.6 3.4-.7.3zm3.3-1.6l-3.5-6 .7-.4 3.5 6-.7.4zm3.1-2l-2.2-3.1.6-.4 2.2 3.1-.6.4zm3-2.2l-4.4-5.3.6-.5 4.4 5.3-.6.5zm2.7-2.5L91 75.9l.5-.5 2.7 2.7-.6.4zm2.5-2.7l-5.3-4.4.5-.6 5.3 4.4-.5.6zm2.3-2.9l-3.1-2.2.4-.6 3.1 2.2-.4.6zm2-3.1l-6-3.5.4-.7 6 3.5-.4.7zm1.7-3.2L98.7 65l.3-.7 3.4 1.6-.3.7zm1.5-3.4l-6.5-2.4.3-.7 6.5 2.4-.3.7zm1.1-3.5l-3.6-1 .2-.7 3.6 1-.2.7zm.8-3.6l-6.8-1.2.1-.7 6.8 1.2-.1.7zm.6-3.7l-3.8-.3.1-.7 3.8.3-.1.7z\" fill=\"#1B88CA\"/></svg>"

/***/ }),

/***/ "../src/components/safari/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SafariPlainWordmark = __webpack_require__("../src/components/safari/plain-wordmark/SafariPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SafariPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/safari/plain/SafariPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SafariPlain = __webpack_require__("../src/components/safari/plain/SafariPlain.svg");
	
	var _SafariPlain2 = _interopRequireDefault(_SafariPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SafariPlain */
	function SafariPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SafariPlain',
	    svg: _SafariPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SafariPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SafariPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/safari/plain/SafariPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#1B88CA\" d=\"M64 1.5C29.5 1.5 1.5 29.5 1.5 64s28 62.5 62.5 62.5 62.5-28 62.5-62.5S98.5 1.5 64 1.5zm56 57.9l-5 .4-.1-1 5-.4.1 1zm0 3.6v1h-9v-1h9zm-.6-8.4l-9.1 1.6-.2-1 9.1-1.6.2 1zm-1-4.8l-4.9 1.3-.3-1 4.9-1.3.3 1zm-1.4-4.7l-8.6 3.2-.3-.9 8.6-3.2.3.9zm-1.8-4.6l-4.5 2.1-.4-.9 4.5-2.1.4.9zm-2.3-4.3l-8 4.6-.5-.9 8-4.6.5.9zm-3.1-5l.6.8-4.1 2.9-.6-.8 4.1-2.9zm-2.4-3.1l-7.1 5.9-.6-.8 7.1-5.9.6.8zm-6.9-7l-5.9 7.1-.8-.6 5.9-7.1.8.6zm-4.7-3.6l.8.6-2.9 4.1-.8-.6 2.9-4.1zm-3.2-2.1l-4.6 8-.9-.5 4.6-8 .9.5zm-5.3-2.7l.9.4-2.1 4.5-.9-.4 2.1-4.5zm-4.5-1.8l.9.3-3.2 8.6-.9-.3 3.2-8.6zm-4.7-1.5l1 .3-1.3 4.9-1-.3 1.3-4.9zm-4.8-1l1 .2-1.6 9.1-1-.2 1.6-9.1zm-4.9-.6l1 .1-.4 5-1-.1.4-5zM63 8h1v9h-1V8zm-3.4-.2l.4 5-1 .1-.4-5 1-.1zm-4.9.6l1.6 9.1-1 .2-1.6-9.1 1-.2zm-4.8 1l1.3 4.9-1 .3L49 9.7l.9-.3zm-4.7 1.5l3.2 8.6-.9.3-3.2-8.6.9-.3zm-4.5 1.8l2.1 4.5-.9.4-2.1-4.5.9-.4zm-4.4 2.2l4.6 8-.9.5-4.6-8 .9-.5zm-4.1 2.6l2.9 4.1-.8.6-2.9-4.1.8-.6zm-3.9 3l5.9 7.1-.8.6-5.9-7.1.8-.6zm-3.7 3.2l3.5 3.5-.7.8-3.5-3.5.7-.8zm-3.4 3.6l7.1 5.9-.6.8-7.1-5.9.6-.8zm-3 3.9l4.1 2.9-.6.8-4.1-2.9.6-.8zm-2.6 4.1l8 4.6-.6.9-8-4.6.6-.9zm-2.3 4.3l4.5 2.1-.4.9-4.5-2.1.4-.9zm-1.9 4.6l8.6 3.2-.3.9-8.7-3.2.4-.9zm-1.6 4.6l4.9 1.3-.3 1-4.9-1.3.3-1zm-1.1 4.8l9.1 1.6-.2 1-9.1-1.6.2-1zM8 58.5l5 .4-.1 1-5-.4.1-1zm9 4.5v1H8v-1h9zm-9 5.3l5-.4.1 1-5 .4-.1-1zm.6 4.8l9.1-1.6.2 1-9.1 1.6-.2-1zm1 4.8l4.9-1.3.3 1-4.9 1.3-.3-1zm1.4 4.7l8.6-3.2.3.9-8.6 3.2-.3-.9zm1.8 4.6l4.5-2.1.4.9-4.5 2.1-.4-.9zm2.3 4.4l8-4.6.5.9-8 4.6-.5-.9zm3.1 4.9l-.6-.8 4.1-2.9.6.8-4.1 2.9zm9.5-2.8l.6.8-7.1 5.9-.6-.8 7.1-5.9zm-.2 12.9l5.9-7.1.8.6-5.9 7.1-.8-.6zm4.7 3.6l-.8-.6 2.9-4.1.8.6-2.9 4.1zm3.2 2.1l4.6-8 .9.5-4.6 8-.9-.5zm5.3 2.7l-.9-.4 2.1-4.5.9.4-2.1 4.5zm4.5 1.9l-.9-.3 3.2-8.6.9.3-3.2 8.6zm4.7 1.4l-1-.3 1.3-4.9 1 .3-1.3 4.9zm4.8 1l-1-.2 1.6-9.1 1 .2-1.6 9.1zm4.9.6l-1-.1.4-5 1 .1-.4 5zm4.4.1h-1v-9h1v9zm4.4-.1l-.4-5 1-.1.4 5-1 .1zM21 106.7l37.7-48 48-37.7-36.8 48.9L21 106.7zm52.3 12.6l-1.6-9.1 1-.2 1.6 9.1-1 .2zm4.8-1l-1.3-4.9 1-.3L79 118l-.9.3zm4.7-1.4l-3.2-8.6.9-.3 3.2 8.6-.9.3zm4.5-1.9l-2.1-4.5.9-.4 2.1 4.5-.9.4zm4.4-2.2l-4.6-8 .9-.5 4.6 8-.9.5zm4.1-2.6l-2.9-4.1.8-.6 2.9 4.1-.8.6zm3.9-2.9l-5.9-7.1.8-.6 5.9 7.1-.8.6zm3.7-3.3l-3.5-3.5.7-.7 3.5 3.5-.7.7zm3.4-3.6l-7.1-5.9.6-.8 7.1 5.9-.6.8zm3-3.9l-4.1-2.9.6-.8 4.1 2.9-.6.8zm2.6-4.1l-8-4.6.5-.9 8 4.6-.5.9zm2.3-4.3l-4.5-2.1.4-.9 4.5 2.1-.4.9zm1.9-4.5l-8.6-3.2.3-.9 8.6 3.2-.3.9zm1.6-4.7l-4.9-1.3.3-1 4.9 1.3-.3 1zm1.1-4.8l-9.1-1.6.2-1 9.1 1.6-.2 1zm.7-4.8l-5-.4.1-1 5 .4-.1 1z\"/></svg>"

/***/ }),

/***/ "../src/components/safari/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SafariPlain = __webpack_require__("../src/components/safari/plain/SafariPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SafariPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sass/original/SassOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SassOriginal = __webpack_require__("../src/components/sass/original/SassOriginal.svg");
	
	var _SassOriginal2 = _interopRequireDefault(_SassOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SassOriginal */
	function SassOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SassOriginal',
	    svg: _SassOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SassOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SassOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sass/original/SassOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#CB6699\" d=\"M1.219 56.156c0 .703.207 1.167.323 1.618.756 2.933 2.381 5.45 4.309 7.746 2.746 3.272 6.109 5.906 9.554 8.383 2.988 2.148 6.037 4.248 9.037 6.38.515.366 1.002.787 1.561 1.236-.481.26-.881.489-1.297.7-3.959 2.008-7.768 4.259-11.279 6.986-2.116 1.644-4.162 3.391-5.607 5.674-2.325 3.672-3.148 7.584-1.415 11.761.506 1.22 1.278 2.274 2.367 3.053.353.252.749.502 1.162.6 1.058.249 2.136.412 3.207.609l3.033-.002c3.354-.299 6.407-1.448 9.166-3.352 4.312-2.976 7.217-6.966 8.466-12.087.908-3.722.945-7.448-.125-11.153a11.696 11.696 0 0 0-.354-1.014c-.13-.333-.283-.657-.463-1.072l6.876-3.954.103.088c-.125.409-.258.817-.371 1.23-.817 2.984-1.36 6.02-1.165 9.117.208 3.3 1.129 6.389 3.061 9.146 1.562 2.23 5.284 2.313 6.944.075.589-.795 1.16-1.626 1.589-2.513 1.121-2.315 2.159-4.671 3.23-7.011l.187-.428c-.077 1.108-.167 2.081-.208 3.055-.064 1.521.025 3.033.545 4.48.445 1.238 1.202 2.163 2.62 2.326.97.111 1.743-.333 2.456-.896a10.384 10.384 0 0 0 2.691-3.199c1.901-3.491 3.853-6.961 5.576-10.54 1.864-3.871 3.494-7.855 5.225-11.792l.286-.698c.409 1.607.694 3.181 1.219 4.671.61 1.729 1.365 3.417 2.187 5.058.389.775.344 1.278-.195 1.928-2.256 2.72-4.473 5.473-6.692 8.223-.491.607-.98 1.225-1.389 1.888a3.701 3.701 0 0 0-.48 1.364 1.737 1.737 0 0 0 1.383 1.971 9.661 9.661 0 0 0 2.708.193c3.097-.228 5.909-1.315 8.395-3.157 3.221-2.386 4.255-5.642 3.475-9.501-.211-1.047-.584-2.065-.947-3.074-.163-.455-.174-.774.123-1.198 2.575-3.677 4.775-7.578 6.821-11.569.081-.157.164-.314.306-.482.663 3.45 1.661 6.775 3.449 9.792-.912.879-1.815 1.676-2.632 2.554-1.799 1.934-3.359 4.034-4.173 6.595-.35 1.104-.619 2.226-.463 3.405.242 1.831 1.742 3.021 3.543 2.604 3.854-.892 7.181-2.708 9.612-5.925 1.636-2.166 1.785-4.582 1.1-7.113-.188-.688-.411-1.365-.651-2.154.951-.295 1.878-.649 2.837-.868 4.979-1.136 9.904-.938 14.702.86 2.801 1.05 5.064 2.807 6.406 5.571 1.639 3.379.733 6.585-2.452 8.721-.297.199-.637.356-.883.605a.869.869 0 0 0-.205.67c.021.123.346.277.533.275 1.047-.008 1.896-.557 2.711-1.121 2.042-1.413 3.532-3.314 3.853-5.817l.063-.188-.077-1.63c-.031-.094.023-.187.016-.258-.434-3.645-2.381-6.472-5.213-8.688-3.28-2.565-7.153-3.621-11.249-3.788a25.401 25.401 0 0 0-9.765 1.503c-.897.325-1.786.71-2.688 1.073-.121-.219-.251-.429-.358-.646-.926-1.896-2.048-3.708-2.296-5.882-.176-1.544-.392-3.086-.025-4.613.353-1.469.813-2.913 1.246-4.362.223-.746.066-1.164-.646-1.5a2.854 2.854 0 0 0-.786-.258c-1.75-.254-3.476-.109-5.171.384-.6.175-1.036.511-1.169 1.175-.076.381-.231.746-.339 1.122-.443 1.563-.757 3.156-1.473 4.645-1.794 3.735-3.842 7.329-5.938 10.897-.227.385-.466.763-.752 1.23-.736-1.54-1.521-2.922-1.759-4.542-.269-1.832-.481-3.661-.025-5.479.339-1.356.782-2.687 1.19-4.025.193-.636.104-.97-.472-1.305-.291-.169-.62-.319-.948-.368a11.643 11.643 0 0 0-5.354.438c-.543.176-.828.527-.994 1.087-.488 1.652-.904 3.344-1.589 4.915-2.774 6.36-5.628 12.687-8.479 19.013-.595 1.321-1.292 2.596-1.963 3.882-.17.326-.418.613-.63.919-.17-.201-.236-.339-.235-.477.005-.813-.092-1.65.063-2.436a172.189 172.189 0 0 1 1.578-7.099c.47-1.946 1.017-3.874 1.538-5.807.175-.647.178-1.252-.287-1.796-.781-.911-2.413-1.111-3.381-.409l-.428.242.083-.69c.204-1.479.245-2.953-.161-4.41-.506-1.816-1.802-2.861-3.686-2.803-.878.027-1.8.177-2.613.497-3.419 1.34-6.048 3.713-8.286 6.568a2.592 2.592 0 0 1-.757.654c-2.893 1.604-5.795 3.188-8.696 4.778l-3.229 1.769c-.866-.826-1.653-1.683-2.546-2.41-2.727-2.224-5.498-4.393-8.244-6.592-2.434-1.949-4.792-3.979-6.596-6.56-1.342-1.92-2.207-4.021-2.29-6.395-.105-3.025.753-5.789 2.293-8.362 1.97-3.292 4.657-5.934 7.611-8.327 3.125-2.53 6.505-4.678 10.008-6.639 4.901-2.743 9.942-5.171 15.347-6.774 5.542-1.644 11.165-2.585 16.965-1.929 2.28.258 4.494.78 6.527 1.895 1.557.853 2.834 1.97 3.428 3.716.586 1.718.568 3.459.162 5.204-.825 3.534-2.76 6.447-5.195 9.05-3.994 4.267-8.866 7.172-14.351 9.091a39.478 39.478 0 0 1-9.765 2.083c-2.729.229-5.401-.013-7.985-.962-1.711-.629-3.201-1.591-4.399-2.987-.214-.25-.488-.521-.887-.287-.391.23-.46.602-.329.979.219.626.421 1.278.762 1.838.857 1.405 2.107 2.424 3.483 3.298 2.643 1.681 5.597 2.246 8.66 2.377 4.648.201 9.183-.493 13.654-1.74 6.383-1.78 11.933-4.924 16.384-9.884 3.706-4.13 6.353-8.791 6.92-14.419.277-2.747-.018-5.438-1.304-7.944-1.395-2.715-3.613-4.734-6.265-6.125C68.756 18.179 64.588 17 60.286 17h-4.31c-5.21 0-10.247 1.493-15.143 3.274-3.706 1.349-7.34 2.941-10.868 4.703-7.683 3.839-14.838 8.468-20.715 14.833-2.928 3.171-5.407 6.67-6.833 10.79a40.494 40.494 0 0 0-1.111 3.746m27.839 36.013c-.333 4.459-2.354 8.074-5.657 11.002-1.858 1.646-3.989 2.818-6.471 3.23-.9.149-1.821.185-2.694-.188-1.245-.532-1.524-1.637-1.548-2.814-.037-1.876.62-3.572 1.521-5.186 1.176-2.104 2.9-3.708 4.741-5.206 2.9-2.361 6.046-4.359 9.268-6.245l.243-.1c.498 1.84.735 3.657.597 5.507zM54.303 70.98c-.235 1.424-.529 2.849-.945 4.229-1.438 4.777-3.285 9.406-5.282 13.973-.369.845-.906 1.616-1.373 2.417a1.689 1.689 0 0 1-.283.334c-.578.571-1.126.541-1.418-.206-.34-.868-.549-1.797-.729-2.716-.121-.617-.092-1.265-.13-1.897.039-4.494 1.41-8.578 3.736-12.38.959-1.568 2.003-3.062 3.598-4.054a6.27 6.27 0 0 1 1.595-.706c.85-.239 1.372.154 1.231 1.006zm17.164 21.868l6.169-7.203c.257 2.675-4.29 8.015-6.169 7.203zm19.703-4.847c-.436.25-.911.43-1.358.661-.409.212-.544-.002-.556-.354a2.385 2.385 0 0 1 .093-.721c.833-2.938 2.366-5.446 4.647-7.486l.16-.082c1.085 3.035-.169 6.368-2.986 7.982z\"/></svg>"

/***/ }),

/***/ "../src/components/sass/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SassOriginal = __webpack_require__("../src/components/sass/original/SassOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SassOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sequelize/original-wordmark/SequelizeOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SequelizeOriginalWordmark = __webpack_require__("../src/components/sequelize/original-wordmark/SequelizeOriginalWordmark.svg");
	
	var _SequelizeOriginalWordmark2 = _interopRequireDefault(_SequelizeOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SequelizeOriginalWordmark */
	function SequelizeOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SequelizeOriginalWordmark',
	    svg: _SequelizeOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SequelizeOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SequelizeOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sequelize/original-wordmark/SequelizeOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"sequelize\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#2f406a}.cls-2{fill:#2379bd}.cls-3{fill:#03afef}</style></defs><title>Artboard 14</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M32.51 56.94V71l-11.94 7-.11.1v5.3l.11.1 16.81-9.71V54.21h-.16l-4.74 2.65v.11\"/><path class=\"cls-2\" d=\"M8.59 71.1l12 6.95v5.45L3.64 73.75v-19.5h.17L8.54 57l.05.16v14\"/><path class=\"cls-3\" d=\"M8.59 57.13l-5-2.88 16.94-9.75 16.85 9.71-4.87 2.73-12-6.83-11.94 7\"/><path class=\"cls-1\" d=\"M20.36 69.49l-.13-.13v-5.27l.13-.07v-.13l4.52-2.64h.14v5.44l-4.69 2.78\"/><path class=\"cls-2\" d=\"M15.59 66.89v-5.65h.13l4.6 2.68v5.58l-4.77-2.61\"/><path class=\"cls-3\" d=\"M20.28 58.47l-4.69 2.78L20.36 64l4.69-2.74-4.77-2.82\"/><path class=\"cls-1\" d=\"M14.52 72.94l-.13-.13v-5.28l.13-.07v-.13l4.52-2.64h.14v5.44l-4.69 2.78\"/><path class=\"cls-2\" d=\"M9.75 70.33v-5.65h.13l4.6 2.68v5.58l-4.73-2.61\"/><path class=\"cls-3\" d=\"M14.45 61.91l-4.7 2.77 4.77 2.78 4.69-2.74-4.77-2.82\"/><path class=\"cls-1\" d=\"M26.62 73.07l-.13-.13v-5.28l.13-.07v-.13l4.52-2.64h.14v5.44l-4.69 2.78\"/><path class=\"cls-2\" d=\"M21.85 70.46v-5.65H22l4.6 2.68v5.58l-4.77-2.61\"/><path class=\"cls-3\" d=\"M26.54 62l-4.69 2.78 4.77 2.78 4.69-2.74L26.54 62\"/><path class=\"cls-1\" d=\"M20.78 76.51l-.13-.13V71.1l.13-.07v-.13l4.52-2.64h.14v5.44l-4.69 2.78\"/><path class=\"cls-2\" d=\"M16 73.9v-5.64h.13l4.6 2.68v5.58L16 73.9\"/><path class=\"cls-3\" d=\"M20.7 65.48L16 68.26 20.78 71l4.69-2.74-4.77-2.78\"/><path class=\"cls-1\" d=\"M20.36 62l-.13-.13v-5.26l.13-.07v-.13l4.52-2.64h.14v5.44L20.36 62\"/><path class=\"cls-2\" d=\"M15.59 59.41v-5.65h.13l4.6 2.68V62l-4.77-2.61\"/><path class=\"cls-3\" d=\"M20.28 51l-4.69 2.78 4.77 2.78 4.69-2.74L20.28 51\"/><path class=\"cls-1\" d=\"M14.52 65.45l-.13-.13V60l.13-.07v-.13l4.52-2.64h.14v5.44l-4.69 2.78\"/><path class=\"cls-2\" d=\"M9.75 62.85V57.2h.13l4.6 2.68v5.58l-4.73-2.61\"/><path class=\"cls-3\" d=\"M14.45 54.43l-4.7 2.77 4.77 2.8 4.69-2.74-4.77-2.82\"/><path class=\"cls-1\" d=\"M26.62 65.58l-.13-.13v-5.27l.13-.07v-.13l4.52-2.64h.14v5.44l-4.69 2.78\"/><path class=\"cls-2\" d=\"M21.85 63v-5.67H22L26.58 60v5.58L21.85 63\"/><path class=\"cls-3\" d=\"M26.54 54.56l-4.69 2.78 4.77 2.78 4.69-2.74-4.77-2.82\"/><path class=\"cls-1\" d=\"M20.78 69l-.13-.13v-5.25l.13-.07v-.13l4.52-2.64h.14v5.44L20.78 69\"/><path class=\"cls-2\" d=\"M16 66.42v-5.65h.13l4.6 2.68V69L16 66.42\"/><path class=\"cls-3\" d=\"M20.7 58L16 60.77l4.77 2.78 4.69-2.74L20.7 58\"/><path class=\"cls-1\" d=\"M45.82 56.56q-3.15 0-3.15 2.37a2 2 0 0 0 .72 1.82 9.66 9.66 0 0 0 2.94 1A7.47 7.47 0 0 1 49.47 63a3.24 3.24 0 0 1 .92 2.59q0 4.47-4.64 4.47a26 26 0 0 1-3.84-.36l-.76-.1.17-1.34a36 36 0 0 0 4.35.38q3.11 0 3.11-2.92A2 2 0 0 0 48.1 64a6.64 6.64 0 0 0-2.55-.87 8.59 8.59 0 0 1-3.49-1.35A3.38 3.38 0 0 1 41 59q0-3.91 4.68-3.91a25.83 25.83 0 0 1 3.68.31l.71.11-.07 1.4a39.48 39.48 0 0 0-4.18-.35zM60.06 68.59l.61-.06v1.24a30.21 30.21 0 0 1-4.1.34 3.69 3.69 0 0 1-3.21-1.31 7 7 0 0 1-.95-4.08q0-5.52 4.39-5.52a4 4 0 0 1 3.2 1.17 5.53 5.53 0 0 1 1.05 3.73L61 65.29h-6.95a4.31 4.31 0 0 0 .63 2.58 2.58 2.58 0 0 0 2.19.84q1.57 0 3.19-.12zM59.49 64a4.56 4.56 0 0 0-.62-2.73 2.39 2.39 0 0 0-2-.8 2.58 2.58 0 0 0-2.1.84A4.24 4.24 0 0 0 54 64zM67 70.1a3.52 3.52 0 0 1-3-1.24 7.29 7.29 0 0 1-.91-4.2 6.44 6.44 0 0 1 1.09-4.22q1.09-1.26 3.86-1.26l3.51.21v15.16H70v-5.14a6.89 6.89 0 0 1-3 .69zm1-9.56a3.09 3.09 0 0 0-2.68 1 5.49 5.49 0 0 0-.7 3.14 6.14 6.14 0 0 0 .58 3.09 2.1 2.1 0 0 0 1.94.93 6.66 6.66 0 0 0 2.42-.46l.38-.15v-7.42q-1.27-.12-1.94-.12zM81.12 59.39h1.58v10.5h-1.58v-.73a6 6 0 0 1-3.12.94q-2.14 0-2.85-1.11a8.38 8.38 0 0 1-.7-4.12v-5.48H76v5.46a7.72 7.72 0 0 0 .4 3.07q.4.78 1.81.78a5.21 5.21 0 0 0 1.41-.2 6.42 6.42 0 0 0 1.09-.39l.38-.19zM92.86 68.59l.61-.06v1.24a30.21 30.21 0 0 1-4.1.34 3.69 3.69 0 0 1-3.21-1.31 7 7 0 0 1-.95-4.08q0-5.52 4.39-5.52a4 4 0 0 1 3.17 1.19 5.53 5.53 0 0 1 1.05 3.73l-.08 1.2h-6.89a4.31 4.31 0 0 0 .63 2.58 2.58 2.58 0 0 0 2.19.84q1.57-.03 3.19-.15zM92.29 64a4.56 4.56 0 0 0-.62-2.73 2.39 2.39 0 0 0-2-.8 2.58 2.58 0 0 0-2.1.84 4.24 4.24 0 0 0-.74 2.69zM96.45 69.89V54.81H98v15.08zM101.17 57v-1.81h1.57V57zm0 12.87V59.39h1.57v10.5zM105.14 60.8v-1.41h7.79v1.41l-5.88 7.69h5.88v1.41h-7.79v-1.42L111 60.8zM122.41 68.59l.61-.06v1.24a30.21 30.21 0 0 1-4.1.34 3.69 3.69 0 0 1-3.21-1.31 7 7 0 0 1-.95-4.08q0-5.52 4.39-5.52a4 4 0 0 1 3.17 1.19 5.53 5.53 0 0 1 1.05 3.73l-.08 1.2h-6.89a4.31 4.31 0 0 0 .63 2.58 2.58 2.58 0 0 0 2.19.84q1.57-.03 3.19-.15zm-.57-4.59a4.56 4.56 0 0 0-.62-2.73 2.39 2.39 0 0 0-2-.8 2.58 2.58 0 0 0-2.1.84 4.24 4.24 0 0 0-.72 2.69z\"/></g></svg>"

/***/ }),

/***/ "../src/components/sequelize/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SequelizeOriginalWordmark = __webpack_require__("../src/components/sequelize/original-wordmark/SequelizeOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SequelizeOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sequelize/original/SequelizeOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SequelizeOriginal = __webpack_require__("../src/components/sequelize/original/SequelizeOriginal.svg");
	
	var _SequelizeOriginal2 = _interopRequireDefault(_SequelizeOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SequelizeOriginal */
	function SequelizeOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SequelizeOriginal',
	    svg: _SequelizeOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SequelizeOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SequelizeOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sequelize/original/SequelizeOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"sequelize\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#2f406a}.cls-2{fill:#2379bd}.cls-3{fill:#03afef}</style></defs><title>Artboard 12</title><g id=\"original\"><path class=\"cls-1\" d=\"M101.84 41.72V86l-37.66 22.32-.34.31v16.57l.34.32 53-30.64V33.12l-.5-.12-15 8.36.08.36\"/><path class=\"cls-2\" d=\"M26.4 86.4l37.78 21.92v17.2l-53.4-30.76V33.24l.55-.08 14.91 8.67.16.5V86.4\"/><path class=\"cls-3\" d=\"M26.4 42.32l-15.62-9.08L64.06 2.48l53.16 30.64-15.38 8.6-37.78-21.56L26.4 42.32\"/><path class=\"cls-1\" d=\"M63.53 81.33l-.41-.42V64.27l.41-.21.1-.41 14.27-8.32.44.1v17.15l-14.8 8.76\"/><path class=\"cls-2\" d=\"M48.48 73.11V55.3h.41l14.51 8.45.12.33v17.25l-15.04-8.22\"/><path class=\"cls-3\" d=\"M63.29 46.54L48.48 55.3l15.05 8.76 14.8-8.64-15.04-8.88\"/><path class=\"cls-1\" d=\"M45.11 92.19l-.41-.42V75.13l.41-.21.1-.41 14.27-8.32.44.1v17.14l-14.8 8.76\"/><path class=\"cls-2\" d=\"M30.06 84V66.16h.41L45 74.59l.12.33v17.27L30.06 84\"/><path class=\"cls-3\" d=\"M44.86 57.4l-14.8 8.76 15.05 8.76 14.8-8.64-15.05-8.88\"/><path class=\"cls-1\" d=\"M83.27 92.6l-.41-.42V75.54l.41-.21.1-.41 14.27-8.32.44.1v17.14L83.27 92.6\"/><path class=\"cls-2\" d=\"M68.22 84.38V66.57h.41L83.15 75l.12.33V92.6l-15.05-8.22\"/><path class=\"cls-3\" d=\"M83 57.81l-14.8 8.76 15.05 8.76 14.8-8.64L83 57.81\"/><path class=\"cls-1\" d=\"M64.85 103.46l-.41-.42V86.4l.41-.21.1-.41 14.27-8.32.44.1V94.7l-14.8 8.76\"/><path class=\"cls-2\" d=\"M49.8 95.23v-17.8h.41l14.51 8.45.12.33v17.27L49.8 95.23\"/><path class=\"cls-3\" d=\"M64.6 68.67l-14.8 8.76 15.05 8.76 14.8-8.64-15.05-8.88\"/><path class=\"cls-1\" d=\"M63.53 57.73l-.41-.42V40.67l.41-.21.1-.41 14.27-8.33.44.1V49l-14.8 8.76\"/><path class=\"cls-2\" d=\"M48.48 49.5V31.7h.41l14.51 8.45.12.33v17.25L48.48 49.5\"/><path class=\"cls-3\" d=\"M63.29 22.94L48.48 31.7l15.05 8.76 14.8-8.64-15.04-8.88\"/><path class=\"cls-1\" d=\"M45.11 68.59l-.41-.42V51.53l.41-.21.1-.41 14.27-8.32.44.1v17.14l-14.8 8.76\"/><path class=\"cls-2\" d=\"M30.06 60.36V42.55h.41L45 51l.12.33v17.26l-15.06-8.23\"/><path class=\"cls-3\" d=\"M44.86 33.8l-14.8 8.76 15.05 8.76 14.8-8.64-15.05-8.88\"/><path class=\"cls-1\" d=\"M83.27 69l-.41-.42V51.94l.41-.21.1-.41L97.64 43l.44.1v17.14L83.27 69\"/><path class=\"cls-2\" d=\"M68.22 60.77V43h.41l14.51 8.45.12.33V69l-15.04-8.23\"/><path class=\"cls-3\" d=\"M83 34.21L68.22 43l15.05 8.76 14.8-8.64L83 34.21\"/><path class=\"cls-1\" d=\"M64.85 79.85l-.41-.42V62.79l.41-.21.1-.41 14.27-8.32.44.1v17.14l-14.8 8.76\"/><path class=\"cls-2\" d=\"M49.8 71.63V53.82h.41l14.51 8.45.12.33v17.25L49.8 71.63\"/><path class=\"cls-3\" d=\"M64.6 45.06l-14.8 8.76 15.05 8.76 14.8-8.64-15.05-8.88\"/></g></svg>"

/***/ }),

/***/ "../src/components/sequelize/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SequelizeOriginal = __webpack_require__("../src/components/sequelize/original/SequelizeOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SequelizeOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sequelize/plain-wordmark/SequelizePlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SequelizePlainWordmark = __webpack_require__("../src/components/sequelize/plain-wordmark/SequelizePlainWordmark.svg");
	
	var _SequelizePlainWordmark2 = _interopRequireDefault(_SequelizePlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SequelizePlainWordmark */
	function SequelizePlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SequelizePlainWordmark',
	    svg: _SequelizePlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SequelizePlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SequelizePlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sequelize/plain-wordmark/SequelizePlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"sequelize\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#2f406a}</style></defs><title>Artboard 15</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M46.29 56.56q-3.15 0-3.15 2.37a2 2 0 0 0 .72 1.82 9.66 9.66 0 0 0 2.94 1A7.47 7.47 0 0 1 49.95 63a3.24 3.24 0 0 1 .92 2.59q0 4.47-4.64 4.47a26 26 0 0 1-3.84-.36l-.76-.1.17-1.34a36 36 0 0 0 4.35.38q3.11 0 3.11-2.92a2 2 0 0 0-.69-1.72 6.64 6.64 0 0 0-2.57-.83 8.59 8.59 0 0 1-3.49-1.35 3.38 3.38 0 0 1-1-2.78q0-3.91 4.68-3.91a25.83 25.83 0 0 1 3.68.31l.71.11-.15 1.36a39.48 39.48 0 0 0-4.14-.35zM60.53 68.59l.61-.06v1.24a30.21 30.21 0 0 1-4.1.34 3.69 3.69 0 0 1-3.21-1.31 7 7 0 0 1-.95-4.08q0-5.52 4.39-5.52a4 4 0 0 1 3.17 1.19 5.53 5.53 0 0 1 1.05 3.73l-.08 1.2h-6.89a4.31 4.31 0 0 0 .63 2.58 2.58 2.58 0 0 0 2.19.84q1.57-.03 3.19-.15zM60 64a4.56 4.56 0 0 0-.62-2.73 2.39 2.39 0 0 0-2-.8 2.58 2.58 0 0 0-2.1.84A4.24 4.24 0 0 0 54.5 64zM67.48 70.1a3.52 3.52 0 0 1-3-1.24 7.29 7.29 0 0 1-.91-4.2 6.44 6.44 0 0 1 1.09-4.22q1.09-1.26 3.86-1.26l3.51.21v15.16h-1.59v-5.14a6.89 6.89 0 0 1-2.96.69zm1-9.56a3.09 3.09 0 0 0-2.68 1 5.49 5.49 0 0 0-.7 3.14 6.14 6.14 0 0 0 .58 3.09 2.1 2.1 0 0 0 1.94.93 6.66 6.66 0 0 0 2.42-.46l.38-.15v-7.42q-1.28-.12-1.91-.12zM81.59 59.39h1.58v10.5h-1.58v-.73a6 6 0 0 1-3.11.94q-2.14 0-2.85-1.11a8.38 8.38 0 0 1-.7-4.12v-5.48h1.57v5.46a7.72 7.72 0 0 0 .4 3.07q.4.78 1.81.78a5.21 5.21 0 0 0 1.41-.2 6.42 6.42 0 0 0 1.09-.39l.38-.19zM93.33 68.59l.61-.06v1.24a30.21 30.21 0 0 1-4.1.34 3.69 3.69 0 0 1-3.21-1.31 7 7 0 0 1-.95-4.08q0-5.52 4.39-5.52a4 4 0 0 1 3.17 1.19 5.53 5.53 0 0 1 1.05 3.73l-.08 1.2h-6.88a4.31 4.31 0 0 0 .67 2.55 2.58 2.58 0 0 0 2.19.84q1.52 0 3.14-.12zM92.76 64a4.56 4.56 0 0 0-.62-2.73 2.39 2.39 0 0 0-2-.8 2.58 2.58 0 0 0-2.1.84A4.24 4.24 0 0 0 87.3 64zM96.92 69.89V54.81h1.58v15.08zM101.65 57v-1.81h1.57V57zm0 12.87V59.39h1.57v10.5zM105.62 60.8v-1.41h7.79v1.41l-5.88 7.69h5.88v1.41h-7.79v-1.42l5.88-7.69zM122.88 68.59l.61-.06v1.24a30.21 30.21 0 0 1-4.1.34 3.69 3.69 0 0 1-3.21-1.31 7 7 0 0 1-.95-4.08q0-5.52 4.39-5.52a4 4 0 0 1 3.17 1.19 5.53 5.53 0 0 1 1.05 3.73l-.08 1.2h-6.93a4.31 4.31 0 0 0 .63 2.58 2.58 2.58 0 0 0 2.19.84q1.61-.03 3.23-.15zm-.57-4.59a4.56 4.56 0 0 0-.62-2.73 2.39 2.39 0 0 0-2-.8 2.58 2.58 0 0 0-2.1.84 4.24 4.24 0 0 0-.72 2.69z\"/><g id=\"plain\"><path class=\"cls-1\" d=\"M33 56.92v14.14l-12 7.11-.11.1v5.29l.11.1 16.92-9.78v-19.7h-.16L33 56.81v.12\"/><path class=\"cls-1\" d=\"M8.94 71.18l12.06 7v5.49L4 73.85V54.22h.17L8.88 57l.05.16v14.02\"/><path class=\"cls-1\" d=\"M8.94 57.12l-5-2.9L21 44.4l17 9.78-5 2.74L21 50 9 57.07M10.1 70.4v-5.76l.13.08 4.63 2.7V73l-4.76-2.6M27.08 73.16v-5.63l4.55-2.66.14-.08v5.59l-4.72 2.79M21.2 76.62l-.13-.13V71l.16-.06 4.55-2.66.14-.08v5.58l-4.72 2.84\"/><path class=\"cls-1\" d=\"M16.4 74v-5.77l.13.07 4.63 2.7v5.62L16.4 74M20.71 50.93L16 53.73l4.8 2.79 4.72-2.76-4.8-2.83M10.1 62.87v-5.68h.13l4.63 2.7v5.62l-4.8-2.62\"/><path class=\"cls-1\" d=\"M14.83 54.39l-4.73 2.8L14.91 60l4.72-2.76-4.8-2.83M27.08 65.62v-5.64l4.55-2.66h.14v5.47l-4.72 2.79\"/><path class=\"cls-1\" d=\"M27 54.53l-4.72 2.79 4.8 2.79 4.72-2.76-4.8-2.82M21.2 69.09l-.13-.09v-5.35l.13-.07v-.13l4.55-2.66h.14v5.51l-4.69 2.79\"/><path class=\"cls-1\" d=\"M16.4 66.47v-5.69h.13l4.63 2.7v5.62l-4.8-2.62\"/><path class=\"cls-1\" d=\"M21.13 58l-4.73 2.78 4.8 2.79 4.72-2.76L21.13 58\"/></g></g></svg>"

/***/ }),

/***/ "../src/components/sequelize/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SequelizePlainWordmark = __webpack_require__("../src/components/sequelize/plain-wordmark/SequelizePlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SequelizePlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sequelize/plain/SequelizePlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SequelizePlain = __webpack_require__("../src/components/sequelize/plain/SequelizePlain.svg");
	
	var _SequelizePlain2 = _interopRequireDefault(_SequelizePlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SequelizePlain */
	function SequelizePlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SequelizePlain',
	    svg: _SequelizePlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SequelizePlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SequelizePlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sequelize/plain/SequelizePlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"sequelize\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#2f406a}</style></defs><title>Artboard 13</title><g id=\"plain\"><path class=\"cls-1\" d=\"M101.84 41.72V86l-37.66 22.32-.34.31v16.57l.34.32 53-30.64V33.12l-.5-.12-15 8.36.08.36\"/><path class=\"cls-1\" d=\"M26.4 86.4l37.78 21.92v17.2l-53.4-30.76V33.24l.55-.08 14.91 8.67.16.5V86.4\"/><path class=\"cls-1\" d=\"M26.4 42.32l-15.62-9.08L64.06 2.48l53.16 30.64-15.38 8.6-37.78-21.56L26.4 42.32M30.06 84V65.9l.41.24L45 74.59l.12.07v17.53L30.06 84M83.27 92.6V75l.1-.05 14.27-8.35.44-.26v17.5L83.27 92.6M64.85 103.46l-.41-.42V86l.51-.18 14.27-8.32.44-.25V94.7l-14.8 8.76\"/><path class=\"cls-1\" d=\"M49.8 95.23V77.17l.41.23 14.51 8.45.12 17.61-15.04-8.23M63.29 22.94L48.48 31.7l15.05 8.76 14.8-8.64-15.04-8.88M30.06 60.36V42.55h.41L45 51l.12.33v17.26l-15.06-8.23\"/><path class=\"cls-1\" d=\"M44.86 33.8l-14.8 8.76 15.05 8.76 14.8-8.64-15.05-8.88M83.27 69V51.7l.1-.41L97.64 43l.44.1v17.11L83.27 69\"/><path class=\"cls-1\" d=\"M83 34.21L68.22 43l15.05 8.76 14.8-8.64L83 34.21M64.85 79.85l-.41-.42V62.79l.41-.21.1-.41 14.27-8.32.44.1v17.14l-14.8 8.76\"/><path class=\"cls-1\" d=\"M49.8 71.63V53.82h.41l14.51 8.45.12.33v17.25L49.8 71.63\"/><path class=\"cls-1\" d=\"M64.6 45.06l-14.8 8.76 15.05 8.76 14.8-8.64-15.05-8.88\"/></g></svg>"

/***/ }),

/***/ "../src/components/sequelize/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SequelizePlain = __webpack_require__("../src/components/sequelize/plain/SequelizePlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SequelizePlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sketch/line-wordmark/SketchLineWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SketchLineWordmark = __webpack_require__("../src/components/sketch/line-wordmark/SketchLineWordmark.svg");
	
	var _SketchLineWordmark2 = _interopRequireDefault(_SketchLineWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SketchLineWordmark */
	function SketchLineWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SketchLineWordmark',
	    svg: _SketchLineWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SketchLineWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SketchLineWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sketch/line-wordmark/SketchLineWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Sketch\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#fdad00}</style></defs><title>Artboard 15</title><g id=\"line-wordmark\"><path class=\"cls-1\" d=\"M43.73 68.62v-.32H41v.36c.17 4.06 2.9 6.75 7.77 6.75 4.64 0 7.8-2.41 7.8-6.06a5 5 0 0 0-2-4.33 10.54 10.54 0 0 0-4.19-1.58l-.38-.09-.43-.09c-3.61-.76-4.76-1.42-4.76-3.38s1.66-3.32 4.44-3.32a4.15 4.15 0 0 1 4.49 4.25v.34h2.66v-.35c-.1-4.06-2.82-6.8-7.22-6.8S42 56.61 42 60a4.8 4.8 0 0 0 2 4.26 10.53 10.53 0 0 0 4.2 1.44l.31.06.31.06a11 11 0 0 1 3.55 1.07 2.73 2.73 0 0 1 1.44 2.6c0 2.15-1.81 3.37-5 3.37s-4.87-1.52-5.08-4.24zm18.52-15v-.35h-2.68V75h2.69v-4.08l2.83-2.76 5.05 6.71.11.14h3.34l-.43-.56L67 66.33l5.69-5.66.6-.6h-3.66l-.1.1-7.27 7.32zm25.12 14.8h.33v-.33-.27-.26-.25c0-4.39-2.91-7.63-7.21-7.63s-7.35 3.45-7.35 7.8 2.92 7.83 7.38 7.83a7 7 0 0 0 6.92-5l.14-.45h-2.75l-.08.23a4.26 4.26 0 0 1-4.15 2.76 4.63 4.63 0 0 1-4.68-4.4zM76 66.14a4.53 4.53 0 0 1 4.55-3.92A4.32 4.32 0 0 1 85 66.14zm20.58-3.7h.35v-2.38h-3.28V56H91v4.06h-2.76v2.38H91v8.39c0 2.75 1.43 4.24 4 4.24a8.67 8.67 0 0 0 1.19-.07l.42-.08.26-.07v-2.49l-.42.09h-.38a5.9 5.9 0 0 1-.74.07h-.07c-1.15 0-1.61-.54-1.61-1.89v-8.19zm8.36 12.91a6.86 6.86 0 0 0 7-5.69l.08-.42h-2.71l-.07.26a4.2 4.2 0 0 1-4.31 3.35c-2.76 0-4.66-2.18-4.66-5.31s1.9-5.33 4.66-5.33a4.2 4.2 0 0 1 4.31 3.35l.07.26H112l-.08-.42a6.86 6.86 0 0 0-7-5.69c-4.32 0-7.38 3.47-7.38 7.83s3.08 7.81 7.39 7.81zm12-21.69v-.35h-2.69V75H117v-8.76a3.72 3.72 0 0 1 3.93-4.07c2.26 0 3.4 1.31 3.4 3.79V75H127v-9.43c0-3.51-2.17-5.84-5.75-5.84a5.89 5.89 0 0 0-4.25 1.64zM17.16 78.5h-.38L.81 60.05v-.31l7-9.28.17-.1 9-.94 9.05.94.17.1 7 9.28v.31zM1.32 59.88L17 78l15.62-18.12-6.78-9-8.89-.93-8.84.93z\"/><path class=\"cls-1\" d=\"M16.78 78.5L.81 60.05l.19-.41h6.47l.22.14 9.5 18.45zM1.55 60.14l14.24 16.45-8.47-16.45z\"/><path class=\"cls-1\" d=\"M17.16 78.5l-.41-.28 9.5-18.45.22-.14h6.47l.19.41zm9.46-18.36l-8.47 16.45 14.24-16.45z\"/><path class=\"cls-1\" d=\"M16.75 78.45L7.25 60l.22-.36h19l.22.36-9.5 18.45zM7.88 60.14L17 77.79l9.09-17.65z\"/><path class=\"cls-1\" d=\"M7.65 60.06l-.43-.18.5-9.28.22-.23 9-.94.21.42zm.56-9.22l-.45 8.38L16.33 50z\"/><path class=\"cls-1\" d=\"M26.29 60.06l-9.5-10.22.21-.42 9 .94.22.23.5 9.28zM17.61 50l8.58 9.23-.45-8.38z\"/><path class=\"cls-1\" d=\"M32.94 60.14h-6.47l-.25-.24-.5-9.28.45-.16 7 9.28zm-6.23-.5h5.73l-6.17-8.22zM7.47 60.14H1l-.2-.4 7-9.28.45.16-.5 9.28zm-6-.5h5.76l.44-8.22z\"/><path class=\"cls-1\" d=\"M26.47 60.14h-19l-.18-.42 9.5-10.22h.37l9.5 10.22zM8 59.64h17.9L17 50z\"/></g></svg>"

/***/ }),

/***/ "../src/components/sketch/line-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SketchLineWordmark = __webpack_require__("../src/components/sketch/line-wordmark/SketchLineWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SketchLineWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sketch/line/SketchLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SketchLine = __webpack_require__("../src/components/sketch/line/SketchLine.svg");
	
	var _SketchLine2 = _interopRequireDefault(_SketchLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SketchLine */
	function SketchLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SketchLine',
	    svg: _SketchLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SketchLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SketchLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sketch/line/SketchLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Sketch\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#fdad00}</style></defs><title>Artboard 14</title><g id=\"line\"><path class=\"cls-1\" d=\"M63.81 118.63l-61-70.46v-.31l26.61-35.45.17-.1L64 8.7l34.43 3.61.17.1 26.6 35.44v.31l-61 70.46zM3.32 48L64 118.08 124.68 48 98.25 12.79 64 9.2l-34.25 3.59z\"/><path class=\"cls-1\" d=\"M63.81 118.63l-61-70.46.19-.42h24.71l.22.14 36.29 70.46zM3.55 48.25l59.27 68.47-35.26-68.47z\"/><path class=\"cls-1\" d=\"M64.19 118.63l-.41-.28 36.29-70.46.22-.14H125l.19.41zm36.26-70.38l-35.27 68.47 59.27-68.47z\"/><path class=\"cls-1\" d=\"M64.22 118.58h-.44L27.49 48.11l.22-.36h72.58l.22.36zm-36.1-70.33L64 117.92l35.88-69.67z\"/><path class=\"cls-1\" d=\"M27.89 48.17l-.43-.17 1.91-35.44.22-.23L64 8.7l.21.42zm2-35.39L28 47.32 63.36 9.27z\"/><path class=\"cls-1\" d=\"M100.11 48.17l-36.29-39L64 8.7l34.38 3.6.22.23L100.54 48zM64.64 9.27L100 47.32l-1.86-34.54z\"/><path class=\"cls-1\" d=\"M125 48.25h-24.71L100 48l-1.87-35.43.45-.16 26.62 35.44zm-24.47-.5h24L98.68 13.36z\"/><path class=\"cls-1\" d=\"M100.29 48.25H27.71l-.18-.42 36.29-39h.37l36.29 39zm-72-.5h71.43L64 9.32z\"/><path class=\"cls-1\" d=\"M27.71 48.25H3l-.2-.4 26.62-35.44.45.16L28 48zm-24.21-.5h24l1.85-34.39z\"/></g></svg>"

/***/ }),

/***/ "../src/components/sketch/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SketchLine = __webpack_require__("../src/components/sketch/line/SketchLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SketchLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sketch/original-wordmark/SketchOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SketchOriginalWordmark = __webpack_require__("../src/components/sketch/original-wordmark/SketchOriginalWordmark.svg");
	
	var _SketchOriginalWordmark2 = _interopRequireDefault(_SketchOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SketchOriginalWordmark */
	function SketchOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SketchOriginalWordmark',
	    svg: _SketchOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SketchOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SketchOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sketch/original-wordmark/SketchOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Sketch\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#fdb300}.cls-2{fill:#ea6c00}.cls-3{fill:#fdad00}.cls-4{fill:#fdd231}.cls-5{fill:#feeeb7}</style></defs><title>Artboard 13</title><g id=\"original-wordmark\"><path d=\"M43.73 68.62v-.32H41v.36c.17 4.06 2.9 6.75 7.77 6.75 4.64 0 7.8-2.41 7.8-6.06a5 5 0 0 0-2-4.33 10.54 10.54 0 0 0-4.19-1.58l-.38-.09-.43-.09c-3.61-.76-4.76-1.42-4.76-3.38s1.66-3.32 4.44-3.32a4.15 4.15 0 0 1 4.49 4.25v.34h2.66v-.35c-.1-4.06-2.82-6.8-7.22-6.8S42 56.61 42 60a4.8 4.8 0 0 0 2 4.26 10.53 10.53 0 0 0 4.2 1.44l.31.06.31.06a11 11 0 0 1 3.55 1.07 2.73 2.73 0 0 1 1.44 2.6c0 2.15-1.81 3.37-5 3.37s-4.87-1.52-5.08-4.24zm18.52-15v-.35h-2.68V75h2.69v-4.08l2.83-2.76 5.05 6.71.11.14h3.34l-.43-.56L67 66.33l5.69-5.66.6-.6h-3.66l-.1.1-7.27 7.32zm25.12 14.8h.33v-.33-.27-.26-.25c0-4.39-2.91-7.63-7.21-7.63s-7.35 3.45-7.35 7.8 2.92 7.83 7.38 7.83a7 7 0 0 0 6.92-5l.14-.45h-2.75l-.08.23a4.26 4.26 0 0 1-4.15 2.76 4.63 4.63 0 0 1-4.68-4.4zM76 66.14a4.53 4.53 0 0 1 4.55-3.92A4.32 4.32 0 0 1 85 66.14zm20.58-3.7h.35v-2.38h-3.28V56H91v4.06h-2.76v2.38H91v8.39c0 2.75 1.43 4.24 4 4.24a8.67 8.67 0 0 0 1.19-.07l.42-.08.26-.07v-2.49l-.42.09h-.38a5.9 5.9 0 0 1-.74.07h-.07c-1.15 0-1.61-.54-1.61-1.89v-8.19zm8.36 12.91a6.86 6.86 0 0 0 7-5.69l.08-.42h-2.71l-.07.26a4.2 4.2 0 0 1-4.31 3.35c-2.76 0-4.66-2.18-4.66-5.31s1.9-5.33 4.66-5.33a4.2 4.2 0 0 1 4.31 3.35l.07.26H112l-.08-.42a6.86 6.86 0 0 0-7-5.69c-4.32 0-7.38 3.47-7.38 7.83s3.08 7.81 7.39 7.81zm12-21.69v-.35h-2.69V75H117v-8.76a3.72 3.72 0 0 1 3.93-4.07c2.26 0 3.4 1.31 3.4 3.79V75H127v-9.43c0-3.51-2.17-5.84-5.75-5.84a5.89 5.89 0 0 0-4.25 1.64z\"/><path class=\"cls-1\" d=\"M8 50.61l9-.94 9 .94 7 9.28-16 18.44L1 59.89z\"/><path class=\"cls-2\" d=\"M7.47 59.89l9.5 18.44L1 59.89h6.47zM26.47 59.89l-9.5 18.44 15.97-18.44h-6.47z\"/><path class=\"cls-3\" d=\"M7.47 59.89h19l-9.5 18.44-9.5-18.44z\"/><path class=\"cls-4\" d=\"M16.97 49.66l-9 .95-.5 9.28 9.5-10.23zM16.97 49.66l9 .95.5 9.28-9.5-10.23z\"/><path class=\"cls-3\" d=\"M32.94 59.89l-6.97-9.28.5 9.28h6.47zM1 59.89l6.97-9.28-.5 9.28H1z\"/><path class=\"cls-5\" d=\"M16.97 49.66l-9.5 10.23h19l-9.5-10.23z\"/></g></svg>"

/***/ }),

/***/ "../src/components/sketch/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SketchOriginalWordmark = __webpack_require__("../src/components/sketch/original-wordmark/SketchOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SketchOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sketch/original/SketchOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SketchOriginal = __webpack_require__("../src/components/sketch/original/SketchOriginal.svg");
	
	var _SketchOriginal2 = _interopRequireDefault(_SketchOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SketchOriginal */
	function SketchOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SketchOriginal',
	    svg: _SketchOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SketchOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SketchOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sketch/original/SketchOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Sketch\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#fdb300}.cls-2{fill:#ea6c00}.cls-3{fill:#fdad00}.cls-4{fill:#fdd231}.cls-5{fill:#feeeb7}</style></defs><title>Artboard 12</title><g id=\"original\"><path class=\"cls-1\" d=\"M29.62 12.85L64 9.24l34.38 3.61L125 48.29l-61 70.47L3 48.29z\"/><path class=\"cls-2\" d=\"M27.71 48.29L64 118.76 3 48.29h24.71zM100.29 48.29L64 118.76l61-70.47h-24.71z\"/><path class=\"cls-3\" d=\"M27.71 48.29h72.58L64 118.76 27.71 48.29z\"/><path class=\"cls-4\" d=\"M64 9.24l-34.38 3.61-1.91 35.44L64 9.24zM64 9.24l34.38 3.61 1.91 35.44L64 9.24z\"/><path class=\"cls-3\" d=\"M125 48.29L98.38 12.85l1.91 35.44H125z\"/><path class=\"cls-5\" d=\"M64 9.24L27.71 48.29h72.58L64 9.24z\"/><path class=\"cls-3\" d=\"M3 48.29l26.62-35.44-1.91 35.44H3z\"/></g></svg>"

/***/ }),

/***/ "../src/components/sketch/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SketchOriginal = __webpack_require__("../src/components/sketch/original/SketchOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SketchOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/slack/original-wordmark/SlackOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SlackOriginalWordmark = __webpack_require__("../src/components/slack/original-wordmark/SlackOriginalWordmark.svg");
	
	var _SlackOriginalWordmark2 = _interopRequireDefault(_SlackOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SlackOriginalWordmark */
	function SlackOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SlackOriginalWordmark',
	    svg: _SlackOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SlackOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SlackOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/slack/original-wordmark/SlackOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"slack\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#ecb32d}.cls-2{fill:#63c1a0}.cls-3{fill:#e01a59}.cls-4{fill:#331433}.cls-5{fill:#d62027}.cls-6{fill:#89d3df}.cls-7{fill:#258b74}.cls-8{fill:#819c3c}.cls-9{fill:#2d333a}</style></defs><title>Artboard 10</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M23.69 49.2a3.12 3.12 0 1 0-5.94 1.92l8.07 24.81a3.11 3.11 0 0 0 3.79 1.92A3.06 3.06 0 0 0 31.73 74c0-.05-8.04-24.8-8.04-24.8z\"/><path class=\"cls-2\" d=\"M11.2 53.24a3.12 3.12 0 1 0-5.94 1.92L13.33 80a3.11 3.11 0 0 0 3.79 1.92 3.06 3.06 0 0 0 2.12-3.85c0-.07-8.04-24.83-8.04-24.83z\"/><path class=\"cls-3\" d=\"M33.85 69.72a3.12 3.12 0 1 0-1.92-5.94L7.1 71.88a3.11 3.11 0 0 0-1.92 3.79A3.06 3.06 0 0 0 9 77.79c.08 0 24.85-8.07 24.85-8.07z\"/><path class=\"cls-4\" d=\"M12.26 76.76l5.94-1.92c-.52-1.61-1.21-3.7-1.92-5.94l-5.94 1.92z\"/><path class=\"cls-5\" d=\"M24.78 72.68l5.94-1.92c-.52-1.61-1.21-3.7-1.92-5.94l-5.94 1.92z\"/><path class=\"cls-6\" d=\"M29.78 57.24a3.12 3.12 0 1 0-1.92-5.94L3 59.36a3.11 3.11 0 0 0-1.92 3.79A3.06 3.06 0 0 0 5 65.27l24.78-8.03z\"/><path class=\"cls-7\" d=\"M8.22 64.24l5.94-1.92c-.72-2.24-1.41-4.34-1.92-5.94L6.29 58.3z\"/><path class=\"cls-8\" d=\"M20.7 60.19l5.94-1.92c-.72-2.24-1.41-4.34-1.92-5.94l-5.94 1.92z\"/><path class=\"cls-9\" d=\"M59 55.71c1.09.49 1.18.83.32 2.47s-1.09 1.82-2.18 1.35a12.46 12.46 0 0 0-4.22-1c-1.84 0-3 .66-3 1.67 0 3.3 10.51 1.52 10.51 8.53 0 3.53-3 5.89-7.58 5.89a18 18 0 0 1-7.38-1.84c-1-.52-1.09-.8-.2-2.5.75-1.46 1-1.64 2.1-1.18a15.67 15.67 0 0 0 5.4 1.35c1.67 0 2.78-.69 2.78-1.67 0-3.19-10.71-1.67-10.71-8.47 0-3.62 3-6 7.52-6a17.23 17.23 0 0 1 6.64 1.4zM67.5 47.39v26.18a.94.94 0 0 1-1 .8h-2.76a.94.94 0 0 1-1-.8V47.39c0-1.29.37-1.41 2.38-1.41 2.3.02 2.38.14 2.38 1.41zM87.08 62.09v11.28a1 1 0 0 1-1 1h-2.73a1 1 0 0 1-1-1.09v-1.21a7.68 7.68 0 0 1-5.71 2.5c-4.11 0-6.86-2.38-6.86-5.91 0-3.76 3.1-6.32 7.78-6.32a12.41 12.41 0 0 1 4.71.86v-1.28c0-2.07-1.64-3.3-4.42-3.3a8.86 8.86 0 0 0-4.16 1.26c-1 .55-1.21.52-2.27-1.06s-1-1.87 0-2.53a13.34 13.34 0 0 1 6.89-2c5.39-.04 8.77 2.86 8.77 7.8zm-12.69 6.54c0 1.35 1.15 2.24 2.84 2.24a6 6 0 0 0 5.05-2.7v-1.75a10.35 10.35 0 0 0-3.62-.66c-2.57 0-4.27 1.24-4.27 2.87zM105.75 55.74c1 .57 1 .89-.06 2.58s-1.21 1.69-2.33 1.15a8 8 0 0 0-3.27-.8 5.4 5.4 0 0 0-5.74 5.71c0 3.56 2.3 6 5.74 6a8.35 8.35 0 0 0 3.68-1c1-.57 1.21-.55 2.27 1s.95 1.78.09 2.38a11.64 11.64 0 0 1-6.13 1.85c-6.37 0-10.65-4.08-10.65-10.22s4.28-10.13 10.71-10.13a12.45 12.45 0 0 1 5.69 1.48zM126.59 71.91c.8 1 .49 1.38-1.52 2.1s-2.33.69-3-.23l-5.71-7.61-2.56 2.47v4.94a.94.94 0 0 1-1 .8H110a.94.94 0 0 1-1-.8V47.39c0-1.29.37-1.41 2.38-1.41 2.33 0 2.38.17 2.38 1.41v14.87l7.81-7.49c.86-.8 1.35-.75 2.87.26 1.69 1.09 1.81 1.41 1 2.18l-5.8 5.68z\"/></g></svg>"

/***/ }),

/***/ "../src/components/slack/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SlackOriginalWordmark = __webpack_require__("../src/components/slack/original-wordmark/SlackOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SlackOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/slack/original/SlackOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SlackOriginal = __webpack_require__("../src/components/slack/original/SlackOriginal.svg");
	
	var _SlackOriginal2 = _interopRequireDefault(_SlackOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SlackOriginal */
	function SlackOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SlackOriginal',
	    svg: _SlackOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SlackOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SlackOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/slack/original/SlackOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"slack\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#80cade}.cls-2{fill:#db015c}.cls-3{fill:#e8a900}.cls-4{fill:#41b088}.cls-5{fill:#ca161a}.cls-6{fill:#3b1d37}.cls-7{fill:#69852c}.cls-8{fill:#118f79}</style></defs><title>Artboard 9</title><g id=\"original\"><path class=\"cls-1\" d=\"M12.81 67.6a10.2 10.2 0 0 1-9.94-7c-.06-.17-.1-.33-.15-.49a10.69 10.69 0 0 1 6.92-13.04L97 17.8a11.82 11.82 0 0 1 3.19-.47 10.47 10.47 0 0 1 10.21 7.14l.13.42c1.63 5.71-2.43 10.81-7.29 12.44L16.36 67a11.3 11.3 0 0 1-3.55.6z\"/><path class=\"cls-2\" d=\"M27.37 110.55a10.19 10.19 0 0 1-10-6.89c-.05-.16-.1-.32-.15-.49A10.76 10.76 0 0 1 24.16 90l87.34-29.54a11.24 11.24 0 0 1 3.47-.58A10.55 10.55 0 0 1 125.15 67l.13.44a11.05 11.05 0 0 1-1.28 8.84c-1.25 1.95-5.19 3.66-5.19 3.66l-87.68 30a12 12 0 0 1-3.71.63z\"/><path class=\"cls-3\" d=\"M100.08 110.74a10.72 10.72 0 0 1-10.27-7.31L60.66 16.84l-.15-.49A10.74 10.74 0 0 1 81 10l29.15 86.58.08.28a10.73 10.73 0 0 1-10.17 13.89z\"/><path class=\"cls-4\" d=\"M56.75 125.33A10.73 10.73 0 0 1 46.48 118L17.33 31.43l-.15-.48a10.72 10.72 0 0 1 6.9-13.12 10.89 10.89 0 0 1 3.34-.56 10.72 10.72 0 0 1 10.27 7.31l29.14 86.59c.05.15.1.32.15.48a10.73 10.73 0 0 1-10.23 13.68z\"/><path class=\"cls-5\" d=\"M85.71 91.24L106 84.29l-6.61-19.73L79 71.44z\"/><path class=\"cls-6\" d=\"M42.45 106l20.32-6.95-6.69-19.85-20.35 6.88z\"/><path class=\"cls-7\" d=\"M71.24 48.26l20.33-6.94L85 21.82l-20.36 6.82z\"/><path class=\"cls-8\" d=\"M28 63l20.3-6.91-6.65-19.75-20.36 6.82L28 63z\"/></g></svg>"

/***/ }),

/***/ "../src/components/slack/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SlackOriginal = __webpack_require__("../src/components/slack/original/SlackOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SlackOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/slack/plain-wordmark/SlackPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SlackPlainWordmark = __webpack_require__("../src/components/slack/plain-wordmark/SlackPlainWordmark.svg");
	
	var _SlackPlainWordmark2 = _interopRequireDefault(_SlackPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SlackPlainWordmark */
	function SlackPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SlackPlainWordmark',
	    svg: _SlackPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SlackPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SlackPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/slack/plain-wordmark/SlackPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"slack\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#2d333a}</style></defs><title>Artboard 11</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M58.17 56.11c1.12.47 1.2.83.33 2.44s-1.12 1.75-2.22 1.32a13 13 0 0 0-4.29-1c-1.87 0-3.11.65-3.11 1.63 0 3.24 10.72 1.49 10.72 8.41 0 3.48-3.09 5.8-7.73 5.8a18.71 18.71 0 0 1-7.53-1.81c-1-.51-1.1-.81-.2-2.46.77-1.45 1-1.61 2.14-1.16a16.18 16.18 0 0 0 5.51 1.32c1.71 0 2.85-.67 2.85-1.65 0-3.14-10.9-1.65-10.9-8.35 0-3.56 3.07-5.94 7.67-5.94a18.71 18.71 0 0 1 6.76 1.45zM66.82 47.9v25.78a1 1 0 0 1-1 .81H63a1 1 0 0 1-1-.81V47.9c0-1.28.37-1.4 2.44-1.4 2.3 0 2.38.16 2.38 1.4zM86.78 62.4v11.1a1 1 0 0 1-1 1H83a1 1 0 0 1-1-1.06v-1.2a8 8 0 0 1-5.82 2.46c-4.19 0-7-2.34-7-5.84 0-3.71 3.17-6.21 7.93-6.23a13.19 13.19 0 0 1 4.8.85V62.2c0-2-1.67-3.26-4.5-3.26a9.41 9.41 0 0 0-4.25 1.24c-1 .55-1.24.51-2.32-1s-1-1.85 0-2.48a13.92 13.92 0 0 1 7-2c5.5-.04 8.94 2.83 8.94 7.7zm-12.94 6.43c0 1.32 1.16 2.2 2.91 2.2a6.12 6.12 0 0 0 5.15-2.65v-1.74a11.18 11.18 0 0 0-3.7-.65c-2.61.01-4.36 1.2-4.36 2.84zM105.82 56.15c1 .57 1.06.88-.06 2.55s-1.24 1.67-2.36 1.12a8.22 8.22 0 0 0-3.34-.81c-3.52 0-5.86 2.24-5.86 5.62a5.55 5.55 0 0 0 5.86 5.88 8.86 8.86 0 0 0 3.74-1c1-.57 1.24-.53 2.32 1s1 1.75.08 2.34a12.2 12.2 0 0 1-6.2 1.85c-6.51 0-10.86-4-10.86-10.06s4.35-10 10.9-10a12.73 12.73 0 0 1 5.78 1.51zM127.06 72c.81 1 .49 1.36-1.55 2.06s-2.36.69-3.09-.24l-5.82-7.51-2.6 2.5v4.87a1 1 0 0 1-1 .81h-2.81a1 1 0 0 1-1-.81V47.9c0-1.28.37-1.4 2.44-1.4 2.36 0 2.44.16 2.44 1.4v14.66l8-7.39c.87-.81 1.36-.75 2.93.26 1.73 1.08 1.85 1.38 1 2.16l-6 5.58zM15.27 62.75l1.54 4.45 4.79-1.55-1.55-4.44-4.78 1.54z\"/><path class=\"cls-1\" d=\"M15.27 62.75l1.54 4.45 4.79-1.55-1.55-4.44-4.78 1.54z\"/><path class=\"cls-1\" d=\"M34.84 59.45c-3.69-11.89-9-14.66-21.33-11.09S-1.66 57.07 2 69s9 14.66 21.33 11.09 15.2-8.75 11.51-20.64zm-6.22 7.72l-2.32.75.8 2.32a1.78 1.78 0 0 1-1.17 2.27 1.91 1.91 0 0 1-.64.09 1.85 1.85 0 0 1-1.71-1.22l-.8-2.32L18 70.6l.8 2.32a1.78 1.78 0 0 1-1.17 2.27 1.91 1.91 0 0 1-.64.09 1.85 1.85 0 0 1-1.71-1.22l-.8-2.32-2.32.75a1.91 1.91 0 0 1-.64.09 1.85 1.85 0 0 1-1.72-1.22 1.78 1.78 0 0 1 1.2-2.27l2.32-.75-1.54-4.45-2.32.75a1.91 1.91 0 0 1-.64.09 1.85 1.85 0 0 1-1.71-1.22 1.78 1.78 0 0 1 1.17-2.27l2.32-.75-.8-2.32a1.78 1.78 0 0 1 1.17-2.27 1.87 1.87 0 0 1 2.32 1.1l.8 2.32 4.78-1.55-.8-2.32a1.78 1.78 0 0 1 1.17-2.27 1.87 1.87 0 0 1 2.35 1.13l.8 2.32 2.32-.75A1.87 1.87 0 0 1 27.07 57a1.78 1.78 0 0 1-1.17 2.27l-2.32.75 1.54 4.45 2.32-.75a1.87 1.87 0 0 1 2.35 1.13 1.78 1.78 0 0 1-1.17 2.32z\"/></g></svg>"

/***/ }),

/***/ "../src/components/slack/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SlackPlainWordmark = __webpack_require__("../src/components/slack/plain-wordmark/SlackPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SlackPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/slack/plain/SlackPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SlackPlain = __webpack_require__("../src/components/slack/plain/SlackPlain.svg");
	
	var _SlackPlain2 = _interopRequireDefault(_SlackPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SlackPlain */
	function SlackPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SlackPlain',
	    svg: _SlackPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SlackPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SlackPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/slack/plain/SlackPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"slack\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#2d333a}</style></defs><title>Artboard 7</title><g id=\"plain\"><path class=\"cls-1\" d=\"M53.03 58.97l5.35 15.43 16.59-5.37-5.35-15.43-16.59 5.37z\"/><path class=\"cls-1\" d=\"M53.03 58.97l5.35 15.43 16.59-5.37-5.35-15.43-16.59 5.37z\"/><path class=\"cls-1\" d=\"M120.91 47.51C108.1 6.27 89.61-3.35 46.93 9S-5.72 39.26 7.09 80.49s31.3 50.85 74 38.48 52.63-30.23 39.82-71.46zM99.32 74.27l-8 2.6 2.79 8A6.17 6.17 0 0 1 90 92.8a6.63 6.63 0 0 1-2.21.32 6.42 6.42 0 0 1-5.94-4.24l-2.79-8-16.59 5.32 2.79 8a6.17 6.17 0 0 1-4.06 7.87 6.63 6.63 0 0 1-2.21.32 6.42 6.42 0 0 1-5.99-4.2l-2.79-8-8 2.6a6.64 6.64 0 0 1-2.21.32 6.42 6.42 0 0 1-5.94-4.24A6.17 6.17 0 0 1 38.12 81l8-2.6-5.3-15.48-8 2.6a6.63 6.63 0 0 1-2.21.32 6.42 6.42 0 0 1-5.94-4.24 6.17 6.17 0 0 1 4.06-7.87l8-2.6-2.79-8A6.17 6.17 0 0 1 38 35.2a6.49 6.49 0 0 1 8.15 3.92l2.79 8 16.6-5.37-2.79-8a6.17 6.17 0 0 1 4.06-7.87A6.49 6.49 0 0 1 75 29.81l2.79 8 8-2.6a6.49 6.49 0 0 1 8.15 3.92A6.17 6.17 0 0 1 89.88 47l-8 2.6 5.35 15.43 8-2.6a6.49 6.49 0 0 1 8.15 3.92 6.17 6.17 0 0 1-4.06 7.92z\"/></g></svg>"

/***/ }),

/***/ "../src/components/slack/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SlackPlain = __webpack_require__("../src/components/slack/plain/SlackPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SlackPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sourcetree/original-wordmark/SourcetreeOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SourcetreeOriginalWordmark = __webpack_require__("../src/components/sourcetree/original-wordmark/SourcetreeOriginalWordmark.svg");
	
	var _SourcetreeOriginalWordmark2 = _interopRequireDefault(_SourcetreeOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SourcetreeOriginalWordmark */
	function SourcetreeOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SourcetreeOriginalWordmark',
	    svg: _SourcetreeOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SourcetreeOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SourcetreeOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sourcetree/original-wordmark/SourcetreeOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><g fill=\"#205081\"><path d=\"M8.153 114.608c-3.36-.818-3.36-.818-3.36-2.98 0-1.63.348-2.07 2.794-2.07 1.53 0 3.358.193 5.014.532a.523.523 0 0 0 .624-.443l.344-2.608a.522.522 0 0 0-.408-.58 28.066 28.066 0 0 0-5.632-.61c-4.96 0-6.984 1.648-6.984 5.687 0 2.1.163 3.504.993 4.473.75.876 2.026 1.424 4.706 2.023 3.505.76 3.505.843 3.505 2.98 0 1.822-.35 2.28-2.975 2.28-1.71 0-3.347-.256-5.304-.833a.524.524 0 0 0-.66.388l-.54 2.437a.523.523 0 0 0 .305.594c1.27.538 3.73 1.12 6.137 1.12 6.125 0 7.286-2.104 7.286-5.988 0-2.002-.042-3.28-.866-4.257-.845-1.002-2.402-1.528-4.98-2.147zm14.27-3.358c-4.332 0-6.622 2.082-6.622 6.02v3.712c0 3.937 2.29 6.018 6.623 6.018 4.332 0 6.622-2.08 6.622-6.018v-3.712c0-3.938-2.29-6.02-6.622-6.02zm-2.493 5.9c0-1.62.746-2.312 2.492-2.312 1.747 0 2.492.69 2.492 2.31v3.954c0 1.62-.745 2.31-2.492 2.31-1.747 0-2.492-.69-2.492-2.31v-3.953zm23.39-5.597h-3.084a.522.522 0 0 0-.522.522v9.766c-1.11.566-2.673 1.15-3.608 1.15-.695 0-.953-.257-.953-.952v-9.962a.522.522 0 0 0-.522-.522h-3.084a.522.522 0 0 0-.522.522v10.355c0 3.033 1.192 4.57 3.544 4.57 1.635 0 3.862-.563 5.744-1.446l.225.77c.065.222.27.375.5.375h2.285c.29 0 .522-.235.522-.523v-14.1a.524.524 0 0 0-.523-.524zm10.79.26a.522.522 0 0 0-.688-.438c-1.135.39-2.473 1.153-3.264 1.655l-.153-1.03a.523.523 0 0 0-.517-.447h-2.553a.522.522 0 0 0-.522.522v14.1c0 .29.234.522.522.522h3.085c.29 0 .522-.234.522-.522v-9.055c1.172-.743 2.237-1.366 3.566-1.973a.522.522 0 0 0 .302-.53l-.3-2.804zm11.375 11.691a.524.524 0 0 0-.633-.43 12.2 12.2 0 0 1-2.684.31c-1.957 0-2.523-.5-2.523-2.22v-4.075c0-1.724.566-2.222 2.523-2.222.464 0 1.622.064 2.685.308a.52.52 0 0 0 .633-.43l.366-2.44a.523.523 0 0 0-.37-.58c-1.187-.35-2.576-.474-3.405-.474-4.66 0-6.562 1.7-6.562 5.868v4.014c0 4.167 1.9 5.867 6.562 5.867 1.134 0 2.44-.18 3.41-.472a.524.524 0 0 0 .365-.578l-.367-2.446zm7.982-12.254c-4.135 0-6.32 2.06-6.32 5.96v3.892c0 4.024 2.047 5.898 6.44 5.898 1.792 0 3.7-.313 5.234-.86a.522.522 0 0 0 .337-.597l-.456-2.208a.522.522 0 0 0-.653-.397c-1.415.4-2.765.595-4.128.595-2.25 0-2.644-.726-2.644-2.25v-.53h7.656c.29 0 .522-.235.522-.523v-2.84c0-4.188-1.9-6.14-5.987-6.14zm-2.19 6.097v-.5c0-1.453.706-2.13 2.22-2.13 1.674 0 2.01.815 2.01 2.13v.5h-4.23zm22.093-7.921v-2.753a.522.522 0 0 0-.522-.522H78.415a.522.522 0 0 0-.522.523v2.753c0 .29.234.522.522.522h5.09v16.227c0 .29.235.522.523.522h3.206c.29 0 .522-.234.522-.522v-16.227h5.09a.52.52 0 0 0 .524-.522z\"/><path d=\"M99.715 111.813a.522.522 0 0 0-.69-.438c-1.134.39-2.472 1.153-3.263 1.655L95.61 112a.523.523 0 0 0-.518-.447H92.54a.522.522 0 0 0-.523.522v14.1c0 .29.234.522.522.522h3.084c.29 0 .522-.234.522-.522v-9.055c1.172-.743 2.237-1.366 3.566-1.973a.522.522 0 0 0 .302-.53l-.3-2.804zm7.802-.563c-4.135 0-6.32 2.06-6.32 5.96v3.892c0 4.024 2.047 5.898 6.44 5.898 1.792 0 3.7-.313 5.234-.86a.522.522 0 0 0 .337-.597l-.456-2.208a.524.524 0 0 0-.653-.397c-1.415.4-2.765.595-4.128.595-2.25 0-2.644-.726-2.644-2.25v-.53h7.656c.29 0 .522-.235.522-.523v-2.84c0-4.188-1.9-6.14-5.987-6.14zm-2.19 6.097v-.5c0-1.453.706-2.13 2.22-2.13 1.674 0 2.01.815 2.01 2.13v.5h-4.23zm16.429-6.097c-4.135 0-6.32 2.06-6.32 5.96v3.892c0 4.024 2.047 5.898 6.44 5.898 1.792 0 3.7-.313 5.234-.86a.522.522 0 0 0 .336-.597l-.456-2.208a.522.522 0 0 0-.654-.397c-1.415.4-2.765.595-4.128.595-2.248 0-2.643-.726-2.643-2.25v-.53h7.656c.29 0 .523-.235.523-.523v-2.84c0-4.188-1.902-6.14-5.987-6.14zm-2.19 6.097v-.5c0-1.453.705-2.13 2.22-2.13 1.673 0 2.01.815 2.01 2.13v.5h-4.23zM64 5C37.77 5 16.428 26.342 16.428 52.574S37.767 100.146 64 100.147c26.232 0 47.572-21.342 47.572-47.573S90.232 5 64.002 5zm2.507 90.36v-8.263l20.633-10.45a1.47 1.47 0 0 0 .806-1.314v-4.73a4.495 4.495 0 0 0 3-4.705 4.495 4.495 0 1 0-8.94.922 4.488 4.488 0 0 0 3 3.783v3.826l-18.498 9.368v-7.685l8.154-3.772c.52-.238.852-.76.854-1.332l.016-12.802 15.09-8.477c.464-.26.75-.752.75-1.284v-3.57a4.493 4.493 0 0 0-1.932-8.715 4.494 4.494 0 0 0-4.01 4.933 4.49 4.49 0 0 0 3 3.782v2.71l-15.09 8.476a1.47 1.47 0 0 0-.75 1.283l-.017 12.722-6.066 2.804V45.204l12.695-6.208c.504-.244.825-.758.825-1.32v-4.73a4.493 4.493 0 0 0-1.932-8.714 4.494 4.494 0 0 0-4.01 4.934 4.486 4.486 0 0 0 3 3.78v3.813l-10.578 5.17V25.954a4.495 4.495 0 1 0-5.94-3.783 4.487 4.487 0 0 0 3 3.78v26.05l-7.478-3.93v-11.83c0-.458-.214-.89-.577-1.168L50.4 31.16a4.496 4.496 0 1 0-1.962 2.2l4.71 3.61v11.994c0 .547.304 1.05.788 1.303l9.632 5.06v9.568l-16.07-7.432.22-5.822a1.47 1.47 0 0 0-.8-1.364l-7.365-3.778c.11-.474.15-.972.097-1.482a4.496 4.496 0 0 0-8.942.923 4.495 4.495 0 0 0 4.932 4.01 4.452 4.452 0 0 0 2.33-.955l6.77 3.472-.22 5.866a1.472 1.472 0 0 0 .852 1.39l18.195 8.416v6.83a1.482 1.482 0 0 0 0 .388v20.07a43.294 43.294 0 0 1-4.582-.29V77.88a1.47 1.47 0 0 0-.857-1.336L46.71 71.293a4.49 4.49 0 0 0-4.935-4.908 4.494 4.494 0 1 0 3.702 7.58l10.562 4.86v15.86c-19.844-3.743-34.905-21.197-34.905-42.11 0-23.636 19.23-42.867 42.865-42.867 23.636 0 42.864 19.23 42.864 42.866 0 22.794-17.885 41.483-40.357 42.785z\"/></g></svg>"

/***/ }),

/***/ "../src/components/sourcetree/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SourcetreeOriginalWordmark = __webpack_require__("../src/components/sourcetree/original-wordmark/SourcetreeOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SourcetreeOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sourcetree/original/SourcetreeOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SourcetreeOriginal = __webpack_require__("../src/components/sourcetree/original/SourcetreeOriginal.svg");
	
	var _SourcetreeOriginal2 = _interopRequireDefault(_SourcetreeOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SourcetreeOriginal */
	function SourcetreeOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SourcetreeOriginal',
	    svg: _SourcetreeOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SourcetreeOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SourcetreeOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/sourcetree/original/SourcetreeOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#205081\" d=\"M64 .73C29.114.73.73 29.113.73 64S29.114 127.27 64 127.27c34.888 0 63.27-28.384 63.27-63.27S98.887.73 64 .73zm3.335 120.17v-10.988l27.44-13.9a1.955 1.955 0 0 0 1.073-1.747v-6.29a5.98 5.98 0 0 0 3.99-6.258 5.978 5.978 0 1 0-11.892 1.225 5.97 5.97 0 0 0 3.99 5.03v5.09l-24.6 12.46v-10.22l10.843-5.017a1.957 1.957 0 0 0 1.135-1.773l.02-17.026 20.07-11.276c.617-.346 1-1 1-1.706V53.76a5.974 5.974 0 0 0-2.57-11.59 5.975 5.975 0 0 0-1.344 11.59v3.606l-20.07 11.27c-.617.35-1 1-1 1.706l-.02 16.92-8.068 3.73V54.2l16.884-8.257a1.95 1.95 0 0 0 1.097-1.755v-6.29a5.978 5.978 0 0 0 3.99-6.26 5.976 5.976 0 0 0-6.56-5.33 5.975 5.975 0 0 0-5.332 6.56 5.964 5.964 0 0 0 3.99 5.027v5.07l-14.068 6.877V28.598a5.977 5.977 0 1 0-7.902-5.03 5.97 5.97 0 0 0 3.988 5.028V63.24l-9.943-5.224V42.28a1.95 1.95 0 0 0-.767-1.552l-6.802-5.21a5.978 5.978 0 1 0-2.61 2.928l6.265 4.802V59.2c0 .728.404 1.395 1.048 1.733l12.81 6.73v12.724l-21.37-9.884.292-7.742a1.956 1.956 0 0 0-1.063-1.815l-9.797-5.025c.147-.63.2-1.292.13-1.97a5.978 5.978 0 0 0-11.892 1.227 5.977 5.977 0 0 0 6.56 5.33 5.91 5.91 0 0 0 3.1-1.268l9.004 4.616-.295 7.8c-.03.79.417 1.52 1.133 1.85L63.42 84.7v9.084a1.98 1.98 0 0 0 0 .516v26.693a57.53 57.53 0 0 1-6.093-.387V97.66c0-.766-.445-1.46-1.14-1.778l-15.182-6.987a5.974 5.974 0 0 0-6.563-6.527 5.976 5.976 0 1 0 4.924 10.08l14.047 6.463v21.092C27.022 115.028 6.992 91.815 6.992 64c0-31.434 25.574-57.01 57.01-57.01 31.433 0 57.006 25.576 57.006 57.01 0 30.315-23.787 55.17-53.674 56.902z\"/></svg>"

/***/ }),

/***/ "../src/components/sourcetree/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SourcetreeOriginal = __webpack_require__("../src/components/sourcetree/original/SourcetreeOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SourcetreeOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ssh/original-wordmark/SshOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SshOriginalWordmark = __webpack_require__("../src/components/ssh/original-wordmark/SshOriginalWordmark.svg");
	
	var _SshOriginalWordmark2 = _interopRequireDefault(_SshOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SshOriginalWordmark */
	function SshOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SshOriginalWordmark',
	    svg: _SshOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SshOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SshOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ssh/original-wordmark/SshOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M99.438 45.906c-1.593 7.332-6.957 31.736-6.957 31.736h10.766c.645-3.008 1.146-5.777 1.88-8.835 1.297-5.42 2.752-7.566 6.6-7.566 1.697 0 3.453.577 3.453 2.895 0 1.054-2.42 11.405-2.845 13.507h10.714s3.322-16.116 3.35-16.3c.112-.542.355-2.133.355-2.133 0-3.85-5.01-5.665-7.617-5.74-1.886-.053-.465-.032-2.387 0-3.085.053-7.185 1.767-8.987 3.606l-.203.152.102-.254 2.437-10.866a.344.344 0 0 0-.103-.203h-10.56zm-50.98 7.26c-1.056-.016-2.795-.015-5.586.052-5.58.133-13.913 1.852-13.913 9.85 0 4.524 4.2 4.918 7.92 5.282 2.91.287 5.792.627 8.632.914.818.076 1.625.26 1.625 1.168 0 1.54-1.27 2.027-3.047 2.183-1.776.157-2.183 0-2.183 0-1.12 0-3.036-.677-2.793-2.285H26.47v1.88c.005 6.05 9.77 6.073 11.578 6.295h3.148l4.824-.152c6.44-.425 13.41-2.355 13.71-10.054.208-5.312-6.58-5.16-9.546-5.485h-.812c-.152 0-4.763-.468-7.058-.71-.35-.04-1.93-.273-1.93-1.22 0-1.88 3.457-1.828 4.215-1.828 1.218 0 3.854-.052 3.757 2.03H60.29c.024-.443.203-.842.203-1.32 0-5.354-6.87-6.37-10.612-6.55 0 0-.366-.033-1.422-.05zm32.09 0c-.472-.017-1.118-.004-3.91.052-5.59.112-13.963 1.902-13.963 9.902 0 4.523 4.202 4.917 7.92 5.28 2.91.288 5.792.628 8.633.915.818.076 1.625.26 1.625 1.168 0 1.54-1.584 2.09-3.047 2.183-1.464.093-2.183 0-2.183 0-1.122 0-3.036-.627-2.793-2.234H60.187v1.88c-.01 5.72 9.73 6.095 11.577 6.194l3.148.102 4.824-.152c6.44-.423 13.385-2.357 13.71-10.054.214-5.076-6.34-5.007-9.445-5.433l-.913-.103c-.152 0-4.763-.418-7.058-.66-.35-.038-1.88-.323-1.88-1.27 0-1.878 3.407-1.827 4.164-1.827 1.22 0 3.855-.052 3.758 2.03h11.933c.024-.443.203-.842.203-1.32 0-5.355-6.904-6.39-10.612-6.498-2.27-.07-2.574-.137-3.047-.155zm-60.771-7.92c0-1.958-1.387-3.453-3.453-3.453-1.938 0-3.504 1.495-3.504 3.453 0 1.835 1.49 3.504 3.453 3.504 1.856 0 3.504-1.462 3.504-3.504zm9.496-8.176c0-1.49-.975-3.4-3.047-3.4-1.885 0-2.844 1.655-2.844 3.147 0 1.443 1.02 3.554 3.047 3.554 1.884 0 2.843-1.856 2.843-3.3zm-8.486 55.297c-1.728 0-4.008 2.258-4.008 3.96 0 .866.404 1.32 1.346 1.32 1.232 0 2.847-1.043 3.613-2.59.15-.303.26-.816.26-.913v-.863c0-.72-.707-.913-1.213-.913zm-7.357-4.214c-1.91 0-4.57 1.992-4.57 4.215 0 1.1.684 1.625 1.676 1.625 1.836 0 4.722-1.925 4.722-4.265 0-1.154-.807-1.575-1.828-1.575zM8.15 60.885c1.805 0 4.315-1.247 4.315-3.808 0-1.934-1.594-3.148-3.35-3.148-1.91 0-4.368 1.325-4.368 3.807 0 1.91 1.543 3.148 3.402 3.148zm2.183 20.87c0-1.492-1.104-2.082-2.336-2.082-1.8 0-4.925 1.73-4.925 4.215 0 1.402.955 2.03 2.285 2.03 1.703 0 4.976-1.543 4.976-4.163zM9.114 70.177c0-1.777-1.45-2.59-2.996-2.59-.098 0-.17-.03-.56 0-2.232.187-4.315 2.11-4.315 4.062 0 1.825 1.66 2.59 3.097 2.59 1.86 0 4.774-1.427 4.774-4.063zm19.753 22.85c-1.62 0-3.504 2.164-3.504 3.656 0 .22.004.65.406.914.42.276 1.172.3 2.08-.305 1.22-.813 2.032-2.252 2.032-3.2 0-.52-.333-1.065-1.015-1.065zM51.87 34.836c-1.36 0-1.83 2.11-1.83 2.793 0 .676.235 2.182 1.423 2.182 1.394 0 1.828-2.11 1.828-2.793 0-.574-.307-2.183-1.42-2.184zm4.416 5.586c-1.256 0-1.726 2.063-1.726 2.69 0 .526.2 1.778 1.168 1.778 1.222 0 1.676-2.012 1.676-2.64 0-.417-.185-1.828-1.118-1.828zm-11.069-9.394c-1.58 0-2.082 1.977-2.082 2.894 0 .604.372 2.756 1.88 2.742 1.506-.015 2.08-1.973 2.08-2.945 0-.756-.362-2.692-1.878-2.692zm-2.133 55.754c-1.433 0-2.437 2.19-2.437 3.047 0 .447.114.913.762.913 1.417 0 2.436-2.153 2.436-3.047 0-.418-.153-.914-.762-.914zm-6.702-56.566c-1.727 0-2.387 2.05-2.387 3.148 0 1.153.85 3.148 2.54 3.148 1.712 0 2.366-2.047 2.335-3.097-.04-1.344-.604-3.2-2.488-3.2zm0 60.679c-1.57 0-2.894 2.25-2.894 3.402 0 .58.264.914.863.914 1.42 0 2.895-2.17 2.895-3.3 0-.496-.102-1.015-.863-1.015z\" fill=\"#231F20\"/></svg>"

/***/ }),

/***/ "../src/components/ssh/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SshOriginalWordmark = __webpack_require__("../src/components/ssh/original-wordmark/SshOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SshOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ssh/original/SshOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SshOriginal = __webpack_require__("../src/components/ssh/original/SshOriginal.svg");
	
	var _SshOriginal2 = _interopRequireDefault(_SshOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SshOriginal */
	function SshOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SshOriginal',
	    svg: _SshOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SshOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SshOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ssh/original/SshOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M34.27 109.182c-3.572 0-8.55 3.725-8.55 7.884 0 2.055 1.28 3.04 3.135 3.04 3.434 0 8.834-3.6 8.834-7.98-.002-2.156-1.512-2.944-3.42-2.944zm11.872-80.265c0-3.662-2.594-6.46-6.46-6.46-3.625 0-6.553 2.798-6.553 6.46 0 3.433 2.786 6.554 6.458 6.554 3.47 0 6.554-2.733 6.554-6.553zm17.763-15.293c0-2.79-1.825-6.364-5.7-6.364-3.524 0-5.318 3.098-5.318 5.89 0 2.698 1.908 6.648 5.7 6.648 3.524 0 5.318-3.474 5.318-6.174zM48.38 117.066c-3.23 0-7.673 4.224-7.673 7.41 0 1.618.67 2.47 2.432 2.47 2.303 0 5.63-1.953 7.064-4.845.284-.568.795-1.527.795-1.71v-1.614c-1-1.347-1.673-1.71-2.62-1.71zM28.475 97.213c0-2.79-2.066-3.894-4.37-3.894-3.368 0-9.213 3.236-9.213 7.883 0 2.624 1.787 3.8 4.274 3.8 3.185 0 9.31-2.888 9.31-7.79zm-4.085-39.04c3.38 0 8.074-2.332 8.074-7.124 0-3.618-2.983-5.89-6.27-5.89-3.57 0-8.168 2.48-8.168 7.124 0 3.572 2.885 5.89 6.364 5.89zm1.805 17.383c0-3.325-2.713-4.844-5.604-4.844-.182 0-.32-.056-1.044 0-4.177.35-8.074 3.946-8.074 7.6 0 3.414 3.104 4.843 5.794 4.843 3.48 0 8.93-2.67 8.93-7.6zm79.979-66.111c-2.543 0-3.42 3.948-3.42 5.224 0 1.266.438 4.083 2.66 4.083 2.607 0 3.42-3.948 3.42-5.224 0-1.074-.576-4.085-2.66-4.085zM93.73 2.32c-2.955 0-3.893 3.7-3.893 5.415 0 1.13.696 5.156 3.515 5.13 2.82-.03 3.894-3.693 3.894-5.51 0-1.413-.68-5.034-3.515-5.034zm20.708 17.573c-2.35 0-3.23 3.86-3.23 5.034 0 .982.376 3.325 2.185 3.325 2.285 0 3.135-3.765 3.135-4.94 0-.78-.345-3.42-2.09-3.42zm-24.696 86.724c-2.68 0-4.56 4.094-4.56 5.7 0 .836.214 1.71 1.426 1.71 2.652 0 4.56-4.03 4.56-5.7-.002-.782-.288-1.71-1.426-1.71zM63.145 118.3c-3.03 0-6.554 4.048-6.554 6.84 0 .41.008 1.213.76 1.71.788.515 2.196.563 3.895-.57 2.28-1.522 3.8-4.213 3.8-5.985 0-.973-.623-1.994-1.9-1.995zM77.203.8c-3.23 0-4.464 3.834-4.464 5.89 0 2.157 1.59 5.89 4.748 5.89 3.205 0 4.43-3.83 4.37-5.795C81.782 4.27 80.727.8 77.202.8zm0 113.51c-2.937 0-5.414 4.21-5.414 6.365 0 1.085.494 1.71 1.614 1.71 2.653 0 5.414-4.064 5.414-6.174 0-.927-.19-1.9-1.615-1.9z\" fill=\"#231F20\"/></svg>"

/***/ }),

/***/ "../src/components/ssh/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SshOriginal = __webpack_require__("../src/components/ssh/original/SshOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SshOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/stylus/original/StylusOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _StylusOriginal = __webpack_require__("../src/components/stylus/original/StylusOriginal.svg");
	
	var _StylusOriginal2 = _interopRequireDefault(_StylusOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** StylusOriginal */
	function StylusOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'StylusOriginal',
	    svg: _StylusOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	StylusOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = StylusOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/stylus/original/StylusOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Stylus\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#333}</style></defs><title>Artboard 12</title><g id=\"original\"><path class=\"cls-1\" d=\"M20.62 85.39c3.25-3.89 3.64-7.91 1.12-15.37-1.59-4.72-4.24-8.36-2.3-11.29 2.07-3.13 6.47-.1 2.81 4.08l.73.51c4.4.51 6.57-5.52 3.28-7.24-8.67-4.53-16.26 4.18-12.91 14.26 1.44 4.27 3.44 8.8 1.82 12.41-1.4 3.09-4.11 4.91-5.93 5C5.44 87.91 8 79.2 12.33 77c.38-.19.92-.45.41-1.08-5.39-.61-8.55 1.88-10.36 5.36-5.29 10.14 10.05 13.87 18.24 4.11zM115.34 55.67c1.24 3.06 3.13 6.09 2 8.77-.92 2.3-2.14 3.25-3.48 3.48-1.88.32-1.37-5.58 1.85-7.33.29-.16.7-.92.32-1.37-4.08-.22-6.38 1.72-7.62 4.31-3.6 7.56 8.16 9.63 13.94 2.2 2.3-3 2.39-5.9.19-11.23-1.4-3.38-3.54-5.9-2.2-8.13s4.88-.32 2.3 2.84l.57.32c3.35.19 4.72-4.27 2.17-5.39-6.73-2.89-13.01 4.35-10.04 11.53z\"/><path class=\"cls-1\" d=\"M72.73 47.6c-2.33-1.85-8.86 1.24-10.73 5.84-2.33 5.84-5.77 14.35-9.15 18.08-3.57 3.92-3.92.89-3.57-1.37.83-5.33 6-17.67 8.87-21.14-1.05-1.56-7.94-1.34-12.72 6.09-1.78 2.8-5.86 12.14-10.43 19.51-1 1.59-2.23.48-1.28-3.25 1.08-4.31 4.27-16.14 8.39-25.45 10.78-2.14 22.23-3.64 31-3.67 1.18-.32 2-1.37 0-1.44-7.56-.26-18.91.64-29.53 2 2-4.08 4.24-7.33 6.47-8.71-2.42-1.53-7.33-.92-10.14 3.22a55 55 0 0 0-3.67 6.51c-7.74 1.18-14.4 2.57-17.78 3.84s-3.13 5.58-1 4.78a141.67 141.67 0 0 1 17.09-4.91C30.32 57.1 27 68.39 26.2 73c-2 11.16 4.94 11.1 8.32 6.7C38.2 74.87 45.85 57.93 47 56.15c.35-.61.83-.29.57.26-8.55 17.06-7.81 23.66-.89 22.2 3.13-.67 8.51-6 9.92-8.8.29-.67.89-.61.77-.32C52 83.54 45.08 94.92 40.46 98.5c-4.21 3.22-7.33-3.76 7.56-13.78 2.2-1.5 1.18-3.54-1.31-2.84C39 83.09 17 90.08 7.36 96.77c-.73.51-1.4.92-1.37 2 0 .61 1.08.38 1.59.06 12.5-7.49 22.74-10.43 34.47-12.88a.71.71 0 0 0 .51 0c.54-.13.51.16.16.38-.8.45-1.59.86-1.79.92-7.91 3.09-12.69 9.92-11 13.39 1.44 3 9.18 1.91 12.85-.06 9-4.88 15.53-14.45 20-27.65 3.89-11.68 8.8-24.93 9.95-25.33zM125 74.61c-14.64-1.91-46.21.64-60.15 4.34-4.15 1.08-3 3.28-.89 2.87l1-.22c11.45-2.23 39.23-4.18 55.43-1.08 1.9.34 7.74-5.52 4.61-5.91zM76.81 72.89C80.9 70.85 87 58.22 90.94 51.3c.29-.51.8-.1.51.26-10.08 17.35-5.8 19.36-1.82 19.1C95 70.34 99.87 62.68 101 61c.45-.67.7-.13.45.35-.26.8-1.18 2.2-2 4.11-1.21 2.71.06 3.76 1.12 4.24 1.66.8 6.19.29 6.89-2.49-4.53-.1 6.31-21.46 7.43-22.77-3-1.75-7.72.16-9.85 4.37-4.56 9-8.39 16.3-10.78 16.42-4.66.26 5.36-20.12 7-20.76-1-1.44-7.33-.83-10.87 4.66-1.28 2-9.06 15.75-11 18-3.38 4-3.64.57-2.68-3.44a47.34 47.34 0 0 1 1.56-5.07c2.23-5 4.62-6.63 6.09-8.26 9.85-10.94 15.5-19.8 13.27-23.28-2-3.09-8.58-1.72-12.82 4.66-7.81 11.7-15 27.74-15.95 35.08s4.35 7.85 7.95 6.07zM81 51.43c.35-.8.57-1 1.18-2.36 3.47-7.72 7.82-15.85 10.9-19.65 1.88-2 4.53.7-.26 8a73.73 73.73 0 0 1-9.47 11.83c-.89 1-1.69 1.82-2 2.3-.29.39-.58.32-.35-.12z\"/></g></svg>"

/***/ }),

/***/ "../src/components/stylus/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StylusOriginal = __webpack_require__("../src/components/stylus/original/StylusOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StylusOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/swift/original-wordmark/SwiftOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SwiftOriginalWordmark = __webpack_require__("../src/components/swift/original-wordmark/SwiftOriginalWordmark.svg");
	
	var _SwiftOriginalWordmark2 = _interopRequireDefault(_SwiftOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SwiftOriginalWordmark */
	function SwiftOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SwiftOriginalWordmark',
	    svg: _SwiftOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SwiftOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SwiftOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/swift/original-wordmark/SwiftOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Swift\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#f05138}.cls-2{fill:#fefefe}.cls-3{fill:#221f20}</style></defs><title>Artboard 2</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M37.35 54a11.24 11.24 0 0 0-.23-2.26 7.42 7.42 0 0 0-2.16-4A6.83 6.83 0 0 0 33 46.39a8 8 0 0 0-2.24-.73c-.77-.15-1.62-.15-2.39-.22H9.35a13.37 13.37 0 0 0-1.77.15 6.41 6.41 0 0 0-1.7.44c-.15.07-.39.15-.54.22a9.86 9.86 0 0 0-1.47.95c-.15.15-.31.22-.46.36A6.47 6.47 0 0 0 2 49.38a6.77 6.77 0 0 0-.77 2.19A22.44 22.44 0 0 0 1 53.82v17.43a11.24 11.24 0 0 0 .23 2.26 7.42 7.42 0 0 0 2.16 4 6.83 6.83 0 0 0 1.93 1.31 8 8 0 0 0 2.24.73c.77.15 1.62.15 2.39.22h18.46a13.26 13.26 0 0 0 2.39-.22 8 8 0 0 0 2.2-.72 8.78 8.78 0 0 0 2-1.31 6.47 6.47 0 0 0 1.39-1.82 6.77 6.77 0 0 0 .77-2.19 22.44 22.44 0 0 0 .23-2.26V54z\"/><path class=\"cls-2\" d=\"M25.3 72c-3.24 1.77-7.69 1.95-12.16.14a18.77 18.77 0 0 1-8.57-6.94A14.61 14.61 0 0 0 7.74 67c4.62 2 9.25 1.91 12.5 0a64.45 64.45 0 0 1-11.5-11.28 12.56 12.56 0 0 1-1.54-2 88.68 88.68 0 0 0 11.18 8 78.59 78.59 0 0 1-7.87-9.33 77.67 77.67 0 0 0 13 10.06l.5.28a9.38 9.38 0 0 0 .35-1c1.08-3.72-.15-7.95-2.85-11.45 6.25 3.57 9.95 10.28 8.41 15.9 0 .15-.08.3-.13.45l.05.06c3.09 3.65 2.24 7.51 1.85 6.78C30 70.42 26.87 71.36 25.3 72z\"/><path class=\"cls-3\" d=\"M119.34 60.31h-8.95v-1.09c0-.87.08-1.75.15-2.62a5.73 5.73 0 0 1 .62-2.19 4.09 4.09 0 0 1 1.31-1.46 4.49 4.49 0 0 1 2.31-.58 7.49 7.49 0 0 1 1.47.15c.39.15.69.22 1 .36l.62-1.46a7.29 7.29 0 0 0-1.23-.44 6 6 0 0 0-1.7-.22 6.59 6.59 0 0 0-3.09.66 6.12 6.12 0 0 0-2.08 1.82 8.75 8.75 0 0 0-1.08 2.7 15.55 15.55 0 0 0-.31 3.35v1.09h-2.93v1.46h2.93v17.65h2V61.77h8.95v12.1a11.64 11.64 0 0 0 .23 2.41 4.69 4.69 0 0 0 .69 1.9 3.2 3.2 0 0 0 1.39 1.24 5.41 5.41 0 0 0 2.31.44 6.87 6.87 0 0 0 2.7-.44l-.21-1.42a8.39 8.39 0 0 1-.93.22 7 7 0 0 1-1.31.07 2.51 2.51 0 0 1-2.24-1 6 6 0 0 1-.62-2.92V61.84H127v-1.45h-5.63v-4.23l-2 .58zm.08 0zm.08 1.46zm-70 14.8a9.51 9.51 0 0 0 2.78 1.24 12.09 12.09 0 0 0 3.32.51 7.31 7.31 0 0 0 4.94-1.53 5.2 5.2 0 0 0 1.77-4A5.39 5.39 0 0 0 61 69.06a11.66 11.66 0 0 0-4.32-2.62 15.12 15.12 0 0 1-5.24-2.84 5.78 5.78 0 0 1-1.93-4.52 6.33 6.33 0 0 1 .62-2.7 6.56 6.56 0 0 1 1.7-2.11 7 7 0 0 1 2.55-1.39 9.4 9.4 0 0 1 3.24-.51 15 15 0 0 1 3.39.36 9.8 9.8 0 0 1 2.08.8l-.77 1.6a7.23 7.23 0 0 0-1.85-.8 9.27 9.27 0 0 0-3-.44 8 8 0 0 0-2.85.44 5.58 5.58 0 0 0-1.92 1.17 5.12 5.12 0 0 0-1 1.6 4.3 4.3 0 0 0-.31 1.68 4.75 4.75 0 0 0 1.39 3.57 14.15 14.15 0 0 0 4.4 2.48 18.59 18.59 0 0 1 3 1.46A13.23 13.23 0 0 1 62.42 68a5.86 5.86 0 0 1 1.31 2 7.25 7.25 0 0 1 .46 2.62 7.44 7.44 0 0 1-.54 2.84A6.38 6.38 0 0 1 62 77.81a8.49 8.49 0 0 1-2.78 1.6 12.16 12.16 0 0 1-3.86.58 15.82 15.82 0 0 1-1.85-.15 16.6 16.6 0 0 1-1.85-.36 11.43 11.43 0 0 1-1.7-.58 6.86 6.86 0 0 1-1.31-.66zM68 60.39l3.32 10.86c.31 1.09.62 2.19.93 3.14s.54 2 .77 2.84h.15c.23-.87.54-1.82.85-2.84s.69-2 1.08-3.14L79 60.39h1.85l3.78 10.71c.39 1.17.77 2.26 1.08 3.28s.62 2 .85 2.84h.15c.23-.95.46-1.9.77-2.84s.62-2 1-3.21L92 60.39h2l-6.63 19.1h-1.58L82 68.84q-.58-1.75-1.16-3.28c-.31-1-.62-2.11-.85-3.21h-.08a33.72 33.72 0 0 1-1 3.28q-.58 1.53-1.16 3.28l-3.92 10.58h-1.7L66 60.39zm30.31 0h2v19.1h-2zm-.77-5.83a1.66 1.66 0 0 1 1.7-1.68 1.8 1.8 0 0 1 1.76 1.67 1.51 1.51 0 0 1-.54 1.17 1.81 1.81 0 0 1-1.23.44 2 2 0 0 1-1.23-.44 1.73 1.73 0 0 1-.49-1.17z\"/></g></svg>"

/***/ }),

/***/ "../src/components/swift/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SwiftOriginalWordmark = __webpack_require__("../src/components/swift/original-wordmark/SwiftOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SwiftOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/swift/original/SwiftOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SwiftOriginal = __webpack_require__("../src/components/swift/original/SwiftOriginal.svg");
	
	var _SwiftOriginal2 = _interopRequireDefault(_SwiftOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SwiftOriginal */
	function SwiftOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SwiftOriginal',
	    svg: _SwiftOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SwiftOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SwiftOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/swift/original/SwiftOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Swift\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#f05138}.cls-2{fill:#fefefe}</style></defs><title>Artboard 1</title><g id=\"orignal\"><path class=\"cls-1\" d=\"M126.33 34.06a39.32 39.32 0 0 0-.79-7.83 28.78 28.78 0 0 0-2.65-7.58 28.84 28.84 0 0 0-4.76-6.32 23.42 23.42 0 0 0-6.62-4.55 27.27 27.27 0 0 0-7.68-2.53c-2.65-.51-5.56-.51-8.21-.76H30.25a45.46 45.46 0 0 0-6.09.51 21.82 21.82 0 0 0-5.82 1.52c-.53.25-1.32.51-1.85.76a33.82 33.82 0 0 0-5 3.28c-.53.51-1.06.76-1.59 1.26a22.41 22.41 0 0 0-4.76 6.32 23.61 23.61 0 0 0-2.65 7.58 78.5 78.5 0 0 0-.79 7.83v60.39a39.32 39.32 0 0 0 .79 7.83 28.78 28.78 0 0 0 2.65 7.58 28.84 28.84 0 0 0 4.76 6.32 23.42 23.42 0 0 0 6.62 4.55 27.27 27.27 0 0 0 7.68 2.53c2.65.51 5.56.51 8.21.76h63.22a45.08 45.08 0 0 0 8.21-.76 27.27 27.27 0 0 0 7.68-2.53 30.13 30.13 0 0 0 6.62-4.55 22.41 22.41 0 0 0 4.76-6.32 23.61 23.61 0 0 0 2.65-7.58 78.49 78.49 0 0 0 .79-7.83V34.06z\"/><path class=\"cls-2\" d=\"M85 96.5c-11.11 6.13-26.38 6.76-41.75.47A64.53 64.53 0 0 1 13.84 73a50 50 0 0 0 10.85 6.32c15.87 7.1 31.73 6.61 42.9 0-15.9-11.66-29.4-26.82-39.46-39.2a43.47 43.47 0 0 1-5.29-6.82c12.16 10.61 31.5 24 38.38 27.79a271.77 271.77 0 0 1-27-32.34 266.8 266.8 0 0 0 44.47 34.87c.71.38 1.26.7 1.7 1a32.7 32.7 0 0 0 1.21-3.51c3.71-12.89-.53-27.54-9.79-39.67C93.25 33.81 106 57.05 100.66 76.51c-.14.53-.29 1-.45 1.55l.19.22c10.59 12.63 7.68 26 6.35 23.5C101 91 90.37 94.33 85 96.5z\"/></g></svg>"

/***/ }),

/***/ "../src/components/swift/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SwiftOriginal = __webpack_require__("../src/components/swift/original/SwiftOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SwiftOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/swift/plain-wordmark/SwiftPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SwiftPlainWordmark = __webpack_require__("../src/components/swift/plain-wordmark/SwiftPlainWordmark.svg");
	
	var _SwiftPlainWordmark2 = _interopRequireDefault(_SwiftPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SwiftPlainWordmark */
	function SwiftPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SwiftPlainWordmark',
	    svg: _SwiftPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SwiftPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SwiftPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/swift/plain-wordmark/SwiftPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Swift\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#221f20}</style></defs><title>Artboard 6</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M119.34 61.59h-8.95V60.5c0-.87.08-1.75.15-2.62a5.73 5.73 0 0 1 .62-2.19 4.09 4.09 0 0 1 1.31-1.46 4.49 4.49 0 0 1 2.31-.58 7.49 7.49 0 0 1 1.47.15c.39.15.69.22 1 .36l.62-1.46a7.29 7.29 0 0 0-1.23-.44 6 6 0 0 0-1.7-.22 6.59 6.59 0 0 0-3.09.66 6.12 6.12 0 0 0-2.08 1.82 8.75 8.75 0 0 0-1.08 2.7 15.55 15.55 0 0 0-.31 3.35v1.09h-2.93v1.46h2.93v17.65h2V63.05h8.95v12.1a11.64 11.64 0 0 0 .23 2.41 4.69 4.69 0 0 0 .69 1.9 3.2 3.2 0 0 0 1.39 1.24 5.41 5.41 0 0 0 2.31.44 6.87 6.87 0 0 0 2.7-.44l-.23-1.46a8.39 8.39 0 0 1-.93.22 7 7 0 0 1-1.31.07 2.51 2.51 0 0 1-2.24-1 6 6 0 0 1-.62-2.92V63.12H127v-1.45h-5.63v-4.23l-2 .58zm.08 0zm.08 1.46zm-70 14.8a9.51 9.51 0 0 0 2.78 1.24 12.09 12.09 0 0 0 3.32.51 7.31 7.31 0 0 0 4.94-1.53 5.2 5.2 0 0 0 1.77-4A5.39 5.39 0 0 0 61 70.34a11.66 11.66 0 0 0-4.32-2.62 15.12 15.12 0 0 1-5.24-2.84 5.78 5.78 0 0 1-1.93-4.52 6.33 6.33 0 0 1 .62-2.7 6.56 6.56 0 0 1 1.7-2.11 7 7 0 0 1 2.55-1.39 9.4 9.4 0 0 1 3.24-.51A15 15 0 0 1 61 54a9.8 9.8 0 0 1 2.08.8l-.77 1.6a7.23 7.23 0 0 0-1.85-.8 9.27 9.27 0 0 0-3-.44 8 8 0 0 0-2.85.44 5.58 5.58 0 0 0-1.85 1.17 5.12 5.12 0 0 0-1 1.6 4.3 4.3 0 0 0-.31 1.68 4.75 4.75 0 0 0 1.39 3.57 14.15 14.15 0 0 0 4.4 2.48 18.59 18.59 0 0 1 3 1.46 13.23 13.23 0 0 1 2.24 1.68 5.86 5.86 0 0 1 1.31 2 7.25 7.25 0 0 1 .46 2.62 7.44 7.44 0 0 1-.54 2.84A6.38 6.38 0 0 1 62 79.09a8.49 8.49 0 0 1-2.78 1.6 12.16 12.16 0 0 1-3.86.58 15.82 15.82 0 0 1-1.85-.15 16.6 16.6 0 0 1-1.85-.36 11.43 11.43 0 0 1-1.7-.58 6.86 6.86 0 0 1-1.31-.66zM68 61.67l3.32 10.86c.31 1.09.62 2.19.93 3.14s.54 2 .77 2.84h.15c.23-.87.54-1.82.85-2.84s.69-2 1.08-3.14L79 61.67h1.85l3.78 10.72c.39 1.17.77 2.26 1.08 3.28s.62 2 .85 2.84h.15c.23-.95.46-1.9.77-2.84s.62-2 1-3.21L92 61.67h2l-6.63 19.1h-1.58L82 70.12q-.58-1.75-1.16-3.28c-.31-1-.62-2.11-.85-3.21h-.08a33.72 33.72 0 0 1-1 3.28q-.58 1.53-1.16 3.28l-3.92 10.58h-1.7L66 61.67zm30.31 0h2v19.1h-2zm-.77-5.83a1.66 1.66 0 0 1 1.7-1.68 1.8 1.8 0 0 1 1.76 1.67 1.51 1.51 0 0 1-.54 1.17 1.81 1.81 0 0 1-1.23.44A2 2 0 0 1 98 57a1.73 1.73 0 0 1-.49-1.17z\"/><path id=\"path\" d=\"M36.77 53.16A8.14 8.14 0 0 0 36 51a8.27 8.27 0 0 0-1.39-1.81 6.83 6.83 0 0 0-1.93-1.3 8 8 0 0 0-2.24-.72c-.77-.14-1.62-.14-2.39-.22H9a13.48 13.48 0 0 0-1.77.14 6.45 6.45 0 0 0-1.7.43c-.15.07-.39.14-.54.22a9.88 9.88 0 0 0-1.47.94c-.15.14-.31.22-.46.36a6.43 6.43 0 0 0-1.39 1.81A6.68 6.68 0 0 0 .9 53a22.07 22.07 0 0 0-.23 2.24v17.3a11.06 11.06 0 0 0 .23 2.24A8.14 8.14 0 0 0 1.67 77a8.27 8.27 0 0 0 1.39 1.81A6.83 6.83 0 0 0 5 80.06a8 8 0 0 0 2.24.72c.77.14 1.62.14 2.39.22h18.42a13.37 13.37 0 0 0 2.39-.22 8 8 0 0 0 2.24-.72 8.79 8.79 0 0 0 1.93-1.3A6.43 6.43 0 0 0 36 77a6.68 6.68 0 0 0 .77-2.17 22.07 22.07 0 0 0 .23-2.29V55.4a11.06 11.06 0 0 0-.23-2.24zm-5.48 21.62c-1.67-3.07-4.77-2.13-6.35-1.51-3.24 1.75-7.69 1.93-12.17.13a18.74 18.74 0 0 1-8.56-6.87 14.64 14.64 0 0 0 3.16 1.81c4.62 2 9.25 1.89 12.5 0A64.21 64.21 0 0 1 8.38 57.13a12.47 12.47 0 0 1-1.54-2 88.7 88.7 0 0 0 11.19 8 78.1 78.1 0 0 1-7.87-9.26 77.64 77.64 0 0 0 13 10l.5.28a9.25 9.25 0 0 0 .35-1c1.08-3.69-.15-7.88-2.85-11.35 6.25 3.54 10 10.2 8.41 15.77 0 .15-.08.3-.13.44l.05.06c3.04 3.6 2.19 7.43 1.8 6.71z\"/></g></svg>"

/***/ }),

/***/ "../src/components/swift/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SwiftPlainWordmark = __webpack_require__("../src/components/swift/plain-wordmark/SwiftPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SwiftPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/swift/plain/SwiftPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SwiftPlain = __webpack_require__("../src/components/swift/plain/SwiftPlain.svg");
	
	var _SwiftPlain2 = _interopRequireDefault(_SwiftPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SwiftPlain */
	function SwiftPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SwiftPlain',
	    svg: _SwiftPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SwiftPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SwiftPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/swift/plain/SwiftPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><title>Artboard 5</title><path d=\"M125.54 26.23a28.78 28.78 0 0 0-2.65-7.58 28.84 28.84 0 0 0-4.76-6.32 23.42 23.42 0 0 0-6.62-4.55 27.27 27.27 0 0 0-7.68-2.53c-2.65-.51-5.56-.51-8.21-.76H30.25a45.46 45.46 0 0 0-6.09.51 21.81 21.81 0 0 0-5.82 1.52c-.53.25-1.32.51-1.85.76a33.82 33.82 0 0 0-5 3.28c-.53.51-1.06.76-1.59 1.26a22.41 22.41 0 0 0-4.76 6.32 23.61 23.61 0 0 0-2.65 7.58 78.47 78.47 0 0 0-.79 7.83v60.39a39.32 39.32 0 0 0 .79 7.83 28.78 28.78 0 0 0 2.65 7.58 28.84 28.84 0 0 0 4.76 6.32 23.42 23.42 0 0 0 6.62 4.55 27.27 27.27 0 0 0 7.68 2.53c2.65.51 5.56.51 8.21.76h63.22a45.08 45.08 0 0 0 8.21-.76 27.27 27.27 0 0 0 7.68-2.53 30.13 30.13 0 0 0 6.62-4.55 22.41 22.41 0 0 0 4.76-6.32 23.61 23.61 0 0 0 2.65-7.58 78.47 78.47 0 0 0 .79-7.83V34.06a39.32 39.32 0 0 0-.8-7.83zm-18.79 75.54C101 91 90.37 94.33 85 96.5c-11.11 6.13-26.38 6.76-41.75.47A64.53 64.53 0 0 1 13.84 73a50 50 0 0 0 10.85 6.32c15.87 7.1 31.73 6.61 42.9 0-15.9-11.66-29.4-26.82-39.46-39.2a43.47 43.47 0 0 1-5.29-6.82c12.16 10.61 31.5 24 38.38 27.79a271.77 271.77 0 0 1-27-32.34 266.8 266.8 0 0 0 44.47 34.87c.71.38 1.26.7 1.7 1a32.71 32.71 0 0 0 1.21-3.51c3.71-12.89-.53-27.54-9.79-39.67C93.25 33.81 106 57.05 100.66 76.51c-.14.53-.29 1-.45 1.55l.19.22c10.6 12.63 7.67 26.02 6.35 23.49z\"/></svg>"

/***/ }),

/***/ "../src/components/swift/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SwiftPlain = __webpack_require__("../src/components/swift/plain/SwiftPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SwiftPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/symfony/original-wordmark/SymfonyOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SymfonyOriginalWordmark = __webpack_require__("../src/components/symfony/original-wordmark/SymfonyOriginalWordmark.svg");
	
	var _SymfonyOriginalWordmark2 = _interopRequireDefault(_SymfonyOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SymfonyOriginalWordmark */
	function SymfonyOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SymfonyOriginalWordmark',
	    svg: _SymfonyOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SymfonyOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SymfonyOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/symfony/original-wordmark/SymfonyOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M81.1 102.1c-5 0-8.4 3.6-8.4 8.6 0 4.7 3.4 8.6 8.4 8.6 4.9 0 8.3-3.9 8.3-8.6 0-5-3.3-8.6-8.3-8.6zm0 14.7c-3.6 0-5.1-3.2-5.1-6.1 0-3.1 1.9-6.1 5.1-6.1 3.2 0 5.1 3 5.1 6.1 0 2.9-1.6 6.1-5.1 6.1zM65 101.2v.8h-4v1.7c0 .7.7 1.2 1.4 1.2H65v14h1.6c.7 0 1.4-.7 1.4-1.3V105h3c.7 0 1-.7 1-1.4V102h-4v-1.1c0-2.2.3-3.9 2.9-3.9h.1c.7.1 1.3-.5 1.4-1.3l.1-1c-.6-.1-1.2-.2-2-.2-4.5.1-5.5 2.7-5.5 6.7zm-32.9 1v.1c-.6 0-1.3.5-1.5 1.1L26.4 116h-.1l-4.1-12.5c-.3-.6-.9-1.3-1.5-1.3v-.2h-2.1l5.6 15.5c.2.5.6 1.5.6 1.9 0 .3-.9 4.1-3.6 4.1H21c-.7 0-1.2.5-1.3 1.2l-.1 1.1c.5.1 1.1.2 2.1.2 4 0 5.2-3.9 6.3-7l6-17h-1.9v.2zm-19.2 3.6c-2.5-1.3-5.2-2.1-5.3-4.7 0-2.7 2.5-3.4 4.4-3.4.8 0 1.5.1 2.2.2.7.1 1.3-.5 1.4-1.2l.1-1c-1.3-.3-2.6-.5-3.7-.5-4.2 0-7.3 2.1-7.3 6.2 0 3.5 2.4 4.9 4.9 6.1 2.5 1.2 5.3 2.2 5.3 5.1 0 3-2.9 4.2-5 4.2-1.2 0-2.5-.3-3.5-.6-.7-.1-1.2.5-1.3 1.3l-.1.8c1.5.5 3 .8 4.5.8 4.7 0 8.4-1.8 8.4-6.7-.1-3.8-2.5-5.3-5-6.6zm41.4-3.7c-1.5 0-4 .8-5.1 3.2-.9-2.2-2.8-3.1-4.7-3.1-2.4 0-4.1.8-5.2 2.8H39v-1.2c0-.7-.5-1.6-1.3-1.6l.1-.2H36v17h2c.8 0 1.2-.7 1.2-1.4l-.2-.1v-6.8c0-3.1 1.6-6.1 4.7-6.1 2.4 0 3.3 2.5 3.3 4.6v9.9h1.3c.7 0 1.7-.7 1.7-1.4v-7c0-3.1 1.1-6.1 4.2-6.1 2.4 0 2.8 2.5 2.8 4.6v9.9h1.6c.7 0 1.4-.6 1.4-1.2v-9.4c0-3.7-1.5-6.4-5.7-6.4zm46.4-.1c-2.3 0-4.6 1-5.5 3H95v-1.2c0-.8-.6-1.6-1.4-1.6v-.2H92v17h1.8c.7 0 1.2-.7 1.2-1.4v-6.3c0-4 1.8-6.8 5.3-6.8 2.6.2 3.7 2 3.7 5.8v8.6h1.3c.7 0 1.7-.7 1.7-1.4v-8.4c0-4.4-2.1-7.1-6.3-7.1zm20.9 0v.3c-.6 0-1.3.5-1.5 1.1l-4.2 12.6h-.1l-4.1-12.5c-.3-.6-.9-1.3-1.5-1.3v-.2h-2.1l5.6 15.5c.2.5.6 1.5.6 1.9 0 .3-.9 4.1-3.6 4.1h-.2c-.7 0-1.2.5-1.3 1.2l-.1 1.1c.5.1 1.1.2 2.1.2 4 0 5.2-3.9 6.3-7l6-17h-1.9zM64 90.2c24.6 0 44.6-20 44.6-44.6S88.6 1 64 1 19.4 21 19.4 45.6s20 44.6 44.6 44.6zM34.4 48.8c.7-2.2 2.4-2.6 4.2-2.1 1.8.6 2.6 2.8 2 4.5-.1.2-.2.5-.3.9l-.8 1.4c-.4 1.4 1.4 2.3 2.7 2.7 2.9.9 5.7-.6 6.4-3 .7-2.2-.7-3.7-1.3-4.2l-2.7-2.9c-1.3-1.4-4-5.3-2.7-9.7.5-1.7 1.6-3.5 3.2-4.7 3.3-2.5 7-2.9 10.4-1.9 4.5 1.3 6.6 4.3 9.4 6.5 1.6-4.6 3.7-9.1 7-12.9 2.9-3.5 6.9-5.9 11.4-6.1 4.5-.1 7.9 1.9 8.1 5.1 0 1.4-.7 4.1-3.5 4.2-2.1.1-3.5-1.2-3.6-3 0-.7.2-1.3.6-2 .5-.9.6-1 .5-1.4 0-1.2-1.8-1.2-2.3-1.2-6.7.2-8.5 9.3-9.9 16.6l-.7 3.9c3.9.6 6.6-.1 8.1-1.1 2.1-1.4-.6-2.8-.3-4.4.4-1.6 1.8-2.4 3-2.4 1.6 0 2.8 1.7 2.8 3.4-.1 2.8-3.8 6.8-11.4 6.6-.9 0-1.8-.1-2.6-.2L71 49.3c-1.3 6-3 14.1-9 21.2-5.2 6.2-10.5 7.2-12.9 7.2-4.4.1-7.4-2.2-7.5-5.4-.1-3.1 2.6-4.7 4.4-4.8 2.4-.1 4 1.6 4.1 3.6.1 1.7-.8 2.2-1.4 2.5-.4.3-1 .6-.9 1.3 0 .3.3 1 1.3.9 1.9-.1 3.1-1 4-1.6 4.3-3.6 6-9.9 8.2-21.3l.5-2.8c.7-3.7 1.6-7.8 2.8-12-3-2.3-4.9-5.1-9-6.2-2.8-.8-4.5-.1-5.7 1.4-1.4 1.8-1 4.1.4 5.5l2.3 2.5c2.8 3.2 4.3 5.7 3.7 9.1-.9 5.4-7.3 9.5-14.9 7.2-6.6-1.7-7.8-6.3-7-8.8z\" fill=\"#1A171B\"/></svg>"

/***/ }),

/***/ "../src/components/symfony/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SymfonyOriginalWordmark = __webpack_require__("../src/components/symfony/original-wordmark/SymfonyOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SymfonyOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/symfony/original/SymfonyOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _SymfonyOriginal = __webpack_require__("../src/components/symfony/original/SymfonyOriginal.svg");
	
	var _SymfonyOriginal2 = _interopRequireDefault(_SymfonyOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** SymfonyOriginal */
	function SymfonyOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'SymfonyOriginal',
	    svg: _SymfonyOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	SymfonyOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = SymfonyOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/symfony/original/SymfonyOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#1A171B\" d=\"M64 2.3C29.9 2.3 2.3 29.9 2.3 64s27.6 61.7 61.7 61.7 61.7-27.6 61.7-61.7S98.1 2.3 64 2.3zM97.3 38c-2.9.1-4.8-1.6-4.9-4.2 0-1 .2-1.8.9-2.8.6-1.2.8-1.4.8-1.9-.1-1.6-2.5-1.7-3.2-1.7-9.3.3-11.7 12.8-13.7 23l-1 5.4c5.3.8 9.1-.2 11.2-1.5 3-1.9-.8-3.9-.4-6.1.5-2.2 2.5-3.3 4.1-3.4 2.3-.1 3.9 2.3 3.8 4.7-.1 3.9-5.3 9.4-15.8 9.1-1.3 0-2.4-.1-3.5-.2l-2 10.9c-1.8 8.2-4.1 19.5-12.5 29.3-7.2 8.6-14.5 9.9-17.8 10-6.1.2-10.2-3.1-10.3-7.4-.1-4.2 3.6-6.5 6-6.6 3.3-.1 5.5 2.3 5.6 5 .1 2.3-1.1 3-1.9 3.5-.5.4-1.3.9-1.3 1.8 0 .4.5 1.3 1.8 1.3 2.6-.1 4.3-1.4 5.5-2.2 6-5 8.3-13.7 11.3-29.4l.6-3.8c1-5.1 2.2-10.9 3.9-16.6-4.2-3.2-6.7-7.1-12.4-8.6-3.9-1.1-6.2-.2-7.9 1.9-2 2.5-1.3 5.7.6 7.6l3.1 3.5c3.9 4.5 6 7.9 5.2 12.6-1.1 7.3-10 13-20.5 9.8-9-2.8-10.6-9.1-9.5-12.6.9-3.1 3.4-3.7 5.8-2.9 2.6.8 3.6 3.9 2.8 6.3-.1.3-.2.7-.5 1.2-.3.7-.8 1.2-1.1 2-.6 1.9 2 3.2 3.8 3.8 4 1.2 7.9-.9 8.9-4.1.9-3-1-5.1-1.7-5.9l-3.8-4.1c-1.7-1.9-5.6-7.3-3.7-13.4.7-2.3 2.2-4.8 4.4-6.4 4.6-3.5 9.7-4 14.5-2.6 6.2 1.8 9.2 5.9 13.1 9.1 2.2-6.3 5.2-12.6 9.7-17.8 4.1-4.8 9.5-8.2 15.8-8.5 6.3-.2 11 2.6 11.2 7.1-.1 2-1.2 5.7-5 5.8z\"/></svg>"

/***/ }),

/***/ "../src/components/symfony/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SymfonyOriginal = __webpack_require__("../src/components/symfony/original/SymfonyOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SymfonyOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/tomcat/line-wordmark/TomcatLineWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _TomcatLineWordmark = __webpack_require__("../src/components/tomcat/line-wordmark/TomcatLineWordmark.svg");
	
	var _TomcatLineWordmark2 = _interopRequireDefault(_TomcatLineWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** TomcatLineWordmark */
	function TomcatLineWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'TomcatLineWordmark',
	    svg: _TomcatLineWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	TomcatLineWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = TomcatLineWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/tomcat/line-wordmark/TomcatLineWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"128\" viewBox=\"0 0 128 128\" width=\"128\"><path d=\"M56.455 38.9L60.067 49.6l-10.972-7.357zM45.887 43.582l3.877 6.688-8.16-4.146zM37.054 48.8l1.873 6.69-5.619-3.881zM96.858 66.728L93.38 72.08l6.155-2.81zM102.344 72.883l-5.618 4.28 7.763-2.007zM88.701 14.816l4.148 9.099 2.676-9.232zM67.693 28.062l6.558 3.479-5.89.401zM69.297 35.153l4.014 1.606-3.345.936zM116.13 30.604l-5.353 2.275 4.413.669zM113.985 37.16l-4.148 1.205 3.346 1.203z\"/><g><path d=\"M65.538 47.202H78.45v1.593H65.538zM65.538 43.375H78.45v1.594H65.538zM104.967 47.202h12.912v1.593h-12.912zM104.967 43.375h12.912v1.594h-12.912zM100.416 33.924H79.373V32.49h6.549c.806-3.453.965-6.753-.007-8.426-.415-.711-.989-1.043-1.808-1.043-3.744 0-5.29 3.959-5.355 4.127l.001-.001-1.343-.504c.077-.207 1.95-5.057 6.697-5.057 1.325 0 2.378.608 3.046 1.757 1.186 2.037 1.047 5.562.243 9.147h11.49c1.527-4.485 4.714-6.6 10.04-6.6v1.435c-5.772 0-7.39 2.447-8.544 5.165h6.27l-.015 1.427-6.222.008zm.944 7.086l.01-.001c-1.702-2.51-2.242-4.652-1.53-7.092l-1.462.008c-.509 1.624-.305 4.07.95 6.17h-14.6c.888-1.78 1.711-3.95 2.313-6.17h-1.486c-.663 2.355-1.595 4.686-2.643 6.532l-.34.597 8.193 5.157-4.612 3.04.79 1.198 5.155-3.4 5.566 3.633.764-1.215-5.16-3.192s7.716-5.012 8.099-5.256l-.006-.01zm-9.279 4.334l-6.06-3.816 11.843.003-5.783 3.813z\"/></g><g><path d=\"M118.413 18.68c-.01-2.494-.786-13.037-2.214-15.94-3.872 1.471-10.917 6.238-12.512 11.113-7.642-1.141-16.257-1.006-23.804.3-1.26-5.245-7.588-9.259-12.362-11.52-2.014 3.398-2.906 11.277-2.679 16.866l-.027.017c.886 23.469 12.399 38.08 27.454 46.937 15.488-8.85 26.554-26.104 26.125-47.783l.019.01zm-12.888-4.524l.169.031-.17-.03zm-.964-.166c.136.021.273.046.409.069l-.409-.07zm11.443 6.384c.398 19.527-9.565 35.07-23.513 43.04C68.817 51.617 64.357 21.736 68.394 5.707c1.123 6.128 3.161 9.972 7.574 11.857 9.61-2.75 22.84-2.968 32.586-.28 4.061-2.953 5.636-7.464 6.496-11.404 1.074 4.586.95 14.491.954 14.493zm10.099 67.56c-2.431-2.72-7.195-4.008-11.172-3.913-2.823-3.36-19.19-20.596-19.19-20.596l-1.134 1.429 19.76 21.273.857-.074c5.369-.46 8.42 2.452 9.229 3.356.592.662.95 1.267 1.144 1.74h-10.86c-24.91-12.998-46.78-22.164-70.012-24.161.05-3.233.626-6.893 1.73-10.971l-2.136-.58c-1.136 4.193-1.734 7.989-1.801 11.382-2.421-.16-4.858-.244-7.316-.244-2.084 0-3.982.194-5.714.53-2.258-2.256-4.182-4.407-5.817-6.449 10.79-11.242 28.61-21.402 44.049-25.138l-.502-2.163C50.593 37.364 32.396 48.278 22.255 58.82c-4.706-6.352-6.573-11.563-7.127-15.513-.7-4.989.49-9.566 3.443-13.235 4.624-5.744 11.193-6.148 17.947-5.012-.132 1.067.008 2.086.436 2.717 1.786 2.638 11.386 3.565 17.117 1.009-4.23-5.926-12.795-8.82-15.169-7.66-.786.384-1.379 1.089-1.786 1.911-2.334-.417-4.653-.728-6.348-.715-5.956.043-10.51 2.125-13.921 6.363-3.347 4.157-4.7 9.32-3.912 14.93.746 5.314 3.377 10.965 7.786 16.826-.732.785-1.44 1.561-2.122 2.323C7.852 74.79-.003 87.685-.003 89.822v1.107h14.177l-.248-1.313c-.8-4.231.798-9.52 4.073-13.473 2.056-2.482 5.461-5.314 10.808-6.621 4.755 4.64 10.812 9.567 17.555 14.322h10.535v-1.107c0-1.25-.62-2.343-1.744-3.079-1.664-1.088-4.234-1.238-6.594-.433-2.25-2.506-3.511-5.853-3.784-10.01 22.866 2.024 44.737 11.258 69.412 24.149h13.578l.178-.89c.253-1.267-.437-2.964-1.846-4.54zM16.298 74.727c-3.353 4.047-5.13 9.394-4.723 13.984H2.643c1.795-3.883 8.943-15.11 19.505-26.45a80.407 80.407 0 0 0 4.857 5.448c-5.185 1.56-8.585 4.458-10.707 7.018z\"/></g><path d=\"M11.863 98.562v3.21h6.783v19.206h3.49v-19.205h6.782v-3.211zm97.219 1.64l-1.066 3.563-2.387 1.049v1.998h2.3v9.05c0 1.716.41 3.088 1.301 4.026.891.939 2.217 1.383 3.858 1.383.443 0 .925-.048 1.451-.139l.01-.002c.54-.082.965-.186 1.305-.35l.283-.136v-2.84l-.64.186a8.497 8.497 0 0 1-.885.191h-.004a8.083 8.083 0 0 1-1.168.082c-.693 0-1.153-.198-1.516-.607-.356-.402-.562-1.007-.562-1.895v-8.95h4.658v-2.888h-4.658v-3.72h-2.28zm-71.303 3.428c-2.43 0-4.416.79-5.822 2.364-1.407 1.565-2.09 3.742-2.09 6.441 0 1.75.314 3.302.957 4.64.642 1.337 1.572 2.387 2.77 3.112 1.194.723 2.57 1.084 4.083 1.084 2.43 0 4.418-.79 5.834-2.363h.002v-.002c1.417-1.585 2.106-3.77 2.106-6.471 0-2.635-.698-4.795-2.12-6.395-1.41-1.6-3.363-2.41-5.72-2.41zm18.824 0c-1.106 0-2.13.237-3.045.715l-.002.002c-.623.33-1.029.877-1.467 1.39l-.328-1.814h-2.894v17.055h3.431v-8.923c0-2.024.36-3.414.95-4.176.607-.782 1.535-1.184 2.958-1.184 1.07 0 1.748.28 2.182.791h.002l.002.002c.439.51.7 1.337.7 2.545v10.945h3.43v-9.465c0-1.74.354-2.957.968-3.695.613-.737 1.552-1.123 2.97-1.123 1.06 0 1.734.279 2.168.791l.002.002c.439.509.7 1.337.7 2.545v10.945h3.431v-10.975c0-2.124-.468-3.757-1.504-4.817-1.015-1.057-2.528-1.556-4.43-1.556-1.231 0-2.357.26-3.343.79-.781.42-1.316 1.069-1.813 1.741-.945-1.642-2.686-2.531-5.068-2.531zm27.23 0c-2.495 0-4.51.787-5.91 2.366h-.002c-1.39 1.578-2.059 3.79-2.059 6.556 0 2.698.66 4.862 2.03 6.41l.002.002.001.002c1.38 1.538 3.351 2.305 5.778 2.305 1.688 0 3.12-.288 4.287-.893l.27-.138v-3.203l-.69.283c-1.355.555-2.66.826-3.926.826-1.45 0-2.442-.455-3.148-1.385-.7-.935-1.084-2.333-1.084-4.238 0-2.015.401-3.458 1.117-4.371.716-.913 1.75-1.37 3.275-1.37.439 0 .965.068 1.573.208h.004l.003.002c.61.131 1.17.298 1.678.502l.479.193 1.074-2.967-.393-.2c-.5-.257-1.141-.458-1.94-.63a11.48 11.48 0 0 0-2.42-.26zm13.756.03c-.99 0-1.98.126-2.967.38h-.002a11.96 11.96 0 0 0-2.705 1.057l-.39.211 1.11 2.771.483-.234c1.643-.798 3.089-1.18 4.324-1.18 1.107 0 1.804.272 2.22.74l.001.005.004.002c.428.466.688 1.258.688 2.445v.512l-2.24.072c-2.645.08-4.674.543-6.092 1.473-1.419.93-2.17 2.37-2.17 4.125 0 1.612.498 2.947 1.51 3.87l.001.003c1.016.917 2.409 1.36 4.086 1.36 1.241 0 2.3-.182 3.176-.571l.002-.002c.69-.312 1.333-.99 1.979-1.68l.414 1.96h2.706V109.52c0-1.956-.488-3.482-1.55-4.455-1.045-.967-2.6-1.406-4.588-1.406zm-59.883 3.035c1.501 0 2.526.463 3.25 1.402l.002.002.002.002c.733.932 1.139 2.361 1.139 4.334 0 1.994-.407 3.445-1.143 4.397-.725.94-1.74 1.402-3.22 1.402-1.48 0-2.498-.464-3.223-1.414-.727-.952-1.127-2.4-1.127-4.385 0-2.005.398-3.448 1.111-4.367.713-.92 1.727-1.373 3.209-1.373zm62.59 6.408v.93c0 1.397-.388 2.396-1.148 3.123l-.002.002c-.754.728-1.791 1.105-3.213 1.105-.876 0-1.487-.204-1.912-.566-.409-.355-.62-.85-.62-1.63 0-.996.323-1.606 1.038-2.05h.002c.724-.453 2.051-.767 3.941-.834h.002l1.912-.08z\" style=\"block-progression:tb;isolation:auto;mix-blend-mode:normal;text-decoration-color:#000;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-transform:none\" white-space=\"normal\"/></svg>"

/***/ }),

/***/ "../src/components/tomcat/line-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TomcatLineWordmark = __webpack_require__("../src/components/tomcat/line-wordmark/TomcatLineWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TomcatLineWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/tomcat/line/TomcatLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _TomcatLine = __webpack_require__("../src/components/tomcat/line/TomcatLine.svg");
	
	var _TomcatLine2 = _interopRequireDefault(_TomcatLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** TomcatLine */
	function TomcatLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'TomcatLine',
	    svg: _TomcatLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	TomcatLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = TomcatLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/tomcat/line/TomcatLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"128\" width=\"128\" viewBox=\"0 0 128 128\"><path d=\"M49.096 58.246l7.36-3.345 3.611 10.702zM41.604 62.126l4.284-2.542 3.877 6.688zM33.309 67.61l3.746-2.81 1.873 6.692zM99.536 85.273l-2.677-2.543-3.478 5.353zM104.49 91.158l-2.145-2.274-5.618 4.28zM95.526 30.684l-6.824.134 4.148 9.098zM68.362 47.943l-.669-3.88 6.559 3.479zM69.966 53.696l-.669-2.541 4.015 1.605zM115.191 49.55l.94-2.944-5.353 2.274zM113.184 55.57l.802-2.408-4.148 1.204z\"/><g><path d=\"M65.538 63.203h12.913v1.594H65.538zM65.538 59.377h12.913v1.594H65.538zM104.968 63.203h12.912v1.594h-12.912zM104.968 59.377h12.912v1.594h-12.912zM100.417 49.926H79.374V48.49h6.548c.807-3.453.966-6.753-.006-8.426-.416-.71-.99-1.043-1.808-1.043-3.744 0-5.29 3.959-5.355 4.127l.001-.001-1.343-.504c.077-.207 1.95-5.057 6.697-5.057 1.325 0 2.378.608 3.046 1.757 1.186 2.037 1.047 5.562.243 9.147h11.49c1.527-4.485 4.714-6.6 10.04-6.6v1.435c-5.772 0-7.39 2.447-8.544 5.165h6.27l-.015 1.428-6.222.007zm.944 7.085l.01-.001c-1.702-2.51-2.242-4.652-1.53-7.091l-1.462.007c-.509 1.624-.305 4.07.95 6.17h-14.6c.888-1.78 1.711-3.949 2.313-6.17h-1.486c-.664 2.355-1.595 4.686-2.644 6.532l-.339.597 8.193 5.157-4.612 3.04.79 1.198 5.155-3.399 5.566 3.632.764-1.214-5.16-3.192s7.716-5.012 8.099-5.257c-.003-.003-.004-.006-.006-.01zm-9.279 4.334l-6.06-3.815 11.843.003-5.783 3.812z\"/></g><g><path d=\"M118.414 34.682c-.009-2.495-.786-13.038-2.214-15.941-3.872 1.471-10.917 6.239-12.512 11.113-7.642-1.14-16.257-1.006-23.804.3-1.26-5.245-7.588-9.258-12.362-11.52-2.014 3.398-2.906 11.277-2.68 16.866l-.026.018c.886 23.468 12.399 38.08 27.453 46.936 15.49-8.85 26.555-26.104 26.126-47.783l.02.01zm-12.888-4.525l.169.031-.17-.03zm-.964-.166c.136.022.273.046.409.07l-.409-.07zm11.443 6.384c.398 19.528-9.565 35.07-23.513 43.04C68.818 67.62 64.358 37.739 68.395 21.71c1.123 6.127 3.16 9.971 7.574 11.856 9.61-2.75 22.84-2.967 32.586-.28 4.061-2.953 5.636-7.463 6.496-11.404 1.075 4.586.95 14.492.954 14.494zm10.1 67.56c-2.432-2.72-7.195-4.007-11.173-3.912-2.823-3.36-19.19-20.596-19.19-20.596l-1.134 1.429 19.76 21.273.857-.074c5.369-.46 8.42 2.452 9.229 3.355.592.663.95 1.267 1.144 1.742h-10.86c-24.911-13-46.78-22.165-70.013-24.163.05-3.233.626-6.893 1.73-10.97l-2.136-.58c-1.135 4.192-1.734 7.988-1.801 11.382-2.42-.16-4.857-.244-7.315-.244-2.085 0-3.983.194-5.714.53-2.259-2.257-4.182-4.408-5.817-6.45 10.79-11.241 28.61-21.402 44.048-25.138l-.501-2.163c-16.625 4.01-34.823 14.923-44.963 25.467-4.706-6.352-6.573-11.564-7.128-15.514-.7-4.989.49-9.565 3.444-13.235 4.623-5.743 11.192-6.148 17.946-5.012-.131 1.067.009 2.087.436 2.717 1.786 2.639 11.387 3.566 17.117 1.009-4.229-5.926-12.795-8.82-15.168-7.66-.786.384-1.38 1.09-1.786 1.912-2.335-.418-4.654-.729-6.348-.716-5.957.044-10.511 2.125-13.922 6.363-3.347 4.157-4.7 9.32-3.912 14.93.746 5.314 3.377 10.966 7.786 16.826-.732.786-1.44 1.562-2.122 2.324C7.853 90.792-.003 103.687-.003 105.824v1.107h14.177l-.248-1.313c-.8-4.232.798-9.52 4.073-13.474 2.057-2.481 5.462-5.314 10.809-6.62 4.754 4.64 10.812 9.567 17.554 14.321h10.536v-1.107c0-1.249-.62-2.342-1.744-3.078-1.665-1.088-4.234-1.238-6.594-.433-2.25-2.506-3.512-5.853-3.784-10.011 22.865 2.024 44.736 11.258 69.412 24.15h13.578l.178-.89c.254-1.267-.437-2.965-1.846-4.541zM16.298 90.729c-3.354 4.048-5.132 9.395-4.724 13.985H2.643c1.795-3.883 8.943-15.11 19.505-26.45a80.408 80.408 0 0 0 4.858 5.448c-5.186 1.559-8.586 4.457-10.707 7.017z\"/></g></svg>"

/***/ }),

/***/ "../src/components/tomcat/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TomcatLine = __webpack_require__("../src/components/tomcat/line/TomcatLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TomcatLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/tomcat/original-wordmark/TomcatOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _TomcatOriginalWordmark = __webpack_require__("../src/components/tomcat/original-wordmark/TomcatOriginalWordmark.svg");
	
	var _TomcatOriginalWordmark2 = _interopRequireDefault(_TomcatOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** TomcatOriginalWordmark */
	function TomcatOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'TomcatOriginalWordmark',
	    svg: _TomcatOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	TomcatOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = TomcatOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/tomcat/original-wordmark/TomcatOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"128\" viewBox=\"0 0 128 128\" width=\"128\"><path fill=\"#d1a41a\" d=\"M22.148 62.305a80.73 80.73 0 0 0 4.857 5.446c-5.186 1.56-8.586 4.458-10.706 7.016-3.356 4.05-5.132 9.398-4.723 13.988h-8.93c1.79-3.887 8.94-15.114 19.503-26.45zm103.45 28.885M125.597 91.19H114.74c-24.91-12.998-46.78-22.164-70.012-24.167.049-3.232.624-6.893 1.731-10.971l-2.14-.576c-1.136 4.192-1.732 7.985-1.8 11.38-2.421-.162-4.857-.241-7.317-.241-2.081 0-3.98.192-5.712.526-2.258-2.253-4.182-4.408-5.815-6.45 10.715-11.158 28.364-21.254 43.724-25.053 4.325 14.377 13.609 24.227 24.876 30.854a47.543 47.543 0 0 0 2.435-1.486l19.656 21.161.86-.074c5.368-.462 8.419 2.45 9.226 3.356.595.66.95 1.265 1.146 1.742z\"/><path fill=\"#ffdc76\" d=\"M116.008 20.41c.399 19.528-9.564 35.07-23.513 43.041C68.82 51.658 64.362 21.774 68.397 5.744c1.122 6.13 3.164 9.974 7.572 11.858 9.614-2.75 22.844-2.967 32.59-.28 4.06-2.953 5.634-7.464 6.495-11.405 1.072 4.585.95 14.494.954 14.494z\"/><path d=\"M60.067 49.601l-10.971-7.357 7.36-3.345zM49.765 50.27l-8.161-4.146 4.284-2.542zM38.928 55.49l-5.62-3.881 3.747-2.81zM93.38 72.081l6.156-2.81-2.677-2.543zM96.727 77.163l7.763-2.007-2.145-2.273zM92.85 23.914l2.676-9.232-6.824.134zM74.252 31.54l-5.89.402-.669-3.88zM73.312 36.759l-3.346.936-.669-2.542zM110.778 32.879l4.413.669.94-2.944zM109.838 38.364l3.346 1.204.802-2.408z\"/><g><path d=\"M65.538 47.202h12.913v1.593H65.538zM65.538 43.375h12.913v1.594H65.538zM104.968 47.202h12.912v1.593h-12.912zM104.968 43.375h12.912v1.594h-12.912zM100.417 33.924H79.374V32.49h6.548c.807-3.452.966-6.752-.006-8.425-.416-.711-.99-1.044-1.808-1.044-3.744 0-5.29 3.96-5.355 4.128l.001-.001-1.343-.504c.077-.207 1.95-5.057 6.697-5.057 1.325 0 2.378.608 3.046 1.756 1.186 2.038 1.047 5.562.243 9.148h11.49c1.527-4.485 4.714-6.6 10.04-6.6v1.435c-5.772 0-7.39 2.447-8.544 5.165h6.27l-.015 1.427-6.222.007zm.944 7.086l.01-.001m-.01.001l.01-.001\"/><path d=\"M101.361 41.01l.01-.001c-1.702-2.51-2.242-4.652-1.53-7.092l-1.462.008c-.509 1.624-.305 4.07.95 6.17h-14.6c.888-1.78 1.711-3.95 2.313-6.17h-1.486c-.664 2.355-1.595 4.686-2.644 6.532l-.339.597 8.193 5.157-4.612 3.04.79 1.198 5.155-3.4 5.566 3.633.764-1.215-5.16-3.192s7.716-5.012 8.099-5.256l-.006-.01zm-9.279 4.334l-6.06-3.816 11.843.003-5.783 3.813z\"/></g><g><path d=\"M118.414 18.68c-.009-2.494-.786-13.038-2.214-15.94-3.872 1.47-10.917 6.238-12.512 11.113-7.642-1.141-16.257-1.006-23.804.3-1.26-5.245-7.588-9.259-12.362-11.52-2.014 3.398-2.906 11.277-2.68 16.865l-.026.018c.886 23.469 12.399 38.08 27.453 46.937 15.49-8.85 26.555-26.105 26.126-47.783l.02.01zm-12.888-4.524l.169.031-.17-.031zm-.964-.167c.136.022.273.047.409.07l-.409-.07zm11.443 6.385c.398 19.527-9.565 35.07-23.513 43.04C68.818 51.618 64.358 21.736 68.395 5.707c1.123 6.128 3.16 9.972 7.574 11.857 9.61-2.75 22.84-2.968 32.586-.28 4.061-2.953 5.636-7.464 6.496-11.405 1.075 4.586.95 14.492.954 14.494zm10.1 67.56\"/><path d=\"M126.104 87.933c-2.431-2.72-7.194-4.007-11.172-3.912-2.823-3.36-19.19-20.595-19.19-20.595l-1.134 1.428 19.76 21.273.857-.073c5.369-.46 8.42 2.452 9.229 3.355.592.663.95 1.267 1.144 1.741h-10.86c-24.911-12.999-46.78-22.165-70.013-24.162.05-3.233.626-6.893 1.73-10.971l-2.136-.58c-1.135 4.193-1.734 7.989-1.801 11.382-2.42-.16-4.857-.243-7.315-.243-2.085 0-3.983.193-5.714.53-2.259-2.257-4.182-4.408-5.817-6.45 10.79-11.242 28.61-21.402 44.048-25.138l-.502-2.163C50.594 37.364 32.396 48.278 22.256 58.82c-4.706-6.352-6.573-11.563-7.128-15.513-.7-4.99.49-9.566 3.444-13.235 4.623-5.744 11.192-6.148 17.946-5.012-.131 1.067.009 2.086.436 2.717 1.786 2.638 11.387 3.565 17.117 1.008-4.229-5.926-12.795-8.82-15.168-7.66-.786.384-1.38 1.09-1.786 1.912-2.335-.417-4.654-.728-6.348-.716-5.957.044-10.511 2.125-13.922 6.363-3.347 4.158-4.7 9.32-3.912 14.931.746 5.314 3.377 10.965 7.786 16.826-.732.785-1.44 1.561-2.122 2.323C7.853 74.79-.003 87.685-.003 89.822v1.107h14.177l-.248-1.312c-.8-4.232.798-9.521 4.073-13.474 2.057-2.482 5.462-5.314 10.809-6.62 4.754 4.64 10.812 9.567 17.554 14.32h10.536v-1.106c0-1.25-.62-2.343-1.744-3.079-1.665-1.088-4.234-1.238-6.594-.433-2.25-2.506-3.512-5.853-3.784-10.01 22.865 2.024 44.736 11.258 69.412 24.15h13.578l.178-.89c.254-1.268-.437-2.965-1.846-4.541zM16.3 74.728c-3.354 4.048-5.132 9.394-4.724 13.985H2.643c1.795-3.884 8.943-15.11 19.505-26.45a80.408 80.408 0 0 0 4.858 5.448c-5.186 1.558-8.586 4.457-10.707 7.017z\"/></g><path d=\"M12.122 98.818v2.695h6.783v19.204h2.973v-19.204h6.783v-2.695zm97.155 1.64l-1.046 3.493-2.342 1.03v1.571h2.3v9.31c0 1.674.4 2.97 1.231 3.847s2.073 1.301 3.669 1.301c.425 0 .897-.045 1.413-.134h.005c.528-.08.935-.184 1.235-.33l.137-.065v-2.334l-.31.09c-.218.064-.527.13-.918.198h-.002c-.388.056-.79.085-1.208.085-.75 0-1.297-.23-1.71-.695-.409-.462-.627-1.137-.627-2.066v-9.207h4.658v-2.373h-4.658v-3.72h-1.827zM37.78 103.89c-2.375 0-4.274.76-5.63 2.278-1.356 1.51-2.024 3.613-2.024 6.27 0 1.718.309 3.23.933 4.528.623 1.297 1.516 2.304 2.67 3.002 1.152.698 2.475 1.046 3.948 1.046 2.375 0 4.278-.76 5.644-2.277 1.366-1.528 2.04-3.641 2.04-6.299 0-2.59-.68-4.68-2.054-6.225-1.363-1.545-3.227-2.323-5.527-2.323zm18.823 0c-1.069 0-2.048.229-2.924.687h-.001c-.74.391-1.313.945-1.774 1.6l-.358-1.994h-2.421v16.539h2.915v-8.665c0-2.052.355-3.496 1.003-4.334l.001-.001c.662-.851 1.689-1.283 3.163-1.283 1.117 0 1.887.302 2.38.882h.001c.495.575.762 1.47.762 2.714v10.686h2.914v-9.206c0-1.775.359-3.053 1.029-3.86.67-.805 1.7-1.216 3.168-1.216 1.107 0 1.872.3 2.365.882h.001c.494.575.762 1.469.762 2.714v10.686h2.915v-10.716c0-2.085-.46-3.643-1.43-4.634v-.001c-.956-.996-2.39-1.48-4.247-1.48-1.196 0-2.273.253-3.219.761a5.384 5.384 0 0 0-2.01 1.873c-.857-1.728-2.549-2.634-4.995-2.634zm27.232 0c-2.442 0-4.371.759-5.719 2.278v.001c-1.338 1.52-1.994 3.662-1.994 6.386 0 2.656.647 4.75 1.965 6.24h.001c1.328 1.48 3.212 2.219 5.585 2.219 1.659 0 3.05-.282 4.17-.862l.13-.068v-2.66l-.334.137c-1.381.566-2.72.846-4.024.846-1.508 0-2.598-.493-3.353-1.487-.747-.997-1.137-2.455-1.137-4.394 0-2.049.404-3.553 1.172-4.531s1.899-1.468 3.478-1.468c.465 0 1.01.07 1.631.213h.002l.001.001a10.69 10.69 0 0 1 1.72.516l.232.092.904-2.5-.19-.097c-.469-.24-1.09-.438-1.875-.607a11.216 11.216 0 0 0-2.365-.255zm13.754.03c-.968 0-1.936.124-2.902.373a11.7 11.7 0 0 0-2.648 1.033l-.189.103.924 2.3.233-.113c1.667-.81 3.147-1.207 4.436-1.207 1.15 0 1.934.289 2.412.828h.001l.001.003c.49.533.757 1.395.757 2.62v.761l-2.49.081c-2.618.08-4.603.543-5.959 1.431-1.355.888-2.054 2.223-2.054 3.908 0 1.562.474 2.809 1.427 3.68.961.867 2.28 1.293 3.913 1.293 1.215 0 2.24-.178 3.072-.548.77-.347 1.517-1 2.258-1.875l.45 2.13h2.24v-11.198c0-1.915-.477-3.355-1.47-4.264-.979-.907-2.462-1.34-4.412-1.34zm-59.884 2.52c1.558 0 2.682.498 3.456 1.502h.001l.001.002c.783.995 1.193 2.486 1.193 4.494 0 2.028-.41 3.539-1.195 4.554-.774 1.005-1.889 1.503-3.427 1.503-1.537 0-2.651-.502-3.426-1.517-.775-1.015-1.18-2.521-1.18-4.54 0-2.039.401-3.542 1.164-4.525.764-.985 1.874-1.474 3.413-1.474zm62.851 6.396v1.198c0 1.447-.412 2.531-1.229 3.311v.001c-.81.781-1.923 1.178-3.393 1.178-.917 0-1.6-.217-2.082-.63h-.001c-.47-.41-.707-.994-.707-1.824 0-1.062.376-1.784 1.16-2.27.795-.497 2.158-.805 4.07-.872h.002l2.18-.092z\" style=\"block-progression:tb;isolation:auto;mix-blend-mode:normal;text-decoration-color:#000;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-transform:none\" white-space=\"normal\"/></svg>"

/***/ }),

/***/ "../src/components/tomcat/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TomcatOriginalWordmark = __webpack_require__("../src/components/tomcat/original-wordmark/TomcatOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TomcatOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/tomcat/original/TomcatOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _TomcatOriginal = __webpack_require__("../src/components/tomcat/original/TomcatOriginal.svg");
	
	var _TomcatOriginal2 = _interopRequireDefault(_TomcatOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** TomcatOriginal */
	function TomcatOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'TomcatOriginal',
	    svg: _TomcatOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	TomcatOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = TomcatOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/tomcat/original/TomcatOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"128\" width=\"128\" viewBox=\"0 0 128 128\"><path fill=\"#d1a41a\" d=\"M22.148 78.306a80.73 80.73 0 0 0 4.857 5.446c-5.186 1.56-8.586 4.458-10.706 7.017-3.356 4.05-5.132 9.398-4.723 13.988h-8.93c1.79-3.887 8.94-15.115 19.503-26.45zm103.45 28.886M125.597 107.192H114.74c-24.91-12.999-46.78-22.165-70.012-24.167.049-3.233.624-6.893 1.731-10.972l-2.14-.576c-1.136 4.192-1.732 7.985-1.8 11.38-2.421-.162-4.857-.24-7.317-.24-2.081 0-3.98.191-5.712.526-2.258-2.254-4.182-4.408-5.815-6.45C34.389 65.534 52.038 55.438 67.398 51.64c4.325 14.376 13.609 24.226 24.876 30.853a47.543 47.543 0 0 0 2.435-1.485l19.656 21.16.86-.073c5.368-.462 8.419 2.45 9.226 3.356.595.659.95 1.264 1.146 1.741z\"/><path fill=\"#ffdc76\" d=\"M116.008 36.412c.399 19.528-9.564 35.07-23.513 43.04C68.82 67.66 64.362 37.776 68.397 21.747c1.122 6.13 3.164 9.973 7.572 11.857 9.614-2.75 22.844-2.967 32.59-.28 4.06-2.952 5.634-7.464 6.495-11.405 1.072 4.585.95 14.494.954 14.494z\"/><path d=\"M49.096 58.246l7.36-3.345 3.611 10.702zM41.604 62.126l4.284-2.542 3.877 6.688zM33.309 67.61l3.746-2.81 1.873 6.692zM99.536 85.273l-2.677-2.543-3.478 5.353zM104.49 91.158l-2.145-2.274-5.618 4.28zM95.526 30.684l-6.824.134 4.148 9.098zM68.362 47.943l-.669-3.88 6.559 3.479zM69.966 53.696l-.669-2.541 4.015 1.605zM115.191 49.55l.94-2.944-5.353 2.274zM113.184 55.57l.802-2.408-4.148 1.204z\"/><g><path d=\"M65.538 63.203h12.913v1.594H65.538zM65.538 59.377h12.913v1.594H65.538zM104.968 63.203h12.912v1.594h-12.912zM104.968 59.377h12.912v1.594h-12.912zM100.417 49.926H79.374V48.49h6.548c.807-3.453.966-6.753-.006-8.426-.416-.71-.99-1.043-1.808-1.043-3.744 0-5.29 3.959-5.355 4.127l.001-.001-1.343-.504c.077-.207 1.95-5.057 6.697-5.057 1.325 0 2.378.608 3.046 1.757 1.186 2.037 1.047 5.562.243 9.147h11.49c1.527-4.485 4.714-6.6 10.04-6.6v1.435c-5.772 0-7.39 2.447-8.544 5.165h6.27l-.015 1.428-6.222.007zm.944 7.085l.01-.001m-.01.001l.01-.001\"/><path d=\"M101.361 57.011l.01-.001c-1.702-2.51-2.242-4.652-1.53-7.091l-1.462.007c-.509 1.624-.305 4.07.95 6.17h-14.6c.888-1.78 1.711-3.949 2.313-6.17h-1.486c-.664 2.355-1.595 4.686-2.644 6.532l-.339.597 8.193 5.157-4.612 3.04.79 1.198 5.155-3.399 5.566 3.632.764-1.214-5.16-3.192s7.716-5.012 8.099-5.257c-.003-.003-.004-.006-.006-.01zm-9.279 4.334l-6.06-3.815 11.843.003-5.783 3.812z\"/></g><g><path d=\"M118.414 34.682c-.009-2.495-.786-13.038-2.214-15.941-3.872 1.471-10.917 6.239-12.512 11.113-7.642-1.14-16.257-1.006-23.804.3-1.26-5.245-7.588-9.258-12.362-11.52-2.014 3.398-2.906 11.277-2.68 16.866l-.026.018c.886 23.468 12.399 38.08 27.453 46.936 15.49-8.85 26.555-26.104 26.126-47.783l.02.01zm-12.888-4.525l.169.031-.17-.03zm-.964-.166c.136.022.273.046.409.07l-.409-.07zm11.443 6.384c.398 19.528-9.565 35.07-23.513 43.04C68.818 67.62 64.358 37.739 68.395 21.71c1.123 6.127 3.16 9.971 7.574 11.856 9.61-2.75 22.84-2.967 32.586-.28 4.061-2.953 5.636-7.463 6.496-11.404 1.075 4.586.95 14.492.954 14.494zm10.1 67.56\"/><path d=\"M126.104 103.935c-2.431-2.72-7.194-4.007-11.172-3.912-2.823-3.36-19.19-20.596-19.19-20.596l-1.134 1.429 19.76 21.273.857-.074c5.369-.46 8.42 2.452 9.229 3.355.592.663.95 1.267 1.144 1.742h-10.86c-24.911-13-46.78-22.165-70.013-24.163.05-3.233.626-6.893 1.73-10.97l-2.136-.58c-1.135 4.192-1.734 7.988-1.801 11.382-2.42-.16-4.857-.244-7.315-.244-2.085 0-3.983.194-5.714.53-2.259-2.257-4.182-4.408-5.817-6.45 10.79-11.241 28.61-21.402 44.048-25.138l-.501-2.163c-16.625 4.01-34.823 14.923-44.963 25.467-4.706-6.352-6.573-11.564-7.128-15.514-.7-4.989.49-9.565 3.444-13.235 4.623-5.743 11.192-6.148 17.946-5.012-.131 1.067.009 2.087.436 2.717 1.786 2.639 11.387 3.566 17.117 1.009-4.229-5.926-12.795-8.82-15.168-7.66-.786.384-1.38 1.09-1.786 1.912-2.335-.418-4.654-.729-6.348-.716-5.957.044-10.511 2.125-13.922 6.363-3.347 4.157-4.7 9.32-3.912 14.93.746 5.314 3.377 10.966 7.786 16.826-.732.786-1.44 1.562-2.122 2.324C7.853 90.792-.003 103.687-.003 105.824v1.107h14.177l-.248-1.313c-.8-4.232.798-9.52 4.073-13.474 2.057-2.481 5.462-5.314 10.809-6.62 4.754 4.64 10.812 9.567 17.554 14.321h10.536v-1.107c0-1.249-.62-2.342-1.744-3.078-1.665-1.088-4.234-1.238-6.594-.433-2.25-2.506-3.512-5.853-3.784-10.011 22.865 2.024 44.736 11.258 69.412 24.15h13.578l.178-.89c.254-1.267-.437-2.965-1.846-4.541zM16.3 90.729c-3.354 4.048-5.132 9.395-4.724 13.985H2.643c1.795-3.883 8.943-15.11 19.505-26.45a80.408 80.408 0 0 0 4.858 5.448c-5.186 1.559-8.586 4.457-10.707 7.017z\"/></g></svg>"

/***/ }),

/***/ "../src/components/tomcat/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TomcatOriginal = __webpack_require__("../src/components/tomcat/original/TomcatOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TomcatOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/travis/plain-wordmark/TravisPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _TravisPlainWordmark = __webpack_require__("../src/components/travis/plain-wordmark/TravisPlainWordmark.svg");
	
	var _TravisPlainWordmark2 = _interopRequireDefault(_TravisPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** TravisPlainWordmark */
	function TravisPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'TravisPlainWordmark',
	    svg: _TravisPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	TravisPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = TravisPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/travis/plain-wordmark/TravisPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#BB2031\" d=\"M20 50h8v28h-3v5h13v-6h-4V49h9v4h4v-8H15v8h5zm37.674-15H4.683C3.758 35 3 36.141 3 37.053v52.985C3 90.95 3.758 92 4.683 92h52.992C58.598 92 59 90.95 59 90.038V37.053c0-.912-.402-2.053-1.326-2.053zM50 56h-9v-4h-4v22h4v11H22V75h4V52h-4v4H12V42h38v14zm19.549-.894a4.03 4.03 0 0 0-1.092.156 4.487 4.487 0 0 0-1.051.451 5.05 5.05 0 0 0-.928.707c-.285.273-.526.388-.723.727L65.443 55H63v17h3v-9.913c0-.515.039-1.011.198-1.486.158-.477.368-.896.669-1.257.301-.361.664-.651 1.107-.87s.923-.328 1.493-.328c.23 0 .533.153 1.533.459v-3.202c0-.109-.49-.187-.758-.23a4.237 4.237 0 0 0-.693-.067zm17.293 14.568a.551.551 0 0 1-.304-.09.94.94 0 0 1-.246-.238c-.071-.099-.162-.211-.2-.337-.038-.126-.092-.254-.092-.386v-8.425c0-.92-.148-1.7-.515-2.341s-.838-1.166-1.452-1.576a6.332 6.332 0 0 0-2.094-.896 10.653 10.653 0 0 0-2.459-.279c-.756 0-1.512.104-2.272.313a6.81 6.81 0 0 0-2.084.961c-.63.433-1.155.79-1.577 1.452S72.888 60 72.833 60h3.235c.065 0 .203-.643.411-.961.208-.316.471-.48.788-.677.317-.197.682-.295 1.092-.388s.851-.115 1.322-.115c.997 0 1.782.191 2.357.554.575.361.862.957.862 1.778 0 .351-.112.652-.336.898-.225.247-.529.47-.912.667a8.528 8.528 0 0 1-1.331.534c-.503.158-1.029.321-1.577.485-.733.219-1.476.451-2.225.698-.75.246-1.429.55-2.037.911-.607.361-1.103.797-1.486 1.306s-.575 1.136-.575 1.881c0 .733.134 1.398.402 1.995.268.597.632 1.105 1.092 1.527s1.001.747 1.626.978a5.77 5.77 0 0 0 2.003.345c.493 0 .977-.033 1.454-.099.476-.065.95-.188 1.42-.369a6.717 6.717 0 0 0 1.404-.756 8.47 8.47 0 0 0 1.404-1.257c.186.778.525 1.386 1.018 1.823a2.514 2.514 0 0 0 1.725.657c.306 0 .606-.027.907-.082.304-.054 1.124-.151 1.124-.294v-2.677c0 .088-.543.161-.751.222-.208.06-.341.09-.407.09zM83 66.258c-1 1.14-1.473 1.993-2.349 2.563-.876.569-1.799.854-2.719.854-.295 0-.595-.041-.874-.123s-.535-.213-.754-.394a2.055 2.055 0 0 1-.537-.698c-.137-.285-.207-.624-.207-1.019 0-.427.145-.791.435-1.092.29-.302.662-.559 1.117-.772.454-.213.96-.396 1.519-.55l1.65-.451a28.384 28.384 0 0 0 1.561-.46c.465-.16 1.158-.354 1.158-.584v2.726zm13.434 1.093L92.131 55h-3.4l6.175 17h3.203l6.126-17h-3.367zM106 49h3v3h-3zm0 6h3v17h-3zm18.238 10.732c-.273-.427-.635-.808-1.084-1.142s-.96-.632-1.536-.895a35.758 35.758 0 0 0-1.757-.747l-1.758-.69a11.358 11.358 0 0 1-1.535-.723c-.449-.257-.811-.539-1.084-.846a1.533 1.533 0 0 1-.411-1.051c0-.536.238-.963.714-1.281.476-.317 1.168-.477 2.078-.477.405 0 .785.036 1.142.107.355.071.673.194.952.369.279.176.509.333.69.624.181.289.298 1.018.353 1.018h3.202c-.033-1-.216-1.543-.55-2.184s-.783-1.124-1.347-1.54-1.224-.7-1.979-.897c-.755-.196-1.577-.283-2.463-.283-.778 0-1.525.096-2.242.276a6.016 6.016 0 0 0-1.905.832 4.334 4.334 0 0 0-1.33 1.406c-.334.563-.501 1.229-.501 1.996 0 .613.137 1.146.411 1.601.273.454.635.86 1.084 1.216.449.356.96.671 1.535.944.575.274 1.161.531 1.757.772s1.183.471 1.757.689c.575.219 1.086.457 1.536.715.449.257.81.542 1.084.854.273.313.411.671.411 1.076 0 .427-.115.782-.345 1.067a2.51 2.51 0 0 1-.871.682c-.351.17-.737.287-1.158.353-.422.066-.83.099-1.224.099-.471 0-.903-.058-1.297-.172a2.625 2.625 0 0 1-1.027-.559c-.29-.257-.523-.811-.698-1.221-.175-.411-.269-.723-.279-1.723h-3.252c.033 1 .23 2.105.591 2.855s.838 1.48 1.429 1.975c.591.492 1.275.916 2.053 1.162a8.147 8.147 0 0 0 2.48.396c.909 0 1.773-.082 2.595-.273s1.541-.491 2.16-.912c.619-.422 1.111-.957 1.478-1.614s.55-1.449.55-2.38c.001-.556-.135-1.047-.409-1.474z\"/></svg>"

/***/ }),

/***/ "../src/components/travis/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TravisPlainWordmark = __webpack_require__("../src/components/travis/plain-wordmark/TravisPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TravisPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/travis/plain/TravisPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _TravisPlain = __webpack_require__("../src/components/travis/plain/TravisPlain.svg");
	
	var _TravisPlain2 = _interopRequireDefault(_TravisPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** TravisPlain */
	function TravisPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'TravisPlain',
	    svg: _TravisPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	TravisPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = TravisPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/travis/plain/TravisPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#BB2031\" d=\"M40 34h18v61h-8v11h28V94h-7V33h19v9h10V24H29v18h11zm82.2-31H6.031C4.005 3 2 4.226 2 6.225v116.154c0 2 2.005 3.621 4.031 3.621H122.2c2.026 0 2.8-1.621 2.8-3.621V6.225C125 4.226 124.226 3 122.2 3zM106 48H85v-9h-9v48h9v24H45V88h6V40h-6v8H22V18h84v30z\"/></svg>"

/***/ }),

/***/ "../src/components/travis/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TravisPlain = __webpack_require__("../src/components/travis/plain/TravisPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TravisPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/trello/plain-wordmark/TrelloPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _TrelloPlainWordmark = __webpack_require__("../src/components/trello/plain-wordmark/TrelloPlainWordmark.svg");
	
	var _TrelloPlainWordmark2 = _interopRequireDefault(_TrelloPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** TrelloPlainWordmark */
	function TrelloPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'TrelloPlainWordmark',
	    svg: _TrelloPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	TrelloPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = TrelloPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/trello/plain-wordmark/TrelloPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#23719F\" d=\"M82.128 75.202c-.527.386-.902.691-1.306.95-1.677 1.082-3.337 2.193-5.055 3.206-1.088.642-2.315.587-3.476.183-1.125-.39-2.245-.83-3.296-1.384-1.685-.889-2.219-2.574-2.742-4.259-.877-2.823.31-5.239 1.434-7.674.208-.446.492-.856.724-1.293.331-.625.145-.952-.571-.908a3.12 3.12 0 0 0-1.193.318c-3.145 1.599-5.882 3.702-7.973 6.578-1.438 1.981-2.322 4.208-2.911 6.575-.358 1.439-1.427 2.205-2.561 1.954-1.596-.354-2.731-2.725-2-4.18.116-.232.219-.479.383-.676 1.819-2.187 2.457-4.892 3.286-7.509.485-1.533.962-3.071 1.377-4.624.202-.757.45-1.529.05-2.343-.246-.505.162-.974.572-1.02.929-.105 1.948-.244 2.802.03.938.302 1.016 1.424 1.174 2.305.094.523.018 1.077.018 1.796.377-.173.647-.274.896-.416 1.419-.808 2.798-1.692 4.258-2.416 1.392-.69 2.816-.316 4.124.329.66.326 1.001.289 1.512-.283 1.135-1.273 2.316-2.527 3.619-3.622 1.081-.907 2.489-1.176 3.897-1.075.923.065 1.85.236 2.747.464 1.048.269 1.711 1.211 1.808 2.274.194 2.162-.669 4.003-1.904 5.629-2.938 3.871-6.267 7.355-10.481 9.884-.582.35-.627.767-.358 1.309.412.824 1.406 1.178 2.318.897 2.576-.792 4.57-2.505 6.628-4.125 1.099-.865 2.272-1.655 3.259-2.633.555-.549.821-1.4 1.18-2.135 1.367-2.796 2.641-5.641 4.093-8.392 1.525-2.894 3.232-5.691 4.824-8.55.439-.79.76-1.647 1.118-2.48.523-1.211 1.342-1.959 2.754-1.832.258.023.521-.005.782-.004 1.836.003 2.837 1.586 1.935 3.204-.808 1.448-1.746 2.823-2.657 4.211-2.662 4.058-5.409 8.069-7.482 12.473a64.288 64.288 0 0 0-2.628 6.404c-.364 1.053-.363 2.247-.427 3.383-.04.743.481.99 1.07.495.971-.817 1.847-1.744 2.799-2.583.813-.716 1.727-1.319 2.498-2.073.399-.391.659-.971.855-1.511 1.427-3.914 3.256-7.635 5.262-11.277 1.441-2.615 2.935-5.203 4.372-7.822.68-1.24 1.245-2.544 1.937-3.779.43-.767 1.113-1.219 2.066-1.119.31.033.628.026.938-.009 2.12-.243 2.784 1.895 2.021 3.213-.637 1.098-1.329 2.164-2.023 3.226-3.086 4.715-6.307 9.354-8.634 14.511-.915 2.026-1.659 4.138-2.356 6.25-.252.765-.181 1.648-.18 2.478 0 .75.471.974 1.067.473.952-.8 1.828-1.688 2.753-2.524l2.217-1.933c.183-.164.397-.389.428-.61.58-4.051 2.565-7.411 5.137-10.476.832-.993 1.665-2.004 2.62-2.872 1.924-1.746 4.42-1.339 5.867.04.408.389.637.991.875 1.527.496 1.105.856 1.359 2.085 1.355 1.455-.005 2.912-.058 4.362.021.569.031 1.168.284 1.673.575.637.369.579 1.02-.076 1.319-1.85.844-3.775 1.436-5.825 1.485-.682.017-.977.247-1.153.953-1.116 4.477-2.672 8.759-6.054 12.097-.708.699-1.522 1.36-2.408 1.79-1.674.812-3.134-.028-4.496-.948a8.128 8.128 0 0 1-1.578-1.376c-.396-.455-.617-.411-.977-.006-1.038 1.171-2.136 2.28-3.611 2.908-.89.378-1.756.607-2.778.302-1.534-.46-2.922-1.085-3.915-2.38-.37-.485-.621-.435-1.056-.055-.817.713-1.646 1.445-2.576 1.988-1.901 1.109-3.726.481-5.438-.546-1.296-.773-2.212-1.869-2.319-3.63zm25.52-2.126c.081.363.125.897.324 1.365.172.4.478.962.803 1.021.309.057.832-.37 1.066-.716a118.356 118.356 0 0 0 3.092-4.85c1.313-2.169 1.977-4.561 2.212-7.069a2.789 2.789 0 0 0-.238-1.358c-.478-1.043-.962-1.112-1.594-.171-1.286 1.91-2.56 3.834-3.71 5.83a15.071 15.071 0 0 0-1.955 5.948zM79.195 59.895c.053-.576-.21-.754-.705-.622-.144.038-.278.141-.396.238-2.979 2.445-5.281 5.408-6.813 8.952-.068.157.023.385.04.58.187-.042.429-.022.555-.134.682-.601 1.338-1.229 1.996-1.854 2.043-1.941 3.866-4.051 5.107-6.611.09-.187.152-.386.216-.549zm-31.459-4.052c-.509-.054-.878-.103-1.249-.13-1.084-.08-2.178-.091-3.251-.246-.868-.126-1.24-.705-1.24-1.611l.007-.468c.045-1.591.627-1.829 2.207-1.601 1.623.234 3.319.165 4.964.012 2.164-.2 4.306-.647 6.464-.92 1.311-.165 2.636-.226 3.955-.294 1.727-.09 3.111.739 4.323 1.828.302.27.415.946.343 1.393-.139.873-2.167 1.779-2.987.96-.595-.593-1.377-.789-2.237-.687-1.624.194-3.254.35-4.88.536-.414.047-.572.263-.719.722-.28.876-.787 1.684-1.229 2.504-1.908 3.55-3.597 7.19-4.639 11.096a227.55 227.55 0 0 0-1.783 7.242c-.121.522-.097 1.091-.069 1.634.109 2.07-1.022 2.381-2.707 1.834-.491-.158-.949-.423-1.421-.64-.545-.254-.905-.688-.837-1.279.16-1.386.281-2.792.627-4.135a101.72 101.72 0 0 1 2.114-7.157c.733-2.188 1.606-4.331 2.461-6.478.524-1.319 1.127-2.608 1.783-4.115z\"/><path fill=\"#23719F\" d=\"M36 52.028A4.029 4.029 0 0 0 31.971 48H7.029A4.029 4.029 0 0 0 3 52.028v24.943A4.03 4.03 0 0 0 7.029 81H31.97A4.03 4.03 0 0 0 36 76.972V52.028zM19 73.003C19 73.952 16.886 75 15.844 75H8.636C7.595 75 7 73.952 7 73.003V52.745c0-.949.595-.745 1.636-.745h7.208c1.042 0 3.156-.204 3.156.745v20.258zm14-17.486V64c0 1.011-1.282 2-2.295 2h-7.27C22.422 66 22 65.011 22 63.999V52.797c0-1.012.422-.797 1.436-.797h7.27c1.012 0 2.294-.215 2.294.797v2.72z\"/></svg>"

/***/ }),

/***/ "../src/components/trello/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TrelloPlainWordmark = __webpack_require__("../src/components/trello/plain-wordmark/TrelloPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TrelloPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/trello/plain/TrelloPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _TrelloPlain = __webpack_require__("../src/components/trello/plain/TrelloPlain.svg");
	
	var _TrelloPlain2 = _interopRequireDefault(_TrelloPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** TrelloPlain */
	function TrelloPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'TrelloPlain',
	    svg: _TrelloPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	TrelloPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = TrelloPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/trello/plain/TrelloPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#23719F\" d=\"M127 16.142C127 7.779 120.221 1 111.858 1H16.142C7.779 1 1 7.779 1 16.142v95.715C1 120.221 7.779 127 16.142 127h95.716c8.363 0 15.142-6.779 15.142-15.143V16.142zM58 99.54c0 3.807-3.286 6.46-7.093 6.46H23.563C19.756 106 17 103.347 17 99.54V23.23c0-3.808 2.756-7.23 6.563-7.23h27.344C54.714 16 58 19.422 58 23.23v76.31zm55-66.456V64.97c0 3.807-2.936 7.03-6.744 7.03h-27.33C75.118 72 72 68.776 72 64.97V22.866C72 19.058 75.118 16 78.926 16h27.33c3.808 0 6.744 3.058 6.744 6.866v10.218z\"/></svg>"

/***/ }),

/***/ "../src/components/trello/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TrelloPlain = __webpack_require__("../src/components/trello/plain/TrelloPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TrelloPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/twitter/original/TwitterOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _TwitterOriginal = __webpack_require__("../src/components/twitter/original/TwitterOriginal.svg");
	
	var _TwitterOriginal2 = _interopRequireDefault(_TwitterOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** TwitterOriginal */
	function TwitterOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'TwitterOriginal',
	    svg: _TwitterOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	TwitterOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = TwitterOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/twitter/original/TwitterOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"twitter\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 126.24 102.59\"><defs><style>.cls-1{fill:#1da1f2}</style></defs><title>twitter-original</title><path id=\"original\" class=\"cls-1\" d=\"M40.58 115.3c47.64 0 73.69-39.47 73.69-73.69 0-1.12 0-2.24-.07-3.35a52.7 52.7 0 0 0 12.92-13.41 51.7 51.7 0 0 1-14.87 4.08 26 26 0 0 0 11.38-14.33 51.9 51.9 0 0 1-16.45 6.29 25.92 25.92 0 0 0-44.13 23.62A73.53 73.53 0 0 1 9.67 17.45a25.92 25.92 0 0 0 8 34.58A25.71 25.71 0 0 1 6 48.78v.33A25.91 25.91 0 0 0 26.73 74.5a25.86 25.86 0 0 1-11.7.44 25.93 25.93 0 0 0 24.2 18A52 52 0 0 1 7.06 104a52.72 52.72 0 0 1-6.18-.36 73.32 73.32 0 0 0 39.7 11.63\" transform=\"translate(-.88 -12.7)\"/></svg>"

/***/ }),

/***/ "../src/components/twitter/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TwitterOriginal = __webpack_require__("../src/components/twitter/original/TwitterOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TwitterOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/typescript/original/TypescriptOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _TypescriptOriginal = __webpack_require__("../src/components/typescript/original/TypescriptOriginal.svg");
	
	var _TypescriptOriginal2 = _interopRequireDefault(_TypescriptOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** TypescriptOriginal */
	function TypescriptOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'TypescriptOriginal',
	    svg: _TypescriptOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	TypescriptOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = TypescriptOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/typescript/original/TypescriptOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"typescript\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#fff}.cls-2{fill:#007acc}</style></defs><title>Artboard 3</title><g id=\"original\"><path class=\"cls-1\" d=\"M22.67 47h99.67v73.67H22.67z\"/><path id=\"original-2\" data-name=\"original\" class=\"cls-2\" d=\"M1.5 63.91v62.5h125v-125H1.5zm100.73-5a15.56 15.56 0 0 1 7.82 4.5 20.58 20.58 0 0 1 3 4c0 .16-5.4 3.81-8.69 5.85-.12.08-.6-.44-1.13-1.23a7.09 7.09 0 0 0-5.87-3.53c-3.79-.26-6.23 1.73-6.21 5a4.58 4.58 0 0 0 .54 2.34c.83 1.73 2.38 2.76 7.24 4.86 8.95 3.85 12.78 6.39 15.16 10 2.66 4 3.25 10.46 1.45 15.24-2 5.2-6.9 8.73-13.83 9.9a38.32 38.32 0 0 1-9.52-.1 23 23 0 0 1-12.72-6.63c-1.15-1.27-3.39-4.58-3.25-4.82a9.34 9.34 0 0 1 1.15-.73L82 101l3.59-2.08.75 1.11a16.78 16.78 0 0 0 4.74 4.54c4 2.1 9.46 1.81 12.16-.62a5.43 5.43 0 0 0 .69-6.92c-1-1.39-3-2.56-8.59-5-6.45-2.78-9.23-4.5-11.77-7.24a16.48 16.48 0 0 1-3.43-6.25 25 25 0 0 1-.22-8c1.33-6.23 6-10.58 12.82-11.87a31.66 31.66 0 0 1 9.49.26zm-29.34 5.24v5.12H56.66v46.23H45.15V69.26H28.88v-5a49.19 49.19 0 0 1 .12-5.17C29.08 59 39 59 51 59h21.83z\"/></g></svg>"

/***/ }),

/***/ "../src/components/typescript/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TypescriptOriginal = __webpack_require__("../src/components/typescript/original/TypescriptOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TypescriptOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/typescript/plain/TypescriptPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _TypescriptPlain = __webpack_require__("../src/components/typescript/plain/TypescriptPlain.svg");
	
	var _TypescriptPlain2 = _interopRequireDefault(_TypescriptPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** TypescriptPlain */
	function TypescriptPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'TypescriptPlain',
	    svg: _TypescriptPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	TypescriptPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = TypescriptPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/typescript/plain/TypescriptPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"typescript\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#007acc}</style></defs><title>Artboard 4</title><path id=\"plain\" class=\"cls-1\" d=\"M2 63.91v62.5h125v-125H2zm100.73-5a15.56 15.56 0 0 1 7.82 4.5 20.58 20.58 0 0 1 3 4c0 .16-5.4 3.81-8.69 5.85-.12.08-.6-.44-1.13-1.23a7.09 7.09 0 0 0-5.87-3.53c-3.79-.26-6.23 1.73-6.21 5a4.58 4.58 0 0 0 .54 2.34c.83 1.73 2.38 2.76 7.24 4.86 8.95 3.85 12.78 6.39 15.16 10 2.66 4 3.25 10.46 1.45 15.24-2 5.2-6.9 8.73-13.83 9.9a38.32 38.32 0 0 1-9.52-.1A23 23 0 0 1 80 109.19c-1.15-1.27-3.39-4.58-3.25-4.82a9.34 9.34 0 0 1 1.15-.73l4.6-2.64 3.59-2.08.75 1.11a16.78 16.78 0 0 0 4.74 4.54c4 2.1 9.46 1.81 12.16-.62a5.43 5.43 0 0 0 .69-6.92c-1-1.39-3-2.56-8.59-5-6.45-2.78-9.23-4.5-11.77-7.24a16.48 16.48 0 0 1-3.43-6.25 25 25 0 0 1-.22-8c1.33-6.23 6-10.58 12.82-11.87a31.66 31.66 0 0 1 9.49.26zm-29.34 5.24v5.12H57.16v46.23H45.65V69.26H29.38v-5a49.19 49.19 0 0 1 .14-5.16c.06-.08 10-.12 22-.1h21.81z\"/></svg>"

/***/ }),

/***/ "../src/components/typescript/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TypescriptPlain = __webpack_require__("../src/components/typescript/plain/TypescriptPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TypescriptPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ubuntu/plain-wordmark/UbuntuPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _UbuntuPlainWordmark = __webpack_require__("../src/components/ubuntu/plain-wordmark/UbuntuPlainWordmark.svg");
	
	var _UbuntuPlainWordmark2 = _interopRequireDefault(_UbuntuPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** UbuntuPlainWordmark */
	function UbuntuPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'UbuntuPlainWordmark',
	    svg: _UbuntuPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	UbuntuPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = UbuntuPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ubuntu/plain-wordmark/UbuntuPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#DD4814\" d=\"M64.02 1.596c-24.36 0-44.107 19.747-44.107 44.107 0 24.356 19.747 44.105 44.107 44.105 24.359 0 44.106-19.749 44.106-44.105 0-24.36-19.747-44.107-44.106-44.107zm9.896 15.19a5.887 5.887 0 1 1 10.199 5.88 5.887 5.887 0 0 1-10.199-5.88zm-9.896 3.335c2.368 0 4.658.328 6.834.929a8.244 8.244 0 0 0 4.027 5.839 8.254 8.254 0 0 0 7.06.572c4.354 4.282 7.188 10.105 7.602 16.592l-8.392.123c-.774-8.786-8.146-15.675-17.131-15.675-2.589 0-5.044.575-7.246 1.6l-4.092-7.333a25.484 25.484 0 0 1 11.338-2.647zm-29.992 31.47a5.89 5.89 0 1 1-.001-11.779 5.89 5.89 0 0 1 .001 11.779zm5.222.524a8.261 8.261 0 0 0 3.048-6.413 8.264 8.264 0 0 0-3.048-6.415c1.593-6.163 5.426-11.425 10.578-14.87l4.305 7.211c-4.423 3.112-7.313 8.254-7.313 14.074 0 5.818 2.89 10.959 7.313 14.07l-4.305 7.213c-5.154-3.443-8.988-8.705-10.578-14.87zm42.709 24.658a5.884 5.884 0 0 1-8.041-2.156 5.887 5.887 0 1 1 8.041 2.156zm-.018-12.831a8.252 8.252 0 0 0-7.06.572 8.254 8.254 0 0 0-4.027 5.839 25.59 25.59 0 0 1-6.834.931c-4.071 0-7.919-.957-11.337-2.649l4.092-7.332a17.138 17.138 0 0 0 7.246 1.6c8.985 0 16.357-6.888 17.13-15.676l8.393.123c-.414 6.487-3.248 12.31-7.603 16.592zM16 121.659c-1 .055-.509.103-.823.144-.315.042-.738.082-1.122.123-.384.042-.832.076-1.271.103-.439.028-.882.042-1.293.042-1.947 0-3.383-.562-4.206-1.687C6.462 119.26 6 117.394 6 114.789V104H3v11.612c0 1.454-.22 2.777.082 3.969.302 1.192.61 2.228 1.295 3.105.685.878 1.498 1.556 2.623 2.037 1.123.478 2.462.719 4.107.719 1.893 0 3.269-.123 4.708-.37 1.439-.246 2.184-.48 3.184-.699V104h-3v17.659zm25.376-15.426a8.505 8.505 0 0 0-3.023-2.303c-1.193-.548-2.557-.823-4.093-.823-1.233 0-2.26.164-3.206.494-.946.329-1.054.645-2.054.945V93.071l-4 .659v30.644c0 .247 2.025.494 3.396.74 1.372.247 2.96.37 4.742.37 1.646 0 3.133-.262 4.449-.782 1.316-.521 2.442-1.261 3.375-2.221.932-.96 1.653-2.132 2.161-3.516.507-1.386.762-2.943.762-4.67 0-1.645-.213-3.153-.638-4.524-.425-1.371-1.048-2.55-1.871-3.538zm-3.331 13.841c-1.234 1.358-2.879 2.037-4.937 2.037-1.042 0-1.848-.048-2.548-.144-.699-.096-.561-.199-1.561-.309v-13.534c1-.384 1.073-.754 1.951-1.11.878-.356 1.805-.535 2.849-.535 1.096 0 2.02.199 2.801.596a5.164 5.164 0 0 1 1.905 1.646c.493.699.845 1.529 1.065 2.489.22.961.327 1.989.327 3.085 0 2.497-.619 4.422-1.852 5.779zM61 121.659c0 .055-.161.103-.476.144-.315.042-.563.082-.947.123-.384.042-.745.076-1.183.103-.438.028-.838.042-1.249.042-1.948 0-3.209-.562-4.032-1.687-.823-1.124-1.113-2.99-1.113-5.595V104h-4v11.612c0 1.454.129 2.776.431 3.969.302 1.192.785 2.228 1.471 3.105.685.878 1.584 1.556 2.709 2.037 1.125.478 2.507.719 4.153.719 1.892 0 3.439-.123 4.879-.37 1.439-.246 2.357-.48 3.357-.699V104h-4v17.659zm25.19-15.775c-.673-.864-1.57-1.535-2.694-2.015-1.125-.479-2.537-.72-4.237-.72-1.892 0-3.937.123-5.39.37-1.455.247-2.869.48-3.869.7V124h4v-17.067l.964-.123c.314-.055.813-.103 1.211-.145.397-.041.887-.076 1.326-.103a21.91 21.91 0 0 1 1.311-.041c1.014 0 1.882.13 2.567.391.687.26 1.244.679 1.655 1.254.412.575.613 1.329.792 2.262.177.932.174 2.057.174 3.372V124h4v-11.021c0-1.453-.127-2.783-.401-3.991-.275-1.205-.738-2.24-1.409-3.104zm17.419 15.795c-.685.26-1.618.391-2.797.391-.658 0-1.234-.083-1.727-.247a2.654 2.654 0 0 1-1.234-.843c-.329-.398-1.008-.945-1.172-1.646-.165-.699-.679-1.584-.679-2.652V107h9v-3h-9v-7.022l-3 .659v19.085c0 1.427.135 2.681.368 3.764.233 1.084.647 1.995 1.223 2.736.576.74 1.341 1.295 2.288 1.665.946.371 2.148.556 3.603.556 1.234 0 2.338-.151 3.312-.453s1.652-.547 2.037-.74l-.821-3.127c-.249.11-.716.295-1.401.556zM122 104v17.659c0 .055-.387.103-.701.144-.315.042-.678.082-1.061.123-.384.042-.801.076-1.239.103-.439.028-.867.042-1.278.042-1.947 0-3.498-.562-4.32-1.687-.823-1.124-1.4-2.989-1.4-5.595V104h-3v11.612c0 1.454-.098 2.776.205 3.969.301 1.192.67 2.228 1.356 3.105a6.514 6.514 0 0 0 2.652 2.037c1.125.478 2.479.719 4.124.719 1.893 0 3.153-.123 4.593-.37 1.439-.246 2.05-.48 3.07-.699V104H122z\"/></svg>"

/***/ }),

/***/ "../src/components/ubuntu/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _UbuntuPlainWordmark = __webpack_require__("../src/components/ubuntu/plain-wordmark/UbuntuPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_UbuntuPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ubuntu/plain/UbuntuPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _UbuntuPlain = __webpack_require__("../src/components/ubuntu/plain/UbuntuPlain.svg");
	
	var _UbuntuPlain2 = _interopRequireDefault(_UbuntuPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** UbuntuPlain */
	function UbuntuPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'UbuntuPlain',
	    svg: _UbuntuPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	UbuntuPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = UbuntuPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/ubuntu/plain/UbuntuPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#DD4814\" d=\"M64 3.246C30.445 3.246 3.245 30.446 3.245 64c0 33.552 27.2 60.754 60.755 60.754 33.554 0 60.755-27.202 60.755-60.754 0-33.554-27.2-60.754-60.755-60.754zm13.631 20.922a8.108 8.108 0 1 1 14.046 8.108A8.105 8.105 0 0 1 80.6 35.243a8.11 8.11 0 0 1-2.969-11.075zM64 28.763c3.262 0 6.417.453 9.414 1.281a11.357 11.357 0 0 0 5.548 8.042 11.378 11.378 0 0 0 9.725.789c5.998 5.898 9.901 13.919 10.47 22.854l-11.558.17C86.532 49.796 76.377 40.306 64 40.306a23.6 23.6 0 0 0-9.98 2.203L48.383 32.41A35.116 35.116 0 0 1 64 28.763zM22.689 72.112A8.112 8.112 0 0 1 14.576 64a8.111 8.111 0 0 1 8.113-8.113 8.113 8.113 0 0 1 0 16.225zm7.191.722A11.377 11.377 0 0 0 34.08 64c0-3.565-1.639-6.747-4.2-8.836 2.194-8.489 7.475-15.738 14.571-20.483l5.931 9.934C44.29 48.902 40.308 55.984 40.308 64s3.981 15.098 10.074 19.383l-5.931 9.937c-7.099-4.744-12.38-11.995-14.571-20.486zm58.831 33.964a8.105 8.105 0 0 1-11.077-2.969c-2.241-3.877-.911-8.835 2.969-11.076 3.877-2.239 8.838-.908 11.077 2.969a8.106 8.106 0 0 1-2.969 11.076zm-.024-17.673a11.357 11.357 0 0 0-9.725.788 11.36 11.36 0 0 0-5.547 8.042A35.232 35.232 0 0 1 64 99.239a35.097 35.097 0 0 1-15.616-3.649l5.636-10.1A23.6 23.6 0 0 0 64 87.694c12.378 0 22.532-9.488 23.596-21.592l11.561.169c-.569 8.935-4.472 16.956-10.47 22.854z\"/></svg>"

/***/ }),

/***/ "../src/components/ubuntu/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _UbuntuPlain = __webpack_require__("../src/components/ubuntu/plain/UbuntuPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_UbuntuPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/utils.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.normalizeUnit = normalizeUnit;
	
	var _lodash = __webpack_require__("../node_modules/lodash.isnumber/index.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function normalizeUnit(unitValue) {
	  return (0, _lodash2.default)(unitValue) ? unitValue + 'px' : unitValue;
	}

/***/ }),

/***/ "../src/components/vagrant/original-wordmark/VagrantOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VagrantOriginalWordmark = __webpack_require__("../src/components/vagrant/original-wordmark/VagrantOriginalWordmark.svg");
	
	var _VagrantOriginalWordmark2 = _interopRequireDefault(_VagrantOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VagrantOriginalWordmark */
	function VagrantOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VagrantOriginalWordmark',
	    svg: _VagrantOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VagrantOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VagrantOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vagrant/original-wordmark/VagrantOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Vagrant\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#1159cc}.cls-2{fill:#127eff}</style></defs><title>Artboard 13</title><g id=\"original-wordmark\"><path d=\"M47.77 51.47v-1.82H46.1v1.82h-.85v-4.38h.85v1.84h1.67v-1.84h.85v4.38zm4 0h-.68l-.09-.21a1.86 1.86 0 0 1-1 .28c-.6 0-.86-.4-.86-.94s.29-.89 1-.89h.79v-.33c0-.35-.1-.47-.63-.47a4.79 4.79 0 0 0-.91.1l-.1-.6a4.46 4.46 0 0 1 1.13-.15c1 0 1.34.35 1.34 1.14zm-.82-1.19h-.61c-.27 0-.34.07-.34.31s.07.32.33.32a1.34 1.34 0 0 0 .62-.16zm2.55 1.26a4 4 0 0 1-1.14-.18l.11-.6a3.83 3.83 0 0 0 1 .14c.37 0 .42-.08.42-.32s0-.29-.57-.42c-.8-.19-.9-.38-.9-1s.29-.92 1.23-.92a4.51 4.51 0 0 1 1 .11l-.08.63a6 6 0 0 0-.91-.09c-.36 0-.42.08-.42.27s0 .27.47.38c.92.23 1 .35 1 1s-.24 1-1.23 1zm3.78-.06v-2.21c0-.17-.07-.25-.26-.25a2.34 2.34 0 0 0-.86.27v2.19h-.82V47l.82.12v1.4a3 3 0 0 1 1.2-.31c.55 0 .74.37.74.93v2.29zm1.52-3.61v-.77h.82v.77zm0 3.61v-3.17h.82v3.16zm1.48-3.14c0-.79.48-1.25 1.6-1.25a5.3 5.3 0 0 1 1.22.14l-.09.71a6.91 6.91 0 0 0-1.1-.11c-.59 0-.78.19-.78.66v1.66c0 .46.19.66.78.66a6.91 6.91 0 0 0 1.1-.11l.09.71a5.3 5.3 0 0 1-1.22.14c-1.12 0-1.6-.46-1.6-1.25zm4.65 3.2c-1.13 0-1.43-.6-1.43-1.25v-.8c0-.65.3-1.25 1.43-1.25s1.43.6 1.43 1.25v.8c-.02.65-.36 1.25-1.45 1.25zm0-2.62c-.44 0-.61.19-.61.55v.85c0 .36.17.55.61.55s.61-.19.61-.55v-.85c-.03-.36-.2-.55-.63-.55zm3.76.05a6.54 6.54 0 0 0-.87.46v2H67v-3.12h.7l.05.35a3.75 3.75 0 0 1 .87-.42zM72 50.42a1 1 0 0 1-1.09 1.12 4.73 4.73 0 0 1-.88-.09v1.29l-.82.12v-4.55h.66l.08.27a1.78 1.78 0 0 1 1-.33c.66 0 1 .38 1 1.1zm-2 .36a3.8 3.8 0 0 0 .73.08c.3 0 .41-.14.41-.42v-1.12c0-.26-.1-.4-.41-.4a1.19 1.19 0 0 0-.74.29zM57.56 55h3.56l-5.41 18.1h-5.05L45.25 55h3.56l4.37 15.08zM71 73.1h-2.71l-.24-.9a7.24 7.24 0 0 1-3.94 1.17c-2.42 0-3.45-1.66-3.45-3.94 0-2.69 1.17-3.72 3.86-3.72h3.18v-1.39c0-1.47-.41-2-2.53-2a18.49 18.49 0 0 0-3.67.41l-.41-2.53a17.27 17.27 0 0 1 4.54-.63c4.16 0 5.38 1.47 5.38 4.78zm-3.32-5h-2.43c-1.09 0-1.39.3-1.39 1.3s.3 1.33 1.33 1.33a5.22 5.22 0 0 0 2.5-.68zM77.34 69.54a1.42 1.42 0 0 0-.79 1.06c0 .35.22.52.73.57l3.83.41c2.15.24 2.83 1.3 2.83 3.21 0 2.83-1 3.94-6 3.94a19.27 19.27 0 0 1-5.08-.73l.41-2.47a18.38 18.38 0 0 0 4.46.57c2.64 0 3.15-.19 3.15-1.06s-.24-1-1.25-1.06l-3.83-.43c-1.87-.22-2.61-.84-2.61-2.53a2.8 2.8 0 0 1 1.39-2.26 3.84 3.84 0 0 1-1.79-3.56V64c.05-2.74 1.49-4.4 5.33-4.4a9 9 0 0 1 2.26.27h4.08v1.66l-1.46.4a4.54 4.54 0 0 1 .43 2.07v1.25c0 2.69-1.63 4.32-5.33 4.32a6.89 6.89 0 0 1-.76-.03zm.76-7.28c-1.63 0-2.2.6-2.2 1.85v1c0 1.3.65 1.79 2.2 1.79s2.23-.52 2.23-1.79v-1c0-1.25-.57-1.85-2.23-1.85zM92.75 62.64a26 26 0 0 0-3.51 1.93v8.53h-3.31V59.87h2.8l.22 1.47a14.83 14.83 0 0 1 3.48-1.74zM103.84 73.1h-2.72l-.24-.9a7.24 7.24 0 0 1-3.94 1.17c-2.42 0-3.45-1.66-3.45-3.94 0-2.69 1.17-3.72 3.86-3.72h3.18v-1.39c0-1.47-.41-2-2.53-2a18.49 18.49 0 0 0-3.67.41l-.41-2.53a17.27 17.27 0 0 1 4.54-.63c4.16 0 5.38 1.47 5.38 4.78zm-3.32-5h-2.44c-1.09 0-1.39.3-1.39 1.3S97 70.74 98 70.74a5.22 5.22 0 0 0 2.5-.68zM113.7 73.1v-9.24c0-.71-.3-1.06-1.06-1.06a9.14 9.14 0 0 0-3.45 1.11v9.19h-3.32V59.87h2.53l.33 1.11A13.25 13.25 0 0 1 114 59.6c2.2 0 3 1.55 3 3.91v9.59zM126.77 72.86a9.19 9.19 0 0 1-2.91.52c-2.42 0-3.64-1.14-3.64-3.51V62.5h-2v-2.63h2v-3.29l3.32-.46v3.75h3.4l-.22 2.64h-3.18v6.93a1 1 0 0 0 1.2 1.17 6.38 6.38 0 0 0 1.66-.27z\"/><path class=\"cls-1\" d=\"M33.89 52.75v-3.1l-7.46 4.34v2.62l-5.97 12.88-2.98 2.05v9.43l6.4-3.69 10.01-24.53zM17.48 64.83L13 54.38v-2.95l-.03-.01-4.44 2.57v2.62l5.96 13.44 2.99-1.47v-3.75z\"/><path class=\"cls-2\" d=\"M29.42 47.03l-7.46 4.37h-.01v2.98l-4.47 10.45v3.49l-2.99 1.73-5.96-13.44v-2.63l4.48-2.57-7.47-4.38-4.47 2.62v3.2l10.07 24.46 6.34 3.66v-9.19l2.98-1.73-.03-.02 6-13.42v-2.63l7.46-4.33-4.47-2.62z\"/></g></svg>"

/***/ }),

/***/ "../src/components/vagrant/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VagrantOriginalWordmark = __webpack_require__("../src/components/vagrant/original-wordmark/VagrantOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VagrantOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vagrant/original/VagrantOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VagrantOriginal = __webpack_require__("../src/components/vagrant/original/VagrantOriginal.svg");
	
	var _VagrantOriginal2 = _interopRequireDefault(_VagrantOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VagrantOriginal */
	function VagrantOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VagrantOriginal',
	    svg: _VagrantOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VagrantOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VagrantOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vagrant/original/VagrantOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Vagrant\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#1159cc}.cls-2{fill:#127eff}</style></defs><title>Artboard 12</title><g id=\"original\"><path class=\"cls-1\" d=\"M122.5 23.9V12.82L95.91 28.3v9.34l-21.28 45.9-10.64 7.33v33.61l22.81-13.15 35.7-87.43zM63.99 66.94L48.04 29.71V19.19l-.11-.06-15.84 9.17v9.34l21.27 47.91 10.63-5.25V66.94z\"/><path class=\"cls-2\" d=\"M106.55 3.52L79.97 19.09l-.02-.01V29.71L63.99 66.94v12.45l-10.63 6.16-21.27-47.91v-9.36l15.96-9.19-26.6-15.57-15.95 9.3v11.42l35.9 87.2 22.59 13.04V91.72l10.64-6.17-.13-.08 21.41-47.83v-9.36l26.59-15.46-15.95-9.3z\"/></g></svg>"

/***/ }),

/***/ "../src/components/vagrant/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VagrantOriginal = __webpack_require__("../src/components/vagrant/original/VagrantOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VagrantOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vagrant/plain-wordmark/VagrantPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VagrantPlainWordmark = __webpack_require__("../src/components/vagrant/plain-wordmark/VagrantPlainWordmark.svg");
	
	var _VagrantPlainWordmark2 = _interopRequireDefault(_VagrantPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VagrantPlainWordmark */
	function VagrantPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VagrantPlainWordmark',
	    svg: _VagrantPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VagrantPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VagrantPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vagrant/plain-wordmark/VagrantPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><title>Artboard 15</title><path d=\"M47.76 51.46v-1.83h-1.67v1.83h-.85v-4.39h.85v1.84h1.67v-1.84h.85v4.39zm4 0h-.68l-.08-.21a1.86 1.86 0 0 1-1 .28c-.6 0-.86-.4-.86-.94s.29-.89 1-.89h.79v-.33c0-.35-.1-.47-.63-.47a4.79 4.79 0 0 0-.91.1l-.1-.6a4.47 4.47 0 0 1 1.13-.15c1 0 1.34.35 1.34 1.14zm-.83-1.2h-.63c-.27 0-.35.07-.35.31s.07.32.33.32a1.34 1.34 0 0 0 .62-.16zm2.56 1.26a4 4 0 0 1-1.14-.18l.12-.6a3.83 3.83 0 0 0 1 .14c.37 0 .42-.08.42-.32s0-.29-.58-.42c-.81-.19-.9-.38-.9-1s.29-.92 1.23-.92a4.51 4.51 0 0 1 1 .11l-.08.63a6 6 0 0 0-.91-.09c-.36 0-.42.08-.42.27s0 .27.47.38c.92.23 1 .35 1 1s-.24 1-1.23 1zm3.78-.06v-2.21c0-.17-.07-.25-.26-.25a2.35 2.35 0 0 0-.86.27v2.2h-.85V47l.83.12v1.4a3 3 0 0 1 1.2-.31c.55 0 .74.37.74.94v2.29zm1.52-3.61v-.77h.83v.77zm0 3.61v-3.17h.83v3.17zm1.49-3.14c0-.79.48-1.25 1.6-1.25a5.31 5.31 0 0 1 1.23.14l-.09.71a6.91 6.91 0 0 0-1.1-.11c-.59 0-.78.19-.78.66v1.66c0 .46.19.66.78.66a6.91 6.91 0 0 0 1.1-.11l.09.71a5.31 5.31 0 0 1-1.23.14c-1.12 0-1.6-.46-1.6-1.25zm4.65 3.2c-1.13 0-1.44-.6-1.44-1.25v-.8c0-.65.3-1.25 1.44-1.25s1.43.6 1.43 1.25v.8c-.02.66-.36 1.25-1.45 1.25zm0-2.62c-.44 0-.61.19-.61.55v.85c0 .36.17.55.61.55s.61-.19.61-.55v-.85c-.02-.36-.19-.54-.63-.54zm3.76.05a6.55 6.55 0 0 0-.87.46v2H67v-3.12h.7l.05.35a3.75 3.75 0 0 1 .87-.42zM72 50.41a1 1 0 0 1-1.09 1.12 4.73 4.73 0 0 1-.88-.09v1.29l-.83.12v-4.56h.66l.08.27a1.78 1.78 0 0 1 1-.33c.66 0 1 .38 1 1.1zm-2 .36a3.81 3.81 0 0 0 .73.08c.3 0 .41-.14.41-.42v-1.12c0-.26-.1-.4-.41-.4a1.19 1.19 0 0 0-.74.29zM57.56 55h3.56l-5.41 18.11h-5.06L45.23 55h3.57l4.38 15.1zM71 73.11h-2.7l-.24-.9a7.25 7.25 0 0 1-3.94 1.17c-2.42 0-3.45-1.66-3.45-3.94 0-2.69 1.17-3.73 3.86-3.73h3.17v-1.39c0-1.47-.41-2-2.53-2a18.51 18.51 0 0 0-3.67.41l-.41-2.53a17.28 17.28 0 0 1 4.54-.63c4.16 0 5.39 1.47 5.39 4.79zm-3.32-5h-2.43c-1.09 0-1.39.3-1.39 1.31s.3 1.33 1.33 1.33a5.22 5.22 0 0 0 2.5-.68zM77.36 69.55a1.43 1.43 0 0 0-.79 1.06c0 .35.22.52.73.57l3.84.41c2.15.24 2.83 1.31 2.83 3.21 0 2.83-1 3.94-6 3.94a19.29 19.29 0 0 1-5.11-.68l.41-2.48a18.4 18.4 0 0 0 4.46.57c2.64 0 3.16-.19 3.16-1.06s-.24-1-1.25-1.06l-3.84-.44c-1.88-.22-2.61-.84-2.61-2.53a2.81 2.81 0 0 1 1.39-2.26 3.85 3.85 0 0 1-1.8-3.56V64c.05-2.75 1.5-4.41 5.33-4.41a9 9 0 0 1 2.26.27h4.08v1.66l-1.45.41a4.54 4.54 0 0 1 .45 2.07v1.25c0 2.69-1.63 4.33-5.33 4.33a6.89 6.89 0 0 1-.76-.03zm.76-7.29c-1.63 0-2.2.6-2.2 1.85v1c0 1.31.65 1.8 2.2 1.8s2.23-.52 2.23-1.8v-1c0-1.25-.57-1.85-2.23-1.85zM92.78 62.64a26 26 0 0 0-3.51 1.93v8.54H86V59.86h2.8l.2 1.47a14.84 14.84 0 0 1 3.48-1.74zM103.88 73.11h-2.72l-.24-.9A7.25 7.25 0 0 1 97 73.38c-2.42 0-3.45-1.66-3.45-3.94 0-2.69 1.17-3.73 3.86-3.73h3.18v-1.39c0-1.47-.41-2-2.53-2a18.51 18.51 0 0 0-3.67.41L94 60.22a17.28 17.28 0 0 1 4.54-.63c4.16 0 5.39 1.47 5.39 4.79zm-3.32-5h-2.45c-1.09 0-1.39.3-1.39 1.31s.3 1.33 1.33 1.33a5.22 5.22 0 0 0 2.5-.68zM113.75 73.11v-9.25c0-.71-.3-1.06-1.06-1.06a9.15 9.15 0 0 0-3.45 1.12v9.19h-3.32V59.86h2.53l.33 1.12a13.27 13.27 0 0 1 5.3-1.39c2.2 0 3 1.55 3 3.92v9.6zM126.84 72.87a9.2 9.2 0 0 1-2.91.52c-2.42 0-3.64-1.14-3.64-3.51V62.5h-2v-2.64h2v-3.29l3.32-.46v3.75H127l-.22 2.64h-3.18v6.94a1 1 0 0 0 1.2 1.17 6.38 6.38 0 0 0 1.66-.27zM33.86 52.74v-3.11l-7.47 4.35v2.62l-5.97 12.89-2.99 2.06v9.44l6.4-3.69 10.03-24.56zM17.43 64.83l-4.48-10.46v-2.95l-.03-.02-4.45 2.58v2.62l5.97 13.46 2.99-1.48v-3.75z\"/><path d=\"M29.38 47.02l-7.47 4.37v2.98l-4.48 10.46v3.49l-2.99 1.74L8.47 56.6v-2.63l4.48-2.58-7.47-4.37L1 49.63v3.21l10.08 24.49 6.35 3.66v-9.2l2.99-1.73-.04-.03 6.01-13.43v-2.63l7.47-4.34-4.48-2.61z\"/></svg>"

/***/ }),

/***/ "../src/components/vagrant/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VagrantPlainWordmark = __webpack_require__("../src/components/vagrant/plain-wordmark/VagrantPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VagrantPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vagrant/plain/VagrantPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VagrantPlain = __webpack_require__("../src/components/vagrant/plain/VagrantPlain.svg");
	
	var _VagrantPlain2 = _interopRequireDefault(_VagrantPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VagrantPlain */
	function VagrantPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VagrantPlain',
	    svg: _VagrantPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VagrantPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VagrantPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vagrant/plain/VagrantPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><title>Artboard 14</title><path d=\"M122.51 23.9V12.82l-26.6 15.47v9.35L74.64 83.55l-10.65 7.33v33.61l22.81-13.15 35.71-87.44zM63.99 66.94L48.04 29.71V19.18l-.11-.05-15.85 9.16v9.35l21.28 47.92 10.63-5.26V66.94z\"/><path d=\"M106.56 3.51L79.97 19.08l-.02-.01V29.71L63.99 66.94v12.45l-10.63 6.17-21.28-47.92v-9.37l15.97-9.18-26.6-15.58-15.96 9.31v11.41l35.91 87.21 22.59 13.05V91.73l10.65-6.17-.14-.08 21.41-47.84v-9.35l.01-.02 26.59-15.45-15.95-9.31z\"/></svg>"

/***/ }),

/***/ "../src/components/vagrant/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VagrantPlain = __webpack_require__("../src/components/vagrant/plain/VagrantPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VagrantPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vim/original/VimOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VimOriginal = __webpack_require__("../src/components/vim/original/VimOriginal.svg");
	
	var _VimOriginal2 = _interopRequireDefault(_VimOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VimOriginal */
	function VimOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VimOriginal',
	    svg: _VimOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VimOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VimOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vim/original/VimOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><path fill=\"#019833\" d=\"M64.461 7.136L8.529 63.173l55.779 55.898 56.085-56.037L64.461 7.136z\"/><path d=\"M64.308 119.211L8.376 63.174l.153-.139L64.614 6.858l55.932 56.037-.153.139-56.085 56.177zM8.682 63.174l55.626 55.759 55.932-55.898L64.614 7.276 8.682 63.174z\"/><path fill=\"#66FE98\" d=\"M64.308 7.275V2.396L3.319 63.452h5.21L64.308 7.275z\"/><path d=\"M8.529 63.452H3.012l.153-.139L64.307 2.118v5.158L8.528 63.453zm-4.904-.139h4.75L64.154 7.276v-4.6L3.625 63.314z\"/><path fill=\"#45FE02\" d=\"M64.154 7.275V2.396l60.989 61.056h-5.21L64.154 7.275z\"/><path d=\"M125.297 63.452h-5.517L64.001 7.415V2.257l.153.139 61.142 61.056zm-5.363-.139h4.75L64.308 2.675v4.6l55.626 56.037z\"/><path fill=\"#017D17\" d=\"M64.308 119.35v4.879L3.319 63.313h5.21l55.779 56.037z\"/><path d=\"M64.308 124.508l-.153-.139L3.013 63.174H8.53l55.779 56.177v5.158zM3.625 63.313l60.529 60.638v-4.6L8.375 63.314h-4.75z\"/><path d=\"M33.507 112.659H21.708l-4.597-2.649V22.608h-3.678l-3.065-3.067V9.923l3.218-3.485h41.221l3.678 3.764v9.061l-3.065 3.764h-3.065v28.995l29.269-28.995h-1.686l-3.371-3.624V9.785l3.371-3.067h41.528l3.218 3.346v9.061L33.507 112.66zm-10.573-4.461h8.735l88.725-91.026v-5.436l-.613-.697H81.625l-.613.558v5.855l.919.976h10.573L47.912 62.477V18.428h5.517l.766-.836v-5.576l-1.073-1.115H15.578l-.766.836v5.994l.46.558h6.436v89.074l1.226.836z\"/><path fill=\"#005D04\" d=\"M64.154 119.35v4.879l60.989-61.056h-5.21L64.154 119.35z\"/><path d=\"M64.001 124.508v-5.158l55.779-56.177h5.517l-.153.139-61.142 61.195zm.306-5.158v4.6l60.529-60.638h-4.75l-55.779 56.037z\"/><path d=\"M63.848 125.065L1.94 63.173 64.002 1.002l61.908 61.892-62.062 62.171zM3.932 63.173l59.916 60.08 60.223-60.219-59.916-60.08L3.932 63.173z\"/><path fill=\"#FEFEFE\" d=\"M54.347 12.294l2.145-1.115-2.299-2.23H14.657l-1.992 1.952v7.667l2.299 2.23 1.073-2.23-1.379-1.394v-5.436l1.073-.976h37.85l.766 1.533z\"/><path d=\"M14.965 20.936l-2.452-2.37v-7.667l2.145-2.091h39.689l2.452 2.37-2.452 1.255-.919-1.533h-37.85l-.919.836v5.297l1.379 1.394-1.073 2.509zm-2.145-2.509l2.145 2.091.919-1.952-1.379-1.394v-5.436l1.073-.976h37.85l.919 1.533 1.992-1.115-2.145-2.091H14.658l-1.992 1.952v7.388z\"/><path d=\"M30.748 108.895h-7.509l-1.226-1.255V18.566h-6.436l-1.379-1.255v-5.436l1.226-1.255h37.544l1.379 1.115v5.297l-1.532 1.533h-7.049v47.952l42.6-43.213v-4.739H81.93l-1.226-1.255v-5.297l1.532-1.533h36.931l1.532 1.533v4.182l-89.951 92.699zm-7.355-.139h7.355l89.645-92.699v-4.043l-1.379-1.394H82.39l-1.379 1.394v5.018l1.226 1.115h6.589v5.158l-43.06 43.771V18.287h7.202l1.379-1.394v-5.158l-1.226-.976H15.577l-1.226 1.115v5.158l1.226 1.115h6.589v89.214l1.226 1.394z\"/><path fill=\"#FEFEFE\" d=\"M22.014 18.288v89.214l1.226 1.255-.919 1.673-2.605-2.509V20.659l2.299-2.37z\"/><path d=\"M22.32 110.847l-2.758-2.649V20.657l2.605-2.509v89.493l1.226 1.394-1.073 1.812zm-2.452-2.788l2.452 2.37.766-1.533-1.073-1.255V18.567l-2.145 2.091v87.402z\"/><path fill=\"gray\" d=\"M15.731 18.288l-.613 2.091h4.75l2.605-2.091H15.73z\"/><path d=\"M19.868 20.657h-4.904l.766-2.37h7.202l-3.065 2.37zm-4.75-.279h4.597l2.299-1.952h-6.436l-.46 1.952z\"/><g><path fill=\"#FEFEFE\" d=\"M81.47 20.797l1.073-2.23-1.532-1.394v-4.739l1.686-1.812h36.471l1.379 1.812 1.992-1.394-1.992-2.091H81.318l-1.992 1.952v7.667l2.145 2.23M49.597 57.459l-3.831 9.2 43.06-43.213v-5.158l-39.229 39.17z\"/><path d=\"M45.919 66.937l-.153-.139 3.831-9.34 39.382-39.31v5.436l-43.06 43.352zm3.831-9.34l-3.524 8.782 42.6-42.795v-4.879L49.75 57.597zm31.72-36.801l-.153-.139-1.992-1.952v-7.806l1.992-2.091h39.382l2.145 2.37-2.145 1.533-1.379-1.952H82.696l-1.686 1.673v4.739l1.532 1.394-1.073 2.23zm-1.992-2.091l1.992 1.812.919-1.952-1.532-1.394v-4.879l1.839-1.812h36.624l1.379 1.812 1.839-1.255-1.992-1.952H81.317l-1.839 1.952v7.667z\"/></g><g><path fill=\"gray\" d=\"M54.194 12.015l1.839-1.255v7.527l-2.145 2.23h-4.291v37.08l-3.831 9.2v-48.51h7.049l1.379-1.115v-5.158z\"/><path d=\"M45.919 66.798h-.153v-48.51h7.202l1.226-.976v-5.158l2.145-1.394v7.806l-2.299 2.23h-4.137v36.94l-3.984 9.061zm0-48.371V66.24l3.678-8.643V20.378h4.291l2.145-2.091v-7.249l-1.686 1.115v5.158l-1.379 1.115h-7.049z\"/></g><g><path xlink:href=\"#path3620\" fill=\"#ccc\" d=\"M82.39 10.621l-1.379 1.394v5.158l1.226 1.255h6.436v5.018L45.766 66.798V18.427h7.049l1.532-1.394v-5.158l-1.379-.976h-37.39l-1.226 1.255v5.297l1.226 1.255h6.589v89.074l1.226 1.255h7.355l89.798-92.699v-4.043l-1.379-1.394H82.39z\"/><path d=\"M30.748 108.895h-7.509l-1.226-1.255V18.566h-6.436l-1.379-1.255v-5.436l1.226-1.255h37.544l1.379 1.115v5.297l-1.532 1.533h-7.049v47.952l42.6-43.213v-4.739H81.93l-1.226-1.255v-5.297l1.532-1.533h36.931l1.532 1.533v4.182l-89.951 92.699zm-7.355-.139h7.355l89.645-92.699v-4.043l-1.379-1.394H82.39l-1.379 1.394v5.018l1.226 1.115h6.589v5.158l-43.06 43.771V18.287h7.202l1.379-1.394v-5.158l-1.226-.976H15.577l-1.226 1.115v5.158l1.226 1.115h6.589v89.214l1.226 1.394z\"/></g><g><path fill=\"gray\" d=\"M120.7 12.154l1.992-1.115v7.109l-90.411 92.559h-9.654l.919-1.812h7.355l89.645-92.699.153-4.043z\"/><path d=\"M32.281 110.847h-9.807l1.073-2.091h7.355l89.491-92.559.153-4.043 2.145-1.255v7.527l-90.411 92.42zm-9.501-.279h9.348l90.411-92.42v-6.97l-1.839.976-.153 4.043-89.645 92.838h-7.355l-.766 1.533z\"/></g><g><path fill=\"gray\" d=\"M88.673 18.427l-1.992 2.091h-5.21l1.226-2.091h5.976z\"/><path d=\"M86.681 20.657h-5.517l1.379-2.37h6.436l-2.299 2.37zm-5.057-.139h5.057l1.839-1.952h-5.67l-1.226 1.952z\"/></g><g><path fill=\"#ccc\" d=\"M67.219 70.561s-.153 0-.153.139l-1.686 1.533-.153.139-1.686 4.879c0 .139 0 .279.153.418l1.379 1.394c.153.139.153.139.306.139h5.363c.153 0 .153 0 .306-.139l1.379-1.394.153-.139 1.532-5.158c0-.139 0-.279-.153-.418l-1.226-1.115c-.153-.139-.153-.139-.306-.139h-5.21v-.139zm-9.961 13.8c-.153 0-.306.139-.306.279l-.613 2.649c0 .279.153.418.306.558h3.371l-7.815 22.303c0 .279 0 .418.306.558H64c.153 0 .306-.139.46-.279l.766-2.37c0-.279 0-.418-.306-.558h-2.758l7.815-22.582c0-.279 0-.418-.306-.558H57.259zm36.318.139c-.153 0-.153 0-.153.139l-2.299 2.649h-3.831l-2.452-2.649c0-.139-.153-.139-.306-.139h-9.194c-.153 0-.306.139-.306.279l-.766 2.509c0 .279 0 .418.306.558h2.605l-7.509 22.164c0 .279 0 .418.306.558h9.807c.153 0 .306-.139.306-.279l.766-2.091c0-.279 0-.418-.306-.558h-1.839l4.75-15.055h8.581l-5.517 17.564c0 .279 0 .418.306.558h9.347c.153 0 .306-.139.306-.279l.766-1.952c.153-.139 0-.418-.153-.558h-1.839l4.904-15.334h8.275l-5.517 17.564c0 .279 0 .418.306.558h10.267c.153 0 .306-.139.306-.279l.766-2.091c0-.279 0-.418-.306-.558h-2.145l6.13-19.934v-.418l-1.839-2.509c-.153-.139-.153-.139-.306-.139h-7.202c-.153 0-.153 0-.306.139l-2.299 2.509h-3.984l-2.299-2.649c-.153-.139-.153-.139-.306-.139h-6.13v-.139z\"/><path d=\"M63.848 111.683h-11.34c-.153 0-.306 0-.46-.139-.766-.279-1.073-.976-.919-1.673l7.355-21.049h-2.145c-.766-.139-1.226-.976-.919-1.673l.613-2.649c.153-.558.46-.836 1.073-.976h12.259c.153 0 .306 0 .46.139.766.279 1.073.976.919 1.673l-7.355 21.328h1.686c.766.279 1.073.976.919 1.673l-.766 2.37c-.306.558-.766.976-1.379.976zM59.864 86.87h1.379l-7.968 22.861h10.267l.46-1.255h-3.218l7.968-23.14H58.025l-.46 1.533h2.299zm53.48 24.534H102.77c-.766-.279-1.073-.976-.919-1.673l5.21-16.309h-6.283l-4.291 13.382h.306c.153 0 .306 0 .46.139.766.279 1.073 1.115.766 1.812l-.766 1.952c-.153.558-.766.836-1.226.836h-9.654c-.766-.279-1.073-.976-.919-1.673l5.21-16.449h-6.743l-4.137 13.103h.306c.153 0 .306 0 .46.139.766.279 1.073.976.919 1.673l-.766 2.23c-.153.558-.766.836-1.226.976h-9.654c-.153 0-.306 0-.46-.139-.766-.279-1.073-.976-.919-1.673l7.049-20.91H74.42c-.153 0-.306 0-.46-.139-.766-.279-1.073-.976-.919-1.673l.766-2.509c.153-.558.766-.976 1.226-.976h9.041c.306 0 .766.139.919.418l2.299 2.37h2.912l2.145-2.37c.153-.279.46-.418.766-.418h6.129c.306 0 .766.139.919.418l2.145 2.23h3.218l1.992-2.23c.306-.279.613-.418.919-.418h7.202c.46 0 .766.139 1.073.558l1.839 2.509c.306.279.306.836.153 1.255l-5.67 18.679h.766c.153 0 .306 0 .46.139.766.279 1.073.976.766 1.673l-.766 2.23c.153.418-.306.836-.919.836zM77.026 86.87h1.379l-7.662 22.582h8.428l.306-1.115h-2.145l5.363-17.006h10.573l-5.67 18.122h8.122l.306-.836h-2.145l5.517-17.146h10.267l-5.67 18.122h9.041l.46-1.115h-2.452l6.436-20.91-1.532-2.091h-6.743l-2.452 2.649h-4.904l-2.452-2.788h-5.363l-2.452 2.788h-4.597l-2.605-2.788h-8.428l-.46 1.394h1.532zm-6.589-6.83h-5.363c-.306 0-.766-.139-.919-.418l-1.379-1.394c-.306-.418-.46-.976-.306-1.394l1.686-4.879c0-.279.153-.418.306-.558l1.686-1.533c.153-.139.306-.279.613-.279h5.21c.306 0 .613.139.919.418l1.226 1.115c.306.279.46.836.306 1.394L72.89 77.67c0 .279-.153.418-.306.558l-1.379 1.394c0 .279-.46.418-.766.418zm-5.976-2.788l.919.976h4.904l1.073-1.115 1.379-4.739-.766-.697h-4.597l-1.532 1.255-1.379 4.321z\"/></g><g><path fill=\"#ccc\" d=\"M67.219 70.98l-1.686 1.533-1.686 4.879 1.379 1.394h5.363l1.379-1.394 1.532-5.158-1.226-1.115h-5.057zm-9.807 13.8l-.613 2.649h3.678l-7.968 22.861h11.34l.766-2.37H61.55l7.968-23.14H57.412zm36.164 0l-2.452 2.788h-4.137l-2.605-2.788h-9.041l-.766 2.509h2.912l-7.662 22.582h9.654l.766-2.091h-2.299l5.057-15.752h9.501l-5.67 17.982h9.194l.766-1.952h-2.299l5.057-16.17h9.041l-5.67 18.122h10.114l.766-2.091h-2.605l6.283-20.352-1.839-2.509h-7.202l-2.452 2.649h-4.444l-2.452-2.788h-5.517z\"/><path d=\"M64.001 110.429H52.355l7.968-22.861h-3.678l.766-2.927H69.67l-8.122 23.14h3.065L64 110.43zm-11.34-.279h11.186l.613-2.23h-3.065l7.815-23H57.564l-.613 2.37h3.678l-7.968 22.861zm60.836 0h-10.42l5.67-18.122h-8.888l-5.057 15.891h2.299l-.919 2.23h-9.501l5.67-17.982h-9.194l-4.904 15.612h2.299l-.766 2.37h-9.807l7.662-22.582h-2.912l.919-2.649h9.194l2.605 2.788h3.984l2.452-2.788h5.976l2.452 2.788h4.291l2.452-2.649h7.355l1.992 2.649-6.283 20.213h2.605l-1.226 2.23zm-10.114-.279h9.961l.766-1.952h-2.605l6.283-20.491-1.839-2.509h-7.202l-2.452 2.649h-4.444l-2.452-2.788h-5.67l-2.452 2.788h-4.291l-2.605-2.788h-8.888l-.766 2.23h2.912l-7.662 22.582h9.348l.613-1.952h-2.299l5.057-16.031h9.807l-5.67 17.982h9.041l.766-1.812h-2.145l5.21-16.309h9.348l-5.67 18.4zM70.437 78.786H64.92l-1.379-1.394 1.839-5.018 1.839-1.533h5.057l1.226 1.255-1.532 5.158-1.532 1.533zm-5.363-.139h5.21l1.379-1.394 1.532-5.018-1.073-1.115h-4.904l-1.686 1.394-1.686 4.739 1.226 1.394z\"/></g></svg>"

/***/ }),

/***/ "../src/components/vim/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VimOriginal = __webpack_require__("../src/components/vim/original/VimOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VimOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vim/plain/VimPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VimPlain = __webpack_require__("../src/components/vim/plain/VimPlain.svg");
	
	var _VimPlain2 = _interopRequireDefault(_VimPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VimPlain */
	function VimPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VimPlain',
	    svg: _VimPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VimPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VimPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vim/plain/VimPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#179A33\" d=\"M72.6 80.5c.2.2.6.5.9.5h5.3c.3 0 .7-.3.9-.5l1.4-1.5c.2-.2.3-.4.3-.6l1.5-5.1c.1-.5 0-1-.3-1.3l-1.1-.9c-.2-.2-.6-.1-.9-.1h-4.8l-.2-.2-.1-.1c-.2 0-.4-.1-.6.1L73 72c-.2 0-.3.5-.4.7L71 77.6c-.2.5-.1 1.1.3 1.5l1.3 1.4zm.8 26.4l-.4.1h-1.2L79 85.9c.2-.7-.1-1.5-.8-1.7l-.4-.1H65.7c-.5.1-.9.5-1 1l-.7 2.5c-.2.7.3 1.3 1 1.5l.3-.1h1.8l-7.3 20.9c-.2.7.1 1.6.8 1.9l.4.3h11.2c.6 0 1.1-.5 1.3-1.1l.7-2.4c.3-.7-.1-1.5-.8-1.7zm53.1-19.7l-1.9-2.5v-.1c-.3-.3-.6-.6-1-.6h-7.2c-.4 0-.7.4-1 .6l-2 2.4h-3.1l-2.1-2.4v-.1c-.2-.3-.6-.5-1-.5h-4l20.2-20.2-22.6-22.4L121 20.6v-9L118.2 8H77.3L74 11.5v2.9L62.7 3 55 10.5 52.6 8H12.2L9 11.7v9.4l3 2.9h3v26.1l-14 14 14 14v32l5.2 2.9h11.6l9.1-9.5 21.6 21.6L77 110.6c.1.4.4.5.9.7l.4-.2h9.4c.6 0 1.1-.1 1.2-.6l.7-2c.2-.7-.1-1.3-.8-1.5l-.4.1H88l3.4-10.7 2.3-2.3h5l-5 15.9c-.2.7.2 1.1.9 1.4l.4-.2h9.1c.5 0 1-.1 1.2-.6l.8-1.8c.3-.7-.1-1.3-.7-1.6-.1-.1-.3 0-.5 0h-.4l4.2-13h6.1l-5.1 15.9c-.2.7.2 1.1.9 1.3l.4-.3h10c.5 0 1-.1 1.2-.6l.8-2c.3-.7-.1-1.3-.8-1.5-.1-.1-.3.1-.5.1h-.7l5.6-18.5c.2-.5.1-1.1-.1-1.4zM62.7 4.9L74 16.2v4.7l3.4 4.1H79L50 53V25h3.3l2.7-4.2v-8.9l-.2-.3 6.9-6.7zM2.9 64.1L15 52v24.2L2.9 64.1zm38.9 38.3l58.4-60 21.4 21.5-20.2 20.2h-.1c-.3.1-.5.3-.7.5L98.5 87h-2.9l-2.2-2.4c-.2-.3-.6-.6-1-.6h-8.8c-.6 0-1.1.4-1.3 1l-.8 2.5c-.2.7.1 1.3.8 1.6h1.5L77.4 108l-15.1 15.2-20.5-20.8z\"/></svg>"

/***/ }),

/***/ "../src/components/vim/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VimPlain = __webpack_require__("../src/components/vim/plain/VimPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VimPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/visualstudio/plain-wordmark/VisualstudioPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VisualstudioPlainWordmark = __webpack_require__("../src/components/visualstudio/plain-wordmark/VisualstudioPlainWordmark.svg");
	
	var _VisualstudioPlainWordmark2 = _interopRequireDefault(_VisualstudioPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VisualstudioPlainWordmark */
	function VisualstudioPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VisualstudioPlainWordmark',
	    svg: _VisualstudioPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VisualstudioPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VisualstudioPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/visualstudio/plain-wordmark/VisualstudioPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.a{fill:#68217a}.b{isolation:isolate}</style></defs><title>visualstudio</title><path class=\"a\" d=\"M17.6 53.27l5.31 2.14v17.18l-5.36 2.14L9 66.26l-5.4 4.19-2.12-1.07V58.62l2.14-1L9 61.83zm-14 7.55v6.52L6.84 64zM12 64l5.55 4.38v-8.74z\"/><g class=\"b\"><path class=\"a\" d=\"M40.53 57.52l-4.79 12.94h-1.67l-4.7-12.94h1.69l3.58 10.26a6.13 6.13 0 0 1 .26 1.15 5.6 5.6 0 0 1 .3-1.16l3.7-10.25zm1.87 1.35M42.4 58.87a.94.94 0 0 1-.68-.27.91.91 0 0 1-.28-.69.95.95 0 0 1 1-1 1 1 0 0 1 .69.28 1 1 0 0 1 0 1.37 1 1 0 0 1-.73.31zm.72 11.59h-1.48v-9.24h1.48zM45 70.13v-1.59a4.38 4.38 0 0 0 2.66.89q2 0 2-1.3a1.12 1.12 0 0 0-.17-.63A1.65 1.65 0 0 0 49 67a3.42 3.42 0 0 0-.67-.36l-.83-.33a10.58 10.58 0 0 1-1.08-.49 3.27 3.27 0 0 1-.78-.56 2.08 2.08 0 0 1-.47-.71 2.51 2.51 0 0 1-.16-.93 2.21 2.21 0 0 1 .3-1.15 2.65 2.65 0 0 1 .79-.84 3.73 3.73 0 0 1 1.13-.51 5 5 0 0 1 1.33-.12 5.31 5.31 0 0 1 2.15.41v1.5a4.18 4.18 0 0 0-2.35-.67 2.73 2.73 0 0 0-.75.09 1.83 1.83 0 0 0-.57.27 1.24 1.24 0 0 0-.37.41 1.09 1.09 0 0 0-.13.53 1.27 1.27 0 0 0 .13.61 1.34 1.34 0 0 0 .38.43 3 3 0 0 0 .61.34l.82.33a11.32 11.32 0 0 1 1.1.48 3.81 3.81 0 0 1 .83.56 2.21 2.21 0 0 1 .53.72 2.31 2.31 0 0 1 .18 1 2.27 2.27 0 0 1-.3 1.19 2.59 2.59 0 0 1-.82.8 3.7 3.7 0 0 1-1.16.5 5.76 5.76 0 0 1-1.38.16 5.22 5.22 0 0 1-2.46-.53zM60.33 70.46h-1.49V69A3 3 0 0 1 56 70.68q-3.3 0-3.3-3.94v-5.52h1.47v5.29q0 2.92 2.24 2.92a2.27 2.27 0 0 0 1.78-.8 3.06 3.06 0 0 0 .7-2.09v-5.32h1.48zM69.38 70.46H67.9V69a3.1 3.1 0 0 1-2.9 1.68 3 3 0 0 1-2.16-.73 2.53 2.53 0 0 1-.77-1.95q0-2.59 3.05-3l2.77-.39q0-2.36-1.9-2.36a4.55 4.55 0 0 0-3 1.14v-1.52a5.72 5.72 0 0 1 3.13-.87q3.26 0 3.26 3.45zm-1.48-4.68l-2.23.31a3.61 3.61 0 0 0-1.55.51 1.47 1.47 0 0 0-.52 1.3 1.41 1.41 0 0 0 .47 1.1 1.86 1.86 0 0 0 1.29.43 2.38 2.38 0 0 0 1.82-.77 2.76 2.76 0 0 0 .72-2zM73.09 70.46h-1.48V56.78h1.48z\"/></g><g class=\"b\"><path class=\"a\" d=\"M77.72 69.94v-1.79a3.43 3.43 0 0 0 .73.49 5.9 5.9 0 0 0 .9.37 7.25 7.25 0 0 0 1 .23 5.3 5.3 0 0 0 .88.08 3.46 3.46 0 0 0 2.09-.52 1.95 1.95 0 0 0 .46-2.41 2.58 2.58 0 0 0-.64-.71 6.3 6.3 0 0 0-1-.61l-1.2-.62q-.68-.34-1.26-.7a5.5 5.5 0 0 1-1-.78A3.26 3.26 0 0 1 78 62a3.28 3.28 0 0 1 .14-2.8 3.34 3.34 0 0 1 1-1.08 4.63 4.63 0 0 1 1.44-.63 6.58 6.58 0 0 1 1.65-.21 6.3 6.3 0 0 1 2.79.46v1.71a5.06 5.06 0 0 0-2.94-.79 4.87 4.87 0 0 0-1 .1 2.8 2.8 0 0 0-.88.34 2 2 0 0 0-.63.6 1.61 1.61 0 0 0-.24.9 1.87 1.87 0 0 0 .19.86 2.1 2.1 0 0 0 .55.66 5.37 5.37 0 0 0 .88.58l1.2.61q.69.34 1.32.72a6.05 6.05 0 0 1 1.09.84 3.75 3.75 0 0 1 .74 1 2.85 2.85 0 0 1 .28 1.28 3.26 3.26 0 0 1-.37 1.62 3.07 3.07 0 0 1-1 1.08 4.42 4.42 0 0 1-1.47.6 8 8 0 0 1-1.75.19 7.25 7.25 0 0 1-.76 0c-.3 0-.61-.08-.92-.14a7.65 7.65 0 0 1-.89-.23 2.77 2.77 0 0 1-.7-.33zm13.64.43M91.36 70.37a2.86 2.86 0 0 1-1.38.29q-2.43 0-2.43-2.71v-5.47H86v-1.26h1.59V59l1.41-.52v2.73h2.33v1.26H89v5.21a2.16 2.16 0 0 0 .34 1.32 1.26 1.26 0 0 0 1 .4 1.55 1.55 0 0 0 1-.31zM100.53 70.46h-1.48V69a3 3 0 0 1-2.85 1.68q-3.3 0-3.3-3.94v-5.52h1.47v5.29q0 2.92 2.24 2.92a2.27 2.27 0 0 0 1.78-.8 3.06 3.06 0 0 0 .7-2.09v-5.32h1.48v9.24zM111.13 70.46h-1.48v-1.57a3.42 3.42 0 0 1-3.18 1.79 3.45 3.45 0 0 1-2.79-1.24 5.1 5.1 0 0 1-1-3.38 5.54 5.54 0 0 1 1.16-3.67 3.81 3.81 0 0 1 3-1.39 3 3 0 0 1 2.77 1.5v-5.72h1.48zm-1.48-4.18v-1.36a2.65 2.65 0 0 0-.74-1.9 2.48 2.48 0 0 0-1.88-.78 2.56 2.56 0 0 0-2.13 1 4.35 4.35 0 0 0-.78 2.74 3.91 3.91 0 0 0 .74 2.52 2.43 2.43 0 0 0 2 .92 2.53 2.53 0 0 0 2-.89 3.33 3.33 0 0 0 .79-2.25zM114.61 58.87a.93.93 0 0 1-.68-.27.91.91 0 0 1-.28-.69 1 1 0 0 1 1-1 1 1 0 0 1 .69.28 1 1 0 0 1 0 1.37 1 1 0 0 1-.73.31zm.72 11.59h-1.48v-9.24h1.48zM121.91 70.68a4.29 4.29 0 0 1-3.27-1.3 4.8 4.8 0 0 1-1.22-3.43 5 5 0 0 1 1.27-3.64 4.58 4.58 0 0 1 3.44-1.31 4.14 4.14 0 0 1 3.23 1.27 5 5 0 0 1 1.16 3.53 5 5 0 0 1-1.25 3.54 4.38 4.38 0 0 1-3.36 1.34zm.11-8.43a2.82 2.82 0 0 0-2.26 1 4 4 0 0 0-.83 2.68 3.77 3.77 0 0 0 .84 2.59 2.85 2.85 0 0 0 2.25.95 2.71 2.71 0 0 0 2.21-.93 4 4 0 0 0 .77-2.64 4.11 4.11 0 0 0-.77-2.67 2.69 2.69 0 0 0-2.23-.98z\"/></g></svg>"

/***/ }),

/***/ "../src/components/visualstudio/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VisualstudioPlainWordmark = __webpack_require__("../src/components/visualstudio/plain-wordmark/VisualstudioPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VisualstudioPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/visualstudio/plain/VisualstudioPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VisualstudioPlain = __webpack_require__("../src/components/visualstudio/plain/VisualstudioPlain.svg");
	
	var _VisualstudioPlain2 = _interopRequireDefault(_VisualstudioPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VisualstudioPlain */
	function VisualstudioPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VisualstudioPlain',
	    svg: _VisualstudioPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VisualstudioPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VisualstudioPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/visualstudio/plain/VisualstudioPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.a{fill:#68217a}</style></defs><title>visualstudio-plain</title><path class=\"a\" d=\"M95 2.3l30.5 12.3v98.7l-30.7 12.4-49-48.7-31 24.1-12.3-6.2V33.1l12.3-5.9 31 24.3zM14.8 45.7v37.5l18.5-19zm48.1 18.5l31.9 25.1V39z\"/></svg>"

/***/ }),

/***/ "../src/components/visualstudio/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VisualstudioPlain = __webpack_require__("../src/components/visualstudio/plain/VisualstudioPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VisualstudioPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vuejs/line-wordmark/VuejsLineWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VuejsLineWordmark = __webpack_require__("../src/components/vuejs/line-wordmark/VuejsLineWordmark.svg");
	
	var _VuejsLineWordmark2 = _interopRequireDefault(_VuejsLineWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VuejsLineWordmark */
	function VuejsLineWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VuejsLineWordmark',
	    svg: _VuejsLineWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VuejsLineWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VuejsLineWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vuejs/line-wordmark/VuejsLineWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"128\" viewBox=\"0 0 128 128\" width=\"128\"><path d=\"M7.941 0L51.61.139l12.525 21.385L76.66.139 120.06.001 64.145 96.465zm111.23.558L97.825.577 64.127 58.433 30.447.573 8.766.558l55.368 94.5zM97.143.551L77.22.698 64.134 22.626 51.05.698 31.084.552l33.05 56.479z\" fill=\"#35495e\"/><path d=\"M31.393 97.211a1.94 1.94 0 0 0-1.072.322c-.325.215-.623.586-.623 1.059 0 .063-.035.201.086.443l-.032-.076 6.573 21.318c.116.397.394.701.709.875.314.174.66.24.996.24.714 0 1.497-.341 1.736-1.107l6.565-21.398v-.074c0 .103.03.04.03-.19 0-.48-.306-.835-.636-1.058a2.002 2.002 0 0 0-1.121-.354c-.498 0-1.068.302-1.26.877l-.004.006-5.312 17.729-5.333-17.705c-.078-.312-.287-.573-.532-.719s-.513-.195-.771-.195zm52.337 1.101c-1.04 0-1.916.794-1.916 1.79 0 .994.863 1.82 1.916 1.82 1.033 0 1.852-.841 1.852-1.82 0-.98-.833-1.79-1.852-1.79zm-15.408 6.824c-3.57 0-6.508 2.855-6.508 6.287v3.524c0 1.923.767 3.571 2.067 4.709s3.113 1.767 5.195 1.767c1.538 0 2.792-.345 3.687-.812.448-.234.808-.497 1.073-.781.264-.285.459-.596.459-.983 0-.355-.14-.663-.362-.941-.222-.278-.57-.533-1.02-.533-.324 0-.574.135-.792.269s-.424.283-.672.426c-.495.285-1.15.562-2.309.562-1.289 0-2.367-.368-3.109-.986s-1.172-1.479-1.172-2.603v-.665h6.608c.703 0 1.483.002 2.156-.427.672-.43 1.08-1.284 1.08-2.588 0-3.611-3.011-6.225-6.381-6.225zm24.793 0c-1.898 0-3.292.613-4.187 1.535-.896.922-1.282 2.121-1.282 3.243 0 1.429.576 2.45 1.403 3.107.826.656 1.857.987 2.838 1.283.98.296 1.92.56 2.552.95.633.39.975.815.975 1.706 0 .48-.145.862-.535 1.174-.39.313-1.08.559-2.203.559-1.329 0-2.075-.33-2.616-.664-.27-.168-.487-.34-.71-.494-.224-.155-.476-.32-.827-.32-.422 0-.733.26-.924.53-.19.271-.298.58-.298.913 0 .41.199.772.484 1.088.285.315.67.596 1.144.841.949.492 2.256.836 3.81.836 1.685 0 3.07-.412 4.05-1.209.98-.797 1.514-1.982 1.514-3.35 0-1.544-.563-2.65-1.39-3.384-.826-.733-1.87-1.113-2.864-1.418-.995-.305-1.955-.542-2.598-.877-.643-.336-.95-.65-.95-1.365 0-.388.156-.874.55-1.258.393-.384 1.033-.695 2.095-.695.849 0 1.482.196 1.987.402.252.103.47.21.677.299.208.09.399.18.67.18.491 0 .828-.327 1.03-.63.201-.302.32-.601.32-.94 0-.426-.266-.728-.56-.956-.296-.228-.666-.41-1.096-.568-.86-.315-1.958-.518-3.059-.518zm-44.957.19c-.826 0-1.54.518-1.54 1.285v8.398c0 3.4 2.892 6.414 6.478 6.414 3.524 0 6.476-2.978 6.476-6.414v-8.43c0-.383-.21-.715-.488-.927a1.668 1.668 0 0 0-1.018-.326c-.385 0-.743.113-1.027.32-.284.207-.512.537-.512.934v8.43c0 1.792-1.56 3.525-3.431 3.525-1.902 0-3.432-1.763-3.432-3.526v-8.398c0-.397-.218-.705-.488-.924s-.623-.361-1.018-.361zm35.572 0c-.387 0-.746.098-1.03.312a1.203 1.203 0 0 0-.478.942v15.475c0 1.161-.08 2.137-.336 2.73s-.564.86-1.427.86c-.754 0-1.381.654-1.381 1.443 0 .327.105.687.373.967.267.28.682.445 1.164.445 1.63 0 2.876-.722 3.619-1.897.743-1.174 1.033-2.747 1.033-4.548V106.58c0-.4-.228-.744-.517-.95s-.644-.304-1.02-.304zm-15.439 2.51c2.048 0 3.432 1.715 3.432 3.462 0 .19-.021.317-.041.375s-.02.054-.051.075c-.061.04-.377.119-.98.119h-5.792v-.696c0-1.828 1.527-3.336 3.432-3.336zm9.75 9.63c-1.108 0-1.947.917-1.947 1.979 0 1.019.826 1.947 1.947 1.947 1.06 0 1.914-.9 1.914-1.947 0-1.087-.867-1.979-1.914-1.979z\" stroke-width=\"0\" fill=\"#35495e\" style=\"block-progression:tb;isolation:auto;mix-blend-mode:normal;text-decoration-color:#000;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-transform:none\" white-space=\"normal\"/></svg>"

/***/ }),

/***/ "../src/components/vuejs/line-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VuejsLineWordmark = __webpack_require__("../src/components/vuejs/line-wordmark/VuejsLineWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VuejsLineWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vuejs/line/VuejsLine.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VuejsLine = __webpack_require__("../src/components/vuejs/line/VuejsLine.svg");
	
	var _VuejsLine2 = _interopRequireDefault(_VuejsLine);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VuejsLine */
	function VuejsLine(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VuejsLine',
	    svg: _VuejsLine2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VuejsLine.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VuejsLine;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vuejs/line/VuejsLine.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"128\" viewBox=\"0 0 128 128\" width=\"128\"><path fill=\"#35495e\" d=\"M0 8.934l49.854.158 14.299 24.415 14.3-24.415L128 8.935l-63.834 110.14zm126.98.637l-24.36.02-38.476 66.053L25.691 9.592.942 9.572l63.211 107.89zm-25.14-.008l-22.749.168-14.938 25.033L49.215 9.73l-22.794-.168 37.731 64.476z\"/></svg>"

/***/ }),

/***/ "../src/components/vuejs/line/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VuejsLine = __webpack_require__("../src/components/vuejs/line/VuejsLine.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VuejsLine).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vuejs/original-wordmark/VuejsOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VuejsOriginalWordmark = __webpack_require__("../src/components/vuejs/original-wordmark/VuejsOriginalWordmark.svg");
	
	var _VuejsOriginalWordmark2 = _interopRequireDefault(_VuejsOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VuejsOriginalWordmark */
	function VuejsOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VuejsOriginalWordmark',
	    svg: _VuejsOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VuejsOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VuejsOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vuejs/original-wordmark/VuejsOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"128\" viewBox=\"0 0 128 128\" width=\"128\"><path d=\"M32.191 97.953a1.91 1.91 0 0 0-1.055.316c-.319.211-.611.575-.611 1.041 0 .062-.036.2.084.44l-.031-.076 6.41 20.797c.115.39.39.688.7.86s.648.235.978.235c.7 0 1.47-.334 1.705-1.088v-.002l6.404-20.875v-.076c0 .106.031.045.031-.183 0-.475-.303-.824-.627-1.043a1.966 1.966 0 0 0-1.101-.346c-.49 0-1.052.297-1.24.863l-.004.006-5.17 17.254-5.19-17.223c-.077-.308-.284-.565-.525-.709s-.504-.191-.758-.191zm51.055 1.072c-1.02 0-1.88.782-1.88 1.76s.846 1.787 1.88 1.787c1.014 0 1.82-.824 1.82-1.787s-.82-1.76-1.82-1.76zm-15.029 6.658c-3.488 0-6.361 2.792-6.361 6.147v3.438c0 1.879.748 3.49 2.02 4.601 1.27 1.112 3.044 1.727 5.077 1.727 1.502 0 2.727-.337 3.602-.793.438-.229.79-.485 1.049-.764.26-.28.45-.585.45-.967 0-.35-.134-.654-.353-.927-.218-.273-.562-.524-1.006-.524-.32 0-.566.135-.779.266-.213.13-.413.275-.654.414-.482.277-1.12.547-2.248.547-1.256 0-2.302-.358-3.024-.96-.72-.6-1.14-1.435-1.14-2.529v-.636h6.435c.687 0 1.45 0 2.11-.42.66-.422 1.06-1.26 1.06-2.533 0-3.53-2.944-6.086-6.238-6.086zm24.186 0c-1.854 0-3.218.6-4.094 1.502-.876.902-1.254 2.076-1.254 3.172 0 1.398.565 2.4 1.373 3.041.809.643 1.815.966 2.772 1.254.957.289 1.873.545 2.488.924.615.38.945.789.945 1.654 0 .465-.14.835-.517 1.137-.378.303-1.05.541-2.143.541-1.293 0-2.016-.319-2.543-.644-.263-.163-.475-.332-.693-.483s-.466-.314-.813-.314c-.417 0-.725.257-.912.523a1.546 1.546 0 0 0-.295.897c0 .405.198.761.477 1.07.28.309.657.584 1.121.824.927.48 2.204.815 3.72.815 1.647 0 3.001-.402 3.96-1.182.958-.78 1.48-1.939 1.48-3.275 0-1.51-.549-2.595-1.357-3.313-.809-.717-1.83-1.087-2.801-1.385-.971-.297-1.906-.529-2.531-.855-.626-.326-.92-.627-.92-1.32 0-.375.15-.847.531-1.22.381-.371 1.003-.673 2.037-.673.826 0 1.44.19 1.932.39.246.101.46.206.662.294.203.087.39.173.658.173.485 0 .818-.32 1.016-.617.198-.297.312-.59.312-.926 0-.42-.261-.718-.55-.94s-.653-.402-1.073-.556c-.84-.308-1.912-.507-2.988-.507zm-43.857.186c-.811 0-1.512.509-1.512 1.266v8.193c0 3.324 2.826 6.268 6.33 6.268 3.446 0 6.33-2.91 6.33-6.268v-8.223c0-.378-.208-.707-.482-.916-.274-.208-.622-.32-1-.32s-.728.11-1.008.315c-.28.204-.504.53-.504.921v8.223c0 1.742-1.518 3.428-3.336 3.428-1.847 0-3.335-1.716-3.335-3.428v-8.193c0-.393-.215-.695-.48-.91s-.615-.356-1.003-.356zm34.701 0c-.38 0-.73.098-1.01.309-.28.21-.47.558-.47.927v15.096c0 1.133-.08 2.083-.329 2.659-.248.575-.542.83-1.38.83-.741 0-1.36.647-1.36 1.422 0 .321.104.675.367.95s.672.438 1.145.438c1.594 0 2.814-.707 3.54-1.855.728-1.149 1.01-2.685 1.01-4.444v-15.096c0-.393-.224-.735-.51-.937a1.723 1.723 0 0 0-1.003-.299zm-15.061 2.473c1.991 0 3.336 1.667 3.336 3.365 0 .185-.02.306-.04.361-.018.055-.016.048-.044.067-.055.036-.363.115-.951.115H64.85v-.666c0-1.777 1.485-3.242 3.336-3.242zm9.512 9.37c-1.088 0-1.912.9-1.912 1.942 0 1 .812 1.912 1.912 1.912 1.042 0 1.88-.884 1.88-1.912 0-1.067-.852-1.941-1.88-1.941z\" fill=\"#35495e\" style=\"block-progression:tb;isolation:auto;mix-blend-mode:normal;text-decoration-color:#000;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-transform:none\" white-space=\"normal\"/><path fill=\"none\" d=\"M9.106 0l42.76.136 12.151 20.988L76.396.136 118.893 0 64.142 94.469zm108.912.546L97.124.564 64.123 57.218 31.14.564 9.914.547 64.13 93.086zM96.448.54l-19.51.143-12.91 21.14L51.319.683 31.769.54 64.13 55.841zM31.403.394L51.133.4l12.896 21.407L76.88.403 96.592.398 64.128 56.71\"/><path fill=\"#35495e\" d=\"M31.404.394L51.133.4l12.896 21.407L76.88.403 96.592.398 64.128 56.71z\"/><path fill=\"#41b883\" d=\"M9.887.544l21.5-.146 32.722 56.315L96.575.401l21.537.023-54.007 92.684z\"/></svg>"

/***/ }),

/***/ "../src/components/vuejs/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VuejsOriginalWordmark = __webpack_require__("../src/components/vuejs/original-wordmark/VuejsOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VuejsOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vuejs/original/VuejsOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VuejsOriginal = __webpack_require__("../src/components/vuejs/original/VuejsOriginal.svg");
	
	var _VuejsOriginal2 = _interopRequireDefault(_VuejsOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VuejsOriginal */
	function VuejsOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VuejsOriginal',
	    svg: _VuejsOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VuejsOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VuejsOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vuejs/original/VuejsOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"128\" viewBox=\"0 0 128 128\" width=\"128\"><path d=\"M0 8.934l49.854.158 14.167 24.47 14.432-24.47L128 8.935l-63.834 110.14zm126.98.637l-24.36.02-38.476 66.053L25.691 9.592.942 9.572l63.211 107.89zm-25.149-.008l-22.745.168-15.053 24.647L49.216 9.73l-22.794-.168 37.731 64.476zm-75.834-.17l23.002.009m-23.002-.01l23.002.01\" fill=\"none\"/><path d=\"M25.997 9.393l23.002.009L64.035 34.36 79.018 9.404 102 9.398 64.15 75.053z\" fill=\"#35495e\"/><path d=\"M.91 9.569l25.067-.172 38.15 65.659L101.98 9.401l25.11.026-62.966 108.06z\" fill=\"#41b883\"/></svg>"

/***/ }),

/***/ "../src/components/vuejs/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VuejsOriginal = __webpack_require__("../src/components/vuejs/original/VuejsOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VuejsOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vuejs/plain-wordmark/VuejsPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VuejsPlainWordmark = __webpack_require__("../src/components/vuejs/plain-wordmark/VuejsPlainWordmark.svg");
	
	var _VuejsPlainWordmark2 = _interopRequireDefault(_VuejsPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VuejsPlainWordmark */
	function VuejsPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VuejsPlainWordmark',
	    svg: _VuejsPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VuejsPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VuejsPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vuejs/plain-wordmark/VuejsPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"128\" viewBox=\"0 0 128 128\" width=\"128\"><path d=\"M31.393 97.211c-.375 0-.75.108-1.074.322-.325.215-.621.584-.621 1.057 0 .063-.037.203.084.445l-.03-.076 6.57 21.318c.117.397.395.701.71.875.314.174.662.238.998.238.714 0 1.495-.34 1.734-1.105l.002-.002 6.565-21.396v-.076c0 .103.03.042.03-.188 0-.48-.306-.837-.636-1.06a2 2 0 0 0-1.12-.352c-.498 0-1.07.3-1.263.875l-.002.008-5.312 17.727-5.332-17.697c-.078-.313-.287-.571-.531-.717s-.514-.195-.772-.195zm52.336 1.1c-1.04 0-1.914.794-1.914 1.789 0 .995.861 1.822 1.914 1.822 1.033 0 1.853-.842 1.853-1.822 0-.98-.834-1.79-1.853-1.79zm-15.406 6.826c-3.57 0-6.508 2.855-6.508 6.287v3.521c0 1.923.765 3.572 2.065 4.71 1.3 1.137 3.115 1.767 5.197 1.767 1.538 0 2.792-.343 3.688-.81.447-.234.805-.497 1.07-.782.265-.285.46-.598.46-.984 0-.356-.138-.664-.36-.942-.223-.277-.57-.533-1.02-.533-.325 0-.577.138-.795.272s-.422.281-.67.424c-.495.285-1.152.562-2.31.562-1.29 0-2.366-.366-3.108-.984-.742-.619-1.174-1.48-1.174-2.604v-.664h6.61c.703 0 1.484.002 2.156-.428.672-.429 1.08-1.284 1.08-2.588 0-3.61-3.011-6.224-6.38-6.224zm24.793 0c-1.898 0-3.294.613-4.19 1.535-.895.922-1.28 2.121-1.28 3.242 0 1.43.577 2.451 1.404 3.108.826.656 1.855.987 2.836 1.283.98.296 1.92.56 2.552.949.633.39.977.814.977 1.705 0 .48-.145.862-.535 1.174-.39.312-1.083.56-2.205.56-1.329 0-2.075-.331-2.616-.666-.27-.167-.486-.34-.709-.494-.223-.154-.475-.318-.826-.318-.422 0-.735.26-.926.531-.19.271-.298.58-.298.912 0 .411.199.771.484 1.086.285.315.672.598 1.146.844.949.491 2.254.834 3.807.834 1.686 0 3.071-.412 4.05-1.21.98-.796 1.515-1.98 1.515-3.347 0-1.544-.56-2.653-1.387-3.386-.827-.734-1.872-1.112-2.867-1.416-.995-.305-1.953-.542-2.596-.877-.644-.34-.952-.65-.952-1.37 0-.388.157-.876.55-1.26.394-.384 1.034-.696 2.096-.696.85 0 1.48.198 1.985.405.252.103.472.209.68.299.207.09.398.177.67.177.49 0 .827-.324 1.029-.627.202-.302.32-.601.32-.941 0-.425-.267-.727-.562-.955-.295-.228-.666-.41-1.096-.568-.86-.316-1.956-.518-3.057-.518zm-44.959.187c-.826 0-1.537.521-1.537 1.287v8.399c0 3.4 2.891 6.412 6.476 6.412 3.525 0 6.475-2.977 6.475-6.412v-8.43c0-.384-.208-.718-.486-.93s-.635-.326-1.02-.326a1.73 1.73 0 0 0-1.025.32c-.285.208-.512.54-.512.936v8.43c0 1.793-1.56 3.525-3.431 3.525-1.902 0-3.432-1.763-3.432-3.525v-8.399c0-.397-.218-.705-.488-.923s-.625-.364-1.02-.364zm35.572 0c-.387 0-.746.1-1.03.315s-.476.566-.476.941v15.475c0 1.162-.08 2.138-.336 2.73-.256.594-.566.858-1.43.858-.753 0-1.38.657-1.38 1.445 0 .328.107.685.375.965.267.28.682.447 1.164.447 1.63 0 2.876-.722 3.619-1.896.743-1.174 1.033-2.748 1.033-4.549V106.58c0-.399-.228-.746-.518-.951a1.753 1.753 0 0 0-1.021-.305zm-15.439 2.51c2.048 0 3.432 1.716 3.432 3.463 0 .19-.021.316-.041.375s-.02.054-.051.074c-.061.04-.377.121-.98.121h-5.792v-.695c0-1.829 1.527-3.338 3.432-3.338zm9.75 9.631c-1.109 0-1.945.917-1.945 1.978 0 1.02.824 1.948 1.945 1.948 1.06 0 1.916-.9 1.916-1.948 0-1.087-.87-1.978-1.916-1.978z\" fill=\"#35495e\" style=\"block-progression:tb;isolation:auto;mix-blend-mode:normal;text-decoration-color:#000;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-transform:none\" white-space=\"normal\"/><path fill=\"#35495e\" d=\"M7.941 0L51.61.139l12.523 21.385L76.66.139l43.4-.138-55.914 96.466zm111.23.558L97.827.576 64.127 58.434 30.447.577 8.767.56l55.369 94.5z\"/></svg>"

/***/ }),

/***/ "../src/components/vuejs/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VuejsPlainWordmark = __webpack_require__("../src/components/vuejs/plain-wordmark/VuejsPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VuejsPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vuejs/plain/VuejsPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _VuejsPlain = __webpack_require__("../src/components/vuejs/plain/VuejsPlain.svg");
	
	var _VuejsPlain2 = _interopRequireDefault(_VuejsPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** VuejsPlain */
	function VuejsPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'VuejsPlain',
	    svg: _VuejsPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	VuejsPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = VuejsPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/vuejs/plain/VuejsPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"128\" viewBox=\"0 0 128 128\" width=\"128\"><path fill=\"#35495e\" d=\"M0 8.934l49.854.158 14.3 24.415 14.3-24.415 49.548-.158-63.835 110.134zm126.987.637l-24.37.021-38.473 66.053L25.692 9.592l-24.75-.02 63.212 107.89z\"/></svg>"

/***/ }),

/***/ "../src/components/vuejs/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VuejsPlain = __webpack_require__("../src/components/vuejs/plain/VuejsPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VuejsPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webpack/original-wordmark/WebpackOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _WebpackOriginalWordmark = __webpack_require__("../src/components/webpack/original-wordmark/WebpackOriginalWordmark.svg");
	
	var _WebpackOriginalWordmark2 = _interopRequireDefault(_WebpackOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** WebpackOriginalWordmark */
	function WebpackOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'WebpackOriginalWordmark',
	    svg: _WebpackOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	WebpackOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = WebpackOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webpack/original-wordmark/WebpackOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"angularjs\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#8ed6fb}.cls-2{fill:#1c78c0}</style></defs><title>Artboard 14</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M30.13 72.62l-12.27 6.94v-5.41l7.65-4.21 4.63 2.67zm.84-.76V57.34l-4.49 2.59v9.33l4.52 2.6zm-26.46.76l12.27 6.94v-5.41l-7.65-4.2zm-.84-.76V57.34l4.49 2.59v9.33zM4.2 56.4l12.59-7.12v5.22l-8.07 4.44h-.06zm26.25 0l-12.59-7.12v5.22l8.06 4.43.08.07 4.46-2.57z\"/><path class=\"cls-2\" d=\"M16.78 72.92l-7.54-4.15v-8.22l7.55 4.36zm1.08 0l7.55-4.15v-8.22l-7.55 4.36zM9.75 59.6l7.57-4.16 7.58 4.16-7.58 4.4-7.57-4.4zM48.61 70h3.32l3.38-11.27h-3.23l-2 8-2.14-8h-2.8l-2.16 8-2-8h-3.21L41.13 70h3.32l2.09-7.22zm6.87-5.6a5.62 5.62 0 0 0 5.93 5.88 5.35 5.35 0 0 0 4.74-2.48l-2-1.49a3.29 3.29 0 0 1-2.74 1.38 2.74 2.74 0 0 1-2.93-2.59h7.94v-.65c0-3.68-2-6-5.47-6-3.21 0-5.52 2.54-5.52 5.95zm3.13-1.23a2.39 2.39 0 0 1 2.39-2.3 2.3 2.3 0 0 1 2.41 2.28zm9 6.83h2.8v-1.18a4.39 4.39 0 0 0 3.34 1.44c3.23 0 5.52-2.43 5.52-5.9s-2.11-5.92-5.35-5.92a4.24 4.24 0 0 0-3.34 1.46v-5.5h-3V70zm2.89-5.6c0-2.11 1.25-3.32 2.89-3.32s2.89 1.36 2.89 3.32-1.21 3.25-2.89 3.25a3 3 0 0 1-2.89-3.25zm9.92 9.6h3v-5.2a4.3 4.3 0 0 0 3.34 1.44c3.23 0 5.35-2.43 5.35-5.92s-2.28-5.9-5.52-5.9a4.32 4.32 0 0 0-3.34 1.46v-1.17h-2.8V74zm2.89-9.7a3 3 0 0 1 2.89-3.25c1.68 0 2.89 1.25 2.89 3.25s-1.16 3.32-2.89 3.32-2.89-1.21-2.89-3.32zm9.31 2.18c0 2.37 1.94 3.77 4.22 3.77a3.52 3.52 0 0 0 2.74-1l.19.73h2.63v-7.13c0-2.52-1.08-4.42-4.7-4.42a8.41 8.41 0 0 0-4.44 1.34l1.12 2a6.65 6.65 0 0 1 3-.8c1.32 0 2 .67 2 1.66v.73a4.57 4.57 0 0 0-2.38-.59c-2.63 0-4.38 1.5-4.38 3.72zm3-.09c0-.93.8-1.57 1.94-1.57s2 .58 2 1.57-.88 1.61-2 1.61-2-.62-2-1.55zm14 1.23a3.29 3.29 0 0 1-.1-6.57 3.83 3.83 0 0 1 2.63 1.08l.84-2.5a5.74 5.74 0 0 0-3.56-1.21 5.81 5.81 0 0 0-6 5.95 5.73 5.73 0 0 0 6 5.88 5.67 5.67 0 0 0 3.57-1.19l-.8-2.43a4.12 4.12 0 0 1-2.55 1zm4.47 2.38h3v-5.83l3.75 5.83h3.49l-4.27-6.17 4-5.11h-3.34l-3.62 4.74V54.4h-3V70z\"/></g></svg>"

/***/ }),

/***/ "../src/components/webpack/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebpackOriginalWordmark = __webpack_require__("../src/components/webpack/original-wordmark/WebpackOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebpackOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webpack/original/WebpackOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _WebpackOriginal = __webpack_require__("../src/components/webpack/original/WebpackOriginal.svg");
	
	var _WebpackOriginal2 = _interopRequireDefault(_WebpackOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** WebpackOriginal */
	function WebpackOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'WebpackOriginal',
	    svg: _WebpackOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	WebpackOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = WebpackOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webpack/original/WebpackOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"angularjs\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#8ed6fb}.cls-2{fill:#1c78c0}</style></defs><title>Artboard 12</title><g id=\"original\"><path class=\"cls-1\" d=\"M117.29 98.1L66.24 127v-22.51L98 87l19.29 11.1zm3.5-3.16V34.55l-18.68 10.8v38.81l18.67 10.77zM10.71 98.1l51 28.88v-22.49L29.94 87zm-3.5-3.16V34.55l18.68 10.8v38.81zm2.19-64.3L61.76 1v21.76L28.21 41.21l-.27.15zm109.18 0L66.24 1v21.76L99.79 41.2l.27.15 18.54-10.71z\"/><path class=\"cls-2\" d=\"M61.76 99.37L30.37 82.1V47.92L61.76 66zm4.48 0l31.39-17.25v-34.2L66.24 66zM32.5 44L64 26.66 95.5 44 64 62.16 32.5 44z\"/></g></svg>"

/***/ }),

/***/ "../src/components/webpack/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebpackOriginal = __webpack_require__("../src/components/webpack/original/WebpackOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebpackOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webpack/plain-wordmark/WebpackPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _WebpackPlainWordmark = __webpack_require__("../src/components/webpack/plain-wordmark/WebpackPlainWordmark.svg");
	
	var _WebpackPlainWordmark2 = _interopRequireDefault(_WebpackPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** WebpackPlainWordmark */
	function WebpackPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'WebpackPlainWordmark',
	    svg: _WebpackPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	WebpackPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = WebpackPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webpack/plain-wordmark/WebpackPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"angularjs\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#1c78c0}</style></defs><title>Artboard 15</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M30.13 72.2l-12.27 6.94v-5.41l7.65-4.21 4.63 2.67zm.84-.76V56.92l-4.49 2.59v9.33l4.52 2.6zm-26.46.76l12.27 6.94v-5.41l-7.65-4.2zm-.84-.76V56.92l4.49 2.59v9.33zM4.2 56l12.59-7.12v5.22l-8.07 4.42h-.06zm26.25 0l-12.59-7.14v5.22l8.06 4.43h.06L30.45 56zM16.78 72.5l-7.54-4.15v-8.22l7.55 4.36zm1.08 0l7.55-4.15v-8.22l-7.55 4.36zM9.75 59.19L17.32 55l7.57 4.16-7.57 4.37-7.57-4.34zM48.61 69.57h3.32l3.38-11.27h-3.23l-2 8-2.14-8h-2.8l-2.16 8-2-8h-3.21l3.36 11.27h3.32l2.09-7.22zM55.49 64a5.62 5.62 0 0 0 5.93 5.88 5.35 5.35 0 0 0 4.74-2.48l-2-1.49a3.29 3.29 0 0 1-2.74 1.38 2.74 2.74 0 0 1-2.93-2.59h7.94v-.65c0-3.68-2-6-5.47-6-3.21 0-5.52 2.54-5.52 5.95zm3.13-1.23A2.39 2.39 0 0 1 61 60.45a2.3 2.3 0 0 1 2.41 2.28zm9 6.83h2.8v-1.2a4.39 4.39 0 0 0 3.34 1.44c3.23 0 5.52-2.43 5.52-5.9S77.15 58 73.92 58a4.24 4.24 0 0 0-3.34 1.46V54h-3v15.57zm2.87-5.6c0-2.11 1.25-3.32 2.89-3.32S76.27 62 76.27 64s-1.21 3.25-2.89 3.25A3 3 0 0 1 70.49 64zm9.93 9.63h3V68.4a4.3 4.3 0 0 0 3.34 1.44c3.23 0 5.35-2.43 5.35-5.92S89.8 58 86.57 58a4.32 4.32 0 0 0-3.34 1.46v-1.17h-2.8V73.6zm2.89-9.7a3 3 0 0 1 2.89-3.25c1.68 0 2.89 1.25 2.89 3.25s-1.16 3.32-2.89 3.32-2.89-1.25-2.89-3.35zm9.31 2.18c0 2.37 1.94 3.77 4.22 3.77a3.52 3.52 0 0 0 2.74-1l.19.73h2.63v-7.18c0-2.52-1.08-4.42-4.7-4.42a8.41 8.41 0 0 0-4.44 1.34l1.12 2a6.65 6.65 0 0 1 3-.8c1.32 0 2 .67 2 1.66V63a4.57 4.57 0 0 0-2.38-.65c-2.63 0-4.38 1.5-4.38 3.72zm3-.09c0-.93.8-1.57 1.94-1.57s2 .58 2 1.57-.82 1.55-1.94 1.55-2-.62-2-1.55zm14 1.23a3.29 3.29 0 0 1-.1-6.57 3.83 3.83 0 0 1 2.63 1.08l.84-2.5a5.74 5.74 0 0 0-3.55-1.26 5.81 5.81 0 0 0-6 5.95 5.73 5.73 0 0 0 6 5.88 5.67 5.67 0 0 0 3.56-1.19l-.8-2.43a4.12 4.12 0 0 1-2.55 1zm4.46 2.35h3v-5.85l3.77 5.82h3.49l-4.27-6.17 4-5.11h-3.34L117.06 63v-9h-3v15.57z\"/></g></svg>"

/***/ }),

/***/ "../src/components/webpack/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebpackPlainWordmark = __webpack_require__("../src/components/webpack/plain-wordmark/WebpackPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebpackPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webpack/plain/WebpackPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _WebpackPlain = __webpack_require__("../src/components/webpack/plain/WebpackPlain.svg");
	
	var _WebpackPlain2 = _interopRequireDefault(_WebpackPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** WebpackPlain */
	function WebpackPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'WebpackPlain',
	    svg: _WebpackPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	WebpackPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = WebpackPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webpack/plain/WebpackPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"angularjs\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#1c78c0}</style></defs><title>Artboard 13</title><g id=\"plain\"><path class=\"cls-1\" d=\"M117.29 98.1L66.24 127v-22.51L98 87l19.29 11.1zm3.5-3.16V34.55l-18.68 10.8v38.81l18.67 10.77zM10.71 98.1l51 28.88v-22.49L29.94 87zm-3.5-3.16V34.55l18.68 10.8v38.81zm2.19-64.3L61.76 1v21.76L28.21 41.21l-.27.15zm109.18 0L66.24 1v21.76L99.79 41.2l.27.15 18.54-10.71zM61.76 99.37L30.37 82.1V47.92L61.76 66zm4.48 0l31.39-17.25v-34.2L66.24 66zM32.5 44L64 26.66 95.5 44 64 62.16 32.5 44z\"/></g></svg>"

/***/ }),

/***/ "../src/components/webpack/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebpackPlain = __webpack_require__("../src/components/webpack/plain/WebpackPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebpackPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webstorm/original-wordmark/WebstormOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _WebstormOriginalWordmark = __webpack_require__("../src/components/webstorm/original-wordmark/WebstormOriginalWordmark.svg");
	
	var _WebstormOriginalWordmark2 = _interopRequireDefault(_WebstormOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** WebstormOriginalWordmark */
	function WebstormOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'WebstormOriginalWordmark',
	    svg: _WebstormOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	WebstormOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = WebstormOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webstorm/original-wordmark/WebstormOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"webstorm\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#2788b5}.cls-2{fill:#fa930d}</style></defs><title>Artboard 12</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M42.29 72.45L39 59.3h1.8l1.56 6.65c.39 1.64.74 3.28 1 4.55.21-1.31.62-2.87 1.07-4.56l1.76-6.63h1.78L49.53 66c.37 1.56.72 3.12.92 4.51.27-1.44.64-2.91 1.05-4.55l1.74-6.63H55l-3.72 13.12h-1.77l-1.66-6.85a39.6 39.6 0 0 1-.85-4.29 41.15 41.15 0 0 1-1 4.29l-1.87 6.85h-1.84zM56.9 68a3 3 0 0 0 3.24 3.28 6.21 6.21 0 0 0 2.61-.49l.25 1.27a7.64 7.64 0 0 1-3.14.59 4.39 4.39 0 0 1-4.64-4.76c0-2.85 1.68-5.09 4.43-5.09 3.08 0 3.9 2.71 3.9 4.45a6.61 6.61 0 0 1-.06.8H56.9zm5-1.23c0-1.09-.45-2.79-2.38-2.79a2.84 2.84 0 0 0-2.63 2.79zM65.63 72.45c0-.64.08-1.6.08-2.44V58.6h1.7v5.93a3.52 3.52 0 0 1 3.22-1.74c2.34 0 4 2 4 4.82 0 3.37-2.13 5.05-4.23 5.05a3.36 3.36 0 0 1-3.16-1.78h-.06l-.08 1.56h-1.47zm1.78-3.78a3.23 3.23 0 0 0 .08.62 2.65 2.65 0 0 0 2.57 2c1.8 0 2.87-1.46 2.87-3.63 0-1.89-1-3.51-2.81-3.51a2.74 2.74 0 0 0-2.61 2.11 3.38 3.38 0 0 0-.1.7v1.7zM76.77 69.38a7.59 7.59 0 0 0 3.3.82c1.37 0 2.09-.57 2.09-1.42s-.62-1.29-2.2-1.85c-2.18-.76-3.61-2-3.61-3.88 0-2.24 1.87-4 5-4a8.06 8.06 0 0 1 3.36.66L84 62.15a6.25 6.25 0 0 0-2.75-.62c-1.29 0-1.91.59-1.91 1.27 0 .84.74 1.21 2.44 1.85 2.32.86 3.41 2.07 3.41 3.92 0 2.2-1.7 4.08-5.31 4.08a8.61 8.61 0 0 1-3.73-.8zM90.32 60.18v2.73h2.13v2.19h-2.13v3.45c0 1.15.27 1.68 1.17 1.68a4.87 4.87 0 0 0 .88-.08v2.24a5.81 5.81 0 0 1-1.93.25 3.09 3.09 0 0 1-2.22-.82 4 4 0 0 1-.8-2.82v-3.9h-1.27v-2.19h1.27v-2.07zM103.49 67.57a4.79 4.79 0 0 1-5 5.09 4.67 4.67 0 0 1-4.94-4.92 4.76 4.76 0 0 1 5.09-5.05 4.64 4.64 0 0 1 4.85 4.88zm-6.91.1c0 1.64.68 2.87 2 2.87s1.89-1.15 1.89-2.87c0-1.42-.55-2.87-1.89-2.87s-2 1.46-2 2.87zM105.32 66c0-1.4 0-2.32-.08-3.14h2.55l.1 1.76h.11a2.8 2.8 0 0 1 2.57-2 3 3 0 0 1 .62 0v2.79a4.23 4.23 0 0 0-.8-.08 1.9 1.9 0 0 0-2 1.5 3.49 3.49 0 0 0-.06.66v4.84h-3V66zM112.73 65.95c0-1.19 0-2.2-.08-3h2.5l.14 1.29h.06a3.31 3.31 0 0 1 2.89-1.5 2.7 2.7 0 0 1 2.61 1.62 4.26 4.26 0 0 1 1.23-1.15 3.44 3.44 0 0 1 1.81-.47c1.83 0 3.22 1.29 3.22 4.14v5.62h-2.89v-5.24c0-1.38-.45-2.18-1.4-2.18a1.45 1.45 0 0 0-1.37 1 2.48 2.48 0 0 0-.12.76v5.58h-2.89V67.1c0-1.21-.43-2-1.36-2a1.51 1.51 0 0 0-1.39 1.07 2 2 0 0 0-.12.74v5.56h-2.89v-6.5zM17 74.9c.28-.35.61-.74 1-1.19l.2-.23c.24-.28.45-.5.64-.71a15.49 15.49 0 0 0 1.34-1.62 3.48 3.48 0 0 0 .93-2.5 2 2 0 0 0-.41-1.36 14.61 14.61 0 0 0-1-1.05c-.45-.44-.85-.86-1.39-1.41a10.55 10.55 0 0 1-1.23-2 9.09 9.09 0 0 1-.7-2.36l-1.58-8.08h-4.5L8.1 62.61 6.16 52.43H.86l4.78 23.14h4.46l2.23-10 2 10h2.07z\"/><path class=\"cls-2\" d=\"M26.35 53.81c.47-.54.86-1 1.17-1.38H20.4a18.78 18.78 0 0 0-1.78 2.51 8.18 8.18 0 0 0-1.24 4.4v.73a7.9 7.9 0 0 0 .77 2.65 9.51 9.51 0 0 0 .85 1.22l.14.19c.73.87 1.86 1.87 2.41 2.49a3.06 3.06 0 0 1 .65 2 4.53 4.53 0 0 1-1.13 3.2 26.12 26.12 0 0 1-2 2.39c-.47.54-.85 1-1.17 1.38h7.36a19.8 19.8 0 0 0 1.54-2.51 8.17 8.17 0 0 0 1.2-4.41v-.73a7.9 7.9 0 0 0-.77-2.65 9.73 9.73 0 0 0-.79-1.23l-.14-.19c-.8-.87-1.96-1.87-2.47-2.49a3.06 3.06 0 0 1-.65-2 4.53 4.53 0 0 1 1.14-3.2 26.38 26.38 0 0 1 2.03-2.37z\"/></g></svg>"

/***/ }),

/***/ "../src/components/webstorm/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebstormOriginalWordmark = __webpack_require__("../src/components/webstorm/original-wordmark/WebstormOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebstormOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webstorm/original/WebstormOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _WebstormOriginal = __webpack_require__("../src/components/webstorm/original/WebstormOriginal.svg");
	
	var _WebstormOriginal2 = _interopRequireDefault(_WebstormOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** WebstormOriginal */
	function WebstormOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'WebstormOriginal',
	    svg: _WebstormOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	WebstormOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = WebstormOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webstorm/original/WebstormOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"webstorm\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#2788b5}.cls-2{fill:#fa930d}</style></defs><title>Artboard 14</title><g id=\"original\"><path class=\"cls-1\" d=\"M75.78 113.66c1.28-1.6 2.79-3.36 4.58-5.42l.89-1c1.11-1.29 2-2.28 2.93-3.24a70.64 70.64 0 0 0 6.09-7.36c2.74-3.74 4.51-6.55 4.22-11.37-.14-2.48-.24-4.18-1.86-6.18a66.7 66.7 0 0 0-4.69-4.78c-2.07-2-3.87-3.9-6.31-6.44s-5.6-9-5.6-9a41.4 41.4 0 0 1-3.19-10.74l-7.18-36.8H45.22l-10 46.41-8.87-46.46H2.22L24 116.72h20.32l10.17-45.64 9 45.64h9.44z\"/><path class=\"cls-2\" d=\"M118.34 17.59c2.14-2.48 3.9-4.48 5.34-6.3H91.24c-1.93 2.46-5.85 7.21-8.09 11.43-3 5.58-5.39 9.76-5.63 20l.11 3.31c0 4.9 3.5 12.08 3.5 12.08a43.35 43.35 0 0 0 3.58 5.61l.65.85c3.5 4 8.78 8.48 11.12 11.35 2.73 3.37 2.8 6.53 3 9 .39 6.65-2.29 10.65-5.17 14.58-4.35 5.93-5.92 7-9.27 10.91-2.14 2.47-3.89 4.48-5.34 6.29h33.51a90.25 90.25 0 0 0 7-11.42c3-5.58 5.39-9.76 5.63-20l-.16-3.28c0-4.9-3.5-12.09-3.5-12.09a44.31 44.31 0 0 0-3.59-5.61l-.64-.85c-3.5-4-8.79-8.48-11.12-11.35-2.73-3.38-2.8-6.54-3-9-.4-6.64 2.29-10.65 5.17-14.58 4.42-5.95 6-7.06 9.34-10.93z\"/></g></svg>"

/***/ }),

/***/ "../src/components/webstorm/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebstormOriginal = __webpack_require__("../src/components/webstorm/original/WebstormOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebstormOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webstorm/plain-wordmark/WebstormPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _WebstormPlainWordmark = __webpack_require__("../src/components/webstorm/plain-wordmark/WebstormPlainWordmark.svg");
	
	var _WebstormPlainWordmark2 = _interopRequireDefault(_WebstormPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** WebstormPlainWordmark */
	function WebstormPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'WebstormPlainWordmark',
	    svg: _WebstormPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	WebstormPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = WebstormPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webstorm/plain-wordmark/WebstormPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"webstorm\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#2788b5}</style></defs><title>Artboard 13</title><g id=\"plain-wordmark\"><path class=\"cls-1\" d=\"M43 72.18l-3.27-12.74h1.74L43 65.89c.38 1.59.72 3.18.94 4.4.21-1.27.6-2.78 1-4.42l1.7-6.43h1.72L50 65.91c.36 1.51.7 3 .89 4.37.26-1.4.62-2.82 1-4.4l1.68-6.43h1.68l-3.57 12.73H50l-1.61-6.63a38.38 38.38 0 0 1-.83-4.16 39.87 39.87 0 0 1-1 4.16l-1.81 6.63H43zM57.12 67.91a2.93 2.93 0 0 0 3.14 3.18 6 6 0 0 0 2.53-.47l.28 1.19a7.41 7.41 0 0 1-3 .57 4.25 4.25 0 0 1-4.5-4.61c0-2.76 1.63-4.93 4.29-4.93 3 0 3.78 2.63 3.78 4.31a6.4 6.4 0 0 1-.06.77h-6.46zM62 66.72A2.37 2.37 0 0 0 59.69 64a2.76 2.76 0 0 0-2.55 2.7zM65.58 72.18c0-.62.08-1.55.08-2.36V58.76h1.64v5.75a3.41 3.41 0 0 1 3.12-1.68c2.27 0 3.87 1.89 3.86 4.67 0 3.27-2.06 4.89-4.1 4.89a3.26 3.26 0 0 1-3.06-1.72h-.06L67 72.18h-1.42zm1.72-3.67a3.13 3.13 0 0 0 .08.6 2.57 2.57 0 0 0 2.49 1.95c1.74 0 2.78-1.42 2.78-3.52 0-1.83-.95-3.4-2.72-3.4a2.65 2.65 0 0 0-2.53 2 3.27 3.27 0 0 0-.09.68v1.64zM76.37 69.22a7.36 7.36 0 0 0 3.19.79c1.32 0 2-.55 2-1.38s-.6-1.25-2.14-1.8c-2.12-.74-3.5-1.91-3.5-3.76 0-2.17 1.81-3.84 4.82-3.84a7.81 7.81 0 0 1 3.25.64l-.64 2.32a6.05 6.05 0 0 0-2.66-.61c-1.25 0-1.85.57-1.85 1.23 0 .81.72 1.17 2.36 1.8 2.25.83 3.31 2 3.31 3.8 0 2.14-1.64 4-5.14 4a8.35 8.35 0 0 1-3.61-.77zM89.5 60.3v2.65h2.06v2.12H89.5v3.33c0 1.11.26 1.63 1.13 1.63a4.72 4.72 0 0 0 .85-.08v2.17a5.63 5.63 0 0 1-1.87.25 3 3 0 0 1-2.15-.79 3.83 3.83 0 0 1-.79-2.74v-3.78h-1.21v-2.12h1.23v-2zM102.26 67.46a4.64 4.64 0 0 1-4.88 4.93 4.53 4.53 0 0 1-4.78-4.76 4.61 4.61 0 0 1 4.93-4.89 4.49 4.49 0 0 1 4.73 4.72zm-6.69.09c0 1.59.66 2.78 1.89 2.78s1.83-1.11 1.83-2.78c0-1.38-.53-2.78-1.83-2.78s-1.89 1.42-1.89 2.78zM104 66c0-1.36 0-2.25-.08-3h2.48l.09 1.7h.08a2.72 2.72 0 0 1 2.49-1.91 3 3 0 0 1 .61 0v2.7a4.11 4.11 0 0 0-.77-.08 1.85 1.85 0 0 0-2 1.46 3.39 3.39 0 0 0-.06.64v4.69H104zM111.21 65.89c0-1.15 0-2.14-.08-2.95h2.42l.13 1.25h.06a3.21 3.21 0 0 1 2.8-1.46 2.62 2.62 0 0 1 2.53 1.57 4.12 4.12 0 0 1 1.19-1.12 3.33 3.33 0 0 1 1.76-.45c1.78 0 3.12 1.25 3.12 4v5.44h-2.8v-5c0-1.34-.43-2.12-1.36-2.12a1.41 1.41 0 0 0-1.32 1 2.4 2.4 0 0 0-.11.74v5.41h-2.8V67c0-1.17-.42-2-1.32-2a1.46 1.46 0 0 0-1.34 1 1.91 1.91 0 0 0-.11.72v5.39h-2.8v-6.22zM18.47 74.56c.27-.34.59-.71 1-1.15l.19-.22c.24-.27.43-.48.62-.69a15 15 0 0 0 1.3-1.57 3.37 3.37 0 0 0 .9-2.42 2 2 0 0 0-.4-1.31 14.19 14.19 0 0 0-1-1c-.44-.43-.82-.83-1.34-1.37a10.22 10.22 0 0 1-1.19-1.92 8.81 8.81 0 0 1-.68-2.28l-1.53-7.83H12l-2.16 9.86L8 52.79H2.82l4.63 22.42h4.32l2.16-9.71 1.91 9.71h2z\"/><path class=\"cls-1\" d=\"M27.52 54.13c.45-.53.83-1 1.14-1.34h-6.9A18.2 18.2 0 0 0 20 55.22a7.92 7.92 0 0 0-1.2 4.26v.7a7.65 7.65 0 0 0 .74 2.57 9.22 9.22 0 0 0 .76 1.19l.14.18c.74.85 1.87 1.8 2.37 2.42a3 3 0 0 1 .63 1.91 4.39 4.39 0 0 1-1.1 3.1 25.31 25.31 0 0 1-2 2.32c-.45.53-.83 1-1.14 1.34h7.13a19.2 19.2 0 0 0 1.49-2.43 7.92 7.92 0 0 0 1.2-4.26v-.7a7.66 7.66 0 0 0-.74-2.57 9.42 9.42 0 0 0-.76-1.19l-.14-.18c-.74-.85-1.87-1.8-2.37-2.42a3 3 0 0 1-.63-1.91 4.39 4.39 0 0 1 1.1-3.1 25.56 25.56 0 0 1 2.04-2.32z\"/></g></svg>"

/***/ }),

/***/ "../src/components/webstorm/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebstormPlainWordmark = __webpack_require__("../src/components/webstorm/plain-wordmark/WebstormPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebstormPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webstorm/plain/WebstormPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _WebstormPlain = __webpack_require__("../src/components/webstorm/plain/WebstormPlain.svg");
	
	var _WebstormPlain2 = _interopRequireDefault(_WebstormPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** WebstormPlain */
	function WebstormPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'WebstormPlain',
	    svg: _WebstormPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	WebstormPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = WebstormPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/webstorm/plain/WebstormPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"webstorm\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#2788b5}</style></defs><title>Artboard 15</title><g id=\"plain\"><path class=\"cls-1\" d=\"M75.62 113c1.26-1.58 2.75-3.31 4.52-5.35l.88-1c1.1-1.27 2-2.25 2.89-3.2a69.7 69.7 0 0 0 6-7.26c2.71-3.69 4.45-6.46 4.17-11.22-.14-2.45-.24-4.13-1.83-6.1a65.81 65.81 0 0 0-4.63-4.72c-2-2-3.82-3.85-6.23-6.36s-5.53-8.89-5.53-8.89a40.85 40.85 0 0 1-3.14-10.6L65.64 12H45.47L35.6 57.77 26.85 12H3l21.52 104h20.07l10-45 8.87 45h9.34z\"/><path class=\"cls-1\" d=\"M117.61 18.2c2.11-2.44 3.84-4.42 5.27-6.22h-32c-1.9 2.43-5.77 7.12-8 11.28-2.88 5.5-5.29 9.63-5.53 19.74l.11 3.26c0 4.83 3.45 11.92 3.45 11.92a42.78 42.78 0 0 0 3.54 5.54l.64.84c3.45 4 8.67 8.37 11 11.2 2.69 3.32 2.77 6.44 2.91 8.87.39 6.56-2.26 10.51-5.1 14.39-4.35 5.89-5.9 6.98-9.2 10.8-2.11 2.44-3.84 4.42-5.27 6.21h33.07a89 89 0 0 0 6.92-11.27c2.92-5.5 5.32-9.63 5.55-19.76l-.11-3.27c0-4.84-3.45-11.93-3.45-11.93a43.72 43.72 0 0 0-3.54-5.54l-.64-.84c-3.45-4-8.67-8.36-11-11.2-2.69-3.33-2.77-6.45-2.91-8.87-.39-6.55 2.26-10.51 5.1-14.39 4.35-5.84 5.89-6.96 9.19-10.76z\"/></g></svg>"

/***/ }),

/***/ "../src/components/webstorm/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebstormPlain = __webpack_require__("../src/components/webstorm/plain/WebstormPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebstormPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/windows8/original-wordmark/Windows8OriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _Windows8OriginalWordmark = __webpack_require__("../src/components/windows8/original-wordmark/Windows8OriginalWordmark.svg");
	
	var _Windows8OriginalWordmark2 = _interopRequireDefault(_Windows8OriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Windows8OriginalWordmark */
	function Windows8OriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'Windows8OriginalWordmark',
	    svg: _Windows8OriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	Windows8OriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = Windows8OriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/windows8/original-wordmark/Windows8OriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path d=\"M.5 55.235l9.869-1.343.004 9.519-9.863.055-.01-8.231zm9.863 9.27l.008 9.527-9.863-1.357v-8.232l9.855.062zm1.196-10.789l13.082-1.91v11.481l-13.082.104v-9.675zm13.088 10.88l-.006 11.43-13.082-1.847-.018-9.605 13.106.022zm26.535-7.879L47.14 71.193l-2.399-.023-3.152-11.419c.025-.596.072-.165.072-.165l-3.186 11.572-2.403.025-4.169-14.46 2.249-.006 3.202 12.061-.064-.037 3.366-12.024 2.157.007 3.2 12.263-.055-.175 3.024-12.082 2.2-.013zm2.01 1.718c-.36 0-.661-.12-.907-.358a1.201 1.201 0 0 1-.369-.899c0-.354.124-.655.371-.898.248-.244.551-.366.905-.366.357 0 .662.123.916.367a1.2 1.2 0 0 1 .378.897c0 .344-.126.639-.376.885a1.258 1.258 0 0 1-.918.372zm.894 12.761l-1.953-.014-.041-10.323 2.006-.012-.012 10.349zm11.222.012H63.32v-5.759c0-2.031-.648-3.188-2.19-3.172-.742 0-1.43.301-1.924.871-.607.698-.72 1.08-.726 2.301l-.025 5.759-2.014-.018.008-10.321 1.98-.008.016 2.344-.287-.268c.759-1.329 1.783-2.34 3.597-2.34 1.182 0 2.054.321 2.683 1.086.625.765.854 1.949.854 3.349l.016 6.176zm11.607.169H74.84v-1.729h.317c-.754 1.312-1.965 1.967-3.629 1.967-1.354 0-2.431-.478-3.231-1.43-.8-.954-1.201-2.238-1.201-3.856 0-1.727.442-3.122 1.327-4.178.883-1.056 2.067-1.585 3.554-1.585 1.485 0 2.545.551 3.181 1.65h-.317v-6.295h2.075v15.456zm-2.075-4.801v-1.498c0-.767-.251-1.416-.755-1.943-.503-.529-1.137-.792-1.899-.792-.917 0-1.643.34-2.176 1.022-.532.683-.8 1.644-.8 2.885 0 1.129.255 2.012.763 2.642.51.633 1.186.947 2.033.947.836 0 1.517-.305 2.044-.916.527-.609.79-1.393.79-2.347zm8.831 4.941c-1.571 0-2.824-.491-3.761-1.477-.938-.987-1.406-2.283-1.406-3.893 0-1.744.488-3.115 1.462-4.112.975-.995 2.289-1.493 3.944-1.493 1.584 0 2.822.483 3.712 1.455.891.97 1.335 2.301 1.335 3.992 0 1.66-.478 2.995-1.436 4.008-.957 1.013-2.24 1.52-3.85 1.52zm.12-9.21c-.974 0-1.747.331-2.317.993-.57.661-.855 1.591-.855 2.789 0 1.152.287 2.051.863 2.698.574.645 1.346.966 2.31.966.977 0 1.732-.314 2.261-.948.529-.631.793-1.55.793-2.755 0-1.216-.266-2.144-.795-2.783-.529-.641-1.283-.96-2.26-.96zm20.549-1.477l-3.038 10.368-2.146.014-2.181-8.026.01.012-2.432 8.008h-2.016L89.338 60.83h2.147l2.204 8.427-.057.085 2.462-8.512h1.873l2.371 8.739-.068-.259 2.018-8.48h2.052zm.74 10.095v-2.067c.965.655 1.897.981 2.802.981 1.14 0 1.71-.409 1.71-1.227 0-.234-.048-.431-.142-.592a1.51 1.51 0 0 0-.392-.439 3.132 3.132 0 0 0-.638-.377l-.772-.349a10.042 10.042 0 0 1-1.094-.561 3.387 3.387 0 0 1-.799-.65 2.498 2.498 0 0 1-.493-.838 3.326 3.326 0 0 1-.167-1.098c0-.515.104-.967.313-1.359.208-.393.483-.722.83-.987a3.635 3.635 0 0 1 1.176-.596 4.56 4.56 0 0 1 1.342-.201c.81 0 1.577.179 2.299.537v1.973c-.842-.488-1.674-.733-2.494-.733-.248 0-.472.031-.666.094a1.507 1.507 0 0 0-.5.26 1.082 1.082 0 0 0-.419.871c0 .238.037.431.108.582.072.152.183.287.33.413.149.126.335.242.559.348l.783.358c.429.185.802.37 1.121.553.32.183.6.397.839.642.24.243.425.528.557.854.132.324.197.704.197 1.139 0 .532-.106 1.001-.321 1.403a2.937 2.937 0 0 1-.845.993 3.59 3.59 0 0 1-1.198.577 5.255 5.255 0 0 1-1.408.187c-.97-.001-1.841-.231-2.618-.691zm12.766-3.723a4.225 4.225 0 0 1 .72-2.305c.231-.346.521-.663.865-.948.346-.287.694-.462 1.046-.531-.578-.226-1.058-.622-1.441-1.19a3.317 3.317 0 0 1-.572-1.896 3.627 3.627 0 0 1 1.202-2.741c.377-.342.823-.61 1.347-.803a4.785 4.785 0 0 1 1.674-.291 4.76 4.76 0 0 1 1.682.295c.521.198.972.468 1.347.808a3.658 3.658 0 0 1 1.194 2.732c0 .694-.191 1.325-.574 1.894-.386.568-.857.966-1.42 1.19.346.069.688.246 1.026.529a4.423 4.423 0 0 1 1.398 2.067c.124.397.185.795.185 1.19 0 .645-.118 1.238-.354 1.781a4.007 4.007 0 0 1-1.002 1.398 4.605 4.605 0 0 1-1.527.903 5.76 5.76 0 0 1-1.955.32c-.71 0-1.357-.108-1.943-.32a4.709 4.709 0 0 1-1.53-.903 4.062 4.062 0 0 1-1.009-1.395 4.344 4.344 0 0 1-.359-1.784zm2.212-.137c0 .427.063.806.189 1.137.126.332.303.611.528.844.229.229.504.407.826.531.32.123.687.185 1.094.185a2.9 2.9 0 0 0 1.065-.191 2.44 2.44 0 0 0 .828-.534 2.46 2.46 0 0 0 .551-.85c.134-.337.203-.71.203-1.121 0-.372-.065-.718-.193-1.043a2.524 2.524 0 0 0-1.37-1.435 2.687 2.687 0 0 0-1.084-.21c-.376 0-.722.067-1.044.198a2.504 2.504 0 0 0-.832.549 2.563 2.563 0 0 0-.557.848 2.8 2.8 0 0 0-.204 1.092zm.508-6.603c0 .317.055.608.165.868.112.259.268.49.464.688.197.199.425.352.677.46.254.11.529.163.824.163.293 0 .568-.055.826-.169.26-.112.483-.268.677-.462a2.31 2.31 0 0 0 .464-.692c.114-.265.173-.55.173-.855 0-.32-.057-.611-.167-.877a2.13 2.13 0 0 0-1.973-1.313c-.316 0-.605.057-.865.171a2.036 2.036 0 0 0-1.11 1.152 2.338 2.338 0 0 0-.155.866z\" fill=\"#00ADEF\"/></svg>"

/***/ }),

/***/ "../src/components/windows8/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Windows8OriginalWordmark = __webpack_require__("../src/components/windows8/original-wordmark/Windows8OriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Windows8OriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/windows8/original/Windows8Original.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _Windows8Original = __webpack_require__("../src/components/windows8/original/Windows8Original.svg");
	
	var _Windows8Original2 = _interopRequireDefault(_Windows8Original);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Windows8Original */
	function Windows8Original(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'Windows8Original',
	    svg: _Windows8Original2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	Windows8Original.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = Windows8Original;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/windows8/original/Windows8Original.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill=\"#00ADEF\" d=\"M126 1.637l-67 9.834v49.831l67-.534zM1.647 66.709l.003 42.404 50.791 6.983-.04-49.057zm56.82.68l.094 49.465 67.376 9.509.016-58.863zM1.61 19.297l.047 42.383 50.791-.289-.023-49.016z\"/></svg>"

/***/ }),

/***/ "../src/components/windows8/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Windows8Original = __webpack_require__("../src/components/windows8/original/Windows8Original.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Windows8Original).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/wordpress/original/WordpressOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _WordpressOriginal = __webpack_require__("../src/components/wordpress/original/WordpressOriginal.svg");
	
	var _WordpressOriginal2 = _interopRequireDefault(_WordpressOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** WordpressOriginal */
	function WordpressOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'WordpressOriginal',
	    svg: _WordpressOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	WordpressOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = WordpressOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/wordpress/original/WordpressOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#337BA2\" d=\"M43.257 121.233c.079 1.018.029 2.071.299 3.037.115.408.9.629 1.381.935l.625.401c-.235.137-.469.389-.707.392a165.82 165.82 0 0 1-5.598.002c-.248-.004-.491-.237-.735-.364.198-.143.388-.391.597-.408 1.251-.105 1.632-.865 1.626-1.989-.011-2.066-.006-4.134.003-6.202.005-1.152-.322-1.993-1.679-2.045-.188-.008-.366-.296-.548-.453.182-.111.366-.321.546-.318 2.39.029 4.79-.024 7.167.177 1.873.159 3.107 1.455 3.234 2.949.138 1.639-.703 2.764-2.605 3.486l-.729.272c1.225 1.158 2.31 2.29 3.516 3.272.535.437 1.293.697 1.989.817 1.393.238 2.149-.361 2.187-1.742.061-2.229.032-4.461.011-6.691-.01-1.022-.449-1.697-1.589-1.753-.215-.01-.42-.253-.629-.388.239-.14.478-.4.715-.399 2.432.02 4.875-.055 7.291.161 4.123.366 6.42 3.797 5.214 7.588-.735 2.312-2.495 3.619-4.759 3.773-3.958.27-7.938.215-11.909.243-.316.002-.706-.341-.944-.623-.914-1.085-1.776-2.213-2.668-3.316-.27-.334-.571-.641-.858-.961l-.444.147zm13.119-5.869c0 2.785-.034 5.484.036 8.18.011.414.41 1.039.78 1.187 1.457.581 3.812-.368 4.47-1.842.881-1.973.988-4.05-.203-5.922-1.175-1.847-3.132-1.663-5.083-1.603zm-13.021 4.561c1.262.032 2.653.313 3.192-1.073.302-.777.234-1.982-.183-2.69-.633-1.076-1.906-.888-3.01-.752l.001 4.515z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#515151\" d=\"M96.77 119.35c.834-.18 1.661-.154 2.198-.537.451-.32.563-1.116.908-1.886.199.357.386.539.39.724.025 1.38.03 2.761 0 4.141-.005.216-.226.427-.347.641-.136-.114-.339-.2-.399-.346-.733-1.771-.729-1.772-2.843-1.583.309 1.382-.763 3.149.89 4.058.843.463 2.203.371 3.189.068.841-.256 1.48-1.171 2.212-1.798v3.096c-.405.036-.712.086-1.021.086-4.141.006-8.282-.012-12.422.019-.714.006-1.197-.174-1.633-.773-.857-1.182-1.799-2.302-2.725-3.432-.232-.283-.534-.508-1.021-.962 0 1.154-.042 1.981.012 2.802.056.858.469 1.427 1.418 1.534.279.032.529.325.792.5-.271.105-.54.298-.812.303-1.827.026-3.653.025-5.48.001-.28-.004-.558-.173-.866-.275l.156-.303c2.244-.906 2.25-.906 2.248-3.508a343.88 343.88 0 0 0-.039-4.87c-.017-1.121-.321-2.01-1.689-2.058-.197-.007-.384-.287-.577-.441.226-.113.453-.325.678-.323 2.311.022 4.635-.054 6.93.16 2.512.234 4.065 2.329 3.132 4.257-.51 1.053-1.688 1.783-2.725 2.818.984.9 2.117 2.194 3.491 3.135 1.941 1.33 3.268.571 3.317-1.748.041-1.947-.007-3.896-.015-5.845-.004-1.155-.361-1.994-1.717-2.013-.185-.003-.367-.2-.586-.33.705-.52 7.499-.709 10.448-.332l.19 3.214-.333.136c-.686-.717-.601-2.199-2.02-2.204-1.084-.005-2.168-.119-3.332-.189.003 1.356.003 2.59.003 4.063zm-12.647.566c2.61.105 3.646-.603 3.584-2.364-.061-1.698-1.195-2.383-3.584-2.121v4.485z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#3179A1\" d=\"M11.555 120.682c.996-2.947 1.979-5.897 3.003-8.834.141-.404.486-.737.737-1.104.248.378.587.725.729 1.14.931 2.719 1.817 5.451 2.722 8.179.072.219.165.43.375.969.928-2.813 1.787-5.308 2.564-7.829.27-.873-.081-1.504-1.097-1.618-.335-.039-.66-.17-1.051-.274.676-.749 5.957-.804 6.827-.108-.236.112-.424.271-.618.279-1.65.064-2.414 1.097-2.884 2.521-1.258 3.81-2.54 7.611-3.817 11.415-.133.395-.3.778-.452 1.166l-.421.03-3.579-10.821-3.619 10.788-.354.022c-.185-.401-.412-.79-.547-1.207-1.167-3.581-2.319-7.167-3.474-10.751-.495-1.539-.99-3.069-3.012-3.167-.132-.006-.253-.229-.38-.35.158-.13.316-.373.476-.375 2.272-.024 4.546-.024 6.818.001.158.001.313.247.47.379-.169.126-.319.309-.508.367-1.82.55-1.951.761-1.378 2.526.723 2.233 1.468 4.457 2.204 6.686l.266-.03z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#4D4D4D\" d=\"M65.484 111.25c.279-.241.435-.494.587-.491 2.957.044 5.938-.093 8.864.247 2.768.321 4.301 2.919 3.466 5.359-.748 2.189-2.593 2.874-4.68 3.064-.881.081-1.776.013-2.824.013.093 1.453.14 2.78.275 4.098.113 1.114.863 1.56 1.923 1.65.239.021.457.288.684.442-.25.126-.498.36-.75.363-2.191.029-4.384.028-6.575.002-.263-.003-.523-.219-.784-.336.218-.165.432-.463.656-.472 1.463-.056 2.012-.964 2.03-2.235.044-3.081.04-6.162.002-9.243-.016-1.31-.649-2.148-2.072-2.206-.212-.008-.422-.13-.802-.255zm5.523 6.706c2.682.278 3.703.022 4.349-1.167.648-1.192.65-2.439-.116-3.566-1.059-1.559-2.679-1.098-4.233-1.154v5.887z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#3279A1\" d=\"M31.076 126.463c-2.396-.104-4.348-.856-5.794-2.647-2.053-2.542-1.741-5.994.711-8.192 2.645-2.37 7.018-2.472 9.733-.171 1.838 1.559 2.709 3.533 2.111 5.953-.675 2.73-2.601 4.192-5.218 4.856-.546.137-1.122.149-1.543.201zm4.544-6.249l-.224-.147c-.149-.709-.236-1.439-.458-2.125-.642-1.971-1.986-2.945-3.963-2.949-1.97-.004-3.295.975-3.939 2.967-.572 1.771-.498 3.526.383 5.18 1.315 2.468 4.829 2.931 6.549.736.802-1.023 1.116-2.43 1.652-3.662z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#505050\" d=\"M122.748 114.317l.893-.782v4.376l-.259.195c-.209-.295-.498-.562-.615-.891-.591-1.655-1.865-2.553-3.319-2.117-.499.149-1.099.649-1.232 1.11-.109.376.285 1.12.671 1.374 1.008.664 2.131 1.156 3.214 1.703 2.356 1.192 3.198 2.845 2.401 4.736-.809 1.921-3.263 2.915-5.462 2.173-.606-.206-1.167-.544-1.728-.811l-.857 1.126-.379-.116c0-1.477-.009-2.954.015-4.431.002-.143.215-.282.33-.423.18.218.448.41.527.66.523 1.656 1.53 2.756 3.325 2.94 1.023.105 2.023-.021 2.378-1.187.324-1.067-.42-1.669-1.219-2.124-.879-.5-1.808-.909-2.708-1.37-.395-.203-.798-.404-1.153-.665-1.257-.927-1.753-2.263-1.381-3.618.332-1.211 1.523-2.237 2.997-2.28 1.091-.031 2.195.25 3.561.422zm-16.269 11.027c-.166.33-.258.607-.429.821-.103.128-.356.25-.49.208-.127-.04-.262-.294-.265-.456-.021-1.299-.021-2.599.001-3.896.002-.159.178-.314.274-.471.184.117.446.193.537.362.169.314.208.696.356 1.024.668 1.482 2.021 2.409 3.573 2.184.649-.093 1.45-.586 1.772-1.138.434-.741-.086-1.504-.814-1.925-.979-.566-1.993-1.075-3.009-1.571-2.297-1.121-3.266-2.972-2.443-4.719.818-1.737 3.33-2.46 5.429-1.556.256.11.499.25.7.354l1.078-.886c.113.317.185.426.186.535.008 1.216.005 2.431.005 3.646l-.317.212c-.211-.27-.504-.509-.619-.814-.573-1.532-1.48-2.381-2.81-2.219-.624.075-1.419.504-1.726 1.018-.45.755.2 1.361.885 1.729.963.519 1.949.992 2.926 1.483 2.418 1.213 3.269 2.898 2.434 4.824-.813 1.876-3.346 2.847-5.517 2.077-.564-.199-1.087-.52-1.717-.826z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#494949\" d=\"M65.261 1.395C38.48.917 16.103 22.648 16.096 49c-.008 27.11 21.338 48.739 48.077 48.699 26.49-.039 47.932-21.587 47.932-48.167C112.104 23.384 90.76 1.85 65.261 1.395zm-1.148 93.887c-25.326.006-45.694-20.529-45.693-46.067.001-24.88 20.685-45.48 45.674-45.489 25.432-.008 45.695 20.654 45.687 46.587-.008 24.483-20.807 44.964-45.668 44.969zm24.395-59.347c-.994-1.638-2.216-3.227-2.778-5.013-.64-2.032-1.171-4.345-.832-6.382.576-3.454 3.225-5.169 6.812-5.497C72.086.83 41.248 7.349 29.885 27.138c4.374-.203 8.55-.468 12.729-.524.791-.011 2.1.657 2.286 1.277.416 1.385-.748 1.868-1.986 1.963-1.301.102-2.604.199-4.115.314l14.935 44.494c.359-.587.507-.752.572-.945 2.762-8.255 5.54-16.505 8.232-24.784.246-.755.124-1.755-.146-2.531-1.424-4.111-3.13-8.133-4.379-12.294-.855-2.849-1.988-4.692-5.355-4.362-.574.056-1.273-1.178-1.916-1.816.777-.463 1.548-1.316 2.332-1.328a659.24 659.24 0 0 1 20.572.006c.786.013 1.557.889 2.335 1.364-.681.622-1.267 1.554-2.063 1.794-1.276.385-2.691.312-4.218.448l14.953 44.484c2.266-7.524 4.374-14.434 6.422-21.36 1.83-6.182.74-11.957-2.567-17.403zM52.719 88.149c-.092.267-.097.563-.168 1.007 8.458 2.344 16.75 2.175 25.24-.685l-12.968-35.52c-4.151 12.064-8.131 23.63-12.104 35.198zm-6.535-1.606L26.646 32.947c-8.814 17.217-2.109 43.486 19.538 53.596zm54.452-55.403c-.27 2.994-.082 6.327-.941 9.362-2.023 7.152-4.496 14.181-6.877 21.229-2.588 7.66-5.28 15.286-7.927 22.927 12.437-7.372 19.271-18.253 20.359-32.555.62-8.14-2.188-19.412-4.614-20.963z\"/></svg>"

/***/ }),

/***/ "../src/components/wordpress/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WordpressOriginal = __webpack_require__("../src/components/wordpress/original/WordpressOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WordpressOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/wordpress/plain-wordmark/WordpressPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _WordpressPlainWordmark = __webpack_require__("../src/components/wordpress/plain-wordmark/WordpressPlainWordmark.svg");
	
	var _WordpressPlainWordmark2 = _interopRequireDefault(_WordpressPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** WordpressPlainWordmark */
	function WordpressPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'WordpressPlainWordmark',
	    svg: _WordpressPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	WordpressPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = WordpressPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/wordpress/plain-wordmark/WordpressPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#494949\" d=\"M59.628 114.382c-2.417-.216-4.859-.142-7.291-.161-.237-.001-.477.26-.715.399.209.135.414.378.629.388 1.14.056 1.579.73 1.589 1.753.021 2.23.049 4.463-.011 6.691-.038 1.381-.794 1.98-2.187 1.742-.696-.12-1.454-.381-1.989-.817-1.206-.982-2.291-2.114-3.516-3.272l.729-.272c1.902-.723 2.743-1.848 2.604-3.486-.126-1.494-1.361-2.79-3.233-2.949-2.377-.201-4.777-.147-7.167-.177-.181-.003-.364.207-.547.318.183.157.36.445.548.453 1.356.052 1.684.893 1.679 2.045a641.115 641.115 0 0 0-.003 6.202c.006 1.124-.375 1.884-1.627 1.989-.209.018-.398.266-.597.408.245.127.488.36.736.364 1.865.03 3.732.031 5.597-.002.238-.003.472-.255.707-.392l-.625-.401c-.481-.306-1.267-.526-1.381-.935-.27-.966-.22-2.02-.299-3.037l.447-.147c.287.32.589.627.858.961.892 1.104 1.754 2.231 2.668 3.316.238.282.627.625.944.623 3.971-.028 7.952.026 11.909-.243 2.264-.154 4.024-1.462 4.759-3.773 1.205-3.791-1.092-7.222-5.215-7.588zM43 119.925v-4.516c1-.136 2.555-.324 3.188.752.417.708.396 1.913.094 2.69-.54 1.386-2.282 1.106-3.282 1.074zm18.661 2.964c-.658 1.474-3.013 2.423-4.47 1.842-.37-.147-.769-.772-.78-1.187-.07-2.695-.036-5.395-.036-8.18 1.951-.061 3.907-.244 5.083 1.603 1.191 1.872 1.084 3.949.203 5.922zm39.111 1.74c-.986.303-2.355.395-3.198-.068-1.653-.908-.585-2.676-.894-4.058 2.114-.189 2.108-.188 2.841 1.583.06.146.261.231.397.346.121-.214.342-.425.347-.641.031-1.38.025-2.761 0-4.141-.004-.185-.19-.366-.39-.724-.345.77-.343 1.565-.793 1.886-.537.383-2.082.358-2.082.538v-4.065c1 .07 2.132.185 3.217.189 1.418.005 1.275 1.487 1.962 2.204l.303-.136-.204-3.214c-2.949-.377-9.75-.188-10.456.332.22.13.397.327.582.33 1.356.019 1.711.857 1.717 2.013.006 1.948.054 3.897.013 5.845-.049 2.319-1.375 3.078-3.317 1.748-1.374-.94-2.507-2.234-3.491-3.135 1.037-1.035 2.216-1.766 2.726-2.818.932-1.928-.621-4.022-3.133-4.257-2.296-.214-4.619-.138-6.931-.16-.225-.002-.451.21-.677.323.191.154.379.435.576.441 1.368.048 1.673.937 1.689 2.058.024 1.624.037 3.247.038 4.87.003 2.602-.003 2.602-2.247 3.508l-.156.303c.31.103.587.271.866.275 1.827.024 3.653.025 5.48-.001.272-.005.541-.197.812-.303-.264-.175-.514-.468-.793-.5-.949-.107-1.362-.676-1.418-1.534-.055-.82-.012-1.647-.012-2.802.486.454.788.679 1.02.962.926 1.13 1.868 2.25 2.726 3.432.436.6.919.779 1.633.773 4.141-.03 8.296-.013 12.439-.019.307 0 1.036-.05 1.036-.086v-3.096c-1 .628-1.388 1.543-2.228 1.799zM84 119.916v-4.485c2-.262 3.524.423 3.584 2.121.062 1.761-.584 2.469-3.584 2.364zm-57.635-8.715c-.87-.695-6.152-.641-6.827.108.391.104.715.235 1.05.274 1.017.114 1.368.745 1.098 1.618-.778 2.521-1.637 5.017-2.564 7.829-.21-.539-.303-.75-.375-.969-.904-2.728-1.791-5.46-2.722-8.179-.142-.415-.481-.762-.729-1.14-.251.366-.596.699-.737 1.104-1.025 2.937-2.008 5.887-3.004 8.834l-.267.03c-.735-2.229-1.481-4.452-2.204-6.686-.573-1.766-.441-1.977 1.378-2.526.189-.059.339-.241.508-.367-.156-.132-.312-.378-.47-.379a316.326 316.326 0 0 0-6.819-.001c-.159.002-.317.245-.475.375.126.121.248.344.38.35 2.022.098 2.517 1.628 3.012 3.167 1.154 3.584 2.306 7.17 3.474 10.751.136.417.363.806.547 1.207l.354-.022 3.62-10.788 3.578 10.821.422-.03c.151-.388.319-.771.452-1.166 1.278-3.804 2.56-7.605 3.818-11.415.47-1.425 1.234-2.457 2.884-2.521.193-.007.381-.167.618-.279zm48.57-.195c-2.925-.34-5.906-.203-8.863-.247-.152-.003-.309.25-.588.491.38.125.59.247.805.256 1.422.058 2.056.896 2.072 2.206.037 3.081.041 6.162-.003 9.243-.019 1.271-.567 2.18-2.03 2.235-.225.009-.438.307-.656.472.262.117.521.333.785.336 2.19.026 4.383.027 6.574-.002.251-.003.499-.237.75-.363-.229-.154-.445-.422-.685-.442-1.061-.091-1.811-.536-1.924-1.65-.135-1.317-.182-2.645-.274-4.098 1.048 0 1.942.068 2.823-.013 2.088-.19 3.933-.875 4.681-3.064.835-2.441-.698-5.039-3.467-5.36zm.418 5.783c-.646 1.189-1.353 1.445-4.353 1.167v-5.888c1 .057 3.176-.404 4.236 1.154.765 1.128.765 2.375.117 3.567zm-39.627-1.337c-2.715-2.301-7.089-2.199-9.733.171-2.452 2.198-2.764 5.65-.711 8.192 1.446 1.791 3.397 2.543 5.794 2.647.422-.052.998-.063 1.542-.201 2.618-.664 4.544-2.126 5.219-4.856.598-2.42-.273-4.394-2.111-5.953zm-1.758 8.423c-1.72 2.194-5.234 1.731-6.549-.736-.882-1.653-.956-3.408-.384-5.18.645-1.992 1.969-2.971 3.939-2.967 1.977.004 3.322.979 3.964 2.949.223.686.31 1.416.458 2.125l.224.147c-.536 1.233-.85 2.64-1.652 3.662zm88.132-4.589c-1.083-.547-2.206-1.039-3.215-1.703-.386-.254-.78-.998-.671-1.374.134-.461.734-.961 1.233-1.11 1.454-.436 2.728.462 3.318 2.117.117.329.584.596.795.891.086-.064.438-.13.438-.195v-4.376c-1 .449-.987.708-1.071.782-1.367-.173-2.56-.453-3.654-.42-1.475.043-2.711 1.069-3.043 2.28-.372 1.355.103 2.691 1.36 3.618.355.261.747.462 1.141.665.9.461 1.823.87 2.702 1.37.8.455 1.54 1.057 1.218 2.124-.355 1.166-1.357 1.292-2.381 1.187-1.795-.185-2.802-1.284-3.325-2.94-.079-.25-.349-.442-.528-.66-.115.141-.327.28-.33.423-.023 1.477-.015 2.954-.015 4.431l.38.116.857-1.126c.561.267 1.121.604 1.728.811 2.199.742 4.653-.252 5.462-2.173.799-1.893-.042-3.545-2.399-4.738zm-10.819-.016c-.978-.491-1.963-.965-2.926-1.483-.687-.367-1.336-.974-.886-1.729.307-.514 1.102-.942 1.727-1.018 1.329-.162 2.235.687 2.809 2.219.115.306.409.545.62.814l.316-.212c0-1.216.002-2.431-.005-3.646-.001-.109-.073-.218-.187-.535l-1.078.886c-.201-.104-.443-.243-.7-.354-2.099-.904-4.61-.182-5.429 1.556-.822 1.747.146 3.598 2.443 4.719a48.242 48.242 0 0 1 3.009 1.571c.729.421 1.248 1.184.814 1.925-.322.552-1.123 1.045-1.772 1.138-1.552.226-2.904-.701-3.573-2.184-.147-.328-.187-.71-.355-1.024-.091-.169-.353-.245-.537-.362-.096.156-.271.312-.273.471a117.673 117.673 0 0 0-.002 3.896c.003.162.139.416.266.456.134.042.387-.08.49-.208.17-.214.263-.491.429-.821.629.307 1.152.627 1.719.827 2.17.77 4.704-.201 5.517-2.077.832-1.927-.018-3.613-2.436-4.825zM64.172 97.698c26.49-.039 47.933-21.587 47.932-48.167 0-26.147-21.344-47.682-46.844-48.137C38.48.917 16.103 22.648 16.096 49c-.009 27.109 21.338 48.738 48.076 48.698zm-.078-93.971c25.432-.008 45.695 20.654 45.687 46.587-.008 24.482-20.808 44.964-45.667 44.969-25.327.005-45.695-20.53-45.694-46.068.001-24.88 20.685-45.48 45.674-45.488zM44.9 27.891c.416 1.385-.748 1.868-1.986 1.963-1.301.102-2.604.199-4.115.314l14.935 44.494c.359-.587.507-.752.572-.945 2.762-8.255 5.54-16.505 8.232-24.784.246-.755.124-1.755-.146-2.531-1.424-4.111-3.13-8.133-4.379-12.294-.855-2.849-1.988-4.692-5.354-4.362-.574.056-1.273-1.178-1.916-1.816.777-.463 1.548-1.316 2.332-1.328a659.241 659.241 0 0 1 20.572.006c.785.013 1.557.889 2.335 1.364-.681.622-1.268 1.554-2.063 1.794-1.276.385-2.691.312-4.218.448l14.953 44.484c2.266-7.524 4.373-14.434 6.422-21.36 1.829-6.184.739-11.958-2.567-17.404-.994-1.638-2.216-3.227-2.778-5.013-.641-2.032-1.172-4.345-.832-6.382.575-3.454 3.225-5.169 6.812-5.497C72.085.83 41.248 7.349 29.885 27.138c4.374-.203 8.55-.468 12.729-.524.791-.01 2.1.657 2.286 1.277zm7.819 60.258c-.092.267-.097.563-.168 1.007 8.458 2.344 16.751 2.175 25.24-.685l-12.969-35.52c-4.15 12.064-8.131 23.63-12.103 35.198zm-6.535-1.606L26.646 32.947c-8.814 17.217-2.109 43.486 19.538 53.596zm59.066-34.439c.619-8.141-2.188-19.413-4.614-20.963-.27 2.994-.082 6.327-.941 9.362-2.022 7.152-4.495 14.181-6.877 21.229-2.589 7.66-5.28 15.286-7.928 22.927 12.437-7.373 19.272-18.254 20.36-32.555z\"/></svg>"

/***/ }),

/***/ "../src/components/wordpress/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WordpressPlainWordmark = __webpack_require__("../src/components/wordpress/plain-wordmark/WordpressPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WordpressPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/wordpress/plain/WordpressPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _WordpressPlain = __webpack_require__("../src/components/wordpress/plain/WordpressPlain.svg");
	
	var _WordpressPlain2 = _interopRequireDefault(_WordpressPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** WordpressPlain */
	function WordpressPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'WordpressPlain',
	    svg: _WordpressPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	WordpressPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = WordpressPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/wordpress/plain/WordpressPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#494949\" d=\"M64.094 126.224c34.275-.052 62.021-27.933 62.021-62.325 0-33.833-27.618-61.697-60.613-62.286C30.85.995 1.894 29.113 1.885 63.21c-.01 35.079 27.612 63.064 62.209 63.014zM63.993 4.63c32.907-.011 59.126 26.725 59.116 60.28-.011 31.679-26.925 58.18-59.092 58.187-32.771.007-59.125-26.563-59.124-59.608.002-32.193 26.766-58.848 59.1-58.859zM39.157 35.896c.538 1.793-.968 2.417-2.569 2.542-1.685.13-3.369.257-5.325.406 6.456 19.234 12.815 38.183 19.325 57.573.464-.759.655-.973.739-1.223 3.574-10.682 7.168-21.357 10.651-32.069.318-.977.16-2.271-.188-3.275-1.843-5.32-4.051-10.524-5.667-15.908-1.105-3.686-2.571-6.071-6.928-5.644-.742.073-1.648-1.524-2.479-2.349 1.005-.6 2.003-1.704 3.017-1.719a849.593 849.593 0 0 1 26.618.008c1.018.017 2.016 1.15 3.021 1.765-.88.804-1.639 2.01-2.668 2.321-1.651.498-3.482.404-5.458.58l19.349 57.56c2.931-9.736 5.658-18.676 8.31-27.639 2.366-8.001.956-15.473-3.322-22.52-1.286-2.119-2.866-4.175-3.595-6.486-.828-2.629-1.516-5.622-1.077-8.259.745-4.469 4.174-6.688 8.814-7.113C74.333.881 34.431 9.317 19.728 34.922c5.66-.261 11.064-.604 16.472-.678 1.022-.013 2.717.851 2.957 1.652zm10.117 77.971c-.118.345-.125.729-.218 1.302 10.943 3.034 21.675 2.815 32.659-.886l-16.78-45.96c-5.37 15.611-10.52 30.575-15.661 45.544zm-8.456-2.078l-25.281-69.35c-11.405 22.278-2.729 56.268 25.281 69.35zm76.428-44.562c.802-10.534-2.832-25.119-5.97-27.125-.35 3.875-.106 8.186-1.218 12.114-2.617 9.255-5.817 18.349-8.899 27.468-3.35 9.912-6.832 19.779-10.257 29.666 16.092-9.539 24.935-23.618 26.344-42.123z\"/></svg>"

/***/ }),

/***/ "../src/components/wordpress/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WordpressPlain = __webpack_require__("../src/components/wordpress/plain/WordpressPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WordpressPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/yarn/original-wordmark/YarnOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _YarnOriginalWordmark = __webpack_require__("../src/components/yarn/original-wordmark/YarnOriginalWordmark.svg");
	
	var _YarnOriginalWordmark2 = _interopRequireDefault(_YarnOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** YarnOriginalWordmark */
	function YarnOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'YarnOriginalWordmark',
	    svg: _YarnOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	YarnOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = YarnOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/yarn/original-wordmark/YarnOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Yarn\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#2c8ebb}</style></defs><title>Artboard 5</title><g id=\"original-wordmark\"><path class=\"cls-1\" d=\"M79 63.87a16.8 16.8 0 0 1-3.73 6.75v-14.9A2 2 0 0 0 73 53.86c-.59 0-1.1.3-1.1.72a9.14 9.14 0 0 1 .1 1.36v6.83c-.51 3-1.78 5.73-3.48 5.73-1.23 0-2-1.23-2-3.52a30.76 30.76 0 0 1 1.23-8.57c.17-.64 1.4-2.33-.68-2.33-2.25 0-2 .85-2.25 1.57a41.45 41.45 0 0 0-1.42 9.55c0 3.69 1.55 6.11 4.39 6.11 1.82 0 3.14-1.23 4.16-2.93v5.39c-2.8 2.46-5.26 4.63-5.26 8.91 0 2.72 1.7 4.88 4.07 4.88 2.16 0 4.41-1.57 4.41-6v-7.37a18.42 18.42 0 0 0 6.2-9.42 2 2 0 0 0 0-.42A1.87 1.87 0 0 0 80 62.6c-.42 0-.76.38-1 1.27zm-8.15 21c-.68 0-1.1-1-1.1-2.33A7.41 7.41 0 0 1 72 77v4.54c0 .81.17 3.35-1.19 3.35z\"/><path class=\"cls-1\" d=\"M91.16 68.46c-1 0-1.44-1-1.44-2v-7a2 2 0 0 0-2.29-1.87c-.59 0-1.1.3-1.1.72a9.14 9.14 0 0 1 .17 1.36v6.54c-.47 1.19-1.23 2.21-2.38 2.21-1.49 0-2.42-1.27-2.42-3.48 0-6.11 3.78-8.87 7-8.87.42 0 .85.08 1.23.08s.55-.25.55-1a1.76 1.76 0 0 0-2-1.78c-5.18 0-10.1 4.33-10.1 11.42 0 3.61 1.74 6.41 5.05 6.41a4.72 4.72 0 0 0 3.65-1.74 3.75 3.75 0 0 0 3.27 1.74c3.65 0 5.35-3.82 6.07-6.62a1.12 1.12 0 0 0 0-.3A1.87 1.87 0 0 0 95 62.6c-.42 0-.85.38-1 1.27-.38 1.87-1.15 4.58-2.84 4.58z\"/><path class=\"cls-1\" d=\"M103.43 71.26c3.65 0 5.31-3.82 6.07-6.62v-.3a1.87 1.87 0 0 0-1.49-1.74c-.42 0-.85.38-1 1.27-.38 1.87-1.1 4.58-3.06 4.58-1.15 0-1.7-1.1-1.7-2.29 0-4.24 1.91-9.25 1.91-9.76.17-1-1.53-2.38-2-2.38h-2.21a15.82 15.82 0 0 1-2.25-.17 2.69 2.69 0 0 0-2.7-2.24 2 2 0 0 0-2.12 2 3.12 3.12 0 0 0 1.82 2.72 39.41 39.41 0 0 1-.7 7.33c-.38 1.44 1.82 3 2.38 1.19A34 34 0 0 0 97.49 57h3.69a27.53 27.53 0 0 0-2.12 9.38c0 3.73 2.38 4.84 4.37 4.84z\"/><path class=\"cls-1\" d=\"M107.21 69.39a1.78 1.78 0 0 0 2 1.87c1.23 0 1.19-1 1.19-1.82v-6.2c.3-3.35 2.93-7 4.16-7 .81 0 .89 1.1.89 2.42v8.62c0 2.16 1.32 4 3.57 4 3.65 0 5.45-3.82 6.18-6.62a1.12 1.12 0 0 0 0-.3 1.87 1.87 0 0 0-1.49-1.74c-.42 0-.85.38-1 1.27-.38 1.87-1.25 4.58-2.95 4.58-1.1 0-1.1-1.57-1.1-2v-8.75c0-2-.68-4.29-3.52-4.29-2.08 0-3.61 1.82-4.75 4.2v-1.91a2 2 0 0 0-2.29-1.87c-.59 0-1.1.3-1.1.72a9.14 9.14 0 0 1 .17 1.36v13.46zM57.7 64\"/><g id=\"icon\"><path class=\"cls-1\" d=\"M45.35 71.28a9.82 9.82 0 0 0-4.94 1.86c-2.62 1.62-3.92 1.51-3.92 1.51v-.07c-.18-.29.83-2.91-.3-6-1.23-3.41-3.18-4.23-3-4.49a16.2 16.2 0 0 0 3-6.25c.4-2 .29-5.35-.6-7.09-.17-.32-1.65.54-1.65.54a21.21 21.21 0 0 0-1.77-3.34c-1.25-.8-2.61 3.32-2.61 3.32a6.09 6.09 0 0 0-5.1 2 4.2 4.2 0 0 1-1.68 1c-.18.06-.4.05-.94 1.51-.83 2.23 1.41 4.71 1.41 4.71a12.07 12.07 0 0 0-3.66 4.23 10.79 10.79 0 0 0-.76 5.09s-1.9 1.65-2 3.35a5.6 5.6 0 0 0 .77 3.41.84.84 0 0 0 1.15.4s-1.26 1.47-.08 2.1 2.89.89 3.85-.08c.7-.7.83-2.25 1.09-2.89.06-.15.27.25.47.45a4.35 4.35 0 0 0 .59.44 1.82 1.82 0 0 0-1 2.4c.23.55 1.05.91 2.4.9a71.93 71.93 0 0 0 7.45-.67 1.89 1.89 0 0 0 1.14-.64 27.45 27.45 0 0 0 6.74-3.05 12.13 12.13 0 0 1 4.58-2.11 1.25 1.25 0 0 0-.63-2.54z\"/><path class=\"cls-1\" d=\"M30 37a27 27 0 1 0 27 27 27 27 0 0 0-27-27zm16.24 38.25a10.83 10.83 0 0 0-4.1 1.9 29.18 29.18 0 0 1-6.78 3.13 3.79 3.79 0 0 1-1.58.77 68.25 68.25 0 0 1-7.8.71h-.1a4.26 4.26 0 0 1-3.26-1.11 5.45 5.45 0 0 1-4.77-.3 2.42 2.42 0 0 1-1.29-1.7 2.6 2.6 0 0 1 0-.9 2.9 2.9 0 0 1-.34-.44 7.14 7.14 0 0 1-1-4.38 6.85 6.85 0 0 1 2-3.85 12.44 12.44 0 0 1 .85-5.08 11.68 11.68 0 0 1 3-3.91 5.82 5.82 0 0 1-.74-5c.51-1.36.93-2.11 1.85-2.43a3 3 0 0 0 1.09-.58 7.69 7.69 0 0 1 5.17-2.48c.08-.21.18-.42.28-.64A4.6 4.6 0 0 1 31 46.37a2.13 2.13 0 0 1 1.92.22c.28.19.65.42 1.7 2.6a2 2 0 0 1 1.24 0 1.66 1.66 0 0 1 1 .84c1.07 2.06 1.22 5.74.75 8.11a14.72 14.72 0 0 1-2.54 5.8A11.21 11.21 0 0 1 37.61 68a11.07 11.07 0 0 1 .62 4.53 12.5 12.5 0 0 0 1.36-.74 11.36 11.36 0 0 1 5.74-2.1 2.88 2.88 0 0 1 3 2.48 2.77 2.77 0 0 1-2.09 3.08z\"/></g></g></svg>"

/***/ }),

/***/ "../src/components/yarn/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _YarnOriginalWordmark = __webpack_require__("../src/components/yarn/original-wordmark/YarnOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YarnOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/yarn/original/YarnOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _YarnOriginal = __webpack_require__("../src/components/yarn/original/YarnOriginal.svg");
	
	var _YarnOriginal2 = _interopRequireDefault(_YarnOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** YarnOriginal */
	function YarnOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'YarnOriginal',
	    svg: _YarnOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	YarnOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = YarnOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/yarn/original/YarnOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Yarn\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><defs><style>.cls-1{fill:#2c8ebb}</style></defs><title>Artboard 7</title><g id=\"original\"><path class=\"cls-1\" d=\"M99.24 80.71C94.9 80.76 91.1 83 87.89 85c-6 3.71-9 3.47-9 3.47l-.1-.17c-.41-.67 1.92-6.68-.69-13.84-2.82-7.83-7.3-9.72-6.94-10.32 1.53-2.59 5.36-6.7 6.89-14.36.91-4.64.67-12.28-1.39-16.28-.38-.74-3.78 1.24-3.78 1.24s-3.18-7.09-4.07-7.66c-2.87-1.84-6 7.61-6 7.61a14 14 0 0 0-11.71 4.5 9.64 9.64 0 0 1-3.85 2.27c-.41.14-.91.12-2.15 3.47-1.9 5.07 3.24 10.81 3.24 10.81s-6.13 4.33-8.4 9.72a24.78 24.78 0 0 0-1.75 11.68s-4.36 3.78-4.64 7.68a12.87 12.87 0 0 0 1.77 7.83 1.94 1.94 0 0 0 2.63.91s-2.9 3.38-.19 4.81c2.47 1.29 6.63 2 8.83-.19 1.6-1.6 1.92-5.17 2.51-6.63.14-.34.62.57 1.08 1a10 10 0 0 0 1.36 1s-3.9 1.68-2.3 5.51c.53 1.27 2.42 2.08 5.51 2.06 1.15 0 13.76-.72 17.12-1.53a4.33 4.33 0 0 0 2.61-1.46 63 63 0 0 0 15.49-7c4.74-3.09 6.68-3.93 10.51-4.84 3.16-.75 2.95-5.65-1.24-5.58z\"/><path class=\"cls-1\" d=\"M64 2a62 62 0 1 0 62 62A62 62 0 0 0 64 2zm37.3 87.83c-3.35.81-4.91 1.44-9.41 4.36a67 67 0 0 1-15.56 7.18 8.71 8.71 0 0 1-3.64 1.77c-3.81.93-16.88 1.63-17.91 1.63h-.24c-4 0-6.27-1.24-7.49-2.54-3.4 1.7-7.8 1-11-.69a5.55 5.55 0 0 1-3-3.9 6 6 0 0 1 0-2.06 6.66 6.66 0 0 1-.79-1A16.38 16.38 0 0 1 30 84.52c.29-3.73 2.87-7.06 4.55-8.83A28.56 28.56 0 0 1 36.61 64a26.82 26.82 0 0 1 6.82-9c-1.65-2.78-3.33-7.06-1.7-11.42 1.17-3.11 2.13-4.84 4.24-5.58a6.84 6.84 0 0 0 2.51-1.34A17.65 17.65 0 0 1 60.34 31c.19-.48.41-1 .65-1.46 1.6-3.4 3.3-5.31 5.29-6a4.88 4.88 0 0 1 4.4.5c.65.43 1.48 1 3.9 6a4.69 4.69 0 0 1 2.85-.1 3.81 3.81 0 0 1 2.39 1.94c2.47 4.74 2.8 13.19 1.72 18.62a33.8 33.8 0 0 1-5.84 13.31 25.73 25.73 0 0 1 5.77 9.43 25.42 25.42 0 0 1 1.41 10.41A28.7 28.7 0 0 0 86 81.91c3.06-1.89 7.68-4.74 13.19-4.81a6.62 6.62 0 0 1 7 5.7 6.35 6.35 0 0 1-4.89 7.03z\"/></g></svg>"

/***/ }),

/***/ "../src/components/yarn/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _YarnOriginal = __webpack_require__("../src/components/yarn/original/YarnOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YarnOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/yii/original-wordmark/YiiOriginalWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _YiiOriginalWordmark = __webpack_require__("../src/components/yii/original-wordmark/YiiOriginalWordmark.svg");
	
	var _YiiOriginalWordmark2 = _interopRequireDefault(_YiiOriginalWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** YiiOriginalWordmark */
	function YiiOriginalWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'YiiOriginalWordmark',
	    svg: _YiiOriginalWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	YiiOriginalWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = YiiOriginalWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/yii/original-wordmark/YiiOriginalWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><defs><path id=\"a\" d=\"M92.716 94.493c.239-.085.437-.178.588-.267.253-.153.385-.311.385-.471s-.132-.314-.385-.467a3.506 3.506 0 0 0-.602-.274c-2.229-.823-8.078-1.529-16.038-1.992a350.878 350.878 0 0 0-8.607-.367 427.01 427.01 0 0 0-12.81-.186c-4.491 0-8.801.064-12.809.186-3.066.092-5.952.221-8.605.367-7.961.463-13.81 1.169-16.039 1.992a3.69 3.69 0 0 0-.604.274c-.253.153-.385.307-.385.467s.132.317.385.471c.153.089.351.181.59.267 2.218.827 8.069 1.536 16.039 1.992 2.658.153 5.548.278 8.62.371 4.008.121 8.317.189 12.809.189 4.492 0 8.802-.068 12.81-.189 3.069-.093 5.963-.217 8.618-.371 7.969-.456 13.824-1.165 16.04-1.992z\"/></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#b)\"><defs><path id=\"c\" d=\"M16.806 90.47h76.883v6.575H16.806z\"/></defs><clipPath id=\"d\"><use xlink:href=\"#c\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#d)\"><image overflow=\"visible\" width=\"120\" height=\"14\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAawBrAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGWAAAB5gAAAjX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABAAeAMBIgACEQEDEQH/ xAB5AAADAQEBAAAAAAAAAAAAAAAAAQIDBAYBAQAAAAAAAAAAAAAAAAAAAAAQAAMAAwADAQAAAAAA AAAAAAABAgMEBTARFRARAAIBAwMEAwAAAAAAAAAAAAABITGRAhFBMhAgcQOBsSISAQAAAAAAAAAA AAAAAAAAADD/2gAMAwEAAhEDEQAAAPfghS5CGiE8y0g0eQdOmGpYB//aAAgBAgABBQDwf//aAAgB AwABBQDwf//aAAgBAQABBQA9oeSUPPCHs40PdhD6EIXTxD6mE+piPpaxPR1m52sFCuGe0/xymPFL HgQ9X2PShj58MfLTa5UHy4HysZPLhONLHJOGJEkj/9oACAECAgY/AA//2gAIAQMCBj8AD//aAAgB AQEGPwAqV6blDiz9Yv4IxyOLN7GmrXlEZXj7IyVyOypUqVIz0J9jsc3Yj2OyJzdirZCIP//Z\" transform=\"matrix(.672 0 0 -.672 15.133 98.695)\"/></g></g><defs><path id=\"e\" d=\"M16.806 97.045V90.47h76.883v6.575H16.806\"/></defs><defs><path id=\"g\" d=\"M92.716 94.493c.239-.085.437-.178.588-.267.253-.153.385-.311.385-.471s-.132-.314-.385-.467a3.506 3.506 0 0 0-.602-.274c-2.229-.823-8.078-1.529-16.038-1.992a350.878 350.878 0 0 0-8.607-.367 427.01 427.01 0 0 0-12.81-.186c-4.491 0-8.801.064-12.809.186-3.066.092-5.952.221-8.605.367-7.961.463-13.81 1.169-16.039 1.992a3.69 3.69 0 0 0-.604.274c-.253.153-.385.307-.385.467s.132.317.385.471c.153.089.351.181.59.267 2.218.827 8.069 1.536 16.039 1.992 2.658.153 5.548.278 8.62.371 4.008.121 8.317.189 12.809.189 4.492 0 8.802-.068 12.81-.189 3.069-.093 5.963-.217 8.618-.371 7.969-.456 13.824-1.165 16.04-1.992z\"/></defs><clipPath id=\"f\"><use xlink:href=\"#e\" overflow=\"visible\"/></clipPath><clipPath id=\"h\" clip-path=\"url(#f)\"><use xlink:href=\"#g\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#h)\"><image overflow=\"visible\" width=\"228\" height=\"19\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEA1gDWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHNAAACRgAAAn7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABUA6AMBIgACEQEDEQH/ xAB8AAEBAQEBAQEAAAAAAAAAAAAAAQIEAwUGAQEBAAAAAAAAAAAAAAAAAAAAARAAAgEDAwUBAQAA AAAAAAAAAAECERMUEgQkECBAIQMiIxEAAgIBBQEAAAAAAAAAAAAAADEQQUAgMAERIaESAQAAAAAA AAAAAAAAAAAAAED/2gAMAwEAAhEDEQAAAP35Csw0xDc84npPKHrnxye+efFdU5Ina4h23hHdeCnf r52j6OuHcva5vRfZBoEAgQEgZgkgZABQWhdhrQqgB//aAAgBAgABBQDzv//aAAgBAwABBQDtqVKl SpUqV8L/2gAIAQEAAQUAKlUakaka0XEXUXS8P7mQPdD3ZmGYZhmmaZqM5GbEW9gxbuDFuPmxfaAp xZqRVdGhplGUY0UGhjGMYx9tH0ozSyMZEYSIwkRhIjCRFNdvo9H5PwO2O2O0O0fwHYHjCxjjnGOO cc4osc45GyLQej11/9oACAECAgY/AHf/2gAIAQMCBj8Ad//aAAgBAQEGPwDfYxjHDljHkIQhCFgW P4MsfJZceR50Vp//2Q==\" transform=\"matrix(.337 0 0 -.346 16.806 97.045)\"/></g><defs><path id=\"i\" d=\"M80.783 27.807c-4.38-12.33 8.418-25.557 18.946-25.949 6.307 3.211 11.728 11.646 11.455 23.091-.827 14.104-11.051 26.259-22.176 37.456-.621-13.659-3.59-22.357-8.225-34.598z\"/></defs><clipPath id=\"j\"><use xlink:href=\"#i\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#j)\"><defs><path id=\"k\" d=\"M76.403 1.858h35.054v60.546H76.403z\"/></defs><clipPath id=\"l\"><use xlink:href=\"#k\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#l)\"><image overflow=\"visible\" width=\"60\" height=\"94\" xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABhCAYAAACOGRJmAAAACXBIWXMAABB0AAAQdAFKfdo/AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAACwZJREFUeNrsW8uRK0UQrFKsAZiA FZwxhAgwATziiBmcOHPlhiVKVjv9qX93zz6CA08RWo1GM1JnVda/l+jr4+vjf/Fg+eaPv37+6f3U t/YDZnY3AtDv29/xin6uncV17nqHj/vR7ruO5bl+/Xz/On6O730/bvdcl0KdQ7vuea3g1x++++1v u/43LQX+8f3le2pAOZPQJQ0vRtgbOnoeX/BaEPfPIa5Ff70OwP0txq9f971A8fXzuN5/XP9+3evc 67O+GL7u+P39uQAuAfMQxpIqLwm/fh/MDcPHCq7jIYAIvBFMBL6x5ELVfxtO1jyEMy4iQ8oc+ENo UR5xcrNS2Fj7FIITAKCZgho8ujKgwXD7Qgits9D6x2dGQCuqa9DmgAPAXZtqzU3LQwBKQhX4ZkLt muv+CUop4XUeLLzL/BSXyCnVWAZ8mGQCPNM+d0pLAUigSps88RvwDeokb0D5Ca4J1mh92voOcJ4H LE5wad+svJoVwCXE5o3bIp8GvHZ4+KD3pLSmvLLp7ugCrVc0z53bAGwYENk3pH0b6ikv3zT6/t2P AjxIC0FSnjpIo3V0x3eg9cSrCxomzm2wtP+YEMKMQJ277Gxcgu+x6QpTmvIkKC+dntR6ZOtHzk17 dePqODZs7dR0zFUGMMBPzTP0+xn2bKxu8bw5jkrrzFDsueHVu9Zzxwb23O9ObWh9mIIMW3NxJGy1 X89CW7DuNdA6jKe5fATCHKsGzkYIyTdwt1EphI5YG/8Ajxb6tNZokHMIpdlorXXS15IVyKlzE4C5 8m5K483WOfV8IyxNZkNRHv2DQusQob6rp6L7no2TD2eZZ4dcikk1qQSP5u015YWLTLQO57h26L4F nEQ44waArX3RzJeRUQo6t+7gPxY3PLggZKJ1HSB72FvT/WkEsmfj3IGTAu9cO/vwBpOdkcmzmXjG bhHfvda7WQSadHQ3kYW8re/ZOM84PsFzYOLcnFsSkoab51GHd0EOqkLrRWm3nwvproFGYaXb+WHm NuM4M4cB7WNh/XrYvBxCMJl2ddEz09QF3WeWriJ1bOd5afrmsrEG+jEEwWlI45ZAdG8KgWhWjFC1 8dCliIEc0B260tF+yNi5NYOoL2IfD+vbtKYbxbrNMwUm4K8XsYBk1s+KWXFavHqNymZO/M21Hl4D JwOiU6B/waM9uT8teLUo1h0d0mCZaFHqcgk+rB1WRXiqcWnT7c/j9XxQA/z4eF7HIsNjo0kjgFX/ LgfIJdC8eOIz4EIvQtM0NPxogpgaT0qaqK7J3yxT40qTvNM+Xts4q5g77VsKYYik0TnTHJeLyZuY FcC7MDc0HnWRrdPatj0jmJvt/k18/GWBjxEA5LiAwtf/9oEvAFyCdNMJMR0hnR05QSDPnrIcGhWI NBU7F/2bGwuxaNJCREWWQrnWMNcBzQbE0FAsFAMYbgiKPgd8aLgXCCoVglp4Bw4SPTJAcEFrKWJG P14KCDFgFIzBkcZV2geRg5vKqQ/rhLZjmsPQd1IfS+0hN6HsXuxz4C2kk6i0GD5dVuC6hsX0kpwg NAsGMwI2xWxIRILc9I+ajYDvgc8REURfzQDq41zMse844WgOoyLLAiEkyBGFQYmcMdYkN2y8fT10 W0j06/0PSK13IYDEOaQ0L1mASN9wui/pjyOv3o9bc59UFThGlsqJSI0PyhsWHNFcnOumA+iNBgb0 DL+1pnPgzkia9hPjkgu0oKfjMyzYpDkCC4fTpgmlm5zwwNUMn3VX1BB1LlqANds3lO/v73GT5tD+ AdLkg9wBuyMkqEGBmn0GPTfjwaGs2Xj86QAVG9Q9X4DmGXt3w1nvl21FWbOomdNP0E/h/QmaoFPb QoN3aY51rrBl41IACMjuMiVJcxXmMM1ICIgkQxSd9a6p+zTfpPpTzEfkhJfVJgDjRlzCIhwZtKZh t3pBOj4SmR5cjnCH5gfhTLSBSe/Y4oLu8sfnj05QNWio+J9pe3j6L0DzUOOjPd49+iJPRljGilUq ehvQEcWX2t6n+ZGNy51LajNS0OGwEocKc5LeFIKWJqHNxDu9SNsILFnTHDecG+kpiN9Ooiu07NiC QXTOUNwmM0ttI0+J9+pxFP0PO3A2GReFGZiw1xVoQmoSBG1ClbZh4v4Nry7HM0GRJ7ozIO/ZSWlZ QIMQiLDrZ+L0yNo6ZDistI39+fiwDzvbTzshMVjt4a2jgtO0BE3RLmZb85sIQuozbLUijMb1MDC3 b2fqsZMLtG+BwYB+2rR3VfAYM7M5xKbGnyQm2aMMZSx6m6jpTgG1pSPzzAjsGiYllgVPYtu4k7mN raPKzutmMCInB51yatAQnj4GLbUoKW4BwlSBZ81GBI2+ZH8fgi4oXLsn8NqwAKxNUyiMjOK67RWV wSfOTQ46YbZCJz3QCKwqQmyMtvn8LuiC4rbvd2zj2RyqnH3A8kBkXOQnM2RCHdleXQU6SHudEBdV ylvZpjnoU3uwxv4R26D39Dlo2VdTTQ6KOz3bGn9CuzFwPYdENm8L2rsIanZJV1qCtr09axaG4qAD Gzea79uhsRjpOh+Lqogh02wIQlYIeobEZ8gQK9yT1pOVEGMxf44mpjHYCLDXso/VFjSyBKhT3Hn5 gzg+YrnhsixNUUw8kTUlnTlEWo4cmdC0qdXi62/U467jKj/neEyBZQc2dnYxzQNTiEJf4O19oxM3 whkHFAfyyTX8e0QTT9gQZFvSVUyfwHQ1R7rqK8bIW149SlzyfD2aotu8Haa1TEY72iNHoH29Lmr9 oONz5NVVyXW46yAHa9vCCFtWqmYP83raBH3DxrH4v9Jyq0YC1o6WCeYqxN6dIq3vgsZpdRbQ1goh 9eoV2KiERQ2SEq2vQB/m6kgzthpm3IeLxkzO+ZmKSwmA4Ko5su2rEvRpHIfeNL+5A8WksDFYa/++ eoPruFoN0ybo47LUbSZZuTNQPplG0pEpzvmaXW4+MPssCtAHXh27tWhOefhEZtmWCmp2te8Ni9Q2 Af0E3dE4HwUzZN2YpAtLKc2zWXowlQmnOK1heZSrQ/bc9HYAXjYmonl2DLZqUlDWmQ0LGr8Dw+7C +he8et5/QzJh22lSuM5s4vHl1AeiV+8bFCc2LvpsZw8U8TzY+bwATK7eDro5RCno/Vx9BDCcuHUP GPHQHm4+twDs4nqyhyYBva9xRPkajnRsOzI12BwwGa0horbM/JzTO4jjthFxSna1IYBoCdbtpogA R2Mpt3uyEMztBOZGZRYnNUkvbgHY2jIV1I5z/RsdGF5lcFjn8muwNt57j+23h8Z763z2drvZuBfP ovZ73ZCI9q0EgF1MRjxLc03HNYPzjQGLBGBNd1uj12AzwLSwZXK1ut9McJzA7DYjYDiPMpuj0Pm5 3Q8GsPcBMPF97pEH0ZmN20bE+QCpMoUaLGUAI1q7VDULecc9t6PyLNwoUM7WQrA2UQlCncvi9D8C 2b7etsbLXU83wxqyMXTq0WvAtNLynXD2NBfyTadmx8YnYFeAZ5kOvyfOxfeb4Qyf0TZy7ZcDhxXg Qst+SLE9ULjRedqqy/0oOQRLXpPaYUcmEJWup159jJBuB7MkngdCKfrv4WhZAV0kM65tvbRxq2Xc mqLkref4H/Gi7aFLwK5HZxhwZONJPOYDpxaBzJoTOVgzYVk1JSkfHH6qOsNWz21N7apURWgKOWBK aB2FvBv1+L6HR3ExklJ1BTbK3CihNRGpLV90ovH3xy/vz28+m8REmwqo2EuO9HUOqaNrLEj5FM3x P+nr4+uD/hFgAF37MD594AS9AAAAAElFTkSuQmCC\" transform=\"matrix(.672 0 0 -.672 74.892 63.962)\"/></g></g><defs><path id=\"m\" d=\"M55.961 94.6c-1.76-13.772 3.968-25.514 9.65-32.677 12.354-15.369 11.584-24.598 10.367-32.509 6.5 10.131 10.553 22.275 11.452 33.022.458 8.867-6.008 29.356-31.469 32.164z\"/></defs><clipPath id=\"n\"><use xlink:href=\"#m\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#n)\"><defs><path id=\"o\" d=\"M54.201 29.415h33.687v65.186H54.201z\"/></defs><clipPath id=\"p\"><use xlink:href=\"#o\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#p)\"><image overflow=\"visible\" width=\"56\" height=\"101\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAawBrAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAJkAAADJAAABFT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAGcAOAMBIgACEQEDEQH/ xACkAAACAwEBAAAAAAAAAAAAAAAAAwIEBQEGAQADAQEBAAAAAAAAAAAAAAABAgMABAUQAAEDAwEH BQEBAAAAAAAAAAIAAQMRBAUjEBITQxQ0BiAiMjUWMyQRAAEDAgMHBAMAAAAAAAAAAAEAAgNxsSAR siFhkdEykjQQYnIEMSJCEgAABAQFBQEAAAAAAAAAAAAAARECEMFygjFhkfESIUFxMmKB/9oADAMB AAIRAxEAAADWz44/p+TtGL102ZZDw3oCkQ6UY+xldHJF0ntotkydbY0lajQ1qFJRbJp0W9ajWBpK tOjpVKJFvWkRb1iFxMnSrVvV3SLezI50AXgI8UW6xAAygGzwEe0kJ0ACADZoCt//2gAIAQIAAQUA iijePgxJ4oluBxYv5OSd1XVjfTd07qurG/sd07rmA/sd9nMD47OY3FprLWWpvf/aAAgBAwABBQCW aVpOPKhlmdb58Gb+ogmZU0jHUZlRco299NnLP57OWfz2csuFXRWitLd//9oACAEBAAEFAM75BkbH Jfrcwv1uYX63ML9bmEPlWZdYnPZK6v8Ayr7raEdUEawQ0ynlX3SZndBGhBCCwo0yXlX3Qg7oI6IQ QghBYgaZDyYN7NACEEIIQQgsUNL7yIa5YQQghBCKEVjRpeZ4a5QQQihFCKEVjxpdZsa5IRQihFCC YaKy7rMDXICKEUIJmpssu6yo1vhFCKptsu6yQ1vWGnpsu6yDf6vTZd1d20ck/RQrooV0UK6KFdFC ra1jCf8A/9oACAECAgY/AGGbGmZtLsPRug9G6BOLU4KiZhlJRsmGUlGyYbSUbZhtJRtmG+CjbMEm H4NhsM0ywH//2gAIAQMCBj8AeRPcRE4+493aj3dqF5OXniuQfWY6wvkHn9HG+QdUcb5B1RxvkHeT jfIGuK9cRuNx8rniP//aAAgBAQEGPwCT6313MEbQ0jNuZ2tBXVH2BdUfYF1R9gXVH2BdUfYFDBM5 hjeSHZNyOwEqb4s0jBt9PrnedJU3xZpGKA7zpKm+LNIxQ1Nipj7WaRihqbFSn2s0jFEd5sVIdzNI xR1NipDubpGKOpsVIdzbDFHU2KfRtsUdTYp9G2xR1NinUFsUdTYoudOxhOX6nLP8VXkx8RzXkx8R zXkx8RzXkx8RzXkx8RzTHCdjyP5GWZ2VX//Z\" transform=\"matrix(.672 0 0 -.672 52.241 96.296)\"/></g></g><defs><path id=\"q\" d=\"M47.092 42.307c-18.681-5.096-23.289-21.117-22.455-31.89 18.142-7.18 37.666.175 48.937 15.498 7.902 10.74 12.852 24.506 13.857 36.522-5.424-6.981-12.273-11.029-20.994-14.197-5.97-2.17-11.479-3.606-19.345-5.933z\"/></defs><clipPath id=\"r\"><use xlink:href=\"#q\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#r)\"><defs><path id=\"s\" d=\"M23.803 3.237H87.43v59.2H23.803z\"/></defs><clipPath id=\"t\"><use xlink:href=\"#s\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#t)\"><image overflow=\"visible\" width=\"100\" height=\"92\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAawBrAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAALGAAADzgAABUj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAF4AZQMBIgACEQEDEQH/ xACzAAEAAwEBAQAAAAAAAAAAAAADAAIEBQEGAQACAwEAAAAAAAAAAAAAAAABAwACBAUQAAIBAwMD BAEFAAAAAAAAAAABAgMEBRESExQlNSAzJAYjISIyRBURAAADAwoEBQUAAAAAAAAAAAABAhGSAzAx YZHBgrLSBDQhEmLCUYETs9NBIkIzFBIAAQMBBQYEBwAAAAAAAAAAAAECMgMgITGRkrEScnODhPAR QTRRYYGhQkOT/9oADAMBAAIRAxEAAAD6DOOTndfqX5irHSvz0FN98SReu+ZRRpT2V0zybU/M5NeT L11UkUFUlC1QlilUlC0tT2L0STer5fJrx5+uyii4yigWyCgW6BeLeFBXfKzej5nJqxo67KCKDoCC j3BAtrhaVaF7K9SVm/N81i1YkdfQgIqMgXC3uFxVrD7KtCkHalZux/M4Posdelzk6N1Tn332FMF9 3orhtt9gxTb6BsjTZj//2gAIAQIAAQUAqVainzVDmqnNVOaqc1U3yKvueqr7nqq/z9VVfvfqqQ1k 6TOJnEziZxM2n//aAAgBAwABBQCnRpOk6NIdKmOnAcIG2Boil7TGMY1+pS9ljGho0NCkvwtDQ0NG hoUV+FoaGjQ0NCjXiqLrxHWiOtE5YnLE3I//2gAIAQEAAQUAyeZvba/WfyLFnL9izV8xZe9Ysrds WSumLIXLFfXDFeV2dVWOqrHJPps35WJEiRIkSKIoihI2mnxc35WJEiRIkSJEiRGj+tm/KxIkSJEi RIsixMcjX4uc8tEiRIkWRZFkWRkKRuNfh5zy0WRZFkWRZFkWJikKRuNfgZ192iyLIsiyLIsTFIUj cbjXtuefd4siyLIsTExSFIUjcbjXtWffeIsiyLExMTFIUhSNxuNez/YXpmoyIsixMTFIUhSFI3G4 17L9j81GRGRGQpCkKQpCkbjcbjXsWXtsFPIqz+sitPrYrX68K1wArbAitsGdPhDp8IdPhTp8KdPh jZaf5X//2gAIAQICBj8AciOdc5fUm7Mm7Mm7Mm7Mm7MxX2+99fiP4l22u1H8S2u1H8S2u1HcS2u1 HXtkv5ISZqQkzUhKnrQlT1oSp60MW+33cfFx/9oACAEDAgY/AGKrG+asaq3fIg3Ig3IimRFDBDD9 n2KfLbstdQp8tuy11Sny27LXXKXLbstdwU0VlW6m1LqbvLAhV/m4jU0KRqaFI1NCkamhTB3uN7Dx ef/aAAgBAQEGPwCLAhGkoaOVjUtPiklWidDonS6J0uidLonTUJ01CcqhOVQnKoTlUJyqHqfky0R7 mBMoyi0R7mBMp5WiPcwJlPK0R7mBMo2i0R7mBMo2i0R7mBMo2juGouYEyjaO4ai57aZRvT3DUXPb RKN6e4ai57aJRvT3iMrV6uJC1B8vOhKTMi+1LOJIP6Dhr4rivjHDXRXFfGN7EcV8Y3kRw8g3kR08 g3cR08g3cR08g3UR08g3S3TyDdLdPIN0t08g5PUV/Mz9jDazm8GeNA//2Q==\" transform=\"matrix(.672 0 0 -.672 22.044 64.329)\"/></g></g><defs><path id=\"u\" d=\"M75.98 29.418l.353.556.143.228c.291.467.577.94.857 1.415l.046.079.076.132.07.117.203.346.012.025.274.481.006.011c.199.35.393.703.584 1.055l.025.043.214.395.005.007.231.441.07.129.128.252.16.307.153.303c.157.306.313.616.465.93l.039.078c.274.563.543 1.129.805 1.696l.2.438.02.042.125.281.15.335.084.192.137.31.095.224.203.478.014.032.217.521.025.064c.233.563.458 1.126.673 1.692l.02.05.18.474.011.028.103.278.34.937.042.121.364 1.048.04.11.322.98.052.164.012.035.167.531.009.025.153.506.157.521.003.014.128.442.041.143.077.271.262.944.063.235.121.467.007.021c.146.57.287 1.14.42 1.71l.013.061.013.061c.174.748.334 1.496.481 2.245l.014.075c.226 1.158.42 2.313.584 3.457l.001.018.139 1.051.018.154.059.502v.004l.051.463.014.153.038.371.016.146.006.06.044.506c-4.009-5.16-8.797-8.72-14.542-11.503 4.64-9.16 3.99-15.695 3.095-21.514z\"/></defs><clipPath id=\"v\"><use xlink:href=\"#u\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#v)\"><defs><path id=\"w\" d=\"M72.888 29.418H87.43v33.019H72.888z\"/></defs><clipPath id=\"x\"><use xlink:href=\"#w\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#x)\"><image overflow=\"visible\" width=\"28\" height=\"54\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAawBrAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHWAAACCQAAAoL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIADcAHAMBIgACEQEDEQH/ xACTAAADAQEBAAAAAAAAAAAAAAAAAwUEAQYBAAMBAQAAAAAAAAAAAAAAAAECAwAEEAABAQcFAQEA AAAAAAAAAAABAgAQERIDEwQhIhQ0RDMkEQABAgQFAwUAAAAAAAAAAAABAAIQETFxscESMoIhkZJB UYFCExIAAgIBAwUAAAAAAAAAAAAAAAERAnExsRIQIUGRcv/aAAwDAQACEQMRAAAA9oviYro1TaDD IlyOevaE+gy5EuRG3aM2kVQkHxuA7//aAAgBAgABBQArMQrRSt4VtqHek7F2Zk2Zf//aAAgBAwAB BQAxYRaGkGA0I1E0DNH/2gAIAQEAAQUAyMmrTq8ys3MrNcVx8z7u8eZ93ePM7DvHm9h3izew7xZV IqrWC1gtL+T/2gAIAQICBj8AanyMtllsLct9Mvhblp5zLktHOIU+z//aAAgBAwIGPwAffqhC0Fof /9oACAEBAQY/AC1spCXoqjsqjsv0+2mfynWGEeGSdYYR4ZJ1hhHhknWGEeGSdYYR4ZInU0U6FwBo t7PILezyC0zGyU59Ke6//9k=\" transform=\"matrix(.672 0 0 -.672 71.089 64.415)\"/></g></g><defs><path id=\"y\" d=\"M26.528 119.856v-13.829a.436.436 0 0 0-.435-.436h-2.002a.437.437 0 0 0-.434.436v13.829c0 .239.195.457.434.457h2.002c.24 0 .435-.218.435-.457zm-10.57.415v-14.588c-1.123.023-2.849.756-2.87 2.293v9.989c-.609.087-1.567.175-2.089.175-1.87 0-2.327-1.327-2.327-3.112v-7.132c-.117-1.74-2.079-2.247-2.871-2.195v9.327c0 3.394 1.696 5.465 5.198 5.465.521 0 1.632-.153 2.089-.245v.178c.443 2.86-3.027 1.781-4.907 1.587-1.385 0-2.331 1.141-2.582 2.427.805.261 3.459.597 5.3.742 3.329-.001 5.059-1.821 5.059-4.911zm5.253-.415v-13.829a.436.436 0 0 0-.435-.436h-2.001a.437.437 0 0 0-.436.436v13.829c0 .239.195.457.436.457h2.001c.24 0 .435-.218.435-.457zm-1.436-18.163a1.497 1.497 0 1 1-.002 2.994 1.497 1.497 0 0 1 .002-2.994zm5.331 0a1.497 1.497 0 1 1-.002 2.994 1.497 1.497 0 0 1 .002-2.994z\"/></defs><clipPath id=\"z\"><use xlink:href=\"#y\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#z)\"><defs><path id=\"A\" d=\"M5.599 101.693h21.004v23.487H5.599z\"/></defs><clipPath id=\"B\"><use xlink:href=\"#A\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#B)\"><image overflow=\"visible\" width=\"100\" height=\"106\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBOgE6AAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAALZAAADvwAABUn/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAG0AZAMBIgACEQEDEQH/ xACkAAEBAAMAAwAAAAAAAAAAAAAAAwQFBgECBwEBAQEBAQEAAAAAAAAAAAAAAAUCAQQDEAACAAYA BQMFAQAAAAAAAAAAEgERAgMEBSEUJAYWIiM1IDAyEzQzEQABAgIJBAICAwAAAAAAAAACAQMAkhAw MnKy0jNz0xFxsQQhIjESQVFiEgABAwMEAwEBAAAAAAAAAAABADECECByEXGRkiFRQkEy/9oADAMB AAIRAxEAAADqcbR6f3ze0cW3ntHFjtHFjtHFjtPfiMjj6YJ1Tg9PuNPWih9PmAAAyMfI5r6YI1zg 9RutTWjTUb+c1BNQTUE8ieRzX0cR7fF6vb62nMkq3iSokqJKiVvFud70SqvJa7a6+hPkq3mSokqJ KiVvFed7QTaPNYGzwvd4YrN5isIrCKwjXzTjqhPoaLE2ON6/JjshrOOyBjsgY7IGP719+N6PH7f/ 2gAIAQIAAQUAt41uqjlLRylo5S0cpaI4tqECz/n9FX4lmPtzJkyZVH0lqPtzJkyZVHgW4+iZMmTI x4FuPomTJkyMeBRV6XHHHI1cD//aAAgBAwABBQC5l3abnOXjnLxzl45y8U5l6MS9/r9FP5F6mP7V iLEWIsSmmLF2HuSJEiRTDiXIeuRIkSIQ4lz85EiRIhDiV0xZIiREiJEhTGZ//9oACAEBAAEFANh3 Jg6/K8z1Z5nqzzPVnmerPM9WeZ6s8z1Z5nqzzPVnmerLPd2tvXjur5r7Wv8A7zur5r7Wv/vO6vmv ta/+87p+akSJEiRIkSJEjXw687npnuEEEEEEEEEEMCjrjuSme2UUUUUUUUUUwaetO4oT2qiiiiii iiimFT1hv6Z7NRRRRRRRRRTDp6s3lM9kooooooooopiU9UbqmewUUUUUUUUUUxaepNvTPOUUUUUU UUUUxqeoNpTPMUUUUUUUUUUx6ffNhCxHKXGFxhcYXGFxhcYXGFxhcYXGLNON+4//2gAIAQICBj8A jI66mILpjymPKY8pjyidC3ukMRadqQxFp2pDEWnakcRadqRxFpoPBb0U0upTS6lNLqU0upR8S6mn /9oACAEDAgY/AJRBGkZEMnjwnjwnjwnjwgNYv6pPM2jcUnmbRuKTyNo3pLI2jeksjaKSZz+hfPYL 57BfPYL57BD+ewp//9oACAEBAQY/AC9V5t0nARFVQQVH7J1/k0jSflDkjSflDkjSflDkjSflDkjS flDkjSflDkjSflDkjSflDkjSflDkjSflDkgGRafQnCQEVRDp1Jenz96HroYUq/W3W8SUPXQwpV+t ut4koeuhhSr9bdbxJQ9dDClX6263iSh1f8hhSr9bdDElDt0MKVfr7oYkod7BhSrY3AxJQ52HClWx uBiShzsOFKtncHylDnYfCVbN8fKUH2HxVtXx80H2HxVt3x80F+5EhdE+EFFT8Xki2ciZ4tnImeLZ yJni2ciZ4tnImeLZyJni2ciZ4tnImeLZyJni2ciZ4DoZ9f2Tp9E/u/R//9k=\" transform=\"matrix(.229 0 0 -.229 5.041 125.677)\"/></g></g><path fill=\"#58595B\" d=\"M35.489 105.079v-.745c0-.197-.109-.329-.438-.372a14.116 14.116 0 0 0-1.973-.131c-2.06 0-3.374.7-3.374 3.046v13.145c0 .242.197.438.439.438h1.051a.439.439 0 0 0 .438-.438v-10.078h3.418c.24 0 .416-.176.416-.394v-.746c0-.241-.176-.394-.416-.394h-3.418v-1.533c0-1.294.24-1.491 1.445-1.491h1.95c.309-.001.462-.11.462-.307zm6.997 4.512v-1.007c0-.306-.175-.328-.459-.328-1.819 0-3.331.065-4.58.613-.241.109-.395.263-.395.503v10.648c0 .242.175.438.395.438h1.14c.24 0 .394-.219.394-.438v-9.859c.833-.175 1.557-.219 3.047-.219.414.001.458-.109.458-.351zm9.473 10.013v-10.341c0-.307-.065-.416-.46-.503-1.161-.285-2.717-.503-4.031-.503-3.287 0-4.776 2.124-4.776 5.411v1.533c0 3.286 1.513 5.415 4.776 5.415 1.336 0 2.87-.223 4.031-.507.395-.088.46-.22.46-.505zm-1.929-.832c-.612.109-1.643.219-2.563.219-2.169 0-2.849-1.49-2.849-3.791v-1.533c0-2.323.68-3.791 2.849-3.791.92 0 1.972.11 2.563.219v8.677zm17.843 1.249v-7.931c0-2.257-1.271-3.834-3.899-3.834h-.504c-1.314 0-2.191.219-2.848.788-.68-.613-1.534-.788-2.849-.788h-.503c-2.63 0-3.9 1.577-3.9 3.834v7.931c0 .242.152.438.395.438h1.14c.24 0 .394-.196.394-.438v-7.931c0-1.885.833-2.147 1.973-2.147h.504c1.401 0 1.884.241 1.884 1.49v8.588c0 .242.153.438.395.438h1.139c.241 0 .395-.196.395-.438v-8.588c0-1.249.482-1.49 1.885-1.49h.504c1.16 0 1.972.263 1.972 2.147v7.931c0 .242.153.438.395.438h1.14c.235 0 .388-.196.388-.438zm10.7-5.455v-1.183c0-3.112-1.621-5.126-4.82-5.126-3.133 0-4.864 1.993-4.864 5.126v1.971c0 4.076 2.454 5.262 4.974 5.262 1.468 0 2.673-.131 3.922-.375.351-.066.438-.219.438-.504v-.745c0-.219-.176-.307-.351-.307h-.109c-1.008.153-2.629.241-3.9.241-2.016 0-3.046-.964-3.046-3.571v-.306h7.34c.263-.001.416-.198.416-.483zm-1.95-.986h-5.807v-.197c0-2.366 1.053-3.44 2.937-3.44 1.928 0 2.87.964 2.87 3.44v.197zm17.887 2.124v-6.857a.44.44 0 0 0-.439-.438h-1.029a.44.44 0 0 0-.438.438v6.857c0 2.39-.898 3.265-2.695 3.265-.549 0-1.117-.131-1.753-.285v-9.837a.44.44 0 0 0-.438-.438h-1.073a.44.44 0 0 0-.438.438v9.837c-.635.153-1.205.285-1.753.285-1.84 0-2.694-.875-2.694-3.265v-6.857a.44.44 0 0 0-.438-.438H80.29a.44.44 0 0 0-.438.438v6.857c0 3.879 2.169 4.912 4.425 4.912 1.097 0 1.994-.199 2.915-.529.92.33 1.796.529 2.892.529 2.256 0 4.426-1.033 4.426-4.912zm11.203-.437v-1.665c0-3.221-1.666-5.345-4.887-5.345-3.22 0-4.863 2.124-4.863 5.345v1.665c0 3.22 1.644 5.349 4.863 5.349 3.221 0 4.887-2.13 4.887-5.349zm-1.929 0c0 2.257-.92 3.659-2.958 3.659-2.059 0-2.935-1.424-2.935-3.659v-1.665c0-2.257.897-3.659 2.935-3.659 2.061 0 2.958 1.424 2.958 3.659v1.665zm8.816-5.676v-1.007c0-.306-.175-.328-.459-.328-1.819 0-3.331.065-4.58.613-.241.109-.395.263-.395.503v10.648c0 .242.176.438.395.438h1.14c.241 0 .395-.219.395-.438v-9.859c.833-.175 1.556-.219 3.046-.219.415.001.458-.109.458-.351zm9.801 10.583c0-.065-.022-.153-.066-.197l-4.863-5.872 4.82-5.214a.354.354 0 0 0 .109-.241c0-.131-.109-.241-.328-.241h-1.534c-.219 0-.307.044-.438.197l-4.382 4.93v-9.115a.44.44 0 0 0-.438-.438h-1.053a.44.44 0 0 0-.438.438v15.6c0 .242.197.438.438.438h1.053a.44.44 0 0 0 .438-.438v-5.236l4.36 5.389c.175.219.263.285.504.285h1.577c.154 0 .241-.131.241-.285z\"/></svg>"

/***/ }),

/***/ "../src/components/yii/original-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _YiiOriginalWordmark = __webpack_require__("../src/components/yii/original-wordmark/YiiOriginalWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YiiOriginalWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/yii/original/YiiOriginal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _YiiOriginal = __webpack_require__("../src/components/yii/original/YiiOriginal.svg");
	
	var _YiiOriginal2 = _interopRequireDefault(_YiiOriginal);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** YiiOriginal */
	function YiiOriginal(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'YiiOriginal',
	    svg: _YiiOriginal2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	YiiOriginal.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = YiiOriginal;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/yii/original/YiiOriginal.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><defs><path id=\"a\" d=\"M101.697 123.133c.314-.115.574-.236.774-.354.332-.201.504-.406.504-.615 0-.208-.173-.413-.504-.613a4.724 4.724 0 0 0-.792-.363c-2.927-1.08-10.606-2.007-21.054-2.61a434.502 434.502 0 0 0-11.299-.485 563.422 563.422 0 0 0-16.815-.243c-5.896 0-11.554.085-16.814.243-4.025.122-7.815.288-11.297.485-10.45.603-18.129 1.53-21.056 2.61a4.84 4.84 0 0 0-.792.363c-.333.2-.506.405-.506.613 0 .208.172.414.506.615.199.118.459.239.773.354 2.911 1.085 10.594 2.014 21.057 2.613 3.489.201 7.283.367 11.315.489 5.26.158 10.919.244 16.814.244 5.897 0 11.555-.086 16.815-.244 4.031-.122 7.828-.288 11.314-.489 10.462-.599 18.147-1.528 21.057-2.613z\"/></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#b)\"><defs><path id=\"c\" d=\"M2.045 117.851h100.931v8.628H2.045z\"/></defs><clipPath id=\"d\"><use xlink:href=\"#c\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#d)\"><image overflow=\"visible\" width=\"120\" height=\"14\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAUgBSAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGeAAAB7wAAAlD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AegMBIgACEQEDEQH/ xAB/AAADAQEBAAAAAAAAAAAAAAABAgMABAYBAQAAAAAAAAAAAAAAAAAAAAAQAAIDAAEFAQAAAAAA AAAAAAABAgMEBRAwERQVEhEAAgEBBgUFAAAAAAAAAAAAAAEhAhARkTKSMzGBodEDYSJyggQSAQAA AAAAAAAAAAAAAAAAADD/2gAMAwEAAhEDEQAAAPf7AClAplFGmUEyVMcdVeaxUqx//9oACAECAAEF AOx//9oACAEDAAEFAOx//9oACAEBAAEFADyh2RQ7oo9mCJbIofIRQuTgfUqPqQFydAuSztx2USFb WxNPq1Ecax11jqqHRnY8+UlkysWPGepjPTxeFjx+YZ8kSMKEL89P/9oACAECAgY/AA//2gAIAQMC Bj8AD//aAAgBAQEGPwA42yQjKe6kilmQlNF0r1uIfQipEO2Tj1MyxM9OJPkpxRu06kb9K+yJ/RTq Xc36cV3N9X/JG/TqRHkT5ohp80RdZ//Z\" transform=\"matrix(.882 0 0 -.882 -.152 128.647)\"/></g></g><defs><path id=\"e\" d=\"M2.045 126.479v-8.628h100.931v8.628H2.045\"/></defs><defs><path id=\"g\" d=\"M101.697 123.133c.314-.115.574-.236.774-.354.332-.201.504-.406.504-.615 0-.208-.173-.413-.504-.613a4.724 4.724 0 0 0-.792-.363c-2.927-1.08-10.606-2.007-21.054-2.61a434.502 434.502 0 0 0-11.299-.485 563.422 563.422 0 0 0-16.815-.243c-5.896 0-11.554.085-16.814.243-4.025.122-7.815.288-11.297.485-10.45.603-18.129 1.53-21.056 2.61a4.84 4.84 0 0 0-.792.363c-.333.2-.506.405-.506.613 0 .208.172.414.506.615.199.118.459.239.773.354 2.911 1.085 10.594 2.014 21.057 2.613 3.489.201 7.283.367 11.315.489 5.26.158 10.919.244 16.814.244 5.897 0 11.555-.086 16.815-.244 4.031-.122 7.828-.288 11.314-.489 10.462-.599 18.147-1.528 21.057-2.613z\"/></defs><clipPath id=\"f\"><use xlink:href=\"#e\" overflow=\"visible\"/></clipPath><clipPath id=\"h\" clip-path=\"url(#f)\"><use xlink:href=\"#g\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#h)\"><image overflow=\"visible\" width=\"228\" height=\"19\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAowCjAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHWAAACVwAAArD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABcA5QMBIgACEQEDEQH/ xAB9AAEBAAMBAQAAAAAAAAAAAAAAAQIDBAUGAQEBAAAAAAAAAAAAAAAAAAAAARAAAgEDBAMBAQAA AAAAAAAAAAERAgMEIRITFBAgMEAiEQABBAICAwEAAAAAAAAAAAAAAZECMiExEEFAUBEzEgEAAAAA AAAAAAAAAAAAAABA/9oADAMBAAIRAxEAAAD78hWEM2uGya8U3TTibpz4nTOTCu1wE73APQeePRvm j08vLzX075+yO1zbV2IMoACBIEgSCTEJQAUFC5i5UKCg/9oACAECAAEFAP3f/9oACAEDAAEFAPWS SSSSSSfhoaGhoaGhp6f/2gAIAQEAAQUA8SSjcjejejkRyo5kO+jsIeUh5aO4juI7iO4hZlJ3KTuU T26DtWxZFtiu0M30koleXI59GMYxjGP4qSlVCTKVUUqopVRDjzoaEUkUG2g22zZbHRaHbtHFYHax zhxzhxzhxzhxzhxzixhWsUVvHOPGFTYErZ/Ao8//2gAIAQICBj8Ad//aAAgBAwIGPwB3/9oACAEB AQY/APA3x0dcZVOdmzfptm0No5ZCyOWi6F4uheLofpF0LxdC8XQvF0LxdDM4uheLoWi6FouhhUdD Hw6Mc//Z\" transform=\"matrix(.443 0 0 -.454 2.045 126.482)\"/></g><defs><path id=\"i\" d=\"M86.03 35.59C80.281 19.4 97.084 2.039 110.904 1.521c8.28 4.218 15.395 15.291 15.038 30.315-1.084 18.516-14.506 34.472-29.111 49.17-.817-17.928-4.715-29.351-10.801-45.416z\"/></defs><clipPath id=\"j\"><use xlink:href=\"#i\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#j)\"><defs><path id=\"k\" d=\"M80.282 1.521h46.017v79.485H80.282z\"/></defs><clipPath id=\"l\"><use xlink:href=\"#k\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#l)\"><image overflow=\"visible\" width=\"60\" height=\"94\" xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABfCAYAAACwaXS7AAAACXBIWXMAAAycAAAMnAGTj5aaAAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAC41JREFUeNrsXEuW60QMlXKyJsYs hEWwBFgKM3YBTNgDm/GlHddH3yo53cCAFzjdncR2fEtX0pVUeUTfHv+vB/c//vzrx98+nn6vXjz/ ZnYnAdDP28/xG/219iqu1+SR5zXQXrn+lq9d5xzieT/mgH5+/n+o8z+OGfeAn3/47tefIuDPuQKs QPJqtcRxaMeeH/T6ff7k82cHy9cbfB1D7bh28PwweaHz7HZafz4/+0TE4hy0466Xzx+s7ix+DOCP BmZi4iX4ec8XwHMx5L3rBWC1mhjgOzU4BK8+7byxfh7BLDyLyzdWsTpsYXHWp++sLr3ltALEIlC7 FgSuAYYbBkyLReDRVocFTlxr2d7XVu/r2N+zC7SmugBCnbaKBe2GqbNXWLO/KmnerEQK/HXdcU0F ftKe27nj8oDiIMtzjL2ZsLWcAt6t8UF8mj+tf0sCNmt/3N1DLUIzzXmzzQXQQKCByMCPxVYroSkP iKMCq3dfXz0m8IfwFRXkgqjebmoENe43jNdi9aB2vd4sI3z04Ale2eu1XtOfLeUn25p1T3YFVt/R PIzqmk6pV88g9bIohrv1vzoTWVi/X/CBCb6/BsvOdoFBeQlIWB0U+/rO6iKqPwZYLoa2GdR4BuJO 72YNldIGOh6BaIZ4GdUDyjMPjSAXP/J1FKz+lNZlfcml1WGvyVfwaaFtBCYmE7VJWrInf1bgr0Wb loTIClurC/bVqT6iuvdstvm7+TULKyiejZvmBl5k/uGb01clLVlFEkl/b/WRRs2NMm5E9Q6YF07O JNPLXG0eUpYNeAgVxoGvyufS6rS1OuRHBXQvWXwot+6DMsg9IprPoMY9Qg9lElleWIJ0POiLs7M6 DPWYZGD1dC9SXQPmB6ca7hXUmJQ6YxG45t0aXS2sJJUYlO9GVodgBpsFyelekqwd9ATMuQLC1G6v oNYlJCATuwZPM9iBdDERWx0CIo8YuKL7lt+pjz8aeOqi4RFSpgcsEBkOyypkyDQVcGBERmR1GDGi BNPCorx4tlBuDbQAbMvUQHY3ySpkKhnA4Gk1ltoPw+owKYgXdI/EVObnN5TbTGszwnOQ0rQG19UX LpF/GDEhhIYUJ+P0l6jxdI+zSuznd7j+lAmgW/oho3qW0qDrZGIjakbUHpqFRKtiFjkB3UWYWvh5 3E7CbeAsLc2jamBRpl7uy0aEiCaBjOJCscFUWxgrh9C6E0BkX1cxxIGN162Up24o8GwLkfB5kchZ +OdMTQiyiI3OMo/FlqpYLDuG6V5kV3l8+vQF+sEz6M2ILj4BPKnXCg9ZbGY3woGfZ3U/sGmT4j26 P6ILdkuP3P5ahPk3syxqpM5Pihp17AIH11/fsYKrwKM2MrOO9icDHhO+AuSRclrZFbrd//jj8d/f QnVJ+Etv6rFrH2M258cAYA4KbqnETz3wxR/2lNOR2dlskfgQS4OZVGDkglqQHuURKy2sFhr41xj0 tB8+cmPPVQ08puyaim00GBpQB4TUOStmLZmH5A3kL5fr8dH2bdp4pK1TIx8+vcjZl52fwU3VNEok dw5T899nzDtUHwKSZpe09cy1SsT4kEH8PihQNJduAe0mvYiHKFhSOKv37wMOfLz3vmZvi7tf25JT WrgDBJY0R2JrKFfAZhkkDdYLch2Kio9DVFoTPyfLOiciMuI360NbOV4AGPAQHwPvJkurI1TzZapT 649zaxX3m2EzPEMGHtM3VQAkAyqgeeTfcMF0R3656Deo3mfNGBSf3VM9f4S4EYibncN5mfcBTeMa zT1EBBEdSSWOjStM4EcDyrIDImbeSaweVsfc2UBD3Ij/IHI16DbNI/9WC4d6KvNRXV6EW32d9agl 5SHz+FR6JNTd2BJCdnvH52ge+ncBvfNxMbGXM70AN4Sf2twOtQDSBQjWYnr/y/s01/69w64kqwpk fVIChP1lBDoaKleT2KzjLaeYMOKETI/v0xwF0j8dFDG0tyGNQrB67VVBI3L8EDkm949NA+7W8Sma YyP9XVSXz1n0U3zDA/5vmGrOiBtIH7dbvFwaFNbV6Es0Lwe3oyk19Jkz6f0kCKGTs7oGuQZtKb63 dp3mG11nfbz1y6Em0SHdEep2UpQm6GsD+rYsxb0b5NZGBA56QUo+fgCkZvXdwzk5HYZuBrBcCJiI 79xBUNxK2r21RcZIegRrrY5WibXtHTQ27sTdaWXRqHiRcjYELUtPr/SUSyBgS2Btx5J6HhdbUkSV ltbEQBzwrH63lZzx6x3FJQ6pB9bWRq06u7ZVmZwN25mh0NtRKV5kQSI29V65HulmXqX7YRxBLY5N eMU8fowBJ/Sgb7V/KAFrb04uAFEO2rUtMorDRnEyboK5n7Zk8cFwFpPeXfcDYfuJYBqTxirq5tvr R+DXpNwEQa8v8u0b6exQuxVXmo0WaS1YBPjCBbB+aPK76U65fK4+RwllsTg32svSn3u7iXfd0QCs 7L9JWpPpz8cb9BOFF1E8bXr4dthaudEc60p/r1hcgSXSlZtpUdHboIXCQ3QNmwrvVGc095VjMU6C qRUdWFuLm2LE5vcK6O7XtukRuQBtBhR6kqJE/5xVpekMQT/Gfh9FAdb5NY7euaVhmlQrit/Q6scs Q9WXPFY9TrhJiZaxGnBYs9s0loL2HZrQ/1W1V6rHJWV7UDsKI10EzUPE5arpjwO6zyqFjgetKR76 tZLPxV1PB6AG8diMi6GFelqbh53ZwMpENdCHVXawExrb3KhqderbM2t53A8NEJatEeDYyiZ6y9a1 ydpukPGej9uvNEFvjUhCOhY1uq7iTE89tHIO+ljU8xDRnkzWqFFdfD1M6VxgWaTY9GbBxvIWSmXV croeVKp8DfILSNXqzOy/rc2x4dKbU3Im6us056m6A3040PA7N8pFiq3HN19RDOffu3weAJaDCNdQ CFxAp70M9J0ipW+/JLvpcgd7l8/9yCgCrNUYJWBMtF+Aris3gvpCUHWrRkR5LBScs79tSDpq3wd9 W6vP/I3NV2o3/bcU7BqwHUhkJazr36egi9WZbCzaHcQ7FihoAVjLvJjWsZWVBrgBut5zk5MTrtEd yAId3Ptupm6bkYmVbcc21vYe9M0OTL9hLhN9tRhIRj47wNIYBHoLdGl2RvCRercX1V9YW9kOHMLe XPBPK0grryO8vfY896hOUiJ/WM3HI+DOq4G4XF0AJtvECK0cp8VL2tI9ix+vXXw9mHGliRGKljCy p/05D1gPIEz7GHpDgWtAOuV2M6rbE7goYeMdDDFYzTIPOLMyqR7eGnQtjxvrcFHEwE8SlxWbG+0v AFOB2hYobJentDGgtJ2uGuPXYMPeewJYDtDWoD0Tbg0U1r2XpVp3OxaiWp9U0z8CbDbw2HIWmf9T 3nGtDBSoKFvT/YXAYr9MVLrmgPdWNhI3UH3309kil6+3VPtqLQNLweBvBVjMZZw7RL36e8DNv/vC m+1ehE1nJs3r7N4nyvbUxKkqajoCNwYKhyxKQmGyaz5Vpqm2m4dU0UWAqWBl+0WCYlm66r1gn84Q dWTs19oR5vYMMNm5dyB8FLVt+qsJmPp4OA927J0ByfbMaLycAKaClb2wKQmYyIb1lIZ9DzYoUEw2 cbT2vkxJAIOTsNX5eLHk3GZ0YL15IARr398B9oWMZsP++wrPlX9+iXKrgg0mMRaw1QTOyvSuj98k ecaLUP4WwG4Bj3lgFNnrldlSwOAz1kZu/QwsVQBvray3ixSnpfkguG7tbMBQAJs0LjJaU1SJBdvA 3ihS7lk9VnIxi3YtKdWTXwCmsF7fd182RYrtxeyGR/lCrFtSeft5Ddi2ruLA93Y6w40OTGplBLp9 AXYLWLqADXDBF3zqWv1mNt/L1vVgIQ9yO8CxPkfhvp+rG/hsHk+7sdgFuSCfb2iNRSW467n98vHr j0/qF/dvL6LAAltFWq2eukmWhicrfqdvD/34W4ABAIiqmxsUeVmXAAAAAElFTkSuQmCC\" transform=\"matrix(.882 0 0 -.882 78.299 83.052)\"/></g></g><defs><path id=\"m\" d=\"M53.447 123.273c-2.311-18.079 5.208-33.495 12.668-42.898 16.218-20.177 15.206-32.293 13.61-42.676C88.257 50.997 93.578 66.94 94.757 81.05c.602 11.636-7.886 38.533-41.31 42.223z\"/></defs><clipPath id=\"n\"><use xlink:href=\"#m\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#n)\"><defs><path id=\"o\" d=\"M51.136 37.699h44.223v85.575H51.136z\"/></defs><clipPath id=\"p\"><use xlink:href=\"#o\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#p)\"><image overflow=\"visible\" width=\"56\" height=\"101\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAUgBSAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAJ6AAADMwAABGD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAGcAOQMBIgACEQEDEQH/ xACmAAACAwEBAAAAAAAAAAAAAAAABQIDBgEEAQEBAQEBAQAAAAAAAAAAAAACAwEABAUQAAIBAgMH AwUAAAAAAAAAAAACAQMEESMFEBITFCQ0BjJCFiAiM0M1EQABAgMGBQMFAAAAAAAAAAABAgMAELEg EeFyknMhMrIzBBIiE0HB0WJjEgABAwIFBQEBAAAAAAAAAAABABECEHJBcZGxEiFRYTJCoWL/2gAM AwEAAhEDEQAAAHSuaL6XynQl7SbmSe/E81uE3cfRiET1Jby8tnc8jd20Wu2uP2Ea4tU7WOcbe2ro 2ysCs1eZ006ZZa2Xo8slYsjbKw7PQIns3nvCy8azlkp6edDNseonoSXze3ybwAiAd1j1E9CX+YBU A0gHdNsBX//aAAgBAgABBQCjSpzT4NImlSOGnFofiliZMc2lOVMkyY5lOcuZJkx++nP2TOz3p6Nn vXiYZpmmZvf/2gAIAQMAAQUAr1qkVePVFq1pN+pwrj8yoRBhlVVzYgwP11IzMNn66nr2eyp69nsb hb2SZJlbv//aAAgBAQABBQDyHXdQ0+/+W6wfLdYPlusHy3WBfKtZksfIdUr3Z5h/W2pTmRKZpqYX 55h/WIiZEpioKhpy9ceYf1lWZEpioKgqlgvWHlib2rJTFQVBUFUsl6s8nXHU1QVBUFUVSzXqTyNc dRVBVFQVRVLVeoPIFxv1UVRUFUVS37g1xcb5VFUVCFw2W/cGsrjeKoqkRhtt+4NVXG7Vfpt+4NTj qfpt+4L634lblDlDlDlDlCja7tY//9oACAECAgY/AIkxiSR2XpHRekdEBxi3A9G8qFtRYd1C2otO 6jlUWqOVRahlUWoMzLBYLB2X/9oACAEDAgY/AJgTkAJd17y1XvLVE8pPzHV/CncutDeNlM/1U3DZ SzqbhspZ1NwUs6m4Iu7r6X0sWf8AV//aAAgBAQEGPwAMeMUhstpV7k3m8k/iOZvQI5m9Ajmb0COZ vQI5m9AhhpxSPQ44hCrk3cFKAMhtJqq14u831CQ2k1Va8bdR1CQ2k1Va8fdR1CQP8k1VaY3EdQkD /JNVWmc6aiQ201VaazprIbaam01nTWQyJqbTWdNZDIKm01nTWQyCptNZ01kD+o+9prOmsvV8jaPa BctVxjvs68I77OvCO+zrwjvs68I77OvCG1fM0blA3BXE8fpwl//Z\" transform=\"matrix(.882 0 0 -.882 48.562 125.499)\"/></g></g><defs><path id=\"q\" d=\"M41.804 54.622C17.28 47.931 11.23 26.902 12.325 12.76c23.815-9.425 49.446.23 64.244 20.343 10.374 14.101 16.87 32.172 18.189 47.947-7.119-9.167-16.111-14.48-27.561-18.639-7.835-2.848-15.068-4.732-25.393-7.789z\"/></defs><clipPath id=\"r\"><use xlink:href=\"#q\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#r)\"><defs><path id=\"s\" d=\"M11.229 3.334h83.528v77.715H11.229z\"/></defs><clipPath id=\"t\"><use xlink:href=\"#s\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#t)\"><image overflow=\"visible\" width=\"100\" height=\"92\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAUgBSAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAALHAAAD1QAABV7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAF0AZwMBIgACEQEDEQH/ xACqAAEAAwEBAQAAAAAAAAAAAAADAAIFAQQGAQACAwEAAAAAAAAAAAAAAAABAwACBAUQAAIBAwIF BAMBAAAAAAAAAAABAhIDBBMFESMzJAYgFEQ1ITQlQxEAAQMACQMEAgMAAAAAAAAAAgABAzARMZGy M3OT03GxBMEScpIhQSIyExIAAQICCAUFAQAAAAAAAAAAAgABETEgIVGRwdEyknGBEnID8EFhQlKT /9oADAMBAAIRAxEAAAD6XxdzOf1dW+YqraN89Yv3X8Shfrt5lFG6dpX0Ss2pws3SzM3VVSVJVCUL VSSLVhULW1LRbTk3pwczSzEdVVFVWZBQLZRQLZAvFv0uivslJvRiZenlJ6roKJsyCgWyBcUew2lG 6PZXRlJvzY2Vp5Cur6EBEWe43FHsNxRrD2VaF0DUlZvx4+Nv49elVeom1U7cUra1hStrdArLyDRl psx//9oACAECAAEFAL12aua1w1rprXTWumvdK5e1v9T0/Dv9T0/Dv9T0/EvLmP0/Euwbm7bNNmmz TZpspftv/9oACAEDAAEFALFm07Ls2h2rY7cBwgUwOC1MfoMYxjR/pj9BjGho4HDnY65DQ0NDRwOH Pxl27Q0NDRwOHc412CsO7Ad2A7kDUiakSpe5/9oACAEBAAEFAN63XLwstb/uLFvmexb1nMW8ZrFu uYxbnlMW45LFnZDFmX2LKvnurxavXJWvJf34kSJEiRRFEURQkUllcnyX9+JEiRIkSJEiROH4tdLy X9+JEiRIkSJFkWJlRZfK8l+wiRIkSLIsiyLIsUiosPk+TfYRZFkWRZFkWRYmKQpFRjPjj+T/AGEW RZFkWRZFiYpCkVFRiPtfKH/RiyLEyLIsTExSFIqKjCfZ+VP+jFkWRYmJiYpCkKRUVGC+y8sfDcoy IsTExMUhSFIUioqNvfYeXfZRkRkRkKQmJikKRUVFRtr/AJ3lEcR7gre3Ebe3ihgChgihhChhChhi hhlGIUYhRiG3Kytv/9oACAECAgY/ACZidmjatZXrWV61letZXrWV66ov1Qn7zRcaXLFFxpcsUXGl yxRcaXLFFWM/0ymO4c1MN45qYbxzUw3jmphvHNdNUrWhO1f/2gAIAQMCBj8AB3AXdxnBaBuWgblp G5aWUmUIVIO2mHbS9WLx9tKHzgvH20ofOC8bOx1D7eMna9mUj/meSkewslI9hZL77CyX32Fko1wj Y8ZWTX//2gAIAQEBBj8ACKBxYCjYnrav8uRN6L+wfVWj9VaP1Vo/VWjcrRuVrXK1rla1yta5Wtcp CKqsWeq5R6Q4jpJOj9lHpDiOkk6eij0hxHSSdH7KPSHEdJL0fso9EcR0k3R+yj0RxHST9H7KPRHE dJ5HR8LqPRHEdJ5XxfC6i0BxnSeX8SwuotAcZ0nmfEsLqN55ZAL/ABGpgjE2q9x/t5A7LPn2A51n zbI86z5tkeZZ0u0PMs6XaHmWdLtDyrNl2h5Vmy7Q8qzZdoeVZsm2PKs2TbHlXlsBk4+0vc7gzO38 Xsb3vXev/9k=\" transform=\"matrix(.882 0 0 -.882 8.922 83.533)\"/></g></g><defs><path id=\"u\" d=\"M79.728 37.705l.463.727.186.302c.383.612.758 1.233 1.127 1.856l.061.103.101.171.09.156.266.454.018.033.358.628.009.018c.26.458.515.918.766 1.382l.033.058.279.519.007.012.305.579.09.169.17.331.21.405.202.392c.206.405.411.813.61 1.222l.05.103c.362.739.714 1.482 1.059 2.229l.262.572.024.057.166.371.195.439.11.253.179.407.125.293.266.628.018.043.285.684.034.084c.305.738.6 1.478.883 2.22l.027.068.238.623.013.034.137.368c.151.407.302.817.447 1.226l.055.162c.163.456.323.916.478 1.375l.05.144.423 1.289.068.212.018.05.218.696.011.032.203.665.205.685.005.018.168.578.054.186.101.359.343 1.238.083.309.159.611.007.029c.194.75.377 1.499.553 2.247l.018.079.016.079c.229.983.438 1.966.63 2.949l.02.097a89.17 89.17 0 0 1 .767 4.537l.001.021c.067.463.128.927.184 1.386l.023.197.079.661v.004l.066.609.02.201.048.485.02.193.007.079.06.665c-5.262-6.777-11.547-11.446-19.089-15.1 6.087-12.033 5.232-20.61 4.059-28.246z\"/></defs><clipPath id=\"v\"><use xlink:href=\"#u\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#v)\"><defs><path id=\"w\" d=\"M75.668 37.705h19.089V81.05H75.668z\"/></defs><clipPath id=\"x\"><use xlink:href=\"#w\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#x)\"><image overflow=\"visible\" width=\"28\" height=\"54\" xlink:href=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAUgBSAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHaAAACDQAAAof/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIADgAHgMBIgACEQEDEQH/ xACUAAADAQEBAQAAAAAAAAAAAAAAAwUEAQIGAQADAQAAAAAAAAAAAAAAAAABAgMEEAAAAwgDAQAA AAAAAAAAAAABAwQAEBEhAhMURBIiNDMRAAAEBQAKAwAAAAAAAAAAAAABEQIQcbHBgiExQVGRodES MhNhIkISAAIBBAEFAAAAAAAAAAAAAAABETFxAnISEEFhMhP/2gAMAwEAAhEDEQAAAPtV+UxXRqm0 GGRLkZ69oT6FFyJcjPXtGbSoqUgGNwOP/9oACAECAAEFABrGIVRCqrvQMjB7lDKuzzLtQ//aAAgB AwABBQAYsEWhKDAEhCYcoVcm/9oACAEBAAEFAD1JhZuac2Yc1yqws+7tNZ93aaz0O01vodpLfQ7S VJjjDsNS2Gpa3Xi//9oACAECAgY/AGp7jsZXZlqzLZmejMp+ky5iDPjz9HMxTwf/2gAIAQMCBj8A HbqhXFQUxU//2gAIAQEBBj8ANjUQk1jZwGzgPZ+u1Q6RUjhYOkVI4WDpFSOFg6RUjhYOkVI4WBuY 1WmmlS3Dw5l1HhzLqPWn37UT5Qf/2Q==\" transform=\"matrix(.882 0 0 -.882 73.308 83.648)\"/></g></g></svg>"

/***/ }),

/***/ "../src/components/yii/original/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _YiiOriginal = __webpack_require__("../src/components/yii/original/YiiOriginal.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YiiOriginal).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/yii/plain-wordmark/YiiPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _YiiPlainWordmark = __webpack_require__("../src/components/yii/plain-wordmark/YiiPlainWordmark.svg");
	
	var _YiiPlainWordmark2 = _interopRequireDefault(_YiiPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** YiiPlainWordmark */
	function YiiPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'YiiPlainWordmark',
	    svg: _YiiPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	YiiPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = YiiPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/yii/plain-wordmark/YiiPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\"><path fill=\"#0073BB\" d=\"M96.644 1.858c-10.79.404-23.907 13.955-19.419 26.595 4.751 12.541 7.795 21.461 8.431 35.452 11.403-11.473 21.88-23.929 22.725-38.382.277-11.729-5.275-20.372-11.737-23.665zM84.012 66.273c-4.532-6.84-12.758-11.051-15.819-12.343-1.62 2.895-3.746 6.04-6.516 9.483-5.823 7.34-11.695 19.377-9.888 33.487 24.053-2.654 31.564-20.707 32.223-30.627zM42.699 43.311c8.062 2.388 13.709 3.857 19.823 6.078 8.939 3.248 15.957 7.395 21.516 14.551-1.031-12.313-6.103-26.423-14.2-37.429-11.554-15.7-31.561-23.238-50.151-15.881-.854 11.04 3.869 27.456 23.012 32.681z\"/><defs><path id=\"a\" d=\"M28.528 119.856v-13.829a.436.436 0 0 0-.435-.436h-2.002a.437.437 0 0 0-.434.436v13.829c0 .239.195.457.434.457h2.002c.24 0 .435-.218.435-.457zm-10.57.415v-14.588c-1.123.023-2.849.756-2.87 2.293v9.989c-.609.087-1.567.175-2.089.175-1.87 0-2.327-1.327-2.327-3.112v-7.132c-.117-1.74-2.079-2.247-2.871-2.195v9.327c0 3.394 1.696 5.465 5.198 5.465.521 0 1.632-.153 2.089-.245v.178c.443 2.86-3.027 1.781-4.907 1.587-1.385 0-2.331 1.141-2.582 2.427.805.261 3.459.597 5.3.742 3.329-.001 5.059-1.821 5.059-4.911zm5.253-.415v-13.829a.436.436 0 0 0-.435-.436h-2.001a.437.437 0 0 0-.436.436v13.829c0 .239.195.457.436.457h2.001c.24 0 .435-.218.435-.457zm-1.436-18.163a1.497 1.497 0 1 1-.002 2.994 1.497 1.497 0 0 1 .002-2.994zm5.331 0a1.497 1.497 0 1 1-.002 2.994 1.497 1.497 0 0 1 .002-2.994z\"/></defs><use xlink:href=\"#a\" overflow=\"visible\" fill=\"#0073BB\"/><path fill=\"#0073BB\" d=\"M37.489 105.079v-.745c0-.197-.109-.329-.438-.372a14.116 14.116 0 0 0-1.973-.131c-2.06 0-3.374.7-3.374 3.046v13.145c0 .242.197.438.439.438h1.051a.439.439 0 0 0 .438-.438v-10.078h3.418c.24 0 .416-.176.416-.394v-.746c0-.241-.176-.394-.416-.394h-3.418v-1.533c0-1.294.24-1.491 1.445-1.491h1.95c.309-.001.462-.11.462-.307zm6.997 4.512v-1.007c0-.306-.175-.328-.459-.328-1.819 0-3.331.065-4.58.613-.241.109-.395.263-.395.503v10.648c0 .242.175.438.395.438h1.14c.24 0 .394-.219.394-.438v-9.859c.833-.175 1.557-.219 3.047-.219.414.001.458-.109.458-.351zm9.473 10.013v-10.341c0-.307-.065-.416-.46-.503-1.161-.285-2.717-.503-4.031-.503-3.287 0-4.776 2.124-4.776 5.411v1.533c0 3.286 1.513 5.415 4.776 5.415 1.336 0 2.87-.223 4.031-.507.395-.088.46-.22.46-.505zm-1.929-.832c-.612.109-1.643.219-2.563.219-2.169 0-2.849-1.49-2.849-3.791v-1.533c0-2.323.68-3.791 2.849-3.791.92 0 1.972.11 2.563.219v8.677zm17.843 1.249v-7.931c0-2.257-1.271-3.834-3.899-3.834h-.504c-1.314 0-2.191.219-2.848.788-.68-.613-1.534-.788-2.849-.788h-.503c-2.63 0-3.9 1.577-3.9 3.834v7.931c0 .242.152.438.395.438h1.14c.24 0 .394-.196.394-.438v-7.931c0-1.885.833-2.147 1.973-2.147h.504c1.401 0 1.884.241 1.884 1.49v8.588c0 .242.153.438.395.438h1.139c.241 0 .395-.196.395-.438v-8.588c0-1.249.482-1.49 1.885-1.49h.504c1.16 0 1.972.263 1.972 2.147v7.931c0 .242.153.438.395.438h1.14c.235 0 .388-.196.388-.438zm10.7-5.455v-1.183c0-3.112-1.621-5.126-4.82-5.126-3.133 0-4.864 1.993-4.864 5.126v1.971c0 4.076 2.454 5.262 4.974 5.262 1.468 0 2.673-.131 3.922-.375.351-.066.438-.219.438-.504v-.745c0-.219-.176-.307-.351-.307h-.109c-1.008.153-2.629.241-3.9.241-2.016 0-3.046-.964-3.046-3.571v-.306h7.34c.263-.001.416-.198.416-.483zm-1.95-.986h-5.807v-.197c0-2.366 1.053-3.44 2.937-3.44 1.928 0 2.87.964 2.87 3.44v.197zm17.887 2.124v-6.857a.44.44 0 0 0-.439-.438h-1.029a.44.44 0 0 0-.438.438v6.857c0 2.39-.898 3.265-2.695 3.265-.549 0-1.117-.131-1.753-.285v-9.837a.44.44 0 0 0-.438-.438h-1.073a.44.44 0 0 0-.438.438v9.837c-.635.153-1.205.285-1.753.285-1.84 0-2.694-.875-2.694-3.265v-6.857a.44.44 0 0 0-.438-.438H82.29a.44.44 0 0 0-.438.438v6.857c0 3.879 2.169 4.912 4.425 4.912 1.097 0 1.994-.199 2.915-.529.92.33 1.796.529 2.892.529 2.256 0 4.426-1.033 4.426-4.912zm11.203-.437v-1.665c0-3.221-1.666-5.345-4.887-5.345-3.22 0-4.863 2.124-4.863 5.345v1.665c0 3.22 1.644 5.349 4.863 5.349 3.221 0 4.887-2.13 4.887-5.349zm-1.929 0c0 2.257-.92 3.659-2.958 3.659-2.059 0-2.935-1.424-2.935-3.659v-1.665c0-2.257.897-3.659 2.935-3.659 2.061 0 2.958 1.424 2.958 3.659v1.665zm8.816-5.676v-1.007c0-.306-.175-.328-.459-.328-1.819 0-3.331.065-4.58.613-.241.109-.395.263-.395.503v10.648c0 .242.176.438.395.438h1.14c.241 0 .395-.219.395-.438v-9.859c.833-.175 1.556-.219 3.046-.219.415.001.458-.109.458-.351zm9.801 10.583c0-.065-.022-.153-.066-.197l-4.863-5.872 4.82-5.214a.354.354 0 0 0 .109-.241c0-.131-.109-.241-.328-.241h-1.534c-.219 0-.307.044-.438.197l-4.382 4.93v-9.115a.44.44 0 0 0-.438-.438h-1.053a.44.44 0 0 0-.438.438v15.6c0 .242.197.438.438.438h1.053a.44.44 0 0 0 .438-.438v-5.236l4.36 5.389c.175.219.263.285.504.285h1.577c.154 0 .241-.131.241-.285z\"/></svg>"

/***/ }),

/***/ "../src/components/yii/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _YiiPlainWordmark = __webpack_require__("../src/components/yii/plain-wordmark/YiiPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YiiPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/yii/plain/YiiPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _YiiPlain = __webpack_require__("../src/components/yii/plain/YiiPlain.svg");
	
	var _YiiPlain2 = _interopRequireDefault(_YiiPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** YiiPlain */
	function YiiPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'YiiPlain',
	    svg: _YiiPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	YiiPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = YiiPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/yii/plain/YiiPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#0073BB\" d=\"M107.131 1.228c-14.253.534-31.578 18.435-25.65 35.13 6.275 16.565 10.296 28.348 11.137 46.83 15.062-15.155 28.901-31.609 30.018-50.7.366-15.493-6.967-26.911-15.505-31.26zM69.549 70.012c-2.139 3.823-4.946 7.978-8.606 12.528-7.691 9.693-15.446 25.593-13.061 44.232 31.771-3.506 41.693-27.353 42.563-40.457-5.987-9.034-16.85-14.596-20.896-16.303zM5.477 12.815c-1.128 14.583 5.11 36.267 30.397 43.169 10.648 3.153 18.109 5.096 26.186 8.028 11.809 4.291 21.078 9.768 28.422 19.221-1.363-16.265-8.062-34.902-18.759-49.441C56.462 13.052 30.034 3.097 5.477 12.815z\"/></svg>"

/***/ }),

/***/ "../src/components/yii/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _YiiPlain = __webpack_require__("../src/components/yii/plain/YiiPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YiiPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/zend/plain-wordmark/ZendPlainWordmark.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ZendPlainWordmark = __webpack_require__("../src/components/zend/plain-wordmark/ZendPlainWordmark.svg");
	
	var _ZendPlainWordmark2 = _interopRequireDefault(_ZendPlainWordmark);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ZendPlainWordmark */
	function ZendPlainWordmark(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ZendPlainWordmark',
	    svg: _ZendPlainWordmark2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ZendPlainWordmark.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ZendPlainWordmark;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/zend/plain-wordmark/ZendPlainWordmark.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#68B604\" d=\"M53.607 57.793c-8.247.028-16.494.207-24.741.207H27.68c11.396-16 22.632-31.211 33.949-46.722-.384-.026-.569-.144-.754-.144-17.851-.002-35.701-.046-53.552-.06-.627 0-.842.137-.836.798.031 3.689.015 7.367.015 11.057 0 1.052.001 1.047 1.067 1.047 9.034.001 18.068-.003 27.102.001.355 0 .711.046 1.256.086L1.781 70.651l.584.033c17.146.001 34.291-.003 51.436.017.701.001.794-.281.791-.866-.018-3.744-.03-7.393.009-11.136.007-.779-.206-.908-.994-.906zm6.757-30.306c.027.71.442.513.869.513h24.828c4.178 0 8.357.116 12.536.091 4.555-.027 9.12.124 13.662-.146 4.703-.279 8.459-2.475 11.051-6.493 1.743-2.702 2.514-5.711 2.896-8.863.104-.861-.447-.742-.963-.742-16.172.001-32.344-.018-48.517.034-1.793.006-3.633.191-5.37.638-6.242 1.602-11.236 8.491-10.992 14.968zM76 32.988c-2.638.003-5.18.517-7.503 1.791-5.405 2.962-7.481 7.921-8.119 13.723-.084.766.38.745.905.744 4.312-.007 8.623-.004 12.935-.004 1.464 0 2.929.021 4.393-.004 3.222-.054 6.464.069 9.661-.248 4.157-.412 7.536-2.437 9.939-5.917 1.889-2.735 2.833-5.812 3.162-9.103.096-.965.135-.985-.804-.986-8.19-.001-16.38-.006-24.569.004zm8.882 21.711c-.004-.574-.228-.675-.722-.672-2.494.016-4.989-.023-7.482.021-1.157.021-2.323.12-3.466.299-8.958 1.396-12.3 8.892-12.836 15.287-.048.573.158.762.729.75 1.491-.03 2.982-.011 4.473-.011l.003.083c2.027-.09 4.073-.036 6.079-.295 7.531-.971 13.28-7.764 13.222-15.462zM33.72 103.333c-.092-.279-.233-.37-.512-.366-.938.012-1.875.018-2.813-.003-.342-.007-.488.115-.595.44-1.208 3.696-2.433 7.387-3.655 11.077-.199.6-.408 1.195-.649 1.9l-4.28-5.52.303-.206c1.25-.733 2.08-1.759 2.238-3.243.197-1.842-.329-3.343-2.345-4.108a4.948 4.948 0 0 0-1.61-.295c-2.008-.042-4.018-.025-6.026-.043-.329-.003-.471.07-.47.445.013 4.286.012 8.572.001 12.858-.001.349.125.426.444.418a39.71 39.71 0 0 1 2.366.003c.399.014.542-.085.534-.514-.028-1.368-.014-2.738-.004-4.107.001-.146.038-.358.136-.424.319-.214 1.154.007 1.393.327 1.083 1.457 2.16 2.918 3.259 4.362.124.164.37.33.562.332 2.128.023 4.256.009 6.384.021.287.002.39-.114.458-.363l.598-2.051c.083-.306.24-.431.566-.426 1.161.015 2.322.014 3.482 0 .333-.005.469.134.552.44.186.688.395 1.369.621 2.044.046.137.208.33.321.333 1.024.025 2.048.015 3.109.015l-.062-.329c-1.438-4.336-2.878-8.675-4.306-13.017zm-14.434 5.629c-.771.211-1.606.199-2.415.254-.069.005-.215-.218-.221-.34-.024-.535-.01-1.07-.01-1.606 0-.505.006-1.012-.003-1.517-.004-.228.052-.387.313-.376.696.027 1.401.004 2.086.106.817.122 1.257.647 1.324 1.399.093 1.024-.254 1.855-1.074 2.08zM30.304 111c.467-1 .915-2.811 1.362-4.287l.137-.106c.449 1.477.898 3.394 1.368 4.394L30.304 111zm54.295-8.03c-.818.006-1.638.024-2.455-.009-.39-.016-.512.152-.582.491-.478 2.308-.966 4.613-1.454 6.92-.12.566-.25 1.131-.376 1.695a.8.8 0 0 1-.222-.424c-.648-2.757-1.301-5.513-1.933-8.273-.073-.32-.215-.407-.514-.402-.803.012-1.608.023-2.411-.006-.372-.013-.521.128-.604.475-.533 2.235-1.081 4.468-1.628 6.7-.155.633-.324 1.263-.486 1.894l-.131-.006c-.106-.498-.219-.995-.319-1.495-.482-2.397-.957-4.796-1.45-7.191-.028-.136-.199-.343-.307-.346-1.037-.027-2.075-.016-3.142-.016l.049.398c1.07 4.317 2.144 8.635 3.212 12.954.063.253.174.366.457.36a53.8 53.8 0 0 1 2.812.004c.373.012.515-.11.6-.464.528-2.206 1.076-4.408 1.62-6.61.109-.441.233-.878.351-1.317l.111.016.117.377c.647 2.513 1.3 5.024 1.929 7.543.084.338.208.463.562.453a58.052 58.052 0 0 1 2.768 0c.324.008.467-.091.547-.413 1.057-4.307 2.124-8.61 3.2-12.912.08-.329-.036-.398-.321-.396zm-31.311.46c0-.347-.108-.472-.461-.465-.967.019-1.935.02-2.902-.001-.347-.007-.528.101-.669.432-.775 1.817-1.577 3.624-2.371 5.434l-.428.924-.276-.546c-.857-1.944-1.718-3.887-2.562-5.837-.124-.286-.273-.411-.594-.405a96.2 96.2 0 0 1-2.991.002c-.325-.005-.474.064-.473.443.013 4.285.012 8.572.001 12.859-.001.347.122.428.442.419a33.255 33.255 0 0 1 2.188.003c.401.017.677-.09.674-.516-.021-2.664.132-5.328.132-7.992v-.461c0 .135.117.285.182.443.663 1.59 1.263 3.177 1.905 4.776.146.364.304.502.691.473.444-.033.876-.023 1.322-.002.3.014.445-.101.556-.378.397-.993.813-1.977 1.225-2.964l.984-2.376.136.022v.469c0 2.664.015 5.328 0 7.992-.002.376.078.531.492.514a32.13 32.13 0 0 1 2.323-.002c.343.01.474-.083.473-.445-.009-4.271-.008-8.544.001-12.815zm55.806 7.353l.108-.076c1.376-.771 2.22-1.893 2.347-3.505.12-1.526-.316-2.795-1.744-3.623-.686-.397-1.442-.563-2.218-.575-2.008-.03-4.017-.02-6.025-.037-.33-.004-.47.074-.469.446.013 4.285.012 8.57.001 12.855 0 .345.12.428.441.42a37.97 37.97 0 0 1 2.41.004c.411.017.496-.131.49-.511-.021-1.384-.011-2.768-.002-4.151 0-.133.033-.325.122-.387.291-.202 1.149.008 1.366.299 1.083 1.456 2.169 2.909 3.243 4.372.192.262.391.387.735.378 1.026-.026 2.053-.009 3.08-.01l.494-.027-4.459-5.76.08-.112zm-2.544-1.641c-.572.069-1.154.062-1.73.102-.321.022-.408-.123-.397-.421.018-.504.005-1.01.005-1.515 0-.535-.014-1.07.012-1.604.006-.112.164-.312.25-.311.71.005 1.431-.021 2.126.095.952.16 1.378.805 1.332 1.804-.046.988-.67 1.736-1.598 1.85zm-11.886-6.18c-1.035-.308-2.092-.373-3.171-.242-1.455.177-2.72.72-3.72 1.811-1.37 1.495-1.763 3.321-1.828 5.281.081.691.109 1.394.252 2.071.457 2.169 1.59 3.823 3.725 4.659.972.381 1.99.436 3.022.416 2.535-.047 4.646-1.5 5.506-3.882.757-2.096.762-4.235.064-6.338-.624-1.89-1.905-3.2-3.85-3.776zm.29 9.894c-.523.982-1.298 1.563-2.442 1.574-1.167.012-1.998-.561-2.47-1.583a6.497 6.497 0 0 1-.555-1.904c-.166-1.364-.124-2.731.472-4.015.386-.831.962-1.466 1.899-1.668 1.288-.278 2.428.254 3.06 1.433.533.996.679 2.077.644 3.19.027 1.039-.111 2.04-.608 2.973zm30.976 3.206c-1.438-2.115-2.871-4.234-4.323-6.34-.203-.295-.21-.491.009-.778 1.363-1.785 2.707-3.585 4.058-5.379l.442-.587c-1.285 0-2.472-.01-3.658.015-.133.002-.294.177-.389.31-1.003 1.404-1.995 2.816-2.991 4.225l-.983 1.448-.096-.039v-.473c0-1.667-.055-3.334-.033-5 .005-.403-.149-.512-.532-.499-.758.024-1.528.028-2.287-.002-.418-.016-.565.098-.563.542.017 4.226.012 8.452 0 12.679-.001.38.079.527.489.51.772-.032 1.547-.03 2.319-.001.399.015.545-.086.534-.514-.03-1.146.032-2.294-.026-3.437-.035-.689.287-1.146.731-1.643l.276.363c1.015 1.539 2.045 3.069 3.03 4.628.278.438.565.632 1.101.607 1.063-.049 2.131-.015 3.292-.015l-.4-.62zm-61.121-13.098a687.5 687.5 0 0 1-8.124-.002c-.429-.003-.514.149-.511.543.017 2.113.008 4.226.008 6.338 0 2.129.001 4.256-.001 6.384 0 .248-.028.464.349.462 2.812-.012 5.624-.009 8.436-.001.287 0 .353-.119.348-.376-.012-.565-.027-1.132.004-1.695.021-.387-.128-.474-.486-.47-1.622.016-3.243-.001-4.865.013-.344.003-.475-.099-.465-.458a49.85 49.85 0 0 0-.001-2.679c-.012-.389.101-.514.5-.507 1.458.022 2.916-.001 4.374.015.336.004.446-.108.434-.437-.02-.55-.022-1.102 0-1.651.015-.354-.115-.456-.465-.451-1.413.017-2.581.007-3.995.007-.594 0-.349-.001-.349-.573v-1.339c0-.624-.245-.626.402-.626 1.562-.001 3.001-.011 4.563.006.375.005.434-.119.414-.487-.028-.504-.064-1.013-.03-1.517.027-.407-.161-.501-.54-.499zm-53.318.488c.018-.368-.113-.489-.484-.487-2.679.012-5.357.013-8.036-.001-.379-.002-.474.129-.471.49.015 2.128.007 4.257.007 6.385 0 2.114.008 4.228-.008 6.341-.003.376.074.53.488.513a29.168 29.168 0 0 1 2.366 0c.413.018.493-.135.489-.513-.019-1.666.001-3.333-.015-5-.003-.365.101-.49.476-.485l4.286.017c.362.005.469-.12.456-.462a18.3 18.3 0 0 1 .002-1.606c.019-.379-.127-.478-.49-.473l-4.241.014c-.359.004-.509-.088-.489-.472.029-.549.007-1.102.007-1.651 0-.597.001-.6.583-.601 1.518-.002 3.036-.01 4.554.006.375.004.547-.086.521-.497a14.234 14.234 0 0 1-.001-1.518zm19.907-8.068l-.116.014-.246-.46c-1.646-3.299-3.293-6.596-4.928-9.899-.159-.321-.339-.472-.712-.444-.489.036-.983.033-1.473.001-.406-.027-.53.096-.529.517.017 4.033.01 8.067.01 12.1 0 1.118 0 1.102 1.139 1.113.401.004.481-.131.479-.515C25.01 94.268 25 90.726 25 87.183v-.527l.122-.028.2.33c1.705 3.385 3.453 6.752 5.091 10.169.441.92.926 1.367 1.966 1.205.601-.095.621-.019.621-.619V85.658c0-1.06-.005-1.038-1.05-1.066-.422-.011-.525.126-.523.528.015 3.26.008 6.519.006 9.778l-.035.486zm4.478 2.457c0 .286.027.488.399.478 1.59-.047 3.187.001 4.768-.133 1.909-.161 3.384-1.133 4.374-2.791 1.032-1.729 1.209-3.604.878-5.549-.49-2.88-2.513-4.929-5.745-5.146-1.378-.094-2.765-.055-4.146-.106-.41-.014-.537.108-.533.521.018 2.114.008 4.227.009 6.341 0 2.128.002 4.256-.004 6.385zm1.753-11.482l.038-.212c1.355.009 2.706-.135 4.011.36 1.698.646 2.592 1.922 2.877 3.664.187 1.141.147 2.281-.172 3.399-.499 1.75-1.993 3.008-3.803 3.163-.857.073-1.721.065-2.582.102-.25.011-.379-.051-.378-.341.008-3.377.006-6.757.009-10.135zM20.336 98.312c1.113-.003.941.16.982-.964.017-.441-.142-.552-.562-.548-1.86.02-3.72.001-5.58.015-.375.003-.521-.093-.514-.501.024-1.427.009-2.856.011-4.284l.026-.214c.184-.008.343.184.503.184h4.643c1.03 0 1.015-.207 1.026-1.252.004-.381-.099-.618-.501-.613-1.755.021-3.511-.049-5.267-.038-.323.002-.445-.118-.438-.458.02-.996.022-2.006-.001-3.003-.008-.373.114-.489.481-.486 1.696.017 3.393.003 5.089.003 1.094 0 1.079-.001 1.083-1.08.001-.375-.122-.479-.488-.476-2.455.014-4.91.015-7.365-.004-.408-.003-.529.106-.527.521.015 4.226.014 8.451 0 12.678-.001.407.112.535.524.531 2.292-.017 4.583-.003 6.875-.011zm-10.306.002c.997 0 .976-.001 1-.987.01-.419-.129-.529-.532-.526-2.114.017-4.227.009-6.341.005-.178 0-.355-.039-.597-.067l.289-.443c2.114-3.042 4.212-6.096 6.357-9.114.465-.655.708-1.294.652-2.096-.028-.397-.134-.493-.518-.491-2.44.015-4.881.008-7.322.008-1.052 0-1.034 0-1.056 1.053-.008.394.105.433.5.429 1.95-.02 3.9-.084 5.85-.084h.62c-.145 0-.219.453-.307.58-2.101 3.033-4.188 6.112-6.315 9.126-.442.627-.677 1.258-.635 2.029.024.454.143.583.587.579 2.588-.02 5.178-.001 7.768-.001z\"/></svg>"

/***/ }),

/***/ "../src/components/zend/plain-wordmark/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ZendPlainWordmark = __webpack_require__("../src/components/zend/plain-wordmark/ZendPlainWordmark.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ZendPlainWordmark).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/zend/plain/ZendPlain.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__("../node_modules/react-svg-inline/lib/index.js");
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _ZendPlain = __webpack_require__("../src/components/zend/plain/ZendPlain.svg");
	
	var _ZendPlain2 = _interopRequireDefault(_ZendPlain);
	
	var _utils = __webpack_require__("../src/components/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** ZendPlain */
	function ZendPlain(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return _react2.default.createElement(_reactSvgInline2.default, {
	    classSuffix: '-devicon',
	    className: 'ZendPlain',
	    svg: _ZendPlain2.default,
	    width: (0, _utils.normalizeUnit)(width),
	    height: (0, _utils.normalizeUnit)(height)
	  });
	}
	
	ZendPlain.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = ZendPlain;
	module.exports = exports['default'];

/***/ }),

/***/ "../src/components/zend/plain/ZendPlain.svg":
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#68B604\" d=\"M53.608 80.858c-8.247.029-16.494.142-24.741.142H27.68c11.396-16 22.633-31.146 33.949-46.657-.384-.025-.568-.11-.754-.11-17.851-.002-35.701-.03-53.552-.043-.627 0-.842.146-.837.807.031 3.689.016 7.371.016 11.06 0 1.052.001 1.05 1.066 1.05 9.034 0 18.068-.002 27.102.001.355 0 .712.047 1.257.087L1.781 93.782l.584.032c17.146.001 34.291-.003 51.437.017.701.001.794-.281.791-.866-.018-3.743-.03-7.425.009-11.168.007-.778-.207-.942-.994-.939zm71.635-45.876c-16.172.001-32.344-.021-48.517.031a22.057 22.057 0 0 0-5.37.684C65.115 37.3 60.12 44.074 60.365 50.552c.026.711.441.448.869.448h24.828c4.179 0 8.357.181 12.536.156 4.555-.028 9.119.156 13.661-.114 4.703-.279 8.459-2.458 11.052-6.477 1.742-2.702 2.514-5.703 2.896-8.854.104-.862-.448-.729-.964-.729zM100.57 56.116c-8.19-.003-16.38-.008-24.57.003-2.639.003-5.18.517-7.504 1.79-5.404 2.962-7.481 7.921-8.119 13.723-.083.766.38.745.905.744 4.312-.007 8.623-.004 12.936-.004 1.464.001 2.929.021 4.393-.004 3.223-.054 6.464.069 9.66-.247 4.157-.412 7.536-2.437 9.939-5.917 1.889-2.736 2.834-5.812 3.163-9.103.096-.965.134-.985-.803-.985zM84.161 77.157c-2.493.016-4.988-.024-7.481.021a25.333 25.333 0 0 0-3.467.299c-8.957 1.396-12.3 8.892-12.835 15.287-.049.572.157.762.729.75 1.49-.031 2.981-.011 4.473-.011l.004.082c2.026-.089 4.073-.036 6.078-.294 7.531-.97 13.28-7.764 13.223-15.462-.007-.574-.23-.675-.724-.672z\"/></svg>"

/***/ }),

/***/ "../src/components/zend/plain/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ZendPlain = __webpack_require__("../src/components/zend/plain/ZendPlain.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ZendPlain).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-icon-page-js-084c23b8f1f1ed2c124b.js